/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(864);
	module.exports = __webpack_require__(541);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(62);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.4
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        return name.match('^[^/\\\\]*$') != null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(681)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.4';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(128)(module)))

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(692);
	var parse = __webpack_require__(691);
	var formats = __webpack_require__(390);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(689)();
	}


/***/ },
/* 5 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assertString;
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function assertString(input) {
	  var isString = typeof input === 'string' || input instanceof String;
	
	  if (!isString) {
	    var invalidType;
	
	    if (input === null) {
	      invalidType = 'null';
	    } else {
	      invalidType = _typeof(input);
	
	      if (invalidType === 'object' && input.constructor && input.constructor.hasOwnProperty('name')) {
	        invalidType = input.constructor.name;
	      } else {
	        invalidType = "a ".concat(invalidType);
	      }
	    }
	
	    throw new TypeError("Expected string but received ".concat(invalidType, "."));
	  }
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';var _domainValues;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var hostname=window.location.hostname;var protocoltxt='https:';//window.location.protocol;
	/*if (location.protocol != 'https:')
	{
	 location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
	}*/var domainValues=(_domainValues={"ninjaprodemo.jankosoftworks.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F77D467A-F552-4BB3-ABBF-C491DB6661A0",fbAppId:"273665979745325",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIyd2hhdHNhcHAlMjI6JTIyKzY1OTAwMTMxNTclMjIsJTIyZmFjZWJvb2slMjI6JTIyMTUxODI0NzE5MTc4MTg1NCUyMiU3RA==",stripeKey:"pk_test_NcgEfVqBVIEN2vUSDpC5wfT2",stripeCompany:'Lean Bento',stripeImage:"https://leanbento.ninjapro.co/img/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ninjaprodemo',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://leanbento.ninjapro.co/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'http://leanbento.ninjapro.co/',fbImage:'http://bigberns.ninjapro.co/img/logo.png',fbTitle:'Lean Bento',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : http://leanbento.ninjapro.co/'},/* Twitter  */tw:{twURL:'http://leanbento.ninjapro.co/',twTitile:'Lean Bento',twvia:'Lean Bento'},/* google Plus data   */gp:{gpURL:'http://leanbento.ninjapro.co/'},/* Whatsapp data   */wa:{waURL:'http://leanbento.ninjapro.co/',waSeparator:'Lean Bento'},site_title:'Lean Bento',site_title_with_separator:' | Lean Bento',home_meta_title:"Welcome to Lean Bento"},"leanbento.ninjapro.co":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F77D467A-F552-4BB3-ABBF-C491DB6661A0",fbAppId:"273665979745325",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIyd2hhdHNhcHAlMjI6JTIyKzY1OTAwMTMxNTclMjIsJTIyZmFjZWJvb2slMjI6JTIyMTUxODI0NzE5MTc4MTg1NCUyMiU3RA==",stripeKey:"pk_test_NcgEfVqBVIEN2vUSDpC5wfT2",stripeCompany:'Lean Bento',stripeImage:"https://leanbento.ninjapro.co/img/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'leanbento',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://leanbento.ninjapro.co/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'http://leanbento.ninjapro.co/',fbImage:'http://bigberns.ninjapro.co/img/logo.png',fbTitle:'Lean Bento',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : http://leanbento.ninjapro.co/'},/* Twitter  */tw:{twURL:'http://leanbento.ninjapro.co/',twTitile:'Lean Bento',twvia:'Lean Bento'},/* google Plus data   */gp:{gpURL:'http://leanbento.ninjapro.co/'},/* Whatsapp data   */wa:{waURL:'http://leanbento.ninjapro.co/',waSeparator:'Lean Bento'},site_title:'Lean Bento',site_title_with_separator:' | Lean Bento',home_meta_title:"Welcome to Lean Bento"},"192.168.2.6a9":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F77D467A-F552-4BB3-ABBF-C491DB6661A0",fbAppId:"273665979745325",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIyd2hhdHNhcHAlMjI6JTIyKzY1OTAwMTMxNTclMjIsJTIyZmFjZWJvb2slMjI6JTIyMTUxODI0NzE5MTc4MTg1NCUyMiU3RA==",stripeKey:"pk_test_NcgEfVqBVIEN2vUSDpC5wfT2",stripeCompany:'Lean Bento',stripeImage:"http://leanbento.ninjapro.co/img/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'leanbento-test',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'http://leanbento.ninjapro.co/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'http://leanbento.ninjapro.co/',fbImage:'http://bigberns.ninjapro.co/img/logo.png',fbTitle:'Lean Bento',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : http://leanbento.ninjapro.co/'},/* Twitter  */tw:{twURL:'http://leanbento.ninjapro.co/',twTitile:'Lean Bento',twvia:'Lean Bento'},/* google Plus data   */gp:{gpURL:'http://leanbento.ninjapro.co/'},/* Whatsapp data   */wa:{waURL:'http://leanbento.ninjapro.co/',waSeparator:'Lean Bento'},site_title:'Lean Bento Test',site_title_with_separator:' | Lean Bento Test',home_meta_title:"Welcome to Lean Bento Test"},"localhost":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F77D467A-F552-4BB3-ABBF-C491DB6661A0",fbAppId:"834478453372307",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIyd2hhdHNhcHAlMjI6JTIyKzY1OTAwMTMxNTclMjIsJTIyZmFjZWJvb2slMjI6JTIyMTUxODI0NzE5MTc4MTg1NCUyMiU3RA==",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Ninjapro Demo',stripeImage:"http://ninjaprocmn.jankosoftworks.com/img/logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ninjapro',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'http://ninjaprocmn.jankosoftworks.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'http://ninjaprocmn.jankosoftworks.com/#/',fbImage:'http://ninjaprocmn.jankosoftworks.com/img/logo.png',fbTitle:'Demo Site',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : http://ninjaprocmn.jankosoftworks.com/'},/* Twitter  */tw:{twURL:'http://ninjaprocmn.jankosoftworks.com/#/',twTitile:'Demo site',twvia:'Demo site'},/* google Plus data   */gp:{gpURL:'http://ninjaprocmn.jankosoftworks.com/#/'},/* Whatsapp data   */wa:{waURL:'http://ninjaprocmn.jankosoftworks.com/#/',waSeparator:'Demo site'},site_title:'Junior Kupanna',site_title_with_separator:' | Junior Kupanna',home_meta_title:"Welcome to Junior Kupanna",home_meta_description:"DESV - Little Cake Bites",home_meta_keywords:"Leywirds - Little Cake Bites"},"localhost3":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F77D467A-F552-4BB3-ABBF-C491DB6661A0",fbAppId:"834478453372307",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIyd2hhdHNhcHAlMjI6JTIyKzY1OTAwMTMxNTclMjIsJTIyZmFjZWJvb2slMjI6JTIyMTUxODI0NzE5MTc4MTg1NCUyMiU3RA==",stripeKey:"pk_test_f5ROLHULd4UlQF59L24mdDBV",stripeCompany:'Ninjapro Demo',stripeImage:"http://ninjaprocmn.jankosoftworks.com/img/logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'leanbento-3',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'http://ninjaprocmn.jankosoftworks.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'http://ninjaprocmn.jankosoftworks.com/#/',fbImage:'http://ninjaprocmn.jankosoftworks.com/img/logo.png',fbTitle:'Demo Site',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : http://ninjaprocmn.jankosoftworks.com/'},/* Twitter  */tw:{twURL:'http://ninjaprocmn.jankosoftworks.com/#/',twTitile:'Demo site',twvia:'Demo site'},/* google Plus data   */gp:{gpURL:'http://ninjaprocmn.jankosoftworks.com/#/'},/* Whatsapp data   */wa:{waURL:'http://ninjaprocmn.jankosoftworks.com/#/',waSeparator:'Demo site'},site_title:'Demo site',site_title_with_separator:' | Demo site',home_meta_title:"Welcome to Demo site",bgimage:'/img/ninjaprocmn/body_bg.jpg'},"order.evertop.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"5F2E6A5D-25B6-498F-AEBA-6EC8171F9625",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIycGhvbmUlMjI6JTIyKzY1Njc3NDEzNTMlMjIlN0Q=",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Evertop Chicken Rice',stripeImage:"https://order.evertop.sg/img/ninjaprocmn/evertop/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'evertop',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.evertop.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.evertop.sg/#/',fbImage:'https://order.evertop.sg/img/evertop/logo.png',fbTitle:'Evertop Chicken Rice',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.evertop.sg/'},/* Twitter  */tw:{twURL:'https://order.evertop.sg/#/',twTitile:'Evertop Chicken Rice',twvia:'Evertop Chicken Rice'},/* google Plus data   */gp:{gpURL:'http://order.evertop.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.evertop.sg/#/',waSeparator:'Evertop Chicken Rice'},site_title:'Evertop Chicken Rice',site_title_with_separator:' | Evertop Chicken Rice',home_meta_title:"Welcome to Evertop Chicken Rice",bgimage:'/img/ninjaprocmn/evertop/body_bg.jpg'},"order.thesaladbox.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"C2533ED5-3B72-41B4-91AC-F57E7DE5422B",fbAppId:"834478453372307",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIyd2hhdHNhcHAlMjI6JTIyMDY1OTAzMDUzMTYlMjIsJTIyZmFjZWJvb2slMjI6JTIyMTQ0NDA1MjMxOTE2MDY2MiUyMiU3RA==",stripeKey:"pk_live_OqBVS2Aa11U7EZbsY2gJcer5",stripeCompany:'The SaladBox',stripeImage:"https://order.thesaladbox.com.sg/img/ninjaprocmn/saladbox/stripe_logo.png",stripeEmail:'thesaladbox@hotmail.com',stripeReference:'saladbox',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.thesaladbox.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.thesaladbox.com.sg/#/',fbImage:'https://order.thesaladbox.com.sg/img/saladbox/logo.png',fbTitle:'The SaladBox',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.thesaladbox.com.sg/'},/* Twitter  */tw:{twURL:'https://order.thesaladbox.com.sg/#/',twTitile:'The SaladBox',twvia:'The SaladBox'},/* google Plus data   */gp:{gpURL:'http://order.thesaladbox.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.thesaladbox.com.sg/#/',waSeparator:'The SaladBox'},site_title:'The SaladBox',site_title_with_separator:' | The SaladBox',home_meta_title:"Welcome to The SaladBox",bgimage:'/img/ninjaprocmn/saladbox/body_bg.jpg'},"www.alhussainrestaurant.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"B254C662-6518-4B4D-BE5F-30ADFD38FBA9",fbAppId:"273850896575817",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIyZmFjZWJvb2slMjI6JTIyNTcxODYxMzk5ODM4NzU5JTIyJTdE",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Al Hussain Restaurant',stripeImage:"https://www.alhussainrestaurant.com/img/ninjaprocmn/alhussain/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'alhussain',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.alhussainrestaurant.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.alhussainrestaurant.com/#/',fbImage:'https://www.alhussainrestaurant.com/img/alhussain/logo.png',fbTitle:'Al Hussain Restaurant',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.alhussainrestaurant.com/'},/* Twitter  */tw:{twURL:'https://www.alhussainrestaurant.com/#/',twTitile:'Al Hussain Restaurant',twvia:'Al Hussain Restaurant'},/* google Plus data   */gp:{gpURL:'http://www.alhussainrestaurant.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.alhussainrestaurant.com/#/',waSeparator:'Al Hussain Restaurant'},site_title:'Al Hussain Restaurant',forcewww:'YES',site_title_with_separator:' | Al Hussain Restaurant',home_meta_title:"Welcome to Al Hussain Restaurant",bgimage:'/img/ninjaprocmn/alhussain/body_bg.jpg'},"order.mrprata.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"2E5B22E3-D685-4693-AD4C-B1765A80EA75",fbAppId:"288627768562027",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIyd2hhdHNhcHAlMjI6JTIyKzY1OTE0Mzc2ODglMjIlN0Q=",stripeKey:"pk_live_VYh72LUoep6GSlU7ZnuFLBIB",stripeCompany:'Mr. Prata',stripeImage:"https://order.mrprata.com.sg/img/ninjaprocmn/mrprata/stripe_logo.png",stripeEmail:'thanuja@jankosoft.com',stripeReference:'mrprata',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.mrprata.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.mrprata.com.sg/#/',fbImage:'https://order.mrprata.com.sg/img/mrprata/preview.png',fbTitle:'Mr. Prata',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.mrprata.com.sg/'},/* Twitter  */tw:{twURL:'https://order.mrprata.com.sg/#/',twTitile:'Mr. Prata',twvia:'Mr. Prata'},/* google Plus data   */gp:{gpURL:'https://order.mrprata.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.mrprata.com.sg/#/',waSeparator:'Mr. Prata'},site_title:'Mr. Prata',site_title_with_separator:' | Mr. Prata',home_meta_title:"Welcome to Mr. Prata",bgimage:'/img/ninjaprocmn/mrprata/body_bg.jpg'},"order.pitatree.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"1E7CC2BB-01F7-47A7-B128-404EECDECE0C",fbAppId:"335207373897794",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIycGhvbmUlMjI6JTIyKzY1NjUzMjIwOTglMjIsJTIyZmFjZWJvb2slMjI6JTIyMjA0NTg5MzgzNTg1ODY0JTIyLCUyMmVtYWlsJTIyOiUyMmJvYXRxdWF5QHBpdGF0cmVlLmNvbSUyMiU3RA==",stripeKey:"pk_live_8EOxPtyezZRh1dFarEQIUJB7",stripeCompany:'Pita Tree',stripeImage:"https://order.pitatree.com/img/ninjaprocmn/pitatree/stripe_logo.png",stripeEmail:'hello@pitatree.com',stripeReference:'pitatree',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.pitatree.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.pitatree.com/#/',fbImage:'https://order.pitatree.com/img/pitatree/preview.jpg',fbTitle:'Pita Tree',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.pitatree.com/'},/* Twitter  */tw:{twURL:'https://order.pitatree.com/#/',twTitile:'Pita Tree',twvia:'Pita Tree'},/* google Plus data   */gp:{gpURL:'https://order.pitatree.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.pitatree.com/#/',waSeparator:'Pita Tree'},site_title:'Pita Tree',site_title_with_separator:' | Pita Tree',home_meta_title:"Welcome to Pita Tree",bgimage:'/img/ninjaprocmn/pitatree/body_bg.jpg'},"bushido.ninjapro.co":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"AD8BDEE2-92AA-461A-AEAF-47E921C99235",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_live_bldDQUj98zmY7mc3dTZDpr6W",stripeCompany:'Bushido',stripeImage:"https://bushido.ninjapro.co/img/ninjaprocmn/Bushido/stripe_logo.png",stripeEmail:'info@bushidoasia.com',stripeReference:'bushido',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://bushido.ninjapro.co/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://bushido.ninjapro.co/#/',fbImage:'https://bushido.ninjapro.co/img/Bushido/preview.jpg',fbTitle:'Bushido',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://bushido.ninjapro.co/'},/* Twitter  */tw:{twURL:'https://bushido.ninjapro.co/#/',twTitile:'Bushido',twvia:'Bushido'},/* google Plus data   */gp:{gpURL:'http://bushido.ninjapro.co/#/'},/* Whatsapp data   */wa:{waURL:'http://bushido.ninjapro.co/#/',waSeparator:'Bushido'},site_title:'Bushido',site_title_with_separator:' | Bushido',home_meta_title:"Welcome to Bushido",bgimage:'/img/ninjaprocmn/Bushido/body_bg.jpg'},"order.konarmess.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"9F55B4B0-A88F-4074-9598-D0AD61F22985",fbAppId:"584916035262204",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIycGhvbmUlMjI6JTIyKzY1OTYzNTY2MjclMjIsJTIyZmFjZWJvb2slMjI6JTIyMTc5OTY3OTQyODA1MjIzJTIyLCUyMmVtYWlsJTIyOiUyMmtvbmFybWVzcy5zZ0BnbWFpbC5jb20lMjIlN0Q=",stripeKey:"pk_live_mnmrho4ERX8wFpZX42pDN6v0",stripeCompany:'Konar Mess',stripeImage:"https://order.konarmess.com.sg/img/ninjaprocmn/konarmess/stripe_logo.png",stripeEmail:'konarmess.sg@gmail.com',stripeReference:'konarmess',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.konarmess.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.konarmess.com.sg/#/',fbImage:'https://order.konarmess.com.sg/img/Bushido/preview.jpg',fbTitle:'Konar Mess',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.konarmess.com.sg/'},/* Twitter  */tw:{twURL:'https://order.konarmess.com.sg/#/',twTitile:'Konar Mess',twvia:'Konar Mess'},/* google Plus data   */gp:{gpURL:'http://order.konarmess.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.konarmess.com.sg/#/',waSeparator:'Konar Mess'},site_title:'Konar Mess',site_title_with_separator:' | Konar Mess',home_meta_title:"Welcome to Konar Mess",bgimage:'/img/ninjaprocmn/konarmess/body_bg.jpg'},"www.tiptopbriyani.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"6665D5E0-F716-4208-85AD-D062AE89B61B",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIycGhvbmUlMjI6JTIyKzY1OTAxMDMxMTklMjIsJTIyZmFjZWJvb2slMjI6JTIyNDg1NTc0NTU1Mjk4NTc3JTIyLCUyMmVtYWlsJTIyOiUyMnRpcHRvcGJyaXlhbmlAZ21haWwuY29tJTIyJTdE",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Tip Top Briyani',stripeImage:"https://www.tiptopbriyani.com/img/ninjaprocmn/tiptopbriyani/stripe_logo.png",stripeEmail:'tiptopbriyani@gmail.com',stripeReference:'tiptopbriyani',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.tiptopbriyani.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.tiptopbriyani.com/#/',fbImage:'https://www.tiptopbriyani.com/img/tiptopbriyani/preview.jpg',fbTitle:'Tip Top Briyani',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.tiptopbriyani.com/'},/* Twitter  */tw:{twURL:'https://www.tiptopbriyani.com/#/',twTitile:'Tip Top Briyani',twvia:'Tip Top Briyani'},/* google Plus data   */gp:{gpURL:'http://www.tiptopbriyani.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.tiptopbriyani.com/#/',waSeparator:'Tip Top Briyani'},site_title:'Tip Top Briyani',forcewww:'YES',site_title_with_separator:' | Tip Top Briyani',home_meta_title:"Welcome to Tip Top Briyani",bgimage:'/img/ninjaprocmn/tiptopbriyani/body_bg.jpg'},"order.brownieboys.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"59ADA2AD-499C-4B0B-841F-452B754324ED",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_live_oT18rOGN2qxTzE0nO2s9DXCx",stripeCompany:'Brownie Boys',stripeImage:"https://order.brownieboys.com.sg/img/ninjaprocmn/brownieboys/stripe_logo.png",stripeEmail:'brownieboys@gmail.com',stripeReference:'brownie',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.brownieboys.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.brownieboys.com.sg/#/',fbImage:'https://order.brownieboys.com.sg/img/brownieboys/preview.jpg',fbTitle:'Brownie Boys',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.brownieboys.com.sg/'},/* Twitter  */tw:{twURL:'https://order.brownieboys.com.sg/#/',twTitile:'Brownie Boys',twvia:'Brownie Boys'},/* google Plus data   */gp:{gpURL:'http://order.brownieboys.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.brownieboys.com.sg/#/',waSeparator:'Brownie Boys'},site_title:'Brownie Boys',site_title_with_separator:' | Brownie Boys',home_meta_title:"Welcome to Brownie Boys",bgimage:'/img/ninjaprocmn/brownieboys/body_bg.jpg'},"orderonline.cucina.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"0A3FDFD4-07AD-44BB-8D86-1988AA200D97",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIycGhvbmUlMjI6JTIyKzY1NjcwMjI2MjklMjIsJTIyZmFjZWJvb2slMjI6JTIyNDYxOTIxMDU3NDk4MjYzJTIyLCUyMmVtYWlsJTIyOiUyMnJlc2VydmF0aW9uc0BjdWNpbmEuc2clMjIlN0Q=",stripeKey:"pk_live_qNEGnqCIRg3Uqu6BrA7g1NE3",stripeCompany:'Cucina',stripeImage:"https://orderonline.cucina.sg/img/ninjaprocmn/cucina/stripe_logo.png",stripeEmail:'joyce@cucina.sg',stripeReference:'cucina',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://orderonline.cucina.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://orderonline.cucina.sg/#/',fbImage:'https://orderonline.cucina.sg/img/cucina/preview.jpg',fbTitle:'Cucina',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://orderonline.cucina.sg/'},/* Twitter  */tw:{twURL:'https://orderonline.cucina.sg/#/',twTitile:'Cucina',twvia:'Cucina'},/* google Plus data   */gp:{gpURL:'http://orderonline.cucina.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://orderonline.cucina.sg/#/',waSeparator:'Cucina'},site_title:'Cucina',site_title_with_separator:' | Cucina',home_meta_title:"Welcome to Cucina",bgimage:'/img/ninjaprocmn/cucina/body_bg.jpg'},"staging.udders.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"80D71B04-C58D-4D3A-8619-687DDBC382FE",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIycGhvbmUlMjI6JTIyKzY1NjY2Mjk0MTAlMjIsJTIyZmFjZWJvb2slMjI6JTIyMTM2NjI0OTI5ODIxJTIyLCUyMmVtYWlsJTIyOiUyMm1vb0B1ZGRlcnMuY29tLnNnJTIyJTdE",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'udders',stripeImage:"https://staging.udders.com.sg/img/ninjaprocmn/udders/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'udders',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://staging.udders.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://staging.udders.com.sg/#/',fbImage:'https://staging.udders.com.sg/img/udders/preview.jpg',fbTitle:'Udders',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://staging.udders.com.sg/'},/* Twitter  */tw:{twURL:'https://staging.udders.com.sg/#/',twTitile:'udders',twvia:'udders'},/* google Plus data   */gp:{gpURL:'http://staging.udders.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://staging.udders.com.sg/#/',waSeparator:'udders'},site_title:'Udders',site_title_with_separator:' | Udders',home_meta_title:"Welcome to Udders",bgimage:'/img/ninjaprocmn/udders/body_bg.jpg'},"order.everestkitchensg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E5381958-8EF3-4971-A845-87BFDC94C604",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIycGhvbmUlMjI6JTIyKzY1NjY2Mjk0MTAlMjIsJTIyZmFjZWJvb2slMjI6JTIyMTM2NjI0OTI5ODIxJTIyLCUyMmVtYWlsJTIyOiUyMm1vb0B1ZGRlcnMuY29tLnNnJTIyJTdE",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Everest Kitchen',stripeImage:"https://order.everestkitchensg.com/img/ninjaprocmn/everestkitchen/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'everestkitchen',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.everestkitchensg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.everestkitchensg.com/#/',fbImage:'https://order.everestkitchensg.com/img/udders/preview.jpg',fbTitle:'Everest Kitchen',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.everestkitchensg.com/'},/* Twitter  */tw:{twURL:'https://order.everestkitchensg.com/#/',twTitile:'everestkitchen',twvia:'everestkitchen'},/* google Plus data   */gp:{gpURL:'http://order.everestkitchensg.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.everestkitchensg.com/#/',waSeparator:'everestkitchen'},site_title:'Udders',site_title_with_separator:' | Everest Kitchen',home_meta_title:"Welcome to Everest Kitchen",bgimage:'/img/ninjaprocmn/everestkitchen/body_bg.jpg'},"www.yishikitchen.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"0DD7BB89-B71D-4A81-B253-65CB90DBF08B",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIycGhvbmUlMjI6JTIyKzY1ODExMTM1OTAlMjIsJTIyZmFjZWJvb2slMjI6JTIyMjAwNzYxNzEzNzQyMDQ5JTIyJTdE",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'yishi',stripeImage:"https://www.yishikitchen.com/img/ninjaprocmn/yishi/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'yishi',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.yishikitchen.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.yishikitchen.com/#/',fbImage:'https://www.yishikitchen.com/img/yishi/preview.jpg',fbTitle:'Yi Shi Kitchen',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.yishikitchen.com/'},/* Twitter  */tw:{twURL:'https://www.yishikitchen.com/#/',twTitile:'Yi Shi Kitchen',twvia:'Yi Shi Kitchen'},/* google Plus data   */gp:{gpURL:'http://www.yishikitchen.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.yishikitchen.com/#/',waSeparator:'Yi Shi Kitchen'},site_title:'Yi Shi Kitchen',forcewww:'YES',site_title_with_separator:' | Yi Shi Kitchen',home_meta_title:"Welcome to Yi Shi Kitchen",bgimage:'/img/ninjaprocmn/yishi/body_bg.jpg'},"www.khanrestaurants.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"A9F98030-897B-4057-BD62-33883AA65FF0",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Khan Kitchen',stripeImage:"https://www.khanrestaurants.com/img/ninjaprocmn/khan/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'khan',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.khanrestaurants.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.khanrestaurants.com/#/',fbImage:'https://www.khanrestaurants.com/img/khan/preview.jpg',fbTitle:'Khan Kitchen',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.khanrestaurants.com/'},/* Twitter  */tw:{twURL:'https://www.khanrestaurants.com/#/',twTitile:'Khan Kitchen',twvia:'Khan Kitchen'},/* google Plus data   */gp:{gpURL:'http://www.khanrestaurants.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.khanrestaurants.com/#/',waSeparator:'Khan Kitchen'},site_title:'Khan Kitchen',forcewww:'YES',site_title_with_separator:' | Khan Kitchen',home_meta_title:"Welcome to Khan Kitchen",bgimage:'/img/ninjaprocmn/khan/body_bg.jpg'},"www.tabboulehrestaurant.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"67A7C5CF-6EA2-4AF7-9414-BB4E2CE689C2",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIycGhvbmUlMjI6JTIyJTIwKzY1NjI5MjUyMzUlMjIsJTIyZmFjZWJvb2slMjI6JTIyNTM3NTA5MjU2NDQyNjkyJTIyJTdE",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Tabbouleh',stripeImage:"https://www.tabboulehrestaurant.com/img/ninjaprocmn/tabbouleh/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'tabbouleh',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.tabboulehrestaurant.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.tabboulehrestaurant.com/#/',fbImage:'https://www.tabboulehrestaurant.com/img/tabbouleh/preview.jpg',fbTitle:'Tabbouleh',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.tabboulehrestaurant.com/'},/* Twitter  */tw:{twURL:'https://www.tabboulehrestaurant.com/#/',twTitile:'Tabbouleh',twvia:'Tabbouleh'},/* google Plus data   */gp:{gpURL:'http://www.tabboulehrestaurant.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.tabboulehrestaurant.com/#/',waSeparator:'Tabbouleh'},site_title:'Tabbouleh',forcewww:'YES',site_title_with_separator:' | Tabbouleh',home_meta_title:"Welcome to Tabbouleh",bgimage:'/img/ninjaprocmn/tabbouleh/body_bg.jpg'},"order.ahhuakelong.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"EBE69618-422B-4B43-ABB1-A23CDC59E9FE",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIyd2hhdHNhcHAlMjI6JTIyMDY1OTIzMzMzNzElMjIsJTIycGhvbmUlMjI6JTIyMDY1OTIzMzMzNzElMjIsJTIyZmFjZWJvb2slMjI6JTIyMTQ1NjE2MTg0MTI5Mjk1MiUyMiU3RA==",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Ah Hua Kelong',stripeImage:"https://order.ahhuakelong.com/img/ninjaprocmn/ahhuakelong/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ahhuakelong',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.ahhuakelong.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.ahhuakelong.com/#/',fbImage:'https://order.ahhuakelong.com/img/ahhuakelong/preview.jpg',fbTitle:'Ah Hua Kelong',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.ahhuakelong.com/'},/* Twitter  */tw:{twURL:'https://order.ahhuakelong.com/#/',twTitile:'Ah Hua Kelong',twvia:'Ah Hua Kelong'},/* google Plus data   */gp:{gpURL:'http://order.ahhuakelong.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.ahhuakelong.com/#/',waSeparator:'Ah Hua Kelong'},site_title:'Ah Hua Kelong',site_title_with_separator:' | Ah Hua Kelong',home_meta_title:"Welcome to Ah Hua Kelong",bgimage:'/img/ninjaprocmn/ahhuakelong/body_bg.jpg'},"order.saladchef.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"329428F3-CB23-4961-968C-68775ADD8ACE",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIycGhvbmUlMjI6JTIyMDY1ODQ1NzM5NjklMjIsJTIyZmFjZWJvb2slMjI6JTIyNTAzMDQ5Njg2NDYxOTgxJTIyLCUyMmVtYWlsJTIyOiUyMmluZm9Ac2FsYWRjaGVmLnNnJTIyJTdE",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Salad Chef',stripeImage:"https://order.saladchef.sg/img/ninjaprocmn/saladchef/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'saladchef',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.saladchef.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.saladchef.sg/#/',fbImage:'https://order.saladchef.sg/img/saladchef/preview.jpg',fbTitle:'Salad Chef',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.saladchef.sg/'},/* Twitter  */tw:{twURL:'https://order.saladchef.sg/#/',twTitile:'Salad Chef',twvia:'Salad Chef'},/* google Plus data   */gp:{gpURL:'http://order.saladchef.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.saladchef.sg/#/',waSeparator:'Salad Chef'},site_title:'Salad Chef',site_title_with_separator:' | Salad Chef',home_meta_title:"Welcome to Salad Chef",bgimage:'/img/ninjaprocmn/saladchef/body_bg.jpg'},"www.machanskitchensg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"9571C6D1-6D44-4888-9DF1-F048650B4881",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Machans Kitchen',stripeImage:"https://www.machanskitchensg.com/img/ninjaprocmn/machans/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'machans',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.machanskitchensg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.machanskitchensg.com/#/',fbImage:'https://www.machanskitchensg.com/img/machans/preview.jpg',fbTitle:'Machans Kitchen',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.machanskitchensg.com/'},/* Twitter  */tw:{twURL:'https://www.machanskitchensg.com/#/',twTitile:'Machans Kitchen',twvia:'Machans Kitchen'},/* google Plus data   */gp:{gpURL:'http://www.machanskitchensg.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.machanskitchensg.com/#/',waSeparator:'Machans Kitchen'},site_title:'Machans Kitchen',forcewww:'YES',site_title_with_separator:' | Machans Kitchen',home_meta_title:"Welcome to Machans Kitchen",bgimage:'/img/ninjaprocmn/machans/body_bg.jpg'},"www.gokulrestaurantsg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F189BE15-851E-42F8-9750-45D13C2CC1B7",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Gokul Restaurant',stripeImage:"https://www.gokulrestaurantsg.com/img/ninjaprocmn/gokul/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'gokul',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.gokulrestaurantsg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.gokulrestaurantsg.com/#/',fbImage:'https://www.gokulrestaurantsg.com/img/gokul/preview.jpg',fbTitle:'Gokul Restaurant',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.gokulrestaurantsg.com/'},/* Twitter  */tw:{twURL:'https://www.gokulrestaurantsg.com/#/',twTitile:'Gokul Restaurant',twvia:'Gokul Restaurant'},/* google Plus data   */gp:{gpURL:'http://www.gokulrestaurantsg.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.gokulrestaurantsg.com/#/',waSeparator:'Gokul Restaurant'},site_title:'Gokul Restaurant',forcewww:'YES',site_title_with_separator:' | Gokul Restaurant',home_meta_title:"Welcome to Gokul Restaurant",bgimage:'/img/ninjaprocmn/gokul/body_bg.jpg'},"www.deannaskitchensg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"30E6FB69-4E50-4331-9BE8-883D413CA457",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIyd2hhdHNhcHAlMjI6JTIyKzY1ODI5ODI3MzAlMjIsJTIycGhvbmUlMjI6JTIyKzY1ODI5ODI3MzAlMjIsJTIyZmFjZWJvb2slMjI6JTIyNDczNTA0NDQ2MzMxMTYzJTIyLCUyMmVtYWlsJTIyOiUyMmRlYW5uYXNraXRjaGVuLnNnQGdtYWlsLmNvbSUyMiU3RA==",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Deannas Kitchen',stripeImage:"https://www.deannaskitchensg.com/img/ninjaprocmn/deannas/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'deannas',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.deannaskitchensg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.deannaskitchensg.com/#/',fbImage:'https://www.deannaskitchensg.com/img/deannas/preview.jpg',fbTitle:'Deannas Kitchen',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.deannaskitchensg.com/'},/* Twitter  */tw:{twURL:'https://www.deannaskitchensg.com/#/',twTitile:'Deannas Kitchen',twvia:'Deannas Kitchen'},/* google Plus data   */gp:{gpURL:'http://www.deannaskitchensg.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.deannaskitchensg.com/#/',waSeparator:'Deannas Kitchen'},site_title:'Deannas Kitchen',forcewww:'YES',site_title_with_separator:' | Deannas Kitchen',home_meta_title:"Welcome to Deannas Kitchen",bgimage:'/img/ninjaprocmn/deannas/body_bg.jpg'},"order.bbqtonight.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"100F50EB-E1D5-4035-8C74-06FE9399FDFE",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Bar BQ Tonight',stripeImage:"https://order.bbqtonight.com.sg/img/ninjaprocmn/barbqtonight/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'barbqtonight',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.bbqtonight.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.bbqtonight.com.sg/#/',fbImage:'https://order.bbqtonight.com.sg/img/barbqtonight/preview.jpg',fbTitle:'Bar BQ Tonight',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.bbqtonight.com.sg/'},/* Twitter  */tw:{twURL:'https://order.bbqtonight.com.sg/#/',twTitile:'Bar BQ Tonight',twvia:'Bar BQ Tonight'},/* google Plus data   */gp:{gpURL:'http://order.bbqtonight.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.bbqtonight.com.sg/#/',waSeparator:'Bar BQ Tonight'},site_title:'Bar BQ Tonight',site_title_with_separator:' | Bar BQ Tonight',home_meta_title:"Welcome to Bar BQ Tonight",bgimage:'/img/ninjaprocmn/barbqtonight/body_bg.jpg'},"www.hongkongstreetjiakee.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"64AB8EB8-3E53-4516-AFF8-CD197643DD15",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Hong Kong Street',stripeImage:"https://www.hongkongstreetjiakee.com/img/ninjaprocmn/hongkong/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'hongkong',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.hongkongstreetjiakee.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.hongkongstreetjiakee.com/#/',fbImage:'https://www.hongkongstreetjiakee.com/img/hongkong/preview.jpg',fbTitle:'Hong Kong Street',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.hongkongstreetjiakee.com/'},/* Twitter  */tw:{twURL:'https://www.hongkongstreetjiakee.com/#/',twTitile:'Hong Kong Street',twvia:'Hong Kong Street'},/* google Plus data   */gp:{gpURL:'http://www.hongkongstreetjiakee.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.hongkongstreetjiakee.com/#/',waSeparator:'Hong Kong Street'},site_title:'Hong Kong Street',forcewww:'YES',site_title_with_separator:' | Hong Kong Street',home_meta_title:"Welcome to Hong Kong Street",bgimage:'/img/ninjaprocmn/hongkong/body_bg.jpg'},"hungrythai.ninjapro.co":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"80449D55-AB58-47C3-A054-A016C50512EE",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Hong Kong Street',stripeImage:"https://www.hongkongstreetjiakee.com/img/ninjaprocmn/hongkong/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'hongkong',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.hongkongstreetjiakee.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.hongkongstreetjiakee.com/#/',fbImage:'https://www.hongkongstreetjiakee.com/img/hongkong/preview.jpg',fbTitle:'Hong Kong Street',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.hongkongstreetjiakee.com/'},/* Twitter  */tw:{twURL:'https://www.hongkongstreetjiakee.com/#/',twTitile:'Hong Kong Street',twvia:'Hong Kong Street'},/* google Plus data   */gp:{gpURL:'http://www.hongkongstreetjiakee.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.hongkongstreetjiakee.com/#/',waSeparator:'Hong Kong Street'},site_title:'Hong Kong Street',site_title_with_separator:' | Hong Kong Street',home_meta_title:"Welcome to Hong Kong Street",bgimage:'/img/ninjaprocmn/hongkong/body_bg.jpg'},"www.melben440.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"583EB2C1-9FBA-4E0B-B655-20A96507647B",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIycGhvbmUlMjI6JTIyNjU4MjAzOTclMjIsJTIyZmFjZWJvb2slMjI6JTIyMTMzOTg5NDYwMTA1ODQ1JTIyLCUyMmVtYWlsJTIyOiUyMm1lbGxiZW40NDBAaG90bWFpbC5jb20lMjIlN0Q=",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Melben440',stripeImage:"https://www.melben440.com/img/ninjaprocmn/melben/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'melben',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.melben440.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.melben440.com/#/',fbImage:'https://www.melben440.com/img/melben/preview.jpg',fbTitle:'Melben440',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.melben440.com/'},/* Twitter  */tw:{twURL:'https://www.melben440.com/#/',twTitile:'Melben440',twvia:'Melben440'},/* google Plus data   */gp:{gpURL:'http://www.melben440.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.melben440.com/#/',waSeparator:'Melben440'},site_title:'Melben440',forcewww:'YES',site_title_with_separator:' | Melben440',home_meta_title:"Welcome to Melben440",bgimage:'/img/ninjaprocmn/melben/body_bg.jpg'},"www.hungrythai.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"80449D55-AB58-47C3-A054-A016C50512EE",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIycGhvbmUlMjI6JTIyODE4NjgwNzglMjIsJTIyZmFjZWJvb2slMjI6JTIyMTcwNzQ0NjQ2NTk4MTIwNyUyMiU3RA==",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Hungry Thai',stripeImage:"https://www.hungrythai.sg/img/ninjaprocmn/hungrythai/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'hungrythai',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.hungrythai.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.hungrythai.sg/#/',fbImage:'https://www.hungrythai.sg/img/hungrythai/preview.jpg',fbTitle:'Hungry Thai',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.hungrythai.sg/'},/* Twitter  */tw:{twURL:'https://www.hungrythai.sg/#/',twTitile:'Hungry Thai',twvia:'Hungry Thai'},/* google Plus data   */gp:{gpURL:'http://www.hungrythai.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://www.hungrythai.sg/#/',waSeparator:'Hungry Thai'},site_title:'Hungry Thai',forcewww:'YES',site_title_with_separator:' | Hungry Thai',home_meta_title:"Welcome to Hungry Thai",bgimage:'/img/ninjaprocmn/hungrythai/body_bg.jpg'},"orderonline.chillas.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"DB08BAAE-4F7A-4F90-B3B5-AC7CBF001B88",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIycGhvbmUlMjI6JTIyKzY1NjcxMDQxMDQlMjIsJTIyZmFjZWJvb2slMjI6JTIyODMzOTEwMjYwMDYwMjcxJTIyLCUyMmVtYWlsJTIyOiUyMmNoaWxsYXMyMDE1QGdtYWlsLmNvbSUyMiU3RA==",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Chillas',stripeImage:"https://orderonline.chillas.com.sg/img/ninjaprocmn/chillas/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'chillas',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://orderonline.chillas.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://orderonline.chillas.com.sg/#/',fbImage:'https://orderonline.chillas.com.sg/img/chillas/preview.jpg',fbTitle:'Chillas',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://orderonline.chillas.com.sg/'},/* Twitter  */tw:{twURL:'https://orderonline.chillas.com.sg/#/',twTitile:'Chillas',twvia:'Chillas'},/* google Plus data   */gp:{gpURL:'http://orderonline.chillas.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://orderonline.chillas.com.sg/#/',waSeparator:'Chillas'},site_title:'Chillas',site_title_with_separator:' | Chillas',home_meta_title:"Welcome to Chillas",bgimage:'/img/ninjaprocmn/chillas/body_bg.jpg'},"order.egajuiceclinic.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"CC11FCFA-3F4D-4AA9-9082-665BC5E7C669",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIycGhvbmUlMjI6JTIyMDY1NjY5NDE5MDAlMjIsJTIyZmFjZWJvb2slMjI6JTIyMTg2MzQ3NjMyMDU0OTI5OCUyMiwlMjJlbWFpbCUyMjolMjJvcmRlcnNAZWdhanVpY2VjbGluaWMuY29tJTIyJTdE",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Ega Juice',stripeImage:"https://order.egajuiceclinic.com/img/ninjaprocmn/egajuice/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'egajuice',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.egajuiceclinic.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.egajuiceclinic.com/#/',fbImage:'https://order.egajuiceclinic.com/img/egajuice/preview.jpg',fbTitle:'Ega Juice',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.egajuiceclinic.com/'},/* Twitter  */tw:{twURL:'https://order.egajuiceclinic.com/#/',twTitile:'Ega Juice',twvia:'Ega Juice'},/* google Plus data   */gp:{gpURL:'http://order.egajuiceclinic.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.egajuiceclinic.com/#/',waSeparator:'Ega Juice'},site_title:'Ega Juice',forcewww:'YES',site_title_with_separator:' | Ega Juice',home_meta_title:"Welcome to Ega Juice",bgimage:'/img/ninjaprocmn/egajuice/body_bg.jpg',enablesccan:'Yes'},"order.greenhousecafe.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"0BD8D167-6DDA-4DCE-A063-2F440A15397D",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIyd2hhdHNhcHAlMjI6JTIyKzY1OTA4NzU5NDElMjIsJTIycGhvbmUlMjI6JTIyKzY1Njg2MzAxMTAlMjIsJTIyZmFjZWJvb2slMjI6JTIyNTcyNTM5MjE5NTU3ODc4JTIyLCUyMmVtYWlsJTIyOiUyMmNvbnRhY3R1c0BncmVlbmhvdXNlY2FmZS5jb20uc2clMjIlN0Q=",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Green House Cafe',stripeImage:"https://order.greenhousecafe.com.sg/img/ninjaprocmn/greenhouse/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'greenhouse',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.greenhousecafe.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.greenhousecafe.com.sg/#/',fbImage:'https://order.greenhousecafe.com.sg/img/greenhouse/preview.jpg',fbTitle:'Green House Cafe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.greenhousecafe.com.sg/'},/* Twitter  */tw:{twURL:'https://order.greenhousecafe.com.sg/#/',twTitile:'Green House Cafe',twvia:'Green House Cafe'},/* google Plus data   */gp:{gpURL:'http://order.greenhousecafe.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.greenhousecafe.com.sg/#/',waSeparator:'Green House Cafe'},site_title:'Green House Cafe',site_title_with_separator:' | Green House Cafe',home_meta_title:"Welcome to Green House Cafe",bgimage:'/img/ninjaprocmn/greenhouse/body_bg.jpg'},"order.keto-indulgence.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"3904C55A-6013-469A-8735-72EF19F38DDC",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Elyon Cafe',stripeImage:"https://order.keto-indulgence.com/img/ninjaprocmn/elyoncafe/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'elyoncafe',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.keto-indulgence.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.keto-indulgence.com/#/',fbImage:'https://order.keto-indulgence.com/img/elyoncafe/preview.jpg',fbTitle:'Elyon Cafe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.keto-indulgence.com/'},/* Twitter  */tw:{twURL:'https://order.keto-indulgence.com/#/',twTitile:'Elyon Cafe',twvia:'Elyon Cafe'},/* google Plus data   */gp:{gpURL:'http://order.keto-indulgence.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.keto-indulgence.com/#/',waSeparator:'Elyon Cafe'},site_title:'Elyon Cafe',site_title_with_separator:' | Elyon Cafe',home_meta_title:"Welcome to Elyon Cafe",bgimage:'/img/ninjaprocmn/elyoncafe/body_bg.jpg'},"www.dynamicdiningsg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"0C81A804-F745-4D69-9DC6-E609A719ED0A",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Dynamic Dining',stripeImage:"https://www.dynamicdiningsg.com/img/ninjaprocmn/dynamic/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'dynamic',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.dynamicdiningsg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.dynamicdiningsg.com/#/',fbImage:'https://www.dynamicdiningsg.com/img/dynamic/preview.jpg',fbTitle:'Dynamic Dining',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.dynamicdiningsg.com/'},/* Twitter  */tw:{twURL:'https://www.dynamicdiningsg.com/#/',twTitile:'Dynamic Dining',twvia:'Dynamic Dining'},/* google Plus data   */gp:{gpURL:'http://www.dynamicdiningsg.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.dynamicdiningsg.com/#/',waSeparator:'Dynamic Dining'},site_title:'Dynamic Dining',forcewww:'YES',site_title_with_separator:' | Dynamic Dining',home_meta_title:"Welcome to Dynamic Dining",bgimage:'/img/ninjaprocmn/dynamic/body_bg.jpg'},"order.inspirithouse.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"55E5FFE8-05D9-42AC-A661-C5E0F747B485",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Inspirit House',stripeImage:"https://order.inspirithouse.com/img/ninjaprocmn/inspirithouse/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'inspirithouse',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.inspirithouse.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.inspirithouse.com/#/',fbImage:'https://order.inspirithouse.com/img/inspirithouse/preview.jpg',fbTitle:'Inspirit House',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.inspirithouse.com/'},/* Twitter  */tw:{twURL:'https://order.inspirithouse.com/#/',twTitile:'Inspirit House',twvia:'Inspirit House'},/* google Plus data   */gp:{gpURL:'http://order.inspirithouse.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.inspirithouse.com/#/',waSeparator:'Inspirit House'},site_title:'Inspirit House',site_title_with_separator:' | Inspirit House',home_meta_title:"Welcome to Inspirit House",bgimage:'/img/ninjaprocmn/inspirithouse/body_bg.jpg'},"order.eighteenchefs.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"57D02BBE-A453-4F97-9D79-DB3CA9C27525",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Eighteen Chefs',stripeImage:"https://order.eighteenchefs.com/img/ninjaprocmn/eighteenchefs/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'eighteenchefs',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.eighteenchefs.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.eighteenchefs.com/#/',fbImage:'https://order.eighteenchefs.com/img/eighteenchefs/preview.jpg',fbTitle:'Eighteen Chefs',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.eighteenchefs.com/'},/* Twitter  */tw:{twURL:'https://order.eighteenchefs.com/#/',twTitile:'Eighteen Chefs',twvia:'Eighteen Chefs'},/* google Plus data   */gp:{gpURL:'http://order.eighteenchefs.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.eighteenchefs.com/#/',waSeparator:'Eighteen Chefs'},site_title:'Eighteen Chefs',site_title_with_separator:' | Eighteen Chefs',home_meta_title:"Welcome to Eighteen Chefs",bgimage:'/img/ninjaprocmn/eighteenchefs/body_bg.jpg'},"order.currynations.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"B7F75474-F5F3-4657-AE64-A8E0D43C100A",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Curry Nations',stripeImage:"https://order.currynations.com/img/ninjaprocmn/currynations/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'currynations',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.currynations.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.currynations.com/#/',fbImage:'https://order.currynations.com/img/currynations/preview.jpg',fbTitle:'Curry Nations',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.currynations.com/'},/* Twitter  */tw:{twURL:'https://order.currynations.com/#/',twTitile:'Curry Nations',twvia:'Curry Nations'},/* google Plus data   */gp:{gpURL:'http://order.currynations.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.currynations.com/#/',waSeparator:'Curry Nations'},site_title:'Curry Nations',site_title_with_separator:' | Curry Nations',home_meta_title:"Welcome to Curry Nations",bgimage:'/img/ninjaprocmn/currynations/body_bg.jpg'},"order.717trading.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"AD716160-DE4D-4BFF-9EEC-B7148F91FBC5",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'717 Trading',stripeImage:"https://order.717trading.com.sg/img/ninjaprocmn/freshdurian/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'freshdurian',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.717trading.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.717trading.com.sg/#/',fbImage:'https://order.717trading.com.sg/img/freshdurian/preview.jpg',fbTitle:'717 Trading',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.717trading.com.sg/'},/* Twitter  */tw:{twURL:'https://order.717trading.com.sg/#/',twTitile:'717 Trading',twvia:'717 Trading'},/* google Plus data   */gp:{gpURL:'http://order.717trading.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.717trading.com.sg/#/',waSeparator:'717 Trading'},site_title:'717 Trading',site_title_with_separator:' | 717 Trading',home_meta_title:"Welcome to 717 Trading",bgimage:'/img/ninjaprocmn/freshdurian/body_bg.jpg'},"www.blackboyscubanos.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"A4785C91-2610-43E4-BA48-92F79CECB50C",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Black Boys Cubanos',stripeImage:"https://www.blackboyscubanos.com/img/ninjaprocmn/blackboys/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'blackboys',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.blackboyscubanos.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.blackboyscubanos.com/#/',fbImage:'https://www.blackboyscubanos.com/img/blackboys/preview.jpg',fbTitle:'Black Boys Cubanos',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.blackboyscubanos.com/'},/* Twitter  */tw:{twURL:'https://www.blackboyscubanos.com/#/',twTitile:'Black Boys Cubanos',twvia:'Black Boys Cubanos'},/* google Plus data   */gp:{gpURL:'http://www.blackboyscubanos.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.blackboyscubanos.com/#/',waSeparator:'Black Boys Cubanos'},site_title:'Black Boys Cubanos',forcewww:'YES',site_title_with_separator:' | Black Boys Cubanos',home_meta_title:"Welcome to Black Boys Cubanos",bgimage:'/img/ninjaprocmn/blackboys/body_bg.jpg'},"order.greenleafcafe.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"A8362694-E4F3-4A0B-A157-0F7FBCF82502",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Greenleaf Cafe',stripeImage:"https://order.greenleafcafe.com.sg/img/ninjaprocmn/greenleaf/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'greenleaf',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.greenleafcafe.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.greenleafcafe.com.sg/#/',fbImage:'https://order.greenleafcafe.com.sg/img/greenleaf/preview.jpg',fbTitle:'Greenleaf Cafe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.greenleafcafe.com.sg/'},/* Twitter  */tw:{twURL:'https://order.greenleafcafe.com.sg/#/',twTitile:'Greenleaf Cafe',twvia:'Greenleaf Cafe'},/* google Plus data   */gp:{gpURL:'http://order.greenleafcafe.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.greenleafcafe.com.sg/#/',waSeparator:'Greenleaf Cafe'},site_title:'Greenleaf Cafe',site_title_with_separator:' | Greenleaf Cafe',home_meta_title:"Welcome to Greenleaf Cafe",bgimage:'/img/ninjaprocmn/greenleaf/body_bg.jpg'},"www.nawabsbriyani.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D2630350-4A81-4D4D-AF7D-D7D1656C34DA",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Nawabs Kitchen',stripeImage:"https://www.nawabsbriyani.com/img/ninjaprocmn/nawabskitchen/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'nawabskitchen',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.nawabsbriyani.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.nawabsbriyani.com/#/',fbImage:'https://www.nawabsbriyani.com/img/nawabskitchen/preview.jpg',fbTitle:'Nawabs Kitchen',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.nawabsbriyani.com/'},/* Twitter  */tw:{twURL:'https://www.nawabsbriyani.com/#/',twTitile:'Nawabs Kitchen',twvia:'Nawabs Kitchen'},/* google Plus data   */gp:{gpURL:'http://www.nawabsbriyani.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.nawabsbriyani.com/#/',waSeparator:'Nawabs Kitchen'},site_title:'Nawabs Kitchen',forcewww:'YES',site_title_with_separator:' | Nawabs Kitchen',home_meta_title:"Welcome to Nawabs Kitchen",bgimage:'/img/ninjaprocmn/nawabskitchen/body_bg.jpg'},"order.pizzaboysg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"961EAB20-EA57-4D91-9F04-265ACE34BD05",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIyZmFjZWJvb2slMjI6JTIyODMxNjEzMzE2OTQxOTA4JTIyJTdE",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Pizzaboy',stripeImage:"https://order.pizzaboysg.com/img/ninjaprocmn/pizzaboy/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'pizzaboy',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.pizzaboysg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.pizzaboysg.com/#/',fbImage:'https://order.pizzaboysg.com/img/pizzaboy/preview.jpg',fbTitle:'Pizzaboy',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.pizzaboysg.com/'},/* Twitter  */tw:{twURL:'https://order.pizzaboysg.com/#/',twTitile:'Pizzaboy',twvia:'Pizzaboy'},/* google Plus data   */gp:{gpURL:'http://order.pizzaboysg.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.pizzaboysg.com/#/',waSeparator:'Pizzaboy'},site_title:'Pizzaboy',site_title_with_separator:' | Pizzaboy',home_meta_title:"Welcome to Pizzaboy",bgimage:'/img/ninjaprocmn/pizzaboy/body_bg.jpg'},"order.zazzpizza.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"DDAA254C-BD1E-49F0-AD1E-164A140421D3",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Zazz Pizza',stripeImage:"https://order.zazzpizza.sg/img/ninjaprocmn/zazzpizza/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'zazzpizza',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.zazzpizza.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.zazzpizza.sg/#/',fbImage:'https://order.zazzpizza.sg/img/zazzpizza/preview.jpg',fbTitle:'Zazz Pizza',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.zazzpizza.sg/'},/* Twitter  */tw:{twURL:'https://order.zazzpizza.sg/#/',twTitile:'Zazz Pizza',twvia:'Zazz Pizza'},/* google Plus data   */gp:{gpURL:'http://order.zazzpizza.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.zazzpizza.sg/#/',waSeparator:'Zazz Pizza'},site_title:'Zazz Pizza',site_title_with_separator:' | Zazz Pizza',home_meta_title:"Welcome to Zazz Pizza",bgimage:'/img/ninjaprocmn/zazzpizza/body_bg.jpg'},"kiddypalace.ninjapro.co":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"C3A3A5E8-FAAA-41BB-A73F-13D44F391976",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Kiddy Palace',stripeImage:"https://kiddypalace.ninjapro.co/img/ninjaprocmn/kiddypalace/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'kiddypalace',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://kiddypalace.ninjapro.co/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://kiddypalace.ninjapro.co/#/',fbImage:'https://kiddypalace.ninjapro.co/img/kiddypalace/preview.jpg',fbTitle:'Kiddy Palace',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://kiddypalace.ninjapro.co/'},/* Twitter  */tw:{twURL:'https://kiddypalace.ninjapro.co/#/',twTitile:'Kiddy Palace',twvia:'Kiddy Palace'},/* google Plus data   */gp:{gpURL:'http://kiddypalace.ninjapro.co/#/'},/* Whatsapp data   */wa:{waURL:'http://kiddypalace.ninjapro.co/#/',waSeparator:'Kiddy Palace'},site_title:'Kiddy Palace',site_title_with_separator:' | Kiddy Palace',home_meta_title:"Welcome to Kiddy Palace",bgimage:'/img/ninjaprocmn/kiddypalace/body_bg.jpg',enablesccan:'Yes'},"www.bikanervalasg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"9DED92D4-FED9-4AE7-8866-86A030EB6A4B",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Bikanervala',stripeImage:"https://www.bikanervalasg.com/img/ninjaprocmn/bikanervala/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'bikanervala',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.bikanervalasg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.bikanervalasg.com/#/',fbImage:'https://www.bikanervalasg.com/img/bikanervala/preview.jpg',fbTitle:'Bikanervala',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.bikanervalasg.com/'},/* Twitter  */tw:{twURL:'https://www.bikanervalasg.com/#/',twTitile:'Bikanervala',twvia:'Bikanervala'},/* google Plus data   */gp:{gpURL:'http://www.bikanervalasg.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.bikanervalasg.com/#/',waSeparator:'Bikanervala'},site_title:'Bikanervala',forcewww:'YES',site_title_with_separator:' | Bikanervala',home_meta_title:"Welcome to Bikanervala",bgimage:'/img/ninjaprocmn/bikanervala/body_bg.jpg'},"order.vatossg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"1EEBEE8F-D7A4-4B56-A040-44AE76FE4A25",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Vatos',stripeImage:"https://order.vatossg.com/img/ninjaprocmn/vatos/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'vatos',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.vatossg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.vatossg.com/#/',fbImage:'https://order.vatossg.com/img/vatos/preview.jpg',fbTitle:'Vatos',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.vatossg.com/'},/* Twitter  */tw:{twURL:'https://order.vatossg.com/#/',twTitile:'Vatos',twvia:'Vatos'},/* google Plus data   */gp:{gpURL:'http://order.vatossg.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.vatossg.com/#/',waSeparator:'Vatos'},site_title:'Vatos',site_title_with_separator:' | Vatosa',home_meta_title:"Welcome to Vatos",bgimage:'/img/ninjaprocmn/vatos/body_bg.jpg'},"order.themeatery.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"68009D56-9386-4ECE-92D8-6F81E11B8742",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIyd2hhdHNhcHAlMjI6JTIyMDY1ODg5Mzc1NjElMjIsJTIyZmFjZWJvb2slMjI6JTIyMjA3NTA0MjIxOTQ3Njc4OCUyMiwlMjJlbWFpbCUyMjolMjJyZW5nYUB0aGVtZWF0ZXJ5LnNnJTIyJTdE",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'The Meatery',stripeImage:"https://order.themeatery.sg/img/ninjaprocmn/meatery/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'meatery',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.themeatery.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.themeatery.sg/#/',fbImage:'https://order.themeatery.sg/img/meatery/preview.jpg',fbTitle:'The Meatery',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.themeatery.sg/'},/* Twitter  */tw:{twURL:'https://order.themeatery.sg/#/',twTitile:'The Meatery',twvia:'The Meatery'},/* google Plus data   */gp:{gpURL:'http://order.themeatery.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.themeatery.sg/#/',waSeparator:'The Meatery'},site_title:'The Meatery',site_title_with_separator:' | The Meatery',home_meta_title:"Welcome to The Meatery",bgimage:'/img/ninjaprocmn/meatery/body_bg.jpg'},"www.wangyuanfishsoup.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"0895EF10-4D64-4791-8EA6-CA447C8DC768",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Wang Yuan Fish Soup',stripeImage:"https://www.wangyuanfishsoup.com/img/ninjaprocmn/wangyuan/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'wangyuan',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.wangyuanfishsoup.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.wangyuanfishsoup.com/#/',fbImage:'https://www.wangyuanfishsoup.com/img/wangyuan/preview.jpg',fbTitle:'Wang Yuan Fish Soup',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.wangyuanfishsoup.com/'},/* Twitter  */tw:{twURL:'https://www.wangyuanfishsoup.com/#/',twTitile:'Wang Yuan Fish Soup',twvia:'Wang Yuan Fish Soup'},/* google Plus data   */gp:{gpURL:'http://www.wangyuanfishsoup.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.wangyuanfishsoup.com/#/',waSeparator:'Wang Yuan Fish Soup'},site_title:'Wang Yuan Fish Soup',forcewww:'YES',site_title_with_separator:' | Wang Yuan Fish Soup',home_meta_title:"Welcome to Wang Yuan Fish Soup",bgimage:'/img/ninjaprocmn/wangyuan/body_bg.jpg'},"www.dashengsg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"09D52521-8F4D-4E7B-A99D-5BD9E603D921",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Da Sheng Minced Pork Noodles',stripeImage:"https://www.dashengsg.com/img/ninjaprocmn/dasheng/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'dasheng',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.dashengsg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.dashengsg.com/#/',fbImage:'https://www.dashengsg.com/img/dasheng/preview.jpg',fbTitle:'Da Sheng Minced Pork Noodles',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.dashengsg.com/'},/* Twitter  */tw:{twURL:'https://www.dashengsg.com/#/',twTitile:'Da Sheng Minced Pork Noodles',twvia:'Da Sheng Minced Pork Noodles'},/* google Plus data   */gp:{gpURL:'http://www.dashengsg.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.dashengsg.com/#/',waSeparator:'Da Sheng Minced Pork Noodles'},site_title:'Da Sheng Minced Pork Noodles',forcewww:'YES',site_title_with_separator:' | Da Sheng Minced Pork Noodles',home_meta_title:"Welcome to Da Sheng Minced Pork Noodles",bgimage:'/img/ninjaprocmn/dasheng/body_bg.jpg'},"order.camaca.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"0CBD3191-08D0-4A58-9541-53A0923D0800",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Camaca',stripeImage:"https://order.camaca.sg/img/ninjaprocmn/camaca/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'camaca',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.camaca.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.camaca.sg/#/',fbImage:'https://order.camaca.sg/img/dasheng/preview.jpg',fbTitle:'Camaca',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.camaca.sg/'},/* Twitter  */tw:{twURL:'https://order.camaca.sg/#/',twTitile:'Camaca',twvia:'Camaca'},/* google Plus data   */gp:{gpURL:'http://order.camaca.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.camaca.sg/#/',waSeparator:'Camaca'},site_title:'Camaca',site_title_with_separator:' | Camaca',home_meta_title:"Welcome to Camaca",bgimage:'/img/ninjaprocmn/camaca/body_bg.jpg'},"www.abumubarakmandirice.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"AF75C2CD-90D2-4EFF-A1EE-C5AF199BC874",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Abumubarak Mandi Rice',stripeImage:"https://www.abumubarakmandirice.com/img/ninjaprocmn/abumubarak/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'abumubarak',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.abumubarakmandirice.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.abumubarakmandirice.com/#/',fbImage:'https://www.abumubarakmandirice.com/img/abumubarak/preview.jpg',fbTitle:'Abumubarak Mandi Rice',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.abumubarakmandirice.com/'},/* Twitter  */tw:{twURL:'https://www.abumubarakmandirice.com/#/',twTitile:'Abumubarak Mandi Rice',twvia:'Abumubarak Mandi Rice'},/* google Plus data   */gp:{gpURL:'http://www.abumubarakmandirice.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.abumubarakmandirice.com/#/',waSeparator:'Abumubarak Mandi Rice'},site_title:'Abumubarak Mandi Rice',forcewww:'YES',site_title_with_separator:' | Abumubarak Mandi Rice',home_meta_title:"Welcome to Abumubarak Mandi Rice",bgimage:'/img/ninjaprocmn/abumubarak/body_bg.jpg'},"order.luckycafe.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"FAE285F1-9DBD-48DD-976F-3CEEF4F7F8AE",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Lucky Cafe',stripeImage:"https://order.luckycafe.com.sg/img/ninjaprocmn/luckycafe/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'luckycafe',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.luckycafe.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.luckycafe.com.sg/#/',fbImage:'https://order.luckycafe.com.sg/img/luckycafe/preview.jpg',fbTitle:'Lucky Cafe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.luckycafe.com.sg/'},/* Twitter  */tw:{twURL:'https://order.luckycafe.com.sg/#/',twTitile:'Lucky Cafe',twvia:'Lucky Cafe'},/* google Plus data   */gp:{gpURL:'http://order.luckycafe.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.luckycafe.com.sg/#/',waSeparator:'Lucky Cafe'},site_title:'Lucky Cafe',site_title_with_separator:' | Lucky Cafe',home_meta_title:"Welcome to Lucky Cafe",bgimage:'/img/ninjaprocmn/luckycafe/body_bg.jpg'},"order.chatramuesg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F1ED4F6E-CFC1-40E7-AC7D-70AE54316761",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Cha Tra Mue',stripeImage:"https://order.chatramuesg.com/img/ninjaprocmn/chatramue/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'chatramue',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.chatramuesg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.chatramuesg.com/#/',fbImage:'https://order.chatramuesg.com/img/chatramue/preview.jpg',fbTitle:'Cha Tra Mue',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.chatramuesg.com/'},/* Twitter  */tw:{twURL:'https://order.chatramuesg.com/#/',twTitile:'Cha Tra Mue',twvia:'Cha Tra Mue'},/* google Plus data   */gp:{gpURL:'http://order.chatramuesg.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.chatramuesg.com/#/',waSeparator:'Cha Tra Mue'},site_title:'Cha Tra Mue',site_title_with_separator:' | Cha Tra Mue',home_meta_title:"Welcome to Cha Tra Mue",bgimage:'/img/ninjaprocmn/chatramue/body_bg.jpg'},"www.cohaibanhmi.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"590C8489-82FA-4A58-AC47-D9F938DD226B",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Co Hai Banh Mi',stripeImage:"https://www.cohaibanhmi.com/img/ninjaprocmn/cohaibanhmi/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'cohaibanhmi',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.cohaibanhmi.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.cohaibanhmi.com/#/',fbImage:'https://www.cohaibanhmi.com/img/cohaibanhmi/preview.jpg',fbTitle:'Co Hai Banh Mi',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.cohaibanhmi.com/'},/* Twitter  */tw:{twURL:'https://www.cohaibanhmi.com/#/',twTitile:'Co Hai Banh Mi',twvia:'Co Hai Banh Mi'},/* google Plus data   */gp:{gpURL:'http://www.cohaibanhmi.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.cohaibanhmi.com/#/',waSeparator:'Co Hai Banh Mi'},site_title:'Co Hai Banh Mi',forcewww:'YES',site_title_with_separator:' | Co Hai Banh Mi',home_meta_title:"Welcome to Co Hai Banh Mi",bgimage:'/img/ninjaprocmn/cohaibanhmi/body_bg.jpg'},"www.edenfoodhall.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Eden Food Hall',stripeImage:"https://www.edenfoodhall.com/img/ninjaprocmn/edenfoodhall/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'edenfoodhall',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.edenfoodhall.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.edenfoodhall.com/#/',fbImage:'https://www.edenfoodhall.com/img/edenfoodhall/preview.jpg',fbTitle:'Eden Food Hall',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.edenfoodhall.com/'},/* Twitter  */tw:{twURL:'https://www.edenfoodhall.com/#/',twTitile:'Eden Food Hall',twvia:'Eden Food Hall'},/* google Plus data   */gp:{gpURL:'http://www.edenfoodhall.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.edenfoodhall.com/#/',waSeparator:'Eden Food Hall'},site_title:'Eden Food Hall',forcewww:'YES',site_title_with_separator:' | Eden Food Hall',home_meta_title:"Welcome to Eden Food Hall",bgimage:'/img/ninjaprocmn/edenfoodhall/body_bg.jpg'},"order.kailashparbat.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"A6AE2DA0-031E-41EB-B92F-984663170B43",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Kailashparbat',stripeImage:"https://order.kailashparbat.com.sg/img/ninjaprocmn/kailashparbat/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'kailashparbat',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.kailashparbat.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.kailashparbat.com.sg/#/',fbImage:'https://order.kailashparbat.com.sg/img/kailashparbat/preview.jpg',fbTitle:'Kailashparbat',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.kailashparbat.com.sg/'},/* Twitter  */tw:{twURL:'https://order.kailashparbat.com.sg/#/',twTitile:'Kailashparbat',twvia:'Kailashparbat'},/* google Plus data   */gp:{gpURL:'http://order.kailashparbat.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.kailashparbat.com.sg/#/',waSeparator:'Kailashparbat'},site_title:'Kailashparbat',site_title_with_separator:' | Kailashparbat',home_meta_title:"Welcome to Kailashparbat",bgimage:'/img/ninjaprocmn/kailashparbat/body_bg.jpg'},"www.koedosg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"1E28AF0F-29F8-4BC5-9B47-8BA1F8199E5B",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Demae Sushi Koedo',stripeImage:"https://www.koedosg.com/img/ninjaprocmn/koedosg/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'koedosg',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.koedosg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.koedosg.com/#/',fbImage:'https://www.koedosg.com/img/koedosg/preview.jpg',fbTitle:'Demae Sushi Koedo',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.koedosg.com/'},/* Twitter  */tw:{twURL:'https://www.koedosg.com/#/',twTitile:'Demae Sushi Koedo',twvia:'Demae Sushi Koedo'},/* google Plus data   */gp:{gpURL:'http://www.koedosg.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.koedosg.com/#/',waSeparator:'Demae Sushi Koedo'},site_title:'Demae Sushi Koedo',forcewww:'YES',site_title_with_separator:' | Demae Sushi Koedo',home_meta_title:"Welcome to Demae Sushi Koedo",bgimage:'/img/ninjaprocmn/koedosg/body_bg.jpg'},"order.wholesomesavour.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"DA2E4426-0FC5-4A47-BBED-26AD217F2BA6",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Wholesome Savour',stripeImage:"https://order.wholesomesavour.com/img/ninjaprocmn/wholesome/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'wholesome',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.wholesomesavour.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.wholesomesavour.com/#/',fbImage:'https://order.wholesomesavour.com/img/wholesome/preview.jpg',fbTitle:'Wholesome Savour',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.wholesomesavour.com/'},/* Twitter  */tw:{twURL:'https://order.wholesomesavour.com/#/',twTitile:'Wholesome Savour',twvia:'Wholesome Savour'},/* google Plus data   */gp:{gpURL:'http://order.wholesomesavour.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.wholesomesavour.com/#/',waSeparator:'Wholesome Savour'},site_title:'Wholesome Savour',site_title_with_separator:' | Wholesome Savour',home_meta_title:"Welcome to Wholesome Savour",bgimage:'/img/ninjaprocmn/wholesome/body_bg.jpg'},"www.doesingapore.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"0E498BC1-88F5-44E3-B5BB-CCE4E8AFC3A6",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'DOE',stripeImage:"https://www.doesingapore.com/img/ninjaprocmn/doesingapore/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'doesingapore',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.doesingapore.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.doesingapore.com/#/',fbImage:'https://www.doesingapore.com/img/doesingapore/preview.jpg',fbTitle:'DOE',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.doesingapore.com/'},/* Twitter  */tw:{twURL:'https://www.doesingapore.com/#/',twTitile:'DOE',twvia:'DOE'},/* google Plus data   */gp:{gpURL:'http://www.doesingapore.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.doesingapore.com/#/',waSeparator:'DOE'},site_title:'DOE',forcewww:'YES',site_title_with_separator:' | DOE',home_meta_title:"Welcome to DOE",bgimage:'/img/ninjaprocmn/doesingapore/body_bg.jpg'},"order.bakedtoorder.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"320BAB66-2B77-47F3-980C-82F8B4AF1940",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIycGhvbmUlMjI6JTIyKzY1NjgwMzk0MjclMjIsJTIyZW1haWwlMjI6JTIyZnJlc2hseUBiYWtlZHRvb3JkZXIuc2clMjIlN0Q=",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Baked To Order',stripeImage:"https://order.bakedtoorder.sg/img/ninjaprocmn/bakedtoorder/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'bakedtoorder',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.bakedtoorder.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.bakedtoorder.sg/#/',fbImage:'https://order.bakedtoorder.sg/img/bakedtoorder/preview.jpg',fbTitle:'Baked To Order',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.bakedtoorder.sg/'},/* Twitter  */tw:{twURL:'https://order.bakedtoorder.sg/#/',twTitile:'Baked To Order',twvia:'Baked To Order'},/* google Plus data   */gp:{gpURL:'http://order.bakedtoorder.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.bakedtoorder.sg/#/',waSeparator:'Baked To Order'},site_title:'Baked To Order',site_title_with_separator:' | Baked To Order',home_meta_title:"Welcome to Baked To Order",bgimage:'/img/ninjaprocmn/bakedtoorder/body_bg.jpg'},"www.tribedcubelounge.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"782D2401-5C31-43E9-83CF-B3AB5A394E66",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'The Tribe',stripeImage:"https://www.tribedcubelounge.com/img/ninjaprocmn/thetribe/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'thetribe',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.tribedcubelounge.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.tribedcubelounge.com/#/',fbImage:'https://www.tribedcubelounge.com/img/thetribe/preview.jpg',fbTitle:'The Tribe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.tribedcubelounge.com/'},/* Twitter  */tw:{twURL:'https://www.tribedcubelounge.com/#/',twTitile:'The Tribe',twvia:'The Tribe'},/* google Plus data   */gp:{gpURL:'http://www.tribedcubelounge.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.tribedcubelounge.com/#/',waSeparator:'The Tribe'},site_title:'The Tribe',forcewww:'YES',site_title_with_separator:' | The Tribe',home_meta_title:"Welcome to The Tribe",bgimage:'/img/ninjaprocmn/thetribe/body_bg.jpg'},"www.lotusthaisingapore.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"FD1B35F9-A38A-4212-BCB2-63175CDC22F9",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Lotus Thai',stripeImage:"https://www.lotusthaisingapore.com/img/ninjaprocmn/lotusthai/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'lotusthai',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.lotusthaisingapore.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.lotusthaisingapore.com/#/',fbImage:'https://www.lotusthaisingapore.com/img/lotusthai/preview.jpg',fbTitle:'Lotus Thai',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.lotusthaisingapore.com/'},/* Twitter  */tw:{twURL:'https://www.lotusthaisingapore.com/#/',twTitile:'Lotus Thai',twvia:'Lotus Thai'},/* google Plus data   */gp:{gpURL:'http://www.lotusthaisingapore.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.lotusthaisingapore.com/#/',waSeparator:'Lotus Thai'},site_title:'Lotus Thai',forcewww:'YES',site_title_with_separator:' | Lotus Thai',home_meta_title:"Welcome to Lotus Thai",bgimage:'/img/ninjaprocmn/lotusthai/body_bg.jpg'},"www.grainsandgreens.online":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"324274F9-A091-40E4-8EBA-002E5048667E",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Grains and Greens',stripeImage:"https://www.grainsandgreens.online/img/ninjaprocmn/grainsandgreens/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'grainsandgreens',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.grainsandgreens.online/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.grainsandgreens.online/#/',fbImage:'https://www.grainsandgreens.online/img/grainsandgreens/preview.jpg',fbTitle:'Grains and Greens',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.grainsandgreens.online/'},/* Twitter  */tw:{twURL:'https://www.grainsandgreens.online/#/',twTitile:'Grains and Greens',twvia:'Grains and Greens'},/* google Plus data   */gp:{gpURL:'http://www.grainsandgreens.online/#/'},/* Whatsapp data   */wa:{waURL:'http://www.grainsandgreens.online/#/',waSeparator:'Grains and Greens'},site_title:'Grains and Greens',forcewww:'YES',site_title_with_separator:' | Grains and Greens',home_meta_title:"Welcome to Grains and Greens",bgimage:'/img/ninjaprocmn/grainsandgreens/body_bg.jpg'},"order.tandoorlounge.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"A641208A-D15B-45A0-8076-63BE57C4928A",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Tandoor Lounge',stripeImage:"https://order.tandoorlounge.com/img/ninjaprocmn/tandoorlounge/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'tandoorlounge',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.tandoorlounge.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.tandoorlounge.com/#/',fbImage:'https://order.tandoorlounge.com/img/tandoorlounge/preview.jpg',fbTitle:'Tandoor Lounge',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.tandoorlounge.com/'},/* Twitter  */tw:{twURL:'https://order.tandoorlounge.com/#/',twTitile:'Tandoor Lounge',twvia:'Tandoor Lounge'},/* google Plus data   */gp:{gpURL:'http://order.tandoorlounge.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.tandoorlounge.com/#/',waSeparator:'Tandoor Lounge'},site_title:'Tandoor Lounge',site_title_with_separator:' | Tandoor Lounge',home_meta_title:"Welcome to Tandoor Lounge",bgimage:'/img/ninjaprocmn/tandoorlounge/body_bg.jpg'},"www.ollella.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D89F3695-82D5-4105-991A-7A373AEBEABF",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Ollella',stripeImage:"https://www.ollella.com/img/ninjaprocmn/ollella/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ollella',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.ollella.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.www.ollella.com/#/',fbImage:'https://www.www.ollella.com/img/ollella/preview.jpg',fbTitle:'Ollella',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.ollella.com/'},/* Twitter  */tw:{twURL:'https://www.ollella.com/#/',twTitile:'Ollella',twvia:'Ollella'},/* google Plus data   */gp:{gpURL:'http://www.ollella.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.ollella.com/#/',waSeparator:'Ollella'},site_title:'Ollella',forcewww:'YES',site_title_with_separator:' | Ollella',home_meta_title:"Welcome to Ollella",bgimage:'/img/ninjaprocmn/ollella/body_bg.jpg'},"www.ayamtaliwangsg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"DD85398E-1DD3-4EFF-9613-AC79A3A4C7D6",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Ayam Taliwang',stripeImage:"https://www.ayamtaliwangsg.com/img/ninjaprocmn/ayamtaliwang/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ayamtaliwang',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.ayamtaliwangsg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.ayamtaliwangsg.com/#/',fbImage:'https://www.ayamtaliwangsg.com/img/ayamtaliwang/preview.jpg',fbTitle:'Ayam Taliwang',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.ayamtaliwangsg.com/'},/* Twitter  */tw:{twURL:'https://www.ayamtaliwangsg.com/#/',twTitile:'Ayam Taliwang',twvia:'Ayam Taliwang'},/* google Plus data   */gp:{gpURL:'http://www.ayamtaliwangsg.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.ayamtaliwangsg.com/#/',waSeparator:'Ayam Taliwang'},site_title:'Ayam Taliwang',forcewww:'YES',site_title_with_separator:' | Ayam Taliwang',home_meta_title:"Welcome to Ayam Taliwang",bgimage:'/img/ninjaprocmn/ayamtaliwang/body_bg.jpg'},"www.portmakan.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"CD8D5FE3-0586-44DD-9360-EE9DEF351223",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Portmakan',stripeImage:"https://www.portmakan.sg/img/ninjaprocmn/portmakan/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'portmakan',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.portmakan.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.portmakan.sg/#/',fbImage:'https://www.portmakan.sg/img/portmakan/preview.jpg',fbTitle:'Portmakan',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.portmakan.sg/'},/* Twitter  */tw:{twURL:'https://www.portmakan.sg/#/',twTitile:'Portmakan',twvia:'Portmakan'},/* google Plus data   */gp:{gpURL:'http://www.portmakan.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://www.portmakan.sg/#/',waSeparator:'Portmakan'},site_title:'Portmakan',forcewww:'YES',site_title_with_separator:' | Portmakan',home_meta_title:"Welcome to Portmakan",bgimage:'/img/ninjaprocmn/portmakan/body_bg.jpg'},"order.ainice.biz":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"9DA50C3E-F970-4E68-BB5F-AEE25CF345BC",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Kookery Nook Cafe',stripeImage:"https://order.ainice.biz/img/ninjaprocmn/kookery/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'kookery',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.ainice.biz/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.ainice.biz/#/',fbImage:'https://order.ainice.biz/img/kookery/preview.jpg',fbTitle:'Kookery Nook Cafe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.ainice.biz/'},/* Twitter  */tw:{twURL:'https://order.ainice.biz/#/',twTitile:'Kookery Nook Cafe',twvia:'Kookery Nook Cafe'},/* google Plus data   */gp:{gpURL:'http://order.ainice.biz/#/'},/* Whatsapp data   */wa:{waURL:'http://order.ainice.biz/#/',waSeparator:'Kookery Nook Cafe'},site_title:'Kookery Nook Cafe',site_title_with_separator:' | Kookery Nook Cafe',home_meta_title:"Kookery Nook Cafe",bgimage:'/img/ninjaprocmn/kookery/body_bg.jpg'},"reservation.mrbiryanisg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"8862E1FC-5327-424D-8246-11A3408C0CAF",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Mr Biryani',stripeImage:"https://reservation.mrbiryanisg.com/img/ninjaprocmn/mrbiryani/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'mrbiryani',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://reservation.mrbiryanisg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://reservation.mrbiryanisg.com/#/',fbImage:'https://reservation.mrbiryanisg.com/img/mrbiryani/preview.jpg',fbTitle:'Mr Biryani',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://reservation.mrbiryanisg.com/'},/* Twitter  */tw:{twURL:'https://reservation.mrbiryanisg.com/#/',twTitile:'Mr Biryani',twvia:'Mr Biryani'},/* google Plus data   */gp:{gpURL:'http://reservation.mrbiryanisg.com/#/'},/* Whatsapp data   */wa:{waURL:'http://reservation.mrbiryanisg.com/#/',waSeparator:'Mr Biryani'},site_title:'Mr Biryani',site_title_with_separator:' | Mr Biryani',home_meta_title:"Mr Biryani",bgimage:'/img/ninjaprocmn/mrbiryani/body_bg.jpg'},"order.kudos.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"1239E773-EAD2-4831-BDB9-8BD390EE1916",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Kudos',stripeImage:"https://order.kudos.sg/img/ninjaprocmn/kudos/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'kudos',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.kudos.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.kudos.sg/#/',fbImage:'https://order.kudos.sg/img/kudos/preview.jpg',fbTitle:'Kudos',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.kudos.sg/'},/* Twitter  */tw:{twURL:'https://order.kudos.sg/#/',twTitile:'Kudos',twvia:'Kudos'},/* google Plus data   */gp:{gpURL:'http://order.kudos.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.kudos.sg/#/',waSeparator:'Kudos'},site_title:'Kudos',site_title_with_separator:' | Kudos',home_meta_title:"Kudos",bgimage:'/img/ninjaprocmn/kudos/body_bg.jpg'},"order.greendot.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F09B5ED3-2E64-4B8D-AB02-D201BAA65737",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Greendot',stripeImage:"https://order.greendot.sg/img/ninjaprocmn/greendot/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'greendot',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.greendot.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.greendot.sg/#/',fbImage:'https://order.greendot.sg/img/greendot/preview.jpg',fbTitle:'Greendot',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.greendot.sg/'},/* Twitter  */tw:{twURL:'https://order.greendot.sg/#/',twTitile:'Greendot',twvia:'Greendot'},/* google Plus data   */gp:{gpURL:'http://order.greendot.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.greendot.sg/#/',waSeparator:'Greendot'},site_title:'Greendot',site_title_with_separator:' | Greendot',home_meta_title:"Greendot",bgimage:'/img/ninjaprocmn/greendot/body_bg.jpg'},"www.halal-delicacies.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"28B90522-E3D3-459A-B6F5-CDE3CAF436D6",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Halal Delicacies',stripeImage:"https://www.halal-delicacies.com/img/ninjaprocmn/halaldelicacies/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'halaldelicacies',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.halal-delicacies.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.halal-delicacies.com/#/',fbImage:'https://www.halal-delicacies.com/img/halaldelicacies/preview.jpg',fbTitle:'Halal Delicacies',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.portmakan.sg/'},/* Twitter  */tw:{twURL:'https://www.halal-delicacies.com/#/',twTitile:'Halal Delicacies',twvia:'Halal Delicacies'},/* google Plus data   */gp:{gpURL:'http://www.halal-delicacies.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.halal-delicacies.com/#/',waSeparator:'Halal Delicacies'},site_title:'Halal Delicacies',forcewww:'YES',site_title_with_separator:' | Halal Delicacies',home_meta_title:"Welcome to Halal Delicacies",bgimage:'/img/ninjaprocmn/halaldelicacies/body_bg.jpg'},"www.bedok511bbq.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"011601A7-A075-4C1E-9913-CF7A5ED21130",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Bedok 511 BBQ',stripeImage:"https://www.bedok511bbq.com/img/ninjaprocmn/bedok511bbq/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'bedok511bbq',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.bedok511bbq.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.bedok511bbq.com/#/',fbImage:'https://www.bedok511bbq.com/img/bedok511bbq/preview.jpg',fbTitle:'Bedok 511 BBQ',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.bedok511bbq.com/'},/* Twitter  */tw:{twURL:'https://www.bedok511bbq.com/#/',twTitile:'Bedok 511 BBQ',twvia:'Bedok 511 BBQ'},/* google Plus data   */gp:{gpURL:'http://www.bedok511bbq.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.bedok511bbq.com/#/',waSeparator:'Bedok 511 BBQ'},site_title:'Bedok 511 BBQ',forcewww:'YES',site_title_with_separator:' | Bedok 511 BBQ',home_meta_title:"Welcome to Bedok 511 BBQ",bgimage:'/img/ninjaprocmn/bedok511bbq/body_bg.jpg'},"order.makcikepok2.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"97347EE4-2845-4011-BCE6-9C0B806DA437",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Makcikepok2',stripeImage:"https://order.makcikepok2.com/img/ninjaprocmn/makcikepok2/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'makcikepok2',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.makcikepok2.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.makcikepok2.com/#/',fbImage:'https://order.makcikepok2.com/img/makcikepok2/preview.jpg',fbTitle:'Makcikepok2',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.makcikepok2.com/'},/* Twitter  */tw:{twURL:'https://order.makcikepok2.com/#/',twTitile:'Makcikepok2',twvia:'Makcikepok2'},/* google Plus data   */gp:{gpURL:'http://order.makcikepok2.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.makcikepok2.com/#/',waSeparator:'Makcikepok2'},site_title:'Makcikepok2',site_title_with_separator:' | Makcikepok2',home_meta_title:"Welcome to Makcikepok2",bgimage:'/img/ninjaprocmn/makcikepok2/body_bg.jpg'},"order.provence.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"3039AB57-0894-4128-A921-F2D832B28902",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Provence',stripeImage:"https://order.provence.com.sg/img/ninjaprocmn/provence/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'provence',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.provence.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.provence.com.sg/#/',fbImage:'https://order.provence.com.sg/img/provence/preview.jpg',fbTitle:'Provence',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.provence.com.sg/'},/* Twitter  */tw:{twURL:'https://order.provence.com.sg/#/',twTitile:'Provence',twvia:'Provence'},/* google Plus data   */gp:{gpURL:'http://order.provence.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.provence.com.sg/#/',waSeparator:'Provence'},site_title:'Provence',site_title_with_separator:' | Provence',home_meta_title:"Welcome to Provence",bgimage:'/img/ninjaprocmn/provence/body_bg.jpg'},"order.nasilemakindulgence.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"4609FA79-DBD8-4AD0-BFA4-E0F4CFFBF987",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Nasi Lemak',stripeImage:"https://order.nasilemakindulgence.com/img/ninjaprocmn/nasilemak/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'nasilemak',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.nasilemakindulgence.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.nasilemakindulgence.com/#/',fbImage:'https://order.nasilemakindulgence.com/img/nasilemak/logo.png',fbTitle:'Nasi Lemak',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.nasilemakindulgence.com/'},/* Twitter  */tw:{twURL:'https://order.nasilemakindulgence.com/#/',twTitile:'Nasi Lemak',twvia:'Nasi Lemak'},/* google Plus data   */gp:{gpURL:'http://order.nasilemakindulgence.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.nasilemakindulgence.com/#/',waSeparator:'Nasi Lemak'},site_title:'Nasi Lemak',site_title_with_separator:' | Nasi Lemak',home_meta_title:"Welcome to Nasi Lemak",bgimage:'/img/ninjaprocmn/nasilemak/body_bg.jpg'},"order.blimpiesg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"AA850867-4108-4EB8-872B-024903608E9F",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Blimpie',stripeImage:"https://order.blimpiesg.com/img/ninjaprocmn/blimpie/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'blimpie',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.blimpiesg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.blimpiesg.com/#/',fbImage:'https://order.blimpiesg.com/img/blimpie/logo.png',fbTitle:'Blimpie',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.blimpiesg.com/'},/* Twitter  */tw:{twURL:'https://order.blimpiesg.com/#/',twTitile:'Blimpie',twvia:'Blimpie'},/* google Plus data   */gp:{gpURL:'https://order.blimpiesg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.blimpiesg.com/#/',waSeparator:'Blimpie'},site_title:'Blimpie',site_title_with_separator:' | Blimpie',home_meta_title:"Welcome to Blimpie",bgimage:'/img/ninjaprocmn/blimpie/body_bg.jpg'},"www.bbhqpl.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"69089BA4-D3EE-4A99-895E-0879850CA863",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'BBHQ',stripeImage:"https://www.bbhqpl.com/img/ninjaprocmn/bbhq/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'bbhq',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.bbhqpl.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.bbhqpl.com/#/',fbImage:'https://www.bbhqpl.com/img/bbhq/preview.jpg',fbTitle:'BBHQ',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.bbhqpl.com/'},/* Twitter  */tw:{twURL:'https://www.bbhqpl.com/#/',twTitile:'BBHQ',twvia:'BBHQ'},/* google Plus data   */gp:{gpURL:'http://www.bbhqpl.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.bbhqpl.com/#/',waSeparator:'BBHQ'},site_title:'BBHQ',forcewww:'YES',site_title_with_separator:' | BBHQ',home_meta_title:"Welcome to BBHQ",bgimage:'/img/ninjaprocmn/bbhq/body_bg.jpg'},"orderonline.ayambakarojolali.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"59DDF345-6FDA-4A7D-81D7-270635D19394",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'AYAM BAKAR OJOLALI',stripeImage:"https://orderonline.ayambakarojolali.com/img/ninjaprocmn/ojolali/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ojolali',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://orderonline.ayambakarojolali.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://orderonline.ayambakarojolali.com/#/',fbImage:'https://orderonline.ayambakarojolali.com/img/ojolali/preview.jpg',fbTitle:'AYAM BAKAR OJOLALI',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://orderonline.ayambakarojolali.com/'},/* Twitter  */tw:{twURL:'https://orderonline.ayambakarojolali.com/#/',twTitile:'AYAM BAKAR OJOLALI',twvia:'AYAM BAKAR OJOLALI'},/* google Plus data   */gp:{gpURL:'http://orderonline.ayambakarojolali.com/#/'},/* Whatsapp data   */wa:{waURL:'http://orderonline.ayambakarojolali.com/#/',waSeparator:'AYAM BAKAR OJOLALI'},site_title:'AYAM BAKAR OJOLALI',site_title_with_separator:' | AYAM BAKAR OJOLALI',home_meta_title:"Welcome to AYAM BAKAR OJOLALI",bgimage:'/img/ninjaprocmn/ojolali/body_bg.jpg'},"www.youtiaomei.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"1B146D63-0219-4417-9E68-5E2325D29982",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'You Tiao Mei',stripeImage:"https://www.youtiaomei.com/img/ninjaprocmn/youtiaomei/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'youtiaomei',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.youtiaomei.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.youtiaomei.com/#/',fbImage:'https://www.youtiaomei.com/img/youtiaomei/preview.jpg',fbTitle:'You Tiao Mei',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.youtiaomei.com/'},/* Twitter  */tw:{twURL:'https://www.youtiaomei.com/#/',twTitile:'You Tiao Mei',twvia:'You Tiao Mei'},/* google Plus data   */gp:{gpURL:'http://www.youtiaomei.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.youtiaomei.com/#/',waSeparator:'You Tiao Mei'},site_title:'You Tiao Mei',forcewww:'YES',site_title_with_separator:' | You Tiao Mei',home_meta_title:"Welcome to You Tiao Mei",bgimage:'/img/ninjaprocmn/youtiaomei/body_bg.jpg'},"order.lasaigon.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"CC804508-EB5E-4148-BF76-8A9D40D945FF",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'La Saigon',stripeImage:"https://order.lasaigon.com/img/ninjaprocmn/lasaigon/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'lasaigon',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.lasaigon.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.lasaigon.com/#/',fbImage:'https://order.lasaigon.com/img/lasaigon/preview.jpg',fbTitle:'La Saigon',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.lasaigon.com/'},/* Twitter  */tw:{twURL:'https://order.lasaigon.com/#/',twTitile:'La Saigon',twvia:'La Saigon'},/* google Plus data   */gp:{gpURL:'http://order.lasaigon.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.lasaigon.com/#/',waSeparator:'La Saigon'},site_title:'La Saigon',site_title_with_separator:' | La Saigon',home_meta_title:"Welcome to La Saigon",bgimage:'/img/ninjaprocmn/lasaigon/body_bg.jpg'},"order.xingfutangsg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"AFA6F84D-423C-44AB-A47A-A1AF8813B387",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Xing Fu Tang',stripeImage:"https://order.xingfutangsg.com/img/ninjaprocmn/xingfutang/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'xingfutang',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.xingfutangsg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.xingfutangsg.com/#/',fbImage:'https://order.xingfutangsg.com/img/xingfutang/preview.jpg',fbTitle:'Xing Fu Tang',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.xingfutangsg.com/'},/* Twitter  */tw:{twURL:'https://order.xingfutangsg.com/#/',twTitile:'Xing Fu Tang',twvia:'Xing Fu Tang'},/* google Plus data   */gp:{gpURL:'http://order.xingfutangsg.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.xingfutangsg.com/#/',waSeparator:'Xing Fu Tang'},site_title:'Xing Fu Tang',site_title_with_separator:' | Xing Fu Tang',home_meta_title:"Welcome to Xing Fu Tang",bgimage:'/img/ninjaprocmn/xingfutang/body_bg.jpg'},"order.mrspho.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"45AD857A-CE25-4E9F-A37B-BA27FCD8DF14",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Mrs Pho',stripeImage:"https://order.mrspho.com/img/ninjaprocmn/mrspho/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'mrspho',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.mrspho.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.mrspho.com/#/',fbImage:'https://order.mrspho.com/img/mrspho/preview.jpg',fbTitle:'Mrs Pho',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.mrspho.com/'},/* Twitter  */tw:{twURL:'https://order.mrspho.com/#/',twTitile:'Mrs Pho',twvia:'Mrs Pho'},/* google Plus data   */gp:{gpURL:'http://order.mrspho.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.mrspho.com/#/',waSeparator:'Mrs Pho'},site_title:'Mrs Pho',site_title_with_separator:' | Mrs Pho',home_meta_title:"Welcome to Mrs Pho",bgimage:'/img/ninjaprocmn/mrspho/body_bg.jpg'},"order.goodoldtaste.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"EA3688FD-DF96-4159-9414-84E74CD5782A",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Good Old Taste',stripeImage:"https://order.goodoldtaste.com.sg/img/ninjaprocmn/goodoldtaste/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'goodoldtaste',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.goodoldtaste.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.goodoldtaste.com.sg/#/',fbImage:'https://order.goodoldtaste.com.sg/img/goodoldtaste/preview.jpg',fbTitle:'Good Old Taste',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.goodoldtaste.com.sg/'},/* Twitter  */tw:{twURL:'https://order.goodoldtaste.com.sg/#/',twTitile:'Good Old Taste',twvia:'Good Old Taste'},/* google Plus data   */gp:{gpURL:'http://order.goodoldtaste.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.goodoldtaste.com.sg/#/',waSeparator:'Good Old Taste'},site_title:'Good Old Taste',site_title_with_separator:' | Good Old Taste',home_meta_title:"Welcome to Good Old Taste",bgimage:'/img/ninjaprocmn/goodoldtaste/body_bg.jpg'},"order.limaa51hajilane.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D84863F1-DD6F-4E21-A26E-0D8F989CCDD5",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Limaa',stripeImage:"https://order.limaa51hajilane.com/img/ninjaprocmn/limaa/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'limaa',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.limaa51hajilane.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.limaa51hajilane.com/#/',fbImage:'https://order.limaa51hajilane.com/img/limaa/preview.jpg',fbTitle:'Limaa',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.limaa51hajilane.com/'},/* Twitter  */tw:{twURL:'https://order.limaa51hajilane.com/#/',twTitile:'Limaa',twvia:'Limaa'},/* google Plus data   */gp:{gpURL:'http://order.limaa51hajilane.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.limaa51hajilane.com/#/',waSeparator:'Limaa'},site_title:'Limaa',site_title_with_separator:' | Limaa',home_meta_title:"Welcome to Limaa",bgimage:'/img/ninjaprocmn/limaa/body_bg.jpg'},"www.pokpokthai.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"720DFBEA-A0E6-4BC0-9B6E-859DB7195A3D",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Pok Pok Thai',stripeImage:"https://www.pokpokthai.com/img/ninjaprocmn/pokpokthai/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'pokpokthai',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.pokpokthai.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.pokpokthai.com/#/',fbImage:'https://www.pokpokthai.com/img/pokpokthai/preview.jpg',fbTitle:'Pok Pok Thai',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.pokpokthai.com/'},/* Twitter  */tw:{twURL:'https://www.pokpokthai.com/#/',twTitile:'Pok Pok Thai',twvia:'Pok Pok Thai'},/* google Plus data   */gp:{gpURL:'http://www.pokpokthai.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.pokpokthai.com/#/',waSeparator:'Pok Pok Thai'},site_title:'Pok Pok Thai',forcewww:'YES',site_title_with_separator:' | Pok Pok Thai',home_meta_title:"Welcome to Pok Pok Thai",bgimage:'/img/ninjaprocmn/pokpokthai/body_bg.jpg'},"order.gochiso-bento.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"3CEDCD40-D9CB-49D1-BD52-3DDBAB6CB70E",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'GOCHISO BENTO',stripeImage:"https://order.gochiso-bento.com/img/ninjaprocmn/gochisobento/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'gochisobento',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.gochiso-bento.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.gochiso-bento.com/#/',fbImage:'https://order.gochiso-bento.com/img/gochisobento/preview.jpg',fbTitle:'GOCHISO BENTO',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.gochiso-bento.com/'},/* Twitter  */tw:{twURL:'https://order.gochiso-bento.com/#/',twTitile:'GOCHISO BENTO',twvia:'GOCHISO BENTO'},/* google Plus data   */gp:{gpURL:'http://order.gochiso-bento.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.gochiso-bento.com/#/',waSeparator:'GOCHISO BENTO'},site_title:'GOCHISO BENTO',site_title_with_separator:' | GOCHISO BENTO',home_meta_title:"Welcome to GOCHISO BENTO",bgimage:'/img/ninjaprocmn/gochisobento/body_bg.jpg'},"www.winecityglobal.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"2AE048E7-2D84-42BE-9BB5-22016FC4DFBC",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'WINE CITY ',stripeImage:"https://www.winecityglobal.com/img/ninjaprocmn/winecity/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'winecity',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.winecityglobal.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.winecityglobal.com/#/',fbImage:'https://www.winecityglobal.com/img/winecity/preview.jpg',fbTitle:'WINE CITY',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.winecityglobal.com/'},/* Twitter  */tw:{twURL:'https://www.winecityglobal.com/#/',twTitile:'WINE CITY ',twvia:'WINE CITY '},/* google Plus data   */gp:{gpURL:'http://www.winecityglobal.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.winecityglobal.com/#/',waSeparator:'WINE CITY '},site_title:'WINE CITY ',forcewww:'YES',site_title_with_separator:' | WINE CITY ',home_meta_title:"Welcome to WINE CITY ",bgimage:'/img/ninjaprocmn/winecity/body_bg.jpg'},"www.thaibaang.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"ACE159CB-01A6-4B09-A94B-38A8385DBBF7",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Thai baang ',stripeImage:"https://www.thaibaang.com/img/ninjaprocmn/thaibaang/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'thaibaang',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.thaibaang.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.thaibaang.com/#/',fbImage:'https://www.thaibaang.com/img/thaibaang/preview.jpg',fbTitle:'Thai baang ',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.thaibaang.com/'},/* Twitter  */tw:{twURL:'https://www.thaibaang.com/#/',twTitile:'Thai baang ',twvia:'Thai baang '},/* google Plus data   */gp:{gpURL:'http://www.thaibaang.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.thaibaang.com/#/',waSeparator:'Thai baang '},site_title:'Thai baang ',forcewww:'YES',site_title_with_separator:' | Thai baang ',home_meta_title:"Welcome to Thai baang ",bgimage:'/img/ninjaprocmn/thaibaang/body_bg.jpg'},"order.thewhaletea.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"44DF417C-A1F0-404C-BDD8-FB077C3BEFA8",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'The Whale Tea',stripeImage:"https://order.thewhaletea.sg/img/ninjaprocmn/thewhaletea/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'thewhaletea',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.thewhaletea.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.thewhaletea.sg/#/',fbImage:'https://order.thewhaletea.sg/img/thewhaletea/preview.jpg',fbTitle:'The Whale Tea',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.thewhaletea.sg/'},/* Twitter  */tw:{twURL:'https://order.thewhaletea.sg/#/',twTitile:'The Whale Tea',twvia:'The Whale Tea'},/* google Plus data   */gp:{gpURL:'http://order.thewhaletea.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.thewhaletea.sg/#/',waSeparator:'The Whale Tea'},site_title:'The Whale Tea',site_title_with_separator:' | The Whale Tea',home_meta_title:"Welcome to The Whale Tea",bgimage:'/img/ninjaprocmn/thewhaletea/body_bg.jpg'},"order.yummypalace.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D5588172-6216-4908-88B7-ABCA75D50A79",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Yummy Palace',stripeImage:"https://order.yummypalace.com.sg/img/ninjaprocmn/yummypalace/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'yummypalace',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.yummypalace.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.yummypalace.com.sg/#/',fbImage:'https://order.yummypalace.com.sg/img/yummypalace/preview.jpg',fbTitle:'Yummy Palace',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.yummypalace.com.sg/'},/* Twitter  */tw:{twURL:'https://order.yummypalace.com.sg/#/',twTitile:'Yummy Palace',twvia:'Yummy Palace'},/* google Plus data   */gp:{gpURL:'http://order.yummypalace.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.yummypalace.com.sg/#/',waSeparator:'Yummy Palace'},site_title:'Yummy Palace',site_title_with_separator:' | Yummy Palace',home_meta_title:"Welcome to Yummy Palace",bgimage:'/img/ninjaprocmn/yummypalace/body_bg.jpg'},"order.grillninetynine.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F2D3DA83-F5DC-4C09-B571-F2DD63E590BB",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Grill Ninety Nine',stripeImage:"https://order.grillninetynine.com.sg/img/ninjaprocmn/grillninetynine/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'grillninetynine',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.grillninetynine.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.grillninetynine.com.sg/#/',fbImage:'https://order.grillninetynine.com.sg/img/grillninetynine/preview.jpg',fbTitle:'Grill Ninety Nine',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.grillninetynine.com.sg/'},/* Twitter  */tw:{twURL:'https://order.grillninetynine.com.sg/#/',twTitile:'Grill Ninety Nine',twvia:'Grill Ninety Nine'},/* google Plus data   */gp:{gpURL:'http://order.grillninetynine.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.grillninetynine.com.sg/#/',waSeparator:'Grill Ninety Nine'},site_title:'Grill Ninety Nine',site_title_with_separator:' | Grill Ninety Nine',home_meta_title:"Welcome to Grill Ninety Nine",bgimage:'/img/ninjaprocmn/grillninetynine/body_bg.jpg'},"order.vatanse.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"8F8FE4E6-88C9-4071-9215-312E0F50016A",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Vatan Se',stripeImage:"https://order.vatanse.com/img/ninjaprocmn/vatanse/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'vatanse',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.vatanse.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.vatanse.com/#/',fbImage:'https://order.vatanse.com/img/vatanse/preview.jpg',fbTitle:'Vatan Se',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.vatanse.com/'},/* Twitter  */tw:{twURL:'https://order.vatanse.com/#/',twTitile:'Vatan Se',twvia:'Vatan Se'},/* google Plus data   */gp:{gpURL:'http://order.vatanse.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.vatanse.com/#/',waSeparator:'Vatan Se'},site_title:'Vatan Se',site_title_with_separator:' | Vatan Se',home_meta_title:"Vatan Se",bgimage:'/img/ninjaprocmn/vatanse/body_bg.jpg'},"www.azmirestaurant.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"48720C8A-D6BE-42E5-9426-73A406B5CED5",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Azmi Restaurant',stripeImage:"https://www.azmirestaurant.com/img/ninjaprocmn/azmirestaurant/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'azmirestaurant',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.azmirestaurant.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.azmirestaurant.com/#/',fbImage:'https://www.azmirestaurant.com/img/azmirestaurant/preview.jpg',fbTitle:'Azmi Restaurant',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.azmirestaurant.com/'},/* Twitter  */tw:{twURL:'https://www.azmirestaurant.com/#/',twTitile:'Azmi Restaurant',twvia:'Azmi Restaurant'},/* google Plus data   */gp:{gpURL:'http://www.azmirestaurant.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.azmirestaurant.com/#/',waSeparator:'Azmi Restaurant'},site_title:'Azmi Restaurant',forcewww:'YES',site_title_with_separator:' | Azmi Restaurant',home_meta_title:"Welcome to Azmi Restaurant ",bgimage:'/img/ninjaprocmn/azmirestaurant/body_bg.jpg'},"order.sgfooddelivery.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E9798A3B-8D30-4E2F-A078-8D7E68225736",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Laifaba',stripeImage:"https://order.sgfooddelivery.com/img/ninjaprocmn/laifaba/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'laifaba',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.sgfooddelivery.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.sgfooddelivery.com/#/',fbImage:'https://order.sgfooddelivery.com/img/laifaba/preview.jpg',fbTitle:'Laifaba',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.sgfooddelivery.com/'},/* Twitter  */tw:{twURL:'https://order.sgfooddelivery.com/#/',twTitile:'Laifaba',twvia:'Laifaba'},/* google Plus data   */gp:{gpURL:'http://order.sgfooddelivery.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.sgfooddelivery.com/#/',waSeparator:'Laifaba'},site_title:'Laifaba',site_title_with_separator:' | Laifaba',home_meta_title:"Welcome to Laifaba",bgimage:'/img/ninjaprocmn/laifaba/body_bg.jpg'},"order.liulian.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"AFA91493-EA0C-4A55-8BB8-F63D4FABE065",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Savorition Recipes',stripeImage:"https://order.liulian.com.sg/img/ninjaprocmn/savorition/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'savorition',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.liulian.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.liulian.com.sg/#/',fbImage:'https://order.liulian.com.sg/img/savorition/preview.jpg',fbTitle:'Savorition Recipes',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.liulian.com.sg/'},/* Twitter  */tw:{twURL:'https://order.liulian.com.sg/#/',twTitile:'Savorition Recipes',twvia:'Savorition Recipes'},/* google Plus data   */gp:{gpURL:'http://order.liulian.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.liulian.com.sg/#/',waSeparator:'Savorition Recipes'},site_title:'Savorition Recipes',site_title_with_separator:' | Savorition Recipes',home_meta_title:"Welcome to Savorition Recipes",bgimage:'/img/ninjaprocmn/savorition/body_bg.jpg'},"www.kinkaomai.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F829A001-0900-4035-BB87-C11A6DF83425",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Kin Kao Mai',stripeImage:"https://www.kinkaomai.com/img/ninjaprocmn/kinkao/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'kinkao',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.kinkaomai.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.kinkaomai.com/#/',fbImage:'https://www.kinkaomai.com/img/kinkao/preview.jpg',fbTitle:'Kin Kao Mai',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.kinkaomai.com/'},/* Twitter  */tw:{twURL:'https://www.kinkaomai.com/#/',twTitile:'Kin Kao Mai',twvia:'Kin Kao Mai'},/* google Plus data   */gp:{gpURL:'http://www.kinkaomai.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.kinkaomai.com/#/',waSeparator:'Kin Kao Mai'},site_title:'Kin Kao Mai',forcewww:'YES',site_title_with_separator:' | Kin Kao Mai',home_meta_title:"Welcome to Kin Kao Mai",bgimage:'/img/ninjaprocmn/kinkao/body_bg.jpg'},"order.podiandporiyal.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"ACD3183F-F85F-4B14-9042-02270AA19B06",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Podi & Poriyal',stripeImage:"https://order.podiandporiyal.com/img/ninjaprocmn/podiporiyal/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'podiporiyal',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.podiandporiyal.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.podiandporiyal.com/#/',fbImage:'https://order.podiandporiyal.com/img/podiporiyal/preview.jpg',fbTitle:'Podi & Poriyal',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.podiandporiyal.com/'},/* Twitter  */tw:{twURL:'https://order.podiandporiyal.com/#/',twTitile:'Podi & Poriyal',twvia:'Podi & Poriyal'},/* google Plus data   */gp:{gpURL:'http://order.podiandporiyal.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.podiandporiyal.com/#/',waSeparator:'Podi & Poriyal'},site_title:'Podi & Poriyal',site_title_with_separator:' | Podi & Poriyal',home_meta_title:"Welcome to Podi & Poriyal",bgimage:'/img/ninjaprocmn/podiporiyal/body_bg.jpg'},"order.zagufood.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"FEEFDB18-A9DA-41B8-9391-DFD8E468CD47",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Zagu',stripeImage:"https://order.zagufood.com/img/ninjaprocmn/zagufood/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'zagufood',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.zagufood.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.zagufood.com/#/',fbImage:'https://order.zagufood.com/img/zagufood/preview.jpg',fbTitle:'Zagu',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.zagufood.com/'},/* Twitter  */tw:{twURL:'https://order.zagufood.com/#/',twTitile:'Zagu',twvia:'Zagu'},/* google Plus data   */gp:{gpURL:'http://order.zagufood.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.zagufood.com/#/',waSeparator:'Zagu'},site_title:'Zagu',site_title_with_separator:' | Zagu',home_meta_title:"Welcome to Zagu",bgimage:'/img/ninjaprocmn/zagufood/body_bg.jpg'},"order.empressporridge.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"B2C7873B-FF2B-4913-9E38-EF5D10F05DFE",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Empress Porridge',stripeImage:"https://order.empressporridge.com/img/ninjaprocmn/empress/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'empress',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.empressporridge.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.empressporridge.com/#/',fbImage:'https://order.empressporridge.com/img/empress/preview.jpg',fbTitle:'Empress Porridge',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.empressporridge.com/'},/* Twitter  */tw:{twURL:'https://order.empressporridge.com/#/',twTitile:'Empress Porridge',twvia:'Empress Porridge'},/* google Plus data   */gp:{gpURL:'http://order.empressporridge.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.empressporridge.com/#/',waSeparator:'Empress Porridge'},site_title:'Empress Porridge',site_title_with_separator:' | Empress Porridge',home_meta_title:"Welcome to Empress Porridge",bgimage:'/img/ninjaprocmn/empress/body_bg.jpg'},"order.taliwangsg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"1A3FC392-8E34-49ED-A6C8-5B4D5C46DEF8",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Taliwang Restaurant',stripeImage:"https://order.taliwangsg.com/img/ninjaprocmn/taliwang/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'taliwang',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.taliwangsg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.taliwangsg.com/#/',fbImage:'https://order.taliwangsg.com/img/taliwang/preview.jpg',fbTitle:'Taliwang Restaurant',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.taliwangsg.com/'},/* Twitter  */tw:{twURL:'https://order.taliwangsg.com/#/',twTitile:'Taliwang Restaurant',twvia:'Taliwang Restaurant'},/* google Plus data   */gp:{gpURL:'http://order.taliwangsg.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.taliwangsg.com/#/',waSeparator:'Taliwang Restaurant'},site_title:'Taliwang Restaurant',site_title_with_separator:' | Taliwang Restaurant',home_meta_title:"Welcome to Taliwang Restaurant",bgimage:'/img/ninjaprocmn/taliwang/body_bg.jpg'},"www.oceanseafoodsg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"5F6CA945-118A-4185-B1B2-C0DA1F3A9A18",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Ocean Sea Food',stripeImage:"https://www.oceanseafoodsg.com/img/ninjaprocmn/oceanseafood/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'oceanseafood',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.oceanseafoodsg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.oceanseafoodsg.com/#/',fbImage:'https://www.oceanseafoodsg.com/img/oceanseafood/preview.jpg',fbTitle:'Ocean Sea Food',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.oceanseafoodsg.com/'},/* Twitter  */tw:{twURL:'https://www.oceanseafoodsg.com/#/',twTitile:'Ocean Sea Food',twvia:'Ocean Sea Food'},/* google Plus data   */gp:{gpURL:'http://www.oceanseafoodsg.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.oceanseafoodsg.com/#/',waSeparator:'Ocean Sea Food'},site_title:'Ocean Sea Food',forcewww:'YES',site_title_with_separator:' | Ocean Sea Food',home_meta_title:"Welcome to Ocean Sea Food",bgimage:'/img/ninjaprocmn/oceanseafood/body_bg.jpg'},"order.pastaria-abate.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"93F54B1A-2A05-4136-B047-257453EF41C3",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Pastaria',stripeImage:"https://order.pastaria-abate.com/img/ninjaprocmn/pastaria/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'pastaria',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.pastaria-abate.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.pastaria-abate.com/#/',fbImage:'https://order.pastaria-abate.com/img/pastaria/preview.jpg',fbTitle:'Pastaria',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.pastaria-abate.com/'},/* Twitter  */tw:{twURL:'https://order.pastaria-abate.com/#/',twTitile:'Pastaria',twvia:'Pastaria'},/* google Plus data   */gp:{gpURL:'http://order.pastaria-abate.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.pastaria-abate.com/#/',waSeparator:'Pastaria'},site_title:'Pastaria',site_title_with_separator:' | Pastaria',home_meta_title:"Welcome to Pastaria",bgimage:'/img/ninjaprocmn/pastaria/body_bg.jpg'},"www.trungnguyencoffeesg.com-grant":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"92C82689-93D3-4777-B5C5-6E868CB0227E",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Trung Nguyen Coffee By Cafe De Saigon',stripeImage:"https://www.trungnguyencoffeesg.com/img/ninjaprocmn/trungnguyen/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'trungnguyen',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.trungnguyencoffeesg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.trungnguyencoffeesg.com/#/',fbImage:'https://www.trungnguyencoffeesg.com/img/trungnguyen/preview.jpg',fbTitle:'Trung Nguyen Coffee By Cafe De Saigon',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.trungnguyencoffeesg.com/'},/* Twitter  */tw:{twURL:'https://www.trungnguyencoffeesg.com/#/',twTitile:'Trung Nguyen Coffee By Cafe De Saigon',twvia:'Trung Nguyen Coffee By Cafe De Saigon'},/* google Plus data   */gp:{gpURL:'http://www.trungnguyencoffeesg.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.trungnguyencoffeesg.com/#/',waSeparator:'Trung Nguyen Coffee By Cafe De Saigon'},site_title:'Trung Nguyen Coffee By Cafe De Saigon',forcewww:'YES',site_title_with_separator:' | Trung Nguyen Coffee By Cafe De Saigon',home_meta_title:"Welcome to Trung Nguyen Coffee By Cafe De Saigon",bgimage:'/img/ninjaprocmn/trungnguyen/body_bg.jpg'},"order.unigallery.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"03847B53-0141-4414-99EA-18B687C8B220",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Uni Gallery',stripeImage:"https://order.unigallery.sg/img/ninjaprocmn/unigallery/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'unigallery',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.unigallery.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.unigallery.sg/#/',fbImage:'https://order.unigallery.sg/img/unigallery/preview.jpg',fbTitle:'Uni Gallery',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.unigallery.sg/'},/* Twitter  */tw:{twURL:'https://order.unigallery.sg/#/',twTitile:'Uni Gallery',twvia:'Uni Gallery'},/* google Plus data   */gp:{gpURL:'http://order.unigallery.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.unigallery.sg/#/',waSeparator:'Uni Gallery'},site_title:'Uni Gallery',site_title_with_separator:' | Uni Gallery',home_meta_title:"Welcome to Uni Gallery",bgimage:'/img/ninjaprocmn/unigallery/body_bg.jpg'},"order.theassemblyground.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"944F718E-F5D9-48A0-B047-7E2D01E62CD3",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'The Assembly Ground',stripeImage:"https://order.theassemblyground.com/img/ninjaprocmn/assembly/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'assembly',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.theassemblyground.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.theassemblyground.com/#/',fbImage:'https://order.theassemblyground.com/img/assembly/preview.jpg',fbTitle:'The Assembly Ground',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.theassemblyground.com/'},/* Twitter  */tw:{twURL:'https://order.theassemblyground.com/#/',twTitile:'The Assembly Ground',twvia:'The Assembly Ground'},/* google Plus data   */gp:{gpURL:'http://order.theassemblyground.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.theassemblyground.com/#/',waSeparator:'The Assembly Ground'},site_title:'The Assembly Ground',site_title_with_separator:' | The Assembly Ground',home_meta_title:"Welcome to The Assembly Ground",bgimage:'/img/ninjaprocmn/assembly/body_bg.jpg'},"order.lagnaa.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E4C16739-3FF3-4B0F-AD5B-91D3331A4DEC",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Lagnaa',stripeImage:"https://order.lagnaa.com/img/ninjaprocmn/lagnaa/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'lagnaa',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.lagnaa.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.lagnaa.com/#/',fbImage:'https://order.lagnaa.com/img/lagnaa/preview.jpg',fbTitle:'Lagnaa',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.lagnaa.com/'},/* Twitter  */tw:{twURL:'https://order.lagnaa.com/#/',twTitile:'Lagnaa',twvia:'Lagnaa'},/* google Plus data   */gp:{gpURL:'http://order.lagnaa.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.lagnaa.com/#/',waSeparator:'Lagnaa'},site_title:'Laganaa',site_title_with_separator:' | Lagnaa',home_meta_title:"Welcome to Lagnaa",bgimage:'/img/ninjaprocmn/lagnaa/body_bg.jpg'},"order.elemen.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"1631B8E5-75D7-428F-A20F-028E04A86F8C",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Elemen',stripeImage:"https://order.elemen.com.sg/img/ninjaprocmn/elemen/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'elemen',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.elemen.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.elemen.com.sg/#/',fbImage:'https://order.elemen.com.sg/img/elemen/preview.jpg',fbTitle:'Elemen',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.elemen.com.sg/'},/* Twitter  */tw:{twURL:'https://order.elemen.com.sg/#/',twTitile:'Elemen',twvia:'Elemen'},/* google Plus data   */gp:{gpURL:'http://order.elemen.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.elemen.com.sg/#/',waSeparator:'Elemen'},site_title:'Elemen',site_title_with_separator:' | Elemen',home_meta_title:"Welcome to Elemen",bgimage:'/img/ninjaprocmn/elemen/body_bg.jpg'},"order.tsuta.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"13EDCB94-B360-4046-8BDC-423FED10A0BB",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Tsuta',stripeImage:"https://order.tsuta.com/img/ninjaprocmn/tsuta/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'tsuta',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.tsuta.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.tsuta.com/#/',fbImage:'https://order.tsuta.com/img/tsuta/preview.jpg',fbTitle:'Tsuta',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.tsuta.com/'},/* Twitter  */tw:{twURL:'https://order.tsuta.com/#/',twTitile:'Tsuta',twvia:'Tsuta'},/* google Plus data   */gp:{gpURL:'http://order.tsuta.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.tsuta.com/#/',waSeparator:'Tsuta'},site_title:'Elemen',site_title_with_separator:' | Tsuta',home_meta_title:"Welcome to Tsuta",bgimage:'/img/ninjaprocmn/tsuta/body_bg.jpg'},"www.ohanaxadams.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"47E73E3D-119A-44D1-9962-8EC7E13C9F4B",fbAppId:"306833739927522",logo:"/img/ninjaprocmn/logo.png",chatWidget:"",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Ohana by Adam’s corner',stripeImage:"https://www.ohanaxadams.com/img/ninjaprocmn/ohana/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ohana',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.ohanaxadams.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.ohanaxadams.com/#/',fbImage:'https://www.ohanaxadams.com/img/ohana/preview.jpg',fbTitle:'Ohana by Adam’s corner',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.ohanaxadams.com/'},/* Twitter  */tw:{twURL:'https://www.ohanaxadams.com/#/',twTitile:'Ohana by Adam’s corner',twvia:'Ohana by Adam’s corner'},/* google Plus data   */gp:{gpURL:'http://www.ohanaxadams.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.ohanaxadams.com/#/',waSeparator:'Ohana by Adam’s corner'},site_title:'Ohana by Adam’s corner',forcewww:'YES',site_title_with_separator:' | Ohana by Adam’s corner',home_meta_title:"Welcome to Ohana by Adam’s corner",bgimage:'/img/ninjaprocmn/ohana/body_bg.jpg'},"orderonline.springcourt.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"82D314C2-3A88-47C1-827E-454D5A5CCF53",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"JTdCJTIyd2hhdHNhcHAlMjI6JTIyMDY1OTQ2MTU4MjglMjIlN0Q=",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Spring Court',stripeImage:"https://orderonline.springcourt.com.sg/img/ninjaprocmn/springcourt/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'springcourt',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://orderonline.springcourt.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://orderonline.springcourt.com.sg/#/',fbImage:'https://orderonline.springcourt.com.sg/img/springcourt/logo.png',fbTitle:'Spring Court',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://orderonline.springcourt.com.sg/'},/* Twitter  */tw:{twURL:'https://orderonline.springcourt.com.sg/#/',twTitile:'Spring Court',twvia:'Spring Court'},/* google Plus data   */gp:{gpURL:'http://orderonline.springcourt.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://orderonline.springcourt.com.sg/#/',waSeparator:'Spring Court'},site_title:'Spring Court',site_title_with_separator:' | Spring Court',home_meta_title:"Welcome to Spring Court",bgimage:'/img/ninjaprocmn/springcourt/body_bg.jpg'},"order.theawadh.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"79AB2892-FC11-4FDA-935B-4A37701C4953",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'The Awadh',stripeImage:"https://order.theawadh.com/img/ninjaprocmn/theawadh/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'theawadh',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.theawadh.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.theawadh.com/#/',fbImage:'https://order.theawadh.com/img/theawadh/logo.png',fbTitle:'The Awadh',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.theawadh.com/'},/* Twitter  */tw:{twURL:'https://order.theawadh.com/#/',twTitile:'The Awadh',twvia:'The Awadh'},/* google Plus data   */gp:{gpURL:'http://order.theawadh.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.theawadh.com/#/',waSeparator:'The Awadh'},site_title:'The Awadh',site_title_with_separator:' | The Awadh',home_meta_title:"Welcome to The Awadh",bgimage:'/img/ninjaprocmn/theawadh/body_bg.jpg'},"order.al-azhar.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"1E8C044F-E42B-4BDA-8B8B-62AC4E76FF70",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Al-Azhar Restaurant',stripeImage:"https://order.al-azhar.com/img/ninjaprocmn/alazhar/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'alazhar',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.al-azhar.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.al-azhar.com/#/',fbImage:'https://order.al-azhar.com/img/alazhar/logo.png',fbTitle:'Al-Azhar Restaurant',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.al-azhar.com/'},/* Twitter  */tw:{twURL:'https://order.al-azhar.com/#/',twTitile:'Al-Azhar Restaurant',twvia:'Al-Azhar Restaurant'},/* google Plus data   */gp:{gpURL:'http://order.al-azhar.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.al-azhar.com/#/',waSeparator:'Al-Azhar Restaurant'},site_title:'Al-Azhar Restaurant',site_title_with_separator:' | Al-Azhar Restaurant',home_meta_title:"Welcome to Al-Azhar Restaurant",bgimage:'/img/ninjaprocmn/alazhar/body_bg.jpg'},"order.justlazzat.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"CE8155DC-6B8A-4ACC-A853-AEAED6EC3789",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Justlazzat',stripeImage:"https://order.justlazzat.sg/img/ninjaprocmn/justlazzat/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'justlazzat',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.justlazzat.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.justlazzat.sg/#/',fbImage:'https://order.justlazzat.sg/img/justlazzat/logo.png',fbTitle:'Justlazzat',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.justlazzat.sg/'},/* Twitter  */tw:{twURL:'https://order.justlazzat.sg/#/',twTitile:'Justlazzat',twvia:'Justlazzat'},/* google Plus data   */gp:{gpURL:'http://order.justlazzat.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.justlazzat.sg/#/',waSeparator:'Justlazzat'},site_title:'Justlazzat',site_title_with_separator:' | Justlazzat',home_meta_title:"Welcome to Justlazzat",bgimage:'/img/ninjaprocmn/justlazzat/body_bg.jpg'},"www.boulangerieaccueil.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"3ACD7D3E-70B2-429E-9334-747F26EAAAC8",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Boulangerie Accueil',stripeImage:"https://www.boulangerieaccueil.com/img/ninjaprocmn/boulangerieaccueil/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'boulangerieaccueil',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.boulangerieaccueil.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.boulangerieaccueil.com/#/',fbImage:'https://www.boulangerieaccueil.com/img/boulangerieaccueil/logo.png',fbTitle:'Boulangerie Accueil',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.boulangerieaccueil.com/'},/* Twitter  */tw:{twURL:'https://www.boulangerieaccueil.com/#/',twTitile:'Boulangerie Accueil',twvia:'Boulangerie Accueil'},/* google Plus data   */gp:{gpURL:'http://www.boulangerieaccueil.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.boulangerieaccueil.com/#/',waSeparator:'Boulangerie Accueil'},site_title:'Boulangerie Accueil',forcewww:'YES',site_title_with_separator:' | Boulangerie Accueil',home_meta_title:"Welcome to Boulangerie Accueil",bgimage:'/img/ninjaprocmn/boulangerieaccueil/body_bg.jpg'},"order.arroz.today":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"7E6A4907-F4D3-48DB-BB99-4F111503BA41",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Arroz',stripeImage:"https://order.arroz.today/img/ninjaprocmn/arroz/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'arroz',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.arroz.today/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.arroz.today/#/',fbImage:'https://order.arroz.today/img/arroz/logo.png',fbTitle:'Arroz',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.arroz.today/'},/* Twitter  */tw:{twURL:'https://order.arroz.today/#/',twTitile:'Arroz',twvia:'Arroz'},/* google Plus data   */gp:{gpURL:'http://order.arroz.today/#/'},/* Whatsapp data   */wa:{waURL:'http://order.arroz.today/#/',waSeparator:'Arroz'},site_title:'Arroz',site_title_with_separator:' | Arroz',home_meta_title:"Welcome to Arroz",bgimage:'/img/ninjaprocmn/arroz/body_bg.jpg'},"order.thesocialoutcast.com-canceled":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"501908B9-A9D0-4BEF-A131-5D1FBBFDE2BE-cancled",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Social Outcast',stripeImage:"https://order.thesocialoutcast.com/img/ninjaprocmn/thesocialoutcast/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'thesocialoutcast',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.thesocialoutcast.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.thesocialoutcast.com/#/',fbImage:'https://order.thesocialoutcast.com/img/thesocialoutcast/logo.png',fbTitle:'Social Outcast',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.thesocialoutcast.com/'},/* Twitter  */tw:{twURL:'https://order.thesocialoutcast.com/#/',twTitile:'Social Outcast',twvia:'Social Outcast'},/* google Plus data   */gp:{gpURL:'http://order.thesocialoutcast.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.thesocialoutcast.com/#/',waSeparator:'Social Outcast'},site_title:'Social Outcast',site_title_with_separator:' | Social Outcast',home_meta_title:"Welcome to Social Outcast",bgimage:'/img/ninjaprocmn/thesocialoutcast/body_bg.jpg'},"order.amclub.org.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"B401FC82-8E39-4076-838A-55192F765004",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'The American Club',stripeImage:"https://order.amclub.org.sg/img/ninjaprocmn/americanclub/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'americanclub',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.amclub.org.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.amclub.org.sg/#/',fbImage:'https://order.amclub.org.sg/img/americanclub/logo.png',fbTitle:'The American Club',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.amclub.org.sg/'},/* Twitter  */tw:{twURL:'https://order.amclub.org.sg/#/',twTitile:'The American Club',twvia:'The American Club'},/* google Plus data   */gp:{gpURL:'http://order.amclub.org.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.amclub.org.sg/#/',waSeparator:'The American Club'},site_title:'The American Club',site_title_with_separator:' | The American Club',home_meta_title:"Welcome to The American Club",bgimage:'/img/ninjaprocmn/americanclub/body_bg.jpg'},"order.saltedplum.co":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D568F3C0-8C03-498E-AAC1-83B3AB8E1977",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'The Salted Plum',stripeImage:"https://order.saltedplum.co/img/ninjaprocmn/saltedplum/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'saltedplum',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.saltedplum.co/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.saltedplum.co/#/',fbImage:'https://order.saltedplum.co/img/saltedplum/logo.png',fbTitle:'The Salted Plum',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.saltedplum.co/'},/* Twitter  */tw:{twURL:'https://order.saltedplum.co/#/',twTitile:'The Salted Plum',twvia:'The Salted Plum'},/* google Plus data   */gp:{gpURL:'http://order.saltedplum.co/#/'},/* Whatsapp data   */wa:{waURL:'http://order.saltedplum.co/#/',waSeparator:'The Salted Plum'},site_title:'The Salted Plum',site_title_with_separator:' | The Salted Plum',home_meta_title:"Welcome to The Salted Plum",bgimage:'/img/ninjaprocmn/saltedplum/body_bg.jpg'},"www.tigafolks.co":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"136ADFCE-B7EA-4D30-B393-9A6317C5EBF8",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'TIGAfolks & Co',stripeImage:"https://www.tigafolks.co/img/ninjaprocmn/tigafolks/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'tigafolks',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.tigafolks.co/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.tigafolks.co/#/',fbImage:'https://www.tigafolks.co/img/tigafolks/logo.png',fbTitle:'TIGAfolks & Co',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.tigafolks.co/'},/* Twitter  */tw:{twURL:'https://www.tigafolks.co/#/',twTitile:'TIGAfolks & Co',twvia:'TIGAfolks & Co'},/* google Plus data   */gp:{gpURL:'http://www.tigafolks.co/#/'},/* Whatsapp data   */wa:{waURL:'http://www.tigafolks.co/#/',waSeparator:'TIGAfolks & Co'},site_title:'TIGAfolks & Co',forcewww:'YES',site_title_with_separator:' | TIGAfolks & Co',home_meta_title:"Welcome to TIGAfolks & Co",bgimage:'/img/ninjaprocmn/tigafolks/body_bg.jpg'},"order.qi-philosophy.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E857D7D1-B2CA-468E-A8C2-609106835941",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Qi Philosophy Cafe',stripeImage:"https://order.qi-philosophy.com/img/ninjaprocmn/qiphilosophy/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'qiphilosophy',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.qi-philosophy.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.qi-philosophy.com/#/',fbImage:'https://order.qi-philosophy.com/img/qiphilosophy/logo.png',fbTitle:'Qi Philosophy Cafe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.qi-philosophy.com/'},/* Twitter  */tw:{twURL:'https://order.qi-philosophy.com/#/',twTitile:'Qi Philosophy Cafe',twvia:'Qi Philosophy Cafe'},/* google Plus data   */gp:{gpURL:'http://order.qi-philosophy.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.qi-philosophy.com/#/',waSeparator:'Qi Philosophy Cafe'},site_title:'Qi Philosophy Cafe',site_title_with_separator:' | Qi Philosophy Cafe',home_meta_title:"Welcome to Qi Philosophy Cafe",bgimage:'/img/ninjaprocmn/qiphilosophy/body_bg.jpg'},"order.kkokkonara.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"3429C9CF-F91D-4C5F-A963-363E51847726",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'KKO KKO NA RA',stripeImage:"https://order.kkokkonara.com/img/ninjaprocmn/kkokkonara/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'kkokkonara',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.kkokkonara.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.kkokkonara.com/#/',fbImage:'https://order.kkokkonara.com/img/kkokkonara/logo.png',fbTitle:'KKO KKO NA RA',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.kkokkonara.com/'},/* Twitter  */tw:{twURL:'https://order.kkokkonara.com/#/',twTitile:'KKO KKO NA RA',twvia:'KKO KKO NA RA'},/* google Plus data   */gp:{gpURL:'http://order.kkokkonara.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.kkokkonara.com/#/',waSeparator:'KKO KKO NA RA'},site_title:'KKO KKO NA RA',site_title_with_separator:' | KKO KKO NA RA',home_meta_title:"Welcome to KKO KKO NA RA",bgimage:'/img/ninjaprocmn/kkokkonara/body_bg.jpg'},"www.madrasnewwoodlands.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"0D63D63E-4A28-483C-B455-A8A90FF9B68F",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Madras New Woodlands',stripeImage:"https://www.madrasnewwoodlands.com/img/ninjaprocmn/madrasnew/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'madrasnew',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.madrasnewwoodlands.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.madrasnewwoodlands.com/#/',fbImage:'https://www.madrasnewwoodlands.com/img/madrasnew/logo.png',fbTitle:'Madras New Woodlands',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.madrasnewwoodlands.com/'},/* Twitter  */tw:{twURL:'https://www.madrasnewwoodlands.com/#/',twTitile:'Madras New Woodlands',twvia:'Madras New Woodlands'},/* google Plus data   */gp:{gpURL:'http://www.madrasnewwoodlands.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.madrasnewwoodlands.com/#/',waSeparator:'Madras New Woodlands'},site_title:'Madras New Woodlands',forcewww:'YES',site_title_with_separator:' | Madras New Woodlands',home_meta_title:"Welcome to Madras New Woodlands",bgimage:'/img/ninjaprocmn/madrasnew/body_bg.jpg'},"pro.baoshimart.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"37D59EAD-2E8F-4F8F-A07E-51E5B9EE818F",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Bao Shi',stripeImage:"https://pro.baoshimart.com/img/ninjaprocmn/baoshi/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'baoshi',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://pro.baoshimart.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://pro.baoshimart.com/#/',fbImage:'https://pro.baoshimart.com/img/baoshi/logo.png',fbTitle:'Bao Shi',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://pro.baoshimart.com/'},/* Twitter  */tw:{twURL:'https://pro.baoshimart.com/#/',twTitile:'Bao Shi',twvia:'Bao Shi'},/* google Plus data   */gp:{gpURL:'http://pro.baoshimart.com/#/'},/* Whatsapp data   */wa:{waURL:'http://pro.baoshimart.com/#/',waSeparator:'Bao Shi'},site_title:'Bao Shi',forcewww:'YES',site_title_with_separator:' | Bao Shi',home_meta_title:"Welcome to Bao Shi",bgimage:'/img/ninjaprocmn/baoshi/body_bg.jpg'},"www.qsataycorner.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"2C1939DC-F138-4186-A619-00E196AAFC75",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Qsatay Corner',stripeImage:"https://www.qsataycorner.com/img/ninjaprocmn/qataycorner/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'qataycorner',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.qsataycorner.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.qsataycorner.com/#/',fbImage:'https://www.qsataycorner.com/img/qataycorner/logo.png',fbTitle:'Qsatay Corner',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.qsataycorner.com/'},/* Twitter  */tw:{twURL:'https://www.qsataycorner.com/#/',twTitile:'Qsatay Corner',twvia:'Qsatay Corner'},/* google Plus data   */gp:{gpURL:'http://www.qsataycorner.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.qsataycorner.com/#/',waSeparator:'Qsatay Corner'},site_title:'Qsatay Corner',forcewww:'YES',site_title_with_separator:' | Qsatay Corner',home_meta_title:"Welcome to Qsatay Corner",bgimage:'/img/ninjaprocmn/qataycorner/body_bg.jpg'},"order.district10.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"9F890676-9B83-4B65-B10B-8286259CF0C0",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'District 10 Bar & Restaurant',stripeImage:"https://order.district10.com.sg/img/ninjaprocmn/district10/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'district10',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.district10.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.district10.com.sg/#/',fbImage:'https://order.district10.com.sg/img/district10/logo.png',fbTitle:'District 10 Bar & Restaurant',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.district10.com.sg/'},/* Twitter  */tw:{twURL:'https://order.district10.com.sg/#/',twTitile:'District 10 Bar & Restaurant',twvia:'District 10 Bar & Restaurant'},/* google Plus data   */gp:{gpURL:'http://order.district10.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.district10.com.sg/#/',waSeparator:'District 10 Bar & Restaurant'},site_title:'District 10 Bar & Restaurant',site_title_with_separator:' | District 10 Bar & Restaurant',home_meta_title:"Welcome to District 10 Bar & Restaurant",bgimage:'/img/ninjaprocmn/district10/body_bg.jpg'},"order.anjanakitchen.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"AF234469-80CF-42F9-BD87-B69BD7AC515D",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Anjana Kitchen',stripeImage:"https://order.anjanakitchen.com/img/ninjaprocmn/anjanakitchen/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'anjanakitchen',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.anjanakitchen.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.anjanakitchen.com/#/',fbImage:'https://order.anjanakitchen.com/img/anjanakitchen/logo.png',fbTitle:'Anjana Kitchen',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.anjanakitchen.com/'},/* Twitter  */tw:{twURL:'https://order.anjanakitchen.com/#/',twTitile:'Anjana Kitchen',twvia:'Anjana Kitchen'},/* google Plus data   */gp:{gpURL:'http://order.anjanakitchen.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.anjanakitchen.com/#/',waSeparator:'Anjana Kitchen'},site_title:'Anjana Kitchen',site_title_with_separator:' | Anjana Kitchen',home_meta_title:"Welcome to Anjana Kitchen",bgimage:'/img/ninjaprocmn/anjanakitchen/body_bg.jpg'},"www.goburgersg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"2B8A54EB-1524-4F34-BBAB-0F61C2B4F2E9",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Goburger',stripeImage:"https://www.goburgersg.com/img/ninjaprocmn/goburger/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'goburger',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.goburgersg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.goburgersg.com/#/',fbImage:'https://www.goburgersg.com/img/goburger/logo.png',fbTitle:'Goburger',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.goburgersg.com/'},/* Twitter  */tw:{twURL:'https://www.goburgersg.com/#/',twTitile:'Goburger',twvia:'Goburger'},/* google Plus data   */gp:{gpURL:'http://www.goburgersg.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.goburgersg.com/#/',waSeparator:'Goburger'},site_title:'Goburger',forcewww:'YES',site_title_with_separator:' | Goburger',home_meta_title:"Welcome to Goburger",bgimage:'/img/ninjaprocmn/goburger/body_bg.jpg'},"www.primegrillsg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D3519D6C-7D05-4947-B54E-E6441BD1E1D8",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Prime Grill',stripeImage:"https://www.primegrillsg.com/img/ninjaprocmn/primegrill/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'primegrill',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.primegrillsg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.primegrillsg.com/#/',fbImage:'https://www.primegrillsg.com/img/primegrill/logo.png',fbTitle:'Prime Grill',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.primegrillsg.com/'},/* Twitter  */tw:{twURL:'https://www.primegrillsg.com/#/',twTitile:'Prime Grill',twvia:'Prime Grill'},/* google Plus data   */gp:{gpURL:'http://www.primegrillsg.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.primegrillsg.com/#/',waSeparator:'Prime Grill'},site_title:'Prime Grill',forcewww:'YES',site_title_with_separator:' | Prime Grill',home_meta_title:"Welcome to Prime Grill",bgimage:'/img/ninjaprocmn/primegrill/body_bg.jpg'},"order.gorojapcuisine.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"B25AFE67-84CB-4E0A-AAB1-787EFF72469A",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Goro Japanese Cuisine',stripeImage:"https://order.gorojapcuisine.com/img/ninjaprocmn/gorocuisine/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'gorocuisine',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.gorojapcuisine.com//#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.gorojapcuisine.com/#/',fbImage:'https://order.gorojapcuisine.com/img/gorocuisine/logo.png',fbTitle:'Goro Japanese Cuisine',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.gorojapcuisine.com/'},/* Twitter  */tw:{twURL:'https://order.gorojapcuisine.com/#/',twTitile:'Goro Japanese Cuisine',twvia:'Goro Japanese Cuisine'},/* google Plus data   */gp:{gpURL:'http://order.gorojapcuisine.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.gorojapcuisine.com/#/',waSeparator:'Goro Japanese Cuisine'},site_title:'Goro Japanese Cuisine',site_title_with_separator:' | Goro Japanese Cuisine',home_meta_title:"Welcome to Goro Japanese Cuisine",bgimage:'/img/ninjaprocmn/gorocuisine/body_bg.jpg'},"www.ps1965.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F7F546C4-E115-43ED-8280-654D8A72AFEF",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Pump Station 1965',stripeImage:"https://www.ps1965.com.sg/img/ninjaprocmn/pumpstation/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'pumpstation',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.ps1965.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.ps1965.com.sg/#/',fbImage:'https://www.ps1965.com.sg/img/pumpstation/logo.png',fbTitle:'Pump Station 1965',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.ps1965.com.sg/'},/* Twitter  */tw:{twURL:'https://www.ps1965.com.sg/#/',twTitile:'Pump Station 1965',twvia:'Pump Station 1965'},/* google Plus data   */gp:{gpURL:'http://www.ps1965.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://www.ps1965.com.sg/#/',waSeparator:'Pump Station 1965'},site_title:'Pump Station 1965',forcewww:'YES',site_title_with_separator:' | Pump Station 1965',home_meta_title:"Welcome to Pump Station 1965",bgimage:'/img/ninjaprocmn/pumpstation/body_bg.jpg'},"order.cafemelba.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"A93FA41B-2E53-4FA6-9752-F5D29D2F85C4",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Cafe Melba',stripeImage:"https://order.cafemelba.com.sg/img/ninjaprocmn/cafemelba/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'cafemelba',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.cafemelba.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.cafemelba.com.sg/#/',fbImage:'https://order.cafemelba.com.sg/img/cafemelba/logo.png',fbTitle:'Cafe Melba',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.cafemelba.com.sg/'},/* Twitter  */tw:{twURL:'https://order.cafemelba.com.sg/#/',twTitile:'Cafe Melba',twvia:'Cafe Melba'},/* google Plus data   */gp:{gpURL:'http://order.cafemelba.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.cafemelba.com.sg/#/',waSeparator:'Cafe Melba'},site_title:'Cafe Melba',site_title_with_separator:' | Cafe Melba',home_meta_title:"Welcome to Cafe Melba",bgimage:'/img/ninjaprocmn/cafemelba/body_bg.jpg'},"order.thenomads.vip":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D84D8AC3-0B45-456D-865C-5D465CB904F2",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'The Nomads',stripeImage:"https://order.thenomads.vip/img/ninjaprocmn/nomads/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'nomads',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.thenomads.vip/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.thenomads.vip/#/',fbImage:'https://order.thenomads.vip/img/nomads/logo.png',fbTitle:'The Nomads',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.thenomads.vip/'},/* Twitter  */tw:{twURL:'https://order.thenomads.vip/#/',twTitile:'The Nomads',twvia:'The Nomads'},/* google Plus data   */gp:{gpURL:'http://order.thenomads.vip/#/'},/* Whatsapp data   */wa:{waURL:'http://order.thenomads.vip/#/',waSeparator:'The Nomads'},site_title:'The Nomads',site_title_with_separator:' | The Nomads',home_meta_title:"Welcome to The Nomads",bgimage:'/img/ninjaprocmn/nomads/body_bg.jpg'},"order.thesocialalley.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"44275190-B355-4486-8083-EE1C63607916",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'SOCIAL ALLEY',stripeImage:"https://order.thesocialalley.com/img/ninjaprocmn/socialalley/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'socialalley',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.thesocialalley.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.thesocialalley.com/#/',fbImage:'https://order.thesocialalley.com/img/socialalley/logo.png',fbTitle:'SOCIAL ALLEY',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.thesocialalley.com/'},/* Twitter  */tw:{twURL:'https://order.thesocialalley.com/#/',twTitile:'SOCIAL ALLEY',twvia:'SOCIAL ALLEY'},/* google Plus data   */gp:{gpURL:'http://order.thesocialalley.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.thesocialalley.com/#/',waSeparator:'SOCIAL ALLEY'},site_title:'SOCIAL ALLEY',site_title_with_separator:' | SOCIAL ALLEY',home_meta_title:"Welcome to SOCIAL ALLEY",bgimage:'/img/ninjaprocmn/socialalley/body_bg.jpg'},"order.mavi.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"FEC5D252-440B-40CF-B23B-A69907BB3496",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Mavi',stripeImage:"https://order.mavi.sg/img/ninjaprocmn/istanablue/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'istanablue',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.mavi.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.mavi.sg/#/',fbImage:'https://order.mavi.sg/img/istanablue/logo.png',fbTitle:'Mavi',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.mavi.sg/'},/* Twitter  */tw:{twURL:'https://order.mavi.sg/#/',twTitile:'Mavi',twvia:'Mavi'},/* google Plus data   */gp:{gpURL:'http://order.mavi.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.mavi.sg/#/',waSeparator:'Mavi'},site_title:'Mavi',site_title_with_separator:' | Mavi',home_meta_title:"Welcome to Mavi",bgimage:'/img/ninjaprocmn/istanablue/body_bg.jpg'},"order.theexchange.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D9200105-CE08-4371-A669-7B4915849CEA",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'The Exchange Asia Square',stripeImage:"https://order.theexchange.com.sg/img/ninjaprocmn/theexchange/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'theexchange',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.theexchange.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.theexchange.com.sg/#/',fbImage:'https://order.theexchange.com.sg/img/theexchange/logo.png',fbTitle:'The Exchange Asia Square',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.theexchange.com.sg/'},/* Twitter  */tw:{twURL:'https://order.theexchange.com.sg/#/',twTitile:'The Exchange Asia Square',twvia:'The Exchange Asia Square'},/* google Plus data   */gp:{gpURL:'https://order.theexchange.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.theexchange.com.sg/#/',waSeparator:'The Exchange Asia Square'},site_title:'The Exchange Asia Square',site_title_with_separator:' | The Exchange Asia Square',home_meta_title:"Welcome to The Exchange Asia Square",bgimage:'/img/ninjaprocmn/theexchange/body_bg.jpg'},"order.toribiru.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D75A75B6-EC64-451F-B522-5328DDD8F636",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Toribiru',stripeImage:"https://www.toribiru.sg/img/ninjaprocmn/toribiru/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'toribiru',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.toribiru.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.toribiru.sg/#/',fbImage:'https://www.toribiru.sg/img/toribiru/logo.png',fbTitle:'Toribiru',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.toribiru.sg/'},/* Twitter  */tw:{twURL:'https://www.toribiru.sg/#/',twTitile:'Toribiru',twvia:'Toribiru'},/* google Plus data   */gp:{gpURL:'https://www.toribiru.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://www.toribiru.sg/#/',waSeparator:'Toribiru'},site_title:'Toribiru',site_title_with_separator:' | Toribiru',home_meta_title:"Welcome to Toribiru",bgimage:'/img/ninjaprocmn/toribiru/body_bg.jpg'},"order.ourboss.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"5E9E2C14-F364-4575-B8FB-AE99DBB4D95B",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'OurBoss.sg',stripeImage:"https://order.ourboss.sg/img/ninjaprocmn/ourboss/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ourboss',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.ourboss.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.ourboss.sg/#/',fbImage:'https://order.ourboss.sg/img/ourboss/logo.png',fbTitle:'OurBoss.sg',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.ourboss.sg/'},/* Twitter  */tw:{twURL:'https://order.ourboss.sg/#/',twTitile:'OurBoss.sg',twvia:'OurBoss.sg'},/* google Plus data   */gp:{gpURL:'https://order.ourboss.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.ourboss.sg/#/',waSeparator:'OurBoss.sg'},site_title:'OurBoss.sg',forcewww:'YES',site_title_with_separator:' | OurBoss.sg',home_meta_title:"Welcome to OurBoss.sg",bgimage:'/img/ninjaprocmn/ourboss/body_bg.jpg'},"www.rempahratusbya2catering.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"729A09D6-2A38-4E1C-ADB1-67A9242D2158",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Rempah Ratus by A2 Catering',stripeImage:"https://www.rempahratusbya2catering.com/img/ninjaprocmn/a2catering/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'a2catering',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.rempahratusbya2catering.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.rempahratusbya2catering.com/#/',fbImage:'https://www.rempahratusbya2catering.com/img/a2catering/logo.png',fbTitle:'Rempah Ratus by A2 Catering',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.rempahratusbya2catering.com/'},/* Twitter  */tw:{twURL:'https://www.rempahratusbya2catering.com/#/',twTitile:'Rempah Ratus by A2 Catering',twvia:'Rempah Ratus by A2 Catering'},/* google Plus data   */gp:{gpURL:'https://www.rempahratusbya2catering.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.rempahratusbya2catering.com/#/',waSeparator:'Rempah Ratus by A2 Catering'},site_title:'Rempah Ratus by A2 Catering',forcewww:'YES',site_title_with_separator:' | Rempah Ratus by A2 Catering',home_meta_title:"Welcome to Rempah Ratus by A2 Catering",bgimage:'/img/ninjaprocmn/a2catering/body_bg.jpg'},"order.zenbu.co.id":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"60A81B14-07D2-4E09-8255-60746D0C242A",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Zenbu',stripeImage:"https://order.zenbu.co.id/img/ninjaprocmn/zenbu/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'zenbu',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.zenbu.co.id/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.zenbu.co.id/#/',fbImage:'https://order.zenbu.co.id/img/zenbu/logo.png',fbTitle:'Zenbu',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.zenbu.co.id/'},/* Twitter  */tw:{twURL:'https://order.zenbu.co.id/#/',twTitile:'Zenbu',twvia:'Zenbu'},/* google Plus data   */gp:{gpURL:'https://order.zenbu.co.id/#/'},/* Whatsapp data   */wa:{waURL:'https://order.zenbu.co.id/#/',waSeparator:'Zenbu'},site_title:'Zenbu',site_title_with_separator:' | Zenbu',home_meta_title:"Welcome to Zenbu",bgimage:'/img/ninjaprocmn/zenbu/body_bg.jpg'},"www.finestsongkeefishballnoodles.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"6800B976-C082-44F2-8D5E-299988E5FCB0",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Finest Songkees',stripeImage:"https://www.finestsongkeefishballnoodles.com.sg/img/ninjaprocmn/finestsongkees/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'finestsongkees',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.finestsongkeefishballnoodles.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.finestsongkeefishballnoodles.com.sg/#/',fbImage:'https://www.finestsongkeefishballnoodles.com.sg/img/finestsongkees/logo.png',fbTitle:'Finest Songkees',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.finestsongkeefishballnoodles.com.sg/'},/* Twitter  */tw:{twURL:'https://www.finestsongkeefishballnoodles.com.sg/#/',twTitile:'Finest Songkees',twvia:'Finest Songkees'},/* google Plus data   */gp:{gpURL:'https://www.finestsongkeefishballnoodles.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://www.finestsongkeefishballnoodles.com.sg/#/',waSeparator:'Finest Songkees'},site_title:'Finest Songkees',forcewww:'YES',site_title_with_separator:' | Finest Songkees',home_meta_title:"Welcome to Finest Songkees",bgimage:'/img/ninjaprocmn/finestsongkees/body_bg.jpg'},"www.almahboobrojak.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"90CD20F4-DB68-4C35-91C0-438B454FD583",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Al Mahboob Rojak',stripeImage:"https://www.almahboobrojak.com/img/ninjaprocmn/almaboobrojak/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'almaboobrojak',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.almaboobrojak.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.almahboobrojak.com/#/',fbImage:'https://www.almahboobrojak.com/img/almaboobrojak/logo.png',fbTitle:'Al Mahboob Rojak',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.almahboobrojak.com/'},/* Twitter  */tw:{twURL:'https://www.almahboobrojak.com/#/',twTitile:'Al Mahboob Rojak',twvia:'Al Mahboob Rojak'},/* google Plus data   */gp:{gpURL:'https://www.almahboobrojak.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.almahboobrojak.com/#/',waSeparator:'Al Mahboob Rojak'},site_title:'Al Mahboob Rojak',forcewww:'YES',site_title_with_separator:' | Al Mahboob Rojak',home_meta_title:"Welcome to Al Mahboob Rojak",bgimage:'/img/ninjaprocmn/almaboobrojak/body_bg.jpg'},"order.nelsonbar.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"0458B75A-5B08-46BB-8DAE-DEE7508C758E",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Nelson Bar',stripeImage:"https://order.nelsonbar.com/img/ninjaprocmn/nelson/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'nelson',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.nelsonbar.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.nelsonbar.com/#/',fbImage:'https://order.nelsonbar.com/img/nelson/logo.png',fbTitle:'Nelson Bar',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.nelsonbar.com/'},/* Twitter  */tw:{twURL:'https://order.nelsonbar.com/#/',twTitile:'Nelson Bar',twvia:'Nelson Bar'},/* google Plus data   */gp:{gpURL:'https://order.nelsonbar.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.nelsonbar.com/#/',waSeparator:'Nelson Bar'},site_title:'Nelson Bar',forcewww:'YES',site_title_with_separator:' | Nelson Bar',home_meta_title:"Welcome to Nelson Bar",bgimage:'/img/ninjaprocmn/nelson/body_bg.jpg'},"order.tulasi.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"32E5004A-B304-47CC-9150-F543DF91D895",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Tulasi',stripeImage:"https://order.tulasi.sg/img/ninjaprocmn/tulasi/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'tulasi',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.tulasi.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.tulasi.sg/#/',fbImage:'https://order.tulasi.sg/img/tulasi/logo.png',fbTitle:'Tulasi',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.tulasi.sg/'},/* Twitter  */tw:{twURL:'https://order.tulasi.sg/#/',twTitile:'Tulasi',twvia:'Tulasi'},/* google Plus data   */gp:{gpURL:'https://order.tulasi.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.tulasi.sg/#/',waSeparator:'Tulasi'},site_title:'Tulasi',site_title_with_separator:' | Tulasi',home_meta_title:"Welcome to Tulasi",bgimage:'/img/ninjaprocmn/tulasi/body_bg.jpg'},"www.aroydeesedap.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"77773849-99C0-45A7-B1AD-38DA2BCA127D",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Aroydee Sedap',stripeImage:"https://www.aroydeesedap.com/img/ninjaprocmn/aroydee/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'aroydee',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.aroydeesedap.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.aroydeesedap.com/#/',fbImage:'https://www.aroydeesedap.com/img/aroydee/logo.png',fbTitle:'Aroydee Sedap',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.aroydeesedap.com/'},/* Twitter  */tw:{twURL:'https://www.aroydeesedap.com/#/',twTitile:'Aroydee Sedap',twvia:'Aroydee Sedap'},/* google Plus data   */gp:{gpURL:'https://www.aroydeesedap.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.aroydeesedap.com/#/',waSeparator:'Aroydee Sedap'},site_title:'Aroydee Sedap',forcewww:'YES',site_title_with_separator:' | Aroydee Sedap',home_meta_title:"Welcome to Aroydee Sedap",bgimage:'/img/ninjaprocmn/aroydee/body_bg.jpg'},"delivery.zafferano.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"95AD803A-748B-4C1D-AE86-D7BD28B0A574",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Zafferano',stripeImage:"https://delivery.zafferano.sg/img/ninjaprocmn/zafferano/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'zafferano',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://delivery.zafferano.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://delivery.zafferano.sg/#/',fbImage:'https://delivery.zafferano.sg/img/zafferano/logo.png',fbTitle:'Zafferano',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://delivery.zafferano.sg/'},/* Twitter  */tw:{twURL:'https://delivery.zafferano.sg/#/',twTitile:'Zafferano',twvia:'Zafferano'},/* google Plus data   */gp:{gpURL:'https://delivery.zafferano.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://delivery.zafferano.sg/#/',waSeparator:'Zafferano'},site_title:'Zafferano',site_title_with_separator:' | Zafferano',home_meta_title:"Welcome to Zafferano",bgimage:'/img/ninjaprocmn/zafferano/body_bg.jpg'},"order.zoukclub.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"671432D9-9D92-4229-AAF1-571C87A6779F",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'ZoukSHOP',stripeImage:"https://order.zoukclub.com/img/ninjaprocmn/redtail/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'redtail',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.zoukclub.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.zoukclub.com/#/',fbImage:'https://order.zoukclub.com/img/redtail/logo.png',fbTitle:'ZoukSHOP',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.zoukclub.com/'},/* Twitter  */tw:{twURL:'https://order.zoukclub.com/#/',twTitile:'ZoukSHOP',twvia:'ZoukSHOP'},/* google Plus data   */gp:{gpURL:'https://order.zoukclub.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.zoukclub.com/#/',waSeparator:'ZoukSHOP'},site_title:'ZoukSHOP',site_title_with_separator:' | ZoukSHOP',home_meta_title:"Welcome to ZoukSHOP",bgimage:'/img/ninjaprocmn/redtail/body_bg.jpg'},"order.morganfields.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"CD9D3E7B-C4E4-4FF0-B751-A7FE97524F53",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Morganfields',stripeImage:"https://order.morganfields.com.sg/img/ninjaprocmn/morganfields/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'morganfields',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.morganfields.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.morganfields.com.sg/#/',fbImage:'https://order.morganfields.com.sg/img/morganfields/logo.png',fbTitle:'Morganfields',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.morganfields.com.sg/'},/* Twitter  */tw:{twURL:'https://order.morganfields.com.sg/#/',twTitile:'Morganfields',twvia:'Morganfields'},/* google Plus data   */gp:{gpURL:'https://order.morganfields.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.morganfields.com.sg/#/',waSeparator:'Morganfields'},site_title:'Morganfields',site_title_with_separator:' | Morganfields',home_meta_title:"Welcome to Morganfields",bgimage:'/img/ninjaprocmn/morganfields/body_bg.jpg'},"www.mrsoats.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"479259DA-32BF-461F-B6DD-BD306BEE7B63",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Mrs Oats',stripeImage:"https://www.mrsoats.com/img/ninjaprocmn/mrsoats/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'mrsoats',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.mrsoats.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.mrsoats.com/#/',fbImage:'https://www.mrsoats.com/img/mrsoats/logo.png',fbTitle:'Mrs Oats',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.mrsoats.com/'},/* Twitter  */tw:{twURL:'https://www.mrsoats.com/#/',twTitile:'Mrs Oats',twvia:'Mrs Oats'},/* google Plus data   */gp:{gpURL:'https://www.mrsoats.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.mrsoats.com/#/',waSeparator:'Mrs Oats'},site_title:'Mrs Oats',forcewww:'YES',site_title_with_separator:' | Mrs Oats',home_meta_title:"Welcome to Mrs Oats",bgimage:'/img/ninjaprocmn/mrsoats/body_bg.jpg'},"order.angmohdumplings.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"86B86621-C403-4779-80A5-01116AFCB93D",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Angmoh Dumplings',stripeImage:"https://order.angmohdumplings.com/img/ninjaprocmn/angmohdumplings/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'angmohdumplings',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.angmohdumplings.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.angmohdumplings.com/#/',fbImage:'https://order.angmohdumplings.com/img/angmohdumplings/logo.png',fbTitle:'Angmoh Dumplings',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.angmohdumplings.com/'},/* Twitter  */tw:{twURL:'https://order.angmohdumplings.com/#/',twTitile:'Angmoh Dumplings',twvia:'Angmoh Dumplings'},/* google Plus data   */gp:{gpURL:'https://order.angmohdumplings.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.angmohdumplings.com/#/',waSeparator:'Angmoh Dumplings'},site_title:'Angmoh Dumplings',site_title_with_separator:' | Angmoh Dumplings',home_meta_title:"Welcome to Angmoh Dumplings",bgimage:'/img/ninjaprocmn/angmohdumplings/body_bg.jpg'},"order.handlebaroriginal.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"0FCD06D7-B5C8-4399-B413-42C64413A0FC",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Handlebar',stripeImage:"https://order.handlebaroriginal.com/img/ninjaprocmn/handlebar/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'handlebar',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.handlebaroriginal.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.handlebaroriginal.com/#/',fbImage:'https://order.handlebaroriginal.com/img/handlebar/logo.png',fbTitle:'Handlebar',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.handlebaroriginal.com/'},/* Twitter  */tw:{twURL:'https://order.handlebaroriginal.com/#/',twTitile:'Handlebar',twvia:'Handlebar'},/* google Plus data   */gp:{gpURL:'https://order.handlebaroriginal.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.handlebaroriginal.com/#/',waSeparator:'Handlebar'},site_title:'Handlebar',site_title_with_separator:' | Handlebar',home_meta_title:"Welcome to Handlebar",bgimage:'/img/ninjaprocmn/handlebar/body_bg.jpg'},"www.gopizzasg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"2D7ED505-0372-4A46-8980-E6CC15897000",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Gopizza',stripeImage:"https://www.gopizzasg.com/img/ninjaprocmn/gopizza/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'gopizza',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.gopizzasg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.gopizzasg.com/#/',fbImage:'https://www.gopizzasg.com/img/gopizza/logo.png',fbTitle:'Gopizza',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.gopizzasg.com/'},/* Twitter  */tw:{twURL:'https://www.gopizzasg.com/#/',twTitile:'Gopizza',twvia:'Gopizza'},/* google Plus data   */gp:{gpURL:'https://www.gopizzasg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.gopizzasg.com/#/',waSeparator:'Gopizza'},site_title:'Gopizza',site_title_with_separator:' | Gopizza',home_meta_title:"Welcome to Gopizza",bgimage:'/img/ninjaprocmn/gopizza/body_bg.jpg'},"order.kontiki.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"8C1681DB-1596-43D7-BE72-40B8B48A455A",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Kontiki',stripeImage:"https://order.kontiki.sg/img/ninjaprocmn/kontiki/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'kontiki',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.kontiki.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.kontiki.sg/#/',fbImage:'https://order.kontiki.sg/img/kontiki/logo.png',fbTitle:'Kontiki',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.kontiki.sg/'},/* Twitter  */tw:{twURL:'https://order.kontiki.sg/#/',twTitile:'Kontiki',twvia:'Kontiki'},/* google Plus data   */gp:{gpURL:'https://order.kontiki.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.kontiki.sg/#/',waSeparator:'Kontiki'},site_title:'Kontiki',site_title_with_separator:' | Kontiki',home_meta_title:"Welcome to Kontiki",bgimage:'/img/ninjaprocmn/kontiki/body_bg.jpg'},"www.asiahsrecipe.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"A15C4B42-E9B5-446D-B04C-5EA6B247625C",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Asiahs Recipe',stripeImage:"https://www.asiahsrecipe.com/img/ninjaprocmn/asiahsrecipe/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'asiahsrecipe',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.asiahsrecipe.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.asiahsrecipe.com/#/',fbImage:'https://www.asiahsrecipe.com/img/asiahsrecipe/logo.png',fbTitle:'Asiahs Recipe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.asiahsrecipe.com/'},/* Twitter  */tw:{twURL:'https://www.asiahsrecipe.com/#/',twTitile:'Asiahs Recipe',twvia:'Asiahs Recipe'},/* google Plus data   */gp:{gpURL:'https://www.asiahsrecipe.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.asiahsrecipe.com/#/',waSeparator:'Asiahs Recipe'},site_title:'Asiahs Recipe',forcewww:'YES',site_title_with_separator:' | Asiahs Recipe',home_meta_title:"Welcome to Asiahs Recipe",bgimage:'/img/ninjaprocmn/asiahsrecipe/body_bg.jpg'},"www.smoodsmoothies.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E14C262B-9C32-4830-A7F2-660506C2C32F",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'SMOOD SMOOTHIES',stripeImage:"https://www.smoodsmoothies.com/img/ninjaprocmn/smood/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'smood',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.smoodsmoothies.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.smoodsmoothies.com/#/',fbImage:'https://www.smoodsmoothies.com/img/smood/logo.png',fbTitle:'SMOOD SMOOTHIES',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.smoodsmoothies.com/'},/* Twitter  */tw:{twURL:'https://www.smoodsmoothies.com/#/',twTitile:'SMOOD SMOOTHIES',twvia:'SMOOD SMOOTHIES'},/* google Plus data   */gp:{gpURL:'https://www.smoodsmoothies.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.smoodsmoothies.com/#/',waSeparator:'SMOOD SMOOTHIES'},site_title:'SMOOD SMOOTHIES',forcewww:'YES',site_title_with_separator:' | SMOOD SMOOTHIES',home_meta_title:"Welcome to SMOOD SMOOTHIES",bgimage:'/img/ninjaprocmn/smood/body_bg.jpg'},"www.pastaexpressdelivery.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"291B6AEE-2684-4D64-8243-A1481536D932",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Pasta Express',stripeImage:"https://www.pastaexpressdelivery.com/img/ninjaprocmn/pastaexpress/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'pastaexpress',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.almaboobrojak.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.pastaexpressdelivery.com/#/',fbImage:'https://www.pastaexpressdelivery.com/img/pastaexpress/logo.png',fbTitle:'Pasta Express',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.pastaexpressdelivery.com/'},/* Twitter  */tw:{twURL:'https://www.pastaexpressdelivery.com/#/',twTitile:'Pasta Express',twvia:'Pasta Express'},/* google Plus data   */gp:{gpURL:'https://www.pastaexpressdelivery.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.pastaexpressdelivery.com/#/',waSeparator:'Pasta Express'},site_title:'Pasta Express',forcewww:'YES',site_title_with_separator:' | Pasta Express',home_meta_title:"Welcome to Pasta Express",bgimage:'/img/ninjaprocmn/pastaexpress/body_bg.jpg'},"www.mruncle.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"7A1B942A-D0D8-416A-BE85-A22F91689E8C",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Mr Uncle',stripeImage:"https://www.mruncle.sg/img/ninjaprocmn/mruncle/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'mruncle',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.mruncle.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.mruncle.sg/#/',fbImage:'https://www.mruncle.sg/img/mruncle/logo.png',fbTitle:'Mr Uncle',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.mruncle.sg/'},/* Twitter  */tw:{twURL:'https://www.mruncle.sg/#/',twTitile:'Mr Uncle',twvia:'Mr Uncle'},/* google Plus data   */gp:{gpURL:'https://www.mruncle.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://www.mruncle.sg/#/',waSeparator:'Mr Uncle'},site_title:'Mr Uncle',forcewww:'YES',site_title_with_separator:' | Mr Uncle',home_meta_title:"Welcome to Mr Uncle",bgimage:'/img/ninjaprocmn/mruncle/body_bg.jpg'},"order.maxwellteochewporridge.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"060A7EC3-77F8-44E6-8F57-5144A3D15938",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Teochew Rice and Porridge',stripeImage:"https://order.maxwellteochewporridge.com/img/ninjaprocmn/teochew/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'teochew',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.maxwellteochewporridge.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.maxwellteochewporridge.com/#/',fbImage:'https://order.maxwellteochewporridge.com/img/teochew/logo.png',fbTitle:'Teochew Rice and Porridge',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.maxwellteochewporridge.com/'},/* Twitter  */tw:{twURL:'https://order.maxwellteochewporridge.com/#/',twTitile:'Teochew Rice and Porridge',twvia:'Teochew Rice and Porridge'},/* google Plus data   */gp:{gpURL:'https://order.maxwellteochewporridge.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.maxwellteochewporridge.com/#/',waSeparator:'Teochew Rice and Porridge'},site_title:'Teochew Rice and Porridge',site_title_with_separator:' | Teochew Rice and Porridge',home_meta_title:"Welcome to Teochew Rice and Porridge",bgimage:'/img/ninjaprocmn/teochew/body_bg.jpg'},"www.minoracuisine.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"18C6010E-24F1-4186-A666-E76909D10A15",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Minora Cuisine',stripeImage:"https://www.minoracuisine.com/img/ninjaprocmn/minora/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'minora',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.minoracuisine.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.minoracuisine.com/#/',fbImage:'https://www.minoracuisine.com/img/minora/logo.png',fbTitle:'Minora Cuisine',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.minoracuisine.com/'},/* Twitter  */tw:{twURL:'https://www.minoracuisine.com/#/',twTitile:'Minora Cuisine',twvia:'Minora Cuisine'},/* google Plus data   */gp:{gpURL:'https://www.minoracuisine.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.minoracuisine.com/#/',waSeparator:'Minora Cuisine'},site_title:'Minora Cuisine',forcewww:'YES',site_title_with_separator:' | Minora Cuisine',home_meta_title:"Welcome to Minora Cuisine",bgimage:'/img/ninjaprocmn/minora/body_bg.jpg'},"whipped.ninjapro.co":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"386D2334-BE66-43BA-B059-83EC37238C7C",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Whipped',stripeImage:"https://whipped.ninjapro.co/img/ninjaprocmn/whipped/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'whipped',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://whipped.ninjapro.co/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://whipped.ninjapro.co/#/',fbImage:'https://whipped.ninjapro.co/img/whipped/logo.png',fbTitle:'Whipped',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://whipped.ninjapro.co/'},/* Twitter  */tw:{twURL:'https://whipped.ninjapro.co/#/',twTitile:'Whipped',twvia:'Whipped'},/* google Plus data   */gp:{gpURL:'https://whipped.ninjapro.co/#/'},/* Whatsapp data   */wa:{waURL:'https://whipped.ninjapro.co/#/',waSeparator:'Whipped'},site_title:'Whipped',site_title_with_separator:' | Whipped',home_meta_title:"Welcome to Whipped",bgimage:'/img/ninjaprocmn/whipped/body_bg.jpg'},"www.xiangdessertfood.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"0B0E3C46-2233-4D14-A138-F64BD4BF2EA4",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Xiang Authentic Taiwanese Dessert and Food',stripeImage:"https://www.xiangdessertfood.com/img/ninjaprocmn/xiang/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'xiang',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.xiangdessertfood.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.xiangdessertfood.com/#/',fbImage:'https://www.xiangdessertfood.com/img/xiang/logo.png',fbTitle:'Xiang Authentic Taiwanese Dessert and Food',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.xiangdessertfood.com/'},/* Twitter  */tw:{twURL:'https://www.xiangdessertfood.com/#/',twTitile:'Xiang Authentic Taiwanese Dessert and Food',twvia:'Xiang Authentic Taiwanese Dessert and Food'},/* google Plus data   */gp:{gpURL:'https://www.xiangdessertfood.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.xiangdessertfood.com/#/',waSeparator:'Xiang Authentic Taiwanese Dessert and Food'},site_title:'Xiang Authentic Taiwanese Dessert and Food',forcewww:'YES',site_title_with_separator:' | Xiang Authentic Taiwanese Dessert and Food',home_meta_title:"Welcome to Xiang Authentic Taiwanese Dessert and Food",bgimage:'/img/ninjaprocmn/xiang/body_bg.jpg'},"sgunited.gayatrirestaurant.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"C0C8EB6D-0F3D-4F10-AA3F-4CC8990A87A9",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Gayatri Restaurant',stripeImage:"https://sgunited.gayatrirestaurant.com/img/ninjaprocmn/andra/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'andra',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://sgunited.gayatrirestaurant.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://sgunited.gayatrirestaurant.com/#/',fbImage:'https://sgunited.gayatrirestaurant.com/img/andra/logo.png',fbTitle:'Gayatri Restaurant',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://sgunited.gayatrirestaurant.com/'},/* Twitter  */tw:{twURL:'https://sgunited.gayatrirestaurant.com/#/',twTitile:'Gayatri Restaurant',twvia:'Gayatri Restaurant'},/* google Plus data   */gp:{gpURL:'https://sgunited.gayatrirestaurant.com/#/'},/* Whatsapp data   */wa:{waURL:'https://sgunited.gayatrirestaurant.com/#/',waSeparator:'Gayatri Restaurant'},site_title:'Gayatri Restaurant',site_title_with_separator:' | Gayatri Restaurant',home_meta_title:"Welcome to Gayatri Restaurant",bgimage:'/img/ninjaprocmn/andra/body_bg.jpg'},"order.tembusuprojects.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"25321897-C0EC-42A4-A84A-7F668F031950",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Tembusu',stripeImage:"https://order.tembusuprojects.com/img/ninjaprocmn/tembusu/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'tembusu',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.tembusuprojects.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.tembusuprojects.com/#/',fbImage:'https://order.tembusuprojects.com/img/tembusu/logo.png',fbTitle:'Tembusu',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.tembusuprojects.com/'},/* Twitter  */tw:{twURL:'https://order.tembusuprojects.com/#/',twTitile:'Tembusu',twvia:'Tembusu'},/* google Plus data   */gp:{gpURL:'https://order.tembusuprojects.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.tembusuprojects.com/#/',waSeparator:'Tembusu'},site_title:'Tembusu',site_title_with_separator:' | Tembusu',home_meta_title:"Welcome to Tembusu",bgimage:'/img/ninjaprocmn/tembusu/body_bg.jpg'},"order.yummypunjaby.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"42E1C07C-9095-449E-A1EE-2EE497C44FB0",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Yummy Punjaby',stripeImage:"https://order.yummypunjaby.com/img/ninjaprocmn/yummypunjaby/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'yummypunjaby',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.yummypunjaby.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.yummypunjaby.com/#/',fbImage:'https://order.yummypunjaby.com/img/yummypunjaby/logo.png',fbTitle:'Yummy Punjaby',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.yummypunjaby.com/'},/* Twitter  */tw:{twURL:'https://order.yummypunjaby.com/#/',twTitile:'Yummy Punjaby',twvia:'Yummy Punjaby'},/* google Plus data   */gp:{gpURL:'https://order.yummypunjaby.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.yummypunjaby.com/#/',waSeparator:'Yummy Punjaby'},site_title:'Yummy Punjaby',site_title_with_separator:' | Yummy Punjaby',home_meta_title:"Welcome to Yummy Punjaby",bgimage:'/img/ninjaprocmn/yummypunjaby/body_bg.jpg'},"order.scc.org.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"6C0280A0-B655-4E0F-A43F-041C189683BA",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Singapore Cricket Club',stripeImage:"https://order.scc.org.sg/img/ninjaprocmn/sccadmin/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'sccadmin',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.scc.org.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.scc.org.sg/#/',fbImage:'https://order.scc.org.sg/img/sccadmin/logo.png',fbTitle:'Singapore Cricket Club',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.scc.org.sg/'},/* Twitter  */tw:{twURL:'https://order.scc.org.sg/#/',twTitile:'Singapore Cricket Club',twvia:'Singapore Cricket Club'},/* google Plus data   */gp:{gpURL:'https://order.scc.org.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.scc.org.sg/#/',waSeparator:'Singapore Cricket Club'},site_title:'Singapore Cricket Club',site_title_with_separator:' | Singapore Cricket Club',home_meta_title:"Welcome to Singapore Cricket Club",bgimage:'/img/ninjaprocmn/sccadmin/body_bg.jpg'},"www.thehwangsil.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"B77DBBA2-34B6-4153-9001-FEC3F62D70B6",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'The Hwangsil',stripeImage:"https://www.thehwangsil.com/img/ninjaprocmn/hwangsil/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'hwangsil',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.thehwangsil.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.thehwangsil.com/#/',fbImage:'https://www.thehwangsil.com/img/hwangsil/logo.png',fbTitle:'The Hwangsil',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.thehwangsil.com/'},/* Twitter  */tw:{twURL:'https://www.thehwangsil.com/#/',twTitile:'The Hwangsil',twvia:'The Hwangsil'},/* google Plus data   */gp:{gpURL:'https://www.thehwangsil.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.thehwangsil.com/#/',waSeparator:'The Hwangsil'},site_title:'The Hwangsil',forcewww:'YES',site_title_with_separator:' | The Hwangsil',home_meta_title:"Welcome to The Hwangsil",bgimage:'/img/ninjaprocmn/hwangsil/body_bg.jpg'},"order.drdurian.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"AC8AA9F5-F20D-49C0-AF12-7D47F066A160",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Dr Durian',stripeImage:"https://order.drdurian.com.sg/img/ninjaprocmn/drdurian/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'drdurian',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.drdurian.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.drdurian.com.sg/#/',fbImage:'https://order.drdurian.com.sg/img/drdurian/logo.png',fbTitle:'Dr Durian',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.drdurian.com.sg/'},/* Twitter  */tw:{twURL:'https://order.drdurian.com.sg/#/',twTitile:'Dr Durian',twvia:'Dr Durian'},/* google Plus data   */gp:{gpURL:'https://order.drdurian.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.drdurian.com.sg/#/',waSeparator:'Dr Durian'},site_title:'Dr Durian',forcewww:'YES',site_title_with_separator:' | Dr Durian',home_meta_title:"Welcome to Dr Durian",bgimage:'/img/ninjaprocmn/drdurian/body_bg.jpg'},"www.thecurryclub.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"5C28CCD6-6A1F-44AD-BE9A-0765B906BDB8",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'The Curry Club',stripeImage:"https://www.thecurryclub.sg/img/ninjaprocmn/curryclub/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'curryclub',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.thecurryclub.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.thecurryclub.sg/#/',fbImage:'https://www.thecurryclub.sg/img/curryclub/logo.png',fbTitle:'The Curry Club',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.thecurryclub.sg/'},/* Twitter  */tw:{twURL:'https://www.thecurryclub.sg/#/',twTitile:'The Curry Club',twvia:'The Curry Club'},/* google Plus data   */gp:{gpURL:'https://www.thecurryclub.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://www.thecurryclub.sg/#/',waSeparator:'The Curry Club'},site_title:'The Curry Club',forcewww:'YES',site_title_with_separator:' | The Curry Club',home_meta_title:"Welcome to The Curry Club",bgimage:'/img/ninjaprocmn/curryclub/body_bg.jpg'},"order.ministryofrojak.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E02013C3-C733-49C5-ADAA-5EE1DA42EB93",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Ministry of Rojak',stripeImage:"https://order.ministryofrojak.com/img/ninjaprocmn/ministryofrojak/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ministryofrojak',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.ministryofrojak.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.ministryofrojak.com/#/',fbImage:'https://order.ministryofrojak.com/img/ministryofrojak/logo.png',fbTitle:'Ministry of Rojak',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.ministryofrojak.com/'},/* Twitter  */tw:{twURL:'https://order.ministryofrojak.com/#/',twTitile:'Ministry of Rojak',twvia:'Ministry of Rojak'},/* google Plus data   */gp:{gpURL:'https://order.ministryofrojak.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.ministryofrojak.com/#/',waSeparator:'Ministry of Rojak'},site_title:'Ministry of Rojak',site_title_with_separator:' | Ministry of Rojak',home_meta_title:"Welcome to Ministry of Rojak",bgimage:'/img/ninjaprocmn/ministryofrojak/body_bg.jpg'},"order.saffrons.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"76DABFCC-0A47-40C7-8588-E3C32F87B3C8",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Saffrons',stripeImage:"https://order.saffrons.com.sg/img/ninjaprocmn/saffrons/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'saffrons',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.saffrons.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.saffrons.com.sg/#/',fbImage:'https://order.saffrons.com.sg/img/saffrons/logo.png',fbTitle:'Saffrons',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.saffrons.com.sg/'},/* Twitter  */tw:{twURL:'https://order.saffrons.com.sg/#/',twTitile:'Saffrons',twvia:'Saffrons'},/* google Plus data   */gp:{gpURL:'https://order.saffrons.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.saffrons.com.sg/#/',waSeparator:'Saffrons'},site_title:'Saffrons',site_title_with_separator:' | Saffrons',home_meta_title:"Welcome to Saffrons",bgimage:'/img/ninjaprocmn/saffrons/body_bg.jpg'},"www.esync.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"6171DF9A-7946-4EEA-85A7-8EDF3C70990A",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'ESync',stripeImage:"https://www.esync.sg/img/ninjaprocmn/mealcaterer/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'mealcaterer',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.esync.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.esync.sg/#/',fbImage:'https://www.esync.sg/img/mealcaterer/logo.png',fbTitle:'ESync',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.esync.sg/'},/* Twitter  */tw:{twURL:'https://www.esync.sg/#/',twTitile:'ESync',twvia:'ESync'},/* google Plus data   */gp:{gpURL:'https://www.esync.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://www.esync.sg/#/',waSeparator:'ESync'},site_title:'ESync',site_title_with_separator:' | ESync',home_meta_title:"ESync",bgimage:'/img/ninjaprocmn/mealcaterer/body_bg.jpg'},"www.goldensandstreetkitchen.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"7DF70096-44E7-4072-97C3-E83562DEBF13",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Golden Sands Street Kitchen',stripeImage:"https://www.goldensandstreetkitchen.com/img/ninjaprocmn/goldensands/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'goldensands',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.goldensandstreetkitchen.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.goldensandstreetkitchen.com/#/',fbImage:'https://www.goldensandstreetkitchen.com/img/goldensands/logo.png',fbTitle:'Golden Sands Street Kitchen',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.goldensandstreetkitchen.com/'},/* Twitter  */tw:{twURL:'https://www.goldensandstreetkitchen.com/#/',twTitile:'Golden Sands Street Kitchen',twvia:'Golden Sands Street Kitchen'},/* google Plus data   */gp:{gpURL:'https://www.goldensandstreetkitchen.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.goldensandstreetkitchen.com/#/',waSeparator:'Golden Sands Street Kitchen'},site_title:'Golden Sands Street Kitchen',forcewww:'YES',site_title_with_separator:' | Golden Sands Street Kitchen',home_meta_title:"Golden Sands Street Kitchen",bgimage:'/img/ninjaprocmn/goldensands/body_bg.jpg'},"www.sghappypot.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"81FEE5A7-2AEE-4CD9-8BF5-372DE9A822FF",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'SG Happy Pot',stripeImage:"https://www.sghappypot.com/img/ninjaprocmn/sghappypot/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'sghappypot',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.sghappypot.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.sghappypot.com/#/',fbImage:'https://www.sghappypot.com/img/sghappypot/logo.png',fbTitle:'SG Happy Pot',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.sghappypot.com/'},/* Twitter  */tw:{twURL:'https://www.sghappypot.com/#/',twTitile:'SG Happy Pot',twvia:'SG Happy Pot'},/* google Plus data   */gp:{gpURL:'https://www.sghappypot.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.sghappypot.com/#/',waSeparator:'SG Happy Pot'},site_title:'SG Happy Pot',forcewww:'YES',site_title_with_separator:' | SG Happy Pot',home_meta_title:"SG Happy Pot",bgimage:'/img/ninjaprocmn/sghappypot/body_bg.jpg'},"order.pastabrava.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"0D33B481-DCEC-47D8-BEE6-FBE5A9A4D5C7",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Pasta Brava',stripeImage:"https://order.pastabrava.com.sg/img/ninjaprocmn/pastabrava/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'pastabrava',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.pastabrava.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.pastabrava.com.sg/#/',fbImage:'https://order.pastabrava.com.sg/img/pastabrava/logo.png',fbTitle:'Pasta Brava',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.pastabrava.com.sg/'},/* Twitter  */tw:{twURL:'https://order.pastabrava.com.sg/#/',twTitile:'Pasta Brava',twvia:'Pasta Brava'},/* google Plus data   */gp:{gpURL:'https://order.pastabrava.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.pastabrava.com.sg/#/',waSeparator:'Pasta Brava'},site_title:'Pasta Brava',site_title_with_separator:' | Pasta Brava',home_meta_title:"Pasta Brava",bgimage:'/img/ninjaprocmn/pastabrava/body_bg.jpg'},"orderonline.theboiler.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"33843AC9-EB47-42EE-8AAA-14CEA187D85A",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'The Boiler',stripeImage:"https://orderonline.theboiler.com.sg/img/ninjaprocmn/theboiler/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'theboiler',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://orderonline.theboiler.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://orderonline.theboiler.com.sg/#/',fbImage:'https://orderonline.theboiler.com.sg/img/theboiler/logo.png',fbTitle:'The Boiler',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://orderonline.theboiler.com.sg/'},/* Twitter  */tw:{twURL:'https://orderonline.theboiler.com.sg/#/',twTitile:'The Boiler',twvia:'The Boiler'},/* google Plus data   */gp:{gpURL:'https://orderonline.theboiler.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://orderonline.theboiler.com.sg/#/',waSeparator:'The Boiler'},site_title:'The Boiler',site_title_with_separator:' | The Boiler',home_meta_title:"The Boiler",bgimage:'/img/ninjaprocmn/theboiler/body_bg.jpg'},"order.mala.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"4750A971-EC66-49E5-956A-9F9D2271FAB2",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Xiao Man Niu Mala Xiang Guo',stripeImage:"https://order.mala.com.sg/img/ninjaprocmn/xiaoman/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'xiaoman',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.mala.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.mala.com.sg/#/',fbImage:'https://order.mala.com.sg/img/xiaoman/logo.png',fbTitle:'Xiao Man Niu Mala Xiang Guo',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.mala.com.sg/'},/* Twitter  */tw:{twURL:'https://order.mala.com.sg/#/',twTitile:'Xiao Man Niu Mala Xiang Guo',twvia:'Xiao Man Niu Mala Xiang Guo'},/* google Plus data   */gp:{gpURL:'https://order.mala.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.mala.com.sg/#/',waSeparator:'Xiao Man Niu Mala Xiang Guo'},site_title:'Xiao Man Niu Mala Xiang Guo',site_title_with_separator:' | Xiao Man Niu Mala Xiang Guo',home_meta_title:"Xiao Man Niu Mala Xiang Guo",bgimage:'/img/ninjaprocmn/xiaoman/body_bg.jpg'},"order.oystercosg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"150A49CA-6982-4AFA-95B8-B3AE1F01677C",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Oyster Co',stripeImage:"https://order.oystercosg.com/img/ninjaprocmn/oysterco/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'oysterco',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.oystercosg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.oystercosg.com/#/',fbImage:'https://order.oystercosg.com/img/oysterco/logo.png',fbTitle:'Oyster Co',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.oystercosg.com/'},/* Twitter  */tw:{twURL:'https://order.oystercosg.com/#/',twTitile:'Oyster Co',twvia:'Oyster Co'},/* google Plus data   */gp:{gpURL:'https://order.oystercosg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.oystercosg.com/#/',waSeparator:'Oyster Co'},site_title:'Oyster Co',site_title_with_separator:' | Oyster Co',home_meta_title:"Oyster Co",bgimage:'/img/ninjaprocmn/oysterco/body_bg.jpg'},"order.deetonguethai.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"2D749004-5E7F-4DCA-9F89-40BCE80BD085",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Dee Tongue Thai By Rung Mama',stripeImage:"https://order.deetonguethai.com.sg/img/ninjaprocmn/deetonguethai/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'deetonguethai',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.deetonguethai.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.deetonguethai.com.sg/#/',fbImage:'https://order.deetonguethai.com.sg/img/deetonguethai/logo.png',fbTitle:'Dee Tongue Thai By Rung Mama',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.deetonguethai.com.sg/'},/* Twitter  */tw:{twURL:'https://order.deetonguethai.com.sg/#/',twTitile:'Dee Tongue Thai By Rung Mama',twvia:'Dee Tongue Thai By Rung Mama'},/* google Plus data   */gp:{gpURL:'https://order.deetonguethai.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.deetonguethai.com.sg/#/',waSeparator:'Dee Tongue Thai By Rung Mama'},site_title:'Dee Tongue Thai By Rung Mama',site_title_with_separator:' | Dee Tongue Thai By Rung Mama',home_meta_title:"Dee Tongue Thai By Rung Mama",bgimage:'/img/ninjaprocmn/deetonguethai/body_bg.jpg'},"www.grainsandco.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"27B89C4A-49DF-4492-B3D6-1168871611CF",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Grains & Co',stripeImage:"https://www.grainsandco.sg/img/ninjaprocmn/mixconnection/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'mixconnection',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.grainsandco.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.grainsandco.sg/#/',fbImage:'https://www.grainsandco.sg/img/mixconnection/logo.png',fbTitle:'Grains & Co',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.grainsandco.sg/'},/* Twitter  */tw:{twURL:'https://www.grainsandco.sg/#/',twTitile:'Grains & Co',twvia:'Grains & Co'},/* google Plus data   */gp:{gpURL:'https://www.grainsandco.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://www.grainsandco.sg/#/',waSeparator:'Grains & Co'},site_title:'Grains & Co',site_title_with_separator:' | Grains & Co',home_meta_title:"Grains & Co",bgimage:'/img/ninjaprocmn/mixconnection/body_bg.jpg'},"www.mrdonerkebabsg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"C0DB3D3C-8A00-4F11-BB9D-515A46BF3FC7",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Mr Doner Kebab',stripeImage:"https://www.mrdonerkebabsg.com/img/ninjaprocmn/curryspize/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'curryspize',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.mrdonerkebabsg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.mrdonerkebabsg.com/#/',fbImage:'https://www.mrdonerkebabsg.com/img/curryspize/logo.png',fbTitle:'Mr Doner Kebab',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.mrdonerkebabsg.com/'},/* Twitter  */tw:{twURL:'https://www.mrdonerkebabsg.com/#/',twTitile:'Mr Doner Kebab',twvia:'Mr Doner Kebab'},/* google Plus data   */gp:{gpURL:'https://www.mrdonerkebabsg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.mrdonerkebabsg.com/#/',waSeparator:'Mr Doner Kebab '},site_title:'Mr Doner Kebab',forcewww:'YES',site_title_with_separator:' | Mr Doner Kebab',home_meta_title:"Mr Doner Kebab",bgimage:'/img/ninjaprocmn/curryspize/body_bg.jpg'},"www.kotobukibentosg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"A732D7B1-5FBC-4DB1-BC3B-1750617AC480",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'KOTOBUKI',stripeImage:"https://www.kotobukibentosg.com/img/ninjaprocmn/kotobuki/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'kotobuki',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.kotobukibentosg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.kotobukibentosg.com/#/',fbImage:'https://www.kotobukibentosg.com/img/kotobuki/logo.png',fbTitle:'KOTOBUKI',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.kotobukibentosg.com/'},/* Twitter  */tw:{twURL:'https://www.kotobukibentosg.com/#/',twTitile:'KOTOBUKI',twvia:'KOTOBUKI'},/* google Plus data   */gp:{gpURL:'https://www.kotobukibentosg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.kotobukibentosg.com/#/',waSeparator:'KOTOBUKI'},site_title:'KOTOBUKI',forcewww:'YES',site_title_with_separator:' | KOTOBUKI',home_meta_title:"KOTOBUKI",bgimage:'/img/ninjaprocmn/kotobuki/body_bg.jpg'},"order.platethora.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"C08D07DE-1F10-4A7A-8F60-C39B20194D81",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Platethora',stripeImage:"https://order.platethora.com.sg/img/ninjaprocmn/platethora/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'platethora',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.platethora.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.platethora.com.sg/#/',fbImage:'https://order.platethora.com.sg/img/platethora/logo.png',fbTitle:'Platethora',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.platethora.com.sg/'},/* Twitter  */tw:{twURL:'https://order.platethora.com.sg/#/',twTitile:'Platethora',twvia:'Platethora'},/* google Plus data   */gp:{gpURL:'https://order.platethora.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.platethora.com.sg/#/',waSeparator:'Platethora'},site_title:'Platethora',site_title_with_separator:' | Platethora',home_meta_title:"Platethora",bgimage:'/img/ninjaprocmn/platethora/body_bg.jpg'},"ninjaorder.gourmetz.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"6BA585FF-8494-4393-8FCF-D8A876E40538",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Gourmetz',stripeImage:"https://ninjaorder.gourmetz.com.sg/img/ninjaprocmn/gourmetz/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'gourmetz',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://ninjaorder.gourmetz.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://ninjaorder.gourmetz.com.sg/#/',fbImage:'https://ninjaorder.gourmetz.com.sg/img/gourmetz/logo.png',fbTitle:'Gourmetz',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://ninjaorder.gourmetz.com.sg/'},/* Twitter  */tw:{twURL:'https://ninjaorder.gourmetz.com.sg/#/',twTitile:'Gourmetz',twvia:'Gourmetz'},/* google Plus data   */gp:{gpURL:'https://ninjaorder.gourmetz.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://ninjaorder.gourmetz.com.sg/#/',waSeparator:'Gourmetz'},site_title:'Gourmetz',site_title_with_separator:' | Gourmetz',home_meta_title:"Gourmetz",bgimage:'/img/ninjaprocmn/gourmetz/body_bg.jpg'},"order.makanmate.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"A25899B9-E00B-4B08-B068-01EE55529BB1",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Makan Mate Catering',stripeImage:"https://order.makanmate.com/img/ninjaprocmn/makanmate/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'makanmate',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.makanmate.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.makanmate.com/#/',fbImage:'https://order.makanmate.com/img/makanmate/logo.png',fbTitle:'Makan Mate Catering',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.makanmate.com/'},/* Twitter  */tw:{twURL:'https://order.makanmate.com/#/',twTitile:'Makan Mate Catering',twvia:'Makan Mate Catering'},/* google Plus data   */gp:{gpURL:'https://order.makanmate.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.makanmate.com/#/',waSeparator:'Makan Mate Catering'},site_title:'Makan Mate Catering',site_title_with_separator:' | Makan Mate Catering',home_meta_title:"Makan Mate Catering",bgimage:'/img/ninjaprocmn/makanmate/body_bg.jpg'},"order.therefinery.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"61ACAD41-E48E-4F3F-A71C-7913BA965CDF",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'The Refinery',stripeImage:"https://order.therefinery.sg/img/ninjaprocmn/refinery/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'refinery',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.therefinery.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.therefinery.sg/#/',fbImage:'https://order.therefinery.sg/img/refinery/logo.png',fbTitle:'The Refinery',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.therefinery.sg/'},/* Twitter  */tw:{twURL:'https://order.therefinery.sg/#/',twTitile:'The Refinery',twvia:'The Refinery'},/* google Plus data   */gp:{gpURL:'https://order.therefinery.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.therefinery.sg/#/',waSeparator:'The Refinery'},site_title:'The Refinery',site_title_with_separator:' | The Refinery',home_meta_title:"The Refinery",bgimage:'/img/ninjaprocmn/refinery/body_bg.jpg'},"order.tomahawk.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"EF790149-70A0-4250-9481-8BAEC710EDE3",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Tomahawk',stripeImage:"https://order.tomahawk.com.sg/img/ninjaprocmn/omajadmin/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'omajadmin',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.tomahawk.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.tomahawk.com.sg/#/',fbImage:'https://order.tomahawk.com.sg/img/omajadmin/logo.png',fbTitle:'Tomahawk',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.tomahawk.com.sg/'},/* Twitter  */tw:{twURL:'https://order.tomahawk.com.sg/#/',twTitile:'Tomahawk',twvia:'Tomahawk'},/* google Plus data   */gp:{gpURL:'https://order.tomahawk.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.tomahawk.com.sg/#/',waSeparator:'Tomahawk'},site_title:'Tomahawk',site_title_with_separator:' | Tomahawk',home_meta_title:"Tomahawk",bgimage:'/img/ninjaprocmn/omajadmin/body_bg.jpg'},"order.pickapastasg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"A19B2637-E952-4ABD-BBC0-BE4B441ABE60",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Pick-A-Pasta',stripeImage:"https://order.pickapastasg.com/img/ninjaprocmn/pickapastasg/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'pickapastasg',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.pickapastasg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.pickapastasg.com/#/',fbImage:'https://order.pickapastasg.com/img/pickapastasg/logo.png',fbTitle:'Pick-A-Pasta',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.pickapastasg.com/'},/* Twitter  */tw:{twURL:'https://order.pickapastasg.com/#/',twTitile:'Pick-A-Pasta',twvia:'Pick-A-Pasta'},/* google Plus data   */gp:{gpURL:'https://order.pickapastasg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.pickapastasg.com/#/',waSeparator:'Pick-A-Pasta'},site_title:'Pick-A-Pasta',site_title_with_separator:' | Pick-A-Pasta',home_meta_title:"Pick-A-Pasta",bgimage:'/img/ninjaprocmn/pickapastasg/body_bg.jpg'},"order.ricebowlgold.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"53A5C4BB-5119-4EA6-A5F1-8450138CF162",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Rice Bowl Gold',stripeImage:"https://order.ricebowlgold.com/img/ninjaprocmn/ricebowlgold/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ricebowlgold',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.ricebowlgold.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.ricebowlgold.com/#/',fbImage:'https://order.ricebowlgold.com/img/ricebowlgold/logo.png',fbTitle:'Rice Bowl Gold',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.ricebowlgold.com/'},/* Twitter  */tw:{twURL:'https://order.ricebowlgold.com/#/',twTitile:'Rice Bowl Gold',twvia:'Rice Bowl Gold'},/* google Plus data   */gp:{gpURL:'https://order.ricebowlgold.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.ricebowlgold.com/#/',waSeparator:'Rice Bowl Gold'},site_title:'Rice Bowl Gold',site_title_with_separator:' | Rice Bowl Gold',home_meta_title:"Rice Bowl Gold",bgimage:'/img/ninjaprocmn/ricebowlgold/body_bg.jpg'},"www.suriafood.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E74DA3C5-BE62-471B-8949-3A8EB9F622A7",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Suria Food',stripeImage:"https://www.suriafood.com.sg/img/ninjaprocmn/suriafood/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'suriafood',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.suriafood.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.suriafood.com.sg/#/',fbImage:'https://www.suriafood.com.sg/img/suriafood/logo.png',fbTitle:'Suria Food',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.suriafood.com.sg/'},/* Twitter  */tw:{twURL:'https://www.suriafood.com.sg/#/',twTitile:'Suria Food',twvia:'Suria Food'},/* google Plus data   */gp:{gpURL:'https://www.suriafood.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://www.suriafood.com.sg/#/',waSeparator:'Suria Food'},site_title:'Suria Food',forcewww:'YES',site_title_with_separator:' | Suria Food',home_meta_title:"Suria Food",bgimage:'/img/ninjaprocmn/suriafood/body_bg.jpg'},"order.hawkerchan.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"A1DDCC23-D7DF-4F1C-A59C-ECD6AF1C37FA",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Hawker Chan',stripeImage:"https://order.hawkerchan.com/img/ninjaprocmn/hawkerchan/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'hawkerchan',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.hawkerchan.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.hawkerchan.com/#/',fbImage:'https://order.hawkerchan.com/img/hawkerchan/logo.png',fbTitle:'Hawker Chan',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.hawkerchan.com/'},/* Twitter  */tw:{twURL:'https://order.hawkerchan.com/#/',twTitile:'Hawker Chan',twvia:'Hawker Chan'},/* google Plus data   */gp:{gpURL:'https://order.hawkerchan.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.hawkerchan.com/#/',waSeparator:'Hawker Chan'},site_title:'Hawker Chan',site_title_with_separator:' | Hawker Chan',home_meta_title:"Hawker Chan",bgimage:'/img/ninjaprocmn/hawkerchan/body_bg.jpg'},"www.kimotogastrobar.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"6991DFCE-7B67-4528-AA4C-9B7331848346",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'KIMOTO GASTROBAR',stripeImage:"https://www.kimotogastrobar.com/img/ninjaprocmn/kimoto/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'kimoto',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.kimotogastrobar.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.kimotogastrobar.com/#/',fbImage:'https://www.kimotogastrobar.com/img/kimoto/logo.png',fbTitle:'KIMOTO GASTROBAR',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.kimotogastrobar.com/'},/* Twitter  */tw:{twURL:'https://www.kimotogastrobar.com/#/',twTitile:'KIMOTO GASTROBAR',twvia:'KIMOTO GASTROBAR'},/* google Plus data   */gp:{gpURL:'https://www.kimotogastrobar.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.kimotogastrobar.com/#/',waSeparator:'KIMOTO GASTROBAR'},site_title:'KIMOTO GASTROBAR',forcewww:'YES',site_title_with_separator:' | KIMOTO GASTROBAR',home_meta_title:"KIMOTO GASTROBAR",bgimage:'/img/ninjaprocmn/kimoto/body_bg.jpg'},"www.kacacoffee.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"2E6757CD-8E20-4454-9FC5-B3721277612D",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Kaca Coffee ',stripeImage:"https://www.kacacoffee.com/img/ninjaprocmn/kacacoffee/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'kacacoffee',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.kacacoffee.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.kacacoffee.com/#/',fbImage:'https://www.kacacoffee.com/img/kacacoffee/logo.png',fbTitle:'Kaca Coffee ',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.kacacoffee.com/'},/* Twitter  */tw:{twURL:'https://www.kacacoffee.com/#/',twTitile:'Kaca Coffee ',twvia:'Kaca Coffee '},/* google Plus data   */gp:{gpURL:'https://www.kacacoffee.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.kacacoffee.com/#/',waSeparator:'Kaca Coffee '},site_title:'Kaca Coffee ',forcewww:'YES',site_title_with_separator:' | Kaca Coffee ',home_meta_title:"Kaca Coffee ",bgimage:'/img/ninjaprocmn/kacacoffee/body_bg.jpg'},"coba.cobacoba.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"A2924058-9DEC-4A6B-A92C-F762D2C1A7E3",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Coba Coba',stripeImage:"https://coba.cobacoba.sg/img/ninjaprocmn/cobacoba/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'cobacoba',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://coba.cobacoba.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://coba.cobacoba.sg/#/',fbImage:'https://coba.cobacoba.sg/img/cobacoba/logo.png',fbTitle:'Coba Coba',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://coba.cobacoba.sg/'},/* Twitter  */tw:{twURL:'https://coba.cobacoba.sg/#/',twTitile:'Coba Coba',twvia:'Coba Coba'},/* google Plus data   */gp:{gpURL:'https://coba.cobacoba.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://coba.cobacoba.sg/#/',waSeparator:'Coba Coba'},site_title:'Coba Coba',site_title_with_separator:' | Coba Coba',home_meta_title:"Coba Coba",bgimage:'/img/ninjaprocmn/cobacoba/body_bg.jpg'},"www.hansimglucksg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"C69911CC-C6B9-46D0-9A15-5DF5A201B3CF",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'HANS IM GLUCK GERMAN BURGERGRILL',stripeImage:"https://www.hansimglucksg.com/img/ninjaprocmn/hansimgluck/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'hansimgluck',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.hansimglucksg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.hansimglucksg.com/#/',fbImage:'https://www.hansimglucksg.com/img/hansimgluck/logo.png',fbTitle:'HANS IM GLUCK GERMAN BURGERGRILL',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.hansimglucksg.com/'},/* Twitter  */tw:{twURL:'https://www.hansimglucksg.com/#/',twTitile:'HANS IM GLUCK GERMAN BURGERGRILL',twvia:'HANS IM GLUCK GERMAN BURGERGRILL'},/* google Plus data   */gp:{gpURL:'https://www.hansimglucksg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.hansimglucksg.com/#/',waSeparator:'HANS IM GLUCK GERMAN BURGERGRILL'},site_title:'HANS IM GLUCK GERMAN BURGERGRILL',forcewww:'YES',site_title_with_separator:' | HANS IM GLUCK GERMAN BURGERGRILL',home_meta_title:"HANS IM GLUCK GERMAN BURGERGRILL",bgimage:'/img/ninjaprocmn/hansimgluck/body_bg.jpg'},"www.tasteofbiriyani.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"4C2828D1-54B1-4957-AF53-B2BEF0A19E41",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Taste of Biriyani',stripeImage:"https://www.tasteofbiriyani.com/img/ninjaprocmn/tasteofbiriyani/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'tasteofbiriyani',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.tasteofbiriyani.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.tasteofbiriyani.com/#/',fbImage:'https://www.tasteofbiriyani.com/img/tasteofbiriyani/logo.png',fbTitle:'Taste of Biriyani',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.tasteofbiriyani.com/'},/* Twitter  */tw:{twURL:'https://www.tasteofbiriyani.com/#/',twTitile:'Taste of Biriyani',twvia:'Taste of Biriyani'},/* google Plus data   */gp:{gpURL:'https://www.tasteofbiriyani.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.tasteofbiriyani.com/#/',waSeparator:'Taste of Biriyani'},site_title:'Taste of Biriyani',forcewww:'YES',site_title_with_separator:' | Taste of Biriyani',home_meta_title:"Taste of Biriyani",bgimage:'/img/ninjaprocmn/tasteofbiriyani/body_bg.jpg'},"order.juewei.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F0A5CE81-2070-4A4A-A74D-D57968FFDB3C",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'JUEWEI',stripeImage:"https://order.juewei.com.sg/img/ninjaprocmn/juweiadmin/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'juweiadmin',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.juewei.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.juewei.com.sg/#/',fbImage:'https://order.juewei.com.sg/img/juweiadmin/logo.png',fbTitle:'JUEWEI',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.juewei.com.sg/'},/* Twitter  */tw:{twURL:'https://order.juewei.com.sg/#/',twTitile:'JUEWEI',twvia:'JUEWEI'},/* google Plus data   */gp:{gpURL:'https://order.juewei.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.juewei.com.sg/#/',waSeparator:'JUEWEI'},site_title:'JUEWEI',site_title_with_separator:' | JUEWEI',home_meta_title:"JUEWEI",bgimage:'/img/ninjaprocmn/juweiadmin/body_bg.jpg'},"order.fuelbeast.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"6067687F-3151-4F7A-920C-B4C51DEC29C1",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Fuel Beast',stripeImage:"https://order.fuelbeast.com.sg/img/ninjaprocmn/fuelbeast/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'fuelbeast',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.fuelbeast.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.fuelbeast.com.sg/#/',fbImage:'https://order.fuelbeast.com.sg/img/fuelbeast/logo.png',fbTitle:'Fuel Beast',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.fuelbeast.com.sg/'},/* Twitter  */tw:{twURL:'https://order.fuelbeast.com.sg/#/',twTitile:'Fuel Beast',twvia:'Fuel Beast'},/* google Plus data   */gp:{gpURL:'https://order.fuelbeast.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.fuelbeast.com.sg/#/',waSeparator:'Fuel Beast'},site_title:'Fuel Beast',forcewww:'YES',site_title_with_separator:' | Fuel Beast',home_meta_title:"Fuel Beast",bgimage:'/img/ninjaprocmn/fuelbeast/body_bg.jpg'},"gourmetpantry.amclub.org.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"B93EC9A9-1A67-4EBA-ADB7-BC7C14FA88A4",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Gourmet Pantry',stripeImage:"https://gourmetpantry.amclub.org.sg/img/ninjaprocmn/gourmet/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'gourmet',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://gourmetpantry.amclub.org.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://gourmetpantry.amclub.org.sg/#/',fbImage:'https://gourmetpantry.amclub.org.sg/img/gourmet/logo.png',fbTitle:'Gourmet Pantry',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://gourmetpantry.amclub.org.sg/'},/* Twitter  */tw:{twURL:'https://gourmetpantry.amclub.org.sg/#/',twTitile:'Gourmet Pantry',twvia:'Gourmet Pantry'},/* google Plus data   */gp:{gpURL:'https://gourmetpantry.amclub.org.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://gourmetpantry.amclub.org.sg/#/',waSeparator:'Gourmet Pantry'},site_title:'Gourmet Pantry',site_title_with_separator:' | Gourmet Pantry',home_meta_title:"Gourmet Pantry",bgimage:'/img/ninjaprocmn/gourmet/body_bg.jpg'},"www.mumbaidelights.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F2A38D8E-892E-4ABD-9543-0961F528F0CA",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Mumbai Delights',stripeImage:"https://www.mumbaidelights.com/img/ninjaprocmn/mumbaidelights/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'mumbaidelights',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.mumbaidelights.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.mumbaidelights.com/#/',fbImage:'https://www.mumbaidelights.com/img/mumbaidelights/logo.png',fbTitle:'Mumbai Delights',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.mumbaidelights.com/'},/* Twitter  */tw:{twURL:'https://www.mumbaidelights.com/#/',twTitile:'Mumbai Delights',twvia:'Mumbai Delights'},/* google Plus data   */gp:{gpURL:'https://www.mumbaidelights.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.mumbaidelights.com/#/',waSeparator:'Mumbai Delights'},site_title:'Mumbai Delights',forcewww:'YES',site_title_with_separator:' | Mumbai Delights',home_meta_title:"Mumbai Delights",bgimage:'/img/ninjaprocmn/mumbaidelights/body_bg.jpg'},"order.homeofseafood.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F6580CC4-91DA-4AEF-BD83-AE545869A774",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Home Of Seafood',stripeImage:"https://order.homeofseafood.com/img/ninjaprocmn/homeofseafood/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'homeofseafood',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.homeofseafood.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.homeofseafood.com/#/',fbImage:'https://order.homeofseafood.com/img/homeofseafood/logo.png',fbTitle:'Home Of Seafood',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.homeofseafood.com/'},/* Twitter  */tw:{twURL:'https://order.homeofseafood.com/#/',twTitile:'Home Of Seafood',twvia:'Home Of Seafood'},/* google Plus data   */gp:{gpURL:'https://order.homeofseafood.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.homeofseafood.com/#/',waSeparator:'Home Of Seafood'},site_title:'Home Of Seafood',site_title_with_separator:' | Home Of Seafood',home_meta_title:"Home Of Seafood",bgimage:'/img/ninjaprocmn/homeofseafood/body_bg.jpg'},"order.keefthebeef.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"88E232C9-8943-4042-B4D4-3413E394007B",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Keef The Beef',stripeImage:"https://order.keefthebeef.com/img/ninjaprocmn/keefthebeef/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'keefthebeef',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.keefthebeef.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.keefthebeef.com/#/',fbImage:'https://order.keefthebeef.com/img/keefthebeef/logo.png',fbTitle:'Keef The Beef',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.keefthebeef.com/'},/* Twitter  */tw:{twURL:'https://order.keefthebeef.com/#/',twTitile:'Keef The Beef',twvia:'Keef The Beef'},/* google Plus data   */gp:{gpURL:'https://order.keefthebeef.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.keefthebeef.com/#/',waSeparator:'Keef The Beef'},site_title:'Keef The Beef',site_title_with_separator:' | Keef The Beef',home_meta_title:"Keef The Beef",bgimage:'/img/ninjaprocmn/keefthebeef/body_bg.jpg'},"order.randyindulgence.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"86DF58AF-FF24-4F28-AFA1-A0440F2B352F",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Randy Indulgence',stripeImage:"https://order.randyindulgence.com/img/ninjaprocmn/randyindulgence/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'randyindulgence',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.randyindulgence.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.randyindulgence.com/#/',fbImage:'https://order.randyindulgence.com/img/randyindulgence/logo.png',fbTitle:'Randy Indulgence',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.randyindulgence.com/'},/* Twitter  */tw:{twURL:'https://order.randyindulgence.com/#/',twTitile:'Randy Indulgence',twvia:'Randy Indulgence'},/* google Plus data   */gp:{gpURL:'https://order.randyindulgence.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.randyindulgence.com/#/',waSeparator:'Randy Indulgence'},site_title:'Randy Indulgence',site_title_with_separator:' | Randy Indulgence',home_meta_title:"Randy Indulgence",bgimage:'/img/ninjaprocmn/randyindulgence/body_bg.jpg'},"order.xiyanseafood.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"57D53B2C-83D6-41E2-A819-A7E9286B548A",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Xiyan Sea Food',stripeImage:"https://order.xiyanseafood.com/img/ninjaprocmn/xiyanseafood/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'xiyanseafood',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.xiyanseafood.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.xiyanseafood.com/#/',fbImage:'https://order.xiyanseafood.com/img/xiyanseafood/logo.png',fbTitle:'Xiyan Sea Food',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.xiyanseafood.com/'},/* Twitter  */tw:{twURL:'https://order.xiyanseafood.com/#/',twTitile:'Xiyan Sea Food',twvia:'Xiyan Sea Food'},/* google Plus data   */gp:{gpURL:'https://order.xiyanseafood.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.xiyanseafood.com/#/',waSeparator:'Xiyan Sea Food'},site_title:'Xiyan Sea Food',site_title_with_separator:' | Xiyan Sea Food',home_meta_title:"Xiyan Sea Food",bgimage:'/img/ninjaprocmn/xiyanseafood/body_bg.jpg'},"order.pennyuniversitysg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"709477D0-BC39-4F2B-BC2D-9FB4E71D5FEC",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Flat White',stripeImage:"https://order.pennyuniversitysg.com/img/ninjaprocmn/flatwhite/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'flatwhite',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.pennyuniversitysg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.pennyuniversitysg.com/#/',fbImage:'https://order.pennyuniversitysg.com/img/flatwhite/logo.png',fbTitle:'Flat White',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.pennyuniversitysg.com/'},/* Twitter  */tw:{twURL:'https://order.pennyuniversitysg.com/#/',twTitile:'Flat White',twvia:'Flat White'},/* google Plus data   */gp:{gpURL:'https://order.pennyuniversitysg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.pennyuniversitysg.com/#/',waSeparator:'Flat White'},site_title:'Flat White',site_title_with_separator:' | Flat White',home_meta_title:"Flat White",bgimage:'/img/ninjaprocmn/flatwhite/body_bg.jpg'},"order.wangdaebakbbq.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"0F2CF5CD-8291-4A87-86AE-537BE58D4739",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Wang Dae Bak Pocha BBQ',stripeImage:"https://order.wangdaebakbbq.sg/img/ninjaprocmn/wangdaebak/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'wangdaebak',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.wangdaebakbbq.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.wangdaebakbbq.sg/#/',fbImage:'https://order.wangdaebakbbq.sg/img/wangdaebak/logo.png',fbTitle:'Wang Dae Bak Pocha BBQ',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.wangdaebakbbq.sg/'},/* Twitter  */tw:{twURL:'https://order.wangdaebakbbq.sg/#/',twTitile:'Wang Dae Bak Pocha BBQ',twvia:'Wang Dae Bak Pocha BBQ'},/* google Plus data   */gp:{gpURL:'https://order.wangdaebakbbq.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.wangdaebakbbq.sg/#/',waSeparator:'Wang Dae Bak Pocha BBQ'},site_title:'Wang Dae Bak Pocha BBQ',site_title_with_separator:' | Wang Dae Bak Pocha BBQ',home_meta_title:"Wang Dae Bak Pocha BBQ",bgimage:'/img/ninjaprocmn/wangdaebak/body_bg.jpg'},"order.getthislive.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"EDEE0B9B-353B-476C-9ECE-2881D11AA2B7",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Get This Live',stripeImage:"https://order.getthislive.com/img/ninjaprocmn/getthislive/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'getthislive',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.getthislive.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.getthislive.com/#/',fbImage:'https://order.getthislive.com/img/getthislive/logo.png',fbTitle:'Get This Live',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.getthislive.com/'},/* Twitter  */tw:{twURL:'https://order.getthislive.com/#/',twTitile:'Get This Live',twvia:'Get This Live'},/* google Plus data   */gp:{gpURL:'https://order.getthislive.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.getthislive.com/#/',waSeparator:'Get This Live'},site_title:'Get This Live',site_title_with_separator:' | Get This Live',home_meta_title:"Get This Live",bgimage:'/img/ninjaprocmn/getthislive/body_bg.jpg'},"www.easternhouseofseafood.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"06283C83-FD4F-4E71-8012-840420DF0556",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Eastern House of Seafood',stripeImage:"https://www.easternhouseofseafood.com/img/ninjaprocmn/easternhouse/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'easternhouse',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.easternhouseofseafood.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.easternhouseofseafood.com/#/',fbImage:'https://www.easternhouseofseafood.com/img/easternhouse/logo.png',fbTitle:'Eastern House of Seafood',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.easternhouseofseafood.com/'},/* Twitter  */tw:{twURL:'https://www.easternhouseofseafood.com/#/',twTitile:'Eastern House of Seafood',twvia:'Eastern House of Seafood'},/* google Plus data   */gp:{gpURL:'https://www.easternhouseofseafood.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.easternhouseofseafood.com/#/',waSeparator:'Eastern House of Seafood'},site_title:'Eastern House of Seafood',forcewww:'YES',site_title_with_separator:' | Eastern House of Seafood',home_meta_title:"Eastern House of Seafood",bgimage:'/img/ninjaprocmn/easternhouse/body_bg.jpg'},"www.suthascafe.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"B8817E3D-1D19-4858-A0C5-565F4519B477",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Suthas Cafe',stripeImage:"https://www.suthascafe.com/img/ninjaprocmn/suthascafe/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'suthascafe',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.suthascafe.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.suthascafe.com/#/',fbImage:'https://www.suthascafe.com/img/suthascafe/logo.png',fbTitle:'Suthas Cafe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.suthascafe.com/'},/* Twitter  */tw:{twURL:'https://www.suthascafe.com/#/',twTitile:'Suthas Cafe',twvia:'Suthas Cafe'},/* google Plus data   */gp:{gpURL:'https://www.suthascafe.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.suthascafe.com/#/',waSeparator:'Suthas Cafe'},site_title:'Suthas Cafe',forcewww:'YES',site_title_with_separator:' | Suthas Cafe',home_meta_title:"Suthas Cafe",bgimage:'/img/ninjaprocmn/suthascafe/body_bg.jpg'},"www.happycupfamily.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E2698A9B-672C-4232-9A0C-27BBC329E7C2",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Happy Cup Family',stripeImage:"https://www.happycupfamily.com/img/ninjaprocmn/happycup/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'happycup',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.happycupfamily.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.happycupfamily.com/#/',fbImage:'https://www.happycupfamily.com/img/happycup/logo.png',fbTitle:'Happy Cup Family',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.happycupfamily.com/'},/* Twitter  */tw:{twURL:'https://www.happycupfamily.com/#/',twTitile:'Happy Cup Family',twvia:'Happy Cup Family'},/* google Plus data   */gp:{gpURL:'https://www.happycupfamily.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.happycupfamily.com/#/',waSeparator:'Happy Cup Family'},site_title:'Happy Cup Family',forcewww:'YES',site_title_with_separator:' | Happy Cup Family',home_meta_title:"Happy Cup Family",bgimage:'/img/ninjaprocmn/happycup/body_bg.jpg'},"order.ikki.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"B74440B9-2129-4C91-A578-A02C646C5157",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'IKKI IZAKAYA',stripeImage:"https://order.ikki.com.sg/img/ninjaprocmn/la-cantina/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'la-cantina',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.ikki.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.ikki.com.sg/#/',fbImage:'https://order.ikki.com.sg/img/la-cantina/logo.png',fbTitle:'IKKI IZAKAYA',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.ikki.com.sg/'},/* Twitter  */tw:{twURL:'https://order.ikki.com.sg/#/',twTitile:'IKKI IZAKAYA',twvia:'IKKI IZAKAYA'},/* google Plus data   */gp:{gpURL:'https://order.ikki.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.ikki.com.sg/#/',waSeparator:'IKKI IZAKAYA'},site_title:'IKKI IZAKAYA',site_title_with_separator:' | IKKI IZAKAYA',home_meta_title:"IKKI IZAKAYA",bgimage:'/img/ninjaprocmn/la-cantina/body_bg.jpg'},"order.rollieolie.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F557E2F0-6A9D-4B1F-B772-E4830505384B",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Rollie Olie',stripeImage:"https://order.rollieolie.com/img/ninjaprocmn/rollieolie/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'rollieolie',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.rollieolie.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.rollieolie.com/#/',fbImage:'https://order.rollieolie.com/img/rollieolie/logo.png',fbTitle:'Rollie Olie',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.rollieolie.com/'},/* Twitter  */tw:{twURL:'https://order.rollieolie.com/#/',twTitile:'Rollie Olie',twvia:'Rollie Olie'},/* google Plus data   */gp:{gpURL:'https://order.rollieolie.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.rollieolie.com/#/',waSeparator:'Rollie Olie'},site_title:'Rollie Olie',site_title_with_separator:' | Rollie Olie',home_meta_title:"Rollie Olie",bgimage:'/img/ninjaprocmn/rollieolie/body_bg.jpg'},"www.timikacuisine.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"78106897-0612-45BB-8592-A65EBC7DCD6B",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Timika Cuisine ',stripeImage:"https://www.timikacuisine.com/img/ninjaprocmn/timikacuisine/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'timikacuisine',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.timikacuisine.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.timikacuisine.com/#/',fbImage:'https://www.timikacuisine.com/img/timikacuisine/logo.png',fbTitle:'Timika Cuisine ',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.timikacuisine.com/'},/* Twitter  */tw:{twURL:'https://www.timikacuisine.com/#/',twTitile:'Timika Cuisine ',twvia:'Timika Cuisine '},/* google Plus data   */gp:{gpURL:'https://www.timikacuisine.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.timikacuisine.com/#/',waSeparator:'Timika Cuisine '},site_title:'Timika Cuisine ',forcewww:'YES',site_title_with_separator:' | Timika Cuisine ',home_meta_title:"Timika Cuisine ",bgimage:'/img/ninjaprocmn/timikacuisine/body_bg.jpg'},"www.kingoflobster.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"38AA0470-F298-4E72-8955-B98A0AEAB6DA",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'King of Lobster',stripeImage:"https://www.kingoflobster.com.sg/img/ninjaprocmn/kingoflobster/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'kingoflobster',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.kingoflobster.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.kingoflobster.com.sg/#/',fbImage:'https://www.kingoflobster.com.sg/img/kingoflobster/logo.png',fbTitle:'King of Lobster',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.kingoflobster.com.sg/'},/* Twitter  */tw:{twURL:'https://www.kingoflobster.com.sg/#/',twTitile:'King of Lobster',twvia:'King of Lobster'},/* google Plus data   */gp:{gpURL:'https://www.kingoflobster.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://www.kingoflobster.com.sg/#/',waSeparator:'King of Lobster'},site_title:'King of Lobster',forcewww:'YES',site_title_with_separator:' | King of Lobster',home_meta_title:"King of Lobster",bgimage:'/img/ninjaprocmn/kingoflobster/body_bg.jpg'},"www.icgchickenandburger.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"87E64237-E8D7-4CB6-ADC0-3E124D858641",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'ICG Chicken & Burger',stripeImage:"https://www.icgchickenandburger.com/img/ninjaprocmn/icgchicken/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'icgchicken',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.icgchickenandburger.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.icgchickenandburger.com/#/',fbImage:'https://www.icgchickenandburger.com/img/icgchicken/logo.png',fbTitle:'ICG Chicken & Burger',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.icgchickenandburger.com/'},/* Twitter  */tw:{twURL:'https://www.icgchickenandburger.com/#/',twTitile:'ICG Chicken & Burger',twvia:'ICG Chicken & Burger'},/* google Plus data   */gp:{gpURL:'https://www.icgchickenandburger.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.icgchickenandburger.com/#/',waSeparator:'ICG Chicken & Burger'},site_title:'ICG Chicken & Burger',forcewww:'YES',site_title_with_separator:' | ICG Chicken & Burger',home_meta_title:"ICG Chicken & Burger",bgimage:'/img/ninjaprocmn/icgchicken/body_bg.jpg'},"www.janggutlaksa.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"1DAE4692-4358-4CBC-B534-B95BB017C706",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Janggut Laksa',stripeImage:"https://www.janggutlaksa.com/img/ninjaprocmn/janggutlaksa/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'janggutlaksa',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.janggutlaksa.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.janggutlaksa.com/#/',fbImage:'https://www.janggutlaksa.com/img/janggutlaksa/logo.png',fbTitle:'Janggut Laksa',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.janggutlaksa.com/'},/* Twitter  */tw:{twURL:'https://www.janggutlaksa.com/#/',twTitile:'Janggut Laksa',twvia:'Janggut Laksa'},/* google Plus data   */gp:{gpURL:'https://www.janggutlaksa.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.janggutlaksa.com/#/',waSeparator:'Janggut Laksa'},site_title:'Janggut Laksa',forcewww:'YES',site_title_with_separator:' | Janggut Laksa',home_meta_title:"Janggut Laksa",bgimage:'/img/ninjaprocmn/janggutlaksa/body_bg.jpg'},"www.petracafe95.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F10D730F-A3B1-4F02-A116-3EDAD9524A04",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Petra Cafe',stripeImage:"https://www.petracafe95.com/img/ninjaprocmn/petracafe/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'petracafe',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.petracafe95.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.petracafe95.com/#/',fbImage:'https://www.petracafe95.com/img/petracafe/logo.png',fbTitle:'Petra Cafe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.petracafe95.com/'},/* Twitter  */tw:{twURL:'https://www.petracafe95.com/#/',twTitile:'Petra Cafe',twvia:'Petra Cafe'},/* google Plus data   */gp:{gpURL:'https://www.petracafe95.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.petracafe95.com/#/',waSeparator:'Petra Cafe'},site_title:'Petra Cafe',forcewww:'YES',site_title_with_separator:' | Petra Cafe',home_meta_title:"Petra Cafe",bgimage:'/img/ninjaprocmn/petracafe/body_bg.jpg'},"order.jinglongseafood.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"9DA31D19-0099-4D2C-8DF8-7F8B916CA536",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Jing Long Seafood Restaurant',stripeImage:"https://order.jinglongseafood.com.sg/img/ninjaprocmn/jinglongseafood/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'jinglongseafood',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.jinglongseafood.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.jinglongseafood.com.sg/#/',fbImage:'https://order.jinglongseafood.com.sg/img/jinglongseafood/logo.png',fbTitle:'Jing Long Seafood Restaurant',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.jinglongseafood.com.sg/'},/* Twitter  */tw:{twURL:'https://order.jinglongseafood.com.sg/#/',twTitile:'Jing Long Seafood Restaurant',twvia:'Jing Long Seafood Restaurant'},/* google Plus data   */gp:{gpURL:'https://order.jinglongseafood.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.jinglongseafood.com.sg/#/',waSeparator:'Jing Long Seafood Restaurant'},site_title:'Jing Long Seafood Restaurant',site_title_with_separator:' | Jing Long Seafood Restaurant',home_meta_title:"Jing Long Seafood Restaurant",bgimage:'/img/ninjaprocmn/jinglongseafood/body_bg.jpg'},"order.dbestfishing.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E8BB11AB-FD8A-4CB3-A5C0-71F90C9CAA42",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'D Best Recreation',stripeImage:"https://order.dbestfishing.com.sg/img/ninjaprocmn/dbestone/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'dbestone',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.dbestfishing.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.dbestfishing.com.sg/#/',fbImage:'https://order.dbestfishing.com.sg/img/dbestone/logo.png',fbTitle:'D Best Recreation',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.dbestfishing.com.sg/'},/* Twitter  */tw:{twURL:'https://order.dbestfishing.com.sg/#/',twTitile:'D Best Recreation',twvia:'D Best Recreation'},/* google Plus data   */gp:{gpURL:'https://order.dbestfishing.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.dbestfishing.com.sg/#/',waSeparator:'D Best Recreation'},site_title:'D Best Recreation',site_title_with_separator:' | D Best Recreation',home_meta_title:"D Best Recreation",bgimage:'/img/ninjaprocmn/dbestone/body_bg.jpg'},"order.char.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"205A3AF1-7155-4D04-9424-F4F524473EFC",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'charadmin',stripeImage:"https://order.char.com.sg/img/ninjaprocmn/charadmin/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'charadmin',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.char.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.char.com.sg/#/',fbImage:'https://order.char.com.sg/img/charadmin/logo.png',fbTitle:'Char',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.char.com.sg/'},/* Twitter  */tw:{twURL:'https://order.char.com.sg/#/',twTitile:'Char',twvia:'Char'},/* google Plus data   */gp:{gpURL:'https://order.char.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.char.com.sg/#/',waSeparator:'Char'},site_title:'Char',site_title_with_separator:' | Char',home_meta_title:"Char",bgimage:'/img/ninjaprocmn/charadmin/body_bg.jpg'},"shop.onefiftypeel.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"C655A75D-2E68-4E31-BCE1-58F533E0D1A7",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'One Fifty Peel',stripeImage:"https://shop.onefiftypeel.com/img/ninjaprocmn/onefiftypeel/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'onefiftypeel',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://shop.onefiftypeel.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://shop.onefiftypeel.com/#/',fbImage:'https://shop.onefiftypeel.com/img/onefiftypeel/logo.png',fbTitle:'One Fifty Peel',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://shop.onefiftypeel.com/'},/* Twitter  */tw:{twURL:'https://shop.onefiftypeel.com/#/',twTitile:'One Fifty Peel',twvia:'One Fifty Peel'},/* google Plus data   */gp:{gpURL:'https://shop.onefiftypeel.com/#/'},/* Whatsapp data   */wa:{waURL:'https://shop.onefiftypeel.com/#/',waSeparator:'One Fifty Peel'},site_title:'One Fifty Peel',site_title_with_separator:' | One Fifty Peel',home_meta_title:"One Fifty Peel",bgimage:'/img/ninjaprocmn/onefiftypeel/body_bg.jpg'},"order.gotluckcafe.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"BD919956-9E02-4CB9-831F-D5450F51F4B4",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Got Luck Cafe',stripeImage:"https://order.gotluckcafe.sg/img/ninjaprocmn/gotluckcafe/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'gotluckcafe',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.gotluckcafe.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.gotluckcafe.sg/#/',fbImage:'https://order.gotluckcafe.sg/img/gotluckcafe/logo.png',fbTitle:'Got Luck Cafe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.gotluckcafe.sg/'},/* Twitter  */tw:{twURL:'https://order.gotluckcafe.sg/#/',twTitile:'Got Luck Cafe',twvia:'Got Luck Cafe'},/* google Plus data   */gp:{gpURL:'https://order.gotluckcafe.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.gotluckcafe.sg/#/',waSeparator:'Got Luck Cafe'},site_title:'Got Luck Cafe',site_title_with_separator:' | Got Luck Cafe',home_meta_title:"Got Luck Cafe",bgimage:'/img/ninjaprocmn/gotluckcafe/body_bg.jpg'},"prodemo.ninjapro.co":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"6023698C-B0E7-4F2F-9DEA-76E9686D8D76",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'prodemo',stripeImage:"https://prodemo.ninjapro.co/img/ninjaprocmn/prodemo/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'prodemo',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://prodemo.ninjapro.co/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://prodemo.ninjapro.co/#/',fbImage:'https://prodemo.ninjapro.co/img/prodemo/logo.png',fbTitle:'prodemo',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://prodemo.ninjapro.co/'},/* Twitter  */tw:{twURL:'https://prodemo.ninjapro.co/#/',twTitile:'prodemo',twvia:'prodemo'},/* google Plus data   */gp:{gpURL:'https://prodemo.ninjapro.co/#/'},/* Whatsapp data   */wa:{waURL:'https://prodemo.ninjapro.co/#/',waSeparator:'prodemo'},site_title:'prodemo',site_title_with_separator:' | prodemo',home_meta_title:"prodemo",bgimage:'/img/ninjaprocmn/prodemo/body_bg.jpg'},"www.wheatsoba.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E31DCFC8-6685-4F30-A70A-6BF4CF21FB0E",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'WHEAT BAUMKUCHEN',stripeImage:"https://www.wheatsoba.com/img/ninjaprocmn/wheatsoba/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'wheatsoba',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.wheatsoba.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.wheatsoba.com/#/',fbImage:'https://www.wheatsoba.com/img/wheatsoba/logo.png',fbTitle:'WHEAT BAUMKUCHEN',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.wheatsoba.com/'},/* Twitter  */tw:{twURL:'https://www.wheatsoba.com/#/',twTitile:'WHEAT BAUMKUCHEN',twvia:'WHEAT BAUMKUCHEN'},/* google Plus data   */gp:{gpURL:'https://www.wheatsoba.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.wheatsoba.com/#/',waSeparator:'WHEAT BAUMKUCHEN'},site_title:'WHEAT BAUMKUCHEN',forcewww:'YES',site_title_with_separator:' | WHEAT BAUMKUCHEN',home_meta_title:"WHEAT BAUMKUCHEN",bgimage:'/img/ninjaprocmn/wheatsoba/body_bg.jpg'},"order.thefoodbarn.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"2A7F12CD-E994-40C3-9F5C-A4C3A4FECDFE",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'The FoodBarn',stripeImage:"https://order.thefoodbarn.com.sg/img/ninjaprocmn/foodbarn/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'foodbarn',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.thefoodbarn.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.thefoodbarn.com.sg/#/',fbImage:'https://order.thefoodbarn.com.sg/img/foodbarn/logo.png',fbTitle:'The FoodBarn',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.thefoodbarn.com.sg/'},/* Twitter  */tw:{twURL:'https://order.thefoodbarn.com.sg/#/',twTitile:'The FoodBarn',twvia:'The FoodBarn'},/* google Plus data   */gp:{gpURL:'https://order.thefoodbarn.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.thefoodbarn.com.sg/#/',waSeparator:'The FoodBarn'},site_title:'The FoodBarn',site_title_with_separator:' | The FoodBarn',home_meta_title:"The FoodBarn",bgimage:'/img/ninjaprocmn/foodbarn/body_bg.jpg'},"order.winehours.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"51362470-0A08-4A56-AD2C-7F815EC9A90C",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Wine Hours',stripeImage:"https://order.winehours.com/img/ninjaprocmn/winehours/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'winehours',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.winehours.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.winehours.com/#/',fbImage:'https://order.winehours.com/img/winehours/logo.png',fbTitle:'Wine Hours',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.winehours.com/'},/* Twitter  */tw:{twURL:'https://order.winehours.com/#/',twTitile:'Wine Hours',twvia:'Wine Hours'},/* google Plus data   */gp:{gpURL:'https://order.winehours.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.winehours.com/#/',waSeparator:'Wine Hours'},site_title:'Wine Hours',site_title_with_separator:' | Wine Hours',home_meta_title:"Wine Hours",bgimage:'/img/ninjaprocmn/winehours/body_bg.jpg'},"order.kinhoi.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"4EDE9A25-89AA-4200-848D-AC4A5A54B7BC",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'KIN HOI',stripeImage:"https://order.kinhoi.sg/img/ninjaprocmn/kinhoi/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'kinhoi',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.kinhoi.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.kinhoi.sg/#/',fbImage:'https://order.kinhoi.sg/img/kinhoi/logo.png',fbTitle:'KIN HOI',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.kinhoi.sg/'},/* Twitter  */tw:{twURL:'https://order.kinhoi.sg/#/',twTitile:'KIN HOI',twvia:'KIN HOI'},/* google Plus data   */gp:{gpURL:'https://order.kinhoi.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.kinhoi.sg/#/',waSeparator:'KIN HOI'},site_title:'KIN HOI',site_title_with_separator:' | KIN HOI',home_meta_title:"KIN HOI",bgimage:'/img/ninjaprocmn/kinhoi/body_bg.jpg'},"order.thetiramisuhero.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F45D6DB1-0D27-4E28-BF95-C5EBBE9B3DB4",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'The Tiramisu Hero',stripeImage:"https://order.thetiramisuhero.com/img/ninjaprocmn/tiramisu/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'tiramisu',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.thetiramisuhero.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.thetiramisuhero.com/#/',fbImage:'https://order.thetiramisuhero.com/img/tiramisu/logo.png',fbTitle:'The Tiramisu Hero',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.thetiramisuhero.com/'},/* Twitter  */tw:{twURL:'https://order.thetiramisuhero.com/#/',twTitile:'The Tiramisu Hero',twvia:'The Tiramisu Hero'},/* google Plus data   */gp:{gpURL:'https://order.thetiramisuhero.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.thetiramisuhero.com/#/',waSeparator:'The Tiramisu Hero'},site_title:'The Tiramisu Hero',site_title_with_separator:' | The Tiramisu Hero',home_meta_title:"The Tiramisu Hero",bgimage:'/img/ninjaprocmn/tiramisu/body_bg.jpg'},"www.f1rstgrillgastro.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E4C204F7-67A3-4EDF-BD5F-199AAB36481D",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'F1rstgrill Gastronomic',stripeImage:"https://www.f1rstgrillgastro.com/img/ninjaprocmn/f1rstgrill/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'f1rstgrill',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.f1rstgrillgastro.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.f1rstgrillgastro.com/#/',fbImage:'https://www.f1rstgrillgastro.com/img/f1rstgrill/logo.png',fbTitle:'F1rstgrill Gastronomic',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.f1rstgrillgastro.com/'},/* Twitter  */tw:{twURL:'https://www.f1rstgrillgastro.com/#/',twTitile:'F1rstgrill Gastronomic',twvia:'F1rstgrill Gastronomic'},/* google Plus data   */gp:{gpURL:'https://www.f1rstgrillgastro.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.f1rstgrillgastro.com/#/',waSeparator:'F1rstgrill Gastronomic'},site_title:'F1rstgrill Gastronomic',forcewww:'YES',site_title_with_separator:' | F1rstgrill Gastronomic',home_meta_title:"F1rstgrill Gastronomic",bgimage:'/img/ninjaprocmn/f1rstgrill/body_bg.jpg'},"order.indiantandoor.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"9E19E513-F3D0-48BB-8D35-91DD424D2E26",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Indian Tandoor',stripeImage:"https://order.indiantandoor.com.sg/img/ninjaprocmn/indiantandoor/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'indiantandoor',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.indiantandoor.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.indiantandoor.com.sg/#/',fbImage:'https://order.indiantandoor.com.sg/img/indiantandoor/logo.png',fbTitle:'Indian Tandoor',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.indiantandoor.com.sg/'},/* Twitter  */tw:{twURL:'https://order.indiantandoor.com.sg/#/',twTitile:'Indian Tandoor',twvia:'Indian Tandoor'},/* google Plus data   */gp:{gpURL:'https://order.indiantandoor.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.indiantandoor.com.sg/#/',waSeparator:'Indian Tandoor'},site_title:'Indian Tandoor',site_title_with_separator:' | Indian Tandoor',home_meta_title:"Indian Tandoor",bgimage:'/img/ninjaprocmn/indiantandoor/body_bg.jpg'},"www.cantolicious.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"DE70C3B3-FA36-482B-AC28-8652880AF20D",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Cantolicious',stripeImage:"https://www.cantolicious.com/img/ninjaprocmn/cantolicious/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'cantolicious',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.cantolicious.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.cantolicious.com/#/',fbImage:'https://www.cantolicious.com/img/cantolicious/logo.png',fbTitle:'Cantolicious',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.cantolicious.com/'},/* Twitter  */tw:{twURL:'https://www.cantolicious.com/#/',twTitile:'Cantolicious',twvia:'Cantolicious'},/* google Plus data   */gp:{gpURL:'https://www.cantolicious.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.cantolicious.com/#/',waSeparator:'Cantolicious'},site_title:'Cantolicious',forcewww:'YES',site_title_with_separator:' | Cantolicious',home_meta_title:"Cantolicious",bgimage:'/img/ninjaprocmn/cantolicious/body_bg.jpg'},"orderonline.chanung.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"6281EA4D-CE95-4AE0-9187-0DFE1BE09D79",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'CHA NUNG SG',stripeImage:"https://orderonline.chanung.com.sg/img/ninjaprocmn/chanung/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'chanung',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://orderonline.chanung.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://orderonline.chanung.com.sg/#/',fbImage:'https://orderonline.chanung.com.sg/img/chanung/logo.png',fbTitle:'CHA NUNG SG',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://orderonline.chanung.com.sg/'},/* Twitter  */tw:{twURL:'https://orderonline.chanung.com.sg/#/',twTitile:'CHA NUNG SG',twvia:'CHA NUNG SG'},/* google Plus data   */gp:{gpURL:'https://orderonline.chanung.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://orderonline.chanung.com.sg/#/',waSeparator:'CHA NUNG SG'},site_title:'Indian Tandoor',site_title_with_separator:' | CHA NUNG SG',home_meta_title:"CHA NUNG SG",bgimage:'/img/ninjaprocmn/chanung/body_bg.jpg'},"order.carraracafesg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"1FBFFCCF-921C-47F2-AC46-04B048D78132",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Carrara',stripeImage:"https://order.carraracafesg.com/img/ninjaprocmn/carrara/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'carrara',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.carraracafesg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.carraracafesg.com/#/',fbImage:'https://order.carraracafesg.com/img/carrara/logo.png',fbTitle:'Carrara',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.carraracafesg.com/'},/* Twitter  */tw:{twURL:'https://order.carraracafesg.com/#/',twTitile:'Carrara',twvia:'Carrara'},/* google Plus data   */gp:{gpURL:'https://order.carraracafesg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.carraracafesg.com/#/',waSeparator:'Carrara'},site_title:'Carrara',site_title_with_separator:' | Carrara',home_meta_title:"Carrara",bgimage:'/img/ninjaprocmn/carrara/body_bg.jpg'},"www.ordersingsweekee.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"430B7778-6299-4827-9DDF-C684E81729A5",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Sing Swee Kee',stripeImage:"https://www.ordersingsweekee.com/img/ninjaprocmn/singswee/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'singswee',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.ordersingsweekee.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.ordersingsweekee.com/#/',fbImage:'https://www.ordersingsweekee.com/img/singswee/logo.png',fbTitle:'Sing Swee Kee',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.ordersingsweekee.com/'},/* Twitter  */tw:{twURL:'https://www.ordersingsweekee.com/#/',twTitile:'Sing Swee Kee',twvia:'Sing Swee Kee'},/* google Plus data   */gp:{gpURL:'https://www.ordersingsweekee.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.ordersingsweekee.com/#/',waSeparator:'Sing Swee Kee'},site_title:'Sing Swee Kee',site_title_with_separator:' | Sing Swee Kee',home_meta_title:"Sing Swee Kee",bgimage:'/img/ninjaprocmn/singswee/body_bg.jpg'},"orderonline.soonhuat.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"3292DD26-CAEF-421D-81AF-72218513B3EE",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'SOON HUAT',stripeImage:"https://orderonline.soonhuat.sg/img/ninjaprocmn/soonhuat/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'soonhuat',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://orderonline.soonhuat.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://orderonline.soonhuat.sg/#/',fbImage:'https://orderonline.soonhuat.sg/img/soonhuat/logo.png',fbTitle:'SOON HUAT',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://orderonline.soonhuat.sg/'},/* Twitter  */tw:{twURL:'https://orderonline.soonhuat.sg/#/',twTitile:'SOON HUAT',twvia:'SOON HUAT'},/* google Plus data   */gp:{gpURL:'https://orderonline.soonhuat.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://orderonline.soonhuat.sg/#/',waSeparator:'SOON HUAT'},site_title:'SOON HUAT',site_title_with_separator:' | SOON HUAT',home_meta_title:"SOON HUAT",bgimage:'/img/ninjaprocmn/soonhuat/body_bg.jpg'},"www.sumosalad.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"27F0698D-98F8-4E34-B8D3-DC1921D53CE8",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Sumo Salad',stripeImage:"https://www.sumosalad.sg/img/ninjaprocmn/sumosalad/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'sumosalad',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.sumosalad.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.sumosalad.sg/#/',fbImage:'https://www.sumosalad.sg/img/ninjaprocmn/sumosalad/logo.png',fbTitle:'Sumo Salad',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.sumosalad.sg/'},/* Twitter  */tw:{twURL:'https://www.sumosalad.sg/#/',twTitile:'Sumo Salad',twvia:'Sumo Salad'},/* google Plus data   */gp:{gpURL:'https://www.sumosalad.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://www.sumosalad.sg/#/',waSeparator:'Sumo Salad'},site_title:'Sumo Salad',forcewww:'YES',site_title_with_separator:' | Sumo Salad',home_meta_title:"Sumo Salad",bgimage:'/img/ninjaprocmn/sumosalad/body_bg.jpg'},"www.briyani47.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F3A90347-7ABC-42D1-8685-A8170A2C6CE4",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Briyani 47',stripeImage:"https://www.briyani47.com/img/ninjaprocmn/briyani47/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'briyani47',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.briyani47.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.briyani47.com/#/',fbImage:'https://www.briyani47.com/img/briyani47/logo.png',fbTitle:'Briyani 47',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.briyani47.com/'},/* Twitter  */tw:{twURL:'https://www.briyani47.com/#/',twTitile:'Briyani 47',twvia:'Briyani 47'},/* google Plus data   */gp:{gpURL:'http://www.briyani47.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.briyani47.com/#/',waSeparator:'Briyani 47'},site_title:'Briyani 47',forcewww:'YES',site_title_with_separator:' | Briyani 47',home_meta_title:"Welcome to Briyani 47",bgimage:'/img/ninjaprocmn/briyani47/body_bg.jpg'},"order.aoi.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"4D60440C-1D4E-4E0D-8558-37BCABE899D9",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Aromas of India',stripeImage:"https://order.aoi.com.sg/img/ninjaprocmn/aromas/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'aromas',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.aoi.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.aoi.com.sg/#/',fbImage:'https://order.aoi.com.sg/img/aromas/logo.png',fbTitle:'Aromas of India',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.aoi.com.sg/'},/* Twitter  */tw:{twURL:'https://order.aoi.com.sg/#/',twTitile:'Aromas of India',twvia:'Aromas of India'},/* google Plus data   */gp:{gpURL:'http://order.aoi.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.aoi.com.sg/#/',waSeparator:'Aromas of India'},site_title:'Aromas of India',site_title_with_separator:' | Aromas of India',home_meta_title:"Welcome to Aromas of India",bgimage:'/img/ninjaprocmn/aromas/body_bg.jpg'},"www.madnest.co":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"BFC17245-A2AB-40C6-9E3C-BB7030236DCF",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'MADNEST',stripeImage:"https://www.madnest.co/img/ninjaprocmn/madnest/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'madnest',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.madnest.co/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.madnest.co/#/',fbImage:'https://www.madnest.co/img/madnest/logo.png',fbTitle:'MADNEST',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.madnest.co/'},/* Twitter  */tw:{twURL:'https://www.madnest.co/#/',twTitile:'MADNEST',twvia:'MADNEST'},/* google Plus data   */gp:{gpURL:'http://www.madnest.co/#/'},/* Whatsapp data   */wa:{waURL:'http://www.madnest.co/#/',waSeparator:'MADNEST'},site_title:'MADNEST',forcewww:'YES',site_title_with_separator:' | MADNEST',home_meta_title:"Welcome to MADNEST",bgimage:'/img/ninjaprocmn/madnest/body_bg.jpg'},"www.lovefoodclubsg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D00DFFC4-F616-4B59-9411-B0EFD359E632",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Love Food Club',stripeImage:"https://www.lovefoodclubsg.com/img/ninjaprocmn/lovefoodclub/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'lovefoodclub',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.lovefoodclubsg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.lovefoodclubsg.com/#/',fbImage:'https://www.lovefoodclubsg.com/img/lovefoodclub/logo.png',fbTitle:'Love Food Club',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.lovefoodclubsg.com/'},/* Twitter  */tw:{twURL:'https://www.lovefoodclubsg.com/#/',twTitile:'Love Food Club',twvia:'Love Food Club'},/* google Plus data   */gp:{gpURL:'http://www.lovefoodclubsg.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.lovefoodclubsg.com/#/',waSeparator:'Love Food Club'},site_title:'Love Food Club',forcewww:'YES',site_title_with_separator:' | Love Food Club',home_meta_title:"Welcome to Love Food Club",bgimage:'/img/ninjaprocmn/lovefoodclub/body_bg.jpg'},"www.alphakrust.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"043CF8B4-9CFD-4A30-B49A-E21667FEAF52",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Alphakrust',stripeImage:"https://www.alphakrust.com/img/ninjaprocmn/alphakrust/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'alphakrust',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.alphakrust.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.alphakrust.com/#/',fbImage:'https://www.alphakrust.com/img/alphakrust/logo.png',fbTitle:'Alphakrust',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.alphakrust.com/'},/* Twitter  */tw:{twURL:'https://www.alphakrust.com/#/',twTitile:'Alphakrust',twvia:'Alphakrust'},/* google Plus data   */gp:{gpURL:'http://www.alphakrust.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.alphakrust.com/#/',waSeparator:'Alphakrust'},site_title:'Alphakrust',forcewww:'YES',site_title_with_separator:' | Alphakrust',home_meta_title:"Best hot pizzas in Singapore | Alphakrust",home_meta_description:"Best affordable pizzas available in Singapore. At alphaKrust, every pizza is handcrafted with the freshest premium ingredients with no added MSG and preservatives.",home_meta_keywords:"pizzas, best pizzas, singapore pizza",bgimage:'/img/ninjaprocmn/alphakrust/body_bg.jpg'},"order.promonade.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"65829C8E-D5CE-40B9-A519-F91D10D639E4",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Promonade',stripeImage:"https://order.promonade.sg/img/ninjaprocmn/promonade/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'promonade',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.promonade.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.promonade.sg/#/',fbImage:'https://order.promonade.sg/img/promonade/logo.png',fbTitle:'Promonade',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.promonade.sg/'},/* Twitter  */tw:{twURL:'https://order.promonade.sg/#/',twTitile:'Promonade',twvia:'Promonade'},/* google Plus data   */gp:{gpURL:'http://order.promonade.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.promonade.sg/#/',waSeparator:'Promonade'},site_title:'Promonade',site_title_with_separator:' | Promonade',home_meta_title:"Welcome to Promonade",bgimage:'/img/ninjaprocmn/promonade/body_bg.jpg'},"order.houseofperanakan.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"932D4271-78D7-42C4-9BE7-F932748D2E2F",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'House of Peranakan',stripeImage:"https://order.houseofperanakan.com.sg/img/ninjaprocmn/houseofperanakan/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'houseofperanakan',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.houseofperanakan.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.houseofperanakan.com.sg/#/',fbImage:'https://order.houseofperanakan.com.sg/img/houseofperanakan/logo.png',fbTitle:'House of Peranakan',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.houseofperanakan.com.sg/'},/* Twitter  */tw:{twURL:'https://order.houseofperanakan.com.sg/#/',twTitile:'House of Peranakan',twvia:'House of Peranakan'},/* google Plus data   */gp:{gpURL:'http://order.houseofperanakan.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.houseofperanakan.com.sg/#/',waSeparator:'House of Peranakan'},site_title:'House of Peranakan',site_title_with_separator:' | House of Peranakan',home_meta_title:"Welcome to House of Peranakan",bgimage:'/img/ninjaprocmn/houseofperanakan/body_bg.jpg'},"www.shiokt.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"52D42907-CB13-4213-A6C4-D851CC3A18F8",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Shiokt',stripeImage:"https://www.shiokt.com/img/ninjaprocmn/shiokt/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'shiokt',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.shiokt.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.shiokt.com/#/',fbImage:'https://www.shiokt.com/img/shiokt/logo.png',fbTitle:'Shiokt',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.shiokt.com/'},/* Twitter  */tw:{twURL:'https://www.shiokt.com/#/',twTitile:'Shiokt',twvia:'Shiokt'},/* google Plus data   */gp:{gpURL:'http://www.shiokt.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.shiokt.com/#/',waSeparator:'Shiokt'},site_title:'Shiokt',forcewww:'YES',site_title_with_separator:' | Shiokt',home_meta_title:"Welcome to Shiokt",bgimage:'/img/ninjaprocmn/shiokt/body_bg.jpg'},"order.tigerlilypatisserie.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"70AB707E-15B3-4DC5-986C-0BCD550CF304",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Tigerlily Patisserie',stripeImage:"https://order.tigerlilypatisserie.com/img/ninjaprocmn/tigerlilypatisserie/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'tigerlilypatisserie',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.tigerlilypatisserie.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.tigerlilypatisserie.com/#/',fbImage:'https://order.tigerlilypatisserie.com/img/tigerlilypatisserie/logo.png',fbTitle:'Tigerlily Patisserie',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.tigerlilypatisserie.com/'},/* Twitter  */tw:{twURL:'https://order.tigerlilypatisserie.com/#/',twTitile:'Tigerlily Patisserie',twvia:'Tigerlily Patisserie'},/* google Plus data   */gp:{gpURL:'http://order.tigerlilypatisserie.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.tigerlilypatisserie.com/#/',waSeparator:'Tigerlily Patisserie'},site_title:'Tigerlily Patisserie',forcewww:'YES',site_title_with_separator:' | Tigerlily Patisserie',home_meta_title:"Tigerlily Patisserie",bgimage:'/img/ninjaprocmn/tigerlilypatisserie/body_bg.jpg'},"menu.straitschinese.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"06B88300-674B-47B4-B0A5-15C297B0C7E7",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Straits Chinese',stripeImage:"https://menu.straitschinese.com.sg/img/ninjaprocmn/straitschinese/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'straitschinese',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://menu.straitschinese.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://menu.straitschinese.com.sg/#/',fbImage:'https://menu.straitschinese.com.sg/img/straitschinese/logo.png',fbTitle:'Straits Chinese',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://menu.straitschinese.com.sg/'},/* Twitter  */tw:{twURL:'https://menu.straitschinese.com.sg/#/',twTitile:'Straits Chinese',twvia:'Straits Chinese'},/* google Plus data   */gp:{gpURL:'http://menu.straitschinese.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://menu.straitschinese.com.sg/#/',waSeparator:'Straits Chinese'},site_title:'Straits Chinese',forcewww:'YES',site_title_with_separator:' | Straits Chinese',home_meta_title:"Straits Chinese",bgimage:'/img/ninjaprocmn/straitschinese/body_bg.jpg'},"www.changisatay.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"894313A0-4C95-4676-A4AF-05CA42B55080",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Changi Satay',stripeImage:"https://www.changisatay.com/img/ninjaprocmn/changisatay/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'changisatay',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.changisatay.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.changisatay.com/#/',fbImage:'https://www.changisatay.com/img/changisatay/logo.png',fbTitle:'Changi Satay',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.changisatay.com/'},/* Twitter  */tw:{twURL:'https://www.changisatay.com/#/',twTitile:'Changi Satay',twvia:'Changi Satay'},/* google Plus data   */gp:{gpURL:'http://www.changisatay.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.changisatay.com/#/',waSeparator:'Changi Satay'},site_title:'Changi Satay',forcewww:'YES',site_title_with_separator:' | Changi Satay',home_meta_title:"Changi Satay",bgimage:'/img/ninjaprocmn/changisatay/body_bg.jpg'},"order.livingwholesome.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"DD9A6F53-5A85-4ED4-9E92-E693EDC68C1B",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Living Wholesome Vegetarian',stripeImage:"https://order.livingwholesome.sg/img/ninjaprocmn/livingwholesome/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'livingwholesome',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.livingwholesome.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.livingwholesome.sg/#/',fbImage:'https://order.livingwholesome.sg/img/livingwholesome/logo.png',fbTitle:'Living Wholesome Vegetarian',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.livingwholesome.sg/'},/* Twitter  */tw:{twURL:'https://order.livingwholesome.sg/#/',twTitile:'Living Wholesome Vegetarian',twvia:'Living Wholesome Vegetarian'},/* google Plus data   */gp:{gpURL:'http://order.livingwholesome.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.livingwholesome.sg/#/',waSeparator:'Living Wholesome Vegetarian'},site_title:'Living Wholesome Vegetarian',site_title_with_separator:' | Living Wholesome Vegetarian',home_meta_title:"Living Wholesome Vegetarian",bgimage:'/img/ninjaprocmn/livingwholesome/body_bg.jpg'},"www.emicakeskovan.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"AF62C48A-20E5-4994-94A7-633B06275311",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Emicakes',stripeImage:"https://www.emicakeskovan.com/img/ninjaprocmn/emicakeskovan/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'emicakeskovan',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.emicakeskovan.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.emicakeskovan.com/#/',fbImage:'https://www.emicakeskovan.com/img/emicakeskovan/logo.png',fbTitle:'Emicakes',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.emicakeskovan.com/'},/* Twitter  */tw:{twURL:'https://www.emicakeskovan.com/#/',twTitile:'Emicakes',twvia:'Emicakes'},/* google Plus data   */gp:{gpURL:'http://www.emicakeskovan.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.emicakeskovan.com/#/',waSeparator:'Emicakes'},site_title:'Emicakes',forcewww:'YES',site_title_with_separator:' | Emicakes',home_meta_title:"Emicakes",bgimage:'/img/ninjaprocmn/emicakeskovan/body_bg.jpg'},"orderonline.ayshacatering.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"5F496164-AF56-4EB9-8C2E-61D7261B4585",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'AYSHA CATERING',stripeImage:"https://orderonline.ayshacatering.com/img/ninjaprocmn/ayshacatering/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ayshacatering',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://orderonline.ayshacatering.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://orderonline.ayshacatering.com/#/',fbImage:'https://orderonline.ayshacatering.com/img/ayshacatering/logo.png',fbTitle:'AYSHA CATERING',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://orderonline.ayshacatering.com/'},/* Twitter  */tw:{twURL:'https://orderonline.ayshacatering.com/#/',twTitile:'AYSHA CATERING',twvia:'AYSHA CATERING'},/* google Plus data   */gp:{gpURL:'http://orderonline.ayshacatering.com/#/'},/* Whatsapp data   */wa:{waURL:'http://orderonline.ayshacatering.com/#/',waSeparator:'AYSHA CATERING'},site_title:'AYSHA CATERING',site_title_with_separator:' | AYSHA CATERING',home_meta_title:"AYSHA CATERING",bgimage:'/img/ninjaprocmn/ayshacatering/body_bg.jpg'},"www.santai.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F3004C88-701F-4FCD-83D2-F956DE3C8917",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'RM Santai',stripeImage:"https://www.santai.sg/img/ninjaprocmn/santai/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'santai',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.santai.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.santai.sg/#/',fbImage:'https://www.santai.sg/img/santai/logo.png',fbTitle:'RM Santai',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.santai.sg/'},/* Twitter  */tw:{twURL:'https://www.santai.sg/#/',twTitile:'RM Santai',twvia:'RM Santai'},/* google Plus data   */gp:{gpURL:'http://www.santai.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://www.santai.sg/#/',waSeparator:'RM Santai'},site_title:'RM Santai',forcewww:'YES',site_title_with_separator:' | RM Santai',home_meta_title:"RM Santai",bgimage:'/img/ninjaprocmn/santai/body_bg.jpg'},"www.deliciouslynostalgic.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"A6F9CA1B-0EF8-4749-B569-AE3A9923A219",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Deliciously Nostalgic',stripeImage:"https://www.deliciouslynostalgic.com/img/ninjaprocmn/deliciouslynostalgic/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'deliciouslynostalgic',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.deliciouslynostalgic.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.deliciouslynostalgic.com/#/',fbImage:'https://www.deliciouslynostalgic.com/img/deliciouslynostalgic/logo.png',fbTitle:'Deliciously Nostalgic',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.deliciouslynostalgic.com/'},/* Twitter  */tw:{twURL:'https://www.deliciouslynostalgic.com/#/',twTitile:'Deliciously Nostalgic',twvia:'Deliciously Nostalgic'},/* google Plus data   */gp:{gpURL:'http://www.deliciouslynostalgic.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.deliciouslynostalgic.com/#/',waSeparator:'Deliciously Nostalgic'},site_title:'Deliciously Nostalgic',forcewww:'YES',site_title_with_separator:' | Deliciously Nostalgic',home_meta_title:"Deliciously Nostalgic",bgimage:'/img/ninjaprocmn/deliciouslynostalgic/body_bg.jpg'},"www.firmanshah.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"202C9EE4-5ECE-4AAA-BC64-AEC066F17063",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Firkopi',stripeImage:"https://www.firmanshah.com/img/ninjaprocmn/firmanshah/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'firmanshah',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.firmanshah.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.firmanshah.com/#/',fbImage:'https://www.firmanshah.com/img/ninjaprocmn/firmanshah/logo.png',fbTitle:'Firkopi',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.firmanshah.com/'},/* Twitter  */tw:{twURL:'https://www.firmanshah.com/#/',twTitile:'Firkopi',twvia:'Firkopi'},/* google Plus data   */gp:{gpURL:'http://www.firmanshah.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.firmanshah.com/#/',waSeparator:'Firkopi'},site_title:'Firkopi',forcewww:'YES',site_title_with_separator:' | Firkopi',home_meta_title:"Firkopi",bgimage:'/img/ninjaprocmn/firmanshah/body_bg.jpg'},"www.littlecakebites.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"CCBE56AE-91FC-48E4-BD38-676A43669BB7",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Little Cake Bites',stripeImage:"https://www.littlecakebites.com/img/ninjaprocmn/littlecakebites/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'littlecakebites',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.littlecakebites.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.littlecakebites.com/#/',fbImage:'https://www.littlecakebites.com/img/littlecakebites/logo.png',fbTitle:'Little Cake Bites',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.littlecakebites.com/'},/* Twitter  */tw:{twURL:'https://www.littlecakebites.com/#/',twTitile:'Little Cake Bites',twvia:'Little Cake Bites'},/* google Plus data   */gp:{gpURL:'http://www.littlecakebites.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.littlecakebites.com/#/',waSeparator:'Little Cake Bites'},site_title:'Little Cake Bites',forcewww:'YES',site_title_with_separator:' | Little Cake Bites',home_meta_title:"Little Cake Bites",bgimage:'/img/ninjaprocmn/littlecakebites/body_bg.jpg'},"order.takeshisan.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"48B66ACA-7490-4645-A003-74C8AEC20BFC",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Takeshi-San',stripeImage:"https://order.takeshisan.sg/img/ninjaprocmn/takeshisan/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'takeshisan',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.takeshisan.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.takeshisan.sg/#/',fbImage:'https://order.takeshisan.sg/img/takeshisan/logo.png',fbTitle:'Takeshi-San',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.takeshisan.sg/'},/* Twitter  */tw:{twURL:'https://order.takeshisan.sg/#/',twTitile:'Takeshi-San',twvia:'Takeshi-San'},/* google Plus data   */gp:{gpURL:'http://order.takeshisan.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.takeshisan.sg/#/',waSeparator:'Takeshi-San'},site_title:'Takeshi-San',site_title_with_separator:' | Takeshi-San',home_meta_title:"Takeshi-San",bgimage:'/img/ninjaprocmn/takeshisan/body_bg.jpg'},"www.kuyaskusinangpinoy.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"C15DF7E1-5CE8-4B5F-B18D-5039DD2B5776",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Kuyas Kusinang Pinoy',stripeImage:"https://www.kuyaskusinangpinoy.com.sg/img/ninjaprocmn/kuyaskusinang/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'kuyaskusinang',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.kuyaskusinangpinoy.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.kuyaskusinangpinoy.com.sg/#/',fbImage:'https://www.kuyaskusinangpinoy.com.sg/img/kuyaskusinang/logo.png',fbTitle:'Kuyas Kusinang Pinoy',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.kuyaskusinangpinoy.com.sg/'},/* Twitter  */tw:{twURL:'https://www.kuyaskusinangpinoy.com.sg/#/',twTitile:'Kuyas Kusinang Pinoy',twvia:'Kuyas Kusinang Pinoy'},/* google Plus data   */gp:{gpURL:'http://www.kuyaskusinangpinoy.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://www.kuyaskusinangpinoy.com.sg/#/',waSeparator:'Kuyas Kusinang Pinoy'},site_title:'Kuyas Kusinang Pinoy',forcewww:'YES',site_title_with_separator:' | Kuyas Kusinang Pinoy',home_meta_title:"Kuyas Kusinang Pinoy",bgimage:'/img/ninjaprocmn/kuyaskusinang/body_bg.jpg'},"www.gomartstop.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F4AA7F6B-4814-47B4-ABDB-FC7E9EDFF3B3",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Hao Guan Minimart',stripeImage:"https://www.gomartstop.com/img/ninjaprocmn/haoguan/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'haoguan',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.gomartstop.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.gomartstop.com/#/',fbImage:'https://www.gomartstop.com/img/haoguan/logo.png',fbTitle:'Hao Guan Minimart',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.gomartstop.com/'},/* Twitter  */tw:{twURL:'https://www.gomartstop.com/#/',twTitile:'Hao Guan Minimart',twvia:'Hao Guan Minimart'},/* google Plus data   */gp:{gpURL:'http://www.gomartstop.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.gomartstop.com/#/',waSeparator:'Hao Guan Minimart'},site_title:'Hao Guan Minimart',forcewww:'YES',site_title_with_separator:' | Hao Guan Minimart',home_meta_title:"Hao Guan Minimart",bgimage:'/img/ninjaprocmn/haoguan/body_bg.jpg'},"www.familymartstop.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E44CC702-DC8A-44F0-A285-1F096D1AD817",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Family Grocermart',stripeImage:"https://www.familymartstop.com/img/ninjaprocmn/familygrocermart/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'familygrocermart',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.familymartstop.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.familymartstop.com/#/',fbImage:'https://www.familymartstop.com/img/familygrocermart/logo.png',fbTitle:'Family Grocermart',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.familymartstop.com/'},/* Twitter  */tw:{twURL:'https://www.familymartstop.com/#/',twTitile:'Family Grocermart',twvia:'Family Grocermart'},/* google Plus data   */gp:{gpURL:'http://www.familymartstop.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.familymartstop.com/#/',waSeparator:'Family Grocermart'},site_title:'Hao Guan Minimart',forcewww:'YES',site_title_with_separator:' | Family Grocermart',home_meta_title:"Family Grocermart",bgimage:'/img/ninjaprocmn/familygrocermart/body_bg.jpg'},"www.bestmartstop.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"A7064639-38AA-4A74-97E4-2EBB1FAF790D",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Best Supermart',stripeImage:"https://www.bestmartstop.com/img/ninjaprocmn/bestsupermart/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'bestsupermart',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.bestmartstop.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.bestmartstop.com/#/',fbImage:'https://www.bestmartstop.com/img/bestsupermart/logo.png',fbTitle:'Best Supermart',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.bestmartstop.com/'},/* Twitter  */tw:{twURL:'https://www.bestmartstop.com/#/',twTitile:'Best Supermart',twvia:'Best Supermart'},/* google Plus data   */gp:{gpURL:'http://www.bestmartstop.com/#/'},/* Whatsapp data   */wa:{waURL:'http://www.bestmartstop.com/#/',waSeparator:'Best Supermart'},site_title:'Best Supermart',forcewww:'YES',site_title_with_separator:' | Best Supermart',home_meta_title:"Best Supermart",bgimage:'/img/ninjaprocmn/bestsupermart/body_bg.jpg'},"orderonline.westlake.com.sg - moved to enterprise":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"627EBD75-9DCE-48B2-B4C5-88E71A9B49C7",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Westlake',stripeImage:"https://orderonline.westlake.com.sg/img/ninjaprocmn/westlake/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'westlake',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://orderonline.westlake.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://orderonline.westlake.com.sg/#/',fbImage:'https://orderonline.westlake.com.sg/img/westlake/logo.png',fbTitle:'Westlake',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://orderonline.westlake.com.sg/'},/* Twitter  */tw:{twURL:'https://orderonline.westlake.com.sg/#/',twTitile:'Westlake',twvia:'Westlake'},/* google Plus data   */gp:{gpURL:'http://orderonline.westlake.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://orderonline.westlake.com.sg/#/',waSeparator:'Westlake'},site_title:'Westlake',site_title_with_separator:' | Westlake',home_meta_title:"Westlake",bgimage:'/img/ninjaprocmn/westlake/body_bg.jpg'},"order.yoonstraditionalteochewkueh.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"6FB06618-7D23-49B1-BD10-D12DB8488A1A",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Yoons Holdings',stripeImage:"https://order.yoonstraditionalteochewkueh.com.sg/img/ninjaprocmn/yoons/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'yoons',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.yoonstraditionalteochewkueh.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.yoonstraditionalteochewkueh.com.sg/#/',fbImage:'https://order.yoonstraditionalteochewkueh.com.sg/img/yoons/logo.png',fbTitle:'Yoons Holdings',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.yoonstraditionalteochewkueh.com.sg/'},/* Twitter  */tw:{twURL:'https://order.yoonstraditionalteochewkueh.com.sg/#/',twTitile:'Yoons Holdings',twvia:'Yoons Holdings'},/* google Plus data   */gp:{gpURL:'http://order.yoonstraditionalteochewkueh.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://order.yoonstraditionalteochewkueh.com.sg/#/',waSeparator:'Yoons Holdings'},site_title:'Yoons Holdings',site_title_with_separator:' | Yoons Holdings',home_meta_title:"Yoons Holdings",bgimage:'/img/ninjaprocmn/yoons/body_bg.jpg'},"order.misskefir.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"60B08C4E-56F3-4770-A535-898F7966BC5D",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Miss Kefir',stripeImage:"https://order.misskefir.com/img/ninjaprocmn/misskefir/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'misskefir',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.misskefir.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.misskefir.com/#/',fbImage:'https://order.misskefir.com/img/misskefir/logo.png',fbTitle:'Miss Kefir',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.misskefir.com/'},/* Twitter  */tw:{twURL:'https://order.misskefir.com/#/',twTitile:'Miss Kefir',twvia:'Miss Kefir'},/* google Plus data   */gp:{gpURL:'http://order.misskefir.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.misskefir.com/#/',waSeparator:'Miss Kefir'},site_title:'Miss Kefir',site_title_with_separator:' | Miss Kefir',home_meta_title:"Miss Kefir",bgimage:'/img/ninjaprocmn/misskefir/body_bg.jpg'},"www.bbburgers.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"FF30FE53-79E7-4F0C-AD27-4DF55EC95B99",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'BBBURGERS',stripeImage:"https://www.bbburgers.sg/img/ninjaprocmn/bbburgers/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'bbburgers',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.misskefir.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.bbburgers.sg/#/',fbImage:'https://www.bbburgers.sg/img/bbburgers/logo.png',fbTitle:'BBBURGERS',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.bbburgers.sg/'},/* Twitter  */tw:{twURL:'https://www.bbburgers.sg/#/',twTitile:'BBBURGERS',twvia:'BBBURGERS'},/* google Plus data   */gp:{gpURL:'http://www.bbburgers.sg/#/'},/* Whatsapp data   */wa:{waURL:'http://www.bbburgers.sg/#/',waSeparator:'BBBURGERS'},site_title:'BBBURGERS',forcewww:'YES',site_title_with_separator:' | BBBURGERS',home_meta_title:"BBBURGERS",bgimage:'/img/ninjaprocmn/bbburgers/body_bg.jpg'},"order.fortsanctuary.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D52B0F7C-912E-408E-90DB-B85E272447AD",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Fort Sanctuary',stripeImage:"https://order.fortsanctuary.com/img/ninjaprocmn/fortsanctuary/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'fortsanctuary',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.misskefir.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.fortsanctuary.com/#/',fbImage:'https://order.fortsanctuary.com/img/fortsanctuary/logo.png',fbTitle:'Fort Sanctuary',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.fortsanctuary.com/'},/* Twitter  */tw:{twURL:'https://order.fortsanctuary.com/#/',twTitile:'Fort Sanctuary',twvia:'Fort Sanctuary'},/* google Plus data   */gp:{gpURL:'http://order.fortsanctuary.com/#/'},/* Whatsapp data   */wa:{waURL:'http://order.fortsanctuary.com/#/',waSeparator:'Fort Sanctuary'},site_title:'Fort Sanctuary',site_title_with_separator:' | Fort Sanctuary',home_meta_title:"Fort Sanctuary",bgimage:'/img/ninjaprocmn/fortsanctuary/body_bg.jpg'},"order.wineconnection.com.sg-removed":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"6023698C-B0E7-4F2F-9DEA-76E9686D8D76",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Wine Connection',stripeImage:"https://order.wineconnection.com.sg/img/ninjaprocmn/wineconnection/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'wineconnection',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.wineconnection.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.wineconnection.com.sg/#/',fbImage:'https://order.wineconnection.com.sg/img/wineconnection/logo.png',fbTitle:'Wine Connection',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.wineconnection.com.sg/'},/* Twitter  */tw:{twURL:'https://order.wineconnection.com.sg/#/',twTitile:'Wine Connection',twvia:'Wine Connection'},/* google Plus data   */gp:{gpURL:'https://order.wineconnection.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.wineconnection.com.sg/#/',waSeparator:'Wine Connection'},site_title:'Wine Connection',site_title_with_separator:' | Wine Connection',home_meta_title:"Wine Connection",bgimage:'/img/ninjaprocmn/wineconnection/body_bg.jpg'},"reservation.wineconnection.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"6FCDE66B-8022-421E-A41B-34AF16B3A645",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Wine Connection',stripeImage:"https://reservation.wineconnection.com.sg/img/ninjaprocmn/wineconnection/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'wineconnection',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://reservation.wineconnection.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://reservation.wineconnection.com.sg/#/',fbImage:'https://reservation.wineconnection.com.sg/img/wineconnection/logo.png',fbTitle:'Wine Connection',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://reservation.wineconnection.com.sg/'},/* Twitter  */tw:{twURL:'https://reservation.wineconnection.com.sg/#/',twTitile:'Wine Connection',twvia:'Wine Connection'},/* google Plus data   */gp:{gpURL:'https://reservation.wineconnection.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://reservation.wineconnection.com.sg/#/',waSeparator:'Wine Connection'},site_title:'Wine Connection',site_title_with_separator:' | Wine Connection',home_meta_title:"Wine Connection",bgimage:'/img/ninjaprocmn/wineconnection/body_bg.jpg'},"www.popiahoriginals.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"694F4A9E-B491-4D7D-AEC4-ABDF5E5FD821",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Popiah Original',stripeImage:"https://www.popiahoriginals.com/img/ninjaprocmn/popiahoriginal/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'popiahoriginal',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.popiahoriginals.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.popiahoriginals.com/#/',fbImage:'https://www.popiahoriginals.com/img/popiahoriginal/logo.png',fbTitle:'Popiah Original',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.popiahoriginals.com/'},/* Twitter  */tw:{twURL:'https://www.popiahoriginals.com/#/',twTitile:'Popiah Original',twvia:'Popiah Original'},/* google Plus data   */gp:{gpURL:'https://www.popiahoriginals.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.popiahoriginals.com/#/',waSeparator:'Popiah Original'},site_title:'Popiah Original',forcewww:'YES',site_title_with_separator:' | Popiah Original',home_meta_title:"Popiah Original",bgimage:'/img/ninjaprocmn/popiahoriginal/body_bg.jpg'},"order.backalley.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F34559CA-596A-4F2E-8547-17B2AEBB3326",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Back Alley Cafe',stripeImage:"https://order.backalley.com.sg/img/ninjaprocmn/backalley/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'backalley',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.backalley.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.backalley.com.sg/#/',fbImage:'https://order.backalley.com.sg/img/backalley/logo.png',fbTitle:'Back Alley Cafe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.backalley.com.sg/'},/* Twitter  */tw:{twURL:'https://order.backalley.com.sg/#/',twTitile:'Back Alley Cafe',twvia:'Back Alley Cafe'},/* google Plus data   */gp:{gpURL:'https://order.backalley.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.backalley.com.sg/#/',waSeparator:'Back Alley Cafe'},site_title:'Back Alley Cafe',site_title_with_separator:' | Back Alley Cafe',home_meta_title:"Back Alley Cafe",bgimage:'/img/ninjaprocmn/backalley/body_bg.jpg'},"order.tehadventures.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"857D66FF-E308-4372-BF65-4C9F5654A675",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Teh Adventures',stripeImage:"https://order.tehadventures.com/img/ninjaprocmn/zook/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'zook',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.tehadventures.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.tehadventures.com/#/',fbImage:'https://order.tehadventures.com/img/zook/logo.png',fbTitle:'Teh Adventures',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.tehadventures.com/'},/* Twitter  */tw:{twURL:'https://order.tehadventures.com/#/',twTitile:'Teh Adventures',twvia:'Teh Adventures'},/* google Plus data   */gp:{gpURL:'https://order.tehadventures.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.tehadventures.com/#/',waSeparator:'Teh Adventures'},site_title:'Teh Adventures',site_title_with_separator:' | Teh Adventures',home_meta_title:"Teh Adventures",bgimage:'/img/ninjaprocmn/zook/body_bg.jpg'},"order.17teas.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"431F97A9-6CA0-4316-BCD6-CAC5C5922A5A",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'No.17 Tea',stripeImage:"https://order.17teas.com/img/ninjaprocmn/17tea/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'17tea',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.17teas.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.17teas.com/#/',fbImage:'https://order.17teas.com/img/17tea/logo.png',fbTitle:'No.17 Tea',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.17teas.com/'},/* Twitter  */tw:{twURL:'https://order.17teas.com/#/',twTitile:'No.17 Tea',twvia:'No.17 Tea'},/* google Plus data   */gp:{gpURL:'https://order.17teas.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.17teas.com/#/',waSeparator:'No.17 Tea'},site_title:'No.17 Tea',site_title_with_separator:' | No.17 Tea',home_meta_title:"No.17 Tea",bgimage:'/img/ninjaprocmn/17tea/body_bg.jpg'},"order.kloudkitchen.sg moved to enterprise":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"4D1C050A-29CD-4B79-8607-F05ADE966B2B",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Kloudkitchen',stripeImage:"https://order.kloudkitchen.sg/img/ninjaprocmn/kloudkitchen/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'kloudkitchen',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.kloudkitchen.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.kloudkitchen.sg/#/',fbImage:'https://order.kloudkitchen.sg/img/kloudkitchen/logo.png',fbTitle:'Kloudkitchen',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.kloudkitchen.sg/'},/* Twitter  */tw:{twURL:'https://order.kloudkitchen.sg/#/',twTitile:'Kloudkitchen',twvia:'Kloudkitchen'},/* google Plus data   */gp:{gpURL:'https://order.kloudkitchen.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.kloudkitchen.sg/#/',waSeparator:'Kloudkitchen'},site_title:'Kloudkitchen',site_title_with_separator:' | Kloudkitchen',home_meta_title:"Kloudkitchen",bgimage:'/img/ninjaprocmn/kloudkitchen/body_bg.jpg'},"www.ajmirbriyani.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D4870FF9-134C-4A80-9C97-323CA6C6A4F7",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Ajmir Briyani',stripeImage:"https://www.ajmirbriyani.com/img/ninjaprocmn/ajmirbriyani/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ajmirbriyani',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.ajmirbriyani.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.ajmirbriyani.com/#/',fbImage:'https://www.ajmirbriyani.com/img/ajmirbriyani/logo.png',fbTitle:'Ajmir Briyani',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.ajmirbriyani.com/'},/* Twitter  */tw:{twURL:'https://www.ajmirbriyani.com/#/',twTitile:'Ajmir Briyani',twvia:'Ajmir Briyani'},/* google Plus data   */gp:{gpURL:'https://www.ajmirbriyani.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.ajmirbriyani.com/#/',waSeparator:'Ajmir Briyani'},site_title:'Ajmir Briyani',site_title_with_separator:' | Ajmir Briyani',home_meta_title:"Ajmir Briyani",bgimage:'/img/ninjaprocmn/ajmirbriyani/body_bg.jpg'},"www.taliwang.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"61AED792-381F-4AEC-B37E-F573A06CB9BF",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Nasi Lemak Ayam Taliwang',stripeImage:"https://www.taliwang.sg/img/ninjaprocmn/ayamtaliwang-admin/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ayamtaliwang-admin',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.taliwang.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.taliwang.sg/#/',fbImage:'https://www.taliwang.sg/img/ayamtaliwang-admin/logo.png',fbTitle:'Nasi Lemak Ayam Taliwang',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.taliwang.sg/'},/* Twitter  */tw:{twURL:'https://www.taliwang.sg/#/',twTitile:'Nasi Lemak Ayam Taliwang',twvia:'Nasi Lemak Ayam Taliwang'},/* google Plus data   */gp:{gpURL:'https://www.taliwang.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://www.taliwang.sg/#/',waSeparator:'Nasi Lemak Ayam Taliwang'},site_title:'Nasi Lemak Ayam Taliwang',forcewww:'YES',site_title_with_separator:' | Nasi Lemak Ayam Taliwang',home_meta_title:"Nasi Lemak Ayam Taliwang",bgimage:'/img/ninjaprocmn/ayamtaliwang-admin/body_bg.jpg'},"www.mummathaikitchen.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"31D15779-1796-40C1-80CA-D1A0CF1B62D7",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Mummas Thai Kitchen',stripeImage:"https://www.mummathaikitchen.com/img/ninjaprocmn/mummasthaikitchen/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'mummasthaikitchen',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.mummathaikitchen.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.mummathaikitchen.com/#/',fbImage:'https://www.mummathaikitchen.com/img/mummasthaikitchen/logo.png',fbTitle:'Mummas Thai Kitchen',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.mummathaikitchen.com/'},/* Twitter  */tw:{twURL:'https://www.mummathaikitchen.com/#/',twTitile:'Mummas Thai Kitchen',twvia:'Mummas Thai Kitchen'},/* google Plus data   */gp:{gpURL:'https://www.mummathaikitchen.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.mummathaikitchen.com/#/',waSeparator:'Mummas Thai Kitchen'},site_title:'Mummas Thai Kitchen',forcewww:'YES',site_title_with_separator:' | Mummas Thai Kitchen',home_meta_title:"Mummas Thai Kitchen",bgimage:'/img/ninjaprocmn/mummasthaikitchen/body_bg.jpg'},"www.meitoythaifood.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"9A87DB60-6E73-4E33-B2BC-1DD74367504F",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Mei Toy Thai Food',stripeImage:"https://www.meitoythaifood.com/img/ninjaprocmn/meitoythaifood/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'meitoythaifood',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.meitoythaifood.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.meitoythaifood.com/#/',fbImage:'https://www.meitoythaifood.com/img/meitoythaifood/logo.png',fbTitle:'Mei Toy Thai Food',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.meitoythaifood.com/'},/* Twitter  */tw:{twURL:'https://www.meitoythaifood.com/#/',twTitile:'Mei Toy Thai Food',twvia:'Mei Toy Thai Food'},/* google Plus data   */gp:{gpURL:'https://www.meitoythaifood.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.meitoythaifood.com/#/',waSeparator:'Mei Toy Thai Food'},site_title:'Mei Toy Thai Food',forcewww:'YES',site_title_with_separator:' | Mei Toy Thai Food',home_meta_title:"Mei Toy Thai Food",bgimage:'/img/ninjaprocmn/meitoythaifood/body_bg.jpg'},"www.ohsomebowls.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"025D9F2B-0D16-479C-B47D-1445F68E54FD",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'OH SOME BOWLS',stripeImage:"https://www.ohsomebowls.com/img/ninjaprocmn/ohsomebowls/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ohsomebowls',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.ohsomebowls.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.ohsomebowls.com/#/',fbImage:'https://www.ohsomebowls.com/img/ohsomebowls/logo.png',fbTitle:'OH SOME BOWLS',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.ohsomebowls.com/'},/* Twitter  */tw:{twURL:'https://www.ohsomebowls.com/#/',twTitile:'OH SOME BOWLS',twvia:'OH SOME BOWLS'},/* google Plus data   */gp:{gpURL:'https://www.ohsomebowls.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.ohsomebowls.com/#/',waSeparator:'OH SOME BOWLS'},site_title:'OH SOME BOWLS',forcewww:'YES',site_title_with_separator:' | OH SOME BOWLS',home_meta_title:"OH SOME BOWLS",bgimage:'/img/ninjaprocmn/ohsomebowls/body_bg.jpg'},"order.qbreadtampines.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"2F182BAF-41EC-45FC-AF6F-1E5A159FBB10",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Q Bread Tampines',stripeImage:"https://order.qbreadtampines.com/img/ninjaprocmn/qbreadtampines/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'qbreadtampines',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.qbreadtampines.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.qbreadtampines.com/#/',fbImage:'https://order.qbreadtampines.com/img/qbreadtampines/logo.png',fbTitle:'Q Bread Tampines',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.qbreadtampines.com/'},/* Twitter  */tw:{twURL:'https://order.qbreadtampines.com/#/',twTitile:'Q Bread Tampines',twvia:'Q Bread Tampines'},/* google Plus data   */gp:{gpURL:'https://order.qbreadtampines.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.qbreadtampines.com/#/',waSeparator:'Q Bread Tampines'},site_title:'Q Bread Tampines',forcewww:'YES',site_title_with_separator:' Q Bread Tampines',home_meta_title:"Q Bread Tampines",bgimage:'/img/ninjaprocmn/qbreadtampines/body_bg.jpg'},"order.tooklaedee.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"EC060123-6053-4635-8784-6BD72118F2AF",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Took Lae Dee',stripeImage:"https://order.tooklaedee.com.sg/img/ninjaprocmn/tooklaedee/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'tooklaedee',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.tooklaedee.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.tooklaedee.com.sg/#/',fbImage:'https://order.tooklaedee.com.sg/img/tooklaedee/logo.png',fbTitle:'Took Lae Dee',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.tooklaedee.com.sg/'},/* Twitter  */tw:{twURL:'https://order.tooklaedee.com.sg/#/',twTitile:'Took Lae Dee',twvia:'Took Lae Dee'},/* google Plus data   */gp:{gpURL:'https://order.tooklaedee.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.tooklaedee.com.sg/#/',waSeparator:'Took Lae Dee'},site_title:'Took Lae Dee',forcewww:'YES',site_title_with_separator:'Took Lae Dee',home_meta_title:"Took Lae Dee",bgimage:'/img/ninjaprocmn/tooklaedee/body_bg.jpg'},"order.greenkitchen.co":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"2F49E72A-D007-4458-B525-D80CC65641FE",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Green Kitchen',stripeImage:"https://order.greenkitchen.co/img/ninjaprocmn/greenkitchen/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'greenkitchen',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.greenkitchen.co/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.greenkitchen.co/#/',fbImage:'https://order.greenkitchen.co/img/greenkitchen/logo.png',fbTitle:'Took Lae Dee',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.greenkitchen.co/'},/* Twitter  */tw:{twURL:'https://order.greenkitchen.co/#/',twTitile:'Green Kitchen',twvia:'Green Kitchen'},/* google Plus data   */gp:{gpURL:'https://order.greenkitchen.co/#/'},/* Whatsapp data   */wa:{waURL:'https://order.greenkitchen.co/#/',waSeparator:'Green Kitchen'},site_title:'Green Kitchen',site_title_with_separator:'Green Kitchen',home_meta_title:"Green Kitchen",bgimage:'/img/ninjaprocmn/greenkitchen/body_bg.jpg'},"www.annkalsri.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"C5D95E86-0D1A-46DC-BDEB-9D14F2E04F1F",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'ANN & KALSRI',stripeImage:"https://www.annkalsri.com/img/ninjaprocmn/annkalsri/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'annkalsri',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.annkalsri.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.annkalsri.com/#/',fbImage:'https://www.annkalsri.com/img/annkalsri/logo.png',fbTitle:'ANN & KALSRI',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.annkalsri.com/'},/* Twitter  */tw:{twURL:'https://www.annkalsri.com/#/',twTitile:'ANN & KALSRI',twvia:'ANN & KALSRI'},/* google Plus data   */gp:{gpURL:'https://www.annkalsri.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.annkalsri.com/#/',waSeparator:'ANN & KALSRI'},site_title:'ANN & KALSRI',forcewww:'YES',site_title_with_separator:'ANN & KALSRI',home_meta_title:"ANN & KALSRI",bgimage:'/img/ninjaprocmn/annkalsri/body_bg.jpg'},"www.dapuryummy.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"8F658C8A-FF24-4DB9-BC84-D868698FBCD5",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Dapur Yummy',stripeImage:"https://www.dapuryummy.com/img/ninjaprocmn/dapuryummy/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'dapuryummy',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.dapuryummy.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.dapuryummy.com/#/',fbImage:'https://www.dapuryummy.com/img/dapuryummy/logo.png',fbTitle:'Dapur Yummy',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.dapuryummy.com/'},/* Twitter  */tw:{twURL:'https://www.dapuryummy.com/#/',twTitile:'Dapur Yummy',twvia:'Dapur Yummy'},/* google Plus data   */gp:{gpURL:'https://www.dapuryummy.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.dapuryummy.com/#/',waSeparator:'Dapur Yummy'},site_title:'Dapur Yummy',forcewww:'YES',site_title_with_separator:'Dapur Yummy',home_meta_title:"Dapur Yummy",bgimage:'/img/ninjaprocmn/dapuryummy/body_bg.jpg'},"www.thegoodfatsg.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"7849A48A-EA9D-48F2-8202-9E44322AFBCE",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'The Good Fat',stripeImage:"https://www.thegoodfatsg.com/img/ninjaprocmn/thegoodfatsg/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'thegoodfatsg',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.thegoodfatsg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.thegoodfatsg.com/#/',fbImage:'https://www.thegoodfatsg.com/img/thegoodfatsg/logo.png',fbTitle:'The Good Fat',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.thegoodfatsg.com/'},/* Twitter  */tw:{twURL:'https://www.thegoodfatsg.com/#/',twTitile:'The Good Fat',twvia:'The Good Fat'},/* google Plus data   */gp:{gpURL:'https://www.thegoodfatsg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.thegoodfatsg.com/#/',waSeparator:'The Good Fat'},site_title:'The Good Fat',forcewww:'YES',site_title_with_separator:'The Good Fat',home_meta_title:"The Good Fat",bgimage:'/img/ninjaprocmn/thegoodfatsg/body_bg.jpg'},"order.bedokbakchormee.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"AAEE8C75-72DD-43A5-B11C-AD906CCBB3AC",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Bedok Bak Chor Mee',stripeImage:"https://order.bedokbakchormee.com/img/ninjaprocmn/bedokbak/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'bedokbak',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.bedokbakchormee.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.bedokbakchormee.com/#/',fbImage:'https://order.bedokbakchormee.com/img/bedokbak/logo.png',fbTitle:'Bedok Bak Chor Mee',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.bedokbakchormee.com/'},/* Twitter  */tw:{twURL:'https://order.bedokbakchormee.com/#/',twTitile:'Bedok Bak Chor Mee',twvia:'Bedok Bak Chor Mee'},/* google Plus data   */gp:{gpURL:'https://order.bedokbakchormee.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.bedokbakchormee.com/#/',waSeparator:'Bedok Bak Chor Mee'},site_title:'Bedok Bak Chor Mee',forcewww:'YES',site_title_with_separator:'Bedok Bak Chor Mee',home_meta_title:"Bedok Bak Chor Mee",bgimage:'/img/ninjaprocmn/bedokbak/body_bg.jpg'},"order.thegogijip.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"3361972F-C12A-483A-8F64-DA92E4C5E2CE",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'The Gogijip',stripeImage:"https://order.thegogijip.com/img/ninjaprocmn/gogijip/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'gogijip',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.thegogijip.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.thegogijip.com/#/',fbImage:'https://order.thegogijip.com/img/gogijip/logo.png',fbTitle:'The Gogijip',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.thegogijip.com/'},/* Twitter  */tw:{twURL:'https://order.thegogijip.com/#/',twTitile:'The Gogijip',twvia:'The Gogijip'},/* google Plus data   */gp:{gpURL:'https://order.thegogijip.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.thegogijip.com/#/',waSeparator:'The Gogijip'},site_title:'The Gogijip',forcewww:'YES',site_title_with_separator:'The Gogijip',home_meta_title:"The Gogijip",bgimage:'/img/ninjaprocmn/gogijip/body_bg.jpg'},"order.lavendernasilemak.sg-removed":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"7F424A7C-7225-4809-87AB-E787C96D9B89",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Lavender Nasi Lemak',stripeImage:"https://order.lavendernasilemak.sg/img/ninjaprocmn/lavendernasilemak/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'lavendernasilemak',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.lavendernasilemak.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.lavendernasilemak.sg/#/',fbImage:'https://order.lavendernasilemak.sg/img/lavendernasilemak/logo.png',fbTitle:'Lavender Nasi Lemak',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.lavendernasilemak.sg/'},/* Twitter  */tw:{twURL:'https://order.lavendernasilemak.sg/#/',twTitile:'Lavender Nasi Lemak',twvia:'Lavender Nasi Lemak'},/* google Plus data   */gp:{gpURL:'https://order.lavendernasilemak.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.lavendernasilemak.sg/#/',waSeparator:'Lavender Nasi Lemak'},site_title:'Lavender Nasi Lemak',site_title_with_separator:'Lavender Nasi Lemak',home_meta_title:"Lavender Nasi Lemak",bgimage:'/img/ninjaprocmn/lavendernasilemak/body_bg.jpg'},"order.gerainenekobek.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"3B806592-1677-4219-96CD-893382DD7281",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Gerai Nenek Obek',stripeImage:"https://order.gerainenekobek.com/img/ninjaprocmn/gerainenekobek/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'gerainenekobek',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.gerainenekobek.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.gerainenekobek.com/#/',fbImage:'https://order.gerainenekobek.com/img/gerainenekobek/logo.png',fbTitle:'Gerai Nenek Obek',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.gerainenekobek.com/'},/* Twitter  */tw:{twURL:'https://order.gerainenekobek.com/#/',twTitile:'Gerai Nenek Obek',twvia:'Gerai Nenek Obek'},/* google Plus data   */gp:{gpURL:'https://order.gerainenekobek.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.gerainenekobek.com/#/',waSeparator:'Gerai Nenek Obek'},site_title:'Gerai Nenek Obek',site_title_with_separator:'Gerai Nenek Obek',home_meta_title:"Gerai Nenek Obek",bgimage:'/img/ninjaprocmn/gerainenekobek/body_bg.jpg'},"order.sengkangoysteromelette.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"67C3C333-7F55-4296-B56D-9E53940B7F4E",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Sengkang Oyster Omelette',stripeImage:"https://order.sengkangoysteromelette.com/img/ninjaprocmn/sengkangoysteromelette/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'sengkangoysteromelette',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.sengkangoysteromelette.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.sengkangoysteromelette.com/#/',fbImage:'https://order.sengkangoysteromelette.com/img/sengkangoysteromelette/logo.png',fbTitle:'Sengkang Oyster Omelette',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.sengkangoysteromelette.com/'},/* Twitter  */tw:{twURL:'https://order.sengkangoysteromelette.com/#/',twTitile:'Sengkang Oyster Omelette',twvia:'Sengkang Oyster Omelette'},/* google Plus data   */gp:{gpURL:'https://order.sengkangoysteromelette.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.sengkangoysteromelette.com/#/',waSeparator:'Sengkang Oyster Omelette'},site_title:'Sengkang Oyster Omelette',site_title_with_separator:'Sengkang Oyster Omelette',home_meta_title:"Sengkang Oyster Omelette",bgimage:'/img/ninjaprocmn/sengkangoysteromelette/body_bg.jpg'},"www.sweeteacaffe.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"A1DAF62B-6E3B-4509-98F0-A0BA7BE216BC",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Sweetea Caffe',stripeImage:"https://www.sweeteacaffe.com/img/ninjaprocmn/sweeteacaffe/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'sweeteacaffe',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.sweeteacaffe.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.sweeteacaffe.com/#/',fbImage:'https://www.sweeteacaffe.com/img/sweeteacaffe/logo.png',fbTitle:'Sweetea Caffe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.sweeteacaffe.com/'},/* Twitter  */tw:{twURL:'https://www.sweeteacaffe.com/#/',twTitile:'Sweetea Caffe',twvia:'Sweetea Caffe'},/* google Plus data   */gp:{gpURL:'https://www.sweeteacaffe.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.sweeteacaffe.com/#/',waSeparator:'Sweetea Caffe'},site_title:'Sweetea Caffe',forcewww:'YES',site_title_with_separator:'Sweetea Caffe',home_meta_title:"Sweetea Caffe",bgimage:'/img/ninjaprocmn/sweeteacaffe/body_bg.jpg'},"www.happywokie.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D0014A91-28CA-4C39-90E6-A3CD30FC465B",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Happy Woki',stripeImage:"https://www.happywokie.com/img/ninjaprocmn/happywokie/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'happywokie',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.happywokie.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.happywokie.com/#/',fbImage:'https://www.happywokie.com/img/happywokie/logo.png',fbTitle:'Happy Woki',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.happywokie.com/'},/* Twitter  */tw:{twURL:'https://www.happywokie.com/#/',twTitile:'Happy Woki',twvia:'Happy Woki'},/* google Plus data   */gp:{gpURL:'https://www.happywokie.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.happywokie.com/#/',waSeparator:'Happy Woki'},site_title:'Happy Woki',forcewww:'YES',site_title_with_separator:'Happy Woki',home_meta_title:"Happy Woki",bgimage:'/img/ninjaprocmn/happywokie/body_bg.jpg'},"order.dstarbistro.com.sg":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F5B81837-70AF-49C3-BFB0-A21BF5324745",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'DStar Bistro',stripeImage:"https://order.dstarbistro.com.sg/img/ninjaprocmn/dstarbistro/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'dstarbistro',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.dstarbistro.com.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.dstarbistro.com.sg/#/',fbImage:'https://order.dstarbistro.com.sg/img/happywokie/logo.png',fbTitle:'DStar Bistro',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.dstarbistro.com.sg/'},/* Twitter  */tw:{twURL:'https://order.dstarbistro.com.sg/#/',twTitile:'DStar Bistro',twvia:'DStar Bistro'},/* google Plus data   */gp:{gpURL:'https://order.dstarbistro.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.dstarbistro.com.sg/#/',waSeparator:'DStar Bistro'},site_title:'DStar Bistro',site_title_with_separator:'DStar Bistro',home_meta_title:"DStar Bistro",bgimage:'/img/ninjaprocmn/dstarbistro/body_bg.jpg'},"order.ddesservir.com":{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"81E217F5-F599-4721-A228-D4B280C8EE1B",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Ddesservir',stripeImage:"https://order.ddesservir.com/img/ninjaprocmn/ddesservir/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ddesservir',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.ddesservir.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.ddesservir.com/#/',fbImage:'https://order.ddesservir.com/img/ddesservir/logo.png',fbTitle:'Ddesservir',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.ddesservir.com/'},/* Twitter  */tw:{twURL:'https://order.ddesservir.com/#/',twTitile:'Ddesservir',twvia:'Ddesservir'},/* google Plus data   */gp:{gpURL:'https://order.ddesservir.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.ddesservir.com/#/',waSeparator:'Ddesservir'},site_title:'Ddesservir',site_title_with_separator:'Ddesservir',home_meta_title:"Ddesservir",bgimage:'/img/ninjaprocmn/ddesservir/body_bg.jpg'}},_defineProperty(_domainValues,'www.happywokie.com',{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D0014A91-28CA-4C39-90E6-A3CD30FC465B",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Happy Woki',stripeImage:"https://www.happywokie.com/img/ninjaprocmn/happywokie/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'happywokie',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.happywokie.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.happywokie.com/#/',fbImage:'https://www.happywokie.com/img/happywokie/logo.png',fbTitle:'Happy Woki',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.happywokie.com/'},/* Twitter  */tw:{twURL:'https://www.happywokie.com/#/',twTitile:'Happy Woki',twvia:'Happy Woki'},/* google Plus data   */gp:{gpURL:'https://www.happywokie.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.happywokie.com/#/',waSeparator:'Happy Woki'},site_title:'Happy Woki',forcewww:'YES',site_title_with_separator:'Happy Woki',home_meta_title:"Happy Woki",bgimage:'/img/ninjaprocmn/happywokie/body_bg.jpg'}),_defineProperty(_domainValues,"order.multifoodsupply.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E77ADD5F-2C13-47E5-940D-29DE0FB0444C",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Multi Food',stripeImage:"https://order.multifoodsupply.com/img/ninjaprocmn/multifood/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'multifood',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.multifoodsupply.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.multifoodsupply.com/#/',fbImage:'https://order.multifoodsupply.com/img/multifood/logo.png',fbTitle:'Multi Food',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.multifoodsupply.com/'},/* Twitter  */tw:{twURL:'https://order.multifoodsupply.com/#/',twTitile:'Multi Food',twvia:'Multi Food'},/* google Plus data   */gp:{gpURL:'https://order.multifoodsupply.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.multifoodsupply.com/#/',waSeparator:'Multi Food'},site_title:'Multi Food',forcewww:'NO',site_title_with_separator:'Multi Food',home_meta_title:"Multi Food",bgimage:'/img/ninjaprocmn/multifood/body_bg.jpg'}),_defineProperty(_domainValues,"www.totogourmet.net",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"21C5C6BE-B8C4-4073-A7CA-78833B6D1680",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'TOTO Gourmet',stripeImage:"https://www.totogourmet.net/img/ninjaprocmn/totogourmet/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'totogourmet',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.totogourmet.net/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.totogourmet.net/#/',fbImage:'https://www.totogourmet.net/img/totogourmet/logo.png',fbTitle:'TOTO Gourmet',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.totogourmet.net/'},/* Twitter  */tw:{twURL:'https://www.totogourmet.net/#/',twTitile:'TOTO Gourmet',twvia:'TOTO Gourmet'},/* google Plus data   */gp:{gpURL:'https://www.totogourmet.net/#/'},/* Whatsapp data   */wa:{waURL:'https://www.totogourmet.net/#/',waSeparator:'TOTO Gourmet'},site_title:'TOTO Gourmet',forcewww:'YES',site_title_with_separator:'TOTO Gourmet',home_meta_title:"TOTO Gourmet",bgimage:'/img/ninjaprocmn/totogourmet/body_bg.jpg'}),_defineProperty(_domainValues,"order.snowangelsdesserthouse.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"73BF7668-B7E1-4677-ACEA-FE9C70D8D249",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Snow Angels Dessert House',stripeImage:"https://order.snowangelsdesserthouse.sg/img/ninjaprocmn/snowangels/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'snowangels',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.totogourmet.net/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.snowangelsdesserthouse.sg/#/',fbImage:'https://order.snowangelsdesserthouse.sg/img/snowangels/logo.png',fbTitle:'Snow Angels Dessert House',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.snowangelsdesserthouse.sg'},/* Twitter  */tw:{twURL:'https://order.snowangelsdesserthouse.sg/#/',twTitile:'Snow Angels Dessert House',twvia:'Snow Angels Dessert House'},/* google Plus data   */gp:{gpURL:'https://order.snowangelsdesserthouse.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.snowangelsdesserthouse.sg/#/',waSeparator:'Snow Angels Dessert House'},site_title:'Snow Angels Dessert House',site_title_with_separator:'Snow Angels Dessert House',home_meta_title:"Snow Angels Dessert House",bgimage:'/img/ninjaprocmn/snowangels/body_bg.jpg'}),_defineProperty(_domainValues,"www.asamgaram29.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"EA68D170-74CE-4305-AABE-335368C8D45E",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Asam Garam',stripeImage:"https://www.asamgaram29.com/img/ninjaprocmn/asamgaram/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'asamgaram',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.asamgaram29.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.asamgaram29.com/#/',fbImage:'https://www.asamgaram29.com/img/asamgaram/logo.png',fbTitle:'Asam Garam',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.asamgaram29.com/'},/* Twitter  */tw:{twURL:'https://www.asamgaram29.com/#/',twTitile:'Asam Garam',twvia:'Asam Garam'},/* google Plus data   */gp:{gpURL:'https://www.asamgaram29.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.asamgaram29.com/#/',waSeparator:'Asam Garam'},site_title:'Asam Garam',forcewww:'YES',site_title_with_separator:'Asam Garam',home_meta_title:"Asam Garam",bgimage:'/img/ninjaprocmn/asamgaram/body_bg.jpg'}),_defineProperty(_domainValues,"www.curryclubsg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"5C28CCD6-6A1F-44AD-BE9A-0765B906BDB8",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'The Curry Club',stripeImage:"https://www.curryclubsg.com/img/ninjaprocmn/curryclub/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'curryclub',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.curryclubsg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.curryclubsg.com/#/',fbImage:'https://www.curryclubsg.com/img/curryclub/logo.png',fbTitle:'The Curry Club',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.curryclubsg.com/'},/* Twitter  */tw:{twURL:'https://www.curryclubsg.com/#/',twTitile:'The Curry Club',twvia:'The Curry Club'},/* google Plus data   */gp:{gpURL:'https://www.curryclubsg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.curryclubsg.com/#/',waSeparator:'The Curry Club'},site_title:'The Curry Club',forcewww:'YES',site_title_with_separator:' | The Curry Club',home_meta_title:"Welcome to The Curry Club",bgimage:'/img/ninjaprocmn/curryclub/body_bg.jpg'}),_defineProperty(_domainValues,"www.origanicssg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F57B2471-7A4A-4B43-B870-A7BE17843FEF",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'VEGZ DELIGHTS',stripeImage:"https://www.origanicssg.com/img/ninjaprocmn/origanics/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'origanics',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.origanicssg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.origanicssg.com/#/',fbImage:'https://www.origanicssg.com/img/origanics/logo.png',fbTitle:'VEGZ DELIGHTS',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.origanicssg.com/'},/* Twitter  */tw:{twURL:'https://www.origanicssg.com/#/',twTitile:'VEGZ DELIGHTS',twvia:'VEGZ DELIGHTS'},/* google Plus data   */gp:{gpURL:'https://www.origanicssg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.origanicssg.com/#/',waSeparator:'VEGZ DELIGHTS'},site_title:'VEGZ DELIGHTS',forcewww:'YES',site_title_with_separator:' | VEGZ DELIGHTS',home_meta_title:"Welcome to VEGZ DELIGHTS",bgimage:'/img/ninjaprocmn/origanics/body_bg.jpg'}),_defineProperty(_domainValues,"www.madraswoodlandsganga.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"5D4FB593-06E2-4F9F-832D-E8F5A93F0FB7",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Madras Woodlands Ganga',stripeImage:"https://www.madraswoodlandsganga.com/img/ninjaprocmn/madraswoodlandsganga/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'madraswoodlandsganga',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.madraswoodlandsganga.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.madraswoodlandsganga.com/#/',fbImage:'https://www.madraswoodlandsganga.com/img/madraswoodlandsganga/logo.png',fbTitle:'Madras Woodlands Ganga',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.madraswoodlandsganga.com /'},/* Twitter  */tw:{twURL:'https://www.madraswoodlandsganga.com/#/',twTitile:'Madras Woodlands Ganga',twvia:'Madras Woodlands Ganga'},/* google Plus data   */gp:{gpURL:'https://www.madraswoodlandsganga.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.madraswoodlandsganga.com/#/',waSeparator:'Madras Woodlands Ganga'},site_title:'Madras Woodlands Ganga',forcewww:'YES',site_title_with_separator:' | Madras Woodlands Ganga',home_meta_title:"Welcome to Madras Woodlands Ganga",bgimage:'/img/ninjaprocmn/madraswoodlandsganga/body_bg.jpg'}),_defineProperty(_domainValues,"www.chiru2u.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"775ADF2B-1EC9-4615-8D95-63EBEC7CA287",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Chiru',stripeImage:"https://www.chiru2u.com/img/ninjaprocmn/chiru2u/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'chiru2u',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.chiru2u.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.chiru2u.com/#/',fbImage:'https://www.chiru2u.com/img/chiru2u/logo.png',fbTitle:'Chiru',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.chiru2u.com/'},/* Twitter  */tw:{twURL:'https://www.chiru2u.com/#/',twTitile:'Chiru',twvia:'Chiru'},/* google Plus data   */gp:{gpURL:'https://www.chiru2u.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.chiru2u.com/#/',waSeparator:'Chiru'},site_title:'Chiru',forcewww:'YES',site_title_with_separator:' | Chiru',home_meta_title:"Welcome to Chiru",bgimage:'/img/ninjaprocmn/chiru2u/body_bg.jpg'}),_defineProperty(_domainValues,"www.fiscatch.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"5C83FFC3-8AE1-4936-8240-F1EDD2C179F0",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'FISCatch Seafood',stripeImage:"https://www.fiscatch.com/img/ninjaprocmn/chiru2u/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'fiscatch',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.fiscatch.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.fiscatch.com/#/',fbImage:'https://www.fiscatch.com/img/fiscatch/logo.png',fbTitle:'FISCatch Seafood',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.fiscatch.com/'},/* Twitter  */tw:{twURL:'https://www.fiscatch.com/#/',twTitile:'FISCatch Seafood',twvia:'FISCatch Seafood'},/* google Plus data   */gp:{gpURL:'https://www.fiscatch.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.fiscatch.com/#/',waSeparator:'FISCatch Seafood'},site_title:'FISCatch Seafood',forcewww:'YES',site_title_with_separator:' | FISCatch Seafood',home_meta_title:"Welcome to FISCatch Seafood",bgimage:'/img/ninjaprocmn/fiscatch/body_bg.jpg'}),_defineProperty(_domainValues,"www.sunsetrailwaycafe.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E63C6A59-C17B-4B00-B257-6B5B3B80BE69",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'SUNSET RAILWAY CAFE',stripeImage:"https://www.sunsetrailwaycafe.com/img/ninjaprocmn/sunsetrailwaycafe/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'sunsetrailwaycafe',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.sunsetrailwaycafe.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.sunsetrailwaycafe.com/#/',fbImage:'https://www.sunsetrailwaycafe.com/img/sunsetrailwaycafe/logo.png',fbTitle:'SUNSET RAILWAY CAFE',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.sunsetrailwaycafe.com/'},/* Twitter  */tw:{twURL:'https://www.sunsetrailwaycafe.com/#/',twTitile:'SUNSET RAILWAY CAFE',twvia:'SUNSET RAILWAY CAFE'},/* google Plus data   */gp:{gpURL:'https://www.sunsetrailwaycafe.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.sunsetrailwaycafe.com/#/',waSeparator:'SUNSET RAILWAY CAFE'},site_title:'SUNSET RAILWAY CAFE',forcewww:'YES',site_title_with_separator:' | SUNSET RAILWAY CAFE',home_meta_title:"Welcome to SUNSET RAILWAY CAFE",bgimage:'/img/ninjaprocmn/sunsetrailwaycafe/body_bg.jpg'}),_defineProperty(_domainValues,"order.houseofthaal.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"41200A37-9022-4E14-89DB-F86B31AD7E53",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'House of Thaal',stripeImage:"https://order.houseofthaal.com/img/ninjaprocmn/houseofthaal/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'houseofthaal',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.houseofthaal.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.houseofthaal.com/#/',fbImage:'https://order.houseofthaal.com/img/houseofthaal/logo.png',fbTitle:'House of Thaal',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.houseofthaal.com/'},/* Twitter  */tw:{twURL:'https://order.houseofthaal.com/#/',twTitile:'House of Thaal',twvia:'House of Thaal'},/* google Plus data   */gp:{gpURL:'https://order.houseofthaal.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.houseofthaal.com/#/',waSeparator:'House of Thaal'},site_title:'House of Thaal',site_title_with_separator:' | House of Thaal',home_meta_title:"Welcome to House of Thaal",bgimage:'/img/ninjaprocmn/houseofthaal/body_bg.jpg'}),_defineProperty(_domainValues,"order.yummynonya.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"36AFC00D-603D-4521-9F4E-70C8C408A7B9",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Yummy Nonya Peranakanl',stripeImage:"https://order.yummynonya.com/img/ninjaprocmn/yummynonya/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'yummynonya',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.yummynonya.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.yummynonya.com/#/',fbImage:'https://order.yummynonya.com/img/yummynonya/logo.png',fbTitle:'Yummy Nonya Peranakan',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.yummynonya.com/'},/* Twitter  */tw:{twURL:'https://order.yummynonya.com/#/',twTitile:'Yummy Nonya Peranakan',twvia:'Yummy Nonya Peranakan'},/* google Plus data   */gp:{gpURL:'https://order.yummynonya.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.yummynonya.com/#/',waSeparator:'Yummy Nonya Peranakan'},site_title:'Yummy Nonya Peranakan',site_title_with_separator:' | Yummy Nonya Peranakan',home_meta_title:"Welcome to Yummy Nonya Peranakan",bgimage:'/img/ninjaprocmn/yummynonya/body_bg.jpg'}),_defineProperty(_domainValues,"order.zhongxincafe.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D492C0C5-ECB7-4D0D-935C-3297A325174B",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'ZHONG XIN CAFE',stripeImage:"https://order.zhongxincafe.com/img/ninjaprocmn/zhongxincafe/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'zhongxincafe',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.zhongxincafe.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.zhongxincafe.com/#/',fbImage:'https://order.zhongxincafe.com/img/zhongxincafe/logo.png',fbTitle:'ZHONG XIN CAFE',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.zhongxincafe.com/'},/* Twitter  */tw:{twURL:'https://order.zhongxincafe.com/#/',twTitile:'ZHONG XIN CAFE',twvia:'ZHONG XIN CAFE'},/* google Plus data   */gp:{gpURL:'https://order.zhongxincafe.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.zhongxincafe.com/#/',waSeparator:'ZHONG XIN CAFE'},site_title:'ZHONG XIN CAFE',site_title_with_separator:' | ZHONG XIN CAFE',home_meta_title:"Welcome to ZHONG XIN CAFE",bgimage:'/img/ninjaprocmn/zhongxincafe/body_bg.jpg'}),_defineProperty(_domainValues,"order.helefoods.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"92ED29EF-5F44-41F6-BBEE-409908D1C66B",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Hele Foods',stripeImage:"https://order.helefoods.com/img/ninjaprocmn/helefoods/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'helefoods',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.helefoods.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.helefoods.com/#/',fbImage:'https://order.helefoods.com/img/helefoods/logo.png',fbTitle:'Hele Foods',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.helefoods.com/'},/* Twitter  */tw:{twURL:'https://order.helefoods.com/#/',twTitile:'Hele Foods',twvia:'Hele Foods'},/* google Plus data   */gp:{gpURL:'https://order.helefoods.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.helefoods.com/#/',waSeparator:'Hele Foods'},site_title:'Hele Foods',site_title_with_separator:' | Hele Foods',home_meta_title:"Welcome to Hele Foods",bgimage:'/img/ninjaprocmn/helefoods/body_bg.jpg'}),_defineProperty(_domainValues,"www.healthyplatz.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"A5905140-5A12-44EF-841E-8BF0E7350294",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Healthyplatz',stripeImage:"https://www.healthyplatz.com/img/ninjaprocmn/healthyplatz/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'healthyplatz',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.healthyplatz.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.healthyplatz.com/#/',fbImage:'https://www.healthyplatz.com/img/healthyplatz/logo.png',fbTitle:'Healthyplatz',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.healthyplatz.com /'},/* Twitter  */tw:{twURL:'https://www.healthyplatz.com/#/',twTitile:'Healthyplatz',twvia:'Healthyplatz'},/* google Plus data   */gp:{gpURL:'https://www.healthyplatz.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.healthyplatz.com/#/',waSeparator:'Healthyplatz'},site_title:'Healthyplatz',forcewww:'YES',site_title_with_separator:' | Healthyplatz',home_meta_title:"Welcome to Healthyplatz",bgimage:'/img/ninjaprocmn/healthyplatz/body_bg.jpg'}),_defineProperty(_domainValues,"www.g-kitchenholdings.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"4111EC2C-4612-49F0-A402-06D92E5C240B",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'KING OF PAO FAN',stripeImage:"https://www.g-kitchenholdings.com/img/ninjaprocmn/kingofpaofan/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'kingofpaofan',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.g-kitchenholdings.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.g-kitchenholdings.com/#/',fbImage:'https://www.g-kitchenholdings.com/img/kingofpaofan/logo.png',fbTitle:'KING OF PAO FAN',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.g-kitchenholdings.com /'},/* Twitter  */tw:{twURL:'https://www.g-kitchenholdings.com/#/',twTitile:'KING OF PAO FAN',twvia:'KING OF PAO FAN'},/* google Plus data   */gp:{gpURL:'https://www.g-kitchenholdings.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.g-kitchenholdings.com/#/',waSeparator:'KING OF PAO FAN'},site_title:'KING OF PAO FAN',forcewww:'YES',site_title_with_separator:' | KING OF PAO FAN',home_meta_title:"Welcome to KING OF PAO FAN",bgimage:'/img/ninjaprocmn/kingofpaofan/body_bg.jpg'}),_defineProperty(_domainValues,"order.insidescoop.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"12BFE3FC-DE70-44DF-999A-898CB155D738",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Inside Scoop',stripeImage:"https://order.insidescoop.sg/img/ninjaprocmn/insidescoop/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'insidescoop',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.insidescoop.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.insidescoop.sg/#/',fbImage:'https://order.insidescoop.sg/img/insidescoop/logo.png',fbTitle:'Inside Scoop',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.insidescoop.sg /'},/* Twitter  */tw:{twURL:'https://order.insidescoop.sg/#/',twTitile:'Inside Scoop',twvia:'Inside Scoop'},/* google Plus data   */gp:{gpURL:'https://order.insidescoop.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.insidescoop.sg/#/',waSeparator:'Inside Scoop'},site_title:'Inside Scoop',forcewww:'YES',site_title_with_separator:' | Inside Scoop',home_meta_title:"Welcome to Inside Scoop",bgimage:'/img/ninjaprocmn/insidescoop/body_bg.jpg'}),_defineProperty(_domainValues,"www.hajjahjamillah.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"07DBB7D9-F66D-49C8-98A1-34C88D9006AB",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'HAJJAH JAMILLAH',stripeImage:"https://www.hajjahjamillah.com/img/ninjaprocmn/hajjahjamillah/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'hajjahjamillah',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.hajjahjamillah.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.hajjahjamillah.com/#/',fbImage:'https://www.hajjahjamillah.com/img/hajjahjamillah/logo.png',fbTitle:'HAJJAH JAMILLAH',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.hajjahjamillah.com /'},/* Twitter  */tw:{twURL:'https://www.hajjahjamillah.com/#/',twTitile:'HAJJAH JAMILLAH',twvia:'HAJJAH JAMILLAH'},/* google Plus data   */gp:{gpURL:'https://www.hajjahjamillah.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.hajjahjamillah.com/#/',waSeparator:'HAJJAH JAMILLAH'},site_title:'HAJJAH JAMILLAH',forcewww:'YES',site_title_with_separator:' | HAJJAH JAMILLAH',home_meta_title:"Welcome to HAJJAH JAMILLAH",bgimage:'/img/ninjaprocmn/hajjahjamillah/body_bg.jpg'}),_defineProperty(_domainValues,"order.ashkafe.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"123CEF6E-0204-4153-83BD-D6FB54E63D76",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Ash Kafe',stripeImage:"https://order.ashkafe.com/img/ninjaprocmn/ashkafe/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ashkafe',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.ashkafe.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.ashkafe.com/#/',fbImage:'https://order.ashkafe.com/img/ashkafe/logo.png',fbTitle:'Ash Kafe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.ashkafe.com /'},/* Twitter  */tw:{twURL:'https://order.ashkafe.com/#/',twTitile:'Ash Kafe',twvia:'Ash Kafe'},/* google Plus data   */gp:{gpURL:'https://order.ashkafe.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.ashkafe.com/#/',waSeparator:'Ash Kafe'},site_title:'Ash Kafe',site_title_with_separator:' | Ash Kafe',home_meta_title:"Welcome to Ash Kafe",bgimage:'/img/ninjaprocmn/ashkafe/body_bg.jpg'}),_defineProperty(_domainValues,"order.bedok85friedoyster.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D69E7B1F-B08A-4C87-A438-94D267504BD9",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Bedok 85 Fried Oyster',stripeImage:"https://order.bedok85friedoyster.com/img/ninjaprocmn/bedok85friedoyster/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'bedok85friedoyster',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.bedok85friedoyster.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.bedok85friedoyster.com/#/',fbImage:'https://order.bedok85friedoyster.com/img/bedok85friedoyster/logo.png',fbTitle:'Bedok 85 Fried Oyster',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.bedok85friedoyster.com /'},/* Twitter  */tw:{twURL:'https://order.bedok85friedoyster.com/#/',twTitile:'Bedok 85 Fried Oyster',twvia:'Bedok 85 Fried Oyster'},/* google Plus data   */gp:{gpURL:'https://order.bedok85friedoyster.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.bedok85friedoyster.com/#/',waSeparator:'Bedok 85 Fried Oyster'},site_title:'Bedok 85 Fried Oyster',site_title_with_separator:' | Bedok 85 Fried Oyster',home_meta_title:"Welcome to Bedok 85 Fried Oyster",bgimage:'/img/ninjaprocmn/bedok85friedoyster/body_bg.jpg'}),_defineProperty(_domainValues,"order.gopizza.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"48084EE2-3BE1-421B-94DE-232B4F460C09",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'GOPIZZA',stripeImage:"https://order.gopizza.sg/img/ninjaprocmn/gopizzaadmin/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'gopizzaadmin',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.gopizza.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.gopizza.sg/#/',fbImage:'https://order.gopizza.sg/img/gopizzaadmin/logo.png',fbTitle:'GOPIZZA',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.gopizza.sg /'},/* Twitter  */tw:{twURL:'https://order.gopizza.sg/#/',twTitile:'GOPIZZA',twvia:'GOPIZZA'},/* google Plus data   */gp:{gpURL:'https://order.gopizza.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.gopizza.sg/#/',waSeparator:'GOPIZZA'},site_title:'GOPIZZA',site_title_with_separator:' | GOPIZZA',home_meta_title:"Welcome to GOPIZZA",bgimage:'/img/ninjaprocmn/gopizzaadmin/body_bg.jpg'}),_defineProperty(_domainValues,"order.sidetrackbistro.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"5FC5E7BC-71C5-49DD-B6FA-D40820DDC6AE",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Sidetrack',stripeImage:"https://order.sidetrackbistro.com/img/ninjaprocmn/sidetrackbistro/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'sidetrackbistro',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.sidetrackbistro.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.sidetrackbistro.com/#/',fbImage:'https://order.sidetrackbistro.com/img/sidetrackbistro/logo.png',fbTitle:'Sidetrack',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.sidetrackbistro.com /'},/* Twitter  */tw:{twURL:'https://order.sidetrackbistro.com/#/',twTitile:'Sidetrack',twvia:'Sidetrack'},/* google Plus data   */gp:{gpURL:'https://order.sidetrackbistro.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.sidetrackbistro.com/#/',waSeparator:'Sidetrack'},site_title:'Sidetrack',site_title_with_separator:' | Sidetrack',home_meta_title:"Welcome to Sidetrack",bgimage:'/img/ninjaprocmn/sidetrackbistro/body_bg.jpg'}),_defineProperty(_domainValues,"order.deckbistro.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E27E4C81-3E2F-4DBC-B6E9-B1BCBABF3156",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Happy Hut Bistro & Bar',stripeImage:"https://order.deckbistro.com/img/ninjaprocmn/deckbistro/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'deckbistro',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.deckbistro.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.deckbistro.com/#/',fbImage:'https://order.deckbistro.com/img/deckbistro/logo.png',fbTitle:'Happy Hut Bistro & Bar',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.deckbistro.com /'},/* Twitter  */tw:{twURL:'https://order.deckbistro.com/#/',twTitile:'Happy Hut Bistro & Bar',twvia:'Happy Hut Bistro & Bar'},/* google Plus data   */gp:{gpURL:'https://order.deckbistro.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.deckbistro.com/#/',waSeparator:'Happy Hut Bistro & Bar'},site_title:'Happy Hut Bistro & Bar',site_title_with_separator:' | Happy Hut Bistro & Bar',home_meta_title:"Welcome to Happy Hut Bistro & Bar",bgimage:'/img/ninjaprocmn/deckbistro/body_bg.jpg'}),_defineProperty(_domainValues,"order.ayasofyarestaurant.com.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E23CF43C-7434-40F7-8C8A-130E3927608F",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Ayasofya Turkish Restaurant',stripeImage:"https://order.ayasofyarestaurant.com.sg/img/ninjaprocmn/ayasofyarestaurant/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ayasofyarestaurant',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.ayasofyarestaurant.com.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.ayasofyarestaurant.com.sg/#/',fbImage:'https://order.ayasofyarestaurant.com.sg/img/ayasofyarestaurant/logo.png',fbTitle:'Ayasofya Turkish Restaurant',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.ayasofyarestaurant.com.sg /'},/* Twitter  */tw:{twURL:'https://order.ayasofyarestaurant.com.sg/#/',twTitile:'Ayasofya Turkish Restaurant',twvia:'Ayasofya Turkish Restaurant'},/* google Plus data   */gp:{gpURL:'https://order.ayasofyarestaurant.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.ayasofyarestaurant.com.sg/#/',waSeparator:'Ayasofya Turkish Restaurant'},site_title:'Ayasofya Turkish Restaurant',site_title_with_separator:' | Ayasofya Turkish Restaurant',home_meta_title:"Welcome to Ayasofya Turkish Restaurant",bgimage:'/img/ninjaprocmn/ayasofyarestaurant/body_bg.jpg'}),_defineProperty(_domainValues,"order.pungpungkitchen.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"FD4D99BA-0298-4CBC-9CD0-7380161408A8",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Pung Pung Kitchen',stripeImage:"https://order.pungpungkitchen.com/img/ninjaprocmn/pungpungkitchen/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'pungpungkitchen',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.pungpungkitchen.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.pungpungkitchen.com/#/',fbImage:'https://order.pungpungkitchen.com/img/pungpungkitchen/logo.png',fbTitle:'Pung Pung Kitchen',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.pungpungkitchen.com /'},/* Twitter  */tw:{twURL:'https://order.pungpungkitchen.com/#/',twTitile:'Pung Pung Kitchen',twvia:'Pung Pung Kitchen'},/* google Plus data   */gp:{gpURL:'https://order.pungpungkitchen.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.pungpungkitchen.com/#/',waSeparator:'Pung Pung Kitchen'},site_title:'Pung Pung Kitchen',site_title_with_separator:' | Pung Pung Kitchen',home_meta_title:"Welcome to Pung Pung Kitchen",bgimage:'/img/ninjaprocmn/pungpungkitchen/body_bg.jpg'}),_defineProperty(_domainValues,"order.ministarfermentedbeancurd.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"3D55242D-EEFA-4849-9E3A-EF7442380931",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'MINI STAR',stripeImage:"https://order.ministarfermentedbeancurd.com/img/ninjaprocmn/ministar/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ministar',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.ministarfermentedbeancurd.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.ministarfermentedbeancurd.com/#/',fbImage:'https://order.ministarfermentedbeancurd.com/img/ministar/logo.png',fbTitle:'MINI STAR',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.ministarfermentedbeancurd.com /'},/* Twitter  */tw:{twURL:'https://order.ministarfermentedbeancurd.com/#/',twTitile:'MINI STAR',twvia:'MINI STAR'},/* google Plus data   */gp:{gpURL:'https://order.ministarfermentedbeancurd.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.ministarfermentedbeancurd.com/#/',waSeparator:'MINI STAR'},site_title:'MINI STAR',site_title_with_separator:' | MINI STAR',home_meta_title:"Welcome to MINI STAR",bgimage:'/img/ninjaprocmn/ministar/body_bg.jpg'}),_defineProperty(_domainValues,"order.theblacksheepcafe.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"3BBC2C53-B9B0-47DA-ACB5-BB703A8FB04E",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'The Black Sheep Cafe',stripeImage:"https://order.theblacksheepcafe.com/img/ninjaprocmn/theblacksheepcafe/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'theblacksheepcafe',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.theblacksheepcafe.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.theblacksheepcafe.com/#/',fbImage:'https://order.theblacksheepcafe.com/img/theblacksheepcafe/logo.png',fbTitle:'The Black Sheep Cafe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.theblacksheepcafe.com /'},/* Twitter  */tw:{twURL:'https://order.theblacksheepcafe.com/#/',twTitile:'The Black Sheep Cafe',twvia:'The Black Sheep Cafe'},/* google Plus data   */gp:{gpURL:'https://order.theblacksheepcafe.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.theblacksheepcafe.com/#/',waSeparator:'The Black Sheep Cafe'},site_title:'The Black Sheep Cafe',site_title_with_separator:' | The Black Sheep Cafe',home_meta_title:"Welcome to The Black Sheep Cafe",bgimage:'/img/ninjaprocmn/theblacksheepcafe/body_bg.jpg'}),_defineProperty(_domainValues,"order.chezbiryaneco.com.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"8FA5ED0C-5482-46CA-8534-FF8BDE22056F",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Chez Biryane',stripeImage:"https://order.chezbiryaneco.com.sg/img/ninjaprocmn/chezbiryaneco/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'chezbiryaneco',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.chezbiryaneco.com.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.chezbiryaneco.com.sg/#/',fbImage:'https://order.chezbiryaneco.com.sg/img/chezbiryaneco/logo.png',fbTitle:'Chez Biryane',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.chezbiryaneco.com.sg /'},/* Twitter  */tw:{twURL:'https://order.chezbiryaneco.com.sg/#/',twTitile:'Chez Biryane',twvia:'Chez Biryane'},/* google Plus data   */gp:{gpURL:'https://order.chezbiryaneco.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.chezbiryaneco.com.sg/#/',waSeparator:'Chez Biryane'},site_title:'Chez Biryane',site_title_with_separator:' | Chez Biryane',home_meta_title:"Welcome to Chez Biryane",bgimage:'/img/ninjaprocmn/chezbiryaneco/body_bg.jpg'}),_defineProperty(_domainValues,"order.bedok85oysteromelette.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"B93F0EAA-A13A-48D5-B0EF-7B7550787955",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'BEDOK 85 FRIED OYSTER PTE',stripeImage:"https://order.bedok85oysteromelette.com/img/ninjaprocmn/bedok85oysteromelette/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'bedok85oysteromelette',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.bedok85oysteromelette.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.bedok85oysteromelette.com/#/',fbImage:'https://order.bedok85oysteromelette.com/img/bedok85oysteromelette/logo.png',fbTitle:'BEDOK 85 FRIED OYSTER PTE',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.bedok85oysteromelette.com /'},/* Twitter  */tw:{twURL:'https://order.bedok85oysteromelette.com/#/',twTitile:'BEDOK 85 FRIED OYSTER PTE',twvia:'BEDOK 85 FRIED OYSTER PTE'},/* google Plus data   */gp:{gpURL:'https://order.bedok85oysteromelette.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.bedok85oysteromelette.com/#/',waSeparator:'BEDOK 85 FRIED OYSTER PTE'},site_title:'BEDOK 85 FRIED OYSTER PTE',site_title_with_separator:' | BEDOK 85 FRIED OYSTER PTE',home_meta_title:"Welcome to BEDOK 85 FRIED OYSTER PTE",bgimage:'/img/ninjaprocmn/bedok85oysteromelette/body_bg.jpg'}),_defineProperty(_domainValues,"www.thechailounge.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"1B8B9475-E42E-4CED-8A7C-25A37E69FF2A",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'The Chai Lounge',stripeImage:"https://www.thechailounge.sg/img/ninjaprocmn/thechailounge/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'thechailounge',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.thechailounge.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.thechailounge.sg/#/',fbImage:'https://www.thechailounge.sg/img/thechailounge/logo.png',fbTitle:'The Chai Lounge',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.thechailounge.sg /'},/* Twitter  */tw:{twURL:'https://www.thechailounge.sg/#/',twTitile:'The Chai Lounge',twvia:'The Chai Lounge'},/* google Plus data   */gp:{gpURL:'https://www.thechailounge.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://www.thechailounge.sg/#/',waSeparator:'The Chai Lounge'},site_title:'The Chai Lounge',forcewww:'YES',site_title_with_separator:' | The Chai Lounge',home_meta_title:"Welcome to The Chai Lounge",bgimage:'/img/ninjaprocmn/thechailounge/body_bg.jpg'}),_defineProperty(_domainValues,"order.moosh.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"137FF94D-F8D5-4D63-A588-26D0856A92C8",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Moosh Softserve',stripeImage:"https://order.moosh.sg/img/ninjaprocmn/moosh/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'moosh',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.moosh.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.moosh.sg/#/',fbImage:'https://order.moosh.sg/img/moosh/logo.png',fbTitle:'Moosh Softserve',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.moosh.sg /'},/* Twitter  */tw:{twURL:'https://order.moosh.sg/#/',twTitile:'Moosh Softserve',twvia:'Moosh Softserve'},/* google Plus data   */gp:{gpURL:'https://order.moosh.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.moosh.sg/#/',waSeparator:'Moosh Softserve'},site_title:'Moosh Softserve',site_title_with_separator:' | Moosh Softserve',home_meta_title:"Welcome to Moosh Softserve",bgimage:'/img/ninjaprocmn/moosh/body_bg.jpg'}),_defineProperty(_domainValues,"order.asamtree.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D40E0C2F-A4B8-474F-B92E-C3EA9D2B5F25",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Asam Tree',stripeImage:"https://order.asamtree.com/img/ninjaprocmn/asamtree/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'asamtree',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.asamtree.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.asamtree.com/#/',fbImage:'https://order.asamtree.com/img/asamtree/logo.png',fbTitle:'Asam Tree',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.asamtree.com /'},/* Twitter  */tw:{twURL:'https://order.asamtree.com/#/',twTitile:'Asam Tree',twvia:'Asam Tree'},/* google Plus data   */gp:{gpURL:'https://order.asamtree.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.asamtree.com/#/',waSeparator:'Asam Tree'},site_title:'Asam Tree',site_title_with_separator:' | Asam Tree',home_meta_title:"Welcome to Asam Tree",bgimage:'/img/ninjaprocmn/asamtree/body_bg.jpg'}),_defineProperty(_domainValues,"www.zhenvegetarian.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"72963D8E-D367-45CE-BA71-CE38B52EFC7E",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'ZHEN VEGETARIAN',stripeImage:"https://www.zhenvegetarian.com/img/ninjaprocmn/zhenvegetarian/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'zhenvegetarian',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.zhenvegetarian.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.zhenvegetarian.com/#/',fbImage:'https://www.zhenvegetarian.com/img/zhenvegetarian/logo.png',fbTitle:'ZHEN VEGETARIAN',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.zhenvegetarian.com /'},/* Twitter  */tw:{twURL:'https://www.zhenvegetarian.com/#/',twTitile:'ZHEN VEGETARIAN',twvia:'ZHEN VEGETARIAN'},/* google Plus data   */gp:{gpURL:'https://www.zhenvegetarian.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.zhenvegetarian.com/#/',waSeparator:'ZHEN VEGETARIAN'},site_title:'ZHEN VEGETARIAN',forcewww:'YES',site_title_with_separator:' | ZHEN VEGETARIAN',home_meta_title:"Welcome to ZHEN VEGETARIAN",bgimage:'/img/ninjaprocmn/zhenvegetarian/body_bg.jpg'}),_defineProperty(_domainValues,"order.syed-cafe.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E3CF7BD4-6B20-4E1C-A126-CBE3ED1EB975",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Syed Cafe',stripeImage:"https://order.syed-cafe.com/img/ninjaprocmn/syed-cafe/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'syed-cafe',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.syed-cafe.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.syed-cafe.com/#/',fbImage:'https://order.syed-cafe.com/img/syed-cafe/logo.png',fbTitle:'Syed Cafe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.syed-cafe.com /'},/* Twitter  */tw:{twURL:'https://order.syed-cafe.com/#/',twTitile:'Syed Cafe',twvia:'Syed Cafe'},/* google Plus data   */gp:{gpURL:'https://order.syed-cafe.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.syed-cafe.com/#/',waSeparator:'Syed Cafe'},site_title:'Syed Cafe',site_title_with_separator:' | Syed Cafe',home_meta_title:"Welcome to Syed Cafe",bgimage:'/img/ninjaprocmn/syed-cafe/body_bg.jpg'}),_defineProperty(_domainValues,"order.mixedgreens.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F79AC4C3-9BD4-456B-86DB-99842DDA4F21",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Mixed Greens',stripeImage:"https://order.mixedgreens.sg/img/ninjaprocmn/mixedgreens/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'mixedgreens',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.mixedgreens.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.mixedgreens.sg/#/',fbImage:'https://order.mixedgreens.sg/img/mixedgreens/logo.png',fbTitle:'Mixed Greens',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.mixedgreens.sg /'},/* Twitter  */tw:{twURL:'https://order.mixedgreens.sg/#/',twTitile:'Mixed Greens',twvia:'Mixed Greens'},/* google Plus data   */gp:{gpURL:'https://order.mixedgreens.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.mixedgreens.sg/#/',waSeparator:'Mixed Greens'},site_title:'Mixed Greens',site_title_with_separator:' | Mixed Greens',home_meta_title:"Welcome to Mixed Greens",bgimage:'/img/ninjaprocmn/mixedgreens/body_bg.jpg'}),_defineProperty(_domainValues,"order.manmanchisg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"796C89C5-882E-44B2-BFE9-A549D903E32B",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Man Man Chi',stripeImage:"https://order.manmanchisg.com/img/ninjaprocmn/manmanchisg/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'manmanchisg',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.manmanchisg.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.manmanchisg.com/#/',fbImage:'https://order.manmanchisg.com/img/manmanchisg/logo.png',fbTitle:'Man Man Chi',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.manmanchisg.com /'},/* Twitter  */tw:{twURL:'https://order.manmanchisg.com/#/',twTitile:'Man Man Chi',twvia:'Man Man Chi'},/* google Plus data   */gp:{gpURL:'https://order.manmanchisg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.manmanchisg.com/#/',waSeparator:'Man Man Chi'},site_title:'Man Man Chi',site_title_with_separator:' | Man Man Chi',home_meta_title:"Welcome to Man Man Chi",bgimage:'/img/ninjaprocmn/manmanchisg/body_bg.jpg'}),_defineProperty(_domainValues,"orders.teabrary.online",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"DF79B08D-141B-425E-9143-A4C8D4D007AB",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Stars Tea and Coffee Asia',stripeImage:"https://orders.teabrary.online/img/ninjaprocmn/teabrary/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'teabrary',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://orders.teabrary.online /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://orders.teabrary.online/#/',fbImage:'https://orders.teabrary.online/img/teabrary/logo.png',fbTitle:'Stars Tea and Coffee Asia',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://orders.teabrary.online /'},/* Twitter  */tw:{twURL:'https://orders.teabrary.online/#/',twTitile:'Stars Tea and Coffee Asia',twvia:'Stars Tea and Coffee Asia'},/* google Plus data   */gp:{gpURL:'https://orders.teabrary.online/#/'},/* Whatsapp data   */wa:{waURL:'https://orders.teabrary.online/#/',waSeparator:'Stars Tea and Coffee Asia'},site_title:'Stars Tea and Coffee Asia',site_title_with_separator:' | Stars Tea and Coffee Asia',home_meta_title:"Welcome to Stars Tea and Coffee Asia",bgimage:'/img/ninjaprocmn/teabrary/body_bg.jpg'}),_defineProperty(_domainValues,"www.desertdessert.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"C920B567-99E7-452E-ABFC-CEF90FF311E2",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'DESERT DESSERT',stripeImage:"https://www.desertdessert.sg/img/ninjaprocmn/desertdessert/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'desertdessert',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.desertdessert.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.desertdessert.sg/#/',fbImage:'https://www.desertdessert.sg/img/desertdessert/logo.png',fbTitle:'DESERT DESSERT',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.desertdessert.sg /'},/* Twitter  */tw:{twURL:'https://www.desertdessert.sg/#/',twTitile:'DESERT DESSERT',twvia:'DESERT DESSERT'},/* google Plus data   */gp:{gpURL:'https://www.desertdessert.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://www.desertdessert.sg/#/',waSeparator:'DESERT DESSERT'},site_title:'DESERT DESSERT',forcewww:'YES',site_title_with_separator:' | DESERT DESSERT',home_meta_title:"Welcome to DESERT DESSERT",bgimage:'/img/ninjaprocmn/desertdessert/body_bg.jpg'}),_defineProperty(_domainValues,"order.carrotcubes.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D4CD2AFC-78F1-4C14-B670-CF724D17FFC8",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'CARROT CUBES',stripeImage:"https://order.carrotcubes.sg/img/ninjaprocmn/carrotcubes/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'carrotcubes',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.carrotcubes.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.carrotcubes.sg/#/',fbImage:'https://order.carrotcubes.sg/img/carrotcubes/logo.png',fbTitle:'CARROT CUBES',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.carrotcubes.sg /'},/* Twitter  */tw:{twURL:'https://order.carrotcubes.sg/#/',twTitile:'CARROT CUBES',twvia:'CARROT CUBES'},/* google Plus data   */gp:{gpURL:'https://order.carrotcubes.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.carrotcubes.sg/#/',waSeparator:'CARROT CUBES'},site_title:'CARROT CUBES',site_title_with_separator:' | CARROT CUBES',home_meta_title:"Welcome to CARROT CUBES",bgimage:'/img/ninjaprocmn/carrotcubes/body_bg.jpg'}),_defineProperty(_domainValues,"order.viiogastropub.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"4C9E5828-301C-48D7-BFC8-03AA6FA4B939",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'VIIO GASTROPUB',stripeImage:"https://order.viiogastropub.com/img/ninjaprocmn/viiogastropub/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'viiogastropub',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.viiogastropub.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.viiogastropub.com/#/',fbImage:'https://order.viiogastropub.com/img/viiogastropub/logo.png',fbTitle:'VIIO GASTROPUB',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.viiogastropub.com /'},/* Twitter  */tw:{twURL:'https://order.viiogastropub.com/#/',twTitile:'VIIO GASTROPUB',twvia:'VIIO GASTROPUB'},/* google Plus data   */gp:{gpURL:'https://order.viiogastropub.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.viiogastropub.com/#/',waSeparator:'VIIO GASTROPUB'},site_title:'VIIO GASTROPUB',site_title_with_separator:' | VIIO GASTROPUB',home_meta_title:"Welcome to VIIO GASTROPUB",bgimage:'/img/ninjaprocmn/viiogastropub/body_bg.jpg'}),_defineProperty(_domainValues,"order.sinkeefamouschickenrice.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"94B08008-AB71-424D-9580-B78B4DF07194",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Sin Kee Famous Chicken Rice',stripeImage:"https://order.sinkeefamouschickenrice.com/img/ninjaprocmn/sinkeefamouschickenrice/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'sinkeefamouschickenrice',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.sinkeefamouschickenrice.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.sinkeefamouschickenrice.com/#/',fbImage:'https://order.sinkeefamouschickenrice.com/img/sinkeefamouschickenrice/logo.png',fbTitle:'Sin Kee Famous Chicken Rice',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.sinkeefamouschickenrice.com /'},/* Twitter  */tw:{twURL:'https://order.sinkeefamouschickenrice.com/#/',twTitile:'Sin Kee Famous Chicken Rice',twvia:'Sin Kee Famous Chicken Rice'},/* google Plus data   */gp:{gpURL:'https://order.sinkeefamouschickenrice.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.sinkeefamouschickenrice.com/#/',waSeparator:'Sin Kee Famous Chicken Rice'},site_title:'Sin Kee Famous Chicken Rice',site_title_with_separator:' | Sin Kee Famous Chicken Rice',home_meta_title:"Welcome to Sin Kee Famous Chicken Rice",bgimage:'/img/ninjaprocmn/sinkeefamouschickenrice/body_bg.jpg'}),_defineProperty(_domainValues,"order.switchkitchensg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F97CD809-E010-496C-8C45-804CCADAF331",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Switch Kitchen Sg',stripeImage:"https://order.switchkitchensg.com/img/ninjaprocmn/switchkitchensg/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'switchkitchensg',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.switchkitchensg.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.switchkitchensg.com/#/',fbImage:'https://order.switchkitchensg.com/img/switchkitchensg/logo.png',fbTitle:'Switch Kitchen Sg',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.switchkitchensg.com /'},/* Twitter  */tw:{twURL:'https://order.switchkitchensg.com/#/',twTitile:'Switch Kitchen Sg',twvia:'Switch Kitchen Sg'},/* google Plus data   */gp:{gpURL:'https://order.switchkitchensg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.switchkitchensg.com/#/',waSeparator:'Switch Kitchen Sg'},site_title:'Switch Kitchen Sg',site_title_with_separator:' | Switch Kitchen Sg',home_meta_title:"Welcome to Switch Kitchen Sg",bgimage:'/img/ninjaprocmn/switchkitchensg/body_bg.jpg'}),_defineProperty(_domainValues,"order.jiaxiangkolomee.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"7B637086-CDB5-461E-B93A-AF2527DEE755",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Jia Xiang Kuching',stripeImage:"https://order.jiaxiangkolomee.com/img/ninjaprocmn/jiaxiangkolomee/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'jiaxiangkolomee',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.jiaxiangkolomee.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.jiaxiangkolomee.com/#/',fbImage:'https://order.jiaxiangkolomee.com/img/jiaxiangkolomee/logo.png',fbTitle:'Jia Xiang Kuching',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.jiaxiangkolomee.com /'},/* Twitter  */tw:{twURL:'https://order.jiaxiangkolomee.com/#/',twTitile:'Jia Xiang Kuching',twvia:'Jia Xiang Kuching'},/* google Plus data   */gp:{gpURL:'https://order.jiaxiangkolomee.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.jiaxiangkolomee.com/#/',waSeparator:'Jia Xiang Kuching'},site_title:'Jia Xiang Kuching',site_title_with_separator:' | Jia Xiang Kuching',home_meta_title:"Welcome to Jia Xiang Kuching",bgimage:'/img/ninjaprocmn/jiaxiangkolomee/body_bg.jpg'}),_defineProperty(_domainValues,"www.brightaste.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"97EC1352-DEAF-41D1-AE42-A09FBC2C770D",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Shugar Gourmet',stripeImage:"https://www.brightaste.com/img/ninjaprocmn/brightaste/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'brightaste',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.brightaste.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.brightaste.com/#/',fbImage:'https://www.brightaste.com/img/brightaste/logo.png',fbTitle:'Shugar Gourmet',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.brightaste.com /'},/* Twitter  */tw:{twURL:'https://www.brightaste.com/#/',twTitile:'Shugar Gourmet',twvia:'Shugar Gourmet'},/* google Plus data   */gp:{gpURL:'https://www.brightaste.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.brightaste.com/#/',waSeparator:'Shugar Gourmet'},site_title:'Shugar Gourmet',forcewww:'YES',site_title_with_separator:' | Shugar Gourmet',home_meta_title:"Welcome to Shugar Gourmet",bgimage:'/img/ninjaprocmn/brightaste/body_bg.jpg'}),_defineProperty(_domainValues,"order.sove.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"C35B8131-D028-487F-9112-2E5D84AE7C5E",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Sove ',stripeImage:"https://order.sove.sg/img/ninjaprocmn/sove/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'sove',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.sove.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.sove.sg/#/',fbImage:'https://order.sove.sg/img/sove/logo.png',fbTitle:'Sove ',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.sove.sg /'},/* Twitter  */tw:{twURL:'https://order.sove.sg/#/',twTitile:'Sove ',twvia:'Sove '},/* google Plus data   */gp:{gpURL:'https://order.sove.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.sove.sg/#/',waSeparator:'Sove '},site_title:'Sove ',site_title_with_separator:' | Sove ',home_meta_title:"Welcome to Sove ",bgimage:'/img/ninjaprocmn/sove/body_bg.jpg'}),_defineProperty(_domainValues,"www.yiji.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"9629BD63-13E3-4E2B-96CB-2915B7CF3335",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'T&T FOODIE',stripeImage:"https://www.yiji.sg/img/ninjaprocmn/ttfood/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ttfood',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.yiji.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.yiji.sg/#/',fbImage:'https://www.yiji.sg/img/ttfood/logo.png',fbTitle:'T&T FOODIE',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.yiji.sg /'},/* Twitter  */tw:{twURL:'https://www.yiji.sg/#/',twTitile:'T&T FOODIE',twvia:'T&T FOODIE'},/* google Plus data   */gp:{gpURL:'https://www.yiji.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://www.yiji.sg/#/',waSeparator:'T&T FOODIE'},site_title:'T&T FOODIE',forcewww:'YES',site_title_with_separator:' | T&T FOODIE',home_meta_title:"Welcome to T&T FOODIE",bgimage:'/img/ninjaprocmn/ttfood/body_bg.jpg'}),_defineProperty(_domainValues,"www.annswesternfood.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"C04515C6-9F9E-40B1-91AE-D7A19B508929",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'ANNS WESTERN FOOD',stripeImage:"https://www.annswesternfood.com/img/ninjaprocmn/annswesternfood/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'annswesternfood',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.annswesternfood.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.annswesternfood.com/#/',fbImage:'https://www.annswesternfood.com/img/annswesternfood/logo.png',fbTitle:'ANNS WESTERN FOOD',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.annswesternfood.com /'},/* Twitter  */tw:{twURL:'https://www.annswesternfood.com/#/',twTitile:'ANNS WESTERN FOOD',twvia:'ANNS WESTERN FOOD'},/* google Plus data   */gp:{gpURL:'https://www.annswesternfood.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.annswesternfood.com/#/',waSeparator:'ANNS WESTERN FOOD'},site_title:'ANNS WESTERN FOOD',forcewww:'YES',site_title_with_separator:' | ANNS WESTERN FOOD',home_meta_title:"Welcome to ANNS WESTERN FOOD",bgimage:'/img/ninjaprocmn/annswesternfood/body_bg.jpg'}),_defineProperty(_domainValues,"www.lianghaus.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"79623D14-1407-412E-A3F6-2515F47DDF51",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'LIANG HAUS',stripeImage:"https://www.lianghaus.com/img/ninjaprocmn/lianghaus/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'lianghaus',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.lianghaus.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.lianghaus.com/#/',fbImage:'https://www.lianghaus.com/img/lianghaus/logo.png',fbTitle:'LIANG HAUS',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.lianghaus.com /'},/* Twitter  */tw:{twURL:'https://www.lianghaus.com/#/',twTitile:'LIANG HAUS',twvia:'LIANG HAUS'},/* google Plus data   */gp:{gpURL:'https://www.lianghaus.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.lianghaus.com/#/',waSeparator:'LIANG HAUS'},site_title:'LIANG HAUS',forcewww:'YES',site_title_with_separator:' | LIANG HAUS',home_meta_title:"Welcome to LIANG HAUS",bgimage:'/img/ninjaprocmn/lianghaus/body_bg.jpg'}),_defineProperty(_domainValues,"order.almajlis.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"10714D13-7DB8-464B-A418-7BBC6E27ED55",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Al Majlis Thai Seafood Restaurant',stripeImage:"https://order.almajlis.sg/img/ninjaprocmn/almajlisthaiseafood/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'almajlisthaiseafood',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.almajlis.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.almajlis.sg/#/',fbImage:'https://order.almajlis.sg/img/almajlisthaiseafood/logo.png',fbTitle:'Al Majlis Thai Seafood Restaurant',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.almajlis.sg /'},/* Twitter  */tw:{twURL:'https://order.almajlis.sg/#/',twTitile:'Al Majlis Thai Seafood Restaurant',twvia:'Al Majlis Thai Seafood Restaurant'},/* google Plus data   */gp:{gpURL:'https://order.almajlis.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.almajlis.sg/#/',waSeparator:'Al Majlis Thai Seafood Restaurant'},site_title:'Al Majlis Thai Seafood Restaurant',site_title_with_separator:' | Al Majlis Thai Seafood Restaurant',home_meta_title:"Welcome to Al Majlis Thai Seafood Restaurant",bgimage:'/img/ninjaprocmn/almajlisthaiseafood/body_bg.jpg'}),_defineProperty(_domainValues,"order.jamilcatering.co",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"B01FEEE4-6834-4F05-A67A-91CF5719D069",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'JAMIL CATERING',stripeImage:"https://order.jamilcatering.co/img/ninjaprocmn/jamilcatering/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'jamilcatering',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.jamilcatering.co /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.jamilcatering.co/#/',fbImage:'https://order.jamilcatering.co/img/jamilcatering/logo.png',fbTitle:'JAMIL CATERING',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.jamilcatering.co /'},/* Twitter  */tw:{twURL:'https://order.jamilcatering.co/#/',twTitile:'JAMIL CATERING',twvia:'JAMIL CATERING'},/* google Plus data   */gp:{gpURL:'https://order.jamilcatering.co/#/'},/* Whatsapp data   */wa:{waURL:'https://order.jamilcatering.co/#/',waSeparator:'JAMIL CATERING'},site_title:'JAMIL CATERING',site_title_with_separator:' | JAMIL CATERING',home_meta_title:"Welcome to JAMIL CATERING",bgimage:'/img/ninjaprocmn/jamilcatering/body_bg.jpg'}),_defineProperty(_domainValues,"order.centong.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"B562096E-63E5-4F7F-B2F8-08A217C83E50",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Centong',stripeImage:"https://order.centong.sg/img/ninjaprocmn/centong/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'centong',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.centong.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.centong.sg/#/',fbImage:'https://order.centong.sg/img/centong/logo.png',fbTitle:'Centong',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.centong.sg /'},/* Twitter  */tw:{twURL:'https://order.centong.sg/#/',twTitile:'Centong',twvia:'Centong'},/* google Plus data   */gp:{gpURL:'https://order.centong.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.centong.sg/#/',waSeparator:'Centong'},site_title:'Centong',site_title_with_separator:' | Centong',home_meta_title:"Welcome to Centong",bgimage:'/img/ninjaprocmn/centong/body_bg.jpg'}),_defineProperty(_domainValues,"www.lifebowlsg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"3286367D-CB18-4B7B-9F17-8D1E8F6FBFA9",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Lifebowl',stripeImage:"https://www.lifebowlsg.com/img/ninjaprocmn/lifebowlsg/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'lifebowlsg',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.lifebowlsg.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.lifebowlsg.com/#/',fbImage:'https://www.lifebowlsg.com/img/lifebowlsg/logo.png',fbTitle:'Lifebowl',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.lifebowlsg.com /'},/* Twitter  */tw:{twURL:'https://www.lifebowlsg.com/#/',twTitile:'Lifebowl',twvia:'Lifebowl'},/* google Plus data   */gp:{gpURL:'https://www.lifebowlsg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.lifebowlsg.com/#/',waSeparator:'Lifebowl'},site_title:'Lifebowl',forcewww:'YES',site_title_with_separator:' | Lifebowl',home_meta_title:"Welcome to Lifebowl",bgimage:'/img/ninjaprocmn/lifebowlsg/body_bg.jpg'}),_defineProperty(_domainValues,"order.samrang.com.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"C0E58DA0-FD5F-45E8-A4BA-3D9145311D85",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Samrang',stripeImage:"https://order.samrang.com.sg/img/ninjaprocmn/samrang/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'samrang',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.samrang.com.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.samrang.com.sg/#/',fbImage:'https://order.samrang.com.sg/img/samrang/logo.png',fbTitle:'Samrang',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.samrang.com.sg /'},/* Twitter  */tw:{twURL:'https://order.samrang.com.sg/#/',twTitile:'Samrang',twvia:'Samrang'},/* google Plus data   */gp:{gpURL:'https://order.samrang.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.samrang.com.sg/#/',waSeparator:'Samrang'},site_title:'Samrang',site_title_with_separator:' | Samrang',home_meta_title:"Welcome to Samrang",bgimage:'/img/ninjaprocmn/samrang/body_bg.jpg'}),_defineProperty(_domainValues,"order.whitfieldstreetbakery.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"145E3A37-C131-4603-A5EB-52AEA37E748C",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Whitfield Street Bakery',stripeImage:"https://order.whitfieldstreetbakery.com/img/ninjaprocmn/whitfieldstbakery/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'whitfieldstbakery',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.whitfieldstreetbakery.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.whitfieldstreetbakery.com/#/',fbImage:'https://order.whitfieldstreetbakery.com/img/whitfieldstbakery/logo.png',fbTitle:'Whitfield Street Bakery',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.whitfieldstreetbakery.com /'},/* Twitter  */tw:{twURL:'https://order.whitfieldstreetbakery.com/#/',twTitile:'Whitfield Street Bakery',twvia:'Whitfield Street Bakery'},/* google Plus data   */gp:{gpURL:'https://order.whitfieldstreetbakery.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.whitfieldstreetbakery.com/#/',waSeparator:'Whitfield Street Bakery'},site_title:'Whitfield Street Bakery',forcewww:'YES',site_title_with_separator:' | Whitfield Street Bakery',home_meta_title:"Welcome to Whitfield Street Bakery",bgimage:'/img/ninjaprocmn/whitfieldstbakery/body_bg.jpg'}),_defineProperty(_domainValues,"www.kiposkitchen.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"1A19B725-8B45-4414-9713-5F270E557D6A",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Kipos Kitchen',stripeImage:"https://www.kiposkitchen.sg/img/ninjaprocmn/kiposkitchen/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'kiposkitchen',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.kiposkitchen.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.kiposkitchen.sg/#/',fbImage:'https://www.kiposkitchen.sg/img/kiposkitchen/logo.png',fbTitle:'Kipos Kitchen',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.kiposkitchen.sg /'},/* Twitter  */tw:{twURL:'https://www.kiposkitchen.sg/#/',twTitile:'Kipos Kitchen',twvia:'Kipos Kitchen'},/* google Plus data   */gp:{gpURL:'https://www.kiposkitchen.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://www.kiposkitchen.sg/#/',waSeparator:'Kipos Kitchen'},site_title:'Kipos Kitchen',forcewww:'YES',site_title_with_separator:' | Kipos Kitchen',home_meta_title:"Welcome to Kipos Kitchen",bgimage:'/img/ninjaprocmn/kiposkitchen/body_bg.jpg'}),_defineProperty(_domainValues,"order.flavvorsgourmet.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D8F2F4D4-079D-4CE9-B025-C9073C8D045F",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Flavvors Gourmet',stripeImage:"https://order.flavvorsgourmet.sg/img/ninjaprocmn/flavvorsgourmet/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'flavvorsgourmet',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.flavvorsgourmet.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.flavvorsgourmet.sg/#/',fbImage:'https://order.flavvorsgourmet.sg/img/flavvorsgourmet/logo.png',fbTitle:'Flavvors Gourmet',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.flavvorsgourmet.sg /'},/* Twitter  */tw:{twURL:'https://order.flavvorsgourmet.sg/#/',twTitile:'Flavvors Gourmet',twvia:'Flavvors Gourmet'},/* google Plus data   */gp:{gpURL:'https://order.flavvorsgourmet.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.flavvorsgourmet.sg/#/',waSeparator:'Flavvors Gourmet'},site_title:'Flavvors Gourmet',forcewww:'YES',site_title_with_separator:' | Flavvors Gourmet',home_meta_title:"Welcome to Flavvors Gourmet",bgimage:'/img/ninjaprocmn/flavvorsgourmet/body_bg.jpg'}),_defineProperty(_domainValues,"www.tandooribites.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"1DD31A95-B02E-45C3-8EA3-7EB68F8D0E9A",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Tandoori Bites',stripeImage:"https://www.tandooribites.sg/img/ninjaprocmn/tandooribites/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'tandooribites',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.tandooribites.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.tandooribites.sg/#/',fbImage:'https://www.tandooribites.sg/img/tandooribites/logo.png',fbTitle:'Tandoori Bites',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.tandooribites.sg /'},/* Twitter  */tw:{twURL:'https://www.tandooribites.sg/#/',twTitile:'Tandoori Bites',twvia:'Tandoori Bites'},/* google Plus data   */gp:{gpURL:'https://www.tandooribites.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://www.tandooribites.sg/#/',waSeparator:'Tandoori Bites'},site_title:'Tandoori Bites',forcewww:'YES',site_title_with_separator:' | Tandoori Bites',home_meta_title:"Welcome to Tandoori Bites",bgimage:'/img/ninjaprocmn/tandooribites/body_bg.jpg'}),_defineProperty(_domainValues,"order.projectburgs.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E68BBCD4-9C71-41EA-8BF8-84DF3222CC67",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Burgs',stripeImage:"https://order.projectburgs.com/img/ninjaprocmn/burgs/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'burgs',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.projectburgs.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.projectburgs.com/#/',fbImage:'https://order.projectburgs.com/img/burgs/logo.png',fbTitle:'Burgs',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.projectburgs.com/'},/* Twitter  */tw:{twURL:'https://order.projectburgs.com/#/',twTitile:'Burgs',twvia:'Burgs'},/* google Plus data   */gp:{gpURL:'https://order.projectburgs.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.projectburgs.com/#/',waSeparator:'Burgs'},site_title:'Burgs',site_title_with_separator:' | Burgs',home_meta_title:"Welcome to Burgs",bgimage:'/img/ninjaprocmn/burgs/body_bg.jpg'}),_defineProperty(_domainValues,"order.beirut.com.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"014E9FC6-A56D-43AF-A39C-1F8CDAA4D59B",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Beirut Grill',stripeImage:"https://order.beirut.com.sg/img/ninjaprocmn/beirut/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'beirut',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.beirut.com.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.beirut.com.sg/#/',fbImage:'https://order.beirut.com.sg/img/beirut/logo.png',fbTitle:'Beirut Grill',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.beirut.com.sg /'},/* Twitter  */tw:{twURL:'https://order.beirut.com.sg/#/',twTitile:'Beirut Grill',twvia:'Beirut Grill'},/* google Plus data   */gp:{gpURL:'https://order.beirut.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.beirut.com.sg/#/',waSeparator:'Beirut Grill'},site_title:'Beirut Grill',site_title_with_separator:' | Beirut Grill',home_meta_title:"Welcome to Beirut Grill",bgimage:'/img/ninjaprocmn/beirut/body_bg.jpg'}),_defineProperty(_domainValues,"order.biryanibrews.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"71F68480-A4B8-4B02-B5D5-44A5CD393EA1",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Biryani Brews',stripeImage:"https://order.biryanibrews.sg/img/ninjaprocmn/biryanibrews/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'biryanibrews',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.biryanibrews.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.biryanibrews.sg/#/',fbImage:'https://order.biryanibrews.sg/img/biryanibrews/logo.png',fbTitle:'Biryani Brews',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.biryanibrews.sg /'},/* Twitter  */tw:{twURL:'https://order.biryanibrews.sg/#/',twTitile:'Biryani Brews',twvia:'Biryani Brews'},/* google Plus data   */gp:{gpURL:'https://order.biryanibrews.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.biryanibrews.sg/#/',waSeparator:'Biryani Brews'},site_title:'Biryani Brews',site_title_with_separator:' | Biryani Brews',home_meta_title:"Welcome to Biryani Brews",bgimage:'/img/ninjaprocmn/biryanibrews/body_bg.jpg'}),_defineProperty(_domainValues,"order.ahyatrestaurant.com.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"B9618066-964F-4948-AFFE-C569D2F3126B",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Owen Seafood Restaurant',stripeImage:"https://order.ahyatrestaurant.com.sg/img/ninjaprocmn/ahyatrestaurant/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ahyatrestaurant',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.ahyatrestaurant.com.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.ahyatrestaurant.com.sg/#/',fbImage:'https://order.ahyatrestaurant.com.sg/img/ahyatrestaurant/logo.png',fbTitle:'Owen Seafood Restaurant',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.ahyatrestaurant.com.sg /'},/* Twitter  */tw:{twURL:'https://order.ahyatrestaurant.com.sg/#/',twTitile:'Owen Seafood Restaurant',twvia:'Owen Seafood Restaurant'},/* google Plus data   */gp:{gpURL:'https://order.ahyatrestaurant.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.ahyatrestaurant.com.sg/#/',waSeparator:'Owen Seafood Restaurant'},site_title:'Owen Seafood Restaurant',site_title_with_separator:' | Owen Seafood Restaurant',home_meta_title:"Welcome to Owen Seafood Restaurant",bgimage:'/img/ninjaprocmn/ahyatrestaurant/body_bg.jpg'}),_defineProperty(_domainValues,"www.zarinabegum.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F8A09672-EFCB-4740-AAD4-B30E53233A00",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Zarina Begum',stripeImage:"https://www.zarinabegum.com/img/ninjaprocmn/zarinabegum/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'zarinabegum',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.zarinabegum.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.zarinabegum.com/#/',fbImage:'https://www.zarinabegum.com/img/zarinabegum/logo.png',fbTitle:'Zarina Begum',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.zarinabegum.com /'},/* Twitter  */tw:{twURL:'https://www.zarinabegum.com/#/',twTitile:'Zarina Begum',twvia:'Zarina Begum'},/* google Plus data   */gp:{gpURL:'https://www.zarinabegum.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.zarinabegum.com/#/',waSeparator:'Zarina Begum'},site_title:'Zarina Begum',forcewww:'YES',site_title_with_separator:' | Zarina Begum',home_meta_title:"Welcome to Zarina Begum",bgimage:'/img/ninjaprocmn/zarinabegum/body_bg.jpg'}),_defineProperty(_domainValues,"order.fangko.co",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"751C03C3-825B-4FC8-80CB-C61B20FA70BA",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Fangko',stripeImage:"https://order.fangko.co/img/ninjaprocmn/fangko/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'fangko',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.fangko.co /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.fangko.co/#/',fbImage:'https://order.fangko.co/img/fangko/logo.png',fbTitle:'Fangko',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.fangko.co /'},/* Twitter  */tw:{twURL:'https://order.fangko.co/#/',twTitile:'Fangko',twvia:'Fangko'},/* google Plus data   */gp:{gpURL:'https://order.fangko.co/#/'},/* Whatsapp data   */wa:{waURL:'https://order.fangko.co/#/',waSeparator:'Fangko'},site_title:'Fangko',site_title_with_separator:' | Fangko',home_meta_title:"Welcome to Fangko",bgimage:'/img/ninjaprocmn/fangko/body_bg.jpg'}),_defineProperty(_domainValues,"www.kuehbykakwan.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"B8AB6B91-B8A5-49F9-9CA8-A1A7E910362E",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Fangko',stripeImage:"https://www.kuehbykakwan.sg/img/ninjaprocmn/kuehbykakwan/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'kuehbykakwan',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.kuehbykakwan.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.kuehbykakwan.sg/#/',fbImage:'https://www.kuehbykakwan.sg/img/kuehbykakwan/logo.png',fbTitle:'Kueh by Kak Wan',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.kuehbykakwan.sg/'},/* Twitter  */tw:{twURL:'https://www.kuehbykakwan.sg/#/',twTitile:'Kueh by Kak Wan',twvia:'Kueh by Kak Wan'},/* google Plus data   */gp:{gpURL:'https://www.kuehbykakwan.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://www.kuehbykakwan.sg/#/',waSeparator:'Kueh by Kak Wan'},site_title:'Kueh by Kak Wan',site_title_with_separator:' | Kueh by Kak Wan',home_meta_title:"Welcome to Kueh by Kak Wan",bgimage:'/img/ninjaprocmn/kuehbykakwan/body_bg.jpg'}),_defineProperty(_domainValues,"www.ichiwangtori.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E84B2EC4-5D90-46BE-A775-EC9D6173BD67",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Ichiwang Tori',stripeImage:"https://www.ichiwangtori.com/img/ninjaprocmn/ichiwangtori/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ichiwangtori',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.ichiwangtori.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.ichiwangtori.com/#/',fbImage:'https://www.ichiwangtori.com/img/ichiwangtori/logo.png',fbTitle:'Ichiwang Tori',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.ichiwangtori.com /'},/* Twitter  */tw:{twURL:'https://www.ichiwangtori.com/#/',twTitile:'Ichiwang Tori',twvia:'Ichiwang Tori'},/* google Plus data   */gp:{gpURL:'https://www.ichiwangtori.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.ichiwangtori.com/#/',waSeparator:'Ichiwang Tori'},site_title:'Ichiwang Tori',forcewww:'YES',site_title_with_separator:' | Ichiwang Tori',home_meta_title:"Welcome to Ichiwang Tori",bgimage:'/img/ninjaprocmn/ichiwangtori/body_bg.jpg'}),_defineProperty(_domainValues,"www.putraminangsg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"1450D789-6446-4AE2-B2FA-5E0231264390",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Putra Minang',stripeImage:"https://www.putraminangsg.com/img/ninjaprocmn/putraminangsg/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'putraminangsg',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.putraminangsg.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.putraminangsg.com/#/',fbImage:'https://www.putraminangsg.com/img/putraminangsg/logo.png',fbTitle:'Putra Minang',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.putraminangsg.com /'},/* Twitter  */tw:{twURL:'https://www.putraminangsg.com/#/',twTitile:'Putra Minang',twvia:'Putra Minang'},/* google Plus data   */gp:{gpURL:'https://www.putraminangsg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.putraminangsg.com/#/',waSeparator:'Putra Minang'},site_title:'Putra Minang',forcewww:'YES',site_title_with_separator:' | Putra Minang',home_meta_title:"Welcome to Putra Minang",bgimage:'/img/ninjaprocmn/putraminangsg/body_bg.jpg'}),_defineProperty(_domainValues,"www.orientaldesserts.com.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"3CB2DAE9-8FCE-4A3D-BD9B-ECBE2A71E484",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Oriental Desserts',stripeImage:"https://www.orientaldesserts.com.sg/img/ninjaprocmn/orientaldesserts/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'orientaldesserts',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.orientaldesserts.com.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.orientaldesserts.com.sg/#/',fbImage:'https://www.orientaldesserts.com.sg/img/orientaldesserts/logo.png',fbTitle:'Oriental Desserts',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.orientaldesserts.com.sg /'},/* Twitter  */tw:{twURL:'https://www.orientaldesserts.com.sg/#/',twTitile:'Oriental Desserts',twvia:'Oriental Desserts'},/* google Plus data   */gp:{gpURL:'https://www.orientaldesserts.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://www.orientaldesserts.com.sg/#/',waSeparator:'Oriental Desserts'},site_title:'Oriental Desserts',forcewww:'YES',site_title_with_separator:' | Oriental Desserts',home_meta_title:"Welcome to Oriental Desserts",bgimage:'/img/ninjaprocmn/orientaldesserts/body_bg.jpg'}),_defineProperty(_domainValues,"order.sgmy.com.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E155EED2-6C5B-442F-A14E-CBFCDF350E09",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Auriga Culinary',stripeImage:"https://order.sgmy.com.sg/img/ninjaprocmn/sgmy/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'sgmy',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.sgmy.com.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.sgmy.com.sg/#/',fbImage:'https://order.sgmy.com.sg/img/sgmy/logo.png',fbTitle:'Auriga Culinary',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.sgmy.com.sg /'},/* Twitter  */tw:{twURL:'https://order.sgmy.com.sg/#/',twTitile:'Auriga Culinary',twvia:'Auriga Culinary'},/* google Plus data   */gp:{gpURL:'https://order.sgmy.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.sgmy.com.sg/#/',waSeparator:'Auriga Culinary'},site_title:'Auriga Culinary',site_title_with_separator:' | Auriga Culinary',home_meta_title:"Welcome to Auriga Culinary",bgimage:'/img/ninjaprocmn/sgmy/body_bg.jpg'}),_defineProperty(_domainValues,"order.lowercase.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"118FDED9-B1D3-455D-90A9-5C8BE9B880FF",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Broun Cafe',stripeImage:"https://order.lowercase.sg/img/ninjaprocmn/lowercase/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'lowercase',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.lowercase.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.lowercase.sg/#/',fbImage:'https://order.lowercase.sg/img/lowercase/logo.png',fbTitle:'Broun Cafe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.lowercase.sg /'},/* Twitter  */tw:{twURL:'https://order.lowercase.sg/#/',twTitile:'Broun Cafe',twvia:'Broun Cafe'},/* google Plus data   */gp:{gpURL:'https://order.lowercase.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.lowercase.sg/#/',waSeparator:'Broun Cafe'},site_title:'Broun Cafe',site_title_with_separator:' | Broun Cafe',home_meta_title:"Welcome to Broun Cafe ",bgimage:'/img/ninjaprocmn/lowercase/body_bg.jpg'}),_defineProperty(_domainValues,"order.ciel.com.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"7A4DF3BB-B383-4D1F-8986-C157BE4C18A9",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Ciel Patisserie',stripeImage:"https://order.ciel.com.sg/img/ninjaprocmn/ciel/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ciel',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.ciel.com.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.ciel.com.sg/#/',fbImage:'https://order.ciel.com.sg/img/ciel/logo.png',fbTitle:'Ciel Patisserie',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.ciel.com.sg /'},/* Twitter  */tw:{twURL:'https://order.ciel.com.sg/#/',twTitile:'Ciel Patisserie',twvia:'Ciel Patisserie'},/* google Plus data   */gp:{gpURL:'https://order.ciel.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.ciel.com.sg/#/',waSeparator:'Ciel Patisserie'},site_title:'Ciel Patisserie',site_title_with_separator:' | Ciel Patisserie',home_meta_title:"Welcome to Ciel Patisserie",bgimage:'/img/ninjaprocmn/ciel/body_bg.jpg'}),_defineProperty(_domainValues,"order.forknspoonsg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"1DA36208-F0D4-4B33-ADE6-7707AC709FFA",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Fork and Spoon',stripeImage:"https://order.forknspoonsg.com/img/ninjaprocmn/forknspoonsg/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'forknspoonsg',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.forknspoonsg.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.forknspoonsg.com/#/',fbImage:'https://order.forknspoonsg.com/img/forknspoonsg/logo.png',fbTitle:'Fork and Spoon',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.forknspoonsg.com /'},/* Twitter  */tw:{twURL:'https://order.forknspoonsg.com/#/',twTitile:'Fork and Spoon',twvia:'Fork and Spoon'},/* google Plus data   */gp:{gpURL:'https://order.forknspoonsg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.forknspoonsg.com/#/',waSeparator:'Fork and Spoon'},site_title:'Fork and Spoon',site_title_with_separator:' | Fork and Spoon',home_meta_title:"Welcome to Fork and Spoon",bgimage:'/img/ninjaprocmn/forknspoonsg/body_bg.jpg'}),_defineProperty(_domainValues,"www.sedapwok.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"1111111",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Siam Wok',stripeImage:"https://www.sedapwok.com/img/ninjaprocmn/sedapwok/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'sedapwok',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.sedapwok.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.sedapwok.com/#/',fbImage:'https://www.sedapwok.com/img/sedapwok/logo.png',fbTitle:'Siam Wok',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.sedapwok.com /'},/* Twitter  */tw:{twURL:'https://www.sedapwok.com/#/',twTitile:'Siam Wok',twvia:'Siam Wok'},/* google Plus data   */gp:{gpURL:'https://www.sedapwok.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.sedapwok.com/#/',waSeparator:'Siam Wok'},site_title:'Siam Wok',forcewww:'YES',site_title_with_separator:' | Siam Wok',home_meta_title:"Welcome to Siam Wok",bgimage:'/img/ninjaprocmn/sedapwok/body_bg.jpg'}),_defineProperty(_domainValues,"order.walkingonsunshine.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"4696350D-3670-4E1D-90ED-2008EDAC8E88",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Walking on Sunshine Cafe',stripeImage:"https://order.walkingonsunshine.sg/img/ninjaprocmn/walkingonsunshine/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'walkingonsunshine',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.walkingonsunshine.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.walkingonsunshine.sg/#/',fbImage:'https://order.walkingonsunshine.sg/img/walkingonsunshine/logo.png',fbTitle:'Walking on Sunshine Cafe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.walkingonsunshine.sg /'},/* Twitter  */tw:{twURL:'https://order.walkingonsunshine.sg/#/',twTitile:'Walking on Sunshine Cafe',twvia:'Walking on Sunshine Cafe'},/* google Plus data   */gp:{gpURL:'https://order.walkingonsunshine.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.walkingonsunshine.sg/#/',waSeparator:'Walking on Sunshine Cafe'},site_title:'Walking on Sunshine Cafe',site_title_with_separator:' | Walking on Sunshine Cafe',home_meta_title:"Welcome to Walking on Sunshine Cafe",bgimage:'/img/ninjaprocmn/walkingonsunshine/body_bg.jpg'}),_defineProperty(_domainValues,"www.halalketobyswitch.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F97CD809-E010-496C-8C45-804CCADAF331",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Switch Kitchen',stripeImage:"https://www.halalketobyswitch.com/img/ninjaprocmn/halalketobyswitch/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'halalketobyswitch',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.halalketobyswitch.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.halalketobyswitch.com/#/',fbImage:'https://www.halalketobyswitch.com/img/halalketobyswitch/logo.png',fbTitle:'Switch Kitchen',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.halalketobyswitch.com /'},/* Twitter  */tw:{twURL:'https://www.halalketobyswitch.com/#/',twTitile:'Switch Kitchen',twvia:'Switch Kitchen'},/* google Plus data   */gp:{gpURL:'https://www.halalketobyswitch.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.halalketobyswitch.com/#/',waSeparator:'Switch Kitchen'},site_title:'Switch Kitchen',forcewww:'YES',site_title_with_separator:' | Switch Kitchen',home_meta_title:"Welcome to Switch Kitchen",bgimage:'/img/ninjaprocmn/halalketobyswitch/body_bg.jpg'}),_defineProperty(_domainValues,"www.pu3restaurantsg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D0F92B76-AF0D-45A0-B784-C80054AE556B",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'PU3 Restaurantsg',stripeImage:"https://www.pu3restaurantsg.com/img/ninjaprocmn/halalketobyswitch/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'pu3restaurantsg',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.pu3restaurantsg.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.pu3restaurantsg.com/#/',fbImage:'https://www.pu3restaurantsg.com/img/pu3restaurantsg/logo.png',fbTitle:'PU3 Restaurantsg',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.pu3restaurantsg.com /'},/* Twitter  */tw:{twURL:'https://www.pu3restaurantsg.com/#/',twTitile:'PU3 Restaurantsg',twvia:'PU3 Restaurantsg'},/* google Plus data   */gp:{gpURL:'https://www.pu3restaurantsg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.pu3restaurantsg.com/#/',waSeparator:'PU3 Restaurantsg'},site_title:'PU3 Restaurantsg',forcewww:'YES',site_title_with_separator:' | PU3 Restaurantsg',home_meta_title:"Welcome to PU3 Restaurantsg",bgimage:'/img/ninjaprocmn/pu3restaurantsg/body_bg.jpg'}),_defineProperty(_domainValues,"orders.stephanieebakery.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"5C01570D-9780-42C8-9C67-5C7297BE985A",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Stephanie eBakery',stripeImage:"https://orders.stephanieebakery.sg/img/ninjaprocmn/stephanieebakery/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'stephanieebakery',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://orders.stephanieebakery.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://orders.stephanieebakery.sg/#/',fbImage:'https://orders.stephanieebakery.sg/img/stephanieebakery/logo.png',fbTitle:'Stephanie eBakery',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://orders.stephanieebakery.sg /'},/* Twitter  */tw:{twURL:'https://orders.stephanieebakery.sg/#/',twTitile:'Stephanie eBakery',twvia:'Stephanie eBakery'},/* google Plus data   */gp:{gpURL:'https://orders.stephanieebakery.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://orders.stephanieebakery.sg/#/',waSeparator:'Stephanie eBakery'},site_title:'Stephanie eBakery',site_title_with_separator:' | Stephanie eBakery',home_meta_title:"Welcome to Stephanie eBakery",bgimage:'/img/ninjaprocmn/stephanieebakery/body_bg.jpg'}),_defineProperty(_domainValues,"order.sonasgrill.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"20EEEAFC-E290-48CF-9609-672D8DCA4BF5",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Sona’s Grill',stripeImage:"https://order.sonasgrill.com/img/ninjaprocmn/sonasgrill/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'sonasgrill',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.sonasgrill.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.sonasgrill.com/#/',fbImage:'https://order.sonasgrill.com/img/sonasgrill/logo.png',fbTitle:'Sona’s Grill',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.sonasgrill.com /'},/* Twitter  */tw:{twURL:'https://order.sonasgrill.com/#/',twTitile:'Sona’s Grill',twvia:'Sona’s Grill'},/* google Plus data   */gp:{gpURL:'https://order.sonasgrill.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.sonasgrill.com/#/',waSeparator:'Sona’s Grill'},site_title:'Sona’s Grill',site_title_with_separator:' | Sona’s Grill',home_meta_title:"Welcome to Sona’s Grill",bgimage:'/img/ninjaprocmn/sonasgrill/body_bg.jpg'}),_defineProperty(_domainValues,"order.shifudo.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"655AE08E-3AB6-4A4B-9685-2BBDCB555922",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'SHIFUDO',stripeImage:"https://order.shifudo.sg/img/ninjaprocmn/shifudo/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'shifudo',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.shifudo.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.shifudo.sg/#/',fbImage:'https://order.shifudo.sg/img/shifudo/logo.png',fbTitle:'SHIFUDO',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.shifudo.sg /'},/* Twitter  */tw:{twURL:'https://order.shifudo.sg/#/',twTitile:'SHIFUDO',twvia:'SHIFUDO'},/* google Plus data   */gp:{gpURL:'https://order.shifudo.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.shifudo.sg/#/',waSeparator:'SHIFUDO'},site_title:'SHIFUDO',site_title_with_separator:' | SHIFUDO',home_meta_title:"Welcome to SHIFUDO",bgimage:'/img/ninjaprocmn/shifudo/body_bg.jpg'}),_defineProperty(_domainValues,"www.seleramerlyn.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"9D54028B-CFFD-4969-9F6A-63871D4E3470",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'SELERA MERLYN',stripeImage:"https://www.seleramerlyn.com/img/ninjaprocmn/seleramerlyn/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'seleramerlyn',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.seleramerlyn.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.seleramerlyn.com/#/',fbImage:'https://www.seleramerlyn.com/img/seleramerlyn/logo.png',fbTitle:'SELERA MERLYN',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.seleramerlyn.com /'},/* Twitter  */tw:{twURL:'https://www.seleramerlyn.com/#/',twTitile:'SELERA MERLYN',twvia:'SELERA MERLYN'},/* google Plus data   */gp:{gpURL:'https://www.seleramerlyn.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.seleramerlyn.com/#/',waSeparator:'SELERA MERLYN'},site_title:'SELERA MERLYN',forcewww:'YES',site_title_with_separator:' | SELERA MERLYN',home_meta_title:"Welcome to SELERA MERLYN",bgimage:'/img/ninjaprocmn/seleramerlyn/body_bg.jpg'}),_defineProperty(_domainValues,"www.chemilanofficial.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"CADEC225-ECA2-410F-B703-FB89FD19ECED",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Chemilan',stripeImage:"https://www.chemilanofficial.com/img/ninjaprocmn/chemilanofficial/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'chemilanofficial',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.chemilanofficial.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.chemilanofficial.com/#/',fbImage:'https://www.chemilanofficial.com/img/chemilanofficial/logo.png',fbTitle:'Chemilan',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.chemilanofficial.com /'},/* Twitter  */tw:{twURL:'https://www.chemilanofficial.com/#/',twTitile:'Chemilan',twvia:'Chemilan'},/* google Plus data   */gp:{gpURL:'https://www.chemilanofficial.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.chemilanofficial.com/#/',waSeparator:'Chemilan'},site_title:'Chemilan',forcewww:'YES',site_title_with_separator:' | Chemilan',home_meta_title:"Welcome to Chemilan",bgimage:'/img/ninjaprocmn/chemilanofficial/body_bg.jpg'}),_defineProperty(_domainValues,"holland.wangdaebakbbq.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"DB6B3299-45AE-44F4-AC0C-50FCEE32B04B",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Wang Dae Bak Korean',stripeImage:"https://holland.wangdaebakbbq.sg/img/ninjaprocmn/amoy/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'amoy',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://holland.wangdaebakbbq.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://holland.wangdaebakbbq.sg/#/',fbImage:'https://holland.wangdaebakbbq.sg/img/amoy/logo.png',fbTitle:'Wang Dae Bak Korean',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://holland.wangdaebakbbq.sg /'},/* Twitter  */tw:{twURL:'https://holland.wangdaebakbbq.sg/#/',twTitile:'Wang Dae Bak Korean',twvia:'Wang Dae Bak Korean'},/* google Plus data   */gp:{gpURL:'https://holland.wangdaebakbbq.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://holland.wangdaebakbbq.sg/#/',waSeparator:'Wang Dae Bak Korean'},site_title:'Wang Dae Bak Korean',site_title_with_separator:' | Wang Dae Bak Korean',home_meta_title:"Welcome to Wang Dae Bak Korean",bgimage:'/img/ninjaprocmn/amoy/body_bg.jpg'}),_defineProperty(_domainValues,"order.kalindiskuzines.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"614F3FD1-8659-4FD0-BF07-0560BC039AE6",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Kalindis Kuzines',stripeImage:"https://order.kalindiskuzines.com/img/ninjaprocmn/kalindiskuzines/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'kalindiskuzines',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.kalindiskuzines.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.kalindiskuzines.com/#/',fbImage:'https://order.kalindiskuzines.com/img/kalindiskuzines/logo.png',fbTitle:'Kalindis Kuzines',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.kalindiskuzines.com /'},/* Twitter  */tw:{twURL:'https://order.kalindiskuzines.com/#/',twTitile:'Kalindis Kuzines',twvia:'Kalindis Kuzines'},/* google Plus data   */gp:{gpURL:'https://order.kalindiskuzines.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.kalindiskuzines.com/#/',waSeparator:'Kalindis Kuzines'},site_title:'Kalindis Kuzines',site_title_with_separator:' | Kalindis Kuzines',home_meta_title:"Welcome to Kalindis Kuzines",bgimage:'/img/ninjaprocmn/kalindiskuzines/body_bg.jpg'}),_defineProperty(_domainValues,"www.thaistreet.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"1B62C926-EE9B-4B4A-A83E-908FC10AC8D6",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Thai Street',stripeImage:"https://www.thaistreet.sg/img/ninjaprocmn/thaistreet/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'thaistreet',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.thaistreet.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.thaistreet.sg/#/',fbImage:'https://www.thaistreet.sg/img/thaistreet/logo.png',fbTitle:'Thai Street',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.thaistreet.sg /'},/* Twitter  */tw:{twURL:'https://www.thaistreet.sg/#/',twTitile:'Thai Street',twvia:'Thai Street'},/* google Plus data   */gp:{gpURL:'https://www.thaistreet.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://www.thaistreet.sg/#/',waSeparator:'Thai Street'},site_title:'Thai Street',forcewww:'YES',site_title_with_separator:' | Thai Street',home_meta_title:"Welcome to Thai Street",bgimage:'/img/ninjaprocmn/thaistreet/body_bg.jpg'}),_defineProperty(_domainValues,"www.ruhesg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"EF059958-1F29-4B55-A6B4-E4861FE565DF",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'RUHE',stripeImage:"https://www.ruhesg.com/img/ninjaprocmn/socialhideoutsg/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ruhesg',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.ruhesg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.ruhesg.com/#/',fbImage:'https://www.ruhesg.com/img/socialhideoutsg/logo.png',fbTitle:'RUHE',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.ruhesg.com/'},/* Twitter  */tw:{twURL:'https://www.ruhesg.com/#/',twTitile:'RUHE',twvia:'RUHE'},/* google Plus data   */gp:{gpURL:'https://www.ruhesg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.ruhesg.com/#/',waSeparator:'RUHE'},site_title:'RUHE',forcewww:'YES',site_title_with_separator:' | RUHE',home_meta_title:"Welcome to RUHE",bgimage:'/img/ninjaprocmn/socialhideoutsg/body_bg.jpg'}),_defineProperty(_domainValues,"www.tasteforyousg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"DB73A28F-7F93-46BD-AD24-5A9EBF7E181C",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Taste For You',stripeImage:"https://www.tasteforyousg.com/img/ninjaprocmn/tasteforyousg/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'tasteforyousg',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.tasteforyousg.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.tasteforyousg.com/#/',fbImage:'https://www.tasteforyousg.com/img/tasteforyousg/logo.png',fbTitle:'Taste For You',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.tasteforyousg.com /'},/* Twitter  */tw:{twURL:'https://www.tasteforyousg.com/#/',twTitile:'Taste For You',twvia:'Taste For You'},/* google Plus data   */gp:{gpURL:'https://www.tasteforyousg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.tasteforyousg.com/#/',waSeparator:'Taste For You'},site_title:'Taste For You',forcewww:'YES',site_title_with_separator:' | Taste For You',home_meta_title:"Welcome to Taste For You",bgimage:'/img/ninjaprocmn/tasteforyousg/body_bg.jpg'}),_defineProperty(_domainValues,"order.fatsaigonboy.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"179E5292-2AD0-4C66-A68F-DFAA888E60A2",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Taste For You',stripeImage:"https://order.fatsaigonboy.com/img/ninjaprocmn/fatsaigonboy/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'fatsaigonboy',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.fatsaigonboy.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.fatsaigonboy.com/#/',fbImage:'https://order.fatsaigonboy.com/img/fatsaigonboy/logo.png',fbTitle:'Fat Saigon Boy',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.fatsaigonboy.com /'},/* Twitter  */tw:{twURL:'https://order.fatsaigonboy.com/#/',twTitile:'Fat Saigon Boy',twvia:'Fat Saigon Boy'},/* google Plus data   */gp:{gpURL:'https://order.fatsaigonboy.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.fatsaigonboy.com/#/',waSeparator:'Fat Saigon Boy'},site_title:'Fat Saigon Boy',site_title_with_separator:' | Fat Saigon Boy',home_meta_title:"Welcome to Fat Saigon Boy",bgimage:'/img/ninjaprocmn/fatsaigonboy/body_bg.jpg'}),_defineProperty(_domainValues,"order.homekitchen.com.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"96D2729C-D822-438A-A6BF-54A000DC3F58",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'HOME KITCHEN',stripeImage:"https://order.homekitchen.com.sg/img/ninjaprocmn/homekitchen/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'homekitchen',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.homekitchen.com.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.homekitchen.com.sg/#/',fbImage:'https://order.homekitchen.com.sg/img/homekitchen/logo.png',fbTitle:'HOME KITCHEN',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.homekitchen.com.sg /'},/* Twitter  */tw:{twURL:'https://order.homekitchen.com.sg/#/',twTitile:'HOME KITCHEN',twvia:'HOME KITCHEN'},/* google Plus data   */gp:{gpURL:'https://order.homekitchen.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.homekitchen.com.sg/#/',waSeparator:'HOME KITCHEN'},site_title:'HOME KITCHEN',site_title_with_separator:' | HOME KITCHEN',home_meta_title:"Welcome to HOME KITCHEN",bgimage:'/img/ninjaprocmn/homekitchen/body_bg.jpg'}),_defineProperty(_domainValues,"www.hometalkscafe.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E53E9643-7E94-4C03-9C4B-D7B0C6650CB7",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Home Talks Cafe',stripeImage:"https://www.hometalkscafe.com/img/ninjaprocmn/hometalkscafe/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'hometalkscafe',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.hometalkscafe.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.hometalkscafe.com/#/',fbImage:'https://www.hometalkscafe.com/img/hometalkscafe/logo.png',fbTitle:'Home Talks Cafe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.hometalkscafe.com /'},/* Twitter  */tw:{twURL:'https://www.hometalkscafe.com/#/',twTitile:'Home Talks Cafe',twvia:'Home Talks Cafe'},/* google Plus data   */gp:{gpURL:'https://www.hometalkscafe.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.hometalkscafe.com/#/',waSeparator:'Home Talks Cafe'},site_title:'Home Talks Cafe',forcewww:'YES',site_title_with_separator:' | Home Talks Cafe',home_meta_title:"Welcome to Home Talks Cafe",bgimage:'/img/ninjaprocmn/hometalkscafe/body_bg.jpg'}),_defineProperty(_domainValues,"www.teasocialsg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"86E93BFA-26B5-4961-A0EA-F7D294A47B56",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Tea Social Cafe',stripeImage:"https://www.teasocialsg.com/img/ninjaprocmn/teasocialsg/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'teasocialsg',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.teasocialsg.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.teasocialsg.com/#/',fbImage:'https://www.teasocialsg.com/img/teasocialsg/logo.png',fbTitle:'Tea Social Cafe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.teasocialsg.com /'},/* Twitter  */tw:{twURL:'https://www.teasocialsg.com/#/',twTitile:'Tea Social Cafe',twvia:'Tea Social Cafe'},/* google Plus data   */gp:{gpURL:'https://www.teasocialsg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.teasocialsg.com/#/',waSeparator:'Tea Social Cafe'},site_title:'Tea Social Cafe',forcewww:'YES',site_title_with_separator:' | Tea Social Cafe',home_meta_title:"Welcome to Tea Social Cafe",bgimage:'/img/ninjaprocmn/teasocialsg/body_bg.jpg'}),_defineProperty(_domainValues,"www.curryncurry.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"62A11668-6068-47C7-AC12-4CC4F036A452",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Curry & Curry',stripeImage:"https://www.curryncurry.com/img/ninjaprocmn/curryncurry/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'curryncurry',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.curryncurry.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.curryncurry.com/#/',fbImage:'https://www.curryncurry.com/img/curryncurry/logo.png',fbTitle:'Curry & Curry',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.curryncurry.com /'},/* Twitter  */tw:{twURL:'https://www.curryncurry.com/#/',twTitile:'Curry & Curry',twvia:'Curry & Curry'},/* google Plus data   */gp:{gpURL:'https://www.curryncurry.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.curryncurry.com/#/',waSeparator:'Curry & Curry'},site_title:'Curry & Curry',forcewww:'YES',site_title_with_separator:' | Curry & Curry',home_meta_title:"Welcome to Curry & Curry",bgimage:'/img/ninjaprocmn/curryncurry/body_bg.jpg'}),_defineProperty(_domainValues,"order.53galaxyspace.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E0FB2263-1246-4E43-B25C-6743B013F142",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Toxic Room',stripeImage:"https://order.53galaxyspace.com/img/ninjaprocmn/toxicroom/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'toxicroom',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.53galaxyspace.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.53galaxyspace.com/#/',fbImage:'https://order.53galaxyspace.com/img/toxicroom/logo.png',fbTitle:'Toxic Room',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.53galaxyspace.com /'},/* Twitter  */tw:{twURL:'https://order.53galaxyspace.com/#/',twTitile:'Toxic Room',twvia:'Toxic Room'},/* google Plus data   */gp:{gpURL:'https://order.53galaxyspace.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.53galaxyspace.com/#/',waSeparator:'Toxic Room'},site_title:'Toxic Room',site_title_with_separator:' | Toxic Room',home_meta_title:"Welcome to Toxic Room",bgimage:'/img/ninjaprocmn/toxicroom/body_bg.jpg'}),_defineProperty(_domainValues,"order.bacos.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"00167E5E-67A7-42E3-85EB-8D80342FACF1",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'BACOS THE DINE',stripeImage:"https://order.bacos.sg/img/ninjaprocmn/bacos/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'bacos',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.bacos.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.bacos.sg/#/',fbImage:'https://order.bacos.sg/img/bacos/logo.png',fbTitle:'BACOS THE DINE',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.bacos.sg /'},/* Twitter  */tw:{twURL:'https://order.bacos.sg/#/',twTitile:'BACOS THE DINE',twvia:'BACOS THE DINE'},/* google Plus data   */gp:{gpURL:'https://order.bacos.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.bacos.sg/#/',waSeparator:'BACOS THE DINE'},site_title:'BACOS THE DINE',site_title_with_separator:' | BACOS THE DINE',home_meta_title:"Welcome to BACOS THE DINE",bgimage:'/img/ninjaprocmn/bacos/body_bg.jpg'}),_defineProperty(_domainValues,"www.honolulucafesg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"B637EE61-A5A9-4303-ACF7-4A3C055DC845",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Honolulu Cafe',stripeImage:"https://www.honolulucafesg.com/img/ninjaprocmn/honolulu/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'honolulu',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.honolulucafesg.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.honolulucafesg.com/#/',fbImage:'https://www.honolulucafesg.com/img/honolulu/logo.png',fbTitle:'Honolulu Cafe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.honolulucafesg.com /'},/* Twitter  */tw:{twURL:'https://www.honolulucafesg.com/#/',twTitile:'Honolulu Cafe',twvia:'Honolulu Cafe'},/* google Plus data   */gp:{gpURL:'https://www.honolulucafesg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.honolulucafesg.com/#/',waSeparator:'Honolulu Cafe'},site_title:'Honolulu Cafe',forcewww:'YES',site_title_with_separator:' | Honolulu Cafe',home_meta_title:"Welcome to Honolulu Cafe",bgimage:'/img/ninjaprocmn/honolulu/body_bg.jpg'}),_defineProperty(_domainValues,"www.nainaskitchensg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"0253AE3F-3989-450A-9FC4-897A3458A27A",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Nainas Kitchen',stripeImage:"https://www.nainaskitchensg.com/img/ninjaprocmn/nainaskitchensg/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'nainaskitchensg',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.nainaskitchensg.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.nainaskitchensg.com/#/',fbImage:'https://www.nainaskitchensg.com/img/nainaskitchensg/logo.png',fbTitle:'Nainas Kitchen',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.nainaskitchensg.com /'},/* Twitter  */tw:{twURL:'https://www.nainaskitchensg.com/#/',twTitile:'Nainas Kitchen',twvia:'Nainas Kitchen'},/* google Plus data   */gp:{gpURL:'https://www.nainaskitchensg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.nainaskitchensg.com/#/',waSeparator:'Nainas Kitchen'},site_title:'Nainas Kitchen',forcewww:'YES',site_title_with_separator:' | Nainas Kitchen',home_meta_title:"Welcome to Nainas Kitchen",bgimage:'/img/ninjaprocmn/nainaskitchensg/body_bg.jpg'}),_defineProperty(_domainValues,"www.nhungkitchen.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"BF2000BF-9B3C-43F8-BA14-CD0899A4E7DD",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Nhung Kitchen',stripeImage:"https://www.nhungkitchen.com/img/ninjaprocmn/nhungkitchen/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'nhungkitchen',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.nhungkitchen.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.nhungkitchen.com/#/',fbImage:'https://www.nhungkitchen.com/img/nhungkitchen/logo.png',fbTitle:'Nhung Kitchen',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.nhungkitchen.com /'},/* Twitter  */tw:{twURL:'https://www.nhungkitchen.com/#/',twTitile:'Nhung Kitchen',twvia:'Nhung Kitchen'},/* google Plus data   */gp:{gpURL:'https://www.nhungkitchen.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.nhungkitchen.com/#/',waSeparator:'Nhung Kitchen'},site_title:'Nhung Kitchen',forcewww:'YES',site_title_with_separator:' | Nhung Kitchen',home_meta_title:"Welcome to Nhung Kitchen",bgimage:'/img/ninjaprocmn/nhungkitchen/body_bg.jpg'}),_defineProperty(_domainValues,"order.fluffbakery.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"9F47BAE5-9A6B-4FB1-81ED-260C8C4A6533",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Fluff Bakery',stripeImage:"https://order.fluffbakery.sg/img/ninjaprocmn/fluffbakery/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'fluffbakery',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.fluffbakery.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.fluffbakery.sg/#/',fbImage:'https://order.fluffbakery.sg/img/fluffbakery/logo.png',fbTitle:'Fluff Bakery',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.fluffbakery.sg /'},/* Twitter  */tw:{twURL:'https://order.fluffbakery.sg/#/',twTitile:'Fluff Bakery',twvia:'Fluff Bakery'},/* google Plus data   */gp:{gpURL:'https://order.fluffbakery.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.fluffbakery.sg/#/',waSeparator:'Fluff Bakery'},site_title:'Fluff Bakery',site_title_with_separator:' | Fluff Bakery',home_meta_title:"Welcome to Fluff Bakery",bgimage:'/img/ninjaprocmn/fluffbakery/body_bg.jpg'}),_defineProperty(_domainValues,"order.yogurtlady.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"41EBC14C-5BEC-4051-97F7-ACE106222F11",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Yogurt Lady',stripeImage:"https://order.yogurtlady.sg/img/ninjaprocmn/yogurtlady/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'yogurtlady',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.yogurtlady.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.yogurtlady.sg/#/',fbImage:'https://order.yogurtlady.sg/img/yogurtlady/logo.png',fbTitle:'Yogurt Lady',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.yogurtlady.sg /'},/* Twitter  */tw:{twURL:'https://order.yogurtlady.sg/#/',twTitile:'Yogurt Lady',twvia:'Yogurt Lady'},/* google Plus data   */gp:{gpURL:'https://order.yogurtlady.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.yogurtlady.sg/#/',waSeparator:'Yogurt Lady'},site_title:'Yogurt Lady',site_title_with_separator:' | Yogurt Lady',home_meta_title:"Welcome to Yogurt Lady",bgimage:'/img/ninjaprocmn/yogurtlady/body_bg.jpg'}),_defineProperty(_domainValues,"order.yummyraja.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"4175698E-03E3-4815-8798-F438A3265C75",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Yummy Raja',stripeImage:"https://order.yummyraja.com/img/ninjaprocmn/yummyraja/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'yummyraja',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.yummyraja.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.yummyraja.com/#/',fbImage:'https://order.yummyraja.com/img/yummyraja/logo.png',fbTitle:'Yummy Raja',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.yummyraja.com /'},/* Twitter  */tw:{twURL:'https://order.yummyraja.com/#/',twTitile:'Yummy Raja',twvia:'Yummy Raja'},/* google Plus data   */gp:{gpURL:'https://order.yummyraja.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.yummyraja.com/#/',waSeparator:'Yummy Raja'},site_title:'Yummy Raja',site_title_with_separator:' | Yummy Raja',home_meta_title:"Welcome to Yummy Raja",bgimage:'/img/ninjaprocmn/yummyraja/body_bg.jpg'}),_defineProperty(_domainValues,"order.kruabaanthai.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"CA78F793-7987-4656-9B6A-B101C89EABB1",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Krua Baan Thai',stripeImage:"https://order.kruabaanthai.sg/img/ninjaprocmn/kruabaanthai/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'kruabaanthai',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.kruabaanthai.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.kruabaanthai.sg/#/',fbImage:'https://order.kruabaanthai.sg/img/kruabaanthai/logo.png',fbTitle:'Krua Baan Thai',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.kruabaanthai.sg /'},/* Twitter  */tw:{twURL:'https://order.kruabaanthai.sg/#/',twTitile:'Krua Baan Thai',twvia:'Krua Baan Thai'},/* google Plus data   */gp:{gpURL:'https://order.kruabaanthai.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.kruabaanthai.sg/#/',waSeparator:'Krua Baan Thai'},site_title:'Krua Baan Thai',site_title_with_separator:' | Krua Baan Thai',home_meta_title:"Welcome to Krua Baan Thai",bgimage:'/img/ninjaprocmn/kruabaanthai/body_bg.jpg'}),_defineProperty(_domainValues,"www.eacsg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"8AAB3D00-C15E-4D95-9573-239A1500FFC5",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Each a Cup',stripeImage:"https://www.eacsg.com/img/ninjaprocmn/eacsg/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'eacsg',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.eacsg.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.eacsg.com/#/',fbImage:'https://www.eacsg.com/img/eacsg/logo.png',fbTitle:'Each a Cup',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.eacsg.com /'},/* Twitter  */tw:{twURL:'https://www.eacsg.com/#/',twTitile:'Each a Cup',twvia:'Each a Cup'},/* google Plus data   */gp:{gpURL:'https://www.eacsg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.eacsg.com/#/',waSeparator:'Each a Cup'},site_title:'Each a Cup',forcewww:'YES',site_title_with_separator:' | Each a Cup',home_meta_title:"Welcome to Each a Cup",bgimage:'/img/ninjaprocmn/eacsg/body_bg.jpg'}),_defineProperty(_domainValues,"www.fengzhensg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"529914DF-266E-462E-9511-3E4EBB806AE9",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Yew Tee Feng Zhen Lor Mee',stripeImage:"https://www.fengzhensg.com/img/ninjaprocmn/fengzhensg/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'fengzhensg',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.fengzhensg.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.fengzhensg.com/#/',fbImage:'https://www.fengzhensg.com/img/fengzhensg/logo.png',fbTitle:'Yew Tee Feng Zhen Lor Mee',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.fengzhensg.com /'},/* Twitter  */tw:{twURL:'https://www.fengzhensg.com/#/',twTitile:'Yew Tee Feng Zhen Lor Mee',twvia:'Yew Tee Feng Zhen Lor Mee'},/* google Plus data   */gp:{gpURL:'https://www.fengzhensg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.fengzhensg.com/#/',waSeparator:'Yew Tee Feng Zhen Lor Mee'},site_title:'Yew Tee Feng Zhen Lor Mee',forcewww:'YES',site_title_with_separator:' | Yew Tee Feng Zhen Lor Mee',home_meta_title:"Welcome to Yew Tee Feng Zhen Lor Mee",bgimage:'/img/ninjaprocmn/fengzhensg/body_bg.jpg'}),_defineProperty(_domainValues,"order.ekiben.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"014D1A83-2F46-4074-B6AF-83413A3E654D",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Ekiben',stripeImage:"https://order.ekiben.sg/img/ninjaprocmn/ekiben/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ekiben',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.ekiben.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.ekiben.sg/#/',fbImage:'https://order.ekiben.sg/img/ekiben/logo.png',fbTitle:'Ekiben',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.ekiben.sg /'},/* Twitter  */tw:{twURL:'https://order.ekiben.sg/#/',twTitile:'Ekiben',twvia:'Ekiben'},/* google Plus data   */gp:{gpURL:'https://order.ekiben.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.ekiben.sg/#/',waSeparator:'Ekiben'},site_title:'Ekiben',site_title_with_separator:' | Ekiben',home_meta_title:"Welcome to Ekiben",bgimage:'/img/ninjaprocmn/ekiben/body_bg.jpg'}),_defineProperty(_domainValues,"www.vietspicesg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D9C6C55E-EBCA-4C4C-8D89-A5E11BB876D9",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'VietSpice',stripeImage:"https://www.vietspicesg.com/img/ninjaprocmn/vietspicesg/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'vietspicesg',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.vietspicesg.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.vietspicesg.com/#/',fbImage:'https://www.vietspicesg.com/img/vietspicesg/logo.png',fbTitle:'VietSpice',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.vietspicesg.com /'},/* Twitter  */tw:{twURL:'https://www.vietspicesg.com/#/',twTitile:'VietSpice',twvia:'VietSpice'},/* google Plus data   */gp:{gpURL:'https://www.vietspicesg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.vietspicesg.com/#/',waSeparator:'VietSpice'},site_title:'VietSpice',forcewww:'YES',site_title_with_separator:' | VietSpice',home_meta_title:"Welcome to VietSpice",bgimage:'/img/ninjaprocmn/vietspicesg/body_bg.jpg'}),_defineProperty(_domainValues,"www.vintagetreecatering.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"A226445E-1396-4AFD-AF4E-601898E17984",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Vintagetree',stripeImage:"https://www.vintagetreecatering.com/img/ninjaprocmn/vintagetreecatering/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'vintagetreecatering',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.vintagetreecatering.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.vintagetreecatering.com/#/',fbImage:'https://www.vintagetreecatering.com/img/vintagetreecatering/logo.png',fbTitle:'Vintagetree',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.vintagetreecatering.com /'},/* Twitter  */tw:{twURL:'https://www.vintagetreecatering.com/#/',twTitile:'Vintagetree',twvia:'Vintagetree'},/* google Plus data   */gp:{gpURL:'https://www.vintagetreecatering.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.vintagetreecatering.com/#/',waSeparator:'Vintagetree'},site_title:'Vintagetree',forcewww:'YES',site_title_with_separator:' | Vintagetree',home_meta_title:"Welcome to Vintagetree",bgimage:'/img/ninjaprocmn/vintagetreecatering/body_bg.jpg'}),_defineProperty(_domainValues,"order.smokinjoe.com.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E98B5F15-D7FE-4C7C-9D9E-C24469278849",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Smokin Joe',stripeImage:"https://order.smokinjoe.com.sg/img/ninjaprocmn/smokinjoe/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'smokinjoe',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.smokinjoe.com.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.smokinjoe.com.sg/#/',fbImage:'https://order.smokinjoe.com.sg/img/smokinjoe/logo.png',fbTitle:'Smokin Joe',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.smokinjoe.com.sg /'},/* Twitter  */tw:{twURL:'https://order.smokinjoe.com.sg/#/',twTitile:'Smokin Joe',twvia:'Smokin Joe'},/* google Plus data   */gp:{gpURL:'https://order.smokinjoe.com.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.smokinjoe.com.sg/#/',waSeparator:'Smokin Joe'},site_title:'Smokin Joe',site_title_with_separator:' | Smokin Joe',home_meta_title:"Welcome to Smokin Joe",bgimage:'/img/ninjaprocmn/smokinjoe/body_bg.jpg'}),_defineProperty(_domainValues,"ninjaprodemo.ninjaos.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"B19417EE-1A66-4F3E-B056-0A2B1E797F9B",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'NinjaPro Demo',stripeImage:"https://ninjaprodemo.ninjaos.com/img/ninjaprocmn/ninjaprodemo/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ninjaprodemo',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://ninjaprodemo.ninjaos.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://ninjaprodemo.ninjaos.com/#/',fbImage:'https://ninjaprodemo.ninjaos.com/img/ninjaprodemo/logo.png',fbTitle:'NinjaPro Demo',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://ninjaprodemo.ninjaos.com /'},/* Twitter  */tw:{twURL:'https://ninjaprodemo.ninjaos.com/#/',twTitile:'NinjaPro Demo',twvia:'NinjaPro Demo'},/* google Plus data   */gp:{gpURL:'https://ninjaprodemo.ninjaos.com/#/'},/* Whatsapp data   */wa:{waURL:'https://ninjaprodemo.ninjaos.com/#/',waSeparator:'NinjaPro Demo'},site_title:'NinjaPro Demo',site_title_with_separator:' | NinjaPro Demo',home_meta_title:"Welcome to NinjaPro Demo",bgimage:'/img/ninjaprocmn/ninjaprodemo/body_bg.jpg'}),_defineProperty(_domainValues,"order.liulianman.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"5C231373-6EFC-49DF-8EB5-90D874A55E96",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Liu Lian Man',stripeImage:"https://order.liulianman.com/img/ninjaprocmn/liulianman/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'liulianman',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.liulianman.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.liulianman.com/#/',fbImage:'https://order.liulianman.com/img/liulianman/logo.png',fbTitle:'Liu Lian Man',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.liulianman.com/'},/* Twitter  */tw:{twURL:'https://order.liulianman.com/#/',twTitile:'Liu Lian Man',twvia:'Liu Lian Man'},/* google Plus data   */gp:{gpURL:'https://order.liulianman.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.liulianman.com/#/',waSeparator:'Liu Lian Man'},site_title:'Liu Lian Man',site_title_with_separator:' | Liu Lian Man',home_meta_title:"Welcome to Liu Lian Man",bgimage:'/img/ninjaprocmn/liulianman/body_bg.jpg'}),_defineProperty(_domainValues,"www.taterist.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E636FC8A-DC6B-4F04-ADA1-F83BFE53E219",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Taterist',stripeImage:"https://www.taterist.com/img/ninjaprocmn/taterist/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'taterist',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.taterist.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.taterist.com/#/',fbImage:'https://www.taterist.com/img/taterist/logo.png',fbTitle:'Taterist',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.taterist.com/'},/* Twitter  */tw:{twURL:'https://www.taterist.com/#/',twTitile:'Taterist',twvia:'Taterist'},/* google Plus data   */gp:{gpURL:'https://www.taterist.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.taterist.com/#/',waSeparator:'Taterist'},site_title:'Taterist',forcewww:'YES',site_title_with_separator:' | Taterist',home_meta_title:"Welcome to Taterist",bgimage:'/img/ninjaprocmn/taterist/body_bg.jpg'}),_defineProperty(_domainValues,"www.karnivalsingapore.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"352A0F60-2894-44FD-AF9E-3D23C3395FF3",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Karnival Singapore',stripeImage:"https://www.karnivalsingapore.com/img/ninjaprocmn/karnivalsingapore/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'karnivalsingapore',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.karnivalsingapore.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.karnivalsingapore.com/#/',fbImage:'https://www.karnivalsingapore.com/img/karnivalsingapore/logo.png',fbTitle:'Karnival Singapore',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.karnivalsingapore.com/'},/* Twitter  */tw:{twURL:'https://www.karnivalsingapore.com/#/',twTitile:'Karnival Singapore',twvia:'Karnival Singapore'},/* google Plus data   */gp:{gpURL:'https://www.karnivalsingapore.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.karnivalsingapore.com/#/',waSeparator:'Karnival Singapore'},site_title:'Karnival Singapore',forcewww:'YES',site_title_with_separator:' | Karnival Singapore',home_meta_title:"Welcome to Karnival Singapore",bgimage:'/img/ninjaprocmn/karnivalsingapore/body_bg.jpg'}),_defineProperty(_domainValues,"www.juparocoffee.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"EB23A9E5-0D63-49C3-9EB2-7D2A5C37B68C",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'JUPARO COFFEE',stripeImage:"https://www.juparocoffee.com/img/ninjaprocmn/juparocoffee/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'juparocoffee',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.juparocoffee.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.juparocoffee.com/#/',fbImage:'https://www.juparocoffee.com/img/juparocoffee/logo.png',fbTitle:'JUPARO COFFEE',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.juparocoffee.com/'},/* Twitter  */tw:{twURL:'https://www.juparocoffee.com/#/',twTitile:'JUPARO COFFEE',twvia:'JUPARO COFFEE'},/* google Plus data   */gp:{gpURL:'https://www.juparocoffee.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.juparocoffee.com/#/',waSeparator:'JUPARO COFFEE'},site_title:'JUPARO COFFEE',forcewww:'YES',site_title_with_separator:' | JUPARO COFFEE',home_meta_title:"Welcome to JUPARO COFFEE",bgimage:'/img/ninjaprocmn/juparocoffee/body_bg.jpg'}),_defineProperty(_domainValues,"order.chilispizza.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"E4C4E8F2-672D-476F-876B-45102C243932",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'CHILIS PIZZA',stripeImage:"https://order.chilispizza.com/img/ninjaprocmn/chilispizza/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'chilispizza',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.chilispizza.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.chilispizza.com/#/',fbImage:'https://order.chilispizza.com/img/chilispizza/logo.png',fbTitle:'CHILIS PIZZA',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.chilispizza.com/'},/* Twitter  */tw:{twURL:'https://order.chilispizza.com/#/',twTitile:'CHILIS PIZZA',twvia:'CHILIS PIZZA'},/* google Plus data   */gp:{gpURL:'https://order.chilispizza.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.chilispizza.com/#/',waSeparator:'CHILIS PIZZA'},site_title:'CHILIS PIZZA',site_title_with_separator:' | CHILIS PIZZA',home_meta_title:"Welcome to CHILIS PIZZA",bgimage:'/img/ninjaprocmn/chilispizza/body_bg.jpg'}),_defineProperty(_domainValues,"www.mreggfriedrice.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"4D9FBC3C-48EE-482B-8A1D-663E332DC739",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Mr. Egg Fried Rice',stripeImage:"https://www.mreggfriedrice.com/img/ninjaprocmn/mreggfriedrice/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'mreggfriedrice',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.mreggfriedrice.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.mreggfriedrice.com/#/',fbImage:'https://www.mreggfriedrice.com/img/mreggfriedrice/logo.png',fbTitle:'Mr. Egg Fried Rice',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.mreggfriedrice.com/'},/* Twitter  */tw:{twURL:'https://www.mreggfriedrice.com/#/',twTitile:'Mr. Egg Fried Rice',twvia:'Mr. Egg Fried Rice'},/* google Plus data   */gp:{gpURL:'https://www.mreggfriedrice.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.mreggfriedrice.com/#/',waSeparator:'Mr. Egg Fried Rice'},site_title:'Mr. Egg Fried Rice',forcewww:'YES',site_title_with_separator:' | Mr. Egg Fried Rice',home_meta_title:"Welcome to Mr. Egg Fried Rice",bgimage:'/img/ninjaprocmn/mreggfriedrice/body_bg.jpg'}),_defineProperty(_domainValues,"www.dooda.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"B02F1AEB-C370-4034-A358-C14579AFE9D4",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Dooda',stripeImage:"https://www.dooda.sg/img/ninjaprocmn/dooda/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'dooda',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.dooda.sg /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.dooda.sg/#/',fbImage:'https://www.dooda.sg/img/dooda/logo.png',fbTitle:'Dooda',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.dooda.sg/'},/* Twitter  */tw:{twURL:'https://www.dooda.sg/#/',twTitile:'Dooda',twvia:'Dooda'},/* google Plus data   */gp:{gpURL:'https://www.dooda.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://www.dooda.sg/#/',waSeparator:'Dooda'},site_title:'Dooda',forcewww:'YES',site_title_with_separator:' | Dooda',home_meta_title:"Welcome to Dooda",bgimage:'/img/ninjaprocmn/dooda/body_bg.jpg'}),_defineProperty(_domainValues,"www.kanesonkitchen.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"85C5D8A5-9BF9-4F81-B026-936FAFD7B3D1",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Kaneson Kitchen',stripeImage:"https://www.kanesonkitchen.com/img/ninjaprocmn/kanesonkitchen/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'kanesonkitchen',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.kanesonkitchen.com /#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.kanesonkitchen.com/#/',fbImage:'https://www.kanesonkitchen.com/img/kanesonkitchen/logo.png',fbTitle:'Kaneson Kitchen',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.kanesonkitchen.com/'},/* Twitter  */tw:{twURL:'https://www.kanesonkitchen.com/#/',twTitile:'Kaneson Kitchen',twvia:'Kaneson Kitchen'},/* google Plus data   */gp:{gpURL:'https://www.kanesonkitchen.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.kanesonkitchen.com/#/',waSeparator:'Kaneson Kitchen'},site_title:'Kaneson Kitchen',forcewww:'YES',site_title_with_separator:' | Kaneson Kitchen',home_meta_title:"Welcome to Kaneson Kitchen",bgimage:'/img/ninjaprocmn/kanesonkitchen/body_bg.jpg'}),_defineProperty(_domainValues,"www.handinhandfoodsg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"D5618CE8-AD7E-4F58-B181-FE970D1719CB",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Hand in Hand',stripeImage:"https://www.handinhandfoodsg.com/img/ninjaprocmn/handinhandfood/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'handinhandfood',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.handinhandfoodsg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.handinhandfoodsg.com/#/',fbImage:'https://www.handinhandfoodsg.com/img/handinhandfood/logo.png',fbTitle:'Hand in Hand',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.kanesonkitchen.com/'},/* Twitter  */tw:{twURL:'https://www.handinhandfoodsg.com/#/',twTitile:'Hand in Hand',twvia:'Hand in Hand'},/* google Plus data   */gp:{gpURL:'https://www.handinhandfoodsg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.handinhandfoodsg.com/#/',waSeparator:'Hand in Hand'},site_title:'Hand in Hand',forcewww:'YES',site_title_with_separator:' | Hand in Hand',home_meta_title:"Welcome to Hand in Hand",bgimage:'/img/ninjaprocmn/handinhandfood/body_bg.jpg'}),_defineProperty(_domainValues,"www.kingrojak.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"7B8628E8-3B24-4F83-8918-A113F85366D6",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'King Rojak',stripeImage:"https://www.kingrojak.com/img/ninjaprocmn/kingrojak/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'kingrojak',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.kingrojak.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.kingrojak.com/#/',fbImage:'https://www.kingrojak.com/img/kingrojak/logo.png',fbTitle:'King Rojak',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.kanesonkitchen.com/'},/* Twitter  */tw:{twURL:'https://www.kingrojak.com/#/',twTitile:'King Rojak',twvia:'King Rojak'},/* google Plus data   */gp:{gpURL:'https://www.kingrojak.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.kingrojak.com/#/',waSeparator:'King Rojak'},site_title:'King Rojak',forcewww:'YES',site_title_with_separator:' | King Rojak',home_meta_title:"Welcome to King Rojak",bgimage:'/img/ninjaprocmn/kingrojak/body_bg.jpg'}),_defineProperty(_domainValues,"www.teaattarik.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"29F1186E-74C4-49BA-BECB-F8ECB7CCBE24",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Tarik',stripeImage:"https://www.teaattarik.com/img/ninjaprocmn/teaattarik/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'teaattarik',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.teaattarik.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.teaattarik.com/#/',fbImage:'https://www.teaattarik.com/img/teaattarik/logo.png',fbTitle:'Tarik',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.kanesonkitchen.com/'},/* Twitter  */tw:{twURL:'https://www.teaattarik.com/#/',twTitile:'Tarik',twvia:'Tarik'},/* google Plus data   */gp:{gpURL:'https://www.teaattarik.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.teaattarik.com/#/',waSeparator:'Tarik'},site_title:'Tarik',forcewww:'YES',site_title_with_separator:' | Tarik',home_meta_title:"Welcome to Tarik",bgimage:'/img/ninjaprocmn/teaattarik/body_bg.jpg'}),_defineProperty(_domainValues,"www.groundfloorcoffee.co",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"CAF8774B-4C44-4CD3-BF39-10F3705520E2",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Ground Floor Coffee',stripeImage:"https://www.groundfloorcoffee.co/img/ninjaprocmn/groundfloorcoffee/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'groundfloorcoffee',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.groundfloorcoffee.co/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.groundfloorcoffee.co/#/',fbImage:'https://www.groundfloorcoffee.co/img/groundfloorcoffee/logo.png',fbTitle:'Ground Floor Coffee',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.kanesonkitchen.com/'},/* Twitter  */tw:{twURL:'https://www.groundfloorcoffee.co/#/',twTitile:'Ground Floor Coffee',twvia:'Ground Floor Coffee'},/* google Plus data   */gp:{gpURL:'https://www.groundfloorcoffee.co/#/'},/* Whatsapp data   */wa:{waURL:'https://www.groundfloorcoffee.co/#/',waSeparator:'Ground Floor Coffee'},site_title:'Ground Floor Coffee',forcewww:'YES',site_title_with_separator:' | Ground Floor Coffee',home_meta_title:"Welcome to Ground Floor Coffee",bgimage:'/img/ninjaprocmn/groundfloorcoffee/body_bg.jpg'}),_defineProperty(_domainValues,"www.ainpopiahbasah.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"24D0F527-B654-4FBA-8400-DD86E24DF31B",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Ain Popiah Basah',stripeImage:"https://www.ainpopiahbasah.com/img/ninjaprocmn/ainpopiahbasah/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ainpopiahbasah',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.ainpopiahbasah.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.ainpopiahbasah.com/#/',fbImage:'https://www.ainpopiahbasah.com/img/ainpopiahbasah/logo.png',fbTitle:'Ain Popiah Basah',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.kanesonkitchen.com/'},/* Twitter  */tw:{twURL:'https://www.ainpopiahbasah.com/#/',twTitile:'Ain Popiah Basah',twvia:'Ain Popiah Basah'},/* google Plus data   */gp:{gpURL:'https://www.ainpopiahbasah.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.ainpopiahbasah.com/#/',waSeparator:'Ain Popiah Basah'},site_title:'Ain Popiah Basah',forcewww:'YES',site_title_with_separator:' | Ain Popiah Basah',home_meta_title:"Welcome to Ain Popiah Basah",bgimage:'/img/ninjaprocmn/ainpopiahbasah/body_bg.jpg'}),_defineProperty(_domainValues,"order.jixingmalatang.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"81E8BA48-026E-4044-B202-5666405A02DD",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Jixing Hotpot',stripeImage:"https://order.jixingmalatang.com/img/ninjaprocmn/jixingmalatang/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'jixingmalatang',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.ainpopiahbasah.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.jixingmalatang.com/#/',fbImage:'https://order.jixingmalatang.com/img/jixingmalatang/logo.png',fbTitle:'Jixing Hotpot',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.jixingmalatang.com/'},/* Twitter  */tw:{twURL:'https://order.jixingmalatang.com/#/',twTitile:'Jixing Hotpot',twvia:'Jixing Hotpot'},/* google Plus data   */gp:{gpURL:'https://order.jixingmalatang.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.jixingmalatang.com/#/',waSeparator:'Jixing Hotpot'},site_title:'Jixing Hotpot',site_title_with_separator:' | Jixing Hotpot',home_meta_title:"Welcome to Jixing Hotpot",bgimage:'/img/ninjaprocmn/jixingmalatang/body_bg.jpg'}),_defineProperty(_domainValues,"www.eatsbysam.asia",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"0F8612BD-A60D-4BBF-9BB7-E81A5A29FED7",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Eats by Sam',stripeImage:"https://www.eatsbysam.asia/img/ninjaprocmn/eatbysam/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'eatbysam',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.eatsbysam.asia/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.eatsbysam.asia/#/',fbImage:'https://order.jixingmalatang.com/img/eatbysam/logo.png',fbTitle:'Eats by Sam',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.eatsbysam.asia/'},/* Twitter  */tw:{twURL:'https://www.eatsbysam.asia/#/',twTitile:'Eats by Sam',twvia:'Eats by Sam'},/* google Plus data   */gp:{gpURL:'https://www.eatsbysam.asia/#/'},/* Whatsapp data   */wa:{waURL:'https://www.eatsbysam.asia/#/',waSeparator:'Eats by Sam'},site_title:'Eats by Sam',forcewww:'YES',site_title_with_separator:' | Eats by Sam',home_meta_title:"Welcome to Eats by Sam",bgimage:'/img/ninjaprocmn/eatbysam/body_bg.jpg'}),_defineProperty(_domainValues,"www.yuhuangpremiumseafoodsoup.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"B3C6369B-E3D4-4D67-B3D8-6C6991CB8F7F",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Yu Huang Premium Seafood Soup',stripeImage:"https://www.yuhuangpremiumseafoodsoup.com/img/ninjaprocmn/yuhuangpremiumseafoodsoup/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'yuhuangpremiumseafoodsoup',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.yuhuangpremiumseafoodsoup.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.yuhuangpremiumseafoodsoup.com/#/',fbImage:'https://www.yuhuangpremiumseafoodsoup.com/img/yuhuangpremiumseafoodsoup/logo.png',fbTitle:'Yu Huang Premium Seafood Soup',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.yuhuangpremiumseafoodsoup.com/'},/* Twitter  */tw:{twURL:'https://www.yuhuangpremiumseafoodsoup.com/#/',twTitile:'Yu Huang Premium Seafood Soup',twvia:'Yu Huang Premium Seafood Soup'},/* google Plus data   */gp:{gpURL:'https://www.yuhuangpremiumseafoodsoup.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.yuhuangpremiumseafoodsoup.com/#/',waSeparator:'Yu Huang Premium Seafood Soup'},site_title:'Yu Huang Premium Seafood Soup',forcewww:'YES',site_title_with_separator:' | Yu Huang Premium Seafood Soup',home_meta_title:"Welcome to Yu Huang Premium Seafood Soup",bgimage:'/img/ninjaprocmn/yuhuangpremiumseafoodsoup/body_bg.jpg'}),_defineProperty(_domainValues,"www.woai.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"997BE745-2103-4E1F-BE8C-546164A20F42",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'WOAI',stripeImage:"https://www.woai.sg/img/ninjaprocmn/woai/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'woai',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.woai.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.woai.sg/#/',fbImage:'https://www.woai.sg/img/woai/logo.png',fbTitle:'WOAI',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.woai.sg/'},/* Twitter  */tw:{twURL:'https://www.woai.sg/#/',twTitile:'WOAI',twvia:'WOAI'},/* google Plus data   */gp:{gpURL:'https://www.woai.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://www.woai.sg/#/',waSeparator:'WOAI'},site_title:'WOAI',forcewww:'YES',site_title_with_separator:' | WOAI',home_meta_title:"Welcome to WOAI",bgimage:'/img/ninjaprocmn/woai/body_bg.jpg'}),_defineProperty(_domainValues,"www.ordersogreen.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"DC5995FE-B9CD-45C3-9DA6-AECACFB09776",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'So Green',stripeImage:"https://www.ordersogreen.com/img/ninjaprocmn/ordersogreen/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'ordersogreen',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.ordersogreen.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.ordersogreen.com/#/',fbImage:'https://www.ordersogreen.com/img/ordersogreen/logo.png',fbTitle:'So Green',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.ordersogreen.com/'},/* Twitter  */tw:{twURL:'https://www.ordersogreen.com/#/',twTitile:'So Green',twvia:'So Green'},/* google Plus data   */gp:{gpURL:'https://www.ordersogreen.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.ordersogreen.com/#/',waSeparator:'So Green'},site_title:'So Green',forcewww:'YES',site_title_with_separator:' | So Green',home_meta_title:"Welcome to So Green",bgimage:'/img/ninjaprocmn/ordersogreen/body_bg.jpg'}),_defineProperty(_domainValues,"www.hometasteleicha.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"BAAB7D5D-07DB-41B4-92A1-EFAE2022A494",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Hometaste Hakka Lei Cha',stripeImage:"https://www.hometasteleicha.com/img/ninjaprocmn/hometasteleicha/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'hometasteleicha',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.hometasteleicha.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.hometasteleicha.com/#/',fbImage:'https://www.hometasteleicha.com/img/hometasteleicha/logo.png',fbTitle:'Hometaste Hakka Lei Cha',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.hometasteleicha.com/'},/* Twitter  */tw:{twURL:'https://www.hometasteleicha.com/#/',twTitile:'Hometaste Hakka Lei Cha',twvia:'Hometaste Hakka Lei Cha'},/* google Plus data   */gp:{gpURL:'https://www.hometasteleicha.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.hometasteleicha.com/#/',waSeparator:'Hometaste Hakka Lei Cha'},site_title:'Hometaste Hakka Lei Cha',forcewww:'YES',site_title_with_separator:' | Hometaste Hakka Lei Cha',home_meta_title:"Welcome to Hometaste Hakka Lei Cha",bgimage:'/img/ninjaprocmn/hometasteleicha/body_bg.jpg'}),_defineProperty(_domainValues,"www.lotusgrocerysg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F5BBD8AF-DDC1-48F9-A16F-2628CD398DCC",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Lotus Grocery',stripeImage:"https://www.lotusgrocerysg.com/img/ninjaprocmn/lotusgrocerysg/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'lotusgrocerysg',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.lotusgrocerysg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.lotusgrocerysg.com/#/',fbImage:'https://www.lotusgrocerysg.com/img/lotusgrocerysg/logo.png',fbTitle:'Lotus Grocery',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.lotusgrocerysg.com/'},/* Twitter  */tw:{twURL:'https://www.lotusgrocerysg.com/#/',twTitile:'Lotus Grocery',twvia:'Lotus Grocery'},/* google Plus data   */gp:{gpURL:'https://www.lotusgrocerysg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.lotusgrocerysg.com/#/',waSeparator:'Lotus Grocery'},site_title:'Lotus Grocery',forcewww:'YES',site_title_with_separator:' | Lotus Grocery',home_meta_title:"Welcome to Lotus Grocery",bgimage:'/img/ninjaprocmn/lotusgrocerysg/body_bg.jpg'}),_defineProperty(_domainValues,"shop.soupdayz.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"81E8BA48-026E-4044-B202-5666405A02DD",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Soupdayz',stripeImage:"https://shop.soupdayz.com/img/ninjaprocmn/soupdayz/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'soupdayz',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.soupdayz.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://shop.soupdayz.com/#/',fbImage:'https://shop.soupdayz.com/img/soupdayz/logo.png',fbTitle:'Soupdayz',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://shop.soupdayz.com/'},/* Twitter  */tw:{twURL:'https://shop.soupdayz.com/#/',twTitile:'Soupdayz',twvia:'Soupdayz'},/* google Plus data   */gp:{gpURL:'https://shop.soupdayz.com/#/'},/* Whatsapp data   */wa:{waURL:'https://shop.soupdayz.com/#/',waSeparator:'Soupdayz'},site_title:'Soupdayz',site_title_with_separator:' | Soupdayz',home_meta_title:"Welcome to Soupdayz",bgimage:'/img/ninjaprocmn/soupdayz/body_bg.jpg'}),_defineProperty(_domainValues,"www.uulicious.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"19F0724A-7125-494C-B2EC-699FC716B71A",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Uulicious',stripeImage:"https://www.uulicious.com/img/ninjaprocmn/uulicious/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'uulicious',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.uulicious.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.uulicious.com/#/',fbImage:'https://www.uulicious.com/img/uulicious/logo.png',fbTitle:'Uulicious',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.uulicious.com/'},/* Twitter  */tw:{twURL:'https://www.uulicious.com/#/',twTitile:'Uulicious',twvia:'Uulicious'},/* google Plus data   */gp:{gpURL:'https://www.uulicious.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.uulicious.com/#/',waSeparator:'Uulicious'},site_title:'Uulicious',forcewww:'YES',site_title_with_separator:' | Uulicious',home_meta_title:"Welcome to Uulicious",bgimage:'/img/ninjaprocmn/uulicious/body_bg.jpg'}),_defineProperty(_domainValues,"www.veggielovers.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"3A2B3C39-DF47-4D79-B96C-F512526BAE6E",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Veggie lovers',stripeImage:"https://www.veggielovers.sg/img/ninjaprocmn/veggielovers/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'veggielovers',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.veggielovers.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.veggielovers.sg/#/',fbImage:'https://www.veggielovers.sg/img/veggielovers/logo.png',fbTitle:'Veggie lovers',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.veggielovers.sg/'},/* Twitter  */tw:{twURL:'https://www.veggielovers.sg/#/',twTitile:'Veggie lovers',twvia:'Veggie lovers'},/* google Plus data   */gp:{gpURL:'https://www.veggielovers.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://www.veggielovers.sg/#/',waSeparator:'Veggie lovers'},site_title:'Veggie lovers',forcewww:'YES',site_title_with_separator:' | Veggie lovers',home_meta_title:"Welcome to Veggie lovers",bgimage:'/img/ninjaprocmn/veggielovers/body_bg.jpg'}),_defineProperty(_domainValues,"www.fernvalehappydurian.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"37835F97-6948-46CE-BF7C-0F4F0072EA8A",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Happy Durian',stripeImage:"https://www.fernvalehappydurian.com/img/ninjaprocmn/fernvalehappydurian/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'fernvalehappydurian',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.fernvalehappydurian.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.fernvalehappydurian.com/#/',fbImage:'https://www.fernvalehappydurian.com/img/fernvalehappydurian/logo.png',fbTitle:'Happy Durian',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.fernvalehappydurian.com/'},/* Twitter  */tw:{twURL:'https://www.fernvalehappydurian.com/#/',twTitile:'Happy Durian',twvia:'Happy Durian'},/* google Plus data   */gp:{gpURL:'https://www.fernvalehappydurian.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.fernvalehappydurian.com/#/',waSeparator:'Happy Durian'},site_title:'Happy Durian',forcewww:'YES',site_title_with_separator:' | Happy Durian',home_meta_title:"Welcome to Happy Durian",bgimage:'/img/ninjaprocmn/fernvalehappydurian/body_bg.jpg'}),_defineProperty(_domainValues,"www.norazkitchen.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"5737BF76-F5CC-41C6-91B9-8BA3DCBE754F",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Noraz Kitchen',stripeImage:"https://www.norazkitchen.com/img/ninjaprocmn/norazkitchen/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'norazkitchen',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.norazkitchen.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.norazkitchen.com/#/',fbImage:'https://www.norazkitchen.com/img/norazkitchen/logo.png',fbTitle:'Noraz Kitchen',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.norazkitchen.com/'},/* Twitter  */tw:{twURL:'https://www.norazkitchen.com/#/',twTitile:'Noraz Kitchen',twvia:'Noraz Kitchen'},/* google Plus data   */gp:{gpURL:'https://www.norazkitchen.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.norazkitchen.com/#/',waSeparator:'Noraz Kitchen'},site_title:'Noraz Kitchen',forcewww:'YES',site_title_with_separator:' | Noraz Kitchen',home_meta_title:"Welcome to Noraz Kitchen",bgimage:'/img/ninjaprocmn/norazkitchen/body_bg.jpg'}),_defineProperty(_domainValues,"www.lovefulgroup.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"15FC3E21-FE67-4446-8E17-FC13D5B78C35",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Loveful',stripeImage:"https://www.lovefulgroup.com/img/ninjaprocmn/lovefulgroup/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'lovefulgroup',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.lovefulgroup.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.lovefulgroup.com/#/',fbImage:'https://www.lovefulgroup.com/img/lovefulgroup/logo.png',fbTitle:'Loveful',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.lovefulgroup.com/'},/* Twitter  */tw:{twURL:'https://www.lovefulgroup.com/#/',twTitile:'Loveful',twvia:'Loveful'},/* google Plus data   */gp:{gpURL:'https://www.lovefulgroup.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.lovefulgroup.com/#/',waSeparator:'Loveful'},site_title:'Loveful',forcewww:'YES',site_title_with_separator:' | Loveful',home_meta_title:"Welcome to Loveful",bgimage:'/img/ninjaprocmn/lovefulgroup/body_bg.jpg'}),_defineProperty(_domainValues,"www.khairunmiyah.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"8002102B-F3D1-4850-BCBF-14FE3739D82F",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Khairunmiyah Crispy Prata',stripeImage:"https://www.khairunmiyah.com/img/ninjaprocmn/khairunmiyah/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'khairunmiyah',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.khairunmiyah.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.khairunmiyah.com/#/',fbImage:'https://www.khairunmiyah.com/img/khairunmiyah/logo.png',fbTitle:'Khairunmiyah Crispy Prata',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.khairunmiyah.com/'},/* Twitter  */tw:{twURL:'https://www.khairunmiyah.com/#/',twTitile:'Khairunmiyah Crispy Prata',twvia:'Khairunmiyah Crispy Prata'},/* google Plus data   */gp:{gpURL:'https://www.khairunmiyah.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.khairunmiyah.com/#/',waSeparator:'Khairunmiyah Crispy Prata'},site_title:'Khairunmiyah Crispy Prata',forcewww:'YES',site_title_with_separator:' | Khairunmiyah Crispy Prata',home_meta_title:"Welcome to Khairunmiyah Crispy Prata",bgimage:'/img/ninjaprocmn/khairunmiyah/body_bg.jpg'}),_defineProperty(_domainValues,"www.pizzapazzasg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"423079F7-2DEB-45FF-9080-6594857779BB",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Pizza pazza',stripeImage:"https://www.pizzapazzasg.com/img/ninjaprocmn/pizzapazzasg/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'pizzapazzasg',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.pizzapazzasg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.pizzapazzasg.com/#/',fbImage:'https://www.pizzapazzasg.com/img/pizzapazzasg/logo.png',fbTitle:'Pizza pazza',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.pizzapazzasg.com/'},/* Twitter  */tw:{twURL:'https://www.pizzapazzasg.com/#/',twTitile:'Pizza pazza',twvia:'Pizza pazza'},/* google Plus data   */gp:{gpURL:'https://www.pizzapazzasg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.pizzapazzasg.com/#/',waSeparator:'Pizza pazza'},site_title:'Pizza pazza',forcewww:'YES',site_title_with_separator:' | Pizza pazza',home_meta_title:"Welcome to Pizza pazza",bgimage:'/img/ninjaprocmn/pizzapazzasg/body_bg.jpg'}),_defineProperty(_domainValues,"www.5grillkitchen.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"FDC6D6C1-AE13-4098-9F28-D2EA3E17E113",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'5 Grill Kitchen',stripeImage:"https://www.5grillkitchen.com/img/ninjaprocmn/5grillkitchen/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'5grillkitchen',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.5grillkitchen.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.5grillkitchen.com/#/',fbImage:'https://www.5grillkitchen.com/img/5grillkitchen/logo.png',fbTitle:'5 Grill Kitchen',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.5grillkitchen.com/'},/* Twitter  */tw:{twURL:'https://www.5grillkitchen.com/#/',twTitile:'5 Grill Kitchen',twvia:'5 Grill Kitchen'},/* google Plus data   */gp:{gpURL:'https://www.5grillkitchen.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.5grillkitchen.com/#/',waSeparator:'5 Grill Kitchen'},site_title:'5 Grill Kitchen',forcewww:'YES',site_title_with_separator:' | 5 Grill Kitchen',home_meta_title:"Welcome to 5 Grill Kitchen",bgimage:'/img/ninjaprocmn/5grillkitchen/body_bg.jpg'}),_defineProperty(_domainValues,"order.mickeymomo.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"C7529362-730D-4495-A0C1-9440A57CC899",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Mickeymomo',stripeImage:"https://order.mickeymomo.com/img/ninjaprocmn/mickeymomo/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'mickeymomo',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.mickeymomo.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.mickeymomo.com/#/',fbImage:'https://order.mickeymomo.com/img/mickeymomo/logo.png',fbTitle:'Mickeymomo',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.mickeymomo.com/'},/* Twitter  */tw:{twURL:'https://order.mickeymomo.com/#/',twTitile:'Mickeymomo',twvia:'Mickeymomo'},/* google Plus data   */gp:{gpURL:'https://order.mickeymomo.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.mickeymomo.com/#/',waSeparator:'Mickeymomo'},site_title:'Mickeymomo',site_title_with_separator:' | Mickeymomo',home_meta_title:"Welcome to Mickeymomo",bgimage:'/img/ninjaprocmn/mickeymomo/body_bg.jpg'}),_defineProperty(_domainValues,"www.sgbuttercakes.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"5694483D-B9D5-4B2C-859D-8382BBA10D2C",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'SG Butter Cakes',stripeImage:"https://www.sgbuttercakes.com/img/ninjaprocmn/sgbuttercakes/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'sgbuttercakes',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.sgbuttercakes.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.sgbuttercakes.com/#/',fbImage:'https://www.sgbuttercakes.com/img/sgbuttercakes/logo.png',fbTitle:'SG Butter Cakes',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.sgbuttercakes.com/'},/* Twitter  */tw:{twURL:'https://www.sgbuttercakes.com/#/',twTitile:'SG Butter Cakes',twvia:'SG Butter Cakes'},/* google Plus data   */gp:{gpURL:'https://www.sgbuttercakes.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.sgbuttercakes.com/#/',waSeparator:'SG Butter Cakes'},site_title:'SG Butter Cakes',forcewww:'YES',site_title_with_separator:' | SG Butter Cakes',home_meta_title:"Welcome to SG Butter Cakes",bgimage:'/img/ninjaprocmn/sgbuttercakes/body_bg.jpg'}),_defineProperty(_domainValues,"order.thericenspice.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"709C9821-905E-4DED-98D4-6FF566CD5E85",fbAppId:"299877000824930",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Rice and Spice',stripeImage:"https://order.thericenspice.com/img/ninjaprocmn/thericenspice/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'thericenspice',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.thericenspice.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.thericenspice.com/#/',fbImage:'https://order.thericenspice.com/img/thericenspice/logo.png',fbTitle:'Rice and Spice',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.thericenspice.com/'},/* Twitter  */tw:{twURL:'https://order.thericenspice.com/#/',twTitile:'Rice and Spice',twvia:'Rice and Spice'},/* google Plus data   */gp:{gpURL:'https://order.thericenspice.com/#/'},/* Whatsapp data   */wa:{waURL:'https://order.thericenspice.com/#/',waSeparator:'Rice and Spice'},site_title:'Rice and Spice',site_title_with_separator:' | Rice and Spice',home_meta_title:"Welcome to Rice and Spice",bgimage:'/img/ninjaprocmn/thericenspice/body_bg.jpg'}),_defineProperty(_domainValues,"www.twobakingpans.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"DB9DF050-44BF-47BB-85DC-D9981FA37AD5",fbAppId:"6719004438130245",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Two Baking Pans',stripeImage:"https://www.twobakingpans.com/img/ninjaprocmn/twobakingpans/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'twobakingpans',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.twobakingpans.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.twobakingpans.com/#/',fbImage:'https://www.twobakingpans.com/img/twobakingpans/logo.png',fbTitle:'Two Baking Pans',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.twobakingpans.com/'},/* Twitter  */tw:{twURL:'https://www.twobakingpans.com/#/',twTitile:'Two Baking Pans',twvia:'Two Baking Pans'},/* google Plus data   */gp:{gpURL:'https://www.twobakingpans.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.twobakingpans.com/#/',waSeparator:'Two Baking Pans'},site_title:'Two Baking Pans',site_title_with_separator:' | Two Baking Pans',home_meta_title:"Welcome to Two Baking Pans",bgimage:'/img/ninjaprocmn/twobakingpans/body_bg.jpg'}),_defineProperty(_domainValues,"sweetcheeks.ninjapro.co",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"B0A122F4-BAB4-4906-A1AA-A6103115EA97",fbAppId:"986531779440247",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Sweet Cheeks',stripeImage:"https://sweetcheeks.ninjapro.co/img/ninjaprocmn/sweetcheeks/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'sweetcheeks',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://sweetcheeks.ninjapro.co/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://sweetcheeks.ninjapro.co/#/',fbImage:'https://sweetcheeks.ninjapro.co/img/sweetcheeks/logo.png',fbTitle:'Sweet Cheeks',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://sweetcheeks.ninjapro.co/'},/* Twitter  */tw:{twURL:'https://sweetcheeks.ninjapro.co/#/',twTitile:'Sweet Cheeks',twvia:'Sweet Cheeks'},/* google Plus data   */gp:{gpURL:'https://sweetcheeks.ninjapro.co/#/'},/* Whatsapp data   */wa:{waURL:'https://sweetcheeks.ninjapro.co/#/',waSeparator:'Sweet Cheeks'},site_title:'Sweet Cheeks',site_title_with_separator:' | Sweet Cheeks',home_meta_title:"Welcome to Sweet Cheeks",bgimage:'/img/ninjaprocmn/sweetcheeks/body_bg.jpg'}),_defineProperty(_domainValues,"order.sweetcheeks.sg",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"B0A122F4-BAB4-4906-A1AA-A6103115EA97",fbAppId:"986531779440247",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Sweet Cheeks',stripeImage:"https://order.sweetcheeks.sg/img/ninjaprocmn/sweetcheeks/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'sweetcheeks',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://order.sweetcheeks.sg/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://order.sweetcheeks.sg/#/',fbImage:'https://order.sweetcheeks.sg/img/sweetcheeks/logo.png',fbTitle:'Sweet Cheeks',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://order.sweetcheeks.sg/'},/* Twitter  */tw:{twURL:'https://order.sweetcheeks.sg/#/',twTitile:'Sweet Cheeks',twvia:'Sweet Cheeks'},/* google Plus data   */gp:{gpURL:'https://order.sweetcheeks.sg/#/'},/* Whatsapp data   */wa:{waURL:'https://order.sweetcheeks.sg/#/',waSeparator:'Sweet Cheeks'},site_title:'Sweet Cheeks',site_title_with_separator:' | Sweet Cheeks',home_meta_title:"Welcome to Sweet Cheeks",bgimage:'/img/ninjaprocmn/sweetcheeks/body_bg.jpg'}),_defineProperty(_domainValues,"www.qilixiangsg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"957CDEF7-25F1-446C-B758-AF0BC637722C",fbAppId:"992697608823469",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Qi Li Xiang 七里香',stripeImage:"https://www.qilixiangsg.com/img/ninjaprocmn/qilixiangsg/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'qilixiangsg',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.qilixiangsg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.qilixiangsg.com/#/',fbImage:'https://www.qilixiangsg.com/img/qilixiangsg/logo.png',fbTitle:'Qi Li Xiang 七里香',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.qilixiangsg.com/'},/* Twitter  */tw:{twURL:'https://www.qilixiangsg.com/#/',twTitile:'Qi Li Xiang 七里香',twvia:'Qi Li Xiang 七里香'},/* google Plus data   */gp:{gpURL:'https://www.qilixiangsg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.qilixiangsg.com/#/',waSeparator:'Qi Li Xiang 七里香'},site_title:'Qi Li Xiang 七里香',site_title_with_separator:' | Qi Li Xiang 七里香',home_meta_title:"Welcome to Qi Li Xiang 七里香",bgimage:'/img/ninjaprocmn/qilixiangsg/body_bg.jpg'}),_defineProperty(_domainValues,"www.cafeiace.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"70BC17DD-EF1B-49D5-94FC-3E7F5E7E0720",fbAppId:"199361353119509",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Cafeiace',stripeImage:"https://www.cafeiace.com/img/ninjaprocmn/cafeiace/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'cafeiace',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.cafeiace.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.cafeiace.com/#/',fbImage:'https://www.cafeiace.com/img/cafeiace/logo.png',fbTitle:'Cafeiace',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.cafeiace.com/'},/* Twitter  */tw:{twURL:'https://www.cafeiace.com/#/',twTitile:'Cafeiace',twvia:'Cafeiace'},/* google Plus data   */gp:{gpURL:'https://www.cafeiace.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.cafeiace.com/#/',waSeparator:'Cafeiace'},site_title:'Cafeiace',site_title_with_separator:' | Cafeiace',home_meta_title:"Welcome to Cafeiace",bgimage:'/img/ninjaprocmn/cafeiace/body_bg.jpg'}),_defineProperty(_domainValues,"www.dsweettouch.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"23265954-7AC1-4D85-B3CD-CE446670EB1B",fbAppId:"893334919127628",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'D Sweet Touch',stripeImage:"https://www.dsweettouch.com/img/ninjaprocmn/dsweettouch/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'dsweettouch',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.dsweettouch.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.dsweettouch.com/#/',fbImage:'https://www.dsweettouch.com/img/dsweettouch/logo.png',fbTitle:'D Sweet Touch',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.dsweettouch.com/'},/* Twitter  */tw:{twURL:'https://www.dsweettouch.com/#/',twTitile:'D Sweet Touch',twvia:'D Sweet Touch'},/* google Plus data   */gp:{gpURL:'https://www.dsweettouch.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.dsweettouch.com/#/',waSeparator:'dsweettouch'},site_title:'D Sweet Touch',site_title_with_separator:' | D Sweet Touch',home_meta_title:"Welcome to D Sweet Touch",bgimage:'/img/ninjaprocmn/dsweettouch/body_bg.jpg'}),_defineProperty(_domainValues,"www.chunfusg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"8797E7FC-3BCD-40FC-9772-22B29A092B9F",fbAppId:"893334919127628",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Chun Fu Seafood',stripeImage:"https://www.chunfusg.com/img/ninjaprocmn/chunfusg/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'chunfusg',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.chunfusg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.chunfusg.com/#/',fbImage:'https://www.chunfusg.com/img/chunfusg/logo.png',fbTitle:'Chun Fu Seafood',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.chunfusg.com/'},/* Twitter  */tw:{twURL:'https://www.chunfusg.com/#/',twTitile:'Chun Fu Seafood',twvia:'Chun Fu Seafood'},/* google Plus data   */gp:{gpURL:'https://www.chunfusg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.chunfusg.com/#/',waSeparator:'chunfusg'},site_title:'Chun Fu Seafood',site_title_with_separator:' | Chun Fu Seafood',home_meta_title:"Welcome to Chun Fu Seafood",bgimage:'/img/ninjaprocmn/chunfusg/body_bg.jpg'}),_defineProperty(_domainValues,"www.supersisterdurians.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"F1C3A062-A88A-466C-A273-5DBDCED4EBFD",fbAppId:"893334919127628",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Super Sister Durian',stripeImage:"https://www.supersisterdurians.com/img/ninjaprocmn/supersisterdurians/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'supersisterdurians',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.supersisterdurians.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.supersisterdurians.com/#/',fbImage:'https://www.supersisterdurians.com/img/supersisterdurians/logo.png',fbTitle:'Super Sister Durian',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.supersisterdurians.com/'},/* Twitter  */tw:{twURL:'https://www.supersisterdurians.com/#/',twTitile:'Super Sister Durian',twvia:'Super Sister Durian'},/* google Plus data   */gp:{gpURL:'https://www.supersisterdurians.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.supersisterdurians.com/#/',waSeparator:'supersisterdurians'},site_title:'Super Sister Durian',site_title_with_separator:' | Super Sister Durian',home_meta_title:"Welcome to Super Sister Durian",bgimage:'/img/ninjaprocmn/supersisterdurians/body_bg.jpg'}),_defineProperty(_domainValues,"www.liyangmalahotpot.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"721BA299-1E18-46A6-A0A1-26E90052A2B2",fbAppId:"893334919127628",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Li Yang Mala Hotpot',stripeImage:"https://www.liyangmalahotpot.com/img/ninjaprocmn/liyangmalahotpot/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'liyangmalahotpot',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.liyangmalahotpot.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.liyangmalahotpot.com/#/',fbImage:'https://www.liyangmalahotpot.com/img/liyangmalahotpot/logo.png',fbTitle:'Li Yang Mala Hotpot',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.liyangmalahotpot.com/'},/* Twitter  */tw:{twURL:'https://www.liyangmalahotpot.com/#/',twTitile:'Li Yang Mala Hotpot',twvia:'Li Yang Mala Hotpot'},/* google Plus data   */gp:{gpURL:'https://www.liyangmalahotpot.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.liyangmalahotpot.com/#/',waSeparator:'liyangmalahotpot'},site_title:'Li Yang Mala Hotpot',site_title_with_separator:' | Li Yang Mala Hotpot',home_meta_title:"Welcome to Li Yang Mala Hotpot",bgimage:'/img/ninjaprocmn/liyangmalahotpot/body_bg.jpg'}),_defineProperty(_domainValues,"www.orderchooswok.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"A09AF37E-F4B3-47CB-8869-5792ED8D983B",fbAppId:"893334919127628",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Lucky Starsb F&B Pte Ltd',stripeImage:"https://www.orderchooswok.com/img/ninjaprocmn/orderchooswok/stripe_logo.png",stripeEmail:'vignesh@jankosoft.com',stripeReference:'orderchooswok',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.orderchooswok.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.orderchooswok.com/#/',fbImage:'https://www.orderchooswok.com/img/orderchooswok/logo.png',fbTitle:'Lucky Starsb F&B Pte Ltd',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.orderchooswok.com/'},/* Twitter  */tw:{twURL:'https://www.orderchooswok.com/#/',twTitile:'Lucky Starsb F&B Pte Ltd',twvia:'Lucky Starsb F&B Pte Ltd'},/* google Plus data   */gp:{gpURL:'https://www.orderchooswok.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.orderchooswok.com/#/',waSeparator:'orderchooswok'},site_title:'Lucky Starsb F&B Pte Ltd',site_title_with_separator:' | Lucky Starsb F&B Pte Ltd',home_meta_title:"Welcome to Lucky Starsb F&B Pte Ltd",bgimage:'/img/ninjaprocmn/orderchooswok/body_bg.jpg'}),_defineProperty(_domainValues,"www.kimkeehainanesesg.com",{apiUrl:protocoltxt+'//mars.ninjaos.com/api/',//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:protocoltxt+'//mars.ninjaos.com/ninjapro/',//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:protocoltxt+"//mars.ninjaos.com/apiv2/",tinThumpUrl:protocoltxt+'//mars.ninjaos.com/timthumb.php?src=',appId:"3900251D-B30D-4D69-8B0F-D81BE5C52A46",fbAppId:"893334919127628",logo:"/img/ninjaprocmn/logo.png",chatWidget:"eeeee",stripeKey:"pk_test_gOgyc4KtNAk48z5WOuqFQWdP",stripeCompany:'Kim Kee Hainanese Chicken Rice',stripeImage:"https://www.kimkeehainanesesg.com/img/ninjaprocmn/kimkeesg/stripe_logo.png",stripeEmail:'dev@jankosoft.com',stripeReference:'kimkeesg',stripeDesc:'My Checkout',stripeCurrency:'SGD',defaultAvilablityId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',defaultAvilablityName:'Delivery',defaultAvilablityImage:'/img/icons/Delivery_white.png',baseUrl:'https://www.kimkeehainanesesg.com/#/',product_thumbnail:"/img/no-images/productthump-no-image.jpg",product_listing:"/img/no-images/products-no-image.jpg",fb:{fbURL:'https://www.kimkeehainanesesg.com/#/',fbImage:'https://www.kimkeehainanesesg.com/img/kimkeesg/logo.png',fbTitle:'Kim Kee Hainanese Chicken Rice',fbDesc:'Yes ! I love the food here, and did I say its also a great place to eat ! Check out : url : https://www.kimkeehainanesesg.com/'},/* Twitter  */tw:{twURL:'https://www.kimkeehainanesesg.com/#/',twTitile:'Kim Kee Hainanese Chicken Rice',twvia:'Kim Kee Hainanese Chicken Rice'},/* google Plus data   */gp:{gpURL:'https://www.kimkeehainanesesg.com/#/'},/* Whatsapp data   */wa:{waURL:'https://www.kimkeehainanesesg.com/#/',waSeparator:'kimkeesg'},site_title:'Kim Kee Hainanese Chicken Rice',site_title_with_separator:' | Kim Kee Hainanese Chicken Rice',home_meta_title:"Welcome to Kim Kee Hainanese Chicken Rice",bgimage:'/img/ninjaprocmn/kimkeesg/body_bg.jpg'}),_domainValues);/*console.log(hostname);
	console.log(domainValues[hostname]);
	console.log(hostname.substring(0,3));*/if(hostname.substring(0,3)!=='www'){var hostnametemp="www."+hostname;if(domainValues[hostnametemp]!==undefined&&domainValues[hostnametemp].forcewww!==undefined&&domainValues[hostnametemp].forcewww==='YES'){window.location="https://"+hostnametemp;}}/*if(hostname.substring(0,3)!=='www'){
		let hostnametemp ="www."+hostname; 
		try {
		if(domainValues[hostnametemp] !== undefined && domainValues[hostnametemp].forcewww=='YES')
		{
			window.location = "https://"+hostnametemp;
		}
		}catch(err) {
			console.log(err)}
	}*//* get current host name */var getAppValues={/* all path values */path:{baseUrl:domainValues[hostname].baseUrl,apiUrl:domainValues[hostname].apiUrl,//'https://ccpl.ninjaos.com/api/',
	apiUrlPro:domainValues[hostname].apiUrlPro,//'https://ccpl.ninjaos.com/ninjapro/',
	apiUrlv2:domainValues[hostname].apiUrlv2,apiUrlNotify:protocoltxt+'//mars.ninjaos.com/',tinThumpUrl:domainValues[hostname].tinThumpUrl,logo:domainValues[hostname].logo},ids:{appId:domainValues[hostname].appId,deliveryId:'634E6FA8-8DAF-4046-A494-FFC1FCF8BD11',pickupId:'718B1A92-5EBB-4F25-B24D-3067606F67F0',dineinId:'EF9FB350-4FD4-4894-9381-3E859AB74019',reservationId:'79FA4C7F-75A1-4A95-B7CE-81ECA2575363',currency:'$',defaultAvilablityId:domainValues[hostname].defaultAvilablityId,defaultAvilablityName:domainValues[hostname].defaultAvilablityName,defaultAvilablityImage:domainValues[hostname].defaultAvilablityImage,fbAppId:domainValues[hostname].fbAppId//'104121986790084' demo - 410091149364782
	},stripe:{stripeCompany:domainValues[hostname].stripeCompany,stripeImage:domainValues[hostname].stripeImage,stripeKey:domainValues[hostname].stripeKey,stripeEmail:domainValues[hostname].stripeEmail,stripeReference:domainValues[hostname].stripeReference,stripeDesc:domainValues[hostname].stripeDesc,stripeCurrency:domainValues[hostname].stripeCurrency},noImages:{product_thumbnail:domainValues[hostname].product_thumbnail,product_listing:domainValues[hostname].product_listing},fb:domainValues[hostname].fb,/* Twitter  */tw:domainValues[hostname].tw,/* google Plus data   */gp:domainValues[hostname].gp,/* Whatsapp data   */wa:domainValues[hostname].wa,site_title:domainValues[hostname].site_title,site_title_with_separator:domainValues[hostname].site_title_with_separator,home_meta_title:domainValues[hostname].home_meta_title,home_meta_keywords:domainValues[hostname].home_meta_keywords,home_meta_description:domainValues[hostname].home_meta_description,enablescan:domainValues[hostname].enablesccan!==undefined&&domainValues[hostname].enablesccan!=='No'?"Yes":"No"};/* Chat Widget */var fileref=document.createElement('script');fileref.setAttribute("type","text/javascript");fileref.setAttribute("src",'//keyreply.com/chat/widget.js');fileref.setAttribute("data-align","left");fileref.setAttribute("data-overlay","false");fileref.setAttribute("id","keyreply-script");fileref.setAttribute("id","keyreply-script");fileref.setAttribute("data-color","#E4392B");fileref.setAttribute("data-apps",domainValues[hostname].chatWidget);document.getElementsByTagName("body")[0].appendChild(fileref);module.exports=getAppValues;document.body.style.background='url('+domainValues[hostname].bgimage+') repeat';

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.load = load;
	exports.select = select;
	exports.save = save;
	exports.remove = remove;
	exports.setRawCookie = setRawCookie;
	exports.plugToRequest = plugToRequest;
	
	var _cookie = __webpack_require__(556);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _objectAssign = __webpack_require__(18);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IS_NODE = typeof document === 'undefined' || process && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test';
	var _rawCookie = {};
	var _res = undefined;
	
	function _isResWritable() {
	  return _res && !_res.headersSent;
	}
	
	function load(name, doNotParse) {
	  var cookies = IS_NODE ? _rawCookie : _cookie2.default.parse(document.cookie);
	  var cookieVal = cookies && cookies[name];
	
	  if (typeof doNotParse === 'undefined') {
	    doNotParse = !cookieVal || cookieVal[0] !== '{' && cookieVal[0] !== '[';
	  }
	
	  if (!doNotParse) {
	    try {
	      cookieVal = JSON.parse(cookieVal);
	    } catch (e) {
	      // Not serialized object
	    }
	  }
	
	  return cookieVal;
	}
	
	function select(regex) {
	  var cookies = IS_NODE ? _rawCookie : _cookie2.default.parse(document.cookie);
	
	  if (!cookies) {
	    return {};
	  }
	
	  if (!regex) {
	    return cookies;
	  }
	
	  return Object.keys(cookies).reduce(function (accumulator, name) {
	    if (!regex.test(name)) {
	      return accumulator;
	    }
	
	    var newCookie = {};
	    newCookie[name] = cookies[name];
	    return (0, _objectAssign2.default)({}, accumulator, newCookie);
	  }, {});
	}
	
	function save(name, val, opt) {
	  _rawCookie[name] = val;
	
	  // allow you to work with cookies as objects.
	  if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
	    _rawCookie[name] = JSON.stringify(val);
	  }
	
	  // Cookies only work in the browser
	  if (!IS_NODE) {
	    document.cookie = _cookie2.default.serialize(name, _rawCookie[name], opt);
	  }
	
	  if (_isResWritable() && _res.cookie) {
	    _res.cookie(name, val, opt);
	  }
	}
	
	function remove(name, opt) {
	  delete _rawCookie[name];
	
	  if (typeof opt === 'undefined') {
	    opt = {};
	  } else if (typeof opt === 'string') {
	    // Will be deprecated in future versions
	    opt = { path: opt };
	  } else {
	    // Prevent mutation of opt below
	    opt = (0, _objectAssign2.default)({}, opt);
	  }
	
	  if (typeof document !== 'undefined') {
	    opt.expires = new Date(1970, 1, 1, 0, 0, 1);
	    opt.maxAge = 0;
	    document.cookie = _cookie2.default.serialize(name, '', opt);
	  }
	
	  if (_isResWritable() && _res.clearCookie) {
	    _res.clearCookie(name, opt);
	  }
	}
	
	function setRawCookie(rawCookie) {
	  if (rawCookie) {
	    _rawCookie = _cookie2.default.parse(rawCookie);
	  } else {
	    _rawCookie = {};
	  }
	}
	
	function plugToRequest(req, res) {
	  if (req.cookie) {
	    _rawCookie = req.cookie;
	  } else if (req.cookies) {
	    _rawCookie = req.cookies;
	  } else if (req.headers && req.headers.cookie) {
	    setRawCookie(req.headers.cookie);
	  } else {
	    _rawCookie = {};
	  }
	
	  _res = res;
	
	  return function unplug() {
	    _res = null;
	    _rawCookie = {};
	  };
	}
	
	exports.default = {
	  setRawCookie: setRawCookie,
	  load: load,
	  select: select,
	  save: save,
	  remove: remove,
	  plugToRequest: plugToRequest
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75)))

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(46);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(182);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(81);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(852);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(440);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(848);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(863);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(849);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(850);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(442);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(851);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(183);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(861);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(447);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(854);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(855);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(859);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(444);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(485);

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadAnalytics = loadAnalytics;
	exports.fbPixelCustomEvent = fbPixelCustomEvent;
	
	var _reactGa = __webpack_require__(833);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _reactFacebookPixel = __webpack_require__(830);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function loadAnalytics() {
	  var gaID = typeof _reactCookie2.default.load("ga_id") !== null ? _reactCookie2.default.load("ga_id") : "";
	  var fbPixelID = typeof _reactCookie2.default.load("fb_pixel_id") !== null ? _reactCookie2.default.load("fb_pixel_id") : "";
	
	  if (gaID) {
	    _reactGa2.default.initialize(gaID);
	    _reactGa2.default.pageview(window.location.hash);
	  }
	
	  if (fbPixelID) {
	    var options = {
	      autoConfig: true,
	      debug: false
	    };
	
	    _reactFacebookPixel2.default.init(fbPixelID, {}, options);
	    _reactFacebookPixel2.default.pageView();
	  }
	}
	
	function fbPixelCustomEvent(event, data) {
	  var fbPixelID = typeof _reactCookie2.default.load("fb_pixel_id") !== null ? _reactCookie2.default.load("fb_pixel_id") : "";
	
	  if (fbPixelID) {
	    var options = {
	      autoConfig: true,
	      debug: false
	    };
	
	    _reactFacebookPixel2.default.init(fbPixelID, {}, options);
	    _reactFacebookPixel2.default.trackCustom(event, data);
	  }
	}

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(30);
	
	var config = __webpack_require__(7);
	
	module.exports = {
	
	  /* Home page navigation items   d*/
	  navigation: {
	    home: 'Home',
	    myaccount: 'My Account',
	    vieworders: 'View Orders',
	    viewrewards: 'View Rewards',
	    about: 'About Us',
	    privacy: 'Privacy Policy',
	    contact: 'Contact Us'
	  },
	
	  fb: config.fb,
	  /* Twitter  */
	  tw: config.tw,
	  /* google Plus data   */
	  gp: config.gp,
	  /* Whatsapp data   */
	  wa: config.wa,
	
	  /* Availability and images lables */
	  delivery: "Delivery",
	  deliveryImage: "/img/icons/Delivery.png",
	  deliveryImageWhite: "/img/icons/Delivery_white.svg",
	  takeaWay: "Takeaway",
	  takeaWayImage: "/img/icons/Takeaway.svg",
	  takeaWayImageWhite: "/img/icons/Takeaway_white.svg",
	  dineIn: "Dine In",
	  dineInImage: "/img/icons/home-popup/dineIn.svg",
	  dineInImageWhite: "/img/icons/dineIn_white.svg",
	  dineInImageWhiteDefault: "/img/icons/home-popup/dineIn_white.svg",
	  reservation: "Reservation",
	  reservationImage: "/img/icons/Reservation.svg",
	  reservationImageWhite: "/img/icons/Reservation_white.svg",
	  /*  Products Module Languages  */
	  no_products_found: "No Products found ",
	
	  /*  Cart  Module Languages  */
	  add_to_cart: "Add To Cart",
	  no_cart_items: "No items found in the cart",
	  availability_disabled: "Other availabilities currently disabled by administrator",
	  select_all_modofier: "Please select all modifiers",
	  modifier_missing: "product combination is wrong. Please check your combination",
	  combo_missing: "Combo product selection wrong. Please check your products",
	  cart_success: "Great Choice ! Item added to cart",
	
	  /* checkout page */
	  choose_payment_mode: "Please choose any one payment method",
	  user_info_missing: "Some User basic information missing. Please update your profile and try again",
	  delivery_info_missing: "Please choose a delivery date and time.",
	  something_wrong: "Something went wrong. Please check all user information (or) product details",
	
	  /* delvery date module */
	  choose_delvery_date: "Choose delivery date",
	  choose_delvery_date_error: "Please choose a delivery/pickup date and time.",
	
	  /* sign up page and related modules  */
	  signup_success: "Thank you for signing up. Please check your email for an activation link or do check your spam inbox in the event you do not find your email.",
	  reset_key_invalid: "Invalid security key.",
	
	  /*all page meta tags */
	  site_title: config.site_title,
	  site_title_with_separator: config.site_title_with_separator,
	  home_meta_title: config.home_meta_title,
	  home_meta_description: !(0, _lodash.isUndefined)(config.home_meta_description) ? config.home_meta_description : config.home_meta_title,
	  home_meta_keywords: !(0, _lodash.isUndefined)(config.home_meta_keywords) ? config.home_meta_keywords : config.home_meta_title,
	  prodcuts_meta_title: "Products Details",
	  scan_qr_code_page: "Book a Table",
	  signin_meta_title: "User Signin",
	  signup_meta_title: "User signup",
	  forgotpassword_meta_title: "forgot password",
	  checkout_meta_title: "Checkout",
	  ordersuccess_meta_title: "Order Success",
	  about_meta_title: "Aboutus",
	  privacy_meta_title: "Privacy Policy",
	  myaccount_meta_title: "My account",
	  contactus_meta_title: "Contact us",
	  orders_meta_title: "Orders",
	  cart_page_title: "Cart",
	  cart_page_description: "",
	  cart_page_keywords: "",
	  addons_meta_title: "Complete Your Meal",
	  activation_meta_title: "Please wait, we are validating your account",
	  reset_meta_title: "Reset Password",
	  outlet_closed_message: "Currently all outlets are closed. please try again later."
	
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.stripslashes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* eslint-disable */
	
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _reactRouter = __webpack_require__(9);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = __webpack_require__(7);
	var lang = __webpack_require__(12);
	
	var APPID = config.ids.appId;
	var APIURL = config.path.apiUrl;
	var APIURLPRO = config.path.apiUrlPro;
	var qs = __webpack_require__(3);
	var HtmlToReactParser = __webpack_require__(21).Parser;
	var htmlToReactParser = new HtmlToReactParser();
	var apps = __webpack_require__(29);
	
	/* address format */
	exports.addressFormat = function (unitOne, unitTwo, addressOne, addressTwo, postCode) {
		var unit = unitTwo !== "" && unitOne !== "" ? "#" + unitOne + "-" + unitTwo + "," : unitOne !== '' ? "#" + unitOne + "," : "";
		return unit + addressOne;
	};
	
	/* set default avilablity  */
	exports.setDefaultAvailability = function (avlId, avlText, avlImage) {
		if (typeof _reactCookie2.default.load('defaultAvilablityId') === 'undefined' || _reactCookie2.default.load('defaultAvilablityId') === "" || typeof _reactCookie2.default.load('defaultAvilablity') === 'undefined' || _reactCookie2.default.load('defaultAvilablity') === "" || typeof _reactCookie2.default.load('defaultAvilablityImage') === 'undefined' || _reactCookie2.default.load('defaultAvilablityImage') === "") {
			_reactCookie2.default.save('defaultAvilablityId', avlId, {});
			_reactCookie2.default.save('defaultAvilablity', avlText, {});
			_reactCookie2.default.save('defaultAvilablityImage', avlImage, {});
		}
	};
	
	exports.loadingImage = function () {
		return "<div style={{bottom : 0, left: 0, position: 'fixed', right : 0,  top : 0, margin :'auto'}}> <img src='/img/loader.gif' alt=''  style={{bottom : 0, left: 0, position: 'fixed', right : 0,  top : 0, margin :'auto'}} /> </div>";
	};
	
	/* this function used to show unit */
	exports.unitFormat = function (noOne, noTwo) {
		if (noOne != '' && noTwo != "") {
			return "#" + noOne + "-" + noTwo;
		} else if (noOne != "") {
			return "#" + noOne;
		} else if (noTwo != "") {
			return noTwo;
		}
	};
	
	/* this function used for static table setup sarvesh */
	exports.sarveshTableSetup = function () {
	
		var postObject = {};
		postObject = { 'app_id': APPID, 'tm_table_number': 'Wavehouse' };
		_axios2.default.post(APIURL + "tablemanagement/find_table", qs.stringify(postObject)).then(function (res) {
			if (res.data.status === "ok") {
				_reactCookie2.default.save('orderOutletId', res.data.result_set[0].outlet_id);
				_reactCookie2.default.save('orderOutletName', res.data.result_set[0].outlet_name);
				_reactCookie2.default.save('orderTableNo', res.data.result_set[0].tm_table_number);
				var tatVal = res.data.result_set[0].outlet_dine_tat !== "" ? res.data.result_set[0].outlet_dine_tat : res.data.result_set[0].outlet_delivery_timing;
				_reactCookie2.default.save('orderTAT', tatVal);
				if (_reactCookie2.default.load('dineinClick') === 'yes') {
					_reactRouter.hashHistory.push("/");
				} else {
					_reactRouter.hashHistory.push("/checkout");
				}
			} else if (res.data.status === "error") {
				_reactCookie2.default.save('orderOutletId', '76');
				_reactCookie2.default.save('orderOutletName', 'Thaikkudam Bridge');
				_reactCookie2.default.save('orderTableNo', 'Wavehouse');
				_reactCookie2.default.save('orderTAT', '15');
				_reactRouter.hashHistory.push("/checkout");
				if (_reactCookie2.default.load('dineinClick') === 'yes') {
					_reactRouter.hashHistory.push("/");
				} else {
					_reactRouter.hashHistory.push("/checkout");
				}
			}
		});
	};
	
	/* check vaild input */
	exports.validInput = function (inPut) {
		if (typeof _reactCookie2.default.load('defaultAvilablityId') === 'undefined') {}
	};
	
	/* shop timing  funtion */
	exports.shopTiming = function (start, end) {
		if (typeof start !== "undefined" && start !== "" && typeof end !== "undefined" && end !== "") {
			return start + " - " + end;
		}
	};
	
	/* shop timing  funtion */
	exports.defauktImage = function (availId) {
		if (typeof start !== "undefined" && start !== "" && typeof end !== "undefined" && end !== "") {
			return start + " - " + end;
		}
	};
	
	/* sample funtion */
	exports.findDevice = function () {
	
		if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i)
		//|| navigator.userAgent.match(/iPhone/i)
		//|| navigator.userAgent.match(/iPad/i)
		//|| navigator.userAgent.match(/iPod/i)
		|| navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
			return "Others";
		} else if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i)) {
			return "IOS";
		} else {
	
			return "Web";
		}
	};
	
	/* sample funtion */
	exports.getGstValue = function (gst, subtotal, format) {
	
		var gst = parseFloat(gst);
		var subtotal = parseFloat(subtotal);
		var gstResult = 0;
	
		if (gst > 0) {
			gstResult = gst / 100 * subtotal;
		}
	
		if (format === "format") {
			return gstResult.toFixed(2);
		} else {
			return gstResult;
		}
	};
	
	/* gstInclusive  amount funtion */
	exports.getInclusiveGst = function (gstVal, total, format) {
		if (gstVal > 0) {
			var vatDivisor = 1 + gstVal / 100;
			var gstpercentage = gstVal / 100;
			var productvalue = total / vatDivisor;
			var gst = productvalue * gstpercentage;
			var return_data = [];
			return_data['text'] = "GST Inclusive" + "(" + gstVal + "%): $" + gst.toFixed(2);
			return_data['value'] = gst.toFixed(2);
			return_data['percentage'] = gstVal;
		} else {
			var return_data = [];
		}
	
		return return_data;
	};
	
	/* sample funtion */
	exports.getServicecharge = function (service_percent, total_amt, format) {
	
		var service_percent = parseFloat(service_percent);
		var total_amt = parseFloat(total_amt);
		var cal_amount = 0;
	
		if (service_percent > 0) {
			cal_amount = service_percent / 100 * total_amt;
		}
	
		if (format === "format") {
			return cal_amount.toFixed(2);
		} else {
			return cal_amount;
		}
	};
	
	/*
	 
	showInfo(alrtmessage,alertheader)
	{
	$('.alrt_overlay').remove();
	$('.custom_alert').remove();
	
	alertheader =  (typeof(alertheader) =="undefined" )?  "Information" :  alertheader;
	
	
	   $('body').append('<div class="alrt_overlay"></div><div class="custom_alert"><div class="custom_alertin"><div class="alert_height"><div class="alert_header">'+ alertheader +'</div><div class="alert_body"> '+ alrtmessage +' <div class="alt_btns"><a href="javascript:;" class="btn btn-info reject" id="alt0">Close</a></div></div></div></div></div>');
		
		   var actheight=$('.alert_height').height();
		   $('.custom_alert').height(actheight+10);
	   
		
	   $('.alt_btns a').click(function(e) {
		  $('.alrt_overlay, .custom_alert').remove();
		  
	   });
	} 
	 
	*/
	exports.showInfo = function (alrtmessage, alertheade) {
	
		$('.alrt_overlay').remove();
		$('.custom_alert').remove();
	
		var alertheader = typeof alertheader == "undefined" ? "Information" : alertheader;
	
		$('body').append('<div class="alrt_overlay"></div><div class="custom_alert"><div class="custom_alertin"><div class="alert_height"><div class="alert_header">' + alertheader + '</div><div class="alert_body"> ' + alrtmessage + ' <div class="alt_btns"><a href="javascript:;" class="btn btn-info reject" id="alt0">Close</a></div></div></div></div></div>');
	
		var actheight = $('.alert_height').height();
		$('.custom_alert').height(actheight + 10);
	
		$('.alt_btns a').click(function (e) {
			$('.alrt_overlay, .custom_alert').remove();
		});
	};
	
	exports.confirmAlert = function (alrtmessage, alertheader) {
	
		$('.alrt_overlay').remove();
		$('.custom_alert').remove();
	
		var alertheader = typeof alertheader == "undefined" ? "Confirmation" : alertheader;
	
		$('body').append('<div class="alrt_overlay"></div><div class="custom_alert"><div class="custom_alertin"><div class="alert_height"><div class="alert_header">' + alertheader + '</div><div class="alert_body"> ' + alrtmessage + ' <div class="alt_btns"><a href="javascript:;" class="btn btn-primary confirm" id="alt1">OK</a><a href="javascript:;" class="btn btn-info reject" id="alt0">Cancel</a></div></div></div></div></div>');
	
		var actheight = $('.alert_height').height();
		$('.custom_alert').height(actheight + 10);
	
		$('.alt_btns a').click(function (e) {
			$('.alrt_overlay, .custom_alert').remove();
		});
	};
	
	/*  get pro settings */
	exports.getProSettings = function (allowPostalcode, postalFilter) {
	
		if (allowPostalcode === "Yes") {
			var postalStr = "&postal_code=" + _reactCookie2.default.load('orderPostalCode');
		} else {
			postalStr = "";
		}
		var postalFilter = postalFilter === "Yes" ? "Yes" : "No";
		return _axios2.default.get(APIURLPRO + 'settings/get_common_settings?app_id=' + APPID + postalStr + "&postalFilter=" + postalFilter);
	};
	
	/* get static block content */
	exports.getStaticBlock = function (blockSlug) {
	
		return _axios2.default.get(APIURL + 'cms/staticblocks?app_id=' + APPID + "&slug=" + blockSlug);
	};
	
	/* sample funtion */
	exports.getAliasName = function (alias, productName) {
	
		return alias != "" ? alias : productName;
	};
	
	/* get subtotal value  */
	exports.getsubTotal = function (subTotal, OriginalAmount, promotionApplied) {
		var redeemptionApplied = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	
		if (promotionApplied === "Yes") {
			return subTotal;
		} else if (redeemptionApplied === "Yes") {
			return subTotal;
		} else {
			return OriginalAmount;
		}
	};
	
	/* get subtotal value  */
	exports.getDeliveryCharge = function (promotionApplied, deliveryEnabled, OriginalAmount) {
		var isFreeDelivery = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	
		if (promotionApplied === "Yes" && deliveryEnabled === "Yes" || isFreeDelivery === "Yes") {
			return 0;
		} else {
			return OriginalAmount;
		}
	};
	
	/* get subtotal value  */
	exports.getAdditionalDeliveryCharge = function (promotionApplied, deliveryEnabled, OriginalAmount) {
		var isFreeDelivery = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	
		if (promotionApplied === "Yes" && deliveryEnabled === "Yes" || isFreeDelivery === "Yes") {
			return 0;
		} else {
			return OriginalAmount;
		}
	};
	
	/* Show cart count  */
	exports.cartCount = function () {
	
		var count = parseInt(_reactCookie2.default.load('cartCount'));
	
		if (_reactCookie2.default.load('cartValue') === "Yes" && typeof _reactCookie2.default.load('cartCount') !== 'undefined' && count > 0) {
	
			return htmlToReactParser.parse('<span className="count">' + count + '</span>');
		}
	};
	
	/* Show cart class   */
	exports.cartClass = function () {
	
		var count = parseInt(_reactCookie2.default.load('cartCount'));
	
		if (_reactCookie2.default.load('cartValue') === "Yes" && typeof _reactCookie2.default.load('cartCount') !== 'undefined' && count > 0) {
	
			return "rel cart-icon bounce";
		} else {
	
			return "rel cart-icon";
		}
	};
	
	/* add body tag class for workspace */
	exports.addBodyClass = function (appId) {
	
		if (APPID === apps.workspace) {
			document.body.className += ' ' + 'workspace-css';
		}
	};
	
	/* sample funtion */
	exports.myFunc2 = function () {
		return "wellcome1";
	};
	
	exports.alphabet = function (e) {
		var re = /^[a-zA-Z. ]*$/;
		if (!re.test(e.key)) {
			e.preventDefault();
		}
	};
	
	exports.numariconly = function (e) {
		var re = /[0-9. ]+/g;
		if (!re.test(e.key)) {
			e.preventDefault();
		}
	};
	/* distance part */
	exports.getSortedList = function (obj, coordinate) {
		var returnValue = {};
		var coordinateVal = coordinate;
		if (!(0, _lodash.isEmpty)(obj)) {
			var sortObject = obj.map(function (option) {
				var distanceVal = distance(option.outlet_marker_latitude, option.outlet_marker_longitude, coordinateVal);
				var newPropsObj = {
					distance: distanceVal
				};
				return Object.assign(option, newPropsObj);
			});
			returnValue = (0, _lodash.orderBy)(sortObject, function (data) {
				return (0, _moment2.default)(data['distance']);
			}, ['asc']);
		}
		return returnValue;
	};
	
	function distance(lat1, lon1, coordinate) {
	
		if (coordinate) {
	
			var lat2 = coordinate.latitude;
			var lon2 = coordinate.longitude;
			var R = 6371; // km (change this constant to get miles)
			var dLat = (lat2 - lat1) * Math.PI / 180;
			var dLon = (lon2 - lon1) * Math.PI / 180;
			var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
			var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
			var d = R * c;
			if (d > 1) return Math.round(d); //km
			else if (d <= 1) return Math.round(d * 1000) + "m";
			return d;
		}
	}
	
	/* distance part */
	
	/* truncate  */
	exports.truncate = function (input, type) {
		var windowWidth = window.innerWidth >= 480 ? 100 : type === 1 ? 40 : 40;
		if (input && input.length > 0) {
			if (input.length > windowWidth) {
				return input.substring(0, windowWidth) + '...';
			}
			return input;
		} else {
			return "";
		}
	};
	
	exports.disableMenu = function (object, value) {
	
		var isAnonymousUser = parseInt(_reactCookie2.default.load("isAnonymousUser"));
	
		if (typeof object !== "undefined" && typeof object.menu_enable_settings !== "undefined" && typeof object.menu_enable_settings[value] !== "undefined") {
			return false;
		} else {
			return isAnonymousUser === 1 && (0, _lodash.includes)(['home_main_vouchers', 'home_main_orders', 'home_main_promos', 'home_main_rewards', 'home_main_vouchers', 'home_sub_my_account', 'home_sub_orders', 'home_sub_rewards'], value) ? false : true;
		}
	};
	
	/* sample funtion */
	exports.isAnonymousUserRedirect = function () {
		var isAnonymousUser = parseInt(_reactCookie2.default.load("isAnonymousUser"));
		console.log('isAnonymousUser', isAnonymousUser);
		if (isAnonymousUser === 1) {
			console.log('isAnonymousUser', isAnonymousUser);
			_reactRouter.hashHistory.push("/");
			this.showInfo("You don't have access to view this pages");
		}
	};
	
	/* disable textarea for some customers*/
	exports.disableSpecialInstructions = function (appID) {
	
		var clients = ['6FCDE66B-8022-421E-A41B-34AF16B3A645'];
	
		return (0, _lodash.includes)(clients, appID) ? false : true;
	};
	
	/* sample funtion */
	exports.getTat = function () {};
	
	/* show Loader */
	exports.showLoader = function (divRef, type) {
		if (type === 'class') {
			$('.' + divRef).addClass('loader-main-cls').append('<div class="loader-sub-div"></div>');
		} else {
			$('#' + divRef).addClass('loader-main-cls').append('<div class="loader-sub-div"></div>');
		}
	};
	
	/* hide Loader */
	exports.hideLoader = function (divRef, type) {
		if (type === 'class') {
			$('.' + divRef).removeClass('loader-main-cls');
			$('.' + divRef).find('.loader-sub-div').remove();
		} else {
			$('#' + divRef).removeClass('loader-main-cls');
			$('#' + divRef).find('.loader-sub-div').remove();
		}
	};
	
	/* stripslashes  */
	var stripslashes = exports.stripslashes = function stripslashes(str) {
		console.log(str, "str");
	
		if (str !== "" && str !== null && (typeof str === 'undefined' ? 'undefined' : _typeof(str)) !== undefined && typeof str !== "undefined") {
			str = str.replace(/\\'/g, "'");
			str = str.replace(/\\"/g, '"');
			str = str.replace(/\\0/g, "\0");
			str = str.replace(/\\\\/g, "\\");
			return str;
		}
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(34);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _server = __webpack_require__(436);
	
	var _reactSideEffect = __webpack_require__(895);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _utils = __webpack_require__(410);
	
	var _dom = __webpack_require__(768);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function reducePropsTostate(propsList) {
	  var props = {};
	
	  var extend = true;
	
	  for (var i = propsList.length - 1; extend && i >= 0; i--) {
	    extend = propsList[i].hasOwnProperty('extend');
	
	    var _props = (0, _utils.clone)(propsList[i]);
	
	    if (_props.hasOwnProperty('description')) {
	      (0, _utils.defaults)(_props, { meta: { name: { description: _props.description } } });
	    }
	    if (_props.hasOwnProperty('canonical')) {
	      (0, _utils.defaults)(_props, { link: { rel: { canonical: _props.canonical } } });
	    }
	
	    (0, _utils.defaults)(props, _props);
	  }
	
	  // Auto props
	  if (props.auto) {
	    if (props.auto.ograph) {
	      ograph(props);
	    }
	  }
	
	  return props;
	}
	
	function handleStateChangeOnClient(props) {
	  if (_dom.canUseDOM) {
	    document.title = props.title || '';
	    (0, _dom.insertDocumentMeta)(getTags(props));
	  }
	}
	
	function ograph(p) {
	  if (!p.meta) {
	    p.meta = {};
	  }
	  if (!p.meta.property) {
	    p.meta.property = {};
	  }
	
	  var group = p.meta.property;
	  if (group) {
	    if (p.title && !group['og:title']) {
	      group['og:title'] = p.title;
	    }
	    if (p.hasOwnProperty('description') && !group['og:description']) {
	      group['og:description'] = p.description;
	    }
	    if (p.hasOwnProperty('canonical') && !group['og:url']) {
	      group['og:url'] = p.canonical;
	    }
	  }
	  return p;
	}
	
	function parseTags(tagName) {
	  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var tags = [];
	  var contentKey = tagName === 'link' ? 'href' : 'content';
	  Object.keys(props).forEach(function (groupKey) {
	    var group = props[groupKey];
	    if (typeof group === 'string') {
	      tags.push(_defineProperty({
	        tagName: tagName
	      }, groupKey, group));
	      return;
	    }
	    Object.keys(group).forEach(function (key) {
	      var values = Array.isArray(group[key]) ? group[key] : [group[key]];
	      values.forEach(function (value) {
	        if (value !== null) {
	          var _tags$push2;
	
	          tags.push((_tags$push2 = {
	            tagName: tagName
	          }, _defineProperty(_tags$push2, groupKey, key), _defineProperty(_tags$push2, contentKey, value), _tags$push2));
	        }
	      });
	    });
	  });
	  return tags;
	}
	
	function getTags(_props) {
	  return [].concat(parseTags('meta', _props.meta), parseTags('link', _props.link));
	}
	
	function render() {
	  var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var opts = arguments[1];
	
	  if ((typeof opts === 'undefined' ? 'undefined' : _typeof(opts)) !== 'object') {
	    return meta;
	  }
	
	  var i = 0;
	  var tags = [];
	
	  function renderTag(entry) {
	    var tagName = entry.tagName,
	        attr = _objectWithoutProperties(entry, ['tagName']);
	
	    if (tagName === 'meta') {
	      return _react2.default.createElement('meta', _extends({}, attr, { key: i++, 'data-rdm': true }));
	    }
	    if (tagName === 'link') {
	      return _react2.default.createElement('link', _extends({}, attr, { key: i++, 'data-rdm': true }));
	    }
	    return null;
	  }
	
	  if (meta.title) {
	    tags.push(_react2.default.createElement(
	      'title',
	      { key: i++ },
	      meta.title
	    ));
	  }
	
	  getTags(meta).reduce(function (acc, entry) {
	    tags.push(renderTag(entry));
	    return tags;
	  }, tags);
	
	  if (opts.asReact) {
	    return tags;
	  }
	
	  return (0, _server.renderToStaticMarkup)(_react2.default.createElement(
	    'div',
	    null,
	    tags
	  )).replace(/(^<div>|<\/div>$)/g, '').replace(/data-rdm="true"/g, 'data-rdm');
	}
	
	var DocumentMeta = function (_Component) {
	  _inherits(DocumentMeta, _Component);
	
	  function DocumentMeta() {
	    _classCallCheck(this, DocumentMeta);
	
	    return _possibleConstructorReturn(this, (DocumentMeta.__proto__ || Object.getPrototypeOf(DocumentMeta)).apply(this, arguments));
	  }
	
	  _createClass(DocumentMeta, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	      var count = _react2.default.Children.count(children);
	      return count === 1 ? _react2.default.Children.only(children) : count ? _react2.default.createElement(
	        'div',
	        null,
	        this.props.children
	      ) : null;
	    }
	  }]);
	
	  return DocumentMeta;
	}(_react.Component);
	
	DocumentMeta.propTypes = {
	  title: _react.PropTypes.string,
	  description: _react.PropTypes.string,
	  base: _react.PropTypes.string,
	  canonical: _react.PropTypes.string,
	  meta: _react.PropTypes.objectOf(_react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.objectOf(_react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string)]))])),
	  link: _react.PropTypes.objectOf(_react.PropTypes.objectOf(_react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string)]))),
	  auto: _react.PropTypes.objectOf(_react.PropTypes.bool)
	};
	
	
	var DocumentMetaWithSideEffect = (0, _reactSideEffect2.default)(reducePropsTostate, handleStateChangeOnClient)(DocumentMeta);
	
	DocumentMetaWithSideEffect.renderAsReact = function rewindAsReact() {
	  return render(DocumentMetaWithSideEffect.rewind(), { asReact: true });
	};
	
	DocumentMetaWithSideEffect.renderAsHTML = function rewindAsHTML() {
	  return render(DocumentMetaWithSideEffect.rewind(), { asHtml: true });
	};
	
	DocumentMetaWithSideEffect.renderToStaticMarkup = function rewindAsHTML() {
	  return render(DocumentMetaWithSideEffect.rewind(), { asHtml: true });
	};
	
	exports.default = DocumentMetaWithSideEffect;
	module.exports = exports['default'];


/***/ },
/* 16 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var Loading = React.createClass({
	    displayName: 'Loading',
	
	    render: function render() {
	        return React.createElement(
	            'div',
	            { style: { bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto' } },
	            ' ',
	            React.createElement('img', { src: '/img/loader.gif', alt: '', style: { bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto' } }),
	            ' '
	        );
	    }
	});
	
	module.exports = Loading;

/***/ },
/* 18 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = __webpack_require__(7);
	var APIURL = config.path.apiUrl;
	var APIURLPRO = config.path.apiUrlPro;
	var APPID = config.ids.appId;
	
	module.exports = function (type, param) {
	
		if (type === 'category') {
			/* API CALL FOR PRODUCT MENU NAVIGATION */
			return _axios2.default.get(APIURL + 'productsver3/navigation_menu?app_id=' + APPID + "&availability=" + _reactCookie2.default.load('defaultAvilablityId'));
		} else if (type === 'settings') {
			/* get all settings  */
	
			return _axios2.default.get(APIURL + 'settings/get_common_settings?app_id=' + APPID + "&postal_code=" + _reactCookie2.default.load('orderPostalCode') + "&postalFilter=" + param);
		} else if (type === 'settingsPro') {
			/* get all settings  */
			return _axios2.default.get(APIURLPRO + 'settings/get_common_settings?app_id=' + APPID + "&postal_code=" + _reactCookie2.default.load('orderPostalCode') + "&postalFilter=" + param);
		} else if (type === 'settingsProWithavailability') {
			/* get all settings  */
			return _axios2.default.get(APIURLPRO + 'settings/get_common_settings?app_id=' + APPID + "&availability=" + _reactCookie2.default.load('defaultAvilablityId') + "&postal_code=" + _reactCookie2.default.load('orderPostalCode') + "&postalFilter=" + param);
		} else if (type === 'product') {
			return _axios2.default.get(APIURLPRO + 'productsver2/ninjapro_products_list?app_id=' + APPID + '&status=A&availability=' + _reactCookie2.default.load('defaultAvilablityId') + '&' + param);
		} else if (type === "cartImage") {
			/* used to load cart image */
			return _reactCookie2.default.load('cartValue') === "Yes" ? "/img/icons/shopping-cart.png" : "/img/icons/shopping-cart.png";
		} else if (type === "referenceId") /* get referenceId */
			{
				if (typeof _reactCookie2.default.load('referenceId') === 'undefined') {
					var randomKey = randomId();
					_reactCookie2.default.save('referenceId', randomKey, {});
					return randomKey;
				} else {
					return _reactCookie2.default.load('referenceId');
				}
			} else if (type === "Auth") {
			/* this function used to cyheck user login */
	
			if (typeof _reactCookie2.default.load('UserId') === 'undefined') {
				return false;
			}
		} else if (type === "fillAllData") /* this function used to fill all customer information  */
			{
				if (typeof _reactCookie2.default.load('UserId') === 'undefined' || typeof _reactCookie2.default.load('UserId') === 'undefined' || typeof _reactCookie2.default.load('UserId') === 'undefined' || typeof _reactCookie2.default.load('UserId') === 'undefined') {
					return false;
				}
			} else if (type === "minCartAmount") /* this function used to validate minimum cart amount  */
			{} else if (type === "UserDetails") {
			/* this function used to cyheck user login */
	
			if (typeof _reactCookie2.default.load('UserId') === 'undefined' || _reactCookie2.default.load('UserId') === "" || _reactCookie2.default.load('UserId') === "null" || typeof _reactCookie2.default.load('UserFname') === 'undefined' || _reactCookie2.default.load('UserFname') === "" || _reactCookie2.default.load('UserFname') === "null" || typeof _reactCookie2.default.load('UserEmail') === 'undefined' || _reactCookie2.default.load('UserEmail') === "" || _reactCookie2.default.load('UserEmail') === "null" || typeof _reactCookie2.default.load('UserMobile') === "undefined" || _reactCookie2.default.load('UserMobile') === "" || _reactCookie2.default.load('UserMobile') === "null") {
				return false;
			}
		} else if (type === "DeliveryDetails") {
			/* this function used to cyheck user login */
	
			if (typeof _reactCookie2.default.load('DeliveryDate') === 'undefined' || _reactCookie2.default.load('DeliveryDate') === "") {
	
				if ((typeof _reactCookie2.default.load('DeliveryTime') === 'undefined' || _reactCookie2.default.load('DeliveryTime') === "") && _reactCookie2.default.load('isSletedTimeSlot') === "No") {
					return false;
				} else if ((typeof _reactCookie2.default.load('DeliveryTimeSlot') === 'undefined' || _reactCookie2.default.load('DeliveryTimeSlot') === "") && _reactCookie2.default.load('isSletedTimeSlot') === "Yes") {
					return false;
				}
			}
		}
	
		/* this function used to create random string*/
		function randomId() {
			var text = "";
			var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	
			for (var i = 0; i < 50; i++) {
				text += possible.charAt(Math.floor(Math.random() * possible.length));
			}return text;
		}
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
		var nativeCodeString = '[native code]';
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
						classes.push(arg.toString());
						continue;
					}
	
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var parser = __webpack_require__(640);
	var processingInstructions = __webpack_require__(245);
	var isValidNodeDefinitions = __webpack_require__(243);
	var processNodeDefinitions = __webpack_require__(244);
	
	module.exports = {
	  Parser: parser,
	  ProcessingInstructions: processingInstructions,
	  IsValidNodeDefinitions: isValidNodeDefinitions,
	  ProcessNodeDefinitions: processNodeDefinitions,
	};


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var DOMProperty = __webpack_require__(80);
	var ReactDOMComponentFlags = __webpack_require__(414);
	
	var invariant = __webpack_require__(6);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(782);


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.tileProps = exports.tileGroupProps = exports.isView = exports.isClassName = exports.isViews = exports.isValue = exports.isMaxDate = exports.isMinDate = exports.isCalendarType = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var calendarTypes = ['ISO 8601', 'US', 'Arabic', 'Hebrew'];
	var allViews = ['century', 'decade', 'year', 'month'];
	
	var isCalendarType = _propTypes["default"].oneOf(calendarTypes);
	
	exports.isCalendarType = isCalendarType;
	
	var isMinDate = function isMinDate(props, propName, componentName) {
	  var minDate = props[propName];
	
	  if (minDate) {
	    if (!(minDate instanceof Date)) {
	      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
	    }
	
	    var maxDate = props.maxDate;
	
	    if (maxDate && minDate > maxDate) {
	      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, minDate cannot be larger than maxDate."));
	    }
	  } // Everything is fine
	
	
	  return null;
	};
	
	exports.isMinDate = isMinDate;
	
	var isMaxDate = function isMaxDate(props, propName, componentName) {
	  var maxDate = props[propName];
	
	  if (maxDate) {
	    if (!(maxDate instanceof Date)) {
	      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
	    }
	
	    var minDate = props.minDate;
	
	    if (minDate && maxDate < minDate) {
	      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, maxDate cannot be smaller than minDate."));
	    }
	  } // Everything is fine
	
	
	  return null;
	};
	
	exports.isMaxDate = isMaxDate;
	
	var isValue = _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].arrayOf(_propTypes["default"].instanceOf(Date))]);
	
	exports.isValue = isValue;
	
	var isViews = _propTypes["default"].arrayOf(_propTypes["default"].oneOf(allViews));
	
	exports.isViews = isViews;
	
	var isClassName = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]);
	
	exports.isClassName = isClassName;
	
	var isView = function isView(props, propName, componentName) {
	  var view = props[propName];
	  var views = props.views;
	  var allowedViews = views || allViews;
	
	  if (view !== undefined && allowedViews.indexOf(view) === -1) {
	    return new Error("Invalid prop `".concat(propName, "` of value `").concat(view, "` supplied to `").concat(componentName, "`, expected one of [").concat(allowedViews.map(function (a) {
	      return "\"".concat(a, "\"");
	    }).join(', '), "]."));
	  } // Everything is fine
	
	
	  return null;
	};
	
	exports.isView = isView;
	
	isView.isRequired = function (props, propName, componentName) {
	  var view = props[propName];
	
	  if (!view) {
	    return new Error("The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(view, "`."));
	  }
	
	  return isView(props, propName, componentName);
	};
	
	var tileGroupProps = {
	  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
	  hover: _propTypes["default"].instanceOf(Date),
	  locale: _propTypes["default"].string,
	  maxDate: isMaxDate,
	  minDate: isMinDate,
	  onClick: _propTypes["default"].func,
	  onMouseOver: _propTypes["default"].func,
	  tileClassName: _propTypes["default"].oneOfType([_propTypes["default"].func, isClassName]),
	  tileContent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
	  value: isValue,
	  valueType: _propTypes["default"].string
	};
	exports.tileGroupProps = tileGroupProps;
	var tileProps = {
	  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
	  classes: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
	  date: _propTypes["default"].instanceOf(Date).isRequired,
	  locale: _propTypes["default"].string,
	  maxDate: isMaxDate,
	  minDate: isMinDate,
	  onClick: _propTypes["default"].func,
	  onMouseOver: _propTypes["default"].func,
	  style: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),
	  tileClassName: _propTypes["default"].oneOfType([_propTypes["default"].func, isClassName]),
	  tileContent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
	  tileDisabled: _propTypes["default"].func
	};
	exports.tileProps = tileProps;

/***/ },
/* 26 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 27 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getYear = getYear;
	exports.getMonth = getMonth;
	exports.getMonthIndex = getMonthIndex;
	exports.getDay = getDay;
	exports.getDayOfWeek = getDayOfWeek;
	exports.getBeginOfCenturyYear = getBeginOfCenturyYear;
	exports.getBeginOfCentury = getBeginOfCentury;
	exports.getEndOfCentury = getEndOfCentury;
	exports.getCenturyRange = getCenturyRange;
	exports.getBeginOfPreviousCentury = getBeginOfPreviousCentury;
	exports.getEndOfPreviousCentury = getEndOfPreviousCentury;
	exports.getBeginOfNextCentury = getBeginOfNextCentury;
	exports.getBeginOfDecadeYear = getBeginOfDecadeYear;
	exports.getBeginOfDecade = getBeginOfDecade;
	exports.getEndOfDecade = getEndOfDecade;
	exports.getDecadeRange = getDecadeRange;
	exports.getBeginOfPreviousDecade = getBeginOfPreviousDecade;
	exports.getEndOfPreviousDecade = getEndOfPreviousDecade;
	exports.getBeginOfNextDecade = getBeginOfNextDecade;
	exports.getBeginOfYear = getBeginOfYear;
	exports.getEndOfYear = getEndOfYear;
	exports.getYearRange = getYearRange;
	exports.getBeginOfPreviousYear = getBeginOfPreviousYear;
	exports.getEndOfPreviousYear = getEndOfPreviousYear;
	exports.getBeginOfNextYear = getBeginOfNextYear;
	exports.getBeginOfMonth = getBeginOfMonth;
	exports.getEndOfMonth = getEndOfMonth;
	exports.getBeginOfWeek = getBeginOfWeek;
	exports.getMonthRange = getMonthRange;
	exports.getBeginOfPreviousMonth = getBeginOfPreviousMonth;
	exports.getEndOfPreviousMonth = getEndOfPreviousMonth;
	exports.getBeginOfNextMonth = getBeginOfNextMonth;
	exports.getBeginOfDay = getBeginOfDay;
	exports.getEndOfDay = getEndOfDay;
	exports.getDayRange = getDayRange;
	exports.getWeekNumber = getWeekNumber;
	exports.getBegin = getBegin;
	exports.getBeginPrevious = getBeginPrevious;
	exports.getBeginNext = getBeginNext;
	exports.getEnd = getEnd;
	exports.getEndPrevious = getEndPrevious;
	exports.getRange = getRange;
	exports.getValueRange = getValueRange;
	exports.getDaysInMonth = getDaysInMonth;
	exports.getCenturyLabel = getCenturyLabel;
	exports.getDecadeLabel = getDecadeLabel;
	exports.isWeekend = isWeekend;
	exports.getISOLocalMonth = getISOLocalMonth;
	exports.getISOLocalDate = getISOLocalDate;
	exports.getEndPrevious2 = exports.getBeginNext2 = exports.getBeginPrevious2 = void 0;
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var _map = _toConsumableArray(Array(7)).map(function (el, index) {
	  return index;
	}),
	    _map2 = _slicedToArray(_map, 7),
	    // eslint-disable-next-line no-unused-vars
	SUNDAY = _map2[0],
	    MONDAY = _map2[1],
	    TUESDAY = _map2[2],
	    WEDNESDAY = _map2[3],
	    THURSDAY = _map2[4],
	    FRIDAY = _map2[5],
	    SATURDAY = _map2[6];
	/* Simple getters - getting a property of a given point in time */
	
	
	function getYear(date) {
	  if (date instanceof Date) {
	    return date.getFullYear();
	  }
	
	  if (typeof date === 'number') {
	    return date;
	  }
	
	  var year = parseInt(date, 10);
	
	  if (typeof date === 'string' && !isNaN(year)) {
	    return year;
	  }
	
	  throw new Error("Failed to get year from date: ".concat(date, "."));
	}
	
	function getMonth(date) {
	  return date.getMonth() + 1;
	}
	
	function getMonthIndex(date) {
	  return date.getMonth();
	}
	
	function getDay(date) {
	  return date.getDate();
	}
	
	function getDayOfWeek(date) {
	  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
	  var weekday = date.getDay();
	
	  switch (calendarType) {
	    case 'ISO 8601':
	      // Shifts days of the week so that Monday is 0, Sunday is 6
	      return (weekday + 6) % 7;
	
	    case 'Arabic':
	      return (weekday + 1) % 7;
	
	    case 'Hebrew':
	    case 'US':
	      return weekday;
	
	    default:
	      throw new Error('Unsupported calendar type.');
	  }
	}
	/* Complex getters - getting a property somehow related to a given point in time */
	
	
	function getBeginOfCenturyYear(date) {
	  var year = getYear(date) - 1;
	  return year + -year % 100 + 1;
	}
	
	function getBeginOfCentury(date) {
	  var beginOfCenturyYear = getBeginOfCenturyYear(date);
	  return new Date(beginOfCenturyYear, 0, 1);
	}
	
	function getEndOfCentury(date) {
	  var beginOfCenturyYear = getBeginOfCenturyYear(date);
	  return new Date(beginOfCenturyYear + 100, 0, 1, 0, 0, 0, -1);
	}
	
	function getCenturyRange(date) {
	  return [getBeginOfCentury(date), getEndOfCentury(date)];
	}
	
	function getBeginOfPreviousCentury(date) {
	  var previousCenturyYear = getYear(date) - 100;
	  return getBeginOfCentury(previousCenturyYear);
	}
	
	function getEndOfPreviousCentury(date) {
	  var previousCenturyYear = getYear(date) - 100;
	  return getEndOfCentury(previousCenturyYear);
	}
	
	function getBeginOfNextCentury(date) {
	  var nextCenturyYear = getYear(date) + 100;
	  return getBeginOfCentury(nextCenturyYear);
	}
	
	function getBeginOfDecadeYear(date) {
	  var year = getYear(date) - 1;
	  return year + -year % 10 + 1;
	}
	
	function getBeginOfDecade(date) {
	  var beginOfDecadeYear = getBeginOfDecadeYear(date);
	  return new Date(beginOfDecadeYear, 0, 1);
	}
	
	function getEndOfDecade(date) {
	  var beginOfDecadeYear = getBeginOfDecadeYear(date);
	  return new Date(beginOfDecadeYear + 10, 0, 1, 0, 0, 0, -1);
	}
	
	function getDecadeRange(date) {
	  return [getBeginOfDecade(date), getEndOfDecade(date)];
	}
	
	function getBeginOfPreviousDecade(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	  var previousDecadeYear = getBeginOfDecadeYear(date) - offset;
	  return getBeginOfDecade(previousDecadeYear);
	}
	
	function getEndOfPreviousDecade(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	  var previousDecadeYear = getBeginOfDecadeYear(date) - offset;
	  return getEndOfDecade(previousDecadeYear);
	}
	
	function getBeginOfNextDecade(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	  var nextDecadeYear = getBeginOfDecadeYear(date) + offset;
	  return getBeginOfDecade(nextDecadeYear);
	}
	/**
	 * Returns the beginning of a given year.
	 *
	 * @param {Date} date Date.
	 */
	
	
	function getBeginOfYear(date) {
	  var year = getYear(date);
	  return new Date(year, 0, 1);
	}
	/**
	 * Returns the end of a given year.
	 *
	 * @param {Date} date Date.
	 */
	
	
	function getEndOfYear(date) {
	  var year = getYear(date);
	  return new Date(year + 1, 0, 1, 0, 0, 0, -1);
	}
	/**
	 * Returns an array with the beginning and the end of a given year.
	 *
	 * @param {Date} date Date.
	 */
	
	
	function getYearRange(date) {
	  return [getBeginOfYear(date), getEndOfYear(date)];
	}
	
	function getBeginOfPreviousYear(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var previousYear = getYear(date) - offset;
	  return getBeginOfYear(previousYear);
	}
	
	function getEndOfPreviousYear(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var previousYear = getYear(date) - offset;
	  return getEndOfYear(previousYear);
	}
	
	function getBeginOfNextYear(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var nextYear = getYear(date) + offset;
	  return getBeginOfYear(nextYear);
	}
	/**
	 * Returns the beginning of a given month.
	 *
	 * @param {Date} date Date.
	 */
	
	
	function getBeginOfMonth(date) {
	  var year = getYear(date);
	  var monthIndex = getMonthIndex(date);
	  return new Date(year, monthIndex, 1);
	}
	/**
	 * Returns the end of a given month.
	 *
	 * @param {Date} date Date.
	 */
	
	
	function getEndOfMonth(date) {
	  var year = getYear(date);
	  var monthIndex = getMonthIndex(date);
	  return new Date(year, monthIndex + 1, 1, 0, 0, 0, -1);
	}
	/**
	 * Returns the beginning of a given week.
	 *
	 * @param {Date} date Date.
	 * @param {String} calendarType Calendar type. Can be ISO 8601 or US.
	 */
	
	
	function getBeginOfWeek(date) {
	  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
	  var year = getYear(date);
	  var monthIndex = getMonthIndex(date);
	  var day = date.getDate() - getDayOfWeek(date, calendarType);
	  return new Date(year, monthIndex, day);
	}
	/**
	 * Returns an array with the beginning and the end of a given month.
	 *
	 * @param {Date} date Date.
	 */
	
	
	function getMonthRange(date) {
	  return [getBeginOfMonth(date), getEndOfMonth(date)];
	}
	
	function getDifferentMonth(date, offset) {
	  var year = getYear(date);
	  var previousMonthIndex = getMonthIndex(date) + offset;
	  return new Date(year, previousMonthIndex, 1);
	}
	
	function getBeginOfPreviousMonth(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var previousMonth = getDifferentMonth(date, -offset);
	  return getBeginOfMonth(previousMonth);
	}
	
	function getEndOfPreviousMonth(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var previousMonth = getDifferentMonth(date, -offset);
	  return getEndOfMonth(previousMonth);
	}
	
	function getBeginOfNextMonth(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var nextMonth = getDifferentMonth(date, offset);
	  return getBeginOfMonth(nextMonth);
	}
	
	function getBeginOfDay(date) {
	  var year = getYear(date);
	  var monthIndex = getMonthIndex(date);
	  var day = getDay(date);
	  return new Date(year, monthIndex, day);
	}
	
	function getEndOfDay(date) {
	  var year = getYear(date);
	  var monthIndex = getMonthIndex(date);
	  var day = getDay(date);
	  return new Date(year, monthIndex, day + 1, 0, 0, 0, -1);
	}
	/**
	 * Returns an array with the beginning and the end of a given day.
	 *
	 * @param {Date} date Date.
	 */
	
	
	function getDayRange(date) {
	  return [getBeginOfDay(date), getEndOfDay(date)];
	}
	/**
	 * Gets week number according to ISO 8601 or US standard.
	 * In ISO 8601, Arabic and Hebrew week 1 is the one with January 4.
	 * In US calendar week 1 is the one with January 1.
	 *
	 * @param {Date} date Date.
	 * @param {String} calendarType Calendar type. Can be ISO 8601 or US.
	 */
	
	
	function getWeekNumber(date) {
	  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
	  var calendarTypeForWeekNumber = calendarType === 'US' ? 'US' : 'ISO 8601';
	  var beginOfWeek = getBeginOfWeek(date, calendarTypeForWeekNumber);
	  var year = getYear(date) + 1;
	  var dayInWeekOne;
	  var beginOfFirstWeek; // Look for the first week one that does not come after a given date
	
	  do {
	    dayInWeekOne = new Date(year, 0, calendarTypeForWeekNumber === 'ISO 8601' ? 4 : 1);
	    beginOfFirstWeek = getBeginOfWeek(dayInWeekOne, calendarTypeForWeekNumber);
	    year -= 1;
	  } while (date - beginOfFirstWeek < 0);
	
	  return Math.round((beginOfWeek - beginOfFirstWeek) / (8.64e7 * 7)) + 1;
	}
	/**
	 * Returns the beginning of a given range.
	 *
	 * @param {String} rangeType Range type (e.g. 'day')
	 * @param {Date} date Date.
	 */
	
	
	function getBegin(rangeType, date) {
	  switch (rangeType) {
	    case 'century':
	      return getBeginOfCentury(date);
	
	    case 'decade':
	      return getBeginOfDecade(date);
	
	    case 'year':
	      return getBeginOfYear(date);
	
	    case 'month':
	      return getBeginOfMonth(date);
	
	    case 'day':
	      return getBeginOfDay(date);
	
	    default:
	      throw new Error("Invalid rangeType: ".concat(rangeType));
	  }
	}
	
	function getBeginPrevious(rangeType, date) {
	  switch (rangeType) {
	    case 'century':
	      return getBeginOfPreviousCentury(date);
	
	    case 'decade':
	      return getBeginOfPreviousDecade(date);
	
	    case 'year':
	      return getBeginOfPreviousYear(date);
	
	    case 'month':
	      return getBeginOfPreviousMonth(date);
	
	    default:
	      throw new Error("Invalid rangeType: ".concat(rangeType));
	  }
	}
	
	function getBeginNext(rangeType, date) {
	  switch (rangeType) {
	    case 'century':
	      return getBeginOfNextCentury(date);
	
	    case 'decade':
	      return getBeginOfNextDecade(date);
	
	    case 'year':
	      return getBeginOfNextYear(date);
	
	    case 'month':
	      return getBeginOfNextMonth(date);
	
	    default:
	      throw new Error("Invalid rangeType: ".concat(rangeType));
	  }
	}
	
	var getBeginPrevious2 = function getBeginPrevious2(rangeType, date) {
	  switch (rangeType) {
	    case 'decade':
	      return getBeginOfPreviousDecade(date, 100);
	
	    case 'year':
	      return getBeginOfPreviousYear(date, 10);
	
	    case 'month':
	      return getBeginOfPreviousMonth(date, 12);
	
	    default:
	      throw new Error("Invalid rangeType: ".concat(rangeType));
	  }
	};
	
	exports.getBeginPrevious2 = getBeginPrevious2;
	
	var getBeginNext2 = function getBeginNext2(rangeType, date) {
	  switch (rangeType) {
	    case 'decade':
	      return getBeginOfNextDecade(date, 100);
	
	    case 'year':
	      return getBeginOfNextYear(date, 10);
	
	    case 'month':
	      return getBeginOfNextMonth(date, 12);
	
	    default:
	      throw new Error("Invalid rangeType: ".concat(rangeType));
	  }
	};
	/**
	 * Returns the end of a given range.
	 *
	 * @param {String} rangeType Range type (e.g. 'day')
	 * @param {Date} date Date.
	 */
	
	
	exports.getBeginNext2 = getBeginNext2;
	
	function getEnd(rangeType, date) {
	  switch (rangeType) {
	    case 'century':
	      return getEndOfCentury(date);
	
	    case 'decade':
	      return getEndOfDecade(date);
	
	    case 'year':
	      return getEndOfYear(date);
	
	    case 'month':
	      return getEndOfMonth(date);
	
	    case 'day':
	      return getEndOfDay(date);
	
	    default:
	      throw new Error("Invalid rangeType: ".concat(rangeType));
	  }
	}
	
	function getEndPrevious(rangeType, date) {
	  switch (rangeType) {
	    case 'century':
	      return getEndOfPreviousCentury(date);
	
	    case 'decade':
	      return getEndOfPreviousDecade(date);
	
	    case 'year':
	      return getEndOfPreviousYear(date);
	
	    case 'month':
	      return getEndOfPreviousMonth(date);
	
	    default:
	      throw new Error("Invalid rangeType: ".concat(rangeType));
	  }
	}
	
	var getEndPrevious2 = function getEndPrevious2(rangeType, date) {
	  switch (rangeType) {
	    case 'decade':
	      return getEndOfPreviousDecade(date, 100);
	
	    case 'year':
	      return getEndOfPreviousYear(date, 10);
	
	    case 'month':
	      return getEndOfPreviousMonth(date, 12);
	
	    default:
	      throw new Error("Invalid rangeType: ".concat(rangeType));
	  }
	};
	/**
	 * Returns an array with the beginning and the end of a given range.
	 *
	 * @param {String} rangeType Range type (e.g. 'day')
	 * @param {Date} date Date.
	 */
	
	
	exports.getEndPrevious2 = getEndPrevious2;
	
	function getRange(rangeType, date) {
	  switch (rangeType) {
	    case 'century':
	      return getCenturyRange(date);
	
	    case 'decade':
	      return getDecadeRange(date);
	
	    case 'year':
	      return getYearRange(date);
	
	    case 'month':
	      return getMonthRange(date);
	
	    case 'day':
	      return getDayRange(date);
	
	    default:
	      throw new Error("Invalid rangeType: ".concat(rangeType));
	  }
	}
	/**
	 * Creates a range out of two values, ensuring they are in order and covering entire period ranges.
	 *
	 * @param {String} rangeType Range type (e.g. 'day')
	 * @param {Date} date1 First date.
	 * @param {Date} date2 Second date.
	 */
	
	
	function getValueRange(rangeType, date1, date2) {
	  var rawNextValue = [date1, date2].sort(function (a, b) {
	    return a - b;
	  });
	  return [getBegin(rangeType, rawNextValue[0]), getEnd(rangeType, rawNextValue[1])];
	}
	/**
	 * Returns a number of days in a month of a given date.
	 *
	 * @param {Date} date Date.
	 */
	
	
	function getDaysInMonth(date) {
	  var year = getYear(date);
	  var monthIndex = getMonthIndex(date);
	  return new Date(year, monthIndex + 1, 0).getDate();
	}
	
	function toYearLabel(_ref) {
	  var _ref2 = _slicedToArray(_ref, 2),
	      start = _ref2[0],
	      end = _ref2[1];
	
	  return "".concat(getYear(start), " \u2013 ").concat(getYear(end));
	}
	/**
	 * Returns a string labelling a century of a given date.
	 * For example, for 2017 it will return 2001-2100.
	 *
	 * @param {Date|String|Number} date Date or a year as a string or as a number.
	 */
	
	
	function getCenturyLabel(date) {
	  return toYearLabel(getCenturyRange(date));
	}
	/**
	 * Returns a string labelling a century of a given date.
	 * For example, for 2017 it will return 2011-2020.
	 *
	 * @param {Date|String|Number} date Date or a year as a string or as a number.
	 */
	
	
	function getDecadeLabel(date) {
	  return toYearLabel(getDecadeRange(date));
	}
	/**
	 * Returns a boolean determining whether a given date is on Saturday or Sunday.
	 *
	 * @param {Date} date Date.
	 */
	
	
	function isWeekend(date) {
	  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
	  var weekday = date.getDay();
	
	  switch (calendarType) {
	    case 'Arabic':
	    case 'Hebrew':
	      return weekday === FRIDAY || weekday === SATURDAY;
	
	    case 'ISO 8601':
	    case 'US':
	      return weekday === SATURDAY || weekday === SUNDAY;
	
	    default:
	      throw new Error('Unsupported calendar type.');
	  }
	}
	/**
	 * Returns local month in ISO-like format (YYYY-MM).
	 */
	
	
	function getISOLocalMonth(value) {
	  if (!value) {
	    return value;
	  }
	
	  var date = new Date(value);
	
	  if (isNaN(date.getTime())) {
	    throw new Error("Invalid date: ".concat(value));
	  }
	
	  var year = getYear(date);
	  var month = "0".concat(getMonth(date)).slice(-2);
	  return "".concat(year, "-").concat(month);
	}
	/**
	 * Returns local date in ISO-like format (YYYY-MM-DD).
	 */
	
	
	function getISOLocalDate(value) {
	  if (!value) {
	    return value;
	  }
	
	  var date = new Date(value);
	
	  if (isNaN(date.getTime())) {
	    throw new Error("Invalid date: ".concat(value));
	  }
	
	  var year = getYear(date);
	  var month = "0".concat(getMonth(date)).slice(-2);
	  var day = "0".concat(getDay(date)).slice(-2);
	  return "".concat(year, "-").concat(month, "-").concat(day);
	}

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(201);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is a Buffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Buffer, otherwise false
	 */
	function isBuffer(val) {
	  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
	    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a plain Object
	 *
	 * @param {Object} val The value to test
	 * @return {boolean} True if value is a plain Object, otherwise false
	 */
	function isPlainObject(val) {
	  if (toString.call(val) !== '[object Object]') {
	    return false;
	  }
	
	  var prototype = Object.getPrototypeOf(val);
	  return prototype === null || prototype === Object.prototype;
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 * nativescript
	 *  navigator.product -> 'NativeScript' or 'NS'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
	                                           navigator.product === 'NativeScript' ||
	                                           navigator.product === 'NS')) {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (isPlainObject(result[key]) && isPlainObject(val)) {
	      result[key] = merge(result[key], val);
	    } else if (isPlainObject(val)) {
	      result[key] = merge({}, val);
	    } else if (isArray(val)) {
	      result[key] = val.slice();
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	/**
	 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
	 *
	 * @param {string} content with BOM
	 * @return {string} content value without BOM
	 */
	function stripBOM(content) {
	  if (content.charCodeAt(0) === 0xFEFF) {
	    content = content.slice(1);
	  }
	  return content;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isPlainObject: isPlainObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim,
	  stripBOM: stripBOM
	};


/***/ },
/* 29 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	
	     chilliz: "6C9AEE37-BC05-4FB8-A351-D51458B83F26",
	     leanbento: "F77D467A-F552-4BB3-ABBF-C491DB6661A0",
	     demo: "500B0232-1BEB-4A9A-92C4-F466638AE496",
	     vantase: "8F8FE4E6-88C9-4071-9215-312E0F50016A",
	     bushido: "AD8BDEE2-92AA-461A-AEAF-47E921C99235",
	     workspace: "56E9AF98-4562-4AB8-95D8-3BDB4423A9E4",
	     zazzpizza: "DDAA254C-BD1E-49F0-AD1E-164A140421D3"
	
	};

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.4';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
	      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, customDefaultsAssignIn);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(128)(module)))

/***/ },
/* 31 */
/***/ function(module, exports) {

	/**
	* strp
	*
	* Copyright (c) 2013 Insanehong
	*
	* Contributors
	*
	* Licensed under the MIT license.
	* https://github.com/insanehong/strp/blob/master/LICENSE
	*/
	
	var strp = module.exports = {};
	
	var reverse = strp.reverse = function(str) {
		return str.split("").reverse().join("");
	};
	
	var ltrim = strp.ltrim = function(str) {
		return str.replace(/^\s+/,"");
	};
	
	var rtrim = strp.rtrim = function(str) {
		return str.replace(/\s+$/,"");
	};
	
	var trim = strp.trim = function(str) {
		return str.replace(/^\s+|\s+$/g,"");
	};
	
	var join = strp.join = function() {
		var args = Array.prototype.slice.apply( arguments);
		return args.join("");
	};
	
	var joins = strp.joins = function() {
		var args = Array.prototype.slice.apply(arguments);
		return args.join(" ");
	};
	
	var joinln = strp.joinln = function() {
		var args = Array.prototype.slice.apply(arguments);
		return args.join("\n");
	};
	
	var lpad = strp.lpad = function(str,maxlength,padstr) {
		var i = 0,
				s = str;
	
		if( str.length < maxlength) for ( ; i < (maxlength - str.length) ; i++ ) s = padstr.charAt(0).concat(s);
			
		return s;
	};
	
	var rpad = strp.rpad = function(str,maxlength,padstr) {
		var i = 0,		
				s = str;
	
		if( str.length < maxlength) for ( ; i < (maxlength - str.length) ; i++ ) s  = s.concat(padstr.charAt(0));
	
		return s;
	};
	
	var lcfirst = strp.lcfirst = function(str) {
		var s = str,
		first = s.charAt(0).toLowerCase();
	
		return first.concat(s.slice(1));
	};
	
	var ucfirst = strp.ucfirst = function(str) {
		var s = str,
		first = s.charAt(0).toUpperCase();
	
		return first.concat(s.slice(1));
	};
	
	var shuffle = strp.shuffle = function(str) {
		return str.split("").sort(function() { return 0.5 - Math.random();}).join("");
	};
	
	
	var stripslashes = strp.stripslashes = function(str) {
	  return str.replace(/\\(.?)/g, function (s,slashes) {
	    
	    switch (slashes) {
	    case '\\':
	      return '\\';
	    case '0':
	      return '\u0000';
	    case '':
	      return '';
	    default:
	      return slashes;
	    }
	  });
	};
	
	var number_format = strp.number_format = function(str) {
		if(isNaN(str)) return NaN;
		if (typeof str === 'number') str = str.toString();
		
		var numberData = str.split(".");
	  
	  return numberData[0].replace(/\B(?=(\d{3})+(?=$))/g, ",") + (numberData[1] ? "." + numberData[1] : ""); 
	};
	
	
	
	


/***/ },
/* 32 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 34 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16),
	    _assign = __webpack_require__(18);
	
	var CallbackQueue = __webpack_require__(412);
	var PooledClass = __webpack_require__(59);
	var ReactFeatureFlags = __webpack_require__(420);
	var ReactReconciler = __webpack_require__(60);
	var Transaction = __webpack_require__(122);
	
	var invariant = __webpack_require__(6);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 36 */
[1039, 55, 112],
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var PooledClass = __webpack_require__(59);
	
	var emptyFunction = __webpack_require__(34);
	var warning = __webpack_require__(14);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 38 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 39 */
/***/ function(module, exports) {

	/*
	 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
	 *
	 *  Use of this source code is governed by a BSD-style license
	 *  that can be found in the LICENSE file in the root of the source
	 *  tree.
	 */
	/* eslint-env node */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.extractVersion = extractVersion;
	exports.wrapPeerConnectionEvent = wrapPeerConnectionEvent;
	exports.disableLog = disableLog;
	exports.disableWarnings = disableWarnings;
	exports.log = log;
	exports.deprecated = deprecated;
	exports.detectBrowser = detectBrowser;
	exports.compactObject = compactObject;
	exports.walkStats = walkStats;
	exports.filterStats = filterStats;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var logDisabled_ = true;
	var deprecationWarnings_ = true;
	
	/**
	 * Extract browser version out of the provided user agent string.
	 *
	 * @param {!string} uastring userAgent string.
	 * @param {!string} expr Regular expression used as match criteria.
	 * @param {!number} pos position in the version string to be returned.
	 * @return {!number} browser version.
	 */
	function extractVersion(uastring, expr, pos) {
	  var match = uastring.match(expr);
	  return match && match.length >= pos && parseInt(match[pos], 10);
	}
	
	// Wraps the peerconnection event eventNameToWrap in a function
	// which returns the modified event object (or false to prevent
	// the event).
	function wrapPeerConnectionEvent(window, eventNameToWrap, wrapper) {
	  if (!window.RTCPeerConnection) {
	    return;
	  }
	  var proto = window.RTCPeerConnection.prototype;
	  var nativeAddEventListener = proto.addEventListener;
	  proto.addEventListener = function (nativeEventName, cb) {
	    if (nativeEventName !== eventNameToWrap) {
	      return nativeAddEventListener.apply(this, arguments);
	    }
	    var wrappedCallback = function wrappedCallback(e) {
	      var modifiedEvent = wrapper(e);
	      if (modifiedEvent) {
	        if (cb.handleEvent) {
	          cb.handleEvent(modifiedEvent);
	        } else {
	          cb(modifiedEvent);
	        }
	      }
	    };
	    this._eventMap = this._eventMap || {};
	    if (!this._eventMap[eventNameToWrap]) {
	      this._eventMap[eventNameToWrap] = new Map();
	    }
	    this._eventMap[eventNameToWrap].set(cb, wrappedCallback);
	    return nativeAddEventListener.apply(this, [nativeEventName, wrappedCallback]);
	  };
	
	  var nativeRemoveEventListener = proto.removeEventListener;
	  proto.removeEventListener = function (nativeEventName, cb) {
	    if (nativeEventName !== eventNameToWrap || !this._eventMap || !this._eventMap[eventNameToWrap]) {
	      return nativeRemoveEventListener.apply(this, arguments);
	    }
	    if (!this._eventMap[eventNameToWrap].has(cb)) {
	      return nativeRemoveEventListener.apply(this, arguments);
	    }
	    var unwrappedCb = this._eventMap[eventNameToWrap].get(cb);
	    this._eventMap[eventNameToWrap].delete(cb);
	    if (this._eventMap[eventNameToWrap].size === 0) {
	      delete this._eventMap[eventNameToWrap];
	    }
	    if (Object.keys(this._eventMap).length === 0) {
	      delete this._eventMap;
	    }
	    return nativeRemoveEventListener.apply(this, [nativeEventName, unwrappedCb]);
	  };
	
	  Object.defineProperty(proto, 'on' + eventNameToWrap, {
	    get: function get() {
	      return this['_on' + eventNameToWrap];
	    },
	    set: function set(cb) {
	      if (this['_on' + eventNameToWrap]) {
	        this.removeEventListener(eventNameToWrap, this['_on' + eventNameToWrap]);
	        delete this['_on' + eventNameToWrap];
	      }
	      if (cb) {
	        this.addEventListener(eventNameToWrap, this['_on' + eventNameToWrap] = cb);
	      }
	    },
	
	    enumerable: true,
	    configurable: true
	  });
	}
	
	function disableLog(bool) {
	  if (typeof bool !== 'boolean') {
	    return new Error('Argument type: ' + (typeof bool === 'undefined' ? 'undefined' : _typeof(bool)) + '. Please use a boolean.');
	  }
	  logDisabled_ = bool;
	  return bool ? 'adapter.js logging disabled' : 'adapter.js logging enabled';
	}
	
	/**
	 * Disable or enable deprecation warnings
	 * @param {!boolean} bool set to true to disable warnings.
	 */
	function disableWarnings(bool) {
	  if (typeof bool !== 'boolean') {
	    return new Error('Argument type: ' + (typeof bool === 'undefined' ? 'undefined' : _typeof(bool)) + '. Please use a boolean.');
	  }
	  deprecationWarnings_ = !bool;
	  return 'adapter.js deprecation warnings ' + (bool ? 'disabled' : 'enabled');
	}
	
	function log() {
	  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object') {
	    if (logDisabled_) {
	      return;
	    }
	    if (typeof console !== 'undefined' && typeof console.log === 'function') {
	      console.log.apply(console, arguments);
	    }
	  }
	}
	
	/**
	 * Shows a deprecation warning suggesting the modern and spec-compatible API.
	 */
	function deprecated(oldMethod, newMethod) {
	  if (!deprecationWarnings_) {
	    return;
	  }
	  console.warn(oldMethod + ' is deprecated, please use ' + newMethod + ' instead.');
	}
	
	/**
	 * Browser detector.
	 *
	 * @return {object} result containing browser and version
	 *     properties.
	 */
	function detectBrowser(window) {
	  // Returned result object.
	  var result = { browser: null, version: null };
	
	  // Fail early if it's not a browser
	  if (typeof window === 'undefined' || !window.navigator) {
	    result.browser = 'Not a browser.';
	    return result;
	  }
	
	  var navigator = window.navigator;
	
	
	  if (navigator.mozGetUserMedia) {
	    // Firefox.
	    result.browser = 'firefox';
	    result.version = extractVersion(navigator.userAgent, /Firefox\/(\d+)\./, 1);
	  } else if (navigator.webkitGetUserMedia || window.isSecureContext === false && window.webkitRTCPeerConnection && !window.RTCIceGatherer) {
	    // Chrome, Chromium, Webview, Opera.
	    // Version matches Chrome/WebRTC version.
	    // Chrome 74 removed webkitGetUserMedia on http as well so we need the
	    // more complicated fallback to webkitRTCPeerConnection.
	    result.browser = 'chrome';
	    result.version = extractVersion(navigator.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);
	  } else if (navigator.mediaDevices && navigator.userAgent.match(/Edge\/(\d+).(\d+)$/)) {
	    // Edge.
	    result.browser = 'edge';
	    result.version = extractVersion(navigator.userAgent, /Edge\/(\d+).(\d+)$/, 2);
	  } else if (window.RTCPeerConnection && navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) {
	    // Safari.
	    result.browser = 'safari';
	    result.version = extractVersion(navigator.userAgent, /AppleWebKit\/(\d+)\./, 1);
	    result.supportsUnifiedPlan = window.RTCRtpTransceiver && 'currentDirection' in window.RTCRtpTransceiver.prototype;
	  } else {
	    // Default fallthrough: not supported.
	    result.browser = 'Not a supported browser.';
	    return result;
	  }
	
	  return result;
	}
	
	/**
	 * Checks if something is an object.
	 *
	 * @param {*} val The something you want to check.
	 * @return true if val is an object, false otherwise.
	 */
	function isObject(val) {
	  return Object.prototype.toString.call(val) === '[object Object]';
	}
	
	/**
	 * Remove all empty objects and undefined values
	 * from a nested object -- an enhanced and vanilla version
	 * of Lodash's `compact`.
	 */
	function compactObject(data) {
	  if (!isObject(data)) {
	    return data;
	  }
	
	  return Object.keys(data).reduce(function (accumulator, key) {
	    var isObj = isObject(data[key]);
	    var value = isObj ? compactObject(data[key]) : data[key];
	    var isEmptyObject = isObj && !Object.keys(value).length;
	    if (value === undefined || isEmptyObject) {
	      return accumulator;
	    }
	    return Object.assign(accumulator, _defineProperty({}, key, value));
	  }, {});
	}
	
	/* iterates the stats graph recursively. */
	function walkStats(stats, base, resultSet) {
	  if (!base || resultSet.has(base.id)) {
	    return;
	  }
	  resultSet.set(base.id, base);
	  Object.keys(base).forEach(function (name) {
	    if (name.endsWith('Id')) {
	      walkStats(stats, stats.get(base[name]), resultSet);
	    } else if (name.endsWith('Ids')) {
	      base[name].forEach(function (id) {
	        walkStats(stats, stats.get(id), resultSet);
	      });
	    }
	  });
	}
	
	/* filter getStats for a sender/receiver track. */
	function filterStats(result, track, outbound) {
	  var streamStatsType = outbound ? 'outbound-rtp' : 'inbound-rtp';
	  var filteredResult = new Map();
	  if (track === null) {
	    return filteredResult;
	  }
	  var trackStats = [];
	  result.forEach(function (value) {
	    if (value.type === 'track' && value.trackIdentifier === track.id) {
	      trackStats.push(value);
	    }
	  });
	  trackStats.forEach(function (trackStat) {
	    result.forEach(function (stats) {
	      if (stats.type === streamStatsType && stats.trackId === trackStat.id) {
	        walkStats(result, stats, filteredResult);
	      }
	    });
	  });
	  return filteredResult;
	}


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(66)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 41 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * Date Format 1.2.3
	 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
	 * MIT license
	 *
	 * Includes enhancements by Scott Trenda <scott.trenda.net>
	 * and Kris Kowal <cixar.com/~kris.kowal/>
	 *
	 * Accepts a date, a mask, or a date and a mask.
	 * Returns a formatted version of the given date.
	 * The date defaults to the current date/time.
	 * The mask defaults to dateFormat.masks.default.
	 */
	
	(function(global) {
	  'use strict';
	
	  var dateFormat = (function() {
	      var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZWN]|"[^"]*"|'[^']*'/g;
	      var timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
	      var timezoneClip = /[^-+\dA-Z]/g;
	  
	      // Regexes and supporting functions are cached through closure
	      return function (date, mask, utc, gmt) {
	  
	        // You can't provide utc if you skip other args (use the 'UTC:' mask prefix)
	        if (arguments.length === 1 && kindOf(date) === 'string' && !/\d/.test(date)) {
	          mask = date;
	          date = undefined;
	        }
	  
	        date = date || new Date;
	  
	        if(!(date instanceof Date)) {
	          date = new Date(date);
	        }
	  
	        if (isNaN(date)) {
	          throw TypeError('Invalid date');
	        }
	  
	        mask = String(dateFormat.masks[mask] || mask || dateFormat.masks['default']);
	  
	        // Allow setting the utc/gmt argument via the mask
	        var maskSlice = mask.slice(0, 4);
	        if (maskSlice === 'UTC:' || maskSlice === 'GMT:') {
	          mask = mask.slice(4);
	          utc = true;
	          if (maskSlice === 'GMT:') {
	            gmt = true;
	          }
	        }
	  
	        var _ = utc ? 'getUTC' : 'get';
	        var d = date[_ + 'Date']();
	        var D = date[_ + 'Day']();
	        var m = date[_ + 'Month']();
	        var y = date[_ + 'FullYear']();
	        var H = date[_ + 'Hours']();
	        var M = date[_ + 'Minutes']();
	        var s = date[_ + 'Seconds']();
	        var L = date[_ + 'Milliseconds']();
	        var o = utc ? 0 : date.getTimezoneOffset();
	        var W = getWeek(date);
	        var N = getDayOfWeek(date);
	        var flags = {
	          d:    d,
	          dd:   pad(d),
	          ddd:  dateFormat.i18n.dayNames[D],
	          dddd: dateFormat.i18n.dayNames[D + 7],
	          m:    m + 1,
	          mm:   pad(m + 1),
	          mmm:  dateFormat.i18n.monthNames[m],
	          mmmm: dateFormat.i18n.monthNames[m + 12],
	          yy:   String(y).slice(2),
	          yyyy: y,
	          h:    H % 12 || 12,
	          hh:   pad(H % 12 || 12),
	          H:    H,
	          HH:   pad(H),
	          M:    M,
	          MM:   pad(M),
	          s:    s,
	          ss:   pad(s),
	          l:    pad(L, 3),
	          L:    pad(Math.round(L / 10)),
	          t:    H < 12 ? dateFormat.i18n.timeNames[0] : dateFormat.i18n.timeNames[1],
	          tt:   H < 12 ? dateFormat.i18n.timeNames[2] : dateFormat.i18n.timeNames[3],
	          T:    H < 12 ? dateFormat.i18n.timeNames[4] : dateFormat.i18n.timeNames[5],
	          TT:   H < 12 ? dateFormat.i18n.timeNames[6] : dateFormat.i18n.timeNames[7],
	          Z:    gmt ? 'GMT' : utc ? 'UTC' : (String(date).match(timezone) || ['']).pop().replace(timezoneClip, ''),
	          o:    (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
	          S:    ['th', 'st', 'nd', 'rd'][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10],
	          W:    W,
	          N:    N
	        };
	  
	        return mask.replace(token, function (match) {
	          if (match in flags) {
	            return flags[match];
	          }
	          return match.slice(1, match.length - 1);
	        });
	      };
	    })();
	
	  dateFormat.masks = {
	    'default':               'ddd mmm dd yyyy HH:MM:ss',
	    'shortDate':             'm/d/yy',
	    'mediumDate':            'mmm d, yyyy',
	    'longDate':              'mmmm d, yyyy',
	    'fullDate':              'dddd, mmmm d, yyyy',
	    'shortTime':             'h:MM TT',
	    'mediumTime':            'h:MM:ss TT',
	    'longTime':              'h:MM:ss TT Z',
	    'isoDate':               'yyyy-mm-dd',
	    'isoTime':               'HH:MM:ss',
	    'isoDateTime':           'yyyy-mm-dd\'T\'HH:MM:sso',
	    'isoUtcDateTime':        'UTC:yyyy-mm-dd\'T\'HH:MM:ss\'Z\'',
	    'expiresHeaderFormat':   'ddd, dd mmm yyyy HH:MM:ss Z'
	  };
	
	  // Internationalization strings
	  dateFormat.i18n = {
	    dayNames: [
	      'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat',
	      'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
	    ],
	    monthNames: [
	      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
	      'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
	    ],
	    timeNames: [
	      'a', 'p', 'am', 'pm', 'A', 'P', 'AM', 'PM'
	    ]
	  };
	
	function pad(val, len) {
	  val = String(val);
	  len = len || 2;
	  while (val.length < len) {
	    val = '0' + val;
	  }
	  return val;
	}
	
	/**
	 * Get the ISO 8601 week number
	 * Based on comments from
	 * http://techblog.procurios.nl/k/n618/news/view/33796/14863/Calculate-ISO-8601-week-and-year-in-javascript.html
	 *
	 * @param  {Object} `date`
	 * @return {Number}
	 */
	function getWeek(date) {
	  // Remove time components of date
	  var targetThursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	
	  // Change date to Thursday same week
	  targetThursday.setDate(targetThursday.getDate() - ((targetThursday.getDay() + 6) % 7) + 3);
	
	  // Take January 4th as it is always in week 1 (see ISO 8601)
	  var firstThursday = new Date(targetThursday.getFullYear(), 0, 4);
	
	  // Change date to Thursday same week
	  firstThursday.setDate(firstThursday.getDate() - ((firstThursday.getDay() + 6) % 7) + 3);
	
	  // Check if daylight-saving-time-switch occurred and correct for it
	  var ds = targetThursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
	  targetThursday.setHours(targetThursday.getHours() - ds);
	
	  // Number of weeks between target Thursday and first Thursday
	  var weekDiff = (targetThursday - firstThursday) / (86400000*7);
	  return 1 + Math.floor(weekDiff);
	}
	
	/**
	 * Get ISO-8601 numeric representation of the day of the week
	 * 1 (for Monday) through 7 (for Sunday)
	 * 
	 * @param  {Object} `date`
	 * @return {Number}
	 */
	function getDayOfWeek(date) {
	  var dow = date.getDay();
	  if(dow === 0) {
	    dow = 7;
	  }
	  return dow;
	}
	
	/**
	 * kind-of shortcut
	 * @param  {*} val
	 * @return {String}
	 */
	function kindOf(val) {
	  if (val === null) {
	    return 'null';
	  }
	
	  if (val === undefined) {
	    return 'undefined';
	  }
	
	  if (typeof val !== 'object') {
	    return typeof val;
	  }
	
	  if (Array.isArray(val)) {
	    return 'array';
	  }
	
	  return {}.toString.call(val)
	    .slice(8, -1).toLowerCase();
	};
	
	
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return dateFormat;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = dateFormat;
	  } else {
	    global.dateFormat = dateFormat;
	  }
	})(this);


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ThemeProvider = __webpack_require__(728);
	
	Object.defineProperty(exports, 'ThemeProvider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ThemeProvider).default;
	  }
	});
	
	var _themr = __webpack_require__(729);
	
	Object.defineProperty(exports, 'themr', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_themr).default;
	  }
	});
	Object.defineProperty(exports, 'themeable', {
	  enumerable: true,
	  get: function get() {
	    return _themr.themeable;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 45 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reactRouter = __webpack_require__(9);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	
	
	var config = __webpack_require__(7);
	
	var APPID = config.ids.appId;
	var APIURL = config.path.apiUrl;
	var APIURLPRO = config.path.apiUrlPro;
	var qs = __webpack_require__(3);
	var HtmlToReactParser = __webpack_require__(21).Parser;
	var htmlToReactParser = new HtmlToReactParser();
	
	var Alert = React.createClass({
		displayName: 'Alert',
		getInitialState: function getInitialState() {
			return {
				successoff: null
			};
		},
	
		componentWillMount: function componentWillMount() {
	
			// cookie.remove('alertSuccess')
			//cookie.remove('alertError')
	
			setTimeout(function () {
				if (document.getElementById("AlertBox")) {
					document.getElementById("AlertBox").style.display = "none";
				}
				_reactCookie2.default.remove('alertSuccess');
				_reactCookie2.default.remove('alertError');
			}, 2000);
		},
		componentDidMount: function componentDidMount() {
			var _this = this;
	
			_axios2.default.get(APIURL + 'settings/checkPaymentStatus?app_id=' + APPID).then(function (res) {
				if (Object.values(res.data) == 'fail' && typeof Object.values(res.data) != 'undefined' && Object.values(res.data) != '') {
					_this.setState({ successoff: 1 });
				}
			});
		},
		loadofflinepopup: function loadofflinepopup() {
			if (this.state.successoff == 1) {
				return htmlToReactParser.parse('<div className="modal" style="display: block;z-index: 1000000;" id="offilepopoup"><div className="modal-dialog PopupWidth"><div className="modal-content"><div className="modal-body"><br /><img src="img/plug.png"	<br /><h2>Site Is Offline</h2><span>Please Contact the merchant to place order directly</span><br></div><div className="modal-footer"></div></div></div></div>');
			} else {
				return true;
			}
		},
		removeAlert: function removeAlert() {
			if (document.getElementById("AlertBox")) {
				document.getElementById("AlertBox").style.display = "none";
				_reactCookie2.default.remove('alertSuccess');
				_reactCookie2.default.remove('alertError');
			}
		},
		render: function render() {
	
			/* Success message */
			if (typeof _reactCookie2.default.load('alertSuccess') !== 'undefined' && _reactCookie2.default.load('alertSuccess') !== "") {
				return React.createElement(
					'div',
					{ className: 'alert-box', style: { display: 'block' }, id: 'AlertBox' },
					React.createElement(
						'p',
						{ className: 'success-msg alert-msg' },
						_reactCookie2.default.load('alertSuccess'),
						React.createElement(
							_reactRouter.Link,
							{ style: { cusror: 'pointer' }, onClick: this.removeAlert.bind(null, this), className: 'close-icon' },
							React.createElement('i', { className: 'fa fa-times-circle-o', 'aria-hidden': 'true' })
						)
					)
				);
	
				/* remove cookie valuese */
			} else if (typeof _reactCookie2.default.load('alertError') !== 'undefined' && _reactCookie2.default.load('alertError') !== "") {
				return React.createElement(
					'div',
					{ className: 'alert-box', style: { display: 'block' }, id: 'AlertBox' },
					React.createElement(
						'p',
						{ className: 'error-msg alert-msg' },
						_reactCookie2.default.load('alertError'),
						React.createElement(
							_reactRouter.Link,
							{ style: { cusror: 'pointer' }, onClick: this.removeAlert.bind(null, this), className: 'close-icon' },
							React.createElement('i', { className: 'fa fa-times-circle-o', 'aria-hidden': 'true' })
						)
					)
				);
			} else {
	
				return React.createElement(
					'div',
					null,
					this.loadofflinepopup(),
					' '
				);
			}
		}
	});
	
	module.exports = Alert;

/***/ },
/* 49 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(544);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(543);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(131);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(131);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(41);
	var core = __webpack_require__(32);
	var ctx = __webpack_require__(216);
	var hide = __webpack_require__(67);
	var has = __webpack_require__(53);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 53 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(90);
	var IE8_DOM_DEFINE = __webpack_require__(218);
	var toPrimitive = __webpack_require__(141);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(40) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 55 */
[1038, 112],
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var invariant = __webpack_require__(24);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var splice = Array.prototype.splice;
	var toString = Object.prototype.toString;
	function type(obj) {
	    return toString.call(obj).slice(8, -1);
	}
	var assign = Object.assign || /* istanbul ignore next */ (function (target, source) {
	    getAllKeys(source).forEach(function (key) {
	        if (hasOwnProperty.call(source, key)) {
	            target[key] = source[key];
	        }
	    });
	    return target;
	});
	var getAllKeys = typeof Object.getOwnPropertySymbols === 'function'
	    ? function (obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)); }
	    /* istanbul ignore next */
	    : function (obj) { return Object.keys(obj); };
	function copy(object) {
	    return Array.isArray(object)
	        ? assign(object.constructor(object.length), object)
	        : (type(object) === 'Map')
	            ? new Map(object)
	            : (type(object) === 'Set')
	                ? new Set(object)
	                : (object && typeof object === 'object')
	                    ? assign(Object.create(Object.getPrototypeOf(object)), object)
	                    /* istanbul ignore next */
	                    : object;
	}
	var Context = /** @class */ (function () {
	    function Context() {
	        this.commands = assign({}, defaultCommands);
	        this.update = this.update.bind(this);
	        // Deprecated: update.extend, update.isEquals and update.newContext
	        this.update.extend = this.extend = this.extend.bind(this);
	        this.update.isEquals = function (x, y) { return x === y; };
	        this.update.newContext = function () { return new Context().update; };
	    }
	    Object.defineProperty(Context.prototype, "isEquals", {
	        get: function () {
	            return this.update.isEquals;
	        },
	        set: function (value) {
	            this.update.isEquals = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Context.prototype.extend = function (directive, fn) {
	        this.commands[directive] = fn;
	    };
	    Context.prototype.update = function (object, $spec) {
	        var _this = this;
	        var spec = (typeof $spec === 'function') ? { $apply: $spec } : $spec;
	        if (!(Array.isArray(object) && Array.isArray(spec))) {
	            invariant(!Array.isArray(spec), 'update(): You provided an invalid spec to update(). The spec may ' +
	                'not contain an array except as the value of $set, $push, $unshift, ' +
	                '$splice or any custom command allowing an array value.');
	        }
	        invariant(typeof spec === 'object' && spec !== null, 'update(): You provided an invalid spec to update(). The spec and ' +
	            'every included key path must be plain objects containing one of the ' +
	            'following commands: %s.', Object.keys(this.commands).join(', '));
	        var nextObject = object;
	        getAllKeys(spec).forEach(function (key) {
	            if (hasOwnProperty.call(_this.commands, key)) {
	                var objectWasNextObject = object === nextObject;
	                nextObject = _this.commands[key](spec[key], nextObject, spec, object);
	                if (objectWasNextObject && _this.isEquals(nextObject, object)) {
	                    nextObject = object;
	                }
	            }
	            else {
	                var nextValueForKey = type(object) === 'Map'
	                    ? _this.update(object.get(key), spec[key])
	                    : _this.update(object[key], spec[key]);
	                var nextObjectValue = type(nextObject) === 'Map'
	                    ? nextObject.get(key)
	                    : nextObject[key];
	                if (!_this.isEquals(nextValueForKey, nextObjectValue)
	                    || typeof nextValueForKey === 'undefined'
	                        && !hasOwnProperty.call(object, key)) {
	                    if (nextObject === object) {
	                        nextObject = copy(object);
	                    }
	                    if (type(nextObject) === 'Map') {
	                        nextObject.set(key, nextValueForKey);
	                    }
	                    else {
	                        nextObject[key] = nextValueForKey;
	                    }
	                }
	            }
	        });
	        return nextObject;
	    };
	    return Context;
	}());
	exports.Context = Context;
	var defaultCommands = {
	    $push: function (value, nextObject, spec) {
	        invariantPushAndUnshift(nextObject, spec, '$push');
	        return value.length ? nextObject.concat(value) : nextObject;
	    },
	    $unshift: function (value, nextObject, spec) {
	        invariantPushAndUnshift(nextObject, spec, '$unshift');
	        return value.length ? value.concat(nextObject) : nextObject;
	    },
	    $splice: function (value, nextObject, spec, originalObject) {
	        invariantSplices(nextObject, spec);
	        value.forEach(function (args) {
	            invariantSplice(args);
	            if (nextObject === originalObject && args.length) {
	                nextObject = copy(originalObject);
	            }
	            splice.apply(nextObject, args);
	        });
	        return nextObject;
	    },
	    $set: function (value, _nextObject, spec) {
	        invariantSet(spec);
	        return value;
	    },
	    $toggle: function (targets, nextObject) {
	        invariantSpecArray(targets, '$toggle');
	        var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;
	        targets.forEach(function (target) {
	            nextObjectCopy[target] = !nextObject[target];
	        });
	        return nextObjectCopy;
	    },
	    $unset: function (value, nextObject, _spec, originalObject) {
	        invariantSpecArray(value, '$unset');
	        value.forEach(function (key) {
	            if (Object.hasOwnProperty.call(nextObject, key)) {
	                if (nextObject === originalObject) {
	                    nextObject = copy(originalObject);
	                }
	                delete nextObject[key];
	            }
	        });
	        return nextObject;
	    },
	    $add: function (values, nextObject, _spec, originalObject) {
	        invariantMapOrSet(nextObject, '$add');
	        invariantSpecArray(values, '$add');
	        if (type(nextObject) === 'Map') {
	            values.forEach(function (_a) {
	                var key = _a[0], value = _a[1];
	                if (nextObject === originalObject && nextObject.get(key) !== value) {
	                    nextObject = copy(originalObject);
	                }
	                nextObject.set(key, value);
	            });
	        }
	        else {
	            values.forEach(function (value) {
	                if (nextObject === originalObject && !nextObject.has(value)) {
	                    nextObject = copy(originalObject);
	                }
	                nextObject.add(value);
	            });
	        }
	        return nextObject;
	    },
	    $remove: function (value, nextObject, _spec, originalObject) {
	        invariantMapOrSet(nextObject, '$remove');
	        invariantSpecArray(value, '$remove');
	        value.forEach(function (key) {
	            if (nextObject === originalObject && nextObject.has(key)) {
	                nextObject = copy(originalObject);
	            }
	            nextObject.delete(key);
	        });
	        return nextObject;
	    },
	    $merge: function (value, nextObject, _spec, originalObject) {
	        invariantMerge(nextObject, value);
	        getAllKeys(value).forEach(function (key) {
	            if (value[key] !== nextObject[key]) {
	                if (nextObject === originalObject) {
	                    nextObject = copy(originalObject);
	                }
	                nextObject[key] = value[key];
	            }
	        });
	        return nextObject;
	    },
	    $apply: function (value, original) {
	        invariantApply(value);
	        return value(original);
	    },
	};
	var defaultContext = new Context();
	exports.isEquals = defaultContext.update.isEquals;
	exports.extend = defaultContext.extend;
	exports.default = defaultContext.update;
	// @ts-ignore
	exports.default.default = module.exports = assign(exports.default, exports);
	// invariants
	function invariantPushAndUnshift(value, spec, command) {
	    invariant(Array.isArray(value), 'update(): expected target of %s to be an array; got %s.', command, value);
	    invariantSpecArray(spec[command], command);
	}
	function invariantSpecArray(spec, command) {
	    invariant(Array.isArray(spec), 'update(): expected spec of %s to be an array; got %s. ' +
	        'Did you forget to wrap your parameter in an array?', command, spec);
	}
	function invariantSplices(value, spec) {
	    invariant(Array.isArray(value), 'Expected $splice target to be an array; got %s', value);
	    invariantSplice(spec.$splice);
	}
	function invariantSplice(value) {
	    invariant(Array.isArray(value), 'update(): expected spec of $splice to be an array of arrays; got %s. ' +
	        'Did you forget to wrap your parameters in an array?', value);
	}
	function invariantApply(fn) {
	    invariant(typeof fn === 'function', 'update(): expected spec of $apply to be a function; got %s.', fn);
	}
	function invariantSet(spec) {
	    invariant(Object.keys(spec).length === 1, 'Cannot have more than one key in an object with $set');
	}
	function invariantMerge(target, specValue) {
	    invariant(specValue && typeof specValue === 'object', 'update(): $merge expects a spec of type \'object\'; got %s', specValue);
	    invariant(target && typeof target === 'object', 'update(): $merge expects a target of type \'object\'; got %s', target);
	}
	function invariantMapOrSet(target, command) {
	    var typeOfTarget = type(target);
	    invariant(typeOfTarget === 'Map' || typeOfTarget === 'Set', 'update(): %s expects a target of type Set or Map; got %s', command, typeOfTarget);
	}


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(94);
	
	Object.defineProperty(exports, 'initValidation', {
	  enumerable: true,
	  get: function get() {
	    return _helpers.initValidation;
	  }
	});
	Object.defineProperty(exports, 'isFormValid', {
	  enumerable: true,
	  get: function get() {
	    return _helpers.isFormValid;
	  }
	});
	
	var _validated = __webpack_require__(744);
	
	Object.defineProperty(exports, 'validated', {
	  enumerable: true,
	  get: function get() {
	    return _validated.validated;
	  }
	});

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "isMaxDate", {
	  enumerable: true,
	  get: function get() {
	    return _propTypes2.isMaxDate;
	  }
	});
	Object.defineProperty(exports, "isMinDate", {
	  enumerable: true,
	  get: function get() {
	    return _propTypes2.isMinDate;
	  }
	});
	exports.isValueType = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _propTypes2 = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var allViews = ['century', 'decade', 'year', 'month'];
	var allValueTypes = [].concat(_toConsumableArray(allViews.slice(1)), ['day']);
	
	var isValueType = _propTypes["default"].oneOf(allValueTypes);
	
	exports.isValueType = isValueType;

/***/ },
/* 59 */
[1042, 16],
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(802);
	var ReactInstrumentation = __webpack_require__(33);
	
	var warning = __webpack_require__(14);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 61 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var APP_BAR = exports.APP_BAR = 'RTAppBar';
	var AUTOCOMPLETE = exports.AUTOCOMPLETE = 'RTAutocomplete';
	var AVATAR = exports.AVATAR = 'RTAvatar';
	var BUTTON = exports.BUTTON = 'RTButton';
	var CARD = exports.CARD = 'RTCard';
	var CHIP = exports.CHIP = 'RTChip';
	var CHECKBOX = exports.CHECKBOX = 'RTCheckbox';
	var DATE_PICKER = exports.DATE_PICKER = 'RTDatePicker';
	var DIALOG = exports.DIALOG = 'RTDialog';
	var DRAWER = exports.DRAWER = 'RTDrawer';
	var DROPDOWN = exports.DROPDOWN = 'RTDropdown';
	var INPUT = exports.INPUT = 'RTInput';
	var LAYOUT = exports.LAYOUT = 'RTLayout';
	var LINK = exports.LINK = 'RTLink';
	var LIST = exports.LIST = 'RTList';
	var MENU = exports.MENU = 'RTMenu';
	var NAVIGATION = exports.NAVIGATION = 'RTNavigation';
	var OVERLAY = exports.OVERLAY = 'RTOverlay';
	var PROGRESS_BAR = exports.PROGRESS_BAR = 'RTProgressBar';
	var RADIO = exports.RADIO = 'RTRadio';
	var RIPPLE = exports.RIPPLE = 'RTRipple';
	var SLIDER = exports.SLIDER = 'RTSlider';
	var SNACKBAR = exports.SNACKBAR = 'RTSnackbar';
	var SWITCH = exports.SWITCH = 'RTSwitch';
	var TABLE = exports.TABLE = 'RTTable';
	var TABS = exports.TABS = 'RTTabs';
	var TOOLTIP = exports.TOOLTIP = 'RTTooltip';
	var TIME_PICKER = exports.TIME_PICKER = 'RTTimePicker';

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var ReactChildren = __webpack_require__(931);
	var ReactComponent = __webpack_require__(189);
	var ReactPureComponent = __webpack_require__(936);
	var ReactClass = __webpack_require__(932);
	var ReactDOMFactories = __webpack_require__(933);
	var ReactElement = __webpack_require__(86);
	var ReactPropTypes = __webpack_require__(934);
	var ReactVersion = __webpack_require__(937);
	
	var onlyChild = __webpack_require__(938);
	var warning = __webpack_require__(14);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 63 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = merge;
	
	function merge() {
	  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaults = arguments.length > 1 ? arguments[1] : undefined;
	
	  for (var key in defaults) {
	    if (typeof obj[key] === 'undefined') {
	      obj[key] = defaults[key];
	    }
	  }
	
	  return obj;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var Overlay = React.createClass({
	    displayName: 'Overlay',
	
	    render: function render() {
	        if (this.props.load === 'true') {
	            return React.createElement(
	                'div',
	                { style: { bottom: 0, left: 0, position: 'fixed', zIndex: 2, right: 0, top: 0, margin: 'auto' } },
	                ' ',
	                React.createElement('img', { src: '/img/loader.gif', alt: '', className: 'loader_ov', style: { bottom: 0, left: 0, position: 'absolute', right: 0, top: 0, margin: 'auto' } }),
	                ' '
	            );
	        } else {
	            return React.createElement('span', null);
	        }
	    }
	});
	
	module.exports = Overlay;

/***/ },
/* 65 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var API_v4_URL = exports.API_v4_URL = "https://mars.ninjaos.com/apiV4/";
	var MEDIA_SERVER_URL = exports.MEDIA_SERVER_URL = "https://mars.ninjaos.com/";

/***/ },
/* 66 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(54);
	var createDesc = __webpack_require__(107);
	module.exports = __webpack_require__(40) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 68 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(219);
	var defined = __webpack_require__(132);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(139)('wks');
	var uid = __webpack_require__(108);
	var Symbol = __webpack_require__(41).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 71 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var undefined;
	
	var $SyntaxError = SyntaxError;
	var $Function = Function;
	var $TypeError = TypeError;
	
	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};
	
	var $gOPD = Object.getOwnPropertyDescriptor;
	if ($gOPD) {
		try {
			$gOPD({}, '');
		} catch (e) {
			$gOPD = null; // this is IE 8, which has a broken gOPD
		}
	}
	
	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(631)();
	var hasProto = __webpack_require__(630)();
	
	var getProto = Object.getPrototypeOf || (
		hasProto
			? function (x) { return x.__proto__; } // eslint-disable-line no-proto
			: null
	);
	
	var needsEval = {};
	
	var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': needsEval,
		'%AsyncGenerator%': needsEval,
		'%AsyncGeneratorFunction%': needsEval,
		'%AsyncIteratorPrototype%': needsEval,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
		'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
		'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': EvalError,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': needsEval,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': Object,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': RangeError,
		'%ReferenceError%': ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%URIError%': URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
	};
	
	if (getProto) {
		try {
			null.error; // eslint-disable-line no-unused-expressions
		} catch (e) {
			// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
			var errorProto = getProto(getProto(e));
			INTRINSICS['%Error.prototype%'] = errorProto;
		}
	}
	
	var doEval = function doEval(name) {
		var value;
		if (name === '%AsyncFunction%') {
			value = getEvalledConstructor('async function () {}');
		} else if (name === '%GeneratorFunction%') {
			value = getEvalledConstructor('function* () {}');
		} else if (name === '%AsyncGeneratorFunction%') {
			value = getEvalledConstructor('async function* () {}');
		} else if (name === '%AsyncGenerator%') {
			var fn = doEval('%AsyncGeneratorFunction%');
			if (fn) {
				value = fn.prototype;
			}
		} else if (name === '%AsyncIteratorPrototype%') {
			var gen = doEval('%AsyncGenerator%');
			if (gen && getProto) {
				value = getProto(gen.prototype);
			}
		}
	
		INTRINSICS[name] = value;
	
		return value;
	};
	
	var LEGACY_ALIASES = {
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};
	
	var bind = __webpack_require__(236);
	var hasOwn = __webpack_require__(632);
	var $concat = bind.call(Function.call, Array.prototype.concat);
	var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
	var $replace = bind.call(Function.call, String.prototype.replace);
	var $strSlice = bind.call(Function.call, String.prototype.slice);
	var $exec = bind.call(Function.call, RegExp.prototype.exec);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}
	
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (value === needsEval) {
				value = doEval(intrinsicName);
			}
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}
	
			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}
	
		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}
	
		if ($exec(/^%?[^%]*%?$/, name) === null) {
			throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
		}
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	
		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
	
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
	
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}
	
			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';
	
			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined;
				}
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
	
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
	
				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(43);
	
	var _Actions = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },
/* 75 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 76 */
[1038, 158],
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "getYear", {
	  enumerable: true,
	  get: function get() {
	    return _dates.getYear;
	  }
	});
	Object.defineProperty(exports, "getMonth", {
	  enumerable: true,
	  get: function get() {
	    return _dates.getMonth;
	  }
	});
	Object.defineProperty(exports, "getMonthIndex", {
	  enumerable: true,
	  get: function get() {
	    return _dates.getMonthIndex;
	  }
	});
	Object.defineProperty(exports, "getDay", {
	  enumerable: true,
	  get: function get() {
	    return _dates.getDay;
	  }
	});
	Object.defineProperty(exports, "getDaysInMonth", {
	  enumerable: true,
	  get: function get() {
	    return _dates.getDaysInMonth;
	  }
	});
	Object.defineProperty(exports, "getBegin", {
	  enumerable: true,
	  get: function get() {
	    return _dates.getBegin;
	  }
	});
	Object.defineProperty(exports, "getEnd", {
	  enumerable: true,
	  get: function get() {
	    return _dates.getEnd;
	  }
	});
	Object.defineProperty(exports, "getISOLocalMonth", {
	  enumerable: true,
	  get: function get() {
	    return _dates.getISOLocalMonth;
	  }
	});
	Object.defineProperty(exports, "getISOLocalDate", {
	  enumerable: true,
	  get: function get() {
	    return _dates.getISOLocalDate;
	  }
	});
	
	var _dates = __webpack_require__(27);

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "between", {
	  enumerable: true,
	  get: function get() {
	    return _utils.between;
	  }
	});
	Object.defineProperty(exports, "callIfDefined", {
	  enumerable: true,
	  get: function get() {
	    return _utils.callIfDefined;
	  }
	});
	exports.max = exports.min = void 0;
	
	var _utils = __webpack_require__(161);
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var isValidNumber = function isValidNumber(a) {
	  return typeof a === 'number' && !isNaN(a);
	};
	
	var min = function min() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return Math.min.apply(Math, _toConsumableArray(args.filter(isValidNumber)));
	};
	
	exports.min = min;
	
	var max = function max() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  return Math.max.apply(Math, _toConsumableArray(args.filter(isValidNumber)));
	};
	
	exports.max = max;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(163);
	var setInnerHTML = __webpack_require__(124);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(171);
	var setTextContent = __webpack_require__(434);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var invariant = __webpack_require__(6);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/react-select
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactInputAutosize = __webpack_require__(838);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsDefaultArrowRenderer = __webpack_require__(874);
	
	var _utilsDefaultArrowRenderer2 = _interopRequireDefault(_utilsDefaultArrowRenderer);
	
	var _utilsDefaultFilterOptions = __webpack_require__(449);
	
	var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);
	
	var _utilsDefaultMenuRenderer = __webpack_require__(450);
	
	var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);
	
	var _utilsDefaultClearRenderer = __webpack_require__(875);
	
	var _utilsDefaultClearRenderer2 = _interopRequireDefault(_utilsDefaultClearRenderer);
	
	var _Async = __webpack_require__(869);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(870);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(871);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Option = __webpack_require__(872);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(873);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function stringifyValue(value) {
		var valueType = typeof value;
		if (valueType === 'string') {
			return value;
		} else if (valueType === 'object') {
			return JSON.stringify(value);
		} else if (valueType === 'number' || valueType === 'boolean') {
			return String(value);
		} else {
			return '';
		}
	}
	
	var stringOrNode = _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]);
	
	var instanceId = 1;
	
	var Select = _react2['default'].createClass({
	
		displayName: 'Select',
	
		propTypes: {
			addLabelText: _react2['default'].PropTypes.string, // placeholder displayed when you want to add a label on a multi-value input
			'aria-label': _react2['default'].PropTypes.string, // Aria label (for assistive tech)
			'aria-labelledby': _react2['default'].PropTypes.string, // HTML ID of an element that should be used as the label (for assistive tech)
			arrowRenderer: _react2['default'].PropTypes.func, // Create drop-down caret element
			autoBlur: _react2['default'].PropTypes.bool, // automatically blur the component when an option is selected
			autofocus: _react2['default'].PropTypes.bool, // autofocus the component on mount
			autosize: _react2['default'].PropTypes.bool, // whether to enable autosizing or not
			backspaceRemoves: _react2['default'].PropTypes.bool, // whether backspace removes an item if there is no text input
			backspaceToRemoveMessage: _react2['default'].PropTypes.string, // Message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
			className: _react2['default'].PropTypes.string, // className for the outer element
			clearAllText: stringOrNode, // title for the "clear" control when multi: true
			clearRenderer: _react2['default'].PropTypes.func, // create clearable x element
			clearValueText: stringOrNode, // title for the "clear" control
			clearable: _react2['default'].PropTypes.bool, // should it be possible to reset value
			deleteRemoves: _react2['default'].PropTypes.bool, // whether backspace removes an item if there is no text input
			delimiter: _react2['default'].PropTypes.string, // delimiter to use to join multiple values for the hidden field value
			disabled: _react2['default'].PropTypes.bool, // whether the Select is disabled or not
			escapeClearsValue: _react2['default'].PropTypes.bool, // whether escape clears the value when the menu is closed
			filterOption: _react2['default'].PropTypes.func, // method to filter a single option (option, filterString)
			filterOptions: _react2['default'].PropTypes.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
			ignoreAccents: _react2['default'].PropTypes.bool, // whether to strip diacritics when filtering
			ignoreCase: _react2['default'].PropTypes.bool, // whether to perform case-insensitive filtering
			inputProps: _react2['default'].PropTypes.object, // custom attributes for the Input
			inputRenderer: _react2['default'].PropTypes.func, // returns a custom input component
			instanceId: _react2['default'].PropTypes.string, // set the components instanceId
			isLoading: _react2['default'].PropTypes.bool, // whether the Select is loading externally or not (such as options being loaded)
			joinValues: _react2['default'].PropTypes.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
			labelKey: _react2['default'].PropTypes.string, // path of the label value in option objects
			matchPos: _react2['default'].PropTypes.string, // (any|start) match the start or entire string when filtering
			matchProp: _react2['default'].PropTypes.string, // (any|label|value) which option property to filter on
			menuBuffer: _react2['default'].PropTypes.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
			menuContainerStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu container
			menuRenderer: _react2['default'].PropTypes.func, // renders a custom menu with options
			menuStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu
			multi: _react2['default'].PropTypes.bool, // multi-value input
			name: _react2['default'].PropTypes.string, // generates a hidden <input /> tag with this field name for html forms
			noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
			onBlur: _react2['default'].PropTypes.func, // onBlur handler: function (event) {}
			onBlurResetsInput: _react2['default'].PropTypes.bool, // whether input is cleared on blur
			onChange: _react2['default'].PropTypes.func, // onChange handler: function (newValue) {}
			onClose: _react2['default'].PropTypes.func, // fires when the menu is closed
			onCloseResetsInput: _react2['default'].PropTypes.bool, // whether input is cleared when menu is closed through the arrow
			onFocus: _react2['default'].PropTypes.func, // onFocus handler: function (event) {}
			onInputChange: _react2['default'].PropTypes.func, // onInputChange handler: function (inputValue) {}
			onInputKeyDown: _react2['default'].PropTypes.func, // input keyDown handler: function (event) {}
			onMenuScrollToBottom: _react2['default'].PropTypes.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
			onOpen: _react2['default'].PropTypes.func, // fires when the menu is opened
			onValueClick: _react2['default'].PropTypes.func, // onClick handler for value labels: function (value, event) {}
			openAfterFocus: _react2['default'].PropTypes.bool, // boolean to enable opening dropdown when focused
			openOnFocus: _react2['default'].PropTypes.bool, // always open options menu on focus
			optionClassName: _react2['default'].PropTypes.string, // additional class(es) to apply to the <Option /> elements
			optionComponent: _react2['default'].PropTypes.func, // option component to render in dropdown
			optionRenderer: _react2['default'].PropTypes.func, // optionRenderer: function (option) {}
			options: _react2['default'].PropTypes.array, // array of options
			pageSize: _react2['default'].PropTypes.number, // number of entries to page when using page up/down keys
			placeholder: stringOrNode, // field placeholder, displayed when there's no value
			required: _react2['default'].PropTypes.bool, // applies HTML5 required attribute when needed
			resetValue: _react2['default'].PropTypes.any, // value to use when you clear the control
			scrollMenuIntoView: _react2['default'].PropTypes.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
			searchable: _react2['default'].PropTypes.bool, // whether to enable searching feature or not
			simpleValue: _react2['default'].PropTypes.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
			style: _react2['default'].PropTypes.object, // optional style to apply to the control
			tabIndex: _react2['default'].PropTypes.string, // optional tab index of the control
			tabSelectsValue: _react2['default'].PropTypes.bool, // whether to treat tabbing out while focused to be value selection
			value: _react2['default'].PropTypes.any, // initial field value
			valueComponent: _react2['default'].PropTypes.func, // value component to render
			valueKey: _react2['default'].PropTypes.string, // path of the label value in option objects
			valueRenderer: _react2['default'].PropTypes.func, // valueRenderer: function (option) {}
			wrapperStyle: _react2['default'].PropTypes.object },
	
		// optional style to apply to the component wrapper
		statics: { Async: _Async2['default'], AsyncCreatable: _AsyncCreatable2['default'], Creatable: _Creatable2['default'] },
	
		getDefaultProps: function getDefaultProps() {
			return {
				addLabelText: 'Add "{label}"?',
				arrowRenderer: _utilsDefaultArrowRenderer2['default'],
				autosize: true,
				backspaceRemoves: true,
				backspaceToRemoveMessage: 'Press backspace to remove {label}',
				clearable: true,
				clearAllText: 'Clear all',
				clearRenderer: _utilsDefaultClearRenderer2['default'],
				clearValueText: 'Clear value',
				deleteRemoves: true,
				delimiter: ',',
				disabled: false,
				escapeClearsValue: true,
				filterOptions: _utilsDefaultFilterOptions2['default'],
				ignoreAccents: true,
				ignoreCase: true,
				inputProps: {},
				isLoading: false,
				joinValues: false,
				labelKey: 'label',
				matchPos: 'any',
				matchProp: 'any',
				menuBuffer: 0,
				menuRenderer: _utilsDefaultMenuRenderer2['default'],
				multi: false,
				noResultsText: 'No results found',
				onBlurResetsInput: true,
				onCloseResetsInput: true,
				openAfterFocus: false,
				optionComponent: _Option2['default'],
				pageSize: 5,
				placeholder: 'Select...',
				required: false,
				scrollMenuIntoView: true,
				searchable: true,
				simpleValue: false,
				tabSelectsValue: true,
				valueComponent: _Value2['default'],
				valueKey: 'value'
			};
		},
	
		getInitialState: function getInitialState() {
			return {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
		},
	
		componentWillMount: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);
	
			if (this.props.required) {
				this.setState({
					required: this.handleRequired(valueArray[0], this.props.multi)
				});
			}
		},
	
		componentDidMount: function componentDidMount() {
			if (this.props.autofocus) {
				this.focus();
			}
		},
	
		componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);
	
			if (nextProps.required) {
				this.setState({
					required: this.handleRequired(valueArray[0], nextProps.multi)
				});
			}
		},
	
		componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
			if (nextState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(nextState.isOpen);
				var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
				handler && handler();
			}
		},
	
		componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = _reactDom2['default'].findDOMNode(this.focused);
				var menuNode = _reactDom2['default'].findDOMNode(this.menu);
				menuNode.scrollTop = focusedOptionNode.offsetTop;
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}
	
			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = _reactDom2['default'].findDOMNode(this.focused);
				var menuDOM = _reactDom2['default'].findDOMNode(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom || focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
		},
	
		componentWillUnmount: function componentWillUnmount() {
			if (!document.removeEventListener && document.detachEvent) {
				document.detachEvent('ontouchstart', this.handleTouchOutside);
			} else {
				document.removeEventListener('touchstart', this.handleTouchOutside);
			}
		},
	
		toggleTouchOutsideEvent: function toggleTouchOutsideEvent(enabled) {
			if (enabled) {
				if (!document.addEventListener && document.attachEvent) {
					document.attachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.addEventListener('touchstart', this.handleTouchOutside);
				}
			} else {
				if (!document.removeEventListener && document.detachEvent) {
					document.detachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.removeEventListener('touchstart', this.handleTouchOutside);
				}
			}
		},
	
		handleTouchOutside: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		},
	
		focus: function focus() {
			if (!this.input) return;
			this.input.focus();
	
			if (this.props.openAfterFocus) {
				this.setState({
					isOpen: true
				});
			}
		},
	
		blurInput: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		},
	
		handleTouchMove: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		},
	
		handleTouchStart: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		},
	
		handleTouchEnd: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			// Fire the mouse events
			this.handleMouseDown(event);
		},
	
		handleTouchEndClearValue: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			// Clear the value
			this.clearValue(event);
		},
	
		handleMouseDown: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
	
			if (event.target.tagName === 'INPUT') {
				return;
			}
	
			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();
	
			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen
				});
			}
	
			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();
	
				var input = this.input;
				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}
	
				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';
	
				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: true,
					isPseudoFocused: false
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = true;
				this.focus();
			}
		},
	
		handleMouseDownOnArrow: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			// If the menu isn't open, let the event bubble to the main handleMouseDown
			if (!this.state.isOpen) {
				return;
			}
			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();
			// close the menu
			this.closeMenu();
		},
	
		handleMouseDownOnMenu: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();
	
			this._openAfterFocus = true;
			this.focus();
		},
	
		closeMenu: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi,
					inputValue: ''
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi,
					inputValue: this.state.inputValue
				});
			}
			this.hasScrolledToOption = false;
		},
	
		handleInputFocus: function handleInputFocus(event) {
			if (this.props.disabled) return;
			var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			if (this.props.onFocus) {
				this.props.onFocus(event);
			}
			this.setState({
				isFocused: true,
				isOpen: isOpen
			});
			this._openAfterFocus = false;
		},
	
		handleInputBlur: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}
	
			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = '';
			}
			this.setState(onBlurredState);
		},
	
		handleInputChange: function handleInputChange(event) {
			var newInputValue = event.target.value;
	
			if (this.state.inputValue !== event.target.value && this.props.onInputChange) {
				var nextState = this.props.onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && typeof nextState !== 'object') {
					newInputValue = '' + nextState;
				}
			}
	
			this.setState({
				isOpen: true,
				isPseudoFocused: false,
				inputValue: newInputValue
			});
		},
	
		handleKeyDown: function handleKeyDown(event) {
			if (this.props.disabled) return;
	
			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}
	
			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					return;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						return;
					}
					this.selectFocusedOption();
					return;
				case 13:
					// enter
					if (!this.state.isOpen) return;
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 27:
					// escape
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 38:
					// up
					this.focusPreviousOption();
					break;
				case 40:
					// down
					this.focusNextOption();
					break;
				case 33:
					// page up
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						return;
					}
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						return;
					}
					this.focusStartOption();
					break;
				case 46:
					// backspace
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					return;
				default:
					return;
			}
			event.preventDefault();
		},
	
		handleValueClick: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		},
	
		handleMenuScroll: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;
	
			if (target.scrollHeight > target.offsetHeight && !(target.scrollHeight - target.offsetHeight - target.scrollTop)) {
				this.props.onMenuScrollToBottom();
			}
		},
	
		handleRequired: function handleRequired(value, multi) {
			if (!value) return true;
			return multi ? value.length === 0 : Object.keys(value).length === 0;
		},
	
		getOptionLabel: function getOptionLabel(op) {
			return op[this.props.labelKey];
		},
	
		/**
	  * Turns a value into an array from the given options
	  * @param	{String|Number|Array}	value		- the value of the select input
	  * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	  * @returns	{Array}	the value of the select represented in an array
	  */
		getValueArray: function getValueArray(value, nextProps) {
			var _this = this;
	
			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = typeof nextProps === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') value = value.split(props.delimiter);
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return _this.expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = this.expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		},
	
		/**
	  * Retrieve a value from the given options and valueKey
	  * @param	{String|Number|Array}	value	- the selected value(s)
	  * @param	{Object}		props	- the Select component's props (or nextProps)
	  */
		expandValue: function expandValue(value, props) {
			var valueType = typeof value;
			if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
			var options = props.options;
			var valueKey = props.valueKey;
	
			if (!options) return;
			for (var i = 0; i < options.length; i++) {
				if (options[i][valueKey] === value) return options[i];
			}
		},
	
		setValue: function setValue(value) {
			var _this2 = this;
	
			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (!this.props.onChange) return;
			if (this.props.required) {
				var required = this.handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			this.props.onChange(value);
		},
	
		selectValue: function selectValue(value) {
			var _this3 = this;
	
			//NOTE: update value in the callback to make sure the input value is empty so that there are no styling issues (Chrome had issue otherwise)
			this.hasScrolledToOption = false;
			if (this.props.multi) {
				this.setState({
					inputValue: '',
					focusedIndex: null
				}, function () {
					_this3.addValue(value);
				});
			} else {
				this.setState({
					isOpen: false,
					inputValue: '',
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		},
	
		addValue: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		},
	
		popValue: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(valueArray.slice(0, valueArray.length - 1));
		},
	
		removeValue: function removeValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i !== value;
			}));
			this.focus();
		},
	
		clearValue: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();
			this.setValue(this.getResetValue());
			this.setState({
				isOpen: false,
				inputValue: ''
			}, this.focus);
		},
	
		getResetValue: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		},
	
		focusOption: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		},
	
		focusNextOption: function focusNextOption() {
			this.focusAdjacentOption('next');
		},
	
		focusPreviousOption: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		},
	
		focusPageUpOption: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		},
	
		focusPageDownOption: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		},
	
		focusStartOption: function focusStartOption() {
			this.focusAdjacentOption('start');
		},
	
		focusEndOption: function focusEndOption() {
			this.focusAdjacentOption('end');
		},
	
		focusAdjacentOption: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				this.setState({
					isOpen: true,
					inputValue: '',
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null)
				});
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var potentialIndex = focusedIndex + this.props.pageSize;
				if (potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = potentialIndex;
				}
			}
	
			if (focusedIndex === -1) {
				focusedIndex = 0;
			}
	
			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		},
	
		getFocusedOption: function getFocusedOption() {
			return this._focusedOption;
		},
	
		getInputValue: function getInputValue() {
			return this.state.inputValue;
		},
	
		selectFocusedOption: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		},
	
		renderLoading: function renderLoading() {
			if (!this.props.isLoading) return;
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				_react2['default'].createElement('span', { className: 'Select-loading' })
			);
		},
	
		renderValue: function renderValue(valueArray, isOpen) {
			var _this4 = this;
	
			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				return !this.state.inputValue ? _react2['default'].createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return _react2['default'].createElement(
						ValueComponent,
						{
							id: _this4._instancePrefix + '-value-' + i,
							instancePrefix: _this4._instancePrefix,
							disabled: _this4.props.disabled || value.clearableValue === false,
							key: 'value-' + i + '-' + value[_this4.props.valueKey],
							onClick: onClick,
							onRemove: _this4.removeValue,
							value: value
						},
						renderLabel(value, i),
						_react2['default'].createElement(
							'span',
							{ className: 'Select-aria-only' },
							' '
						)
					);
				});
			} else if (!this.state.inputValue) {
				if (isOpen) onClick = null;
				return _react2['default'].createElement(
					ValueComponent,
					{
						id: this._instancePrefix + '-value-item',
						disabled: this.props.disabled,
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		},
	
		renderInput: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this5 = this;
	
			var className = (0, _classnames2['default'])('Select-input', this.props.inputProps.className);
			var isOpen = !!this.state.isOpen;
	
			var ariaOwns = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
			// TODO: Check how this project includes Object.assign()
			var inputProps = _extends({}, this.props.inputProps, {
				role: 'combobox',
				'aria-expanded': '' + isOpen,
				'aria-owns': ariaOwns,
				'aria-haspopup': '' + isOpen,
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-label': this.props['aria-label'],
				className: className,
				tabIndex: this.props.tabIndex,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this5.input = _ref;
				},
				required: this.state.required,
				value: this.state.inputValue
			});
	
			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}
	
			if (this.props.disabled || !this.props.searchable) {
				var _props$inputProps = this.props.inputProps;
				var inputClassName = _props$inputProps.inputClassName;
	
				var divProps = _objectWithoutProperties(_props$inputProps, ['inputClassName']);
	
				return _react2['default'].createElement('div', _extends({}, divProps, {
					role: 'combobox',
					'aria-expanded': isOpen,
					'aria-owns': isOpen ? this._instancePrefix + '-list' : this._instancePrefix + '-value',
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					className: className,
					tabIndex: this.props.tabIndex || 0,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function (ref) {
						return _this5.input = ref;
					},
					'aria-readonly': '' + !!this.props.disabled,
					style: { border: 0, width: 1, display: 'inline-block' } }));
			}
	
			if (this.props.autosize) {
				return _react2['default'].createElement(_reactInputAutosize2['default'], _extends({}, inputProps, { minWidth: '5' }));
			}
			return _react2['default'].createElement(
				'div',
				{ className: className },
				_react2['default'].createElement('input', inputProps)
			);
		},
	
		renderClear: function renderClear() {
			if (!this.props.clearable || !this.props.value || this.props.value === 0 || this.props.multi && !this.props.value.length || this.props.disabled || this.props.isLoading) return;
			var clear = this.props.clearRenderer();
	
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					onMouseDown: this.clearValue,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEndClearValue
				},
				clear
			);
		},
	
		renderArrow: function renderArrow() {
			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
			return _react2['default'].createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		},
	
		filterOptions: function filterOptions(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _utilsDefaultFilterOptions2['default'];
	
				return filterOptions(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		},
	
		onOptionRef: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		},
	
		renderMenu: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey,
					onOptionRef: this.onOptionRef
				});
			} else if (this.props.noResultsText) {
				return _react2['default'].createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		},
	
		renderHiddenField: function renderHiddenField(valueArray) {
			var _this6 = this;
	
			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this6.props.valueKey]);
				}).join(this.props.delimiter);
				return _react2['default'].createElement('input', {
					type: 'hidden',
					ref: function (ref) {
						return _this6.value = ref;
					},
					name: this.props.name,
					value: value,
					disabled: this.props.disabled });
			}
			return valueArray.map(function (item, index) {
				return _react2['default'].createElement('input', { key: 'hidden.' + index,
					type: 'hidden',
					ref: 'value' + index,
					name: _this6.props.name,
					value: stringifyValue(item[_this6.props.valueKey]),
					disabled: _this6.props.disabled });
			});
		},
	
		getFocusableOptionIndex: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;
	
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = options.indexOf(focusedOption);
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}
	
			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		},
	
		renderOuter: function renderOuter(options, valueArray, focusedOption) {
			var _this7 = this;
	
			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}
	
			return _react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this7.menuContainer = ref;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				_react2['default'].createElement(
					'div',
					{ ref: function (ref) {
							return _this7.menu = ref;
						}, role: 'listbox', className: 'Select-menu', id: this._instancePrefix + '-list',
						style: this.props.menuStyle,
						onScroll: this.handleMenuScroll,
						onMouseDown: this.handleMouseDownOnMenu },
					menu
				)
			);
		},
	
		render: function render() {
			var _this8 = this;
	
			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi ? this.getValueArray(this.props.value) : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = (0, _classnames2['default'])('Select', this.props.className, {
				'Select--multi': this.props.multi,
				'Select--single': !this.props.multi,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'has-value': valueArray.length
			});
	
			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = _react2['default'].createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}
	
			return _react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this8.wrapper = ref;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				_react2['default'].createElement(
					'div',
					{ ref: function (ref) {
							return _this8.control = ref;
						},
						className: 'Select-control',
						style: this.props.style,
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove
					},
					_react2['default'].createElement(
						'span',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, !this.props.multi ? valueArray : null, focusedOption) : null
			);
		}
	
	});
	
	exports['default'] = Select;
	module.exports = exports['default'];

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactCssThemr = __webpack_require__(44);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactCssThemr.ThemeProvider;
	  }
	});

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DatePicker = exports.Calendar = exports.datePickerFactory = exports.DatePickerDialog = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(20);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(44);
	
	var _identifiers = __webpack_require__(61);
	
	var _events = __webpack_require__(458);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _time = __webpack_require__(101);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _IconButton = __webpack_require__(913);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _Input = __webpack_require__(921);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Dialog = __webpack_require__(918);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Calendar = __webpack_require__(914);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _DatePickerDialog = __webpack_require__(917);
	
	var _DatePickerDialog2 = _interopRequireDefault(_DatePickerDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(Input, DatePickerDialog) {
	  var DatePicker = function (_Component) {
	    _inherits(DatePicker, _Component);
	
	    function DatePicker() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, DatePicker);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        active: _this.props.active
	      }, _this.handleDismiss = function () {
	        _this.setState({ active: false });
	        if (_this.props.onDismiss) {
	          _this.props.onDismiss();
	        }
	      }, _this.handleInputFocus = function (event) {
	        _events2.default.pauseEvent(event);
	        _this.setState({ active: true });
	      }, _this.handleInputBlur = function (event) {
	        _events2.default.pauseEvent(event);
	        _this.setState({ active: false });
	      }, _this.handleInputClick = function (event) {
	        _events2.default.pauseEvent(event);
	        _this.setState({ active: true });
	        if (_this.props.onClick) _this.props.onClick(event);
	      }, _this.handleInputKeyPress = function (event) {
	        if (event.charCode === 13) {
	          _events2.default.pauseEvent(event);
	          _this.setState({ active: true });
	        }
	        if (_this.props.onKeyPress) _this.props.onKeyPress(event);
	      }, _this.handleSelect = function (value, event) {
	        if (_this.props.onChange) _this.props.onChange(value, event);
	        _this.setState({ active: false });
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(DatePicker, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (nextProps.active !== this.props.active && this.state.active !== nextProps.active) {
	          this.setState({ active: nextProps.active });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            active = _props.active,
	            onDismiss = _props.onDismiss,
	            autoOk = _props.autoOk,
	            cancelLabel = _props.cancelLabel,
	            enabledDates = _props.enabledDates,
	            disabledDates = _props.disabledDates,
	            inputClassName = _props.inputClassName,
	            inputFormat = _props.inputFormat,
	            locale = _props.locale,
	            maxDate = _props.maxDate,
	            minDate = _props.minDate,
	            okLabel = _props.okLabel,
	            onEscKeyDown = _props.onEscKeyDown,
	            onOverlayClick = _props.onOverlayClick,
	            readonly = _props.readonly,
	            sundayFirstDayOfWeek = _props.sundayFirstDayOfWeek,
	            value = _props.value,
	            others = _objectWithoutProperties(_props, ['active', 'onDismiss', 'autoOk', 'cancelLabel', 'enabledDates', 'disabledDates', 'inputClassName', 'inputFormat', 'locale', 'maxDate', 'minDate', 'okLabel', 'onEscKeyDown', 'onOverlayClick', 'readonly', 'sundayFirstDayOfWeek', 'value']);
	
	        var finalInputFormat = inputFormat || _time2.default.formatDate;
	        var date = Object.prototype.toString.call(value) === '[object Date]' ? value : undefined;
	        var formattedDate = date === undefined ? '' : finalInputFormat(value, locale);
	
	        return _react2.default.createElement(
	          'div',
	          { 'data-react-toolbox': 'date-picker', className: this.props.theme.container },
	          _react2.default.createElement(Input, _extends({}, others, {
	            className: (0, _classnames3.default)(this.props.theme.input, _defineProperty({}, inputClassName, inputClassName)),
	            disabled: readonly,
	            error: this.props.error,
	            icon: this.props.icon,
	            label: this.props.label,
	            name: this.props.name,
	            onFocus: this.handleInputFocus,
	            onKeyPress: this.handleInputKeyPress,
	            onClick: this.handleInputClick,
	            readOnly: true,
	            type: 'text',
	            value: formattedDate
	          })),
	          _react2.default.createElement(DatePickerDialog, {
	            active: this.state.active,
	            autoOk: autoOk,
	            cancelLabel: cancelLabel,
	            className: this.props.className,
	            disabledDates: disabledDates,
	            enabledDates: enabledDates,
	            locale: locale,
	            maxDate: maxDate,
	            minDate: minDate,
	            name: this.props.name,
	            onDismiss: this.handleDismiss,
	            okLabel: okLabel,
	            onEscKeyDown: onEscKeyDown || this.handleDismiss,
	            onOverlayClick: onOverlayClick || this.handleDismiss,
	            onSelect: this.handleSelect,
	            sundayFirstDayOfWeek: sundayFirstDayOfWeek,
	            theme: this.props.theme,
	            value: date
	          })
	        );
	      }
	    }]);
	
	    return DatePicker;
	  }(_react.Component);
	
	  DatePicker.propTypes = {
	    active: _propTypes2.default.bool,
	    autoOk: _propTypes2.default.bool,
	    cancelLabel: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    disabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	    enabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	    error: _propTypes2.default.string,
	    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    inputClassName: _propTypes2.default.string,
	    inputFormat: _propTypes2.default.func,
	    label: _propTypes2.default.string,
	    locale: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	    maxDate: _propTypes2.default.instanceOf(Date),
	    minDate: _propTypes2.default.instanceOf(Date),
	    name: _propTypes2.default.string,
	    okLabel: _propTypes2.default.string,
	    onChange: _propTypes2.default.func,
	    onClick: _propTypes2.default.func,
	    onDismiss: _propTypes2.default.func,
	    onEscKeyDown: _propTypes2.default.func,
	    onKeyPress: _propTypes2.default.func,
	    onOverlayClick: _propTypes2.default.func,
	    readonly: _propTypes2.default.bool,
	    sundayFirstDayOfWeek: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      container: _propTypes2.default.string,
	      input: _propTypes2.default.string
	    }),
	    value: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(Date), _propTypes2.default.string])
	  };
	  DatePicker.defaultProps = {
	    active: false,
	    locale: 'en',
	    sundayFirstDayOfWeek: false
	  };
	
	
	  return DatePicker;
	};
	
	var Calendar = (0, _Calendar2.default)(_IconButton2.default);
	var DatePickerDialog = (0, _DatePickerDialog2.default)(_Dialog2.default, Calendar);
	var DatePicker = factory(_Input2.default, DatePickerDialog);
	
	exports.default = (0, _reactCssThemr.themr)(_identifiers.DATE_PICKER)(DatePicker);
	exports.DatePickerDialog = DatePickerDialog;
	exports.datePickerFactory = factory;
	exports.Calendar = Calendar;
	exports.DatePicker = DatePicker;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var ReactCurrentOwner = __webpack_require__(38);
	
	var warning = __webpack_require__(14);
	var canDefineProperty = __webpack_require__(463);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(461);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 87 */
16,
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _toDate = _interopRequireDefault(__webpack_require__(193));
	
	var _toFloat = _interopRequireDefault(__webpack_require__(474));
	
	var _toInt = _interopRequireDefault(__webpack_require__(1019));
	
	var _toBoolean = _interopRequireDefault(__webpack_require__(1018));
	
	var _equals = _interopRequireDefault(__webpack_require__(963));
	
	var _contains = _interopRequireDefault(__webpack_require__(962));
	
	var _matches = _interopRequireDefault(__webpack_require__(1015));
	
	var _isEmail = _interopRequireDefault(__webpack_require__(978));
	
	var _isURL = _interopRequireDefault(__webpack_require__(1010));
	
	var _isMACAddress = _interopRequireDefault(__webpack_require__(998));
	
	var _isIP = _interopRequireDefault(__webpack_require__(127));
	
	var _isIPRange = _interopRequireDefault(__webpack_require__(983));
	
	var _isFQDN = _interopRequireDefault(__webpack_require__(192));
	
	var _isBoolean = _interopRequireDefault(__webpack_require__(972));
	
	var _isAlpha = _interopRequireWildcard(__webpack_require__(966));
	
	var _isAlphanumeric = _interopRequireWildcard(__webpack_require__(967));
	
	var _isNumeric = _interopRequireDefault(__webpack_require__(1005));
	
	var _isPort = _interopRequireDefault(__webpack_require__(1006));
	
	var _isLowercase = _interopRequireDefault(__webpack_require__(997));
	
	var _isUppercase = _interopRequireDefault(__webpack_require__(1012));
	
	var _isAscii = _interopRequireDefault(__webpack_require__(968));
	
	var _isFullWidth = _interopRequireDefault(__webpack_require__(468));
	
	var _isHalfWidth = _interopRequireDefault(__webpack_require__(469));
	
	var _isVariableWidth = _interopRequireDefault(__webpack_require__(1013));
	
	var _isMultibyte = _interopRequireDefault(__webpack_require__(1004));
	
	var _isSurrogatePair = _interopRequireDefault(__webpack_require__(1009));
	
	var _isInt = _interopRequireDefault(__webpack_require__(471));
	
	var _isFloat = _interopRequireWildcard(__webpack_require__(980));
	
	var _isDecimal = _interopRequireDefault(__webpack_require__(976));
	
	var _isHexadecimal = _interopRequireDefault(__webpack_require__(470));
	
	var _isDivisibleBy = _interopRequireDefault(__webpack_require__(977));
	
	var _isHexColor = _interopRequireDefault(__webpack_require__(982));
	
	var _isISRC = _interopRequireDefault(__webpack_require__(989));
	
	var _isMD = _interopRequireDefault(__webpack_require__(999));
	
	var _isHash = _interopRequireDefault(__webpack_require__(981));
	
	var _isJWT = _interopRequireDefault(__webpack_require__(994));
	
	var _isJSON = _interopRequireDefault(__webpack_require__(993));
	
	var _isEmpty = _interopRequireDefault(__webpack_require__(979));
	
	var _isLength = _interopRequireDefault(__webpack_require__(996));
	
	var _isByteLength = _interopRequireDefault(__webpack_require__(467));
	
	var _isUUID = _interopRequireDefault(__webpack_require__(1011));
	
	var _isMongoId = _interopRequireDefault(__webpack_require__(1003));
	
	var _isAfter = _interopRequireDefault(__webpack_require__(965));
	
	var _isBefore = _interopRequireDefault(__webpack_require__(971));
	
	var _isIn = _interopRequireDefault(__webpack_require__(992));
	
	var _isCreditCard = _interopRequireDefault(__webpack_require__(973));
	
	var _isIdentityCard = _interopRequireDefault(__webpack_require__(991));
	
	var _isISIN = _interopRequireDefault(__webpack_require__(985));
	
	var _isISBN = _interopRequireDefault(__webpack_require__(984));
	
	var _isISSN = _interopRequireDefault(__webpack_require__(990));
	
	var _isMobilePhone = _interopRequireWildcard(__webpack_require__(1002));
	
	var _isCurrency = _interopRequireDefault(__webpack_require__(974));
	
	var _isISO = _interopRequireDefault(__webpack_require__(988));
	
	var _isRFC = _interopRequireDefault(__webpack_require__(1008));
	
	var _isISO31661Alpha = _interopRequireDefault(__webpack_require__(986));
	
	var _isISO31661Alpha2 = _interopRequireDefault(__webpack_require__(987));
	
	var _isBase = _interopRequireDefault(__webpack_require__(969));
	
	var _isBase2 = _interopRequireDefault(__webpack_require__(970));
	
	var _isDataURI = _interopRequireDefault(__webpack_require__(975));
	
	var _isMagnetURI = _interopRequireDefault(__webpack_require__(1000));
	
	var _isMimeType = _interopRequireDefault(__webpack_require__(1001));
	
	var _isLatLong = _interopRequireDefault(__webpack_require__(995));
	
	var _isPostalCode = _interopRequireWildcard(__webpack_require__(1007));
	
	var _ltrim = _interopRequireDefault(__webpack_require__(472));
	
	var _rtrim = _interopRequireDefault(__webpack_require__(473));
	
	var _trim = _interopRequireDefault(__webpack_require__(1020));
	
	var _escape = _interopRequireDefault(__webpack_require__(964));
	
	var _unescape = _interopRequireDefault(__webpack_require__(1021));
	
	var _stripLow = _interopRequireDefault(__webpack_require__(1017));
	
	var _whitelist = _interopRequireDefault(__webpack_require__(1022));
	
	var _blacklist = _interopRequireDefault(__webpack_require__(466));
	
	var _isWhitelisted = _interopRequireDefault(__webpack_require__(1014));
	
	var _normalizeEmail = _interopRequireDefault(__webpack_require__(1016));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var version = '11.1.0';
	var validator = {
	  version: version,
	  toDate: _toDate.default,
	  toFloat: _toFloat.default,
	  toInt: _toInt.default,
	  toBoolean: _toBoolean.default,
	  equals: _equals.default,
	  contains: _contains.default,
	  matches: _matches.default,
	  isEmail: _isEmail.default,
	  isURL: _isURL.default,
	  isMACAddress: _isMACAddress.default,
	  isIP: _isIP.default,
	  isIPRange: _isIPRange.default,
	  isFQDN: _isFQDN.default,
	  isBoolean: _isBoolean.default,
	  isAlpha: _isAlpha.default,
	  isAlphaLocales: _isAlpha.locales,
	  isAlphanumeric: _isAlphanumeric.default,
	  isAlphanumericLocales: _isAlphanumeric.locales,
	  isNumeric: _isNumeric.default,
	  isPort: _isPort.default,
	  isLowercase: _isLowercase.default,
	  isUppercase: _isUppercase.default,
	  isAscii: _isAscii.default,
	  isFullWidth: _isFullWidth.default,
	  isHalfWidth: _isHalfWidth.default,
	  isVariableWidth: _isVariableWidth.default,
	  isMultibyte: _isMultibyte.default,
	  isSurrogatePair: _isSurrogatePair.default,
	  isInt: _isInt.default,
	  isFloat: _isFloat.default,
	  isFloatLocales: _isFloat.locales,
	  isDecimal: _isDecimal.default,
	  isHexadecimal: _isHexadecimal.default,
	  isDivisibleBy: _isDivisibleBy.default,
	  isHexColor: _isHexColor.default,
	  isISRC: _isISRC.default,
	  isMD5: _isMD.default,
	  isHash: _isHash.default,
	  isJWT: _isJWT.default,
	  isJSON: _isJSON.default,
	  isEmpty: _isEmpty.default,
	  isLength: _isLength.default,
	  isByteLength: _isByteLength.default,
	  isUUID: _isUUID.default,
	  isMongoId: _isMongoId.default,
	  isAfter: _isAfter.default,
	  isBefore: _isBefore.default,
	  isIn: _isIn.default,
	  isCreditCard: _isCreditCard.default,
	  isIdentityCard: _isIdentityCard.default,
	  isISIN: _isISIN.default,
	  isISBN: _isISBN.default,
	  isISSN: _isISSN.default,
	  isMobilePhone: _isMobilePhone.default,
	  isMobilePhoneLocales: _isMobilePhone.locales,
	  isPostalCode: _isPostalCode.default,
	  isPostalCodeLocales: _isPostalCode.locales,
	  isCurrency: _isCurrency.default,
	  isISO8601: _isISO.default,
	  isRFC3339: _isRFC.default,
	  isISO31661Alpha2: _isISO31661Alpha.default,
	  isISO31661Alpha3: _isISO31661Alpha2.default,
	  isBase32: _isBase.default,
	  isBase64: _isBase2.default,
	  isDataURI: _isDataURI.default,
	  isMagnetURI: _isMagnetURI.default,
	  isMimeType: _isMimeType.default,
	  isLatLong: _isLatLong.default,
	  ltrim: _ltrim.default,
	  rtrim: _rtrim.default,
	  trim: _trim.default,
	  escape: _escape.default,
	  unescape: _unescape.default,
	  stripLow: _stripLow.default,
	  whitelist: _whitelist.default,
	  blacklist: _blacklist.default,
	  isWhitelisted: _isWhitelisted.default,
	  normalizeEmail: _normalizeEmail.default,
	  toString: toString
	};
	var _default = validator;
	exports.default = _default;
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 89 */
/***/ function(module, exports) {

	module.exports={"RTButton":{"button":"_2Agdx","rippleWrapper":"_3AVBi","squared":"_2GH_L","icon":"_3aBSX","solid":"_1ZxqC","raised":"_221ic _2Agdx _2GH_L _1ZxqC","flat":"_1jWAQ _2Agdx _2GH_L","floating":"_3IRMZ _2Agdx _1ZxqC","mini":"_2DCN-","toggle":"hC5Z2 _2Agdx","primary":"_3tTAW","accent":"_2wp6F","neutral":"_2CPs4","inverse":"_2SPZr"},"RTRipple":{"rippleWrapper":"_16N7o","ripple":"_3SV_u","rippleRestarting":"_2OZWa","rippleActive":"_3O2Ue"},"RTDatePicker":{"input":"_2ISvI","disabled":"Cf3yF","inputElement":"x7MhN","header":"_2vLUd","year":"_1VWY-","date":"_3K2Ws","calendarWrapper":"_1t-4v","yearsDisplay":"_2OzvT","monthsDisplay":"_2DDdC","dialog":"_3fCV6","button":"_2hL6u","calendar":"_1X9ls","prev":"Nv9Bc","next":"_3iPkS","title":"_2ESpD","years":"zEdgW","active":"_1pjXb","week":"PcByv","days":"_1qh3T","day":"_2qF_L","month":"_1hSm5","slideRightEnter":"Rk89h","slideRightLeave":"_1nam4","slideRightEnterActive":"m5B3T","slideRightLeaveActive":"_2bZap","slideLeftEnter":"bGml_","slideLeftLeave":"_2WGqM","slideLeftEnterActive":"_3Ghls","slideLeftLeaveActive":"_2WLHG"},"RTInput":{"input":"lFVgC","withIcon":"_1nKdf","icon":"_3ga1V","inputElement":"_4bZUj","bar":"_3FySS","label":"_34120","fixed":"GRQEP","required":"_2G0aY","hint":"bMyi_","filled":"_34NWn","error":"_2k5Jz","counter":"_1oTuT","disabled":"_3ZfJq","errored":"_2s74E","hidden":"_2gAMv"},"RTDialog":{"wrapper":"_3nrqp","dialog":"_3lw90","active":"_3ea_1","small":"_38VTT","normal":"_1K3iz","large":"_10LcP","fullscreen":"_3tLXQ","title":"_2J-aP","body":"_1Ivuq","navigation":"wgwdj","button":"_22_c6"},"RTOverlay":{"overlay":"_2LA9x","active":"_1mb5R"},"RTTimePicker":{"input":"_2APuy","disabled":"_2Vc_4","inputElement":"_2Z4kT","header":"_2u1sB","hours":"_3Kl2E","minutes":"_3Bp7w","separator":"_1c2VQ","ampm":"_1vAVQ","am":"_14hQA","pm":"aU9C9","dialog":"_1YlHq","button":"_1Kf0L","hoursDisplay":"_2JeOG","minutesDisplay":"_3UMNx","amFormat":"_26MJk","pmFormat":"_3H_-m","clock":"_2CwF0","placeholder":"zCpyM","clockWrapper":"_3paoD","face":"_3ui0r","number":"qr9pw","active":"_30yS_","hand":"_1rtAF","small":"_3eEHh","knob":"VqPQb","zoomInEnter":"_3DTnI","zoomInLeave":"_1tgJ3","zoomInEnterActive":"_1Fr4_","zoomInLeaveActive":"_1EUpH","zoomOutEnter":"_1Lb15","zoomOutLeave":"_3LDEu","zoomOutEnterActive":"_3y67C","zoomOutLeaveActive":"_18Ean"}}

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(68);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(224);
	var enumBugKeys = __webpack_require__(133);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(132);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 93 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = mergeClassNames;
	
	function mergeClassNames() {
	  return Array.prototype.slice.call(arguments).reduce(function (classList, arg) {
	    return classList.concat(arg);
	  }, []).filter(function (arg) {
	    return typeof arg === 'string';
	  }).join(' ');
	}

/***/ },
/* 94 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initValidation = initValidation;
	exports.isFormValid = isFormValid;
	exports.assertSpec = assertSpec;
	// Returns initial status of validation data as provided by this library.
	// It is recommended (but not necessary) to keep the validation data in the app
	// state structured in the same way.
	function initValidation() {
	  return { isValid: null, error: {}, show: false };
	}
	
	// Returns validity of multiple validation results. The result is false if any
	// single validation contains isValid = false, null if any validation contains
	// isValid = null (and none is false) and true otherwise. The argument
	// `validationData` should be a dict of validation results as provided by this
	// library.
	function isFormValid(validationData) {
	  var result = true;
	  for (var name in validationData) {
	    var v = validationData[name].isValid;
	    if (v === false) {
	      return false;
	    }
	    if (v == null) {
	      result = null;
	    }
	  }
	  return result;
	}
	
	function assertSpec(statement, shortMsg, received, expected) {
	  if (!statement) {
	    console.error( // eslint-disable-line no-console
	    shortMsg, '\nReceived:', received, '\nExpected:', expected);
	    throw new Error(shortMsg);
	  }
	}

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var EventPluginRegistry = __webpack_require__(164);
	var EventPluginUtils = __webpack_require__(165);
	var ReactErrorUtils = __webpack_require__(169);
	
	var accumulateInto = __webpack_require__(429);
	var forEachAccumulated = __webpack_require__(430);
	var invariant = __webpack_require__(6);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(95);
	var EventPluginUtils = __webpack_require__(165);
	
	var accumulateInto = __webpack_require__(429);
	var forEachAccumulated = __webpack_require__(430);
	var warning = __webpack_require__(14);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 97 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(37);
	
	var getEventTarget = __webpack_require__(174);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(2),__webpack_require__(1)):"function"==typeof define&&define.amd?define(["moment","react"],t):"object"==typeof exports?exports["react-moment"]=t(require("moment"),require("react")):e["react-moment"]=t(e.moment,e.react)}(this,function(e,t){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=6)}([function(e,t,n){e.exports=n(3)()},function(t,n){t.exports=e},function(e,n){e.exports=t},function(e,t,n){"use strict";var r=n(4);function o(){}function i(){}i.resetWarningCache=o,e.exports=function(){function e(e,t,n,o,i,a){if(a!==r){var l=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw l.name="Invariant Violation",l}}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:i,resetWarningCache:o};return n.PropTypes=n,n}},function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,n){var r,o,i,a,l;
	/*! Moment Duration Format v2.2.2
	 *  https://github.com/jsmreese/moment-duration-format
	 *  Date: 2018-02-16
	 *
	 *  Duration format plugin function for the Moment.js library
	 *  http://momentjs.com/
	 *
	 *  Copyright 2018 John Madhavan-Reese
	 *  Released under the MIT license
	 */
	/*! Moment Duration Format v2.2.2
	 *  https://github.com/jsmreese/moment-duration-format
	 *  Date: 2018-02-16
	 *
	 *  Duration format plugin function for the Moment.js library
	 *  http://momentjs.com/
	 *
	 *  Copyright 2018 John Madhavan-Reese
	 *  Released under the MIT license
	 */
	a=this,l=function(e){var t=!1,n=!1,r="escape years months weeks days hours minutes seconds milliseconds general".split(" "),o=[{type:"seconds",targets:[{type:"minutes",value:60},{type:"hours",value:3600},{type:"days",value:86400},{type:"weeks",value:604800},{type:"months",value:2678400},{type:"years",value:31536e3}]},{type:"minutes",targets:[{type:"hours",value:60},{type:"days",value:1440},{type:"weeks",value:10080},{type:"months",value:44640},{type:"years",value:525600}]},{type:"hours",targets:[{type:"days",value:24},{type:"weeks",value:168},{type:"months",value:744},{type:"years",value:8760}]},{type:"days",targets:[{type:"weeks",value:7},{type:"months",value:31},{type:"years",value:365}]},{type:"months",targets:[{type:"years",value:12}]}];function i(e,t){return!(t.length>e.length)&&-1!==e.indexOf(t)}function a(e){for(var t="";e;)t+="0",e-=1;return t}function l(e,t,r){var o,i,u,s=t.useToLocaleString,c=t.useGrouping,m=c&&t.grouping.slice(),f=t.maximumSignificantDigits,p=t.minimumIntegerDigits||1,g=t.fractionDigits||0,y=t.groupingSeparator,h=t.decimalSeparator;if(s&&r){var d={minimumIntegerDigits:p,useGrouping:c};if(g&&(d.maximumFractionDigits=g,d.minimumFractionDigits=g),f&&e>0&&(d.maximumSignificantDigits=f),!n){var v=w({},t);v.useGrouping=!1,v.decimalSeparator=".",e=parseFloat(l(e,v),10)}return e.toLocaleString(r,d)}var b=(f?e.toPrecision(f+1):e.toFixed(g+1)).split("e");u=b[1]||"",i=(b=b[0].split("."))[1]||"";var S=(o=b[0]||"").length,T=i.length,_=S+T,x=o+i;(f&&_===f+1||!f&&T===g+1)&&((x=function(e){for(var t=e.split("").reverse(),n=0,r=!0;r&&n<t.length;)n?"9"===t[n]?t[n]="0":(t[n]=(parseInt(t[n],10)+1).toString(),r=!1):(parseInt(t[n],10)<5&&(r=!1),t[n]="0"),n+=1;return r&&t.push("1"),t.reverse().join("")}(x)).length===_+1&&(S+=1),T&&(x=x.slice(0,-1)),o=x.slice(0,S),i=x.slice(S)),f&&(i=i.replace(/0*$/,""));var O=parseInt(u,10);O>0?i.length<=O?(o+=i+=a(O-i.length),i=""):(o+=i.slice(0,O),i=i.slice(O)):O<0&&(i=a(Math.abs(O)-o.length)+o+i,o="0"),f||((i=i.slice(0,g)).length<g&&(i+=a(g-i.length)),o.length<p&&(o=a(p-o.length)+o));var V,D="";if(c)for(b=o;b.length;)m.length&&(V=m.shift()),D&&(D=y+D),D=b.slice(-V)+D,b=b.slice(0,-V);else D=o;return i&&(D=D+h+i),D}function u(e,t){return e.label.length>t.label.length?-1:e.label.length<t.label.length?1:0}var s,c={durationLabelsStandard:{S:"millisecond",SS:"milliseconds",s:"second",ss:"seconds",m:"minute",mm:"minutes",h:"hour",hh:"hours",d:"day",dd:"days",w:"week",ww:"weeks",M:"month",MM:"months",y:"year",yy:"years"},durationLabelsShort:{S:"msec",SS:"msecs",s:"sec",ss:"secs",m:"min",mm:"mins",h:"hr",hh:"hrs",d:"dy",dd:"dys",w:"wk",ww:"wks",M:"mo",MM:"mos",y:"yr",yy:"yrs"},durationTimeTemplates:{HMS:"h:mm:ss",HM:"h:mm",MS:"m:ss"},durationLabelTypes:[{type:"standard",string:"__"},{type:"short",string:"_"}],durationPluralKey:function(e,t,n){return 1===t&&null===n?e:e+e}};function m(e){return"[object Array]"===Object.prototype.toString.call(e)}function f(e){return"[object Object]"===Object.prototype.toString.call(e)}function p(e,t){var n,r=0,o=e&&e.length||0;for("function"!=typeof t&&(n=t,t=function(e){return e===n});r<o;){if(t(e[r]))return e[r];r+=1}}function g(e,t){var n=0,r=e.length;if(e&&r)for(;n<r;){if(!1===t(e[n],n))return;n+=1}}function y(e,t){var n=0,r=e.length,o=[];if(!e||!r)return o;for(;n<r;)o[n]=t(e[n],n),n+=1;return o}function h(e,t){return y(e,function(e){return e[t]})}function d(e){var t=[];return g(e,function(e){e&&t.push(e)}),t}function v(e){var t=[];return g(e,function(e){p(t,e)||t.push(e)}),t}function b(e,t){var n=[];return g(e,function(e){g(t,function(t){e===t&&n.push(e)})}),v(n)}function S(e,t){var n=[];return g(e,function(r,o){if(!t(r))return n=e.slice(o),!1}),n}function w(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n]);return e}function T(e){var t=[];for(var n in e)e.hasOwnProperty(n)&&t.push(n);return t}function _(e,t){var n=0,r=e.length;if(!e||!r)return!1;for(;n<r;){if(!0===t(e[n],n))return!0;n+=1}return!1}function x(){var e,t=[].slice.call(arguments),n={};if(g(t,function(t,r){if(!r){if(!m(t))throw"Expected array as the first argument to durationsFormat.";e=t}"string"!=typeof t&&"function"!=typeof t?"number"!=typeof t?f(t)&&w(n,t):n.precision=t:n.template=t}),!e||!e.length)return[];n.returnMomentTypes=!0;var o,i=y(e,function(e){return e.format(n)}),a=b(r,v(h((o=[],g(i,function(e){o=o.concat(e)}),o),"type"))),l=n.largest;return l&&(a=a.slice(0,l)),n.returnMomentTypes=!1,n.outputTypes=a,y(e,function(e){return e.format(n)})}function O(){var n=[].slice.call(arguments),a=w({},this.format.defaults),s=this.asMilliseconds(),x=this.asMonths();"function"==typeof this.isValid&&!1===this.isValid()&&(s=0,x=0);var O=s<0,V=e.duration(Math.abs(s),"milliseconds"),D=e.duration(Math.abs(x),"months");g(n,function(e){"string"!=typeof e&&"function"!=typeof e?"number"!=typeof e?f(e)&&w(a,e):a.precision=e:a.template=e});var L={years:"y",months:"M",weeks:"w",days:"d",hours:"h",minutes:"m",seconds:"s",milliseconds:"S"},j={escape:/\[(.+?)\]/,years:/\*?[Yy]+/,months:/\*?M+/,weeks:/\*?[Ww]+/,days:/\*?[Dd]+/,hours:/\*?[Hh]+/,minutes:/\*?m+/,seconds:/\*?s+/,milliseconds:/\*?S+/,general:/.+?/};a.types=r;var M=function(e){return p(r,function(t){return j[t].test(e)})},k=new RegExp(y(r,function(e){return j[e].source}).join("|"),"g");a.duration=this;var P="function"==typeof a.template?a.template.apply(a):a.template,E=a.outputTypes,F=a.returnMomentTypes,I=a.largest,C=[];E||(m(a.stopTrim)&&(a.stopTrim=a.stopTrim.join("")),a.stopTrim&&g(a.stopTrim.match(k),function(e){var t=M(e);"escape"!==t&&"general"!==t&&C.push(t)}));var N=e.localeData();N||(N={}),g(T(c),function(e){"function"!=typeof c[e]?N["_"+e]||(N["_"+e]=c[e]):N[e]||(N[e]=c[e])}),g(T(N._durationTimeTemplates),function(e){P=P.replace("_"+e+"_",N._durationTimeTemplates[e])});var G=a.userLocale||e.locale(),R=a.useLeftUnits,U=a.usePlural,q=a.precision,z=a.forceLength,H=a.useGrouping,W=a.trunc,$=a.useSignificantDigits&&q>0,A=$?a.precision:0,B=A,K=a.minValue,Y=!1,J=a.maxValue,Q=!1,X=a.useToLocaleString,Z=a.groupingSeparator,ee=a.decimalSeparator,te=a.grouping;X=X&&t;var ne=a.trim;m(ne)&&(ne=ne.join(" ")),null===ne&&(I||J||$)&&(ne="all"),null!==ne&&!0!==ne&&"left"!==ne&&"right"!==ne||(ne="large"),!1===ne&&(ne="");var re=function(e){return e.test(ne)},oe=/both/,ie=/^all|[^sm]all/,ae=I>0||_([/large/,oe,ie],re),le=_([/small/,oe,ie],re),ue=_([/mid/,ie],re),se=_([/final/,ie],re),ce=y(P.match(k),function(e,t){var n=M(e);return"*"===e.slice(0,1)&&(e=e.slice(1),"escape"!==n&&"general"!==n&&C.push(n)),{index:t,length:e.length,text:"",token:"escape"===n?e.replace(j.escape,"$1"):e,type:"escape"===n||"general"===n?null:n}}),me={index:0,length:0,token:"",text:"",type:null},fe=[];R&&ce.reverse(),g(ce,function(e){if(e.type)return(me.type||me.text)&&fe.push(me),void(me=e);R?me.text=e.token+me.text:me.text+=e.token}),(me.type||me.text)&&fe.push(me),R&&fe.reverse();var pe=b(r,v(d(h(fe,"type"))));if(!pe.length)return h(fe,"text").join("");pe=y(pe,function(e,t){var n,r=t+1===pe.length,o=!t;n="years"===e||"months"===e?D.as(e):V.as(e);var i=Math.floor(n),l=n-i,u=p(fe,function(t){return e===t.type});return o&&J&&n>J&&(Q=!0),r&&K&&Math.abs(a.duration.as(e))<K&&(Y=!0),o&&null===z&&u.length>1&&(z=!0),V.subtract(i,e),D.subtract(i,e),{rawValue:n,wholeValue:i,decimalValue:r?l:0,isSmallest:r,isLargest:o,type:e,tokenLength:u.length}});var ge,ye=W?Math.floor:Math.round,he=function(e,t){var n=Math.pow(10,t);return ye(e*n)/n},de=!1,ve=!1,be=function(e,t){var n={useGrouping:H,groupingSeparator:Z,decimalSeparator:ee,grouping:te,useToLocaleString:X};return $&&(A<=0?(e.rawValue=0,e.wholeValue=0,e.decimalValue=0):(n.maximumSignificantDigits=A,e.significantDigits=A)),Q&&!ve&&(e.isLargest?(e.wholeValue=J,e.decimalValue=0):(e.wholeValue=0,e.decimalValue=0)),Y&&!ve&&(e.isSmallest?(e.wholeValue=K,e.decimalValue=0):(e.wholeValue=0,e.decimalValue=0)),e.isSmallest||e.significantDigits&&e.significantDigits-e.wholeValue.toString().length<=0?q<0?e.value=he(e.wholeValue,q):0===q?e.value=ye(e.wholeValue+e.decimalValue):$?(e.value=W?he(e.rawValue,A-e.wholeValue.toString().length):e.rawValue,e.wholeValue&&(A-=e.wholeValue.toString().length)):(n.fractionDigits=q,e.value=W?e.wholeValue+he(e.decimalValue,q):e.wholeValue+e.decimalValue):$&&e.wholeValue?(e.value=Math.round(he(e.wholeValue,e.significantDigits-e.wholeValue.toString().length)),A-=e.wholeValue.toString().length):e.value=e.wholeValue,e.tokenLength>1&&(z||de)&&(n.minimumIntegerDigits=e.tokenLength,ve&&n.maximumSignificantDigits<e.tokenLength&&delete n.maximumSignificantDigits),!de&&(e.value>0||""===ne||p(C,e.type)||p(E,e.type))&&(de=!0),e.formattedValue=l(e.value,n,G),n.useGrouping=!1,n.decimalSeparator=".",e.formattedValueEn=l(e.value,n,"en"),2===e.tokenLength&&"milliseconds"===e.type&&(e.formattedValueMS=l(e.value,{minimumIntegerDigits:3,useGrouping:!1},"en").slice(0,2)),e};if((pe=d(pe=y(pe,be))).length>1){var Se=function(e){return p(pe,function(t){return t.type===e})};g(o,function(e){var t=Se(e.type);t&&g(e.targets,function(e){var n=Se(e.type);n&&parseInt(t.formattedValueEn,10)===e.value&&(t.rawValue=0,t.wholeValue=0,t.decimalValue=0,n.rawValue+=1,n.wholeValue+=1,n.decimalValue=0,n.formattedValueEn=n.wholeValue.toString(),ve=!0)})})}return ve&&(de=!1,A=B,pe=d(pe=y(pe,be))),!E||Q&&!a.trim?(ae&&(pe=S(pe,function(e){return!e.isSmallest&&!e.wholeValue&&!p(C,e.type)})),I&&pe.length&&(pe=pe.slice(0,I)),le&&pe.length>1&&(ge=function(e){return!e.wholeValue&&!p(C,e.type)&&!e.isLargest},pe=S(pe.slice().reverse(),ge).reverse()),ue&&(pe=d(pe=y(pe,function(e,t){return t>0&&t<pe.length-1&&!e.wholeValue?null:e}))),!se||1!==pe.length||pe[0].wholeValue||!W&&pe[0].isSmallest&&pe[0].rawValue<K||(pe=[])):pe=d(pe=y(pe,function(e){return p(E,function(t){return e.type===t})?e:null})),F?pe:(g(fe,function(e){var t=L[e.type],n=p(pe,function(t){return t.type===e.type});if(t&&n){var r=n.formattedValueEn.split(".");r[0]=parseInt(r[0],10),r[1]?r[1]=parseFloat("0."+r[1],10):r[1]=null;var o=N.durationPluralKey(t,r[0],r[1]),a=function(e,t){var n=[];return g(T(t),function(r){if("_durationLabels"===r.slice(0,15)){var o=r.slice(15).toLowerCase();g(T(t[r]),function(i){i.slice(0,1)===e&&n.push({type:o,key:i,label:t[r][i]})})}}),n}(t,N),l=!1,s={};g(N._durationLabelTypes,function(t){var n=p(a,function(e){return e.type===t.type&&e.key===o});n&&(s[n.type]=n.label,i(e.text,t.string)&&(e.text=e.text.replace(t.string,n.label),l=!0))}),U&&!l&&(a.sort(u),g(a,function(t){return s[t.type]===t.label?!i(e.text,t.label)&&void 0:i(e.text,t.label)?(e.text=e.text.replace(t.label,s[t.type]),!1):void 0}))}}),(fe=y(fe,function(e){if(!e.type)return e.text;var t=p(pe,function(t){return t.type===e.type});if(!t)return"";var n="";return R&&(n+=e.text),(O&&Q||!O&&Y)&&(n+="< ",Q=!1,Y=!1),(O&&Y||!O&&Q)&&(n+="> ",Q=!1,Y=!1),O&&(t.value>0||""===ne||p(C,t.type)||p(E,t.type))&&(n+="-",O=!1),"milliseconds"===e.type&&t.formattedValueMS?n+=t.formattedValueMS:n+=t.formattedValue,R||(n+=e.text),n})).join("").replace(/(,| |:|\.)*$/,"").replace(/^(,| |:|\.)*/,""))}function V(){var e=this.duration,t=function(t){return e._data[t]},n=p(this.types,t),r=function(e,t){for(var n=e.length;n-=1;)if(t(e[n]))return e[n]}(this.types,t);switch(n){case"milliseconds":return"S __";case"seconds":case"minutes":return"*_MS_";case"hours":return"_HMS_";case"days":if(n===r)return"d __";case"weeks":return n===r?"w __":(null===this.trim&&(this.trim="both"),"w __, d __, h __");case"months":if(n===r)return"M __";case"years":return n===r?"y __":(null===this.trim&&(this.trim="both"),"y __, M __, d __");default:return null===this.trim&&(this.trim="both"),"y __, d __, h __, m __, s __"}}function D(e){if(!e)throw"Moment Duration Format init cannot find moment instance.";e.duration.format=x,e.duration.fn.format=O,e.duration.fn.format.defaults={trim:null,stopTrim:null,largest:null,maxValue:null,minValue:null,precision:0,trunc:!1,forceLength:null,userLocale:null,usePlural:!0,useLeftUnits:!1,useGrouping:!0,useSignificantDigits:!1,template:V,useToLocaleString:!0,groupingSeparator:",",decimalSeparator:".",grouping:[3]},e.updateLocale("en",c)}return t=!!((s=(s=!0)&&function(){try{(0).toLocaleString("i")}catch(e){return"RangeError"===e.name}return!1}())&&(s=(s=(s=s&&"1"===1..toLocaleString("en",{minimumIntegerDigits:1}))&&"01"===1..toLocaleString("en",{minimumIntegerDigits:2}))&&"001"===1..toLocaleString("en",{minimumIntegerDigits:3}))&&(s=(s=(s=(s=s&&"100"===99.99.toLocaleString("en",{maximumFractionDigits:0,minimumFractionDigits:0}))&&"100.0"===99.99.toLocaleString("en",{maximumFractionDigits:1,minimumFractionDigits:1}))&&"99.99"===99.99.toLocaleString("en",{maximumFractionDigits:2,minimumFractionDigits:2}))&&"99.990"===99.99.toLocaleString("en",{maximumFractionDigits:3,minimumFractionDigits:3}))&&(s=(s=(s=(s=(s=s&&"100"===99.99.toLocaleString("en",{maximumSignificantDigits:1}))&&"100"===99.99.toLocaleString("en",{maximumSignificantDigits:2}))&&"100"===99.99.toLocaleString("en",{maximumSignificantDigits:3}))&&"99.99"===99.99.toLocaleString("en",{maximumSignificantDigits:4}))&&"99.99"===99.99.toLocaleString("en",{maximumSignificantDigits:5}))&&(s=(s=s&&"1,000"===1e3.toLocaleString("en",{useGrouping:!0}))&&"1000"===1e3.toLocaleString("en",{useGrouping:!1}))),n=t&&"3.6"===3.55.toLocaleString("en",{useGrouping:!1,minimumIntegerDigits:1,minimumFractionDigits:1,maximumFractionDigits:1}),D(e),D},o=[n(1)],void 0===(i="function"==typeof(r=l)?r.apply(t,o):r)||(e.exports=i),a&&(a.momentDurationFormatSetup=a.moment?l(a.moment):l)},function(e,t,n){"use strict";n.r(t);var r=n(2),o=n.n(r),i=n(0),a=n.n(i),l=n(1),u=n.n(l);n(5);function s(e){return(s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function c(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}function m(e){return(m=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function f(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function p(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function g(e,t,n){return t&&p(e.prototype,t),n&&p(e,n),e}function y(e,t){return(y=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function h(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}n.d(t,"default",function(){return S});var d=[a.a.string,a.a.number,a.a.array,a.a.object],v=[a.a.string,a.a.array],b=[a.a.object,a.a.bool],S=function(e){function t(e){var n,r,o;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),r=this,o=m(t).call(this,e),n=!o||"object"!==s(o)&&"function"!=typeof o?f(r):o,h(f(n),"setTimer",function(){var e=n.props.interval;n.clearTimer(),t.pooledTimer||0===e||(n.timer=setInterval(function(){n.update(n.props)},e))}),h(f(n),"getTitle",function(){var e=n.props.titleFormat,r=t.getDatetime(n.props),o=e||t.globalFormat;return r.format(o)}),h(f(n),"clearTimer",function(){!t.pooledTimer&&n.timer&&(clearInterval(n.timer),n.timer=null),t.pooledTimer&&!n.timer&&t.removePooledElement(f(n))}),t.globalMoment||(t.globalMoment=u.a),n.state={content:""},n.timer=null,n}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&y(e,t)}(t,o.a.Component),g(t,null,[{key:"startPooledTimer",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:6e4;t.clearPooledTimer(),t.pooledTimer=setInterval(function(){t.pooledElements.forEach(function(e){0!==e.props.interval&&e.update()})},e)}},{key:"clearPooledTimer",value:function(){t.pooledTimer&&(clearInterval(t.pooledTimer),t.pooledTimer=null,t.pooledElements=[])}},{key:"pushPooledElement",value:function(e){e instanceof t?-1===t.pooledElements.indexOf(e)&&t.pooledElements.push(e):console.error("Element not an instance of Moment.")}},{key:"removePooledElement",value:function(e){var n=t.pooledElements.indexOf(e);-1!==n&&t.pooledElements.splice(n,1)}},{key:"getDatetime",value:function(e){var n=e.utc,r=e.unix,o=e.date,i=e.locale,a=e.parse,l=e.tz,u=e.local;o=o||e.children,a=a||t.globalParse,u=u||t.globalLocal,l=l||t.globalTimezone,i=t.globalLocale?t.globalLocale:i||t.globalMoment.locale();var s=null;return s=n?t.globalMoment.utc(o,a,i):r?t.globalMoment(1e3*o,a,i):t.globalMoment(o,a,i),l?s=s.tz(l):u&&(s=s.local()),s}},{key:"getContent",value:function(e){var n=e.fromNow,r=e.fromNowDuring,o=e.from,i=e.add,a=e.subtract,l=e.toNow,s=e.to,c=e.ago,m=e.calendar,f=e.diff,p=e.duration,g=e.durationFromNow,y=e.unit,h=e.decimal,d=e.format;d=d||t.globalFormat;var v=t.getDatetime(e);i&&v.add(i),a&&v.subtract(a);var b=Boolean(r)&&-v.diff(u()())<r,S="";return S=d&&!b?v.format(d):o?v.from(o,c):n||b?v.fromNow(c):s?v.to(s,c):l?v.toNow(c):m?v.calendar(null,m):f?v.diff(f,y,h):p?v.diff(p):g?u()().diff(v):v.toString(),(p||g)&&(S=(S=u.a.duration(S)).format(d)),S=(t.globalFilter||e.filter)(S)}}]),g(t,[{key:"componentDidMount",value:function(){this.setTimer(),t.pooledTimer&&t.pushPooledElement(this)}},{key:"componentDidUpdate",value:function(e){var t=this.props.interval;e.interval!==t&&this.setTimer()}},{key:"componentWillUnmount",value:function(){this.clearTimer()}},{key:"update",value:function(e){var n=e||this.props,r=n.onChange,o=t.getContent(n);this.setState({content:o},function(){r(o)})}},{key:"render",value:function(){var e,n,r,i,a=this.props,l=a.withTitle,u=a.element,s=c(a,["withTitle","element"]),m=this.state.content,f=(e=s,n=t.propTypes,r=Object.keys(n),i=Object.assign({},e),Object.keys(i).filter(function(e){return-1!==r.indexOf(e)}).forEach(function(e){return delete i[e]}),i);return l&&(f.title=this.getTitle()),o.a.createElement(u||t.globalElement,function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{},r=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(r=r.concat(Object.getOwnPropertySymbols(n).filter(function(e){return Object.getOwnPropertyDescriptor(n,e).enumerable}))),r.forEach(function(t){h(e,t,n[t])})}return e}({dateTime:t.getDatetime(this.props)},f),m)}}],[{key:"getDerivedStateFromProps",value:function(e){return{content:t.getContent(e)}}}]),t}();h(S,"propTypes",{element:a.a.any,date:a.a.oneOfType(d),parse:a.a.oneOfType(v),format:a.a.string,add:a.a.object,subtract:a.a.object,ago:a.a.bool,fromNow:a.a.bool,fromNowDuring:a.a.number,from:a.a.oneOfType(d),toNow:a.a.bool,to:a.a.oneOfType(d),calendar:a.a.oneOfType(b),unix:a.a.bool,utc:a.a.bool,local:a.a.bool,tz:a.a.string,withTitle:a.a.bool,titleFormat:a.a.string,locale:a.a.string,interval:a.a.number,diff:a.a.oneOfType(d),duration:a.a.oneOfType(d),durationFromNow:a.a.bool,unit:a.a.string,decimal:a.a.bool,filter:a.a.func,onChange:a.a.func}),h(S,"defaultProps",{element:null,fromNow:!1,toNow:!1,calendar:!1,ago:!1,unix:!1,utc:!1,local:!1,unit:null,withTitle:!1,decimal:!1,titleFormat:"",interval:6e4,filter:function(e){return e},onChange:function(){}}),h(S,"globalMoment",null),h(S,"globalLocale",null),h(S,"globalLocal",null),h(S,"globalFormat",null),h(S,"globalParse",null),h(S,"globalFilter",null),h(S,"globalElement","time"),h(S,"globalTimezone",null),h(S,"pooledElements",[]),h(S,"pooledTimer",null)}])});

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func,
	    object = _react.PropTypes.object,
	    arrayOf = _react.PropTypes.arrayOf,
	    oneOfType = _react.PropTypes.oneOfType,
	    element = _react.PropTypes.element,
	    shape = _react.PropTypes.shape,
	    string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hasOwnProperty = __webpack_require__(923);
	
	var _hasOwnProperty2 = _interopRequireDefault(_hasOwnProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateLocales = {
	  de: {
	    months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan_Feb_März_Apr_Mai_Juni_Juli_Aug_Sept_Okt_Nov_Dez'.split('_'),
	    weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysLetter: 'S_M_D_M_D_F_S'.split('_')
	  },
	  no: {
	    months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort: 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysLetter: []
	  },
	  en: {
	    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysLetter: []
	  },
	  es: {
	    months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort: 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	    weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysLetter: 'D_L_M_X_J_V_S'.split('_')
	  },
	  af: {
	    months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysLetter: []
	  },
	  ar: {
	    months: ['كانون الثاني يناير', 'شباط فبراير', 'آذار مارس', 'نيسان أبريل', 'أيار مايو', 'حزيران يونيو', 'تموز يوليو', 'آب أغسطس', 'أيلول سبتمبر', 'تشرين الأول أكتوبر', 'تشرين الثاني نوفمبر', 'كانون الأول ديسمبر'],
	    monthsShort: ['كانون الثاني يناير', 'شباط فبراير', 'آذار مارس', 'نيسان أبريل', 'أيار مايو', 'حزيران يونيو', 'تموز يوليو', 'آب أغسطس', 'أيلول سبتمبر', 'تشرين الأول أكتوبر', 'تشرين الثاني نوفمبر', 'كانون الأول ديسمبر'],
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysLetter: []
	  },
	  be: {
	    months: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_'),
	    monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	    weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysLetter: []
	  },
	  bg: {
	    months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort: 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysLetter: []
	  },
	  bn: {
	    months: 'জানুয়ারী_ফেবুয়ারী_মার্চ_এপ্রিল_মে_জুন_জুলাই_অগাস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort: 'জানু_ফেব_মার্চ_এপর_মে_জুন_জুল_অগ_সেপ্ট_অক্টো_নভ_ডিসেম্'.split('_'),
	    weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পত্তিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পত্তি_শুক্র_শনি'.split('_'),
	    weekdaysLetter: []
	  },
	  bo: {
	    months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysLetter: []
	  },
	  br: {
	    months: 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort: 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays: 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysLetter: []
	  },
	  bs: {
	    months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysLetter: []
	  },
	  ca: {
	    months: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	    monthsShort: 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	    weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysLetter: 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_')
	  },
	  gl: {
	    months: 'Xaneiro_Febreiro_Marzo_Abril_Maio_Xuño_Xullo_Agosto_Setembro_Outubro_Novembro_Decembro'.split('_'),
	    monthsShort: 'Xan._Feb._Mar._Abr._Mai._Xuñ._Xul._Ago._Set._Out._Nov._Dec.'.split('_'),
	    weekdays: 'Domingo_Luns_Martes_Mércores_Xoves_Venres_Sábado'.split('_'),
	    weekdaysShort: 'Dom._Lun._Mar._Mér._Xov._Ven._Sáb.'.split('_'),
	    weekdaysLetter: 'Do_Lu_Ma_Mé_Xo_Ve_Sá'.split('_')
	  },
	  eu: {
	    months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysLetter: 'ig_al_ar_az_og_ol_lr'.split('_')
	  },
	  pt: {
	    months: 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays: 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysLetter: []
	  },
	  it: {
	    months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays: 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	    weekdaysShort: 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	    weekdaysLetter: []
	  },
	  fr: {
	    months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysLetter: []
	  },
	  ru: {
	    months: 'Январь_Февраль_Март_Апрель_Май_Июнь_Июль_Август_Сентябрь_Октябрь_Ноябрь_Декабрь'.split('_'),
	    monthsShort: 'Янв_Фев_Мар_Апр_Май_Июн_Июл_Авг_Сен_Окт_Ноя_Дек'.split('_'),
	    weekdays: 'Воскресенье_Понедельник_Вторник_Среда_Четверг_Пятница_Суббота'.split('_'),
	    weekdaysShort: 'Вс_Пн_Вт_Ср_Чт_Пт_Сб'.split('_'),
	    weekdaysLetter: []
	  },
	  ua: {
	    months: 'Січень_Лютий_Березень_Квітень_Травень_Червень_Липень_Серпень_Вересень_Жовтень_Листопад_Грудень'.split('_'),
	    monthsShort: 'Січ_Лют_Берез_Квіт_Трав_Черв_Лип_Серп_Верес_Жовт_Листоп_Груд'.split('_'),
	    weekdays: 'Неділя_Понеділок_Вівторок_Середа_Четвер_П’ятниця_Субота'.split('_'),
	    weekdaysShort: 'Нд_Пн_Вт_Ср_Чт_Пт_Сб'.split('_'),
	    weekdaysLetter: []
	  },
	  'zh-cn': {
	    months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysLetter: '日_一_二_三_四_五_六'.split('_')
	  },
	  'zh-hk': {
	    months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysLetter: '日_一_二_三_四_五_六'.split('_')
	  },
	  'zh-tw': {
	    months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysLetter: '日_一_二_三_四_五_六'.split('_')
	  }
	};
	
	var time = {
	  getDaysInMonth: function getDaysInMonth(d) {
	    var resultDate = this.getFirstDayOfMonth(d);
	    resultDate.setMonth(resultDate.getMonth() + 1);
	    resultDate.setDate(resultDate.getDate() - 1);
	    return resultDate.getDate();
	  },
	  getFirstDayOfMonth: function getFirstDayOfMonth(d) {
	    return new Date(d.getFullYear(), d.getMonth(), 1);
	  },
	  getFirstWeekDay: function getFirstWeekDay(d) {
	    return this.getFirstDayOfMonth(d).getDay();
	  },
	  getTimeMode: function getTimeMode(d) {
	    return d.getHours() >= 12 ? 'pm' : 'am';
	  },
	  getFullMonth: function getFullMonth(d) {
	    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	    var month = d.getMonth();
	    var l = (typeof locale === 'string' ? dateLocales[locale] : locale) || dateLocales.en;
	    return (0, _hasOwnProperty2.default)(l, 'months') ? l.months[month] || 'Unknown' : 'Unknown';
	  },
	  getShortMonth: function getShortMonth(d) {
	    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	    var month = d.getMonth();
	    var l = (typeof locale === 'string' ? dateLocales[locale] : locale) || dateLocales.en;
	    return (0, _hasOwnProperty2.default)(l, 'monthsShort') ? l.monthsShort[month] || 'Unknown' : 'Unknown';
	  },
	  getFullDayOfWeek: function getFullDayOfWeek(day) {
	    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	    var l = (typeof locale === 'string' ? dateLocales[locale] : locale) || dateLocales.en;
	    return (0, _hasOwnProperty2.default)(l, 'weekdays') ? l.weekdays[day] || 'Unknown' : 'Unknown';
	  },
	  getShortDayOfWeek: function getShortDayOfWeek(day) {
	    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	    var l = (typeof locale === 'string' ? dateLocales[locale] : locale) || dateLocales.en;
	    return (0, _hasOwnProperty2.default)(l, 'weekdaysShort') ? l.weekdaysShort[day] || 'Unknown' : 'Unknown';
	  },
	  getDayOfWeekLetter: function getDayOfWeekLetter(day) {
	    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	    var l = (typeof locale === 'string' ? dateLocales[locale] : locale) || dateLocales.en;
	    return (0, _hasOwnProperty2.default)(l, 'weekdaysLetter') ? l.weekdaysLetter[day] || this.getFullDayOfWeek(day, locale).charAt(0) : 'Unknown';
	  },
	  clone: function clone(d) {
	    return new Date(d.getTime());
	  },
	  cloneAsDate: function cloneAsDate(d) {
	    var clonedDate = this.clone(d);
	    clonedDate.setHours(0, 0, 0, 0);
	    return clonedDate;
	  },
	  isDateObject: function isDateObject(d) {
	    return d instanceof Date;
	  },
	  addDays: function addDays(d, days) {
	    var newDate = this.clone(d);
	    newDate.setDate(d.getDate() + days);
	    return newDate;
	  },
	  addMonths: function addMonths(d, months) {
	    var newDate = this.clone(d);
	    newDate.setMonth(d.getMonth() + months, 1);
	    return newDate;
	  },
	  addYears: function addYears(d, years) {
	    var newDate = this.clone(d);
	    newDate.setFullYear(d.getFullYear() + years);
	    return newDate;
	  },
	  setDay: function setDay(d, day) {
	    var newDate = this.clone(d);
	    newDate.setDate(day);
	    return newDate;
	  },
	  setMonth: function setMonth(d, month) {
	    var newDate = this.clone(d);
	    newDate.setMonth(month);
	    return newDate;
	  },
	  setYear: function setYear(d, year) {
	    var newDate = this.clone(d);
	    newDate.setFullYear(year);
	    return newDate;
	  },
	  setHours: function setHours(d, hours) {
	    var newDate = this.clone(d);
	    newDate.setHours(hours);
	    return newDate;
	  },
	  setMinutes: function setMinutes(d, minutes) {
	    var newDate = this.clone(d);
	    newDate.setMinutes(minutes);
	    return newDate;
	  },
	  toggleTimeMode: function toggleTimeMode(d) {
	    var newDate = this.clone(d);
	    var hours = newDate.getHours();
	
	    newDate.setHours(hours - (hours > 12 ? -12 : 12));
	    return newDate;
	  },
	  formatTime: function formatTime(date, format) {
	    var hours = date.getHours();
	    var mins = date.getMinutes().toString();
	
	    if (format === 'ampm') {
	      var isAM = hours < 12;
	      var additional = isAM ? ' am' : ' pm';
	
	      hours %= 12;
	      hours = (hours || 12).toString();
	      if (mins.length < 2) mins = '0' + mins;
	
	      return hours + (mins === '00' ? '' : ':' + mins) + additional;
	    }
	
	    hours = hours.toString();
	    if (hours.length < 2) hours = '0' + hours;
	    if (mins.length < 2) mins = '0' + mins;
	    return hours + ':' + mins;
	  },
	  dateOutOfRange: function dateOutOfRange(date, minDate, maxDate) {
	    return minDate && !(date >= minDate) || maxDate && !(date <= maxDate);
	  },
	  closestDate: function closestDate(to, date1, date2) {
	    var toTime = to.getTime();
	
	    var diff1 = Math.abs(toTime - date1.getTime());
	    var diff2 = Math.abs(toTime - date2.getTime());
	
	    return diff1 < diff2 ? date1 : date2;
	  },
	  formatDate: function formatDate(date) {
	    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	    if (locale === 'en') {
	      return date.getDate() + ' ' + time.getFullMonth(date, locale) + ' ' + date.getFullYear();
	    }
	    return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
	  }
	};
	
	exports.default = time;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var config = __webpack_require__(7);
	var APPID = config.ids.appId;
	
	var Distancebar = function (_React$Component) {
	  _inherits(Distancebar, _React$Component);
	
	  function Distancebar(props) {
	    _classCallCheck(this, Distancebar);
	
	    return _possibleConstructorReturn(this, (Distancebar.__proto__ || Object.getPrototypeOf(Distancebar)).call(this, props));
	  }
	
	  _createClass(Distancebar, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          distance = _props.distance,
	          tat = _props.tat,
	          minDateValue = _props.minDateValue;
	
	      return _react2.default.createElement(
	        "p",
	        { className: "map-sub" },
	        distance && _react2.default.createElement(
	          "span",
	          null,
	          _react2.default.createElement("img", { src: "/img/icons/location.svg", className: "icon-img-small" }),
	          distance ? distance + " km" : "-"
	        ),
	        APPID !== "D89F3695-82D5-4105-991A-7A373AEBEABF" && _react2.default.createElement(
	          "span",
	          null,
	          _react2.default.createElement("img", { src: "/img/icons/calendar.svg", className: "icon-img-small" }),
	          (0, _moment2.default)().add(minDateValue, 'day').format("DD-MM-YYYY")
	        ),
	        tat && APPID !== "D89F3695-82D5-4105-991A-7A373AEBEABF" && _react2.default.createElement(
	          "span",
	          null,
	          _react2.default.createElement("img", { src: "/img/icons/clock.svg", className: "icon-img-small" }),
	          tat + " mins"
	        )
	      );
	    }
	  }]);
	
	  return Distancebar;
	}(_react2.default.Component);
	
	exports.default = Distancebar;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HtmlToReactParser = __webpack_require__(21).Parser;
	var htmlToReactParser = new HtmlToReactParser();
	var lang = __webpack_require__(12);
	
	var Outletclosedmessage = function (_React$Component) {
	  _inherits(Outletclosedmessage, _React$Component);
	
	  function Outletclosedmessage(props) {
	    _classCallCheck(this, Outletclosedmessage);
	
	    return _possibleConstructorReturn(this, (Outletclosedmessage.__proto__ || Object.getPrototypeOf(Outletclosedmessage)).call(this, props));
	  }
	
	  _createClass(Outletclosedmessage, [{
	    key: 'render',
	    value: function render() {
	      var messages = this.props.messages;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'no_outlet_msg' },
	        ' ',
	        _react2.default.createElement(
	          'h4',
	          null,
	          ' ',
	          messages === "" ? lang.outlet_closed_message : htmlToReactParser.parse(messages)
	        ),
	        ' '
	      );
	    }
	  }]);
	
	  return Outletclosedmessage;
	}(_react2.default.Component);
	
	exports.default = Outletclosedmessage;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(542);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 105 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 106 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 107 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 108 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(385);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var defineDataProperty = __webpack_require__(593);
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var supportsDescriptors = __webpack_require__(238)();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object) {
			if (predicate === true) {
				if (object[name] === value) {
					return;
				}
			} else if (!isFunction(predicate) || !predicate()) {
				return;
			}
		}
	
		if (supportsDescriptors) {
			defineDataProperty(object, name, value, true);
		} else {
			defineDataProperty(object, name, value);
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ },
/* 110 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },
/* 111 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 112 */
/***/ function(module, exports) {

	module.exports = function _isPlaceholder(a) {
	  return a != null &&
	         typeof a === 'object' &&
	         a['@@functional/placeholder'] === true;
	};


/***/ },
/* 113 */
[1039, 76, 158],
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TimePicker["default"];
	  }
	});
	
	var _TimePicker = _interopRequireDefault(__webpack_require__(718));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialSubmitState = exports.initialResultsState = exports.initialFieldsState = undefined;
	exports.initialState = initialState;
	
	var _helpers = __webpack_require__(94);
	
	var initialFieldsState = exports.initialFieldsState = {
	  change: {
	    // fieldName: true if field was changed
	  },
	  blur: {},
	  submit: {},
	  isTyping: {
	    // fieldName: timestamp in millis (until when)
	  }
	};
	
	var initialResultsState = exports.initialResultsState = {};
	
	var initialSubmitState = exports.initialSubmitState = {
	  isSubmitting: false,
	  onValid: null,
	  onInvalid: null
	};
	
	function initialState(config) {
	  var validationData = {};
	  for (var name in config.validations) {
	    validationData[name] = (0, _helpers.initValidation)();
	  }
	  return {
	    fields: initialFieldsState,
	    results: initialResultsState,
	    submit: initialSubmitState,
	    validationData: validationData,
	    config: config,
	    isMounted: true
	  };
	}

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var invariant = __webpack_require__(24);
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var splice = Array.prototype.splice;
	
	var toString = Object.prototype.toString
	var type = function(obj) {
	  return toString.call(obj).slice(8, -1);
	}
	
	var assign = Object.assign || /* istanbul ignore next */ function assign(target, source) {
	  getAllKeys(source).forEach(function(key) {
	    if (hasOwnProperty.call(source, key)) {
	      target[key] = source[key];
	    }
	  });
	  return target;
	};
	
	var getAllKeys = typeof Object.getOwnPropertySymbols === 'function' ?
	  function(obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)) } :
	  /* istanbul ignore next */ function(obj) { return Object.keys(obj) };
	
	/* istanbul ignore next */
	function copy(object) {
	  if (Array.isArray(object)) {
	    return assign(object.constructor(object.length), object)
	  } else if (type(object) === 'Map') {
	    return new Map(object)
	  } else if (type(object) === 'Set') {
	    return new Set(object)
	  } else if (object && typeof object === 'object') {
	    var prototype = Object.getPrototypeOf(object);
	    return assign(Object.create(prototype), object);
	  } else {
	    return object;
	  }
	}
	
	function newContext() {
	  var commands = assign({}, defaultCommands);
	  update.extend = function(directive, fn) {
	    commands[directive] = fn;
	  };
	  update.isEquals = function(a, b) { return a === b; };
	
	  return update;
	
	  function update(object, spec) {
	    if (typeof spec === 'function') {
	      spec = { $apply: spec };
	    }
	
	    if (!(Array.isArray(object) && Array.isArray(spec))) {
	      invariant(
	        !Array.isArray(spec),
	        'update(): You provided an invalid spec to update(). The spec may ' +
	        'not contain an array except as the value of $set, $push, $unshift, ' +
	        '$splice or any custom command allowing an array value.'
	      );
	    }
	
	    invariant(
	      typeof spec === 'object' && spec !== null,
	      'update(): You provided an invalid spec to update(). The spec and ' +
	      'every included key path must be plain objects containing one of the ' +
	      'following commands: %s.',
	      Object.keys(commands).join(', ')
	    );
	
	    var nextObject = object;
	    var index, key;
	    getAllKeys(spec).forEach(function(key) {
	      if (hasOwnProperty.call(commands, key)) {
	        var objectWasNextObject = object === nextObject;
	        nextObject = commands[key](spec[key], nextObject, spec, object);
	        if (objectWasNextObject && update.isEquals(nextObject, object)) {
	          nextObject = object;
	        }
	      } else {
	        var nextValueForKey =
	          type(object) === 'Map'
	            ? update(object.get(key), spec[key])
	            : update(object[key], spec[key]);
	        var nextObjectValue =
	          type(nextObject) === 'Map'
	              ? nextObject.get(key)
	              : nextObject[key];
	        if (!update.isEquals(nextValueForKey, nextObjectValue) || typeof nextValueForKey === 'undefined' && !hasOwnProperty.call(object, key)) {
	          if (nextObject === object) {
	            nextObject = copy(object);
	          }
	          if (type(nextObject) === 'Map') {
	            nextObject.set(key, nextValueForKey);
	          } else {
	            nextObject[key] = nextValueForKey;
	          }
	        }
	      }
	    })
	    return nextObject;
	  }
	
	}
	
	var defaultCommands = {
	  $push: function(value, nextObject, spec) {
	    invariantPushAndUnshift(nextObject, spec, '$push');
	    return value.length ? nextObject.concat(value) : nextObject;
	  },
	  $unshift: function(value, nextObject, spec) {
	    invariantPushAndUnshift(nextObject, spec, '$unshift');
	    return value.length ? value.concat(nextObject) : nextObject;
	  },
	  $splice: function(value, nextObject, spec, originalObject) {
	    invariantSplices(nextObject, spec);
	    value.forEach(function(args) {
	      invariantSplice(args);
	      if (nextObject === originalObject && args.length) nextObject = copy(originalObject);
	      splice.apply(nextObject, args);
	    });
	    return nextObject;
	  },
	  $set: function(value, nextObject, spec) {
	    invariantSet(spec);
	    return value;
	  },
	  $toggle: function(targets, nextObject) {
	    invariantSpecArray(targets, '$toggle');
	    var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;
	
	    targets.forEach(function(target) {
	      nextObjectCopy[target] = !nextObject[target];
	    });
	
	    return nextObjectCopy;
	  },
	  $unset: function(value, nextObject, spec, originalObject) {
	    invariantSpecArray(value, '$unset');
	    value.forEach(function(key) {
	      if (Object.hasOwnProperty.call(nextObject, key)) {
	        if (nextObject === originalObject) nextObject = copy(originalObject);
	        delete nextObject[key];
	      }
	    });
	    return nextObject;
	  },
	  $add: function(value, nextObject, spec, originalObject) {
	    invariantMapOrSet(nextObject, '$add');
	    invariantSpecArray(value, '$add');
	    if (type(nextObject) === 'Map') {
	      value.forEach(function(pair) {
	        var key = pair[0];
	        var value = pair[1];
	        if (nextObject === originalObject && nextObject.get(key) !== value) nextObject = copy(originalObject);
	        nextObject.set(key, value);
	      });
	    } else {
	      value.forEach(function(value) {
	        if (nextObject === originalObject && !nextObject.has(value)) nextObject = copy(originalObject);
	        nextObject.add(value);
	      });
	    }
	    return nextObject;
	  },
	  $remove: function(value, nextObject, spec, originalObject) {
	    invariantMapOrSet(nextObject, '$remove');
	    invariantSpecArray(value, '$remove');
	    value.forEach(function(key) {
	      if (nextObject === originalObject && nextObject.has(key)) nextObject = copy(originalObject);
	      nextObject.delete(key);
	    });
	    return nextObject;
	  },
	  $merge: function(value, nextObject, spec, originalObject) {
	    invariantMerge(nextObject, value);
	    getAllKeys(value).forEach(function(key) {
	      if (value[key] !== nextObject[key]) {
	        if (nextObject === originalObject) nextObject = copy(originalObject);
	        nextObject[key] = value[key];
	      }
	    });
	    return nextObject;
	  },
	  $apply: function(value, original) {
	    invariantApply(value);
	    return value(original);
	  }
	};
	
	var contextForExport = newContext();
	
	module.exports = contextForExport;
	module.exports.default = contextForExport;
	module.exports.newContext = newContext;
	
	// invariants
	
	function invariantPushAndUnshift(value, spec, command) {
	  invariant(
	    Array.isArray(value),
	    'update(): expected target of %s to be an array; got %s.',
	    command,
	    value
	  );
	  invariantSpecArray(spec[command], command)
	}
	
	function invariantSpecArray(spec, command) {
	  invariant(
	    Array.isArray(spec),
	    'update(): expected spec of %s to be an array; got %s. ' +
	    'Did you forget to wrap your parameter in an array?',
	    command,
	    spec
	  );
	}
	
	function invariantSplices(value, spec) {
	  invariant(
	    Array.isArray(value),
	    'Expected $splice target to be an array; got %s',
	    value
	  );
	  invariantSplice(spec['$splice']);
	}
	
	function invariantSplice(value) {
	  invariant(
	    Array.isArray(value),
	    'update(): expected spec of $splice to be an array of arrays; got %s. ' +
	    'Did you forget to wrap your parameters in an array?',
	    value
	  );
	}
	
	function invariantApply(fn) {
	  invariant(
	    typeof fn === 'function',
	    'update(): expected spec of $apply to be a function; got %s.',
	    fn
	  );
	}
	
	function invariantSet(spec) {
	  invariant(
	    Object.keys(spec).length === 1,
	    'Cannot have more than one key in an object with $set'
	  );
	}
	
	function invariantMerge(target, specValue) {
	  invariant(
	    specValue && typeof specValue === 'object',
	    'update(): $merge expects a spec of type \'object\'; got %s',
	    specValue
	  );
	  invariant(
	    target && typeof target === 'object',
	    'update(): $merge expects a target of type \'object\'; got %s',
	    target
	  );
	}
	
	function invariantMapOrSet(target, command) {
	  var typeOfTarget = type(target);
	  invariant(
	    typeOfTarget === 'Map' || typeOfTarget === 'Set',
	    'update(): %s expects a target of type Set or Map; got %s',
	    command,
	    typeOfTarget
	  );
	}


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _mergeClassNames = _interopRequireDefault(__webpack_require__(93));
	
	var _propTypes2 = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Tile =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Tile, _Component);
	
	  function Tile() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Tile);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tile)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "state", {});
	
	    return _this;
	  }
	
	  _createClass(Tile, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          activeStartDate = _this$props.activeStartDate,
	          children = _this$props.children,
	          classes = _this$props.classes,
	          date = _this$props.date,
	          formatAbbr = _this$props.formatAbbr,
	          locale = _this$props.locale,
	          maxDate = _this$props.maxDate,
	          maxDateTransform = _this$props.maxDateTransform,
	          minDate = _this$props.minDate,
	          minDateTransform = _this$props.minDateTransform,
	          onClick = _this$props.onClick,
	          onMouseOver = _this$props.onMouseOver,
	          style = _this$props.style,
	          tileDisabled = _this$props.tileDisabled,
	          view = _this$props.view;
	      var _this$state = this.state,
	          tileClassName = _this$state.tileClassName,
	          tileContent = _this$state.tileContent;
	      return _react["default"].createElement("button", {
	        className: (0, _mergeClassNames["default"])(classes, tileClassName),
	        disabled: minDate && minDateTransform(minDate) > date || maxDate && maxDateTransform(maxDate) < date || tileDisabled && tileDisabled({
	          activeStartDate: activeStartDate,
	          date: date,
	          view: view
	        }),
	        onClick: onClick && function () {
	          return onClick(date);
	        },
	        onFocus: onMouseOver && function () {
	          return onMouseOver(date);
	        },
	        onMouseOver: onMouseOver && function () {
	          return onMouseOver(date);
	        },
	        style: style,
	        type: "button"
	      }, formatAbbr ? _react["default"].createElement("abbr", {
	        "aria-label": formatAbbr(locale, date)
	      }, children) : children, tileContent);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var date = nextProps.date,
	          tileClassName = nextProps.tileClassName,
	          tileContent = nextProps.tileContent,
	          view = nextProps.view;
	      var nextState = {};
	
	      if (tileClassName !== prevState.tileClassNameProps) {
	        nextState.tileClassName = typeof tileClassName === 'function' ? tileClassName({
	          date: date,
	          view: view
	        }) : tileClassName;
	        nextState.tileClassNameProps = tileClassName;
	      }
	
	      if (tileContent !== prevState.tileContentProps) {
	        nextState.tileContent = typeof tileContent === 'function' ? tileContent({
	          date: date,
	          view: view
	        }) : tileContent;
	        nextState.tileContentProps = tileContent;
	      }
	
	      return nextState;
	    }
	  }]);
	
	  return Tile;
	}(_react.Component);
	
	exports["default"] = Tile;
	Tile.propTypes = _objectSpread({}, _propTypes2.tileProps, {
	  children: _propTypes["default"].node.isRequired,
	  formatAbbr: _propTypes["default"].func,
	  maxDateTransform: _propTypes["default"].func.isRequired,
	  minDateTransform: _propTypes["default"].func.isRequired
	});

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = TileGroup;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Flex = _interopRequireDefault(__webpack_require__(160));
	
	var _utils = __webpack_require__(161);
	
	var _propTypes2 = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function TileGroup(_ref) {
	  var className = _ref.className,
	      count = _ref.count,
	      dateTransform = _ref.dateTransform,
	      dateType = _ref.dateType,
	      end = _ref.end,
	      hover = _ref.hover,
	      offset = _ref.offset,
	      start = _ref.start,
	      step = _ref.step,
	      Tile = _ref.tile,
	      value = _ref.value,
	      valueType = _ref.valueType,
	      tileProps = _objectWithoutProperties(_ref, ["className", "count", "dateTransform", "dateType", "end", "hover", "offset", "start", "step", "tile", "value", "valueType"]);
	
	  var tiles = [];
	
	  for (var point = start; point <= end; point += step) {
	    var date = dateTransform(point);
	    tiles.push(_react["default"].createElement(Tile, _extends({
	      key: date.getTime(),
	      classes: (0, _utils.getTileClasses)({
	        value: value,
	        valueType: valueType,
	        date: date,
	        dateType: dateType,
	        hover: hover
	      }),
	      date: date,
	      point: point
	    }, tileProps)));
	  }
	
	  return _react["default"].createElement(_Flex["default"], {
	    className: className,
	    count: count,
	    offset: offset,
	    wrap: true
	  }, tiles);
	}
	
	TileGroup.propTypes = _objectSpread({}, _propTypes2.tileGroupProps, {
	  activeStartDate: _propTypes["default"].instanceOf(Date),
	  count: _propTypes["default"].number,
	  dateTransform: _propTypes["default"].func.isRequired,
	  offset: _propTypes["default"].number,
	  step: _propTypes["default"].number,
	  tile: _propTypes["default"].func.isRequired
	});
	TileGroup.defaultProps = {
	  count: 3,
	  step: 1
	};

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatShortWeekday = exports.formatWeekday = exports.formatMonth = exports.formatMonthYear = exports.formatLongDate = exports.formatDate = void 0;
	
	var _getUserLocale = _interopRequireDefault(__webpack_require__(237));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getFormatter(options) {
	  return function (locale, date) {
	    return date.toLocaleString(locale || (0, _getUserLocale["default"])(), options);
	  };
	}
	/**
	 * Changes the hour in a Date to ensure right date formatting even if DST is messed up.
	 * Workaround for bug in WebKit and Firefox with historical dates.
	 * For more details, see:
	 * https://bugs.chromium.org/p/chromium/issues/detail?id=750465
	 * https://bugzilla.mozilla.org/show_bug.cgi?id=1385643
	 *
	 * @param {Date} date Date.
	 */
	
	
	function toSafeHour(date) {
	  var safeDate = new Date(date);
	  return new Date(safeDate.setHours(12));
	}
	
	function getSafeFormatter(options) {
	  return function (locale, date) {
	    return getFormatter(options)(locale, toSafeHour(date));
	  };
	}
	
	var formatDateOptions = {
	  day: 'numeric',
	  month: 'numeric',
	  year: 'numeric'
	};
	var formatLongDateOptions = {
	  day: 'numeric',
	  month: 'long',
	  year: 'numeric'
	};
	var formatMonthYearOptions = {
	  month: 'long',
	  year: 'numeric'
	};
	var formatMonthOptions = {
	  month: 'long'
	};
	var formatWeekdayOptions = {
	  weekday: 'long'
	};
	var formatShortWeekdayOptions = {
	  weekday: 'short'
	};
	var formatDate = getSafeFormatter(formatDateOptions);
	exports.formatDate = formatDate;
	var formatLongDate = getSafeFormatter(formatLongDateOptions);
	exports.formatLongDate = formatLongDate;
	var formatMonthYear = getSafeFormatter(formatMonthYearOptions);
	exports.formatMonthYear = formatMonthYear;
	var formatMonth = getSafeFormatter(formatMonthOptions);
	exports.formatMonth = formatMonth;
	var formatWeekday = getSafeFormatter(formatWeekdayOptions);
	exports.formatWeekday = formatWeekday;
	var formatShortWeekday = getSafeFormatter(formatShortWeekdayOptions);
	exports.formatShortWeekday = formatShortWeekday;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var EventPluginRegistry = __webpack_require__(164);
	var ReactEventEmitterMixin = __webpack_require__(795);
	var ViewportMetrics = __webpack_require__(428);
	
	var getVendorPrefixedEventName = __webpack_require__(827);
	var isEventSupported = __webpack_require__(176);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(98);
	var ViewportMetrics = __webpack_require__(428);
	
	var getEventModifierState = __webpack_require__(173);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var invariant = __webpack_require__(6);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 123 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(26);
	var DOMNamespaces = __webpack_require__(163);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(171);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(23));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
	  var onDemandSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
	      onDemandSlides.push(slideIndex);
	    }
	  }
	
	  return onDemandSlides;
	}; // return list of slides that need to be present
	
	
	exports.getOnDemandLazySlides = getOnDemandLazySlides;
	
	var getRequiredLazySlides = function getRequiredLazySlides(spec) {
	  var requiredSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    requiredSlides.push(slideIndex);
	  }
	
	  return requiredSlides;
	}; // startIndex that needs to be present
	
	
	exports.getRequiredLazySlides = getRequiredLazySlides;
	
	var lazyStartIndex = function lazyStartIndex(spec) {
	  return spec.currentSlide - lazySlidesOnLeft(spec);
	};
	
	exports.lazyStartIndex = lazyStartIndex;
	
	var lazyEndIndex = function lazyEndIndex(spec) {
	  return spec.currentSlide + lazySlidesOnRight(spec);
	};
	
	exports.lazyEndIndex = lazyEndIndex;
	
	var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
	  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
	};
	
	exports.lazySlidesOnLeft = lazySlidesOnLeft;
	
	var lazySlidesOnRight = function lazySlidesOnRight(spec) {
	  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
	}; // get width of an element
	
	
	exports.lazySlidesOnRight = lazySlidesOnRight;
	
	var getWidth = function getWidth(elem) {
	  return elem && elem.offsetWidth || 0;
	};
	
	exports.getWidth = getWidth;
	
	var getHeight = function getHeight(elem) {
	  return elem && elem.offsetHeight || 0;
	};
	
	exports.getHeight = getHeight;
	
	var getSwipeDirection = function getSwipeDirection(touchObject) {
	  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var xDist, yDist, r, swipeAngle;
	  xDist = touchObject.startX - touchObject.curX;
	  yDist = touchObject.startY - touchObject.curY;
	  r = Math.atan2(yDist, xDist);
	  swipeAngle = Math.round(r * 180 / Math.PI);
	
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	
	  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	    return "left";
	  }
	
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return "right";
	  }
	
	  if (verticalSwiping === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return "up";
	    } else {
	      return "down";
	    }
	  }
	
	  return "vertical";
	}; // whether or not we can go next
	
	
	exports.getSwipeDirection = getSwipeDirection;
	
	var canGoNext = function canGoNext(spec) {
	  var canGo = true;
	
	  if (!spec.infinite) {
	    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
	      canGo = false;
	    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
	      canGo = false;
	    }
	  }
	
	  return canGo;
	}; // given an object and a list of keys, return new object with given keys
	
	
	exports.canGoNext = canGoNext;
	
	var extractObject = function extractObject(spec, keys) {
	  var newObject = {};
	  keys.forEach(function (key) {
	    return newObject[key] = spec[key];
	  });
	  return newObject;
	}; // get initialized state
	
	
	exports.extractObject = extractObject;
	
	var initializedState = function initializedState(spec) {
	  // spec also contains listRef, trackRef
	  var slideCount = _react["default"].Children.count(spec.children);
	
	  var listWidth = Math.ceil(getWidth(_reactDom["default"].findDOMNode(spec.listRef)));
	  var trackWidth = Math.ceil(getWidth(_reactDom["default"].findDOMNode(spec.trackRef)));
	  var slideWidth;
	
	  if (!spec.vertical) {
	    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
	
	    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
	      centerPaddingAdj *= listWidth / 100;
	    }
	
	    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
	  } else {
	    slideWidth = listWidth;
	  }
	
	  var slideHeight = _reactDom["default"].findDOMNode(spec.listRef) && getHeight(_reactDom["default"].findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
	  var listHeight = slideHeight * spec.slidesToShow;
	  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
	
	  if (spec.rtl && spec.currentSlide === undefined) {
	    currentSlide = slideCount - 1 - spec.initialSlide;
	  }
	
	  var lazyLoadedList = spec.lazyLoadedList || [];
	  var slidesToLoad = getOnDemandLazySlides({
	    currentSlide: currentSlide,
	    lazyLoadedList: lazyLoadedList
	  }, spec);
	  lazyLoadedList.concat(slidesToLoad);
	  var state = {
	    slideCount: slideCount,
	    slideWidth: slideWidth,
	    listWidth: listWidth,
	    trackWidth: trackWidth,
	    currentSlide: currentSlide,
	    slideHeight: slideHeight,
	    listHeight: listHeight,
	    lazyLoadedList: lazyLoadedList
	  };
	
	  if (spec.autoplaying === null && spec.autoplay) {
	    state["autoplaying"] = "playing";
	  }
	
	  return state;
	};
	
	exports.initializedState = initializedState;
	
	var slideHandler = function slideHandler(spec) {
	  var waitForAnimate = spec.waitForAnimate,
	      animating = spec.animating,
	      fade = spec.fade,
	      infinite = spec.infinite,
	      index = spec.index,
	      slideCount = spec.slideCount,
	      lazyLoadedList = spec.lazyLoadedList,
	      lazyLoad = spec.lazyLoad,
	      currentSlide = spec.currentSlide,
	      centerMode = spec.centerMode,
	      slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      useCSS = spec.useCSS;
	  if (waitForAnimate && animating) return {};
	  var animationSlide = index,
	      finalSlide,
	      animationLeft,
	      finalLeft;
	  var state = {},
	      nextState = {};
	
	  if (fade) {
	    if (!infinite && (index < 0 || index >= slideCount)) return {};
	
	    if (index < 0) {
	      animationSlide = index + slideCount;
	    } else if (index >= slideCount) {
	      animationSlide = index - slideCount;
	    }
	
	    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
	      lazyLoadedList.push(animationSlide);
	    }
	
	    state = {
	      animating: true,
	      currentSlide: animationSlide,
	      lazyLoadedList: lazyLoadedList
	    };
	    nextState = {
	      animating: false
	    };
	  } else {
	    finalSlide = animationSlide;
	
	    if (animationSlide < 0) {
	      finalSlide = animationSlide + slideCount;
	      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
	    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
	      animationSlide = finalSlide = currentSlide;
	    } else if (centerMode && animationSlide >= slideCount) {
	      animationSlide = infinite ? slideCount : slideCount - 1;
	      finalSlide = infinite ? 0 : slideCount - 1;
	    } else if (animationSlide >= slideCount) {
	      finalSlide = animationSlide - slideCount;
	      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
	    }
	
	    animationLeft = getTrackLeft(_objectSpread({}, spec, {
	      slideIndex: animationSlide
	    }));
	    finalLeft = getTrackLeft(_objectSpread({}, spec, {
	      slideIndex: finalSlide
	    }));
	
	    if (!infinite) {
	      if (animationLeft === finalLeft) animationSlide = finalSlide;
	      animationLeft = finalLeft;
	    }
	
	    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread({}, spec, {
	      currentSlide: animationSlide
	    })));
	
	    if (!useCSS) {
	      state = {
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread({}, spec, {
	          left: finalLeft
	        })),
	        lazyLoadedList: lazyLoadedList
	      };
	    } else {
	      state = {
	        animating: true,
	        currentSlide: finalSlide,
	        trackStyle: getTrackAnimateCSS(_objectSpread({}, spec, {
	          left: animationLeft
	        })),
	        lazyLoadedList: lazyLoadedList
	      };
	      nextState = {
	        animating: false,
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread({}, spec, {
	          left: finalLeft
	        })),
	        swipeLeft: null
	      };
	    }
	  }
	
	  return {
	    state: state,
	    nextState: nextState
	  };
	};
	
	exports.slideHandler = slideHandler;
	
	var changeSlide = function changeSlide(spec, options) {
	  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	  var slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      slideCount = spec.slideCount,
	      currentSlide = spec.currentSlide,
	      lazyLoad = spec.lazyLoad,
	      infinite = spec.infinite;
	  unevenOffset = slideCount % slidesToScroll !== 0;
	  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	  if (options.message === "previous") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	    targetSlide = currentSlide - slideOffset;
	
	    if (lazyLoad && !infinite) {
	      previousInt = currentSlide - slideOffset;
	      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	    }
	  } else if (options.message === "next") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	    targetSlide = currentSlide + slideOffset;
	
	    if (lazyLoad && !infinite) {
	      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	    }
	  } else if (options.message === "dots") {
	    // Click on dots
	    targetSlide = options.index * options.slidesToScroll;
	
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  } else if (options.message === "children") {
	    // Click on the slides
	    targetSlide = options.index;
	
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	
	    if (infinite) {
	      var direction = siblingDirection(_objectSpread({}, spec, {
	        targetSlide: targetSlide
	      }));
	
	      if (targetSlide > options.currentSlide && direction === "left") {
	        targetSlide = targetSlide - slideCount;
	      } else if (targetSlide < options.currentSlide && direction === "right") {
	        targetSlide = targetSlide + slideCount;
	      }
	    }
	  } else if (options.message === "index") {
	    targetSlide = Number(options.index);
	
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  }
	
	  return targetSlide;
	};
	
	exports.changeSlide = changeSlide;
	
	var keyHandler = function keyHandler(e, accessibility, rtl) {
	  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
	  if (e.keyCode === 37) return rtl ? "next" : "previous";
	  if (e.keyCode === 39) return rtl ? "previous" : "next";
	  return "";
	};
	
	exports.keyHandler = keyHandler;
	
	var swipeStart = function swipeStart(e, swipe, draggable) {
	  e.target.tagName === "IMG" && e.preventDefault();
	  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
	  return {
	    dragging: true,
	    touchObject: {
	      startX: e.touches ? e.touches[0].pageX : e.clientX,
	      startY: e.touches ? e.touches[0].pageY : e.clientY,
	      curX: e.touches ? e.touches[0].pageX : e.clientX,
	      curY: e.touches ? e.touches[0].pageY : e.clientY
	    }
	  };
	};
	
	exports.swipeStart = swipeStart;
	
	var swipeMove = function swipeMove(e, spec) {
	  // spec also contains, trackRef and slideIndex
	  var scrolling = spec.scrolling,
	      animating = spec.animating,
	      vertical = spec.vertical,
	      swipeToSlide = spec.swipeToSlide,
	      verticalSwiping = spec.verticalSwiping,
	      rtl = spec.rtl,
	      currentSlide = spec.currentSlide,
	      edgeFriction = spec.edgeFriction,
	      edgeDragged = spec.edgeDragged,
	      onEdge = spec.onEdge,
	      swiped = spec.swiped,
	      swiping = spec.swiping,
	      slideCount = spec.slideCount,
	      slidesToScroll = spec.slidesToScroll,
	      infinite = spec.infinite,
	      touchObject = spec.touchObject,
	      swipeEvent = spec.swipeEvent,
	      listHeight = spec.listHeight,
	      listWidth = spec.listWidth;
	  if (scrolling) return;
	  if (animating) return e.preventDefault();
	  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
	  var swipeLeft,
	      state = {};
	  var curLeft = getTrackLeft(spec);
	  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	
	  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
	    return {
	      scrolling: true
	    };
	  }
	
	  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
	  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	  var dotCount = Math.ceil(slideCount / slidesToScroll);
	  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
	  var touchSwipeLength = touchObject.swipeLength;
	
	  if (!infinite) {
	    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
	      touchSwipeLength = touchObject.swipeLength * edgeFriction;
	
	      if (edgeDragged === false && onEdge) {
	        onEdge(swipeDirection);
	        state["edgeDragged"] = true;
	      }
	    }
	  }
	
	  if (!swiped && swipeEvent) {
	    swipeEvent(swipeDirection);
	    state["swiped"] = true;
	  }
	
	  if (!vertical) {
	    if (!rtl) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft - touchSwipeLength * positionOffset;
	    }
	  } else {
	    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
	  }
	
	  if (verticalSwiping) {
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	  }
	
	  state = _objectSpread({}, state, {
	    touchObject: touchObject,
	    swipeLeft: swipeLeft,
	    trackStyle: getTrackCSS(_objectSpread({}, spec, {
	      left: swipeLeft
	    }))
	  });
	
	  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > 10) {
	    state["swiping"] = true;
	    e.preventDefault();
	  }
	
	  return state;
	};
	
	exports.swipeMove = swipeMove;
	
	var swipeEnd = function swipeEnd(e, spec) {
	  var dragging = spec.dragging,
	      swipe = spec.swipe,
	      touchObject = spec.touchObject,
	      listWidth = spec.listWidth,
	      touchThreshold = spec.touchThreshold,
	      verticalSwiping = spec.verticalSwiping,
	      listHeight = spec.listHeight,
	      currentSlide = spec.currentSlide,
	      swipeToSlide = spec.swipeToSlide,
	      scrolling = spec.scrolling,
	      onSwipe = spec.onSwipe;
	
	  if (!dragging) {
	    if (swipe) e.preventDefault();
	    return {};
	  }
	
	  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
	  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.
	
	  var state = {
	    dragging: false,
	    edgeDragged: false,
	    scrolling: false,
	    swiping: false,
	    swiped: false,
	    swipeLeft: null,
	    touchObject: {}
	  };
	
	  if (scrolling) {
	    return state;
	  }
	
	  if (!touchObject.swipeLength) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > minSwipe) {
	    e.preventDefault();
	
	    if (onSwipe) {
	      onSwipe(swipeDirection);
	    }
	
	    var slideCount, newSlide;
	
	    switch (swipeDirection) {
	      case "left":
	      case "up":
	        newSlide = currentSlide + getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 0;
	        break;
	
	      case "right":
	      case "down":
	        newSlide = currentSlide - getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 1;
	        break;
	
	      default:
	        slideCount = currentSlide;
	    }
	
	    state["triggerSlideHandler"] = slideCount;
	  } else {
	    // Adjust the track back to it's original position.
	    var currentLeft = getTrackLeft(spec);
	    state["trackStyle"] = getTrackAnimateCSS(_objectSpread({}, spec, {
	      left: currentLeft
	    }));
	  }
	
	  return state;
	};
	
	exports.swipeEnd = swipeEnd;
	
	var getNavigableIndexes = function getNavigableIndexes(spec) {
	  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
	  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var indexes = [];
	
	  while (breakpoint < max) {
	    indexes.push(breakpoint);
	    breakpoint = counter + spec.slidesToScroll;
	    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
	  }
	
	  return indexes;
	};
	
	exports.getNavigableIndexes = getNavigableIndexes;
	
	var checkNavigable = function checkNavigable(spec, index) {
	  var navigables = getNavigableIndexes(spec);
	  var prevNavigable = 0;
	
	  if (index > navigables[navigables.length - 1]) {
	    index = navigables[navigables.length - 1];
	  } else {
	    for (var n in navigables) {
	      if (index < navigables[n]) {
	        index = prevNavigable;
	        break;
	      }
	
	      prevNavigable = navigables[n];
	    }
	  }
	
	  return index;
	};
	
	exports.checkNavigable = checkNavigable;
	
	var getSlideCount = function getSlideCount(spec) {
	  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
	
	  if (spec.swipeToSlide) {
	    var swipedSlide;
	
	    var slickList = _reactDom["default"].findDOMNode(spec.listRef);
	
	    var slides = slickList.querySelectorAll(".slick-slide");
	    Array.from(slides).every(function (slide) {
	      if (!spec.vertical) {
	        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      } else {
	        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      }
	
	      return true;
	    });
	
	    if (!swipedSlide) {
	      return 0;
	    }
	
	    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
	    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	    return slidesTraversed;
	  } else {
	    return spec.slidesToScroll;
	  }
	};
	
	exports.getSlideCount = getSlideCount;
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error("Keys Missing:", spec);
	};
	
	exports.checkSpecKeys = checkSpecKeys;
	
	var getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
	  var trackWidth, trackHeight;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    transition: "",
	    WebkitTransition: ""
	  };
	
	  if (spec.useTransform) {
	    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
	    style = _objectSpread({}, style, {
	      WebkitTransform: WebkitTransform,
	      transform: transform,
	      msTransform: msTransform
	    });
	  } else {
	    if (spec.vertical) {
	      style["top"] = spec.left;
	    } else {
	      style["left"] = spec.left;
	    }
	  }
	
	  if (spec.fade) style = {
	    opacity: 1
	  };
	  if (trackWidth) style.width = trackWidth;
	  if (trackHeight) style.height = trackHeight; // Fallback for IE8
	
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + "px";
	    } else {
	      style.marginTop = spec.left + "px";
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackCSS = getTrackCSS;
	
	var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
	  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined
	
	  if (spec.useTransform) {
	    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
	    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
	  } else {
	    if (spec.vertical) {
	      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
	    } else {
	      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackAnimateCSS = getTrackAnimateCSS;
	
	var getTrackLeft = function getTrackLeft(spec) {
	  if (spec.unslick) {
	    return 0;
	  }
	
	  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    } // shift current slide to center of the frame
	
	
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	
	    var trackElem = _reactDom["default"].findDOMNode(trackRef);
	
	    targetSlideIndex = slideIndex + getPreClones(spec);
	    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	
	    if (centerMode === true) {
	      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
	      targetSlide = trackElem && trackElem.children[targetSlideIndex];
	      targetLeft = 0;
	
	      for (var slide = 0; slide < targetSlideIndex; slide++) {
	        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
	      }
	
	      targetLeft -= parseInt(spec.centerPadding);
	      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};
	
	exports.getTrackLeft = getTrackLeft;
	
	var getPreClones = function getPreClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  if (spec.variableWidth) {
	    return spec.slideCount;
	  }
	
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	};
	
	exports.getPreClones = getPreClones;
	
	var getPostClones = function getPostClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  return spec.slideCount;
	};
	
	exports.getPostClones = getPostClones;
	
	var getTotalSlides = function getTotalSlides(spec) {
	  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
	};
	
	exports.getTotalSlides = getTotalSlides;
	
	var siblingDirection = function siblingDirection(spec) {
	  if (spec.targetSlide > spec.currentSlide) {
	    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
	      return "left";
	    }
	
	    return "right";
	  } else {
	    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
	      return "right";
	    }
	
	    return "left";
	  }
	};
	
	exports.siblingDirection = siblingDirection;
	
	var slidesOnRight = function slidesOnRight(_ref) {
	  var slidesToShow = _ref.slidesToShow,
	      centerMode = _ref.centerMode,
	      rtl = _ref.rtl,
	      centerPadding = _ref.centerPadding;
	
	  // returns no of slides on the right of active slide
	  if (centerMode) {
	    var right = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) right += 1;
	    if (rtl && slidesToShow % 2 === 0) right += 1;
	    return right;
	  }
	
	  if (rtl) {
	    return 0;
	  }
	
	  return slidesToShow - 1;
	};
	
	exports.slidesOnRight = slidesOnRight;
	
	var slidesOnLeft = function slidesOnLeft(_ref2) {
	  var slidesToShow = _ref2.slidesToShow,
	      centerMode = _ref2.centerMode,
	      rtl = _ref2.rtl,
	      centerPadding = _ref2.centerPadding;
	
	  // returns no of slides on the left of active slide
	  if (centerMode) {
	    var left = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) left += 1;
	    if (!rtl && slidesToShow % 2 === 0) left += 1;
	    return left;
	  }
	
	  if (rtl) {
	    return slidesToShow - 1;
	  }
	
	  return 0;
	};
	
	exports.slidesOnLeft = slidesOnLeft;
	
	var canUseDOM = function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	};
	
	exports.canUseDOM = canUseDOM;

/***/ },
/* 126 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.commaDecimal = exports.dotDecimal = exports.arabicLocales = exports.englishLocales = exports.decimal = exports.alphanumeric = exports.alpha = void 0;
	var alpha = {
	  'en-US': /^[A-Z]+$/i,
	  'bg-BG': /^[А-Я]+$/i,
	  'cs-CZ': /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
	  'da-DK': /^[A-ZÆØÅ]+$/i,
	  'de-DE': /^[A-ZÄÖÜß]+$/i,
	  'el-GR': /^[Α-ω]+$/i,
	  'es-ES': /^[A-ZÁÉÍÑÓÚÜ]+$/i,
	  'fr-FR': /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
	  'it-IT': /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
	  'nb-NO': /^[A-ZÆØÅ]+$/i,
	  'nl-NL': /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
	  'nn-NO': /^[A-ZÆØÅ]+$/i,
	  'hu-HU': /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
	  'pl-PL': /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
	  'pt-PT': /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
	  'ru-RU': /^[А-ЯЁ]+$/i,
	  'sl-SI': /^[A-ZČĆĐŠŽ]+$/i,
	  'sk-SK': /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
	  'sr-RS@latin': /^[A-ZČĆŽŠĐ]+$/i,
	  'sr-RS': /^[А-ЯЂЈЉЊЋЏ]+$/i,
	  'sv-SE': /^[A-ZÅÄÖ]+$/i,
	  'tr-TR': /^[A-ZÇĞİıÖŞÜ]+$/i,
	  'uk-UA': /^[А-ЩЬЮЯЄIЇҐі]+$/i,
	  'ku-IQ': /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
	  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
	};
	exports.alpha = alpha;
	var alphanumeric = {
	  'en-US': /^[0-9A-Z]+$/i,
	  'bg-BG': /^[0-9А-Я]+$/i,
	  'cs-CZ': /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
	  'da-DK': /^[0-9A-ZÆØÅ]+$/i,
	  'de-DE': /^[0-9A-ZÄÖÜß]+$/i,
	  'el-GR': /^[0-9Α-ω]+$/i,
	  'es-ES': /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
	  'fr-FR': /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
	  'it-IT': /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
	  'hu-HU': /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
	  'nb-NO': /^[0-9A-ZÆØÅ]+$/i,
	  'nl-NL': /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
	  'nn-NO': /^[0-9A-ZÆØÅ]+$/i,
	  'pl-PL': /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
	  'pt-PT': /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
	  'ru-RU': /^[0-9А-ЯЁ]+$/i,
	  'sl-SI': /^[0-9A-ZČĆĐŠŽ]+$/i,
	  'sk-SK': /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
	  'sr-RS@latin': /^[0-9A-ZČĆŽŠĐ]+$/i,
	  'sr-RS': /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
	  'sv-SE': /^[0-9A-ZÅÄÖ]+$/i,
	  'tr-TR': /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
	  'uk-UA': /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
	  'ku-IQ': /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
	  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
	};
	exports.alphanumeric = alphanumeric;
	var decimal = {
	  'en-US': '.',
	  ar: '٫'
	};
	exports.decimal = decimal;
	var englishLocales = ['AU', 'GB', 'HK', 'IN', 'NZ', 'ZA', 'ZM'];
	exports.englishLocales = englishLocales;
	
	for (var locale, i = 0; i < englishLocales.length; i++) {
	  locale = "en-".concat(englishLocales[i]);
	  alpha[locale] = alpha['en-US'];
	  alphanumeric[locale] = alphanumeric['en-US'];
	  decimal[locale] = decimal['en-US'];
	} // Source: http://www.localeplanet.com/java/
	
	
	var arabicLocales = ['AE', 'BH', 'DZ', 'EG', 'IQ', 'JO', 'KW', 'LB', 'LY', 'MA', 'QM', 'QA', 'SA', 'SD', 'SY', 'TN', 'YE'];
	exports.arabicLocales = arabicLocales;
	
	for (var _locale, _i = 0; _i < arabicLocales.length; _i++) {
	  _locale = "ar-".concat(arabicLocales[_i]);
	  alpha[_locale] = alpha.ar;
	  alphanumeric[_locale] = alphanumeric.ar;
	  decimal[_locale] = decimal.ar;
	} // Source: https://en.wikipedia.org/wiki/Decimal_mark
	
	
	var dotDecimal = ['ar-EG', 'ar-LB', 'ar-LY'];
	exports.dotDecimal = dotDecimal;
	var commaDecimal = ['bg-BG', 'cs-CZ', 'da-DK', 'de-DE', 'el-GR', 'en-ZM', 'es-ES', 'fr-FR', 'it-IT', 'ku-IQ', 'hu-HU', 'nb-NO', 'nn-NO', 'nl-NL', 'pl-PL', 'pt-PT', 'ru-RU', 'sl-SI', 'sr-RS@latin', 'sr-RS', 'sv-SE', 'tr-TR', 'uk-UA'];
	exports.commaDecimal = commaDecimal;
	
	for (var _i2 = 0; _i2 < dotDecimal.length; _i2++) {
	  decimal[dotDecimal[_i2]] = decimal['en-US'];
	}
	
	for (var _i3 = 0; _i3 < commaDecimal.length; _i3++) {
	  decimal[commaDecimal[_i3]] = ',';
	}
	
	alpha['pt-BR'] = alpha['pt-PT'];
	alphanumeric['pt-BR'] = alphanumeric['pt-PT'];
	decimal['pt-BR'] = decimal['pt-PT']; // see #862
	
	alpha['pl-Pl'] = alpha['pl-PL'];
	alphanumeric['pl-Pl'] = alphanumeric['pl-PL'];
	decimal['pl-Pl'] = decimal['pl-PL'];

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isIP;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
	var ipv6Block = /^[0-9A-F]{1,4}$/i;
	
	function isIP(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  (0, _assertString.default)(str);
	  version = String(version);
	
	  if (!version) {
	    return isIP(str, 4) || isIP(str, 6);
	  } else if (version === '4') {
	    if (!ipv4Maybe.test(str)) {
	      return false;
	    }
	
	    var parts = str.split('.').sort(function (a, b) {
	      return a - b;
	    });
	    return parts[3] <= 255;
	  } else if (version === '6') {
	    var blocks = str.split(':');
	    var foundOmissionBlock = false; // marker to indicate ::
	    // At least some OS accept the last 32 bits of an IPv6 address
	    // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
	    // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
	    // and '::a.b.c.d' is deprecated, but also valid.
	
	    var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
	    var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;
	
	    if (blocks.length > expectedNumberOfBlocks) {
	      return false;
	    } // initial or final ::
	
	
	    if (str === '::') {
	      return true;
	    } else if (str.substr(0, 2) === '::') {
	      blocks.shift();
	      blocks.shift();
	      foundOmissionBlock = true;
	    } else if (str.substr(str.length - 2) === '::') {
	      blocks.pop();
	      blocks.pop();
	      foundOmissionBlock = true;
	    }
	
	    for (var i = 0; i < blocks.length; ++i) {
	      // test for a :: which can not be at the string start/end
	      // since those cases have been handled above
	      if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
	        if (foundOmissionBlock) {
	          return false; // multiple :: in address
	        }
	
	        foundOmissionBlock = true;
	      } else if (foundIPv4TransitionBlock && i === blocks.length - 1) {// it has been checked before that the last
	        // block is a valid IPv4 address
	      } else if (!ipv6Block.test(blocks[i])) {
	        return false;
	      }
	    }
	
	    if (foundOmissionBlock) {
	      return blocks.length >= 1;
	    }
	
	    return blocks.length === expectedNumberOfBlocks;
	  }
	
	  return false;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 128 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	__webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Select = __webpack_require__(83);
	
	var Loading = __webpack_require__(17);
	
	var Overlay = __webpack_require__(64);
	
	var LocationSearchInput = function (_React$Component) {
	  _inherits(LocationSearchInput, _React$Component);
	
	  function LocationSearchInput(props) {
	    _classCallCheck(this, LocationSearchInput);
	
	    var _this = _possibleConstructorReturn(this, (LocationSearchInput.__proto__ || Object.getPrototypeOf(LocationSearchInput)).call(this, props));
	
	    _this.handleChange = function (selectedOption) {
	      _this.setState({
	        selectedOption: selectedOption.value
	      });
	      //his.props.postalcode
	      _this.props.parentCallback(_this, true, _this.props.postalcode, selectedOption.value);
	    };
	
	    _this.state = { selectedOption: "" };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.getOptions = _this.getOptions.bind(_this);
	    return _this;
	  }
	
	  _createClass(LocationSearchInput, [{
	    key: "getOptions",
	    value: function getOptions(input) {
	      var searchResult = [];
	      return _axios2.default.get("https://developers.onemap.sg/commonapi/search?returnGeom=Y&getAddrDetails=Y&searchVal=" + input).then(function (response) {
	        if (response.data.found > 0) {
	          var resultData = response.data.results;
	          resultData.map(function (loadData) {
	            return loadData.POSTAL !== "NIL" && searchResult.push({
	              value: JSON.stringify(loadData),
	              label: loadData.ADDRESS
	            });
	          });
	        }
	
	        return { options: searchResult };
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var selectedOption = this.state.selectedOption;
	
	      if (this.props.Loading === true) {
	        return _react2.default.createElement(
	          "div",
	          {
	            className: "container-fluid desktop-container position-rel",
	            style: { minHeight: this.state.windowHeightNormal }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(Loading, null)
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          "div",
	          { className: "modal", id: "address-auto" },
	          _react2.default.createElement(
	            "div",
	            { className: "modal-dialog PopupWidth" },
	            _react2.default.createElement(
	              "div",
	              { className: "modal-content" },
	              _react2.default.createElement(
	                "div",
	                { className: "modal-header" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "close",
	                    "data-dismiss": "modal",
	                    "aria-hidden": "true"
	                  },
	                  _react2.default.createElement("img", {
	                    src: "/img/icons/modal-close.png",
	                    className: "img-responsive",
	                    alt: "close"
	                  })
	                ),
	                _react2.default.createElement("div", { className: "space-10", style: { padding: "22px" } }),
	                _react2.default.createElement(
	                  "h4",
	                  { className: "modal-title" },
	                  "WE COULDNT FIND THE POSTAL CODE YOU ENTERED"
	                ),
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Could you type your address to search instead"
	                )
	              ),
	              _react2.default.createElement(Overlay, { load: this.state.load }),
	              _react2.default.createElement(
	                "div",
	                { className: "modal-body" },
	                _react2.default.createElement(
	                  "div",
	                  { style: { textAlign: "left" }, className: "location-search" },
	                  _react2.default.createElement(Select.Async, {
	                    name: "form-field-name",
	                    placeholder: "Search here",
	                    value: selectedOption,
	                    noResultsText: "No result found",
	                    autoload: false,
	                    onChange: this.handleChange,
	                    loadOptions: this.getOptions.bind(this)
	                  })
	                )
	              ),
	              _react2.default.createElement("div", { className: "modal-footer" }),
	              _react2.default.createElement("div", { className: "space-10", style: { padding: "22px" } })
	            )
	          )
	        );
	      }
	    }
	  }]);
	
	  return LocationSearchInput;
	}(_react2.default.Component);
	
	exports.default = LocationSearchInput;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(204);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(546);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(545);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 132 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 133 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 134 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(90);
	var dPs = __webpack_require__(570);
	var enumBugKeys = __webpack_require__(133);
	var IE_PROTO = __webpack_require__(138)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(217)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(564).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 136 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(54).f;
	var has = __webpack_require__(53);
	var TAG = __webpack_require__(70)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(139)('keys');
	var uid = __webpack_require__(108);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(32);
	var global = __webpack_require__(41);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(105) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 140 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(68);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(41);
	var core = __webpack_require__(32);
	var LIBRARY = __webpack_require__(105);
	var wksExt = __webpack_require__(143);
	var defineProperty = __webpack_require__(54).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(70);


/***/ },
/* 144 */
71,
/* 145 */
71,
/* 146 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(74);
	
	var _DOMUtils = __webpack_require__(111);
	
	var _DOMStateStorage = __webpack_require__(240);
	
	var _PathUtils = __webpack_require__(43);
	
	var _ExecutionEnvironment = __webpack_require__(148);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },
/* 148 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(633);
	
	var _PathUtils = __webpack_require__(43);
	
	var _runTransitionHook = __webpack_require__(150);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(110);
	
	var _LocationUtils = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },
/* 151 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 152 */
/***/ function(module, exports) {

	module.exports = function _arity(n, fn) {
	  /* eslint-disable no-unused-vars */
	  switch (n) {
	    case 0: return function() { return fn.apply(this, arguments); };
	    case 1: return function(a0) { return fn.apply(this, arguments); };
	    case 2: return function(a0, a1) { return fn.apply(this, arguments); };
	    case 3: return function(a0, a1, a2) { return fn.apply(this, arguments); };
	    case 4: return function(a0, a1, a2, a3) { return fn.apply(this, arguments); };
	    case 5: return function(a0, a1, a2, a3, a4) { return fn.apply(this, arguments); };
	    case 6: return function(a0, a1, a2, a3, a4, a5) { return fn.apply(this, arguments); };
	    case 7: return function(a0, a1, a2, a3, a4, a5, a6) { return fn.apply(this, arguments); };
	    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) { return fn.apply(this, arguments); };
	    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) { return fn.apply(this, arguments); };
	    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) { return fn.apply(this, arguments); };
	    default: throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
	  }
	};


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	var _isArray = __webpack_require__(248);
	var _isTransformer = __webpack_require__(655);
	
	
	/**
	 * Returns a function that dispatches with different strategies based on the
	 * object in list position (last argument). If it is an array, executes [fn].
	 * Otherwise, if it has a function with one of the given method names, it will
	 * execute that function (functor case). Otherwise, if it is a transformer,
	 * uses transducer [xf] to return a new transformer (transducer case).
	 * Otherwise, it will default to executing [fn].
	 *
	 * @private
	 * @param {Array} methodNames properties to check for a custom implementation
	 * @param {Function} xf transducer to initialize if object is transformer
	 * @param {Function} fn default ramda implementation
	 * @return {Function} A function that dispatches on object in list position
	 */
	module.exports = function _dispatchable(methodNames, xf, fn) {
	  return function() {
	    if (arguments.length === 0) {
	      return fn();
	    }
	    var args = Array.prototype.slice.call(arguments, 0);
	    var obj = args.pop();
	    if (!_isArray(obj)) {
	      var idx = 0;
	      while (idx < methodNames.length) {
	        if (typeof obj[methodNames[idx]] === 'function') {
	          return obj[methodNames[idx]].apply(obj, args);
	        }
	        idx += 1;
	      }
	      if (_isTransformer(obj)) {
	        var transducer = xf.apply(null, args);
	        return transducer(obj);
	      }
	    }
	    return fn.apply(this, arguments);
	  };
	};


/***/ },
/* 154 */
/***/ function(module, exports) {

	module.exports = function _has(prop, obj) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	};


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var _isArrayLike = __webpack_require__(652);
	var _xwrap = __webpack_require__(661);
	var bind = __webpack_require__(643);
	
	
	module.exports = (function() {
	  function _arrayReduce(xf, acc, list) {
	    var idx = 0;
	    var len = list.length;
	    while (idx < len) {
	      acc = xf['@@transducer/step'](acc, list[idx]);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      idx += 1;
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _iterableReduce(xf, acc, iter) {
	    var step = iter.next();
	    while (!step.done) {
	      acc = xf['@@transducer/step'](acc, step.value);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      step = iter.next();
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _methodReduce(xf, acc, obj, methodName) {
	    return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
	  }
	
	  var symIterator = (typeof Symbol !== 'undefined') ? Symbol.iterator : '@@iterator';
	  return function _reduce(fn, acc, list) {
	    if (typeof fn === 'function') {
	      fn = _xwrap(fn);
	    }
	    if (_isArrayLike(list)) {
	      return _arrayReduce(fn, acc, list);
	    }
	    if (typeof list['fantasy-land/reduce'] === 'function') {
	      return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
	    }
	    if (list[symIterator] != null) {
	      return _iterableReduce(fn, acc, list[symIterator]());
	    }
	    if (typeof list.next === 'function') {
	      return _iterableReduce(fn, acc, list);
	    }
	    if (typeof list.reduce === 'function') {
	      return _methodReduce(fn, acc, list, 'reduce');
	    }
	
	    throw new TypeError('reduce: list must be array or iterable');
	  };
	}());


/***/ },
/* 156 */
/***/ function(module, exports) {

	module.exports = {
	  init: function() {
	    return this.xf['@@transducer/init']();
	  },
	  result: function(result) {
	    return this.xf['@@transducer/result'](result);
	  }
	};


/***/ },
/* 157 */
[1040, 76, 113, 158],
/* 158 */
112,
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Input;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _mergeClassNames = _interopRequireDefault(__webpack_require__(93));
	
	var _updateInputWidth = _interopRequireWildcard(__webpack_require__(955));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function select(element) {
	  if (!element) {
	    return;
	  }
	
	  requestAnimationFrame(function () {
	    return element.select();
	  });
	}
	
	function updateInputWidthOnFontLoad(element) {
	  if (!document.fonts) {
	    return;
	  }
	
	  var font = (0, _updateInputWidth.getFontShorthand)(element);
	
	  if (!font) {
	    return;
	  }
	
	  var isFontLoaded = document.fonts.check(font);
	
	  if (isFontLoaded) {
	    return;
	  }
	
	  function onLoadingDone() {
	    (0, _updateInputWidth["default"])(element);
	  }
	
	  document.fonts.addEventListener('loadingdone', onLoadingDone);
	}
	
	function Input(_ref) {
	  var ariaLabel = _ref.ariaLabel,
	      className = _ref.className,
	      disabled = _ref.disabled,
	      itemRef = _ref.itemRef,
	      max = _ref.max,
	      min = _ref.min,
	      name = _ref.name,
	      nameForClass = _ref.nameForClass,
	      onChange = _ref.onChange,
	      onKeyDown = _ref.onKeyDown,
	      _onKeyUp = _ref.onKeyUp,
	      placeholder = _ref.placeholder,
	      required = _ref.required,
	      showLeadingZeros = _ref.showLeadingZeros,
	      step = _ref.step,
	      value = _ref.value;
	  var hasLeadingZero = showLeadingZeros && value !== null && value < 10;
	  return [hasLeadingZero && _react["default"].createElement("span", {
	    key: "leadingZero",
	    className: "".concat(className, "__leadingZero")
	  }, "0"), _react["default"].createElement("input", {
	    key: "input",
	    "aria-label": ariaLabel,
	    autoComplete: "off",
	    className: (0, _mergeClassNames["default"])("".concat(className, "__input"), "".concat(className, "__").concat(nameForClass || name), hasLeadingZero && "".concat(className, "__input--hasLeadingZero")),
	    disabled: disabled,
	    max: max,
	    min: min,
	    name: name,
	    onChange: onChange,
	    onFocus: function onFocus(event) {
	      return select(event.target);
	    },
	    onKeyDown: onKeyDown,
	    onKeyUp: function onKeyUp(event) {
	      (0, _updateInputWidth["default"])(event.target);
	
	      if (_onKeyUp) {
	        _onKeyUp(event);
	      }
	    },
	    placeholder: placeholder,
	    ref: function ref(_ref2) {
	      if (_ref2) {
	        (0, _updateInputWidth["default"])(_ref2);
	        updateInputWidthOnFontLoad(_ref2);
	      }
	
	      if (itemRef) {
	        itemRef(_ref2, name);
	      }
	    },
	    required: required,
	    step: step,
	    type: "number",
	    value: value !== null ? value : ''
	  })];
	}
	
	Input.propTypes = {
	  className: _propTypes["default"].string.isRequired,
	  disabled: _propTypes["default"].bool,
	  itemRef: _propTypes["default"].func,
	  max: _propTypes["default"].number,
	  min: _propTypes["default"].number,
	  onChange: _propTypes["default"].func,
	  onKeyDown: _propTypes["default"].func,
	  onKeyUp: _propTypes["default"].func,
	  required: _propTypes["default"].bool,
	  showLeadingZeros: _propTypes["default"].bool,
	  step: _propTypes["default"].number,
	  value: _propTypes["default"].number
	};
	Input.defaultProps = {
	  placeholder: '--'
	};

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Flex;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function toPercent(num) {
	  return "".concat(num, "%");
	}
	
	function Flex(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      direction = _ref.direction,
	      count = _ref.count,
	      offset = _ref.offset,
	      style = _ref.style,
	      wrap = _ref.wrap,
	      otherProps = _objectWithoutProperties(_ref, ["children", "className", "direction", "count", "offset", "style", "wrap"]);
	
	  return _react["default"].createElement("div", _extends({
	    className: className,
	    style: _objectSpread({
	      display: 'flex',
	      flexDirection: direction,
	      flexWrap: wrap ? 'wrap' : 'no-wrap'
	    }, style)
	  }, otherProps), _react["default"].Children.map(children, function (child, index) {
	    return _react["default"].cloneElement(child, _objectSpread({}, child.props, {
	      style: {
	        flexBasis: toPercent(100 / count),
	        maxWidth: toPercent(100 / count),
	        overflow: 'hidden',
	        marginLeft: offset && index === 0 ? toPercent(100 * offset / count) : null
	      }
	    }));
	  }));
	}
	
	Flex.propTypes = {
	  children: _propTypes["default"].node,
	  className: _propTypes["default"].string,
	  count: _propTypes["default"].number.isRequired,
	  direction: _propTypes["default"].string,
	  offset: _propTypes["default"].number,
	  style: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),
	  wrap: _propTypes["default"].bool
	};

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTileClasses = exports.between = exports.doRangesOverlap = exports.isRangeWithinRange = exports.isValueWithinRange = exports.callIfDefined = exports.mergeFunctions = void 0;
	
	var _dates = __webpack_require__(27);
	
	/**
	 * Returns a function that, when called, calls all the functions
	 * passed to it, applying its arguments to them.
	 *
	 * @param {Function[]} functions
	 */
	var mergeFunctions = function mergeFunctions() {
	  for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
	    functions[_key] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return functions.filter(Boolean).forEach(function (f) {
	      return f.apply(void 0, args);
	    });
	  };
	};
	/**
	 * Calls a function, if it's defined, with specified arguments
	 * @param {Function} fn
	 * @param {Object} args
	 */
	
	
	exports.mergeFunctions = mergeFunctions;
	
	var callIfDefined = function callIfDefined(fn) {
	  if (fn && typeof fn === 'function') {
	    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	      args[_key3 - 1] = arguments[_key3];
	    }
	
	    fn.apply(void 0, args);
	  }
	};
	
	exports.callIfDefined = callIfDefined;
	
	var isValueWithinRange = function isValueWithinRange(value, range) {
	  return range[0] <= value && range[1] >= value;
	};
	
	exports.isValueWithinRange = isValueWithinRange;
	
	var isRangeWithinRange = function isRangeWithinRange(greaterRange, smallerRange) {
	  return greaterRange[0] <= smallerRange[0] && greaterRange[1] >= smallerRange[1];
	};
	
	exports.isRangeWithinRange = isRangeWithinRange;
	
	var doRangesOverlap = function doRangesOverlap(range1, range2) {
	  return isValueWithinRange(range1[0], range2) || isValueWithinRange(range1[1], range2);
	};
	/**
	 * Returns a value no smaller than min and no larger than max.
	 *
	 * @param {*} value Value to return.
	 * @param {*} min Minimum return value.
	 * @param {*} max Maximum return value.
	 */
	
	
	exports.doRangesOverlap = doRangesOverlap;
	
	var between = function between(value, min, max) {
	  if (min && min > value) {
	    return min;
	  }
	
	  if (max && max < value) {
	    return max;
	  }
	
	  return value;
	};
	
	exports.between = between;
	
	var getTileClasses = function getTileClasses() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      value = _ref.value,
	      valueType = _ref.valueType,
	      date = _ref.date,
	      dateType = _ref.dateType,
	      hover = _ref.hover;
	
	  var className = 'react-calendar__tile';
	  var classes = [className];
	
	  if (!date) {
	    return classes;
	  }
	
	  if (!(date instanceof Array) && !dateType) {
	    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
	  }
	
	  var now = new Date();
	  var dateRange = date instanceof Array ? date : (0, _dates.getRange)(dateType, date);
	
	  if (isValueWithinRange(now, dateRange)) {
	    classes.push("".concat(className, "--now"));
	  }
	
	  if (!value) {
	    return classes;
	  }
	
	  if (!(value instanceof Array) && !valueType) {
	    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
	  }
	
	  var valueRange = value instanceof Array ? value : (0, _dates.getRange)(valueType, value);
	
	  if (isRangeWithinRange(valueRange, dateRange)) {
	    classes.push("".concat(className, "--active"));
	  } else if (doRangesOverlap(valueRange, dateRange)) {
	    classes.push("".concat(className, "--hasActive"));
	  } else if (hover && ( // Date before value
	  dateRange[1] < valueRange[0] && doRangesOverlap(dateRange, [hover, valueRange[0]]) || // Date after value
	  dateRange[0] > valueRange[1] && doRangesOverlap(dateRange, [valueRange[1], hover]))) {
	    classes.push("".concat(className, "--hover"));
	  }
	
	  var isRangeStart = isValueWithinRange(valueRange[0], dateRange);
	  var isRangeEnd = isValueWithinRange(valueRange[1], dateRange);
	
	  if (isRangeStart) {
	    classes.push("".concat(className, "--rangeStart"));
	  }
	
	  if (isRangeEnd) {
	    classes.push("".concat(className, "--rangeEnd"));
	  }
	
	  if (isRangeStart && isRangeEnd) {
	    classes.push("".concat(className, "--rangeBothEnds"));
	  }
	
	  return classes;
	};
	
	exports.getTileClasses = getTileClasses;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(79);
	var Danger = __webpack_require__(774);
	var ReactDOMComponentTree = __webpack_require__(22);
	var ReactInstrumentation = __webpack_require__(33);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(171);
	var setInnerHTML = __webpack_require__(124);
	var setTextContent = __webpack_require__(434);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 163 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var ReactErrorUtils = __webpack_require__(169);
	
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(14);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 166 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var React = __webpack_require__(62);
	var ReactPropTypesSecret = __webpack_require__(800);
	
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(14);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: React.PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var invariant = __webpack_require__(6);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      // $FlowFixMe https://github.com/facebook/flow/issues/2336
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var ReactCurrentOwner = __webpack_require__(38);
	var ReactInstanceMap = __webpack_require__(97);
	var ReactInstrumentation = __webpack_require__(33);
	var ReactUpdates = __webpack_require__(35);
	
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(14);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 171 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 172 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 173 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 174 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16),
	    _assign = __webpack_require__(18);
	
	var ReactCompositeComponent = __webpack_require__(781);
	var ReactEmptyComponent = __webpack_require__(419);
	var ReactHostComponent = __webpack_require__(421);
	
	var getNextDebugID = __webpack_require__(825);
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(14);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(26);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 177 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var emptyFunction = __webpack_require__(34);
	var warning = __webpack_require__(14);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.geoPropTypes = exports.geolocated = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getDisplayName = function getDisplayName(WrappedComponent) {
	  return "Geolocated(".concat(WrappedComponent.displayName || WrappedComponent.name || "Component", ")");
	};
	
	var geolocated = function geolocated() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$positionOptions = _ref.positionOptions,
	      positionOptions = _ref$positionOptions === void 0 ? {
	    enableHighAccuracy: true,
	    maximumAge: 0,
	    timeout: Infinity
	  } : _ref$positionOptions,
	      _ref$isOptimisticGeol = _ref.isOptimisticGeolocationEnabled,
	      isOptimisticGeolocationEnabled = _ref$isOptimisticGeol === void 0 ? true : _ref$isOptimisticGeol,
	      _ref$userDecisionTime = _ref.userDecisionTimeout,
	      userDecisionTimeout = _ref$userDecisionTime === void 0 ? null : _ref$userDecisionTime,
	      _ref$suppressLocation = _ref.suppressLocationOnMount,
	      suppressLocationOnMount = _ref$suppressLocation === void 0 ? false : _ref$suppressLocation,
	      _ref$watchPosition = _ref.watchPosition,
	      watchPosition = _ref$watchPosition === void 0 ? false : _ref$watchPosition,
	      _ref$geolocationProvi = _ref.geolocationProvider,
	      geolocationProvider = _ref$geolocationProvi === void 0 ? typeof navigator !== "undefined" && navigator.geolocation : _ref$geolocationProvi;
	
	  return function (WrappedComponent) {
	    var _temp;
	
	    var result = (_temp =
	    /*#__PURE__*/
	    function (_Component) {
	      _inherits(Geolocated, _Component);
	
	      function Geolocated(props) {
	        var _this;
	
	        _classCallCheck(this, Geolocated);
	
	        _this = _possibleConstructorReturn(this, _getPrototypeOf(Geolocated).call(this, props));
	
	        _defineProperty(_assertThisInitialized(_this), "isCurrentlyMounted", false);
	
	        _defineProperty(_assertThisInitialized(_this), "cancelUserDecisionTimeout", function () {
	          if (_this.userDecisionTimeoutId) {
	            clearTimeout(_this.userDecisionTimeoutId);
	          }
	        });
	
	        _defineProperty(_assertThisInitialized(_this), "onPositionError", function (positionError) {
	          _this.cancelUserDecisionTimeout();
	
	          if (_this.isCurrentlyMounted) {
	            _this.setState({
	              coords: null,
	              isGeolocationEnabled: false,
	              positionError: positionError
	            });
	          }
	
	          if (_this.props.onError) {
	            _this.props.onError(positionError);
	          }
	        });
	
	        _defineProperty(_assertThisInitialized(_this), "onPositionSuccess", function (position) {
	          _this.cancelUserDecisionTimeout();
	
	          if (_this.isCurrentlyMounted) {
	            _this.setState({
	              coords: position.coords,
	              isGeolocationEnabled: true,
	              positionError: null
	            });
	          }
	
	          if (_this.props.onSuccess) {
	            _this.props.onSuccess(position);
	          }
	        });
	
	        _defineProperty(_assertThisInitialized(_this), "getLocation", function () {
	          if (!geolocationProvider || !geolocationProvider.getCurrentPosition || !geolocationProvider.watchPosition) {
	            throw new Error("The provided geolocation provider is invalid");
	          }
	
	          var funcPosition = (watchPosition ? geolocationProvider.watchPosition : geolocationProvider.getCurrentPosition).bind(geolocationProvider);
	
	          if (userDecisionTimeout) {
	            _this.userDecisionTimeoutId = setTimeout(function () {
	              _this.onPositionError();
	            }, userDecisionTimeout);
	          }
	
	          _this.watchId = funcPosition(_this.onPositionSuccess, _this.onPositionError, positionOptions);
	        });
	
	        _this.state = {
	          coords: null,
	          isGeolocationAvailable: Boolean(geolocationProvider),
	          isGeolocationEnabled: isOptimisticGeolocationEnabled,
	          positionError: null
	        };
	        return _this;
	      }
	
	      _createClass(Geolocated, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	          this.isCurrentlyMounted = true;
	
	          if (!suppressLocationOnMount) {
	            this.getLocation();
	          }
	        }
	      }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	          this.isCurrentlyMounted = false;
	          this.cancelUserDecisionTimeout();
	
	          if (watchPosition) {
	            geolocationProvider.clearWatch(this.watchId);
	          }
	        }
	      }, {
	        key: "render",
	        value: function render() {
	          return _react["default"].createElement(WrappedComponent, _extends({}, this.state, this.props));
	        }
	      }]);
	
	      return Geolocated;
	    }(_react.Component), _temp);
	    result.displayName = getDisplayName(WrappedComponent);
	    result.propTypes = {
	      onError: _propTypes["default"].func,
	      onSuccess: _propTypes["default"].func
	    };
	    return result;
	  };
	};
	
	exports.geolocated = geolocated;
	var geoPropTypes = {
	  coords: _propTypes["default"].shape({
	    latitude: _propTypes["default"].number,
	    longitude: _propTypes["default"].number,
	    altitude: _propTypes["default"].number,
	    accuracy: _propTypes["default"].number,
	    altitudeAccuracy: _propTypes["default"].number,
	    heading: _propTypes["default"].number,
	    speed: _propTypes["default"].number
	  }),
	  isGeolocationAvailable: _propTypes["default"].bool,
	  isGeolocationEnabled: _propTypes["default"].bool,
	  positionError: _propTypes["default"].shape({
	    code: _propTypes["default"].oneOf([1, 2, 3]),
	    message: _propTypes["default"].string
	  }),
	  watchPosition: _propTypes["default"].bool
	};
	exports.geoPropTypes = geoPropTypes;

/***/ },
/* 180 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _react = __webpack_require__(1);
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  eventIndex: _react.PropTypes.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	function ContextProvider(name) {
	  var _childContextTypes, _ref2;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  return _ref2 = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _ref2[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _ref2;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _ref4;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  return _ref4 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref3;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _ref4;
	}

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func,
	    object = _react.PropTypes.object,
	    shape = _react.PropTypes.shape,
	    string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getRouteParams = __webpack_require__(858);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(181);
	
	var _RouteUtils = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    array = _React$PropTypes.array,
	    func = _React$PropTypes.func,
	    object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(452);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.objectToGetParams = objectToGetParams;
	exports.windowOpen = windowOpen;
	
	var _platform = __webpack_require__(389);
	
	var _platform2 = _interopRequireDefault(_platform);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function objectToGetParams(object) {
	  return '?' + (0, _keys2.default)(object).filter(function (key) {
	    return !!object[key];
	  }).map(function (key) {
	    return key + '=' + encodeURIComponent(object[key]);
	  }).join('&');
	} /* eslint-disable prefer-template */
	function windowOpen(url, _ref) {
	  var name = _ref.name,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 400 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 550 : _ref$width;
	
	  var left = window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2;
	  var top = window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2;
	
	  var config = {
	    height: height,
	    width: width,
	    left: left,
	    top: top,
	    location: 'no',
	    toolbar: 'no',
	    status: 'no',
	    directories: 'no',
	    menubar: 'no',
	    scrollbars: 'yes',
	    resizable: 'no',
	    centerscreen: 'yes',
	    chrome: 'yes'
	  };
	
	  return window.open(url, _platform2.default.name === 'IE' && parseInt(_platform2.default.version, 10) < 10 ? '' : name, (0, _keys2.default)(config).map(function (key) {
	    return key + '=' + config[key];
	  }).join(', '));
	}

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(884);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var scriptLoading = false;
	var scriptLoaded = false;
	var scriptDidError = false;
	
	var ReactStripeCheckout = function (_React$Component) {
	  _inherits(ReactStripeCheckout, _React$Component);
	
	  function ReactStripeCheckout(props) {
	    _classCallCheck(this, ReactStripeCheckout);
	
	    var _this = _possibleConstructorReturn(this, (ReactStripeCheckout.__proto__ || Object.getPrototypeOf(ReactStripeCheckout)).call(this, props));
	
	    _this.onScriptLoaded = function () {
	      if (!ReactStripeCheckout.stripeHandler) {
	        ReactStripeCheckout.stripeHandler = StripeCheckout.configure({
	          key: _this.props.stripeKey
	        });
	        if (_this.hasPendingClick) {
	          _this.showStripeDialog();
	        }
	      }
	    };
	
	    _this.onScriptError = function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this.hideLoadingDialog();
	      if (_this.props.onScriptError) {
	        _this.props.onScriptError.apply(_this, args);
	      }
	    };
	
	    _this.onClosed = function () {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      if (_this._isMounted) _this.setState({ open: false });
	      if (_this.props.closed) {
	        _this.props.closed.apply(_this, args);
	      }
	    };
	
	    _this.onOpened = function () {
	      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      _this.setState({ open: true });
	      if (_this.props.opened) {
	        _this.props.opened.apply(_this, args);
	      }
	    };
	
	    _this.getConfig = function () {
	      return ['token', 'image', 'name', 'description', 'amount', 'locale', 'currency', 'panelLabel', 'zipCode', 'shippingAddress', 'billingAddress', 'email', 'allowRememberMe', 'bitcoin', 'alipay', 'alipayReusable'].reduce(function (config, key) {
	        return _extends({}, config, _this.props.hasOwnProperty(key) && _defineProperty({}, key, _this.props[key]));
	      }, {
	        opened: _this.onOpened,
	        closed: _this.onClosed
	      });
	    };
	
	    _this.onClick = function () {
	      // eslint-disable-line react/sort-comp
	      if (_this.props.disabled) {
	        return;
	      }
	
	      if (scriptDidError) {
	        try {
	          throw new Error('Tried to call onClick, but StripeCheckout failed to load');
	        } catch (x) {} // eslint-disable-line no-empty
	      } else if (ReactStripeCheckout.stripeHandler) {
	        _this.showStripeDialog();
	      } else {
	        _this.showLoadingDialog();
	        _this.hasPendingClick = true;
	      }
	    };
	
	    _this.handleOnMouseDown = function () {
	      _this.setState({
	        buttonActive: true
	      });
	    };
	
	    _this.handleOnMouseUp = function () {
	      _this.setState({
	        buttonActive: false
	      });
	    };
	
	    _this.state = {
	      open: false,
	      buttonActive: false
	    };
	    return _this;
	  }
	
	  _createClass(ReactStripeCheckout, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this._isMounted = true;
	      if (scriptLoaded) {
	        return;
	      }
	
	      if (scriptLoading) {
	        return;
	      }
	
	      scriptLoading = true;
	
	      var script = document.createElement('script');
	      if (typeof this.props.onScriptTagCreated === 'function') {
	        this.props.onScriptTagCreated(script);
	      }
	
	      script.src = 'https://checkout.stripe.com/checkout.js';
	      script.async = 1;
	
	      this.loadPromise = function () {
	        var canceled = false;
	        var promise = new Promise(function (resolve, reject) {
	          script.onload = function () {
	            scriptLoaded = true;
	            scriptLoading = false;
	            resolve();
	            _this2.onScriptLoaded();
	          };
	          script.onerror = function (event) {
	            scriptDidError = true;
	            scriptLoading = false;
	            reject(event);
	            _this2.onScriptError(event);
	          };
	        });
	        var wrappedPromise = new Promise(function (accept, cancel) {
	          promise.then(function () {
	            return canceled ? cancel({ isCanceled: true }) : accept();
	          }); // eslint-disable-line no-confusing-arrow
	          promise.catch(function (error) {
	            return canceled ? cancel({ isCanceled: true }) : cancel(error);
	          }); // eslint-disable-line no-confusing-arrow
	        });
	
	        return {
	          promise: wrappedPromise,
	          cancel: function cancel() {
	            canceled = true;
	          }
	        };
	      }();
	
	      this.loadPromise.promise.then(this.onScriptLoaded).catch(this.onScriptError);
	
	      document.body.appendChild(script);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (!scriptLoading) {
	        this.updateStripeHandler();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	      if (this.loadPromise) {
	        this.loadPromise.cancel();
	      }
	      if (ReactStripeCheckout.stripeHandler && this.state.open) {
	        ReactStripeCheckout.stripeHandler.close();
	      }
	    }
	  }, {
	    key: 'updateStripeHandler',
	    value: function updateStripeHandler() {
	      if (!ReactStripeCheckout.stripeHandler || this.props.reconfigureOnUpdate) {
	        ReactStripeCheckout.stripeHandler = StripeCheckout.configure({
	          key: this.props.stripeKey
	        });
	      }
	    }
	  }, {
	    key: 'showLoadingDialog',
	    value: function showLoadingDialog() {
	      if (this.props.showLoadingDialog) {
	        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	          args[_key4] = arguments[_key4];
	        }
	
	        this.props.showLoadingDialog.apply(this, args);
	      }
	    }
	  }, {
	    key: 'hideLoadingDialog',
	    value: function hideLoadingDialog() {
	      if (this.props.hideLoadingDialog) {
	        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	          args[_key5] = arguments[_key5];
	        }
	
	        this.props.hideLoadingDialog.apply(this, args);
	      }
	    }
	  }, {
	    key: 'showStripeDialog',
	    value: function showStripeDialog() {
	      this.hideLoadingDialog();
	      ReactStripeCheckout.stripeHandler.open(this.getConfig());
	    }
	  }, {
	    key: 'renderDefaultStripeButton',
	    value: function renderDefaultStripeButton() {
	      return _react2.default.createElement(
	        'button',
	        _extends({}, _defineProperty({}, this.props.triggerEvent, this.onClick), {
	          className: this.props.className,
	          onMouseDown: this.handleOnMouseDown,
	          onFocus: this.handleOnMouseDown,
	          onMouseUp: this.handleOnMouseUp,
	          onMouseOut: this.handleOnMouseUp,
	          onBlur: this.handleOnMouseUp,
	          style: _extends({}, {
	            overflow: 'hidden',
	            display: 'inline-block',
	            background: 'linear-gradient(#28a0e5,#015e94)',
	            border: 0,
	            padding: 1,
	            textDecoration: 'none',
	            borderRadius: 5,
	            boxShadow: '0 1px 0 rgba(0,0,0,0.2)',
	            cursor: 'pointer',
	            visibility: 'visible',
	            userSelect: 'none'
	          }, this.state.buttonActive && {
	            background: '#005d93'
	          }, this.props.style)
	        }),
	        _react2.default.createElement(
	          'span',
	          {
	            style: _extends({}, {
	              backgroundImage: 'linear-gradient(#7dc5ee,#008cdd 85%,#30a2e4)',
	              fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
	              fontSize: 14,
	              position: 'relative',
	              padding: '0 12px',
	              display: 'block',
	              height: 30,
	              lineHeight: '30px',
	              color: '#fff',
	              fontWeight: 'bold',
	              boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.25)',
	              textShadow: '0 -1px 0 rgba(0,0,0,0.25)',
	              borderRadius: 4
	            }, this.state.buttonActive && {
	              color: '#eee',
	              boxShadow: 'inset 0 1px 0 rgba(0,0,0,0.1)',
	              backgroundImage: 'linear-gradient(#008cdd,#008cdd 85%,#239adf)'
	            }, this.props.textStyle)
	          },
	          this.props.label
	        )
	      );
	    }
	  }, {
	    key: 'renderDisabledButton',
	    value: function renderDisabledButton() {
	      return _react2.default.createElement(
	        'button',
	        {
	          disabled: true,
	          style: {
	            background: 'rgba(0,0,0,0.2)',
	            overflow: 'hidden',
	            display: 'inline-block',
	            border: 0,
	            padding: 1,
	            textDecoration: 'none',
	            borderRadius: 5,
	            userSelect: 'none'
	          }
	        },
	        _react2.default.createElement(
	          'span',
	          {
	            style: {
	              boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.25)',
	              fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
	              fontSize: 14,
	              position: 'relative',
	              padding: '0 12px',
	              display: 'block',
	              height: 30,
	              lineHeight: '30px',
	              borderRadius: 4,
	              color: '#999',
	              background: '#f8f9fa',
	              textShadow: '0 1px 0 rgba(255,255,255,0.5)'
	            }
	          },
	          this.props.label
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.desktopShowModal === true && !this.state.open) {
	        this.onClick();
	      } else if (this.props.desktopShowModal === false && this.state.open) {
	        ReactStripeCheckout.stripeHandler.close();
	      }
	
	      var ComponentClass = this.props.ComponentClass;
	
	      if (this.props.children) {
	        return _react2.default.createElement(ComponentClass, _extends({}, _defineProperty({}, this.props.triggerEvent, this.onClick), {
	          children: this.props.children
	        }));
	      }
	      return this.props.disabled ? this.renderDisabledButton() : this.renderDefaultStripeButton();
	    }
	  }]);
	
	  return ReactStripeCheckout;
	}(_react2.default.Component);
	
	ReactStripeCheckout.defaultProps = {
	  className: 'StripeCheckout',
	  label: 'Pay With Card',
	  locale: 'auto',
	  ComponentClass: 'span',
	  reconfigureOnUpdate: false,
	  triggerEvent: 'onClick'
	};
	ReactStripeCheckout.propTypes = {
	  // Opens / closes the checkout modal by value
	  // WARNING: does not work on mobile due to browser security restrictions
	  // NOTE: Must be set to false when receiving token to prevent modal from
	  //       opening automatically after closing
	  desktopShowModal: _propTypes2.default.bool,
	
	  triggerEvent: _propTypes2.default.oneOf(['onClick', 'onTouchTap', 'onTouchStart']),
	
	  // If included, will render the default blue button with label text.
	  // (Requires including stripe-checkout.css or adding the .styl file
	  // to your pipeline)
	  label: _propTypes2.default.string,
	
	  // Custom styling for default button
	  style: _propTypes2.default.object,
	  // Custom styling for <span> tag inside default button
	  textStyle: _propTypes2.default.object,
	
	  // Prevents any events from opening the popup
	  // Adds the disabled prop to the button and adjusts the styling as well
	  disabled: _propTypes2.default.bool,
	
	  // Named component to wrap button (eg. div)
	  ComponentClass: _propTypes2.default.string,
	
	  // Show a loading indicator
	  showLoadingDialog: _propTypes2.default.func,
	  // Hide the loading indicator
	  hideLoadingDialog: _propTypes2.default.func,
	
	  // Run this method when the scrupt fails to load. Will run if the internet
	  // connection is offline when attemting to load the script.
	  onScriptError: _propTypes2.default.func,
	
	  // Runs when the script tag is created, but before it is added to the DOM
	  onScriptTagCreated: _propTypes2.default.func,
	
	  // By default, any time the React component is updated, it will call
	  // StripeCheckout.configure, which may result in additional XHR calls to the
	  // stripe API.  If you know the first configuration is all you need, you
	  // can set this to false.  Subsequent updates will affect the StripeCheckout.open
	  // (e.g. different prices)
	  reconfigureOnUpdate: _propTypes2.default.bool,
	
	  // =====================================================
	  // Required by stripe
	  // see Stripe docs for more info:
	  //   https://stripe.com/docs/checkout#integration-custom
	  // =====================================================
	
	  // Your publishable key (test or live).
	  // can't use "key" as a prop in react, so have to change the keyname
	  stripeKey: _propTypes2.default.string.isRequired,
	
	  // The callback to invoke when the Checkout process is complete.
	  //   function(token)
	  //     token is the token object created.
	  //     token.id can be used to create a charge or customer.
	  //     token.email contains the email address entered by the user.
	  token: _propTypes2.default.func.isRequired,
	
	  // ==========================
	  // Highly Recommended Options
	  // ==========================
	
	  // Name of the company or website.
	  name: _propTypes2.default.string,
	
	  // A description of the product or service being purchased.
	  description: _propTypes2.default.string,
	
	  // A relative URL pointing to a square image of your brand or product. The
	  // recommended minimum size is 128x128px. The recommended image types are
	  // .gif, .jpeg, and .png.
	  image: _propTypes2.default.string,
	
	  // The amount (in cents) that's shown to the user. Note that you will still
	  // have to explicitly include it when you create a charge using the API.
	  amount: _propTypes2.default.number,
	
	  // Specify auto to display Checkout in the user's preferred language, if
	  // available. English will be used by default.
	  //
	  // https://stripe.com/docs/checkout#supported-languages
	  // for more info.
	  locale: _propTypes2.default.oneOf(['auto', // (Default) Automatically chosen by checkout
	  'zh', // Simplified Chinese
	  'da', // Danish
	  'nl', // Dutch
	  'en', // English
	  'fr', // French
	  'de', // German
	  'it', // Italian
	  'ja', // Japanease
	  'no', // Norwegian
	  'es', // Spanish
	  'sv']),
	
	  // ==============
	  // Optional Props
	  // ==============
	
	  // The currency of the amount (3-letter ISO code). The default is USD.
	  currency: _propTypes2.default.oneOf(['AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN', 'BAM', 'BBD', // eslint-disable-line comma-spacing
	  'BDT', 'BGN', 'BIF', 'BMD', 'BND', 'BOB', 'BRL', 'BSD', 'BWP', 'BZD', 'CAD', 'CDF', // eslint-disable-line comma-spacing
	  'CHF', 'CLP', 'CNY', 'COP', 'CRC', 'CVE', 'CZK', 'DJF', 'DKK', 'DOP', 'DZD', 'EEK', // eslint-disable-line comma-spacing
	  'EGP', 'ETB', 'EUR', 'FJD', 'FKP', 'GBP', 'GEL', 'GIP', 'GMD', 'GNF', 'GTQ', 'GYD', // eslint-disable-line comma-spacing
	  'HKD', 'HNL', 'HRK', 'HTG', 'HUF', 'IDR', 'ILS', 'INR', 'ISK', 'JMD', 'JPY', 'KES', // eslint-disable-line comma-spacing
	  'KGS', 'KHR', 'KMF', 'KRW', 'KYD', 'KZT', 'LAK', 'LBP', 'LKR', 'LRD', 'LSL', 'LTL', // eslint-disable-line comma-spacing
	  'LVL', 'MAD', 'MDL', 'MGA', 'MKD', 'MNT', 'MOP', 'MRO', 'MUR', 'MVR', 'MWK', 'MXN', // eslint-disable-line comma-spacing
	  'MYR', 'MZN', 'NAD', 'NGN', 'NIO', 'NOK', 'NPR', 'NZD', 'PAB', 'PEN', 'PGK', 'PHP', // eslint-disable-line comma-spacing
	  'PKR', 'PLN', 'PYG', 'QAR', 'RON', 'RSD', 'RUB', 'RWF', 'SAR', 'SBD', 'SCR', 'SEK', // eslint-disable-line comma-spacing
	  'SGD', 'SHP', 'SLL', 'SOS', 'SRD', 'STD', 'SVC', 'SZL', 'THB', 'TJS', 'TOP', 'TRY', // eslint-disable-line comma-spacing
	  'TTD', 'TWD', 'TZS', 'UAH', 'UGX', 'USD', 'UYU', 'UZS', 'VND', 'VUV', 'WST', 'XAF', // eslint-disable-line comma-spacing
	  'XCD', 'XOF', 'XPF', 'YER', 'ZAR', 'ZMW']),
	
	  // The label of the payment button in the Checkout form (e.g. “Subscribe”,
	  // “Pay {{amount}}”, etc.). If you include {{amount}}, it will be replaced
	  // by the provided amount. Otherwise, the amount will be appended to the
	  // end of your label.
	  panelLabel: _propTypes2.default.string,
	
	  // Specify whether Checkout should validate the billing ZIP code (true or
	  // false)
	  zipCode: _propTypes2.default.bool,
	
	  // Specify whether Checkout should collect the user's billing address
	  // (true or false). The default is false.
	  billingAddress: _propTypes2.default.bool,
	
	  // Specify whether Checkout should collect the user's shipping address
	  // (true or false). The default is false.
	  shippingAddress: _propTypes2.default.bool,
	
	  // Specify whether Checkout should validate the billing ZIP code (true or
	  // false). The default is false.
	  email: _propTypes2.default.string,
	
	  // Specify whether to include the option to "Remember Me" for future
	  // purchases (true or false). The default is true.
	  allowRememberMe: _propTypes2.default.bool,
	
	  // Specify whether to accept Bitcoin in Checkout. The default is false.
	  bitcoin: _propTypes2.default.bool,
	
	  // Specify whether to accept Alipay ('auto', true, or false). The default
	  // is false.
	  alipay: _propTypes2.default.oneOf(['auto', true, false]),
	
	  // Specify if you need reusable access to the customer's Alipay account
	  // (true or false). The default is false.
	  alipayReusable: _propTypes2.default.bool,
	
	  // function() The callback to invoke when Checkout is opened (not supported
	  // in IE6 and IE7).
	  opened: _propTypes2.default.func,
	
	  // function() The callback to invoke when Checkout is closed (not supported
	  // in IE6 and IE7).
	  closed: _propTypes2.default.func
	};
	ReactStripeCheckout._isMounted = false;
	exports.default = ReactStripeCheckout;


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontIcon = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var FontIcon = function FontIcon(_ref) {
	  var alt = _ref.alt,
	      children = _ref.children,
	      className = _ref.className,
	      theme = _ref.theme,
	      value = _ref.value,
	      other = _objectWithoutProperties(_ref, ['alt', 'children', 'className', 'theme', 'value']);
	
	  return (// eslint-disable-line
	    _react2.default.createElement(
	      'span',
	      _extends({
	        'data-react-toolbox': 'font-icon',
	        'aria-label': alt,
	        className: (0, _classnames2.default)({ 'material-icons': typeof value === 'string' || typeof children === 'string' }, className)
	      }, other),
	      value,
	      children
	    )
	  );
	};
	
	FontIcon.propTypes = {
	  alt: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  theme: _propTypes2.default.object, // eslint-disable-line
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
	};
	
	FontIcon.defaultProps = {
	  alt: '',
	  className: ''
	};
	
	exports.default = FontIcon;
	exports.FontIcon = FontIcon;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isValuePresent = exports.getAnimationModule = exports.removeNamespace = exports.transformKeys = exports.prepareValueForInput = exports.inputTypeForPrototype = exports.cloneObject = exports.getViewport = exports.round = exports.range = exports.angle360FromPositions = exports.angleFromPositions = undefined;
	
	var _assoc = __webpack_require__(694);
	
	var _assoc2 = _interopRequireDefault(_assoc);
	
	var _compose = __webpack_require__(696);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _keys = __webpack_require__(398);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _reduce = __webpack_require__(399);
	
	var _reduce2 = _interopRequireDefault(_reduce);
	
	var _pickBy = __webpack_require__(703);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var angleFromPositions = exports.angleFromPositions = function angleFromPositions(cx, cy, ex, ey) {
	  var theta = Math.atan2(ey - cy, ex - cx) + Math.PI / 2;
	  return theta * 180 / Math.PI;
	};
	
	var angle360FromPositions = exports.angle360FromPositions = function angle360FromPositions(cx, cy, ex, ey) {
	  var angle = angleFromPositions(cx, cy, ex, ey);
	  return angle < 0 ? 360 + angle : angle;
	};
	
	var range = exports.range = function range() {
	  var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var stop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	  var _start = 0,
	      _stop = start;
	
	  if (stop !== null) {
	    _start = start;
	    _stop = stop;
	  }
	  var length = Math.max(Math.ceil((_stop - _start) / step), 0);
	  var _range = Array(length);
	
	  for (var idx = 0; idx < length; idx += 1, _start += step) {
	    _range[idx] = _start;
	  }
	
	  return _range;
	};
	
	var round = exports.round = function round(number, decimals) {
	  if (!isNaN(parseFloat(number)) && isFinite(number)) {
	    var decimalPower = Math.pow(10, decimals);
	    return Math.round(parseFloat(number) * decimalPower) / decimalPower;
	  }
	  return NaN;
	};
	
	var getViewport = exports.getViewport = function getViewport() {
	  return {
	    height: window.innerHeight || document.documentElement.offsetHeight,
	    width: window.innerWidth || document.documentElement.offsetWidth
	  };
	};
	
	var cloneObject = exports.cloneObject = function cloneObject(object) {
	  return JSON.parse(JSON.stringify(object));
	};
	
	var inputTypeForPrototype = exports.inputTypeForPrototype = function inputTypeForPrototype(prototype) {
	  if (prototype === Date) return 'date';
	  if (prototype === Number) return 'number';
	  if (prototype === Boolean) return 'checkbox';
	  return 'text';
	};
	
	var prepareValueForInput = exports.prepareValueForInput = function prepareValueForInput(value, type) {
	  if (type === 'date') return new Date(value).toISOString().slice(0, 10);
	  if (type === 'checkbox') {
	    return value ? 'on' : '';
	  }
	  return value;
	};
	
	var transformKeys = exports.transformKeys = function transformKeys(fn) {
	  return function (obj) {
	    var addTransformedKey = function addTransformedKey(result, key) {
	      return (0, _assoc2.default)(fn(key), obj[key], result);
	    };
	    return (0, _reduce2.default)(addTransformedKey, {}, (0, _keys2.default)(obj));
	  };
	};
	
	var removeNamespace = exports.removeNamespace = function removeNamespace(namespace) {
	  return function (key) {
	    var capitalized = key.substr(namespace.length);
	    return capitalized.slice(0, 1).toLowerCase() + capitalized.slice(1);
	  };
	};
	
	var getAnimationModule = exports.getAnimationModule = function getAnimationModule(animation, theme) {
	  return (0, _compose2.default)(transformKeys(removeNamespace(animation)), (0, _pickBy2.default)(function (v, k) {
	    return k.startsWith(animation);
	  }))(theme);
	};
	
	var isValuePresent = exports.isValuePresent = function isValuePresent(value) {
	  return value !== null && value !== undefined && value !== '' && !(typeof value === 'number' && isNaN(value));
	};

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(87);
	
	var ReactNoopUpdateQueue = __webpack_require__(190);
	
	var canDefineProperty = __webpack_require__(463);
	var emptyObject = __webpack_require__(72);
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(14);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(14);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 191 */
/***/ function(module, exports) {

	/**
	 * Ensure some object is a coerced to a string
	 **/
	module.exports = function makeString(object) {
	  if (object == null) return '';
	  return '' + object;
	};


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFQDN;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	var _merge = _interopRequireDefault(__webpack_require__(63));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_fqdn_options = {
	  require_tld: true,
	  allow_underscores: false,
	  allow_trailing_dot: false
	};
	
	function isFQDN(str, options) {
	  (0, _assertString.default)(str);
	  options = (0, _merge.default)(options, default_fqdn_options);
	  /* Remove the optional trailing dot before checking validity */
	
	  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
	    str = str.substring(0, str.length - 1);
	  }
	
	  var parts = str.split('.');
	
	  for (var i = 0; i < parts.length; i++) {
	    if (parts[i].length > 63) {
	      return false;
	    }
	  }
	
	  if (options.require_tld) {
	    var tld = parts.pop();
	
	    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
	      return false;
	    } // disallow spaces
	
	
	    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
	      return false;
	    }
	  }
	
	  for (var part, _i = 0; _i < parts.length; _i++) {
	    part = parts[_i];
	
	    if (options.allow_underscores) {
	      part = part.replace(/_/g, '');
	    }
	
	    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
	      return false;
	    } // disallow full-width chars
	
	
	    if (/[\uff01-\uff5e]/.test(part)) {
	      return false;
	    }
	
	    if (part[0] === '-' || part[part.length - 1] === '-') {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toDate(date) {
	  (0, _assertString.default)(date);
	  date = Date.parse(date);
	  return !isNaN(date) ? new Date(date) : null;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 194 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var includes = function includes(arr, val) {
	  return arr.some(function (arrVal) {
	    return val === arrVal;
	  });
	};
	
	var _default = includes;
	exports.default = _default;
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	var settle = __webpack_require__(492);
	var cookies = __webpack_require__(495);
	var buildURL = __webpack_require__(202);
	var buildFullPath = __webpack_require__(489);
	var parseHeaders = __webpack_require__(500);
	var isURLSameOrigin = __webpack_require__(498);
	var createError = __webpack_require__(198);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    var fullPath = buildFullPath(config.baseURL, config.url);
	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request.onreadystatechange = function handleLoad() {
	      if (!request || request.readyState !== 4) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }
	
	      reject(createError('Request aborted', config, 'ECONNABORTED', request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }
	      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (!utils.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (!requestData) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 196 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 197 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(491);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	
	/**
	 * Config-specific merge-function which creates a new config-object
	 * by merging two configuration objects together.
	 *
	 * @param {Object} config1
	 * @param {Object} config2
	 * @returns {Object} New object resulting from merging config2 to config1
	 */
	module.exports = function mergeConfig(config1, config2) {
	  // eslint-disable-next-line no-param-reassign
	  config2 = config2 || {};
	  var config = {};
	
	  var valueFromConfig2Keys = ['url', 'method', 'data'];
	  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
	  var defaultToConfig2Keys = [
	    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
	    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
	    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
	    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
	    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
	  ];
	  var directMergeKeys = ['validateStatus'];
	
	  function getMergedValue(target, source) {
	    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
	      return utils.merge(target, source);
	    } else if (utils.isPlainObject(source)) {
	      return utils.merge({}, source);
	    } else if (utils.isArray(source)) {
	      return source.slice();
	    }
	    return source;
	  }
	
	  function mergeDeepProperties(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(config1[prop], config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(undefined, config2[prop]);
	    }
	  });
	
	  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
	
	  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(undefined, config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  });
	
	  utils.forEach(directMergeKeys, function merge(prop) {
	    if (prop in config2) {
	      config[prop] = getMergedValue(config1[prop], config2[prop]);
	    } else if (prop in config1) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  });
	
	  var axiosKeys = valueFromConfig2Keys
	    .concat(mergeDeepPropertiesKeys)
	    .concat(defaultToConfig2Keys)
	    .concat(directMergeKeys);
	
	  var otherKeys = Object
	    .keys(config1)
	    .concat(Object.keys(config2))
	    .filter(function filterAxiosKeys(key) {
	      return axiosKeys.indexOf(key) === -1;
	    });
	
	  utils.forEach(otherKeys, mergeDeepProperties);
	
	  return config;
	};


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(28);
	var normalizeHeaderName = __webpack_require__(499);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(195);
	  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(195);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Accept');
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	  maxBodyLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75)))

/***/ },
/* 201 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    var hashmarkIndex = url.indexOf('#');
	    if (hashmarkIndex !== -1) {
	      url = url.slice(0, hashmarkIndex);
	    }
	
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 203 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	
			/*Common alerts  */
			invalidEmail: 'Please enter valid email address',
	
			/* promo poup */
			promopopSuc: 'Success! Please check your email for more information.',
			promopopFail: "Currently you don't have any available coupon code",
	
			/* promotion module */
			promoRequired: "The Promo code field is Required.",
			promoCodeDeliveryAlert: "This promo code only for delivery orders.",
			promoPaymentText: "Promotion",
			stripeMinPaymentText: "Minimum payment $0.50",
	
			/* points module */
	
			pointsRequired: "Please enter a valid point value"
	
	};

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(211), __esModule: true };

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(73);
	
	var callBind = __webpack_require__(206);
	
	var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
	
	module.exports = function callBoundIntrinsic(name, allowMissing) {
		var intrinsic = GetIntrinsic(name, !!allowMissing);
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBind(intrinsic);
		}
		return intrinsic;
	};


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(236);
	var GetIntrinsic = __webpack_require__(73);
	
	var $apply = GetIntrinsic('%Function.prototype.apply%');
	var $call = GetIntrinsic('%Function.prototype.call%');
	var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
	
	var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
	var $max = GetIntrinsic('%Math.max%');
	
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = null;
		}
	}
	
	module.exports = function callBind(originalFunction) {
		var func = $reflectApply(bind, $call, arguments);
		if ($gOPD && $defineProperty) {
			var desc = $gOPD(func, 'length');
			if (desc.configurable) {
				// original length, plus the receiver, minus any additional arguments (after the receiver)
				$defineProperty(
					func,
					'length',
					{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
				);
			}
		}
		return func;
	};
	
	var applyBind = function applyBind() {
		return $reflectApply(bind, $apply, arguments);
	};
	
	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}


/***/ },
/* 207 */
/***/ function(module, exports) {

	module.exports = function forEach(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(i, arr[i]);
	  }
	};


/***/ },
/* 208 */
/***/ function(module, exports) {

	module.exports = function(arr, obj){
	  if (arr.indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(577);
	module.exports = __webpack_require__(32).Object.assign;


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(578);
	var $Object = __webpack_require__(32).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(579);
	var $Object = __webpack_require__(32).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(582);
	module.exports = __webpack_require__(32).Object.setPrototypeOf;


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(585);
	__webpack_require__(583);
	__webpack_require__(586);
	__webpack_require__(587);
	module.exports = __webpack_require__(32).Symbol;


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(584);
	__webpack_require__(588);
	module.exports = __webpack_require__(143).f('iterator');


/***/ },
/* 215 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(560);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(68);
	var document = __webpack_require__(41).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(40) && !__webpack_require__(66)(function () {
	  return Object.defineProperty(__webpack_require__(217)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(215);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(105);
	var $export = __webpack_require__(52);
	var redefine = __webpack_require__(226);
	var hide = __webpack_require__(67);
	var Iterators = __webpack_require__(134);
	var $iterCreate = __webpack_require__(566);
	var setToStringTag = __webpack_require__(137);
	var getPrototypeOf = __webpack_require__(223);
	var ITERATOR = __webpack_require__(70)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(106);
	var createDesc = __webpack_require__(107);
	var toIObject = __webpack_require__(69);
	var toPrimitive = __webpack_require__(141);
	var has = __webpack_require__(53);
	var IE8_DOM_DEFINE = __webpack_require__(218);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(40) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(224);
	var hiddenKeys = __webpack_require__(133).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(53);
	var toObject = __webpack_require__(92);
	var IE_PROTO = __webpack_require__(138)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(53);
	var toIObject = __webpack_require__(69);
	var arrayIndexOf = __webpack_require__(562)(false);
	var IE_PROTO = __webpack_require__(138)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(52);
	var core = __webpack_require__(32);
	var fails = __webpack_require__(66);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(67);


/***/ },
/* 227 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function contains(other) {
		if (arguments.length < 1) {
			throw new TypeError('1 argument is required');
		}
		if (typeof other !== 'object') {
			throw new TypeError('Argument 1 (”other“) to Node.contains must be an instance of Node');
		}
	
		var node = other;
		do {
			if (this === node) {
				return true;
			}
			if (node) {
				node = node.parentNode;
			}
		} while (node);
	
		return false;
	};


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(227);
	
	module.exports = function getPolyfill() {
		if (typeof document !== 'undefined') {
			if (document.contains) {
				return document.contains;
			}
			if (document.body && document.body.contains) {
				try {
					if (typeof document.body.contains.call(document, '') === 'boolean') {
						return document.body.contains;
					}
				} catch (e) { /**/ }
			}
		}
		return implementation;
	};


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	var prefix = __webpack_require__(688)
	var toCamelCase = __webpack_require__(946)
	var cache = { 'float': 'cssFloat' }
	var addPxToStyle = __webpack_require__(480)
	
	function style (element, property, value) {
	  var camel = cache[property]
	  if (typeof camel === 'undefined') {
	    camel = detect(property)
	  }
	
	  // may be false if CSS prop is unsupported
	  if (camel) {
	    if (value === undefined) {
	      return element.style[camel]
	    }
	
	    element.style[camel] = addPxToStyle(camel, value)
	  }
	}
	
	function each (element, properties) {
	  for (var k in properties) {
	    if (properties.hasOwnProperty(k)) {
	      style(element, k, properties[k])
	    }
	  }
	}
	
	function detect (cssProp) {
	  var camel = toCamelCase(cssProp)
	  var result = prefix(camel)
	  cache[camel] = cache[cssProp] = cache[result] = result
	  return result
	}
	
	function set () {
	  if (arguments.length === 2) {
	    if (typeof arguments[1] === 'string') {
	      arguments[0].style.cssText = arguments[1]
	    } else {
	      each(arguments[0], arguments[1])
	    }
	  } else {
	    style(arguments[0], arguments[1], arguments[2])
	  }
	}
	
	module.exports = set
	module.exports.set = set
	
	module.exports.get = function (element, properties) {
	  if (Array.isArray(properties)) {
	    return properties.reduce(function (obj, prop) {
	      obj[prop] = style(element, prop || '')
	      return obj
	    }, {})
	  } else {
	    return style(element, properties || '')
	  }
	}


/***/ },
/* 230 */
/***/ function(module, exports) {

	// This object will be used as the prototype for Nodes when creating a
	// DOM-Level-1-compliant structure.
	var NodePrototype = module.exports = {
		get firstChild() {
			var children = this.children;
			return children && children[0] || null;
		},
		get lastChild() {
			var children = this.children;
			return children && children[children.length - 1] || null;
		},
		get nodeType() {
			return nodeTypes[this.type] || nodeTypes.element;
		}
	};
	
	var domLvl1 = {
		tagName: "name",
		childNodes: "children",
		parentNode: "parent",
		previousSibling: "prev",
		nextSibling: "next",
		nodeValue: "data"
	};
	
	var nodeTypes = {
		element: 1,
		text: 3,
		cdata: 4,
		comment: 8
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(NodePrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ },
/* 231 */
/***/ function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ },
/* 232 */
71,
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(34);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 234 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 235 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(628);
	
	module.exports = Function.prototype.bind || implementation;


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getUserLocales = exports.getUserLocale = exports["default"] = void 0;
	
	var _lodash = _interopRequireDefault(__webpack_require__(679));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function resolver(options) {
	  return JSON.stringify(options);
	}
	
	function uniqDefined(arr) {
	  return arr.filter(function (el, index) {
	    return el && arr.indexOf(el) === index;
	  });
	}
	
	function normalizeLocales(arr) {
	  return arr.map(function (el) {
	    if (!el || el.indexOf('-') === -1 || el.toLowerCase() !== el) {
	      return el;
	    }
	
	    var splitEl = el.split('-');
	    return splitEl[0] + "-" + splitEl[1].toUpperCase();
	  });
	}
	
	function getUserLocalesInternal(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$useFallbackLocal = _ref.useFallbackLocale,
	      useFallbackLocale = _ref$useFallbackLocal === void 0 ? true : _ref$useFallbackLocal,
	      _ref$fallbackLocale = _ref.fallbackLocale,
	      fallbackLocale = _ref$fallbackLocale === void 0 ? 'en-US' : _ref$fallbackLocale;
	
	  var languageList = [];
	
	  if (typeof window !== 'undefined') {
	    var _window = window,
	        navigator = _window.navigator;
	    languageList = languageList.concat(navigator.languages, navigator.language, navigator.userLanguage, navigator.browserLanguage, navigator.systemLanguage);
	  }
	
	  if (useFallbackLocale) {
	    languageList.push(fallbackLocale);
	  }
	
	  return normalizeLocales(uniqDefined(languageList));
	}
	
	var getUserLocales = (0, _lodash["default"])(getUserLocalesInternal, resolver);
	exports.getUserLocales = getUserLocales;
	
	function getUserLocaleInternal(options) {
	  return getUserLocales(options)[0] || null;
	}
	
	var getUserLocale = (0, _lodash["default"])(getUserLocaleInternal, resolver);
	exports.getUserLocale = getUserLocale;
	var _default = getUserLocale;
	exports["default"] = _default;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(73);
	
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
	
	var hasPropertyDescriptors = function hasPropertyDescriptors() {
		if ($defineProperty) {
			try {
				$defineProperty({}, 'a', { value: 1 });
				return true;
			} catch (e) {
				// IE 8 has a broken defineProperty
				return false;
			}
		}
		return false;
	};
	
	hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
		// node v0.6 has a bug where array lengths can be Set but not Defined
		if (!hasPropertyDescriptors()) {
			return null;
		}
		try {
			return $defineProperty([], 'length', { value: 1 }).length !== 1;
		} catch (e) {
			// In Firefox 4-22, defining length on an array throws an exception.
			return true;
		}
	};
	
	module.exports = hasPropertyDescriptors;


/***/ },
/* 239 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(150);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(693);
	
	var _runTransitionHook = __webpack_require__(150);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(74);
	
	var _PathUtils = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },
/* 243 */
/***/ function(module, exports) {

	'use strict';
	function alwaysValid() {
	  return true;
	}
	
	module.exports = {
	  alwaysValid: alwaysValid,
	};


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var utils = __webpack_require__(246);
	
	// eslint-disable-next-line max-len
	// https://github.com/facebook/react/blob/15.0-stable/src/renderers/dom/shared/ReactDOMComponent.js#L457
	var voidElementTags = [
	  'area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param',
	  'source', 'track', 'wbr', 'menuitem', 'textarea',
	];
	
	function ProcessNodeDefinitions() {
	  function processDefaultNode(node, children, index) {
	    if (node.type === 'text') {
	      return node.data;
	    } else if (node.type === 'comment') {
	      // FIXME: The following doesn't work as the generated HTML results in
	      // "&lt;!--  This is a comment  --&gt;"
	      // return '<!-- ' + node.data + ' -->';
	      return false;
	    }
	
	    if (voidElementTags.indexOf(node.name) > -1) {
	      return utils.createElement(node, index);
	    } else {
	      return utils.createElement(node, index, node.data, children);
	    }
	  }
	
	  return {
	    processDefaultNode: processDefaultNode,
	  };
	}
	
	module.exports = ProcessNodeDefinitions;


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ShouldProcessNodeDefinitions = __webpack_require__(641);
	var ProcessNodeDefinitions = __webpack_require__(244);
	
	function ProcessingInstructions() {
	  var processNodeDefinitions = new ProcessNodeDefinitions();
	
	  return {
	    defaultProcessingInstructions: [{
	      shouldProcessNode: ShouldProcessNodeDefinitions.shouldProcessEveryNode,
	      processNode: processNodeDefinitions.processDefaultNode,
	    },],
	  };
	};
	
	module.exports = ProcessingInstructions;


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var camelize = __webpack_require__(949);
	var toPairs = __webpack_require__(665);
	var reduce = __webpack_require__(663);
	var React = __webpack_require__(1);
	var camelCaseAttrMap = __webpack_require__(639);
	
	function createStyleJsonFromString(styleString) {
	  styleString = styleString || '';
	  var styles = styleString.split(/;(?!base64)/);
	  var singleStyle, key, value, jsonStyles = {};
	  for (var i = 0; i < styles.length; ++i) {
	    singleStyle = styles[i].split(':');
	    if (singleStyle.length > 2) {
	      singleStyle[1] = singleStyle.slice(1).join(':');
	    }
	    
	    key = camelize(singleStyle[0]);
	    value = singleStyle[1];
	    if (typeof value === 'string'){
	      value = value.trim();
	    }
	
	    if (key.length > 0 && value.length > 0) {
	      jsonStyles[key] = value;
	    }
	  }
	  return jsonStyles;
	}
	
	function createElement(node, index, data, children) {
	  var elementProps = {
	    key: index,
	  };
	  if (node.attribs) {
	    elementProps = reduce(function(result, keyAndValue) {
	      var key = keyAndValue[0];
	      var value = keyAndValue[1];
	      key = camelCaseAttrMap[key.replace(/[-:]/, '')] || key;
	      if (key === 'style') {
	        value = createStyleJsonFromString(value);
	      } else if (key === 'class') {
	        key = 'className';
	      } else if (key === 'for') {
	        key = 'htmlFor';
	      }
	      if (typeof value === 'string') {
	        value = value;
	      }
	      result[key] = value || key;
	      return result;
	    }, elementProps, toPairs(node.attribs));
	  }
	
	  children = children || [];
	  var allChildren = data != null ? [data,].concat(children) : children;
	  return React.createElement.apply(
	    null, [node.name, elementProps,].concat(allChildren)
	  );
	}
	
	module.exports = {
	  createElement: createElement,
	};


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(152);
	var _curry1 = __webpack_require__(55);
	var _curry2 = __webpack_require__(36);
	var _curryN = __webpack_require__(649);
	
	
	/**
	 * Returns a curried equivalent of the provided function, with the specified
	 * arity. The curried function has two unusual capabilities. First, its
	 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
	 * the following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.5.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curry
	 * @example
	 *
	 *      var sumArgs = (...args) => R.sum(args);
	 *
	 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
	 *      var f = curriedAddFourNumbers(1, 2);
	 *      var g = f(3);
	 *      g(4); //=> 10
	 */
	module.exports = _curry2(function curryN(length, fn) {
	  if (length === 1) {
	    return _curry1(fn);
	  }
	  return _arity(length, _curryN(length, [], fn));
	});


/***/ },
/* 248 */
/***/ function(module, exports) {

	/**
	 * Tests whether or not an object is an array.
	 *
	 * @private
	 * @param {*} val The object to test.
	 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
	 * @example
	 *
	 *      _isArray([]); //=> true
	 *      _isArray(null); //=> false
	 *      _isArray({}); //=> false
	 */
	module.exports = Array.isArray || function _isArray(val) {
	  return (val != null &&
	          val.length >= 0 &&
	          Object.prototype.toString.call(val) === '[object Array]');
	};


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(55);
	var _has = __webpack_require__(154);
	var _isArguments = __webpack_require__(651);
	
	
	/**
	 * Returns a list containing the names of all the enumerable own properties of
	 * the supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own properties.
	 * @see R.keysIn, R.values
	 * @example
	 *
	 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
	 */
	module.exports = (function() {
	  // cover IE < 9 keys issues
	  var hasEnumBug = !({toString: null}).propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString',
	                            'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	  // Safari bug
	  var hasArgsEnumBug = (function() {
	    'use strict';
	    return arguments.propertyIsEnumerable('length');
	  }());
	
	  var contains = function contains(list, item) {
	    var idx = 0;
	    while (idx < list.length) {
	      if (list[idx] === item) {
	        return true;
	      }
	      idx += 1;
	    }
	    return false;
	  };
	
	  return typeof Object.keys === 'function' && !hasArgsEnumBug ?
	    _curry1(function keys(obj) {
	      return Object(obj) !== obj ? [] : Object.keys(obj);
	    }) :
	    _curry1(function keys(obj) {
	      if (Object(obj) !== obj) {
	        return [];
	      }
	      var prop, nIdx;
	      var ks = [];
	      var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
	      for (prop in obj) {
	        if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
	          ks[ks.length] = prop;
	        }
	      }
	      if (hasEnumBug) {
	        nIdx = nonEnumerableProps.length - 1;
	        while (nIdx >= 0) {
	          prop = nonEnumerableProps[nIdx];
	          if (_has(prop, obj) && !contains(ks, prop)) {
	            ks[ks.length] = prop;
	          }
	          nIdx -= 1;
	        }
	      }
	      return ks;
	    });
	}());


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Libya) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays:
	            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	                '_'
	            ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone:
	                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone:
	                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                    '_'
	                ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	                '_'
	            ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays:
	            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	                '_'
	            ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex =
	            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone:
	                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                    '_'
	                ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	                '_'
	            ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = {
	            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	                '_'
	            ),
	            standalone:
	                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
	                    '_'
	                ),
	        },
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex =
	            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex:
	            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex:
	            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays:
	            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	                '_'
	            ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays:
	            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl:
	            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	                '_'
	            ),
	        monthsGenitiveEl:
	            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	                '_'
	            ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays:
	            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	                '_'
	            ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort:
	            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	                '_'
	            ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	                '_'
	            ),
	        weekdays:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast =
	            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	                ' '
	            ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort:
	            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	                '_'
	            ),
	        weekdays:
	            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	                '_'
	            ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex =
	            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort:
	            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone:
	                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                    '_'
	                ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone:
	                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                    '_'
	                ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort:
	            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort:
	            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse:
	            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone:
	                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex:
	            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex:
	            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone:
	                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings =
	        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone:
	                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays:
	            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	                '_'
	            ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone:
	                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                    '_'
	                ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(
	                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
	                    function ($0, $1, $2) {
	                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                    }
	                );
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort:
	            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	                '_'
	            ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort:
	            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays:
	            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	                '_'
	            ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone:
	                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                    '_'
	                ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone:
	                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                    '_'
	                ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays:
	            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort:
	            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	                '_'
	            ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	                '_'
	            ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort:
	            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays:
	            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	                '_'
	            ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            w: 'en uke',
	            ww: '%d uker',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone:
	                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                    '_'
	                ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	                '_'
	            ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative =
	            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	                '_'
	            ),
	        monthsSubjective =
	            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	                '_'
	            ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays:
	            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort:
	            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone:
	                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                    '_'
	                ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone:
	                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                    '_'
	                ),
	        },
	        weekdays: {
	            standalone:
	                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                    '_'
	                ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex:
	            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex:
	            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort:
	            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays:
	            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	                '_'
	            ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays:
	            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	                '_'
	            ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months =
	            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	                '_'
	            ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једног минута'],
	            mm: ['минут', 'минута', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            d: ['један дан', 'једног дана'],
	            dd: ['дан', 'дана', 'дана'],
	            M: ['један месец', 'једног месеца'],
	            MM: ['месец', 'месеца', 'месеци'],
	            y: ['једну годину', 'једне године'],
	            yy: ['годину', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'једна година';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'годину') {
	                return number + ' година';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort:
	            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            d: ['jedan dan', 'jednog dana'],
	            dd: ['dan', 'dana', 'dana'],
	            M: ['jedan mesec', 'jednog meseca'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            y: ['jednu godinu', 'jedne godine'],
	            yy: ['godinu', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'jedna godina';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'godinu') {
	                return number + ' godina';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays:
	            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	                '_'
	            ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays:
	            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	                '_'
	            ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort:
	            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	                '_'
	            ),
	        weekdays:
	            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	                '_'
	            ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort:
	            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	                '_'
	            ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone:
	                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort:
	            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort:
	            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort:
	            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	                '_'
	            ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	                '_'
	            ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	                '_'
	            ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative:
	                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                        '_'
	                    ),
	                accusative:
	                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                        '_'
	                    ),
	                genitive:
	                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                        '_'
	                    ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone:
	                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays:
	            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	                '_'
	            ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort:
	            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort:
	            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	                '_'
	            ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(386);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(682);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ },
/* 386 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var RequireObjectCoercible = __webpack_require__(609);
	var callBound = __webpack_require__(205);
	
	var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');
	var $push = callBound('Array.prototype.push');
	
	module.exports = function values(O) {
		var obj = RequireObjectCoercible(O);
		var vals = [];
		for (var key in obj) {
			if ($isEnumerable(obj, key)) { // checks own-ness as well
				$push(vals, obj[key]);
			}
		}
		return vals;
	};


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(387);
	
	module.exports = function getPolyfill() {
		return typeof Object.values === 'function' ? Object.values : implementation;
	};


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*!
	 * Platform.js <https://mths.be/platform>
	 * Copyright 2014-2016 Benjamin Tan <https://demoneaux.github.io/>
	 * Copyright 2011-2013 John-David Dalton <http://allyoucanleet.com/>
	 * Available under MIT license <https://mths.be/mit>
	 */
	;(function() {
	  'use strict';
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used as a reference to the global object. */
	  var root = (objectTypes[typeof window] && window) || this;
	
	  /** Backup possible global object. */
	  var oldRoot = root;
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global;
	  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
	    root = freeGlobal;
	  }
	
	  /**
	   * Used as the maximum length of an array-like object.
	   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
	   * for more details.
	   */
	  var maxSafeInteger = Math.pow(2, 53) - 1;
	
	  /** Regular expression to detect Opera. */
	  var reOpera = /\bOpera/;
	
	  /** Possible global object. */
	  var thisBinding = this;
	
	  /** Used for native method references. */
	  var objectProto = Object.prototype;
	
	  /** Used to check for own properties of an object. */
	  var hasOwnProperty = objectProto.hasOwnProperty;
	
	  /** Used to resolve the internal `[[Class]]` of values. */
	  var toString = objectProto.toString;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Capitalizes a string value.
	   *
	   * @private
	   * @param {string} string The string to capitalize.
	   * @returns {string} The capitalized string.
	   */
	  function capitalize(string) {
	    string = String(string);
	    return string.charAt(0).toUpperCase() + string.slice(1);
	  }
	
	  /**
	   * A utility function to clean up the OS name.
	   *
	   * @private
	   * @param {string} os The OS name to clean up.
	   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
	   * @param {string} [label] A label for the OS.
	   */
	  function cleanupOS(os, pattern, label) {
	    // Platform tokens are defined at:
	    // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
	    // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
	    var data = {
	      '10.0': '10',
	      '6.4':  '10 Technical Preview',
	      '6.3':  '8.1',
	      '6.2':  '8',
	      '6.1':  '7 / Server 2008 R2',
	      '6.0':  'Vista / Server 2008',
	      '5.2':  'XP 64-bit / Server 2003',
	      '5.1':  'XP',
	      '5.01': '2000 SP1',
	      '5.0':  '2000',
	      '4.0':  'NT',
	      '4.90': 'ME'
	    };
	    // Detect Windows version from platform tokens.
	    if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) &&
	        (data = data[/[\d.]+$/.exec(os)])) {
	      os = 'Windows ' + data;
	    }
	    // Correct character case and cleanup string.
	    os = String(os);
	
	    if (pattern && label) {
	      os = os.replace(RegExp(pattern, 'i'), label);
	    }
	
	    os = format(
	      os.replace(/ ce$/i, ' CE')
	        .replace(/\bhpw/i, 'web')
	        .replace(/\bMacintosh\b/, 'Mac OS')
	        .replace(/_PowerPC\b/i, ' OS')
	        .replace(/\b(OS X) [^ \d]+/i, '$1')
	        .replace(/\bMac (OS X)\b/, '$1')
	        .replace(/\/(\d)/, ' $1')
	        .replace(/_/g, '.')
	        .replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '')
	        .replace(/\bx86\.64\b/gi, 'x86_64')
	        .replace(/\b(Windows Phone) OS\b/, '$1')
	        .replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1')
	        .split(' on ')[0]
	    );
	
	    return os;
	  }
	
	  /**
	   * An iteration utility for arrays and objects.
	   *
	   * @private
	   * @param {Array|Object} object The object to iterate over.
	   * @param {Function} callback The function called per iteration.
	   */
	  function each(object, callback) {
	    var index = -1,
	        length = object ? object.length : 0;
	
	    if (typeof length == 'number' && length > -1 && length <= maxSafeInteger) {
	      while (++index < length) {
	        callback(object[index], index, object);
	      }
	    } else {
	      forOwn(object, callback);
	    }
	  }
	
	  /**
	   * Trim and conditionally capitalize string values.
	   *
	   * @private
	   * @param {string} string The string to format.
	   * @returns {string} The formatted string.
	   */
	  function format(string) {
	    string = trim(string);
	    return /^(?:webOS|i(?:OS|P))/.test(string)
	      ? string
	      : capitalize(string);
	  }
	
	  /**
	   * Iterates over an object's own properties, executing the `callback` for each.
	   *
	   * @private
	   * @param {Object} object The object to iterate over.
	   * @param {Function} callback The function executed per own property.
	   */
	  function forOwn(object, callback) {
	    for (var key in object) {
	      if (hasOwnProperty.call(object, key)) {
	        callback(object[key], key, object);
	      }
	    }
	  }
	
	  /**
	   * Gets the internal `[[Class]]` of a value.
	   *
	   * @private
	   * @param {*} value The value.
	   * @returns {string} The `[[Class]]`.
	   */
	  function getClassOf(value) {
	    return value == null
	      ? capitalize(value)
	      : toString.call(value).slice(8, -1);
	  }
	
	  /**
	   * Host objects can return type values that are different from their actual
	   * data type. The objects we are concerned with usually return non-primitive
	   * types of "object", "function", or "unknown".
	   *
	   * @private
	   * @param {*} object The owner of the property.
	   * @param {string} property The property to check.
	   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
	   */
	  function isHostType(object, property) {
	    var type = object != null ? typeof object[property] : 'number';
	    return !/^(?:boolean|number|string|undefined)$/.test(type) &&
	      (type == 'object' ? !!object[property] : true);
	  }
	
	  /**
	   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
	   *
	   * @private
	   * @param {string} string The string to qualify.
	   * @returns {string} The qualified string.
	   */
	  function qualify(string) {
	    return String(string).replace(/([ -])(?!$)/g, '$1?');
	  }
	
	  /**
	   * A bare-bones `Array#reduce` like utility function.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} callback The function called per iteration.
	   * @returns {*} The accumulated result.
	   */
	  function reduce(array, callback) {
	    var accumulator = null;
	    each(array, function(value, index) {
	      accumulator = callback(accumulator, value, index, array);
	    });
	    return accumulator;
	  }
	
	  /**
	   * Removes leading and trailing whitespace from a string.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} The trimmed string.
	   */
	  function trim(string) {
	    return String(string).replace(/^ +| +$/g, '');
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Creates a new platform object.
	   *
	   * @memberOf platform
	   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
	   *  context object.
	   * @returns {Object} A platform object.
	   */
	  function parse(ua) {
	
	    /** The environment context object. */
	    var context = root;
	
	    /** Used to flag when a custom context is provided. */
	    var isCustomContext = ua && typeof ua == 'object' && getClassOf(ua) != 'String';
	
	    // Juggle arguments.
	    if (isCustomContext) {
	      context = ua;
	      ua = null;
	    }
	
	    /** Browser navigator object. */
	    var nav = context.navigator || {};
	
	    /** Browser user agent string. */
	    var userAgent = nav.userAgent || '';
	
	    ua || (ua = userAgent);
	
	    /** Used to flag when `thisBinding` is the [ModuleScope]. */
	    var isModuleScope = isCustomContext || thisBinding == oldRoot;
	
	    /** Used to detect if browser is like Chrome. */
	    var likeChrome = isCustomContext
	      ? !!nav.likeChrome
	      : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());
	
	    /** Internal `[[Class]]` value shortcuts. */
	    var objectClass = 'Object',
	        airRuntimeClass = isCustomContext ? objectClass : 'ScriptBridgingProxyObject',
	        enviroClass = isCustomContext ? objectClass : 'Environment',
	        javaClass = (isCustomContext && context.java) ? 'JavaPackage' : getClassOf(context.java),
	        phantomClass = isCustomContext ? objectClass : 'RuntimeObject';
	
	    /** Detect Java environments. */
	    var java = /\bJava/.test(javaClass) && context.java;
	
	    /** Detect Rhino. */
	    var rhino = java && getClassOf(context.environment) == enviroClass;
	
	    /** A character to represent alpha. */
	    var alpha = java ? 'a' : '\u03b1';
	
	    /** A character to represent beta. */
	    var beta = java ? 'b' : '\u03b2';
	
	    /** Browser document object. */
	    var doc = context.document || {};
	
	    /**
	     * Detect Opera browser (Presto-based).
	     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
	     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
	     */
	    var opera = context.operamini || context.opera;
	
	    /** Opera `[[Class]]`. */
	    var operaClass = reOpera.test(operaClass = (isCustomContext && opera) ? opera['[[Class]]'] : getClassOf(opera))
	      ? operaClass
	      : (opera = null);
	
	    /*------------------------------------------------------------------------*/
	
	    /** Temporary variable used over the script's lifetime. */
	    var data;
	
	    /** The CPU architecture. */
	    var arch = ua;
	
	    /** Platform description array. */
	    var description = [];
	
	    /** Platform alpha/beta indicator. */
	    var prerelease = null;
	
	    /** A flag to indicate that environment features should be used to resolve the platform. */
	    var useFeatures = ua == userAgent;
	
	    /** The browser/environment version. */
	    var version = useFeatures && opera && typeof opera.version == 'function' && opera.version();
	
	    /** A flag to indicate if the OS begins with "Name Version /". */
	    var isSpecialCasedOS;
	
	    /* Detectable layout engines (order is important). */
	    var layout = getLayout([
	      { 'label': 'EdgeHTML', 'pattern': 'Edge' },
	      'Trident',
	      { 'label': 'WebKit', 'pattern': 'AppleWebKit' },
	      'iCab',
	      'Presto',
	      'NetFront',
	      'Tasman',
	      'KHTML',
	      'Gecko'
	    ]);
	
	    /* Detectable browser names (order is important). */
	    var name = getName([
	      'Adobe AIR',
	      'Arora',
	      'Avant Browser',
	      'Breach',
	      'Camino',
	      'Epiphany',
	      'Fennec',
	      'Flock',
	      'Galeon',
	      'GreenBrowser',
	      'iCab',
	      'Iceweasel',
	      'K-Meleon',
	      'Konqueror',
	      'Lunascape',
	      'Maxthon',
	      { 'label': 'Microsoft Edge', 'pattern': 'Edge' },
	      'Midori',
	      'Nook Browser',
	      'PaleMoon',
	      'PhantomJS',
	      'Raven',
	      'Rekonq',
	      'RockMelt',
	      'SeaMonkey',
	      { 'label': 'Silk', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
	      'Sleipnir',
	      'SlimBrowser',
	      { 'label': 'SRWare Iron', 'pattern': 'Iron' },
	      'Sunrise',
	      'Swiftfox',
	      'WebPositive',
	      'Opera Mini',
	      { 'label': 'Opera Mini', 'pattern': 'OPiOS' },
	      'Opera',
	      { 'label': 'Opera', 'pattern': 'OPR' },
	      'Chrome',
	      { 'label': 'Chrome Mobile', 'pattern': '(?:CriOS|CrMo)' },
	      { 'label': 'Firefox', 'pattern': '(?:Firefox|Minefield)' },
	      { 'label': 'Firefox for iOS', 'pattern': 'FxiOS' },
	      { 'label': 'IE', 'pattern': 'IEMobile' },
	      { 'label': 'IE', 'pattern': 'MSIE' },
	      'Safari'
	    ]);
	
	    /* Detectable products (order is important). */
	    var product = getProduct([
	      { 'label': 'BlackBerry', 'pattern': 'BB10' },
	      'BlackBerry',
	      { 'label': 'Galaxy S', 'pattern': 'GT-I9000' },
	      { 'label': 'Galaxy S2', 'pattern': 'GT-I9100' },
	      { 'label': 'Galaxy S3', 'pattern': 'GT-I9300' },
	      { 'label': 'Galaxy S4', 'pattern': 'GT-I9500' },
	      'Google TV',
	      'Lumia',
	      'iPad',
	      'iPod',
	      'iPhone',
	      'Kindle',
	      { 'label': 'Kindle Fire', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
	      'Nexus',
	      'Nook',
	      'PlayBook',
	      'PlayStation 3',
	      'PlayStation 4',
	      'PlayStation Vita',
	      'TouchPad',
	      'Transformer',
	      { 'label': 'Wii U', 'pattern': 'WiiU' },
	      'Wii',
	      'Xbox One',
	      { 'label': 'Xbox 360', 'pattern': 'Xbox' },
	      'Xoom'
	    ]);
	
	    /* Detectable manufacturers. */
	    var manufacturer = getManufacturer({
	      'Apple': { 'iPad': 1, 'iPhone': 1, 'iPod': 1 },
	      'Archos': {},
	      'Amazon': { 'Kindle': 1, 'Kindle Fire': 1 },
	      'Asus': { 'Transformer': 1 },
	      'Barnes & Noble': { 'Nook': 1 },
	      'BlackBerry': { 'PlayBook': 1 },
	      'Google': { 'Google TV': 1, 'Nexus': 1 },
	      'HP': { 'TouchPad': 1 },
	      'HTC': {},
	      'LG': {},
	      'Microsoft': { 'Xbox': 1, 'Xbox One': 1 },
	      'Motorola': { 'Xoom': 1 },
	      'Nintendo': { 'Wii U': 1,  'Wii': 1 },
	      'Nokia': { 'Lumia': 1 },
	      'Samsung': { 'Galaxy S': 1, 'Galaxy S2': 1, 'Galaxy S3': 1, 'Galaxy S4': 1 },
	      'Sony': { 'PlayStation 4': 1, 'PlayStation 3': 1, 'PlayStation Vita': 1 }
	    });
	
	    /* Detectable operating systems (order is important). */
	    var os = getOS([
	      'Windows Phone',
	      'Android',
	      'CentOS',
	      { 'label': 'Chrome OS', 'pattern': 'CrOS' },
	      'Debian',
	      'Fedora',
	      'FreeBSD',
	      'Gentoo',
	      'Haiku',
	      'Kubuntu',
	      'Linux Mint',
	      'OpenBSD',
	      'Red Hat',
	      'SuSE',
	      'Ubuntu',
	      'Xubuntu',
	      'Cygwin',
	      'Symbian OS',
	      'hpwOS',
	      'webOS ',
	      'webOS',
	      'Tablet OS',
	      'Linux',
	      'Mac OS X',
	      'Macintosh',
	      'Mac',
	      'Windows 98;',
	      'Windows '
	    ]);
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Picks the layout engine from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected layout engine.
	     */
	    function getLayout(guesses) {
	      return reduce(guesses, function(result, guess) {
	        return result || RegExp('\\b' + (
	          guess.pattern || qualify(guess)
	        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
	      });
	    }
	
	    /**
	     * Picks the manufacturer from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An object of guesses.
	     * @returns {null|string} The detected manufacturer.
	     */
	    function getManufacturer(guesses) {
	      return reduce(guesses, function(result, value, key) {
	        // Lookup the manufacturer by product or scan the UA for the manufacturer.
	        return result || (
	          value[product] ||
	          value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] ||
	          RegExp('\\b' + qualify(key) + '(?:\\b|\\w*\\d)', 'i').exec(ua)
	        ) && key;
	      });
	    }
	
	    /**
	     * Picks the browser name from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected browser name.
	     */
	    function getName(guesses) {
	      return reduce(guesses, function(result, guess) {
	        return result || RegExp('\\b' + (
	          guess.pattern || qualify(guess)
	        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
	      });
	    }
	
	    /**
	     * Picks the OS name from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected OS name.
	     */
	    function getOS(guesses) {
	      return reduce(guesses, function(result, guess) {
	        var pattern = guess.pattern || qualify(guess);
	        if (!result && (result =
	              RegExp('\\b' + pattern + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(ua)
	            )) {
	          result = cleanupOS(result, pattern, guess.label || guess);
	        }
	        return result;
	      });
	    }
	
	    /**
	     * Picks the product name from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected product name.
	     */
	    function getProduct(guesses) {
	      return reduce(guesses, function(result, guess) {
	        var pattern = guess.pattern || qualify(guess);
	        if (!result && (result =
	              RegExp('\\b' + pattern + ' *\\d+[.\\w_]*', 'i').exec(ua) ||
	              RegExp('\\b' + pattern + '(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)', 'i').exec(ua)
	            )) {
	          // Split by forward slash and append product version if needed.
	          if ((result = String((guess.label && !RegExp(pattern, 'i').test(guess.label)) ? guess.label : result).split('/'))[1] && !/[\d.]+/.test(result[0])) {
	            result[0] += ' ' + result[1];
	          }
	          // Correct character case and cleanup string.
	          guess = guess.label || guess;
	          result = format(result[0]
	            .replace(RegExp(pattern, 'i'), guess)
	            .replace(RegExp('; *(?:' + guess + '[_-])?', 'i'), ' ')
	            .replace(RegExp('(' + guess + ')[-_.]?(\\w)', 'i'), '$1 $2'));
	        }
	        return result;
	      });
	    }
	
	    /**
	     * Resolves the version using an array of UA patterns.
	     *
	     * @private
	     * @param {Array} patterns An array of UA patterns.
	     * @returns {null|string} The detected version.
	     */
	    function getVersion(patterns) {
	      return reduce(patterns, function(result, pattern) {
	        return result || (RegExp(pattern +
	          '(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)', 'i').exec(ua) || 0)[1] || null;
	      });
	    }
	
	    /**
	     * Returns `platform.description` when the platform object is coerced to a string.
	     *
	     * @name toString
	     * @memberOf platform
	     * @returns {string} Returns `platform.description` if available, else an empty string.
	     */
	    function toStringPlatform() {
	      return this.description || '';
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Convert layout to an array so we can add extra details.
	    layout && (layout = [layout]);
	
	    // Detect product names that contain their manufacturer's name.
	    if (manufacturer && !product) {
	      product = getProduct([manufacturer]);
	    }
	    // Clean up Google TV.
	    if ((data = /\bGoogle TV\b/.exec(product))) {
	      product = data[0];
	    }
	    // Detect simulators.
	    if (/\bSimulator\b/i.test(ua)) {
	      product = (product ? product + ' ' : '') + 'Simulator';
	    }
	    // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
	    if (name == 'Opera Mini' && /\bOPiOS\b/.test(ua)) {
	      description.push('running in Turbo/Uncompressed mode');
	    }
	    // Detect IE Mobile 11.
	    if (name == 'IE' && /\blike iPhone OS\b/.test(ua)) {
	      data = parse(ua.replace(/like iPhone OS/, ''));
	      manufacturer = data.manufacturer;
	      product = data.product;
	    }
	    // Detect iOS.
	    else if (/^iP/.test(product)) {
	      name || (name = 'Safari');
	      os = 'iOS' + ((data = / OS ([\d_]+)/i.exec(ua))
	        ? ' ' + data[1].replace(/_/g, '.')
	        : '');
	    }
	    // Detect Kubuntu.
	    else if (name == 'Konqueror' && !/buntu/i.test(os)) {
	      os = 'Kubuntu';
	    }
	    // Detect Android browsers.
	    else if ((manufacturer && manufacturer != 'Google' &&
	        ((/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua)) || /\bVita\b/.test(product))) ||
	        (/\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua))) {
	      name = 'Android Browser';
	      os = /\bAndroid\b/.test(os) ? os : 'Android';
	    }
	    // Detect Silk desktop/accelerated modes.
	    else if (name == 'Silk') {
	      if (!/\bMobi/i.test(ua)) {
	        os = 'Android';
	        description.unshift('desktop mode');
	      }
	      if (/Accelerated *= *true/i.test(ua)) {
	        description.unshift('accelerated');
	      }
	    }
	    // Detect PaleMoon identifying as Firefox.
	    else if (name == 'PaleMoon' && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) {
	      description.push('identifying as Firefox ' + data[1]);
	    }
	    // Detect Firefox OS and products running Firefox.
	    else if (name == 'Firefox' && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
	      os || (os = 'Firefox OS');
	      product || (product = data[1]);
	    }
	    // Detect false positives for Firefox/Safari.
	    else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
	      // Escape the `/` for Firefox 1.
	      if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + '/') + 8))) {
	        // Clear name of false positives.
	        name = null;
	      }
	      // Reassign a generic name.
	      if ((data = product || manufacturer || os) &&
	          (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) {
	        name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + ' Browser';
	      }
	    }
	    // Detect non-Opera (Presto-based) versions (order is important).
	    if (!version) {
	      version = getVersion([
	        '(?:Cloud9|CriOS|CrMo|Edge|FxiOS|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|Silk(?!/[\\d.]+$))',
	        'Version',
	        qualify(name),
	        '(?:Firefox|Minefield|NetFront)'
	      ]);
	    }
	    // Detect stubborn layout engines.
	    if ((data =
	          layout == 'iCab' && parseFloat(version) > 3 && 'WebKit' ||
	          /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? 'Blink' : 'Presto') ||
	          /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && 'WebKit' ||
	          !layout && /\bMSIE\b/i.test(ua) && (os == 'Mac OS' ? 'Tasman' : 'Trident') ||
	          layout == 'WebKit' && /\bPlayStation\b(?! Vita\b)/i.test(name) && 'NetFront'
	        )) {
	      layout = [data];
	    }
	    // Detect Windows Phone 7 desktop mode.
	    if (name == 'IE' && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
	      name += ' Mobile';
	      os = 'Windows Phone ' + (/\+$/.test(data) ? data : data + '.x');
	      description.unshift('desktop mode');
	    }
	    // Detect Windows Phone 8.x desktop mode.
	    else if (/\bWPDesktop\b/i.test(ua)) {
	      name = 'IE Mobile';
	      os = 'Windows Phone 8.x';
	      description.unshift('desktop mode');
	      version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
	    }
	    // Detect IE 11.
	    else if (name != 'IE' && layout == 'Trident' && (data = /\brv:([\d.]+)/.exec(ua))) {
	      if (name) {
	        description.push('identifying as ' + name + (version ? ' ' + version : ''));
	      }
	      name = 'IE';
	      version = data[1];
	    }
	    // Leverage environment features.
	    if (useFeatures) {
	      // Detect server-side environments.
	      // Rhino has a global function while others have a global object.
	      if (isHostType(context, 'global')) {
	        if (java) {
	          data = java.lang.System;
	          arch = data.getProperty('os.arch');
	          os = os || data.getProperty('os.name') + ' ' + data.getProperty('os.version');
	        }
	        if (isModuleScope && isHostType(context, 'system') && (data = [context.system])[0]) {
	          os || (os = data[0].os || null);
	          try {
	            data[1] = context.require('ringo/engine').version;
	            version = data[1].join('.');
	            name = 'RingoJS';
	          } catch(e) {
	            if (data[0].global.system == context.system) {
	              name = 'Narwhal';
	            }
	          }
	        }
	        else if (
	          typeof context.process == 'object' && !context.process.browser &&
	          (data = context.process)
	        ) {
	          name = 'Node.js';
	          arch = data.arch;
	          os = data.platform;
	          version = /[\d.]+/.exec(data.version)[0];
	        }
	        else if (rhino) {
	          name = 'Rhino';
	        }
	      }
	      // Detect Adobe AIR.
	      else if (getClassOf((data = context.runtime)) == airRuntimeClass) {
	        name = 'Adobe AIR';
	        os = data.flash.system.Capabilities.os;
	      }
	      // Detect PhantomJS.
	      else if (getClassOf((data = context.phantom)) == phantomClass) {
	        name = 'PhantomJS';
	        version = (data = data.version || null) && (data.major + '.' + data.minor + '.' + data.patch);
	      }
	      // Detect IE compatibility modes.
	      else if (typeof doc.documentMode == 'number' && (data = /\bTrident\/(\d+)/i.exec(ua))) {
	        // We're in compatibility mode when the Trident version + 4 doesn't
	        // equal the document mode.
	        version = [version, doc.documentMode];
	        if ((data = +data[1] + 4) != version[1]) {
	          description.push('IE ' + version[1] + ' mode');
	          layout && (layout[1] = '');
	          version[1] = data;
	        }
	        version = name == 'IE' ? String(version[1].toFixed(1)) : version[0];
	      }
	      os = os && format(os);
	    }
	    // Detect prerelease phases.
	    if (version && (data =
	          /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) ||
	          /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ';' + (useFeatures && nav.appMinorVersion)) ||
	          /\bMinefield\b/i.test(ua) && 'a'
	        )) {
	      prerelease = /b/i.test(data) ? 'beta' : 'alpha';
	      version = version.replace(RegExp(data + '\\+?$'), '') +
	        (prerelease == 'beta' ? beta : alpha) + (/\d+\+?/.exec(data) || '');
	    }
	    // Detect Firefox Mobile.
	    if (name == 'Fennec' || name == 'Firefox' && /\b(?:Android|Firefox OS)\b/.test(os)) {
	      name = 'Firefox Mobile';
	    }
	    // Obscure Maxthon's unreliable version.
	    else if (name == 'Maxthon' && version) {
	      version = version.replace(/\.[\d.]+/, '.x');
	    }
	    // Detect Xbox 360 and Xbox One.
	    else if (/\bXbox\b/i.test(product)) {
	      os = null;
	      if (product == 'Xbox 360' && /\bIEMobile\b/.test(ua)) {
	        description.unshift('mobile mode');
	      }
	    }
	    // Add mobile postfix.
	    else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) &&
	        (os == 'Windows CE' || /Mobi/i.test(ua))) {
	      name += ' Mobile';
	    }
	    // Detect IE platform preview.
	    else if (name == 'IE' && useFeatures && context.external === null) {
	      description.unshift('platform preview');
	    }
	    // Detect BlackBerry OS version.
	    // http://docs.blackberry.com/en/developers/deliverables/18169/HTTP_headers_sent_by_BB_Browser_1234911_11.jsp
	    else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data =
	          (RegExp(product.replace(/ +/g, ' *') + '/([.\\d]+)', 'i').exec(ua) || 0)[1] ||
	          version
	        )) {
	      data = [data, /BB10/.test(ua)];
	      os = (data[1] ? (product = null, manufacturer = 'BlackBerry') : 'Device Software') + ' ' + data[0];
	      version = null;
	    }
	    // Detect Opera identifying/masking itself as another browser.
	    // http://www.opera.com/support/kb/view/843/
	    else if (this != forOwn && product != 'Wii' && (
	          (useFeatures && opera) ||
	          (/Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua)) ||
	          (name == 'Firefox' && /\bOS X (?:\d+\.){2,}/.test(os)) ||
	          (name == 'IE' && (
	            (os && !/^Win/.test(os) && version > 5.5) ||
	            /\bWindows XP\b/.test(os) && version > 8 ||
	            version == 8 && !/\bTrident\b/.test(ua)
	          ))
	        ) && !reOpera.test((data = parse.call(forOwn, ua.replace(reOpera, '') + ';'))) && data.name) {
	      // When "identifying", the UA contains both Opera and the other browser's name.
	      data = 'ing as ' + data.name + ((data = data.version) ? ' ' + data : '');
	      if (reOpera.test(name)) {
	        if (/\bIE\b/.test(data) && os == 'Mac OS') {
	          os = null;
	        }
	        data = 'identify' + data;
	      }
	      // When "masking", the UA contains only the other browser's name.
	      else {
	        data = 'mask' + data;
	        if (operaClass) {
	          name = format(operaClass.replace(/([a-z])([A-Z])/g, '$1 $2'));
	        } else {
	          name = 'Opera';
	        }
	        if (/\bIE\b/.test(data)) {
	          os = null;
	        }
	        if (!useFeatures) {
	          version = null;
	        }
	      }
	      layout = ['Presto'];
	      description.push(data);
	    }
	    // Detect WebKit Nightly and approximate Chrome/Safari versions.
	    if ((data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
	      // Correct build number for numeric comparison.
	      // (e.g. "532.5" becomes "532.05")
	      data = [parseFloat(data.replace(/\.(\d)$/, '.0$1')), data];
	      // Nightly builds are postfixed with a "+".
	      if (name == 'Safari' && data[1].slice(-1) == '+') {
	        name = 'WebKit Nightly';
	        prerelease = 'alpha';
	        version = data[1].slice(0, -1);
	      }
	      // Clear incorrect browser versions.
	      else if (version == data[1] ||
	          version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
	        version = null;
	      }
	      // Use the full Chrome version when available.
	      data[1] = (/\bChrome\/([\d.]+)/i.exec(ua) || 0)[1];
	      // Detect Blink layout engine.
	      if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == 'WebKit') {
	        layout = ['Blink'];
	      }
	      // Detect JavaScriptCore.
	      // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
	      if (!useFeatures || (!likeChrome && !data[1])) {
	        layout && (layout[1] = 'like Safari');
	        data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? '4+' : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : '8');
	      } else {
	        layout && (layout[1] = 'like Chrome');
	        data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? '13+' : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? '21+' : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != 'Blink' ? '27' : '28');
	      }
	      // Add the postfix of ".x" or "+" for approximate versions.
	      layout && (layout[1] += ' ' + (data += typeof data == 'number' ? '.x' : /[.+]/.test(data) ? '' : '+'));
	      // Obscure version for some Safari 1-2 releases.
	      if (name == 'Safari' && (!version || parseInt(version) > 45)) {
	        version = data;
	      }
	    }
	    // Detect Opera desktop modes.
	    if (name == 'Opera' &&  (data = /\bzbov|zvav$/.exec(os))) {
	      name += ' ';
	      description.unshift('desktop mode');
	      if (data == 'zvav') {
	        name += 'Mini';
	        version = null;
	      } else {
	        name += 'Mobile';
	      }
	      os = os.replace(RegExp(' *' + data + '$'), '');
	    }
	    // Detect Chrome desktop mode.
	    else if (name == 'Safari' && /\bChrome\b/.exec(layout && layout[1])) {
	      description.unshift('desktop mode');
	      name = 'Chrome Mobile';
	      version = null;
	
	      if (/\bOS X\b/.test(os)) {
	        manufacturer = 'Apple';
	        os = 'iOS 4.3+';
	      } else {
	        os = null;
	      }
	    }
	    // Strip incorrect OS versions.
	    if (version && version.indexOf((data = /[\d.]+$/.exec(os))) == 0 &&
	        ua.indexOf('/' + data + '-') > -1) {
	      os = trim(os.replace(data, ''));
	    }
	    // Add layout engine.
	    if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (
	        /Browser|Lunascape|Maxthon/.test(name) ||
	        name != 'Safari' && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) ||
	        /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Sleipnir|Web)/.test(name) && layout[1])) {
	      // Don't add layout details to description if they are falsey.
	      (data = layout[layout.length - 1]) && description.push(data);
	    }
	    // Combine contextual information.
	    if (description.length) {
	      description = ['(' + description.join('; ') + ')'];
	    }
	    // Append manufacturer to description.
	    if (manufacturer && product && product.indexOf(manufacturer) < 0) {
	      description.push('on ' + manufacturer);
	    }
	    // Append product to description.
	    if (product) {
	      description.push((/^on /.test(description[description.length - 1]) ? '' : 'on ') + product);
	    }
	    // Parse the OS into an object.
	    if (os) {
	      data =
	        / ([\d.+]+)$/.exec(os) ||
	        (isSpecialCasedOS = /^[a-z]+ ([\d.+]+) \//i.exec(os));
	      os = {
	        'architecture': 32,
	        'family': (data && !isSpecialCasedOS) ? os.replace(data[0], '') : os,
	        'version': data ? data[1] : null,
	        'toString': function() {
	          var version = this.version;
	          return this.family + ((version && !isSpecialCasedOS) ? ' ' + version : '') + (this.architecture == 64 ? ' 64-bit' : '');
	        }
	      };
	    }
	    // Add browser/OS architecture.
	    if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
	      if (os) {
	        os.architecture = 64;
	        os.family = os.family.replace(RegExp(' *' + data), '');
	      }
	      if (
	          name && (/\bWOW64\b/i.test(ua) ||
	          (useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua)))
	      ) {
	        description.unshift('32-bit');
	      }
	    }
	    // Chrome 39 and above on OS X is always 64-bit.
	    else if (
	        os && /^OS X/.test(os.family) &&
	        name == 'Chrome' && parseFloat(version) >= 39
	    ) {
	      os.architecture = 64;
	    }
	
	    ua || (ua = null);
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The platform object.
	     *
	     * @name platform
	     * @type Object
	     */
	    var platform = {};
	
	    /**
	     * The platform description.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.description = ua;
	
	    /**
	     * The name of the browser's layout engine.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.layout = layout && layout[0];
	
	    /**
	     * The name of the product's manufacturer.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.manufacturer = manufacturer;
	
	    /**
	     * The name of the browser/environment.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.name = name;
	
	    /**
	     * The alpha/beta release indicator.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.prerelease = prerelease;
	
	    /**
	     * The name of the product hosting the browser.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.product = product;
	
	    /**
	     * The browser's user agent string.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.ua = ua;
	
	    /**
	     * The browser/environment version.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.version = name && version;
	
	    /**
	     * The name of the operating system.
	     *
	     * @memberOf platform
	     * @type Object
	     */
	    platform.os = os || {
	
	      /**
	       * The CPU architecture the OS is built for.
	       *
	       * @memberOf platform.os
	       * @type number|null
	       */
	      'architecture': null,
	
	      /**
	       * The family of the OS.
	       *
	       * Common values include:
	       * "Windows", "Windows 7 / Server 2008 R2", "Windows Vista / Server 2008",
	       * "Windows XP", "OS X", "Ubuntu", "Debian", "Fedora", "Red Hat", "SuSE",
	       * "Android", "iOS" and "Windows Phone"
	       *
	       * @memberOf platform.os
	       * @type string|null
	       */
	      'family': null,
	
	      /**
	       * The version of the OS.
	       *
	       * @memberOf platform.os
	       * @type string|null
	       */
	      'version': null,
	
	      /**
	       * Returns the OS string.
	       *
	       * @memberOf platform.os
	       * @returns {string} The OS string.
	       */
	      'toString': function() { return 'null'; }
	    };
	
	    platform.parse = parse;
	    platform.toString = toStringPlatform;
	
	    if (platform.version) {
	      description.unshift(version);
	    }
	    if (platform.name) {
	      description.unshift(name);
	    }
	    if (os && name && !(os == String(os).split(' ')[0] && (os == name.split(' ')[0] || product))) {
	      description.push(product ? '(' + os + ')' : 'on ' + os);
	    }
	    if (description.length) {
	      platform.description = description.join(' ');
	    }
	    return platform;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export platform.
	  var platform = parse();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like the following:
	  if (true) {
	    // Expose platform on the global object to prevent errors when platform is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    root.platform = platform;
	
	    // Define as an anonymous module so platform can be aliased through path mapping.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return platform;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for CommonJS support.
	    forOwn(platform, function(value, key) {
	      freeExports[key] = value;
	    });
	  }
	  else {
	    // Export to the global object.
	    root.platform = platform;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(128)(module), (function() { return this; }())))

/***/ },
/* 390 */
/***/ function(module, exports) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	module.exports = {
	    'default': 'RFC3986',
	    formatters: {
	        RFC1738: function (value) {
	            return replace.call(value, percentTwenties, '+');
	        },
	        RFC3986: function (value) {
	            return String(value);
	        }
	    },
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};


/***/ },
/* 391 */
/***/ function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	var compactQueue = function compactQueue(queue) {
	    var obj;
	
	    while (queue.length) {
	        var item = queue.pop();
	        obj = item.obj[item.prop];
	
	        if (Array.isArray(obj)) {
	            var compacted = [];
	
	            for (var j = 0; j < obj.length; ++j) {
	                if (typeof obj[j] !== 'undefined') {
	                    compacted.push(obj[j]);
	                }
	            }
	
	            item.obj[item.prop] = compacted;
	        }
	    }
	
	    return obj;
	};
	
	var arrayToObject = function arrayToObject(source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	var merge = function merge(target, source, options) {
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        } else if (target && typeof target === 'object') {
	            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (!target || typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (Array.isArray(target) && !Array.isArray(source)) {
	        mergeTarget = arrayToObject(target, options);
	    }
	
	    if (Array.isArray(target) && Array.isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                var targetItem = target[i];
	                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
	                    target[i] = merge(targetItem, item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (has.call(acc, key)) {
	            acc[key] = merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	var assign = function assignSingleSource(target, source) {
	    return Object.keys(source).reduce(function (acc, key) {
	        acc[key] = source[key];
	        return acc;
	    }, target);
	};
	
	var decode = function (str) {
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	var encode = function encode(str) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = typeof str === 'string' ? str : String(str);
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D // -
	            || c === 0x2E // .
	            || c === 0x5F // _
	            || c === 0x7E // ~
	            || (c >= 0x30 && c <= 0x39) // 0-9
	            || (c >= 0x41 && c <= 0x5A) // a-z
	            || (c >= 0x61 && c <= 0x7A) // A-Z
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        /* eslint operator-linebreak: [2, "before"] */
	        out += hexTable[0xF0 | (c >> 18)]
	            + hexTable[0x80 | ((c >> 12) & 0x3F)]
	            + hexTable[0x80 | ((c >> 6) & 0x3F)]
	            + hexTable[0x80 | (c & 0x3F)];
	    }
	
	    return out;
	};
	
	var compact = function compact(value) {
	    var queue = [{ obj: { o: value }, prop: 'o' }];
	    var refs = [];
	
	    for (var i = 0; i < queue.length; ++i) {
	        var item = queue[i];
	        var obj = item.obj[item.prop];
	
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; ++j) {
	            var key = keys[j];
	            var val = obj[key];
	            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
	                queue.push({ obj: obj, prop: key });
	                refs.push(val);
	            }
	        }
	    }
	
	    return compactQueue(queue);
	};
	
	var isRegExp = function isRegExp(obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	var isBuffer = function isBuffer(obj) {
	    if (obj === null || typeof obj === 'undefined') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};
	
	module.exports = {
	    arrayToObject: arrayToObject,
	    assign: assign,
	    compact: compact,
	    decode: decode,
	    encode: encode,
	    isBuffer: isBuffer,
	    isRegExp: isRegExp,
	    merge: merge
	};


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(687)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 393 */
152,
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	var _isArray = __webpack_require__(396);
	
	
	/**
	 * This checks whether a function has a [methodname] function. If it isn't an
	 * array it will execute that function otherwise it will default to the ramda
	 * implementation.
	 *
	 * @private
	 * @param {Function} fn ramda implemtation
	 * @param {String} methodname property to check for a custom implementation
	 * @return {Object} Whatever the return value of the method is.
	 */
	module.exports = function _checkForMethod(methodname, fn) {
	  return function() {
	    var length = arguments.length;
	    if (length === 0) {
	      return fn();
	    }
	    var obj = arguments[length - 1];
	    return (_isArray(obj) || typeof obj[methodname] !== 'function') ?
	      fn.apply(this, arguments) :
	      obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
	  };
	};


/***/ },
/* 395 */
154,
/* 396 */
248,
/* 397 */
/***/ function(module, exports) {

	module.exports = function _isString(x) {
	  return Object.prototype.toString.call(x) === '[object String]';
	};


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(76);
	var _has = __webpack_require__(395);
	var _isArguments = __webpack_require__(698);
	
	
	/**
	 * Returns a list containing the names of all the enumerable own properties of
	 * the supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own properties.
	 * @example
	 *
	 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
	 */
	module.exports = (function() {
	  // cover IE < 9 keys issues
	  var hasEnumBug = !({toString: null}).propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString',
	                            'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	  // Safari bug
	  var hasArgsEnumBug = (function() {
	    'use strict';
	    return arguments.propertyIsEnumerable('length');
	  }());
	
	  var contains = function contains(list, item) {
	    var idx = 0;
	    while (idx < list.length) {
	      if (list[idx] === item) {
	        return true;
	      }
	      idx += 1;
	    }
	    return false;
	  };
	
	  return typeof Object.keys === 'function' && !hasArgsEnumBug ?
	    _curry1(function keys(obj) {
	      return Object(obj) !== obj ? [] : Object.keys(obj);
	    }) :
	    _curry1(function keys(obj) {
	      if (Object(obj) !== obj) {
	        return [];
	      }
	      var prop, nIdx;
	      var ks = [];
	      var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
	      for (prop in obj) {
	        if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
	          ks[ks.length] = prop;
	        }
	      }
	      if (hasEnumBug) {
	        nIdx = nonEnumerableProps.length - 1;
	        while (nIdx >= 0) {
	          prop = nonEnumerableProps[nIdx];
	          if (_has(prop, obj) && !contains(ks, prop)) {
	            ks[ks.length] = prop;
	          }
	          nIdx -= 1;
	        }
	      }
	      return ks;
	    });
	}());


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(157);
	var _reduce = __webpack_require__(700);
	
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It may use
	 * `R.reduced` to shortcut the iteration.
	 *
	 * The arguments' order of `reduceRight`'s iterator function is *(value, acc)*.
	 *
	 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduce` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
	 *
	 * Dispatches to the `reduce` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduced, R.addIndex, R.reduceRight
	 * @example
	 *
	 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
	 *                -               -10
	 *               / \              / \
	 *              -   4           -6   4
	 *             / \              / \
	 *            -   3   ==>     -3   3
	 *           / \              / \
	 *          -   2           -1   2
	 *         / \              / \
	 *        0   1            0   1
	 *
	 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
	 */
	module.exports = _curry3(_reduce);


/***/ },
/* 400 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var util = {
	  isAppearSupported: function isAppearSupported(props) {
	    return props.transitionName && props.transitionAppear || props.animation.appear;
	  },
	  isEnterSupported: function isEnterSupported(props) {
	    return props.transitionName && props.transitionEnter || props.animation.enter;
	  },
	  isLeaveSupported: function isLeaveSupported(props) {
	    return props.transitionName && props.transitionLeave || props.animation.leave;
	  },
	  allowAppearCallback: function allowAppearCallback(props) {
	    return props.transitionAppear || props.animation.appear;
	  },
	  allowEnterCallback: function allowEnterCallback(props) {
	    return props.transitionEnter || props.animation.enter;
	  },
	  allowLeaveCallback: function allowLeaveCallback(props) {
	    return props.transitionLeave || props.animation.leave;
	  }
	};
	exports["default"] = util;
	module.exports = exports['default'];

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(548);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(49);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(51);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(50);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var LazyRenderBox = function (_Component) {
	  (0, _inherits3['default'])(LazyRenderBox, _Component);
	
	  function LazyRenderBox() {
	    (0, _classCallCheck3['default'])(this, LazyRenderBox);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return nextProps.hiddenClassName || nextProps.visible;
	  };
	
	  LazyRenderBox.prototype.render = function render() {
	    var _props = this.props,
	        hiddenClassName = _props.hiddenClassName,
	        visible = _props.visible,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['hiddenClassName', 'visible']);
	
	
	    if (hiddenClassName || _react2['default'].Children.count(props.children) > 1) {
	      if (!visible && hiddenClassName) {
	        props.className += ' ' + hiddenClassName;
	      }
	      return _react2['default'].createElement('div', props);
	    }
	
	    return _react2['default'].Children.only(props.children);
	  };
	
	  return LazyRenderBox;
	}(_react.Component);
	
	LazyRenderBox.propTypes = {
	  children: _propTypes2['default'].any,
	  className: _propTypes2['default'].string,
	  visible: _propTypes2['default'].bool,
	  hiddenClassName: _propTypes2['default'].string
	};
	exports['default'] = LazyRenderBox;
	module.exports = exports['default'];

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(104);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getAlignFromPlacement = getAlignFromPlacement;
	exports.getAlignPopupClassName = getAlignPopupClassName;
	exports.saveRef = saveRef;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isPointsEq(a1, a2, isAlignPoint) {
	  if (isAlignPoint) {
	    return a1[0] === a2[0];
	  }
	  return a1[0] === a2[0] && a1[1] === a2[1];
	}
	
	function getAlignFromPlacement(builtinPlacements, placementStr, align) {
	  var baseAlign = builtinPlacements[placementStr] || {};
	  return (0, _extends3['default'])({}, baseAlign, align);
	}
	
	function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
	  var points = align.points;
	  for (var placement in builtinPlacements) {
	    if (builtinPlacements.hasOwnProperty(placement)) {
	      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
	        return prefixCls + '-placement-' + placement;
	      }
	    }
	  }
	  return '';
	}
	
	function saveRef(name, component) {
	  this[name] = component;
	}

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addEventListenerWrap;
	
	var _addDomEventListener = _interopRequireDefault(__webpack_require__(479));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(23));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addEventListenerWrap(target, eventType, cb, option) {
	  /* eslint camelcase: 2 */
	  var callback = _reactDom.default.unstable_batchedUpdates ? function run(e) {
	    _reactDom.default.unstable_batchedUpdates(cb, e);
	  } : cb;
	  return (0, _addDomEventListener.default)(target, eventType, callback, option);
	}

/***/ },
/* 404 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = contains;
	
	function contains(root, n) {
	  var node = n;
	
	  while (node) {
	    if (node === root) {
	      return true;
	    }
	
	    node = node.parentNode;
	  }
	
	  return false;
	}

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFormatter = getFormatter;
	exports.formatShortMonth = exports.formatMonth = void 0;
	
	var _getUserLocale = _interopRequireDefault(__webpack_require__(237));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getFormatter(options) {
	  return function (locale, date) {
	    return date.toLocaleString(locale || (0, _getUserLocale["default"])(), options);
	  };
	}
	/**
	 * Changes the hour in a Date to ensure right date formatting even if DST is messed up.
	 * Workaround for bug in WebKit and Firefox with historical dates.
	 * For more details, see:
	 * https://bugs.chromium.org/p/chromium/issues/detail?id=750465
	 * https://bugzilla.mozilla.org/show_bug.cgi?id=1385643
	 *
	 * @param {Date} date Date.
	 */
	
	
	function toSafeHour(date) {
	  var safeDate = new Date(date);
	  return new Date(safeDate.setHours(12));
	}
	
	function getSafeFormatter(options) {
	  return function (locale, date) {
	    return getFormatter(options)(locale, toSafeHour(date));
	  };
	}
	
	var formatMonthOptions = {
	  month: 'long'
	};
	var formatShortMonthOptions = {
	  month: 'short'
	};
	var formatMonth = getSafeFormatter(formatMonthOptions);
	exports.formatMonth = formatMonth;
	var formatShortMonth = getSafeFormatter(formatShortMonthOptions);
	exports.formatShortMonth = formatShortMonth;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = CenturyView;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Decades = _interopRequireDefault(__webpack_require__(757));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function CenturyView(props) {
	  function renderDecades() {
	    return _react["default"].createElement(_Decades["default"], props);
	  }
	
	  return _react["default"].createElement("div", {
	    className: "react-calendar__century-view"
	  }, renderDecades());
	}

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = DecadeView;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Years = _interopRequireDefault(__webpack_require__(759));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function DecadeView(props) {
	  function renderYears() {
	    return _react["default"].createElement(_Years["default"], props);
	  }
	
	  return _react["default"].createElement("div", {
	    className: "react-calendar__decade-view"
	  }, renderYears());
	}

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = MonthView;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Days = _interopRequireDefault(__webpack_require__(761));
	
	var _Weekdays = _interopRequireDefault(__webpack_require__(764));
	
	var _WeekNumbers = _interopRequireDefault(__webpack_require__(763));
	
	var _propTypes2 = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function MonthView(props) {
	  var activeStartDate = props.activeStartDate,
	      locale = props.locale,
	      onMouseLeave = props.onMouseLeave,
	      showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
	
	  var calendarTypeProps = props.calendarType,
	      formatShortWeekday = props.formatShortWeekday,
	      onClickWeekNumber = props.onClickWeekNumber,
	      showWeekNumbers = props.showWeekNumbers,
	      childProps = _objectWithoutProperties(props, ["calendarType", "formatShortWeekday", "onClickWeekNumber", "showWeekNumbers"]);
	
	  var calendarType = function () {
	    if (calendarTypeProps) {
	      return calendarTypeProps;
	    }
	
	    switch (locale) {
	      case 'en-CA':
	      case 'en-US':
	      case 'es-AR':
	      case 'es-BO':
	      case 'es-CL':
	      case 'es-CO':
	      case 'es-CR':
	      case 'es-DO':
	      case 'es-EC':
	      case 'es-GT':
	      case 'es-HN':
	      case 'es-MX':
	      case 'es-NI':
	      case 'es-PA':
	      case 'es-PE':
	      case 'es-PR':
	      case 'es-SV':
	      case 'es-VE':
	      case 'pt-BR':
	        return 'US';
	      // ar-LB, ar-MA intentionally missing
	
	      case 'ar':
	      case 'ar-AE':
	      case 'ar-BH':
	      case 'ar-DZ':
	      case 'ar-EG':
	      case 'ar-IQ':
	      case 'ar-JO':
	      case 'ar-KW':
	      case 'ar-LY':
	      case 'ar-OM':
	      case 'ar-QA':
	      case 'ar-SA':
	      case 'ar-SD':
	      case 'ar-SY':
	      case 'ar-YE':
	      case 'dv':
	      case 'dv-MV':
	      case 'ps':
	      case 'ps-AR':
	        return 'Arabic';
	
	      case 'he':
	      case 'he-IL':
	        return 'Hebrew';
	
	      default:
	        return 'ISO 8601';
	    }
	  }();
	
	  function renderWeekdays() {
	    return _react["default"].createElement(_Weekdays["default"], {
	      calendarType: calendarType,
	      formatShortWeekday: formatShortWeekday,
	      locale: locale,
	      onMouseLeave: onMouseLeave
	    });
	  }
	
	  function renderWeekNumbers() {
	    if (!showWeekNumbers) {
	      return null;
	    }
	
	    return _react["default"].createElement(_WeekNumbers["default"], {
	      activeStartDate: activeStartDate,
	      calendarType: calendarType,
	      onClickWeekNumber: onClickWeekNumber,
	      onMouseLeave: onMouseLeave,
	      showFixedNumberOfWeeks: showFixedNumberOfWeeks
	    });
	  }
	
	  function renderDays() {
	    return _react["default"].createElement(_Days["default"], _extends({
	      calendarType: calendarType
	    }, childProps));
	  }
	
	  var className = 'react-calendar__month-view';
	  return _react["default"].createElement("div", {
	    className: [className, showWeekNumbers ? "".concat(className, "--weekNumbers") : ''].join(' ')
	  }, _react["default"].createElement("div", {
	    style: {
	      display: 'flex',
	      alignItems: 'flex-end'
	    }
	  }, renderWeekNumbers(), _react["default"].createElement("div", {
	    style: {
	      flexGrow: 1,
	      width: '100%'
	    }
	  }, renderWeekdays(), renderDays())));
	}
	
	MonthView.propTypes = {
	  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
	  calendarType: _propTypes2.isCalendarType,
	  formatShortWeekday: _propTypes["default"].func,
	  locale: _propTypes["default"].string,
	  maxDate: _propTypes2.isMaxDate,
	  minDate: _propTypes2.isMinDate,
	  onChange: _propTypes["default"].func,
	  onClickWeekNumber: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  setActiveRange: _propTypes["default"].func,
	  showFixedNumberOfWeeks: _propTypes["default"].bool,
	  showNeighboringMonth: _propTypes["default"].bool,
	  showWeekNumbers: _propTypes["default"].bool,
	  value: _propTypes2.isValue,
	  valueType: _propTypes["default"].string
	};

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = YearView;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Months = _interopRequireDefault(__webpack_require__(766));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function YearView(props) {
	  function renderMonths() {
	    return _react["default"].createElement(_Months["default"], props);
	  }
	
	  return _react["default"].createElement("div", {
	    className: "react-calendar__year-view"
	  }, renderMonths());
	}

/***/ },
/* 410 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.clone = clone;
	exports.defaults = defaults;
	exports.forEach = forEach;
	function clone(_ref) {
	  var title = _ref.title,
	      description = _ref.description,
	      base = _ref.base,
	      canonical = _ref.canonical,
	      meta = _ref.meta,
	      link = _ref.link,
	      auto = _ref.auto;
	
	  try {
	    return JSON.parse(JSON.stringify({ title: title, description: description, base: base, canonical: canonical, meta: meta, link: link, auto: auto }));
	  } catch (x) {
	    return {};
	  }
	}
	
	function defaults(target, source) {
	  return Object.keys(source).reduce(function (acc, key) {
	    if (!target.hasOwnProperty(key)) {
	      target[key] = source[key];
	    } else if (_typeof(target[key]) === 'object' && !Array.isArray(target[key]) && target[key]) {
	      defaults(target[key], source[key]);
	    }
	
	    return target;
	  }, target);
	}
	
	function forEach(arr, fn) {
	  Array.prototype.slice.call(arr || []).forEach(fn);
	}


/***/ },
/* 411 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(59);
	
	var invariant = __webpack_require__(6);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(80);
	var ReactDOMComponentTree = __webpack_require__(22);
	var ReactInstrumentation = __webpack_require__(33);
	
	var quoteAttributeValueForBrowser = __webpack_require__(828);
	var warning = __webpack_require__(14);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 414 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(178);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var LinkedValueUtils = __webpack_require__(167);
	var ReactDOMComponentTree = __webpack_require__(22);
	var ReactUpdates = __webpack_require__(35);
	
	var warning = __webpack_require__(14);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var ReactUpdates = __webpack_require__(35);
	var Transaction = __webpack_require__(122);
	
	var emptyFunction = __webpack_require__(34);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(769);
	var BeforeInputEventPlugin = __webpack_require__(771);
	var ChangeEventPlugin = __webpack_require__(773);
	var DefaultEventPluginOrder = __webpack_require__(775);
	var EnterLeaveEventPlugin = __webpack_require__(776);
	var HTMLDOMPropertyConfig = __webpack_require__(778);
	var ReactComponentBrowserEnvironment = __webpack_require__(780);
	var ReactDOMComponent = __webpack_require__(783);
	var ReactDOMComponentTree = __webpack_require__(22);
	var ReactDOMEmptyComponent = __webpack_require__(784);
	var ReactDOMTreeTraversal = __webpack_require__(793);
	var ReactDOMTextComponent = __webpack_require__(791);
	var ReactDefaultBatchingStrategy = __webpack_require__(417);
	var ReactEventListener = __webpack_require__(796);
	var ReactInjection = __webpack_require__(797);
	var ReactReconcileTransaction = __webpack_require__(801);
	var SVGDOMPropertyConfig = __webpack_require__(806);
	var SelectEventPlugin = __webpack_require__(807);
	var SimpleEventPlugin = __webpack_require__(808);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 419 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 420 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var invariant = __webpack_require__(6);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(789);
	
	var containsNode = __webpack_require__(618);
	var focusNode = __webpack_require__(234);
	var getActiveElement = __webpack_require__(235);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(819);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var DOMLazyTree = __webpack_require__(79);
	var DOMProperty = __webpack_require__(80);
	var React = __webpack_require__(62);
	var ReactBrowserEventEmitter = __webpack_require__(120);
	var ReactCurrentOwner = __webpack_require__(38);
	var ReactDOMComponentTree = __webpack_require__(22);
	var ReactDOMContainerInfo = __webpack_require__(415);
	var ReactDOMFeatureFlags = __webpack_require__(785);
	var ReactFeatureFlags = __webpack_require__(420);
	var ReactInstanceMap = __webpack_require__(97);
	var ReactInstrumentation = __webpack_require__(33);
	var ReactMarkupChecksum = __webpack_require__(423);
	var ReactReconciler = __webpack_require__(60);
	var ReactUpdateQueue = __webpack_require__(170);
	var ReactUpdates = __webpack_require__(35);
	
	var emptyObject = __webpack_require__(72);
	var instantiateReactComponent = __webpack_require__(175);
	var invariant = __webpack_require__(6);
	var setInnerHTML = __webpack_require__(124);
	var shouldUpdateReactComponent = __webpack_require__(177);
	var warning = __webpack_require__(14);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var React = __webpack_require__(62);
	
	var invariant = __webpack_require__(6);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var PooledClass = __webpack_require__(59);
	var Transaction = __webpack_require__(122);
	var ReactInstrumentation = __webpack_require__(33);
	var ReactServerUpdateQueue = __webpack_require__(805);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 427 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.4.2';

/***/ },
/* 428 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 430 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(425);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(26);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 433 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(26);
	var escapeTextContentForBrowser = __webpack_require__(123);
	var setInnerHTML = __webpack_require__(124);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var ReactCurrentOwner = __webpack_require__(38);
	var REACT_ELEMENT_TYPE = __webpack_require__(794);
	
	var getIteratorFn = __webpack_require__(824);
	var invariant = __webpack_require__(6);
	var KeyEscapeUtils = __webpack_require__(166);
	var warning = __webpack_require__(14);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(790);


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.FacebookLogin=t(require("react")):e.FacebookLogin=t(e.react)}(this,function(e){return function(e){function t(n){if(o[n])return o[n].exports;var r=o[n]={exports:{},id:n,loaded:!1};return e[n].call(r.exports,r,r.exports,t),r.loaded=!0,r.exports}var o={};return t.m=e,t.c=o,t.p="",t(0)}([function(e,t,o){e.exports=o(8)},function(e,t,o){e.exports=o(6)()},function(t,o){t.exports=e},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e,t){return decodeURIComponent(e.replace(new RegExp("^(?:.*[&\\?]"+encodeURIComponent(t).replace(/[\.\+\*]/g,"\\$&")+"(?:\\=([^&]*))?)?.*$","i"),"$1"))}},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var n in o)Object.prototype.hasOwnProperty.call(o,n)&&(e[n]=o[n])}return e},c=function(){function e(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,o,n){return o&&e(t.prototype,o),n&&e(t,n),t}}(),u=o(2),l=n(u),f=o(1),p=n(f),d=o(5),b=n(d),y=o(3),h=n(y),g=function(){var e=!1;try{e=!!(window.navigator&&window.navigator.standalone||navigator.userAgent.match("CriOS")||navigator.userAgent.match(/mobile/i))}catch(t){}return e},m=function(e){function t(){var e,o,n,a;r(this,t);for(var c=arguments.length,u=Array(c),l=0;l<c;l++)u[l]=arguments[l];return o=n=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(u))),n.state={isSdkLoaded:!1,isProcessing:!1},n.responseApi=function(e){window.FB.api("/me",{locale:n.props.language,fields:n.props.fields},function(t){s(t,e),n.props.callback(t)})},n.checkLoginState=function(e){n.setStateIfMounted({isProcessing:!1}),e.authResponse?n.responseApi(e.authResponse):n.props.onFailure?n.props.onFailure({status:e.status}):n.props.callback({status:e.status})},n.checkLoginAfterRefresh=function(e){"connected"===e.status?n.checkLoginState(e):window.FB.login(function(e){return n.checkLoginState(e)},!0)},n.click=function(e){if(n.state.isSdkLoaded&&!n.state.isProcessing&&!n.props.isDisabled){n.setState({isProcessing:!0});var t=n.props,o=t.scope,r=t.appId,i=t.onClick,a=t.returnScopes,s=t.responseType,c=t.redirectUri,u=t.disableMobileRedirect,l=t.authType,f=t.state;if("function"!=typeof i||(i(e),!e.defaultPrevented)){var p={client_id:r,redirect_uri:c,state:f,return_scopes:a,scope:o,response_type:s,auth_type:l};if(n.props.isMobile&&!u)window.location.href="https://www.facebook.com/dialog/oauth"+(0,b["default"])(p);else{if(!window.FB)return void(n.props.onFailure&&n.props.onFailure({status:"facebookNotLoaded"}));window.FB.login(n.checkLoginState,{scope:o,return_scopes:a,auth_type:p.auth_type})}}}},a=o,i(n,a)}return a(t,e),c(t,[{key:"componentDidMount",value:function(){if(this._isMounted=!0,document.getElementById("facebook-jssdk"))return void this.sdkLoaded();this.setFbAsyncInit(),this.loadSdkAsynchronously();var e=document.getElementById("fb-root");e||(e=document.createElement("div"),e.id="fb-root",document.body.appendChild(e))}},{key:"componentWillReceiveProps",value:function(e){this.state.isSdkLoaded&&e.autoLoad&&!this.props.autoLoad&&window.FB.getLoginStatus(this.checkLoginAfterRefresh)}},{key:"componentWillUnmount",value:function(){this._isMounted=!1}},{key:"setStateIfMounted",value:function(e){this._isMounted&&this.setState(e)}},{key:"setFbAsyncInit",value:function(){var e=this,t=this.props,o=t.appId,n=t.xfbml,r=t.cookie,i=t.version,a=t.autoLoad;window.fbAsyncInit=function(){window.FB.init({version:"v"+i,appId:o,xfbml:n,cookie:r}),e.setStateIfMounted({isSdkLoaded:!0}),(a||e.isRedirectedFromFb())&&window.FB.getLoginStatus(e.checkLoginAfterRefresh)}}},{key:"isRedirectedFromFb",value:function(){var e=window.location.search;return(0,h["default"])(e,"code")||(0,h["default"])(e,"granted_scopes")}},{key:"sdkLoaded",value:function(){this.setState({isSdkLoaded:!0})}},{key:"loadSdkAsynchronously",value:function(){var e=this.props.language;!function(t,o,n){var r=t.getElementsByTagName(o)[0],i=r,a=r;t.getElementById(n)||(a=t.createElement(o),a.id=n,a.src="https://connect.facebook.net/"+e+"/sdk.js",i.parentNode.insertBefore(a,i))}(document,"script","facebook-jssdk")}},{key:"render",value:function o(){var o=this.props.render;if(!o)throw new Error("ReactFacebookLogin requires a render prop to render");var e={onClick:this.click,isDisabled:!!this.props.isDisabled,isProcessing:this.state.isProcessing,isSdkLoaded:this.state.isSdkLoaded};return this.props.render(e)}}]),t}(l["default"].Component);m.propTypes={isDisabled:p["default"].bool,callback:p["default"].func.isRequired,appId:p["default"].string.isRequired,xfbml:p["default"].bool,cookie:p["default"].bool,authType:p["default"].string,scope:p["default"].string,state:p["default"].string,responseType:p["default"].string,returnScopes:p["default"].bool,redirectUri:p["default"].string,autoLoad:p["default"].bool,disableMobileRedirect:p["default"].bool,isMobile:p["default"].bool,fields:p["default"].string,version:p["default"].string,language:p["default"].string,onClick:p["default"].func,onFailure:p["default"].func,render:p["default"].func.isRequired},m.defaultProps={redirectUri:"undefined"!=typeof window?window.location.href:"/",scope:"public_profile,email",returnScopes:!1,xfbml:!1,cookie:!1,authType:"",fields:"name",version:"2.3",language:"en_US",disableMobileRedirect:!1,isMobile:g(),onFailure:null,state:"facebookdirect",responseType:"code"},t["default"]=m},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e){return"?"+Object.keys(e).map(function(t){return t+"="+encodeURIComponent(e[t])}).join("&")}},function(e,t,o){"use strict";function n(){}var r=o(7);e.exports=function(){function e(e,t,o,n,i,a){if(a!==r){var s=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw s.name="Invariant Violation",s}}function t(){return e}e.isRequired=e;var o={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return o.checkPropTypes=n,o.PropTypes=o,o}},function(e,t){"use strict";var o="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=o},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var n in o)Object.prototype.hasOwnProperty.call(o,n)&&(e[n]=o[n])}return e},c=function(){function e(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,o,n){return o&&e(t.prototype,o),n&&e(t,n),t}}(),u=o(2),l=n(u),f=o(1),p=n(f),d=o(9),b=n(d),y=o(4),h=n(y),g=function(e){return["button","input","select","textarea","optgroup","option","fieldset"].indexOf((e+"").toLowerCase())>=0},m=function(e){function t(){return r(this,t),i(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return a(t,e),c(t,[{key:"style",value:function(){var e=this.constructor.defaultProps.cssClass;return this.props.cssClass===e&&l["default"].createElement("style",{dangerouslySetInnerHTML:{__html:b["default"]}})}},{key:"containerStyle",value:function(e){var t=e.isProcessing,o=e.isSdkLoaded,n=e.isDisabled,r={transition:"opacity 0.5s"};return(t||!o||n)&&(r.opacity=.6),s(r,this.props.containerStyle)}},{key:"renderOwnButton",value:function(e){var t=this.props,o=t.cssClass,n=t.size,r=t.icon,i=t.textButton,a=t.typeButton,c=t.buttonStyle,u=e.onClick,f=e.isDisabled,p="string"==typeof r,d={};return f&&g(this.props.tag)&&(d.disabled=!0),l["default"].createElement("span",{style:this.containerStyle(e)},p&&l["default"].createElement("link",{rel:"stylesheet",href:"https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css"}),l["default"].createElement(this.props.tag,s({type:a,className:o+" "+n,style:c,onClick:u},d),r&&p&&l["default"].createElement("i",{className:"fa "+r}),r&&!p&&r,i),this.style())}},{key:"render",value:function(){var e=this;return l["default"].createElement(h["default"],s({},this.props,{render:function(t){return e.renderOwnButton(t)}}))}}]),t}(l["default"].Component);m.propTypes={textButton:p["default"].string,typeButton:p["default"].string,size:p["default"].string,cssClass:p["default"].string,icon:p["default"].any,containerStyle:p["default"].object,buttonStyle:p["default"].object,tag:p["default"].oneOfType([p["default"].node,p["default"].func])},m.defaultProps={textButton:"Login with Facebook",typeButton:"button",size:"metro",fields:"name",cssClass:"kep-login-facebook",tag:"button"},t["default"]=m},function(e,t,o){t=e.exports=o(10)(),t.push([e.id,".kep-login-facebook{font-family:Helvetica,sans-serif;font-weight:700;-webkit-font-smoothing:antialiased;color:#fff;cursor:pointer;display:inline-block;font-size:calc(.27548vw + 12.71074px);text-decoration:none;text-transform:uppercase;transition:background-color .3s,border-color .3s;background-color:#4c69ba;border:calc(.06887vw + .67769px) solid #4c69ba;padding:calc(.34435vw + 13.38843px) calc(.34435vw + 18.38843px)}.kep-login-facebook.small{padding:calc(.34435vw + 3.38843px) calc(.34435vw + 8.38843px)}.kep-login-facebook.medium{padding:calc(.34435vw + 8.38843px) calc(.34435vw + 13.38843px)}.kep-login-facebook.metro{border-radius:0}.kep-login-facebook .fa{margin-right:calc(.34435vw + 3.38843px)}",""]),t.locals={"kep-login-facebook":"kep-login-facebook",small:"small",medium:"medium",metro:"metro",fa:"fa"}},function(e,t){e.exports=function(){var e=[];return e.toString=function(){for(var e=[],t=0;t<this.length;t++){var o=this[t];o[2]?e.push("@media "+o[2]+"{"+o[1]+"}"):e.push(o[1])}return e.join("")},e.i=function(t,o){"string"==typeof t&&(t=[[null,t,""]]);for(var n={},r=0;r<this.length;r++){var i=this[r][0];"number"==typeof i&&(n[i]=!0)}for(r=0;r<t.length;r++){var a=t[r];"number"==typeof a[0]&&n[a[0]]||(o&&!a[2]?a[2]=o:o&&(a[2]="("+a[2]+") and ("+o+")"),e.push(a))}},e}}])});

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var Component = React.Component;
	
	var PropTypes = __webpack_require__(4);
	
	var _require = __webpack_require__(846),
	    getDeviceId = _require.getDeviceId,
	    getFacingModePattern = _require.getFacingModePattern;
	
	var havePropsChanged = __webpack_require__(847);
	var createBlob = __webpack_require__(844);
	
	// Require adapter to support older browser implementations
	__webpack_require__(1023);
	
	// Inline worker.js as a string value of workerBlob.
	// eslint-disable-next-line
	var workerBlob = createBlob(["!function(o,e){\"object\"==typeof exports&&\"object\"==typeof module?module.exports=e():\"function\"==typeof define&&define.amd?define([],e):\"object\"==typeof exports?exports.jsQR=e():o.jsQR=e()}(\"undefined\"!=typeof self?self:this,function(){return function(o){function e(t){if(r[t])return r[t].exports;var c=r[t]={i:t,l:!1,exports:{}};return o[t].call(c.exports,c,c.exports,e),c.l=!0,c.exports}var r={};return e.m=o,e.c=r,e.d=function(o,r,t){e.o(o,r)||Object.defineProperty(o,r,{configurable:!1,enumerable:!0,get:t})},e.n=function(o){var r=o&&o.__esModule?function(){return o.default}:function(){return o};return e.d(r,\"a\",r),r},e.o=function(o,e){return Object.prototype.hasOwnProperty.call(o,e)},e.p=\"\",e(e.s=3)}([function(o,e,r){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0});var t=function(){function o(o,e){this.width=e,this.height=o.length/e,this.data=o}return o.createEmpty=function(e,r){return new o(new Uint8ClampedArray(e*r),e)},o.prototype.get=function(o,e){return!(o<0||o>=this.width||e<0||e>=this.height)&&!!this.data[e*this.width+o]},o.prototype.set=function(o,e,r){this.data[e*this.width+o]=r?1:0},o.prototype.setRegion=function(o,e,r,t,c){for(var s=e;s<e+t;s++)for(var a=o;a<o+r;a++)this.set(a,s,!!c)},o}();e.BitMatrix=t},function(o,e,r){\"use strict\";function t(o,e){return o^e}Object.defineProperty(e,\"__esModule\",{value:!0});var c=r(2);e.addOrSubtractGF=t;var s=function(){function o(o,e,r){this.primitive=o,this.size=e,this.generatorBase=r,this.expTable=new Array(this.size),this.logTable=new Array(this.size);for(var t=1,s=0;s<this.size;s++)this.expTable[s]=t,(t*=2)>=this.size&&(t=(t^this.primitive)&this.size-1);for(var s=0;s<this.size-1;s++)this.logTable[this.expTable[s]]=s;this.zero=new c.default(this,Uint8ClampedArray.from([0])),this.one=new c.default(this,Uint8ClampedArray.from([1]))}return o.prototype.multiply=function(o,e){return 0===o||0===e?0:this.expTable[(this.logTable[o]+this.logTable[e])%(this.size-1)]},o.prototype.inverse=function(o){if(0===o)throw new Error(\"Can't invert 0\");return this.expTable[this.size-this.logTable[o]-1]},o.prototype.buildMonomial=function(o,e){if(o<0)throw new Error(\"Invalid monomial degree less than 0\");if(0===e)return this.zero;var r=new Uint8ClampedArray(o+1);return r[0]=e,new c.default(this,r)},o.prototype.log=function(o){if(0===o)throw new Error(\"Can't take log(0)\");return this.logTable[o]},o.prototype.exp=function(o){return this.expTable[o]},o}();e.default=s},function(o,e,r){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0});var t=r(1),c=function(){function o(o,e){if(0===e.length)throw new Error(\"No coefficients.\");this.field=o;var r=e.length;if(r>1&&0===e[0]){for(var t=1;t<r&&0===e[t];)t++;if(t===r)this.coefficients=o.zero.coefficients;else{this.coefficients=new Uint8ClampedArray(r-t);for(var c=0;c<this.coefficients.length;c++)this.coefficients[c]=e[t+c]}}else this.coefficients=e}return o.prototype.degree=function(){return this.coefficients.length-1},o.prototype.isZero=function(){return 0===this.coefficients[0]},o.prototype.getCoefficient=function(o){return this.coefficients[this.coefficients.length-1-o]},o.prototype.addOrSubtract=function(e){if(this.isZero())return e;if(e.isZero())return this;var r=this.coefficients,c=e.coefficients;r.length>c.length&&(n=[c,r],r=n[0],c=n[1]);for(var s=new Uint8ClampedArray(c.length),a=c.length-r.length,d=0;d<a;d++)s[d]=c[d];for(var d=a;d<c.length;d++)s[d]=t.addOrSubtractGF(r[d-a],c[d]);return new o(this.field,s);var n},o.prototype.multiply=function(e){if(0===e)return this.field.zero;if(1===e)return this;for(var r=this.coefficients.length,t=new Uint8ClampedArray(r),c=0;c<r;c++)t[c]=this.field.multiply(this.coefficients[c],e);return new o(this.field,t)},o.prototype.multiplyPoly=function(e){if(this.isZero()||e.isZero())return this.field.zero;for(var r=this.coefficients,c=r.length,s=e.coefficients,a=s.length,d=new Uint8ClampedArray(c+a-1),n=0;n<c;n++)for(var l=r[n],i=0;i<a;i++)d[n+i]=t.addOrSubtractGF(d[n+i],this.field.multiply(l,s[i]));return new o(this.field,d)},o.prototype.multiplyByMonomial=function(e,r){if(e<0)throw new Error(\"Invalid degree less than 0\");if(0===r)return this.field.zero;for(var t=this.coefficients.length,c=new Uint8ClampedArray(t+e),s=0;s<t;s++)c[s]=this.field.multiply(this.coefficients[s],r);return new o(this.field,c)},o.prototype.evaluateAt=function(o){var e=0;if(0===o)return this.getCoefficient(0);var r=this.coefficients.length;if(1===o)return this.coefficients.forEach(function(o){e=t.addOrSubtractGF(e,o)}),e;e=this.coefficients[0];for(var c=1;c<r;c++)e=t.addOrSubtractGF(this.field.multiply(o,e),this.coefficients[c]);return e},o}();e.default=c},function(o,e,r){\"use strict\";function t(o){var e=n.locate(o);if(!e)return null;var r=d.extract(o,e),t=a.decode(r.matrix);return t?{binaryData:t.bytes,data:t.text,chunks:t.chunks,location:{topRightCorner:r.mappingFunction(e.dimension,0),topLeftCorner:r.mappingFunction(0,0),bottomRightCorner:r.mappingFunction(e.dimension,e.dimension),bottomLeftCorner:r.mappingFunction(0,e.dimension),topRightFinderPattern:e.topRight,topLeftFinderPattern:e.topLeft,bottomLeftFinderPattern:e.bottomLeft,bottomRightAlignmentPattern:e.alignmentPattern}}:null}function c(o,e,r,c){void 0===c&&(c={});var a=l;Object.keys(a||{}).forEach(function(o){a[o]=c[o]||a[o]});var d=\"attemptBoth\"===a.inversionAttempts||\"invertFirst\"===a.inversionAttempts,n=\"onlyInvert\"===a.inversionAttempts||\"invertFirst\"===a.inversionAttempts,i=s.binarize(o,e,r,d),B=i.binarized,k=i.inverted,u=t(n?k:B);return u||\"attemptBoth\"!==a.inversionAttempts&&\"invertFirst\"!==a.inversionAttempts||(u=t(n?B:k)),u}Object.defineProperty(e,\"__esModule\",{value:!0});var s=r(4),a=r(5),d=r(11),n=r(12),l={inversionAttempts:\"attemptBoth\"};c.default=c,e.default=c},function(o,e,r){\"use strict\";function t(o,e,r){return o<e?e:o>r?r:o}function c(o,e,r,c){if(o.length!==e*r*4)throw new Error(\"Malformed data passed to binarizer.\");for(var l=new n(e,r),i=0;i<e;i++)for(var B=0;B<r;B++){var k=o[4*(B*e+i)+0],u=o[4*(B*e+i)+1],C=o[4*(B*e+i)+2];l.set(i,B,.2126*k+.7152*u+.0722*C)}for(var m=Math.ceil(e/a),f=Math.ceil(r/a),w=new n(m,f),P=0;P<f;P++)for(var v=0;v<m;v++){for(var h=0,p=1/0,y=0,B=0;B<a;B++)for(var i=0;i<a;i++){var b=l.get(v*a+i,P*a+B);h+=b,p=Math.min(p,b),y=Math.max(y,b)}var g=h/Math.pow(a,2);if(y-p<=d&&(g=p/2,P>0&&v>0)){var x=(w.get(v,P-1)+2*w.get(v-1,P)+w.get(v-1,P-1))/4;p<x&&(g=x)}w.set(v,P,g)}var M=s.BitMatrix.createEmpty(e,r),L=null;c&&(L=s.BitMatrix.createEmpty(e,r));for(var P=0;P<f;P++)for(var v=0;v<m;v++){for(var N=t(v,2,m-3),I=t(P,2,f-3),h=0,O=-2;O<=2;O++)for(var z=-2;z<=2;z++)h+=w.get(N+O,I+z);for(var S=h/25,O=0;O<a;O++)for(var z=0;z<a;z++){var i=v*a+O,B=P*a+z,X=l.get(i,B);M.set(i,B,X<=S),c&&L.set(i,B,!(X<=S))}}return c?{binarized:M,inverted:L}:{binarized:M}}Object.defineProperty(e,\"__esModule\",{value:!0});var s=r(0),a=8,d=24,n=function(){function o(o,e){this.width=o,this.data=new Uint8ClampedArray(o*e)}return o.prototype.get=function(o,e){return this.data[e*this.width+o]},o.prototype.set=function(o,e,r){this.data[e*this.width+o]=r},o}();e.binarize=c},function(o,e,r){\"use strict\";function t(o,e){for(var r=o^e,t=0;r;)t++,r&=r-1;return t}function c(o,e){return e<<1|o}function s(o){var e=17+4*o.versionNumber,r=k.BitMatrix.createEmpty(e,e);r.setRegion(0,0,9,9,!0),r.setRegion(e-8,0,8,9,!0),r.setRegion(0,e-8,9,8,!0);for(var t=0,c=o.alignmentPatternCenters;t<c.length;t++)for(var s=c[t],a=0,d=o.alignmentPatternCenters;a<d.length;a++){var n=d[a];6===s&&6===n||6===s&&n===e-7||s===e-7&&6===n||r.setRegion(s-2,n-2,5,5,!0)}return r.setRegion(6,9,1,e-17,!0),r.setRegion(9,6,e-17,1,!0),o.versionNumber>6&&(r.setRegion(e-11,0,3,6,!0),r.setRegion(0,e-11,6,3,!0)),r}function a(o,e,r){for(var t=w[r.dataMask],a=o.height,d=s(e),n=[],l=0,i=0,B=!0,k=a-1;k>0;k-=2){6===k&&k--;for(var u=0;u<a;u++)for(var C=B?a-1-u:u,m=0;m<2;m++){var f=k-m;if(!d.get(f,C)){i++;var P=o.get(f,C);t({y:C,x:f})&&(P=!P),l=c(P,l),8===i&&(n.push(l),i=0,l=0)}}B=!B}return n}function d(o){var e=o.height,r=Math.floor((e-17)/4);if(r<=6)return m.VERSIONS[r-1];for(var s=0,a=5;a>=0;a--)for(var d=e-9;d>=e-11;d--)s=c(o.get(d,a),s);for(var n=0,d=5;d>=0;d--)for(var a=e-9;a>=e-11;a--)n=c(o.get(d,a),n);for(var l,i=1/0,B=0,k=m.VERSIONS;B<k.length;B++){var u=k[B];if(u.infoBits===s||u.infoBits===n)return u;var C=t(s,u.infoBits);C<i&&(l=u,i=C),C=t(n,u.infoBits),C<i&&(l=u,i=C)}return i<=3?l:void 0}function n(o){for(var e=0,r=0;r<=8;r++)6!==r&&(e=c(o.get(r,8),e));for(var s=7;s>=0;s--)6!==s&&(e=c(o.get(8,s),e));for(var a=o.height,d=0,s=a-1;s>=a-7;s--)d=c(o.get(8,s),d);for(var r=a-8;r<a;r++)d=c(o.get(r,8),d);for(var n=1/0,l=null,i=0,B=f;i<B.length;i++){var k=B[i],u=k.bits,C=k.formatInfo;if(u===e||u===d)return C;var m=t(e,u);m<n&&(l=C,n=m),e!==d&&(m=t(d,u))<n&&(l=C,n=m)}return n<=3?l:null}function l(o,e,r){var t=e.errorCorrectionLevels[r],c=[],s=0;if(t.ecBlocks.forEach(function(o){for(var e=0;e<o.numBlocks;e++)c.push({numDataCodewords:o.dataCodewordsPerBlock,codewords:[]}),s+=o.dataCodewordsPerBlock+t.ecCodewordsPerBlock}),o.length<s)return null;o=o.slice(0,s);for(var a=t.ecBlocks[0].dataCodewordsPerBlock,d=0;d<a;d++)for(var n=0,l=c;n<l.length;n++){var i=l[n];i.codewords.push(o.shift())}if(t.ecBlocks.length>1)for(var B=t.ecBlocks[0].numBlocks,k=t.ecBlocks[1].numBlocks,d=0;d<k;d++)c[B+d].codewords.push(o.shift());for(;o.length>0;)for(var u=0,C=c;u<C.length;u++){var i=C[u];i.codewords.push(o.shift())}return c}function i(o){var e=d(o);if(!e)return null;var r=n(o);if(!r)return null;var t=a(o,e,r),c=l(t,e,r.errorCorrectionLevel);if(!c)return null;for(var s=c.reduce(function(o,e){return o+e.numDataCodewords},0),i=new Uint8ClampedArray(s),B=0,k=0,m=c;k<m.length;k++){var f=m[k],w=C.decode(f.codewords,f.codewords.length-f.numDataCodewords);if(!w)return null;for(var P=0;P<f.numDataCodewords;P++)i[B++]=w[P]}try{return u.decode(i,e.versionNumber)}catch(o){return null}}function B(o){if(null==o)return null;var e=i(o);if(e)return e;for(var r=0;r<o.width;r++)for(var t=r+1;t<o.height;t++)o.get(r,t)!==o.get(t,r)&&(o.set(r,t,!o.get(r,t)),o.set(t,r,!o.get(t,r)));return i(o)}Object.defineProperty(e,\"__esModule\",{value:!0});var k=r(0),u=r(6),C=r(9),m=r(10),f=[{bits:21522,formatInfo:{errorCorrectionLevel:1,dataMask:0}},{bits:20773,formatInfo:{errorCorrectionLevel:1,dataMask:1}},{bits:24188,formatInfo:{errorCorrectionLevel:1,dataMask:2}},{bits:23371,formatInfo:{errorCorrectionLevel:1,dataMask:3}},{bits:17913,formatInfo:{errorCorrectionLevel:1,dataMask:4}},{bits:16590,formatInfo:{errorCorrectionLevel:1,dataMask:5}},{bits:20375,formatInfo:{errorCorrectionLevel:1,dataMask:6}},{bits:19104,formatInfo:{errorCorrectionLevel:1,dataMask:7}},{bits:30660,formatInfo:{errorCorrectionLevel:0,dataMask:0}},{bits:29427,formatInfo:{errorCorrectionLevel:0,dataMask:1}},{bits:32170,formatInfo:{errorCorrectionLevel:0,dataMask:2}},{bits:30877,formatInfo:{errorCorrectionLevel:0,dataMask:3}},{bits:26159,formatInfo:{errorCorrectionLevel:0,dataMask:4}},{bits:25368,formatInfo:{errorCorrectionLevel:0,dataMask:5}},{bits:27713,formatInfo:{errorCorrectionLevel:0,dataMask:6}},{bits:26998,formatInfo:{errorCorrectionLevel:0,dataMask:7}},{bits:5769,formatInfo:{errorCorrectionLevel:3,dataMask:0}},{bits:5054,formatInfo:{errorCorrectionLevel:3,dataMask:1}},{bits:7399,formatInfo:{errorCorrectionLevel:3,dataMask:2}},{bits:6608,formatInfo:{errorCorrectionLevel:3,dataMask:3}},{bits:1890,formatInfo:{errorCorrectionLevel:3,dataMask:4}},{bits:597,formatInfo:{errorCorrectionLevel:3,dataMask:5}},{bits:3340,formatInfo:{errorCorrectionLevel:3,dataMask:6}},{bits:2107,formatInfo:{errorCorrectionLevel:3,dataMask:7}},{bits:13663,formatInfo:{errorCorrectionLevel:2,dataMask:0}},{bits:12392,formatInfo:{errorCorrectionLevel:2,dataMask:1}},{bits:16177,formatInfo:{errorCorrectionLevel:2,dataMask:2}},{bits:14854,formatInfo:{errorCorrectionLevel:2,dataMask:3}},{bits:9396,formatInfo:{errorCorrectionLevel:2,dataMask:4}},{bits:8579,formatInfo:{errorCorrectionLevel:2,dataMask:5}},{bits:11994,formatInfo:{errorCorrectionLevel:2,dataMask:6}},{bits:11245,formatInfo:{errorCorrectionLevel:2,dataMask:7}}],w=[function(o){return(o.y+o.x)%2==0},function(o){return o.y%2==0},function(o){return o.x%3==0},function(o){return(o.y+o.x)%3==0},function(o){return(Math.floor(o.y/2)+Math.floor(o.x/3))%2==0},function(o){return o.x*o.y%2+o.x*o.y%3==0},function(o){return(o.y*o.x%2+o.y*o.x%3)%2==0},function(o){return((o.y+o.x)%2+o.y*o.x%3)%2==0}];e.decode=B},function(o,e,r){\"use strict\";function t(o,e){for(var r=[],t=\"\",c=[10,12,14][e],s=o.readBits(c);s>=3;){var a=o.readBits(10);if(a>=1e3)throw new Error(\"Invalid numeric value above 999\");var d=Math.floor(a/100),n=Math.floor(a/10)%10,l=a%10;r.push(48+d,48+n,48+l),t+=d.toString()+n.toString()+l.toString(),s-=3}if(2===s){var a=o.readBits(7);if(a>=100)throw new Error(\"Invalid numeric value above 99\");var d=Math.floor(a/10),n=a%10;r.push(48+d,48+n),t+=d.toString()+n.toString()}else if(1===s){var a=o.readBits(4);if(a>=10)throw new Error(\"Invalid numeric value above 9\");r.push(48+a),t+=a.toString()}return{bytes:r,text:t}}function c(o,e){for(var r=[],t=\"\",c=[9,11,13][e],s=o.readBits(c);s>=2;){var a=o.readBits(11),d=Math.floor(a/45),n=a%45;r.push(k[d].charCodeAt(0),k[n].charCodeAt(0)),t+=k[d]+k[n],s-=2}if(1===s){var d=o.readBits(6);r.push(k[d].charCodeAt(0)),t+=k[d]}return{bytes:r,text:t}}function s(o,e){for(var r=[],t=\"\",c=[8,16,16][e],s=o.readBits(c),a=0;a<s;a++){var d=o.readBits(8);r.push(d)}try{t+=decodeURIComponent(r.map(function(o){return\"%\"+(\"0\"+o.toString(16)).substr(-2)}).join(\"\"))}catch(o){}return{bytes:r,text:t}}function a(o,e){for(var r=[],t=\"\",c=[8,10,12][e],s=o.readBits(c),a=0;a<s;a++){var d=o.readBits(13),n=Math.floor(d/192)<<8|d%192;n+=n<7936?33088:49472,r.push(n>>8,255&n),t+=String.fromCharCode(i.shiftJISTable[n])}return{bytes:r,text:t}}function d(o,e){for(var r=new l.BitStream(o),d=e<=9?0:e<=26?1:2,i={text:\"\",bytes:[],chunks:[]};r.available()>=4;){var k=r.readBits(4);if(k===B.Terminator)return i;if(k===B.ECI)0===r.readBits(1)?i.chunks.push({type:n.ECI,assignmentNumber:r.readBits(7)}):0===r.readBits(1)?i.chunks.push({type:n.ECI,assignmentNumber:r.readBits(14)}):0===r.readBits(1)?i.chunks.push({type:n.ECI,assignmentNumber:r.readBits(21)}):i.chunks.push({type:n.ECI,assignmentNumber:-1});else if(k===B.Numeric){var u=t(r,d);i.text+=u.text,(w=i.bytes).push.apply(w,u.bytes),i.chunks.push({type:n.Numeric,text:u.text})}else if(k===B.Alphanumeric){var C=c(r,d);i.text+=C.text,(P=i.bytes).push.apply(P,C.bytes),i.chunks.push({type:n.Alphanumeric,text:C.text})}else if(k===B.Byte){var m=s(r,d);i.text+=m.text,(v=i.bytes).push.apply(v,m.bytes),i.chunks.push({type:n.Byte,bytes:m.bytes,text:m.text})}else if(k===B.Kanji){var f=a(r,d);i.text+=f.text,(h=i.bytes).push.apply(h,f.bytes),i.chunks.push({type:n.Kanji,bytes:f.bytes,text:f.text})}}var w,P,v,h}Object.defineProperty(e,\"__esModule\",{value:!0});var n,l=r(7),i=r(8);!function(o){o.Numeric=\"numeric\",o.Alphanumeric=\"alphanumeric\",o.Byte=\"byte\",o.Kanji=\"kanji\",o.ECI=\"eci\"}(n=e.Mode||(e.Mode={}));var B;!function(o){o[o.Terminator=0]=\"Terminator\",o[o.Numeric=1]=\"Numeric\",o[o.Alphanumeric=2]=\"Alphanumeric\",o[o.Byte=4]=\"Byte\",o[o.Kanji=8]=\"Kanji\",o[o.ECI=7]=\"ECI\"}(B||(B={}));var k=[\"0\",\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"A\",\"B\",\"C\",\"D\",\"E\",\"F\",\"G\",\"H\",\"I\",\"J\",\"K\",\"L\",\"M\",\"N\",\"O\",\"P\",\"Q\",\"R\",\"S\",\"T\",\"U\",\"V\",\"W\",\"X\",\"Y\",\"Z\",\" \",\"$\",\"%\",\"*\",\"+\",\"-\",\".\",\"/\",\":\"];e.decode=d},function(o,e,r){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0});var t=function(){function o(o){this.byteOffset=0,this.bitOffset=0,this.bytes=o}return o.prototype.readBits=function(o){if(o<1||o>32||o>this.available())throw new Error(\"Cannot read \"+o.toString()+\" bits\");var e=0;if(this.bitOffset>0){var r=8-this.bitOffset,t=o<r?o:r,c=r-t,s=255>>8-t<<c;e=(this.bytes[this.byteOffset]&s)>>c,o-=t,this.bitOffset+=t,8===this.bitOffset&&(this.bitOffset=0,this.byteOffset++)}if(o>0){for(;o>=8;)e=e<<8|255&this.bytes[this.byteOffset],this.byteOffset++,o-=8;if(o>0){var c=8-o,s=255>>c<<c;e=e<<o|(this.bytes[this.byteOffset]&s)>>c,this.bitOffset+=o}}return e},o.prototype.available=function(){return 8*(this.bytes.length-this.byteOffset)-this.bitOffset},o}();e.BitStream=t},function(o,e,r){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.shiftJISTable={32:32,33:33,34:34,35:35,36:36,37:37,38:38,39:39,40:40,41:41,42:42,43:43,44:44,45:45,46:46,47:47,48:48,49:49,50:50,51:51,52:52,53:53,54:54,55:55,56:56,57:57,58:58,59:59,60:60,61:61,62:62,63:63,64:64,65:65,66:66,67:67,68:68,69:69,70:70,71:71,72:72,73:73,74:74,75:75,76:76,77:77,78:78,79:79,80:80,81:81,82:82,83:83,84:84,85:85,86:86,87:87,88:88,89:89,90:90,91:91,92:165,93:93,94:94,95:95,96:96,97:97,98:98,99:99,100:100,101:101,102:102,103:103,104:104,105:105,106:106,107:107,108:108,109:109,110:110,111:111,112:112,113:113,114:114,115:115,116:116,117:117,118:118,119:119,120:120,121:121,122:122,123:123,124:124,125:125,126:8254,33088:12288,33089:12289,33090:12290,33091:65292,33092:65294,33093:12539,33094:65306,33095:65307,33096:65311,33097:65281,33098:12443,33099:12444,33100:180,33101:65344,33102:168,33103:65342,33104:65507,33105:65343,33106:12541,33107:12542,33108:12445,33109:12446,33110:12291,33111:20189,33112:12293,33113:12294,33114:12295,33115:12540,33116:8213,33117:8208,33118:65295,33119:92,33120:12316,33121:8214,33122:65372,33123:8230,33124:8229,33125:8216,33126:8217,33127:8220,33128:8221,33129:65288,33130:65289,33131:12308,33132:12309,33133:65339,33134:65341,33135:65371,33136:65373,33137:12296,33138:12297,33139:12298,33140:12299,33141:12300,33142:12301,33143:12302,33144:12303,33145:12304,33146:12305,33147:65291,33148:8722,33149:177,33150:215,33152:247,33153:65309,33154:8800,33155:65308,33156:65310,33157:8806,33158:8807,33159:8734,33160:8756,33161:9794,33162:9792,33163:176,33164:8242,33165:8243,33166:8451,33167:65509,33168:65284,33169:162,33170:163,33171:65285,33172:65283,33173:65286,33174:65290,33175:65312,33176:167,33177:9734,33178:9733,33179:9675,33180:9679,33181:9678,33182:9671,33183:9670,33184:9633,33185:9632,33186:9651,33187:9650,33188:9661,33189:9660,33190:8251,33191:12306,33192:8594,33193:8592,33194:8593,33195:8595,33196:12307,33208:8712,33209:8715,33210:8838,33211:8839,33212:8834,33213:8835,33214:8746,33215:8745,33224:8743,33225:8744,33226:172,33227:8658,33228:8660,33229:8704,33230:8707,33242:8736,33243:8869,33244:8978,33245:8706,33246:8711,33247:8801,33248:8786,33249:8810,33250:8811,33251:8730,33252:8765,33253:8733,33254:8757,33255:8747,33256:8748,33264:8491,33265:8240,33266:9839,33267:9837,33268:9834,33269:8224,33270:8225,33271:182,33276:9711,33359:65296,33360:65297,33361:65298,33362:65299,33363:65300,33364:65301,33365:65302,33366:65303,33367:65304,33368:65305,33376:65313,33377:65314,33378:65315,33379:65316,33380:65317,33381:65318,33382:65319,33383:65320,33384:65321,33385:65322,33386:65323,33387:65324,33388:65325,33389:65326,33390:65327,33391:65328,33392:65329,33393:65330,33394:65331,33395:65332,33396:65333,33397:65334,33398:65335,33399:65336,33400:65337,33401:65338,33409:65345,33410:65346,33411:65347,33412:65348,33413:65349,33414:65350,33415:65351,33416:65352,33417:65353,33418:65354,33419:65355,33420:65356,33421:65357,33422:65358,33423:65359,33424:65360,33425:65361,33426:65362,33427:65363,33428:65364,33429:65365,33430:65366,33431:65367,33432:65368,33433:65369,33434:65370,33439:12353,33440:12354,33441:12355,33442:12356,33443:12357,33444:12358,33445:12359,33446:12360,33447:12361,33448:12362,33449:12363,33450:12364,33451:12365,33452:12366,33453:12367,33454:12368,33455:12369,33456:12370,33457:12371,33458:12372,33459:12373,33460:12374,33461:12375,33462:12376,33463:12377,33464:12378,33465:12379,33466:12380,33467:12381,33468:12382,33469:12383,33470:12384,33471:12385,33472:12386,33473:12387,33474:12388,33475:12389,33476:12390,33477:12391,33478:12392,33479:12393,33480:12394,33481:12395,33482:12396,33483:12397,33484:12398,33485:12399,33486:12400,33487:12401,33488:12402,33489:12403,33490:12404,33491:12405,33492:12406,33493:12407,33494:12408,33495:12409,33496:12410,33497:12411,33498:12412,33499:12413,33500:12414,33501:12415,33502:12416,33503:12417,33504:12418,33505:12419,33506:12420,33507:12421,33508:12422,33509:12423,33510:12424,33511:12425,33512:12426,33513:12427,33514:12428,33515:12429,33516:12430,33517:12431,33518:12432,33519:12433,33520:12434,33521:12435,33600:12449,33601:12450,33602:12451,33603:12452,33604:12453,33605:12454,33606:12455,33607:12456,33608:12457,33609:12458,33610:12459,33611:12460,33612:12461,33613:12462,33614:12463,33615:12464,33616:12465,33617:12466,33618:12467,33619:12468,33620:12469,33621:12470,33622:12471,33623:12472,33624:12473,33625:12474,33626:12475,33627:12476,33628:12477,33629:12478,33630:12479,33631:12480,33632:12481,33633:12482,33634:12483,33635:12484,33636:12485,33637:12486,33638:12487,33639:12488,33640:12489,33641:12490,33642:12491,33643:12492,33644:12493,33645:12494,33646:12495,33647:12496,33648:12497,33649:12498,33650:12499,33651:12500,33652:12501,33653:12502,33654:12503,33655:12504,33656:12505,33657:12506,33658:12507,33659:12508,33660:12509,33661:12510,33662:12511,33664:12512,33665:12513,33666:12514,33667:12515,33668:12516,33669:12517,33670:12518,33671:12519,33672:12520,33673:12521,33674:12522,33675:12523,33676:12524,33677:12525,33678:12526,33679:12527,33680:12528,33681:12529,33682:12530,33683:12531,33684:12532,33685:12533,33686:12534,33695:913,33696:914,33697:915,33698:916,33699:917,33700:918,33701:919,33702:920,33703:921,33704:922,33705:923,33706:924,33707:925,33708:926,33709:927,33710:928,33711:929,33712:931,33713:932,33714:933,33715:934,33716:935,33717:936,33718:937,33727:945,33728:946,33729:947,33730:948,33731:949,33732:950,33733:951,33734:952,33735:953,33736:954,33737:955,33738:956,33739:957,33740:958,33741:959,33742:960,33743:961,33744:963,33745:964,33746:965,33747:966,33748:967,33749:968,33750:969,33856:1040,33857:1041,33858:1042,33859:1043,33860:1044,33861:1045,33862:1025,33863:1046,33864:1047,33865:1048,33866:1049,33867:1050,33868:1051,33869:1052,33870:1053,33871:1054,33872:1055,33873:1056,33874:1057,33875:1058,33876:1059,33877:1060,33878:1061,33879:1062,33880:1063,33881:1064,33882:1065,33883:1066,33884:1067,33885:1068,33886:1069,33887:1070,33888:1071,33904:1072,33905:1073,33906:1074,33907:1075,33908:1076,33909:1077,33910:1105,33911:1078,33912:1079,33913:1080,33914:1081,33915:1082,33916:1083,33917:1084,33918:1085,33920:1086,33921:1087,33922:1088,33923:1089,33924:1090,33925:1091,33926:1092,33927:1093,33928:1094,33929:1095,33930:1096,33931:1097,33932:1098,33933:1099,33934:1100,33935:1101,33936:1102,33937:1103,33951:9472,33952:9474,33953:9484,33954:9488,33955:9496,33956:9492,33957:9500,33958:9516,33959:9508,33960:9524,33961:9532,33962:9473,33963:9475,33964:9487,33965:9491,33966:9499,33967:9495,33968:9507,33969:9523,33970:9515,33971:9531,33972:9547,33973:9504,33974:9519,33975:9512,33976:9527,33977:9535,33978:9501,33979:9520,33980:9509,33981:9528,33982:9538,34975:20124,34976:21782,34977:23043,34978:38463,34979:21696,34980:24859,34981:25384,34982:23030,34983:36898,34984:33909,34985:33564,34986:31312,34987:24746,34988:25569,34989:28197,34990:26093,34991:33894,34992:33446,34993:39925,34994:26771,34995:22311,34996:26017,34997:25201,34998:23451,34999:22992,35e3:34427,35001:39156,35002:32098,35003:32190,35004:39822,35005:25110,35006:31903,35007:34999,35008:23433,35009:24245,35010:25353,35011:26263,35012:26696,35013:38343,35014:38797,35015:26447,35016:20197,35017:20234,35018:20301,35019:20381,35020:20553,35021:22258,35022:22839,35023:22996,35024:23041,35025:23561,35026:24799,35027:24847,35028:24944,35029:26131,35030:26885,35031:28858,35032:30031,35033:30064,35034:31227,35035:32173,35036:32239,35037:32963,35038:33806,35039:34915,35040:35586,35041:36949,35042:36986,35043:21307,35044:20117,35045:20133,35046:22495,35047:32946,35048:37057,35049:30959,35050:19968,35051:22769,35052:28322,35053:36920,35054:31282,35055:33576,35056:33419,35057:39983,35058:20801,35059:21360,35060:21693,35061:21729,35062:22240,35063:23035,35064:24341,35065:39154,35066:28139,35067:32996,35068:34093,35136:38498,35137:38512,35138:38560,35139:38907,35140:21515,35141:21491,35142:23431,35143:28879,35144:32701,35145:36802,35146:38632,35147:21359,35148:40284,35149:31418,35150:19985,35151:30867,35152:33276,35153:28198,35154:22040,35155:21764,35156:27421,35157:34074,35158:39995,35159:23013,35160:21417,35161:28006,35162:29916,35163:38287,35164:22082,35165:20113,35166:36939,35167:38642,35168:33615,35169:39180,35170:21473,35171:21942,35172:23344,35173:24433,35174:26144,35175:26355,35176:26628,35177:27704,35178:27891,35179:27945,35180:29787,35181:30408,35182:31310,35183:38964,35184:33521,35185:34907,35186:35424,35187:37613,35188:28082,35189:30123,35190:30410,35191:39365,35192:24742,35193:35585,35194:36234,35195:38322,35196:27022,35197:21421,35198:20870,35200:22290,35201:22576,35202:22852,35203:23476,35204:24310,35205:24616,35206:25513,35207:25588,35208:27839,35209:28436,35210:28814,35211:28948,35212:29017,35213:29141,35214:29503,35215:32257,35216:33398,35217:33489,35218:34199,35219:36960,35220:37467,35221:40219,35222:22633,35223:26044,35224:27738,35225:29989,35226:20985,35227:22830,35228:22885,35229:24448,35230:24540,35231:25276,35232:26106,35233:27178,35234:27431,35235:27572,35236:29579,35237:32705,35238:35158,35239:40236,35240:40206,35241:40644,35242:23713,35243:27798,35244:33659,35245:20740,35246:23627,35247:25014,35248:33222,35249:26742,35250:29281,35251:20057,35252:20474,35253:21368,35254:24681,35255:28201,35256:31311,35257:38899,35258:19979,35259:21270,35260:20206,35261:20309,35262:20285,35263:20385,35264:20339,35265:21152,35266:21487,35267:22025,35268:22799,35269:23233,35270:23478,35271:23521,35272:31185,35273:26247,35274:26524,35275:26550,35276:27468,35277:27827,35278:28779,35279:29634,35280:31117,35281:31166,35282:31292,35283:31623,35284:33457,35285:33499,35286:33540,35287:33655,35288:33775,35289:33747,35290:34662,35291:35506,35292:22057,35293:36008,35294:36838,35295:36942,35296:38686,35297:34442,35298:20420,35299:23784,35300:25105,35301:29273,35302:30011,35303:33253,35304:33469,35305:34558,35306:36032,35307:38597,35308:39187,35309:39381,35310:20171,35311:20250,35312:35299,35313:22238,35314:22602,35315:22730,35316:24315,35317:24555,35318:24618,35319:24724,35320:24674,35321:25040,35322:25106,35323:25296,35324:25913,35392:39745,35393:26214,35394:26800,35395:28023,35396:28784,35397:30028,35398:30342,35399:32117,35400:33445,35401:34809,35402:38283,35403:38542,35404:35997,35405:20977,35406:21182,35407:22806,35408:21683,35409:23475,35410:23830,35411:24936,35412:27010,35413:28079,35414:30861,35415:33995,35416:34903,35417:35442,35418:37799,35419:39608,35420:28012,35421:39336,35422:34521,35423:22435,35424:26623,35425:34510,35426:37390,35427:21123,35428:22151,35429:21508,35430:24275,35431:25313,35432:25785,35433:26684,35434:26680,35435:27579,35436:29554,35437:30906,35438:31339,35439:35226,35440:35282,35441:36203,35442:36611,35443:37101,35444:38307,35445:38548,35446:38761,35447:23398,35448:23731,35449:27005,35450:38989,35451:38990,35452:25499,35453:31520,35454:27179,35456:27263,35457:26806,35458:39949,35459:28511,35460:21106,35461:21917,35462:24688,35463:25324,35464:27963,35465:28167,35466:28369,35467:33883,35468:35088,35469:36676,35470:19988,35471:39993,35472:21494,35473:26907,35474:27194,35475:38788,35476:26666,35477:20828,35478:31427,35479:33970,35480:37340,35481:37772,35482:22107,35483:40232,35484:26658,35485:33541,35486:33841,35487:31909,35488:21e3,35489:33477,35490:29926,35491:20094,35492:20355,35493:20896,35494:23506,35495:21002,35496:21208,35497:21223,35498:24059,35499:21914,35500:22570,35501:23014,35502:23436,35503:23448,35504:23515,35505:24178,35506:24185,35507:24739,35508:24863,35509:24931,35510:25022,35511:25563,35512:25954,35513:26577,35514:26707,35515:26874,35516:27454,35517:27475,35518:27735,35519:28450,35520:28567,35521:28485,35522:29872,35523:29976,35524:30435,35525:30475,35526:31487,35527:31649,35528:31777,35529:32233,35530:32566,35531:32752,35532:32925,35533:33382,35534:33694,35535:35251,35536:35532,35537:36011,35538:36996,35539:37969,35540:38291,35541:38289,35542:38306,35543:38501,35544:38867,35545:39208,35546:33304,35547:20024,35548:21547,35549:23736,35550:24012,35551:29609,35552:30284,35553:30524,35554:23721,35555:32747,35556:36107,35557:38593,35558:38929,35559:38996,35560:39e3,35561:20225,35562:20238,35563:21361,35564:21916,35565:22120,35566:22522,35567:22855,35568:23305,35569:23492,35570:23696,35571:24076,35572:24190,35573:24524,35574:25582,35575:26426,35576:26071,35577:26082,35578:26399,35579:26827,35580:26820,35648:27231,35649:24112,35650:27589,35651:27671,35652:27773,35653:30079,35654:31048,35655:23395,35656:31232,35657:32e3,35658:24509,35659:35215,35660:35352,35661:36020,35662:36215,35663:36556,35664:36637,35665:39138,35666:39438,35667:39740,35668:20096,35669:20605,35670:20736,35671:22931,35672:23452,35673:25135,35674:25216,35675:25836,35676:27450,35677:29344,35678:30097,35679:31047,35680:32681,35681:34811,35682:35516,35683:35696,35684:25516,35685:33738,35686:38816,35687:21513,35688:21507,35689:21931,35690:26708,35691:27224,35692:35440,35693:30759,35694:26485,35695:40653,35696:21364,35697:23458,35698:33050,35699:34384,35700:36870,35701:19992,35702:20037,35703:20167,35704:20241,35705:21450,35706:21560,35707:23470,35708:24339,35709:24613,35710:25937,35712:26429,35713:27714,35714:27762,35715:27875,35716:28792,35717:29699,35718:31350,35719:31406,35720:31496,35721:32026,35722:31998,35723:32102,35724:26087,35725:29275,35726:21435,35727:23621,35728:24040,35729:25298,35730:25312,35731:25369,35732:28192,35733:34394,35734:35377,35735:36317,35736:37624,35737:28417,35738:31142,35739:39770,35740:20136,35741:20139,35742:20140,35743:20379,35744:20384,35745:20689,35746:20807,35747:31478,35748:20849,35749:20982,35750:21332,35751:21281,35752:21375,35753:21483,35754:21932,35755:22659,35756:23777,35757:24375,35758:24394,35759:24623,35760:24656,35761:24685,35762:25375,35763:25945,35764:27211,35765:27841,35766:29378,35767:29421,35768:30703,35769:33016,35770:33029,35771:33288,35772:34126,35773:37111,35774:37857,35775:38911,35776:39255,35777:39514,35778:20208,35779:20957,35780:23597,35781:26241,35782:26989,35783:23616,35784:26354,35785:26997,35786:29577,35787:26704,35788:31873,35789:20677,35790:21220,35791:22343,35792:24062,35793:37670,35794:26020,35795:27427,35796:27453,35797:29748,35798:31105,35799:31165,35800:31563,35801:32202,35802:33465,35803:33740,35804:34943,35805:35167,35806:35641,35807:36817,35808:37329,35809:21535,35810:37504,35811:20061,35812:20534,35813:21477,35814:21306,35815:29399,35816:29590,35817:30697,35818:33510,35819:36527,35820:39366,35821:39368,35822:39378,35823:20855,35824:24858,35825:34398,35826:21936,35827:31354,35828:20598,35829:23507,35830:36935,35831:38533,35832:20018,35833:27355,35834:37351,35835:23633,35836:23624,35904:25496,35905:31391,35906:27795,35907:38772,35908:36705,35909:31402,35910:29066,35911:38536,35912:31874,35913:26647,35914:32368,35915:26705,35916:37740,35917:21234,35918:21531,35919:34219,35920:35347,35921:32676,35922:36557,35923:37089,35924:21350,35925:34952,35926:31041,35927:20418,35928:20670,35929:21009,35930:20804,35931:21843,35932:22317,35933:29674,35934:22411,35935:22865,35936:24418,35937:24452,35938:24693,35939:24950,35940:24935,35941:25001,35942:25522,35943:25658,35944:25964,35945:26223,35946:26690,35947:28179,35948:30054,35949:31293,35950:31995,35951:32076,35952:32153,35953:32331,35954:32619,35955:33550,35956:33610,35957:34509,35958:35336,35959:35427,35960:35686,35961:36605,35962:38938,35963:40335,35964:33464,35965:36814,35966:39912,35968:21127,35969:25119,35970:25731,35971:28608,35972:38553,35973:26689,35974:20625,35975:27424,35976:27770,35977:28500,35978:31348,35979:32080,35980:34880,35981:35363,35982:26376,35983:20214,35984:20537,35985:20518,35986:20581,35987:20860,35988:21048,35989:21091,35990:21927,35991:22287,35992:22533,35993:23244,35994:24314,35995:25010,35996:25080,35997:25331,35998:25458,35999:26908,36e3:27177,36001:29309,36002:29356,36003:29486,36004:30740,36005:30831,36006:32121,36007:30476,36008:32937,36009:35211,36010:35609,36011:36066,\n36012:36562,36013:36963,36014:37749,36015:38522,36016:38997,36017:39443,36018:40568,36019:20803,36020:21407,36021:21427,36022:24187,36023:24358,36024:28187,36025:28304,36026:29572,36027:29694,36028:32067,36029:33335,36030:35328,36031:35578,36032:38480,36033:20046,36034:20491,36035:21476,36036:21628,36037:22266,36038:22993,36039:23396,36040:24049,36041:24235,36042:24359,36043:25144,36044:25925,36045:26543,36046:28246,36047:29392,36048:31946,36049:34996,36050:32929,36051:32993,36052:33776,36053:34382,36054:35463,36055:36328,36056:37431,36057:38599,36058:39015,36059:40723,36060:20116,36061:20114,36062:20237,36063:21320,36064:21577,36065:21566,36066:23087,36067:24460,36068:24481,36069:24735,36070:26791,36071:27278,36072:29786,36073:30849,36074:35486,36075:35492,36076:35703,36077:37264,36078:20062,36079:39881,36080:20132,36081:20348,36082:20399,36083:20505,36084:20502,36085:20809,36086:20844,36087:21151,36088:21177,36089:21246,36090:21402,36091:21475,36092:21521,36160:21518,36161:21897,36162:22353,36163:22434,36164:22909,36165:23380,36166:23389,36167:23439,36168:24037,36169:24039,36170:24055,36171:24184,36172:24195,36173:24218,36174:24247,36175:24344,36176:24658,36177:24908,36178:25239,36179:25304,36180:25511,36181:25915,36182:26114,36183:26179,36184:26356,36185:26477,36186:26657,36187:26775,36188:27083,36189:27743,36190:27946,36191:28009,36192:28207,36193:28317,36194:30002,36195:30343,36196:30828,36197:31295,36198:31968,36199:32005,36200:32024,36201:32094,36202:32177,36203:32789,36204:32771,36205:32943,36206:32945,36207:33108,36208:33167,36209:33322,36210:33618,36211:34892,36212:34913,36213:35611,36214:36002,36215:36092,36216:37066,36217:37237,36218:37489,36219:30783,36220:37628,36221:38308,36222:38477,36224:38917,36225:39321,36226:39640,36227:40251,36228:21083,36229:21163,36230:21495,36231:21512,36232:22741,36233:25335,36234:28640,36235:35946,36236:36703,36237:40633,36238:20811,36239:21051,36240:21578,36241:22269,36242:31296,36243:37239,36244:40288,36245:40658,36246:29508,36247:28425,36248:33136,36249:29969,36250:24573,36251:24794,36252:39592,36253:29403,36254:36796,36255:27492,36256:38915,36257:20170,36258:22256,36259:22372,36260:22718,36261:23130,36262:24680,36263:25031,36264:26127,36265:26118,36266:26681,36267:26801,36268:28151,36269:30165,36270:32058,36271:33390,36272:39746,36273:20123,36274:20304,36275:21449,36276:21766,36277:23919,36278:24038,36279:24046,36280:26619,36281:27801,36282:29811,36283:30722,36284:35408,36285:37782,36286:35039,36287:22352,36288:24231,36289:25387,36290:20661,36291:20652,36292:20877,36293:26368,36294:21705,36295:22622,36296:22971,36297:23472,36298:24425,36299:25165,36300:25505,36301:26685,36302:27507,36303:28168,36304:28797,36305:37319,36306:29312,36307:30741,36308:30758,36309:31085,36310:25998,36311:32048,36312:33756,36313:35009,36314:36617,36315:38555,36316:21092,36317:22312,36318:26448,36319:32618,36320:36001,36321:20916,36322:22338,36323:38442,36324:22586,36325:27018,36326:32948,36327:21682,36328:23822,36329:22524,36330:30869,36331:40442,36332:20316,36333:21066,36334:21643,36335:25662,36336:26152,36337:26388,36338:26613,36339:31364,36340:31574,36341:32034,36342:37679,36343:26716,36344:39853,36345:31545,36346:21273,36347:20874,36348:21047,36416:23519,36417:25334,36418:25774,36419:25830,36420:26413,36421:27578,36422:34217,36423:38609,36424:30352,36425:39894,36426:25420,36427:37638,36428:39851,36429:30399,36430:26194,36431:19977,36432:20632,36433:21442,36434:23665,36435:24808,36436:25746,36437:25955,36438:26719,36439:29158,36440:29642,36441:29987,36442:31639,36443:32386,36444:34453,36445:35715,36446:36059,36447:37240,36448:39184,36449:26028,36450:26283,36451:27531,36452:20181,36453:20180,36454:20282,36455:20351,36456:21050,36457:21496,36458:21490,36459:21987,36460:22235,36461:22763,36462:22987,36463:22985,36464:23039,36465:23376,36466:23629,36467:24066,36468:24107,36469:24535,36470:24605,36471:25351,36472:25903,36473:23388,36474:26031,36475:26045,36476:26088,36477:26525,36478:27490,36480:27515,36481:27663,36482:29509,36483:31049,36484:31169,36485:31992,36486:32025,36487:32043,36488:32930,36489:33026,36490:33267,36491:35222,36492:35422,36493:35433,36494:35430,36495:35468,36496:35566,36497:36039,36498:36060,36499:38604,36500:39164,36501:27503,36502:20107,36503:20284,36504:20365,36505:20816,36506:23383,36507:23546,36508:24904,36509:25345,36510:26178,36511:27425,36512:28363,36513:27835,36514:29246,36515:29885,36516:30164,36517:30913,36518:31034,36519:32780,36520:32819,36521:33258,36522:33940,36523:36766,36524:27728,36525:40575,36526:24335,36527:35672,36528:40235,36529:31482,36530:36600,36531:23437,36532:38635,36533:19971,36534:21489,36535:22519,36536:22833,36537:23241,36538:23460,36539:24713,36540:28287,36541:28422,36542:30142,36543:36074,36544:23455,36545:34048,36546:31712,36547:20594,36548:26612,36549:33437,36550:23649,36551:34122,36552:32286,36553:33294,36554:20889,36555:23556,36556:25448,36557:36198,36558:26012,36559:29038,36560:31038,36561:32023,36562:32773,36563:35613,36564:36554,36565:36974,36566:34503,36567:37034,36568:20511,36569:21242,36570:23610,36571:26451,36572:28796,36573:29237,36574:37196,36575:37320,36576:37675,36577:33509,36578:23490,36579:24369,36580:24825,36581:20027,36582:21462,36583:23432,36584:25163,36585:26417,36586:27530,36587:29417,36588:29664,36589:31278,36590:33131,36591:36259,36592:37202,36593:39318,36594:20754,36595:21463,36596:21610,36597:23551,36598:25480,36599:27193,36600:32172,36601:38656,36602:22234,36603:21454,36604:21608,36672:23447,36673:23601,36674:24030,36675:20462,36676:24833,36677:25342,36678:27954,36679:31168,36680:31179,36681:32066,36682:32333,36683:32722,36684:33261,36685:33311,36686:33936,36687:34886,36688:35186,36689:35728,36690:36468,36691:36655,36692:36913,36693:37195,36694:37228,36695:38598,36696:37276,36697:20160,36698:20303,36699:20805,36700:21313,36701:24467,36702:25102,36703:26580,36704:27713,36705:28171,36706:29539,36707:32294,36708:37325,36709:37507,36710:21460,36711:22809,36712:23487,36713:28113,36714:31069,36715:32302,36716:31899,36717:22654,36718:29087,36719:20986,36720:34899,36721:36848,36722:20426,36723:23803,36724:26149,36725:30636,36726:31459,36727:33308,36728:39423,36729:20934,36730:24490,36731:26092,36732:26991,36733:27529,36734:28147,36736:28310,36737:28516,36738:30462,36739:32020,36740:24033,36741:36981,36742:37255,36743:38918,36744:20966,36745:21021,36746:25152,36747:26257,36748:26329,36749:28186,36750:24246,36751:32210,36752:32626,36753:26360,36754:34223,36755:34295,36756:35576,36757:21161,36758:21465,36759:22899,36760:24207,36761:24464,36762:24661,36763:37604,36764:38500,36765:20663,36766:20767,36767:21213,36768:21280,36769:21319,36770:21484,36771:21736,36772:21830,36773:21809,36774:22039,36775:22888,36776:22974,36777:23100,36778:23477,36779:23558,36780:23567,36781:23569,36782:23578,36783:24196,36784:24202,36785:24288,36786:24432,36787:25215,36788:25220,36789:25307,36790:25484,36791:25463,36792:26119,36793:26124,36794:26157,36795:26230,36796:26494,36797:26786,36798:27167,36799:27189,36800:27836,36801:28040,36802:28169,36803:28248,36804:28988,36805:28966,36806:29031,36807:30151,36808:30465,36809:30813,36810:30977,36811:31077,36812:31216,36813:31456,36814:31505,36815:31911,36816:32057,36817:32918,36818:33750,36819:33931,36820:34121,36821:34909,36822:35059,36823:35359,36824:35388,36825:35412,36826:35443,36827:35937,36828:36062,36829:37284,36830:37478,36831:37758,36832:37912,36833:38556,36834:38808,36835:19978,36836:19976,36837:19998,36838:20055,36839:20887,36840:21104,36841:22478,36842:22580,36843:22732,36844:23330,36845:24120,36846:24773,36847:25854,36848:26465,36849:26454,36850:27972,36851:29366,36852:30067,36853:31331,36854:33976,36855:35698,36856:37304,36857:37664,36858:22065,36859:22516,36860:39166,36928:25325,36929:26893,36930:27542,36931:29165,36932:32340,36933:32887,36934:33394,36935:35302,36936:39135,36937:34645,36938:36785,36939:23611,36940:20280,36941:20449,36942:20405,36943:21767,36944:23072,36945:23517,36946:23529,36947:24515,36948:24910,36949:25391,36950:26032,36951:26187,36952:26862,36953:27035,36954:28024,36955:28145,36956:30003,36957:30137,36958:30495,36959:31070,36960:31206,36961:32051,36962:33251,36963:33455,36964:34218,36965:35242,36966:35386,36967:36523,36968:36763,36969:36914,36970:37341,36971:38663,36972:20154,36973:20161,36974:20995,36975:22645,36976:22764,36977:23563,36978:29978,36979:23613,36980:33102,36981:35338,36982:36805,36983:38499,36984:38765,36985:31525,36986:35535,36987:38920,36988:37218,36989:22259,36990:21416,36992:36887,36993:21561,36994:22402,36995:24101,36996:25512,36997:27700,36998:28810,36999:30561,37e3:31883,37001:32736,37002:34928,37003:36930,37004:37204,37005:37648,37006:37656,37007:38543,37008:29790,37009:39620,37010:23815,37011:23913,37012:25968,37013:26530,37014:36264,37015:38619,37016:25454,37017:26441,37018:26905,37019:33733,37020:38935,37021:38592,37022:35070,37023:28548,37024:25722,37025:23544,37026:19990,37027:28716,37028:30045,37029:26159,37030:20932,37031:21046,37032:21218,37033:22995,37034:24449,37035:24615,37036:25104,37037:25919,37038:25972,37039:26143,37040:26228,37041:26866,37042:26646,37043:27491,37044:28165,37045:29298,37046:29983,37047:30427,37048:31934,37049:32854,37050:22768,37051:35069,37052:35199,37053:35488,37054:35475,37055:35531,37056:36893,37057:37266,37058:38738,37059:38745,37060:25993,37061:31246,37062:33030,37063:38587,37064:24109,37065:24796,37066:25114,37067:26021,37068:26132,37069:26512,37070:30707,37071:31309,37072:31821,37073:32318,37074:33034,37075:36012,37076:36196,37077:36321,37078:36447,37079:30889,37080:20999,37081:25305,37082:25509,37083:25666,37084:25240,37085:35373,37086:31363,37087:31680,37088:35500,37089:38634,37090:32118,37091:33292,37092:34633,37093:20185,37094:20808,37095:21315,37096:21344,37097:23459,37098:23554,37099:23574,37100:24029,37101:25126,37102:25159,37103:25776,37104:26643,37105:26676,37106:27849,37107:27973,37108:27927,37109:26579,37110:28508,37111:29006,37112:29053,37113:26059,37114:31359,37115:31661,37116:32218,37184:32330,37185:32680,37186:33146,37187:33307,37188:33337,37189:34214,37190:35438,37191:36046,37192:36341,37193:36984,37194:36983,37195:37549,37196:37521,37197:38275,37198:39854,37199:21069,37200:21892,37201:28472,37202:28982,37203:20840,37204:31109,37205:32341,37206:33203,37207:31950,37208:22092,37209:22609,37210:23720,37211:25514,37212:26366,37213:26365,37214:26970,37215:29401,37216:30095,37217:30094,37218:30990,37219:31062,37220:31199,37221:31895,37222:32032,37223:32068,37224:34311,37225:35380,37226:38459,37227:36961,37228:40736,37229:20711,37230:21109,37231:21452,37232:21474,37233:20489,37234:21930,37235:22766,37236:22863,37237:29245,37238:23435,37239:23652,37240:21277,37241:24803,37242:24819,37243:25436,37244:25475,37245:25407,37246:25531,37248:25805,37249:26089,37250:26361,37251:24035,37252:27085,37253:27133,37254:28437,37255:29157,37256:20105,37257:30185,37258:30456,37259:31379,37260:31967,37261:32207,37262:32156,37263:32865,37264:33609,37265:33624,37266:33900,37267:33980,37268:34299,37269:35013,37270:36208,37271:36865,37272:36973,37273:37783,37274:38684,37275:39442,37276:20687,37277:22679,37278:24974,37279:33235,37280:34101,37281:36104,37282:36896,37283:20419,37284:20596,37285:21063,37286:21363,37287:24687,37288:25417,37289:26463,37290:28204,37291:36275,37292:36895,37293:20439,37294:23646,37295:36042,37296:26063,37297:32154,37298:21330,37299:34966,37300:20854,37301:25539,37302:23384,37303:23403,37304:23562,37305:25613,37306:26449,37307:36956,37308:20182,37309:22810,37310:22826,37311:27760,37312:35409,37313:21822,37314:22549,37315:22949,37316:24816,37317:25171,37318:26561,37319:33333,37320:26965,37321:38464,37322:39364,37323:39464,37324:20307,37325:22534,37326:23550,37327:32784,37328:23729,37329:24111,37330:24453,37331:24608,37332:24907,37333:25140,37334:26367,37335:27888,37336:28382,37337:32974,37338:33151,37339:33492,37340:34955,37341:36024,37342:36864,37343:36910,37344:38538,37345:40667,37346:39899,37347:20195,37348:21488,37349:22823,37350:31532,37351:37261,37352:38988,37353:40441,37354:28381,37355:28711,37356:21331,37357:21828,37358:23429,37359:25176,37360:25246,37361:25299,37362:27810,37363:28655,37364:29730,37365:35351,37366:37944,37367:28609,37368:35582,37369:33592,37370:20967,37371:34552,37372:21482,37440:21481,37441:20294,37442:36948,37443:36784,37444:22890,37445:33073,37446:24061,37447:31466,37448:36799,37449:26842,37450:35895,37451:29432,37452:40008,37453:27197,37454:35504,37455:20025,37456:21336,37457:22022,37458:22374,37459:25285,37460:25506,37461:26086,37462:27470,37463:28129,37464:28251,37465:28845,37466:30701,37467:31471,37468:31658,37469:32187,37470:32829,37471:32966,37472:34507,37473:35477,37474:37723,37475:22243,37476:22727,37477:24382,37478:26029,37479:26262,37480:27264,37481:27573,37482:30007,37483:35527,37484:20516,37485:30693,37486:22320,37487:24347,37488:24677,37489:26234,37490:27744,37491:30196,37492:31258,37493:32622,37494:33268,37495:34584,37496:36933,37497:39347,37498:31689,37499:30044,37500:31481,37501:31569,37502:33988,37504:36880,37505:31209,37506:31378,37507:33590,37508:23265,37509:30528,37510:20013,37511:20210,37512:23449,37513:24544,37514:25277,37515:26172,37516:26609,37517:27880,37518:34411,37519:34935,37520:35387,37521:37198,37522:37619,37523:39376,37524:27159,37525:28710,37526:29482,37527:33511,37528:33879,37529:36015,37530:19969,37531:20806,37532:20939,37533:21899,37534:23541,37535:24086,37536:24115,37537:24193,37538:24340,37539:24373,37540:24427,37541:24500,37542:25074,37543:25361,37544:26274,37545:26397,37546:28526,37547:29266,37548:30010,37549:30522,37550:32884,37551:33081,37552:33144,37553:34678,37554:35519,37555:35548,37556:36229,37557:36339,37558:37530,37559:38263,37560:38914,37561:40165,37562:21189,37563:25431,37564:30452,37565:26389,37566:27784,37567:29645,37568:36035,37569:37806,37570:38515,37571:27941,37572:22684,37573:26894,37574:27084,37575:36861,37576:37786,37577:30171,37578:36890,37579:22618,37580:26626,37581:25524,37582:27131,37583:20291,37584:28460,37585:26584,37586:36795,37587:34086,37588:32180,37589:37716,37590:26943,37591:28528,37592:22378,37593:22775,37594:23340,37595:32044,37596:29226,37597:21514,37598:37347,37599:40372,37600:20141,37601:20302,37602:20572,37603:20597,37604:21059,37605:35998,37606:21576,37607:22564,37608:23450,37609:24093,37610:24213,37611:24237,37612:24311,37613:24351,37614:24716,37615:25269,37616:25402,37617:25552,37618:26799,37619:27712,37620:30855,37621:31118,37622:31243,37623:32224,37624:33351,37625:35330,37626:35558,37627:36420,37628:36883,37696:37048,37697:37165,37698:37336,37699:40718,37700:27877,37701:25688,37702:25826,37703:25973,37704:28404,37705:30340,37706:31515,37707:36969,37708:37841,37709:28346,37710:21746,37711:24505,37712:25764,37713:36685,37714:36845,37715:37444,37716:20856,37717:22635,37718:22825,37719:23637,37720:24215,37721:28155,37722:32399,37723:29980,37724:36028,37725:36578,37726:39003,37727:28857,37728:20253,37729:27583,37730:28593,37731:3e4,37732:38651,37733:20814,37734:21520,37735:22581,37736:22615,37737:22956,37738:23648,37739:24466,37740:26007,37741:26460,37742:28193,37743:30331,37744:33759,37745:36077,37746:36884,37747:37117,37748:37709,37749:30757,37750:30778,37751:21162,37752:24230,37753:22303,37754:22900,37755:24594,37756:20498,37757:20826,37758:20908,37760:20941,37761:20992,37762:21776,37763:22612,37764:22616,37765:22871,37766:23445,37767:23798,37768:23947,37769:24764,37770:25237,37771:25645,37772:26481,37773:26691,37774:26812,37775:26847,37776:30423,37777:28120,37778:28271,37779:28059,37780:28783,37781:29128,37782:24403,37783:30168,37784:31095,37785:31561,37786:31572,37787:31570,37788:31958,37789:32113,37790:21040,37791:33891,37792:34153,37793:34276,37794:35342,37795:35588,37796:35910,37797:36367,37798:36867,37799:36879,37800:37913,37801:38518,37802:38957,37803:39472,37804:38360,37805:20685,37806:21205,37807:21516,37808:22530,37809:23566,37810:24999,37811:25758,37812:27934,37813:30643,37814:31461,37815:33012,37816:33796,37817:36947,37818:37509,37819:23776,37820:40199,37821:21311,37822:24471,37823:24499,37824:28060,37825:29305,37826:30563,37827:31167,37828:31716,37829:27602,37830:29420,37831:35501,37832:26627,37833:27233,37834:20984,37835:31361,37836:26932,37837:23626,37838:40182,37839:33515,37840:23493,37841:37193,37842:28702,37843:22136,37844:23663,37845:24775,37846:25958,37847:27788,37848:35930,37849:36929,37850:38931,37851:21585,37852:26311,37853:37389,37854:22856,37855:37027,37856:20869,37857:20045,37858:20970,37859:34201,37860:35598,37861:28760,37862:25466,37863:37707,37864:26978,37865:39348,37866:32260,37867:30071,37868:21335,37869:26976,37870:36575,37871:38627,37872:27741,37873:20108,37874:23612,37875:24336,37876:36841,37877:21250,37878:36049,37879:32905,37880:34425,37881:24319,37882:26085,37883:20083,37884:20837,37952:22914,37953:23615,37954:38894,37955:20219,37956:22922,37957:24525,37958:35469,37959:28641,37960:31152,37961:31074,37962:23527,37963:33905,37964:29483,37965:29105,37966:24180,37967:24565,37968:25467,37969:25754,37970:29123,37971:31896,37972:20035,37973:24316,37974:20043,37975:22492,37976:22178,37977:24745,37978:28611,37979:32013,37980:33021,37981:33075,37982:33215,37983:36786,37984:35223,37985:34468,37986:24052,37987:25226,37988:25773,37989:35207,37990:26487,37991:27874,37992:27966,37993:29750,37994:30772,37995:23110,37996:32629,37997:33453,37998:39340,37999:20467,38e3:24259,38001:25309,38002:25490,38003:25943,38004:26479,38005:30403,38006:29260,38007:32972,38008:32954,38009:36649,38010:37197,38011:20493,38012:22521,38013:23186,38014:26757,38016:26995,38017:29028,38018:29437,38019:36023,38020:22770,38021:36064,38022:38506,38023:36889,38024:34687,38025:31204,38026:30695,38027:33833,38028:20271,38029:21093,38030:21338,38031:25293,38032:26575,38033:27850,38034:30333,38035:31636,38036:31893,38037:33334,38038:34180,38039:36843,38040:26333,38041:28448,38042:29190,38043:32283,38044:33707,38045:39361,38046:40614,38047:20989,38048:31665,38049:30834,38050:31672,38051:32903,38052:31560,38053:27368,38054:24161,38055:32908,38056:30033,38057:30048,38058:20843,38059:37474,38060:28300,38061:30330,38062:37271,38063:39658,38064:20240,38065:32624,38066:25244,38067:31567,38068:38309,38069:40169,38070:22138,38071:22617,38072:34532,38073:38588,38074:20276,38075:21028,38076:21322,38077:21453,38078:21467,38079:24070,38080:25644,38081:26001,38082:26495,38083:27710,38084:27726,38085:29256,38086:29359,38087:29677,38088:30036,38089:32321,38090:33324,38091:34281,38092:36009,38093:31684,38094:37318,38095:29033,38096:38930,38097:39151,38098:25405,38099:26217,38100:30058,38101:30436,38102:30928,38103:34115,38104:34542,38105:21290,38106:21329,38107:21542,38108:22915,38109:24199,38110:24444,38111:24754,38112:25161,38113:25209,38114:25259,38115:26e3,38116:27604,38117:27852,38118:30130,38119:30382,38120:30865,38121:31192,38122:32203,38123:32631,38124:32933,38125:34987,38126:35513,38127:36027,38128:36991,38129:38750,38130:39131,38131:27147,38132:31800,38133:20633,38134:23614,38135:24494,38136:26503,38137:27608,38138:29749,38139:30473,38140:32654,38208:40763,38209:26570,38210:31255,38211:21305,38212:30091,38213:39661,38214:24422,38215:33181,38216:33777,38217:32920,38218:24380,38219:24517,38220:30050,38221:31558,38222:36924,38223:26727,38224:23019,38225:23195,38226:32016,38227:30334,38228:35628,38229:20469,38230:24426,38231:27161,38232:27703,38233:28418,38234:29922,38235:31080,38236:34920,38237:35413,38238:35961,38239:24287,38240:25551,38241:30149,38242:31186,38243:33495,38244:37672,38245:37618,38246:33948,38247:34541,38248:39981,38249:21697,38250:24428,38251:25996,38252:27996,38253:28693,38254:36007,38255:36051,38256:38971,38257:25935,38258:29942,38259:19981,38260:20184,38261:22496,38262:22827,38263:23142,38264:23500,38265:20904,38266:24067,38267:24220,38268:24598,38269:25206,38270:25975,38272:26023,38273:26222,38274:28014,38275:29238,38276:31526,38277:33104,38278:33178,38279:33433,38280:35676,38281:36e3,38282:36070,38283:36212,38284:38428,38285:38468,38286:20398,38287:25771,38288:27494,38289:33310,38290:33889,38291:34154,38292:37096,38293:23553,38294:26963,38295:39080,38296:33914,38297:34135,38298:20239,38299:21103,38300:24489,38301:24133,38302:26381,38303:31119,38304:33145,38305:35079,38306:35206,38307:28149,38308:24343,38309:25173,38310:27832,38311:20175,38312:29289,38313:39826,38314:20998,38315:21563,38316:22132,38317:22707,38318:24996,38319:25198,38320:28954,38321:22894,38322:31881,38323:31966,38324:32027,38325:38640,38326:25991,38327:32862,38328:19993,38329:20341,38330:20853,38331:22592,38332:24163,38333:24179,38334:24330,38335:26564,38336:20006,38337:34109,38338:38281,38339:38491,38340:31859,38341:38913,38342:20731,38343:22721,38344:30294,38345:30887,38346:21029,38347:30629,38348:34065,38349:31622,38350:20559,38351:22793,38352:29255,38353:31687,38354:32232,38355:36794,38356:36820,38357:36941,38358:20415,38359:21193,38360:23081,38361:24321,38362:38829,38363:20445,38364:33303,38365:37610,38366:22275,38367:25429,38368:27497,38369:29995,38370:35036,38371:36628,38372:31298,38373:21215,38374:22675,38375:24917,38376:25098,38377:26286,38378:27597,38379:31807,38380:33769,38381:20515,38382:20472,38383:21253,38384:21574,38385:22577,38386:22857,38387:23453,38388:23792,38389:23791,38390:23849,38391:24214,38392:25265,38393:25447,38394:25918,38395:26041,38396:26379,38464:27861,38465:27873,38466:28921,38467:30770,38468:32299,38469:32990,38470:33459,38471:33804,38472:34028,38473:34562,38474:35090,38475:35370,38476:35914,38477:37030,38478:37586,38479:39165,38480:40179,38481:40300,38482:20047,38483:20129,38484:20621,38485:21078,38486:22346,38487:22952,38488:24125,38489:24536,38490:24537,38491:25151,38492:26292,38493:26395,38494:26576,38495:26834,38496:20882,38497:32033,38498:32938,38499:33192,38500:35584,38501:35980,38502:36031,38503:37502,38504:38450,38505:21536,38506:38956,38507:21271,38508:20693,38509:21340,38510:22696,38511:25778,38512:26420,38513:29287,38514:30566,38515:31302,38516:37350,38517:21187,38518:27809,38519:27526,38520:22528,38521:24140,38522:22868,38523:26412,38524:32763,38525:20961,38526:30406,38528:25705,38529:30952,38530:39764,38531:40635,38532:22475,38533:22969,38534:26151,38535:26522,38536:27598,38537:21737,38538:27097,38539:24149,38540:33180,38541:26517,38542:39850,38543:26622,38544:40018,38545:26717,38546:20134,38547:20451,38548:21448,38549:25273,38550:26411,38551:27819,38552:36804,38553:20397,38554:32365,38555:40639,38556:19975,38557:24930,38558:28288,38559:28459,38560:34067,38561:21619,38562:26410,38563:39749,38564:24051,38565:31637,38566:23724,38567:23494,38568:34588,38569:28234,38570:34001,38571:31252,38572:33032,38573:22937,38574:31885,38575:27665,38576:30496,38577:21209,38578:22818,38579:28961,38580:29279,38581:30683,38582:38695,38583:40289,38584:26891,38585:23167,38586:23064,38587:20901,38588:21517,38589:21629,38590:26126,38591:30431,38592:36855,38593:37528,38594:40180,38595:23018,38596:29277,38597:28357,38598:20813,38599:26825,38600:32191,38601:32236,38602:38754,38603:40634,38604:25720,38605:27169,38606:33538,38607:22916,38608:23391,38609:27611,38610:29467,38611:30450,38612:32178,38613:32791,38614:33945,38615:20786,38616:26408,38617:40665,38618:30446,38619:26466,38620:21247,38621:39173,38622:23588,38623:25147,38624:31870,38625:36016,38626:21839,38627:24758,38628:32011,38629:38272,38630:21249,38631:20063,38632:20918,38633:22812,38634:29242,38635:32822,38636:37326,38637:24357,38638:30690,38639:21380,38640:24441,38641:32004,38642:34220,38643:35379,38644:36493,38645:38742,38646:26611,38647:34222,38648:37971,38649:24841,38650:24840,38651:27833,38652:30290,38720:35565,38721:36664,38722:21807,38723:20305,38724:20778,38725:21191,38726:21451,38727:23461,38728:24189,38729:24736,38730:24962,38731:25558,38732:26377,38733:26586,38734:28263,38735:28044,38736:29494,38737:29495,38738:30001,38739:31056,38740:35029,38741:35480,38742:36938,38743:37009,38744:37109,38745:38596,38746:34701,38747:22805,38748:20104,38749:20313,38750:19982,38751:35465,38752:36671,38753:38928,38754:20653,38755:24188,38756:22934,38757:23481,38758:24248,38759:25562,38760:25594,38761:25793,38762:26332,38763:26954,38764:27096,38765:27915,38766:28342,38767:29076,38768:29992,38769:31407,38770:32650,38771:32768,38772:33865,38773:33993,38774:35201,38775:35617,38776:36362,38777:36965,38778:38525,38779:39178,38780:24958,38781:25233,38782:27442,38784:27779,38785:28020,38786:32716,38787:32764,38788:28096,38789:32645,38790:34746,38791:35064,38792:26469,38793:33713,38794:38972,38795:38647,38796:27931,38797:32097,38798:33853,38799:37226,38800:20081,38801:21365,38802:23888,38803:27396,38804:28651,38805:34253,38806:34349,38807:35239,38808:21033,38809:21519,38810:23653,38811:26446,38812:26792,38813:29702,38814:29827,38815:30178,38816:35023,38817:35041,38818:37324,38819:38626,38820:38520,38821:24459,38822:29575,38823:31435,38824:33870,38825:25504,38826:30053,38827:21129,38828:27969,38829:28316,38830:29705,38831:30041,38832:30827,38833:31890,38834:38534,38835:31452,38836:40845,38837:20406,38838:24942,38839:26053,38840:34396,38841:20102,38842:20142,38843:20698,38844:20001,38845:20940,38846:23534,38847:26009,38848:26753,38849:28092,38850:29471,38851:30274,38852:30637,38853:31260,38854:31975,38855:33391,38856:35538,38857:36988,38858:37327,38859:38517,38860:38936,38861:21147,38862:32209,38863:20523,38864:21400,38865:26519,38866:28107,38867:29136,38868:29747,38869:33256,38870:36650,38871:38563,38872:40023,38873:40607,38874:29792,38875:22593,38876:28057,38877:32047,38878:39006,38879:20196,38880:20278,38881:20363,38882:20919,38883:21169,38884:23994,38885:24604,38886:29618,38887:31036,38888:33491,38889:37428,38890:38583,38891:38646,38892:38666,38893:40599,38894:40802,38895:26278,38896:27508,38897:21015,38898:21155,38899:28872,38900:35010,38901:24265,38902:24651,38903:24976,38904:28451,38905:29001,38906:31806,38907:32244,38908:32879,38976:34030,38977:36899,38978:37676,38979:21570,38980:39791,38981:27347,38982:28809,38983:36034,38984:36335,38985:38706,38986:21172,38987:23105,38988:24266,38989:24324,38990:26391,38991:27004,38992:27028,38993:28010,38994:28431,38995:29282,38996:29436,38997:31725,38998:32769,38999:32894,39e3:34635,39001:37070,39002:20845,39003:40595,39004:31108,39005:32907,39006:37682,39007:35542,39008:20525,39009:21644,39010:35441,39011:27498,39012:36036,39013:33031,39014:24785,39015:26528,39016:40434,39017:20121,39018:20120,39019:39952,39020:35435,39021:34241,39022:34152,39023:26880,39024:28286,39025:30871,39026:33109,39071:24332,39072:19984,39073:19989,39074:20010,39075:20017,39076:20022,39077:20028,39078:20031,39079:20034,39080:20054,39081:20056,39082:20098,39083:20101,39084:35947,39085:20106,39086:33298,39087:24333,39088:20110,39089:20126,39090:20127,39091:20128,39092:20130,39093:20144,39094:20147,39095:20150,39096:20174,39097:20173,39098:20164,39099:20166,39100:20162,39101:20183,39102:20190,39103:20205,39104:20191,39105:20215,39106:20233,39107:20314,39108:20272,39109:20315,39110:20317,39111:20311,39112:20295,39113:20342,39114:20360,39115:20367,39116:20376,39117:20347,39118:20329,39119:20336,39120:20369,39121:20335,39122:20358,39123:20374,39124:20760,39125:20436,39126:20447,39127:20430,39128:20440,39129:20443,39130:20433,39131:20442,39132:20432,39133:20452,39134:20453,39135:20506,39136:20520,39137:20500,39138:20522,39139:20517,39140:20485,39141:20252,39142:20470,39143:20513,39144:20521,39145:20524,39146:20478,39147:20463,39148:20497,39149:20486,39150:20547,39151:20551,39152:26371,39153:20565,39154:20560,39155:20552,39156:20570,39157:20566,39158:20588,39159:20600,39160:20608,39161:20634,39162:20613,39163:20660,39164:20658,39232:20681,39233:20682,39234:20659,39235:20674,39236:20694,39237:20702,39238:20709,39239:20717,39240:20707,39241:20718,39242:20729,39243:20725,39244:20745,39245:20737,39246:20738,39247:20758,39248:20757,39249:20756,39250:20762,39251:20769,39252:20794,39253:20791,39254:20796,39255:20795,39256:20799,39257:20800,39258:20818,39259:20812,39260:20820,39261:20834,39262:31480,39263:20841,39264:20842,39265:20846,39266:20864,39267:20866,39268:22232,39269:20876,39270:20873,39271:20879,39272:20881,39273:20883,39274:20885,39275:20886,39276:20900,39277:20902,39278:20898,39279:20905,39280:20906,39281:20907,39282:20915,39283:20913,39284:20914,39285:20912,39286:20917,39287:20925,39288:20933,39289:20937,39290:20955,39291:20960,39292:34389,39293:20969,39294:20973,39296:20976,39297:20981,39298:20990,39299:20996,39300:21003,39301:21012,39302:21006,39303:21031,39304:21034,39305:21038,39306:21043,39307:21049,39308:21071,39309:21060,39310:21067,39311:21068,39312:21086,39313:21076,39314:21098,39315:21108,39316:21097,39317:21107,39318:21119,39319:21117,39320:21133,39321:21140,39322:21138,39323:21105,39324:21128,39325:21137,39326:36776,39327:36775,39328:21164,39329:21165,39330:21180,39331:21173,39332:21185,39333:21197,39334:21207,39335:21214,39336:21219,39337:21222,39338:39149,39339:21216,39340:21235,39341:21237,39342:21240,39343:21241,39344:21254,39345:21256,39346:30008,39347:21261,39348:21264,39349:21263,39350:21269,39351:21274,39352:21283,39353:21295,39354:21297,39355:21299,39356:21304,39357:21312,39358:21318,39359:21317,39360:19991,39361:21321,39362:21325,39363:20950,39364:21342,39365:21353,39366:21358,39367:22808,39368:21371,39369:21367,39370:21378,39371:21398,39372:21408,39373:21414,39374:21413,39375:21422,39376:21424,39377:21430,39378:21443,39379:31762,39380:38617,39381:21471,39382:26364,39383:29166,39384:21486,39385:21480,39386:21485,39387:21498,39388:21505,39389:21565,39390:21568,39391:21548,39392:21549,39393:21564,39394:21550,39395:21558,39396:21545,39397:21533,39398:21582,39399:21647,39400:21621,39401:21646,39402:21599,39403:21617,39404:21623,39405:21616,39406:21650,39407:21627,39408:21632,39409:21622,39410:21636,39411:21648,39412:21638,39413:21703,39414:21666,39415:21688,39416:21669,39417:21676,39418:21700,39419:21704,39420:21672,39488:21675,39489:21698,39490:21668,39491:21694,39492:21692,39493:21720,39494:21733,39495:21734,39496:21775,39497:21780,39498:21757,39499:21742,39500:21741,39501:21754,39502:21730,39503:21817,39504:21824,39505:21859,39506:21836,39507:21806,39508:21852,39509:21829,39510:21846,39511:21847,39512:21816,39513:21811,39514:21853,39515:21913,39516:21888,39517:21679,39518:21898,39519:21919,39520:21883,39521:21886,39522:21912,39523:21918,39524:21934,39525:21884,39526:21891,39527:21929,39528:21895,39529:21928,39530:21978,39531:21957,39532:21983,39533:21956,39534:21980,39535:21988,39536:21972,39537:22036,39538:22007,39539:22038,39540:22014,39541:22013,39542:22043,39543:22009,39544:22094,39545:22096,39546:29151,39547:22068,39548:22070,39549:22066,39550:22072,39552:22123,39553:22116,39554:22063,39555:22124,39556:22122,39557:22150,39558:22144,39559:22154,39560:22176,39561:22164,39562:22159,39563:22181,39564:22190,39565:22198,39566:22196,39567:22210,39568:22204,39569:22209,39570:22211,39571:22208,39572:22216,39573:22222,39574:22225,39575:22227,39576:22231,39577:22254,39578:22265,39579:22272,39580:22271,39581:22276,39582:22281,39583:22280,39584:22283,39585:22285,39586:22291,39587:22296,39588:22294,39589:21959,39590:22300,39591:22310,39592:22327,39593:22328,39594:22350,39595:22331,39596:22336,39597:22351,39598:22377,39599:22464,39600:22408,39601:22369,39602:22399,39603:22409,39604:22419,39605:22432,39606:22451,39607:22436,39608:22442,39609:22448,39610:22467,39611:22470,39612:22484,39613:22482,39614:22483,39615:22538,39616:22486,39617:22499,39618:22539,39619:22553,39620:22557,39621:22642,39622:22561,39623:22626,39624:22603,39625:22640,39626:27584,39627:22610,39628:22589,39629:22649,39630:22661,39631:22713,39632:22687,39633:22699,39634:22714,39635:22750,39636:22715,39637:22712,39638:22702,39639:22725,39640:22739,39641:22737,39642:22743,39643:22745,39644:22744,39645:22757,39646:22748,39647:22756,39648:22751,39649:22767,39650:22778,39651:22777,39652:22779,39653:22780,39654:22781,39655:22786,39656:22794,39657:22800,39658:22811,39659:26790,39660:22821,39661:22828,39662:22829,39663:22834,39664:22840,39665:22846,39666:31442,39667:22869,39668:22864,39669:22862,39670:22874,39671:22872,39672:22882,39673:22880,\n39674:22887,39675:22892,39676:22889,39744:22904,39745:22913,39746:22941,39747:20318,39748:20395,39749:22947,39750:22962,39751:22982,39752:23016,39753:23004,39754:22925,39755:23001,39756:23002,39757:23077,39758:23071,39759:23057,39760:23068,39761:23049,39762:23066,39763:23104,39764:23148,39765:23113,39766:23093,39767:23094,39768:23138,39769:23146,39770:23194,39771:23228,39772:23230,39773:23243,39774:23234,39775:23229,39776:23267,39777:23255,39778:23270,39779:23273,39780:23254,39781:23290,39782:23291,39783:23308,39784:23307,39785:23318,39786:23346,39787:23248,39788:23338,39789:23350,39790:23358,39791:23363,39792:23365,39793:23360,39794:23377,39795:23381,39796:23386,39797:23387,39798:23397,39799:23401,39800:23408,39801:23411,39802:23413,39803:23416,39804:25992,39805:23418,39806:23424,39808:23427,39809:23462,39810:23480,39811:23491,39812:23495,39813:23497,39814:23508,39815:23504,39816:23524,39817:23526,39818:23522,39819:23518,39820:23525,39821:23531,39822:23536,39823:23542,39824:23539,39825:23557,39826:23559,39827:23560,39828:23565,39829:23571,39830:23584,39831:23586,39832:23592,39833:23608,39834:23609,39835:23617,39836:23622,39837:23630,39838:23635,39839:23632,39840:23631,39841:23409,39842:23660,39843:23662,39844:20066,39845:23670,39846:23673,39847:23692,39848:23697,39849:23700,39850:22939,39851:23723,39852:23739,39853:23734,39854:23740,39855:23735,39856:23749,39857:23742,39858:23751,39859:23769,39860:23785,39861:23805,39862:23802,39863:23789,39864:23948,39865:23786,39866:23819,39867:23829,39868:23831,39869:23900,39870:23839,39871:23835,39872:23825,39873:23828,39874:23842,39875:23834,39876:23833,39877:23832,39878:23884,39879:23890,39880:23886,39881:23883,39882:23916,39883:23923,39884:23926,39885:23943,39886:23940,39887:23938,39888:23970,39889:23965,39890:23980,39891:23982,39892:23997,39893:23952,39894:23991,39895:23996,39896:24009,39897:24013,39898:24019,39899:24018,39900:24022,39901:24027,39902:24043,39903:24050,39904:24053,39905:24075,39906:24090,39907:24089,39908:24081,39909:24091,39910:24118,39911:24119,39912:24132,39913:24131,39914:24128,39915:24142,39916:24151,39917:24148,39918:24159,39919:24162,39920:24164,39921:24135,39922:24181,39923:24182,39924:24186,39925:40636,39926:24191,39927:24224,39928:24257,39929:24258,39930:24264,39931:24272,39932:24271,4e4:24278,40001:24291,40002:24285,40003:24282,40004:24283,40005:24290,40006:24289,40007:24296,40008:24297,40009:24300,40010:24305,40011:24307,40012:24304,40013:24308,40014:24312,40015:24318,40016:24323,40017:24329,40018:24413,40019:24412,40020:24331,40021:24337,40022:24342,40023:24361,40024:24365,40025:24376,40026:24385,40027:24392,40028:24396,40029:24398,40030:24367,40031:24401,40032:24406,40033:24407,40034:24409,40035:24417,40036:24429,40037:24435,40038:24439,40039:24451,40040:24450,40041:24447,40042:24458,40043:24456,40044:24465,40045:24455,40046:24478,40047:24473,40048:24472,40049:24480,40050:24488,40051:24493,40052:24508,40053:24534,40054:24571,40055:24548,40056:24568,40057:24561,40058:24541,40059:24755,40060:24575,40061:24609,40062:24672,40064:24601,40065:24592,40066:24617,40067:24590,40068:24625,40069:24603,40070:24597,40071:24619,40072:24614,40073:24591,40074:24634,40075:24666,40076:24641,40077:24682,40078:24695,40079:24671,40080:24650,40081:24646,40082:24653,40083:24675,40084:24643,40085:24676,40086:24642,40087:24684,40088:24683,40089:24665,40090:24705,40091:24717,40092:24807,40093:24707,40094:24730,40095:24708,40096:24731,40097:24726,40098:24727,40099:24722,40100:24743,40101:24715,40102:24801,40103:24760,40104:24800,40105:24787,40106:24756,40107:24560,40108:24765,40109:24774,40110:24757,40111:24792,40112:24909,40113:24853,40114:24838,40115:24822,40116:24823,40117:24832,40118:24820,40119:24826,40120:24835,40121:24865,40122:24827,40123:24817,40124:24845,40125:24846,40126:24903,40127:24894,40128:24872,40129:24871,40130:24906,40131:24895,40132:24892,40133:24876,40134:24884,40135:24893,40136:24898,40137:24900,40138:24947,40139:24951,40140:24920,40141:24921,40142:24922,40143:24939,40144:24948,40145:24943,40146:24933,40147:24945,40148:24927,40149:24925,40150:24915,40151:24949,40152:24985,40153:24982,40154:24967,40155:25004,40156:24980,40157:24986,40158:24970,40159:24977,40160:25003,40161:25006,40162:25036,40163:25034,40164:25033,40165:25079,40166:25032,40167:25027,40168:25030,40169:25018,40170:25035,40171:32633,40172:25037,40173:25062,40174:25059,40175:25078,40176:25082,40177:25076,40178:25087,40179:25085,40180:25084,40181:25086,40182:25088,40183:25096,40184:25097,40185:25101,40186:25100,40187:25108,40188:25115,40256:25118,40257:25121,40258:25130,40259:25134,40260:25136,40261:25138,40262:25139,40263:25153,40264:25166,40265:25182,40266:25187,40267:25179,40268:25184,40269:25192,40270:25212,40271:25218,40272:25225,40273:25214,40274:25234,40275:25235,40276:25238,40277:25300,40278:25219,40279:25236,40280:25303,40281:25297,40282:25275,40283:25295,40284:25343,40285:25286,40286:25812,40287:25288,40288:25308,40289:25292,40290:25290,40291:25282,40292:25287,40293:25243,40294:25289,40295:25356,40296:25326,40297:25329,40298:25383,40299:25346,40300:25352,40301:25327,40302:25333,40303:25424,40304:25406,40305:25421,40306:25628,40307:25423,40308:25494,40309:25486,40310:25472,40311:25515,40312:25462,40313:25507,40314:25487,40315:25481,40316:25503,40317:25525,40318:25451,40320:25449,40321:25534,40322:25577,40323:25536,40324:25542,40325:25571,40326:25545,40327:25554,40328:25590,40329:25540,40330:25622,40331:25652,40332:25606,40333:25619,40334:25638,40335:25654,40336:25885,40337:25623,40338:25640,40339:25615,40340:25703,40341:25711,40342:25718,40343:25678,40344:25898,40345:25749,40346:25747,40347:25765,40348:25769,40349:25736,40350:25788,40351:25818,40352:25810,40353:25797,40354:25799,40355:25787,40356:25816,40357:25794,40358:25841,40359:25831,40360:33289,40361:25824,40362:25825,40363:25260,40364:25827,40365:25839,40366:25900,40367:25846,40368:25844,40369:25842,40370:25850,40371:25856,40372:25853,40373:25880,40374:25884,40375:25861,40376:25892,40377:25891,40378:25899,40379:25908,40380:25909,40381:25911,40382:25910,40383:25912,40384:30027,40385:25928,40386:25942,40387:25941,40388:25933,40389:25944,40390:25950,40391:25949,40392:25970,40393:25976,40394:25986,40395:25987,40396:35722,40397:26011,40398:26015,40399:26027,40400:26039,40401:26051,40402:26054,40403:26049,40404:26052,40405:26060,40406:26066,40407:26075,40408:26073,40409:26080,40410:26081,40411:26097,40412:26482,40413:26122,40414:26115,40415:26107,40416:26483,40417:26165,40418:26166,40419:26164,40420:26140,40421:26191,40422:26180,40423:26185,40424:26177,40425:26206,40426:26205,40427:26212,40428:26215,40429:26216,40430:26207,40431:26210,40432:26224,40433:26243,40434:26248,40435:26254,40436:26249,40437:26244,40438:26264,40439:26269,40440:26305,40441:26297,40442:26313,40443:26302,40444:26300,40512:26308,40513:26296,40514:26326,40515:26330,40516:26336,40517:26175,40518:26342,40519:26345,40520:26352,40521:26357,40522:26359,40523:26383,40524:26390,40525:26398,40526:26406,40527:26407,40528:38712,40529:26414,40530:26431,40531:26422,40532:26433,40533:26424,40534:26423,40535:26438,40536:26462,40537:26464,40538:26457,40539:26467,40540:26468,40541:26505,40542:26480,40543:26537,40544:26492,40545:26474,40546:26508,40547:26507,40548:26534,40549:26529,40550:26501,40551:26551,40552:26607,40553:26548,40554:26604,40555:26547,40556:26601,40557:26552,40558:26596,40559:26590,40560:26589,40561:26594,40562:26606,40563:26553,40564:26574,40565:26566,40566:26599,40567:27292,40568:26654,40569:26694,40570:26665,40571:26688,40572:26701,40573:26674,40574:26702,40576:26803,40577:26667,40578:26713,40579:26723,40580:26743,40581:26751,40582:26783,40583:26767,40584:26797,40585:26772,40586:26781,40587:26779,40588:26755,40589:27310,40590:26809,40591:26740,40592:26805,40593:26784,40594:26810,40595:26895,40596:26765,40597:26750,40598:26881,40599:26826,40600:26888,40601:26840,40602:26914,40603:26918,40604:26849,40605:26892,40606:26829,40607:26836,40608:26855,40609:26837,40610:26934,40611:26898,40612:26884,40613:26839,40614:26851,40615:26917,40616:26873,40617:26848,40618:26863,40619:26920,40620:26922,40621:26906,40622:26915,40623:26913,40624:26822,40625:27001,40626:26999,40627:26972,40628:27e3,40629:26987,40630:26964,40631:27006,40632:26990,40633:26937,40634:26996,40635:26941,40636:26969,40637:26928,40638:26977,40639:26974,40640:26973,40641:27009,40642:26986,40643:27058,40644:27054,40645:27088,40646:27071,40647:27073,40648:27091,40649:27070,40650:27086,40651:23528,40652:27082,40653:27101,40654:27067,40655:27075,40656:27047,40657:27182,40658:27025,40659:27040,40660:27036,40661:27029,40662:27060,40663:27102,40664:27112,40665:27138,40666:27163,40667:27135,40668:27402,40669:27129,40670:27122,40671:27111,40672:27141,40673:27057,40674:27166,40675:27117,40676:27156,40677:27115,40678:27146,40679:27154,40680:27329,40681:27171,40682:27155,40683:27204,40684:27148,40685:27250,40686:27190,40687:27256,40688:27207,40689:27234,40690:27225,40691:27238,40692:27208,40693:27192,40694:27170,40695:27280,40696:27277,40697:27296,40698:27268,40699:27298,40700:27299,40768:27287,40769:34327,40770:27323,40771:27331,40772:27330,40773:27320,40774:27315,40775:27308,40776:27358,40777:27345,40778:27359,40779:27306,40780:27354,40781:27370,40782:27387,40783:27397,40784:34326,40785:27386,40786:27410,40787:27414,40788:39729,40789:27423,40790:27448,40791:27447,40792:30428,40793:27449,40794:39150,40795:27463,40796:27459,40797:27465,40798:27472,40799:27481,40800:27476,40801:27483,40802:27487,40803:27489,40804:27512,40805:27513,40806:27519,40807:27520,40808:27524,40809:27523,40810:27533,40811:27544,40812:27541,40813:27550,40814:27556,40815:27562,40816:27563,40817:27567,40818:27570,40819:27569,40820:27571,40821:27575,40822:27580,40823:27590,40824:27595,40825:27603,40826:27615,40827:27628,40828:27627,40829:27635,40830:27631,40832:40638,40833:27656,40834:27667,40835:27668,40836:27675,40837:27684,40838:27683,40839:27742,40840:27733,40841:27746,40842:27754,40843:27778,40844:27789,40845:27802,40846:27777,40847:27803,40848:27774,40849:27752,40850:27763,40851:27794,40852:27792,40853:27844,40854:27889,40855:27859,40856:27837,40857:27863,40858:27845,40859:27869,40860:27822,40861:27825,40862:27838,40863:27834,40864:27867,40865:27887,40866:27865,40867:27882,40868:27935,40869:34893,40870:27958,40871:27947,40872:27965,40873:27960,40874:27929,40875:27957,40876:27955,40877:27922,40878:27916,40879:28003,40880:28051,40881:28004,40882:27994,40883:28025,40884:27993,40885:28046,40886:28053,40887:28644,40888:28037,40889:28153,40890:28181,40891:28170,40892:28085,40893:28103,40894:28134,40895:28088,40896:28102,40897:28140,40898:28126,40899:28108,40900:28136,40901:28114,40902:28101,40903:28154,40904:28121,40905:28132,40906:28117,40907:28138,40908:28142,40909:28205,40910:28270,40911:28206,40912:28185,40913:28274,40914:28255,40915:28222,40916:28195,40917:28267,40918:28203,40919:28278,40920:28237,40921:28191,40922:28227,40923:28218,40924:28238,40925:28196,40926:28415,40927:28189,40928:28216,40929:28290,40930:28330,40931:28312,40932:28361,40933:28343,40934:28371,40935:28349,40936:28335,40937:28356,40938:28338,40939:28372,40940:28373,40941:28303,40942:28325,40943:28354,40944:28319,40945:28481,40946:28433,40947:28748,40948:28396,40949:28408,40950:28414,40951:28479,40952:28402,40953:28465,40954:28399,40955:28466,40956:28364,161:65377,162:65378,163:65379,164:65380,165:65381,166:65382,167:65383,168:65384,169:65385,170:65386,171:65387,172:65388,173:65389,174:65390,175:65391,176:65392,177:65393,178:65394,179:65395,180:65396,181:65397,182:65398,183:65399,184:65400,185:65401,186:65402,187:65403,188:65404,189:65405,190:65406,191:65407,192:65408,193:65409,194:65410,195:65411,196:65412,197:65413,198:65414,199:65415,200:65416,201:65417,202:65418,203:65419,204:65420,205:65421,206:65422,207:65423,208:65424,209:65425,210:65426,211:65427,212:65428,213:65429,214:65430,215:65431,216:65432,217:65433,218:65434,219:65435,220:65436,221:65437,222:65438,223:65439,57408:28478,57409:28435,57410:28407,57411:28550,57412:28538,57413:28536,57414:28545,57415:28544,57416:28527,57417:28507,57418:28659,57419:28525,57420:28546,57421:28540,57422:28504,57423:28558,57424:28561,57425:28610,57426:28518,57427:28595,57428:28579,57429:28577,57430:28580,57431:28601,57432:28614,57433:28586,57434:28639,57435:28629,57436:28652,57437:28628,57438:28632,57439:28657,57440:28654,57441:28635,57442:28681,57443:28683,57444:28666,57445:28689,57446:28673,57447:28687,57448:28670,57449:28699,57450:28698,57451:28532,57452:28701,57453:28696,57454:28703,57455:28720,57456:28734,57457:28722,57458:28753,57459:28771,57460:28825,57461:28818,57462:28847,57463:28913,57464:28844,57465:28856,57466:28851,57467:28846,57468:28895,57469:28875,57470:28893,57472:28889,57473:28937,57474:28925,57475:28956,57476:28953,57477:29029,57478:29013,57479:29064,57480:29030,57481:29026,57482:29004,57483:29014,57484:29036,57485:29071,57486:29179,57487:29060,57488:29077,57489:29096,57490:29100,57491:29143,57492:29113,57493:29118,57494:29138,57495:29129,57496:29140,57497:29134,57498:29152,57499:29164,57500:29159,57501:29173,57502:29180,57503:29177,57504:29183,57505:29197,57506:29200,57507:29211,57508:29224,57509:29229,57510:29228,57511:29232,57512:29234,57513:29243,57514:29244,57515:29247,57516:29248,57517:29254,57518:29259,57519:29272,57520:29300,57521:29310,57522:29314,57523:29313,57524:29319,57525:29330,57526:29334,57527:29346,57528:29351,57529:29369,57530:29362,57531:29379,57532:29382,57533:29380,57534:29390,57535:29394,57536:29410,57537:29408,57538:29409,57539:29433,57540:29431,57541:20495,57542:29463,57543:29450,57544:29468,57545:29462,57546:29469,57547:29492,57548:29487,57549:29481,57550:29477,57551:29502,57552:29518,57553:29519,57554:40664,57555:29527,57556:29546,57557:29544,57558:29552,57559:29560,57560:29557,57561:29563,57562:29562,57563:29640,57564:29619,57565:29646,57566:29627,57567:29632,57568:29669,57569:29678,57570:29662,57571:29858,57572:29701,57573:29807,57574:29733,57575:29688,57576:29746,57577:29754,57578:29781,57579:29759,57580:29791,57581:29785,57582:29761,57583:29788,57584:29801,57585:29808,57586:29795,57587:29802,57588:29814,57589:29822,57590:29835,57591:29854,57592:29863,57593:29898,57594:29903,57595:29908,57596:29681,57664:29920,57665:29923,57666:29927,57667:29929,57668:29934,57669:29938,57670:29936,57671:29937,57672:29944,57673:29943,57674:29956,57675:29955,57676:29957,57677:29964,57678:29966,57679:29965,57680:29973,57681:29971,57682:29982,57683:29990,57684:29996,57685:30012,57686:30020,57687:30029,57688:30026,57689:30025,57690:30043,57691:30022,57692:30042,57693:30057,57694:30052,57695:30055,57696:30059,57697:30061,57698:30072,57699:30070,57700:30086,57701:30087,57702:30068,57703:30090,57704:30089,57705:30082,57706:30100,57707:30106,57708:30109,57709:30117,57710:30115,57711:30146,57712:30131,57713:30147,57714:30133,57715:30141,57716:30136,57717:30140,57718:30129,57719:30157,57720:30154,57721:30162,57722:30169,57723:30179,57724:30174,57725:30206,57726:30207,57728:30204,57729:30209,57730:30192,57731:30202,57732:30194,57733:30195,57734:30219,57735:30221,57736:30217,57737:30239,57738:30247,57739:30240,57740:30241,57741:30242,57742:30244,57743:30260,57744:30256,57745:30267,57746:30279,57747:30280,57748:30278,57749:30300,57750:30296,57751:30305,57752:30306,57753:30312,57754:30313,57755:30314,57756:30311,57757:30316,57758:30320,57759:30322,57760:30326,57761:30328,57762:30332,57763:30336,57764:30339,57765:30344,57766:30347,57767:30350,57768:30358,57769:30355,57770:30361,57771:30362,57772:30384,57773:30388,57774:30392,57775:30393,57776:30394,57777:30402,57778:30413,57779:30422,57780:30418,57781:30430,57782:30433,57783:30437,57784:30439,57785:30442,57786:34351,57787:30459,57788:30472,57789:30471,57790:30468,57791:30505,57792:30500,57793:30494,57794:30501,57795:30502,57796:30491,57797:30519,57798:30520,57799:30535,57800:30554,57801:30568,57802:30571,57803:30555,57804:30565,57805:30591,57806:30590,57807:30585,57808:30606,57809:30603,57810:30609,57811:30624,57812:30622,57813:30640,57814:30646,57815:30649,57816:30655,57817:30652,57818:30653,57819:30651,57820:30663,57821:30669,57822:30679,57823:30682,57824:30684,57825:30691,57826:30702,57827:30716,57828:30732,57829:30738,57830:31014,57831:30752,57832:31018,57833:30789,57834:30862,57835:30836,57836:30854,57837:30844,57838:30874,57839:30860,57840:30883,57841:30901,57842:30890,57843:30895,57844:30929,57845:30918,57846:30923,57847:30932,57848:30910,57849:30908,57850:30917,57851:30922,57852:30956,57920:30951,57921:30938,57922:30973,57923:30964,57924:30983,57925:30994,57926:30993,57927:31001,57928:31020,57929:31019,57930:31040,57931:31072,57932:31063,57933:31071,57934:31066,57935:31061,57936:31059,57937:31098,57938:31103,57939:31114,57940:31133,57941:31143,57942:40779,57943:31146,57944:31150,57945:31155,57946:31161,57947:31162,57948:31177,57949:31189,57950:31207,57951:31212,57952:31201,57953:31203,57954:31240,57955:31245,57956:31256,57957:31257,57958:31264,57959:31263,57960:31104,57961:31281,57962:31291,57963:31294,57964:31287,57965:31299,57966:31319,57967:31305,57968:31329,57969:31330,57970:31337,57971:40861,57972:31344,57973:31353,57974:31357,57975:31368,57976:31383,57977:31381,57978:31384,57979:31382,57980:31401,57981:31432,57982:31408,57984:31414,57985:31429,57986:31428,57987:31423,57988:36995,57989:31431,57990:31434,57991:31437,57992:31439,57993:31445,57994:31443,57995:31449,57996:31450,57997:31453,57998:31457,57999:31458,58e3:31462,58001:31469,58002:31472,58003:31490,58004:31503,58005:31498,58006:31494,58007:31539,58008:31512,58009:31513,58010:31518,58011:31541,58012:31528,58013:31542,58014:31568,58015:31610,58016:31492,58017:31565,58018:31499,58019:31564,58020:31557,58021:31605,58022:31589,58023:31604,58024:31591,58025:31600,58026:31601,58027:31596,58028:31598,58029:31645,58030:31640,58031:31647,58032:31629,58033:31644,58034:31642,58035:31627,58036:31634,58037:31631,58038:31581,58039:31641,58040:31691,58041:31681,58042:31692,58043:31695,58044:31668,58045:31686,58046:31709,58047:31721,58048:31761,58049:31764,58050:31718,58051:31717,58052:31840,58053:31744,58054:31751,58055:31763,58056:31731,58057:31735,58058:31767,58059:31757,58060:31734,58061:31779,58062:31783,58063:31786,58064:31775,58065:31799,58066:31787,58067:31805,58068:31820,58069:31811,58070:31828,58071:31823,58072:31808,58073:31824,58074:31832,58075:31839,58076:31844,58077:31830,58078:31845,58079:31852,58080:31861,58081:31875,58082:31888,58083:31908,58084:31917,58085:31906,58086:31915,58087:31905,58088:31912,58089:31923,58090:31922,58091:31921,58092:31918,58093:31929,58094:31933,58095:31936,58096:31941,58097:31938,58098:31960,58099:31954,58100:31964,58101:31970,58102:39739,58103:31983,58104:31986,58105:31988,58106:31990,58107:31994,58108:32006,58176:32002,58177:32028,58178:32021,58179:32010,58180:32069,58181:32075,58182:32046,58183:32050,58184:32063,58185:32053,58186:32070,58187:32115,58188:32086,58189:32078,58190:32114,58191:32104,58192:32110,58193:32079,58194:32099,58195:32147,58196:32137,58197:32091,58198:32143,58199:32125,58200:32155,58201:32186,58202:32174,58203:32163,58204:32181,58205:32199,58206:32189,58207:32171,58208:32317,58209:32162,58210:32175,58211:32220,58212:32184,58213:32159,58214:32176,58215:32216,58216:32221,58217:32228,58218:32222,58219:32251,58220:32242,58221:32225,58222:32261,58223:32266,58224:32291,58225:32289,58226:32274,58227:32305,58228:32287,58229:32265,58230:32267,58231:32290,58232:32326,58233:32358,58234:32315,58235:32309,58236:32313,58237:32323,58238:32311,58240:32306,58241:32314,58242:32359,58243:32349,58244:32342,58245:32350,58246:32345,58247:32346,58248:32377,58249:32362,58250:32361,58251:32380,58252:32379,58253:32387,58254:32213,58255:32381,58256:36782,58257:32383,58258:32392,58259:32393,58260:32396,58261:32402,58262:32400,58263:32403,58264:32404,58265:32406,58266:32398,58267:32411,58268:32412,58269:32568,58270:32570,58271:32581,58272:32588,58273:32589,58274:32590,58275:32592,58276:32593,58277:32597,58278:32596,58279:32600,58280:32607,58281:32608,58282:32616,58283:32617,58284:32615,58285:32632,58286:32642,58287:32646,58288:32643,58289:32648,58290:32647,58291:32652,58292:32660,58293:32670,58294:32669,58295:32666,58296:32675,58297:32687,58298:32690,58299:32697,58300:32686,58301:32694,58302:32696,58303:35697,58304:32709,58305:32710,58306:32714,58307:32725,58308:32724,58309:32737,58310:32742,58311:32745,58312:32755,58313:32761,58314:39132,58315:32774,58316:32772,58317:32779,58318:32786,58319:32792,58320:32793,58321:32796,58322:32801,58323:32808,58324:32831,58325:32827,58326:32842,58327:32838,58328:32850,58329:32856,58330:32858,58331:32863,58332:32866,58333:32872,58334:32883,58335:32882,58336:32880,58337:32886,58338:32889,58339:32893,58340:32895,58341:32900,58342:32902,58343:32901,58344:32923,58345:32915,58346:32922,58347:32941,58348:20880,58349:32940,58350:32987,58351:32997,58352:32985,58353:32989,58354:32964,58355:32986,58356:32982,58357:33033,58358:33007,58359:33009,58360:33051,58361:33065,58362:33059,58363:33071,58364:33099,58432:38539,58433:33094,58434:33086,58435:33107,58436:33105,58437:33020,58438:33137,58439:33134,58440:33125,58441:33126,58442:33140,58443:33155,58444:33160,58445:33162,58446:33152,58447:33154,58448:33184,58449:33173,58450:33188,58451:33187,58452:33119,58453:33171,58454:33193,58455:33200,58456:33205,58457:33214,58458:33208,58459:33213,58460:33216,58461:33218,58462:33210,58463:33225,58464:33229,58465:33233,58466:33241,58467:33240,58468:33224,58469:33242,58470:33247,58471:33248,58472:33255,58473:33274,58474:33275,58475:33278,58476:33281,58477:33282,58478:33285,58479:33287,58480:33290,58481:33293,58482:33296,58483:33302,58484:33321,58485:33323,58486:33336,58487:33331,58488:33344,58489:33369,58490:33368,58491:33373,58492:33370,58493:33375,58494:33380,58496:33378,58497:33384,58498:33386,58499:33387,58500:33326,58501:33393,58502:33399,58503:33400,58504:33406,58505:33421,58506:33426,58507:33451,58508:33439,58509:33467,58510:33452,58511:33505,58512:33507,58513:33503,58514:33490,58515:33524,58516:33523,58517:33530,58518:33683,58519:33539,58520:33531,58521:33529,58522:33502,58523:33542,58524:33500,58525:33545,58526:33497,58527:33589,58528:33588,58529:33558,58530:33586,58531:33585,58532:33600,58533:33593,58534:33616,58535:33605,58536:33583,58537:33579,58538:33559,58539:33560,58540:33669,58541:33690,58542:33706,58543:33695,58544:33698,58545:33686,58546:33571,58547:33678,58548:33671,58549:33674,58550:33660,58551:33717,58552:33651,58553:33653,58554:33696,58555:33673,58556:33704,58557:33780,58558:33811,58559:33771,58560:33742,58561:33789,58562:33795,58563:33752,58564:33803,58565:33729,58566:33783,58567:33799,58568:33760,58569:33778,58570:33805,58571:33826,58572:33824,58573:33725,58574:33848,58575:34054,58576:33787,58577:33901,58578:33834,58579:33852,58580:34138,58581:33924,58582:33911,58583:33899,58584:33965,58585:33902,58586:33922,58587:33897,58588:33862,58589:33836,58590:33903,58591:33913,58592:33845,58593:33994,58594:33890,58595:33977,58596:33983,58597:33951,58598:34009,58599:33997,58600:33979,58601:34010,58602:34e3,58603:33985,58604:33990,58605:34006,58606:33953,58607:34081,58608:34047,58609:34036,58610:34071,58611:34072,58612:34092,58613:34079,58614:34069,58615:34068,58616:34044,58617:34112,58618:34147,58619:34136,58620:34120,58688:34113,58689:34306,58690:34123,58691:34133,58692:34176,58693:34212,58694:34184,58695:34193,58696:34186,58697:34216,58698:34157,58699:34196,58700:34203,58701:34282,58702:34183,58703:34204,58704:34167,58705:34174,58706:34192,58707:34249,58708:34234,58709:34255,58710:34233,58711:34256,58712:34261,58713:34269,58714:34277,58715:34268,58716:34297,58717:34314,58718:34323,58719:34315,58720:34302,58721:34298,58722:34310,58723:34338,58724:34330,58725:34352,58726:34367,58727:34381,58728:20053,58729:34388,58730:34399,58731:34407,58732:34417,58733:34451,58734:34467,58735:34473,58736:34474,58737:34443,58738:34444,58739:34486,58740:34479,58741:34500,58742:34502,58743:34480,58744:34505,58745:34851,58746:34475,58747:34516,58748:34526,58749:34537,58750:34540,58752:34527,58753:34523,58754:34543,58755:34578,58756:34566,58757:34568,58758:34560,58759:34563,58760:34555,58761:34577,58762:34569,58763:34573,58764:34553,58765:34570,58766:34612,58767:34623,58768:34615,58769:34619,58770:34597,58771:34601,58772:34586,58773:34656,58774:34655,58775:34680,58776:34636,58777:34638,58778:34676,58779:34647,58780:34664,58781:34670,58782:34649,58783:34643,58784:34659,58785:34666,58786:34821,58787:34722,58788:34719,58789:34690,58790:34735,58791:34763,58792:34749,58793:34752,58794:34768,58795:38614,58796:34731,58797:34756,58798:34739,58799:34759,58800:34758,58801:34747,58802:34799,58803:34802,58804:34784,58805:34831,58806:34829,58807:34814,58808:34806,58809:34807,58810:34830,58811:34770,58812:34833,58813:34838,58814:34837,58815:34850,58816:34849,58817:34865,58818:34870,58819:34873,58820:34855,58821:34875,58822:34884,58823:34882,58824:34898,58825:34905,58826:34910,58827:34914,58828:34923,58829:34945,58830:34942,58831:34974,58832:34933,58833:34941,58834:34997,58835:34930,58836:34946,58837:34967,58838:34962,58839:34990,58840:34969,58841:34978,58842:34957,58843:34980,58844:34992,58845:35007,58846:34993,58847:35011,58848:35012,58849:35028,58850:35032,58851:35033,58852:35037,58853:35065,58854:35074,58855:35068,58856:35060,58857:35048,58858:35058,58859:35076,58860:35084,58861:35082,58862:35091,58863:35139,58864:35102,58865:35109,58866:35114,58867:35115,58868:35137,58869:35140,58870:35131,58871:35126,58872:35128,58873:35148,58874:35101,58875:35168,58876:35166,58944:35174,58945:35172,58946:35181,58947:35178,58948:35183,58949:35188,58950:35191,58951:35198,58952:35203,58953:35208,58954:35210,58955:35219,58956:35224,58957:35233,58958:35241,58959:35238,58960:35244,58961:35247,58962:35250,58963:35258,58964:35261,58965:35263,58966:35264,58967:35290,58968:35292,58969:35293,58970:35303,58971:35316,58972:35320,58973:35331,58974:35350,58975:35344,58976:35340,58977:35355,58978:35357,58979:35365,58980:35382,58981:35393,58982:35419,58983:35410,58984:35398,58985:35400,58986:35452,58987:35437,58988:35436,58989:35426,58990:35461,58991:35458,58992:35460,58993:35496,58994:35489,58995:35473,58996:35493,58997:35494,58998:35482,58999:35491,59e3:35524,59001:35533,59002:35522,59003:35546,59004:35563,59005:35571,59006:35559,59008:35556,59009:35569,59010:35604,59011:35552,59012:35554,59013:35575,59014:35550,59015:35547,59016:35596,59017:35591,59018:35610,59019:35553,59020:35606,59021:35600,59022:35607,59023:35616,59024:35635,59025:38827,59026:35622,59027:35627,59028:35646,59029:35624,59030:35649,59031:35660,59032:35663,59033:35662,59034:35657,59035:35670,59036:35675,59037:35674,59038:35691,59039:35679,59040:35692,59041:35695,59042:35700,59043:35709,59044:35712,59045:35724,59046:35726,59047:35730,59048:35731,59049:35734,59050:35737,59051:35738,59052:35898,59053:35905,59054:35903,59055:35912,59056:35916,59057:35918,59058:35920,59059:35925,59060:35938,59061:35948,59062:35960,59063:35962,59064:35970,59065:35977,59066:35973,59067:35978,59068:35981,59069:35982,59070:35988,59071:35964,59072:35992,59073:25117,59074:36013,59075:36010,59076:36029,59077:36018,59078:36019,59079:36014,59080:36022,59081:36040,59082:36033,59083:36068,59084:36067,59085:36058,59086:36093,59087:36090,59088:36091,59089:36100,59090:36101,59091:36106,59092:36103,59093:36111,59094:36109,59095:36112,59096:40782,59097:36115,59098:36045,59099:36116,59100:36118,59101:36199,59102:36205,59103:36209,59104:36211,59105:36225,59106:36249,59107:36290,59108:36286,59109:36282,59110:36303,59111:36314,59112:36310,59113:36300,59114:36315,59115:36299,59116:36330,59117:36331,59118:36319,59119:36323,59120:36348,59121:36360,59122:36361,59123:36351,59124:36381,59125:36382,59126:36368,59127:36383,59128:36418,59129:36405,59130:36400,59131:36404,59132:36426,59200:36423,59201:36425,59202:36428,59203:36432,59204:36424,59205:36441,59206:36452,59207:36448,59208:36394,59209:36451,59210:36437,59211:36470,59212:36466,59213:36476,59214:36481,59215:36487,59216:36485,59217:36484,59218:36491,59219:36490,59220:36499,59221:36497,59222:36500,59223:36505,59224:36522,59225:36513,59226:36524,59227:36528,59228:36550,59229:36529,59230:36542,59231:36549,59232:36552,59233:36555,59234:36571,59235:36579,59236:36604,59237:36603,59238:36587,59239:36606,59240:36618,59241:36613,59242:36629,59243:36626,59244:36633,59245:36627,59246:36636,59247:36639,59248:36635,59249:36620,59250:36646,59251:36659,59252:36667,59253:36665,59254:36677,59255:36674,59256:36670,59257:36684,59258:36681,59259:36678,59260:36686,59261:36695,59262:36700,59264:36706,59265:36707,59266:36708,59267:36764,59268:36767,59269:36771,59270:36781,59271:36783,59272:36791,59273:36826,59274:36837,59275:36834,59276:36842,59277:36847,59278:36999,59279:36852,59280:36869,59281:36857,59282:36858,59283:36881,59284:36885,59285:36897,59286:36877,59287:36894,59288:36886,59289:36875,59290:36903,59291:36918,59292:36917,59293:36921,59294:36856,59295:36943,59296:36944,59297:36945,59298:36946,59299:36878,59300:36937,59301:36926,59302:36950,59303:36952,59304:36958,59305:36968,59306:36975,59307:36982,59308:38568,59309:36978,59310:36994,59311:36989,59312:36993,59313:36992,59314:37002,59315:37001,59316:37007,59317:37032,59318:37039,59319:37041,59320:37045,59321:37090,59322:37092,59323:25160,59324:37083,59325:37122,59326:37138,59327:37145,59328:37170,59329:37168,59330:37194,59331:37206,59332:37208,59333:37219,59334:37221,59335:37225,59336:37235,59337:37234,59338:37259,59339:37257,59340:37250,59341:37282,59342:37291,59343:37295,59344:37290,59345:37301,59346:37300,59347:37306,59348:37312,59349:37313,59350:37321,59351:37323,59352:37328,59353:37334,59354:37343,59355:37345,59356:37339,59357:37372,59358:37365,59359:37366,59360:37406,59361:37375,59362:37396,59363:37420,59364:37397,59365:37393,59366:37470,59367:37463,59368:37445,59369:37449,59370:37476,59371:37448,59372:37525,59373:37439,59374:37451,59375:37456,59376:37532,59377:37526,59378:37523,59379:37531,59380:37466,59381:37583,59382:37561,59383:37559,59384:37609,59385:37647,59386:37626,59387:37700,59388:37678,59456:37657,59457:37666,59458:37658,59459:37667,59460:37690,59461:37685,59462:37691,59463:37724,59464:37728,59465:37756,59466:37742,59467:37718,59468:37808,59469:37804,59470:37805,59471:37780,59472:37817,59473:37846,59474:37847,59475:37864,59476:37861,59477:37848,59478:37827,59479:37853,59480:37840,59481:37832,59482:37860,59483:37914,59484:37908,59485:37907,59486:37891,59487:37895,59488:37904,59489:37942,59490:37931,59491:37941,59492:37921,59493:37946,59494:37953,59495:37970,59496:37956,59497:37979,59498:37984,59499:37986,59500:37982,59501:37994,59502:37417,59503:38e3,59504:38005,59505:38007,59506:38013,59507:37978,59508:38012,59509:38014,59510:38017,59511:38015,59512:38274,59513:38279,59514:38282,59515:38292,59516:38294,59517:38296,59518:38297,59520:38304,59521:38312,59522:38311,59523:38317,59524:38332,59525:38331,59526:38329,59527:38334,59528:38346,59529:28662,59530:38339,59531:38349,59532:38348,59533:38357,59534:38356,59535:38358,59536:38364,59537:38369,59538:38373,59539:38370,59540:38433,59541:38440,59542:38446,59543:38447,59544:38466,59545:38476,59546:38479,59547:38475,59548:38519,59549:38492,59550:38494,59551:38493,59552:38495,59553:38502,59554:38514,59555:38508,59556:38541,59557:38552,59558:38549,59559:38551,59560:38570,59561:38567,59562:38577,59563:38578,59564:38576,59565:38580,59566:38582,59567:38584,59568:38585,59569:38606,59570:38603,59571:38601,59572:38605,59573:35149,59574:38620,59575:38669,59576:38613,59577:38649,59578:38660,59579:38662,59580:38664,59581:38675,59582:38670,59583:38673,59584:38671,59585:38678,59586:38681,59587:38692,59588:38698,59589:38704,59590:38713,59591:38717,59592:38718,59593:38724,59594:38726,59595:38728,59596:38722,59597:38729,59598:38748,59599:38752,59600:38756,59601:38758,59602:38760,59603:21202,59604:38763,59605:38769,59606:38777,59607:38789,59608:38780,59609:38785,59610:38778,59611:38790,59612:38795,59613:38799,59614:38800,59615:38812,59616:38824,59617:38822,59618:38819,59619:38835,59620:38836,59621:38851,59622:38854,59623:38856,\n59624:38859,59625:38876,59626:38893,59627:40783,59628:38898,59629:31455,59630:38902,59631:38901,59632:38927,59633:38924,59634:38968,59635:38948,59636:38945,59637:38967,59638:38973,59639:38982,59640:38991,59641:38987,59642:39019,59643:39023,59644:39024,59712:39025,59713:39028,59714:39027,59715:39082,59716:39087,59717:39089,59718:39094,59719:39108,59720:39107,59721:39110,59722:39145,59723:39147,59724:39171,59725:39177,59726:39186,59727:39188,59728:39192,59729:39201,59730:39197,59731:39198,59732:39204,59733:39200,59734:39212,59735:39214,59736:39229,59737:39230,59738:39234,59739:39241,59740:39237,59741:39248,59742:39243,59743:39249,59744:39250,59745:39244,59746:39253,59747:39319,59748:39320,59749:39333,59750:39341,59751:39342,59752:39356,59753:39391,59754:39387,59755:39389,59756:39384,59757:39377,59758:39405,59759:39406,59760:39409,59761:39410,59762:39419,59763:39416,59764:39425,59765:39439,59766:39429,59767:39394,59768:39449,59769:39467,59770:39479,59771:39493,59772:39490,59773:39488,59774:39491,59776:39486,59777:39509,59778:39501,59779:39515,59780:39511,59781:39519,59782:39522,59783:39525,59784:39524,59785:39529,59786:39531,59787:39530,59788:39597,59789:39600,59790:39612,59791:39616,59792:39631,59793:39633,59794:39635,59795:39636,59796:39646,59797:39647,59798:39650,59799:39651,59800:39654,59801:39663,59802:39659,59803:39662,59804:39668,59805:39665,59806:39671,59807:39675,59808:39686,59809:39704,59810:39706,59811:39711,59812:39714,59813:39715,59814:39717,59815:39719,59816:39720,59817:39721,59818:39722,59819:39726,59820:39727,59821:39730,59822:39748,59823:39747,59824:39759,59825:39757,59826:39758,59827:39761,59828:39768,59829:39796,59830:39827,59831:39811,59832:39825,59833:39830,59834:39831,59835:39839,59836:39840,59837:39848,59838:39860,59839:39872,59840:39882,59841:39865,59842:39878,59843:39887,59844:39889,59845:39890,59846:39907,59847:39906,59848:39908,59849:39892,59850:39905,59851:39994,59852:39922,59853:39921,59854:39920,59855:39957,59856:39956,59857:39945,59858:39955,59859:39948,59860:39942,59861:39944,59862:39954,59863:39946,59864:39940,59865:39982,59866:39963,59867:39973,59868:39972,59869:39969,59870:39984,59871:40007,59872:39986,59873:40006,59874:39998,59875:40026,59876:40032,59877:40039,59878:40054,59879:40056,59880:40167,59881:40172,59882:40176,59883:40201,59884:40200,59885:40171,59886:40195,59887:40198,59888:40234,59889:40230,59890:40367,59891:40227,59892:40223,59893:40260,59894:40213,59895:40210,59896:40257,59897:40255,59898:40254,59899:40262,59900:40264,59968:40285,59969:40286,59970:40292,59971:40273,59972:40272,59973:40281,59974:40306,59975:40329,59976:40327,59977:40363,59978:40303,59979:40314,59980:40346,59981:40356,59982:40361,59983:40370,59984:40388,59985:40385,59986:40379,59987:40376,59988:40378,59989:40390,59990:40399,59991:40386,59992:40409,59993:40403,59994:40440,59995:40422,59996:40429,59997:40431,59998:40445,59999:40474,6e4:40475,60001:40478,60002:40565,60003:40569,60004:40573,60005:40577,60006:40584,60007:40587,60008:40588,60009:40594,60010:40597,60011:40593,60012:40605,60013:40613,60014:40617,60015:40632,60016:40618,60017:40621,60018:38753,60019:40652,60020:40654,60021:40655,60022:40656,60023:40660,60024:40668,60025:40670,60026:40669,60027:40672,60028:40677,60029:40680,60030:40687,60032:40692,60033:40694,60034:40695,60035:40697,60036:40699,60037:40700,60038:40701,60039:40711,60040:40712,60041:30391,60042:40725,60043:40737,60044:40748,60045:40766,60046:40778,60047:40786,60048:40788,60049:40803,60050:40799,60051:40800,60052:40801,60053:40806,60054:40807,60055:40812,60056:40810,60057:40823,60058:40818,60059:40822,60060:40853,60061:40860,60062:40864,60063:22575,60064:27079,60065:36953,60066:29796,60067:20956,60068:29081}},function(o,e,r){\"use strict\";function t(o,e,r,t){e.degree()<r.degree()&&(w=[r,e],e=w[0],r=w[1]);for(var c=e,s=r,a=o.zero,d=o.one;s.degree()>=t/2;){var n=c,l=a;if(c=s,a=d,c.isZero())return null;s=n;for(var i=o.zero,B=c.getCoefficient(c.degree()),k=o.inverse(B);s.degree()>=c.degree()&&!s.isZero();){var u=s.degree()-c.degree(),C=o.multiply(s.getCoefficient(s.degree()),k);i=i.addOrSubtract(o.buildMonomial(u,C)),s=s.addOrSubtract(c.multiplyByMonomial(u,C))}if(d=i.multiplyPoly(a).addOrSubtract(l),s.degree()>=c.degree())return null}var m=d.getCoefficient(0);if(0===m)return null;var f=o.inverse(m);return[d.multiply(f),s.multiply(f)];var w}function c(o,e){var r=e.degree();if(1===r)return[e.getCoefficient(1)];for(var t=new Array(r),c=0,s=1;s<o.size&&c<r;s++)0===e.evaluateAt(s)&&(t[c]=o.inverse(s),c++);return c!==r?null:t}function s(o,e,r){for(var t=r.length,c=new Array(t),s=0;s<t;s++){for(var a=o.inverse(r[s]),n=1,l=0;l<t;l++)s!==l&&(n=o.multiply(n,d.addOrSubtractGF(1,o.multiply(r[l],a))));c[s]=o.multiply(e.evaluateAt(a),o.inverse(n)),0!==o.generatorBase&&(c[s]=o.multiply(c[s],a))}return c}function a(o,e){var r=new Uint8ClampedArray(o.length);r.set(o);for(var a=new d.default(285,256,0),l=new n.default(a,r),i=new Uint8ClampedArray(e),B=!1,k=0;k<e;k++){var u=l.evaluateAt(a.exp(k+a.generatorBase));i[i.length-1-k]=u,0!==u&&(B=!0)}if(!B)return r;var C=new n.default(a,i),m=t(a,a.buildMonomial(e,1),C,e);if(null===m)return null;var f=c(a,m[0]);if(null==f)return null;for(var w=s(a,m[1],f),P=0;P<f.length;P++){var v=r.length-1-a.log(f[P]);if(v<0)return null;r[v]=d.addOrSubtractGF(r[v],w[P])}return r}Object.defineProperty(e,\"__esModule\",{value:!0});var d=r(1),n=r(2);e.decode=a},function(o,e,r){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.VERSIONS=[{infoBits:null,versionNumber:1,alignmentPatternCenters:[],errorCorrectionLevels:[{ecCodewordsPerBlock:7,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:19}]},{ecCodewordsPerBlock:10,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:16}]},{ecCodewordsPerBlock:13,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:13}]},{ecCodewordsPerBlock:17,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:9}]}]},{infoBits:null,versionNumber:2,alignmentPatternCenters:[6,18],errorCorrectionLevels:[{ecCodewordsPerBlock:10,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:34}]},{ecCodewordsPerBlock:16,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:28}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:22}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:16}]}]},{infoBits:null,versionNumber:3,alignmentPatternCenters:[6,22],errorCorrectionLevels:[{ecCodewordsPerBlock:15,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:55}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:44}]},{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:17}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:13}]}]},{infoBits:null,versionNumber:4,alignmentPatternCenters:[6,26],errorCorrectionLevels:[{ecCodewordsPerBlock:20,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:80}]},{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:32}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:24}]},{ecCodewordsPerBlock:16,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:9}]}]},{infoBits:null,versionNumber:5,alignmentPatternCenters:[6,30],errorCorrectionLevels:[{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:108}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:43}]},{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:15},{numBlocks:2,dataCodewordsPerBlock:16}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:11},{numBlocks:2,dataCodewordsPerBlock:12}]}]},{infoBits:null,versionNumber:6,alignmentPatternCenters:[6,34],errorCorrectionLevels:[{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:68}]},{ecCodewordsPerBlock:16,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:27}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:19}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:15}]}]},{infoBits:31892,versionNumber:7,alignmentPatternCenters:[6,22,38],errorCorrectionLevels:[{ecCodewordsPerBlock:20,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:78}]},{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:31}]},{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:14},{numBlocks:4,dataCodewordsPerBlock:15}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:13},{numBlocks:1,dataCodewordsPerBlock:14}]}]},{infoBits:34236,versionNumber:8,alignmentPatternCenters:[6,24,42],errorCorrectionLevels:[{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:97}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:38},{numBlocks:2,dataCodewordsPerBlock:39}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:18},{numBlocks:2,dataCodewordsPerBlock:19}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:14},{numBlocks:2,dataCodewordsPerBlock:15}]}]},{infoBits:39577,versionNumber:9,alignmentPatternCenters:[6,26,46],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:36},{numBlocks:2,dataCodewordsPerBlock:37}]},{ecCodewordsPerBlock:20,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:16},{numBlocks:4,dataCodewordsPerBlock:17}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:12},{numBlocks:4,dataCodewordsPerBlock:13}]}]},{infoBits:42195,versionNumber:10,alignmentPatternCenters:[6,28,50],errorCorrectionLevels:[{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:68},{numBlocks:2,dataCodewordsPerBlock:69}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:43},{numBlocks:1,dataCodewordsPerBlock:44}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:19},{numBlocks:2,dataCodewordsPerBlock:20}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:15},{numBlocks:2,dataCodewordsPerBlock:16}]}]},{infoBits:48118,versionNumber:11,alignmentPatternCenters:[6,30,54],errorCorrectionLevels:[{ecCodewordsPerBlock:20,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:81}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:50},{numBlocks:4,dataCodewordsPerBlock:51}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:22},{numBlocks:4,dataCodewordsPerBlock:23}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:12},{numBlocks:8,dataCodewordsPerBlock:13}]}]},{infoBits:51042,versionNumber:12,alignmentPatternCenters:[6,32,58],errorCorrectionLevels:[{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:92},{numBlocks:2,dataCodewordsPerBlock:93}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:36},{numBlocks:2,dataCodewordsPerBlock:37}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:20},{numBlocks:6,dataCodewordsPerBlock:21}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:7,dataCodewordsPerBlock:14},{numBlocks:4,dataCodewordsPerBlock:15}]}]},{infoBits:55367,versionNumber:13,alignmentPatternCenters:[6,34,62],errorCorrectionLevels:[{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:107}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:37},{numBlocks:1,dataCodewordsPerBlock:38}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:20},{numBlocks:4,dataCodewordsPerBlock:21}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:12,dataCodewordsPerBlock:11},{numBlocks:4,dataCodewordsPerBlock:12}]}]},{infoBits:58893,versionNumber:14,alignmentPatternCenters:[6,26,46,66],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:115},{numBlocks:1,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:40},{numBlocks:5,dataCodewordsPerBlock:41}]},{ecCodewordsPerBlock:20,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:16},{numBlocks:5,dataCodewordsPerBlock:17}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:12},{numBlocks:5,dataCodewordsPerBlock:13}]}]},{infoBits:63784,versionNumber:15,alignmentPatternCenters:[6,26,48,70],errorCorrectionLevels:[{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:87},{numBlocks:1,dataCodewordsPerBlock:88}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:41},{numBlocks:5,dataCodewordsPerBlock:42}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:24},{numBlocks:7,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:12},{numBlocks:7,dataCodewordsPerBlock:13}]}]},{infoBits:68472,versionNumber:16,alignmentPatternCenters:[6,26,50,74],errorCorrectionLevels:[{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:98},{numBlocks:1,dataCodewordsPerBlock:99}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:7,dataCodewordsPerBlock:45},{numBlocks:3,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:15,dataCodewordsPerBlock:19},{numBlocks:2,dataCodewordsPerBlock:20}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:15},{numBlocks:13,dataCodewordsPerBlock:16}]}]},{infoBits:70749,versionNumber:17,alignmentPatternCenters:[6,30,54,78],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:107},{numBlocks:5,dataCodewordsPerBlock:108}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:10,dataCodewordsPerBlock:46},{numBlocks:1,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:22},{numBlocks:15,dataCodewordsPerBlock:23}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:14},{numBlocks:17,dataCodewordsPerBlock:15}]}]},{infoBits:76311,versionNumber:18,alignmentPatternCenters:[6,30,56,82],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:120},{numBlocks:1,dataCodewordsPerBlock:121}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:9,dataCodewordsPerBlock:43},{numBlocks:4,dataCodewordsPerBlock:44}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:22},{numBlocks:1,dataCodewordsPerBlock:23}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:14},{numBlocks:19,dataCodewordsPerBlock:15}]}]},{infoBits:79154,versionNumber:19,alignmentPatternCenters:[6,30,58,86],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:113},{numBlocks:4,dataCodewordsPerBlock:114}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:44},{numBlocks:11,dataCodewordsPerBlock:45}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:21},{numBlocks:4,dataCodewordsPerBlock:22}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:9,dataCodewordsPerBlock:13},{numBlocks:16,dataCodewordsPerBlock:14}]}]},{infoBits:84390,versionNumber:20,alignmentPatternCenters:[6,34,62,90],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:107},{numBlocks:5,dataCodewordsPerBlock:108}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:41},{numBlocks:13,dataCodewordsPerBlock:42}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:15,dataCodewordsPerBlock:24},{numBlocks:5,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:15,dataCodewordsPerBlock:15},{numBlocks:10,dataCodewordsPerBlock:16}]}]},{infoBits:87683,versionNumber:21,alignmentPatternCenters:[6,28,50,72,94],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:116},{numBlocks:4,dataCodewordsPerBlock:117}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:42}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:22},{numBlocks:6,dataCodewordsPerBlock:23}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:16},{numBlocks:6,dataCodewordsPerBlock:17}]}]},{infoBits:92361,versionNumber:22,alignmentPatternCenters:[6,26,50,74,98],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:111},{numBlocks:7,dataCodewordsPerBlock:112}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:7,dataCodewordsPerBlock:24},{numBlocks:16,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:34,dataCodewordsPerBlock:13}]}]},{infoBits:96236,versionNumber:23,alignmentPatternCenters:[6,30,54,74,102],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:121},{numBlocks:5,dataCodewordsPerBlock:122}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:47},{numBlocks:14,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:24},{numBlocks:14,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:16,dataCodewordsPerBlock:15},{numBlocks:14,dataCodewordsPerBlock:16}]}]},{infoBits:102084,versionNumber:24,alignmentPatternCenters:[6,28,54,80,106],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:117},{numBlocks:4,dataCodewordsPerBlock:118}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:45},{numBlocks:14,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:24},{numBlocks:16,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:30,dataCodewordsPerBlock:16},{numBlocks:2,dataCodewordsPerBlock:17}]}]},{infoBits:102881,versionNumber:25,alignmentPatternCenters:[6,32,58,84,110],errorCorrectionLevels:[{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:106},{numBlocks:4,dataCodewordsPerBlock:107}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:47},{numBlocks:13,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:7,dataCodewordsPerBlock:24},{numBlocks:22,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:22,dataCodewordsPerBlock:15},{numBlocks:13,dataCodewordsPerBlock:16}]}]},{infoBits:110507,versionNumber:26,alignmentPatternCenters:[6,30,58,86,114],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:10,dataCodewordsPerBlock:114},{numBlocks:2,dataCodewordsPerBlock:115}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:46},{numBlocks:4,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:28,dataCodewordsPerBlock:22},{numBlocks:6,dataCodewordsPerBlock:23}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:33,dataCodewordsPerBlock:16},{numBlocks:4,dataCodewordsPerBlock:17}]}]},{infoBits:110734,versionNumber:27,alignmentPatternCenters:[6,34,62,90,118],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:122},{numBlocks:4,dataCodewordsPerBlock:123}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:22,dataCodewordsPerBlock:45},{numBlocks:3,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:23},{numBlocks:26,dataCodewordsPerBlock:24}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:12,dataCodewordsPerBlock:15},{numBlocks:28,dataCodewordsPerBlock:16}]}]},{infoBits:117786,versionNumber:28,alignmentPatternCenters:[6,26,50,74,98,122],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:117},{numBlocks:10,dataCodewordsPerBlock:118}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:45},{numBlocks:23,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:24},{numBlocks:31,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:15},{numBlocks:31,dataCodewordsPerBlock:16}]}]},{infoBits:119615,versionNumber:29,alignmentPatternCenters:[6,30,54,78,102,126],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:7,dataCodewordsPerBlock:116},{numBlocks:7,dataCodewordsPerBlock:117}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:21,dataCodewordsPerBlock:45},{numBlocks:7,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:23},{numBlocks:37,dataCodewordsPerBlock:24}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:15},{numBlocks:26,dataCodewordsPerBlock:16}]}]},{infoBits:126325,versionNumber:30,alignmentPatternCenters:[6,26,52,78,104,130],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:115},{numBlocks:10,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:47},{numBlocks:10,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:15,dataCodewordsPerBlock:24},{numBlocks:25,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:23,dataCodewordsPerBlock:15},{numBlocks:25,dataCodewordsPerBlock:16}]}]},{infoBits:127568,versionNumber:31,alignmentPatternCenters:[6,30,56,82,108,134],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:13,dataCodewordsPerBlock:115},{numBlocks:3,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:46},{numBlocks:29,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:42,dataCodewordsPerBlock:24},{numBlocks:1,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:23,dataCodewordsPerBlock:15},{numBlocks:28,dataCodewordsPerBlock:16}]}]},{infoBits:133589,versionNumber:32,alignmentPatternCenters:[6,34,60,86,112,138],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:115}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:10,dataCodewordsPerBlock:46},{numBlocks:23,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:10,dataCodewordsPerBlock:24},{numBlocks:35,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:15},{numBlocks:35,dataCodewordsPerBlock:16}]}]},{infoBits:136944,versionNumber:33,alignmentPatternCenters:[6,30,58,86,114,142],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:115},{numBlocks:1,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:14,dataCodewordsPerBlock:46},{numBlocks:21,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:29,dataCodewordsPerBlock:24},{numBlocks:19,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:15},{numBlocks:46,dataCodewordsPerBlock:16}]}]},{infoBits:141498,versionNumber:34,alignmentPatternCenters:[6,34,62,90,118,146],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:13,dataCodewordsPerBlock:115},{numBlocks:6,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:14,dataCodewordsPerBlock:46},{numBlocks:23,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:44,dataCodewordsPerBlock:24},{numBlocks:7,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:59,dataCodewordsPerBlock:16},{numBlocks:1,dataCodewordsPerBlock:17}]}]},{infoBits:145311,versionNumber:35,alignmentPatternCenters:[6,30,54,78,102,126,150],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:12,dataCodewordsPerBlock:121},{numBlocks:7,dataCodewordsPerBlock:122}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:12,dataCodewordsPerBlock:47},{numBlocks:26,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:39,dataCodewordsPerBlock:24},{numBlocks:14,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:22,dataCodewordsPerBlock:15},{numBlocks:41,dataCodewordsPerBlock:16}]}]},{infoBits:150283,versionNumber:36,alignmentPatternCenters:[6,24,50,76,102,128,154],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:121},{numBlocks:14,dataCodewordsPerBlock:122}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:47},{numBlocks:34,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:46,dataCodewordsPerBlock:24},{numBlocks:10,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:15},{numBlocks:64,dataCodewordsPerBlock:16}]}]},{infoBits:152622,versionNumber:37,alignmentPatternCenters:[6,28,54,80,106,132,158],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:122},{numBlocks:4,dataCodewordsPerBlock:123}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:29,dataCodewordsPerBlock:46},{numBlocks:14,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:49,dataCodewordsPerBlock:24},{numBlocks:10,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:24,dataCodewordsPerBlock:15},{numBlocks:46,dataCodewordsPerBlock:16}]}]},{infoBits:158308,versionNumber:38,alignmentPatternCenters:[6,32,58,84,110,136,162],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:122},{numBlocks:18,dataCodewordsPerBlock:123}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:13,dataCodewordsPerBlock:46},{numBlocks:32,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:48,dataCodewordsPerBlock:24},{numBlocks:14,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:42,dataCodewordsPerBlock:15},{numBlocks:32,dataCodewordsPerBlock:16}]}]},{infoBits:161089,versionNumber:39,alignmentPatternCenters:[6,26,54,82,110,138,166],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:20,dataCodewordsPerBlock:117},{numBlocks:4,dataCodewordsPerBlock:118}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:40,dataCodewordsPerBlock:47},{numBlocks:7,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:43,dataCodewordsPerBlock:24},{numBlocks:22,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:10,dataCodewordsPerBlock:15},{numBlocks:67,dataCodewordsPerBlock:16}]}]},{infoBits:167017,versionNumber:40,alignmentPatternCenters:[6,30,58,86,114,142,170],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:118},{numBlocks:6,dataCodewordsPerBlock:119}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:18,dataCodewordsPerBlock:47},{numBlocks:31,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:34,dataCodewordsPerBlock:24},{numBlocks:34,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:20,dataCodewordsPerBlock:15},{numBlocks:61,dataCodewordsPerBlock:16}]}]}]},function(o,e,r){\"use strict\";function t(o,e,r,t){var c=o.x-e.x+r.x-t.x,s=o.y-e.y+r.y-t.y;if(0===c&&0===s)return{a11:e.x-o.x,a12:e.y-o.y,a13:0,a21:r.x-e.x,a22:r.y-e.y,a23:0,a31:o.x,a32:o.y,a33:1};var a=e.x-r.x,d=t.x-r.x,n=e.y-r.y,l=t.y-r.y,i=a*l-d*n,B=(c*l-d*s)/i,k=(a*s-c*n)/i;return{a11:e.x-o.x+B*e.x,a12:e.y-o.y+B*e.y,a13:B,a21:t.x-o.x+k*t.x,a22:t.y-o.y+k*t.y,a23:k,a31:o.x,a32:o.y,a33:1}}function c(o,e,r,c){var s=t(o,e,r,c);return{a11:s.a22*s.a33-s.a23*s.a32,a12:s.a13*s.a32-s.a12*s.a33,a13:s.a12*s.a23-s.a13*s.a22,a21:s.a23*s.a31-s.a21*s.a33,a22:s.a11*s.a33-s.a13*s.a31,a23:s.a13*s.a21-s.a11*s.a23,a31:s.a21*s.a32-s.a22*s.a31,a32:s.a12*s.a31-s.a11*s.a32,a33:s.a11*s.a22-s.a12*s.a21}}function s(o,e){return{a11:o.a11*e.a11+o.a21*e.a12+o.a31*e.a13,a12:o.a12*e.a11+o.a22*e.a12+o.a32*e.a13,a13:o.a13*e.a11+o.a23*e.a12+o.a33*e.a13,a21:o.a11*e.a21+o.a21*e.a22+o.a31*e.a23,a22:o.a12*e.a21+o.a22*e.a22+o.a32*e.a23,a23:o.a13*e.a21+o.a23*e.a22+o.a33*e.a23,a31:o.a11*e.a31+o.a21*e.a32+o.a31*e.a33,a32:o.a12*e.a31+o.a22*e.a32+o.a32*e.a33,a33:o.a13*e.a31+o.a23*e.a32+o.a33*e.a33}}function a(o,e){for(var r=c({x:3.5,y:3.5},{x:e.dimension-3.5,y:3.5},{x:e.dimension-6.5,y:e.dimension-6.5},{x:3.5,y:e.dimension-3.5}),a=t(e.topLeft,e.topRight,e.alignmentPattern,e.bottomLeft),n=s(a,r),l=d.BitMatrix.createEmpty(e.dimension,e.dimension),i=function(o,e){var r=n.a13*o+n.a23*e+n.a33;return{x:(n.a11*o+n.a21*e+n.a31)/r,y:(n.a12*o+n.a22*e+n.a32)/r}},B=0;B<e.dimension;B++)for(var k=0;k<e.dimension;k++){var u=k+.5,C=B+.5,m=i(u,C);l.set(k,B,o.get(Math.floor(m.x),Math.floor(m.y)))}return{matrix:l,mappingFunction:i}}Object.defineProperty(e,\"__esModule\",{value:!0});var d=r(0);e.extract=a},function(o,e,r){\"use strict\";function t(o){return o.reduce(function(o,e){return o+e})}function c(o,e,r){var t,c,s,a=C(o,e),d=C(e,r),n=C(o,r);return d>=a&&d>=n?(l=[e,o,r],t=l[0],c=l[1],s=l[2]):n>=d&&n>=a?(i=[o,e,r],t=i[0],c=i[1],s=i[2]):(B=[o,r,e],t=B[0],c=B[1],s=B[2]),(s.x-c.x)*(t.y-c.y)-(s.y-c.y)*(t.x-c.x)<0&&(k=[s,t],t=k[0],s=k[1]),{bottomLeft:t,topLeft:c,topRight:s};var l,i,B,k}function s(o,e,r,c){var s=(t(d(o,r,c,5))/7+t(d(o,e,c,5))/7+t(d(r,o,c,5))/7+t(d(e,o,c,5))/7)/4;if(s<1)throw new Error(\"Invalid module size\");var a=Math.round(C(o,e)/s),n=Math.round(C(o,r)/s),l=Math.floor((a+n)/2)+7;switch(l%4){case 0:l++;break;case 2:l--}return{dimension:l,moduleSize:s}}function a(o,e,r,t){var c,s,a,d,n=[{x:Math.floor(o.x),y:Math.floor(o.y)}],l=Math.abs(e.y-o.y)>Math.abs(e.x-o.x);l?(c=Math.floor(o.y),s=Math.floor(o.x),a=Math.floor(e.y),d=Math.floor(e.x)):(c=Math.floor(o.x),s=Math.floor(o.y),a=Math.floor(e.x),d=Math.floor(e.y));for(var i=Math.abs(a-c),B=Math.abs(d-s),k=Math.floor(-i/2),u=c<a?1:-1,m=s<d?1:-1,f=!0,w=c,P=s;w!==a+u;w+=u){var v=l?P:w,h=l?w:P;if(r.get(v,h)!==f&&(f=!f,n.push({x:v,y:h}),n.length===t+1))break;if((k+=B)>0){if(P===d)break;P+=m,k-=i}}for(var p=[],y=0;y<t;y++)n[y]&&n[y+1]?p.push(C(n[y],n[y+1])):p.push(0);return p}function d(o,e,r,t){var c=e.y-o.y,s=e.x-o.x,d=a(o,e,r,Math.ceil(t/2)),n=a(o,{x:o.x-s,y:o.y-c},r,Math.ceil(t/2)),l=d.shift()+n.shift()-1;return(i=n.concat(l)).concat.apply(i,d);var i}function n(o,e){var r=t(o)/t(e),c=0;return e.forEach(function(e,t){c+=Math.pow(o[t]-e*r,2)}),{averageSize:r,error:c}}function l(o,e,r){try{var t=d(o,{x:-1,y:o.y},r,e.length),c=d(o,{x:o.x,y:-1},r,e.length),s={x:Math.max(0,o.x-o.y)-1,y:Math.max(0,o.y-o.x)-1},a=d(o,s,r,e.length),l={x:Math.min(r.width,o.x+o.y)+1,y:Math.min(r.height,o.y+o.x)+1},i=d(o,l,r,e.length),B=n(t,e),k=n(c,e),u=n(a,e),C=n(i,e),m=Math.sqrt(B.error*B.error+k.error*k.error+u.error*u.error+C.error*C.error),f=(B.averageSize+k.averageSize+u.averageSize+C.averageSize)/4;return m+(Math.pow(B.averageSize-f,2)+Math.pow(k.averageSize-f,2)+Math.pow(u.averageSize-f,2)+Math.pow(C.averageSize-f,2))/f}catch(o){return 1/0}}function i(o){for(var e=[],r=[],a=[],d=[],n=0;n<=o.height;n++)!function(c){for(var s=0,n=!1,l=[0,0,0,0,0],i=-1;i<=o.width;i++)!function(e){var a=o.get(e,c);if(a===n)s++;else{l=[l[1],l[2],l[3],l[4],s],s=1,n=a;var i=t(l)/7,B=Math.abs(l[0]-i)<i&&Math.abs(l[1]-i)<i&&Math.abs(l[2]-3*i)<3*i&&Math.abs(l[3]-i)<i&&Math.abs(l[4]-i)<i&&!a,C=t(l.slice(-3))/3,m=Math.abs(l[2]-C)<C&&Math.abs(l[3]-C)<C&&Math.abs(l[4]-C)<C&&a;if(B){var f=e-l[3]-l[4],w=f-l[2],P={startX:w,endX:f,y:c},v=r.filter(function(o){return w>=o.bottom.startX&&w<=o.bottom.endX||f>=o.bottom.startX&&w<=o.bottom.endX||w<=o.bottom.startX&&f>=o.bottom.endX&&l[2]/(o.bottom.endX-o.bottom.startX)<u&&l[2]/(o.bottom.endX-o.bottom.startX)>k});v.length>0?v[0].bottom=P:r.push({top:P,bottom:P})}if(m){var h=e-l[4],p=h-l[3],P={startX:p,y:c,endX:h},v=d.filter(function(o){return p>=o.bottom.startX&&p<=o.bottom.endX||h>=o.bottom.startX&&p<=o.bottom.endX||p<=o.bottom.startX&&h>=o.bottom.endX&&l[2]/(o.bottom.endX-o.bottom.startX)<u&&l[2]/(o.bottom.endX-o.bottom.startX)>k});v.length>0?v[0].bottom=P:d.push({top:P,bottom:P})}}}(i);e.push.apply(e,r.filter(function(o){return o.bottom.y!==c&&o.bottom.y-o.top.y>=2})),r=r.filter(function(o){return o.bottom.y===c}),a.push.apply(a,d.filter(function(o){return o.bottom.y!==c})),d=d.filter(function(o){return o.bottom.y===c})}(n);e.push.apply(e,r.filter(function(o){return o.bottom.y-o.top.y>=2})),a.push.apply(a,d);var i=e.filter(function(o){return o.bottom.y-o.top.y>=2}).map(function(e){var r=(e.top.startX+e.top.endX+e.bottom.startX+e.bottom.endX)/4,c=(e.top.y+e.bottom.y+1)/2;if(o.get(Math.round(r),Math.round(c))){\nvar s=[e.top.endX-e.top.startX,e.bottom.endX-e.bottom.startX,e.bottom.y-e.top.y+1],a=t(s)/s.length;return{score:l({x:Math.round(r),y:Math.round(c)},[1,1,3,1,1],o),x:r,y:c,size:a}}}).filter(function(o){return!!o}).sort(function(o,e){return o.score-e.score}).map(function(o,e,r){if(e>B)return null;var t=r.filter(function(o,r){return e!==r}).map(function(e){return{x:e.x,y:e.y,score:e.score+Math.pow(e.size-o.size,2)/o.size,size:e.size}}).sort(function(o,e){return o.score-e.score});if(t.length<2)return null;var c=o.score+t[0].score+t[1].score;return{points:[o].concat(t.slice(0,2)),score:c}}).filter(function(o){return!!o}).sort(function(o,e){return o.score-e.score});if(0===i.length)return null;var m,f,w=c(i[0].points[0],i[0].points[1],i[0].points[2]),P=w.topRight,v=w.topLeft,h=w.bottomLeft;try{L=s(v,P,h,o),m=L.dimension,f=L.moduleSize}catch(o){return null}var p={x:P.x-v.x+h.x,y:P.y-v.y+h.y},y=(C(v,h)+C(v,P))/2/f,b=1-3/y,g={x:v.x+b*(p.x-v.x),y:v.y+b*(p.y-v.y)},x=a.map(function(e){var r=(e.top.startX+e.top.endX+e.bottom.startX+e.bottom.endX)/4,c=(e.top.y+e.bottom.y+1)/2;if(o.get(Math.floor(r),Math.floor(c))){var s=[e.top.endX-e.top.startX,e.bottom.endX-e.bottom.startX,e.bottom.y-e.top.y+1];t(s);return{x:r,y:c,score:l({x:Math.floor(r),y:Math.floor(c)},[1,1,1],o)+C({x:r,y:c},g)}}}).filter(function(o){return!!o}).sort(function(o,e){return o.score-e.score}),M=y>=15&&x.length?x[0]:g;return{alignmentPattern:{x:M.x,y:M.y},bottomLeft:{x:h.x,y:h.y},dimension:m,topLeft:{x:v.x,y:v.y},topRight:{x:P.x,y:P.y}};var L}Object.defineProperty(e,\"__esModule\",{value:!0});var B=4,k=.5,u=1.5,C=function(o,e){return Math.sqrt(Math.pow(e.x-o.x,2)+Math.pow(e.y-o.y,2))};e.locate=i}]).default}),self.addEventListener(\"message\",function(o){var e=jsQR(o.data.data,o.data.width,o.data.height);e?postMessage(e.data):postMessage(null)});"], {
	  type: 'application/javascript'
	});
	
	// Props that are allowed to change dynamicly
	var propsKeys = ['delay', 'legacyMode', 'facingMode'];
	
	module.exports = (_temp = _class = function (_Component) {
	  _inherits(Reader, _Component);
	
	  function Reader(props) {
	    _classCallCheck(this, Reader);
	
	    var _this = _possibleConstructorReturn(this, (Reader.__proto__ || Object.getPrototypeOf(Reader)).call(this, props));
	
	    _this.els = {};
	
	
	    _this.state = {
	      mirrorVideo: false
	
	      // Bind function to the class
	    };_this.initiate = _this.initiate.bind(_this);
	    _this.initiateLegacyMode = _this.initiateLegacyMode.bind(_this);
	    _this.check = _this.check.bind(_this);
	    _this.handleVideo = _this.handleVideo.bind(_this);
	    _this.handleLoadStart = _this.handleLoadStart.bind(_this);
	    _this.handleInputChange = _this.handleInputChange.bind(_this);
	    _this.clearComponent = _this.clearComponent.bind(_this);
	    _this.handleReaderLoad = _this.handleReaderLoad.bind(_this);
	    _this.openImageDialog = _this.openImageDialog.bind(_this);
	    _this.handleWorkerMessage = _this.handleWorkerMessage.bind(_this);
	    _this.setRefFactory = _this.setRefFactory.bind(_this);
	    return _this;
	  }
	
	  _createClass(Reader, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Initiate web worker execute handler according to mode.
	      this.worker = new Worker(URL.createObjectURL(workerBlob));
	      this.worker.onmessage = this.handleWorkerMessage;
	
	      if (!this.props.legacyMode) {
	        this.initiate();
	      } else {
	        this.initiateLegacyMode();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // React according to change in props
	      var changedProps = havePropsChanged(this.props, nextProps, propsKeys);
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = changedProps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var prop = _step.value;
	
	          if (prop == 'facingMode') {
	            this.clearComponent();
	            this.initiate(nextProps);
	            break;
	          } else if (prop == 'delay') {
	            if (this.props.delay == false && !nextProps.legacyMode) {
	              this.timeout = setTimeout(this.check, nextProps.delay);
	            }
	            if (nextProps.delay == false) {
	              clearTimeout(this.timeout);
	            }
	          } else if (prop == 'legacyMode') {
	            if (this.props.legacyMode && !nextProps.legacyMode) {
	              this.clearComponent();
	              this.initiate(nextProps);
	            } else {
	              this.clearComponent();
	              this.componentDidUpdate = this.initiateLegacyMode;
	            }
	            break;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState !== this.state) {
	        return true;
	      }
	
	      // Only render when the `propsKeys` have changed.
	      var changedProps = havePropsChanged(this.props, nextProps, propsKeys);
	      return changedProps.length > 0;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // Stop web-worker and clear the component
	      if (this.worker) {
	        this.worker.terminate();
	        this.worker = undefined;
	      }
	      this.clearComponent();
	    }
	  }, {
	    key: 'clearComponent',
	    value: function clearComponent() {
	      // Remove all event listeners and variables
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	        this.timeout = undefined;
	      }
	      if (this.stopCamera) {
	        this.stopCamera();
	      }
	      if (this.reader) {
	        this.reader.removeEventListener('load', this.handleReaderLoad);
	      }
	      if (this.els.img) {
	        this.els.img.removeEventListener('load', this.check);
	      }
	    }
	  }, {
	    key: 'initiate',
	    value: function initiate() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var onError = props.onError,
	          facingMode = props.facingMode;
	
	      // Check browser facingMode constraint support
	      // Firefox ignores facingMode or deviceId constraints
	
	      var isFirefox = /firefox/i.test(navigator.userAgent);
	      var supported = {};
	      if (navigator.mediaDevices && typeof navigator.mediaDevices.getSupportedConstraints === 'function') {
	        supported = navigator.mediaDevices.getSupportedConstraints();
	      }
	      var constraints = {};
	
	      if (supported.facingMode) {
	        constraints.facingMode = { ideal: facingMode };
	      }
	      if (supported.frameRate) {
	        constraints.frameRate = { ideal: 25, min: 10 };
	      }
	
	      var vConstraintsPromise = supported.facingMode || isFirefox ? Promise.resolve(props.constraints || constraints) : getDeviceId(facingMode).then(function (deviceId) {
	        return Object.assign({}, { deviceId: deviceId }, props.constraints);
	      });
	
	      vConstraintsPromise.then(function (video) {
	        return navigator.mediaDevices.getUserMedia({ video: video });
	      }).then(this.handleVideo).catch(onError);
	    }
	  }, {
	    key: 'handleVideo',
	    value: function handleVideo(stream) {
	      var preview = this.els.preview;
	      var facingMode = this.props.facingMode;
	
	      // Preview element hasn't been rendered so wait for it.
	
	      if (!preview) {
	        return setTimeout(this.handleVideo, 200, stream);
	      }
	
	      // Handle different browser implementations of MediaStreams as src
	      if ((preview || {}).srcObject !== undefined) {
	        preview.srcObject = stream;
	      } else if (preview.mozSrcObject !== undefined) {
	        preview.mozSrcObject = stream;
	      } else if (window.URL.createObjectURL) {
	        preview.src = window.URL.createObjectURL(stream);
	      } else if (window.webkitURL) {
	        preview.src = window.webkitURL.createObjectURL(stream);
	      } else {
	        preview.src = stream;
	      }
	
	      // IOS play in fullscreen
	      preview.playsInline = true;
	
	      var streamTrack = stream.getTracks()[0];
	      // Assign `stopCamera` so the track can be stopped once component is cleared
	      this.stopCamera = streamTrack.stop.bind(streamTrack);
	
	      preview.addEventListener('loadstart', this.handleLoadStart);
	
	      this.setState({ mirrorVideo: facingMode == 'user', streamLabel: streamTrack.label });
	    }
	  }, {
	    key: 'handleLoadStart',
	    value: function handleLoadStart() {
	      var _props = this.props,
	          delay = _props.delay,
	          onLoad = _props.onLoad;
	      var _state = this.state,
	          mirrorVideo = _state.mirrorVideo,
	          streamLabel = _state.streamLabel;
	
	      var preview = this.els.preview;
	      preview.play();
	
	      if (typeof onLoad == 'function') {
	        onLoad({ mirrorVideo: mirrorVideo, streamLabel: streamLabel });
	      }
	
	      if (typeof delay == 'number') {
	        this.timeout = setTimeout(this.check, delay);
	      }
	
	      // Some browsers call loadstart continuously
	      preview.removeEventListener('loadstart', this.handleLoadStart);
	    }
	  }, {
	    key: 'check',
	    value: function check() {
	      var _props2 = this.props,
	          legacyMode = _props2.legacyMode,
	          resolution = _props2.resolution,
	          delay = _props2.delay;
	      var _els = this.els,
	          preview = _els.preview,
	          canvas = _els.canvas,
	          img = _els.img;
	
	      // Get image/video dimensions
	
	      var width = Math.floor(legacyMode ? img.naturalWidth : preview.videoWidth);
	      var height = Math.floor(legacyMode ? img.naturalHeight : preview.videoHeight);
	
	      // Canvas draw offsets
	      var hozOffset = 0;
	      var vertOffset = 0;
	
	      // Scale image to correct resolution
	      if (legacyMode) {
	        // Keep image aspect ratio
	        var greatestSize = width > height ? width : height;
	        var ratio = resolution / greatestSize;
	
	        height = ratio * height;
	        width = ratio * width;
	
	        canvas.width = width;
	        canvas.height = height;
	      } else {
	        // Crop image to fit 1:1 aspect ratio
	        var smallestSize = width < height ? width : height;
	        var _ratio = resolution / smallestSize;
	
	        height = _ratio * height;
	        width = _ratio * width;
	
	        vertOffset = (height - resolution) / 2 * -1;
	        hozOffset = (width - resolution) / 2 * -1;
	
	        canvas.width = resolution;
	        canvas.height = resolution;
	      }
	
	      var previewIsPlaying = preview && preview.readyState === preview.HAVE_ENOUGH_DATA;
	
	      if (legacyMode || previewIsPlaying) {
	        var ctx = canvas.getContext('2d');
	
	        ctx.drawImage(legacyMode ? img : preview, hozOffset, vertOffset, width, height);
	
	        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
	        // Send data to web-worker
	        this.worker.postMessage(imageData);
	      } else {
	        // Preview not ready -> check later
	        this.timeout = setTimeout(this.check, delay);
	      }
	    }
	  }, {
	    key: 'handleWorkerMessage',
	    value: function handleWorkerMessage(e) {
	      var _props3 = this.props,
	          onScan = _props3.onScan,
	          legacyMode = _props3.legacyMode,
	          delay = _props3.delay;
	
	      var decoded = e.data;
	      onScan(decoded || null);
	
	      if (!legacyMode && typeof delay == 'number' && this.worker) {
	        this.timeout = setTimeout(this.check, delay);
	      }
	    }
	  }, {
	    key: 'initiateLegacyMode',
	    value: function initiateLegacyMode() {
	      this.reader = new FileReader();
	      this.reader.addEventListener('load', this.handleReaderLoad);
	      this.els.img.addEventListener('load', this.check, false);
	
	      // Reset componentDidUpdate
	      this.componentDidUpdate = undefined;
	
	      if (typeof this.props.onLoad == 'function') {
	        this.props.onLoad();
	      }
	    }
	  }, {
	    key: 'handleInputChange',
	    value: function handleInputChange(e) {
	      var selectedImg = e.target.files[0];
	      this.reader.readAsDataURL(selectedImg);
	    }
	  }, {
	    key: 'handleReaderLoad',
	    value: function handleReaderLoad(e) {
	      // Set selected image blob as img source
	      this.els.img.src = e.target.result;
	    }
	  }, {
	    key: 'openImageDialog',
	    value: function openImageDialog() {
	      // Function to be executed by parent in user action context to trigger img file uploader
	      this.els.input.click();
	    }
	  }, {
	    key: 'setRefFactory',
	    value: function setRefFactory(key) {
	      var _this2 = this;
	
	      return function (element) {
	        _this2.els[key] = element;
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          style = _props4.style,
	          className = _props4.className,
	          onImageLoad = _props4.onImageLoad,
	          legacyMode = _props4.legacyMode,
	          showViewFinder = _props4.showViewFinder,
	          facingMode = _props4.facingMode;
	
	
	      var containerStyle = {
	        overflow: 'hidden',
	        position: 'relative',
	        width: '100%',
	        paddingTop: '100%'
	      };
	      var hiddenStyle = { display: 'none' };
	      var previewStyle = {
	        top: 0,
	        left: 0,
	        display: 'block',
	        position: 'absolute',
	        overflow: 'hidden',
	        width: '100%',
	        height: '100%'
	      };
	      var videoPreviewStyle = _extends({}, previewStyle, {
	        objectFit: 'cover',
	        transform: this.state.mirrorVideo ? 'scaleX(-1)' : undefined
	      });
	      var imgPreviewStyle = _extends({}, previewStyle, {
	        objectFit: 'scale-down'
	      });
	
	      var viewFinderStyle = {
	        top: 0,
	        left: 0,
	        zIndex: 1,
	        boxSizing: 'border-box',
	        border: '50px solid rgba(0, 0, 0, 0.3)',
	        boxShadow: 'inset 0 0 0 5px rgba(255, 0, 0, 0.5)',
	        position: 'absolute',
	        width: '100%',
	        height: '100%'
	      };
	
	      return React.createElement(
	        'section',
	        { className: className, style: style },
	        React.createElement(
	          'section',
	          { style: containerStyle },
	          !legacyMode && showViewFinder ? React.createElement('div', { style: viewFinderStyle }) : null,
	          legacyMode ? React.createElement('input', {
	            style: hiddenStyle,
	            type: 'file',
	            accept: 'image/*',
	            ref: this.setRefFactory('input'),
	            onChange: this.handleInputChange
	          }) : null,
	          legacyMode ? React.createElement('img', { style: imgPreviewStyle, ref: this.setRefFactory('img'), onLoad: onImageLoad }) : React.createElement('video', { style: videoPreviewStyle, ref: this.setRefFactory('preview') }),
	          React.createElement('canvas', { style: hiddenStyle, ref: this.setRefFactory('canvas') })
	        )
	      );
	    }
	  }]);
	
	  return Reader;
	}(Component), _class.propTypes = {
	  onScan: PropTypes.func.isRequired,
	  onError: PropTypes.func.isRequired,
	  onLoad: PropTypes.func,
	  onImageLoad: PropTypes.func,
	  delay: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
	  facingMode: PropTypes.oneOf(['user', 'environment']),
	  legacyMode: PropTypes.bool,
	  resolution: PropTypes.number,
	  showViewFinder: PropTypes.bool,
	  style: PropTypes.any,
	  className: PropTypes.string,
	  constraints: PropTypes.object
	}, _class.defaultProps = {
	  delay: 500,
	  resolution: 600,
	  facingMode: 'environment',
	  showViewFinder: true,
	  constraints: null
	}, _temp);

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1));
		else if(typeof define === 'function' && define.amd)
			define(["react"], factory);
		else if(typeof exports === 'object')
			exports["ReactRouterTransition"] = factory(require("react"));
		else
			root["ReactRouterTransition"] = factory(root["React"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _RouteTransition = __webpack_require__(1);
		
		Object.defineProperty(exports, 'RouteTransition', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_RouteTransition).default;
		  }
		});
		
		var _presets = __webpack_require__(19);
		
		Object.defineProperty(exports, 'presets', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_presets).default;
		  }
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _react = __webpack_require__(2);
		
		var _react2 = _interopRequireDefault(_react);
		
		var _reactMotion = __webpack_require__(3);
		
		var _ensureSpring = __webpack_require__(18);
		
		var _ensureSpring2 = _interopRequireDefault(_ensureSpring);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		var RouteTransition = _react2.default.createClass({
		  displayName: 'RouteTransition',
		
		  propTypes: {
		    className: _react.PropTypes.string,
		    component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.bool]),
		    pathname: _react.PropTypes.string.isRequired,
		    atEnter: _react.PropTypes.object.isRequired,
		    atActive: _react.PropTypes.object.isRequired,
		    atLeave: _react.PropTypes.object.isRequired,
		    mapStyles: _react.PropTypes.func,
		    runOnMount: _react.PropTypes.bool,
		    style: _react.PropTypes.object
		  },
		
		  getDefaultProps: function getDefaultProps() {
		    return {
		      component: 'div',
		      runOnMount: true,
		      mapStyles: function mapStyles(val) {
		        return val;
		      }
		    };
		  },
		  getDefaultStyles: function getDefaultStyles() {
		    if (!this.props.runOnMount) {
		      return null;
		    }
		
		    if (!this.props.children) {
		      return [];
		    }
		
		    return [{
		      key: this.props.pathname,
		      data: this.props.children,
		      style: this.props.atEnter
		    }];
		  },
		
		  // there's only ever one route mounted at a time,
		  // so just return the current match
		  getStyles: function getStyles() {
		    if (!this.props.children) {
		      return [];
		    }
		
		    // TODO: maybe access route path from children for pathname?
		    return [{
		      key: this.props.pathname,
		      data: this.props.children,
		      style: (0, _ensureSpring2.default)(this.props.atActive)
		    }];
		  },
		  willEnter: function willEnter() {
		    return this.props.atEnter;
		  },
		  willLeave: function willLeave() {
		    return (0, _ensureSpring2.default)(this.props.atLeave);
		  },
		  renderRoute: function renderRoute(config) {
		    var props = {
		      style: this.props.mapStyles(config.style),
		      key: config.key
		    };
		
		    return this.props.component ? (0, _react.createElement)(this.props.component, props, config.data) : (0, _react.cloneElement)(config.data, props);
		  },
		  renderRoutes: function renderRoutes(interpolatedStyles) {
		    return _react2.default.createElement(
		      'div',
		      { className: this.props.className, style: this.props.style },
		      interpolatedStyles.map(this.renderRoute)
		    );
		  },
		  render: function render() {
		    return _react2.default.createElement(
		      _reactMotion.TransitionMotion,
		      {
		        defaultStyles: this.getDefaultStyles(),
		        styles: this.getStyles(),
		        willEnter: this.willEnter,
		        willLeave: this.willLeave
		      },
		      this.renderRoutes
		    );
		  }
		});
		
		exports.default = RouteTransition;
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		exports.__esModule = true;
		
		function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
		
		var _Motion = __webpack_require__(4);
		
		exports.Motion = _interopRequire(_Motion);
		
		var _StaggeredMotion = __webpack_require__(12);
		
		exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
		
		var _TransitionMotion = __webpack_require__(13);
		
		exports.TransitionMotion = _interopRequire(_TransitionMotion);
		
		var _spring = __webpack_require__(15);
		
		exports.spring = _interopRequire(_spring);
		
		var _presets = __webpack_require__(16);
		
		exports.presets = _interopRequire(_presets);
		
		// deprecated, dummy warning function
		
		var _reorderKeys = __webpack_require__(17);
		
		exports.reorderKeys = _interopRequire(_reorderKeys);
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		exports.__esModule = true;
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
		
		var _mapToZero = __webpack_require__(5);
		
		var _mapToZero2 = _interopRequireDefault(_mapToZero);
		
		var _stripStyle = __webpack_require__(6);
		
		var _stripStyle2 = _interopRequireDefault(_stripStyle);
		
		var _stepper3 = __webpack_require__(7);
		
		var _stepper4 = _interopRequireDefault(_stepper3);
		
		var _performanceNow = __webpack_require__(8);
		
		var _performanceNow2 = _interopRequireDefault(_performanceNow);
		
		var _raf = __webpack_require__(10);
		
		var _raf2 = _interopRequireDefault(_raf);
		
		var _shouldStopAnimation = __webpack_require__(11);
		
		var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
		
		var _react = __webpack_require__(2);
		
		var _react2 = _interopRequireDefault(_react);
		
		var msPerFrame = 1000 / 60;
		
		var Motion = _react2['default'].createClass({
		  displayName: 'Motion',
		
		  propTypes: {
		    // TOOD: warn against putting a config in here
		    defaultStyle: _react.PropTypes.objectOf(_react.PropTypes.number),
		    style: _react.PropTypes.objectOf(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.object])).isRequired,
		    children: _react.PropTypes.func.isRequired,
		    onRest: _react.PropTypes.func
		  },
		
		  getInitialState: function getInitialState() {
		    var _props = this.props;
		    var defaultStyle = _props.defaultStyle;
		    var style = _props.style;
		
		    var currentStyle = defaultStyle || _stripStyle2['default'](style);
		    var currentVelocity = _mapToZero2['default'](currentStyle);
		    return {
		      currentStyle: currentStyle,
		      currentVelocity: currentVelocity,
		      lastIdealStyle: currentStyle,
		      lastIdealVelocity: currentVelocity
		    };
		  },
		
		  wasAnimating: false,
		  animationID: null,
		  prevTime: 0,
		  accumulatedTime: 0,
		  // it's possible that currentStyle's value is stale: if props is immediately
		  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
		  // at 0 (didn't have time to tick and interpolate even once). If we naively
		  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
		  // In reality currentStyle should be 400
		  unreadPropStyle: null,
		  // after checking for unreadPropStyle != null, we manually go set the
		  // non-interpolating values (those that are a number, without a spring
		  // config)
		  clearUnreadPropStyle: function clearUnreadPropStyle(destStyle) {
		    var dirty = false;
		    var _state = this.state;
		    var currentStyle = _state.currentStyle;
		    var currentVelocity = _state.currentVelocity;
		    var lastIdealStyle = _state.lastIdealStyle;
		    var lastIdealVelocity = _state.lastIdealVelocity;
		
		    for (var key in destStyle) {
		      if (!destStyle.hasOwnProperty(key)) {
		        continue;
		      }
		
		      var styleValue = destStyle[key];
		      if (typeof styleValue === 'number') {
		        if (!dirty) {
		          dirty = true;
		          currentStyle = _extends({}, currentStyle);
		          currentVelocity = _extends({}, currentVelocity);
		          lastIdealStyle = _extends({}, lastIdealStyle);
		          lastIdealVelocity = _extends({}, lastIdealVelocity);
		        }
		
		        currentStyle[key] = styleValue;
		        currentVelocity[key] = 0;
		        lastIdealStyle[key] = styleValue;
		        lastIdealVelocity[key] = 0;
		      }
		    }
		
		    if (dirty) {
		      this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
		    }
		  },
		
		  startAnimationIfNecessary: function startAnimationIfNecessary() {
		    var _this = this;
		
		    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
		    // call cb? No, otherwise accidental parent rerender causes cb trigger
		    this.animationID = _raf2['default'](function () {
		      // check if we need to animate in the first place
		      var propsStyle = _this.props.style;
		      if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
		        if (_this.wasAnimating && _this.props.onRest) {
		          _this.props.onRest();
		        }
		
		        // no need to cancel animationID here; shouldn't have any in flight
		        _this.animationID = null;
		        _this.wasAnimating = false;
		        _this.accumulatedTime = 0;
		        return;
		      }
		
		      _this.wasAnimating = true;
		
		      var currentTime = _performanceNow2['default']();
		      var timeDelta = currentTime - _this.prevTime;
		      _this.prevTime = currentTime;
		      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
		      // more than 10 frames? prolly switched browser tab. Restart
		      if (_this.accumulatedTime > msPerFrame * 10) {
		        _this.accumulatedTime = 0;
		      }
		
		      if (_this.accumulatedTime === 0) {
		        // no need to cancel animationID here; shouldn't have any in flight
		        _this.animationID = null;
		        _this.startAnimationIfNecessary();
		        return;
		      }
		
		      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
		      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
		
		      var newLastIdealStyle = {};
		      var newLastIdealVelocity = {};
		      var newCurrentStyle = {};
		      var newCurrentVelocity = {};
		
		      for (var key in propsStyle) {
		        if (!propsStyle.hasOwnProperty(key)) {
		          continue;
		        }
		
		        var styleValue = propsStyle[key];
		        if (typeof styleValue === 'number') {
		          newCurrentStyle[key] = styleValue;
		          newCurrentVelocity[key] = 0;
		          newLastIdealStyle[key] = styleValue;
		          newLastIdealVelocity[key] = 0;
		        } else {
		          var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
		          var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
		          for (var i = 0; i < framesToCatchUp; i++) {
		            var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
		
		            newLastIdealStyleValue = _stepper[0];
		            newLastIdealVelocityValue = _stepper[1];
		          }
		
		          var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
		
		          var nextIdealX = _stepper2[0];
		          var nextIdealV = _stepper2[1];
		
		          newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
		          newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
		          newLastIdealStyle[key] = newLastIdealStyleValue;
		          newLastIdealVelocity[key] = newLastIdealVelocityValue;
		        }
		      }
		
		      _this.animationID = null;
		      // the amount we're looped over above
		      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
		
		      _this.setState({
		        currentStyle: newCurrentStyle,
		        currentVelocity: newCurrentVelocity,
		        lastIdealStyle: newLastIdealStyle,
		        lastIdealVelocity: newLastIdealVelocity
		      });
		
		      _this.unreadPropStyle = null;
		
		      _this.startAnimationIfNecessary();
		    });
		  },
		
		  componentDidMount: function componentDidMount() {
		    this.prevTime = _performanceNow2['default']();
		    this.startAnimationIfNecessary();
		  },
		
		  componentWillReceiveProps: function componentWillReceiveProps(props) {
		    if (this.unreadPropStyle != null) {
		      // previous props haven't had the chance to be set yet; set them here
		      this.clearUnreadPropStyle(this.unreadPropStyle);
		    }
		
		    this.unreadPropStyle = props.style;
		    if (this.animationID == null) {
		      this.prevTime = _performanceNow2['default']();
		      this.startAnimationIfNecessary();
		    }
		  },
		
		  componentWillUnmount: function componentWillUnmount() {
		    if (this.animationID != null) {
		      _raf2['default'].cancel(this.animationID);
		      this.animationID = null;
		    }
		  },
		
		  render: function render() {
		    var renderedChildren = this.props.children(this.state.currentStyle);
		    return renderedChildren && _react2['default'].Children.only(renderedChildren);
		  }
		});
		
		exports['default'] = Motion;
		module.exports = exports['default'];
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		
		
		// currently used to initiate the velocity style object to 0
		'use strict';
		
		exports.__esModule = true;
		exports['default'] = mapToZero;
		
		function mapToZero(obj) {
		  var ret = {};
		  for (var key in obj) {
		    if (obj.hasOwnProperty(key)) {
		      ret[key] = 0;
		    }
		  }
		  return ret;
		}
		
		module.exports = exports['default'];
	
	/***/ },
	/* 6 */
	/***/ function(module, exports) {
	
		
		// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
		// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
		
		'use strict';
		
		exports.__esModule = true;
		exports['default'] = stripStyle;
		
		function stripStyle(style) {
		  var ret = {};
		  for (var key in style) {
		    if (!style.hasOwnProperty(key)) {
		      continue;
		    }
		    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
		  }
		  return ret;
		}
		
		module.exports = exports['default'];
	
	/***/ },
	/* 7 */
	/***/ function(module, exports) {
	
		
		
		// stepper is used a lot. Saves allocation to return the same array wrapper.
		// This is fine and danger-free against mutations because the callsite
		// immediately destructures it and gets the numbers inside without passing the
		"use strict";
		
		exports.__esModule = true;
		exports["default"] = stepper;
		
		var reusedTuple = [];
		
		function stepper(secondPerFrame, x, v, destX, k, b, precision) {
		  // Spring stiffness, in kg / s^2
		
		  // for animations, destX is really spring length (spring at rest). initial
		  // position is considered as the stretched/compressed position of a spring
		  var Fspring = -k * (x - destX);
		
		  // Damping, in kg / s
		  var Fdamper = -b * v;
		
		  // usually we put mass here, but for animation purposes, specifying mass is a
		  // bit redundant. you could simply adjust k and b accordingly
		  // let a = (Fspring + Fdamper) / mass;
		  var a = Fspring + Fdamper;
		
		  var newV = v + a * secondPerFrame;
		  var newX = x + newV * secondPerFrame;
		
		  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
		    reusedTuple[0] = destX;
		    reusedTuple[1] = 0;
		    return reusedTuple;
		  }
		
		  reusedTuple[0] = newX;
		  reusedTuple[1] = newV;
		  return reusedTuple;
		}
		
		module.exports = exports["default"];
		// array reference around.
	
	/***/ },
	/* 8 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
		(function() {
		  var getNanoSeconds, hrtime, loadTime;
		
		  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
		    module.exports = function() {
		      return performance.now();
		    };
		  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
		    module.exports = function() {
		      return (getNanoSeconds() - loadTime) / 1e6;
		    };
		    hrtime = process.hrtime;
		    getNanoSeconds = function() {
		      var hr;
		      hr = hrtime();
		      return hr[0] * 1e9 + hr[1];
		    };
		    loadTime = getNanoSeconds();
		  } else if (Date.now) {
		    module.exports = function() {
		      return Date.now() - loadTime;
		    };
		    loadTime = Date.now();
		  } else {
		    module.exports = function() {
		      return new Date().getTime() - loadTime;
		    };
		    loadTime = new Date().getTime();
		  }
		
		}).call(this);
		
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))
	
	/***/ },
	/* 9 */
	/***/ function(module, exports) {
	
		// shim for using process in browser
		
		var process = module.exports = {};
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;
		
		function cleanUpNextTick() {
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}
		
		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = setTimeout(cleanUpNextTick);
		    draining = true;
		
		    var len = queue.length;
		    while(len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    clearTimeout(timeout);
		}
		
		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        setTimeout(drainQueue, 0);
		    }
		};
		
		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};
		
		function noop() {}
		
		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
		
		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};
		
		process.cwd = function () { return '/' };
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function() { return 0; };
	
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		var now = __webpack_require__(8)
		  , global = typeof window === 'undefined' ? {} : window
		  , vendors = ['moz', 'webkit']
		  , suffix = 'AnimationFrame'
		  , raf = global['request' + suffix]
		  , caf = global['cancel' + suffix] || global['cancelRequest' + suffix]
		
		for(var i = 0; i < vendors.length && !raf; i++) {
		  raf = global[vendors[i] + 'Request' + suffix]
		  caf = global[vendors[i] + 'Cancel' + suffix]
		      || global[vendors[i] + 'CancelRequest' + suffix]
		}
		
		// Some versions of FF have rAF but not cAF
		if(!raf || !caf) {
		  var last = 0
		    , id = 0
		    , queue = []
		    , frameDuration = 1000 / 60
		
		  raf = function(callback) {
		    if(queue.length === 0) {
		      var _now = now()
		        , next = Math.max(0, frameDuration - (_now - last))
		      last = next + _now
		      setTimeout(function() {
		        var cp = queue.slice(0)
		        // Clear queue here to prevent
		        // callbacks from appending listeners
		        // to the current frame's queue
		        queue.length = 0
		        for(var i = 0; i < cp.length; i++) {
		          if(!cp[i].cancelled) {
		            try{
		              cp[i].callback(last)
		            } catch(e) {
		              setTimeout(function() { throw e }, 0)
		            }
		          }
		        }
		      }, Math.round(next))
		    }
		    queue.push({
		      handle: ++id,
		      callback: callback,
		      cancelled: false
		    })
		    return id
		  }
		
		  caf = function(handle) {
		    for(var i = 0; i < queue.length; i++) {
		      if(queue[i].handle === handle) {
		        queue[i].cancelled = true
		      }
		    }
		  }
		}
		
		module.exports = function(fn) {
		  // Wrap in a new function to prevent
		  // `cancel` potentially being assigned
		  // to the native rAF function
		  return raf.call(global, fn)
		}
		module.exports.cancel = function() {
		  caf.apply(global, arguments)
		}
	
	
	/***/ },
	/* 11 */
	/***/ function(module, exports) {
	
		
		
		// usage assumption: currentStyle values have already been rendered but it says
		// nothing of whether currentStyle is stale (see unreadPropStyle)
		'use strict';
		
		exports.__esModule = true;
		exports['default'] = shouldStopAnimation;
		
		function shouldStopAnimation(currentStyle, style, currentVelocity) {
		  for (var key in style) {
		    if (!style.hasOwnProperty(key)) {
		      continue;
		    }
		
		    if (currentVelocity[key] !== 0) {
		      return false;
		    }
		
		    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
		    // stepper will have already taken care of rounding precision errors, so
		    // won't have such thing as 0.9999 !=== 1
		    if (currentStyle[key] !== styleValue) {
		      return false;
		    }
		  }
		
		  return true;
		}
		
		module.exports = exports['default'];
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		exports.__esModule = true;
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
		
		var _mapToZero = __webpack_require__(5);
		
		var _mapToZero2 = _interopRequireDefault(_mapToZero);
		
		var _stripStyle = __webpack_require__(6);
		
		var _stripStyle2 = _interopRequireDefault(_stripStyle);
		
		var _stepper3 = __webpack_require__(7);
		
		var _stepper4 = _interopRequireDefault(_stepper3);
		
		var _performanceNow = __webpack_require__(8);
		
		var _performanceNow2 = _interopRequireDefault(_performanceNow);
		
		var _raf = __webpack_require__(10);
		
		var _raf2 = _interopRequireDefault(_raf);
		
		var _shouldStopAnimation = __webpack_require__(11);
		
		var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
		
		var _react = __webpack_require__(2);
		
		var _react2 = _interopRequireDefault(_react);
		
		var msPerFrame = 1000 / 60;
		
		function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
		  for (var i = 0; i < currentStyles.length; i++) {
		    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
		      return false;
		    }
		  }
		  return true;
		}
		
		var StaggeredMotion = _react2['default'].createClass({
		  displayName: 'StaggeredMotion',
		
		  propTypes: {
		    // TOOD: warn against putting a config in here
		    defaultStyles: _react.PropTypes.arrayOf(_react.PropTypes.objectOf(_react.PropTypes.number)),
		    styles: _react.PropTypes.func.isRequired,
		    children: _react.PropTypes.func.isRequired
		  },
		
		  getInitialState: function getInitialState() {
		    var _props = this.props;
		    var defaultStyles = _props.defaultStyles;
		    var styles = _props.styles;
		
		    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
		    var currentVelocities = currentStyles.map(function (currentStyle) {
		      return _mapToZero2['default'](currentStyle);
		    });
		    return {
		      currentStyles: currentStyles,
		      currentVelocities: currentVelocities,
		      lastIdealStyles: currentStyles,
		      lastIdealVelocities: currentVelocities
		    };
		  },
		
		  animationID: null,
		  prevTime: 0,
		  accumulatedTime: 0,
		  // it's possible that currentStyle's value is stale: if props is immediately
		  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
		  // at 0 (didn't have time to tick and interpolate even once). If we naively
		  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
		  // In reality currentStyle should be 400
		  unreadPropStyles: null,
		  // after checking for unreadPropStyles != null, we manually go set the
		  // non-interpolating values (those that are a number, without a spring
		  // config)
		  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
		    var _state = this.state;
		    var currentStyles = _state.currentStyles;
		    var currentVelocities = _state.currentVelocities;
		    var lastIdealStyles = _state.lastIdealStyles;
		    var lastIdealVelocities = _state.lastIdealVelocities;
		
		    var someDirty = false;
		    for (var i = 0; i < unreadPropStyles.length; i++) {
		      var unreadPropStyle = unreadPropStyles[i];
		      var dirty = false;
		
		      for (var key in unreadPropStyle) {
		        if (!unreadPropStyle.hasOwnProperty(key)) {
		          continue;
		        }
		
		        var styleValue = unreadPropStyle[key];
		        if (typeof styleValue === 'number') {
		          if (!dirty) {
		            dirty = true;
		            someDirty = true;
		            currentStyles[i] = _extends({}, currentStyles[i]);
		            currentVelocities[i] = _extends({}, currentVelocities[i]);
		            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
		            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
		          }
		          currentStyles[i][key] = styleValue;
		          currentVelocities[i][key] = 0;
		          lastIdealStyles[i][key] = styleValue;
		          lastIdealVelocities[i][key] = 0;
		        }
		      }
		    }
		
		    if (someDirty) {
		      this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
		    }
		  },
		
		  startAnimationIfNecessary: function startAnimationIfNecessary() {
		    var _this = this;
		
		    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
		    // call cb? No, otherwise accidental parent rerender causes cb trigger
		    this.animationID = _raf2['default'](function () {
		      var destStyles = _this.props.styles(_this.state.lastIdealStyles);
		
		      // check if we need to animate in the first place
		      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
		        // no need to cancel animationID here; shouldn't have any in flight
		        _this.animationID = null;
		        _this.accumulatedTime = 0;
		        return;
		      }
		
		      var currentTime = _performanceNow2['default']();
		      var timeDelta = currentTime - _this.prevTime;
		      _this.prevTime = currentTime;
		      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
		      // more than 10 frames? prolly switched browser tab. Restart
		      if (_this.accumulatedTime > msPerFrame * 10) {
		        _this.accumulatedTime = 0;
		      }
		
		      if (_this.accumulatedTime === 0) {
		        // no need to cancel animationID here; shouldn't have any in flight
		        _this.animationID = null;
		        _this.startAnimationIfNecessary();
		        return;
		      }
		
		      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
		      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
		
		      var newLastIdealStyles = [];
		      var newLastIdealVelocities = [];
		      var newCurrentStyles = [];
		      var newCurrentVelocities = [];
		
		      for (var i = 0; i < destStyles.length; i++) {
		        var destStyle = destStyles[i];
		        var newCurrentStyle = {};
		        var newCurrentVelocity = {};
		        var newLastIdealStyle = {};
		        var newLastIdealVelocity = {};
		
		        for (var key in destStyle) {
		          if (!destStyle.hasOwnProperty(key)) {
		            continue;
		          }
		
		          var styleValue = destStyle[key];
		          if (typeof styleValue === 'number') {
		            newCurrentStyle[key] = styleValue;
		            newCurrentVelocity[key] = 0;
		            newLastIdealStyle[key] = styleValue;
		            newLastIdealVelocity[key] = 0;
		          } else {
		            var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
		            var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
		            for (var j = 0; j < framesToCatchUp; j++) {
		              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
		
		              newLastIdealStyleValue = _stepper[0];
		              newLastIdealVelocityValue = _stepper[1];
		            }
		
		            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
		
		            var nextIdealX = _stepper2[0];
		            var nextIdealV = _stepper2[1];
		
		            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
		            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
		            newLastIdealStyle[key] = newLastIdealStyleValue;
		            newLastIdealVelocity[key] = newLastIdealVelocityValue;
		          }
		        }
		
		        newCurrentStyles[i] = newCurrentStyle;
		        newCurrentVelocities[i] = newCurrentVelocity;
		        newLastIdealStyles[i] = newLastIdealStyle;
		        newLastIdealVelocities[i] = newLastIdealVelocity;
		      }
		
		      _this.animationID = null;
		      // the amount we're looped over above
		      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
		
		      _this.setState({
		        currentStyles: newCurrentStyles,
		        currentVelocities: newCurrentVelocities,
		        lastIdealStyles: newLastIdealStyles,
		        lastIdealVelocities: newLastIdealVelocities
		      });
		
		      _this.unreadPropStyles = null;
		
		      _this.startAnimationIfNecessary();
		    });
		  },
		
		  componentDidMount: function componentDidMount() {
		    this.prevTime = _performanceNow2['default']();
		    this.startAnimationIfNecessary();
		  },
		
		  componentWillReceiveProps: function componentWillReceiveProps(props) {
		    if (this.unreadPropStyles != null) {
		      // previous props haven't had the chance to be set yet; set them here
		      this.clearUnreadPropStyle(this.unreadPropStyles);
		    }
		
		    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
		    if (this.animationID == null) {
		      this.prevTime = _performanceNow2['default']();
		      this.startAnimationIfNecessary();
		    }
		  },
		
		  componentWillUnmount: function componentWillUnmount() {
		    if (this.animationID != null) {
		      _raf2['default'].cancel(this.animationID);
		      this.animationID = null;
		    }
		  },
		
		  render: function render() {
		    var renderedChildren = this.props.children(this.state.currentStyles);
		    return renderedChildren && _react2['default'].Children.only(renderedChildren);
		  }
		});
		
		exports['default'] = StaggeredMotion;
		module.exports = exports['default'];
	
	/***/ },
	/* 13 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		exports.__esModule = true;
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
		
		var _mapToZero = __webpack_require__(5);
		
		var _mapToZero2 = _interopRequireDefault(_mapToZero);
		
		var _stripStyle = __webpack_require__(6);
		
		var _stripStyle2 = _interopRequireDefault(_stripStyle);
		
		var _stepper3 = __webpack_require__(7);
		
		var _stepper4 = _interopRequireDefault(_stepper3);
		
		var _mergeDiff = __webpack_require__(14);
		
		var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
		
		var _performanceNow = __webpack_require__(8);
		
		var _performanceNow2 = _interopRequireDefault(_performanceNow);
		
		var _raf = __webpack_require__(10);
		
		var _raf2 = _interopRequireDefault(_raf);
		
		var _shouldStopAnimation = __webpack_require__(11);
		
		var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
		
		var _react = __webpack_require__(2);
		
		var _react2 = _interopRequireDefault(_react);
		
		var msPerFrame = 1000 / 60;
		
		// the children function & (potential) styles function asks as param an
		// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
		// {key: string, data?: any, style: PlainStyle}. However, the way we keep
		// internal states doesn't contain such a data structure (check the state and
		// TransitionMotionState). So when children function and others ask for such
		// data we need to generate them on the fly by combining mergedPropsStyles and
		// currentStyles/lastIdealStyles
		function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
		  if (unreadPropStyles == null) {
		    // $FlowFixMe
		    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
		      return {
		        key: mergedPropsStyle.key,
		        data: mergedPropsStyle.data,
		        style: plainStyles[i]
		      };
		    });
		  }
		  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
		    // $FlowFixMe
		    for (var j = 0; j < unreadPropStyles.length; j++) {
		      // $FlowFixMe
		      if (unreadPropStyles[j].key === mergedPropsStyle.key) {
		        return {
		          // $FlowFixMe
		          key: unreadPropStyles[j].key,
		          data: unreadPropStyles[j].data,
		          style: plainStyles[i]
		        };
		      }
		    }
		    // $FlowFixMe
		    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
		  });
		}
		
		function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
		  if (mergedPropsStyles.length !== destStyles.length) {
		    return false;
		  }
		
		  for (var i = 0; i < mergedPropsStyles.length; i++) {
		    if (mergedPropsStyles[i].key !== destStyles[i].key) {
		      return false;
		    }
		  }
		
		  // we have the invariant that mergedPropsStyles and
		  // currentStyles/currentVelocities/last* are synced in terms of cells, see
		  // mergeAndSync comment for more info
		  for (var i = 0; i < mergedPropsStyles.length; i++) {
		    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
		      return false;
		    }
		  }
		
		  return true;
		}
		
		// core key merging logic
		
		// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
		// c}, previous current (interpolating) style is {a, b}
		// **invariant**: current[i] corresponds to merged[i] in terms of key
		
		// steps:
		// turn merged style into {a?, b, c}
		//    add c, value of c is destStyles.c
		//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
		// turn current (interpolating) style from {a, b} into {a?, b, c}
		//    maybe remove a
		//    certainly add c, value of c is willEnter(c)
		// loop over merged and construct new current
		// dest doesn't change, that's owner's
		function mergeAndSync(willEnter, willLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
		  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
		    var leavingStyle = willLeave(oldMergedPropsStyle);
		    if (leavingStyle == null) {
		      return null;
		    }
		    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
		      return null;
		    }
		    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
		  });
		
		  var newCurrentStyles = [];
		  var newCurrentVelocities = [];
		  var newLastIdealStyles = [];
		  var newLastIdealVelocities = [];
		  for (var i = 0; i < newMergedPropsStyles.length; i++) {
		    var newMergedPropsStyleCell = newMergedPropsStyles[i];
		    var foundOldIndex = null;
		    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
		      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
		        foundOldIndex = j;
		        break;
		      }
		    }
		    // TODO: key search code
		    if (foundOldIndex == null) {
		      var plainStyle = willEnter(newMergedPropsStyleCell);
		      newCurrentStyles[i] = plainStyle;
		      newLastIdealStyles[i] = plainStyle;
		
		      // $FlowFixMe
		      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
		      newCurrentVelocities[i] = velocity;
		      newLastIdealVelocities[i] = velocity;
		    } else {
		      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
		      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
		      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
		      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
		    }
		  }
		
		  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
		}
		
		var TransitionMotion = _react2['default'].createClass({
		  displayName: 'TransitionMotion',
		
		  propTypes: {
		    defaultStyles: _react.PropTypes.arrayOf(_react.PropTypes.shape({
		      key: _react.PropTypes.string.isRequired,
		      data: _react.PropTypes.any,
		      style: _react.PropTypes.objectOf(_react.PropTypes.number).isRequired
		    })),
		    styles: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.arrayOf(_react.PropTypes.shape({
		      key: _react.PropTypes.string.isRequired,
		      data: _react.PropTypes.any,
		      style: _react.PropTypes.objectOf(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.object])).isRequired
		    }))]).isRequired,
		    children: _react.PropTypes.func.isRequired,
		    willLeave: _react.PropTypes.func,
		    willEnter: _react.PropTypes.func
		  },
		
		  getDefaultProps: function getDefaultProps() {
		    return {
		      willEnter: function willEnter(styleThatEntered) {
		        return _stripStyle2['default'](styleThatEntered.style);
		      },
		      // recall: returning null makes the current unmounting TransitionStyle
		      // disappear immediately
		      willLeave: function willLeave() {
		        return null;
		      }
		    };
		  },
		
		  getInitialState: function getInitialState() {
		    var _props = this.props;
		    var defaultStyles = _props.defaultStyles;
		    var styles = _props.styles;
		    var willEnter = _props.willEnter;
		    var willLeave = _props.willLeave;
		
		    var destStyles = typeof styles === 'function' ? styles() : styles;
		
		    // this is special. for the first time around, we don't have a comparison
		    // between last (no last) and current merged props. we'll compute last so:
		    // say default is {a, b} and styles (dest style) is {b, c}, we'll
		    // fabricate last as {a, b}
		    var oldMergedPropsStyles = undefined;
		    if (defaultStyles == null) {
		      oldMergedPropsStyles = destStyles;
		    } else {
		      // $FlowFixMe
		      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
		        // TODO: key search code
		        for (var i = 0; i < destStyles.length; i++) {
		          if (destStyles[i].key === defaultStyleCell.key) {
		            return destStyles[i];
		          }
		        }
		        return defaultStyleCell;
		      });
		    }
		    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
		      return _stripStyle2['default'](s.style);
		    }) : defaultStyles.map(function (s) {
		      return _stripStyle2['default'](s.style);
		    });
		    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
		      return _mapToZero2['default'](s.style);
		    }) : defaultStyles.map(function (s) {
		      return _mapToZero2['default'](s.style);
		    });
		
		    var _mergeAndSync = mergeAndSync(
		    // $FlowFixMe
		    willEnter,
		    // $FlowFixMe
		    willLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
		    oldCurrentVelocities);
		
		    var mergedPropsStyles = _mergeAndSync[0];
		    var currentStyles = _mergeAndSync[1];
		    var currentVelocities = _mergeAndSync[2];
		    var lastIdealStyles = _mergeAndSync[3];
		    var lastIdealVelocities = _mergeAndSync[4];
		    // oldLastIdealVelocities really
		
		    return {
		      currentStyles: currentStyles,
		      currentVelocities: currentVelocities,
		      lastIdealStyles: lastIdealStyles,
		      lastIdealVelocities: lastIdealVelocities,
		      mergedPropsStyles: mergedPropsStyles
		    };
		  },
		
		  animationID: null,
		  prevTime: 0,
		  accumulatedTime: 0,
		  // it's possible that currentStyle's value is stale: if props is immediately
		  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
		  // at 0 (didn't have time to tick and interpolate even once). If we naively
		  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
		  // In reality currentStyle should be 400
		  unreadPropStyles: null,
		  // after checking for unreadPropStyles != null, we manually go set the
		  // non-interpolating values (those that are a number, without a spring
		  // config)
		  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
		    var _mergeAndSync2 = mergeAndSync(
		    // $FlowFixMe
		    this.props.willEnter,
		    // $FlowFixMe
		    this.props.willLeave, this.state.mergedPropsStyles, unreadPropStyles, this.state.currentStyles, this.state.currentVelocities, this.state.lastIdealStyles, this.state.lastIdealVelocities);
		
		    var mergedPropsStyles = _mergeAndSync2[0];
		    var currentStyles = _mergeAndSync2[1];
		    var currentVelocities = _mergeAndSync2[2];
		    var lastIdealStyles = _mergeAndSync2[3];
		    var lastIdealVelocities = _mergeAndSync2[4];
		
		    for (var i = 0; i < unreadPropStyles.length; i++) {
		      var unreadPropStyle = unreadPropStyles[i].style;
		      var dirty = false;
		
		      for (var key in unreadPropStyle) {
		        if (!unreadPropStyle.hasOwnProperty(key)) {
		          continue;
		        }
		
		        var styleValue = unreadPropStyle[key];
		        if (typeof styleValue === 'number') {
		          if (!dirty) {
		            dirty = true;
		            currentStyles[i] = _extends({}, currentStyles[i]);
		            currentVelocities[i] = _extends({}, currentVelocities[i]);
		            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
		            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
		            mergedPropsStyles[i] = {
		              key: mergedPropsStyles[i].key,
		              data: mergedPropsStyles[i].data,
		              style: _extends({}, mergedPropsStyles[i].style)
		            };
		          }
		          currentStyles[i][key] = styleValue;
		          currentVelocities[i][key] = 0;
		          lastIdealStyles[i][key] = styleValue;
		          lastIdealVelocities[i][key] = 0;
		          mergedPropsStyles[i].style[key] = styleValue;
		        }
		      }
		    }
		
		    // unlike the other 2 components, we can't detect staleness and optionally
		    // opt out of setState here. each style object's data might contain new
		    // stuff we're not/cannot compare
		    this.setState({
		      currentStyles: currentStyles,
		      currentVelocities: currentVelocities,
		      mergedPropsStyles: mergedPropsStyles,
		      lastIdealStyles: lastIdealStyles,
		      lastIdealVelocities: lastIdealVelocities
		    });
		  },
		
		  startAnimationIfNecessary: function startAnimationIfNecessary() {
		    var _this = this;
		
		    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
		    // call cb? No, otherwise accidental parent rerender causes cb trigger
		    this.animationID = _raf2['default'](function () {
		      var propStyles = _this.props.styles;
		      var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
		
		      // check if we need to animate in the first place
		      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
		        // no need to cancel animationID here; shouldn't have any in flight
		        _this.animationID = null;
		        _this.accumulatedTime = 0;
		        return;
		      }
		
		      var currentTime = _performanceNow2['default']();
		      var timeDelta = currentTime - _this.prevTime;
		      _this.prevTime = currentTime;
		      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
		      // more than 10 frames? prolly switched browser tab. Restart
		      if (_this.accumulatedTime > msPerFrame * 10) {
		        _this.accumulatedTime = 0;
		      }
		
		      if (_this.accumulatedTime === 0) {
		        // no need to cancel animationID here; shouldn't have any in flight
		        _this.animationID = null;
		        _this.startAnimationIfNecessary();
		        return;
		      }
		
		      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
		      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
		
		      var _mergeAndSync3 = mergeAndSync(
		      // $FlowFixMe
		      _this.props.willEnter,
		      // $FlowFixMe
		      _this.props.willLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
		
		      var newMergedPropsStyles = _mergeAndSync3[0];
		      var newCurrentStyles = _mergeAndSync3[1];
		      var newCurrentVelocities = _mergeAndSync3[2];
		      var newLastIdealStyles = _mergeAndSync3[3];
		      var newLastIdealVelocities = _mergeAndSync3[4];
		
		      for (var i = 0; i < newMergedPropsStyles.length; i++) {
		        var newMergedPropsStyle = newMergedPropsStyles[i].style;
		        var newCurrentStyle = {};
		        var newCurrentVelocity = {};
		        var newLastIdealStyle = {};
		        var newLastIdealVelocity = {};
		
		        for (var key in newMergedPropsStyle) {
		          if (!newMergedPropsStyle.hasOwnProperty(key)) {
		            continue;
		          }
		
		          var styleValue = newMergedPropsStyle[key];
		          if (typeof styleValue === 'number') {
		            newCurrentStyle[key] = styleValue;
		            newCurrentVelocity[key] = 0;
		            newLastIdealStyle[key] = styleValue;
		            newLastIdealVelocity[key] = 0;
		          } else {
		            var newLastIdealStyleValue = newLastIdealStyles[i][key];
		            var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
		            for (var j = 0; j < framesToCatchUp; j++) {
		              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
		
		              newLastIdealStyleValue = _stepper[0];
		              newLastIdealVelocityValue = _stepper[1];
		            }
		
		            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
		
		            var nextIdealX = _stepper2[0];
		            var nextIdealV = _stepper2[1];
		
		            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
		            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
		            newLastIdealStyle[key] = newLastIdealStyleValue;
		            newLastIdealVelocity[key] = newLastIdealVelocityValue;
		          }
		        }
		
		        newLastIdealStyles[i] = newLastIdealStyle;
		        newLastIdealVelocities[i] = newLastIdealVelocity;
		        newCurrentStyles[i] = newCurrentStyle;
		        newCurrentVelocities[i] = newCurrentVelocity;
		      }
		
		      _this.animationID = null;
		      // the amount we're looped over above
		      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
		
		      _this.setState({
		        currentStyles: newCurrentStyles,
		        currentVelocities: newCurrentVelocities,
		        lastIdealStyles: newLastIdealStyles,
		        lastIdealVelocities: newLastIdealVelocities,
		        mergedPropsStyles: newMergedPropsStyles
		      });
		
		      _this.unreadPropStyles = null;
		
		      _this.startAnimationIfNecessary();
		    });
		  },
		
		  componentDidMount: function componentDidMount() {
		    this.prevTime = _performanceNow2['default']();
		    this.startAnimationIfNecessary();
		  },
		
		  componentWillReceiveProps: function componentWillReceiveProps(props) {
		    if (this.unreadPropStyles) {
		      // previous props haven't had the chance to be set yet; set them here
		      this.clearUnreadPropStyle(this.unreadPropStyles);
		    }
		
		    if (typeof props.styles === 'function') {
		      // $FlowFixMe
		      this.unreadPropStyles = props.styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
		    } else {
		      this.unreadPropStyles = props.styles;
		    }
		
		    if (this.animationID == null) {
		      this.prevTime = _performanceNow2['default']();
		      this.startAnimationIfNecessary();
		    }
		  },
		
		  componentWillUnmount: function componentWillUnmount() {
		    if (this.animationID != null) {
		      _raf2['default'].cancel(this.animationID);
		      this.animationID = null;
		    }
		  },
		
		  render: function render() {
		    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
		    var renderedChildren = this.props.children(hydratedStyles);
		    return renderedChildren && _react2['default'].Children.only(renderedChildren);
		  }
		});
		
		exports['default'] = TransitionMotion;
		module.exports = exports['default'];
		
		// list of styles, each containing interpolating values. Part of what's passed
		// to children function. Notice that this is
		// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
		// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
		// contains the key & data info (so that we only have a single source of truth
		// for these, and to save space). Check the comment for `rehydrateStyles` to
		// see how we regenerate the entirety of what's passed to children function
		
		// the array that keeps track of currently rendered stuff! Including stuff
		// that you've unmounted but that's still animating. This is where it lives
	
	/***/ },
	/* 14 */
	/***/ function(module, exports) {
	
		
		
		// core keys merging algorithm. If previous render's keys are [a, b], and the
		// next render's [c, b, d], what's the final merged keys and ordering?
		
		// - c and a must both be before b
		// - b before d
		// - ordering between a and c ambiguous
		
		// this reduces to merging two partially ordered lists (e.g. lists where not
		// every item has a definite ordering, like comparing a and c above). For the
		// ambiguous ordering we deterministically choose to place the next render's
		// item after the previous'; so c after a
		
		// this is called a topological sorting. Except the existing algorithms don't
		// work well with js bc of the amount of allocation, and isn't optimized for our
		// current use-case bc the runtime is linear in terms of edges (see wiki for
		// meaning), which is huge when two lists have many common elements
		'use strict';
		
		exports.__esModule = true;
		exports['default'] = mergeDiff;
		
		function mergeDiff(prev, next, onRemove) {
		  // bookkeeping for easier access of a key's index below. This is 2 allocations +
		  // potentially triggering chrome hash map mode for objs (so it might be faster
		
		  var prevKeyIndex = {};
		  for (var i = 0; i < prev.length; i++) {
		    prevKeyIndex[prev[i].key] = i;
		  }
		  var nextKeyIndex = {};
		  for (var i = 0; i < next.length; i++) {
		    nextKeyIndex[next[i].key] = i;
		  }
		
		  // first, an overly elaborate way of merging prev and next, eliminating
		  // duplicates (in terms of keys). If there's dupe, keep the item in next).
		  // This way of writing it saves allocations
		  var ret = [];
		  for (var i = 0; i < next.length; i++) {
		    ret[i] = next[i];
		  }
		  for (var i = 0; i < prev.length; i++) {
		    if (!nextKeyIndex.hasOwnProperty(prev[i].key)) {
		      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
		      // merge in keys that the user desires to kill
		      var fill = onRemove(i, prev[i]);
		      if (fill != null) {
		        ret.push(fill);
		      }
		    }
		  }
		
		  // now all the items all present. Core sorting logic to have the right order
		  return ret.sort(function (a, b) {
		    var nextOrderA = nextKeyIndex[a.key];
		    var nextOrderB = nextKeyIndex[b.key];
		    var prevOrderA = prevKeyIndex[a.key];
		    var prevOrderB = prevKeyIndex[b.key];
		
		    if (nextOrderA != null && nextOrderB != null) {
		      // both keys in next
		      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
		    } else if (prevOrderA != null && prevOrderB != null) {
		      // both keys in prev
		      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
		    } else if (nextOrderA != null) {
		      // key a in next, key b in prev
		
		      // how to determine the order between a and b? We find a "pivot" (term
		      // abuse), a key present in both prev and next, that is sandwiched between
		      // a and b. In the context of our above example, if we're comparing a and
		      // d, b's (the only) pivot
		      for (var i = 0; i < next.length; i++) {
		        var pivot = next[i].key;
		        if (!prevKeyIndex.hasOwnProperty(pivot)) {
		          continue;
		        }
		
		        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
		          return -1;
		        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
		          return 1;
		        }
		      }
		      // pluggable. default to: next bigger than prev
		      return 1;
		    }
		    // prevOrderA, nextOrderB
		    for (var i = 0; i < next.length; i++) {
		      var pivot = next[i].key;
		      if (!prevKeyIndex.hasOwnProperty(pivot)) {
		        continue;
		      }
		      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
		        return 1;
		      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
		        return -1;
		      }
		    }
		    // pluggable. default to: next bigger than prev
		    return -1;
		  });
		}
		
		module.exports = exports['default'];
		// to loop through and find a key's index each time), but I no longer care
	
	/***/ },
	/* 15 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		exports.__esModule = true;
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		exports['default'] = spring;
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
		
		var _presets = __webpack_require__(16);
		
		var _presets2 = _interopRequireDefault(_presets);
		
		var defaultConfig = _extends({}, _presets2['default'].noWobble, {
		  precision: 0.01
		});
		
		function spring(val, config) {
		  return _extends({}, defaultConfig, config, { val: val });
		}
		
		module.exports = exports['default'];
	
	/***/ },
	/* 16 */
	/***/ function(module, exports) {
	
		"use strict";
		
		exports.__esModule = true;
		exports["default"] = {
		  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
		  gentle: { stiffness: 120, damping: 14 },
		  wobbly: { stiffness: 180, damping: 12 },
		  stiff: { stiffness: 210, damping: 20 }
		};
		module.exports = exports["default"];
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
		
		exports.__esModule = true;
		exports['default'] = reorderKeys;
		
		var hasWarned = false;
		
		function reorderKeys() {
		  if (process.env.NODE_ENV === 'development') {
		    if (!hasWarned) {
		      hasWarned = true;
		      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
		    }
		  }
		}
		
		module.exports = exports['default'];
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))
	
	/***/ },
	/* 18 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = ensureSpring;
		
		var _reactMotion = __webpack_require__(3);
		
		function ensureSpring(styles) {
		  return Object.keys(styles).reduce(function (acc, key) {
		    var value = styles[key];
		    acc[key] = typeof value === 'number' ? (0, _reactMotion.spring)(value) : value;
		    return acc;
		  }, {});
		}
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _reactMotion = __webpack_require__(3);
		
		var fadeConfig = { stiffness: 200, damping: 22 };
		var popConfig = { stiffness: 360, damping: 25 };
		var slideConfig = { stiffness: 330, damping: 30 };
		
		var fade = {
		  atEnter: {
		    opacity: 0
		  },
		  atLeave: {
		    opacity: (0, _reactMotion.spring)(0, fadeConfig)
		  },
		  atActive: {
		    opacity: (0, _reactMotion.spring)(1, fadeConfig)
		  }
		};
		
		var pop = {
		  atEnter: {
		    scale: 0.8,
		    opacity: 0
		  },
		  atLeave: {
		    scale: (0, _reactMotion.spring)(0.8, popConfig),
		    opacity: (0, _reactMotion.spring)(0, popConfig)
		  },
		  atActive: {
		    scale: (0, _reactMotion.spring)(1, popConfig),
		    opacity: 1
		  },
		  mapStyles: function mapStyles(styles) {
		    return {
		      opacity: styles.opacity,
		      transform: 'scale(' + styles.scale + ')'
		    };
		  }
		};
		
		var slideLeft = {
		  atEnter: {
		    opacity: 0,
		    offset: 100
		  },
		  atLeave: {
		    opacity: (0, _reactMotion.spring)(0, fadeConfig),
		    offset: (0, _reactMotion.spring)(-100, slideConfig)
		  },
		  atActive: {
		    opacity: (0, _reactMotion.spring)(1, slideConfig),
		    offset: (0, _reactMotion.spring)(0, slideConfig)
		  },
		  mapStyles: function mapStyles(styles) {
		    return {
		      opacity: styles.opacity,
		      transform: 'translateX(' + styles.offset + '%)'
		    };
		  }
		};
		
		var slideRight = {
		  atEnter: {
		    opacity: 0,
		    offset: -100
		  },
		  atLeave: {
		    opacity: (0, _reactMotion.spring)(0, fadeConfig),
		    offset: (0, _reactMotion.spring)(100, slideConfig)
		  },
		  atActive: {
		    opacity: (0, _reactMotion.spring)(1, slideConfig),
		    offset: (0, _reactMotion.spring)(0, slideConfig)
		  },
		  mapStyles: function mapStyles(styles) {
		    return {
		      opacity: styles.opacity,
		      transform: 'translateX(' + styles.offset + '%)'
		    };
		  }
		};
		
		exports.default = { fade: fade, pop: pop, slideLeft: slideLeft, slideRight: slideRight };
	
	/***/ }
	/******/ ])
	});
	;
	//# sourceMappingURL=react-router-transition.map

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(182);
	
	var _ContextUtils = __webpack_require__(181);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    bool = _React$PropTypes.bool,
	    object = _React$PropTypes.object,
	    string = _React$PropTypes.string,
	    func = _React$PropTypes.func,
	    oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object, func]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 441 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(46);
	
	var _PatternUtils = __webpack_require__(81);
	
	var _InternalPropTypes = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    string = _React$PropTypes.string,
	    object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 443 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(242);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(241);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(638);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(447);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(82);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(856);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(853);
	
	var _isActive2 = __webpack_require__(860);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(857);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(862);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(242);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(241);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(483);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stripDiacritics = __webpack_require__(451);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function filterOptions(options, filterValue, excludeOptions, props) {
		var _this = this;
	
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2['default'])(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
			if (!filterValue) return true;
			var valueTest = String(option[props.valueKey]);
			var labelTest = String(option[props.labelKey]);
			if (props.ignoreAccents) {
				if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2['default'])(valueTest);
				if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2['default'])(labelTest);
			}
			if (props.ignoreCase) {
				if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
			return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	}
	
	module.exports = filterOptions;

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption;
		var instancePrefix = _ref.instancePrefix;
		var labelKey = _ref.labelKey;
		var onFocus = _ref.onFocus;
		var onSelect = _ref.onSelect;
		var optionClassName = _ref.optionClassName;
		var optionComponent = _ref.optionComponent;
		var optionRenderer = _ref.optionRenderer;
		var options = _ref.options;
		var valueArray = _ref.valueArray;
		var valueKey = _ref.valueKey;
		var onOptionRef = _ref.onOptionRef;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.indexOf(option) > -1;
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2['default'])(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2['default'].createElement(
				Option,
				{
					className: optionClass,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function (ref) {
						onOptionRef(ref, isFocused);
					}
				},
				optionRenderer(option, i)
			);
		});
	}
	
	module.exports = menuRenderer;

/***/ },
/* 451 */
/***/ function(module, exports) {

	'use strict';
	
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	module.exports = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(559), __esModule: true };

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(890);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(889);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _slider = _interopRequireDefault(__webpack_require__(901));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _slider["default"];
	exports["default"] = _default;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = __webpack_require__(1);
	
	var _events = __webpack_require__(904);
	
	var _find = _interopRequireDefault(__webpack_require__(905));
	
	var _getClosestTransformedParent = _interopRequireDefault(__webpack_require__(906));
	
	var _rect = __webpack_require__(907);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var buildTopStyles = function buildTopStyles(container, props) {
	  var bottomOffset = props.bottomOffset,
	      hideOnBoundaryHit = props.hideOnBoundaryHit;
	  var top = container.top,
	      height = container.height,
	      width = container.width,
	      boundaryBottom = container.boundaryBottom;
	
	  if (hideOnBoundaryHit || top + height + bottomOffset < boundaryBottom) {
	    return {
	      top: "".concat(top, "px"),
	      width: "".concat(width, "px"),
	      position: 'fixed'
	    };
	  }
	
	  return {
	    width: "".concat(width, "px"),
	    bottom: "".concat(bottomOffset, "px"),
	    position: 'absolute'
	  };
	};
	
	var buildBottomStyles = function buildBottomStyles(container, props) {
	  var bottomOffset = props.bottomOffset,
	      hideOnBoundaryHit = props.hideOnBoundaryHit;
	  var bottom = container.bottom,
	      height = container.height,
	      width = container.width,
	      boundaryTop = container.boundaryTop;
	
	  if (hideOnBoundaryHit || bottom - height - bottomOffset > boundaryTop) {
	    return {
	      width: "".concat(width, "px"),
	      top: "".concat(bottom - height, "px"),
	      position: 'fixed'
	    };
	  }
	
	  return {
	    width: "".concat(width, "px"),
	    top: "".concat(bottomOffset, "px"),
	    position: 'absolute'
	  };
	};
	
	var buildStickyStyle = function buildStickyStyle(mode, props, container) {
	  return (mode === 'top' ? buildTopStyles : buildBottomStyles)(container, props);
	};
	
	var isEqual = function isEqual(obj1, obj2) {
	  var styles1 = obj1.wrapperStyles;
	  var styles2 = obj2.wrapperStyles;
	
	  if (obj1.isFixed !== obj2.isFixed || obj1.height !== obj2.height || !styles1 && styles2 || styles1 && !styles2) {
	    return false;
	  }
	
	  if (!styles2) {
	    // we need this condition to make Flow happy
	    return true;
	  }
	
	  for (var field in styles1) {
	    if (styles1.hasOwnProperty(field) && styles1[field] !== styles2[field]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	var Sticky =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Sticky, _Component);
	
	  function Sticky() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Sticky);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Sticky)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "holderEl", null);
	
	    _defineProperty(_assertThisInitialized(_this), "wrapperEl", null);
	
	    _defineProperty(_assertThisInitialized(_this), "el", null);
	
	    _defineProperty(_assertThisInitialized(_this), "scrollEl", null);
	
	    _defineProperty(_assertThisInitialized(_this), "boundaryEl", null);
	
	    _defineProperty(_assertThisInitialized(_this), "disabled", false);
	
	    _defineProperty(_assertThisInitialized(_this), "checkPositionIntervalId", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "lastMinHeight", void 0);
	
	    _defineProperty(_assertThisInitialized(_this), "state", {
	      isFixed: false,
	      wrapperStyles: null,
	      holderStyles: null,
	      height: 0
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "holderRef", function (holderEl) {
	      if (holderEl === _this.holderEl) {
	        return;
	      }
	
	      _this.holderEl = holderEl;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "wrapperRef", function (wrapperEl) {
	      if (wrapperEl === _this.wrapperEl) {
	        return;
	      }
	
	      _this.wrapperEl = wrapperEl;
	
	      _this.updateScrollEl();
	
	      _this.updateBoundaryEl();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "checkPosition", function () {
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          holderEl = _assertThisInitialize.holderEl,
	          wrapperEl = _assertThisInitialize.wrapperEl,
	          boundaryEl = _assertThisInitialize.boundaryEl,
	          scrollEl = _assertThisInitialize.scrollEl,
	          disabled = _assertThisInitialize.disabled;
	
	      if (!scrollEl || !holderEl || !wrapperEl) {
	        console.error("Missing required elements:", {
	          scrollEl: scrollEl,
	          holderEl: holderEl,
	          wrapperEl: wrapperEl
	        });
	        return;
	      }
	
	      var _this$props = _this.props,
	          mode = _this$props.mode,
	          onFixedToggle = _this$props.onFixedToggle,
	          offsetTransforms = _this$props.offsetTransforms,
	          isIOSFixEnabled = _this$props.isIOSFixEnabled,
	          dontUpdateHolderHeightWhenSticky = _this$props.dontUpdateHolderHeightWhenSticky;
	
	      if (disabled) {
	        if (_this.state.isFixed) {
	          _this.setState({
	            isFixed: false
	          });
	        }
	
	        return;
	      }
	
	      if (!holderEl.getBoundingClientRect || !wrapperEl.getBoundingClientRect) {
	        return;
	      }
	
	      var holderRect = holderEl.getBoundingClientRect();
	      var wrapperRect = wrapperEl.getBoundingClientRect();
	      var boundaryRect = boundaryEl ? (0, _rect.getRect)(boundaryEl) : _rect.infiniteRect;
	      var scrollRect = (0, _rect.getRect)(scrollEl);
	
	      var isFixed = _this.isFixed(holderRect, wrapperRect, boundaryRect, scrollRect);
	
	      var offsets = null;
	
	      if (offsetTransforms && isFixed) {
	        var closestTransformedParent = (0, _getClosestTransformedParent.default)(scrollEl);
	
	        if (closestTransformedParent) {
	          offsets = (0, _rect.getRect)(closestTransformedParent);
	        }
	      }
	
	      var minHeight = _this.state.isFixed && dontUpdateHolderHeightWhenSticky && _this.lastMinHeight ? _this.lastMinHeight : wrapperRect.height;
	      _this.lastMinHeight = minHeight; // To ensure that this component becomes sticky immediately on mobile devices instead
	      // of disappearing until the scroll event completes, we add `transform: translateZ(0)`
	      // to 'kick' rendering of this element to the GPU
	      // @see http://stackoverflow.com/questions/32875046
	
	      var iosRenderingFixStyles = isIOSFixEnabled ? {
	        transform: 'translateZ(0)',
	        WebkitTransform: 'translateZ(0)'
	      } : null;
	      var newState = {
	        isFixed: isFixed,
	        height: wrapperRect.height,
	        holderStyles: {
	          minHeight: "".concat(minHeight, "px")
	        },
	        wrapperStyles: isFixed ? _objectSpread({}, iosRenderingFixStyles, {}, buildStickyStyle(mode, _this.props, {
	          boundaryTop: mode === 'bottom' ? boundaryRect.top : 0,
	          boundaryBottom: mode === 'top' ? boundaryRect.bottom : 0,
	          top: mode === 'top' ? scrollRect.top - (offsets ? offsets.top : 0) : 0,
	          bottom: mode === 'bottom' ? scrollRect.bottom - (offsets ? offsets.bottom : 0) : 0,
	          width: holderRect.width,
	          height: wrapperRect.height
	        })) : iosRenderingFixStyles
	      };
	
	      if (isFixed !== _this.state.isFixed && onFixedToggle && typeof onFixedToggle === 'function') {
	        onFixedToggle(isFixed);
	      }
	
	      if (!isEqual(_this.state, newState)) {
	        _this.setState(newState);
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(Sticky, [{
	    key: "isFixed",
	    value: function isFixed(holderRect, wrapperRect, boundaryRect, scrollRect) {
	      var _this$props2 = this.props,
	          hideOnBoundaryHit = _this$props2.hideOnBoundaryHit,
	          bottomOffset = _this$props2.bottomOffset,
	          topOffset = _this$props2.topOffset,
	          mode = _this$props2.mode;
	
	      if (this.disabled) {
	        return false;
	      }
	
	      if (boundaryRect && !(0, _rect.isIntersecting)(boundaryRect, scrollRect, topOffset, bottomOffset)) {
	        return false;
	      }
	
	      var hideOffset = hideOnBoundaryHit ? wrapperRect.height + bottomOffset : 0;
	
	      if (mode === 'top') {
	        return holderRect.top + topOffset < scrollRect.top && scrollRect.top + hideOffset <= boundaryRect.bottom;
	      }
	
	      return holderRect.bottom - topOffset > scrollRect.bottom && scrollRect.bottom - hideOffset >= boundaryRect.top;
	    }
	  }, {
	    key: "updateScrollEl",
	    value: function updateScrollEl() {
	      if (!this.wrapperEl) {
	        return;
	      }
	
	      if (this.scrollEl) {
	        (0, _events.unlisten)(this.scrollEl, ['scroll'], this.checkPosition);
	        this.scrollEl = null;
	      }
	
	      var scrollElement = this.props.scrollElement;
	
	      if (typeof scrollElement === 'string') {
	        this.scrollEl = (0, _find.default)(scrollElement, this.wrapperEl);
	      } else {
	        this.scrollEl = scrollElement;
	      }
	
	      if (this.scrollEl) {
	        (0, _events.listen)(this.scrollEl, ['scroll'], this.checkPosition);
	      } else {
	        console.error('Cannot find scrollElement ' + (typeof scrollElement === 'string' ? scrollElement : 'unknown'));
	      }
	    }
	  }, {
	    key: "updateBoundaryEl",
	    value: function updateBoundaryEl() {
	      if (!this.wrapperEl) {
	        return;
	      }
	
	      var boundaryElement = this.props.boundaryElement;
	      this.boundaryEl = (0, _find.default)(boundaryElement, this.wrapperEl);
	
	      if (this.boundaryEl === window || this.boundaryEl === document) {
	        // such objects can't be used as boundary
	        // and in fact there is no point in such a case
	        this.boundaryEl = null;
	      }
	    }
	  }, {
	    key: "initialize",
	    value: function initialize() {
	      var _this$props3 = this.props,
	          positionRecheckInterval = _this$props3.positionRecheckInterval,
	          disabled = _this$props3.disabled;
	      this.disabled = disabled; // we should always listen to window events because they will affect the layout of the whole page
	
	      (0, _events.listen)(window, ['scroll', 'resize', 'pageshow', 'load'], this.checkPosition);
	      this.checkPosition();
	
	      if (positionRecheckInterval) {
	        this.checkPositionIntervalId = setInterval(this.checkPosition, positionRecheckInterval);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_ref) {
	      var scrollElement = _ref.scrollElement,
	          boundaryElement = _ref.boundaryElement,
	          disabled = _ref.disabled;
	
	      if (scrollElement !== this.props.scrollElement) {
	        this.updateScrollEl();
	      }
	
	      if (boundaryElement !== this.props.boundaryElement) {
	        this.updateBoundaryEl();
	      }
	
	      if (disabled !== this.props.disabled) {
	        this.disabled = this.props.disabled;
	        this.checkPosition();
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.initialize();
	
	      if (this.wrapperEl === null) {
	        console.error("Wrapper element is missing, please make sure that you have assigned refs correctly");
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.scrollEl) {
	        (0, _events.unlisten)(this.scrollEl, ['scroll'], this.checkPosition);
	      }
	
	      (0, _events.unlisten)(window, ['scroll', 'resize', 'pageshow', 'load'], this.checkPosition);
	      this.boundaryEl = null;
	      this.scrollEl = null;
	      clearInterval(this.checkPositionIntervalId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var holderRef = this.holderRef,
	          wrapperRef = this.wrapperRef;
	      var _this$state = this.state,
	          isFixed = _this$state.isFixed,
	          wrapperStyles = _this$state.wrapperStyles,
	          holderStyles = _this$state.holderStyles;
	      return this.props.children({
	        holderRef: holderRef,
	        wrapperRef: wrapperRef,
	        isFixed: isFixed,
	        wrapperStyles: wrapperStyles,
	        holderStyles: holderStyles
	      });
	    }
	  }]);
	
	  return Sticky;
	}(_react.Component);
	
	_defineProperty(Sticky, "defaultProps", {
	  mode: 'top',
	  topOffset: 0,
	  bottomOffset: 0,
	  isIOSFixEnabled: true,
	  disabled: false,
	  onFixedToggle: null,
	  boundaryElement: null,
	  scrollElement: 'window',
	  dontUpdateHolderHeightWhenSticky: false
	});
	
	var _default = Sticky;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames2 = __webpack_require__(20);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(44);
	
	var _dissoc = __webpack_require__(697);
	
	var _dissoc2 = _interopRequireDefault(_dissoc);
	
	var _identifiers = __webpack_require__(61);
	
	var _events = __webpack_require__(458);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _prefixer = __webpack_require__(924);
	
	var _prefixer2 = _interopRequireDefault(_prefixer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var defaults = {
	  centered: false,
	  className: '',
	  multiple: true,
	  passthrough: true,
	  spread: 2,
	  theme: {}
	};
	
	var rippleFactory = function rippleFactory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var _defaults$options = _extends({}, defaults, options),
	      defaultCentered = _defaults$options.centered,
	      defaultClassName = _defaults$options.className,
	      defaultMultiple = _defaults$options.multiple,
	      defaultPassthrough = _defaults$options.passthrough,
	      defaultSpread = _defaults$options.spread,
	      defaultTheme = _defaults$options.theme,
	      props = _objectWithoutProperties(_defaults$options, ['centered', 'className', 'multiple', 'passthrough', 'spread', 'theme']);
	
	  return function (ComposedComponent) {
	    var RippledComponent = function (_Component) {
	      _inherits(RippledComponent, _Component);
	
	      function RippledComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, RippledComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RippledComponent.__proto__ || Object.getPrototypeOf(RippledComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	          ripples: {}
	        }, _this.rippleNodes = {}, _this.doRipple = function () {
	          return !_this.props.disabled && _this.props.ripple;
	        }, _this.handleMouseDown = function (event) {
	          if (_this.props.onMouseDown) _this.props.onMouseDown(event);
	          if (_this.doRipple()) {
	            var _events$getMousePosit = _events2.default.getMousePosition(event),
	                x = _events$getMousePosit.x,
	                y = _events$getMousePosit.y;
	
	            _this.animateRipple(x, y, false);
	          }
	        }, _this.handleTouchStart = function (event) {
	          if (_this.props.onTouchStart) _this.props.onTouchStart(event);
	          if (_this.doRipple()) {
	            var _events$getTouchPosit = _events2.default.getTouchPosition(event),
	                x = _events$getTouchPosit.x,
	                y = _events$getTouchPosit.y;
	
	            _this.animateRipple(x, y, true);
	          }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _createClass(RippledComponent, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	          // If a new ripple was just added, add a remove event listener to its animation
	          if (Object.keys(prevState.ripples).length < Object.keys(this.state.ripples).length) {
	            this.addRippleRemoveEventListener(this.getLastKey());
	          }
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          var _this2 = this;
	
	          // Remove document event listeners for ripple if they still exists
	          Object.keys(this.state.ripples).forEach(function (key) {
	            _this2.state.ripples[key].endRipple();
	          });
	        }
	
	        /**
	         * Find out a descriptor object for the ripple element being created depending on
	         * the position where the it was triggered and the component's dimensions.
	         *
	         * @param {Number} x Coordinate x in the viewport where ripple was triggered
	         * @param {Number} y Coordinate y in the viewport where ripple was triggered
	         * @return {Object} Descriptor element including position and size of the element
	         */
	
	      }, {
	        key: 'getDescriptor',
	        value: function getDescriptor(x, y) {
	          var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this).getBoundingClientRect(),
	              left = _ReactDOM$findDOMNode.left,
	              top = _ReactDOM$findDOMNode.top,
	              height = _ReactDOM$findDOMNode.height,
	              width = _ReactDOM$findDOMNode.width;
	
	          var _props = this.props,
	              centered = _props.rippleCentered,
	              spread = _props.rippleSpread;
	
	          return {
	            left: centered ? 0 : x - left - width / 2,
	            top: centered ? 0 : y - top - height / 2,
	            width: width * spread
	          };
	        }
	
	        /**
	         * Increments and internal counter and returns the next value as a string. It
	         * is used to assign key references to new ripple elements.
	         *
	         * @return {String} Key to be assigned to a ripple.
	         */
	
	      }, {
	        key: 'getNextKey',
	        value: function getNextKey() {
	          this.currentCount = this.currentCount ? this.currentCount + 1 : 1;
	          return 'ripple' + this.currentCount;
	        }
	
	        /**
	         * Return the last generated key for a ripple element. When there is only one ripple
	         * and to get the reference when a ripple was just created.
	         *
	         * @return {String} The last generated ripple key.
	         */
	
	      }, {
	        key: 'getLastKey',
	        value: function getLastKey() {
	          return 'ripple' + this.currentCount;
	        }
	
	        /**
	         * Variable to store the ripple references
	         */
	
	      }, {
	        key: 'rippleShouldTrigger',
	
	
	        /**
	         * Determine if a ripple should start depending if its a touch event. For mobile both
	         * touchStart and mouseDown are launched so in case is touch we should always trigger
	         * but if its not we should check if a touch was already triggered to decide.
	         *
	         * @param {Boolean} isTouch True in case a touch event triggered the ripple false otherwise.
	         * @return {Boolean} True in case the ripple should trigger or false if it shouldn't.
	         */
	        value: function rippleShouldTrigger(isTouch) {
	          var shouldStart = isTouch ? true : !this.touchCache;
	          this.touchCache = isTouch;
	          return shouldStart;
	        }
	
	        /**
	         * Start a ripple animation on an specific point with touch or mouse events. First
	         * decides if the animation should trigger. If the ripple is multiple or there is no
	         * ripple present, it creates a new key. If it's a simple ripple and already exists,
	         * it just restarts the current ripple. The animation happens in two state changes
	         * to allow triggering via css.
	         *
	         * @param {Number} x Coordinate X on the screen where animation should start
	         * @param {Number} y Coordinate Y on the screen where animation should start
	         * @param {Boolean} isTouch Use events from touch or mouse.
	         */
	
	      }, {
	        key: 'animateRipple',
	        value: function animateRipple(x, y, isTouch) {
	          var _this3 = this;
	
	          if (this.rippleShouldTrigger(isTouch)) {
	            var _getDescriptor = this.getDescriptor(x, y),
	                top = _getDescriptor.top,
	                left = _getDescriptor.left,
	                width = _getDescriptor.width;
	
	            var noRipplesActive = Object.keys(this.state.ripples).length === 0;
	            var key = this.props.rippleMultiple || noRipplesActive ? this.getNextKey() : this.getLastKey();
	            var endRipple = this.addRippleDeactivateEventListener(isTouch, key);
	            var initialState = { active: false, restarting: true, top: top, left: left, width: width, endRipple: endRipple };
	            var runningState = { active: true, restarting: false };
	            var ripples = _extends({}, this.state.ripples, _defineProperty({}, key, initialState));
	            this.setState({ ripples: ripples }, function () {
	              if (_this3.rippleNodes[key]) _this3.rippleNodes[key].offsetWidth; // eslint-disable-line
	              _this3.setState({ ripples: _extends({}, _this3.state.ripples, _defineProperty({}, key, Object.assign({}, _this3.state.ripples[key], runningState))) });
	            });
	          }
	        }
	
	        /**
	         * Add an event listener to the reference with given key so when the animation transition
	         * ends we can be sure that it finished and it can be safely removed from the state.
	         * This function is called whenever a new ripple is added to the component.
	         *
	         * @param {String} rippleKey Is the key of the ripple to add the event.
	         */
	
	      }, {
	        key: 'addRippleRemoveEventListener',
	        value: function addRippleRemoveEventListener(rippleKey) {
	          var self = this;
	          var rippleNode = this.rippleNodes[rippleKey];
	          _events2.default.addEventListenerOnTransitionEnded(rippleNode, function onOpacityEnd(e) {
	            if (e.propertyName === 'opacity') {
	              if (self.props.onRippleEnded) self.props.onRippleEnded(e);
	              _events2.default.removeEventListenerOnTransitionEnded(self.rippleNodes[rippleKey], onOpacityEnd);
	              // self.rippleNodes = dissoc(rippleKey, self.rippleNodes);
	              delete self.rippleNodes[rippleKey];
	              self.setState({ ripples: (0, _dissoc2.default)(rippleKey, self.state.ripples) });
	            }
	          });
	        }
	
	        /**
	         * Add an event listener to the document needed to deactivate a ripple and make it dissappear.
	         * Deactivation can happen with a touchend or mouseup depending on the trigger type. The
	         * ending function is created from a factory function and returned.
	         *
	         * @param {Boolean} isTouch True in case the trigger was a touch event false otherwise.
	         * @param {String} rippleKey It's a key to identify the ripple that should be deactivated.
	         * @return {Function} Callback function that deactivates the ripple and removes the listener
	         */
	
	      }, {
	        key: 'addRippleDeactivateEventListener',
	        value: function addRippleDeactivateEventListener(isTouch, rippleKey) {
	          var eventType = isTouch ? 'touchend' : 'mouseup';
	          var endRipple = this.createRippleDeactivateCallback(eventType, rippleKey);
	          document.addEventListener(eventType, endRipple);
	          return endRipple;
	        }
	
	        /**
	         * Generates a function that can be called to deactivate a ripple and remove its finishing
	         * event listener. If is generated because we need to store it to be called on unmount in case
	         * the ripple is still running.
	         *
	         * @param {String} eventType Is the event type that can be touchend or mouseup
	         * @param {String} rippleKey Is the key representing the ripple
	         * @return {Function} Callback function that deactivates the ripple and removes the listener
	         */
	
	      }, {
	        key: 'createRippleDeactivateCallback',
	        value: function createRippleDeactivateCallback(eventType, rippleKey) {
	          var self = this;
	          return function endRipple() {
	            document.removeEventListener(eventType, endRipple);
	            self.setState({ ripples: _extends({}, self.state.ripples, _defineProperty({}, rippleKey, Object.assign({}, self.state.ripples[rippleKey], { active: false }))) });
	          };
	        }
	      }, {
	        key: 'renderRipple',
	        value: function renderRipple(key, className, _ref2) {
	          var _classnames,
	              _this4 = this;
	
	          var active = _ref2.active,
	              left = _ref2.left,
	              restarting = _ref2.restarting,
	              top = _ref2.top,
	              width = _ref2.width;
	
	          var scale = restarting ? 0 : 1;
	          var transform = 'translate3d(' + (-width / 2 + left) + 'px, ' + (-width / 2 + top) + 'px, 0) scale(' + scale + ')';
	          var _className = (0, _classnames3.default)(this.props.theme.ripple, (_classnames = {}, _defineProperty(_classnames, this.props.theme.rippleActive, active), _defineProperty(_classnames, this.props.theme.rippleRestarting, restarting), _classnames), className);
	          return _react2.default.createElement(
	            'span',
	            _extends({ key: key, 'data-react-toolbox': 'ripple', className: this.props.theme.rippleWrapper }, props),
	            _react2.default.createElement('span', {
	              className: _className,
	              ref: function ref(node) {
	                if (node) _this4.rippleNodes[key] = node;
	              },
	              style: (0, _prefixer2.default)({ transform: transform }, { width: width, height: width })
	            })
	          );
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _this5 = this;
	
	          var _props2 = this.props,
	              children = _props2.children,
	              disabled = _props2.disabled,
	              ripple = _props2.ripple,
	              onRippleEnded = _props2.onRippleEnded,
	              rippleCentered = _props2.rippleCentered,
	              rippleClassName = _props2.rippleClassName,
	              rippleMultiple = _props2.rippleMultiple,
	              rippleSpread = _props2.rippleSpread,
	              theme = _props2.theme,
	              other = _objectWithoutProperties(_props2, ['children', 'disabled', 'ripple', 'onRippleEnded', 'rippleCentered', 'rippleClassName', 'rippleMultiple', 'rippleSpread', 'theme']);
	
	          var ripples = this.state.ripples;
	
	          var childRipples = Object.keys(ripples).map(function (key) {
	            return _this5.renderRipple(key, rippleClassName, ripples[key]);
	          });
	          var childProps = _extends({
	            onMouseDown: this.handleMouseDown,
	            onTouchStart: this.handleTouchStart
	          }, other);
	          var finalProps = defaultPassthrough ? _extends({}, childProps, { theme: theme, disabled: disabled }) : childProps;
	
	          return !ripple ? _react2.default.createElement(ComposedComponent, finalProps, children) : _react2.default.createElement(ComposedComponent, finalProps, [children, childRipples]);
	        }
	      }]);
	
	      return RippledComponent;
	    }(_react.Component);
	
	    RippledComponent.propTypes = {
	      children: _propTypes2.default.node,
	      disabled: _propTypes2.default.bool,
	      onMouseDown: _propTypes2.default.func,
	      onRippleEnded: _propTypes2.default.func,
	      onTouchStart: _propTypes2.default.func,
	      ripple: _propTypes2.default.bool,
	      rippleCentered: _propTypes2.default.bool,
	      rippleClassName: _propTypes2.default.string,
	      rippleMultiple: _propTypes2.default.bool,
	      rippleSpread: _propTypes2.default.number,
	      theme: _propTypes2.default.shape({
	        ripple: _propTypes2.default.string,
	        rippleActive: _propTypes2.default.string,
	        rippleRestarting: _propTypes2.default.string,
	        rippleWrapper: _propTypes2.default.string
	      })
	    };
	    RippledComponent.defaultProps = {
	      disabled: false,
	      ripple: true,
	      rippleCentered: defaultCentered,
	      rippleClassName: defaultClassName,
	      rippleMultiple: defaultMultiple,
	      rippleSpread: defaultSpread
	    };
	
	
	    return (0, _reactCssThemr.themr)(_identifiers.RIPPLE, defaultTheme)(RippledComponent);
	  };
	};
	
	exports.default = rippleFactory;

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(398);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getMousePosition: function getMousePosition(event) {
	    return {
	      x: event.pageX - (window.scrollX || window.pageXOffset),
	      y: event.pageY - (window.scrollY || window.pageYOffset)
	    };
	  },
	  getTouchPosition: function getTouchPosition(event) {
	    return {
	      x: event.touches[0].pageX - (window.scrollX || window.pageXOffset),
	      y: event.touches[0].pageY - (window.scrollY || window.pageYOffset)
	    };
	  },
	  pauseEvent: function pauseEvent(event) {
	    event.stopPropagation();
	    event.preventDefault();
	  },
	  addEventsToDocument: function addEventsToDocument(eventMap) {
	    Object.keys(eventMap).forEach(function (key) {
	      document.addEventListener(key, eventMap[key], false);
	    });
	  },
	  removeEventsFromDocument: function removeEventsFromDocument(eventMap) {
	    Object.keys(eventMap).forEach(function (key) {
	      document.removeEventListener(key, eventMap[key], false);
	    });
	  },
	  targetIsDescendant: function targetIsDescendant(event, parent) {
	    var node = event.target;
	    while (node !== null) {
	      if (node === parent) return true;
	      node = node.parentNode;
	    }
	    return false;
	  },
	  addEventListenerOnTransitionEnded: function addEventListenerOnTransitionEnded(element, fn) {
	    var eventName = transitionEventNamesFor(element);
	    if (!eventName) return false;
	    element.addEventListener(eventName, fn);
	    return true;
	  },
	  removeEventListenerOnTransitionEnded: function removeEventListenerOnTransitionEnded(element, fn) {
	    var eventName = transitionEventNamesFor(element);
	    if (!eventName) return false;
	    element.removeEventListener(eventName, fn);
	    return true;
	  }
	};
	
	
	var TRANSITIONS = {
	  transition: 'transitionend',
	  OTransition: 'oTransitionEnd',
	  MozTransition: 'transitionend',
	  WebkitTransition: 'webkitTransitionEnd'
	};
	
	function transitionEventNamesFor(element) {
	  return (0, _keys2.default)(TRANSITIONS).reduce(function (result, transition) {
	    return !result && element && element.style[transition] !== undefined ? TRANSITIONS[transition] : result;
	  }, null);
	}

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(87);
	
	var ReactCurrentOwner = __webpack_require__(38);
	
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(14);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 461 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 464 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-env node */
	'use strict';
	
	// SDP helpers.
	var SDPUtils = {};
	
	// Generate an alphanumeric identifier for cname or mids.
	// TODO: use UUIDs instead? https://gist.github.com/jed/982883
	SDPUtils.generateIdentifier = function() {
	  return Math.random().toString(36).substr(2, 10);
	};
	
	// The RTCP CNAME used by all peerconnections from the same JS.
	SDPUtils.localCName = SDPUtils.generateIdentifier();
	
	// Splits SDP into lines, dealing with both CRLF and LF.
	SDPUtils.splitLines = function(blob) {
	  return blob.trim().split('\n').map(function(line) {
	    return line.trim();
	  });
	};
	// Splits SDP into sessionpart and mediasections. Ensures CRLF.
	SDPUtils.splitSections = function(blob) {
	  var parts = blob.split('\nm=');
	  return parts.map(function(part, index) {
	    return (index > 0 ? 'm=' + part : part).trim() + '\r\n';
	  });
	};
	
	// returns the session description.
	SDPUtils.getDescription = function(blob) {
	  var sections = SDPUtils.splitSections(blob);
	  return sections && sections[0];
	};
	
	// returns the individual media sections.
	SDPUtils.getMediaSections = function(blob) {
	  var sections = SDPUtils.splitSections(blob);
	  sections.shift();
	  return sections;
	};
	
	// Returns lines that start with a certain prefix.
	SDPUtils.matchPrefix = function(blob, prefix) {
	  return SDPUtils.splitLines(blob).filter(function(line) {
	    return line.indexOf(prefix) === 0;
	  });
	};
	
	// Parses an ICE candidate line. Sample input:
	// candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
	// rport 55996"
	SDPUtils.parseCandidate = function(line) {
	  var parts;
	  // Parse both variants.
	  if (line.indexOf('a=candidate:') === 0) {
	    parts = line.substring(12).split(' ');
	  } else {
	    parts = line.substring(10).split(' ');
	  }
	
	  var candidate = {
	    foundation: parts[0],
	    component: parseInt(parts[1], 10),
	    protocol: parts[2].toLowerCase(),
	    priority: parseInt(parts[3], 10),
	    ip: parts[4],
	    address: parts[4], // address is an alias for ip.
	    port: parseInt(parts[5], 10),
	    // skip parts[6] == 'typ'
	    type: parts[7]
	  };
	
	  for (var i = 8; i < parts.length; i += 2) {
	    switch (parts[i]) {
	      case 'raddr':
	        candidate.relatedAddress = parts[i + 1];
	        break;
	      case 'rport':
	        candidate.relatedPort = parseInt(parts[i + 1], 10);
	        break;
	      case 'tcptype':
	        candidate.tcpType = parts[i + 1];
	        break;
	      case 'ufrag':
	        candidate.ufrag = parts[i + 1]; // for backward compability.
	        candidate.usernameFragment = parts[i + 1];
	        break;
	      default: // extension handling, in particular ufrag
	        candidate[parts[i]] = parts[i + 1];
	        break;
	    }
	  }
	  return candidate;
	};
	
	// Translates a candidate object into SDP candidate attribute.
	SDPUtils.writeCandidate = function(candidate) {
	  var sdp = [];
	  sdp.push(candidate.foundation);
	  sdp.push(candidate.component);
	  sdp.push(candidate.protocol.toUpperCase());
	  sdp.push(candidate.priority);
	  sdp.push(candidate.address || candidate.ip);
	  sdp.push(candidate.port);
	
	  var type = candidate.type;
	  sdp.push('typ');
	  sdp.push(type);
	  if (type !== 'host' && candidate.relatedAddress &&
	      candidate.relatedPort) {
	    sdp.push('raddr');
	    sdp.push(candidate.relatedAddress);
	    sdp.push('rport');
	    sdp.push(candidate.relatedPort);
	  }
	  if (candidate.tcpType && candidate.protocol.toLowerCase() === 'tcp') {
	    sdp.push('tcptype');
	    sdp.push(candidate.tcpType);
	  }
	  if (candidate.usernameFragment || candidate.ufrag) {
	    sdp.push('ufrag');
	    sdp.push(candidate.usernameFragment || candidate.ufrag);
	  }
	  return 'candidate:' + sdp.join(' ');
	};
	
	// Parses an ice-options line, returns an array of option tags.
	// a=ice-options:foo bar
	SDPUtils.parseIceOptions = function(line) {
	  return line.substr(14).split(' ');
	};
	
	// Parses an rtpmap line, returns RTCRtpCoddecParameters. Sample input:
	// a=rtpmap:111 opus/48000/2
	SDPUtils.parseRtpMap = function(line) {
	  var parts = line.substr(9).split(' ');
	  var parsed = {
	    payloadType: parseInt(parts.shift(), 10) // was: id
	  };
	
	  parts = parts[0].split('/');
	
	  parsed.name = parts[0];
	  parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
	  parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
	  // legacy alias, got renamed back to channels in ORTC.
	  parsed.numChannels = parsed.channels;
	  return parsed;
	};
	
	// Generate an a=rtpmap line from RTCRtpCodecCapability or
	// RTCRtpCodecParameters.
	SDPUtils.writeRtpMap = function(codec) {
	  var pt = codec.payloadType;
	  if (codec.preferredPayloadType !== undefined) {
	    pt = codec.preferredPayloadType;
	  }
	  var channels = codec.channels || codec.numChannels || 1;
	  return 'a=rtpmap:' + pt + ' ' + codec.name + '/' + codec.clockRate +
	      (channels !== 1 ? '/' + channels : '') + '\r\n';
	};
	
	// Parses an a=extmap line (headerextension from RFC 5285). Sample input:
	// a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
	// a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
	SDPUtils.parseExtmap = function(line) {
	  var parts = line.substr(9).split(' ');
	  return {
	    id: parseInt(parts[0], 10),
	    direction: parts[0].indexOf('/') > 0 ? parts[0].split('/')[1] : 'sendrecv',
	    uri: parts[1]
	  };
	};
	
	// Generates a=extmap line from RTCRtpHeaderExtensionParameters or
	// RTCRtpHeaderExtension.
	SDPUtils.writeExtmap = function(headerExtension) {
	  return 'a=extmap:' + (headerExtension.id || headerExtension.preferredId) +
	      (headerExtension.direction && headerExtension.direction !== 'sendrecv'
	        ? '/' + headerExtension.direction
	        : '') +
	      ' ' + headerExtension.uri + '\r\n';
	};
	
	// Parses an ftmp line, returns dictionary. Sample input:
	// a=fmtp:96 vbr=on;cng=on
	// Also deals with vbr=on; cng=on
	SDPUtils.parseFmtp = function(line) {
	  var parsed = {};
	  var kv;
	  var parts = line.substr(line.indexOf(' ') + 1).split(';');
	  for (var j = 0; j < parts.length; j++) {
	    kv = parts[j].trim().split('=');
	    parsed[kv[0].trim()] = kv[1];
	  }
	  return parsed;
	};
	
	// Generates an a=ftmp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
	SDPUtils.writeFmtp = function(codec) {
	  var line = '';
	  var pt = codec.payloadType;
	  if (codec.preferredPayloadType !== undefined) {
	    pt = codec.preferredPayloadType;
	  }
	  if (codec.parameters && Object.keys(codec.parameters).length) {
	    var params = [];
	    Object.keys(codec.parameters).forEach(function(param) {
	      if (codec.parameters[param]) {
	        params.push(param + '=' + codec.parameters[param]);
	      } else {
	        params.push(param);
	      }
	    });
	    line += 'a=fmtp:' + pt + ' ' + params.join(';') + '\r\n';
	  }
	  return line;
	};
	
	// Parses an rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
	// a=rtcp-fb:98 nack rpsi
	SDPUtils.parseRtcpFb = function(line) {
	  var parts = line.substr(line.indexOf(' ') + 1).split(' ');
	  return {
	    type: parts.shift(),
	    parameter: parts.join(' ')
	  };
	};
	// Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
	SDPUtils.writeRtcpFb = function(codec) {
	  var lines = '';
	  var pt = codec.payloadType;
	  if (codec.preferredPayloadType !== undefined) {
	    pt = codec.preferredPayloadType;
	  }
	  if (codec.rtcpFeedback && codec.rtcpFeedback.length) {
	    // FIXME: special handling for trr-int?
	    codec.rtcpFeedback.forEach(function(fb) {
	      lines += 'a=rtcp-fb:' + pt + ' ' + fb.type +
	      (fb.parameter && fb.parameter.length ? ' ' + fb.parameter : '') +
	          '\r\n';
	    });
	  }
	  return lines;
	};
	
	// Parses an RFC 5576 ssrc media attribute. Sample input:
	// a=ssrc:3735928559 cname:something
	SDPUtils.parseSsrcMedia = function(line) {
	  var sp = line.indexOf(' ');
	  var parts = {
	    ssrc: parseInt(line.substr(7, sp - 7), 10)
	  };
	  var colon = line.indexOf(':', sp);
	  if (colon > -1) {
	    parts.attribute = line.substr(sp + 1, colon - sp - 1);
	    parts.value = line.substr(colon + 1);
	  } else {
	    parts.attribute = line.substr(sp + 1);
	  }
	  return parts;
	};
	
	SDPUtils.parseSsrcGroup = function(line) {
	  var parts = line.substr(13).split(' ');
	  return {
	    semantics: parts.shift(),
	    ssrcs: parts.map(function(ssrc) {
	      return parseInt(ssrc, 10);
	    })
	  };
	};
	
	// Extracts the MID (RFC 5888) from a media section.
	// returns the MID or undefined if no mid line was found.
	SDPUtils.getMid = function(mediaSection) {
	  var mid = SDPUtils.matchPrefix(mediaSection, 'a=mid:')[0];
	  if (mid) {
	    return mid.substr(6);
	  }
	};
	
	SDPUtils.parseFingerprint = function(line) {
	  var parts = line.substr(14).split(' ');
	  return {
	    algorithm: parts[0].toLowerCase(), // algorithm is case-sensitive in Edge.
	    value: parts[1]
	  };
	};
	
	// Extracts DTLS parameters from SDP media section or sessionpart.
	// FIXME: for consistency with other functions this should only
	//   get the fingerprint line as input. See also getIceParameters.
	SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
	  var lines = SDPUtils.matchPrefix(mediaSection + sessionpart,
	    'a=fingerprint:');
	  // Note: a=setup line is ignored since we use the 'auto' role.
	  // Note2: 'algorithm' is not case sensitive except in Edge.
	  return {
	    role: 'auto',
	    fingerprints: lines.map(SDPUtils.parseFingerprint)
	  };
	};
	
	// Serializes DTLS parameters to SDP.
	SDPUtils.writeDtlsParameters = function(params, setupType) {
	  var sdp = 'a=setup:' + setupType + '\r\n';
	  params.fingerprints.forEach(function(fp) {
	    sdp += 'a=fingerprint:' + fp.algorithm + ' ' + fp.value + '\r\n';
	  });
	  return sdp;
	};
	
	// Parses a=crypto lines into
	//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members
	SDPUtils.parseCryptoLine = function(line) {
	  var parts = line.substr(9).split(' ');
	  return {
	    tag: parseInt(parts[0], 10),
	    cryptoSuite: parts[1],
	    keyParams: parts[2],
	    sessionParams: parts.slice(3),
	  };
	};
	
	SDPUtils.writeCryptoLine = function(parameters) {
	  return 'a=crypto:' + parameters.tag + ' ' +
	    parameters.cryptoSuite + ' ' +
	    (typeof parameters.keyParams === 'object'
	      ? SDPUtils.writeCryptoKeyParams(parameters.keyParams)
	      : parameters.keyParams) +
	    (parameters.sessionParams ? ' ' + parameters.sessionParams.join(' ') : '') +
	    '\r\n';
	};
	
	// Parses the crypto key parameters into
	//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*
	SDPUtils.parseCryptoKeyParams = function(keyParams) {
	  if (keyParams.indexOf('inline:') !== 0) {
	    return null;
	  }
	  var parts = keyParams.substr(7).split('|');
	  return {
	    keyMethod: 'inline',
	    keySalt: parts[0],
	    lifeTime: parts[1],
	    mkiValue: parts[2] ? parts[2].split(':')[0] : undefined,
	    mkiLength: parts[2] ? parts[2].split(':')[1] : undefined,
	  };
	};
	
	SDPUtils.writeCryptoKeyParams = function(keyParams) {
	  return keyParams.keyMethod + ':'
	    + keyParams.keySalt +
	    (keyParams.lifeTime ? '|' + keyParams.lifeTime : '') +
	    (keyParams.mkiValue && keyParams.mkiLength
	      ? '|' + keyParams.mkiValue + ':' + keyParams.mkiLength
	      : '');
	};
	
	// Extracts all SDES paramters.
	SDPUtils.getCryptoParameters = function(mediaSection, sessionpart) {
	  var lines = SDPUtils.matchPrefix(mediaSection + sessionpart,
	    'a=crypto:');
	  return lines.map(SDPUtils.parseCryptoLine);
	};
	
	// Parses ICE information from SDP media section or sessionpart.
	// FIXME: for consistency with other functions this should only
	//   get the ice-ufrag and ice-pwd lines as input.
	SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
	  var ufrag = SDPUtils.matchPrefix(mediaSection + sessionpart,
	    'a=ice-ufrag:')[0];
	  var pwd = SDPUtils.matchPrefix(mediaSection + sessionpart,
	    'a=ice-pwd:')[0];
	  if (!(ufrag && pwd)) {
	    return null;
	  }
	  return {
	    usernameFragment: ufrag.substr(12),
	    password: pwd.substr(10),
	  };
	};
	
	// Serializes ICE parameters to SDP.
	SDPUtils.writeIceParameters = function(params) {
	  return 'a=ice-ufrag:' + params.usernameFragment + '\r\n' +
	      'a=ice-pwd:' + params.password + '\r\n';
	};
	
	// Parses the SDP media section and returns RTCRtpParameters.
	SDPUtils.parseRtpParameters = function(mediaSection) {
	  var description = {
	    codecs: [],
	    headerExtensions: [],
	    fecMechanisms: [],
	    rtcp: []
	  };
	  var lines = SDPUtils.splitLines(mediaSection);
	  var mline = lines[0].split(' ');
	  for (var i = 3; i < mline.length; i++) { // find all codecs from mline[3..]
	    var pt = mline[i];
	    var rtpmapline = SDPUtils.matchPrefix(
	      mediaSection, 'a=rtpmap:' + pt + ' ')[0];
	    if (rtpmapline) {
	      var codec = SDPUtils.parseRtpMap(rtpmapline);
	      var fmtps = SDPUtils.matchPrefix(
	        mediaSection, 'a=fmtp:' + pt + ' ');
	      // Only the first a=fmtp:<pt> is considered.
	      codec.parameters = fmtps.length ? SDPUtils.parseFmtp(fmtps[0]) : {};
	      codec.rtcpFeedback = SDPUtils.matchPrefix(
	        mediaSection, 'a=rtcp-fb:' + pt + ' ')
	        .map(SDPUtils.parseRtcpFb);
	      description.codecs.push(codec);
	      // parse FEC mechanisms from rtpmap lines.
	      switch (codec.name.toUpperCase()) {
	        case 'RED':
	        case 'ULPFEC':
	          description.fecMechanisms.push(codec.name.toUpperCase());
	          break;
	        default: // only RED and ULPFEC are recognized as FEC mechanisms.
	          break;
	      }
	    }
	  }
	  SDPUtils.matchPrefix(mediaSection, 'a=extmap:').forEach(function(line) {
	    description.headerExtensions.push(SDPUtils.parseExtmap(line));
	  });
	  // FIXME: parse rtcp.
	  return description;
	};
	
	// Generates parts of the SDP media section describing the capabilities /
	// parameters.
	SDPUtils.writeRtpDescription = function(kind, caps) {
	  var sdp = '';
	
	  // Build the mline.
	  sdp += 'm=' + kind + ' ';
	  sdp += caps.codecs.length > 0 ? '9' : '0'; // reject if no codecs.
	  sdp += ' UDP/TLS/RTP/SAVPF ';
	  sdp += caps.codecs.map(function(codec) {
	    if (codec.preferredPayloadType !== undefined) {
	      return codec.preferredPayloadType;
	    }
	    return codec.payloadType;
	  }).join(' ') + '\r\n';
	
	  sdp += 'c=IN IP4 0.0.0.0\r\n';
	  sdp += 'a=rtcp:9 IN IP4 0.0.0.0\r\n';
	
	  // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
	  caps.codecs.forEach(function(codec) {
	    sdp += SDPUtils.writeRtpMap(codec);
	    sdp += SDPUtils.writeFmtp(codec);
	    sdp += SDPUtils.writeRtcpFb(codec);
	  });
	  var maxptime = 0;
	  caps.codecs.forEach(function(codec) {
	    if (codec.maxptime > maxptime) {
	      maxptime = codec.maxptime;
	    }
	  });
	  if (maxptime > 0) {
	    sdp += 'a=maxptime:' + maxptime + '\r\n';
	  }
	  sdp += 'a=rtcp-mux\r\n';
	
	  if (caps.headerExtensions) {
	    caps.headerExtensions.forEach(function(extension) {
	      sdp += SDPUtils.writeExtmap(extension);
	    });
	  }
	  // FIXME: write fecMechanisms.
	  return sdp;
	};
	
	// Parses the SDP media section and returns an array of
	// RTCRtpEncodingParameters.
	SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
	  var encodingParameters = [];
	  var description = SDPUtils.parseRtpParameters(mediaSection);
	  var hasRed = description.fecMechanisms.indexOf('RED') !== -1;
	  var hasUlpfec = description.fecMechanisms.indexOf('ULPFEC') !== -1;
	
	  // filter a=ssrc:... cname:, ignore PlanB-msid
	  var ssrcs = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
	    .map(function(line) {
	      return SDPUtils.parseSsrcMedia(line);
	    })
	    .filter(function(parts) {
	      return parts.attribute === 'cname';
	    });
	  var primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
	  var secondarySsrc;
	
	  var flows = SDPUtils.matchPrefix(mediaSection, 'a=ssrc-group:FID')
	    .map(function(line) {
	      var parts = line.substr(17).split(' ');
	      return parts.map(function(part) {
	        return parseInt(part, 10);
	      });
	    });
	  if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) {
	    secondarySsrc = flows[0][1];
	  }
	
	  description.codecs.forEach(function(codec) {
	    if (codec.name.toUpperCase() === 'RTX' && codec.parameters.apt) {
	      var encParam = {
	        ssrc: primarySsrc,
	        codecPayloadType: parseInt(codec.parameters.apt, 10)
	      };
	      if (primarySsrc && secondarySsrc) {
	        encParam.rtx = {ssrc: secondarySsrc};
	      }
	      encodingParameters.push(encParam);
	      if (hasRed) {
	        encParam = JSON.parse(JSON.stringify(encParam));
	        encParam.fec = {
	          ssrc: primarySsrc,
	          mechanism: hasUlpfec ? 'red+ulpfec' : 'red'
	        };
	        encodingParameters.push(encParam);
	      }
	    }
	  });
	  if (encodingParameters.length === 0 && primarySsrc) {
	    encodingParameters.push({
	      ssrc: primarySsrc
	    });
	  }
	
	  // we support both b=AS and b=TIAS but interpret AS as TIAS.
	  var bandwidth = SDPUtils.matchPrefix(mediaSection, 'b=');
	  if (bandwidth.length) {
	    if (bandwidth[0].indexOf('b=TIAS:') === 0) {
	      bandwidth = parseInt(bandwidth[0].substr(7), 10);
	    } else if (bandwidth[0].indexOf('b=AS:') === 0) {
	      // use formula from JSEP to convert b=AS to TIAS value.
	      bandwidth = parseInt(bandwidth[0].substr(5), 10) * 1000 * 0.95
	          - (50 * 40 * 8);
	    } else {
	      bandwidth = undefined;
	    }
	    encodingParameters.forEach(function(params) {
	      params.maxBitrate = bandwidth;
	    });
	  }
	  return encodingParameters;
	};
	
	// parses http://draft.ortc.org/#rtcrtcpparameters*
	SDPUtils.parseRtcpParameters = function(mediaSection) {
	  var rtcpParameters = {};
	
	  // Gets the first SSRC. Note tha with RTX there might be multiple
	  // SSRCs.
	  var remoteSsrc = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
	    .map(function(line) {
	      return SDPUtils.parseSsrcMedia(line);
	    })
	    .filter(function(obj) {
	      return obj.attribute === 'cname';
	    })[0];
	  if (remoteSsrc) {
	    rtcpParameters.cname = remoteSsrc.value;
	    rtcpParameters.ssrc = remoteSsrc.ssrc;
	  }
	
	  // Edge uses the compound attribute instead of reducedSize
	  // compound is !reducedSize
	  var rsize = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-rsize');
	  rtcpParameters.reducedSize = rsize.length > 0;
	  rtcpParameters.compound = rsize.length === 0;
	
	  // parses the rtcp-mux attrіbute.
	  // Note that Edge does not support unmuxed RTCP.
	  var mux = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-mux');
	  rtcpParameters.mux = mux.length > 0;
	
	  return rtcpParameters;
	};
	
	// parses either a=msid: or a=ssrc:... msid lines and returns
	// the id of the MediaStream and MediaStreamTrack.
	SDPUtils.parseMsid = function(mediaSection) {
	  var parts;
	  var spec = SDPUtils.matchPrefix(mediaSection, 'a=msid:');
	  if (spec.length === 1) {
	    parts = spec[0].substr(7).split(' ');
	    return {stream: parts[0], track: parts[1]};
	  }
	  var planB = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
	    .map(function(line) {
	      return SDPUtils.parseSsrcMedia(line);
	    })
	    .filter(function(msidParts) {
	      return msidParts.attribute === 'msid';
	    });
	  if (planB.length > 0) {
	    parts = planB[0].value.split(' ');
	    return {stream: parts[0], track: parts[1]};
	  }
	};
	
	// SCTP
	// parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
	// to draft-ietf-mmusic-sctp-sdp-05
	SDPUtils.parseSctpDescription = function(mediaSection) {
	  var mline = SDPUtils.parseMLine(mediaSection);
	  var maxSizeLine = SDPUtils.matchPrefix(mediaSection, 'a=max-message-size:');
	  var maxMessageSize;
	  if (maxSizeLine.length > 0) {
	    maxMessageSize = parseInt(maxSizeLine[0].substr(19), 10);
	  }
	  if (isNaN(maxMessageSize)) {
	    maxMessageSize = 65536;
	  }
	  var sctpPort = SDPUtils.matchPrefix(mediaSection, 'a=sctp-port:');
	  if (sctpPort.length > 0) {
	    return {
	      port: parseInt(sctpPort[0].substr(12), 10),
	      protocol: mline.fmt,
	      maxMessageSize: maxMessageSize
	    };
	  }
	  var sctpMapLines = SDPUtils.matchPrefix(mediaSection, 'a=sctpmap:');
	  if (sctpMapLines.length > 0) {
	    var parts = SDPUtils.matchPrefix(mediaSection, 'a=sctpmap:')[0]
	      .substr(10)
	      .split(' ');
	    return {
	      port: parseInt(parts[0], 10),
	      protocol: parts[1],
	      maxMessageSize: maxMessageSize
	    };
	  }
	};
	
	// SCTP
	// outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
	// support by now receiving in this format, unless we originally parsed
	// as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
	// protocol of DTLS/SCTP -- without UDP/ or TCP/)
	SDPUtils.writeSctpDescription = function(media, sctp) {
	  var output = [];
	  if (media.protocol !== 'DTLS/SCTP') {
	    output = [
	      'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.protocol + '\r\n',
	      'c=IN IP4 0.0.0.0\r\n',
	      'a=sctp-port:' + sctp.port + '\r\n'
	    ];
	  } else {
	    output = [
	      'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.port + '\r\n',
	      'c=IN IP4 0.0.0.0\r\n',
	      'a=sctpmap:' + sctp.port + ' ' + sctp.protocol + ' 65535\r\n'
	    ];
	  }
	  if (sctp.maxMessageSize !== undefined) {
	    output.push('a=max-message-size:' + sctp.maxMessageSize + '\r\n');
	  }
	  return output.join('');
	};
	
	// Generate a session ID for SDP.
	// https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
	// recommends using a cryptographically random +ve 64-bit value
	// but right now this should be acceptable and within the right range
	SDPUtils.generateSessionId = function() {
	  return Math.random().toString().substr(2, 21);
	};
	
	// Write boilder plate for start of SDP
	// sessId argument is optional - if not supplied it will
	// be generated randomly
	// sessVersion is optional and defaults to 2
	// sessUser is optional and defaults to 'thisisadapterortc'
	SDPUtils.writeSessionBoilerplate = function(sessId, sessVer, sessUser) {
	  var sessionId;
	  var version = sessVer !== undefined ? sessVer : 2;
	  if (sessId) {
	    sessionId = sessId;
	  } else {
	    sessionId = SDPUtils.generateSessionId();
	  }
	  var user = sessUser || 'thisisadapterortc';
	  // FIXME: sess-id should be an NTP timestamp.
	  return 'v=0\r\n' +
	      'o=' + user + ' ' + sessionId + ' ' + version +
	        ' IN IP4 127.0.0.1\r\n' +
	      's=-\r\n' +
	      't=0 0\r\n';
	};
	
	SDPUtils.writeMediaSection = function(transceiver, caps, type, stream) {
	  var sdp = SDPUtils.writeRtpDescription(transceiver.kind, caps);
	
	  // Map ICE parameters (ufrag, pwd) to SDP.
	  sdp += SDPUtils.writeIceParameters(
	    transceiver.iceGatherer.getLocalParameters());
	
	  // Map DTLS parameters to SDP.
	  sdp += SDPUtils.writeDtlsParameters(
	    transceiver.dtlsTransport.getLocalParameters(),
	    type === 'offer' ? 'actpass' : 'active');
	
	  sdp += 'a=mid:' + transceiver.mid + '\r\n';
	
	  if (transceiver.direction) {
	    sdp += 'a=' + transceiver.direction + '\r\n';
	  } else if (transceiver.rtpSender && transceiver.rtpReceiver) {
	    sdp += 'a=sendrecv\r\n';
	  } else if (transceiver.rtpSender) {
	    sdp += 'a=sendonly\r\n';
	  } else if (transceiver.rtpReceiver) {
	    sdp += 'a=recvonly\r\n';
	  } else {
	    sdp += 'a=inactive\r\n';
	  }
	
	  if (transceiver.rtpSender) {
	    // spec.
	    var msid = 'msid:' + stream.id + ' ' +
	        transceiver.rtpSender.track.id + '\r\n';
	    sdp += 'a=' + msid;
	
	    // for Chrome.
	    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
	        ' ' + msid;
	    if (transceiver.sendEncodingParameters[0].rtx) {
	      sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
	          ' ' + msid;
	      sdp += 'a=ssrc-group:FID ' +
	          transceiver.sendEncodingParameters[0].ssrc + ' ' +
	          transceiver.sendEncodingParameters[0].rtx.ssrc +
	          '\r\n';
	    }
	  }
	  // FIXME: this should be written by writeRtpDescription.
	  sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
	      ' cname:' + SDPUtils.localCName + '\r\n';
	  if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) {
	    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
	        ' cname:' + SDPUtils.localCName + '\r\n';
	  }
	  return sdp;
	};
	
	// Gets the direction from the mediaSection or the sessionpart.
	SDPUtils.getDirection = function(mediaSection, sessionpart) {
	  // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
	  var lines = SDPUtils.splitLines(mediaSection);
	  for (var i = 0; i < lines.length; i++) {
	    switch (lines[i]) {
	      case 'a=sendrecv':
	      case 'a=sendonly':
	      case 'a=recvonly':
	      case 'a=inactive':
	        return lines[i].substr(2);
	      default:
	        // FIXME: What should happen here?
	    }
	  }
	  if (sessionpart) {
	    return SDPUtils.getDirection(sessionpart);
	  }
	  return 'sendrecv';
	};
	
	SDPUtils.getKind = function(mediaSection) {
	  var lines = SDPUtils.splitLines(mediaSection);
	  var mline = lines[0].split(' ');
	  return mline[0].substr(2);
	};
	
	SDPUtils.isRejected = function(mediaSection) {
	  return mediaSection.split(' ', 2)[1] === '0';
	};
	
	SDPUtils.parseMLine = function(mediaSection) {
	  var lines = SDPUtils.splitLines(mediaSection);
	  var parts = lines[0].substr(2).split(' ');
	  return {
	    kind: parts[0],
	    port: parseInt(parts[1], 10),
	    protocol: parts[2],
	    fmt: parts.slice(3).join(' ')
	  };
	};
	
	SDPUtils.parseOLine = function(mediaSection) {
	  var line = SDPUtils.matchPrefix(mediaSection, 'o=')[0];
	  var parts = line.substr(2).split(' ');
	  return {
	    username: parts[0],
	    sessionId: parts[1],
	    sessionVersion: parseInt(parts[2], 10),
	    netType: parts[3],
	    addressType: parts[4],
	    address: parts[5]
	  };
	};
	
	// a very naive interpretation of a valid SDP.
	SDPUtils.isValidSDP = function(blob) {
	  if (typeof blob !== 'string' || blob.length === 0) {
	    return false;
	  }
	  var lines = SDPUtils.splitLines(blob);
	  for (var i = 0; i < lines.length; i++) {
	    if (lines[i].length < 2 || lines[i].charAt(1) !== '=') {
	      return false;
	    }
	    // TODO: check the modifier a bit more.
	  }
	  return true;
	};
	
	// Expose public methods.
	if (true) {
	  module.exports = SDPUtils;
	}


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = blacklist;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function blacklist(str, chars) {
	  (0, _assertString.default)(str);
	  return str.replace(new RegExp("[".concat(chars, "]+"), 'g'), '');
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isByteLength;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	/* eslint-disable prefer-rest-params */
	function isByteLength(str, options) {
	  (0, _assertString.default)(str);
	  var min;
	  var max;
	
	  if (_typeof(options) === 'object') {
	    min = options.min || 0;
	    max = options.max;
	  } else {
	    // backwards compatibility: isByteLength(str, min [, max])
	    min = arguments[1];
	    max = arguments[2];
	  }
	
	  var len = encodeURI(str).split(/%..|./).length - 1;
	  return len >= min && (typeof max === 'undefined' || len <= max);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFullWidth;
	exports.fullWidth = void 0;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
	exports.fullWidth = fullWidth;
	
	function isFullWidth(str) {
	  (0, _assertString.default)(str);
	  return fullWidth.test(str);
	}

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHalfWidth;
	exports.halfWidth = void 0;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
	exports.halfWidth = halfWidth;
	
	function isHalfWidth(str) {
	  (0, _assertString.default)(str);
	  return halfWidth.test(str);
	}

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHexadecimal;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hexadecimal = /^[0-9A-F]+$/i;
	
	function isHexadecimal(str) {
	  (0, _assertString.default)(str);
	  return hexadecimal.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isInt;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
	var intLeadingZeroes = /^[-+]?[0-9]+$/;
	
	function isInt(str, options) {
	  (0, _assertString.default)(str);
	  options = options || {}; // Get the regex to use for testing, based on whether
	  // leading zeroes are allowed or not.
	
	  var regex = options.hasOwnProperty('allow_leading_zeroes') && !options.allow_leading_zeroes ? int : intLeadingZeroes; // Check min/max/lt/gt
	
	  var minCheckPassed = !options.hasOwnProperty('min') || str >= options.min;
	  var maxCheckPassed = !options.hasOwnProperty('max') || str <= options.max;
	  var ltCheckPassed = !options.hasOwnProperty('lt') || str < options.lt;
	  var gtCheckPassed = !options.hasOwnProperty('gt') || str > options.gt;
	  return regex.test(str) && minCheckPassed && maxCheckPassed && ltCheckPassed && gtCheckPassed;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ltrim;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ltrim(str, chars) {
	  (0, _assertString.default)(str); // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
	
	  var pattern = chars ? new RegExp("^[".concat(chars.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "]+"), 'g') : /^\s+/g;
	  return str.replace(pattern, '');
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rtrim;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rtrim(str, chars) {
	  (0, _assertString.default)(str); // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
	
	  var pattern = chars ? new RegExp("[".concat(chars.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "]+$"), 'g') : /\s+$/g;
	  return str.replace(pattern, '');
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toFloat;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toFloat(str) {
	  (0, _assertString.default)(str);
	  return parseFloat(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 475 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toString;
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function toString(input) {
	  if (_typeof(input) === 'object' && input !== null) {
	    if (typeof input.toString === 'function') {
	      input = input.toString();
	    } else {
	      input = '[object Object]';
	    }
	  } else if (input === null || typeof input === 'undefined' || isNaN(input) && !input.length) {
	    input = '';
	  }
	
	  return String(input);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 476 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 477 */
/***/ function(module, exports) {

	/**
	 * @ignore
	 * base event object for custom and dom event.
	 * @author yiminghe@gmail.com
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function returnFalse() {
	  return false;
	}
	
	function returnTrue() {
	  return true;
	}
	
	function EventBaseObject() {
	  this.timeStamp = Date.now();
	  this.target = undefined;
	  this.currentTarget = undefined;
	}
	
	EventBaseObject.prototype = {
	  isEventObject: 1,
	
	  constructor: EventBaseObject,
	
	  isDefaultPrevented: returnFalse,
	
	  isPropagationStopped: returnFalse,
	
	  isImmediatePropagationStopped: returnFalse,
	
	  preventDefault: function preventDefault() {
	    this.isDefaultPrevented = returnTrue;
	  },
	
	  stopPropagation: function stopPropagation() {
	    this.isPropagationStopped = returnTrue;
	  },
	
	  stopImmediatePropagation: function stopImmediatePropagation() {
	    this.isImmediatePropagationStopped = returnTrue;
	    // fixed 1.2
	    // call stopPropagation implicitly
	    this.stopPropagation();
	  },
	
	  halt: function halt(immediate) {
	    if (immediate) {
	      this.stopImmediatePropagation();
	    } else {
	      this.stopPropagation();
	    }
	    this.preventDefault();
	  }
	};
	
	exports["default"] = EventBaseObject;
	module.exports = exports["default"];

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ignore
	 * event object for dom
	 * @author yiminghe@gmail.com
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _EventBaseObject = __webpack_require__(477);
	
	var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);
	
	var _objectAssign = __webpack_require__(18);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var TRUE = true;
	var FALSE = false;
	var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];
	
	function isNullOrUndefined(w) {
	  return w === null || w === undefined;
	}
	
	var eventNormalizers = [{
	  reg: /^key/,
	  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
	  fix: function fix(event, nativeEvent) {
	    if (isNullOrUndefined(event.which)) {
	      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
	    }
	
	    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
	    if (event.metaKey === undefined) {
	      event.metaKey = event.ctrlKey;
	    }
	  }
	}, {
	  reg: /^touch/,
	  props: ['touches', 'changedTouches', 'targetTouches']
	}, {
	  reg: /^hashchange$/,
	  props: ['newURL', 'oldURL']
	}, {
	  reg: /^gesturechange$/i,
	  props: ['rotation', 'scale']
	}, {
	  reg: /^(mousewheel|DOMMouseScroll)$/,
	  props: [],
	  fix: function fix(event, nativeEvent) {
	    var deltaX = undefined;
	    var deltaY = undefined;
	    var delta = undefined;
	    var wheelDelta = nativeEvent.wheelDelta;
	    var axis = nativeEvent.axis;
	    var wheelDeltaY = nativeEvent.wheelDeltaY;
	    var wheelDeltaX = nativeEvent.wheelDeltaX;
	    var detail = nativeEvent.detail;
	
	    // ie/webkit
	    if (wheelDelta) {
	      delta = wheelDelta / 120;
	    }
	
	    // gecko
	    if (detail) {
	      // press control e.detail == 1 else e.detail == 3
	      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
	    }
	
	    // Gecko
	    if (axis !== undefined) {
	      if (axis === event.HORIZONTAL_AXIS) {
	        deltaY = 0;
	        deltaX = 0 - delta;
	      } else if (axis === event.VERTICAL_AXIS) {
	        deltaX = 0;
	        deltaY = delta;
	      }
	    }
	
	    // Webkit
	    if (wheelDeltaY !== undefined) {
	      deltaY = wheelDeltaY / 120;
	    }
	    if (wheelDeltaX !== undefined) {
	      deltaX = -1 * wheelDeltaX / 120;
	    }
	
	    // 默认 deltaY (ie)
	    if (!deltaX && !deltaY) {
	      deltaY = delta;
	    }
	
	    if (deltaX !== undefined) {
	      /**
	       * deltaX of mousewheel event
	       * @property deltaX
	       * @member Event.DomEvent.Object
	       */
	      event.deltaX = deltaX;
	    }
	
	    if (deltaY !== undefined) {
	      /**
	       * deltaY of mousewheel event
	       * @property deltaY
	       * @member Event.DomEvent.Object
	       */
	      event.deltaY = deltaY;
	    }
	
	    if (delta !== undefined) {
	      /**
	       * delta of mousewheel event
	       * @property delta
	       * @member Event.DomEvent.Object
	       */
	      event.delta = delta;
	    }
	  }
	}, {
	  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
	  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
	  fix: function fix(event, nativeEvent) {
	    var eventDoc = undefined;
	    var doc = undefined;
	    var body = undefined;
	    var target = event.target;
	    var button = nativeEvent.button;
	
	    // Calculate pageX/Y if missing and clientX/Y available
	    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
	      eventDoc = target.ownerDocument || document;
	      doc = eventDoc.documentElement;
	      body = eventDoc.body;
	      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	    }
	
	    // which for click: 1 === left; 2 === middle; 3 === right
	    // do not use button
	    if (!event.which && button !== undefined) {
	      if (button & 1) {
	        event.which = 1;
	      } else if (button & 2) {
	        event.which = 3;
	      } else if (button & 4) {
	        event.which = 2;
	      } else {
	        event.which = 0;
	      }
	    }
	
	    // add relatedTarget, if necessary
	    if (!event.relatedTarget && event.fromElement) {
	      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
	    }
	
	    return event;
	  }
	}];
	
	function retTrue() {
	  return TRUE;
	}
	
	function retFalse() {
	  return FALSE;
	}
	
	function DomEventObject(nativeEvent) {
	  var type = nativeEvent.type;
	
	  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';
	
	  _EventBaseObject2['default'].call(this);
	
	  this.nativeEvent = nativeEvent;
	
	  // in case dom event has been mark as default prevented by lower dom node
	  var isDefaultPrevented = retFalse;
	  if ('defaultPrevented' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
	  } else if ('getPreventDefault' in nativeEvent) {
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
	    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
	  } else if ('returnValue' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
	  }
	
	  this.isDefaultPrevented = isDefaultPrevented;
	
	  var fixFns = [];
	  var fixFn = undefined;
	  var l = undefined;
	  var prop = undefined;
	  var props = commonProps.concat();
	
	  eventNormalizers.forEach(function (normalizer) {
	    if (type.match(normalizer.reg)) {
	      props = props.concat(normalizer.props);
	      if (normalizer.fix) {
	        fixFns.push(normalizer.fix);
	      }
	    }
	  });
	
	  l = props.length;
	
	  // clone properties of the original event object
	  while (l) {
	    prop = props[--l];
	    this[prop] = nativeEvent[prop];
	  }
	
	  // fix target property, if necessary
	  if (!this.target && isNative) {
	    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
	  }
	
	  // check if target is a text node (safari)
	  if (this.target && this.target.nodeType === 3) {
	    this.target = this.target.parentNode;
	  }
	
	  l = fixFns.length;
	
	  while (l) {
	    fixFn = fixFns[--l];
	    fixFn(this, nativeEvent);
	  }
	
	  this.timeStamp = nativeEvent.timeStamp || Date.now();
	}
	
	var EventBaseObjectProto = _EventBaseObject2['default'].prototype;
	
	(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
	  constructor: DomEventObject,
	
	  preventDefault: function preventDefault() {
	    var e = this.nativeEvent;
	
	    // if preventDefault exists run it on the original event
	    if (e.preventDefault) {
	      e.preventDefault();
	    } else {
	      // otherwise set the returnValue property of the original event to FALSE (IE)
	      e.returnValue = FALSE;
	    }
	
	    EventBaseObjectProto.preventDefault.call(this);
	  },
	
	  stopPropagation: function stopPropagation() {
	    var e = this.nativeEvent;
	
	    // if stopPropagation exists run it on the original event
	    if (e.stopPropagation) {
	      e.stopPropagation();
	    } else {
	      // otherwise set the cancelBubble property of the original event to TRUE (IE)
	      e.cancelBubble = TRUE;
	    }
	
	    EventBaseObjectProto.stopPropagation.call(this);
	  }
	});
	
	exports['default'] = DomEventObject;
	module.exports = exports['default'];

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = addEventListener;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _EventObject = __webpack_require__(478);
	
	var _EventObject2 = _interopRequireDefault(_EventObject);
	
	function addEventListener(target, eventType, callback, option) {
	  function wrapCallback(e) {
	    var ne = new _EventObject2['default'](e);
	    callback.call(target, ne);
	  }
	
	  if (target.addEventListener) {
	    var _ret = (function () {
	      var useCapture = false;
	      if (typeof option === 'object') {
	        useCapture = option.capture || false;
	      } else if (typeof option === 'boolean') {
	        useCapture = option;
	      }
	
	      target.addEventListener(eventType, wrapCallback, option || false);
	
	      return {
	        v: {
	          remove: function remove() {
	            target.removeEventListener(eventType, wrapCallback, useCapture);
	          }
	        }
	      };
	    })();
	
	    if (typeof _ret === 'object') return _ret.v;
	  } else if (target.attachEvent) {
	    target.attachEvent('on' + eventType, wrapCallback);
	    return {
	      remove: function remove() {
	        target.detachEvent('on' + eventType, wrapCallback);
	      }
	    };
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 480 */
/***/ function(module, exports) {

	/* The following list is defined in React's core */
	var IS_UNITLESS = {
	  animationIterationCount: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  stopOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	module.exports = function(name, value) {
	  if(typeof value === 'number' && !IS_UNITLESS[ name ]) {
	    return value + 'px';
	  } else {
	    return value;
	  }
	};

/***/ },
/* 481 */
/***/ function(module, exports) {

	"use strict";
	
	function noop() {
	  return null;
	}
	
	noop.isRequired = noop;
	
	function noopThunk() {
	  return noop;
	}
	
	module.exports = {
	  and: noopThunk,
	  between: noopThunk,
	  booleanSome: noopThunk,
	  childrenHavePropXorChildren: noopThunk,
	  childrenOf: noopThunk,
	  childrenOfType: noopThunk,
	  childrenSequenceOf: noopThunk,
	  componentWithName: noopThunk,
	  disallowedIf: noopThunk,
	  elementType: noopThunk,
	  empty: noopThunk,
	  explicitNull: noopThunk,
	  forbidExtraProps: Object,
	  integer: noopThunk,
	  keysOf: noopThunk,
	  mutuallyExclusiveProps: noopThunk,
	  mutuallyExclusiveTrueProps: noopThunk,
	  nChildren: noopThunk,
	  nonNegativeInteger: noop,
	  nonNegativeNumber: noopThunk,
	  numericString: noopThunk,
	  object: noopThunk,
	  or: noopThunk,
	  predicate: noopThunk,
	  range: noopThunk,
	  ref: noopThunk,
	  requiredBy: noopThunk,
	  restrictedProp: noopThunk,
	  sequenceOf: noopThunk,
	  shape: noopThunk,
	  stringEndsWith: noopThunk,
	  stringStartsWith: noopThunk,
	  uniqueArray: noopThunk,
	  uniqueArrayOf: noopThunk,
	  valuesOf: noopThunk,
	  withShape: noopThunk
	};
	//# sourceMappingURL=index.js.map

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =  true ? __webpack_require__(481) : require('./build');
	
	//# sourceMappingURL=index.js.map

/***/ },
/* 483 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var objectAssign = __webpack_require__(684)();
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	// NB: The URL to the CommonJS spec is kept just for tradition.
	//     node-assert has evolved a lot since then, both in API and behavior.
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(961);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	// Expose a strict only variant of assert
	function strict(value, message) {
	  if (!value) fail(value, true, message, '==', strict);
	}
	assert.strict = objectAssign(strict, assert, {
	  equal: assert.strictEqual,
	  deepEqual: assert.deepStrictEqual,
	  notEqual: assert.notStrictEqual,
	  notDeepEqual: assert.notDeepStrictEqual
	});
	assert.strict.strict = assert.strict;
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	var bind = __webpack_require__(201);
	var Axios = __webpack_require__(487);
	var mergeConfig = __webpack_require__(199);
	var defaults = __webpack_require__(200);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(mergeConfig(axios.defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(196);
	axios.CancelToken = __webpack_require__(486);
	axios.isCancel = __webpack_require__(197);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(501);
	
	// Expose isAxiosError
	axios.isAxiosError = __webpack_require__(497);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(196);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	var buildURL = __webpack_require__(202);
	var InterceptorManager = __webpack_require__(488);
	var dispatchRequest = __webpack_require__(490);
	var mergeConfig = __webpack_require__(199);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = arguments[1] || {};
	    config.url = arguments[0];
	  } else {
	    config = config || {};
	  }
	
	  config = mergeConfig(this.defaults, config);
	
	  // Set config.method
	  if (config.method) {
	    config.method = config.method.toLowerCase();
	  } else if (this.defaults.method) {
	    config.method = this.defaults.method.toLowerCase();
	  } else {
	    config.method = 'get';
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	Axios.prototype.getUri = function getUri(config) {
	  config = mergeConfig(this.defaults, config);
	  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: (config || {}).data
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isAbsoluteURL = __webpack_require__(496);
	var combineURLs = __webpack_require__(494);
	
	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */
	module.exports = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }
	  return requestedURL;
	};


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	var transformData = __webpack_require__(493);
	var isCancel = __webpack_require__(197);
	var defaults = __webpack_require__(200);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 491 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	
	  error.request = request;
	  error.response = response;
	  error.isAxiosError = true;
	
	  error.toJSON = function toJSON() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code
	    };
	  };
	  return error;
	};


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(198);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 494 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));
	
	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }
	
	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }
	
	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }
	
	          if (secure === true) {
	            cookie.push('secure');
	          }
	
	          document.cookie = cookie.join('; ');
	        },
	
	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },
	
	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);


/***/ },
/* 496 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 497 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the payload is an error thrown by Axios
	 *
	 * @param {*} payload The value to test
	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	 */
	module.exports = function isAxiosError(payload) {
	  return (typeof payload === 'object') && (payload.isAxiosError === true);
	};


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;
	
	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;
	
	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }
	
	        urlParsingNode.setAttribute('href', href);
	
	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }
	
	      originURL = resolveURL(window.location.href);
	
	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 501 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(9);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var Loading = __webpack_require__(17);
	var config = __webpack_require__(7);
	var lang = __webpack_require__(12);
	var APIURL = config.path.apiUrl;
	var APPID = config.ids.appId;
	
	var helper = __webpack_require__(13);
	
	/* Load meta tags */
	var meta = {
		title: lang.activation_meta_title,
		description: lang.activation_meta_title,
		meta: {
			name: {
				keywords: lang.activation_meta_title
			}
		}
	};
	
	var Activation = function (_React$Component) {
		_inherits(Activation, _React$Component);
	
		function Activation() {
			_classCallCheck(this, Activation);
	
			return _possibleConstructorReturn(this, (Activation.__proto__ || Object.getPrototypeOf(Activation)).apply(this, arguments));
		}
	
		_createClass(Activation, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
	
				/* add class */
				helper.addBodyClass();
			}
			/* Account activation */
	
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				(0, _withTracker.loadAnalytics)();
				var qs = __webpack_require__(3);
				var activationId = this.props.params.activationId;
	
				/* for account activation - start */
				if (typeof activationId !== 'undefined' && activationId !== "") {
					// return false;
					var postObject = {
						"app_id": APPID,
						"key": activationId
					};
					_axios2.default.post(APIURL + "customer/activation", qs.stringify(postObject)).then(function (response) {
	
						/* Success response */
						if (response.data.status === "ok") {
							var errorMsg = response.data.message;
							helper.showInfo(errorMsg);
							_reactRouter.hashHistory.push("/sign-in");
						}
	
						/* Success response */
						if (response.data.status === "error") {
	
							var errorMsg = response.data.message;
							helper.showInfo(errorMsg);
							_reactRouter.hashHistory.push("/sign-in");
						}
						/* error reponse */
					});
				}
				/* for account activation - end  */
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_reactDocumentMeta2.default, meta),
					_react2.default.createElement(
						'div',
						{ className: 'chk_popup act_loder', id: 'PayProcess', style: { position: 'unset' } },
						_react2.default.createElement(
							'div',
							{ className: 'white-outer center-block process_order' },
							_react2.default.createElement(
								'div',
								{ className: 'row ' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 padd2' },
									_react2.default.createElement(
										'h4',
										null,
										lang.activation_meta_title
									),
									_react2.default.createElement(
										'div',
										{ className: 'clock_part' },
										_react2.default.createElement('img', { src: '/img/spinner.gif', alt: '' }),
										_react2.default.createElement('br', null)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return Activation;
	}(_react2.default.Component);
	
	exports.default = Activation;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(9);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var config = __webpack_require__(7);
	var lang = __webpack_require__(12);
	var APIURL = config.path.apiUrl;
	var APPID = config.ids.appId;
	var strp = __webpack_require__(31);
	
	var helper = __webpack_require__(13);
	
	/* Load meta tags */
	var meta = {
		title: lang.addons_meta_title + lang.site_title_with_separator,
		description: lang.addons_meta_title,
		meta: {
			name: {
				keywords: lang.addons_meta_title
			}
		}
	};
	
	var Addons = function (_React$Component) {
		_inherits(Addons, _React$Component);
	
		function Addons(props) {
			_classCallCheck(this, Addons);
	
			var _this = _possibleConstructorReturn(this, (Addons.__proto__ || Object.getPrototypeOf(Addons)).call(this, props));
	
			_this.state = { products: [], products_common: [], status: 'Loading' };
	
			/*add class */
			helper.addBodyClass();
			return _this;
		}
	
		_createClass(Addons, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				_axios2.default.get(APIURL + 'productsver2/products_list?status=A&app_id=' + APPID + "&availability=" + _reactCookie2.default.load('defaultAvilablityId') + "&apply_addon=Yes").then(function (res) {
					_this2.setState({ status: res.data.status });
					if (res.data.status === "ok") {
						_this2.setState({ status: res.data.status });
						_this2.setState({ products_common: res.data.common });
						_this2.setState({ products: res.data.result_set });
					} else {
						_this2.setState({ status: res.data.status });
					}
				});
	
				(0, _withTracker.loadAnalytics)();
			}
		}, {
			key: 'handleChange',
			value: function handleChange(event) {
				var query = document.getElementById("searchInput").value;
	
				this.setState({ searchText: query });
			}
	
			/* load product Image*/
	
		}, {
			key: '__productImage',
			value: function __productImage(product_thumbnail, imagePath) {
				return product_thumbnail === "" ? "/img/no-images/productthump-no-image.jpg" : this.state.products_common.image_source + "/" + product_thumbnail;
			}
	
			/* imnage class */
	
		}, {
			key: 'productClass',
			value: function productClass(product_thumbnail) {
				return product_thumbnail !== "" ? "col-lg-7 col-md-7 col-sm-7 col-xs-7" : "col-md-12";
			}
	
			/* image content */
	
		}, {
			key: 'productImagecontent',
			value: function productImagecontent(product_slug, product_thumbnail) {
				if (product_thumbnail !== "") {
					var image = config.path.tinThumpUrl + this.state.products_common.image_source + "/" + product_thumbnail + "&w=288&h=144&q=80";
					return _react2.default.createElement(
						'div',
						{ className: 'col-lg-5 col-md-5 col-sm-5 col-xs-5 thumb-img-div' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: "/product/" + product_slug },
							'  ',
							_react2.default.createElement('img', { src: image, alt: '', width: '100%' }),
							' '
						)
					);
				}
			}
	
			/* this function used to load  products */
	
		}, {
			key: 'showProducts',
			value: function showProducts() {
				var _this3 = this;
	
				return this.state.products.map(function (product, index) {
					return function () {
						if (typeof _this3.state.searchText !== 'undefined') {
							if (product.product_name.toLowerCase().indexOf(_this3.state.searchText.toLowerCase()) !== -1) {
	
								return _react2.default.createElement(
									'div',
									{ className: 'productparent', key: index },
									_this3.productImagecontent(product.product_slug, product.product_thumbnail),
									_react2.default.createElement(
										'div',
										{ className: _this3.productClass(product.product_thumbnail) },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: "/product/" + product.product_slug },
											_react2.default.createElement(
												'h1',
												{ className: 'head1' },
												' ',
												strp.stripslashes(product.product_name),
												' ',
												_react2.default.createElement(
													'p',
													{ className: ' price pull-right' },
													' ',
													" ",
													config.ids.currency + product.product_price
												)
											),
											_react2.default.createElement(
												'p',
												{ className: 'text-justify' },
												strp.stripslashes(product.product_short_description),
												'} '
											)
										)
									),
									_react2.default.createElement('div', { className: 'clearfix' })
								);
							}
						} else {
							return _react2.default.createElement(
								'div',
								{ className: 'productparent', key: index },
								_this3.productImagecontent(product.product_slug, product.product_thumbnail),
								_react2.default.createElement(
									'div',
									{ className: _this3.productClass(product.product_thumbnail) },
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: "/product/" + product.product_slug },
										_react2.default.createElement(
											'h1',
											{ className: 'head1' },
											' ',
											strp.stripslashes(product.product_name),
											' ',
											_react2.default.createElement(
												'p',
												{ className: ' price pull-right' },
												' ',
												" ",
												config.ids.currency + product.product_price
											)
										),
										_react2.default.createElement(
											'p',
											{ className: 'text-justify' },
											strp.stripslashes(product.product_short_description),
											' '
										)
									)
								),
								_react2.default.createElement('div', { className: 'clearfix' })
							);
						}
					}();
				});
			}
	
			/* show next page link */
	
		}, {
			key: 'nextpage',
			value: function nextpage() {
	
				if (typeof _reactCookie2.default.load('UserId') === "undefined" || _reactCookie2.default.load('UserId') && _reactCookie2.default.load('UserId') === "") {
					_reactRouter.hashHistory.push("/sign-in");
				} else {
					if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId) {
						/* only for sarvesh app */
						if (APPID === "287E5552-328E-4DBE-A3CA-E998ACCAC9BD") {
	
							helper.sarveshTableSetup();
						} else {
							_reactRouter.hashHistory.push("/book-a-table");
						}
					} else {
						_reactRouter.hashHistory.push("/delivery-date");
					}
				}
			}
	
			/* this function used to load cart icon image */
	
		}, {
			key: 'loadCartImage',
			value: function loadCartImage() {
				return (0, _Api2.default)('cartImage', 'Yes');
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.state.status === "Loading") {
					return _react2.default.createElement(
						'div',
						{ style: { bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto' } },
						' ',
						_react2.default.createElement('img', { src: '/img/loader.gif', alt: 'Loading', style: { bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto' } }),
						' '
					);
				} else if (this.state.status === "ok") {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_reactDocumentMeta2.default, meta),
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid desktop-container' },
							_react2.default.createElement('div', { id: 'parentDisable' }),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 top-nav inner-top-nav  head-main' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-3 nav-head pd-l-20  head-child' },
										' ',
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: "/cart" },
											_react2.default.createElement('img', { src: '/img/icons/arrow-right.png', alt: 'left-arrow', className: 'icon-img-small-3' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-6 nav-head  head-child' },
										_react2.default.createElement(
											'h1',
											{ className: 'main-title' },
											'Complete Your Meal'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-3 nopadding  head-child' },
										_react2.default.createElement(
											'p',
											{ className: 'b-txt text-right ' },
											_react2.default.createElement(
												_reactRouter.Link,
												{ 'data-toggle': 'collapse', to: "#SearchBAR", 'aria-expanded': 'false', 'aria-controls': 'collapseExample' },
												_react2.default.createElement('img', { alt: '', src: '/img/icons/search.png', className: 'icon-img-small4 head_serch' })
											),
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: "/cart" },
												'  ',
												_react2.default.createElement('img', { alt: '', src: this.loadCartImage(), className: 'icon-img-small-1 carticon' }),
												' '
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'collapse', id: 'SearchBAR' },
										_react2.default.createElement(
											'div',
											{ className: '' },
											_react2.default.createElement(
												'div',
												{ className: 'form-group SearchBAR' },
												_react2.default.createElement(
													'div',
													{ className: 'input-group' },
													_react2.default.createElement('input', { type: 'text', id: 'searchInput', onChange: this.handleChange.bind(this), ref: 'searchInput', className: 'form-control', placeholder: 'Go ahead search for a dish...' })
												)
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement('img', { src: '/img/pasta-1.jpg', alt: 'pasta', className: 'img-responsive' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'product-holder' },
								this.showProducts()
							),
							_react2.default.createElement(
								'div',
								{ className: 'row ' },
								_react2.default.createElement(
									'div',
									{ className: 'container' },
									_react2.default.createElement(
										'div',
										{ className: 'row' },
										_react2.default.createElement(
											_reactRouter.Link,
											null,
											_react2.default.createElement(
												'button',
												{ className: 'col-lg-12 continue-but desktop-container container-fluid', onClick: this.nextpage.bind() },
												'Continue'
											)
										),
										'                  '
									)
								)
							),
							_react2.default.createElement('br', null)
						)
					);
				} else {
	
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_reactDocumentMeta2.default, meta),
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid desktop-container' },
							_react2.default.createElement('div', { id: 'parentDisable' }),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 top-nav inner-top-nav head-main' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-3 nav-head pd-l-20 head-child' },
										' ',
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: "/" },
											_react2.default.createElement('img', { src: '/img/icons/arrow-right.png', alt: 'left-arrow', className: 'icon-img-small-3' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-6 nav-head  head-child' },
										_react2.default.createElement(
											'h1',
											{ className: 'main-title' },
											'Complete Your Meal'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-3 nopadding  head-child' },
										_react2.default.createElement(
											'p',
											{ className: 'b-txt text-right ' },
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: "/cart" },
												'   ',
												_react2.default.createElement('img', { src: this.loadCartImage(), className: 'icon-img-small-1-inner', alt: 'shopping-cart' }),
												' '
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row product-holder' },
								_react2.default.createElement('br', null),
								_react2.default.createElement('br', null),
								_react2.default.createElement(
									'p',
									null,
									' ',
									lang.no_products_found,
									' '
								),
								_react2.default.createElement('div', { className: 'clearfix' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'row ' },
								_react2.default.createElement(
									'div',
									{ className: 'container' },
									_react2.default.createElement(
										'div',
										{ className: 'row' },
										_react2.default.createElement(
											_reactRouter.Link,
											null,
											_react2.default.createElement(
												'button',
												{ className: 'col-lg-12 continue-but desktop-container container-fluid', onClick: this.nextpage.bind() },
												'Continue'
											)
										),
										'                  '
									)
								)
							),
							_react2.default.createElement('br', null)
						),
						' '
					);
				}
			}
		}]);
	
		return Addons;
	}(_react2.default.Component);
	
	exports.default = Addons;

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(9);
	
	var _ThemeProvider = __webpack_require__(84);
	
	var _ThemeProvider2 = _interopRequireDefault(_ThemeProvider);
	
	var _theme = __webpack_require__(89);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	__webpack_require__(71);
	
	var _DatePicker = __webpack_require__(85);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _rcTimePicker = __webpack_require__(114);
	
	var _rcTimePicker2 = _interopRequireDefault(_rcTimePicker);
	
	__webpack_require__(144);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var lang = __webpack_require__(12);
	var apps = __webpack_require__(29);
	var config = __webpack_require__(7);
	var APPID = config.ids.appId;
	var APIURL = config.path.apiUrl;
	var APIURLV2 = config.path.apiUrlv2;
	var APIURLPRO = config.path.apiUrlPro;
	
	
	var helper = __webpack_require__(13);
	var dateFormat = __webpack_require__(42);
	
	var HtmlToReactParser = __webpack_require__(21).Parser;
	var tat = _reactCookie2.default.load("orderTAT") === "" ? 0 : _reactCookie2.default.load("orderTAT");
	var htmlToReactParser = new HtmlToReactParser();
	
	
	/* Load meta tags */
	var meta = {
	  title: lang.choose_delvery_date,
	  description: lang.site_title,
	  meta: {
	    name: {
	      keywords: lang.site_title
	    }
	  }
	};
	var Product_LeadTime = 0;
	var TodayDate = new Date();
	var autoFillDate = TodayDate;
	var getDate = TodayDate.getDate();
	var min_datetime = new Date(new Date(TodayDate).setDate(getDate - 1));
	var max_datetime = new Date(new Date(TodayDate).setDate(getDate));
	var weekdayArr = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
	
	var Advancedtimeslot = function (_React$Component) {
	  _inherits(Advancedtimeslot, _React$Component);
	
	  function Advancedtimeslot(props) {
	    _classCallCheck(this, Advancedtimeslot);
	
	    /* check Authentication */
	    var _this = _possibleConstructorReturn(this, (Advancedtimeslot.__proto__ || Object.getPrototypeOf(Advancedtimeslot)).call(this, props));
	
	    _this.handleChange = function (item, value) {
	      if (item == "date") {
	        var _this$setState;
	
	        _this.setState((_this$setState = {}, _defineProperty(_this$setState, item, value), _defineProperty(_this$setState, "TimeSlotHtmlVal", ""), _this$setState), function () {
	          var selectDar = weekdayArr[value.getDay()];
	          if (this.state.time_slot_type === "1") {
	            this.timeDropDownFunction(selectDar);
	          } else if (this.state.time_slot_type === "2") {
	            this.loadTimeSlotDropDown(selectDar);
	          }
	        });
	      } else {
	        _this.setState(_defineProperty({}, item, value));
	      }
	    };
	
	    if ((0, _Api2.default)("Auth") === false) {
	      _reactRouter.hashHistory.push("/sign-in");
	    }
	
	    /* validate delivery avilablity */
	    if (_reactCookie2.default.load("defaultAvilablityId") === config.ids.dineinId || typeof _reactCookie2.default.load("defaultAvilablityId") === "undefined" || _reactCookie2.default.load("defaultAvilablityId") === "") {
	      _reactRouter.hashHistory.push("/");
	    }
	
	    _this.state = {
	      settings: [],
	      date: autoFillDate,
	      selectTime: "",
	      selectMins: "",
	      disableDate: [],
	      cutOfftime: "",
	      cutoffnextday: "",
	      cutofNextDayReached: 0,
	      intervalTime: "",
	      min_datetime: min_datetime,
	      max_datetime: max_datetime,
	      timeText: "Time (HH/MM)",
	      timeHtml: "",
	      timeExceed: "No",
	      time_slot_type: "1",
	      TimeSlotHtmlVal: ""
	    };
	
	    _this.changeTimer = _this.changeTimer.bind(_this); //changeHrs
	    _this.changeMins = _this.changeMins.bind(_this); //changeMins
	
	    if (typeof _reactCookie2.default.load("UserId") === "undefined") {
	      var customerParam = "&reference_id=" + (0, _Api2.default)("referenceId");
	    } else {
	      var customerParam = "&customer_id=" + _reactCookie2.default.load("UserId");
	    }
	    var postalCodeWhere = "";
	    if (typeof _reactCookie2.default.load("orderPostalCode") !== "undefined") {
	      postalCodeWhere = '&postal_code=' + _reactCookie2.default.load("orderPostalCode");
	    }
	
	    _axios2.default.get(APIURL + "cartver2/contents?status=A&app_id=" + APPID + customerParam + postalCodeWhere).then(function (res) {
	      if (res.data.status === "ok") {
	        if (typeof res.data.result_set !== "undefined") {
	          Product_LeadTime = parseInt(res.data.result_set.product_lead_time);
	          _this.getsettings();
	        }
	      }
	    });
	    return _this;
	  }
	
	  _createClass(Advancedtimeslot, [{
	    key: "getsettings",
	    value: function getsettings() {
	      var _this2 = this;
	
	      var promise = helper.getProSettings("", "No"); //getResult('settings','');
	      promise.then(function (res) {
	        _this2.setState({ settings: res.data.result_set });
	
	        /* find current tat value */
	        _axios2.default.get(APIURL + "outlets/gettat_details?app_id=" + APPID + "&availability_id=" + _reactCookie2.default.load("defaultAvilablityId") + "&outlet_id=" + _reactCookie2.default.load("orderOutletId")).then(function (res) {
	          if (res.data.status === "ok") {
	            if (res.data.result_set !== "" && res.data.result_set !== null) {
	              _reactCookie2.default.save("orderTat", res.data.tat);
	              _this2.setState({ serverTat: res.data.tat }, function () {
	                this.getTimesettingArrFun();
	              });
	            }
	
	            // this.mainDateTimeFun();
	          } else {
	            helper.showInfo("Your selected outlet currently closed or disabled by an administrator. Please choose another outlet.");
	            _reactRouter.hashHistory.push("/");
	          }
	        });
	        /* find current tat value - End  */
	
	        /* Holiday  - start */
	        /* var DisableDats = [];
	        if (
	          parseInt(res.data.result_set.client_holiday_enable) === 1 &&
	          cookie.load("defaultAvilablityId") !== config.ids.dineinId
	        ) {
	          axios
	            .get(
	              APIURLPRO +
	                "settings/get_holidaylist?app_id=" +
	                APPID +
	                "&availability=" +
	                cookie.load("defaultAvilablityId") +
	                "&outlet_id=" +
	                cookie.load("orderOutletId")
	            )
	            .then((res) => {
	              if (res.data.status === "ok") {
	                
	                var resultData = res.data.result_set;
	                 resultData.map((loadData) =>
	                  DisableDats.push(this.parseDate(loadData.date))
	                );
	                this.setState({
	                  hollidayList: resultData,
	                  allowHoliDay: "Yes",
	                  disableDate: DisableDats,
	                });
	              }
	            });
	        } */
	      });
	    }
	
	    /* mainDateTimeFun() {
	      axios
	        .get(
	          APIURL +
	            "settings/deliverytime_slotminmax/?app_id=" +
	            APPID +
	            "&availability=" +
	            cookie.load("defaultAvilablityId") +
	            "&outlet_id=" +
	            cookie.load("orderOutletId")
	        )
	        .then((res) => {
	          if (res.data.status === "ok") {
	            if (typeof res.data.result_set !== "undefined") {
	              var result = res.data.result_set[0];
	              var mindatetime = result.minimum_date;
	              if (Product_LeadTime > 0) {
	                if (mindatetime < Product_LeadTime) {
	                  mindatetime = Product_LeadTime;
	                } else {
	                  mindatetime = mindatetime;
	                }
	              }
	              mindatetime = parseInt(mindatetime) + parseInt(getDate);
	              var currentDate = new Date(
	                new Date(TodayDate).setDate(mindatetime)
	              );
	               min_datetime = new Date(
	                new Date(TodayDate).setDate(mindatetime - 1)
	              );
	              var totalDays =
	                parseInt(min_datetime.getDate()) +
	                parseInt(1) +
	                parseInt(Product_LeadTime) +
	                parseInt(result.maximum_date);
	              var max_datetime = new Date(new Date(TodayDate).setDate(totalDays));
	              var cutOfftime =
	                result.cut_off !== "" ? parseInt(result.cut_off) : "";
	              this.setState(
	                {
	                  min_datetime: min_datetime,
	                  max_datetime: max_datetime,
	                  date: currentDate,
	                  cutOfftime: cutOfftime,
	                },
	                function () {
	                  this.getTimesettingArrFun();
	                }
	              );
	            } else {
	              this.setState({ timeExceed: "Yes" });
	            }
	          } else {
	            this.setState({ timeExceed: "Yes" });
	          }
	        });
	    } */
	
	    /*  getStartDate(mindatetime) {
	      var startDate = new Date(new Date(TodayDate).setDate(mindatetime));
	      var i = 0;
	      if (this.state.disableDate !== "") {
	        var current = this;
	        this.state.disableDate.map(function (item, index) {
	          var existDate =
	            startDate.getDate() +
	            "-" +
	            startDate.getMonth() +
	            "-" +
	            startDate.getFullYear();
	          var checkDate =
	            item.getDate() + "-" + item.getMonth() + "-" + item.getFullYear();
	          if (existDate == checkDate) {
	            var newDate = new Date(
	              new Date(TodayDate).setDate(parseInt(item.getDate()) + 1)
	            );
	            i++;
	            current.getStartDate(newDate);
	          }
	        });
	      }
	      if (i === 0) {
	        return startDate;
	      }
	    } */
	
	  }, {
	    key: "getTimesettingArrFun",
	    value: function getTimesettingArrFun() {
	      var _this3 = this;
	
	      var selectedDate = this.state.date;
	      var currentThis = this;
	      if (this.state.cutOfftime !== "") {
	        selectedDate.setDate(selectedDate.getDate() + 1);
	
	        var min_datetime = this.state.min_datetime;
	        min_datetime.setDate(min_datetime.getDate() + 1);
	
	        var max_datetime = this.state.max_datetime;
	        max_datetime.setDate(max_datetime.getDate() + 1);
	        this.setState({
	          date: selectedDate,
	          min_datetime: min_datetime,
	          max_datetime: max_datetime
	        });
	      }
	
	      _axios2.default.get(APIURLV2 + "settings/availableDatesAdvanced/?app_id=" + APPID + "&availability_id=" + _reactCookie2.default.load("defaultAvilablityId") + "&outletId=" + _reactCookie2.default.load("orderOutletId") + "&tatTime=" + this.state.serverTat).then(function (tmres) {
	        $(".custom-date-label").removeClass("loader-main-cls");
	        $(".custom-date-label").find(".loader-sub-div").remove();
	        $('.slot_loading_sec').hide();
	        if (tmres.data.status === "success") {
	          var result = tmres.data.timeslot_data.result_set[0];
	          _this3.setState({ time_slot_type: result.time_slot_type });
	          var mindatetime = result.minimum_date;
	          if (Product_LeadTime > 0) {
	            if (mindatetime < Product_LeadTime) {
	              mindatetime = Product_LeadTime;
	            } else {
	              mindatetime = mindatetime;
	            }
	          }
	          mindatetime = parseInt(mindatetime) + parseInt(getDate);
	          var currentDate = new Date(new Date(TodayDate).setDate(mindatetime));
	
	          min_datetime = new Date(new Date(TodayDate).setDate(mindatetime - 1));
	          var totalDays = parseInt(min_datetime.getDate()) + parseInt(1) + parseInt(Product_LeadTime) + parseInt(result.maximum_date);
	          var max_datetime = new Date(new Date(min_datetime).setDate(totalDays));
	          var cutOfftime = result.cut_off !== "" ? parseInt(result.cut_off) : "";
	          var cutoffnextday = result.cut_off_next_day !== "" ? parseInt(result.cut_off_next_day) : "";
	
	          /* Holliday Disable Dates */
	          var hollidayList = tmres.data.timeslot_data.holidayresult;
	          var DisableDats = [];
	          if (hollidayList !== "") {
	            hollidayList.map(function (loadData) {
	              var checkingDate = currentDate.getFullYear() + "-" + currentThis.padnewone(parseInt(currentDate.getMonth()) + 1) + "-" + currentThis.padnewone(currentDate.getDate());
	              if (loadData == checkingDate) {
	                currentDate = new Date(new Date(TodayDate).setDate(parseInt(currentDate.getDate()) + 1));
	              }
	
	              DisableDats.push(currentThis.parseDate(loadData));
	            });
	          }
	
	          if (cutOfftime !== "") {
	            var cutofMindate = parseInt(min_datetime.getDate()) + 1;
	            var currentDateTime = new Date();
	            var currentTimeDetails = currentDateTime.getHours();
	            var currentDateDetails = currentDateTime.getDate();
	            if (cutofMindate === currentDateDetails && currentTimeDetails >= cutOfftime && result.time_slot_type == "2") {
	              min_datetime = new Date(new Date(min_datetime).setDate(cutofMindate));
	              currentDate = new Date(new Date(min_datetime).setDate(parseInt(cutofMindate) + 1));
	            }
	          }
	
	          var slot = tmres.data.timeslot_data.result_set[0].slot;
	          for (var k = mindatetime; k <= totalDays; k++) {
	            var addDates = new Date(new Date(TodayDate).setDate(k));
	            var addDay = weekdayArr[addDates.getDay()];
	            if (slot[addDay] === "" || slot[addDay] === undefined) {
	              var checking_Date = currentDate.getFullYear() + "-" + currentThis.padnewone(parseInt(currentDate.getMonth()) + 1) + "-" + currentDate.getDate();
	              var hideDate = addDates.getFullYear() + "-" + _this3.padnewone(parseInt(addDates.getMonth()) + 1) + "-" + _this3.padnewone(addDates.getDate());
	              if (hideDate == checking_Date) {
	                currentDate = new Date(new Date(TodayDate).setDate(parseInt(currentDate.getDate()) + 1));
	              }
	
	              DisableDats.push(_this3.parseDate(hideDate));
	            }
	          }
	
	          if (hollidayList !== "") {
	            hollidayList.map(function (loadData) {
	              var checkingDate = currentDate.getFullYear() + "-" + currentThis.padnewone(parseInt(currentDate.getMonth()) + 1) + "-" + currentThis.padnewone(currentDate.getDate());
	
	              if (loadData === checkingDate) {
	                currentDate = new Date(new Date(TodayDate).setDate(parseInt(currentDate.getDate()) + 1));
	              }
	            });
	          }
	
	          _this3.setState({
	            min_datetime: min_datetime,
	            max_datetime: max_datetime,
	            date: currentDate,
	            forcutoffstart: currentDate,
	            cutOfftime: cutOfftime,
	            cutoffnextday: cutoffnextday,
	            timeExceed: "No",
	            hollidayList: hollidayList,
	            /*   allowHoliDay: "Yes", */
	            disableDate: DisableDats
	          });
	          var daytxt = weekdayArr[currentDate.getDay()];
	          if (result.time_slot_type === "1") {
	            _this3.setState({
	              intervalTime: tmres.data.timeslot_data.result_set[0].interval_time,
	              timeandsecArrayset: slot
	            }, function () {
	              this.timeDropDownFunction(daytxt);
	            });
	          } else if (result.time_slot_type === "2") {
	            _this3.setState({
	              timeText: "Choose Time slot",
	              timeandsecArrayset: tmres.data.timeslot_data.result_set[0].slot
	            }, function () {
	              this.loadTimeSlotDropDown(daytxt);
	            });
	          }
	        } else {
	          _this3.setState({ intervalTime: "" });
	          _this3.setState({ timeandsecArrayset: [] });
	          _this3.setState({ timeHtml: "" });
	          _this3.setState({ minsHtml: "" });
	          _this3.setState({ timeExceed: "Yes" });
	        }
	      });
	    }
	  }, {
	    key: "timeDropDownFunction",
	    value: function timeDropDownFunction(daytxt) {
	      var skiptime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var enable_advance_time_slot_cutof_time = this.state.settings.enable_advance_time_slot_cutof_time !== "" && _typeof(this.state.settings.enable_advance_time_slot_cutof_time) !== undefined && typeof this.state.settings.enable_advance_time_slot_cutof_time !== "undefined" ? this.state.settings.enable_advance_time_slot_cutof_time : 0;
	      var currentthis = this;
	      var timeExceed = "No";
	      var TimeHtml = "";
	      var changeTmtxt = "";
	      var checkTimeArr = [];
	      var timethis = this;
	      var tatval = this.state.serverTat;
	      var cutOfftime = this.state.cutOfftime;
	      var totdayDate = new Date();
	      var addHrs = parseInt(totdayDate.getMinutes()) + parseInt(this.state.serverTat);
	      totdayDate.setMinutes(addHrs);
	      var selectDate = this.state.date.getDate() + "-" + this.state.date.getMonth() + "-" + this.state.date.getFullYear();
	      var j = 0;
	      var slotArr = [];
	      var addtionalArray = [];
	      var startList,
	          endList = "";
	      var intervalTime = this.state.intervalTime;
	      if (this.state.timeandsecArrayset[daytxt] !== "" && this.state.timeandsecArrayset[daytxt] !== undefined) {
	        var cut_of_Reached = 0;
	        this.state.timeandsecArrayset[daytxt].map(function (item) {
	          var cutofNextDayReached = 0;
	          if (currentthis.state.cutofNextDayReached === 1 && cut_of_Reached === 0 && currentthis.state.cutoffnextday !== "" && enable_advance_time_slot_cutof_time === "1") {
	            currentthis.setState({ cutofNextDayReached: 0 });
	            cutofNextDayReached = 1;
	          }
	          if (cutofNextDayReached === 0) {
	            //Start Slot
	            var slot_time1 = item.slot_time1.split(":");
	            var startTimeVal = slot_time1.length > 0 ? slot_time1[0] : "";
	            var startMinitVal = slot_time1.length > 0 ? slot_time1[1] : "";
	            var strdatevalobj = new Date();
	            strdatevalobj.setHours(startTimeVal);
	            var stringrMinits = parseInt(startMinitVal) + parseInt(tatval);
	            strdatevalobj.setMinutes(stringrMinits);
	            startTimeVal = strdatevalobj.getHours();
	            startMinitVal = strdatevalobj.getMinutes();
	
	            //End Slot
	            var endArr = item.slot_time2 !== "" ? item.slot_time2.split(":") : [];
	            var endTimeVal = endArr.length > 0 ? endArr[0] : "";
	            var endMinitVal = endArr.length > 0 ? endArr[1] : "";
	            var enddatevalobj = new Date();
	            enddatevalobj.setHours(endTimeVal);
	            var ingrendMinits = parseInt(endMinitVal) + parseInt(tatval);
	            enddatevalobj.setMinutes(ingrendMinits);
	            endTimeVal = enddatevalobj.getHours();
	            endMinitVal = enddatevalobj.getMinutes();
	
	            var checkDate = totdayDate.getDate() + "-" + totdayDate.getMonth() + "-" + totdayDate.getFullYear();
	            var slotcutOff = 0;
	            if (item.slot_cutt_off !== "" && item.slot_cutt_off !== null) {
	              var slot_cutt_off = item.slot_cutt_off.split(":");
	              if (enable_advance_time_slot_cutof_time === "1") {
	                if (parseInt(slot_cutt_off[0]) >= 0 && checkDate === selectDate) {
	                  if (totdayDate.getHours() >= slot_cutt_off[0]) {
	                    slotcutOff = 1;
	                  }
	                }
	              }
	            }
	            if (slotcutOff === 0) {
	              if (startTimeVal !== "" && endTimeVal !== "") {
	                for (var valueTime = startTimeVal; valueTime <= endTimeVal; valueTime++) {
	                  var todaycond = 0;
	                  if (checkDate === selectDate) {
	                    if (valueTime < totdayDate.getHours()) {
	                      todaycond = 1;
	                    }
	                  }
	                  if (checkTimeArr.indexOf(valueTime) >= 0 && todaycond === 0) {
	                    addtionalArray[timethis.padnewone(valueTime)] = strdatevalobj + "-" + enddatevalobj;
	                  }
	                  if (checkTimeArr.indexOf(valueTime) === -1 && todaycond === 0) {
	                    if (skiptime <= valueTime) {
	                      if (j === 0) {
	                        timethis.setState({ selectTime: valueTime });
	                      }
	
	                      if (startTimeVal == timethis.padnewone(valueTime)) {
	                        startList = startMinitVal;
	                      } else {
	                        startList = 0;
	                      }
	                      if (endTimeVal == valueTime) {
	                        endList = endMinitVal;
	                      } else {
	                        endList = Math.round((60 / intervalTime - 1) * intervalTime);
	                      }
	                      if (startList > endList) {
	                        endList = startList;
	                      }
	                      slotArr[timethis.padnewone(valueTime)] = startList + "-" + endList;
	                      checkTimeArr.push(valueTime);
	                      if (j === 0) {
	                        timethis.setState({
	                          selectTime: timethis.padnewone(valueTime)
	                        });
	                      }
	                      var cutoffexist = 0;
	
	                      if (cutOfftime !== "" && cutOfftime < valueTime && timethis.state.date.getDate() == timethis.state.forcutoffstart.getDate()) {
	                        cutoffexist = 1;
	                      }
	                      if (cutoffexist === 0) {
	                        TimeHtml += "<option value='" + timethis.padnewone(valueTime) + "'  >" + timethis.padnewone(valueTime) + "</option>";
	                        j++;
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	          cut_of_Reached++;
	        });
	      }
	      if (this.state.cutoffnextday !== "" && enable_advance_time_slot_cutof_time === "1") {
	        var check_Date = totdayDate.getDate() + "-" + totdayDate.getMonth() + "-" + totdayDate.getFullYear();
	        if (check_Date === selectDate && this.state.cutoffnextday <= totdayDate.getHours()) {
	          this.setState({ cutofNextDayReached: 1 });
	        }
	      }
	      var timeDropDown = "";
	      var currentselectdate = this.state.date;
	      if (TimeHtml !== "") {
	        timeDropDown = htmlToReactParser.parse(TimeHtml);
	      } else {
	        timeExceed = "Yes";
	
	        var min_datetime = new Date(new Date(this.state.date).setDate(currentselectdate.getDate()));
	
	        this.setState({ min_datetime: min_datetime });
	        var addonday = parseInt(currentselectdate.getDate()) + 1;
	        var cudate = new Date(new Date(currentselectdate).setDate(addonday));
	
	        if (this.state.hollidayList !== "" && _typeof(this.state.hollidayList) !== undefined && typeof this.state.hollidayList !== "undefined") {
	          var currentThis = this;
	          this.state.hollidayList.map(function (loadData) {
	            var checkingDate = cudate.getFullYear() + "-" + currentThis.padnewone(parseInt(cudate.getMonth()) + 1) + "-" + currentThis.padnewone(cudate.getDate());
	            if (loadData == checkingDate) {
	              cudate = new Date(new Date(cudate).setDate(parseInt(cudate.getDate()) + 1));
	            }
	          });
	        }
	
	        this.setState({ date: cudate }, function () {
	          this.timeDropDownFunction(weekdayArr[cudate.getDay()]);
	        });
	      }
	
	      this.setState({
	        timeHtml: timeDropDown,
	        minsHtml: "",
	        slotArr: slotArr,
	        addtionalArray: addtionalArray,
	        timeExceed: timeExceed
	      }, function () {
	        if (TimeHtml !== "") {
	          this.minsDropDownFunction();
	        }
	      });
	    }
	  }, {
	    key: "minsDropDownFunction",
	    value: function minsDropDownFunction() {
	      var slotArr = this.state.slotArr;
	      var intervalTime = this.state.intervalTime;
	      var selectTime = this.state.selectTime;
	      var timeExceed = "No";
	      var startTimeLimit = 0;
	      var totdayDate = new Date();
	
	      var addHrs = parseInt(totdayDate.getMinutes()) + parseInt(this.state.serverTat);
	
	      totdayDate.setMinutes(addHrs);
	
	      var selectDate = this.state.date.getDate() + "-" + this.state.date.getMonth() + "-" + this.state.date.getFullYear();
	
	      var checkDate = totdayDate.getDate() + "-" + totdayDate.getMonth() + "-" + totdayDate.getFullYear();
	      var endTimeLimit = (60 / intervalTime - 1) * intervalTime;
	      var startTime_Limit = startTimeLimit;
	      var endTime_Limit = endTimeLimit;
	      var slotArray = [];
	      while (startTime_Limit <= endTime_Limit) {
	        slotArray.push(startTime_Limit);
	        startTime_Limit += parseInt(intervalTime);
	      }
	
	      var k = 0;
	      var htmlMins = "";
	      if (slotArr !== "" && slotArr[selectTime] !== "" && _typeof(slotArr[selectTime]) !== undefined) {
	        var slotArrNew = slotArr[selectTime].split("-");
	
	        var startTimeLimitNew = parseInt(slotArrNew[0]);
	        var endTimeLimitNew = parseInt(slotArrNew[1]);
	        var minArrayList = [];
	        var startSelect = "";
	        var startcompleteTime = 0;
	        if (totdayDate.getHours() == selectTime && checkDate == selectDate) {
	          if (totdayDate.getMinutes() > startTimeLimitNew) {
	            startcompleteTime = 1;
	          }
	        }
	        var currentEnd = 0;
	        if (slotArray.indexOf(startTimeLimitNew) === -1 && startcompleteTime === 0) {
	          htmlMins += "<option value='" + this.padnewone(startTimeLimitNew) + "'  >" + this.padnewone(startTimeLimitNew) + "</option>";
	          currentEnd = startTimeLimitNew;
	          startSelect = startTimeLimitNew;
	        }
	        while (startTimeLimit <= endTimeLimit) {
	          var completeTime = 0;
	          if (totdayDate.getHours() == selectTime && checkDate == selectDate) {
	            if (totdayDate.getMinutes() > startTimeLimit) {
	              completeTime = 1;
	            }
	          }
	          if (completeTime === 0) {
	            if (startTimeLimitNew > startTimeLimit) {
	              completeTime = 1;
	            }
	          }
	          if (completeTime === 0) {
	            if (endTimeLimitNew < startTimeLimit) {
	              completeTime = 1;
	            }
	          }
	          if (completeTime === 0) {
	            if (k === 0) {
	              this.setState({ selectMins: this.padnewone(startTimeLimit) });
	            }
	            minArrayList.push(startTimeLimit);
	            htmlMins += "<option value='" + this.padnewone(startTimeLimit) + "'  >" + this.padnewone(startTimeLimit) + "</option>";
	            currentEnd = startTimeLimit;
	            k++;
	          }
	          startTimeLimit += parseInt(intervalTime);
	        }
	
	        var endcompleteTime = 0;
	        if (totdayDate.getHours() == selectTime && checkDate == selectDate) {
	          if (totdayDate.getMinutes() > endTimeLimitNew) {
	            endcompleteTime = 1;
	          }
	        }
	
	        if (minArrayList.indexOf(endTimeLimitNew) === -1 && startSelect !== endTimeLimitNew && endcompleteTime === 0) {
	          htmlMins += "<option value='" + this.padnewone(endTimeLimitNew) + "'  >" + this.padnewone(endTimeLimitNew) + "</option>";
	          currentEnd = endTimeLimitNew;
	        }
	      }
	      var loadAddtionalTime = this.loadAddtionalTime(currentEnd);
	      htmlMins += loadAddtionalTime;
	      var minsDropDown = "";
	      if (htmlMins !== "") {
	        minsDropDown = htmlToReactParser.parse(htmlMins);
	      } else {
	        timeExceed = "Yes";
	        var day_txt = weekdayArr[this.state.date.getDay()];
	        var select_Time = parseInt(selectTime) + 1;
	        this.timeDropDownFunction(day_txt, select_Time);
	      }
	      this.setState({ minsHtml: minsDropDown, timeExceed: timeExceed });
	    }
	  }, {
	    key: "loadAddtionalTime",
	    value: function loadAddtionalTime(currentEnd) {
	      var html_Mins = "";
	      var select_Time = this.state.selectTime;
	      var intervalTime = this.state.intervalTime;
	      var startTimeLimit = 0;
	      var endTimeLimit = (60 / intervalTime - 1) * intervalTime;
	      var addtional_Array = this.state.addtionalArray;
	      if (addtional_Array !== "" && addtional_Array[select_Time] !== "" && _typeof(addtional_Array[select_Time]) !== undefined && typeof addtional_Array[select_Time] !== "undefined") {
	        var totdayDate = new Date();
	
	        var addHrs = parseInt(totdayDate.getMinutes()) + parseInt(this.state.serverTat);
	
	        totdayDate.setMinutes(addHrs);
	
	        var selectDate = this.state.date.getDate() + "-" + this.state.date.getMonth() + "-" + this.state.date.getFullYear();
	
	        var checkDate = totdayDate.getDate() + "-" + totdayDate.getMonth() + "-" + totdayDate.getFullYear();
	
	        var add_start_time = addtional_Array[select_Time].split("-");
	
	        var startTime = new Date(add_start_time[0].trim());
	        var endTime = new Date(add_start_time[1].trim());
	        var endMin = endTimeLimit;
	        if (endTime.getHours() == select_Time) {
	          endMin = endTime.getMinutes();
	        }
	        var completeTime = 0;
	        if (totdayDate.getHours() == select_Time && checkDate == selectDate) {
	          if (totdayDate.getMinutes() > startTimeLimit) {
	            completeTime = 1;
	          }
	        }
	        if (completeTime === 0) {
	          html_Mins += "<option value='" + this.padnewone(startTime.getMinutes()) + "'  >" + this.padnewone(startTime.getMinutes()) + "</option>";
	        }
	        var minArrayList = [];
	        var endofMin = 0;
	        while (startTimeLimit <= endTimeLimit) {
	          if (currentEnd < startTimeLimit && startTime.getMinutes() < startTimeLimit) {
	            var _completeTime = 0;
	            if (totdayDate.getHours() == select_Time && checkDate == selectDate) {
	              if (totdayDate.getMinutes() > startTimeLimit) {
	                _completeTime = 1;
	              }
	            }
	            if (_completeTime == 0) {
	              minArrayList.push(startTimeLimit);
	              html_Mins += "<option value='" + this.padnewone(startTimeLimit) + "'  >" + this.padnewone(startTimeLimit) + "</option>";
	              endofMin = startTimeLimit;
	            }
	          }
	          startTimeLimit += parseInt(intervalTime);
	        }
	
	        var endcompleteTime = 0;
	        if (totdayDate.getHours() == select_Time && checkDate == selectDate) {
	          if (totdayDate.getMinutes() > endMin) {
	            endcompleteTime = 1;
	          }
	        }
	        if (minArrayList.indexOf(endMin) === -1 && startTime.getMinutes() !== endMin && endcompleteTime === 0 && endMin < endofMin) {
	          html_Mins += "<option value='" + this.padnewone(endMin) + "'  >" + this.padnewone(endMin) + "</option>";
	        }
	      }
	      return html_Mins;
	    }
	  }, {
	    key: "loadTimeSlotDropDown",
	    value: function loadTimeSlotDropDown(daytxt) {
	      var currentthis = this;
	      var enable_advance_time_slot_cutof_time = this.state.settings.enable_advance_time_slot_cutof_time !== "" && _typeof(this.state.settings.enable_advance_time_slot_cutof_time) !== undefined && typeof this.state.settings.enable_advance_time_slot_cutof_time !== "undefined" ? this.state.settings.enable_advance_time_slot_cutof_time : 0;
	      var timeExceed = "No";
	      var currentTime = new Date();
	      var totdayDate = new Date();
	      if (this.state.serverTat !== "" && this.state.serverTat !== null && this.state.serverTat !== undefined && this.state.serverTat != "undefined") {
	        var addhrToday = parseInt(currentTime.getMinutes()) + parseInt(this.state.serverTat);
	        currentTime.setMinutes(addhrToday);
	      }
	      var timeSlotHtml = "";
	      var selectDate = this.state.date.getDate() + "-" + this.state.date.getMonth() + "-" + this.state.date.getFullYear();
	
	      var checkDate = currentTime.getDate() + "-" + currentTime.getMonth() + "-" + currentTime.getFullYear();
	      var cutOfftime = this.state.cutOfftime;
	      var timeExist = 0;
	      if (this.state.timeandsecArrayset[daytxt] !== "" && this.state.timeandsecArrayset[daytxt] !== undefined) {
	        var cut_of_Reached = 0;
	        this.state.timeandsecArrayset[daytxt].map(function (item) {
	          var cutofNextDayReached = 0;
	          if (currentthis.state.cutofNextDayReached === 1 && cut_of_Reached === 0 && currentthis.state.cutoffnextday !== "" && enable_advance_time_slot_cutof_time === "1") {
	            currentthis.setState({ cutofNextDayReached: 0 });
	            cutofNextDayReached = 1;
	          }
	          if (cutofNextDayReached === 0) {
	            timeExist = 0;
	            //Start Slot
	            var slot_time1 = item.slot_time1.split(":");
	            var startTimeVal = slot_time1.length > 0 ? slot_time1[0] : "";
	            var startMinitVal = slot_time1.length > 0 ? slot_time1[1] : "";
	            var strdatevalobj = new Date();
	            strdatevalobj.setHours(startTimeVal);
	            var stringrMinits = parseInt(startMinitVal);
	            strdatevalobj.setMinutes(stringrMinits);
	
	            //End Slot
	            var endArr = item.slot_time2 !== "" ? item.slot_time2.split(":") : [];
	            var endTimeVal = endArr.length > 0 ? endArr[0] : "";
	            var endMinitVal = endArr.length > 0 ? endArr[1] : "";
	            var enddatevalobj = new Date();
	            enddatevalobj.setHours(endTimeVal);
	            var ingrendMinits = parseInt(endMinitVal);
	            enddatevalobj.setMinutes(ingrendMinits);
	            var lable = (0, _moment2.default)(strdatevalobj).format("hh:mm A") + " - " + (0, _moment2.default)(enddatevalobj).format("hh:mm A");
	            var TimeValue = (0, _moment2.default)(strdatevalobj).format("HH:mm") + ":00" + "-" + (0, _moment2.default)(enddatevalobj).format("HH:mm") + ":00/" + (0, _moment2.default)(strdatevalobj).format("hh:mm A") + "-" + (0, _moment2.default)(enddatevalobj).format("hh:mm A");
	
	            var checkDate = totdayDate.getDate() + "-" + totdayDate.getMonth() + "-" + totdayDate.getFullYear();
	            var slotcutOff = 0;
	            if (item.slot_cutt_off !== "" && item.slot_cutt_off !== null) {
	              var slot_cutt_off = item.slot_cutt_off.split(":");
	              if (enable_advance_time_slot_cutof_time === "1") {
	                if (parseInt(slot_cutt_off[0]) != '00' && parseInt(slot_cutt_off[0]) >= 0 && checkDate === selectDate) {
	                  if (totdayDate.getHours() >= slot_cutt_off[0]) {
	                    slotcutOff = 1;
	                  }
	                }
	              }
	            }
	
	            if (slotcutOff === 0) {
	              if (currentTime.getHours() >= strdatevalobj.getHours() && checkDate == selectDate) {
	                timeExist = 1;
	              }
	              if (timeExist == 0) {
	                timeSlotHtml += "<option value='" + TimeValue + "'  >" + lable + "</option>";
	              }
	            }
	          }
	          cut_of_Reached++;
	        });
	      }
	      if (this.state.cutoffnextday !== "" && enable_advance_time_slot_cutof_time === "1") {
	        var check_Date = totdayDate.getDate() + "-" + totdayDate.getMonth() + "-" + totdayDate.getFullYear();
	        console.log(check_Date, selectDate, this.state.cutoffnextday, totdayDate.getHours(), 'totdayDate.getHours()');
	        if (check_Date === selectDate && this.state.cutoffnextday <= totdayDate.getHours()) {
	          this.setState({ cutofNextDayReached: 1 });
	        }
	      }
	      var timeSlotDD = "";
	      var currentselectdate = this.state.date;
	      if (timeSlotHtml !== "") {
	        timeSlotDD = htmlToReactParser.parse(timeSlotHtml);
	      } else {
	        timeExceed = "Yes";
	        var min_datetime = new Date(new Date(this.state.date).setDate(currentselectdate.getDate()));
	
	        this.setState({ min_datetime: min_datetime });
	        var addonday = parseInt(currentselectdate.getDate()) + 1;
	        var cudate = new Date(new Date(currentselectdate).setDate(addonday));
	
	        if (this.state.hollidayList !== "" && _typeof(this.state.hollidayList) !== undefined && typeof this.state.hollidayList !== "undefined") {
	          var currentThis = this;
	          this.state.hollidayList.map(function (loadData) {
	            var checkingDate = cudate.getFullYear() + "-" + currentThis.padnewone(parseInt(cudate.getMonth()) + 1) + "-" + currentThis.padnewone(cudate.getDate());
	            if (loadData == checkingDate) {
	              cudate = new Date(new Date(cudate).setDate(parseInt(cudate.getDate()) + 1));
	            }
	          });
	        }
	
	        this.setState({ date: cudate }, function () {
	          this.loadTimeSlotDropDown(weekdayArr[cudate.getDay()]);
	        });
	      }
	      this.setState({ TimeSlotHtmlVal: timeSlotDD, timeExceed: timeExceed });
	    }
	
	    /* Disaple year */
	
	  }, {
	    key: "showTimeslotExceed",
	    value: function showTimeslotExceed() {
	      if (this.state.timeExceed === "Yes") {
	        if (APPID === "97347EE4-2845-4011-BCE6-9C0B806DA437" && (_reactCookie2.default.load("defaultAvilablityId") === "634E6FA8-8DAF-4046-A494-FFC1FCF8BD11" || _reactCookie2.default.load("defaultAvilablityId") === "718B1A92-5EBB-4F25-B24D-3067606F67F0")) {
	          if (_reactCookie2.default.load("defaultAvilablityId") === "634E6FA8-8DAF-4046-A494-FFC1FCF8BD11") {
	            return _react2.default.createElement(
	              "div",
	              { className: "timeslot_exc" },
	              "Delivery available only on Saturdays (12- 4) pm"
	            );
	          } else if (_reactCookie2.default.load("defaultAvilablityId") === "718B1A92-5EBB-4F25-B24D-3067606F67F0") {
	            return _react2.default.createElement(
	              "div",
	              { className: "timeslot_exc" },
	              "Takeaway available only on Saturdays (9 am to 2pm)"
	            );
	          }
	        } else if (APPID === "729A09D6-2A38-4E1C-ADB1-67A9242D2158" && (_reactCookie2.default.load("defaultAvilablityId") === "634E6FA8-8DAF-4046-A494-FFC1FCF8BD11" || _reactCookie2.default.load("defaultAvilablityId") === "718B1A92-5EBB-4F25-B24D-3067606F67F0")) {
	          if (_reactCookie2.default.load("defaultAvilablityId") === "634E6FA8-8DAF-4046-A494-FFC1FCF8BD11") {
	            return _react2.default.createElement(
	              "div",
	              { className: "timeslot_exc" },
	              "Delivery available only on Fri, Sat & Sun"
	            );
	          } else if (_reactCookie2.default.load("defaultAvilablityId") === "718B1A92-5EBB-4F25-B24D-3067606F67F0") {
	            return _react2.default.createElement(
	              "div",
	              { className: "timeslot_exc" },
	              "Pickup available only on Fri, Sat & Sun"
	            );
	          }
	        } else {
	          return _react2.default.createElement(
	            "div",
	            { className: "timeslot_exc" },
	            " ",
	            "Note: Please refer our operating hours. The time you are selecting is outside of our delivery timing. Apologies for the inconvenience."
	          );
	        }
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _withTracker.loadAnalytics)();
	      var windowHeight = window.innerHeight;
	      this.setState({ windowHeight: windowHeight - 45 + "px" });
	
	      $(".custom-date-label").addClass("loader-main-cls").append('<div class="loader-sub-div"></div>');
	      $('.slot_loading_sec').show();
	    }
	
	    /* store unit no's */
	
	  }, {
	    key: "stroteUnitNoOne",
	    value: function stroteUnitNoOne(event) {
	      _reactCookie2.default.save("unitNoOne", event.target.value);
	    }
	
	    /* store unit no's */
	
	  }, {
	    key: "stroteUnitNoTwo",
	    value: function stroteUnitNoTwo(event) {
	      _reactCookie2.default.save("unitNoTwo", event.target.value);
	    }
	
	    /* store unit no's */
	
	  }, {
	    key: "strotetowerNo",
	    value: function strotetowerNo(event) {
	      _reactCookie2.default.save("towerNo", event.target.value);
	    }
	
	    /* Submit Order Date */
	
	  }, {
	    key: "checkDeliveryDate",
	    value: function checkDeliveryDate() {
	      if (this.state.timeExceed === "No") {
	        var DeliveryDate = this.state.date.getDate() + "/" + (parseInt(this.state.date.getMonth()) + 1) + "/" + this.state.date.getFullYear();
	        var OrderTime = "";
	        var timelimits = "";
	        if (this.state.time_slot_type === "1") {
	          _reactCookie2.default.save("isSletedTimeSlot", "No");
	          _reactCookie2.default.save("DeliveryDate", DeliveryDate);
	          var DeliveryTime = this.state.selectTime + ":" + this.state.selectMins;
	          var DeliveryDate1 = DeliveryDate.split("/");
	          OrderTime = DeliveryDate1[2] + "-" + this.padnewone(DeliveryDate1[1]) + "-" + this.padnewone(DeliveryDate1[0]) + " " + DeliveryTime;
	          _reactCookie2.default.save("DeliveryTime", DeliveryTime);
	        } else if (this.state.time_slot_type === "2") {
	          var Timeslot = document.getElementById("timeSlot").value;
	          var splited = Timeslot.split("/");
	          var startTime = splited[0].split("-");
	          _reactCookie2.default.save("isSletedTimeSlot", "Yes");
	          _reactCookie2.default.save("DeliveryDate", DeliveryDate);
	          _reactCookie2.default.save("DeliveryTimeSlotFormated", splited[1]);
	          _reactCookie2.default.save("DeliveryTime", startTime[0]);
	          _reactCookie2.default.save("DeliveryTimeSlot", splited[0]);
	          var DeliveryDate1 = DeliveryDate.split("/");
	          OrderTime = DeliveryDate1[2] + "-" + this.padnewone(DeliveryDate1[1]) + "-" + this.padnewone(DeliveryDate1[0]) + " " + startTime[0];
	          timelimits = "&order_pickup_time_slot_from=" + startTime[0] + "&order_pickup_time_slot_to=" + startTime[1];
	        }
	
	        //Check unit number validation
	        if (_reactCookie2.default.load("defaultAvilablityId") === config.ids.deliveryId) {
	          var AlertOne = document.getElementById("unitone").value;
	          var AlertTwo = document.getElementById("unittwo").value;
	          if (AlertOne === "" || AlertTwo === "") {
	            var res = confirm("You did not enter a Floor No / Unit No. \n Do you want to continue");
	            if (!res) {
	              error = "1";
	              return false;
	            }
	          }
	        }
	
	        _axios2.default.get(APIURLPRO + "ordersv1/validate_order_count_advanced?app_id=" + APPID + "&availability_id=" + _reactCookie2.default.load("defaultAvilablityId") + "&outlet_id=" + _reactCookie2.default.load("orderOutletId") + "&order_date=" + OrderTime + timelimits + "&order_tat_time=" + this.state.serverTat).then(function (res) {
	          if (res.data.status === "ok") {
	            _reactRouter.hashHistory.push("/checkout");
	          } else {
	            helper.showInfo(res.data.message);
	          }
	        });
	
	        //hashHistory.push("/checkout");
	      } else {
	        helper.showInfo("Please select another date and time");
	        return false;
	      }
	    }
	  }, {
	    key: "changeTimer",
	    value: function changeTimer(e) {
	      var seletedTime = e.target.value;
	      this.setState({ selectTime: seletedTime, minsHtml: "" }, function () {
	        this.minsDropDownFunction();
	      });
	    }
	
	    /* chnage minutes */
	
	  }, {
	    key: "changeMins",
	    value: function changeMins(e) {
	      this.setState({ selectMins: e.target.value });
	    }
	
	    /* add zero */
	
	  }, {
	    key: "padnewone",
	    value: function padnewone(d) {
	      var dd = parseInt(d);
	      return dd < 10 ? "0" + dd.toString() : dd.toString();
	    }
	
	    /* format date'es */
	
	  }, {
	    key: "parseDate",
	    value: function parseDate(input) {
	      var parts = input.match(/(\d+)/g);
	      return new Date(parts[0], parts[1] - 1, parts[2]); // months are 0-based
	    }
	
	    /*show outlet text for workspace */
	
	  }, {
	    key: "outletNameText",
	    value: function outletNameText() {
	      if (apps.workspace === APPID) {
	        return htmlToReactParser.parse("Workspace Espresso Bar <br/> 12 Marina Boulevard<br/> Marina Bay Financial Centre Tower 3<br/> #01-08 Singapore 018982");
	      } else {
	        /*return (cookie.load('defaultAvilablityId') === config.ids.deliveryId? cookie.load('orderDeliveryAddress'): cookie.load('orderHandled') );*/
	        return _reactCookie2.default.load("defaultAvilablityId") === config.ids.deliveryId ? _reactCookie2.default.load("orderDeliveryAddress") + ", Singapore " + _reactCookie2.default.load("orderPostalCode") : _reactCookie2.default.load("orderHandled");
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        " ",
	        _react2.default.createElement(_reactDocumentMeta2.default, meta),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "container-fluid desktop-container",
	            style: { minHeight: this.state.windowHeight }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-xs-12 top-nav inner-top-nav head-main" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-xs-3 nav-head pd-l-20  head-child" },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: "/cart" },
	                  _react2.default.createElement("img", {
	                    src: "/img/icons/arrow-right.png",
	                    alt: "left-arrow",
	                    className: "icon-img-small-3"
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-xs-6 nav-head head-child" },
	                _react2.default.createElement(
	                  "h1",
	                  { className: "main-title" },
	                  _reactCookie2.default.load("defaultAvilablityId") === config.ids.deliveryId ? "Delivery" : "PICKUP"
	                )
	              ),
	              _react2.default.createElement("div", { className: "col-xs-3 nopadding head-child" })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-12 calender-area" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-xs-12 calender-area-sub" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-xs-offset-2 col-xs-8 cal-div" },
	                  _react2.default.createElement(
	                    "h1",
	                    { className: "sub-heading", style: { textAlign: "center" } },
	                    _reactCookie2.default.load("defaultAvilablityId") === config.ids.deliveryId ? "SELECT YOUR DELIVERY DATE AND TIME" : "SELECT YOUR PICKUP DATE AND TIME"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group label-floating is-empty card-no custom-date-label" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group deliverydate" },
	                      _react2.default.createElement(
	                        _ThemeProvider2.default,
	                        { theme: _theme2.default },
	                        _react2.default.createElement(_DatePicker2.default, {
	                          label: "Date (DD/MM/YYYY)",
	                          className: "delivery_datepiker",
	                          inputFormat: function inputFormat(value) {
	                            return value.getDate() + "/" + (value.getMonth() + 1) + "/" + value.getFullYear();
	                          },
	                          value: this.state.date,
	                          onChange: this.handleChange.bind(this, "date"),
	                          minDate: this.state.min_datetime,
	                          maxDate: this.state.max_datetime,
	                          sundayFirstDayOfWeek: true,
	                          disabledDates: this.state.disableDate
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { className: "text-center sub-heading-2 slot_loading_sec", style: { display: 'none' } },
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                      "b",
	                      null,
	                      "Please wait...Checking the next available slots.."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group label-floating is-empty card-no custom-time-label min-hgt-hour-t" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group" },
	                      _react2.default.createElement(
	                        "label",
	                        { className: "control-label" },
	                        this.state.timeText
	                      ),
	                      this.state.time_slot_type === "1" && _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            value: this.state.selectTime,
	                            onChange: this.changeTimer,
	                            id: "deliveryTime"
	                            /*  className={disabledClass + " customdd"}
	                                               */
	                          },
	                          this.state.timeHtml
	                        ),
	                        " ",
	                        "/",
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            id: "deliveryMins",
	                            value: this.state.selectMins,
	                            onChange: this.changeMins
	                            /* 
	                            className={
	                            disabledClassMins + " " + disabledClass + " customdd"
	                            }
	                            */
	                          },
	                          this.state.minsHtml
	                        )
	                      ),
	                      this.state.time_slot_type === "2" && _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            className: " customdd timelsotdd",
	                            id: "timeSlot"
	                          },
	                          this.state.TimeSlotHtmlVal
	                        )
	                      )
	                    )
	                  ),
	                  this.showTimeslotExceed(),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "all-time-text" },
	                    APPID == "CD9D3E7B-C4E4-4FF0-B751-A7FE97524F53" && (0, _moment2.default)(this.state.date).format("YYYY-M-D") == (0, _moment2.default)(new Date()).format("YYYY-M-D") ? "Today's orders will only be  available till 9pm" : ""
	                  ),
	                  _react2.default.createElement("div", { className: "space-35" })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-xs-12 calender-area-sub-2" },
	                _react2.default.createElement(
	                  "h1",
	                  { className: "sub-heading", style: { textAlign: "center" } },
	                  _reactCookie2.default.load("defaultAvilablityId") === config.ids.deliveryId ? "DELIVER TO" : "PICKUP AT"
	                ),
	                _react2.default.createElement(
	                  "h1",
	                  { className: "sub-heading-2", style: { textAlign: "center" } },
	                  this.outletNameText()
	                ),
	                _reactCookie2.default.load("defaultAvilablityId") === config.ids.deliveryId ? _react2.default.createElement(
	                  "div",
	                  { className: "col-xs-12 unit-no-div" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group col-sm-4 col-xs-12 no-margin" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group label-floating is-empty card-no" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group" },
	                        _react2.default.createElement(
	                          "label",
	                          { className: "control-label" },
	                          "Building Name/ Tower"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          id: "towerno",
	                          className: "form-control",
	                          onChange: this.strotetowerNo
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group col-sm-4 col-xs-12 no-margin" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group label-floating is-empty card-no" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group" },
	                        _react2.default.createElement(
	                          "label",
	                          { className: "control-label" },
	                          "Floor No"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          id: "unitone",
	                          className: "form-control",
	                          onChange: this.stroteUnitNoOne
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group col-sm-4 col-xs-12 no-margin" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group label-floating is-empty card-no" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group" },
	                        _react2.default.createElement(
	                          "label",
	                          { className: "control-label" },
	                          "Unit No"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          id: "unittwo",
	                          className: "form-control",
	                          onChange: this.stroteUnitNoTwo
	                        })
	                      )
	                    ),
	                    _react2.default.createElement("br", null)
	                  ),
	                  _react2.default.createElement("div", { className: "clearfix" })
	                ) : _react2.default.createElement("div", { className: "space-30" })
	              ),
	              _react2.default.createElement("div", { className: "space-30" })
	            )
	          ),
	          _react2.default.createElement("div", { className: "space-30" }),
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { onClick: this.checkDeliveryDate.bind(this) },
	              _react2.default.createElement(
	                "button",
	                { className: "col-lg-12 continue-but desktop-container container-fluid" },
	                "Continue"
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Advancedtimeslot;
	}(_react2.default.Component);
	
	exports.default = Advancedtimeslot;

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* var Loader = require('react-loader'); */
	
	/*
	if (location.protocol !== 'https:' &&  location.host !== "localhost:3000" )
	{
	  location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
	}
	*/
	
	var App = function (_React$Component) {
	  _inherits(App, _React$Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        ' ',
	        this.props.children,
	        '  '
	      );
	    }
	  }]);
	
	  return App;
	}(_react2.default.Component);
	
	exports.default = App;

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _withTracker = __webpack_require__(11);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _reactRouter = __webpack_require__(9);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	__webpack_require__(232);
	
	var _reactRouterTransition = __webpack_require__(439);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var config = __webpack_require__(7);
	
	var lang = __webpack_require__(12);
	var APIURL = config.path.apiUrl;
	var APPID = config.ids.appId;
	var APIURLv2 = config.path.apiUrlv2;
	var apps = __webpack_require__(29);
	var currency = config.ids.currency;
	
	var Loading = __webpack_require__(17);
	var Overlay = __webpack_require__(64);
	var qs = __webpack_require__(3);
	var HtmlToReactParser = __webpack_require__(21).Parser;
	var htmlToReactParserTo = new HtmlToReactParser();
	
	var strp = __webpack_require__(31);
	var helper = __webpack_require__(13);
	var zonalEnable = 1;
	/* Load meta tags */
	var meta = {
		title: lang.cart_page_title + lang.site_title_with_separator,
		description: lang.cart_page_description,
		meta: {
			name: {
				keywords: lang.cart_page_keywords
			}
		}
	};
	var deletevar = 'No';
	
	var Cart = function (_React$Component) {
		_inherits(Cart, _React$Component);
	
		function Cart(props) {
			_classCallCheck(this, Cart);
	
			/*add class */
			helper.addBodyClass();
	
			/* Declare state */
			var _this = _possibleConstructorReturn(this, (Cart.__proto__ || Object.getPrototypeOf(Cart)).call(this, props));
	
			_this.state = { zoneEnabled: 0, outbasedProducts: 0, windowHeightNormal: 0, windowHeight: 0, cartDetails: [], cartItems: [], secAddrData: [], status: 'Loading', cartCount: 'No', settings: [], delPercentage: 0, minOrderPercentage: 0, remaingAmnt: 0, minOrderRemaingAmnt: 0, additnl_deliveryAmnt_cal: 0, zoneDetails: [], incrementValue: 0, checkItems: [], checkDetails: []
				/* get settings values */
			};var postalParam = _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId ? "Yes" : "No";
	
			/*11/28/2018*/
			var zoneDetails = "";
	
			if (typeof _reactCookie2.default.load('orderZoneID') !== "undefined" && _reactCookie2.default.load('orderZoneID') !== "" && _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId) {
	
				_axios2.default.get(APIURLv2 + 'outlets/getZoneDetails/?app_id=' + APPID + "&availability=" + config.ids.deliveryId + "&ZoneId=" + _reactCookie2.default.load('orderZoneID') + "&outletId=" + _reactCookie2.default.load('orderOutletId')).then(function (res) {
					if (res.data.status === "ok") {
						_this.setState({ zoneDetails: res.data.result_set[0] });
					} else {
						alert(res.data.message);
						_reactRouter.hashHistory.push("/");
					}
				});
			}
	
			_this.loadCartData();
	
			/*11/28/2018*/
	
			var promise = (0, _Api2.default)('settingsPro', postalParam);
			promise.then(function (res) {
				var settingResult = res.data.result_set;
				_this.setState({ zoneEnabled: parseInt(settingResult.client_outlet_zone) });
				_this.setState({ outbasedProducts: parseInt(settingResult.ninja_outletbasedproduct_enable) });
				if (parseInt(settingResult.client_outlet_zone) === 1 && _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId) {
					if (typeof _this.state.zoneDetails === "undefined" || _this.state.zoneDetails === "") {
						alert("something went wrong");
						_reactRouter.hashHistory.push("");
					} else {
						if (_this.state.zoneEnabled === 1 && _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && _this.state.zoneDetails['zone_delivery_charge'] > 0 || _this.state.zoneDetails['zone_min_amount'] > 0) {
							settingResult['callcnter_min_amount'] = _this.state.zoneDetails['zone_min_amount'];
							settingResult['client_free_delivery_amount'] = _this.state.zoneDetails['zone_free_delivery'];
							settingResult['client_delivery_surcharge'] = _this.state.zoneDetails['zone_delivery_charge'];
							settingResult['additional_delivery_charge'] = _this.state.zoneDetails['zone_additional_delivery_charge'];
						}
					}
				}
	
				_this.setState({ 'settings': settingResult });
				_this.loadCartData();
				_this.setState({ additnl_deliveryAmnt_cal: settingResult.additional_delivery_charge });
				_reactCookie2.default.save('siteURL', settingResult.client_site_url);
			});
	
			_this.handleChange1 = _this.handleChange1.bind(_this); //handleChangeValue
			_this.handleChangeValue = _this.handleChangeValue.bind(_this);
	
			_axios2.default.get(APIURL + 'outlets/pickup_outlets?app_id=' + APPID).then(function (res) {
				if (res.data.status === "ok") {
					_this.setState({ Outlets: res.data.result_set });
					//this.loadMarkers();
				}
			});
	
			_axios2.default.get(APIURL + '/customer/get_user_secondary_address?app_id=' + APPID + "&refrence=" + _reactCookie2.default.load('UserId')).then(function (res) {
				if (res.data.status === "ok") {
					_this.setState({ secAddrData: res.data.result_set });
				}
			});
	
			return _this;
		}
	
		/* Open Zipcode popup */
	
		_createClass(Cart, [{
			key: 'getSignInlink',
			value: function getSignInlink() {
				return parseInt(this.state.settings.client_enable_express_checkout) === 1 ? '/new-signin' : '/sign-in';
			}
		}, {
			key: 'changeDelivery',
			value: function changeDelivery() {
				this.setState({ load: "false" });
				$("#DeliveryError").modal("toggle");
				if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
					$("#AddressList").modal("toggle");
				} else {
					$("#DeliveryAddress").modal("toggle");
				}
	
				//$("#DeliveryAddress").modal("toggle");
			}
		}, {
			key: 'changeDeliveryAddr',
			value: function changeDeliveryAddr() {
	
				$("#SwitchingError").modal("toggle");
	
				/*if(cookie.load('defaultAvilablityId')===config.ids.deliveryId && cookie.load('defaultAvilablity')===lang.delivery){
	   	
	   	$("#Delivery-OutletSelection").modal("toggle");
	   	 
	   	
	   }else if(cookie.load('defaultAvilablityId')===config.ids.pickupId && cookie.load('defaultAvilablity')===lang.takeaWay){
	   	$("#Pickup-OutletSelection").modal("toggle");
	   
	   
	   } */
			}
		}, {
			key: 'handleChange1',
			value: function handleChange1(event) {
				//alert(event.target.value);
				this.setState({ addressField: event.target.value });
			}
		}, {
			key: 'handleChangeValue',
			value: function handleChangeValue(event) {
				this.setState({ addressField: event.target.value });
			}
		}, {
			key: 'closeDeliveryErr',
			value: function closeDeliveryErr() {
				this.setState({ load: "false" });
				$("#DeliveryError").modal("toggle");
			}
	
			/* Validate zipcode */
	
		}, {
			key: 'validatezip',
			value: function validatezip(e) {
				var re = /[0-9A-F:]+/g;
				if (!re.test(e.key)) {
					e.preventDefault();
				}
			}
	
			/* load outlets */
	
		}, {
			key: '__loadOutlets',
			value: function __loadOutlets() {
				var _this2 = this;
	
				if (this.state.Outlets) {
					return this.state.Outlets.map(function (loaddata, index) {
						return _react2.default.createElement(
							'div',
							{ className: 'map-li', key: index, onClick: _this2.pickOutlet.bind(_this2, loaddata.outlet_id, loaddata.outlet_name, loaddata.outlet_postal_code, loaddata.outlet_address_line1, loaddata.outlet_address_line2, loaddata.outlet_unit_number1, loaddata.outlet_unit_number2, loaddata.outlet_pickup_tat, loaddata.outlet_tax_option, loaddata.outlet_tax_surcharge, loaddata.outlet_tax_surcharge_inclusive) },
							_react2.default.createElement(
								'p',
								{ className: 'map-h' },
								loaddata.outlet_name
							),
							_react2.default.createElement(
								'p',
								{ className: 'map-sub' },
								loaddata.outlet_address_line1 + ", " + loaddata.outlet_address_line2 + " " + loaddata.outlet_postal_code
							)
						);
					});
				}
			}
		}, {
			key: 'loadAddressList',
			value: function loadAddressList() {
				var _this3 = this;
	
				return this.state.secAddrData.map(function (item, index) {
					return _react2.default.createElement(
						'p',
						{ key: index },
						_react2.default.createElement('input', { name: 'radio', value: item.postal_code, id: item.secondary_address_id, className: 'css-radio', type: 'radio', onChange: _this3.handleChange1 }),
						_react2.default.createElement(
							'label',
							{ htmlFor: item.secondary_address_id, className: 'css-label ' },
							' ',
							item.address + " Singapore " + item.postal_code
						)
					);
				});
			}
	
			/* Select outlet */
	
		}, {
			key: 'selectOutlet',
			value: function selectOutlet() {
				var _this4 = this;
	
				if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
					var postalcode = $("#postalcode").val(); //"postalcode";
				} else {
					postalcode = $("#postalcode1").val(); // "postalcode1";
				}
	
				if (postalcode.length < 5) {
					return false;
				}
	
				this.setState({ load: "true" });
	
				/*add loading */
				_axios2.default.get(APIURL + 'outlets/find_outlet?skip_timing=Yes&app_id=' + APPID + "&availability_id=" + _reactCookie2.default.load('defaultAvilablityId') + "&postal_code=" + postalcode).then(function (res) {
	
					/* Success response */
					/* Success response  && Object.keys(res.data.result_set.postal_code_information).length !==0 */
					if (res.data.status === "ok") {
						/*if(Object.keys(res.data.result_set.postal_code_information).length !==0)
	     { */
						var orderDeliveryAddress = res.data.result_set.postal_code_information.zip_buno + " " + res.data.result_set.postal_code_information.zip_sname;
						var orderHandled = res.data.result_set.outlet_name + ", Crew will be seeing you in " + res.data.result_set.outlet_delivery_timing + " Minutes";
						_this4.setState({ orderDeliveryAddress: orderDeliveryAddress + " Singapore " + res.data.result_set.postal_code_information.zip_code });
						_this4.setState({ orderHandled: orderHandled });
						_reactCookie2.default.save('orderOutletId', res.data.result_set.outlet_id);
						_reactCookie2.default.save('orderOutletName', res.data.result_set.outlet_name);
						_reactCookie2.default.save('orderPostalCode', res.data.result_set.postal_code_information.zip_code);
						_reactCookie2.default.save('orderTAT', res.data.result_set.outlet_delivery_timing);
						_reactCookie2.default.save('orderDeliveryAddress', orderDeliveryAddress);
						_reactCookie2.default.save('orderHandled', orderHandled);
	
						_reactCookie2.default.save('outlet_tax_option', res.data.result_set.outlet_tax_option);
						_reactCookie2.default.save('outlet_tax_surcharge', res.data.result_set.outlet_tax_surcharge);
						_reactCookie2.default.save('outlet_tax_surcharge_inclusive', res.data.result_set.outlet_tax_surcharge_inclusive);
	
						var orderHandledText = res.data.result_set.outlet_name + " " + res.data.result_set.outlet_address_line1 + " " + res.data.result_set.outlet_address_line2 + ", Singapore " + postalcode;
						_reactCookie2.default.save('orderHandledByText', orderHandledText);
	
						if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
							$("#AddressList").modal("toggle");
						} else {
							$("#DeliveryAddress").modal("toggle");
						}
						$("#DeliverySucess").modal("toggle");
	
						/* }else{
	     $("#DeliveryAddress").modal("toggle");
	     $("#DeliveryError").modal("toggle");
	     } */
					}
					/* Error response */
					if (res.data.status === "error") {
						_this4.setState({ load: "false" });
	
						if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
							$("#AddressList").modal("toggle");
						} else {
							$("#DeliveryAddress").modal("toggle");
						}
						if (res.data.shop_close === 'Yes') {
							$("#ShopClosedError").modal("toggle");
						} else {
							$("#DeliveryError").modal("toggle");
						}
					}
				});
			}
		}, {
			key: 'closeShopClosedError',
			value: function closeShopClosedError() {
				this.setState({ load: "false" });
				$("#ShopClosedError").modal("toggle");
			}
	
			/* pick outlet */
	
		}, {
			key: 'pickOutlet',
			value: function pickOutlet(outlet_id, outlet_name, outlet_postal_code, outlet_address_line1, outlet_address_line2, outlet_unit_number1, outlet_unit_number2, outlet_pickup_tat, outlet_tax_option, outlet_tax_surcharge, outlet_tax_surcharge_inclusive) {
	
				var orderHandled = outlet_name + " " + outlet_address_line1 + " " + outlet_address_line2 + ", Singapore " + outlet_postal_code;
				this.setState({ orderHandled: orderHandled });
				_reactCookie2.default.save('orderOutletId', outlet_id);
				_reactCookie2.default.save('orderOutletName', outlet_name);
				_reactCookie2.default.save('orderPostalCode', outlet_postal_code);
				_reactCookie2.default.save('orderTAT', outlet_pickup_tat);
				_reactCookie2.default.save('orderHandled', orderHandled);
				_reactCookie2.default.save('orderHandledByText', orderHandled);
	
				_reactCookie2.default.save('outlet_tax_option', outlet_tax_option);
				_reactCookie2.default.save('outlet_tax_surcharge', outlet_tax_surcharge);
				_reactCookie2.default.save('outlet_tax_surcharge_inclusive', outlet_tax_surcharge_inclusive);
	
				$("#Pickup-OutletSelection").modal("toggle");
				$("#Pickup-Sucess").modal("toggle");
			}
	
			/* continue with pickup success */
	
		}, {
			key: 'pickupSuccess',
			value: function pickupSuccess() {
				var productId = this.state.productId;
				var proName = this.state.proName;
				var prosku = this.state.prosku;
				var proPrice = this.state.proPrice;
				var proQty = this.state.proQty;
				var proImage = this.state.proImage;
				var allowCart = this.state.allowCart;
				var applyMinmaxSelect = this.state.applyMinmaxSelect;
				$("#Pickup-Sucess").modal("toggle");
				this.destroyCart("No");
			}
	
			/* continue with delivery success */
	
		}, {
			key: 'deliverySuccess',
			value: function deliverySuccess() {
				var productId = this.state.productId;
				var proName = this.state.proName;
				var prosku = this.state.prosku;
				var proPrice = this.state.proPrice;
				var proQty = this.state.proQty;
				var proImage = this.state.proImage;
				var allowCart = this.state.allowCart;
				var applyMinmaxSelect = this.state.applyMinmaxSelect;
				$("#DeliverySucess").modal("toggle");
				this.destroyCart("No");
			}
		}, {
			key: 'closeSwitcher',
			value: function closeSwitcher() {
	
				$("#SwitchingError").modal("toggle");
				document.body.classList.add('home_body');
			}
		}, {
			key: 'switchAvailability',
			value: function switchAvailability() {
	
				/* remove default cokkie values */
				_reactCookie2.default.remove('orderOutletId');
				_reactCookie2.default.remove('orderOutletName');
				_reactCookie2.default.remove('orderPostalCode');
				_reactCookie2.default.remove('orderTAT');
				_reactCookie2.default.remove('orderDeliveryAddress');
				_reactCookie2.default.remove('orderHandled');
				_reactCookie2.default.remove('orderHandledByText');
				_reactCookie2.default.remove('orderZoneID');
	
				_reactCookie2.default.remove('outlet_tax_option');
				_reactCookie2.default.remove('outlet_tax_surcharge');
				_reactCookie2.default.remove('outlet_tax_surcharge_inclusive');
	
				_reactCookie2.default.remove('product_remarks');
	
				$("#SwitchingError").modal("toggle");
				//document.body.classList.add('home_body');
	
				if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && _reactCookie2.default.load('defaultAvilablity') === lang.delivery) {
	
					if (parseInt(this.state.zoneEnabled) === 1 /*&& parseInt(this.state.outbasedProducts) === 1 */) {
	
							this.destroyCart(this, "Yes");
							_reactRouter.hashHistory.push("/");
						} else {
						if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
							$("#AddressList").modal("toggle");
						} else {
							$("#DeliveryAddress").modal("toggle");
						}
					}
				} else if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.pickupId && _reactCookie2.default.load('defaultAvilablity') === lang.takeaWay) {
					$("#Pickup-OutletSelection").modal("toggle");
				}
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var windowHeight = window.innerHeight;
				//alert(windowHeight);
				this.setState({ 'windowHeight': windowHeight - 45 + 'px' });
				this.setState({ 'windowHeightNormal': windowHeight + 'px' });
			}
		}, {
			key: 'loadCartData',
			value: function loadCartData() {
				var _this5 = this;
	
				/* API CALL FOR BANNERS */
				if (typeof _reactCookie2.default.load('UserId') === 'undefined') {
					var customerParam = "&reference_id=" + (0, _Api2.default)('referenceId');
				} else {
					customerParam = "&customer_id=" + _reactCookie2.default.load('UserId');
				}
				var zoneparam = "";
				if (_reactCookie2.default.load('orderZoneID') !== "" && _typeof(_reactCookie2.default.load('orderZoneID')) !== undefined && typeof _reactCookie2.default.load('orderZoneID') !== "undefined") {
					zoneparam = "&zone_id=" + _reactCookie2.default.load('orderZoneID');
				}
	
				var deliveryDate = '';
				var deliveryTime = _reactCookie2.default.load("DeliveryTime") !== undefined ? _reactCookie2.default.load("DeliveryTime") : '';
				var deliveryDateTxt = _reactCookie2.default.load("DeliveryDate") !== undefined ? _reactCookie2.default.load("DeliveryDate") : '';
				if (deliveryDateTxt != '') {
					var deliveryDateArr = deliveryDateTxt.split("/");
					deliveryDate = deliveryDateArr[2] + "-" + deliveryDateArr[1] + "-" + deliveryDateArr[0];
				}
	
				if (deliveryTime == '' && deliveryDateTxt == '') {
					var today = new Date();
					var dd = String(today.getDate()).padStart(2, '0');
					var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
					var yyyy = today.getFullYear();
					var todayDate = yyyy + '-' + mm + '-' + dd;
					var timeNow = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
					deliveryDate = todayDate;
					deliveryTime = timeNow;
				}
				var postalCodeWhere = "";
				if (typeof _reactCookie2.default.load("orderPostalCode") !== "undefined") {
					postalCodeWhere = '&postal_code=' + _reactCookie2.default.load("orderPostalCode");
				}
				_axios2.default.get(APIURL + 'cartver2/contents?status=A&app_id=' + APPID + customerParam + zoneparam + "&orderdate=" + deliveryDate + "&ordertime=" + deliveryTime + "&stockvalide=yes" + postalCodeWhere).then(function (res) {
					if (res.data.status === "ok") {
						_this5.setState({ status: 'ok' });
						if (typeof res.data.result_set !== "undefined") {
							var cartDetails = res.data.result_set.cart_details;
							var cartItems = res.data.result_set.cart_items;
	
							if (_this5.state.zoneEnabled === 1 && _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && _this5.state.settings.zone_order_value_delivery_charge === "1") {
								var zone_Details = _this5.state.zoneDetails;
								zone_Details['zone_delivery_charge'] = cartDetails['cart_zone_delivery_charge'];
								_this5.setState({ zoneDetails: zone_Details });
							}
	
							if (_this5.state.zoneEnabled === 1 && _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && _this5.state.zoneDetails['zone_delivery_charge'] > 0) {
								cartDetails['cart_delivery_charge'] = _this5.state.zoneDetails['zone_delivery_charge'];
								cartDetails['cart_grand_total'] = parseFloat(cartDetails['cart_sub_total']) + parseFloat(_this5.state.zoneDetails['zone_delivery_charge']);
							}
							_this5.setState({
								checkItems: cartItems,
								checkDetails: cartDetails
							}, function () {
								this.findvocuherItems();
							});
							_this5.setStateSuccess('ok', cartDetails, cartItems);
							_this5.cartCountSts('Yes');
						} else {
							_this5.cartCountSts('No');
							_this5.setState({ status: 'error' });
						}
					} else {
	
						_this5.cartCountSts('No');
						_this5.setState({ status: 'error' });
					}
				});
			}
	
			/* Delete cart items */
	
		}, {
			key: 'deleteOrderCookie',
			value: function deleteOrderCookie() {
				_reactCookie2.default.save('cartValue', 'No');
				_reactCookie2.default.remove('orderPaymentMode');
				_reactCookie2.default.remove('orderOutletId');
				_reactCookie2.default.remove('orderTableNo');
				_reactCookie2.default.remove('product_remarks');
				_reactCookie2.default.remove('orderOutletName');
				_reactCookie2.default.remove('orderOutletId');
				_reactCookie2.default.remove('orderZoneID');
	
				/* Delivery avilablity */
				_reactCookie2.default.remove('DeliveryDate');
				_reactCookie2.default.remove('DeliveryTime');
				_reactCookie2.default.remove('unitNoOne');
				_reactCookie2.default.remove('unitNoTwo');
	
				_reactCookie2.default.remove('outlet_tax_option');
				_reactCookie2.default.remove('outlet_tax_surcharge');
				_reactCookie2.default.remove('outlet_tax_surcharge_inclusive');
			}
			/* this function used to delte all  cart items */
	
		}, {
			key: 'destroyCart',
			value: function destroyCart(deletevar) {
				var _this6 = this;
	
				var postObject = {};
				postObject = { 'app_id': config.ids.appId };
	
				if (typeof _reactCookie2.default.load('UserId') === 'undefined') {
					postObject['reference_id'] = (0, _Api2.default)('referenceId');
				} else {
					postObject['customer_id'] = _reactCookie2.default.load('UserId');
				}
	
				_axios2.default.post(APIURL + "cart/destroy", qs.stringify(postObject)).then(function (res) {
					_reactCookie2.default.remove('promotion_code');
					if (res.data.status === "ok") {
						_this6.cartCountSts('No');
	
						/* remove */
						if (deletevar == 'Yes') {
							_this6.deleteOrderCookie();
						}
	
						_this6.setStateSuccess('error', '[]', '[]');
					} else if (res.data.status === "error") {
						helper.showInfo(res.data.message);
					}
				});
			}
	
			/* this function used to delte single cart items */
	
		}, {
			key: 'deleteCartItem',
			value: function deleteCartItem(cartItemId) {
				var _this7 = this;
	
				var postObject = {};
				postObject = { 'app_id': config.ids.appId, 'cart_item_id': cartItemId };
	
				if (typeof _reactCookie2.default.load('UserId') === 'undefined') {
					postObject['reference_id'] = (0, _Api2.default)('referenceId');
				} else {
					postObject['customer_id'] = _reactCookie2.default.load('UserId');
				}
				if (_reactCookie2.default.load('orderZoneID') !== "" && _typeof(_reactCookie2.default.load('orderZoneID')) !== undefined && typeof _reactCookie2.default.load('orderZoneID') !== "undefined") {
					postObject['zone_id'] = _reactCookie2.default.load('orderZoneID');
				}
				_axios2.default.post(APIURL + "cart/delete", qs.stringify(postObject)).then(function (res) {
					if (res.data.status === "ok") {
						if (res.data.contents) {
							_this7.cartCountSts('Yes');
	
							var cartDetails = res.data.contents.cart_details;
							var cartItems = res.data.contents.cart_items;
	
							_this7.setState({
								checkItems: cartItems,
								checkDetails: cartDetails
							}, function () {
								this.findvocuherItems();
							});
	
							if (_this7.state.zoneEnabled === 1 && _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && _this7.state.settings.zone_order_value_delivery_charge === "1") {
								var zone_Details = _this7.state.zoneDetails;
								zone_Details['zone_delivery_charge'] = cartDetails['cart_zone_delivery_charge'];
								_this7.setState({ zoneDetails: zone_Details });
							}
	
							if (_this7.state.zoneEnabled === 1 && _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && _this7.state.zoneDetails['zone_delivery_charge'] > 0) {
								cartDetails['cart_delivery_charge'] = _this7.state.zoneDetails['zone_delivery_charge'];
								cartDetails['cart_grand_total'] = parseFloat(cartDetails['cart_sub_total']) + parseFloat(_this7.state.zoneDetails['zone_delivery_charge']);
							}
	
							_this7.setStateSuccess('ok', cartDetails, cartItems);
						} else {
							_this7.cartCountSts('No');
							_this7.deleteOrderCookie();
							_this7.setStateSuccess('error', '[]', '[]');
						}
					} else if (res.data.status === "error") {
						helper.showInfo(res.data.message);
					}
				});
			}
	
			/* this function used increase cart item qty */
	
		}, {
			key: 'incQty',
			value: function incQty(cartItemId, qty, productId, type, order_id) {
				var _this8 = this;
	
				if (type === "add") {
					var cartQty = Number(qty) + 1;
				} else {
					if (Number(qty) === 1) {
						return false;
					} else {
						cartQty = Number(qty) - 1;
					}
				}
	
				var postObject = {};
	
				if (order_id !== "" && order_id !== 'undefined' && order_id !== null && order_id !== '0') {
	
					postObject = { 'app_id': config.ids.appId, 'cart_item_id': cartItemId, 'product_id': productId, product_qty: cartQty, voucher_order_id: order_id };
				} else {
	
					postObject = { 'app_id': config.ids.appId, 'cart_item_id': cartItemId, 'product_id': productId, product_qty: cartQty };
				}
	
				if (typeof _reactCookie2.default.load('UserId') === 'undefined') {
					postObject['reference_id'] = (0, _Api2.default)('referenceId');
				} else {
					postObject['customer_id'] = _reactCookie2.default.load('UserId');
				}
				if (_reactCookie2.default.load('orderZoneID') !== "" && _typeof(_reactCookie2.default.load('orderZoneID')) !== undefined && typeof _reactCookie2.default.load('orderZoneID') !== "undefined") {
					postObject['zone_id'] = _reactCookie2.default.load('orderZoneID');
				}
	
				_axios2.default.post(APIURL + "cart/update", qs.stringify(postObject)).then(function (res) {
					if (res.data.status === "ok") {
						_reactCookie2.default.remove('tempPromoCode');
						_reactCookie2.default.remove('tempPoints');
						_this8.cartCountSts('Yes');
						var cartDetails = res.data.contents.cart_details;
						var cartItems = res.data.contents.cart_items;
	
						_this8.setState({
							checkItems: cartItems,
							checkDetails: cartDetails
						}, function () {
							this.findvocuherItems();
						});
	
						if (_this8.state.zoneEnabled === 1 && _this8.state.settings.zone_order_value_delivery_charge === "1") {
							var zone_Details = _this8.state.zoneDetails;
							zone_Details['zone_delivery_charge'] = cartDetails['cart_zone_delivery_charge'];
							_this8.setState({ zoneDetails: zone_Details });
						}
	
						if (_this8.state.zoneEnabled === 1 && _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && _this8.state.zoneDetails['zone_delivery_charge'] > 0) {
	
							cartDetails['cart_delivery_charge'] = _this8.state.zoneDetails['zone_delivery_charge'];
							cartDetails['cart_grand_total'] = parseFloat(cartDetails['cart_sub_total']) + parseFloat(_this8.state.zoneDetails['zone_delivery_charge']);
						}
						_this8.setStateSuccess('ok', cartDetails, cartItems);
					} else if (res.data.status === "error") {
						helper.showInfo(res.data.message);
					}
				});
			}
	
			/* store special instruction  cokie value */
	
		}, {
			key: 'handleChange',
			value: function handleChange(event) {
				_reactCookie2.default.save('product_remarks', event.target.value);
			}
	
			/* this function used to set default succes  state value */
	
		}, {
			key: 'setStateSuccess',
			value: function setStateSuccess(sts, cartDetails, cartItms) {
				this.setState({ status: sts });
				this.setState({ cartDetails: cartDetails });
				this.setState({ cartItems: cartItms });
	
				/* store orginal data for refference */
				//this.setState({cartDetailsSource: cartDetails});
				//this.setState({cartItemsSource: cartItms})
	
	
				if (sts === "ok") {
	
					/* calculate free delivery amount calculation */
					var freeDeliveryAmnt = parseFloat(this.state.settings.client_free_delivery_amount);
					var DeliveryAmnt = parseFloat(this.state.settings.client_delivery_surcharge);
					var AdditnlDeliveryAmnt = parseFloat(this.state.settings.additional_delivery_charge);
					this.setState({ additnl_deliveryAmnt_cal: AdditnlDeliveryAmnt });
	
					/* min order perentage */
					var minAmount = parseFloat(this.state.settings.callcnter_min_amount);
					if (cartDetails.cart_availability_id === config.ids.deliveryId && minAmount > 0) {
	
						var MinOrdersubTotal = parseFloat(cartDetails.cart_sub_total);
						var minpercentage = MinOrdersubTotal * 100 / minAmount;
						minpercentage = Math.round(minpercentage);
						var minremaingAmnt = parseFloat(minAmount - MinOrdersubTotal).toFixed(2);
						if (minremaingAmnt > 0) {
							this.setState({ minOrderRemaingAmnt: minremaingAmnt });
							this.setState({ minOrderPercentage: minpercentage });
						} else {
							this.setState({ minOrderRemaingAmnt: 0 });
							this.setState({ minOrderPercentage: 0 });
						}
					}
	
					if (cartDetails.cart_availability_id === config.ids.deliveryId && (DeliveryAmnt > 0 || AdditnlDeliveryAmnt > 0) && freeDeliveryAmnt > 0) {
						var subTotal = parseFloat(cartDetails.cart_sub_total);
						var percentage = subTotal * 100 / freeDeliveryAmnt;
						percentage = Math.round(percentage);
						var remaingAmnt = parseFloat(freeDeliveryAmnt - subTotal).toFixed(2);
	
						if (remaingAmnt > 0) {
							this.setState({ remaingAmnt: remaingAmnt });
							this.setState({ delPercentage: percentage });
							// this.changeDeliveryAmount(DeliveryAmnt,subTotal);
						} else {
							;
							this.setState({ remaingAmnt: 0 });
							this.setState({ delPercentage: 0 });
							this.changeDeliveryAmount(0, subTotal);
							this.setState({ additnl_deliveryAmnt_cal: 0 });
						}
					} else {
						//alert(DeliveryAmnt + "//"+freeDeliveryAmnt);
					}
				}
			}
	
			/* this function used to  set cart items count */
	
		}, {
			key: 'cartCountSts',
			value: function cartCountSts(cartsts) {
				// var cartCount = (cartsts === "Yes")? this.state.cartDetails.cart_total_items : 0;
				//alert(cartCount);
				_reactCookie2.default.save('cartValue', cartsts);
				// cookie.save('cartCount',this.state.cartDetails.cart_total_items);
			}
	
			/* show avilablity details */
	
			/* hide menu */
	
		}, {
			key: 'hideMenu',
			value: function hideMenu() {
				return APPID === apps.workspace ? "none" : "block";
			}
	
			/* show avilablity details */
	
		}, {
			key: 'loadAvliablityDetails',
			value: function loadAvliablityDetails(i) {
	
				if (_reactCookie2.default.load('defaultAvilablityId') !== config.ids.dineinId && i === 0) {
	
					if (_reactCookie2.default.load('defaultAvilablityId') === '634E6FA8-8DAF-4046-A494-FFC1FCF8BD11') {
						return _react2.default.createElement(
							'div',
							{ className: 'outlet_wrap' },
							' ',
							_react2.default.createElement(
								'div',
								{ className: 'left_t_outlet', style: { width: '99%' } },
								' ',
								_react2.default.createElement(
									'span',
									{ className: 'pull-right' },
									_react2.default.createElement(
										_reactRouter.Link,
										{ style: { cursor: 'pointer', textDecoration: 'none' }, onClick: this.changeDeliveryAddr.bind() },
										'Change Address'
									)
								),
								_react2.default.createElement(
									'h4',
									null,
									'Your ',
									_reactCookie2.default.load('defaultAvilablity'),
									' Address'
								),
								' ',
								_react2.default.createElement(
									'p',
									null,
									_reactCookie2.default.load('orderDeliveryAddress'),
									', Singapore ',
									_reactCookie2.default.load('orderPostalCode'),
									' '
								)
							),
							' '
						);
					} else if (_reactCookie2.default.load('defaultAvilablityId') === '718B1A92-5EBB-4F25-B24D-3067606F67F0') {
	
						if (APPID === apps.workspace) {
							return _react2.default.createElement(
								'div',
								{ className: 'outlet_wrap' },
								' ',
								_react2.default.createElement(
									'div',
									{ className: 'left_t_outlet', style: { width: '99%' } },
									_react2.default.createElement(
										'h4',
										null,
										'Your ',
										_reactCookie2.default.load('defaultAvilablity'),
										' Outlet'
									),
									' ',
									_react2.default.createElement(
										'p',
										null,
										'Workspace Espresso Bar ',
										_react2.default.createElement('br', null),
										' 12 Marina Boulevard',
										_react2.default.createElement('br', null),
										' Marina Bay Financial Centre Tower 3',
										_react2.default.createElement('br', null),
										' #01-08 Singapore 018982'
									)
								),
								' '
							);
						} else {
							if (_reactCookie2.default.load('outlet_option_single') === '1') {
								return _react2.default.createElement(
									'div',
									{ className: 'outlet_wrap' },
									' ',
									_react2.default.createElement(
										'div',
										{ className: 'left_t_outlet', style: { width: '99%' } },
										_react2.default.createElement(
											'h4',
											null,
											'Your ',
											_reactCookie2.default.load('defaultAvilablity'),
											' Outlet'
										),
										' ',
										_react2.default.createElement(
											'p',
											null,
											_reactCookie2.default.load('orderHandledByText'),
											' '
										)
									),
									' '
								);
							} else {
								return _react2.default.createElement(
									'div',
									{ className: 'outlet_wrap' },
									' ',
									_react2.default.createElement(
										'div',
										{ className: 'left_t_outlet', style: { width: '99%' } },
										' ',
										_react2.default.createElement(
											'span',
											{ className: 'pull-right' },
											_react2.default.createElement(
												_reactRouter.Link,
												{ style: { cursor: 'pointer', textDecoration: 'none', display: this.hideMenu() }, onClick: this.changeDeliveryAddr.bind() },
												'Change Outlet'
											)
										),
										_react2.default.createElement(
											'h4',
											null,
											'Your ',
											_reactCookie2.default.load('defaultAvilablity'),
											' Outlet'
										),
										' ',
										_react2.default.createElement(
											'p',
											null,
											_reactCookie2.default.load('orderHandledByText'),
											' '
										)
									),
									' '
								);
							}
						}
					}
				}
			}
		}, {
			key: 'findvocuherItems',
			value: function findvocuherItems() {
	
				var incrementValues = '0';
				var otherproducts = 0;
	
				if (this.state.checkItems != "") {
					var task = this.state.checkItems.map(function (item, index) {
						if (item.cart_item_product_type == '5' && item.cart_voucher_order_item_id == '0' && item.cart_item_unit_price > 0) {
							incrementValues++;
						} else {
							otherproducts++;
						}
					});
				}
				if (incrementValues > 0 && otherproducts == "0") {
					_reactCookie2.default.save("vocuherItems", '1');
				} else {
	
					_reactCookie2.default.save("vocuherItems", '0');
				}
	
				if (this.state.checkDetails != "") {
					if (this.state.cart_delivery_charge) _reactCookie2.default.save("cart_delivery_charge", this.state.checkDetails.cart_delivery_charge);
				}
			}
	
			/* this function used to load cart items */
	
		}, {
			key: 'loadCartItems',
			value: function loadCartItems() {
				var _this9 = this;
	
				return this.state.cartItems.map(function (item, index) {
					return _react2.default.createElement(
						'div',
						{ className: 'row product-holder1 top-zero', key: index },
						_this9.loadAvliablityDetails(index),
						_this9.loadiItemsCount(index),
						_react2.default.createElement(
							'div',
							{ className: 'col-lg-5 col-md-5 col-sm-5 col-xs-5 cart_com' },
							_react2.default.createElement(
								'h1',
								{ className: 'head22' },
								_react2.default.createElement(
									_reactRouter.Link /*to={"product/"+item.cart_item_product_id+"/update/"+item.cart_item_id} */,
									null,
									strp.stripslashes(item.cart_item_product_name),
									' ',
									_this9.loadModifierItems(item.cart_item_type, item.modifiers, item.set_menu_component)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-lg-2 col-md-2 col-sm-2 col-xs-2 nopadding cart_com cart_qty' },
							_react2.default.createElement(
								'div',
								{ className: 'counter-bg new_cart' },
								_react2.default.createElement(
									'div',
									{ className: 'subh count-div new_cart_bub' },
									_react2.default.createElement(
										_reactRouter.Link,
										{ className: 'btn btn-my btn-left btn-group-mini', onClick: _this9.incQty.bind(_this9, item.cart_item_id, item.cart_item_qty, item.cart_item_product_id, 'remove', item.cart_voucher_order_item_id) },
										_react2.default.createElement(
											'i',
											{ className: 'material-icons' },
											'remove'
										)
									),
									'\xA0',
									_react2.default.createElement(
										'span',
										{ className: 'head22' },
										item.cart_item_qty
									),
									' ',
									" ",
									_react2.default.createElement(
										_reactRouter.Link,
										{ className: 'btn btn-my btn-right btn-group-sm', onClick: _this9.incQty.bind(_this9, item.cart_item_id, item.cart_item_qty, item.cart_item_product_id, 'add', item.cart_voucher_order_item_id) },
										_react2.default.createElement(
											'i',
											{ className: 'material-icons' },
											'add'
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-lg-2 col-md-2 col-sm-2 col-xs-2 unit-price cart_com cart_price' },
							_react2.default.createElement(
								'h1',
								{ className: 'head222 pull-right' },
								item.cart_item_total_price,
								' '
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-lg-2 col-md-2 col-sm-2 col-xs-2 del-icon cart_com cart_delet' },
							_react2.default.createElement(
								'h1',
								{ className: 'head22 color-light-gray' },
								_react2.default.createElement(
									_reactRouter.Link,
									{ style: { cursor: 'pointer', textDecoration: 'none' }, onClick: _this9.deleteCartItem.bind(_this9, item.cart_item_id) },
									_react2.default.createElement('i', { className: 'fa fa-trash', 'aria-hidden': 'true' })
								)
							)
						)
					);
				});
			}
		}, {
			key: 'showProAvblErrorMgs',
			value: function showProAvblErrorMgs(cartItms) {
				// console.log(cartItms); return false;
				var errorMgs = '';
				var availability = _reactCookie2.default.load("defaultAvilablityId");
				var showtext = "delivery/pickup";
				if (availability === config.ids.deliveryId) {
					showtext = "delivery";
				} else if (availability === config.ids.pickupId) {
					showtext = "pickup";
				}
				if (cartItms.pro_current_datetime_avl === 'no') {
					errorMgs = 'This product is not available for order today. Please refer to the product description.';
				} else if (cartItms.pro_fullfill_datetime_avl === 'no') {
					errorMgs = 'This product is not available for ' + showtext + ' on the selected date and time. Please refer to the product description.';
				}
	
				if (errorMgs !== '') {
					return _react2.default.createElement(
						'div',
						{ className: 'pro-avbl-errormsg' },
						errorMgs
					);
				}
			}
		}, {
			key: 'showProStockErrorMgs',
			value: function showProStockErrorMgs(cartItms) {
				var errorMgs = '';
				var availability = _reactCookie2.default.load("defaultAvilablityId");
				var showtext = "delivery/pickup";
				if (availability === config.ids.deliveryId) {
					showtext = "delivery";
				} else if (availability === config.ids.pickupId) {
					showtext = "pickup";
				}
				if (cartItms.pro_current_stock_avl === 'no') {
					errorMgs = 'The selected quantity is not available for order.';
				} else if (cartItms.pro_fullfill_stock_avl === 'no') {
					errorMgs = 'The selected quantity is not available for ' + showtext + ' on the selected date and time.';
				}
	
				if (errorMgs !== '') {
					return _react2.default.createElement(
						'div',
						{ className: 'pro-avbl-errormsg' },
						errorMgs
					);
				}
			}
	
			/* this function used to load modifer items */
	
		}, {
			key: 'loadModifierItems',
			value: function loadModifierItems(itemType, modifiers, combo) {
				var len = modifiers.length;
				var comboLen = combo.length;
				var html = "<ul className='table_list cart_sub_items mod'>";
	
				if (itemType === "Modifier" && len > 0) {
					for (var i = 0, length = len; i < length; i++) {
						var modName = modifiers[i]['cart_modifier_name'];
						var modval = modifiers[i]['modifiers_values'][0]['cart_modifier_name'];
						html += "<li className='sub-item'>" + modName + " : " + modval + "</li> ";
					}
					html += "</ul>";
					var reactElement = htmlToReactParserTo.parse(html);
					return reactElement;
				} else if (itemType === "Component" && comboLen > 0) {
					for (var i = 0, length = comboLen; i < length; i++) {
						var comboName = combo[i]['menu_component_name'];
						//var comboVal =combo[i]['product_details'][0]['cart_menu_component_product_name'];
						var comboVal = this.showComboProducts(combo[i]['product_details']);
						html += " <li className='sub-item'><b>" + comboName + " :</b>" + comboVal + " " + this.showComboModifiers(combo[i]['product_details'][0]['modifiers']) + "</li> ";
	
						//html += "<li className='sub-item'><b>"+comboName+" :</b>"+comboVal+" "+ "</li> ";
					}
					html += "</ul>";
					var reactElement = htmlToReactParserTo.parse(html);
					return reactElement;
				}
			}
	
			/* show combo products  list */
	
		}, {
			key: 'showComboProducts',
			value: function showComboProducts(combos) {
				var lenCombo = combos.length;
				var html = " ";
				if (lenCombo > 0) {
					for (var r = 0, lengthCombo = lenCombo; r < lengthCombo; r++) {
						var comboPro = combos[r]['cart_menu_component_product_name'];
						var comboQty = combos[r]['cart_menu_component_product_qty'];
						var comboPrice = combos[r]['cart_menu_component_product_price'];
						var newPrice = comboPrice > 0 ? " (+" + comboPrice + ")" : "";
						html += "<li className='sub-item'>" + comboQty + " X " + strp.stripslashes(helper.getAliasName(comboPro)) + newPrice + " </li> ";
					}
					return html;
				}
				return "";
			}
	
			/* this function used to show combo modifieirs list */
	
		}, {
			key: 'showComboModifiers',
			value: function showComboModifiers(modifiers) {
				var lenMod = modifiers.length;
				var html = "<ul className='table_list cart_sub_items combo'>";
				if (lenMod > 0) {
					for (var i = 0, length = lenMod; i < length; i++) {
						var modName = modifiers[i]['cart_modifier_name'];
						var modval = modifiers[i]['modifiers_values'][0]['cart_modifier_name'];
						var modValPrice = modifiers[i]['modifiers_values'][0]['cart_modifier_price'];
						var newModValPrice = modValPrice > 0 ? " (+" + modValPrice + ")" : "";
	
						html += "<li className='sub-item'>" + modName + ": " + modval + newModValPrice + "</li> ";
					}
					html += "</ul>";
					// var reactElement = htmlToReactParserTo.parse(html );
					return html;
				}
	
				return "";
			}
	
			/* this function used to load cart itmes count */
	
		}, {
			key: 'loadiItemsCount',
			value: function loadiItemsCount(key) {
				if (key === 0) {
					_reactCookie2.default.save('cartCount', this.state.cartDetails.cart_total_items);
					return _react2.default.createElement(
						'p',
						{ className: 'cart-text' },
						'You have ',
						this.state.cartDetails.cart_total_items,
						' item(s) in your cart  ',
						_react2.default.createElement(
							'span',
							{ className: 'pull-right' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ style: { cursor: 'pointer', textDecoration: 'none' }, onClick: this.destroyCart.bind(this, "Yes") },
								'Clear Cart'
							)
						),
						' '
					);
				}
			}
	
			/* this function used to load delivery content */
	
		}, {
			key: 'loadDeliveryContent',
			value: function loadDeliveryContent(availblity) {
	
				var DelAmount = parseFloat(this.state.cartDetails.cart_delivery_charge);
				if (isNaN(DelAmount)) {
					var delivery_amount = parseFloat(_reactCookie2.default.load("cart_delivery_charge"));
				} else {
					delivery_amount = parseFloat(this.state.cartDetails.cart_delivery_charge);
				}
	
				var voucher_new = _reactCookie2.default.load('vocuherItems');
	
				if (availblity === config.ids.deliveryId && delivery_amount > 0 && voucher_new != "1") {
					return _react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'td',
							{ className: 'sub-price text-left' },
							'Delivery'
						),
						_react2.default.createElement(
							'td',
							{ className: 'sub-num text-right ' },
							parseFloat(delivery_amount).toFixed(2)
						)
					);
				}
			}
	
			/* load GST  amount */
	
		}, {
			key: 'loadTaxAmount',
			value: function loadTaxAmount(subTotal) {
	
				var outlet_tax_option = _reactCookie2.default.load('outlet_tax_option');
				var outlet_tax_surcharge = _reactCookie2.default.load('outlet_tax_surcharge');
				var outlet_tax_surcharge_inclusive = _reactCookie2.default.load('outlet_tax_surcharge_inclusive');
	
				if (outlet_tax_option == 1 && outlet_tax_surcharge > "0.00" && this.state.cartDetails.cart_availability_id != config.ids.dineinId) {
					var gstAmount = outlet_tax_surcharge;
				} else if (outlet_tax_option == 1 && outlet_tax_surcharge_inclusive > "0.00" && this.state.cartDetails.cart_availability_id != config.ids.dineinId) {
					var gstAmount = "0.00";
				} else {
					var gstAmount = parseFloat(this.state.settings.client_tax_surcharge);
				}
	
				var subTotal_delAdditnlAmount = subTotal;
	
				if (this.state.cartDetails.cart_availability_id === config.ids.deliveryId) {
	
					if (isNaN(this.state.additnl_deliveryAmnt_cal)) {
	
						var subTotal_delAdditnlAmount = parseFloat(_reactCookie2.default.load('cart_delivery_charge')) + parseFloat(subTotal);
					} else {
						var subTotal_delAdditnlAmount = parseFloat(this.state.additnl_deliveryAmnt_cal) + parseFloat(this.state.cartDetails.cart_delivery_charge) + parseFloat(subTotal);
					}
				}
	
				var displayGst = helper.getGstValue(gstAmount, subTotal_delAdditnlAmount, 'format');
	
				var voucher_new = _reactCookie2.default.load("vocuherItems");
	
				if (gstAmount > 0 && voucher_new != '1') {
					return _react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'td',
							{ className: 'sub-price text-left' },
							'GST(',
							gstAmount,
							'%)'
						),
						_react2.default.createElement(
							'td',
							{ className: 'sub-num text-right ' },
							displayGst
						)
					);
				}
			}
	
			/* load gstInclusive  amount */
	
		}, {
			key: 'showGstInclusive',
			value: function showGstInclusive(subTotal) {
	
				var outlet_tax_option = _reactCookie2.default.load('outlet_tax_option');
				var outlet_tax_surcharge = _reactCookie2.default.load('outlet_tax_surcharge');
				var outlet_tax_surcharge_inclusive = _reactCookie2.default.load('outlet_tax_surcharge_inclusive');
	
				if (outlet_tax_option == 1 && this.state.cartDetails.cart_availability_id != config.ids.dineinId) {
					if (outlet_tax_surcharge_inclusive > "0.00") {
						var gstAmount = parseFloat(outlet_tax_surcharge);
						var gstInclusive = parseFloat(outlet_tax_surcharge_inclusive);
					} else {
						var gstAmount = parseFloat(outlet_tax_surcharge);
						var gstInclusive = "0.00";
					}
				} else {
					var gstAmount = parseFloat(this.state.settings.client_tax_surcharge);
					var gstInclusive = parseFloat(this.state.settings.client_tax_surcharge_inclusive);
				}
	
				var subTotal_delAdditnlAmount = subTotal;
	
				if (this.state.cartDetails.cart_availability_id === config.ids.deliveryId) {
					var subTotal_delAdditnlAmount = parseFloat(this.state.additnl_deliveryAmnt_cal) + parseFloat(this.state.cartDetails.cart_delivery_charge) + parseFloat(subTotal);
				}
	
				var displayInclusiveGst = helper.getInclusiveGst(gstInclusive, subTotal_delAdditnlAmount, 'format');
				var voucher_new = _reactCookie2.default.load("vocuherItems");
				if (gstAmount === 0 && displayInclusiveGst != '') {
					return _react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'td',
							{ className: 'text-right displayInclusiveGst', colSpan: 2 },
							displayInclusiveGst
						)
					);
				}
			}
	
			/* this function used to load additional delivery content */
	
		}, {
			key: 'loadadditionalDeliveryContent',
			value: function loadadditionalDeliveryContent(availblity) {
				/*var delAmount = parseFloat(this.state.settings.additional_delivery_charge);*/
				var delAmount = parseFloat(this.state.additnl_deliveryAmnt_cal);
	
				var voucher_new = _reactCookie2.default.load("vocuherItems");
	
				if (availblity === config.ids.deliveryId && delAmount > 0 && voucher_new != '1') {
					return _react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'td',
							{ className: 'sub-price text-left' },
							'Additional Surcharge'
						),
						_react2.default.createElement(
							'td',
							{ className: 'sub-num text-right ' },
							delAmount.toFixed(2)
						)
					);
				}
			}
	
			/* show final tottal */
	
		}, {
			key: 'showFinalTotal',
			value: function showFinalTotal(grandTotal) {
				var subTotal = parseFloat(this.state.cartDetails.cart_sub_total);
	
				var outlet_tax_option = _reactCookie2.default.load('outlet_tax_option');
				var outlet_tax_surcharge = _reactCookie2.default.load('outlet_tax_surcharge');
				var outlet_tax_surcharge_inclusive = _reactCookie2.default.load('outlet_tax_surcharge_inclusive');
	
				if (outlet_tax_option == 1 && outlet_tax_surcharge > "0.00" && this.state.cartDetails.cart_availability_id != config.ids.dineinId) {
					var gstAmount = outlet_tax_surcharge;
				} else if (outlet_tax_option == 1 && outlet_tax_surcharge_inclusive > "0.00" && this.state.cartDetails.cart_availability_id != config.ids.dineinId) {
					var gstAmount = "0.00";
				} else {
					var gstAmount = parseFloat(this.state.settings.client_tax_surcharge);
				}
	
				// var subTotal_delivery_amt = subTotal;
				// if(this.state.cartDetails.cart_availability_id == config.ids.deliveryId) {
				// var subTotal_delivery_amt = parseFloat(this.state.additnl_deliveryAmnt_cal) + parseFloat(this.state.cartDetails.cart_delivery_charge) + subTotal;
				// }
	
				var subTotal_delivery_amt = subTotal;
	
				if (this.state.cartDetails.cart_availability_id === config.ids.deliveryId) {
					if (isNaN(parseFloat(this.state.additnl_deliveryAmnt_cal) && parseFloat(this.state.cartDetails.cart_delivery_charge))) {
	
						var subTotal_delivery_amt = parseFloat(_reactCookie2.default.load('cart_delivery_charge')) + parseFloat(subTotal);
					} else {
	
						subTotal_delivery_amt = parseFloat(this.state.additnl_deliveryAmnt_cal) + parseFloat(this.state.cartDetails.cart_delivery_charge) + parseFloat(subTotal);
					}
				} /*var displayGst = helper.getGstValue(gstAmount,subTotal,'format');*/
	
				var displayGst = helper.getGstValue(gstAmount, subTotal_delivery_amt, 'format');
	
				/*var delAmount = parseFloat(this.state.settings.additional_delivery_charge) + parseFloat(grandTotal) + parseFloat(displayGst);*/
	
				var voucher_new = _reactCookie2.default.load("vocuherItems");
	
				if (voucher_new != '1') {
					var delAmount = parseFloat(this.state.additnl_deliveryAmnt_cal) + parseFloat(grandTotal) + parseFloat(displayGst);
				} else {
					var delAmount = subTotal;
				}
	
				if (isNaN(delAmount)) {
					//return "";
					//var defaultAmount = parseFloat(this.state.cartDetails.cart_sub_total) + parseFloat(cookie.load("cart_delivery_charge")) + parseFloat(displayGst);
					//return defaultAmount.toFixed(2);
	
				} else {
					return delAmount.toFixed(2);
				}
			}
	
			/* this  function used to load min order percentage */
	
		}, {
			key: 'loadMinOrderPercentage',
			value: function loadMinOrderPercentage(availblity) {
				var minAmount = this.state.settings.callcnter_min_amount;
				var remainAmnt = this.state.minOrderRemaingAmnt;
				if (availblity === config.ids.deliveryId && minAmount > 0 && remainAmnt > 0) {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'progress' },
							_react2.default.createElement('div', { className: "progress-bar progress-bar-danger", style: { width: this.state.minOrderPercentage + "%" } })
						),
						_react2.default.createElement(
							'p',
							{ className: 'text-center' },
							_react2.default.createElement(
								'b',
								null,
								currency + this.state.minOrderRemaingAmnt,
								' more to min order amount.'
							)
						)
					);
				}
			}
	
			/* this  function used to load delivery percentage */
	
		}, {
			key: 'loadDeliveryPercentage',
			value: function loadDeliveryPercentage(availblity) {
				var freeDeliveryAmnt = this.state.settings.client_free_delivery_amount;
				var remainAmnt = this.state.remaingAmnt;
				if (availblity === config.ids.deliveryId && (this.state.cartDetails.cart_delivery_charge > 0 || this.state.additnl_deliveryAmnt_cal > 0) && freeDeliveryAmnt > 0 && remainAmnt > 0) {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'progress' },
							_react2.default.createElement('div', { className: "progress-bar progress-bar-danger", style: { width: this.state.delPercentage + "%" } })
						),
						_react2.default.createElement(
							'p',
							{ className: 'text-center' },
							_react2.default.createElement(
								'b',
								null,
								'Spend ',
								currency + this.state.remaingAmnt,
								' more to get free delivery!'
							)
						)
					);
				}
			}
	
			/* this function used to change delivery amount */
	
		}, {
			key: 'changeDeliveryAmount',
			value: function changeDeliveryAmount(amnt, grandTotal) {
				this.setState({ cartDetails: Object.assign({}, this.state.cartDetails, { cart_delivery_charge: amnt, cart_grand_total: grandTotal }) });
				//  this.setState({cartDetails: Object.assign({}, this.state.cartDetails, {cart_delivery_charge: amnt})});
			}
	
			/* this metod used to validate cart delvery amount and next redirect URL */
	
		}, {
			key: 'validateCart',
			value: function validateCart() {
				if (this.state.cartDetails.cart_availability_id === config.ids.deliveryId) {
					var subtotal = parseFloat(this.state.cartDetails.cart_sub_total);
					var minCart = parseFloat(this.state.settings.callcnter_min_amount);
					if (subtotal < minCart) {
						helper.showInfo("A minimum order value of " + currency + minCart + " is required in order to checkout the cart. The current cart value is " + currency + subtotal + ".");
						return false;
					}
					//hashHistory.push("/add-on");
				} else {
						//hashHistory.push("/add-on");
					}
				this.nextpage();
			}
	
			/* Focus class name */
	
		}, {
			key: 'isClassName',
			value: function isClassName() {
				if (typeof _reactCookie2.default.load('product_remarks') !== "undefined" && _reactCookie2.default.load('product_remarks') !== "") {
					return 'form-group label-floating card-no is-focused special_instructions';
				} else {
					return 'form-group label-floating card-no is-empty special_instructions';
				}
			}
	
			/* show next page link */
	
		}, {
			key: 'nextpage',
			value: function nextpage() {
	
				if (typeof _reactCookie2.default.load('UserId') === "undefined" || _reactCookie2.default.load('UserId') && _reactCookie2.default.load('UserId') === "") {
					_reactRouter.hashHistory.push(this.getSignInlink());
				} else {
	
					if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId) {
						/* only for sarvesh app */
						if (APPID === "287E5552-328E-4DBE-A3CA-E998ACCAC9BD") {
							helper.sarveshTableSetup();
						} else {
							if (typeof _reactCookie2.default.load("orderOutletId") !== "undefined" && _reactCookie2.default.load("orderOutletId") !== "" && typeof _reactCookie2.default.load("orderTableNo") !== "undefined" && _reactCookie2.default.load("orderTableNo") !== "") {
								_reactRouter.hashHistory.push("/checkout");
							} else {
								_reactRouter.hashHistory.push("/book-a-table");
							}
						}
					} else {
						if (this.state.settings.client_advanced_timeslot_enable === '1') {
							_reactRouter.hashHistory.push("/delivery-date-advanced");
						} else if (this.state.settings.client_delivery_time_setting_enable === '1') {
							_reactRouter.hashHistory.push("/delivery-date-new");
						} else {
							_reactRouter.hashHistory.push("/delivery-date");
						}
					}
				}
			}
		}, {
			key: 'idReMarks',
			value: function idReMarks() {
				if (typeof _reactCookie2.default.load('product_remarks') !== "undefined" && _reactCookie2.default.load('product_remarks') !== "") {
					return _reactCookie2.default.load('product_remarks');
				} else {
					return "";
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				(0, _withTracker.loadAnalytics)();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this10 = this;
	
				var reMarkClass = _reactCookie2.default.load('product_remarks') !== "" ? "is-focused" : "";
				var reMarkVal = _reactCookie2.default.load('product_remarks') !== "" ? _reactCookie2.default.load('product_remarks') : "";
				if (this.state.status === "Loading") {
					return _react2.default.createElement(
						'div',
						{ className: 'container-fluid desktop-container position-rel', style: { minHeight: this.state.windowHeightNormal } },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(Loading, null)
						)
					);
				} else if (this.state.cartDetails.cart_total_items > 0) return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_reactDocumentMeta2.default, meta),
					_react2.default.createElement(
						'div',
						{ className: 'container-fluid desktop-container', style: { minHeight: this.state.windowHeight } },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-xs-12 top-nav inner-top-nav head-main' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-3 nav-head pd-l-20 head-child' },
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: "/" },
										_react2.default.createElement('img', { src: '/img/icons/arrow-right.png', className: 'icon-img-small-3', alt: 'left-arrow' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-6 nav-head  head-child' },
									_react2.default.createElement(
										'h1',
										{ className: 'main-title' },
										'CART'
									)
								),
								_react2.default.createElement('div', { className: 'col-xs-3 nopadding  head-child' })
							)
						),
						this.loadCartItems(),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement('div', { className: 'col-lg-7 col-md-7 col-sm-7' }),
							_react2.default.createElement(
								'div',
								{ className: 'col-sm-5' },
								_react2.default.createElement(
									'table',
									{ className: 'sub-price-table', style: { border: 0 } },
									_react2.default.createElement(
										'tbody',
										null,
										_react2.default.createElement(
											'tr',
											null,
											_react2.default.createElement(
												'td',
												{ className: 'sub-price text-left' },
												'Sub Total'
											),
											_react2.default.createElement(
												'td',
												{ className: 'sub-num text-right ' },
												parseFloat(this.state.cartDetails.cart_sub_total).toFixed(2)
											)
										),
										this.loadDeliveryContent(this.state.cartDetails.cart_availability_id),
										this.loadadditionalDeliveryContent(this.state.cartDetails.cart_availability_id),
										this.loadTaxAmount(this.state.cartDetails.cart_sub_total),
										_react2.default.createElement(
											'tr',
											null,
											_react2.default.createElement(
												'td',
												{ colSpan: '2' },
												_react2.default.createElement('hr', null)
											)
										),
										_react2.default.createElement(
											'tr',
											null,
											_react2.default.createElement(
												'td',
												{ className: 'total' },
												'Total'
											),
											_react2.default.createElement(
												'td',
												{ className: ' text-right total-num' },
												this.showFinalTotal(this.state.cartDetails.cart_grand_total)
											)
										),
										this.showGstInclusive(this.state.cartDetails.cart_sub_total)
									)
								),
								this.loadMinOrderPercentage(this.state.cartDetails.cart_availability_id),
								this.loadDeliveryPercentage(this.state.cartDetails.cart_availability_id)
							),
							_react2.default.createElement('div', { className: 'clearfix' }),
							_react2.default.createElement('div', { className: 'space-5' }),
							_react2.default.createElement(
								'div',
								{ className: 'col-xs-12' },
								_react2.default.createElement(
									'div',
									{ className: this.isClassName() },
									_react2.default.createElement(
										'div',
										{ className: 'input-group' },
										_react2.default.createElement(
											'label',
											{ className: 'control-label', htmlFor: 'remarks' },
											APPID === 'CD8D5FE3-0586-44DD-9360-EE9DEF351223' ? 'Please enter your Berth number , Quay Crane and Yard location here' : 'Special Instructions...'
										),
										_react2.default.createElement('textarea', { type: 'text', id: 'remarks', defaultValue: this.idReMarks(), className: APPID === 'CD8D5FE3-0586-44DD-9360-EE9DEF351223' ? 'form-control port_makan cart_text_area' : 'form-control cart_text_area', cols: '5', rows: '2', onChange: this.handleChange })
									)
								)
							)
						),
						_react2.default.createElement('div', { className: 'space-5' }),
						_react2.default.createElement('div', { className: 'space-5' }),
						_react2.default.createElement('div', { className: 'space-5' }),
						_react2.default.createElement('div', { className: 'space-5' }),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ onClick: this.validateCart.bind(this) },
								_react2.default.createElement(
									'button',
									{ className: 'col-lg-12 continue-but desktop-container main-title container-fluid' },
									'CONTINUE'
								)
							),
							'            '
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'modal', id: 'Pickup-Sucess' },
						_react2.default.createElement(
							'div',
							{ className: 'modal-dialog PopupWidth' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-content' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-header' },
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
										_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: '' })
									),
									_react2.default.createElement(
										'h4',
										{ className: 'modal-title' },
										_react2.default.createElement('img', { src: '/img/icons/DeliverySucess.png', className: 'img-responsive', alt: '' }),
										'Awesome, you can pickup !'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'modal-body text-center' },
									this.showDeliveryTiming,
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										'button',
										{ type: 'button', onClick: this.pickupSuccess.bind(this), className: 'btn btn-raised btn-info ' },
										'Continue'
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement('br', null)
								),
								_react2.default.createElement('div', { className: 'modal-footer' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'modal', id: 'ShopClosedError' },
						_react2.default.createElement(
							'div',
							{ className: 'modal-dialog PopupWidth' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-content' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-header' },
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
										_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: '' })
									),
									_react2.default.createElement(
										'h4',
										{ className: 'modal-title' },
										_react2.default.createElement('img', { src: '/img/icons/Cant_Deliver.png', className: 'img-responsive', alt: '' }),
										'Sorry !'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'modal-body' },
									_react2.default.createElement(
										'p',
										null,
										_react2.default.createElement(
											'b',
											null,
											'Outlet Closed Temporarily. Please Try again later'
										),
										' '
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										'div',
										{ className: 'col-sm-12' },
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.closeShopClosedError.bind(this), className: 'col-lg-6 btn btn-raised btn-info fullwidth ' },
											'Check Later'
										)
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement('br', null),
									_react2.default.createElement('br', null)
								),
								_react2.default.createElement('div', { className: 'modal-footer' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'modal', id: 'DeliveryError' },
						_react2.default.createElement(
							'div',
							{ className: 'modal-dialog PopupWidth' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-content' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-header' },
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
										_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: '' })
									),
									_react2.default.createElement(
										'h4',
										{ className: 'modal-title' },
										_react2.default.createElement('img', { src: '/img/icons/Cant_Deliver.png', className: 'img-responsive', alt: '' }),
										'Sorry !'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'modal-body' },
									_react2.default.createElement(
										'p',
										null,
										'Sorry we cant deliver to your address ',
										_react2.default.createElement('br', null),
										'Do you want to change your address or check again later ?'
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										'div',
										{ className: 'col-sm-6' },
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.closeDeliveryErr.bind(this), className: 'col-lg-6 btn btn-raised btn-info fullwidth ' },
											'Check Later'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-sm-6' },
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.changeDelivery.bind(this), className: 'col-lg-6 btn btn-raised btn-info fullwidth ' },
											'Change Address'
										)
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement('br', null),
									_react2.default.createElement('br', null)
								),
								_react2.default.createElement('div', { className: 'modal-footer' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'modal', id: 'DeliverySucess' },
						_react2.default.createElement(
							'div',
							{ className: 'modal-dialog PopupWidth' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-content' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-header' },
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
										_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
									),
									_react2.default.createElement(
										'h4',
										{ className: 'modal-title' },
										_react2.default.createElement('img', { src: '/img/icons/DeliverySucess.png', className: 'img-responsive', alt: 'thumb-up' }),
										'Awesome, we can deliver!'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'modal-body text-center' },
									_react2.default.createElement(
										'p',
										null,
										_react2.default.createElement(
											'b',
											null,
											'Your Delivery Address: '
										),
										_react2.default.createElement('br', null),
										this.state.orderDeliveryAddress
									),
									this.showdeliveryTiming,
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										'button',
										{ type: 'button', onClick: this.deliverySuccess.bind(this), className: 'btn btn-raised btn-info ' },
										'Continue'
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement('br', null)
								),
								_react2.default.createElement('div', { className: 'modal-footer' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'modal', id: 'DeliveryAddress' },
						_react2.default.createElement(
							'div',
							{ className: 'modal-dialog PopupWidth' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-content' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-header' },
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
										_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
									),
									_react2.default.createElement(
										'h4',
										{ className: 'modal-title' },
										'Your Delivery Address'
									)
								),
								_react2.default.createElement(Overlay, { load: this.state.load }),
								_react2.default.createElement(
									'div',
									{ className: 'modal-body' },
									_react2.default.createElement(
										'div',
										{ className: 'form-group label-floating is-empty card-no' },
										_react2.default.createElement(
											'div',
											{ className: 'input-group' },
											'\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0',
											_react2.default.createElement(
												'label',
												{ className: 'control-label' },
												'Enter Your Postal Code'
											),
											'\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0',
											_react2.default.createElement('input', { value: this.state.addressField, id: 'postalcode1', maxLength: '6', className: 'form-control', onKeyPress: function onKeyPress(e) {
													return _this10.validatezip(e);
												}, onChange: this.handleChangeValue }),
											'\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0'
										),
										'\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0'
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										'button',
										{ type: 'button', onClick: this.selectOutlet.bind(this), className: 'btn btn-raised btn-info ' },
										'Continue'
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement('br', null)
								),
								_react2.default.createElement('div', { className: 'modal-footer' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'modal', id: 'AddressList' },
						_react2.default.createElement(
							'div',
							{ className: 'modal-dialog PopupWidth' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-content' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-header' },
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
										_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: true })
									),
									_react2.default.createElement(
										'h4',
										{ className: 'modal-title' },
										_react2.default.createElement('img', { src: '/img/icons/DeliverySucess.png', className: 'img-responsive', alt: true }),
										'Your Delivery Address'
									)
								),
								_react2.default.createElement(Overlay, { load: this.state.load }),
								_react2.default.createElement(
									'div',
									{ className: 'modal-body', style: { textAlign: 'left' } },
									this.loadAddressList(),
									_react2.default.createElement(
										'p',
										null,
										'\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 ',
										_react2.default.createElement('input', { value: this.state.addressField, onChange: this.handleChangeValue, id: 'postalcode', maxLength: '6', placeholder: 'Enter Your Postal Code', className: 'add_list', onKeyPress: function onKeyPress(e) {
												return _this10.validatezip(e);
											} }),
										'\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 '
									),
									_react2.default.createElement('br', null),
									'\xA0\xA0\xA0 ',
									_react2.default.createElement(
										'button',
										{ type: 'button', onClick: this.selectOutlet.bind(this), className: 'btn btn-raised btn-info ' },
										'Continue'
									),
									'\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0',
									_react2.default.createElement('br', null),
									_react2.default.createElement('br', null),
									_react2.default.createElement('br', null)
								),
								_react2.default.createElement('div', { className: 'modal-footer' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'modal', id: 'Pickup-OutletSelection' },
						_react2.default.createElement(
							'div',
							{ className: 'modal-dialog locWidth' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-content' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-header' },
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
										_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
									),
									_react2.default.createElement(
										'h4',
										{ className: 'modal-title' },
										'Select Your Pickup Location'
									)
								),
								_react2.default.createElement(Overlay, { load: this.state.load }),
								_react2.default.createElement(
									'div',
									{ className: 'modal-body' },
									_react2.default.createElement(
										'div',
										{ className: 'map-loc' },
										_react2.default.createElement(
											'div',
											{ className: 'map-box scrollbar', id: 'style-3' },
											this.__loadOutlets()
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									)
								),
								_react2.default.createElement('div', { className: 'modal-footer' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'modal fade swithErrorCls', id: 'SwitchingError' },
						_react2.default.createElement(
							'div',
							{ className: 'modal-dialog PopupWidth' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-content' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-header' },
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
										_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: '' })
									),
									_react2.default.createElement(
										'h4',
										{ className: 'modal-title' },
										_react2.default.createElement('img', { src: '/img/icons/SwitchingError.png', className: 'img-responsive', alt: '' }),
										'Wait a second !'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'modal-body' },
									_react2.default.createElement(
										'p',
										null,
										'By switching you are about to clear your cart. ',
										_react2.default.createElement('br', null),
										'Do you wish to proceed ?'
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										'div',
										{ className: 'col-sm-6' },
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.closeSwitcher.bind(this), className: 'btn btn-raised btn-info fullwidth' },
											'Cancel'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-sm-6' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'col-lg-6 btn btn-raised btn-info fullwidth ', onClick: this.switchAvailability.bind(this) },
											'Yes Proceed'
										)
									),
									_react2.default.createElement('br', null),
									_react2.default.createElement('br', null),
									_react2.default.createElement('br', null)
								),
								_react2.default.createElement('div', { className: 'modal-footer' })
							)
						)
					)
				);else {
					return _react2.default.createElement(
						_reactRouterTransition.RouteTransition,
						{
							pathname: this.props.location.pathname,
							atEnter: { translateX: -10 },
							atLeave: { translateX: -10 },
							atActive: { translateX: 0 },
							mapStyles: function mapStyles(styles) {
								return { transform: 'translateX(' + styles.translateX + '%)' };
							}
						},
						' ',
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid desktop-container', style: { minHeight: this.state.windowHeightNormal } },
							_react2.default.createElement(_reactDocumentMeta2.default, meta),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 top-nav inner-top-nav head-main' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-3 nav-head pd-l-20 head-child' },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: "/" },
											_react2.default.createElement('img', { src: '/img/icons/arrow-right.png', className: 'icon-img-small-3', alt: 'left-arrow' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-6 nav-head head-child' },
										_react2.default.createElement(
											'h1',
											{ className: 'main-title' },
											'CART'
										)
									),
									_react2.default.createElement('div', { className: 'col-xs-3 nopadding head-child' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row product-holder1' },
								_react2.default.createElement(
									'div',
									{ className: 'empty-cart-wrap' },
									_react2.default.createElement(
										'div',
										{ className: 'rgt-top-img' },
										_react2.default.createElement('img', { src: 'img/cart-rgt-top.jpg', alt: '' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'empty-cart-order' },
										_react2.default.createElement('img', { className: 'img-responsive', src: 'img/empty-cart.png', alt: '' }),
										_react2.default.createElement(
											'h3',
											null,
											'Cart is empty'
										),
										_react2.default.createElement(
											'p',
											null,
											'You have to add something first'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: "/", className: 'btn btn-cart-order' },
											'Order Now'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'lft-btm-img' },
										_react2.default.createElement('img', { src: 'img/cart-left-btm.jpg', alt: '' })
									)
								)
							)
						),
						' '
					);
				}
			}
		}]);
	
		return Cart;
	}(_react2.default.Component);
	
	exports.default = Cart;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(9);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var strp = __webpack_require__(31);
	var config = __webpack_require__(7);
	var lang = __webpack_require__(12);
	var APIURL = config.path.apiUrl;
	var APIURLPRO = config.path.apiUrlPro;
	var APPID = config.ids.appId;
	
	var qs = __webpack_require__(3);
	var helper = __webpack_require__(13);
	var Loading = __webpack_require__(17);
	var Overlay = __webpack_require__(64);
	
	//import Map from './Map';
	
	/* Load meta tags */
	var meta = {
		title: lang.home_meta_title,
		description: lang.home_meta_title,
		meta: {
			name: {
				keywords: lang.home_meta_title
			}
		}
	};
	
	//var Loading = require('react-loading');
	
	var Cartitemsedit = function (_React$Component) {
		_inherits(Cartitemsedit, _React$Component);
	
		function Cartitemsedit(props) {
			_classCallCheck(this, Cartitemsedit);
	
			/* set default avilablity */
			var _this = _possibleConstructorReturn(this, (Cartitemsedit.__proto__ || Object.getPrototypeOf(Cartitemsedit)).call(this, props));
	
			helper.setDefaultAvailability();
	
			_this.state = { details: [], orderHandled: '', load: '', Outlets: [], markers: [], details_common: [], cartCount: 1, status: 'Loading', allowCart: 'Yes', productPrice: '', itemType: 'Simple', ModifierCount: '', windowHeight: 0, secAddrData: [], addressField: '' };
	
			/* set default cookie values */
			_reactCookie2.default.save('modiferCount', 0);
			_reactCookie2.default.save('itemType', 'Simple');
			_this.handleChange = _this.handleChange.bind(_this); //handleChangeValue
			_this.handleChangeValue = _this.handleChangeValue.bind(_this);
			return _this;
		}
	
		_createClass(Cartitemsedit, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				/* set default height */
				//this.setState('windowHeight':winHeight);
				// this.setState({windowHeight:(window.innerHeight-45)+'px'});
	
				/* API CALL FOR BANNERS */
				var productSlug = this.props.params.productSlug;
				_axios2.default.get(APIURL + 'productsver2/products_list?status=A&app_id=' + APPID + "&availability=" + _reactCookie2.default.load('defaultAvilablityId') + "&product_slug=" + productSlug).then(function (res) {
					_this2.setState({ status: res.data.status });
					if (res.data.status === "ok") {
						_this2.setState({ status: res.data.status });
						_this2.setState({ details_common: res.data.common });
						_this2.setState({ productPrice: res.data.result_set[0].product_price });
						_this2.setState({ details: res.data.result_set[0] });
						// this.setState({productPrice: res.data.result_set[0]});
					}
				});
	
				if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.pickupId && _reactCookie2.default.load('defaultAvilablity') === lang.takeaWay) {
					_axios2.default.get(APIURL + 'outlets/pickup_outlets?app_id=' + APPID).then(function (res) {
						// console.log('banner result loading done');
						if (res.data.status === "ok") {
							_this2.setState({ Status: res.data.status });
							_this2.setState({ Outlets: res.data.result_set });
							//this.loadMarkers();
						} else {
							_this2.setState({ Status: res.data.status });
						}
					});
				}
	
				/* get secondary address lits */
				if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
					this.getSecAddr();
				}
				(0, _withTracker.loadAnalytics)();
			}
	
			/* used to get all secondary address list */
	
		}, {
			key: 'getSecAddr',
			value: function getSecAddr() {
				var _this3 = this;
	
				_axios2.default.get(APIURL + '/customer/get_user_secondary_address?app_id=' + APPID + "&refrence=" + _reactCookie2.default.load('UserId')).then(function (res) {
					if (res.data.status === "ok") {
						_this3.setState({ secAddrData: res.data.result_set });
					}
				});
			}
		}, {
			key: 'handleChange',
			value: function handleChange(event) {
				//alert(event.target.value);
				this.setState({ addressField: event.target.value });
			}
		}, {
			key: 'handleChangeValue',
			value: function handleChangeValue(event) {
				this.setState({ addressField: event.target.value });
			}
			/* used to load address list */
	
		}, {
			key: 'loadAddressList',
			value: function loadAddressList() {
				var _this4 = this;
	
				return this.state.secAddrData.map(function (item, index) {
					return _react2.default.createElement(
						'p',
						{ key: index },
						_react2.default.createElement('input', { name: 'radio', value: item.postal_code, id: item.secondary_address_id, className: 'css-radio', type: 'radio', onChange: _this4.handleChange }),
						_react2.default.createElement(
							'label',
							{ htmlFor: item.secondary_address_id, className: 'css-label ' },
							' ',
							item.address + " Singapore " + item.postal_code
						)
					);
				});
			}
			/* this function used to load default billing address */
	
		}, {
			key: 'loadDefaultAddress',
			value: function loadDefaultAddress() {
				if (typeof _reactCookie2.default.load('UserDefaultAddress') !== "undefined" && _reactCookie2.default.load('UserDefaultAddress') !== "" && typeof _reactCookie2.default.load('UserDefaultPostalCode') !== "undefined" && _reactCookie2.default.load('UserDefaultPostalCode') !== "") {
					return _react2.default.createElement(
						'p',
						null,
						_react2.default.createElement('input', { name: 'radio', value: _reactCookie2.default.load('UserDefaultPostalCode'), id: 'defaultAdd', className: 'css-radio', type: 'radio', onChange: this.handleChange }),
						_react2.default.createElement(
							'label',
							{ htmlFor: 'defaultAdd', className: 'css-label ' },
							' ',
							_reactCookie2.default.load('UserDefaultAddress') + " Singapore " + _reactCookie2.default.load('UserDefaultPostalCode')
						)
					);
				}
			}
	
			/* this function used to load cart icon image */
	
		}, {
			key: 'loadCartImage',
			value: function loadCartImage() {
				return (0, _Api2.default)('cartImage', 'Yes');
			}
	
			/* show product thump image */
	
		}, {
			key: '__productImage',
			value: function __productImage(product_thumbnail) {
				return product_thumbnail === "" ? config.noImages.product_listing : this.state.details_common.image_source + "/" + product_thumbnail;
			}
			/* load product image */
	
		}, {
			key: 'loadProductImage',
			value: function loadProductImage(product_thumbnail) {
				if (product_thumbnail !== "" && typeof product_thumbnail !== "undefined") {
					return _react2.default.createElement(
						'div',
						{ className: 'row no-bar-image' },
						' ',
						_react2.default.createElement('img', { src: config.path.tinThumpUrl + this.state.details_common.image_source + "/" + product_thumbnail + "&w=768&h=264&q=80", alt: 'banner', className: 'img-responsive' }),
						' '
					);
				}
			}
		}, {
			key: 'loadMarkers',
			value: function loadMarkers() {
	
				var markers = [];
				this.state.Outlets.map(function (data, index) {
					var markerinfo = {
						'position': new google.maps.LatLng(data.outlet_marker_latitude, data.outlet_marker_longitude),
						showInfo: false,
						infoContent: _react2.default.createElement(
							'div',
							null,
							data.outlet_name
						)
					};
					markers[index] = markerinfo;
				});
				this.setState({ markers: markers });
			}
	
			/* checkActive */
	
		}, {
			key: 'checkActive',
			value: function checkActive() {}
	
			/* show modifiers values */
	
		}, {
			key: 'showModifiers',
			value: function showModifiers(modVal) {
				var _this5 = this;
	
				//console.log(modVal);
				if (modVal) {
					var modLen = modVal.length;
					return modVal.map(function (item, index) {
						return _react2.default.createElement(
							'div',
							{ className: 'panel panel-default', key: index },
							_react2.default.createElement(
								'div',
								{ className: 'panel-heading', role: 'tab', id: "modHead" + index },
								_react2.default.createElement(
									'h4',
									{ className: 'panel-title' },
									_react2.default.createElement(
										_reactRouter.Link,
										{ className: 'collapsed', onClick: _this5.checkActive.bind(), 'data-toggle': 'collapse', 'data-parent': '#accordion', to: "#collapse" + index, 'aria-expanded': 'true', 'aria-controls': 'collapseTwo' },
										strp.stripslashes(item.pro_modifier_name)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: "collapse" + index, className: 'panel-collapse collapse in', role: 'tabpanel', 'aria-labelledby': "modHead" + index },
								_react2.default.createElement(
									'div',
									{ className: 'panel-body' },
									_this5.showModifierItems(item.modifiers_values, index, modLen, item.pro_modifier_name, item.pro_modifier_id)
								)
							)
						);
					});
				}
			}
	
			/* show set products values */
	
		}, {
			key: 'showSetMeal',
			value: function showSetMeal(isCombo, mealVal) {
				var _this6 = this;
	
				if (isCombo === "Yes") {
					var mealLength = mealVal.length;
	
					if (mealLength > 0) {
	
						return mealVal.map(function (item, index) {
							return _react2.default.createElement(
								'div',
								{ className: 'panel panel-default', key: index },
								_react2.default.createElement(
									'div',
									{ className: 'panel-heading', role: 'tab', id: "headingTwo" + index },
									_react2.default.createElement(
										'h4',
										{ className: 'panel-title' },
										_react2.default.createElement(
											_reactRouter.Link,
											{ className: 'collapsed', onClick: _this6.checkActive.bind(), 'data-toggle': 'collapse', 'data-parent': '#accordion', to: "#collapse" + index, 'aria-expanded': 'true', 'aria-controls': 'collapseTwo' },
											strp.stripslashes(item.menu_set_component_name)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ id: "collapse" + index, className: 'panel-collapse collapse in', role: 'tabpanel', 'aria-labelledby': "headingTwo" + index },
									_react2.default.createElement(
										'div',
										{ className: 'panel-body' },
										_this6.showSetMealProducts(item.product_details, index, mealLength, item.menu_component_name, item.menu_component_id, item.menu_component_default_select, item.menu_component_min_select, item.menu_component_max_select)
									)
								)
							);
						});
					}
				}
			}
	
			/* show & hide set meal modifier child products */
	
		}, {
			key: 'showModDiv',
			value: function showModDiv(modifiers, setIndex, mindex) {
				var modLen = modifiers !== null ? modifiers.length : 0;
				var elems = document.getElementsByClassName('modDiv' + setIndex);
				for (var i = 0; i < elems.length; i++) {
					elems[i].style.display = 'none';
				}
				if (modLen > 0) {
					var showEle = document.getElementsByClassName('modDiv_' + setIndex + mindex);
					showEle[0].style.display = 'block';
				}
			}
	
			/* if modifier products selected show modifer div */
	
		}, {
			key: 'modifierDefault',
			value: function modifierDefault(isDefault, productId, modVal) {
				var modLen = modVal !== null ? modVal.length : 0;
				return isDefault === productId && modLen > 0 ? 'block' : 'none';
			}
	
			/* this fucntion used to show set items list */
	
		}, {
			key: 'showSetMealProducts',
			value: function showSetMealProducts(products, mIndex, length, comboName, comboId, isDefault, minSelect, maxSelect) {
				var _this7 = this;
	
				//console.log(products);
				var totalLen = products.length;
				var modItemLen = totalLen - 1;
				if (totalLen === 0) {
					alert('Products items missing');
					_reactRouter.hashHistory.push("/");
				}
	
				/*  Modifer count */
				_reactCookie2.default.save('comboCount', length);
				_reactCookie2.default.save('itemType', 'Combo');
	
				return products.map(function (item, index) {
					return _react2.default.createElement(
						'div',
						{ className: _this7.showArrow(modItemLen, index), key: index },
						_react2.default.createElement(
							'h1',
							{ className: 'bb-txt2 margin-15' },
							strp.stripslashes(item[0].product_name),
							_react2.default.createElement(
								'div',
								{ className: 'radio  pull-right' },
								_react2.default.createElement('input', { className: 'css-radio', type: 'radio', value: comboName + "~" + comboId + "~" + item[0].product_name + "~" + item[0].product_id + "~" + item[0].product_sku, id: item[0].product_id + "_" + mIndex + "_" + index, name: "comboVal_" + mIndex, defaultChecked: _this7.defaultSetMeal(isDefault, item[0].product_id), onChange: _this7.showModDiv.bind(_this7, item[0].modifiers, mIndex, index) }),
								_react2.default.createElement('label', { htmlFor: item[0].product_id + "_" + mIndex + "_" + index, className: 'css-label' })
							)
						),
						_react2.default.createElement(
							'div',
							{ style: { display: _this7.modifierDefault(isDefault, item[0].product_id, item[0].modifiers) }, className: "modDiv" + mIndex + " modDiv_" + mIndex + index, id: "parDiv" + item[0].product_id + mIndex },
							_this7.showSetMealModifeirs(item[0].modifiers, item[0].product_id, mIndex, index)
						)
					);
				});
			}
	
			/* load set meal modifiers items */
	
		}, {
			key: 'showSetMealModifeirs',
			value: function showSetMealModifeirs(modifiers, productId, mIndex, pIndex) {
				var _this8 = this;
	
				var modLen = modifiers !== null ? modifiers.length : 0;
				if (modLen > 0) {
					return modifiers.map(function (modItems, index) {
						return _react2.default.createElement(
							'div',
							{ className: "fancy-collapse-panel fancy-collapse-inner" + "  setModValClass" + productId + mIndex, key: index },
							_react2.default.createElement(
								'div',
								{ className: 'panel-group', id: "accordion2" + index + mIndex, role: 'tablist', 'aria-multiselectable': 'true' },
								_react2.default.createElement(
									'div',
									{ className: 'panel panel-default' },
									_react2.default.createElement(
										'div',
										{ className: 'panel-heading', role: 'tab', id: "modHeadingTwo" + index + mIndex + pIndex },
										_react2.default.createElement(
											'h4',
											{ className: 'panel-title' },
											_react2.default.createElement(
												'a',
												{ className: 'collapsed', 'data-toggle': 'collapse', 'data-parent': "#accordion2" + index + mIndex, href: "#collapse_flavour" + index + mIndex + pIndex, 'aria-expanded': 'true', 'aria-controls': 'collapseTwo' },
												_react2.default.createElement('img', { src: '/img/share.png' }),
												modItems.pro_modifier_name
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ id: "collapse_flavour" + index + mIndex + pIndex, className: "panel-collapse collapse in ", role: 'tabpanel', 'aria-labelledby': "modHeadingTwo" + index + mIndex + pIndex },
										_react2.default.createElement(
											'div',
											{ className: 'panel-body' },
											_this8.showSetMealModifierItems(modItems.modifiers_values, index, modLen, modItems.pro_modifier_name, modItems.pro_modifier_id, productId, mIndex, pIndex)
										)
									)
								)
							)
						);
					});
				}
			}
	
			/* this function used to show  set meal products modifier items */
	
			/* this fucntion used to show modifer items */
	
		}, {
			key: 'showSetMealModifierItems',
			value: function showSetMealModifierItems(modVal, mIndex, length, modName, modId, productId, setIndex, pIndex) {
				var _this9 = this;
	
				//alert(setIndex);
				var totalLen = modVal.length;
				var modItemLen = totalLen - 1;
				if (totalLen === 0) {
					alert('Modifier items missing');
					_reactRouter.hashHistory.push("/");
				}
				/* set modifier cosunt value */
				//alert(productId+"->"+length);
				//this.setState({productId: length});
				/* set modifier count cooki values */
				//this.setState({productId: length})  
				/*
	    if(typeof cookie.load(productId)==="undefined" || cookie.load(productId) ==="" ){
	    this.setState({productId: length})  
	    }else {
	    alert(cookie.load(productId));
	    } */
				//cookie.save(length,length  );
				//this.setState({"productID": '4'})  
				/*onChange={this.validateModifier.bind(this,length,modName,modId,item.pro_modifier_value_name,item.pro_modifier_value_id,item.pro_modifier_value_price,productId)} */
				/*  Modifer count */
				//cookie.save('modiferCount',length  );
				// cookie.save('itemType','Modifier' );
	
				return modVal.map(function (item, index) {
					return _react2.default.createElement(
						'div',
						{ className: _this9.showArrow(modItemLen, index), key: index },
						_react2.default.createElement(
							'h1',
							{ className: 'bb-txt2 margin-15' },
							strp.stripslashes(item.pro_modifier_value_name),
							_react2.default.createElement(
								'div',
								{ className: 'radio  pull-right' },
								_react2.default.createElement('input', {
									className: 'css-radio', type: 'radio', value: modName + "~" + modId + "~" + item.pro_modifier_value_name + "~" + item.pro_modifier_value_id + "~" + item.pro_modifier_value_price, id: item.pro_modifier_value_id + "_" + setIndex + "_" + pIndex + "_" + mIndex + "_" + index, name: "modValItems" + productId + "-" + setIndex + "-" + mIndex, defaultChecked: _this9.isDefault(item.pro_modifier_value_is_default)
								}),
								_react2.default.createElement('label', { htmlFor: item.pro_modifier_value_id + "_" + setIndex + "_" + pIndex + "_" + mIndex + "_" + index, className: 'css-label' })
							)
						)
					);
				});
			}
	
			/* choose defaultg set meal product */
	
		}, {
			key: 'defaultSetMeal',
			value: function defaultSetMeal(isDefault, productId) {
				return isDefault === productId ? true : false;
			}
	
			/* load outlets */
	
		}, {
			key: '__loadOutlets',
			value: function __loadOutlets() {
				var _this10 = this;
	
				if (this.state.Outlets) {
					return this.state.Outlets.map(function (loaddata, index) {
						return _react2.default.createElement(
							'div',
							{ className: 'map-li', key: index, onClick: _this10.pickOutlet.bind(_this10, loaddata.outlet_id, loaddata.outlet_name, loaddata.outlet_postal_code, loaddata.outlet_address_line1, loaddata.outlet_address_line2, loaddata.outlet_unit_number1, loaddata.outlet_unit_number2, loaddata.outlet_pickup_tat, loaddata.outlet_tax_option, loaddata.outlet_tax_surcharge, loaddata.outlet_tax_surcharge_inclusive) },
							_react2.default.createElement(
								'p',
								{ className: 'map-h' },
								loaddata.outlet_name
							),
							_react2.default.createElement(
								'p',
								{ className: 'map-sub' },
								loaddata.outlet_address_line1 + ", " + loaddata.outlet_address_line2 + " " + loaddata.outlet_postal_code
							)
						);
					});
				}
			}
	
			/* this fucntion used to show modifer items */
	
		}, {
			key: 'showModifierItems',
			value: function showModifierItems(modVal, mIndex, length, modName, modId) {
				var _this11 = this;
	
				//console.log(modVal);
				var totalLen = modVal.length;
				var modItemLen = totalLen - 1;
				if (totalLen === 0) {
					alert('Modifier items missing');
					_reactRouter.hashHistory.push("/");
				}
	
				/*  Modifer count */
				_reactCookie2.default.save('modiferCount', length);
				_reactCookie2.default.save('itemType', 'Modifier');
	
				return modVal.map(function (item, index) {
					return _react2.default.createElement(
						'div',
						{ className: _this11.showArrow(modItemLen, index), key: index },
						_react2.default.createElement(
							'h1',
							{ className: 'bb-txt2 margin-15' },
							strp.stripslashes(item.pro_modifier_value_name) + _this11.modifierPrice(item.pro_modifier_value_price),
							_react2.default.createElement(
								'div',
								{ className: 'radio  pull-right' },
								_react2.default.createElement('input', { className: 'css-radio', type: 'radio', value: modName + "~" + modId + "~" + item.pro_modifier_value_name + "~" + item.pro_modifier_value_id + "~" + item.pro_modifier_value_price, id: item.pro_modifier_value_id, name: "modVal_" + mIndex, defaultChecked: _this11.isDefault(item.pro_modifier_value_is_default, modName, modId, item.pro_modifier_value_name, item.pro_modifier_value_id, item.pro_modifier_value_price), onChange: _this11.validateModifier.bind(_this11, length, modName, modId, item.pro_modifier_value_name, item.pro_modifier_value_id, item.pro_modifier_value_price, '') }),
								_react2.default.createElement('label', { htmlFor: item.pro_modifier_value_id, className: 'css-label' })
							)
						)
					);
				});
			}
	
			/* show  modifier extra amount */
	
		}, {
			key: 'modifierPrice',
			value: function modifierPrice(price) {
				return price > 0 ? " (+" + price + ")" : "";
			}
	
			/* this function used to validate modifer values */
	
		}, {
			key: 'validateModifier',
			value: function validateModifier(ModifierLen, modName, modId, modValName, modValId, modValPrice, productId) {
				var _this12 = this;
	
				//alert(productId);
				var allModVal = "";
				var commaVal = ModifierLen - 1;
				var sts = "Fail";
				//console.log(modName + "_"+modId+" - "+modValName+"-"+modValId+"-"+modValPrice);
				for (var i = 0, length = ModifierLen; i < length; i++) {
					var inputName = "modVal_" + i;
					if (document.querySelector('input[name = ' + inputName + ']:checked')) {
						var modVal = document.querySelector('input[name = ' + inputName + ']:checked').value;
						var res = modVal.split("~");
						if (modVal === "") {
							sts = "Fail";
							document.getElementById("addToCart").disabled = true;
							alert(lang.select_all_modofier);
							break;
						} else {
							sts = "Success";
							document.getElementById("addToCart").disabled = false;;
							var strt = i === commaVal ? res[3] : res[3] + ";";
							allModVal += strt;
							/* post data */
						}
					} else {
						sts = "Fail";
						document.getElementById("addToCart").disabled = true;
						alert(lang.select_all_modofier);
						break;
					}
				}
				if (sts === "Success") {
					/* for normal modifiers get state value, set meal product pass param */
					productId = productId === "" ? this.state.details.product_id : productId;
	
					//alert(productId);
					_axios2.default.get(APIURLPRO + 'products/validate_product?app_id=' + APPID + "&product_id=" + productId + "&modifier_value_id=" + allModVal).then(function (res) {
	
						/* Success response */
						if (res.data.status === "ok") {
							_this12.setState({ sts: 'No' });
							_this12.setState({ allowCart: 'Yes' });
							_this12.setState({ productPrice: res.data.result_set[0].product_price });
						}
						/* Error response */
						if (res.data.status === "error") {
							alert(res.data.message);
							_this12.setState({ allowCart: 'No' });
							document.getElementById("addToCart").disabled = true;
						}
					});
				}
			}
	
			/* this function used to checked radio value */
	
		}, {
			key: 'isDefault',
			value: function isDefault(select) {
				return select === "Yes" ? true : false;
			}
	
			/* this function used to show show  arrow*/
	
		}, {
			key: 'showArrow',
			value: function showArrow(len, index) {
				return len === index ? "" : "acrow";
			}
	
			/* increase cart qty */
	
		}, {
			key: 'iQty',
			value: function iQty() {
				this.setState({ cartCount: this.state.cartCount + 1 });
			}
	
			/* decrease cart qty */
	
		}, {
			key: 'dQty',
			value: function dQty() {
				if (this.state.cartCount !== 1) {
					this.setState({ cartCount: this.state.cartCount - 1 });
				}
			}
	
			/* pick outlet */
	
		}, {
			key: 'pickOutlet',
			value: function pickOutlet(outlet_id, outlet_name, outlet_postal_code, outlet_address_line1, outlet_address_line2, outlet_unit_number1, outlet_unit_number2, outlet_pickup_tat, outlet_tax_option, outlet_tax_surcharge, outlet_tax_surcharge_inclusive) {
	
				var orderHandled = outlet_name + " " + outlet_address_line1 + " " + outlet_address_line2 + ", Singapore " + outlet_postal_code;
				//console.log(outlet_id+outlet_postal_code)
				this.setState({ orderHandled: orderHandled });
				_reactCookie2.default.save('orderOutletId', outlet_id);
				_reactCookie2.default.save('orderOutletName', outlet_name);
				_reactCookie2.default.save('orderPostalCode', outlet_postal_code);
				_reactCookie2.default.save('orderTAT', outlet_pickup_tat);
				_reactCookie2.default.save('orderHandled', orderHandled);
	
				_reactCookie2.default.save('outlet_tax_option', outlet_tax_option);
				_reactCookie2.default.save('outlet_tax_surcharge', outlet_tax_surcharge);
				_reactCookie2.default.save('outlet_tax_surcharge_inclusive', outlet_tax_surcharge_inclusive);
	
				$("#Pickup-OutletSelection").modal("toggle");
				$("#Pickup-Sucess").modal("toggle");
			}
	
			/* continue with pickup success */
	
		}, {
			key: 'pickupSuccess',
			value: function pickupSuccess() {
				var productId = this.state.productId;
				var proName = this.state.proName;
				var prosku = this.state.prosku;
				var proPrice = this.state.proPrice;
				var proQty = this.state.proQty;
				var proImage = this.state.proImage;
				var allowCart = this.state.allowCart;
				$("#Pickup-Sucess").modal("toggle");
				this.addToCart(productId, proName, prosku, proPrice, proQty, proImage, allowCart);
			}
	
			/* continue with delivery success */
	
		}, {
			key: 'deliverySuccess',
			value: function deliverySuccess() {
				var productId = this.state.productId;
				var proName = this.state.proName;
				var prosku = this.state.prosku;
				var proPrice = this.state.proPrice;
				var proQty = this.state.proQty;
				var proImage = this.state.proImage;
				var allowCart = this.state.allowCart;
				$("#DeliverySucess").modal("toggle");
				this.addToCart(productId, proName, prosku, proPrice, proQty, proImage, allowCart);
			}
	
			/* Select outlet */
	
		}, {
			key: 'selectOutlet',
			value: function selectOutlet() {
				var _this13 = this;
	
				if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
					var postalcode = $("#postalcode").val(); //"postalcode";
				} else {
					postalcode = $("#postalcode1").val(); // "postalcode1";
				}
	
				if (postalcode.length < 5) {
					return false;
				}
	
				this.setState({ load: "true" });
	
				/*add loading */
				_axios2.default.get(APIURL + 'outlets/find_outlet?app_id=' + APPID + "&availability_id=" + _reactCookie2.default.load('defaultAvilablityId') + "&postal_code=" + postalcode).then(function (res) {
	
					/* Success response */
					/* Success response  && Object.keys(res.data.result_set.postal_code_information).length !==0 */
					if (res.data.status === "ok") {
						/*if(Object.keys(res.data.result_set.postal_code_information).length !==0)
	     { */
						var orderDeliveryAddress = res.data.result_set.postal_code_information.zip_buno + " " + res.data.result_set.postal_code_information.zip_sname;
						var orderHandled = res.data.result_set.outlet_name + ", Crew will be seeing you in " + res.data.result_set.outlet_delivery_timing + " Minutes";
						_this13.setState({ orderDeliveryAddress: orderDeliveryAddress + " Singapore " + res.data.result_set.postal_code_information.zip_code });
						_this13.setState({ orderHandled: orderHandled });
						_reactCookie2.default.save('orderOutletId', res.data.result_set.outlet_id);
						_reactCookie2.default.save('orderOutletName', res.data.result_set.outlet_name);
						_reactCookie2.default.save('orderPostalCode', res.data.result_set.postal_code_information.zip_code);
						_reactCookie2.default.save('orderTAT', res.data.result_set.outlet_delivery_tat);
						_reactCookie2.default.save('orderDeliveryAddress', orderDeliveryAddress);
						_reactCookie2.default.save('orderHandled', orderHandled);
	
						_reactCookie2.default.save('outlet_tax_option', res.data.result_set.outlet_tax_option);
						_reactCookie2.default.save('outlet_tax_surcharge', res.data.result_set.outlet_tax_surcharge);
						_reactCookie2.default.save('outlet_tax_surcharge_inclusive', res.data.result_set.outlet_tax_surcharge_inclusive);
	
						if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
							$("#AddressList").modal("toggle");
						} else {
							$("#DeliveryAddress").modal("toggle");
						}
						$("#DeliverySucess").modal("toggle");
	
						/* }else{
	     	 $("#DeliveryAddress").modal("toggle");
	     	 $("#DeliveryError").modal("toggle");
	      } */
					}
					/* Error response */
					if (res.data.status === "error") {
						if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
							$("#AddressList").modal("toggle");
						} else {
							$("#DeliveryAddress").modal("toggle");
						}
						$("#DeliveryError").modal("toggle");
					}
				});
			}
	
			/* Open Zipcode popup */
	
		}, {
			key: 'changeDelivery',
			value: function changeDelivery() {
				this.setState({ load: "false" });
				$("#DeliveryError").modal("toggle");
				if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
					$("#AddressList").modal("toggle");
				} else {
					$("#DeliveryAddress").modal("toggle");
				}
	
				//$("#DeliveryAddress").modal("toggle");
			}
		}, {
			key: 'closeDeliveryErr',
			value: function closeDeliveryErr() {
				this.setState({ load: "false" });
				$("#DeliveryError").modal("toggle");
			}
			/* Validate zipcode */
	
		}, {
			key: 'validatezip',
			value: function validatezip(e) {
				var re = /[0-9A-F:]+/g;
				if (!re.test(e.key)) {
					e.preventDefault();
				}
			}
	
			/* formated  string */
	
		}, {
			key: 'formatString',
			value: function formatString(str) {
				var stringVal = window.btoa(str);
				return stringVal.replace(/\=/g, '');
			}
	
			/* add to cart */
	
		}, {
			key: 'addToCart',
			value: function addToCart(productId, proName, prosku, proPrice, proQty, proImage, allowCart) {
				var _this14 = this;
	
				this.setState({ productId: productId });
				this.setState({ proName: proName });
				this.setState({ prosku: prosku });
				this.setState({ proPrice: proPrice });
				this.setState({ proQty: proQty });
				this.setState({ proImage: proImage });
				this.setState({ allowCart: allowCart });
	
				if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && _reactCookie2.default.load('defaultAvilablity') === lang.delivery) {
					if (typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderPostalCode') === "undefined") {
						if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
							$("#AddressList").modal("toggle");
							return false;
						} else {
							$("#DeliveryAddress").modal("toggle");
							return false;
						}
					}
				} else if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.pickupId && _reactCookie2.default.load('defaultAvilablity') === lang.takeaWay) {
					if (typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderPostalCode') === "undefined") {
						$("#Pickup-OutletSelection").modal("toggle");
						return false;
					}
				}
	
				/* check add to cart permission */
				if (allowCart === "No") {
					alert(lang.modifier_missing);
					return false;
				}
	
				/* Post Modifier part */
	
				var modifier = [];
				//console.log(cookie.load('itemType') +"<---->"+ cookie.load('modiferCount'));
				if (_reactCookie2.default.load('itemType') === 'Modifier' && _reactCookie2.default.load('modiferCount') > 0) {
					//  console.log('is allow');
					for (var i = 0, lengthMod = _reactCookie2.default.load('modiferCount'); i < lengthMod; i++) {
						var inputName = "modVal_" + i;
						if (document.querySelector('input[name = ' + inputName + ']:checked')) {
							var modVal = document.querySelector('input[name = ' + inputName + ']:checked').value;
							if (modVal !== "") {
								var res = modVal.split("~");
								var modifierVal = [];
								modifierVal.push({ modifier_value_id: res[3], modifier_value_qty: '1', modifier_value_name: res[2], modifier_value_price: res[4] });
								modifier.push({ modifier_id: res[1], modifier_name: res[0], modifiers_values: modifierVal });
							} else {
								alert(lang.modifier_missing);
								return false;
							}
						} else {
							alert(lang.modifier_missing);
							return false;
						}
					}
				}
	
				/* set meat products array */
				var combo = [];
				var comborVal = [];
				var comboSelction = "Fail";
				var modifierSelction = "Fail";
				if (_reactCookie2.default.load('itemType') === 'Combo' && _reactCookie2.default.load('comboCount') > 0) {
					// alert(cookie.load('comboCount'));
					for (var m = 0, length = _reactCookie2.default.load('comboCount'); m < length; m++) {
						//alert('  combo' + m);
						var inputName = "comboVal_" + m;
						var comboRes = '';
						if (document.querySelector('input[name = ' + inputName + ']:checked')) {
							var comboVal_ = document.querySelector('input[name = ' + inputName + ']:checked').value;
							if (comboVal_ !== "") {
								comboSelction = "Success";
								comboRes = comboVal_.split("~");
								var product_id = comboRes[3];
	
								/* Validate modififer selection - start */
								var comboModifier = [];
								var modLength = 0;
								//alert("mod count" + m);
								var modLength = document.querySelectorAll('.setModValClass' + product_id + m).length;
								//alert('.setModValClass'+product_id+m)
								if (modLength > 0) {
									//  alert(modLength);
									//alert(modLength + comboRes[2] + "modifier count");   
									comboModifier = [];
									for (var n = 0, forLen = modLength; n < forLen; n++) {
										var inputName = "modValItems" + product_id + "-" + m + "-" + n;
										if (document.querySelector('input[name = ' + inputName + ']:checked')) {
											var modComboVal = document.querySelector('input[name = ' + inputName + ']:checked').value;
											if (modComboVal !== "") {
												modifierSelction = "success";
												var comboModRes = modComboVal.split("~");
												var comboModifierVal = [];
												comboModifierVal.push({ modifier_value_id: comboModRes[3], modifier_value_qty: '1', modifier_value_name: comboModRes[2], modifier_value_price: comboModRes[4] });
												comboModifier.push({ modifier_id: comboModRes[1], modifier_name: comboModRes[0], modifiers_values: comboModifierVal });
											} else {
												modifierSelction = "Fail";
											}
										} else {
											modifierSelction = "Fail";
										}
	
										/* if modifier selection misiing show alert */
										if (modifierSelction === "Fail") {
											alert(lang.modifier_missing);
											return false;
										}
									} /* end of second modifer for */
								}
	
								/* Validate modififer selection - End  */
	
								/* object formation  - start */
								var comborVal = [];
								comborVal.push({ product_id: comboRes[3], product_name: comboRes[2], product_sku: comboRes[4], modifiers: comboModifier });
								combo.push({ menu_component_id: comboRes[1], menu_component_name: comboRes[0], product_details: comborVal });
								/* object formation - End */
							} else {
								comboSelction = "Fail";
							}
						} else {
							comboSelction = "Fail";
						}
	
						/* combo selection is missing show alert */
						if (comboSelction === "Fail") {
							alert(lang.combo_missing);
							return false;
						}
					}
				}
	
				var totalPrice = proQty * proPrice;
	
				var postObject = {};
				postObject = {
					'app_id': config.ids.appId,
					"product_id": productId,
					"product_name": proName,
					"product_sku": prosku,
					"product_image": proImage,
					"availability_id": _reactCookie2.default.load('defaultAvilablityId'),
					"product_unit_price": proPrice,
					"product_qty": proQty,
					"product_total_price": totalPrice,
					"modifiers": JSON.stringify(modifier),
					"menu_set_component": JSON.stringify(combo)
	
				};
	
				if (typeof _reactCookie2.default.load('UserId') === 'undefined') {
					postObject['reference_id'] = (0, _Api2.default)('referenceId');
				} else {
					postObject['customer_id'] = _reactCookie2.default.load('UserId');
				}
	
				//console.log(postObject);
				/*add loading */
				this.setState({ status: 'Loading' });
				_axios2.default.post(APIURLPRO + "cart/insert", qs.stringify(postObject)).then(function (res) {
					_this14.setState({ status: 'ok' });
					if (res.data.status === "ok") {
						_reactCookie2.default.save('cartValue', 'Yes');
	
						/* find previous page */
						var slugType = _reactCookie2.default.load('categoryType');
						var slugValue = _reactCookie2.default.load('categoryId');
						if (typeof slugType !== "undefined" && typeof slugValue !== "undefined" && slugType !== '' && slugValue !== '') {
							var keyValue = slugType === "category" ? "category" : "subcategory";
							var reDirectUrl = "/products/" + keyValue + "/" + slugValue;
						} else {
							reDirectUrl = "/";
						}
						_reactCookie2.default.save('alertSuccess', lang.cart_success);
						_reactRouter.hashHistory.push(reDirectUrl);
					} else if (res.data.status === "error") {
						alert(res.data.message);
					}
				});
			}
	
			/* use to  back URL */
	
		}, {
			key: 'goBack',
			value: function goBack() {
				var slugType = _reactCookie2.default.load('categoryType');
				var slugValue = _reactCookie2.default.load('categoryId');
				if (typeof slugType !== "undefined" && typeof slugValue !== "undefined" && slugType !== '' && slugValue !== '') {
					var keyValue = slugType === "category" ? "category" : "subcategory";
					var reDirectUrl = "/products/" + keyValue + "/" + slugValue;
				} else {
					reDirectUrl = "/";
				}
	
				return reDirectUrl;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this15 = this;
	
				var proImg = this.__productImage(this.state.details.product_thumbnail);
				if (this.state.status === "Loading") {
	
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(Loading, null)
					);
				} else if (this.state.status === "ok") {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_reactDocumentMeta2.default, meta),
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid desktop-container' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 top-nav inner-top-nav head-main' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-3 nav-head pd-l-20 head-child' },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: this.goBack(), style: { cursor: 'pointer' } },
											_react2.default.createElement('img', { src: '/img/icons/arrow-right.png', className: 'icon-img-small-3', alt: 'left-arrow' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-6 nav-head head-child' },
										_react2.default.createElement('h1', { className: 'main-title' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-3 nopadding head-child' },
										_react2.default.createElement(
											'p',
											{ className: 'b-txt text-right ' },
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: "/cart" },
												'  ',
												_react2.default.createElement('img', { src: this.loadCartImage(), className: 'icon-img-small-1 carticon', alt: 'shopping-cart' }),
												' '
											)
										)
									)
								)
							),
							this.loadProductImage(this.state.details.product_thumbnail),
							_react2.default.createElement(
								'div',
								{ className: 'row ' },
								_react2.default.createElement(
									'div',
									{ className: 'col-lg-12 col-md-12 col-sm-12 ' },
									_react2.default.createElement(
										'h1',
										{ className: 'head2 ' },
										this.state.details.product_name,
										' '
									),
									_react2.default.createElement(
										'p',
										{ className: 'subh' },
										this.state.details.product_short_description
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row ' },
								_react2.default.createElement(
									'div',
									{ className: 'col-lg-12 col-md-12 col-sm-12 ' },
									_react2.default.createElement(
										'div',
										{ className: '' },
										_react2.default.createElement(
											'div',
											{ className: 'btn-div' },
											_react2.default.createElement(
												_reactRouter.Link,
												{ className: 'btn btn-group-mini' },
												_react2.default.createElement(
													'i',
													{ className: 'material-icons', onClick: this.dQty.bind(this) },
													' remove'
												)
											),
											'\xA0 ',
											this.state.cartCount,
											' \xA0',
											_react2.default.createElement(
												_reactRouter.Link,
												{ className: 'btn btn-group-sm ' },
												' ',
												_react2.default.createElement(
													'i',
													{ className: 'material-icons', onClick: this.iQty.bind(this) },
													'add'
												)
											),
											_react2.default.createElement('div', { className: 'clearfix' })
										)
									)
								)
							),
							_react2.default.createElement('br', null)
						),
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid desktop-container' },
							_react2.default.createElement(
								'div',
								{ className: 'row ' },
								_react2.default.createElement(
									'div',
									{ className: 'col-lg-12 col-md-12 col-sm-12 nopadding my-bg' },
									_react2.default.createElement(
										'div',
										{ className: 'fancy-collapse-panel' },
										_react2.default.createElement(
											'div',
											{ className: 'panel-group', id: 'accordion', role: 'tablist', 'aria-multiselectable': 'true' },
											this.showModifiers(this.state.details.modifiers),
											this.showSetMeal(this.state.details.product_is_combo, this.state.details.set_menu_component)
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid ' },
							_react2.default.createElement('div', { className: 'space-30' }),
							_react2.default.createElement(
								'div',
								{ className: 'row ' },
								_react2.default.createElement(
									_reactRouter.Link,
									null,
									_react2.default.createElement(
										'button',
										{ id: 'addToCart', className: 'col-xs-12 continue-but desktop-container container-fluid bg-red ', onClick: this.addToCart.bind(this, this.state.details.product_id, this.state.details.product_name, this.state.details.product_sku, this.state.productPrice, this.state.cartCount, proImg, this.state.allowCart) },
										lang.add_to_cart,
										'( ',
										this.state.cartCount,
										' )',
										_react2.default.createElement(
											'p',
											{ className: 'bb-txt pull-right no-margin pd-r-25' },
											this.state.productPrice
										)
									)
								)
							),
							_react2.default.createElement('div', { className: 'clearfix' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'Pickup-Sucess' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: '' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/DeliverySucess.png', className: 'img-responsive', alt: '' }),
											'Awesome, you can pickup !'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body text-center' },
										_react2.default.createElement(
											'p',
											null,
											_react2.default.createElement(
												'b',
												null,
												'Your Order is handled by:  '
											),
											_react2.default.createElement('br', null),
											this.state.orderHandled
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.pickupSuccess.bind(this), className: 'btn btn-raised btn-info ' },
											'Continue'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'DeliverySucess' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/DeliverySucess.png', className: 'img-responsive', alt: 'thumb-up' }),
											'Awesome, we can deliver!'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body text-center' },
										_react2.default.createElement(
											'p',
											null,
											_react2.default.createElement(
												'b',
												null,
												'Your Delivery Address: '
											),
											_react2.default.createElement('br', null),
											this.state.orderDeliveryAddress
										),
										_react2.default.createElement(
											'p',
											null,
											_react2.default.createElement(
												'b',
												null,
												'Your Order is handled by:'
											),
											_react2.default.createElement('br', null),
											this.state.orderHandled
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.deliverySuccess.bind(this), className: 'btn btn-raised btn-info ' },
											'Continue'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'DeliveryError' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: '' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/Cant_Deliver.png', className: 'img-responsive', alt: '' }),
											'Sorry !'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'p',
											null,
											'Sorry we cant deliver to your address ',
											_react2.default.createElement('br', null),
											'Do you want to change your address or check again later ?'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-6' },
											_react2.default.createElement(
												'button',
												{ type: 'button', onClick: this.closeDeliveryErr.bind(this), className: 'col-lg-6 btn btn-raised btn-info fullwidth ' },
												'Check Later'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-6' },
											_react2.default.createElement(
												'button',
												{ type: 'button', onClick: this.changeDelivery.bind(this), className: 'col-lg-6 btn btn-raised btn-info fullwidth ' },
												'Change Address'
											)
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'Pickup-OutletSelection' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog locWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											'Select Your Pickup Location'
										)
									),
									_react2.default.createElement(Overlay, { load: this.state.load }),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'div',
											{ className: 'map-loc' },
											_react2.default.createElement(
												'div',
												{ className: 'map-box scrollbar', id: 'style-3' },
												this.__loadOutlets()
											),
											_react2.default.createElement('br', null),
											_react2.default.createElement('br', null)
										)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'DeliveryAddress' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											'Your Delivery Address'
										)
									),
									_react2.default.createElement(Overlay, { load: this.state.load }),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'div',
											{ className: 'form-group label-floating is-empty card-no' },
											_react2.default.createElement(
												'div',
												{ className: 'input-group' },
												_react2.default.createElement(
													'label',
													{ className: 'control-label' },
													'Enter Your Postal Code'
												),
												_react2.default.createElement('input', { value: this.state.addressField, id: 'postalcode1', maxLength: '6', className: 'form-control', onKeyPress: function onKeyPress(e) {
														return _this15.validatezip(e);
													}, onChange: this.handleChangeValue })
											)
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.selectOutlet.bind(this), className: 'btn btn-raised btn-info ' },
											'Continue'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'AddressList' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: true })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/DeliverySucess.png', className: 'img-responsive', alt: true }),
											'Your Delivery Address'
										)
									),
									_react2.default.createElement(Overlay, { load: this.state.load }),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body', style: { textAlign: 'left' } },
										this.loadDefaultAddress(),
										this.loadAddressList(),
										_react2.default.createElement(
											'p',
											null,
											_react2.default.createElement('input', { value: this.state.addressField, onChange: this.handleChangeValue, id: 'postalcode', maxLength: '6', placeholder: 'Enter Your Postal Code', className: 'add_list', onKeyPress: function onKeyPress(e) {
													return _this15.validatezip(e);
												} })
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.selectOutlet.bind(this), className: 'btn btn-raised btn-info ' },
											'Continue'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						)
					);
				} else {
					return _react2.default.createElement(
						'div',
						null,
						'  ',
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid desktop-container' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								lang.no_products_found,
								'  '
							),
							' '
						),
						' '
					);
					//	hashHistory.push("/");
				}
			}
		}]);
	
		return Cartitemsedit;
	}(_react2.default.Component);
	
	exports.default = Cartitemsedit;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _withTracker = __webpack_require__(11);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _reactStripeCheckout = __webpack_require__(186);
	
	var _reactStripeCheckout2 = _interopRequireDefault(_reactStripeCheckout);
	
	var _reactPaypalExpressCheckout = __webpack_require__(843);
	
	var _reactPaypalExpressCheckout2 = _interopRequireDefault(_reactPaypalExpressCheckout);
	
	var _lodash = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var config = __webpack_require__(7);
	var lang = __webpack_require__(12);
	var alertMsg = __webpack_require__(203);
	var APIURL = config.path.apiUrl;
	var APPID = config.ids.appId;
	var APIURLPRO = config.path.apiUrlPro;
	var APIURLv2 = config.path.apiUrlv2;
	var currency = config.ids.currency;
	
	var Loading = __webpack_require__(17);
	var dateFormat = __webpack_require__(42);
	var now = new Date();
	var currentDate = dateFormat(now, "d/m/yyyy");
	var currentTime = dateFormat(now, "h:MM TT");
	var qs = __webpack_require__(3);
	
	var HtmlToReactParser = __webpack_require__(21).Parser;
	var htmlToReactParserTo = new HtmlToReactParser();
	var helper = __webpack_require__(13);
	var strp = __webpack_require__(31);
	var apps = __webpack_require__(29);
	
	
	var rewardsApplyList = ["3292DD26-CAEF-421D-81AF-72218513B3EE", "F77D467A-F552-4BB3-ABBF-C491DB6661A01"];
	var rewardsApply = 1;
	
	//import Time from 'react-time';
	var zonalEnable = 1;
	/* Load meta tags */
	var meta = {
		title: lang.checkout_meta_title + lang.site_title_with_separator,
		description: lang.checkout_meta_title,
		meta: {
			name: {
				keywords: lang.checkout_meta_title
			}
		}
	};
	
	var Chekout = function (_React$Component) {
		_inherits(Chekout, _React$Component);
	
		function Chekout(props) {
			_classCallCheck(this, Chekout);
	
			/*add class */
			helper.addBodyClass();
	
			/* Declare state */
	
			var _this = _possibleConstructorReturn(this, (Chekout.__proto__ || Object.getPrototypeOf(Chekout)).call(this, props));
	
			_this.onToken = function (token) {
				(0, _withTracker.fbPixelCustomEvent)('EnteredPaymentInfo', {});
				/*  load process html */
				_this.setState({ 'paymentStatus': 'ONLINE' });
				_this.setState({ 'defaultClass': 'chk_popup_bg' });
				$("#SwitchingError").modal("toggle");
				_axios2.default.get(APIURL + "callcenterapi/get_payment_reference_id?app_id=" + APPID).then(function (res) {
					if (res.data.status === "ok") {
						var paymentRef = res.data.payment_ref_id;
						_this.setState({ "payment_ref_id": paymentRef });
						var orderOutlet_Id = _reactCookie2.default.load('orderOutletId');
						var postObject = {};
						postObject = {
							'app_id': APPID,
							'token': token.id,
	
							'customer_id': _reactCookie2.default.load('UserId'),
							"paid_amount": _this.state.newVoucher != "1" ? (parseFloat(_this.state.cartDetails.cart_grand_total) + parseFloat(_this.state.cartDetails.service_charge_amount)).toFixed(2) : parseFloat(_this.state.cartDetails.cart_sub_total).toFixed(2),
							"outlet_name": typeof _reactCookie2.default.load('orderOutletName') !== 'undefined' ? _reactCookie2.default.load('orderOutletName') + " - " + paymentRef : '',
							"payment_reference": config.stripe.stripeReference,
							"outlet_id": orderOutlet_Id
						};
	
						_axios2.default.post(APIURLPRO + "paymentV7/stripeTokenPay", qs.stringify(postObject)).then(function (res) {
	
							//this.setState({status:""});
							if (res.data.status === "ok") {
	
								/* Reset poup message -  start */
								// console.log('paysuccess');
	
								_this.setState({ 'paymentLoading': '/img/tick.png' });
								_this.setState({ 'paymentGateway': 'Stripe' });
	
								/* Reset poup message -  end  */
	
								var captureID = res.data.result_set.payment_reference_1;
								_this.postOrder(3, "", captureID);
							} else if (res.data.status === "error") {
								/* Reset poup message -  start */
								$("#SwitchingError").modal("toggle");
								_this.setState({ 'defaultClass': '' });
								/* Reset poup message -  end  */
								helper.showInfo(res.data.message);
							}
						});
					}
				});
			};
	
			_this.onError = function (err) {
				// The main Paypal's script cannot be loaded or somethings block the loading of that script!
				console.log("Error!", err);
				_this.setState({ 'paypalPayment': false });
				// Because the Paypal's main script is loaded asynchronously from "https://www.paypalobjects.com/api/checkout.js"
				// => sometimes it may take about 0.5 second for everything to get set, or for the button to appear
			};
	
			_this.onSuccess = function (payment) {
				// Congratulation, it came here means everything's fine!
				console.log("The payment was succeeded!", payment);
				/* used process screen html show */
				_reactCookie2.default.save('orderPaymentMode', 'PAYPAL');
				_this.setState({ 'paymentStatus': 'ONLINE' });
				_this.setState({ 'defaultClass': 'chk_popup_bg' });
				_this.setState({ 'paypalPayment': true });
				$("#SwitchingError").modal("toggle");
				_this.postOrder(2);
				// You can bind the "payment" object's value to your state or props or whatever here, please see below for sample returned data
			};
	
			_this.onCancel = function (data) {
				// User pressed "cancel" or close Paypal's popup!
				console.log('The payment was cancelled!', data);
				_this.setState({ 'paypalPayment': false });
				// You can bind the "data" object's value to your state or props or whatever here, please see below for sample returned data
			};
	
			_this.handleChangeTxt = function (item, event) {
				var re = /^[0-9 \b]+$/;
				if (item == 'cardNumber') {
					/*if (event.target.value === '' || re.test(event.target.value)) {*/
					//var cardnumber = this.space(event.target.value);
					var cardnumberLenght = event.target.value.length;
					if (cardnumberLenght <= 16) {
						_this.setState(_defineProperty({}, item, event.target.value));
						_this.cardValidation(event.target.value);
					}
					/*}*/
				} else if (item == 'expiration_month') {
					if (event.target.value === '' || re.test(event.target.value) && event.target.value.length <= 2) {
						_this.setState(_defineProperty({}, item, event.target.value));
					}
				} else if (item == 'expiration_year') {
					if (event.target.value === '' || re.test(event.target.value) && event.target.value.length <= 4) {
						_this.setState(_defineProperty({}, item, event.target.value));
					}
				} else if (item == 'security_code') {
					if (event.target.value === '' || re.test(event.target.value) && event.target.value.length <= 4) {
						_this.setState(_defineProperty({}, item, event.target.value));
					}
				} else {
					_this.setState(_defineProperty({}, item, event.target.value));
				}
			};
	
			_this.onProcessOmiseToken = function (token) {
	
				var calc_grand_total = _this.getApplyRewardsPaymentTotal(_this.state.newVoucher != "1" ? parseFloat(_this.state.cartDetails.cart_grand_total) + parseFloat(_this.state.cartDetails.service_charge_amount) : parseFloat(_this.state.cartDetails.cart_sub_total));
	
				/*Calculate service charge End*/
				if (_this.isApplyRewardOnGrandTotal()) {
					calc_grand_total = calc_grand_total;
				} else {
					calc_grand_total = calc_grand_total.toFixed(2);
				}
	
				/*  load process html */
				_this.setState({ 'paymentStatus': 'ONLINE' });
				_this.setState({ 'defaultClass': 'chk_popup_bg' });
				$("#SwitchingError").modal("toggle");
				_axios2.default.get(APIURL + "callcenterapi/get_payment_reference_id?app_id=" + APPID).then(function (res) {
					if (res.data.status === "ok") {
						var paymentRef = res.data.payment_ref_id;
						_this.setState({ "payment_ref_id": paymentRef });
	
						var redirectUrl = window.location.protocol + '//' + window.location.hostname + '/#/checkout?callback_omise=1';
						var orderOutlet_Id = _reactCookie2.default.load('orderOutletId');
						var postObject = {};
						postObject = {
							'app_id': APPID,
							'token': token.id,
							'customer_id': _reactCookie2.default.load('UserId'),
							"paid_amount": calc_grand_total,
							"outlet_name": typeof _reactCookie2.default.load('orderOutletName') !== 'undefined' ? _reactCookie2.default.load('orderOutletName') + " - " + paymentRef : '',
							"redirect_url": redirectUrl,
							"outlet_id": orderOutlet_Id
						};
	
						_axios2.default.post(APIURL + "paymentv1/authOmise", qs.stringify(postObject)).then(function (res) {
							if (res.data.status === "ok") {
								/* Reset poup message -  start */
								_this.setState({ 'paymentLoading': '/img/tick.png' });
								_this.setState({ 'paymentGateway': 'Omise' });
								/* Reset poup message -  end  */
								if (res.data.result_set.authorize_uri != '') {
									_reactCookie2.default.save('omise_capture_id', res.data.result_set.payment_reference_1);
									window.location.href = res.data.result_set.authorize_uri;
								} else {
									var captureID = res.data.result_set.payment_reference_1;
									_this.setState({ log_id: res.data.result_set.log_id });
									_this.postOrder(3, "", captureID);
								}
							} else if (res.data.status === "error") {
								/* Reset poup message -  start */
								$("#SwitchingError").modal("toggle");
								_this.setState({ 'defaultClass': '' });
								/* Reset poup message -  end  */
	
								if (res.data.message == "token was already used") {
									var omiseSearchAPICal = parseInt(_this.state.omiseSearchAPICal) + 1;
									if (omiseSearchAPICal <= 150) {
										_this.setState({ omiseSearchAPICal: omiseSearchAPICal }, function () {
											this.omise_search_history();
										});
									} else {
										helper.showInfo('Something is wrong. Try again');
									}
								} else {
									helper.showInfo(res.data.message);
								}
							} else {
								var currents = _this;
								setTimeout(function () {
	
									var omiseSearchAPICal = parseInt(currents.state.omiseSearchAPICal) + 1;
									if (omiseSearchAPICal <= 150) {
										currents.setState({ omiseSearchAPICal: omiseSearchAPICal }, function () {
											currents.omise_search_history();
										});
									} else {
										helper.showInfo('Something is wrong. Try again');
									}
								}.bind(_this), 2000);
							}
						}).catch(function (error) {
							var currentcatch = _this;
							setTimeout(function () {
								var omiseSearchAPICal = parseInt(currentcatch.state.omiseSearchAPICal) + 1;
								if (omiseSearchAPICal <= 150) {
									currentcatch.setState({ omiseSearchAPICal: omiseSearchAPICal }, function () {
										currentcatch.omise_search_history();
									});
								} else {
									helper.showInfo('Something is wrong. Try again');
								}
							}.bind(_this), 2000);
						});
					}
				});
			};
	
			_this.omise_search_history = function () {
				var orderOutlet_Id = _reactCookie2.default.load('orderOutletId');
				var postObject = {};
				postObject = {
					'app_id': APPID,
					'card_id': _this.state.omise_tokken_card_id,
					'token_id': _this.state.omise_tokken_id,
					"outlet_id": orderOutlet_Id
				};
	
				_axios2.default.post(APIURL + "paymentv1/omise_search_details", qs.stringify(postObject)).then(function (res) {
	
					if (res.data.status === "ok") {
	
						_this.setState({ 'paymentLoading': '/img/tick.png' });
						_this.setState({ 'paymentGateway': 'Omise' });
						/* Reset poup message -  end  */
	
						var captureID = res.data.captureID;
						_this.setState({ log_id: res.data.log_id });
						_this.postOrder(3, "", captureID);
					} else if (res.data.status === "error") {
						/* Reset poup message -  start */
						// this.onProcessOmiseToken(this.state.omise_tokken_response);
					} else {
							//this.onProcessOmiseToken(this.state.omise_tokken_response);
						}
				});
			};
	
			_this.retrieve_charge_details = function (captureID, localOrderNo, orderPrimaryId) {
				var orderOutlet_Id = _reactCookie2.default.load('orderOutletId');
				var postObject = {};
				postObject = { 'charge_id': captureID, 'app_id': APPID, 'order_primary_id': orderPrimaryId, "outlet_id": orderOutlet_Id };
	
				_axios2.default.post(APIURL + "paymentv1/retrieve_charge_details", qs.stringify(postObject)).then(function (res) {
	
					if (res.data.status === 'ok' && res.data.payment_status === "successful") {
						_this.showSuccessPage(localOrderNo, orderPrimaryId);
					} else if (res.data.status === 'ok' && res.data.payment_status === "pending") {
						_this.retrieve_charge_details(captureID, localOrderNo, orderPrimaryId);
					} else {
						document.getElementById("PayProcess").style.display = "none";
						_this.setState({ 'defaultClass': '' });
						_this.setState({ status: "error" });
						/*helper.showInfo(res.data.status);*/
						var msgTxt = res.data.message != '' ? res.data.message : res.data.status;
						helper.showInfo(msgTxt);
					}
				});
			};
	
			_this.retrieve_three_d_charges = function (captureID) {
				var orderOutlet_Id = _reactCookie2.default.load('orderOutletId');
				var postObject = {};
				postObject = { 'charge_id': captureID, 'app_id': APPID, "outlet_id": orderOutlet_Id };
	
				_axios2.default.post(APIURL + "paymentv1/retrieve_three_d_charges", qs.stringify(postObject)).then(function (res) {
	
					if (res.data.status === 'ok' && res.data.payment_status === "successful") {
						_this.setState({ omisePayment: 1 });
						var captureID = _reactCookie2.default.load('omise_capture_id');
						_this.postOrder(3, "", captureID);
						_reactCookie2.default.save('omise_capture_id', '');
					} else if (res.data.status === 'ok' && res.data.payment_status === "pending") {
						_this.setState({ omisePayment: 1 });
						var captureID = _reactCookie2.default.load('omise_capture_id');
						_this.postOrder(3, "", captureID);
						_reactCookie2.default.save('omise_capture_id', '');
					} else {
						var redirectUrl = window.location.protocol + '//' + window.location.hostname + ':3000/#/checkout';
						window.location.href = redirectUrl;
						//document.getElementById("PayProcess").style.display = "none";
						_this.setState({ 'defaultClass': '' });
						_this.setState({ status: "error" });
						/*helper.showInfo(res.data.status);*/
						var msgTxt = res.data.message != '' ? res.data.message : res.data.status;
						helper.showInfo(msgTxt);
					}
				});
			};
	
			_this.state = { offlineDesc: "", advocado_earn_points: '', pdpacontent: '', advocado_cashbackPercent: '', advocadopin: '', paymentGateway: '', zoneEnabled: 0, cartResult: 0, cartDetails: [], cartItems: [], status: 'Loading', settings: [], 'paymentLoading': '/img/loading.gif', 'paymentSuccess': '/img/tick.png', 'orderLoading': '/img/loading.gif', 'orderSuccess': '/img/tick.png', 'paymentStatus': 'CASH', 'defaultClass': '', windowHeightNormal: 0, windowHeight: 0, promoApplied: 'No', promoAmount: 0, promocode: '', promoAppliedDelivery: 'No', promotionCategory: '', promotionId: '', previousPromotionAmount: 0, originalSubTotal: 1000, originalGrandTotal: 1000, cartSubToatl: 0, dealersOverallTotal: 0, reedemptionApplied: 'No', originalDeliveryAmnt: 0, isFreeDelivery: 'No', promoQty: 0, stripeMinPay: 'No', promoType: "", promoPoints: 0, customerPoints: 0, customerAdvocadoPoints: 0, zoneDetails: [], omisePayment: 0,
				appliedPromocode: typeof _reactCookie2.default.load('promotion_code') !== "undefined" ? _reactCookie2.default.load('promotion_code') : '', omisecodeerror: '', omiseyearerror: '', omisemontherror: '', omisecardrror: '', omisenameerror: '', holdername: '', cardNumber: '', expiration_month: '', expiration_year: '', security_code: '', cardImage: '', log_id: '', onlineservice_displaylabel: 'Service Charge', online_servicecharge_type: 'percentage', online_servicecharge_per: 0, online_servicecharge_amount: 0, subchr_amount: 0, subchr_type: '', subchr_date: '', subchr_frmtime: '', subchr_totime: '', payment_ref_id: "", customer_otp_limit: 0, omise_tokken_response: "", omise_tokken_card_id: "", omise_tokken_id: '', masterCardLogo: '',
				omisePayNowStatus: '',
				payNowCaptureId: '',
				paynowAttempts: 0,
				isPaymentProcessing: '',
				razerpayOrderId: '',
				statusInterval: null,
				isRazerpayScript: false,
				promo_with_delivery: "No",
				promo_type: '',
				newVoucher: "",
				omiseSearchAPICal: 1,
				zone_order_value_delivery_charge: 0,
				gift_option: false,
				recipient_name: '',
				recipient_contact_no: '',
				gift_message: '',
				applyRewardsOriginalGrandTotal: '',
				finalApplyRewardsOriginalGrandTotal: 999999,
				paypalPayment: false,
				proStockAndDatetimeAvl: 'yes'
			};
	
			/* surcharge details - Start */
			var availabilityIdTxt = _reactCookie2.default.load('defaultAvilablityId');
			var orderOutletId = _reactCookie2.default.load('orderOutletId');
			if (availabilityIdTxt === config.ids.deliveryId) {
				var cookieDate = _reactCookie2.default.load('DeliveryDate');
				var splitedDate = cookieDate.split('/');
				var selDate = _this.pad(splitedDate[0]);
				var selMonth = _this.pad(splitedDate[1]);
				var selYear = splitedDate[2];
				var orderDate = selYear + "-" + selMonth + "-" + selDate;
				var orderTime = _reactCookie2.default.load('DeliveryTime');
			} else {
				var orderDate = '';
				var orderTime = '';
			}
	
			var online_servicecharge_type = _this.state.online_servicecharge_type;
			var onlineservice_displaylabel = _this.state.onlineservice_displaylabel;
			var online_servicecharge_per = 0,
			    online_servicecharge_amount = 0,
			    subchr_amount = 0;
			var subchr_type = '',
			    subchr_date = '',
			    subchr_frmtime = '',
			    subchr_totime = '';
	
			_axios2.default.get(APIURL + 'outlets/outletsubcharge/?app_id=' + APPID + "&availabilityid=" + availabilityIdTxt + "&outletid=" + orderOutletId + "&orderdate=" + orderDate + "&ordertime=" + orderTime + "&").then(function (res) {
				if (res.data.status === "ok") {
	
					online_servicecharge_type = res.data.onlineservice_type;
					onlineservice_displaylabel = res.data.onlineservice_displaylbl;
					if (res.data.onlineservice_type === 'fixed') {
						online_servicecharge_per = 0;
						online_servicecharge_amount = res.data.online_service_charge;
					} else {
						online_servicecharge_per = res.data.online_service_charge;
						online_servicecharge_amount = 0;
					}
	
					if (res.data.subcharge_apply === "Yes" && _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId) {
						var subchr_data = res.data.result_set[0];
						subchr_amount = subchr_data.subchr_value;
						subchr_type = subchr_data.subchr_type;
						if (subchr_data.subchr_type === 'Time') {
							subchr_frmtime = _this.tmConv24(subchr_data.subchr_from_time);
							subchr_totime = _this.tmConv24(subchr_data.subchr_to_time);
						} else {
							subchr_date = subchr_data.subchr_date;
						}
					}
				}
	
				_this.setState({ onlineservice_displaylabel: onlineservice_displaylabel, online_servicecharge_type: online_servicecharge_type, online_servicecharge_per: online_servicecharge_per, online_servicecharge_amount: online_servicecharge_amount, subchr_amount: subchr_amount, subchr_type: subchr_type, subchr_date: subchr_date, subchr_frmtime: subchr_frmtime, subchr_totime: subchr_totime });
			});
	
			/* surcharge details - End */
	
			/* check order validation */
			var settingpostalParam = _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId ? "Yes" : "No";
			if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId) {
				var promise = (0, _Api2.default)('settingsPro', 'No');
				promise.then(function (res) {
					var settingResultZone = res.data.result_set;
					_this.setState({ zoneEnabled: parseInt(settingResultZone.client_outlet_zone) });
					_this.setState({ zone_order_value_delivery_charge: settingResultZone.zone_order_value_delivery_charge }, function () {
						this.getCartDetails('First');
					});
					_reactCookie2.default.save('client_otp_verification_enable', settingResultZone.client_otp_verification_enable);
					_reactCookie2.default.save('client_otp_verification_via', settingResultZone.client_otp_verification_via);
				});
			} else {
				_this.getCartDetails('First');
			}
	
			var zoneDetails = "";
			if (typeof _reactCookie2.default.load('orderZoneID') !== "undefined" && _reactCookie2.default.load('orderZoneID') !== "" && _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId) {
				_axios2.default.get(APIURLv2 + 'outlets/getZoneDetails/?app_id=' + APPID + "&availability=" + config.ids.deliveryId + "&ZoneId=" + _reactCookie2.default.load('orderZoneID') + "&outletId=" + _reactCookie2.default.load('orderOutletId')).then(function (res) {
					if (res.data.status === "ok") {
						_this.setState({ zoneDetails: res.data.result_set[0] });
					} else {
						alert('something went wrong');
						_reactRouter.hashHistory.push("/");
						/* check */
					}
				});
			}
			/* load cart details */
	
			/* check Authentication */
			if ((0, _Api2.default)('Auth') === false) {
				_reactRouter.hashHistory.push("/sign-in");
			}
	
			/* check user informations  */
			//  alert(cookie.load('UserMobile'));
			if ((0, _Api2.default)('UserDetails') === false) {
				_reactCookie2.default.save('isChecoutRedirect', 'Yes');
				helper.showInfo(lang.user_info_missing);
				_reactRouter.hashHistory.push("/my-account");
			}
	
			/* validate delivery details */
			if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId) {
				if ((0, _Api2.default)('DeliveryDetails') === false) {
					helper.showInfo(lang.delivery_info_missing);
					_reactRouter.hashHistory.push("/delivery-date");
				}
			}
	
			/* validate cart details */
			/*
	   Removed - page optimization
	  axios.get(APIURL+'cartver2/contents?app_id='+APPID+"&customer_id="+cookie.load('UserId'))
	  	 .then(res => {
	  	  if(res.data.status === "ok"){
	  		 if(typeof res.data.result_set =="undefined")
	  		   {    helper.showInfo('Your cart is empty. Please add products.');
	  		        hashHistory.push("/");
	  		   }
	  	  }
	  	  });  */
	
			/* get offline payment statick block content */
			var stsaicResult = helper.getStaticBlock('offline-payment-information');
			stsaicResult.then(function (stTes) {
				if (stTes.data.status === "ok") {
					_this.setState({ offlineDesc: stTes.data.result_set[0].staticblocks_description });
				}
			});
	
			/*  Get master card logo - End */
			var masterResult = helper.getStaticBlock('master-card-logo-checkout');
			masterResult.then(function (stTes) {
				if (stTes.data.status === "ok") {
					_this.setState({ masterCardLogo: stTes.data.result_set[0].staticblocks_description });
				}
			});
	
			return _this;
		}
	
		_createClass(Chekout, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				var windowHeight = window.innerHeight;
				this.setState({ 'windowHeight': windowHeight - 45 + 'px' });
				this.setState({ 'windowHeightNormal': windowHeight + 'px' });
	
				_axios2.default.get(APIURL + 'customer/advocado_PDPA?app_id=' + APPID).then(function (res) {
					if (res.data.status === "ok") {
						_this2.setState({ pdpacontent: res.data.content });
					}
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				(0, _withTracker.loadAnalytics)();
				(0, _withTracker.fbPixelCustomEvent)("InitiateCheckout", {});
	
				/* if( typeof cookie.load('promotion_code') !== "undefined" && cookie.load('promotion_code') !== "") {
	   	  $(".applyPromo").trigger("click");
	    } */
				var script = document.createElement("script");
				script.src = "https://cdn.omise.co/omise.js";
				script.async = true;
				document.body.appendChild(script);
	
				if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId) {
					this.dineInInfirmation();
				}
	
				if (typeof _reactCookie2.default.load('is_custom_redirect') !== 'undefined' && _reactCookie2.default.load('is_custom_redirect') === 'yes') {
					this.setState(_reactCookie2.default.load('promo_object'));
					this.setState({ 'promo_type': 'add_products' });
				}
			}
		}, {
			key: 'dineInInfirmation',
			value: function dineInInfirmation() {
				$('.alrt_overlay').remove();
				$('.custom_alert').remove();
				var alertheader = "Confirmation";
				var alrtmessage = "Please be informed to place the order when you are present at the outlet.<br/>All orders paid cannot be cancelled or altered.";
				$('body').append('<div class="alrt_overlay"></div><div class="custom_alert"><div class="custom_alertin"><div class="alert_height"><div class="alert_header">' + alertheader + '</div><div class="alert_body dine-in-alert-msg"> ' + alrtmessage + ' <div class="alt_btns"><a href="javascript:;" class="btn btn-primary confirm_dine_in" id="alt1">Proceed</a><a href="javascript:;" class="btn btn-info reject_dine_in"  >Close</a></div></div></div></div></div>');
	
				var actheight = $('.alert_height').height();
				$('.custom_alert').height(actheight + 10);
	
				$('.confirm_dine_in').click(function (e) {
					$('.alrt_overlay, .custom_alert').remove();
				});
	
				$('.reject_dine_in').click(function (e) {
					_reactRouter.hashHistory.push("/");
					$('.alrt_overlay, .custom_alert').remove();
					return false;
				});
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {}
	
			/* post stripe account */
	
		}, {
			key: 'tmConv24',
			value: function tmConv24(time24) {
				var ts = time24;
				if (ts !== '') {
					var H = +ts.substr(0, 2);
					var h = H % 12 || 12;
					h = h < 10 ? "0" + h : h;
					var ampm = H < 12 ? " AM" : " PM";
					ts = h + ts.substr(2, 3) + ampm;
				}
				return ts;
			}
	
			/* stripe description  */
	
		}, {
			key: 'stripeDescription',
			value: function stripeDescription() {
				//userName
				if (typeof _reactCookie2.default.load('UserLname') !== 'undefined' && _reactCookie2.default.load('UserLname') !== "") {
					return _reactCookie2.default.load('UserFname') + " " + _reactCookie2.default.load('UserLname');
				} else {
					return _reactCookie2.default.load('UserLname');
				}
			}
	
			/* */
	
		}, {
			key: 'checkDeliveryAmount',
	
			/**/
	
			/* check  delivery account and grand total amount */
			value: function checkDeliveryAmount() {
				var subTotal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
				var deliveryApplied = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	
				/* update state valeu */
				// alert(deliveryApplied);
	
				//alert('check delivery');
				/* check free  delivery */
				// console.log(this.state.cartDetails);
				var freeDeliveryAmnt = parseFloat(this.state.settings.client_free_delivery_amount);
				var DeliveryAmnt = parseFloat(this.state.settings.client_delivery_surcharge);
				var cartSubtotal = subTotal === null ? parseFloat(this.state.cartDetails.cart_sub_total) : parseFloat(subTotal);
				//  alert(cartSubtotal);
				/* get GST value */
				var dgstSubToatl = cartSubtotal;
	
				var outlet_tax_option = _reactCookie2.default.load('outlet_tax_option');
				var outlet_tax_surcharge = _reactCookie2.default.load('outlet_tax_surcharge');
				var outlet_tax_surcharge_inclusive = _reactCookie2.default.load('outlet_tax_surcharge_inclusive');
	
				if (outlet_tax_option == 1 && outlet_tax_surcharge > "0.00") {
					var dgstAmount = outlet_tax_surcharge;
				} else if (outlet_tax_option == 1 && outlet_tax_surcharge_inclusive > "0.00") {
					var dgstAmount = "0.00";
				} else {
					var dgstAmount = parseFloat(this.state.settings.client_tax_surcharge);
				}
	
				// var dgstAmount = parseFloat(this.state.settings.client_tax_surcharge);
				/*var ddisplayGst = helper.getGstValue(dgstAmount,dgstSubToatl,'format');*/
	
				if (this.state.cartDetails.cart_availability_id === config.ids.deliveryId && (DeliveryAmnt > 0 || parseFloat(this.state.additnl_deliveryAmnt_cal) > 0) && freeDeliveryAmnt > 0 && this.state.originalSubTotal >= freeDeliveryAmnt || deliveryApplied === "Yes") {
					var dgstSubToatl_delivry = dgstSubToatl;
				} else if (this.state.cartDetails.cart_availability_id === config.ids.deliveryId) {
					var dgstSubToatl_delivry = parseFloat(this.state.additnl_deliveryAmnt_cal) + parseFloat(DeliveryAmnt) + parseFloat(dgstSubToatl);
				} else {
					var dgstSubToatl_delivry = dgstSubToatl;
				}
	
				if (parseFloat(this.state.subchr_amount) > 0) {
					dgstSubToatl_delivry = parseFloat(dgstSubToatl_delivry) + parseFloat(this.state.subchr_amount);
				}
	
				var service_charge_amount = this.state.cartDetails.service_charge_amount !== '' && this.state.cartDetails.service_charge_amount !== undefined ? parseFloat(this.state.cartDetails.service_charge_amount) : 0;
	
				if (parseFloat(service_charge_amount) > 0) {
					dgstSubToatl_delivry = parseFloat(dgstSubToatl_delivry) + parseFloat(service_charge_amount);
				}
	
				var ddisplayGst = helper.getGstValue(dgstAmount, dgstSubToatl_delivry, 'format');
				/* End - Gst value */
	
				/*var grandTotal = cartSubtotal + parseFloat(this.state.settings.additional_delivery_charge) + parseFloat(ddisplayGst);*/
	
				/*var grandTotal = cartSubtotal + parseFloat(this.state.additnl_deliveryAmnt_cal) + parseFloat(ddisplayGst);
	   if( (this.state.cartDetails.cart_availability_id === config.ids.deliveryId &&  (DeliveryAmnt  > 0 || parseFloat(this.state.additnl_deliveryAmnt_cal) > 0) && freeDeliveryAmnt > 0   && grandTotal >= freeDeliveryAmnt) || deliveryApplied === "Yes")
	   { */
	
				if (this.state.cartDetails.cart_availability_id === config.ids.deliveryId && (DeliveryAmnt > 0 || parseFloat(this.state.additnl_deliveryAmnt_cal) > 0) && freeDeliveryAmnt > 0 && this.state.originalSubTotal >= freeDeliveryAmnt || deliveryApplied === "Yes") {
					//// alert('  free delivery // ' + grandTotal + "//"+dgstSubToatl+"//"+subTotal);
					/* if less the 0.50 - start */
					var grandTotal = cartSubtotal + parseFloat(ddisplayGst) + parseFloat(this.state.subchr_amount);
	
					if (grandTotal < parseFloat("0.50") && grandTotal > 0) {
						grandTotal = parseFloat("0.50");
						this.setState({ stripeMinPay: 'Yes' });
					} else {
						this.setState({ stripeMinPay: 'No' });
					}
					/* if less then  0.50 - End */
					this.setState({ cartDetails: Object.assign({}, this.state.cartDetails, { cart_delivery_charge: 0, cart_grand_total: grandTotal }) });
					this.setState({ additnl_deliveryAmnt_cal: 0 });
					this.setState({ isFreeDelivery: 'Yes' });
				} else {
					this.setState({ isFreeDelivery: 'No' });
					// console.log('not free delivery');
				}
			}
	
			/* Load modifier arr */
	
		}, {
			key: 'modifierArr',
			value: function modifierArr() {
				return [];
			}
	
			/* add zero */
	
		}, {
			key: 'pad',
			value: function pad(d) {
				return d < 10 ? '0' + d.toString() : d.toString();
			}
	
			/*calculate service charge*/
	
		}, {
			key: 'cal_service_charge',
			value: function cal_service_charge(payment_mode) {
	
				var service_charge_amount = 0;
				var onlineServicechargePer = 0;
				var originalSubTotal = parseFloat(this.state.originalSubTotal);
	
				console.log(payment_mode, $('input[name="payment"]').length, this.state.settings.client_cod_enable);
	
				if ((payment_mode == 1 || payment_mode == 2 || payment_mode == 3 || payment_mode == 5 || payment_mode === 'initial' && !$('input[name="payment"]').length || payment_mode === 'change') && originalSubTotal > 0) {
	
					if (this.state.online_servicecharge_type === 'fixed') {
						onlineServicechargePer = 0;
						var serChrAmount = this.state.online_servicecharge_amount !== '' ? parseFloat(this.state.online_servicecharge_amount) : 0;
						service_charge_amount = serChrAmount.toFixed(2);
					} else {
						onlineServicechargePer = this.state.online_servicecharge_per;
						if (parseFloat(this.state.online_servicecharge_per) > 0) {
							service_charge_amount = helper.getServicecharge(this.state.online_servicecharge_per, originalSubTotal, 'format');
						}
					}
				}
				console.log('well');
				this.setState({ cartDetails: Object.assign({}, this.state.cartDetails, { service_charge: onlineServicechargePer, service_charge_amount: service_charge_amount }) });
			}
		}, {
			key: 'cal_service_charge_old',
			value: function cal_service_charge_old(payment_mode) {
	
				var service_charge_amount = 0;
				var onlineServicechargePer = 0;
				var grand_total = parseFloat(this.state.cartDetails.cart_grand_total);
	
				console.log(payment_mode, $('input[name="payment"]').length, this.state.settings.client_cod_enable);
	
				var bool_flag = parseInt(this.state.settings.client_cod_enable) === 1 && parseFloat(this.state.cartDetails.cart_grand_total) > 0 && parseInt(this.state.settings.client_payment_availability_enable) === 0 || parseInt(this.state.settings.client_cod_enable) === 1 && parseFloat(this.state.cartDetails.cart_grand_total) > 0 && parseInt(this.state.settings.client_payment_availability_enable) === 1 && parseInt(this.state.settings.client_cod_availability) === 1;
	
				console.log('bool_flag', bool_flag);
	
				/*|| (payment_mode === 'initial' && !$('input[name="payment"]').length && parseInt(this.state.settings.client_cod_enable) !== 1) */
	
				/*if(  (
	   
	   (payment_mode == 2 || payment_mode == 3) 
	   
	   || (payment_mode === 'initial' && !$('input[name="payment"]').length && !bool_flag) 
	   
	   || (payment_mode === 'change' && $('input[name="payment"]:checked').val() !== 'CASH')) && grand_total > 0) { */
	
				if ((payment_mode == 1 || payment_mode == 2 || payment_mode == 3 || payment_mode == 5 || payment_mode === 'initial' && !$('input[name="payment"]').length || payment_mode === 'change') && grand_total > 0) {
	
					/*console.log(this.state.settings.client_online_service_charge);
	    if(parseFloat(this.state.settings.client_online_service_charge) > 0) {
	    	service_charge_amount = helper.getServicecharge(this.state.settings.client_online_service_charge,grand_total,'format');
	    }*/
	
					if (this.state.online_servicecharge_type === 'fixed') {
						onlineServicechargePer = 0;
						var serChrAmount = this.state.online_servicecharge_amount !== '' ? parseFloat(this.state.online_servicecharge_amount) : 0;
						service_charge_amount = serChrAmount.toFixed(2);
					} else {
						onlineServicechargePer = this.state.online_servicecharge_per;
						if (parseFloat(this.state.online_servicecharge_per) > 0) {
							service_charge_amount = helper.getServicecharge(this.state.online_servicecharge_per, grand_total, 'format');
						}
					}
				}
	
				this.setState({ cartDetails: Object.assign({}, this.state.cartDetails, { service_charge: onlineServicechargePer, service_charge_amount: service_charge_amount }) });
	
				/*this.setState({cartDetails: Object.assign({}, this.state.cartDetails, {service_charge: this.state.settings.client_online_service_charge,service_charge_amount:service_charge_amount})});*/
			}
	
			/* this fuction used to post order to biz panel */
	
		}, {
			key: 'postOrder',
			value: function postOrder(paymentMode, validation, captureID) {
				var _this3 = this;
	
				var products = [];
				var row = this.state.cartItems.map(function (item, i) {
	
					var modifierdata = [];
					var comboData = [];
					var ComboLen = item.set_menu_component.length;
					var modifierLen = item.modifiers.length;
					if (item.cart_item_type === "Modifier" && modifierLen > 0) {
	
						for (var l = 0; l < modifierLen; l++) {
							var modifierVal = [];
							modifierVal.push({
								modifier_value_id: item.modifiers[l].modifiers_values[0].cart_modifier_id,
								modifier_value_qty: item.modifiers[l].modifiers_values[0].cart_modifier_qty,
								modifier_value_name: item.modifiers[l].modifiers_values[0].cart_modifier_name,
								modifier_value_price: item.modifiers[l].modifiers_values[0].cart_modifier_price });
							modifierdata.push({
								modifier_id: item.modifiers[l].cart_modifier_id,
								modifier_name: item.modifiers[l].cart_modifier_name,
								modifiers_values: modifierVal });
						}
					} else if (item.cart_item_type === "Component" && ComboLen > 0) {
						/* combo product setup */
	
						for (var m = 0; m < ComboLen; m++) {
							var combomodifierdata = [];
							//console.log(item.set_menu_component[m].product_details);
							/* build  modifier array */
							var comboModifier = item.set_menu_component[m].product_details[0].modifiers;
	
							var combomodifierdata = [];
							if (comboModifier.length > 0) {
								/* new version product setup */
	
								for (var p = 0; p < comboModifier.length; p++) {
									// alert(comboModifier[p].modifiers_values[0].cart_modifier_id); return false;
									var comboModifierVal = [];
									comboModifierVal.push({
										modifier_value_id: comboModifier[p].modifiers_values[0].cart_modifier_id,
										modifier_value_qty: comboModifier[p].modifiers_values[0].cart_modifier_qty,
										modifier_value_name: comboModifier[p].modifiers_values[0].cart_modifier_name,
										modifier_value_price: comboModifier[p].modifiers_values[0].cart_modifier_price });
									combomodifierdata.push({
										modifier_id: comboModifier[p].cart_modifier_id,
										modifier_name: comboModifier[p].cart_modifier_name,
										modifiers_values: comboModifierVal });
								}
							}
	
							/*	comborVal.push( { /* commented for new version setup  /
	      	product_id:item.set_menu_component[m].product_details[0].cart_menu_component_product_id ,
	      	product_name:item.set_menu_component[m].product_details[0].cart_menu_component_product_name,
	      	product_sku:item.set_menu_component[m].product_details[0].cart_menu_component_product_sku,
	      	modifiers:combomodifierdata});
	      	comboData.push( {
	      				menu_component_id:item.set_menu_component[m].menu_component_id,
	      				menu_component_name:item.set_menu_component[m].menu_component_name,
	      				product_details:comborVal}) */
							//console.log(item.set_menu_component[m].product_details);
	
							var comborVal = [];
							var comboProductDetailslen = item.set_menu_component[m].product_details.length;
							if (comboProductDetailslen > 0) {
								for (var j = 0, lengthComboPro = comboProductDetailslen; j < lengthComboPro; j++) {
									comborVal.push({
										product_id: item.set_menu_component[m].product_details[j].cart_menu_component_product_id,
										product_name: item.set_menu_component[m].product_details[j].cart_menu_component_product_name,
										product_sku: item.set_menu_component[m].product_details[j].cart_menu_component_product_sku,
										product_qty: item.set_menu_component[m].product_details[j].cart_menu_component_product_qty,
										product_price: item.set_menu_component[m].product_details[j].cart_menu_component_product_price,
										modifiers: combomodifierdata });
								}
							}
	
							comboData.push({
								menu_component_id: item.set_menu_component[m].menu_component_id,
								menu_component_name: item.set_menu_component[m].menu_component_name,
								product_details: comborVal });
						}
					}
	
					products.push({ product_name: item.cart_item_product_name,
						product_unit_price: item.cart_item_unit_price,
						product_total_amount: item.cart_item_total_price,
						product_sku: item.cart_item_product_sku,
						product_image: item.cart_item_product_image,
						product_id: item.cart_item_product_id,
						product_qty: item.cart_item_qty,
						product_cost_price: item.cart_product_price,
						product_product_voucher: item.cart_product_voucher,
						product_voucher_expiry_date: item.product_voucher_expiry_date,
						product_voucher_points: item.product_voucher_points,
						voucher_gift_name: item.cart_item_product_voucher_gift_name,
						voucher_gift_email: item.cart_item_product_voucher_gift_email,
						voucher_gift_message: item.cart_item_product_voucher_gift_message,
						order_item_id: item.cart_voucher_order_item_id != '0' ? item.cart_voucher_order_item_id : "",
						condiments: '',
						modifiers: modifierdata,
						bakers_modifiers: '',
						menu_set_components: comboData,
						baby_pack: ''
					});
	
					return products;
				}.bind(this));
	
				//console.log(products); return false;
	
				/* if  merge order date */
				var orderDate = '';
				if (_reactCookie2.default.load('defaultAvilablityId') !== config.ids.dineinId) {
	
					var cookieDate = _reactCookie2.default.load('DeliveryDate');
					var splitedDate = cookieDate.split('/');
					//alert(splitedDate);  return false;
					var selDate = this.pad(splitedDate[0]);
					var selMonth = this.pad(splitedDate[1]);
					var selYear = splitedDate[2];
					var formatedDate = selYear + "-" + selMonth + "-" + selDate;
					//alert(formatedDate);
					var orderTime = typeof _reactCookie2.default.load('DeliveryTime') === "undefined" || _reactCookie2.default.load('DeliveryTime') === "" ? "" : _reactCookie2.default.load('DeliveryTime');
					orderDate = formatedDate + " " + orderTime; //dateFormat( cookie.load('DeliveryTime'),"yyyy-m-d H:MM");
	
					/* timeslot calculation */
	
					var order_pickup_time_slot_from = "";
					var order_pickup_time_slot_to = "";
					var order_is_timeslot = "No";
	
					if (_reactCookie2.default.load('isSletedTimeSlot') === "Yes") {
						var order_is_timeslot = "Yes";
						var cookieSlot = _reactCookie2.default.load('DeliveryTimeSlot');
						var splitedSlot = cookieSlot.split("-");
						order_pickup_time_slot_from = splitedSlot[0];
						order_pickup_time_slot_to = splitedSlot[1];
					}
				}
	
				/* insert customner details */
				if (validation !== 'Yes') {
					var addressObject = {};
					var customerAddressId = 0;
					addressObject = {
						'app_id': APPID,
						"customer_first_name": _reactCookie2.default.load('UserFname'),
						"customer_last_name": _reactCookie2.default.load('UserLname'),
						"customer_phone": _reactCookie2.default.load('UserMobile'),
						"customer_email": _reactCookie2.default.load('UserEmail'),
						"customer_address_line1": _reactCookie2.default.load('orderDeliveryAddress'),
						"customer_postal_code": _reactCookie2.default.load('orderPostalCode'),
						"customer_address_name": _reactCookie2.default.load('unitNoOne'),
						"customer_address_name2": _reactCookie2.default.load('unitNoTwo'),
						"refrence": _reactCookie2.default.load('UserId')
					};
					if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId) {
						_axios2.default.post(APIURL + "customer/secondary_address_add", qs.stringify(addressObject)).then(function (res) {
							if (res.data.status === "ok") {
								customerAddressId = res.data.insert_id;
							}
						});
					}
				}
	
				if (this.state.promoType !== "PROMO" && _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && parseFloat(this.state.cartDetails.cart_sub_total) > 0 && parseFloat(this.state.cartDetails.cart_sub_total) < parseFloat(this.state.settings.callcnter_min_amount)) {
					helper.showInfo("A minimum order value of " + currency + this.state.settings.callcnter_min_amount + ",in order to checkout the cart. Current cart value is " + currency + this.state.cartDetails.cart_sub_total + ".");
					_reactRouter.hashHistory.push("/cart");
					return false;
				}
	
				/* End of customer address add */
	
				var GetSubToalAmount = parseFloat(helper.getsubTotal(this.state.cartDetails.cart_sub_total, this.state.originalSubTotal, this.state.promoApplied, this.state.reedemptionApplied)).toFixed(2);
	
				// console.log(products);  return false;
	
	
				/* get cart details */
	
				var deliveryAmnt = helper.getDeliveryCharge(this.state.promoApplied, this.state.promoAppliedDelivery, this.state.originalDeliveryAmnt, this.state.isFreeDelivery, this.state.isFreeDelivery);
	
				/*var AdditionalDelivery = this.state.settings.additional_delivery_charge;*/
				var AdditionalDelivery = helper.getAdditionalDeliveryCharge(this.state.promoApplied, this.state.promoAppliedDelivery, this.state.additnl_deliveryAmnt_cal, this.state.isFreeDelivery);
	
				/* get GST amount */
				var orderGtSubToatl = parseFloat(GetSubToalAmount);
	
				var outlet_tax_option = _reactCookie2.default.load('outlet_tax_option');
				var outlet_tax_surcharge = _reactCookie2.default.load('outlet_tax_surcharge');
				var outlet_tax_surcharge_inclusive = _reactCookie2.default.load('outlet_tax_surcharge_inclusive');
	
				if (outlet_tax_option == 1 && outlet_tax_surcharge > "0.00") {
					var orderGstAmount = outlet_tax_surcharge;
				} else if (outlet_tax_option == 1 && outlet_tax_surcharge_inclusive > "0.00") {
					var orderGstAmount = "0.00";
				} else {
					var orderGstAmount = parseFloat(this.state.settings.client_tax_surcharge);
				}
	
				//var orderGstAmount =  parseFloat(this.state.settings.client_tax_surcharge);
				/*var orderDisplayGst = helper.getGstValue(orderGstAmount,orderGtSubToatl,'format');*/
	
				var orderGtSubToatl_delivry = parseFloat(orderGtSubToatl) + parseFloat(deliveryAmnt) + parseFloat(AdditionalDelivery) + parseFloat(this.state.subchr_amount) + parseFloat(this.state.cartDetails.service_charge_amount);
				var orderDisplayGst = helper.getGstValue(orderGstAmount, orderGtSubToatl_delivry, 'format');
	
				var calc_grand_total = parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount);
	
				var ServiceChargeText = this.state.onlineservice_displaylabel !== '' ? this.state.onlineservice_displaylabel : 'Service Charge';
	
				/*Calculate service charge End*/
				calc_grand_total = calc_grand_total.toFixed(2);
	
				var postObject = {};
				postObject = {
	
					/* cart details */
					'app_id': APPID,
					'availability_id': _reactCookie2.default.load('defaultAvilablityId'),
					'sub_total': this.state.originalSubTotal,
					"grand_total": this.isApplyRewardOnGrandTotal() === true ? this.state.finalApplyRewardsOriginalGrandTotal : this.state.newVoucher != "1" ? calc_grand_total : this.state.originalSubTotal,
	
					"order_subcharge_amount": this.state.newVoucher != "1" ? this.state.subchr_amount : "",
					"order_service_flage": 'yes',
					"order_service_charge": this.state.newVoucher != "1" ? this.state.cartDetails.service_charge : "",
					"order_service_charge_amount": this.state.newVoucher != "1" ? this.state.cartDetails.service_charge_amount : "",
					"order_servicecharge_displaylabel": ServiceChargeText,
	
					"outlet_id": _reactCookie2.default.load('orderOutletId'),
					"zone_id": this.state.zoneDetails != '' && typeof this.state.zoneDetails != 'undefined' ? this.state.zoneDetails['oza_outlet_zone_id'] : '',
					"table_number": _reactCookie2.default.load('orderTableNo'),
					"order_status": 1,
					"order_source": 'Web',
					"order_date": orderDate,
					"order_pickup_time_slot_from": order_pickup_time_slot_from,
					"order_pickup_time_slot_to": order_pickup_time_slot_to,
					"order_is_timeslot": order_is_timeslot,
					"order_remarks": _reactCookie2.default.load('product_remarks'),
					"products": JSON.stringify(products),
	
					/* customer  Details */
					"customer_id": _reactCookie2.default.load('UserId'),
					"customer_address_id": customerAddressId,
					"customer_fname": _reactCookie2.default.load('UserFname'),
					"customer_lname": _reactCookie2.default.load('UserLname'),
					"customer_mobile_no": _reactCookie2.default.load('UserMobile'),
					"customer_email": _reactCookie2.default.load('UserEmail'),
					"customer_address_line1": _reactCookie2.default.load('orderDeliveryAddress'),
					"customer_address_line2": '',
					"customer_postal_code": _reactCookie2.default.load('orderPostalCode'),
					"customer_unit_no1": _reactCookie2.default.load('unitNoOne'),
					"customer_unit_no2": _reactCookie2.default.load('unitNoTwo'),
					"customer_tower_number": typeof _reactCookie2.default.load('towerNo') === "undefined" ? '' : _reactCookie2.default.load('towerNo'),
	
					/* Payment */
					"payment_mode": paymentMode, /*paymentMode, */
					"payment_reference": config.stripe.stripeReference,
					"order_payment_getway_type": '',
					"order_payment_getway_status": '',
					"order_local_payment_reference": this.state.payment_ref_id,
	
					/* additional paras */
					"delivery_charge": this.state.newVoucher != "1" ? parseFloat(deliveryAmnt) : "",
					"additional_delivery": this.state.newVoucher != "1" ? parseFloat(AdditionalDelivery) : "",
					"order_tat_time": typeof _reactCookie2.default.load('orderTAT') === "undefined" ? '' : _reactCookie2.default.load('orderTAT'),
					"tax_charge": this.state.newVoucher != "1" ? orderGstAmount : "",
					"order_tax_calculate_amount": this.state.newVoucher != "1" ? orderDisplayGst : "",
	
					"order_tax_charge_inclusive": typeof _reactCookie2.default.load('gstInclusivePercent') === "undefined" ? '' : _reactCookie2.default.load('gstInclusivePercent'),
					"order_tax_calculate_amount_inclusive": typeof _reactCookie2.default.load('gstInclusiveValue') === "undefined" ? '' : _reactCookie2.default.load('gstInclusiveValue'),
	
					"order_data_encode": 'Yes',
					"ispromobuddyOrder": typeof _reactCookie2.default.load('ispromobuddyOrder') !== "undefined" && _reactCookie2.default.load('ispromobuddyOrder') === "Yes" ? _reactCookie2.default.load('ispromobuddyOrder') : "",
	
					/* validation purpose*/
					"promotion_applied_text": this.state.promoApplied,
					"promo_applied_delivery_text": this.state.promoAppliedDelivery,
					"is_freeDelivery_text": this.state.isFreeDelivery,
	
					/* discount */
					"order_discount_applied": '',
					"order_discount_amount": '',
					"order_discount_type": '',
					"reward_point_status": this.state.promoApplied,
	
					"outlet_tax_option": _reactCookie2.default.load('outlet_tax_option'),
					"outlet_tax_surcharge": _reactCookie2.default.load('outlet_tax_surcharge'),
					"outlet_tax_surcharge_inclusive": _reactCookie2.default.load('outlet_tax_surcharge_inclusive'),
					"pin": this.state.advocadopin,
					"omise_paynow_status": this.state.omisePayNowStatus,
					"omise_paynow_capture_id": this.state.payNowCaptureId,
					"omise_card_capture_id": captureID,
					'log_id': this.state.log_id,
					'razerpay_order_id': this.state.razerpayOrderId,
					'is_voucher': this.state.newVoucher == "1" ? 1 : "",
					"is_paypal_payment_success": this.state.paypalPayment
					//console.log(postObject);
					/* check  validation */
	
					/*  promo code object - start */
				};if (this.state.promoApplied === "Yes" && this.state.promoType === "PROMO") {
					postObject['coupon_applied'] = "Yes";
					postObject['promo_code'] = this.state.promocode;
					//	 postObject['sub_total'] = this.state.originalSubTotal;
					postObject['cart_quantity'] = this.state.promoQty;
					postObject['category_id'] = this.getPromoCategory();
					postObject['coupon_amount'] = this.state.promoAmount;
					postObject['promotion_delivery_charge_applied'] = this.state.promoAppliedDelivery;
					//promotion_delivery_charge_applied
	
					// console.log(postObject); return false;
				} else if (this.state.promoApplied === "Yes" && this.state.promoType === "POINTS") {
					postObject['redeem_point'] = this.state.promoPoints; //redeem_applied
					postObject['redeem_applied'] = "Yes"; //redeem_amount
					postObject['redeem_amount'] = this.state.promoAmount;
					postObject['redeem_amount_apply_on_grand_total'] = this.isApplyRewardOnGrandTotal();
					postObject['redeem_amount_apply_on_grand_total_amount'] = this.state.finalApplyRewardsOriginalGrandTotal;
					postObject['redeem_amount_apply_on_original_grand_total_amount'] = this.state.applyRewardsOriginalGrandTotal;
				}
	
				var advocadopinTxt = this.state.advocadopin;
				var promoAppliedTxt = this.state.promoApplied;
				var promoTypeTxt = this.state.promoType;
	
				if (validation !== 'Yes' && advocadopinTxt === '') {
	
					postObject['reward_point_status'] = 'Yes';
				}
	
				var gift_option = "No";
				if (this.state.gift_option === true) {
					gift_option = "Yes";
					postObject['order_recipient_name'] = this.state.recipient_name;
					postObject['order_recipient_contact_no'] = this.state.recipient_contact_no;
					postObject['order_gift_message'] = this.state.gift_message;
				}
				postObject['order_customer_send_gift'] = gift_option;
	
				//this.setState({status:"Loading"});
				/*var OrderAPIUrl = APIURLPRO+"orders/submit_order";
	   if((captureID !==undefined && captureID !=='') || (advocadopinTxt === '')){
	    OrderAPIUrl = APIURLPRO+"ordersv1/submit_order";
	   }*/
				//		var OrderAPIUrl = APIURLPRO+"testapi/ordersv1/submit_order"; 
				var OrderAPIUrl = APIURLPRO + "ordersv2/submit_order";
				window.sessionStorage.setItem("postObject", qs.stringify(postObject));
	
				if (validation === 'Yes') {
					postObject['validation_only'] = "Yes";
				}
	
				_axios2.default.post(OrderAPIUrl, qs.stringify(postObject)).then(function (res) {
	
					if (res.data.status === "ok") {
	
						if (validation !== 'Yes') {
	
							if (captureID !== undefined && captureID !== '') {
								if (_this3.state.omisePayment == 1) {
									_this3.captureOmiseAmount(captureID, res.data.common.order_primary_id, res.data.common.local_order_no);
								} else {
									_this3.captureAmount(captureID, res.data.common.order_primary_id, res.data.common.local_order_no);
								}
							} else {
								_this3.setState({ 'orderLoading': '/img/tick.png' });
								_this3.setState({ status: "ok" });
								_this3.destroyCart();
								_this3.deleteOrderCookie();
								setTimeout(function () {
									$("#SwitchingError").modal("toggle");
									this.sentchatbox(res.data.common.order_primary_id);
									_reactRouter.hashHistory.push("/order-success/" + res.data.common.local_order_no);
								}.bind(_this3), 500);
							}
						} else {
							_this3.setState({ status: "ok" });
	
							document.getElementById("loadIcon").style.display = "none";
	
							return true;
						}
					} else if (res.data.status === "error") {
	
						var errorMsg = "";
						if (res.data.message !== "" && _typeof(res.data.message) != undefined && typeof res.data.message != "undefined") {
							errorMsg = res.data.message;
						} else if (res.data.form_error != '' && _typeof(res.data.form_error) != undefined && typeof res.data.form_error != "undefined") {
							errorMsg = htmlToReactParserTo.parse(res.data.form_error);
						}
	
						if (validation !== 'Yes') {
							$("#SwitchingError").modal("toggle");
							document.getElementById("PayProcess").style.display = "none";
							_this3.setState({ 'defaultClass': '' });
							_this3.setState({ status: "error" });
							/*helper.showInfo(res.data.status);*/
							var msgTxt = res.data.message != '' ? res.data.message : res.data.status;
							helper.showInfo(msgTxt);
						} else {
							if (_typeof(res.data.order_count) !== undefined && res.data.order_count === 1) {
								helper.showInfo(res.data.message);
								if (_this3.state.settings.client_delivery_time_setting_enable === "1") {
									_reactRouter.hashHistory.push("/delivery-date-advanced");
								} else if (_this3.state.settings.client_delivery_time_setting_enable === '1') {
									_reactRouter.hashHistory.push("/delivery-date-new");
								} else {
									_reactRouter.hashHistory.push("/delivery-date");
								}
							} else {
								_this3.orderValidationFail(errorMsg);
							}
						}
					} else if (res.data.status == "revel_cart_error") {
	
						/*helper.showInfo(res.data.status);*/
						var msgTxt = res.data.message != '' ? res.data.message : res.data.status;
						helper.showInfo(msgTxt);
	
						_reactRouter.hashHistory.push("/cart");
					} else {
						_this3.orderValidationFail();
					}
				});
			}
		}, {
			key: 'sentchatbox',
			value: function sentchatbox(orderPrimaryId) {
				var postObject = {
					app_id: APPID,
					order_primary_id: orderPrimaryId,
					customer_id: _reactCookie2.default.load("UserId")
				};
				_axios2.default.post(APIURL + "chatbot/order_notify", qs.stringify(postObject)).then(function (res) {
	
					if (res.data.status === "ok") {
						console.log("Chatbot Notified");
					}
				});
			}
	
			/* sucess page */
	
		}, {
			key: 'showSuccessPage',
			value: function showSuccessPage(localOrderNo, orderPrimaryId) {
				this.setState({ 'orderLoading': '/img/tick.png' });
				this.setState({ status: "ok" });
				this.sentnoviteepos(orderPrimaryId);
				this.sentchatbox(orderPrimaryId);
				this.destroyCart();
				this.deleteOrderCookie();
				setTimeout(function () {
					if (this.state.settings.client_omise_enable_secure !== '1') {
						$("#SwitchingError").modal("toggle");
					}
					_reactRouter.hashHistory.push("/order-success/" + localOrderNo);
				}.bind(this), 500);
			}
	
			/* Capture amount */
	
		}, {
			key: 'captureAmount',
			value: function captureAmount(captureID, orderPrimaryId, localOrderNo) {
				var _this4 = this;
	
				console.log(captureID);
				var orderOutlet_Id = _reactCookie2.default.load('orderOutletId');
				var cabtureObjects = {};
				var captureParams = captureID + "~" + orderPrimaryId + "~" + localOrderNo;
				cabtureObjects = { payment_reference: config.stripe.stripeReference, "customer_id": _reactCookie2.default.load('UserId'), 'app_id': config.ids.appId, 'token': captureID, 'order_id': orderPrimaryId, 'outlet_id': orderOutlet_Id,
					"paid_amount": this.state.newVoucher != "1" ? (parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount)).toFixed(2) : (parseFloat(this.state.cartDetails.cart_sub_total) + parseFloat(this.state.cartDetails.service_charge_amount)).toFixed(2) };
	
				_axios2.default.post(APIURLPRO + "paymentV7/captureAmount", qs.stringify(cabtureObjects)).then(function (captureRes) {
					if (captureRes.data.status === "ok") {
	
						_this4.showSuccessPage(localOrderNo, orderPrimaryId);
					} else if (captureRes.data.status === "error") {
	
						$("#SwitchingError").modal("toggle");
						document.getElementById("PayProcess").style.display = "none";
						_this4.setState({ 'defaultClass': '' });
						_this4.setState({ status: "error" });
						/*helper.showInfo(res.data.status);*/
						var msgTxt = res.data.message != '' ? res.data.message : res.data.status;
						helper.showInfo(msgTxt);
					} else {}
				}).catch(function (error) {});
			}
	
			/* check order validation */
	
		}, {
			key: 'orderValidationFail',
			value: function orderValidationFail() {
				var errorMsg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
				if (errorMsg !== null) {
					helper.showInfo(errorMsg, 'Alert');
				} else {
					helper.showInfo('Something went wrong. Your order details or personal information is wrong. Please check and try again.');
				}
				var isTempUser = parseInt(_reactCookie2.default.load("isTempUser"));
				if (isTempUser === 1) {
					_reactRouter.hashHistory.push("/");
				} else {
					_reactRouter.hashHistory.push("/my-account");
				}
			}
			/* this function used to  delete all cookie values */
	
		}, {
			key: 'deleteOrderCookie',
			value: function deleteOrderCookie() {
				_reactCookie2.default.save('cartValue', 'No');
				_reactCookie2.default.remove('orderPaymentMode');
				_reactCookie2.default.remove('orderOutletId');
				_reactCookie2.default.remove('orderTableNo');
				_reactCookie2.default.remove('product_remarks');
				_reactCookie2.default.remove('orderOutletName');
				_reactCookie2.default.remove('orderOutletId');
				_reactCookie2.default.remove('orderZoneID');
				_reactCookie2.default.remove('promotion_code');
				/* Delivery avilablity */
				_reactCookie2.default.remove('DeliveryDate');
				_reactCookie2.default.remove('DeliveryTime');
				_reactCookie2.default.remove('isSletedTimeSlot');
				_reactCookie2.default.remove('DeliveryTimeSlot'); //
				_reactCookie2.default.remove('DeliveryTimeSlotFormated');
				_reactCookie2.default.remove('unitNoOne');
				_reactCookie2.default.remove('unitNoTwo'); //
				_reactCookie2.default.remove('towerNo');
	
				_reactCookie2.default.remove('outlet_tax_option');
				_reactCookie2.default.remove('outlet_tax_surcharge');
				_reactCookie2.default.remove('outlet_tax_surcharge_inclusive');
				_reactCookie2.default.remove('tempPromoCode');
				_reactCookie2.default.remove('tempPoints');
			}
	
			/* this function used to delte all  cart items */
	
		}, {
			key: 'destroyCart',
			value: function destroyCart() {
				// var params = new URLSearchParams();
				//params.append('app_id', config.ids.appId);
				//params.append('customer_id',cookie.load('UserId'));
				var postObject = {};
				postObject = { 'app_id': config.ids.appId };
				postObject['customer_id'] = _reactCookie2.default.load('UserId');
				_axios2.default.post(APIURL + "cart/destroy", qs.stringify(postObject));
			}
	
			/* this  function used get cart content details */
	
		}, {
			key: 'getCartDetails',
			value: function getCartDetails(sts) {
				var _this5 = this;
	
				var promoreload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				/* API CALL FOR BANNERS */
				//customerParam = "&customer_id="+cookie.load('UserId');
				var zoneparam = "";
				if (_reactCookie2.default.load('orderZoneID') !== "" && _typeof(_reactCookie2.default.load('orderZoneID')) !== undefined && typeof _reactCookie2.default.load('orderZoneID') !== "undefined") {
					zoneparam = "&zone_id=" + _reactCookie2.default.load('orderZoneID');
				}
				var deliveryDate = '';
				var deliveryTime = _reactCookie2.default.load("DeliveryTime") !== undefined ? _reactCookie2.default.load("DeliveryTime") : '';
				var deliveryDateTxt = _reactCookie2.default.load("DeliveryDate") !== undefined ? _reactCookie2.default.load("DeliveryDate") : '';
				if (deliveryDateTxt != '') {
					var deliveryDateArr = deliveryDateTxt.split("/");
					deliveryDate = deliveryDateArr[2] + "-" + deliveryDateArr[1] + "-" + deliveryDateArr[0];
				}
				var postalCodeWhere = "";
				if (typeof _reactCookie2.default.load("orderPostalCode") !== "undefined") {
					postalCodeWhere = '&postal_code=' + _reactCookie2.default.load("orderPostalCode");
				}
				_axios2.default.get(APIURL + 'cartver2/contents?status=A&app_id=' + APPID + "&customer_id=" + _reactCookie2.default.load('UserId') + zoneparam + "&orderdate=" + deliveryDate + "&ordertime=" + deliveryTime + "&stockvalide=yes" + postalCodeWhere).then(function (res) {
					if (res.data.status === "ok") {
	
						if (typeof res.data.result_set == "undefined") {
							helper.showInfo('Your cart is empty. Please add products.');
							_reactRouter.hashHistory.push("/");
						}
	
						var cartDetails = res.data.result_set.cart_details;
						var cartItems = res.data.result_set.cart_items;
	
						if (_this5.state.zoneEnabled === 1 && _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && _this5.state.zone_order_value_delivery_charge === "1" && cartDetails['cart_zone_delivery_charge'] > 0) {
							var zone_Details = _this5.state.zoneDetails;
							zone_Details['zone_delivery_charge'] = cartDetails['cart_zone_delivery_charge'];
							_this5.setState({ zoneDetails: zone_Details });
						}
	
						if (_this5.state.zoneEnabled === 1 && _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && _this5.state.zoneDetails['zone_delivery_charge'] > 0) {
							cartDetails['cart_delivery_charge'] = _this5.state.zoneDetails['zone_delivery_charge'];
							cartDetails['cart_grand_total'] = parseFloat(cartDetails['cart_sub_total']) + parseFloat(_this5.state.zoneDetails['zone_delivery_charge']);
						}
						_this5.setState({ cartDetails: cartDetails, cartItems: cartItems }, function () {
							this.findVoucherProduct();
						});
	
						var originalSubTotalAmt = cartDetails.cart_sub_total;
	
						if (sts == "First") {
	
							_this5.setState({
								originalSubTotal: cartDetails.cart_sub_total,
								originalGrandTotal: cartDetails.cart_grand_total,
								originalDeliveryAmnt: cartDetails.cart_delivery_charge });
	
							_this5.setState({ status: "Loading" });
	
							/* get customer reward points */
							var inputKeys = ["promotionwithoutuqc", "reward", "testtxt"];
							inputKeys = JSON.stringify(inputKeys);
							_axios2.default.get(APIURL + 'reports/activity_counts1?app_id=' + APPID + "&status=A&customer_id=" + _reactCookie2.default.load('UserId') + "&act_arr=" + inputKeys).then(function (res) {
								if (res.data.status === "ok") {
									_this5.setState({ customerPoints: res.data.result_set.reward_ponits, promotion_count: res.data.result_set.promotionwithoutuqc
									});
								}
							});
	
							/* get customer points */
							_axios2.default.get(APIURL + '/customer/customerdetail?app_id=' + APPID + "&refrence=" + _reactCookie2.default.load('UserId')).then(function (res) {
								if (res.data.status === "ok") {
									_this5.setState({ customers_is_anonymous: parseFloat(res.data.result_set.customers_is_anonymous), customerAdvocadoPoints: parseFloat(res.data.result_set.customer_reward_point), advocado_id: res.data.result_set.customer_advocado_id, enable_advocado: res.data.result_set.enable_advocado, advocado_cashbackPercent: typeof res.data.result_set.cashbackPercent !== 'undefined' ? res.data.result_set.cashbackPercent : 0
									});
								}
							});
						}
	
						/* get settings values */
						var postalParam = _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId ? "Yes" : "No";
						var outletParam = _reactCookie2.default.load('orderOutletId') !== "" && _typeof(_reactCookie2.default.load('orderOutletId')) !== undefined ? '&outletid=' + _reactCookie2.default.load('orderOutletId') : '';
	
						var promise = (0, _Api2.default)('settingsPro', postalParam + "&availability=" + _reactCookie2.default.load('defaultAvilablityId') + outletParam);
						promise.then(function (res) {
	
							var settingsDet = res.data.result_set;
	
							if (_this5.state.zoneEnabled === 1 && _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && _this5.state.zoneDetails['zone_delivery_charge'] > 0 || _this5.state.zoneDetails['zone_min_amount'] > 0) {
								if (typeof _this5.state.zoneDetails === "undefined" || _this5.state.zoneDetails === "") {
									alert("something went wrong");
									_reactRouter.hashHistory.push("");
								}
	
								settingsDet['callcnter_min_amount'] = _this5.state.zoneDetails['zone_min_amount'];
								settingsDet['client_free_delivery_amount'] = _this5.state.zoneDetails['zone_free_delivery'];
								settingsDet['client_delivery_surcharge'] = _this5.state.zoneDetails['zone_delivery_charge'];
								settingsDet['additional_delivery_charge'] = _this5.state.zoneDetails['zone_additional_delivery_charge'];
							}
	
							if (sts == "First") {
								var omiseEnable = parseInt(settingsDet.client_omise_enable);
								var stripeEnable = parseInt(settingsDet.client_stripe_enable);
								var codEnable = parseInt(settingsDet.client_cod_enable);
								var stripeAvbl = parseInt(settingsDet.client_stripe_availability);
								var codAvbl = parseInt(settingsDet.client_cod_availability);
	
								if ((codEnable === 0 || codAvbl === 0) && (stripeEnable === 0 || stripeAvbl === 0) && omiseEnable === 1) {
									_this5.setState({ omisePayment: 1 });
								}
							}
	
							_this5.setState({ settings: settingsDet });
	
							var AddDelgrandTotal = _this5.state.newVoucher != "1" ? parseFloat(_this5.state.cartDetails.cart_grand_total) + parseFloat(_this5.state.subchr_amount) : parseFloat(_this5.state.cartDetails.cart_sub_total) + parseFloat(_this5.state.subchr_amount);
	
							var addDelCharge = parseFloat(settingsDet.additional_delivery_charge);
	
							/* get GST value */
							var gstSubToatl = parseFloat(_this5.state.cartDetails.cart_sub_total);
	
							var outlet_tax_option = _reactCookie2.default.load('outlet_tax_option');
							var outlet_tax_surcharge = _reactCookie2.default.load('outlet_tax_surcharge');
							var outlet_tax_surcharge_inclusive = _reactCookie2.default.load('outlet_tax_surcharge_inclusive');
	
							if (outlet_tax_option == 1 && outlet_tax_surcharge > "0.00") {
								var gstAmount = outlet_tax_surcharge;
							} else if (outlet_tax_option == 1 && outlet_tax_surcharge_inclusive > "0.00") {
								var gstAmount = "0.00";
							} else {
								var gstAmount = parseFloat(_this5.state.settings.client_tax_surcharge);
							}
	
							//var gstAmount = parseFloat(settingsDet.client_tax_surcharge);
							/* End - Gst value */
	
							var freeDeliveryAmnt = parseFloat(settingsDet.client_free_delivery_amount);
	
							if (_this5.state.cartDetails.cart_availability_id === config.ids.deliveryId && addDelCharge > 0 && freeDeliveryAmnt > 0) {
								var remaingAmnt = parseFloat(freeDeliveryAmnt - gstSubToatl).toFixed(2);
								if (remaingAmnt > 0) {} else {
									addDelCharge = 0;
								}
							}
							_this5.setState({ additnl_deliveryAmnt_cal: addDelCharge });
	
							var service_charge_amount = 0;
							if (_this5.state.online_servicecharge_type === 'fixed') {
								var serChrAmount = _this5.state.online_servicecharge_amount !== '' ? parseFloat(_this5.state.online_servicecharge_amount) : 0;
								service_charge_amount = serChrAmount.toFixed(2);
							} else {
								if (parseFloat(_this5.state.online_servicecharge_per) > 0) {
									service_charge_amount = helper.getServicecharge(_this5.state.online_servicecharge_per, originalSubTotalAmt, 'format');
								}
							}
	
							/* get GST value New*/
							var gstSubToatl_delivry = parseFloat(AddDelgrandTotal) + parseFloat(addDelCharge) + parseFloat(service_charge_amount);
							var displayGst = helper.getGstValue(gstAmount, gstSubToatl_delivry, 'format');
							/* End - Gst value New*/
	
							var finResult = AddDelgrandTotal + addDelCharge + parseFloat(displayGst);
	
							/*this.setState({cartDetails: Object.assign({}, this.state.cartDetails, {cart_grand_total:finResult})}, function () { this.checkDeliveryAmount();
	         this.cal_service_charge('initial'); $('#loadIcon').show(); this.postOrder(2,'Yes'); }.bind(this));*/
	
							_this5.setState({ cartDetails: Object.assign({}, _this5.state.cartDetails, { cart_grand_total: finResult }) }, function () {
								if (this.state.settings.client_omise_enable_secure === '1') {
									if (_reactCookie2.default.load('tempPromoCode') !== "" && _typeof(_reactCookie2.default.load('tempPromoCode')) !== undefined && typeof _reactCookie2.default.load('tempPromoCode') !== "undefined") {
										var tempPromoCode = _reactCookie2.default.load('tempPromoCode');
										this.setState({ appliedPromocode: tempPromoCode, promoApplied: "Yes", promoType: "PROMO" }, function () {
											if (_reactCookie2.default.load('promo_type') != "add_products") {
												this.applyCoupon(this.state.cartDetails.cart_sub_total, tempPromoCode);
											}
										});
									}
	
									if (_reactCookie2.default.load('tempPoints') !== "" && _typeof(_reactCookie2.default.load('tempPoints')) !== undefined && typeof _reactCookie2.default.load('tempPoints') !== "undefined") {
										var tempPoints = _reactCookie2.default.load('tempPoints');
										/*, */
										this.setState({ promoPoints: tempPoints, promoApplied: "Yes", promoType: "POINTS" }, function () {
											$('#points').val(tempPoints);
											this.applyRewardsAuto(tempPoints);
										});
									}
								}
							});
	
							_this5.checkDeliveryAmount();
							_this5.cal_service_charge('initial');
	
							var callcnterMinAmount = parseInt(settingsDet.callcnter_min_amount);
	
							if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && gstSubToatl > 0 && gstSubToatl < callcnterMinAmount) {
								helper.showInfo("A minimum order value of " + currency + callcnterMinAmount + ",in order to checkout the cart. current cart value is " + currency + gstSubToatl + ".");
								_reactRouter.hashHistory.push("/cart");
								return false;
							}
	
							if (promoreload === false) {
								/* validate alerts  */
								$('#loadIcon').show();
								/*var retun_data = this.postOrder(2,'Yes');*/
	
								var $_thisPer = _this5;
								setTimeout(function () {
									if ($_thisPer.props.location.query.razerpay != 'undefined' && $_thisPer.props.location.query.razerpay != undefined && $_thisPer.props.location.query.razerpay == 'success') {
										$_thisPer.setState({ razerpayOrderId: $_thisPer.props.location.query.order_id });
										$("#SwitchingError").modal("toggle");
										$_thisPer.postOrder(7, 'No');
									} else if ($_thisPer.props.location.query.callback_omise != 'undefined' && $_thisPer.props.location.query.callback_omise != undefined && _reactCookie2.default.load('omise_capture_id') != undefined && _reactCookie2.default.load('omise_capture_id') != '') {
										var captureID = _reactCookie2.default.load('omise_capture_id');
										$_thisPer.retrieve_three_d_charges(captureID);
									} else {
										if (_reactCookie2.default.load('tempPromoCode') === "" || _typeof(_reactCookie2.default.load('tempPromoCode')) === undefined || typeof _reactCookie2.default.load('tempPromoCode') === "undefined" || _reactCookie2.default.load('tempPoints') === "" || _typeof(_reactCookie2.default.load('tempPoints')) === undefined || typeof _reactCookie2.default.load('tempPoints') === "undefined") {
											$_thisPer.postOrder(2, 'Yes');
										}
									}
								}, 600);
							}
							//this.setState({status: 'ok'});
						});
					} else {
						_reactRouter.hashHistory.push("/");
					}
				});
			}
		}, {
			key: 'findVoucherProduct',
			value: function findVoucherProduct() {
				var cartItms = this.state.cartItems;
				if (cartItms.length > 0) {
					var voucherExit = 0;
					var otherProExist = 0;
					cartItms.map(function (item) {
						if (item.cart_item_product_type == '5' && item.cart_voucher_order_item_id == '0' && item.cart_item_unit_price > 0) {
	
							voucherExit++;
							_reactCookie2.default.save("checkoutVoucher", '1');
						} else {
							otherProExist++;
							_reactCookie2.default.save("checkoutVoucher", '0');
						}
					});
				}
				if (voucherExit > 0 && otherProExist == "0") {
					_reactCookie2.default.save("checkoutVoucher", '1');
				} else {
					_reactCookie2.default.save("checkoutVoucher", '0');
				}
				if (voucherExit > 0) {
					this.setState({ newVoucher: _reactCookie2.default.load('checkoutVoucher') });
				} else if (otherProExist > 0) {
					this.setState({ newVoucher: _reactCookie2.default.load('checkoutVoucher') });
				}
			}
	
			/*Reset promotion applied details */
	
		}, {
			key: 'resetAppliedPromo',
			value: function resetAppliedPromo(type) {
				var promoAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
				var deliveryApplied = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	
				var $_thisVr = this;
				// alert(type);
				if (deliveryApplied !== "Yes") {
	
					var addDelCharge = parseFloat(this.state.additnl_deliveryAmnt_cal);
	
					if (type === "Add") {
						var addedgrandTotal = parseFloat(this.state.originalGrandTotal) - parseFloat(promoAmount);
						var AddDelgrandTotal = addedgrandTotal > 0 ? parseFloat(addedgrandTotal) : 0;
						var addGstSubToatl = parseFloat(this.state.originalSubTotal) - parseFloat(promoAmount);
						var gstSubToatl = addGstSubToatl > 0 ? parseFloat(addGstSubToatl) : 0;
					} else {
						AddDelgrandTotal = parseFloat(this.state.originalGrandTotal);
						gstSubToatl = parseFloat(this.state.originalSubTotal);
						//alert(gstSubToatl + "//" + AddDelgrandTotal);
	
						var addDelCharge = parseFloat(this.state.settings.additional_delivery_charge);
						var freeDeliveryAmnt = parseFloat(this.state.settings.client_free_delivery_amount);
						if (this.state.cartDetails.cart_availability_id === config.ids.deliveryId && addDelCharge > 0 && freeDeliveryAmnt > 0) {
							var remaingAmnt = parseFloat(freeDeliveryAmnt - gstSubToatl).toFixed(2);
							if (remaingAmnt > 0) {} else {
								addDelCharge = 0;
							}
						}
					}
	
					this.setState({ additnl_deliveryAmnt_cal: addDelCharge });
	
					var service_charge_amount = this.state.cartDetails.service_charge_amount !== '' && this.state.cartDetails.service_charge_amount !== undefined ? parseFloat(this.state.cartDetails.service_charge_amount) : 0;
	
					AddDelgrandTotal = parseFloat(AddDelgrandTotal) + parseFloat(this.state.subchr_amount);
	
					var outlet_tax_option = _reactCookie2.default.load('outlet_tax_option');
					var outlet_tax_surcharge = _reactCookie2.default.load('outlet_tax_surcharge');
					var outlet_tax_surcharge_inclusive = _reactCookie2.default.load('outlet_tax_surcharge_inclusive');
	
					if (outlet_tax_option == 1 && outlet_tax_surcharge > "0.00") {
						var gstAmount = outlet_tax_surcharge;
					} else if (outlet_tax_option == 1 && outlet_tax_surcharge_inclusive > "0.00") {
						var gstAmount = "0.00";
					} else {
						var gstAmount = parseFloat(this.state.settings.client_tax_surcharge);
					}
	
					//var gstAmount = parseFloat(this.state.settings.client_tax_surcharge);
					/*var displayGst = helper.getGstValue(gstAmount,gstSubToatl,'format');*/
					var gstSubToatl_delivrytxt = AddDelgrandTotal + addDelCharge + parseFloat(service_charge_amount);
					var displayGst = helper.getGstValue(gstAmount, gstSubToatl_delivrytxt, 'format');
					/* End - Gst value */
					var finResult = AddDelgrandTotal + addDelCharge + parseFloat(displayGst);
					/* if less the 0.50 - start */
					if (finResult < parseFloat("0.50") && finResult > 0) {
						finResult = parseFloat("0.50");
						this.setState({ stripeMinPay: 'Yes' });
					} else {
						this.setState({ stripeMinPay: 'No' });
					}
					/* if less then  0.50 - End */
	
					this.setState({ cartDetails: Object.assign({}, this.state.cartDetails, { cart_sub_total: gstSubToatl, cart_grand_total: finResult }) }, function () {
						this.checkDeliveryAmount(gstSubToatl, 'No');setTimeout(function () {
							$_thisVr.cal_service_charge('change');
						}, 100);
						//this.postOrder(2,'Yes');
					}.bind(this));
				} else {
	
					this.checkDeliveryAmount(this.state.originalSubTotal, 'Yes');
					setTimeout(function () {
						$_thisVr.cal_service_charge('change');
					}, 100);
				}
	
				/*this.cal_service_charge('change');*/
			}
	
			/* this function used to validate customer information */
	
		}, {
			key: 'validateCustomer',
			value: function validateCustomer() {}
	
			/* this function used to validate customer information */
	
		}, {
			key: 'validateCart',
			value: function validateCart() {}
	
			/* this function used to validate order details */
	
		}, {
			key: 'validateOrderDetails',
			value: function validateOrderDetails() {}
		}, {
			key: 'otp_verification',
			value: function otp_verification() {
				var _this6 = this;
	
				var otpObject = {};
				var otp_value = $("#redeem_points_otp").val();
	
				if (otp_value != '') {
	
					document.getElementById("PromoLoading").style.display = "block";
	
					var qs = __webpack_require__(3);
					otpObject = { "app_id": APPID, "customer_otp_val": otp_value, "customer_email_id": _reactCookie2.default.load('UserEmail'), "verify_type": "redeempoints" };
	
					_axios2.default.post(APIURL + "customer/customer_otp_verification", qs.stringify(otpObject)).then(function (response) {
						document.getElementById("PromoLoading").style.display = "none";
						if (response.data.status === "ok") {
							_this6.otp_redeem_points();
							$("#redeem_points_otp").val('');
						} else {
							helper.showInfo(response.data.message);
						}
					});
				} else {
					$("#redeem_points_otp").val('');
					helper.showInfo("Enter valid OTP.");
					return false;
				}
			}
		}, {
			key: 'otp_cancel_option',
			value: function otp_cancel_option() {
				document.getElementById("redeem_points_option").style.display = "block";
				document.getElementById("redeem_point_otp_div").style.display = "none";
				document.getElementById("resend_otp_button").style.display = "block";
				$("#redeem_points_otp").val('');
			}
		}, {
			key: 'handleResendotp',
			value: function handleResendotp() {
				var _this7 = this;
	
				var otp_limit = this.state.customer_otp_limit + 1;
				var qs = __webpack_require__(3);
				var postObject = { "app_id": APPID, "customer_email": _reactCookie2.default.load('UserEmail'), "customer_mobile": _reactCookie2.default.load('UserMobile'), "customer_first_name": _reactCookie2.default.load('UserFname'), "customer_last_name": _reactCookie2.default.load('UserLname'), "verify_type": "redeempoints" };
	
				if (otp_limit > 1) {
					//helper.showInfo("OTP limit has been reached.");
					document.getElementById("resend_otp_button").style.display = "none";
				} else {
	
					document.getElementById("PromoLoading").style.display = "block";
	
					_axios2.default.post(APIURL + "customer/resend_otp", qs.stringify(postObject)).then(function (response) {
						document.getElementById("PromoLoading").style.display = "none";
						if (response.data.status === "ok") {
							_this7.setState({ customer_otp_limit: otp_limit });
							helper.showInfo(response.data.message);
							document.getElementById("resend_otp_button").style.display = "none";
						} else {
							helper.showInfo(response.data.message);
						}
					});
				}
			}
		}, {
			key: 'otp_redeem_points',
			value: function otp_redeem_points() {
				var _this8 = this;
	
				document.getElementById("PromoLoading").style.display = "block";
				var cartSubToatl = parseFloat(this.state.originalSubTotal);
				var pointsVal = parseFloat($("#points").val());
				var pointsObject = {};
	
				pointsObject = {
					/* cart details */
					'app_id': APPID,
					'reference_id': _reactCookie2.default.load('UserId'),
					'pin': this.state.advocadopin,
					'redeem_point': pointsVal,
					'cart_amount': parseFloat(cartSubToatl)
				};
	
				_axios2.default.post(APIURL + 'loyalty/apply_loyalityv1', qs.stringify(pointsObject)).then(function (res) {
					document.getElementById("PromoLoading").style.display = "none";
					if (res.data.status === "success") {
						_this8.resetAppliedPromo('Add', parseFloat(res.data.result_set.points_amount), 'No');
						_this8.setState({
							promoApplied: 'Yes',
							promoAmount: parseFloat(res.data.result_set.points_amount),
							promoType: "POINTS",
							promoPoints: parseFloat(res.data.result_set.points_used)
	
						});
	
						_this8.postOrder(2, 'Yes');
	
						document.getElementById("redeem_points_option").style.display = "block";
						document.getElementById("redeem_point_otp_div").style.display = "none";
	
						helper.showInfo("OTP is verified successfully and rewards points are added your order.");
					} else {
						_this8.resetPromoState();
						helper.showInfo(res.data.message);
					}
				});
			}
	
			/*apply rewards function*/
	
		}, {
			key: 'applyRewards',
			value: function applyRewards() {
				var _this9 = this;
	
				//helper.showInfo('Invalid Rewards');
				var pointsObject = {};
				var postOTPObject = {};
				var pointsVal = parseFloat($("#points").val());
	
				if (pointsVal > 0) {
	
					document.getElementById("PromoLoading").style.display = "block";
	
					var company_otp_verification = _reactCookie2.default.load('client_otp_verification_enable');
					var company_otp_via = _reactCookie2.default.load('client_otp_verification_via');
	
					var qs = __webpack_require__(3);
	
					if (company_otp_verification === '1') {
	
						postOTPObject = {
							"app_id": APPID,
							"customer_first_name": _reactCookie2.default.load('UserFname'),
							"customer_last_name": _reactCookie2.default.load('UserLname'),
							"customer_email": _reactCookie2.default.load('UserEmail'),
							"customer_phone": _reactCookie2.default.load('UserMobile'),
							"customer_otp_type": company_otp_via,
							"verify_type": "redeempoints"
						};
	
						_axios2.default.post(APIURL + "customer/send_customer_otp", qs.stringify(postOTPObject)).then(function (response) {
							document.getElementById("PromoLoading").style.display = "none";
							if (response.data.status === "ok") {
								document.getElementById("redeem_points_option").style.display = "none";
								document.getElementById("redeem_point_otp_div").style.display = "block";
								$("#redeem_points_otp").focus();
								if (company_otp_via === "1") {
									helper.showInfo("OTP has been sent to your email id.");
								} else {
									helper.showInfo("OTP has been sent to your mobile number.");
								}
							} else {
								helper.showInfo(response.data.message);
							}
							return false;
						});
					} else {
	
						var cartSubToatl = this.getOriginalGrandTotal(parseFloat(this.state.originalSubTotal));
						this.setState({ applyRewardsOriginalGrandTotal: cartSubToatl });
	
						pointsObject = {
							/* cart details */
							'app_id': APPID,
							'reference_id': _reactCookie2.default.load('UserId'),
							'pin': this.state.advocadopin,
							'redeem_point': pointsVal,
							'cart_amount': parseFloat(cartSubToatl)
							//this.setState({status:"Loading"});
						};_axios2.default.post(APIURL + 'loyalty/apply_loyalityv1', qs.stringify(pointsObject)).then(function (res) {
							document.getElementById("PromoLoading").style.display = "none";
							if (res.data.status === "success") {
								console.log("cartSubToatl ==> ", parseFloat(cartSubToatl) - parseFloat(res.data.result_set.points_amount));
								// helper.showInfo(res.data.message)
								_this9.setState({
									promoApplied: 'Yes',
									promoAmount: parseFloat(res.data.result_set.points_amount),
									promoType: "POINTS",
									promoPoints: parseFloat(res.data.result_set.points_used),
									finalApplyRewardsOriginalGrandTotal: parseFloat(cartSubToatl) - parseFloat(res.data.result_set.points_amount)
	
								}, function () {
									_reactCookie2.default.save('tempPoints', pointsVal);
									this.resetAppliedPromo('Add', parseFloat(res.data.result_set.points_amount), 'No');
								});
	
								var retun_data = _this9.postOrder(2, 'Yes'); /* Todo : 1 */
							} else {
	
								_this9.resetPromoState();
								helper.showInfo(res.data.message);
							}
						});
					}
				} else {
					$("#points").val('');
					helper.showInfo(alertMsg.pointsRequired);
					return false;
				}
			}
	
			/*apply rewards function*/
	
		}, {
			key: 'applyRewardsAuto',
			value: function applyRewardsAuto(pointsVal) {
				var _this10 = this;
	
				//helper.showInfo('Invalid Rewards');
				var pointsObject = {};
				var postOTPObject = {};
	
				if (pointsVal > 0) {
					if ($('#PromoLoading').length > 0) {
						document.getElementById("PromoLoading").style.display = "block";
					}
	
					var company_otp_verification = _reactCookie2.default.load('client_otp_verification_enable');
					var company_otp_via = _reactCookie2.default.load('client_otp_verification_via');
	
					var qs = __webpack_require__(3);
	
					var cartSubToatl = this.getOriginalGrandTotal(parseFloat(this.state.originalSubTotal));
					this.setState({ applyRewardsOriginalGrandTotal: cartSubToatl });
	
					pointsObject = {
						/* cart details */
						'app_id': APPID,
						'reference_id': _reactCookie2.default.load('UserId'),
						'pin': this.state.advocadopin,
						'redeem_point': pointsVal,
						'cart_amount': parseFloat(cartSubToatl)
						//this.setState({status:"Loading"});
					};_axios2.default.post(APIURL + 'loyalty/apply_loyalityv1', qs.stringify(pointsObject)).then(function (res) {
						if ($('#PromoLoading').length > 0) {
							document.getElementById("PromoLoading").style.display = "none";
						}
						if (res.data.status === "success") {
							console.log("cartSubToatl ==> ", parseFloat(cartSubToatl) - parseFloat(res.data.result_set.points_amount));
							// helper.showInfo(res.data.message)
	
							_this10.setState({
								promoApplied: 'Yes',
								promoAmount: parseFloat(res.data.result_set.points_amount),
								promoType: "POINTS",
								promoPoints: parseFloat(res.data.result_set.points_used),
								finalApplyRewardsOriginalGrandTotal: parseFloat(cartSubToatl) - parseFloat(res.data.result_set.points_amount)
	
							}, function () {
								this.resetAppliedPromo('Add', parseFloat(res.data.result_set.points_amount), 'No');
							});
						} else {
	
							_this10.resetPromoState();
							helper.showInfo(res.data.message);
						}
					});
				} else {
					$("#points").val('');
					helper.showInfo(alertMsg.pointsRequired);
					return false;
				}
			}
	
			/* Advocado registration */
	
		}, {
			key: 'advocadoregister',
			value: function advocadoregister() {
	
				var advocadoObj = {};
	
				if (this.state.advocadopin !== undefined || this.state.advocadopin !== '') {
					document.getElementById("PromoLoading").style.display = "block";
					advocadoObj = {
						'app_id': APPID,
						'customer_id': _reactCookie2.default.load('UserId'),
						'pin': this.state.advocadopin
	
						//this.setState({status:"Loading"});
					};_axios2.default.post(APIURL + 'customer/advocado_register', qs.stringify(advocadoObj)).then(function (res) {
						document.getElementById("PromoLoading").style.display = "none";
						if (res.data.status === "success") {
							$("#advocadopopup").modal("toggle");
							setTimeout(function () {
								location.reload();
							}, 6000);
							helper.showInfo(res.data.message);
						} else {
							$("#advocadopopup").modal("toggle");
							setTimeout(function () {
								location.reload();
							}, 6000);
							helper.showInfo(res.data.message);
						}
					});
				} else {}
			}
	
			/* Advocado registration */
	
		}, {
			key: 'advocadoforgot',
			value: function advocadoforgot() {
	
				var advocadoObj = {};
	
				if (this.state.advocadopin !== undefined || this.state.advocadopin !== '') {
					document.getElementById("PromoLoading").style.display = "block";
					advocadoObj = {
						'app_id': APPID,
						'customer_id': _reactCookie2.default.load('UserId')
	
						//this.setState({status:"Loading"});
					};_axios2.default.post(APIURL + 'customer/advocado_forgot_pin', qs.stringify(advocadoObj)).then(function (res) {
						document.getElementById("PromoLoading").style.display = "none";
						if (res.data.status === "success") {
							helper.showInfo(res.data.message);
						} else {
							helper.showInfo(res.data.message);
						}
					});
				} else {}
			}
	
			/*apply coupon new function*/
	
		}, {
			key: 'applyCoupon',
			value: function applyCoupon(SubTotal, AutoPromoCode) {
				var _this11 = this;
	
				//return false;
				var promoObject = {};
				if (AutoPromoCode !== "" && (typeof AutoPromoCode === 'undefined' ? 'undefined' : _typeof(AutoPromoCode)) !== undefined && typeof AutoPromoCode !== "undefined") {
					var promocode = AutoPromoCode;
				} else {
					var promocode = $("#promocode").val();
				}
	
				if (promocode === '') {
					helper.showInfo(alertMsg.promoRequired);
					return false;
				}
	
				if ($('#PromoLoading').length > 0) {
					document.getElementById("PromoLoading").style.display = "block";
				}
	
				var cartSubToatl = parseFloat(this.state.originalSubTotal);
				var cartItemsCount = this.state.cartDetails.cart_total_items;
				var deliveryAmnt = parseFloat(helper.getDeliveryCharge(this.state.promoApplied, this.state.promoAppliedDelivery, this.state.originalDeliveryAmnt, this.state.isFreeDelivery));
				var AdditionalDeliveryAmnt = parseFloat(this.state.additnl_deliveryAmnt_cal);
	
				promoObject = {
					/* cart details */
					'app_id': APPID,
					'reference_id': _reactCookie2.default.load('UserId'),
					'promo_code': promocode,
					'cart_amount': parseFloat(cartSubToatl),
					'cart_quantity': cartItemsCount,
					'category_id': this.getPromoCategory(),
					'availability_id': _reactCookie2.default.load('defaultAvilablityId'),
					'delivery_amount': deliveryAmnt,
					'additional_delivery_amount': AdditionalDeliveryAmnt,
					'totalDeliveryCharge': deliveryAmnt + AdditionalDeliveryAmnt
				};
	
				_axios2.default.post(APIURL + 'Promotion_api_v3/apply_promotion_v2', qs.stringify(promoObject)).then(function (res) {
					if ($('#PromoLoading').length > 0) {
						document.getElementById("PromoLoading").style.display = "none";
					}
	
					if (res.data.status === "success") {
						var pointDet = res.data.result_set;
						if (pointDet.promotion_delivery_charge_applied === "Yes" && _this11.state.cartDetails.cart_availability_id !== config.ids.deliveryId) {
							_this11.resetPromoState();
							helper.showInfo(alertMsg.promoCodeDeliveryAlert);
							return false;
						}
	
						var promo_object = {
							promoApplied: 'Yes',
							promoAmount: parseFloat(pointDet.promotion_amount),
							promocode: pointDet.promotion_code,
							promoAppliedDelivery: pointDet.promotion_delivery_charge_applied,
							promotionCategory: pointDet.promotionCategory,
							promotionId: pointDet.promotionId,
							previousPromotionAmount: pointDet.promotion_amount,
							promoQty: cartItemsCount,
							promoType: "PROMO",
							promoPoints: 0,
							promo_with_delivery: pointDet.is_include_delivery_discount,
							original_promotion_amount: parseFloat(typeof pointDet.original_promotion_amount !== 'undefined' && pointDet.original_promotion_amount > 0 ? pointDet.original_promotion_amount : 0),
							delivery_promotion_amount: parseFloat(typeof pointDet.delivery_promotion_amount !== 'undefined' && pointDet.delivery_promotion_amount > 0 ? pointDet.delivery_promotion_amount : 0)
						};
						_this11.setState(promo_object, function () {
							_reactCookie2.default.save("tempPromoCode", pointDet.promotion_code, { path: "/" });
							this.resetAppliedPromo('Add', parseFloat(pointDet.promotion_amount), pointDet.promotion_delivery_charge_applied);
						});
	
						if (typeof pointDet.prmo_type !== 'undefined' && pointDet.prmo_type === "add_products") {
							_this11.setState({ promo_type: 'add_products' });
							_reactCookie2.default.save('promo_type', 'add_products');
							_reactCookie2.default.save('promo_object', promo_object);
							_reactCookie2.default.save('is_custom_redirect', 'yes');
							_reactCookie2.default.save('promotion_code', pointDet.promotion_code);
							_reactRouter.hashHistory.push("/");
							_reactRouter.hashHistory.push("/checkout");
						} else {
							if (AutoPromoCode === "") {
								var retun_data = _this11.postOrder(2, 'Yes');
							}
						}
					} else {
						_this11.resetPromoState();
						helper.showInfo(res.data.message);
					}
				});
			}
	
			/*apply coupon  function*/
	
		}, {
			key: 'applyCoupon_old',
			value: function applyCoupon_old(SubTotal) {
				var _this12 = this;
	
				// helper.showInfo('Invalid Promocode');
	
				//alert(SubTotal);
	
				var promoObject = {};
				var promocode = $("#promocode").val();
	
				if (promocode === '') {
					//alert("The Promo code field is Required.")
					helper.showInfo(alertMsg.promoRequired);
					return false;
				}
	
				document.getElementById("PromoLoading").style.display = "block";
				/* get cat category ids */
				//get_productid_cart()
				//{
				var product_cartid = "";
				var cartItems = this.state.cartItems;
				var cartCount = cartItems.length;
				if (cartCount > 0) {
					for (var p = 0; p < cartCount; p++) {
						///alert(cartItems[p].cart_item_product_id);
						if (product_cartid !== '' && cartItems[p].cart_item_product_id !== '') {
							product_cartid += ";";
						}
						product_cartid += cartItems[p].cart_item_product_id + "|" + cartItems[p].cart_item_total_price;
					}
				}
	
				var cartSubToatl = parseFloat(this.state.originalSubTotal);
				var cartItemsCount = this.state.cartDetails.cart_total_items;
				promoObject = {
					/* cart details */
					'app_id': APPID,
					'reference_id': _reactCookie2.default.load('UserId'),
					'promo_code': promocode,
					'cart_amount': parseFloat(cartSubToatl),
					'cart_quantity': cartItemsCount,
					'category_id': this.getPromoCategory()
					//this.setState({status:"Loading"});
				};_axios2.default.post(APIURL + 'promotion_api_v1/apply_promotion', qs.stringify(promoObject)).then(function (res) {
	
					document.getElementById("PromoLoading").style.display = "none";
	
					if (res.data.status === "success") {
	
						if (res.data.result_set.promotion_delivery_charge_applied === "Yes" && _this12.state.cartDetails.cart_availability_id !== config.ids.deliveryId) {
							_this12.resetPromoState();
							helper.showInfo(alertMsg.promoCodeDeliveryAlert);
							return false;
						}
	
						_this12.resetAppliedPromo('Add', parseFloat(res.data.result_set.promotion_amount), res.data.result_set.promotion_delivery_charge_applied);
						_this12.setState({
							promoApplied: 'Yes',
							promoAmount: parseFloat(res.data.result_set.promotion_amount),
							promocode: res.data.result_set.promotion_code,
							promoAppliedDelivery: res.data.result_set.promotion_delivery_charge_applied,
							promotionCategory: res.data.result_set.promotionCategory,
							promotionId: res.data.result_set.promotionId,
							previousPromotionAmount: res.data.result_set.promotion_amount,
							promoQty: cartItemsCount,
							promoType: "PROMO",
							promoPoints: 0
						});
						var retun_data = _this12.postOrder(2, 'Yes');
					} else {
	
						_this12.resetPromoState();
						helper.showInfo(res.data.message);
					}
				});
			}
	
			/*  get promo category details  */
	
		}, {
			key: 'getPromoCategory',
			value: function getPromoCategory() {
	
				var product_cartid = "";
				var cartItems = this.state.cartItems;
				var cartCount = cartItems.length;
				if (cartCount > 0) {
					for (var p = 0; p < cartCount; p++) {
						if (product_cartid !== '' && cartItems[p].cart_item_product_id !== '') {
							product_cartid += ";";
						}
						product_cartid += cartItems[p].cart_item_product_id + "|" + cartItems[p].cart_item_total_price + "|" + cartItems[p].cart_item_qty;
					}
				}
	
				return product_cartid;
			}
	
			/*  reset prmo state values */
	
		}, {
			key: 'resetPromoState',
			value: function resetPromoState() {
	
				this.setState({
					promoApplied: 'No',
					promoAmount: 0,
					promocode: '',
					promoAppliedDelivery: 'No',
					promotionCategory: '',
					promotionId: '',
					promoQty: 0,
					promoType: '',
					promoPoints: 0,
					advocadopin: '',
					'appliedPromocode': ''
				});
	
				_reactCookie2.default.remove('promotion_code');
				_reactCookie2.default.remove('tempPromoCode');
				_reactCookie2.default.remove('tempPoints');
				$("#promocode").val('');
				$("#points").val('');
				this.resetAppliedPromo('Remove', 0, 'No');
				this.resetPromoProducts();
			}
		}, {
			key: 'resetPromoProducts',
			value: function resetPromoProducts() {
				var _this13 = this;
	
				if (this.state.promo_type === "add_products" || _reactCookie2.default.load('promo_type') === "add_products") {
					var qs = __webpack_require__(3);
					var otpObject = { "app_id": APPID, 'customer_id': _reactCookie2.default.load('UserId'), "product_promotion_type": "add_products" };
	
					_axios2.default.post(APIURLPRO + "cartv3/delete_promo_type", qs.stringify(otpObject)).then(function (response) {
	
						_this13.setState({ promo_type: '' });
						_reactCookie2.default.remove('promo_type');
						_reactCookie2.default.remove('promo_object');
						_reactCookie2.default.remove('is_custom_redirect');
						_reactRouter.hashHistory.push("/");
						_reactRouter.hashHistory.push("/checkout");
					});
				}
			}
	
			/* for apply rewards on grand total */
	
		}, {
			key: 'getOriginalGrandTotal',
			value: function getOriginalGrandTotal(returnVal) {
				var cartGrandTotal = returnVal;
				if (rewardsApply === 1 && (0, _lodash.includes)(rewardsApplyList, APPID)) {
					if (this.state.newVoucher === "1") {
						cartGrandTotal = parseFloat(this.state.cartDetails.cart_sub_total).toFixed(2);
					} else {
						cartGrandTotal = (parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount)).toFixed(2);
					}
				}
	
				return cartGrandTotal;
			}
		}, {
			key: 'isApplyRewardOnGrandTotal',
			value: function isApplyRewardOnGrandTotal() {
				return rewardsApply === 1 && (0, _lodash.includes)(rewardsApplyList, APPID) && this.state.promoApplied === "Yes" && this.state.promoType === "POINTS" ? true : false;
			}
	
			/* this function used to load product items */
	
		}, {
			key: 'loadProductsDetails',
			value: function loadProductsDetails() {
	
				var subTotalVal = helper.getsubTotal(this.state.cartDetails.cart_sub_total, this.state.originalSubTotal, this.state.promoApplied, this.state.reedemptionApplied);
	
				var ServiceChargeText = this.state.onlineservice_displaylabel !== '' ? this.state.onlineservice_displaylabel : 'Service Charge';
	
				if (this.state.newVoucher === '1') {
					var cartGrandTotal = config.ids.currency + parseFloat(this.state.cartDetails.cart_sub_total).toFixed(2);
				} else {
					cartGrandTotal = config.ids.currency + (parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount)).toFixed(2);
				}
	
				/*  apply grand total on rewards */
				if (this.isApplyRewardOnGrandTotal()) {
					subTotalVal = parseFloat(this.state.originalSubTotal);
					cartGrandTotal = (parseFloat(this.state.applyRewardsOriginalGrandTotal) - parseFloat(this.state.promoAmount)).toFixed(2);
					//this.setState({finalApplyRewardsOriginalGrandTotal : cartGrandTotal });
				}
	
				return _react2.default.createElement(
					'table',
					null,
					_react2.default.createElement(
						'tbody',
						null,
						this.loadProductItems(),
						_react2.default.createElement(
							'tr',
							{ className: 'sub-total-tr' },
							_react2.default.createElement(
								'td',
								{ className: 'sub-total' },
								'Sub Total'
							),
							_react2.default.createElement(
								'td',
								{ className: 'sub-total text-right' },
								parseFloat(this.state.originalSubTotal).toFixed(2)
							)
						),
						parseFloat(this.state.cartDetails.service_charge_amount) > 0 && this.state.newVoucher != '1' && _react2.default.createElement(
							'tr',
							{ className: 'sub-total-tr' },
							this.state.online_servicecharge_type === 'fixed' ? _react2.default.createElement(
								'td',
								{ className: 'sub-total' },
								ServiceChargeText
							) : _react2.default.createElement(
								'td',
								{ className: 'sub-total' },
								ServiceChargeText,
								' (',
								parseFloat(this.state.online_servicecharge_per),
								'%)'
							),
							_react2.default.createElement(
								'td',
								{ className: 'sub-total text-right' },
								this.state.cartDetails.service_charge_amount
							)
						),
						this.loadDeliveryContent(this.state.cartDetails.cart_availability_id),
						this.loadAddDeliveryContent(this.state.cartDetails.cart_availability_id),
						this.surchargeAmount(),
						this.discountApplied(),
						this.loadTaxAmount(subTotalVal),
						_react2.default.createElement(
							'tr',
							null,
							_react2.default.createElement(
								'td',
								{ className: 'total' },
								'Total ',
								this.stripeMinPayText()
							),
							_react2.default.createElement(
								'td',
								{ className: 'total text-right' },
								cartGrandTotal
							)
						)
					),
					this.showGstInclusive(subTotalVal)
				);
			}
	
			/* stripe MIn pay text */
	
		}, {
			key: 'stripeMinPayText',
			value: function stripeMinPayText() {
				if (this.state.stripeMinPay === "Yes") {
					return _react2.default.createElement(
						'span',
						{ className: 'font_snall' },
						'(',
						alertMsg.stripeMinPaymentText,
						')'
					);
				}
			}
	
			/* discpunt applied  text */
	
		}, {
			key: 'discountApplied',
			value: function discountApplied() {
				if (this.state.promoApplied === "Yes" && this.state.promoAppliedDelivery === "No" && this.state.promo_type !== "add_products") {
					return _react2.default.createElement(
						'tr',
						{ className: 'sub-total-tr' },
						_react2.default.createElement(
							'td',
							{ className: 'sub-total' },
							'Discount Applied',
							this.state.promo_with_delivery === 'Yes' && this.showDeliveryEnabledDiscount()
						),
						_react2.default.createElement(
							'td',
							{ className: 'sub-total text-right' },
							' - ',
							parseFloat(this.state.promoAmount).toFixed(2)
						)
					);
				}
			}
		}, {
			key: 'showDeliveryEnabledDiscount',
			value: function showDeliveryEnabledDiscount() {
	
				if (this.state.original_promotion_amount > 0 && this.state.delivery_promotion_amount > 0) {
					return _react2.default.createElement(
						'p',
						null,
						'(Delivery -$',
						this.state.delivery_promotion_amount,
						' Product -$',
						this.state.original_promotion_amount,
						')'
					);
				} else if (this.state.original_promotion_amount > 0) {
					return _react2.default.createElement(
						'p',
						null,
						'(Product -$',
						this.state.original_promotion_amount,
						')'
					);
				} else if (this.state.delivery_promotion_amount > 0) {
					return _react2.default.createElement(
						'p',
						null,
						'(Delivery -$',
						this.state.delivery_promotion_amount,
						')'
					);
				}
			}
	
			/* this function used to load delivery content */
	
		}, {
			key: 'loadDeliveryContent',
			value: function loadDeliveryContent(availblity) {
				var deliveryAmnt = helper.getDeliveryCharge(this.state.promoApplied, this.state.promoAppliedDelivery, this.state.originalDeliveryAmnt, this.state.isFreeDelivery);
				var voucherNew = this.state.newVoucher;
				if (availblity === config.ids.deliveryId && voucherNew != "1" && deliveryAmnt > 0) {
					return _react2.default.createElement(
						'tr',
						{ className: 'sub-total-tr' },
						_react2.default.createElement(
							'td',
							{ className: 'sub-total' },
							'Delivery'
						),
						_react2.default.createElement(
							'td',
							{ className: 'sub-total text-right' },
							parseFloat(deliveryAmnt).toFixed(2)
						)
					);
				}
			}
	
			/* this function used to load delivery content */
	
		}, {
			key: 'loadTaxAmount',
			value: function loadTaxAmount(subTotal) {
	
				//var gstAmount = parseFloat(this.state.settings.client_tax_surcharge);
	
				var outlet_tax_option = _reactCookie2.default.load('outlet_tax_option');
				var outlet_tax_surcharge = _reactCookie2.default.load('outlet_tax_surcharge');
				var outlet_tax_surcharge_inclusive = _reactCookie2.default.load('outlet_tax_surcharge_inclusive');
	
				if (outlet_tax_option == 1 && outlet_tax_surcharge > "0.00") {
					var gstAmount = outlet_tax_surcharge;
				} else if (outlet_tax_option == 1 && outlet_tax_surcharge_inclusive > "0.00") {
					var gstAmount = "0.00";
				} else {
					var gstAmount = parseFloat(this.state.settings.client_tax_surcharge);
				}
	
				var subTotal_delvry = subTotal;
				if (this.state.cartDetails.cart_availability_id === config.ids.deliveryId) {
					var delAmount = parseFloat(this.state.additnl_deliveryAmnt_cal);
					var deliveryAmnt = helper.getDeliveryCharge(this.state.promoApplied, this.state.promoAppliedDelivery, this.state.originalDeliveryAmnt, this.state.isFreeDelivery);
					var subTotal_delvry = parseFloat(subTotal) + parseFloat(delAmount) + parseFloat(deliveryAmnt);
				}
	
				var service_charge_amount = this.state.cartDetails.service_charge_amount !== '' && this.state.cartDetails.service_charge_amount !== undefined ? parseFloat(this.state.cartDetails.service_charge_amount) : 0;
	
				subTotal_delvry = parseFloat(subTotal_delvry) + parseFloat(this.state.subchr_amount) + parseFloat(service_charge_amount);
	
				var displayGst = helper.getGstValue(gstAmount, subTotal_delvry, 'format');
				var voucherNew = this.state.newVoucher;
				if (gstAmount > 0 && voucherNew != "1") {
					return _react2.default.createElement(
						'tr',
						{ className: 'sub-total-tr' },
						_react2.default.createElement(
							'td',
							{ className: 'sub-total' },
							'GST(',
							gstAmount,
							'%)'
						),
						_react2.default.createElement(
							'td',
							{ className: 'sub-total text-right' },
							displayGst
						)
					);
				}
			}
	
			/* load gstInclusive  amount */
	
		}, {
			key: 'showGstInclusive',
			value: function showGstInclusive(subTotal) {
	
				//var gstAmount = parseFloat(this.state.settings.client_tax_surcharge);
				//var gstInclusive = parseFloat(this.state.settings.client_tax_surcharge_inclusive);
	
				var outlet_tax_option = _reactCookie2.default.load('outlet_tax_option');
				var outlet_tax_surcharge = _reactCookie2.default.load('outlet_tax_surcharge');
				var outlet_tax_surcharge_inclusive = _reactCookie2.default.load('outlet_tax_surcharge_inclusive');
	
				if (outlet_tax_option == 1) {
					if (outlet_tax_surcharge_inclusive > "0.00") {
						var gstAmount = parseFloat(outlet_tax_surcharge);
						var gstInclusive = parseFloat(outlet_tax_surcharge_inclusive);
					} else {
						var gstAmount = parseFloat(outlet_tax_surcharge);
						var gstInclusive = "0.00";
					}
				} else {
					var gstAmount = parseFloat(this.state.settings.client_tax_surcharge);
					var gstInclusive = parseFloat(this.state.settings.client_tax_surcharge_inclusive);
				}
	
				var subTotal_delvry = subTotal;
	
				if (this.state.cartDetails.cart_availability_id === config.ids.deliveryId) {
					var delAmount = parseFloat(this.state.additnl_deliveryAmnt_cal);
					var deliveryAmnt = helper.getDeliveryCharge(this.state.promoApplied, this.state.promoAppliedDelivery, this.state.originalDeliveryAmnt, this.state.isFreeDelivery);
					var subTotal_delvry = parseFloat(subTotal) + parseFloat(delAmount) + parseFloat(deliveryAmnt);
				}
	
				var service_charge_amount = this.state.cartDetails.service_charge_amount !== '' && this.state.cartDetails.service_charge_amount !== undefined ? parseFloat(this.state.cartDetails.service_charge_amount) : 0;
	
				subTotal_delvry = parseFloat(subTotal_delvry) + parseFloat(this.state.subchr_amount) + service_charge_amount;
	
				var displayInclusiveGst = helper.getInclusiveGst(gstInclusive, subTotal_delvry, 'format');
	
				if (gstAmount === 0 && displayInclusiveGst.text != 'undefined') {
					_reactCookie2.default.save('gstInclusive', displayInclusiveGst.text);
					_reactCookie2.default.save('gstInclusiveValue', displayInclusiveGst.value);
					_reactCookie2.default.save('gstInclusivePercent', displayInclusiveGst.percentage);
					return _react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'td',
							{ className: 'text-right', colSpan: 2 },
							displayInclusiveGst.text
						)
					);
				}
			}
	
			/* this function used to load surcharge amount */
	
		}, {
			key: 'surchargeAmount',
			value: function surchargeAmount() {
				var surchrAmount = parseFloat(this.state.subchr_amount);
				var voucherNew = this.state.newVoucher;
				if (surchrAmount > 0 && voucherNew != '1') {
					return _react2.default.createElement(
						'tr',
						{ className: 'sub-total-tr' },
						_react2.default.createElement(
							'td',
							{ className: 'sub-total' },
							'Surcharge'
						),
						_react2.default.createElement(
							'td',
							{ className: 'sub-total text-right' },
							surchrAmount.toFixed(2)
						)
					);
				}
			}
	
			//loadAddDeliveryContent{
	
			/* this function used to load delivery content */
	
		}, {
			key: 'loadAddDeliveryContent',
			value: function loadAddDeliveryContent(availblity) {
	
				/*var delAmount = parseFloat(this.state.settings.additional_delivery_charge);*/
				var delAmount = parseFloat(this.state.additnl_deliveryAmnt_cal);
				var voucherNew = this.state.newVoucher;
				if (availblity === config.ids.deliveryId && delAmount > 0 && voucherNew != '1') {
					return _react2.default.createElement(
						'tr',
						{ className: 'sub-total-tr' },
						_react2.default.createElement(
							'td',
							{ className: 'sub-total' },
							'Additional Surcharge',
							APPID === 'A2924058-9DEC-4A6B-A92C-F762D2C1A7E3' ? _react2.default.createElement(
								'span',
								{ className: 'font_snall' },
								' (This is CBD Zone Surcharge) '
							) : _react2.default.createElement(
								'span',
								{ className: 'font_snall' },
								' (This is applicable to areas that are 5km and further from our address)'
							)
						),
						_react2.default.createElement(
							'td',
							{ className: 'sub-total text-right' },
							parseFloat(delAmount).toFixed(2)
						)
					);
				}
			}
	
			/*load product details */
	
		}, {
			key: 'loadProductItems',
			value: function loadProductItems() {
				var _this14 = this;
	
				return this.state.cartItems.map(function (item, index) {
					return _react2.default.createElement(
						'tr',
						{ key: index },
						_react2.default.createElement(
							'td',
							{ className: 'main-item' },
							item.cart_item_qty,
							' X ',
							strp.stripslashes(item.cart_item_product_name),
							_this14.loadModifierItems(item.cart_item_type, item.modifiers, item.set_menu_component)
						),
						_react2.default.createElement(
							'td',
							{ className: 'text-right' },
							item.cart_item_total_price
						),
						_this14.showProAvblErrorMgs(item),
						_this14.showProStockErrorMgs(item)
					);
				});
			}
		}, {
			key: 'checkOutFlag',
			value: function checkOutFlag(cartItm) {
				var checkFlag = 0;
				this.state.cartItems.map(function (cartItm, index) {
					if (cartItm.pro_current_datetime_avl === 'no' || cartItm.pro_fullfill_datetime_avl === 'no' || cartItm.pro_current_stock_avl === 'no' || cartItm.pro_fullfill_stock_avl === 'no') {
						checkFlag++;
					}
				});
				return checkFlag === 0 ? "block" : "none";
			}
		}, {
			key: 'showProAvblErrorMgs',
			value: function showProAvblErrorMgs(cartItms) {
				// console.log(cartItms); return false;
				var errorMgs = '';
				var availability = _reactCookie2.default.load("defaultAvilablityId");
				var showtext = "delivery/pickup";
				if (availability === config.ids.deliveryId) {
					showtext = "delivery";
				} else if (availability === config.ids.pickupId) {
					showtext = "pickup";
				}
				if (cartItms.pro_current_datetime_avl === 'no') {
					errorMgs = 'This product is not available for order today. Please refer to the product description.';
				} else if (cartItms.pro_fullfill_datetime_avl === 'no') {
					errorMgs = 'This product is not available for ' + showtext + ' on the selected date and time. Please refer to the product description.';
				}
	
				if (errorMgs !== '') {
					return _react2.default.createElement(
						'div',
						{ className: 'pro-avbl-errormsg' },
						errorMgs
					);
				}
			}
		}, {
			key: 'showProStockErrorMgs',
			value: function showProStockErrorMgs(cartItms) {
				var errorMgs = '';
				var availability = _reactCookie2.default.load("defaultAvilablityId");
				var showtext = "delivery/pickup";
				if (availability === config.ids.deliveryId) {
					showtext = "delivery";
				} else if (availability === config.ids.pickupId) {
					showtext = "pickup";
				}
				if (cartItms.pro_current_stock_avl === 'no') {
					errorMgs = 'The selected quantity is not available for order.';
				} else if (cartItms.pro_fullfill_stock_avl === 'no') {
					errorMgs = 'The selected quantity is not available for ' + showtext + ' on the selected date and time.';
				}
	
				if (errorMgs !== '') {
					return _react2.default.createElement(
						'div',
						{ className: 'pro-avbl-errormsg' },
						errorMgs
					);
				}
			}
	
			/* this function used to load modifer items */
	
		}, {
			key: 'loadModifierItems',
			value: function loadModifierItems(itemType, modifiers, combo) {
				var len = modifiers.length;
				var comboLen = combo.length;
				var html = "<ul className='table_list'>";
	
				if (itemType === "Modifier" && len > 0) {
					for (var i = 0, length = len; i < length; i++) {
						var modName = modifiers[i]['cart_modifier_name'];
						var modval = modifiers[i]['modifiers_values'][0]['cart_modifier_name'];
						html += "<li className='sub-item'>" + modName + " : " + modval + "</li> ";
					}
					html += "</ul>";
					var reactElement = htmlToReactParserTo.parse(html);
					return reactElement;
				} else if (itemType === "Component" && comboLen > 0) {
					for (var i = 0, length = comboLen; i < length; i++) {
						var comboName = combo[i]['menu_component_name'];
						var comboVal = this.showComboProducts(combo[i]['product_details']);
						/* html += "<li className='sub-item'><b>"+comboName+" :</b>"+comboVal+" "+this.showComboModifiers(combo[i]['product_details'][0]['modifiers'])+"</li> "; */
						html += "<li className='sub-item'><b>" + comboName + " :</b> " + comboVal + " " + this.showComboModifiers(combo[i]['product_details'][0]['modifiers']) + "</li> ";
					}
					html += "</ul>";
					var reactElement = htmlToReactParserTo.parse(html);
					return reactElement;
				}
			}
	
			/* show combo products  list */
	
		}, {
			key: 'showComboProducts',
			value: function showComboProducts(combos) {
				var lenCombo = combos.length;
				var html = " ";
				if (lenCombo > 0) {
					for (var r = 0, lengthCombo = lenCombo; r < lengthCombo; r++) {
						var comboPro = combos[r]['cart_menu_component_product_name'];
						comboPro = comboPro !== '' ? strp.stripslashes(comboPro) : comboPro;
						var comboQty = combos[r]['cart_menu_component_product_qty'];
						var comboPrice = combos[r]['cart_menu_component_product_price'];
						var newPrice = comboPrice > 0 ? " (+" + comboPrice + ")" : "";
						html += "<li className='sub-item'>" + comboQty + " X " + comboPro + newPrice + " </li> ";
					}
					return html;
				}
				return "";
			}
	
			/* this function used to show combo modifieirs list */
	
		}, {
			key: 'showComboModifiers',
			value: function showComboModifiers(modifiers) {
				//console.log(modifiers);
				var lenMod = modifiers.length;
				var html = "<ul className='table_list'>";
				if (lenMod > 0) {
					for (var i = 0, length = lenMod; i < length; i++) {
						var modName = modifiers[i]['cart_modifier_name'];
						var modval = modifiers[i]['modifiers_values'][0]['cart_modifier_name'];
						var modValPrice = modifiers[i]['modifiers_values'][0]['cart_modifier_price'];
						var newModValPrice = modValPrice > 0 ? " (+" + modValPrice + ")" : "";
						html += "<li className='sub-item'>" + modName + "  : " + modval + newModValPrice + "</li> ";
					}
					html += "</ul>";
					// var reactElement = htmlToReactParserTo.parse(html );
					return html;
				}
	
				return "";
			}
		}, {
			key: 'processRazerpay',
			value: function processRazerpay() {
				var self = this;
				var razerpay_api_key = this.state.settings.razerpay_api_key;
				var razerpay_key_secret = this.state.settings.razerpay_key_secret;
				var razerpay_secret_key = this.state.settings.razerpay_secret_key;
				var postObject = {};
				var calc_grand_total = this.getApplyRewardsPaymentTotal(this.state.newVoucher != "1" ? parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount) : parseFloat(this.state.cartDetails.cart_sub_total));
				/*Calculate service charge End*/
				//calc_grand_total = parseInt(calc_grand_total * 100);
	
				var current = this;
	
				var redirectUrl = window.location.protocol + '//' + window.location.hostname + '/#/checkout';
				postObject = {
					'app_id': APPID,
					'razerpay_api_key': razerpay_api_key,
					'razerpay_key_secret': razerpay_key_secret,
					'razerpay_secret_key': razerpay_secret_key,
					'customer_id': _reactCookie2.default.load('UserId'),
					"outlet_id": _reactCookie2.default.load('orderOutletId'),
					'amount': calc_grand_total,
					'email': _reactCookie2.default.load('UserEmail'),
					'mobile': _reactCookie2.default.load('UserMobile'),
					'firstname': _reactCookie2.default.load('UserFname'),
					'lastname': _reactCookie2.default.load('UserLname'),
					'address': _reactCookie2.default.load('orderDeliveryAddress'),
					'return_url': APIURL + 'paymentv1/razerpay_success',
					'cancel_url': APIURL + 'paymentv1/razerpay_canceled',
					'redirect_url': redirectUrl
	
				};
	
				_axios2.default.post(APIURL + "paymentv1/razorpayOrder?" + Math.random().toString(36).substring(10), qs.stringify(postObject)).then(function (res) {
					if (res.data.status === true) {
						console.info(res.data);
						$('#molpay_btn').html("<button type=\"button\" id=\"myPay\" class=\"btn btn-primary btn-lg\" data-toggle=\"molpayseamless\" data-mpsmerchantid=\"" + res.data.mpsmerchantid + "\" data-mpschannel=\"" + res.data.mpschannel + "\" data-mpsamount=\"" + res.data.mpsamount + "\" data-mpsorderid=\"" + res.data.mpsorderid + "\" data-mpsbill_name=\"" + res.data.mpsbill_name + "\" data-mpscurrency=\"" + res.data.mpscurrency + "\" data-mpsvcode=\"" + res.data.mpsvcode + "\">Pay by Maybank2u</button>");
	
						var var_mpsbill_name = res.data.mpsbill_name;
						var var_mpsbill_email = res.data.mpsbill_email;
						if ($("[data-toggle=\"molpayseamless\"]")) {
							$("[data-toggle=\"molpayseamless\"]").attr('data-mpsbill_name', var_mpsbill_name);
						} else {
							$("[data-toggle=molpayseamless]").attr('data-mpsbill_name', var_mpsbill_name);
						} //End of if()
						if ($("[data-toggle=\"molpayseamless\"]")) {
							$("[data-toggle=\"molpayseamless\"]").attr('data-mpsbill_email', var_mpsbill_email);
						} else {
							$("[data-toggle=molpayseamless]").attr('data-mpsbill_email', var_mpsbill_email);
						} //End of if()
						if ($("[data-toggle=\"molpayseamless\"]")) {
							$("[data-toggle=\"molpayseamless\"]").attr('data-mpsreturnurl', res.data.mpsreturnurl);
						} else {
							$("[data-toggle=molpayseamless]").attr('data-mpsreturnurl', res.data.mpsreturnurl);
						} //End of if()
						$("#loading-popup").modal('toggle');
						$(".loading-popup-img").hide();
						$('#molpay_btn').hide();
						$('#myPay').trigger('click');
	
						//self.setState({razerpayOrderId:res.data.merchant_order_id});
						//self.renderIframe(res);
					} else {
						self.setState({ isPaymentProcessing: response.message });
					}
				}).catch(function (error) {});
			}
		}, {
			key: 'processStripesession',
			value: function processStripesession() {
				var self = this;
				var postObject = {};
				var calc_grand_total = this.getApplyRewardsPaymentTotal(this.state.newVoucher != "1" ? parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount) : parseFloat(this.state.cartDetails.cart_sub_total));
	
				var current = this;
	
				var redirectUrl = window.location.protocol + '//' + window.location.hostname + '/#/';
				$("#loading-popup").modal('toggle');
				$(".loading-popup-img").show();
				postObject = {
					'app_id': APPID,
					'customer_id': _reactCookie2.default.load('UserId'),
					"outlet_id": _reactCookie2.default.load('orderOutletId'),
					'paid_amount': calc_grand_total,
					'availability_id': _reactCookie2.default.load('defaultAvilablityId'),
					"payment_reference": config.stripe.stripeReference,
					"stripe_envir": this.state.settings.client_stripe_mode === 1 ? 'live' : 'dev',
					'site_url': redirectUrl
				};
	
				_axios2.default.post(APIURL + "paymentv1/stripeClientTokenGenerateredirect?" + Math.random().toString(36).substring(10), qs.stringify(postObject)).then(function (statusRes) {
					if (statusRes.data.status === "ok") {
						_reactCookie2.default.save("paymentSession", statusRes.data.result_set.session_id, { path: "/" });
						$(document).find(".proceedpayment").attr("href", statusRes.data.result_set.url);
	
						$("#loading-popup").modal('toggle');
						$(".loading-popup-img").hide();
						$("#stripepopup").modal({ backdrop: 'static', keyboard: false });
					} else {
						helper.showInfo('Something is wrong. Try again');
						self.setState({ isPaymentProcessing: "Something is wrong. Try again" });
					}
				}).catch(function (error) {});
			}
	
			/* this function used to  validate payment method.. */
	
		}, {
			key: 'payNow',
			value: function payNow() {
				var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
				(0, _withTracker.fbPixelCustomEvent)('EnteredPaymentInfo', {});
				$('.checkout-note').hide();
				if (method === "PROMOTION") {
					this.setState({ 'paymentStatus': 'PROMOTION' }); /* used process screen html show */
					this.postOrder(4);
					this.setState({ 'defaultClass': 'chk_popup_bg' });
					$("#SwitchingError").modal("toggle");
				} else {
					if (document.getElementById('cash') !== null && document.getElementById('cash').checked) {
						console.log('cash');
						this.setState({ 'paymentStatus': 'CASH' }); /* used process screen html show */
						this.postOrder(1);
						this.setState({ 'defaultClass': 'chk_popup_bg' });
						$("#SwitchingError").modal("toggle");
					} else if (document.getElementById('offline') !== null && document.getElementById('offline').checked) {
	
						this.setState({ 'paymentStatus': 'OFFLINE' }); /* used process screen html show */
						this.postOrder(10);
						this.setState({ 'defaultClass': 'chk_popup_bg' });
						$("#SwitchingError").modal("toggle");
					} else if (document.getElementById('stripe') !== null && document.getElementById('stripe').checked) {
						this.setState({ 'paymentStatus': 'ONLINE' }); /* used process screen html show */
						_reactCookie2.default.save('orderPaymentMode', 'STRIPE');
						//indow.location="/pay-now";
						// hashHistory.push("/pay-now");
						$("#loading-popup").modal('toggle');
						$(".loading-popup-img").show();
						$('.checkout-note').show();
						this.postOrder(3, 'Yes');
						this.setState({ isPaymentProcessing: 'processing' });
						this.processStripesession();
					} else if (document.getElementById('razerpay') !== null && document.getElementById('razerpay').checked) {
						$("#loading-popup").modal('toggle');
						$(".loading-popup-img").show();
						$('.checkout-note').show();
						this.setState({ isPaymentProcessing: 'processing' });
						this.processRazerpay();
					} else if (document.getElementById('omise') !== null && document.getElementById('omise').checked) {
						$("#omisepopup").modal({ backdrop: 'static', keyboard: false });
					} else if (document.getElementById('omise-paynow') !== null && document.getElementById('omise-paynow').checked) {
						$("#loading-popup").modal('toggle');
						$(".loading-popup-img").show();
						Omise.setPublicKey(this.state.settings.omise_paynow_public_key);
						var calc_grand_total = this.getApplyRewardsPaymentTotal(this.state.newVoucher != "1" ? parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount) : parseFloat(this.state.cartDetails.cart_sub_total));
						/*Calculate service charge End*/
						calc_grand_total = parseInt(Math.round(calc_grand_total * 100));
						var current = this;
						Omise.createSource('paynow', {
							"amount": calc_grand_total,
							"currency": "SGD",
							"name": _reactCookie2.default.load('UserFname'),
							"email": _reactCookie2.default.load('UserEmail')
						}, function (statusCode, response) {
							if (statusCode == 200) {
	
								var sourceId = response.id;
								var postObject = {};
								var orderOutlet_Id = _reactCookie2.default.load('orderOutletId');
								postObject = {
									'app_id': APPID,
									'source_id': sourceId,
									'customer_id': _reactCookie2.default.load('UserId'),
									"outlet_id": orderOutlet_Id,
									'amount': response.amount,
									"customer_name": _reactCookie2.default.load('UserFname'),
									"customer_email": _reactCookie2.default.load('UserEmail')
	
								};
	
								if (current.state.statusInterval != null) {
									clearInterval(current.state.statusInterval);
									current.setState({
										paynowAttempts: 0
									});
								}
	
								_axios2.default.post(APIURL + "paymentv1/paynowCapture", qs.stringify(postObject)).then(function (res) {
	
									if (res.data.status === "ok") {
										$("#loading-popup").modal('toggle');
										$(".loading-popup-img").hide();
										$('#paynow-qr-image').attr('src', res.data.result_set.download_uri).load(function () {
	
											$('.omise-paynow-amount-to-paid span').text('SGD ' + (calc_grand_total / 100).toFixed('2'));
											$('.alert-payment').hide();
											$("#omise-paynow-popup").modal({ backdrop: 'static', keyboard: false });
											$('.paynow-seconds span').text('600 sec');
											$('.paynow-seconds span').css({ 'padding-left': '4px', 'display': 'inline-block', 'width': '70px', 'text-align': 'left' });
											var timer = 600;
	
											/* var timerInterval	=	setInterval(function() {
	            if(timer < 0) {
	          	  clearInterval(timerInterval);
	          	  clearInterval(statusInterval);
	            } else {
	          	  $('.paynow-seconds span').text(timer+' sec');
	          	  timer	=	timer-1;
	            }
	           },1000);*/
											current.setState({ 'paymentGateway': 'Omise' });
											//current.postOrder(5,'No');
											current.state.statusInterval = setInterval(function () {
												if (current.state.paynowAttempts >= 100) {
													clearInterval(current.state.statusInterval);
													$('#omise-paynow-popup').modal('toggle');
	
													current.setState({
														paynowAttempts: 0
													});
													alert('Time has been expired. Please try again.');
													window.location.reload(false);
													return;
												}
	
												if (current.state.paynowAttempts == 1) {
													$('.alert-payment').show();
												}
	
												if (timer < 0) {
													clearInterval(current.state.statusInterval);
												} else {
													console.log(current.state.paynowAttempts);
													$('.paynow-seconds span').text(timer + ' sec');
													timer = timer - 1;
												}
												var r = timer % 6;
												if (r == 0) {
													var statusObj = {};
													statusObj = {
														'app_id': APPID,
														'customer_id': _reactCookie2.default.load('UserId'),
														'outlet_id': orderOutlet_Id,
														'capture_id': res.data.result_set.captureId
													};
													_axios2.default.post(APIURL + "paymentv1/checkPaynowStatus", qs.stringify(statusObj)).then(function (statusRes) {
	
														if (statusRes.data.result_set.omise_paynow_status) {
															clearInterval(current.state.statusInterval);
															current.setState({ omisePayNowStatus: 2 });
															current.setState({ payNowCaptureId: res.data.result_set.captureId });
	
															$('#omise-paynow-popup').modal('toggle');
															$("#SwitchingError").modal("toggle");
															current.postOrder(5, 'No');
															current.setState({
																paynowAttempts: 101
															});
														} else {
															var pState = current.state.paynowAttempts + 1;
															current.setState({
																paynowAttempts: pState
															});
														}
													});
												}
											}, 1000);
										});
									}
								}).catch(function (error) {});
							} else {
								console.log(response);
							}
						});
					} else {
						helper.showInfo(lang.choose_payment_mode);
					}
				}
			}
	
			/* Omise Payment Gateway Start */
	
		}, {
			key: 'space',
			value: function space(el) {
				var numbes = el.replace(/ /g, "");
				return numbes.replace(/(\d{4})/g, '$1 ').replace(/(^\s+|\s+$)/, '');
			}
		}, {
			key: 'cardValidation',
			value: function cardValidation(carnumber) {
				var imagename = '';
				if (carnumber != '') {
					var single = carnumber.substring(0, 1);
					var double = carnumber.substring(0, 2);
	
					if (single == 4) {
						imagename = 'visa.png';
					} else if (double == 34 || double == 37) {
						imagename = 'american-express.png';
					} else if (double >= 51 && double <= 55) {
						imagename = 'master-card.png';
					} else if (double == 60 || double == 64 || double == 65) {
						imagename = 'discover.png';
					}
					if (imagename != '') {
						this.setState({ cardImage: htmlToReactParserTo.parse('<img src="img/cards/' + imagename + '" className="card-image" alt="" />') });
					} else {
						this.setState({ cardImage: '' });
					}
				} else {
	
					this.setState({ cardImage: '' });
				}
			}
	
			/* Generate Token */
	
		}, {
			key: 'getOmiseToken',
			value: function getOmiseToken() {
				var error = 0;
				if (this.state.holdername == '') {
					error++;this.setState({ omisenameerror: htmlToReactParserTo.parse('<span className="spn-error">This field is required.</span>') });
				} else {
					this.setState({ omisenameerror: '' });
				}
	
				if (this.state.cardNumber == '') {
					error++;this.setState({ omisecardrror: htmlToReactParserTo.parse('<span className="spn-error">This field is required.</span>') });
				} else {
					this.setState({ omisecardrror: '' });
				}
	
				if (this.state.expiration_month == '') {
					error++;this.setState({ omisemontherror: htmlToReactParserTo.parse('<span className="spn-error">Required.</span>') });
				} else {
					this.setState({ omisemontherror: '' });
				}
	
				if (this.state.expiration_year == '') {
					error++;this.setState({ omiseyearerror: htmlToReactParserTo.parse('<span className="spn-error">Required.</span>') });
				} else {
					this.setState({ omiseyearerror: '' });
				}
	
				if (this.state.security_code == '') {
					error++;this.setState({ omisecodeerror: htmlToReactParserTo.parse('<span className="spn-error">This field is required.</span>') });
				} else {
					this.setState({ omisecodeerror: '' });
				}
				if (error > 0) {
					return false;
				} else {
					$('#omisepopup .btn.bg-black').button('loading');
					Omise.setPublicKey(this.state.settings.omise_public_key);
					var current = this;
					var card = {
						"name": this.state.holdername,
						"number": this.state.cardNumber,
						"expiration_month": this.state.expiration_month,
						"expiration_year": this.state.expiration_year,
						"security_code": this.state.security_code,
						'livemode': false
					};
					Omise.createToken("card", card, function (statusCode, response) {
						$('#omisepopup .btn.bg-black').button('reset');
						if (statusCode === 200) {
							if (response.object == "error" || !response.card.security_code_check) {
								var message_text = "Invalid card details.";
	
								if (response.object == "error") {
									message_text = response.message;
								}
								helper.showInfo(message_text);
							} else {
								$('#omisepopup').modal('hide');
								//current.onProcessOmiseToken(response);
								current.setState({ 'omise_tokken_response': response, 'omise_tokken_card_id': response.card.id, 'omise_tokken_id': response.id }, function () {
									current.onProcessOmiseToken(response);
								});
							}
						} else {
							helper.showInfo(response.message);
						}
					});
				}
			}
			/* Authentication For Payment */
	
		}, {
			key: 'captureOmiseAmount',
	
	
			/* Capture Payment */
			value: function captureOmiseAmount(captureID, orderPrimaryId, localOrderNo) {
				var _this15 = this;
	
				var cabtureObjects = {};
				var captureParams = captureID + "~" + orderPrimaryId + "~" + localOrderNo;
				var orderOutlet_Id = _reactCookie2.default.load('orderOutletId');
				cabtureObjects = { payment_reference: config.stripe.stripeReference, "customer_id": _reactCookie2.default.load('UserId'), 'app_id': config.ids.appId, 'token': captureID, 'order_id': orderPrimaryId, 'log_id': this.state.log_id, "outlet_id": orderOutlet_Id };
				_axios2.default.post(APIURL + "paymentv1/captureAmountOmise", qs.stringify(cabtureObjects)).then(function (captureRes) {
					if (captureRes.data.status === "ok") {
						_this15.showSuccessPage(localOrderNo, orderPrimaryId);
					} else if (captureRes.data.status === "pending") {
						_this15.retrieve_charge_details(captureID, localOrderNo, orderPrimaryId);
					} else if (captureRes.data.status === "error") {
						$("#SwitchingError").modal("toggle");
						document.getElementById("PayProcess").style.display = "none";
						_this15.setState({ 'defaultClass': '' });
						_this15.setState({ status: "error" });
						/*helper.showInfo(res.data.status);*/
						var msgTxt = res.data.message != '' ? res.data.message : res.data.status;
						helper.showInfo(msgTxt);
					} else {
						/*Get Status of Charge ID*/
						_this15.retrieve_charge_details(captureID, localOrderNo, orderPrimaryId);
					}
				}).catch(function (error) {
					_this15.captureOmiseAmount(captureID, orderPrimaryId, localOrderNo);
				});
			}
		}, {
			key: 'enableOmise',
	
	
			/* Enable Omise */
			value: function enableOmise() {
				var omiseSts = parseInt(this.state.settings.client_omise_enable);
				var stripeSts = parseInt(this.state.settings.client_stripe_enable);
				var codSts = parseInt(this.state.settings.client_cod_enable);
				var stripeAvl = parseInt(this.state.settings.client_stripe_availability);
				var codAvl = parseInt(this.state.settings.client_cod_availability);
				var calc_grand_total = this.getApplyRewardsPaymentTotal(parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount));
				var omiseChecked = (codSts === 0 || codAvl === 0) && (stripeSts === 0 || stripeAvl === 0) ? true : false;
				if (omiseSts === 1 && parseFloat(calc_grand_total) > 0 && parseInt(this.state.settings.client_payment_availability_enable) === 0 || omiseSts === 1 && parseFloat(calc_grand_total) > 0 && parseInt(this.state.settings.client_payment_availability_enable) === 1) {
					return _react2.default.createElement(
						'label',
						null,
						_react2.default.createElement('input', { type: 'radio', name: 'payment', id: 'omise', defaultChecked: omiseChecked, value: 'OMISE', onClick: this.showCheckoutBtn.bind(this, 'OMISE') }),
						_react2.default.createElement('span', { className: 'circle' }),
						_react2.default.createElement('span', { className: 'check' }),
						_react2.default.createElement('img', { src: '/img/cards/omise.png', className: 'img-responsive img-width-120', alt: 'omise' })
					);
				}
			}
		}, {
			key: 'enableRazerpay',
			value: function enableRazerpay() {
				var isEnabled = parseInt(this.state.settings.razerpay_enable);
				var calc_grand_total = this.getApplyRewardsPaymentTotal(parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount));
				if (isEnabled && parseFloat(calc_grand_total) > 0) {
					var script_r = document.createElement("script");
					console.info(this.state.settings.razerpay_mode);
					if (this.state.isRazerpayScript == false) {
						this.setState({ isRazerpayScript: true });
						if (this.state.settings.razerpay_mode == 'live') {
							script_r.src = "https://www.onlinepayment.com.my/MOLPay/API/seamless/latest/js/MOLPay_seamless.deco.js";
						} else {
							script_r.src = "https://sandbox.merchant.razer.com/MOLPay/API/seamless/latest/js/MOLPay_seamless.deco.js";
						}
	
						script_r.async = true;
						document.body.appendChild(script_r);
					}
	
					return _react2.default.createElement(
						'label',
						null,
						_react2.default.createElement('input', { type: 'radio', name: 'payment', id: 'razerpay', value: 'RAZERPAY', onClick: this.showCheckoutBtn.bind(this, 'RAZERPAY') }),
						_react2.default.createElement('span', { className: 'circle' }),
						_react2.default.createElement('span', { className: 'check' }),
						_react2.default.createElement('img', { src: '/img/cards/razerpay.jpg', className: 'img-responsive img-width-120', alt: 'RAZERPAY' }),
						_react2.default.createElement('div', { id: 'molpay_btn' })
					);
				}
			}
		}, {
			key: 'razerpaySts',
			value: function razerpaySts() {
				var isEnabled = parseInt(this.state.settings.razerpay_enable);
				var calc_grand_total = this.getApplyRewardsPaymentTotal(parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount));
				if (isEnabled && parseFloat(calc_grand_total) > 0) {
					return "block";
				} else {
					return "none";
				}
			}
		}, {
			key: 'enableOmisePayNow',
			value: function enableOmisePayNow() {
				var isPayNowEnabled = parseInt(this.state.settings.client_omise_enable_paynow);
				var omiseChecked = false;
				var calc_grand_total = this.getApplyRewardsPaymentTotal(parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount));
				if (isPayNowEnabled === 1 && parseFloat(calc_grand_total) > 0) {
					return _react2.default.createElement(
						'label',
						null,
						_react2.default.createElement('input', { type: 'radio', name: 'payment', id: 'omise-paynow', defaultChecked: omiseChecked, value: 'OMISE-PAYNOW', onClick: this.showCheckoutBtn.bind(this, 'OMISE-PAYNOW') }),
						_react2.default.createElement('span', { className: 'circle' }),
						_react2.default.createElement('span', { className: 'check' }),
						_react2.default.createElement('img', { src: '/img/omise-paynow.png', className: 'img-responsive img-width-120', alt: 'omise' })
					);
				}
			}
		}, {
			key: 'omiseSts',
			value: function omiseSts() {
				var codSts = parseInt(this.state.settings.client_cod_enable);
				var omiseStsVl = parseInt(this.state.settings.client_omise_enable);
				var omiseAvl = parseInt(this.state.settings.client_omise_availability);
				var calc_grand_total = this.getApplyRewardsPaymentTotal(parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount));
				if ((codSts === 1 && omiseStsVl === 1 || codSts === 1 && omiseStsVl === 0) && parseFloat(calc_grand_total) <= 0) {
					return "none";
				} else {
					return omiseStsVl == 1 && omiseAvl === 1 ? "block" : "none";
				}
			}
	
			/* Omise Payment Gateway End */
	
			/* Show checkout page */
	
		}, {
			key: 'showCheckoutBtn',
			value: function showCheckoutBtn(type) {
				this.setState({ omisePayment: 0 });
				if (type === "CASH") {
					$("#extraBtn").show();
					//console.log(type);
					document.getElementById("cash_btn").style.display = "block";
					document.getElementById("stripe_btn").style.display = "none";
					document.getElementById("paypal_btn").style.display = "none";
					document.getElementById("omise_btn").style.display = "none";
					document.getElementById("razerpay_btn").style.display = "none";
					document.getElementById("omise_btn_paynow").style.display = "none";
	
					this.cal_service_charge(1);
				}
				if (type === "OFFLINE") {
					$("#extraBtn").show();
					$("#offlinePaymentInfo").modal("toggle");
					document.getElementById("cash_btn").style.display = "block";
					document.getElementById("stripe_btn").style.display = "none";
					document.getElementById("paypal_btn").style.display = "none";
					document.getElementById("omise_btn").style.display = "none";
					document.getElementById("razerpay_btn").style.display = "none";
					document.getElementById("omise_btn_paynow").style.display = "none";
	
					this.cal_service_charge(1);
				} else if (type === "STRIPE") {
					$("#extraBtn").show();
					//console.log(type);
					document.getElementById("cash_btn").style.display = "none";
					document.getElementById("stripe_btn").style.display = "block";
					document.getElementById("paypal_btn").style.display = "none";
					document.getElementById("omise_btn").style.display = "none";
					document.getElementById("razerpay_btn").style.display = "none";
					document.getElementById("omise_btn_paynow").style.display = "none";
	
					this.cal_service_charge(3);
				} else if (type === "PAYPAL") {
					$("#extraBtn").hide();
					document.getElementById("cash_btn").style.display = "none";
					document.getElementById("stripe_btn").style.display = "none";
					document.getElementById("paypal_btn").style.display = "block";
					document.getElementById("omise_btn").style.display = "none";
					document.getElementById("razerpay_btn").style.display = "none";
					document.getElementById("omise_btn_paynow").style.display = "none";
					this.cal_service_charge(2);
				} else if (type === "OMISE") {
					this.setState({ omisePayment: 1 });
					document.getElementById("cash_btn").style.display = "none";
					document.getElementById("stripe_btn").style.display = "none";
					document.getElementById("paypal_btn").style.display = "none";
					document.getElementById("omise_btn").style.display = "block";
					document.getElementById("razerpay_btn").style.display = "none";
					document.getElementById("omise_btn_paynow").style.display = "none";
	
					this.cal_service_charge(3);
				} else if (type === "OMISE-PAYNOW") {
					this.setState({ omisePayment: 1 });
					document.getElementById("cash_btn").style.display = "none";
					document.getElementById("stripe_btn").style.display = "none";
					document.getElementById("paypal_btn").style.display = "none";
					document.getElementById("omise_btn").style.display = "none";
					document.getElementById("razerpay_btn").style.display = "none";
					document.getElementById("omise_btn_paynow").style.display = "block";
	
					this.cal_service_charge(5);
				} else if (type === "RAZERPAY") {
					this.setState({ omisePayment: 1 });
					document.getElementById("cash_btn").style.display = "none";
					document.getElementById("stripe_btn").style.display = "none";
					document.getElementById("paypal_btn").style.display = "none";
					document.getElementById("omise_btn").style.display = "none";
					document.getElementById("omise_btn_paynow").style.display = "none";
					document.getElementById("razerpay_btn").style.display = "block";
	
					this.cal_service_charge(5);
				}
			}
	
			/* this function used back nav link for all avilablities */
	
		}, {
			key: 'backLink',
			value: function backLink() {
				/* Validate delivery order details */
				if (this.state.cartDetails.cart_availability_id === config.ids.deliveryId || this.state.cartDetails.cart_availability_id === config.ids.pickupId) {
					return "delivery-date";
				} else {
					if (APPID === "287E5552-328E-4DBE-A3CA-E998ACCAC9BD") {
						return "/";
					} else {
						return "cart";
					}
				}
			}
	
			/* this function nused to load */
	
		}, {
			key: 'showOrderDetails',
			value: function showOrderDetails() {
				var labelThree = '';var labelThreeVal = '';
				if (this.state.cartDetails.cart_availability_id !== config.ids.dineinId) {
					var labelOne = _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId ? "Delivery Date" : "Pickup Date";
					var labelOneVal = _reactCookie2.default.load('DeliveryDate');
					var labelTwo = _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId ? "Delivery Time" : "Pickup Time";
					//<Moment format="HH:mm">{cookie.load('DeliveryTimeSlot')}</Moment>
					/*var labelTwoVal = (cookie.load('isSletedTimeSlot') === "Yes"?  cookie.load('DeliveryTimeSlotFormated') :   cookie.load('DeliveryTime'));*/
					var labelTwoVal = _reactCookie2.default.load('isSletedTimeSlot') === "Yes" ? _reactCookie2.default.load('DeliveryTimeSlotFormated') : _reactCookie2.default.load('DeliveryTime');
	
					return _react2.default.createElement(
						'div',
						{ className: 'col-xs-12' },
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-6  date-info' },
							_react2.default.createElement(
								'p',
								{ className: '' },
								labelOne,
								':',
								_react2.default.createElement(
									'span',
									{ className: 'span-txt1 small-font' },
									' ',
									labelOneVal
								)
							),
							labelThree,
							_react2.default.createElement(
								'p',
								{ className: 'visible-xs' },
								_react2.default.createElement(
									'span',
									null,
									labelTwo,
									': '
								),
								_react2.default.createElement(
									'span',
									{ className: 'span-txt1 small-font' },
									labelTwoVal
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-6 hidden-xs date-info' },
							_react2.default.createElement(
								'p',
								{ className: 'text-right' },
								_react2.default.createElement(
									'span',
									null,
									labelTwo,
									': '
								),
								_react2.default.createElement(
									'span',
									{ className: 'span-txt1' },
									labelTwoVal
								)
							)
						)
					);
				} else {
	
					return _react2.default.createElement(
						'div',
						{ className: 'col-xs-12' },
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-6  date-info' },
							_react2.default.createElement(
								'p',
								{ className: '' },
								'Dine in Date: ',
								_react2.default.createElement(
									'span',
									{ className: 'span-txt1' },
									' ',
									currentDate
								)
							),
							_react2.default.createElement(
								'p',
								{ className: 'visible-xs' },
								_react2.default.createElement(
									'span',
									null,
									'Current Time : '
								),
								_react2.default.createElement(
									'span',
									{ className: 'span-txt1' },
									currentTime
								)
							),
							_react2.default.createElement(
								'p',
								{ className: '' },
								'Table : ',
								_react2.default.createElement(
									'span',
									{ className: 'span-txt1' },
									_reactCookie2.default.load('orderTableNo')
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-6 hidden-xs date-info' },
							_react2.default.createElement(
								'p',
								{ className: 'text-right' },
								_react2.default.createElement(
									'span',
									null,
									'Current Time : '
								),
								_react2.default.createElement(
									'span',
									{ className: 'span-txt1' },
									currentTime
								)
							),
							_react2.default.createElement(
								'p',
								{ className: 'text-right' },
								'\xA0',
								_react2.default.createElement(
									'span',
									{ className: 'span-txt1' },
									'\xA0'
								)
							)
						)
					);
				}
			}
	
			/* show online payment mode loading */
	
		}, {
			key: 'onlinePaymentLoading',
			value: function onlinePaymentLoading() {
				if (this.state.paymentStatus === "ONLINE") {
	
					return _react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'img' },
							_react2.default.createElement('img', { src: this.state.paymentLoading, alt: '' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'cont' },
							_react2.default.createElement(
								'p',
								{ className: 'date' },
								currentDate,
								'   ',
								_react2.default.createElement(
									'span',
									{ className: 'time' },
									currentTime
								)
							),
							_react2.default.createElement(
								'p',
								null,
								'Waiting for your online payment to be processed.'
							)
						)
					);
				}
			}
			/**/
	
		}, {
			key: 'enableCOD',
			value: function enableCOD() {
				//alert(parseFloat(this.state.cartDetails.cart_grand_total));
				var calc_grand_total = this.getApplyRewardsPaymentTotal(parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount));
	
				if (parseInt(this.state.settings.client_cod_enable) === 1 && parseFloat(calc_grand_total) > 0 && parseInt(this.state.settings.client_payment_availability_enable) === 0 || parseInt(this.state.settings.client_cod_enable) === 1 && parseFloat(calc_grand_total) > 0 && parseInt(this.state.settings.client_payment_availability_enable) === 1 && parseInt(this.state.settings.client_cod_availability) === 1) {
					return _react2.default.createElement(
						'label',
						null,
						' ',
						_react2.default.createElement('input', { type: 'radio', name: 'payment', id: 'cash', defaultChecked: true, value: 'CASH', onClick: this.showCheckoutBtn.bind(this, 'CASH') }),
						_react2.default.createElement('span', { className: 'circle' }),
						_react2.default.createElement('span', { className: 'check' }),
						APPID == "B637EE61-A5A9-4303-ACF7-4A3C055DC845" ? _react2.default.createElement('img', { src: '/img/honolulu_cash_pay.png', className: 'img-responsive img-width-120', alt: 'cash-on-delivery' }) : _react2.default.createElement('img', { src: '/img/cash-on-delivery.png', className: 'img-responsive img-width-120', alt: 'cash-on-delivery' })
					);
				}
			}
	
			/* enable stripe */
	
		}, {
			key: 'enableStripe',
			value: function enableStripe() {
				var stripeSts = parseInt(this.state.settings.client_stripe_enable);
				var codSts = parseInt(this.state.settings.client_cod_enable);
				var calc_grand_total = this.getApplyRewardsPaymentTotal(parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount));
	
				var retSts = codSts === 0 || parseInt(this.state.settings.client_cod_availability) === 0 ? true : false;
				if (stripeSts === 1 && parseFloat(calc_grand_total) > 0 && parseInt(this.state.settings.client_payment_availability_enable) === 0 || stripeSts === 1 && parseFloat(calc_grand_total) > 0 && parseInt(this.state.settings.client_payment_availability_enable) === 1 && parseInt(this.state.settings.client_stripe_availability) === 1) {
					return _react2.default.createElement(
						'label',
						null,
						_react2.default.createElement('input', { type: 'radio', name: 'payment', id: 'stripe', defaultChecked: retSts, value: 'STRIPE', onClick: this.showCheckoutBtn.bind(this, 'STRIPE') }),
						_react2.default.createElement('span', { className: 'circle' }),
						_react2.default.createElement('span', { className: 'check' }),
						_react2.default.createElement('img', { src: '/img/cards/visa-logo.png', className: 'img-responsive img-width-120', alt: 'visa-card' })
					);
				}
			}
		}, {
			key: 'enablePaypal',
			value: function enablePaypal() {
				var paypalSts = parseInt(this.state.settings.client_paypal_enable);
				var stripeSts = parseInt(this.state.settings.client_stripe_enable);
				var codSts = parseInt(this.state.settings.client_cod_enable);
				var stripeAvl = parseInt(this.state.settings.client_stripe_availability);
				var codAvl = parseInt(this.state.settings.client_cod_availability);
				var calc_grand_total = this.getApplyRewardsPaymentTotal(parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount));
				var paySts = (codSts === 0 || codAvl === 0) && (stripeSts === 0 || stripeAvl === 0) ? true : false;
				if (paypalSts === 1 && parseFloat(calc_grand_total) > 0 && parseInt(this.state.settings.client_payment_availability_enable) === 1 && parseInt(this.state.settings.client_paypal_availability) === 1) {
	
					return _react2.default.createElement(
						'label',
						null,
						_react2.default.createElement('input', { type: 'radio', name: 'payment', id: 'paypal', defaultChecked: paySts, value: 'PAYPAL', onClick: this.showCheckoutBtn.bind(this, 'PAYPAL') }),
						_react2.default.createElement('span', { className: 'circle' }),
						_react2.default.createElement('span', { className: 'check' }),
						_react2.default.createElement('img', { src: '/img/paypal-logo.png', className: 'img-responsive img-width-120', alt: 'Paypal' })
					);
				}
			}
		}, {
			key: 'sentnoviteepos',
			value: function sentnoviteepos(orderPrimaryId) {
				var postObject = {
					app_id: APPID,
					order_primary_id: orderPrimaryId,
					customer_id: _reactCookie2.default.load("UserId")
				};
	
				_axios2.default.post(APIURL + "v1/external/push_to_novitee", qs.stringify(postObject)).then(function (res) {
					if (res.data.status === "ok") {}
				});
			}
		}, {
			key: 'enableOffline',
			value: function enableOffline() {
				var paypalSts = parseInt(this.state.settings.client_paypal_enable);
				var omiseSts = parseInt(this.state.settings.omise_stripe_availability);
				var client_offline_enable = parseInt(this.state.settings.client_offline_enable);
				var stripeSts = parseInt(this.state.settings.client_stripe_enable);
				var codSts = parseInt(this.state.settings.client_cod_enable);
				var stripeAvl = parseInt(this.state.settings.client_stripe_availability);
				var codAvl = parseInt(this.state.settings.client_cod_availability);
				var calc_grand_total = this.getApplyRewardsPaymentTotal(parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount));
				if (isNaN(omiseSts)) {
					omiseSts = 0;
				}
				var offlineStatus = client_offline_enable == 1 && codAvl === 0 && omiseSts === 0 && paypalSts === 0 && stripeSts === 0 && stripeAvl === 0 ? true : false;
	
				offlineStatus = APPID === "C655A75D-2E68-4E31-BCE1-58F533E0D1A7" ? false : offlineStatus;
				if (client_offline_enable === 1 && parseFloat(calc_grand_total) > 0 && parseInt(this.state.settings.client_payment_availability_enable) === 1) {
	
					return _react2.default.createElement(
						'label',
						null,
						_react2.default.createElement('input', { type: 'radio', name: 'payment', id: 'offline', defaultChecked: offlineStatus, value: 'OFFLINE', onClick: this.showCheckoutBtn.bind(this, 'OFFLINE') }),
						_react2.default.createElement('span', { className: 'circle' }),
						_react2.default.createElement('span', { className: 'check' }),
						_react2.default.createElement('img', { src: '/img/offline-delivery.png', className: 'img-responsive img-width-120', alt: 'Offline Payment' })
					);
				}
			}
	
			/* check stripe status */
	
		}, {
			key: 'cashSts',
			value: function cashSts() {
				var codSts = parseInt(this.state.settings.client_cod_enable);
				var stripeSts = parseInt(this.state.settings.client_stripe_enable);
				var calc_grand_total = this.getApplyRewardsPaymentTotal(parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount));
	
				var codAvl = parseInt(this.state.settings.client_cod_availability);
				if ((codSts === 1 && stripeSts === 1 || codSts === 1 && stripeSts === 0) && parseFloat(calc_grand_total) > 0) {
					return codSts === 1 && codAvl === 1 ? "block" : "none";
				} else {
					return "none";
				}
			}
			//offlineSts
	
		}, {
			key: 'offlineSts',
			value: function offlineSts() {
				var codSts = parseInt(this.state.settings.client_cod_enable);
				var codAvl = parseInt(this.state.settings.client_cod_availability);
	
				var stripeSts = parseInt(this.state.settings.client_stripe_enable);
				var stripeAvl = parseInt(this.state.settings.client_stripe_availability);
	
				var isOffline = parseInt(this.state.settings.client_offline_enable);
				var calc_grand_total = this.getApplyRewardsPaymentTotal(parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount));
				if ((codSts === 1 && codAvl === 1 || stripeSts === 1 && stripeAvl === 1) && parseFloat(calc_grand_total) > 0) {
					return "none";
				} else {
					return isOffline === 1 ? "block" : "none";
				}
			}
	
			/* show cash status stripeSts */
	
		}, {
			key: 'stripeSts',
			value: function stripeSts() {
				var codSts = parseInt(this.state.settings.client_cod_enable);
				var stripeSts = parseInt(this.state.settings.client_stripe_enable);
				var stripeAvl = parseInt(this.state.settings.client_stripe_availability);
				var calc_grand_total = this.getApplyRewardsPaymentTotal(parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount));
				if ((codSts === 1 && stripeSts === 1 || codSts === 1 && stripeSts === 0) && parseFloat(calc_grand_total) <= 0) {
					return "none";
				} else {
					return stripeSts == 1 && stripeAvl === 1 ? "block" : "none";
				}
			}
		}, {
			key: 'paypalSts',
			value: function paypalSts() {
	
				var codSts = parseInt(this.state.settings.client_cod_enable);
				var codAvl = parseInt(this.state.settings.client_cod_availability);
	
				var stripeSts = parseInt(this.state.settings.client_stripe_enable);
				var stripeAvl = parseInt(this.state.settings.client_stripe_availability);
	
				var paypalSts = parseInt(this.state.settings.client_paypal_enable);
				var calc_grand_total = this.getApplyRewardsPaymentTotal(parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount));
				if ((codSts === 1 && codAvl === 1 || stripeSts === 1 && stripeAvl === 1) && parseFloat(calc_grand_total) > 0) {
					return "none";
				} else {
					return paypalSts === 1 ? "block" : "none";
				}
			}
	
			/* enable promo buttoon */
	
		}, {
			key: 'promoSts',
			value: function promoSts() {
				var calc_grand_total = this.getApplyRewardsPaymentTotal(parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount));
				if (parseFloat(calc_grand_total) <= 0) {
					return "block";
				} else {
					return "none";
				}
			}
		}, {
			key: 'promoButton',
			value: function promoButton() {
	
				if (this.state.promoApplied === "Yes" && this.state.promoType === "PROMO") {
	
					return _react2.default.createElement(
						'button',
						{ className: 'btn bg-black btn-apply', onClick: this.resetPromoState.bind(this, this.state.cartDetails.cart_sub_total) },
						'Remove'
					);
				} else {
					if (this.state.promoType !== "POINTS") {
						return _react2.default.createElement(
							'button',
							{ className: 'btn bg-black btn-apply applyPromo', onClick: this.applyCoupon.bind(this, this.state.cartDetails.cart_sub_total, '') },
							'Apply'
						);
					}
				}
			}
	
			/* Show  reward button */
	
		}, {
			key: 'pointsButton',
			value: function pointsButton() {
				if (this.state.promoApplied === "Yes" && this.state.promoType === "POINTS") {
	
					return _react2.default.createElement(
						'button',
						{ className: 'btn bg-black  btn-apply', onClick: this.resetPromoState.bind(this, this.state.cartDetails.cart_sub_total) },
						'Remove'
					);
				} else {
					if (this.state.promoType !== "PROMO") {
						return _react2.default.createElement(
							'button',
							{ className: 'btn bg-black btn-apply', onClick: this.applyRewards.bind(this) },
							'Apply'
						);
					}
				}
			}
		}, {
			key: 'advocadopopupreg',
			value: function advocadopopupreg() {
	
				$("#advocadopopup").modal("toggle");
			}
	
			/* select payment text */
	
		}, {
			key: 'selectPaymentText',
			value: function selectPaymentText() {
				if (parseFloat(this.state.cartDetails.cart_grand_total) > 0) {
					return _react2.default.createElement(
						'p',
						{ className: 'text-center' },
						'Please select your payment method'
					);
				}
			}
	
			/* enable promotion payment */
	
		}, {
			key: 'enablePromotion',
			value: function enablePromotion() {
				var calc_grand_total = parseFloat(this.getApplyRewardsPaymentTotal(parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount)));
				if (parseFloat(calc_grand_total) <= 0) {
					return _react2.default.createElement(
						'p',
						null,
						alertMsg.promoPaymentText
					);
				}
			}
	
			/* Hide  drop down work space site */
	
		}, {
			key: 'hidedropDown',
			value: function hidedropDown(type) {
				if (type === 'sub' && APPID === apps.zazzpizza) {
					return "none";
				} else {
					return APPID === apps.workspace ? "none" : "block";
				}
			}
	
			/* add class "col-sm-6 padd1 "*/
	
		}, {
			key: 'addClass',
			value: function addClass(type, rewardMenustatus) {
				if (APPID === "8F8FE4E6-88C9-4071-9215-312E0F50016A") {
	
					return APPID == apps.workspace || APPID === apps.zazzpizza ? "  padd1" : "col-sm-6 col-md-offset-3 padd1";
				} else {
					return APPID == apps.workspace || APPID === apps.zazzpizza || rewardMenustatus === false ? "  padd1" : "col-sm-6 padd1";
				}
			}
		}, {
			key: 'changePromoVal',
			value: function changePromoVal(e) {
				this.setState({ appliedPromocode: e.target.value });
			}
		}, {
			key: 'changeRewardVal',
			value: function changeRewardVal(e) {
				this.setState({ promoPoints: e.target.value });
			}
		}, {
			key: 'advocadopin',
			value: function advocadopin(e) {
				this.setState({ advocadopin: e.target.value });
			}
		}, {
			key: 'showPromoPart',
			value: function showPromoPart() {
				var usertype = typeof _reactCookie2.default.load('userAccountType') !== "undefined" ? _reactCookie2.default.load('userAccountType') : 0;
				var rewardMenustatus = helper.disableMenu(this.state.settings, 'checkout_rewards');
				var promoMenustatus = helper.disableMenu(this.state.settings, 'checkout_promos');
	
				if (!rewardMenustatus && !promoMenustatus) {
					return false;
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'col-sm-12 no-padding main-outer' },
					_react2.default.createElement(
						'div',
						{ className: 'reward_row clearfix', style: { display: this.hidedropDown('main') } },
						_react2.default.createElement(
							'h3',
							{ style: { display: this.hidedropDown('main') }, className: 'inner-title-1' },
							'CHECK YOUR REWARDS & PROMOTIONS'
						),
						APPID !== "8F8FE4E6-88C9-4071-9215-312E0F50016A" && rewardMenustatus && this.state.enable_advocado !== 'Yes' && _react2.default.createElement(
							'div',
							{ style: { display: this.hidedropDown('sub') }, className: !promoMenustatus ? " col-sm-12 padd1 " : " col-sm-6 padd1 " },
							_react2.default.createElement(
								'div',
								{ className: 'redeem_points_option', id: 'redeem_points_option' },
								_react2.default.createElement(
									'h4',
									{ className: 'text-center reward_smtt' },
									'Redeem Rewards Points'
								),
								_react2.default.createElement(
									'div',
									{ className: 'promotion_formgroup' },
									_react2.default.createElement('input', { type: 'text', className: 'txt-field', id: 'points', placeholder: "Redeem " + parseFloat(this.state.customerPoints) + " Points", value: this.state.promoPoints > 0 ? this.state.promoPoints : '', onChange: this.changeRewardVal.bind(this) })
								),
								_react2.default.createElement(
									'p',
									{ className: 'text-center' },
									this.pointsButton()
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'redeem_point_otp', id: 'redeem_point_otp_div', style: { display: 'none' } },
								_react2.default.createElement(
									'h4',
									{ className: 'text-center reward_smtt' },
									'Enter your OTP'
								),
								_react2.default.createElement(
									'div',
									{ className: 'promotion_formgroup' },
									_react2.default.createElement('input', { type: 'text', className: 'txt-field', id: 'redeem_points_otp', placeholder: 'Enter valid OTP' })
								),
								_react2.default.createElement(
									'a',
									{ className: 'resent_redeem_otp', id: 'resend_otp_button', onClick: this.handleResendotp.bind(this) },
									_react2.default.createElement(
										'b',
										null,
										'Resent OTP'
									)
								),
								_react2.default.createElement(
									'p',
									{ className: 'text-center' },
									_react2.default.createElement(
										'button',
										{ className: 'btn bg-black btn-apply', onClick: this.otp_verification.bind(this) },
										'Submit'
									),
									_react2.default.createElement(
										'button',
										{ className: 'btn bg-black btn-apply cancel_otp_val', onClick: this.otp_cancel_option.bind(this) },
										'Cancel'
									)
								)
							)
						),
						this.state.enable_advocado === 'Yes' && (this.state.advocado_id === undefined || this.state.advocado_id === null) && _react2.default.createElement(
							'div',
							{ style: { display: this.hidedropDown('sub') }, className: 'col-sm-6 padd1 ' },
							_react2.default.createElement(
								'h4',
								{ className: 'text-center' },
								'\xA0'
							),
							_react2.default.createElement(
								'div',
								{ className: 'row redeem_advocado_formgroup' },
								_react2.default.createElement(
									'div',
									{ className: 'redeem_signup_info text-center' },
									_react2.default.createElement(
										'h4',
										null,
										'DON\'T HAVE A ',
										_react2.default.createElement(
											'b',
											null,
											'REWARDS'
										),
										' ACCOUNT?'
									),
									_react2.default.createElement(
										'p',
										null,
										_react2.default.createElement(
											_reactRouter.Link,
											{ style: { 'cursor': 'pointer', 'textDecoration': 'none', 'font-size': '18px' }, onClick: this.advocadopopupreg.bind(this) },
											_react2.default.createElement(
												'b',
												null,
												'Sign up'
											)
										),
										' here for rewards.'
									)
								)
							)
						),
						this.state.enable_advocado === 'Yes' && this.state.advocado_id !== 'undefined' && this.state.advocado_id !== null && _react2.default.createElement(
							'div',
							{ style: { display: this.hidedropDown('sub') }, className: 'col-sm-6 padd1 ' },
							_react2.default.createElement(
								'h4',
								{ className: 'text-center reward_smtt' },
								'Redeem Cashback'
							),
							_react2.default.createElement(
								'div',
								{ className: 'row redeem_advocado_formgroup' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-8 advocado-redeem-sec' },
									_react2.default.createElement('input', { type: 'text', className: 'txt-field', id: 'points', placeholder: parseFloat(this.state.customerAdvocadoPoints) > 0 ? "Redeem $" + parseFloat(this.state.customerAdvocadoPoints) + " cashback" : 'You have no cashback' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-4' },
									_react2.default.createElement('input', { type: 'text', className: 'txt-field', id: 'points', placeholder: "Enter Pin", onChange: this.advocadopin.bind(this) }),
									_react2.default.createElement(
										'div',
										{ className: 'forgot_redeempin text-center' },
										_react2.default.createElement(
											_reactRouter.Link,
											{ onClick: this.advocadoforgot.bind(this), title: 'Forgot Pin' },
											'Forgot Pin'
										)
									)
								)
							),
							_react2.default.createElement(
								'p',
								{ className: 'text-center' },
								this.pointsButton()
							)
						),
						promoMenustatus && _react2.default.createElement(
							'div',
							{ className: this.addClass(usertype, rewardMenustatus) },
							_react2.default.createElement(
								'h4',
								{ className: 'text-center reward_smtt' },
								'Promotion'
							),
							_react2.default.createElement(
								'div',
								{ className: 'promotion_formgroup' },
								_react2.default.createElement('input', { type: 'text', value: this.state.appliedPromocode, onChange: this.changePromoVal.bind(this), className: 'txt-field', id: 'promocode', placeholder: 'Add Your Promo Code Here' })
							),
							_react2.default.createElement(
								'p',
								{ className: 'text-center' },
								this.promoButton()
							)
						)
					)
				);
			}
		}, {
			key: 'showGiftOption',
			value: function showGiftOption() {
				if (this.state.settings.enable_recipient !== "" && _typeof(this.state.settings.enable_recipient) !== undefined && typeof this.state.settings.enable_recipient !== "undefined") {
					if (this.state.settings.enable_recipient === "1") {
						return _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'div',
								{ className: 'gift-option' },
								_react2.default.createElement(
									'div',
									{ className: 'pull-left' },
									_react2.default.createElement('input', { type: 'checkbox', id: 'gift_option', onChange: this.selectGift.bind(this), checked: this.state.gift_option, style: { marginRight: "10px" } }),
									_react2.default.createElement(
										'label',
										{ htmlFor: 'gift_option', className: 'css-label-chkbox' },
										' I would like to send this order as a gift'
									)
								)
							),
							this.state.gift_option === true && _react2.default.createElement(
								'div',
								{ className: 'col-sm-12 no-padding main-outer' },
								_react2.default.createElement(
									'div',
									{ className: 'gift_row clearfix' },
									_react2.default.createElement(
										'h3',
										{ className: 'inner-title-1' },
										'Gift'
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-sm-6 padd1' },
										_react2.default.createElement(
											'h4',
											{ className: 'text-center reward_smtt' },
											'Recipient Name'
										),
										_react2.default.createElement(
											'div',
											{ className: 'promotion_formgroup' },
											_react2.default.createElement('input', { type: 'text', className: 'txt-field', id: 'recipient_name', placeholder: 'Recipient Name', onChange: this.handleChangeTxt.bind(this, 'recipient_name') })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-sm-6 padd1' },
										_react2.default.createElement(
											'h4',
											{ className: 'text-center reward_smtt' },
											'Recipient Contact Number'
										),
										_react2.default.createElement(
											'div',
											{ className: 'promotion_formgroup' },
											_react2.default.createElement('input', { type: 'text', className: 'txt-field', id: 'recipient_contact_no', placeholder: 'Recipient Contact Number', onChange: this.handleChangeTxt.bind(this, 'recipient_contact_no') })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-sm-12 padd1' },
										_react2.default.createElement(
											'h4',
											{ className: 'text-center reward_smtt' },
											'Message'
										),
										_react2.default.createElement(
											'div',
											{ className: 'promotion_formgroup' },
											_react2.default.createElement('textarea', { type: 'text', id: 'gift_message', placeholder: 'Please enter your gift message here...', className: 'txt-field', cols: '5', style: { textAlign: 'left' }, onChange: this.handleChangeTxt.bind(this, 'gift_message') })
										)
									)
								)
							)
						);
					}
				}
			}
		}, {
			key: 'selectGift',
			value: function selectGift(e) {
				this.setState({ gift_option: e.target.checked });
			}
	
			/*
	  paypalLogMonitoring(status, response)
	  {
	  	postObject = {
	  'app_id' : APPID,
	  'token' : token.id,
	  }
	    axios.post(APIURL+"Paypallogmonitoring/add_log", qs.stringify(postObject)).then(res => {
	  			//this.setState({status:""});
	  		   if(res.data.status === "ok"){
	  			      /* Reset poup message -  start
	  			 // console.log('paysuccess');
	  			  this.setState({'paymentLoading':'/img/tick.png'});
	  			     /* Reset poup message -  end
	  				 this.postOrder(2);
	  			 }
	  		  else if(res.data.status === "error") {
	  		   /* Reset poup message -  start
	  		    $("#SwitchingError").modal("toggle");
	                 this.setState({'defaultClass':''});
	  		     /* Reset poup message -  end
	  			helper.showInfo(res.data.message);
	  		 }
	    });
	  } */
	
		}, {
			key: 'showPDPA',
			value: function showPDPA() {
	
				$(".pdpa").toggleClass("active");
			}
		}, {
			key: 'paymentHide',
			value: function paymentHide() {
				if (APPID === 'CD8D5FE3-0586-44DD-9360-EE9DEF351223') {
					var hidePaymentMode = 'none';
					if (parseInt(this.state.settings.client_cod_enable) === 1 && parseFloat(this.state.cartDetails.cart_grand_total) > 0 && parseInt(this.state.settings.client_payment_availability_enable) === 0 || parseInt(this.state.settings.client_cod_enable) === 1 && parseFloat(this.state.cartDetails.cart_grand_total) > 0 && parseInt(this.state.settings.client_payment_availability_enable) === 1 && parseInt(this.state.settings.client_cod_availability) === 1) {
						hidePaymentMode = '';
					}
	
					var stripeSts = parseInt(this.state.settings.client_stripe_enable);
					var codSts = parseInt(this.state.settings.client_cod_enable);
	
					var retSts = codSts === 0 || parseInt(this.state.settings.client_cod_availability) === 0 ? true : false;
					if (stripeSts === 1 && parseFloat(this.state.cartDetails.cart_grand_total) > 0 && parseInt(this.state.settings.client_payment_availability_enable) === 0 || stripeSts === 1 && parseFloat(this.state.cartDetails.cart_grand_total) > 0 && parseInt(this.state.settings.client_payment_availability_enable) === 1 && parseInt(this.state.settings.client_stripe_availability) === 1) {
						//var hidePaymentMode = parseInt(this.state.hidePaymentMode)+1;
						//this.setState({hidePaymentMode:hidePaymentMode});
						hidePaymentMode = '';
					}
	
					var paypalSts = parseInt(this.state.settings.client_paypal_enable);
					var stripeSts = parseInt(this.state.settings.client_stripe_enable);
					var codSts = parseInt(this.state.settings.client_cod_enable);
					var stripeAvl = parseInt(this.state.settings.client_stripe_availability);
					var codAvl = parseInt(this.state.settings.client_cod_availability);
					var paySts = (codSts === 0 || codAvl === 0) && (stripeSts === 0 || stripeAvl === 0) ? true : false;
					if (paypalSts === 1 && parseFloat(this.state.cartDetails.cart_grand_total) > 0 && parseInt(this.state.settings.client_payment_availability_enable) === 1 && parseInt(this.state.settings.client_paypal_availability) === 1) {
						hidePaymentMode = '';
					}
					var omiseSts = parseInt(this.state.settings.client_omise_enable);
					var stripeSts = parseInt(this.state.settings.client_stripe_enable);
					var codSts = parseInt(this.state.settings.client_cod_enable);
					var stripeAvl = parseInt(this.state.settings.client_stripe_availability);
					var codAvl = parseInt(this.state.settings.client_cod_availability);
					var omiseChecked = (codSts === 0 || codAvl === 0) && (stripeSts === 0 || stripeAvl === 0) ? true : false;
					if (omiseSts === 1 && parseFloat(this.state.cartDetails.cart_grand_total) > 0 && parseInt(this.state.settings.client_payment_availability_enable) === 0 || omiseSts === 1 && parseFloat(this.state.cartDetails.cart_grand_total) > 0 && parseInt(this.state.settings.client_payment_availability_enable) === 1) {
						hidePaymentMode = '';
					}
	
					return hidePaymentMode;
				}
			}
		}, {
			key: 'getApplyRewardsPaymentTotal',
			value: function getApplyRewardsPaymentTotal(payAbleAmount) {
	
				var returnAmount = payAbleAmount;
				if (this.isApplyRewardOnGrandTotal()) {
					returnAmount = parseFloat(this.state.finalApplyRewardsOriginalGrandTotal).toFixed(2);
				}
	
				return returnAmount;
			}
		}, {
			key: 'render',
			value: function render() {
	
				/* Render */
	
				var envSts = parseInt(this.state.settings.client_paypal_mode) === 0 ? "sandbox" : "production";
				var totalAmount = this.state.newVoucher != "1" ? (parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount)).toFixed(2) : parseFloat(this.state.cartDetails.cart_sub_total).toFixed(2);
				var client = {
					sandbox: this.state.settings.paypal_client_id,
					production: this.state.settings.paypal_client_id
				};
	
				if (this.state.status === "Loading") {
					return _react2.default.createElement(
						'div',
						{ className: 'container-fluid desktop-container position-rel', style: { minHeight: this.state.windowHeightNormal } },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(Loading, null)
						)
					);
				} else {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ id: 'loadIcon', style: { display: 'none', bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto', zIndex: 9999, background: 'rgba(255, 255, 255, 0.8)' } },
							' ',
							_react2.default.createElement('img', { style: { bottom: 0, left: 0, position: 'absolute', right: 0, top: 0, margin: 'auto' }, src: '/img/loader.gif', alt: 'Loading' }),
							' ',
							_react2.default.createElement(
								'p',
								{ className: 'validateOrder' },
								' We are validating your order details. Please Wait.'
							),
							' '
						),
						_react2.default.createElement(
							'div',
							{ id: 'PromoLoading', style: { display: 'none', bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto', zIndex: 9999, background: 'rgba(255, 255, 255, 0.8)' } },
							' ',
							_react2.default.createElement('img', { style: { bottom: 0, left: 0, position: 'absolute', right: 0, top: 0, margin: 'auto' }, src: '/img/loader.gif', alt: 'Loading' }),
							'    '
						),
						_react2.default.createElement(_reactDocumentMeta2.default, meta),
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid desktop-container', style: { minHeight: this.state.windowHeight } },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 top-nav inner-top-nav' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-3 nav-head pd-l-20' },
										' ',
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: this.backLink(this) },
											_react2.default.createElement('img', { src: '/img/icons/arrow-right.png', className: 'icon-img-small-3', alt: 'left-arrow' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-6 nav-head ' },
										_react2.default.createElement(
											'h1',
											{ className: 'main-title' },
											'CHECKOUT'
										)
									),
									_react2.default.createElement('div', { className: 'col-xs-3 nopadding' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row bg-white' },
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-12 ' },
									_react2.default.createElement(
										'div',
										{ className: 'col-sm-12  main-outer margin-top-40 rewardbx_up' },
										_react2.default.createElement(
											'h3',
											{ className: 'inner-title-1' },
											'your order details'
										),
										APPID !== 'B401FC82-8E39-4076-838A-55192F765004' && APPID !== "6C0280A0-B655-4E0F-A43F-041C189683BA" && APPID !== "B93EC9A9-1A67-4EBA-ADB7-BC7C14FA88A4" && APPID !== "B637EE61-A5A9-4303-ACF7-4A3C055DC845" && _react2.default.createElement(
											'h4',
											{ className: 'text-center reward_smtt' },
											'Please Select Mode of Payment for Order Submission'
										),
										APPID === "B637EE61-A5A9-4303-ACF7-4A3C055DC845" && _react2.default.createElement(
											'h4',
											{ style: { fontWeight: "bold" }, className: 'text-center reward_smtt' },
											'PLEASE MAKE PAYMENT AT COUNTER'
										),
										_react2.default.createElement('h4', { className: 'text-center reward_smtt' }),
										this.showOrderDetails(),
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-12 padd1 price-list' },
											this.loadProductsDetails()
										),
										this.state.enable_advocado === 'Yes' && this.state.advocado_id !== 'undefined' && this.state.advocado_id !== null && parseFloat(this.state.advocado_cashbackPercent) > 0 && _react2.default.createElement(
											'div',
											{ className: 'reward_offerlabel' },
											_react2.default.createElement('img', { src: 'images/reward_offer.png', alt: '' }),
											' ',
											_react2.default.createElement(
												'span',
												null,
												'You will Get  $',
												((parseFloat(this.state.originalSubTotal) - parseFloat(this.state.promoAmount)) * this.state.advocado_cashbackPercent / 100).toFixed(2),
												' Cashback with this order'
											)
										)
									),
									_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && this.showGiftOption(),
									APPID !== 'B401FC82-8E39-4076-838A-55192F765004' && APPID !== "6C0280A0-B655-4E0F-A43F-041C189683BA" && APPID !== "B93EC9A9-1A67-4EBA-ADB7-BC7C14FA88A4" && APPID !== "33843AC9-EB47-42EE-8AAA-14CEA187D85A" && APPID !== "4EDE9A25-89AA-4200-848D-AC4A5A54B7BC" && this.state.customers_is_anonymous === 0 && this.showPromoPart(),
									_react2.default.createElement(
										'div',
										{ style: { display: APPID === "B401FC82-8E39-4076-838A-55192F765004" || APPID === "6C0280A0-B655-4E0F-A43F-041C189683BA" || APPID === "B93EC9A9-1A67-4EBA-ADB7-BC7C14FA88A4" ? 'none' : '' } },
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-12 no-padding main-outer', style: { display: this.paymentHide() } },
											htmlToReactParserTo.parse(this.state.masterCardLogo),
											_react2.default.createElement(
												'h3',
												{ className: 'inner-title-2' },
												'PAYMENT'
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-12 padd1 ' },
												this.selectPaymentText(),
												_react2.default.createElement('div', { className: 'space-10' }),
												_react2.default.createElement(
													'div',
													{ className: 'cards center-block payment_gatesec', style: { width: "100%" } },
													_react2.default.createElement(
														'div',
														{ className: 'radio radio-primary' },
														this.enableCOD()
													),
													_react2.default.createElement(
														'div',
														{ className: 'radio radio-primary' },
														this.enableOffline()
													),
													_react2.default.createElement(
														'div',
														{ className: 'radio radio-primary' },
														this.enableStripe()
													),
													_react2.default.createElement(
														'div',
														{ className: 'radio radio-primary' },
														this.enablePaypal()
													),
													_react2.default.createElement(
														'div',
														{ className: 'radio radio-primary' },
														this.enableOmise()
													),
													_react2.default.createElement(
														'div',
														{ className: 'radio radio-primary' },
														this.enableOmisePayNow()
													),
													_react2.default.createElement(
														'div',
														{ className: 'radio radio-primary' },
														this.enableRazerpay()
													),
													_react2.default.createElement(
														'div',
														{ className: 'radio radio-primary' },
														this.enablePromotion()
													)
												),
												_react2.default.createElement('div', { className: 'space-10' })
											)
										)
									)
								)
							),
							_react2.default.createElement('div', { className: 'space-50', style: { padding: "22px" } }),
							_react2.default.createElement(
								'div',
								{ className: 'row', style: { display: this.checkOutFlag() } },
								_react2.default.createElement(
									'div',
									{ style: { display: this.stripeSts() }, id: 'stripe_btn' },
									' ',
									parseInt(this.state.settings.client_stripe_enable) === 1 && parseInt(this.state.settings.client_stripe_availability) === 1 && _react2.default.createElement(
										'button',
										{ className: 'col-lg-12 continue-but desktop-container container-fluid', onClick: this.payNow.bind(this, 'STRIPE') },
										' CHECKOUT  '
									)
								),
								_react2.default.createElement(
									'div',
									{ id: 'omise_btn', style: { display: this.omiseSts() } },
									_react2.default.createElement(
										'button',
										{ className: 'col-lg-12 continue-but desktop-container container-fluid', onClick: this.payNow.bind(this, 'OMISE') },
										'CHECKOUT'
									)
								),
								_react2.default.createElement(
									'div',
									{ id: 'omise_btn_paynow', style: { display: this.omiseSts() } },
									_react2.default.createElement(
										'button',
										{ className: 'col-lg-12 continue-but desktop-container container-fluid', onClick: this.payNow.bind(this, 'OMISE-PAYNOW') },
										'CHECKOUT'
									)
								),
								_react2.default.createElement(
									'div',
									{ style: { display: this.razerpaySts() }, id: 'razerpay_btn' },
									_react2.default.createElement(
										'button',
										{ className: 'col-lg-12 continue-but desktop-container container-fluid', onClick: this.payNow.bind(this) },
										'CHECKOUT'
									),
									'    '
								),
								_react2.default.createElement(
									'div',
									{ style: { display: this.cashSts() }, id: 'cash_btn' },
									_react2.default.createElement(
										'button',
										{ className: 'col-lg-12 continue-but desktop-container container-fluid', onClick: this.payNow.bind(this) },
										'CHECKOUT'
									),
									'    '
								),
								_react2.default.createElement(
									'div',
									{ style: { display: this.offlineSts() }, id: 'offline_btn' },
									_react2.default.createElement(
										'button',
										{ className: 'col-lg-12 continue-but desktop-container container-fluid', onClick: this.payNow.bind(this, "OFFLINE") },
										'CHECKOUT'
									),
									'    '
								),
								_react2.default.createElement(
									'div',
									{ id: 'paypal_btn', className: 'col-lg-12 continue-but desktop-container container-fluid', style: { textAlign: "center", display: this.paypalSts() } },
									_react2.default.createElement(_reactPaypalExpressCheckout2.default, { style: { tagline: false, color: "white" }, env: envSts, client: client, currency: 'SGD', total: totalAmount, onError: this.onError, onSuccess: this.onSuccess, onCancel: this.onCancel })
								),
								_react2.default.createElement(
									'div',
									{ style: { display: this.promoSts() }, id: 'promo_btn' },
									_react2.default.createElement(
										'button',
										{ className: 'col-lg-12 continue-but desktop-container container-fluid', onClick: this.payNow.bind(this, 'PROMOTION') },
										'CHECKOUT'
									),
									'    '
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'modal', id: 'SwitchingError' },
								_react2.default.createElement('div', { className: this.state.defaultClass }),
								_react2.default.createElement(
									'div',
									{ className: 'chk_popup', id: 'PayProcess' },
									_react2.default.createElement(
										'div',
										{ className: 'white-outer center-block process_order' },
										_react2.default.createElement(
											'div',
											{ className: 'row ' },
											_react2.default.createElement(
												'div',
												{ className: 'col-xs-12 padd2' },
												_react2.default.createElement(
													'h4',
													null,
													'We are processing your order'
												),
												_react2.default.createElement(
													'div',
													{ className: 'clock_part' },
													_react2.default.createElement('img', { src: '/img/spinner.gif', alt: '' })
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'white-outer center-block pay_process' },
										_react2.default.createElement(
											'div',
											{ className: 'row ' },
											_react2.default.createElement(
												'div',
												{ className: 'col-xs-12' },
												_react2.default.createElement(
													'ul',
													null,
													this.onlinePaymentLoading(),
													_react2.default.createElement(
														'li',
														null,
														_react2.default.createElement(
															'div',
															{ className: 'img' },
															_react2.default.createElement('img', { src: this.state.orderLoading, alt: '' })
														),
														_react2.default.createElement(
															'div',
															{ className: 'cont' },
															_react2.default.createElement(
																'p',
																{ className: 'date' },
																currentDate,
																'   ',
																_react2.default.createElement(
																	'span',
																	{ className: 'time' },
																	currentTime
																)
															),
															_react2.default.createElement(
																'p',
																null,
																'We are placing your order details.'
															)
														)
													)
												)
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'modal', id: 'advocadopopup' },
								_react2.default.createElement(
									'div',
									{ className: 'signup_popup' },
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-label': 'Close' },
										_react2.default.createElement(
											'span',
											{ 'aria-hidden': 'true' },
											'\xD7'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'white-outer' },
										_react2.default.createElement(
											'div',
											{ className: ' signup_poptt' },
											_react2.default.createElement(
												'h3',
												null,
												'Sign up For Rewards'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'signup_popform' },
											_react2.default.createElement(
												'div',
												{ className: 'form-group' },
												_react2.default.createElement('input', { type: 'text', readOnly: true, value: _reactCookie2.default.load("UserMobile"), placeholder: "test", className: 'form-control' })
											),
											_react2.default.createElement(
												'div',
												{ className: 'form-group' },
												_react2.default.createElement('input', { type: 'text', value: this.state.advocadopin, onChange: this.advocadopin.bind(this), placeholder: "Create Your 4 Digit Pin", className: 'form-control' }),
												_react2.default.createElement(
													'p',
													null,
													'Pin required to redeem points in outlets & online orders'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'form-group' },
												_react2.default.createElement(
													'span',
													null,
													' ',
													_react2.default.createElement('input', { type: 'checkbox', value: 'Yes', checked: 'checked' }),
													' I Agree to the ',
													_react2.default.createElement(
														'a',
														{ onClick: this.showPDPA.bind(this), className: 'pdpaopen' },
														'PDPA'
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'signuppop_btnsec' },
												_react2.default.createElement(
													'button',
													{ onClick: this.advocadoregister.bind(this), className: 'btn bg-black' },
													'SUBMIT'
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'pdpa' },
										_react2.default.createElement(
											'a',
											{ onClick: this.showPDPA.bind(this), className: 'pdpaopen' },
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'close', 'data-dismiss': 'pdpa', 'aria-label': 'Close' },
												_react2.default.createElement(
													'span',
													{ 'aria-hidden': 'true' },
													'\xD7'
												)
											)
										),
										_react2.default.createElement(
											'h4',
											null,
											this.state.settings.company_name,
											' PDPA'
										),
										htmlToReactParserTo.parse(this.state.pdpacontent)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'modal', id: 'offlinePaymentInfo' },
								_react2.default.createElement(
									'div',
									{ className: 'signup_popup' },
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-label': 'Close' },
										_react2.default.createElement(
											'span',
											{ 'aria-hidden': 'true' },
											'\xD7'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'white-outer' },
										_react2.default.createElement(
											'div',
											{ className: ' signup_poptt' },
											_react2.default.createElement(
												'h3',
												null,
												'Payment Information'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'signup_popform' },
											htmlToReactParserTo.parse(this.state.offlineDesc)
										)
									)
								)
							),
							_react2.default.createElement('div', { className: 'modal loading-popup', id: 'loading-popup' }),
							_react2.default.createElement(
								'div',
								{ className: 'white-outer loading-popup-img' },
								_react2.default.createElement(
									'p',
									null,
									_react2.default.createElement('img', { src: '/img/loader.gif', alt: 'Loading...' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'modal omise_popsec', id: 'omise-paynow-popup' },
								_react2.default.createElement(
									'div',
									{ className: 'white-outer' },
									_react2.default.createElement(
										'div',
										{ className: 'omise_pophead' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-label': 'Close' },
											_react2.default.createElement(
												'span',
												{ 'aria-hidden': 'true' },
												'\xD7'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'omisepop_logo' },
											_react2.default.createElement('img', { src: '/img/omise-icon.png', className: 'img-responsive img-width-120', alt: 'omise' })
										),
										_react2.default.createElement(
											'h3',
											null,
											_react2.default.createElement('img', { src: '/img/PayNow.png', className: 'img-responsive width-150', alt: 'omise' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'omisepop_in' },
										_react2.default.createElement(
											'p',
											{ className: 'omise-pay-now-notes' },
											'Scan the QR code to pay.'
										),
										_react2.default.createElement('img', { src: '', id: 'paynow-qr-image' }),
										_react2.default.createElement(
											'p',
											{ className: 'omise-paynow-amount-to-paid' },
											_react2.default.createElement('span', null)
										),
										_react2.default.createElement(
											'p',
											{ className: 'paynow-seconds' },
											_react2.default.createElement('i', { className: 'fa fa-clock-o', 'aria-hidden': 'true' }),
											_react2.default.createElement('span', null)
										),
										_react2.default.createElement(
											'p',
											{ className: 'alert-payment' },
											'Your payment is being submitted. Please do not close this window or click the Back button on your browser.'
										),
										_react2.default.createElement(
											'div',
											{ className: 'device-notes' },
											_react2.default.createElement(
												'div',
												{ className: 'device-mobile' },
												_react2.default.createElement(
													'h2',
													null,
													'Instructions:'
												),
												_react2.default.createElement(
													'p',
													null,
													'If you are on mobile, save the image above to your photo library or take a screenshot of this page. Then proceed to your mobile banking application\'s Scan & Pay page and upload the image.'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'device-desktop' },
												_react2.default.createElement(
													'h2',
													null,
													'Instructions:'
												),
												_react2.default.createElement(
													'ul',
													null,
													_react2.default.createElement(
														'li',
														null,
														'Take a screenshot of the QR code and pay using your Bank app'
													),
													_react2.default.createElement(
														'li',
														null,
														'You will be paying to Omise Payment SG (Authorised payment processor) for ',
														this.state.settings.company_name,
														'.'
													),
													_react2.default.createElement(
														'li',
														null,
														'Once you make the payment, payment status of the order will reflect as \'paid\', please do not make multiple payments with the same QR Code.'
													),
													_react2.default.createElement(
														'li',
														null,
														'Page will automatically refresh after your successful payment.'
													),
													APPID === "76DABFCC-0A47-40C7-8588-E3C32F87B3C8" && _react2.default.createElement(
														'li',
														null,
														'Please Contact us at 90081545 if you are having trouble with payment.'
													)
												)
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'modal omise_popsec', id: 'omisepopup' },
								_react2.default.createElement(
									'div',
									{ className: 'white-outer' },
									_react2.default.createElement(
										'div',
										{ className: 'omise_pophead' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-label': 'Close' },
											_react2.default.createElement(
												'span',
												{ 'aria-hidden': 'true' },
												'\xD7'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'omisepop_logo' },
											_react2.default.createElement('img', { src: config.stripe.stripeImage, className: 'img-responsive img-width-120', alt: 'omise' })
										),
										_react2.default.createElement(
											'h3',
											null,
											'Payment'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'omisepop_in' },
										_react2.default.createElement(
											'div',
											{ className: 'form_sec' },
											_react2.default.createElement(
												'div',
												{ className: '' },
												_react2.default.createElement(
													'div',
													{ className: 'form-group label-floating is-empty card-no' },
													_react2.default.createElement(
														'div',
														{ className: 'input-group' },
														_react2.default.createElement(
															'label',
															{ className: 'control-label', htmlFor: 'holdername' },
															'Card Holder Name'
														),
														_react2.default.createElement('input', { type: 'text', id: 'holdername', className: 'form-control', value: this.state.holdername, onChange: this.handleChangeTxt.bind(this, 'holdername'), onKeyPress: function onKeyPress(e) {
																return helper.alphabet(e);
															} }),
														this.state.omisenameerror
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'form-group label-floating is-empty card-no' },
													_react2.default.createElement(
														'div',
														{ className: 'input-group' },
														_react2.default.createElement(
															'label',
															{ className: 'control-label', htmlFor: 'omise_card_number' },
															'Card Number'
														),
														_react2.default.createElement('input', { type: 'number', className: 'form-control', value: this.state.cardNumber, id: 'omise_card_number', onChange: this.handleChangeTxt.bind(this, 'cardNumber'), onKeyPress: function onKeyPress(e) {
																return helper.numariconly(e);
															} }),
														this.state.cardImage,
														this.state.omisecardrror
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'form-group form_expire_row' },
													_react2.default.createElement(
														'label',
														{ className: 'black' },
														'Expiration Date'
													),
													_react2.default.createElement(
														'div',
														{ className: 'row' },
														_react2.default.createElement(
															'div',
															{ className: 'col-xs-6' },
															_react2.default.createElement(
																'div',
																{ className: 'form-group label-floating is-empty card-month card-no' },
																_react2.default.createElement(
																	'div',
																	{ className: 'input-group' },
																	_react2.default.createElement(
																		'label',
																		{ className: 'control-label', htmlFor: 'expiration_month' },
																		'MM'
																	),
																	_react2.default.createElement('input', { type: 'number', className: 'form-control', maxLength: '2', id: 'expiration_month', value: this.state.expiration_month, onChange: this.handleChangeTxt.bind(this, 'expiration_month'), onKeyPress: function onKeyPress(e) {
																			return helper.numariconly(e);
																		} }),
																	this.state.omisemontherror
																)
															)
														),
														_react2.default.createElement(
															'div',
															{ className: ' col-xs-6 ' },
															_react2.default.createElement(
																'div',
																{ className: 'form-group label-floating is-empty card-year card-no' },
																_react2.default.createElement(
																	'div',
																	{ className: 'input-group' },
																	_react2.default.createElement(
																		'label',
																		{ className: 'control-label', htmlFor: 'expiration_year' },
																		'YY'
																	),
																	_react2.default.createElement('input', { type: 'number', className: 'form-control', maxLength: '4', id: 'expiration_year', value: this.state.expiration_year, onChange: this.handleChangeTxt.bind(this, 'expiration_year'), onKeyPress: function onKeyPress(e) {
																			return helper.numariconly(e);
																		} }),
																	this.state.omiseyearerror
																)
															)
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'form-group label-floating is-empty card-no' },
												_react2.default.createElement(
													'div',
													{ className: 'input-group' },
													_react2.default.createElement(
														'label',
														{ className: 'control-label', htmlFor: 'security_code' },
														'CVV'
													),
													_react2.default.createElement('input', { type: 'number', maxLength: '4', className: 'form-control', id: 'security_code', value: this.state.security_code, onChange: this.handleChangeTxt.bind(this, 'security_code'), onKeyPress: function onKeyPress(e) {
															return helper.numariconly(e);
														} }),
													this.state.omisecodeerror
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'btn_sec' },
												_react2.default.createElement(
													'button',
													{ onClick: this.getOmiseToken.bind(this), className: 'btn bg-black' },
													'Pay ',
													config.stripe.stripeCurrency,
													' ',
													config.ids.currency,
													' ',
													this.getApplyRewardsPaymentTotal(this.state.newVoucher != "1" ? (parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount)).toFixed(2) : this.state.cartDetails.cart_sub_total)
												)
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'modal omise_popsec', id: 'stripepopup' },
								_react2.default.createElement(
									'div',
									{ className: 'white-outer' },
									_react2.default.createElement(
										'div',
										{ className: 'omise_pophead' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-label': 'Close' },
											_react2.default.createElement(
												'span',
												{ 'aria-hidden': 'true' },
												'\xD7'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'omisepop_logo' },
											_react2.default.createElement('img', { src: config.stripe.stripeImage, className: 'img-responsive img-width-120', alt: 'omise' })
										),
										_react2.default.createElement(
											'h3',
											null,
											'Payment'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'omisepop_in' },
										_react2.default.createElement(
											'div',
											{ className: 'form_sec' },
											_react2.default.createElement(
												'div',
												{ className: 'btn_sec' },
												_react2.default.createElement(
													'a',
													{ href: void 0, className: 'button proceedpayment', title: 'Proceed to payment' },
													_react2.default.createElement(
														'button',
														{ className: 'btn bg-black' },
														'Pay ',
														config.stripe.stripeCurrency,
														' ',
														config.ids.currency,
														' ',
														this.getApplyRewardsPaymentTotal(this.state.newVoucher != "1" ? (parseFloat(this.state.cartDetails.cart_grand_total) + parseFloat(this.state.cartDetails.service_charge_amount)).toFixed(2) : this.state.cartDetails.cart_sub_total)
													)
												)
											)
										)
									)
								)
							)
						)
					);
				}
			}
		}]);
	
		return Chekout;
	}(_react2.default.Component);
	
	exports.default = Chekout;

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _immutabilityHelper = __webpack_require__(56);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactCustomValidation = __webpack_require__(57);
	
	var _validator = __webpack_require__(88);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var lang = __webpack_require__(12);
	
	var config = __webpack_require__(7);
	var APPID = config.ids.appId;
	var APIURL = config.path.apiUrl;
	
	var Loading = __webpack_require__(17);
	var Alert = __webpack_require__(48);
	//import cookie from 'react-cookie';
	var HtmlToReactParser = __webpack_require__(21).Parser;
	var htmlToReactParserTo = new HtmlToReactParser();
	var helper = __webpack_require__(13);
	var initialState = {
		fields: {
			name: '',
			status: 'Loading',
			mobile: '',
			email: ''
		}
	};
	/* Load meta tags */
	var meta = {
		title: lang.contactus_meta_title,
		description: lang.contactus_meta_title,
		meta: {
			name: {
				keywords: lang.contactus_meta_title
			}
		}
	};
	
	var Contactus = function (_React$Component) {
		_inherits(Contactus, _React$Component);
	
		function Contactus() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Contactus);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Contactus.__proto__ || Object.getPrototypeOf(Contactus)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
				fields: {
					name: '',
					mobile: '',
					email: ''
				}
			}, _this.fieldChange = function (field, value) {
				_this.setState((0, _immutabilityHelper2.default)(_this.state, { fields: _defineProperty({}, field, { $set: value }) }));
			}, _this.handleFormSubmit = function () {
				var formPayload = _this.state.fields;
				formPayload.feedback = document.getElementById("feedback").value;
	
				if (formPayload.feedback === '') {
					document.getElementById("spn-feedback-error").innerHTML = '<span class="spn-error">This field is required.</span>';
					return false;
				} else {
					document.getElementById("spn-feedback-error").innerHTML = '';
				}
				var qs = __webpack_require__(3);
				var postObject = {
					"app_id": APPID,
					"customer_first_name": formPayload.name,
					"customer_emailaddress": formPayload.email,
					"customer_phonenumber": formPayload.mobile,
					"customer_message": formPayload.feedback,
					"subject": "Feedback From customer"
				};
				_this.setStateLoading('Loading');
	
				_axios2.default.post(APIURL + "contactus/contact_us", qs.stringify(postObject)).then(function (response) {
					if (response.data.status === "ok") {
						_this.setState(initialState);
						helper.showInfo('Thanks for your feedback');
						_this.setStateLoading('ok');
					} else {
						_this.setStateLoading('error');
						_this.setState(initialState);
						helper.showInfo('Something went wrong');;
					}
				}).catch(function (error) {
					console.log(error);
				});
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(Contactus, [{
			key: 'setStateLoading',
			value: function setStateLoading(sts) {
				this.setState({ status: sts });
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
	
				var site_maintenance_verify = _reactCookie2.default.load("client_site_maintenance_verify") !== '' && _reactCookie2.default.load("client_site_maintenance_verify") !== 'undefined' && _reactCookie2.default.load("client_site_maintenance_verify") !== undefined ? _reactCookie2.default.load("client_site_maintenance_verify") : '';
	
				var site_maintenance_popup_open = _reactCookie2.default.load("site_maintenance_popup_open") !== '' && _reactCookie2.default.load("site_maintenance_popup_open") !== 'undefined' && _reactCookie2.default.load("site_maintenance_popup_open") !== undefined ? _reactCookie2.default.load("site_maintenance_popup_open") : '';
	
				if (site_maintenance_popup_open === "1" && (site_maintenance_verify === '' || site_maintenance_verify === '0')) {
					_reactRouter.hashHistory.push("/");
					return;
				}
	
				(0, _withTracker.loadAnalytics)();
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.state.status === "Loading") {
					return _react2.default.createElement(Loading, null);
				} else {
					return _react2.default.createElement(Form, {
						fields: this.state.fields,
						onChange: this.fieldChange,
						onValid: this.handleFormSubmit,
						onInvalid: function onInvalid() {
							return console.log('Form invalid!');
						}
					});
				}
			}
		}]);
	
		return Contactus;
	}(_react2.default.Component);
	
	var phonenumberPattern = /^[0-9]{6,14}$/;
	var isEmpty = function isEmpty(value) {
		return value === '' ? 'This field is required.' : null;
	};
	
	var isMobile = function isMobile(mobile) {
		return mobile.match(phonenumberPattern) ? null : 'This is not a valid mobile number.';
	};
	
	var isEmail = function isEmail(email) {
		return _validator2.default.isEmail(email) ? null : 'This is not a valid email.';
	};
	
	function validationConfig(props) {
		var _props$fields = props.fields,
		    name = _props$fields.name,
		    mobile = _props$fields.mobile,
		    email = _props$fields.email;
	
	
		return {
			fields: ['name', 'mobile', 'email'],
	
			validations: {
				name: [[isEmpty, name]],
				mobile: [[isEmpty, mobile], [isMobile, mobile]],
				email: [[isEmpty, email, isEmail]]
			}
		};
	}
	
	var Form = function (_React$Component2) {
		_inherits(Form, _React$Component2);
	
		function Form() {
			var _ref2;
	
			var _temp2, _this2, _ret2;
	
			_classCallCheck(this, Form);
	
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}
	
			return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref2, [this].concat(args))), _this2), _this2.state = {
				pageTitle: '',
				pageDesc: '', windowHeightNormal: 0, windowHeight: 0
			}, _temp2), _possibleConstructorReturn(_this2, _ret2);
		}
	
		_createClass(Form, [{
			key: 'componentWillMount',
			value: function componentWillMount(props) {
				var _this3 = this;
	
				/*add class */
				helper.addBodyClass();
	
				var windowHeight = window.innerHeight;
				this.setState({ 'windowHeight': windowHeight - 45 + 'px' });
				this.setState({ 'windowHeightNormal': windowHeight + 'px' });
	
				_axios2.default.get(APIURL + 'cms/page?status=A&app_id=' + APPID + '&page_slug=contact-us').then(function (res) {
					if (res.data.status === "ok") {
						//document.getElementById("header").innerHTML = res.data.result_set[0].cmspage_title;
						//document.getElementById("textDesc").innerHTML = res.data.result_set[0].cmspage_description;
						_this3.setState({ pageTitle: res.data.result_set[0].cmspage_title });
						_this3.setState({ pageDesc: res.data.result_set[0].cmspage_description });
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var _props = this.props,
				    fields = _props.fields,
				    onChange = _props.onChange,
				    onValid = _props.onValid,
				    onInvalid = _props.onInvalid,
				    $field = _props.$field,
				    $validation = _props.$validation;
	
				var errMsgFirstName = void 0,
				    errMsgEmail = void 0,
				    errMsgMobile = void 0;
	
				if ($validation.name.error.reason !== undefined) {
					errMsgFirstName = $validation.name.show && _react2.default.createElement(
						'span',
						{ className: 'spn-error' },
						$validation.name.error.reason
					);
				}
	
				if ($validation.mobile.error.reason !== undefined) {
					errMsgMobile = $validation.mobile.show && _react2.default.createElement(
						'span',
						{ className: 'spn-error' },
						$validation.mobile.error.reason
					);
				}
	
				if ($validation.email.error.reason !== undefined) {
					errMsgEmail = $validation.email.show && _react2.default.createElement(
						'span',
						{ className: 'spn-error' },
						$validation.email.error.reason
					);
				}
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_reactDocumentMeta2.default, meta),
					_react2.default.createElement(Alert, null),
					_react2.default.createElement(
						'div',
						{ className: 'container-fluid desktop-container', style: { minHeight: this.state.windowHeightNormal } },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-xs-12 main-title-bar' },
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: "/" },
									' ',
									_react2.default.createElement('img', { src: '/img/left-arrow.png', className: 'pull-left icon-img-small', alt: 'left-arrow' }),
									' '
								),
								_react2.default.createElement(
									'h3',
									{ className: 'top-title main-title padding-right-20 text-uppercase', id: 'header' },
									this.state.pageTitle
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement('div', { className: 'space-10 bg-gray' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'white-outer center-block' },
							_react2.default.createElement(
								'div',
								{ className: 'col-xs-10 div-center' },
								_react2.default.createElement('div', { className: 'space-20' }),
								_react2.default.createElement(
									'div',
									{ id: 'textDesc' },
									' ',
									htmlToReactParserTo.parse(this.state.pageDesc)
								),
								_react2.default.createElement('div', { className: 'space-5' }),
								_react2.default.createElement(
									'div',
									{ className: 'form-group label-floating is-empty card-no' },
									_react2.default.createElement(
										'div',
										{ className: 'input-group' },
										_react2.default.createElement(
											'label',
											{ className: 'control-label' },
											'Name'
										),
										_react2.default.createElement('input', Object.assign({ type: 'text', className: 'form-control', value: fields.name }, $field('name', function (e) {
											return onChange('name', e.target.value);
										}))),
										errMsgFirstName
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'form-group label-floating is-empty card-no' },
									_react2.default.createElement(
										'div',
										{ className: 'input-group' },
										_react2.default.createElement(
											'label',
											{ className: 'control-label' },
											'Contact Number'
										),
										_react2.default.createElement('input', Object.assign({ type: 'text', className: 'form-control', value: fields.mobile }, $field('mobile', function (e) {
											return onChange('mobile', e.target.value);
										}))),
										errMsgMobile
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'form-group label-floating is-empty card-no' },
									_react2.default.createElement(
										'div',
										{ className: 'input-group' },
										_react2.default.createElement(
											'label',
											{ className: 'control-label' },
											'Email'
										),
										_react2.default.createElement('input', Object.assign({ type: 'text', className: 'form-control', value: fields.email }, $field('email', function (e) {
											return onChange('email', e.target.value);
										}))),
										errMsgEmail
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'form-group label-floating is-empty card-no' },
									_react2.default.createElement(
										'div',
										{ className: 'input-group' },
										_react2.default.createElement(
											'label',
											{ className: 'control-label' },
											'Your Feedback'
										),
										_react2.default.createElement('textarea', { className: 'form-control', id: 'feedback' }),
										_react2.default.createElement('span', { id: 'spn-feedback-error' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'text-center ' },
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'btn btn-raised btn-info full-width-btn text-uppercase', onClick: function onClick(e) {
												e.preventDefault();_this4.props.$submit(onValid, onInvalid);
											} },
										'Send',
										_react2.default.createElement('div', { className: 'ripple-container' })
									),
									_react2.default.createElement('br', null)
								),
								_react2.default.createElement('div', { className: 'space-20' })
							),
							_react2.default.createElement('div', { className: 'clearfix' })
						)
					)
				);
			}
		}]);
	
		return Form;
	}(_react2.default.Component);
	
	Form = (0, _reactCustomValidation.validated)(validationConfig)(Form);
	
	exports.default = Contactus;

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(9);
	
	var _ThemeProvider = __webpack_require__(84);
	
	var _ThemeProvider2 = _interopRequireDefault(_ThemeProvider);
	
	var _theme = __webpack_require__(89);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	__webpack_require__(71);
	
	var _DatePicker = __webpack_require__(85);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _rcTimePicker = __webpack_require__(114);
	
	var _rcTimePicker2 = _interopRequireDefault(_rcTimePicker);
	
	__webpack_require__(144);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var lang = __webpack_require__(12);
	var apps = __webpack_require__(29);
	var config = __webpack_require__(7);
	var APPID = config.ids.appId;
	var APIURL = config.path.apiUrl;
	var APIURLPRO = config.path.apiUrlPro;
	
	var datetime = new Date();
	var currentDateValue = datetime.getDate();
	var helper = __webpack_require__(13);
	
	//const min_datetime = new Date(new Date(datetime).setDate(currentDate3));
	
	var CurrentDate = new Date();
	var dateFormat = __webpack_require__(42);
	var currentDate2 = dateFormat(datetime, "d/m/yyyy");
	var currentTime = dateFormat(datetime, "H");
	var currentMins = dateFormat(datetime, "MM");
	var currentMins3 = dateFormat(datetime, "HH:MM:ss");
	//alert(currentMins3);
	var HtmlToReactParser = __webpack_require__(21).Parser;
	var tat = _reactCookie2.default.load('orderTAT') === "" ? 0 : _reactCookie2.default.load('orderTAT');
	var htmlToReactParser = new HtmlToReactParser();
	
	
	//alert(APPID + "//" + apps.milkHoney);
	
	/* Only apply for chillz india gate */
	var defaultDate = datetime;
	var disabledClassMins = "";
	var disabledDays = [];
	
	var newdefaultDate = new Date(new Date(datetime).setDate(currentDateValue + 2));
	
	if (APPID === apps.chilliz) {
		//6C9AEE37-BC05-4FB8-A351-D51458B83F26
	
		var min_datetime = new Date(new Date(datetime).setDate(currentDateValue - 1));
		var max_datetime = new Date(new Date(datetime).setDate(currentDateValue));
		var readOnly = "readonly";
		var disabledClass = "sel-disabled";
	} else if (APPID === apps.milkHoney) {
		/*  milk and honey */
		// alert();
		min_datetime = new Date(new Date(datetime).setDate(currentDateValue + 2));
		var defaultDate = new Date(new Date(datetime).setDate(currentDateValue + 3));
	
		readOnly = "";
		disabledClass = '';
	} else if (APPID === apps.leanbento) {
		/* learn bento */
	
		if (currentTime <= 19) {
			var min_datetime = new Date(new Date(datetime).setDate(currentDateValue));
			var defaultDate = new Date(new Date(datetime).setDate(currentDateValue + 1));
			//alert(defaultDate);
		} else {
			var min_datetime = new Date(new Date(datetime).setDate(currentDateValue + 1));
			var defaultDate = new Date(new Date(datetime).setDate(currentDateValue + 2));
		}
		max_datetime = new Date(CurrentDate.setMonth(CurrentDate.getMonth() + 1));
		readOnly = "";
		disabledClass = "";
		disabledClassMins = "";
	} else if (APPID === apps.bushido) {
		/*  bushido order  - 11 am to 12 pm -> 15 mins time interval 
	 after  10am choose next day */
		console.log(currentTime);
		if (currentTime >= 9) {
			console.log(1);
			var min_datetime = new Date(new Date(datetime).setDate(currentDateValue));
			var defaultDate = new Date(new Date(datetime).setDate(currentDateValue + 1));
			//alert(defaultDate);
		} else {
			console.log('else condition');
			min_datetime = new Date(new Date(datetime).setDate(currentDateValue - 1));
			max_datetime = new Date(CurrentDate.setMonth(CurrentDate.getMonth() + 1));
		}
		//  max_datetime = new Date(CurrentDate.setMonth(CurrentDate.getMonth() + 1));
		readOnly = "";
		disabledClass = "";
		disabledClassMins = "";
	} else {
	
		min_datetime = new Date(new Date(datetime).setDate(currentDateValue - 1));
		max_datetime = new Date(CurrentDate.setMonth(CurrentDate.getMonth() + 1));
		readOnly = "";
		disabledClass = '';
	}
	
	//var  defaultDate2 = new Date(new Date(datetime).setDate(defaultDate + 1 ));
	
	//alert(defaultDate2);
	/* Load meta tags */
	var meta = {
		title: lang.choose_delvery_date,
		description: lang.site_title,
		meta: {
			name: {
				keywords: lang.site_title
			}
		}
	};
	var showSecond = false;
	var str = showSecond ? 'HH:mm:ss' : 'HH:mm';
	
	var now = (0, _moment2.default)().hour(14).minute(30);
	
	var vStartTime = '';
	var vEndTime = '';
	var vDisplayHrs = [];
	var vDisplayMins = [];
	var utc = '';
	var valueutc = '';
	
	var DeliveryDatePicker = function (_React$Component) {
		_inherits(DeliveryDatePicker, _React$Component);
	
		function DeliveryDatePicker(props) {
			_classCallCheck(this, DeliveryDatePicker);
	
			/*add class */
			// helper.addBodyClass();
	
			/* check Authentication */
			var _this = _possibleConstructorReturn(this, (DeliveryDatePicker.__proto__ || Object.getPrototypeOf(DeliveryDatePicker)).call(this, props));
	
			_this.handleChange = function (item, value) {
				_this.setState(Object.assign({}, _this.state, _defineProperty({}, item, value)));
				var des = document.getElementsByClassName('deliverydate');
				var label = des[0].getElementsByTagName('label');
				label[0].style.top = '0px';
				var input = des[0].getElementsByTagName('input');;
				utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
				valueutc = value.toJSON().slice(0, 10).replace(/-/g, '/');
				//alert(utc)
				if (valueutc === utc) {
					_this.loadTimeDropDown('', '');
				} else {
					_this.loadTimeDropDown('nextDay');
				}
				_react2.default.createElement('p', null);
			};
	
			if ((0, _Api2.default)('Auth') === false) {
				_reactRouter.hashHistory.push("/sign-in");
			}
	
			/* validate delivery avilablity */
			if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId || typeof _reactCookie2.default.load('defaultAvilablityId') === 'undefined' || _reactCookie2.default.load('defaultAvilablityId') === "") {
				_reactRouter.hashHistory.push("/");
			}
	
			if (typeof _reactCookie2.default.load('DeliveryDate') === 'undefined' || _reactCookie2.default.load('DeliveryDate') === "" || _reactCookie2.default.load('DeliveryDate') === null) {
				var autoFillDate = defaultDate;
			} else {
				// var  autoFillDate =  cookie.load('DeliveryDate');
				var cookieDate = _reactCookie2.default.load('DeliveryDate');
				//	alert(cookieDate);
				var splitedDate = cookieDate.split('/');
				var selDate = _this.pad(splitedDate[0]);
				var selMonth = _this.pad(splitedDate[1]);
				var selYear = _this.pad(splitedDate[2]);
				//var autoFillDate = new Date(selYear, selMonth, selDate);
				autoFillDate = defaultDate;
			}
	
			//alert(autoFillDate );
			_this.state = { date: autoFillDate, settings: [], selectTime: currentTime, selectMins: currentMins, startTime: 0, endTime: 24, startMins: 0, endMins: 60, overWriteMins: 'No', overWriteTime: 'No', timeHtml: '', minsHtml: '', fianlstartTime: 0, serverTat: 15, timeExceed: 'No', windowHeight: 0, timeSlots: [], disableDate: [], 'allowTimeSlot': 'No', 'hollidayList': [], allowHoliDay: 'No', TimeSlotHtmlVal: '', timeText: "Time (HH/MM)", productleadtime: 0 };
			_this.changeTimer = _this.changeTimer.bind(_this); //changeMins
			_this.changeMins = _this.changeMins.bind(_this); //changeMins
	
			_this.getsettings();
	
			if (typeof _reactCookie2.default.load('UserId') === 'undefined') {
				var customerParam = "&reference_id=" + (0, _Api2.default)('referenceId');
			} else {
				var customerParam = "&customer_id=" + _reactCookie2.default.load('UserId');
			}
			var postalCodeWhere = "";
			if (typeof _reactCookie2.default.load("orderPostalCode") !== "undefined") {
				postalCodeWhere = '&postal_code=' + _reactCookie2.default.load("orderPostalCode");
			}
			_axios2.default.get(APIURL + 'cartver2/contents?status=A&app_id=' + APPID + customerParam + postalCodeWhere).then(function (res) {
				if (res.data.status === "ok") {
	
					if (typeof res.data.result_set !== "undefined") {
						//this.setState('productleadtime',res.data.result_set.product_lead_time);
						var productleadtime = parseInt(res.data.result_set.product_lead_time);
						if (productleadtime > 0) {
							min_datetime = new Date(new Date(datetime).setDate(currentDateValue + (productleadtime - 1)));
							var str_datetime = new Date(new Date(datetime).setDate(currentDateValue + productleadtime));
							_this.setState({ productleadtime: productleadtime, date: str_datetime });
						}
					}
				}
			});
	
			return _this;
		}
	
		_createClass(DeliveryDatePicker, [{
			key: 'showTimeslotExceed',
	
			/* Disaple year */
			value: function showTimeslotExceed() {
	
				if (this.state.timeExceed === "Yes") {
					if (APPID === "97347EE4-2845-4011-BCE6-9C0B806DA437" && (_reactCookie2.default.load('defaultAvilablityId') === "634E6FA8-8DAF-4046-A494-FFC1FCF8BD11" || _reactCookie2.default.load('defaultAvilablityId') === "718B1A92-5EBB-4F25-B24D-3067606F67F0")) {
						if (_reactCookie2.default.load('defaultAvilablityId') === "634E6FA8-8DAF-4046-A494-FFC1FCF8BD11") {
							return _react2.default.createElement(
								'div',
								{ className: 'timeslot_exc' },
								'Delivery available only on Saturdays (12- 4) pm'
							);
						} else if (_reactCookie2.default.load('defaultAvilablityId') === "718B1A92-5EBB-4F25-B24D-3067606F67F0") {
							return _react2.default.createElement(
								'div',
								{ className: 'timeslot_exc' },
								'Takeaway available only on Saturdays (9 am to 2pm)'
							);
						}
					} else {
						/*return (<div className="timeslot_exc"> Note: Please refer our operating hours. The time you are selecting is outside of our delivery timing. Apologies for the inconvenience.</div>);*/
						return _react2.default.createElement(
							'div',
							{ className: 'timeslot_exc' },
							' Note: Please click on the date/time to select the next available timeslot.'
						);
					}
				}
			}
		}, {
			key: 'getsettings',
			value: function getsettings() {
				var _this2 = this;
	
				var promise = helper.getProSettings('', 'No'); //getResult('settings','');
				promise.then(function (res) {
					_this2.setState({ settings: res.data.result_set });
	
					if (res.data.result_set.client_advanced_timeslot_enable === "1") {
						_reactRouter.hashHistory.push("/delivery-date-advanced");
					} else if (res.data.result_set.client_delivery_time_setting_enable === '1') {
						_reactRouter.hashHistory.push("/delivery-date-new");
					}
	
					/* find current tat value */
					_axios2.default.get(APIURL + 'outlets/gettat_details?app_id=' + APPID + "&availability_id=" + _reactCookie2.default.load('defaultAvilablityId') + "&outlet_id=" + _reactCookie2.default.load('orderOutletId')).then(function (res) {
						if (res.data.status === "ok") {
	
							_reactCookie2.default.save('orderTat', res.data.tat);
							_this2.setState({ serverTat: res.data.tat });
	
							_this2.loadTimeDropDown();
						} else {
							helper.showInfo('Your selected outlet currently closed or disabled by an administrator. Please choose another outlet.');
							_reactRouter.hashHistory.push("/");
						}
					});
					/* find current tat value - End  */
	
					/* timeslot - start */
					if (parseInt(res.data.result_set.client_timeslot_enable) === 1 && _reactCookie2.default.load('defaultAvilablityId') !== config.ids.dineinId) {
						_axios2.default.get(APIURLPRO + 'settings/get_timeslotlist?app_id=' + APPID + "&availability=" + _reactCookie2.default.load('defaultAvilablityId')).then(function (res) {
							if (res.data.status === "ok") {
								_this2.setState({ timeSlots: res.data.result_set });
								_this2.setState({ allowTimeSlot: 'Yes', timeText: "Choose Time slot" });
								_this2.loadTimeDropDown('initail'); /* this enabled for time slot only */
							}
						});
					}
					/* timeslot - End  */
	
					/* Holiday  - start */
	
					var DisableDats = [];
					var DisableDatsArr = [];
					if (parseInt(res.data.result_set.client_holiday_enable) === 1 && _reactCookie2.default.load('defaultAvilablityId') !== config.ids.dineinId) {
						_axios2.default.get(APIURLPRO + 'settings/get_holidaylist?app_id=' + APPID + "&availability=" + _reactCookie2.default.load('defaultAvilablityId') + "&outlet_id=" + _reactCookie2.default.load('orderOutletId')).then(function (res) {
							if (res.data.status === "ok") {
								var resultData = res.data.result_set;
	
								resultData.map(function (loadData) {
									return DisableDats.push(_this2.parseDate(loadData.date));
								});
	
								resultData.map(function (loadData) {
									return DisableDatsArr.push(loadData.date);
								});
								var strdate_obj = _this2.state.date;
								if (DisableDatsArr.length > 0 && strdate_obj !== '') {
									_this2.checkCrntDateHolliday(strdate_obj, DisableDatsArr);
								}
	
								_this2.setState({ hollidayList: resultData, allowHoliDay: 'Yes', disableDate: DisableDats });
							}
						});
					}
	
					/* Holiday - end */
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				(0, _withTracker.loadAnalytics)();
				/* get settings */
	
				var windowHeight = window.innerHeight;
				this.setState({ 'windowHeight': windowHeight - 45 + 'px' });
	
				//this.getsettings();
				var des = document.getElementsByClassName('deliverydate');
				var fc = des[0].getElementsByTagName('div');
				var se = fc[0].getElementsByTagName('div');
				se[0].style.padding = '0px';
				var input = se[0].getElementsByTagName('input');
				input[0].style.borderBottom = '0px';
				var label = des[0].getElementsByTagName('label');
				label[0].style.top = '6px';
				//document.getElementsByClassName('rc-time-picker-input')[0].classList.add("form-control");
	
				/* load time and mins  html values */
	
				/* disabled */
				if (this.state.allowTimeSlot === "Yes") {
					if (APPID === apps.chilliz) {
						/* disabled date and time picker chilliz */
						document.getElementById("deliveryTime").disabled = true;
						document.getElementById("deliveryMins").disabled = true;
					} else {
						document.getElementById("deliveryTime").disabled = false;
						document.getElementById("deliveryMins").disabled = false;
					}
				}
			}
		}, {
			key: 'onChange',
			value: function onChange(value) {
	
				var list = document.getElementsByClassName('form-group');
				var n;
				for (n = 0; n < list.length; ++n) {
					list[n].classList.remove("is-empty");
				}
			}
	
			/* this function used to load cart icon image */
	
		}, {
			key: 'loadCartImage',
			value: function loadCartImage() {
				return (0, _Api2.default)('cartImage', 'Yes');
			}
	
			/* store unit no's */
	
		}, {
			key: 'stroteUnitNoOne',
			value: function stroteUnitNoOne(event) {
				_reactCookie2.default.save('unitNoOne', event.target.value);
			}
	
			/* store unit no's */
	
		}, {
			key: 'stroteUnitNoTwo',
			value: function stroteUnitNoTwo(event) {
				_reactCookie2.default.save('unitNoTwo', event.target.value);
			}
	
			/* store unit no's */
	
		}, {
			key: 'strotetowerNo',
			value: function strotetowerNo(event) {
				_reactCookie2.default.save('towerNo', event.target.value);
			}
			/* validate delivery date */
	
		}, {
			key: 'checkDeliveryDate',
			value: function checkDeliveryDate(holidayData) {
				this.loadTimeDropDown('', '');
				var seldate = document.getElementsByClassName('deliverydate')[0].getElementsByTagName('input')[0].value;
	
				if (this.state.allowTimeSlot === "Yes") {
					/* for timeslot */
					var selMins = "";
					var selTime = "";
					var Timeslot = document.getElementById('timeSlot').value;
				} else {
					/* For TAT */
					selTime = document.getElementById('deliveryTime').value;
					selMins = document.getElementById('deliveryMins').value;
					Timeslot = "";
				}
	
				if (seldate !== "" && selMins !== "" && selTime !== "" || this.state.allowTimeSlot === "Yes" && Timeslot !== "") {
	
					_reactCookie2.default.save('DeliveryDate', seldate);
					if (this.state.allowTimeSlot === "Yes") {
						/* For timeslot */
	
						var splited = Timeslot.split("/");
						_reactCookie2.default.save('isSletedTimeSlot', "Yes");
						_reactCookie2.default.save('DeliveryTimeSlotFormated', splited[1]);
						_reactCookie2.default.save('DeliveryTimeSlot', splited[0]);
	
						var splitedSlot = splited[0].split("-");
						var orderTimeSlotFrom = splitedSlot[0].replace(/"+$/g, "");
						/*var DeliveryTimeTxt = this.convertTime12to24(orderTimeSlotFrom);
	     cookie.save('DeliveryTime', DeliveryTimeTxt);*/
						_reactCookie2.default.save('DeliveryTime', orderTimeSlotFrom);
					} else {
						/* For TAT  */
						_reactCookie2.default.save('isSletedTimeSlot', "No");
						_reactCookie2.default.save('DeliveryTime', selTime + ":" + selMins);
					}
	
					/* start - holiday validation  */
					var holidayLen = holidayData.length;
					if (holidayLen > 0 && this.state.allowHoliDay === "Yes") {
						for (var hl = 0; hl < holidayLen; hl++) {
							//alert(seldate + "===" );
							if (seldate === dateFormat(holidayData[hl].date, "d/m/yyyy")) {
								helper.showInfo('The selected date is a holiday. Please select another day');
								return false;
							}
						}
					}
	
					/* End of holiday validation  */
	
					//Check unit number validation 
					if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId) {
						var AlertOne = document.getElementById('unitone').value;
						var AlertTwo = document.getElementById('unittwo').value;
						if (AlertOne === "" || AlertTwo === "") {
							var res = confirm('You did not enter a Floor No / Unit No. \n Do you want to continue');
	
							if (!res) {
								error = '1';
								return false;
							}
						}
					}
	
					var splitedDate = seldate.split('/');
					var OrderTime = splitedDate[2] + '-' + this.pad(splitedDate[1]) + '-' + this.pad(splitedDate[0]) + ' ' + selTime + ":" + selMins;
					var cookieSlot = _reactCookie2.default.load('DeliveryTimeSlot');
					var splitedSlot = cookieSlot.split("-");
					var order_pickup_time_slot_from = splitedSlot[0];
					var order_pickup_time_slot_to = splitedSlot[1];
	
					_axios2.default.get(APIURLPRO + 'ordersv1/validate_order_count?app_id=' + APPID + '&availability_id=' + _reactCookie2.default.load('defaultAvilablityId') + '&outlet_id=' + _reactCookie2.default.load('orderOutletId') + '&order_date=' + OrderTime + '&order_pickup_time_slot_from=' + order_pickup_time_slot_from + '&order_pickup_time_slot_to=' + order_pickup_time_slot_to).then(function (res) {
						if (res.data.status === "ok") {
							_reactRouter.hashHistory.push("/checkout");
						} else {
							helper.showInfo(res.data.message);
						}
					});
					//hashHistory.push("/checkout");
				} else {
					helper.showInfo(lang.choose_delvery_date_error);
				}
			}
		}, {
			key: 'changeTimer',
			value: function changeTimer(e) {
				console.log("change date action");
				var seletedTime = e.target.value;
	
				/* add date wise calculation */
				var selectedDate = document.getElementsByClassName('deliverydate')[0].getElementsByTagName('input')[0].value;
				this.setState({ selectTime: seletedTime });
				if (selectedDate === currentDate2) {
					if (parseInt(seletedTime) === parseInt(this.state.fianlstartTime)) {
						this.loadTimeDropDown('', 'samemins', seletedTime);
					} else {
						this.loadTimeDropDown('', 'nextMins', seletedTime);
					}
				} else {
					//  alert('next day');
					this.loadTimeDropDown('nextDay', 'nextMins', seletedTime);
				}
			}
		}, {
			key: 'convertTime12to24',
			value: function convertTime12to24(time12h) {
				var ts = time12h;
				if (ts !== '') {
					var _time12h$split = time12h.split(' '),
					    _time12h$split2 = _slicedToArray(_time12h$split, 2),
					    time = _time12h$split2[0],
					    modifier = _time12h$split2[1];
	
					var _time$split = time.split(':'),
					    _time$split2 = _slicedToArray(_time$split, 2),
					    hours = _time$split2[0],
					    minutes = _time$split2[1];
	
					if (hours === '12') {
						hours = '00';
					}
	
					if (modifier === 'PM') {
						hours = parseInt(hours, 10) + 12;
					}
	
					ts = hours + ':' + minutes;
				}
				return ts;
			}
	
			/* chnage minutes */
	
		}, {
			key: 'changeMins',
			value: function changeMins(e) {
				this.setState({ selectMins: e.target.value });
			}
	
			/* set default Avilablity */
	
		}, {
			key: 'loadTimeDropDown',
			value: function loadTimeDropDown() {
				var day = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
				var mins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
				var triggerTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
				//console.log("load Time INIT");
				if (this.state.allowTimeSlot === "No") {
	
					/* if calculate server TAT time */
					var serStartTat = 0;
					var serEndTat = 0;
					var serverStartFloat = 0;
					//var bushidoStart = "11:00:00";
					//var bushidoEndt = "13:30:00";
					if (parseFloat(this.state.settings.client_timer_enable) === 1 && typeof this.state.settings.client_timer_enable !== 'undefined' && this.state.settings.client_start_time !== '' && typeof this.state.settings.client_start_time !== 'undefined' && this.state.settings.client_end_time !== '' && typeof this.state.settings.client_end_time !== 'undefined') {
						var serStrTime = this.state.settings.client_start_time; //(APPID === apps.bushido ? bushidoStart :   this.state.settings.client_start_time );
						var serEndTime = this.state.settings.client_end_time; //(APPID === apps.bushido ? bushidoEndt : this.state.settings.client_end_time );
	
						/* split start time */
						var strrtSplited = serStrTime.split(":");
						if (typeof strrtSplited[1] !== "undefined") {
							serStartTat = parseInt(strrtSplited[1]);
	
							//var newFlatRes = parseInt(strrtSplited[0])+"."+parseInt(strrtSplited[1]);
							// var serverStartFloat = parseFloat(newFlatRes);
						}
	
						/* split start time */
						var endTimeSplited = serEndTime.split(":");
						if (typeof endTimeSplited[1] !== "undefined") {
							serEndTat = parseInt(endTimeSplited[1]);
						}
					}
	
					tat = parseInt(this.state.serverTat);
					var tatTime = 0;
					var tatmins = 0;
	
					var converted = tat / 60;
					var addTatTime = day !== "nextDay" ? parseInt(currentMins) + parseInt(tat) : parseInt(tat);
					//alert(addTatTime);
					if (addTatTime < 45) {
						//alert(addTatTime + "//");
						tatTime = 0;
						tatmins = this.makeround(addTatTime); //alert(tatmins + "/////");
					} else if (addTatTime >= 45 && addTatTime <= 104) {
						tatTime = 1;
						var minusVlaue = parseInt(addTatTime) > 60 ? parseInt(addTatTime) - 60 : 0;
						tatmins = this.makeround(minusVlaue);
					} else {
						//alert('else');
						tatTime = 2;
						var minusVlaue = parseInt(addTatTime) > 120 ? parseInt(addTatTime) - 120 : 0;
						tatmins = this.makeround(minusVlaue);
						/* if choose next day over default time */
					}
	
					/* set start timing */
	
					/* calculate timer dropdown values */
					if (parseFloat(this.state.settings.client_timer_enable) === 1 && typeof this.state.settings.client_timer_enable !== 'undefined' && this.state.settings.client_start_time !== '' && typeof this.state.settings.client_start_time !== 'undefined' && this.state.settings.client_end_time !== '' && typeof this.state.settings.client_end_time !== 'undefined') {
						var serverTime = parseInt(this.state.settings.client_start_time); // (APPID === apps.bushido? parseInt(bushidoStart) :    parseInt(this.state.settings.client_start_time));
	
						//  var serStrTime = (APPID === apps.bushido? "10:30:00" :   this.state.settings.client_start_time );
						var startTime = serverTime <= currentTime && day !== "nextDay" ? currentTime : serverTime;
						var endTime = parseInt(this.state.settings.client_end_time); //(APPID === apps.bushido? parseInt(bushidoEndt) :  parseInt(this.state.settings.client_end_time));
	
						/*only for learn bento */
						var startTimeLeanbento = parseInt(this.state.settings.client_start_time);
						var endTimeLeanbento = parseInt(this.state.settings.client_end_time);
					} else {
						var startTime = day !== "nextDay" ? currentTime : 0;
						var endTime = 24;
	
						/*only for learn bento */
						var startTimeLeanbento = 0;
						var endTimeLeanbento = 24;
					}
	
					var fianlstartTime = parseInt(startTime) + parseInt(tatTime);
	
					/* add server 30 mins calculation  
	     if(day === "nextDay"){
	     
	      var newAddTatTime = parseInt(tat) + parseInt(serStartTat) ;
	       //alert(newAddTatTime);
	     
	    		 //alert(tatmins);
	      if(serStartTat > 44 ){
	         fianlstartTime =  fianlstartTime + 1 ;
	      }
	     }*/
	
					this.setState({ fianlstartTime: fianlstartTime });
					var TimeHtml = "";
					var timerStatus = "No";
					var endTimeCalc = endTime;
					var bushidoEndTime = null;
	
					/* for leanbento apply server tine */
					if (APPID === apps.leanbento) {
						if (serStartTat > 0) {
							fianlstartTime = startTimeLeanbento + 1;
						} else {
							fianlstartTime = startTimeLeanbento;
						}
	
						if (serEndTat >= 30) {
							endTime = endTimeLeanbento + 1;
						} else {
							endTime = endTimeLeanbento;
						}
	
						document.getElementById("deliveryMins").disabled = false;
					}
	
					/* for bushido apply server tome  */
					if (APPID === apps.bushido) {
						fianlstartTime = 11;
						endTime = 12;
					}
	
					for (var valueTime = fianlstartTime; valueTime < endTime; valueTime++) {
						if (APPID !== apps.vantase && APPID !== apps.workspace || APPID === apps.vantase && parseInt(valueTime) !== parseInt(15) && parseInt(valueTime) !== parseInt(16) && parseInt(valueTime) !== parseInt(17) || APPID === apps.workspace && parseInt(valueTime) !== parseInt(12) && APPID === apps.workspace && parseInt(valueTime) !== parseInt(13)) {
							TimeHtml += "<option value='" + this.pad(valueTime) + "'  >" + this.pad(valueTime) + "</option>";
							timerStatus = "Yes";
							var endTimeCalc = valueTime;
							bushidoEndTime = valueTime;
						}
					}
	
					var timeDropDown = htmlToReactParser.parse(TimeHtml);
					this.setState({ timeHtml: timeDropDown });
					/* End of timer dropdown */
	
					/* calculate Mins dropdown values */
					var htmlMins = "";
					// alert(serverTime + "//" + triggerTime )
					if (parseInt(triggerTime) === parseInt(serverTime) && day === "nextDay") {
						//  console.log("server start time - click time(same) / next day");
						//alert("time same" + tatmins + "//" + tat);
						// var startMins =  parseInt(tatmins) + tat;   commented by vinoth = 06/10/2017
						//alert(tatmins);
						var startMins = parseInt(tatmins);
					} else {
	
						if (day === "nextDay" && parseInt(triggerTime) === fianlstartTime) /* set next day + tat time */
							{
								// console.log("server start time - click time(same) / next day");
								var startMins = parseInt(tatmins);
							} else {
							var startMins = mins === 'nextMins' ? 0 : parseInt(tatmins); /* if choose next miin s apply 0 */
						}
					}
					//alert(startMins);
	
					var endMins = 60;
	
					/* check final time tat */
	
					if (parseInt(triggerTime) === parseInt(endTimeCalc)) {
	
						/* startMins = startMins + tat;  this code removed for testing purpose -- 17/04/2017 */
						startMins = startMins + tat;
					}
	
					/* for leanbento apply server tine */
					var incrementVal = 15;
					if (APPID === apps.leanbento) {
						startMins = 0;
						endMins = 45;
						incrementVal = 30;
					}
	
					//  console.log(triggerTime + " // triggerTime")
					var bushidotime = triggerTime !== null ? parseInt(triggerTime) : 10;
					/*  console.log(bushidotime);
	       if(parseInt(bushidotime) === parseInt(serverTime) && day ==="nextDay" && APPID === apps.bushido){
	    	console.log('choose tomorrow');
	    	 // startMins = 45;
	    }else if(APPID === apps.bushido){
	    	 startMins = 0;
	    } */
					if (APPID === apps.bushido) {
						console.log("apps bushido");
						incrementVal = 5;
						/// var calTime = (triggerTime !== null && triggerTime !==""? triggerTime : fianlstartTime );
						console.log("bushidoEndTime " + bushidoEndTime + " // triggerTime " + triggerTime);
						if (endTimeCalc === 12) {
							console.log("endMins 15");
							startMins = 0;
							endMins = 15;
						} else {
							console.log(2);
							startMins = 0;
						}
						/*if(parseInt(calTime) === parseInt("12") ){
	      console.log(1);
	         startMins = 0;
	         endMins = 15;
	     }else{
	       console.log(2);
	       startMins = 0;
	     } */
					}
	
					// alert(startMins);
					var minsStatus = "No";
					for (var valuemins = startMins; valuemins < endMins; valuemins += incrementVal) {
						htmlMins += "<option value='" + this.pad(valuemins) + "'  >" + this.pad(valuemins) + "</option>";
						minsStatus = "Yes";
					}
	
					if (timerStatus === 'No' || minsStatus === 'No') {
						this.setState({ timeExceed: 'Yes' });
					} else {
						this.setState({ timeExceed: 'No' });
					}
					var minsDropDown = htmlToReactParser.parse(htmlMins);
					this.setState({ minsHtml: minsDropDown });
	
					/* End of Mins dropdown values  */
				} else {
					/* if time slot enabled */
	
					var todayDateonly = new Date().toISOString().slice(0, 10);
					var nowDateTimetxt = new Date();
	
					var timeSlotHtml = "";
					//	     state.timeSlots => 
					var stateTimeSlot = this.state.timeSlots;
					var lenghtTimeSlots = stateTimeSlot.length;
					var exceedLoop = 'No';
					if (lenghtTimeSlots > 0) {
						if (day === 'initail' && this.state.productleadtime > 0) {
							day = 'nextDay';
						}
	
						for (var tl = 0; tl < lenghtTimeSlots; tl++) {
							//	alert(currentTime + " --" + stateTimeSlot[tl].timeslot_to_time );
							var chkngTxt = new Date(todayDateonly + " " + stateTimeSlot[tl].timeslot_from_time);
							//if(   day !=="nextDay" && ( Date.parse(currentDate2+' '+currentMins3) <  Date.parse(currentDate2+' '+stateTimeSlot[tl].timeslot_from_time )) ) {
							if (day !== "nextDay" && nowDateTimetxt < chkngTxt) {
								exceedLoop = 'Yes';
								timeSlotHtml += "<option value='" + stateTimeSlot[tl].timeslot_from_time + '"-"' + stateTimeSlot[tl].timeslot_to_time + "'>" + stateTimeSlot[tl].FormatedFrom + " - " + stateTimeSlot[tl].FormatedTo + "</option>";
							} else if (day === "nextDay") {
								exceedLoop = 'Yes';
								timeSlotHtml += "<option value='" + stateTimeSlot[tl].timeslot_from_time + '-' + stateTimeSlot[tl].timeslot_to_time + '/' + stateTimeSlot[tl].FormatedFrom + '-' + stateTimeSlot[tl].FormatedTo + "'>" + stateTimeSlot[tl].FormatedFrom + " - " + stateTimeSlot[tl].FormatedTo;
							}
						}
						// alert(exceedLoop);
	
						if (exceedLoop === 'No') {
							this.setState({ timeExceed: 'Yes' });
						} else {
							this.setState({ timeExceed: 'No' });
						}
					}
	
					// console.log(timeSlotDD);
					var timeSlotDD = htmlToReactParser.parse(timeSlotHtml);
					this.setState({ TimeSlotHtmlVal: timeSlotDD });
	
					//alert('nect day ');
					//}
	
				}
			}
	
			/* add zero */
	
		}, {
			key: 'pad',
			value: function pad(d) {
				return d < 10 ? '0' + d.toString() : d.toString();
			}
	
			/* maek round of */
	
		}, {
			key: 'makeround',
			value: function makeround(value) {
				var returnValue = 0;
				if (value > 0 && value <= 15) {
					returnValue = 15;
				} else if (value >= 16 && value <= 30) {
					returnValue = 30;
				} else if (value >= 31 && value <= 45) {
					returnValue = 45;
				}
	
				return returnValue;
			}
	
			/* format date'es */
	
		}, {
			key: 'changeDateFun',
			value: function changeDateFun(chgDateTxt) {
				var mnth_txt = parseInt(chgDateTxt.getMonth()) + 1;
				mnth_txt = this.pad(mnth_txt);
				var date_txt = parseInt(chgDateTxt.getDate());
				date_txt = this.pad(date_txt);
				var strdate_txt = chgDateTxt.getFullYear() + '-' + mnth_txt + '-' + date_txt;
	
				return strdate_txt;
			}
			/* format date'es */
	
		}, {
			key: 'checkCrntDateHolliday',
			value: function checkCrntDateHolliday(DateTxt, DateArr) {
				if (DateArr.indexOf(this.changeDateFun(DateTxt)) === -1) {
					this.setState({ date: DateTxt });
				} else {
					var daytextstr = parseInt(DateTxt.getDate()) + 1;
					var str_datetime = new Date(new Date(DateTxt).setDate(daytextstr));
					this.checkCrntDateHolliday(str_datetime, DateArr);
				}
			}
	
			/* format date'es */
	
		}, {
			key: 'parseDate',
			value: function parseDate(input) {
				var parts = input.match(/(\d+)/g);
				// new Date(year, month [, date [, hours[, minutes[, seconds[, ms]]]]])
				return new Date(parts[0], parts[1] - 1, parts[2]); // months are 0-based
			}
	
			/* show timig DD or timelsot */
	
			/* function sued to load time slot and time dd vales */
	
		}, {
			key: 'loadTimer',
			value: function loadTimer() {
	
				/* <select className={' customdd timelsotdd'}   id="timeSlot"   >
	   								   {this.state.TimeSlotHtmlVal}
	   								    </select>
	   									 */
	
				_react2.default.createElement(
					'select',
					{ className: disabledClass + ' customdd', value: this.state.selectTime, onChange: this.changeTimer, id: 'deliveryTime' },
					this.state.timeHtml
				) / _react2.default.createElement(
					'select',
					{ id: 'deliveryMins', className: disabledClassMins + " " + disabledClass + ' customdd', value: this.state.selectMins, onChange: this.changeMins },
					this.state.minsHtml
				);
			}
	
			/*show outlet text for workspace */
	
		}, {
			key: 'outletNameText',
			value: function outletNameText() {
				if (apps.workspace === APPID) {
					return htmlToReactParser.parse("Workspace Espresso Bar <br/> 12 Marina Boulevard<br/> Marina Bay Financial Centre Tower 3<br/> #01-08 Singapore 018982");
				} else {
	
					return _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId ? _reactCookie2.default.load('orderDeliveryAddress') : _reactCookie2.default.load('orderHandled');
				}
			}
		}, {
			key: 'render',
			value: function render() {
	
				if (this.state.allowTimeSlot === "Yes") {
	
					return _react2.default.createElement(
						'div',
						null,
						' ',
						_react2.default.createElement(_reactDocumentMeta2.default, meta),
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid desktop-container', style: { minHeight: this.state.windowHeight } },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 top-nav inner-top-nav head-main' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-3 nav-head pd-l-20  head-child' },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: "/cart" },
											_react2.default.createElement('img', { src: '/img/icons/arrow-right.png', alt: 'left-arrow', className: 'icon-img-small-3' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-6 nav-head head-child' },
										_react2.default.createElement(
											'h1',
											{ className: 'main-title' },
											_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId ? "Delivery" : "PICKUP"
										)
									),
									_react2.default.createElement('div', { className: 'col-xs-3 nopadding head-child' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-lg-12 calender-area' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-12 calender-area-sub' },
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-offset-2 col-xs-8 cal-div' },
											_react2.default.createElement(
												'h1',
												{ className: 'sub-heading', style: { textAlign: 'center' } },
												_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId ? "SELECT YOUR DELIVERY DATE AND TIME" : "SELECT YOUR PICKUP DATE AND TIME"
											),
											_react2.default.createElement(
												'div',
												{ className: 'form-group label-floating is-empty card-no custom-date-label' },
												_react2.default.createElement(
													'div',
													{ className: 'input-group deliverydate' },
													_react2.default.createElement(
														_ThemeProvider2.default,
														{ theme: _theme2.default },
														_react2.default.createElement(_DatePicker2.default, { label: 'Date (DD/MM/YYYY)',
															readonly: readOnly,
															inputFormat: function inputFormat(value) {
																return value.getDate() + '/' + (value.getMonth() + 1) + '/' + value.getFullYear();
															},
															minDate: min_datetime,
															maxDate: max_datetime,
															sundayFirstDayOfWeek: true,
															onChange: this.handleChange.bind(this, 'date'),
															className: 'delivery_datepiker',
															disabledDates: this.state.disableDate,
	
															value: this.state.date })
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'form-group label-floating is-empty card-no custom-time-label min-hgt-hour-t' },
												_react2.default.createElement(
													'div',
													{ className: 'input-group' },
													_react2.default.createElement(
														'label',
														{ className: 'control-label' },
														this.state.timeText
													),
													_react2.default.createElement(
														'select',
														{ className: ' customdd timelsotdd', id: 'timeSlot' },
														this.state.TimeSlotHtmlVal
													)
												)
											),
											this.showTimeslotExceed(),
											_react2.default.createElement('div', { className: 'space-35' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-12 calender-area-sub-2' },
										_react2.default.createElement(
											'h1',
											{ className: 'sub-heading', style: { textAlign: 'center' } },
											_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId ? "DELIVER TO" : "PICKUP AT"
										),
										_react2.default.createElement(
											'h1',
											{ className: 'sub-heading-2', style: { textAlign: 'center' } },
											this.outletNameText()
										),
										_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId ? _react2.default.createElement(
											'div',
											{ className: 'col-xs-12 unit-no-div' },
											_react2.default.createElement(
												'div',
												{ className: 'form-group col-sm-4 col-xs-12 no-margin' },
												_react2.default.createElement(
													'div',
													{ className: 'form-group label-floating is-empty card-no' },
													_react2.default.createElement(
														'div',
														{ className: 'input-group' },
														_react2.default.createElement(
															'label',
															{ className: 'control-label' },
															'Building Name/ Tower'
														),
														_react2.default.createElement('input', { type: 'text', id: 'towerno', className: 'form-control', onChange: this.strotetowerNo })
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'form-group col-sm-4 col-xs-12 no-margin' },
												_react2.default.createElement(
													'div',
													{ className: 'form-group label-floating is-empty card-no' },
													_react2.default.createElement(
														'div',
														{ className: 'input-group' },
														_react2.default.createElement(
															'label',
															{ className: 'control-label' },
															'Floor No'
														),
														_react2.default.createElement('input', { type: 'text', id: 'unitone', className: 'form-control', onChange: this.stroteUnitNoOne })
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'form-group col-sm-4 col-xs-12 no-margin' },
												_react2.default.createElement(
													'div',
													{ className: 'form-group label-floating is-empty card-no' },
													_react2.default.createElement(
														'div',
														{ className: 'input-group' },
														_react2.default.createElement(
															'label',
															{ className: 'control-label' },
															'Unit No'
														),
														_react2.default.createElement('input', { type: 'text', id: 'unittwo', className: 'form-control', onChange: this.stroteUnitNoTwo })
													)
												),
												_react2.default.createElement('br', null)
											),
											_react2.default.createElement('div', { className: 'clearfix' })
										) : _react2.default.createElement('div', { className: 'space-30' })
									),
									_react2.default.createElement('div', { className: 'space-30' })
								)
							),
							_react2.default.createElement('div', { className: 'space-30' }),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									_reactRouter.Link,
									{ onClick: this.checkDeliveryDate.bind(this, this.state.hollidayList) },
									_react2.default.createElement(
										'button',
										{ className: 'col-lg-12 continue-but desktop-container container-fluid' },
										'Continue'
									)
								)
							)
						)
					);
				} else {
	
					return _react2.default.createElement(
						'div',
						null,
						' ',
						_react2.default.createElement(_reactDocumentMeta2.default, meta),
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid desktop-container', style: { minHeight: this.state.windowHeight } },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 top-nav inner-top-nav head-main' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-3 nav-head pd-l-20  head-child' },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: "/cart" },
											_react2.default.createElement('img', { src: '/img/icons/arrow-right.png', alt: 'left-arrow', className: 'icon-img-small-3' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-6 nav-head head-child' },
										_react2.default.createElement(
											'h1',
											{ className: 'main-title' },
											_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId ? "Delivery" : "PICKUP"
										)
									),
									_react2.default.createElement('div', { className: 'col-xs-3 nopadding head-child' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-lg-12 calender-area' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-12 calender-area-sub' },
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-offset-2 col-xs-8 cal-div' },
											_react2.default.createElement(
												'h1',
												{ className: 'sub-heading', style: { textAlign: 'center' } },
												_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId ? "SELECT YOUR DELIVERY DATE AND TIME" : "SELECT YOUR PICKUP DATE AND TIME"
											),
											_react2.default.createElement(
												'div',
												{ className: 'form-group label-floating is-empty card-no custom-date-label' },
												_react2.default.createElement(
													'div',
													{ className: 'input-group deliverydate' },
													_react2.default.createElement(
														_ThemeProvider2.default,
														{ theme: _theme2.default },
														_react2.default.createElement(_DatePicker2.default, { label: 'Date (DD/MM/YYYY)',
															readonly: readOnly,
															inputFormat: function inputFormat(value) {
																return value.getDate() + '/' + (value.getMonth() + 1) + '/' + value.getFullYear();
															},
															minDate: min_datetime,
															maxDate: max_datetime,
															sundayFirstDayOfWeek: true,
															onChange: this.handleChange.bind(this, 'date'),
															className: 'delivery_datepiker',
															disabledDates: this.state.disableDate,
	
															value: this.state.date })
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'form-group label-floating is-empty card-no custom-time-label min-hgt-hour-t' },
												_react2.default.createElement(
													'div',
													{ className: 'input-group' },
													_react2.default.createElement(
														'label',
														{ className: 'control-label' },
														this.state.timeText
													),
													_react2.default.createElement(
														'select',
														{ className: disabledClass + ' customdd', value: this.state.selectTime, onChange: this.changeTimer, id: 'deliveryTime' },
														this.state.timeHtml
													),
													' /',
													_react2.default.createElement(
														'select',
														{ id: 'deliveryMins', className: disabledClassMins + " " + disabledClass + ' customdd', value: this.state.selectMins, onChange: this.changeMins },
														this.state.minsHtml
													)
												)
											),
											this.showTimeslotExceed(),
											_react2.default.createElement('div', { className: 'space-35' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-12 calender-area-sub-2' },
										_react2.default.createElement(
											'h1',
											{ className: 'sub-heading', style: { textAlign: 'center' } },
											_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId ? "DELIVER TO" : "PICKUP AT"
										),
										_react2.default.createElement(
											'h1',
											{ className: 'sub-heading-2', style: { textAlign: 'center' } },
											this.outletNameText()
										),
										_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId ? _react2.default.createElement(
											'div',
											{ className: 'col-xs-12 unit-no-div' },
											_react2.default.createElement(
												'div',
												{ className: 'form-group col-sm-4 col-xs-12 no-margin' },
												_react2.default.createElement(
													'div',
													{ className: 'form-group label-floating is-empty card-no' },
													_react2.default.createElement(
														'div',
														{ className: 'input-group' },
														_react2.default.createElement(
															'label',
															{ className: 'control-label' },
															'Building Name/ Tower'
														),
														_react2.default.createElement('input', { type: 'text', id: 'towerno', className: 'form-control', onChange: this.strotetowerNo })
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'form-group col-sm-4 col-xs-12 no-margin' },
												_react2.default.createElement(
													'div',
													{ className: 'form-group label-floating is-empty card-no' },
													_react2.default.createElement(
														'div',
														{ className: 'input-group' },
														_react2.default.createElement(
															'label',
															{ className: 'control-label' },
															'Floor No'
														),
														_react2.default.createElement('input', { type: 'text', id: 'unitone', className: 'form-control', onChange: this.stroteUnitNoOne })
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'form-group col-sm-4 col-xs-12 no-margin' },
												_react2.default.createElement(
													'div',
													{ className: 'form-group label-floating is-empty card-no' },
													_react2.default.createElement(
														'div',
														{ className: 'input-group' },
														_react2.default.createElement(
															'label',
															{ className: 'control-label' },
															'Unit No'
														),
														_react2.default.createElement('input', { type: 'text', id: 'unittwo', className: 'form-control', onChange: this.stroteUnitNoTwo })
													)
												),
												_react2.default.createElement('br', null)
											),
											_react2.default.createElement('div', { className: 'clearfix' })
										) : _react2.default.createElement('div', { className: 'space-30' })
									),
									_react2.default.createElement('div', { className: 'space-30' })
								)
							),
							_react2.default.createElement('div', { className: 'space-30' }),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									_reactRouter.Link,
									{ onClick: this.checkDeliveryDate.bind(this, this.state.hollidayList) },
									_react2.default.createElement(
										'button',
										{ className: 'col-lg-12 continue-but desktop-container container-fluid' },
										'Continue'
									)
								)
							)
						)
					);
				}
			}
		}]);
	
		return DeliveryDatePicker;
	}(_react2.default.Component);
	
	exports.default = DeliveryDatePicker;

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(9);
	
	var _ThemeProvider = __webpack_require__(84);
	
	var _ThemeProvider2 = _interopRequireDefault(_ThemeProvider);
	
	var _theme = __webpack_require__(89);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	__webpack_require__(71);
	
	var _DatePicker = __webpack_require__(85);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _rcTimePicker = __webpack_require__(114);
	
	var _rcTimePicker2 = _interopRequireDefault(_rcTimePicker);
	
	__webpack_require__(144);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var lang = __webpack_require__(12);
	var apps = __webpack_require__(29);
	var config = __webpack_require__(7);
	var APPID = config.ids.appId;
	var APIURL = config.path.apiUrl;
	var APIURLPRO = config.path.apiUrlPro;
	
	var datetime = new Date();
	var datetimecal = new Date();
	var currentDateValue = datetime.getDate();
	var helper = __webpack_require__(13);
	
	var CurrentDate = new Date();
	var dateFormat = __webpack_require__(42);
	var currentDate2 = dateFormat(datetime, "d/m/yyyy");
	var currentTime = dateFormat(datetime, "H");
	var currentMins = dateFormat(datetime, "MM");
	var currentMins3 = dateFormat(datetime, "HH:MM:ss");
	var HtmlToReactParser = __webpack_require__(21).Parser;
	var tat = _reactCookie2.default.load('orderTAT') === "" ? 0 : _reactCookie2.default.load('orderTAT');
	var htmlToReactParser = new HtmlToReactParser();
	
	
	/* Only apply for chillz india gate */
	var defaultDate = datetime;
	var disabledClassMins = "";
	var disabledDays = [];
	var Product_LeadTime = 0;
	
	var newdefaultDate = new Date(new Date(datetime).setDate(currentDateValue + 2));
	var min_datetime = new Date(new Date(datetime).setDate(currentDateValue - 1));
	var max_datetime = new Date(new Date(datetime).setDate(currentDateValue));
	var readOnly = "";
	var disabledClass = "";
	
	var weekdayArr = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
	/* Load meta tags */
	var meta = {
		title: lang.choose_delvery_date,
		description: lang.site_title,
		meta: {
			name: {
				keywords: lang.site_title
			}
		}
	};
	
	var showSecond = false;
	var str = showSecond ? 'HH:mm:ss' : 'HH:mm';
	var now = (0, _moment2.default)().hour(14).minute(30);
	
	var vStartTime = '';
	var vEndTime = '';
	var vDisplayHrs = [];
	var vDisplayMins = [];
	var utc = '';
	var valueutc = '';
	
	var DeliveryDatePickerNew = function (_React$Component) {
		_inherits(DeliveryDatePickerNew, _React$Component);
	
		function DeliveryDatePickerNew(props) {
			_classCallCheck(this, DeliveryDatePickerNew);
	
			/* check Authentication */
			var _this = _possibleConstructorReturn(this, (DeliveryDatePickerNew.__proto__ || Object.getPrototypeOf(DeliveryDatePickerNew)).call(this, props));
	
			_this.handleChange = function (item, value) {
				var sltdDatevalue = value;
				var des = document.getElementsByClassName('deliverydate');
				var label = des[0].getElementsByTagName('label');
				label[0].style.top = '0px';
				var input = des[0].getElementsByTagName('input');
				var itsCurtDy = 'no';
				var utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
				var valueutc = value.toJSON().slice(0, 10).replace(/-/g, '/');
				var cutOfftime = _this.state.cutOfftimeTxt;
				var maxdays = _this.state.maxDayscount;
				var incrDaysNw = _this.state.minDatecount;
				var strDatetimeVl = new Date(new Date(datetime).setDate(currentDateValue + incrDaysNw));
				var strDatetimeChk = strDatetimeVl.toJSON().slice(0, 10).replace(/-/g, '/');
	
				if (valueutc === utc) {
					var currentTimeNew = dateFormat(new Date(), "H");
					if (parseInt(currentTimeNew) < parseInt(cutOfftime)) {
						itsCurtDy = 'yes';
					} else {
						var incr_daysincr_days = 1;
						var str_datetime = new Date(new Date(datetime).setDate(currentDateValue + incr_daysincr_days));
						max_datetime = new Date(new Date(datetime).setDate(currentDateValue + incr_daysincr_days + maxdays));
						min_datetime = new Date(new Date(datetime).setDate(currentDateValue + (incr_daysincr_days - 1)));
	
						sltdDatevalue = str_datetime;
						helper.showInfo('Sorry shop was closed or disabled by an administrator. Please choose another day.');
					}
				} else if (valueutc === strDatetimeChk) {
					var currentTimeChk = dateFormat(new Date(), "H");
					if (parseInt(currentTimeChk) >= parseInt(cutOfftime)) {
						var incrDaysincrDays = parseInt(incrDaysNw) + 1;
						var str_datetime = new Date(new Date(datetime).setDate(currentDateValue + incrDaysincrDays));
						max_datetime = new Date(new Date(datetime).setDate(currentDateValue + incrDaysincrDays + maxdays));
						min_datetime = new Date(new Date(datetime).setDate(currentDateValue + (incrDaysincrDays - 1)));
	
						sltdDatevalue = str_datetime;
						helper.showInfo('Sorry shop was closed or disabled by an administrator. Please choose another day.');
					}
				}
	
				_this.setState(Object.assign({}, _this.state, _defineProperty({}, item, sltdDatevalue)));
				_this.setState({ itsCurtDay: itsCurtDy });
				var dayText = weekdayArr[sltdDatevalue.getDay()];
				_this.getTimesettingArrFun(dayText);
			};
	
			if ((0, _Api2.default)('Auth') === false) {
				_reactRouter.hashHistory.push("/sign-in");
			}
	
			/* validate delivery avilablity */
			if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId || typeof _reactCookie2.default.load('defaultAvilablityId') === 'undefined' || _reactCookie2.default.load('defaultAvilablityId') === "") {
				_reactRouter.hashHistory.push("/");
			}
	
			if (typeof _reactCookie2.default.load('DeliveryDate') === 'undefined' || _reactCookie2.default.load('DeliveryDate') === "" || _reactCookie2.default.load('DeliveryDate') === null) {
				var autoFillDate = defaultDate;
			} else {
				var cookieDate = _reactCookie2.default.load('DeliveryDate');
				var splitedDate = cookieDate.split('/');
				var selDate = _this.pad(splitedDate[0]);
				var selMonth = _this.pad(splitedDate[1]);
				var selYear = _this.pad(splitedDate[2]);
				autoFillDate = defaultDate;
			}
	
			_this.state = { date: autoFillDate, settings: [], selectTime: currentTime, selectMins: currentMins, minDatecount: 0, maxDayscount: 1, startTime: 0, endTime: 24, startMins: 0, endMins: 60, overWriteMins: 'No', overWriteTime: 'No', timeHtml: '', minsHtml: '', fianlstartTime: 0, serverTat: 14, timeExceed: 'No', windowHeight: 0, timeSlots: [], disableDate: [], ststrTimeArr: [], ststrSecndArr: [], stendTimeArr: [], stendSecndArr: [], intervalTime: 2, itsCurtDay: '', 'allowTimeSlot': 'No', 'hollidayList': [], allowHoliDay: 'No', 'timeandsecArrayset': [], TimeSlotHtmlVal: '', timeText: "Time (HH/MM)" };
			_this.changeTimer = _this.changeTimer.bind(_this); //changeMins
			_this.changeMins = _this.changeMins.bind(_this); //changeMins
			_this.getsettings();
	
			if (typeof _reactCookie2.default.load('UserId') === 'undefined') {
				var customerParam = "&reference_id=" + (0, _Api2.default)('referenceId');
			} else {
				var customerParam = "&customer_id=" + _reactCookie2.default.load('UserId');
			}
			var postalCodeWhere = "";
			if (typeof _reactCookie2.default.load("orderPostalCode") !== "undefined") {
				postalCodeWhere = '&postal_code=' + _reactCookie2.default.load("orderPostalCode");
			}
			_axios2.default.get(APIURL + 'cartver2/contents?status=A&app_id=' + APPID + customerParam + postalCodeWhere).then(function (res) {
				if (res.data.status === "ok") {
	
					if (typeof res.data.result_set !== "undefined") {
						Product_LeadTime = parseInt(res.data.result_set.product_lead_time);
						/*var productleadtime = parseInt(res.data.result_set.product_lead_time)-1;
	     if(productleadtime > 0){
	      min_datetime = new Date(new Date(datetime).setDate(currentDateValue+productleadtime));
	      this.setState({date:min_datetime})
	     }*/
					}
				}
			});
	
			return _this;
		}
	
		_createClass(DeliveryDatePickerNew, [{
			key: 'mainDateTimeFun',
			value: function mainDateTimeFun() {
				var _this2 = this;
	
				this.setState({ timeExceed: "No" });
	
				_axios2.default.get(APIURL + 'settings/deliverytime_slotminmax/?app_id=' + APPID + '&availability=' + _reactCookie2.default.load("defaultAvilablityId") + "&outlet_id=" + _reactCookie2.default.load('orderOutletId')).then(function (res) {
					if (res.data.status === "ok") {
	
						if (typeof res.data.result_set !== "undefined") {
							var itsCurtDy = 'no';
							var incr_minimum_days = res.data.result_set[0].minimum_date !== '' ? parseInt(res.data.result_set[0].minimum_date) : 0;
							var incr_days = Product_LeadTime > incr_minimum_days ? Product_LeadTime : incr_minimum_days;
							var incr_days_real = incr_days;
							var max_days = res.data.result_set[0].maximum_date !== '' ? parseInt(res.data.result_set[0].maximum_date) : 1;
							var cutOfftime = res.data.result_set[0].cut_off !== '' ? parseInt(res.data.result_set[0].cut_off) : 24;
	
							var str_datetime = new Date(new Date(datetime).setDate(currentDateValue + incr_days));
	
							var crtutc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
							var sltutc = str_datetime.toJSON().slice(0, 10).replace(/-/g, '/');
							if (crtutc === sltutc) {
								var currentTimeNew = dateFormat(new Date(), "H");
								if (parseInt(currentTimeNew) < parseInt(cutOfftime)) {
									itsCurtDy = 'yes';
								} else {
									incr_days = 1;
									str_datetime = new Date(new Date(datetime).setDate(currentDateValue + incr_days));
								}
							} else if (parseInt(incr_days) > 0) {
								var currentTimeLst = dateFormat(new Date(), "H");
								if (parseInt(currentTimeLst) >= parseInt(cutOfftime)) {
									incr_days = incr_days + 1;
									str_datetime = new Date(new Date(datetime).setDate(currentDateValue + incr_days));
								}
							}
	
							max_datetime = new Date(new Date(datetime).setDate(currentDateValue + incr_days + max_days));
							min_datetime = new Date(new Date(datetime).setDate(currentDateValue + (incr_days - 1)));
	
							_this2.setState({ cutOfftimeTxt: cutOfftime });
							_this2.setState({ maxDayscount: max_days });
							_this2.setState({ minDatecount: incr_days_real });
							_this2.setState({ date: str_datetime });
							_this2.setState({ itsCurtDay: itsCurtDy });
							var dayText = weekdayArr[str_datetime.getDay()];
							_this2.getTimesettingArrFun(dayText);
	
							setInterval(function () {
								var currentTimeNew = dateFormat(new Date(), "H");
								var currentMinsNew = dateFormat(new Date(), "MM");
								var tatvalnew = parseInt(this.state.serverTat);
								var dtnowobj = new Date();
								dtnowobj.setMinutes(dtnowobj.getMinutes() + tatvalnew);
								var currentTimetat = dtnowobj.getHours();
								var currentMinstat = dtnowobj.getMinutes();
								if (this.state.itsCurtDay === 'yes') {
									if (parseInt(currentTimeNew) >= parseInt(this.state.cutOfftimeTxt)) {
										this.mainDateTimeFun();
									}
	
									if (parseInt(this.state.selectTime) < parseInt(currentTimetat)) {
										this.timeDropDownFunction();
									} else if (parseInt(this.state.selectTime) === parseInt(currentTimetat) && parseInt(this.state.selectMins) < parseInt(currentMinstat)) {
										this.timeDropDownFunction();
									}
								}
							}.bind(_this2), 60000);
						} else {
							_this2.setState({ timeExceed: "Yes" });
						}
					} else {
						_this2.setState({ timeExceed: "Yes" });
					}
	
					$('.custom-date-label').removeClass("loader-main-cls");
					$('.custom-date-label').find(".loader-sub-div").remove();
				});
			}
		}, {
			key: 'showTimeslotExceed',
	
	
			/* Disaple year */
			value: function showTimeslotExceed() {
	
				if (this.state.timeExceed === "Yes") {
					if (APPID === "97347EE4-2845-4011-BCE6-9C0B806DA437" && (_reactCookie2.default.load('defaultAvilablityId') === "634E6FA8-8DAF-4046-A494-FFC1FCF8BD11" || _reactCookie2.default.load('defaultAvilablityId') === "718B1A92-5EBB-4F25-B24D-3067606F67F0")) {
						if (_reactCookie2.default.load('defaultAvilablityId') === "634E6FA8-8DAF-4046-A494-FFC1FCF8BD11") {
							return _react2.default.createElement(
								'div',
								{ className: 'timeslot_exc' },
								'Delivery available only on Saturdays (12- 4) pm'
							);
						} else if (_reactCookie2.default.load('defaultAvilablityId') === "718B1A92-5EBB-4F25-B24D-3067606F67F0") {
							return _react2.default.createElement(
								'div',
								{ className: 'timeslot_exc' },
								'Takeaway available only on Saturdays (9 am to 2pm)'
							);
						}
					} else if (APPID === "729A09D6-2A38-4E1C-ADB1-67A9242D2158" && (_reactCookie2.default.load('defaultAvilablityId') === "634E6FA8-8DAF-4046-A494-FFC1FCF8BD11" || _reactCookie2.default.load('defaultAvilablityId') === "718B1A92-5EBB-4F25-B24D-3067606F67F0")) {
						if (_reactCookie2.default.load('defaultAvilablityId') === "634E6FA8-8DAF-4046-A494-FFC1FCF8BD11") {
							return _react2.default.createElement(
								'div',
								{ className: 'timeslot_exc' },
								'Delivery available only on Fri, Sat & Sun'
							);
						} else if (_reactCookie2.default.load('defaultAvilablityId') === "718B1A92-5EBB-4F25-B24D-3067606F67F0") {
							return _react2.default.createElement(
								'div',
								{ className: 'timeslot_exc' },
								'Pickup available only on Fri, Sat & Sun'
							);
						}
					} else {
						return _react2.default.createElement(
							'div',
							{ className: 'timeslot_exc' },
							' Note: Please refer our operating hours. The time you are selecting is outside of our delivery timing. Apologies for the inconvenience.'
						);
					}
				}
			}
		}, {
			key: 'getTimesettingArrFun',
			value: function getTimesettingArrFun(daytxt) {
				var _this3 = this;
	
				_axios2.default.get(APIURL + 'settings/delivery_time_slot/?app_id=' + APPID + '&availability=' + _reactCookie2.default.load("defaultAvilablityId") + "&outlet_id=" + _reactCookie2.default.load('orderOutletId') + '&daytxt=' + daytxt).then(function (tmres) {
					if (tmres.data.status === "ok") {
						_this3.setState({ timeExceed: "No" });
						_this3.setState({ intervalTime: tmres.data.result_set[0].interval_time });
						_this3.setState({ timeandsecArrayset: tmres.data.result_set[0].slot });
						_this3.timeDropDownFunction();
					} else {
						_this3.setState({ intervalTime: 2 });
						_this3.setState({ timeandsecArrayset: [] });
						_this3.setState({ timeHtml: '' });
						_this3.setState({ minsHtml: '' });
						_this3.setState({ timeExceed: "Yes" });
					}
				});
			}
		}, {
			key: 'get_strtatadded_timeArr',
			value: function get_strtatadded_timeArr(startTimeVal, startMinitVal, endTimeVal, endMinitVal) {
				var result_Arr = [],
				    strtimetxt = '',
				    endtimetxtval = '';
				var currentTimeNew = dateFormat(new Date(), "H");
				var currentMinsNew = dateFormat(new Date(), "MM");
				var tatvalnew = parseInt(this.state.serverTat);
				var dtnowobj = new Date();
				dtnowobj.setMinutes(dtnowobj.getMinutes() + tatvalnew);
				var currentTimetat = dtnowobj.getHours();
				var currentMinstat = dtnowobj.getMinutes();
	
				if (this.state.itsCurtDay === 'yes') {
	
					if (parseInt(startTimeVal) <= parseInt(currentTimetat)) {
						if (parseInt(startTimeVal) === parseInt(endTimeVal) && parseInt(currentTimetat) === parseInt(endTimeVal) && parseInt(endMinitVal) < parseInt(currentMinstat)) {
							strtimetxt = '';
						} else {
							strtimetxt = currentTimetat;
						}
					} else {
						strtimetxt = startTimeVal;
					}
				} else if (startTimeVal !== null) {
	
					strtimetxt = startTimeVal;
				}
	
				if (this.state.itsCurtDay === 'yes') {
					if (parseInt(endTimeVal) <= parseInt(currentTimetat)) {
						if (parseInt(endTimeVal) === parseInt(currentTimetat) && parseInt(endMinitVal) >= parseInt(currentMinstat)) {
							endtimetxtval = endTimeVal;
						} else {
							endtimetxtval = parseInt(endTimeVal) > 0 ? parseInt(endTimeVal) - 1 : 0;
						}
					} else {
						endtimetxtval = endTimeVal;
					}
				} else if (endTimeVal !== null) {
					endtimetxtval = endTimeVal;
				}
	
				result_Arr['strtimetxt'] = strtimetxt;
				result_Arr['endtimetxtval'] = endtimetxtval;
				return result_Arr;
			}
		}, {
			key: 'get_strtatadded_minitArr',
			value: function get_strtatadded_minitArr(startTimeVal, startMinitVal) {
	
				var result_Arr = [],
				    strminittxt = '';
				var currentTimeNew = dateFormat(new Date(), "H");
				var currentMinsNew = dateFormat(new Date(), "MM");
				var tatvalnew = parseInt(this.state.serverTat);
				var dtnowobj = new Date();
				dtnowobj.setMinutes(dtnowobj.getMinutes() + tatvalnew);
				var currentTimetat = dtnowobj.getHours();
				var currentMinstat = dtnowobj.getMinutes();
	
				if (this.state.itsCurtDay === 'yes') {
					if (parseInt(startTimeVal) === parseInt(currentTimetat)) {
						if (parseInt(startMinitVal) <= parseInt(currentMinstat)) {
							strminittxt = currentMinstat;
						} else {
							strminittxt = startMinitVal;
						}
					} else {
						strminittxt = startMinitVal;
					}
				} else if (startTimeVal !== null && startMinitVal !== null) {
	
					strminittxt = startMinitVal;
				}
	
				result_Arr['strminittxt'] = strminittxt;
				return result_Arr;
			}
		}, {
			key: 'timeDropDownFunction',
			value: function timeDropDownFunction() {
	
				var TimeHtml = '';
				var tatval = parseInt(this.state.serverTat);
				var TimeandsecArr = this.state.timeandsecArrayset;
				var j = 0,
				    checkTimeArr = [],
				    strTimeArr = [],
				    endTimeArr = [],
				    strSecndArr = [],
				    endSecndArr = [];
				var changeTmtxt = '';
				for (var i = 0; i < TimeandsecArr.length; i++) {
	
					var strArr = TimeandsecArr[i].slot_time1 !== '' ? TimeandsecArr[i].slot_time1.split(':') : [];
					var startTimeVal = strArr.length > 0 ? strArr[0] : '';
					var startMinitVal = strArr.length > 0 ? strArr[1] : '';
	
					/* if(this.state.itsCurtDay === 'yes') { */
					var strdatevalobj = new Date();
					strdatevalobj.setHours(startTimeVal);
					var stringrMinits = parseInt(startMinitVal) + parseInt(tatval);
					strdatevalobj.setMinutes(stringrMinits);
					startTimeVal = strdatevalobj.getHours();
					startMinitVal = strdatevalobj.getMinutes();
					/* } */
	
					if (strArr.length > 0) {
						strTimeArr.push(startTimeVal);
						strSecndArr.push(startMinitVal);
					}
	
					var endArr = TimeandsecArr[i].slot_time2 !== '' ? TimeandsecArr[i].slot_time2.split(':') : [];
					var endTimeVal = endArr.length > 0 ? endArr[0] : '';
					var endMinitVal = endArr.length > 0 ? endArr[1] : '';
	
					/* if(this.state.itsCurtDay === 'yes') { */
					var enddatevalobj = new Date();
					enddatevalobj.setHours(endTimeVal);
					var ingrendMinits = parseInt(endMinitVal) + parseInt(tatval);
					enddatevalobj.setMinutes(ingrendMinits);
	
					var mnthvaltxt = enddatevalobj.getMonth() + 1;
					var sltutcnew = this.pad(enddatevalobj.getFullYear()) + '/' + this.pad(mnthvaltxt) + '/' + this.pad(enddatevalobj.getDate());
					var crtutcnew = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
	
					if (sltutcnew === crtutcnew) {
						endTimeVal = enddatevalobj.getHours();
						endMinitVal = enddatevalobj.getMinutes();
					} else {
						endTimeVal = 23;
						endMinitVal = 60;
					}
					/* } */
	
					if (endArr.length > 0) {
						endTimeArr.push(endTimeVal);
						endSecndArr.push(endMinitVal);
					}
	
					if (startTimeVal !== '' && endTimeVal !== '') {
						var getStrTatHr = this.get_strtatadded_timeArr(startTimeVal, startMinitVal, endTimeVal, endMinitVal);
						if (getStrTatHr['strtimetxt'] !== '') {
							startTimeVal = getStrTatHr['strtimetxt'];
							startTimeVal = parseInt(startTimeVal);
							endTimeVal = getStrTatHr['endtimetxtval'];
							endTimeVal = parseInt(endTimeVal);
							for (var valueTime = startTimeVal; valueTime <= endTimeVal; valueTime++) {
								valueTime = parseInt(valueTime);
								if (j === 0) {
									changeTmtxt = startTimeVal;
									this.setState({ selectTime: startTimeVal });
									this.setState({ selectMins: startMinitVal });
								}
	
								if (checkTimeArr.indexOf(valueTime) === -1) {
									checkTimeArr.push(valueTime);
									TimeHtml += "<option value='" + this.padnewone(valueTime) + "'  >" + this.padnewone(valueTime) + "</option>";
								}
								j++;
							}
						}
					}
				}
	
				var timeDropDown = htmlToReactParser.parse(TimeHtml);
	
				this.setState({ timeHtml: timeDropDown });
				this.setState({ ststrTimeArr: strTimeArr });
				this.setState({ ststrSecndArr: strSecndArr });
				this.setState({ stendTimeArr: endTimeArr });
				this.setState({ stendSecndArr: endSecndArr });
				this.minsDropDownFunction(changeTmtxt);
				if (changeTmtxt === '' && TimeHtml === '') {
					this.setState({ timeExceed: "Yes" });
				}
			}
		}, {
			key: 'minsDropDownFunction',
			value: function minsDropDownFunction(chngTmtxt) {
				var ststrTimeArrtxt = this.state.ststrTimeArr;
				var stendTimeArrtxt = this.state.stendTimeArr;
				var ststrSecndArrtxt = this.state.ststrSecndArr;
				var stendSecndArrtxt = this.state.stendSecndArr;
				var intervalTimetxt = this.state.intervalTime;
				var tatval = parseInt(this.state.serverTat);
				var scltdTime = chngTmtxt,
				    htmlMins = '',
				    checkMinsArr = [];
				var k = 0;
				for (var i = 0; i < ststrTimeArrtxt.length; i++) {
					if (parseInt(ststrTimeArrtxt[i]) === parseInt(scltdTime)) {
						var strsecnd = ststrSecndArrtxt[i];
						var endsecnd = parseInt(stendTimeArrtxt[i]) === parseInt(scltdTime) ? stendSecndArrtxt[i] : '60';
						var getStrTatHr = this.get_strtatadded_minitArr(scltdTime, strsecnd);
						strsecnd = getStrTatHr['strminittxt'];
						strsecnd = parseInt(strsecnd);endsecnd = parseInt(endsecnd);
						for (var valuemins = strsecnd; valuemins <= endsecnd; valuemins++) {
							valuemins = parseInt(valuemins);
							if ((valuemins === strsecnd || valuemins === endsecnd || valuemins % parseInt(intervalTimetxt) === 0) && checkMinsArr.indexOf(valuemins) === -1 && valuemins !== 60) {
								if (k === 0) {
									this.setState({ selectMins: valuemins });
								}
								checkMinsArr.push(valuemins);
								htmlMins += "<option value='" + this.pad(valuemins) + "'  >" + this.pad(valuemins) + "</option>";
								k++;
							}
						}
						if (endsecnd >= 59) {
							break;
						}
					} else if (parseInt(stendTimeArrtxt[i]) === parseInt(scltdTime)) {
						var strsecnd = '00';
						var endsecnd = stendSecndArrtxt[i];
						var getStrTatHr = this.get_strtatadded_minitArr(scltdTime, strsecnd);
						strsecnd = getStrTatHr['strminittxt'];
						strsecnd = parseInt(strsecnd);endsecnd = parseInt(endsecnd);
						for (var _valuemins = strsecnd; _valuemins <= endsecnd; _valuemins++) {
							_valuemins = parseInt(_valuemins);
							if ((_valuemins === strsecnd || _valuemins === endsecnd || _valuemins % parseInt(intervalTimetxt) === 0) && checkMinsArr.indexOf(_valuemins) === -1 && _valuemins !== 60) {
								if (k === 0) {
									this.setState({ selectMins: _valuemins });
								}
								checkMinsArr.push(_valuemins);
								htmlMins += "<option value='" + this.pad(_valuemins) + "'  >" + this.pad(_valuemins) + "</option>";
								k++;
							}
						}
					}
				}
				if (htmlMins === '' && ststrTimeArrtxt.length > 0 && scltdTime !== '') {
					var strsecnd = '00';
					var endsecnd = '60';
					var getStrTatHr = this.get_strtatadded_minitArr(scltdTime, strsecnd);
					strsecnd = getStrTatHr['strminittxt'];
					strsecnd = parseInt(strsecnd);endsecnd = parseInt(endsecnd);
					for (var _valuemins2 = strsecnd; _valuemins2 <= endsecnd; _valuemins2++) {
						_valuemins2 = parseInt(_valuemins2);
						if ((_valuemins2 === strsecnd || _valuemins2 === endsecnd || _valuemins2 % parseInt(intervalTimetxt) === 0) && checkMinsArr.indexOf(_valuemins2) === -1 && _valuemins2 !== 60) {
							if (k === 0) {
								this.setState({ selectMins: _valuemins2 });
							}
							checkMinsArr.push(_valuemins2);
							htmlMins += "<option value='" + this.pad(_valuemins2) + "'  >" + this.pad(_valuemins2) + "</option>";
							k++;
						}
					}
				}
	
				var minsDropDown = htmlToReactParser.parse(htmlMins);
				this.setState({ minsHtml: minsDropDown });
			}
		}, {
			key: 'getsettings',
			value: function getsettings() {
				var _this4 = this;
	
				var promise = helper.getProSettings('', 'No'); //getResult('settings','');
				promise.then(function (res) {
					if (res.data.result_set.client_advanced_timeslot_enable === "1") {
						_reactRouter.hashHistory.push("/delivery-date-advanced");
					}
					_this4.setState({ settings: res.data.result_set });
	
					/* find current tat value */
					_axios2.default.get(APIURL + 'outlets/gettat_details?app_id=' + APPID + "&availability_id=" + _reactCookie2.default.load('defaultAvilablityId') + "&outlet_id=" + _reactCookie2.default.load('orderOutletId')).then(function (res) {
						if (res.data.status === "ok") {
	
							if (res.data.result_set !== '' && res.data.result_set !== null) {
								_reactCookie2.default.save('orderTat', res.data.tat);
								_this4.setState({ serverTat: res.data.tat });
							}
							_this4.mainDateTimeFun();
						} else {
							helper.showInfo('Your selected outlet currently closed or disabled by an administrator. Please choose another outlet.');
							_reactRouter.hashHistory.push("/");
						}
					});
					/* find current tat value - End  */
	
					/* Holiday  - start */
					var DisableDats = [];
					if (parseInt(res.data.result_set.client_holiday_enable) === 1 && _reactCookie2.default.load('defaultAvilablityId') !== config.ids.dineinId) {
						_axios2.default.get(APIURLPRO + 'settings/get_holidaylist?app_id=' + APPID + "&availability=" + _reactCookie2.default.load('defaultAvilablityId') + "&outlet_id=" + _reactCookie2.default.load('orderOutletId')).then(function (res) {
							if (res.data.status === "ok") {
								var resultData = res.data.result_set;
	
								resultData.map(function (loadData) {
									return DisableDats.push(_this4.parseDate(loadData.date));
								});
	
								_this4.setState({ hollidayList: resultData, allowHoliDay: 'Yes', disableDate: DisableDats });
							}
						});
					}
					/* Holiday - end */
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				(0, _withTracker.loadAnalytics)();
				var windowHeight = window.innerHeight;
				this.setState({ 'windowHeight': windowHeight - 45 + 'px' });
	
				var des = document.getElementsByClassName('deliverydate');
				var fc = des[0].getElementsByTagName('div');
				var se = fc[0].getElementsByTagName('div');
				se[0].style.padding = '0px';
				var input = se[0].getElementsByTagName('input');
				input[0].style.borderBottom = '0px';
				var label = des[0].getElementsByTagName('label');
				label[0].style.top = '6px';
				//document.getElementsByClassName('rc-time-picker-input')[0].classList.add("form-control");
				$('.custom-date-label').addClass("loader-main-cls").append('<div class="loader-sub-div"></div>');
			}
		}, {
			key: 'onChange',
			value: function onChange(value) {
	
				var list = document.getElementsByClassName('form-group');
				var n;
				for (n = 0; n < list.length; ++n) {
					list[n].classList.remove("is-empty");
				}
			}
	
			/* this function used to load cart icon image */
	
		}, {
			key: 'loadCartImage',
			value: function loadCartImage() {
				return (0, _Api2.default)('cartImage', 'Yes');
			}
	
			/* store unit no's */
	
		}, {
			key: 'stroteUnitNoOne',
			value: function stroteUnitNoOne(event) {
				_reactCookie2.default.save('unitNoOne', event.target.value);
			}
	
			/* store unit no's */
	
		}, {
			key: 'stroteUnitNoTwo',
			value: function stroteUnitNoTwo(event) {
				_reactCookie2.default.save('unitNoTwo', event.target.value);
			}
	
			/* store unit no's */
	
		}, {
			key: 'strotetowerNo',
			value: function strotetowerNo(event) {
				_reactCookie2.default.save('towerNo', event.target.value);
			}
	
			/* validate delivery date */
	
		}, {
			key: 'checkDeliveryDate',
			value: function checkDeliveryDate(holidayData) {
				this.loadTimeDropDown('', '');
				var seldate = document.getElementsByClassName('deliverydate')[0].getElementsByTagName('input')[0].value;
	
				if (this.state.allowTimeSlot === "Yes") {
					/* for timeslot */
					var selMins = "";
					var selTime = "";
					var Timeslot = document.getElementById('timeSlot').value;
				} else {
					/* For TAT */
					selTime = document.getElementById('deliveryTime').value;
					selMins = document.getElementById('deliveryMins').value;
					Timeslot = "";
				}
	
				if (seldate !== "" && selMins !== "" && selTime !== "" || this.state.allowTimeSlot === "Yes" && Timeslot !== "") {
	
					_reactCookie2.default.save('DeliveryDate', seldate);
					if (this.state.allowTimeSlot === "Yes") {
						/* For timeslot */
	
						var splited = Timeslot.split("/");
						_reactCookie2.default.save('isSletedTimeSlot', "Yes");
						_reactCookie2.default.save('DeliveryTimeSlotFormated', splited[1]);
						_reactCookie2.default.save('DeliveryTimeSlot', splited[0]);
					} else {
						/* For TAT  */
						_reactCookie2.default.save('isSletedTimeSlot', "No");
						_reactCookie2.default.save('DeliveryTime', selTime + ":" + selMins);
					}
	
					/* start - holiday validation  */
					var holidayLen = holidayData.length;
					if (holidayLen > 0 && this.state.allowHoliDay === "Yes") {
						for (var hl = 0; hl < holidayLen; hl++) {
							if (seldate === dateFormat(holidayData[hl].date, "d/m/yyyy")) {
								helper.showInfo('The selected date is a holiday. Please select another day');
								return false;
							}
						}
					}
					/* End of holiday validation  */
	
					//Check unit number validation 
					if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId) {
						var AlertOne = document.getElementById('unitone').value;
						var AlertTwo = document.getElementById('unittwo').value;
						if (AlertOne === "" || AlertTwo === "") {
							var res = confirm('You did not enter a Floor No / Unit No. \n Do you want to continue');
							if (!res) {
								error = '1';
								return false;
							}
						}
					}
	
					var splitedDate = seldate.split('/');
					var OrderTime = splitedDate[2] + '-' + this.pad(splitedDate[1]) + '-' + this.pad(splitedDate[0]) + ' ' + selTime + ":" + selMins;
					var orderTAT = typeof _reactCookie2.default.load('orderTAT') === "undefined" ? '' : _reactCookie2.default.load('orderTAT');
					_axios2.default.get(APIURLPRO + 'ordersv1/validate_order_count?app_id=' + APPID + '&availability_id=' + _reactCookie2.default.load('defaultAvilablityId') + '&outlet_id=' + _reactCookie2.default.load('orderOutletId') + '&order_date=' + OrderTime + '&order_tat_time=' + orderTAT).then(function (res) {
						if (res.data.status === "ok") {
							_reactRouter.hashHistory.push("/checkout");
						} else {
							helper.showInfo(res.data.message);
						}
					});
				} else {
					helper.showInfo(lang.choose_delvery_date_error);
				}
			}
		}, {
			key: 'changeTimer',
			value: function changeTimer(e) {
	
				var seletedTime = e.target.value;
				this.setState({ selectTime: seletedTime });
				this.minsDropDownFunction(seletedTime);
			}
	
			/* chnage minutes */
	
		}, {
			key: 'changeMins',
			value: function changeMins(e) {
				this.setState({ selectMins: e.target.value });
			}
	
			/* set default Avilablity */
	
		}, {
			key: 'loadTimeDropDown',
			value: function loadTimeDropDown() {
				var day = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
				var mins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
				var triggerTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
			}
	
			/* add zero */
	
		}, {
			key: 'pad',
			value: function pad(d) {
				return d < 10 ? '0' + d.toString() : d.toString();
			}
	
			/* add zero */
	
		}, {
			key: 'padnewone',
			value: function padnewone(d) {
				var dd = parseInt(d);
				return dd < 10 ? '0' + dd.toString() : dd.toString();
			}
	
			/* maek round of */
	
		}, {
			key: 'makeround',
			value: function makeround(value) {
				var returnValue = 0;
				if (value > 0 && value <= 15) {
					returnValue = 15;
				} else if (value >= 16 && value <= 30) {
					returnValue = 30;
				} else if (value >= 31 && value <= 45) {
					returnValue = 45;
				}
	
				return returnValue;
			}
	
			/* format date'es */
	
		}, {
			key: 'parseDate',
			value: function parseDate(input) {
				var parts = input.match(/(\d+)/g);
				return new Date(parts[0], parts[1] - 1, parts[2]); // months are 0-based
			}
	
			/*show outlet text for workspace */
	
		}, {
			key: 'outletNameText',
			value: function outletNameText() {
				if (apps.workspace === APPID) {
					return htmlToReactParser.parse("Workspace Espresso Bar <br/> 12 Marina Boulevard<br/> Marina Bay Financial Centre Tower 3<br/> #01-08 Singapore 018982");
				} else {
	
					/*return (cookie.load('defaultAvilablityId') === config.ids.deliveryId? cookie.load('orderDeliveryAddress'): cookie.load('orderHandled') );*/
					return _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId ? _reactCookie2.default.load('orderDeliveryAddress') + ", Singapore " + _reactCookie2.default.load('orderPostalCode') : _reactCookie2.default.load('orderHandled');
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var morganfield_message = "Please allow an additional grace period of +/- 30 minutes from your preferred delivery time slot due to unforeseen weather and traffic conditions.";
				return _react2.default.createElement(
					'div',
					null,
					' ',
					_react2.default.createElement(_reactDocumentMeta2.default, meta),
					_react2.default.createElement(
						'div',
						{ className: 'container-fluid desktop-container', style: { minHeight: this.state.windowHeight } },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-xs-12 top-nav inner-top-nav head-main' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-3 nav-head pd-l-20  head-child' },
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: "/cart" },
										_react2.default.createElement('img', { src: '/img/icons/arrow-right.png', alt: 'left-arrow', className: 'icon-img-small-3' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-6 nav-head head-child' },
									_react2.default.createElement(
										'h1',
										{ className: 'main-title' },
										_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId ? "Delivery" : "PICKUP"
									)
								),
								_react2.default.createElement('div', { className: 'col-xs-3 nopadding head-child' })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-lg-12 calender-area' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 calender-area-sub' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-offset-2 col-xs-8 cal-div' },
										_react2.default.createElement(
											'h1',
											{ className: 'sub-heading', style: { textAlign: 'center' } },
											_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId ? "SELECT YOUR DELIVERY DATE AND TIME" : "SELECT YOUR PICKUP DATE AND TIME"
										),
										_react2.default.createElement(
											'div',
											{ className: 'form-group label-floating is-empty card-no custom-date-label' },
											_react2.default.createElement(
												'div',
												{ className: 'input-group deliverydate' },
												_react2.default.createElement(
													_ThemeProvider2.default,
													{ theme: _theme2.default },
													_react2.default.createElement(_DatePicker2.default, { label: 'Date (DD/MM/YYYY)',
														readonly: readOnly,
														inputFormat: function inputFormat(value) {
															return value.getDate() + '/' + (value.getMonth() + 1) + '/' + value.getFullYear();
														},
														minDate: min_datetime,
														maxDate: max_datetime,
														sundayFirstDayOfWeek: true,
														onChange: this.handleChange.bind(this, 'date'),
														className: 'delivery_datepiker',
														disabledDates: this.state.disableDate,
	
														value: this.state.date })
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'form-group label-floating is-empty card-no custom-time-label min-hgt-hour-t' },
											_react2.default.createElement(
												'div',
												{ className: 'input-group' },
												_react2.default.createElement(
													'label',
													{ className: 'control-label' },
													this.state.timeText
												),
												_react2.default.createElement(
													'select',
													{ className: disabledClass + ' customdd', value: this.state.selectTime, onChange: this.changeTimer, id: 'deliveryTime' },
													this.state.timeHtml
												),
												' /',
												_react2.default.createElement(
													'select',
													{ id: 'deliveryMins', className: disabledClassMins + " " + disabledClass + ' customdd', value: this.state.selectMins, onChange: this.changeMins },
													this.state.minsHtml
												)
											)
										),
										this.showTimeslotExceed(),
										_react2.default.createElement(
											'div',
											{ className: 'all-time-text' },
											APPID == 'CD9D3E7B-C4E4-4FF0-B751-A7FE97524F53' && _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && (0, _moment2.default)(this.state.date).format('YYYY-M-D') == (0, _moment2.default)(new Date()).format('YYYY-M-D') ? morganfield_message : ''
										),
										_react2.default.createElement('div', { className: 'space-35' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 calender-area-sub-2' },
									_react2.default.createElement(
										'h1',
										{ className: 'sub-heading', style: { textAlign: 'center' } },
										_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId ? "DELIVER TO" : "PICKUP AT"
									),
									_react2.default.createElement(
										'h1',
										{ className: 'sub-heading-2', style: { textAlign: 'center' } },
										this.outletNameText()
									),
									_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId ? _react2.default.createElement(
										'div',
										{ className: 'col-xs-12 unit-no-div' },
										_react2.default.createElement(
											'div',
											{ className: 'form-group col-sm-4 col-xs-12 no-margin' },
											_react2.default.createElement(
												'div',
												{ className: 'form-group label-floating is-empty card-no' },
												_react2.default.createElement(
													'div',
													{ className: 'input-group' },
													_react2.default.createElement(
														'label',
														{ className: 'control-label' },
														'Building Name/ Tower'
													),
													_react2.default.createElement('input', { type: 'text', id: 'towerno', className: 'form-control', onChange: this.strotetowerNo })
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'form-group col-sm-4 col-xs-12 no-margin' },
											_react2.default.createElement(
												'div',
												{ className: 'form-group label-floating is-empty card-no' },
												_react2.default.createElement(
													'div',
													{ className: 'input-group' },
													_react2.default.createElement(
														'label',
														{ className: 'control-label' },
														'Floor No'
													),
													_react2.default.createElement('input', { type: 'text', id: 'unitone', className: 'form-control', onChange: this.stroteUnitNoOne })
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'form-group col-sm-4 col-xs-12 no-margin' },
											_react2.default.createElement(
												'div',
												{ className: 'form-group label-floating is-empty card-no' },
												_react2.default.createElement(
													'div',
													{ className: 'input-group' },
													_react2.default.createElement(
														'label',
														{ className: 'control-label' },
														'Unit No'
													),
													_react2.default.createElement('input', { type: 'text', id: 'unittwo', className: 'form-control', onChange: this.stroteUnitNoTwo })
												)
											),
											_react2.default.createElement('br', null)
										),
										_react2.default.createElement('div', { className: 'clearfix' })
									) : _react2.default.createElement('div', { className: 'space-30' })
								),
								_react2.default.createElement('div', { className: 'space-30' })
							)
						),
						_react2.default.createElement('div', { className: 'space-30' }),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ onClick: this.checkDeliveryDate.bind(this, this.state.hollidayList) },
								_react2.default.createElement(
									'button',
									{ className: 'col-lg-12 continue-but desktop-container container-fluid' },
									'Continue'
								)
							)
						)
					)
				);
			}
		}]);
	
		return DeliveryDatePickerNew;
	}(_react2.default.Component);
	
	exports.default = DeliveryDatePickerNew;

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(9);
	
	var _immutabilityHelper = __webpack_require__(56);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _validator = __webpack_require__(88);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _reactCustomValidation = __webpack_require__(57);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var config = __webpack_require__(7);
	var Loading = __webpack_require__(17);
	var lang = __webpack_require__(12);
	var Alert = __webpack_require__(48);
	//const APIURL = config.path.apiUrl;
	var APIURLPRO = config.path.apiUrlPro;
	var APPID = config.ids.appId;
	
	var helper = __webpack_require__(13);
	var initialState = {
	  fields: {
	    email: '',
	    status: 'Loading',
	    settings: []
	  }
	};
	
	/* Load meta tags */
	var meta = {
	  title: lang.forgotpassword_meta_title,
	  description: lang.forgotpassword_meta_title,
	  meta: {
	    name: {
	      keywords: lang.forgotpassword_meta_title
	    }
	  }
	};
	
	var Forgotpassword = function (_React$Component) {
	  _inherits(Forgotpassword, _React$Component);
	
	  function Forgotpassword() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Forgotpassword);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Forgotpassword.__proto__ || Object.getPrototypeOf(Forgotpassword)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {
	        email: '',
	        status: 'Loading'
	      }
	    }, _this.fieldChange = function (field, value) {
	      _this.setState((0, _immutabilityHelper2.default)(_this.state, { fields: _defineProperty({}, field, { $set: value }) }));
	    }, _this.handleFormSubmit = function () {
	
	      var formPayload = _this.state.fields;
	
	      var qs = __webpack_require__(3);
	      var postObject = {
	        "app_id": APPID,
	        "type": "web",
	        "email_address": formPayload.email,
	        "site_url": _this.state.settings.client_site_url + "#/"
	      };
	      _this.setStateLoading('Loading');
	      document.getElementById("loadIcon").style.display = "block";
	      _axios2.default.post(APIURLPRO + "customer/forgot_password", qs.stringify(postObject)).then(function (response) {
	        document.getElementById("loadIcon").style.display = "none";
	        if (response.data.status === "ok") {
	          _this.setStateLoading('ok');
	          //document.getElementById("form-msg").innerHTML='<div class="alert-box" id="AlertBox" style="display: block;"><p class="success-msg alert-msg">An email has been sent to your mail with reset password link<a class="close-icon"><i class="fa fa-times-circle-o" aria-hidden="true"></i></a></p></div>';
	          //cookie.save('alertSuccess','An email has been sent to your mail with reset password link');
	          //$("#Forgot-Success").modal("toggle");
	          helper.showInfo('An email address has been sent to your mail with reset password link.');
	          _this.setState(initialState);
	          var list = document.getElementsByClassName('spn-error');
	          var n;
	          for (n = 0; n < list.length; ++n) {
	            list[n].remove();
	          }
	          var list1 = document.getElementsByClassName('form-group');
	          var n1;
	          for (n1 = 0; n1 < list1.length; ++n1) {
	            list1[n1].classList.add("is-empty");
	          }
	        } else {
	          _this.setStateLoading('error');
	          //$("#Forgot-Error").modal("toggle");
	          //document.getElementById("form-msg").innerHTML='<div class="box_error"><ul><li>'+response.data.message+'</li></ul></div>';			
	          helper.showInfo(response.data.message);
	          var list1 = document.getElementsByClassName('form-group');
	          var n1;
	          for (n1 = 0; n1 < list1.length; ++n1) {
	            list1[n1].classList.remove("is-empty");
	          }
	        }
	        document.getElementById("loadIcon").style.display = "none";
	      }).catch(function (error) {
	        console.log(error);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Forgotpassword, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ status: 'ok' });
	
	      /*add class */
	      helper.addBodyClass();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      /* update settings values */
	      var promise = (0, _Api2.default)('settings', '');
	      promise.then(function (res) {
	        console.log(res.data.result_set);
	        _this2.setState({ settings: res.data.result_set });
	      });
	
	      (0, _withTracker.loadAnalytics)();
	    }
	  }, {
	    key: 'setStateLoading',
	    value: function setStateLoading(sts) {
	      this.setState({ status: sts });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(Form, {
	        fields: this.state.fields,
	        onChange: this.fieldChange,
	        onValid: this.handleFormSubmit,
	        onInvalid: function onInvalid() {
	          return console.log('Form invalid!');
	        }
	      });
	    }
	  }]);
	
	  return Forgotpassword;
	}(_react2.default.Component);
	
	var isEmpty = function isEmpty(value) {
	  return value === '' ? 'This field is required.' : null;
	};
	
	var isEmail = function isEmail(email) {
	  return _validator2.default.isEmail(email) ? null : 'This is not a valid email.';
	};
	
	function validationConfig(props) {
	  var email = props.fields.email;
	
	
	  return {
	    fields: ['email'],
	
	    validations: {
	      email: [[isEmpty, email], [isEmail, email]]
	    }
	  };
	}
	
	var Form = function (_React$Component2) {
	  _inherits(Form, _React$Component2);
	
	  function Form(props) {
	    _classCallCheck(this, Form);
	
	    /* Declare state */
	    var _this3 = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));
	
	    _this3.state = { windowHeightNormal: 0, windowHeight: 0 };
	    return _this3;
	  }
	
	  _createClass(Form, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var windowHeight = window.innerHeight;
	      this.setState({ 'windowHeight': windowHeight - 45 + 'px' });
	      this.setState({ 'windowHeightNormal': windowHeight + 'px' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          fields = _props.fields,
	          onChange = _props.onChange,
	          onValid = _props.onValid,
	          onInvalid = _props.onInvalid,
	          $field = _props.$field,
	          $validation = _props.$validation;
	
	      var errMsgEmail = void 0;
	      if ($validation.email.error.reason !== undefined) {
	        errMsgEmail = $validation.email.show && _react2.default.createElement(
	          'span',
	          { className: 'spn-error' },
	          $validation.email.error.reason
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        ' ',
	        _react2.default.createElement(_reactDocumentMeta2.default, meta),
	        _react2.default.createElement(Alert, null),
	        _react2.default.createElement(
	          'div',
	          { id: 'loadIcon', style: { display: 'none', bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto', zIndex: 99, background: 'rgba(255, 255, 255, 0.8)' } },
	          ' ',
	          _react2.default.createElement('img', { style: { bottom: 0, left: 0, position: 'absolute', right: 0, top: 0, margin: 'auto' }, src: '/img/loader.gif', alt: 'Loading' }),
	          ' '
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid desktop-container', style: { minHeight: this.state.windowHeightNormal } },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 main-title-bar' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: "/sign-in" },
	                ' ',
	                _react2.default.createElement('img', { src: '/img/left-arrow.png', className: 'pull-left icon-img-small', alt: 'left-arrow' }),
	                ' '
	              ),
	              _react2.default.createElement(
	                'h3',
	                { className: 'top-title main-title padding-right-20 text-uppercase' },
	                'forget password'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement('div', { className: 'space-10 bg-gray' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'white-outer center-block', id: 'forgotpassword-form' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-10 div-center' },
	              _react2.default.createElement('div', { className: 'space-20' }),
	              _react2.default.createElement(
	                'p',
	                { className: 'text-center font-bold font-size-18' },
	                'Enter Your Email Address'
	              ),
	              _react2.default.createElement('div', { id: 'form-msg' }),
	              _react2.default.createElement('div', { className: 'space-5' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group label-floating is-empty card-no' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'control-label', htmlFor: 'card' },
	                    'Email Address'
	                  ),
	                  _react2.default.createElement('input', Object.assign({ type: 'text', className: 'form-control', value: fields.email }, $field('email', function (e) {
	                    return onChange('email', e.target.value);
	                  }))),
	                  errMsgEmail
	                )
	              ),
	              _react2.default.createElement('div', { className: 'space-20' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center ' },
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', className: 'btn btn-raised btn-info full-width-btn text-uppercase', onClick: function onClick(e) {
	                      e.preventDefault();_this4.props.$submit(onValid, onInvalid);
	                    } },
	                  'send',
	                  _react2.default.createElement('div', { className: 'ripple-container' })
	                ),
	                _react2.default.createElement('br', null)
	              ),
	              _react2.default.createElement('div', { className: 'space-20' })
	            ),
	            _react2.default.createElement('div', { className: 'clearfix' })
	          ),
	          _react2.default.createElement('div', { className: 'space-30' }),
	          _react2.default.createElement('div', { className: 'space-30' }),
	          _react2.default.createElement('div', { className: 'space-10' }),
	          _react2.default.createElement('div', { className: 'space-30' }),
	          _react2.default.createElement('div', { className: 'space-30' }),
	          _react2.default.createElement('div', { className: 'space-30' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal', id: 'Forgot-Success' },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-dialog PopupWidth' },
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-content' },
	              _react2.default.createElement(
	                'div',
	                { className: 'modal-header' },
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
	                  _react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: '' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'modal-body text-center' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    'An email address has been sent to your mail with reset password link.'
	                  ),
	                  ' ',
	                  _react2.default.createElement('br', null),
	                  ' ',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null)
	                )
	              ),
	              _react2.default.createElement('div', { className: 'modal-footer' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal', id: 'Forgot-Error' },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-dialog PopupWidth' },
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-content' },
	              _react2.default.createElement(
	                'div',
	                { className: 'modal-header' },
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
	                  _react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: '' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'modal-body text-center' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    'An email address was not found in our records.'
	                  ),
	                  ' ',
	                  _react2.default.createElement('br', null),
	                  ' ',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null)
	                )
	              ),
	              _react2.default.createElement('div', { className: 'modal-footer' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Form;
	}(_react2.default.Component);
	
	Form = (0, _reactCustomValidation.validated)(validationConfig)(Form);
	
	exports.default = Forgotpassword;

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(9);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _ThemeProvider = __webpack_require__(84);
	
	var _ThemeProvider2 = _interopRequireDefault(_ThemeProvider);
	
	var _theme = __webpack_require__(89);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _Distancebar = __webpack_require__(102);
	
	var _Distancebar2 = _interopRequireDefault(_Distancebar);
	
	var _Outletclosedmessage = __webpack_require__(103);
	
	var _Outletclosedmessage2 = _interopRequireDefault(_Outletclosedmessage);
	
	var _reactGeolocated = __webpack_require__(179);
	
	__webpack_require__(71);
	
	var _DatePicker = __webpack_require__(85);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _rcTimePicker = __webpack_require__(114);
	
	var _rcTimePicker2 = _interopRequireDefault(_rcTimePicker);
	
	var _LocationSearchInput = __webpack_require__(129);
	
	var _LocationSearchInput2 = _interopRequireDefault(_LocationSearchInput);
	
	var _reactOutsideClickHandler = __webpack_require__(841);
	
	var _reactOutsideClickHandler2 = _interopRequireDefault(_reactOutsideClickHandler);
	
	var _constants = __webpack_require__(65);
	
	__webpack_require__(232);
	
	var _lodash = __webpack_require__(30);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _withTracker = __webpack_require__(11);
	
	__webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	/* global $, angular, React */
	
	
	var Loading = __webpack_require__(17);
	var Overlay = __webpack_require__(64);
	var config = __webpack_require__(7);
	var alerts = __webpack_require__(203);
	var Alert = __webpack_require__(48);
	var lang = __webpack_require__(12);
	var APIURL = config.path.apiUrl;
	var APIURLPRO = config.path.apiUrlPro;
	var APPID = config.ids.appId;
	var APIURLv2 = config.path.apiUrlv2;
	var helper = __webpack_require__(13);
	var HtmlToReactParser = __webpack_require__(21).Parser;
	
	var htmlToReactParser = new HtmlToReactParser();
	var Select = __webpack_require__(83);
	
	//import 'rc-time-picker/assets/index.css';
	var apps = __webpack_require__(29);
	var strp = __webpack_require__(31);
	var dateFormat = __webpack_require__(42);
	var datetime = new Date();
	var currentDateValue = datetime.getDate();
	
	var defaultDate = '';
	var defaultresTime = '';
	var min_datetime = new Date(new Date(datetime).setDate(currentDateValue - 1));
	var max_datetime = new Date(new Date(datetime).setDate(currentDateValue + 15));
	
	var monthNamesArr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	
	var dayNamesArr = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
	
	var timetxt = new Date();
	timetxt.setHours(17);
	timetxt.setMinutes(28);
	
	/* Load meta tags */
	var meta = {
		title: lang.home_meta_title,
		description: lang.home_meta_description,
		meta: {
			name: {
				keywords: lang.home_meta_keywords
			}
		}
	};
	
	var expires = new Date();
	/*expires.setMinutes(expires.getMinutes() + 1);*/
	expires.setDate(expires.getDate() + 1);
	
	var Product_LeadTime = 0;
	var TodayDate = new Date();
	var autoFillDate = TodayDate;
	var getDate_advanced = TodayDate.getDate();
	var min_datetime_advanced = new Date(new Date(TodayDate).setDate(getDate_advanced - 1));
	var max_datetime_advanced = new Date(new Date(TodayDate).setDate(getDate_advanced));
	var weekdayArr = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
	
	var Home = function (_React$Component) {
		_inherits(Home, _React$Component);
	
		function Home(props) {
			_classCallCheck(this, Home);
	
			//var reservationPersonMax = (APPID === 'DDAA254C-BD1E-49F0-AD1E-164A140421D3') ? 7 : 11;
	
			/* Declare state */
			var _this = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props));
	
			_this.handleChangeDatefun = function (item, value) {
				_this.setState({ resDate: value });
				_this.getReservationtime(_this.state.selectResOutlet, value);
			};
	
			_this.noofAdultsfun = function (itemvalue) {
				_this.setState({ noofAdults: itemvalue.target.value });
				_reactCookie2.default.save('reserVationClick', '');
			};
	
			_this.noofChildrenfun = function (itemvalue) {
				_this.setState({ noofChildren: itemvalue.target.value });
				_reactCookie2.default.save('reserVationClick', '');
			};
	
			_this.changeRemarkDes = function (itemvalue) {
				_this.setState({ resRemarkDes: itemvalue.target.value });
			};
	
			_this.handleChange_advanced = function (item, value) {
				if (item == "date") {
					_this.setState({ date_advanced: value, TimeSlotHtmlVal_advanced: "" }, function () {
						var selectDar = weekdayArr[value.getDay()];
						if (this.state.time_slot_type_advanced === "1") {
							this.timeDropDownFunction(selectDar);
						} else if (this.state.time_slot_type_advanced === "2") {
							this.loadTimeSlotDropDown(selectDar);
						}
					});
				} else {
					_this.setState({ date_advanced: value });
				}
			};
	
			_this.state = { closeNormalPopup: false, zoneOutletSeleted: "", zoneDeliveryOutlet: '', deliveryOutlets: [], zoneDetails: [], windowHeightNormal: 0, windowHeight: 0, searchHtml: '', secAddrData: [], addressField: '', Outlets: [], category: [], common: [], banner: [], bannercom: [], defaultAvilablity: config.ids.defaultAvilablityName, defaultAvilablityImage: "", navStatus: "Loading", openNav: 'side-l', rewadNav: 'collapsed', 'login': '', searchText: '', settings: [], options: [], showPromoPopup: "No", showNormalPopup: 'No', pageDesc: '', bannersource: '', noPagerClass: "", bxClass: '', onetimeclickstate: "No", reservationPersonMax: "", reservationChildMax: "", orderCount: 0, promotionCount: 0, enableAddressSearch: false, masterCardLogo: '', outletCloseddMessage: '', date_advanced: autoFillDate, selectTime_advanced: "", selectMins_advanced: "", disableDate_advanced: [], cutOfftime_advanced: "", intervalTime_advanced: "", min_datetime_advanced: min_datetime_advanced, max_datetime_advanced: max_datetime_advanced, timeText_advanced: "Time (HH/MM)", timeHtml_advanced: "", timeExceed_advanced: "No", time_slot_type_advanced: "1", TimeSlotHtmlVal_advanced: "", serverTat: "0", allowTimeSlot: 'No', hollidayList: [], manualLoading: false, outlet_max_pax_limit: 0, client_maintenance_mode: 0, client_maintanace_popup_hide: false, client_password_maintain: '', client_password_maintain_error: ''
			};
	
			if (_reactCookie2.default.load('reserVationClick') !== 'fromhome') {
				_reactCookie2.default.save('itsfromreservation', 'no');
			}
			_this.changeResOutlet = _this.changeResOutlet.bind(_this);
			_this.changeResTimeset = _this.changeResTimeset.bind(_this);
			_this.selectOutlet = _this.selectOutlet.bind(_this);
			_this.closeNornalPopup = _this.closeNornalPopup.bind(_this);
			_this.changeTimer = _this.changeTimer.bind(_this); //changeHrs
			_this.changeMins = _this.changeMins.bind(_this); //changeMins
			/* API CALL FOR PRODUCT MENU NAVIGATION */
			var promise = (0, _Api2.default)('settingsPro', 'No');
			promise.then(function (res) {
				_this.setState({ settings: res.data.result_set });
	
				var applyOutletIdtxt = res.data.result_set.ninja_outletbasedproduct_enable === '1' ? 'yes' : 'no';
	
				_reactCookie2.default.save('site_maintenance_popup_open', res.data.result_set.client_maintenance_mode, { path: "/" });
				var client_maintenance_mode_check = res.data.result_set.client_maintenance_mode === '1' ? '1' : '0';
				_this.setState({ client_maintenance_mode: client_maintenance_mode_check });
	
				_reactCookie2.default.save('dineinClick', 'no');
				_reactCookie2.default.save('applyOutletId', applyOutletIdtxt);
				_reactCookie2.default.save('siteURL', res.data.result_set.client_site_url);
	
				_reactCookie2.default.save('fb_pixel_id', res.data.result_set.ninja_pro_fb_pixel_id !== null ? res.data.result_set.ninja_pro_fb_pixel_id : "");
				_reactCookie2.default.save('ga_id', res.data.result_set.ninja_pro_google_ga_id !== null ? res.data.result_set.ninja_pro_google_ga_id : "");
				_reactCookie2.default.save('gtm_id', res.data.result_set.ninja_pro_google_gtm_id !== null ? res.data.result_set.ninja_pro_google_gtm_id : "");
				var avlId = res.data.result_set.ninja_pro_default_availability_id;
				var avlText = res.data.result_set.ninja_pro_default_availability_name === "Pickup" ? "Takeaway" : res.data.result_set.ninja_pro_default_availability_name;
				var avlImage = "/img/icons/" + res.data.result_set.ninja_pro_default_availability_id + ".svg";
	
				if (_reactCookie2.default.load('dineinFrom') === 'booktbl' || _reactCookie2.default.load('dineinFrom') === 'signin') {
					_reactCookie2.default.remove('defaultAvilablityId');
					_reactCookie2.default.remove('defaultAvilablity');
					_reactCookie2.default.remove('defaultAvilablityImage');
				}
				_reactCookie2.default.save('dineinFrom', 'homepage');
				_reactCookie2.default.save('navmenuClk', 'no');
				_reactCookie2.default.save('bckurlTxt', '');
	
				/*set default avilablity cookie value */
				helper.setDefaultAvailability(avlId, avlText, avlImage);
	
				/* set default values */
				_this.setState({ defaultAvilablity: avlText, defaultAvilablityName: avlText, defaultAvilablityImage: avlImage });
	
				/* load menu items */
				_this.loadMenuNavigation(_reactCookie2.default.load('defaultAvilablityId'), _reactCookie2.default.load('defaultAvilablity'), _reactCookie2.default.load('defaultAvilablityImage'), '');
	
				/* Check promo popup  - start */
				var showPrmoPopup = parseInt(res.data.result_set.client_promocode_options) === 1 ? "Yes" : "No";
				var showNormalPopup = parseInt(res.data.result_set.client_promo_code_normal_popup_enable) === 1 ? "Yes" : "No";
				_this.setState({ showPromoPopup: showPrmoPopup, showNormalPopup: showNormalPopup });
	
				/* Get normal popup content */
				if (_reactCookie2.default.load('NormalPopup') !== "Yes" && _this.state.showNormalPopup === "Yes") {
					var stsaicResult = helper.getStaticBlock('normal-popup');
					stsaicResult.then(function (stTes) {
						if (stTes.data.status === "ok") {
							_this.setState({ pageDesc: stTes.data.result_set[0].staticblocks_description });
						}
					});
				}
				/*  Get master card logo - End */
	
				/* Get normal popup content */
				var masterResult = helper.getStaticBlock('master-card-logo-popup');
				masterResult.then(function (stTes) {
					if (stTes.data.status === "ok") {
						_this.setState({ masterCardLogo: stTes.data.result_set[0].staticblocks_description });
					}
				});
	
				/* outlet closed messages  */
				var outResult = helper.getStaticBlock('outlet-closed-message');
				outResult.then(function (stTes) {
					if (stTes.data.status === "ok") {
						_this.setState({ outletCloseddMessage: stTes.data.result_set[0].staticblocks_description });
					}
				});
	
				/* get outlets lits */
				if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.pickupId && _reactCookie2.default.load('defaultAvilablity') === lang.takeaWay && typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderPostalCode') === "undefined") {
	
					_this.getpickupOutletlist();
				}
				/* get outlets lits - End*/
	
				/* get secondary address lits */
				if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "" && _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId) {
	
					if (typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderPostalCode') === "undefined") {
						_this.getSecAddr();
					}
				}
				/* get secondary address lits - end */
	
				/* JC */
				if (parseInt(res.data.result_set.client_outlet_zone) === 1) {
					_axios2.default.get(_constants.API_v4_URL + 'Getoutlets/getAllOutles/pickup_outlets?app_id=' + APPID + "&availability_id=" + config.ids.deliveryId).then(function (res) {
	
						if (res.data.status === "ok") {
							_this.setState({ deliveryOutlets: res.data.result_set });
						}
					});
				} /* JC*/
	
				if (parseInt(res.data.result_set.advanced_time_slot_reservation_enable) === 1) {
					_reactCookie2.default.save('advanced_time_slot_reservation_enable', "1");
				} else {
	
					_reactCookie2.default.save('advanced_time_slot_reservation_enable', "");
				}
			});
	
			return _this;
		}
	
		_createClass(Home, [{
			key: 'closeNornalPopup',
			value: function closeNornalPopup() {
				this.setState({ closeNormalPopup: true });
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.setState({ closeNormalPopup: false });
			}
			/* BX slider */
	
		}, {
			key: '__bxslider',
			value: function __bxslider() {
				console.log('bx loaded');
				var bxslider = $('.bxslider').bxSlider({
					infiniteLoop: true,
					auto: true,
					pause: 4000
				});
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				console.log(config.stripe.stripeCurrency);
				/* add class body tag */
	
				//  console.log('Will mount');
				var windowHeight = window.innerHeight;
				this.setState({ 'windowHeight': windowHeight - 45 + 'px' });
				this.setState({ 'windowHeightNormal': windowHeight + 'px' });
				//this.__bxslider();
	
				/* load banner */
				_axios2.default.get(APIURL + 'cms/banner?app_id=' + APPID).then(function (res) {
	
					if (res.data.status === "ok") {
						var sliderLen = res.data.result_set;
						var noPageClass = sliderLen.length === 1 ? "bx-slide-single" : "";
						var bxClass = sliderLen.length === 1 ? "" : "bxslider";
						//this.setState({ banner: res.data.result_set });	
						_this2.setState({ bxClass: bxClass, banner: res.data.result_set, bannersource: res.data.common.image_source, noPagerClass: noPageClass });
	
						// console.log('loaded');
						//this.setState({ navStatus: res.data.status });
						//this.__bxslider();
	
					}
				});
	
				this.berforeopenReserVtnPopup();
	
				if (typeof _reactCookie2.default.load('onetimeClick') === "undefined") {
					this.setState({ onetimeclickstate: 'Yes' });
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this3 = this;
	
				_reactCookie2.default.save('reserVationClick', '');
				if (_reactCookie2.default.load("open_reservation") !== "" && _typeof(_reactCookie2.default.load("open_reservation")) !== undefined && _reactCookie2.default.load("open_reservation") !== "undefined" && _reactCookie2.default.load("open_reservation") !== undefined) {
					_reactCookie2.default.remove("open_reservation");
					var current = this;
					setTimeout(function () {
						current.changeAvilablityTemp(config.ids.reservationId, lang.reservation, lang.reservationImageWhite);
					}, 2500);
				}
				//  console.log('did mount');
				// this.__bxslider();
	
				/* orders count */
				if (typeof _reactCookie2.default.load('UserId') !== "undefined" || _reactCookie2.default.load('UserId') && _reactCookie2.default.load('UserId') !== "") {
					var qs = __webpack_require__(3);
					var inputKeys = ["promotion", "order_all"];
	
					var postObject = { "app_id": APPID, "customer_id": _reactCookie2.default.load('UserId'), "availability_id": _reactCookie2.default.load('defaultAvilablityId'), act_arr: JSON.stringify(inputKeys) };
					_axios2.default.post(APIURL + "reports/activity_counts", qs.stringify(postObject)).then(function (response) {
						if (response.data.status === "ok") {
							var resultData = response.data;
							_this3.setState({ orderCount: resultData.count.order_all, promotionCount: resultData.count.promotion });
						}
					}).catch(function (error) {
						console.log(error);
					});
					/* oreders count */
				}
	
				(0, _withTracker.loadAnalytics)();
				setTimeout(function () {
					if (APPID == '76DABFCC-0A47-40C7-8588-E3C32F87B3C8') {
						var options = {
							whatsapp: this.state.settings.ninja_pro_phone_number, // WhatsApp number
							call_to_action: "Message us", // Call to action
							position: "right" // Position may be 'right' or 'left'
						};
						var proto = document.location.protocol,
						    host = "getbutton.io",
						    url = proto + "//static." + host;
						var s = document.createElement('script');s.type = 'text/javascript';s.async = true;s.src = url + '/widget-send-button/js/init.js';
						s.onload = function () {
							WhWidgetSendButton.init(host, proto, options);
						};
						var x = document.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);
					}
					if (APPID == 'CD9D3E7B-C4E4-4FF0-B751-A7FE97524F53') {
						var options = {
							whatsapp: this.state.settings.ninja_pro_phone_number, // WhatsApp number
							call_to_action: "Message us", // Call to action
							position: "right" // Position may be 'right' or 'left'
						};
						var proto = document.location.protocol,
						    host = "getbutton.io",
						    url = proto + "//static." + host;
						var s = document.createElement('script');s.type = 'text/javascript';s.async = true;s.src = url + '/widget-send-button/js/init.js';
						s.onload = function () {
							WhWidgetSendButton.init(host, proto, options);
						};
						var x = document.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);
					}
				}.bind(this), 1000);
			}
		}, {
			key: 'closeTooltip',
			value: function closeTooltip() {
	
				$(".scan-tooltip").hide();
			}
		}, {
			key: 'getpickupOutletlist',
			value: function getpickupOutletlist() {
				var _this4 = this;
	
				_axios2.default.get(_constants.API_v4_URL + 'Getoutlets/pickup_outlets?app_id=' + APPID).then(function (res) {
					if (res.data.status === "ok") {
						_this4.setState({ Status: res.data.status });
						_this4.setState({ Outlets: res.data.result_set });
						if (apps.workspace === APPID) {
							_this4.addWorkSpaceCookieValues(res.data.result_set);
						}
					} else {
						_this4.setState({ Status: res.data.status });
					}
				});
			}
	
			/* click order type */
	
		}, {
			key: 'clickOrderTypePopup',
			value: function clickOrderTypePopup() {
				if (typeof _reactCookie2.default.load('onetimeClick') === "undefined" && this.state.onetimeclickstate === "Yes" && _reactCookie2.default.load('site_maintenance_popup_open') !== "1" && APPID != "81891E42-EB66-44EF-A90E-1E3F2AA9B722" && APPID != "AA850867-4108-4EB8-872B-024903608E9F") {
					$("#onload-screen").modal({
						backdrop: 'static',
						keyboard: false
					});
				}
			}
	
			/* check promo popup */
	
		}, {
			key: 'checkPromoPopup',
			value: function checkPromoPopup() {
				if (_reactCookie2.default.load('promoPopup') !== "Yes" && this.state.showPromoPopup === "Yes") {
					$("#promo_popup").modal("show");
				}
			}
	
			/* check normal poup //showNormalPopup */
	
		}, {
			key: 'checkNormalPopup',
			value: function checkNormalPopup() {
				if (this.state.closeNormalPopup === false && _reactCookie2.default.load('NormalPopup') !== "Yes" && this.state.showNormalPopup === "Yes" && _reactCookie2.default.load('itsfromreservation') !== "yes") {
					$("#normal_popup").modal({
						backdrop: 'static',
						keyboard: false
					});
				}
			}
		}, {
			key: 'checkMaintenancePopup',
			value: function checkMaintenancePopup() {
	
				// $("#onload-screen").modal("hide");
				// $('.modal-backdrop').remove();
	
				/* Get Client Maintenance popup content */
				if (_reactCookie2.default.load('site_maintenance_popup_open') === "1" && this.state.client_maintenance_mode === "1") {
	
					console.log("er");
	
					$("#promo_popup-2").modal({
						backdrop: 'static',
						keyboard: false
					});
				}
			}
		}, {
			key: 'triggerReservationPopup',
			value: function triggerReservationPopup() {
				if (_reactCookie2.default.load('reserVationClick') === 'fromlogin') {
					console.log('reservationpopup');
					document.body.classList.add('reservationPopup');
					//$('.goback_arwcls').hide();
					$("#ReservationMdl").modal({
						backdrop: 'static',
						keyboard: false
					});
				}
			}
	
			/* format date'es */
	
		}, {
			key: 'parseDate',
			value: function parseDate(input) {
				var parts = input.match(/(\d+)/g);
				// new Date(year, month [, date [, hours[, minutes[, seconds[, ms]]]]])
				return new Date(parts[0], parts[1] - 1, parts[2]); // months are 0-based
			}
		}, {
			key: 'getOptions',
			value: function getOptions(input) {
	
				var orderOutletIdtext = _reactCookie2.default.load('orderOutletId');
				var applyOutletIdtext = _reactCookie2.default.load('applyOutletId');
				var addquery_txt = '';
	
				if (applyOutletIdtext === 'yes') {
					if (typeof orderOutletIdtext !== "undefined" && orderOutletIdtext !== '') {
						addquery_txt = "&outletId=" + orderOutletIdtext + "&applyOutletId=yes";
					}
				}
	
				var searchResult = [];
				return _axios2.default.get(APIURLPRO + '/products/products_search?app_id=' + APPID + "&availability=" + _reactCookie2.default.load('defaultAvilablityId') + addquery_txt + "&search_value=" + input).then(function (response) {
					if (response.data.status === "ok") {
						var resultData = response.data.result_set;
						resultData.map(function (loadData) {
							return searchResult.push({ value: loadData.product_slug, label: strp.stripslashes(helper.getAliasName(loadData.product_alias, loadData.product_name)) });
						});
					}
	
					return { options: searchResult };
				});
			}
		}, {
			key: 'getAllOutlets',
			value: function getAllOutlets() {
				var _this5 = this;
	
				return _axios2.default.get(APIURL + '/outlets/pickup_outlets?app_id=' + APPID + "&availability=" + config.ids.reservationId).then(function (response) {
					//console.log(response.data);
					var ResOutletHtml = '',
					    frstResOutletid = 0,
					    ResOutletOptionTxt = '',
					    ResOutletAddressAndId = '',
					    ResOutletAddressTxt = '',
					    AdultHtml = '',
					    ChildrenHtml = '',
					    outlet_max_pax_limit = 0;
					if (response.data.status === "ok") {
						var resultData = response.data.result_set;
						resultData.map(function (loadData) {
							return ResOutletHtml += "<option data-maxlimit='" + parseInt(Number(loadData.outlet_max_pax_limit)) + "' value='" + loadData.oa_outlet_id + '~' + loadData.outlet_adult_limit + '~' + loadData.outlet_child_limit + '~' + loadData.outlet_address_line1 + "' >" + loadData.outlet_name + "</option>";
						});
					} else {
						var resultData = {};
					}
	
					if (resultData.length > 0) {
						frstResOutletid = resultData[0].oa_outlet_id;
						ResOutletOptionTxt = resultData[0].outlet_name;
						ResOutletAddressTxt = resultData[0].outlet_address_line1;
						ResOutletAddressAndId = resultData[0].oa_outlet_id + '~' + resultData[0].outlet_address_line1;
						outlet_max_pax_limit = parseInt(Number(resultData[0].outlet_max_pax_limit));
					}
					if (frstResOutletid !== 0) {
						_this5.getRestimeData(frstResOutletid);
					}
					_this5.setState({ Reservationoutlets: resultData });
					var outletDropDown = htmlToReactParser.parse(ResOutletHtml);
					_this5.setState({ ResOutletDropDownHtml: outletDropDown });
					_this5.setState({ selectResOutlet: frstResOutletid });
					_this5.setState({ selectResOutletAdrr: ResOutletAddressTxt });
					_this5.setState({ selectResOutletAdrrAndId: ResOutletAddressAndId });
					_this5.setState({ selectResOutletOptionTxt: ResOutletOptionTxt });
					_this5.setState({ resDate: defaultDate });
					_this5.setState({ resTimeval: defaultresTime });
					_this5.setState({ noofAdults: 0 });
					_this5.setState({ noofChildren: 0 });
					_this5.setState({ outlet_max_pax_limit: outlet_max_pax_limit });
	
					var maxLmt = APPID === 'DDAA254C-BD1E-49F0-AD1E-164A140421D3' ? 7 : 11;
	
					if (_reactCookie2.default.load('advanced_time_slot_reservation_enable') === "1") {
						_this5.getReservationtime(frstResOutletid, defaultDate);
						_this5.getTimesettingArrFun();
					}
	
					_this5.setState({ reservationPersonMax: resultData[0].outlet_adult_limit });
					_this5.setState({ reservationChildMax: resultData[0].outlet_child_limit });
					var maxAdult = _this5.state.reservationPersonMax;
					var maxChild = _this5.state.reservationChildMax;
					if (parseInt(maxAdult) > 0) {
						for (var a = 0; a <= maxAdult; a++) {
							var adltxt = a > 1 ? 'Adults' : 'Adult';
							AdultHtml += "<option value='" + a + "'  >" + a + " " + adltxt + "</option>";
						}
						for (var a = 0; a <= maxChild; a++) {
							var chldtxt = a > 1 ? 'Children' : 'Child';
							ChildrenHtml += "<option value='" + a + "'  >" + a + " " + chldtxt + "</option>";
						}
					} else {
						for (var a = 0; a < maxLmt; a++) {
							var adltxt = a > 1 ? 'Adults' : 'Adult';
							var chldtxt = a > 1 ? 'Children' : 'Child';
							AdultHtml += "<option value='" + a + "'  >" + a + " " + adltxt + "</option>";
							ChildrenHtml += "<option value='" + a + "'  >" + a + " " + chldtxt + "</option>";
						}
					}
					var AdultHtmlDropDown = htmlToReactParser.parse(AdultHtml);
					var ChildrenHtmlDropDown = htmlToReactParser.parse(ChildrenHtml);
					_this5.setState({ noofAdultHtml: AdultHtmlDropDown });
					_this5.setState({ noofChildrenHtml: ChildrenHtmlDropDown });
				});
			}
		}, {
			key: 'getTimesettingArrFun',
			value: function getTimesettingArrFun() {
				var _this6 = this;
	
				var selectedDate = this.state.date_advanced;
				var currentThis = this;
				if (this.state.cutOfftime_advanced !== "") {
					selectedDate.setDate(selectedDate.getDate() + 1);
	
					var min_datetime = this.state.min_datetime_advanced;
					min_datetime.setDate(min_datetime.getDate() + 1);
	
					var max_datetime = this.state.max_datetime_advanced;
					max_datetime.setDate(max_datetime.getDate() + 1);
					this.setState({
						date_advanced: selectedDate,
						min_datetime_advanced: min_datetime,
						max_datetime_advanced: max_datetime
					});
				}
	
				// axios.get("https://mars.ninjaos.com/apiv2/settings/availableDatesAdvanced/?app_id=F77D467A-F552-4BB3-ABBF-C491DB6661A0&availability_id=634E6FA8-8DAF-4046-A494-FFC1FCF8BD11&outletId=80&tatTime=0")
	
				_axios2.default.get(APIURLv2 + "settings/availableDatesAdvanced/?app_id=" + APPID + "&availability_id=" + config.ids.reservationId + "&outletId=" + this.state.selectResOutlet + "&tatTime=" + this.state.serverTat).then(function (tmres) {
					$(".custom-date-label").removeClass("loader-main-cls");
					$(".custom-date-label").find(".loader-sub-div").remove();
					if (tmres.data.status === "success") {
						var result = tmres.data.timeslot_data.result_set[0];
						_this6.setState({ time_slot_type_advanced: result.time_slot_type });
						var mindatetime = result.minimum_date;
						if (Product_LeadTime > 0) {
							if (mindatetime < Product_LeadTime) {
								mindatetime = Product_LeadTime;
							} else {
								mindatetime = mindatetime;
							}
						}
						mindatetime = parseInt(mindatetime) + parseInt(getDate_advanced);
						var currentDate = new Date(new Date(TodayDate).setDate(mindatetime));
	
						min_datetime = new Date(new Date(TodayDate).setDate(mindatetime - 1));
						var totalDays = parseInt(min_datetime.getDate()) + parseInt(1) + parseInt(Product_LeadTime) + parseInt(result.maximum_date);
						var max_datetime = new Date(new Date(TodayDate).setDate(totalDays));
						var cutOfftime = result.cut_off !== "" ? parseInt(result.cut_off) : "";
	
						/* Holliday Disable Dates */
						var hollidayList = tmres.data.timeslot_data.holidayresult;
						var DisableDats = [];
						if (hollidayList !== "") {
							hollidayList.map(function (loadData) {
	
								/*var chekingHoliday = parseInt(min_datetime.getFullYear())+'-'+parseInt(min_datetime.getMonth())+'-'+(currentThis.padnewone(parseInt(min_datetime.getDate())+1));
	        if(chekingHoliday===chekingHoliday) {
	        min_datetime = new Date(new Date(min_datetime).setDate(currentThis.padnewone(parseInt(min_datetime.getDate())+1)));
	        currentDate = new Date(new Date(currentDate).setDate(currentThis.padnewone(parseInt(currentDate.getDate())+1)));
	        }*/
	
								var checkingDate = currentDate.getFullYear() + "-" + currentThis.padnewone(parseInt(currentDate.getMonth()) + 1) + "-" + currentThis.padnewone(currentDate.getDate());
								if (loadData == checkingDate) {
									currentDate = new Date(new Date(TodayDate).setDate(parseInt(currentDate.getDate()) + 1));
								}
	
								DisableDats.push(currentThis.parseDate(loadData));
							});
						}
	
						var slot = tmres.data.timeslot_data.result_set[0].slot;
						for (var k = mindatetime; k <= totalDays; k++) {
							var addDates = new Date(new Date(TodayDate).setDate(k));
							var addDay = weekdayArr[addDates.getDay()];
							if (slot[addDay] === "" || slot[addDay] === undefined) {
								var checking_Date = currentDate.getFullYear() + "-" + currentThis.padnewone(parseInt(currentDate.getMonth()) + 1) + "-" + currentDate.getDate();
								var hideDate = addDates.getFullYear() + "-" + _this6.padnewone(parseInt(addDates.getMonth()) + 1) + "-" + _this6.padnewone(addDates.getDate());
								if (hideDate == checking_Date) {
									currentDate = new Date(new Date(TodayDate).setDate(parseInt(currentDate.getDate()) + 1));
								}
	
								DisableDats.push(_this6.parseDate(hideDate));
							}
						}
	
						_this6.setState({
							min_datetime_advanced: min_datetime,
							max_datetime_advanced: max_datetime,
							date_advanced: currentDate,
							forcutoffstart: currentDate,
							cutOfftime_advanced: cutOfftime,
							timeExceed_advanced: "No",
							hollidayList: hollidayList,
							/*   allowHoliDay: "Yes", */
							disableDate_advanced: DisableDats
						});
						var daytxt = weekdayArr[currentDate.getDay()];
						if (result.time_slot_type === "1") {
							_this6.setState({
								intervalTime_advanced: tmres.data.timeslot_data.result_set[0].interval_time,
								timeandsecArrayset: slot
							}, function () {
								this.timeDropDownFunction(daytxt);
							});
						} else if (result.time_slot_type === "2") {
							_this6.setState({
								timeText_advanced: "Choose Time slot",
								timeandsecArrayset: tmres.data.timeslot_data.result_set[0].slot
							}, function () {
								this.loadTimeSlotDropDown(daytxt);
							});
						}
					} else {
						_this6.setState({ intervalTime_advanced: "" });
						_this6.setState({ timeandsecArrayset: [] });
						_this6.setState({ timeHtml_advanced: "" });
						_this6.setState({ minsHtml: "" });
						_this6.setState({ timeExceed_advanced: "Yes" });
					}
				});
			}
		}, {
			key: 'timeDropDownFunction',
			value: function timeDropDownFunction(daytxt) {
				var skiptime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
				var timeExceed = "No";
				var TimeHtml = "";
				var changeTmtxt = "";
				var checkTimeArr = [];
				var timethis = this;
				var tatval = this.state.serverTat;
				var cutOfftime = this.state.cutOfftime_advanced;
				var totdayDate = new Date();
				var addHrs = parseInt(totdayDate.getMinutes()) + parseInt(this.state.serverTat);
				totdayDate.setMinutes(addHrs);
				var selectDate = this.state.date_advanced.getDate() + "-" + this.state.date_advanced.getMonth() + "-" + this.state.date_advanced.getFullYear();
				var j = 0;
				var slotArr = [];
				var addtionalArray = [];
				var startList,
				    endList = "";
				var intervalTime = this.state.intervalTime_advanced;
				if (this.state.timeandsecArrayset[daytxt] !== "" && this.state.timeandsecArrayset[daytxt] !== undefined) {
					this.state.timeandsecArrayset[daytxt].map(function (item) {
						//Start Slot
						var slot_time1 = item.slot_time1.split(":");
						var startTimeVal = slot_time1.length > 0 ? slot_time1[0] : "";
						var startMinitVal = slot_time1.length > 0 ? slot_time1[1] : "";
						var strdatevalobj = new Date();
						strdatevalobj.setHours(startTimeVal);
						var stringrMinits = parseInt(startMinitVal) + parseInt(tatval);
						strdatevalobj.setMinutes(stringrMinits);
						startTimeVal = strdatevalobj.getHours();
						startMinitVal = strdatevalobj.getMinutes();
	
						//End Slot
						var endArr = item.slot_time2 !== "" ? item.slot_time2.split(":") : [];
						var endTimeVal = endArr.length > 0 ? endArr[0] : "";
						var endMinitVal = endArr.length > 0 ? endArr[1] : "";
						var enddatevalobj = new Date();
						enddatevalobj.setHours(endTimeVal);
						var ingrendMinits = parseInt(endMinitVal) + parseInt(tatval);
						enddatevalobj.setMinutes(ingrendMinits);
						endTimeVal = enddatevalobj.getHours();
						endMinitVal = enddatevalobj.getMinutes();
	
						if (startTimeVal !== "" && endTimeVal !== "") {
							for (var valueTime = startTimeVal; valueTime <= endTimeVal; valueTime++) {
								var todaycond = 0;
								var checkDate = totdayDate.getDate() + "-" + totdayDate.getMonth() + "-" + totdayDate.getFullYear();
	
								if (checkDate === selectDate) {
									if (valueTime < totdayDate.getHours()) {
										todaycond = 1;
									}
								}
								if (checkTimeArr.indexOf(valueTime) >= 0 && todaycond === 0) {
									addtionalArray[timethis.padnewone(valueTime)] = strdatevalobj + "-" + enddatevalobj;
								}
								if (checkTimeArr.indexOf(valueTime) === -1 && todaycond === 0) {
									if (skiptime <= valueTime) {
										if (j === 0) {
											timethis.setState({ selectTime_advanced: valueTime });
										}
	
										if (startTimeVal == timethis.padnewone(valueTime)) {
											startList = startMinitVal;
										} else {
											startList = 0;
										}
										if (endTimeVal == valueTime) {
											endList = endMinitVal;
										} else {
											endList = Math.round((60 / intervalTime - 1) * intervalTime);
										}
										if (startList > endList) {
											endList = startList;
										}
										slotArr[timethis.padnewone(valueTime)] = startList + "-" + endList;
										checkTimeArr.push(valueTime);
										if (j === 0) {
											timethis.setState({
												selectTime_advanced: timethis.padnewone(valueTime)
											});
										}
										var cutoffexist = 0;
	
										if (cutOfftime !== "" && cutOfftime < valueTime && timethis.state.date_advanced.getDate() == timethis.state.forcutoffstart.getDate()) {
											cutoffexist = 1;
										}
										if (cutoffexist === 0) {
											TimeHtml += "<option value='" + timethis.padnewone(valueTime) + "'  >" + timethis.padnewone(valueTime) + "</option>";
											j++;
										}
									}
								}
							}
						}
					});
				}
				var timeDropDown = "";
				var currentselectdate = this.state.date_advanced;
				if (TimeHtml !== "") {
					timeDropDown = htmlToReactParser.parse(TimeHtml);
				} else {
					timeExceed = "Yes";
	
					var min_datetime = new Date(new Date(this.state.date_advanced).setDate(currentselectdate.getDate()));
	
					this.setState({ min_datetime_advanced: min_datetime });
					var addonday = parseInt(currentselectdate.getDate()) + 1;
					var cudate = new Date(new Date(currentselectdate).setDate(addonday));
	
					this.setState({ date_advanced: cudate }, function () {
						this.timeDropDownFunction(weekdayArr[cudate.getDay()]);
					});
				}
	
				this.setState({
					timeHtml_advanced: timeDropDown,
					minsHtml: "",
					slotArr: slotArr,
					addtionalArray: addtionalArray,
					timeExceed_advanced: timeExceed
				}, function () {
					if (TimeHtml !== "") {
						this.minsDropDownFunction();
					}
				});
			}
		}, {
			key: 'minsDropDownFunction',
			value: function minsDropDownFunction() {
	
				var slotArr = this.state.slotArr;
				var intervalTime = this.state.intervalTime_advanced;
				var selectTime = this.state.selectTime_advanced;
				var timeExceed = "No";
				var startTimeLimit = 0;
				var totdayDate = new Date();
	
				var addHrs = parseInt(totdayDate.getMinutes()) + parseInt(this.state.serverTat);
	
				totdayDate.setMinutes(addHrs);
	
				var selectDate = this.state.date_advanced.getDate() + "-" + this.state.date_advanced.getMonth() + "-" + this.state.date_advanced.getFullYear();
	
				var checkDate = totdayDate.getDate() + "-" + totdayDate.getMonth() + "-" + totdayDate.getFullYear();
				var endTimeLimit = (60 / intervalTime - 1) * intervalTime;
				var startTime_Limit = startTimeLimit;
				var endTime_Limit = endTimeLimit;
				var slotArray = [];
				while (startTime_Limit <= endTime_Limit) {
					slotArray.push(startTime_Limit);
					startTime_Limit += parseInt(intervalTime);
				}
	
				var k = 0;
				var htmlMins = "";
				if (slotArr !== "" && slotArr[selectTime] !== "" && _typeof(slotArr[selectTime]) !== undefined) {
					var slotArrNew = slotArr[selectTime].split("-");
	
					var startTimeLimitNew = parseInt(slotArrNew[0]);
					var endTimeLimitNew = parseInt(slotArrNew[1]);
					var minArrayList = [];
					var startSelect = "";
					var startcompleteTime = 0;
					if (totdayDate.getHours() == selectTime && checkDate == selectDate) {
						if (totdayDate.getMinutes() > startTimeLimitNew) {
							startcompleteTime = 1;
						}
					}
					var currentEnd = 0;
					if (slotArray.indexOf(startTimeLimitNew) === -1 && startcompleteTime === 0) {
						htmlMins += "<option value='" + this.padnewone(startTimeLimitNew) + "'  >" + this.padnewone(startTimeLimitNew) + "</option>";
						currentEnd = startTimeLimitNew;
						startSelect = startTimeLimitNew;
					}
					while (startTimeLimit <= endTimeLimit) {
						var completeTime = 0;
						if (totdayDate.getHours() == selectTime && checkDate == selectDate) {
							if (totdayDate.getMinutes() > startTimeLimit) {
								completeTime = 1;
							}
						}
						if (completeTime === 0) {
							if (startTimeLimitNew > startTimeLimit) {
								completeTime = 1;
							}
						}
						if (completeTime === 0) {
							if (endTimeLimitNew < startTimeLimit) {
								completeTime = 1;
							}
						}
						if (completeTime === 0) {
							if (k === 0) {
								this.setState({ selectMins_advanced: this.padnewone(startTimeLimit) });
							}
							minArrayList.push(startTimeLimit);
							htmlMins += "<option value='" + this.padnewone(startTimeLimit) + "'  >" + this.padnewone(startTimeLimit) + "</option>";
							currentEnd = startTimeLimit;
							k++;
						}
						startTimeLimit += parseInt(intervalTime);
					}
	
					var endcompleteTime = 0;
					if (totdayDate.getHours() == selectTime && checkDate == selectDate) {
						if (totdayDate.getMinutes() > endTimeLimitNew) {
							endcompleteTime = 1;
						}
					}
	
					if (minArrayList.indexOf(endTimeLimitNew) === -1 && startSelect !== endTimeLimitNew && endcompleteTime === 0) {
						htmlMins += "<option value='" + this.padnewone(endTimeLimitNew) + "'  >" + this.padnewone(endTimeLimitNew) + "</option>";
						currentEnd = endTimeLimitNew;
					}
				}
				var loadAddtionalTime = this.loadAddtionalTime(currentEnd);
				htmlMins += loadAddtionalTime;
				var minsDropDown = "";
				if (htmlMins !== "") {
					minsDropDown = htmlToReactParser.parse(htmlMins);
				} else {
					timeExceed = "Yes";
					var day_txt = weekdayArr[this.state.date_advanced.getDay()];
					var select_Time = parseInt(selectTime) + 1;
					this.timeDropDownFunction(day_txt, select_Time);
				}
				this.setState({ minsHtml: minsDropDown, timeExceed_advanced: timeExceed });
			}
		}, {
			key: 'getsettings',
			value: function getsettings() {
				var _this7 = this;
	
				var promise = helper.getProSettings('', 'No'); //getResult('settings','');
				promise.then(function (res) {
					_this7.setState({ settings: res.data.result_set });
	
					/* Holiday  - start */
					var DisableDats = [];
					if (parseInt(res.data.result_set.client_holiday_enable) === 1 && _reactCookie2.default.load('defaultAvilablityId') !== config.ids.dineinId) {
						var apiheaderauth = { headers: {
								'Auth': _reactCookie2.default.load('Token'),
								'X-API-KEY': "8611E7D6-ECA7-4172-966C-4C10EA1E8C7N"
							} };
						_axios2.default.get(APIURL + 'settings/get_holidaylist?app_id=' + APPID + "&availability=" + _reactCookie2.default.load('defaultAvilablityId') + "&outlet_id=327", apiheaderauth).then(function (res) {
							if (res.data.status === "ok") {
								var resultData = res.data.result_set;
								resultData.map(function (loadData) {
									return DisableDats.push(_this7.parseDate(loadData.date));
								});
								_this7.setState({ hollidayList: resultData, allowHoliDay: 'Yes', disableDate_advanced: DisableDats });
							}
						});
					}
					/* Holiday - end */
				});
			}
		}, {
			key: 'loadAddtionalTime',
			value: function loadAddtionalTime(currentEnd) {
				var html_Mins = "";
				var select_Time = this.state.selectTime_advanced;
				var intervalTime = this.state.intervalTime_advanced;
				var startTimeLimit = 0;
				var endTimeLimit = (60 / intervalTime - 1) * intervalTime;
				var addtional_Array = this.state.addtionalArray;
				if (addtional_Array !== "" && addtional_Array[select_Time] !== "" && _typeof(addtional_Array[select_Time]) !== undefined && typeof addtional_Array[select_Time] !== "undefined") {
					var totdayDate = new Date();
	
					var addHrs = parseInt(totdayDate.getMinutes()) + parseInt(this.state.serverTat);
	
					totdayDate.setMinutes(addHrs);
	
					var selectDate = this.state.date_advanced.getDate() + "-" + this.state.date_advanced.getMonth() + "-" + this.state.date_advanced.getFullYear();
	
					var checkDate = totdayDate.getDate() + "-" + totdayDate.getMonth() + "-" + totdayDate.getFullYear();
	
					var add_start_time = addtional_Array[select_Time].split("-");
	
					var startTime = new Date(add_start_time[0].trim());
					var endTime = new Date(add_start_time[1].trim());
					var endMin = endTimeLimit;
					if (endTime.getHours() == select_Time) {
						endMin = endTime.getMinutes();
					}
					var completeTime = 0;
					if (totdayDate.getHours() == select_Time && checkDate == selectDate) {
						if (totdayDate.getMinutes() > startTimeLimit) {
							completeTime = 1;
						}
					}
					if (completeTime === 0) {
						html_Mins += "<option value='" + this.padnewone(startTime.getMinutes()) + "'  >" + this.padnewone(startTime.getMinutes()) + "</option>";
					}
					var minArrayList = [];
					var endofMin = 0;
					while (startTimeLimit <= endTimeLimit) {
						if (currentEnd < startTimeLimit && startTime.getMinutes() < startTimeLimit) {
							var _completeTime = 0;
							if (totdayDate.getHours() == select_Time && checkDate == selectDate) {
								if (totdayDate.getMinutes() > startTimeLimit) {
									_completeTime = 1;
								}
							}
							if (_completeTime == 0) {
								minArrayList.push(startTimeLimit);
								html_Mins += "<option value='" + this.padnewone(startTimeLimit) + "'  >" + this.padnewone(startTimeLimit) + "</option>";
								endofMin = startTimeLimit;
							}
						}
						startTimeLimit += parseInt(intervalTime);
					}
	
					var endcompleteTime = 0;
					if (totdayDate.getHours() == select_Time && checkDate == selectDate) {
						if (totdayDate.getMinutes() > endMin) {
							endcompleteTime = 1;
						}
					}
					if (minArrayList.indexOf(endMin) === -1 && startTime.getMinutes() !== endMin && endcompleteTime === 0 && endMin < endofMin) {
						html_Mins += "<option value='" + this.padnewone(endMin) + "'  >" + this.padnewone(endMin) + "</option>";
					}
				}
				return html_Mins;
			}
		}, {
			key: 'loadTimeSlotDropDown',
			value: function loadTimeSlotDropDown(daytxt) {
				var timeExceed = "No";
				var currentTime = new Date();
				if (this.state.serverTat !== "" && this.state.serverTat !== null && this.state.serverTat !== undefined && this.state.serverTat != "undefined") {
					var addhrToday = parseInt(currentTime.getMinutes()) + parseInt(this.state.serverTat);
					currentTime.setMinutes(addhrToday);
				}
				var timeSlotHtml = "";
				var selectDate = this.state.date_advanced.getDate() + "-" + this.state.date_advanced.getMonth() + "-" + this.state.date_advanced.getFullYear();
	
				var checkDate = currentTime.getDate() + "-" + currentTime.getMonth() + "-" + currentTime.getFullYear();
				var timeExist = 0;
				if (this.state.timeandsecArrayset[daytxt] !== "" && this.state.timeandsecArrayset[daytxt] !== undefined) {
					this.state.timeandsecArrayset[daytxt].map(function (item) {
						timeExist = 0;
						//Start Slot
						var slot_time1 = item.slot_time1.split(":");
						var startTimeVal = slot_time1.length > 0 ? slot_time1[0] : "";
						var startMinitVal = slot_time1.length > 0 ? slot_time1[1] : "";
						var strdatevalobj = new Date();
						strdatevalobj.setHours(startTimeVal);
						var stringrMinits = parseInt(startMinitVal);
						strdatevalobj.setMinutes(stringrMinits);
	
						//End Slot
						var endArr = item.slot_time2 !== "" ? item.slot_time2.split(":") : [];
						var endTimeVal = endArr.length > 0 ? endArr[0] : "";
						var endMinitVal = endArr.length > 0 ? endArr[1] : "";
						var enddatevalobj = new Date();
						enddatevalobj.setHours(endTimeVal);
						var ingrendMinits = parseInt(endMinitVal);
						enddatevalobj.setMinutes(ingrendMinits);
						var lable = moment(strdatevalobj).format("hh:mm A") + " - " + moment(enddatevalobj).format("hh:mm A");
						var TimeValue = moment(strdatevalobj).format("HH:mm") + ":00" + "-" + moment(enddatevalobj).format("HH:mm") + ":00/" + moment(strdatevalobj).format("hh:mm A") + "-" + moment(enddatevalobj).format("hh:mm A");
						if (currentTime.getHours() >= strdatevalobj.getHours() && checkDate == selectDate) {
							timeExist = 1;
						}
						if (timeExist == 0) {
							timeSlotHtml += "<option value='" + TimeValue + "'  >" + lable + "</option>";
						}
					});
				}
				var timeSlotDD = "";
				var currentselectdate = this.state.date_advanced;
				if (timeSlotHtml !== "") {
					timeSlotDD = htmlToReactParser.parse(timeSlotHtml);
				} else {
					timeExceed = "Yes";
					var min_datetime = new Date(new Date(this.state.date_advanced).setDate(currentselectdate.getDate()));
	
					this.setState({ min_datetime_advanced: min_datetime });
					var addonday = parseInt(currentselectdate.getDate()) + 1;
					var cudate = new Date(new Date(currentselectdate).setDate(addonday));
	
					this.setState({ date_advanced: cudate }, function () {
						this.loadTimeSlotDropDown(weekdayArr[cudate.getDay()]);
					});
				}
				this.setState({ TimeSlotHtmlVal_advanced: timeSlotDD, timeExceed_advanced: timeExceed });
			}
	
			/* Disaple year */
	
		}, {
			key: 'showTimeslotExceed',
			value: function showTimeslotExceed() {
				if (this.state.timeExceed_advanced === "Yes") {
					if (APPID === "97347EE4-2845-4011-BCE6-9C0B806DA437" && (_reactCookie2.default.load("defaultAvilablityId") === "634E6FA8-8DAF-4046-A494-FFC1FCF8BD11" || _reactCookie2.default.load("defaultAvilablityId") === "718B1A92-5EBB-4F25-B24D-3067606F67F0")) {
						if (_reactCookie2.default.load("defaultAvilablityId") === "634E6FA8-8DAF-4046-A494-FFC1FCF8BD11") {
							return _react2.default.createElement(
								'div',
								{ className: 'timeslot_exc' },
								'Delivery available only on Saturdays (12- 4) pm'
							);
						} else if (_reactCookie2.default.load("defaultAvilablityId") === "718B1A92-5EBB-4F25-B24D-3067606F67F0") {
							return _react2.default.createElement(
								'div',
								{ className: 'timeslot_exc' },
								'Takeaway available only on Saturdays (9 am to 2pm)'
							);
						}
					} else if (APPID === "729A09D6-2A38-4E1C-ADB1-67A9242D2158" && (_reactCookie2.default.load("defaultAvilablityId") === "634E6FA8-8DAF-4046-A494-FFC1FCF8BD11" || _reactCookie2.default.load("defaultAvilablityId") === "718B1A92-5EBB-4F25-B24D-3067606F67F0")) {
						if (_reactCookie2.default.load("defaultAvilablityId") === "634E6FA8-8DAF-4046-A494-FFC1FCF8BD11") {
							return _react2.default.createElement(
								'div',
								{ className: 'timeslot_exc' },
								'Delivery available only on Fri, Sat & Sun'
							);
						} else if (_reactCookie2.default.load("defaultAvilablityId") === "718B1A92-5EBB-4F25-B24D-3067606F67F0") {
							return _react2.default.createElement(
								'div',
								{ className: 'timeslot_exc' },
								'Pickup available only on Fri, Sat & Sun'
							);
						}
					} else {
						return _react2.default.createElement(
							'div',
							{ className: 'timeslot_exc' },
							" ",
							'Note: Please refer our operating hours. The time you are selecting is outside of our delivery timing. Apologies for the inconvenience.'
						);
					}
				}
			}
	
			/* add zero */
	
		}, {
			key: 'padnewone',
			value: function padnewone(d) {
				var dd = parseInt(d);
				return dd < 10 ? "0" + dd.toString() : dd.toString();
			}
		}, {
			key: 'changeTimer',
			value: function changeTimer(e) {
				var seletedTime = e.target.value;
				this.setState({ selectTime_advanced: seletedTime, minsHtml: "" }, function () {
					this.minsDropDownFunction();
				});
			}
	
			/* chnage minutes */
	
		}, {
			key: 'changeMins',
			value: function changeMins(e) {
				this.setState({ selectMins_advanced: e.target.value });
			}
		}, {
			key: 'getRestimeData',
			value: function getRestimeData(outletIdtxt) {
				var _this8 = this;
	
				var qs = __webpack_require__(3);
				var postObject = { "app_id": APPID, "outlet_id": outletIdtxt };
				var DisableDats = [];
				_axios2.default.post(APIURL + "reservation/reservation_shop_closed_dates", qs.stringify(postObject)).then(function (response) {
					if (response.data.status === "success") {
						var resultData = response.data.result_set;
						resultData.map(function (loadData) {
							return DisableDats.push(_this8.parseDate(loadData.res_closed_day));
						});
					} else {
						DisableDats = [];
					}
					_this8.setState({ ReservationtimeData: DisableDats });
					_this8.getReservationtime(outletIdtxt, defaultDate);
				}).catch(function (error) {
					console.log(error);
				});
			}
		}, {
			key: 'getReservationtime',
			value: function getReservationtime(selectResOutletIdtxt, resDateoptiontxt) {
				var _this9 = this;
	
				var qs = __webpack_require__(3);
				var postObject = { "app_id": APPID, "outlet_id": selectResOutletIdtxt, "availability_date": resDateoptiontxt };
				var resultDataHtm = "";
				_axios2.default.post(APIURLPRO + "reservation/reservation_availability_timesninjapro", qs.stringify(postObject)).then(function (response) {
					if (response.data.status === "success") {
						resultDataHtm = response.data.result_set;
					} else {
						resultDataHtm = "<option value=''>Select Time</option>";
					}
					var ReservationtimeDown = htmlToReactParser.parse(resultDataHtm);
					_this9.setState({ ReservationtimeHtml: ReservationtimeDown });
				}).catch(function (error) {
					console.log(error);
				});
			}
		}, {
			key: 'changeResOutlet',
			value: function changeResOutlet(event) {
	
				var seletedResOutletVal = event.target.value;
				var splitedResOutletArr = seletedResOutletVal.split('~');
				var seletedResOutletid = splitedResOutletArr[0];
				var seletedResOutletAddr = splitedResOutletArr[3];
				var adultmax = splitedResOutletArr[1];
				var childmax = splitedResOutletArr[2];
				var ResOutletOptionTxt = event.target.options[event.target.selectedIndex].text;
				this.setState({ selectResOutlet: seletedResOutletid });
				this.setState({ selectResOutletAdrr: seletedResOutletAddr });
				this.setState({ selectResOutletAdrrAndId: seletedResOutletVal });
				this.setState({ selectResOutletOptionTxt: ResOutletOptionTxt });
				this.setState({ resDate: defaultDate });
				this.getRestimeData(seletedResOutletid);
	
				var maxAdult = adultmax;
				var maxChild = childmax;
	
				var outlet_max_pax_limit = _typeof(event.target.options[event.target.selectedIndex].getAttribute('data-maxlimit')) !== undefined ? event.target.options[event.target.selectedIndex].getAttribute('data-maxlimit') : 0;
				this.setState({ outlet_max_pax_limit: outlet_max_pax_limit });
	
				var AdultHtml = "";
				var ChildrenHtml = "";
	
				for (var a = 0; a <= maxAdult; a++) {
					var adltxt = a > 1 ? 'Adults' : 'Adult';
					AdultHtml += "<option value='" + a + "'  >" + a + " " + adltxt + "</option>";
				}
	
				for (var a = 0; a <= maxChild; a++) {
					var chldtxt = a > 1 ? 'Children' : 'Child';
					ChildrenHtml += "<option value='" + a + "'  >" + a + " " + chldtxt + "</option>";
				}
	
				var AdultHtmlDropDown = htmlToReactParser.parse(AdultHtml);
				var ChildrenHtmlDropDown = htmlToReactParser.parse(ChildrenHtml);
				this.setState({ noofAdultHtml: AdultHtmlDropDown });
				this.setState({ noofChildrenHtml: ChildrenHtmlDropDown });
	
				this.setState({ selectResOutlet: seletedResOutletid }, function () {
					this.getTimesettingArrFun();
				});
			}
		}, {
			key: 'changeResTimeset',
			value: function changeResTimeset(event) {
				var seletedResTmval = event.target.value;
				var seletedResTmTxt = event.target.options[event.target.selectedIndex].text;
				this.setState({ resTimeval: seletedResTmval });
				this.setState({ resTimeText: seletedResTmTxt });
			}
	
			/* ViewProducts */
	
		}, {
			key: 'ViewProducts',
			value: function ViewProducts(event) {
				var productSlug = event.value;
				_reactRouter.hashHistory.push("/product/" + productSlug);
			}
		}, {
			key: 'reservationFirstli',
			value: function reservationFirstli() {
				if (this.state.ResStageTxt === 'info') {
					document.getElementById("InformationLi").className = "";
					document.getElementById("tab1").className = "tab-pane active";
					document.getElementById("tab2").className = "tab-pane";
					document.getElementById("goback_arwId").style.display = "none";
					//$('.goback_arwcls').hide();
				}
			}
		}, {
			key: 'formatAMPM',
			value: function formatAMPM(date) {
				// console.log(date, "date");
				var hours = date;
				var ampm = hours >= 12 ? '2' : '1';
				return ampm;
			}
	
			/* Reservation Submission */
	
		}, {
			key: 'reservationSubmtn',
			value: function reservationSubmtn() {
				var _this10 = this;
	
				this.setState({ manualLoading: true }, function () {
					this.loadManualLoading();
				});
	
				var errorTxt = '';
				var RsOutletVal = document.getElementById("resOutlets").value;
				var RsNoofadultsVal = document.getElementById("noofadults").value;
				var RsNoofchildrenVal = document.getElementById("noofchildren").value;
				var RsResDatepkidVal = document.getElementById("resDatepkid").value;
				/*var RsResTimeVal = document.getElementById("resTime").value;*/
	
				var RsresRemarkVal = void 0;
	
				if (helper.disableSpecialInstructions(APPID)) {
					RsresRemarkVal = document.getElementById("resRemark").value;
				}
	
				if (_reactCookie2.default.load("advanced_time_slot_reservation_enable") === "1") {
					var RsResTimeVal = this.state.time_slot_type_advanced == "1" ? document.getElementById("deliveryTime").value : document.getElementById("timeSlot").value;
				} else {
					var RsResTimeVal = document.getElementById("resTime").value;
				}
	
				// var RsresRemarkVal = document.getElementById("resRemark").value;
	
				if (_reactCookie2.default.load("advanced_time_slot_reservation_enable") === "1") {
					if (this.state.time_slot_type_advanced === "1") {
						var testing = document.getElementById("deliveryTime").value + ":" + document.getElementById("deliveryMins").value + ":00";
						var getValue = this.formatAMPM(RsResTimeVal);
						this.setState({ resTimeText: testing });
					} else {
						var timeslot_date = document.getElementById("timeSlot").value;
						var split_time_slot = timeslot_date.split("/");
						var get_split_time = split_time_slot[0].split("-");
						this.setState({ resTimeText: split_time_slot[1] });
					}
				}
	
				this.setState({ resRemarkDes: RsresRemarkVal });
				_reactCookie2.default.save('reserVationClick', '');
	
				var calRsNoofadultsVal = RsNoofadultsVal !== '' ? parseInt(RsNoofadultsVal) : 0;
				var calRsNoofchildrenVal = RsNoofchildrenVal !== '' ? parseInt(RsNoofchildrenVal) : 0;
				/*var calResPeopleTxt = parseInt(calRsNoofadultsVal) + parseInt(calRsNoofchildrenVal);*/
				var adltext = '',
				    chldtext = '';
				if (calRsNoofadultsVal > 0) {
					adltext = calRsNoofadultsVal > 1 ? calRsNoofadultsVal + ' Adults ' : calRsNoofadultsVal + ' Adult ';
				}
				if (calRsNoofchildrenVal > 0) {
					chldtext = calRsNoofchildrenVal > 1 ? calRsNoofchildrenVal + ' Children' : calRsNoofchildrenVal + ' Child';
				}
				var calResPeopleTxt = adltext + chldtext;
				this.setState({ ResPeopleTxt: calResPeopleTxt });
	
				var calRsResDayText = '';
				var calRsResDatepkidVal = '';
				if (RsResDatepkidVal !== '') {
					var splitedDate = RsResDatepkidVal.split('/');
					var selDate = this.pad(splitedDate[0]);
					var selMonth = this.pad(splitedDate[1]);
					var calMnt = parseInt(splitedDate[1]) - 1;
					var selMonthcal = this.pad(calMnt);
					var selYear = this.pad(splitedDate[2]);
					this.setState({ ResselectedDateInst: selYear + '-' + selMonth + '-' + selDate });
					var caldatesplt = new Date(selYear, selMonthcal, selDate);
					calRsResDatepkidVal = ("0" + caldatesplt.getDate()).slice(-2) + " " + monthNamesArr[caldatesplt.getMonth()] + " " + caldatesplt.getFullYear();
	
					calRsResDayText = dayNamesArr[caldatesplt.getDay()];
	
					var calresvsateDate = this.state.ReservationtimeData;
					var resvsateDateLen = calresvsateDate.length;
					if (resvsateDateLen > 0) {
						for (var rd = 0; rd < resvsateDateLen; rd++) {
							if (dateFormat(caldatesplt, "d/m/yyyy") === dateFormat(calresvsateDate[rd], "d/m/yyyy")) {
								helper.showInfo('The selected date is a holiday. Please select another day');
								errorTxt = 'yes';
							}
						}
					}
				}
				this.setState({ ResselectedDateTxt: calRsResDatepkidVal });
				this.setState({ ResselectedDayTxt: calRsResDayText });
	
				if (RsOutletVal === '' || RsOutletVal === '0' || RsOutletVal === 'value') {
					helper.showInfo('Please Select Outlet');
					errorTxt = 'yes';
					this.setState({ manualLoading: false }, function () {
						this.loadManualLoading();
					});
				} else if (RsNoofadultsVal === '' || RsNoofadultsVal === '0') {
					helper.showInfo('Please Enter No Of Adults');
					errorTxt = 'yes';
					this.setState({ manualLoading: false }, function () {
						this.loadManualLoading();
					});
				} else if (RsNoofchildrenVal === '') {
					/* || RsNoofchildrenVal === '0'*/
					helper.showInfo('Please Enter No Of Children');
					errorTxt = 'yes';
					this.setState({ manualLoading: false }, function () {
						this.loadManualLoading();
					});
				} else if (this.state.outlet_max_pax_limit > 0 && parseInt(RsNoofadultsVal) + parseInt(RsNoofchildrenVal) > this.state.outlet_max_pax_limit) {
					/* || RsNoofchildrenVal === '0'*/
					helper.showInfo('maximum allowed ' + this.state.outlet_max_pax_limit + ' members per reservation');
					errorTxt = 'yes';
					this.setState({ manualLoading: false }, function () {
						this.loadManualLoading();
					});
				} else if (RsResDatepkidVal === '') {
					helper.showInfo('Please Select Date');
					errorTxt = 'yes';
					this.setState({ manualLoading: false }, function () {
						this.loadManualLoading();
					});
				} else if (RsResTimeVal === '' || RsResTimeVal === 'value') {
					helper.showInfo('Please Select Time');
					errorTxt = 'yes';
					this.setState({ manualLoading: false }, function () {
						this.loadManualLoading();
					});
				}
	
				if (errorTxt === '') {
	
					this.setState({ ResStageTxt: 'info', manualLoading: true }, function () {
						this.loadManualLoading();
					});
	
					//$('.goback_arwcls').show();
	
					if (_reactCookie2.default.load("advanced_time_slot_reservation_enable") === "1") {
	
						if (this.state.timeExceed_advanced === "No") {
	
							var current = this;
	
							var DeliveryDate = this.state.date_advanced.getDate() + "/" + (parseInt(this.state.date_advanced.getMonth()) + 1) + "/" + this.state.date_advanced.getFullYear();
							var OrderTime = "";
							var timelimits = "";
	
							if (this.state.time_slot_type_advanced === "1") {
	
								var DeliveryTime = this.state.selectTime_advanced + ":" + this.state.selectMins_advanced;
	
								var DeliveryDate1 = DeliveryDate.split("/");
								OrderTime = DeliveryDate1[2] + "-" + this.padnewone(DeliveryDate1[1]) + "-" + this.padnewone(DeliveryDate1[0]) + " " + DeliveryTime;
							} else if (this.state.time_slot_type_advanced === "2") {
	
								var Timeslot = document.getElementById("timeSlot").value;
								var splited = Timeslot.split("/");
								var startTime = splited[0].split("-");
								var DeliveryDate1 = DeliveryDate.split("/");
								OrderTime = DeliveryDate1[2] + "-" + this.padnewone(DeliveryDate1[1]) + "-" + this.padnewone(DeliveryDate1[0]) + " " + startTime[0];
								timelimits = "&order_pickup_time_slot_from=" + startTime[0] + "&order_pickup_time_slot_to=" + startTime[1];
							}
	
							var apiheaderauth = { headers: {
									'Auth': _reactCookie2.default.load('Token'),
									'X-API-KEY': "8611E7D6-ECA7-4172-966C-4C10EA1E8C7N"
								} };
	
							_axios2.default.get(APIURLPRO + "ordersv1/validate_order_count_advanced?app_id=" + APPID + "&availability_id=" + config.ids.reservationId + "&outlet_id=" + this.state.selectResOutlet + "&order_date=" + OrderTime + timelimits + "&order_tat_time=" + this.state.serverTat + "&no_of_adult_pax=" + this.state.noofAdults + "&no_of_children_pax=" + this.state.noofChildren, apiheaderauth).then(function (res) {
	
								if (res.data.status === "ok") {
	
									document.getElementById("goback_arwId").style.display = "block";
									document.getElementById("loadIcon").style.display = "none";
									document.getElementById("InformationLi").className = "active";
									document.getElementById("tab1").className = "tab-pane";
									document.getElementById("tab2").className = "tab-pane active";
	
									_this10.setState({ manualLoading: false }, function () {
										this.loadManualLoading();
									});
								} else {
	
									_this10.setState({ manualLoading: false }, function () {
										this.loadManualLoading();
									});
	
									helper.showInfo(res.data.message);
								}
							});
							console.log('next-tab');
						}
					} else {
	
						document.getElementById("InformationLi").className = "active";
						document.getElementById("tab1").className = "tab-pane";
						document.getElementById("tab2").className = "tab-pane active";
						this.setState({ ResStageTxt: 'info' });
						//$('.goback_arwcls').show();
						document.getElementById("goback_arwId").style.display = "block";
						console.log('next-tab');
	
						this.setState({
							manualLoading: false
						}, function () {
							this.loadManualLoading();
						});
					}
				}
			}
		}, {
			key: 'orderComfirmSubmtn',
			value: function orderComfirmSubmtn() {
				var _this11 = this;
	
				this.setState({ manualLoading: true }, function () {
					this.loadManualLoading();
				});
				document.getElementById("resvloadIcon").style.display = "block";
	
				var reservation_time = "";
				var reservation_slot_end_time = "";
	
				if (_reactCookie2.default.load("advanced_time_slot_reservation_enable") === "1") {
	
					if (this.state.time_slot_type_advanced === "1") {
	
						var RsResTimeVal = document.getElementById("deliveryTime").value;
						var getValue = this.formatAMPM(RsResTimeVal);
						var testing = document.getElementById("deliveryTime").value + ":" + document.getElementById("deliveryMins").value + ":00";
						reservation_time = getValue + "-" + testing;
						reservation_slot_end_time = testing;
					} else {
						var timeslot_date = document.getElementById("timeSlot").value;
						console.log(timeslot_date, "timeslot_date");
	
						var split_time_slot = timeslot_date.split("/");
						console.log(split_time_slot, "split_time_slot");
						var get_split_time = split_time_slot[0].split("-");
	
						console.log(get_split_time, "get_split_time");
	
						var getValue = this.formatAMPM(get_split_time[0].substring(0, 2));
						var getValue1 = this.formatAMPM(get_split_time[1].substring(0, 2));
						var prevTimeSlotValue = getValue === getValue1 ? getValue1 : getValue1;
						reservation_time = getValue + "-" + get_split_time[0];
						reservation_slot_end_time = get_split_time[1];
					}
				} else {
	
					reservation_time = this.state.resTimeval;
					reservation_slot_end_time = reservation_time;
				}
	
				var qs = __webpack_require__(3);
				var orderPostObject = { "app_id": APPID,
					"availability_id": config.ids.reservationId,
					"order_source": 'Web',
					"reservation_status": '0',
					"customer_id": _reactCookie2.default.load('UserId'),
					"customer_fname": _reactCookie2.default.load('UserFname'),
					"customer_lname": _reactCookie2.default.load('UserLname'),
					"customer_email": _reactCookie2.default.load('UserEmail'),
					"customer_mobile_no": _reactCookie2.default.load('UserMobile'),
					"reservation_outlet_id": this.state.selectResOutlet,
					"reservation_outlet_name": this.state.selectResOutletOptionTxt,
					"reservation_datetime": this.state.ResselectedDateInst,
					"reservation_outlet_time": reservation_time,
					"reservation_no_of_adult_pax": this.state.noofAdults,
					"reservation_no_of_children_pax": this.state.noofChildren,
					"reservation_instruction": this.state.resRemarkDes,
					'reservation_slot_end_time': reservation_slot_end_time,
					'time_slot_type_advanced': _reactCookie2.default.load("advanced_time_slot_reservation_enable") === "1" ? this.state.time_slot_type_advanced : ""
				};
	
				_axios2.default.post(APIURL + "reservation/reservation_submit_order", qs.stringify(orderPostObject)).then(function (response) {
					document.getElementById("resvloadIcon").style.display = "none";
					if (response.data.status === "ok") {
						_this11.setState({ resOrdermsg: response.data.message });
						_this11.setState({ resOrderPrmryId: response.data.common.order_primary_id });
						_this11.setState({ resOrderId: response.data.common.local_order_no });
						document.getElementById("ConfirmationLi").className = "active";
						document.getElementById("tab2").className = "tab-pane";
						document.getElementById("tab3").className = "tab-pane active";
						_this11.setState({ ResStageTxt: '' });
						//$('.goback_arwcls').hide();
						document.getElementById("goback_arwId").style.display = "none";
	
						_this11.setState({
							manualLoading: false
						}, function () {
							this.loadManualLoading();
						});
					}
				}).catch(function (error) {
	
					this.setState({
						manualLoading: false
					}, function () {
						this.loadManualLoading();
					});
	
					console.log(error);
				});
			}
		}, {
			key: 'gotoMyAcct',
			value: function gotoMyAcct() {
				$("body").removeClass("reservationPopup");
				$("#ReservationMdl").modal("hide");
				if (typeof _reactCookie2.default.load('UserId') === "undefined" || _reactCookie2.default.load('UserId') && _reactCookie2.default.load('UserId') === "") {
					_reactRouter.hashHistory.push(this.getSignInlink());
				} else {
					_reactRouter.hashHistory.push("/my-account");
				}
			}
		}, {
			key: 'closeResvPoup',
			value: function closeResvPoup() {
				$("body").removeClass("reservationPopup");
				_reactCookie2.default.save('reserVationClick', '');
			}
		}, {
			key: 'getSignInlink',
			value: function getSignInlink() {
				return parseInt(this.state.settings.client_enable_express_checkout) === 1 ? '/new-signin' : '/sign-in';
			}
	
			/* Menu open and close */
	
		}, {
			key: 'openNavmenu',
			value: function openNavmenu() {
				//console.log('open');
				_reactCookie2.default.save('navmenuClk', 'open');
				document.getElementById("mySidenav").className = "sidenav nav-width";
				document.getElementById("parentDisable").style.display = "block";
				this.setState({ openNav: 'side-l side-l-tran' }); //rewadNav
				this.setState({ rewadNav: 'side-l side-l-tran' });
				//	$("#promo_popup").modal("toggle"); 
			}
		}, {
			key: 'closeNav',
			value: function closeNav() {
				if (_reactCookie2.default.load("navmenuClk") === "open") {
					_reactCookie2.default.save('navmenuClk', 'no');
					document.getElementById("mySidenav").className = "sidenav";
					document.getElementById("parentDisable").style.display = "none";
					this.setState({ openNav: 'side-l side-l-out' });
					this.setState({ rewadNav: 'side-l side-l-out' });
				}
			}
	
			/* avilablity buttons */
	
		}, {
			key: 'showAvilablityItems',
			value: function showAvilablityItems() {
				var _this12 = this;
	
				if (this.state.settings.availability) {
					return this.state.settings.availability.map(function (loaddata, index) {
						return _react2.default.createElement(
							'div',
							{ className: 'modal-button', key: index },
							_this12.allowPickupOption(loaddata.availability_id),
							_this12.allowDeliveryOption(loaddata.availability_id),
							_this12.allowdineinOption(loaddata.availability_id),
							_this12.allowReservationOption(loaddata.availability_id)
						);
					});
				}
	
				/* return  (<div className="col-xs-12 modal-button">
	   <button className={this.isActive(lang.delivery)}   type="button" id="delivery" name="delivery" onClick={this.changeAvilablityTemp.bind(this,config.ids.deliveryId,lang.delivery,lang.deliveryImageWhite)}> <img alt=""  src={this.activeImage(lang.delivery)} className="icon-img-small1"/> {" "} {lang.delivery} </button>
	   	    {this.allowPickupOption()}
	              {this.allowdineinOption()} 
	   	
	   </div>)*/
			}
	
			/* function used to allow pickup */
	
		}, {
			key: 'allowDeliveryOption',
			value: function allowDeliveryOption(availId) {
				if (availId === config.ids.deliveryId) {
					return _react2.default.createElement(
						'button',
						{ className: this.isActive(lang.delivery), type: 'button', id: 'delivery', name: 'delivery', onClick: this.changeAvilablityTemp.bind(this, config.ids.deliveryId, lang.delivery, lang.deliveryImageWhite) },
						' ',
						_react2.default.createElement('img', { alt: '', src: this.activeImage(lang.delivery), className: 'icon-img-small1' }),
						' ',
						" ",
						' ',
						lang.delivery,
						' '
					);
				}
			}
	
			/* this function allow dine-in option */
	
		}, {
			key: 'allowdineinOption',
			value: function allowdineinOption(availId) {
				if (availId === config.ids.dineinId) {
					return _react2.default.createElement(
						'button',
						{ className: this.isActive("Dine In"), type: 'button', id: 'dine-in', name: 'dine-in', onClick: this.changeAvilablityTemp.bind(this, config.ids.dineinId, "Dine In", lang.dineInImageWhite) },
						' ',
						_react2.default.createElement('img', { alt: '', src: this.activeImage('Dine In'), className: 'icon-img-small1' }),
						' ',
						" ",
						' ',
						"Dine In"
					);
				}
			}
	
			/* allow  pick up option */
	
		}, {
			key: 'allowPickupOption',
			value: function allowPickupOption(availId) {
				if (availId === config.ids.pickupId) {
					return _react2.default.createElement(
						'button',
						{ className: this.isActive(lang.takeaWay), type: 'button', id: 'takeaway', name: 'takeaway', onClick: this.changeAvilablityTemp.bind(this, config.ids.pickupId, lang.takeaWay, lang.takeaWayImageWhite) },
						' ',
						_react2.default.createElement('img', { alt: '', src: this.activeImage(lang.takeaWay), className: 'icon-img-small1' }),
						' ',
						lang.takeaWay,
						' '
					);
				}
			}
	
			/* function used to allow reservation */
	
		}, {
			key: 'allowReservationOption',
			value: function allowReservationOption(availId) {
				if (availId === config.ids.reservationId) {
					return _react2.default.createElement(
						'button',
						{ className: this.isActive(lang.reservation), type: 'button', id: 'reservation', name: 'reservation', onClick: this.changeAvilablityTemp.bind(this, config.ids.reservationId, lang.reservation, lang.reservationImageWhite) },
						' ',
						_react2.default.createElement('img', { alt: '', src: this.activeImage(lang.reservation), className: 'icon-img-small1' }),
						' ',
						" ",
						' ',
						lang.reservation,
						' '
					);
				}
			}
		}, {
			key: 'berforeopenReserVtnPopup',
			value: function berforeopenReserVtnPopup() {
	
				this.setState({ restimetxt: timetxt });
				var ReservationtimeDown = htmlToReactParser.parse("<option value=''>Select Time</option>");
				this.setState({ ReservationtimeHtml: ReservationtimeDown });
	
				this.setState({ selectResOutletAdrr: '' });
				this.setState({ selectResOutletAdrrAndId: '' });
				this.setState({ selectResOutletOptionTxt: '' });
				this.setState({ noofAdultHtml: '' });
				this.setState({ noofChildrenHtml: '' });
				this.setState({ ResPeopleTxt: '' });
				this.setState({ ResselectedDayTxt: '' });
				this.setState({ ResselectedDateTxt: '' });
				this.setState({ ResselectedDateInst: '' });
				this.setState({ resTimeText: '' });
				this.setState({ resRemarkDes: '' });
				this.setState({ ResStageTxt: '' });
				this.setState({ resOrderId: '' });
				this.getAllOutlets();
				this.getsettings();
			}
		}, {
			key: 'openReserVtnPopup',
			value: function openReserVtnPopup() {
				document.body.classList.add('reservationPopup');
	
				//$('.goback_arwcls').hide();
				document.getElementById("goback_arwId").style.display = "none";
	
				this.setState({ restimetxt: timetxt });
				var ReservationtimeDown = htmlToReactParser.parse("<option value=''>Select Time</option>");
				this.setState({ ReservationtimeHtml: ReservationtimeDown });
	
				this.setState({ selectResOutletAdrr: '' });
				this.setState({ selectResOutletAdrrAndId: '' });
				this.setState({ selectResOutletOptionTxt: '' });
				this.setState({ noofAdultHtml: '' });
				this.setState({ noofChildrenHtml: '' });
				this.setState({ ResPeopleTxt: '' });
				this.setState({ ResselectedDayTxt: '' });
				this.setState({ ResselectedDateTxt: '' });
				this.setState({ ResselectedDateInst: '' });
				this.setState({ resTimeText: '' });
				this.setState({ resRemarkDes: '' });
				this.setState({ ResStageTxt: '' });
				this.setState({ resOrderId: '' });
	
				this.getAllOutlets();
	
				$("#ReservationMdl").modal({
					backdrop: 'static',
					keyboard: false
				});
			}
	
			/* change Availability - default delievry  */
	
		}, {
			key: 'changeAvilablityTemp',
			value: function changeAvilablityTemp(avail, availText, availImage) {
				$("body").removeClass("addresslistPopup");
				this.setState({ zoneOutletSeleted: "" });
	
				if (this.state.onetimeclickstate === "Yes") {
					this.setState({ onetimeclickstate: 'No' });
					_reactCookie2.default.save('onetimeClick', 'Yes', { expires: expires });
				}
	
				if (avail === config.ids.reservationId) {
					_reactCookie2.default.save('itsfromreservation', 'yes');
					document.getElementById("ReservationLiId").className = "active";
					document.getElementById("InformationLi").className = "";
					document.getElementById("ConfirmationLi").className = "";
					document.getElementById("tab1").className = "tab-pane active";
					document.getElementById("tab2").className = "tab-pane";
					document.getElementById("tab3").className = "tab-pane";
	
					if (typeof _reactCookie2.default.load('UserId') === "undefined" || _reactCookie2.default.load('UserId') && _reactCookie2.default.load('UserId') === "") {
						_reactCookie2.default.save('reserVationClick', 'fromhome');
						_reactRouter.hashHistory.push(this.getSignInlink());
					} else {
	
						this.openReserVtnPopup();
					}
				} else {
					_reactCookie2.default.save('itsfromreservation', 'no');
	
					if (avail === config.ids.deliveryId) {
						this.getSecAddr();
					}
	
					this.setState({ avail: avail });
					this.setState({ availText: availText });
					this.setState({ availImage: availImage });
	
					//if(cookie.load('defaultAvilablityId')!== avail){
					if (_reactCookie2.default.load('cartValue') === 'Yes') {
						//alert(); 
	
						$("#SwitchingError").modal("toggle");
					} else {
						this.clearCookieValues();
						this.changeAvilablity(avail, availText, availImage);
					}
					//}
				}
			}
	
			/* add zero */
	
		}, {
			key: 'pad',
			value: function pad(d) {
				return d < 10 ? '0' + d.toString() : d.toString();
			}
		}, {
			key: 'destroyCart',
	
	
			/* this function used to delte all  cart items */
			value: function destroyCart() {
				var postObject = {};
				postObject = { 'app_id': config.ids.appId };
				if (typeof _reactCookie2.default.load('UserId') === 'undefined') {
					var customerKey = 'reference_id';
					var customerVal = (0, _Api2.default)('referenceId');
				} else {
					customerKey = 'customer_id';
					customerVal = _reactCookie2.default.load('UserId');
				}
				postObject[customerKey] = customerVal;
				var qs = __webpack_require__(3);
				_axios2.default.post(APIURL + "cart/destroy", qs.stringify(postObject)).then(function (res) {
					_reactCookie2.default.save('cartValue', 'No');
					if (res.data.status === "ok") {
	
						$(".carticon").attr("src", "/img/icons/shopping-cart.png");
					} else if (res.data.status === "error") {}
				});
			}
	
			/* used to delete all cookie values */
	
		}, {
			key: 'clearCookieValues',
			value: function clearCookieValues() {
				_reactCookie2.default.remove('orderOutletId');
				_reactCookie2.default.remove('orderZoneID');
				_reactCookie2.default.remove('orderOutletName');
				_reactCookie2.default.remove('orderPostalCode');
				_reactCookie2.default.remove('orderTAT');
				_reactCookie2.default.remove('orderDeliveryAddress');
				_reactCookie2.default.remove('orderHandled');
				_reactCookie2.default.remove('orderHandledByText');
			}
	
			/* change Availability - default delievry  */
	
		}, {
			key: 'changeAvilablity',
			value: function changeAvilablity(avail, availText, availImage) {
	
				this.savedefaultCookie(avail, availText, availImage);
				this.setState({ defaultAvilablity: availText });
				console.log(avail);
				this.loadMenuNavigation(avail, availText, availImage, ''); /* removed Yes for loading issue */
				if (_reactCookie2.default.load('applyOutletId') === 'yes') {
					this.openOrderTupeChangeFun();
				}
			}
			/* this function used to set default cookie values */
	
		}, {
			key: 'savedefaultCookie',
			value: function savedefaultCookie(avail, availText, availImage) {
				_reactCookie2.default.save('defaultAvilablityId', avail, {});
				_reactCookie2.default.save('defaultAvilablity', availText, {});
				_reactCookie2.default.save('defaultAvilablityImage', availImage, {});
			}
			/* this function used to load cart icon image */
	
		}, {
			key: 'loadCartImage',
			value: function loadCartImage() {
				return (0, _Api2.default)('cartImage', 'Yes');
			}
	
			/* this function used to load menu navigation */
	
		}, {
			key: 'loadMenuNavigation',
			value: function loadMenuNavigation(currentAvi, availText, availImage, loading) {
				var _this13 = this;
	
				if (loading === "Yes") {
					this.setState({ navStatus: "Loading" });
				}
	
				var orderOutletIdTxt = _reactCookie2.default.load('orderOutletId');
				var addqueryTxt = '';
	
				if (typeof orderOutletIdTxt !== "undefined" && orderOutletIdTxt !== '') {
					addqueryTxt = "&outletIdTxt=" + orderOutletIdTxt;
				}
	
				_axios2.default.get(APIURL + 'productsver3/navigation_menu?app_id=' + APPID + addqueryTxt + "&availability=" + currentAvi).then(function (res) {
					if (res.data.status === "ok") {
						_this13.setState({ navStatus: res.data.status });
						_this13.setState({ common: res.data.common });
						_this13.setState({ category: res.data.result_set });
						_this13.setState({ defaultAvilablityImage: availImage });
						_this13.setState({ defaultAvilablity: availText });
	
						// this.setstate({defaultAvilablityImage:availImage });
					} else {
						_this13.setState({ navStatus: res.data.status });
					}
				});
			}
		}, {
			key: '__showBanners',
			value: function __showBanners() {
				var _this14 = this;
	
				this.__bxslider();
	
				if (this.state.banner) {
					return this.state.banner.map(function (loaddata, index) {
						return _react2.default.createElement(
							'div',
							{ key: index },
							_react2.default.createElement('img', { src: _this14.state.bannersource + loaddata.banner_image, alt: 'Loading...' })
						);
					});
				} else {
					return _react2.default.createElement(
						'div',
						null,
						' ',
						_react2.default.createElement('img', { src: 'img/header-img.jpg', alt: 'Loading...' }),
						' '
					);
				}
			}
	
			/* listing navigation  items.. */
	
		}, {
			key: '__ProductListing',
			value: function __ProductListing() {
				var _this15 = this;
	
				if (this.state.navStatus === "Loading2") {
					return _react2.default.createElement(
						'div',
						{ className: 'home-load-div' },
						' ',
						_react2.default.createElement('img', { src: '/img/loader.gif', alt: '', className: 'home-load-img' }),
						' '
					);
				} else if (this.state.navStatus === "ok") {
					return this.state.category.map(function (loaddata, index) {
						return _react2.default.createElement(
							'div',
							{ className: 'col-xs-12 nopadding home-bottom-img', key: index },
							_react2.default.createElement(
								'div',
								{ className: 'gradient-img' },
								'  ',
								_react2.default.createElement(
									_reactRouter.Link,
									{ key: index, to: _this15.__navLink(loaddata.menu_type, loaddata.menu_category_id, loaddata.pro_subcate_id, index) },
									_react2.default.createElement('img', { src: _this15.__navImage(loaddata.menu_type, loaddata.pro_cate_image, loaddata.pro_subcate_image, _this15.state.common.category_image_url, _this15.state.common.subcategory_image_url), alt: '', className: 'img-responsive' }),
									_react2.default.createElement(
										'p',
										{ className: 'text-left font-bold text-uppercase pd-l-20' },
										strp.stripslashes(loaddata.menu_custom_title)
									)
								)
							)
						);
					});
				} else {
	
					if (!helper.disableSpecialInstructions(APPID)) {
						return null;
					} else {
						return _react2.default.createElement(
							'div',
							{ className: 'col-xs-12 nopadding home-bottom-img no_pro_home' },
							'  ',
							_react2.default.createElement(
								'span',
								null,
								' ',
								lang.no_products_found,
								'  '
							),
							' '
						);
					}
				}
			}
	
			/* return navigation menu slug */
	
		}, {
			key: '__navLink',
			value: function __navLink(menu_type, CateId, subCateId, slideno) {
				return menu_type === "sub" ? "/products/subcategory/" + subCateId + "/" + slideno : "/products/category/" + CateId + "/" + slideno;
			}
	
			/* return navigation image value.  like no image, category image, sub category image */
	
		}, {
			key: '__navImage',
			value: function __navImage(menuType, cateImgae, subCateImage, cateUrl, subcateUrl) {
				var image = menuType === "sub" ? subCateImage : cateImgae;
				var imageUrl = menuType === "sub" ? subcateUrl : cateUrl;
				return image === null || image === "" ? "/img/no-images/products-no-image.jpg" : config.path.tinThumpUrl + imageUrl + "/" + image + "&w=768&h=265&q=80";
			}
	
			/* this function used to add active class for selected avilablity */
	
		}, {
			key: 'isActive',
			value: function isActive(value) {
				//alert(value + "//" + this.state.defaultAvilablity);
				//value = (value === "Dine in"? "Dine In" : value);
				return value === this.state.defaultAvilablity ? 'btn active' : 'btn in-active';
			}
	
			/* this function used to show active images  */
	
		}, {
			key: 'activeImage',
			value: function activeImage(value) {
				//return (value === this.state.defaultAvilablity? 'btn active': 'btn in-active');
				if (value === this.state.defaultAvilablity) {
					return value === "Dine In" ? lang.dineInImageWhiteDefault : "/img/icons/home-popup/" + this.state.defaultAvilablity + "_white.svg";
				} else {
					return value === "Dine In" ? lang.dineInImage : "/img/icons/home-popup/" + value + ".svg";
				}
			}
	
			/* login part */
	
		}, {
			key: 'loginPart',
			value: function loginPart() {
				if (typeof _reactCookie2.default.load('UserId') !== 'undefined' && this.state.login === "") {
					return _react2.default.createElement(
						'div',
						{ className: 'logout-menu' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ className: this.state.openNav, onClick: this.logOut.bind(this), style: { cursor: 'pointer' } },
							_react2.default.createElement('img', { alt: '', src: '/img/icons/logout.png' }),
							' ',
							" ",
							'Logout',
							_react2.default.createElement(
								'p',
								{ className: 'subb' },
								'Signed in as ',
								_reactCookie2.default.load('UserEmail')
							)
						)
					);
				}
			}
		}, {
			key: 'loginPartHeader',
			value: function loginPartHeader() {
				if (typeof _reactCookie2.default.load('UserId') !== 'undefined' && this.state.login === "") {
					return _react2.default.createElement(
						'div',
						{ className: 'login-header' },
						_react2.default.createElement(
							'div',
							{ className: 'member', style: { flexGrow: '9' } },
							_react2.default.createElement(
								'p',
								null,
								' Hello, ',
								_reactCookie2.default.load('UserFname')
							),
							_react2.default.createElement('img', { src: 'img/hi.gif' })
						),
						_react2.default.createElement(
							'div',
							{ style: { flexGrow: '3' }, className: 'sign-out' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ onClick: this.logOut.bind(this), style: { cursor: 'pointer' } },
								' ',
								" ",
								'Logout'
							)
						)
					);
				}
			}
		}, {
			key: 'signinHeader',
			value: function signinHeader() {
				if (typeof _reactCookie2.default.load('UserId') === "undefined" || _reactCookie2.default.load('UserId') && _reactCookie2.default.load('UserId') === "") {
					return _react2.default.createElement(
						'div',
						{ className: 'signin-container' },
						_react2.default.createElement('div', { style: { flexGrow: '4' } }),
						_react2.default.createElement(
							'div',
							{ className: 'not-a-member', style: { flexGrow: '6' } },
							'Signup as a member today! '
						),
						_react2.default.createElement(
							'div',
							{ className: 'sign-in', style: { flexGrow: '2' } },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: this.getSignInlink() },
								'Signup'
							)
						)
					);
				}
			}
		}, {
			key: 'closeSwitcher',
			value: function closeSwitcher() {
	
				$("#SwitchingError").modal("hide");
				document.body.classList.add('home_body');
			}
		}, {
			key: 'closeAndBrowse',
			value: function closeAndBrowse() {
				$("#onload-screen").modal("hide");
				$('.modal-backdrop').remove();
			}
		}, {
			key: 'switchAvailability',
			value: function switchAvailability() {
	
				var avail = this.state.avail;
				var availText = this.state.availText;
				var availImage = this.state.availImage;
				this.changeAvilablity(avail, availText, availImage);
				this.destroyCart();
	
				/* remove default cokkie values */
				_reactCookie2.default.remove('orderOutletId');
				_reactCookie2.default.remove('orderOutletName');
				_reactCookie2.default.remove('orderPostalCode');
				_reactCookie2.default.remove('orderTAT');
				_reactCookie2.default.remove('orderDeliveryAddress');
				_reactCookie2.default.remove('orderHandled');
				_reactCookie2.default.remove('orderHandledByText');
	
				_reactCookie2.default.remove('outlet_tax_option');
				_reactCookie2.default.remove('outlet_tax_surcharge');
				_reactCookie2.default.remove('outlet_tax_surcharge_inclusive');
	
				_reactCookie2.default.remove('product_remarks');
	
				$("#SwitchingError").modal("toggle");
			}
		}, {
			key: 'logOut',
			value: function logOut() {
				//console.log('logout');
				_reactCookie2.default.remove("UserId");
				_reactCookie2.default.remove("UserFname");
				_reactCookie2.default.remove("UserLname");
				_reactCookie2.default.remove("UserMobile");
				_reactCookie2.default.remove("UserEmail");
				_reactCookie2.default.remove("userAccountType");
				_reactCookie2.default.remove("isAnonymousUser");
				_reactCookie2.default.remove("isTempUser");
				// this.closeNav();
				this.setState({ login: 'No' });
				_reactRouter.hashHistory.push(this.getSignInlink());
			}
	
			/* this function used to show office timing*/
	
		}, {
			key: 'showTimer',
			value: function showTimer() {
				//console.log(this.state.settings.client_delivery_enable);
				/* if(parseFloat(this.state.settings. 	client_timer_enable) === 1 && this.state.settings.client_start_time!=='' && this.state.settings.client_end_time!=='') { 
	    return (<p className="b-txt text-right pd-r-20">{this.state.settings.ninja_pro_operation_time_start} - {this.state.settings.ninja_pro_operation_time_end} </p>);
	   /*  }  */
	
				return helper.shopTiming(this.state.settings.ninja_pro_operation_time_start, this.state.settings.ninja_pro_operation_time_end);
			}
			/* open  direction link */
	
		}, {
			key: 'targetMap',
			value: function targetMap() {
				if (typeof this.state.settings.ninja_pro_direction_url != "undefined" || this.state.settings.ninja_pro_direction_url !== "") {
					window.open(this.state.settings.ninja_pro_direction_url);
				}
			}
	
			/* load home banner image */
	
		}, {
			key: 'homeBanner',
			value: function homeBanner() {
				//img/logo.png
				return typeof this.state.settings.ninja_pro_home_banner === "undefined" || this.state.settings.ninja_pro_home_banner === "" ? "/img/no-images/products-no-image.jpg" : config.path.tinThumpUrl + this.state.settings.ninja_pro_home_banner + "&w=768&h=265&q=80";
			}
			/* load home logo  image */
	
		}, {
			key: 'loadLogo',
			value: function loadLogo() {
				//img/logo.png
				return typeof this.state.settings.ninja_pro_logo === "undefined" || this.state.settings.ninja_pro_logo === "" ? "/img/logo.png" : config.path.tinThumpUrl + this.state.settings.ninja_pro_logo + "&w=191&h=51&q=80";
			}
	
			/* this function used to load mobile number */
	
		}, {
			key: 'loadNumber',
			value: function loadNumber() {
				if (typeof this.state.settings.ninja_pro_phone_number != "undefined" || this.state.settings.ninja_pro_phone_number !== "") {
					return "tel:" + this.state.settings.ninja_pro_phone_number;
				}
			}
		}, {
			key: 'loadPopupLogoImage',
			value: function loadPopupLogoImage() {
	
				if (typeof this.state.settings.ninja_pro_welcome_logo === "undefined" || this.state.settings.ninja_pro_welcome_logo === "") {
					if (typeof this.state.settings.ninja_pro_logo === "undefined" || this.state.settings.ninja_pro_logo === "") {
						return "/img/logo.png";
					} else {
						return config.path.tinThumpUrl + this.state.settings.ninja_pro_logo + "&w=191&h=51&q=80";
					}
				} else {
					return config.path.tinThumpUrl + this.state.settings.ninja_pro_welcome_logo + "&w=370&h=94&q=80";
				}
				//return  (typeof this.state.settings.ninja_pro_welcome_logo === "undefined" || this.state.settings.ninja_pro_welcome_logo === "" )? "/img/logo.png" : config.path.tinThumpUrl+this.state.settings.ninja_pro_welcome_logo+"&w=370&h=94&q=80";
				//     return  (typeof this.state.settings.ninja_pro_logo === "undefined" || this.state.settings.ninja_pro_logo === "" )? "/img/logo.png" : config.path.tinThumpUrl+this.state.settings.ninja_pro_logo+"&w=191&h=51&q=80";
			}
		}, {
			key: 'loadPopupBackgroundImage',
			value: function loadPopupBackgroundImage() {
				//img/logo.png
				return typeof this.state.settings.ninja_pro_bg_image === "undefined" || this.state.settings.ninja_pro_bg_image === "" ? "/img/popup-images/popup-bg.jpg" : this.state.settings.ninja_pro_bg_image;
			}
		}, {
			key: 'loadPopupWelcomeText',
			value: function loadPopupWelcomeText() {
				var homeHeaderText = "How will you be enjoying <br/> your food today?";
				return htmlToReactParser.parse(this.state.settings.ninja_pro_welcome_text === null || this.state.settings.ninja_pro_welcome_text === "" ? homeHeaderText : this.state.settings.ninja_pro_welcome_text);
			}
	
			/* food types */
	
		}, {
			key: 'foodTypes',
			value: function foodTypes() {
	
				if (this.state.settings.ninja_pro_food_types && this.state.settings.ninja_pro_food_types.length > 0) {
					return this.state.settings.ninja_pro_food_types.map(function (loaddata, index) {
						return _react2.default.createElement(
							'button',
							{ key: index, type: 'button', className: 'btn pull-right food-type-btn', style: { cursor: 'text' } },
							loaddata
						);
					});
				}
			}
	
			/* get Promo code  details */
	
		}, {
			key: 'getPromocode',
			value: function getPromocode() {
				var _this16 = this;
	
				var inputEmail = $("#promoEmail").val();
				if (this.isValidEmailAddress(inputEmail)) {
					var qs = __webpack_require__(3);
					var promoPostObject = { 'app_id': config.ids.appId, 'email_address': inputEmail };
					document.getElementById("loadIcon").style.display = "block";
					_axios2.default.post(APIURL + "promotion/user_promotion", qs.stringify(promoPostObject)).then(function (res) {
						document.getElementById("loadIcon").style.display = "none";
						$("#promo_popup").modal("hide");
						_this16.DisablePromoPopup();
						if (res.data.status === "ok") {
							helper.showInfo(alerts.promopopSuc);
						} else if (res.data.status === "error") {
							helper.showInfo(alerts.promopopFail);
						}
					});
				} else {
					helper.showInfo(alerts.invalidEmail);
				}
			}
	
			/* set promocode disable value */
	
		}, {
			key: 'DisablePromoPopup',
			value: function DisablePromoPopup() {
				_reactCookie2.default.save('promoPopup', 'Yes');
			}
	
			/* validate email address */
	
		}, {
			key: 'isValidEmailAddress',
			value: function isValidEmailAddress(emailAddress) {
				var pattern = new RegExp(/^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i);
				// alert( pattern.test(emailAddress) );
				return pattern.test(emailAddress);
			}
		}, {
			key: 'toggleCheckbox',
	
	
			/* Don't show promo popup */
	
			value: function toggleCheckbox() {
				_reactCookie2.default.save('NormalPopup', 'Yes');
				$("#normal_popup").modal("hide");
			}
	
			/* bx slider  - no pager class */
	
		}, {
			key: 'bxNoPager',
			value: function bxNoPager() {
				var sliderLen = this.state.banner;
				console.log(sliderLen.lenght);
				if (this.state.banner.lenght === 1) {
					return "bx-slide-single";
				}
			}
	
			/* Hide  drop down work space site */
	
		}, {
			key: 'hidedropDown',
			value: function hidedropDown() {
				return APPID === apps.workspace ? "none" : "block";
			}
	
			/* continue with pickup success */
	
		}, {
			key: 'pickupSuccess',
			value: function pickupSuccess() {
				/* load menu items */
				this.loadMenuNavigation(config.ids.pickupId, lang.takeaWay, lang.takeaWayImageWhite, '');
				$("#Pickup-Sucess").modal("hide");
				$("#pickup-outlet-sucess").modal('hide');
				$("#onload-screen").modal("hide");
				$('.modal-backdrop').remove();
				this.setState({ onetimeclickstate: 'No' });
				_reactCookie2.default.save('onetimeClick', 'Yes', { expires: expires });
			}
	
			/* continue with delivery success */
	
		}, {
			key: 'deliverySuccess',
			value: function deliverySuccess() {
				this.loadMenuNavigation(config.ids.deliveryId, lang.delivery, lang.deliveryImageWhite, '');
				$("body").removeClass("addresslistPopup");
				$("#DeliverySucess").modal("hide");
	
				this.setState({ load: "false" });
				$("#onload-screen").modal("hide");
				$('.modal-backdrop').remove();
				this.setState({ onetimeclickstate: 'No' });
				_reactCookie2.default.save('onetimeClick', 'Yes', { expires: expires });
			}
		}, {
			key: 'closeDeliveryErr',
			value: function closeDeliveryErr() {
				this.setState({ load: "false" });
				$("#DeliveryError").modal("toggle");
			}
		}, {
			key: 'closeShopClosedError',
			value: function closeShopClosedError() {
				this.setState({ load: "false" });
				$("#ShopClosedError").modal("toggle");
			}
		}, {
			key: 'closeaddlist',
			value: function closeaddlist() {
				$("body").removeClass("addresslistPopup");
			}
	
			/* Open Zipcode popup */
	
		}, {
			key: 'changeDelivery',
			value: function changeDelivery() {
				this.setState({ load: "false" });
				$("#DeliveryError").modal("hide");
				console.log("login");
				if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
					document.body.classList.add('addresslistPopup');
					$("#AddressList").modal({ backdrop: 'static', keyboard: false });
				} else {
	
					$("#DeliveryAddress").modal({ backdrop: 'static', keyboard: false });
				}
			}
	
			/* add outlet ids work spac */
	
		}, {
			key: 'addWorkSpaceCookieValues',
			value: function addWorkSpaceCookieValues(data) {
	
				var loaddata = data[0];
				var outlet_name = helper.stripslashes(loaddata.outlet_name);
				var outlet_id = loaddata.outlet_id,
				    loaddata;
				var outlet_address_line1 = loaddata.outlet_address_line1;
				var outlet_address_line2 = loaddata.outlet_address_line2;
				var outlet_postal_code = loaddata.outlet_postal_code;
				var outlet_pickup_tat = loaddata.outlet_postal_code;
	
				var orderHandled = outlet_name + " " + outlet_address_line1 + " " + outlet_address_line2 + ", Singapore " + outlet_postal_code;
	
				this.setState({ orderHandled: orderHandled });
				_reactCookie2.default.save('orderOutletId', outlet_id);
				_reactCookie2.default.save('orderOutletName', outlet_name);
				_reactCookie2.default.save('orderPostalCode', outlet_postal_code);
				_reactCookie2.default.save('orderTAT', outlet_pickup_tat);
				_reactCookie2.default.save('orderHandled', orderHandled);
				_reactCookie2.default.save('orderHandledByText', orderHandled);
			}
	
			/* pick outlet */
	
		}, {
			key: 'pickOutlet',
			value: function pickOutlet(outlet_id, outlet_name, outlet_postal_code, outlet_address_line1, outlet_address_line2, outlet_unit_number1, outlet_unit_number2, outlet_pickup_tat, outlet_tax_option, outlet_tax_surcharge, outlet_tax_surcharge_inclusive) {
	
				if (outlet_unit_number1 != '' && outlet_unit_number2 != '') {
					var unitTxt = ", #" + outlet_unit_number1 + "-" + outlet_unit_number2;
					var orderHandled = outlet_name + " " + outlet_address_line1 + " " + outlet_address_line2 + unitTxt + ", Singapore " + outlet_postal_code;
				} else if (outlet_unit_number1 != '' || outlet_unit_number2 != '') {
					var unitTxt = outlet_unit_number1 != '' ? ", #" + outlet_unit_number1 : ", #" + outlet_unit_number2;
					var orderHandled = outlet_name + " " + outlet_address_line1 + " " + outlet_address_line2 + unitTxt + ", Singapore " + outlet_postal_code;
				} else {
					var orderHandled = outlet_name + " " + outlet_address_line1 + " " + outlet_address_line2 + ", Singapore " + outlet_postal_code;
				}
	
				this.setState({ orderHandled: orderHandled });
				_reactCookie2.default.save('orderOutletId', outlet_id);
				_reactCookie2.default.save('orderOutletName', outlet_name);
				_reactCookie2.default.save('orderPostalCode', outlet_postal_code);
				_reactCookie2.default.save('orderTAT', outlet_pickup_tat);
				_reactCookie2.default.save('orderHandled', orderHandled);
				_reactCookie2.default.save('orderHandledByText', orderHandled);
	
				_reactCookie2.default.save('outlet_tax_option', outlet_tax_option);
				_reactCookie2.default.save('outlet_tax_surcharge', outlet_tax_surcharge);
				_reactCookie2.default.save('outlet_tax_surcharge_inclusive', outlet_tax_surcharge_inclusive);
	
				$("#Pickup-OutletSelection").modal("hide");
				$("#Pickup-Sucess").modal({ backdrop: 'static', keyboard: false });
			}
		}, {
			key: 'openOrderTupeChangeFun',
			value: function openOrderTupeChangeFun() {
				if (_reactCookie2.default.load('applyOutletId') === 'yes' && _reactCookie2.default.load('navmenuClk') === 'no' && _reactCookie2.default.load('itsfromreservation') !== 'yes') {
					console.log(1);
					if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && _reactCookie2.default.load('defaultAvilablity') === lang.delivery) {
						console.log(2);
						if (typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderPostalCode') === "undefined") {
							console.log(3);
							if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
								document.body.classList.add('addresslistPopup');
								if (parseInt(this.state.settings.client_outlet_zone) === 0) {
									$("#AddressList").modal({ backdrop: 'static', keyboard: false });
								} else {
									if (this.state.zoneOutletSeleted == "") {
										if (parseInt(this.state.settings.client_zone_outlet_disable) === 1) {
											$("#AddressList").modal({ backdrop: 'static', keyboard: false });
										} else {
											$("#delivery_outlet").modal({ backdrop: 'static', keyboard: false });
										}
									}
								}
							} else {
								if (parseInt(this.state.settings.client_outlet_zone) === 0) {
									$("#DeliveryAddress").modal({ backdrop: 'static', keyboard: false });
								} else {
									if (this.state.zoneOutletSeleted == "") {
										if (parseInt(this.state.settings.client_zone_outlet_disable) === 1) {
											$("#DeliveryAddress").modal({ backdrop: 'static', keyboard: false });
										} else {
											$("#delivery_outlet").modal({ backdrop: 'static', keyboard: false });
										}
									}
								}
							}
						}
					} else if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.pickupId && _reactCookie2.default.load('defaultAvilablity') === lang.takeaWay) {
						_reactCookie2.default.save('dineinClick', 'no');
						var pickupOutlets = this.state.Outlets;
						if (typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderPostalCode') === "undefined") {
							if (this.state.Outlets.length === 0) {
								this.getpickupOutletlist();
							} else if (pickupOutlets.length === 1) {
	
								if (pickupOutlets[0].outlet_unit_number1 != "" && pickupOutlets[0].outlet_unit_number2 != "") {
									var unitTxt = ", #" + pickupOutlets[0].outlet_unit_number1 + "-" + pickupOutlets[0].outlet_unit_number2;
								} else if (pickupOutlets[0].outlet_unit_number1 != "" || pickupOutlets[0].outlet_unit_number2 != "") {
									var unitTxt = pickupOutlets[0].outlet_unit_number1 != "" ? ", #" + pickupOutlets[0].outlet_unit_number1 : ", #" + pickupOutlets[0].outlet_unit_number2;
								}
	
								var orderHandled = pickupOutlets[0].outlet_name + unitTxt + ", " + pickupOutlets[0].outlet_address_line1 + " " + pickupOutlets[0].outlet_address_line2 + ", Singapore " + pickupOutlets[0].outlet_postal_code;
	
								this.setState({ orderHandled: orderHandled });
								_reactCookie2.default.save('orderOutletId', pickupOutlets[0].outlet_id);
								_reactCookie2.default.save('orderOutletName', pickupOutlets[0].outlet_name);
								_reactCookie2.default.save('orderPostalCode', pickupOutlets[0].outlet_postal_code);
								_reactCookie2.default.save('orderTAT', pickupOutlets[0].outlet_pickup_tat);
								_reactCookie2.default.save('orderHandled', orderHandled);
								_reactCookie2.default.save('orderHandledByText', orderHandled);
	
								_reactCookie2.default.save('outlet_tax_option', pickupOutlets[0].outlet_tax_option);
								_reactCookie2.default.save('outlet_tax_surcharge', pickupOutlets[0].outlet_tax_surcharge);
								_reactCookie2.default.save('outlet_tax_surcharge_inclusive', pickupOutlets[0].outlet_tax_surcharge_inclusive);
	
								_reactCookie2.default.save('outlet_option_single', 1);
	
								$("#pickup-outlet-sucess").modal("toggle");
							} else {
								$("#Pickup-OutletSelection").modal({ backdrop: 'static', keyboard: false });
							}
						}
					} else if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId && _reactCookie2.default.load('defaultAvilablity') === "Dine In") {
						_reactCookie2.default.save('dineinClick', 'yes');
						if (typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderTableNo') === "undefined" || _reactCookie2.default.load('orderOutletId') === "" || _reactCookie2.default.load('orderTableNo') === "") {
							//cookie.save('dineinClick','yes');
							_reactCookie2.default.remove('orderTableNo');
							if (APPID === "287E5552-328E-4DBE-A3CA-E998ACCAC9BD") {
								helper.sarveshTableSetup();
							} else {
								_reactRouter.hashHistory.push("/book-a-table");
							}
						}
					}
				}
	
				if (_reactCookie2.default.load('navmenuClk') === 'close') {
					_reactCookie2.default.save('navmenuClk', 'no');
				}
			}
		}, {
			key: 'handleChange',
			value: function handleChange(event) {
				this.setState({ addressField: event.target.value });
			}
		}, {
			key: 'handleChangeValue',
			value: function handleChangeValue(event) {
				this.setState({ addressField: event.target.value });
			}
	
			/* Validate zipcode */
	
		}, {
			key: 'validatezip',
			value: function validatezip(e) {
				var re = /[0-9A-F:]+/g;
				if (!re.test(e.key)) {
					e.preventDefault();
				}
			}
	
			/* delivery timing */
	
		}, {
			key: 'showDeliveryTiming',
			value: function showDeliveryTiming() {
				if (APPID === apps.leanbento) {
					return _react2.default.createElement(
						'p',
						null,
						_react2.default.createElement(
							'b',
							null,
							'Your Order is handled by:'
						),
						_react2.default.createElement('br', null),
						' ',
						this.state.orderHandled
					);
				}
			}
	
			/* used to get all secondary address list */
	
		}, {
			key: 'getSecAddr',
			value: function getSecAddr() {
				var _this17 = this;
	
				_axios2.default.get(APIURL + '/customer/get_user_secondary_address?app_id=' + APPID + "&refrence=" + _reactCookie2.default.load('UserId')).then(function (res) {
					if (res.data.status === "ok") {
						_this17.setState({ secAddrData: res.data.result_set });
					}
				});
			}
	
			/* used to load address list */
	
		}, {
			key: 'loadAddressList',
			value: function loadAddressList() {
				var _this18 = this;
	
				return this.state.secAddrData.map(function (item, index) {
					return _react2.default.createElement(
						'p',
						{ key: index },
						_react2.default.createElement('input', { name: 'radio', value: item.postal_code, id: item.secondary_address_id, className: 'css-radio', type: 'radio', onChange: _this18.handleChange.bind(_this18) }),
						_react2.default.createElement(
							'label',
							{ htmlFor: item.secondary_address_id, className: 'css-label ' },
							' ',
							item.address + " Singapore " + item.postal_code
						)
					);
				});
			}
	
			/* show Address */
	
		}, {
			key: 'showNewAddressFrmd',
			value: function showNewAddressFrmd(pstcode, address1, address2, unittxt1, unittxt2) {
				var addressLn = address2 != '' ? address1 + ", " + address2 : address1;
				if (unittxt1 != '' && unittxt2 != '') {
					addressLn = addressLn + ", #" + unittxt1 + "-" + unittxt2;
				} else if (unittxt1 != '' || unittxt2 != '') {
					addressLn = unittxt1 != '' ? addressLn + ", #" + unittxt1 : addressLn + ", #" + unittxt2;
				}
	
				addressLn = addressLn + ", Singapore " + pstcode;
				return addressLn;
			}
	
			/* load outlets */
	
		}, {
			key: '__loadOutlets',
			value: function __loadOutlets() {
				var _this19 = this;
	
				if (this.state.Outlets) {
	
					var list = helper.getSortedList(this.state.Outlets, this.props.coords);
	
					return !(0, _lodash.isEmpty)(list) && list.map(function (loaddata, index) {
						return _react2.default.createElement(
							'div',
							{ className: 'map-li', key: index, onClick: _this19.pickOutlet.bind(_this19, loaddata.outlet_id, loaddata.outlet_name, loaddata.outlet_postal_code, loaddata.outlet_address_line1, loaddata.outlet_address_line2, loaddata.outlet_unit_number1, loaddata.outlet_unit_number2, loaddata.outlet_pickup_tat, loaddata.outlet_tax_option, loaddata.outlet_tax_surcharge, loaddata.outlet_tax_surcharge_inclusive) },
							_react2.default.createElement(
								'p',
								{ className: 'map-h outlet-name' },
								helper.stripslashes(loaddata.outlet_name)
							),
							_react2.default.createElement(
								'p',
								{ className: 'map-sub' },
								_this19.showNewAddressFrmd(loaddata.outlet_postal_code, loaddata.outlet_address_line1, loaddata.outlet_address_line2, loaddata.outlet_unit_number1, loaddata.outlet_unit_number2)
							),
							_react2.default.createElement(_Distancebar2.default, { minDateValue: loaddata.min_date, isOutletBased: loaddata.is_outlet_based, distance: loaddata.distance, coords: _this19.props.coords, tat: loaddata.outlet_pickup_tat ? loaddata.outlet_pickup_tat : loaddata.outlet_delivery_timing })
						);
					});
				}
			}
			/* Select outlet */
	
		}, {
			key: 'selectOutlet',
			value: function selectOutlet(thisobject) {
				var retry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				var _this20 = this;
	
				var callbackPostalCode = arguments[2];
				var addressObj = arguments[3];
	
	
				var postalcode = "";
				var address = "";
				var googleRetryAttempt = 0;
				if (retry === false) {
					if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
						postalcode = $("#postalcode").val(); //"postalcode";
					} else {
						postalcode = $("#postalcode1").val(); // "postalcode1";
					}
				} else {
					postalcode = callbackPostalCode;
					address = addressObj;
					googleRetryAttempt = 1;
				}
				if (postalcode.length < 5) {
					return false;
				}
	
				this.setState({ load: "true" });
				var findPostUrl = APIURL + 'outlets/find_outlet?skip_timing=Yes&app_id=' + APPID + "&availability_id=" + _reactCookie2.default.load('defaultAvilablityId') + "&postal_code=" + postalcode;
				if (parseInt(this.state.settings.client_outlet_zone) === 1) {
					findPostUrl = _constants.API_v4_URL + 'test/outlets/findOutletZone?skip_timing=Yes&app_id=' + APPID + "&availability_id=" + _reactCookie2.default.load('defaultAvilablityId') + "&postal_code=" + postalcode + "&outlet_id=" + this.state.zoneDeliveryOutlet + "&googleRetryAttempt=" + googleRetryAttempt + "&addressObject=" + address;
				}
				/*add loading */
				_axios2.default.get(findPostUrl).then(function (res) {
	
					/* Success response */
					/* Success response  && Object.keys(res.data.result_set.postal_code_information).length !==0 */
					if (res.data.status === "ok") {
						var orderDeliveryAddress = res.data.result_set.postal_code_information.zip_buno + " " + res.data.result_set.postal_code_information.zip_sname;
						var orderHandled = res.data.result_set.outlet_name + ", Crew will be seeing you in " + res.data.result_set.outlet_delivery_timing + " Minutes";
						_this20.setState({ orderDeliveryAddress: orderDeliveryAddress + " Singapore " + res.data.result_set.postal_code_information.zip_code });
						_this20.setState({ orderHandled: orderHandled });
						_reactCookie2.default.save('orderOutletId', res.data.result_set.outlet_id);
						_reactCookie2.default.save('orderOutletName', res.data.result_set.outlet_name);
						_reactCookie2.default.save('orderPostalCode', res.data.result_set.postal_code_information.zip_code);
						_reactCookie2.default.save('orderTAT', res.data.result_set.outlet_delivery_timing);
						_reactCookie2.default.save('orderDeliveryAddress', orderDeliveryAddress);
						_reactCookie2.default.save('orderHandled', orderHandled);
	
						_reactCookie2.default.save('outlet_tax_option', res.data.result_set.outlet_tax_option);
						_reactCookie2.default.save('outlet_tax_surcharge', res.data.result_set.outlet_tax_surcharge);
						_reactCookie2.default.save('outlet_tax_surcharge_inclusive', res.data.result_set.outlet_tax_surcharge_inclusive);
	
						var orderHandledText = res.data.result_set.outlet_name + " " + res.data.result_set.outlet_address_line1 + " " + res.data.result_set.outlet_address_line2 + ", Singapore " + postalcode;
						_reactCookie2.default.save('orderHandledByText', orderHandledText);
	
						if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
							$("body").removeClass("addresslistPopup");
							$("#AddressList").modal("hide");
						} else {
							$("#DeliveryAddress").modal("hide");
						}
						$("#address-auto").modal("hide");
						$("#DeliverySucess").modal('show');
	
						if (parseInt(_this20.state.settings.client_outlet_zone) === 1) {
							_reactCookie2.default.save('orderZoneID', res.data.result_set.zone_id);
						}
					}
	
					/* Error response */
					if (res.data.status === "error") {
						_this20.setState({ load: "false" });
	
						/* check google api result */
						var google_api_result = false;
						if (typeof res.data.not_fount_in_google !== "undefined" && res.data.not_fount_in_google === true) {
							_this20.setState({ enableAddressSearch: true });
							google_api_result = true;
						} else {
							_this20.setState({ enableAddressSearch: false });
						}
	
						if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
							$("body").removeClass("addresslistPopup");
							$("#AddressList").modal("hide");
						} else {
							$("#DeliveryAddress").modal("hide");
						}
						// $("#DeliveryError").modal({ backdrop: 'static', keyboard: false });
						if (google_api_result === false) {
							$("#address-auto").modal("hide");
							if (res.data.shop_close === 'Yes') {
								$("#ShopClosedError").modal({ backdrop: 'static', keyboard: false });
							} else {
								$("#DeliveryError").modal({ backdrop: 'static', keyboard: false });
							}
						} else {
							$("#address-auto").modal("show");
						}
					}
				});
			}
		}, {
			key: 'showZonalPostalCode',
			value: function showZonalPostalCode(outletId) {
				this.setState({ "zoneOutletSeleted": "Yes" });
				$("#delivery_outlet").modal("toggle");
				if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
					$("#AddressList").modal("toggle");
				} else {
					$("#DeliveryAddress").modal("toggle");
				}
	
				this.setState({ zoneDeliveryOutlet: outletId });
			}
		}, {
			key: '__loadDeliveryOutlets',
			value: function __loadDeliveryOutlets() {
				var _this21 = this;
	
				if (this.state.deliveryOutlets) {
					var list = helper.getSortedList(this.state.deliveryOutlets, this.props.coords);
	
					if (!(0, _lodash.isEmpty)(list)) {
						return list.map(function (loaddata, index) {
							return _react2.default.createElement(
								'div',
								{ className: 'map-li', key: index, onClick: _this21.showZonalPostalCode.bind(_this21, loaddata.outlet_id) },
								_react2.default.createElement(
									'p',
									{ className: 'map-h outlet-name' },
									helper.stripslashes(loaddata.outlet_name)
								),
								_react2.default.createElement(
									'p',
									{ className: 'map-sub' },
									_this21.showNewAddressFrmd(loaddata.outlet_postal_code, loaddata.outlet_address_line1, '', '', ''),
									' ',
									loaddata.outlet_unit_number2
								),
								_react2.default.createElement(_Distancebar2.default, { minDateValue: loaddata.min_date, isOutletBased: loaddata.is_outlet_based, distance: loaddata.distance, coords: _this21.props.coords, tat: loaddata.outlet_delivery_tat ? loaddata.outlet_delivery_tat : loaddata.outlet_delivery_timing })
							);
						});
					} else {
						return _react2.default.createElement(_Outletclosedmessage2.default, { messages: this.state.outletCloseddMessage });
					}
				}
			}
		}, {
			key: 'backToDeliveryBack',
			value: function backToDeliveryBack() {
				$("#DeliveryAddress").modal("toggle");
				$("#delivery_outlet").modal("toggle");
			}
		}, {
			key: 'showZonalBackButton',
			value: function showZonalBackButton() {
				if (parseInt(this.state.settings.client_outlet_zone) === 1 && parseInt(this.state.settings.client_zone_outlet_disable) === 0) {
					return _react2.default.createElement(
						'div',
						{ className: 'col-sm-6 popup-back-btn' },
						_react2.default.createElement(
							'button',
							{ type: 'button', onClick: this.backToDeliveryBack.bind(this), className: 'btn btn-raised btn-info ' },
							'Go Back'
						)
					);
				}
			}
			/* reward menu */
	
		}, {
			key: 'rewardMenu',
			value: function rewardMenu() {
	
				var usertype = typeof _reactCookie2.default.load('userAccountType') !== "undefined" ? _reactCookie2.default.load('userAccountType') : 0;
	
				if (APPID !== apps.workspace && parseInt(usertype) !== 1 && helper.disableMenu(this.state.settings, 'home_sub_rewards')) {
					return _react2.default.createElement(
						_reactRouter.Link,
						{ to: '/rewards', className: this.state.openNav },
						_react2.default.createElement('img', { alt: '', src: '/img/icons/orders.png' }),
						' ',
						" ",
						lang.navigation.viewrewards
					);
				}
			}
		}, {
			key: 'loadManualLoading',
			value: function loadManualLoading() {
	
				if (this.state.manualLoading === true) {
					return _react2.default.createElement(
						'div',
						{ style: { bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto' } },
						' ',
						_react2.default.createElement('img', { src: '/img/loader.gif', alt: 'Loading', style: { bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto' } }),
						' '
					);
				}
			}
		}, {
			key: 'handleChange_maintain',
			value: function handleChange_maintain(event) {
	
				if (event.target.name === "client_password_maintain") {
					this.setState({ client_password_maintain: event.target.value });
				}
			}
		}, {
			key: 'serviceMaintanance',
			value: function serviceMaintanance() {
				var _this22 = this;
	
				if (this.state.client_password_maintain !== '') {
	
					this.setState({ client_password_maintain_error: '' });
	
					var postObject = {
						"app_id": APPID,
						"client_password": this.state.client_password_maintain
					};
	
					var qs = __webpack_require__(3);
	
					_axios2.default.post(APIURLPRO + "settings/checking_maintenance", qs.stringify(postObject)).then(function (response) {
	
						if (response.data.status === "ok") {
							$("#promo_popup-2").modal("hide");
							_this22.setState({ client_maintanace_popup_hide: true });
							_reactCookie2.default.save('site_maintenance_popup_open', '0', { path: "/" });
							_reactCookie2.default.save('client_site_maintenance_verify', '1', { path: "/" });
						} else {
							$("#promo_popup-2").modal("show");
							_this22.setState({ client_password_maintain_error: '2' });
							_reactCookie2.default.save('site_maintenance_popup_open', '1', { path: "/" });
							_reactCookie2.default.save('client_site_maintenance_verify', '0', { path: "/" });
						}
					});
				} else {
					_reactCookie2.default.save('site_maintenance_popup_open', '1', { path: "/" });
					_reactCookie2.default.save('client_site_maintenance_verify', '0', { path: "/" });
					this.setState({ client_password_maintain_error: '1' });
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this23 = this;
	
				if (this.state.navStatus === "Loading") {
	
					return _react2.default.createElement(
						'div',
						{ className: 'container-fluid desktop-container position-rel', style: { minHeight: this.state.windowHeightNormal } },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(Loading, null)
						)
					);
				} else {
					var _React$createElement;
	
					var homeHeaderText = void 0;
					if (APPID == '68009D56-9386-4ECE-92D8-6F81E11B8742') {
						homeHeaderText = "Nice to meat you. <br/>How will your meat get to you today?";
					} else if (APPID == "AA850867-4108-4EB8-872B-024903608E9F") {
						homeHeaderText = "Please select your dining preference";
					} else {
						homeHeaderText = "How will you be enjoying <br/>your food today?";
					}
	
					// const master_card_block = helper.getStaticBlock('master-card-popup');
	
					var site_maintenance_verify = _reactCookie2.default.load("client_site_maintenance_verify") !== '' && _reactCookie2.default.load("client_site_maintenance_verify") !== 'undefined' && _reactCookie2.default.load("client_site_maintenance_verify") !== undefined ? _reactCookie2.default.load("client_site_maintenance_verify") : '';
	
					return _react2.default.createElement(
						'div',
						null,
						' ',
						_react2.default.createElement(_reactDocumentMeta2.default, meta),
						_react2.default.createElement(Alert, null),
						_react2.default.createElement(_LocationSearchInput2.default, { loading: this.state.status, open: this.state.enableAddressSearch, parentCallback: this.selectOutlet, postalcode: this.state.addressField }),
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid desktop-container position-rel', style: { minHeight: this.state.windowHeightNormal } },
							_react2.default.createElement('div', { id: 'parentDisable' }),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 head-dropdwn nopadding', style: { display: this.hidedropDown() } },
									_react2.default.createElement(
										'div',
										{ className: 'dropdown center-block' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'btn home-modal-button', 'data-toggle': 'modal', 'data-target': '#onload-screen', 'data-keyboard': 'false', 'data-backdrop': 'static' },
											_react2.default.createElement(
												'p',
												{ className: 'text-center dine-in-text' },
												_react2.default.createElement('img', { alt: '', src: this.state.defaultAvilablityImage, className: 'icon-img-small' }),
												" ",
												_react2.default.createElement(
													'span',
													{ style: { fontSize: '16px' } },
													this.state.defaultAvilablity
												),
												" ",
												_react2.default.createElement('img', { alt: '', src: '/img/icons/arrow-down.png', className: 'icon-img-small' })
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 top-nav padding-0 head-main' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-4 head-child' },
										_react2.default.createElement(
											'span',
											{ className: 'cursor-pointer side-l1', onClick: this.openNavmenu.bind(this) },
											_react2.default.createElement('img', { alt: '', src: '/img/menu.png', className: 'icon-img-small5 menuicon' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-4 head-child' },
										_react2.default.createElement('img', { alt: '', src: this.loadLogo(), className: 'logo-main center-block' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-4 nopadding head-child' },
										_react2.default.createElement(
											'p',
											{ className: 'b-txt text-right pd-tr-12-20' },
											config.enablescan === 'Yes' && _react2.default.createElement(
												'a',
												{ href: 'https://scan.ninjapro.co', className: 'scan-icon-a' },
												_react2.default.createElement('img', { alt: '', src: '/img/icons/Scan-to-add-btn.png', className: 'icon-img-small-scan head_serch' })
											),
											_react2.default.createElement(
												_reactRouter.Link,
												{ className: 'rel search-icon', 'data-toggle': 'collapse', to: "#SearchBAR", 'aria-expanded': 'false', 'aria-controls': 'collapseExample' },
												_react2.default.createElement('img', { alt: '', src: '/img/icons/search-new.png', className: 'icon-img-small4 head_serch' })
											),
											"  ",
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: "/cart", className: helper.cartClass() },
												helper.cartCount(),
												_react2.default.createElement('img', { alt: '', src: (0, _Api2.default)('cartImage'), className: 'icon-img-small-1 carticon' }),
												' '
											),
											config.enablescan === 'Yes' && _react2.default.createElement(
												'div',
												{ className: 'scan-tooltip' },
												'Click here to Scan QR Code & Add to Cart ',
												_react2.default.createElement(
													'a',
													{ onClick: this.closeTooltip.bind(this) },
													_react2.default.createElement(
														'span',
														null,
														_react2.default.createElement(
															'i',
															{ className: 'material-icons' },
															'close'
														)
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'collapse', id: 'SearchBAR' },
										_react2.default.createElement(
											'div',
											{ className: '' },
											_react2.default.createElement(
												'div',
												{ className: 'form-group SearchBAR' },
												_react2.default.createElement(
													'div',
													{ className: 'input-group' },
													_react2.default.createElement(Select.Async, {
														name: 'form-field-name',
														placeholder: APPID == '68009D56-9386-4ECE-92D8-6F81E11B8742' ? 'what are you in the mood for today' : 'Go ahead search for a dish...',
														noResultsText: 'No Products Found',
														autoload: false,
	
														loadOptions: this.getOptions.bind(this),
														onChange: this.ViewProducts.bind(this)
													})
												)
											)
										)
									)
								)
							),
							_react2.default.createElement(
								_reactOutsideClickHandler2.default,
								{
									onOutsideClick: this.closeNav.bind(this)
								},
								_react2.default.createElement(
									'div',
									{ id: 'mySidenav', className: 'sidenav' },
									_react2.default.createElement('br', null),
									' ',
									_react2.default.createElement('br', null),
									_react2.default.createElement(
										'div',
										{ className: 'side-nav-header' },
										_react2.default.createElement(
											'div',
											{ className: this.state.openNav },
											_react2.default.createElement('img', { className: 'logo ', alt: '', src: this.loadLogo() })
										),
										_react2.default.createElement(
											'a',
											{ style: { cursor: 'pointer' }, className: 'closebtn', onClick: this.closeNav.bind(this) },
											_react2.default.createElement('img', { alt: '', src: '/img/icons/menu2.png', id: 'close-btn-nav' })
										)
									),
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: '/', onClick: this.closeNav.bind(this), className: this.state.openNav },
										_react2.default.createElement('img', { alt: '', src: '/img/icons/home.png' }),
										" ",
										lang.navigation.home
									),
									helper.disableMenu(this.state.settings, 'home_sub_my_account') && _react2.default.createElement(
										_reactRouter.Link,
										{ to: typeof _reactCookie2.default.load('UserId') === 'undefined' || _reactCookie2.default.load('UserId') === null ? this.getSignInlink() : "my-account", className: this.state.openNav },
										_react2.default.createElement('img', { alt: '', src: '/img/icons/user.png' }),
										' ',
										" ",
										lang.navigation.myaccount
									),
									helper.disableMenu(this.state.settings, 'home_sub_orders') && _react2.default.createElement(
										_reactRouter.Link,
										{ to: '/orders', className: this.state.openNav },
										_react2.default.createElement('img', { alt: '', src: '/img/icons/orders.png' }),
										' ',
										" ",
										lang.navigation.vieworders
									),
									this.rewardMenu(),
									(helper.disableMenu(this.state.settings, 'home_sub_contact_us') || helper.disableMenu(this.state.settings, 'home_sub_about_us') || helper.disableMenu(this.state.settings, 'home_sub_terms') || helper.disableMenu(this.state.settings, 'home_sub_privacy')) && _react2.default.createElement('div', { className: 'grey-seperater' }),
									helper.disableMenu(this.state.settings, 'home_sub_about_us') && _react2.default.createElement(
										_reactRouter.Link,
										{ to: 'pages/about-us', className: this.state.openNav },
										_react2.default.createElement('img', { alt: '', src: '/img/icons/info.png' }),
										' \xA0',
										lang.navigation.about
									),
									helper.disableMenu(this.state.settings, 'home_sub_terms') && _react2.default.createElement(
										_reactRouter.Link,
										{ to: 'pages/terms-conditions', className: this.state.openNav },
										_react2.default.createElement('img', { alt: '', src: '/img/icons/info.png' }),
										' \xA0Terms & Conditions'
									),
									helper.disableMenu(this.state.settings, 'home_sub_privacy') && _react2.default.createElement(
										_reactRouter.Link,
										{ to: 'pages/privacy-policy', className: this.state.openNav },
										_react2.default.createElement('img', { alt: '', src: '/img/icons/lock.png' }),
										' \xA0',
										lang.navigation.privacy
									),
									APPID === "614F3FD1-8659-4FD0-BF07-0560BC039AE6" && helper.disableMenu(this.state.settings, 'home_sub_contact_us') && _react2.default.createElement(
										_reactRouter.Link,
										{ to: 'module/contact-us', className: this.state.openNav },
										_react2.default.createElement('img', { alt: '', src: '/img/icons/phone.png' }),
										' \xA0Feedback'
									),
									APPID === "614F3FD1-8659-4FD0-BF07-0560BC039AE6" && helper.disableMenu(this.state.settings, 'home_sub_contact_us') && _react2.default.createElement(
										'a',
										{ href: 'https://api.whatsapp.com/send/?phone=%2B6593545155&text&app_absent=0', className: this.state.openNav, target: '_blank' },
										_react2.default.createElement('img', { alt: '', src: '/img/icons/phone.png' }),
										' \xA0',
										lang.navigation.contact
									),
									APPID !== "614F3FD1-8659-4FD0-BF07-0560BC039AE6" && helper.disableMenu(this.state.settings, 'home_sub_contact_us') && _react2.default.createElement(
										_reactRouter.Link,
										{ to: 'module/contact-us', className: this.state.openNav },
										_react2.default.createElement('img', { alt: '', src: '/img/icons/phone.png' }),
										' \xA0',
										lang.navigation.contact
									),
									this.loginPart()
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: this.state.noPagerClass },
									_react2.default.createElement(
										'ul',
										{ className: this.state.bxClass },
										this.__showBanners()
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'account-section' },
									this.loginPartHeader(),
									APPID !== "B401FC82-8E39-4076-838A-55192F765004" && APPID !== "6C0280A0-B655-4E0F-A43F-041C189683BA" && APPID !== "B93EC9A9-1A67-4EBA-ADB7-BC7C14FA88A4" && this.signinHeader()
								),
								_react2.default.createElement(
									'div',
									{ className: 'flex-container desktop_header' },
									helper.disableMenu(this.state.settings, 'home_main_orders') && _react2.default.createElement(
										_reactRouter.Link,
										{ to: '/orders', className: 'order_items' },
										_react2.default.createElement(
											'div',
											{ className: 'order_promo' },
											_react2.default.createElement('img', { alt: '', src: '/img/icons/shopping-bag.svg' }),
											this.state.orderCount > 0 && _react2.default.createElement(
												'span',
												{ className: 'badge' },
												this.state.orderCount
											)
										),
										_react2.default.createElement(
											'span',
											null,
											'Orders'
										)
									),
									APPID !== '8F8FE4E6-88C9-4071-9215-312E0F50016A' && APPID !== 'B401FC82-8E39-4076-838A-55192F765004' && APPID !== "6C0280A0-B655-4E0F-A43F-041C189683BA" && APPID !== "B93EC9A9-1A67-4EBA-ADB7-BC7C14FA88A4" && APPID !== "33843AC9-EB47-42EE-8AAA-14CEA187D85A" && APPID !== "4EDE9A25-89AA-4200-848D-AC4A5A54B7BC" && helper.disableMenu(this.state.settings, 'home_main_promos') && _react2.default.createElement(
										_reactRouter.Link,
										{ to: '/promotion', className: 'order_items' },
										_react2.default.createElement(
											'div',
											{ className: 'order_promo' },
											_react2.default.createElement('img', { alt: '', src: '/img/icons/megaphone.svg' }),
											this.state.promotionCount > 0 && _react2.default.createElement(
												'span',
												{ className: 'badge' },
												this.state.promotionCount
											)
										),
										_react2.default.createElement(
											'span',
											null,
											'Promos'
										)
									),
									APPID !== 'AA850867-4108-4EB8-872B-024903608E9F' && APPID !== '8F8FE4E6-88C9-4071-9215-312E0F50016A' && APPID !== 'B401FC82-8E39-4076-838A-55192F765004' && APPID !== "6C0280A0-B655-4E0F-A43F-041C189683BA" && APPID !== "B93EC9A9-1A67-4EBA-ADB7-BC7C14FA88A4" && APPID !== "33843AC9-EB47-42EE-8AAA-14CEA187D85A" && APPID !== "4EDE9A25-89AA-4200-848D-AC4A5A54B7BC" && helper.disableMenu(this.state.settings, 'home_main_rewards') && _react2.default.createElement(
										_reactRouter.Link,
										{ to: '/rewards', className: 'order_items' },
										_react2.default.createElement(
											'div',
											{ className: 'header_common_icon' },
											_react2.default.createElement('img', { alt: '', src: '/img/icons/confetti.svg' })
										),
										_react2.default.createElement(
											'span',
											null,
											'Rewards'
										)
									),
									APPID !== 'AA850867-4108-4EB8-872B-024903608E9F' && APPID !== '8F8FE4E6-88C9-4071-9215-312E0F50016A' && APPID !== 'B401FC82-8E39-4076-838A-55192F765004' && APPID !== "33843AC9-EB47-42EE-8AAA-14CEA187D85A" && APPID !== "6C0280A0-B655-4E0F-A43F-041C189683BA" && APPID !== "4EDE9A25-89AA-4200-848D-AC4A5A54B7BC" && helper.disableMenu(this.state.settings, 'home_main_vouchers') && _react2.default.createElement(
										_reactRouter.Link,
										{ to: '/vouchers', className: 'order_items' },
										_react2.default.createElement(
											'div',
											{ className: 'header_common_icon' },
											_react2.default.createElement('img', { alt: '', src: '/img/icons/gift-voucher.svg' })
										),
										_react2.default.createElement(
											'span',
											null,
											'E-Vouchers'
										)
									),
									APPID !== 'AFA6F84D-423C-44AB-A47A-A1AF8813B387' && helper.disableMenu(this.state.settings, 'home_main_call_us') && _react2.default.createElement(
										'a',
										{ href: this.loadNumber(), style: { cursor: 'pointer' }, className: 'order_items' },
										_react2.default.createElement(
											'div',
											{ className: 'header_common_icon' },
											_react2.default.createElement('img', { alt: '', src: '/img/icons/call.svg' })
										),
										_react2.default.createElement(
											'span',
											null,
											'Call Us'
										)
									),
									APPID !== 'B401FC82-8E39-4076-838A-55192F765004' && APPID !== "6C0280A0-B655-4E0F-A43F-041C189683BA" && APPID !== "B93EC9A9-1A67-4EBA-ADB7-BC7C14FA88A4" && helper.disableMenu(this.state.settings, 'home_main_directions') && _react2.default.createElement(
										_reactRouter.Link,
										{ onClick: this.targetMap.bind(this), style: { cursor: 'pointer' }, className: 'order_items' },
										_react2.default.createElement(
											'div',
											{ className: 'header_common_icon' },
											_react2.default.createElement('img', { alt: '', src: '/img/icons/compass.svg' })
										),
										_react2.default.createElement(
											'span',
											null,
											'Direction'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 heading-div our_special_head' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-8 pd-r-20 our_menu_com' },
										this.foodTypes(this)
									)
								),
								this.__ProductListing()
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal fade reservationmdlCls', id: 'ReservationMdl' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'div',
											{ className: 'reservation-wrap-ija' },
											_react2.default.createElement(
												'div',
												{ className: 'reserve-head' },
												_react2.default.createElement(
													'button',
													{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true', onClick: this.closeResvPoup.bind(this) },
													_react2.default.createElement('img', { src: '/img/icons/close_popup.png', className: 'img-responsive', alt: '' })
												),
												_react2.default.createElement(
													'a',
													{ className: 'back-aw-t goback_arwcls', id: 'goback_arwId', href: 'javascript:;', style: { display: 'none' }, onClick: this.reservationFirstli.bind(this) },
													_react2.default.createElement('img', { src: 'img/back_aw.png' })
												),
												_react2.default.createElement(
													'h4',
													null,
													'Reservation'
												),
												_react2.default.createElement(
													'p',
													null,
													this.state.selectResOutletOptionTxt,
													'  - ',
													this.state.selectResOutletAdrr
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'reserve-items-box' },
												_react2.default.createElement(
													'form',
													{ id: 'wizard-1', noValidate: 'novalidate' },
													_react2.default.createElement(
														'div',
														{ id: 'bootstrap-wizard-1', className: 'col-sm-12' },
														_react2.default.createElement(
															'div',
															{ className: 'form-bootstrapWizard' },
															_react2.default.createElement(
																'ul',
																{ className: 'bootstrapWizard form-wizard' },
																_react2.default.createElement(
																	'li',
																	{ className: 'active', 'data-target': '#step1', id: 'ReservationLiId' },
																	_react2.default.createElement(
																		'a',
																		null,
																		' ',
																		_react2.default.createElement(
																			'span',
																			{ className: 'step' },
																			'1'
																		),
																		' ',
																		_react2.default.createElement(
																			'span',
																			{ className: 'title' },
																			'Reservation'
																		),
																		' '
																	)
																),
																_react2.default.createElement(
																	'li',
																	{ id: 'InformationLi' },
																	_react2.default.createElement(
																		'a',
																		null,
																		' ',
																		_react2.default.createElement(
																			'span',
																			{ className: 'step' },
																			'2'
																		),
																		' ',
																		_react2.default.createElement(
																			'span',
																			{ className: 'title' },
																			'Information'
																		),
																		' '
																	)
																),
																_react2.default.createElement(
																	'li',
																	{ id: 'ConfirmationLi' },
																	_react2.default.createElement(
																		'a',
																		null,
																		' ',
																		_react2.default.createElement(
																			'span',
																			{ className: 'step' },
																			'3'
																		),
																		' ',
																		_react2.default.createElement(
																			'span',
																			{ className: 'title' },
																			'Confirmation'
																		),
																		' '
																	)
																)
															),
															_react2.default.createElement('div', { className: 'clearfix' })
														),
														_react2.default.createElement(
															'div',
															{ className: 'tab-content' },
															_react2.default.createElement(
																'div',
																{ className: 'tab-pane active', id: 'tab1' },
																_react2.default.createElement(
																	'div',
																	{ className: 'reserve-content cmn-grey-box' },
																	_react2.default.createElement(
																		'div',
																		{ className: 'row' },
																		_react2.default.createElement(
																			'div',
																			{ className: 'col-md-12' },
																			_react2.default.createElement(
																				'div',
																				{ className: 'form-group' },
																				_react2.default.createElement(
																					'div',
																					{ className: ' sct-aw' },
																					_react2.default.createElement(
																						'select',
																						{ className: 'form-control form-select', value: this.state.selectResOutletAdrrAndId, onChange: this.changeResOutlet, id: 'resOutlets' },
																						this.state.ResOutletDropDownHtml
																					)
																				)
																			)
																		)
																	),
																	_react2.default.createElement(
																		'div',
																		{ className: 'row' },
																		_react2.default.createElement(
																			'div',
																			{ className: 'col-md-6 col-sm-6' },
																			_react2.default.createElement(
																				'div',
																				{ className: 'form-group' },
																				_react2.default.createElement(
																					'div',
																					{ className: 'icon-select sct-aw' },
																					_react2.default.createElement(
																						'select',
																						{ className: 'form-control form-select', id: 'noofadults', onChange: this.noofAdultsfun.bind(this), value: this.state.noofAdults },
																						this.state.noofAdultHtml
																					)
																				)
																			)
																		),
																		_react2.default.createElement(
																			'div',
																			{ className: 'col-md-6 col-sm-6' },
																			_react2.default.createElement(
																				'div',
																				{ className: 'form-group' },
																				_react2.default.createElement(
																					'div',
																					{ className: 'icon-select sct-aw' },
																					_react2.default.createElement(
																						'select',
																						{ className: 'form-control form-select', id: 'noofchildren', onChange: this.noofChildrenfun.bind(this), value: this.state.noofChildren },
																						this.state.noofChildrenHtml
																					)
																				)
																			)
																		)
																	),
																	this.loadManualLoading(),
																	_reactCookie2.default.load("advanced_time_slot_reservation_enable") === "1" ? _react2.default.createElement(
																		'div',
																		null,
																		_react2.default.createElement(
																			'div',
																			{ className: 'row' },
																			_react2.default.createElement(
																				'div',
																				{ className: 'col-md-6 col-sm-6' },
																				_react2.default.createElement(
																					'div',
																					{ className: 'form-group' },
																					_react2.default.createElement(
																						'div',
																						{ className: ' icon-date-cs sct-aw deliverydate' },
																						_react2.default.createElement(
																							_ThemeProvider2.default,
																							{ theme: _theme2.default },
																							_react2.default.createElement(_DatePicker2.default, { placeholder: 'Date',
																								inputFormat: function inputFormat(value) {
																									return value.getDate() + '/' + (value.getMonth() + 1) + '/' + value.getFullYear();
																								},
																								value: this.state.date_advanced,
																								onChange: this.handleChange_advanced.bind(this, "date"),
																								minDate: this.state.min_datetime_advanced,
																								maxDate: this.state.max_datetime_advanced,
																								sundayFirstDayOfWeek: true,
																								disabledDates: this.state.disableDate_advanced,
																								id: 'resDatepkid',
																								className: 'delivery_datepiker' })
																						)
																					)
																				)
																			),
																			_react2.default.createElement(
																				'div',
																				{ className: 'col-md-6 col-sm-6' },
																				_react2.default.createElement(
																					'div',
																					{ className: 'form-group label-floating is-empty card-no custom-time-label min-hgt-hour-t' },
																					_react2.default.createElement(
																						'div',
																						{ className: 'input-group' },
																						_react2.default.createElement(
																							'label',
																							{ className: 'control-label' },
																							this.state.time_slot_type_advanced === "1" ? "Choose Time" : "Choose Time Slot"
																						),
																						this.state.time_slot_type_advanced === "1" && _react2.default.createElement(
																							'div',
																							null,
																							_react2.default.createElement(
																								'select',
																								{
																									value: this.state.selectTime_advanced,
																									onChange: this.changeTimer,
																									id: 'deliveryTime'
																								},
																								this.state.timeHtml_advanced
																							),
																							'/',
																							_react2.default.createElement(
																								'select',
																								{
																									id: 'deliveryMins',
																									value: this.state.selectMins_advanced,
																									onChange: this.changeMins },
																								this.state.minsHtml
																							)
																						),
																						this.state.time_slot_type_advanced === "2" && _react2.default.createElement(
																							'div',
																							null,
																							_react2.default.createElement(
																								'select',
																								{ className: " customdd timelsotdd", id: 'timeSlot' },
																								this.state.TimeSlotHtmlVal_advanced
																							)
																						)
																					)
																				)
																			)
																		),
																		this.showTimeslotExceed()
																	) : _react2.default.createElement(
																		'div',
																		{ className: 'row' },
																		_react2.default.createElement(
																			'div',
																			{ className: 'col-md-6 col-sm-6' },
																			_react2.default.createElement(
																				'div',
																				{ className: 'form-group' },
																				_react2.default.createElement(
																					'div',
																					{ className: ' icon-date-cs sct-aw' },
																					_react2.default.createElement(
																						_ThemeProvider2.default,
																						{ theme: _theme2.default },
																						_react2.default.createElement(_DatePicker2.default, { placeholder: 'Date',
																							inputFormat: function inputFormat(value) {
																								return value.getDate() + '/' + (value.getMonth() + 1) + '/' + value.getFullYear();
																							},
																							minDate: min_datetime,
																							onChange: this.handleChangeDatefun.bind(this, 'date'),
																							value: this.state.resDate,
																							disabledDates: this.state.ReservationtimeData,
																							id: 'resDatepkid',
																							className: 'delivery_datepiker' })
																					)
																				)
																			)
																		),
																		_react2.default.createElement(
																			'div',
																			{ className: 'col-md-6 col-sm-6' },
																			_react2.default.createElement(
																				'div',
																				{ className: 'form-group' },
																				_react2.default.createElement(
																					'div',
																					{ className: 'clock-icon sct-aw' },
																					_react2.default.createElement(
																						'select',
																						{ className: 'form-control form-select', value: this.state.resTimeval, onChange: this.changeResTimeset, id: 'resTime' },
																						this.state.ReservationtimeHtml
																					)
																				)
																			)
																		)
																	),
																	this.state.resDate !== '' && typeof this.state.resDate != "undefined" && APPID === "DDAA254C-BD1E-49F0-AD1E-164A140421D3" && this.state.resDate.getDate() === 14 && this.state.resDate.getMonth() === 1 && _react2.default.createElement(
																		'div',
																		{ className: 'timeslot_exc' },
																		'Celebrate Valentine\u2019s Day at Zazz Pizza! Special menu available for Valentine\u2019s Night only'
																	),
																	helper.disableSpecialInstructions(APPID) && _react2.default.createElement(
																		'div',
																		{ className: 'row' },
																		_react2.default.createElement(
																			'div',
																			{ className: 'col-md-12' },
																			_react2.default.createElement(
																				'div',
																				{ className: 'form-group' },
																				_react2.default.createElement('textarea', { className: 'form-control', id: 'resRemark', placeholder: 'Special Instruction', value: this.state.resRemarkDes, onChange: this.changeRemarkDes.bind(this) })
																			)
																		)
																	)
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'text-center' },
																	_react2.default.createElement(
																		'a',
																		{ className: 'btn-send-t', href: 'javascript:;', onClick: this.reservationSubmtn.bind(this) },
																		'Send'
																	)
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'tab-pane', id: 'tab2' },
																_react2.default.createElement(
																	'div',
																	{ className: 'reserve-content cmn-grey-box' },
																	_react2.default.createElement(
																		'p',
																		null,
																		'You are making a reservation for'
																	),
																	_react2.default.createElement(
																		'p',
																		null,
																		_react2.default.createElement(
																			'span',
																			null,
																			this.state.ResPeopleTxt
																		),
																		' at ',
																		_react2.default.createElement('br', null),
																		_react2.default.createElement(
																			'span',
																			null,
																			this.state.settings.company_name,
																			' - ',
																			this.state.selectResOutletOptionTxt
																		),
																		' on ',
																		_react2.default.createElement('br', null),
																		_react2.default.createElement(
																			'span',
																			null,
																			this.state.ResselectedDateTxt,
																			', ',
																			this.state.ResselectedDayTxt,
																			', ',
																			this.state.resTimeText
																		)
																	),
																	_react2.default.createElement(
																		'p',
																		{ style: { wordBreak: "break-all" } },
																		this.state.resRemarkDes
																	),
																	_react2.default.createElement(
																		'p',
																		{ className: 'disclaimerTxt' },
																		'Special requests are not guaranteed and are subject to availability and restaurant discretion. Notes stating an alternative timing or party-size will not be accommodated.'
																	)
																),
																_react2.default.createElement(
																	'div',
																	{ id: 'resvloadIcon', style: { display: 'none', bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto', zIndex: 99, background: 'rgba(255, 255, 255, 0.8)' } },
																	' ',
																	_react2.default.createElement('img', { style: { bottom: 0, left: 0, position: 'absolute', right: 0, top: 0, margin: 'auto' }, src: '/img/loader.gif', alt: 'Loading' }),
																	' '
																),
																this.loadManualLoading(),
																_react2.default.createElement(
																	'div',
																	{ className: 'text-center' },
																	_react2.default.createElement(
																		'a',
																		{ className: 'btn-send-t', href: 'javascript:;', onClick: this.orderComfirmSubmtn.bind(this) },
																		'Confirm'
																	)
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'tab-pane', id: 'tab3' },
																_react2.default.createElement(
																	'div',
																	{ className: 'confirmation-bx' },
																	_react2.default.createElement('img', { src: 'img/success.png' }),
																	_react2.default.createElement(
																		'h4',
																		null,
																		'Thank You'
																	),
																	_react2.default.createElement(
																		'h3',
																		null,
																		'Your Reservation has been sent'
																	),
																	_react2.default.createElement(
																		'p',
																		null,
																		'Our staff member will contact you for',
																		_react2.default.createElement('br', null),
																		' booking confirmation'
																	)
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'cnfm-id-section' },
																	_react2.default.createElement(
																		'h5',
																		null,
																		'Confirmation ID : ',
																		_react2.default.createElement(
																			'span',
																			null,
																			this.state.resOrderId
																		)
																	),
																	_react2.default.createElement(
																		'p',
																		null,
																		_react2.default.createElement(
																			'span',
																			null,
																			this.state.ResPeopleTxt
																		),
																		' at ',
																		_react2.default.createElement('br', null),
																		_react2.default.createElement(
																			'span',
																			null,
																			this.state.settings.company_name,
																			' - ',
																			this.state.selectResOutletOptionTxt
																		),
																		' on ',
																		_react2.default.createElement('br', null),
																		_react2.default.createElement(
																			'span',
																			null,
																			this.state.ResselectedDateTxt,
																			', ',
																			this.state.ResselectedDayTxt,
																			', ',
																			this.state.resTimeText
																		)
																	)
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'text-center' },
																	_react2.default.createElement(
																		'a',
																		{ className: 'btn-send-t bg-bck-color', href: 'javascript:;', onClick: this.gotoMyAcct.bind(this) },
																		'Go To My Account'
																	)
																)
															)
														)
													)
												)
											)
										)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal fade swithErrorCls', id: 'SwitchingError' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: '' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/SwitchingError.png', className: 'img-responsive', alt: '' }),
											'Wait a second !'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'p',
											null,
											'By switching you are about to clear your cart. ',
											_react2.default.createElement('br', null),
											'Do you wish to proceed ?'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-6' },
											_react2.default.createElement(
												'button',
												{ type: 'button', onClick: this.closeSwitcher.bind(this), className: 'btn btn-raised btn-info fullwidth' },
												'Cancel'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-6' },
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'col-lg-6 btn btn-raised btn-info fullwidth ', onClick: this.switchAvailability.bind(this) },
												'Yes Proceed'
											)
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal fade homepopup', id: 'onload-screen' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog index-modal' },
								_react2.default.createElement('img', { className: 'bg-img', src: this.loadPopupBackgroundImage() }),
								_react2.default.createElement(
									'div',
									{ className: 'modal-sec' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-content' },
										_react2.default.createElement(
											'div',
											{ className: 'modal-logo' },
											_react2.default.createElement('img', { alt: 'Ninja OS System', src: this.loadPopupLogoImage(), className: 'img-responsive' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'modal-body' },
											_react2.default.createElement(
												'h3',
												{ className: 'modal-title ' },
												this.loadPopupWelcomeText()
											),
											this.showAvilablityItems(),
											helper.disableSpecialInstructions(APPID) && _react2.default.createElement(
												'a',
												{ className: 'modal-skip', style: { cursor: 'pointer' }, onClick: this.closeAndBrowse.bind(this) },
												'Skip & Browse'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'modal-footer' },
											_react2.default.createElement(
												'div',
												{ className: 'powered-by' },
												'POWERED BY'
											),
											_react2.default.createElement(
												'div',
												{ className: 'footer-logo' },
												_react2.default.createElement(
													'div',
													null,
													' ',
													_react2.default.createElement('img', { src: '/img/popup-ninjaos-card.png' }),
													' '
												),
												htmlToReactParser.parse(this.state.masterCardLogo)
											)
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal fade normal_popup', id: 'normal_popup' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content custom_popup_cms_promo' },
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true', onClick: this.closeNornalPopup.bind() },
										_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: '' })
									),
									htmlToReactParser.parse(this.state.pageDesc),
									_react2.default.createElement(
										'div',
										{ className: 'promo_check' },
										_react2.default.createElement(
											'label',
											null,
											_react2.default.createElement('input', (_React$createElement = { type: 'checkbox', value: 'Yes', name: 'option' }, _defineProperty(_React$createElement, 'value', ''), _defineProperty(_React$createElement, 'onClick', this.toggleCheckbox.bind(this)), _React$createElement)),
											'Don\'t show this message again'
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal fade normal_popup', id: 'promo_popup' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog' },
								_react2.default.createElement(
									'div',
									{ id: 'loadIcon', style: { display: 'none', bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto', zIndex: 99, background: 'rgba(255, 255, 255, 0.8)' } },
									' ',
									_react2.default.createElement('img', { style: { bottom: 0, left: 0, position: 'absolute', right: 0, top: 0, margin: 'auto' }, src: '/img/loader.gif', alt: 'Loading' }),
									' '
								),
								_react2.default.createElement(
									'div',
									{ className: 'modal-content custom_popup_cms_promo' },
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true', onClick: this.DisablePromoPopup.bind(this) },
										_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: '' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'promotion_t' },
										_react2.default.createElement(
											'h4',
											null,
											'PROMOTIONS'
										),
										_react2.default.createElement(
											'p',
											null,
											'Enter your Email address to receive your promocode'
										),
										_react2.default.createElement(
											'div',
											{ className: 'form-group' },
											_react2.default.createElement('input', { type: 'text', id: 'promoEmail', className: 'form-control', placeholder: 'Enter your Email address to receive your promocod' }),
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'btn btn-primary', onClick: this.getPromocode.bind(this) },
												'CHECK PROMOTION'
											)
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal common-distance', id: 'Pickup-OutletSelection' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog locWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											'Select Your Pickup Location'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'div',
											{ className: 'map-loc' },
											_react2.default.createElement(
												'div',
												{ className: 'map-box scrollbar', id: 'style-3' },
												this.__loadOutlets()
											),
											_react2.default.createElement('br', null),
											_react2.default.createElement('br', null)
										)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'Pickup-Sucess' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/DeliverySucess.png', className: 'img-responsive', alt: '' }),
											'Awesome, you can pickup !'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body text-center' },
										this.showDeliveryTiming,
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.pickupSuccess.bind(this), className: 'btn btn-raised btn-info ' },
											'Continue'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'pickup-outlet-sucess' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: '' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/DeliverySucess.png', className: 'img-responsive', alt: '' }),
											'Awesome, you can pickup !'
										),
										_react2.default.createElement(
											'p',
											null,
											_reactCookie2.default.load('orderHandled')
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body text-center' },
										this.showDeliveryTiming,
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.pickupSuccess.bind(this), className: 'btn btn-raised btn-info ' },
											'Continue'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'DeliveryAddress' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											'Your Delivery Address'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'div',
											{ className: 'form-group label-floating is-empty card-no' },
											_react2.default.createElement(
												'div',
												{ className: 'input-group' },
												_react2.default.createElement(
													'label',
													{ className: 'control-label' },
													'Enter Your Postal Code'
												),
												_react2.default.createElement('input', { value: this.state.addressField, id: 'postalcode1', maxLength: '6', className: 'form-control', onKeyPress: function onKeyPress(e) {
														return _this23.validatezip(e);
													}, onChange: this.handleChangeValue.bind(this) })
											)
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										this.showZonalBackButton(),
										_react2.default.createElement(
											'div',
											{ className: parseInt(this.state.settings.client_outlet_zone) === 1 && parseInt(this.state.settings.client_zone_outlet_disable) === 0 ? "col-sm-6 popup-back-btn" : "col-sm-12" },
											_react2.default.createElement(
												'button',
												{ type: 'button', onClick: this.selectOutlet.bind(this), className: 'btn btn-raised btn-info ' },
												'Continue'
											)
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal common-distance', id: 'delivery_outlet' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog locWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											'Please Select Which Outlet is Nearest To Your',
											_react2.default.createElement('br', null),
											'Delivery Location'
										)
									),
									_react2.default.createElement(Overlay, { load: this.state.load }),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'div',
											{ className: 'map-loc' },
											_react2.default.createElement(
												'div',
												{ className: 'map-box scrollbar', id: 'style-3' },
												this.__loadDeliveryOutlets()
											),
											_react2.default.createElement('br', null),
											_react2.default.createElement('br', null)
										)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'AddressList' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', onClick: this.closeaddlist.bind(this), 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/DeliverySucess.png', className: 'img-responsive', alt: true }),
											'Your Delivery Address'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body', style: { textAlign: 'left' } },
										this.loadAddressList(),
										_react2.default.createElement(
											'p',
											null,
											_react2.default.createElement('input', { value: this.state.addressField, onChange: this.handleChangeValue.bind(this), id: 'postalcode', maxLength: '6', placeholder: 'Enter Your Postal Code', className: 'add_list', onKeyPress: function onKeyPress(e) {
													return _this23.validatezip(e);
												} })
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.selectOutlet.bind(this), className: 'btn btn-raised btn-info ' },
											'Continue'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'DeliverySucess' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/DeliverySucess.png', className: 'img-responsive', alt: 'thumb-up' }),
											'Awesome, we can deliver!'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body text-center' },
										_react2.default.createElement(
											'p',
											null,
											_react2.default.createElement(
												'b',
												null,
												'Your Delivery Address: '
											),
											_react2.default.createElement('br', null),
											this.state.orderDeliveryAddress
										),
										this.showdeliveryTiming,
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.deliverySuccess.bind(this), className: 'btn btn-raised btn-info ' },
											'Continue'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'DeliveryError' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/Cant_Deliver.gif', className: 'img-responsive', alt: '' }),
											'Sorry !'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'p',
											null,
											'Sorry we cant deliver to your address ',
											_react2.default.createElement('br', null),
											'Do you want to change your address or check again later ?'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-3' },
											'\xA0'
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-6' },
											_react2.default.createElement(
												'button',
												{ type: 'button', onClick: this.changeDelivery.bind(this), className: 'col-lg-6 btn btn-raised btn-info fullwidth ' },
												'Change Address'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-3' },
											'\xA0'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'ShopClosedError' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: '' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/Cant_Deliver.gif', className: 'img-responsive', alt: '' }),
											'Sorry !'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'p',
											null,
											_react2.default.createElement(
												'b',
												null,
												'Outlet Closed Temporarily. Please Try again later'
											),
											' '
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-12' },
											_react2.default.createElement(
												'button',
												{ type: 'button', onClick: this.closeShopClosedError.bind(this), className: 'col-lg-6 btn btn-raised btn-info fullwidth ' },
												'Check Later'
											)
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						this.state.client_maintenance_mode === '1' && _reactCookie2.default.load('site_maintenance_popup_open') === '1' && (site_maintenance_verify === '' || site_maintenance_verify === '0' || site_maintenance_verify === 'undefined') && _react2.default.createElement(
							'div',
							{ className: 'modal fade promo_popup-2', id: 'promo_popup-2' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content custom_popup_cms_promo' },
									_react2.default.createElement(
										'div',
										{ className: 'maintance-main-box' },
										_react2.default.createElement(
											'div',
											{ className: this.state.client_maintenance_mode === "1" ? "maintance-popup" : "maintance-popup mfp-hide" },
											_react2.default.createElement(
												'div',
												{ className: 'maintance-popup-container' },
												_react2.default.createElement(
													'div',
													{ className: 'maintance-popup-inner-cnt' },
													_react2.default.createElement(
														'div',
														{ className: 'mtnce-pup-imager' },
														_react2.default.createElement('img', { className: 'mtnce-pup-img', src: '/img/maintance.png' })
													),
													_react2.default.createElement(
														'div',
														{ className: 'maintance-popup-contant' },
														_react2.default.createElement(
															'h3',
															null,
															'site is under maintainance'
														),
														_react2.default.createElement(
															'p',
															null,
															' Please enter admin password to browse through website'
														),
														_react2.default.createElement(
															'div',
															{ className: 'maintance-popup-input' },
															_react2.default.createElement('input', { type: 'password', placeholder: 'Enter Admin Password', name: 'client_password_maintain', onChange: this.handleChange_maintain.bind(this), value: this.state.client_password_maintain }),
															_react2.default.createElement(
																'a',
																{
	
																	className: 'button disbl_href_action',
																	title: 'Continue',
																	onClick: this.serviceMaintanance.bind(this)
																},
																'Continue'
															)
														),
														this.state.client_password_maintain_error === "1" && _react2.default.createElement(
															'span',
															{ className: 'spn-error' },
															'This field is required. '
														),
														this.state.client_password_maintain_error === "2" && _react2.default.createElement(
															'span',
															{ className: 'spn-error' },
															'Password is incorrect. '
														)
													)
												)
											)
										)
									)
								)
							)
						)
	
						// <div className="maintance-main-box">
						// 		<div className="maintance-popup-main">
						// 			<div className={(this.state.client_maintenance_mode === "1") ? "maintance-popup" : "maintance-popup mfp-hide"}>
						// 				<div className="maintance-popup-container">
						// 					<div className="maintance-popup-inner-cnt">
						// 						<div className="mtnce-pup-imager">
						// 						<img className="mtnce-pup-img" src="/img/maintance.png" />
						// 						</div>
						// 						<div className="maintance-popup-contant">
						// 						<h3>site is under maintainance</h3>
						// 						<p> Please enter admin password to browse through website</p>
	
						// 						<div className="maintance-popup-input">
						// 							<input type="password" placeholder="Enter Admin Password" name="client_password_maintain" onChange={this.handleChange_maintain.bind(this)}value={this.state.client_password_maintain}/>
						// 							<a
	
						// 							className="button disbl_href_action"
						// 							title="Continue"
						// 							onClick={this.serviceMaintanance.bind(this)}
						// 							>
						// 							Continue
						// 							</a>
						// 						</div>
						// 						{this.state.client_password_maintain_error === "1" && ( <span className="error">This field is required. </span> )}
						//                         {this.state.client_password_maintain_error === "2" && ( <span className="error">Password is incorrect. </span> )}
						// 						</div>
						// 					</div>
						// 				</div>
						// 			</div>
						// 		</div>
						// 	</div>
	
						,
						this.checkPromoPopup(),
						this.checkNormalPopup(),
						this.triggerReservationPopup(),
						this.clickOrderTypePopup(),
						this.checkMaintenancePopup()
					);
				}
			}
		}]);
	
		return Home;
	}(_react2.default.Component);
	
	exports.default = (0, _reactGeolocated.geolocated)({
		positionOptions: {
			enableHighAccuracy: false
		},
		userDecisionTimeout: 5000
	})(Home);

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(9);
	
	var _immutabilityHelper = __webpack_require__(56);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _validator = __webpack_require__(88);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _reactCustomValidation = __webpack_require__(57);
	
	var _reactDatePicker = __webpack_require__(753);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _ThemeProvider = __webpack_require__(84);
	
	var _ThemeProvider2 = _interopRequireDefault(_ThemeProvider);
	
	var _theme = __webpack_require__(89);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	__webpack_require__(71);
	
	var _DatePicker = __webpack_require__(85);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _reactShare = __webpack_require__(878);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	// import 'react-date-picker/dist/DatePicker.css'
	
	
	var config = __webpack_require__(7);
	var Loading = __webpack_require__(17);
	var APIURL = config.path.apiUrl;
	var APIURLPRO = config.path.apiUrlPro;
	var APPID = config.ids.appId;
	var lang = __webpack_require__(12);
	var datetime = new Date(2015, 10, 16);
	
	var Alert = __webpack_require__(48);
	var helper = __webpack_require__(13);
	var apps = __webpack_require__(29);
	//const social = require('./Social');
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton,
	    WhatsappShareButton = _reactShare.ShareButtons.WhatsappShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var WhatsappIcon = (0, _reactShare.generateShareIcon)('whatsapp');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var LinkedinIcon = (0, _reactShare.generateShareIcon)('linkedin');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	/* Load meta tags */
	/* test commit
	sdsadasd
	sdsdsdsd
	*/
	var meta = {
		title: lang.myaccount_meta_title,
		description: lang.myaccount_meta_title,
		meta: {
			name: {
				keywords: lang.myaccount_meta_title
			}
		}
	};
	
	var Myaccount = function (_React$Component) {
		_inherits(Myaccount, _React$Component);
	
		function Myaccount(props) {
			_classCallCheck(this, Myaccount);
	
			/*add class */
			var _this = _possibleConstructorReturn(this, (Myaccount.__proto__ || Object.getPrototypeOf(Myaccount)).call(this, props));
	
			_this.fieldChange = function (field, value) {
				_this.setState((0, _immutabilityHelper2.default)(_this.state, { fields: _defineProperty({}, field, { $set: value }) }));
			};
	
			_this.handleFormSubmit = function () {
	
				var formPayload = _this.state.fields;
				var des = document.getElementsByClassName('birthdate');
				var input = des[0].getElementsByTagName('input');
				formPayload.birthday = input[0].value;
				formPayload.address = document.getElementById("postal-address").value;
				formPayload.gender = document.getElementsByClassName("select-gender")[0].value;
				/*if(document.getElementById("user-default-address-id").value!== null){
	   	formPayload.defaultAddressId = document.getElementById("user-default-address-id").value;
	   } else {
	   	formPayload.defaultAddressId = 0;
	   }
	   if(formPayload.birthday===''){
	   	document.getElementById("spn-birthday-error").innerHTML='<span class="spn-error">This field is required.</span>';
	   	return false;
	   } else {
	   	document.getElementById("spn-birthday-error").innerHTML='';
	   }
	   	if(formPayload.address===''){
	   	document.getElementById("spn-address-error").innerHTML='<span class="spn-error">This field is required.</span>';
	   	return false;
	   } else {
	   	document.getElementById("spn-address-error").innerHTML='';
	   }*/
	
				if (formPayload.unitnumber1 !== '') {
					if (isNaN(formPayload.unitnumber1) === true) {
						document.getElementById("spn-unitno1-error").innerHTML = '<span class="spn-error">This is not a valid number.</span>';
						vsuccess = false;
					} else {
						document.getElementById("spn-unitno1-error").innerHTML = '';
					}
				}
	
				if (formPayload.unitnumber2 !== '') {
					if (isNaN(formPayload.unitnumber2) === true) {
						document.getElementById("spn-unitno2-error").innerHTML = '<span class="spn-error">This is not a valid number.</span>';
						vsuccess = false;
					} else {
						document.getElementById("spn-unitno2-error").innerHTML = '';
					}
				}
				var qs = __webpack_require__(3);
				var postObject = {
					"app_id": APPID,
					"type": "web",
					"customer_first_name": formPayload.firstname,
					"customer_last_name": formPayload.lastname,
					"customer_phone": formPayload.mobile,
					"customer_email": formPayload.email,
					"customer_birthdate": formPayload.birthday,
					'customer_postal_code': formPayload.postal,
					'customer_address_name': formPayload.address,
					'customer_company_name': formPayload.company,
					'customer_gender': formPayload.gender,
					'customer_address_line1': formPayload.unitnumber1,
					'customer_address_line2': formPayload.unitnumber2,
					'customer_id': _reactCookie2.default.load('UserId')
				};
				_this.setStateLoading('Loading');
				_axios2.default.post(APIURL + "customer/updateprofile", qs.stringify(postObject)).then(function (response) {
					if (response.data.status === "ok") {
						_this.setStateLoading('ok');
						//cookie.save("UserId",response.data.result_set.customer_id);
						_reactCookie2.default.save("UserFname", response.data.result_set.customer_first_name);
						_reactCookie2.default.save("UserLname", response.data.result_set.customer_last_name);
						_reactCookie2.default.save("UserMobile", response.data.result_set.customer_phone);
						_reactCookie2.default.save("UserDefaultAddress", response.data.result_set.customer_address_name);
						_reactCookie2.default.save("UserDefaultUnitOne", response.data.result_set.customer_address_line1);
						_reactCookie2.default.save("UserDefaultUnitTwo", response.data.result_set.customer_address_line2);
						_reactCookie2.default.save("UserDefaultPostalCode", response.data.result_set.customer_postal_code);
	
						/* Redirect to checkou page .. */
						if (_reactCookie2.default.load('isChecoutRedirect') === "Yes" && _reactCookie2.default.load('cartValue') === "Yes") {
							_reactCookie2.default.save('isChecoutRedirect', 'No');
							// hashHistory.push("/checkout");
							if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId) {
								_reactRouter.hashHistory.push("/book-a-table");
							} else {
								_reactRouter.hashHistory.push("/delivery-date");
							}
						}
	
						document.getElementById("AlertBox1").style.display = 'block';
						document.getElementById("msg-text").innerHTML = response.data.message;
						setTimeout(function () {
							document.getElementById('msg-text').innerHTML = '';
							document.getElementById('AlertBox1').style.display = 'none';
						}.bind(_this), 3000);
					} else {
						_this.setStateLoading('error');
	
						if (response.data.form_error) {
							document.getElementById("form-msg").innerHTML = '<div class="box_error"><ul><li>' + response.data.form_error + '</li></ul></div>';
						} else {
							document.getElementById("form-msg").innerHTML = '<div class="box_error"><ul><li>' + response.data.message + '</li></ul></div>';
						}
					}
				}).catch(function (error) {
					console.log(error);
				});
			};
	
			helper.addBodyClass();
	
			_this.state = {
				fields: {
					firstname: '',
					lastname: '',
					email: '',
					mobile: '',
					postal: '',
					unitnumber2: '',
					unitnumber1: '',
					company: '',
					birthday: ''
				},
				status: 'Loading',
				reservationAvailable: '',
				defaultDispaly: "",
				settings: {}
			};
	
			/* check Authentication */
			if ((0, _Api2.default)('Auth') === false) {
				_reactRouter.hashHistory.push("/sign-in");
			}
	
			helper.isAnonymousUserRedirect();
			_this.isTempUserRedirect();
			return _this;
		}
	
		_createClass(Myaccount, [{
			key: 'isTempUserRedirect',
			value: function isTempUserRedirect() {
				var isTempUser = parseInt(_reactCookie2.default.load("isTempUser"));
				console.log('isTempUser', isTempUser);
				if (isTempUser === 1) {
					_reactCookie2.default.remove("UserId");
					_reactCookie2.default.remove("UserFname");
					_reactCookie2.default.remove("UserLname");
					_reactCookie2.default.remove("UserMobile");
					_reactCookie2.default.remove("UserEmail");
					_reactCookie2.default.remove("userAccountType");
					_reactCookie2.default.remove("isAnonymousUser");
					this.setState({ login: 'No' });
					setTimeout(function () {
						_reactCookie2.default.remove("isTempUser");
					}, 240000);
	
					_reactRouter.hashHistory.push("/sign-in");
					helper.showInfo("YOU ARE TRYING TO ACCESS PRIVILAGED INFO , PLEASE USE YOUR PHONE NUMBER AND ATTACHED EMAIL TO ACCESS THIS PAGE.");
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				/* Add script */
				(0, _withTracker.loadAnalytics)();
	
				/* API CALL FOR CUSTOMER DETAIL*/
				_axios2.default.get(APIURL + '/customer/customerdetail?app_id=' + APPID + "&refrence=" + _reactCookie2.default.load('UserId')).then(function (res) {
					if (res.data.status === "ok") {
						_this2.setState({ fields: {
								firstname: res.data.result_set.customer_first_name,
								lastname: res.data.result_set.customer_last_name,
								email: res.data.result_set.customer_email,
								mobile: res.data.result_set.customer_phone,
								postal: res.data.result_set.customer_postal_code,
								unitnumber2: res.data.result_set.customer_address_line2,
								unitnumber1: res.data.result_set.customer_address_line1,
								company: res.data.result_set.customer_company_name
							}, status: res.data.status });
						var des = document.getElementsByClassName('birthdate');
						var fc = des[0].getElementsByTagName('div');
						var se = fc[0].getElementsByTagName('div');
						var input = se[0].getElementsByTagName('input');
						//alert(res.data.result_set.customer_birthdate);
						if (res.data.result_set.customer_birthdate == null) {
							input[0].value = '';
						} else {
							input[0].value = new Date(res.data.result_set.customer_birthdate);
						}
						if (res.data.result_set.customer_gender == 'M') {
							document.getElementById("female").removeAttribute("selected");
							document.getElementById("male").setAttribute("selected", "selected");
						} else {
							document.getElementById("male").removeAttribute("selected");
							document.getElementById("female").setAttribute("selected", "selected");
						}
						var label = des[0].getElementsByTagName('label');
						label[0].style.top = '0px';
						label[0].style.fontSize = '10px';
						document.getElementById("postal-address").value = res.data.result_set.customer_address_name;
						document.getElementById("postal-address").setAttribute("value", res.data.result_set.customer_address_name);
						var vDefaultAddr = '';
						if (res.data.result_set.customer_address_name !== '' && res.data.result_set.customer_address_name !== null) {
							vDefaultAddr += '<p><b>Previous Order Address</b></p><p id="user-default-address" >' + res.data.result_set.customer_address_name + '<br />';
						}
						if (res.data.result_set.customer_address_line1 !== '' && res.data.result_set.customer_address_line1 !== null) {
							vDefaultAddr += res.data.result_set.customer_address_line1 + '<br />';
						}
						if (res.data.result_set.customer_address_line2 !== '' && res.data.result_set.customer_address_line2 !== null) {
							vDefaultAddr += res.data.result_set.customer_address_line2 + '<br />';
						}
						if (res.data.result_set.customer_postal_code !== '' && res.data.result_set.customer_postal_code !== null) {
							vDefaultAddr += res.data.result_set.customer_postal_code;
						}
						vDefaultAddr += '</p>';
						/*document.getElementById("user-default-billing-address").innerHTML=vDefaultAddr;*/
						var list = document.getElementsByClassName('form-group-input');
						var n;
						for (n = 0; n < list.length; ++n) {
							if (list[n].getElementsByTagName('input')[0].value !== '') {
								list[n].classList.remove("is-empty");
							} else {
								list[n].classList.add("is-empty");
							}
						}
					} else {
						_reactCookie2.default.remove("UserId");
						_reactCookie2.default.remove("UserFname");
						_reactCookie2.default.remove("UserLname");
						_reactCookie2.default.remove("UserMobile");
						_reactCookie2.default.remove("UserEmail");
						_reactRouter.hashHistory.push("/sign-in");
						//this.setState({status: res.data.status});
					}
				});
	
				_axios2.default.get(APIURLPRO + 'reservation/check_availability?app_id=' + APPID + '&availability_id=' + config.ids.reservationId).then(function (res) {
					if (res.data.status === "ok") {
						_this2.setState({ reservationAvailable: "Yes" });
					}
				});
			}
		}, {
			key: 'setStateLoading',
			value: function setStateLoading(sts) {
				this.setState({ status: sts });
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.state.status === "Loading") {
					return _react2.default.createElement(
						'div',
						{ className: 'container-fluid desktop-container' },
						_react2.default.createElement('div', { className: 'row' }),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement('div', { className: 'space-10 bg-gray' })
						),
						_react2.default.createElement(
							'div',
							{ className: ' ' },
							_react2.default.createElement(
								'div',
								{ className: 'col-xs-10 div-center' },
								_react2.default.createElement('div', { className: 'space-5' }),
								_react2.default.createElement(Loading, null),
								_react2.default.createElement('div', { className: 'space-5' })
							),
							_react2.default.createElement('div', { className: 'clearfix' })
						),
						_react2.default.createElement('div', { className: 'space-30' }),
						_react2.default.createElement('div', { className: 'space-30' }),
						_react2.default.createElement('div', { className: 'space-30' }),
						_react2.default.createElement('div', { className: 'space-30' }),
						_react2.default.createElement('div', { className: 'space-30' }),
						_react2.default.createElement('div', { className: 'space-5' }),
						_react2.default.createElement('div', { className: 'space-5' }),
						_react2.default.createElement('div', { className: 'space-30' }),
						' ',
						_react2.default.createElement('div', { className: 'space-30' }),
						' ',
						_react2.default.createElement('div', { className: 'space-30' }),
						' ',
						_react2.default.createElement('div', { className: 'space-30' })
					);
				} else {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(Alert, null),
						_react2.default.createElement(_reactDocumentMeta2.default, meta),
						_react2.default.createElement(Form, {
							fields: this.state.fields,
							onChange: this.fieldChange,
							onValid: this.handleFormSubmit,
							onInvalid: function onInvalid() {
								return console.log('Form invalid!');
							}
						})
					);
				}
			}
		}]);
	
		return Myaccount;
	}(_react2.default.Component);
	
	var phonenumberPattern = /^[0-9]{6,14}$/;
	var postalcodePattern = /^\d{6}$/;
	
	var isEmpty = function isEmpty(value) {
		return value === '' ? 'This field is required.' : null;
	};
	
	var isEmail = function isEmail(email) {
		return _validator2.default.isEmail(email) ? null : 'This is not a valid email.';
	};
	
	var isMobile = function isMobile(mobile) {
		if (mobile) {
			mobile.match(phonenumberPattern) ? null : 'This is not a valid mobile number.';
		}
	};
	
	var isMobileDigt = function isMobileDigt(mobile) {
		return mobile != null && mobile.length === 8 ? null : 'This is not a valid mobile number.';
	};
	
	function validationConfig(props) {
		var _props$fields = props.fields,
		    firstname = _props$fields.firstname,
		    lastname = _props$fields.lastname,
		    email = _props$fields.email,
		    mobile = _props$fields.mobile;
	
	
		return {
			fields: ['firstname', 'lastname', 'email', 'mobile'],
	
			validations: {
				firstname: [[isEmpty, firstname]],
				lastname: [[isEmpty, lastname]],
				email: [[isEmail, email]],
				mobile: [[isEmpty, mobile], [isMobileDigt, mobile], [isMobile, mobile]]
			}
		};
	}
	
	var Form = function (_React$Component2) {
		_inherits(Form, _React$Component2);
	
		function Form(props) {
			_classCallCheck(this, Form);
	
			var _this3 = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));
	
			_this3.handleChange = function (item, value) {
				_this3.setState(Object.assign({}, _this3.state, _defineProperty({}, item, value)));
				var des = document.getElementsByClassName('birthdate');
				var label = des[0].getElementsByTagName('label');
				label[0].style.top = '0px';
				label[0].style.fontSize = '10px';
			};
	
			_this3.state = {
				status: 'Loading',
				secAddrData: [],
				date1: datetime,
				settings: {}
			};
			return _this3;
		}
	
		_createClass(Form, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this4 = this;
	
				this.setStateLoading('ok');
				this.getSecAddr();
	
				var promise = (0, _Api2.default)('settingsPro', 'No');
				promise.then(function (res) {
	
					_this4.setState({ settings: res.data.result_set });
				});
			}
		}, {
			key: 'loadSecAddr',
			value: function loadSecAddr(dataArr) {
	
				var htmlStr = dataArr.map(function (data, index) {
					var _this5 = this;
	
					return _react2.default.createElement(
						'p',
						{ id: 'user-default-address', key: index },
						_react2.default.createElement(
							'a',
							{ onClick: function onClick() {
									_this5.DeleteSecAddr(data.secondary_address_id);
								}, title: 'Delete', style: { width: '20px', float: 'right', cursor: 'pointer', paddingLeft: '10px' } },
							_react2.default.createElement('i', { className: 'fa fa-trash' })
						),
						_react2.default.createElement(
							'a',
							{ onClick: function onClick() {
									_this5.LoadEditSecAddr(data);
								}, title: 'Edit', style: { width: '20px', float: 'right', cursor: 'pointer', marginRight: '10px' } },
							_react2.default.createElement('i', { className: 'fa fa-pencil' })
						),
						data.address,
						data.unit_code ? _react2.default.createElement('br', null) : '',
						data.unit_code ? helper.unitFormat(data.unit_code, data.unit_code2) : '',
						data.postal_code ? _react2.default.createElement('br', null) : '',
						data.postal_code ? data.postal_code : ''
					);
				}.bind(this));
				return htmlStr;
			}
		}, {
			key: 'LoadEditSecAddr',
			value: function LoadEditSecAddr(dataArr) {
				$('html,body').animate({ scrollTop: $(".disabled-continue-as-a-guest").offset().top }, 'slow');
				this.openNewAddress();
				document.getElementById("customer_postal_code").value = dataArr.postal_code;
				document.getElementById("customer_address_line1").value = dataArr.address;
				document.getElementById("customer_address_name").value = dataArr.unit_code;
				document.getElementById("customer_address_name2").value = dataArr.unit_code2;
				document.getElementById("address_id").value = dataArr.secondary_address_id;
				var list = document.getElementsByClassName('address-form-group');
				var n;
				for (n = 0; n < list.length; ++n) {
					if (list[n].getElementsByTagName('input')[0].value !== '') {
						list[n].classList.remove("is-empty");
					} else {
						list[n].classList.add("is-empty");
					}
				}
			}
		}, {
			key: 'DeleteSecAddr',
			value: function DeleteSecAddr(pmId) {
				var _this6 = this;
	
				this.setStateLoading('Loading');
				var qs = __webpack_require__(3);
				var postObject = {
					"app_id": APPID,
					"type": "web",
					"secondary_address_id": pmId,
					"refrence": _reactCookie2.default.load('UserId')
				};
	
				_axios2.default.post(APIURL + "customer/secondary_address_remove", qs.stringify(postObject)).then(function (response) {
	
					if (response.data.status === "ok") {
						_this6.setStateLoading('ok');
						//cookie.save('alertSuccess',response.data.message);
						document.getElementById("AlertBox1").style.display = 'block';
						document.getElementById("msg-text").innerHTML = response.data.message;
						setTimeout(function () {
							document.getElementById('msg-text').innerHTML = '';
							document.getElementById('AlertBox1').style.display = 'none';
						}.bind(_this6), 3000);
						_this6.setState({ secAddrData: [] });
						_this6.getSecAddr();
					} else {
						_this6.setStateLoading('error');
						//document.getElementById("form-msg").innerHTML='<p class="spn-error">'+response.data.message+'</p>';
						document.getElementById("form-msg").innerHTML = '<div class="box_error"><ul><li>' + response.data.message + '</li></ul></div>';
					}
				}).catch(function (error) {
					console.log(error);
				});
			}
		}, {
			key: 'loadPostalAddress',
			value: function loadPostalAddress() {
				var postal = document.getElementById("customer_postal_code").value;
				if (postal.match(postalcodePattern)) {
					_axios2.default.get(APIURL + '/settings/get_address?app_id=' + APPID + "&zip_code=" + postal).then(function (res) {
						if (res.data.status === "ok") {
							document.getElementById("customer_address_line1").value = res.data.result_set.zip_buno + " " + res.data.result_set.zip_sname;
							//  document.getElementById("customer_address_line1").setAttribute("value",res.data.result_set.zip_sname);
							document.getElementById("spn-postalcode-error").innerHTML = '';
							var list = document.getElementsByClassName('form-group');
							var n;
							for (n = 0; n < list.length; ++n) {
								if (document.getElementById("customer_address_line1").value !== '') {
									list[n].classList.remove("is-empty");
								} else {
									list[n].classList.add("is-empty");
								}
							}
						} else {
							document.getElementById("spn-postalcode-error").innerHTML = '<span class="spn-error">This is not a valid postal code.</span>';
							document.getElementById("customer_postal_code").value = '';
							document.getElementById("customer_postal_code").setAttribute("value", '');
							document.getElementById("customer_address_line1").value = '';
							document.getElementById("customer_address_line1").setAttribute("value", '');
						}
					});
				}
			}
		}, {
			key: 'openNewAddress',
			value: function openNewAddress() {
				document.getElementsByClassName('new-user-reg')[0].style.display = "block";
				document.getElementById("checkout").classList.remove("disable-btn");
				document.getElementById("customer_postal_code").value = '';
				document.getElementById("customer_address_line1").value = '';
				document.getElementById("customer_address_name").value = '';
				document.getElementById("customer_address_name2").value = '';
				document.getElementById("address_id").value = '';
				var list = document.getElementsByClassName('address-form-group');
				var n;
				for (n = 0; n < list.length; ++n) {
					list[n].classList.add("is-empty");
				}
			}
		}, {
			key: 'setStateLoading',
			value: function setStateLoading(sts) {
				this.setState({ status: sts });
			}
		}, {
			key: 'saveNewAddress',
			value: function saveNewAddress() {
				var _this7 = this;
	
				var vsuccess = true;
				var vPostalCode = document.getElementById("customer_postal_code").value;
				var vAddress = document.getElementById("customer_address_line1").value;
				var vUnitNo1 = document.getElementById("customer_address_name").value;
				var vUnitNo2 = document.getElementById("customer_address_name2").value;
				if (vPostalCode === '') {
					document.getElementById("spn-postalcode-error").innerHTML = '<span class="spn-error">This field is required.</span>';
					vsuccess = false;
				} else if (vPostalCode !== '' && vPostalCode.match(postalcodePattern) === null) {
					document.getElementById("spn-postalcode-error").innerHTML = '<span class="spn-error">This is not a valid postal code.</span>';
					vsuccess = false;
				} else {
					document.getElementById("spn-postalcode-error").innerHTML = '';
				}
				if (vAddress === '') {
					document.getElementById("spn-addr-error").innerHTML = '<span class="spn-error">This field is required.</span>';
					vsuccess = false;
				} else {
					document.getElementById("spn-addr-error").innerHTML = '';
				}
	
				if (vUnitNo1 !== '') {
					if (isNaN(vUnitNo1) === true) {
						document.getElementById("spn-unit1-error").innerHTML = '<span class="spn-error">This is not a valid number.</span>';
						vsuccess = false;
					} else {
						document.getElementById("spn-unit1-error").innerHTML = '';
					}
				}
	
				if (vUnitNo2 !== '') {
					if (isNaN(vUnitNo2) === true) {
						document.getElementById("spn-unit2-error").innerHTML = '<span class="spn-error">This is not a valid number.</span>';
						vsuccess = false;
					} else {
						document.getElementById("spn-unit2-error").innerHTML = '';
					}
				}
	
				if (vsuccess) {
					this.setStateLoading('Loading');
	
					var qs = __webpack_require__(3);
	
					if (document.getElementById("address_id").value !== '') {
						var PostUrl = APIURL + "customer/secondary_address_edit";
						var postObject = {
							"app_id": APPID,
							"type": "web",
							"customer_first_name": _reactCookie2.default.load('UserFname'),
							"customer_last_name": _reactCookie2.default.load('UserLname'),
							"customer_email": _reactCookie2.default.load('UserEmail'),
							"customer_address_line1": document.getElementById("customer_address_line1").value,
							"customer_postal_code": document.getElementById("customer_postal_code").value,
							"customer_address_name": document.getElementById("customer_address_name").value,
							'customer_address_name2': document.getElementById("customer_address_name2").value,
							'secondary_address_id': document.getElementById("address_id").value,
							'refrence': _reactCookie2.default.load('UserId')
						};
					} else {
						var PostUrl = APIURL + "customer/secondary_address_add";
						var postObject = {
							"app_id": APPID,
							"type": "web",
							"customer_first_name": _reactCookie2.default.load('UserFname'),
							"customer_last_name": _reactCookie2.default.load('UserLname'),
							"customer_email": _reactCookie2.default.load('UserEmail'),
							"customer_address_line1": document.getElementById("customer_address_line1").value,
							"customer_postal_code": document.getElementById("customer_postal_code").value,
							"customer_address_name": document.getElementById("customer_address_name").value,
							'customer_address_name2': document.getElementById("customer_address_name2").value,
							'refrence': _reactCookie2.default.load('UserId')
						};
					}
					_axios2.default.post(PostUrl, qs.stringify(postObject)).then(function (response) {
						if (response.data.status === "ok") {
							_this7.setStateLoading('ok');
							//cookie.save('alertSuccess',response.data.message);
							document.getElementById("AlertBox1").style.display = 'block';
							document.getElementById("msg-text").innerHTML = response.data.message;
							_this7.getSecAddr();
							setTimeout(function () {
								document.getElementById('msg-text').innerHTML = '';
								document.getElementById('AlertBox1').style.display = 'none';
							}.bind(_this7), 3000);
						} else {
							_this7.setStateLoading('error');
							//document.getElementById("form-msg").innerHTML='<p class="spn-error">'+response.data.message+'</p>';
							document.getElementById("form-msg").innerHTML = '<div class="box_error"><ul><li>' + response.data.message + '</li></ul></div>';
						}
						//this.openNewAddress();
					}).catch(function (error) {
						console.log(error);
					});
				}
				var select = document.getElementsByClassName('select-gender')[0];
				select.style.background = 'none';
				select.style.margin = '0 0 0 6px';
				select.style.fontWeight = 'bold';
				select.style.fontSize = '14px';
				select.style.padding = '8px 0 0 0';
				return false;
			}
		}, {
			key: 'getSecAddr',
			value: function getSecAddr() {
				var _this8 = this;
	
				_axios2.default.get(APIURL + '/customer/get_user_secondary_address?app_id=' + APPID + "&refrence=" + _reactCookie2.default.load('UserId')).then(function (res) {
					if (res.data.status === "ok") {
	
						_this8.setState({ secAddrData: res.data.result_set });
						var select = document.getElementsByClassName('select-gender')[0];
						select.style.background = 'none';
						select.style.margin = '0 0 0 6px';
						select.style.fontWeight = 'bold';
						select.style.fontSize = '14px';
						select.style.padding = '8px 0 0 0';
						document.getElementsByClassName('gender')[0].classList.remove("is-empty");
						var des = document.getElementsByClassName('birthdate');
						var fc = des[0].getElementsByTagName('div');
						var se = fc[0].getElementsByTagName('div');
						se[0].style.padding = '0px';
						var input = se[0].getElementsByTagName('input');
						input[0].style.borderBottom = '0px';
						var label = des[0].getElementsByTagName('label');
						label[0].style.top = '0px';
						label[0].style.fontSize = '10px';
					}
				});
	
				/* API CALL FOR CUSTOMER DETAIL*/
				_axios2.default.get(APIURL + '/customer/customerdetail?app_id=' + APPID + "&refrence=" + _reactCookie2.default.load('UserId')).then(function (res) {
					if (res.data.status === "ok") {
						var des = document.getElementsByClassName('birthdate');
						var fc = des[0].getElementsByTagName('div');
						var se = fc[0].getElementsByTagName('div');
						var input = se[0].getElementsByTagName('input');
						if (res.data.result_set.customer_birthdate == "0000-00-00" || res.data.result_set.customer_birthdate == null) {
							input[0].value = res.data.result_set.customer_birthdate;
							input[0].setAttribute("value", res.data.result_set.customer_birthdate);
	
							_this8.setState({ date1: '' });
						} else {
							input[0].value = res.data.result_set.customer_birthdate;
							input[0].setAttribute("value", res.data.result_set.customer_birthdate);
	
							_this8.setState({ date1: new Date(res.data.result_set.customer_birthdate) });
						}
						if (res.data.result_set.customer_gender == 'M') {
							document.getElementById("female").removeAttribute("selected");
							document.getElementById("male").setAttribute("selected", "selected");
						} else {
							document.getElementById("male").removeAttribute("selected");
							document.getElementById("female").setAttribute("selected", "selected");
						}
						var label = des[0].getElementsByTagName('label');
						label[0].style.top = '0px';
						label[0].style.fontSize = '10px';
						document.getElementById("postal-address").value = res.data.result_set.customer_address_name;
						document.getElementById("postal-address").setAttribute("value", res.data.result_set.customer_address_name);
						var vDefaultAddr = '';
						if (res.data.result_set.customer_address_name !== '' && res.data.result_set.customer_address_name !== null) {
							vDefaultAddr += '<p><b>Previous Order Address</b></p><p id="user-default-address" >' + res.data.result_set.customer_address_name + '<br />';
						}
						if (res.data.result_set.customer_address_line1 !== '' && res.data.result_set.customer_address_line1 !== null) {
							vDefaultAddr += helper.unitFormat(res.data.result_set.customer_address_line1, res.data.result_set.customer_address_line2) + '<br />';
						}
						if (res.data.result_set.customer_postal_code !== '' && res.data.result_set.customer_postal_code !== null) {
							vDefaultAddr += res.data.result_set.customer_postal_code;
						}
						vDefaultAddr += '</p>';
						//document.getElementById("user-default-billing-address").innerHTML=vDefaultAddr;
						var list = document.getElementsByClassName('form-group-input');
						var n;
						for (n = 0; n < list.length; ++n) {
							if (list[n].getElementsByTagName('input')[0].value !== '') {
								list[n].classList.remove("is-empty");
							} else {
								list[n].classList.add("is-empty");
							}
						}
					} else {
						_reactCookie2.default.remove("UserId");
						_reactCookie2.default.remove("UserFname");
						_reactCookie2.default.remove("UserLname");
						_reactCookie2.default.remove("UserMobile");
						_reactCookie2.default.remove("UserEmail");
						_reactRouter.hashHistory.push("/sign-in");
					}
					var select = document.getElementsByClassName('select-gender')[0];
					select.style.background = 'none';
					select.style.margin = '0 0 0 6px';
					select.style.fontWeight = 'bold';
					select.style.fontSize = '14px';
					select.style.padding = '8px 0 0 0';
					document.getElementsByClassName('gender')[0].classList.remove("is-empty");
					var des = document.getElementsByClassName('birthdate');
					var fc = des[0].getElementsByTagName('div');
					var se = fc[0].getElementsByTagName('div');
					se[0].style.padding = '0px';
					var input = se[0].getElementsByTagName('input');
					input[0].style.borderBottom = '0px';
					var label = des[0].getElementsByTagName('label');
					label[0].style.top = '0px';
					label[0].style.fontSize = '10px';
				});
			}
		}, {
			key: 'setBirthday',
			value: function setBirthday() {
				var _this9 = this;
	
				var des = document.getElementsByClassName('birthdate');
				var input = des[0].getElementsByTagName('input');
				if (input[0].value === '') {
					_axios2.default.get(APIURL + '/customer/customerdetail?app_id=' + APPID + "&refrence=" + _reactCookie2.default.load('UserId')).then(function (res) {
						if (res.data.status === "ok") {
							var des1 = document.getElementsByClassName('birthdate');
							var fc1 = des1[0].getElementsByTagName('div');
							var se1 = fc1[0].getElementsByTagName('div');
							var input1 = se1[0].getElementsByTagName('input');
							if (res.data.result_set.customer_birthdate == "0000-00-00" || res.data.result_set.customer_birthdate == null) {
								input[0].value = res.data.result_set.customer_birthdate;
								input[0].setAttribute("value", res.data.result_set.customer_birthdate);
	
								_this9.setState({ date1: '' });
							} else {
								input[0].value = res.data.result_set.customer_birthdate;
								input[0].setAttribute("value", res.data.result_set.customer_birthdate);
	
								_this9.setState({ date1: new Date(res.data.result_set.customer_birthdate) });
							}
							var label = des1[0].getElementsByTagName('label');
							label[0].style.top = '0px';
							label[0].style.fontSize = '10px';
						}
					});
				} else {
					var des1 = document.getElementsByClassName('birthdate');
					var fc1 = des1[0].getElementsByTagName('div');
					var se1 = fc1[0].getElementsByTagName('div');
					var input1 = se1[0].getElementsByTagName('input');
					input1[0].value = input[0].value;
					input1[0].setAttribute("value", input[0].value);
					this.setState({ date1: new Date(input[0].value) });
					var label = des1[0].getElementsByTagName('label');
					label[0].style.top = '0px';
					label[0].style.fontSize = '10px';
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var select = document.getElementsByClassName('select-gender')[0];
				select.style.background = 'none';
				select.style.margin = '0 0 0 6px';
				select.style.fontWeight = 'bold';
				select.style.fontSize = '14px';
				select.style.padding = '8px 0 0 0';
				document.getElementsByClassName('gender')[0].classList.remove("is-empty");
				var des = document.getElementsByClassName('birthdate');
				var fc = des[0].getElementsByTagName('div');
				var se = fc[0].getElementsByTagName('div');
				se[0].style.padding = '0px';
				var input = se[0].getElementsByTagName('input');
				input[0].style.borderBottom = '0px';
				var label = des[0].getElementsByTagName('label');
				label[0].style.top = '0px';
				label[0].style.fontSize = '10px';
			}
		}, {
			key: 'clearSuccesMsg',
			value: function clearSuccesMsg() {
				document.getElementById('msg-text').innerHTML = '';
				document.getElementById('AlertBox1').style.display = 'none';
			}
	
			/* show and hide */
	
		}, {
			key: 'showAddThisDiv',
			value: function showAddThisDiv() {
	
				if (document.getElementById('sharediv').style.display === "none" || document.getElementById('sharediv').style.display === "") {
					this.setState({ defaultDispaly: "inline-block" });
				} else {
					this.setState({ defaultDispaly: "none" });
				}
			}
		}, {
			key: 'loadCartImage',
			value: function loadCartImage() {
				return (0, _Api2.default)('cartImage', 'Yes');
			}
		}, {
			key: 'loaddaofbirth',
			value: function loaddaofbirth() {
	
				if (this.state.date1 !== '0000-00-00') {
					return _react2.default.createElement(_DatePicker2.default, { className: 'birthdate', label: 'Birthday', sundayFirstDayOfWeek: true, autoOk: true, inputFormat: function inputFormat(value) {
							return (value.getDate() < 10 ? '0' + value.getDate() : value.getDate()) + '-' + (value.getMonth() + 1 < 10 ? '0' + (value.getMonth() + 1) : value.getMonth() + 1) + '-' + value.getFullYear();
						}, onChange: this.handleChange.bind(this, 'date1'), value: this.state.date1 });
				} else {
					return _react2.default.createElement(_DatePicker2.default, { className: 'birthdate', label: 'Birthday', sundayFirstDayOfWeek: true, autoOk: true, inputFormat: function inputFormat(value) {
							return (value.getDate() < 10 ? '0' + value.getDate() : value.getDate()) + '-' + (value.getMonth() + 1 < 10 ? '0' + (value.getMonth() + 1) : value.getMonth() + 1) + '-' + value.getFullYear();
						}, onChange: this.handleChange.bind(this, 'date1') });
				}
			}
	
			/* promoMenu */
	
		}, {
			key: 'rewardMenu',
			value: function rewardMenu() {
				var usertype = typeof _reactCookie2.default.load('userAccountType') !== "undefined" ? _reactCookie2.default.load('userAccountType') : 0;
				if (APPID !== apps.workspace) {
					return _react2.default.createElement(
						_reactRouter.Link,
						{ to: "/rewards" },
						'  ',
						_react2.default.createElement('img', { src: '/img/icons/view-rewards.png', alt: '' }),
						_react2.default.createElement(
							'h4',
							null,
							'Rewards'
						),
						'  '
					);
				}
			}
		}, {
			key: 'vouchersMenu',
			value: function vouchersMenu() {
				var usertype = typeof _reactCookie2.default.load('userAccountType') !== "undefined" ? _reactCookie2.default.load('userAccountType') : 0;
				if (APPID !== apps.workspace) {
					return _react2.default.createElement(
						_reactRouter.Link,
						{ to: "/vouchers" },
						'  ',
						_react2.default.createElement('img', { src: '/img/icons/gift-voucher.svg', alt: '' }),
						_react2.default.createElement(
							'h4',
							null,
							'e-Vouchers'
						),
						'  '
					);
				}
			}
		}, {
			key: 'promoMenu',
			value: function promoMenu() {
				var usertype = typeof _reactCookie2.default.load('userAccountType') !== "undefined" ? _reactCookie2.default.load('userAccountType') : 0;
				if (APPID !== apps.workspace) {
					return _react2.default.createElement(
						_reactRouter.Link,
						{ to: "/promotion" },
						'  ',
						_react2.default.createElement('img', { src: '/img/icons/view-promotions.png', alt: '' }),
						_react2.default.createElement(
							'h4',
							null,
							'Promotion'
						),
						'  '
					);
				}
			}
	
			/**/
	
		}, {
			key: 'reservationMenu',
			value: function reservationMenu() {
				var usertype = typeof _reactCookie2.default.load('userAccountType') !== "undefined" ? _reactCookie2.default.load('userAccountType') : 0;
	
				/*if(parseInt(usertype) !== 1  ) { */
				return _react2.default.createElement(
					_reactRouter.Link,
					{ to: "/reservation" },
					'  ',
					_react2.default.createElement('img', { src: '/img/icons/view-reservation.png', alt: '' }),
					_react2.default.createElement(
						'h4',
						null,
						'Reservation'
					),
					'  '
				);
				/*}*/
			}
		}, {
			key: 'render',
			value: function render() {
				var _this10 = this;
	
				var displaySts = this.state.defaultDispaly === "" ? "none" : this.state.defaultDispaly;
				if (this.state.status === "Loading") {
					return _react2.default.createElement(Loading, null);
				} else {
					var _props = this.props,
					    fields = _props.fields,
					    onChange = _props.onChange,
					    onValid = _props.onValid,
					    onInvalid = _props.onInvalid,
					    $field = _props.$field,
					    $validation = _props.$validation;
	
	
					var PreviousOrderAddressTitle = void 0,
					    errMsgFirstname = void 0,
					    errMsgLastname = void 0,
					    errMsgEmail = void 0,
					    errMsgMobile = void 0,
					    errMsgPostal = void 0;
	
					if ($validation.firstname.error.reason !== undefined) {
						errMsgFirstname = $validation.firstname.show && _react2.default.createElement(
							'span',
							{ className: 'spn-error' },
							$validation.firstname.error.reason
						);
					}
	
					if ($validation.lastname.error.reason !== undefined) {
						errMsgLastname = $validation.lastname.show && _react2.default.createElement(
							'span',
							{ className: 'spn-error' },
							$validation.lastname.error.reason
						);
					}
	
					if ($validation.email.error.reason !== undefined) {
						errMsgEmail = $validation.email.show && _react2.default.createElement(
							'span',
							{ className: 'spn-error' },
							$validation.email.error.reason
						);
					}
	
					if ($validation.mobile.error.reason !== undefined) {
						errMsgMobile = $validation.mobile.show && _react2.default.createElement(
							'span',
							{ className: 'spn-error' },
							$validation.mobile.error.reason
						);
					}
					var opts = {};
					opts['readOnly'] = 'readOnly';
					if (this.state.secAddrData.length > 0) {
						PreviousOrderAddressTitle = _react2.default.createElement(
							'div',
							{ id: 'user-default-billing-address' },
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'b',
									null,
									'Previous Order Address'
								)
							)
						);
					}
					return _react2.default.createElement(
						_ThemeProvider2.default,
						{ theme: _theme2.default },
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid desktop-container' },
							_react2.default.createElement(
								'div',
								{ className: 'alert-box', id: 'AlertBox1', style: { display: 'none' } },
								_react2.default.createElement(
									'p',
									{ className: 'success-msg alert-msg' },
									_react2.default.createElement('span', { id: 'msg-text' }),
									_react2.default.createElement(
										'a',
										{ onClick: this.clearSuccesMsg.bind(this), className: 'close-icon' },
										_react2.default.createElement('i', { className: 'fa fa-times-circle-o' })
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 top-nav inner-top-nav head-main' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-3 nav-head pd-l-20 head-child' },
										' ',
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: "/" },
											_react2.default.createElement('img', { src: '/img/icons/arrow-right.png', alt: 'left-arrow', className: 'icon-img-small-3' }),
											' Back'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-6 nav-head  head-child' },
										_react2.default.createElement(
											'h1',
											{ className: 'main-title' },
											'my account'
										)
									),
									_react2.default.createElement('div', { className: 'col-xs-3 nopadding  head-child' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row login-container color-grey' },
								_react2.default.createElement(
									'div',
									{ className: 'col-lg-12 myAccount' },
									_react2.default.createElement(
										'div',
										{ className: 'profileimage' },
										_react2.default.createElement('img', { src: '/img/no-images/myaccount_icon.jpg', style: { width: '150px', height: '150px', borderRadius: '100px' }, alt: 'profile' }),
										_react2.default.createElement(
											'h1',
											null,
											fields.firstname,
											' ',
											fields.lastname
										),
										_react2.default.createElement(
											'h5',
											null,
											fields.email
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-lg-12' },
									_react2.default.createElement(
										'div',
										{ className: 'myAccountTabs' },
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-12 col-md-12 col-lg-12' },
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: "/orders" },
												_react2.default.createElement('img', { src: '/img/icons/view-oder.png', alt: '' }),
												_react2.default.createElement(
													'h4',
													null,
													'Orders'
												)
											),
											APPID !== 'AA850867-4108-4EB8-872B-024903608E9F' && APPID !== '8F8FE4E6-88C9-4071-9215-312E0F50016A' && APPID !== 'B401FC82-8E39-4076-838A-55192F765004' && APPID !== "6C0280A0-B655-4E0F-A43F-041C189683BA" && APPID !== "B93EC9A9-1A67-4EBA-ADB7-BC7C14FA88A4" && APPID !== "88E232C9-8943-4042-B4D4-3413E394007B" && helper.disableMenu(this.state.settings, 'myaccount_reservation') && this.reservationMenu(),
											APPID !== 'B401FC82-8E39-4076-838A-55192F765004' && APPID !== "6C0280A0-B655-4E0F-A43F-041C189683BA" && APPID !== "B93EC9A9-1A67-4EBA-ADB7-BC7C14FA88A4" && APPID !== "33843AC9-EB47-42EE-8AAA-14CEA187D85A" && APPID !== "4EDE9A25-89AA-4200-848D-AC4A5A54B7BC" && helper.disableMenu(this.state.settings, 'myaccount_promos') && this.promoMenu(),
											APPID !== 'AA850867-4108-4EB8-872B-024903608E9F' && APPID !== '8F8FE4E6-88C9-4071-9215-312E0F50016A' && APPID !== 'B401FC82-8E39-4076-838A-55192F765004' && APPID !== "33843AC9-EB47-42EE-8AAA-14CEA187D85A" && APPID !== "6C0280A0-B655-4E0F-A43F-041C189683BA" && APPID !== "4EDE9A25-89AA-4200-848D-AC4A5A54B7BC" && helper.disableMenu(this.state.settings, 'myaccount_vouchers') && this.vouchersMenu(),
											APPID !== 'AA850867-4108-4EB8-872B-024903608E9F' && APPID !== '8F8FE4E6-88C9-4071-9215-312E0F50016A' && APPID !== 'B401FC82-8E39-4076-838A-55192F765004' && APPID !== "6C0280A0-B655-4E0F-A43F-041C189683BA" && APPID !== "B93EC9A9-1A67-4EBA-ADB7-BC7C14FA88A4" && APPID !== "33843AC9-EB47-42EE-8AAA-14CEA187D85A" && APPID !== "4EDE9A25-89AA-4200-848D-AC4A5A54B7BC" && helper.disableMenu(this.state.settings, 'myaccount_rewards') && this.rewardMenu(),
											APPID !== 'B401FC82-8E39-4076-838A-55192F765004' && APPID !== "6C0280A0-B655-4E0F-A43F-041C189683BA" && APPID !== "B93EC9A9-1A67-4EBA-ADB7-BC7C14FA88A4" && helper.disableMenu(this.state.settings, 'myaccount_share') && _react2.default.createElement(
												_reactRouter.Link,
												{ className: 'share_button', onClick: this.showAddThisDiv.bind(this) },
												'  ',
												_react2.default.createElement('img', { src: '/img/icons/share.png', alt: '', style: { cursor: "pointer" } }),
												_react2.default.createElement(
													'h4',
													null,
													'Share'
												),
												' '
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'share_wrapper', style: { display: displaySts }, id: 'sharediv' },
											_react2.default.createElement(
												FacebookShareButton,
												{ url: lang.fb.fbURL, title: lang.fb.fbTitile,
													description: lang.fb.fbDesc, picture: lang.fb.fbImage },
												_react2.default.createElement(FacebookIcon, { size: 32 })
											),
											_react2.default.createElement(
												TwitterShareButton,
												{ url: lang.tw.twURL, title: lang.tw.twTitile,
													via: lang.tw.twvia },
												_react2.default.createElement(TwitterIcon, { size: 32 })
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-lg-12 myAccountForm' },
									_react2.default.createElement('div', { id: 'form-msg' }),
									_react2.default.createElement(
										'h1',
										null,
										'ACCOUNT INFORMATION'
									),
									_react2.default.createElement(
										'div',
										{ className: 'Form-holder', id: 'myaccount-form' },
										_react2.default.createElement(
											'div',
											{ className: 'form-group-input form-group label-floating card-no' },
											_react2.default.createElement(
												'div',
												{ className: 'input-group' },
												_react2.default.createElement(
													'label',
													{ className: 'control-label' },
													'First Name'
												),
												_react2.default.createElement('input', Object.assign({ type: 'text', className: 'form-control', value: fields.firstname || '' }, $field('firstname', function (e) {
													return onChange('firstname', e.target.value);
												}))),
												errMsgFirstname
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'form-group-input form-group label-floating card-no' },
											_react2.default.createElement(
												'div',
												{ className: 'input-group' },
												_react2.default.createElement(
													'label',
													{ className: 'control-label' },
													'Last Name'
												),
												_react2.default.createElement('input', Object.assign({ type: 'text', className: 'form-control', value: fields.lastname || '' }, $field('lastname', function (e) {
													return onChange('lastname', e.target.value);
												}))),
												errMsgLastname
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'form-group-input form-group label-floating card-no' },
											_react2.default.createElement(
												'div',
												{ className: 'input-group' },
												_react2.default.createElement(
													'label',
													{ className: 'control-label' },
													'Email Address'
												),
												_react2.default.createElement('input', Object.assign({ type: 'text', className: 'form-control', value: fields.email || '' }, $field('email', function (e) {
													return onChange('email', e.target.value);
												}), opts, { disabled: 'true' })),
												errMsgEmail
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'form-group-input form-group label-floating card-no' },
											_react2.default.createElement(
												'div',
												{ className: 'input-group' },
												_react2.default.createElement(
													'label',
													{ className: 'control-label' },
													'Mobile Number'
												),
												_react2.default.createElement('input', Object.assign({ type: 'text', className: 'form-control', value: fields.mobile || '' }, $field('mobile', function (e) {
													return onChange('mobile', e.target.value);
												}))),
												errMsgMobile
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'form-group-input form-group label-floating card-no' },
											_react2.default.createElement(
												'div',
												{ className: 'input-group birthdate' },
												this.loaddaofbirth(),
												_react2.default.createElement('div', { id: 'spn-birthday-error', style: { clear: 'both' } })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'form-group label-floating card-no gender' },
											_react2.default.createElement(
												'div',
												{ className: 'input-group' },
												_react2.default.createElement(
													'label',
													{ className: 'control-label' },
													'Gender'
												),
												_react2.default.createElement(
													'select',
													{ className: 'form-control select-gender' },
													_react2.default.createElement(
														'option',
														{ value: 'M', id: 'male' },
														'Male'
													),
													_react2.default.createElement(
														'option',
														{ value: 'F', id: 'female' },
														'Female'
													)
												)
											)
										),
										_react2.default.createElement('div', { className: 'clearfix' }),
										_react2.default.createElement(
											'div',
											{ className: 'form-group-input form-group label-floating card-no', style: { height: "0px", margin: "0px", visibility: "hidden" } },
											_react2.default.createElement(
												'div',
												{ className: 'input-group' },
												_react2.default.createElement(
													'label',
													{ className: 'control-label' },
													'Postal Code'
												),
												_react2.default.createElement('input', Object.assign({ id: 'postal-code', type: 'text', className: 'form-control', value: fields.postal || '' }, $field('postal', function (e) {
													return onChange('postal', e.target.value);
												}))),
												_react2.default.createElement(
													'div',
													{ id: 'spn-postal-error' },
													errMsgPostal
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'form-group-input form-group label-floating card-no form-addressfield', style: { height: "0px", margin: "0px", visibility: "hidden" } },
											_react2.default.createElement(
												'div',
												{ className: 'input-group' },
												_react2.default.createElement(
													'label',
													{ className: 'control-label' },
													'Address'
												),
												_react2.default.createElement('input', Object.assign({ id: 'postal-address', type: 'text', className: 'form-control' }, opts, { disabled: 'true' })),
												_react2.default.createElement('div', { id: 'spn-address-error' })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'form-group-input form-group label-floating card-no col-xs-6', style: { height: "0px", margin: "0px", visibility: "hidden" } },
											_react2.default.createElement(
												'div',
												{ className: 'input-group' },
												_react2.default.createElement(
													'label',
													{ className: 'control-label' },
													'Unit Number 1'
												),
												_react2.default.createElement('input', Object.assign({ type: 'text', className: 'form-control', value: fields.unitnumber1 || '' }, $field('unitnumber1', function (e) {
													return onChange('unitnumber1', e.target.value);
												}))),
												_react2.default.createElement('div', { id: 'spn-unitno1-error' })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'form-group-input form-group label-floating card-no col-xs-6 unitno', style: { height: "0px", margin: "0px", visibility: "hidden" } },
											_react2.default.createElement(
												'div',
												{ className: 'input-group' },
												_react2.default.createElement(
													'label',
													{ className: 'control-label' },
													'Unit Number 2'
												),
												_react2.default.createElement('input', Object.assign({ type: 'text', className: 'form-control', value: fields.unitnumber2 || '' }, $field('unitnumber2', function (e) {
													return onChange('unitnumber2', e.target.value);
												}))),
												_react2.default.createElement('div', { id: 'spn-unitno2-error' })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'form-group-input form-group label-floating card-no mt80', style: { marginTop: "20px" } },
											_react2.default.createElement(
												'div',
												{ className: 'input-group' },
												_react2.default.createElement(
													'label',
													{ className: 'control-label' },
													'Company Name'
												),
												_react2.default.createElement('input', Object.assign({ type: 'text', className: 'form-control', value: fields.company || '' }, $field('company', function (e) {
													return onChange('company', e.target.value);
												})))
											)
										),
										_react2.default.createElement('div', { className: 'space-20' }),
										_react2.default.createElement(
											'div',
											{ className: 'text-center ' },
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'btn btn-raised btn-info full-width-btn text-uppercase color-green', onClick: function onClick(e) {
														e.preventDefault();_this10.props.$submit(onValid, onInvalid);
													} },
												'update profile',
												_react2.default.createElement('div', { className: 'ripple-container' })
											),
											_react2.default.createElement('br', null)
										),
										_react2.default.createElement(
											'div',
											{ className: 'text-left row', id: 'default-address' },
											_react2.default.createElement(
												'div',
												{ className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
												PreviousOrderAddressTitle,
												this.loadSecAddr(this.state.secAddrData)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'row disabled-continue-as-a-guest' },
											_react2.default.createElement(
												'div',
												{ className: 'col-lg-12 text-center' },
												_react2.default.createElement(
													'button',
													{ type: 'button', id: 'checkout', onClick: function onClick() {
															_this10.openNewAddress();
														}, className: 'btn btn-raised btn-info full-width-btn text-uppercase disable-btn focusgrey' },
													'Add new Address'
												),
												_react2.default.createElement('br', null)
											),
											_react2.default.createElement('div', { className: 'space-50 hide-on-click' })
										),
										_react2.default.createElement('input', { type: 'hidden', id: 'address_id' }),
										_react2.default.createElement(
											'div',
											{ className: 'new-user-reg' },
											_react2.default.createElement(
												'div',
												{ className: 'form-group label-floating card-no address-form-group' },
												_react2.default.createElement(
													'div',
													{ className: 'input-group' },
													_react2.default.createElement(
														'label',
														{ className: 'control-label' },
														'Postal Code'
													),
													_react2.default.createElement('input', { type: 'text', id: 'customer_postal_code', className: 'form-control', onChange: function onChange() {
															_this10.loadPostalAddress();
														} }),
													_react2.default.createElement('div', { id: 'spn-postalcode-error' })
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'form-group label-floating card-no address-form-group' },
												_react2.default.createElement(
													'div',
													{ className: 'input-group' },
													_react2.default.createElement(
														'label',
														{ className: 'control-label' },
														'Address1'
													),
													_react2.default.createElement('input', { type: 'text', id: 'customer_address_line1', className: 'form-control' }),
													_react2.default.createElement('div', { id: 'spn-addr-error' })
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'form-group label-floating card-no col-xs-6 address-form-group' },
												_react2.default.createElement(
													'div',
													{ className: 'input-group' },
													_react2.default.createElement(
														'label',
														{ className: 'control-label' },
														' Floor No'
													),
													_react2.default.createElement('input', { type: 'text', id: 'customer_address_name', className: 'form-control' }),
													_react2.default.createElement('div', { id: 'spn-unit1-error' })
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'form-group label-floating card-no col-xs-6 unitno address-form-group' },
												_react2.default.createElement(
													'div',
													{ className: 'input-group' },
													_react2.default.createElement(
														'label',
														{ className: 'control-label' },
														'Unit No'
													),
													_react2.default.createElement('input', { type: 'text', id: 'customer_address_name2', className: 'form-control' }),
													_react2.default.createElement('div', { id: 'spn-unit2-error' })
												)
											),
											_react2.default.createElement('div', { className: 'space-20', id: 'form-msg1' }),
											_react2.default.createElement(
												'div',
												{ className: 'text-center' },
												_react2.default.createElement(
													'button',
													{ type: 'button', onClick: this.saveNewAddress.bind(this), className: 'btn btn-raised btn-info full-width-btn text-uppercase' },
													'save',
													_react2.default.createElement('div', { className: 'ripple-container' })
												),
												_react2.default.createElement('br', null)
											),
											_react2.default.createElement('div', { className: 'space-50' }),
											_react2.default.createElement('div', { className: 'space-10' })
										)
									)
								)
							)
						)
					);
				}
			}
		}]);
	
		return Form;
	}(_react2.default.Component);
	
	Form = (0, _reactCustomValidation.validated)(validationConfig)(Form);
	
	exports.default = Myaccount;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* 404 page */
	var NotFound = function NotFound() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      '404 page not found'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'We are sorry but the page you are looking for does not exist.'
	    )
	  );
	};
	
	exports.default = NotFound;

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactMoment = __webpack_require__(99);
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var config = __webpack_require__(7);
	var lang = __webpack_require__(12);
	var Loading = __webpack_require__(17);
	//const APIURL = config.path.apiUrl;
	var APIURLPRO = config.path.apiUrlPro;
	var APPID = config.ids.appId;
	var currency = config.ids.currency;
	var helper = __webpack_require__(13);
	var strp = __webpack_require__(31);
	var HtmlToReactParser = __webpack_require__(21).Parser;
	var htmlToReactParserTo = new HtmlToReactParser();
	/* Load meta tags */
	var meta = {
		title: lang.orders_meta_title,
		description: lang.orders_meta_title,
		meta: {
			name: {
				keywords: lang.orders_meta_title
			}
		}
	};
	
	var Orders = function (_React$Component) {
		_inherits(Orders, _React$Component);
	
		function Orders(props) {
			_classCallCheck(this, Orders);
	
			var _this = _possibleConstructorReturn(this, (Orders.__proto__ || Object.getPrototypeOf(Orders)).call(this, props));
	
			_this.state = { orders: [], status: "Loading", pastorders: [], orderscount: 0, pastorderscount: 0, windowHeightNormal: 0, windowHeight: 0 };
			/* check Authentication */
			if ((0, _Api2.default)('Auth') === false) {
				_reactRouter.hashHistory.push("/sign-in");
			}
	
			/*add class */
			helper.addBodyClass();
			helper.isAnonymousUserRedirect();
			_this.isTempUserRedirect();
			return _this;
		}
	
		_createClass(Orders, [{
			key: 'isTempUserRedirect',
			value: function isTempUserRedirect() {
				var isTempUser = parseInt(_reactCookie2.default.load("isTempUser"));
				console.log('isTempUser', isTempUser);
				if (isTempUser === 1) {
					_reactCookie2.default.remove("UserId");
					_reactCookie2.default.remove("UserFname");
					_reactCookie2.default.remove("UserLname");
					_reactCookie2.default.remove("UserMobile");
					_reactCookie2.default.remove("UserEmail");
					_reactCookie2.default.remove("userAccountType");
					_reactCookie2.default.remove("isAnonymousUser");
					this.setState({ login: 'No' });
					setTimeout(function () {
						_reactCookie2.default.remove("isTempUser");
					}, 240000);
	
					_reactRouter.hashHistory.push("/sign-in");
					helper.showInfo("YOU ARE TRYING TO ACCESS PRIVILAGED INFO , PLEASE USE YOUR PHONE NUMBER AND ATTACHED EMAIL TO ACCESS THIS PAGE.");
				}
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.setState({ status: "Loading" });
				/* API CALL FOR CUSTOMER DETAIL cookie.load('UserId')*/
				this.showAllOrders();
				var windowHeight = window.innerHeight;
				this.setState({ 'windowHeight': windowHeight - 45 + 'px' });
				this.setState({ 'windowHeightNormal': windowHeight + 'px' });
				_reactCookie2.default.remove('gstInclusive');
			}
	
			/* show all orders */
	
		}, {
			key: 'showAllOrders',
			value: function showAllOrders() {
				var _this2 = this;
	
				_axios2.default.get(APIURLPRO + 'reports/order_history?order_status=C&app_id=' + APPID + "&customer_id=" + _reactCookie2.default.load('UserId')).then(function (res) {
					if (res.data.status === "ok") {
						_this2.setState({ orders: res.data.result_set, orderscount: 1 });
						_this2.setState({ status: "ok" });
					} else {
						_this2.setState({ orderscount: 1 });
						_this2.setState({ status: "ok" });
					}
				});
	
				_axios2.default.get(APIURLPRO + 'reports/order_history?order_status=P&app_id=' + APPID + "&customer_id=" + _reactCookie2.default.load('UserId')).then(function (res) {
					setTimeout(function () {
						this.showAllOrders();
					}.bind(_this2), 10000);
					if (res.data.status === "ok") {
						_this2.setState({ pastorders: res.data.result_set, pastorderscount: 1 });
					} else {
						_this2.setState({ pastorderscount: 1 });
					}
				});
			}
	
			/* show tower information */
	
		}, {
			key: 'showTowerInfo',
			value: function showTowerInfo(data) {
				if (data !== null && data !== "") {
	
					//return htmlToReactParserTo.parse("Building Name/ Tower : "+data+" <br/>");
	
					var str = "Building Name/ Tower : " + data + " <br/>";
					var reactElement = htmlToReactParserTo.parse(str);
					return reactElement;
				}
			}
	
			/* show Outlet information */
	
		}, {
			key: 'getAddressInfo',
			value: function getAddressInfo(address1, postlCd, unitOne, unitTwo) {
				var unit = unitTwo !== "" && unitOne !== "" ? "#" + unitOne + "-" + unitTwo + ", " : unitOne !== '' ? "#" + unitOne + ", " : "";
				var addressLineTxt = address1 + ", " + unit + "Singapore " + postlCd;
				return addressLineTxt;
			}
		}, {
			key: 'loadOrderTime',
			value: function loadOrderTime(order) {
				if (order.order_date !== null) {
					var orderDateTime = order.order_date.split(" ");
					var orderDate = orderDateTime[0].split('-');
					var orderTime = orderDateTime[1].split(':');
					if (order.FormatedFrom !== null && order.FormatedTo !== null) {
						return _react2.default.createElement(
							'div',
							null,
							orderDate[2] + '/' + orderDate[1] + '/' + orderDate[0] + ' ' + order.FormatedFrom + '-' + order.FormatedTo
						);
					} else {
						return _react2.default.createElement(
							'div',
							null,
							orderDate[2] + '/' + orderDate[1] + '/' + orderDate[0] + ' ' + orderTime[0] + ':' + orderTime[1]
						);
					}
				}
			}
		}, {
			key: '__ordersList',
			value: function __ordersList(orders, paramStr, pmCount) {
				if (pmCount !== 0) {
					if (orders.length === 0) {
						return _react2.default.createElement(
							'div',
							{ className: 'col-lg-12 calender-area' },
							_react2.default.createElement(
								'div',
								{ className: 'col-xs-12 calender-area-sub-2' },
								_react2.default.createElement(
									'h1',
									{ className: 'sub-heading', style: { textAlign: 'center' } },
									'No Order found.'
								)
							),
							_react2.default.createElement('div', { className: 'space-30' })
						);
					} else {
						var htmlStr = orders.map(function (order, index) {
	
							return _react2.default.createElement(
								'div',
								{ key: index },
								_react2.default.createElement(
									'div',
									{ className: index === 0 ? 'topp' : 'order-b' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-12 padd1 main-outer2 bg-white' },
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-12 price-list' },
											_react2.default.createElement(
												'div',
												{ className: 'row' },
												_react2.default.createElement(
													'div',
													{ className: 'col-sm-3 ' },
													_react2.default.createElement(
														_reactRouter.Link,
														{ className: 'btn btn-raised my2-btn btn-success' },
														order.order_availability_name
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'col-sm-7' },
													_react2.default.createElement(
														'p',
														{ className: 'order-date' },
														' ',
														this.loadOrderTime(order),
														' '
													),
													order.order_availability_name === "Dine In" && order.order_table_number !== '' && order.order_table_number !== null && _react2.default.createElement(
														'p',
														null,
														_react2.default.createElement(
															'b',
															null,
															'Table Number:'
														),
														' ',
														order.order_table_number
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'col-sm-2' },
													_react2.default.createElement(
														'p',
														{ className: 'order-date' },
														_react2.default.createElement(
															_reactRouter.Link,
															{ to: "/", style: { color: '#8f8e8e' } },
															'VIEW MENU'
														)
													)
												),
												_react2.default.createElement('div', { className: 'clearfix' }),
												_react2.default.createElement(
													'div',
													{ className: 'col-xs-12' },
													_react2.default.createElement('hr', null)
												)
											),
											_react2.default.createElement(
												'p',
												{ className: 'text-left span-txt1' },
												_react2.default.createElement(
													'b',
													null,
													'Order No - ',
													order.order_local_no
												),
												' '
											),
											_react2.default.createElement(
												'p',
												{ className: 'text-left span-txt1' },
												_react2.default.createElement(
													'b',
													null,
													order.outlet_name
												),
												' '
											),
											order.order_availability_name === "Pickup" && _react2.default.createElement(
												'p',
												{ className: 'text-left span-txt1' },
												function () {
													if (order.outlet_unit_number1 !== "" && order.outlet_unit_number2 !== "") {
														return "#" + order.outlet_unit_number1 + "-" + order.outlet_unit_number2;
													} else if (order.outlet_unit_number1 !== "" || order.outlet_unit_number2 !== "") {
														return order.outlet_unit_number1 !== "" ? "#" + order.outlet_unit_number1 : "#" + order.outlet_unit_number2;
													} else {
														return "";
													}
												}(),
												", " + order.outlet_address_line1 + ', Singapore ' + order.outlet_postal_code
											),
											this.__orderItemsList(order.items),
											_react2.default.createElement('div', { className: 'clearfix' }),
											_react2.default.createElement('hr', null),
											_react2.default.createElement(
												'p',
												{ className: 'text-left span-txt1' },
												_react2.default.createElement(
													'b',
													null,
													'Total : ',
													currency,
													order.order_total_amount
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'tab my_tab' },
												_react2.default.createElement(
													'div',
													{ className: 'my_tab_left' },
													_react2.default.createElement(
														_reactRouter.Link,
														{ to: "/", 'data-toggle': 'modal', 'data-target': "#" + paramStr + "DeliverySucess" + index },
														_react2.default.createElement(
															'p',
															{ className: 'order-date' },
															'VIEW RECEIPT'
														)
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'tabs my_tab_right' },
													order.order_status === '5' ? _react2.default.createElement(
														'div',
														{ className: 'btn-group btn-group-justified btn-group-raised tab-group ' },
														_react2.default.createElement(
															_reactRouter.Link,
															{ className: 'btn', style: { float: 'right', color: 'red' } },
															' Cancelled '
														)
													) : _react2.default.createElement(
														'div',
														{ className: 'btn-group btn-group-justified btn-group-raised tab-group ' },
														order.order_status === '1' || order.order_status === '2' || order.order_status === '3' || order.order_status === '4' ? _react2.default.createElement(
															_reactRouter.Link,
															{ className: 'btn' },
															_react2.default.createElement('img', { alt: '', className: 'number-icon', src: '/img/icons/1.png' }),
															' Received '
														) : _react2.default.createElement(
															_reactRouter.Link,
															{ className: 'btn disabled', disabled: 'true' },
															_react2.default.createElement('img', { className: 'number-icon', src: '/img/icons/1.png', alt: '' }),
															' Received '
														),
														order.order_status === '2' || order.order_status === '3' || order.order_status === '4' ? _react2.default.createElement(
															_reactRouter.Link,
															{ className: 'btn' },
															_react2.default.createElement('img', { alt: '', className: 'number-icon', src: '/img/icons/2.png' }),
															' Preparing '
														) : _react2.default.createElement(
															_reactRouter.Link,
															{ className: 'btn disabled', disabled: 'true' },
															_react2.default.createElement('img', { alt: '', className: 'number-icon', src: '/img/icons/2.png' }),
															' Preparing '
														),
														order.order_status === '2' || order.order_status === '4' ? _react2.default.createElement(
															_reactRouter.Link,
															{ className: 'btn' },
															_react2.default.createElement('img', { className: 'number-icon', alt: '', src: '/img/icons/3.png' }),
															' ',
															order.order_availability_name === 'Dine In' ? 'Ready To Eat' : '',
															order.order_availability_name === 'Delivery' ? 'Delivering' : '',
															order.order_availability_name === 'Pickup' ? 'Ready to Pickup' : '',
															' '
														) : _react2.default.createElement(
															_reactRouter.Link,
															{ className: 'btn disabled', disabled: 'true' },
															_react2.default.createElement('img', { className: 'number-icon', alt: '', src: '/img/icons/3.png' }),
															' ',
															order.order_availability_name === 'Dine In' ? 'Ready To Eat' : '',
															order.order_availability_name === 'Delivery' ? 'Delivering' : '',
															order.order_availability_name === 'Pickup' ? 'Ready to Pickup' : ''
														),
														order.order_status === '4' ? _react2.default.createElement(
															_reactRouter.Link,
															{ className: 'btn' },
															_react2.default.createElement('img', { alt: '', className: 'number-icon', src: '/img/icons/4.png' }),
															' Completed '
														) : _react2.default.createElement(
															_reactRouter.Link,
															{ className: 'btn disabled', disabled: 'true' },
															_react2.default.createElement('img', { className: 'number-icon', alt: '', src: '/img/icons/4.png' }),
															' Completed '
														)
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal', id: paramStr + "DeliverySucess222" + index },
										_react2.default.createElement(
											'div',
											{ className: 'modal-dialog PopupWidth2 popup_tax_wrapper' },
											_react2.default.createElement(
												'div',
												{ className: 'modal-content ' },
												_react2.default.createElement(
													'div',
													{ className: 'modal-header' },
													_react2.default.createElement(
														'button',
														{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
														_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
													),
													_react2.default.createElement(
														'div',
														{ className: 'top_tax' },
														_react2.default.createElement(
															'div',
															{ className: 'row' },
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-6' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1 text-left pop_text_big' },
																	'Tax Invoice'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-6 custom_invoice_div' },
																_react2.default.createElement('img', { src: '/img/salad.jpg' })
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'row' },
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-6' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1 text-left pop_text_md' },
																	'Order No - ',
																	order.order_local_no
																),
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1 text-left  pop_text_sm' },
																	'Order made at - ',
																	_react2.default.createElement(
																		_reactMoment2.default,
																		{ format: 'DD/MM/YYYY,  HH:mm' },
																		order.order_created_on
																	),
																	'  '
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-6 custom_invoice_div' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1 pop_text_sm' },
																	'www.saladbox.com'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-12' },
																'  ',
																_react2.default.createElement('hr', null)
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'row' },
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-6' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1 text-left pop_text_md ' },
																	'Deliver To'
																),
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1 text-left pop_text_sm ' },
																	order.order_customer_fname + " " + order.order_customer_lname,
																	' (Tel :',
																	order.order_customer_mobile_no,
																	')'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-6 custom_invoice_div' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1 pop_text_md' },
																	'Outlet'
																),
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1 pop_text_sm' },
																	order.outlet_name,
																	'  '
																)
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'row btm-15' },
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-6' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1 text-left  pop_text_md' },
																	'Deliver On'
																),
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1 text-left pop_text_sm ' },
																	_react2.default.createElement(
																		_reactMoment2.default,
																		{ format: 'DD/MM/YYYY,  HH:mm' },
																		order.order_date
																	)
																),
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1 text-left  pop_text_sm' },
																	order.order_customer_address_line1
																),
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1 text-left  pop_text_sm' },
																	'Singapore ',
																	order.order_customer_postal_code
																)
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'row' },
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-6' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1 text-left pop_text_sm' },
																	_react2.default.createElement(
																		'span',
																		{ className: 'pop_text_md' },
																		'TAT '
																	),
																	': ',
																	order.order_tat_time,
																	' Mins'
																)
															)
														)
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'modal-body text-center' },
													_react2.default.createElement(
														'div',
														{ className: 'wrap-order-details' },
														_react2.default.createElement(
															'div',
															{ className: 'center-block' },
															_react2.default.createElement(
																'h4',
																{ className: 'modal-title ' },
																' Order Details'
															),
															_react2.default.createElement('hr', null),
															_react2.default.createElement('div', { className: 'clearfix' })
														),
														_react2.default.createElement(
															'div',
															{ className: 'row' },
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-8' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1 text-left ' },
																	'1 ',
																	_react2.default.createElement(
																		'small',
																		null,
																		'x'
																	),
																	' \xA0 Signature Rainbow Shrimp'
																),
																_react2.default.createElement(
																	'p',
																	{ className: 'span-size text-left  ' },
																	'LARGE'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-4' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1' },
																	'$23.00'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-8' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1 text-left  ' },
																	'1 ',
																	_react2.default.createElement(
																		'small',
																		null,
																		'x'
																	),
																	' \xA0 Potato Salad '
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-4' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1' },
																	'$10.00'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-8  ' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1 text-left' },
																	'1 ',
																	_react2.default.createElement(
																		'small',
																		null,
																		'x'
																	),
																	' \xA0 Aglio Olio'
																),
																_react2.default.createElement(
																	'p',
																	{ className: 'span-size text-left ' },
																	'REGULAR'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-4' },
																_react2.default.createElement(
																	'span',
																	{ className: 'span-txt1 ' },
																	'$7.00'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-12' },
																'  ',
																_react2.default.createElement('hr', null)
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'row' },
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-8' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1 text-left  ' },
																	'Subtotal '
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-4' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1' },
																	'$39.00'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-8  ' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1 text-left' },
																	'Delivery Charge'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-4' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1' },
																	'$10.00'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-8  ' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1 text-left' },
																	'GST(7.00%)'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-4' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1' },
																	'$2.90'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-12' },
																'  ',
																_react2.default.createElement('hr', null)
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'row' },
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-8 ' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-tot text-left' },
																	'Grand Total'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-4' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-tot' },
																	'$79.00'
																)
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'modal-footer btm_tax' },
														_react2.default.createElement(
															'div',
															{ className: 'row' },
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-6' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1 text-left  pop_text_sm' },
																	_react2.default.createElement(
																		'span',
																		{ className: 'pop_text_md' },
																		'Rider '
																	),
																	':  Test Rider /4325435453'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-6 custom_invoice_div' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-txt1 pop_text_sm' },
																	'Paid by online payment'
																)
															)
														)
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal', id: paramStr + "DeliverySucess" + index },
										_react2.default.createElement(
											'div',
											{ className: 'modal-dialog PopupWidth2' },
											_react2.default.createElement(
												'div',
												{ className: 'modal-content ' },
												_react2.default.createElement(
													'div',
													{ className: 'modal-header' },
													_react2.default.createElement(
														'button',
														{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
														_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
													),
													_react2.default.createElement(
														'div',
														{ className: 'center-block' },
														_react2.default.createElement(
															'h4',
															{ className: 'modal-title' },
															' Order Receipt'
														),
														_react2.default.createElement(
															'p',
															{ className: 'span-size' },
															'Order No - ',
															order.order_local_no
														),
														_react2.default.createElement('hr', { width: '80%' }),
														_react2.default.createElement('div', { className: 'clearfix' })
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'modal-body text-center' },
													_react2.default.createElement(
														'div',
														null,
														_react2.default.createElement(
															'div',
															{ className: 'order-r' },
															_react2.default.createElement(
																'p',
																{ className: 'span-txt1' },
																order.outlet_name
															),
															order.outlet_receipt_information !== "" && _react2.default.createElement(
																'p',
																{ className: 'span-txt1', style: { textAlign: "justify" } },
																htmlToReactParserTo.parse(order.outlet_receipt_information)
															),
															_react2.default.createElement(
																'span',
																{ className: 'span-size2' },
																order.order_availability_name,
																' - ',
																_react2.default.createElement(
																	_reactMoment2.default,
																	{ format: 'DD/MM/YYYY HH:mm' },
																	order.order_date
																),
																_react2.default.createElement('br', null),
																this.showTowerInfo(order.order_customer_tower_number),
																/*(order.order_availability_name==='Delivery'?helper.addressFormat(order.order_customer_unit_no1,order.order_customer_unit_no2,order.order_customer_address_line1,order.order_customer_address_line2,order.order_customer_postal_code):'')*/
																order.order_availability_name === 'Delivery' ? this.getAddressInfo(order.order_customer_address_line1, order.order_customer_postal_code, order.order_customer_unit_no1, order.order_customer_unit_no2) : '',
																order.order_availability_name === 'Dine In' ? order.order_table_number : '',
																order.order_availability_name === 'Pickup' ? this.getAddressInfo(order.outlet_address_line1, order.outlet_postal_code, order.outlet_unit_number1, order.outlet_unit_number2) : ''
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'row' },
															this.__ordersubItemsList(order.items),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-12' },
																_react2.default.createElement('hr', null)
															),
															this.__showServiceAmount(order),
															order.order_availability_name === 'Delivery' ? this.__showDeliveryCharge(order.order_delivery_charge) : '',
															order.order_availability_name === 'Delivery' ? this.__showAdditionalDeliveryCharge(order.order_additional_delivery) : '',
															this.__showSurchargeAmount(order.order_subcharge_amount),
															this.__showDiscountAmt(order.order_discount_amount),
															this.__showGSTAmount(order.order_tax_charge, order.order_tax_calculate_amount),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-8 ' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-tot text-left' },
																	'Total'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-4' },
																_react2.default.createElement(
																	'p',
																	{ className: 'span-tot' },
																	currency,
																	order.order_total_amount
																)
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'modal-footer' },
															_react2.default.createElement('br', null),
															_react2.default.createElement('br', null)
														)
													)
												)
											)
										)
									),
									'   '
								),
								_react2.default.createElement('div', { className: 'clearfix' })
							);
						}.bind(this));
						return htmlStr;
					}
				}
			}
		}, {
			key: '__showDeliveryCharge',
			value: function __showDeliveryCharge(delivery_charge) {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'col-xs-8 ' },
						_react2.default.createElement(
							'p',
							{ className: 'span-tot text-left' },
							'Delivery'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-xs-4' },
						_react2.default.createElement(
							'p',
							{ className: 'span-tot' },
							currency,
							delivery_charge
						)
					)
				);
			}
		}, {
			key: '__showAdditionalDeliveryCharge',
			value: function __showAdditionalDeliveryCharge(Additnldelivery_charge) {
				if (parseFloat(Additnldelivery_charge) > 0) {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'col-xs-8 ' },
							_react2.default.createElement(
								'p',
								{ className: 'span-tot text-left' },
								'Additional Surcharge'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-xs-4' },
							_react2.default.createElement(
								'p',
								{ className: 'span-tot' },
								currency,
								Additnldelivery_charge
							)
						)
					);
				} else {
					return '';
				}
			}
		}, {
			key: '__showDiscountAmt',
			value: function __showDiscountAmt(DiscountAmt) {
				if (parseFloat(DiscountAmt) > 0) {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'col-xs-8 ' },
							_react2.default.createElement(
								'p',
								{ className: 'span-tot text-left' },
								'Discount Amount'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-xs-4' },
							_react2.default.createElement(
								'p',
								{ className: 'span-tot' },
								currency,
								DiscountAmt
							)
						)
					);
				} else {
					return '';
				}
			}
		}, {
			key: '__showGSTAmount',
			value: function __showGSTAmount(gstPer, gstAmt) {
	
				gstPer = parseFloat(gstPer);
				gstAmt = parseFloat(gstAmt);
	
				if (gstAmt > 0) {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'col-xs-8 ' },
							_react2.default.createElement(
								'p',
								{ className: 'span-tot text-left' },
								'Gst (',
								gstPer,
								'%) '
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-xs-4' },
							_react2.default.createElement(
								'p',
								{ className: 'span-t >ot' },
								currency,
								gstAmt.toFixed(2)
							)
						)
					);
				} else {
					return '';
				}
			}
		}, {
			key: '__showSurchargeAmount',
			value: function __showSurchargeAmount(surchargePer) {
				surchargePer = parseFloat(surchargePer);
				if (surchargePer > 0) {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'col-xs-8 ' },
							_react2.default.createElement(
								'p',
								{ className: 'span-tot text-left' },
								'Surcharge'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-xs-4' },
							_react2.default.createElement(
								'p',
								{ className: 'span-t >ot' },
								currency,
								surchargePer.toFixed(2)
							)
						)
					);
				} else {
					return '';
				}
			}
		}, {
			key: '__showServiceAmount',
			value: function __showServiceAmount(orderData) {
				var gstPer = orderData.order_service_charge;
				var gstAmt = orderData.order_service_charge_amount;
				gstPer = parseFloat(gstPer);
				gstAmt = parseFloat(gstAmt);
				var ServiceChargeText = orderData.order_servicecharge_displaylabel !== '' && orderData.order_servicecharge_displaylabel !== null ? orderData.order_servicecharge_displaylabel : 'Service Charge';
				if (gstAmt > 0) {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'col-xs-8 ' },
							gstPer > 0 ? _react2.default.createElement(
								'p',
								{ className: 'span-tot text-left' },
								ServiceChargeText,
								' (',
								gstPer,
								'%) '
							) : _react2.default.createElement(
								'p',
								{ className: 'span-tot text-left' },
								ServiceChargeText,
								' '
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-xs-4' },
							_react2.default.createElement(
								'p',
								{ className: 'span-t >ot' },
								currency,
								gstAmt.toFixed(2)
							)
						)
					);
				} else {
					return '';
				}
			}
		}, {
			key: '__orderItemsList',
			value: function __orderItemsList(orderItems) {
				return orderItems.map(function (orderItem, index) {
					return _react2.default.createElement(
						'p',
						{ key: index, className: 'text-left spantxt3' },
						_react2.default.createElement(
							'b',
							null,
							orderItem.item_qty,
							'x '
						),
						strp.stripslashes(orderItem.item_name)
					);
				});
			}
		}, {
			key: '__ordersubItemsList',
			value: function __ordersubItemsList(orderItems) {
				var _this3 = this;
	
				return orderItems.map(function (orderItem, index) {
					return _react2.default.createElement(
						'div',
						{ key: index, className: 'col-xs-12' },
						_react2.default.createElement(
							'div',
							{ className: 'col-xs-8' },
							_react2.default.createElement(
								'p',
								{ className: 'span-txt1 text-left ' },
								orderItem.item_qty,
								' ',
								_react2.default.createElement(
									'small',
									null,
									'x'
								),
								' \xA0 ',
								strp.stripslashes(orderItem.item_name)
							),
							_this3.loadModifierItems(orderItem.modifiers),
							_this3.loadComboItems(orderItem.set_menu_component)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-xs-4' },
							_react2.default.createElement(
								'p',
								{ className: 'span-txt1' },
								currency,
								orderItem.item_total_amount
							)
						)
					);
				});
			}
		}, {
			key: 'loadCartImage',
			value: function loadCartImage() {
				return (0, _Api2.default)('cartImage', 'Yes');
			}
	
			/* this function used to load modifer items */
	
		}, {
			key: 'loadModifierItems',
			value: function loadModifierItems(modifiers) {
				if (typeof modifiers !== "undefined") {
					var modlen = parseInt(modifiers.length);
					var modifiers = modifiers;
					var html = "<ul className='table_list cart_sub_items view-list'   >";
					if (modlen > 0) {
						for (var i = 0, length = modlen; i < length; i++) {
							var modName = modifiers[i]['order_modifier_name'];
							var modval = modifiers[i]['modifiers_values'][0]['order_modifier_name'];
							html += "<li className='sub-item'>" + modName + " : " + modval + "</li> ";
						}
						html += "</ul>";
						var reactElement = htmlToReactParserTo.parse(html);
						return reactElement;
					}
				}
			}
	
			/* this function used to show combo modifieirs list */
	
		}, {
			key: 'showComboModifiers',
			value: function showComboModifiers(modifiers) {
				//console.log(modifiers);
				var lenMod = modifiers.length;
				var html = "<ul className='table_list cart_sub_items combo view-list' style={{textAlign: 'left'}}>";
				if (lenMod > 0) {
					for (var i = 0, length = lenMod; i < length; i++) {
						var modName = modifiers[i]['order_modifier_name'];
						var modval = modifiers[i]['modifiers_values'][0]['order_modifier_name'];
						var modValPrice = modifiers[i]['modifiers_values'][0]['order_modifier_price'];
						var newModValPrice = modValPrice > 0 ? " (+" + modValPrice + ")" : "";
	
						html += "<li className='sub-item'>" + modName + ": " + modval + newModValPrice + "</li> ";
					}
					html += "</ul>";
					return html;
				}
	
				return "";
			}
	
			/* this function used to load modifer items */
	
		}, {
			key: 'loadComboItems',
			value: function loadComboItems(combo) {
				if (typeof combo !== "undefined") {
					var comboLen = parseInt(combo.length);
					var combo = combo;
					var html = "<ul className='table_list cart_sub_items mod view-list' style={{textAlign: 'left'}}>";
					if (comboLen > 0) {
	
						for (var i = 0, length = comboLen; i < length; i++) {
							var comboName = combo[i]['menu_component_name'];
							var comboVal = this.showComboProducts(combo[i]['product_details']);
							html += " <li className='sub-item'><b>" + comboName + " :</b>" + comboVal + " " + this.showComboModifiers(combo[i]['product_details'][0]['modifiers']) + "</li> ";
						}
						html += "</ul>";
						var reactElement = htmlToReactParserTo.parse(html);
						return reactElement;
					}
				}
			}
	
			/* show combo products  list */
	
		}, {
			key: 'showComboProducts',
			value: function showComboProducts(combos) {
				var lenCombo = combos.length;
				var html = " ";
				if (lenCombo > 0) {
					for (var r = 0, lengthCombo = lenCombo; r < lengthCombo; r++) {
	
						var comboPro = combos[r]['menu_product_name'];
						comboPro = comboPro !== '' ? strp.stripslashes(comboPro) : comboPro;
						var comboQty = combos[r]['menu_product_qty'];
						var comboPrice = combos[r]['menu_product_price'];
						var newPrice = comboPrice > 0 ? " (+" + comboPrice + ")" : "";
						html += "<li className='sub-item'>" + comboQty + " X " + comboPro + newPrice + " </li> ";
					}
					return html;
				}
				return "";
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				(0, _withTracker.loadAnalytics)();
			}
		}, {
			key: 'render',
			value: function render() {
	
				if (this.state.status === "Loading") {
	
					return _react2.default.createElement(
						'div',
						{ className: 'container-fluid desktop-container', style: { minHeight: this.state.windowHeightNormal } },
						_react2.default.createElement('div', { className: 'row' }),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement('div', { className: 'space-10 bg-gray' })
						),
						_react2.default.createElement(
							'div',
							{ className: ' ' },
							_react2.default.createElement(
								'div',
								{ className: 'col-xs-10 div-center' },
								_react2.default.createElement('div', { className: 'space-5' }),
								_react2.default.createElement(Loading, null),
								_react2.default.createElement('div', { className: 'space-5' })
							),
							_react2.default.createElement('div', { className: 'clearfix' })
						),
						_react2.default.createElement('div', { className: 'space-30' }),
						_react2.default.createElement('div', { className: 'space-30' }),
						_react2.default.createElement('div', { className: 'space-30' }),
						_react2.default.createElement('div', { className: 'space-30' }),
						_react2.default.createElement('div', { className: 'space-30' }),
						_react2.default.createElement('div', { className: 'space-5' }),
						_react2.default.createElement('div', { className: 'space-5' }),
						_react2.default.createElement('div', { className: 'space-30' }),
						' ',
						_react2.default.createElement('div', { className: 'space-30' }),
						' ',
						_react2.default.createElement('div', { className: 'space-30' }),
						' ',
						_react2.default.createElement('div', { className: 'space-30' })
					);
				} else {
	
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_reactDocumentMeta2.default, meta),
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid desktop-container', style: { minHeight: this.state.windowHeightNormal } },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 top-nav inner-top-nav head-main' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-3 nav-head pd-l-20  head-child' },
										' ',
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: "/my-account" },
											_react2.default.createElement('img', { src: '/img/icons/arrow-right.png', alt: 'left-arrow', className: 'icon-img-small-3' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-6 nav-head   head-child' },
										_react2.default.createElement(
											'h1',
											{ className: 'main-title' },
											'MY ORDERS'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-3 nopadding   head-child' },
										_react2.default.createElement(
											'p',
											{ className: 'b-txt text-right ' },
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: "/cart", className: helper.cartClass() },
												helper.cartCount(),
												'   ',
												_react2.default.createElement('img', { alt: '', src: this.loadCartImage(), className: 'icon-img-small-1' }),
												' '
											)
										)
									)
								)
							),
							_react2.default.createElement('div', { className: 'space-10' }),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'line' },
									_react2.default.createElement(
										'div',
										{ className: 'item-add5' },
										_react2.default.createElement(
											'ul',
											{ className: 'orders-tabs ' },
											_react2.default.createElement(
												'li',
												{ className: 'active' },
												_react2.default.createElement(
													'div',
													{ className: 'col-xs-6 order-m-l' },
													_react2.default.createElement(
														'a',
														{ href: '#current_orders', 'data-toggle': 'tab' },
														_react2.default.createElement(
															'span',
															{ className: 'text-1-b' },
															'CURRENT ORDERS'
														)
													)
												)
											),
											_react2.default.createElement(
												'li',
												null,
												_react2.default.createElement(
													'div',
													{ className: 'col-xs-6 order-m-r' },
													_react2.default.createElement(
														'a',
														{ href: '#past_orders', 'data-toggle': 'tab' },
														_react2.default.createElement(
															'span',
															{ className: 'text-1-b' },
															'PAST ORDERS'
														)
													)
												)
											)
										)
									)
								)
							),
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								'div',
								{ className: 'tab-content clearfix' },
								_react2.default.createElement(
									'div',
									{ className: 'tab-pane active', id: 'current_orders' },
									_react2.default.createElement(
										'div',
										{ className: 'row  map-loc' },
										this.__ordersList(this.state.orders, 'current', this.state.orderscount)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'tab-pane', id: 'past_orders' },
									_react2.default.createElement(
										'div',
										{ className: 'row map-loc' },
										this.__ordersList(this.state.pastorders, 'past', this.state.pastorderscount)
									)
								),
								_react2.default.createElement('div', { className: 'space-50' })
							)
						)
					);
				}
			}
		}]);
	
		return Orders;
	}(_react2.default.Component);
	
	exports.default = Orders;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(9);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _reactMoment = __webpack_require__(99);
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	//import getResult from './Api';
	var config = __webpack_require__(7);
	var lang = __webpack_require__(12);
	//const APIURL = config.path.apiUrl;
	var APIURLPRO = config.path.apiUrlPro;
	var apiUrlNotify = config.path.apiUrlNotify;
	var APPID = config.ids.appId;
	//var strp = require('strp');
	
	var Loading = __webpack_require__(17);
	var currency = config.ids.currency;
	var strp = __webpack_require__(31);
	var helper = __webpack_require__(13);
	var HtmlToReactParser = __webpack_require__(21).Parser;
	var htmlToReactParser = new HtmlToReactParser();
	var apps = __webpack_require__(29);
	/* Load meta tags */
	var meta = {
	  title: lang.ordersuccess_meta_title + lang.site_title_with_separator,
	  description: lang.ordersuccess_meta_title,
	  meta: {
	    name: {
	      keywords: lang.ordersuccess_meta_title
	    }
	  }
	};
	
	var Ordersuccess = function (_React$Component) {
	  _inherits(Ordersuccess, _React$Component);
	
	  function Ordersuccess(props) {
	    _classCallCheck(this, Ordersuccess);
	
	    var _this = _possibleConstructorReturn(this, (Ordersuccess.__proto__ || Object.getPrototypeOf(Ordersuccess)).call(this, props));
	
	    _this.state = { cartData: [], cartItems: [], status: 'Loading', availabilityId: '', windowHeightNormal: 0, windowHeight: 0, placed_order_id: '', order_total_amount: ''
	    };
	
	    /*add class */
	    helper.addBodyClass();
	
	    return _this;
	  }
	
	  _createClass(Ordersuccess, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      (0, _withTracker.loadAnalytics)();
	
	      var windowHeight = window.innerHeight;
	      this.setState({ 'windowHeight': windowHeight - 45 + 'px' });
	      this.setState({ 'windowHeightNormal': windowHeight + 'px' });
	
	      var orderId = this.props.params.orderId;
	      _axios2.default.get(APIURLPRO + 'reports/order_history?app_id=' + APPID + "&local_order_no=" + orderId + "&customer_id=" + _reactCookie2.default.load('UserId')).then(function (res) {
	        if (res.data.status === "ok") {
	          _this2.setState({ status: res.data.status, order_total_amount: res.data.result_set[0].order_total_amount, placed_order_id: orderId });
	
	          _axios2.default.get(APIURLPRO + 'orders_duplicate/remove?app_id=' + APPID + "&order_total_amount=" + res.data.result_set[0].order_total_amount + "&local_order_no=" + orderId + "&customer_id=" + _reactCookie2.default.load('UserId') + "&order_date=" + res.data.result_set[0].order_date).then(function (res) {});
	
	          /*	this.setState({availabilityId: res.data.result_set[0]['order_availability_id']});
	          	 this.setState({subTotal: res.data.result_set[0]['order_sub_total']});
	           this.setState({grandTotal: res.data.result_set[0]['order_total_amount']}); */
	          _this2.setState({ cartItems: res.data.result_set[0]['items'] });
	          _this2.setState({ cartData: res.data.result_set[0] }, function () {
	            this.sendNotification(res.data.result_set[0].order_local_no);
	            (0, _withTracker.fbPixelCustomEvent)('Purchase', { currency: "SGD", value: typeof res.data.result_set[0].order_total_amount !== "undefined" ? res.data.result_set[0].order_total_amount : 0 });
	          });
	        } else {
	          _reactRouter.hashHistory.push("/");
	        }
	      });
	    }
	  }, {
	    key: 'sendNotification',
	    value: function sendNotification() {
	      _axios2.default.get(apiUrlNotify + 'OrderActivityJob/order_notify').then(function (res) {});
	    }
	
	    /* Address Format */
	
	  }, {
	    key: 'addressFormat',
	    value: function addressFormat(unitOne, unitTwo, addressOne, addressTwo, postCode, towerNo) {
	      //alert(towerNo);
	      var towerNumber = towerNo !== null && towerNo !== "" ? towerNo + "/" : "";
	      var unit = unitTwo !== "" && unitOne !== "" ? "#" + towerNumber + unitOne + "-" + unitTwo + "," : unitOne !== '' ? "#" + towerNumber + unitOne + "," : "";
	      /*return unit+addressOne;*/
	      return addressOne + ", " + unit + " Singapore " + postCode;
	    }
	
	    /* Delivery Address */
	
	  }, {
	    key: 'deliveryAddress',
	    value: function deliveryAddress() {
	      if (this.state.cartData.order_availability_id === config.ids.deliveryId) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 padd1 bg-gray name-div padding-b-0' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'span-txt' },
	              'Name  :'
	            ),
	            ' ',
	            this.state.cartData.order_customer_fname + " " + this.state.cartData.order_customer_lname
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'span-txt' },
	              'Delivery Address  :'
	            ),
	            '  ',
	            this.addressFormat(this.state.cartData.order_customer_unit_no1, this.state.cartData.order_customer_unit_no2, this.state.cartData.order_customer_address_line1, this.state.cartData.order_customer_address_line2, this.state.cartData.order_customer_postal_code, this.state.cartData.order_customer_tower_number)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'span-txt' },
	              'Order Handled By  : '
	            ),
	            '  ',
	            this.state.cartData.outlet_name
	          ),
	          this.state.cartData.order_customer_send_gift === "Yes" && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'span-txt' },
	                'Recipient Name  : '
	              ),
	              '  ',
	              this.state.cartData.order_recipient_name
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'span-txt' },
	                'Recipient contact No.  : '
	              ),
	              '  ',
	              this.state.cartData.order_recipient_contact_no
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'span-txt' },
	                'Gift message  : '
	              ),
	              '  ',
	              this.state.cartData.order_gift_message
	            )
	          )
	        );
	      } else if (this.state.cartData.order_availability_id === config.ids.dineinId) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 padd1 bg-gray name-div padding-b-0' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'span-txt' },
	              'Name  :'
	            ),
	            ' ',
	            this.state.cartData.order_customer_fname + " " + this.state.cartData.order_customer_lname
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'span-txt' },
	              'Dine In At  : '
	            ),
	            '  ',
	            this.state.cartData.outlet_name,
	            '  '
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'span-txt' },
	              'Table  : '
	            ),
	            '  ',
	            this.state.cartData.order_table_number,
	            ' '
	          )
	        );
	      } else if (this.state.cartData.order_availability_id === config.ids.pickupId) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 padd1 bg-gray name-div padding-b-0' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'span-txt' },
	              'Name  :'
	            ),
	            ' ',
	            this.state.cartData.order_customer_fname + " " + this.state.cartData.order_customer_lname
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'span-txt', style: { width: '23%', float: 'left' } },
	              'Pickup Location  : '
	            ),
	            '  ',
	            _react2.default.createElement(
	              'span',
	              { style: { width: '77%', float: 'left' } },
	              /*this.state.cartData.outlet_name*/this.outletNameText()
	            ),
	            ' '
	          )
	        );
	      }
	    }
	
	    /* this function used to load modifer items */
	
	  }, {
	    key: 'loadModifierItems',
	    value: function loadModifierItems(itemType, modifiers, combo) {
	      var len = modifiers.length;
	      var comboLen = combo.length;
	      var html = '<div class="cart_extrainfo">';
	
	      if (len > 0) {
	        for (var i = 0, length = len; i < length; i++) {
	          var modName = modifiers[i]["order_modifier_name"];
	          var modval = modifiers[i]["modifiers_values"][0]["order_modifier_name"];
	          html += "<p><b>" + stripslashes(modName) + ":</b></p><p> " + stripslashes(modval) + "</p> ";
	        }
	        html += "</div>";
	        var reactElement = htmlToReactParser.parse(html);
	        return reactElement;
	      } else if (comboLen > 0) {
	        for (var i = 0, length = comboLen; i < length; i++) {
	          var comboName = combo[i]["menu_component_name"];
	          var comboVal = this.showComboProducts(combo[i]["product_details"]);
	
	          html += "<p><b>" + comboName + ":</b></p><p> " + comboVal + " " + this.showComboModifiers(combo[i]["product_details"][0]["modifiers"]) + "</p> ";
	        }
	        html += "</div>";
	        var reactElement = htmlToReactParser.parse(html);
	        return reactElement;
	      }
	    }
	
	    /* this function used to show combo modifieirs list */
	
	  }, {
	    key: 'showComboModifiers',
	    value: function showComboModifiers(modifiers) {
	      var lenMod = modifiers.length;
	      var html = "<div >";
	      if (lenMod > 0) {
	        for (var i = 0, length = lenMod; i < length; i++) {
	          var modName = modifiers[i]["order_modifier_name"];
	          var modval = modifiers[i]["modifiers_values"][0]["order_modifier_name"];
	          var modValPrice = modifiers[i]["modifiers_values"][0]["order_modifier_price"];
	          var newModValPrice = modValPrice > 0 ? " (+" + modValPrice + ")" : "";
	          html += "<p><b>" + modName + ":</b></p><p> " + modval + newModValPrice + "</p> ";
	        }
	        html += "</div>";
	
	        return html;
	      }
	
	      return "";
	    }
	
	    /* show combo products  list */
	
	  }, {
	    key: 'showComboProducts',
	    value: function showComboProducts(combos) {
	      var lenCombo = combos.length;
	      var html = " ";
	      if (lenCombo > 0) {
	        for (var r = 0, lengthCombo = lenCombo; r < lengthCombo; r++) {
	          var comboPro = combos[r]["menu_product_name"];
	          var comboQty = combos[r]["menu_product_qty"];
	          var comboPrice = combos[r]["menu_product_price"];
	          var newPrice = comboPrice > 0 ? " (+" + comboPrice + ")" : "";
	          var comboQtyChk = comboQty !== "" ? parseInt(comboQty) : 0;
	          if (comboQtyChk > 0) {
	            html += "<p>" + comboQty + " X " + comboPro + newPrice + " </p> ";
	          }
	        }
	        return html;
	      }
	      return "";
	    }
	  }, {
	    key: 'loadProductsItems',
	    value: function loadProductsItems() {
	      var _this3 = this;
	
	      return this.state.cartItems.map(function (item, index) {
	        return _react2.default.createElement(
	          'tr',
	          { key: index },
	          _react2.default.createElement(
	            'td',
	            { className: 'main-item tab_pad_bot' },
	            item.item_qty,
	            ' X ',
	            strp.stripslashes(item.item_name),
	            _this3.loadModifierItems("Component", item.modifiers, item.set_menu_component)
	          ),
	          _react2.default.createElement(
	            'td',
	            { className: 'text-right tab_pad_bot' },
	            item.item_total_amount
	          )
	        );
	      });
	    }
	
	    /* show delivery amount */
	
	  }, {
	    key: 'deliveryPrice',
	    value: function deliveryPrice() {
	      if (this.state.cartData.order_availability_id === config.ids.deliveryId) {
	        return _react2.default.createElement(
	          'tr',
	          { className: 'sub-total-tr' },
	          _react2.default.createElement(
	            'td',
	            { className: 'sub-total' },
	            'Delivery'
	          ),
	          _react2.default.createElement(
	            'td',
	            { className: 'sub-total text-right' },
	            this.state.cartData.order_delivery_charge
	          )
	        );
	      }
	    }
	
	    //additionaldeliveryPrice
	
	  }, {
	    key: 'additionaldeliveryPrice',
	    value: function additionaldeliveryPrice() {
	
	      var extraDel = parseFloat(this.state.cartData.order_additional_delivery);
	      if (this.state.cartData.order_availability_id === config.ids.deliveryId && extraDel > 0) {
	        return _react2.default.createElement(
	          'tr',
	          { className: 'sub-total-tr' },
	          _react2.default.createElement(
	            'td',
	            { className: 'sub-total' },
	            'Additional Surcharge'
	          ),
	          _react2.default.createElement(
	            'td',
	            { className: 'sub-total text-right' },
	            extraDel.toFixed(2)
	          )
	        );
	      }
	    }
	  }, {
	    key: 'loadGstContent',
	    value: function loadGstContent() {
	      var gstAmount = parseFloat(this.state.cartData.order_tax_calculate_amount);
	      var gstPercentage = parseFloat(this.state.cartData.order_tax_charge);
	
	      if (gstAmount > 0) {
	        return _react2.default.createElement(
	          'tr',
	          { className: 'sub-total-tr' },
	          _react2.default.createElement(
	            'td',
	            { className: 'sub-total' },
	            'GST (',
	            gstPercentage,
	            '%)'
	          ),
	          _react2.default.createElement(
	            'td',
	            { className: 'sub-total text-right' },
	            gstAmount.toFixed(2)
	          )
	        );
	      }
	    }
	  }, {
	    key: 'showGstInclusive',
	    value: function showGstInclusive() {
	
	      var gstAmount = parseFloat(this.state.cartData.order_tax_calculate_amount);
	      var displayInclusiveGst = _reactCookie2.default.load('gstInclusive');
	
	      if (gstAmount === 0 && displayInclusiveGst != '' && displayInclusiveGst != 'undefined') {
	        return _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            { className: 'text-right', colSpan: 2 },
	            displayInclusiveGst
	          )
	        );
	      }
	    }
	  }, {
	    key: 'loadSurchargeContent',
	    value: function loadSurchargeContent() {
	      var order_subcharge_amount = parseFloat(this.state.cartData.order_subcharge_amount);
	
	      if (order_subcharge_amount > 0) {
	        return _react2.default.createElement(
	          'tr',
	          { className: 'sub-total-tr' },
	          _react2.default.createElement(
	            'td',
	            { className: 'sub-total' },
	            'Surcharge'
	          ),
	          _react2.default.createElement(
	            'td',
	            { className: 'sub-total text-right' },
	            order_subcharge_amount.toFixed(2)
	          )
	        );
	      }
	    }
	  }, {
	    key: 'loadServiceContent',
	    value: function loadServiceContent() {
	      var order_service_charge_amount = parseFloat(this.state.cartData.order_service_charge_amount);
	      var order_service_charge = parseFloat(this.state.cartData.order_service_charge);
	
	      var ServiceChargeText = this.state.cartData.order_servicecharge_displaylabel !== '' && this.state.cartData.order_servicecharge_displaylabel !== null ? this.state.cartData.order_servicecharge_displaylabel : 'Service Charge';
	
	      if (order_service_charge_amount > 0) {
	        return _react2.default.createElement(
	          'tr',
	          { className: 'sub-total-tr' },
	          order_service_charge === 0 ? _react2.default.createElement(
	            'td',
	            { className: 'sub-total' },
	            ServiceChargeText,
	            ' '
	          ) : _react2.default.createElement(
	            'td',
	            { className: 'sub-total' },
	            ServiceChargeText,
	            ' (',
	            order_service_charge,
	            '%)'
	          ),
	          _react2.default.createElement(
	            'td',
	            { className: 'sub-total text-right' },
	            order_service_charge_amount.toFixed(2)
	          )
	        );
	      }
	    }
	
	    /* Show time slot */
	
	  }, {
	    key: 'showTimeSlot',
	    value: function showTimeSlot() {
	      //this.state.cartData.order_date
	      if (this.state.cartData.order_is_timeslot === "Yes") {
	        return _react2.default.createElement(
	          'p',
	          { className: 'date text-right' },
	          this.state.cartData.FormatedFrom + "-" + this.state.cartData.FormatedTo
	        );
	      } else {
	        return _react2.default.createElement(
	          'p',
	          { className: 'date text-right' },
	          moment(this.state.cartData.order_date).format('HH:mm')
	        );
	      }
	    }
	
	    /* Display coupon details */
	
	  }, {
	    key: 'couponApplied',
	    value: function couponApplied(amount, sts) {
	
	      if (sts === "Yes") {
	
	        return _react2.default.createElement(
	          'tr',
	          { className: 'sub-total-tr' },
	          _react2.default.createElement(
	            'td',
	            { className: 'sub-total' },
	            'Discount'
	          ),
	          _react2.default.createElement(
	            'td',
	            { className: 'sub-total text-right' },
	            parseFloat(amount)
	          )
	        );
	      }
	    }
	
	    /*  order text */
	
	  }, {
	    key: 'showDateText',
	    value: function showDateText() {
	      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      var returnText = type == 1 ? "Delivery Date" : "Delivery Time";
	      if (this.state.cartData.order_availability_id === config.ids.pickupId) {
	        returnText = type == 1 ? "Pickup Date" : "Pickup Time";
	      } else if (this.state.cartData.order_availability_id === config.ids.dineinId) {
	        returnText = type == 1 ? "Dine in Date" : "Dine in Time";
	      }
	      return returnText;
	    }
	
	    /* order problem text */
	
	  }, {
	    key: 'showproblemText',
	    value: function showproblemText() {
	      if (apps.workspace === APPID) {
	        return _react2.default.createElement(
	          'p',
	          { className: 'order_success_icon' },
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: '#' },
	            ' ',
	            _react2.default.createElement('i', { className: 'fa fa-facebook-official', 'aria-hidden': 'true' }),
	            ' '
	          ),
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: '#' },
	            ' ',
	            _react2.default.createElement('i', { className: 'fa fa-instagram', 'aria-hidden': 'true' }),
	            ' '
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'p',
	          { className: 'text-center' },
	          'Problem with your order ?',
	          _react2.default.createElement('span', { className: 'grey left_span' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/#/module/contact-us', target: '_top' },
	              'please inform us'
	            )
	          )
	        );
	      }
	    }
	
	    /*show outlet text for workspace */
	
	  }, {
	    key: 'outletNameText',
	    value: function outletNameText() {
	      if (apps.workspace === APPID) {
	        return htmlToReactParser.parse("Workspace Espresso Bar <br/> 12 Marina Boulevard<br/> Marina Bay Financial Centre Tower 3<br/> #01-08 Singapore 018982");
	      } else {
	
	        return _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId ? _reactCookie2.default.load('orderDeliveryAddress') : _reactCookie2.default.load('orderHandled');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      if (this.state.status === "Loading") {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_reactDocumentMeta2.default, meta),
	          _react2.default.createElement(Loading, null)
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'container-fluid desktop-container',
	            style: { minHeight: this.state.windowHeightNormal } },
	          _react2.default.createElement(_reactDocumentMeta2.default, meta),
	          APPID === "87E64237-E8D7-4CB6-ADC0-3E124D858641" && _react2.default.createElement('img', { src: "https://marktamerica.go2cloud.org/aff_l?offer_id=14990" + "&adv_sub=" + this.state.placed_order_id + "&amount=" + this.state.order_total_amount, scrolling: 'no', frameborder: '0', width: '1', height: '1' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 main-title-bar' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: "/" },
	                ' ',
	                _react2.default.createElement('img', { src: '/img/left-arrow.png', className: 'pull-left icon-img-small', alt: 'left-arrow' }),
	                ' '
	              ),
	              _react2.default.createElement(
	                'h3',
	                { className: 'top-title' },
	                'ORDER PLACED SUCCESSFULLY'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement('div', { className: 'space-10  bg-gray' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'white-outer center-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 padd2' },
	                _react2.default.createElement('img', { src: '/img/success-background.jpg', className: 'img-responsive', alt: 'success-background' }),
	                _react2.default.createElement('div', { className: 'thank-you-div' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row ' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 padd2' },
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'inner-title' },
	                  'Your Order Details'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-6 padd1 date-div' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'date-title' },
	                    this.showDateText(1)
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'date' },
	                    moment(this.state.cartData.order_date).format('DD/MM/YYYY')
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-6 padd1 date-div' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'date-title text-right' },
	                    this.showDateText()
	                  ),
	                  this.showTimeSlot()
	                ),
	                this.deliveryAddress(),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 padd1 bg-gray order-div padding-b-0 padding-t-0' },
	                  _react2.default.createElement('hr', null),
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Order No - ',
	                    this.state.cartData.order_local_no
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Order placed at : ',
	                    moment(this.state.cartData.order_created_on).format('DD/MM/YYYY hh:mm')
	                  ),
	                  APPID == "B637EE61-A5A9-4303-ACF7-4A3C055DC845" ? _react2.default.createElement(
	                    'h4',
	                    { style: { fontWeight: "bold" } },
	                    'PLEASE MAKE PAYMENT AT COUNTER'
	                  ) : APPID != "B401FC82-8E39-4076-838A-55192F765004" && _react2.default.createElement(
	                    'p',
	                    null,
	                    'Pay by : ',
	                    this.state.cartData.order_method_name,
	                    '  ',
	                    this.state.cartData.order_payment_mode !== undefined && parseInt(this.state.cartData.order_payment_mode) === 1 && _react2.default.createElement(
	                      'span',
	                      null,
	                      'Please pay cash at cash (for dine-in and takeaway order) or to delivery person (for delivery order).'
	                    )
	                  ),
	                  _react2.default.createElement('hr', null)
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 padd1 bg-gray price-list' },
	                  _react2.default.createElement(
	                    'table',
	                    null,
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.loadProductsItems(),
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement('td', { colSpan: 2 })
	                      ),
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'sub-total-tr' },
	                        _react2.default.createElement(
	                          'td',
	                          { className: 'sub-total' },
	                          'Sub Total'
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          { className: 'sub-total text-right' },
	                          this.state.cartData.order_sub_total
	                        )
	                      ),
	                      this.loadServiceContent(),
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement('td', { colSpan: 2 })
	                      ),
	                      this.deliveryPrice(),
	                      this.additionaldeliveryPrice(),
	                      this.loadSurchargeContent(),
	                      this.couponApplied(this.state.cartData.order_discount_amount, this.state.cartData.order_discount_applied),
	                      this.loadGstContent(),
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement('td', { colSpan: 2 })
	                      ),
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          { className: 'total' },
	                          'Total'
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          { className: 'total text-right' },
	                          currency + this.state.cartData.order_total_amount
	                        )
	                      ),
	                      this.showGstInclusive(),
	                      _react2.default.createElement('br', null)
	                    )
	                  )
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xs-12 padd1 price-list-footer' },
	                  this.showproblemText()
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: 'space-50' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: "/orders" },
	                ' ',
	                _react2.default.createElement(
	                  'button',
	                  { className: 'col-lg-12 continue-but desktop-container container-fluid' },
	                  'GO TO MY ACCOUNT'
	                ),
	                ' '
	              ),
	              '           '
	            )
	          )
	        );
	      }
	    }
	  }]);
	
	  return Ordersuccess;
	}(_react2.default.Component);
	
	exports.default = Ordersuccess;

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _immutabilityHelper = __webpack_require__(56);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _validator = __webpack_require__(88);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactCustomValidation = __webpack_require__(57);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(65);
	
	var _reactTextMask = __webpack_require__(911);
	
	var _reactTextMask2 = _interopRequireDefault(_reactTextMask);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _reactFacebookLogin = __webpack_require__(437);
	
	var _reactFacebookLogin2 = _interopRequireDefault(_reactFacebookLogin);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var Loading = __webpack_require__(17);
	var config = __webpack_require__(7);
	var lang = __webpack_require__(12);
	//import PinInput from "react-pin-input";
	var APIURL = config.path.apiUrl;
	var APPID = config.ids.appId;
	
	var Alert = __webpack_require__(48);
	var helper = __webpack_require__(13);
	var dateFormat = __webpack_require__(42);
	var apps = __webpack_require__(29);
	var MemberAppID = "B401FC82-8E39-4076-838A-55192F765004";
	var MemberAppIDSCC = "6C0280A0-B655-4E0F-A43F-041C189683BA";
	/* Load meta tags   sdsd */
	var meta = {
		title: lang.signin_meta_title,
		description: lang.signin_meta_title,
		meta: {
			name: {
				keywords: lang.signin_meta_title
			}
		}
	};
	
	var Otpsignin = function (_React$Component) {
		_inherits(Otpsignin, _React$Component);
	
		function Otpsignin() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Otpsignin);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Otpsignin.__proto__ || Object.getPrototypeOf(Otpsignin)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
				fields: {
					email: '',
					password: '',
					settings: '',
					invalidMemberID: '',
					accepted_coupons: 0
	
				},
				status: 'Loading'
				/*add class */
				// helper.addBodyClass();
			}, _this.fieldChange = function (field, value) {
				_this.setState((0, _immutabilityHelper2.default)(_this.state, { fields: _defineProperty({}, field, { $set: value }) }));
			}, _this.handleFormSubmit = function () {
				document.getElementById("loadIcon").style.display = "block";
				_this.setStateLoading('Loading');
				var formPayload = _this.state.fields;
				var qs = __webpack_require__(3);
				var postObject = {
					"app_id": APPID,
					"type": "web",
					"login_username": formPayload.email,
					"login_password": formPayload.password
				};
				_axios2.default.post(APIURL + "customer/login", qs.stringify(postObject)).then(function (response) {
					document.getElementById("loadIcon").style.display = "none";
					if (response.data.status === "ok") {
						//alert(response.data.result_set.customer_phone);
						var mobileno = '';
						if (response.data.result_set.customer_phone !== "" || response.data.result_set.customer_phone !== null || typeof response.data.result_set.customer_phone !== "undefined") {
							mobileno = response.data.result_set.customer_phone;
						}
	
						/* set User cookie values - Start */
						_reactCookie2.default.save("UserId", response.data.result_set.customer_id);
						_reactCookie2.default.save("UserFname", response.data.result_set.customer_first_name !== "" ? response.data.result_set.customer_first_name : '');
						_reactCookie2.default.save("UserLname", response.data.result_set.customer_last_name != "" ? response.data.result_set.customer_last_name : '');
						_reactCookie2.default.save("UserMobile", mobileno);
						_reactCookie2.default.save("UserEmail", response.data.result_set.customer_email);
						_reactCookie2.default.save("UserDefaultAddress", response.data.result_set.customer_address_name);
						_reactCookie2.default.save("UserDefaultUnitOne", response.data.result_set.customer_address_line1);
						_reactCookie2.default.save("UserDefaultUnitTwo", response.data.result_set.customer_address_line2);
						_reactCookie2.default.save("UserDefaultPostalCode", response.data.result_set.customer_postal_code);
						/* set User cookie values - End */
	
						/* set redirection */
	
						/* upadte customer info */
						var qs = __webpack_require__(3);
						var postObject = {
							"app_id": APPID,
							"reference_id": (0, _Api2.default)('referenceId'),
							"customer_id": response.data.result_set.customer_id,
							"availability_id": _reactCookie2.default.load('defaultAvilablityId')
						};
	
						_axios2.default.post(APIURL + "cart/update_customer_info", qs.stringify(postObject)).then(function (res) {
							if (res.data.status === "ok" && _reactCookie2.default.load('reserVationClick') !== 'fromhome') {
	
								/* check FB login function */
								_reactCookie2.default.save('cartValue', 'Yes');
								if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId) {
									if (APPID === "287E5552-328E-4DBE-A3CA-E998ACCAC9BD") {
										helper.sarveshTableSetup();
										// this.setStateLoading('ok'); 
									} else {
										_this.setStateLoading('ok');
										if (typeof _reactCookie2.default.load("orderOutletId") !== "undefined" && _reactCookie2.default.load("orderOutletId") !== "" && typeof _reactCookie2.default.load("orderTableNo") !== "undefined" && _reactCookie2.default.load("orderTableNo") !== "") {
											_reactRouter.hashHistory.push("/checkout");
										} else {
											_reactRouter.hashHistory.push("/book-a-table");
										}
									}
								} else {
									_this.setStateLoading('ok');
									document.getElementById("loadIcon").style.display = "none";
									_reactRouter.hashHistory.push("/delivery-date");
								}
							} else {
								if (_reactCookie2.default.load('reserVationClick') === 'fromhome') {
									_reactRouter.hashHistory.push("/");
									_reactCookie2.default.save('reserVationClick', 'fromlogin');
								} else if (_reactCookie2.default.load('dineinClick') === 'yes' && _reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId) {
									if (APPID === "287E5552-328E-4DBE-A3CA-E998ACCAC9BD") {
										helper.sarveshTableSetup();
									} else {
										_this.setStateLoading('ok');
										_reactRouter.hashHistory.push("/book-a-table");
									}
								} else {
									//hashHistory.push("/my-account");
									_reactRouter.hashHistory.push("/");
									_reactCookie2.default.save('cartValue', 'No');
								}
							}
						});
	
						/*  if( cookie.load('cartValue') === "Yes"){  
	     		 if(cookie.load('defaultAvilablityId') === config.ids.dineinId){  console.log(2); 
	     				hashHistory.push("/book-a-table");
	     			   }
	       }else{
	      	hashHistory.push("/#/dashboard");
	       }   */
					} else {
	
						_this.setStateLoading('error');
						document.getElementById("loadIcon").style.display = "none";
						//this.setState({signInError :response.data.message });
						//cookie.save("signInError",response.data.message); 
						//	cookie.save("signInError",response.data.message); 
						helper.showInfo(response.data.message);
	
						//$("#Signin-Error").modal("toggle");
						//document.getElementById("form-error").innerHTML='<div class="box_error"><ul><li>'+response.data.message+'</li></ul></div>';
					}
				}).catch(function (error) {
					helper.showInfo(error);
				});
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		/* If user logged in goto  order page */
	
		_createClass(Otpsignin, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				this.setState({ status: 'ok' });
	
				if (_reactCookie2.default.load('dineinClick') === 'yes') {
					_reactCookie2.default.save('dineinFrom', 'signin');
				}
	
				var promise = (0, _Api2.default)('settings', '');
				promise.then(function (res) {
					_this2.setState({ settings: res.data.result_set });
					_reactCookie2.default.save('client_company_name', res.data.result_set.company_name);
					_reactCookie2.default.save('check_new_user', 0);
	
					if (typeof res.data.result_set.client_enable_express_checkout !== "undefined" && parseInt(res.data.result_set.client_enable_express_checkout) === 0) {
						_reactRouter.hashHistory.push("/sign-in");
					}
				});
			}
		}, {
			key: 'setStateLoading',
			value: function setStateLoading(sts) {
				this.setState({ status: sts });
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this3 = this;
	
				var list = document.getElementsByClassName('form-group');
				var n;
				for (n = 0; n < list.length; ++n) {
					list[n].classList.add("is-empty");
				}
	
				var promise = (0, _Api2.default)('settings', '');
				promise.then(function (res) {
					_this3.setState({ settings: res.data.result_set });
					_reactCookie2.default.save("client_otp_verification_enable", res.data.result_set.client_otp_verification_enable);
					_reactCookie2.default.save("client_otp_verification_via", res.data.result_set.client_otp_verification_via);
					_reactCookie2.default.save('client_company_name', res.data.result_set.company_name);
					_reactCookie2.default.save('check_new_user', 0);
				});
	
				(0, _withTracker.loadAnalytics)();
			}
			/* continue with delivery success */
	
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(Form, {
					fields: this.state.fields,
					onChange: this.fieldChange,
					onValid: this.handleFormSubmit,
					onInvalid: function onInvalid() {
						return console.log('Form invalid!');
					}
				});
			}
		}]);
	
		return Otpsignin;
	}(_react2.default.Component);
	
	var isEmpty = function isEmpty(value) {
		return value === '' ? 'This field is required.' : null;
	};
	
	var isEmail = function isEmail(email) {
		return _validator2.default.isEmail(email) ? null : 'This is not a valid email.';
	};
	
	function validationConfig(props) {
		var _props$fields = props.fields,
		    email = _props$fields.email,
		    password = _props$fields.password;
	
	
		return {
			fields: ['email', 'password'],
	
			validations: {
				email: [[isEmail, email]],
				password: [[isEmpty, password]]
			}
		};
	}
	
	var Form = function (_React$Component2) {
		_inherits(Form, _React$Component2);
	
		function Form(props) {
			_classCallCheck(this, Form);
	
			// alert('load');
			var _this4 = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));
	
			_this4.state = {
				status: 'Loading',
				fbId: '',
				guestFields: {},
				guestLoginFields: { 'guest-password': _reactCookie2.default.load('is_refference') ? _reactCookie2.default.load('is_refference') : '' },
				guestforgotFields: {},
				guestresetFields: {},
				check_new_user: 0,
				guestErrors: {},
				guestLoginErrors: {},
				guestforgotErrors: {},
				guestresetErrors: {},
				guest_checkout_enable: 0,
				guest_type: 0,
				backtoGuestform: false,
				forgotPasswordSuccessMessage: "",
				guestName: "",
				'renderLoading': 'Loading', windowHeightNormal: 0, windowHeight: 0,
				'memberLoginPhone': '',
				showPassword: false,
				showPasswordOne: false,
				showPasswordLogin: false,
				showPasswordForgot: false,
				showPasswordForgotOne: false
			};
	
			_this4.responseFacebook = function (response) {
				// console.log(response);
				//alert(response.birthday);  
				if (response.name !== "" && response.email !== "" && response.name !== undefined && response.email !== undefined) {
					_this4.setStateLoading('Loading');
					document.getElementById("loadIcon").style.display = "block";
					var vSplitName = response.name.split(" ");
					var firstname = vSplitName[0];
					var lastname = vSplitName[1];
					var birthday = response.birthday;
					var qs = __webpack_require__(3);
					/* update gender field */
					var postGender = "";
					if (typeof response.gender !== "undefined" && response.gender === "male") {
						postGender = "M";
					} else if (typeof response.gender !== "undefined" && response.gender === "female") {
						postGender = "F";
					}
					/* update DOB */
					var dob = '';
					if (typeof birthday !== "undefined" && birthday !== "") {
						dob = dateFormat(response.birthday, "yyyy-mm-dd");
					}
	
					var postObject = {
						"app_id": APPID,
						"type": "web",
						"login_firstname": response.first_name,
						"login_lastname": response.last_name,
						"login_username": response.email,
						"customer_fb_id": response.id,
						"customer_gender": postGender,
						"customer_dob": dob
					};
					_axios2.default.post(APIURL + "customer/fbloginapp", qs.stringify(postObject)).then(function (response) {
						if (response.data.status === "ok") {
							/* set User cookie values - Start  */
							//alert(response.data.result_set.customer_phone);
							var mobileno = '';
							if (typeof response.data.result_set.customer_phone === "undefined" || response.data.result_set.customer_phone === "null" || response.data.result_set.customer_phone === "") {
								mobileno = "";
							} else {
	
								mobileno = response.data.result_set.customer_phone;
							}
	
							_reactCookie2.default.save("UserId", response.data.result_set.customer_id);
							_reactCookie2.default.save("UserEmail", response.data.result_set.customer_email);
							_reactCookie2.default.save("UserFname", response.data.result_set.customer_first_name !== "" ? response.data.result_set.customer_first_name : '');
							_reactCookie2.default.save("UserLname", response.data.result_set.customer_last_name !== "" ? response.data.result_set.customer_last_name : '');
							_reactCookie2.default.save("UserMobile", mobileno);
	
							_reactCookie2.default.save("UserDefaultAddress", response.data.result_set.customer_address_name);
							_reactCookie2.default.save("UserDefaultUnitOne", response.data.result_set.customer_address_line1);
							_reactCookie2.default.save("UserDefaultUnitTwo", response.data.result_set.customer_address_line2);
							_reactCookie2.default.save("UserDefaultPostalCode", response.data.result_set.customer_postal_code);
	
							/* set User cookie values - End  */
	
							/* set redirection */
	
							/* upadte customer info  */
							var qs = __webpack_require__(3);
							var postObject = {
								"app_id": APPID,
								"reference_id": (0, _Api2.default)('referenceId'),
								"customer_id": response.data.result_set.customer_id,
								"availability_id": _reactCookie2.default.load('defaultAvilablityId')
							};
	
							_axios2.default.post(APIURL + "cart/update_customer_info", qs.stringify(postObject)).then(function (res) {
								if (res.data.status === "ok" && _reactCookie2.default.load('reserVationClick') !== 'fromhome') {
									_reactCookie2.default.save('cartValue', 'Yes');
									if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId) {
										if (APPID === "287E5552-328E-4DBE-A3CA-E998ACCAC9BD") {
											helper.sarveshTableSetup();
										} else {
											if (typeof _reactCookie2.default.load("orderOutletId") !== "undefined" && _reactCookie2.default.load("orderOutletId") !== "" && typeof _reactCookie2.default.load("orderTableNo") !== "undefined" && _reactCookie2.default.load("orderTableNo") !== "") {
												_reactRouter.hashHistory.push("/checkout");
											} else {
	
												_reactRouter.hashHistory.push("/book-a-table");
											}
										}
									} else {
										_reactRouter.hashHistory.push("/delivery-date");
									}
									_this4.setStateLoading('ok');
									document.getElementById("loadIcon").style.display = "none";
								} else {
									if (_reactCookie2.default.load('reserVationClick') === 'fromhome') {
										_reactRouter.hashHistory.push("/");
										_reactCookie2.default.save('reserVationClick', 'fromlogin');
									} else if (_reactCookie2.default.load('dineinClick') === 'yes' && _reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId) {
										if (APPID === "287E5552-328E-4DBE-A3CA-E998ACCAC9BD") {
											helper.sarveshTableSetup();
										} else {
											_this4.setStateLoading('ok');
											_reactRouter.hashHistory.push("/book-a-table");
										}
									} else {
										_reactRouter.hashHistory.push("/my-account");
										_reactCookie2.default.save('cartValue', 'No');
									}
								}
							});
						} else {
							_this4.setStateLoading('error');
							document.getElementById("loadIcon").style.display = "none";
							helper.showInfo(response.data.message);
							//document.getElementById("form-error").innerHTML='<div class="box_error"><ul><li>'+response.data.message+'</li></ul></div>';
						}
					}).catch(function (error) {
						//  console.log(error);
						helper.showInfo(error);
					});
				}
			};
	
			_this4.handleChangeTxt = function (item, event) {
				_this4.setState(_defineProperty({}, item, event.target.value));
				document.getElementById("spn-otp-error").innerHTML = '';
			};
	
			var promise = (0, _Api2.default)('settingsProWithavailability', 'No');
			promise.then(function (res) {
				//alert('loaded');
				//this.setStateLoading('Loading');
				_this4.setState({ client_site_url: res.data.result_set.client_site_url, fbId: res.data.result_set.ninja_pro_fb_app_id, renderLoading: 'ok', guest_checkout_enable: res.data.result_set.client_guest_checkout_enable, client_anonymous_customer_login_enable: res.data.result_set.client_anonymous_customer_login_enable });
			});
			return _this4;
		}
	
		_createClass(Form, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (APPID === MemberAppID || APPID === MemberAppIDSCC) {
					var current = this;
					setTimeout(function () {
						current.guestCheckout();
					}, 1000);
				}
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.setStateLoading('ok');
	
				var windowHeight = window.innerHeight;
				this.setState({ 'windowHeight': windowHeight + 'px' });
			}
	
			/* get FB ID*/
	
			/* guest form */
	
		}, {
			key: 'guestCheckout',
			value: function guestCheckout() {
				$("#GuestCheckout").modal("toggle");
			}
		}, {
			key: 'enableGuset',
			value: function enableGuset() {
				$(".enable-guest").show();
				$(".disable-guest").hide();
				this.setState({ "guest_type": 1 });
			}
		}, {
			key: 'disableGuset',
			value: function disableGuset() {
				$(".enable-guest").hide();
				$(".disable-guest").show();
				this.setState({ "guest_type": 0 });
			}
		}, {
			key: 'showGusetCheckout',
			value: function showGusetCheckout() {
	
				if (parseInt(this.state.guest_checkout_enable) === 1) {
					return _react2.default.createElement(
						'div',
						{ className: 'row row-guest-checkout' },
						_react2.default.createElement(
							'div',
							{ className: 'text-center ' },
							_react2.default.createElement(
								'button',
								{ type: 'button', onClick: this.guestCheckout.bind(this), className: 'btn text-uppercase btn-guest-checkout' },
								_react2.default.createElement('img', { src: '/img/icons/user-white.png', alt: 'guest-checkout', className: 'icon-img-guest-checkout' }),
								APPID === "B401FC82-8E39-4076-838A-55192F765004" || APPID === "6C0280A0-B655-4E0F-A43F-041C189683BA" ? 'Member Login' : 'Express Checkout'
							)
						)
					);
				}
			}
		}, {
			key: 'getAnonymousCheckout',
			value: function getAnonymousCheckout() {
				var _this5 = this;
	
				$("#loadIcon").show();
				_axios2.default.get(_constants.API_v4_URL + "anonymouscustomer/get_anonymous_customer/?app_id=" + APPID).then(function (response) {
	
					$("#loadIcon").hide();
					if (response.data.status === "ok") {
	
						_this5.setGuestData(response, 'isAnonymousUser');
					} else {
						helper.showInfo("This feature is currently unavailable please try again later");
					}
					return false;
				});
			}
		}, {
			key: 'showAnonymousCheckout',
			value: function showAnonymousCheckout() {
	
				if (parseInt(this.state.client_anonymous_customer_login_enable) === 1) {
					return _react2.default.createElement(
						'div',
						{ className: 'row row-guest-checkout' },
						_react2.default.createElement(
							'div',
							{ className: 'text-center ' },
							_react2.default.createElement(
								'h4',
								null,
								'Continue without an account'
							),
							_react2.default.createElement(
								'button',
								{ type: 'button', onClick: this.getAnonymousCheckout.bind(this), className: 'btn text-uppercase btn-guest-checkout btn-guest-checkout-btn' },
								_react2.default.createElement('img', { src: '/img/icons/user-white.png', alt: 'guest-checkout', className: 'icon-img-guest-checkout' }),
								"Guest Order"
							)
						)
					);
				}
			}
		}, {
			key: 'transformEntry',
			value: function transformEntry(item, type) {
				switch (type) {
					case 'email':
						var parts = item.split("@"),
						    len = parts[0].length;
						return item.replace(parts[0].slice(1, -1), "*".repeat(len - 2));
					case 'phone':
						return item[0] + "*".repeat(item.length - 4) + item.slice(-3);
					default:
						throw new Error("Undefined type: " + type);
				}
			}
		}, {
			key: 'handleValidation',
			value: function handleValidation() {
				var fields = this.state.guestFields;
				var errors = {};
				var formIsValid = true;
				var guestMobile = fields["guest-mobile"];
				if (APPID === MemberAppID || APPID === MemberAppIDSCC) {
					var membershipid = fields["guest-membershipid"];
					if (!membershipid) {
						formIsValid = false;
						errors["guest-membershipid"] = "Membership # field is required.";
					}
					/*else {
	    	if(APPID===MemberAppIDSCC) {
	    		var validMember = '^[a-zA-Z][0-9]{4}$';
	     	var result = membershipid.match(validMember);
	     	if(result===null || result==="") {
	     		formIsValid = false;
	        		errors["guest-membershipid"] = "Invalid Membership #";
	     	}
	    	}	        	
	    }*/
					/*else if(this.state.invalidMemberID===true) {
	       formIsValid = false;
	       errors["guest-membershipid"] = "Invalid Membership #";
	    }*/
				}
				if (!guestMobile) {
	
					formIsValid = false;
					errors["guest-mobile"] = "Mobile number field is required.";
				}
	
				if (typeof guestMobile !== "undefined") {
					if (!guestMobile.match(/^[0-9]+$/)) {
						formIsValid = false;
						errors["guest-mobile"] = "Invalid Mobile number";
					} else if (guestMobile.length < 8) {
						formIsValid = false;
						errors["guest-mobile"] = "Mobile number must be of minimum 8 characters length.";
					}
				}
	
				if (!fields["guest-name"]) {
					formIsValid = false;
					errors["guest-name"] = "Name field is required.";
				}
	
				if (typeof fields["guest-name"] !== "undefined") {
					if (!fields["guest-name"].match(/^[A-Za-z ]{3,20}$/)) {
						formIsValid = false;
						errors["guest-name"] = "Name must contain only letters.";
					}
				}
	
				if (!fields["guest-email"]) {
					formIsValid = false;
					errors["guest-email"] = "Email field is required.";
				}
	
				if (typeof fields["guest-email"] !== "undefined") {
					var lastAtPos = fields["guest-email"].lastIndexOf('@');
					var lastDotPos = fields["guest-email"].lastIndexOf('.');
	
					if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fields["guest-email"].indexOf('@@') == -1 && lastDotPos > 2 && fields["guest-email"].length - lastDotPos > 2)) {
						formIsValid = false;
						errors["guest-email"] = "Email is not valid.";
					}
				}
	
				if (!fields["guest-password"]) {
					formIsValid = false;
					errors["guest-password"] = "PIN field is required.";
				}
				if (typeof fields["guest-password"] !== "undefined") {
					if (fields["guest-password"].length < 6) {
						formIsValid = false;
						errors["guest-password"] = "PIN must be of minimum 6 characters length.";
					}
				}
	
				if (!fields["guest-retype-password"]) {
					formIsValid = false;
					errors["guest-retype-password"] = "Confirm PIN field is required.";
				}
	
				if (typeof fields["guest-retype-password"] !== "undefined") {
					if (fields["guest-retype-password"].length < 6) {
						formIsValid = false;
						errors["guest-retype-password"] = "Confirm PIN must be of minimum 6 characters length";
					} else if (this.replaceText(fields["guest-password"]) != this.replaceText(fields["guest-retype-password"])) {
						formIsValid = false;
						errors["guest-retype-password"] = "Your PIN and confirmation PIN do not match.";
					}
				}
	
				if (!fields["guest-accepted-alcohol"] && (APPID === "2AE048E7-2D84-42BE-9BB5-22016FC4DFBC" || APPID === "44275190-B355-4486-8083-EE1C63607916" || APPID === "F34559CA-596A-4F2E-8547-17B2AEBB3326")) {
					formIsValid = false;
					errors["guest-accepted-alcohol"] = "This field is required.";
				}
	
				this.setState({ guestErrors: errors });
				return formIsValid;
			}
		}, {
			key: 'sendOtpToCustomer',
			value: function sendOtpToCustomer() {
				var _this6 = this;
	
				var company_otp_verification = _reactCookie2.default.load('client_otp_verification_enable');
				var company_otp_via = _reactCookie2.default.load('client_otp_verification_via');
	
				if (company_otp_verification === '1') {
					$("#loadIcon").show();
					var qs = __webpack_require__(3);
					var postObject = {
						"app_id": APPID,
						"customer_first_name": this.state.guestFields['guest-name'],
						"customer_last_name": "",
						"customer_email": this.state.guestFields['guest-email'],
						"customer_phone": this.state.guestFields['guest-mobile'],
						"customer_otp_type": company_otp_via
					};
	
					_axios2.default.post(_constants.API_v4_URL + "customer/send_customer_otp", qs.stringify(postObject)).then(function (response) {
						if (response.data.status === "ok") {
							$("#loadIcon").hide();
							document.getElementById("otp_verification_option").style.display = "block";
							if (company_otp_via === '1') {
								helper.showInfo("OTP has been sent to your email id (" + _this6.transformEntry(_this6.state.guestFields['guest-email'], 'email') + " )");
							} else {
								helper.showInfo("OTP has been sent to your mobile number (" + _this6.transformEntry(_this6.state.guestFields['guest-mobile'], 'phone') + " )");
							}
							document.getElementById("loadIcon").style.display = "none";
							document.getElementById("new-guest").style.display = "none";
	
							//  return false;
						} else {
							_this6.setStateLoading('error');
							document.getElementById("otp_error_msg").innerHTML = '<span class="spn-error">' + response.data.message + '</span>';
							document.getElementById("loadIcon").style.display = "none";
							$("#loadIcon").hide();
						}
						return false;
					});
				}
			}
	
			/* for reser password */
	
		}, {
			key: 'applyGuestresetValidation',
			value: function applyGuestresetValidation() {
				var _this7 = this;
	
				if (this.handleGuestrestValidation()) {
					$("#loadIcon").show();
					var qs = __webpack_require__(3);
					var postObject = {
						"app_id": APPID,
						"otp": this.state.guestresetFields['guest-otp'],
						"password": this.replaceText(this.state.guestresetFields['guest-password']),
						"confirmpassword": this.replaceText(this.state.guestresetFields['guest-retype-password']),
						'type': "Web"
	
					};
					_axios2.default.post(_constants.API_v4_URL + "guest-checkout/customer/guest_resetpassword", qs.stringify(postObject)).then(function (response) {
	
						$(".guest-reset-error").hide();
						_this7.setState({ forgotPasswordSuccessMessage: '' });
						if (response.data.status === "ok") {
							$("#loadIcon").hide();
							document.getElementById("reset-pin").style.display = "none";
							document.getElementById("existing-guest").style.display = "block";
							helper.showInfo(response.data.message);
						} else {
							$("#loadIcon").hide();
							if (typeof response.data.form_error !== "undefined") {
								$(".guest-reset-error").show();
								$(".guest-reset-error").html(response.data.form_error);
								$(".guest-reset-error p").addClass("error-msg");
							} else {
								$(".guest-reset-error").show();
								$(".guest-reset-error-p").html(response.data.message);
							}
						}
						return false;
					}).catch(function (error) {
						console.log(error);
					});
				}
			}
		}, {
			key: 'handleGuestrestValidation',
			value: function handleGuestrestValidation() {
	
				var fields = this.state.guestresetFields;
				var errors = {};
				var formIsValid = true;
				var guestOtp = fields["guest-otp"];
	
				if (!guestOtp) {
	
					formIsValid = false;
					errors["guest-otp"] = "OTP field is required.";
				}
	
				if (typeof fields["guest-otp"] !== "undefined") {
					if (fields["guest-otp"].length < 6) {
						formIsValid = false;
						errors["guest-otp"] = "OTP must be of minimum 6 characters length.";
					}
				}
	
				if (!fields["guest-password"]) {
					formIsValid = false;
					errors["guest-password"] = "PIN field is required.";
				}
	
				if (typeof fields["guest-password"] !== "undefined") {
					if (fields["guest-password"].length < 6) {
						formIsValid = false;
						errors["guest-password"] = "PIN must be of minimum 6 characters length.";
					}
				}
	
				if (!fields["guest-retype-password"]) {
					formIsValid = false;
					errors["guest-retype-password"] = "Confirm PIN field is required.";
				}
	
				if (typeof fields["guest-retype-password"] !== "undefined") {
					if (fields["guest-retype-password"].length < 6) {
						formIsValid = false;
						errors["guest-retype-password"] = "Confirm PIN must be of minimum 6 characters length";
					} else if (this.replaceText(fields["guest-password"]) != this.replaceText(fields["guest-retype-password"])) {
						formIsValid = false;
						errors["guest-retype-password"] = "Your PIN and confirmation PIN do not match.";
					}
				}
	
				this.setState({ guestresetErrors: errors });
				return formIsValid;
			}
			/* for reset pasword */
	
			/* fot guest forgot */
	
		}, {
			key: 'applyGuestforgotValidation',
			value: function applyGuestforgotValidation() {
				var _this8 = this;
	
				if (this.handleGuestforgotValidation()) {
					var guestType = parseInt(this.state.guest_type);
					$("#loadIcon").show();
	
					var company_otp_verification = _reactCookie2.default.load('client_otp_verification_enable');
					var company_otp_via = _reactCookie2.default.load('client_otp_verification_via');
	
					var qs = __webpack_require__(3);
					var postObject = {
						"app_id": APPID,
						"type": "web",
						"mobile_no": this.state.guestforgotFields['guest-mobile']
					};
					_axios2.default.post(_constants.API_v4_URL + "guest-checkout/customer/guest_forgot_password", qs.stringify(postObject)).then(function (response) {
	
						if (response.data.status === "ok") {
							var result_set = response.data.result_set;
	
							/* for OTP */
							var qs = __webpack_require__(3);
							var postObject = {
								"app_id": APPID,
								"customer_first_name": result_set['customer_first_name'] ? result_set['customer_first_name'] : "Guest",
								"customer_last_name": "",
								"customer_email": result_set['customer_email'] ? result_set['customer_email'] : "",
								"customer_phone": result_set['customer_phone'] ? result_set['customer_phone'] : "",
								"verify_type": "forgotpin"
							};
	
							_axios2.default.post(_constants.API_v4_URL + "guest-checkout/customer/send_customer_otp", qs.stringify(postObject)).then(function (response) {
								$("#loadIcon").hide();
	
								if (response.data.status === "ok") {
	
									document.getElementById("forgot-pin").style.display = "none";
									document.getElementById("reset-pin").style.display = "block";
									var message = "";
									if (company_otp_via === '1') {
										message = "OTP has been sent to your email id (" + _this8.transformEntry(result_set['customer_email'], "email") + " )";
									} else {
										message = "OTP has been sent to your mobile number (" + _this8.transformEntry(result_set['customer_phone'], 'phone') + " )";
									}
	
									_this8.setState({ forgotPasswordSuccessMessage: message });
								} else {
	
									if (typeof response.data.form_error !== "undefined") {
										$(".guest-forgot-error").show();
										$(".guest-forgot-error").html(response.data.form_error);
										$(".guest-forgot-error p").addClass("error-msg");
									} else {
										$(".guest-forgot-error").show();
										$(".guest-forgot-error-p").html(response.data.message);
									}
	
									_this8.setStateLoading('error');
									document.getElementById("loadIcon").style.display = "none";
								}
								return false;
							});
	
							/* for OTP */
						} else {
	
							$("#loadIcon").hide();
							$(".guest-forgot-error").hide();
	
							if (typeof response.data.form_error !== "undefined") {
	
								$(".guest-forgot-error").show();
								$(".guest-forgot-error").html(response.data.form_error);
								$(".guest-forgot-error p").addClass("error-msg");
							} else {
								$(".guest-forgot-error").show();
								$(".guest-forgot-error-p").html(response.data.message);
							}
						}
						return false;
					}).catch(function (error) {
						console.log(error);
					});
				}
			}
		}, {
			key: 'handleGuestforgotValidation',
			value: function handleGuestforgotValidation() {
	
				var fields = this.state.guestforgotFields;
				var errors = {};
				var formIsValid = true;
				var guestMobile = fields["guest-mobile"];
	
				if (!guestMobile) {
	
					formIsValid = false;
					errors["guest-mobile"] = "Mobile number field is required.";
				}
	
				if (typeof guestMobile !== "undefined") {
					if (!guestMobile.match(/^[0-9]+$/)) {
						formIsValid = false;
						errors["guest-mobile"] = "Invalid Mobile number";
					} else if (guestMobile.length < 8) {
						formIsValid = false;
						errors["guest-mobile"] = "Mobile number must be of minimum 8 characters length.";
					}
				}
	
				this.setState({ guestforgotErrors: errors });
				return formIsValid;
			}
	
			/* for guest login  */
	
		}, {
			key: 'applyGuestLoginValidation',
			value: function applyGuestLoginValidation() {
				var _this9 = this;
	
				if (this.handleGuestLoginValidation()) {
					var pin = this.state.guestLoginFields['guest-password'].replace(/\s/g, '');
					$("#loadIcon").show();
					var qs = __webpack_require__(3);
	
					if (APPID === MemberAppID || APPID === MemberAppIDSCC) {
						var mNumeber = this.state.memberLoginPhone ? this.state.memberLoginPhone : this.state.guestFields['guest-mobile'];
					} else {
						mNumeber = this.state.guestFields['guest-mobile'];
					}
	
					var postObject = {
						"app_id": APPID,
						"login_username": mNumeber,
						"login_password": pin,
						'type': "Web"
	
					};
	
					_axios2.default.post(_constants.API_v4_URL + "guest-checkout/GusestAccount/gusetLogin", qs.stringify(postObject)).then(function (response) {
	
						$(".guest-login-error").hide();
	
						if (response.data.status === "ok") {
	
							if ($('#keep-signin').is(":checked")) {
								var expires = new Date();
								expires.setTime(expires.getTime() + 30 * 24 * 60 * 60 * 1000);
								_reactCookie2.default.save('is_refference', pin, { path: "/", expires: expires });
							}
	
							_this9.setGuestData(response);
							_this9.closeGuestToggle();
						} else {
	
							$("#loadIcon").hide();
							if (typeof response.data.form_error !== "undefined") {
								$(".guest-login-error").show();
								$(".guest-login-error").html(response.data.form_error);
								$(".guest-login-error p").addClass("error-msg");
							} else {
								$(".guest-login-error").show();
								$(".guest-login-error-p").html(response.data.message);
							}
						}
						return false;
					}).catch(function (error) {
						console.log(error);
					});
				}
			}
		}, {
			key: 'handleGuestLoginValidation',
			value: function handleGuestLoginValidation() {
	
				var fields = this.state.guestLoginFields;
				var errors = {};
				var formIsValid = true;
				var guestMobile = fields["guest-mobile"];
	
				/* if(!guestMobile){
	    
	      formIsValid = false;
	      errors["guest-mobile"] = "Mobile number field is required.";
	   }
	   
	    if(typeof guestMobile !== "undefined"){
	      if(!guestMobile.match(/^[0-9]+$/)){
	   	  formIsValid = false;
	   	  errors["guest-mobile"] = "Invalid Mobile number";
	      }else if(guestMobile.length < 8) {
	   	  formIsValid = false;
	   	  errors["guest-mobile"] = "Mobile number must be of minimum 8 characters length.";
	      }		   
	   } */
	
				if (!fields["guest-password"]) {
					formIsValid = false;
					errors["guest-password"] = "PIN field is required.";
				}
				if (typeof fields["guest-password"] !== "undefined") {
					if (fields["guest-password"].length < 6) {
						formIsValid = false;
						errors["guest-password"] = "PIN must be of minimum 6 characters length.";
					}
				}
	
				this.setState({ guestLoginErrors: errors });
				return formIsValid;
			}
		}, {
			key: 'applyValidation',
			value: function applyValidation() {
				var _this10 = this;
	
				/* if(this.state.check_new_user === 1) {
	   	helper.showInfo("You already have account.");
	   	return false;
	   } */
	
				if (this.handleValidation()) {
					/*if(APPID===MemberAppID) {
	    	if(this.state.invalidMemberID===true) {
	    		this.setState({guestErrors : {"guest-membershipid":'Invalid Membership #'}})
	    		return false;
	    	}
	    }*/
	
					var guestType = parseInt(this.state.guest_type);
					$("#loadIcon").show();
	
					var company_otp_verification = _reactCookie2.default.load('client_otp_verification_enable');
					var company_otp_via = _reactCookie2.default.load('client_otp_verification_via');
	
					var accepted_coupons = 0;
					if (this.state.guestFields['guest-accepted-coupons'] !== "" && typeof this.state.guestFields['guest-accepted-coupons'] !== "undefined" && _typeof(this.state.guestFields['guest-accepted-coupons']) !== undefined) {
						accepted_coupons = this.state.guestFields['guest-accepted-coupons'];
					}
	
					var qs = __webpack_require__(3);
					var postObject = {
						"app_id": APPID,
						"type": "web",
						"customer_first_name": this.state.guestFields['guest-name'],
						"customer_last_name": "",
						"customer_email": this.state.guestFields['guest-email'],
						"customer_pin": this.state.guestFields['guest-password'].replace(/\s/g, ''),
						"customer_confirm_pin": this.state.guestFields['guest-retype-password'].replace(/\s/g, ''),
						"customer_phone": this.state.guestFields['guest-mobile'],
						"customer_member_id": APPID === MemberAppID || APPID === MemberAppIDSCC ? this.state.guestFields['guest-membershipid'] : '',
						"search_type": APPID === MemberAppID || APPID === MemberAppIDSCC ? 'MemberID' : 'Mobile',
						"accepted_coupons": accepted_coupons,
						"site_url": this.state.client_site_url + "#/"
					};
	
					postObject["validation_only"] = "Yes";
					_axios2.default.post(_constants.API_v4_URL + "guest-checkout/GusestAccount/create", qs.stringify(postObject)).then(function (response) {
	
						if (response.data.status === "ok") {
	
							/* for OTP */
							var qs = __webpack_require__(3);
							var postObject = {
								"app_id": APPID,
								"customer_first_name": _this10.state.guestFields['guest-name'],
								"customer_last_name": "",
								"customer_email": _this10.state.guestFields['guest-email'],
								"customer_phone": _this10.state.guestFields['guest-mobile'],
								"verify_type": "register"
							};
	
							_axios2.default.post(_constants.API_v4_URL + "guest-checkout/customer/send_customer_otp", qs.stringify(postObject)).then(function (response) {
								if (response.data.status === "ok") {
									document.getElementById("new-guest").style.display = "none";
									document.getElementById("otp_verification_option").style.display = "block";
									if (company_otp_via === '1') {
										helper.showInfo("OTP has been sent to your email id (" + _this10.transformEntry(_this10.state.guestFields['guest-email'], "email") + " )");
									} else {
										helper.showInfo("OTP has been sent to your mobile number (" + _this10.transformEntry(_this10.state.guestFields['guest-mobile'], 'phone') + " )");
									}
									document.getElementById("loadIcon").style.display = "none";
								} else {
	
									_this10.setStateLoading('error');
									document.getElementById("otp_error_msg").innerHTML = '<span class="spn-error">' + response.data.message + '</span>';
									document.getElementById("loadIcon").style.display = "none";
									$("#loadIcon").hide();
								}
								return false;
							});
	
							/* for OTP */
						} else {
	
							$("#loadIcon").hide();
							$(".gue-comm-error").hide();
	
							if (typeof response.data.form_error !== "undefined") {
	
								$(".guest-form-error").show();
								$(".guest-form-error").html(response.data.form_error);
								$(".guest-form-error p").addClass("error-msg");
							} else {
								$(".guest-form-error").show();
								$(".guest-form-error-p").html(response.data.message);
							}
						}
						return false;
					}).catch(function (error) {
						console.log(error);
					});
				} else {
					console.log("Form has errors.");
				}
			}
		}, {
			key: 'setGuestData',
			value: function setGuestData(response) {
				var _this11 = this;
	
				var isAnonymousUser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
				var mobileno = '';
				if (response.data.result_set.customer_phone !== "" || response.data.result_set.customer_phone !== null || typeof response.data.result_set.customer_phone !== "undefined") {
					mobileno = response.data.result_set.customer_phone;
				}
	
				/* set User cookie values - Start */
				_reactCookie2.default.save("UserId", response.data.result_set.customer_id);
				_reactCookie2.default.save("UserFname", response.data.result_set.customer_first_name !== "" ? response.data.result_set.customer_first_name : '');
				_reactCookie2.default.save("UserLname", response.data.result_set.customer_last_name != "" ? response.data.result_set.customer_last_name : '');
				_reactCookie2.default.save("UserMobile", mobileno);
				_reactCookie2.default.save("userAccountType", 1);
				_reactCookie2.default.save("UserEmail", response.data.result_set.customer_email);
				/*cookie.save("UserDefaultAddress",response.data.result_set.customer_address_name);
	   cookie.save("UserDefaultUnitOne",response.data.result_set.customer_address_line1);
	   cookie.save("UserDefaultPostalCode",response.data.result_set.customer_postal_code); */
				_reactCookie2.default.save("UserDefaultUnitTwo", response.data.result_set.customer_address_line2);
				/* set User cookie values - End */
	
				if (isAnonymousUser) {
					_reactCookie2.default.save("isAnonymousUser", 1);
				} else {
					_reactCookie2.default.save("isAnonymousUser", 0);
				}
	
				/* set redirection */
	
				/* upadte customer info */
				var qs = __webpack_require__(3);
				var postObject = {
					"app_id": APPID,
					"reference_id": (0, _Api2.default)('referenceId'),
					"customer_id": response.data.result_set.customer_id,
					"availability_id": _reactCookie2.default.load('defaultAvilablityId')
				};
	
				_axios2.default.post(APIURL + "cart/update_customer_info", qs.stringify(postObject)).then(function (res) {
					if (res.data.status === "ok" && _reactCookie2.default.load('reserVationClick') !== 'fromhome') {
	
						/* check FB login function */
						_reactCookie2.default.save('cartValue', 'Yes');
						if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId) {
							if (APPID === "287E5552-328E-4DBE-A3CA-E998ACCAC9BD") {
								helper.sarveshTableSetup();
								// this.setStateLoading('ok'); 
							} else {
								_this11.setStateLoading('ok');
								if (typeof _reactCookie2.default.load("orderOutletId") !== "undefined" && _reactCookie2.default.load("orderOutletId") !== "" && typeof _reactCookie2.default.load("orderTableNo") !== "undefined" && _reactCookie2.default.load("orderTableNo") !== "") {
									_reactRouter.hashHistory.push("/checkout");
								} else {
									_reactRouter.hashHistory.push("/book-a-table");
								}
							}
						} else {
							_this11.setStateLoading('ok');
							document.getElementById("loadIcon").style.display = "none";
							_reactRouter.hashHistory.push("/delivery-date");
						}
					} else {
						if (_reactCookie2.default.load('reserVationClick') === 'fromhome') {
							_reactRouter.hashHistory.push("/");
							_reactCookie2.default.save('reserVationClick', 'fromlogin');
						} else if (_reactCookie2.default.load('dineinClick') === 'yes' && _reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId) {
							if (APPID === "287E5552-328E-4DBE-A3CA-E998ACCAC9BD") {
								helper.sarveshTableSetup();
							} else {
								_this11.setStateLoading('ok');
								_reactRouter.hashHistory.push("/book-a-table");
							}
						} else {
							if (isAnonymousUser) {
								_reactRouter.hashHistory.push("/");
							} else {
								_reactRouter.hashHistory.push("/my-account");
							}
							_reactCookie2.default.save('cartValue', 'No');
						}
					}
				});
			}
		}, {
			key: 'closeGuestToggle',
			value: function closeGuestToggle() {
				$("#GuestCheckout").modal("toggle");
			}
		}, {
			key: 'closeGuestCheckoutToggle',
			value: function closeGuestCheckoutToggle() {
				$("#GuestCheckout").modal("toggle");
				_reactRouter.hashHistory.push("/");
			}
		}, {
			key: 'guestFormChange',
			value: function guestFormChange(field, e) {
				var guestFields = this.state.guestFields;
				guestFields[field] = e.target.value;
				this.setState({ guestFields: guestFields, guestErrors: {} });
				if (APPID === MemberAppID || APPID === MemberAppIDSCC) {
					if (field === "guest-membershipid") {
						var mobileNo = e.target.value;
						if (mobileNo.length >= 5) {
							if (APPID === MemberAppIDSCC) {
								/*var validMember = '^[a-zA-Z][0-9]{4}$';
	            	var result = mobileNo.match(validMember);
	            	if(result!=="" && result!=null) {*/
								this.validateCustomer(mobileNo);
								/*}*/
							} else {
								this.validateCustomer(mobileNo);
							}
						}
					}
				} else {
					if (field === "guest-mobile") {
						var mobileNo = e.target.value;
						if (mobileNo.length >= 8) {
							this.validateCustomer(mobileNo);
						}
						document.getElementById("otp_error_msg").innerHTML = '';
					}
				}
			}
		}, {
			key: 'guestFormChangeCheckBox',
			value: function guestFormChangeCheckBox(field, e) {
				var guestFields = this.state.guestFields;
				var ID = e.target.id;
				console.log(ID);
				var value = '';
				if ($('#' + ID).is(":checked")) {
					value = 1;
				} else {
					value = 0;
				}
				guestFields[field] = value;
				this.setState({ guestFields: guestFields, guestErrors: {} });
			}
		}, {
			key: 'keepsignin',
			value: function keepsignin(field, e) {
				var guestLoginFields = this.state.guestLoginFields;
				var ID = e.target.id;
				console.log(ID);
				var value = '';
				if ($('#' + ID).is(":checked")) {
					value = 1;
				} else {
					value = 0;
				}
				console.log(value);
				guestLoginFields[field] = value;
				this.setState({ guestLoginFields: guestLoginFields, guestLoginErrors: {} });
			}
		}, {
			key: 'guestLgoinFormChangeCheckBox',
			value: function guestLgoinFormChangeCheckBox(field, e) {
				var guestLoginFields = this.state.guestLoginFields;
				guestLoginFields[field] = e.target.value;
				this.setState({ guestLoginFields: guestLoginFields, guestLoginErrors: {} });
			}
		}, {
			key: 'guestforgotFormChange',
			value: function guestforgotFormChange(field, e) {
				var guestforgotFields = this.state.guestforgotFields;
				guestforgotFields[field] = e.target.value;
				this.setState({ guestforgotFields: guestforgotFields, guestforgotErrors: {} });
			}
		}, {
			key: 'guestresetFormChange',
			value: function guestresetFormChange(field, e) {
				var guestresetFields = this.state.guestresetFields;
				guestresetFields[field] = e.target.value;
				this.setState({ guestresetFields: guestresetFields, guestresetErrors: {} });
			}
		}, {
			key: 'validateCustomer',
			value: function validateCustomer(mobileNo) {
				var _this12 = this;
	
				var mobileNumber = mobileNo;
				var searchData = "";
				if (APPID === MemberAppID || APPID === MemberAppIDSCC) {
					searchData = "search_type=MemberID&member_id=" + mobileNumber;
				} else {
					searchData = "search_type=Mobile&phone_no=" + mobileNumber;
				}
	
				$("#loadIcon").show();
				_axios2.default.get(APIURL + 'settings/get_customerdetail_phone/?app_id=' + APPID + "&status=A&" + searchData).then(function (res) {
					$("#loadIcon").hide();
					if (res.data.status === "ok") {
						document.getElementById("existing-guest").style.display = "block";
						document.getElementById("new-guest").style.display = "none";
						_this12.setState({ guestName: res.data.result_set.customer_first_name });
	
						if (APPID === MemberAppID || APPID === MemberAppIDSCC) {
							_this12.setState({ memberLoginPhone: res.data.result_set.customer_phone });
						} else {
							_this12.setState({ memberLoginPhone: res.data.result_set.customer_phone });
						}
	
						/* var firstName = res.data.result_set.customer_first_name;
	     var email = res.data.result_set.customer_email;
	     var mobileNumber = res.data.result_set.customer_phone;
	     var customer_member_id = res.data.result_set.customer_member_id;
	     var acceptedCoupons = res.data.result_set.accepted_coupons;
	     $(".is-exist").removeClass("is-empty");	
	     $(".is-exist").addClass("is-focused");
	     var MobileNumbers = "";
	     if(APPID===MemberAppID) {
	     	MobileNumbers = mobileNumber;
	     }
	     else {
	     	MobileNumbers = this.state.guestFields['guest-mobile'];						
	     }
	     this.setState({"backtoGuestform" : false , guestFields : {"guest-name" : firstName, "guest-email" : email, "guest-mobile" : MobileNumbers, "guest-membershipid":customer_member_id, "guest-password" : this.state.guestFields['guest-password'], "guest-retype-password" : this.state.guestFields['guest-retype-password'],'guest-accepted-coupons':acceptedCoupons }, invalidMemberID:false, accepted_coupons:acceptedCoupons  });
	     var company_otp_verification = cookie.load('client_otp_verification_enable');
	     if(company_otp_verification === '1' ){
	     	this.setState({"check_new_user" :1});
	     	this.sendOtpToCustomer();
	     }
	     
	     cookie.save('check_new_user',1); */
					} else {
	
						_this12.setState({ memberLoginPhone: '' });
	
						/*  console.log(this.state.guestFields);
	     	if(APPID===MemberAppID) {
	     		this.setState({ "backtoGuestform" : false, "check_new_user" : 0 , guestFields : {"guest-name" : "", "guest-email" : "", "guest-mobile" : this.state.guestFields['guest-mobile'], 'guest-membershipid':mobileNo} });
	     }
	     else {
	      	this.setState({ "backtoGuestform" : false, "check_new_user" : 0 , guestFields : {"guest-name" : "", "guest-email" : "", "guest-mobile" : this.state.guestFields['guest-mobile']} });
	     }
	     cookie.save('check_new_user',0);
	       $(".is-exist").addClass("is-empty");	
	                     $(".is-exist").removeClass("is-focused");				 
	                      this.setState({ guestFields : { "guest-mobile" : this.state.guestFields['guest-mobile'] , "guest-password" : this.state.guestFields['guest-password'], "guest-retype-password" : this.state.guestFields['guest-retype-password']}   });*/
					}
				});
			}
	
			/* guest form - that's it */
	
		}, {
			key: 'setStateLoading',
			value: function setStateLoading(sts) {
				this.setState({ status: sts });
			}
		}, {
			key: 'submit_otp_verification',
			value: function submit_otp_verification() {
				var _this13 = this;
	
				var customer_otp_val = this.state.customer_otp_val;
				var accepted_coupons = 0;
				if (this.state.guestFields['guest-accepted-coupons'] !== "" && typeof this.state.guestFields['guest-accepted-coupons'] !== "undefined" && _typeof(this.state.guestFields['guest-accepted-coupons']) !== undefined) {
					accepted_coupons = this.state.guestFields['guest-accepted-coupons'];
				}
				if (customer_otp_val != "" && customer_otp_val != undefined) {
					$("#loadIcon").show();
					var qs = __webpack_require__(3);
					var postObject = { "app_id": APPID, "customer_otp_val": customer_otp_val, "customer_email_id": this.state.guestFields['guest-email'], "verify_type": "register" };
	
					_axios2.default.post(APIURL + "customer/customer_otp_verification", qs.stringify(postObject)).then(function (response) {
	
						if (response.data.status === "ok") {
	
							var guestType = 0;
	
							if (guestType === 0) {
								//   "customer_confirm_pin": this.state.guestFields['guest-retype-password'],
								var qs = __webpack_require__(3);
								var postObject = {
									"app_id": APPID,
									"type": "web",
									"customer_first_name": _this13.state.guestFields['guest-name'],
									"customer_last_name": "",
									"customer_email": _this13.state.guestFields['guest-email'],
									"customer_pin": _this13.state.guestFields['guest-password'].replace(/\s/g, ''),
									"customer_confirm_pin": _this13.state.guestFields['guest-retype-password'].replace(/\s/g, ''),
									"customer_phone": _this13.state.guestFields['guest-mobile'],
									"site_url": _this13.state.client_site_url + "#/",
									"customer_member_id": APPID === MemberAppID || APPID === MemberAppIDSCC ? _this13.state.guestFields['guest-membershipid'] : '',
									"search_type": APPID === MemberAppID || APPID === MemberAppIDSCC ? 'MemberID' : 'Mobile',
									"accepted_coupons": accepted_coupons
								};
								_axios2.default.post(_constants.API_v4_URL + "guest-checkout/GusestAccount/create", qs.stringify(postObject)).then(function (response) {
	
									$(".gue-comm-error").hide();
									document.getElementById("new-guest").style.display = "block";
									document.getElementById("otp_verification_option").style.display = "none";
									if (response.data.status === "ok") {
	
										_this13.setGuestData(response);
										_this13.closeGuestToggle();
									} else {
										$("#loadIcon").hide();
										if (typeof response.data.form_error !== "undefined") {
											$(".guest-form-error").show();
											$(".guest-form-error").html(response.data.form_error);
											$(".guest-form-error p").addClass("error-msg");
										} else {
											$(".guest-form-error").show();
											$(".guest-form-error-p").html(response.data.message);
										}
									}
									return false;
								}).catch(function (error) {
									console.log(error);
								});
							}
						} else {
							document.getElementById("spn-otp-error").innerHTML = '<span class="spn-error">' + response.data.message + '</span>';
						}
					});
				}
			}
		}, {
			key: 'handleResendotp',
			value: function handleResendotp() {
	
				var qs = __webpack_require__(3);
				var postObject = { "app_id": APPID, "customer_email": this.state.guestFields['guest-email'], "customer_mobile": this.state.guestFields['guest-mobile'], "customer_first_name": this.state.guestFields['guest-name'], "customer_last_name": "" };
	
				document.getElementById("loadIcon").style.display = "block";
	
				_axios2.default.post(_constants.API_v4_URL + "customer/resend_otp", qs.stringify(postObject)).then(function (response) {
					if (response.data.status === "ok") {
						document.getElementById("loadIcon").style.display = "none";
						document.getElementById("resend_otp_button").style.display = "none";
						helper.showInfo(response.data.message);
					} else {
						document.getElementById("loadIcon").style.display = "none";
						document.getElementById("spn-otp-verified-error").innerHTML = '<span class="spn-error">' + response.data.message + '</span>';
						setTimeout(function () {
							document.getElementById("spn-otp-verified-error").innerHTML = '';
						}, 3000);
					}
				});
			}
		}, {
			key: 'backto_login',
			value: function backto_login() {
				//this.setState({ guestFields: { "guest-mobile" : "", "guest-name" : "", "guest-email" : "", "guest-cemail" : ""},check_new_user : 0});
				document.getElementById("new-guest").style.display = "block";
				document.getElementById("otp_verification_option").style.display = "none";
				document.getElementById("resend_otp_button").style.display = "none";
			}
		}, {
			key: 'backToOtpScreen',
			value: function backToOtpScreen() {
				document.getElementById("gust_checkout_form").style.display = "none";
				document.getElementById("otp_verification_option").style.display = "block";
				document.getElementById("resend_otp_button").style.display = "none";
			}
	
			/* login button color */
	
		}, {
			key: 'loginButtonColr',
			value: function loginButtonColr() {
				return APPID === apps.workspace ? "signin-new" : "signin-new sign_btn";
			}
		}, {
			key: 'showGuestSignupForm',
			value: function showGuestSignupForm(type) {
	
				if (type === 1) {
					this.setState({ guestFields: { "guest-mobile": "", "guest-name": "", "guest-email": "", "guest-cemail": "" }, guestName: "" });
					document.getElementById("existing-guest").style.display = "none";
					document.getElementById("new-guest").style.display = "block";
					document.getElementById("forgot-pin").style.display = "none";
					document.getElementById("reset-pin").style.display = "none";
					document.getElementById("otp_verification_option").style.display = "none";
				} else if (type === 3) {
					document.getElementById("existing-guest").style.display = "none";
					document.getElementById("forgot-pin").style.display = "block";
					document.getElementById("reset-pin").style.display = "none";
					document.getElementById("new-guest").style.display = "none";
				} else {
					document.getElementById("existing-guest").style.display = "block";
					document.getElementById("new-guest").style.display = "none";
					document.getElementById("forgot-pin").style.display = "none";
					document.getElementById("reset-pin").style.display = "none";
				}
			}
		}, {
			key: 'hidePassword',
			value: function hidePassword(key) {
				this.setState(_defineProperty({}, key, !this.state[key]));
			}
		}, {
			key: 'hidePasswordOne',
			value: function hidePasswordOne(key) {
				this.setState(_defineProperty({}, key, !this.state[key]));
			}
		}, {
			key: 'hidePasswordLogin',
			value: function hidePasswordLogin(key) {
				this.setState(_defineProperty({}, key, !this.state[key]));
			}
		}, {
			key: 'hidePasswordForgot',
			value: function hidePasswordForgot(key) {
				this.setState(_defineProperty({}, key, !this.state[key]));
			}
		}, {
			key: 'hidePasswordForgotOne',
			value: function hidePasswordForgotOne(key) {
				this.setState(_defineProperty({}, key, !this.state[key]));
			}
		}, {
			key: 'replaceText',
			value: function replaceText(textval) {
	
				var returnText = void 0;
				if (textval) {
					returnText = textval.replace(/\s/g, '');
					returnText = returnText.replace(/_/g, '');
				}
	
				return returnText;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this14 = this;
	
				// alert(this.state.fbId);
				var _props = this.props,
				    fields = _props.fields,
				    onChange = _props.onChange,
				    onValid = _props.onValid,
				    onInvalid = _props.onInvalid,
				    $field = _props.$field,
				    $validation = _props.$validation;
	
				var errMsgEmail = void 0,
				    errMsgPassword = void 0;
				if ($validation.email.error.reason !== undefined) {
					errMsgEmail = $validation.email.show && _react2.default.createElement(
						'span',
						{ className: 'spn-error' },
						$validation.email.error.reason
					);
				}
				if ($validation.password.error.reason !== undefined) {
					errMsgPassword = $validation.password.show && _react2.default.createElement(
						'span',
						{ className: 'spn-error' },
						$validation.password.error.reason
					);
				}
	
				if (this.state.renderLoading === "ok") {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_reactDocumentMeta2.default, meta),
						_react2.default.createElement(
							'div',
							{ id: 'loadIcon', style: { display: 'none', bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto', zIndex: 9999, background: 'rgba(255, 255, 255, 0.8)' } },
							' ',
							_react2.default.createElement('img', { style: { bottom: 0, left: 0, position: 'absolute', right: 0, top: 0, margin: 'auto' }, src: '/img/loader.gif', alt: 'Loading' }),
							' '
						),
						_react2.default.createElement(
							'div',
							{ className: 'background_color' },
							_react2.default.createElement(
								'div',
								{ className: 'container-fluid desktop-container ninja-theme-v2', style: { minHeight: this.state.windowHeight } },
								_react2.default.createElement(Alert, null),
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-12 top-nav inner-top-nav' },
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-3 nav-head pd-l-20' },
											' ',
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: "/" },
												_react2.default.createElement('img', { src: '/img/icons/arrow-right.png', alt: 'left-arrow', className: 'icon-img-small-3' })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-6 nav-head ' },
											_react2.default.createElement(
												'h1',
												{ className: 'main-title' },
												'LOGIN'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-3 nav-head pd-l-20' },
											' ',
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: "/" },
												_react2.default.createElement('img', { src: '/img/icons/shopping-cart.png', alt: 'cart', className: 'icon-img-small-4-inner cart-icon pull-right' })
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'row login-container', id: 'signin-form' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-offset-1 col-xs-10 col-xs-offset-1' },
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: 'col-xs-12' },
												this.showGusetCheckout(),
												this.showAnonymousCheckout(),
												APPID !== "782D2401-5C31-43E9-83CF-B3AB5A394E66" && APPID !== MemberAppID && APPID !== MemberAppIDSCC && _react2.default.createElement(
													'div',
													{ className: 'row row-facebook-login' },
													_react2.default.createElement('div', { id: 'form-error' }),
													_react2.default.createElement(
														'div',
														{ className: 'col-xs-12' },
														_react2.default.createElement(_reactFacebookLogin2.default, {
	
															appId: this.state.fbId,
	
															fields: 'name,email,picture,first_name,last_name,birthday,gender',
															callback: this.responseFacebook,
															scope: 'public_profile,email,user_birthday',
															cssClass: 'btn btn-raised btn-info login-with-facebook',
															redirectUri: config.path.baseUrl + "sign-in",
															icon: 'fa-facebook',
															textButton: '\xA0 Login with Facebook'
														})
													)
												),
												APPID !== MemberAppID && APPID !== MemberAppIDSCC && _react2.default.createElement(
													'div',
													{ className: 'row  login-screen' },
													APPID !== "782D2401-5C31-43E9-83CF-B3AB5A394E66" && _react2.default.createElement(
														'h1',
														null,
														'Sign In'
													),
													_react2.default.createElement(
														'form',
														{ action: true, method: true },
														_react2.default.createElement(
															'div',
															{ className: 'row' },
															_react2.default.createElement(
																'div',
																{ className: ' item-add2' },
																APPID !== "782D2401-5C31-43E9-83CF-B3AB5A394E66" && _react2.default.createElement(
																	'div',
																	null,
																	_react2.default.createElement(
																		'div',
																		{ className: 'form-group label-floating is-empty card-no' },
																		_react2.default.createElement(
																			'div',
																			{ className: 'input-group' },
																			_react2.default.createElement(
																				'label',
																				{ className: 'control-label', htmlFor: 'email' },
																				'Email Address'
																			),
																			_react2.default.createElement('input', Object.assign({ type: 'text', id: 'email', className: 'form-control', value: fields.email }, $field('email', function (e) {
																				return onChange('email', e.target.value);
																			}))),
																			errMsgEmail
																		)
																	),
																	_react2.default.createElement(
																		'div',
																		{ className: 'form-group  label-floating is-empty card-no' },
																		_react2.default.createElement(
																			'div',
																			{ className: 'input-group' },
																			_react2.default.createElement(
																				'label',
																				{ className: 'control-label', htmlFor: 'password' },
																				'Password'
																			),
																			_react2.default.createElement('input', Object.assign({ type: 'password', id: 'password', className: 'form-control', value: fields.password }, $field('password', function (e) {
																				return onChange('password', e.target.value);
																			}))),
																			errMsgPassword
																		)
																	),
																	_react2.default.createElement(
																		_reactRouter.Link,
																		{ className: 'forget-password-link pull-left', to: "/forgot-password" },
																		'Forgot Your Password?'
																	)
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'row' },
																	_react2.default.createElement(
																		'div',
																		{ className: 'col-xs-12 col-sm-8 col-sm-offset-2 text-center font-weight-400' },
																		APPID !== "782D2401-5C31-43E9-83CF-B3AB5A394E66" && _react2.default.createElement(
																			'button',
																			{ type: 'submit', className: this.loginButtonColr(), onClick: function onClick(e) {
																					e.preventDefault();_this14.props.$submit(onValid, onInvalid);
																				} },
																			' GO '
																		),
																		_react2.default.createElement(
																			_reactRouter.Link,
																			{ className: 'signup-link', to: "/sign-up" },
																			'Create Account'
																		)
																	)
																)
															)
														)
													)
												)
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'new-user-reg' },
									_react2.default.createElement(
										'form',
										{ action: true, method: true },
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: ' item-add2' },
												_react2.default.createElement('div', { className: 'space-10' }),
												_react2.default.createElement(
													'p',
													{ className: 'text-center' },
													'Please enter your name and email address to receive receipt '
												),
												_react2.default.createElement(
													'div',
													{ className: 'form-group label-floating is-empty card-no' },
													_react2.default.createElement(
														'div',
														{ className: 'input-group' },
														_react2.default.createElement(
															'label',
															{ className: 'control-label', htmlFor: 'name' },
															'Name'
														),
														_react2.default.createElement('input', { id: 'name', className: 'form-control', type: 'text' })
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'form-group label-floating is-empty card-no' },
													_react2.default.createElement(
														'div',
														{ className: 'input-group' },
														_react2.default.createElement(
															'label',
															{ className: 'control-label', htmlFor: 'emailaddress' },
															'Email Address'
														),
														_react2.default.createElement('input', { id: 'emailaddress', className: 'form-control', type: 'Text' })
													)
												)
											)
										)
									),
									_react2.default.createElement('div', { className: 'space-50' }),
									_react2.default.createElement('div', { className: 'space-10' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal ninja-theme-v2', id: 'GuestCheckout' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ id: 'reset-pin', style: { display: "none" } },
										_react2.default.createElement(
											'div',
											{ className: 'modal-header' },
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
												_react2.default.createElement('img', { src: '/img/icons/close_popup.png', className: 'img-responsive', alt: 'close' })
											),
											_react2.default.createElement(
												'h4',
												{ className: 'modal-title' },
												_react2.default.createElement('img', { src: '/img/icons/user-white.png', alt: 'guest-checkout', className: 'icon-img-guest-checkout' }),
												'Reset pin'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'modal-body' },
											_react2.default.createElement(
												'div',
												{ className: 'guest-checkout-form' },
												_react2.default.createElement(
													'div',
													{ className: 'alert-error guest-reset-error ', style: { display: "none" } },
													_react2.default.createElement('p', { className: 'error-msg guest-reset-error-p' })
												),
												_react2.default.createElement(
													'div',
													{ className: 'alert-success guest-success gue-comm-error', style: { display: this.state.forgotPasswordSuccessMessage ? "block" : "none" } },
													_react2.default.createElement(
														'p',
														{ className: 'success-msg success-msg-p  ' },
														this.state.forgotPasswordSuccessMessage
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'gust_login_form' },
													_react2.default.createElement(
														'div',
														{ className: 'form-group label-floating is-empty card-no is-exist' },
														_react2.default.createElement(
															'div',
															{ className: 'input-group' },
															_react2.default.createElement(
																'label',
																{ className: 'control-label' },
																'OTP'
															),
															_react2.default.createElement('input', { id: 'guest-otp', type: 'password', ref: 'guest-otp', maxLength: '6', name: 'guest-otp', onChange: this.guestresetFormChange.bind(this, "guest-otp"), value: this.state.guestresetFields["guest-otp"], className: 'form-control' })
														)
													),
													_react2.default.createElement(
														'span',
														{ className: 'help-text guest-error' },
														this.state.guestresetErrors["guest-otp"]
													),
													_react2.default.createElement(
														'div',
														{ className: 'image-open-parent' },
														'   ',
														_react2.default.createElement(
															'div',
															{ className: 'form-group label-floating is-empty card-no ' },
															_react2.default.createElement(
																'div',
																{ className: 'input-group' },
																_react2.default.createElement(
																	'label',
																	{ className: 'control-label' },
																	'PIN'
																),
																!this.state.showPasswordForgot && _react2.default.createElement('input', { autoFocus: true, onFocus: function onFocus(e) {
																		var val = e.target.value;e.target.value = '';e.target.value = val;
																	}, id: 'guest-password', maxLength: '6', className: 'form-control', type: 'password', name: 'guest-password', onChange: this.guestresetFormChange.bind(this, "guest-password"), value: this.replaceText(this.state.guestresetFields["guest-password"]) }),
																this.state.showPasswordForgot && _react2.default.createElement(_reactTextMask2.default, { autoFocus: true, onFocus: function onFocus(e) {
																		var val = e.target.value;e.target.value = '';e.target.value = val;
																	},
																	mask: [/[1-9]/, " ", /[1-9]/, " ", /[1-9]/, " ", /[1-9]/, " ", /[1-9]/, " ", /[1-9]/],
																	id: 'guest-password', className: 'form-control maskinput', type: 'text', name: 'guest-password', onChange: this.guestresetFormChange.bind(this, "guest-password"), value: this.replaceText(this.state.guestresetFields["guest-password"])
																})
															)
														),
														_react2.default.createElement('img', { onClick: this.hidePasswordForgot.bind(this, 'showPasswordForgot'), className: 'image-open-child', src: this.state.showPasswordForgot ? "/img/eye-open.png" : "/img/eye-close.png" })
													),
													_react2.default.createElement(
														'span',
														{ className: 'help-text guest-error' },
														this.state.guestresetErrors["guest-password"]
													),
													_react2.default.createElement(
														'div',
														{ className: 'image-open-parent' },
														_react2.default.createElement(
															'div',
															{ className: 'form-group label-floating is-empty card-no' },
															_react2.default.createElement(
																'div',
																{ className: 'input-group' },
																_react2.default.createElement(
																	'label',
																	{ className: 'control-label' },
																	'Confirm PIN'
																),
																!this.state.showPasswordForgotOne && _react2.default.createElement('input', { autoFocus: true, onFocus: function onFocus(e) {
																		var val = e.target.value;e.target.value = '';e.target.value = val;
																	}, maxLength: '6', className: 'form-control', type: 'password', name: 'guest-retype-password', onChange: this.guestresetFormChange.bind(this, "guest-retype-password"), value: this.replaceText(this.state.guestresetFields["guest-retype-password"]) }),
																this.state.showPasswordForgotOne && _react2.default.createElement(_reactTextMask2.default, { autoFocus: true, onFocus: function onFocus(e) {
																		var val = e.target.value;e.target.value = '';e.target.value = val;
																	},
																	mask: [/[1-9]/, " ", /[1-9]/, " ", /[1-9]/, " ", /[1-9]/, " ", /[1-9]/, " ", /[1-9]/],
	
																	id: 'guest-retype-password', className: 'form-control maskinput', type: 'text', name: 'guest-retype-password', onChange: this.guestresetFormChange.bind(this, "guest-retype-password"), value: this.replaceText(this.state.guestresetFields["guest-retype-password"])
	
																}),
																_react2.default.createElement('input', { id: 'guest-type', type: 'hidden', name: 'guest-type', value: this.state.guest_type })
															)
														),
														_react2.default.createElement('img', { onClick: this.hidePasswordForgotOne.bind(this, 'showPasswordForgotOne'), className: 'image-open-child', src: this.state.showPasswordForgotOne ? "/img/eye-open.png" : "/img/eye-close.png" })
													),
													_react2.default.createElement(
														'span',
														{ className: 'help-text guest-error' },
														this.state.guestresetErrors["guest-retype-password"]
													),
													_react2.default.createElement(
														'div',
														{ className: 'form-group' },
														_react2.default.createElement(
															'button',
															{ type: 'button', onClick: this.applyGuestresetValidation.bind(this), className: 'btn btn-raised btn-guest-account ' },
															'Go'
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'form-group forgot-pin' },
														_react2.default.createElement(
															'h4',
															null,
															' ',
															_react2.default.createElement(
																_reactRouter.Link,
																{ className: 'set-password-account anchr-tag guest-account-login ', onClick: this.showGuestSignupForm.bind(this, 2) },
																'Back '
															),
															' '
														)
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ id: 'forgot-pin', style: { display: "none" } },
										_react2.default.createElement(
											'div',
											{ className: 'modal-header' },
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
												_react2.default.createElement('img', { src: '/img/icons/close_popup.png', className: 'img-responsive', alt: 'close' })
											),
											_react2.default.createElement(
												'h4',
												{ className: 'modal-title' },
												_react2.default.createElement('img', { src: '/img/icons/user-white.png', alt: 'guest-checkout', className: 'icon-img-guest-checkout' }),
												'Set A Pin / Forgot Your pin'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'modal-body' },
											_react2.default.createElement(
												'div',
												{ className: 'guest-checkout-form' },
												_react2.default.createElement(
													'div',
													{ className: 'alert-error guest-forgot-error ', style: { display: "none" } },
													_react2.default.createElement('p', { className: 'error-msg guest-forgot-error-p' })
												),
												_react2.default.createElement(
													'div',
													{ className: 'gust_login_form', id: 'gust_login_form' },
													_react2.default.createElement(
														'h4',
														null,
														'If you have previously registered on this site with your mobile number and email.  ',
														_react2.default.createElement('br', null),
														_react2.default.createElement('br', null),
														'Please enter your mobile number to generate a OTP to your email/number. Thereafter you will be able to set yourself a new Pin.'
													),
													_react2.default.createElement(
														'div',
														{ className: 'form-group label-floating is-empty card-no is-exist' },
														_react2.default.createElement(
															'div',
															{ className: 'input-group' },
															_react2.default.createElement(
																'label',
																{ className: 'control-label' },
																'Mobile'
															),
															_react2.default.createElement('input', { id: 'guest-mobile', type: 'text', ref: 'guest-mobile', maxLength: '8', name: 'guest-mobile', onChange: this.guestforgotFormChange.bind(this, "guest-mobile"), value: this.state.guestforgotFields["guest-mobile"], className: 'form-control' })
														)
													),
													_react2.default.createElement(
														'span',
														{ className: 'help-text guest-error' },
														this.state.guestforgotErrors["guest-mobile"]
													),
													_react2.default.createElement(
														'div',
														{ className: 'form-group' },
														_react2.default.createElement(
															'button',
															{ type: 'button', onClick: this.applyGuestforgotValidation.bind(this), className: 'btn btn-raised btn-guest-account ' },
															'Go'
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'form-group forgot-pin' },
														_react2.default.createElement(
															'h4',
															null,
															' ',
															_react2.default.createElement(
																_reactRouter.Link,
																{ className: 'set-password-account anchr-tag guest-account-login ', onClick: this.showGuestSignupForm.bind(this, 2) },
																'Back'
															)
														)
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ id: 'existing-guest', style: { display: "none" } },
										_react2.default.createElement(
											'div',
											{ className: 'modal-header' },
											APPID === MemberAppID || APPID === MemberAppIDSCC ? _react2.default.createElement(
												_reactRouter.Link,
												{ onClick: this.closeGuestCheckoutToggle.bind(this) },
												_react2.default.createElement(
													'button',
													{ type: 'button', className: 'close' },
													_react2.default.createElement('img', { src: '/img/icons/close_popup.png', className: 'img-responsive', alt: 'close' })
												)
											) : _react2.default.createElement(
												'button',
												{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
												_react2.default.createElement('img', { src: '/img/icons/close_popup.png', className: 'img-responsive', alt: 'close' })
											),
											_react2.default.createElement(
												'h4',
												{ className: 'modal-title' },
												_react2.default.createElement('img', { src: '/img/icons/user-white.png', alt: 'guest-checkout', className: 'icon-img-guest-checkout' }),
												APPID === "B401FC82-8E39-4076-838A-55192F765004" || APPID === "6C0280A0-B655-4E0F-A43F-041C189683BA" ? ' Welcome Back, ' + this.state.guestName : 'Welcome Back,  ' + this.state.guestName
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'modal-body' },
											_react2.default.createElement(
												'div',
												{ className: 'guest-checkout-form' },
												_react2.default.createElement(
													'div',
													{ className: 'alert-error guest-login-comm-error guest-login-error ', style: { display: "none" } },
													_react2.default.createElement('p', { className: 'error-msg guest-login-error-p' })
												),
												_react2.default.createElement(
													'div',
													{ className: 'gust_login_form', id: 'gust_login_form' },
													_react2.default.createElement(
														'h4',
														null,
														'Please enter your pin to continue'
													),
													_react2.default.createElement(
														'div',
														{ className: 'image-open-parent' },
														_react2.default.createElement(
															'div',
															{ style: { border: 'none !important' }, className: "form-group label-floating is-empty card-no no_border  mask-contanier" + (this.state.guestLoginFields["guest-password"] !== "" ? " is-focused" : "") },
															_react2.default.createElement(
																'div',
																{ className: 'input-group' },
																_react2.default.createElement(
																	'label',
																	{ className: 'control-label' },
																	'PIN'
																),
																!this.state.showPasswordLogin && _react2.default.createElement('input', { autoFocus: true, onFocus: function onFocus(e) {
																		var val = e.target.value;
																		e.target.value = '';
																		e.target.value = val;
																	}, id: 'guest-password', className: 'form-control', type: 'password', name: 'guest-password', onChange: this.guestLgoinFormChangeCheckBox.bind(this, "guest-password"), value: this.replaceText(this.state.guestLoginFields["guest-password"]) }),
																this.state.showPasswordLogin && _react2.default.createElement(_reactTextMask2.default, { autoFocus: true, onFocus: function onFocus(e) {
																		var val = e.target.value;
																		e.target.value = '';
																		e.target.value = val;
																	},
																	mask: [/[1-9]/, " ", /[1-9]/, " ", /[1-9]/, " ", /[1-9]/, " ", /[1-9]/, " ", /[1-9]/],
																	id: 'guest-password', className: 'form-control maskinput', type: 'text', name: 'guest-password', onChange: this.guestLgoinFormChangeCheckBox.bind(this, "guest-password"), value: this.replaceText(this.state.guestLoginFields["guest-password"])
																})
															)
														),
														_react2.default.createElement('img', { onClick: this.hidePasswordLogin.bind(this, 'showPasswordLogin'), className: 'image-open-child', src: this.state.showPasswordLogin ? "/img/eye-open.png" : "/img/eye-close.png" })
													),
													_react2.default.createElement(
														'span',
														{ className: 'help-text guest-error' },
														this.state.guestLoginErrors["guest-password"]
													),
													_react2.default.createElement(
														'div',
														{ className: 'checkbox_sign_ups' },
														_react2.default.createElement('input', { type: 'checkbox', id: 'keep-signin', name: 'guest-terms', value: '1' }),
														_react2.default.createElement(
															'p',
															null,
															'keep sign in'
														),
														_react2.default.createElement(
															'p',
															null,
															'For security purposes, it\'s important to indicate when you\'re using a public computer to access your account.  Please don\'t use this option'
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'form-group' },
														_react2.default.createElement(
															'button',
															{ type: 'button', onClick: this.applyGuestLoginValidation.bind(this), className: 'btn btn-raised btn-guest-account ' },
															'Go'
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'form-group forgot-pin' },
														_react2.default.createElement(
															'h4',
															null,
															_react2.default.createElement(
																_reactRouter.Link,
																{ className: 'set-password-account anchr-tag guest-account-login ', onClick: this.showGuestSignupForm.bind(this, 3) },
																'Dont Have A Pin? or Forgot Your Pin ?'
															)
														),
														_react2.default.createElement(
															'h4',
															null,
															_react2.default.createElement(
																_reactRouter.Link,
																{ className: 'set-password-account anchr-tag guest-account-login ', onClick: this.showGuestSignupForm.bind(this, 1) },
																'Back'
															)
														)
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ id: 'new-guest' },
										_react2.default.createElement(
											'div',
											{ className: 'modal-header' },
											APPID === MemberAppID || APPID === MemberAppIDSCC ? _react2.default.createElement(
												_reactRouter.Link,
												{ onClick: this.closeGuestCheckoutToggle.bind(this) },
												_react2.default.createElement(
													'button',
													{ type: 'button', className: 'close' },
													_react2.default.createElement('img', { src: '/img/icons/close_popup.png', className: 'img-responsive', alt: 'close' })
												)
											) : _react2.default.createElement(
												'button',
												{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
												_react2.default.createElement('img', { src: '/img/icons/close_popup.png', className: 'img-responsive', alt: 'close' })
											),
											_react2.default.createElement(
												'h4',
												{ className: 'modal-title' },
												_react2.default.createElement('img', { src: '/img/icons/user-white.png', alt: 'guest-checkout', className: 'icon-img-guest-checkout' }),
												APPID === "B401FC82-8E39-4076-838A-55192F765004" || APPID === "6C0280A0-B655-4E0F-A43F-041C189683BA" ? 'Express Checkout Signup' : 'Express Checkout Signup'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'modal-body' },
											_react2.default.createElement(
												'div',
												{ className: 'guest-checkout-form' },
												_react2.default.createElement(
													'div',
													{ className: 'alert-success guest-success gue-comm-error', style: { display: "none" } },
													_react2.default.createElement(
														'p',
														{ className: 'success-msg success-msg-p  ' },
														' Guest account created successfully'
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'alert-error guest-form-error gue-comm-error', style: { display: "none" } },
													_react2.default.createElement('p', { className: 'error-msg guest-form-error-p' })
												),
												_react2.default.createElement('div', { id: 'otp_error_msg' }),
												_react2.default.createElement(
													'div',
													{ className: 'gust_checkout_form', id: 'gust_checkout_form' },
													_react2.default.createElement(
														'form',
														{ action: true, method: true },
														(APPID === MemberAppID || APPID === MemberAppIDSCC) && _react2.default.createElement(
															'div',
															null,
															_react2.default.createElement(
																'div',
																{ className: 'form-group label-floating is-empty card-no' },
																_react2.default.createElement(
																	'div',
																	{ className: 'input-group' },
																	_react2.default.createElement(
																		'label',
																		{ className: 'control-label' },
																		'Membership #'
																	),
																	_react2.default.createElement('input', { id: 'guest-membershipid', type: 'text', ref: 'guest-membershipid', name: 'guest-membershipid', onChange: this.guestFormChange.bind(this, "guest-membershipid"), value: this.state.guestFields["guest-membershipid"], className: 'form-control' })
																)
															),
															_react2.default.createElement(
																'span',
																{ className: 'help-text guest-error' },
																this.state.guestErrors["guest-membershipid"]
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'form-group label-floating is-empty card-no is-exist' },
															_react2.default.createElement(
																'div',
																{ className: 'input-group' },
																_react2.default.createElement(
																	'label',
																	{ className: 'control-label' },
																	'Mobile'
																),
																_react2.default.createElement('input', { id: 'guest-mobile', type: 'text', ref: 'guest-mobile', maxLength: '8', name: 'guest-mobile', onChange: this.guestFormChange.bind(this, "guest-mobile"), value: this.state.guestFields["guest-mobile"], className: 'form-control' })
															)
														),
														_react2.default.createElement(
															'span',
															{ className: 'help-text' },
															'(Used to contact you regarding your order)'
														),
														_react2.default.createElement(
															'span',
															{ className: 'help-text guest-error' },
															this.state.guestErrors["guest-mobile"]
														),
														_react2.default.createElement(
															'div',
															{ className: 'form-group label-floating is-empty card-no is-exist' },
															_react2.default.createElement(
																'div',
																{ className: 'input-group' },
																_react2.default.createElement(
																	'label',
																	{ className: 'control-label' },
																	'Name'
																),
																_react2.default.createElement('input', { id: 'guest-name', name: 'guest-name', onChange: this.guestFormChange.bind(this, "guest-name"), value: this.state.check_new_user === 0 ? this.state.guestFields["guest-name"] : "", className: 'form-control', type: 'text', maxLength: '20' })
															)
														),
														_react2.default.createElement(
															'span',
															{ className: 'help-text guest-error' },
															this.state.guestErrors["guest-name"]
														),
														_react2.default.createElement(
															'div',
															{ className: 'form-group label-floating is-empty card-no is-exist' },
															_react2.default.createElement(
																'div',
																{ className: 'input-group' },
																_react2.default.createElement(
																	'label',
																	{ className: 'control-label' },
																	'Email'
																),
																_react2.default.createElement('input', { id: 'guest-email', className: 'form-control', type: 'text', name: 'guest-email', onChange: this.guestFormChange.bind(this, "guest-email"), value: this.state.check_new_user === 0 ? this.state.guestFields["guest-email"] : "" })
															)
														),
														_react2.default.createElement(
															'span',
															{ className: 'help-text' },
															'(Used to send you a receipt of your order)'
														),
														_react2.default.createElement(
															'span',
															{ className: 'help-text guest-error' },
															this.state.guestErrors["guest-email"]
														),
														_react2.default.createElement(
															'div',
															{ className: 'image-open-parent ' },
															' ',
															_react2.default.createElement(
																'div',
																{ className: 'form-group label-floating is-empty card-no ' },
																_react2.default.createElement(
																	'div',
																	{ className: 'input-group' },
																	_react2.default.createElement(
																		'label',
																		{ className: 'control-label' },
																		'PIN'
																	),
																	!this.state.showPassword && _react2.default.createElement('input', { id: 'guest-password', maxLength: '6', className: 'form-control', type: 'password', name: 'guest-password', onChange: this.guestFormChange.bind(this, "guest-password"), autoFocus: true, value: this.replaceText(this.state.guestFields["guest-password"]), onFocus: function onFocus(e) {
																			var val = e.target.value;
																			e.target.value = '';
																			e.target.value = val;
																		} }),
																	this.state.showPassword && _react2.default.createElement(_reactTextMask2.default, {
																		mask: [/[1-9]/, " ", /[1-9]/, " ", /[1-9]/, " ", /[1-9]/, " ", /[1-9]/, " ", /[1-9]/],
																		id: 'guest-password', autoFocus: true, onFocus: function onFocus(e) {
																			var val = e.target.value;
																			e.target.value = '';
																			e.target.value = val;
																		}, style: { fontSize: "25px" }, className: 'form-control maskinput', type: 'text', name: 'guest-password', onChange: this.guestFormChange.bind(this, "guest-password"), value: this.replaceText(this.state.guestFields["guest-password"])
																	})
																)
															),
															_react2.default.createElement('img', { onClick: this.hidePassword.bind(this, 'showPassword'), className: 'image-open-child', src: this.state.showPassword ? "/img/eye-open.png" : "/img/eye-close.png" }),
															'  '
														),
														_react2.default.createElement(
															'span',
															{ className: 'help-text guest-error' },
															this.state.guestErrors["guest-password"]
														),
														_react2.default.createElement(
															'div',
															{ className: 'image-open-parent ' },
															'  ',
															_react2.default.createElement(
																'div',
																{ className: 'form-group label-floating is-empty card-no' },
																_react2.default.createElement(
																	'div',
																	{ className: 'input-group' },
																	_react2.default.createElement(
																		'label',
																		{ className: 'control-label' },
																		'Confirm PIN'
																	),
																	!this.state.showPasswordOne && _react2.default.createElement('input', { autoFocus: true, onFocus: function onFocus(e) {
																			var val = e.target.value;
																			e.target.value = '';
																			e.target.value = val;
																		}, id: 'guest-retype-password', maxLength: '6', className: 'form-control', type: 'password', name: 'guest-password', onChange: this.guestFormChange.bind(this, "guest-retype-password"), value: this.replaceText(this.state.guestFields["guest-retype-password"]) }),
																	this.state.showPasswordOne && _react2.default.createElement(_reactTextMask2.default, { autoFocus: true, onFocus: function onFocus(e) {
																			var val = e.target.value;
																			e.target.value = '';
																			e.target.value = val;
																		},
																		mask: [/[1-9]/, " ", /[1-9]/, " ", /[1-9]/, " ", /[1-9]/, " ", /[1-9]/, " ", /[1-9]/],
																		id: 'guest-retype-password', className: 'form-control maskinput', type: 'text', name: 'guest-retype-password', onChange: this.guestFormChange.bind(this, "guest-retype-password"), value: this.replaceText(this.state.guestFields["guest-retype-password"])
																	}),
																	_react2.default.createElement('input', { id: 'guest-type', type: 'hidden', name: 'guest-type', value: this.state.guest_type })
																)
															),
															_react2.default.createElement('img', { onClick: this.hidePasswordOne.bind(this, 'showPasswordOne'), className: 'image-open-child', src: this.state.showPasswordOne ? "/img/eye-open.png" : "/img/eye-close.png" })
														),
														_react2.default.createElement(
															'span',
															{ className: 'help-text guest-error' },
															this.state.guestErrors["guest-retype-password"]
														),
														(APPID === "2AE048E7-2D84-42BE-9BB5-22016FC4DFBC" || APPID === "44275190-B355-4486-8083-EE1C63607916" || APPID === "F34559CA-596A-4F2E-8547-17B2AEBB3326") && _react2.default.createElement(
															'div',
															{ className: 'checkbox_sign_ups' },
															_react2.default.createElement('input', { type: 'checkbox', id: 'guest-accepted-alcohol', name: 'guest-accepted-alcohol', onChange: this.guestFormChangeCheckBox.bind(this, "guest-accepted-alcohol") }),
															console.log(this.state.guestFields),
															_react2.default.createElement(
																'p',
																null,
																'You agree that you are of legal age to purchase and consume alcohol in the locale in which the alcohol is delivered and acknowledge and agree to provide valid government-issued identification upon delivery'
															),
															this.state.guestErrors["guest-accepted-alcohol"] !== "" && _typeof(this.state.guestErrors["guest-accepted-alcohol"]) !== undefined && typeof this.state.guestErrors["guest-accepted-alcohol"] !== "undefined" && _react2.default.createElement(
																'span',
																{ className: 'help-text guest-error', style: { marginLeft: '0px' } },
																this.state.guestErrors["guest-accepted-alcohol"]
															)
														),
														APPID !== "B401FC82-8E39-4076-838A-55192F765004" && APPID !== "6C0280A0-B655-4E0F-A43F-041C189683BA" && _react2.default.createElement(
															'div',
															null,
															_react2.default.createElement(
																'div',
																{ className: 'checkbox_sign_ups' },
																_react2.default.createElement('input', { type: 'checkbox', id: 'guest-terms', name: 'guest-terms', value: '1', defaultChecked: true, disabled: 'disabled', onChange: this.guestFormChangeCheckBox.bind(this, "guest-terms") }),
																_react2.default.createElement(
																	'p',
																	null,
																	'I agree to the Privacy Policy and Terms of Service of ',
																	_reactCookie2.default.load('client_company_name')
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'checkbox_sign_ups' },
																_react2.default.createElement('input', { type: 'checkbox', id: 'guest-accepted-coupons', name: 'guest-accepted-coupons', onChange: this.guestFormChangeCheckBox.bind(this, "guest-accepted-coupons"), checked: this.state.guestFields["guest-accepted-coupons"] === "1" || this.state.guestFields["guest-accepted-coupons"] === 1 ? true : false, disabled: this.state.accepted_coupons === "1" ? true : false }),
																_react2.default.createElement(
																	'p',
																	null,
																	'I consent to receive coupons and promotions news from ',
																	_reactCookie2.default.load('client_company_name'),
																	', its franchisees and affiliates, and understand and agree that my information will be for the above. '
																),
																_react2.default.createElement('div', { id: 'spn-accept-error' })
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-xs-12 col-sm-12 create-account-block' },
														_react2.default.createElement(
															'p',
															null,
															'If you would like update your email address, please contact the outlet.'
														),
														this.state.backtoGuestform === true && _react2.default.createElement(
															_reactRouter.Link,
															{ className: 'set-password-account anchr-tag disable-guest ', onClick: this.backToOtpScreen.bind(this) },
															'Back to OTP Verification'
														),
														_react2.default.createElement(
															'button',
															{ type: 'button', onClick: this.applyValidation.bind(this), className: 'btn btn-raised btn-guest-account ' },
															'Proceed'
														)
													)
												)
											)
										),
										_react2.default.createElement('div', { className: 'modal-footer' })
									),
									_react2.default.createElement(
										'div',
										{ id: 'otp_verification_option', style: { display: "none" } },
										_react2.default.createElement(
											'div',
											{ className: 'modal-header' },
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
												_react2.default.createElement('img', { src: '/img/icons/close_popup.png', className: 'img-responsive', alt: 'close' })
											),
											_react2.default.createElement(
												'h4',
												{ className: 'modal-title' },
												_react2.default.createElement('img', { src: '/img/icons/user-white.png', alt: 'guest-checkout', className: 'icon-img-guest-checkout' }),
												'OTP Verification'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'modal-body' },
											_react2.default.createElement(
												'div',
												{ className: 'guest-checkout-form' },
												_react2.default.createElement(
													'div',
													{ className: 'space-20' },
													_react2.default.createElement(
														'form',
														{ className: 'customer_otp', id: 'customer_otp', onSubmit: function onSubmit(e) {
																_this14.submit_otp_verification(_this14);e.preventDefault();
															} },
														_react2.default.createElement('div', { id: 'spn-otp-verified-error' }),
														_react2.default.createElement(
															'div',
															{ className: 'form-group label-floating card-no input-form-group' },
															_react2.default.createElement(
																'div',
																{ className: 'input-group' },
																_react2.default.createElement(
																	'label',
																	{ className: 'control-label' },
																	'Enter your OTP',
																	_react2.default.createElement(
																		'span',
																		null,
																		'*'
																	)
																),
																_react2.default.createElement('input', { type: 'text', name: 'customer_otp_val', className: 'form-control', value: this.state.customer_otp_val, onChange: this.handleChangeTxt.bind(this, 'customer_otp_val') }),
																_react2.default.createElement('div', { id: 'spn-otp-error' })
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'text-center ' },
															_react2.default.createElement(
																'button',
																{ type: 'button', className: 'btn btn-raised btn-info full-width-btn-2 text-uppercase', onClick: this.submit_otp_verification.bind(this) },
																'Submit'
															)
														)
													),
													_react2.default.createElement(
														'h4',
														null,
														' ',
														_react2.default.createElement(
															'a',
															{ className: 'resent_otp_gust', style: { cursor: "pointer" }, id: 'resend_otp_button', onClick: this.handleResendotp.bind(this) },
															_react2.default.createElement(
																'b',
																null,
																'Resent OTP'
															)
														),
														_react2.default.createElement('br', null),
														'  '
													),
													_react2.default.createElement(
														'h4',
														null,
														'  ',
														_react2.default.createElement(
															'a',
															{ className: 'back_to_register_gust',
																onClick: this.showGuestSignupForm.bind(this, 1) },
															_react2.default.createElement(
																'b',
																null,
																'Back'
															)
														)
													)
												)
											)
										)
									)
								)
							)
						)
					);
				} else {
	
					return _react2.default.createElement(
						'div',
						{ className: 'container-fluid desktop-container position-rel' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(Loading, null)
						)
					);
				}
			}
		}]);
	
		return Form;
	}(_react2.default.Component);
	
	Form.contextTypes = {
		router: _react2.default.PropTypes.object.isRequired
	};
	
	Form = (0, _reactCustomValidation.validated)(validationConfig)(Form);
	
	exports.default = Otpsignin;

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var config = __webpack_require__(7);
	var APPID = config.ids.appId;
	var APIURL = config.path.apiUrl;
	
	var lang = __webpack_require__(12);
	//const nl2br = require('react-nl2br');
	var HtmlToReactParser = __webpack_require__(21).Parser;
	var htmlToReactParserTo = new HtmlToReactParser();
	var Loading = __webpack_require__(17);
	var helper = __webpack_require__(13);
	
	var Pages = function (_React$Component) {
	  _inherits(Pages, _React$Component);
	
	  function Pages(props) {
	    _classCallCheck(this, Pages);
	
	    var _this = _possibleConstructorReturn(this, (Pages.__proto__ || Object.getPrototypeOf(Pages)).call(this, props));
	
	    _this.state = { pageTitle: '', pageDesc: '', status: 'Loading', windowHeightNormal: 0, windowHeight: 0 };
	    /*add class */
	    helper.addBodyClass();
	    return _this;
	  }
	
	  _createClass(Pages, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var site_maintenance_verify = _reactCookie2.default.load("client_site_maintenance_verify") !== '' && _reactCookie2.default.load("client_site_maintenance_verify") !== 'undefined' && _reactCookie2.default.load("client_site_maintenance_verify") !== undefined ? _reactCookie2.default.load("client_site_maintenance_verify") : '';
	
	      var site_maintenance_popup_open = _reactCookie2.default.load("site_maintenance_popup_open") !== '' && _reactCookie2.default.load("site_maintenance_popup_open") !== 'undefined' && _reactCookie2.default.load("site_maintenance_popup_open") !== undefined ? _reactCookie2.default.load("site_maintenance_popup_open") : '';
	
	      if (site_maintenance_popup_open === "1" && (site_maintenance_verify === '' || site_maintenance_verify === '0')) {
	        _reactRouter.hashHistory.push("/");
	        return;
	      }
	
	      var pageSlug = this.props.params.pageSlug;
	      _axios2.default.get(APIURL + 'cms/page?status=A&app_id=' + APPID + '&page_slug=' + pageSlug).then(function (res) {
	        if (res.data.status === "ok") {
	          _this2.setState({ pageTitle: res.data.result_set[0].cmspage_title, status: 'ok' });
	          _this2.setState({ pageDesc: res.data.result_set[0].cmspage_description });
	        } else if (res.data.status === "error") {
	          _this2.setState({ status: 'error' });
	        }
	      });
	
	      var windowHeight = window.innerHeight;
	      this.setState({ 'windowHeight': windowHeight - 45 + 'px' });
	      this.setState({ 'windowHeightNormal': windowHeight + 'px' });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _withTracker.loadAnalytics)();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      if (this.state.status === "ok") {
	        return _react2.default.createElement(
	          'div',
	          { className: 'container-fluid desktop-container',
	            style: { minHeight: this.state.windowHeightNormal } },
	          ' ',
	          _react2.default.createElement(_reactDocumentMeta2.default, {
	            title: this.state.pageTitle + lang.site_title_with_separator,
	            description: this.state.pageTitle,
	            meta: {
	              name: {
	                keywords: this.state.pageTitle
	              }
	            }
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 main-title-bar' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: "/" },
	                ' ',
	                _react2.default.createElement('img', { src: '/img/left-arrow.png', className: 'pull-left icon-img-small', alt: 'left-arrow' }),
	                ' '
	              ),
	              _react2.default.createElement(
	                'h3',
	                { className: 'top-title main-title padding-right-20 text-uppercase' },
	                this.state.pageTitle
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement('div', { className: 'space-10 bg-gray' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'white-outer center-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-10 div-center' },
	              _react2.default.createElement('div', { className: 'space-5' }),
	              _react2.default.createElement(
	                'p',
	                { className: 'text-left font-bold font-size-18' },
	                this.state.pageTitle
	              ),
	              htmlToReactParserTo.parse(this.state.pageDesc)
	            ),
	            _react2.default.createElement('div', { className: 'clearfix' })
	          ),
	          _react2.default.createElement('div', { className: 'space-30' })
	        );
	      } else if (this.state.status === 'error') {
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'container-fluid desktop-container', style: { minHeight: this.state.windowHeightNormal } },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 main-title-bar' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: "/" },
	                ' ',
	                _react2.default.createElement('img', { src: '/img/left-arrow.png', className: 'pull-left icon-img-small', alt: 'left-arrow' }),
	                ' '
	              ),
	              _react2.default.createElement(
	                'h3',
	                { className: 'top-title main-title padding-right-20 text-uppercase' },
	                'Page content not found'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement('div', { className: 'space-10 bg-gray' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'white-outer center-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-10 div-center' },
	              _react2.default.createElement('div', { className: 'space-5' }),
	              _react2.default.createElement(
	                'p',
	                { style: { textAlign: 'center' } },
	                'Page content not found'
	              ),
	              _react2.default.createElement('div', { className: 'space-5' })
	            ),
	            _react2.default.createElement('div', { className: 'clearfix' })
	          ),
	          _react2.default.createElement('div', { className: 'space-30' }),
	          _react2.default.createElement('div', { className: 'space-30' }),
	          _react2.default.createElement('div', { className: 'space-30' }),
	          _react2.default.createElement('div', { className: 'space-30' }),
	          _react2.default.createElement('div', { className: 'space-30' }),
	          ' ',
	          _react2.default.createElement('div', { className: 'space-30' }),
	          ' ',
	          _react2.default.createElement('div', { className: 'space-30' }),
	          ' ',
	          _react2.default.createElement('div', { className: 'space-30' })
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'container-fluid desktop-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(Loading, null)
	          )
	        );
	      }
	    }
	  }]);
	
	  return Pages;
	}(_react2.default.Component);
	
	exports.default = Pages;

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _withTracker = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import {  Link  } from 'react-router';
	
	
	var Payment = function (_React$Component) {
	    _inherits(Payment, _React$Component);
	
	    function Payment(props) {
	        _classCallCheck(this, Payment);
	
	        var _this = _possibleConstructorReturn(this, (Payment.__proto__ || Object.getPrototypeOf(Payment)).call(this, props));
	
	        if (_reactCookie2.default.load('orderPaymentMode') !== "STRIPE") {
	            window.location = "/";
	        }
	        return _this;
	    }
	
	    /* check stripr payment */
	
	
	    _createClass(Payment, [{
	        key: 'placeOrder',
	        value: function placeOrder() {
	            console.log('test entr');
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            (0, _withTracker.loadAnalytics)();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container-fluid desktop-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 main-title-bar' },
	                            ' ',
	                            _react2.default.createElement(
	                                'a',
	                                { href: '11.php' },
	                                _react2.default.createElement('img', { src: '/img/left-arrow.png', className: 'icon-img-small  pull-left', alt: 'left-arrow' })
	                            ),
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'top-title main-title' },
	                                'PAYMENT'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row  ' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'payment-meth' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: ' ' },
	                                _react2.default.createElement('div', { className: 'space-30' }),
	                                _react2.default.createElement('img', { src: '/img/emony.png', className: 'img-responsive', alt: 'payment-methods' })
	                            )
	                        ),
	                        _react2.default.createElement('div', { className: 'space-10' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row ' },
	                        _react2.default.createElement(
	                            'form',
	                            { action: '#', id: 'payment-info' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'payment-form' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: '' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group label-floating is-empty card-no' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'input-group' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'control-label', htmlFor: 'name' },
	                                                'Name'
	                                            ),
	                                            _react2.default.createElement('input', { type: 'text', id: 'name', className: 'form-control' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group label-floating is-empty card-no' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'input-group' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: 'control-label', htmlFor: 'card' },
	                                                'Card Number'
	                                            ),
	                                            _react2.default.createElement('input', { type: 'text', id: 'card', className: 'form-control' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-sm-6 ' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'input-group font_bold' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        { className: 'black' },
	                                                        'Expiration Date'
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-sm-3 col-xs-6 card-ex  ' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group label-floating is-empty card-month card-no' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'input-group' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        { className: 'control-label', htmlFor: 'card' },
	                                                        'MM'
	                                                    ),
	                                                    _react2.default.createElement('input', { type: 'text', id: 'card', className: 'form-control' })
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-sm-3 col-xs-6 ' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'form-group label-floating is-empty card-year card-no' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'input-group' },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        { className: 'control-label', htmlFor: 'card' },
	                                                        'YY'
	                                                    ),
	                                                    _react2.default.createElement('input', { type: 'text', id: 'card', className: 'form-control' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group label-floating is-empty card-no' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'input-group' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'control-label', htmlFor: 'card' },
	                                            'CVV'
	                                        ),
	                                        _react2.default.createElement('input', { type: 'text', id: 'card', className: 'form-control' })
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: 'clearfix' }),
	                    _react2.default.createElement('div', { className: 'space-50 hidden-xs' }),
	                    _react2.default.createElement('div', { className: 'space-50 ' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'col-lg-12 continue-but desktop-container container-fluid bg-red', onClick: this.placeOrder.bind(this) },
	                            'PLACE ORDER'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Payment;
	}(_react2.default.Component);
	
	exports.default = Payment;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var PaymentCheckout = function (_Component) {
	  _inherits(PaymentCheckout, _Component);
	
	  function PaymentCheckout(props) {
	    _classCallCheck(this, PaymentCheckout);
	
	    var _this = _possibleConstructorReturn(this, (PaymentCheckout.__proto__ || Object.getPrototypeOf(PaymentCheckout)).call(this, props));
	
	    _this.state = {
	      holdername: '',
	      cardNumber: '',
	      expiration_month: '',
	      expiration_year: '',
	      security_code: '',
	      processOmise: false,
	      globalSettings: []
	    };
	    return _this;
	  }
	
	  _createClass(PaymentCheckout, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var script = document.createElement('script');
	      script.src = 'https://cdn.omise.co/omise.js';
	      script.async = true;
	      document.body.appendChild(script);
	      this.props.sateValChange('productlist', 'a');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(PropsDt) {
	      if (this.state.processOmise !== PropsDt.checkoutState.processOmise && PropsDt.processOmise !== false) {
	        if (PropsDt.checkoutState.processOmise === true) {
	          var checkoutState = PropsDt.checkoutState;
	          this.setState({
	            holdername: checkoutState.holdername,
	            cardNumber: checkoutState.cardNumber,
	            expiration_month: checkoutState.expiration_month,
	            expiration_year: checkoutState.expiration_year,
	            security_code: checkoutState.security_code,
	            globalSettings: PropsDt.checkoutState.settings
	          }, function () {
	            this.getOmiseToken();
	          });
	        }
	        console.log(PropsDt, 'PropsDt');
	      }
	    }
	  }, {
	    key: 'getOmiseToken',
	    value: function getOmiseToken() {
	      try {
	        Omise.setPublicKey(this.state.globalSettings.omise_public_key);
	        var current = this;
	        var card = {
	          name: this.state.holdername,
	          number: this.state.cardNumber,
	          expiration_month: this.state.expiration_month,
	          expiration_year: this.state.expiration_year,
	          security_code: this.state.security_code,
	          livemode: false
	        };
	        Omise.createToken('card', card, function (statusCode, response) {
	          current.props.sateValChange('processOmise', false);
	          //hideLoader('omise-pay-btn', 'class')
	          if (statusCode === 200) {
	            if (response.object == 'error' || !response.card.security_code_check) {
	              var msgArr = Array();
	              msgArr['message'] = response.object == 'error' ? response.message : 'Invalid card details.';
	              current.props.sateValChange('omiseTokenError', msgArr);
	            } else {
	              current.props.sateValChange('omiseTokensucess', response);
	              /*current.onProcessOmiseToken(response);*/
	            }
	          } else {
	            var msgArr = Array();
	            msgArr['message'] = response.message !== '' ? response.message : 'Sorry!. Error from omise.';
	            current.props.sateValChange('omiseTokenError', msgArr);
	          }
	        });
	      } catch (e) {}
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', { style: { display: 'none' } });
	    }
	  }]);
	
	  return PaymentCheckout;
	}(_react.Component);
	
	exports.default = PaymentCheckout;

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _productsNoImage = __webpack_require__(957);
	
	var _productsNoImage2 = _interopRequireDefault(_productsNoImage);
	
	var _reactStripeCheckout = __webpack_require__(186);
	
	var _reactStripeCheckout2 = _interopRequireDefault(_reactStripeCheckout);
	
	var _loader = __webpack_require__(956);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _tick = __webpack_require__(958);
	
	var _tick2 = _interopRequireDefault(_tick);
	
	var _PaymentCheckout = __webpack_require__(521);
	
	var _PaymentCheckout2 = _interopRequireDefault(_PaymentCheckout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Link } from 'react-router-dom'
	// import { bindActionCreators } from 'redux'
	// import { connect } from 'react-redux'
	// import { getblocks, getOutlets } from '../../stores/cms'
	// import { getSetings } from '../../stores/settings'
	
	
	var config = __webpack_require__(7);
	var helper = __webpack_require__(13);
	
	// import Header from '../layout/header'
	// import Footer from '../layout/footer'
	// import {
	//   API_URL,
	//   APP_ID,
	//   DINEIN_ID,
	//   DELIVERY_ID,
	//   stripeCompany,
	//   stripeImage,
	//   stripeCurrency,
	//   stripeReference
	// } from '../../config/constans'
	// import { showLoader, hideLoader } from '../../config/SettingHelper'
	// import { addressFormat, showInfo } from '../../config/supporters'
	// import { history } from '../../store'
	var stripeCurrency = config.stripe.stripeCurrency;
	var stripeImage = config.stripe.stripeImage;
	var stripeReference = config.stripe.stripeReference;
	var DINEIN_ID = config.ids.dineinId;
	var stripeCompany = config.stripe.stripeCompany;
	var API_URL = config.path.apiUrl;
	var API_URL_PRO = config.path.apiUrlPro;
	
	// const APIURLv2 = config.path.apiUrlv2;
	// const currency = config.ids.currency;
	var APP_ID = config.ids.appId;
	// var showLoader = helper.showLoader();
	// var hideLoader = helper.hideLoader();
	// const Loading = require('./loading');
	// const Alert = require('./alert');
	// var strp = require('strp');
	
	var stripeEmail = config.stripe.stripeEmail;
	// import cookie from 'react-cookie';
	
	var _ = __webpack_require__(30);
	
	var HtmlToReactParser = __webpack_require__(21).Parser;
	var htmlToReactParser = new HtmlToReactParser();
	var base64 = __webpack_require__(549);
	var $ = window.$;
	var qs = __webpack_require__(3);
	
	var Paymentrequest = function (_React$Component) {
	  _inherits(Paymentrequest, _React$Component);
	
	  // class Paymentrequest extends Component {
	  function Paymentrequest(props) {
	    _classCallCheck(this, Paymentrequest);
	
	    var _this = _possibleConstructorReturn(this, (Paymentrequest.__proto__ || Object.getPrototypeOf(Paymentrequest)).call(this, props));
	
	    _this.onToken = function (token) {
	      /*  load process html */
	      var avText = _this.state.cartData.order_availability_id === DINEIN_ID ? 'Dine In' : 'Self Collection';
	      var orderDate = (0, _moment2.default)(_this.state.cartData.order_date).format('MM/DD/YYYY HH:mm A');
	      var payRefID = _this.state.payment_ref_id;
	      var postObject = {};
	      postObject = {
	        app_id: APP_ID,
	        token: token.id,
	        stripe_envir: _this.state.settings.client_stripe_mode === 1 ? 'live' : 'dev',
	        stripe_key: _this.state.settings.stripe_public_key,
	        customer_id: '1',
	        paid_amount: _this.state.requestData.ap_request_amount,
	        outlet_name: 'springcourt.com.sg|Web|' + orderDate + '|' + avText + '|' + _this.state.cartData.order_local_no + '|' + payRefID,
	        payment_reference: stripeReference
	
	        //console.log(postObject); return false;
	      };_axios2.default.post(API_URL_PRO + 'payment/stripeTokenPay', qs.stringify(postObject)).then(function (res) {
	        if (res.data.status === 'ok') {
	          // var captureID = res.data.result_set.payment_reference_1
	          var paymentSuccess = {};
	          paymentSuccess = {
	            app_id: APP_ID,
	            paid_amount: _this.state.requestData.ap_request_amount,
	            order_id: _this.state.order_id,
	            order_primary_id: _this.state.payment_id,
	            order_local_payment_reference: payRefID
	
	            //console.log(paymentSuccess); return false;
	
	          };_axios2.default.post(API_URL + 'advancepayments/recordPayment', qs.stringify(paymentSuccess)).then(function (res) {
	            if (res.data.status === "ok") {
	              helper.showInfo('your payment processed successfully');
	              _reactRouter.hashHistory.push('/');
	            } else {
	              helper.showInfo(res.data.message);
	              return false;
	            }
	          });
	        } else if (res.data.status === 'error') {
	          helper.showInfo('error');
	          return false;
	        }
	      }).catch(function (error) {
	        helper.showInfo('error');
	        return false;
	      });
	    };
	
	    _this.handleChangeTxt = function (item, event) {
	      var re = /^[0-9 \b]+$/;
	      if (item === 'cardNumber') {
	        if (event.target.value === '' || re.test(event.target.value)) {
	          var cardnumber = _this.space(event.target.value);
	          var cardnumberLenght = cardnumber.length;
	          if (cardnumberLenght <= 19) {
	            _this.setState(_defineProperty({}, item, cardnumber));
	            _this.cardValidation(cardnumber);
	          }
	        }
	      } else if (item === 'expiration_month' || item === 'expiration_year' || item === 'security_code') {
	        if (event.target.value === '' || re.test(event.target.value)) {
	          _this.setState(_defineProperty({}, item, event.target.value));
	        }
	      } else {
	        _this.setState(_defineProperty({}, item, event.target.value));
	      }
	
	      _this.setState({
	        omisenameerror: '',
	        omisecardrror: '',
	        omisemontherror: '',
	        omiseyearerror: '',
	        omisecodeerror: ''
	      });
	    };
	
	    _this.sateValChange = function (field, value) {
	      if (field === 'processOmise') {
	        _this.setState({ processOmise: value });
	      } else if (field === 'omiseTokenError' && value !== '') {
	        helper.hideLoader('omise-pay-btn', 'class');
	        _this.showOmiselert(value);
	      } else if (field === 'omiseTokensucess' && value !== '') {
	        _this.setState({
	          omise_tokken_response: value,
	          omise_tokken_card_id: value.card.id,
	          omise_tokken_id: value.id
	        }, function () {
	          _this.onProcessOmiseToken(value);
	        });
	      }
	    };
	
	    _this.onProcessOmiseToken = function (token) {
	      if (_this.state.requestData.ap_request_amount > 0) {
	        var payAmount = parseFloat(_this.state.requestData.ap_request_amount).toFixed(2);
	
	        var requestType = 'Springcourt-' + _this.state.orderOutletId + '-' + _this.state.customerId;
	        var postObject = {};
	        postObject = {
	          app_id: APP_ID,
	          token: token.id,
	          customer_id: _this.state.customerId,
	          outlet_id: _this.state.orderOutletId,
	          paid_amount: payAmount,
	          request_type: requestType,
	          outlet_name: typeof _this.state.orderOutletName === 'undefined' ? _this.state.orderOutletName : ''
	        };
	        _axios2.default.post(API_URL + 'paymentv1/authOmise', qs.stringify(postObject)).then(function (res) {
	          if (res.data.status === 'ok') {
	            var captureID = res.data.result_set.payment_reference_1;
	            var omiseLogId = res.data.result_set.log_id;
	            _this.setState({ omise_log_id: omiseLogId }, function () {
	              this.captureOmiseAmount(captureID, this.state.payment_id, this.state.order_local_no);
	            }.bind(_this));
	          } else if (res.data.status === 'error') {
	            helper.hideLoader('omise-pay-btn', 'class');
	            if (res.data.message === 'token was already used') {
	              _this.omise_search_history();
	            } else {
	              var errerTxt = res.data.message !== '' ? res.data.message : 'Error code: 1001 Oops! Something went wrong! Please try again.';
	              _this.paymentFail('Error', errerTxt);
	              return false;
	            }
	          } else {
	            var currents = _this;
	            setTimeout(function () {
	              currents.omise_search_history();
	            }, 2000);
	          }
	        }).catch(function (error) {
	          var currentcatch = _this;
	          setTimeout(function () {
	            currentcatch.omise_search_history();
	          }, 2000);
	        });
	      }
	    };
	
	    _this.retrieve_charge_details = function (captureID, orderPrimaryId, localOrderNo) {
	      var orderOutlet_Id = _this.state.customerId;
	      var postObject = {};
	      postObject = {
	        charge_id: captureID,
	        app_id: APP_ID,
	        order_primary_id: orderPrimaryId,
	        outlet_id: orderOutlet_Id
	      };
	
	      _axios2.default.post(API_URL + 'paymentv1/retrieve_charge_details', qs.stringify(postObject)).then(function (res) {
	        if (res.data.status === 'ok' && res.data.payment_status === 'successful') {
	          _this.setState({ stop_authentication: 'yes' });
	        } else if (res.data.status === 'ok' && res.data.payment_status === 'pending') {
	          _this.retrieve_charge_details(captureID, localOrderNo, orderPrimaryId);
	        } else {
	          // var magnfPopup = $.magnificPopup.instance
	          var msgTxt = res.data.message !== '' ? res.data.message : 'Your order was not successful.';
	          helper.showInfo(msgTxt);
	        }
	      });
	    };
	
	    _this.omise_search_history = function () {
	      var orderOutlet_Id = _this.state.customerId;
	      var postObject = {};
	      postObject = {
	        app_id: APP_ID,
	        card_id: _this.state.omise_tokken_card_id,
	        token_id: _this.state.omise_tokken_id,
	        outlet_id: orderOutlet_Id
	      };
	
	      _axios2.default.post(API_URL + 'paymentv1/omise_search_details', qs.stringify(postObject)).then(function (res) {
	        if (res.data.status === 'ok') {
	          // var captureID = res.data.captureID
	          var omiseLogId = res.data.log_id;
	          _this.setState({ validateimage: _tick2.default, omise_log_id: omiseLogId });
	        } else if (res.data.status === 'error') {
	          /* Reset poup message -  start */
	          _this.onProcessOmiseToken(_this.state.omise_tokken_response);
	        } else {
	          _this.onProcessOmiseToken(_this.state.omise_tokken_response);
	        }
	      });
	    };
	
	    _this.pageReload = function () {
	      setTimeout(function () {
	        //  window.location.reload()
	      }, 15000);
	    };
	
	    _this.state = {
	      cartData: [],
	      cartItems: [],
	      status: 'Loading',
	      availabilityId: '',
	      windowHeightNormal: 0,
	      windowHeight: 0,
	      requestData: [],
	      order_id: '',
	      payment_id: '',
	      omise_payment_enable: 0,
	      omise_log_id: '',
	      omisecodeerror: '',
	      omiseyearerror: '',
	      omisemontherror: '',
	      omisecardrror: '',
	      omisenameerror: '',
	      holdername: '',
	      cardNumber: '',
	      expiration_month: '',
	      expiration_year: '',
	      security_code: '',
	      cardImage: '',
	      payment_ref_id: '',
	      omise_tokken_response: '',
	      omise_tokken_card_id: '',
	      omise_tokken_id: '',
	      processOmise: false,
	      customerId: '',
	      client_payments: 'Omise',
	      settings: ''
	    };
	    _this.onChangePayment = _this.onChangePayment.bind(_this);
	    return _this;
	  }
	
	  _createClass(Paymentrequest, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // this.props.getblocks()
	      // this.props.getOutlets()
	      // this.props.getSetings()
	
	      var orderId = typeof this.props.params.orderId !== 'undefined' && this.props.params.orderId !== '' ? base64.decode(this.props.params.orderId) : '';
	      var paymentId = typeof this.props.params.paymentId === 'undefined' ? '' : base64.decode(this.props.params.paymentId);
	
	      if (paymentId === '' || orderId === '') {
	        _reactRouter.hashHistory.push('/');
	      }
	
	      var promise = (0, _Api2.default)('settingsProWithavailability', 'No');
	      promise.then(function (res) {
	        var settingResult = res.data.result_set;
	        _this2.setState({ settings: settingResult });
	      });
	
	      _axios2.default.all([_axios2.default.get(API_URL + 'reports/order_history?app_id=' + APP_ID + '&order_id=' + orderId)]).then(_axios2.default.spread(function (orders) {
	        if (orders.data.status === 'ok') {
	          _this2.setState({
	            status: orders.data.status,
	            order_id: orderId,
	            payment_id: orders.data.result_set[0].order_primary_id,
	            customerId: orders.data.result_set[0].order_customer_id,
	            orderOutletId: orders.data.result_set[0].outlet_id,
	            orderOutletName: orders.data.result_set[0].outlet_name,
	            order_local_no: orders.data.result_set[0].order_local_no
	          });
	          _this2.setState({ cartItems: orders.data.result_set[0]['items'] });
	          _this2.setState({ cartData: orders.data.result_set[0] });
	        } else {
	          _reactRouter.hashHistory.push('/');
	        }
	      }));
	
	      _axios2.default.all([_axios2.default.get(API_URL + 'advancepayments/order_requestlist/?app_id=' + APP_ID + '&order_id=' + orderId + '&primary_id=' + paymentId), _axios2.default.get(API_URL + 'callcenterapi/get_payment_reference_id?app_id=' + APP_ID)]).then(_axios2.default.spread(function (requestDetails, paymentRef) {
	        if (requestDetails.data.status === 'ok') {
	          var payrefId = '';
	          if (paymentRef.data.status === 'ok') {
	            payrefId = paymentRef.data.payment_ref_id;
	          }
	          _this2.setState({
	            requestData: requestDetails.data.result_set,
	            payment_ref_id: payrefId
	          });
	        } else {
	          helper.showInfo(requestDetails.data.message);
	          _reactRouter.hashHistory.push('/');
	        }
	      }));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.settings !== nextProps.settings) {
	        this.setState({ settings: nextProps.settings });
	      }
	    }
	
	    /* this function used to load modifer items */
	
	  }, {
	    key: 'loadModifierItems',
	    value: function loadModifierItems(itemType, modifiers, combo) {
	      var len = modifiers.length;
	      var comboLen = combo.length;
	      var html = "<ul className='table_list cart_sub_items mod'>";
	      var reactElement = "";
	      if (len > 0) {
	        for (var i = 0, length = len; i < length; i++) {
	          var modName = modifiers[i]['cart_modifier_name'];
	          var modval = modifiers[i]['modifiers_values'][0]['cart_modifier_name'];
	          html += "<li className='sub-item'>" + modName + ' : ' + modval + '</li> ';
	        }
	        html += '</ul>';
	        reactElement = htmlToReactParser.parse(html);
	        return reactElement;
	      } else if (_.isEmpty(comboLen) === true && comboLen > 0) {
	        for (var _i = 0, length1 = comboLen; _i < length1; _i++) {
	          var comboName = combo[_i]['menu_component_name'];
	          //var comboVal =combo[i]['product_details'][0]['cart_menu_component_product_name'];
	          var comboVal = this.showComboProducts(combo[_i]['product_details']);
	          html += " <li className='sub-item'><b>" + comboName + ' :</b>' + comboVal + ' ' + this.showComboModifiers(combo[_i]['product_details'][0]['modifiers']) + '</li> ';
	
	          //html += "<li className='sub-item'><b>"+comboName+" :</b>"+comboVal+" "+ "</li> ";
	        }
	        html += '</ul>';
	        reactElement = htmlToReactParser.parse(html);
	        return reactElement;
	      }
	    }
	    /* show combo products  list */
	
	  }, {
	    key: 'showComboProducts',
	    value: function showComboProducts(combos) {
	      var lenCombo = combos.length;
	      var html = ' ';
	      if (lenCombo > 0) {
	        for (var r = 0, lengthCombo = lenCombo; r < lengthCombo; r++) {
	          //console.log(combos[0]['modifiers']);
	          var comboPro = combos[r]['menu_product_name'];
	          var comboQty = combos[r]['menu_product_qty'];
	          // var comboPrice = combos[r]['menu_product_price']
	          var newPrice = '';
	          /*  var newPrice = (comboPrice >0)? " (+"+comboPrice+")" : ""; */
	          html += "<li className='sub-item'>" + comboQty + ' X ' + comboPro + newPrice + ' </li> ';
	        }
	        return html;
	      }
	      return '';
	    }
	  }, {
	    key: 'showComboModifiers',
	    value: function showComboModifiers(modifiers) {
	      //console.log(modifiers);
	      var lenMod = modifiers.length;
	      var html = "<ul className='table_list cart_sub_items combo'>";
	      if (lenMod > 0) {
	        for (var i = 0, length = lenMod; i < length; i++) {
	          var modName = modifiers[i]['cart_modifier_name'];
	          var modval = modifiers[i]['modifiers_values'][0]['cart_modifier_name'];
	          // var modValPrice =
	          //   modifiers[i]['modifiers_values'][0]['cart_modifier_price']
	          var newModValPrice = '';
	          /* var newModValPrice = (modValPrice >0)? " (+"+modValPrice+")" : ""; */
	
	          html += "<li className='sub-item'>" + modName + ': ' + modval + newModValPrice + '</li> ';
	        }
	        html += '</ul>';
	        // var reactElement = htmlToReactParser.parse(html );
	        return html;
	      }
	
	      return '';
	    }
	
	    /* post stripe account */
	
	  }, {
	    key: 'onChangePayment',
	    value: function onChangePayment(event) {
	      var client_payments = '';
	      // var paymentModeID = 3
	      if (event.target.value === '1') {
	        client_payments = 'COD';
	        // paymentModeID = 2
	      } else if (event.target.value === '4') {
	        client_payments = 'Omise';
	      } else if (event.target.value === '3') {
	        client_payments = 'STRIPE';
	      }
	      this.setState({
	        paymentMode: event.target.value,
	        client_payments: client_payments
	      });
	    }
	
	    /* Omise Payment Gateway Start */
	
	  }, {
	    key: 'space',
	    value: function space(el) {
	      var numbes = el.replace(/ /g, '');
	      return numbes.replace(/(\d{4})/g, '$1 ').replace(/(^\s+|\s+$)/, '');
	    }
	  }, {
	    key: 'cardValidation',
	    value: function cardValidation(carnumber) {
	      var imagename = '';
	      if (carnumber !== '') {
	        var single = carnumber.substring(0, 1);
	        var double = carnumber.substring(0, 2);
	
	        if (single === 4) {
	          imagename = 'visa';
	        } else if (double === 34 || double === 37) {
	          imagename = 'american';
	        } else if (double >= 51 && double <= 55) {
	          imagename = 'master';
	        } else if (double === 60 || double === 64 || double === 65) {
	          imagename = 'discover';
	        }
	      }
	
	      this.setState({ cardImage: imagename });
	    }
	  }, {
	    key: 'orderPayValidaion',
	    value: function orderPayValidaion(event) {
	      event.preventDefault();
	      $('#pay-omiseconf-popup').modal('show');
	    }
	  }, {
	    key: 'getOmiseToken',
	    value: function getOmiseToken() {
	      var errorFlg = 0,
	          omisenameerror = '',
	          omisecardrror = '',
	          omisemontherror = '',
	          omiseyearerror = '',
	          omisecodeerror = '';
	      if (this.state.holdername === '') {
	        errorFlg++;
	        omisenameerror = 'omise-form-error';
	      }
	      if (this.state.cardNumber === '') {
	        errorFlg++;
	        omisecardrror = 'omise-form-error';
	      }
	      if (this.state.expiration_month === '') {
	        errorFlg++;
	        omisemontherror = 'omise-form-error';
	      }
	      if (this.state.expiration_year === '') {
	        errorFlg++;
	        omiseyearerror = 'omise-form-error';
	      }
	      if (this.state.security_code === '') {
	        errorFlg++;
	        omisecodeerror = 'omise-form-error';
	      }
	
	      this.setState({
	        omisenameerror: omisenameerror,
	        omisecardrror: omisecardrror,
	        omisemontherror: omisemontherror,
	        omiseyearerror: omiseyearerror,
	        omisecodeerror: omisecodeerror
	      });
	      if (errorFlg === 0) {
	        this.setState({ processOmise: true }, function () {
	          helper.showLoader('omise-pay-btn', 'class');
	        });
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'showOmiselert',
	    value: function showOmiselert(msgArr) {
	      var dataTimeoutId = $('.omise-error-info-div').attr('data-timeoutid');
	      clearTimeout(dataTimeoutId);
	      $('.omise-error-info-div').hide();
	      $('.omise-error-msg').html(msgArr['message']);
	      $('#omise-error-info-div').fadeIn();
	      var timeoutid = setTimeout(function () {
	        $('.omise-error-info-div').hide();
	      }, 6000);
	      $('.omise-error-info-div').attr('data-timeoutid', timeoutid);
	    }
	
	    /* post stripe account */
	
	  }, {
	    key: 'captureOmiseAmount',
	
	    /* Omise Capture Payment */
	    value: function captureOmiseAmount(captureID, orderPrimaryId, localOrderNo) {
	      var _this3 = this;
	
	      var cabtureObjects = {};
	      cabtureObjects = {
	        payment_reference: '',
	        customer_id: this.state.customerId,
	        app_id: APP_ID,
	        token: captureID,
	        order_id: orderPrimaryId,
	        log_id: this.state.omise_log_id,
	        outlet_id: this.state.orderOutletId
	      };
	      _axios2.default.post(API_URL + 'paymentv1/captureAmountOmise', qs.stringify(cabtureObjects)).then(function (captureRes) {
	        if (captureRes.data.status === 'ok') {
	          _this3.setState({ completingpaymentimage: _tick2.default });
	
	          _this3.setState({ stop_authentication: 'yes' }, function () {
	            var payRefID = this.state.payment_ref_id;
	            var paymentSuccess = {};
	            paymentSuccess = {
	              app_id: APP_ID,
	              paid_amount: this.state.requestData.ap_request_amount,
	              order_id: this.state.order_id,
	              order_primary_id: this.state.payment_id,
	              order_local_payment_reference: payRefID,
	              client_payments: this.state.client_payments
	
	              //console.log(paymentSuccess); return false;
	
	            };_axios2.default.post(API_URL + 'advancepayments/recordPayment', qs.stringify(paymentSuccess)).then(function (res) {
	              console.log(res, "res");
	              if (res.data.status === "ok") {
	                helper.hideLoader('omise-pay-btn', 'class');
	                $('#pay-omiseconf-popup').modal('hide');
	                helper.showInfo('your payment processed successfully');
	                _reactRouter.hashHistory.push('/');
	              } else {
	                helper.showInfo(res.data.message);
	              }
	            });
	            // .catch(error => {
	            //     helper.showInfo('error')
	            //   return false
	            // })
	          }.bind(_this3));
	        } else if (captureRes.data.status === 'pending') {
	          _this3.retrieve_charge_details(captureID, localOrderNo, orderPrimaryId);
	        } else if (captureRes.data.status === 'error') {
	          var omsMsgTxt = captureRes.data.message !== '' ? captureRes.data.message : 'Your order was not successful.';
	          helper.showInfo(omsMsgTxt);
	        } else {
	          _this3.retrieve_charge_details(captureID, localOrderNo, orderPrimaryId);
	        }
	      }).catch(function (error) {
	        _this3.captureOmiseAmount(captureID, orderPrimaryId, localOrderNo);
	      });
	    }
	  }, {
	    key: 'paymentFail',
	    value: function paymentFail(header, message) {
	      $('.warining_popup').remove();
	      $('body').append('<div class="white-popup mfp-hide popup_sec warining_popup"><div class="custom_alert"><div class="custom_alertin"><div class="alert_height"><div class="alert_header">' + header + '</div><div class="alert_body"><p>' + message + '</p><div class="alt_btns"><a href="javascript:void(0);" onClick="' + this.pageReload() + '"class="btn btn-sm btn_yellow popup-modal-dismiss">OK</a></div></div></div></div></div></div>');
	    }
	  }, {
	    key: 'render',
	
	
	    /* Omise End */
	
	    value: function render() {
	      var _this4 = this;
	
	      var settings = this.state.settings ? this.state.settings : [];
	
	      if (this.state.status === 'Loading' || _.isEmpty(settings) === true) {
	        return (
	          // <React.Fragment>
	          _react2.default.createElement(
	            'div',
	            {
	              id: 'cartLoading',
	              style: {
	                display: 'block',
	                bottom: 0,
	                left: 0,
	                position: 'fixed',
	                right: 0,
	                top: 0,
	                margin: 'auto',
	                zIndex: 9999,
	                background: 'rgba(255, 255, 255, 0.8)'
	              } },
	            _react2.default.createElement('img', {
	              src: _loader2.default,
	              alt: 'Loading',
	              style: {
	                bottom: 0,
	                left: 0,
	                position: 'fixed',
	                right: 0,
	                top: 0,
	                margin: 'auto'
	              }
	            })
	          )
	          // </React.Fragment>
	
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'main',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'main-wrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'desktop-over-container' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bg-white' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'page-header-block bg-transparent check-block' },
	                      _react2.default.createElement(
	                        'h1',
	                        { className: 'font-gothamlight  text-center text-uppercase' },
	                        ' ',
	                        'Make Your Payment'
	                      ),
	                      _react2.default.createElement(
	                        'h6',
	                        { className: ' text-center' },
	                        'Requested Payment Amount - $',
	                        ' ',
	                        this.state.requestData.ap_request_amount
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'main-outer margin-top-40 rewardbx_up' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'order-details-item-block order-info-block' },
	                      _react2.default.createElement(
	                        'h4',
	                        { className: 'font-gothamlight checkout-block-header text-center text-uppercase inner-title-1' },
	                        'Your Order Details'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'order-info text-center' },
	                        _react2.default.createElement(
	                          'h4',
	                          { className: 'font-gothamlight  text-center text-uppercase' },
	                          'Order No - ',
	                          this.state.cartData.order_local_no
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'Order placed at :',
	                          ' ',
	                          (0, _moment2.default)(this.state.cartData.order_created_on).format('MM/DD/YYYY HH:mm a')
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'delivery-info address-bodyc' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-left' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'media' },
	                            _react2.default.createElement('img', {
	                              className: 'mr-3',
	                              src: '/img/take-away.png',
	                              alt: 'Generic placeholder '
	                            }),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'media-body' },
	                              _react2.default.createElement(
	                                'h6',
	                                { className: 'mt-0' },
	                                this.state.cartData.order_availability_id === DINEIN_ID ? 'DIne in' : 'SELF COLLECTION',
	                                ' ',
	                                'LOCATION',
	                                ' '
	                              ),
	                              _react2.default.createElement(
	                                'p',
	                                { className: 'outlet-info' },
	                                this.state.cartData.outlet_name,
	                                ' -',
	                                ' ',
	                                helper.addressFormat(this.state.cartData.outlet_unit_number1, this.state.cartData.outlet_unit_number2, this.state.cartData.outlet_address_line1, this.state.cartData.outlet_address_line2, this.state.cartData.outlet_postal_code)
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-right' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'media-rhs' },
	                            _react2.default.createElement('img', {
	                              className: 'mr-3',
	                              src: '/img/alarm-clock.png',
	                              alt: 'Generic placeholder'
	                            }),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'media-body' },
	                              _react2.default.createElement(
	                                'h6',
	                                { className: 'mt-0' },
	                                this.state.cartData.order_availability_id === DINEIN_ID ? 'DIne in' : 'SELF COLLECTION',
	                                ' ',
	                                'Date & Time'
	                              ),
	                              _react2.default.createElement(
	                                'p',
	                                { className: 'outlet-info' },
	                                (0, _moment2.default)(this.state.cartData.order_date).format('MM/DD/YYYY HH:mm a')
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'cart-items-block' },
	                        this.state.cartItems.map(function (item, index) {
	                          return _react2.default.createElement(
	                            'div',
	                            { className: 'cart-row-body', key: index },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'cart-left-lhs' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'cart-img' },
	                                _react2.default.createElement('img', {
	                                  src: item.item_image !== '' ? item.item_image : _productsNoImage2.default,
	                                  width: 110,
	                                  height: 67,
	                                  alt: ''
	                                })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'cart-info' },
	                                _react2.default.createElement(
	                                  'h6',
	                                  null,
	                                  item.item_qty,
	                                  ' X ',
	                                  item.item_name
	                                ),
	                                _this4.loadModifierItems(item.cart_item_type, item.modifiers, item.set_menu_component),
	                                _react2.default.createElement(
	                                  'p',
	                                  { className: 'cart-special-text' },
	                                  item.item_specification
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'cart-right-rhs text-right' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'cart-right ' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'cart-price' },
	                                  _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    '$',
	                                    item.item_total_amount
	                                  )
	                                )
	                              )
	                            )
	                          );
	                        }),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'calctrcart-footer cart-footer' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'calctrcart-row cart-footer-row' },
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'text-uppercase' },
	                              'SUBTOTAL'
	                            ),
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              '$',
	                              this.state.cartData.order_sub_total
	                            )
	                          ),
	                          this.state.cartData.order_discount_amount > 0 && this.state.cartData.order_discount_applied === 'Yes' && _react2.default.createElement(
	                            'div',
	                            { className: 'calctrcart-row cart-footer-row' },
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'text-uppercase' },
	                              'DISCOUNT'
	                            ),
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              '$',
	                              this.state.cartData.order_discount_amount
	                            )
	                          ),
	                          this.state.cartData.order_tax_charge > 0 && this.state.cartData.order_tax_calculate_amount && _react2.default.createElement(
	                            'div',
	                            { className: 'calctrcart-row cart-footer-row' },
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'text-uppercase' },
	                              'GST ( ',
	                              this.state.cartData.order_tax_charge,
	                              ' %)'
	                            ),
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              '$',
	                              this.state.cartData.order_tax_calculate_amount
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'calctrcart-row cart-footer-row calctrcart-footer-totrow' },
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'text-uppercase' },
	                              'Total'
	                            ),
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              '$',
	                              this.state.cartData.order_total_amount
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'calctrcart-row cart-footer-row calctrcart-footer-totrow' },
	                            _react2.default.createElement(
	                              'p',
	                              { className: 'text-uppercase' },
	                              'Payable amount'
	                            ),
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              '$',
	                              this.state.requestData.ap_request_amount,
	                              ' '
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'checkout-payment-actions main-outer' },
	                      _react2.default.createElement(
	                        'h4',
	                        { className: 'text-center text-uppercase pay-mthd' },
	                        ' Select Your Payment Method'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'payment-types-block' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group payment-body' },
	                          settings.client_omise_enable === '1' && _react2.default.createElement(
	                            'div',
	                            { className: 'custom-radio custom-control radio radio-primary' },
	                            _react2.default.createElement(
	                              'label',
	                              {
	                                className: this.state.client_payments === 'Omise' ? 'custom-control-label active' : 'custom-control-label',
	                                htmlFor: 'ptype_omise' },
	                              _react2.default.createElement('input', {
	                                type: 'radio',
	                                id: 'ptype_omise',
	                                name: 'customRadio',
	                                className: 'custom-control-input',
	                                defaultChecked: this.state.client_payments === 'Omise' ? true : false,
	                                value: '4',
	                                onClick: this.onChangePayment
	                              }),
	                              _react2.default.createElement('span', { className: 'circle' }),
	                              _react2.default.createElement('span', { className: 'check' }),
	                              _react2.default.createElement('img', {
	                                src: '../../img/omise.png',
	                                alt: '...', className: 'img-responsive img-width-120'
	                              })
	                            )
	                          ),
	                          settings.client_stripe_enable === '1' && _react2.default.createElement(
	                            'div',
	                            { className: 'custom-radio custom-control radio radio-primary' },
	                            _react2.default.createElement(
	                              'label',
	                              {
	                                className: this.state.client_payments === 'STRIPE' ? 'custom-control-label active' : 'custom-control-label',
	                                htmlFor: 'ptype_cod' },
	                              _react2.default.createElement('input', {
	                                type: 'radio',
	                                id: 'ptype_cod',
	                                name: 'customRadio',
	                                className: 'custom-control-input',
	                                defaultChecked: this.state.client_payments === 'STRIPE' ? true : false,
	                                value: '3',
	                                onClick: this.onChangePayment
	                              }),
	                              _react2.default.createElement('span', { className: 'circle' }),
	                              _react2.default.createElement('span', { className: 'check' }),
	                              _react2.default.createElement('img', {
	                                src: '/img/payment-card-type.png',
	                                alt: '...', className: 'img-responsive img-width-120'
	                              })
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    this.state.client_payments === 'STRIPE' && settings.client_stripe_enable === '1' && _react2.default.createElement(
	                      'div',
	                      { className: 'check-order-status-btn-block' },
	                      _react2.default.createElement(
	                        _reactStripeCheckout2.default,
	                        {
	                          name: stripeCompany,
	                          image: stripeImage,
	                          description: stripeCompany,
	                          token: this.onToken,
	                          stripeKey: settings.stripe_public_key,
	                          amount: this.state.requestData.ap_request_amount * 100,
	                          email: stripeEmail,
	                          currency: stripeCurrency },
	                        ' ',
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            type: 'button',
	                            className: 'btn btn-secondary btn-block' },
	                          'Pay Now'
	                        ),
	                        ' '
	                      )
	                    ),
	                    this.state.client_payments === 'Omise' && settings.client_omise_enable === '1' && _react2.default.createElement(
	                      'div',
	                      { className: 'check-order-status-btn-block' },
	                      settings.omise_public_key && this.state.customerId !== '' && _react2.default.createElement(
	                        'button',
	                        {
	                          type: 'button',
	                          onClick: this.orderPayValidaion.bind(this),
	                          className: 'btn btn-secondary btn-block' },
	                        'Pay Now'
	                      ),
	                      _react2.default.createElement(_PaymentCheckout2.default, {
	                        sateValChange: this.sateValChange,
	                        checkoutState: this.state
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'modal fade'
	              // id="stripPaymentProcess"
	              , tabIndex: -1,
	              role: 'dialog',
	              'aria-hidden': 'true',
	              id: 'pay-omiseconf-popup' },
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'modal-dialog modal-dialog-centered modal-lg',
	                role: 'document pay-omiseconf-popup-body' },
	              _react2.default.createElement(
	                'div',
	                { className: 'modal-content bg-Black delivery-datetime-modal pay-omiseconf-popup-inner' },
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: 'omise-error-info-div',
	                    id: 'omise-error-info-div',
	                    style: { display: 'none' } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'omise-error-icon' },
	                      _react2.default.createElement('i', {
	                        className: 'fa fa-exclamation-triangle',
	                        'aria-hidden': 'true'
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'a',
	                      {
	                        href: '#',
	                        className: 'omise_alert_close',
	                        'data-dismiss': 'alert',
	                        'aria-label': 'Close',
	                        onClick: function onClick(evt) {
	                          evt.preventDefault();
	                        } },
	                      ' ',
	                      _react2.default.createElement(
	                        'span',
	                        { 'aria-hidden': 'true' },
	                        '\xD7'
	                      ),
	                      ' '
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'omise-error-msg' },
	                      'Something went wrong'
	                    )
	                  )
	                ),
	                settings.omise_envir === 'dev' && _react2.default.createElement(
	                  'div',
	                  { className: 'omisepay-mode-option' },
	                  'Test Mode'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'custom_alert_new pay-omiseconf-popup' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'custom_alertin' },
	                    _react2.default.createElement('button', {
	                      type: 'button',
	                      className: 'close',
	                      'data-dismiss': 'modal',
	                      'aria-label': 'Close'
	                    }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'alert_height' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'omise_pay_header' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'omise-pay-img' },
	                          _react2.default.createElement('img', {
	                            className: 'makisan-logo-img',
	                            src: stripeImage,
	                            alt: ''
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'omise_pay_body' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'omisepop_in' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form_sec' },
	                            _react2.default.createElement(
	                              'div',
	                              {
	                                className: 'uname-box ' + this.state.omisenameerror },
	                              _react2.default.createElement('i', { className: 'fa fa-user', 'data-unicode': 'f007' }),
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                id: 'holdername',
	                                className: 'form-control',
	                                placeholder: 'Card Holder Name',
	                                value: this.state.holdername,
	                                onChange: this.handleChangeTxt.bind(this, 'holdername')
	                              })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              {
	                                className: 'card-numbr-div ' + this.state.omisecardrror },
	                              _react2.default.createElement('i', {
	                                className: 'fa fa-credit-card',
	                                'data-unicode': 'f09d'
	                              }),
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                className: 'form-control ' + this.state.cardImage,
	                                placeholder: 'Card Number',
	                                value: this.state.cardNumber,
	                                id: 'omise_card_number',
	                                onChange: this.handleChangeTxt.bind(this, 'cardNumber')
	                              }),
	                              _react2.default.createElement('span', { className: 'card' })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'form_expire_row' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'expire_row_inner' },
	                                _react2.default.createElement(
	                                  'div',
	                                  {
	                                    className: 'expire_left ' + this.state.omisemontherror },
	                                  _react2.default.createElement('i', {
	                                    className: 'fa fa-calendar',
	                                    'data-unicode': 'f133'
	                                  }),
	                                  _react2.default.createElement('input', {
	                                    type: 'text',
	                                    className: 'form-control',
	                                    maxLength: '2',
	                                    id: 'expiration_month',
	                                    placeholder: 'MM',
	                                    value: this.state.expiration_month,
	                                    onChange: this.handleChangeTxt.bind(this, 'expiration_month')
	                                  })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  {
	                                    className: 'expire_mdl ' + this.state.omiseyearerror },
	                                  _react2.default.createElement('input', {
	                                    type: 'text',
	                                    placeholder: 'YY',
	                                    className: 'form-control',
	                                    maxLength: '4',
	                                    id: 'expiration_year',
	                                    value: this.state.expiration_year,
	                                    onChange: this.handleChangeTxt.bind(this, 'expiration_year')
	                                  })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  {
	                                    className: 'expire_right ' + this.state.omisecodeerror },
	                                  _react2.default.createElement('i', {
	                                    className: 'fa fa-lock',
	                                    'data-unicode': 'f023'
	                                  }),
	                                  _react2.default.createElement('input', {
	                                    type: 'password',
	                                    maxLength: '3',
	                                    className: 'form-control',
	                                    id: 'security_code',
	                                    placeholder: 'CVV',
	                                    value: this.state.security_code,
	                                    onChange: this.handleChangeTxt.bind(this, 'security_code')
	                                  })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'alt_btns' },
	                              settings.omise_public_key && this.state.customerId !== '' && this.state.client_payments === 'Omise' && settings.client_omise_enable === '1' && _react2.default.createElement(
	                                'button',
	                                { onClick: this.getOmiseToken.bind(this), className: 'btn-checkout btn btn-primary omise-pay-btn' },
	                                'Pay ',
	                                stripeCurrency,
	                                ' ',
	                                parseFloat(this.state.requestData.ap_request_amount).toFixed(2)
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	    }
	  }]);
	
	  return Paymentrequest;
	}(_react2.default.Component);
	
	exports.default = Paymentrequest;
	// const mapStateToProps = ({ cms, settings }) => ({
	//   staticblocks: cms.staticblocks,
	//   cmsFetch: cms.cmsFetch,
	//   outlets: cms.outlets,
	//   settings: settings.returnData,
	//   setStatus: settings.isStatus
	// })
	// const mapDispatchToProps = dispatch =>
	//   bindActionCreators({ getblocks, getOutlets, getSetings }, dispatch)
	
	// export default connect(
	//   mapStateToProps,
	//   mapDispatchToProps
	// )(Paymentrequest)

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var config = __webpack_require__(7);
	var APPID = config.ids.appId;
	var APIURL = config.path.apiUrl;
	var APIURLPRO = config.path.apiUrlPro;
	
	var lang = __webpack_require__(12);
	var HtmlToReactParser = __webpack_require__(21).Parser;
	var htmlToReactParserTo = new HtmlToReactParser();
	var Loading = __webpack_require__(17);
	var helper = __webpack_require__(13);
	var dateFormat = __webpack_require__(42);
	var now = new Date();
	var currentDate = dateFormat(now, "d/m/yyyy");
	var currentTime = dateFormat(now, "h:MM TT");
	var qs = __webpack_require__(3);
	
	var Placeorder = function (_React$Component) {
	  _inherits(Placeorder, _React$Component);
	
	  function Placeorder(props) {
	    _classCallCheck(this, Placeorder);
	
	    var _this = _possibleConstructorReturn(this, (Placeorder.__proto__ || Object.getPrototypeOf(Placeorder)).call(this, props));
	
	    _this.state = {
	      processingText: 'We are processing your order',
	      defaultClass: '',
	      orderLoading: '/img/loading.gif',
	      paymentLoading: '/img/loading.gif'
	    };
	    var urlParams = new URLSearchParams(_this.props.location.search);
	    var redirectUrl = window.location.protocol + '//' + window.location.hostname + '/#/my-account';
	    if (urlParams.get("status") == "success" && urlParams.get("sessionid") == _reactCookie2.default.load("paymentSession")) {
	      var postObject = window.sessionStorage.getItem("postObject") + "&payment_session=" + _reactCookie2.default.load("paymentSession");
	      var OrderAPIUrl = APIURLPRO + "ordersv2/submit_order";
	
	      _axios2.default.post(OrderAPIUrl, postObject).then(function (res) {
	        if (res.data.status === "ok") {
	          var localOrderNo = res.data.common.local_order_no;
	          var subscription = res.data.common.subscription;
	          var orderID = res.data.common.order_id;
	
	          var statusObject = {};
	          statusObject = {
	            app_id: APPID,
	            order_primary_id: res.data.common.order_primary_id,
	            payment_reference: config.stripe.stripeReference,
	            customer_id: _reactCookie2.default.load("UserId"),
	            customer_email: _reactCookie2.default.load("UserEmail"),
	            payment_session: urlParams.get("sessionid")
	          };
	
	          _axios2.default.post(APIURL + "orders/statusUpdateSession", qs.stringify(statusObject)).then(function (captureRes) {
	            if (captureRes.data.status === "ok") {
	              _this.showSuccessPage(localOrderNo, res.data.common.order_primary_id);
	              return;
	            } else {
	              _this.deleteOrderCookie();
	              _this.setState({
	                processingText: 'Please check in myorders, to get order details.'
	              });
	              setTimeout(function () {
	                window.location.href = redirectUrl;
	              }, 5000);
	            }
	          }).catch(function (error) {
	            this.deleteOrderCookie();
	            this.setState({
	              processingText: 'Please check in myorders, to get order details.'
	            });
	            setTimeout(function () {
	              window.location.href = redirectUrl;
	            }, 5000);
	          }.bind(_this));
	        } else {
	          _this.deleteOrderCookie();
	          _this.setState({ processingText: res.data.message });
	          setTimeout(function () {
	            window.location.href = redirectUrl;
	          }, 5000);
	        }
	      }).catch(function (error) {
	        console.log(error, "errorerror");
	        this.deleteOrderCookie();
	        this.setState({ processingText: 'Please check in myorders, to get order details.' });
	        setTimeout(function () {
	          window.location.href = redirectUrl;
	        }, 5000);
	      }.bind(_this));
	    } else if (urlParams.get("status") == "failure") {
	      setTimeout(function () {
	        this.deleteOrderCookie();
	        this.setState({ processingText: 'Please check in myorders, to get order details.' });
	      }.bind(_this), 300);
	      setTimeout(function () {
	        window.location.href = redirectUrl;
	      }, 5000);
	    } else {
	      setTimeout(function () {
	        this.deleteOrderCookie();
	        this.setState({ processingText: 'Please check in myorders, to get order details.' });
	      }.bind(_this), 300);
	      setTimeout(function () {
	        window.location.href = redirectUrl;
	      }, 5000);
	    }
	    return _this;
	  }
	
	  _createClass(Placeorder, [{
	    key: 'sentchatbox',
	    value: function sentchatbox(orderPrimaryId) {
	      var postObject = {
	        app_id: APPID,
	        order_primary_id: orderPrimaryId,
	        customer_id: _reactCookie2.default.load("UserId")
	      };
	      _axios2.default.post(APIURL + "chatbot/order_notify", qs.stringify(postObject)).then(function (res) {
	
	        if (res.data.status === "ok") {
	          console.log("Chatbot Notified");
	        }
	      });
	    }
	
	    /* sucess page */
	
	  }, {
	    key: 'showSuccessPage',
	    value: function showSuccessPage(localOrderNo, orderPrimaryId) {
	      this.setState({ 'orderLoading': '/img/tick.png' });
	      this.setState({ status: "ok" });
	      this.destroyCart();
	      this.deleteOrderCookie();
	      this.sentchatbox(orderPrimaryId);
	      setTimeout(function () {
	        _reactRouter.hashHistory.push("/order-success/" + localOrderNo);
	      }.bind(this), 500);
	    }
	  }, {
	    key: 'destroyCart',
	    value: function destroyCart() {
	      var postObject = {};
	      postObject = { 'app_id': config.ids.appId };
	      postObject['customer_id'] = _reactCookie2.default.load('UserId');
	      _axios2.default.post(APIURL + "cart/destroy", qs.stringify(postObject));
	    }
	  }, {
	    key: 'deleteOrderCookie',
	    value: function deleteOrderCookie() {
	      _reactCookie2.default.save('cartValue', 'No');
	      _reactCookie2.default.remove('orderPaymentMode');
	      _reactCookie2.default.remove('orderOutletId');
	      _reactCookie2.default.remove('orderTableNo');
	      _reactCookie2.default.remove('product_remarks');
	      _reactCookie2.default.remove('orderOutletName');
	      _reactCookie2.default.remove('orderOutletId');
	      _reactCookie2.default.remove('orderZoneID');
	      _reactCookie2.default.remove('promotion_code');
	      /* Delivery avilablity */
	      _reactCookie2.default.remove('DeliveryDate');
	      _reactCookie2.default.remove('DeliveryTime');
	      _reactCookie2.default.remove('isSletedTimeSlot');
	      _reactCookie2.default.remove('DeliveryTimeSlot'); //
	      _reactCookie2.default.remove('DeliveryTimeSlotFormated');
	      _reactCookie2.default.remove('unitNoOne');
	      _reactCookie2.default.remove('unitNoTwo'); //
	      _reactCookie2.default.remove('towerNo');
	
	      _reactCookie2.default.remove('outlet_tax_option');
	      _reactCookie2.default.remove('outlet_tax_surcharge');
	      _reactCookie2.default.remove('outlet_tax_surcharge_inclusive');
	      _reactCookie2.default.remove('tempPromoCode');
	      _reactCookie2.default.remove('tempPoints');
	      window.sessionStorage.removeItem("postObject");
	      window.sessionStorage.removeItem("paymentSession");
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { id: 'loadIcon', style: { bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto', zIndex: 9999, background: 'rgba(255, 255, 255, 0.8)' } },
	          ' ',
	          _react2.default.createElement('img', { style: { bottom: 0, left: 0, position: 'absolute', right: 0, top: 0, margin: 'auto' }, src: '/img/loader.gif', alt: 'Loading' }),
	          ' ',
	          _react2.default.createElement(
	            'p',
	            { className: 'validateOrder' },
	            this.state.processingText,
	            ' '
	          ),
	          ' '
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid desktop-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 main-title-bar' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: "/" },
	                ' ',
	                _react2.default.createElement('img', { src: '/img/left-arrow.png', className: 'pull-left icon-img-small', alt: 'left-arrow' }),
	                ' '
	              ),
	              _react2.default.createElement(
	                'h3',
	                { className: 'top-title main-title padding-right-20 text-uppercase' },
	                'Placeorder'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement('div', { className: 'space-10 bg-gray' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'white-outer center-block' },
	            _react2.default.createElement('div', { className: 'clearfix' })
	          ),
	          _react2.default.createElement('div', { className: 'space-30' })
	        )
	      );
	    }
	  }]);
	
	  return Placeorder;
	}(_react2.default.Component);
	
	exports.default = Placeorder;

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(9);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _Distancebar = __webpack_require__(102);
	
	var _Distancebar2 = _interopRequireDefault(_Distancebar);
	
	var _Outletclosedmessage = __webpack_require__(103);
	
	var _Outletclosedmessage2 = _interopRequireDefault(_Outletclosedmessage);
	
	var _lodash = __webpack_require__(30);
	
	var _reactGeolocated = __webpack_require__(179);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactCustomScrollbars = __webpack_require__(734);
	
	var _LocationSearchInput = __webpack_require__(129);
	
	var _LocationSearchInput2 = _interopRequireDefault(_LocationSearchInput);
	
	var _constants = __webpack_require__(65);
	
	__webpack_require__(145);
	
	var _reactSlick = __webpack_require__(455);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _reactStickyEl = __webpack_require__(908);
	
	var _reactStickyEl2 = _interopRequireDefault(_reactStickyEl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var config = __webpack_require__(7);
	var lang = __webpack_require__(12);
	var APIURL = config.path.apiUrl;
	var APIURLv2 = config.path.apiUrlv2;
	var currency = config.ids.currency;
	var APPID = config.ids.appId;
	var Loading = __webpack_require__(17);
	var Alert = __webpack_require__(48);
	var strp = __webpack_require__(31);
	var ReactDOMServer = __webpack_require__(436);
	var HtmlToReactParser = __webpack_require__(21).Parser;
	var helper = __webpack_require__(13);
	var Select = __webpack_require__(83);
	
	var APIURLPRO = config.path.apiUrlPro;
	
	/* Load meta tags */
	var meta = {
		title: lang.prodcuts_meta_title + lang.site_title_with_separator,
		description: lang.prodcuts_meta_title,
		meta: {
			name: {
				keywords: lang.prodcuts_meta_title
			}
		}
	};
	
	var Products = function (_React$Component) {
		_inherits(Products, _React$Component);
	
		function Products(props) {
			_classCallCheck(this, Products);
	
			var _this = _possibleConstructorReturn(this, (Products.__proto__ || Object.getPrototypeOf(Products)).call(this, props));
	
			_this.state = {
				slideIndex: 2,
				updateCount: 0
			};
	
	
			helper.addBodyClass();
	
			_this.state = { goto: 1, stockEnabled: 0, zonePopupDisable: 0, zoneEnabled: 0, zoneOutletSeleted: "", zoneDeliveryOutlet: '', deliveryOutlets: [], zoneDetails: [], productHeightNormal: 0, windowHeightNormal: 0, windowHeight: 0, secAddrData: [], addressField: '', Outlets: [], category: [], products: [], products_common: [], urlparams: [], 'status': 'Loading', navStatus: '', categoryName: '', categoryImSrc: config.noImages.product_listing, enableAddressSearch: false, outletCloseddMessage: '' };
			_this.handleChangeValue = _this.handleChangeValue.bind(_this);
			_this.handleChange = _this.handleChange.bind(_this);
			_this.selectOutlet = _this.selectOutlet.bind(_this);
			/* set default avilablity */
			// var sqdasdasd = "test";
			_axios2.default.get(APIURLPRO + 'settings/get_common_settings?app_id=' + APPID + "&postal_code=" + _reactCookie2.default.load('orderPostalCode') + "&postalFilter=No").then(function (res) {
				_this.setState({ zoneEnabled: parseInt(res.data.result_set.client_outlet_zone) });
				_this.setState({ zonePopupDisable: parseInt(res.data.result_set.client_zone_outlet_disable) });
				_this.setState({ stockEnabled: parseInt(res.data.result_set.client_product_stock) }, function () {
					console.log(this.state.stockEnabled);
				});
	
				var applyOutletIdtxt = res.data.result_set.ninja_outletbasedproduct_enable === '1' ? 'yes' : 'no';
				_reactCookie2.default.save('applyOutletId', applyOutletIdtxt);
				var avlId = res.data.result_set.ninja_pro_default_availability_id;
				var avlText = res.data.result_set.ninja_pro_default_availability_name === "Pickup" ? "Takeaway" : res.data.result_set.ninja_pro_default_availability_name;
				var avlImage = "/img/icons/" + res.data.result_set.ninja_pro_default_availability_id + ".png";
				helper.setDefaultAvailability(avlId, avlText, avlImage);
	
				var orderOutletIdTxt = _reactCookie2.default.load('orderOutletId');
				var addqueryTxt = '';
	
				if (typeof orderOutletIdTxt !== "undefined" && orderOutletIdTxt !== '') {
					addqueryTxt = "&outletIdTxt=" + orderOutletIdTxt;
				}
	
				/* API CALL FOR PRODUCT MENU NAVIGATION */
				_axios2.default.get(APIURL + 'productsver3/navigation_menu?app_id=' + APPID + addqueryTxt + "&availability=" + _reactCookie2.default.load('defaultAvilablityId')).then(function (res) {
					_this.setState({ navStatus: res.data.status });
					_this.setState({ common: res.data.common });
					_this.setState({ category: res.data.result_set });
				});
				/* Load Cart */
				_this.loadCartData();
	
				/* get outlets lits */
				if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.pickupId && _reactCookie2.default.load('defaultAvilablity') === lang.takeaWay && typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderPostalCode') === "undefined") {
	
					_this.getpickupOutletlist();
				}
	
				/* get secondary address lits */
				if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "" && _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId) {
	
					if (typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderPostalCode') === "undefined") {
						_this.getSecAddr();
					}
				}
				/* get secondary address lits - end */
	
				/* load products */
				var categoryId = _this.props.params.categoryId;
				var categoryType = _this.props.params.categoryType;
				_this.setState({ categoryId: categoryId });
				var bckurlTxt = categoryType === "category" ? "/products/category/" + categoryId : "/products/subcategory/" + categoryId;
				_reactCookie2.default.save('bckurlTxt', bckurlTxt);
	
				_this.loadData(categoryType, categoryId);
	
				/* JC */
				if (_this.state.zoneEnabled === 1) {
					_axios2.default.get(_constants.API_v4_URL + 'Getoutlets/getAllOutles/pickup_outlets?app_id=' + APPID + "&availability_id=" + config.ids.deliveryId).then(function (res) {
	
						if (res.data.status === "ok") {
							_this.setState({ deliveryOutlets: res.data.result_set });
						}
					});
				} /* JC*/
	
				if (res.data.result_set.client_tax_surcharge_inclusive > "0.00") {
					_this.setState({ gstTaxText: "GST Inclusive(" + parseFloat(res.data.result_set.client_tax_surcharge_inclusive) + "%)" });
				} else if (res.data.result_set.client_tax_surcharge > 0) {
					_this.setState({ gstTaxText: "Excluding Delivery Charges" });
				} else {
					_this.setState({ gstTaxText: "" });
				}
			});
			return _this;
		}
	
		_createClass(Products, [{
			key: 'closeTooltip',
			value: function closeTooltip() {
	
				$(".scan-tooltip").hide();
			}
	
			/* BX slider */
	
		}, {
			key: '__bxslider',
			value: function __bxslider() {
				console.log('bx loaded');
				var bxslider = $('.bxslider').bxSlider({
					infiniteLoop: false,
					auto: false,
					maxSlides: 4,
					slideWidth: 200,
					touchEnabled: true,
					pager: false,
					moveSlides: 1,
					minSlides: 3,
					pause: 4000
				});
				$(".cstm-scroll-menu").mCustomScrollbar({
					axis: "x",
					theme: "dark-3",
					documentTouchScroll: true,
					autoHideScrollbar: true,
					contentTouchScroll: true,
					advanced: {
						autoExpandHorizontalScroll: false
					}
				});
			}
	
			/* return navigation menu slug */
	
		}, {
			key: 'navLinkType',
			value: function navLinkType(menu_type) {
				return menu_type === "sub" ? "subcategory" : "category";
			}
	
			/* this function used reload products */
	
		}, {
			key: 'reLoadProducts',
			value: function reLoadProducts(menu_type, CateId, subCateId) {
				var categoryType = menu_type === "sub" ? 'subcategory' : 'category';
				var categoryId = menu_type === "sub" ? subCateId : CateId;
				this.setState({ categoryId: categoryId });
				document.getElementById("loadIcon").style.display = "block";
				this.loadData(categoryType, categoryId);
			}
			/* return navigation menu slug */
	
		}, {
			key: 'navSlug',
			value: function navSlug(menu_type, CateId, subCateId) {
				return menu_type === "sub" ? "/products/subcategory/" + subCateId : "/products/category/" + CateId;
			}
	
			/* menu listing li  content */
	
		}, {
			key: 'menuListing',
			value: function menuListing(showImage) {
				var _this2 = this;
	
				/*$(window).scroll(function () {
	   		var scroll = $(window).scrollTop();
	   		if (scroll >= 200) {
	   		$(".innerheader-fixed").addClass("scrollheader-fixed");
	   		$(".scrollmain").addClass("fixedscrollmain");
	   	} else {
	   		$(".innerheader-fixed").removeClass("scrollheader-fixed");
	   		$(".scrollmain").removeClass("fixedscrollmain");
	   	}
	   	});  */
	
				var categoryId = this.state.categoryId;
	
				return this.state.category.map(function (loaddata, index) {
					return _react2.default.createElement(
						'div',
						{ key: index, className: categoryId === loaddata.menu_category_id ? "active item_slide" : "item_slide" },
						_react2.default.createElement(
							_reactRouter.Link,
							{ onClick: _this2.reLoadProducts.bind(_this2, loaddata.menu_type, loaddata.menu_category_id, loaddata.pro_subcate_id), style: { cursor: 'pointer' } },
							_this2.loadCategoryImage(true, loaddata),
							_react2.default.createElement(
								'span',
								null,
								strp.stripslashes(loaddata.menu_custom_title)
							)
						)
					);
				});
			}
	
			/* menu listing li  content */
	
		}, {
			key: 'menuListingdropDown',
			value: function menuListingdropDown(showImage) {
				var _this3 = this;
	
				var categoryId = this.state.categoryId;
	
				return this.state.category.map(function (loaddata, index) {
					return _react2.default.createElement(
						'div',
						{ key: index, className: categoryId === loaddata.menu_category_id ? "active item_slide" : "item_slide" },
						_react2.default.createElement(
							_reactRouter.Link,
							{ onClick: _this3.reLoadProducts.bind(_this3, loaddata.menu_type, loaddata.menu_category_id, loaddata.pro_subcate_id), style: { cursor: 'pointer' } },
							_react2.default.createElement(
								'span',
								null,
								strp.stripslashes(loaddata.menu_custom_title)
							)
						)
					);
				});
			}
		}, {
			key: 'loadCategoryImage',
			value: function loadCategoryImage(showImage, loadData) {
	
				//config.path.tinThumpUrl+res.data.common.category_image_source+"/" + res.data.result_set[0].product_list[0][0].catgory_image+"&w=768&h=264&q=80"	 
				var categoryPath = "media/dev_team/products/category-image/";
				var subCategoryPath = "media/dev_team/products/subcategory-image/";
				var returnImage = '/img/no-images/category-slider-no-image.png';
				if (showImage === true) {
					if (loadData.pro_cate_image !== "" && loadData.pro_cate_image !== null) {
						var returnImageOne = _constants.MEDIA_SERVER_URL + categoryPath + "/" + loadData.pro_cate_image;
						return _react2.default.createElement('img', { src: config.path.tinThumpUrl + _constants.MEDIA_SERVER_URL + returnImageOne + '&w=250&h=170&q=80' });
					} else if (loadData.pro_subcate_image != "" && loadData.pro_subcate_image !== null) {
						var returnImageTwo = _constants.MEDIA_SERVER_URL + subCategoryPath + "/" + loadData.pro_subcate_image;
						return _react2.default.createElement('img', { src: config.path.tinThumpUrl + _constants.MEDIA_SERVER_URL + returnImageTwo + '&w=250&h=170&q=80' });
					} else {
						return _react2.default.createElement('img', { src: returnImage });
					}
				}
			}
		}, {
			key: 'loadCartData',
			value: function loadCartData() {
				var _this4 = this;
	
				/* API CALL FOR BANNERS */
				if (typeof _reactCookie2.default.load('UserId') === 'undefined') {
					var customerParam = "&reference_id=" + (0, _Api2.default)('referenceId');
				} else {
					customerParam = "&customer_id=" + _reactCookie2.default.load('UserId');
				}
				var postalCodeWhere = "";
				if (typeof _reactCookie2.default.load("orderPostalCode") !== "undefined") {
					postalCodeWhere = '&postal_code=' + _reactCookie2.default.load("orderPostalCode");
				}
	
				_axios2.default.get(APIURL + 'cartver2/contents?status=A&app_id=' + APPID + customerParam + postalCodeWhere).then(function (res) {
					if (res.data.status === "ok") {
						_this4.setState({ status: 'ok' });
						if (typeof res.data.result_set !== "undefined") {
							var cartDetails = res.data.result_set.cart_details;
							console.log(cartDetails.cart_grand_total);
							_reactCookie2.default.save('cart_grand_total', cartDetails.cart_sub_total);
							_reactCookie2.default.save('cartValue', 'Yes');
						} else {
							_reactCookie2.default.save('cartValue', 'No');
						}
					} else {
	
						_reactCookie2.default.save('cartValue', 'No');
					}
				});
			}
	
			/*Load cart image */
	
		}, {
			key: 'loadCartImage',
			value: function loadCartImage() {
				return (0, _Api2.default)('cartImage');
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this5 = this;
	
				var site_maintenance_verify = _reactCookie2.default.load("client_site_maintenance_verify") !== '' && _reactCookie2.default.load("client_site_maintenance_verify") !== 'undefined' && _reactCookie2.default.load("client_site_maintenance_verify") !== undefined ? _reactCookie2.default.load("client_site_maintenance_verify") : '';
	
				var site_maintenance_popup_open = _reactCookie2.default.load("site_maintenance_popup_open") !== '' && _reactCookie2.default.load("site_maintenance_popup_open") !== 'undefined' && _reactCookie2.default.load("site_maintenance_popup_open") !== undefined ? _reactCookie2.default.load("site_maintenance_popup_open") : '';
	
				if (site_maintenance_popup_open === "1" && (site_maintenance_verify === '' || site_maintenance_verify === '0')) {
					_reactRouter.hashHistory.push("/");
					return;
				}
	
				var slideno = this.props.params.slideno;
				var slidegoto = 0;
	
				if ($(window).width() >= 600) {
					if (slideno > 3) {
						slidegoto = slideno - 3;
					}
					this.setState({ goto: Math.ceil(slidegoto) }, function () {
						console.log(this.state.goto);
					});
				} else if ($(window).width() <= 360) {
					slidegoto = slideno;
					this.setState({ goto: Math.ceil(slidegoto) }, function () {
						console.log(this.state.goto);
					});
				} else if ($(window).width() <= 480) {
	
					if (slideno > 1) {
						slidegoto = slideno - 1;
					}
	
					this.setState({ goto: Math.ceil(slidegoto) }, function () {
						console.log(this.state.goto);
					});
				} else if ($(window).width() < 600) {
	
					if (slideno > 1) {
						slidegoto = slideno - 1;
					}
	
					this.setState({ goto: Math.ceil(slidegoto) }, function () {
						console.log(this.state.goto);
					});
				}
				(0, _withTracker.loadAnalytics)();
	
				/* outlet closed messages  */
				var outResult = helper.getStaticBlock('outlet-closed-message');
				outResult.then(function (stTes) {
					if (stTes.data.status === "ok") {
						_this5.setState({ outletCloseddMessage: stTes.data.result_set[0].staticblocks_description });
					}
				});
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var windowHeight = window.innerHeight;
				this.setState({ 'windowHeight': windowHeight - 45 + 'px' }); //productHeightNormal
				this.setState({ 'windowHeightNormal': windowHeight + 'px' });
				//this.setState({ 'productHeightNormal': (windowHeight + 100) + 'px' });
			}
	
			/* this function used to menu listing */
	
		}, {
			key: 'menuList',
			value: function menuList() {
	
				if (this.state.navStatus === "ok") {
					return _react2.default.createElement(
						'div',
						{ className: 'row ' },
						_react2.default.createElement(
							'div',
							{ className: 'container' },
							_react2.default.createElement(
								'div',
								{ className: 'tigger-menu', id: 'tigger-menu' },
								_react2.default.createElement(
									'div',
									{ className: 'dropup', id: 'dropup' },
									_react2.default.createElement(
										'a',
										{ className: 'dropdown-toggle', id: 'dropdownMenu2', 'data-toggle': 'dropdown', 'aria-haspopup': 'true', 'aria-expanded': 'false' },
										_react2.default.createElement('div', { className: 'float-btn' })
									),
									_react2.default.createElement(
										'ul',
										{ className: 'dropdown-menu', 'aria-labelledby': 'dropdownMenu2' },
										this.menuListingdropDown()
									)
								),
								_react2.default.createElement('a', { href: '#' })
							)
						)
					);
				}
			}
	
			/* this function used to load all content */
	
		}, {
			key: 'loadData',
			value: function loadData(categoryType, categoryId) {
				var _this6 = this;
	
				/* set cookie values */
				_reactCookie2.default.save('categoryType', categoryType);
				_reactCookie2.default.save('categoryId', categoryId);
				this.setState({ 'productHeightNormal': '0px' });
				var query_param = categoryType === "category" ? "category_id=" + categoryId : "subcategory_id=" + categoryId;
	
				var orderOutletIdtext = _reactCookie2.default.load('orderOutletId');
				var applyOutletIdtext = _reactCookie2.default.load('applyOutletId');
	
				if (typeof orderOutletIdtext !== "undefined" && orderOutletIdtext !== '' && applyOutletIdtext === 'yes') {
					query_param = query_param + "&outlet=" + orderOutletIdtext + "&applyOutletId=yes";
				}
	
				var promise = (0, _Api2.default)('product', query_param);
				promise.then(function (res) {
	
					if (res.data.status === "ok") {
	
						if (res.data.common.type === "Category") {
	
							_this6.setState({ categoryName: res.data.result_set[0].product_list[0][0].catgory_name });
							if (res.data.result_set[0].product_list[0][0].catgory_image !== null && res.data.result_set[0].product_list[0][0].catgory_image !== "") {
								_this6.setState({ categoryImSrc: config.path.tinThumpUrl + res.data.common.category_image_source + "/" + res.data.result_set[0].product_list[0][0].catgory_image + "&w=768&h=250&q=80" });
							} else {
								_this6.setState({ categoryImSrc: config.noImages.product_listing });
							}
						} else {
							/*	 console.log(res.data.common.subcategory_image_source +"/"+ res.data.result_set[0].product_list[0][0].subcatgory_image); */
	
							if (res.data.result_set[0].product_list[0][0].subcatgory_image !== null && res.data.result_set[0].product_list[0][0].subcatgory_image !== "") {
								_this6.setState({ categoryImSrc: res.data.common.subcategory_image_source + "/" + res.data.result_set[0].product_list[0][0].subcatgory_image });
							} else {
								_this6.setState({ categoryImSrc: config.noImages.product_listing });
							}
							_this6.setState({ categoryName: res.data.result_set[0].product_list[0][0].subcatgory_name });
						}
	
						_this6.setState({ products_common: res.data.common });
						_this6.setState({ products: res.data.result_set });
						_this6.setState({ status: res.data.status });
						if ((typeof orderOutletIdtext === "undefined" || orderOutletIdtext === '') && applyOutletIdtext === 'yes') {
							_this6.openOrderTupeChangeFun();
						}
						document.getElementById("loadIcon").style.display = "none";
						var windowHeh = window.innerHeight;
						var proHolderHeight = document.getElementById('productholder').clientHeight;
						var minusHeight = windowHeh - 120;
						var plusHeight = windowHeh + 100;
	
						if (minusHeight <= proHolderHeight && proHolderHeight <= plusHeight) {
	
							proHolderHeight = windowHeh + 100;
						}
	
						_this6.setState({ 'productHeightNormal': proHolderHeight + 'px' });
					} else {
						_this6.setState({ status: 'error' });
						document.getElementById("loadIcon").style.display = "none";
					}
				});
			}
	
			/* this function used  menu navigation  listing */
	
		}, {
			key: '__categoryList',
			value: function __categoryList() {
				var _this7 = this;
	
				if (this.state.status === "ok") {
					return this.state.products.map(function (loaddata, index) {
						return _react2.default.createElement(
							'div',
							{ id: 'productholder', className: 'row product-holder', key: index, style: _this7.state.products.length === index + 1 ? { marginBottom: "200px" } : {} },
							_react2.default.createElement(
								'h1',
								{ className: 'inner-title categorytitle' },
								_react2.default.createElement(
									'b',
									null,
									strp.stripslashes(loaddata.pro_subcate_name)
								)
							),
							!(0, _lodash.isEmpty)(loaddata.pro_subcate_description) && _react2.default.createElement(
								'p',
								{ className: 'text-justify', style: { textAlign: "justify", padding: "0px 0%" } },
								strp.stripslashes(loaddata.pro_subcate_description)
							),
							_this7.__productListing(loaddata.product_list[0])
						);
					});
				} else {
					return _react2.default.createElement(
						'div',
						{ className: 'row' },
						'   ',
						_react2.default.createElement(
							'div',
							{ className: 'col-xs-12 nav-head no_products_found  ' },
							_react2.default.createElement(
								'h1',
								{ className: 'main-title' },
								lang.no_products_found,
								' '
							)
						),
						'  '
					);
				}
			}
	
			/* image content */
	
		}, {
			key: 'productImagecontent',
			value: function productImagecontent(product_slug, product_thumbnail, product_stock) {
				if (product_thumbnail !== "") {
					var image = config.path.tinThumpUrl + this.state.products_common.image_source + "/" + product_thumbnail + "&w=200&h=200&q=80";
	
					var mobileImage = config.path.tinThumpUrl + this.state.products_common.image_source + "/" + product_thumbnail + "&w=200&h=250&q=80";
	
					// console.log("WindowHWidth", window.innerWidth)
	
					var windowWidth = window.innerWidth;
	
					if (windowWidth >= 480) {
						return _react2.default.createElement(
							'div',
							{ className: 'col-lg-3 col-md-3 col-sm-3 col-xs-3 thumb-img-div nopad', onClick: this.product_click_page.bind(this, product_slug) },
							product_stock === '0' && this.state.stockEnabled === 1 ? _react2.default.createElement('img', { className: 'product-main-image', src: image, alt: '', width: '100%' }) : _react2.default.createElement(
								_reactRouter.Link,
								{ to: "/product/" + product_slug },
								'  ',
								_react2.default.createElement('img', { className: 'product-main-image', src: image, alt: '', width: '100%' }),
								' '
							)
						);
					} else if (windowWidth <= 481) {
						return _react2.default.createElement(
							'div',
							{ className: 'col-lg-3 col-md-3 col-sm-3 col-xs-3 thumb-img-div nopad mobile-background' },
							_react2.default.createElement('div', { onClick: this.product_click_page.bind(this, product_slug), style: { backgroundImage: 'url(' + mobileImage + ')' }, className: 'product-backg-img' }),
							product_stock === '0' && this.state.stockEnabled === 1 ? _react2.default.createElement('img', { className: 'product-main-image', src: image, alt: '', width: '100%' }) : _react2.default.createElement(
								_reactRouter.Link,
								{ to: "/product/" + product_slug },
								'  ',
								_react2.default.createElement('img', { className: 'product-main-image', src: image, alt: '', width: '100%' }),
								' '
							)
						);
					}
				}
			}
		}, {
			key: 'product_click_page',
			value: function product_click_page(product_slug) {
	
				if (product_slug !== '') {
					_reactRouter.hashHistory.push('/product/' + product_slug);
				}
			}
		}, {
			key: 'getpickupOutletlist',
			value: function getpickupOutletlist() {
				var _this8 = this;
	
				_axios2.default.get(_constants.API_v4_URL + 'Getoutlets/pickup_outlets?app_id=' + APPID).then(function (res) {
					if (res.data.status === "ok") {
						_this8.setState({ Outlets: res.data.result_set });
					}
				});
			}
	
			/* imnage class */
	
		}, {
			key: 'productClass',
			value: function productClass(product_thumbnail) {
				return product_thumbnail !== "" ? "col-lg-9 col-md-9 col-sm-9 col-xs-9 product-cont" : "col-md-12 col-sm-12 col-xs-12";
			}
		}, {
			key: 'productvoucherClass',
			value: function productvoucherClass(product_thumbnail) {
				return product_thumbnail !== "" ? "col-lg-7 col-md-7 col-sm-7 col-xs-7" : "col-md-12";
			}
		}, {
			key: 'productVoucherImagecontent',
			value: function productVoucherImagecontent(product_slug, product_thumbnail, product_stock) {
				if (product_thumbnail !== "") {
					var image = config.path.tinThumpUrl + this.state.products_common.image_source + "/" + product_thumbnail + "&w=288&h=144&q=80";
					return _react2.default.createElement(
						'div',
						{ className: 'col-lg-5 col-md-5 col-sm-5 col-xs-5 thumb-img-div' },
						product_stock === '0' && this.state.stockEnabled === 1 ? _react2.default.createElement('img', { src: image, alt: '', width: '100%' }) : _react2.default.createElement(
							_reactRouter.Link,
							{ to: "/product/" + product_slug },
							'  ',
							_react2.default.createElement('img', { src: image, alt: '', width: '100%' }),
							' '
						)
					);
				}
			}
		}, {
			key: 'loadProductDate',
			value: function loadProductDate(date) {
				var product_date = new Date(date).toString().split(" ");
				return product_date[2] + "-" + product_date[1] + "-" + product_date[3];
			}
	
			/* product Listing */
	
		}, {
			key: '__productListing',
			value: function __productListing(proList) {
				var _this9 = this;
	
				return proList.map(function (product, index) {
					return _react2.default.createElement(
						'div',
						{ key: index, className: _this9.state.stockEnabled === 1 && product.product_stock === '0' ? product.product_type == "5" ? "productparent flex-product greyed" : "productparent greyed mobile-fix col-md-12 col-lg-12 col-sm-12 col-xs-12" : product.product_type == "5" ? "productparent flex-product" : "productparent greyed mobile-fix col-md-12 col-lg-12 col-sm-12 col-xs-12" },
						product.product_type == "5" ? _react2.default.createElement(
							'div',
							{ className: 'flex-product-inner' },
							_this9.productVoucherImagecontent(product.product_slug, product.product_thumbnail, product.product_stock),
							_this9.state.stockEnabled === 1 && product.product_stock === '0' ? _react2.default.createElement(
								'div',
								{ className: _this9.productvoucherClass(product.product_thumbnail) },
								_react2.default.createElement(
									'h1',
									{ className: 'head1 text-center' },
									' ',
									helper.truncate(strp.stripslashes(strp.ucfirst(helper.getAliasName(product.product_alias, product.product_name))), 1)
								),
								_this9.showTags(product.indicators),
								_react2.default.createElement(
									'div',
									{ className: 'product-desction-section' },
									_react2.default.createElement(
										'div',
										{ className: 'pro-des' },
										_react2.default.createElement(
											'p',
											{ className: '' },
											strp.stripslashes(helper.truncate(product.product_short_description))
										)
									),
									_this9.state.stockEnabled === 1 && product.product_stock === '0' && _react2.default.createElement(
										'div',
										{ className: 'nostock inside-cont' },
										'SOLD OUT'
									)
								)
							) : _react2.default.createElement(
								'div',
								{ className: _this9.productvoucherClass(product.product_thumbnail) },
								_react2.default.createElement(
									_reactRouter.Link,
									{ className: 'product-title', to: "/product/" + product.product_slug },
									_react2.default.createElement(
										'h1',
										{ className: 'head1 text-center' },
										' ',
										helper.truncate(strp.stripslashes(strp.ucfirst(helper.getAliasName(product.product_alias, product.product_name))), 1)
									),
									_this9.showTags(product.indicators),
									_react2.default.createElement(
										'p',
										{ className: 'text-center' },
										strp.stripslashes(helper.truncate(product.product_short_description)),
										' '
									)
								),
								product.product_type === "5" ? _react2.default.createElement(
									'div',
									{ className: 'expiry-available-food' },
									_react2.default.createElement(
										'span',
										null,
										'Expiry : ',
										_this9.loadProductDate(product.product_voucher_expiry_date)
									),
									' | ',
									_react2.default.createElement(
										'span',
										null,
										product.product_stock,
										' Available'
									)
								) : "",
								product.product_type === "5" ? _react2.default.createElement(
									'p',
									{ className: 'text-center voucher_product_list' },
									currency + product.product_price
								) : ""
							)
						) : _react2.default.createElement(
							'div',
							{ className: 'row' },
							_this9.productImagecontent(product.product_slug, product.product_thumbnail, product.product_stock),
							_this9.state.stockEnabled === 1 && product.product_stock === '0' ? _react2.default.createElement(
								'div',
								{ className: _this9.productClass(product.product_thumbnail) },
								_react2.default.createElement(
									'h1',
									{ className: 'head1' },
									' ',
									helper.truncate(strp.stripslashes(strp.ucfirst(helper.getAliasName(product.product_alias, product.product_name))), 1),
									' ',
									_react2.default.createElement(
										'p',
										{ className: ' price pull-right' },
										product.product_price
									)
								),
								_this9.showTags(product.indicators),
								_react2.default.createElement(
									'div',
									{ className: 'product-desction-section' },
									_react2.default.createElement(
										'div',
										{ className: 'pro-des' },
										_react2.default.createElement(
											'p',
											{ className: 'text-justify' },
											strp.stripslashes(helper.truncate(product.product_short_description))
										)
									),
									_this9.state.stockEnabled === 1 && product.product_stock === '0' && _react2.default.createElement(
										'div',
										{ className: 'nostock inside-cont' },
										'SOLD OUT'
									)
								)
							) : _react2.default.createElement(
								'div',
								{ className: _this9.productClass(product.product_thumbnail) },
								_react2.default.createElement(
									_reactRouter.Link,
									{ className: 'product-title', to: "/product/" + product.product_slug },
									_react2.default.createElement(
										'h1',
										{ className: 'head1' },
										' ',
										helper.truncate(strp.stripslashes(strp.ucfirst(helper.getAliasName(product.product_alias, product.product_name))), 1),
										' ',
										_react2.default.createElement(
											'p',
											{ className: ' price pull-right' },
											' ',
											' ',
											" ",
											product.product_price
										)
									),
									_this9.showTags(product.indicators),
									_react2.default.createElement(
										'p',
										{ className: 'text-justify' },
										strp.stripslashes(helper.truncate(product.product_short_description)),
										' '
									)
								)
							),
							_react2.default.createElement('div', { className: 'clearfix' })
						)
					);
				});
			}
	
			/* continue with pickup success */
	
		}, {
			key: 'pickupSuccess',
			value: function pickupSuccess() {
				/* load product items */
				var categoryId = this.props.params.categoryId;
				var categoryType = this.props.params.categoryType;
				this.loadMenuNav();
				this.loadData(categoryType, categoryId);
				$("#Pickup-Sucess").modal("hide");
				$("#pickup-outlet-sucess").modal('hide');
			}
	
			/* continue with delivery success */
	
		}, {
			key: 'deliverySuccess',
			value: function deliverySuccess() {
				/* load product items */
				var categoryId = this.props.params.categoryId;
				var categoryType = this.props.params.categoryType;
				this.loadMenuNav();
				this.loadData(categoryType, categoryId);
				$("#DeliverySucess").modal("hide");
			}
		}, {
			key: 'loadMenuNav',
			value: function loadMenuNav() {
				var _this10 = this;
	
				var orderOutletIdTxt = _reactCookie2.default.load('orderOutletId');
				var addqueryTxt = '';
	
				if (typeof orderOutletIdTxt !== "undefined" && orderOutletIdTxt !== '') {
					addqueryTxt = "&outletIdTxt=" + orderOutletIdTxt;
				}
	
				/* API CALL FOR PRODUCT MENU NAVIGATION */
				_axios2.default.get(APIURL + 'productsver3/navigation_menu?app_id=' + APPID + addqueryTxt + "&availability=" + _reactCookie2.default.load('defaultAvilablityId')).then(function (res) {
					_this10.setState({ navStatus: res.data.status });
					_this10.setState({ common: res.data.common });
					_this10.setState({ category: res.data.result_set });
				});
			}
		}, {
			key: 'closeDeliveryErr',
			value: function closeDeliveryErr() {
				this.setState({ load: "false" });
				$("#DeliveryError").modal("toggle");
			}
	
			/* Open Zipcode popup */
	
		}, {
			key: 'changeDelivery',
			value: function changeDelivery() {
				this.setState({ load: "false" });
				$("#DeliveryError").modal("hide");
				if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
					$("#AddressList").modal({ backdrop: 'static', keyboard: false });
				} else {
					$("#DeliveryAddress").modal({ backdrop: 'static', keyboard: false });
				}
			}
		}, {
			key: 'handleChange',
			value: function handleChange(event) {
				this.setState({ addressField: event.target.value });
			}
		}, {
			key: 'handleChangeValue',
			value: function handleChangeValue(event) {
				this.setState({ addressField: event.target.value });
			}
	
			/* Validate zipcode */
	
		}, {
			key: 'validatezip',
			value: function validatezip(e) {
				var re = /[0-9A-F:]+/g;
				if (!re.test(e.key)) {
					e.preventDefault();
				}
			}
	
			/* delivery timing */
	
		}, {
			key: 'showDeliveryTiming',
			value: function showDeliveryTiming() {
				if (APPID === apps.leanbento) {
					return _react2.default.createElement(
						'p',
						null,
						_react2.default.createElement(
							'b',
							null,
							'Your Order is handled by:'
						),
						_react2.default.createElement('br', null),
						' ',
						this.state.orderHandled
					);
				}
			}
	
			/* used to get all secondary address list */
	
		}, {
			key: 'getSecAddr',
			value: function getSecAddr() {
				var _this11 = this;
	
				console.log('safsf');
				_axios2.default.get(APIURL + '/customer/get_user_secondary_address?app_id=' + APPID + "&refrence=" + _reactCookie2.default.load('UserId')).then(function (res) {
					if (res.data.status === "ok") {
						_this11.setState({ secAddrData: res.data.result_set });
					}
				});
			}
	
			/* used to load address list */
	
		}, {
			key: 'loadAddressList',
			value: function loadAddressList() {
				var _this12 = this;
	
				return this.state.secAddrData.map(function (item, index) {
					return _react2.default.createElement(
						'p',
						{ key: index },
						_react2.default.createElement('input', { name: 'radio', value: item.postal_code, id: item.secondary_address_id, className: 'css-radio', type: 'radio', onChange: _this12.handleChange }),
						_react2.default.createElement(
							'label',
							{ htmlFor: item.secondary_address_id, className: 'css-label ' },
							' ',
							item.address + " Singapore " + item.postal_code
						)
					);
				});
			}
	
			/* load outlets */
	
		}, {
			key: '__loadOutlets',
			value: function __loadOutlets() {
				var _this13 = this;
	
				if (this.state.Outlets) {
					var list = helper.getSortedList(this.state.Outlets, this.props.coords);
					return !(0, _lodash.isEmpty)(list) && list.map(function (loaddata, index) {
						return _react2.default.createElement(
							'div',
							{ className: 'map-li ', key: index, onClick: _this13.pickOutlet.bind(_this13, loaddata.outlet_id, loaddata.outlet_name, loaddata.outlet_postal_code, loaddata.outlet_address_line1, loaddata.outlet_address_line2, loaddata.outlet_unit_number1, loaddata.outlet_unit_number2, loaddata.outlet_pickup_tat, loaddata.outlet_tax_option, loaddata.outlet_tax_surcharge, loaddata.outlet_tax_surcharge_inclusive) },
							_react2.default.createElement(
								'p',
								{ className: 'map-h outlet-name' },
								helper.stripslashes(loaddata.outlet_name)
							),
							_react2.default.createElement(
								'p',
								{ className: 'map-sub' },
								loaddata.outlet_address_line1 + ", " + loaddata.outlet_address_line2 + " " + loaddata.outlet_postal_code
							),
							_react2.default.createElement(_Distancebar2.default, { minDateValue: loaddata.min_date, isOutletBased: loaddata.is_outlet_based, distance: loaddata.distance, coords: _this13.props.coords, tat: loaddata.outlet_pickup_tat ? loaddata.outlet_pickup_tat : loaddata.outlet_delivery_timing })
						);
					});
				}
			}
	
			/* pick outlet */
	
		}, {
			key: 'pickOutlet',
			value: function pickOutlet(outlet_id, outlet_name, outlet_postal_code, outlet_address_line1, outlet_address_line2, outlet_unit_number1, outlet_unit_number2, outlet_pickup_tat, outlet_tax_option, outlet_tax_surcharge, outlet_tax_surcharge_inclusive) {
	
				var orderHandled = outlet_name + " " + outlet_address_line1 + " " + outlet_address_line2 + ", Singapore " + outlet_postal_code;
	
				this.setState({ orderHandled: orderHandled });
				_reactCookie2.default.save('orderOutletId', outlet_id);
				_reactCookie2.default.save('orderOutletName', outlet_name);
				_reactCookie2.default.save('orderPostalCode', outlet_postal_code);
				_reactCookie2.default.save('orderTAT', outlet_pickup_tat);
				_reactCookie2.default.save('orderHandled', orderHandled);
				_reactCookie2.default.save('orderHandledByText', orderHandled);
	
				_reactCookie2.default.save('outlet_tax_option', outlet_tax_option);
				_reactCookie2.default.save('outlet_tax_surcharge', outlet_tax_surcharge);
				_reactCookie2.default.save('outlet_tax_surcharge_inclusive', outlet_tax_surcharge_inclusive);
	
				$("#Pickup-OutletSelection").modal("hide");
				$("#Pickup-Sucess").modal({ backdrop: 'static', keyboard: false });
			}
	
			/* Select outlet */
	
		}, {
			key: 'selectOutlet',
			value: function selectOutlet(thisobject) {
				var retry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				var _this14 = this;
	
				var callbackPostalCode = arguments[2];
				var addressObj = arguments[3];
	
	
				var postalcode = "";
				var address = "";
				var googleRetryAttempt = 0;
				if (retry === false) {
					if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
						postalcode = $("#postalcode").val(); //"postalcode";
					} else {
						postalcode = $("#postalcode1").val(); // "postalcode1";
					}
				} else {
					postalcode = callbackPostalCode;
					address = addressObj;
					googleRetryAttempt = 1;
				}
	
				this.setState({ load: "true" });
				var findPostUrl = APIURL + 'outlets/find_outlet?skip_timing=Yes&app_id=' + APPID + "&availability_id=" + _reactCookie2.default.load('defaultAvilablityId') + "&postal_code=" + postalcode;
				if (parseInt(this.state.zoneEnabled) === 1) {
					findPostUrl = _constants.API_v4_URL + 'test/outlets/findOutletZone?skip_timing=Yes&app_id=' + APPID + "&availability_id=" + _reactCookie2.default.load('defaultAvilablityId') + "&postal_code=" + postalcode + "&outlet_id=" + this.state.zoneDeliveryOutlet + "&googleRetryAttempt=" + googleRetryAttempt + "&addressObject=" + address;
				}
				/*add loading */
				_axios2.default.get(findPostUrl).then(function (res) {
	
					/* Success response */
					/* Success response  && Object.keys(res.data.result_set.postal_code_information).length !==0 */
					if (res.data.status === "ok") {
						var orderDeliveryAddress = res.data.result_set.postal_code_information.zip_buno + " " + res.data.result_set.postal_code_information.zip_sname;
						var orderHandled = res.data.result_set.outlet_name + ", Crew will be seeing you in " + res.data.result_set.outlet_delivery_timing + " Minutes";
						_this14.setState({ orderDeliveryAddress: orderDeliveryAddress + " Singapore " + res.data.result_set.postal_code_information.zip_code });
						_this14.setState({ orderHandled: orderHandled });
						_reactCookie2.default.save('orderOutletId', res.data.result_set.outlet_id);
						_reactCookie2.default.save('orderOutletName', res.data.result_set.outlet_name);
						_reactCookie2.default.save('orderPostalCode', res.data.result_set.postal_code_information.zip_code);
						_reactCookie2.default.save('orderTAT', res.data.result_set.outlet_delivery_timing);
						_reactCookie2.default.save('orderDeliveryAddress', orderDeliveryAddress);
						_reactCookie2.default.save('orderHandled', orderHandled);
	
						_reactCookie2.default.save('outlet_tax_option', res.data.result_set.outlet_tax_option);
						_reactCookie2.default.save('outlet_tax_surcharge', res.data.result_set.outlet_tax_surcharge);
						_reactCookie2.default.save('outlet_tax_surcharge_inclusive', res.data.result_set.outlet_tax_surcharge_inclusive);
	
						var orderHandledText = res.data.result_set.outlet_name + " " + res.data.result_set.outlet_address_line1 + " " + res.data.result_set.outlet_address_line2 + ", Singapore " + postalcode;
						_reactCookie2.default.save('orderHandledByText', orderHandledText);
	
						if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
							$("#AddressList").modal("hide");
						} else {
							$("#DeliveryAddress").modal("hide");
						}
						$("#DeliverySucess").modal('show');
						$("#address-auto").modal("hide");
						if (parseInt(_this14.state.zoneEnabled) === 1) {
							_reactCookie2.default.save('orderZoneID', res.data.result_set.zone_id);
						}
					}
	
					/* Error response */
					if (res.data.status === "error") {
						_this14.setState({ load: "false" });
	
						/* check google api result */
						var google_api_result = false;
						if (typeof res.data.not_fount_in_google !== "undefined" && res.data.not_fount_in_google === true) {
							_this14.setState({ enableAddressSearch: true });
							google_api_result = true;
						} else {
							_this14.setState({ enableAddressSearch: false });
						}
						if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
							$("#AddressList").modal("hide");
						} else {
							$("#DeliveryAddress").modal("hide");
						}
						if (google_api_result === false) {
							$("#address-auto").modal("hide");
							$("#DeliveryError").modal('show');
						} else {
							$("#address-auto").modal("show");
						}
					}
				});
			}
		}, {
			key: 'openOrderTupeChangeFun',
			value: function openOrderTupeChangeFun() {
				if (_reactCookie2.default.load('applyOutletId') === 'yes') {
					if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && _reactCookie2.default.load('defaultAvilablity') === lang.delivery) {
						_reactCookie2.default.save('dineinClick', 'no');
						if (typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderPostalCode') === "undefined") {
							if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
	
								if (this.state.zoneEnabled === 1) {
									if (parseInt(this.state.zonePopupDisable) === 1) {
										$("#AddressList").modal({ backdrop: 'static', keyboard: false });
									} else {
										$("#delivery_outlet").modal({ backdrop: 'static', keyboard: false });
									}
								} else {
									$("#AddressList").modal({ backdrop: 'static', keyboard: false });
								}
							} else {
								if (this.state.zoneEnabled === 1) {
									if (parseInt(this.state.zonePopupDisable) === 1) {
										$("#DeliveryAddress").modal({ backdrop: 'static', keyboard: false });
									} else {
										$("#delivery_outlet").modal({ backdrop: 'static', keyboard: false });
									}
								} else {
									$("#DeliveryAddress").modal({ backdrop: 'static', keyboard: false });
								}
							}
						}
					} else if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.pickupId && _reactCookie2.default.load('defaultAvilablity') === lang.takeaWay) {
						_reactCookie2.default.save('dineinClick', 'no');
	
						var pickupOutlets = this.state.Outlets;
	
						if (typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderPostalCode') === "undefined") {
							if (this.state.Outlets.length === 0) {
								this.getpickupOutletlist();
							} else if (this.state.Outlets.length === 1) {
	
								var orderHandled = pickupOutlets[0].outlet_name + " " + pickupOutlets[0].outlet_address_line1 + " " + pickupOutlets[0].outlet_address_line2 + ", Singapore " + pickupOutlets[0].outlet_postal_code;
	
								this.setState({ orderHandled: orderHandled });
								_reactCookie2.default.save('orderOutletId', pickupOutlets[0].outlet_id);
								_reactCookie2.default.save('orderOutletName', pickupOutlets[0].outlet_name);
								_reactCookie2.default.save('orderPostalCode', pickupOutlets[0].outlet_postal_code);
								_reactCookie2.default.save('orderTAT', pickupOutlets[0].outlet_pickup_tat);
								_reactCookie2.default.save('orderHandled', orderHandled);
								_reactCookie2.default.save('orderHandledByText', orderHandled);
	
								_reactCookie2.default.save('outlet_tax_option', pickupOutlets[0].outlet_tax_option);
								_reactCookie2.default.save('outlet_tax_surcharge', pickupOutlets[0].outlet_tax_surcharge);
								_reactCookie2.default.save('outlet_tax_surcharge_inclusive', pickupOutlets[0].outlet_tax_surcharge_inclusive);
	
								_reactCookie2.default.save('outlet_option_single', 1);
	
								$("#pickup-outlet-sucess").modal("toggle");
							} else {
								$("#Pickup-OutletSelection").modal({ backdrop: 'static', keyboard: false });
							}
						}
					} else if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId && _reactCookie2.default.load('defaultAvilablity') === "Dine In") {
						if (typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderTableNo') === "undefined" || _reactCookie2.default.load('orderOutletId') === "" || _reactCookie2.default.load('orderTableNo') === "") {
							_reactCookie2.default.save('dineinClick', 'yes');
							_reactCookie2.default.remove('orderTableNo');
							if (typeof _reactCookie2.default.load('UserId') === "undefined" || _reactCookie2.default.load('UserId') && _reactCookie2.default.load('UserId') === "") {
								_reactRouter.hashHistory.push("/sign-in");
							} else {
								if (APPID === "287E5552-328E-4DBE-A3CA-E998ACCAC9BD") {
									helper.sarveshTableSetup();
								} else {
									_reactRouter.hashHistory.push("/book-a-table");
								}
							}
						}
					}
				}
			}
		}, {
			key: 'gobackHome',
			value: function gobackHome() {
				_reactRouter.hashHistory.push("/");
			}
	
			/* this fucntion used to load  product tags  */
	
		}, {
			key: 'showTags',
			value: function showTags(tags) {
				//console.log(tags);
				if (tags !== null) {
					var splited = tags.split(",");
					var tagsText = "";
	
					for (var i = 0, length = splited.length; i < length; i++) {
						tagsText += "<span className='label label-success text-uppercase'>" + splited[i] + "</span>";
						//tagsText+={"<p>"};
					}
					tagsText = '<p className="tags">' + tagsText + '</p>';
					var htmlToReactParser = new HtmlToReactParser();
					var reactElement = htmlToReactParser.parse(tagsText);
					//var reactHtml = ReactDOMServer.renderToStaticMarkup(reactElement);
	
					return reactElement; //assert.equal(reactHtml, htmlInput);
	
					//return tagsText;
				}
			}
		}, {
			key: 'getOptions',
			value: function getOptions(input) {
	
				var orderOutletIdtext = _reactCookie2.default.load('orderOutletId');
				var applyOutletIdtext = _reactCookie2.default.load('applyOutletId');
				var addquery_txt = '';
	
				if (applyOutletIdtext === 'yes') {
					if (typeof orderOutletIdtext !== "undefined" && orderOutletIdtext !== '') {
						addquery_txt = "&outletId=" + orderOutletIdtext + "&applyOutletId=yes";
					}
				}
	
				var searchResult = [];
				return _axios2.default.get(APIURLPRO + '/products/products_search?app_id=' + APPID + "&availability=" + _reactCookie2.default.load('defaultAvilablityId') + addquery_txt + "&search_value=" + input).then(function (response) {
					if (response.data.status === "ok") {
						var resultData = response.data.result_set;
						resultData.map(function (loadData) {
							return searchResult.push({ value: loadData.product_slug, label: strp.stripslashes(helper.getAliasName(loadData.product_alias, loadData.product_name)) });
						});
					}
	
					return { options: searchResult };
				});
			}
	
			/* ViewProducts */
	
		}, {
			key: 'ViewProducts',
			value: function ViewProducts(event) {
				var productSlug = event.value;
				_reactRouter.hashHistory.push("/product/" + productSlug);
			}
	
			/*this function used to shoe product thump image /
	  __productImage(product_thumbnail,imagePath){
	     return  (product_thumbnail === "" )? config.noImages.product_thumbnail : config.path.tinThumpUrl+this.state.products_common.image_source+"/"+product_thumbnail+"&w=288&h=144&q=80";
	  }
	   */
	
		}, {
			key: 'showZonalPostalCode',
			value: function showZonalPostalCode(outletId) {
				this.setState({ "zoneOutletSeleted": "Yes" });
				$("#delivery_outlet").modal("toggle");
				if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
					$("#AddressList").modal("toggle");
				} else {
					$("#DeliveryAddress").modal("toggle");
				}
	
				this.setState({ zoneDeliveryOutlet: outletId });
			}
		}, {
			key: '__loadDeliveryOutlets',
			value: function __loadDeliveryOutlets() {
				var _this15 = this;
	
				if (this.state.deliveryOutlets) {
					var list = helper.getSortedList(this.state.deliveryOutlets, this.props.coords);
					if (!(0, _lodash.isEmpty)(list)) {
						return list.map(function (loaddata, index) {
							return _react2.default.createElement(
								'div',
								{ className: 'map-li', key: index, onClick: _this15.showZonalPostalCode.bind(_this15, loaddata.outlet_id) },
								_react2.default.createElement(
									'p',
									{ className: 'map-h outlet-name' },
									helper.stripslashes(loaddata.outlet_name)
								),
								_react2.default.createElement(
									'p',
									{ className: 'map-sub' },
									_this15.showNewAddressFrmd(loaddata.outlet_postal_code, loaddata.outlet_address_line1, '', '', ''),
									' ',
									loaddata.outlet_unit_number2
								),
								_react2.default.createElement(_Distancebar2.default, { minDateValue: loaddata.min_date, isOutletBased: loaddata.is_outlet_based, distance: loaddata.distance, coords: _this15.props.coords, tat: loaddata.outlet_delivery_tat ? loaddata.outlet_delivery_tat : loaddata.outlet_delivery_timing })
							);
						});
					} else {
						return _react2.default.createElement(_Outletclosedmessage2.default, { messages: this.state.outletCloseddMessage });
					}
				}
			}
		}, {
			key: 'backToDeliveryBack',
			value: function backToDeliveryBack() {
				$("#DeliveryAddress").modal("toggle");
				$("#delivery_outlet").modal("toggle");
			}
		}, {
			key: 'showZonalBackButton',
			value: function showZonalBackButton() {
				if (parseInt(this.state.zoneEnabled) === 1 && this.state.zonePopupDisable === 0) {
					return _react2.default.createElement(
						'div',
						{ className: 'col-sm-6 popup-back-btn' },
						_react2.default.createElement(
							'button',
							{ type: 'button', onClick: this.backToDeliveryBack.bind(this), className: 'btn btn-raised btn-info ' },
							'Go Back'
						)
					);
				}
			}
		}, {
			key: 'showNewAddressFrmd',
			value: function showNewAddressFrmd(pstcode, address1, address2, unittxt1, unittxt2) {
				var addressLn = address2 != '' ? address1 + ", " + address2 : address1;
				if (unittxt1 != '' && unittxt2 != '') {
					addressLn = addressLn + ", #" + unittxt1 + "-" + unittxt2;
				} else if (unittxt1 != '' || unittxt2 != '') {
					addressLn = unittxt1 != '' ? addressLn + ", #" + unittxt1 : addressLn + ", #" + unittxt2;
				}
	
				addressLn = addressLn + ", Singapore " + pstcode;
				return addressLn;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this16 = this;
	
				var sliderCount = 5;
				var windowWidth = window.innerWidth;
				if (windowWidth <= 768 && windowWidth > 767) {
					sliderCount = 3;
				} else if (windowWidth <= 767 && windowWidth > 479) {
					sliderCount = 3;
				} else if (windowWidth <= 479) {
					sliderCount = 3;
				}
	
				var settingsGallery = {
					infinite: false,
					arrows: true,
					slidesToShow: sliderCount,
					slidesToScroll: sliderCount,
					speed: 500,
					swipe: sliderCount,
					initialSlide: this.state.goto,
					ref: function ref(_ref) {
						return _this16.slider = _ref;
					},
					afterChange: function afterChange() {
						return _this16.setState(function (state) {
							return { updateCount: state.updateCount + 1 };
						});
					},
					beforeChange: function beforeChange(current, next) {
						return _this16.setState({ slideIndex: next });
					},
					responsive: [{
						breakpoint: 600,
						settings: {
							slidesToShow: 3
						}
					}, {
						breakpoint: 480,
						settings: {
							slidesToShow: 2
						}
					}, {
						breakpoint: 360,
						settings: {
							slidesToShow: 1
						}
					}]
				};
	
				if (this.state.status === "Loading") {
	
					return _react2.default.createElement(
						'div',
						{ className: 'container-fluid desktop-container position-rel', style: { minHeight: this.state.windowHeightNormal } },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(Loading, null)
						)
					);
				} else {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_LocationSearchInput2.default, { loading: this.state.status, open: this.state.enableAddressSearch, parentCallback: this.selectOutlet, postalcode: this.state.addressField }),
						_react2.default.createElement(_reactDocumentMeta2.default, meta),
						_react2.default.createElement(
							'div',
							{ id: 'loadIcon', style: { display: 'none', bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto', zIndex: 99, background: 'rgba(255, 255, 255, 0.8)' } },
							' ',
							_react2.default.createElement('img', { style: { bottom: 0, left: 0, position: 'absolute', right: 0, top: 0, margin: 'auto' }, src: '/img/loader.gif', alt: 'Loading' }),
							' '
						),
						_react2.default.createElement(
							'div',
							{ className: 'header-sticky' },
							_react2.default.createElement(
								'div',
								{ className: '' },
								_react2.default.createElement(
									'div',
									{ className: 'container-fluid desktop-container' },
									_react2.default.createElement(
										'div',
										{ className: 'row' },
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-12 top-nav inner-top-nav head-main' },
											_react2.default.createElement(
												'div',
												{ className: 'col-xs-2 nav-head pd-l-20 head-child' },
												' ',
												_react2.default.createElement(
													_reactRouter.Link,
													{ to: "/", className: 'backarrow' },
													_react2.default.createElement('img', { src: '/img/icons/arrow-right.png', className: 'left_arr icon-img-small-3', alt: 'left-arrow' })
												)
											),
											_react2.default.createElement('div', { className: 'col-sm-6 col-xs-4 nav-head head-child' }),
											_react2.default.createElement(
												'div',
												{ className: 'col-sm-4 col-xs-6 nopadding head-child' },
												_react2.default.createElement(
													'p',
													{ className: 'b-txt text-right ' },
													config.enablescan === 'Yes' && _react2.default.createElement(
														'a',
														{ href: 'https://scan.ninjapro.co', className: 'scan-icon-a' },
														_react2.default.createElement('img', { alt: '', src: '/img/icons/Scan-to-add-btn.png', className: 'icon-img-small-scan head_serch' })
													),
													_react2.default.createElement(
														_reactRouter.Link,
														{ 'data-toggle': 'collapse', to: "#SearchBAR", 'aria-expanded': 'false', 'aria-controls': 'collapseExample', className: 'headsearch-icon' },
														_react2.default.createElement('img', { alt: '', src: '/img/icons/search-new.png', className: 'icon-img-small4 head_serch' })
													),
													_react2.default.createElement(
														_reactRouter.Link,
														{ to: "/cart", className: helper.cartClass() },
														' ',
														helper.cartCount(),
														'  ',
														_react2.default.createElement('img', { alt: '', src: this.loadCartImage(), className: 'icon-img-small-1 carticon' }),
														' '
													),
													config.enablescan === 'Yes' && _react2.default.createElement(
														'div',
														{ className: 'scan-tooltip' },
														'Click here to Scan QR Code & Add to Cart ',
														_react2.default.createElement(
															'a',
															{ onClick: this.closeTooltip.bind(this) },
															_react2.default.createElement(
																'span',
																null,
																_react2.default.createElement(
																	'i',
																	{ className: 'material-icons' },
																	'close'
																)
															)
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'collapse', id: 'SearchBAR' },
												_react2.default.createElement(
													'div',
													{ className: '' },
													_react2.default.createElement(
														'div',
														{ className: 'form-group SearchBAR' },
														_react2.default.createElement(
															'div',
															{ className: 'input-group' },
															_react2.default.createElement(Select.Async, {
																name: 'form-field-name',
																placeholder: APPID == '68009D56-9386-4ECE-92D8-6F81E11B8742' ? 'what are you in the mood for today' : 'Go ahead search for a dish...',
																noResultsText: 'No Products Found',
																autoload: false,
	
																loadOptions: this.getOptions.bind(this),
																onChange: this.ViewProducts.bind(this)
															})
														)
													)
												)
											)
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid desktop-container fixedheader-container', style: { minHeight: this.state.windowHeightNormal } },
							_react2.default.createElement(Alert, null),
							_react2.default.createElement('div', { id: 'parentDisable' }),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'product-banner' },
									_react2.default.createElement('img', { alt: '', src: this.state.categoryImSrc, className: 'img-responsive' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'category_sticky' },
								_react2.default.createElement(
									_reactStickyEl2.default,
									{ topOffset: 80, bottomOffset: 80 },
									_react2.default.createElement(
										'div',
										{ className: 'category_slider scrollmain' },
										_react2.default.createElement(
											_reactSlick2.default,
											Object.assign({ ref: function ref(slider) {
													return _this16.slider = slider;
												} }, settingsGallery),
											this.menuListing()
										)
									)
								)
							),
							this.__categoryList()
						),
						_reactCookie2.default.load("cartValue") === 'Yes' && _react2.default.createElement(
							'div',
							{ className: 'category-footer' },
							_react2.default.createElement(
								'div',
								{ className: 'container-fluid desktop-container' },
								_react2.default.createElement(
									'p',
									{ className: 'carttotal' },
									_react2.default.createElement(
										'span',
										null,
										parseInt(_reactCookie2.default.load('cartCount')),
										' Item (s) in Cart'
									),
									_react2.default.createElement(
										'label',
										null,
										_react2.default.createElement(
											'sup',
											null,
											'$'
										),
										_reactCookie2.default.load("cart_grand_total")
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'checkout-button' },
									_react2.default.createElement(
										'button',
										{ onClick: function onClick() {
												_reactRouter.hashHistory.push("/cart");;
											} },
										'Checkout'
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal common-distance', id: 'Pickup-OutletSelection' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog locWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', onClick: this.gobackHome.bind(this), 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											'Select Your Pickup Location'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'div',
											{ className: 'map-loc' },
											_react2.default.createElement(
												'div',
												{ className: 'map-box scrollbar', id: 'style-3' },
												this.__loadOutlets()
											),
											_react2.default.createElement('br', null),
											_react2.default.createElement('br', null)
										)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'Pickup-Sucess' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/DeliverySucess.gif', className: 'img-responsive', alt: '' }),
											'Awesome, you can pickup !'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body text-center' },
										this.showDeliveryTiming,
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.pickupSuccess.bind(this), className: 'btn btn-raised btn-info ' },
											'Continue'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'pickup-outlet-sucess' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: '' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/DeliverySucess.gif', className: 'img-responsive', alt: '' }),
											'Awesome, you can pickup !'
										),
										_react2.default.createElement(
											'p',
											null,
											_reactCookie2.default.load('orderHandled')
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body text-center' },
										this.showDeliveryTiming,
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.pickupSuccess.bind(this), className: 'btn btn-raised btn-info ' },
											'Continue'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'DeliveryAddress' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', onClick: this.gobackHome.bind(this), 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											'Your Delivery Address'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'div',
											{ className: 'form-group label-floating is-empty card-no' },
											_react2.default.createElement(
												'div',
												{ className: 'input-group' },
												_react2.default.createElement(
													'label',
													{ className: 'control-label' },
													'Enter Your Postal Code'
												),
												_react2.default.createElement('input', { value: this.state.addressField, id: 'postalcode1', maxLength: '6', className: 'form-control', onKeyPress: function onKeyPress(e) {
														return _this16.validatezip(e);
													}, onChange: this.handleChangeValue })
											)
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										this.showZonalBackButton(),
										_react2.default.createElement(
											'div',
											{ className: parseInt(this.state.zoneEnabled) === 1 && this.state.zonePopupDisable === 0 ? "col-sm-6 popup-back-btn" : "col-sm-12" },
											_react2.default.createElement(
												'button',
												{ type: 'button', onClick: this.selectOutlet.bind(this), className: 'btn btn-raised btn-info ' },
												'Continue'
											)
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal common-distance', id: 'delivery_outlet' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog locWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement(
											'h3',
											{ className: 'modal-title' },
											'Please select which outlet is nearest to your',
											_react2.default.createElement('br', null),
											'delivery location '
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'div',
											{ className: 'map-loc' },
											_react2.default.createElement(
												'div',
												{ className: 'map-box scrollbar', id: 'style-3' },
												this.__loadDeliveryOutlets()
											),
											_react2.default.createElement('br', null),
											_react2.default.createElement('br', null)
										)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'AddressList' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', onClick: this.gobackHome.bind(this), 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/DeliverySucess.gif', className: 'img-responsive', alt: true }),
											'Your Delivery Address'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body', style: { textAlign: 'left' } },
										this.loadAddressList(),
										_react2.default.createElement(
											'p',
											null,
											_react2.default.createElement('input', { value: this.state.addressField, onChange: this.handleChangeValue, id: 'postalcode', maxLength: '6', placeholder: 'Enter Your Postal Code', className: 'add_list', onKeyPress: function onKeyPress(e) {
													return _this16.validatezip(e);
												} })
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.selectOutlet.bind(this), className: 'btn btn-raised btn-info ' },
											'Continue'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'DeliverySucess' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/DeliverySucess.gif', className: 'img-responsive', alt: 'thumb-up' }),
											'Awesome, we can deliver!'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body text-center' },
										_react2.default.createElement(
											'p',
											null,
											_react2.default.createElement(
												'b',
												null,
												'Your Delivery Address: '
											),
											_react2.default.createElement('br', null),
											this.state.orderDeliveryAddress
										),
										this.showdeliveryTiming,
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.deliverySuccess.bind(this), className: 'btn btn-raised btn-info ' },
											'Continue'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'DeliveryError' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', onClick: this.gobackHome.bind(this), 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/Cant_Deliver.png', className: 'img-responsive', alt: '' }),
											'Sorry !'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'p',
											null,
											'Sorry we cant deliver to your address ',
											_react2.default.createElement('br', null),
											'Do you want to change your address or check again later ?'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-3' },
											'\xA0'
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-6' },
											_react2.default.createElement(
												'button',
												{ type: 'button', onClick: this.changeDelivery.bind(this), className: 'col-lg-6 btn btn-raised btn-info fullwidth ' },
												'Change Address'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-3' },
											'\xA0'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						)
					);
				} /* else {
	     return (
	     <div>
	     <DocumentMeta  {...meta} />
	     <div id="loadIcon" style={{ display: 'none', bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto', zIndex: 99, background: 'rgba(255, 255, 255, 0.8)' }} > <img style={{ bottom: 0, left: 0, position: 'absolute', right: 0, top: 0, margin: 'auto' }} src="/img/loader.gif" alt="Loading" /> </div>
	     <div className="container-fluid desktop-container" style={{ minHeight: this.state.windowHeightNormal }}>
	     	<div id="parentDisable"></div>
	     	<div className="row">
	     		<div className="col-xs-12 top-nav inner-top-nav">
	     			<div className="col-xs-3 nav-head pd-l-20">
	     				<Link to="/">  <img alt="" src="/img/icons/arrow-right.png" className="icon-img-small-3" /></Link>
	     			</div>
	     				<div className="col-xs-6 nav-head ">
	     				<h1 className="main-title">{lang.no_products_found} </h1>
	     			</div>
	     					</div>
	     	</div>
	      
	     	{this.menuList()}
	     			</div>
	     		</div>);
	     } */
			}
		}]);
	
		return Products;
	}(_react2.default.Component);
	
	exports.default = (0, _reactGeolocated.geolocated)({
		positionOptions: {
			enableHighAccuracy: false
		},
		userDecisionTimeout: 5000
	})(Products);

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(9);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Distancebar = __webpack_require__(102);
	
	var _Distancebar2 = _interopRequireDefault(_Distancebar);
	
	var _Outletclosedmessage = __webpack_require__(103);
	
	var _Outletclosedmessage2 = _interopRequireDefault(_Outletclosedmessage);
	
	var _lodash = __webpack_require__(30);
	
	var _reactGeolocated = __webpack_require__(179);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactSlick = __webpack_require__(455);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _LocationSearchInput = __webpack_require__(129);
	
	var _LocationSearchInput2 = _interopRequireDefault(_LocationSearchInput);
	
	var _constants = __webpack_require__(65);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable  */
	
	
	var strp = __webpack_require__(31);
	var config = __webpack_require__(7);
	var lang = __webpack_require__(12);
	
	var APIURL = config.path.apiUrl;
	var APIURLv2 = config.path.apiUrlv2;
	var APIURLPRO = config.path.apiUrlPro;
	var APPID = config.ids.appId;
	
	var qs = __webpack_require__(3);
	var helper = __webpack_require__(13);
	var HtmlToReactParser = __webpack_require__(21).Parser;
	var htmlToReactParser = new HtmlToReactParser();
	var Loading = __webpack_require__(17);
	var Overlay = __webpack_require__(64);
	var nl2br = __webpack_require__(839);
	var apps = __webpack_require__(29);
	
	var _ = __webpack_require__(30);
	//import Map from './Map';
	var combo_0 = [];var combo_1 = [];var combo_2 = [];var combo_3 = [];var combo_4 = [];var combo_5 = [];var combo_6 = [];
	var combo_7 = [];var combo_8 = [];var combo_9 = [];var combo_10 = [];var combo_11 = [];var combo_12 = [];var combo_13 = [];
	var combo_14 = [];var combo_15 = [];var combo_16 = [];var combo_17 = [];var combo_18 = [];var combo_19 = [];var combo_20 = [];var combo_21 = [];var combo_22 = [];var combo_23 = [];var combo_24 = [];var combo_25 = [];
	
	/* Load meta tags */
	var meta = {
		title: lang.home_meta_title,
		description: lang.home_meta_title,
		meta: {
			name: {
				keywords: lang.home_meta_title
			}
		}
	};
	
	/* my test coding */
	
	var Productsdetails = function (_React$Component) {
		_inherits(Productsdetails, _React$Component);
	
		function Productsdetails(props) {
			var _this$state;
	
			_classCallCheck(this, Productsdetails);
	
			var _this = _possibleConstructorReturn(this, (Productsdetails.__proto__ || Object.getPrototypeOf(Productsdetails)).call(this, props));
	
			_this.handleChangeTxt = function (item, event) {
				_this.setState(_defineProperty({}, item, event.target.value));
				_this.setState(_defineProperty({}, 'error_' + item, ''));
			};
	
			combo_0 = [];combo_1 = [];combo_2 = [];combo_3 = [];combo_4 = [];combo_5 = [];combo_6 = [];
			combo_7 = [];combo_8 = [];combo_9 = [];combo_10 = [];combo_11 = [];combo_12 = [];combo_13 = [];
			combo_14 = [];combo_15 = [];combo_16 = [];combo_17 = [];combo_18 = [];combo_19 = [];combo_20 = [];combo_21 = [];combo_22 = [];combo_23 = [];combo_24 = [];combo_25 = [];
			/*add class */
			helper.addBodyClass();
	
			_this.state = (_this$state = { stockEnabled: 0, zonePopupDisable: 0, zoneEnabled: 0, windowHeightNormal: 0, windowHeight: 0, details: [], orderHandled: '', load: '', Outlets: [], deliveryOutlets: [], markers: [], details_common: [], cartCount: 1, status: 'Loading', allowCart: 'Yes', productPrice: '', productUnitPrice: 0, itemType: 'Simple', ModifierCount: '' }, _defineProperty(_this$state, 'windowHeight', props.height), _defineProperty(_this$state, 'secAddrData', []), _defineProperty(_this$state, 'addressField', ''), _defineProperty(_this$state, 'isUpdate', 'No'), _defineProperty(_this$state, 'combo0', []), _defineProperty(_this$state, 'combo1', []), _defineProperty(_this$state, 'combo2', []), _defineProperty(_this$state, 'combo3', []), _defineProperty(_this$state, 'combo4', []), _defineProperty(_this$state, 'combo5', []), _defineProperty(_this$state, 'MinMaxSel', 0), _defineProperty(_this$state, 'extraComboPrice', 0), _defineProperty(_this$state, 'enableAddressSearch', false), _defineProperty(_this$state, 'outletCloseddMessage', ''), _defineProperty(_this$state, 'product_type', ''), _defineProperty(_this$state, 'product_voucher', ''), _defineProperty(_this$state, 'productvoucher_expiry_date', ''), _defineProperty(_this$state, 'product_voucher_points', ''), _defineProperty(_this$state, 'product_voucher', ''), _defineProperty(_this$state, 'voucher_name', ''), _defineProperty(_this$state, 'voucher_email', ''), _defineProperty(_this$state, 'voucher_message', ''), _defineProperty(_this$state, 'error_voucher_name', ''), _defineProperty(_this$state, 'error_voucher_email', ''), _defineProperty(_this$state, 'error_voucher_message', ''), _this$state);
	
			/* set default cookie values */
			_reactCookie2.default.save('modiferCount', 0);
			_reactCookie2.default.save('itemType', 'Simple');
			_this.handleChange = _this.handleChange.bind(_this); //handleChangeValue
			_this.handleChangeValue = _this.handleChangeValue.bind(_this);
			_this.selectOutlet = _this.selectOutlet.bind(_this);
			return _this;
		}
	
		_createClass(Productsdetails, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				var windowHeight = window.innerHeight;
				//alert(windowHeight);
				this.setState({ 'windowHeight': windowHeight - 45 + 'px' });
	
				this.setState({ 'windowHeightNormal': windowHeight + 'px' });
	
				//alert(windowHeight);
				/* API CALL FOR BANNERS */
				/* set default avilablity */
				_axios2.default.get(APIURLPRO + 'settings/get_common_settings?app_id=' + APPID + "&postal_code=" + _reactCookie2.default.load('orderPostalCode') + "&postalFilter=No").then(function (res) {
					_this2.setState({ zoneEnabled: parseInt(res.data.result_set.client_outlet_zone) });
					_this2.setState({ zonePopupDisable: parseInt(res.data.result_set.client_zone_outlet_disable) });
					_this2.setState({ stockEnabled: parseInt(res.data.result_set.client_product_stock) });
	
					var applyOutletIdtxt = res.data.result_set.ninja_outletbasedproduct_enable === '1' ? 'yes' : 'no';
					_reactCookie2.default.save('applyOutletId', applyOutletIdtxt);
					var avlId = res.data.result_set.ninja_pro_default_availability_id;
					var avlText = res.data.result_set.ninja_pro_default_availability_name === "Pickup" ? "Takeaway" : res.data.result_set.ninja_pro_default_availability_name;
					var avlImage = "/img/icons/" + res.data.result_set.ninja_pro_default_availability_id + ".png";
					helper.setDefaultAvailability(avlId, avlText, avlImage);
	
					var productSlug = _this2.props.params.productSlug;
					var CartAction = _this2.props.params.type;
	
					if (CartAction === "update") {
						_this2.setState({ isUpdate: 'Yes' });
						var cartParam = "&product_id=" + productSlug;
	
						/* get cart itesm details */
					} else {
						cartParam = "&product_slug=" + productSlug;
					}
	
					var orderOutletIdtext = _reactCookie2.default.load('orderOutletId');
					var applyOutletIdtext = _reactCookie2.default.load('applyOutletId');
	
					var custmquerytxt = '';
					if (applyOutletIdtext === 'yes') {
						if (typeof orderOutletIdtext !== "undefined" && orderOutletIdtext !== '') {
							custmquerytxt = "&outlet=" + orderOutletIdtext + "&applyOutletId=yes";
						} else {
							_reactRouter.hashHistory.push("/");
						}
					}
	
					_axios2.default.get(APIURLPRO + 'productsver2/products_list?status=A&app_id=' + APPID + "&availability=" + _reactCookie2.default.load('defaultAvilablityId') + cartParam + custmquerytxt).then(function (res) {
	
						_this2.setState({ status: res.data.status });
						if (res.data.status === "ok") {
							console.log(res.data.result_set);
							if (res.data.result_set == '' || typeof res.data.result_set == 'undefined' || res.data.result_set == null) {
	
								_reactRouter.hashHistory.push("/");
							} else {
								_this2.setState({ status: res.data.status });
								_this2.setState({ details_common: res.data.common });
								_this2.setState({ productPrice: res.data.result_set[0].product_price, productUnitPrice: res.data.result_set[0].product_price });
								_this2.setState({ details: res.data.result_set[0] });
								_this2.setState({ MinMaxSel: parseInt(res.data.result_set[0].product_apply_minmax_select) });
								_this2.setState({ product_type: res.data.result_set[0].product_type, product_voucher: res.data.result_set[0].product_voucher, productvoucher_expiry_date: res.data.result_set[0].product_voucher_expiry_date, product_voucher_points: res.data.result_set[0].product_voucher_points });
								// this.setState({productPrice: res.data.result_set[0]});
								_this2.getExtraModifierCost();
							}
						} else if (res.data.status === "error") {
	
							_reactRouter.hashHistory.push("/");
						}
					});
	
					//	if(cookie.load('defaultAvilablityId')===config.ids.pickupId && cookie.load('defaultAvilablity')===lang.takeaWay){ /* old condition page optimaztion */
	
					if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.pickupId && _reactCookie2.default.load('defaultAvilablity') === lang.takeaWay && typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderPostalCode') === "undefined") {
						_axios2.default.get(_constants.API_v4_URL + 'Getoutlets/pickup_outlets?app_id=' + APPID).then(function (res) {
							// console.log('banner result loading done');
							if (res.data.status === "ok") {
								_this2.setState({ Status: res.data.status });
								_this2.setState({ Outlets: res.data.result_set });
								//this,loaddata.outlet_id,loaddata.outlet_name,loaddata.outlet_postal_code, loaddata.outlet_address_line1, loaddata.outlet_address_line2, loaddata.outlet_unit_number1, loaddata.outlet_unit_number2,loaddata.outlet_pickup_tat
								//this.loadMarkers();
								console.log(res.data.result_set);
								if (apps.workspace === APPID) {
									_this2.addWorkSpaceCookieValues(res.data.result_set);
								}
							} else {
								_this2.setState({ Status: res.data.status });
							}
						});
					}
	
					if (_this2.state.zoneEnabled === 1 && _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && _reactCookie2.default.load('defaultAvilablity') === lang.delivery && typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderPostalCode') === "undefined") {
						_axios2.default.get(_constants.API_v4_URL + 'Getoutlets/getAllOutles/pickup_outlets?app_id=' + APPID + "&availability_id=" + config.ids.deliveryId).then(function (res) {
	
							if (res.data.status === "ok") {
								/* this.setState({Status: res.data.status}); */
								_this2.setState({ deliveryOutlets: res.data.result_set });
							} else {
								/* this.setState({Status: res.data.status}); */
							}
						});
					}
	
					/* get secondary address lits */
					if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "" && _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId) {
	
						//typeof cookie.load('orderOutletId')==="undefined" || typeof cookie.load('orderPostalCode')==="undefined"
						if (typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderPostalCode') === "undefined") {
							_this2.getSecAddr();
						}
					}
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this3 = this;
	
				(0, _withTracker.loadAnalytics)();
				/* outlet closed messages  */
				var outResult = helper.getStaticBlock('outlet-closed-message');
				outResult.then(function (stTes) {
					if (stTes.data.status === "ok") {
						_this3.setState({ outletCloseddMessage: stTes.data.result_set[0].staticblocks_description });
					}
				});
	
				window.addEventListener('scroll', function () {
					var activeClass = 'detail_header_scrool ';
					if (window.scrollY === 0) {
						activeClass = 'no_bg';
					}
	
					_this3.setState({ activeClass: activeClass });
				});
			}
			/* add outlet ids work spac */
	
		}, {
			key: 'addWorkSpaceCookieValues',
			value: function addWorkSpaceCookieValues(data) {
	
				var loaddata = data[0];
				var outlet_name = loaddata.outlet_name;
				var outlet_id = loaddata.outlet_id,
				    loaddata;
				var outlet_address_line1 = loaddata.outlet_address_line1;
				var outlet_address_line2 = loaddata.outlet_address_line2;
				var outlet_postal_code = loaddata.outlet_postal_code;
				var outlet_pickup_tat = loaddata.outlet_postal_code;
	
				var orderHandled = outlet_name + " " + outlet_address_line1 + " " + outlet_address_line2 + ", Singapore " + outlet_postal_code;
				//console.log(outlet_id+outlet_postal_code)
				this.setState({ orderHandled: orderHandled });
				_reactCookie2.default.save('orderOutletId', outlet_id);
				_reactCookie2.default.save('orderOutletName', outlet_name);
				_reactCookie2.default.save('orderPostalCode', outlet_postal_code);
				_reactCookie2.default.save('orderTAT', outlet_pickup_tat);
				_reactCookie2.default.save('orderHandled', orderHandled);
				_reactCookie2.default.save('orderHandledByText', orderHandled);
			}
	
			/* CalCulate extra Amount */
	
		}, {
			key: 'getExtraModifierCost',
			value: function getExtraModifierCost() {
				var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
				/*// alert();
	   var extrapriceval = parseFloat(0);
	   		if(id){
	   //     $(".subitems").attr('checked',false);
	      //  document.getElementById(id).checked=true;
	   }
	   				 var indival = []
	   		$.each($(".extraPrice:checked"), function(){            
	   
	   		   indival = $(this).val().split("~")
	   		   
	   		   console.log(indival);
	   		   extrapriceval += parseFloat(indival[indival.length-1]);
	   				});
	   		
	   
	    //alert(extrapriceval); */
				var extrapriceval = parseFloat(0);
				var simpleproExtra = parseFloat(0);
	
				//alert(cookie.load('itemType'));
				var comboSelction = "";
				var modifierSelction = "";
				if (_reactCookie2.default.load('itemType') === 'Combo' && _reactCookie2.default.load('comboCount') > 0 && this.state.MinMaxSel === 0) {
	
					for (var m = 0, length = _reactCookie2.default.load('comboCount'); m < length; m++) {
	
						var inputName = "comboVal_" + m;
						var comboRes = '';
						if (document.querySelector('input[name = ' + inputName + ']:checked')) {
							var comboVal_ = document.querySelector('input[name = ' + inputName + ']:checked').value;
							if (comboVal_ !== "") {
								comboSelction = "Success";
								comboRes = comboVal_.split("~");
								var product_id = comboRes[3];
								var pro_priceAply = parseInt(comboRes[5]);
								var simplepro_price = parseFloat(comboRes[6]);
	
								/* Validate modififer selection - start */
								var comboModifier = [];
								var modLength = 0;
								//alert("mod count" + m);
								var modLength = document.querySelectorAll('.setModValClass' + product_id + m).length;
								//alert('.setModValClass'+product_id+m)
								if (modLength > 0) {
									//  alert(modLength);
									//alert(modLength + comboRes[2] + "modifier count");   
									comboModifier = [];
									for (var n = 0, forLen = modLength; n < forLen; n++) {
										var inputName = "modValItems" + product_id + "-" + m + "-" + n;
										if (document.querySelector('input[name = ' + inputName + ']:checked')) {
											var modComboVal = document.querySelector('input[name = ' + inputName + ']:checked').value;
											if (modComboVal !== "") {
												var comboModRes = modComboVal.split("~");
												//alert(parseFloat(comboModRes[4]));
												var extraComboVal = comboModRes[4] !== "null" ? parseFloat(comboModRes[4]) : 0;
												extrapriceval += extraComboVal;
											}
										}
									} /* end of second modifer for */
								} else {
									if (pro_priceAply === 1) {
										simpleproExtra += simplepro_price;
									}
								}
	
								/* Validate modififer selection - End  */
							}
						}
					}
				}
	
				var newExtraPrice = parseFloat(this.state.productUnitPrice) + parseFloat(extrapriceval) + parseFloat(simpleproExtra);
	
				this.setState({ productPrice: newExtraPrice.toFixed(2) }); //productPrice
			}
	
			/* used to get all secondary address list */
	
		}, {
			key: 'getSecAddr',
			value: function getSecAddr() {
				var _this4 = this;
	
				_axios2.default.get(APIURL + '/customer/get_user_secondary_address?app_id=' + APPID + "&refrence=" + _reactCookie2.default.load('UserId')).then(function (res) {
					if (res.data.status === "ok") {
						_this4.setState({ secAddrData: res.data.result_set });
					}
				});
			}
		}, {
			key: 'handleChange',
			value: function handleChange(event) {
				//alert(event.target.value);
				this.setState({ addressField: event.target.value });
			}
		}, {
			key: 'handleChangeValue',
			value: function handleChangeValue(event) {
				this.setState({ addressField: event.target.value });
			}
			/* used to load address list */
	
		}, {
			key: 'loadAddressList',
			value: function loadAddressList() {
				var _this5 = this;
	
				return this.state.secAddrData.map(function (item, index) {
					return _react2.default.createElement(
						'p',
						{ key: index },
						_react2.default.createElement('input', { name: 'radio', value: item.postal_code, id: item.secondary_address_id, className: 'css-radio', type: 'radio', onChange: _this5.handleChange }),
						_react2.default.createElement(
							'label',
							{ htmlFor: item.secondary_address_id, className: 'css-label ' },
							' ',
							item.address + " Singapore " + item.postal_code
						)
					);
				});
			}
			/* this function used to load default billing address */
	
		}, {
			key: 'loadDefaultAddress',
			value: function loadDefaultAddress() {
				if (typeof _reactCookie2.default.load('UserDefaultAddress') !== "undefined" && _reactCookie2.default.load('UserDefaultAddress') !== "" && _reactCookie2.default.load('UserDefaultAddress') !== "" && typeof _reactCookie2.default.load('UserDefaultPostalCode') !== "undefined" && _reactCookie2.default.load('UserDefaultPostalCode') !== "") {
					return _react2.default.createElement(
						'p',
						null,
						_react2.default.createElement('input', { name: 'radio', value: _reactCookie2.default.load('UserDefaultPostalCode'), id: 'defaultAdd', className: 'css-radio', type: 'radio', onChange: this.handleChange }),
						_react2.default.createElement(
							'label',
							{ htmlFor: 'defaultAdd', className: 'css-label ' },
							' ',
							_reactCookie2.default.load('UserDefaultAddress') + " Singapore " + _reactCookie2.default.load('UserDefaultPostalCode')
						)
					);
				}
			}
	
			/* this function used to load cart icon image */
	
		}, {
			key: 'loadCartImage',
			value: function loadCartImage() {
				return (0, _Api2.default)('cartImage', 'Yes');
			}
	
			/* show product thump image */
	
		}, {
			key: '__productImage',
			value: function __productImage(product_thumbnail) {
				return product_thumbnail === "" ? config.noImages.product_listing : this.state.details_common.image_source + "/" + product_thumbnail;
			}
			/* load product image */
	
		}, {
			key: 'loadProductImage',
			value: function loadProductImage(product_thumbnail, image_gallery) {
	
				if (product_thumbnail !== "" && typeof product_thumbnail !== "undefined") {
					return _react2.default.createElement(
						'div',
						{ className: 'row no-bar-image' },
						' ',
						_react2.default.createElement('img', { src: config.path.tinThumpUrl + this.state.details_common.image_source + "/" + product_thumbnail + "&w=768&h=264&q=80", alt: 'banner', className: 'img-responsive' }),
						' '
					);
				}
			}
		}, {
			key: 'loadMarkers',
			value: function loadMarkers() {
	
				var markers = [];
				this.state.Outlets.map(function (data, index) {
					var markerinfo = {
						'position': new google.maps.LatLng(data.outlet_marker_latitude, data.outlet_marker_longitude),
						showInfo: false,
						infoContent: _react2.default.createElement(
							'div',
							null,
							data.outlet_name
						)
					};
					markers[index] = markerinfo;
				});
				this.setState({ markers: markers });
			}
	
			/* checkActive */
	
		}, {
			key: 'checkActive',
			value: function checkActive() {}
	
			/* show modifiers values */
	
		}, {
			key: 'showModifiers',
			value: function showModifiers(modVal) {
				var _this6 = this;
	
				//console.log(modVal);
				if (modVal) {
					var modLen = modVal.length;
					return modVal.map(function (item, index) {
						return _react2.default.createElement(
							'div',
							{ className: 'panel panel-default', key: index },
							_react2.default.createElement(
								'div',
								{ className: 'panel-heading', role: 'tab', id: "modHead" + index },
								_react2.default.createElement(
									'h4',
									{ className: 'panel-title' },
									_react2.default.createElement(
										'a',
										{ className: '', onClick: _this6.checkActive.bind(), 'data-toggle': 'collapse', 'data-parent': '#accordion', href: "#collapse" + index, 'aria-expanded': 'true', 'aria-controls': 'collapseTwo' },
										strp.stripslashes(item.pro_modifier_name)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ id: "collapse" + index, className: 'panel-collapse collapse in', role: 'tabpanel', 'aria-labelledby': "modHead" + index },
								_react2.default.createElement(
									'div',
									{ className: 'panel-body' },
									_this6.showModifierItems(item.modifiers_values, index, modLen, item.pro_modifier_name, item.pro_modifier_id)
								)
							)
						);
					});
				}
			}
	
			/*  hide minmax bar worksapce */
	
		}, {
			key: 'showMinmaxBar',
			value: function showMinmaxBar() {
				return APPID === apps.workspace ? "block" : "block";
			}
	
			/* close toggle bar */
	
		}, {
			key: 'gettoggleClassName',
			value: function gettoggleClassName() {
				return APPID === apps.workspace ? "collapsed" : "";
			}
	
			/* close toggle bar */
	
		}, {
			key: 'gettoggleClassName2',
			value: function gettoggleClassName2() {
				return APPID === apps.workspace ? "false" : "true";
			}
	
			/* close toggle bar */
	
		}, {
			key: 'gettoggleClassName3',
			value: function gettoggleClassName3() {
				return APPID === apps.workspace ? "" : "in";
			}
			/* show set products values */
	
		}, {
			key: 'showSetMeal',
			value: function showSetMeal(isCombo, mealVal, minmaxSelect) {
				var _this7 = this;
	
				if (isCombo === "Yes") {
					var mealLength = mealVal.length;
					var minmaxSelect = parseFloat(minmaxSelect);
					if (mealLength > 0) {
	
						if (minmaxSelect === 1) {
	
							return mealVal.map(function (item, index) {
								return _react2.default.createElement(
									'div',
									{ className: 'panel panel-default', key: index },
									_react2.default.createElement(
										'div',
										{ className: 'panel-heading', role: 'tab', id: "headingTwo" + index },
										_react2.default.createElement(
											'h4',
											{ className: 'panel-title modifier_title' },
											_react2.default.createElement(
												'a',
												{ className: _this7.gettoggleClassName(), onClick: _this7.checkActive.bind(), 'data-toggle': 'collapse', 'data-parent': '#accordion', href: "#collapse" + index, 'aria-expanded': _this7.gettoggleClassName2(), 'aria-controls': 'collapseTwo' },
												strp.stripslashes(item.menu_set_component_name)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ id: "collapse" + index, className: "panel-collapse collapse " + _this7.gettoggleClassName3(), role: 'tabpanel', 'aria-labelledby': "headingTwo" + index, 'aria-expanded': _this7.gettoggleClassName2() },
										_react2.default.createElement(
											'div',
											{ className: 'max-min-bar', style: { display: _this7.showMinmaxBar() } },
											'You have chosen ',
											_react2.default.createElement(
												'span',
												{ className: "minSele-" + index },
												'0'
											),
											' out of ',
											item.menu_component_min_select,
											'. (Max. ',
											item.menu_component_max_select,
											') '
										),
										_react2.default.createElement(
											'div',
											{ className: 'panel-body' },
											_this7.showSetMealProducts(item.product_details, index, mealLength, item.menu_component_name, item.menu_component_id, item.menu_component_default_select, item.menu_component_min_select, item.menu_component_max_select, minmaxSelect, item.menu_component_apply_price, item.menu_component_modifier_apply, item.menu_component_multipleselection_apply),
											_react2.default.createElement('input', { type: 'hidden', className: "combo-min-" + index, value: item.menu_component_min_select }),
											_react2.default.createElement('input', { type: 'hidden', className: "combo-min-name" + index, value: strp.stripslashes(item.menu_set_component_name) }),
											_react2.default.createElement('input', { type: 'hidden', className: "combo-max-" + index, value: item.menu_component_max_select })
										)
									)
								);
							});
						} else {
	
							return mealVal.map(function (item, index) {
								return _react2.default.createElement(
									'div',
									{ className: 'panel panel-default', key: index },
									_react2.default.createElement(
										'div',
										{ className: 'panel-heading', role: 'tab', id: "headingTwo" + index },
										_react2.default.createElement(
											'h4',
											{ className: 'panel-title' },
											_react2.default.createElement(
												'a',
												{ className: '', onClick: _this7.checkActive.bind(), 'data-toggle': 'collapse', 'data-parent': '#accordion', href: "#collapse" + index, 'aria-expanded': 'false', 'aria-controls': 'collapseTwo' },
												strp.stripslashes(item.menu_set_component_name)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ id: "collapse" + index, className: 'panel-collapse collapse in', role: 'tabpanel', 'aria-labelledby': "headingTwo" + index },
										_react2.default.createElement(
											'div',
											{ className: 'panel-body' },
											_this7.showSetMealProducts(item.product_details, index, mealLength, item.menu_component_name, item.menu_component_id, item.menu_component_default_select, item.menu_component_min_select, item.menu_component_max_select, minmaxSelect, item.menu_component_apply_price, '0', '0')
										)
									)
								);
							});
						}
					}
				}
			}
	
			/* show & hide set meal modifier child products */
	
		}, {
			key: 'showModDiv',
			value: function showModDiv(modifiers, setIndex, mindex) {
				var modLen = modifiers !== null ? modifiers.length : 0;
				var elems = document.getElementsByClassName('modDiv' + setIndex);
				for (var i = 0; i < elems.length; i++) {
					elems[i].style.display = 'none';
				}
				if (modLen > 0) {
					var showEle = document.getElementsByClassName('modDiv_' + setIndex + mindex);
					showEle[0].style.display = 'block';
				}
	
				this.getExtraModifierCost();
			}
	
			/* if modifier products selected show modifer div */
	
		}, {
			key: 'modifierDefault',
			value: function modifierDefault(isDefault, productId, modVal) {
				var modLen = modVal !== null ? modVal.length : 0;
				return isDefault === productId && modLen > 0 ? 'block' : 'none';
			}
		}, {
			key: 'comboMultiSelectUpdate',
			value: function comboMultiSelectUpdate(minSelect, maxSelect, setCount, inputId, flagTxt, unitPrice, productId, applyPrice) {
				var actionTxt = 'no';var actionFlg = '';
				if (flagTxt === 'comboSinglStVal_') {
					var $_this = this;
					$('.hiddenInput_' + setCount).each(function (indx) {
						var inputIdArr = $(this).attr('id').split("~");
						var inputIdTxt = inputIdArr[0];
						var prodArr = inputIdArr[0].split("_");
						var unitPriceTxt = $(this).val();
						$_this.incComboQty(minSelect, maxSelect, setCount, inputIdTxt, 'remove', unitPriceTxt, prodArr[0], applyPrice, flagTxt);
						actionTxt = 'yes';
						actionFlg = 'add';
					});
				} else {
					actionTxt = 'yes';
					if ($("#" + flagTxt + inputId).prop("checked") == true) {
						actionFlg = 'add';
					} else {
						actionFlg = 'remove';
					}
				}
	
				if (actionTxt === 'yes' && actionFlg !== '') {
					var $_this = this;
					setTimeout(function () {
						$_this.incComboQty(minSelect, maxSelect, setCount, inputId, actionFlg, unitPrice, productId, applyPrice, flagTxt);
					}, 100);
				}
			}
	
			/* check min max setup */
	
		}, {
			key: 'incComboQty',
			value: function incComboQty(minSelect, maxSelect, setCount, inputId, action, unitPrice, productId, applyPrice) {
				var multiChk = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
	
				var getQty = parseInt($("#" + inputId).text());
				/* disable if click values is zero*/
				if (getQty <= 0 && action === "remove") {
					return false;
				}
				/* get selected input qty values */
				var items = document.getElementsByClassName("hiddenInput_" + setCount);
				var itemCount = items.length;
				var cartQty = 0;
				for (var i = 0; i < itemCount; i++) {
					cartQty = cartQty + parseInt(document.getElementsByClassName('combinput_' + setCount)[i].innerHTML);
				}
				var addCartQty = cartQty + 1;
				var removeCartQty = cartQty > 0 ? cartQty - 1 : 0;
	
				/* if reached disable  add  buttoon */
				if (addCartQty > maxSelect && action === "add") {
					if (multiChk !== '') {
						$("#" + multiChk + inputId).prop('checked', false);
					}
					return false;
				}
	
				/* chnage slected count */
				if (action === "add") {
					$(".minSele-" + setCount).html(addCartQty);
				} else if (action === "remove") {
					$(".minSele-" + setCount).html(removeCartQty);
				}
	
				/* show  price if choose gretter the min value  */
				if (addCartQty >= minSelect && action === "add") {
					$(".combproduct_" + setCount).fadeIn();
				}
				if (removeCartQty < minSelect && action === "remove" && applyPrice === 0) {
					$(".combproduct_" + setCount).fadeOut();
				}
	
				/* increase price  */
				var postArray = this.getarrayName(setCount);
				if (action === "add" && (addCartQty > minSelect || applyPrice === 1)) {
					var addedPrice = parseFloat(this.state.productPrice) + parseFloat(unitPrice);
					this.setState({ productPrice: parseFloat(addedPrice).toFixed(2) });
					this.addArryValues(postArray, productId, parseFloat(unitPrice));
	
					/* update min selct number */
				}
				//console.log(combo_0);
				/* Decrease price */
				if (action === "remove" && (removeCartQty >= minSelect || applyPrice === 1)) {
					this.decreasePrice(postArray, productId, parseFloat(unitPrice));
				}
	
				/*  increase or decrease  product item qty */
				if (action === "remove") {
					var newQty = getQty > 0 ? getQty - 1 : 0;
				} else {
					newQty = getQty + 1;
				}
				//document.getElementById(inputId).value = newQty;
				//$("#"+inputId).append(newQty);
				$("#" + inputId).text(parseInt(newQty));
			}
	
			/* set array values */
	
		}, {
			key: 'addArryValues',
			value: function addArryValues(postArray, productId, Price) {
	
				var returnData = this.addSearch(productId, postArray, 'add');
				if (typeof returnData === "undefined") {
					postArray.push({ prId: productId, Qty: 1, Price: Price });
				}
			}
	
			/* get array name */
	
		}, {
			key: 'getarrayName',
			value: function getarrayName(setValue) {
				if (setValue === 0) {
					var retunArrCombo = combo_0;
				} else if (setValue === 1) {
					retunArrCombo = combo_1;
				} else if (setValue === 2) {
					retunArrCombo = combo_2;
				} else if (setValue === 3) {
					retunArrCombo = combo_3;
				} else if (setValue === 4) {
					retunArrCombo = combo_4;
				} else if (setValue === 5) {
					retunArrCombo = combo_5;
				} else if (setValue === 6) {
					retunArrCombo = combo_6;
				} else if (setValue === 7) {
					retunArrCombo = combo_7;
				} else if (setValue === 8) {
					retunArrCombo = combo_8;
				} else if (setValue === 3) {
					retunArrCombo = combo_3;
				} else if (setValue === 9) {
					retunArrCombo = combo_9;
				} else if (setValue === 9) {
					retunArrCombo = combo_9;
				} else if (setValue === 10) {
					retunArrCombo = combo_10;
				} else if (setValue === 11) {
					retunArrCombo = combo_11;
				} else if (setValue === 12) {
					retunArrCombo = combo_12;
				} else if (setValue === 13) {
					retunArrCombo = combo_13;
				} else if (setValue === 14) {
					retunArrCombo = combo_14;
				} else if (setValue === 15) {
					retunArrCombo = combo_15;
				} else if (setValue === 16) {
					retunArrCombo = combo_16;
				} else if (setValue === 17) {
					retunArrCombo = combo_17;
				} else if (setValue === 18) {
					retunArrCombo = combo_18;
				} else if (setValue === 19) {
					retunArrCombo = combo_19;
				} else if (setValue === 20) {
					retunArrCombo = combo_20;
				} else if (setValue === 21) {
					retunArrCombo = combo_21;
				} else if (setValue === 22) {
					retunArrCombo = combo_22;
				} else if (setValue === 23) {
					retunArrCombo = combo_23;
				} else if (setValue === 24) {
					retunArrCombo = combo_24;
				} else if (setValue === 25) {
					retunArrCombo = combo_25;
				}
				return retunArrCombo;
			}
	
			/* set array values */
	
		}, {
			key: 'decreasePrice',
			value: function decreasePrice(postArray, productId, Price) {
				// console.log(postArray);
				var returnDatadesc = this.addSearch(productId, postArray);
				if (typeof returnDatadesc === "undefined") {
					/* if product id not avilable */
					if (postArray[0]) {
						/*  update price */
						this.updatePriceCombo(postArray[0].Price);
						var cQty = parseInt(postArray[0].Qty) - 1;
						if (cQty > 0) {
							postArray[0].Qty = parseInt(cQty);;
						} else {
							postArray.splice(0, 1);
						}
					}
				} else {
					returnDatadesc = this.addSearch(productId, postArray, 'remove');
				}
	
				// console.log(postArray);
			}
	
			/* find object exist */
	
		}, {
			key: 'addSearch',
			value: function addSearch(nameKey, myArray, type) {
				for (var i = 0; i < myArray.length; i++) {
					if (myArray[i].prId === nameKey) {
	
						/* add quantity */
						if (type === 'add') {
							myArray[i].Qty = parseInt(myArray[i].Qty) + 1;
						}
						/* remove QTY */
						if (type === 'remove') {
							/* update product Price */
							this.updatePriceCombo(myArray[i].Price);
							var newQtyRes = parseInt(myArray[i].Qty) - 1;
							if (newQtyRes > 0) {
								myArray[i].Qty = parseInt(newQtyRes);;
							} else {
								myArray.splice(i, 1);
							}
						}
						return myArray[i];
						break;
					}
				}
			}
	
			/* this function used to update price value */
	
		}, {
			key: 'updatePriceCombo',
			value: function updatePriceCombo(unitPrice) {
				var newComboPrice = parseFloat(this.state.productPrice) - parseFloat(unitPrice);;
				this.setState({ productPrice: parseFloat(newComboPrice).toFixed(2) });
			}
		}, {
			key: 'showSimpleProprice',
			value: function showSimpleProprice(ProPrice, modifiers, mIndex, index, applyPrice) {
				var modLen = modifiers !== null ? modifiers.length : 0;
				var shwPriceHtml = '';
				if (parseFloat(ProPrice) > 0 && modLen === 0 && applyPrice === 1) {
					var shwPriceHtl = "<span id='simpleproPrice_" + mIndex + "_" + index + "' className='simpleproPricecls'> (+$" + ProPrice + ")</span>";
					shwPriceHtml = htmlToReactParser.parse(shwPriceHtl);
				}
				return shwPriceHtml;
			}
		}, {
			key: 'showComboExtraPrice',
			value: function showComboExtraPrice(minSel, applyPrice) {
				return parseInt(minSel) === 0 || applyPrice === 1 ? '' : 'none';
			}
		}, {
			key: 'showAdditionalPrice',
			value: function showAdditionalPrice(price) {
	
				if (parseFloat(price) > 0) {
					return "(+ " + price + ")";
				}
			}
		}, {
			key: 'showComboMultiSelect',
			value: function showComboMultiSelect(singleSlt, mutilSlct) {
				return singleSlt === 1 || mutilSlct === 1 ? 'none' : '';
			}
	
			/* this fucntion used to show set items list */
	
		}, {
			key: 'showSetMealProducts',
			value: function showSetMealProducts(products, mIndex, length, comboName, comboId, isDefault, minSelect, maxSelect, minmaxSelect, applyPrice, modifierApply, multiSelectApply) {
				var _this8 = this;
	
				//console.log(products);
				var totalLen = products.length;
				var minmaxSelect = parseInt(minmaxSelect);
				var modItemLen = totalLen - 1;
				var applyPrice = parseInt(applyPrice);
				var multiSelectApply = multiSelectApply !== '' ? parseInt(multiSelectApply) : 0;
				var modifierApply = modifierApply !== '' ? parseInt(modifierApply) : 0;
	
				if (totalLen === 0) {
					helper.showInfo('Products items missing');
					_reactRouter.hashHistory.push("/");
				}
	
				/*  Modifer count */
				_reactCookie2.default.save('comboCount', length);
				_reactCookie2.default.save('itemType', 'Combo');
	
				if (minmaxSelect === 1) {
					return products.map(function (item, index) {
						return _react2.default.createElement(
							'div',
							{ className: _this8.showArrow(modItemLen, index), key: index },
							_react2.default.createElement(
								'h1',
								{ className: 'bb-txt2 margin-15' },
								_react2.default.createElement(
									'span',
									{ className: 'product_name_details' },
									strp.stripslashes(helper.getAliasName(item[0].product_alias, item[0].product_name)),
									_react2.default.createElement(
										'span',
										{ className: "combproduct_" + mIndex, style: { display: _this8.showComboExtraPrice(minSelect, applyPrice) } },
										' ',
										_this8.showAdditionalPrice(item[0].product_price),
										'  '
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'radio  pull-right combo-inc-parent', style: { display: _this8.showComboMultiSelect(modifierApply, multiSelectApply) } },
									_react2.default.createElement(
										_reactRouter.Link,
										{ className: 'btn btn-my combo_inc', onClick: _this8.incComboQty.bind(_this8, minSelect, maxSelect, mIndex, item[0].product_id + "_" + mIndex + "_" + index, 'remove', item[0].product_price, item[0].product_id, applyPrice) },
										_react2.default.createElement(
											'i',
											{ className: 'material-icons' },
											'remove'
										)
									),
									'\xA0',
									_react2.default.createElement(
										'lable',
										{ type: 'text', id: item[0].product_id + "_" + mIndex + "_" + index, disabled: true, value: '0', style: { width: 40, textAlign: "center" }, className: "combo-input combinput_" + mIndex },
										'0'
									),
									_react2.default.createElement('input', { type: 'hidden', className: "hiddenInput_" + mIndex, id: item[0].product_id + "_" + mIndex + "_" + index + '~proflg', value: item[0].product_price }),
									_react2.default.createElement('input', { className: item[0].product_id + "_" + mIndex + "_" + index + " css-radio", type: 'hidden', value: comboName + "~" + comboId + "~" + helper.getAliasName(item[0].product_alias, item[0].product_name) + "~" + item[0].product_id + "~" + item[0].product_sku + "~" + item[0].product_price }),
									_react2.default.createElement(
										_reactRouter.Link,
										{ className: 'btn btn-my combo_dec', onClick: _this8.incComboQty.bind(_this8, minSelect, maxSelect, mIndex, item[0].product_id + "_" + mIndex + "_" + index, 'add', item[0].product_price, item[0].product_id, applyPrice) },
										_react2.default.createElement(
											'i',
											{ className: 'material-icons' },
											'add'
										)
									)
								),
								modifierApply === 1 && _react2.default.createElement(
									'div',
									{ className: 'radio pull-right' },
									_react2.default.createElement('input', {
										className: 'css-radio',
										type: 'radio', onChange: _this8.comboMultiSelectUpdate.bind(_this8, minSelect, maxSelect, mIndex, item[0].product_id + "_" + mIndex + "_" + index, 'comboSinglStVal_', item[0].product_price, item[0].product_id, applyPrice), value: comboName + "~" + comboId + "~" + helper.getAliasName(item[0].product_alias, item[0].product_name) + "~" + item[0].product_id + "~" + item[0].product_sku + "~" + item[0].product_price,
										name: "comboSinglStVal_" + mIndex, id: "comboSinglStVal_" + item[0].product_id + "_" + mIndex + "_" + index
									}),
									' ',
									_react2.default.createElement('label', { htmlFor: "comboSinglStVal_" + item[0].product_id + "_" + mIndex + "_" + index, className: 'css-label' })
								),
								multiSelectApply === 1 && _react2.default.createElement(
									'div',
									{ className: 'checkboxcls pull-right' },
									_react2.default.createElement('input', {
										className: 'css-checkboxcls',
										type: 'checkbox', onChange: _this8.comboMultiSelectUpdate.bind(_this8, minSelect, maxSelect, mIndex, item[0].product_id + "_" + mIndex + "_" + index, 'comboMultiStVal_', item[0].product_price, item[0].product_id, applyPrice), value: comboName + "~" + comboId + "~" + helper.getAliasName(item[0].product_alias, item[0].product_name) + "~" + item[0].product_id + "~" + item[0].product_sku + "~" + item[0].product_price,
										name: "comboMultiStVal_" + mIndex, id: "comboMultiStVal_" + item[0].product_id + "_" + mIndex + "_" + index
									}),
									' ',
									_react2.default.createElement('label', { htmlFor: item[0].product_id + "_" + mIndex + "_" + index, className: 'css-label-chkbox' })
								)
							)
						);
					});
				} else {
	
					return products.map(function (item, index) {
						return _react2.default.createElement(
							'div',
							{ className: _this8.showArrow(modItemLen, index), key: index },
							_react2.default.createElement(
								'h1',
								{ className: 'bb-txt2 margin-15' },
								strp.stripslashes(helper.getAliasName(item[0].product_alias, item[0].product_name)),
								' ',
								_this8.showSimpleProprice(item[0].product_price, item[0].modifiers, mIndex, index, applyPrice),
								_react2.default.createElement(
									'div',
									{ className: 'radio  pull-right' },
									_react2.default.createElement('input', {
										className: 'css-radio',
										type: 'radio', value: comboName + "~" + comboId + "~" + helper.getAliasName(item[0].product_alias, item[0].product_name) + "~" + item[0].product_id + "~" + item[0].product_sku + "~" + applyPrice + "~" + item[0].product_price, id: item[0].product_id + "_" + mIndex + "_" + index,
										name: "comboVal_" + mIndex,
										defaultChecked: _this8.defaultSetMeal(isDefault, item[0].product_id),
										onChange: _this8.showModDiv.bind(_this8, item[0].modifiers, mIndex, index)
									}),
									' ',
									_react2.default.createElement('label', { htmlFor: item[0].product_id + "_" + mIndex + "_" + index, className: 'css-label' })
								)
							),
							_react2.default.createElement(
								'div',
								{ style: { display: _this8.modifierDefault(isDefault, item[0].product_id, item[0].modifiers) }, className: "modDiv" + mIndex + " modDiv_" + mIndex + index, id: "parDiv" + item[0].product_id + mIndex },
								_this8.showSetMealModifeirs(item[0].modifiers, item[0].product_id, mIndex, index)
							)
						);
					});
				}
			}
	
			/* load set meal modifiers items */
	
		}, {
			key: 'showSetMealModifeirs',
			value: function showSetMealModifeirs(modifiers, productId, mIndex, pIndex) {
				var _this9 = this;
	
				var modLen = modifiers !== null ? modifiers.length : 0;
				if (modLen > 0) {
					return modifiers.map(function (modItems, index) {
						return _react2.default.createElement(
							'div',
							{ className: "fancy-collapse-panel fancy-collapse-inner" + "  setModValClass" + productId + mIndex, key: index },
							_react2.default.createElement(
								'div',
								{ className: 'panel-group', id: "accordion2" + index + mIndex, role: 'tablist', 'aria-multiselectable': 'true' },
								_react2.default.createElement(
									'div',
									{ className: 'panel panel-default' },
									_react2.default.createElement(
										'div',
										{ className: 'panel-heading', role: 'tab', id: "modHeadingTwo" + index + mIndex + pIndex },
										_react2.default.createElement(
											'h4',
											{ className: 'panel-title' },
											_react2.default.createElement(
												'a',
												{ className: '', 'data-toggle': 'collapse', 'data-parent': "#accordion2" + index + mIndex, href: "#collapse_flavour" + index + mIndex + pIndex, 'aria-expanded': 'true', 'aria-controls': 'collapseTwo' },
												_react2.default.createElement('img', { src: '/img/share.png' }),
												modItems.pro_modifier_name
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ id: "collapse_flavour" + index + mIndex + pIndex, className: "panel-collapse collapse in ", role: 'tabpanel', 'aria-labelledby': "modHeadingTwo" + index + mIndex + pIndex },
										_react2.default.createElement(
											'div',
											{ className: 'panel-body' },
											_this9.showSetMealModifierItems(modItems.modifiers_values, index, modLen, modItems.pro_modifier_name, modItems.pro_modifier_id, productId, mIndex, pIndex)
										)
									)
								)
							)
						);
					});
				}
			}
	
			/* this function used to show  set meal products modifier items */
	
			/* Show modifier price */
	
		}, {
			key: 'showModifierError',
			value: function showModifierError(price) {}
	
			/* combo modifier extra price */
	
		}, {
			key: 'showModValuePrice',
			value: function showModValuePrice(Price) {
				var modPrice = parseFloat(Price);
				return modPrice > 0 ? "(+$" + modPrice.toFixed(2) + ")" : "";
			}
	
			/* this fucntion used to show modifer items */
	
		}, {
			key: 'showSetMealModifierItems',
			value: function showSetMealModifierItems(modVal, mIndex, length, modName, modId, productId, setIndex, pIndex) {
				var _this10 = this;
	
				//alert(setIndex);
				var totalLen = modVal.length;
				var modItemLen = totalLen - 1;
				if (totalLen === 0) {
					helper.showInfo('Modifier items missing');
					_reactRouter.hashHistory.push("/");
				}
	
				return modVal.map(function (item, index) {
					return _react2.default.createElement(
						'div',
						{ className: _this10.showArrow(modItemLen, index), key: index },
						_react2.default.createElement(
							'h1',
							{ className: 'bb-txt2 margin-15' },
							strp.stripslashes(item.pro_modifier_value_name),
							' ',
							_this10.showModValuePrice(item.pro_modifier_value_price),
							_react2.default.createElement(
								'div',
								{ className: 'radio  pull-right' },
								_react2.default.createElement('input', { onClick: _this10.getExtraModifierCost.bind(_this10),
									className: 'css-radio extraPrice subitems', type: 'radio', value: modName + "~" + modId + "~" + item.pro_modifier_value_name + "~" + item.pro_modifier_value_id + "~" + item.pro_modifier_value_price, id: item.pro_modifier_value_id + "_" + setIndex + "_" + pIndex + "_" + mIndex + "_" + index, name: "modValItems" + productId + "-" + setIndex + "-" + mIndex, defaultChecked: _this10.isDefault(item.pro_modifier_value_is_default)
								}),
								_react2.default.createElement('label', { htmlFor: item.pro_modifier_value_id + "_" + setIndex + "_" + pIndex + "_" + mIndex + "_" + index, className: 'css-label' })
							)
						)
					);
				});
			}
	
			/* choose defaultg set meal product */
	
		}, {
			key: 'defaultSetMeal',
			value: function defaultSetMeal(isDefault, productId) {
				return isDefault === productId ? true : false;
			}
	
			/* show Address */
	
		}, {
			key: 'showNewAddressFrmd',
			value: function showNewAddressFrmd(pstcode, address1, address2, unittxt1, unittxt2) {
				var addressLn = address2 != '' ? address1 + ", " + address2 : address1;
				if (unittxt1 != '' && unittxt2 != '') {
					addressLn = addressLn + ", #" + unittxt1 + "-" + unittxt2;
				} else if (unittxt1 != '' || unittxt2 != '') {
					addressLn = unittxt1 != '' ? addressLn + ", #" + unittxt1 : addressLn + ", #" + unittxt2;
				}
	
				addressLn = addressLn + ", Singapore " + pstcode;
				return addressLn;
			}
	
			/* load outlets */
	
		}, {
			key: '__loadOutlets',
			value: function __loadOutlets() {
				var _this11 = this;
	
				if (this.state.Outlets) {
					var list = helper.getSortedList(this.state.Outlets, this.props.coords);
	
					if (!(0, _lodash.isEmpty)(list) && list.length > 0) {
						return list.map(function (loaddata, index) {
							return _react2.default.createElement(
								'div',
								{ className: 'map-li', key: index, onClick: _this11.pickOutlet.bind(_this11, loaddata.outlet_id, loaddata.outlet_name, loaddata.outlet_postal_code, loaddata.outlet_address_line1, loaddata.outlet_address_line2, loaddata.outlet_unit_number1, loaddata.outlet_unit_number2, loaddata.outlet_pickup_tat, loaddata.outlet_tax_option, loaddata.outlet_tax_surcharge, loaddata.outlet_tax_surcharge_inclusive) },
								_react2.default.createElement(
									'p',
									{ className: 'map-h outlet-name' },
									helper.stripslashes(loaddata.outlet_name)
								),
								_react2.default.createElement(
									'p',
									{ className: 'map-sub' },
									loaddata.outlet_address_line1 + ", " + loaddata.outlet_address_line2 + " " + loaddata.outlet_postal_code
								),
								_react2.default.createElement(_Distancebar2.default, { minDateValue: loaddata.min_date, isOutletBased: loaddata.is_outlet_based, distance: loaddata.distance, coords: _this11.props.coords, tat: loaddata.outlet_pickup_tat ? loaddata.outlet_pickup_tat : loaddata.outlet_delivery_timing })
							);
						});
					} else {
						return _react2.default.createElement(_Outletclosedmessage2.default, { messages: this.state.outletCloseddMessage });
					}
				}
			}
		}, {
			key: '__loadDeliveryOutlets',
			value: function __loadDeliveryOutlets() {
				var _this12 = this;
	
				if (this.state.deliveryOutlets) {
					var list = helper.getSortedList(this.state.deliveryOutlets, this.props.coords);
					if (!(0, _lodash.isEmpty)(list)) {
						return list.map(function (loaddata, index) {
							return _react2.default.createElement(
								'div',
								{ className: 'map-li', key: index, onClick: _this12.showZonalPostalCode.bind(_this12, loaddata.outlet_id) },
								_react2.default.createElement(
									'p',
									{ className: 'map-h outlet-name' },
									helper.stripslashes(loaddata.outlet_name)
								),
								_react2.default.createElement(
									'p',
									{ className: 'map-sub' },
									_this12.showNewAddressFrmd(loaddata.outlet_postal_code, loaddata.outlet_address_line1, '', '', ''),
									' ',
									loaddata.outlet_unit_number2
								),
								_react2.default.createElement(_Distancebar2.default, { minDateValue: loaddata.min_date, isOutletBased: loaddata.is_outlet_based, distance: loaddata.distance, coords: _this12.props.coords, tat: loaddata.outlet_delivery_tat ? loaddata.outlet_delivery_tat : loaddata.outlet_delivery_timing })
							);
						});
					} else {
						return _react2.default.createElement(_Outletclosedmessage2.default, { messages: this.state.outletCloseddMessage });
					}
				}
			}
	
			/* this fucntion used to show modifer items */
	
		}, {
			key: 'showModifierItems',
			value: function showModifierItems(modVal, mIndex, length, modName, modId) {
				var _this13 = this;
	
				//console.log(modVal);
				var totalLen = modVal.length;
				var modItemLen = totalLen - 1;
				if (totalLen === 0) {
					helper.showInfo('Modifier items missing');
					_reactRouter.hashHistory.push("/");
				}
	
				/*  Modifer count */
				_reactCookie2.default.save('modiferCount', length);
				_reactCookie2.default.save('itemType', 'Modifier');
	
				return modVal.map(function (item, index) {
					return _react2.default.createElement(
						'div',
						{ className: _this13.showArrow(modItemLen, index), key: index },
						_react2.default.createElement(
							'h1',
							{ className: 'bb-txt2 margin-15' },
							strp.stripslashes(item.pro_modifier_value_name) + _this13.modifierPrice(item.pro_modifier_value_price),
							_react2.default.createElement(
								'div',
								{ className: 'radio  pull-right' },
								_react2.default.createElement('input', {
									className: 'css-radio',
									type: 'radio',
									value: modName + "~" + modId + "~" + item.pro_modifier_value_name + "~" + item.pro_modifier_value_id + "~" + item.pro_modifier_value_price, id: item.pro_modifier_value_id, name: "modVal_" + mIndex, defaultChecked: _this13.isDefault(item.pro_modifier_value_is_default, modName, modId, item.pro_modifier_value_name, item.pro_modifier_value_id, item.pro_modifier_value_price),
									onChange: _this13.validateModifier.bind(_this13, length, modName, modId, item.pro_modifier_value_name, item.pro_modifier_value_id, item.pro_modifier_value_price, '') }),
								_react2.default.createElement('label', { htmlFor: item.pro_modifier_value_id, className: 'css-label' })
							)
						)
					);
				});
			}
	
			/* show  modifier extra amount */
	
		}, {
			key: 'modifierPrice',
			value: function modifierPrice(price) {
				return price > 0 ? " (+" + price + ")" : "";
			}
	
			/* this function used to validate modifer values */
	
		}, {
			key: 'validateModifier',
			value: function validateModifier(ModifierLen, modName, modId, modValName, modValId, modValPrice, productId) {
				var _this14 = this;
	
				//alert(productId);
				var allModVal = "";
				var commaVal = ModifierLen - 1;
				var sts = "Fail";
				//console.log(modName + "_"+modId+" - "+modValName+"-"+modValId+"-"+modValPrice);
				for (var i = 0, length = ModifierLen; i < length; i++) {
					var inputName = "modVal_" + i;
					if (document.querySelector('input[name = ' + inputName + ']:checked')) {
						var modVal = document.querySelector('input[name = ' + inputName + ']:checked').value;
						var res = modVal.split("~");
						if (modVal === "") {
							sts = "Fail";
							document.getElementById("addToCart").disabled = true;
							helper.showInfo(lang.select_all_modofier);
							break;
						} else {
							sts = "Success";
							document.getElementById("addToCart").disabled = false;;
							var strt = i === commaVal ? res[3] : res[3] + ";";
							allModVal += strt;
							/* post data */
						}
					} else {
						sts = "Fail";
						document.getElementById("addToCart").disabled = true;
						helper.showInfo(lang.select_all_modofier);
						break;
					}
				}
				if (sts === "Success") {
					/* for normal modifiers get state value, set meal product pass param */
					productId = productId === "" ? this.state.details.product_id : productId;
	
					//alert(productId);
					_axios2.default.get(APIURLPRO + 'products/validate_product?app_id=' + APPID + "&product_id=" + productId + "&modifier_value_id=" + allModVal).then(function (res) {
	
						/* Success response */
						if (res.data.status === "ok") {
							_this14.setState({ sts: 'No' });
							_this14.setState({ allowCart: 'Yes' });
							_this14.setState({ productPrice: res.data.result_set[0].product_price, productUnitPrice: res.data.result_set[0].product_price });
						}
						/* Error response */
						if (res.data.status === "error") {
							helper.showInfo(res.data.message);
							_this14.setState({ allowCart: 'No' });
							document.getElementById("addToCart").disabled = true;
						}
					});
				}
			}
	
			/* this function used to checked radio value */
	
		}, {
			key: 'isDefault',
			value: function isDefault(select) {
				return select === "Yes" ? true : false;
			}
	
			/* this function used to show show  arrow*/
	
		}, {
			key: 'showArrow',
			value: function showArrow(len, index) {
				return len === index ? "" : "acrow";
			}
	
			/* increase cart qty */
	
		}, {
			key: 'iQty',
			value: function iQty() {
				this.setState({ cartCount: this.state.cartCount + 1 });
			}
	
			/* decrease cart qty */
	
		}, {
			key: 'dQty',
			value: function dQty() {
				if (this.state.cartCount !== 1) {
					this.setState({ cartCount: this.state.cartCount - 1 });
				}
			}
	
			/* pick outlet */
	
		}, {
			key: 'pickOutlet',
			value: function pickOutlet(outlet_id, outlet_name, outlet_postal_code, outlet_address_line1, outlet_address_line2, outlet_unit_number1, outlet_unit_number2, outlet_pickup_tat, outlet_tax_option, outlet_tax_surcharge, outlet_tax_surcharge_inclusive) {
	
				var orderHandled = outlet_name + " " + outlet_address_line1 + " " + outlet_address_line2 + ", Singapore " + outlet_postal_code;
				//console.log(outlet_id+outlet_postal_code)
				this.setState({ orderHandled: orderHandled });
				_reactCookie2.default.save('orderOutletId', outlet_id);
				_reactCookie2.default.save('orderOutletName', outlet_name);
				_reactCookie2.default.save('orderPostalCode', outlet_postal_code);
				_reactCookie2.default.save('orderTAT', outlet_pickup_tat);
				_reactCookie2.default.save('orderHandled', orderHandled);
				_reactCookie2.default.save('orderHandledByText', orderHandled);
	
				_reactCookie2.default.save('outlet_tax_option', outlet_tax_option);
				_reactCookie2.default.save('outlet_tax_surcharge', outlet_tax_surcharge);
				_reactCookie2.default.save('outlet_tax_surcharge_inclusive', outlet_tax_surcharge_inclusive);
	
				$("#Pickup-OutletSelection").modal("toggle");
				$("#Pickup-Sucess").modal("toggle");
			}
		}, {
			key: 'showZonalPostalCode',
			value: function showZonalPostalCode(outletId) {
	
				$("#delivery_outlet").modal("toggle");
				if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
					$("#AddressList").modal("toggle");
				} else {
					$("#DeliveryAddress").modal("toggle");
				}
	
				this.setState({ zoneDeliveryOutlet: outletId });
			}
	
			/* continue with pickup success */
	
		}, {
			key: 'pickupSuccess',
			value: function pickupSuccess() {
				var productId = this.state.productId;
				var proName = this.state.proName;
				var prosku = this.state.prosku;
				var proPrice = this.state.proPrice;
				var proQty = this.state.proQty;
				var proImage = this.state.proImage;
				var allowCart = this.state.allowCart;
				var applyMinmaxSelect = this.state.applyMinmaxSelect;
				$("#Pickup-Sucess").modal("hide");
				$("#pickup-outlet-sucess").modal('hide');
				this.addToCart(productId, proName, prosku, proPrice, proQty, proImage, allowCart, applyMinmaxSelect);
			}
	
			/* continue with delivery success */
	
		}, {
			key: 'deliverySuccess',
			value: function deliverySuccess() {
				var productId = this.state.productId;
				var proName = this.state.proName;
				var prosku = this.state.prosku;
				var proPrice = this.state.proPrice;
				var proQty = this.state.proQty;
				var proImage = this.state.proImage;
				var allowCart = this.state.allowCart;
				var applyMinmaxSelect = this.state.applyMinmaxSelect;
				$("#DeliverySucess").modal("toggle");
				this.addToCart(productId, proName, prosku, proPrice, proQty, proImage, allowCart, applyMinmaxSelect);
			}
	
			/* Del back */
	
		}, {
			key: 'backToDeliveryBack',
			value: function backToDeliveryBack() {
				$("#DeliveryAddress").modal("toggle");
				$("#delivery_outlet").modal("toggle");
			}
	
			/* Select outlet */
	
		}, {
			key: 'selectOutlet',
			value: function selectOutlet(thisobject) {
				var retry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				var _this15 = this;
	
				var callbackPostalCode = arguments[2];
				var addressObj = arguments[3];
	
				var postalcode = "";
				var address = "";
				var googleRetryAttempt = 0;
				if (retry === false) {
					if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
						postalcode = $("#postalcode").val(); //"postalcode";
					} else {
						postalcode = $("#postalcode1").val(); // "postalcode1";
					}
				} else {
					postalcode = callbackPostalCode;
					address = addressObj;
					googleRetryAttempt = 1;
				}
	
				if (postalcode.length < 5) {
					return false;
				}
	
				this.setState({ load: "true" });
	
				var findPostUrl = APIURL + 'outlets/find_outlet?skip_timing=Yes&app_id=' + APPID + "&availability_id=" + _reactCookie2.default.load('defaultAvilablityId') + "&postal_code=" + postalcode;
				if (this.state.zoneEnabled === 1) {
					findPostUrl = _constants.API_v4_URL + 'test/outlets/findOutletZone?skip_timing=Yes&app_id=' + APPID + "&availability_id=" + _reactCookie2.default.load('defaultAvilablityId') + "&postal_code=" + postalcode + "&outlet_id=" + this.state.zoneDeliveryOutlet + "&googleRetryAttempt=" + googleRetryAttempt + "&addressObject=" + address;
				}
				/*add loading */
				_axios2.default.get(findPostUrl).then(function (res) {
	
					/* Success response */
					/* Success response  && Object.keys(res.data.result_set.postal_code_information).length !==0 */
					if (res.data.status === "ok") {
						_this15.setState({ load: "true" });
						/*if(Object.keys(res.data.result_set.postal_code_information).length !==0)
	     { */
						var orderDeliveryAddress = res.data.result_set.postal_code_information.zip_buno + " " + res.data.result_set.postal_code_information.zip_sname;
						var orderHandled = res.data.result_set.outlet_name + ", Crew will be seeing you in " + res.data.result_set.outlet_delivery_timing + " Minutes";
						_this15.setState({ orderDeliveryAddress: orderDeliveryAddress + " Singapore " + res.data.result_set.postal_code_information.zip_code });
						_this15.setState({ orderHandled: orderHandled });
						_reactCookie2.default.save('orderOutletId', res.data.result_set.outlet_id);
						_reactCookie2.default.save('orderOutletName', res.data.result_set.outlet_name);
						_reactCookie2.default.save('orderPostalCode', res.data.result_set.postal_code_information.zip_code);
						_reactCookie2.default.save('orderTAT', res.data.result_set.outlet_delivery_timing);
						_reactCookie2.default.save('orderDeliveryAddress', orderDeliveryAddress);
						_reactCookie2.default.save('orderHandled', orderHandled);
	
						_reactCookie2.default.save('outlet_tax_option', res.data.result_set.outlet_tax_option);
						_reactCookie2.default.save('outlet_tax_surcharge', res.data.result_set.outlet_tax_surcharge);
						_reactCookie2.default.save('outlet_tax_surcharge_inclusive', res.data.result_set.outlet_tax_surcharge_inclusive);
	
						var orderHandledText = res.data.result_set.outlet_name + " " + res.data.result_set.outlet_address_line1 + " " + res.data.result_set.outlet_address_line2 + ", Singapore " + postalcode;
						_reactCookie2.default.save('orderHandledByText', orderHandledText);
	
						if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
							$("#AddressList").modal("hide");
						} else {
							$("#DeliveryAddress").modal("hide");
						}
						$("#address-auto").modal("hide");
						$("#DeliverySucess").modal("toggle");
	
						if (_this15.state.zoneEnabled === 1) {
							_reactCookie2.default.save('orderZoneID', res.data.result_set.zone_id);
						}
	
						/* }else{
	     	 $("#DeliveryAddress").modal("toggle");
	     	 $("#DeliveryError").modal("toggle");
	      } */
					}
					/* Error response */
					if (res.data.status === "error") {
						_this15.setState({ load: "false" });
						/* check google api result */
						var google_api_result = false;
						if (typeof res.data.not_fount_in_google !== "undefined" && res.data.not_fount_in_google === true) {
							_this15.setState({ enableAddressSearch: true });
							google_api_result = true;
						}
	
						if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
							$("#AddressList").modal("hide");
						} else {
							$("#DeliveryAddress").modal("hide");
						}
	
						if (google_api_result === false) {
							if (res.data.shop_close === 'Yes') {
								$("#ShopClosedError").modal("toggle");
							} else {
								$("#DeliveryError").modal("toggle");
							}
						} else {
							$("#address-auto").modal("show");
						}
					}
				});
			}
	
			/* Open Zipcode popup */
	
		}, {
			key: 'changeDelivery',
			value: function changeDelivery() {
				this.setState({ load: "false" });
				this.setState({ addressField: "" });
				$("#DeliveryError").modal("toggle");
				if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
					$("#AddressList").modal("toggle");
				} else {
					$("#DeliveryAddress").modal("toggle");
				}
	
				//$("#DeliveryAddress").modal("toggle");
			}
		}, {
			key: 'closeDeliveryErr',
			value: function closeDeliveryErr() {
				this.setState({ load: "false" });
				$("#DeliveryError").modal("toggle");
			}
		}, {
			key: 'closeShopClosedError',
			value: function closeShopClosedError() {
				this.setState({ load: "false" });
				$("#ShopClosedError").modal("toggle");
			}
	
			/* Validate zipcode */
	
		}, {
			key: 'validatezip',
			value: function validatezip(e) {
				var re = /[0-9A-F:]+/g;
				if (!re.test(e.key)) {
					e.preventDefault();
				}
			}
	
			/* formated  string */
	
		}, {
			key: 'formatString',
			value: function formatString(str) {
				var stringVal = window.btoa(str);
				return stringVal.replace(/\=/g, '');
			}
		}, {
			key: 'cashVocherMesumbit',
			value: function cashVocherMesumbit(productId, proName, prosku, proPrice, proQty, proImage, allowCart, applyMinmaxSelect, product_voucher_expiry_date, product_voucher, product_voucher_points) {
				$('.voucher_popup').trigger('click');
				this.addToVoucherCart(productId, proName, prosku, proPrice, proQty, proImage, allowCart, applyMinmaxSelect, product_voucher_expiry_date, product_voucher, product_voucher_points);
			}
		}, {
			key: 'cashVochersumbit',
			value: function cashVochersumbit(productId, proName, prosku, proPrice, proQty, proImage, allowCart, applyMinmaxSelect, product_voucher_expiry_date, product_voucher, product_voucher_points) {
				var error = 0;
				if (this.state.voucher_name === null || this.state.voucher_name === '') {
					error++;
					this.setState({ error_voucher_name: htmlToReactParser.parse('<span class="spn-error">This field is required.</span>') });
				} else {
					this.setState({ error_voucher_name: '' });
				}
				if (this.state.voucher_email === null || this.state.voucher_email === '') {
					error++;
					this.setState({ error_voucher_email: htmlToReactParser.parse('<span class="spn-error">This field is required.</span>') });
				} else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(this.state.voucher_email)) {
					error++;
					this.setState({ error_voucher_email: htmlToReactParser.parse('<span class="spn-error">This is not a valid email.</span>') });
				} else {
					this.setState({ error_voucher_email: '' });
				}
				if (this.state.voucher_message === null || this.state.voucher_message === '') {
					error++;
					this.setState({ error_voucher_message: htmlToReactParser.parse('<span class="spn-error">This field is required.</span>') });
				} else {
					this.setState({ error_voucher_message: '' });
				}
				if (error == 0) {
					$('.voucher_popup').trigger('click');
					this.addToVoucherCart(productId, proName, prosku, proPrice, proQty, proImage, allowCart, applyMinmaxSelect, product_voucher_expiry_date, product_voucher, product_voucher_points);
				}
			}
	
			/* add to cart */
	
		}, {
			key: 'addToVoucherCart',
			value: function addToVoucherCart(productId, proName, prosku, proPrice, proQty, proImage, allowCart, applyMinmaxSelect, product_voucher_expiry_date, product_voucher, product_voucher_points) {
				var _this16 = this;
	
				(0, _withTracker.fbPixelCustomEvent)('AddToCart', {});
				this.setState({ productId: productId });
				this.setState({ proName: proName });
				this.setState({ prosku: prosku });
				this.setState({ proPrice: proPrice });
				this.setState({ proQty: proQty });
				this.setState({ proImage: proImage });
				this.setState({ allowCart: allowCart });
				this.setState({ productvoucher_expiry_date: product_voucher_expiry_date });
				this.setState({ applyMinmaxSelect: parseInt(applyMinmaxSelect) });
	
				/* check add to cart permission */
				if (allowCart === "No") {
					helper.showInfo(lang.modifier_missing);
					return false;
				}
	
				/* Post Modifier part */
	
				var modifier = [];
	
				if (_reactCookie2.default.load('itemType') === 'Modifier' && _reactCookie2.default.load('modiferCount') > 0) {
	
					for (var i = 0, lengthMod = _reactCookie2.default.load('modiferCount'); i < lengthMod; i++) {
						var inputName = "modVal_" + i;
						if (document.querySelector('input[name = ' + inputName + ']:checked')) {
							var modVal = document.querySelector('input[name = ' + inputName + ']:checked').value;
							if (modVal !== "") {
								var res = modVal.split("~");
								var modifierVal = [];
								modifierVal.push({ modifier_value_id: res[3], modifier_value_qty: '1', modifier_value_name: res[2], modifier_value_price: res[4] });
								modifier.push({ modifier_id: res[1], modifier_name: res[0], modifiers_values: modifierVal });
							} else {
								helper.showInfo(lang.modifier_missing);
								return false;
							}
						} else {
							helper.showInfo(lang.modifier_missing);
							return false;
						}
					}
				}
	
				/* set meat products array */
				var combo = [];
				var comborVal = [];
				var comboModifier = [];
				var comboSelction = "Fail";
				var modifierSelction = "Fail";
				var overAllQty = 0;
				var totalMinSelect = 0;
				if (parseInt(applyMinmaxSelect) === 1) {
	
					if (_reactCookie2.default.load('itemType') === 'Combo' && _reactCookie2.default.load('comboCount') > 0) {
						for (var m = 0, length = _reactCookie2.default.load('comboCount'); m < length; m++) {
							var _items = document.getElementsByClassName("hiddenInput_" + m);
							var _itemCount = _items.length;
							var _cartQty = 0;var selMincount = 0;var selMaxcount = 0;var selMinSetName = '';
	
							var comborVal = [];
							var menu_component_id = "";var menu_component_name = "";var selCurQty = 0;
							for (var i = 0; i < _itemCount; i++) {
								selCurQty = parseInt(document.getElementsByClassName('combinput_' + m)[i].innerHTML);
								_cartQty = _cartQty + selCurQty;
								var comboRes = '';
								var PriceArray = [];var appliedPrice = [];
								if (selCurQty > 0) {
									var comboIdVal = $('.combinput_' + m)[i].id;
									var comboDatas = $("." + comboIdVal).val();
									if (comboDatas) {
	
										/* get extra amount applied products */
										comboRes = comboDatas.split("~");
										PriceArray = this.getarrayName(m);
	
										var appliedPrice = this.addSearch(comboRes[3], PriceArray, 'get');
										var newQtyPrice = 0;
										if (appliedPrice) {
											newQtyPrice = appliedPrice.Price;
										}
	
										comborVal.push({ product_id: comboRes[3], product_name: comboRes[2], product_sku: comboRes[4], product_qty: selCurQty, product_price: newQtyPrice, modifiers: comboModifier });
										menu_component_id = comboRes[1];
										menu_component_name = comboRes[0];
									}
								}
	
								if (i === _itemCount - 1 && menu_component_id != "" && menu_component_name != "" && comborVal) {
									combo.push({ menu_component_id: menu_component_id, menu_component_name: menu_component_name, product_details: comborVal });
								}
								/* push products to array values  */
							}
	
							overAllQty = overAllQty + _cartQty;
	
							/* validate min max setup */
							selMincount = parseInt($(".combo-min-" + m).val());
							selMinSetName = $(".combo-min-name" + m).val();
							selMaxcount = parseInt($(".combo-max-" + m).val());
	
							totalMinSelect = totalMinSelect + selMincount;
							if (_cartQty < selMincount) {
								helper.showInfo('Please select the min number of items for ' + selMinSetName);
								return false;
							}
							if (_cartQty > selMaxcount) {
								helper.showInfo('Maximum selection limit exceed');
								return false;
							}
							/* add products  */
						}
	
						if (overAllQty <= 0 && totalMinSelect > 0) {
							helper.showInfo('Please choose any combo product combination');
							return false;
						}
					}
				} else {
					/* OLD Combo product setup */
	
					if (_reactCookie2.default.load('itemType') === 'Combo' && _reactCookie2.default.load('comboCount') > 0) {
						for (var m = 0, length = _reactCookie2.default.load('comboCount'); m < length; m++) {
	
							var inputName = "comboVal_" + m;
							var comboRes = '';
							if (document.querySelector('input[name = ' + inputName + ']:checked')) {
								var comboVal_ = document.querySelector('input[name = ' + inputName + ']:checked').value;
								if (comboVal_ !== "") {
									comboSelction = "Success";
									comboRes = comboVal_.split("~");
									var product_id = comboRes[3];
									var pro_priceAply = parseInt(comboRes[5]);
									var simplepro_price = parseFloat(comboRes[6]);
									var compoSimpleproprice = parseFloat(0);
									/* Validate modififer selection - start */
									var comboModifier = [];
									var modLength = 0;
									var modLength = document.querySelectorAll('.setModValClass' + product_id + m).length;
									if (modLength > 0) {
										comboModifier = [];
										for (var n = 0, forLen = modLength; n < forLen; n++) {
											var inputName = "modValItems" + product_id + "-" + m + "-" + n;
											if (document.querySelector('input[name = ' + inputName + ']:checked')) {
												var modComboVal = document.querySelector('input[name = ' + inputName + ']:checked').value;
												if (modComboVal !== "") {
													modifierSelction = "success";
													var comboModRes = modComboVal.split("~");
													var comboModifierVal = [];
	
													comboModifierVal.push({ modifier_value_id: comboModRes[3], modifier_value_qty: '1', modifier_value_name: comboModRes[2], modifier_value_price: comboModRes[4] });
													comboModifier.push({ modifier_id: comboModRes[1], modifier_name: comboModRes[0], modifiers_values: comboModifierVal });
												} else {
													modifierSelction = "Fail";
												}
											} else {
												modifierSelction = "Fail";
											}
	
											/* if modifier selection misiing show alert */
											if (modifierSelction === "Fail") {
												helper.showInfo(lang.modifier_missing);
												return false;
											}
										} /* end of second modifer for */
									} else {
										if (pro_priceAply === 1) {
											compoSimpleproprice = simplepro_price;
										}
									}
	
									/* Validate modififer selection - End  */
	
									/* object formation  - start */
									var comborVal = [];
									comborVal.push({ product_id: comboRes[3], product_name: comboRes[2], product_sku: comboRes[4], product_qty: 1, product_price: compoSimpleproprice, modifiers: comboModifier });
									combo.push({ menu_component_id: comboRes[1], menu_component_name: comboRes[0], product_details: comborVal });
									/* object formation - End */
								} else {
									comboSelction = "Fail";
								}
							} else {
								comboSelction = "Fail";
							}
	
							/* combo selection is missing show alert */
							if (comboSelction === "Fail") {
								helper.showInfo(lang.combo_missing);
								return false;
							}
						}
					}
				}
	
				/* outlet validation - Start */
	
				if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && _reactCookie2.default.load('defaultAvilablity') === lang.delivery) {
					if (typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderPostalCode') === "undefined") {
						if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
							if (this.state.zoneEnabled === 1) {
								if (parseInt(this.state.zonePopupDisable) === 1) {
									$("#AddressList").modal("toggle");
									return false;
								} else {
									$("#delivery_outlet").modal("toggle");
									return false;
								}
							} else {
	
								$("#AddressList").modal("toggle");
								return false;
							}
						} else {
							if (this.state.zoneEnabled === 1) {
								if (parseInt(this.state.zonePopupDisable) === 1) {
									$("#DeliveryAddress").modal("toggle");
									return false;
								} else {
									$("#delivery_outlet").modal("toggle");
									return false;
								}
							}
	
							$("#DeliveryAddress").modal("toggle");
							return false;
						}
					}
				} else if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.pickupId && _reactCookie2.default.load('defaultAvilablity') === lang.takeaWay) {
					if (typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderPostalCode') === "undefined") {
	
						var pickupOutlets = this.state.Outlets;
	
						if (pickupOutlets.length === 1) {
	
							var orderHandled = pickupOutlets[0].outlet_name + " " + pickupOutlets[0].outlet_address_line1 + " " + pickupOutlets[0].outlet_address_line2 + ", Singapore " + pickupOutlets[0].outlet_postal_code;
	
							this.setState({ orderHandled: orderHandled });
							_reactCookie2.default.save('orderOutletId', pickupOutlets[0].outlet_id);
							_reactCookie2.default.save('orderOutletName', pickupOutlets[0].outlet_name);
							_reactCookie2.default.save('orderPostalCode', pickupOutlets[0].outlet_postal_code);
							_reactCookie2.default.save('orderTAT', pickupOutlets[0].outlet_pickup_tat);
							_reactCookie2.default.save('orderHandled', orderHandled);
							_reactCookie2.default.save('orderHandledByText', orderHandled);
	
							_reactCookie2.default.save('outlet_tax_option', pickupOutlets[0].outlet_tax_option);
							_reactCookie2.default.save('outlet_tax_surcharge', pickupOutlets[0].outlet_tax_surcharge);
							_reactCookie2.default.save('outlet_tax_surcharge_inclusive', pickupOutlets[0].outlet_tax_surcharge_inclusive);
	
							_reactCookie2.default.save('outlet_option_single', 1);
	
							$("#pickup-outlet-sucess").modal("toggle");
						} else {
							$("#Pickup-OutletSelection").modal("toggle");
						}
	
						return false;
					}
				}
	
				/* Outlet validation - End */
	
				var totalPrice = proQty * proPrice;
	
				var postObject = {};
				postObject = {
					'app_id': config.ids.appId,
					"product_id": productId,
					"product_name": strp.stripslashes(proName),
					"product_sku": prosku,
					"product_image": proImage,
					"availability_id": _reactCookie2.default.load('defaultAvilablityId'),
					"product_unit_price": proPrice,
					"product_qty": proQty,
					"product_total_price": totalPrice,
					"voucher_gift_name": this.state.voucher_name !== "" ? this.state.voucher_name : _reactCookie2.default.load("UserFname"),
					"voucher_gift_email": this.state.voucher_email !== "" ? this.state.voucher_email : _reactCookie2.default.load("UserEmail"),
					"voucher_gift_message": this.state.voucher_message !== "" ? this.state.voucher_message : "",
					"product_voucher_expiry_date": this.state.productvoucher_expiry_date !== "" ? this.state.productvoucher_expiry_date : "",
					"product_voucher_points": this.state.product_voucher == "c" ? this.state.product_voucher_points : "",
					"modifiers": JSON.stringify(modifier),
					"menu_set_component": JSON.stringify(combo)
	
				};
	
				if (typeof _reactCookie2.default.load('UserId') === 'undefined') {
					postObject['reference_id'] = (0, _Api2.default)('referenceId');
				} else {
					postObject['customer_id'] = _reactCookie2.default.load('UserId');
				}
	
				/*add loading */
				this.setState({ status: 'Loading' });
	
				var apiheaderauth = { headers: {
						'Auth': _reactCookie2.default.load('Token'),
						'X-API-KEY': "8611E7D6-ECA7-4172-966C-4C10EA1E8C7N"
					} };
	
				_axios2.default.post(APIURLPRO + "cartv2/insert", qs.stringify(postObject), apiheaderauth).then(function (res) {
					_this16.setState({ status: 'ok' });
					if (res.data.status === "ok") {
	
						(0, _withTracker.fbPixelCustomEvent)('AddToCartSuccess', {});
	
						var cartCount = res.data.contents.cart_details.cart_total_items;
						_reactCookie2.default.save('cartValue', 'Yes');
						_reactCookie2.default.save('cartCount', cartCount);
						_reactCookie2.default.save('voucher_types_enable', '1');
						_reactCookie2.default.remove('tempPromoCode');
						_reactCookie2.default.remove('tempPoints');
	
						/* find previous page */
						var slugType = _reactCookie2.default.load('categoryType');
						var slugValue = _reactCookie2.default.load('categoryId');
						if (typeof slugType !== "undefined" && typeof slugValue !== "undefined" && slugType !== '' && slugValue !== '') {
							var keyValue = slugType === "category" ? "category" : "subcategory";
							var reDirectUrl = "/products/" + keyValue + "/" + slugValue;
						} else {
							reDirectUrl = "/";
						}
						_reactCookie2.default.save('alertSuccess', lang.cart_success);
						_reactRouter.hashHistory.push(reDirectUrl);
					} else if (res.data.status === "error") {
						helper.showInfo(res.data.message);
					}
				});
			}
	
			/* add to cart */
	
		}, {
			key: 'addToCart',
			value: function addToCart(productId, proName, prosku, proPrice, proQty, proImage, allowCart, applyMinmaxSelect) {
				var _this17 = this;
	
				var product_type = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : '';
				var product_voucher = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';
	
				if (product_type == "5" && product_voucher == "c" || product_voucher == 'f') {
					$("#cashVocher").modal("toggle");
				} else {
					(0, _withTracker.fbPixelCustomEvent)('AddToCart', {});
					// alert(applyMinmaxSelect);
					this.setState({ productId: productId });
					this.setState({ proName: proName });
					this.setState({ prosku: prosku });
					this.setState({ proPrice: proPrice });
					this.setState({ proQty: proQty });
					this.setState({ proImage: proImage });
					this.setState({ allowCart: allowCart });
					this.setState({ applyMinmaxSelect: parseInt(applyMinmaxSelect) });
	
					/* check add to cart permission */
					if (allowCart === "No") {
						helper.showInfo(lang.modifier_missing);
						return false;
					}
	
					/* Post Modifier part */
	
					var modifier = [];
					//console.log(cookie.load('itemType') +"<---->"+ cookie.load('modiferCount'));
					if (_reactCookie2.default.load('itemType') === 'Modifier' && _reactCookie2.default.load('modiferCount') > 0) {
						//  console.log('is allow');
						for (var i = 0, lengthMod = _reactCookie2.default.load('modiferCount'); i < lengthMod; i++) {
							var inputName = "modVal_" + i;
							if (document.querySelector('input[name = ' + inputName + ']:checked')) {
								var modVal = document.querySelector('input[name = ' + inputName + ']:checked').value;
								if (modVal !== "") {
									var res = modVal.split("~");
									var modifierVal = [];
									modifierVal.push({ modifier_value_id: res[3], modifier_value_qty: '1', modifier_value_name: res[2], modifier_value_price: res[4] });
									modifier.push({ modifier_id: res[1], modifier_name: res[0], modifiers_values: modifierVal });
								} else {
									helper.showInfo(lang.modifier_missing);
									return false;
								}
							} else {
								helper.showInfo(lang.modifier_missing);
								return false;
							}
						}
					}
	
					/* set meat products array */
					var combo = [];
					var comborVal = [];
					var comboModifier = [];
					var comboSelction = "Fail";
					var modifierSelction = "Fail";
					var overAllQty = 0;
					var totalMinSelect = 0;
					// alert(applyMinmaxSelect);
					if (parseInt(applyMinmaxSelect) === 1) {
	
						if (_reactCookie2.default.load('itemType') === 'Combo' && _reactCookie2.default.load('comboCount') > 0) {
							for (var m = 0, length = _reactCookie2.default.load('comboCount'); m < length; m++) {
								var _items = document.getElementsByClassName("hiddenInput_" + m);
								var _itemCount = _items.length;
								var _cartQty = 0;var selMincount = 0;var selMaxcount = 0;var selMinSetName = '';
	
								var comborVal = [];
								var menu_component_id = "";var menu_component_name = "";var selCurQty = 0;
								for (var i = 0; i < _itemCount; i++) {
									selCurQty = parseInt(document.getElementsByClassName('combinput_' + m)[i].innerHTML);
									_cartQty = _cartQty + selCurQty;
									var comboRes = '';
									var PriceArray = [];var appliedPrice = [];
									if (selCurQty > 0) {
										var comboIdVal = $('.combinput_' + m)[i].id;
										var comboDatas = $("." + comboIdVal).val();
										if (comboDatas) {
	
											/* get extra amount applied products */
											comboRes = comboDatas.split("~");
											PriceArray = this.getarrayName(m);
											//console.log(comboRes[3]);
											//   console.log(PriceArray); 
											var appliedPrice = this.addSearch(comboRes[3], PriceArray, 'get');
											var newQtyPrice = 0;
											if (appliedPrice) {
												newQtyPrice = appliedPrice.Price;
											}
											// var newQtyPrice = (appliedPrice.Price ? appliedPrice.Price : 0);
	
											comborVal.push({ product_id: comboRes[3], product_name: comboRes[2], product_sku: comboRes[4], product_qty: selCurQty, product_price: newQtyPrice, modifiers: comboModifier });
											menu_component_id = comboRes[1];
											menu_component_name = comboRes[0];
										}
									}
	
									if (i === _itemCount - 1 && menu_component_id != "" && menu_component_name != "" && comborVal) {
										combo.push({ menu_component_id: menu_component_id, menu_component_name: menu_component_name, product_details: comborVal });
									}
									/* push products to array values  */
								}
	
								//console.log(comborVal); return false;
								overAllQty = overAllQty + _cartQty;
	
								/* validate min max setup */
								selMincount = parseInt($(".combo-min-" + m).val());
								selMinSetName = $(".combo-min-name" + m).val();
								selMaxcount = parseInt($(".combo-max-" + m).val());
	
								totalMinSelect = totalMinSelect + selMincount;
								// console.log(_cartQty + "//" + selMincount);
								if (_cartQty < selMincount) {
									helper.showInfo('Please select the min number of items for ' + selMinSetName);
									return false;
								}
	
								if (_cartQty > selMaxcount) {
									helper.showInfo('Maximum selection limit exceed');
									return false;
								}
	
								/* add products  */
							}
	
							//alert(totalMinSelect);
							if (overAllQty <= 0 && totalMinSelect > 0) {
								helper.showInfo('Please choose any combo product combination');
								return false;
							}
							//console.log(combo);  return false;
						}
					} else {
						/* OLD Combo product setup */
	
						if (_reactCookie2.default.load('itemType') === 'Combo' && _reactCookie2.default.load('comboCount') > 0) {
							// alert(cookie.load('comboCount'));
							for (var m = 0, length = _reactCookie2.default.load('comboCount'); m < length; m++) {
								//alert('  combo' + m);
								var inputName = "comboVal_" + m;
								var comboRes = '';
								if (document.querySelector('input[name = ' + inputName + ']:checked')) {
									var comboVal_ = document.querySelector('input[name = ' + inputName + ']:checked').value;
									if (comboVal_ !== "") {
										comboSelction = "Success";
										comboRes = comboVal_.split("~");
										var product_id = comboRes[3];
										var pro_priceAply = parseInt(comboRes[5]);
										var simplepro_price = parseFloat(comboRes[6]);
										var compoSimpleproprice = parseFloat(0);
										/* Validate modififer selection - start */
										var comboModifier = [];
										var modLength = 0;
										//alert("mod count" + m);
										var modLength = document.querySelectorAll('.setModValClass' + product_id + m).length;
										//alert('.setModValClass'+product_id+m)
										if (modLength > 0) {
											//  alert(modLength);
											//alert(modLength + comboRes[2] + "modifier count");   
											comboModifier = [];
											for (var n = 0, forLen = modLength; n < forLen; n++) {
												var inputName = "modValItems" + product_id + "-" + m + "-" + n;
												if (document.querySelector('input[name = ' + inputName + ']:checked')) {
													var modComboVal = document.querySelector('input[name = ' + inputName + ']:checked').value;
													if (modComboVal !== "") {
														modifierSelction = "success";
														var comboModRes = modComboVal.split("~");
														var comboModifierVal = [];
														// alert(comboModRes[4]);
														comboModifierVal.push({ modifier_value_id: comboModRes[3], modifier_value_qty: '1', modifier_value_name: comboModRes[2], modifier_value_price: comboModRes[4] });
														comboModifier.push({ modifier_id: comboModRes[1], modifier_name: comboModRes[0], modifiers_values: comboModifierVal });
													} else {
														modifierSelction = "Fail";
													}
												} else {
													modifierSelction = "Fail";
												}
	
												/* if modifier selection misiing show alert */
												if (modifierSelction === "Fail") {
													helper.showInfo(lang.modifier_missing);
													return false;
												}
											} /* end of second modifer for */
										} else {
											if (pro_priceAply === 1) {
												compoSimpleproprice = simplepro_price;
											}
										}
	
										/* Validate modififer selection - End  */
	
										/* object formation  - start */
										var comborVal = [];
										comborVal.push({ product_id: comboRes[3], product_name: comboRes[2], product_sku: comboRes[4], product_qty: 1, product_price: compoSimpleproprice, modifiers: comboModifier });
										combo.push({ menu_component_id: comboRes[1], menu_component_name: comboRes[0], product_details: comborVal });
										/* object formation - End */
									} else {
										comboSelction = "Fail";
									}
								} else {
									comboSelction = "Fail";
								}
	
								/* combo selection is missing show alert */
								if (comboSelction === "Fail") {
									helper.showInfo(lang.combo_missing);
									return false;
								}
							}
						}
					}
	
					//console.log(combo);  return false;
	
	
					/* outlet validation - Start */
	
					if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && _reactCookie2.default.load('defaultAvilablity') === lang.delivery) {
						if (typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderPostalCode') === "undefined") {
							if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
								if (this.state.zoneEnabled === 1) {
									if (parseInt(this.state.zonePopupDisable) === 1) {
										$("#AddressList").modal("toggle");
										return false;
									} else {
										$("#delivery_outlet").modal("toggle");
										return false;
									}
								} else {
	
									$("#AddressList").modal("toggle");
									return false;
								}
							} else {
								if (this.state.zoneEnabled === 1) {
									if (parseInt(this.state.zonePopupDisable) === 1) {
										$("#DeliveryAddress").modal("toggle");
										return false;
									} else {
										$("#delivery_outlet").modal("toggle");
										return false;
									}
								}
	
								$("#DeliveryAddress").modal("toggle");
								return false;
							}
						}
					} else if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.pickupId && _reactCookie2.default.load('defaultAvilablity') === lang.takeaWay) {
						if (typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderPostalCode') === "undefined") {
	
							var pickupOutlets = this.state.Outlets;
	
							if (pickupOutlets.length === 1) {
	
								var orderHandled = pickupOutlets[0].outlet_name + " " + pickupOutlets[0].outlet_address_line1 + " " + pickupOutlets[0].outlet_address_line2 + ", Singapore " + pickupOutlets[0].outlet_postal_code;
	
								this.setState({ orderHandled: orderHandled });
								_reactCookie2.default.save('orderOutletId', pickupOutlets[0].outlet_id);
								_reactCookie2.default.save('orderOutletName', pickupOutlets[0].outlet_name);
								_reactCookie2.default.save('orderPostalCode', pickupOutlets[0].outlet_postal_code);
								_reactCookie2.default.save('orderTAT', pickupOutlets[0].outlet_pickup_tat);
								_reactCookie2.default.save('orderHandled', orderHandled);
								_reactCookie2.default.save('orderHandledByText', orderHandled);
	
								_reactCookie2.default.save('outlet_tax_option', pickupOutlets[0].outlet_tax_option);
								_reactCookie2.default.save('outlet_tax_surcharge', pickupOutlets[0].outlet_tax_surcharge);
								_reactCookie2.default.save('outlet_tax_surcharge_inclusive', pickupOutlets[0].outlet_tax_surcharge_inclusive);
	
								_reactCookie2.default.save('outlet_option_single', 1);
	
								$("#pickup-outlet-sucess").modal("toggle");
							} else {
								$("#Pickup-OutletSelection").modal("toggle");
							}
	
							return false;
						}
					}
	
					/* Outlet validation - End */
	
					var totalPrice = proQty * proPrice;
	
					var postObject = {};
					postObject = {
						'app_id': config.ids.appId,
						"product_id": productId,
						"product_name": strp.stripslashes(proName),
						"product_sku": prosku,
						"product_image": proImage,
						"availability_id": _reactCookie2.default.load('defaultAvilablityId'),
						"product_unit_price": proPrice,
						"product_qty": proQty,
						"product_total_price": totalPrice,
						"voucher_gift_name": this.state.voucher_name !== "" ? this.state.voucher_name : _reactCookie2.default.load("UserFname"),
						"voucher_gift_email": this.state.voucher_email !== "" ? this.state.voucher_email : _reactCookie2.default.load("UserEmail"),
						"voucher_gift_message": this.state.voucher_message !== "" ? this.state.voucher_message : "",
						"product_voucher_expiry_date": this.state.product_voucher_expiry_date !== "" ? this.state.product_voucher_expiry_date : "",
						"product_voucher_points": this.state.product_voucher == "c" ? this.state.product_voucher_points : "",
						"modifiers": JSON.stringify(modifier),
						"menu_set_component": JSON.stringify(combo)
	
					};
	
					if (typeof _reactCookie2.default.load('UserId') === 'undefined') {
						postObject['reference_id'] = (0, _Api2.default)('referenceId');
					} else {
						postObject['customer_id'] = _reactCookie2.default.load('UserId');
					}
	
					//console.log(postObject);
					/*add loading */
					this.setState({ status: 'Loading' });
					_axios2.default.post(APIURLPRO + "cartv2/insert", qs.stringify(postObject)).then(function (res) {
						_this17.setState({ status: 'ok' });
						if (res.data.status === "ok") {
	
							(0, _withTracker.fbPixelCustomEvent)('AddToCartSuccess', {});
	
							var cartCount = res.data.contents.cart_details.cart_total_items;
							_reactCookie2.default.save('cartValue', 'Yes');
							_reactCookie2.default.save('cartCount', cartCount);
							_reactCookie2.default.remove('tempPromoCode');
							_reactCookie2.default.remove('tempPoints');
	
							/* find previous page */
							var slugType = _reactCookie2.default.load('categoryType');
							var slugValue = _reactCookie2.default.load('categoryId');
							if (typeof slugType !== "undefined" && typeof slugValue !== "undefined" && slugType !== '' && slugValue !== '') {
								var keyValue = slugType === "category" ? "category" : "subcategory";
								var reDirectUrl = "/products/" + keyValue + "/" + slugValue;
							} else {
								reDirectUrl = "/";
							}
							_reactCookie2.default.save('alertSuccess', lang.cart_success);
							_reactRouter.hashHistory.push(reDirectUrl);
						} else if (res.data.status === "error") {
							helper.showInfo(res.data.message);
						}
					});
				}
			}
	
			/* use to  back URL */
	
		}, {
			key: 'goBack',
			value: function goBack() {
				var slugType = _reactCookie2.default.load('categoryType');
				var slugValue = _reactCookie2.default.load('categoryId');
				if (typeof slugType !== "undefined" && typeof slugValue !== "undefined" && slugType !== '' && slugValue !== '') {
					var keyValue = slugType === "category" ? "category" : "subcategory";
					var reDirectUrl = "/products/" + keyValue + "/" + slugValue;
				} else {
					reDirectUrl = "/";
				}
	
				return reDirectUrl;
			}
			/* add desc */
	
		}, {
			key: 'addDescClass',
			value: function addDescClass(desc) {
				return desc !== "" ? 'subh product_points' : 'subh';
			}
	
			/* delivery timing */
	
		}, {
			key: 'showDeliveryTiming',
			value: function showDeliveryTiming() {
				if (APPID === apps.leanbento) {
					return _react2.default.createElement(
						'p',
						null,
						_react2.default.createElement(
							'b',
							null,
							'Your Order is handled by:'
						),
						_react2.default.createElement('br', null),
						this.state.orderHandled
					);
				}
			}
			/* show padding set combo product */
	
		}, {
			key: 'showPadding',
			value: function showPadding(product_is_combo) {
				var modVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
				//var modLen = modVal.length;
	
				var modLen = modVal !== null ? modVal.length : 0;
	
				if (product_is_combo === "Yes" || modLen > 0) {
					return _react2.default.createElement(
						'div',
						{ className: '' },
						' '
					);
				}
			}
	
			/* Show desc */
	
		}, {
			key: 'showDesc',
			value: function showDesc() {
				var desc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
				if (desc !== null) {
					return nl2br(strp.stripslashes(desc));
				}
			}
	
			/* show product name */
	
		}, {
			key: 'showProductName',
			value: function showProductName() {
				var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
				if (name !== null) {
					return nl2br(strp.stripslashes(name));
				}
			}
	
			/* work space class */
	
		}, {
			key: 'workspaceClass',
			value: function workspaceClass() {
				var retunClass = "";
				if (APPID === apps.workspace) {
					retunClass = "workspace_css ";
				}
	
				return retunClass;
			}
		}, {
			key: 'showZonalBackButton',
			value: function showZonalBackButton() {
				if (this.state.zoneEnabled === 1 && this.state.zonePopupDisable === 0) {
					return _react2.default.createElement(
						'div',
						{ className: 'col-sm-6 popup-back-btn' },
						_react2.default.createElement(
							'button',
							{ type: 'button', onClick: this.backToDeliveryBack.bind(this), className: 'btn btn-raised btn-info ' },
							'Go Back'
						)
					);
				}
			}
		}, {
			key: 'menuChangeAccess',
			value: function menuChangeAccess(e, type) {
				e.preventDefault();
				if (type == "Me") {
					$("#gust_checkout_form").addClass("show_me");
					$("#two-panel").css("display", "block");
					$("#one-panel").css("display", "none");
					$('.radio_one').removeAttr("id");
					$('.radio_two').attr("id", "two");
					$("#two-tab").addClass("tab_voucher_two");
					$("#one-tab").removeClass("tab_voucher_one");
				} else {
					$("#gust_checkout_form").removeClass("show_me");
					$("#two-panel").css("display", "none");
					$("#one-panel").css("display", "block");
					$('.radio_one').attr("id", "one");
					$('.radio_two').removeAttr("id");
					$("#two-tab").removeClass("tab_voucher_two");
				}
			}
		}, {
			key: 'loadProductDate',
			value: function loadProductDate(date) {
				var product_date = new Date(date).toString().split(" ");
				return product_date[2] + "-" + product_date[1] + "-" + product_date[3];
			}
		}, {
			key: 'render',
			value: function render() {
				var _this18 = this;
	
				var productMoreSliderSettings = {
					dots: false,
					className: "product-detail-slider category_slider row no-bar-image",
					infinite: true,
					speed: 500,
					autoplay: true,
					arrows: true
	
				};
	
				var proImg = this.__productImage(this.state.details.product_thumbnail);
				if (this.state.status === "Loading") {
	
					return _react2.default.createElement(
						'div',
						{ className: 'container-fluid desktop-container position-rel', style: { minHeight: this.state.windowHeightNormal } },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(Loading, null)
						)
					);
				} else if (this.state.status === "ok") {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_reactDocumentMeta2.default, meta),
						_react2.default.createElement(_LocationSearchInput2.default, { loading: this.state.status, open: this.state.enableAddressSearch, parentCallback: this.selectOutlet, postalcode: this.state.addressField }),
						_react2.default.createElement(
							'div',
							{ className: 'innerheader-fixed ' },
							_react2.default.createElement(
								'div',
								{ className: 'container-fluid desktop-container' },
								_react2.default.createElement(
									'div',
									{ className: this.state.activeClass + " row " },
									_react2.default.createElement(
										'div',
										{ className: this.workspaceClass() + " col-xs-12 top-nav inner-top-nav head-main" },
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-2 nav-head pd-l-10 head-child' },
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: this.goBack(), style: { cursor: 'pointer' }, className: 'backarrow' },
												_react2.default.createElement('img', { src: '/img/icons/arrow-right.png', className: 'left_arr icon-img-small-3', alt: 'left-arrow' })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-6 nav-head head-child' },
											_react2.default.createElement('h1', { className: 'main-title' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-4 nopadding head-child' },
											_react2.default.createElement(
												'p',
												{ className: 'b-txt text-right pd-l-10' },
												_react2.default.createElement(
													_reactRouter.Link,
													{ to: "/cart", className: helper.cartClass() },
													'  ',
													helper.cartCount(),
													' ',
													_react2.default.createElement('img', { src: this.loadCartImage(), className: 'icon-img-small-1 carticon', alt: 'shopping-cart' }),
													' '
												)
											)
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'my_height_class product-detailas-body', style: { minHeight: this.state.windowHeight } },
							_react2.default.createElement(
								'div',
								{ className: 'container-fluid desktop-container product-details' },
								_.isEmpty(this.state.details.image_gallery) === false && _react2.default.createElement(
									_reactSlick2.default,
									productMoreSliderSettings,
									this.state.details.image_gallery.map(function (slider, sIndex) {
										return _react2.default.createElement(
											'div',
											{ className: 'product-banner' },
											_react2.default.createElement('img', { src: _this18.state.details_common.product_gallery_image_source + "/" + slider.pro_gallery_image, alt: '', className: 'img-responsive' })
										);
									})
								),
								_.isEmpty(this.state.details.image_gallery) === true && this.loadProductImage(this.state.details.product_thumbnail, this.state.details.image_gallery),
								_react2.default.createElement(
									'div',
									{ className: 'row ' },
									_react2.default.createElement(
										'div',
										{ className: 'col-lg-12 col-md-12 col-sm-12 new-changes-voucher' },
										_react2.default.createElement(
											'h1',
											{ className: 'head2 ' },
											this.showProductName(helper.getAliasName(this.state.details.product_alias, this.state.details.product_name)),
											' '
										),
										_react2.default.createElement(
											'p',
											{ className: this.addDescClass(this.state.details.product_long_description) },
											this.showDesc(this.state.details.product_long_description)
										),
										this.state.product_type === "5" ? _react2.default.createElement(
											'div',
											{ className: 'expiry-available' },
											_react2.default.createElement(
												'span',
												null,
												'Expiry : ',
												this.loadProductDate(this.state.details.product_voucher_expiry_date)
											),
											' | ',
											_react2.default.createElement(
												'span',
												null,
												this.state.details.product_stock,
												' Available'
											)
										) : ""
									)
								),
								_react2.default.createElement('br', null)
							),
							_react2.default.createElement(
								'div',
								{ className: 'container-fluid desktop-container' },
								_react2.default.createElement(
									'div',
									{ className: 'row ' },
									_react2.default.createElement(
										'div',
										{ className: 'col-lg-12 col-md-12 col-sm-12 nopadding my-bg' },
										_react2.default.createElement(
											'div',
											{ className: 'fancy-collapse-panel' },
											_react2.default.createElement(
												'div',
												{ className: 'panel-group', role: 'tablist', 'aria-multiselectable': 'true' },
												this.showModifiers(this.state.details.modifiers),
												this.showSetMeal(this.state.details.product_is_combo, this.state.details.set_menu_component, parseInt(this.state.details.product_apply_minmax_select)),
												this.showPadding(this.state.details.product_is_combo, this.state.details.modifiers)
											)
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'div',
								{ className: 'container-fluid desktop-container' },
								_react2.default.createElement('div', { style: { height: this.newMethod() } }),
								_react2.default.createElement(
									'div',
									{ className: 'row itemsread-sec01' },
									_react2.default.createElement(
										'div',
										{ className: this.state.stockEnabled === 1 && this.state.details.product_stock === '0' ? "col-md-12 col-sm-12 col-xs-12 plus-minus-section greyed text-center" : "col-md-12 col-sm-12 col-xs-12 plus-minus-section text-center" },
										_react2.default.createElement(
											_reactRouter.Link,
											{ className: 'btn btn-group-mini' },
											this.state.stockEnabled === 1 && this.state.details.product_stock === '0' ? _react2.default.createElement(
												'i',
												{ className: 'material-icons' },
												' remove'
											) : _react2.default.createElement(
												'i',
												{ className: 'material-icons', onClick: this.dQty.bind(this) },
												' remove'
											)
										),
										_react2.default.createElement(
											'span',
											{ className: 'cartitem-txt' },
											'\xA0 ',
											this.state.cartCount,
											' \xA0'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ className: 'btn btn-group-sm ' },
											this.state.stockEnabled === 1 && this.state.details.product_stock === '0' ? _react2.default.createElement(
												'i',
												{ className: 'material-icons' },
												'add'
											) : _react2.default.createElement(
												'i',
												{ className: 'material-icons', onClick: this.iQty.bind(this) },
												'add'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-md-6 col-sm-6 col-xs-8 hide' },
										_react2.default.createElement(
											'p',
											{ className: this.state.stockEnabled === 1 && this.state.details.product_stock === '0' ? "bb-txt pull-right no-margin pd-r-25 itemtotal-txt greyed" : "bb-txt pull-right no-margin pd-r-25 itemtotal-txt" },
											_react2.default.createElement(
												'span',
												{ className: this.state.stockEnabled === 1 && this.state.details.product_stock === '0' ? "greyed totaltxt" : "totaltxt" },
												'ITEM TOTAL: '
											),
											' \xA0 ',
											_react2.default.createElement(
												'span',
												{ className: 'total-price-01' },
												_react2.default.createElement(
													'strong',
													null,
													_react2.default.createElement(
														'sup',
														null,
														'$'
													),
													(this.state.productPrice * this.state.cartCount).toFixed(2)
												)
											),
											' '
										)
									),
									_react2.default.createElement('div', { className: 'clearfix ' }),
									_react2.default.createElement(
										'div',
										{ className: 'col-lg-12 col-md-12 col-sm-12 ' },
										this.state.stockEnabled === 1 && this.state.details.product_stock === '0' ? _react2.default.createElement(
											'button',
											{ className: 'itemcart-btn-btm01 soldout' },
											'SOLD OUT'
										) : _react2.default.createElement(
											'button',
											{ id: 'addToCart', className: 'itemcart-btn-btm01', onClick: this.addToCart.bind(this, this.state.details.product_id, helper.getAliasName(this.state.details.product_alias, this.state.details.product_name), this.state.details.product_sku, this.state.productPrice, this.state.cartCount, proImg, this.state.allowCart, parseInt(this.state.details.product_apply_minmax_select), parseInt(this.state.details.product_type), this.state.details.product_voucher) },
											lang.add_to_cart,
											' - ',
											_react2.default.createElement(
												'sup',
												null,
												'$'
											),
											(this.state.productPrice * this.state.cartCount).toFixed(2)
										)
									)
								)
							),
							_react2.default.createElement('div', { className: 'clearfix' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'Pickup-Sucess' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: '' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/DeliverySucess.gif', className: 'img-responsive', alt: '' }),
											'Awesome, you can pickup !'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body text-center' },
										this.showDeliveryTiming,
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.pickupSuccess.bind(this), className: 'btn btn-raised btn-info ' },
											'Continue'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'pickup-outlet-sucess' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: '' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/DeliverySucess.gif', className: 'img-responsive', alt: '' }),
											'Awesome, you can pickup !'
										),
										_react2.default.createElement(
											'p',
											null,
											_reactCookie2.default.load('orderHandled')
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body text-center' },
										this.showDeliveryTiming,
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.pickupSuccess.bind(this), className: 'btn btn-raised btn-info ' },
											'Continue'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'DeliverySucess' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/DeliverySucess.gif', className: 'img-responsive', alt: 'thumb-up' }),
											'Awesome, we can deliver!'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body text-center' },
										_react2.default.createElement(
											'p',
											null,
											_react2.default.createElement(
												'b',
												null,
												'Your Delivery Address: '
											),
											_react2.default.createElement('br', null),
											this.state.orderDeliveryAddress
										),
										this.showdeliveryTiming,
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.deliverySuccess.bind(this), className: 'btn btn-raised btn-info ' },
											'Continue'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'DeliveryError' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: '' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/Cant_Deliver.gif', className: 'img-responsive', alt: '' }),
											'Sorry !'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'p',
											null,
											'Sorry we cant deliver to your address ',
											_react2.default.createElement('br', null),
											'Do you want to change your address or check again later ?'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-6' },
											_react2.default.createElement(
												'button',
												{ type: 'button', onClick: this.closeDeliveryErr.bind(this), className: 'col-lg-6 btn btn-raised btn-info fullwidth ' },
												'Check Later'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-6' },
											_react2.default.createElement(
												'button',
												{ type: 'button', onClick: this.changeDelivery.bind(this), className: 'col-lg-6 btn btn-raised btn-info fullwidth ' },
												'Change Address'
											)
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'ShopClosedError' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: '' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/Cant_Deliver.gif', className: 'img-responsive', alt: '' }),
											'Sorry !'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'p',
											null,
											_react2.default.createElement(
												'b',
												null,
												'Outlet Closed Temporarily. Please Try again later'
											),
											' '
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'div',
											{ className: 'col-sm-12' },
											_react2.default.createElement(
												'button',
												{ type: 'button', onClick: this.closeShopClosedError.bind(this), className: 'col-lg-6 btn btn-raised btn-info fullwidth ' },
												'Check Later'
											)
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal common-distance', id: 'Pickup-OutletSelection' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog locWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											'Select Your Pickup Location'
										)
									),
									_react2.default.createElement(Overlay, { load: this.state.load }),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'div',
											{ className: 'map-loc' },
											_react2.default.createElement(
												'div',
												{ className: 'map-box scrollbar', id: 'style-3' },
												this.__loadOutlets()
											),
											_react2.default.createElement('br', null),
											_react2.default.createElement('br', null)
										)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal common-distance', id: 'delivery_outlet' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog locWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											'PLEASE SELECT WHICH OUTLET DO YOU PREFER'
										)
									),
									_react2.default.createElement(Overlay, { load: this.state.load }),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'div',
											{ className: 'map-loc' },
											_react2.default.createElement(
												'div',
												{ className: 'map-box scrollbar', id: 'style-3' },
												this.__loadDeliveryOutlets()
											),
											_react2.default.createElement('br', null),
											_react2.default.createElement('br', null)
										)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'DeliveryAddress' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement('div', { className: 'space-50', style: { padding: "22px" } }),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											'LET US KNOW YOUR DELIVERY LOCATION'
										)
									),
									_react2.default.createElement(Overlay, { load: this.state.load }),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'div',
											{ className: 'form-group label-floating is-empty card-no' },
											_react2.default.createElement(
												'div',
												{ className: 'input-group' },
												_react2.default.createElement(
													'label',
													{ className: 'control-label' },
													'Enter Your Postal Code'
												),
												_react2.default.createElement('input', { value: this.state.addressField, id: 'postalcode1', maxLength: '6', className: 'form-control', onKeyPress: function onKeyPress(e) {
														return _this18.validatezip(e);
													}, onChange: this.handleChangeValue })
											)
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										this.showZonalBackButton(),
										_react2.default.createElement(
											'div',
											{ className: this.state.zoneEnabled === 1 && this.state.zonePopupDisable === 0 ? "col-sm-6 popup-back-btn" : "col-sm-12" },
											_react2.default.createElement(
												'button',
												{ type: 'button', onClick: this.selectOutlet.bind(this), className: 'btn btn-raised btn-info ' },
												'Continue'
											)
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'AddressList' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: true })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/DeliverySucess.gif', className: 'img-responsive', alt: true }),
											'Your Delivery Address'
										)
									),
									_react2.default.createElement(Overlay, { load: this.state.load }),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body', style: { textAlign: 'left' } },
										this.loadAddressList(),
										_react2.default.createElement(
											'p',
											null,
											_react2.default.createElement('input', { value: this.state.addressField, onChange: this.handleChangeValue, id: 'postalcode', maxLength: '6', placeholder: 'Enter Your Postal Code', className: 'add_list', onKeyPress: function onKeyPress(e) {
													return _this18.validatezip(e);
												} })
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.selectOutlet.bind(this), className: 'btn btn-raised btn-info ' },
											'Continue'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'cashVocher' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close voucher_popup', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: true })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											'Im Purchasing This'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body', style: { textAlign: 'left' } },
										_react2.default.createElement(
											'div',
											{ className: 'voucher_warpper' },
											_react2.default.createElement('input', { className: 'radio_cash radio_one', id: 'one', name: 'group', type: 'radio', checked: true }),
											_react2.default.createElement('input', { className: 'radio_cash radio_two', id: 'two', name: 'group', type: 'radio' }),
											_react2.default.createElement(
												'div',
												{ className: 'tabs_voucher' },
												_react2.default.createElement(
													'label',
													{ className: 'tab_voucher', onClick: function onClick(e) {
															_this18.menuChangeAccess(e, 'Gift');
														}, id: 'one-tab' },
													'For Gift'
												),
												_react2.default.createElement(
													'label',
													{ className: 'tab_voucher second_label', id: 'two-tab', onClick: function onClick(e) {
															_this18.menuChangeAccess(e, 'Me');
														} },
													'For Me'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'panels_voucher' },
												_react2.default.createElement(
													'div',
													{ className: 'panel_voucher', id: 'one-panel' },
													_react2.default.createElement(
														'div',
														{ className: 'panel-title_voucher' },
														_react2.default.createElement(
															'div',
															{ className: 'gust_checkout_form', id: 'gust_checkout_form' },
															_react2.default.createElement(
																'h4',
																{ className: 'vouchers-modal-title' },
																'Gift Receiver\'s Information'
															),
															_react2.default.createElement(
																'div',
																{ className: 'row' },
																_react2.default.createElement(
																	'form',
																	{ action: true, method: true },
																	_react2.default.createElement(
																		'div',
																		{ className: 'form-group label-floating is-empty card-no is-exist' },
																		_react2.default.createElement(
																			'div',
																			{ className: 'input-group' },
																			_react2.default.createElement(
																				'label',
																				{ className: 'control-label' },
																				'Name'
																			),
																			_react2.default.createElement('input', { id: 'guest-name', name: 'guest-name', value: this.state.voucher_name, onChange: this.handleChangeTxt.bind(this, 'voucher_name'), className: 'form-control', type: 'text', maxLength: '20' }),
																			this.state.error_voucher_name
																		)
																	),
																	_react2.default.createElement('span', { className: 'help-text guest-error' }),
																	_react2.default.createElement('div', { id: 'otp_error_msg' }),
																	_react2.default.createElement(
																		'div',
																		{ className: 'form-group label-floating is-empty card-no is-exist' },
																		_react2.default.createElement(
																			'div',
																			{ className: 'input-group' },
																			_react2.default.createElement(
																				'label',
																				{ className: 'control-label' },
																				'Email'
																			),
																			_react2.default.createElement('input', { type: 'email', className: 'form-control', onChange: this.handleChangeTxt.bind(this, 'voucher_email'), value: this.state.voucher_email }),
																			this.state.error_voucher_email
																		)
																	),
																	_react2.default.createElement('span', { className: 'help-text guest-error' }),
																	_react2.default.createElement(
																		'div',
																		{ className: 'form-group label-floating is-empty card-no is-exist' },
																		_react2.default.createElement(
																			'div',
																			{ className: 'input-group' },
																			_react2.default.createElement(
																				'label',
																				{ className: 'control-label' },
																				'Message'
																			),
																			_react2.default.createElement('textarea', { type: 'text', name: 'comment', placeholder: '',
																				rows: '5', id: 'guest-cemail', className: 'form-control', onChange: this.handleChangeTxt.bind(this, 'voucher_message'), value: this.state.voucher_message }),
																			this.state.error_voucher_message
																		)
																	),
																	_react2.default.createElement('span', { className: 'help-text guest-error' }),
																	_react2.default.createElement(
																		'div',
																		{ className: 'text-center voucher_button' },
																		_react2.default.createElement(
																			'button',
																			{ type: 'button', className: 'itemcart-btn-btm01 voucher',
																				onClick: this.cashVochersumbit.bind(this, this.state.details.product_id, helper.getAliasName(this.state.details.product_alias, this.state.details.product_name), this.state.details.product_sku, this.state.productPrice, this.state.cartCount, proImg, this.state.allowCart, parseInt(this.state.details.product_apply_minmax_select), this.state.details.product_voucher_expiry_date, this.state.details.product_voucher, this.state.details.product_voucher_points)
																			},
																			'Continue'
																		)
																	)
																)
															)
														)
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'panel_voucher', id: 'two-panel' },
													_react2.default.createElement(
														'div',
														{ className: 'panel-title_voucher' },
														_react2.default.createElement(
															'div',
															{ className: 'col-lg-12 col-md-12 col-sm-12 ' },
															_react2.default.createElement(
																'button',
																{ type: 'button', className: 'itemcart-btn-btm01', onClick: this.cashVocherMesumbit.bind(this, this.state.details.product_id, helper.getAliasName(this.state.details.product_alias, this.state.details.product_name), this.state.details.product_sku, this.state.productPrice, this.state.cartCount, proImg, this.state.allowCart, parseInt(this.state.details.product_apply_minmax_select), this.state.details.product_voucher_expiry_date, this.state.details.product_voucher, this.state.details.product_voucher_points) },
																lang.add_to_cart
															)
														)
													)
												)
											)
										)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						)
					);
				} else {
					return _react2.default.createElement(
						'div',
						null,
						lang.no_products_found,
						' '
					);
				}
			}
		}, {
			key: 'newMethod',
			value: function newMethod() {
				return '132px';
			}
		}]);
	
		return Productsdetails;
	}(_react2.default.Component);
	
	exports.default = (0, _reactGeolocated.geolocated)({
		positionOptions: {
			enableHighAccuracy: false
		},
		userDecisionTimeout: 5000
	})(Productsdetails);

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _reactRouter = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var config = __webpack_require__(7);
	var APPID = config.ids.appId;
	var Loading = __webpack_require__(17);
	
	var Promobuddytracking = function (_React$Component) {
	  _inherits(Promobuddytracking, _React$Component);
	
	  function Promobuddytracking() {
	    _classCallCheck(this, Promobuddytracking);
	
	    return _possibleConstructorReturn(this, (Promobuddytracking.__proto__ || Object.getPrototypeOf(Promobuddytracking)).apply(this, arguments));
	  }
	
	  _createClass(Promobuddytracking, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var tokenId = this.props.params.tokenId;
	      if (typeof tokenId !== "undefined" && tokenId !== null && APPID === tokenId) {
	        _reactCookie2.default.save('ispromobuddyOrder', 'Yes');
	        _reactRouter.hashHistory.push("/");
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _withTracker.loadAnalytics)();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'container-fluid desktop-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(Loading, null)
	        )
	      );
	    }
	  }]);
	
	  return Promobuddytracking;
	}(_react2.default.Component);
	
	exports.default = Promobuddytracking;

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(9);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var config = __webpack_require__(7);
	var moment = __webpack_require__(2);
	var APPID = config.ids.appId;
	var APIURL = config.path.apiUrl;
	var strp = __webpack_require__(31);
	
	var lang = __webpack_require__(12);
	
	var qs = __webpack_require__(3);
	var Loading = __webpack_require__(17);
	
	var helper = __webpack_require__(13);
	
	var HtmlToReactParser = __webpack_require__(21).Parser;
	var htmlToReactParserTo = new HtmlToReactParser();
	
	/* Load meta tags */
	var meta = {
		title: "My Promotions" + lang.site_title_with_separator,
		description: "My Promotions",
		meta: {
			name: {
				keywords: "My Promotions"
			}
		}
	};
	
	var Promotion = function (_React$Component) {
		_inherits(Promotion, _React$Component);
	
		function Promotion(props) {
			_classCallCheck(this, Promotion);
	
			var _this = _possibleConstructorReturn(this, (Promotion.__proto__ || Object.getPrototypeOf(Promotion)).call(this, props));
	
			_this.state = { pageTitle: 'My promotion', pageDesc: 'My promotion', status: 'ok', windowHeight: 0, promotionStatus: 'Waiting', myPromotions: [], myCatalogue: [], promoImagePath: "", currentPromo: [], cartDetails: [], cartItems: [], settings: {} };
	
			/* check Authentication */
			if ((0, _Api2.default)('Auth') === false) {
				_reactRouter.hashHistory.push("/sign-in");
			}
	
			helper.isAnonymousUserRedirect();
			return _this;
		}
	
		_createClass(Promotion, [{
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				if ((0, _Api2.default)('Auth') === false) {
					_reactRouter.hashHistory.push("/sign-in");
					return false;
				}
	
				if ((0, _Api2.default)('UserDetails') === false) {
					helper.showInfo(lang.users.user_info_missing, "", "redirect", "/my-account");
					return false;
				}
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				_axios2.default.all([_axios2.default.get(APIURL + 'promotion_api_v2/promotionlistWhitoutuniqcode?status=A&app_id=' + APPID + '&customer_id=' + _reactCookie2.default.load('UserId'))]).then(_axios2.default.spread(function (promotion) {
	
					_this2.setState({ promotionStatus: "Ready" });
	
					console.log(promotion);
					/* Set page content */
	
					/* set promotion content */
					if (promotion.data.status === "ok") {
	
						// this.setState({ pageTitle:  "My promotion",pageDesc: "My promotion" });
						_this2.setState({ myCatalogue: promotion.data.result_set.promo_history, myPromotions: promotion.data.result_set.my_promo, promoImagePath: promotion.data.common.promo_image_source });
					}
				}));
	
				var windowHeight = window.innerHeight;
				this.setState({ 'windowHeight': windowHeight + 'px' });
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this3 = this;
	
				var postalCodeWhere = "";
				if (typeof _reactCookie2.default.load("orderPostalCode") !== "undefined") {
					postalCodeWhere = '&postal_code=' + _reactCookie2.default.load("orderPostalCode");
				}
				_axios2.default.get(APIURL + 'cartver2/contents?status=A&app_id=' + APPID + "&customer_id=" + _reactCookie2.default.load('UserId') + postalCodeWhere).then(function (res) {
					if (res.data.status === "ok") {
	
						_this3.setState({ cartDetails: res.data.result_set.cart_details, cartItems: res.data.result_set.cart_items });
					}
				});
	
				(0, _withTracker.loadAnalytics)();
	
				var promise = (0, _Api2.default)("settingsPro", "No");
				promise.then(function (res) {
					if (!helper.disableMenu(res.data.result_set, "myaccount_promos")) {
						_reactRouter.hashHistory.push("/");
						return false;
					}
				});
			}
		}, {
			key: 'showPromo',
			value: function showPromo(promo) {
				this.setState({ currentPromo: promo });
				$("#RedeemPromocodeModal").modal("toggle");
			}
	
			/*apply coupon  function*/
	
		}, {
			key: 'applyPromo',
			value: function applyPromo(promocode) {
				$("#RedeemPromocodeModal").modal("hide");
	
				if (typeof this.state.cartDetails !== "undefined" && this.state.cartDetails.length === 0) {
					helper.showInfo('Your cart is currently empty. Please add products and try again', "", "");
					return false;
				}
				var postObject = {};
				var promocode = promocode !== "" ? promocode : $("#promocode").val();
	
				/* postObject = {
	   	/* cart details  /
	   	'app_id': APPID,
	   	'reference_id': cookie.load('UserId'),
	   	'promo_code': promocode,
	       		'cart_amount': cookie.load('cartsubtotal'),
	       		'availability_id':cookie.load('defaultAvilablityId'),
	   	'cart_quantity': cookie.load('carttotalitems'),
	   } */
	
				var cartSubToatl = parseFloat(this.state.cartDetails.cart_sub_total);
				var cartItemsCount = parseInt(this.state.cartDetails.cart_total_items);
				postObject = {
					/* cart details */
					'app_id': APPID,
					'reference_id': _reactCookie2.default.load('UserId'),
					'promo_code': promocode,
					'cart_amount': parseFloat(cartSubToatl),
					'cart_quantity': cartItemsCount,
					'category_id': this.getPromoCategory(),
					'availability_id': _reactCookie2.default.load('defaultAvilablityId')
				};
	
				_axios2.default.post(APIURL + 'promotion_api_v2/apply_promotion', qs.stringify(postObject)).then(function (res) {
					if (res.data.status === "success") {
	
						//alert(res.data.message);
						helper.showInfo(res.data.message, "", "reload");
						_reactCookie2.default.save('promotion_id', res.data.result_set.promotion_id);
						_reactCookie2.default.save('promotion_applied', "Yes");
						_reactCookie2.default.save('promotion_code', res.data.result_set.promotion_code);
						_reactCookie2.default.save('promotion_delivery_charge_applied', res.data.result_set.promotion_delivery_charge_applied);
						_reactCookie2.default.save('promotion_amount', res.data.result_set.promotion_amount);
						_reactCookie2.default.save('promotion_category', res.data.result_set.promotion_category);
						_reactCookie2.default.save('prmo_type', res.data.result_set.prmo_type);
	
						/*Remove if voucher applied*/
						_reactCookie2.default.remove('voucher_applied');
						_reactCookie2.default.remove('voucher_code');
						_reactCookie2.default.remove('voucher_amount');
	
						_reactRouter.hashHistory.push("/delivery-date");
					} else {
	
						if (typeof res.data.show_message !== 'undefined' && res.data.show_message === "Yes") {
	
							helper.showInfo(res.data.message, "", "redirect", '/');
						} else if (typeof res.data.form_error !== 'undefined') {
	
							helper.showInfo(res.data.form_error, "", "reload");
						} else {
	
							helper.showInfo(res.data.message, "", "reload");
						}
						if (res.data.clear_offer === 'Yes') {
	
							_reactCookie2.default.remove('promotion_id');
							_reactCookie2.default.remove('promotion_applied');
							_reactCookie2.default.remove('promotion_code');
							_reactCookie2.default.remove('promotion_delivery_charge_applied');
							_reactCookie2.default.remove('promotion_amount');
							_reactCookie2.default.remove('promotion_category');
							_reactCookie2.default.remove('prmo_type');
						}
					}
				});
			}
	
			/*  get promo category details  */
	
		}, {
			key: 'getPromoCategory',
			value: function getPromoCategory() {
	
				var product_cartid = "";
				var cartItems = this.state.cartItems;
				var cartCount = cartItems.length;
				if (cartCount > 0) {
					for (var p = 0; p < cartCount; p++) {
						if (product_cartid !== '' && cartItems[p].cart_item_product_id !== '') {
							product_cartid += ";";
						}
						product_cartid += cartItems[p].cart_item_product_id + "|" + cartItems[p].cart_item_total_price + "|" + cartItems[p].cart_item_qty;
					}
				}
	
				return product_cartid;
			}
			/*claim coupon  function*/
	
		}, {
			key: 'claimPromo',
			value: function claimPromo(promocode) {
	
				var postObject = {};
				var promocode = promocode !== "" ? promocode : $("#promocode").val();
	
				postObject = {
					/* cart details */
					'app_id': APPID,
					'reference_id': _reactCookie2.default.load('UserId'),
					'promo_code': promocode,
					'cart_amount': _reactCookie2.default.load('cartsubtotal'),
					'availability_id': _reactCookie2.default.load('defaultAvilablityId'),
					'cart_quantity': _reactCookie2.default.load('carttotalitems')
				};
	
				_axios2.default.post(APIURL + 'promotion_api_v2/claimpromo', qs.stringify(postObject)).then(function (res) {
					if (res.data.status === "success") {
	
						helper.showInfo(res.data.message, "", "reload");
					} else {
	
						if (typeof res.data.show_message !== 'undefined' && res.data.show_message === "Yes") {
							helper.showInfo(res.data.message, "", "");
						} else if (typeof res.data.form_error !== 'undefined') {
							//alert(res.data.form_error);
							helper.showInfo(res.data.form_error, "", "reload");
						} else {
							// alert(res.data.message);
							helper.showInfo(res.data.message, "", "");
						}
					}
				});
			}
	
			/*load my promotion list here */
	
		}, {
			key: 'loadMyPromotions',
			value: function loadMyPromotions(e, type) {
				var _this4 = this;
	
				if (this.state.promotionStatus === "Waiting") {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(Loading, null)
					);
				} else {
	
					/* load promotions */
					if (type === "promotion") {
						var myPromotion = this.state.myPromotions;
						if (myPromotion.length > 0) {
	
							return myPromotion.map(function (promo, index) {
								return _react2.default.createElement(
									'div',
									{ className: 'col-md-6', key: index },
									_react2.default.createElement(
										'div',
										{ className: 'promo-box' },
										_react2.default.createElement(
											'div',
											{ className: 'promo-img-item' },
											_react2.default.createElement('img', { src: _this4.loadPromoImage(promo.promotion_image) })
										),
										_react2.default.createElement(
											'div',
											{ className: 'promo-btm-section' },
											_react2.default.createElement(
												'span',
												{ className: 'promo-text' },
												'Promo Code'
											),
											_react2.default.createElement(
												'span',
												{ className: 'promo-amount' },
												promo.promo_code
											),
											_react2.default.createElement(
												'span',
												{ className: 'promo-expiry-date' },
												' Valid till  ',
												moment(promo.promotion_end_date).format('Do of MMM YYYY'),
												' '
											),
											_react2.default.createElement(
												'div',
												{ className: 'promo-btn-block' },
												_react2.default.createElement(
													_reactRouter.Link,
													{ style: { cursor: 'pointer' }, onClick: _this4.showPromo.bind(_this4, promo), className: 'promo-btn-view' },
													_react2.default.createElement(
														'span',
														null,
														'View'
													)
												),
												_react2.default.createElement(
													_reactRouter.Link,
													{ onClick: _this4.applyPromo.bind(_this4, promo.promo_code), style: { cursor: 'pointer' }, className: 'promo-btn-redeem' },
													_react2.default.createElement(
														'span',
														null,
														'Redeem'
													)
												)
											)
										)
									)
								);
							});
						} else {
	
							return _react2.default.createElement(
								'div',
								{ className: 'productparent' },
								_react2.default.createElement(
									'div',
									{ className: 'raw' },
									_react2.default.createElement(
										'div',
										{ className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'p',
											{ className: 'text-center' },
											'No promotion found'
										)
									)
								)
							);
						}
					}
	
					/* load my catalogue*/
					if (type === "catalogue") {
	
						var myCatalogue = this.state.myCatalogue;
						console.log(myCatalogue);
						if (typeof myCatalogue !== "undefined" && myCatalogue.length > 0) {
	
							return myCatalogue.map(function (cate, indexx) {
								return _react2.default.createElement(
									'div',
									{ className: 'col-md-6', key: indexx },
									_react2.default.createElement(
										'div',
										{ className: 'promo-box' },
										_react2.default.createElement(
											'div',
											{ className: 'promo-img-item' },
											_react2.default.createElement('img', { src: _this4.loadPromoImage(cate.promotion_image) })
										),
										_react2.default.createElement(
											'div',
											{ className: 'promo-btm-section' },
											_react2.default.createElement(
												'span',
												{ className: 'promo-text' },
												'Promo Code'
											),
											_react2.default.createElement(
												'span',
												{ className: 'promo-amount' },
												cate.promo_code
											)
										)
									)
								);
							});
						} else {
	
							return _react2.default.createElement(
								'div',
								{ className: 'productparent' },
								_react2.default.createElement(
									'div',
									{ className: 'raw' },
									_react2.default.createElement(
										'div',
										{ className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'p',
											{ className: 'text-center' },
											'No promotion found'
										)
									)
								)
							);
						}
					}
				}
			}
		}, {
			key: 'loadPromoImage',
			value: function loadPromoImage(promoImage) {
				var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
				//console.log(promoImage);
				if (promoImage !== "" && promoImage !== null && typeof promoImage !== 'undefined') {
					if (type === 'popup') {
						return config.path.tinThumpUrl + this.state.promoImagePath + promoImage + '&w=756&h=500&q=80';
					} else {
						return config.path.tinThumpUrl + this.state.promoImagePath + promoImage + '&w=156&h=137&q=80';
					}
				} else {
	
					return "img/no-images/products-no-image.jpg";
				}
			}
		}, {
			key: 'render',
			value: function render() {
	
				if (this.state.status !== "Loading") {
					return _react2.default.createElement(
						'div',
						{ className: 'container-fluid no-padding ninja-theme-v2 desktop-container', style: { minHeight: this.state.windowHeight } },
						_react2.default.createElement(_reactDocumentMeta2.default, meta),
						_react2.default.createElement(
							'div',
							{ className: 'row', style: { marginLeft: 0, marginRight: 0 } },
							_react2.default.createElement(
								'div',
								{ className: 'col-xs-12 top-nav inner-top-nav head-main' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-3 nav-head head-child' },
									' ',
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: "/" },
										_react2.default.createElement('img', { src: '/img/icons/arrow-right.png', className: 'left_arr icon-img-small-3', alt: 'left-arrow' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-6 nav-head head-child' },
									_react2.default.createElement(
										'h1',
										{ className: 'main-title' },
										'My Promotions'
									)
								),
								_react2.default.createElement('div', { className: 'col-xs-3' })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'reserve-wrap promo-cat' },
							_react2.default.createElement(
								'div',
								{ className: 'promo-apply-block' },
								_react2.default.createElement(
									'p',
									null,
									'Redeem Your'
								),
								_react2.default.createElement(
									'h2',
									null,
									'Promotions'
								),
								_react2.default.createElement(
									'div',
									{ className: 'promo-appy-form' },
									_react2.default.createElement('input', { type: 'text', className: 'txt-field promocode', id: 'promocode', placeholder: 'Add Your Promo/Invite Code Here' }),
									_react2.default.createElement(
										'button',
										{ onClick: this.applyPromo.bind(this, ''), className: 'btn btn-promo-appy' },
										'Apply Now'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'tabbable-panel' },
								_react2.default.createElement(
									'div',
									{ className: 'tabbable-line' },
									_react2.default.createElement(
										'ul',
										{ className: 'nav nav-tabs' },
										_react2.default.createElement(
											'li',
											{ className: 'active' },
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: "#tab_default_1", 'data-toggle': 'tab' },
												'PROMOTIONS '
											)
										),
										_react2.default.createElement(
											'li',
											null,
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: "#tab_default_2", 'data-toggle': 'tab' },
												'USED PROMOTIONS '
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'tab-content' },
										_react2.default.createElement(
											'div',
											{ className: 'tab-pane fade in active', id: 'tab_default_1' },
											_react2.default.createElement(
												'div',
												{ className: 'row' },
												this.loadMyPromotions(this, 'promotion')
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'tab-pane fade', id: 'tab_default_2' },
											_react2.default.createElement(
												'div',
												{ className: 'row' },
												this.loadMyPromotions(this, 'catalogue')
											)
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal ninja-theme-v2 redeem-promocode-modal', style: { display: 'none' }, id: 'RedeemPromocodeModal' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header no-padding' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/black-close.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-12 no-padding' },
											_react2.default.createElement(
												'div',
												{ className: 'promo-box1' },
												_react2.default.createElement(
													'div',
													{ className: 'promo-img-item' },
													_react2.default.createElement('img', { src: this.loadPromoImage(this.state.currentPromo.promotion_image, 'popup') })
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-12 no-padding' },
											_react2.default.createElement(
												'div',
												{ className: 'promo-box1' },
												_react2.default.createElement(
													'div',
													{ className: 'promo-btm-section' },
													_react2.default.createElement(
														'span',
														{ className: 'promo-text' },
														'Promo Code'
													),
													_react2.default.createElement(
														'span',
														{ className: 'promo-amount' },
														this.state.currentPromo.promo_code
													),
													_react2.default.createElement(
														'span',
														{ className: 'promo-expiry-date' },
														'Valid till  ',
														moment(this.state.currentPromo.promotion_end_date).format('Do of MMM YYYY')
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'div',
											{ className: 'promo-code-popup-block' },
											'   ',
											_react2.default.createElement(
												'div',
												{ className: 'promo-pup-content' },
												this.state.currentPromo.promo_desc !== "" ? htmlToReactParserTo.parse(this.state.currentPromo.promo_desc_showtext) : ''
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-xs-12 promo-redeem-btn-block' },
												_react2.default.createElement(
													'button',
													{ onClick: this.applyPromo.bind(this, this.state.currentPromo.promo_code), type: 'button', className: 'btn btn-raised' },
													'Redeem'
												)
											)
										)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						)
					);
				} else {
					return _react2.default.createElement(
						'div',
						{ className: 'container-fluid desktop-container' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(Loading, null)
						)
					);
				}
			}
		}]);
	
		return Promotion;
	}(_react2.default.Component);
	
	exports.default = Promotion;

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactQrReader = __webpack_require__(438);
	
	var _reactQrReader2 = _interopRequireDefault(_reactQrReader);
	
	var _reactRouter = __webpack_require__(9);
	
	var _withTracker = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QrCodeReader = function (_React$Component) {
	  _inherits(QrCodeReader, _React$Component);
	
	  function QrCodeReader(props) {
	    _classCallCheck(this, QrCodeReader);
	
	    var _this = _possibleConstructorReturn(this, (QrCodeReader.__proto__ || Object.getPrototypeOf(QrCodeReader)).call(this, props));
	
	    _this.state = {
	      delay: 100,
	      result: 'No result'
	    };
	    _this.handleScan = _this.handleScan.bind(_this);
	    return _this;
	  }
	
	  _createClass(QrCodeReader, [{
	    key: 'handleScan',
	    value: function handleScan(data) {
	      this.setState({
	        result: data
	      });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError(err) {
	      console.error(err);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _withTracker.loadAnalytics)();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var previewStyle = {
	        height: 240,
	        width: 320
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'container-fluid desktop-container', id: 'qr-scan' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 main-title-bar' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/book-a-table' },
	              _react2.default.createElement('img', { src: '/img/left-arrow.png', className: 'pull-left icon-img-small', alt: 'left-arrow' })
	            ),
	            _react2.default.createElement(
	              'h3',
	              { className: 'top-title main-title padding-right-20' },
	              'SCAN YOUR QR CODE'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement('div', { className: 'space-10 bg-gray' })
	        ),
	        _react2.default.createElement(_reactQrReader2.default, {
	          delay: this.state.delay,
	          previewStyle: previewStyle,
	          onError: this.handleError,
	          onScan: this.handleScan,
	          legacyMode: true
	        }),
	        _react2.default.createElement(
	          'p',
	          null,
	          this.state.result
	        )
	      );
	    }
	  }]);
	
	  return QrCodeReader;
	}(_react2.default.Component);
	
	exports.default = QrCodeReader;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _withTracker = __webpack_require__(11);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	__webpack_require__(614);
	
	var _reactQrReader = __webpack_require__(438);
	
	var _reactQrReader2 = _interopRequireDefault(_reactQrReader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var lang = __webpack_require__(12);
	
	var config = __webpack_require__(7);
	var APIURL = config.path.apiUrl;
	var APPID = config.ids.appId;
	
	var qs = __webpack_require__(3);
	
	var SiteURL = _reactCookie2.default.load('siteURL');
	var ResultURL = SiteURL; //SiteURL.replace(/(^\w+:|^)\/\//, '');
	var targetURL = SiteURL; //ResultURL.replace(/\/$/, '');
	var helper = __webpack_require__(13);
	
	/* Load meta tags */
	var meta = {
		title: lang.scan_qr_code_page,
		description: lang.scan_qr_code_page,
		meta: {
			name: {
				keywords: lang.scan_qr_code_page
			}
		}
	};
	
	var Qrcodescan = function (_React$Component) {
		_inherits(Qrcodescan, _React$Component);
	
		function Qrcodescan(props) {
			_classCallCheck(this, Qrcodescan);
	
			var _this = _possibleConstructorReturn(this, (Qrcodescan.__proto__ || Object.getPrototypeOf(Qrcodescan)).call(this, props));
	
			if (APPID === "AA6A05F0-BEEE-49AF-9CA5-747EF4E901B9") {
				if (location.protocol != 'https:') {
					location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
				}
			}
	
			/* check Authentication */
			/*if(getResult('Auth') === false ){
	      hashHistory.push("/sign-in");
	  }*/
			/* validate cart details */
			var postalCodeWhere = "";
			if (typeof _reactCookie2.default.load("orderPostalCode") !== "undefined") {
				postalCodeWhere = '&postal_code=' + _reactCookie2.default.load("orderPostalCode");
			}
			_axios2.default.get(APIURL + 'cartver2/contents?app_id=' + APPID + "&customer_id=" + _reactCookie2.default.load('UserId') + postalCodeWhere).then(function (res) {
				if (res.data.status === "ok") {
					console.log('success');
				} else {
					helper.showInfo('something went wrong');
					_reactRouter.hashHistory.push("/");
				}
			});
	
			/* Redirect to main page */
			if (_reactCookie2.default.load('defaultAvilablityId') !== config.ids.dineinId) {
				_reactRouter.hashHistory.push("/");
			}
	
			/* Dine in Disabled apps */
			if (APPID === "6C9AEE37-BC05-4FB8-A351-D51458B83F26") {
				_reactRouter.hashHistory.push("/");
			}
	
			var tablenumtxt = typeof _reactCookie2.default.load('orderTableNo') !== "undefined" && _reactCookie2.default.load('orderTableNo') !== '' && _reactCookie2.default.load('applyOutletId') === 'yes' ? _reactCookie2.default.load('orderTableNo') : '';
	
			var backlinktxt = '/cart';
			if (_reactCookie2.default.load('dineinClick') === 'yes') {
				backlinktxt = '/';
				_reactCookie2.default.save('dineinFrom', 'booktbl');
			}
	
			_this.state = {
				delay: 500000,
				result: 'No result', windowHeight: 0, qrResult: '', tableNumTxt: tablenumtxt, backLinkTxt: backlinktxt,
				qrresultClass: ''
	
				//  this.handleScan = this.handleScan.bind(this)
			};_this.handleScan = _this.handleScan.bind(_this);
			_this.openImageDialog = _this.openImageDialog.bind(_this);
			//	 this.handleChange = this.handleChange.bind(this);  
	
	
			return _this;
		}
	
		_createClass(Qrcodescan, [{
			key: 'handleScan',
			value: function handleScan(result) {
				if (result) {
					//alert('succ');
					//$("#qrcode_bg").hide();
					this.validatetableNo(result);
					//alert(result);
					this.setState({ qrResult: result });
					//this.setState({qrresultClass : "is-focused"})
				} else {
					helper.showInfo('Please try agian');
				}
			}
		}, {
			key: 'handleError',
			value: function handleError(err) {
				helper.showInfo('Invalid table no,Please try agian');
				//  $("#qrcode_bg").hide();
				// this.setState({ qrResult: "" })
	
				//console.error(err)
			}
		}, {
			key: 'openImageDialog',
			value: function openImageDialog() {
				this.refs.qrReader1.openImageDialog();
			}
		}, {
			key: 'handleChange',
			value: function handleChange(event) {
				//  alert(event.target.value);
				// this.setState({qrresultClass: event.target.value});
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var windowHeight = window.innerHeight;
				this.setState({ 'windowHeight': windowHeight - 45 + 'px' });
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				/* window.load();
	    window.setimg();
	    setTimeout(function() {
	    this.checkQrFileDiv();
	    }.bind(this), 500); */
	
				var tableno = this.props.params.tableNo;
				console.log("Test message" + tableno);
				if (tableno !== '' && tableno !== undefined) {
					this.handleScan(tableno);
				}
				(0, _withTracker.loadAnalytics)();
			}
		}, {
			key: 'handleChangeTblValue',
			value: function handleChangeTblValue(event) {
				this.setState({ tableNumTxt: event.target.value });
			}
			/* this function used to validate table no*/
	
		}, {
			key: 'checkTablNo',
			value: function checkTablNo() {
	
				var tableNo = document.getElementById("tableNo").value;
	
				if (tableNo !== "") {
					document.getElementById("loadIcon").style.display = "block";
					document.getElementById("SubBtn").style.display = "none";
	
					var postObject = {};
					postObject = { 'app_id': APPID, 'tm_table_number': tableNo };
	
					_axios2.default.post(APIURL + "tablemanagement/find_table", qs.stringify(postObject)).then(function (res) {
						document.getElementById("loadIcon").style.display = "none";
						document.getElementById("SubBtn").style.display = "block";
						if (res.data.status === "ok") {
							_reactCookie2.default.save('orderOutletId', res.data.result_set[0].outlet_id);
							_reactCookie2.default.save('orderOutletName', res.data.result_set[0].outlet_name);
							_reactCookie2.default.save('orderTableNo', tableNo);
	
							_reactCookie2.default.save('outlet_tax_option', res.data.result_set[0].outlet_tax_option);
							_reactCookie2.default.save('outlet_tax_surcharge', res.data.result_set[0].outlet_tax_surcharge);
							_reactCookie2.default.save('outlet_tax_surcharge_inclusive', res.data.result_set[0].outlet_tax_surcharge_inclusive);
	
							var tatVal = res.data.result_set[0].outlet_dine_tat !== "" ? res.data.result_set[0].outlet_dine_tat : res.data.result_set[0].outlet_delivery_timing;
	
							_reactCookie2.default.save('orderTAT', tatVal);
							// window.location = "/checkout";
							if (_reactCookie2.default.load('dineinClick') === 'yes') {
								_reactCookie2.default.save('dineinFrom', '');
								if (_reactCookie2.default.load('bckurlTxt') !== "undefined" && _reactCookie2.default.load('bckurlTxt') !== "") {
									var bckurltxt = _reactCookie2.default.load('bckurlTxt');
									_reactCookie2.default.save('bckurlTxt', '');
									_reactRouter.hashHistory.push(bckurltxt);
								} else {
									_reactRouter.hashHistory.push("/");
								}
							} else {
								_reactRouter.hashHistory.push("/checkout");
							}
						} else if (res.data.status === "error") {
							document.getElementById("tableNo").value = "";
							helper.showInfo(res.data.result_set);
						}
					});
				} else {
					helper.showInfo('Please fill table No');
				}
			}
	
			/* qr code result validation */
	
		}, {
			key: 'validatetableNo',
			value: function validatetableNo(tableNo) {
	
				//	var tableNo =  document.getElementById("tableNo").value;
	
	
				if (tableNo !== "") {
					document.getElementById("loadIcon").style.display = "block";
					document.getElementById("SubBtn").style.display = "none";
	
					var postObject = {};
					postObject = { 'app_id': APPID, 'tm_table_number': tableNo };
	
					_axios2.default.post(APIURL + "tablemanagement/find_table", qs.stringify(postObject)).then(function (res) {
						document.getElementById("loadIcon").style.display = "none";
						document.getElementById("SubBtn").style.display = "block";
						if (res.data.status === "ok") {
							_reactCookie2.default.save('orderOutletId', res.data.result_set[0].outlet_id);
							_reactCookie2.default.save('orderOutletName', res.data.result_set[0].outlet_name);
							_reactCookie2.default.save('orderTableNo', tableNo);
							var tatVal = res.data.result_set[0].outlet_dine_tat !== "" ? res.data.result_set[0].outlet_dine_tat : res.data.result_set[0].outlet_delivery_timing;
	
							_reactCookie2.default.save('orderTAT', tatVal);
							// window.location = "/checkout";
							// if(tableNo !==""){
							$("#qr-code-alert").modal("hide");
							// }
							if (_reactCookie2.default.load('dineinClick') === 'yes') {
								_reactCookie2.default.save('dineinFrom', '');
								_reactRouter.hashHistory.push("/");
							} else {
								_reactRouter.hashHistory.push("/checkout");
							}
						} else if (res.data.status === "error") {
							document.getElementById("tableNo").value = "";
							helper.showInfo(res.data.result_set);
						}
					});
				} else {
					helper.showInfo('Please fill table No');
				}
			}
	
			/**/
	
		}, {
			key: 'checkQrFileDiv',
			value: function checkQrFileDiv() {
				if (document.getElementById("outdiv").innerHTML === '') {
					location.reload();
				}
			}
		}, {
			key: 'render',
			value: function render() {
	
				var previewStyle = {
					height: 240,
					width: 320,
					border: 0,
					display: 'none'
	
				};
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_reactDocumentMeta2.default, meta),
					_react2.default.createElement(
						'div',
						{ className: 'container-fluid desktop-container', style: { minHeight: this.state.windowHeight } },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-xs-12 main-title-bar' },
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: this.state.backLinkTxt },
									_react2.default.createElement('img', { src: '/img/left-arrow.png', className: 'pull-left icon-img-small', alt: 'left-arrow' })
								),
								_react2.default.createElement(
									'h3',
									{ className: 'top-title main-title padding-right-20' },
									'DINE IN'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement('div', { className: 'space-10 bg-gray' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'white-outer center-block', style: { borderBottom: '0px' } },
							_react2.default.createElement(
								'div',
								{ className: 'col-sm-6 col-xs-12 div-center', style: { marginBottom: '0px' } },
								_react2.default.createElement('div', { className: 'space-30' }),
								_react2.default.createElement(
									'p',
									{ className: 'text-center font-bold font-size-18' },
									'Scan The QR Code'
								),
								_react2.default.createElement('div', { className: 'space-15' }),
								_react2.default.createElement(
									'div',
									{ id: 'mainbody' },
									_react2.default.createElement(
										'div',
										{ className: 'my_qr_design' },
										_react2.default.createElement('div', { className: 'outdiv_c', id: 'outdiv' }),
										_react2.default.createElement(
											'a',
											{ className: 'btn btn-info btn-lg btn-qr-submit', href: 'https://dinein.ninjapro.co' },
											'Click Here To Scan'
										)
									)
								)
							)
						),
						_react2.default.createElement('div', { className: 'clearfix' }),
						_react2.default.createElement('div', { className: 'clearfix' }),
						_react2.default.createElement(
							'div',
							{ className: 'white-outer center-block', style: { borderTop: '0px' } },
							_react2.default.createElement('div', { className: 'space-20' }),
							_react2.default.createElement(
								'p',
								{ className: 'text-center font-size-18 color-gray or_t_qr' },
								'OR'
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-sm-4 col-xs-12 div-center', style: { marginTop: '0px' } },
								_react2.default.createElement('div', { className: 'space-10', id: 'message' }),
								_react2.default.createElement(
									'p',
									{ className: 'text-center font-bold text-uppercase font-size-18' },
									'enter table number'
								),
								_react2.default.createElement('div', { className: 'space-5' }),
								_react2.default.createElement(
									'div',
									{ className: 'form-group label-floating is-empty card-no table-no' },
									_react2.default.createElement(
										'div',
										{ className: 'input-group' },
										_react2.default.createElement(
											'label',
											{ className: 'control-label', htmlFor: 'tableNo' },
											'Table Number'
										),
										_react2.default.createElement('input', { type: 'text', id: 'tableNo', value: this.state.tableNumTxt, onChange: this.handleChangeTblValue, className: 'form-control' })
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'clearfix' },
								_react2.default.createElement('div', { className: 'space-30' }),
								' ',
								_react2.default.createElement('div', { className: 'space-30' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'modal custom_qr_t', id: 'qr-code-alert' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-dialog locWidth' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-content' },
										_react2.default.createElement(
											'div',
											{ className: 'modal-header' },
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'close', 'data-dismiss': 'modal' },
												'\xD7'
											),
											_react2.default.createElement('div', { className: 'space-20' }),
											_react2.default.createElement(
												'p',
												null,
												'   Please Take A Photo Of The QR On Your Table To Proceed'
											),
											_react2.default.createElement(
												'div',
												{ className: 'qr_sec_t' },
												_react2.default.createElement('img', { className: 'img-responsive', src: '/img/qr-screen.png', alt: 'qrCode' }),
												_react2.default.createElement(
													'div',
													{ className: 'ninj_pro' },
													_react2.default.createElement(
														'span',
														null,
														'Visit :'
													),
													' \xA0 ',
													_react2.default.createElement(
														'a',
														{ href: targetURL, title: targetURL, target: '_blank' },
														targetURL
													)
												),
												_react2.default.createElement('img', { className: 'code_q', src: '/img/qr_code_t.png', alt: 'qrCode', id: 'qrcode_bg' }),
												_react2.default.createElement(_reactQrReader2.default, {
													ref: 'qrReader1',
													delay: this.state.delay,
													style: previewStyle,
													onError: this.handleError,
													onScan: this.handleScan,
													legacyMode: true
												})
											),
											_react2.default.createElement(
												'div',
												null,
												_react2.default.createElement(
													'p',
													{ className: 'text-center', style: { margin: 0 } },
													_react2.default.createElement(
														'a',
														{ className: 'btn-qr-snap', onClick: this.openImageDialog },
														_react2.default.createElement('img', { src: '/img/camio.png', alt: 'camera' }),
														_react2.default.createElement(
															'span',
															null,
															'Take a Picture'
														)
													),
													' '
												),
												_react2.default.createElement('div', { className: 'clear' })
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								'   ',
								_react2.default.createElement('img', { style: { display: 'none', bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto' }, src: '/img/loader.gif', alt: 'Loading', id: 'loadIcon' }),
								_react2.default.createElement(
									_reactRouter.Link,
									{ onClick: this.checkTablNo.bind(this), id: 'SubBtn' },
									' ',
									_react2.default.createElement(
										'button',
										{ className: 'col-lg-12 continue-but desktop-container container-fluid' },
										'Submit'
									),
									'  '
								)
							),
							'     '
						)
					)
				);
			}
		}]);
	
		return Qrcodescan;
	}(_react2.default.Component);
	
	exports.default = Qrcodescan;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(9);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var Loading = __webpack_require__(17);
	var config = __webpack_require__(7);
	var lang = __webpack_require__(12);
	var APIURL = config.path.apiUrl;
	var APPID = config.ids.appId;
	
	var helper = __webpack_require__(13);
	
	/* Load meta tags */
	var meta = {
	  title: lang.activation_meta_title,
	  description: lang.activation_meta_title,
	  meta: {
	    name: {
	      keywords: lang.activation_meta_title
	    }
	  }
	};
	
	var Quickbook = function (_React$Component) {
	  _inherits(Quickbook, _React$Component);
	
	  function Quickbook() {
	    _classCallCheck(this, Quickbook);
	
	    return _possibleConstructorReturn(this, (Quickbook.__proto__ || Object.getPrototypeOf(Quickbook)).apply(this, arguments));
	  }
	
	  _createClass(Quickbook, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      /* add class */
	      helper.addBodyClass();
	    }
	    /* Account activation */
	
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _withTracker.loadAnalytics)();
	      var qs = __webpack_require__(3);
	      var tableNo = this.props.params.tableNo;
	
	      /* for account activation - start */
	
	      if (typeof tableNo !== "undefined" && tableNo !== "") {
	        // return false;
	        var postObject = {
	          app_id: APPID,
	          tm_table_number: tableNo
	        };
	        _axios2.default.post(APIURL + "tablemanagement/find_table", qs.stringify(postObject)).then(function (response) {
	          /* Success response */
	          if (response.data.status === "ok") {
	            var errorMsg = response.data.message;
	
	            _reactCookie2.default.save('orderOutletId', response.data.result_set[0].outlet_id);
	            _reactCookie2.default.save('orderOutletName', response.data.result_set[0].outlet_name);
	            _reactCookie2.default.save('orderTableNo', tableNo);
	
	            _reactCookie2.default.save('outlet_tax_option', response.data.result_set[0].outlet_tax_option);
	            _reactCookie2.default.save('outlet_tax_surcharge', response.data.result_set[0].outlet_tax_surcharge);
	            _reactCookie2.default.save('outlet_tax_surcharge_inclusive', response.data.result_set[0].outlet_tax_surcharge_inclusive);
	
	            var tatVal = response.data.result_set[0].outlet_dine_tat !== "" ? response.data.result_set[0].outlet_dine_tat : response.data.result_set[0].outlet_delivery_timing;
	
	            _reactCookie2.default.save('orderTAT', tatVal);
	
	            //cookie.save('siteURL','');
	            _reactCookie2.default.save('dineinFrom', 'homepage');
	            _reactCookie2.default.save('defaultAvilablityImage', lang.dineInImageWhite);
	            _reactCookie2.default.save('defaultAvilablityId', config.ids.dineinId);
	            _reactCookie2.default.save('defaultAvilablity', 'Dine In');
	            _reactCookie2.default.save('onetimeClick', 'Yes');
	
	            // helper.showInfo('success! you are ready for ordering');
	            _reactRouter.hashHistory.push("/");
	          }
	
	          /* Success response */
	          if (response.data.status === "error") {
	            helper.showInfo('sorry this table not available now please try again later');
	            _reactRouter.hashHistory.push("/");
	          }
	          /* error reponse */
	        });
	      } else {
	
	        _reactRouter.hashHistory.push("/");
	      }
	      /* for account activation - end  */
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reactDocumentMeta2.default, meta),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "chk_popup act_loder",
	            id: "PayProcess",
	            style: { position: "unset" }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "white-outer center-block process_order" },
	            _react2.default.createElement(
	              "div",
	              { className: "row " },
	              _react2.default.createElement(
	                "div",
	                { className: "col-xs-12 padd2" },
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Please wait while we check the availability of the table"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "clock_part" },
	                  _react2.default.createElement("img", { src: "/img/spinner.gif", alt: "" }),
	                  _react2.default.createElement("br", null)
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Quickbook;
	}(_react2.default.Component);
	
	exports.default = Quickbook;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(9);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactMoment = __webpack_require__(99);
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var config = __webpack_require__(7);
	var lang = __webpack_require__(12);
	var Loading = __webpack_require__(17);
	var APIURL = config.path.apiUrl;
	var APIURLPRO = config.path.apiUrlPro;
	var APPID = config.ids.appId;
	var currency = config.ids.currency;
	var helper = __webpack_require__(13);
	var HtmlToReactParser = __webpack_require__(21).Parser;
	var htmlToReactParser = new HtmlToReactParser();
	var strp = __webpack_require__(31);
	var monthNamesArr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	
	/* Load meta tags */
	var meta = {
		title: "My Reservation",
		description: "My Reservation",
		meta: {
			name: {
				keywords: "My Reservation"
			}
		}
	};
	
	var Reservation = function (_React$Component) {
		_inherits(Reservation, _React$Component);
	
		function Reservation(props) {
			_classCallCheck(this, Reservation);
	
			/*add class */
			helper.addBodyClass();
	
			var _this = _possibleConstructorReturn(this, (Reservation.__proto__ || Object.getPrototypeOf(Reservation)).call(this, props));
	
			_this.state = { credit: [], debit: [], status: "Loading", windowHeightNormal: 0, windowHeight: 0, points: 0, creditLimit: 5, debitLimit: 5 };
	
			/* check Authentication */
			if ((0, _Api2.default)('Auth') === false) {
				_reactRouter.hashHistory.push("/sign-in");
			}
	
			helper.isAnonymousUserRedirect();
	
			_axios2.default.all([_axios2.default.get(APIURL + '/customer/customerdetail?app_id=' + APPID + "&refrence=" + _reactCookie2.default.load('UserId'))]).then(_axios2.default.spread(function (customer) {
				_this.setState({ status: "ok" });
	
				if (customer.data.status === "ok") {
					_this.setState({ points: customer.data.result_set.customer_reward_point });
				}
			}));
	
			_this.loadData();
	
			return _this;
		}
	
		_createClass(Reservation, [{
			key: 'loadData',
			value: function loadData() {
				var _this2 = this;
	
				var cLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
				var dLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
				var limitOne = cLimit !== null ? cLimit : this.state.creditLimit;
				var limitTwo = dLimit !== null ? dLimit : this.state.debitLimit;
				_axios2.default.all([_axios2.default.get(APIURL + 'reports/reservation_orderhistory_details?app_id=' + APPID + "&customer_id=" + _reactCookie2.default.load('UserId') + "&limit=" + limitOne), _axios2.default.get(APIURL + 'reports/reservation_orderhistory_details?statustxt=5&app_id=' + APPID + "&customer_id=" + _reactCookie2.default.load('UserId') + "&limit=" + limitTwo)]).then(_axios2.default.spread(function (credit, debit) {
					_this2.setState({ status: "ok" });
					setTimeout(function () {
						this.loadData();
					}.bind(_this2), 10000);
					if (credit.data.status === "ok") {
						_this2.setState({ credit: credit.data.result_set });
					}
	
					if (debit.data.status === "ok") {
						_this2.setState({ debit: debit.data.result_set });
					}
				}));
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
	
				var windowHeight = window.innerHeight;
				this.setState({ 'windowHeight': windowHeight - 45 + 'px' });
				this.setState({ 'windowHeightNormal': windowHeight + 'px' });
			}
	
			/* Change earend records */
	
		}, {
			key: 'handleChange',
			value: function handleChange(event) //handleChangereedem
			{
				console.log(event.target.value);
				this.setState({ creditLimit: event.target.value });
				this.loadData(event.target.value, null);
			}
	
			/* Change redeem records */
	
		}, {
			key: 'handleChangeRedeem',
			value: function handleChangeRedeem(event) //handleChangereedem
			{
				console.log(event.target.value);
				this.setState({ debitLimit: event.target.value });
				this.loadData(null, event.target.value);
			}
		}, {
			key: 'getTblName',
			value: function getTblName(tblnme, status) {
				if (tblnme !== '') {
					var clsName = '';
					if (status === '6') {
						clsName = 'text-yellow';
					}
					return _react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'td',
							null,
							'Table No'
						),
						_react2.default.createElement(
							'td',
							null,
							':'
						),
						_react2.default.createElement(
							'td',
							null,
							_react2.default.createElement(
								'span',
								{ className: clsName },
								tblnme
							)
						)
					);
				}
			}
		}, {
			key: 'getSpecification',
			value: function getSpecification(msgtxt, status) {
				if (msgtxt !== '') {
					var clsName = '';
					if (status === '6') {
						clsName = 'text-yellow';
					}
					return _react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'td',
							null,
							'Message'
						),
						_react2.default.createElement(
							'td',
							null,
							':'
						),
						_react2.default.createElement(
							'td',
							null,
							_react2.default.createElement(
								'span',
								{ className: clsName },
								msgtxt
							)
						)
					);
				}
			}
		}, {
			key: 'chgDatefrmt',
			value: function chgDatefrmt(datetxt) {
				if (datetxt !== '') {
					datetxt = datetxt.replace(' ', 'T');
					var caldatesplt = new Date(datetxt);
					var calRsResDatepkidVal = ("0" + caldatesplt.getDate()).slice(-2) + " " + monthNamesArr[caldatesplt.getMonth()] + " " + caldatesplt.getFullYear();
					return calRsResDatepkidVal;
				}
			}
		}, {
			key: 'getActionBtn',
			value: function getActionBtn(status, sugPrmyId) {
				if (status === '6') {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'btn-wp' },
							_react2.default.createElement(
								'a',
								{ className: 'btn-accept active', href: 'javascript:;', style: { cursor: 'pointer' }, onClick: this.acceptRejectFun.bind(this, sugPrmyId, 'accept') },
								'Accept'
							)
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'a',
								{ className: 'btn-reject', href: 'javascript:;', style: { cursor: 'pointer' }, onClick: this.acceptRejectFun.bind(this, sugPrmyId, 'reject') },
								'Reject'
							)
						)
					);
				}
			}
		}, {
			key: 'acceptRejectFun',
			value: function acceptRejectFun(sugPrmyId, Actiontxt) {
				var _this3 = this;
	
				document.getElementById("resvloadIcon").style.display = "block";
	
				if (typeof sugPrmyId !== 'undefined' && sugPrmyId !== "" && Actiontxt === "accept") {
					var qs = __webpack_require__(3);
					var postObject = {
						"app_id": APPID,
						"sug_reser_id": sugPrmyId
					};
					_axios2.default.post(APIURL + "reservation/reservation_suggest_accept", qs.stringify(postObject)).then(function (response) {
						document.getElementById("resvloadIcon").style.display = "none";
						/* Success response */
						if (response.data.status === "success") {
							var errorMsg = "<h2>Thank you</h2> Order has been placed successfully.";
							helper.showInfo(errorMsg);
							_this3.loadData();
						}
	
						/* error response */
						if (response.data.status === "error") {
							if (response.data.already_assigned === '1') {
								var errorMsg = "<h2>Sorry</h2> Your Reservation Already Expired.<br> You can make new reservation.";
							} else {
								var errorMsg = "<h2>Thank you</h2> Reservation has been Cancelled successfully.";
							}
	
							helper.showInfo(errorMsg);
							_this3.loadData();
						}
					});
				}if (typeof sugPrmyId !== 'undefined' && sugPrmyId !== "" && Actiontxt === "reject") {
					var qs = __webpack_require__(3);
					var postObject = {
						"app_id": APPID,
						"sug_reser_id": sugPrmyId
					};
					_axios2.default.post(APIURL + "reservation/reservation_suggest_reject", qs.stringify(postObject)).then(function (response) {
						document.getElementById("resvloadIcon").style.display = "none";
						/* Success response */
						if (response.data.status === "success") {
							var errorMsg = "<h2>Thank you</h2> Reservation has been Cancelled successfully.";
							helper.showInfo(errorMsg);
							_this3.loadData();
						}
	
						/* Error response */
						if (response.data.status === "error") {
							if (response.data.already_assigned === '1') {
								var errorMsg = "<h2>Sorry</h2> Your Reservation Already Expired.<br> You can make new reservation.";
							} else {
								var errorMsg = "";
							}
	
							helper.showInfo(errorMsg);
							_this3.loadData();
						}
					});
				}
			}
		}, {
			key: 'showdateFun',
			value: function showdateFun(datetimestr) {
				var datetimeArr = datetimestr.split(" ");
				var resulttxt = this.tmConvert(datetimeArr[1]);
				return resulttxt;
			}
		}, {
			key: 'tmConvert',
			value: function tmConvert(time) {
				time = time.substring(0, time.length - 3);
				time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
				if (time.length > 1) {
					time = time.slice(1);
					time[5] = +time[0] < 12 ? ' am' : ' pm';
					time[0] = +time[0] % 12 || 12;
				}
				return time.join('');
			}
		}, {
			key: 'loadCartImage',
			value: function loadCartImage() {
				return (0, _Api2.default)('cartImage', 'Yes');
			}
		}, {
			key: 'getstatusText',
			value: function getstatusText(status) {
				var statusTxt = 'Pending';
				if (status === '1') {
					statusTxt = 'Assigned';
				} else if (status === '2') {
					statusTxt = 'Cancel';
				} else if (status === '3') {
					statusTxt = 'Arrived';
				} else if (status === '4') {
					statusTxt = 'Not Arrived';
				} else if (status === '5') {
					statusTxt = 'Completed';
				}
				return statusTxt;
			}
		}, {
			key: 'getOrderStatusfun',
			value: function getOrderStatusfun(statustxt) {
				var pendingcls = 'completed';
				var completedcls = '';
	
				if (statustxt === '1' || statustxt === '2' || statustxt === '5') {
					completedcls = 'completed';
				}
	
				var statusText = 'Confirmed';
				if (statustxt === '2') {
					statusText = 'Canceled';
				}
	
				return _react2.default.createElement(
					'ul',
					null,
					_react2.default.createElement(
						'li',
						{ className: pendingcls },
						' ',
						_react2.default.createElement(
							'span',
							null,
							'1'
						),
						'  Pending'
					),
					_react2.default.createElement(
						'li',
						{ className: completedcls },
						' ',
						_react2.default.createElement(
							'span',
							null,
							'2'
						),
						'  ',
						statusText
					)
				);
			}
		}, {
			key: 'getStatusCls',
			value: function getStatusCls(status) {
				var clsName = '';
				if (status === '6') {
					clsName = 'text-yellow';
				}
				return clsName;
			}
		}, {
			key: 'getNoofPax',
			value: function getNoofPax(adult, child) {
				var adultchild = '';
				if (adult !== '' && adult !== '0') {
					var camatxt = child !== '' && child !== '0' ? ', ' : ' ';
					var Adultxt = parseInt(adult) > 1 ? adult + ' Adults' : adult + ' Adult';
					adultchild = Adultxt + camatxt;
				}
				if (child !== '' && child !== '0') {
					var childtxt = parseInt(child) > 1 ? child + ' Children' : child + ' Child';
					adultchild = adultchild + ' ' + childtxt;
				}
				return adultchild;
			}
	
			/* this function used to load reservation orders */
	
		}, {
			key: 'reservationOrder',
			value: function reservationOrder() {
				var _this4 = this;
	
				if (this.state.credit.length > 0) {
	
					return this.state.credit.map(function (cData, index) {
						return _react2.default.createElement(
							'div',
							{ className: 'reserve-orders-item order_list_reservation', key: index },
							_react2.default.createElement(
								'div',
								{ className: 'reserve-od-inner' },
								_react2.default.createElement(
									'div',
									{ className: 'reserve-order-title' },
									_react2.default.createElement(
										'div',
										{ className: 'title-odr-left' },
										cData.reservation_status === '6' ? _react2.default.createElement(
											'span',
											{ className: 'btn-suggest-ylw' },
											'Suggested'
										) : '',
										_react2.default.createElement(
											'h4',
											null,
											'Confirmation ID : ',
											_react2.default.createElement(
												'span',
												null,
												cData.reservation_local_order_id
											)
										)
									),
									_react2.default.createElement(
										'span',
										{ className: 'date-time' },
										_react2.default.createElement(
											_reactMoment2.default,
											{ format: 'DD/MM/YYYY' },
											cData.reservation_created_on
										),
										', ',
										_this4.showdateFun(cData.reservation_created_on)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										'div',
										{ className: 'left-column-odr' },
										_react2.default.createElement(
											'div',
											{ className: 'reserve-order-cnt' },
											_react2.default.createElement(
												'table',
												null,
												_react2.default.createElement(
													'tbody',
													null,
													_react2.default.createElement(
														'tr',
														null,
														_react2.default.createElement(
															'td',
															null,
															'No of Pax'
														),
														_react2.default.createElement(
															'td',
															null,
															':'
														),
														_react2.default.createElement(
															'td',
															null,
															_react2.default.createElement(
																'span',
																{ className: _this4.getStatusCls(cData.reservation_status) },
																_this4.getNoofPax(cData.reservation_no_of_adult_pax, cData.reservation_no_of_children_pax)
															)
														)
													),
													_react2.default.createElement(
														'tr',
														null,
														_react2.default.createElement(
															'td',
															null,
															'Location'
														),
														_react2.default.createElement(
															'td',
															null,
															':'
														),
														_react2.default.createElement(
															'td',
															null,
															_react2.default.createElement(
																'span',
																{ className: _this4.getStatusCls(cData.reservation_status) },
																cData.reservation_outlet_name,
																', ',
																cData.outlet_address_line1
															)
														)
													),
													_react2.default.createElement(
														'tr',
														null,
														_react2.default.createElement(
															'td',
															null,
															'Date'
														),
														_react2.default.createElement(
															'td',
															null,
															':'
														),
														_react2.default.createElement(
															'td',
															null,
															_react2.default.createElement(
																'span',
																{ className: _this4.getStatusCls(cData.reservation_status) },
																_this4.chgDatefrmt(cData.reservation_date),
																', ',
																_this4.tmConvert(cData.reservation_start_time)
															)
														)
													),
													_this4.getTblName(cData.table_name_txt, cData.reservation_status),
													_this4.getSpecification(cData.reservation_specification, cData.reservation_status)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'right-column-odr' },
										_this4.getActionBtn(cData.reservation_status, cData.sug_primary_id)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'ols-product-status' },
								_this4.getOrderStatusfun(cData.reservation_status)
							)
						);
					});
				} else {
					return _react2.default.createElement(
						'div',
						{ className: 'order_list_rewards' },
						' No records found. '
					);
				}
			}
	
			/* this function used to load reservation orders */
	
		}, {
			key: 'completedReservationOrder',
			value: function completedReservationOrder() {
				var _this5 = this;
	
				if (this.state.debit.length > 0) {
	
					return this.state.debit.map(function (dData, index) {
						return _react2.default.createElement(
							'div',
							{ className: 'reserve-orders-item order_list_reservation', key: index },
							_react2.default.createElement(
								'div',
								{ className: 'reserve-od-inner' },
								_react2.default.createElement(
									'div',
									{ className: 'reserve-order-title' },
									_react2.default.createElement(
										'div',
										{ className: 'title-odr-left' },
										dData.reservation_status === '6' ? _react2.default.createElement(
											'span',
											{ className: 'btn-suggest-ylw' },
											'Suggested'
										) : '',
										_react2.default.createElement(
											'h4',
											null,
											'Confirmation ID : ',
											_react2.default.createElement(
												'span',
												null,
												dData.reservation_local_order_id
											)
										)
									),
									_react2.default.createElement(
										'span',
										{ className: 'date-time' },
										_react2.default.createElement(
											_reactMoment2.default,
											{ format: 'DD/MM/YYYY' },
											dData.reservation_created_on
										),
										', ',
										_this5.showdateFun(dData.reservation_created_on)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										'div',
										{ className: 'left-column-odr' },
										_react2.default.createElement(
											'div',
											{ className: 'reserve-order-cnt' },
											_react2.default.createElement(
												'table',
												null,
												_react2.default.createElement(
													'tbody',
													null,
													_react2.default.createElement(
														'tr',
														null,
														_react2.default.createElement(
															'td',
															null,
															'No of Pax'
														),
														_react2.default.createElement(
															'td',
															null,
															':'
														),
														_react2.default.createElement(
															'td',
															null,
															_react2.default.createElement(
																'span',
																{ className: _this5.getStatusCls(dData.reservation_status) },
																_this5.getNoofPax(dData.reservation_no_of_adult_pax, dData.reservation_no_of_children_pax)
															)
														)
													),
													_react2.default.createElement(
														'tr',
														null,
														_react2.default.createElement(
															'td',
															null,
															'Location'
														),
														_react2.default.createElement(
															'td',
															null,
															':'
														),
														_react2.default.createElement(
															'td',
															null,
															_react2.default.createElement(
																'span',
																{ className: _this5.getStatusCls(dData.reservation_status) },
																dData.reservation_outlet_name,
																', ',
																dData.outlet_address_line1
															)
														)
													),
													_react2.default.createElement(
														'tr',
														null,
														_react2.default.createElement(
															'td',
															null,
															'Date'
														),
														_react2.default.createElement(
															'td',
															null,
															':'
														),
														_react2.default.createElement(
															'td',
															null,
															_react2.default.createElement(
																'span',
																{ className: _this5.getStatusCls(dData.reservation_status) },
																_this5.chgDatefrmt(dData.reservation_date),
																', ',
																_this5.tmConvert(dData.reservation_start_time)
															)
														)
													),
													_this5.getTblName(dData.table_name_txt, dData.reservation_status),
													_this5.getSpecification(dData.reservation_specification, dData.reservation_status)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'right-column-odr' },
										_this5.getActionBtn(dData.reservation_status, dData.sug_primary_id)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'ols-product-status' },
								_this5.getOrderStatusfun(dData.reservation_status)
							)
						);
					});
				} else {
					return _react2.default.createElement(
						'div',
						{ className: 'order_list_rewards' },
						' No records found. '
					);
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				(0, _withTracker.loadAnalytics)();
	
				var promise = (0, _Api2.default)("settingsPro", "No");
				promise.then(function (res) {
					if (!helper.disableMenu(res.data.result_set, "myaccount_reservation")) {
						_reactRouter.hashHistory.push("/");
						return false;
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
	
				if (this.state.status === "Loading") {
	
					return _react2.default.createElement(
						'div',
						{ className: 'container-fluid desktop-container', style: { minHeight: this.state.windowHeightNormal } },
						_react2.default.createElement('div', { className: 'row' }),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement('div', { className: 'space-10 bg-gray' })
						),
						_react2.default.createElement(
							'div',
							{ className: ' ' },
							_react2.default.createElement(
								'div',
								{ className: 'col-xs-10 div-center' },
								_react2.default.createElement('div', { className: 'space-5' }),
								_react2.default.createElement(Loading, null),
								_react2.default.createElement('div', { className: 'space-5' })
							),
							_react2.default.createElement('div', { className: 'clearfix' })
						),
						_react2.default.createElement('div', { className: 'space-30' }),
						_react2.default.createElement('div', { className: 'space-30' }),
						_react2.default.createElement('div', { className: 'space-30' }),
						_react2.default.createElement('div', { className: 'space-30' }),
						_react2.default.createElement('div', { className: 'space-30' }),
						_react2.default.createElement('div', { className: 'space-5' }),
						_react2.default.createElement('div', { className: 'space-5' }),
						_react2.default.createElement('div', { className: 'space-30' }),
						' ',
						_react2.default.createElement('div', { className: 'space-30' }),
						' ',
						_react2.default.createElement('div', { className: 'space-30' }),
						' ',
						_react2.default.createElement('div', { className: 'space-30' })
					);
				} else {
	
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_reactDocumentMeta2.default, meta),
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid desktop-container' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 top-nav inner-top-nav head-main' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-3 nav-head pd-l-20  head-child' },
										' ',
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: "/my-account" },
											_react2.default.createElement('img', { src: '/img/icons/arrow-right.png', alt: 'left-arrow', className: 'icon-img-small-3' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-6 nav-head   head-child' },
										_react2.default.createElement(
											'h1',
											{ className: 'main-title' },
											'Reservations'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-3 nopadding   head-child' },
										_react2.default.createElement(
											'p',
											{ className: 'b-txt text-right ' },
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: "/cart", className: helper.cartClass() },
												helper.cartCount(),
												'   ',
												_react2.default.createElement('img', { alt: '', src: this.loadCartImage(), className: 'icon-img-small-1' }),
												' '
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'reserve-orders-tab' },
								_react2.default.createElement(
									'div',
									{ className: 'tabbable-panel' },
									_react2.default.createElement(
										'div',
										{ className: 'tabbable-line' },
										_react2.default.createElement(
											'div',
											{ id: 'resvloadIcon', style: { display: 'none', bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto', zIndex: 99, background: 'rgba(255, 255, 255, 0.8)' } },
											' ',
											_react2.default.createElement('img', { style: { bottom: 0, left: 0, position: 'absolute', right: 0, top: 0, margin: 'auto' }, src: '/img/loader.gif', alt: 'Loading' }),
											' '
										),
										_react2.default.createElement(
											'ul',
											{ className: 'nav nav-tabs ' },
											_react2.default.createElement(
												'li',
												{ className: 'active' },
												_react2.default.createElement(
													'a',
													{ href: '#tab_default_1', 'data-toggle': 'tab' },
													'Current Orders '
												)
											),
											_react2.default.createElement(
												'li',
												null,
												_react2.default.createElement(
													'a',
													{ href: '#tab_default_2', 'data-toggle': 'tab' },
													'PAST Orders '
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'tab-content' },
											_react2.default.createElement(
												'div',
												{ className: 'tab-pane fade in active', id: 'tab_default_1' },
												_react2.default.createElement(
													'div',
													{ className: 'pagination-rewards' },
													_react2.default.createElement(
														'span',
														{ className: 'show_pgn' },
														'Show'
													),
													_react2.default.createElement(
														'div',
														{ className: 'pagination_number' },
														_react2.default.createElement(
															'select',
															{ value: this.state.creditLimit, onChange: this.handleChange.bind(this) },
															' ',
															_react2.default.createElement(
																'option',
																{ value: '5' },
																' 5'
															),
															' ',
															_react2.default.createElement(
																'option',
																{ value: '10' },
																' 10 '
															),
															' ',
															_react2.default.createElement(
																'option',
																{ value: '25' },
																' 25 '
															),
															'  ',
															_react2.default.createElement(
																'option',
																{ value: '50' },
																' 50 '
															),
															' '
														)
													),
													_react2.default.createElement(
														'span',
														null,
														'Per Page'
													)
												),
												this.reservationOrder()
											),
											_react2.default.createElement(
												'div',
												{ className: 'tab-pane fade', id: 'tab_default_2' },
												_react2.default.createElement(
													'div',
													{ className: 'pagination-rewards' },
													_react2.default.createElement(
														'span',
														{ className: 'show_pgn' },
														'Show'
													),
													_react2.default.createElement(
														'div',
														{ className: 'pagination_number' },
														_react2.default.createElement(
															'select',
															{ value: this.state.debitLimitLimit, onChange: this.handleChangeRedeem.bind(this) },
															' ',
															_react2.default.createElement(
																'option',
																{ value: '5' },
																' 5 '
															),
															' ',
															_react2.default.createElement(
																'option',
																{ value: '10' },
																' 10 '
															),
															' ',
															_react2.default.createElement(
																'option',
																{ value: '25' },
																' 25 '
															),
															'  ',
															_react2.default.createElement(
																'option',
																{ value: '50' },
																' 50 '
															),
															' '
														)
													),
													_react2.default.createElement(
														'span',
														null,
														'Per Page'
													)
												),
												this.completedReservationOrder()
											)
										)
									)
								)
							)
						)
					);
				}
			}
		}]);
	
		return Reservation;
	}(_react2.default.Component);
	
	exports.default = Reservation;

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(9);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var Loading = __webpack_require__(17);
	var config = __webpack_require__(7);
	var lang = __webpack_require__(12);
	var APIURL = config.path.apiUrl;
	var APPID = config.ids.appId;
	
	var helper = __webpack_require__(13);
	
	/* Load meta tags */
	var meta = {
		title: lang.activation_meta_title,
		description: lang.activation_meta_title,
		meta: {
			name: {
				keywords: lang.activation_meta_title
			}
		}
	};
	
	var ReservationActivation = function (_React$Component) {
		_inherits(ReservationActivation, _React$Component);
	
		function ReservationActivation() {
			_classCallCheck(this, ReservationActivation);
	
			return _possibleConstructorReturn(this, (ReservationActivation.__proto__ || Object.getPrototypeOf(ReservationActivation)).apply(this, arguments));
		}
	
		_createClass(ReservationActivation, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
	
				/* add class */
				helper.addBodyClass();
			}
	
			/* Account activation */
	
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				(0, _withTracker.loadAnalytics)();
				var qs = __webpack_require__(3);
				var activationType = this.props.params.type;
				var activationId = this.props.params.keyval;
				activationId = atob(activationId);
	
				/* for account activation - start */
				if (typeof activationId !== 'undefined' && activationId !== "" && activationType === "accept") {
					// return false;
					var postObject = {
						"app_id": APPID,
						"sug_reser_id": activationId
					};
					_axios2.default.post(APIURL + "reservation/reservation_suggest_accept", qs.stringify(postObject)).then(function (response) {
	
						/* Success response */
						if (response.data.status === "success") {
							var errorMsg = "<h2>Thank you</h2> Order has been placed successfully.";
							helper.showInfo(errorMsg);
							_reactRouter.hashHistory.push("/");
						}
	
						/* Success response */
						if (response.data.status === "error") {
							if (response.data.already_assigned === '1') {
								var errorMsg = "<h2>Sorry</h2> Your Reservation Already Expired.<br> You can make new reservation.";
							} else {
								var errorMsg = "<h2>Thank you</h2> Reservation has been Cancelled successfully.";
							}
	
							helper.showInfo(errorMsg);
							_reactRouter.hashHistory.push("/");
						}
						/* error reponse */
					});
				}
				/* for account activation - end  */
	
				/* for account activation - start */
				if (typeof activationId !== 'undefined' && activationId !== "" && activationType === "reject") {
					// return false;
					var postObject = {
						"app_id": APPID,
						"sug_reser_id": activationId
					};
					_axios2.default.post(APIURL + "reservation/reservation_suggest_reject", qs.stringify(postObject)).then(function (response) {
	
						/* Success response */
						if (response.data.status === "success") {
							var errorMsg = "<h2>Thank you</h2> Reservation has been Cancelled successfully.";
							helper.showInfo(errorMsg);
							_reactRouter.hashHistory.push("/");
						}
	
						/* Success response */
						if (response.data.status === "error") {
							if (response.data.already_assigned === '1') {
								var errorMsg = "<h2>Sorry</h2> Your Reservation Already Expired.<br> You can make new reservation.";
							} else {
								var errorMsg = "";
							}
	
							helper.showInfo(errorMsg);
							_reactRouter.hashHistory.push("/");
						}
						/* error reponse */
					});
				}
				/* for account activation - end  */
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_reactDocumentMeta2.default, meta),
					_react2.default.createElement(
						'div',
						{ className: 'chk_popup act_loder', id: 'PayProcess', style: { position: 'unset' } },
						_react2.default.createElement(
							'div',
							{ className: 'white-outer center-block process_order' },
							_react2.default.createElement(
								'div',
								{ className: 'row ' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 padd2' },
									_react2.default.createElement(
										'h4',
										null,
										lang.activation_meta_title
									),
									_react2.default.createElement(
										'div',
										{ className: 'clock_part' },
										_react2.default.createElement('img', { src: '/img/spinner.gif', alt: '' }),
										_react2.default.createElement('br', null)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return ReservationActivation;
	}(_react2.default.Component);
	
	exports.default = ReservationActivation;

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _withTracker = __webpack_require__(11);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _reactRouter = __webpack_require__(9);
	
	var _reactRouterTransition = __webpack_require__(439);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var config = __webpack_require__(7);
	var lang = __webpack_require__(12);
	var APIURL = config.path.apiUrl;
	var APPID = config.ids.appId;
	
	var Loading = __webpack_require__(17);
	var qs = __webpack_require__(3);
	var HtmlToReactParser = __webpack_require__(21).Parser;
	var htmlToReactParserTo = new HtmlToReactParser();
	
	var helper = __webpack_require__(13);
	/* Load meta tags */
	var meta = {
	  title: lang.reservation + lang.site_title_with_separator,
	  description: lang.reservation,
	  meta: {
	    name: {
	      keywords: lang.reservation
	    }
	  }
	};
	var deletevar = "No";
	var monthNamesArr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	
	var dayNamesArr = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
	
	var Reservationaccept = function (_React$Component) {
	  _inherits(Reservationaccept, _React$Component);
	
	  function Reservationaccept(props) {
	    _classCallCheck(this, Reservationaccept);
	
	    /*add class */
	    helper.addBodyClass();
	
	    var _this = _possibleConstructorReturn(this, (Reservationaccept.__proto__ || Object.getPrototypeOf(Reservationaccept)).call(this, props));
	
	    console.log("props", _this.props);
	    var reservationID = _this.props.params.reservationID !== "" && _typeof(_this.props.params.reservationID) !== undefined && _this.props.params.reservationID !== "undefined" && _this.props.params.reservationID !== undefined ? _this.props.params.reservationID : "";
	    var acceptType = "";
	    if (_this.props.route.path !== "" && _typeof(_this.props.route.path) !== undefined && _this.props.route.path !== "undefined" && _this.props.route.path !== undefined) {
	      if (_this.props.route.path == "/reservation_suggest/reject/:reservationID") {
	        acceptType = "reject";
	      } else {
	        acceptType = "accept";
	      }
	    }
	    /* Declare state */
	    _this.state = {
	      windowHeightNormal: 0,
	      windowHeight: 0,
	      status: "Loading",
	      settings: [],
	      resstatus: 0,
	      acceptType: acceptType,
	      reservationID: reservationID
	    };
	
	    _this.acceptSuggest();
	
	    /* API CALL FOR PRODUCT MENU NAVIGATION */
	    var promise = (0, _Api2.default)("settingsPro", "No");
	    promise.then(function (res) {
	      _this.setState({ settings: res.data.result_set });
	    });
	    return _this;
	  }
	
	  _createClass(Reservationaccept, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var windowHeight = window.innerHeight;
	      this.setState({ windowHeight: windowHeight - 45 + "px" });
	      this.setState({ windowHeightNormal: windowHeight + "px" });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _withTracker.loadAnalytics)();
	    }
	  }, {
	    key: "acceptSuggest",
	    value: function acceptSuggest() {
	      var _this2 = this;
	
	      if (this.state.reservationID !== "") {
	        var reservation_ID = this.encodedecode(this.state.reservationID, "decode");
	
	        var qs = __webpack_require__(3);
	        var postObject = {
	          app_id: APPID,
	          sug_reser_id: reservation_ID
	        };
	        var urlsucc = "";
	        if (this.state.acceptType == "accept") {
	          urlsucc = "reservation_suggest_accept";
	        } else {
	          urlsucc = "reservation_suggest_reject";
	        }
	        _axios2.default.post(APIURL + "reservation/" + urlsucc, qs.stringify(postObject)).then(function (response) {
	          _this2.setState({ status: "" });
	          console.log("response", response.data);
	
	          if (response.data.status === "success") {
	            var result = response.data.result_set[0];
	            var ResPeopleTxt = result.reservation_no_of_adult_pax;
	            var reservation_date = result.reservation_date;
	            var dateSplit = reservation_date.split(" ");
	            var dateSplit1 = dateSplit[0].split("-");
	            var selYear = dateSplit1[0];
	            var selMonthcal1 = dateSplit1[1];
	            var selDate = dateSplit1[2];
	            var calMnt = parseInt(selMonthcal1) - 1;
	            var selMonthcal = _this2.pad(calMnt);
	            var caldatesplt = new Date(selYear, selMonthcal, selDate);
	            console.log("caldatesplt", caldatesplt);
	            var calRsResDatepkidVal = ("0" + caldatesplt.getDate()).slice(-2) + " " + monthNamesArr[caldatesplt.getMonth()] + " " + caldatesplt.getFullYear();
	            var calRsResDayText = dayNamesArr[caldatesplt.getDay()];
	            _this2.setState({ ResselectedDateTxt: calRsResDatepkidVal });
	            _this2.setState({ ResselectedDayTxt: calRsResDayText });
	
	            var reservation_start_time = result.reservation_start_time;
	            var splitTime = reservation_start_time.split(":");
	            var resTimeText = splitTime[0] + ":" + splitTime[1];
	            if (splitTime[0] >= 12) {
	              resTimeText += " PM";
	            } else {
	              resTimeText += " AM";
	            }
	            _this2.setState({ resTimeText: resTimeText });
	
	            if (result.reservation_no_of_adult_pax > 1) {
	              ResPeopleTxt += " Adults";
	            } else {
	              ResPeopleTxt += " Adult";
	            }
	
	            if (result.reservation_no_of_children_pax !== "" && result.reservation_no_of_children_pax > 0) {
	              ResPeopleTxt += " " + result.reservation_no_of_children_pax;
	              if (result.reservation_no_of_adult_pax > 1) {
	                ResPeopleTxt += " Children";
	              } else {
	                ResPeopleTxt += " Child";
	              }
	            }
	            _this2.setState({
	              selectResOutletOptionTxt: response.data.outlet_name,
	              selectResOutletAdrr: response.data.outlet_address,
	              resOrderId: result.reservation_local_order_id,
	              ResPeopleTxt: ResPeopleTxt,
	              resstatus: 1
	            });
	          } else {
	            _this2.setState({
	              selectResOutletOptionTxt: response.data.outlet_name,
	              selectResOutletAdrr: response.data.outlet_address,
	              resstatus: 2
	            });
	          }
	          $("#ReservationMdl").modal("show");
	        }).catch(function (error) {
	          console.log(error);
	        });
	      }
	    }
	  }, {
	    key: "pad",
	    value: function pad(d) {
	      return d < 10 ? "0" + d.toString() : d.toString();
	    }
	  }, {
	    key: "encodedecode",
	    value: function encodedecode(string, type) {
	      if (string !== "") {
	        var Base64 = {
	          // private property
	          _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
	
	          // public method for encoding
	          encode: function encode(input) {
	            var output = "";
	            var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
	            var i = 0;
	
	            input = Base64._utf8_encode(input);
	
	            while (i < input.length) {
	              chr1 = input.charCodeAt(i++);
	              chr2 = input.charCodeAt(i++);
	              chr3 = input.charCodeAt(i++);
	
	              enc1 = chr1 >> 2;
	              enc2 = (chr1 & 3) << 4 | chr2 >> 4;
	              enc3 = (chr2 & 15) << 2 | chr3 >> 6;
	              enc4 = chr3 & 63;
	
	              if (isNaN(chr2)) {
	                enc3 = enc4 = 64;
	              } else if (isNaN(chr3)) {
	                enc4 = 64;
	              }
	
	              output = output + this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) + this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
	            }
	
	            return output;
	          },
	
	          // public method for decoding
	          decode: function decode(input) {
	            var output = "";
	            var chr1, chr2, chr3;
	            var enc1, enc2, enc3, enc4;
	            var i = 0;
	
	            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
	
	            while (i < input.length) {
	              enc1 = this._keyStr.indexOf(input.charAt(i++));
	              enc2 = this._keyStr.indexOf(input.charAt(i++));
	              enc3 = this._keyStr.indexOf(input.charAt(i++));
	              enc4 = this._keyStr.indexOf(input.charAt(i++));
	
	              chr1 = enc1 << 2 | enc2 >> 4;
	              chr2 = (enc2 & 15) << 4 | enc3 >> 2;
	              chr3 = (enc3 & 3) << 6 | enc4;
	
	              output = output + String.fromCharCode(chr1);
	
	              if (enc3 != 64) {
	                output = output + String.fromCharCode(chr2);
	              }
	              if (enc4 != 64) {
	                output = output + String.fromCharCode(chr3);
	              }
	            }
	
	            output = Base64._utf8_decode(output);
	
	            return output;
	          },
	
	          // private method for UTF-8 encoding
	          _utf8_encode: function _utf8_encode(string) {
	            string = string.replace(/\r\n/g, "\n");
	            var utftext = "";
	
	            for (var n = 0; n < string.length; n++) {
	              var c = string.charCodeAt(n);
	
	              if (c < 128) {
	                utftext += String.fromCharCode(c);
	              } else if (c > 127 && c < 2048) {
	                utftext += String.fromCharCode(c >> 6 | 192);
	                utftext += String.fromCharCode(c & 63 | 128);
	              } else {
	                utftext += String.fromCharCode(c >> 12 | 224);
	                utftext += String.fromCharCode(c >> 6 & 63 | 128);
	                utftext += String.fromCharCode(c & 63 | 128);
	              }
	            }
	
	            return utftext;
	          },
	
	          // private method for UTF-8 decoding
	          _utf8_decode: function _utf8_decode(utftext) {
	            var string = "";
	            var i = 0;
	            var c1, c2, c3;
	            var c = c1 = c2 = 0;
	
	            while (i < utftext.length) {
	              c = utftext.charCodeAt(i);
	
	              if (c < 128) {
	                string += String.fromCharCode(c);
	                i++;
	              } else if (c > 191 && c < 224) {
	                c2 = utftext.charCodeAt(i + 1);
	                string += String.fromCharCode((c & 31) << 6 | c2 & 63);
	                i += 2;
	              } else {
	                c2 = utftext.charCodeAt(i + 1);
	                c3 = utftext.charCodeAt(i + 2);
	                string += String.fromCharCode((c & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
	                i += 3;
	              }
	            }
	
	            return string;
	          }
	        };
	        if (type === "encode") {
	          return Base64.encode(string);
	        } else if (type === "decode") {
	          return Base64.decode(string);
	        }
	      }
	    }
	  }, {
	    key: "closeResvPoup",
	    value: function closeResvPoup() {
	      $("body").removeClass("reservationPopup");
	      $("#ReservationMdl").modal("hide");
	      _reactRouter.hashHistory.push("/");
	    }
	  }, {
	    key: "gotoMyAcct",
	    value: function gotoMyAcct() {
	      $("body").removeClass("reservationPopup");
	      $("#ReservationMdl").modal("hide");
	      if (this.state.acceptType == "accept") {
	        _reactRouter.hashHistory.push("/my-account");
	      } else {
	        if (typeof _reactCookie2.default.load("UserId") === "undefined" || _reactCookie2.default.load("UserId") && _reactCookie2.default.load("UserId") === "") {
	          _reactRouter.hashHistory.push("/sign-in");
	        } else {
	          _reactCookie2.default.save("open_reservation", 1);
	          _reactRouter.hashHistory.push("/");
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this.state.status === "Loading") {
	        return _react2.default.createElement(
	          "div",
	          {
	            className: "container-fluid desktop-container position-rel",
	            style: { minHeight: this.state.windowHeightNormal }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(Loading, null)
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_reactDocumentMeta2.default, meta),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "container-fluid desktop-container",
	              style: { minHeight: this.state.windowHeight }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-xs-12 top-nav inner-top-nav head-main" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-xs-3 nav-head pd-l-20 head-child" },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: "/" },
	                    _react2.default.createElement("img", {
	                      src: "/img/icons/arrow-right.png",
	                      className: "icon-img-small-3",
	                      alt: "left-arrow"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-xs-6 nav-head  head-child" },
	                  _react2.default.createElement(
	                    "h1",
	                    { className: "main-title" },
	                    "Reservation"
	                  )
	                ),
	                _react2.default.createElement("div", { className: "col-xs-3 nopadding  head-child" })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: "/" },
	                _react2.default.createElement(
	                  "button",
	                  { className: "col-lg-12 continue-but desktop-container main-title container-fluid" },
	                  "BACK"
	                )
	              ),
	              " "
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "modal fade reservationmdlCls", id: "ReservationMdl" },
	            _react2.default.createElement(
	              "div",
	              { className: "modal-dialog PopupWidth" },
	              _react2.default.createElement(
	                "div",
	                { className: "modal-content" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "modal-body" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "reservation-wrap-ija" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "reserve-head" },
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          className: "close",
	                          "data-dismiss": "modal",
	                          "aria-hidden": "true",
	                          onClick: this.closeResvPoup.bind(this)
	                        },
	                        _react2.default.createElement("img", {
	                          src: "/img/icons/close_popup.png",
	                          className: "img-responsive",
	                          alt: ""
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "h4",
	                        null,
	                        "Reservation"
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        null,
	                        this.state.selectResOutletOptionTxt,
	                        " -",
	                        " ",
	                        this.state.selectResOutletAdrr
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "reserve-items-box" },
	                      _react2.default.createElement(
	                        "form",
	                        { id: "wizard-1", noValidate: "novalidate" },
	                        _react2.default.createElement(
	                          "div",
	                          { id: "bootstrap-wizard-1", className: "col-sm-12" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "tab-content" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "tab-pane active", id: "tab3" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "confirmation-bx" },
	                                this.state.resstatus === 1 && this.state.acceptType == "accept" && _react2.default.createElement(
	                                  "div",
	                                  null,
	                                  _react2.default.createElement("img", { src: "img/success.png" }),
	                                  _react2.default.createElement(
	                                    "h4",
	                                    null,
	                                    "Thank You"
	                                  ),
	                                  _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    "Your Reservation has been confirmed"
	                                  )
	                                ),
	                                this.state.resstatus === 2 && _react2.default.createElement(
	                                  "div",
	                                  null,
	                                  _react2.default.createElement("img", { src: "img/worried.png" }),
	                                  _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    "Your Reservation already confirmed/rejected"
	                                  )
	                                ),
	                                this.state.resstatus === 1 && this.state.acceptType == "reject" && _react2.default.createElement(
	                                  "div",
	                                  null,
	                                  _react2.default.createElement("img", { src: "img/worried.png" }),
	                                  _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    "Reservation Cancelled"
	                                  )
	                                )
	                              ),
	                              this.state.resstatus === 1 && this.state.acceptType == "accept" && _react2.default.createElement(
	                                "div",
	                                { className: "cnfm-id-section" },
	                                _react2.default.createElement(
	                                  "h5",
	                                  null,
	                                  "Confirmation ID :",
	                                  " ",
	                                  _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    this.state.resOrderId
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  "p",
	                                  null,
	                                  _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    this.state.ResPeopleTxt
	                                  ),
	                                  " at",
	                                  " ",
	                                  _react2.default.createElement("br", null),
	                                  _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    this.state.settings.company_name,
	                                    " -",
	                                    " ",
	                                    this.state.selectResOutletOptionTxt
	                                  ),
	                                  " ",
	                                  "on ",
	                                  _react2.default.createElement("br", null),
	                                  _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    this.state.ResselectedDateTxt,
	                                    ",",
	                                    " ",
	                                    this.state.ResselectedDayTxt,
	                                    ",",
	                                    " ",
	                                    this.state.resTimeText
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "text-center" },
	                                _react2.default.createElement(
	                                  "a",
	                                  {
	                                    className: "btn-send-t bg-bck-color",
	                                    href: "javascript:;",
	                                    onClick: this.gotoMyAcct.bind(this)
	                                  },
	                                  this.state.acceptType == "reject" && _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    "Create New Reservation Request"
	                                  ),
	                                  this.state.acceptType == "accept" && _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    "Go To My Account"
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement("div", { className: "modal-footer" })
	              )
	            )
	          )
	        );
	      }
	    }
	  }]);
	
	  return Reservationaccept;
	}(_react2.default.Component);
	
	exports.default = Reservationaccept;

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(9);
	
	var _immutabilityHelper = __webpack_require__(56);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _reactCustomValidation = __webpack_require__(57);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var lang = __webpack_require__(12);
	
	var config = __webpack_require__(7);
	var APIURL = config.path.apiUrl;
	var APPID = config.ids.appId;
	
	var helper = __webpack_require__(13);
	helper.addBodyClass();
	/* Load meta tags */
	var meta = {
	  title: lang.reset_meta_title,
	  description: lang.reset_meta_title,
	  meta: {
	    name: {
	      keywords: lang.reset_meta_title
	    }
	  }
	};
	
	var initialState = {
	  fields: {
	    password: '',
	    rePassword: '',
	    activationId: ''
	  }
	};
	
	var Resetpassword = function (_React$Component) {
	  _inherits(Resetpassword, _React$Component);
	
	  function Resetpassword() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Resetpassword);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Resetpassword.__proto__ || Object.getPrototypeOf(Resetpassword)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fields: {
	        password: '',
	        rePassword: ''
	      }
	    }, _this.fieldChange = function (field, value) {
	      _this.setState((0, _immutabilityHelper2.default)(_this.state, { fields: _defineProperty({}, field, { $set: value }) }));
	    }, _this.handleFormSubmit = function () {
	
	      var formPayload = _this.state.fields;
	      var qs = __webpack_require__(3);
	      var postObject = {
	        "app_id": APPID,
	        "type": "web",
	        'key': _this.state.activationId,
	        "password": formPayload.password,
	        "confirmpassword": formPayload.rePassword
	      };
	      document.getElementById("loadIcon").style.display = "block";
	      _axios2.default.post(APIURL + "customer/resetpassword", qs.stringify(postObject)).then(function (response) {
	        if (response.data.status === "ok") {
	          // cookie.save('alertSuccess',response.data.message);
	          helper.showInfo('Password has been updated successfully.');
	          _reactRouter.hashHistory.push("/sign-in");
	          //  $("#Reset-Success").modal("toggle");
	          return false;
	        } else if (response.data.status === "error") {
	          //cookie.save('alertError',response.data.message);
	          helper.showInfo('The verification link has been expired.');
	          _reactRouter.hashHistory.push("/sign-in");
	          //$("#Reset-Error").modal("toggle");
	          return false;
	        }
	        document.getElementById("loadIcon").style.display = "none";
	        return false;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Resetpassword, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      (0, _withTracker.loadAnalytics)();
	      var qs = __webpack_require__(3);
	      var activationId = this.props.params.resetId;
	      this.setState({ activationId: activationId });
	
	      /* for account activation - start */
	      if (typeof activationId === 'undefined' || activationId === "") {
	        helper.showInfo(lang.reset_key_invalid);
	        _reactRouter.hashHistory.push("/sign-in");
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(Form, {
	        fields: this.state.fields,
	        onChange: this.fieldChange,
	        onValid: this.handleFormSubmit,
	        onInvalid: function onInvalid() {
	          return console.log('Form invalid!');
	        }
	      });
	    }
	  }]);
	
	  return Resetpassword;
	}(_react2.default.Component);
	
	var isEmpty = function isEmpty(value) {
	  return value === '' ? 'This field is required.' : null;
	};
	
	var minLength = function minLength(password, length) {
	  return password.length >= length ? null : 'Password is too short.';
	};
	
	var areSame = function areSame(password, rePassword) {
	  return password === rePassword ? null : 'Passwords do not match.';
	};
	
	function validationConfig(props) {
	  var _props$fields = props.fields,
	      password = _props$fields.password,
	      rePassword = _props$fields.rePassword;
	
	
	  return {
	    fields: ['password', 'rePassword'],
	
	    validations: {
	      password: [[isEmpty, password], [minLength, password, 6]],
	      rePassword: {
	        rules: [[isEmpty, rePassword], [areSame, password, rePassword]],
	        fields: ['password', 'rePassword']
	      }
	    }
	  };
	}
	
	var Form = function (_React$Component2) {
	  _inherits(Form, _React$Component2);
	
	  function Form() {
	    _classCallCheck(this, Form);
	
	    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
	  }
	
	  _createClass(Form, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          fields = _props.fields,
	          onChange = _props.onChange,
	          onValid = _props.onValid,
	          onInvalid = _props.onInvalid,
	          $field = _props.$field,
	          $validation = _props.$validation;
	
	      var errPassword = void 0,
	          errConfirmPassword = void 0;
	      if ($validation.password.error.reason !== undefined) {
	        errPassword = $validation.password.show && _react2.default.createElement(
	          'span',
	          { className: 'spn-error' },
	          $validation.password.error.reason
	        );
	      }
	
	      if ($validation.rePassword.error.reason !== undefined) {
	        errConfirmPassword = $validation.rePassword.show && _react2.default.createElement(
	          'span',
	          { className: 'spn-error' },
	          $validation.rePassword.error.reason
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'container-fluid desktop-container' },
	        _react2.default.createElement(_reactDocumentMeta2.default, meta),
	        _react2.default.createElement(
	          'div',
	          { id: 'loadIcon', style: { display: 'none', bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto', zIndex: 99, background: 'rgba(255, 255, 255, 0.8)' } },
	          ' ',
	          _react2.default.createElement('img', { style: { bottom: 0, left: 0, position: 'absolute', right: 0, top: 0, margin: 'auto' }, src: '/img/loader.gif', alt: 'Loading' }),
	          ' '
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 main-title-bar' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: "/sign-in" },
	              ' ',
	              _react2.default.createElement('img', { src: '/img/left-arrow.png', className: 'pull-left icon-img-small', alt: 'left-arrow' }),
	              ' '
	            ),
	            _react2.default.createElement(
	              'h3',
	              { className: 'top-title main-title padding-right-20 text-uppercase' },
	              'reset password'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement('div', { className: 'space-10 bg-gray' })
	        ),
	        _react2.default.createElement('div', { className: 'white-outer center-block', id: 'form-success' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'white-outer center-block', id: 'resetpassword-form' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-10 div-center' },
	            _react2.default.createElement('div', { className: 'space-20' }),
	            _react2.default.createElement(
	              'p',
	              { className: 'text-center font-bold font-size-18' },
	              'Enter Your new password'
	            ),
	            _react2.default.createElement('div', { className: 'space-5' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group label-floating is-empty card-no' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'control-label' },
	                  'Password'
	                ),
	                _react2.default.createElement('input', Object.assign({ type: 'password', className: 'form-control', value: fields.password }, $field('password', function (e) {
	                  return onChange('password', e.target.value);
	                }))),
	                errPassword
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group label-floating is-empty card-no' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'control-label' },
	                  'Re Enter Password'
	                ),
	                _react2.default.createElement('input', Object.assign({ type: 'password', className: 'form-control', value: fields.rePassword }, $field('rePassword', function (e) {
	                  return onChange('rePassword', e.target.value);
	                }))),
	                errConfirmPassword
	              )
	            ),
	            _react2.default.createElement('div', { className: 'space-20', id: 'form-msg' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center ' },
	              _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'btn btn-raised btn-info full-width-btn text-uppercase', onClick: function onClick(e) {
	                    e.preventDefault();_this3.props.$submit(onValid, onInvalid);
	                  } },
	                'Reset',
	                _react2.default.createElement('div', { className: 'ripple-container' })
	              ),
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement('div', { className: 'space-20' })
	          ),
	          _react2.default.createElement('div', { className: 'clearfix' })
	        ),
	        _react2.default.createElement('div', { className: 'space-30' }),
	        _react2.default.createElement('div', { className: 'space-30' }),
	        _react2.default.createElement('div', { className: 'space-10' })
	      );
	    }
	  }]);
	
	  return Form;
	}(_react2.default.Component);
	
	Form = (0, _reactCustomValidation.validated)(validationConfig)(Form);
	
	exports.default = Resetpassword;

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(9);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactMoment = __webpack_require__(99);
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var config = __webpack_require__(7);
	var lang = __webpack_require__(12);
	var Loading = __webpack_require__(17);
	var APIURL = config.path.apiUrl;
	var APIURLPRO = config.path.apiUrlPro;
	var APPID = config.ids.appId;
	var currency = config.ids.currency;
	var helper = __webpack_require__(13);
	var strp = __webpack_require__(31);
	var qs = __webpack_require__(3);
	/* Load meta tags */
	var meta = {
		title: "My Rewards",
		description: "My Rewards",
		meta: {
			name: {
				keywords: "My Rewards"
			}
		}
	};
	
	var Rewards = function (_React$Component) {
		_inherits(Rewards, _React$Component);
	
		function Rewards(props) {
			_classCallCheck(this, Rewards);
	
			/*add class */
			helper.addBodyClass();
	
			var _this = _possibleConstructorReturn(this, (Rewards.__proto__ || Object.getPrototypeOf(Rewards)).call(this, props));
	
			_this.state = { redeem_list_flag: '', advocadostatus: '', advocado_id: 0, advocadoHistory: [], enable_advocado: 'No', credit: [], debit: [], status: "Loading", windowHeightNormal: 0, windowHeight: 0, points: 0, creditLimit: 5, debitLimit: 5, promotion_count: 0 };
	
			/* check Authentication */
			if ((0, _Api2.default)('Auth') === false) {
				_reactRouter.hashHistory.push("/sign-in");
			}
	
			helper.isAnonymousUserRedirect();
	
			_axios2.default.all([_axios2.default.get(APIURL + 'customer/customerdetail?app_id=' + APPID + "&refrence=" + _reactCookie2.default.load('UserId'))]).then(_axios2.default.spread(function (customer) {
				_this.setState({ status: "ok" });
				if (customer.data.status === "ok") {
	
					/*this.setState({ points : customer.data.result_set.customer_reward_point, advocado_id:customer.data.result_set.customer_advocado_id, enable_advocado:customer.data.result_set.enable_advocado });*/
	
					_this.setState({ points: customer.data.result_set.customer_reward_point, advocado_id: customer.data.result_set.customer_advocado_id, enable_advocado: customer.data.result_set.enable_advocado }, function () {
						this.getNinjaProCustPoints(customer.data.result_set.enable_advocado);
					}.bind(_this));
	
					if (customer.data.result_set.enable_advocado === 'Yes') {
						_this.rewardTransactionHistory();
					} else {
						_this.loadData();
					}
				}
			}));
	
			return _this;
		}
	
		_createClass(Rewards, [{
			key: 'getNinjaProCustPoints',
			value: function getNinjaProCustPoints(advocadoFlag) {
				var _this2 = this;
	
				if (advocadoFlag !== 'Yes') {
					var inputKeys = ["promotionwithoutuqc", "reward", "testtxt"];
					inputKeys = JSON.stringify(inputKeys);
	
					_axios2.default.all([_axios2.default.get(APIURL + 'reports/activity_counts1?app_id=' + APPID + "&status=A&customer_id=" + _reactCookie2.default.load('UserId') + "&act_arr=" + inputKeys)]).then(_axios2.default.spread(function (activityCnt) {
	
						if (activityCnt.data.status === "ok") {
							_this2.setState({ points: activityCnt.data.result_set.reward_ponits, promotion_count: activityCnt.data.result_set.promotionwithoutuqc });
						}
					}));
				}
			}
		}, {
			key: 'rewardTransactionHistory',
			value: function rewardTransactionHistory() {
				var _this3 = this;
	
				var cLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
				var dLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	
				var limitOne = cLimit !== null ? cLimit : this.state.creditLimit;
				var limitTwo = dLimit !== null ? dLimit : this.state.debitLimit;
				var advocadoObj = {};
				advocadoObj = {
					'app_id': APPID,
					'customer_id': _reactCookie2.default.load('UserId') };
				_axios2.default.post(APIURL + 'customer/advocado_transaction_history', qs.stringify(advocadoObj)).then(function (res) {
					console.log(res);
					if (res.data.status === "ok") {
						_this3.setState({ status: "ok" });
						_this3.setState({ advocadostatus: res.data.result_set.status, redeem_list_flag: res.data.redeem_list_flag, advocadoHistory: res.data.result_set.data.hits });
					} else {}
				});
			}
		}, {
			key: 'loadData',
			value: function loadData() {
				var _this4 = this;
	
				var cLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
				var dLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	
				var limitOne = cLimit !== null ? cLimit : this.state.creditLimit;
				var limitTwo = dLimit !== null ? dLimit : this.state.debitLimit;
	
				_axios2.default.all([_axios2.default.get(APIURL + 'loyalty/customer_earned_rewardpoint_histroyv1?app_id=' + APPID + "&customer_id=" + _reactCookie2.default.load('UserId') + "&limit=" + limitOne), _axios2.default.get(APIURL + 'Loyalty/customer_redeemed_rewardpoint_histroy?status=A&app_id=' + APPID + "&customer_id=" + _reactCookie2.default.load('UserId') + "&limit=" + limitTwo)]).then(_axios2.default.spread(function (credit, debit) {
	
					_this4.setState({ status: "ok" });
	
					if (credit.data.status === "ok") {
						_this4.setState({ credit: credit.data.result_set });
					}
	
					if (debit.data.status === "ok") {
						_this4.setState({ debit: debit.data.result_set });
					}
				}));
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
	
				var windowHeight = window.innerHeight;
				this.setState({ 'windowHeight': windowHeight - 45 + 'px' });
				this.setState({ 'windowHeightNormal': windowHeight + 'px' });
			}
	
			/* Change earend records */
	
		}, {
			key: 'handleChange',
			value: function handleChange(event) //handleChangereedem
			{
				this.setState({ creditLimit: event.target.value });
				this.loadData(event.target.value, null);
			}
	
			/* Change redeem records */
	
		}, {
			key: 'handleChangeRedeem',
			value: function handleChangeRedeem(event) //handleChangereedem
			{
				this.setState({ debitLimit: event.target.value });
				this.loadData(null, event.target.value);
			}
		}, {
			key: 'loadCartImage',
			value: function loadCartImage() {
				return (0, _Api2.default)('cartImage', 'Yes');
			}
	
			/* this function used to load earn advocado points history */
	
		}, {
			key: 'loadadvocadoearnHistory',
			value: function loadadvocadoearnHistory() {
	
				if (this.state.advocadostatus === 'success' && this.state.advocadoHistory.length > 0) {
	
					return this.state.advocadoHistory.map(function (cData, index) {
						return _react2.default.createElement(
							'div',
							{ key: index },
							' ',
							cData.earnedAmount !== undefined && _react2.default.createElement(
								'div',
								{ className: 'order_list_rewards' },
								_react2.default.createElement(
									'div',
									{ className: 'rws_list_title' },
									_react2.default.createElement(
										'p',
										null,
										'Order Id - ',
										cData.receiptNumber,
										',   ',
										_react2.default.createElement(
											_reactMoment2.default,
											{ format: 'DD/MM/YYYY HH:mm' },
											cData.date
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										'div',
										{ className: 'col-md-6 col-sm-6 col-xs-12' },
										_react2.default.createElement(
											'p',
											{ className: 'price_pt' },
											'Order Amount : ',
											currency + cData.spendingAmount,
											'  '
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-md-6 col-sm-6 col-xs-12 text-right' },
										_react2.default.createElement(
											'p',
											{ className: 'price_pt' },
											_react2.default.createElement(
												'span',
												null,
												'Earned'
											),
											' $',
											cData.earnedAmount,
											' Cashback'
										)
									)
								)
							)
						);
					});
				} else {
					return _react2.default.createElement(
						'div',
						{ className: 'order_list_rewards' },
						' No records found. '
					);
				}
			}
	
			/* this function used to load redeem advocado points history */
	
		}, {
			key: 'loadadvocadoRedeemHistory',
			value: function loadadvocadoRedeemHistory() {
	
				if (this.state.advocadostatus === 'success' && String(this.state.redeem_list_flag) === '1' && this.state.advocadoHistory.length > 0) {
	
					return this.state.advocadoHistory.map(function (cData, index) {
						return _react2.default.createElement(
							'div',
							{ key: index },
							cData.redeemAmount !== undefined && _react2.default.createElement(
								'div',
								{ className: 'order_list_rewards' },
								_react2.default.createElement(
									'div',
									{ className: 'rws_list_title' },
									_react2.default.createElement(
										'p',
										null,
										'Order Id - ',
										cData.receiptNumber,
										',   ',
										_react2.default.createElement(
											_reactMoment2.default,
											{ format: 'DD/MM/YYYY HH:mm' },
											cData.date
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										'div',
										{ className: 'col-md-6 col-sm-6 col-xs-12' },
										_react2.default.createElement(
											'p',
											{ className: 'price_pt' },
											_react2.default.createElement(
												'span',
												null,
												'Redeemed'
											),
											' $',
											cData.redeemAmount
										)
									)
								)
							)
						);
					});
				} else {
					return _react2.default.createElement(
						'div',
						{ className: 'order_list_rewards' },
						' No records found. '
					);
				}
			}
		}, {
			key: 'getDtFrmt',
			value: function getDtFrmt(dateTxt) {
				var runDtTxt = '';
				if (dateTxt != '') {
					var dateTmArr = dateTxt.split(' ');
					var dateArr = dateTmArr[0].split('-');
					var TmArr = dateTmArr[1].split(':');
					runDtTxt = dateArr[2] + '/' + dateArr[1] + '/' + dateArr[0] + ' ' + TmArr[0] + ':' + TmArr[1];
				}
	
				return runDtTxt;
			}
		}, {
			key: 'getEprDate',
			value: function getEprDate(dateTxt) {
				if (dateTxt != '') {
					var dateTmArr = dateTxt.split(' ');
					var expDate = new Date(dateTmArr[0]);
					var nowDate = new Date();
					if (expDate > nowDate) {
						return _react2.default.createElement(
							'p',
							{ style: { float: 'right' } },
							'Expiry On : ',
							this.getDtFrmt(dateTxt)
						);
					} else {
						return _react2.default.createElement(
							'p',
							{ style: { float: 'right' } },
							'Expired'
						);
					}
				} else {
					return _react2.default.createElement(
						'p',
						{ style: { float: 'right' } },
						'Expired'
					);
				}
			}
	
			/* this function used to load earn  points history */
	
		}, {
			key: 'loadearnHistory',
			value: function loadearnHistory() {
				var _this5 = this;
	
				if (this.state.credit.length > 0) {
	
					return this.state.credit.map(function (cData, index) {
						return _react2.default.createElement(
							'div',
							{ className: 'order_list_rewards', key: index },
							_react2.default.createElement(
								'div',
								{ className: 'rws_list_title' },
								cData.lh_from === 'pos' ? _react2.default.createElement(
									'p',
									null,
									cData.lh_reason
								) : _react2.default.createElement(
									'p',
									null,
									'Order1 Id - ',
									cData.order_local_no,
									',   ',
									_this5.getDtFrmt(cData.order_date)
								),
								_this5.getEprDate(cData.lh_expiry_on)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								cData.lh_from === 'pos' ? _react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-sm-6 col-xs-12' },
									_react2.default.createElement(
										'p',
										{ className: 'price_pt' },
										'Added By : Admin  '
									),
									_react2.default.createElement('span', null)
								) : _react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-sm-6 col-xs-12' },
									_react2.default.createElement(
										'p',
										{ className: 'price_pt' },
										'Order Amount : ',
										currency + cData.order_total_amount,
										'  '
									),
									_react2.default.createElement(
										'span',
										null,
										cData.order_availability_name
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-sm-6 col-xs-12 text-right' },
									_react2.default.createElement(
										'p',
										{ className: 'price_pt' },
										_react2.default.createElement(
											'span',
											null,
											'Earned'
										),
										' ',
										cData.lup_customer_points,
										' Points'
									)
								)
							)
						);
					});
				} else {
					return _react2.default.createElement(
						'div',
						{ className: 'order_list_rewards' },
						' No records found. '
					);
				}
			}
	
			/* this function used to load redeem  points history */
	
		}, {
			key: 'loadredeemHistory',
			value: function loadredeemHistory() {
				var _this6 = this;
	
				if (this.state.debit.length > 0) {
	
					return this.state.debit.map(function (dData, index) {
						return _react2.default.createElement(
							'div',
							{ className: 'order_list_rewards', key: index },
							_react2.default.createElement(
								'div',
								{ className: 'rws_list_title' },
								_react2.default.createElement(
									'p',
									null,
									'Order Id - ',
									dData.order_local_no,
									',   ',
									_this6.getDtFrmt(dData.order_date)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-sm-6 col-xs-12' },
									_react2.default.createElement(
										'p',
										{ className: 'price_pt' },
										'Order Amount : ',
										currency + dData.order_total_amount,
										'  '
									),
									_react2.default.createElement(
										'span',
										null,
										dData.order_availability_name
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-sm-6 col-xs-12 text-right' },
									_react2.default.createElement(
										'p',
										{ className: 'price_pt' },
										_react2.default.createElement('span', null),
										' Redeemed ',
										dData.lh_redeem_point,
										' Points'
									)
								)
							)
						);
					});
				} else {
					return _react2.default.createElement(
						'div',
						{ className: 'order_list_rewards' },
						' No records found. '
					);
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				(0, _withTracker.loadAnalytics)();
	
				var promise = (0, _Api2.default)("settingsPro", "No");
				promise.then(function (res) {
					if (!helper.disableMenu(res.data.result_set, "myaccount_rewards")) {
						_reactRouter.hashHistory.push("/");
						return false;
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
	
				if (this.state.status === "Loading") {
	
					return _react2.default.createElement(
						'div',
						{ className: 'container-fluid desktop-container', style: { minHeight: this.state.windowHeightNormal } },
						_react2.default.createElement('div', { className: 'row' }),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement('div', { className: 'space-10 bg-gray' })
						),
						_react2.default.createElement(
							'div',
							{ className: ' ' },
							_react2.default.createElement(
								'div',
								{ className: 'col-xs-10 div-center' },
								_react2.default.createElement('div', { className: 'space-5' }),
								_react2.default.createElement(Loading, null),
								_react2.default.createElement('div', { className: 'space-5' })
							),
							_react2.default.createElement('div', { className: 'clearfix' })
						),
						_react2.default.createElement('div', { className: 'space-30' }),
						_react2.default.createElement('div', { className: 'space-30' }),
						_react2.default.createElement('div', { className: 'space-30' }),
						_react2.default.createElement('div', { className: 'space-30' }),
						_react2.default.createElement('div', { className: 'space-30' }),
						_react2.default.createElement('div', { className: 'space-5' }),
						_react2.default.createElement('div', { className: 'space-5' }),
						_react2.default.createElement('div', { className: 'space-30' }),
						' ',
						_react2.default.createElement('div', { className: 'space-30' }),
						' ',
						_react2.default.createElement('div', { className: 'space-30' }),
						' ',
						_react2.default.createElement('div', { className: 'space-30' })
					);
				} else {
	
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_reactDocumentMeta2.default, meta),
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid   ninja-theme-v2  desktop-container rewards-section-top', style: { minHeight: this.state.windowHeightNormal } },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 top-nav inner-top-nav head-main' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-3 nav-head pd-l-20  head-child' },
										' ',
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: "/my-account" },
											_react2.default.createElement('img', { src: '/img/icons/arrow-right.png', alt: 'left-arrow', className: 'icon-img-small-3' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-6 nav-head   head-child' },
										_react2.default.createElement(
											'h1',
											{ className: 'main-title' },
											'My Rewards'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-3 nopadding   head-child' },
										_react2.default.createElement(
											'p',
											{ className: 'b-txt text-right ' },
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: "/cart", className: helper.cartClass() },
												helper.cartCount(),
												'   ',
												_react2.default.createElement('img', { alt: '', src: this.loadCartImage(), className: 'icon-img-small-1' }),
												' '
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'rewards-wrap' },
								_react2.default.createElement(
									'div',
									{ className: 'rewards_banner' },
									_react2.default.createElement('img', { src: 'img/rewards_banner.jpg' }),
									_react2.default.createElement(
										'div',
										{ className: 'rewards-content' },
										_react2.default.createElement(
											'h4',
											null,
											this.state.enable_advocado === 'Yes' ? "$" + this.state.points + " Cashback" : this.state.points + " Points"
										),
										_react2.default.createElement(
											'p',
											null,
											'Available for your redemption'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'tabbable-panel' },
									_react2.default.createElement(
										'div',
										{ className: 'tabbable-line' },
										_react2.default.createElement(
											'ul',
											{ className: 'nav nav-tabs ' },
											_react2.default.createElement(
												'li',
												{ className: 'active' },
												_react2.default.createElement(
													'a',
													{ href: '#tab_default_1', 'data-toggle': 'tab' },
													'Rewards Earned'
												)
											),
											_react2.default.createElement(
												'li',
												null,
												_react2.default.createElement(
													'a',
													{ href: '#tab_default_2', 'data-toggle': 'tab' },
													'Rewards Redeemed '
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'tab-content' },
											_react2.default.createElement(
												'div',
												{ className: 'tab-pane fade in active', id: 'tab_default_1' },
												this.state.enable_advocado === 'Yes' && this.loadadvocadoearnHistory(),
												this.state.enable_advocado === 'No' && this.loadearnHistory()
											),
											_react2.default.createElement(
												'div',
												{ className: 'tab-pane fade', id: 'tab_default_2' },
												this.state.enable_advocado === 'Yes' && this.loadadvocadoRedeemHistory(),
												this.state.enable_advocado === 'No' && this.loadredeemHistory()
											)
										)
									)
								)
							)
						)
					);
				}
			}
		}]);
	
		return Rewards;
	}(_react2.default.Component);
	
	exports.default = Rewards;

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _immutabilityHelper = __webpack_require__(56);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _validator = __webpack_require__(88);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactCustomValidation = __webpack_require__(57);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(65);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _reactFacebookLogin = __webpack_require__(437);
	
	var _reactFacebookLogin2 = _interopRequireDefault(_reactFacebookLogin);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var Loading = __webpack_require__(17);
	var config = __webpack_require__(7);
	var lang = __webpack_require__(12);
	var APIURL = config.path.apiUrl;
	var APIURLV2 = config.path.apiUrlv2;
	var APPID = config.ids.appId;
	
	var Alert = __webpack_require__(48);
	var helper = __webpack_require__(13);
	var dateFormat = __webpack_require__(42);
	var apps = __webpack_require__(29);
	var MemberAppID = "B401FC82-8E39-4076-838A-55192F765004";
	var MemberAppIDGour = "B93EC9A9-1A67-4EBA-ADB7-BC7C14FA88A4";
	var MemberAppIDSCC = "6C0280A0-B655-4E0F-A43F-041C189683BA";
	/* Load meta tags   sdsd */
	var meta = {
		title: lang.signin_meta_title,
		description: lang.signin_meta_title,
		meta: {
			name: {
				keywords: lang.signin_meta_title
			}
		}
	};
	
	var Signin = function (_React$Component) {
		_inherits(Signin, _React$Component);
	
		function Signin() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Signin);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Signin.__proto__ || Object.getPrototypeOf(Signin)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
				fields: {
					email: '',
					password: '',
					settings: '',
					invalidMemberID: '',
					accepted_coupons: 0,
					email_missmatch_error: '',
					email_missmatch_error_count: 0
	
				},
				status: 'Loading'
				/*add class */
				// helper.addBodyClass();
			}, _this.fieldChange = function (field, value) {
				_this.setState((0, _immutabilityHelper2.default)(_this.state, { fields: _defineProperty({}, field, { $set: value }) }));
			}, _this.handleFormSubmit = function () {
				document.getElementById("loadIcon").style.display = "block";
				_this.setStateLoading('Loading');
				var formPayload = _this.state.fields;
				var qs = __webpack_require__(3);
				var postObject = {
					"app_id": APPID,
					"type": "web",
					"login_username": formPayload.email,
					"login_password": formPayload.password
				};
				_axios2.default.post(APIURL + "customer/login", qs.stringify(postObject)).then(function (response) {
					document.getElementById("loadIcon").style.display = "none";
					if (response.data.status === "ok") {
						_reactCookie2.default.remove("isTempUser");
						//alert(response.data.result_set.customer_phone);
						var mobileno = '';
						if (response.data.result_set.customer_phone !== "" || response.data.result_set.customer_phone !== null || typeof response.data.result_set.customer_phone !== "undefined") {
							mobileno = response.data.result_set.customer_phone;
						}
	
						/* set User cookie values - Start */
						_reactCookie2.default.save("UserId", response.data.result_set.customer_id);
						_reactCookie2.default.save("UserFname", response.data.result_set.customer_first_name !== "" ? response.data.result_set.customer_first_name : '');
						_reactCookie2.default.save("UserLname", response.data.result_set.customer_last_name != "" ? response.data.result_set.customer_last_name : '');
						_reactCookie2.default.save("UserMobile", mobileno);
						_reactCookie2.default.save("UserEmail", response.data.result_set.customer_email);
						_reactCookie2.default.save("UserDefaultAddress", response.data.result_set.customer_address_name);
						_reactCookie2.default.save("UserDefaultUnitOne", response.data.result_set.customer_address_line1);
						_reactCookie2.default.save("UserDefaultUnitTwo", response.data.result_set.customer_address_line2);
						_reactCookie2.default.save("UserDefaultPostalCode", response.data.result_set.customer_postal_code);
						/* set User cookie values - End */
	
						/* set redirection */
	
						/* upadte customer info */
						var qs = __webpack_require__(3);
						var postObject = {
							"app_id": APPID,
							"reference_id": (0, _Api2.default)('referenceId'),
							"customer_id": response.data.result_set.customer_id,
							"availability_id": _reactCookie2.default.load('defaultAvilablityId')
						};
	
						_axios2.default.post(APIURL + "cart/update_customer_info", qs.stringify(postObject)).then(function (res) {
							if (res.data.status === "ok" && _reactCookie2.default.load('reserVationClick') !== 'fromhome') {
	
								/* check FB login function */
								_reactCookie2.default.save('cartValue', 'Yes');
								if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId) {
									if (APPID === "287E5552-328E-4DBE-A3CA-E998ACCAC9BD") {
										helper.sarveshTableSetup();
										// this.setStateLoading('ok'); 
									} else {
										_this.setStateLoading('ok');
										if (typeof _reactCookie2.default.load("orderOutletId") !== "undefined" && _reactCookie2.default.load("orderOutletId") !== "" && typeof _reactCookie2.default.load("orderTableNo") !== "undefined" && _reactCookie2.default.load("orderTableNo") !== "") {
											_reactRouter.hashHistory.push("/checkout");
										} else {
	
											_reactRouter.hashHistory.push("/book-a-table");
										}
									}
								} else {
									_this.setStateLoading('ok');
									document.getElementById("loadIcon").style.display = "none";
									_reactRouter.hashHistory.push("/delivery-date");
								}
							} else {
								if (_reactCookie2.default.load('reserVationClick') === 'fromhome') {
									_reactRouter.hashHistory.push("/");
									_reactCookie2.default.save('reserVationClick', 'fromlogin');
								} else if (_reactCookie2.default.load('dineinClick') === 'yes' && _reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId) {
									if (APPID === "287E5552-328E-4DBE-A3CA-E998ACCAC9BD") {
										helper.sarveshTableSetup();
									} else {
										_this.setStateLoading('ok');
										_reactRouter.hashHistory.push("/book-a-table");
									}
								} else {
									//hashHistory.push("/my-account");
									_reactRouter.hashHistory.push("/");
									_reactCookie2.default.save('cartValue', 'No');
								}
							}
						});
	
						/*  if( cookie.load('cartValue') === "Yes"){  
	     		 if(cookie.load('defaultAvilablityId') === config.ids.dineinId){  console.log(2); 
	     				hashHistory.push("/book-a-table");
	     			   }
	       }else{
	      	hashHistory.push("/#/dashboard");
	       }   */
					} else {
	
						_this.setStateLoading('error');
						document.getElementById("loadIcon").style.display = "none";
						//this.setState({signInError :response.data.message });
						//cookie.save("signInError",response.data.message); 
						//	cookie.save("signInError",response.data.message); 
						helper.showInfo(response.data.message);
	
						//$("#Signin-Error").modal("toggle");
						//document.getElementById("form-error").innerHTML='<div class="box_error"><ul><li>'+response.data.message+'</li></ul></div>';
					}
				}).catch(function (error) {
					helper.showInfo(error);
				});
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		/* If user logged in goto  order page */
	
		_createClass(Signin, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				this.setState({ status: 'ok' });
	
				if (_reactCookie2.default.load('dineinClick') === 'yes') {
					_reactCookie2.default.save('dineinFrom', 'signin');
				}
	
				var promise = (0, _Api2.default)('settings', '');
				promise.then(function (res) {
					_this2.setState({ settings: res.data.result_set });
					_reactCookie2.default.save('client_company_name', res.data.result_set.company_name);
					_reactCookie2.default.save('check_new_user', 0);
					if (typeof res.data.result_set.client_enable_express_checkout !== "undefined" && parseInt(res.data.result_set.client_enable_express_checkout) === 1) {
						_reactRouter.hashHistory.push("/new-signin");
					}
				});
			}
		}, {
			key: 'setStateLoading',
			value: function setStateLoading(sts) {
				this.setState({ status: sts });
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this3 = this;
	
				var site_maintenance_verify = _reactCookie2.default.load("client_site_maintenance_verify") !== '' && _reactCookie2.default.load("client_site_maintenance_verify") !== 'undefined' && _reactCookie2.default.load("client_site_maintenance_verify") !== undefined ? _reactCookie2.default.load("client_site_maintenance_verify") : '';
	
				var site_maintenance_popup_open = _reactCookie2.default.load("site_maintenance_popup_open") !== '' && _reactCookie2.default.load("site_maintenance_popup_open") !== 'undefined' && _reactCookie2.default.load("site_maintenance_popup_open") !== undefined ? _reactCookie2.default.load("site_maintenance_popup_open") : '';
	
				if (site_maintenance_popup_open === "1" && (site_maintenance_verify === '' || site_maintenance_verify === '0')) {
					_reactRouter.hashHistory.push("/");
					return;
				}
	
				var list = document.getElementsByClassName('form-group');
				var n;
				for (n = 0; n < list.length; ++n) {
					list[n].classList.add("is-empty");
				}
	
				var promise = (0, _Api2.default)('settings', '');
				promise.then(function (res) {
					_this3.setState({ settings: res.data.result_set });
					_reactCookie2.default.save("client_otp_verification_enable", res.data.result_set.client_otp_verification_enable);
					_reactCookie2.default.save("client_otp_verification_via", res.data.result_set.client_otp_verification_via);
					_reactCookie2.default.save('client_company_name', res.data.result_set.company_name);
					_reactCookie2.default.save('check_new_user', 0);
				});
				setTimeout(function () {
					if (this.state.settings.client_facebook_login == '1') {
						$('.row-facebook-login').removeClass('hidden');
					}
				}.bind(this), 1000);
	
				(0, _withTracker.loadAnalytics)();
			}
			/* continue with delivery success */
	
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(Form, {
					fields: this.state.fields,
					onChange: this.fieldChange,
					onValid: this.handleFormSubmit,
					onInvalid: function onInvalid() {
						return console.log('Form invalid!');
					}
				});
			}
		}]);
	
		return Signin;
	}(_react2.default.Component);
	
	var isEmpty = function isEmpty(value) {
		return value === '' ? 'This field is required.' : null;
	};
	
	var isEmail = function isEmail(email) {
		return _validator2.default.isEmail(email) ? null : 'This is not a valid email.';
	};
	
	function validationConfig(props) {
		var _props$fields = props.fields,
		    email = _props$fields.email,
		    password = _props$fields.password;
	
	
		return {
			fields: ['email', 'password'],
	
			validations: {
				email: [[isEmail, email]],
				password: [[isEmpty, password]]
			}
		};
	}
	
	var Form = function (_React$Component2) {
		_inherits(Form, _React$Component2);
	
		function Form(props) {
			_classCallCheck(this, Form);
	
			// alert('load');
			var _this4 = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));
	
			_this4.state = {
				status: 'Loading',
				fbId: '',
				guestFields: {},
				check_new_user: 0,
				guestErrors: {},
				guest_checkout_enable: 0,
				client_anonymous_customer_login_enable: 0,
				guest_type: 0,
				backtoGuestform: false,
				'renderLoading': 'Loading', windowHeightNormal: 0, windowHeight: 0,
				email_missmatch_error: '',
				email_missmatch_error_count: 0
			};
	
			_this4.responseFacebook = function (response) {
				// console.log(response);
				//alert(response.birthday);  
				if (response.name !== "" && response.email !== "" && response.name !== undefined && response.email !== undefined) {
					_this4.setStateLoading('Loading');
					document.getElementById("loadIcon").style.display = "block";
					var vSplitName = response.name.split(" ");
					var firstname = vSplitName[0];
					var lastname = vSplitName[1];
					var birthday = response.birthday;
					var qs = __webpack_require__(3);
					/* update gender field */
					var postGender = "";
					if (typeof response.gender !== "undefined" && response.gender === "male") {
						postGender = "M";
					} else if (typeof response.gender !== "undefined" && response.gender === "female") {
						postGender = "F";
					}
					/* update DOB */
					var dob = '';
					if (typeof birthday !== "undefined" && birthday !== "") {
						dob = dateFormat(response.birthday, "yyyy-mm-dd");
					}
	
					var postObject = {
						"app_id": APPID,
						"type": "web",
						"login_firstname": response.first_name,
						"login_lastname": response.last_name,
						"login_username": response.email,
						"customer_fb_id": response.id,
						"customer_gender": postGender,
						"customer_dob": dob
					};
					_axios2.default.post(APIURL + "customer/fbloginapp", qs.stringify(postObject)).then(function (response) {
						if (response.data.status === "ok") {
							_reactCookie2.default.remove("isTempUser");
							/* set User cookie values - Start  */
							//alert(response.data.result_set.customer_phone);
							var mobileno = '';
							if (typeof response.data.result_set.customer_phone === "undefined" || response.data.result_set.customer_phone === "null" || response.data.result_set.customer_phone === "") {
								mobileno = "";
							} else {
	
								mobileno = response.data.result_set.customer_phone;
							}
	
							_reactCookie2.default.save("UserId", response.data.result_set.customer_id);
							_reactCookie2.default.save("UserEmail", response.data.result_set.customer_email);
							_reactCookie2.default.save("UserFname", response.data.result_set.customer_first_name !== "" ? response.data.result_set.customer_first_name : '');
							_reactCookie2.default.save("UserLname", response.data.result_set.customer_last_name !== "" ? response.data.result_set.customer_last_name : '');
							_reactCookie2.default.save("UserMobile", mobileno);
	
							_reactCookie2.default.save("UserDefaultAddress", response.data.result_set.customer_address_name);
							_reactCookie2.default.save("UserDefaultUnitOne", response.data.result_set.customer_address_line1);
							_reactCookie2.default.save("UserDefaultUnitTwo", response.data.result_set.customer_address_line2);
							_reactCookie2.default.save("UserDefaultPostalCode", response.data.result_set.customer_postal_code);
	
							/* set User cookie values - End  */
	
							/* set redirection */
	
							/* upadte customer info  */
							var qs = __webpack_require__(3);
							var postObject = {
								"app_id": APPID,
								"reference_id": (0, _Api2.default)('referenceId'),
								"customer_id": response.data.result_set.customer_id,
								"availability_id": _reactCookie2.default.load('defaultAvilablityId')
							};
	
							_axios2.default.post(APIURL + "cart/update_customer_info", qs.stringify(postObject)).then(function (res) {
								if (res.data.status === "ok" && _reactCookie2.default.load('reserVationClick') !== 'fromhome') {
									_reactCookie2.default.save('cartValue', 'Yes');
									if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId) {
										if (APPID === "287E5552-328E-4DBE-A3CA-E998ACCAC9BD") {
											helper.sarveshTableSetup();
										} else {
											if (typeof _reactCookie2.default.load("orderOutletId") !== "undefined" && _reactCookie2.default.load("orderOutletId") !== "" && typeof _reactCookie2.default.load("orderTableNo") !== "undefined" && _reactCookie2.default.load("orderTableNo") !== "") {
												_reactRouter.hashHistory.push("/checkout");
											} else {
												_reactRouter.hashHistory.push("/book-a-table");
											}
										}
									} else {
										_reactRouter.hashHistory.push("/delivery-date");
									}
									_this4.setStateLoading('ok');
									document.getElementById("loadIcon").style.display = "none";
								} else {
									if (_reactCookie2.default.load('reserVationClick') === 'fromhome') {
										_reactRouter.hashHistory.push("/");
										_reactCookie2.default.save('reserVationClick', 'fromlogin');
									} else if (_reactCookie2.default.load('dineinClick') === 'yes' && _reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId) {
										if (APPID === "287E5552-328E-4DBE-A3CA-E998ACCAC9BD") {
											helper.sarveshTableSetup();
										} else {
											_this4.setStateLoading('ok');
											_reactRouter.hashHistory.push("/book-a-table");
										}
									} else {
										_reactRouter.hashHistory.push("/my-account");
										_reactCookie2.default.save('cartValue', 'No');
									}
								}
							});
						} else {
							_this4.setStateLoading('error');
							document.getElementById("loadIcon").style.display = "none";
							helper.showInfo(response.data.message);
							//document.getElementById("form-error").innerHTML='<div class="box_error"><ul><li>'+response.data.message+'</li></ul></div>';
						}
					}).catch(function (error) {
						//  console.log(error);
						helper.showInfo(error);
					});
				}
			};
	
			_this4.handleChangeTxt = function (item, event) {
				_this4.setState(_defineProperty({}, item, event.target.value));
				document.getElementById("spn-otp-error").innerHTML = '';
			};
	
			var promise = (0, _Api2.default)('settingsProWithavailability', 'No');
			promise.then(function (res) {
				//alert('loaded');
				//this.setStateLoading('Loading');
				_this4.setState({ client_site_url: res.data.result_set.client_site_url, fbId: res.data.result_set.ninja_pro_fb_app_id, renderLoading: 'ok', guest_checkout_enable: res.data.result_set.client_guest_checkout_enable, client_anonymous_customer_login_enable: res.data.result_set.client_anonymous_customer_login_enable });
			});
			return _this4;
		}
	
		_createClass(Form, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (APPID === MemberAppID || APPID === MemberAppIDSCC || APPID === MemberAppIDGour) {
					var current = this;
					setTimeout(function () {
						current.guestCheckout();
					}, 1000);
				}
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.setStateLoading('ok');
	
				var windowHeight = window.innerHeight;
				this.setState({ 'windowHeight': windowHeight + 'px' });
			}
	
			/* get FB ID*/
	
			/* guest form */
	
		}, {
			key: 'guestCheckout',
			value: function guestCheckout() {
				$("#GuestCheckout").modal("toggle");
			}
		}, {
			key: 'enableGuset',
			value: function enableGuset() {
				$(".enable-guest").show();
				$(".disable-guest").hide();
				this.setState({ "guest_type": 1 });
			}
		}, {
			key: 'disableGuset',
			value: function disableGuset() {
				$(".enable-guest").hide();
				$(".disable-guest").show();
				this.setState({ "guest_type": 0 });
			}
		}, {
			key: 'showGusetCheckout',
			value: function showGusetCheckout() {
	
				if (parseInt(this.state.guest_checkout_enable) === 1) {
					return _react2.default.createElement(
						'div',
						{ className: 'row row-guest-checkout' },
						_react2.default.createElement(
							'div',
							{ className: 'text-center ' },
							_react2.default.createElement(
								'button',
								{ type: 'button', onClick: this.guestCheckout.bind(this), className: 'btn text-uppercase btn-guest-checkout' },
								_react2.default.createElement('img', { src: '/img/icons/user-white.png', alt: 'guest-checkout', className: 'icon-img-guest-checkout' }),
								APPID === "B401FC82-8E39-4076-838A-55192F765004" || APPID === "6C0280A0-B655-4E0F-A43F-041C189683BA" || APPID === "B93EC9A9-1A67-4EBA-ADB7-BC7C14FA88A4" ? 'Member Login' : 'Express Checkout'
							)
						)
					);
				}
			}
		}, {
			key: 'getAnonymousCheckout',
			value: function getAnonymousCheckout() {
				var _this5 = this;
	
				$("#loadIcon").show();
				_axios2.default.get(_constants.API_v4_URL + "anonymouscustomer/get_anonymous_customer/?app_id=" + APPID).then(function (response) {
	
					$("#loadIcon").hide();
					if (response.data.status === "ok") {
	
						_this5.setGuestData(response, 'isAnonymousUser');
					} else {
						helper.showInfo("This feature is currently unavailable please try again later");
					}
					return false;
				});
			}
		}, {
			key: 'showAnonymousCheckout',
			value: function showAnonymousCheckout() {
	
				if (parseInt(this.state.client_anonymous_customer_login_enable) === 1) {
					return _react2.default.createElement(
						'div',
						{ className: 'row row-guest-checkout' },
						_react2.default.createElement(
							'div',
							{ className: 'text-center ' },
							_react2.default.createElement(
								'h4',
								null,
								'Continue without an account'
							),
							_react2.default.createElement(
								'button',
								{ type: 'button', onClick: this.getAnonymousCheckout.bind(this), className: 'btn text-uppercase btn-guest-checkout btn-guest-checkout-btn' },
								_react2.default.createElement('img', { src: '/img/icons/user-white.png', alt: 'guest-checkout', className: 'icon-img-guest-checkout' }),
								"Guest Order"
							)
						)
					);
				}
			}
		}, {
			key: 'transformEntry',
			value: function transformEntry(item, type) {
				switch (type) {
					case 'email':
						var parts = item.split("@"),
						    len = parts[0].length;
						return item.replace(parts[0].slice(1, -1), "*".repeat(len - 2));
					case 'phone':
						return item[0] + "*".repeat(item.length - 4) + item.slice(-3);
					default:
						throw new Error("Undefined type: " + type);
				}
			}
		}, {
			key: 'handleValidation',
			value: function handleValidation() {
				var fields = this.state.guestFields;
				var errors = {};
				var formIsValid = true;
				var guestMobile = fields["guest-mobile"];
				if (APPID === MemberAppID || APPID === MemberAppIDSCC || APPID === MemberAppIDGour) {
					var membershipid = fields["guest-membershipid"];
					if (!membershipid) {
						formIsValid = false;
						errors["guest-membershipid"] = "Membership # field is required.";
					} /* else {
	      if(APPID===MemberAppID) {
	      	var validMember = '^[a-zA-Z]{1}[0-9]{4}$';
	      	var result = membershipid.match(validMember);
	      	if(result===null || result==="") {
	      		console.log('aaaa', result)
	      		formIsValid = false;
	         		errors["guest-membershipid"] = "Invalid Membership #";
	      	}
	      }
	      }*/
					/*else if(this.state.invalidMemberID===true) {
	       formIsValid = false;
	       errors["guest-membershipid"] = "Invalid Membership #";
	    }*/
				}
				if (!guestMobile) {
	
					formIsValid = false;
					errors["guest-mobile"] = "Mobile number field is required.";
				}
	
				if (typeof guestMobile !== "undefined") {
					if (!guestMobile.match(/^[0-9]+$/)) {
						formIsValid = false;
						errors["guest-mobile"] = "Invalid Mobile number";
					} else if (guestMobile.length < 8) {
						formIsValid = false;
						errors["guest-mobile"] = "Mobile number must be of minimum 8 characters length.";
					}
				}
	
				if (!fields["guest-name"]) {
					formIsValid = false;
					errors["guest-name"] = "Name field is required.";
				}
	
				if (typeof fields["guest-name"] !== "undefined") {
					if (!fields["guest-name"].match(/^[A-Za-z ]{3,20}$/)) {
						formIsValid = false;
						errors["guest-name"] = "Name must contain only letters.";
					}
				}
	
				if (!fields["guest-email"]) {
					formIsValid = false;
					errors["guest-email"] = "Email field is required.";
				}
	
				if (typeof fields["guest-email"] !== "undefined" && fields["guest-email"] != '') {
					var lastAtPos = fields["guest-email"].lastIndexOf('@');
					var lastDotPos = fields["guest-email"].lastIndexOf('.');
	
					if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fields["guest-email"].indexOf('@@') == -1 && lastDotPos > 2 && fields["guest-email"].length - lastDotPos > 2)) {
						formIsValid = false;
						errors["guest-email"] = "Email is not valid.";
					}
				}
	
				/*   if(!fields["guest-cemail"]){
	   	formIsValid = false;
	   	errors["guest-cemail"] = "Email field is required.";
	    }
	   
	    if(typeof fields["guest-cemail"] !== "undefined"){
	   	let lastAtPos = fields["guest-cemail"].lastIndexOf('@');
	   	let lastDotPos = fields["guest-email"].lastIndexOf('.');
	   
	   	if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fields["guest-cemail"].indexOf('@@') == -1 && lastDotPos > 2 && (fields["guest-cemail"].length - lastDotPos) > 2)) {
	   	   formIsValid = false;
	   	   errors["guest-cemail"] = "Email is not valid.";
	   	 }
	   }   
	   if( (typeof fields["guest-email"] !== "undefined" && typeof fields["guest-cemail"] !== "undefined" )  && (fields["guest-email"].toLowerCase() != fields["guest-cemail"].toLowerCase()) && (fields["guest-email"].toLowerCase()  !=="" && fields["guest-cemail"].toLowerCase()  !== "") ) {
	   
	   if( (typeof fields["guest-cemail"] !== "undefined" &&  typeof fields["guest-email"] !== "undefined") && (fields["guest-email"].toLowerCase() != fields["guest-cemail"].toLowerCase()) && (fields["guest-email"].toLowerCase()  !=="" && fields["guest-cemail"].toLowerCase()  !== "") ) {
	   	formIsValid = false;
	   	errors["guest-email"] = "Your email and confirmation email  do not match.";
	    }	 */
	
				if (parseInt(this.state.guest_type) === 1) {
	
					if (!fields["guest-password"]) {
						formIsValid = false;
						errors["guest-password"] = "Password field is required.";
					}
					if (typeof fields["guest-password"] !== "undefined") {
						if (fields["guest-password"].length < 6) {
							formIsValid = false;
							errors["guest-password"] = "Password must be of minimum 6 characters length.";
						}
					}
	
					if (!fields["guest-retype-password"]) {
						formIsValid = false;
						errors["guest-retype-password"] = "Confirm Password field is required.";
					}
	
					if (typeof fields["guest-retype-password"] !== "undefined") {
						if (fields["guest-retype-password"].length < 6) {
							formIsValid = false;
							errors["guest-retype-password"] = "Confirm Password must be of minimum 6 characters length";
						} else if (fields["guest-password"] != fields["guest-retype-password"]) {
							formIsValid = false;
							errors["guest-retype-password"] = "Your password and confirmation password do not match.";
						}
					}
				}
	
				if (!fields["guest-accepted-alcohol"] && (APPID === "2AE048E7-2D84-42BE-9BB5-22016FC4DFBC" || APPID === "44275190-B355-4486-8083-EE1C63607916" || APPID === "F34559CA-596A-4F2E-8547-17B2AEBB3326")) {
					formIsValid = false;
					errors["guest-accepted-alcohol"] = "This field is required.";
				}
	
				this.setState({ guestErrors: errors });
				return formIsValid;
			}
		}, {
			key: 'sendOtpToCustomer',
			value: function sendOtpToCustomer() {
				var _this6 = this;
	
				var company_otp_verification = _reactCookie2.default.load('client_otp_verification_enable');
				var company_otp_via = _reactCookie2.default.load('client_otp_verification_via');
	
				if (company_otp_verification === '1') {
					$("#loadIcon").show();
					var qs = __webpack_require__(3);
					var postObject = {
						"app_id": APPID,
						"customer_first_name": this.state.guestFields['guest-name'],
						"customer_last_name": "",
						"customer_email": this.state.guestFields['guest-email'],
						"customer_phone": this.state.guestFields['guest-mobile'],
						"customer_otp_type": company_otp_via
					};
	
					_axios2.default.post(_constants.API_v4_URL + "customer/send_customer_otp", qs.stringify(postObject)).then(function (response) {
						if (response.data.status === "ok") {
							$("#loadIcon").hide();
							document.getElementById("otp_verification_option").style.display = "block";
							if (company_otp_via === '1') {
								helper.showInfo("OTP has been sent to your email id (" + _this6.transformEntry(_this6.state.guestFields['guest-email'], 'email') + " )");
							} else {
								helper.showInfo("OTP has been sent to your mobile number (" + _this6.transformEntry(_this6.state.guestFields['guest-mobile'], 'phone') + " )");
							}
							document.getElementById("loadIcon").style.display = "none";
							document.getElementById("gust_checkout_form").style.display = "none";
	
							//  return false;
						} else {
							_this6.setStateLoading('error');
							document.getElementById("otp_error_msg").innerHTML = '<span class="spn-error">' + response.data.message + '</span>';
							document.getElementById("loadIcon").style.display = "none";
							$("#loadIcon").hide();
						}
						return false;
					});
				}
			}
		}, {
			key: 'applyValidation',
			value: function applyValidation() {
				var _this7 = this;
	
				if (this.state.check_new_user === 1) {
					//helper.showInfo("You already have account.");
					//return false;
				}
	
				if (this.handleValidation()) {
					/*if(APPID===MemberAppID) {
	    	if(this.state.invalidMemberID===true) {
	    		this.setState({guestErrors : {"guest-membershipid":'Invalid Membership #'}})
	    		return false;
	    	}
	    }*/
	
					var guestType = parseInt(this.state.guest_type);
					$("#loadIcon").show();
					this.setState({ email_missmatch_error: '' });
					var company_otp_verification = _reactCookie2.default.load('client_otp_verification_enable');
					var company_otp_via = _reactCookie2.default.load('client_otp_verification_via');
	
					var skipflow = 1;
					if (company_otp_verification === '1' && _reactCookie2.default.load('check_new_user') === '0' && skipflow === 0) {
	
						var qs = __webpack_require__(3);
						var postObject = {
							"app_id": APPID,
							"customer_first_name": this.state.guestFields['guest-name'],
							"customer_last_name": "",
							"customer_email": this.state.guestFields['guest-email'],
							"customer_phone": this.state.guestFields['guest-mobile'],
							"customer_otp_type": company_otp_via
						};
	
						_axios2.default.post(_constants.API_v4_URL + "customer/send_customer_otp", qs.stringify(postObject)).then(function (response) {
							if (response.data.status === "ok") {
	
								document.getElementById("otp_verification_option").style.display = "block";
								if (company_otp_via === '1') {
									helper.showInfo("OTP has been sent to your email id (" + _this7.transformEntry(_this7.state.guestFields['guest-email'], "email") + " )");
								} else {
									helper.showInfo("OTP has been sent to your mobile number (" + _this7.transformEntry(_this7.state.guestFields['guest-mobile'], 'phone') + " )");
								}
								document.getElementById("loadIcon").style.display = "none";
								document.getElementById("gust_checkout_form").style.display = "none";
	
								//  return false;
							} else {
								_this7.setStateLoading('error');
								document.getElementById("otp_error_msg").innerHTML = '<span class="spn-error">' + response.data.message + '</span>';
								document.getElementById("loadIcon").style.display = "none";
								$("#loadIcon").hide();
							}
							return false;
						});
					} else {
						var accepted_coupons = 0;
						if (this.state.guestFields['guest-accepted-coupons'] !== "" && typeof this.state.guestFields['guest-accepted-coupons'] !== "undefined" && _typeof(this.state.guestFields['guest-accepted-coupons']) !== undefined) {
							accepted_coupons = this.state.guestFields['guest-accepted-coupons'];
						}
	
						if (guestType === 1) {
	
							var qs = __webpack_require__(3);
							var postObject = {
								"app_id": APPID,
								"type": "web",
								"customer_first_name": this.state.guestFields['guest-name'],
								"customer_last_name": "",
								"customer_email": this.state.guestFields['guest-email'],
								"customer_password": this.state.guestFields['guest-password'],
								"customer_phone": this.state.guestFields['guest-mobile'],
								"accepted_coupons": accepted_coupons,
								"site_url": this.state.client_site_url + "#/"
							};
							_axios2.default.post(APIURL + "customer/registration", qs.stringify(postObject)).then(function (response) {
								$("#loadIcon").hide();
								$(".gue-comm-error").hide();
								if (response.data.status === "ok") {
	
									_this7.setState({ guestFields: { "guest-name": "", "guest-email": "", "guest-mobile": "", "guest-password": "", "guest-retype-password": "" } });
									$(".guest-success").show();
									$(".success-msg-p").html(response.data.message);
								} else {
									if (typeof response.data.form_error !== "undefined") {
										$(".guest-form-error").show();
										$(".guest-form-error").html(response.data.form_error);
										$(".guest-form-error p").addClass("error-msg");
									} else {
										$(".guest-form-error").show();
										$(".guest-form-error-p").html(response.data.message);
									}
								}
								return false;
							}).catch(function (error) {
								console.log(error);
							});
						} else if (guestType === 0) {
	
							var qs = __webpack_require__(3);
							var postObject = {
								"app_id": APPID,
								"type": "web",
								"customer_first_name": this.state.guestFields['guest-name'],
								"customer_last_name": "",
								"customer_email": this.state.guestFields['guest-email'],
								"customer_password": this.state.guestFields['guest-password'],
								"customer_phone": this.state.guestFields['guest-mobile'],
								"customer_member_id": APPID === MemberAppID || APPID === MemberAppIDSCC || APPID === MemberAppIDGour ? this.state.guestFields['guest-membershipid'] : '',
								"search_type": APPID === MemberAppID || APPID === MemberAppIDSCC || APPID === MemberAppIDGour ? 'MemberID' : 'Mobile',
								"accepted_coupons": accepted_coupons,
								"site_url": this.state.client_site_url + "#/",
								"is_temp_user": _reactCookie2.default.load("isTempUser")
							};
							_axios2.default.post(APIURLV2 + "GusestAccount/create", qs.stringify(postObject)).then(function (response) {
								$("#loadIcon").hide();
								$(".gue-comm-error").hide();
								if (response.data.status === "ok") {
	
									if (parseInt(response.data.gusetStatus) === 1) {
										_this7.setGuestData(response);
									} else if (parseInt(response.data.gusetStatus) === 2) {
										_this7.setGuestData(response);
									} else if (parseInt(response.data.gusetStatus) === 3) {
										_this7.setGuestData(response, '', 1);
									}
									_this7.closeGuestToggle();
								} else {
									if (typeof response.data.form_error !== "undefined") {
										$(".guest-form-error").show();
										$(".guest-form-error").html(response.data.form_error);
										$(".guest-form-error p").addClass("error-msg");
									} else {
										$(".guest-form-error").show();
										$(".guest-form-error-p").html(response.data.message);
									}
									if (typeof response.data.email_missmatch_error !== "undefined") {
										_this7.setState({ email_missmatch_error: response.data.email_missmatch_error });
										_this7.setState({ email_missmatch_error_count: parseInt(parseInt(_this7.state.email_missmatch_error_count) + 1) });
									} else {
										_this7.setState({ email_missmatch_error_count: 0, email_missmatch_error: '' });
									}
								}
								return false;
							}).catch(function (error) {
								console.log(error);
							});
						}
					}
				} else {
					console.log("Form has errors.");
				}
			}
		}, {
			key: 'setGuestData',
			value: function setGuestData(response) {
				var _this8 = this;
	
				var isAnonymousUser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
				var isTempUser = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
				var mobileno = '';
				if (response.data.result_set.customer_phone !== "" || response.data.result_set.customer_phone !== null || typeof response.data.result_set.customer_phone !== "undefined") {
					mobileno = response.data.result_set.customer_phone;
				}
	
				/* set User cookie values - Start */
				_reactCookie2.default.save("UserId", response.data.result_set.customer_id);
				_reactCookie2.default.save("UserFname", response.data.result_set.customer_first_name !== "" ? response.data.result_set.customer_first_name : '');
				_reactCookie2.default.save("UserLname", response.data.result_set.customer_last_name != "" ? response.data.result_set.customer_last_name : '');
				_reactCookie2.default.save("UserMobile", mobileno);
				_reactCookie2.default.save("userAccountType", response.data.result_set.customer_account_type);
				_reactCookie2.default.save("UserEmail", response.data.result_set.customer_email);
				/*cookie.save("UserDefaultAddress",response.data.result_set.customer_address_name);
	   cookie.save("UserDefaultUnitOne",response.data.result_set.customer_address_line1);
	   cookie.save("UserDefaultPostalCode",response.data.result_set.customer_postal_code); */
				_reactCookie2.default.save("UserDefaultUnitTwo", response.data.result_set.customer_address_line2);
				/* set User cookie values - End */
	
				if (isAnonymousUser) {
					_reactCookie2.default.save("isAnonymousUser", 1);
				} else {
					_reactCookie2.default.save("isAnonymousUser", 0);
				}
	
				if (isTempUser) {
					_reactCookie2.default.save("isTempUser", 1);
				} else {
					_reactCookie2.default.save("isTempUser", 0);
				}
	
				/* set redirection */
	
				/* upadte customer info */
				var qs = __webpack_require__(3);
				var postObject = {
					"app_id": APPID,
					"reference_id": (0, _Api2.default)('referenceId'),
					"customer_id": response.data.result_set.customer_id,
					"availability_id": _reactCookie2.default.load('defaultAvilablityId')
				};
	
				_axios2.default.post(APIURL + "cart/update_customer_info", qs.stringify(postObject)).then(function (res) {
					if (res.data.status === "ok" && _reactCookie2.default.load('reserVationClick') !== 'fromhome') {
	
						/* check FB login function */
						_reactCookie2.default.save('cartValue', 'Yes');
						if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId) {
							if (APPID === "287E5552-328E-4DBE-A3CA-E998ACCAC9BD") {
								helper.sarveshTableSetup();
								// this.setStateLoading('ok'); 
							} else {
								_this8.setStateLoading('ok');
								if (typeof _reactCookie2.default.load("orderOutletId") !== "undefined" && _reactCookie2.default.load("orderOutletId") !== "" && typeof _reactCookie2.default.load("orderTableNo") !== "undefined" && _reactCookie2.default.load("orderTableNo") !== "") {
									_reactRouter.hashHistory.push("/checkout");
								} else {
									_reactRouter.hashHistory.push("/book-a-table");
								}
							}
						} else {
							_this8.setStateLoading('ok');
							document.getElementById("loadIcon").style.display = "none";
							_reactRouter.hashHistory.push("/delivery-date");
						}
					} else {
						if (_reactCookie2.default.load('reserVationClick') === 'fromhome') {
							_reactRouter.hashHistory.push("/");
							_reactCookie2.default.save('reserVationClick', 'fromlogin');
						} else if (_reactCookie2.default.load('dineinClick') === 'yes' && _reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId) {
							if (APPID === "287E5552-328E-4DBE-A3CA-E998ACCAC9BD") {
								helper.sarveshTableSetup();
							} else {
								_this8.setStateLoading('ok');
								_reactRouter.hashHistory.push("/book-a-table");
							}
						} else {
	
							if (isAnonymousUser || isTempUser) {
								_reactRouter.hashHistory.push("/");
							} else {
								_reactCookie2.default.remove("isTempUser");
								_reactRouter.hashHistory.push("/my-account");
							}
							_reactCookie2.default.save('cartValue', 'No');
						}
					}
				});
			}
		}, {
			key: 'closeGuestToggle',
			value: function closeGuestToggle() {
				$("#GuestCheckout").modal("toggle");
			}
		}, {
			key: 'closeGuestCheckoutToggle',
			value: function closeGuestCheckoutToggle() {
				$("#GuestCheckout").modal("toggle");
				_reactRouter.hashHistory.push("/");
			}
		}, {
			key: 'guestFormChange',
			value: function guestFormChange(field, e) {
				var guestFields = this.state.guestFields;
				guestFields[field] = e.target.value;
				this.setState({ guestFields: guestFields, guestErrors: {} });
				if (APPID === MemberAppID || APPID === MemberAppIDSCC || APPID === MemberAppIDGour) {
					if (field === "guest-membershipid") {
						var mobileNo = e.target.value;
						if (mobileNo.length >= 5) {
							//this.validateCustomer(mobileNo);
						}
					}
				} else {
					if (field === "guest-mobile") {
						var mobileNo = e.target.value;
						if (mobileNo.length >= 7) {
							//this.validateCustomer(mobileNo);
						}
						document.getElementById("otp_error_msg").innerHTML = '';
					}
				}
			}
		}, {
			key: 'guestFormChangeCheckBox',
			value: function guestFormChangeCheckBox(field, e) {
				var guestFields = this.state.guestFields;
				var ID = e.target.id;
				console.log(ID);
				var value = '';
				if ($('#' + ID).is(":checked")) {
					value = 1;
				} else {
					value = 0;
				}
				guestFields[field] = value;
				this.setState({ guestFields: guestFields, guestErrors: {} });
			}
		}, {
			key: 'validateCustomer',
			value: function validateCustomer(mobileNo) {
				var _this9 = this;
	
				var mobileNumber = mobileNo;
				var searchData = "";
				if (APPID === MemberAppID || APPID === MemberAppIDSCC || APPID === MemberAppIDGour) {
					searchData = "search_type=MemberID&member_id=" + mobileNumber;
				} else {
					searchData = "search_type=Mobile&phone_no=" + mobileNumber;
				}
	
				$("#loadIcon").show();
				_axios2.default.get(APIURL + 'settings/get_customerdetail_phone/?app_id=' + APPID + "&status=A&" + searchData).then(function (res) {
					$("#loadIcon").hide();
					if (res.data.status === "ok") {
						var firstName = res.data.result_set.customer_first_name;
						var email = res.data.result_set.customer_email;
						var mobileNumber = res.data.result_set.customer_phone;
						var customer_member_id = res.data.result_set.customer_member_id;
						var acceptedCoupons = res.data.result_set.accepted_coupons;
						$(".is-exist").removeClass("is-empty");
						$(".is-exist").addClass("is-focused");
						var MobileNumbers = "";
						if (APPID === MemberAppID || APPID === MemberAppIDSCC || APPID === MemberAppIDGour) {
							MobileNumbers = mobileNumber;
						} else {
							MobileNumbers = _this9.state.guestFields['guest-mobile'];
						}
						_this9.setState({ "backtoGuestform": false, guestFields: { "guest-name": firstName, "guest-email": email, "guest-mobile": MobileNumbers, "guest-membershipid": customer_member_id, "guest-password": _this9.state.guestFields['guest-password'], "guest-retype-password": _this9.state.guestFields['guest-retype-password'], 'guest-accepted-coupons': acceptedCoupons }, invalidMemberID: false, accepted_coupons: acceptedCoupons });
						var company_otp_verification = _reactCookie2.default.load('client_otp_verification_enable');
						if (company_otp_verification === '1') {
							_this9.setState({ "check_new_user": 1 });
							_this9.sendOtpToCustomer();
						}
	
						_reactCookie2.default.save('check_new_user', 1);
					} else {
						// console.log(this.state.guestFields);
						if (APPID === MemberAppID || APPID === MemberAppIDSCC || APPID === MemberAppIDGour) {
							_this9.setState({ "backtoGuestform": false, "check_new_user": 0, guestFields: { "guest-name": "", "guest-email": "", "guest-mobile": _this9.state.guestFields['guest-mobile'], 'guest-membershipid': mobileNo } });
						} else {
							_this9.setState({ "backtoGuestform": false, "check_new_user": 0, guestFields: { "guest-name": "", "guest-email": "", "guest-mobile": _this9.state.guestFields['guest-mobile'] } });
						}
						_reactCookie2.default.save('check_new_user', 0);
						/* $(".is-exist").addClass("is-empty");	
	                    $(".is-exist").removeClass("is-focused");				 
	                     this.setState({ guestFields : { "guest-mobile" : this.state.guestFields['guest-mobile'] , "guest-password" : this.state.guestFields['guest-password'], "guest-retype-password" : this.state.guestFields['guest-retype-password']}   });*/
					}
				});
			}
	
			/* guest form - that's it */
	
		}, {
			key: 'setStateLoading',
			value: function setStateLoading(sts) {
				this.setState({ status: sts });
			}
		}, {
			key: 'submit_otp_verification',
			value: function submit_otp_verification() {
				var _this10 = this;
	
				var customer_otp_val = this.state.customer_otp_val;
				var accepted_coupons = 0;
				if (this.state.guestFields['guest-accepted-coupons'] !== "" && typeof this.state.guestFields['guest-accepted-coupons'] !== "undefined" && _typeof(this.state.guestFields['guest-accepted-coupons']) !== undefined) {
					accepted_coupons = this.state.guestFields['guest-accepted-coupons'];
				}
				if (customer_otp_val != "" && customer_otp_val != undefined) {
	
					var qs = __webpack_require__(3);
					var postObject = { "app_id": APPID, "customer_otp_val": customer_otp_val, "customer_email_id": this.state.guestFields['guest-email'], "verify_type": "register" };
	
					_axios2.default.post(APIURL + "customer/customer_otp_verification", qs.stringify(postObject)).then(function (response) {
	
						if (response.data.status === "ok") {
	
							var guestType = parseInt(_this10.state.guest_type);
	
							if (guestType === 1) {
	
								var qs = __webpack_require__(3);
								var postObject = {
									"app_id": APPID,
									"type": "web",
									"customer_first_name": _this10.state.guestFields['guest-name'],
									"customer_last_name": "",
									"customer_email": _this10.state.guestFields['guest-email'],
									"customer_password": _this10.state.guestFields['guest-password'],
									"customer_phone": _this10.state.guestFields['guest-mobile'],
									"accepted_coupons": accepted_coupons,
									"site_url": _this10.state.client_site_url + "#/"
								};
								_axios2.default.post(APIURL + "customer/registration", qs.stringify(postObject)).then(function (response) {
									$("#loadIcon").hide();
									$(".gue-comm-error").hide();
									if (response.data.status === "ok") {
	
										_this10.setState({ guestFields: { "guest-name": "", "guest-email": "", "guest-mobile": "", "guest-password": "", "guest-retype-password": "" } });
										$(".guest-success").show();
										$(".success-msg-p").html(response.data.message);
									} else {
										if (typeof response.data.form_error !== "undefined") {
											$(".guest-form-error").show();
											$(".guest-form-error").html(response.data.form_error);
											$(".guest-form-error p").addClass("error-msg");
										} else {
											$(".guest-form-error").show();
											$(".guest-form-error-p").html(response.data.message);
										}
									}
									return false;
								}).catch(function (error) {
									console.log(error);
								});
							} else if (guestType === 0) {
	
								var qs = __webpack_require__(3);
								var postObject = {
									"app_id": APPID,
									"type": "web",
									"customer_first_name": _this10.state.guestFields['guest-name'],
									"customer_last_name": "",
									"customer_email": _this10.state.guestFields['guest-email'],
									"customer_password": _this10.state.guestFields['guest-password'],
									"customer_phone": _this10.state.guestFields['guest-mobile'],
									"site_url": _this10.state.client_site_url + "#/",
									"customer_member_id": APPID === MemberAppID || APPID === MemberAppIDSCC || APPID === MemberAppIDGour ? _this10.state.guestFields['guest-membershipid'] : '',
									"search_type": APPID === MemberAppID || APPID === MemberAppIDSCC || APPID === MemberAppIDGour ? 'MemberID' : 'Mobile',
									"accepted_coupons": accepted_coupons
								};
								_axios2.default.post(APIURL + "GusestAccount/create", qs.stringify(postObject)).then(function (response) {
									$("#loadIcon").hide();
									$(".gue-comm-error").hide();
									if (response.data.status === "ok") {
	
										if (parseInt(response.data.gusetStatus) === 1) {
											_this10.setGuestData(response);
										} else if (parseInt(response.data.gusetStatus) === 2) {
											_this10.setGuestData(response);
										}
										_this10.closeGuestToggle();
									} else {
										if (typeof response.data.form_error !== "undefined") {
											$(".guest-form-error").show();
											$(".guest-form-error").html(response.data.form_error);
											$(".guest-form-error p").addClass("error-msg");
										} else {
											$(".guest-form-error").show();
											$(".guest-form-error-p").html(response.data.message);
										}
									}
									return false;
								}).catch(function (error) {
									console.log(error);
								});
							}
						} else {
							document.getElementById("spn-otp-error").innerHTML = '<span class="spn-error">' + response.data.message + '</span>';
						}
					});
				}
			}
		}, {
			key: 'handleResendotp',
			value: function handleResendotp() {
	
				var qs = __webpack_require__(3);
				var postObject = { "app_id": APPID, "customer_email": this.state.guestFields['guest-email'], "customer_mobile": this.state.guestFields['guest-mobile'], "customer_first_name": this.state.guestFields['guest-name'], "customer_last_name": "" };
	
				document.getElementById("loadIcon").style.display = "block";
	
				_axios2.default.post(_constants.API_v4_URL + "customer/resend_otp", qs.stringify(postObject)).then(function (response) {
					if (response.data.status === "ok") {
						document.getElementById("loadIcon").style.display = "none";
						document.getElementById("resend_otp_button").style.display = "none";
						helper.showInfo(response.data.message);
					} else {
						document.getElementById("loadIcon").style.display = "none";
						document.getElementById("spn-otp-verified-error").innerHTML = '<span class="spn-error">' + response.data.message + '</span>';
						setTimeout(function () {
							document.getElementById("spn-otp-verified-error").innerHTML = '';
						}, 3000);
					}
				});
			}
		}, {
			key: 'backto_login',
			value: function backto_login() {
				this.setState({ guestFields: { "guest-mobile": "", "guest-name": "", "guest-email": "", "guest-cemail": "" }, check_new_user: 0 });
				document.getElementById("gust_checkout_form").style.display = "block";
				document.getElementById("otp_verification_option").style.display = "none";
				document.getElementById("resend_otp_button").style.display = "block";
			}
		}, {
			key: 'backToOtpScreen',
			value: function backToOtpScreen() {
				document.getElementById("gust_checkout_form").style.display = "none";
				document.getElementById("otp_verification_option").style.display = "block";
				document.getElementById("resend_otp_button").style.display = "none";
			}
	
			/* login button color */
	
		}, {
			key: 'loginButtonColr',
			value: function loginButtonColr() {
				return APPID === apps.workspace ? "signin-new" : "signin-new sign_btn";
			}
		}, {
			key: 'render',
			value: function render() {
				var _this11 = this;
	
				// alert(this.state.fbId);
				var _props = this.props,
				    fields = _props.fields,
				    onChange = _props.onChange,
				    onValid = _props.onValid,
				    onInvalid = _props.onInvalid,
				    $field = _props.$field,
				    $validation = _props.$validation;
	
				var errMsgEmail = void 0,
				    errMsgPassword = void 0;
				if ($validation.email.error.reason !== undefined) {
					errMsgEmail = $validation.email.show && _react2.default.createElement(
						'span',
						{ className: 'spn-error' },
						$validation.email.error.reason
					);
				}
				if ($validation.password.error.reason !== undefined) {
					errMsgPassword = $validation.password.show && _react2.default.createElement(
						'span',
						{ className: 'spn-error' },
						$validation.password.error.reason
					);
				}
				if (this.state.renderLoading === "ok") {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_reactDocumentMeta2.default, meta),
						_react2.default.createElement(
							'div',
							{ id: 'loadIcon', style: { display: 'none', bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto', zIndex: 9999, background: 'rgba(255, 255, 255, 0.8)' } },
							' ',
							_react2.default.createElement('img', { style: { bottom: 0, left: 0, position: 'absolute', right: 0, top: 0, margin: 'auto' }, src: '/img/loader.gif', alt: 'Loading' }),
							' '
						),
						_react2.default.createElement(
							'div',
							{ className: 'background_color' },
							_react2.default.createElement(
								'div',
								{ className: 'container-fluid desktop-container ninja-theme-v2', style: { minHeight: this.state.windowHeight } },
								_react2.default.createElement(Alert, null),
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-12 top-nav inner-top-nav' },
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-3 nav-head pd-l-20' },
											' ',
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: "/" },
												_react2.default.createElement('img', { src: '/img/icons/arrow-right.png', alt: 'left-arrow', className: 'icon-img-small-3' })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-6 nav-head ' },
											_react2.default.createElement(
												'h1',
												{ className: 'main-title' },
												'LOGIN'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-3 nav-head pd-l-20' },
											' ',
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: "/" },
												_react2.default.createElement('img', { src: '/img/icons/shopping-cart.png', alt: 'cart', className: 'icon-img-small-4-inner cart-icon pull-right' })
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'row login-container', id: 'signin-form' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-offset-1 col-xs-10 col-xs-offset-1' },
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: 'col-xs-12' },
												this.showGusetCheckout(),
												this.showAnonymousCheckout(),
												APPID !== "782D2401-5C31-43E9-83CF-B3AB5A394E66" && APPID !== MemberAppID && APPID !== MemberAppIDSCC && APPID !== MemberAppIDGour && _react2.default.createElement(
													'div',
													{ className: 'row row-facebook-login hidden' },
													_react2.default.createElement('div', { id: 'form-error' }),
													_react2.default.createElement(
														'div',
														{ className: 'col-xs-12' },
														_react2.default.createElement(_reactFacebookLogin2.default, {
	
															appId: this.state.fbId,
	
															fields: 'name,email,picture,first_name,last_name,birthday,gender',
															callback: this.responseFacebook,
															scope: 'public_profile,email,user_birthday',
															cssClass: 'btn btn-raised btn-info login-with-facebook',
															redirectUri: config.path.baseUrl + "sign-in",
															icon: 'fa-facebook',
															textButton: '\xA0 Login with Facebook'
														})
													)
												),
												APPID !== MemberAppID && APPID !== MemberAppIDSCC && APPID !== MemberAppIDGour && _react2.default.createElement(
													'div',
													{ className: 'row  login-screen' },
													APPID !== "782D2401-5C31-43E9-83CF-B3AB5A394E66" && _react2.default.createElement(
														'h1',
														null,
														'Sign In'
													),
													_react2.default.createElement(
														'form',
														{ action: true, method: true },
														_react2.default.createElement(
															'div',
															{ className: 'row' },
															_react2.default.createElement(
																'div',
																{ className: ' item-add2' },
																APPID !== "782D2401-5C31-43E9-83CF-B3AB5A394E66" && _react2.default.createElement(
																	'div',
																	null,
																	_react2.default.createElement(
																		'div',
																		{ className: 'form-group label-floating is-empty card-no' },
																		_react2.default.createElement(
																			'div',
																			{ className: 'input-group' },
																			_react2.default.createElement(
																				'label',
																				{ className: 'control-label', htmlFor: 'email' },
																				'Email Address'
																			),
																			_react2.default.createElement('input', Object.assign({ type: 'text', id: 'email', className: 'form-control', value: fields.email }, $field('email', function (e) {
																				return onChange('email', e.target.value);
																			}))),
																			errMsgEmail
																		)
																	),
																	_react2.default.createElement(
																		'div',
																		{ className: 'form-group  label-floating is-empty card-no' },
																		_react2.default.createElement(
																			'div',
																			{ className: 'input-group' },
																			_react2.default.createElement(
																				'label',
																				{ className: 'control-label', htmlFor: 'password' },
																				'Password'
																			),
																			_react2.default.createElement('input', Object.assign({ type: 'password', id: 'password', className: 'form-control', value: fields.password }, $field('password', function (e) {
																				return onChange('password', e.target.value);
																			}))),
																			errMsgPassword
																		)
																	),
																	_react2.default.createElement(
																		_reactRouter.Link,
																		{ className: 'forget-password-link pull-left', to: "/forgot-password" },
																		'Forgot Your Password?'
																	)
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'row' },
																	_react2.default.createElement(
																		'div',
																		{ className: 'col-xs-12 col-sm-8 col-sm-offset-2 text-center font-weight-400' },
																		APPID !== "782D2401-5C31-43E9-83CF-B3AB5A394E66" && _react2.default.createElement(
																			'button',
																			{ type: 'submit', className: this.loginButtonColr(), onClick: function onClick(e) {
																					e.preventDefault();_this11.props.$submit(onValid, onInvalid);
																				} },
																			' GO '
																		),
																		_react2.default.createElement(
																			_reactRouter.Link,
																			{ className: 'signup-link', to: "/sign-up" },
																			'Create Account'
																		)
																	)
																)
															)
														)
													)
												)
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'new-user-reg' },
									_react2.default.createElement(
										'form',
										{ action: true, method: true },
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: ' item-add2' },
												_react2.default.createElement('div', { className: 'space-10' }),
												_react2.default.createElement(
													'p',
													{ className: 'text-center' },
													'Please enter your name and email address to receive receipt '
												),
												_react2.default.createElement(
													'div',
													{ className: 'form-group label-floating is-empty card-no' },
													_react2.default.createElement(
														'div',
														{ className: 'input-group' },
														_react2.default.createElement(
															'label',
															{ className: 'control-label', htmlFor: 'name' },
															'Name'
														),
														_react2.default.createElement('input', { id: 'name', className: 'form-control', type: 'text' })
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'form-group label-floating is-empty card-no' },
													_react2.default.createElement(
														'div',
														{ className: 'input-group' },
														_react2.default.createElement(
															'label',
															{ className: 'control-label', htmlFor: 'emailaddress' },
															'Email Address'
														),
														_react2.default.createElement('input', { id: 'emailaddress', className: 'form-control', type: 'Text' })
													)
												)
											)
										)
									),
									_react2.default.createElement('div', { className: 'space-50' }),
									_react2.default.createElement('div', { className: 'space-10' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal ninja-theme-v2', id: 'GuestCheckout' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										APPID === MemberAppID || APPID === MemberAppIDSCC || APPID === MemberAppIDGour ? _react2.default.createElement(
											_reactRouter.Link,
											{ onClick: this.closeGuestCheckoutToggle.bind(this) },
											_react2.default.createElement(
												'button',
												{ type: 'button', className: 'close' },
												_react2.default.createElement('img', { src: '/img/icons/close_popup.png', className: 'img-responsive', alt: 'close' })
											)
										) : _react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/close_popup.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/user-white.png', alt: 'guest-checkout', className: 'icon-img-guest-checkout' }),
											APPID === "B401FC82-8E39-4076-838A-55192F765004" || APPID === "6C0280A0-B655-4E0F-A43F-041C189683BA" || APPID === "B93EC9A9-1A67-4EBA-ADB7-BC7C14FA88A4" ? 'Member Login' : 'Guest Checkout'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'div',
											{ className: 'guest-checkout-form' },
											_react2.default.createElement(
												'div',
												{ className: 'alert-success guest-success gue-comm-error', style: { display: "none" } },
												_react2.default.createElement(
													'p',
													{ className: 'success-msg success-msg-p  ' },
													' Guest account created successfully'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'alert-error guest-form-error gue-comm-error', style: { display: "none" } },
												_react2.default.createElement('p', { className: 'error-msg guest-form-error-p' })
											),
											_react2.default.createElement(
												'div',
												{ className: 'gust_checkout_form', id: 'gust_checkout_form' },
												_react2.default.createElement(
													'form',
													{ action: true, method: true },
													(APPID === MemberAppID || APPID === MemberAppIDSCC || APPID === MemberAppIDGour) && _react2.default.createElement(
														'div',
														null,
														_react2.default.createElement(
															'div',
															{ className: 'form-group label-floating is-empty card-no' },
															_react2.default.createElement(
																'div',
																{ className: 'input-group' },
																_react2.default.createElement(
																	'label',
																	{ className: 'control-label' },
																	'Membership #'
																),
																_react2.default.createElement('input', { id: 'guest-membershipid', type: 'text', ref: 'guest-membershipid', name: 'guest-membershipid', onChange: this.guestFormChange.bind(this, "guest-membershipid"), value: this.state.guestFields["guest-membershipid"], className: 'form-control' })
															)
														),
														_react2.default.createElement(
															'span',
															{ className: 'help-text guest-error' },
															this.state.guestErrors["guest-membershipid"]
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'form-group label-floating is-empty card-no is-exist' },
														_react2.default.createElement(
															'div',
															{ className: 'input-group' },
															_react2.default.createElement(
																'label',
																{ className: 'control-label' },
																'Mobile'
															),
															_react2.default.createElement('input', { id: 'guest-mobile', type: 'text', ref: 'guest-mobile', maxLength: '8', name: 'guest-mobile', onChange: this.guestFormChange.bind(this, "guest-mobile"), value: this.state.guestFields["guest-mobile"], className: 'form-control' })
														)
													),
													_react2.default.createElement(
														'span',
														{ className: 'help-text' },
														'(Used to contact you regarding your order)'
													),
													_react2.default.createElement(
														'span',
														{ className: 'help-text guest-error' },
														this.state.guestErrors["guest-mobile"]
													),
													_react2.default.createElement(
														'div',
														{ className: 'form-group label-floating is-empty card-no is-exist' },
														_react2.default.createElement(
															'div',
															{ className: 'input-group' },
															_react2.default.createElement(
																'label',
																{ className: 'control-label' },
																'Name'
															),
															_react2.default.createElement('input', { id: 'guest-name', name: 'guest-name', onChange: this.guestFormChange.bind(this, "guest-name"), value: this.state.check_new_user === 0 ? this.state.guestFields["guest-name"] : "", className: 'form-control', type: 'text', maxLength: '20' })
														)
													),
													_react2.default.createElement(
														'span',
														{ className: 'help-text guest-error' },
														this.state.guestErrors["guest-name"]
													),
													_react2.default.createElement('div', { id: 'otp_error_msg' }),
													_react2.default.createElement(
														'div',
														{ className: 'form-group label-floating is-empty card-no is-exist' },
														_react2.default.createElement(
															'div',
															{ className: 'input-group' },
															_react2.default.createElement(
																'label',
																{ className: 'control-label' },
																'Email'
															),
															_react2.default.createElement('input', { id: 'guest-email', className: 'form-control', type: 'text', name: 'guest-email', onChange: this.guestFormChange.bind(this, "guest-email"), value: this.state.check_new_user === 0 ? this.state.guestFields["guest-email"] : "" })
														)
													),
													_react2.default.createElement(
														'span',
														{ className: 'help-text' },
														'(Used to send you a receipt of your order)'
													),
													_react2.default.createElement(
														'span',
														{ className: 'help-text guest-error' },
														this.state.guestErrors["guest-email"]
													),
													this.state.email_missmatch_error !== "" && this.state.email_missmatch_error_count > 2 && _react2.default.createElement(
														'span',
														{ className: 'help-text guest-error' },
														'Your Email : ',
														this.state.email_missmatch_error
													),
													_react2.default.createElement(
														'div',
														{ className: 'form-group label-floating is-empty card-no enable-guest' },
														_react2.default.createElement(
															'div',
															{ className: 'input-group' },
															_react2.default.createElement(
																'label',
																{ className: 'control-label' },
																'Password'
															),
															_react2.default.createElement('input', { id: 'guest-password', className: 'form-control', type: 'password', name: 'guest-password', onChange: this.guestFormChange.bind(this, "guest-password"), value: this.state.guestFields["guest-password"] })
														)
													),
													_react2.default.createElement(
														'span',
														{ className: 'help-text guest-error enable-guest' },
														this.state.guestErrors["guest-password"]
													),
													_react2.default.createElement(
														'div',
														{ className: 'form-group label-floating is-empty card-no enable-guest' },
														_react2.default.createElement(
															'div',
															{ className: 'input-group' },
															_react2.default.createElement(
																'label',
																{ className: 'control-label' },
																'Retype Password'
															),
															_react2.default.createElement('input', { id: 'guest-retype-password', className: 'form-control', type: 'password', name: 'guest-retype-password', onChange: this.guestFormChange.bind(this, "guest-retype-password"), value: this.state.guestFields["guest-retype-password"] }),
															_react2.default.createElement('input', { id: 'guest-type', type: 'hidden', name: 'guest-type', value: this.state.guest_type })
														)
													),
													_react2.default.createElement(
														'span',
														{ className: 'help-text guest-error enable-guest' },
														this.state.guestErrors["guest-retype-password"]
													),
													(APPID === "2AE048E7-2D84-42BE-9BB5-22016FC4DFBC" || APPID === "44275190-B355-4486-8083-EE1C63607916" || APPID === "F34559CA-596A-4F2E-8547-17B2AEBB3326") && _react2.default.createElement(
														'div',
														{ className: 'checkbox_sign_ups' },
														_react2.default.createElement('input', { type: 'checkbox', id: 'guest-accepted-alcohol', name: 'guest-accepted-alcohol', onChange: this.guestFormChangeCheckBox.bind(this, "guest-accepted-alcohol") }),
														console.log(this.state.guestFields),
														_react2.default.createElement(
															'p',
															null,
															'You agree that you are of legal age to purchase and consume alcohol in the locale in which the alcohol is delivered and acknowledge and agree to provide valid government-issued identification upon delivery'
														),
														this.state.guestErrors["guest-accepted-alcohol"] !== "" && _typeof(this.state.guestErrors["guest-accepted-alcohol"]) !== undefined && typeof this.state.guestErrors["guest-accepted-alcohol"] !== "undefined" && _react2.default.createElement(
															'span',
															{ className: 'help-text guest-error', style: { marginLeft: '0px' } },
															this.state.guestErrors["guest-accepted-alcohol"]
														)
													),
													APPID !== "B401FC82-8E39-4076-838A-55192F765004" && APPID !== "6C0280A0-B655-4E0F-A43F-041C189683BA" && APPID !== "B93EC9A9-1A67-4EBA-ADB7-BC7C14FA88A4" && _react2.default.createElement(
														'div',
														null,
														_react2.default.createElement(
															'div',
															{ className: 'checkbox_sign_ups' },
															_react2.default.createElement('input', { type: 'checkbox', id: 'guest-terms', name: 'guest-terms', value: '1', defaultChecked: true, disabled: 'disabled', onChange: this.guestFormChangeCheckBox.bind(this, "guest-terms") }),
															_react2.default.createElement(
																'p',
																null,
																'I agree to the Privacy Policy and Terms of Service of ',
																_reactCookie2.default.load('client_company_name')
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'checkbox_sign_ups' },
															_react2.default.createElement('input', { type: 'checkbox', id: 'guest-accepted-coupons', name: 'guest-accepted-coupons', onChange: this.guestFormChangeCheckBox.bind(this, "guest-accepted-coupons"), checked: this.state.guestFields["guest-accepted-coupons"] === "1" || this.state.guestFields["guest-accepted-coupons"] === 1 ? true : false, disabled: this.state.accepted_coupons === "1" ? true : false }),
															_react2.default.createElement(
																'p',
																null,
																'I consent to receive coupons and promotions news from ',
																_reactCookie2.default.load('client_company_name'),
																', its franchisees and affiliates, and understand and agree that my information will be for the above. '
															),
															_react2.default.createElement('div', { id: 'spn-accept-error' })
														)
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'col-xs-12 col-sm-12 create-account-block' },
													_react2.default.createElement(
														'p',
														null,
														'If you would like update your email address, please contact the outlet.'
													),
													this.state.backtoGuestform === true && _react2.default.createElement(
														_reactRouter.Link,
														{ className: 'set-password-account anchr-tag disable-guest ', onClick: this.backToOtpScreen.bind(this) },
														'Back to OTP Verification'
													),
													_react2.default.createElement(
														'button',
														{ type: 'button', onClick: this.applyValidation.bind(this), className: 'btn btn-raised btn-guest-account ' },
														'Proceed'
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'space-20', id: 'otp_verification_option', style: { display: 'none' } },
												_react2.default.createElement(
													'p',
													{ className: 'text-center font-bold font-size-18' },
													'OTP Verification'
												),
												_react2.default.createElement(
													'form',
													{ className: 'customer_otp', id: 'customer_otp', onSubmit: function onSubmit(e) {
															_this11.submit_otp_verification(_this11);e.preventDefault();
														} },
													_react2.default.createElement('div', { id: 'spn-otp-verified-error' }),
													_react2.default.createElement(
														'div',
														{ className: 'form-group label-floating card-no input-form-group' },
														_react2.default.createElement(
															'div',
															{ className: 'input-group' },
															_react2.default.createElement(
																'label',
																{ className: 'control-label' },
																'Enter your OTP',
																_react2.default.createElement(
																	'span',
																	null,
																	'*'
																)
															),
															_react2.default.createElement('input', { type: 'text', name: 'customer_otp_val', className: 'form-control', value: this.state.customer_otp_val, onChange: this.handleChangeTxt.bind(this, 'customer_otp_val') }),
															_react2.default.createElement('div', { id: 'spn-otp-error' })
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'text-center ' },
														_react2.default.createElement(
															'button',
															{ type: 'button', className: 'btn btn-raised btn-info full-width-btn-2 text-uppercase', onClick: this.submit_otp_verification.bind(this) },
															'Submit'
														)
													)
												),
												_react2.default.createElement(
													'a',
													{ className: 'resent_otp_gust', style: { cursor: "pointer" }, id: 'resend_otp_button', onClick: this.handleResendotp.bind(this) },
													_react2.default.createElement(
														'b',
														null,
														'Resent OTP'
													)
												),
												_react2.default.createElement('br', null),
												_react2.default.createElement(
													'a',
													{ className: 'back_to_register_gust', onClick: this.backto_login.bind(this) },
													_react2.default.createElement(
														'b',
														null,
														'Back to guest login'
													)
												)
											)
										)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						)
					);
				} else {
	
					return _react2.default.createElement(
						'div',
						{ className: 'container-fluid desktop-container position-rel' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(Loading, null)
						)
					);
				}
			}
		}]);
	
		return Form;
	}(_react2.default.Component);
	
	Form.contextTypes = {
		router: _react2.default.PropTypes.object.isRequired
	};
	
	Form = (0, _reactCustomValidation.validated)(validationConfig)(Form);
	
	exports.default = Signin;

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(9);
	
	var _immutabilityHelper = __webpack_require__(56);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _withTracker = __webpack_require__(11);
	
	var _validator = __webpack_require__(88);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _reactCustomValidation = __webpack_require__(57);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _ThemeProvider = __webpack_require__(84);
	
	var _ThemeProvider2 = _interopRequireDefault(_ThemeProvider);
	
	var _theme = __webpack_require__(89);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	__webpack_require__(71);
	
	var _DatePicker = __webpack_require__(85);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	//import 'react-date-picker/index.css';
	
	
	var Loading = __webpack_require__(17);
	var config = __webpack_require__(7);
	var lang = __webpack_require__(12);
	var APIURL = config.path.apiUrl;
	var APPID = config.ids.appId;
	
	var datetime = new Date(2015, 10, 16);
	
	var helper = __webpack_require__(13);
	helper.addBodyClass();
	/* Load meta tags */
	var meta = {
		title: lang.signup_meta_title,
		description: lang.signup_meta_title,
		meta: {
			name: {
				keywords: lang.signup_meta_title
			}
		}
	};
	
	var Signup = function (_React$Component) {
		_inherits(Signup, _React$Component);
	
		function Signup() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Signup);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Signup.__proto__ || Object.getPrototypeOf(Signup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
				fields: {
					firstname: '',
					lastname: '',
					email: '',
					password: '',
					rePassword: '',
					mobile: '',
					company: '',
					settings: '',
					portmakan_company: '',
					customer_otp_val: '',
					terms: 1,
					accepted_coupons: '',
					accepted_alcohol: '',
					accepted_terms_cond: 0
				},
				status: 'Loading'
				/*add class */
	
			}, _this.fieldChange = function (field, value) {
				if (field == 'accepted_alcohol' && APPID === "2AE048E7-2D84-42BE-9BB5-22016FC4DFBC" && APPID === "F34559CA-596A-4F2E-8547-17B2AEBB3326") {
					value = $("#accepted_alcohol").prop("checked");
				}
				if (field == 'terms') {
					value = $("#terms").prop("checked");
				}
				if (field == 'accepted_coupons') {
					value = $("#accepted_coupons").prop("checked");
				}
				_this.setState((0, _immutabilityHelper2.default)(_this.state, { fields: _defineProperty({}, field, { $set: value }) }));
	
				if (field === "portmakan_company" && value != '') {
					document.getElementById("spn-portmakan_company-error").innerHTML = '';
				} else if (field === "portmakan_company" && value == '') {
					document.getElementById("spn-portmakan_company-error").innerHTML = '<span class="spn-error">Select your company</span>';
				}
			}, _this.handleFormSubmit = function () {
	
				var formPayload = _this.state.fields;
				/*  var des = document.getElementsByClassName('birthdate') 
	   var input = des[0].getElementsByTagName('input');
	   formPayload.birthday = input[0].value; 
	     formPayload.gender = document.getElementsByClassName("select-gender")[0].value;  */
	
				if (document.getElementById("spn-email-error").innerHTML === '<span class="spn-error">This email already exists</span>') {
					return false;
				}
				if (document.getElementById("spn-mobile-error").innerHTML === '<span class="spn-error">This mobile number already exists</span>') {
					return false;
				}
	
				if (APPID === "CD8D5FE3-0586-44DD-9360-EE9DEF351223" && formPayload.portmakan_company == '') {
					document.getElementById("spn-portmakan_company-error").innerHTML = '<span class="spn-error">Select your company</span>';
					return false;
				}
	
				/*var terms_condtions = document.getElementById("accepted_button");
	   if (terms_condtions.checked == true){
	   	document.getElementById("spn-accept-error").innerHTML = '';
	   } else {
	   	document.getElementById("spn-accept-error").innerHTML = '<span class="spn-error accedpted_error">Accept the terms of service and privacy policy</span>';
	   	setTimeout(function(){document.getElementById("spn-accept-error").innerHTML='' }, 3000);
	   	return false;
	   }*/
	
				var company_otp_verification = _this.state.settings.client_otp_verification_enable;
				var company_otp_via = _this.state.settings.client_otp_verification_via;
	
				document.getElementById("loadIcon").style.display = "block";
	
				if (company_otp_verification === '1') {
	
					var qs = __webpack_require__(3);
					var postObject = {
						"app_id": APPID,
						"customer_first_name": formPayload.firstname,
						"customer_last_name": formPayload.lastname,
						"customer_email": formPayload.email,
						"customer_phone": formPayload.mobile,
						"customer_otp_type": company_otp_via,
						"accepted_coupons": formPayload.accepted_coupons === true ? 1 : 0
					};
	
					_reactCookie2.default.save('customer_first_name', formPayload.firstname);
					_reactCookie2.default.save('customer_last_name', formPayload.lastname);
					_reactCookie2.default.save('customer_email', formPayload.email);
					_reactCookie2.default.save('customer_password', formPayload.password);
					_reactCookie2.default.save('customer_phone', formPayload.mobile);
					_reactCookie2.default.save('customer_portmakan_company', formPayload.portmakan_company);
	
					_axios2.default.post(APIURL + "customer/send_customer_otp", qs.stringify(postObject)).then(function (response) {
						if (response.data.status === "ok") {
							document.getElementById("otp_verification_option").style.display = "block";
							if (company_otp_via === '1') {
								helper.showInfo("OTP has been sent to your email id.");
							} else {
								helper.showInfo("OTP has been sent to your mobile number.");
							}
							document.getElementById("loadIcon").style.display = "none";
							document.getElementById("register_form_option").style.display = "none";
							//  return false;
						} else {
							_this.setStateLoading('error');
							document.getElementById("form-error").innerHTML = '<div class="box_error"><ul><li>' + response.data.message + '</li></ul></div>';
							document.getElementById("loadIcon").style.display = "none";
						}
						return false;
					});
				} else {
	
					/* narmal register */
	
					var qs = __webpack_require__(3);
					var postObject = {
						"app_id": APPID,
						"type": "web",
						"customer_first_name": formPayload.firstname,
						"customer_last_name": formPayload.lastname,
						"customer_email": formPayload.email,
						"customer_password": formPayload.password,
						"customer_phone": formPayload.mobile,
						"customer_portmakan_company": formPayload.portmakan_company,
						"customer_verification": "normal",
						"accepted_coupons": formPayload.accepted_coupons === true ? 1 : 0,
						/*  "customer_birthdate" : formPayload.birthday, 
	     'customer_company_name': formPayload.company, 
	     'customer_gender': formPayload.gender, */
						"site_url": _this.state.settings.client_site_url + "#/"
					};
	
					_axios2.default.post(APIURL + "customer/registration", qs.stringify(postObject)).then(function (response) {
						if (response.data.status === "ok") {
							_reactCookie2.default.remove("isTempUser");
							//this.setStateLoading('ok');
							//console.log(lang.signup_success);
							//cookie.save('alertSuccess',lang.signup_success);
							(0, _withTracker.fbPixelCustomEvent)("RegistrationCompleted", {});
	
							/** Skip reg process */
	
							if (typeof response.data.skip_registration !== "undefined" && response.data.skip_registration === true) {
	
								var mobileno = '';
								if (response.data.result_set.customer_phone !== "" || response.data.result_set.customer_phone !== null || typeof response.data.result_set.customer_phone !== "undefined") {
									mobileno = response.data.result_set.customer_phone;
								}
	
								/* set User cookie values - Start */
								_reactCookie2.default.save("UserId", response.data.result_set.customer_id);
								_reactCookie2.default.save("UserFname", response.data.result_set.customer_first_name !== "" ? response.data.result_set.customer_first_name : '');
								_reactCookie2.default.save("UserLname", response.data.result_set.customer_last_name != "" ? response.data.result_set.customer_last_name : '');
								_reactCookie2.default.save("UserMobile", mobileno);
								_reactCookie2.default.save("UserEmail", response.data.result_set.customer_email);
								_reactCookie2.default.save("UserDefaultAddress", response.data.result_set.customer_address_name);
								_reactCookie2.default.save("UserDefaultUnitOne", response.data.result_set.customer_address_line1);
								_reactCookie2.default.save("UserDefaultUnitTwo", response.data.result_set.customer_address_line2);
								_reactCookie2.default.save("UserDefaultPostalCode", response.data.result_set.customer_postal_code);
								/* set User cookie values - End */
	
								/* set redirection */
	
								/* upadte customer info */
								var qs = __webpack_require__(3);
								var postObject = {
									"app_id": APPID,
									"reference_id": (0, _Api2.default)('referenceId'),
									"customer_id": response.data.result_set.customer_id,
									"availability_id": _reactCookie2.default.load('defaultAvilablityId')
								};
	
								_axios2.default.post(APIURL + "cart/update_customer_info", qs.stringify(postObject)).then(function (res) {
									if (res.data.status === "ok" && _reactCookie2.default.load('reserVationClick') !== 'fromhome') {
	
										/* check FB login function */
										_reactCookie2.default.save('cartValue', 'Yes');
										if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId) {
											if (APPID === "287E5552-328E-4DBE-A3CA-E998ACCAC9BD") {
												helper.sarveshTableSetup();
												// this.setStateLoading('ok'); 
											} else {
												//this.setStateLoading('ok'); 
												if (typeof _reactCookie2.default.load("orderOutletId") !== "undefined" && _reactCookie2.default.load("orderOutletId") !== "" && typeof _reactCookie2.default.load("orderTableNo") !== "undefined" && _reactCookie2.default.load("orderTableNo") !== "") {
													_reactRouter.hashHistory.push("/checkout");
												} else {
	
													_reactRouter.hashHistory.push("/book-a-table");
												}
											}
										} else {
											//this.setStateLoading('ok'); 
											document.getElementById("loadIcon").style.display = "none";
											_reactRouter.hashHistory.push("/delivery-date");
										}
									} else {
										if (_reactCookie2.default.load('reserVationClick') === 'fromhome') {
											_reactRouter.hashHistory.push("/");
											_reactCookie2.default.save('reserVationClick', 'fromlogin');
										} else if (_reactCookie2.default.load('dineinClick') === 'yes' && _reactCookie2.default.load('defaultAvilablityId') === config.ids.dineinId) {
											if (APPID === "287E5552-328E-4DBE-A3CA-E998ACCAC9BD") {
												helper.sarveshTableSetup();
											} else {
												_this.setStateLoading('ok');
												_reactRouter.hashHistory.push("/book-a-table");
											}
										} else {
											//hashHistory.push("/my-account");
											_reactRouter.hashHistory.push("/");
											_reactCookie2.default.save('cartValue', 'No');
										}
									}
								});
	
								/*  if( cookie.load('cartValue') === "Yes"){  
	       		 if(cookie.load('defaultAvilablityId') === config.ids.dineinId){  console.log(2); 
	       				hashHistory.push("/book-a-table");
	       			   }
	         }else{
	        	hashHistory.push("/#/dashboard");
	         }   */
							}
	
							/** skip ref Process */
							else {
	
									helper.showInfo(lang.signup_success);
	
									_reactRouter.hashHistory.push("/sign-in");
								}
							//  $("#Register-Sucess").modal("toggle");
							//  return false;
						} else {
							_this.setStateLoading('error');
							if (response.data.form_error) {
								document.getElementById("form-error").innerHTML = '<div class="box_error"><ul><li>' + response.data.form_error + '</li></ul></div>';
								document.getElementById("loadIcon").style.display = "none";
							} else {
								document.getElementById("form-error").innerHTML = '<div class="box_error"><ul><li>' + response.data.message + '</li></ul></div>';
								document.getElementById("loadIcon").style.display = "none";
							}
						}
						return false;
					}).catch(function (error) {
						console.log(error);
					});
				}
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(Signup, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				this.setState({ status: 'ok' });
				var promise = (0, _Api2.default)('settings', '');
				promise.then(function (res) {
					_this2.setState({ settings: res.data.result_set });
					_reactCookie2.default.save('client_company_name', res.data.result_set.company_name);
					_reactCookie2.default.save('client_site_url', res.data.result_set.client_site_url);
				});
			}
		}, {
			key: 'setStateLoading',
			value: function setStateLoading(sts) {
				this.setState({ status: sts });
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this3 = this;
	
				var site_maintenance_verify = _reactCookie2.default.load("client_site_maintenance_verify") !== '' && _reactCookie2.default.load("client_site_maintenance_verify") !== 'undefined' && _reactCookie2.default.load("client_site_maintenance_verify") !== undefined ? _reactCookie2.default.load("client_site_maintenance_verify") : '';
	
				var site_maintenance_popup_open = _reactCookie2.default.load("site_maintenance_popup_open") !== '' && _reactCookie2.default.load("site_maintenance_popup_open") !== 'undefined' && _reactCookie2.default.load("site_maintenance_popup_open") !== undefined ? _reactCookie2.default.load("site_maintenance_popup_open") : '';
	
				if (site_maintenance_popup_open === "1" && (site_maintenance_verify === '' || site_maintenance_verify === '0')) {
					_reactRouter.hashHistory.push("/");
					return;
				}
	
				/* update settings values */
				var promise = (0, _Api2.default)('settings', '');
				promise.then(function (res) {
					_this3.setState({ settings: res.data.result_set });
					_reactCookie2.default.save('client_company_name', res.data.result_set.company_name);
					_reactCookie2.default.save('client_site_url', res.data.result_set.client_site_url);
				});
				(0, _withTracker.loadAnalytics)();
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.state.status === "Loading") {
					return _react2.default.createElement(Loading, null);
				} else {
					return _react2.default.createElement(Form, {
						fields: this.state.fields,
						onChange: this.fieldChange,
						onValid: this.handleFormSubmit,
						onInvalid: function onInvalid() {
							return console.log('Form invalid!');
						}
					});
				}
			}
		}]);
	
		return Signup;
	}(_react2.default.Component);
	
	var phonenumberPattern = /^[0-9]{6,14}$/;
	
	var isEmpty = function isEmpty(value) {
		return value === '' ? 'This field is required.' : null;
	};
	
	var isEmail = function isEmail(email) {
		return _validator2.default.isEmail(email) ? null : 'This is not a valid email.';
	};
	
	var isMobile = function isMobile(mobile) {
		return mobile.match(phonenumberPattern) ? null : 'This is not a valid mobile number.';
	};
	
	var isMobileDigt = function isMobileDigt(mobile) {
		return mobile.length === 8 ? null : 'This is not a valid mobile number.';
	};
	
	var isUnique = function isUnique(email) {
	
		var qs = __webpack_require__(3);
		var postObject = {
			"app_id": APPID,
			"type": "web",
			"customer_email": email
		};
		_axios2.default.post(APIURL + "customer/email_exist", qs.stringify(postObject)).then(function (response) {
			if (response.data.status === "ok") {
				document.getElementById("spn-email-error").innerHTML = '';
			} else {
				document.getElementById("spn-email-error").innerHTML = '<span class="spn-error">This email already exists</span>';
			}
		});
	};
	
	var isPhonenumerExist = function isPhonenumerExist(mobile) {
		var qs = __webpack_require__(3);
		var postObject = {
			"app_id": APPID,
			"type": "web",
			"customer_phone": mobile
		};
		_axios2.default.post(APIURL + "customer/phoneno_exist", qs.stringify(postObject)).then(function (response) {
			if (response.data.status === "ok") {
				document.getElementById("spn-mobile-error").innerHTML = '';
			} else {
				document.getElementById("spn-mobile-error").innerHTML = '<span class="spn-error">This mobile number already exists</span>';
			}
		});
	};
	
	var minLength = function minLength(password, length) {
		return password.length >= length ? null : 'This field must be at least 6 characters.';
	};
	
	var areSame = function areSame(password, rePassword) {
		return password === rePassword ? null : 'Passwords do not match.';
	};
	
	var acceptedAlcohol = function acceptedAlcohol(accepted_alcohol) {
		if (APPID === "2AE048E7-2D84-42BE-9BB5-22016FC4DFBC" || APPID === "F34559CA-596A-4F2E-8547-17B2AEBB3326") {
			if (accepted_alcohol) {
				return null;
			} else {
				return "This field is required.";
			}
		}
	};
	
	var isChecked = function isChecked(terms) {
		return terms ? null : "Please accept terms and conditions";
	};
	
	function validationConfig(props) {
		var _props$fields = props.fields,
		    firstname = _props$fields.firstname,
		    lastname = _props$fields.lastname,
		    email = _props$fields.email,
		    password = _props$fields.password,
		    rePassword = _props$fields.rePassword,
		    mobile = _props$fields.mobile,
		    accepted_alcohol = _props$fields.accepted_alcohol,
		    terms = _props$fields.terms,
		    accepted_coupons = _props$fields.accepted_coupons;
	
	
		return {
			fields: ['firstname', 'lastname', 'email', 'password', 'rePassword', 'mobile', 'accepted_alcohol', 'terms', 'accepted_coupons'],
	
			validations: {
				firstname: [[isEmpty, firstname]],
				lastname: [[isEmpty, lastname]],
				email: [[isEmail, email], [isUnique, email]],
				password: [[minLength, password, 6]],
				rePassword: {
					rules: [[areSame, password, rePassword]],
					fields: ['password', 'rePassword']
				},
				mobile: [[isEmpty, mobile], [isMobileDigt, mobile], [isMobile, mobile], [isPhonenumerExist, mobile]],
				accepted_alcohol: [[acceptedAlcohol, accepted_alcohol, 1]],
				terms: [[isChecked, terms, 1]]
			}
		};
	}
	
	var Form = function (_React$Component2) {
		_inherits(Form, _React$Component2);
	
		function Form(props) {
			_classCallCheck(this, Form);
	
			/* Declare state */
			var _this4 = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));
	
			_this4.state = { date2: datetime };
	
			_this4.handleChange = function (item, value) {
				_this4.setState(Object.assign({}, _this4.state, _defineProperty({}, item, value)));
				var des = document.getElementsByClassName('birthdate');
				var label = des[0].getElementsByTagName('label');
				label[0].style.top = '0px';
				label[0].style.fontSize = '10px';
			};
	
			_this4.handleChangeTxt = function (item, event) {
				_this4.setState(_defineProperty({}, item, event.target.value));
				/*var terms_condtions = document.getElementById("accepted_button");
	   if (terms_condtions.checked == true){
	   	cookie.save('accepted_terms_cond',1);
	     } else {
	   	cookie.save('accepted_terms_cond',0);
	     }*/
				_reactCookie2.default.save('accepted_terms_cond', 1);
				document.getElementById("spn-otp-error").innerHTML = '';
			};
	
			_this4.state = { windowHeightNormal: 0, windowHeight: 0 };
			return _this4;
		}
	
		_createClass(Form, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
	
				var windowHeight = window.innerHeight;
				this.setState({ 'windowHeight': windowHeight - 45 + 'px' });
				this.setState({ 'windowHeightNormal': windowHeight + 'px' });
	
				/*var select = document.getElementsByClassName('select-gender')[0];
	   select.style.background='none';
	   select.style.margin='0 0 0 6px';
	   select.style.fontWeight='bold';
	   select.style.fontSize='14px';
	   select.style.padding='8px 0 0 0';
	   document.getElementsByClassName('gender')[0].classList.remove("is-empty"); 
	   var des = document.getElementsByClassName('birthdate');
	   var fc = des[0].getElementsByTagName('div');
	   var se = fc[0].getElementsByTagName('div');
	   se[0].style.padding='0px';
	   var input = se[0].getElementsByTagName('input'); 
	   input[0].style.borderBottom='0px';
	   var label = se[0].getElementsByTagName('label');
	   label[0].style.top='6px'; */
				var list = document.getElementsByClassName('input-form-group');
				var n;
				for (n = 0; n < list.length; ++n) {
					if (list[n].getElementsByTagName('input')[0].value !== '') {
						list[n].classList.remove("is-empty");
					} else {
						list[n].classList.add("is-empty");
					}
				}
			}
		}, {
			key: 'refreshPage',
			value: function refreshPage() {
				//this.context.router.push('/sign-in');
				location.reload();
			}
		}, {
			key: 'submit_otp_verification',
			value: function submit_otp_verification() {
				var _this5 = this;
	
				var customer_otp_val = this.state.customer_otp_val;
	
				if (customer_otp_val != "" && customer_otp_val != undefined) {
	
					document.getElementById("loadIcon").style.display = "block";
	
					var qs = __webpack_require__(3);
					var postObject = { "app_id": APPID, "customer_otp_val": customer_otp_val, "customer_email_id": _reactCookie2.default.load('customer_email'), "verify_type": "register" };
	
					_axios2.default.post(APIURL + "customer/customer_otp_verification", qs.stringify(postObject)).then(function (response) {
						if (response.data.status === "ok") {
	
							//helper.showInfo(response.data.message);
	
							var qs = __webpack_require__(3);
							var postObject = {
								"app_id": APPID,
								"type": "web",
								"customer_first_name": _reactCookie2.default.load('customer_first_name'),
								"customer_last_name": _reactCookie2.default.load('customer_last_name'),
								"customer_email": _reactCookie2.default.load('customer_email'),
								"customer_password": _reactCookie2.default.load('customer_password'),
								"customer_phone": _reactCookie2.default.load('customer_phone'),
								"customer_portmakan_company": _reactCookie2.default.load('customer_portmakan_company'),
								"customer_verification": "otp",
								"site_url": _reactCookie2.default.load('client_site_url') + "#/"
							};
	
							_axios2.default.post(APIURL + "customer/registration", qs.stringify(postObject)).then(function (response) {
								if (response.data.status === "ok") {
									_reactCookie2.default.remove("isTempUser");
									helper.showInfo("Your account has been activated successfully." + "<br/>" + "Please login to continue");
									_reactCookie2.default.remove('customer_first_name');
									_reactCookie2.default.remove('customer_last_name');
									_reactCookie2.default.remove('customer_email');
									_reactCookie2.default.remove('customer_password');
									_reactCookie2.default.remove('customer_phone');
									_reactCookie2.default.remove('customer_portmakan_company');
									_reactCookie2.default.remove('client_site_url');
									_reactRouter.hashHistory.push("/sign-in");
									document.getElementById("loadIcon").style.display = "none";
								} else {
									_this5.setStateLoading('error');
									if (response.data.form_error) {
										document.getElementById("form-error").innerHTML = '<div class="box_error"><ul><li>' + response.data.form_error + '</li></ul></div>';
										document.getElementById("loadIcon").style.display = "none";
									} else {
										document.getElementById("form-error").innerHTML = '<div class="box_error"><ul><li>' + response.data.message + '</li></ul></div>';
										document.getElementById("loadIcon").style.display = "none";
									}
								}
								return false;
							}).catch(function (error) {
								console.log(error);
							});
						} else {
							document.getElementById("spn-otp-error").innerHTML = '<span class="spn-error">' + response.data.message + '</span>';
							document.getElementById("loadIcon").style.display = "none";
						}
					});
				} else {
					document.getElementById("spn-otp-error").innerHTML = '<span class="spn-error">Enter your valid OTP.</span>';
					document.getElementById("loadIcon").style.display = "none";
				}
			}
		}, {
			key: 'handleResendotp',
			value: function handleResendotp() {
	
				var qs = __webpack_require__(3);
				var postObject = { "app_id": APPID, "customer_email": _reactCookie2.default.load('customer_email'), "customer_mobile": _reactCookie2.default.load('customer_phone'), "customer_first_name": _reactCookie2.default.load('customer_first_name'), "customer_last_name": _reactCookie2.default.load('customer_last_name') };
	
				document.getElementById("loadIcon").style.display = "block";
	
				_axios2.default.post(APIURL + "customer/resend_otp", qs.stringify(postObject)).then(function (response) {
					if (response.data.status === "ok") {
						document.getElementById("loadIcon").style.display = "none";
						document.getElementById("resend_otp_button").style.display = "none";
						helper.showInfo(response.data.message);
					} else {
						document.getElementById("loadIcon").style.display = "none";
						document.getElementById("spn-otp-verified-error").innerHTML = '<span class="spn-error">' + response.data.message + '</span>';
						setTimeout(function () {
							document.getElementById("spn-otp-verified-error").innerHTML = '';
						}, 3000);
					}
				});
			}
		}, {
			key: 'backto_register',
			value: function backto_register() {
				document.getElementById("register_form_option").style.display = "block";
				document.getElementById("otp_verification_option").style.display = "none";
				document.getElementById("resend_otp_button").style.display = "block";
			}
		}, {
			key: 'render',
			value: function render() {
				var _this6 = this;
	
				var _props = this.props,
				    fields = _props.fields,
				    onChange = _props.onChange,
				    onValid = _props.onValid,
				    onInvalid = _props.onInvalid,
				    $field = _props.$field,
				    $validation = _props.$validation;
	
				var spanStyle = {
					clear: 'both'
				};
				var errMsgFirstName = void 0,
				    errMsgLastName = void 0,
				    errMsgEmail = void 0,
				    errMsgPassword = void 0,
				    errMsgrePassword = void 0,
				    errMsgMobile = void 0,
				    errMsgAlcohol = void 0,
				    errMsgTerms = void 0;
	
				if ($validation.firstname.error.reason !== undefined) {
					errMsgFirstName = $validation.firstname.show && _react2.default.createElement(
						'span',
						{ className: 'spn-error' },
						$validation.firstname.error.reason
					);
				}
				if ($validation.lastname.error.reason !== undefined) {
					errMsgLastName = $validation.lastname.show && _react2.default.createElement(
						'span',
						{ className: 'spn-error' },
						$validation.lastname.error.reason
					);
				}
				if ($validation.email.error.reason !== undefined) {
					errMsgEmail = $validation.email.show && _react2.default.createElement(
						'span',
						{ className: 'spn-error' },
						$validation.email.error.reason
					);
				}
				if ($validation.password.error.reason !== undefined) {
					errMsgPassword = $validation.password.show && _react2.default.createElement(
						'span',
						{ className: 'spn-error' },
						$validation.password.error.reason
					);
				}
				if ($validation.rePassword.error.reason !== undefined) {
					errMsgrePassword = $validation.rePassword.show && _react2.default.createElement(
						'span',
						{ className: 'spn-error' },
						$validation.rePassword.error.reason
					);
				}
				if ($validation.mobile.error.reason !== undefined) {
					errMsgMobile = $validation.mobile.show && _react2.default.createElement(
						'span',
						{ className: 'spn-error' },
						$validation.mobile.error.reason
					);
				}
				if (APPID === "2AE048E7-2D84-42BE-9BB5-22016FC4DFBC" || APPID === "F34559CA-596A-4F2E-8547-17B2AEBB3326") {
					if ($validation.accepted_alcohol.error.reason !== undefined) {
						errMsgAlcohol = $validation.accepted_alcohol.show && _react2.default.createElement(
							'span',
							{ className: 'accepted_checkbox_error' },
							$validation.accepted_alcohol.error.reason
						);
					}
				}
	
				if ($validation.terms.error.reason !== undefined) {
					errMsgTerms = $validation.terms.show && _react2.default.createElement(
						'span',
						{ className: 'accepted_checkbox_error' },
						$validation.terms.error.reason
					);
				}
	
				return _react2.default.createElement(
					_ThemeProvider2.default,
					{ theme: _theme2.default },
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_reactDocumentMeta2.default, meta),
						_react2.default.createElement(
							'div',
							{ id: 'loadIcon', style: { display: 'none', bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto', zIndex: 99, background: 'rgba(255, 255, 255, 0.8)' } },
							' ',
							_react2.default.createElement('img', { style: { bottom: 0, left: 0, position: 'absolute', right: 0, top: 0, margin: 'auto' }, src: '/img/loader.gif', alt: 'Loading' }),
							' '
						),
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid desktop-container', style: { minHeight: this.state.windowHeightNormal } },
							_react2.default.createElement(
								'div',
								{ id: 'register-form' },
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-12 main-title-bar' },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: "/sign-in" },
											' ',
											_react2.default.createElement('img', { src: '/img/left-arrow.png', className: 'pull-left icon-img-small', alt: 'left-arrow' }),
											' '
										),
										_react2.default.createElement(
											'h3',
											{ className: 'top-title main-title padding-right-20 text-uppercase' },
											'Account Information'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement('div', { className: 'space-10 bg-gray' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'white-outer center-block' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-10 div-center' },
										_react2.default.createElement(
											'div',
											{ className: 'register_form_option', id: 'register_form_option' },
											_react2.default.createElement('div', { className: 'space-20' }),
											_react2.default.createElement(
												'p',
												{ className: 'text-center font-bold font-size-18' },
												'Register Your Account'
											),
											_react2.default.createElement('div', { className: 'space-5' }),
											_react2.default.createElement('div', { id: 'form-error' }),
											_react2.default.createElement(
												'div',
												{ className: 'form-group label-floating card-no input-form-group' },
												_react2.default.createElement(
													'div',
													{ className: 'input-group' },
													_react2.default.createElement(
														'label',
														{ className: 'control-label' },
														'First Name',
														_react2.default.createElement(
															'span',
															null,
															'*'
														)
													),
													_react2.default.createElement('input', Object.assign({ type: 'text', className: 'form-control', value: fields.firstname }, $field('firstname', function (e) {
														return onChange('firstname', e.target.value);
													}))),
													errMsgFirstName
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'form-group label-floating card-no input-form-group' },
												_react2.default.createElement(
													'div',
													{ className: 'input-group' },
													_react2.default.createElement(
														'label',
														{ className: 'control-label' },
														'Last Name',
														_react2.default.createElement(
															'span',
															null,
															'*'
														)
													),
													_react2.default.createElement('input', Object.assign({ type: 'text', className: 'form-control', value: fields.lastname }, $field('lastname', function (e) {
														return onChange('lastname', e.target.value);
													}))),
													errMsgLastName
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'form-group label-floating card-no input-form-group' },
												_react2.default.createElement(
													'div',
													{ className: 'input-group' },
													_react2.default.createElement(
														'label',
														{ className: 'control-label' },
														'Email Address',
														_react2.default.createElement(
															'span',
															null,
															'*'
														)
													),
													_react2.default.createElement('input', Object.assign({ type: 'text', className: 'form-control', value: fields.email }, $field('email', function (e) {
														return onChange('email', e.target.value);
													}))),
													_react2.default.createElement(
														'div',
														{ id: 'spn-email-error' },
														errMsgEmail
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'form-group label-floating card-no input-form-group' },
												_react2.default.createElement(
													'div',
													{ className: 'input-group' },
													_react2.default.createElement(
														'label',
														{ className: 'control-label' },
														'Password',
														_react2.default.createElement(
															'span',
															null,
															'*'
														)
													),
													_react2.default.createElement('input', Object.assign({ type: 'password', className: 'form-control', value: fields.password }, $field('password', function (e) {
														return onChange('password', e.target.value);
													}))),
													errMsgPassword
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'form-group label-floating card-no input-form-group' },
												_react2.default.createElement(
													'div',
													{ className: 'input-group' },
													_react2.default.createElement(
														'label',
														{ className: 'control-label' },
														'Re Enter Password',
														_react2.default.createElement(
															'span',
															null,
															'*'
														)
													),
													_react2.default.createElement('input', Object.assign({ type: 'password', className: 'form-control', value: fields.rePassword }, $field('rePassword', function (e) {
														return onChange('rePassword', e.target.value);
													}))),
													errMsgrePassword
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'form-group label-floating card-no input-form-group' },
												_react2.default.createElement(
													'div',
													{ className: 'input-group' },
													_react2.default.createElement(
														'label',
														{ className: 'control-label' },
														'Mobile Number',
														_react2.default.createElement(
															'span',
															null,
															'*'
														)
													),
													_react2.default.createElement('input', Object.assign({ type: 'text', className: 'form-control', value: fields.mobile }, $field('mobile', function (e) {
														return onChange('mobile', e.target.value);
													}))),
													_react2.default.createElement(
														'div',
														{ id: 'spn-mobile-error' },
														errMsgMobile
													)
												)
											),
											APPID === "CD8D5FE3-0586-44DD-9360-EE9DEF351223" ? _react2.default.createElement(
												'div',
												{ className: 'select_box_input_group ' },
												_react2.default.createElement('label', { className: 'select_box_label' }),
												_react2.default.createElement(
													'select',
													Object.assign({ className: 'select_box_form_control', name: 'portmakan_company', value: fields.portmakan_company }, $field('portmakan_company', function (e) {
														return onChange('portmakan_company', e.target.value);
													})),
													_react2.default.createElement(
														'option',
														{ value: '' },
														'Select Company'
													),
													_react2.default.createElement(
														'option',
														{ value: 'PSA' },
														'PSA'
													),
													_react2.default.createElement(
														'option',
														{ value: 'HTPS' },
														'HT Ports Services Pte Ltd'
													),
													_react2.default.createElement(
														'option',
														{ value: 'BFL' },
														'Big Foot Logistics Pte Ltd'
													),
													_react2.default.createElement(
														'option',
														{ value: 'SFS' },
														'Seafront Support Pte Ltd'
													),
													_react2.default.createElement(
														'option',
														{ value: 'BJ' },
														'BJ Harvest Services Pte Ltd'
													),
													_react2.default.createElement(
														'option',
														{ value: 'GIL' },
														'Greensafe International Pte Ltd'
													),
													_react2.default.createElement(
														'option',
														{ value: 'RGH' },
														'Royal Greyhound Pte Ltd'
													),
													_react2.default.createElement(
														'option',
														{ value: 'KET' },
														'Koon Seng Enterprises Pte Ltd'
													),
													_react2.default.createElement(
														'option',
														{ value: 'HOY' },
														'Hoy San Stevedoring Pte Ltd'
													),
													_react2.default.createElement(
														'option',
														{ value: 'CLA' },
														'Call Lade Enterprises Pte Ltd'
													),
													_react2.default.createElement(
														'option',
														{ value: 'SRM' },
														'SMS Marine Pte Ltd'
													),
													_react2.default.createElement(
														'option',
														{ value: 'TNO' },
														'TNS Ocean Lines (S) Pte Ltd'
													)
												),
												_react2.default.createElement('div', { id: 'spn-portmakan_company-error' })
											) : "",
											_react2.default.createElement(
												'div',
												{ className: 'cbox_agree_items_wrap' },
												APPID === "2AE048E7-2D84-42BE-9BB5-22016FC4DFBC" || APPID === "F34559CA-596A-4F2E-8547-17B2AEBB3326" ? _react2.default.createElement(
													'div',
													{ className: 'checkbox_sign_up' },
													_react2.default.createElement('br', null),
													_react2.default.createElement('input', Object.assign({ type: 'checkbox', id: 'accepted_alcohol', checked: fields.accepted_alcohol }, $field('accepted_alcohol', function (e) {
														return onChange("accepted_alcohol", e.target.value);
													}, null, false))),
													_react2.default.createElement(
														'p',
														null,
														'You agree that you are of legal age to purchase and consume alcohol in the locale in which the alcohol is delivered and acknowledge and agree to provide valid government-issued identification upon delivery'
													),
													errMsgAlcohol
												) : _react2.default.createElement(
													'div',
													null,
													_react2.default.createElement('input', Object.assign({ type: 'hidden', id: 'accepted_alcohol', value: '1' }, $field('accepted_alcohol', function (e) {
														return onChange("accepted_alcohol", e.target.value);
													}, null, false)))
												),
												_react2.default.createElement(
													'div',
													{ className: 'checkbox_sign_up' },
													APPID !== "2AE048E7-2D84-42BE-9BB5-22016FC4DFBC" && APPID !== "F34559CA-596A-4F2E-8547-17B2AEBB3326" && _react2.default.createElement('br', null),
													_react2.default.createElement('input', Object.assign({ type: 'checkbox', id: 'terms', checked: fields.terms, defaultChecked: true, disabled: 'disabled' }, $field('terms', function (e) {
														return onChange("terms", e.target.value);
													}, null, false))),
													_react2.default.createElement(
														'p',
														null,
														'I agree to the Privacy Policy and Terms of Service of ',
														_reactCookie2.default.load('client_company_name')
													),
													errMsgTerms
												),
												_react2.default.createElement(
													'div',
													{ className: 'checkbox_sign_up' },
													_react2.default.createElement('input', Object.assign({ type: 'checkbox', id: 'accepted_coupons', checked: fields.accepted_coupons }, $field('accepted_coupons', function (e) {
														return onChange("accepted_coupons", e.target.value);
													}, null, false))),
													_react2.default.createElement(
														'p',
														null,
														'I consent to receive coupons and promotions news from ',
														_reactCookie2.default.load('client_company_name'),
														', its franchisees and affiliates, and understand and agree that my information will be for the above. '
													),
													_react2.default.createElement('div', { id: 'spn-accept-error' })
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'mandatory' },
												_react2.default.createElement(
													'span',
													null,
													'*'
												),
												' Mandatory Fields'
											),
											_react2.default.createElement(
												'div',
												{ className: 'text-center ' },
												_react2.default.createElement(
													'button',
													{ type: 'button', className: 'btn btn-raised btn-info full-width-btn-2 text-uppercase', onClick: function onClick(e) {
															e.preventDefault();_this6.props.$submit(onValid, onInvalid);
														} },
													'Register'
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'space-20', style: { display: 'none' }, id: 'otp_verification_option' },
											_react2.default.createElement(
												'a',
												{ className: 'back_to_register', onClick: this.backto_register.bind(this) },
												'Back to Register'
											),
											_react2.default.createElement(
												'p',
												{ className: 'text-center font-bold font-size-18' },
												'OTP Verification'
											),
											_react2.default.createElement(
												'form',
												{ className: 'customer_otp', id: 'customer_otp', onSubmit: function onSubmit(e) {
														_this6.submit_otp_verification(_this6);e.preventDefault();
													} },
												_react2.default.createElement('div', { id: 'spn-otp-verified-error' }),
												_react2.default.createElement(
													'div',
													{ className: 'form-group label-floating card-no input-form-group' },
													_react2.default.createElement(
														'div',
														{ className: 'input-group' },
														_react2.default.createElement(
															'label',
															{ className: 'control-label' },
															'Enter your OTP',
															_react2.default.createElement(
																'span',
																null,
																'*'
															)
														),
														_react2.default.createElement('input', { type: 'text', name: 'customer_otp_val', className: 'form-control', value: this.state.customer_otp_val, onChange: this.handleChangeTxt.bind(this, 'customer_otp_val') }),
														_react2.default.createElement('div', { id: 'spn-otp-error' })
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'text-center ' },
													_react2.default.createElement(
														'button',
														{ type: 'button', className: 'btn btn-raised btn-info full-width-btn-2 text-uppercase', onClick: this.submit_otp_verification.bind(this) },
														'Submit'
													)
												)
											),
											_react2.default.createElement(
												'a',
												{ className: 'resent_otp', id: 'resend_otp_button', onClick: this.handleResendotp.bind(this) },
												'Resent OTP'
											)
										)
									),
									_react2.default.createElement('div', { className: 'clearfix' })
								)
							)
						)
					)
				);
			}
		}]);
	
		return Form;
	}(_react2.default.Component);
	
	Form.contextTypes = {
		router: _react2.default.PropTypes.object.isRequired
	};
	
	Form = (0, _reactCustomValidation.validated)(validationConfig)(Form);
	
	exports.default = Signup;

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactStripeCheckout = __webpack_require__(186);
	
	var _reactStripeCheckout2 = _interopRequireDefault(_reactStripeCheckout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TakeMoney = function (_React$Component) {
	  _inherits(TakeMoney, _React$Component);
	
	  function TakeMoney() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TakeMoney);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TakeMoney.__proto__ || Object.getPrototypeOf(TakeMoney)).call.apply(_ref, [this].concat(args))), _this), _this.onToken = function (token) {
	
	      fetch('/save-stripe-token', {
	        method: 'POST',
	        body: JSON.stringify(token)
	      }).then(function (response) {
	        response.json().then(function (data) {
	          alert('We are in business, ' + data.email);
	        });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TakeMoney, [{
	    key: 'componentDidMount',
	
	
	    // ...
	    value: function componentDidMount() {
	      (0, _withTracker.loadAnalytics)();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return (
	        // ...
	        _react2.default.createElement(_reactStripeCheckout2.default, {
	          token: this.onToken,
	          stripeKey: 'pk_test_cJ0x2SqHNoPu1Gh0lXE0Fxry',
	          amount: 400,
	          currency: 'SGD',
	          email: 'info@vidhub.co',
	          image: 'https://www.vidhub.co/assets/logos/vidhub-icon-2e5c629f64ced5598a56387d4e3d0c7c.png'
	        })
	      );
	    }
	  }]);
	
	  return TakeMoney;
	}(_react2.default.Component);
	
	exports.default = TakeMoney;

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(9);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var Loading = __webpack_require__(17);
	var config = __webpack_require__(7);
	var lang = __webpack_require__(12);
	var APIURL = config.path.apiUrl;
	var APPID = config.ids.appId;
	
	var helper = __webpack_require__(13);
	
	/* Load meta tags */
	var meta = {
		title: lang.activation_meta_title,
		description: lang.activation_meta_title,
		meta: {
			name: {
				keywords: lang.activation_meta_title
			}
		}
	};
	
	var Unsubscribe = function (_React$Component) {
		_inherits(Unsubscribe, _React$Component);
	
		function Unsubscribe() {
			_classCallCheck(this, Unsubscribe);
	
			return _possibleConstructorReturn(this, (Unsubscribe.__proto__ || Object.getPrototypeOf(Unsubscribe)).apply(this, arguments));
		}
	
		_createClass(Unsubscribe, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
	
				/* add class */
				helper.addBodyClass();
			}
			/* Account activation */
	
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				(0, _withTracker.loadAnalytics)();
				var qs = __webpack_require__(3);
				var activationId = this.props.params.activationId;
	
				/* for account activation - start */
				if (typeof activationId !== 'undefined' && activationId !== "") {
					// return false;
					var postObject = {
						"app_id": APPID,
						"key": activationId
					};
					_axios2.default.post(APIURL + "customer/unsubscribe", qs.stringify(postObject)).then(function (response) {
	
						/* Success response */
						if (response.data.status === "ok") {
							var errorMsg = response.data.message;
							helper.showInfo(errorMsg);
							_reactRouter.hashHistory.push("/");
						}
	
						/* Success response */
						if (response.data.status === "error") {
	
							var errorMsg = response.data.message;
							helper.showInfo(errorMsg);
							_reactRouter.hashHistory.push("/");
						}
						/* error reponse */
					});
				}
				/* for account activation - end  */
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_reactDocumentMeta2.default, meta),
					_react2.default.createElement(
						'div',
						{ className: 'chk_popup act_loder', id: 'PayProcess', style: { position: 'unset' } },
						_react2.default.createElement(
							'div',
							{ className: 'white-outer center-block process_order' },
							_react2.default.createElement(
								'div',
								{ className: 'row ' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 padd2' },
									_react2.default.createElement(
										'h4',
										null,
										lang.activation_meta_title
									),
									_react2.default.createElement(
										'div',
										{ className: 'clock_part' },
										_react2.default.createElement('img', { src: '/img/spinner.gif', alt: '' }),
										_react2.default.createElement('br', null)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return Unsubscribe;
	}(_react2.default.Component);
	
	exports.default = Unsubscribe;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withTracker = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(9);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactMoment = __webpack_require__(99);
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _lodash = __webpack_require__(30);
	
	var _Distancebar = __webpack_require__(102);
	
	var _Distancebar2 = _interopRequireDefault(_Distancebar);
	
	var _reactDocumentMeta = __webpack_require__(15);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _constants = __webpack_require__(65);
	
	var _Outletclosedmessage = __webpack_require__(103);
	
	var _Outletclosedmessage2 = _interopRequireDefault(_Outletclosedmessage);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _Api = __webpack_require__(19);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var config = __webpack_require__(7);
	
	var APPID = config.ids.appId;
	var APIURL = config.path.apiUrl;
	var APIURLPRO = config.path.apiUrlPro;
	var strp = __webpack_require__(31);
	
	var lang = __webpack_require__(12);
	var Overlay = __webpack_require__(64);
	
	var qs = __webpack_require__(3);
	var Loading = __webpack_require__(17);
	
	var helper = __webpack_require__(13);
	var apps = __webpack_require__(29);
	
	var HtmlToReactParser = __webpack_require__(21).Parser;
	var htmlToReactParserTo = new HtmlToReactParser();
	
	/* Load meta tags */
	var meta = {
		title: "My Vouchers" + lang.site_title_with_separator,
		description: "My e-Vouchers",
		meta: {
			name: {
				keywords: "My e-Vouchers"
			}
		}
	};
	
	var Vouchers = function (_React$Component) {
		_inherits(Vouchers, _React$Component);
	
		function Vouchers(props) {
			_classCallCheck(this, Vouchers);
	
			var _this = _possibleConstructorReturn(this, (Vouchers.__proto__ || Object.getPrototypeOf(Vouchers)).call(this, props));
	
			_this.state = { pageTitle: 'My e-Vouchers', pageDesc: 'My e-Vouchers', status: 'ok', windowHeight: 0, voucherStatus: 'Waiting', myVouchers: [], usedVouchers: [], productimagePath: "", openModal: false, manualLoading: false, currentVoucher: [], currnetDate: "", Outlets: [], redirectToCart: false, Purchased_voucher: false, zoneEnabled: 0, zonePopupDisable: 0, secAddrData: [], deliveryOutlets: [], addCartValues: [] };
	
			/* check Authentication */
			if ((0, _Api2.default)('Auth') === false) {
				_reactRouter.hashHistory.push("/sign-in");
			}
	
			helper.isAnonymousUserRedirect();
			return _this;
		}
	
		_createClass(Vouchers, [{
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				if ((0, _Api2.default)('Auth') === false) {
					_reactRouter.hashHistory.push("/sign-in");
					return false;
				}
	
				if ((0, _Api2.default)('UserDetails') === false) {
					helper.showInfo(lang.users.user_info_missing, "", "redirect", "/my-account");
					return false;
				}
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				var today = new Date();
				var dd = String(today.getDate()).padStart(2, '0');
				var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
				var yyyy = today.getFullYear();
				today = yyyy + '-' + mm + '-' + dd;
				this.setState({
					currnetDate: today
				});
	
				_axios2.default.all([_axios2.default.get(APIURL + 'promotion_api_v3/vouchers?app_id=' + APPID + '&customer_id=' + _reactCookie2.default.load('UserId'))]).then(_axios2.default.spread(function (vouchers) {
					_this2.setState({ voucherStatus: "Ready" });
					/* set promotion content */
					if (vouchers.data.status === "ok") {
						_this2.setState({ myVouchers: vouchers.data.result_set.product_list, usedVouchers: vouchers.data.result_set.used_vouchers, productimagePath: vouchers.data.common.image_source });
					}
				}));
	
				_axios2.default.get(APIURLPRO + 'settings/get_common_settings?app_id=' + APPID + "&postal_code=" + _reactCookie2.default.load('orderPostalCode') + "&postalFilter=No").then(function (res) {
					_this2.setState({ zoneEnabled: parseInt(res.data.result_set.client_outlet_zone) }, function () {
						var _this3 = this;
	
						if (this.state.zoneEnabled === 1 && _reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && _reactCookie2.default.load('defaultAvilablity') === lang.delivery && typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderPostalCode') === "undefined") {
	
							_axios2.default.get(_constants.API_v4_URL + 'Getoutlets/getAllOutles/pickup_outlets?app_id=' + APPID + "&availability_id=" + config.ids.deliveryId).then(function (res) {
								if (res.data.status === "ok") {
									_this3.setState({ deliveryOutlets: res.data.result_set });
								} else {
									/* this.setState({Status: res.data.status}); */
								}
							});
						}
					});
					_this2.setState({ zonePopupDisable: parseInt(res.data.result_set.client_zone_outlet_disable) });
				});
	
				if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.pickupId && _reactCookie2.default.load('defaultAvilablity') === lang.takeaWay && typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderPostalCode') === "undefined") {
	
					_axios2.default.get(_constants.API_v4_URL + 'Getoutlets/pickup_outlets?app_id=' + APPID).then(function (res) {
						if (res.data.status === "ok") {
							_this2.setState({ Status: res.data.status });
							_this2.setState({ Outlets: res.data.result_set });
							if (apps.workspace === APPID) {
								_this2.getaddWorkSpaceCookieValues(res.data.result_set);
							}
						} else {
							_this2.setState({ Status: res.data.status });
						}
					});
				}
	
				var windowHeight = window.innerHeight;
	
				this.setState({ 'windowHeight': windowHeight + 'px' });
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				(0, _withTracker.loadAnalytics)();
	
				var promise = (0, _Api2.default)("settingsPro", "No");
				promise.then(function (res) {
					if (!helper.disableMenu(res.data.result_set, "myaccount_vouchers")) {
						_reactRouter.hashHistory.push("/");
						return false;
					}
				});
			}
	
			// /* add outlet ids work spac */	 
	
		}, {
			key: 'getaddWorkSpaceCookieValues',
			value: function getaddWorkSpaceCookieValues(data) {
	
				var loaddata = data[0];
				var outlet_name = loaddata.outlet_name;
				var outlet_id = loaddata.outlet_id,
				    loaddata;
				var outlet_address_line1 = loaddata.outlet_address_line1;
				var outlet_address_line2 = loaddata.outlet_address_line2;
				var outlet_postal_code = loaddata.outlet_postal_code;
				var outlet_pickup_tat = loaddata.outlet_postal_code;
	
				var orderHandled = outlet_name + " " + outlet_address_line1 + " " + outlet_address_line2 + ", Singapore " + outlet_postal_code;
				this.setState({ orderHandled: orderHandled });
				_reactCookie2.default.save('orderOutletName', outlet_name);
				_reactCookie2.default.save('orderPostalCode', outlet_postal_code);
				_reactCookie2.default.save('orderTAT', outlet_pickup_tat);
				_reactCookie2.default.save('orderHandled', orderHandled);
				_reactCookie2.default.save('orderHandledByText', orderHandled);
			}
		}, {
			key: 'showPromo',
			value: function showPromo(promo, type) {
				if (type === "usedpromotions") {
					this.setState({
						Purchased_voucher: true
					});
				} else {
					this.setState({
						Purchased_voucher: false
					});
				}
	
				this.setState({ currentVoucher: promo, openModal: true });
				$("#RedeemPromocodeModal").modal("toggle");
			}
		}, {
			key: 'showZonalPostalCode',
			value: function showZonalPostalCode(outletId) {
	
				$("#delivery_outlet").modal("toggle");
				if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
					$("#AddressList").modal("toggle");
				} else {
					$("#DeliveryAddress").modal("toggle");
				}
	
				this.setState({ zoneDeliveryOutlet: outletId });
			}
		}, {
			key: 'getSecAddr',
			value: function getSecAddr() {
				var _this4 = this;
	
				_axios2.default.get(APIURL + '/customer/get_user_secondary_address?app_id=' + APPID + "&refrence=" + _reactCookie2.default.load('UserId')).then(function (res) {
					if (res.data.status === "ok") {
						_this4.setState({ secAddrData: res.data.result_set });
					}
				});
			}
		}, {
			key: 'loadAddressList',
			value: function loadAddressList() {
				var _this5 = this;
	
				if (this.state.secAddrData !== "") {
					return this.state.secAddrData.map(function (item, index) {
						return _react2.default.createElement(
							'p',
							{ key: index },
							_react2.default.createElement('input', { name: 'radio', value: item.postal_code, id: item.secondary_address_id, className: 'css-radio', type: 'radio', onChange: _this5.handleChange }),
							_react2.default.createElement(
								'label',
								{ htmlFor: item.secondary_address_id, className: 'css-label ' },
								' ',
								item.address + " Singapore " + item.postal_code
							)
						);
					});
				}
			}
		}, {
			key: 'addToCart',
			value: function addToCart(voucher) {
				var _this6 = this;
	
				if (voucher !== '') {
					if (voucher.product_voucher === "c") {
						this.setState({
							manualLoading: true
						}, function () {
							this.loadManualLoading();
						});
	
						var modifier = [];
						var combo = [];
						var postObject = {};
						var price = parseFloat("0.00");
						postObject = {
							'app_id': config.ids.appId,
							'product_qty': voucher.item_qty,
							'product_voucher_points': voucher.product_voucher_points,
							'customer_id': _reactCookie2.default.load('UserId'),
							'order_item_id': voucher.order_item_id
						};
	
						_axios2.default.post(APIURLPRO + "ordersv2/add_voucher_redeem", qs.stringify(postObject)).then(function (res) {
							_this6.setState({ status: 'ok' });
							if (res.data.status === "ok") {
								_reactRouter.hashHistory.push("/rewards");
								_this6.setState({ manualLoading: false });
								//hashHistory.push(reDirectUrl);
							} else if (res.data.status === "error") {
								helper.showInfo(res.data.message);
							}
						});
					} else {
	
						var modifier = [];
						var combo = [];
						var postObject = {};
						var price = parseFloat("0.00");
						postObject = {
							'app_id': config.ids.appId,
							'product_id': voucher.item_product_id,
							'product_name': strp.stripslashes(voucher.item_name),
							'product_sku': voucher.item_sku,
							'product_image': this.state.productimagePath + voucher.product_thumbnail,
							'availability_id': _reactCookie2.default.load('defaultAvilablityId'),
							'product_unit_price': price,
							'product_qty': voucher.item_qty,
							'product_total_price': price,
							'voucher_gift_name': "",
							'voucher_gift_email': "",
							'voucher_gift_message': "",
							'product_voucher_points': "",
							'modifiers': modifier,
							'menu_set_component': combo,
							'customer_id': _reactCookie2.default.load('UserId'),
							'order_availability_id': voucher.order_availability_id,
							'order_item_id': voucher.order_item_id,
							'order_outlet_id': voucher.order_outlet_id
						};
	
						if (this.state.openModal === true) {
							$(".close").trigger('click');
						}
	
						if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.deliveryId && _reactCookie2.default.load('defaultAvilablity') === lang.delivery) {
	
							if (typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderPostalCode') === "undefined") {
	
								if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
									if (this.state.zoneEnabled === 1) {
										if (parseInt(this.state.zonePopupDisable) === 1) {
											$("#AddressList").modal("toggle");
											this.setState({
												addCartValues: postObject
											});
											return false;
										} else {
	
											this.setState({
												addCartValues: postObject
											});
											$("#delivery_outlet").modal("toggle");
											return false;
										}
									} else {
										this.setState({
											addCartValues: postObject
										});
	
										$("#AddressList").modal("toggle");
										return false;
									}
								}
							}
						} else if (_reactCookie2.default.load('defaultAvilablityId') === config.ids.pickupId && _reactCookie2.default.load('defaultAvilablity') === lang.takeaWay) {
	
							if (typeof _reactCookie2.default.load('orderOutletId') === "undefined" || typeof _reactCookie2.default.load('orderPostalCode') === "undefined") {
	
								var pickupOutlets = this.state.Outlets;
	
								if (pickupOutlets.length === 1) {
	
									var orderHandled = pickupOutlets[0].outlet_name + " " + pickupOutlets[0].outlet_address_line1 + " " + pickupOutlets[0].outlet_address_line2 + ", Singapore " + pickupOutlets[0].outlet_postal_code;
	
									this.setState({ orderHandled: orderHandled });
									_reactCookie2.default.save('orderOutletId', pickupOutlets[0].outlet_id);
									_reactCookie2.default.save('orderOutletName', pickupOutlets[0].outlet_name);
									_reactCookie2.default.save('orderPostalCode', pickupOutlets[0].outlet_postal_code);
									_reactCookie2.default.save('orderTAT', pickupOutlets[0].outlet_pickup_tat);
									_reactCookie2.default.save('orderHandled', orderHandled);
									_reactCookie2.default.save('orderHandledByText', orderHandled);
	
									_reactCookie2.default.save('outlet_tax_option', pickupOutlets[0].outlet_tax_option);
									_reactCookie2.default.save('outlet_tax_surcharge', pickupOutlets[0].outlet_tax_surcharge);
									_reactCookie2.default.save('outlet_tax_surcharge_inclusive', pickupOutlets[0].outlet_tax_surcharge_inclusive);
	
									_reactCookie2.default.save('outlet_option_single', 1);
	
									$("#pickup-outlet-sucess").modal("toggle");
								} else {
									$("#Pickup-OutletSelection").modal("toggle");
								}
	
								return false;
							}
						}
	
						this.setState({
							manualLoading: true
						}, function () {
							this.loadManualLoading();
						});
	
						_axios2.default.post(APIURLPRO + "cartv2/insert", qs.stringify(postObject)).then(function (res) {
							_this6.setState({ status: 'ok' });
							if (res.data.status === "ok") {
								_this6.setState({ redirectToCart: true, openModal: false
								}, function () {
									this.loadOutletDetails();
								});
								var cartCount = res.data.contents.cart_details.cart_total_items;
								_reactCookie2.default.save('cartValue', 'Yes');
								_reactCookie2.default.save('cartCount', cartCount);
								_reactCookie2.default.save('voucher_types_enable', '1');
								/* find previous page */
								var slugType = _reactCookie2.default.load('categoryType');
								var slugValue = _reactCookie2.default.load('categoryId');
	
								//hashHistory.push(reDirectUrl);
							} else if (res.data.status === "error") {
								helper.showInfo(res.data.message);
								_this6.setState({
									manualLoading: false
								});
							}
						});
					}
				}
			}
		}, {
			key: 'loadManualLoading',
			value: function loadManualLoading() {
				if (this.state.manualLoading === true) {
					return _react2.default.createElement(
						'div',
						{ style: { bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto' } },
						' ',
						_react2.default.createElement('img', { src: '/img/loader.gif', alt: 'Loading', style: { bottom: 0, left: 0, position: 'fixed', right: 0, top: 0, margin: 'auto' } }),
						' '
					);
				}
			}
		}, {
			key: 'loadOutletDetails',
			value: function loadOutletDetails() {
				var _this7 = this;
	
				_axios2.default.get(_constants.API_v4_URL + 'Getoutlets/pickup_outlets?app_id=' + APPID).then(function (res) {
					if (res.data.status === "ok") {
						_this7.setState({ Outlets: res.data.result_set }, function () {
							this.addWorkSpaceCookieValues(res.data.result_set);
						});
					} else {}
				});
			}
	
			/* Select outlet */
	
		}, {
			key: 'selectOutlet',
			value: function selectOutlet(thisobject) {
				var retry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				var _this8 = this;
	
				var callbackPostalCode = arguments[2];
				var addressObj = arguments[3];
	
				var postalcode = "";
				var address = "";
				var googleRetryAttempt = 0;
				if (retry === false) {
					if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
						postalcode = $("#postalcode").val(); //"postalcode";
					} else {
						postalcode = $("#postalcode1").val(); // "postalcode1";
					}
				} else {
					postalcode = callbackPostalCode;
					address = addressObj;
					googleRetryAttempt = 1;
				}
	
				if (postalcode.length < 5) {
					return false;
				}
	
				this.setState({ load: "true" });
	
				var findPostUrl = APIURL + 'outlets/find_outlet?skip_timing=Yes&app_id=' + APPID + "&availability_id=" + _reactCookie2.default.load('defaultAvilablityId') + "&postal_code=" + postalcode;
				if (this.state.zoneEnabled === 1) {
					findPostUrl = _constants.API_v4_URL + 'test/outlets/findOutletZone?skip_timing=Yes&app_id=' + APPID + "&availability_id=" + _reactCookie2.default.load('defaultAvilablityId') + "&postal_code=" + postalcode + "&outlet_id=" + this.state.zoneDeliveryOutlet + "&googleRetryAttempt=" + googleRetryAttempt + "&addressObject=" + address;
				}
				/*add loading */
	
				_axios2.default.get(findPostUrl).then(function (res) {
	
					/* Success response */
					/* Success response  && Object.keys(res.data.result_set.postal_code_information).length !==0 */
					if (res.data.status === "ok") {
						_this8.setState({ load: "true" });
						/*if(Object.keys(res.data.result_set.postal_code_information).length !==0)
	     { */
						var orderDeliveryAddress = res.data.result_set.postal_code_information.zip_buno + " " + res.data.result_set.postal_code_information.zip_sname;
						var orderHandled = res.data.result_set.outlet_name + ", Crew will be seeing you in " + res.data.result_set.outlet_delivery_timing + " Minutes";
	
						_reactCookie2.default.save('orderOutletId', res.data.result_set.outlet_id);
						_reactCookie2.default.save('orderOutletName', res.data.result_set.outlet_name);
						_reactCookie2.default.save('orderPostalCode', res.data.result_set.postal_code_information.zip_code);
						_reactCookie2.default.save('orderTAT', res.data.result_set.outlet_delivery_timing);
						_reactCookie2.default.save('orderDeliveryAddress', orderDeliveryAddress);
						_reactCookie2.default.save('orderHandled', orderHandled);
	
						_reactCookie2.default.save('outlet_tax_option', res.data.result_set.outlet_tax_option);
						_reactCookie2.default.save('outlet_tax_surcharge', res.data.result_set.outlet_tax_surcharge);
						_reactCookie2.default.save('outlet_tax_surcharge_inclusive', res.data.result_set.outlet_tax_surcharge_inclusive);
	
						var orderHandledText = res.data.result_set.outlet_name + " " + res.data.result_set.outlet_address_line1 + " " + res.data.result_set.outlet_address_line2 + ", Singapore " + postalcode;
						_reactCookie2.default.save('orderHandledByText', orderHandledText);
	
						if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
							$("#AddressList").modal("hide");
						} else {
							$("#DeliveryAddress").modal("hide");
						}
						$("#address-auto").modal("hide");
						$("#DeliverySucess").modal("toggle");
	
						if (_this8.state.zoneEnabled === 1) {
							_reactCookie2.default.save('orderZoneID', res.data.result_set.zone_id);
						}
	
						_this8.setState({ orderDeliveryAddress: orderDeliveryAddress + " Singapore " + res.data.result_set.postal_code_information.zip_code });
						_this8.setState({ orderHandled: orderHandled }, function () {
							this.addToCartVoucher();
						});
	
						/* }else{
	     	 $("#DeliveryAddress").modal("toggle");
	     	 $("#DeliveryError").modal("toggle");
	      } */
					}
					/* Error response */
					if (res.data.status === "error") {
						_this8.setState({ load: "false" });
						/* check google api result */
						var google_api_result = false;
						if (typeof res.data.not_fount_in_google !== "undefined" && res.data.not_fount_in_google === true) {
							_this8.setState({ enableAddressSearch: true });
							google_api_result = true;
						}
	
						if (typeof _reactCookie2.default.load('UserId') !== "undefined" && _reactCookie2.default.load('UserId') !== "") {
							$("#AddressList").modal("hide");
						} else {
							$("#DeliveryAddress").modal("hide");
						}
	
						if (google_api_result === false) {
							if (res.data.shop_close === 'Yes') {
								$("#ShopClosedError").modal("toggle");
							} else {
								$("#DeliveryError").modal("toggle");
							}
						} else {
							$("#address-auto").modal("show");
						}
					}
				});
			}
		}, {
			key: 'addToCartVoucher',
			value: function addToCartVoucher() {
				var _this9 = this;
	
				if (this.state.addCartValues !== "" && this.state.addCartValues !== "undefined") {
	
					this.setState({
						manualLoading: true
					}, function () {
						this.loadManualLoading();
					});
	
					var voucher = this.state.addCartValues;
	
					var modifier = [];
					var combo = [];
					var postObject = {};
					var price = parseFloat("0.00");
	
					postObject = {
						'app_id': config.ids.appId,
						'product_id': voucher.product_id,
						'product_name': voucher.product_name,
						'product_sku': voucher.product_sku,
						'product_image': voucher.product_image,
						'availability_id': _reactCookie2.default.load('defaultAvilablityId'),
						'product_unit_price': price,
						'product_qty': voucher.product_qty,
						'product_total_price': price,
						'voucher_gift_name': "",
						'voucher_gift_email': "",
						'voucher_gift_message': "",
						'product_voucher_points': "",
						'modifiers': modifier,
						'menu_set_component': combo,
						'customer_id': _reactCookie2.default.load('UserId'),
						'order_availability_id': voucher.order_availability_id,
						'order_item_id': voucher.order_item_id,
						'order_outlet_id': voucher.order_outlet_id
					};
	
					_axios2.default.post(APIURLPRO + "cartv2/insert", qs.stringify(postObject)).then(function (res) {
						_this9.setState({ status: 'ok' });
						if (res.data.status === "ok") {
							_this9.setState({ redirectToCart: true, openModal: false, addCartValues: ""
							}, function () {
								this.loadOutletDetails();
							});
							var cartCount = res.data.contents.cart_details.cart_total_items;
							_reactCookie2.default.save('cartValue', 'Yes');
							_reactCookie2.default.save('cartCount', cartCount);
							_reactCookie2.default.save('voucher_types_enable', '1');
							//hashHistory.push(reDirectUrl);
						} else if (res.data.status === "error") {
							helper.showInfo(res.data.message);
							_this9.setState({
								manualLoading: false
							});
						}
					});
				}
			}
	
			/* continue with pickup success */
	
		}, {
			key: 'pickupSuccess',
			value: function pickupSuccess() {
				var productId = this.state.productId;
				var proName = this.state.proName;
				var prosku = this.state.prosku;
				var proPrice = this.state.proPrice;
				var proQty = this.state.proQty;
				var proImage = this.state.proImage;
				var allowCart = this.state.allowCart;
				var applyMinmaxSelect = this.state.applyMinmaxSelect;
				$("#Pickup-Sucess").modal("hide");
				$("#pickup-outlet-sucess").modal('hide');
				//this.addToCart(productId, proName, prosku, proPrice, proQty, proImage, allowCart, applyMinmaxSelect);
			}
		}, {
			key: '__loadDeliveryOutlets',
			value: function __loadDeliveryOutlets() {
				var _this10 = this;
	
				if (this.state.deliveryOutlets) {
					var list = helper.getSortedList(this.state.deliveryOutlets, this.props.coords);
	
					return !(0, _lodash.isEmpty)(list) && list.map(function (loaddata, index) {
						return _react2.default.createElement(
							'div',
							{ className: 'map-li', key: index, onClick: _this10.showZonalPostalCode.bind(_this10, loaddata.outlet_id) },
							_react2.default.createElement(
								'p',
								{ className: 'map-h outlet-name' },
								helper.stripslashes(loaddata.outlet_name)
							),
							_react2.default.createElement(
								'p',
								{ className: 'map-sub' },
								_this10.showNewAddressFrmd(loaddata.outlet_postal_code, loaddata.outlet_address_line1, '', '', ''),
								' ',
								loaddata.outlet_unit_number2
							),
							_react2.default.createElement(_Distancebar2.default, { minDateValue: loaddata.min_date, isOutletBased: loaddata.is_outlet_based, distance: loaddata.distance, coords: _this10.props.coords, tat: loaddata.outlet_delivery_tat ? loaddata.outlet_delivery_tat : loaddata.outlet_delivery_timing })
						);
					});
				}
			}
		}, {
			key: 'showNewAddressFrmd',
			value: function showNewAddressFrmd(pstcode, address1, address2, unittxt1, unittxt2) {
				var addressLn = address2 != '' ? address1 + ", " + address2 : address1;
				if (unittxt1 != '' && unittxt2 != '') {
					addressLn = addressLn + ", #" + unittxt1 + "-" + unittxt2;
				} else if (unittxt1 != '' || unittxt2 != '') {
					addressLn = unittxt1 != '' ? addressLn + ", #" + unittxt1 : addressLn + ", #" + unittxt2;
				}
	
				addressLn = addressLn + ", Singapore " + pstcode;
				return addressLn;
			}
	
			/* Validate zipcode */
	
		}, {
			key: 'validatezip',
			value: function validatezip(e) {
				var re = /[0-9A-F:]+/g;
				if (!re.test(e.key)) {
					e.preventDefault();
				}
			}
		}, {
			key: 'addWorkSpaceCookieValues',
			value: function addWorkSpaceCookieValues(data) {
				var _this11 = this;
	
				var loaddata = data[0];
				var outlet_name = loaddata.outlet_name;
				var outlet_id = loaddata.outlet_id,
				    loaddata;
				var outlet_address_line1 = loaddata.outlet_address_line1;
				var outlet_address_line2 = loaddata.outlet_address_line2;
				var outlet_postal_code = loaddata.outlet_postal_code;
				var outlet_pickup_tat = loaddata.outlet_postal_code;
	
				var orderHandled = outlet_name + " " + outlet_address_line1 + " " + outlet_address_line2 + ", Singapore " + outlet_postal_code;
				this.setState({ orderHandled: orderHandled });
				//cookie.save('orderOutletId',outlet_id);
				_reactCookie2.default.save('orderOutletName', outlet_name);
				_reactCookie2.default.save('orderPostalCode', outlet_postal_code);
				_reactCookie2.default.save('orderTAT', outlet_pickup_tat);
				_reactCookie2.default.save('orderHandled', orderHandled);
				_reactCookie2.default.save('orderHandledByText', orderHandled);
	
				var customerParam = "&customer_id=" + _reactCookie2.default.load('UserId');
				var postalCodeWhere = "";
				if (typeof _reactCookie2.default.load("orderPostalCode") !== "undefined") {
					postalCodeWhere = '&postal_code=' + _reactCookie2.default.load("orderPostalCode");
				}
	
				_axios2.default.get(APIURL + 'cartver2/contents?status=A&app_id=' + APPID + customerParam + postalCodeWhere).then(function (res) {
					if (res.data.status === "ok") {
						_this11.setState({ status: 'ok', manualLoading: false });
						if (typeof res.data.result_set !== "undefined") {
							var cartDetails = res.data.result_set.cart_details;
							_reactCookie2.default.save('cart_grand_total', cartDetails.cart_sub_total);
							_reactCookie2.default.save('cartValue', 'Yes');
	
							var reDirectUrl = "/cart";
							_reactRouter.hashHistory.push(reDirectUrl);
						} else {
							_reactCookie2.default.save('cartValue', 'No');
						}
					} else {
	
						_reactCookie2.default.save('cartValue', 'No');
					}
				});
			}
	
			/*apply coupon  function*/
	
		}, {
			key: 'applyPromo',
			value: function applyPromo(promocode) {
				$("#RedeemPromocodeModal").modal("hide");
				var postObject = {};
				var promocode = promocode !== "" ? promocode : $("#promocode").val();
	
				/* postObject = {
	   	/* cart details  /
	   	'app_id': APPID,
	   	'reference_id': cookie.load('UserId'),
	   	'promo_code': promocode,
	       		'cart_amount': cookie.load('cartsubtotal'),
	       		'availability_id':cookie.load('defaultAvilablityId'),
	   	'cart_quantity': cookie.load('carttotalitems'),
	   } */
	
				var cartSubToatl = parseFloat(this.state.cartDetails.cart_sub_total);
				var cartItemsCount = parseInt(this.state.cartDetails.cart_total_items);
				postObject = {
					/* cart details */
					'app_id': APPID,
					'reference_id': _reactCookie2.default.load('UserId'),
					'promo_code': promocode,
					'cart_amount': parseFloat(cartSubToatl),
					'cart_quantity': cartItemsCount,
					'category_id': this.getPromoCategory(),
					'availability_id': _reactCookie2.default.load('defaultAvilablityId')
				};
	
				_axios2.default.post(APIURL + 'promotion_api_v2/apply_promotion', qs.stringify(postObject)).then(function (res) {
					if (res.data.status === "success") {
	
						//alert(res.data.message);
						helper.showInfo(res.data.message, "", "reload");
						_reactCookie2.default.save('promotion_id', res.data.result_set.promotion_id);
						_reactCookie2.default.save('promotion_applied', "Yes");
						_reactCookie2.default.save('promotion_code', res.data.result_set.promotion_code);
						_reactCookie2.default.save('promotion_delivery_charge_applied', res.data.result_set.promotion_delivery_charge_applied);
						_reactCookie2.default.save('promotion_amount', res.data.result_set.promotion_amount);
						_reactCookie2.default.save('promotion_category', res.data.result_set.promotion_category);
						_reactCookie2.default.save('prmo_type', res.data.result_set.prmo_type);
	
						/*Remove if voucher applied*/
						_reactCookie2.default.remove('voucher_applied');
						_reactCookie2.default.remove('voucher_code');
						_reactCookie2.default.remove('voucher_amount');
	
						_reactRouter.hashHistory.push("/delivery-date");
					} else {
	
						if (typeof res.data.show_message !== 'undefined' && res.data.show_message === "Yes") {
	
							helper.showInfo(res.data.message, "", "redirect", '/');
						} else if (typeof res.data.form_error !== 'undefined') {
	
							helper.showInfo(res.data.form_error, "", "reload");
						} else {
	
							helper.showInfo(res.data.message, "", "reload");
						}
						if (res.data.clear_offer === 'Yes') {
	
							_reactCookie2.default.remove('promotion_id');
							_reactCookie2.default.remove('promotion_applied');
							_reactCookie2.default.remove('promotion_code');
							_reactCookie2.default.remove('promotion_delivery_charge_applied');
							_reactCookie2.default.remove('promotion_amount');
							_reactCookie2.default.remove('promotion_category');
							_reactCookie2.default.remove('prmo_type');
						}
					}
				});
			}
	
			/*  get promo category details  */
	
		}, {
			key: 'getPromoCategory',
			value: function getPromoCategory() {
	
				var product_cartid = "";
				var cartItems = this.state.cartItems;
				var cartCount = cartItems.length;
	
				if (cartCount > 0) {
					for (var p = 0; p < cartCount; p++) {
						if (product_cartid !== '' && cartItems[p].cart_item_product_id !== '') {
							product_cartid += ";";
						}
						product_cartid += cartItems[p].cart_item_product_id + "|" + cartItems[p].cart_item_total_price + "|" + cartItems[p].cart_item_qty;
					}
				}
	
				return product_cartid;
			}
	
			/*claim coupon  function*/
	
		}, {
			key: 'claimPromo',
			value: function claimPromo(promocode) {
	
				var postObject = {};
				var promocode = promocode !== "" ? promocode : $("#promocode").val();
	
				postObject = {
					/* cart details */
					'app_id': APPID,
					'reference_id': _reactCookie2.default.load('UserId'),
					'promo_code': promocode,
					'cart_amount': _reactCookie2.default.load('cartsubtotal'),
					'availability_id': _reactCookie2.default.load('defaultAvilablityId'),
					'cart_quantity': _reactCookie2.default.load('carttotalitems')
				};
	
				_axios2.default.post(APIURL + 'promotion_api_v2/claimpromo', qs.stringify(postObject)).then(function (res) {
					if (res.data.status === "success") {
	
						helper.showInfo(res.data.message, "", "reload");
					} else {
	
						if (typeof res.data.show_message !== 'undefined' && res.data.show_message === "Yes") {
							helper.showInfo(res.data.message, "", "");
						} else if (typeof res.data.form_error !== 'undefined') {
							//alert(res.data.form_error);
							helper.showInfo(res.data.form_error, "", "reload");
						} else {
							// alert(res.data.message);
							helper.showInfo(res.data.message, "", "");
						}
					}
				});
			}
	
			/*load my promotion list here */
	
		}, {
			key: 'loadMyPromotions',
			value: function loadMyPromotions(e, type) {
				var _this12 = this;
	
				if (this.state.voucherStatus === "Waiting") {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(Loading, null)
					);
				} else {
	
					/* load promotions */
					if (type === "promotion") {
						var myVouchers = this.state.myVouchers;
						if (myVouchers.length > 0) {
							return myVouchers.map(function (vouch, index) {
								return _react2.default.createElement(
									'div',
									{ className: 'col-md-6', key: index },
									_react2.default.createElement(
										'div',
										{ className: 'promo-box' },
										_react2.default.createElement(
											'div',
											{ className: 'promo-img-item' },
											_react2.default.createElement('img', { src: _this12.loadPromoImage(vouch.product_thumbnail) })
										),
										_react2.default.createElement(
											'div',
											{ className: 'promo-btm-section' },
											_this12.state.currnetDate > vouch.expiry_date ? _react2.default.createElement(
												'div',
												{ className: 'rws_list_title' },
												_react2.default.createElement(
													'p',
													{ style: { float: 'right' } },
													'Expired'
												)
											) : "",
											_react2.default.createElement(
												'span',
												{ className: 'promo-text' },
												vouch.item_name
											),
											_react2.default.createElement(
												'span',
												{ className: 'promo-amount' },
												_this12.loadProductDate(vouch.expiry_date)
											),
											_react2.default.createElement(
												'div',
												{ className: 'promo-btn-block' },
												_react2.default.createElement(
													_reactRouter.Link,
													{ style: { cursor: 'pointer' }, onClick: _this12.showPromo.bind(_this12, vouch, type), className: 'promo-btn-view' },
													_react2.default.createElement(
														'span',
														null,
														'View'
													)
												),
												_this12.state.currnetDate > vouch.expiry_date ? _react2.default.createElement(
													_reactRouter.Link,
													{ style: { cursor: 'pointer' }, className: 'promo-btn-redeem' },
													_react2.default.createElement(
														'span',
														null,
														'Expired'
													)
												) : _react2.default.createElement(
													_reactRouter.Link,
													{ onClick: _this12.addToCart.bind(_this12, vouch), style: { cursor: 'pointer' }, className: 'promo-btn-redeem' },
													_react2.default.createElement(
														'span',
														null,
														'Redeem'
													)
												)
											)
										)
									)
								);
							});
						} else {
	
							return _react2.default.createElement(
								'div',
								{ className: 'productparent' },
								_react2.default.createElement(
									'div',
									{ className: 'raw' },
									_react2.default.createElement(
										'div',
										{ className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'p',
											{ className: 'text-center' },
											'No e-vouchers found'
										)
									)
								)
							);
						}
					}
	
					/* load my catalogue*/
					if (type === "catalogue") {
	
						var myCatalogue = this.state.myCatalogue;
	
						if (typeof myCatalogue !== "undefined" && myCatalogue.length > 0) {} else {
	
							return _react2.default.createElement(
								'div',
								{ className: 'productparent' },
								_react2.default.createElement(
									'div',
									{ className: 'raw' },
									_react2.default.createElement(
										'div',
										{ className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'p',
											{ className: 'text-center' },
											'No e-vouchers found'
										)
									)
								)
							);
						}
					}
				}
			}
		}, {
			key: 'loadProductDate',
			value: function loadProductDate(date) {
				var product_date = new Date(date).toString().split(" ");
				return product_date[2] + "-" + product_date[1] + "-" + product_date[3];
			}
		}, {
			key: 'loadUsedPromotions',
			value: function loadUsedPromotions(e, type) {
				var _this13 = this;
	
				if (this.state.voucherStatus === "Waiting") {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(Loading, null)
					);
				} else {
	
					/* load promotions */
					if (type === "usedpromotions") {
						var myVouchers = this.state.usedVouchers;
						if (myVouchers.length > 0) {
							return myVouchers.map(function (vouch, index) {
								return _react2.default.createElement(
									'div',
									{ className: 'col-md-6', key: index },
									_react2.default.createElement(
										'div',
										{ className: 'promo-box' },
										_react2.default.createElement(
											'div',
											{ className: 'promo-img-item' },
											_react2.default.createElement('img', { src: _this13.loadPromoImage(vouch.product_thumbnail) })
										),
										_react2.default.createElement(
											'div',
											{ className: 'promo-btm-section' },
											_react2.default.createElement(
												'span',
												{ className: 'promo-text' },
												vouch.item_name
											),
											_react2.default.createElement(
												'span',
												{ className: 'promo-amount' },
												_this13.loadProductDate(vouch.expiry_date)
											),
											_react2.default.createElement(
												'div',
												{ className: 'promo-btn-block' },
												_react2.default.createElement(
													_reactRouter.Link,
													{ style: { cursor: 'pointer', textAlign: 'center' }, onClick: _this13.showPromo.bind(_this13, vouch, type), className: 'promo-btn-view' },
													_react2.default.createElement(
														'span',
														null,
														'View'
													)
												)
											)
										)
									)
								);
							});
						} else {
							return _react2.default.createElement(
								'div',
								{ className: 'productparent' },
								_react2.default.createElement(
									'div',
									{ className: 'raw' },
									_react2.default.createElement(
										'div',
										{ className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'p',
											{ className: 'text-center' },
											'No vouchers found'
										)
									)
								)
							);
						}
					}
	
					/* load my catalogue*/
					if (type === "catalogue") {
	
						var myCatalogue = this.state.myCatalogue;
						console.log(myCatalogue);
						if (typeof myCatalogue !== "undefined" && myCatalogue.length > 0) {} else {
							return _react2.default.createElement(
								'div',
								{ className: 'productparent' },
								_react2.default.createElement(
									'div',
									{ className: 'raw' },
									_react2.default.createElement(
										'div',
										{ className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'p',
											{ className: 'text-center' },
											'No vouchers found'
										)
									)
								)
							);
						}
					}
				}
			}
		}, {
			key: '__loadOutlets',
			value: function __loadOutlets() {
				var _this14 = this;
	
				if (this.state.Outlets) {
					var list = helper.getSortedList(this.state.Outlets, this.props.coords);
	
					if (!(0, _lodash.isEmpty)(list) && list.length > 0) {
						return list.map(function (loaddata, index) {
							return _react2.default.createElement(
								'div',
								{ className: 'map-li', key: index, onClick: _this14.pickOutlet.bind(_this14, loaddata.outlet_id, loaddata.outlet_name, loaddata.outlet_postal_code, loaddata.outlet_address_line1, loaddata.outlet_address_line2, loaddata.outlet_unit_number1, loaddata.outlet_unit_number2, loaddata.outlet_pickup_tat, loaddata.outlet_tax_option, loaddata.outlet_tax_surcharge, loaddata.outlet_tax_surcharge_inclusive) },
								_react2.default.createElement(
									'p',
									{ className: 'map-h outlet-name' },
									helper.stripslashes(loaddata.outlet_name)
								),
								_react2.default.createElement(
									'p',
									{ className: 'map-sub' },
									loaddata.outlet_address_line1 + ", " + loaddata.outlet_address_line2 + " " + loaddata.outlet_postal_code
								),
								_react2.default.createElement(_Distancebar2.default, { minDateValue: loaddata.min_date, isOutletBased: loaddata.is_outlet_based, distance: loaddata.distance, coords: _this14.props.coords, tat: loaddata.outlet_pickup_tat ? loaddata.outlet_pickup_tat : loaddata.outlet_delivery_timing })
							);
						});
					} else {
						return _react2.default.createElement(_Outletclosedmessage2.default, { messages: this.state.outletCloseddMessage });
					}
				}
			}
	
			/* pick outlet */
	
		}, {
			key: 'pickOutlet',
			value: function pickOutlet(outlet_id, outlet_name, outlet_postal_code, outlet_address_line1, outlet_address_line2, outlet_unit_number1, outlet_unit_number2, outlet_pickup_tat, outlet_tax_option, outlet_tax_surcharge, outlet_tax_surcharge_inclusive) {
	
				var orderHandled = outlet_name + " " + outlet_address_line1 + " " + outlet_address_line2 + ", Singapore " + outlet_postal_code;
				this.setState({ orderHandled: orderHandled });
				_reactCookie2.default.save('orderOutletId', outlet_id);
				_reactCookie2.default.save('orderOutletName', outlet_name);
				_reactCookie2.default.save('orderPostalCode', outlet_postal_code);
				_reactCookie2.default.save('orderTAT', outlet_pickup_tat);
				_reactCookie2.default.save('orderHandled', orderHandled);
				_reactCookie2.default.save('orderHandledByText', orderHandled);
	
				_reactCookie2.default.save('outlet_tax_option', outlet_tax_option);
				_reactCookie2.default.save('outlet_tax_surcharge', outlet_tax_surcharge);
				_reactCookie2.default.save('outlet_tax_surcharge_inclusive', outlet_tax_surcharge_inclusive);
	
				$("#Pickup-OutletSelection").modal("toggle");
				$("#Pickup-Sucess").modal("toggle");
			}
		}, {
			key: 'loadPromoImage',
			value: function loadPromoImage(promoImage) {
				//console.log(promoImage);
				if (promoImage !== "" && promoImage !== null && typeof promoImage !== 'undefined') {
					return this.state.productimagePath + promoImage;
				} else {
	
					return "img/no-images/products-no-image.jpg";
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this15 = this;
	
				if (this.state.status !== "Loading") {
					return _react2.default.createElement(
						'div',
						{ className: 'container-fluid no-padding ninja-theme-v2 desktop-container', style: { minHeight: this.state.windowHeight } },
						_react2.default.createElement(_reactDocumentMeta2.default, meta),
						_react2.default.createElement(
							'div',
							{ className: 'row', style: { marginLeft: 0, marginRight: 0 } },
							_react2.default.createElement(
								'div',
								{ className: 'col-xs-12 top-nav inner-top-nav head-main' },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-3 nav-head head-child' },
									' ',
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: "/my-account" },
										_react2.default.createElement('img', { src: '/img/icons/arrow-right.png', className: 'left_arr icon-img-small-3', alt: 'left-arrow' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-6 nav-head head-child' },
									_react2.default.createElement(
										'h1',
										{ className: 'main-title vouchers_title' },
										'My e-Vouchers'
									)
								),
								_react2.default.createElement('div', { className: 'col-xs-3' })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'reserve-wrap promo-cat' },
							_react2.default.createElement(
								'div',
								{ className: 'promo-apply-block' },
								_react2.default.createElement(
									'p',
									null,
									'Redeem Your'
								),
								_react2.default.createElement(
									'h2',
									null,
									'e-Vouchers'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'tabbable-panel' },
								_react2.default.createElement(
									'div',
									{ className: 'tabbable-line' },
									_react2.default.createElement(
										'ul',
										{ className: 'nav nav-tabs' },
										_react2.default.createElement(
											'li',
											{ className: 'active' },
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: "#tab_default_1", className: 'vouchers_title', 'data-toggle': 'tab' },
												'e-Vouchers '
											)
										),
										_react2.default.createElement(
											'li',
											null,
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: "#tab_default_2", className: 'vouchers_title', 'data-toggle': 'tab' },
												'Used e-Vouchers '
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'tab-content' },
										_react2.default.createElement(
											'div',
											{ className: 'tab-pane fade in active', id: 'tab_default_1' },
											_react2.default.createElement(
												'div',
												{ className: 'row' },
												this.loadMyPromotions(this, 'promotion')
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'tab-pane fade', id: 'tab_default_2' },
											_react2.default.createElement(
												'div',
												{ className: 'row' },
												this.loadUsedPromotions(this, 'usedpromotions')
											)
										)
									)
								)
							)
						),
						this.loadManualLoading(),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'AddressList' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: true })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/DeliverySucess.png', className: 'img-responsive', alt: true }),
											'Your Delivery Address'
										)
									),
									_react2.default.createElement(Overlay, { load: this.state.load }),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body', style: { textAlign: 'left' } },
										this.loadAddressList(),
										_react2.default.createElement(
											'p',
											null,
											_react2.default.createElement('input', { value: this.state.addressField, onChange: this.handleChangeValue, id: 'postalcode', maxLength: '6', placeholder: 'Enter Your Postal Code', className: 'add_list', onKeyPress: function onKeyPress(e) {
													return _this15.validatezip(e);
												} })
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.selectOutlet.bind(this), className: 'btn btn-raised btn-info ' },
											'Continue'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal common-distance', id: 'delivery_outlet' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog locWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											'PLEASE SELECT WHICH OUTLET DO YOU PREFER'
										)
									),
									_react2.default.createElement(Overlay, { load: this.state.load }),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'div',
											{ className: 'map-loc' },
											_react2.default.createElement(
												'div',
												{ className: 'map-box scrollbar', id: 'style-3' },
												this.__loadDeliveryOutlets()
											),
											_react2.default.createElement('br', null),
											_react2.default.createElement('br', null)
										)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'pickup-outlet-sucess' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: '' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/DeliverySucess.png', className: 'img-responsive', alt: '' }),
											'Awesome, you can pickup !'
										),
										_react2.default.createElement(
											'p',
											null,
											_reactCookie2.default.load('orderHandled')
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body text-center' },
										this.showDeliveryTiming,
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.pickupSuccess.bind(this), className: 'btn btn-raised btn-info ' },
											'Continue'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal', id: 'Pickup-Sucess' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog PopupWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: '' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											_react2.default.createElement('img', { src: '/img/icons/DeliverySucess.png', className: 'img-responsive', alt: '' }),
											'Awesome, you can pickup !'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body text-center' },
										this.showDeliveryTiming,
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'button',
											{ type: 'button', onClick: this.pickupSuccess.bind(this), className: 'btn btn-raised btn-info ' },
											'Continue'
										),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal common-distance', id: 'Pickup-OutletSelection' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog locWidth' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/modal-close.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement(
											'h4',
											{ className: 'modal-title' },
											'Select Your Pickup Location'
										)
									),
									_react2.default.createElement(Overlay, { load: this.state.load }),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'div',
											{ className: 'map-loc' },
											_react2.default.createElement(
												'div',
												{ className: 'map-box scrollbar', id: 'style-3' },
												this.__loadOutlets()
											),
											_react2.default.createElement('br', null),
											_react2.default.createElement('br', null)
										)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'modal ninja-theme-v2 redeem-promocode-modal', style: { display: 'none' }, id: 'RedeemPromocodeModal' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-dialog' },
								_react2.default.createElement(
									'div',
									{ className: 'modal-content' },
									_react2.default.createElement(
										'div',
										{ className: 'modal-header no-padding' },
										_react2.default.createElement(
											'button',
											{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: '/img/icons/black-close.png', className: 'img-responsive', alt: 'close' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-12 no-padding' },
											_react2.default.createElement(
												'div',
												{ className: 'promo-box' },
												_react2.default.createElement(
													'div',
													{ className: 'promo-img-item' },
													_react2.default.createElement('img', { src: this.loadPromoImage(this.state.currentVoucher.product_thumbnail) })
												),
												_react2.default.createElement(
													'div',
													{ className: 'promo-btm-section' },
													_react2.default.createElement(
														'span',
														{ className: 'promo-text' },
														this.state.currentVoucher.item_name
													),
													_react2.default.createElement(
														'span',
														{ className: 'promo-amount' },
														this.state.currentVoucher.product_price
													),
													_react2.default.createElement(
														'span',
														{ className: 'promo-expiry-date' },
														'Valid till ',
														this.state.currentVoucher.expiry_date
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'modal-body' },
										_react2.default.createElement(
											'div',
											{ className: 'promo-code-popup-block' },
											_react2.default.createElement(
												'div',
												{ className: 'promo-pup-content' },
												this.state.currentVoucher.product_long_description !== "" ? htmlToReactParserTo.parse(this.state.currentVoucher.product_long_description) : ''
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-xs-12 promo-redeem-btn-block' },
												this.state.Purchased_voucher === false && this.state.currnetDate < this.state.currentVoucher.expiry_date ? _react2.default.createElement(
													'button',
													{ onClick: this.addToCart.bind(this, this.state.currentVoucher), type: 'button', className: 'btn btn-raised' },
													'Redeem'
												) : ""
											)
										)
									),
									_react2.default.createElement('div', { className: 'modal-footer' })
								)
							)
						)
					);
				} else {
					return _react2.default.createElement(
						'div',
						{ className: 'container-fluid desktop-container' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(Loading, null)
						)
					);
				}
			}
		}]);
	
		return Vouchers;
	}(_react2.default.Component);
	
	exports.default = Vouchers;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(9);
	
	var _App = __webpack_require__(505);
	
	__webpack_require__(615);
	
	var _Home = __webpack_require__(513);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Pages = __webpack_require__(519);
	
	var _Pages2 = _interopRequireDefault(_Pages);
	
	var _Contactus = __webpack_require__(509);
	
	var _Contactus2 = _interopRequireDefault(_Contactus);
	
	var _Products = __webpack_require__(524);
	
	var _Products2 = _interopRequireDefault(_Products);
	
	var _Productsdetails = __webpack_require__(525);
	
	var _Productsdetails2 = _interopRequireDefault(_Productsdetails);
	
	var _Cartitemsedit = __webpack_require__(507);
	
	var _Cartitemsedit2 = _interopRequireDefault(_Cartitemsedit);
	
	var _Cart = __webpack_require__(506);
	
	var _Cart2 = _interopRequireDefault(_Cart);
	
	var _Signin = __webpack_require__(536);
	
	var _Signin2 = _interopRequireDefault(_Signin);
	
	var _Otpsignin = __webpack_require__(518);
	
	var _Otpsignin2 = _interopRequireDefault(_Otpsignin);
	
	var _Signup = __webpack_require__(537);
	
	var _Signup2 = _interopRequireDefault(_Signup);
	
	var _Forgotpassword = __webpack_require__(512);
	
	var _Forgotpassword2 = _interopRequireDefault(_Forgotpassword);
	
	var _Resetpassword = __webpack_require__(534);
	
	var _Resetpassword2 = _interopRequireDefault(_Resetpassword);
	
	var _Myaccount = __webpack_require__(514);
	
	var _Myaccount2 = _interopRequireDefault(_Myaccount);
	
	var _Addons = __webpack_require__(503);
	
	var _Addons2 = _interopRequireDefault(_Addons);
	
	var _Qrcodescan = __webpack_require__(529);
	
	var _Qrcodescan2 = _interopRequireDefault(_Qrcodescan);
	
	var _QrCodeReader = __webpack_require__(528);
	
	var _QrCodeReader2 = _interopRequireDefault(_QrCodeReader);
	
	var _Chekout = __webpack_require__(508);
	
	var _Chekout2 = _interopRequireDefault(_Chekout);
	
	var _Placeorder = __webpack_require__(523);
	
	var _Placeorder2 = _interopRequireDefault(_Placeorder);
	
	var _Payment = __webpack_require__(520);
	
	var _Payment2 = _interopRequireDefault(_Payment);
	
	var _Ordersuccess = __webpack_require__(517);
	
	var _Ordersuccess2 = _interopRequireDefault(_Ordersuccess);
	
	var _StripeCheckout = __webpack_require__(538);
	
	var _StripeCheckout2 = _interopRequireDefault(_StripeCheckout);
	
	var _Orders = __webpack_require__(516);
	
	var _Orders2 = _interopRequireDefault(_Orders);
	
	var _DeliveryDatePicker = __webpack_require__(510);
	
	var _DeliveryDatePicker2 = _interopRequireDefault(_DeliveryDatePicker);
	
	var _DeliveryDatePickerNew = __webpack_require__(511);
	
	var _DeliveryDatePickerNew2 = _interopRequireDefault(_DeliveryDatePickerNew);
	
	var _Advancedtimeslot = __webpack_require__(504);
	
	var _Advancedtimeslot2 = _interopRequireDefault(_Advancedtimeslot);
	
	var _NotFound = __webpack_require__(515);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	var _Activation = __webpack_require__(502);
	
	var _Activation2 = _interopRequireDefault(_Activation);
	
	var _Unsubscribe = __webpack_require__(539);
	
	var _Unsubscribe2 = _interopRequireDefault(_Unsubscribe);
	
	var _Rewards = __webpack_require__(535);
	
	var _Rewards2 = _interopRequireDefault(_Rewards);
	
	var _Reservation = __webpack_require__(531);
	
	var _Reservation2 = _interopRequireDefault(_Reservation);
	
	var _ReservationActivation = __webpack_require__(532);
	
	var _ReservationActivation2 = _interopRequireDefault(_ReservationActivation);
	
	var _Promotion = __webpack_require__(527);
	
	var _Promotion2 = _interopRequireDefault(_Promotion);
	
	var _Promobuddytracking = __webpack_require__(526);
	
	var _Promobuddytracking2 = _interopRequireDefault(_Promobuddytracking);
	
	var _Reservationaccept = __webpack_require__(533);
	
	var _Reservationaccept2 = _interopRequireDefault(_Reservationaccept);
	
	var _reactGtmModule = __webpack_require__(836);
	
	var _reactGtmModule2 = _interopRequireDefault(_reactGtmModule);
	
	var _reactCookie = __webpack_require__(8);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	var _Quickbook = __webpack_require__(530);
	
	var _Quickbook2 = _interopRequireDefault(_Quickbook);
	
	var _Vouchers = __webpack_require__(540);
	
	var _Vouchers2 = _interopRequireDefault(_Vouchers);
	
	var _Paymentrequest = __webpack_require__(522);
	
	var _Paymentrequest2 = _interopRequireDefault(_Paymentrequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* for GTM */
	//Cartitemsedit
	/* eslint-disable */
	var gtmID = typeof _reactCookie2.default.load("gtm_id") !== null ? _reactCookie2.default.load("gtm_id") : ""; //Cartitemsedit
	
	if (gtmID) {
			var tagManagerArgs = {
					gtmId: gtmID
			};
			_reactGtmModule2.default.initialize(tagManagerArgs);
	}
	
	_reactDom2.default.render(_react2.default.createElement(
			_reactRouter.Router,
			{ history: _reactRouter.hashHistory },
			_react2.default.createElement(
					_reactRouter.Route,
					{ path: '/', component: _App.App },
					_react2.default.createElement(_reactRouter.IndexRoute, { component: _Home2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/home', component: _Home2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/promotion', component: _Promotion2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/pages/:pageSlug', component: _Pages2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/module/:pageSlug', component: _Contactus2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/products/:categoryType/:categoryId', component: _Products2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/products/:categoryType/:categoryId/:slideno', component: _Products2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/product/:productSlug', component: _Productsdetails2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/product/:productSlug/:type/:cartItemId', component: _Productsdetails2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/cart', component: _Cart2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/add-on', component: _Addons2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/sign-in', component: _Signin2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/new-signin', component: _Otpsignin2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/sign-up', component: _Signup2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/account/activation/:activationId', component: _Activation2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/unsubscribe/:activationId', component: _Unsubscribe2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/account/resetpassword/:resetId', component: _Resetpassword2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/forgot-password', component: _Forgotpassword2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/book-a-table', component: _Qrcodescan2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/book-a-table/:tableNo', component: _Qrcodescan2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/qrcode-scan', component: _QrCodeReader2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/checkout', component: _Chekout2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/placeorder', component: _Placeorder2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/order-success/:orderId', component: _Ordersuccess2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/StripeCheckout', component: _StripeCheckout2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/Promobuddytracking/:token/:tokenId', component: _Promobuddytracking2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/chopchoptracking/:token/:tokenId', component: _Promobuddytracking2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/my-account', component: _Myaccount2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/orders', component: _Orders2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/rewards', component: _Rewards2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/reservation', component: _Reservation2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/dashboard/:UserId', component: _Myaccount2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/pay-now', component: _Payment2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/delivery-date', component: _DeliveryDatePicker2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/delivery-date-new', component: _DeliveryDatePickerNew2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/delivery-date-advanced', component: _Advancedtimeslot2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/cartreservation_suggest/:type/:keyval', component: _ReservationActivation2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/reservation_suggest/accept/:reservationID', component: _Reservationaccept2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/reservation_suggest/reject/:reservationID', component: _Reservationaccept2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/payment-request/:orderId/:paymentId', component: _Paymentrequest2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/quickbook/:tableNo', component: _Quickbook2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/vouchers', component: _Vouchers2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '*', component: _NotFound2.default })
			)
	), document.getElementById('root'));

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(209), __esModule: true };

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(210), __esModule: true };

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(212), __esModule: true };

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(213), __esModule: true };

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(214), __esModule: true };

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(204);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ },
/* 548 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/base64 v1.0.0 by @mathias | MIT license */
	;(function(root) {
	
		// Detect free variables `exports`.
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`.
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code, and use
		// it as `root`.
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		var InvalidCharacterError = function(message) {
			this.message = message;
		};
		InvalidCharacterError.prototype = new Error;
		InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
		var error = function(message) {
			// Note: the error messages used throughout this file match those used by
			// the native `atob`/`btoa` implementation in Chromium.
			throw new InvalidCharacterError(message);
		};
	
		var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
		// http://whatwg.org/html/common-microsyntaxes.html#space-character
		var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;
	
		// `decode` is designed to be fully compatible with `atob` as described in the
		// HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
		// The optimized base64-decoding algorithm used is based on @atk’s excellent
		// implementation. https://gist.github.com/atk/1020396
		var decode = function(input) {
			input = String(input)
				.replace(REGEX_SPACE_CHARACTERS, '');
			var length = input.length;
			if (length % 4 == 0) {
				input = input.replace(/==?$/, '');
				length = input.length;
			}
			if (
				length % 4 == 1 ||
				// http://whatwg.org/C#alphanumeric-ascii-characters
				/[^+a-zA-Z0-9/]/.test(input)
			) {
				error(
					'Invalid character: the string to be decoded is not correctly encoded.'
				);
			}
			var bitCounter = 0;
			var bitStorage;
			var buffer;
			var output = '';
			var position = -1;
			while (++position < length) {
				buffer = TABLE.indexOf(input.charAt(position));
				bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
				// Unless this is the first of a group of 4 characters…
				if (bitCounter++ % 4) {
					// …convert the first 8 bits to a single ASCII character.
					output += String.fromCharCode(
						0xFF & bitStorage >> (-2 * bitCounter & 6)
					);
				}
			}
			return output;
		};
	
		// `encode` is designed to be fully compatible with `btoa` as described in the
		// HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
		var encode = function(input) {
			input = String(input);
			if (/[^\0-\xFF]/.test(input)) {
				// Note: no need to special-case astral symbols here, as surrogates are
				// matched, and the input is supposed to only contain ASCII anyway.
				error(
					'The string to be encoded contains characters outside of the ' +
					'Latin1 range.'
				);
			}
			var padding = input.length % 3;
			var output = '';
			var position = -1;
			var a;
			var b;
			var c;
			var buffer;
			// Make sure any padding is handled outside of the loop.
			var length = input.length - padding;
	
			while (++position < length) {
				// Read three bytes, i.e. 24 bits.
				a = input.charCodeAt(position) << 16;
				b = input.charCodeAt(++position) << 8;
				c = input.charCodeAt(++position);
				buffer = a + b + c;
				// Turn the 24 bits into four chunks of 6 bits each, and append the
				// matching character for each of them to the output.
				output += (
					TABLE.charAt(buffer >> 18 & 0x3F) +
					TABLE.charAt(buffer >> 12 & 0x3F) +
					TABLE.charAt(buffer >> 6 & 0x3F) +
					TABLE.charAt(buffer & 0x3F)
				);
			}
	
			if (padding == 2) {
				a = input.charCodeAt(position) << 8;
				b = input.charCodeAt(++position);
				buffer = a + b;
				output += (
					TABLE.charAt(buffer >> 10) +
					TABLE.charAt((buffer >> 4) & 0x3F) +
					TABLE.charAt((buffer << 2) & 0x3F) +
					'='
				);
			} else if (padding == 1) {
				buffer = input.charCodeAt(position);
				output += (
					TABLE.charAt(buffer >> 2) +
					TABLE.charAt((buffer << 4) & 0x3F) +
					'=='
				);
			}
	
			return output;
		};
	
		var base64 = {
			'encode': encode,
			'decode': decode,
			'version': '1.0.0'
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return base64;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = base64;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (var key in base64) {
					base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.base64 = base64;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(128)(module), (function() { return this; }())))

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	var merge = __webpack_require__(553),
	    countDefinedItems = __webpack_require__(551),
	    slice = Array.prototype.slice,
	    __;
	
	
	function curry(fn, length, curryArgs) {
	  return function() {
	    var args = slice.call(arguments),
	      concatArgs = curryArgs.concat(args),
	      mergedArgs = [];
	
	    if (length <= countDefinedItems(concatArgs)) {
	      mergedArgs = merge(args, curryArgs);
	      return fn.apply(null, mergedArgs);
	    } else {
	      if (length >= concatArgs.length) {
	        return curry(fn, length, concatArgs);
	      } else {
	        return curry(fn, length, merge(args, curryArgs));
	      }
	    }
	  };
	}
	
	module.exports = function(fn) {
	  var args = slice.call(arguments, 1);
	
	  return curry(fn, fn.length, args);
	};
	
	module.exports.n = function(fn, length) {
	  var args = slice.call(arguments, 2);
	
	  return curry(fn, length, args);
	};
	
	module.exports.__ = __;


/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	var forEach = __webpack_require__(207);
	
	module.exports = function(args) {
	  var count = 0;
	
	  forEach(args, function(key, item) {
	    if (typeof item !== 'undefined') {
	      count = count + 1;
	    }
	  });
	
	  return count;
	};


/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	var forEach = __webpack_require__(207);
	
	module.exports = function map(arr, fn) {
	  var newArr = [];
	
	  forEach(arr, function(key, item) {
	    newArr.push(fn(key, item));
	  });
	
	  return newArr;
	};


/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	var map = __webpack_require__(552);
	
	module.exports = function merge(args, curryArgs) {
	  var mergedArgs = [];
	
	  mergedArgs = map(curryArgs, function(key, item) {
	    if (typeof item === 'undefined') {
	      return args.shift();
	    } else {
	      return item;
	    }
	  });
	
	  return mergedArgs.concat(args);
	};


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	try {
	  var index = __webpack_require__(208);
	} catch (err) {
	  var index = __webpack_require__(208);
	}
	
	/**
	 * Whitespace regexp.
	 */
	
	var re = /\s+/;
	
	/**
	 * toString reference.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Wrap `el` in a `ClassList`.
	 *
	 * @param {Element} el
	 * @return {ClassList}
	 * @api public
	 */
	
	module.exports = function(el){
	  return new ClassList(el);
	};
	
	/**
	 * Initialize a new ClassList for `el`.
	 *
	 * @param {Element} el
	 * @api private
	 */
	
	function ClassList(el) {
	  if (!el || !el.nodeType) {
	    throw new Error('A DOM element reference is required');
	  }
	  this.el = el;
	  this.list = el.classList;
	}
	
	/**
	 * Add class `name` if not already present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.add = function(name){
	  // classList
	  if (this.list) {
	    this.list.add(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (!~i) arr.push(name);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove class `name` when present, or
	 * pass a regular expression to remove
	 * any which match.
	 *
	 * @param {String|RegExp} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.remove = function(name){
	  if ('[object RegExp]' == toString.call(name)) {
	    return this.removeMatching(name);
	  }
	
	  // classList
	  if (this.list) {
	    this.list.remove(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (~i) arr.splice(i, 1);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove all classes matching `re`.
	 *
	 * @param {RegExp} re
	 * @return {ClassList}
	 * @api private
	 */
	
	ClassList.prototype.removeMatching = function(re){
	  var arr = this.array();
	  for (var i = 0; i < arr.length; i++) {
	    if (re.test(arr[i])) {
	      this.remove(arr[i]);
	    }
	  }
	  return this;
	};
	
	/**
	 * Toggle class `name`, can force state via `force`.
	 *
	 * For browsers that support classList, but do not support `force` yet,
	 * the mistake will be detected and corrected.
	 *
	 * @param {String} name
	 * @param {Boolean} force
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.toggle = function(name, force){
	  // classList
	  if (this.list) {
	    if ("undefined" !== typeof force) {
	      if (force !== this.list.toggle(name, force)) {
	        this.list.toggle(name); // toggle again to correct
	      }
	    } else {
	      this.list.toggle(name);
	    }
	    return this;
	  }
	
	  // fallback
	  if ("undefined" !== typeof force) {
	    if (!force) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  } else {
	    if (this.has(name)) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return an array of classes.
	 *
	 * @return {Array}
	 * @api public
	 */
	
	ClassList.prototype.array = function(){
	  var className = this.el.getAttribute('class') || '';
	  var str = className.replace(/^\s+|\s+$/g, '');
	  var arr = str.split(re);
	  if ('' === arr[0]) arr.shift();
	  return arr;
	};
	
	/**
	 * Check if class `name` is present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.has =
	ClassList.prototype.contains = function(name){
	  return this.list
	    ? this.list.contains(name)
	    : !! ~index(this.array(), name);
	};


/***/ },
/* 555 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	// Adapted from Modernizr
	// https://github.com/Modernizr/Modernizr/blob/acb3f0d9/feature-detects/dom/passiveeventlisteners.js#L26-L37
	function testPassiveEventListeners() {
	  if (!CAN_USE_DOM) {
	    return false;
	  }
	
	  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
	    return false;
	  }
	
	  var supportsPassiveOption = false;
	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      // eslint-disable-next-line getter-return
	      get: function () {
	        function get() {
	          supportsPassiveOption = true;
	        }
	
	        return get;
	      }()
	    });
	    var noop = function noop() {};
	    window.addEventListener('testPassiveEventSupport', noop, opts);
	    window.removeEventListener('testPassiveEventSupport', noop, opts);
	  } catch (e) {
	    // do nothing
	  }
	
	  return supportsPassiveOption;
	}
	
	var memoized = void 0;
	
	function canUsePassiveEventListeners() {
	  if (memoized === undefined) {
	    memoized = testPassiveEventListeners();
	  }
	  return memoized;
	}
	
	function normalizeEventOptions(eventOptions) {
	  if (!eventOptions) {
	    return undefined;
	  }
	
	  if (!canUsePassiveEventListeners()) {
	    // If the browser does not support the passive option, then it is expecting
	    // a boolean for the options argument to specify whether it should use
	    // capture or not. In more modern browsers, this is passed via the `capture`
	    // option, so let's just hoist that value up.
	    return !!eventOptions.capture;
	  }
	
	  return eventOptions;
	}
	
	/* eslint-disable no-bitwise */
	
	/**
	 * Generate a unique key for any set of event options
	 */
	function eventOptionsKey(normalizedEventOptions) {
	  if (!normalizedEventOptions) {
	    return 0;
	  }
	
	  // If the browser does not support passive event listeners, the normalized
	  // event options will be a boolean.
	  if (normalizedEventOptions === true) {
	    return 100;
	  }
	
	  // At this point, the browser supports passive event listeners, so we expect
	  // the event options to be an object with possible properties of capture,
	  // passive, and once.
	  //
	  // We want to consistently return the same value, regardless of the order of
	  // these properties, so let's use binary maths to assign each property to a
	  // bit, and then add those together (with an offset to account for the
	  // booleans at the beginning of this function).
	  var capture = normalizedEventOptions.capture << 0;
	  var passive = normalizedEventOptions.passive << 1;
	  var once = normalizedEventOptions.once << 2;
	  return capture + passive + once;
	}
	
	function ensureCanMutateNextEventHandlers(eventHandlers) {
	  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
	    // eslint-disable-next-line no-param-reassign
	    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
	  }
	}
	
	function TargetEventHandlers(target) {
	  this.target = target;
	  this.events = {};
	}
	
	TargetEventHandlers.prototype.getEventHandlers = function () {
	  function getEventHandlers(eventName, options) {
	    var key = String(eventName) + ' ' + String(eventOptionsKey(options));
	
	    if (!this.events[key]) {
	      this.events[key] = {
	        handlers: [],
	        handleEvent: undefined
	      };
	      this.events[key].nextHandlers = this.events[key].handlers;
	    }
	
	    return this.events[key];
	  }
	
	  return getEventHandlers;
	}();
	
	TargetEventHandlers.prototype.handleEvent = function () {
	  function handleEvent(eventName, options, event) {
	    var eventHandlers = this.getEventHandlers(eventName, options);
	    eventHandlers.handlers = eventHandlers.nextHandlers;
	    eventHandlers.handlers.forEach(function (handler) {
	      if (handler) {
	        // We need to check for presence here because a handler function may
	        // cause later handlers to get removed. This can happen if you for
	        // instance have a waypoint that unmounts another waypoint as part of an
	        // onEnter/onLeave handler.
	        handler(event);
	      }
	    });
	  }
	
	  return handleEvent;
	}();
	
	TargetEventHandlers.prototype.add = function () {
	  function add(eventName, listener, options) {
	    var _this = this;
	
	    // options has already been normalized at this point.
	    var eventHandlers = this.getEventHandlers(eventName, options);
	
	    ensureCanMutateNextEventHandlers(eventHandlers);
	
	    if (eventHandlers.nextHandlers.length === 0) {
	      eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);
	
	      this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
	    }
	
	    eventHandlers.nextHandlers.push(listener);
	
	    var isSubscribed = true;
	    var unsubscribe = function () {
	      function unsubscribe() {
	        if (!isSubscribed) {
	          return;
	        }
	
	        isSubscribed = false;
	
	        ensureCanMutateNextEventHandlers(eventHandlers);
	        var index = eventHandlers.nextHandlers.indexOf(listener);
	        eventHandlers.nextHandlers.splice(index, 1);
	
	        if (eventHandlers.nextHandlers.length === 0) {
	          // All event handlers have been removed, so we want to remove the event
	          // listener from the target node.
	
	          if (_this.target) {
	            // There can be a race condition where the target may no longer exist
	            // when this function is called, e.g. when a React component is
	            // unmounting. Guarding against this prevents the following error:
	            //
	            //   Cannot read property 'removeEventListener' of undefined
	            _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
	          }
	
	          eventHandlers.handleEvent = undefined;
	        }
	      }
	
	      return unsubscribe;
	    }();
	    return unsubscribe;
	  }
	
	  return add;
	}();
	
	var EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';
	
	// eslint-disable-next-line import/prefer-default-export
	function addEventListener(target, eventName, listener, options) {
	  if (!target[EVENT_HANDLERS_KEY]) {
	    // eslint-disable-next-line no-param-reassign
	    target[EVENT_HANDLERS_KEY] = new TargetEventHandlers(target);
	  }
	  var normalizedEventOptions = normalizeEventOptions(options);
	  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
	}
	
	exports.addEventListener = addEventListener;


/***/ },
/* 556 */
/***/ function(module, exports) {

	/*!
	 * cookie
	 * Copyright(c) 2012-2014 Roman Shtylman
	 * Copyright(c) 2015 Douglas Christopher Wilson
	 * MIT Licensed
	 */
	
	'use strict';
	
	/**
	 * Module exports.
	 * @public
	 */
	
	exports.parse = parse;
	exports.serialize = serialize;
	
	/**
	 * Module variables.
	 * @private
	 */
	
	var decode = decodeURIComponent;
	var encode = encodeURIComponent;
	var pairSplitRegExp = /; */;
	
	/**
	 * RegExp to match field-content in RFC 7230 sec 3.2
	 *
	 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
	 * field-vchar   = VCHAR / obs-text
	 * obs-text      = %x80-FF
	 */
	
	var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
	
	/**
	 * Parse a cookie header.
	 *
	 * Parse the given cookie header string into an object
	 * The object has the various cookies as keys(names) => values
	 *
	 * @param {string} str
	 * @param {object} [options]
	 * @return {object}
	 * @public
	 */
	
	function parse(str, options) {
	  if (typeof str !== 'string') {
	    throw new TypeError('argument str must be a string');
	  }
	
	  var obj = {}
	  var opt = options || {};
	  var pairs = str.split(pairSplitRegExp);
	  var dec = opt.decode || decode;
	
	  for (var i = 0; i < pairs.length; i++) {
	    var pair = pairs[i];
	    var eq_idx = pair.indexOf('=');
	
	    // skip things that don't look like key=value
	    if (eq_idx < 0) {
	      continue;
	    }
	
	    var key = pair.substr(0, eq_idx).trim()
	    var val = pair.substr(++eq_idx, pair.length).trim();
	
	    // quoted values
	    if ('"' == val[0]) {
	      val = val.slice(1, -1);
	    }
	
	    // only assign once
	    if (undefined == obj[key]) {
	      obj[key] = tryDecode(val, dec);
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Serialize data into a cookie header.
	 *
	 * Serialize the a name value pair into a cookie string suitable for
	 * http headers. An optional options object specified cookie parameters.
	 *
	 * serialize('foo', 'bar', { httpOnly: true })
	 *   => "foo=bar; httpOnly"
	 *
	 * @param {string} name
	 * @param {string} val
	 * @param {object} [options]
	 * @return {string}
	 * @public
	 */
	
	function serialize(name, val, options) {
	  var opt = options || {};
	  var enc = opt.encode || encode;
	
	  if (typeof enc !== 'function') {
	    throw new TypeError('option encode is invalid');
	  }
	
	  if (!fieldContentRegExp.test(name)) {
	    throw new TypeError('argument name is invalid');
	  }
	
	  var value = enc(val);
	
	  if (value && !fieldContentRegExp.test(value)) {
	    throw new TypeError('argument val is invalid');
	  }
	
	  var str = name + '=' + value;
	
	  if (null != opt.maxAge) {
	    var maxAge = opt.maxAge - 0;
	    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
	    str += '; Max-Age=' + Math.floor(maxAge);
	  }
	
	  if (opt.domain) {
	    if (!fieldContentRegExp.test(opt.domain)) {
	      throw new TypeError('option domain is invalid');
	    }
	
	    str += '; Domain=' + opt.domain;
	  }
	
	  if (opt.path) {
	    if (!fieldContentRegExp.test(opt.path)) {
	      throw new TypeError('option path is invalid');
	    }
	
	    str += '; Path=' + opt.path;
	  }
	
	  if (opt.expires) {
	    if (typeof opt.expires.toUTCString !== 'function') {
	      throw new TypeError('option expires is invalid');
	    }
	
	    str += '; Expires=' + opt.expires.toUTCString();
	  }
	
	  if (opt.httpOnly) {
	    str += '; HttpOnly';
	  }
	
	  if (opt.secure) {
	    str += '; Secure';
	  }
	
	  if (opt.sameSite) {
	    var sameSite = typeof opt.sameSite === 'string'
	      ? opt.sameSite.toLowerCase() : opt.sameSite;
	
	    switch (sameSite) {
	      case true:
	        str += '; SameSite=Strict';
	        break;
	      case 'lax':
	        str += '; SameSite=Lax';
	        break;
	      case 'strict':
	        str += '; SameSite=Strict';
	        break;
	      default:
	        throw new TypeError('option sameSite is invalid');
	    }
	  }
	
	  return str;
	}
	
	/**
	 * Try decoding a string using a decoding function.
	 *
	 * @param {string} str
	 * @param {function} decode
	 * @private
	 */
	
	function tryDecode(str, decode) {
	  try {
	    return decode(str);
	  } catch (e) {
	    return str;
	  }
	}


/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(32);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(580);
	module.exports = __webpack_require__(32).Object.getPrototypeOf;


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(581);
	module.exports = __webpack_require__(32).Object.keys;


/***/ },
/* 560 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 561 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(69);
	var toLength = __webpack_require__(575);
	var toAbsoluteIndex = __webpack_require__(574);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(91);
	var gOPS = __webpack_require__(136);
	var pIE = __webpack_require__(106);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(41).document;
	module.exports = document && document.documentElement;


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(215);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(135);
	var descriptor = __webpack_require__(107);
	var setToStringTag = __webpack_require__(137);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(67)(IteratorPrototype, __webpack_require__(70)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 567 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(108)('meta');
	var isObject = __webpack_require__(68);
	var has = __webpack_require__(53);
	var setDesc = __webpack_require__(54).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(66)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(40);
	var getKeys = __webpack_require__(91);
	var gOPS = __webpack_require__(136);
	var pIE = __webpack_require__(106);
	var toObject = __webpack_require__(92);
	var IObject = __webpack_require__(219);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(66)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(54);
	var anObject = __webpack_require__(90);
	var getKeys = __webpack_require__(91);
	
	module.exports = __webpack_require__(40) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(69);
	var gOPN = __webpack_require__(222).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(68);
	var anObject = __webpack_require__(90);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(216)(Function.call, __webpack_require__(221).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(140);
	var defined = __webpack_require__(132);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(140);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(140);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(561);
	var step = __webpack_require__(567);
	var Iterators = __webpack_require__(134);
	var toIObject = __webpack_require__(69);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(220)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(52);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(569) });


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(52);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(135) });


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(52);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(40), 'Object', { defineProperty: __webpack_require__(54).f });


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(92);
	var $getPrototypeOf = __webpack_require__(223);
	
	__webpack_require__(225)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(92);
	var $keys = __webpack_require__(91);
	
	__webpack_require__(225)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(52);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(572).set });


/***/ },
/* 583 */
/***/ function(module, exports) {



/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(573)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(220)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(41);
	var has = __webpack_require__(53);
	var DESCRIPTORS = __webpack_require__(40);
	var $export = __webpack_require__(52);
	var redefine = __webpack_require__(226);
	var META = __webpack_require__(568).KEY;
	var $fails = __webpack_require__(66);
	var shared = __webpack_require__(139);
	var setToStringTag = __webpack_require__(137);
	var uid = __webpack_require__(108);
	var wks = __webpack_require__(70);
	var wksExt = __webpack_require__(143);
	var wksDefine = __webpack_require__(142);
	var enumKeys = __webpack_require__(563);
	var isArray = __webpack_require__(565);
	var anObject = __webpack_require__(90);
	var isObject = __webpack_require__(68);
	var toObject = __webpack_require__(92);
	var toIObject = __webpack_require__(69);
	var toPrimitive = __webpack_require__(141);
	var createDesc = __webpack_require__(107);
	var _create = __webpack_require__(135);
	var gOPNExt = __webpack_require__(571);
	var $GOPD = __webpack_require__(221);
	var $GOPS = __webpack_require__(136);
	var $DP = __webpack_require__(54);
	var $keys = __webpack_require__(91);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(222).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(106).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(105)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(67)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(142)('asyncIterator');


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(142)('observable');


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(576);
	var global = __webpack_require__(41);
	var hide = __webpack_require__(67);
	var Iterators = __webpack_require__(134);
	var TO_STRING_TAG = __webpack_require__(70)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(589);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 591 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var START_EVENT_NAME_MAP = {
	  transitionstart: {
	    transition: 'transitionstart',
	    WebkitTransition: 'webkitTransitionStart',
	    MozTransition: 'mozTransitionStart',
	    OTransition: 'oTransitionStart',
	    msTransition: 'MSTransitionStart'
	  },
	
	  animationstart: {
	    animation: 'animationstart',
	    WebkitAnimation: 'webkitAnimationStart',
	    MozAnimation: 'mozAnimationStart',
	    OAnimation: 'oAnimationStart',
	    msAnimation: 'MSAnimationStart'
	  }
	};
	
	var END_EVENT_NAME_MAP = {
	  transitionend: {
	    transition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd',
	    MozTransition: 'mozTransitionEnd',
	    OTransition: 'oTransitionEnd',
	    msTransition: 'MSTransitionEnd'
	  },
	
	  animationend: {
	    animation: 'animationend',
	    WebkitAnimation: 'webkitAnimationEnd',
	    MozAnimation: 'mozAnimationEnd',
	    OAnimation: 'oAnimationEnd',
	    msAnimation: 'MSAnimationEnd'
	  }
	};
	
	var startEvents = [];
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  if (!('AnimationEvent' in window)) {
	    delete START_EVENT_NAME_MAP.animationstart.animation;
	    delete END_EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete START_EVENT_NAME_MAP.transitionstart.transition;
	    delete END_EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  function process(EVENT_NAME_MAP, events) {
	    for (var baseEventName in EVENT_NAME_MAP) {
	      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
	        var baseEvents = EVENT_NAME_MAP[baseEventName];
	        for (var styleName in baseEvents) {
	          if (styleName in style) {
	            events.push(baseEvents[styleName]);
	            break;
	          }
	        }
	      }
	    }
	  }
	
	  process(START_EVENT_NAME_MAP, startEvents);
	  process(END_EVENT_NAME_MAP, endEvents);
	}
	
	if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	  detectEvents();
	}
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var TransitionEvents = {
	  // Start events
	  startEvents: startEvents,
	
	  addStartEventListener: function addStartEventListener(node, eventListener) {
	    if (startEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    startEvents.forEach(function (startEvent) {
	      addEventListener(node, startEvent, eventListener);
	    });
	  },
	  removeStartEventListener: function removeStartEventListener(node, eventListener) {
	    if (startEvents.length === 0) {
	      return;
	    }
	    startEvents.forEach(function (startEvent) {
	      removeEventListener(node, startEvent, eventListener);
	    });
	  },
	
	
	  // End events
	  endEvents: endEvents,
	
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = TransitionEvents;
	module.exports = exports['default'];

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isCssAnimationSupported = undefined;
	
	var _typeof2 = __webpack_require__(131);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _Event = __webpack_require__(591);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	var _componentClasses = __webpack_require__(554);
	
	var _componentClasses2 = _interopRequireDefault(_componentClasses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var isCssAnimationSupported = _Event2['default'].endEvents.length !== 0;
	var capitalPrefixes = ['Webkit', 'Moz', 'O',
	// ms is special .... !
	'ms'];
	var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];
	
	function getStyleProperty(node, name) {
	  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
	  var style = window.getComputedStyle(node, null);
	  var ret = '';
	  for (var i = 0; i < prefixes.length; i++) {
	    ret = style.getPropertyValue(prefixes[i] + name);
	    if (ret) {
	      break;
	    }
	  }
	  return ret;
	}
	
	function fixBrowserByTimeout(node) {
	  if (isCssAnimationSupported) {
	    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
	    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
	    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
	    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
	    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
	    // sometimes, browser bug
	    node.rcEndAnimTimeout = setTimeout(function () {
	      node.rcEndAnimTimeout = null;
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }, time * 1000 + 200);
	  }
	}
	
	function clearBrowserBugTimeout(node) {
	  if (node.rcEndAnimTimeout) {
	    clearTimeout(node.rcEndAnimTimeout);
	    node.rcEndAnimTimeout = null;
	  }
	}
	
	var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
	  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : (0, _typeof3['default'])(transitionName)) === 'object';
	  var className = nameIsObj ? transitionName.name : transitionName;
	  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
	  var end = endCallback;
	  var start = void 0;
	  var active = void 0;
	  var nodeClasses = (0, _componentClasses2['default'])(node);
	
	  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
	    end = endCallback.end;
	    start = endCallback.start;
	    active = endCallback.active;
	  }
	
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    nodeClasses.remove(className);
	    nodeClasses.remove(activeClassName);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional end is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (end) {
	      end();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  if (start) {
	    start();
	  }
	  nodeClasses.add(className);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    node.rcAnimTimeout = null;
	    nodeClasses.add(activeClassName);
	    if (active) {
	      setTimeout(active, 0);
	    }
	    fixBrowserByTimeout(node);
	    // 30ms for firefox
	  }, 30);
	
	  return {
	    stop: function stop() {
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }
	  };
	};
	
	cssAnimation.style = function (node, style, callback) {
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional callback is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (callback) {
	      callback();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    for (var s in style) {
	      if (style.hasOwnProperty(s)) {
	        node.style[s] = style[s];
	      }
	    }
	    node.rcAnimTimeout = null;
	    fixBrowserByTimeout(node);
	  }, 0);
	};
	
	cssAnimation.setTransition = function (node, p, value) {
	  var property = p;
	  var v = value;
	  if (value === undefined) {
	    v = property;
	    property = '';
	  }
	  property = property || '';
	  capitalPrefixes.forEach(function (prefix) {
	    node.style[prefix + 'Transition' + property] = v;
	  });
	};
	
	cssAnimation.isCssAnimationSupported = isCssAnimationSupported;
	
	exports.isCssAnimationSupported = isCssAnimationSupported;
	exports['default'] = cssAnimation;

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasPropertyDescriptors = __webpack_require__(238)();
	
	var GetIntrinsic = __webpack_require__(73);
	
	var $defineProperty = hasPropertyDescriptors && GetIntrinsic('%Object.defineProperty%', true);
	
	var $SyntaxError = GetIntrinsic('%SyntaxError%');
	var $TypeError = GetIntrinsic('%TypeError%');
	
	var gopd = __webpack_require__(629);
	
	/** @type {(obj: Record<PropertyKey, unknown>, property: PropertyKey, value: unknown, nonEnumerable?: boolean | null, nonWritable?: boolean | null, nonConfigurable?: boolean | null, loose?: boolean) => void} */
	module.exports = function defineDataProperty(
		obj,
		property,
		value
	) {
		if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
			throw new $TypeError('`obj` must be an object or a function`');
		}
		if (typeof property !== 'string' && typeof property !== 'symbol') {
			throw new $TypeError('`property` must be a string or a symbol`');
		}
		if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
			throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
			throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
			throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
			throw new $TypeError('`loose`, if provided, must be a boolean');
		}
	
		var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
		var nonWritable = arguments.length > 4 ? arguments[4] : null;
		var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
		var loose = arguments.length > 6 ? arguments[6] : false;
	
		/* @type {false | TypedPropertyDescriptor<unknown>} */
		var desc = !!gopd && gopd(obj, property);
	
		if ($defineProperty) {
			$defineProperty(obj, property, {
				configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
				enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
				value: value,
				writable: nonWritable === null && desc ? desc.writable : !nonWritable
			});
		} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
			// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
			obj[property] = value; // eslint-disable-line no-param-reassign
		} else {
			throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
		}
	};


/***/ },
/* 594 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function getRect(element) {
	    return element.getBoundingClientRect();
	}
	function detectElementOverflow(element, container) {
	    return {
	        get collidedTop() {
	            return getRect(element).top < getRect(container).top;
	        },
	        get collidedBottom() {
	            return getRect(element).bottom > getRect(container).bottom;
	        },
	        get collidedLeft() {
	            return getRect(element).left < getRect(container).left;
	        },
	        get collidedRight() {
	            return getRect(element).right > getRect(container).right;
	        },
	        get overflowTop() {
	            return getRect(container).top - getRect(element).top;
	        },
	        get overflowBottom() {
	            return getRect(element).bottom - getRect(container).bottom;
	        },
	        get overflowLeft() {
	            return getRect(container).left - getRect(element).left;
	        },
	        get overflowRight() {
	            return getRect(element).right - getRect(container).right;
	        },
	    };
	}
	exports.default = detectElementOverflow;


/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(109);
	
	var implementation = __webpack_require__(227);
	var getPolyfill = __webpack_require__(228);
	var polyfill = getPolyfill();
	var shim = __webpack_require__(596);
	
	var boundContains = function contains(node, other) {
		return polyfill.apply(node, [other]);
	};
	
	define(boundContains, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = boundContains;


/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(109);
	var getPolyfill = __webpack_require__(228);
	
	module.exports = function shimContains() {
		var polyfill = getPolyfill();
		if (typeof document !== 'undefined') {
			define(
				document,
				{ contains: polyfill },
				{ contains: function () { return document.contains !== polyfill; } }
			);
			if (typeof Element !== 'undefined') {
				define(
					Element.prototype,
					{ contains: polyfill },
					{ contains: function () { return Element.prototype.contains !== polyfill; } }
				);
			}
		}
		return polyfill;
	};


/***/ },
/* 597 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var vendorPrefix;
	var jsCssMap = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  // IE did it wrong again ...
	  ms: '-ms-',
	  O: '-o-'
	};
	function getVendorPrefix() {
	  if (vendorPrefix !== undefined) {
	    return vendorPrefix;
	  }
	  vendorPrefix = '';
	  var style = document.createElement('p').style;
	  var testProp = 'Transform';
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      vendorPrefix = key;
	    }
	  }
	  return vendorPrefix;
	}
	function getTransitionName() {
	  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
	}
	function getTransformName() {
	  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
	}
	function setTransitionProperty(node, value) {
	  var name = getTransitionName();
	  if (name) {
	    node.style[name] = value;
	    if (name !== 'transitionProperty') {
	      node.style.transitionProperty = value;
	    }
	  }
	}
	function setTransform(node, value) {
	  var name = getTransformName();
	  if (name) {
	    node.style[name] = value;
	    if (name !== 'transform') {
	      node.style.transform = value;
	    }
	  }
	}
	function getTransitionProperty(node) {
	  return node.style.transitionProperty || node.style[getTransitionName()];
	}
	function getTransformXY(node) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	  if (transform && transform !== 'none') {
	    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
	    return {
	      x: parseFloat(matrix[12] || matrix[4], 0),
	      y: parseFloat(matrix[13] || matrix[5], 0)
	    };
	  }
	  return {
	    x: 0,
	    y: 0
	  };
	}
	var matrix2d = /matrix\((.*)\)/;
	var matrix3d = /matrix3d\((.*)\)/;
	function setTransformXY(node, xy) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	  if (transform && transform !== 'none') {
	    var arr;
	    var match2d = transform.match(matrix2d);
	    if (match2d) {
	      match2d = match2d[1];
	      arr = match2d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[4] = xy.x;
	      arr[5] = xy.y;
	      setTransform(node, "matrix(".concat(arr.join(','), ")"));
	    } else {
	      var match3d = transform.match(matrix3d)[1];
	      arr = match3d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[12] = xy.x;
	      arr[13] = xy.y;
	      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
	    }
	  } else {
	    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
	  }
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	  }, _typeof(obj);
	}
	var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
	var getComputedStyleX;
	
	// https://stackoverflow.com/a/3485654/3040605
	function forceRelayout(elem) {
	  var originalStyle = elem.style.display;
	  elem.style.display = 'none';
	  elem.offsetHeight; // eslint-disable-line
	  elem.style.display = originalStyle;
	}
	function css(el, name, v) {
	  var value = v;
	  if (_typeof(name) === 'object') {
	    for (var i in name) {
	      if (name.hasOwnProperty(i)) {
	        css(el, i, name[i]);
	      }
	    }
	    return undefined;
	  }
	  if (typeof value !== 'undefined') {
	    if (typeof value === 'number') {
	      value = "".concat(value, "px");
	    }
	    el.style[name] = value;
	    return undefined;
	  }
	  return getComputedStyleX(el, name);
	}
	function getClientPosition(elem) {
	  var box;
	  var x;
	  var y;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement;
	  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
	  box = elem.getBoundingClientRect();
	
	  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
	  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
	  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
	
	  x = Math.floor(box.left);
	  y = Math.floor(box.top);
	
	  // In IE, most of the time, 2 extra pixels are added to the top and left
	  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
	  // IE6 standards mode, this border can be overridden by setting the
	  // document element's border to zero -- thus, we cannot rely on the
	  // offset always being 2 pixels.
	
	  // In quirks mode, the offset can be determined by querying the body's
	  // clientLeft/clientTop, but in standards mode, it is found by querying
	  // the document element's clientLeft/clientTop.  Since we already called
	  // getClientBoundingRect we have already forced a reflow, so it is not
	  // too expensive just to query them all.
	
	  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
	  // 窗口边框标准是设 documentElement ,quirks 时设置 body
	  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
	  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
	  // 标准 ie 下 docElem.clientTop 就是 border-top
	  // ie7 html 即窗口边框改变不了。永远为 2
	  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
	
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	  return {
	    left: x,
	    top: y
	  };
	}
	function getScroll(w, top) {
	  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
	  var method = "scroll".concat(top ? 'Top' : 'Left');
	  if (typeof ret !== 'number') {
	    var d = w.document;
	    // ie6,7,8 standard mode
	    ret = d.documentElement[method];
	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }
	  return ret;
	}
	function getScrollLeft(w) {
	  return getScroll(w);
	}
	function getScrollTop(w) {
	  return getScroll(w, true);
	}
	function getOffset(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScrollLeft(w);
	  pos.top += getScrollTop(w);
	  return pos;
	}
	
	/**
	 * A crude way of determining if an object is a window
	 * @member util
	 */
	function isWindow(obj) {
	  // must use == for ie8
	  /* eslint eqeqeq:0 */
	  return obj !== null && obj !== undefined && obj == obj.window;
	}
	function getDocument(node) {
	  if (isWindow(node)) {
	    return node.document;
	  }
	  if (node.nodeType === 9) {
	    return node;
	  }
	  return node.ownerDocument;
	}
	function _getComputedStyle(elem, name, cs) {
	  var computedStyle = cs;
	  var val = '';
	  var d = getDocument(elem);
	  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
	
	  // https://github.com/kissyteam/kissy/issues/61
	  if (computedStyle) {
	    val = computedStyle.getPropertyValue(name) || computedStyle[name];
	  }
	  return val;
	}
	var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');
	var RE_POS = /^(top|right|bottom|left)$/;
	var CURRENT_STYLE = 'currentStyle';
	var RUNTIME_STYLE = 'runtimeStyle';
	var LEFT = 'left';
	var PX = 'px';
	function _getComputedStyleIE(elem, name) {
	  // currentStyle maybe null
	  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
	  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
	
	  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
	  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
	  // 在 ie 下不对，需要直接用 offset 方式
	  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
	
	  // From the awesome hack by Dean Edwards
	  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	  // If we're not dealing with a regular pixel number
	  // but a number that has a weird ending, we need to convert it to pixels
	  // exclude left right for relativity
	  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
	    // Remember the original values
	    var style = elem.style;
	    var left = style[LEFT];
	    var rsLeft = elem[RUNTIME_STYLE][LEFT];
	
	    // prevent flashing of content
	    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
	
	    // Put in the new values to get a computed value out
	    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
	    ret = style.pixelLeft + PX;
	
	    // Revert the changed values
	    style[LEFT] = left;
	    elem[RUNTIME_STYLE][LEFT] = rsLeft;
	  }
	  return ret === '' ? 'auto' : ret;
	}
	if (typeof window !== 'undefined') {
	  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
	}
	function getOffsetDirection(dir, option) {
	  if (dir === 'left') {
	    return option.useCssRight ? 'right' : dir;
	  }
	  return option.useCssBottom ? 'bottom' : dir;
	}
	function oppositeOffsetDirection(dir) {
	  if (dir === 'left') {
	    return 'right';
	  } else if (dir === 'right') {
	    return 'left';
	  } else if (dir === 'top') {
	    return 'bottom';
	  } else if (dir === 'bottom') {
	    return 'top';
	  }
	}
	
	// 设置 elem 相对 elem.ownerDocument 的坐标
	function setLeftTop(elem, offset, option) {
	  // set position first, in-case top/left are set even on static elem
	  if (css(elem, 'position') === 'static') {
	    elem.style.position = 'relative';
	  }
	  var presetH = -999;
	  var presetV = -999;
	  var horizontalProperty = getOffsetDirection('left', option);
	  var verticalProperty = getOffsetDirection('top', option);
	  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
	  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
	  if (horizontalProperty !== 'left') {
	    presetH = 999;
	  }
	  if (verticalProperty !== 'top') {
	    presetV = 999;
	  }
	  var originalTransition = '';
	  var originalOffset = getOffset(elem);
	  if ('left' in offset || 'top' in offset) {
	    originalTransition = getTransitionProperty(elem) || '';
	    setTransitionProperty(elem, 'none');
	  }
	  if ('left' in offset) {
	    elem.style[oppositeHorizontalProperty] = '';
	    elem.style[horizontalProperty] = "".concat(presetH, "px");
	  }
	  if ('top' in offset) {
	    elem.style[oppositeVerticalProperty] = '';
	    elem.style[verticalProperty] = "".concat(presetV, "px");
	  }
	  // force relayout
	  forceRelayout(elem);
	  var old = getOffset(elem);
	  var originalStyle = {};
	  for (var key in offset) {
	    if (offset.hasOwnProperty(key)) {
	      var dir = getOffsetDirection(key, option);
	      var preset = key === 'left' ? presetH : presetV;
	      var off = originalOffset[key] - old[key];
	      if (dir === key) {
	        originalStyle[dir] = preset + off;
	      } else {
	        originalStyle[dir] = preset - off;
	      }
	    }
	  }
	  css(elem, originalStyle);
	  // force relayout
	  forceRelayout(elem);
	  if ('left' in offset || 'top' in offset) {
	    setTransitionProperty(elem, originalTransition);
	  }
	  var ret = {};
	  for (var _key in offset) {
	    if (offset.hasOwnProperty(_key)) {
	      var _dir = getOffsetDirection(_key, option);
	      var _off = offset[_key] - originalOffset[_key];
	      if (_key === _dir) {
	        ret[_dir] = originalStyle[_dir] + _off;
	      } else {
	        ret[_dir] = originalStyle[_dir] - _off;
	      }
	    }
	  }
	  css(elem, ret);
	}
	function setTransform$1(elem, offset) {
	  var originalOffset = getOffset(elem);
	  var originalXY = getTransformXY(elem);
	  var resultXY = {
	    x: originalXY.x,
	    y: originalXY.y
	  };
	  if ('left' in offset) {
	    resultXY.x = originalXY.x + offset.left - originalOffset.left;
	  }
	  if ('top' in offset) {
	    resultXY.y = originalXY.y + offset.top - originalOffset.top;
	  }
	  setTransformXY(elem, resultXY);
	}
	function setOffset(elem, offset, option) {
	  if (option.ignoreShake) {
	    var oriOffset = getOffset(elem);
	    var oLeft = oriOffset.left.toFixed(0);
	    var oTop = oriOffset.top.toFixed(0);
	    var tLeft = offset.left.toFixed(0);
	    var tTop = offset.top.toFixed(0);
	    if (oLeft === tLeft && oTop === tTop) {
	      return;
	    }
	  }
	  if (option.useCssRight || option.useCssBottom) {
	    setLeftTop(elem, offset, option);
	  } else if (option.useCssTransform && getTransformName() in document.body.style) {
	    setTransform$1(elem, offset);
	  } else {
	    setLeftTop(elem, offset, option);
	  }
	}
	function each(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(arr[i]);
	  }
	}
	function isBorderBoxFn(elem) {
	  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
	}
	var BOX_MODELS = ['margin', 'border', 'padding'];
	var CONTENT_INDEX = -1;
	var PADDING_INDEX = 2;
	var BORDER_INDEX = 1;
	var MARGIN_INDEX = 0;
	function swap(elem, options, callback) {
	  var old = {};
	  var style = elem.style;
	  var name;
	
	  // Remember the old values, and insert the new ones
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      old[name] = style[name];
	      style[name] = options[name];
	    }
	  }
	  callback.call(elem);
	
	  // Revert the old values
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      style[name] = old[name];
	    }
	  }
	}
	function getPBMWidth(elem, props, which) {
	  var value = 0;
	  var prop;
	  var j;
	  var i;
	  for (j = 0; j < props.length; j++) {
	    prop = props[j];
	    if (prop) {
	      for (i = 0; i < which.length; i++) {
	        var cssProp = void 0;
	        if (prop === 'border') {
	          cssProp = "".concat(prop).concat(which[i], "Width");
	        } else {
	          cssProp = prop + which[i];
	        }
	        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
	      }
	    }
	  }
	  return value;
	}
	var domUtils = {
	  getParent: function getParent(element) {
	    var parent = element;
	    do {
	      if (parent.nodeType === 11 && parent.host) {
	        parent = parent.host;
	      } else {
	        parent = parent.parentNode;
	      }
	    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
	    return parent;
	  }
	};
	each(['Width', 'Height'], function (name) {
	  domUtils["doc".concat(name)] = function (refWin) {
	    var d = refWin.document;
	    return Math.max(
	    // firefox chrome documentElement.scrollHeight< body.scrollHeight
	    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
	    d.documentElement["scroll".concat(name)],
	    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
	    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
	  };
	  domUtils["viewport".concat(name)] = function (win) {
	    // pc browser includes scrollbar in window.innerWidth
	    var prop = "client".concat(name);
	    var doc = win.document;
	    var body = doc.body;
	    var documentElement = doc.documentElement;
	    var documentElementProp = documentElement[prop];
	    // 标准模式取 documentElement
	    // backcompat 取 body
	    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
	  };
	});
	
	/*
	 得到元素的大小信息
	 @param elem
	 @param name
	 @param {String} [extra]  'padding' : (css width) + padding
	 'border' : (css width) + padding + border
	 'margin' : (css width) + padding + border + margin
	 */
	function getWH(elem, name, ex) {
	  var extra = ex;
	  if (isWindow(elem)) {
	    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
	  } else if (elem.nodeType === 9) {
	    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
	  }
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
	  var isBorderBox = isBorderBoxFn(elem);
	  var cssBoxValue = 0;
	  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
	    borderBoxValue = undefined;
	    // Fall back to computed then un computed css if necessary
	    cssBoxValue = getComputedStyleX(elem, name);
	    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
	      cssBoxValue = elem.style[name] || 0;
	    }
	    // Normalize '', auto, and prepare for extra
	    cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
	  }
	  if (extra === undefined) {
	    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
	  }
	  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
	  var val = borderBoxValue || cssBoxValue;
	  if (extra === CONTENT_INDEX) {
	    if (borderBoxValueOrIsBorderBox) {
	      return val - getPBMWidth(elem, ['border', 'padding'], which);
	    }
	    return cssBoxValue;
	  } else if (borderBoxValueOrIsBorderBox) {
	    if (extra === BORDER_INDEX) {
	      return val;
	    }
	    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
	  }
	  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
	}
	var cssShow = {
	  position: 'absolute',
	  visibility: 'hidden',
	  display: 'block'
	};
	
	// fix #119 : https://github.com/kissyteam/kissy/issues/119
	function getWHIgnoreDisplay() {
	  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	  var val;
	  var elem = args[0];
	  // in case elem is window
	  // elem.offsetWidth === undefined
	  if (elem.offsetWidth !== 0) {
	    val = getWH.apply(undefined, args);
	  } else {
	    swap(elem, cssShow, function () {
	      val = getWH.apply(undefined, args);
	    });
	  }
	  return val;
	}
	each(['width', 'height'], function (name) {
	  var first = name.charAt(0).toUpperCase() + name.slice(1);
	  domUtils["outer".concat(first)] = function (el, includeMargin) {
	    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
	  };
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  domUtils[name] = function (elem, v) {
	    var val = v;
	    if (val !== undefined) {
	      if (elem) {
	        var isBorderBox = isBorderBoxFn(elem);
	        if (isBorderBox) {
	          val += getPBMWidth(elem, ['padding', 'border'], which);
	        }
	        return css(elem, name, val);
	      }
	      return undefined;
	    }
	    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
	  };
	});
	function mix(to, from) {
	  for (var i in from) {
	    if (from.hasOwnProperty(i)) {
	      to[i] = from[i];
	    }
	  }
	  return to;
	}
	var utils = {
	  getWindow: function getWindow(node) {
	    if (node && node.document && node.setTimeout) {
	      return node;
	    }
	    var doc = node.ownerDocument || node;
	    return doc.defaultView || doc.parentWindow;
	  },
	  getDocument: getDocument,
	  offset: function offset(el, value, option) {
	    if (typeof value !== 'undefined') {
	      setOffset(el, value, option || {});
	    } else {
	      return getOffset(el);
	    }
	  },
	  isWindow: isWindow,
	  each: each,
	  css: css,
	  clone: function clone(obj) {
	    var i;
	    var ret = {};
	    for (i in obj) {
	      if (obj.hasOwnProperty(i)) {
	        ret[i] = obj[i];
	      }
	    }
	    var overflow = obj.overflow;
	    if (overflow) {
	      for (i in obj) {
	        if (obj.hasOwnProperty(i)) {
	          ret.overflow[i] = obj.overflow[i];
	        }
	      }
	    }
	    return ret;
	  },
	  mix: mix,
	  getWindowScrollLeft: function getWindowScrollLeft(w) {
	    return getScrollLeft(w);
	  },
	  getWindowScrollTop: function getWindowScrollTop(w) {
	    return getScrollTop(w);
	  },
	  merge: function merge() {
	    var ret = {};
	    for (var i = 0; i < arguments.length; i++) {
	      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
	    }
	    return ret;
	  },
	  viewportWidth: 0,
	  viewportHeight: 0
	};
	mix(utils, domUtils);
	
	/**
	 * 得到会导致元素显示不全的祖先元素
	 */
	var getParent = utils.getParent;
	function getOffsetParent(element) {
	  if (utils.isWindow(element) || element.nodeType === 9) {
	    return null;
	  }
	  // ie 这个也不是完全可行
	  /*
	   <div style="width: 50px;height: 100px;overflow: hidden">
	   <div style="width: 50px;height: 100px;position: relative;" id="d6">
	   元素 6 高 100px 宽 50px<br/>
	   </div>
	   </div>
	   */
	  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
	  //  In other browsers it only includes elements with position absolute, relative or
	  // fixed, not elements with overflow set to auto or scroll.
	  //        if (UA.ie && ieMode < 8) {
	  //            return element.offsetParent;
	  //        }
	  // 统一的 offsetParent 方法
	  var doc = utils.getDocument(element);
	  var body = doc.body;
	  var parent;
	  var positionStyle = utils.css(element, 'position');
	  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
	  if (!skipStatic) {
	    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
	  }
	  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
	    positionStyle = utils.css(parent, 'position');
	    if (positionStyle !== 'static') {
	      return parent;
	    }
	  }
	  return null;
	}
	
	var getParent$1 = utils.getParent;
	function isAncestorFixed(element) {
	  if (utils.isWindow(element) || element.nodeType === 9) {
	    return false;
	  }
	  var doc = utils.getDocument(element);
	  var body = doc.body;
	  var parent = null;
	  for (parent = getParent$1(element);
	  // 修复元素位于 document.documentElement 下导致崩溃问题
	  parent && parent !== body && parent !== doc; parent = getParent$1(parent)) {
	    var positionStyle = utils.css(parent, 'position');
	    if (positionStyle === 'fixed') {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * 获得元素的显示部分的区域
	 */
	function getVisibleRectForElement(element, alwaysByViewport) {
	  var visibleRect = {
	    left: 0,
	    right: Infinity,
	    top: 0,
	    bottom: Infinity
	  };
	  var el = getOffsetParent(element);
	  var doc = utils.getDocument(element);
	  var win = doc.defaultView || doc.parentWindow;
	  var body = doc.body;
	  var documentElement = doc.documentElement;
	
	  // Determine the size of the visible rect by climbing the dom accounting for
	  // all scrollable containers.
	  while (el) {
	    // clientWidth is zero for inline block elements in ie.
	    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
	    // body may have overflow set on it, yet we still get the entire
	    // viewport. In some browsers, el.offsetParent may be
	    // document.documentElement, so check for that too.
	    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
	      var pos = utils.offset(el);
	      // add border
	      pos.left += el.clientLeft;
	      pos.top += el.clientTop;
	      visibleRect.top = Math.max(visibleRect.top, pos.top);
	      visibleRect.right = Math.min(visibleRect.right,
	      // consider area without scrollBar
	      pos.left + el.clientWidth);
	      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
	      visibleRect.left = Math.max(visibleRect.left, pos.left);
	    } else if (el === body || el === documentElement) {
	      break;
	    }
	    el = getOffsetParent(el);
	  }
	
	  // Set element position to fixed
	  // make sure absolute element itself don't affect it's visible area
	  // https://github.com/ant-design/ant-design/issues/7601
	  var originalPosition = null;
	  if (!utils.isWindow(element) && element.nodeType !== 9) {
	    originalPosition = element.style.position;
	    var position = utils.css(element, 'position');
	    if (position === 'absolute') {
	      element.style.position = 'fixed';
	    }
	  }
	  var scrollX = utils.getWindowScrollLeft(win);
	  var scrollY = utils.getWindowScrollTop(win);
	  var viewportWidth = utils.viewportWidth(win);
	  var viewportHeight = utils.viewportHeight(win);
	  var documentWidth = documentElement.scrollWidth;
	  var documentHeight = documentElement.scrollHeight;
	
	  // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
	  // We should cut this ourself.
	  var bodyStyle = window.getComputedStyle(body);
	  if (bodyStyle.overflowX === 'hidden') {
	    documentWidth = win.innerWidth;
	  }
	  if (bodyStyle.overflowY === 'hidden') {
	    documentHeight = win.innerHeight;
	  }
	
	  // Reset element position after calculate the visible area
	  if (element.style) {
	    element.style.position = originalPosition;
	  }
	  if (alwaysByViewport || isAncestorFixed(element)) {
	    // Clip by viewport's size.
	    visibleRect.left = Math.max(visibleRect.left, scrollX);
	    visibleRect.top = Math.max(visibleRect.top, scrollY);
	    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
	    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
	  } else {
	    // Clip by document's size.
	    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
	    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
	    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
	    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
	  }
	  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
	}
	
	function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
	  var pos = utils.clone(elFuturePos);
	  var size = {
	    width: elRegion.width,
	    height: elRegion.height
	  };
	  if (overflow.adjustX && pos.left < visibleRect.left) {
	    pos.left = visibleRect.left;
	  }
	
	  // Left edge inside and right edge outside viewport, try to resize it.
	  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
	    size.width -= pos.left + size.width - visibleRect.right;
	  }
	
	  // Right edge outside viewport, try to move it.
	  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
	    // 保证左边界和可视区域左边界对齐
	    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
	  }
	
	  // Top edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top < visibleRect.top) {
	    pos.top = visibleRect.top;
	  }
	
	  // Top edge inside and bottom edge outside viewport, try to resize it.
	  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
	    size.height -= pos.top + size.height - visibleRect.bottom;
	  }
	
	  // Bottom edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
	    // 保证上边界和可视区域上边界对齐
	    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
	  }
	  return utils.mix(pos, size);
	}
	
	function getRegion(node) {
	  var offset;
	  var w;
	  var h;
	  if (!utils.isWindow(node) && node.nodeType !== 9) {
	    offset = utils.offset(node);
	    w = utils.outerWidth(node);
	    h = utils.outerHeight(node);
	  } else {
	    var win = utils.getWindow(node);
	    offset = {
	      left: utils.getWindowScrollLeft(win),
	      top: utils.getWindowScrollTop(win)
	    };
	    w = utils.viewportWidth(win);
	    h = utils.viewportHeight(win);
	  }
	  offset.width = w;
	  offset.height = h;
	  return offset;
	}
	
	/**
	 * 获取 node 上的 align 对齐点 相对于页面的坐标
	 */
	
	function getAlignOffset(region, align) {
	  var V = align.charAt(0);
	  var H = align.charAt(1);
	  var w = region.width;
	  var h = region.height;
	  var x = region.left;
	  var y = region.top;
	  if (V === 'c') {
	    y += h / 2;
	  } else if (V === 'b') {
	    y += h;
	  }
	  if (H === 'c') {
	    x += w / 2;
	  } else if (H === 'r') {
	    x += w;
	  }
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
	  var p1 = getAlignOffset(refNodeRegion, points[1]);
	  var p2 = getAlignOffset(elRegion, points[0]);
	  var diff = [p2.left - p1.left, p2.top - p1.top];
	  return {
	    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
	    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
	  };
	}
	
	/**
	 * align dom node flexibly
	 * @author yiminghe@gmail.com
	 */
	
	// http://yiminghe.iteye.com/blog/1124720
	
	function isFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
	}
	function isFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
	}
	function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
	}
	function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
	}
	function flip(points, reg, map) {
	  var ret = [];
	  utils.each(points, function (p) {
	    ret.push(p.replace(reg, function (m) {
	      return map[m];
	    }));
	  });
	  return ret;
	}
	function flipOffset(offset, index) {
	  offset[index] = -offset[index];
	  return offset;
	}
	function convertOffset(str, offsetLen) {
	  var n;
	  if (/%$/.test(str)) {
	    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
	  } else {
	    n = parseInt(str, 10);
	  }
	  return n || 0;
	}
	function normalizeOffset(offset, el) {
	  offset[0] = convertOffset(offset[0], el.width);
	  offset[1] = convertOffset(offset[1], el.height);
	}
	
	/**
	 * @param el
	 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
	 * @param align
	 */
	function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
	  var points = align.points;
	  var offset = align.offset || [0, 0];
	  var targetOffset = align.targetOffset || [0, 0];
	  var overflow = align.overflow;
	  var source = align.source || el;
	  offset = [].concat(offset);
	  targetOffset = [].concat(targetOffset);
	  overflow = overflow || {};
	  var newOverflowCfg = {};
	  var fail = 0;
	  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
	  // 当前节点可以被放置的显示区域
	  var visibleRect = getVisibleRectForElement(source, alwaysByViewport);
	  // 当前节点所占的区域, left/top/width/height
	  var elRegion = getRegion(source);
	  // 将 offset 转换成数值，支持百分比
	  normalizeOffset(offset, elRegion);
	  normalizeOffset(targetOffset, tgtRegion);
	  // 当前节点将要被放置的位置
	  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
	  // 当前节点将要所处的区域
	  var newElRegion = utils.merge(elRegion, elFuturePos);
	
	  // 如果可视区域不能完全放置当前节点时允许调整
	  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
	    if (overflow.adjustX) {
	      // 如果横向不能放下
	      if (isFailX(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var newPoints = flip(points, /[lr]/gi, {
	          l: 'r',
	          r: 'l'
	        });
	        // 偏移量也反下
	        var newOffset = flipOffset(offset, 0);
	        var newTargetOffset = flipOffset(targetOffset, 0);
	        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
	        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = newPoints;
	          offset = newOffset;
	          targetOffset = newTargetOffset;
	        }
	      }
	    }
	    if (overflow.adjustY) {
	      // 如果纵向不能放下
	      if (isFailY(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var _newPoints = flip(points, /[tb]/gi, {
	          t: 'b',
	          b: 't'
	        });
	        // 偏移量也反下
	        var _newOffset = flipOffset(offset, 1);
	        var _newTargetOffset = flipOffset(targetOffset, 1);
	        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
	        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = _newPoints;
	          offset = _newOffset;
	          targetOffset = _newTargetOffset;
	        }
	      }
	    }
	
	    // 如果失败，重新计算当前节点将要被放置的位置
	    if (fail) {
	      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
	      utils.mix(newElRegion, elFuturePos);
	    }
	    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
	    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
	    // 检查反下后的位置是否可以放下了，如果仍然放不下：
	    // 1. 复原修改过的定位参数
	    if (isStillFailX || isStillFailY) {
	      var _newPoints2 = points;
	
	      // 重置对应部分的翻转逻辑
	      if (isStillFailX) {
	        _newPoints2 = flip(points, /[lr]/gi, {
	          l: 'r',
	          r: 'l'
	        });
	      }
	      if (isStillFailY) {
	        _newPoints2 = flip(points, /[tb]/gi, {
	          t: 'b',
	          b: 't'
	        });
	      }
	      points = _newPoints2;
	      offset = align.offset || [0, 0];
	      targetOffset = align.targetOffset || [0, 0];
	    }
	    // 2. 只有指定了可以调整当前方向才调整
	    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
	    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
	
	    // 确实要调整，甚至可能会调整高度宽度
	    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
	      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
	    }
	  }
	
	  // need judge to in case set fixed with in css on height auto element
	  if (newElRegion.width !== elRegion.width) {
	    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
	  }
	  if (newElRegion.height !== elRegion.height) {
	    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
	  }
	
	  // https://github.com/kissyteam/kissy/issues/190
	  // 相对于屏幕位置没变，而 left/top 变了
	  // 例如 <div 'relative'><el absolute></div>
	  utils.offset(source, {
	    left: newElRegion.left,
	    top: newElRegion.top
	  }, {
	    useCssRight: align.useCssRight,
	    useCssBottom: align.useCssBottom,
	    useCssTransform: align.useCssTransform,
	    ignoreShake: align.ignoreShake
	  });
	  return {
	    points: points,
	    offset: offset,
	    targetOffset: targetOffset,
	    overflow: newOverflowCfg
	  };
	}
	/**
	 *  2012-04-26 yiminghe@gmail.com
	 *   - 优化智能对齐算法
	 *   - 慎用 resizeXX
	 *
	 *  2011-07-13 yiminghe@gmail.com note:
	 *   - 增加智能对齐，以及大小调整选项
	 **/
	
	function isOutOfVisibleRect(target, alwaysByViewport) {
	  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
	  var targetRegion = getRegion(target);
	  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
	}
	function alignElement(el, refNode, align) {
	  var target = align.target || refNode;
	  var refNodeRegion = getRegion(target);
	  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
	  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
	}
	alignElement.__getOffsetParent = getOffsetParent;
	alignElement.__getVisibleRectForElement = getVisibleRectForElement;
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    enumerableOnly && (symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    })), keys.push.apply(keys, symbols);
	  }
	  return keys;
	}
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = null != arguments[i] ? arguments[i] : {};
	    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
	      _defineProperty(target, key, source[key]);
	    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
	      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	    });
	  }
	  return target;
	}
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	  return obj;
	}
	
	/**
	 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
	 * If client position provided, will internal convert to page position.
	 */
	
	function alignPoint(el, tgtPoint, align) {
	  var pageX;
	  var pageY;
	  var doc = utils.getDocument(el);
	  var win = doc.defaultView || doc.parentWindow;
	  var scrollX = utils.getWindowScrollLeft(win);
	  var scrollY = utils.getWindowScrollTop(win);
	  var viewportWidth = utils.viewportWidth(win);
	  var viewportHeight = utils.viewportHeight(win);
	  if ('pageX' in tgtPoint) {
	    pageX = tgtPoint.pageX;
	  } else {
	    pageX = scrollX + tgtPoint.clientX;
	  }
	  if ('pageY' in tgtPoint) {
	    pageY = tgtPoint.pageY;
	  } else {
	    pageY = scrollY + tgtPoint.clientY;
	  }
	  var tgtRegion = {
	    left: pageX,
	    top: pageY,
	    width: 0,
	    height: 0
	  };
	  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
	
	  // Provide default target point
	  var points = [align.points[0], 'cc'];
	  return doAlign(el, tgtRegion, _objectSpread(_objectSpread({}, align), {}, {
	    points: points
	  }), pointInView);
	}
	
	exports.alignElement = alignElement;
	exports.alignPoint = alignPoint;
	exports.default = alignElement;
	//# sourceMappingURL=index.js.map


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(476);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(599));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 599 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 600 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(603);
	
	var re_whitespace = /\s+/g;
	var NodePrototype = __webpack_require__(230);
	var ElementPrototype = __webpack_require__(602);
	
	function DomHandler(callback, options, elementCB){
		if(typeof callback === "object"){
			elementCB = options;
			options = callback;
			callback = null;
		} else if(typeof options === "function"){
			elementCB = options;
			options = defaultOpts;
		}
		this._callback = callback;
		this._options = options || defaultOpts;
		this._elementCB = elementCB;
		this.dom = [];
		this._done = false;
		this._tagStack = [];
		this._parser = this._parser || null;
	}
	
	//default options
	var defaultOpts = {
		normalizeWhitespace: false, //Replace all whitespace with single spaces
		withStartIndices: false, //Add startIndex properties to nodes
		withEndIndices: false, //Add endIndex properties to nodes
	};
	
	DomHandler.prototype.onparserinit = function(parser){
		this._parser = parser;
	};
	
	//Resets the handler back to starting state
	DomHandler.prototype.onreset = function(){
		DomHandler.call(this, this._callback, this._options, this._elementCB);
	};
	
	//Signals the handler that parsing is done
	DomHandler.prototype.onend = function(){
		if(this._done) return;
		this._done = true;
		this._parser = null;
		this._handleCallback(null);
	};
	
	DomHandler.prototype._handleCallback =
	DomHandler.prototype.onerror = function(error){
		if(typeof this._callback === "function"){
			this._callback(error, this.dom);
		} else {
			if(error) throw error;
		}
	};
	
	DomHandler.prototype.onclosetag = function(){
		//if(this._tagStack.pop().name !== name) this._handleCallback(Error("Tagname didn't match!"));
		
		var elem = this._tagStack.pop();
	
		if(this._options.withEndIndices && elem){
			elem.endIndex = this._parser.endIndex;
		}
	
		if(this._elementCB) this._elementCB(elem);
	};
	
	DomHandler.prototype._createDomElement = function(properties){
		if (!this._options.withDomLvl1) return properties;
	
		var element;
		if (properties.type === "tag") {
			element = Object.create(ElementPrototype);
		} else {
			element = Object.create(NodePrototype);
		}
	
		for (var key in properties) {
			if (properties.hasOwnProperty(key)) {
				element[key] = properties[key];
			}
		}
	
		return element;
	};
	
	DomHandler.prototype._addDomElement = function(element){
		var parent = this._tagStack[this._tagStack.length - 1];
		var siblings = parent ? parent.children : this.dom;
		var previousSibling = siblings[siblings.length - 1];
	
		element.next = null;
	
		if(this._options.withStartIndices){
			element.startIndex = this._parser.startIndex;
		}
		if(this._options.withEndIndices){
			element.endIndex = this._parser.endIndex;
		}
	
		if(previousSibling){
			element.prev = previousSibling;
			previousSibling.next = element;
		} else {
			element.prev = null;
		}
	
		siblings.push(element);
		element.parent = parent || null;
	};
	
	DomHandler.prototype.onopentag = function(name, attribs){
		var properties = {
			type: name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag,
			name: name,
			attribs: attribs,
			children: []
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
	
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.ontext = function(data){
		//the ignoreWhitespace is officially dropped, but for now,
		//it's an alias for normalizeWhitespace
		var normalize = this._options.normalizeWhitespace || this._options.ignoreWhitespace;
	
		var lastTag;
	
		if(!this._tagStack.length && this.dom.length && (lastTag = this.dom[this.dom.length-1]).type === ElementType.Text){
			if(normalize){
				lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
			} else {
				lastTag.data += data;
			}
		} else {
			if(
				this._tagStack.length &&
				(lastTag = this._tagStack[this._tagStack.length - 1]) &&
				(lastTag = lastTag.children[lastTag.children.length - 1]) &&
				lastTag.type === ElementType.Text
			){
				if(normalize){
					lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
				} else {
					lastTag.data += data;
				}
			} else {
				if(normalize){
					data = data.replace(re_whitespace, " ");
				}
	
				var element = this._createDomElement({
					data: data,
					type: ElementType.Text
				});
	
				this._addDomElement(element);
			}
		}
	};
	
	DomHandler.prototype.oncomment = function(data){
		var lastTag = this._tagStack[this._tagStack.length - 1];
	
		if(lastTag && lastTag.type === ElementType.Comment){
			lastTag.data += data;
			return;
		}
	
		var properties = {
			data: data,
			type: ElementType.Comment
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncdatastart = function(){
		var properties = {
			children: [{
				data: "",
				type: ElementType.Text
			}],
			type: ElementType.CDATA
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncommentend = DomHandler.prototype.oncdataend = function(){
		this._tagStack.pop();
	};
	
	DomHandler.prototype.onprocessinginstruction = function(name, data){
		var element = this._createDomElement({
			name: name,
			data: data,
			type: ElementType.Directive
		});
	
		this._addDomElement(element);
	};
	
	module.exports = DomHandler;


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	// DOM-Level-1-compliant structure
	var NodePrototype = __webpack_require__(230);
	var ElementPrototype = module.exports = Object.create(NodePrototype);
	
	var domLvl1 = {
		tagName: "name"
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(ElementPrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ },
/* 603 */
/***/ function(module, exports) {

	//Types of elements found in the DOM
	module.exports = {
		Text: "text", //Text
		Directive: "directive", //<? ... ?>
		Comment: "comment", //<!-- ... -->
		Script: "script", //<script> tags
		Style: "style", //<style> tags
		Tag: "tag", //Any tag
		CDATA: "cdata", //<![CDATA[ ... ]]>
		Doctype: "doctype",
	
		isTag: function(elem){
			return elem.type === "tag" || elem.type === "script" || elem.type === "style";
		}
	};


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(606);
	var each = __webpack_require__(231).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(604);
	var Util = __webpack_require__(231);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ },
/* 606 */
/***/ function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(605);
	module.exports = new MediaQueryDispatch();


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	var decodeMap = __webpack_require__(669);
	
	module.exports = decodeCodePoint;
	
	// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
	function decodeCodePoint(codePoint) {
	    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
	        return "\uFFFD";
	    }
	
	    if (codePoint in decodeMap) {
	        codePoint = decodeMap[codePoint];
	    }
	
	    var output = "";
	
	    if (codePoint > 0xffff) {
	        codePoint -= 0x10000;
	        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
	        codePoint = 0xdc00 | (codePoint & 0x3ff);
	    }
	
	    output += String.fromCharCode(codePoint);
	    return output;
	}


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(610);


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(73);
	
	var $TypeError = GetIntrinsic('%TypeError%');
	
	// http://262.ecma-international.org/5.1/#sec-9.10
	
	module.exports = function CheckObjectCoercible(value, optMessage) {
		if (value == null) {
			throw new $TypeError(optMessage || ('Cannot call method on ' + value));
		}
		return value;
	};


/***/ },
/* 611 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 612 */
71,
/* 613 */
71,
/* 614 */
71,
/* 615 */
71,
/* 616 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(616);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(626);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(26);
	
	var createArrayFromMixed = __webpack_require__(619);
	var getMarkupWrap = __webpack_require__(621);
	var invariant = __webpack_require__(6);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(26);
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 622 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 623 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(623);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 625 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(625);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 627 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 628 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(73);
	
	var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
	
	if ($gOPD) {
		try {
			$gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			$gOPD = null;
		}
	}
	
	module.exports = $gOPD;


/***/ },
/* 630 */
/***/ function(module, exports) {

	'use strict';
	
	var test = {
		foo: {}
	};
	
	var $Object = Object;
	
	module.exports = function hasProto() {
		return { __proto__: test }.foo === test.foo && !({ __proto__: null } instanceof $Object);
	};


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var origSymbol = typeof Symbol !== 'undefined' && Symbol;
	var hasSymbolSham = __webpack_require__(239);
	
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};


/***/ },
/* 632 */
/***/ function(module, exports) {

	'use strict';
	
	var hasOwnProperty = {}.hasOwnProperty;
	var call = Function.prototype.call;
	
	module.exports = call.bind ? call.bind(hasOwnProperty) : function (O, P) {
	  return call.call(hasOwnProperty, O, P);
	};


/***/ },
/* 633 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(147);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(74);
	
	var _DOMUtils = __webpack_require__(111);
	
	var _DOMStateStorage = __webpack_require__(240);
	
	var _PathUtils = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(147);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(74);
	
	var _PathUtils = __webpack_require__(43);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(148);
	
	var _BrowserProtocol = __webpack_require__(147);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(635);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(111);
	
	var _createHistory = __webpack_require__(149);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(148);
	
	var _DOMUtils = __webpack_require__(111);
	
	var _HashProtocol = __webpack_require__(634);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(149);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(47);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(74);
	
	var _PathUtils = __webpack_require__(43);
	
	var _createHistory = __webpack_require__(149);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 639 */
/***/ function(module, exports) {

	// These are all sourced from https://facebook.github.io/react/docs/tags-and-attributes.html -
	// all attributes regardless of whether they have a different case to their HTML equivalents are
	// listed to reduce the chance of human error and make it easier to just copy-paste the new list if
	// it changes.
	'use strict';
	var HTML_ATTRIBUTES = [
	  'accept', 'acceptCharset', 'accessKey', 'action', 'allowFullScreen', 'allowTransparency',
	  'alt', 'async', 'autoComplete', 'autoFocus', 'autoPlay', 'capture', 'cellPadding',
	  'cellSpacing', 'challenge', 'charSet', 'checked', 'cite', 'classID', 'className',
	  'colSpan', 'cols', 'content', 'contentEditable', 'contextMenu', 'controls', 'coords',
	  'crossOrigin', 'data', 'dateTime', 'default', 'defer', 'dir', 'disabled', 'download',
	  'draggable', 'encType', 'form', 'formAction', 'formEncType', 'formMethod', 'formNoValidate',
	  'formTarget', 'frameBorder', 'headers', 'height', 'hidden', 'high', 'href', 'hrefLang',
	  'htmlFor', 'httpEquiv', 'icon', 'id', 'inputMode', 'integrity', 'is', 'keyParams', 'keyType',
	  'kind', 'label', 'lang', 'list', 'loop', 'low', 'manifest', 'marginHeight', 'marginWidth',
	  'max', 'maxLength', 'media', 'mediaGroup', 'method', 'min', 'minLength', 'multiple', 'muted',
	  'name', 'noValidate', 'nonce', 'open', 'optimum', 'pattern', 'placeholder', 'poster',
	  'preload', 'profile', 'radioGroup', 'readOnly', 'rel', 'required', 'reversed', 'role',
	  'rowSpan', 'rows', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected',
	  'shape', 'size', 'sizes', 'span', 'spellCheck', 'src', 'srcDoc', 'srcLang', 'srcSet', 'start',
	  'step', 'style', 'summary', 'tabIndex', 'target', 'title', 'type', 'useMap', 'value', 'width',
	  'wmode', 'wrap',
	];
	
	var NON_STANDARD_ATTRIBUTES = [
	  'autoCapitalize', 'autoCorrect', 'color', 'itemProp', 'itemScope', 'itemType', 'itemRef',
	  'itemID', 'security', 'unselectable', 'results', 'autoSave',
	];
	
	var SVG_ATTRIBUTES = [
	  'accentHeight', 'accumulate', 'additive', 'alignmentBaseline', 'allowReorder', 'alphabetic',
	  'amplitude', 'arabicForm', 'ascent', 'attributeName', 'attributeType', 'autoReverse', 'azimuth',
	  'baseFrequency', 'baseProfile', 'baselineShift', 'bbox', 'begin', 'bias', 'by', 'calcMode',
	  'capHeight', 'clip', 'clipPath', 'clipPathUnits', 'clipRule', 'colorInterpolation',
	  'colorInterpolationFilters', 'colorProfile', 'colorRendering', 'contentScriptType',
	  'contentStyleType', 'cursor', 'cx', 'cy', 'd', 'decelerate', 'descent', 'diffuseConstant',
	  'direction', 'display', 'divisor', 'dominantBaseline', 'dur', 'dx', 'dy', 'edgeMode',
	  'elevation', 'enableBackground', 'end', 'exponent', 'externalResourcesRequired', 'fill',
	  'fillOpacity', 'fillRule', 'filter', 'filterRes', 'filterUnits', 'floodColor', 'floodOpacity',
	  'focusable', 'fontFamily', 'fontSize', 'fontSizeAdjust', 'fontStretch', 'fontStyle',
	  'fontVariant', 'fontWeight', 'format', 'from', 'fx', 'fy', 'g1', 'g2', 'glyphName',
	  'glyphOrientationHorizontal', 'glyphOrientationVertical', 'glyphRef',
	  'gradientTransform', 'gradientUnits', 'hanging', 'horizAdvX', 'horizOriginX', 'ideographic',
	  'imageRendering', 'in', 'in2', 'intercept', 'k', 'k1', 'k2', 'k3', 'k4', 'kernelMatrix',
	  'kernelUnitLength', 'kerning', 'keyPoints', 'keySplines', 'keyTimes', 'lengthAdjust',
	  'letterSpacing', 'lightingColor', 'limitingConeAngle', 'local', 'markerEnd', 'markerHeight',
	  'markerMid', 'markerStart', 'markerUnits', 'markerWidth', 'mask', 'maskContentUnits',
	  'maskUnits', 'mathematical', 'mode', 'numOctaves', 'offset', 'opacity', 'operator', 'order',
	  'orient', 'orientation', 'origin', 'overflow', 'overlinePosition', 'overlineThickness',
	  'paintOrder', 'panose1', 'pathLength', 'patternContentUnits', 'patternTransform',
	  'patternUnits', 'pointerEvents', 'points', 'pointsAtX', 'pointsAtY', 'pointsAtZ',
	  'preserveAlpha', 'preserveAspectRatio', 'primitiveUnits', 'r', 'radius', 'refX', 'refY',
	  'renderingIntent', 'repeatCount', 'repeatDur', 'requiredExtensions', 'requiredFeatures',
	  'restart', 'result', 'rotate', 'rx', 'ry', 'scale', 'seed', 'shapeRendering', 'slope',
	  'spacing', 'specularConstant', 'specularExponent', 'speed', 'spreadMethod', 'startOffset',
	  'stdDeviation', 'stemh', 'stemv', 'stitchTiles', 'stopColor', 'stopOpacity',
	  'strikethroughPosition', 'strikethroughThickness', 'string', 'stroke', 'strokeDasharray',
	  'strokeDashoffset', 'strokeLinecap', 'strokeLinejoin', 'strokeMiterlimit', 'strokeOpacity',
	  'strokeWidth', 'surfaceScale', 'systemLanguage', 'tableValues', 'targetX', 'targetY',
	  'textAnchor', 'textDecoration', 'textLength', 'textRendering', 'to', 'transform', 'u1',
	  'u2', 'underlinePosition', 'underlineThickness', 'unicode', 'unicodeBidi', 'unicodeRange',
	  'unitsPerEm', 'vAlphabetic', 'vHanging', 'vIdeographic', 'vMathematical', 'values',
	  'vectorEffect', 'version', 'vertAdvY', 'vertOriginX', 'vertOriginY', 'viewBox',
	  'viewTarget', 'visibility', 'widths', 'wordSpacing', 'writingMode', 'x', 'x1', 'x2',
	  'xChannelSelector', 'xHeight', 'xlinkActuate', 'xlinkArcrole', 'xlinkHref', 'xlinkRole',
	  'xlinkShow', 'xlinkTitle', 'xlinkType', 'xmlns', 'xmlnsXlink', 'xmlBase', 'xmlLang',
	  'xmlSpace', 'y', 'y1', 'y2', 'yChannelSelector', 'z', 'zoomAndPan',
	];
	
	var camelCaseMap = HTML_ATTRIBUTES
	  .concat(NON_STANDARD_ATTRIBUTES)
	  .concat(SVG_ATTRIBUTES)
	  .reduce(function (soFar, attr) {
	    var lower = attr.toLowerCase();
	    if (lower !== attr) {
	      soFar[lower] = attr;
	    }
	    return soFar;
	  }, {});
	
	module.exports = camelCaseMap;


/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var find = __webpack_require__(645);
	var reject = __webpack_require__(664);
	var addIndex = __webpack_require__(642);
	var map = __webpack_require__(662);
	var HtmlParser = __webpack_require__(666);
	var DomHandler = __webpack_require__(601);
	var ProcessingInstructions = __webpack_require__(245);
	var IsValidNodeDefinitions = __webpack_require__(243);
	var utils = __webpack_require__(246);
	
	function Html2ReactParser(options) {
	  function parseHtmlToTree(html) {
	    options = options || {};
	    options.decodeEntities = true;
	    var handler = new DomHandler();
	    var parser = new HtmlParser(handler, options);
	    parser.parseComplete(html);
	    return handler.dom;
	  };
	
	  function traverseDom(node, isValidNode, processingInstructions, index) {
	    if (isValidNode(node)) {
	      var processingInstruction = find(function (processingInstruction) {
	        return processingInstruction.shouldProcessNode(node);
	      }, processingInstructions);
	      if (processingInstruction != null) {
	        var children = reject(function (x) {return x == null || x === false;},
	          addIndex(map)(function (child, i) {
	            return traverseDom(child, isValidNode, processingInstructions, i);
	          }, node.children || []));
	
	        if (processingInstruction.replaceChildren) {
	          return utils.createElement(node, index, node.data, [
	            processingInstruction.processNode(node, children, index),
	          ]);
	        }
	
	        return processingInstruction.processNode(node, children, index);
	      } else {
	        return false;
	      }
	    } else {
	      return false;
	    }
	  };
	
	  function parseWithInstructions(html, isValidNode, processingInstructions) {
	    var domTree = parseHtmlToTree(html);
	
	    var list = domTree.map(function (domTreeItem, index) {
	      return traverseDom(domTreeItem, isValidNode, processingInstructions, index);
	    });
	    return list.length <= 1 ? list[0] : list;
	  };
	
	  function parse(html) {
	    var processingInstructions = new ProcessingInstructions();
	    return parseWithInstructions(html,
	      IsValidNodeDefinitions.alwaysValid,
	      processingInstructions.defaultProcessingInstructions);
	  };
	
	  return {
	    parse: parse,
	    parseWithInstructions: parseWithInstructions,
	  };
	};
	
	module.exports = Html2ReactParser;


/***/ },
/* 641 */
/***/ function(module, exports) {

	'use strict';
	function shouldProcessEveryNode(node) {
	  return true;
	}
	
	module.exports = {
	  shouldProcessEveryNode: shouldProcessEveryNode,
	};


/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(647);
	var _curry1 = __webpack_require__(55);
	var curryN = __webpack_require__(247);
	
	
	/**
	 * Creates a new list iteration function from an existing one by adding two new
	 * parameters to its callback function: the current index, and the entire list.
	 *
	 * This would turn, for instance, [`R.map`](#map) function into one that
	 * more closely resembles `Array.prototype.map`. Note that this will only work
	 * for functions in which the iteration callback function is the first
	 * parameter, and where the list is the last parameter. (This latter might be
	 * unimportant if the list parameter is not used.)
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Function
	 * @category List
	 * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
	 * @param {Function} fn A list iteration function that does not pass index or list to its callback
	 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
	 * @example
	 *
	 *      var mapIndexed = R.addIndex(R.map);
	 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
	 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
	 */
	module.exports = _curry1(function addIndex(fn) {
	  return curryN(fn.length, function() {
	    var idx = 0;
	    var origFn = arguments[0];
	    var list = arguments[arguments.length - 1];
	    var args = Array.prototype.slice.call(arguments, 0);
	    args[0] = function() {
	      var result = origFn.apply(this, _concat(arguments, [idx, list]));
	      idx += 1;
	      return result;
	    };
	    return fn.apply(this, args);
	  });
	});


/***/ },
/* 643 */
[1037, 152, 36],
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(36);
	var _dispatchable = __webpack_require__(153);
	var _filter = __webpack_require__(650);
	var _isObject = __webpack_require__(653);
	var _reduce = __webpack_require__(155);
	var _xfilter = __webpack_require__(658);
	var keys = __webpack_require__(249);
	
	
	/**
	 * Takes a predicate and a `Filterable`, and returns a new filterable of the
	 * same type containing the members of the given filterable which satisfy the
	 * given predicate. Filterable objects include plain objects or any object
	 * that has a filter method such as `Array`.
	 *
	 * Dispatches to the `filter` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array} Filterable
	 * @see R.reject, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isEven = n => n % 2 === 0;
	 *
	 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	module.exports = _curry2(_dispatchable(['filter'], _xfilter, function(pred, filterable) {
	  return (
	    _isObject(filterable) ?
	      _reduce(function(acc, key) {
	        if (pred(filterable[key])) {
	          acc[key] = filterable[key];
	        }
	        return acc;
	      }, {}, keys(filterable)) :
	    // else
	      _filter(pred, filterable)
	  );
	}));


/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(36);
	var _dispatchable = __webpack_require__(153);
	var _xfind = __webpack_require__(659);
	
	
	/**
	 * Returns the first element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Dispatches to the `find` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 *        desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
	 *      R.find(R.propEq('a', 4))(xs); //=> undefined
	 */
	module.exports = _curry2(_dispatchable(['find'], _xfind, function find(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	    idx += 1;
	  }
	}));


/***/ },
/* 646 */
/***/ function(module, exports) {

	module.exports = function _complement(f) {
	  return function() {
	    return !f.apply(this, arguments);
	  };
	};


/***/ },
/* 647 */
/***/ function(module, exports) {

	/**
	 * Private `concat` function to merge two array-like objects.
	 *
	 * @private
	 * @param {Array|Arguments} [set1=[]] An array-like object.
	 * @param {Array|Arguments} [set2=[]] An array-like object.
	 * @return {Array} A new, merged array.
	 * @example
	 *
	 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 */
	module.exports = function _concat(set1, set2) {
	  set1 = set1 || [];
	  set2 = set2 || [];
	  var idx;
	  var len1 = set1.length;
	  var len2 = set2.length;
	  var result = [];
	
	  idx = 0;
	  while (idx < len1) {
	    result[result.length] = set1[idx];
	    idx += 1;
	  }
	  idx = 0;
	  while (idx < len2) {
	    result[result.length] = set2[idx];
	    idx += 1;
	  }
	  return result;
	};


/***/ },
/* 648 */
[1040, 55, 36, 112],
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(152);
	var _isPlaceholder = __webpack_require__(112);
	
	
	/**
	 * Internal curryN function.
	 *
	 * @private
	 * @category Function
	 * @param {Number} length The arity of the curried function.
	 * @param {Array} received An array of arguments received thus far.
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curryN(length, received, fn) {
	  return function() {
	    var combined = [];
	    var argsIdx = 0;
	    var left = length;
	    var combinedIdx = 0;
	    while (combinedIdx < received.length || argsIdx < arguments.length) {
	      var result;
	      if (combinedIdx < received.length &&
	          (!_isPlaceholder(received[combinedIdx]) ||
	           argsIdx >= arguments.length)) {
	        result = received[combinedIdx];
	      } else {
	        result = arguments[argsIdx];
	        argsIdx += 1;
	      }
	      combined[combinedIdx] = result;
	      if (!_isPlaceholder(result)) {
	        left -= 1;
	      }
	      combinedIdx += 1;
	    }
	    return left <= 0 ? fn.apply(this, combined)
	                     : _arity(left, _curryN(length, combined, fn));
	  };
	};


/***/ },
/* 650 */
/***/ function(module, exports) {

	module.exports = function _filter(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	
	  while (idx < len) {
	    if (fn(list[idx])) {
	      result[result.length] = list[idx];
	    }
	    idx += 1;
	  }
	  return result;
	};


/***/ },
/* 651 */
[1041, 154],
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(55);
	var _isArray = __webpack_require__(248);
	var _isString = __webpack_require__(654);
	
	
	/**
	 * Tests whether or not an object is similar to an array.
	 *
	 * @private
	 * @category Type
	 * @category List
	 * @sig * -> Boolean
	 * @param {*} x The object to test.
	 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
	 * @example
	 *
	 *      _isArrayLike([]); //=> true
	 *      _isArrayLike(true); //=> false
	 *      _isArrayLike({}); //=> false
	 *      _isArrayLike({length: 10}); //=> false
	 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
	 */
	module.exports = _curry1(function isArrayLike(x) {
	  if (_isArray(x)) { return true; }
	  if (!x) { return false; }
	  if (typeof x !== 'object') { return false; }
	  if (_isString(x)) { return false; }
	  if (x.nodeType === 1) { return !!x.length; }
	  if (x.length === 0) { return true; }
	  if (x.length > 0) {
	    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
	  }
	  return false;
	});


/***/ },
/* 653 */
/***/ function(module, exports) {

	module.exports = function _isObject(x) {
	  return Object.prototype.toString.call(x) === '[object Object]';
	};


/***/ },
/* 654 */
397,
/* 655 */
/***/ function(module, exports) {

	module.exports = function _isTransformer(obj) {
	  return typeof obj['@@transducer/step'] === 'function';
	};


/***/ },
/* 656 */
/***/ function(module, exports) {

	module.exports = function _map(fn, functor) {
	  var idx = 0;
	  var len = functor.length;
	  var result = Array(len);
	  while (idx < len) {
	    result[idx] = fn(functor[idx]);
	    idx += 1;
	  }
	  return result;
	};


/***/ },
/* 657 */
/***/ function(module, exports) {

	module.exports = function _reduced(x) {
	  return x && x['@@transducer/reduced'] ? x :
	    {
	      '@@transducer/value': x,
	      '@@transducer/reduced': true
	    };
	};


/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(36);
	var _xfBase = __webpack_require__(156);
	
	
	module.exports = (function() {
	  function XFilter(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XFilter.prototype['@@transducer/init'] = _xfBase.init;
	  XFilter.prototype['@@transducer/result'] = _xfBase.result;
	  XFilter.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
	  };
	
	  return _curry2(function _xfilter(f, xf) { return new XFilter(f, xf); });
	}());


/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(36);
	var _reduced = __webpack_require__(657);
	var _xfBase = __webpack_require__(156);
	
	
	module.exports = (function() {
	  function XFind(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.found = false;
	  }
	  XFind.prototype['@@transducer/init'] = _xfBase.init;
	  XFind.prototype['@@transducer/result'] = function(result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, void 0);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XFind.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, input));
	    }
	    return result;
	  };
	
	  return _curry2(function _xfind(f, xf) { return new XFind(f, xf); });
	}());


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(36);
	var _xfBase = __webpack_require__(156);
	
	
	module.exports = (function() {
	  function XMap(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XMap.prototype['@@transducer/init'] = _xfBase.init;
	  XMap.prototype['@@transducer/result'] = _xfBase.result;
	  XMap.prototype['@@transducer/step'] = function(result, input) {
	    return this.xf['@@transducer/step'](result, this.f(input));
	  };
	
	  return _curry2(function _xmap(f, xf) { return new XMap(f, xf); });
	}());


/***/ },
/* 661 */
/***/ function(module, exports) {

	module.exports = (function() {
	  function XWrap(fn) {
	    this.f = fn;
	  }
	  XWrap.prototype['@@transducer/init'] = function() {
	    throw new Error('init not implemented on XWrap');
	  };
	  XWrap.prototype['@@transducer/result'] = function(acc) { return acc; };
	  XWrap.prototype['@@transducer/step'] = function(acc, x) {
	    return this.f(acc, x);
	  };
	
	  return function _xwrap(fn) { return new XWrap(fn); };
	}());


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(36);
	var _dispatchable = __webpack_require__(153);
	var _map = __webpack_require__(656);
	var _reduce = __webpack_require__(155);
	var _xmap = __webpack_require__(660);
	var curryN = __webpack_require__(247);
	var keys = __webpack_require__(249);
	
	
	/**
	 * Takes a function and
	 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
	 * applies the function to each of the functor's values, and returns
	 * a functor of the same shape.
	 *
	 * Ramda provides suitable `map` implementations for `Array` and `Object`,
	 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
	 *
	 * Dispatches to the `map` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * Also treats functions as functors and will compose them together.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Functor f => (a -> b) -> f a -> f b
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {Array} list The list to be iterated over.
	 * @return {Array} The new list.
	 * @see R.transduce, R.addIndex
	 * @example
	 *
	 *      var double = x => x * 2;
	 *
	 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
	 *
	 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
	 * @symb R.map(f, [a, b]) = [f(a), f(b)]
	 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
	 * @symb R.map(f, functor_o) = functor_o.map(f)
	 */
	module.exports = _curry2(_dispatchable(['fantasy-land/map', 'map'], _xmap, function map(fn, functor) {
	  switch (Object.prototype.toString.call(functor)) {
	    case '[object Function]':
	      return curryN(functor.length, function() {
	        return fn.call(this, functor.apply(this, arguments));
	      });
	    case '[object Object]':
	      return _reduce(function(acc, key) {
	        acc[key] = fn(functor[key]);
	        return acc;
	      }, {}, keys(functor));
	    default:
	      return _map(fn, functor);
	  }
	}));


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(648);
	var _reduce = __webpack_require__(155);
	
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It may use
	 * [`R.reduced`](#reduced) to shortcut the iteration.
	 *
	 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
	 * is *(value, acc)*.
	 *
	 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduce` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
	 *
	 * Dispatches to the `reduce` method of the third argument, if present. When
	 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
	 * shortcuting, as this is not implemented by `reduce`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduced, R.addIndex, R.reduceRight
	 * @example
	 *
	 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
	 *                -               -10
	 *               / \              / \
	 *              -   4           -6   4
	 *             / \              / \
	 *            -   3   ==>     -3   3
	 *           / \              / \
	 *          -   2           -1   2
	 *         / \              / \
	 *        0   1            0   1
	 *
	 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
	 */
	module.exports = _curry3(_reduce);


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	var _complement = __webpack_require__(646);
	var _curry2 = __webpack_require__(36);
	var filter = __webpack_require__(644);
	
	
	/**
	 * The complement of [`filter`](#filter).
	 *
	 * Acts as a transducer if a transformer is given in list position. Filterable
	 * objects include plain objects or any object that has a filter method such
	 * as `Array`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array}
	 * @see R.filter, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isOdd = (n) => n % 2 === 1;
	 *
	 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	module.exports = _curry2(function reject(pred, filterable) {
	  return filter(_complement(pred), filterable);
	});


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(55);
	var _has = __webpack_require__(154);
	
	
	/**
	 * Converts an object into an array of key, value arrays. Only the object's
	 * own properties are used.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Object
	 * @sig {String: *} -> [[String,*]]
	 * @param {Object} obj The object to extract from
	 * @return {Array} An array of key, value arrays from the object's own properties.
	 * @see R.fromPairs
	 * @example
	 *
	 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
	 */
	module.exports = _curry1(function toPairs(obj) {
	  var pairs = [];
	  for (var prop in obj) {
	    if (_has(prop, obj)) {
	      pairs[pairs.length] = [prop, obj[prop]];
	    }
	  }
	  return pairs;
	});


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	var Tokenizer = __webpack_require__(667);
	
	/*
		Options:
	
		xmlMode: Disables the special behavior for script/style tags (false by default)
		lowerCaseAttributeNames: call .toLowerCase for each attribute name (true if xmlMode is `false`)
		lowerCaseTags: call .toLowerCase for each tag name (true if xmlMode is `false`)
	*/
	
	/*
		Callbacks:
	
		oncdataend,
		oncdatastart,
		onclosetag,
		oncomment,
		oncommentend,
		onerror,
		onopentag,
		onprocessinginstruction,
		onreset,
		ontext
	*/
	
	var formTags = {
	    input: true,
	    option: true,
	    optgroup: true,
	    select: true,
	    button: true,
	    datalist: true,
	    textarea: true
	};
	
	var openImpliesClose = {
	    tr: { tr: true, th: true, td: true },
	    th: { th: true },
	    td: { thead: true, th: true, td: true },
	    body: { head: true, link: true, script: true },
	    li: { li: true },
	    p: { p: true },
	    h1: { p: true },
	    h2: { p: true },
	    h3: { p: true },
	    h4: { p: true },
	    h5: { p: true },
	    h6: { p: true },
	    select: formTags,
	    input: formTags,
	    output: formTags,
	    button: formTags,
	    datalist: formTags,
	    textarea: formTags,
	    option: { option: true },
	    optgroup: { optgroup: true }
	};
	
	var voidElements = {
	    __proto__: null,
	    area: true,
	    base: true,
	    basefont: true,
	    br: true,
	    col: true,
	    command: true,
	    embed: true,
	    frame: true,
	    hr: true,
	    img: true,
	    input: true,
	    isindex: true,
	    keygen: true,
	    link: true,
	    meta: true,
	    param: true,
	    source: true,
	    track: true,
	    wbr: true
	};
	
	var foreignContextElements = {
	    __proto__: null,
	    math: true,
	    svg: true
	};
	var htmlIntegrationElements = {
	    __proto__: null,
	    mi: true,
	    mo: true,
	    mn: true,
	    ms: true,
	    mtext: true,
	    "annotation-xml": true,
	    foreignObject: true,
	    desc: true,
	    title: true
	};
	
	var re_nameEnd = /\s|\//;
	
	function Parser(cbs, options) {
	    this._options = options || {};
	    this._cbs = cbs || {};
	
	    this._tagname = "";
	    this._attribname = "";
	    this._attribvalue = "";
	    this._attribs = null;
	    this._stack = [];
	    this._foreignContext = [];
	
	    this.startIndex = 0;
	    this.endIndex = null;
	
	    this._lowerCaseTagNames =
	        "lowerCaseTags" in this._options
	            ? !!this._options.lowerCaseTags
	            : !this._options.xmlMode;
	    this._lowerCaseAttributeNames =
	        "lowerCaseAttributeNames" in this._options
	            ? !!this._options.lowerCaseAttributeNames
	            : !this._options.xmlMode;
	
	    if (this._options.Tokenizer) {
	        Tokenizer = this._options.Tokenizer;
	    }
	    this._tokenizer = new Tokenizer(this._options, this);
	
	    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
	}
	
	__webpack_require__(668)(Parser, __webpack_require__(611).EventEmitter);
	
	Parser.prototype._updatePosition = function(initialOffset) {
	    if (this.endIndex === null) {
	        if (this._tokenizer._sectionStart <= initialOffset) {
	            this.startIndex = 0;
	        } else {
	            this.startIndex = this._tokenizer._sectionStart - initialOffset;
	        }
	    } else this.startIndex = this.endIndex + 1;
	    this.endIndex = this._tokenizer.getAbsoluteIndex();
	};
	
	//Tokenizer event handlers
	Parser.prototype.ontext = function(data) {
	    this._updatePosition(1);
	    this.endIndex--;
	
	    if (this._cbs.ontext) this._cbs.ontext(data);
	};
	
	Parser.prototype.onopentagname = function(name) {
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	
	    this._tagname = name;
	
	    if (!this._options.xmlMode && name in openImpliesClose) {
	        for (
	            var el;
	            (el = this._stack[this._stack.length - 1]) in
	            openImpliesClose[name];
	            this.onclosetag(el)
	        );
	    }
	
	    if (this._options.xmlMode || !(name in voidElements)) {
	        this._stack.push(name);
	        if (name in foreignContextElements) this._foreignContext.push(true);
	        else if (name in htmlIntegrationElements)
	            this._foreignContext.push(false);
	    }
	
	    if (this._cbs.onopentagname) this._cbs.onopentagname(name);
	    if (this._cbs.onopentag) this._attribs = {};
	};
	
	Parser.prototype.onopentagend = function() {
	    this._updatePosition(1);
	
	    if (this._attribs) {
	        if (this._cbs.onopentag)
	            this._cbs.onopentag(this._tagname, this._attribs);
	        this._attribs = null;
	    }
	
	    if (
	        !this._options.xmlMode &&
	        this._cbs.onclosetag &&
	        this._tagname in voidElements
	    ) {
	        this._cbs.onclosetag(this._tagname);
	    }
	
	    this._tagname = "";
	};
	
	Parser.prototype.onclosetag = function(name) {
	    this._updatePosition(1);
	
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	    
	    if (name in foreignContextElements || name in htmlIntegrationElements) {
	        this._foreignContext.pop();
	    }
	
	    if (
	        this._stack.length &&
	        (!(name in voidElements) || this._options.xmlMode)
	    ) {
	        var pos = this._stack.lastIndexOf(name);
	        if (pos !== -1) {
	            if (this._cbs.onclosetag) {
	                pos = this._stack.length - pos;
	                while (pos--) this._cbs.onclosetag(this._stack.pop());
	            } else this._stack.length = pos;
	        } else if (name === "p" && !this._options.xmlMode) {
	            this.onopentagname(name);
	            this._closeCurrentTag();
	        }
	    } else if (!this._options.xmlMode && (name === "br" || name === "p")) {
	        this.onopentagname(name);
	        this._closeCurrentTag();
	    }
	};
	
	Parser.prototype.onselfclosingtag = function() {
	    if (
	        this._options.xmlMode ||
	        this._options.recognizeSelfClosing ||
	        this._foreignContext[this._foreignContext.length - 1]
	    ) {
	        this._closeCurrentTag();
	    } else {
	        this.onopentagend();
	    }
	};
	
	Parser.prototype._closeCurrentTag = function() {
	    var name = this._tagname;
	
	    this.onopentagend();
	
	    //self-closing tags will be on the top of the stack
	    //(cheaper check than in onclosetag)
	    if (this._stack[this._stack.length - 1] === name) {
	        if (this._cbs.onclosetag) {
	            this._cbs.onclosetag(name);
	        }
	        this._stack.pop();
	        
	    }
	};
	
	Parser.prototype.onattribname = function(name) {
	    if (this._lowerCaseAttributeNames) {
	        name = name.toLowerCase();
	    }
	    this._attribname = name;
	};
	
	Parser.prototype.onattribdata = function(value) {
	    this._attribvalue += value;
	};
	
	Parser.prototype.onattribend = function() {
	    if (this._cbs.onattribute)
	        this._cbs.onattribute(this._attribname, this._attribvalue);
	    if (
	        this._attribs &&
	        !Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)
	    ) {
	        this._attribs[this._attribname] = this._attribvalue;
	    }
	    this._attribname = "";
	    this._attribvalue = "";
	};
	
	Parser.prototype._getInstructionName = function(value) {
	    var idx = value.search(re_nameEnd),
	        name = idx < 0 ? value : value.substr(0, idx);
	
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	
	    return name;
	};
	
	Parser.prototype.ondeclaration = function(value) {
	    if (this._cbs.onprocessinginstruction) {
	        var name = this._getInstructionName(value);
	        this._cbs.onprocessinginstruction("!" + name, "!" + value);
	    }
	};
	
	Parser.prototype.onprocessinginstruction = function(value) {
	    if (this._cbs.onprocessinginstruction) {
	        var name = this._getInstructionName(value);
	        this._cbs.onprocessinginstruction("?" + name, "?" + value);
	    }
	};
	
	Parser.prototype.oncomment = function(value) {
	    this._updatePosition(4);
	
	    if (this._cbs.oncomment) this._cbs.oncomment(value);
	    if (this._cbs.oncommentend) this._cbs.oncommentend();
	};
	
	Parser.prototype.oncdata = function(value) {
	    this._updatePosition(1);
	
	    if (this._options.xmlMode || this._options.recognizeCDATA) {
	        if (this._cbs.oncdatastart) this._cbs.oncdatastart();
	        if (this._cbs.ontext) this._cbs.ontext(value);
	        if (this._cbs.oncdataend) this._cbs.oncdataend();
	    } else {
	        this.oncomment("[CDATA[" + value + "]]");
	    }
	};
	
	Parser.prototype.onerror = function(err) {
	    if (this._cbs.onerror) this._cbs.onerror(err);
	};
	
	Parser.prototype.onend = function() {
	    if (this._cbs.onclosetag) {
	        for (
	            var i = this._stack.length;
	            i > 0;
	            this._cbs.onclosetag(this._stack[--i])
	        );
	    }
	    if (this._cbs.onend) this._cbs.onend();
	};
	
	//Resets the parser to a blank state, ready to parse a new HTML document
	Parser.prototype.reset = function() {
	    if (this._cbs.onreset) this._cbs.onreset();
	    this._tokenizer.reset();
	
	    this._tagname = "";
	    this._attribname = "";
	    this._attribs = null;
	    this._stack = [];
	
	    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
	};
	
	//Parses a complete HTML document and pushes it to the handler
	Parser.prototype.parseComplete = function(data) {
	    this.reset();
	    this.end(data);
	};
	
	Parser.prototype.write = function(chunk) {
	    this._tokenizer.write(chunk);
	};
	
	Parser.prototype.end = function(chunk) {
	    this._tokenizer.end(chunk);
	};
	
	Parser.prototype.pause = function() {
	    this._tokenizer.pause();
	};
	
	Parser.prototype.resume = function() {
	    this._tokenizer.resume();
	};
	
	//alias for backwards compat
	Parser.prototype.parseChunk = Parser.prototype.write;
	Parser.prototype.done = Parser.prototype.end;
	
	module.exports = Parser;


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = Tokenizer;
	
	var decodeCodePoint = __webpack_require__(608);
	var entityMap = __webpack_require__(670);
	var legacyMap = __webpack_require__(671);
	var xmlMap = __webpack_require__(672);
	
	var i = 0;
	
	var TEXT = i++;
	var BEFORE_TAG_NAME = i++; //after <
	var IN_TAG_NAME = i++;
	var IN_SELF_CLOSING_TAG = i++;
	var BEFORE_CLOSING_TAG_NAME = i++;
	var IN_CLOSING_TAG_NAME = i++;
	var AFTER_CLOSING_TAG_NAME = i++;
	
	//attributes
	var BEFORE_ATTRIBUTE_NAME = i++;
	var IN_ATTRIBUTE_NAME = i++;
	var AFTER_ATTRIBUTE_NAME = i++;
	var BEFORE_ATTRIBUTE_VALUE = i++;
	var IN_ATTRIBUTE_VALUE_DQ = i++; // "
	var IN_ATTRIBUTE_VALUE_SQ = i++; // '
	var IN_ATTRIBUTE_VALUE_NQ = i++;
	
	//declarations
	var BEFORE_DECLARATION = i++; // !
	var IN_DECLARATION = i++;
	
	//processing instructions
	var IN_PROCESSING_INSTRUCTION = i++; // ?
	
	//comments
	var BEFORE_COMMENT = i++;
	var IN_COMMENT = i++;
	var AFTER_COMMENT_1 = i++;
	var AFTER_COMMENT_2 = i++;
	
	//cdata
	var BEFORE_CDATA_1 = i++; // [
	var BEFORE_CDATA_2 = i++; // C
	var BEFORE_CDATA_3 = i++; // D
	var BEFORE_CDATA_4 = i++; // A
	var BEFORE_CDATA_5 = i++; // T
	var BEFORE_CDATA_6 = i++; // A
	var IN_CDATA = i++; // [
	var AFTER_CDATA_1 = i++; // ]
	var AFTER_CDATA_2 = i++; // ]
	
	//special tags
	var BEFORE_SPECIAL = i++; //S
	var BEFORE_SPECIAL_END = i++; //S
	
	var BEFORE_SCRIPT_1 = i++; //C
	var BEFORE_SCRIPT_2 = i++; //R
	var BEFORE_SCRIPT_3 = i++; //I
	var BEFORE_SCRIPT_4 = i++; //P
	var BEFORE_SCRIPT_5 = i++; //T
	var AFTER_SCRIPT_1 = i++; //C
	var AFTER_SCRIPT_2 = i++; //R
	var AFTER_SCRIPT_3 = i++; //I
	var AFTER_SCRIPT_4 = i++; //P
	var AFTER_SCRIPT_5 = i++; //T
	
	var BEFORE_STYLE_1 = i++; //T
	var BEFORE_STYLE_2 = i++; //Y
	var BEFORE_STYLE_3 = i++; //L
	var BEFORE_STYLE_4 = i++; //E
	var AFTER_STYLE_1 = i++; //T
	var AFTER_STYLE_2 = i++; //Y
	var AFTER_STYLE_3 = i++; //L
	var AFTER_STYLE_4 = i++; //E
	
	var BEFORE_ENTITY = i++; //&
	var BEFORE_NUMERIC_ENTITY = i++; //#
	var IN_NAMED_ENTITY = i++;
	var IN_NUMERIC_ENTITY = i++;
	var IN_HEX_ENTITY = i++; //X
	
	var j = 0;
	
	var SPECIAL_NONE = j++;
	var SPECIAL_SCRIPT = j++;
	var SPECIAL_STYLE = j++;
	
	function whitespace(c) {
	    return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
	}
	
	function ifElseState(upper, SUCCESS, FAILURE) {
	    var lower = upper.toLowerCase();
	
	    if (upper === lower) {
	        return function(c) {
	            if (c === lower) {
	                this._state = SUCCESS;
	            } else {
	                this._state = FAILURE;
	                this._index--;
	            }
	        };
	    } else {
	        return function(c) {
	            if (c === lower || c === upper) {
	                this._state = SUCCESS;
	            } else {
	                this._state = FAILURE;
	                this._index--;
	            }
	        };
	    }
	}
	
	function consumeSpecialNameChar(upper, NEXT_STATE) {
	    var lower = upper.toLowerCase();
	
	    return function(c) {
	        if (c === lower || c === upper) {
	            this._state = NEXT_STATE;
	        } else {
	            this._state = IN_TAG_NAME;
	            this._index--; //consume the token again
	        }
	    };
	}
	
	function Tokenizer(options, cbs) {
	    this._state = TEXT;
	    this._buffer = "";
	    this._sectionStart = 0;
	    this._index = 0;
	    this._bufferOffset = 0; //chars removed from _buffer
	    this._baseState = TEXT;
	    this._special = SPECIAL_NONE;
	    this._cbs = cbs;
	    this._running = true;
	    this._ended = false;
	    this._xmlMode = !!(options && options.xmlMode);
	    this._decodeEntities = !!(options && options.decodeEntities);
	}
	
	Tokenizer.prototype._stateText = function(c) {
	    if (c === "<") {
	        if (this._index > this._sectionStart) {
	            this._cbs.ontext(this._getSection());
	        }
	        this._state = BEFORE_TAG_NAME;
	        this._sectionStart = this._index;
	    } else if (
	        this._decodeEntities &&
	        this._special === SPECIAL_NONE &&
	        c === "&"
	    ) {
	        if (this._index > this._sectionStart) {
	            this._cbs.ontext(this._getSection());
	        }
	        this._baseState = TEXT;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeTagName = function(c) {
	    if (c === "/") {
	        this._state = BEFORE_CLOSING_TAG_NAME;
	    } else if (c === "<") {
	        this._cbs.ontext(this._getSection());
	        this._sectionStart = this._index;
	    } else if (c === ">" || this._special !== SPECIAL_NONE || whitespace(c)) {
	        this._state = TEXT;
	    } else if (c === "!") {
	        this._state = BEFORE_DECLARATION;
	        this._sectionStart = this._index + 1;
	    } else if (c === "?") {
	        this._state = IN_PROCESSING_INSTRUCTION;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state =
	            !this._xmlMode && (c === "s" || c === "S")
	                ? BEFORE_SPECIAL
	                : IN_TAG_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInTagName = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._emitToken("onopentagname");
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateBeforeCloseingTagName = function(c) {
	    if (whitespace(c));
	    else if (c === ">") {
	        this._state = TEXT;
	    } else if (this._special !== SPECIAL_NONE) {
	        if (c === "s" || c === "S") {
	            this._state = BEFORE_SPECIAL_END;
	        } else {
	            this._state = TEXT;
	            this._index--;
	        }
	    } else {
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInCloseingTagName = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._emitToken("onclosetag");
	        this._state = AFTER_CLOSING_TAG_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateAfterCloseingTagName = function(c) {
	    //skip everything until ">"
	    if (c === ">") {
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateBeforeAttributeName = function(c) {
	    if (c === ">") {
	        this._cbs.onopentagend();
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c === "/") {
	        this._state = IN_SELF_CLOSING_TAG;
	    } else if (!whitespace(c)) {
	        this._state = IN_ATTRIBUTE_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInSelfClosingTag = function(c) {
	    if (c === ">") {
	        this._cbs.onselfclosingtag();
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (!whitespace(c)) {
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeName = function(c) {
	    if (c === "=" || c === "/" || c === ">" || whitespace(c)) {
	        this._cbs.onattribname(this._getSection());
	        this._sectionStart = -1;
	        this._state = AFTER_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateAfterAttributeName = function(c) {
	    if (c === "=") {
	        this._state = BEFORE_ATTRIBUTE_VALUE;
	    } else if (c === "/" || c === ">") {
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    } else if (!whitespace(c)) {
	        this._cbs.onattribend();
	        this._state = IN_ATTRIBUTE_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeAttributeValue = function(c) {
	    if (c === '"') {
	        this._state = IN_ATTRIBUTE_VALUE_DQ;
	        this._sectionStart = this._index + 1;
	    } else if (c === "'") {
	        this._state = IN_ATTRIBUTE_VALUE_SQ;
	        this._sectionStart = this._index + 1;
	    } else if (!whitespace(c)) {
	        this._state = IN_ATTRIBUTE_VALUE_NQ;
	        this._sectionStart = this._index;
	        this._index--; //reconsume token
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function(c) {
	    if (c === '"') {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueSingleQuotes = function(c) {
	    if (c === "'") {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueNoQuotes = function(c) {
	    if (whitespace(c) || c === ">") {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeDeclaration = function(c) {
	    this._state =
	        c === "["
	            ? BEFORE_CDATA_1
	            : c === "-"
	                ? BEFORE_COMMENT
	                : IN_DECLARATION;
	};
	
	Tokenizer.prototype._stateInDeclaration = function(c) {
	    if (c === ">") {
	        this._cbs.ondeclaration(this._getSection());
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateInProcessingInstruction = function(c) {
	    if (c === ">") {
	        this._cbs.onprocessinginstruction(this._getSection());
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateBeforeComment = function(c) {
	    if (c === "-") {
	        this._state = IN_COMMENT;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state = IN_DECLARATION;
	    }
	};
	
	Tokenizer.prototype._stateInComment = function(c) {
	    if (c === "-") this._state = AFTER_COMMENT_1;
	};
	
	Tokenizer.prototype._stateAfterComment1 = function(c) {
	    if (c === "-") {
	        this._state = AFTER_COMMENT_2;
	    } else {
	        this._state = IN_COMMENT;
	    }
	};
	
	Tokenizer.prototype._stateAfterComment2 = function(c) {
	    if (c === ">") {
	        //remove 2 trailing chars
	        this._cbs.oncomment(
	            this._buffer.substring(this._sectionStart, this._index - 2)
	        );
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c !== "-") {
	        this._state = IN_COMMENT;
	    }
	    // else: stay in AFTER_COMMENT_2 (`--->`)
	};
	
	Tokenizer.prototype._stateBeforeCdata1 = ifElseState(
	    "C",
	    BEFORE_CDATA_2,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata2 = ifElseState(
	    "D",
	    BEFORE_CDATA_3,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata3 = ifElseState(
	    "A",
	    BEFORE_CDATA_4,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata4 = ifElseState(
	    "T",
	    BEFORE_CDATA_5,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata5 = ifElseState(
	    "A",
	    BEFORE_CDATA_6,
	    IN_DECLARATION
	);
	
	Tokenizer.prototype._stateBeforeCdata6 = function(c) {
	    if (c === "[") {
	        this._state = IN_CDATA;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state = IN_DECLARATION;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInCdata = function(c) {
	    if (c === "]") this._state = AFTER_CDATA_1;
	};
	
	Tokenizer.prototype._stateAfterCdata1 = function(c) {
	    if (c === "]") this._state = AFTER_CDATA_2;
	    else this._state = IN_CDATA;
	};
	
	Tokenizer.prototype._stateAfterCdata2 = function(c) {
	    if (c === ">") {
	        //remove 2 trailing chars
	        this._cbs.oncdata(
	            this._buffer.substring(this._sectionStart, this._index - 2)
	        );
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c !== "]") {
	        this._state = IN_CDATA;
	    }
	    //else: stay in AFTER_CDATA_2 (`]]]>`)
	};
	
	Tokenizer.prototype._stateBeforeSpecial = function(c) {
	    if (c === "c" || c === "C") {
	        this._state = BEFORE_SCRIPT_1;
	    } else if (c === "t" || c === "T") {
	        this._state = BEFORE_STYLE_1;
	    } else {
	        this._state = IN_TAG_NAME;
	        this._index--; //consume the token again
	    }
	};
	
	Tokenizer.prototype._stateBeforeSpecialEnd = function(c) {
	    if (this._special === SPECIAL_SCRIPT && (c === "c" || c === "C")) {
	        this._state = AFTER_SCRIPT_1;
	    } else if (this._special === SPECIAL_STYLE && (c === "t" || c === "T")) {
	        this._state = AFTER_STYLE_1;
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeScript1 = consumeSpecialNameChar(
	    "R",
	    BEFORE_SCRIPT_2
	);
	Tokenizer.prototype._stateBeforeScript2 = consumeSpecialNameChar(
	    "I",
	    BEFORE_SCRIPT_3
	);
	Tokenizer.prototype._stateBeforeScript3 = consumeSpecialNameChar(
	    "P",
	    BEFORE_SCRIPT_4
	);
	Tokenizer.prototype._stateBeforeScript4 = consumeSpecialNameChar(
	    "T",
	    BEFORE_SCRIPT_5
	);
	
	Tokenizer.prototype._stateBeforeScript5 = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._special = SPECIAL_SCRIPT;
	    }
	    this._state = IN_TAG_NAME;
	    this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterScript1 = ifElseState("R", AFTER_SCRIPT_2, TEXT);
	Tokenizer.prototype._stateAfterScript2 = ifElseState("I", AFTER_SCRIPT_3, TEXT);
	Tokenizer.prototype._stateAfterScript3 = ifElseState("P", AFTER_SCRIPT_4, TEXT);
	Tokenizer.prototype._stateAfterScript4 = ifElseState("T", AFTER_SCRIPT_5, TEXT);
	
	Tokenizer.prototype._stateAfterScript5 = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._special = SPECIAL_NONE;
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index - 6;
	        this._index--; //reconsume the token
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeStyle1 = consumeSpecialNameChar(
	    "Y",
	    BEFORE_STYLE_2
	);
	Tokenizer.prototype._stateBeforeStyle2 = consumeSpecialNameChar(
	    "L",
	    BEFORE_STYLE_3
	);
	Tokenizer.prototype._stateBeforeStyle3 = consumeSpecialNameChar(
	    "E",
	    BEFORE_STYLE_4
	);
	
	Tokenizer.prototype._stateBeforeStyle4 = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._special = SPECIAL_STYLE;
	    }
	    this._state = IN_TAG_NAME;
	    this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterStyle1 = ifElseState("Y", AFTER_STYLE_2, TEXT);
	Tokenizer.prototype._stateAfterStyle2 = ifElseState("L", AFTER_STYLE_3, TEXT);
	Tokenizer.prototype._stateAfterStyle3 = ifElseState("E", AFTER_STYLE_4, TEXT);
	
	Tokenizer.prototype._stateAfterStyle4 = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._special = SPECIAL_NONE;
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index - 5;
	        this._index--; //reconsume the token
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeEntity = ifElseState(
	    "#",
	    BEFORE_NUMERIC_ENTITY,
	    IN_NAMED_ENTITY
	);
	Tokenizer.prototype._stateBeforeNumericEntity = ifElseState(
	    "X",
	    IN_HEX_ENTITY,
	    IN_NUMERIC_ENTITY
	);
	
	//for entities terminated with a semicolon
	Tokenizer.prototype._parseNamedEntityStrict = function() {
	    //offset = 1
	    if (this._sectionStart + 1 < this._index) {
	        var entity = this._buffer.substring(
	                this._sectionStart + 1,
	                this._index
	            ),
	            map = this._xmlMode ? xmlMap : entityMap;
	
	        if (map.hasOwnProperty(entity)) {
	            this._emitPartial(map[entity]);
	            this._sectionStart = this._index + 1;
	        }
	    }
	};
	
	//parses legacy entities (without trailing semicolon)
	Tokenizer.prototype._parseLegacyEntity = function() {
	    var start = this._sectionStart + 1,
	        limit = this._index - start;
	
	    if (limit > 6) limit = 6; //the max length of legacy entities is 6
	
	    while (limit >= 2) {
	        //the min length of legacy entities is 2
	        var entity = this._buffer.substr(start, limit);
	
	        if (legacyMap.hasOwnProperty(entity)) {
	            this._emitPartial(legacyMap[entity]);
	            this._sectionStart += limit + 1;
	            return;
	        } else {
	            limit--;
	        }
	    }
	};
	
	Tokenizer.prototype._stateInNamedEntity = function(c) {
	    if (c === ";") {
	        this._parseNamedEntityStrict();
	        if (this._sectionStart + 1 < this._index && !this._xmlMode) {
	            this._parseLegacyEntity();
	        }
	        this._state = this._baseState;
	    } else if (
	        (c < "a" || c > "z") &&
	        (c < "A" || c > "Z") &&
	        (c < "0" || c > "9")
	    ) {
	        if (this._xmlMode);
	        else if (this._sectionStart + 1 === this._index);
	        else if (this._baseState !== TEXT) {
	            if (c !== "=") {
	                this._parseNamedEntityStrict();
	            }
	        } else {
	            this._parseLegacyEntity();
	        }
	
	        this._state = this._baseState;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._decodeNumericEntity = function(offset, base) {
	    var sectionStart = this._sectionStart + offset;
	
	    if (sectionStart !== this._index) {
	        //parse entity
	        var entity = this._buffer.substring(sectionStart, this._index);
	        var parsed = parseInt(entity, base);
	
	        this._emitPartial(decodeCodePoint(parsed));
	        this._sectionStart = this._index;
	    } else {
	        this._sectionStart--;
	    }
	
	    this._state = this._baseState;
	};
	
	Tokenizer.prototype._stateInNumericEntity = function(c) {
	    if (c === ";") {
	        this._decodeNumericEntity(2, 10);
	        this._sectionStart++;
	    } else if (c < "0" || c > "9") {
	        if (!this._xmlMode) {
	            this._decodeNumericEntity(2, 10);
	        } else {
	            this._state = this._baseState;
	        }
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInHexEntity = function(c) {
	    if (c === ";") {
	        this._decodeNumericEntity(3, 16);
	        this._sectionStart++;
	    } else if (
	        (c < "a" || c > "f") &&
	        (c < "A" || c > "F") &&
	        (c < "0" || c > "9")
	    ) {
	        if (!this._xmlMode) {
	            this._decodeNumericEntity(3, 16);
	        } else {
	            this._state = this._baseState;
	        }
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._cleanup = function() {
	    if (this._sectionStart < 0) {
	        this._buffer = "";
	        this._bufferOffset += this._index;
	        this._index = 0;
	    } else if (this._running) {
	        if (this._state === TEXT) {
	            if (this._sectionStart !== this._index) {
	                this._cbs.ontext(this._buffer.substr(this._sectionStart));
	            }
	            this._buffer = "";
	            this._bufferOffset += this._index;
	            this._index = 0;
	        } else if (this._sectionStart === this._index) {
	            //the section just started
	            this._buffer = "";
	            this._bufferOffset += this._index;
	            this._index = 0;
	        } else {
	            //remove everything unnecessary
	            this._buffer = this._buffer.substr(this._sectionStart);
	            this._index -= this._sectionStart;
	            this._bufferOffset += this._sectionStart;
	        }
	
	        this._sectionStart = 0;
	    }
	};
	
	//TODO make events conditional
	Tokenizer.prototype.write = function(chunk) {
	    if (this._ended) this._cbs.onerror(Error(".write() after done!"));
	
	    this._buffer += chunk;
	    this._parse();
	};
	
	Tokenizer.prototype._parse = function() {
	    while (this._index < this._buffer.length && this._running) {
	        var c = this._buffer.charAt(this._index);
	        if (this._state === TEXT) {
	            this._stateText(c);
	        } else if (this._state === BEFORE_TAG_NAME) {
	            this._stateBeforeTagName(c);
	        } else if (this._state === IN_TAG_NAME) {
	            this._stateInTagName(c);
	        } else if (this._state === BEFORE_CLOSING_TAG_NAME) {
	            this._stateBeforeCloseingTagName(c);
	        } else if (this._state === IN_CLOSING_TAG_NAME) {
	            this._stateInCloseingTagName(c);
	        } else if (this._state === AFTER_CLOSING_TAG_NAME) {
	            this._stateAfterCloseingTagName(c);
	        } else if (this._state === IN_SELF_CLOSING_TAG) {
	            this._stateInSelfClosingTag(c);
	        } else if (this._state === BEFORE_ATTRIBUTE_NAME) {
	
	        /*
			*	attributes
			*/
	            this._stateBeforeAttributeName(c);
	        } else if (this._state === IN_ATTRIBUTE_NAME) {
	            this._stateInAttributeName(c);
	        } else if (this._state === AFTER_ATTRIBUTE_NAME) {
	            this._stateAfterAttributeName(c);
	        } else if (this._state === BEFORE_ATTRIBUTE_VALUE) {
	            this._stateBeforeAttributeValue(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_DQ) {
	            this._stateInAttributeValueDoubleQuotes(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_SQ) {
	            this._stateInAttributeValueSingleQuotes(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_NQ) {
	            this._stateInAttributeValueNoQuotes(c);
	        } else if (this._state === BEFORE_DECLARATION) {
	
	        /*
			*	declarations
			*/
	            this._stateBeforeDeclaration(c);
	        } else if (this._state === IN_DECLARATION) {
	            this._stateInDeclaration(c);
	        } else if (this._state === IN_PROCESSING_INSTRUCTION) {
	
	        /*
			*	processing instructions
			*/
	            this._stateInProcessingInstruction(c);
	        } else if (this._state === BEFORE_COMMENT) {
	
	        /*
			*	comments
			*/
	            this._stateBeforeComment(c);
	        } else if (this._state === IN_COMMENT) {
	            this._stateInComment(c);
	        } else if (this._state === AFTER_COMMENT_1) {
	            this._stateAfterComment1(c);
	        } else if (this._state === AFTER_COMMENT_2) {
	            this._stateAfterComment2(c);
	        } else if (this._state === BEFORE_CDATA_1) {
	
	        /*
			*	cdata
			*/
	            this._stateBeforeCdata1(c);
	        } else if (this._state === BEFORE_CDATA_2) {
	            this._stateBeforeCdata2(c);
	        } else if (this._state === BEFORE_CDATA_3) {
	            this._stateBeforeCdata3(c);
	        } else if (this._state === BEFORE_CDATA_4) {
	            this._stateBeforeCdata4(c);
	        } else if (this._state === BEFORE_CDATA_5) {
	            this._stateBeforeCdata5(c);
	        } else if (this._state === BEFORE_CDATA_6) {
	            this._stateBeforeCdata6(c);
	        } else if (this._state === IN_CDATA) {
	            this._stateInCdata(c);
	        } else if (this._state === AFTER_CDATA_1) {
	            this._stateAfterCdata1(c);
	        } else if (this._state === AFTER_CDATA_2) {
	            this._stateAfterCdata2(c);
	        } else if (this._state === BEFORE_SPECIAL) {
	
	        /*
			* special tags
			*/
	            this._stateBeforeSpecial(c);
	        } else if (this._state === BEFORE_SPECIAL_END) {
	            this._stateBeforeSpecialEnd(c);
	        } else if (this._state === BEFORE_SCRIPT_1) {
	
	        /*
			* script
			*/
	            this._stateBeforeScript1(c);
	        } else if (this._state === BEFORE_SCRIPT_2) {
	            this._stateBeforeScript2(c);
	        } else if (this._state === BEFORE_SCRIPT_3) {
	            this._stateBeforeScript3(c);
	        } else if (this._state === BEFORE_SCRIPT_4) {
	            this._stateBeforeScript4(c);
	        } else if (this._state === BEFORE_SCRIPT_5) {
	            this._stateBeforeScript5(c);
	        } else if (this._state === AFTER_SCRIPT_1) {
	            this._stateAfterScript1(c);
	        } else if (this._state === AFTER_SCRIPT_2) {
	            this._stateAfterScript2(c);
	        } else if (this._state === AFTER_SCRIPT_3) {
	            this._stateAfterScript3(c);
	        } else if (this._state === AFTER_SCRIPT_4) {
	            this._stateAfterScript4(c);
	        } else if (this._state === AFTER_SCRIPT_5) {
	            this._stateAfterScript5(c);
	        } else if (this._state === BEFORE_STYLE_1) {
	
	        /*
			* style
			*/
	            this._stateBeforeStyle1(c);
	        } else if (this._state === BEFORE_STYLE_2) {
	            this._stateBeforeStyle2(c);
	        } else if (this._state === BEFORE_STYLE_3) {
	            this._stateBeforeStyle3(c);
	        } else if (this._state === BEFORE_STYLE_4) {
	            this._stateBeforeStyle4(c);
	        } else if (this._state === AFTER_STYLE_1) {
	            this._stateAfterStyle1(c);
	        } else if (this._state === AFTER_STYLE_2) {
	            this._stateAfterStyle2(c);
	        } else if (this._state === AFTER_STYLE_3) {
	            this._stateAfterStyle3(c);
	        } else if (this._state === AFTER_STYLE_4) {
	            this._stateAfterStyle4(c);
	        } else if (this._state === BEFORE_ENTITY) {
	
	        /*
			* entities
			*/
	            this._stateBeforeEntity(c);
	        } else if (this._state === BEFORE_NUMERIC_ENTITY) {
	            this._stateBeforeNumericEntity(c);
	        } else if (this._state === IN_NAMED_ENTITY) {
	            this._stateInNamedEntity(c);
	        } else if (this._state === IN_NUMERIC_ENTITY) {
	            this._stateInNumericEntity(c);
	        } else if (this._state === IN_HEX_ENTITY) {
	            this._stateInHexEntity(c);
	        } else {
	            this._cbs.onerror(Error("unknown _state"), this._state);
	        }
	
	        this._index++;
	    }
	
	    this._cleanup();
	};
	
	Tokenizer.prototype.pause = function() {
	    this._running = false;
	};
	Tokenizer.prototype.resume = function() {
	    this._running = true;
	
	    if (this._index < this._buffer.length) {
	        this._parse();
	    }
	    if (this._ended) {
	        this._finish();
	    }
	};
	
	Tokenizer.prototype.end = function(chunk) {
	    if (this._ended) this._cbs.onerror(Error(".end() after done!"));
	    if (chunk) this.write(chunk);
	
	    this._ended = true;
	
	    if (this._running) this._finish();
	};
	
	Tokenizer.prototype._finish = function() {
	    //if there is remaining data, emit it in a reasonable way
	    if (this._sectionStart < this._index) {
	        this._handleTrailingData();
	    }
	
	    this._cbs.onend();
	};
	
	Tokenizer.prototype._handleTrailingData = function() {
	    var data = this._buffer.substr(this._sectionStart);
	
	    if (
	        this._state === IN_CDATA ||
	        this._state === AFTER_CDATA_1 ||
	        this._state === AFTER_CDATA_2
	    ) {
	        this._cbs.oncdata(data);
	    } else if (
	        this._state === IN_COMMENT ||
	        this._state === AFTER_COMMENT_1 ||
	        this._state === AFTER_COMMENT_2
	    ) {
	        this._cbs.oncomment(data);
	    } else if (this._state === IN_NAMED_ENTITY && !this._xmlMode) {
	        this._parseLegacyEntity();
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (this._state === IN_NUMERIC_ENTITY && !this._xmlMode) {
	        this._decodeNumericEntity(2, 10);
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (this._state === IN_HEX_ENTITY && !this._xmlMode) {
	        this._decodeNumericEntity(3, 16);
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (
	        this._state !== IN_TAG_NAME &&
	        this._state !== BEFORE_ATTRIBUTE_NAME &&
	        this._state !== BEFORE_ATTRIBUTE_VALUE &&
	        this._state !== AFTER_ATTRIBUTE_NAME &&
	        this._state !== IN_ATTRIBUTE_NAME &&
	        this._state !== IN_ATTRIBUTE_VALUE_SQ &&
	        this._state !== IN_ATTRIBUTE_VALUE_DQ &&
	        this._state !== IN_ATTRIBUTE_VALUE_NQ &&
	        this._state !== IN_CLOSING_TAG_NAME
	    ) {
	        this._cbs.ontext(data);
	    }
	    //else, ignore remaining data
	    //TODO add a way to remove current tag
	};
	
	Tokenizer.prototype.reset = function() {
	    Tokenizer.call(
	        this,
	        { xmlMode: this._xmlMode, decodeEntities: this._decodeEntities },
	        this._cbs
	    );
	};
	
	Tokenizer.prototype.getAbsoluteIndex = function() {
	    return this._bufferOffset + this._index;
	};
	
	Tokenizer.prototype._getSection = function() {
	    return this._buffer.substring(this._sectionStart, this._index);
	};
	
	Tokenizer.prototype._emitToken = function(name) {
	    this._cbs[name](this._getSection());
	    this._sectionStart = -1;
	};
	
	Tokenizer.prototype._emitPartial = function(value) {
	    if (this._baseState !== TEXT) {
	        this._cbs.onattribdata(value); //TODO implement the new event
	    } else {
	        this._cbs.ontext(value);
	    }
	};


/***/ },
/* 668 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ },
/* 669 */
/***/ function(module, exports) {

	module.exports = {
		"0": 65533,
		"128": 8364,
		"130": 8218,
		"131": 402,
		"132": 8222,
		"133": 8230,
		"134": 8224,
		"135": 8225,
		"136": 710,
		"137": 8240,
		"138": 352,
		"139": 8249,
		"140": 338,
		"142": 381,
		"145": 8216,
		"146": 8217,
		"147": 8220,
		"148": 8221,
		"149": 8226,
		"150": 8211,
		"151": 8212,
		"152": 732,
		"153": 8482,
		"154": 353,
		"155": 8250,
		"156": 339,
		"158": 382,
		"159": 376
	};

/***/ },
/* 670 */
/***/ function(module, exports) {

	module.exports = {
		"Aacute": "Á",
		"aacute": "á",
		"Abreve": "Ă",
		"abreve": "ă",
		"ac": "∾",
		"acd": "∿",
		"acE": "∾̳",
		"Acirc": "Â",
		"acirc": "â",
		"acute": "´",
		"Acy": "А",
		"acy": "а",
		"AElig": "Æ",
		"aelig": "æ",
		"af": "⁡",
		"Afr": "𝔄",
		"afr": "𝔞",
		"Agrave": "À",
		"agrave": "à",
		"alefsym": "ℵ",
		"aleph": "ℵ",
		"Alpha": "Α",
		"alpha": "α",
		"Amacr": "Ā",
		"amacr": "ā",
		"amalg": "⨿",
		"amp": "&",
		"AMP": "&",
		"andand": "⩕",
		"And": "⩓",
		"and": "∧",
		"andd": "⩜",
		"andslope": "⩘",
		"andv": "⩚",
		"ang": "∠",
		"ange": "⦤",
		"angle": "∠",
		"angmsdaa": "⦨",
		"angmsdab": "⦩",
		"angmsdac": "⦪",
		"angmsdad": "⦫",
		"angmsdae": "⦬",
		"angmsdaf": "⦭",
		"angmsdag": "⦮",
		"angmsdah": "⦯",
		"angmsd": "∡",
		"angrt": "∟",
		"angrtvb": "⊾",
		"angrtvbd": "⦝",
		"angsph": "∢",
		"angst": "Å",
		"angzarr": "⍼",
		"Aogon": "Ą",
		"aogon": "ą",
		"Aopf": "𝔸",
		"aopf": "𝕒",
		"apacir": "⩯",
		"ap": "≈",
		"apE": "⩰",
		"ape": "≊",
		"apid": "≋",
		"apos": "'",
		"ApplyFunction": "⁡",
		"approx": "≈",
		"approxeq": "≊",
		"Aring": "Å",
		"aring": "å",
		"Ascr": "𝒜",
		"ascr": "𝒶",
		"Assign": "≔",
		"ast": "*",
		"asymp": "≈",
		"asympeq": "≍",
		"Atilde": "Ã",
		"atilde": "ã",
		"Auml": "Ä",
		"auml": "ä",
		"awconint": "∳",
		"awint": "⨑",
		"backcong": "≌",
		"backepsilon": "϶",
		"backprime": "‵",
		"backsim": "∽",
		"backsimeq": "⋍",
		"Backslash": "∖",
		"Barv": "⫧",
		"barvee": "⊽",
		"barwed": "⌅",
		"Barwed": "⌆",
		"barwedge": "⌅",
		"bbrk": "⎵",
		"bbrktbrk": "⎶",
		"bcong": "≌",
		"Bcy": "Б",
		"bcy": "б",
		"bdquo": "„",
		"becaus": "∵",
		"because": "∵",
		"Because": "∵",
		"bemptyv": "⦰",
		"bepsi": "϶",
		"bernou": "ℬ",
		"Bernoullis": "ℬ",
		"Beta": "Β",
		"beta": "β",
		"beth": "ℶ",
		"between": "≬",
		"Bfr": "𝔅",
		"bfr": "𝔟",
		"bigcap": "⋂",
		"bigcirc": "◯",
		"bigcup": "⋃",
		"bigodot": "⨀",
		"bigoplus": "⨁",
		"bigotimes": "⨂",
		"bigsqcup": "⨆",
		"bigstar": "★",
		"bigtriangledown": "▽",
		"bigtriangleup": "△",
		"biguplus": "⨄",
		"bigvee": "⋁",
		"bigwedge": "⋀",
		"bkarow": "⤍",
		"blacklozenge": "⧫",
		"blacksquare": "▪",
		"blacktriangle": "▴",
		"blacktriangledown": "▾",
		"blacktriangleleft": "◂",
		"blacktriangleright": "▸",
		"blank": "␣",
		"blk12": "▒",
		"blk14": "░",
		"blk34": "▓",
		"block": "█",
		"bne": "=⃥",
		"bnequiv": "≡⃥",
		"bNot": "⫭",
		"bnot": "⌐",
		"Bopf": "𝔹",
		"bopf": "𝕓",
		"bot": "⊥",
		"bottom": "⊥",
		"bowtie": "⋈",
		"boxbox": "⧉",
		"boxdl": "┐",
		"boxdL": "╕",
		"boxDl": "╖",
		"boxDL": "╗",
		"boxdr": "┌",
		"boxdR": "╒",
		"boxDr": "╓",
		"boxDR": "╔",
		"boxh": "─",
		"boxH": "═",
		"boxhd": "┬",
		"boxHd": "╤",
		"boxhD": "╥",
		"boxHD": "╦",
		"boxhu": "┴",
		"boxHu": "╧",
		"boxhU": "╨",
		"boxHU": "╩",
		"boxminus": "⊟",
		"boxplus": "⊞",
		"boxtimes": "⊠",
		"boxul": "┘",
		"boxuL": "╛",
		"boxUl": "╜",
		"boxUL": "╝",
		"boxur": "└",
		"boxuR": "╘",
		"boxUr": "╙",
		"boxUR": "╚",
		"boxv": "│",
		"boxV": "║",
		"boxvh": "┼",
		"boxvH": "╪",
		"boxVh": "╫",
		"boxVH": "╬",
		"boxvl": "┤",
		"boxvL": "╡",
		"boxVl": "╢",
		"boxVL": "╣",
		"boxvr": "├",
		"boxvR": "╞",
		"boxVr": "╟",
		"boxVR": "╠",
		"bprime": "‵",
		"breve": "˘",
		"Breve": "˘",
		"brvbar": "¦",
		"bscr": "𝒷",
		"Bscr": "ℬ",
		"bsemi": "⁏",
		"bsim": "∽",
		"bsime": "⋍",
		"bsolb": "⧅",
		"bsol": "\\",
		"bsolhsub": "⟈",
		"bull": "•",
		"bullet": "•",
		"bump": "≎",
		"bumpE": "⪮",
		"bumpe": "≏",
		"Bumpeq": "≎",
		"bumpeq": "≏",
		"Cacute": "Ć",
		"cacute": "ć",
		"capand": "⩄",
		"capbrcup": "⩉",
		"capcap": "⩋",
		"cap": "∩",
		"Cap": "⋒",
		"capcup": "⩇",
		"capdot": "⩀",
		"CapitalDifferentialD": "ⅅ",
		"caps": "∩︀",
		"caret": "⁁",
		"caron": "ˇ",
		"Cayleys": "ℭ",
		"ccaps": "⩍",
		"Ccaron": "Č",
		"ccaron": "č",
		"Ccedil": "Ç",
		"ccedil": "ç",
		"Ccirc": "Ĉ",
		"ccirc": "ĉ",
		"Cconint": "∰",
		"ccups": "⩌",
		"ccupssm": "⩐",
		"Cdot": "Ċ",
		"cdot": "ċ",
		"cedil": "¸",
		"Cedilla": "¸",
		"cemptyv": "⦲",
		"cent": "¢",
		"centerdot": "·",
		"CenterDot": "·",
		"cfr": "𝔠",
		"Cfr": "ℭ",
		"CHcy": "Ч",
		"chcy": "ч",
		"check": "✓",
		"checkmark": "✓",
		"Chi": "Χ",
		"chi": "χ",
		"circ": "ˆ",
		"circeq": "≗",
		"circlearrowleft": "↺",
		"circlearrowright": "↻",
		"circledast": "⊛",
		"circledcirc": "⊚",
		"circleddash": "⊝",
		"CircleDot": "⊙",
		"circledR": "®",
		"circledS": "Ⓢ",
		"CircleMinus": "⊖",
		"CirclePlus": "⊕",
		"CircleTimes": "⊗",
		"cir": "○",
		"cirE": "⧃",
		"cire": "≗",
		"cirfnint": "⨐",
		"cirmid": "⫯",
		"cirscir": "⧂",
		"ClockwiseContourIntegral": "∲",
		"CloseCurlyDoubleQuote": "”",
		"CloseCurlyQuote": "’",
		"clubs": "♣",
		"clubsuit": "♣",
		"colon": ":",
		"Colon": "∷",
		"Colone": "⩴",
		"colone": "≔",
		"coloneq": "≔",
		"comma": ",",
		"commat": "@",
		"comp": "∁",
		"compfn": "∘",
		"complement": "∁",
		"complexes": "ℂ",
		"cong": "≅",
		"congdot": "⩭",
		"Congruent": "≡",
		"conint": "∮",
		"Conint": "∯",
		"ContourIntegral": "∮",
		"copf": "𝕔",
		"Copf": "ℂ",
		"coprod": "∐",
		"Coproduct": "∐",
		"copy": "©",
		"COPY": "©",
		"copysr": "℗",
		"CounterClockwiseContourIntegral": "∳",
		"crarr": "↵",
		"cross": "✗",
		"Cross": "⨯",
		"Cscr": "𝒞",
		"cscr": "𝒸",
		"csub": "⫏",
		"csube": "⫑",
		"csup": "⫐",
		"csupe": "⫒",
		"ctdot": "⋯",
		"cudarrl": "⤸",
		"cudarrr": "⤵",
		"cuepr": "⋞",
		"cuesc": "⋟",
		"cularr": "↶",
		"cularrp": "⤽",
		"cupbrcap": "⩈",
		"cupcap": "⩆",
		"CupCap": "≍",
		"cup": "∪",
		"Cup": "⋓",
		"cupcup": "⩊",
		"cupdot": "⊍",
		"cupor": "⩅",
		"cups": "∪︀",
		"curarr": "↷",
		"curarrm": "⤼",
		"curlyeqprec": "⋞",
		"curlyeqsucc": "⋟",
		"curlyvee": "⋎",
		"curlywedge": "⋏",
		"curren": "¤",
		"curvearrowleft": "↶",
		"curvearrowright": "↷",
		"cuvee": "⋎",
		"cuwed": "⋏",
		"cwconint": "∲",
		"cwint": "∱",
		"cylcty": "⌭",
		"dagger": "†",
		"Dagger": "‡",
		"daleth": "ℸ",
		"darr": "↓",
		"Darr": "↡",
		"dArr": "⇓",
		"dash": "‐",
		"Dashv": "⫤",
		"dashv": "⊣",
		"dbkarow": "⤏",
		"dblac": "˝",
		"Dcaron": "Ď",
		"dcaron": "ď",
		"Dcy": "Д",
		"dcy": "д",
		"ddagger": "‡",
		"ddarr": "⇊",
		"DD": "ⅅ",
		"dd": "ⅆ",
		"DDotrahd": "⤑",
		"ddotseq": "⩷",
		"deg": "°",
		"Del": "∇",
		"Delta": "Δ",
		"delta": "δ",
		"demptyv": "⦱",
		"dfisht": "⥿",
		"Dfr": "𝔇",
		"dfr": "𝔡",
		"dHar": "⥥",
		"dharl": "⇃",
		"dharr": "⇂",
		"DiacriticalAcute": "´",
		"DiacriticalDot": "˙",
		"DiacriticalDoubleAcute": "˝",
		"DiacriticalGrave": "`",
		"DiacriticalTilde": "˜",
		"diam": "⋄",
		"diamond": "⋄",
		"Diamond": "⋄",
		"diamondsuit": "♦",
		"diams": "♦",
		"die": "¨",
		"DifferentialD": "ⅆ",
		"digamma": "ϝ",
		"disin": "⋲",
		"div": "÷",
		"divide": "÷",
		"divideontimes": "⋇",
		"divonx": "⋇",
		"DJcy": "Ђ",
		"djcy": "ђ",
		"dlcorn": "⌞",
		"dlcrop": "⌍",
		"dollar": "$",
		"Dopf": "𝔻",
		"dopf": "𝕕",
		"Dot": "¨",
		"dot": "˙",
		"DotDot": "⃜",
		"doteq": "≐",
		"doteqdot": "≑",
		"DotEqual": "≐",
		"dotminus": "∸",
		"dotplus": "∔",
		"dotsquare": "⊡",
		"doublebarwedge": "⌆",
		"DoubleContourIntegral": "∯",
		"DoubleDot": "¨",
		"DoubleDownArrow": "⇓",
		"DoubleLeftArrow": "⇐",
		"DoubleLeftRightArrow": "⇔",
		"DoubleLeftTee": "⫤",
		"DoubleLongLeftArrow": "⟸",
		"DoubleLongLeftRightArrow": "⟺",
		"DoubleLongRightArrow": "⟹",
		"DoubleRightArrow": "⇒",
		"DoubleRightTee": "⊨",
		"DoubleUpArrow": "⇑",
		"DoubleUpDownArrow": "⇕",
		"DoubleVerticalBar": "∥",
		"DownArrowBar": "⤓",
		"downarrow": "↓",
		"DownArrow": "↓",
		"Downarrow": "⇓",
		"DownArrowUpArrow": "⇵",
		"DownBreve": "̑",
		"downdownarrows": "⇊",
		"downharpoonleft": "⇃",
		"downharpoonright": "⇂",
		"DownLeftRightVector": "⥐",
		"DownLeftTeeVector": "⥞",
		"DownLeftVectorBar": "⥖",
		"DownLeftVector": "↽",
		"DownRightTeeVector": "⥟",
		"DownRightVectorBar": "⥗",
		"DownRightVector": "⇁",
		"DownTeeArrow": "↧",
		"DownTee": "⊤",
		"drbkarow": "⤐",
		"drcorn": "⌟",
		"drcrop": "⌌",
		"Dscr": "𝒟",
		"dscr": "𝒹",
		"DScy": "Ѕ",
		"dscy": "ѕ",
		"dsol": "⧶",
		"Dstrok": "Đ",
		"dstrok": "đ",
		"dtdot": "⋱",
		"dtri": "▿",
		"dtrif": "▾",
		"duarr": "⇵",
		"duhar": "⥯",
		"dwangle": "⦦",
		"DZcy": "Џ",
		"dzcy": "џ",
		"dzigrarr": "⟿",
		"Eacute": "É",
		"eacute": "é",
		"easter": "⩮",
		"Ecaron": "Ě",
		"ecaron": "ě",
		"Ecirc": "Ê",
		"ecirc": "ê",
		"ecir": "≖",
		"ecolon": "≕",
		"Ecy": "Э",
		"ecy": "э",
		"eDDot": "⩷",
		"Edot": "Ė",
		"edot": "ė",
		"eDot": "≑",
		"ee": "ⅇ",
		"efDot": "≒",
		"Efr": "𝔈",
		"efr": "𝔢",
		"eg": "⪚",
		"Egrave": "È",
		"egrave": "è",
		"egs": "⪖",
		"egsdot": "⪘",
		"el": "⪙",
		"Element": "∈",
		"elinters": "⏧",
		"ell": "ℓ",
		"els": "⪕",
		"elsdot": "⪗",
		"Emacr": "Ē",
		"emacr": "ē",
		"empty": "∅",
		"emptyset": "∅",
		"EmptySmallSquare": "◻",
		"emptyv": "∅",
		"EmptyVerySmallSquare": "▫",
		"emsp13": " ",
		"emsp14": " ",
		"emsp": " ",
		"ENG": "Ŋ",
		"eng": "ŋ",
		"ensp": " ",
		"Eogon": "Ę",
		"eogon": "ę",
		"Eopf": "𝔼",
		"eopf": "𝕖",
		"epar": "⋕",
		"eparsl": "⧣",
		"eplus": "⩱",
		"epsi": "ε",
		"Epsilon": "Ε",
		"epsilon": "ε",
		"epsiv": "ϵ",
		"eqcirc": "≖",
		"eqcolon": "≕",
		"eqsim": "≂",
		"eqslantgtr": "⪖",
		"eqslantless": "⪕",
		"Equal": "⩵",
		"equals": "=",
		"EqualTilde": "≂",
		"equest": "≟",
		"Equilibrium": "⇌",
		"equiv": "≡",
		"equivDD": "⩸",
		"eqvparsl": "⧥",
		"erarr": "⥱",
		"erDot": "≓",
		"escr": "ℯ",
		"Escr": "ℰ",
		"esdot": "≐",
		"Esim": "⩳",
		"esim": "≂",
		"Eta": "Η",
		"eta": "η",
		"ETH": "Ð",
		"eth": "ð",
		"Euml": "Ë",
		"euml": "ë",
		"euro": "€",
		"excl": "!",
		"exist": "∃",
		"Exists": "∃",
		"expectation": "ℰ",
		"exponentiale": "ⅇ",
		"ExponentialE": "ⅇ",
		"fallingdotseq": "≒",
		"Fcy": "Ф",
		"fcy": "ф",
		"female": "♀",
		"ffilig": "ﬃ",
		"fflig": "ﬀ",
		"ffllig": "ﬄ",
		"Ffr": "𝔉",
		"ffr": "𝔣",
		"filig": "ﬁ",
		"FilledSmallSquare": "◼",
		"FilledVerySmallSquare": "▪",
		"fjlig": "fj",
		"flat": "♭",
		"fllig": "ﬂ",
		"fltns": "▱",
		"fnof": "ƒ",
		"Fopf": "𝔽",
		"fopf": "𝕗",
		"forall": "∀",
		"ForAll": "∀",
		"fork": "⋔",
		"forkv": "⫙",
		"Fouriertrf": "ℱ",
		"fpartint": "⨍",
		"frac12": "½",
		"frac13": "⅓",
		"frac14": "¼",
		"frac15": "⅕",
		"frac16": "⅙",
		"frac18": "⅛",
		"frac23": "⅔",
		"frac25": "⅖",
		"frac34": "¾",
		"frac35": "⅗",
		"frac38": "⅜",
		"frac45": "⅘",
		"frac56": "⅚",
		"frac58": "⅝",
		"frac78": "⅞",
		"frasl": "⁄",
		"frown": "⌢",
		"fscr": "𝒻",
		"Fscr": "ℱ",
		"gacute": "ǵ",
		"Gamma": "Γ",
		"gamma": "γ",
		"Gammad": "Ϝ",
		"gammad": "ϝ",
		"gap": "⪆",
		"Gbreve": "Ğ",
		"gbreve": "ğ",
		"Gcedil": "Ģ",
		"Gcirc": "Ĝ",
		"gcirc": "ĝ",
		"Gcy": "Г",
		"gcy": "г",
		"Gdot": "Ġ",
		"gdot": "ġ",
		"ge": "≥",
		"gE": "≧",
		"gEl": "⪌",
		"gel": "⋛",
		"geq": "≥",
		"geqq": "≧",
		"geqslant": "⩾",
		"gescc": "⪩",
		"ges": "⩾",
		"gesdot": "⪀",
		"gesdoto": "⪂",
		"gesdotol": "⪄",
		"gesl": "⋛︀",
		"gesles": "⪔",
		"Gfr": "𝔊",
		"gfr": "𝔤",
		"gg": "≫",
		"Gg": "⋙",
		"ggg": "⋙",
		"gimel": "ℷ",
		"GJcy": "Ѓ",
		"gjcy": "ѓ",
		"gla": "⪥",
		"gl": "≷",
		"glE": "⪒",
		"glj": "⪤",
		"gnap": "⪊",
		"gnapprox": "⪊",
		"gne": "⪈",
		"gnE": "≩",
		"gneq": "⪈",
		"gneqq": "≩",
		"gnsim": "⋧",
		"Gopf": "𝔾",
		"gopf": "𝕘",
		"grave": "`",
		"GreaterEqual": "≥",
		"GreaterEqualLess": "⋛",
		"GreaterFullEqual": "≧",
		"GreaterGreater": "⪢",
		"GreaterLess": "≷",
		"GreaterSlantEqual": "⩾",
		"GreaterTilde": "≳",
		"Gscr": "𝒢",
		"gscr": "ℊ",
		"gsim": "≳",
		"gsime": "⪎",
		"gsiml": "⪐",
		"gtcc": "⪧",
		"gtcir": "⩺",
		"gt": ">",
		"GT": ">",
		"Gt": "≫",
		"gtdot": "⋗",
		"gtlPar": "⦕",
		"gtquest": "⩼",
		"gtrapprox": "⪆",
		"gtrarr": "⥸",
		"gtrdot": "⋗",
		"gtreqless": "⋛",
		"gtreqqless": "⪌",
		"gtrless": "≷",
		"gtrsim": "≳",
		"gvertneqq": "≩︀",
		"gvnE": "≩︀",
		"Hacek": "ˇ",
		"hairsp": " ",
		"half": "½",
		"hamilt": "ℋ",
		"HARDcy": "Ъ",
		"hardcy": "ъ",
		"harrcir": "⥈",
		"harr": "↔",
		"hArr": "⇔",
		"harrw": "↭",
		"Hat": "^",
		"hbar": "ℏ",
		"Hcirc": "Ĥ",
		"hcirc": "ĥ",
		"hearts": "♥",
		"heartsuit": "♥",
		"hellip": "…",
		"hercon": "⊹",
		"hfr": "𝔥",
		"Hfr": "ℌ",
		"HilbertSpace": "ℋ",
		"hksearow": "⤥",
		"hkswarow": "⤦",
		"hoarr": "⇿",
		"homtht": "∻",
		"hookleftarrow": "↩",
		"hookrightarrow": "↪",
		"hopf": "𝕙",
		"Hopf": "ℍ",
		"horbar": "―",
		"HorizontalLine": "─",
		"hscr": "𝒽",
		"Hscr": "ℋ",
		"hslash": "ℏ",
		"Hstrok": "Ħ",
		"hstrok": "ħ",
		"HumpDownHump": "≎",
		"HumpEqual": "≏",
		"hybull": "⁃",
		"hyphen": "‐",
		"Iacute": "Í",
		"iacute": "í",
		"ic": "⁣",
		"Icirc": "Î",
		"icirc": "î",
		"Icy": "И",
		"icy": "и",
		"Idot": "İ",
		"IEcy": "Е",
		"iecy": "е",
		"iexcl": "¡",
		"iff": "⇔",
		"ifr": "𝔦",
		"Ifr": "ℑ",
		"Igrave": "Ì",
		"igrave": "ì",
		"ii": "ⅈ",
		"iiiint": "⨌",
		"iiint": "∭",
		"iinfin": "⧜",
		"iiota": "℩",
		"IJlig": "Ĳ",
		"ijlig": "ĳ",
		"Imacr": "Ī",
		"imacr": "ī",
		"image": "ℑ",
		"ImaginaryI": "ⅈ",
		"imagline": "ℐ",
		"imagpart": "ℑ",
		"imath": "ı",
		"Im": "ℑ",
		"imof": "⊷",
		"imped": "Ƶ",
		"Implies": "⇒",
		"incare": "℅",
		"in": "∈",
		"infin": "∞",
		"infintie": "⧝",
		"inodot": "ı",
		"intcal": "⊺",
		"int": "∫",
		"Int": "∬",
		"integers": "ℤ",
		"Integral": "∫",
		"intercal": "⊺",
		"Intersection": "⋂",
		"intlarhk": "⨗",
		"intprod": "⨼",
		"InvisibleComma": "⁣",
		"InvisibleTimes": "⁢",
		"IOcy": "Ё",
		"iocy": "ё",
		"Iogon": "Į",
		"iogon": "į",
		"Iopf": "𝕀",
		"iopf": "𝕚",
		"Iota": "Ι",
		"iota": "ι",
		"iprod": "⨼",
		"iquest": "¿",
		"iscr": "𝒾",
		"Iscr": "ℐ",
		"isin": "∈",
		"isindot": "⋵",
		"isinE": "⋹",
		"isins": "⋴",
		"isinsv": "⋳",
		"isinv": "∈",
		"it": "⁢",
		"Itilde": "Ĩ",
		"itilde": "ĩ",
		"Iukcy": "І",
		"iukcy": "і",
		"Iuml": "Ï",
		"iuml": "ï",
		"Jcirc": "Ĵ",
		"jcirc": "ĵ",
		"Jcy": "Й",
		"jcy": "й",
		"Jfr": "𝔍",
		"jfr": "𝔧",
		"jmath": "ȷ",
		"Jopf": "𝕁",
		"jopf": "𝕛",
		"Jscr": "𝒥",
		"jscr": "𝒿",
		"Jsercy": "Ј",
		"jsercy": "ј",
		"Jukcy": "Є",
		"jukcy": "є",
		"Kappa": "Κ",
		"kappa": "κ",
		"kappav": "ϰ",
		"Kcedil": "Ķ",
		"kcedil": "ķ",
		"Kcy": "К",
		"kcy": "к",
		"Kfr": "𝔎",
		"kfr": "𝔨",
		"kgreen": "ĸ",
		"KHcy": "Х",
		"khcy": "х",
		"KJcy": "Ќ",
		"kjcy": "ќ",
		"Kopf": "𝕂",
		"kopf": "𝕜",
		"Kscr": "𝒦",
		"kscr": "𝓀",
		"lAarr": "⇚",
		"Lacute": "Ĺ",
		"lacute": "ĺ",
		"laemptyv": "⦴",
		"lagran": "ℒ",
		"Lambda": "Λ",
		"lambda": "λ",
		"lang": "⟨",
		"Lang": "⟪",
		"langd": "⦑",
		"langle": "⟨",
		"lap": "⪅",
		"Laplacetrf": "ℒ",
		"laquo": "«",
		"larrb": "⇤",
		"larrbfs": "⤟",
		"larr": "←",
		"Larr": "↞",
		"lArr": "⇐",
		"larrfs": "⤝",
		"larrhk": "↩",
		"larrlp": "↫",
		"larrpl": "⤹",
		"larrsim": "⥳",
		"larrtl": "↢",
		"latail": "⤙",
		"lAtail": "⤛",
		"lat": "⪫",
		"late": "⪭",
		"lates": "⪭︀",
		"lbarr": "⤌",
		"lBarr": "⤎",
		"lbbrk": "❲",
		"lbrace": "{",
		"lbrack": "[",
		"lbrke": "⦋",
		"lbrksld": "⦏",
		"lbrkslu": "⦍",
		"Lcaron": "Ľ",
		"lcaron": "ľ",
		"Lcedil": "Ļ",
		"lcedil": "ļ",
		"lceil": "⌈",
		"lcub": "{",
		"Lcy": "Л",
		"lcy": "л",
		"ldca": "⤶",
		"ldquo": "“",
		"ldquor": "„",
		"ldrdhar": "⥧",
		"ldrushar": "⥋",
		"ldsh": "↲",
		"le": "≤",
		"lE": "≦",
		"LeftAngleBracket": "⟨",
		"LeftArrowBar": "⇤",
		"leftarrow": "←",
		"LeftArrow": "←",
		"Leftarrow": "⇐",
		"LeftArrowRightArrow": "⇆",
		"leftarrowtail": "↢",
		"LeftCeiling": "⌈",
		"LeftDoubleBracket": "⟦",
		"LeftDownTeeVector": "⥡",
		"LeftDownVectorBar": "⥙",
		"LeftDownVector": "⇃",
		"LeftFloor": "⌊",
		"leftharpoondown": "↽",
		"leftharpoonup": "↼",
		"leftleftarrows": "⇇",
		"leftrightarrow": "↔",
		"LeftRightArrow": "↔",
		"Leftrightarrow": "⇔",
		"leftrightarrows": "⇆",
		"leftrightharpoons": "⇋",
		"leftrightsquigarrow": "↭",
		"LeftRightVector": "⥎",
		"LeftTeeArrow": "↤",
		"LeftTee": "⊣",
		"LeftTeeVector": "⥚",
		"leftthreetimes": "⋋",
		"LeftTriangleBar": "⧏",
		"LeftTriangle": "⊲",
		"LeftTriangleEqual": "⊴",
		"LeftUpDownVector": "⥑",
		"LeftUpTeeVector": "⥠",
		"LeftUpVectorBar": "⥘",
		"LeftUpVector": "↿",
		"LeftVectorBar": "⥒",
		"LeftVector": "↼",
		"lEg": "⪋",
		"leg": "⋚",
		"leq": "≤",
		"leqq": "≦",
		"leqslant": "⩽",
		"lescc": "⪨",
		"les": "⩽",
		"lesdot": "⩿",
		"lesdoto": "⪁",
		"lesdotor": "⪃",
		"lesg": "⋚︀",
		"lesges": "⪓",
		"lessapprox": "⪅",
		"lessdot": "⋖",
		"lesseqgtr": "⋚",
		"lesseqqgtr": "⪋",
		"LessEqualGreater": "⋚",
		"LessFullEqual": "≦",
		"LessGreater": "≶",
		"lessgtr": "≶",
		"LessLess": "⪡",
		"lesssim": "≲",
		"LessSlantEqual": "⩽",
		"LessTilde": "≲",
		"lfisht": "⥼",
		"lfloor": "⌊",
		"Lfr": "𝔏",
		"lfr": "𝔩",
		"lg": "≶",
		"lgE": "⪑",
		"lHar": "⥢",
		"lhard": "↽",
		"lharu": "↼",
		"lharul": "⥪",
		"lhblk": "▄",
		"LJcy": "Љ",
		"ljcy": "љ",
		"llarr": "⇇",
		"ll": "≪",
		"Ll": "⋘",
		"llcorner": "⌞",
		"Lleftarrow": "⇚",
		"llhard": "⥫",
		"lltri": "◺",
		"Lmidot": "Ŀ",
		"lmidot": "ŀ",
		"lmoustache": "⎰",
		"lmoust": "⎰",
		"lnap": "⪉",
		"lnapprox": "⪉",
		"lne": "⪇",
		"lnE": "≨",
		"lneq": "⪇",
		"lneqq": "≨",
		"lnsim": "⋦",
		"loang": "⟬",
		"loarr": "⇽",
		"lobrk": "⟦",
		"longleftarrow": "⟵",
		"LongLeftArrow": "⟵",
		"Longleftarrow": "⟸",
		"longleftrightarrow": "⟷",
		"LongLeftRightArrow": "⟷",
		"Longleftrightarrow": "⟺",
		"longmapsto": "⟼",
		"longrightarrow": "⟶",
		"LongRightArrow": "⟶",
		"Longrightarrow": "⟹",
		"looparrowleft": "↫",
		"looparrowright": "↬",
		"lopar": "⦅",
		"Lopf": "𝕃",
		"lopf": "𝕝",
		"loplus": "⨭",
		"lotimes": "⨴",
		"lowast": "∗",
		"lowbar": "_",
		"LowerLeftArrow": "↙",
		"LowerRightArrow": "↘",
		"loz": "◊",
		"lozenge": "◊",
		"lozf": "⧫",
		"lpar": "(",
		"lparlt": "⦓",
		"lrarr": "⇆",
		"lrcorner": "⌟",
		"lrhar": "⇋",
		"lrhard": "⥭",
		"lrm": "‎",
		"lrtri": "⊿",
		"lsaquo": "‹",
		"lscr": "𝓁",
		"Lscr": "ℒ",
		"lsh": "↰",
		"Lsh": "↰",
		"lsim": "≲",
		"lsime": "⪍",
		"lsimg": "⪏",
		"lsqb": "[",
		"lsquo": "‘",
		"lsquor": "‚",
		"Lstrok": "Ł",
		"lstrok": "ł",
		"ltcc": "⪦",
		"ltcir": "⩹",
		"lt": "<",
		"LT": "<",
		"Lt": "≪",
		"ltdot": "⋖",
		"lthree": "⋋",
		"ltimes": "⋉",
		"ltlarr": "⥶",
		"ltquest": "⩻",
		"ltri": "◃",
		"ltrie": "⊴",
		"ltrif": "◂",
		"ltrPar": "⦖",
		"lurdshar": "⥊",
		"luruhar": "⥦",
		"lvertneqq": "≨︀",
		"lvnE": "≨︀",
		"macr": "¯",
		"male": "♂",
		"malt": "✠",
		"maltese": "✠",
		"Map": "⤅",
		"map": "↦",
		"mapsto": "↦",
		"mapstodown": "↧",
		"mapstoleft": "↤",
		"mapstoup": "↥",
		"marker": "▮",
		"mcomma": "⨩",
		"Mcy": "М",
		"mcy": "м",
		"mdash": "—",
		"mDDot": "∺",
		"measuredangle": "∡",
		"MediumSpace": " ",
		"Mellintrf": "ℳ",
		"Mfr": "𝔐",
		"mfr": "𝔪",
		"mho": "℧",
		"micro": "µ",
		"midast": "*",
		"midcir": "⫰",
		"mid": "∣",
		"middot": "·",
		"minusb": "⊟",
		"minus": "−",
		"minusd": "∸",
		"minusdu": "⨪",
		"MinusPlus": "∓",
		"mlcp": "⫛",
		"mldr": "…",
		"mnplus": "∓",
		"models": "⊧",
		"Mopf": "𝕄",
		"mopf": "𝕞",
		"mp": "∓",
		"mscr": "𝓂",
		"Mscr": "ℳ",
		"mstpos": "∾",
		"Mu": "Μ",
		"mu": "μ",
		"multimap": "⊸",
		"mumap": "⊸",
		"nabla": "∇",
		"Nacute": "Ń",
		"nacute": "ń",
		"nang": "∠⃒",
		"nap": "≉",
		"napE": "⩰̸",
		"napid": "≋̸",
		"napos": "ŉ",
		"napprox": "≉",
		"natural": "♮",
		"naturals": "ℕ",
		"natur": "♮",
		"nbsp": " ",
		"nbump": "≎̸",
		"nbumpe": "≏̸",
		"ncap": "⩃",
		"Ncaron": "Ň",
		"ncaron": "ň",
		"Ncedil": "Ņ",
		"ncedil": "ņ",
		"ncong": "≇",
		"ncongdot": "⩭̸",
		"ncup": "⩂",
		"Ncy": "Н",
		"ncy": "н",
		"ndash": "–",
		"nearhk": "⤤",
		"nearr": "↗",
		"neArr": "⇗",
		"nearrow": "↗",
		"ne": "≠",
		"nedot": "≐̸",
		"NegativeMediumSpace": "​",
		"NegativeThickSpace": "​",
		"NegativeThinSpace": "​",
		"NegativeVeryThinSpace": "​",
		"nequiv": "≢",
		"nesear": "⤨",
		"nesim": "≂̸",
		"NestedGreaterGreater": "≫",
		"NestedLessLess": "≪",
		"NewLine": "\n",
		"nexist": "∄",
		"nexists": "∄",
		"Nfr": "𝔑",
		"nfr": "𝔫",
		"ngE": "≧̸",
		"nge": "≱",
		"ngeq": "≱",
		"ngeqq": "≧̸",
		"ngeqslant": "⩾̸",
		"nges": "⩾̸",
		"nGg": "⋙̸",
		"ngsim": "≵",
		"nGt": "≫⃒",
		"ngt": "≯",
		"ngtr": "≯",
		"nGtv": "≫̸",
		"nharr": "↮",
		"nhArr": "⇎",
		"nhpar": "⫲",
		"ni": "∋",
		"nis": "⋼",
		"nisd": "⋺",
		"niv": "∋",
		"NJcy": "Њ",
		"njcy": "њ",
		"nlarr": "↚",
		"nlArr": "⇍",
		"nldr": "‥",
		"nlE": "≦̸",
		"nle": "≰",
		"nleftarrow": "↚",
		"nLeftarrow": "⇍",
		"nleftrightarrow": "↮",
		"nLeftrightarrow": "⇎",
		"nleq": "≰",
		"nleqq": "≦̸",
		"nleqslant": "⩽̸",
		"nles": "⩽̸",
		"nless": "≮",
		"nLl": "⋘̸",
		"nlsim": "≴",
		"nLt": "≪⃒",
		"nlt": "≮",
		"nltri": "⋪",
		"nltrie": "⋬",
		"nLtv": "≪̸",
		"nmid": "∤",
		"NoBreak": "⁠",
		"NonBreakingSpace": " ",
		"nopf": "𝕟",
		"Nopf": "ℕ",
		"Not": "⫬",
		"not": "¬",
		"NotCongruent": "≢",
		"NotCupCap": "≭",
		"NotDoubleVerticalBar": "∦",
		"NotElement": "∉",
		"NotEqual": "≠",
		"NotEqualTilde": "≂̸",
		"NotExists": "∄",
		"NotGreater": "≯",
		"NotGreaterEqual": "≱",
		"NotGreaterFullEqual": "≧̸",
		"NotGreaterGreater": "≫̸",
		"NotGreaterLess": "≹",
		"NotGreaterSlantEqual": "⩾̸",
		"NotGreaterTilde": "≵",
		"NotHumpDownHump": "≎̸",
		"NotHumpEqual": "≏̸",
		"notin": "∉",
		"notindot": "⋵̸",
		"notinE": "⋹̸",
		"notinva": "∉",
		"notinvb": "⋷",
		"notinvc": "⋶",
		"NotLeftTriangleBar": "⧏̸",
		"NotLeftTriangle": "⋪",
		"NotLeftTriangleEqual": "⋬",
		"NotLess": "≮",
		"NotLessEqual": "≰",
		"NotLessGreater": "≸",
		"NotLessLess": "≪̸",
		"NotLessSlantEqual": "⩽̸",
		"NotLessTilde": "≴",
		"NotNestedGreaterGreater": "⪢̸",
		"NotNestedLessLess": "⪡̸",
		"notni": "∌",
		"notniva": "∌",
		"notnivb": "⋾",
		"notnivc": "⋽",
		"NotPrecedes": "⊀",
		"NotPrecedesEqual": "⪯̸",
		"NotPrecedesSlantEqual": "⋠",
		"NotReverseElement": "∌",
		"NotRightTriangleBar": "⧐̸",
		"NotRightTriangle": "⋫",
		"NotRightTriangleEqual": "⋭",
		"NotSquareSubset": "⊏̸",
		"NotSquareSubsetEqual": "⋢",
		"NotSquareSuperset": "⊐̸",
		"NotSquareSupersetEqual": "⋣",
		"NotSubset": "⊂⃒",
		"NotSubsetEqual": "⊈",
		"NotSucceeds": "⊁",
		"NotSucceedsEqual": "⪰̸",
		"NotSucceedsSlantEqual": "⋡",
		"NotSucceedsTilde": "≿̸",
		"NotSuperset": "⊃⃒",
		"NotSupersetEqual": "⊉",
		"NotTilde": "≁",
		"NotTildeEqual": "≄",
		"NotTildeFullEqual": "≇",
		"NotTildeTilde": "≉",
		"NotVerticalBar": "∤",
		"nparallel": "∦",
		"npar": "∦",
		"nparsl": "⫽⃥",
		"npart": "∂̸",
		"npolint": "⨔",
		"npr": "⊀",
		"nprcue": "⋠",
		"nprec": "⊀",
		"npreceq": "⪯̸",
		"npre": "⪯̸",
		"nrarrc": "⤳̸",
		"nrarr": "↛",
		"nrArr": "⇏",
		"nrarrw": "↝̸",
		"nrightarrow": "↛",
		"nRightarrow": "⇏",
		"nrtri": "⋫",
		"nrtrie": "⋭",
		"nsc": "⊁",
		"nsccue": "⋡",
		"nsce": "⪰̸",
		"Nscr": "𝒩",
		"nscr": "𝓃",
		"nshortmid": "∤",
		"nshortparallel": "∦",
		"nsim": "≁",
		"nsime": "≄",
		"nsimeq": "≄",
		"nsmid": "∤",
		"nspar": "∦",
		"nsqsube": "⋢",
		"nsqsupe": "⋣",
		"nsub": "⊄",
		"nsubE": "⫅̸",
		"nsube": "⊈",
		"nsubset": "⊂⃒",
		"nsubseteq": "⊈",
		"nsubseteqq": "⫅̸",
		"nsucc": "⊁",
		"nsucceq": "⪰̸",
		"nsup": "⊅",
		"nsupE": "⫆̸",
		"nsupe": "⊉",
		"nsupset": "⊃⃒",
		"nsupseteq": "⊉",
		"nsupseteqq": "⫆̸",
		"ntgl": "≹",
		"Ntilde": "Ñ",
		"ntilde": "ñ",
		"ntlg": "≸",
		"ntriangleleft": "⋪",
		"ntrianglelefteq": "⋬",
		"ntriangleright": "⋫",
		"ntrianglerighteq": "⋭",
		"Nu": "Ν",
		"nu": "ν",
		"num": "#",
		"numero": "№",
		"numsp": " ",
		"nvap": "≍⃒",
		"nvdash": "⊬",
		"nvDash": "⊭",
		"nVdash": "⊮",
		"nVDash": "⊯",
		"nvge": "≥⃒",
		"nvgt": ">⃒",
		"nvHarr": "⤄",
		"nvinfin": "⧞",
		"nvlArr": "⤂",
		"nvle": "≤⃒",
		"nvlt": "<⃒",
		"nvltrie": "⊴⃒",
		"nvrArr": "⤃",
		"nvrtrie": "⊵⃒",
		"nvsim": "∼⃒",
		"nwarhk": "⤣",
		"nwarr": "↖",
		"nwArr": "⇖",
		"nwarrow": "↖",
		"nwnear": "⤧",
		"Oacute": "Ó",
		"oacute": "ó",
		"oast": "⊛",
		"Ocirc": "Ô",
		"ocirc": "ô",
		"ocir": "⊚",
		"Ocy": "О",
		"ocy": "о",
		"odash": "⊝",
		"Odblac": "Ő",
		"odblac": "ő",
		"odiv": "⨸",
		"odot": "⊙",
		"odsold": "⦼",
		"OElig": "Œ",
		"oelig": "œ",
		"ofcir": "⦿",
		"Ofr": "𝔒",
		"ofr": "𝔬",
		"ogon": "˛",
		"Ograve": "Ò",
		"ograve": "ò",
		"ogt": "⧁",
		"ohbar": "⦵",
		"ohm": "Ω",
		"oint": "∮",
		"olarr": "↺",
		"olcir": "⦾",
		"olcross": "⦻",
		"oline": "‾",
		"olt": "⧀",
		"Omacr": "Ō",
		"omacr": "ō",
		"Omega": "Ω",
		"omega": "ω",
		"Omicron": "Ο",
		"omicron": "ο",
		"omid": "⦶",
		"ominus": "⊖",
		"Oopf": "𝕆",
		"oopf": "𝕠",
		"opar": "⦷",
		"OpenCurlyDoubleQuote": "“",
		"OpenCurlyQuote": "‘",
		"operp": "⦹",
		"oplus": "⊕",
		"orarr": "↻",
		"Or": "⩔",
		"or": "∨",
		"ord": "⩝",
		"order": "ℴ",
		"orderof": "ℴ",
		"ordf": "ª",
		"ordm": "º",
		"origof": "⊶",
		"oror": "⩖",
		"orslope": "⩗",
		"orv": "⩛",
		"oS": "Ⓢ",
		"Oscr": "𝒪",
		"oscr": "ℴ",
		"Oslash": "Ø",
		"oslash": "ø",
		"osol": "⊘",
		"Otilde": "Õ",
		"otilde": "õ",
		"otimesas": "⨶",
		"Otimes": "⨷",
		"otimes": "⊗",
		"Ouml": "Ö",
		"ouml": "ö",
		"ovbar": "⌽",
		"OverBar": "‾",
		"OverBrace": "⏞",
		"OverBracket": "⎴",
		"OverParenthesis": "⏜",
		"para": "¶",
		"parallel": "∥",
		"par": "∥",
		"parsim": "⫳",
		"parsl": "⫽",
		"part": "∂",
		"PartialD": "∂",
		"Pcy": "П",
		"pcy": "п",
		"percnt": "%",
		"period": ".",
		"permil": "‰",
		"perp": "⊥",
		"pertenk": "‱",
		"Pfr": "𝔓",
		"pfr": "𝔭",
		"Phi": "Φ",
		"phi": "φ",
		"phiv": "ϕ",
		"phmmat": "ℳ",
		"phone": "☎",
		"Pi": "Π",
		"pi": "π",
		"pitchfork": "⋔",
		"piv": "ϖ",
		"planck": "ℏ",
		"planckh": "ℎ",
		"plankv": "ℏ",
		"plusacir": "⨣",
		"plusb": "⊞",
		"pluscir": "⨢",
		"plus": "+",
		"plusdo": "∔",
		"plusdu": "⨥",
		"pluse": "⩲",
		"PlusMinus": "±",
		"plusmn": "±",
		"plussim": "⨦",
		"plustwo": "⨧",
		"pm": "±",
		"Poincareplane": "ℌ",
		"pointint": "⨕",
		"popf": "𝕡",
		"Popf": "ℙ",
		"pound": "£",
		"prap": "⪷",
		"Pr": "⪻",
		"pr": "≺",
		"prcue": "≼",
		"precapprox": "⪷",
		"prec": "≺",
		"preccurlyeq": "≼",
		"Precedes": "≺",
		"PrecedesEqual": "⪯",
		"PrecedesSlantEqual": "≼",
		"PrecedesTilde": "≾",
		"preceq": "⪯",
		"precnapprox": "⪹",
		"precneqq": "⪵",
		"precnsim": "⋨",
		"pre": "⪯",
		"prE": "⪳",
		"precsim": "≾",
		"prime": "′",
		"Prime": "″",
		"primes": "ℙ",
		"prnap": "⪹",
		"prnE": "⪵",
		"prnsim": "⋨",
		"prod": "∏",
		"Product": "∏",
		"profalar": "⌮",
		"profline": "⌒",
		"profsurf": "⌓",
		"prop": "∝",
		"Proportional": "∝",
		"Proportion": "∷",
		"propto": "∝",
		"prsim": "≾",
		"prurel": "⊰",
		"Pscr": "𝒫",
		"pscr": "𝓅",
		"Psi": "Ψ",
		"psi": "ψ",
		"puncsp": " ",
		"Qfr": "𝔔",
		"qfr": "𝔮",
		"qint": "⨌",
		"qopf": "𝕢",
		"Qopf": "ℚ",
		"qprime": "⁗",
		"Qscr": "𝒬",
		"qscr": "𝓆",
		"quaternions": "ℍ",
		"quatint": "⨖",
		"quest": "?",
		"questeq": "≟",
		"quot": "\"",
		"QUOT": "\"",
		"rAarr": "⇛",
		"race": "∽̱",
		"Racute": "Ŕ",
		"racute": "ŕ",
		"radic": "√",
		"raemptyv": "⦳",
		"rang": "⟩",
		"Rang": "⟫",
		"rangd": "⦒",
		"range": "⦥",
		"rangle": "⟩",
		"raquo": "»",
		"rarrap": "⥵",
		"rarrb": "⇥",
		"rarrbfs": "⤠",
		"rarrc": "⤳",
		"rarr": "→",
		"Rarr": "↠",
		"rArr": "⇒",
		"rarrfs": "⤞",
		"rarrhk": "↪",
		"rarrlp": "↬",
		"rarrpl": "⥅",
		"rarrsim": "⥴",
		"Rarrtl": "⤖",
		"rarrtl": "↣",
		"rarrw": "↝",
		"ratail": "⤚",
		"rAtail": "⤜",
		"ratio": "∶",
		"rationals": "ℚ",
		"rbarr": "⤍",
		"rBarr": "⤏",
		"RBarr": "⤐",
		"rbbrk": "❳",
		"rbrace": "}",
		"rbrack": "]",
		"rbrke": "⦌",
		"rbrksld": "⦎",
		"rbrkslu": "⦐",
		"Rcaron": "Ř",
		"rcaron": "ř",
		"Rcedil": "Ŗ",
		"rcedil": "ŗ",
		"rceil": "⌉",
		"rcub": "}",
		"Rcy": "Р",
		"rcy": "р",
		"rdca": "⤷",
		"rdldhar": "⥩",
		"rdquo": "”",
		"rdquor": "”",
		"rdsh": "↳",
		"real": "ℜ",
		"realine": "ℛ",
		"realpart": "ℜ",
		"reals": "ℝ",
		"Re": "ℜ",
		"rect": "▭",
		"reg": "®",
		"REG": "®",
		"ReverseElement": "∋",
		"ReverseEquilibrium": "⇋",
		"ReverseUpEquilibrium": "⥯",
		"rfisht": "⥽",
		"rfloor": "⌋",
		"rfr": "𝔯",
		"Rfr": "ℜ",
		"rHar": "⥤",
		"rhard": "⇁",
		"rharu": "⇀",
		"rharul": "⥬",
		"Rho": "Ρ",
		"rho": "ρ",
		"rhov": "ϱ",
		"RightAngleBracket": "⟩",
		"RightArrowBar": "⇥",
		"rightarrow": "→",
		"RightArrow": "→",
		"Rightarrow": "⇒",
		"RightArrowLeftArrow": "⇄",
		"rightarrowtail": "↣",
		"RightCeiling": "⌉",
		"RightDoubleBracket": "⟧",
		"RightDownTeeVector": "⥝",
		"RightDownVectorBar": "⥕",
		"RightDownVector": "⇂",
		"RightFloor": "⌋",
		"rightharpoondown": "⇁",
		"rightharpoonup": "⇀",
		"rightleftarrows": "⇄",
		"rightleftharpoons": "⇌",
		"rightrightarrows": "⇉",
		"rightsquigarrow": "↝",
		"RightTeeArrow": "↦",
		"RightTee": "⊢",
		"RightTeeVector": "⥛",
		"rightthreetimes": "⋌",
		"RightTriangleBar": "⧐",
		"RightTriangle": "⊳",
		"RightTriangleEqual": "⊵",
		"RightUpDownVector": "⥏",
		"RightUpTeeVector": "⥜",
		"RightUpVectorBar": "⥔",
		"RightUpVector": "↾",
		"RightVectorBar": "⥓",
		"RightVector": "⇀",
		"ring": "˚",
		"risingdotseq": "≓",
		"rlarr": "⇄",
		"rlhar": "⇌",
		"rlm": "‏",
		"rmoustache": "⎱",
		"rmoust": "⎱",
		"rnmid": "⫮",
		"roang": "⟭",
		"roarr": "⇾",
		"robrk": "⟧",
		"ropar": "⦆",
		"ropf": "𝕣",
		"Ropf": "ℝ",
		"roplus": "⨮",
		"rotimes": "⨵",
		"RoundImplies": "⥰",
		"rpar": ")",
		"rpargt": "⦔",
		"rppolint": "⨒",
		"rrarr": "⇉",
		"Rrightarrow": "⇛",
		"rsaquo": "›",
		"rscr": "𝓇",
		"Rscr": "ℛ",
		"rsh": "↱",
		"Rsh": "↱",
		"rsqb": "]",
		"rsquo": "’",
		"rsquor": "’",
		"rthree": "⋌",
		"rtimes": "⋊",
		"rtri": "▹",
		"rtrie": "⊵",
		"rtrif": "▸",
		"rtriltri": "⧎",
		"RuleDelayed": "⧴",
		"ruluhar": "⥨",
		"rx": "℞",
		"Sacute": "Ś",
		"sacute": "ś",
		"sbquo": "‚",
		"scap": "⪸",
		"Scaron": "Š",
		"scaron": "š",
		"Sc": "⪼",
		"sc": "≻",
		"sccue": "≽",
		"sce": "⪰",
		"scE": "⪴",
		"Scedil": "Ş",
		"scedil": "ş",
		"Scirc": "Ŝ",
		"scirc": "ŝ",
		"scnap": "⪺",
		"scnE": "⪶",
		"scnsim": "⋩",
		"scpolint": "⨓",
		"scsim": "≿",
		"Scy": "С",
		"scy": "с",
		"sdotb": "⊡",
		"sdot": "⋅",
		"sdote": "⩦",
		"searhk": "⤥",
		"searr": "↘",
		"seArr": "⇘",
		"searrow": "↘",
		"sect": "§",
		"semi": ";",
		"seswar": "⤩",
		"setminus": "∖",
		"setmn": "∖",
		"sext": "✶",
		"Sfr": "𝔖",
		"sfr": "𝔰",
		"sfrown": "⌢",
		"sharp": "♯",
		"SHCHcy": "Щ",
		"shchcy": "щ",
		"SHcy": "Ш",
		"shcy": "ш",
		"ShortDownArrow": "↓",
		"ShortLeftArrow": "←",
		"shortmid": "∣",
		"shortparallel": "∥",
		"ShortRightArrow": "→",
		"ShortUpArrow": "↑",
		"shy": "­",
		"Sigma": "Σ",
		"sigma": "σ",
		"sigmaf": "ς",
		"sigmav": "ς",
		"sim": "∼",
		"simdot": "⩪",
		"sime": "≃",
		"simeq": "≃",
		"simg": "⪞",
		"simgE": "⪠",
		"siml": "⪝",
		"simlE": "⪟",
		"simne": "≆",
		"simplus": "⨤",
		"simrarr": "⥲",
		"slarr": "←",
		"SmallCircle": "∘",
		"smallsetminus": "∖",
		"smashp": "⨳",
		"smeparsl": "⧤",
		"smid": "∣",
		"smile": "⌣",
		"smt": "⪪",
		"smte": "⪬",
		"smtes": "⪬︀",
		"SOFTcy": "Ь",
		"softcy": "ь",
		"solbar": "⌿",
		"solb": "⧄",
		"sol": "/",
		"Sopf": "𝕊",
		"sopf": "𝕤",
		"spades": "♠",
		"spadesuit": "♠",
		"spar": "∥",
		"sqcap": "⊓",
		"sqcaps": "⊓︀",
		"sqcup": "⊔",
		"sqcups": "⊔︀",
		"Sqrt": "√",
		"sqsub": "⊏",
		"sqsube": "⊑",
		"sqsubset": "⊏",
		"sqsubseteq": "⊑",
		"sqsup": "⊐",
		"sqsupe": "⊒",
		"sqsupset": "⊐",
		"sqsupseteq": "⊒",
		"square": "□",
		"Square": "□",
		"SquareIntersection": "⊓",
		"SquareSubset": "⊏",
		"SquareSubsetEqual": "⊑",
		"SquareSuperset": "⊐",
		"SquareSupersetEqual": "⊒",
		"SquareUnion": "⊔",
		"squarf": "▪",
		"squ": "□",
		"squf": "▪",
		"srarr": "→",
		"Sscr": "𝒮",
		"sscr": "𝓈",
		"ssetmn": "∖",
		"ssmile": "⌣",
		"sstarf": "⋆",
		"Star": "⋆",
		"star": "☆",
		"starf": "★",
		"straightepsilon": "ϵ",
		"straightphi": "ϕ",
		"strns": "¯",
		"sub": "⊂",
		"Sub": "⋐",
		"subdot": "⪽",
		"subE": "⫅",
		"sube": "⊆",
		"subedot": "⫃",
		"submult": "⫁",
		"subnE": "⫋",
		"subne": "⊊",
		"subplus": "⪿",
		"subrarr": "⥹",
		"subset": "⊂",
		"Subset": "⋐",
		"subseteq": "⊆",
		"subseteqq": "⫅",
		"SubsetEqual": "⊆",
		"subsetneq": "⊊",
		"subsetneqq": "⫋",
		"subsim": "⫇",
		"subsub": "⫕",
		"subsup": "⫓",
		"succapprox": "⪸",
		"succ": "≻",
		"succcurlyeq": "≽",
		"Succeeds": "≻",
		"SucceedsEqual": "⪰",
		"SucceedsSlantEqual": "≽",
		"SucceedsTilde": "≿",
		"succeq": "⪰",
		"succnapprox": "⪺",
		"succneqq": "⪶",
		"succnsim": "⋩",
		"succsim": "≿",
		"SuchThat": "∋",
		"sum": "∑",
		"Sum": "∑",
		"sung": "♪",
		"sup1": "¹",
		"sup2": "²",
		"sup3": "³",
		"sup": "⊃",
		"Sup": "⋑",
		"supdot": "⪾",
		"supdsub": "⫘",
		"supE": "⫆",
		"supe": "⊇",
		"supedot": "⫄",
		"Superset": "⊃",
		"SupersetEqual": "⊇",
		"suphsol": "⟉",
		"suphsub": "⫗",
		"suplarr": "⥻",
		"supmult": "⫂",
		"supnE": "⫌",
		"supne": "⊋",
		"supplus": "⫀",
		"supset": "⊃",
		"Supset": "⋑",
		"supseteq": "⊇",
		"supseteqq": "⫆",
		"supsetneq": "⊋",
		"supsetneqq": "⫌",
		"supsim": "⫈",
		"supsub": "⫔",
		"supsup": "⫖",
		"swarhk": "⤦",
		"swarr": "↙",
		"swArr": "⇙",
		"swarrow": "↙",
		"swnwar": "⤪",
		"szlig": "ß",
		"Tab": "\t",
		"target": "⌖",
		"Tau": "Τ",
		"tau": "τ",
		"tbrk": "⎴",
		"Tcaron": "Ť",
		"tcaron": "ť",
		"Tcedil": "Ţ",
		"tcedil": "ţ",
		"Tcy": "Т",
		"tcy": "т",
		"tdot": "⃛",
		"telrec": "⌕",
		"Tfr": "𝔗",
		"tfr": "𝔱",
		"there4": "∴",
		"therefore": "∴",
		"Therefore": "∴",
		"Theta": "Θ",
		"theta": "θ",
		"thetasym": "ϑ",
		"thetav": "ϑ",
		"thickapprox": "≈",
		"thicksim": "∼",
		"ThickSpace": "  ",
		"ThinSpace": " ",
		"thinsp": " ",
		"thkap": "≈",
		"thksim": "∼",
		"THORN": "Þ",
		"thorn": "þ",
		"tilde": "˜",
		"Tilde": "∼",
		"TildeEqual": "≃",
		"TildeFullEqual": "≅",
		"TildeTilde": "≈",
		"timesbar": "⨱",
		"timesb": "⊠",
		"times": "×",
		"timesd": "⨰",
		"tint": "∭",
		"toea": "⤨",
		"topbot": "⌶",
		"topcir": "⫱",
		"top": "⊤",
		"Topf": "𝕋",
		"topf": "𝕥",
		"topfork": "⫚",
		"tosa": "⤩",
		"tprime": "‴",
		"trade": "™",
		"TRADE": "™",
		"triangle": "▵",
		"triangledown": "▿",
		"triangleleft": "◃",
		"trianglelefteq": "⊴",
		"triangleq": "≜",
		"triangleright": "▹",
		"trianglerighteq": "⊵",
		"tridot": "◬",
		"trie": "≜",
		"triminus": "⨺",
		"TripleDot": "⃛",
		"triplus": "⨹",
		"trisb": "⧍",
		"tritime": "⨻",
		"trpezium": "⏢",
		"Tscr": "𝒯",
		"tscr": "𝓉",
		"TScy": "Ц",
		"tscy": "ц",
		"TSHcy": "Ћ",
		"tshcy": "ћ",
		"Tstrok": "Ŧ",
		"tstrok": "ŧ",
		"twixt": "≬",
		"twoheadleftarrow": "↞",
		"twoheadrightarrow": "↠",
		"Uacute": "Ú",
		"uacute": "ú",
		"uarr": "↑",
		"Uarr": "↟",
		"uArr": "⇑",
		"Uarrocir": "⥉",
		"Ubrcy": "Ў",
		"ubrcy": "ў",
		"Ubreve": "Ŭ",
		"ubreve": "ŭ",
		"Ucirc": "Û",
		"ucirc": "û",
		"Ucy": "У",
		"ucy": "у",
		"udarr": "⇅",
		"Udblac": "Ű",
		"udblac": "ű",
		"udhar": "⥮",
		"ufisht": "⥾",
		"Ufr": "𝔘",
		"ufr": "𝔲",
		"Ugrave": "Ù",
		"ugrave": "ù",
		"uHar": "⥣",
		"uharl": "↿",
		"uharr": "↾",
		"uhblk": "▀",
		"ulcorn": "⌜",
		"ulcorner": "⌜",
		"ulcrop": "⌏",
		"ultri": "◸",
		"Umacr": "Ū",
		"umacr": "ū",
		"uml": "¨",
		"UnderBar": "_",
		"UnderBrace": "⏟",
		"UnderBracket": "⎵",
		"UnderParenthesis": "⏝",
		"Union": "⋃",
		"UnionPlus": "⊎",
		"Uogon": "Ų",
		"uogon": "ų",
		"Uopf": "𝕌",
		"uopf": "𝕦",
		"UpArrowBar": "⤒",
		"uparrow": "↑",
		"UpArrow": "↑",
		"Uparrow": "⇑",
		"UpArrowDownArrow": "⇅",
		"updownarrow": "↕",
		"UpDownArrow": "↕",
		"Updownarrow": "⇕",
		"UpEquilibrium": "⥮",
		"upharpoonleft": "↿",
		"upharpoonright": "↾",
		"uplus": "⊎",
		"UpperLeftArrow": "↖",
		"UpperRightArrow": "↗",
		"upsi": "υ",
		"Upsi": "ϒ",
		"upsih": "ϒ",
		"Upsilon": "Υ",
		"upsilon": "υ",
		"UpTeeArrow": "↥",
		"UpTee": "⊥",
		"upuparrows": "⇈",
		"urcorn": "⌝",
		"urcorner": "⌝",
		"urcrop": "⌎",
		"Uring": "Ů",
		"uring": "ů",
		"urtri": "◹",
		"Uscr": "𝒰",
		"uscr": "𝓊",
		"utdot": "⋰",
		"Utilde": "Ũ",
		"utilde": "ũ",
		"utri": "▵",
		"utrif": "▴",
		"uuarr": "⇈",
		"Uuml": "Ü",
		"uuml": "ü",
		"uwangle": "⦧",
		"vangrt": "⦜",
		"varepsilon": "ϵ",
		"varkappa": "ϰ",
		"varnothing": "∅",
		"varphi": "ϕ",
		"varpi": "ϖ",
		"varpropto": "∝",
		"varr": "↕",
		"vArr": "⇕",
		"varrho": "ϱ",
		"varsigma": "ς",
		"varsubsetneq": "⊊︀",
		"varsubsetneqq": "⫋︀",
		"varsupsetneq": "⊋︀",
		"varsupsetneqq": "⫌︀",
		"vartheta": "ϑ",
		"vartriangleleft": "⊲",
		"vartriangleright": "⊳",
		"vBar": "⫨",
		"Vbar": "⫫",
		"vBarv": "⫩",
		"Vcy": "В",
		"vcy": "в",
		"vdash": "⊢",
		"vDash": "⊨",
		"Vdash": "⊩",
		"VDash": "⊫",
		"Vdashl": "⫦",
		"veebar": "⊻",
		"vee": "∨",
		"Vee": "⋁",
		"veeeq": "≚",
		"vellip": "⋮",
		"verbar": "|",
		"Verbar": "‖",
		"vert": "|",
		"Vert": "‖",
		"VerticalBar": "∣",
		"VerticalLine": "|",
		"VerticalSeparator": "❘",
		"VerticalTilde": "≀",
		"VeryThinSpace": " ",
		"Vfr": "𝔙",
		"vfr": "𝔳",
		"vltri": "⊲",
		"vnsub": "⊂⃒",
		"vnsup": "⊃⃒",
		"Vopf": "𝕍",
		"vopf": "𝕧",
		"vprop": "∝",
		"vrtri": "⊳",
		"Vscr": "𝒱",
		"vscr": "𝓋",
		"vsubnE": "⫋︀",
		"vsubne": "⊊︀",
		"vsupnE": "⫌︀",
		"vsupne": "⊋︀",
		"Vvdash": "⊪",
		"vzigzag": "⦚",
		"Wcirc": "Ŵ",
		"wcirc": "ŵ",
		"wedbar": "⩟",
		"wedge": "∧",
		"Wedge": "⋀",
		"wedgeq": "≙",
		"weierp": "℘",
		"Wfr": "𝔚",
		"wfr": "𝔴",
		"Wopf": "𝕎",
		"wopf": "𝕨",
		"wp": "℘",
		"wr": "≀",
		"wreath": "≀",
		"Wscr": "𝒲",
		"wscr": "𝓌",
		"xcap": "⋂",
		"xcirc": "◯",
		"xcup": "⋃",
		"xdtri": "▽",
		"Xfr": "𝔛",
		"xfr": "𝔵",
		"xharr": "⟷",
		"xhArr": "⟺",
		"Xi": "Ξ",
		"xi": "ξ",
		"xlarr": "⟵",
		"xlArr": "⟸",
		"xmap": "⟼",
		"xnis": "⋻",
		"xodot": "⨀",
		"Xopf": "𝕏",
		"xopf": "𝕩",
		"xoplus": "⨁",
		"xotime": "⨂",
		"xrarr": "⟶",
		"xrArr": "⟹",
		"Xscr": "𝒳",
		"xscr": "𝓍",
		"xsqcup": "⨆",
		"xuplus": "⨄",
		"xutri": "△",
		"xvee": "⋁",
		"xwedge": "⋀",
		"Yacute": "Ý",
		"yacute": "ý",
		"YAcy": "Я",
		"yacy": "я",
		"Ycirc": "Ŷ",
		"ycirc": "ŷ",
		"Ycy": "Ы",
		"ycy": "ы",
		"yen": "¥",
		"Yfr": "𝔜",
		"yfr": "𝔶",
		"YIcy": "Ї",
		"yicy": "ї",
		"Yopf": "𝕐",
		"yopf": "𝕪",
		"Yscr": "𝒴",
		"yscr": "𝓎",
		"YUcy": "Ю",
		"yucy": "ю",
		"yuml": "ÿ",
		"Yuml": "Ÿ",
		"Zacute": "Ź",
		"zacute": "ź",
		"Zcaron": "Ž",
		"zcaron": "ž",
		"Zcy": "З",
		"zcy": "з",
		"Zdot": "Ż",
		"zdot": "ż",
		"zeetrf": "ℨ",
		"ZeroWidthSpace": "​",
		"Zeta": "Ζ",
		"zeta": "ζ",
		"zfr": "𝔷",
		"Zfr": "ℨ",
		"ZHcy": "Ж",
		"zhcy": "ж",
		"zigrarr": "⇝",
		"zopf": "𝕫",
		"Zopf": "ℤ",
		"Zscr": "𝒵",
		"zscr": "𝓏",
		"zwj": "‍",
		"zwnj": "‌"
	};

/***/ },
/* 671 */
/***/ function(module, exports) {

	module.exports = {
		"Aacute": "Á",
		"aacute": "á",
		"Acirc": "Â",
		"acirc": "â",
		"acute": "´",
		"AElig": "Æ",
		"aelig": "æ",
		"Agrave": "À",
		"agrave": "à",
		"amp": "&",
		"AMP": "&",
		"Aring": "Å",
		"aring": "å",
		"Atilde": "Ã",
		"atilde": "ã",
		"Auml": "Ä",
		"auml": "ä",
		"brvbar": "¦",
		"Ccedil": "Ç",
		"ccedil": "ç",
		"cedil": "¸",
		"cent": "¢",
		"copy": "©",
		"COPY": "©",
		"curren": "¤",
		"deg": "°",
		"divide": "÷",
		"Eacute": "É",
		"eacute": "é",
		"Ecirc": "Ê",
		"ecirc": "ê",
		"Egrave": "È",
		"egrave": "è",
		"ETH": "Ð",
		"eth": "ð",
		"Euml": "Ë",
		"euml": "ë",
		"frac12": "½",
		"frac14": "¼",
		"frac34": "¾",
		"gt": ">",
		"GT": ">",
		"Iacute": "Í",
		"iacute": "í",
		"Icirc": "Î",
		"icirc": "î",
		"iexcl": "¡",
		"Igrave": "Ì",
		"igrave": "ì",
		"iquest": "¿",
		"Iuml": "Ï",
		"iuml": "ï",
		"laquo": "«",
		"lt": "<",
		"LT": "<",
		"macr": "¯",
		"micro": "µ",
		"middot": "·",
		"nbsp": " ",
		"not": "¬",
		"Ntilde": "Ñ",
		"ntilde": "ñ",
		"Oacute": "Ó",
		"oacute": "ó",
		"Ocirc": "Ô",
		"ocirc": "ô",
		"Ograve": "Ò",
		"ograve": "ò",
		"ordf": "ª",
		"ordm": "º",
		"Oslash": "Ø",
		"oslash": "ø",
		"Otilde": "Õ",
		"otilde": "õ",
		"Ouml": "Ö",
		"ouml": "ö",
		"para": "¶",
		"plusmn": "±",
		"pound": "£",
		"quot": "\"",
		"QUOT": "\"",
		"raquo": "»",
		"reg": "®",
		"REG": "®",
		"sect": "§",
		"shy": "­",
		"sup1": "¹",
		"sup2": "²",
		"sup3": "³",
		"szlig": "ß",
		"THORN": "Þ",
		"thorn": "þ",
		"times": "×",
		"Uacute": "Ú",
		"uacute": "ú",
		"Ucirc": "Û",
		"ucirc": "û",
		"Ugrave": "Ù",
		"ugrave": "ù",
		"uml": "¨",
		"Uuml": "Ü",
		"uuml": "ü",
		"Yacute": "Ý",
		"yacute": "ý",
		"yen": "¥",
		"yuml": "ÿ"
	};

/***/ },
/* 672 */
/***/ function(module, exports) {

	module.exports = {
		"amp": "&",
		"apos": "'",
		"gt": ">",
		"lt": "<",
		"quot": "\""
	};

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(944);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	
	var debug = __webpack_require__(675)('jsonp');
	
	/**
	 * Module exports.
	 */
	
	module.exports = jsonp;
	
	/**
	 * Callback index.
	 */
	
	var count = 0;
	
	/**
	 * Noop function.
	 */
	
	function noop(){}
	
	/**
	 * JSONP handler
	 *
	 * Options:
	 *  - param {String} qs parameter (`callback`)
	 *  - prefix {String} qs parameter (`__jp`)
	 *  - name {String} qs parameter (`prefix` + incr)
	 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
	 *
	 * @param {String} url
	 * @param {Object|Function} optional options / callback
	 * @param {Function} optional callback
	 */
	
	function jsonp(url, opts, fn){
	  if ('function' == typeof opts) {
	    fn = opts;
	    opts = {};
	  }
	  if (!opts) opts = {};
	
	  var prefix = opts.prefix || '__jp';
	
	  // use the callback name that was passed if one was provided.
	  // otherwise generate a unique name by incrementing our counter.
	  var id = opts.name || (prefix + (count++));
	
	  var param = opts.param || 'callback';
	  var timeout = null != opts.timeout ? opts.timeout : 60000;
	  var enc = encodeURIComponent;
	  var target = document.getElementsByTagName('script')[0] || document.head;
	  var script;
	  var timer;
	
	
	  if (timeout) {
	    timer = setTimeout(function(){
	      cleanup();
	      if (fn) fn(new Error('Timeout'));
	    }, timeout);
	  }
	
	  function cleanup(){
	    if (script.parentNode) script.parentNode.removeChild(script);
	    window[id] = noop;
	    if (timer) clearTimeout(timer);
	  }
	
	  function cancel(){
	    if (window[id]) {
	      cleanup();
	    }
	  }
	
	  window[id] = function(data){
	    debug('jsonp got', data);
	    cleanup();
	    if (fn) fn(null, data);
	  };
	
	  // add qs component
	  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
	  url = url.replace('?&', '?');
	
	  debug('jsonp req "%s"', url);
	
	  // create script
	  script = document.createElement('script');
	  script.src = url;
	  target.parentNode.insertBefore(script, target);
	
	  return cancel;
	}


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(676);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	
	/**
	 * Use chrome.storage.local if we are in an app
	 */
	
	var storage;
	
	if (typeof chrome !== 'undefined' && typeof chrome.storage !== 'undefined')
	  storage = chrome.storage.local;
	else
	  storage = localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  return ('WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  return JSON.stringify(v);
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      storage.removeItem('debug');
	    } else {
	      storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = storage.debug;
	  } catch(e) {}
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}


/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(677);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = Array.prototype.slice.call(arguments);
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    if ('function' === typeof exports.formatArgs) {
	      args = exports.formatArgs.apply(self, args);
	    }
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ },
/* 677 */
/***/ function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options){
	  options = options || {};
	  if ('string' == typeof val) return parse(val);
	  return options.long
	    ? long(val)
	    : short(val);
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
	  if (!match) return;
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function short(ms) {
	  if (ms >= d) return Math.round(ms / d) + 'd';
	  if (ms >= h) return Math.round(ms / h) + 'h';
	  if (ms >= m) return Math.round(ms / m) + 'm';
	  if (ms >= s) return Math.round(ms / s) + 's';
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function long(ms) {
	  return plural(ms, d, 'day')
	    || plural(ms, h, 'hour')
	    || plural(ms, m, 'minute')
	    || plural(ms, s, 'second')
	    || ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) return;
	  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ },
/* 678 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 679 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = memoize;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 680 */
/***/ function(module, exports) {

	"use strict";
	var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
	    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
	        if (ar || !(i in from)) {
	            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
	            ar[i] = from[i];
	        }
	    }
	    return to.concat(ar || Array.prototype.slice.call(from));
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.allEvents = exports.changeEvents = exports.otherEvents = exports.transitionEvents = exports.animationEvents = exports.wheelEvents = exports.uiEvents = exports.pointerEvents = exports.touchEvents = exports.selectionEvents = exports.dragEvents = exports.mouseEvents = exports.mediaEvents = exports.keyboardEvents = exports.imageEvents = exports.formEvents = exports.focusEvents = exports.compositionEvents = exports.clipboardEvents = void 0;
	// As defined on the list of supported events: https://reactjs.org/docs/events.html
	exports.clipboardEvents = ['onCopy', 'onCut', 'onPaste'];
	exports.compositionEvents = [
	    'onCompositionEnd',
	    'onCompositionStart',
	    'onCompositionUpdate',
	];
	exports.focusEvents = ['onFocus', 'onBlur'];
	exports.formEvents = ['onInput', 'onInvalid', 'onReset', 'onSubmit'];
	exports.imageEvents = ['onLoad', 'onError'];
	exports.keyboardEvents = ['onKeyDown', 'onKeyPress', 'onKeyUp'];
	exports.mediaEvents = [
	    'onAbort',
	    'onCanPlay',
	    'onCanPlayThrough',
	    'onDurationChange',
	    'onEmptied',
	    'onEncrypted',
	    'onEnded',
	    'onError',
	    'onLoadedData',
	    'onLoadedMetadata',
	    'onLoadStart',
	    'onPause',
	    'onPlay',
	    'onPlaying',
	    'onProgress',
	    'onRateChange',
	    'onSeeked',
	    'onSeeking',
	    'onStalled',
	    'onSuspend',
	    'onTimeUpdate',
	    'onVolumeChange',
	    'onWaiting',
	];
	exports.mouseEvents = [
	    'onClick',
	    'onContextMenu',
	    'onDoubleClick',
	    'onMouseDown',
	    'onMouseEnter',
	    'onMouseLeave',
	    'onMouseMove',
	    'onMouseOut',
	    'onMouseOver',
	    'onMouseUp',
	];
	exports.dragEvents = [
	    'onDrag',
	    'onDragEnd',
	    'onDragEnter',
	    'onDragExit',
	    'onDragLeave',
	    'onDragOver',
	    'onDragStart',
	    'onDrop',
	];
	exports.selectionEvents = ['onSelect'];
	exports.touchEvents = ['onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart'];
	exports.pointerEvents = [
	    'onPointerDown',
	    'onPointerMove',
	    'onPointerUp',
	    'onPointerCancel',
	    'onGotPointerCapture',
	    'onLostPointerCapture',
	    'onPointerEnter',
	    'onPointerLeave',
	    'onPointerOver',
	    'onPointerOut',
	];
	exports.uiEvents = ['onScroll'];
	exports.wheelEvents = ['onWheel'];
	exports.animationEvents = [
	    'onAnimationStart',
	    'onAnimationEnd',
	    'onAnimationIteration',
	];
	exports.transitionEvents = ['onTransitionEnd'];
	exports.otherEvents = ['onToggle'];
	exports.changeEvents = ['onChange'];
	exports.allEvents = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], exports.clipboardEvents, true), exports.compositionEvents, true), exports.focusEvents, true), exports.formEvents, true), exports.imageEvents, true), exports.keyboardEvents, true), exports.mediaEvents, true), exports.mouseEvents, true), exports.dragEvents, true), exports.selectionEvents, true), exports.touchEvents, true), exports.pointerEvents, true), exports.uiEvents, true), exports.wheelEvents, true), exports.animationEvents, true), exports.transitionEvents, true), exports.changeEvents, true), exports.otherEvents, true);
	/**
	 * Returns an object with on-event callback props curried with provided args.
	 * @param {Object} props Props passed to a component.
	 * @param {Function=} getArgs A function that returns argument(s) on-event callbacks
	 *   shall be curried with.
	 */
	function makeEventProps(props, getArgs) {
	    var eventProps = {};
	    exports.allEvents.forEach(function (eventName) {
	        var eventHandler = props[eventName];
	        if (!eventHandler) {
	            return;
	        }
	        if (getArgs) {
	            eventProps[eventName] = (function (event) {
	                return eventHandler(event, getArgs(eventName));
	            });
	        }
	        else {
	            eventProps[eventName] = eventHandler;
	        }
	    });
	    return eventProps;
	}
	exports.default = makeEventProps;


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 250,
		"./af.js": 250,
		"./ar": 257,
		"./ar-dz": 251,
		"./ar-dz.js": 251,
		"./ar-kw": 252,
		"./ar-kw.js": 252,
		"./ar-ly": 253,
		"./ar-ly.js": 253,
		"./ar-ma": 254,
		"./ar-ma.js": 254,
		"./ar-sa": 255,
		"./ar-sa.js": 255,
		"./ar-tn": 256,
		"./ar-tn.js": 256,
		"./ar.js": 257,
		"./az": 258,
		"./az.js": 258,
		"./be": 259,
		"./be.js": 259,
		"./bg": 260,
		"./bg.js": 260,
		"./bm": 261,
		"./bm.js": 261,
		"./bn": 263,
		"./bn-bd": 262,
		"./bn-bd.js": 262,
		"./bn.js": 263,
		"./bo": 264,
		"./bo.js": 264,
		"./br": 265,
		"./br.js": 265,
		"./bs": 266,
		"./bs.js": 266,
		"./ca": 267,
		"./ca.js": 267,
		"./cs": 268,
		"./cs.js": 268,
		"./cv": 269,
		"./cv.js": 269,
		"./cy": 270,
		"./cy.js": 270,
		"./da": 271,
		"./da.js": 271,
		"./de": 274,
		"./de-at": 272,
		"./de-at.js": 272,
		"./de-ch": 273,
		"./de-ch.js": 273,
		"./de.js": 274,
		"./dv": 275,
		"./dv.js": 275,
		"./el": 276,
		"./el.js": 276,
		"./en-au": 277,
		"./en-au.js": 277,
		"./en-ca": 278,
		"./en-ca.js": 278,
		"./en-gb": 279,
		"./en-gb.js": 279,
		"./en-ie": 280,
		"./en-ie.js": 280,
		"./en-il": 281,
		"./en-il.js": 281,
		"./en-in": 282,
		"./en-in.js": 282,
		"./en-nz": 283,
		"./en-nz.js": 283,
		"./en-sg": 284,
		"./en-sg.js": 284,
		"./eo": 285,
		"./eo.js": 285,
		"./es": 289,
		"./es-do": 286,
		"./es-do.js": 286,
		"./es-mx": 287,
		"./es-mx.js": 287,
		"./es-us": 288,
		"./es-us.js": 288,
		"./es.js": 289,
		"./et": 290,
		"./et.js": 290,
		"./eu": 291,
		"./eu.js": 291,
		"./fa": 292,
		"./fa.js": 292,
		"./fi": 293,
		"./fi.js": 293,
		"./fil": 294,
		"./fil.js": 294,
		"./fo": 295,
		"./fo.js": 295,
		"./fr": 298,
		"./fr-ca": 296,
		"./fr-ca.js": 296,
		"./fr-ch": 297,
		"./fr-ch.js": 297,
		"./fr.js": 298,
		"./fy": 299,
		"./fy.js": 299,
		"./ga": 300,
		"./ga.js": 300,
		"./gd": 301,
		"./gd.js": 301,
		"./gl": 302,
		"./gl.js": 302,
		"./gom-deva": 303,
		"./gom-deva.js": 303,
		"./gom-latn": 304,
		"./gom-latn.js": 304,
		"./gu": 305,
		"./gu.js": 305,
		"./he": 306,
		"./he.js": 306,
		"./hi": 307,
		"./hi.js": 307,
		"./hr": 308,
		"./hr.js": 308,
		"./hu": 309,
		"./hu.js": 309,
		"./hy-am": 310,
		"./hy-am.js": 310,
		"./id": 311,
		"./id.js": 311,
		"./is": 312,
		"./is.js": 312,
		"./it": 314,
		"./it-ch": 313,
		"./it-ch.js": 313,
		"./it.js": 314,
		"./ja": 315,
		"./ja.js": 315,
		"./jv": 316,
		"./jv.js": 316,
		"./ka": 317,
		"./ka.js": 317,
		"./kk": 318,
		"./kk.js": 318,
		"./km": 319,
		"./km.js": 319,
		"./kn": 320,
		"./kn.js": 320,
		"./ko": 321,
		"./ko.js": 321,
		"./ku": 322,
		"./ku.js": 322,
		"./ky": 323,
		"./ky.js": 323,
		"./lb": 324,
		"./lb.js": 324,
		"./lo": 325,
		"./lo.js": 325,
		"./lt": 326,
		"./lt.js": 326,
		"./lv": 327,
		"./lv.js": 327,
		"./me": 328,
		"./me.js": 328,
		"./mi": 329,
		"./mi.js": 329,
		"./mk": 330,
		"./mk.js": 330,
		"./ml": 331,
		"./ml.js": 331,
		"./mn": 332,
		"./mn.js": 332,
		"./mr": 333,
		"./mr.js": 333,
		"./ms": 335,
		"./ms-my": 334,
		"./ms-my.js": 334,
		"./ms.js": 335,
		"./mt": 336,
		"./mt.js": 336,
		"./my": 337,
		"./my.js": 337,
		"./nb": 338,
		"./nb.js": 338,
		"./ne": 339,
		"./ne.js": 339,
		"./nl": 341,
		"./nl-be": 340,
		"./nl-be.js": 340,
		"./nl.js": 341,
		"./nn": 342,
		"./nn.js": 342,
		"./oc-lnc": 343,
		"./oc-lnc.js": 343,
		"./pa-in": 344,
		"./pa-in.js": 344,
		"./pl": 345,
		"./pl.js": 345,
		"./pt": 347,
		"./pt-br": 346,
		"./pt-br.js": 346,
		"./pt.js": 347,
		"./ro": 348,
		"./ro.js": 348,
		"./ru": 349,
		"./ru.js": 349,
		"./sd": 350,
		"./sd.js": 350,
		"./se": 351,
		"./se.js": 351,
		"./si": 352,
		"./si.js": 352,
		"./sk": 353,
		"./sk.js": 353,
		"./sl": 354,
		"./sl.js": 354,
		"./sq": 355,
		"./sq.js": 355,
		"./sr": 357,
		"./sr-cyrl": 356,
		"./sr-cyrl.js": 356,
		"./sr.js": 357,
		"./ss": 358,
		"./ss.js": 358,
		"./sv": 359,
		"./sv.js": 359,
		"./sw": 360,
		"./sw.js": 360,
		"./ta": 361,
		"./ta.js": 361,
		"./te": 362,
		"./te.js": 362,
		"./tet": 363,
		"./tet.js": 363,
		"./tg": 364,
		"./tg.js": 364,
		"./th": 365,
		"./th.js": 365,
		"./tk": 366,
		"./tk.js": 366,
		"./tl-ph": 367,
		"./tl-ph.js": 367,
		"./tlh": 368,
		"./tlh.js": 368,
		"./tr": 369,
		"./tr.js": 369,
		"./tzl": 370,
		"./tzl.js": 370,
		"./tzm": 372,
		"./tzm-latn": 371,
		"./tzm-latn.js": 371,
		"./tzm.js": 372,
		"./ug-cn": 373,
		"./ug-cn.js": 373,
		"./uk": 374,
		"./uk.js": 374,
		"./ur": 375,
		"./ur.js": 375,
		"./uz": 377,
		"./uz-latn": 376,
		"./uz-latn.js": 376,
		"./uz.js": 377,
		"./vi": 378,
		"./vi.js": 378,
		"./x-pseudo": 379,
		"./x-pseudo.js": 379,
		"./yo": 380,
		"./yo.js": 380,
		"./zh-cn": 381,
		"./zh-cn.js": 381,
		"./zh-hk": 382,
		"./zh-hk.js": 382,
		"./zh-mo": 383,
		"./zh-mo.js": 383,
		"./zh-tw": 384,
		"./zh-tw.js": 384
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 681;


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(386); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// modified from https://github.com/es-shims/es6-shim
	var objectKeys = __webpack_require__(385);
	var hasSymbols = __webpack_require__(239)();
	var callBound = __webpack_require__(205);
	var toObject = Object;
	var $push = callBound('Array.prototype.push');
	var $propIsEnumerable = callBound('Object.prototype.propertyIsEnumerable');
	var originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null;
	
	// eslint-disable-next-line no-unused-vars
	module.exports = function assign(target, source1) {
		if (target == null) { throw new TypeError('target must be an object'); }
		var to = toObject(target); // step 1
		if (arguments.length === 1) {
			return to; // step 2
		}
		for (var s = 1; s < arguments.length; ++s) {
			var from = toObject(arguments[s]); // step 3.a.i
	
			// step 3.a.ii:
			var keys = objectKeys(from);
			var getSymbols = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);
			if (getSymbols) {
				var syms = getSymbols(from);
				for (var j = 0; j < syms.length; ++j) {
					var key = syms[j];
					if ($propIsEnumerable(from, key)) {
						$push(keys, key);
					}
				}
			}
	
			// step 3.a.iii:
			for (var i = 0; i < keys.length; ++i) {
				var nextKey = keys[i];
				if ($propIsEnumerable(from, nextKey)) { // step 3.a.iii.2
					var propValue = from[nextKey]; // step 3.a.iii.2.a
					to[nextKey] = propValue; // step 3.a.iii.2.b
				}
			}
		}
	
		return to; // step 4
	};


/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(683);
	
	var lacksProperEnumerationOrder = function () {
		if (!Object.assign) {
			return false;
		}
		/*
		 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
		 * note: this does not detect the bug unless there's 20 characters
		 */
		var str = 'abcdefghijklmnopqrst';
		var letters = str.split('');
		var map = {};
		for (var i = 0; i < letters.length; ++i) {
			map[letters[i]] = letters[i];
		}
		var obj = Object.assign({}, map);
		var actual = '';
		for (var k in obj) {
			actual += k;
		}
		return str !== actual;
	};
	
	var assignHasPendingExceptions = function () {
		if (!Object.assign || !Object.preventExtensions) {
			return false;
		}
		/*
		 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
		 * which is 72% slower than our shim, and Firefox 40's native implementation.
		 */
		var thrower = Object.preventExtensions({ 1: 2 });
		try {
			Object.assign(thrower, 'xy');
		} catch (e) {
			return thrower[1] === 'y';
		}
		return false;
	};
	
	module.exports = function getPolyfill() {
		if (!Object.assign) {
			return implementation;
		}
		if (lacksProperEnumerationOrder()) {
			return implementation;
		}
		if (assignHasPendingExceptions()) {
			return implementation;
		}
		return Object.assign;
	};


/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(109);
	var callBind = __webpack_require__(206);
	
	var implementation = __webpack_require__(387);
	var getPolyfill = __webpack_require__(388);
	var shim = __webpack_require__(686);
	
	var polyfill = callBind(getPolyfill(), Object);
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPolyfill = __webpack_require__(388);
	var define = __webpack_require__(109);
	
	module.exports = function shimValues() {
		var polyfill = getPolyfill();
		define(Object, { values: polyfill }, {
			values: function testValues() {
				return Object.values !== polyfill;
			}
		});
		return polyfill;
	};


/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75)))

/***/ },
/* 688 */
/***/ function(module, exports) {

	var div = null
	var prefixes = [ 'Webkit', 'Moz', 'O', 'ms' ]
	
	module.exports = function prefixStyle (prop) {
	  // re-use a dummy div
	  if (!div) {
	    div = document.createElement('div')
	  }
	
	  var style = div.style
	
	  // prop exists without prefix
	  if (prop in style) {
	    return prop
	  }
	
	  // borderRadius -> BorderRadius
	  var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1)
	
	  // find the vendor-prefixed prop
	  for (var i = prefixes.length; i >= 0; i--) {
	    var name = prefixes[i] + titleCase
	    // e.g. WebkitBorderRadius or webkitBorderRadius
	    if (name in style) {
	      return name
	    }
	  }
	
	  return false
	}


/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(690);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 690 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(391);
	
	var has = Object.prototype.hasOwnProperty;
	
	var defaults = {
	    allowDots: false,
	    allowPrototypes: false,
	    arrayLimit: 20,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    parameterLimit: 1000,
	    plainObjects: false,
	    strictNullHandling: false
	};
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = {};
	    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
	    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
	    var parts = cleanStr.split(options.delimiter, limit);
	
	    for (var i = 0; i < parts.length; ++i) {
	        var part = parts[i];
	
	        var bracketEqualsPos = part.indexOf(']=');
	        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
	
	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part, defaults.decoder);
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos), defaults.decoder);
	            val = options.decoder(part.slice(pos + 1), defaults.decoder);
	        }
	        if (has.call(obj, key)) {
	            obj[key] = [].concat(obj[key]).concat(val);
	        } else {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function (chain, val, options) {
	    var leaf = val;
	
	    for (var i = chain.length - 1; i >= 0; --i) {
	        var obj;
	        var root = chain[i];
	
	        if (root === '[]' && options.parseArrays) {
	            obj = [].concat(leaf);
	        } else {
	            obj = options.plainObjects ? Object.create(null) : {};
	            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	            var index = parseInt(cleanRoot, 10);
	            if (!options.parseArrays && cleanRoot === '') {
	                obj = { 0: leaf };
	            } else if (
	                !isNaN(index)
	                && root !== cleanRoot
	                && String(index) === cleanRoot
	                && index >= 0
	                && (options.parseArrays && index <= options.arrayLimit)
	            ) {
	                obj = [];
	                obj[index] = leaf;
	            } else if (cleanRoot !== '__proto__') {
	                obj[cleanRoot] = leaf;
	            }
	        }
	
	        leaf = obj;
	    }
	
	    return leaf;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;
	
	    // Get the parent
	
	    var segment = brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys
	        // that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(parent);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options);
	};
	
	module.exports = function (str, opts) {
	    var options = opts ? utils.assign({}, opts) : {};
	
	    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
	    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
	    options.parseArrays = options.parseArrays !== false;
	    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
	    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
	    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
	    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
	    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options);
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    return utils.compact(obj);
	};


/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(391);
	var formats = __webpack_require__(390);
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) {
	        return prefix + '[]';
	    },
	    indices: function indices(prefix, key) {
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) {
	        return prefix;
	    }
	};
	
	var isArray = Array.isArray;
	var push = Array.prototype.push;
	var pushToArray = function (arr, valueOrArray) {
	    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaults = {
	    delimiter: '&',
	    encode: true,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    serializeDate: function serializeDate(date) {
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var stringify = function stringify(
	    object,
	    prefix,
	    generateArrayPrefix,
	    strictNullHandling,
	    skipNulls,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    formatter,
	    encodeValuesOnly
	) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    }
	
	    if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
	            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        if (isArray(obj)) {
	            pushToArray(values, stringify(
	                obj[key],
	                generateArrayPrefix(prefix, key),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        } else {
	            pushToArray(values, stringify(
	                obj[key],
	                prefix + (allowDots ? '.' + key : '[' + key + ']'),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        }
	    }
	
	    return values;
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = opts ? utils.assign({}, opts) : {};
	
	    if (options.encoder !== null && typeof options.encoder !== 'undefined' && typeof options.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
	    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
	    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
	    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
	    var sort = typeof options.sort === 'function' ? options.sort : null;
	    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
	    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
	    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
	    if (typeof options.format === 'undefined') {
	        options.format = formats['default'];
	    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
	        throw new TypeError('Unknown format option provided.');
	    }
	    var formatter = formats.formatters[options.format];
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    } else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (sort) {
	        objKeys.sort(sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	        pushToArray(keys, stringify(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            strictNullHandling,
	            skipNulls,
	            encode ? encoder : null,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            formatter,
	            encodeValuesOnly
	        ));
	    }
	
	    var joined = keys.join(delimiter);
	    var prefix = options.addQueryPrefix === true ? '?' : '';
	
	    return joined.length > 0 ? prefix + joined : '';
	};


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(943);
	var objectAssign = __webpack_require__(18);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(157);
	
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the specified
	 * property with the given value. Note that this copies and flattens prototype
	 * properties onto the new object as well. All non-primitive properties are
	 * copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig String -> a -> {k: v} -> {k: v}
	 * @param {String} prop The property name to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except for the changed property.
	 * @see R.dissoc
	 * @example
	 *
	 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry3(function assoc(prop, val, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  result[prop] = val;
	  return result;
	});


/***/ },
/* 695 */
[1037, 393, 113],
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	var pipe = __webpack_require__(704);
	var reverse = __webpack_require__(705);
	
	
	/**
	 * Performs right-to-left function composition. The rightmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * **Note:** The result of compose is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} ...functions The functions to compose
	 * @return {Function}
	 * @see R.pipe
	 * @example
	 *
	 *      var classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
	 *      var yellGreeting = R.compose(R.toUpper, classyGreeting);
	 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
	 *
	 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
	 *
	 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
	 */
	module.exports = function compose() {
	  if (arguments.length === 0) {
	    throw new Error('compose requires at least one argument');
	  }
	  return pipe.apply(this, reverse(arguments));
	};


/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(113);
	
	
	/**
	 * Returns a new object that does not contain a `prop` property.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Object
	 * @sig String -> {k: v} -> {k: v}
	 * @param {String} prop The name of the property to dissociate
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original but without the specified property
	 * @see R.assoc
	 * @example
	 *
	 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
	 */
	module.exports = _curry2(function dissoc(prop, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  delete result[prop];
	  return result;
	});


/***/ },
/* 698 */
[1041, 395],
/* 699 */
/***/ function(module, exports) {

	module.exports = function _pipe(f, g) {
	  return function() {
	    return g.call(this, f.apply(this, arguments));
	  };
	};


/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	var _xwrap = __webpack_require__(701);
	var bind = __webpack_require__(695);
	var isArrayLike = __webpack_require__(702);
	
	
	module.exports = (function() {
	  function _arrayReduce(xf, acc, list) {
	    var idx = 0;
	    var len = list.length;
	    while (idx < len) {
	      acc = xf['@@transducer/step'](acc, list[idx]);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      idx += 1;
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _iterableReduce(xf, acc, iter) {
	    var step = iter.next();
	    while (!step.done) {
	      acc = xf['@@transducer/step'](acc, step.value);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      step = iter.next();
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _methodReduce(xf, acc, obj) {
	    return xf['@@transducer/result'](obj.reduce(bind(xf['@@transducer/step'], xf), acc));
	  }
	
	  var symIterator = (typeof Symbol !== 'undefined') ? Symbol.iterator : '@@iterator';
	  return function _reduce(fn, acc, list) {
	    if (typeof fn === 'function') {
	      fn = _xwrap(fn);
	    }
	    if (isArrayLike(list)) {
	      return _arrayReduce(fn, acc, list);
	    }
	    if (typeof list.reduce === 'function') {
	      return _methodReduce(fn, acc, list);
	    }
	    if (list[symIterator] != null) {
	      return _iterableReduce(fn, acc, list[symIterator]());
	    }
	    if (typeof list.next === 'function') {
	      return _iterableReduce(fn, acc, list);
	    }
	    throw new TypeError('reduce: list must be array or iterable');
	  };
	}());


/***/ },
/* 701 */
661,
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(76);
	var _isArray = __webpack_require__(396);
	var _isString = __webpack_require__(397);
	
	
	/**
	 * Tests whether or not an object is similar to an array.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.5.0
	 * @category Type
	 * @category List
	 * @sig * -> Boolean
	 * @param {*} x The object to test.
	 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
	 * @deprecated since v0.23.0
	 * @example
	 *
	 *      R.isArrayLike([]); //=> true
	 *      R.isArrayLike(true); //=> false
	 *      R.isArrayLike({}); //=> false
	 *      R.isArrayLike({length: 10}); //=> false
	 *      R.isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
	 */
	module.exports = _curry1(function isArrayLike(x) {
	  if (_isArray(x)) { return true; }
	  if (!x) { return false; }
	  if (typeof x !== 'object') { return false; }
	  if (_isString(x)) { return false; }
	  if (x.nodeType === 1) { return !!x.length; }
	  if (x.length === 0) { return true; }
	  if (x.length > 0) {
	    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
	  }
	  return false;
	});


/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(113);
	
	
	/**
	 * Returns a partial copy of an object containing only the keys that satisfy
	 * the supplied predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig (v, k -> Boolean) -> {k: v} -> {k: v}
	 * @param {Function} pred A predicate to determine whether or not a key
	 *        should be included on the output object.
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties that satisfy `pred`
	 *         on it.
	 * @see R.pick, R.filter
	 * @example
	 *
	 *      var isUpperCase = (val, key) => key.toUpperCase() === key;
	 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
	 */
	module.exports = _curry2(function pickBy(test, obj) {
	  var result = {};
	  for (var prop in obj) {
	    if (test(obj[prop], prop, obj)) {
	      result[prop] = obj[prop];
	    }
	  }
	  return result;
	});


/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(393);
	var _pipe = __webpack_require__(699);
	var reduce = __webpack_require__(399);
	var tail = __webpack_require__(707);
	
	
	/**
	 * Performs left-to-right function composition. The leftmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * In some libraries this function is named `sequence`.
	 *
	 * **Note:** The result of pipe is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.compose
	 * @example
	 *
	 *      var f = R.pipe(Math.pow, R.negate, R.inc);
	 *
	 *      f(3, 4); // -(3^4) + 1
	 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
	 */
	module.exports = function pipe() {
	  if (arguments.length === 0) {
	    throw new Error('pipe requires at least one argument');
	  }
	  return _arity(arguments[0].length,
	                reduce(_pipe, arguments[0], tail(arguments)));
	};


/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(76);
	var _isString = __webpack_require__(397);
	
	
	/**
	 * Returns a new list or string with the elements or characters in reverse
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {Array|String}
	 * @example
	 *
	 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
	 *      R.reverse([1, 2]);     //=> [2, 1]
	 *      R.reverse([1]);        //=> [1]
	 *      R.reverse([]);         //=> []
	 *
	 *      R.reverse('abc');      //=> 'cba'
	 *      R.reverse('ab');       //=> 'ba'
	 *      R.reverse('a');        //=> 'a'
	 *      R.reverse('');         //=> ''
	 */
	module.exports = _curry1(function reverse(list) {
	  return _isString(list) ? list.split('').reverse().join('') :
	                           Array.prototype.slice.call(list, 0).reverse();
	});


/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(394);
	var _curry3 = __webpack_require__(157);
	
	
	/**
	 * Returns the elements of the given list or string (or object with a `slice`
	 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
	 *
	 * Dispatches to the `slice` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @sig Number -> Number -> String -> String
	 * @param {Number} fromIndex The start index (inclusive).
	 * @param {Number} toIndex The end index (exclusive).
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
	 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
	 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
	 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
	 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
	 */
	module.exports = _curry3(_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
	  return Array.prototype.slice.call(list, fromIndex, toIndex);
	}));


/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(394);
	var _curry1 = __webpack_require__(76);
	var slice = __webpack_require__(706);
	
	
	/**
	 * Returns all but the first element of the given list or string (or object
	 * with a `tail` method).
	 *
	 * Dispatches to the `slice` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.head, R.init, R.last
	 * @example
	 *
	 *      R.tail([1, 2, 3]);  //=> [2, 3]
	 *      R.tail([1, 2]);     //=> [2]
	 *      R.tail([1]);        //=> []
	 *      R.tail([]);         //=> []
	 *
	 *      R.tail('abc');  //=> 'bc'
	 *      R.tail('ab');   //=> 'b'
	 *      R.tail('a');    //=> ''
	 *      R.tail('');     //=> ''
	 */
	module.exports = _curry1(_checkForMethod('tail', slice(1, Infinity)));


/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(49);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(130);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(51);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(50);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domAlign = __webpack_require__(597);
	
	var _addEventListener = __webpack_require__(403);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _util = __webpack_require__(710);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getElement(func) {
	  if (typeof func !== 'function' || !func) return null;
	  return func();
	}
	
	function getPoint(point) {
	  if (typeof point !== 'object' || !point) return null;
	  return point;
	}
	
	var Align = function (_Component) {
	  (0, _inherits3['default'])(Align, _Component);
	
	  function Align() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Align);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          target = _this$props.target,
	          align = _this$props.align,
	          onAlign = _this$props.onAlign;
	
	      if (!disabled && target) {
	        var source = _reactDom2['default'].findDOMNode(_this);
	
	        var result = void 0;
	        var element = getElement(target);
	        var point = getPoint(target);
	
	        // IE lose focus after element realign
	        // We should record activeElement and restore later
	        var activeElement = document.activeElement;
	
	        if (element) {
	          result = (0, _domAlign.alignElement)(source, element, align);
	        } else if (point) {
	          result = (0, _domAlign.alignPoint)(source, point, align);
	        }
	
	        (0, _util.restoreFocus)(activeElement, source);
	
	        if (onAlign) {
	          onAlign(source, result);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(Align, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var props = this.props;
	      // if parent ref not attached .... use document.getElementById
	      this.forceAlign();
	      if (!props.disabled && props.monitorWindowResize) {
	        this.startMonitorWindowResize();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var reAlign = false;
	      var props = this.props;
	
	      if (!props.disabled) {
	        var source = _reactDom2['default'].findDOMNode(this);
	        var sourceRect = source ? source.getBoundingClientRect() : null;
	
	        if (prevProps.disabled) {
	          reAlign = true;
	        } else {
	          var lastElement = getElement(prevProps.target);
	          var currentElement = getElement(props.target);
	          var lastPoint = getPoint(prevProps.target);
	          var currentPoint = getPoint(props.target);
	
	          if ((0, _util.isWindow)(lastElement) && (0, _util.isWindow)(currentElement)) {
	            // Skip if is window
	            reAlign = false;
	          } else if (lastElement !== currentElement || // Element change
	          lastElement && !currentElement && currentPoint || // Change from element to point
	          lastPoint && currentPoint && currentElement || // Change from point to element
	          currentPoint && !(0, _util.isSamePoint)(lastPoint, currentPoint)) {
	            reAlign = true;
	          }
	
	          // If source element size changed
	          var preRect = this.sourceRect || {};
	          if (!reAlign && source && (!(0, _util.isSimilarValue)(preRect.width, sourceRect.width) || !(0, _util.isSimilarValue)(preRect.height, sourceRect.height))) {
	            reAlign = true;
	          }
	        }
	
	        this.sourceRect = sourceRect;
	      }
	
	      if (reAlign) {
	        this.forceAlign();
	      }
	
	      if (props.monitorWindowResize && !props.disabled) {
	        this.startMonitorWindowResize();
	      } else {
	        this.stopMonitorWindowResize();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stopMonitorWindowResize();
	    }
	  }, {
	    key: 'startMonitorWindowResize',
	    value: function startMonitorWindowResize() {
	      if (!this.resizeHandler) {
	        this.bufferMonitor = (0, _util.buffer)(this.forceAlign, this.props.monitorBufferTime);
	        this.resizeHandler = (0, _addEventListener2['default'])(window, 'resize', this.bufferMonitor);
	      }
	    }
	  }, {
	    key: 'stopMonitorWindowResize',
	    value: function stopMonitorWindowResize() {
	      if (this.resizeHandler) {
	        this.bufferMonitor.clear();
	        this.resizeHandler.remove();
	        this.resizeHandler = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          childrenProps = _props.childrenProps,
	          children = _props.children;
	
	      var child = _react2['default'].Children.only(children);
	      if (childrenProps) {
	        var newProps = {};
	        var propList = Object.keys(childrenProps);
	        propList.forEach(function (prop) {
	          newProps[prop] = _this2.props[childrenProps[prop]];
	        });
	
	        return _react2['default'].cloneElement(child, newProps);
	      }
	      return child;
	    }
	  }]);
	  return Align;
	}(_react.Component);
	
	Align.propTypes = {
	  childrenProps: _propTypes2['default'].object,
	  align: _propTypes2['default'].object.isRequired,
	  target: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].shape({
	    clientX: _propTypes2['default'].number,
	    clientY: _propTypes2['default'].number,
	    pageX: _propTypes2['default'].number,
	    pageY: _propTypes2['default'].number
	  })]),
	  onAlign: _propTypes2['default'].func,
	  monitorBufferTime: _propTypes2['default'].number,
	  monitorWindowResize: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  children: _propTypes2['default'].any
	};
	Align.defaultProps = {
	  target: function target() {
	    return window;
	  },
	  monitorBufferTime: 50,
	  monitorWindowResize: false,
	  disabled: false
	};
	exports['default'] = Align;
	module.exports = exports['default'];

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Align = __webpack_require__(708);
	
	var _Align2 = _interopRequireDefault(_Align);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Align2['default']; // export this package's api
	
	module.exports = exports['default'];

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buffer = buffer;
	exports.isSamePoint = isSamePoint;
	exports.isWindow = isWindow;
	exports.isSimilarValue = isSimilarValue;
	exports.restoreFocus = restoreFocus;
	
	var _contains = __webpack_require__(404);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function buffer(fn, ms) {
	  var timer = void 0;
	
	  function clear() {
	    if (timer) {
	      clearTimeout(timer);
	      timer = null;
	    }
	  }
	
	  function bufferFn() {
	    clear();
	    timer = setTimeout(fn, ms);
	  }
	
	  bufferFn.clear = clear;
	
	  return bufferFn;
	}
	
	function isSamePoint(prev, next) {
	  if (prev === next) return true;
	  if (!prev || !next) return false;
	
	  if ('pageX' in next && 'pageY' in next) {
	    return prev.pageX === next.pageX && prev.pageY === next.pageY;
	  }
	
	  if ('clientX' in next && 'clientY' in next) {
	    return prev.clientX === next.clientX && prev.clientY === next.clientY;
	  }
	
	  return false;
	}
	
	function isWindow(obj) {
	  return obj && typeof obj === 'object' && obj.window === obj;
	}
	
	function isSimilarValue(val1, val2) {
	  var int1 = Math.floor(val1);
	  var int2 = Math.floor(val2);
	  return Math.abs(int1 - int2) <= 1;
	}
	
	function restoreFocus(activeElement, container) {
	  // Focus back if is in the container
	  if (activeElement !== document.activeElement && (0, _contains2['default'])(container, activeElement)) {
	    activeElement.focus();
	  }
	}

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(104);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(547);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(49);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(130);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(51);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(50);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _unsafeLifecyclesPolyfill = __webpack_require__(725);
	
	var _unsafeLifecyclesPolyfill2 = _interopRequireDefault(_unsafeLifecyclesPolyfill);
	
	var _ChildrenUtils = __webpack_require__(713);
	
	var _AnimateChild = __webpack_require__(712);
	
	var _AnimateChild2 = _interopRequireDefault(_AnimateChild);
	
	var _animate = __webpack_require__(400);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultKey = 'rc_animate_' + Date.now();
	
	function getChildrenFromProps(props) {
	  var children = props.children;
	  if (_react2['default'].isValidElement(children)) {
	    if (!children.key) {
	      return _react2['default'].cloneElement(children, {
	        key: defaultKey
	      });
	    }
	  }
	  return children;
	}
	
	function noop() {}
	
	var Animate = function (_React$Component) {
	  (0, _inherits3['default'])(Animate, _React$Component);
	
	  // eslint-disable-line
	
	  function Animate(props) {
	    (0, _classCallCheck3['default'])(this, Animate);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.currentlyAnimatingKeys = {};
	    _this.keysToEnter = [];
	    _this.keysToLeave = [];
	
	    _this.state = {
	      children: (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props))
	    };
	
	    _this.childrenRefs = {};
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Animate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var showProp = this.props.showProp;
	      var children = this.state.children;
	      if (showProp) {
	        children = children.filter(function (child) {
	          return !!child.props[showProp];
	        });
	      }
	      children.forEach(function (child) {
	        if (child) {
	          _this2.performAppear(child.key);
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      this.nextProps = nextProps;
	      var nextChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(nextProps));
	      var props = this.props;
	      // exclusive needs immediate response
	      if (props.exclusive) {
	        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
	          _this3.stop(key);
	        });
	      }
	      var showProp = props.showProp;
	      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
	      // last props children if exclusive
	      var currentChildren = props.exclusive ? (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props)) : this.state.children;
	      // in case destroy in showProp mode
	      var newChildren = [];
	      if (showProp) {
	        currentChildren.forEach(function (currentChild) {
	          var nextChild = currentChild && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, currentChild.key);
	          var newChild = void 0;
	          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
	            newChild = _react2['default'].cloneElement(nextChild || currentChild, (0, _defineProperty3['default'])({}, showProp, true));
	          } else {
	            newChild = nextChild;
	          }
	          if (newChild) {
	            newChildren.push(newChild);
	          }
	        });
	        nextChildren.forEach(function (nextChild) {
	          if (!nextChild || !(0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, nextChild.key)) {
	            newChildren.push(nextChild);
	          }
	        });
	      } else {
	        newChildren = (0, _ChildrenUtils.mergeChildren)(currentChildren, nextChildren);
	      }
	
	      // need render to avoid update
	      this.setState({
	        children: newChildren
	      });
	
	      nextChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasPrev = child && (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	        if (showProp) {
	          var showInNext = child.props[showProp];
	          if (hasPrev) {
	            var showInNow = (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	            if (!showInNow && showInNext) {
	              _this3.keysToEnter.push(key);
	            }
	          } else if (showInNext) {
	            _this3.keysToEnter.push(key);
	          }
	        } else if (!hasPrev) {
	          _this3.keysToEnter.push(key);
	        }
	      });
	
	      currentChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasNext = child && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, key);
	        if (showProp) {
	          var showInNow = child.props[showProp];
	          if (hasNext) {
	            var showInNext = (0, _ChildrenUtils.findShownChildInChildrenByKey)(nextChildren, key, showProp);
	            if (!showInNext && showInNow) {
	              _this3.keysToLeave.push(key);
	            }
	          } else if (showInNow) {
	            _this3.keysToLeave.push(key);
	          }
	        } else if (!hasNext) {
	          _this3.keysToLeave.push(key);
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var keysToEnter = this.keysToEnter;
	      this.keysToEnter = [];
	      keysToEnter.forEach(this.performEnter);
	      var keysToLeave = this.keysToLeave;
	      this.keysToLeave = [];
	      keysToLeave.forEach(this.performLeave);
	    }
	  }, {
	    key: 'isValidChildByKey',
	    value: function isValidChildByKey(currentChildren, key) {
	      var showProp = this.props.showProp;
	      if (showProp) {
	        return (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	      }
	      return (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	    }
	  }, {
	    key: 'stop',
	    value: function stop(key) {
	      delete this.currentlyAnimatingKeys[key];
	      var component = this.childrenRefs[key];
	      if (component) {
	        component.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var props = this.props;
	      this.nextProps = props;
	      var stateChildren = this.state.children;
	      var children = null;
	      if (stateChildren) {
	        children = stateChildren.map(function (child) {
	          if (child === null || child === undefined) {
	            return child;
	          }
	          if (!child.key) {
	            throw new Error('must set key for <rc-animate> children');
	          }
	          return _react2['default'].createElement(
	            _AnimateChild2['default'],
	            {
	              key: child.key,
	              ref: function ref(node) {
	                _this4.childrenRefs[child.key] = node;
	              },
	              animation: props.animation,
	              transitionName: props.transitionName,
	              transitionEnter: props.transitionEnter,
	              transitionAppear: props.transitionAppear,
	              transitionLeave: props.transitionLeave
	            },
	            child
	          );
	        });
	      }
	      var Component = props.component;
	      if (Component) {
	        var passedProps = props;
	        if (typeof Component === 'string') {
	          passedProps = (0, _extends3['default'])({
	            className: props.className,
	            style: props.style
	          }, props.componentProps);
	        }
	        return _react2['default'].createElement(
	          Component,
	          passedProps,
	          children
	        );
	      }
	      return children[0] || null;
	    }
	  }]);
	  return Animate;
	}(_react2['default'].Component);
	
	Animate.isAnimate = true;
	Animate.propTypes = {
	  className: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  component: _propTypes2['default'].any,
	  componentProps: _propTypes2['default'].object,
	  animation: _propTypes2['default'].object,
	  transitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  transitionEnter: _propTypes2['default'].bool,
	  transitionAppear: _propTypes2['default'].bool,
	  exclusive: _propTypes2['default'].bool,
	  transitionLeave: _propTypes2['default'].bool,
	  onEnd: _propTypes2['default'].func,
	  onEnter: _propTypes2['default'].func,
	  onLeave: _propTypes2['default'].func,
	  onAppear: _propTypes2['default'].func,
	  showProp: _propTypes2['default'].string,
	  children: _propTypes2['default'].node
	};
	Animate.defaultProps = {
	  animation: {},
	  component: 'span',
	  componentProps: {},
	  transitionEnter: true,
	  transitionLeave: true,
	  transitionAppear: false,
	  onEnd: noop,
	  onEnter: noop,
	  onLeave: noop,
	  onAppear: noop
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.performEnter = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
	    }
	  };
	
	  this.performAppear = function (key) {
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
	    }
	  };
	
	  this.handleDoneAdding = function (key, type) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    if (!_this5.isValidChildByKey(currentChildren, key)) {
	      // exclusive will not need this
	      _this5.performLeave(key);
	    } else if (type === 'appear') {
	      if (_animate2['default'].allowAppearCallback(props)) {
	        props.onAppear(key);
	        props.onEnd(key, true);
	      }
	    } else if (_animate2['default'].allowEnterCallback(props)) {
	      props.onEnter(key);
	      props.onEnd(key, true);
	    }
	  };
	
	  this.performLeave = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
	    }
	  };
	
	  this.handleDoneLeaving = function (key) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    // in case state change is too fast
	    if (_this5.isValidChildByKey(currentChildren, key)) {
	      _this5.performEnter(key);
	    } else {
	      var end = function end() {
	        if (_animate2['default'].allowLeaveCallback(props)) {
	          props.onLeave(key);
	          props.onEnd(key, false);
	        }
	      };
	      if (!(0, _ChildrenUtils.isSameChildren)(_this5.state.children, currentChildren, props.showProp)) {
	        _this5.setState({
	          children: currentChildren
	        }, end);
	      } else {
	        end();
	      }
	    }
	  };
	};
	
	exports['default'] = (0, _unsafeLifecyclesPolyfill2['default'])(Animate);
	module.exports = exports['default'];

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(49);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(130);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(51);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(50);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cssAnimation = __webpack_require__(592);
	
	var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
	
	var _animate = __webpack_require__(400);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var transitionMap = {
	  enter: 'transitionEnter',
	  appear: 'transitionAppear',
	  leave: 'transitionLeave'
	};
	
	var AnimateChild = function (_React$Component) {
	  (0, _inherits3['default'])(AnimateChild, _React$Component);
	
	  function AnimateChild() {
	    (0, _classCallCheck3['default'])(this, AnimateChild);
	    return (0, _possibleConstructorReturn3['default'])(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(AnimateChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stop();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(done) {
	      if (_animate2['default'].isEnterSupported(this.props)) {
	        this.transition('enter', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(done) {
	      if (_animate2['default'].isAppearSupported(this.props)) {
	        this.transition('appear', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(done) {
	      if (_animate2['default'].isLeaveSupported(this.props)) {
	        this.transition('leave', done);
	      } else {
	        // always sync, do not interupt with react component life cycle
	        // update hidden -> animate hidden ->
	        // didUpdate -> animate leave -> unmount (if animate is none)
	        done();
	      }
	    }
	  }, {
	    key: 'transition',
	    value: function transition(animationType, finishCallback) {
	      var _this2 = this;
	
	      var node = _reactDom2['default'].findDOMNode(this);
	      var props = this.props;
	      var transitionName = props.transitionName;
	      var nameIsObj = typeof transitionName === 'object';
	      this.stop();
	      var end = function end() {
	        _this2.stopper = null;
	        finishCallback();
	      };
	      if ((_cssAnimation.isCssAnimationSupported || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
	        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
	        var activeName = name + '-active';
	        if (nameIsObj && transitionName[animationType + 'Active']) {
	          activeName = transitionName[animationType + 'Active'];
	        }
	        this.stopper = (0, _cssAnimation2['default'])(node, {
	          name: name,
	          active: activeName
	        }, end);
	      } else {
	        this.stopper = props.animation[animationType](node, end);
	      }
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      var stopper = this.stopper;
	      if (stopper) {
	        this.stopper = null;
	        stopper.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return AnimateChild;
	}(_react2['default'].Component);
	
	AnimateChild.propTypes = {
	  children: _propTypes2['default'].any,
	  animation: _propTypes2['default'].any,
	  transitionName: _propTypes2['default'].any
	};
	exports['default'] = AnimateChild;
	module.exports = exports['default'];

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toArrayChildren = toArrayChildren;
	exports.findChildInChildrenByKey = findChildInChildrenByKey;
	exports.findShownChildInChildrenByKey = findShownChildInChildrenByKey;
	exports.findHiddenChildInChildrenByKey = findHiddenChildInChildrenByKey;
	exports.isSameChildren = isSameChildren;
	exports.mergeChildren = mergeChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toArrayChildren(children) {
	  var ret = [];
	  _react2['default'].Children.forEach(children, function (child) {
	    ret.push(child);
	  });
	  return ret;
	}
	
	function findChildInChildrenByKey(children, key) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (ret) {
	        return;
	      }
	      if (child && child.key === key) {
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findShownChildInChildrenByKey(children, key, showProp) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (child && child.key === key && child.props[showProp]) {
	        if (ret) {
	          throw new Error('two child with same key for <rc-animate> children');
	        }
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findHiddenChildInChildrenByKey(children, key, showProp) {
	  var found = 0;
	  if (children) {
	    children.forEach(function (child) {
	      if (found) {
	        return;
	      }
	      found = child && child.key === key && !child.props[showProp];
	    });
	  }
	  return found;
	}
	
	function isSameChildren(c1, c2, showProp) {
	  var same = c1.length === c2.length;
	  if (same) {
	    c1.forEach(function (child, index) {
	      var child2 = c2[index];
	      if (child && child2) {
	        if (child && !child2 || !child && child2) {
	          same = false;
	        } else if (child.key !== child2.key) {
	          same = false;
	        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
	          same = false;
	        }
	      }
	    });
	  }
	  return same;
	}
	
	function mergeChildren(prev, next) {
	  var ret = [];
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextChildrenPending = {};
	  var pendingChildren = [];
	  prev.forEach(function (child) {
	    if (child && findChildInChildrenByKey(next, child.key)) {
	      if (pendingChildren.length) {
	        nextChildrenPending[child.key] = pendingChildren;
	        pendingChildren = [];
	      }
	    } else {
	      pendingChildren.push(child);
	    }
	  });
	
	  next.forEach(function (child) {
	    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
	      ret = ret.concat(nextChildrenPending[child.key]);
	    }
	    ret.push(child);
	  });
	
	  ret = ret.concat(pendingChildren);
	
	  return ret;
	}

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Select = _interopRequireDefault(__webpack_require__(717));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var formatOption = function formatOption(option, disabledOptions) {
	  var value = "".concat(option);
	
	  if (option < 10) {
	    value = "0".concat(option);
	  }
	
	  var disabled = false;
	
	  if (disabledOptions && disabledOptions.indexOf(option) >= 0) {
	    disabled = true;
	  }
	
	  return {
	    value: value,
	    disabled: disabled
	  };
	};
	
	var Combobox =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Combobox, _Component);
	
	  function Combobox() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Combobox);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Combobox)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "onItemChange", function (type, itemValue) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          defaultOpenValue = _this$props.defaultOpenValue,
	          use12Hours = _this$props.use12Hours,
	          propValue = _this$props.value,
	          isAM = _this$props.isAM,
	          onAmPmChange = _this$props.onAmPmChange;
	      var value = (propValue || defaultOpenValue).clone();
	
	      if (type === 'hour') {
	        if (use12Hours) {
	          if (isAM) {
	            value.hour(+itemValue % 12);
	          } else {
	            value.hour(+itemValue % 12 + 12);
	          }
	        } else {
	          value.hour(+itemValue);
	        }
	      } else if (type === 'minute') {
	        value.minute(+itemValue);
	      } else if (type === 'ampm') {
	        var ampm = itemValue.toUpperCase();
	
	        if (use12Hours) {
	          if (ampm === 'PM' && value.hour() < 12) {
	            value.hour(value.hour() % 12 + 12);
	          }
	
	          if (ampm === 'AM') {
	            if (value.hour() >= 12) {
	              value.hour(value.hour() - 12);
	            }
	          }
	        }
	
	        onAmPmChange(ampm);
	      } else {
	        value.second(+itemValue);
	      }
	
	      onChange(value);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onEnterSelectPanel", function (range) {
	      var onCurrentSelectPanelChange = _this.props.onCurrentSelectPanelChange;
	      onCurrentSelectPanelChange(range);
	    });
	
	    return _this;
	  }
	
	  _createClass(Combobox, [{
	    key: "getHourSelect",
	    value: function getHourSelect(hour) {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          prefixCls = _this$props2.prefixCls,
	          hourOptions = _this$props2.hourOptions,
	          disabledHours = _this$props2.disabledHours,
	          showHour = _this$props2.showHour,
	          use12Hours = _this$props2.use12Hours,
	          onEsc = _this$props2.onEsc;
	
	      if (!showHour) {
	        return null;
	      }
	
	      var disabledOptions = disabledHours();
	      var hourOptionsAdj;
	      var hourAdj;
	
	      if (use12Hours) {
	        hourOptionsAdj = [12].concat(hourOptions.filter(function (h) {
	          return h < 12 && h > 0;
	        }));
	        hourAdj = hour % 12 || 12;
	      } else {
	        hourOptionsAdj = hourOptions;
	        hourAdj = hour;
	      }
	
	      return _react["default"].createElement(_Select["default"], {
	        prefixCls: prefixCls,
	        options: hourOptionsAdj.map(function (option) {
	          return formatOption(option, disabledOptions);
	        }),
	        selectedIndex: hourOptionsAdj.indexOf(hourAdj),
	        type: "hour",
	        onSelect: this.onItemChange,
	        onMouseEnter: function onMouseEnter() {
	          return _this2.onEnterSelectPanel('hour');
	        },
	        onEsc: onEsc
	      });
	    }
	  }, {
	    key: "getMinuteSelect",
	    value: function getMinuteSelect(minute) {
	      var _this3 = this;
	
	      var _this$props3 = this.props,
	          prefixCls = _this$props3.prefixCls,
	          minuteOptions = _this$props3.minuteOptions,
	          disabledMinutes = _this$props3.disabledMinutes,
	          defaultOpenValue = _this$props3.defaultOpenValue,
	          showMinute = _this$props3.showMinute,
	          propValue = _this$props3.value,
	          onEsc = _this$props3.onEsc;
	
	      if (!showMinute) {
	        return null;
	      }
	
	      var value = propValue || defaultOpenValue;
	      var disabledOptions = disabledMinutes(value.hour());
	      return _react["default"].createElement(_Select["default"], {
	        prefixCls: prefixCls,
	        options: minuteOptions.map(function (option) {
	          return formatOption(option, disabledOptions);
	        }),
	        selectedIndex: minuteOptions.indexOf(minute),
	        type: "minute",
	        onSelect: this.onItemChange,
	        onMouseEnter: function onMouseEnter() {
	          return _this3.onEnterSelectPanel('minute');
	        },
	        onEsc: onEsc
	      });
	    }
	  }, {
	    key: "getSecondSelect",
	    value: function getSecondSelect(second) {
	      var _this4 = this;
	
	      var _this$props4 = this.props,
	          prefixCls = _this$props4.prefixCls,
	          secondOptions = _this$props4.secondOptions,
	          disabledSeconds = _this$props4.disabledSeconds,
	          showSecond = _this$props4.showSecond,
	          defaultOpenValue = _this$props4.defaultOpenValue,
	          propValue = _this$props4.value,
	          onEsc = _this$props4.onEsc;
	
	      if (!showSecond) {
	        return null;
	      }
	
	      var value = propValue || defaultOpenValue;
	      var disabledOptions = disabledSeconds(value.hour(), value.minute());
	      return _react["default"].createElement(_Select["default"], {
	        prefixCls: prefixCls,
	        options: secondOptions.map(function (option) {
	          return formatOption(option, disabledOptions);
	        }),
	        selectedIndex: secondOptions.indexOf(second),
	        type: "second",
	        onSelect: this.onItemChange,
	        onMouseEnter: function onMouseEnter() {
	          return _this4.onEnterSelectPanel('second');
	        },
	        onEsc: onEsc
	      });
	    }
	  }, {
	    key: "getAMPMSelect",
	    value: function getAMPMSelect() {
	      var _this5 = this;
	
	      var _this$props5 = this.props,
	          prefixCls = _this$props5.prefixCls,
	          use12Hours = _this$props5.use12Hours,
	          format = _this$props5.format,
	          isAM = _this$props5.isAM,
	          onEsc = _this$props5.onEsc;
	
	      if (!use12Hours) {
	        return null;
	      }
	
	      var AMPMOptions = ['am', 'pm'] // If format has A char, then we should uppercase AM/PM
	      .map(function (c) {
	        return format.match(/\sA/) ? c.toUpperCase() : c;
	      }).map(function (c) {
	        return {
	          value: c
	        };
	      });
	      var selected = isAM ? 0 : 1;
	      return _react["default"].createElement(_Select["default"], {
	        prefixCls: prefixCls,
	        options: AMPMOptions,
	        selectedIndex: selected,
	        type: "ampm",
	        onSelect: this.onItemChange,
	        onMouseEnter: function onMouseEnter() {
	          return _this5.onEnterSelectPanel('ampm');
	        },
	        onEsc: onEsc
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          prefixCls = _this$props6.prefixCls,
	          defaultOpenValue = _this$props6.defaultOpenValue,
	          propValue = _this$props6.value;
	      var value = propValue || defaultOpenValue;
	      return _react["default"].createElement("div", {
	        className: "".concat(prefixCls, "-combobox")
	      }, this.getHourSelect(value.hour()), this.getMinuteSelect(value.minute()), this.getSecondSelect(value.second()), this.getAMPMSelect(value.hour()));
	    }
	  }]);
	
	  return Combobox;
	}(_react.Component);
	
	_defineProperty(Combobox, "propTypes", {
	  format: _propTypes["default"].string,
	  defaultOpenValue: _propTypes["default"].object,
	  prefixCls: _propTypes["default"].string,
	  value: _propTypes["default"].object,
	  onChange: _propTypes["default"].func,
	  onAmPmChange: _propTypes["default"].func,
	  showHour: _propTypes["default"].bool,
	  showMinute: _propTypes["default"].bool,
	  showSecond: _propTypes["default"].bool,
	  hourOptions: _propTypes["default"].array,
	  minuteOptions: _propTypes["default"].array,
	  secondOptions: _propTypes["default"].array,
	  disabledHours: _propTypes["default"].func,
	  disabledMinutes: _propTypes["default"].func,
	  disabledSeconds: _propTypes["default"].func,
	  onCurrentSelectPanelChange: _propTypes["default"].func,
	  use12Hours: _propTypes["default"].bool,
	  onEsc: _propTypes["default"].func,
	  isAM: _propTypes["default"].bool
	});
	
	var _default = Combobox;
	exports["default"] = _default;

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Header =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header(props) {
	    var _this;
	
	    _classCallCheck(this, Header);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Header).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (event) {
	      var str = event.target.value;
	
	      _this.setState({
	        str: str
	      });
	
	      var _this$props = _this.props,
	          format = _this$props.format,
	          hourOptions = _this$props.hourOptions,
	          minuteOptions = _this$props.minuteOptions,
	          secondOptions = _this$props.secondOptions,
	          disabledHours = _this$props.disabledHours,
	          disabledMinutes = _this$props.disabledMinutes,
	          disabledSeconds = _this$props.disabledSeconds,
	          onChange = _this$props.onChange;
	
	      if (str) {
	        var originalValue = _this.props.value;
	
	        var value = _this.getProtoValue().clone();
	
	        var parsed = (0, _moment["default"])(str, format, true);
	
	        if (!parsed.isValid()) {
	          _this.setState({
	            invalid: true
	          });
	
	          return;
	        }
	
	        value.hour(parsed.hour()).minute(parsed.minute()).second(parsed.second()); // if time value not allowed, response warning.
	
	        if (hourOptions.indexOf(value.hour()) < 0 || minuteOptions.indexOf(value.minute()) < 0 || secondOptions.indexOf(value.second()) < 0) {
	          _this.setState({
	            invalid: true
	          });
	
	          return;
	        } // if time value is disabled, response warning.
	
	
	        var disabledHourOptions = disabledHours();
	        var disabledMinuteOptions = disabledMinutes(value.hour());
	        var disabledSecondOptions = disabledSeconds(value.hour(), value.minute());
	
	        if (disabledHourOptions && disabledHourOptions.indexOf(value.hour()) >= 0 || disabledMinuteOptions && disabledMinuteOptions.indexOf(value.minute()) >= 0 || disabledSecondOptions && disabledSecondOptions.indexOf(value.second()) >= 0) {
	          _this.setState({
	            invalid: true
	          });
	
	          return;
	        }
	
	        if (originalValue) {
	          if (originalValue.hour() !== value.hour() || originalValue.minute() !== value.minute() || originalValue.second() !== value.second()) {
	            // keep other fields for rc-calendar
	            var changedValue = originalValue.clone();
	            changedValue.hour(value.hour());
	            changedValue.minute(value.minute());
	            changedValue.second(value.second());
	            onChange(changedValue);
	          }
	        } else if (originalValue !== value) {
	          onChange(value);
	        }
	      } else {
	        onChange(null);
	      }
	
	      _this.setState({
	        invalid: false
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
	      var _this$props2 = _this.props,
	          onEsc = _this$props2.onEsc,
	          onKeyDown = _this$props2.onKeyDown;
	
	      if (e.keyCode === 27) {
	        onEsc();
	      }
	
	      onKeyDown(e);
	    });
	
	    var _value = props.value,
	        _format = props.format;
	    _this.state = {
	      str: _value && _value.format(_format) || '',
	      invalid: false
	    };
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var focusOnOpen = this.props.focusOnOpen;
	
	      if (focusOnOpen) {
	        // Wait one frame for the panel to be positioned before focusing
	        var requestAnimationFrame = window.requestAnimationFrame || window.setTimeout;
	        requestAnimationFrame(function () {
	          _this2.refInput.focus();
	
	          _this2.refInput.select();
	        });
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props3 = this.props,
	          value = _this$props3.value,
	          format = _this$props3.format;
	
	      if (value !== prevProps.value) {
	        // eslint-disable-next-line react/no-did-update-set-state
	        this.setState({
	          str: value && value.format(format) || '',
	          invalid: false
	        });
	      }
	    }
	  }, {
	    key: "getProtoValue",
	    value: function getProtoValue() {
	      var _this$props4 = this.props,
	          value = _this$props4.value,
	          defaultOpenValue = _this$props4.defaultOpenValue;
	      return value || defaultOpenValue;
	    }
	  }, {
	    key: "getInput",
	    value: function getInput() {
	      var _this3 = this;
	
	      var _this$props5 = this.props,
	          prefixCls = _this$props5.prefixCls,
	          placeholder = _this$props5.placeholder,
	          inputReadOnly = _this$props5.inputReadOnly;
	      var _this$state = this.state,
	          invalid = _this$state.invalid,
	          str = _this$state.str;
	      var invalidClass = invalid ? "".concat(prefixCls, "-input-invalid") : '';
	      return _react["default"].createElement("input", {
	        className: (0, _classnames["default"])("".concat(prefixCls, "-input"), invalidClass),
	        ref: function ref(_ref) {
	          _this3.refInput = _ref;
	        },
	        onKeyDown: this.onKeyDown,
	        value: str,
	        placeholder: placeholder,
	        onChange: this.onInputChange,
	        readOnly: !!inputReadOnly
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var prefixCls = this.props.prefixCls;
	      return _react["default"].createElement("div", {
	        className: "".concat(prefixCls, "-input-wrap")
	      }, this.getInput());
	    }
	  }]);
	
	  return Header;
	}(_react.Component);
	
	_defineProperty(Header, "propTypes", {
	  format: _propTypes["default"].string,
	  prefixCls: _propTypes["default"].string,
	  disabledDate: _propTypes["default"].func,
	  placeholder: _propTypes["default"].string,
	  clearText: _propTypes["default"].string,
	  value: _propTypes["default"].object,
	  inputReadOnly: _propTypes["default"].bool,
	  hourOptions: _propTypes["default"].array,
	  minuteOptions: _propTypes["default"].array,
	  secondOptions: _propTypes["default"].array,
	  disabledHours: _propTypes["default"].func,
	  disabledMinutes: _propTypes["default"].func,
	  disabledSeconds: _propTypes["default"].func,
	  onChange: _propTypes["default"].func,
	  onEsc: _propTypes["default"].func,
	  defaultOpenValue: _propTypes["default"].object,
	  currentSelectPanel: _propTypes["default"].string,
	  focusOnOpen: _propTypes["default"].bool,
	  onKeyDown: _propTypes["default"].func,
	  clearIcon: _propTypes["default"].node
	});
	
	_defineProperty(Header, "defaultProps", {
	  inputReadOnly: false
	});
	
	var _default = Header;
	exports["default"] = _default;

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _reactLifecyclesCompat = __webpack_require__(45);
	
	var _Header = _interopRequireDefault(__webpack_require__(715));
	
	var _Combobox = _interopRequireDefault(__webpack_require__(714));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function noop() {}
	
	function generateOptions(length, disabledOptions, hideDisabledOptions) {
	  var step = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	  var arr = [];
	
	  for (var value = 0; value < length; value += step) {
	    if (!disabledOptions || disabledOptions.indexOf(value) < 0 || !hideDisabledOptions) {
	      arr.push(value);
	    }
	  }
	
	  return arr;
	}
	
	function toNearestValidTime(time, hourOptions, minuteOptions, secondOptions) {
	  var hour = hourOptions.slice().sort(function (a, b) {
	    return Math.abs(time.hour() - a) - Math.abs(time.hour() - b);
	  })[0];
	  var minute = minuteOptions.slice().sort(function (a, b) {
	    return Math.abs(time.minute() - a) - Math.abs(time.minute() - b);
	  })[0];
	  var second = secondOptions.slice().sort(function (a, b) {
	    return Math.abs(time.second() - a) - Math.abs(time.second() - b);
	  })[0];
	  return (0, _moment["default"])("".concat(hour, ":").concat(minute, ":").concat(second), 'HH:mm:ss');
	}
	
	var Panel =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Panel, _Component);
	
	  function Panel() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Panel);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Panel)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "state", {});
	
	    _defineProperty(_assertThisInitialized(_this), "onChange", function (newValue) {
	      var onChange = _this.props.onChange;
	
	      _this.setState({
	        value: newValue
	      });
	
	      onChange(newValue);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onAmPmChange", function (ampm) {
	      var onAmPmChange = _this.props.onAmPmChange;
	      onAmPmChange(ampm);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onCurrentSelectPanelChange", function (currentSelectPanel) {
	      _this.setState({
	        currentSelectPanel: currentSelectPanel
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "disabledHours", function () {
	      var _this$props = _this.props,
	          use12Hours = _this$props.use12Hours,
	          disabledHours = _this$props.disabledHours;
	      var disabledOptions = disabledHours();
	
	      if (use12Hours && Array.isArray(disabledOptions)) {
	        if (_this.isAM()) {
	          disabledOptions = disabledOptions.filter(function (h) {
	            return h < 12;
	          }).map(function (h) {
	            return h === 0 ? 12 : h;
	          });
	        } else {
	          disabledOptions = disabledOptions.map(function (h) {
	            return h === 12 ? 12 : h - 12;
	          });
	        }
	      }
	
	      return disabledOptions;
	    });
	
	    return _this;
	  }
	
	  _createClass(Panel, [{
	    key: "close",
	    // https://github.com/ant-design/ant-design/issues/5829
	    value: function close() {
	      var onEsc = this.props.onEsc;
	      onEsc();
	    }
	  }, {
	    key: "isAM",
	    value: function isAM() {
	      var defaultOpenValue = this.props.defaultOpenValue;
	      var value = this.state.value;
	      var realValue = value || defaultOpenValue;
	      return realValue.hour() >= 0 && realValue.hour() < 12;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          prefixCls = _this$props2.prefixCls,
	          className = _this$props2.className,
	          placeholder = _this$props2.placeholder,
	          disabledMinutes = _this$props2.disabledMinutes,
	          disabledSeconds = _this$props2.disabledSeconds,
	          hideDisabledOptions = _this$props2.hideDisabledOptions,
	          showHour = _this$props2.showHour,
	          showMinute = _this$props2.showMinute,
	          showSecond = _this$props2.showSecond,
	          format = _this$props2.format,
	          defaultOpenValue = _this$props2.defaultOpenValue,
	          clearText = _this$props2.clearText,
	          onEsc = _this$props2.onEsc,
	          addon = _this$props2.addon,
	          use12Hours = _this$props2.use12Hours,
	          focusOnOpen = _this$props2.focusOnOpen,
	          onKeyDown = _this$props2.onKeyDown,
	          hourStep = _this$props2.hourStep,
	          minuteStep = _this$props2.minuteStep,
	          secondStep = _this$props2.secondStep,
	          inputReadOnly = _this$props2.inputReadOnly,
	          clearIcon = _this$props2.clearIcon;
	      var _this$state = this.state,
	          value = _this$state.value,
	          currentSelectPanel = _this$state.currentSelectPanel;
	      var disabledHourOptions = this.disabledHours();
	      var disabledMinuteOptions = disabledMinutes(value ? value.hour() : null);
	      var disabledSecondOptions = disabledSeconds(value ? value.hour() : null, value ? value.minute() : null);
	      var hourOptions = generateOptions(24, disabledHourOptions, hideDisabledOptions, hourStep);
	      var minuteOptions = generateOptions(60, disabledMinuteOptions, hideDisabledOptions, minuteStep);
	      var secondOptions = generateOptions(60, disabledSecondOptions, hideDisabledOptions, secondStep);
	      var validDefaultOpenValue = toNearestValidTime(defaultOpenValue, hourOptions, minuteOptions, secondOptions);
	      return _react["default"].createElement("div", {
	        className: (0, _classnames["default"])(className, "".concat(prefixCls, "-inner"))
	      }, _react["default"].createElement(_Header["default"], {
	        clearText: clearText,
	        prefixCls: prefixCls,
	        defaultOpenValue: validDefaultOpenValue,
	        value: value,
	        currentSelectPanel: currentSelectPanel,
	        onEsc: onEsc,
	        format: format,
	        placeholder: placeholder,
	        hourOptions: hourOptions,
	        minuteOptions: minuteOptions,
	        secondOptions: secondOptions,
	        disabledHours: this.disabledHours,
	        disabledMinutes: disabledMinutes,
	        disabledSeconds: disabledSeconds,
	        onChange: this.onChange,
	        focusOnOpen: focusOnOpen,
	        onKeyDown: onKeyDown,
	        inputReadOnly: inputReadOnly,
	        clearIcon: clearIcon
	      }), _react["default"].createElement(_Combobox["default"], {
	        prefixCls: prefixCls,
	        value: value,
	        defaultOpenValue: validDefaultOpenValue,
	        format: format,
	        onChange: this.onChange,
	        onAmPmChange: this.onAmPmChange,
	        showHour: showHour,
	        showMinute: showMinute,
	        showSecond: showSecond,
	        hourOptions: hourOptions,
	        minuteOptions: minuteOptions,
	        secondOptions: secondOptions,
	        disabledHours: this.disabledHours,
	        disabledMinutes: disabledMinutes,
	        disabledSeconds: disabledSeconds,
	        onCurrentSelectPanelChange: this.onCurrentSelectPanelChange,
	        use12Hours: use12Hours,
	        onEsc: onEsc,
	        isAM: this.isAM()
	      }), addon(this));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(props, state) {
	      if ('value' in props) {
	        return _objectSpread({}, state, {
	          value: props.value
	        });
	      }
	
	      return null;
	    }
	  }]);
	
	  return Panel;
	}(_react.Component);
	
	_defineProperty(Panel, "propTypes", {
	  clearText: _propTypes["default"].string,
	  prefixCls: _propTypes["default"].string,
	  className: _propTypes["default"].string,
	  defaultOpenValue: _propTypes["default"].object,
	  value: _propTypes["default"].object,
	  placeholder: _propTypes["default"].string,
	  format: _propTypes["default"].string,
	  inputReadOnly: _propTypes["default"].bool,
	  disabledHours: _propTypes["default"].func,
	  disabledMinutes: _propTypes["default"].func,
	  disabledSeconds: _propTypes["default"].func,
	  hideDisabledOptions: _propTypes["default"].bool,
	  onChange: _propTypes["default"].func,
	  onAmPmChange: _propTypes["default"].func,
	  onEsc: _propTypes["default"].func,
	  showHour: _propTypes["default"].bool,
	  showMinute: _propTypes["default"].bool,
	  showSecond: _propTypes["default"].bool,
	  use12Hours: _propTypes["default"].bool,
	  hourStep: _propTypes["default"].number,
	  minuteStep: _propTypes["default"].number,
	  secondStep: _propTypes["default"].number,
	  addon: _propTypes["default"].func,
	  focusOnOpen: _propTypes["default"].bool,
	  onKeyDown: _propTypes["default"].func,
	  clearIcon: _propTypes["default"].node
	});
	
	_defineProperty(Panel, "defaultProps", {
	  prefixCls: 'rc-time-picker-panel',
	  onChange: noop,
	  disabledHours: noop,
	  disabledMinutes: noop,
	  disabledSeconds: noop,
	  defaultOpenValue: (0, _moment["default"])(),
	  use12Hours: false,
	  addon: noop,
	  onKeyDown: noop,
	  onAmPmChange: noop,
	  inputReadOnly: false
	});
	
	(0, _reactLifecyclesCompat.polyfill)(Panel);
	var _default = Panel;
	exports["default"] = _default;

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(23));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _raf = _interopRequireDefault(__webpack_require__(392));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var scrollTo = function scrollTo(element, to, duration) {
	  // jump to target if duration zero
	  if (duration <= 0) {
	    (0, _raf["default"])(function () {
	      element.scrollTop = to;
	    });
	    return;
	  }
	
	  var difference = to - element.scrollTop;
	  var perTick = difference / duration * 10;
	  (0, _raf["default"])(function () {
	    element.scrollTop += perTick;
	    if (element.scrollTop === to) return;
	    scrollTo(element, to, duration - 10);
	  });
	};
	
	var Select =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Select, _Component);
	
	  function Select() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Select);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Select)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "state", {
	      active: false
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSelect", function (value) {
	      var _this$props = _this.props,
	          onSelect = _this$props.onSelect,
	          type = _this$props.type;
	      onSelect(type, value);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function (e) {
	      var onMouseEnter = _this.props.onMouseEnter;
	
	      _this.setState({
	        active: true
	      });
	
	      onMouseEnter(e);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
	      _this.setState({
	        active: false
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "saveList", function (node) {
	      _this.list = node;
	    });
	
	    return _this;
	  }
	
	  _createClass(Select, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // jump to selected option
	      this.scrollToSelected(0);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var selectedIndex = this.props.selectedIndex; // smooth scroll to selected option
	
	      if (prevProps.selectedIndex !== selectedIndex) {
	        this.scrollToSelected(120);
	      }
	    }
	  }, {
	    key: "getOptions",
	    value: function getOptions() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          options = _this$props2.options,
	          selectedIndex = _this$props2.selectedIndex,
	          prefixCls = _this$props2.prefixCls,
	          onEsc = _this$props2.onEsc;
	      return options.map(function (item, index) {
	        var _classNames;
	
	        var cls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-select-option-selected"), selectedIndex === index), _defineProperty(_classNames, "".concat(prefixCls, "-select-option-disabled"), item.disabled), _classNames));
	        var onClick = item.disabled ? undefined : function () {
	          _this2.onSelect(item.value);
	        };
	
	        var onKeyDown = function onKeyDown(e) {
	          if (e.keyCode === 13) onClick();else if (e.keyCode === 27) onEsc();
	        };
	
	        return _react["default"].createElement("li", {
	          role: "button",
	          onClick: onClick,
	          className: cls,
	          key: index,
	          disabled: item.disabled,
	          tabIndex: "0",
	          onKeyDown: onKeyDown
	        }, item.value);
	      });
	    }
	  }, {
	    key: "scrollToSelected",
	    value: function scrollToSelected(duration) {
	      // move to selected item
	      var selectedIndex = this.props.selectedIndex;
	
	      var select = _reactDom["default"].findDOMNode(this);
	
	      var list = _reactDom["default"].findDOMNode(this.list);
	
	      if (!list) {
	        return;
	      }
	
	      var index = selectedIndex;
	
	      if (index < 0) {
	        index = 0;
	      }
	
	      var topOption = list.children[index];
	      var to = topOption.offsetTop;
	      scrollTo(select, to, duration);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props3 = this.props,
	          prefixCls = _this$props3.prefixCls,
	          options = _this$props3.options;
	      var active = this.state.active;
	
	      if (options.length === 0) {
	        return null;
	      }
	
	      var cls = (0, _classnames["default"])("".concat(prefixCls, "-select"), _defineProperty({}, "".concat(prefixCls, "-select-active"), active));
	      return _react["default"].createElement("div", {
	        className: cls,
	        onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: this.handleMouseLeave
	      }, _react["default"].createElement("ul", {
	        ref: this.saveList
	      }, this.getOptions()));
	    }
	  }]);
	
	  return Select;
	}(_react.Component);
	
	_defineProperty(Select, "propTypes", {
	  prefixCls: _propTypes["default"].string,
	  options: _propTypes["default"].array,
	  selectedIndex: _propTypes["default"].number,
	  type: _propTypes["default"].string,
	  onSelect: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onEsc: _propTypes["default"].func
	});
	
	var _default = Select;
	exports["default"] = _default;

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _rcTrigger = _interopRequireDefault(__webpack_require__(722));
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _reactLifecyclesCompat = __webpack_require__(45);
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _Panel = _interopRequireDefault(__webpack_require__(716));
	
	var _placements = _interopRequireDefault(__webpack_require__(719));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function noop() {}
	
	function refFn(field, component) {
	  this[field] = component;
	}
	
	var Picker =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Picker, _Component);
	
	  function Picker(props) {
	    var _this;
	
	    _classCallCheck(this, Picker);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Picker).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_this), "onPanelChange", function (value) {
	      _this.setValue(value);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onAmPmChange", function (ampm) {
	      var onAmPmChange = _this.props.onAmPmChange;
	      onAmPmChange(ampm);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onClear", function (event) {
	      event.stopPropagation();
	
	      _this.setValue(null);
	
	      _this.setOpen(false);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onVisibleChange", function (open) {
	      _this.setOpen(open);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onEsc", function () {
	      _this.setOpen(false);
	
	      _this.focus();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
	      if (e.keyCode === 40) {
	        _this.setOpen(true);
	      }
	    });
	
	    _this.saveInputRef = refFn.bind(_assertThisInitialized(_this), 'picker');
	    _this.savePanelRef = refFn.bind(_assertThisInitialized(_this), 'panelInstance');
	
	    var defaultOpen = props.defaultOpen,
	        defaultValue = props.defaultValue,
	        _props$open = props.open,
	        _open = _props$open === void 0 ? defaultOpen : _props$open,
	        _props$value = props.value,
	        _value = _props$value === void 0 ? defaultValue : _props$value;
	
	    _this.state = {
	      open: _open,
	      value: _value
	    };
	    return _this;
	  }
	
	  _createClass(Picker, [{
	    key: "setValue",
	    value: function setValue(value) {
	      var onChange = this.props.onChange;
	
	      if (!('value' in this.props)) {
	        this.setState({
	          value: value
	        });
	      }
	
	      onChange(value);
	    }
	  }, {
	    key: "getFormat",
	    value: function getFormat() {
	      var _this$props = this.props,
	          format = _this$props.format,
	          showHour = _this$props.showHour,
	          showMinute = _this$props.showMinute,
	          showSecond = _this$props.showSecond,
	          use12Hours = _this$props.use12Hours;
	
	      if (format) {
	        return format;
	      }
	
	      if (use12Hours) {
	        var fmtString = [showHour ? 'h' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
	          return !!item;
	        }).join(':');
	        return fmtString.concat(' a');
	      }
	
	      return [showHour ? 'HH' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
	        return !!item;
	      }).join(':');
	    }
	  }, {
	    key: "getPanelElement",
	    value: function getPanelElement() {
	      var _this$props2 = this.props,
	          prefixCls = _this$props2.prefixCls,
	          placeholder = _this$props2.placeholder,
	          disabledHours = _this$props2.disabledHours,
	          disabledMinutes = _this$props2.disabledMinutes,
	          disabledSeconds = _this$props2.disabledSeconds,
	          hideDisabledOptions = _this$props2.hideDisabledOptions,
	          inputReadOnly = _this$props2.inputReadOnly,
	          showHour = _this$props2.showHour,
	          showMinute = _this$props2.showMinute,
	          showSecond = _this$props2.showSecond,
	          defaultOpenValue = _this$props2.defaultOpenValue,
	          clearText = _this$props2.clearText,
	          addon = _this$props2.addon,
	          use12Hours = _this$props2.use12Hours,
	          focusOnOpen = _this$props2.focusOnOpen,
	          onKeyDown = _this$props2.onKeyDown,
	          hourStep = _this$props2.hourStep,
	          minuteStep = _this$props2.minuteStep,
	          secondStep = _this$props2.secondStep,
	          clearIcon = _this$props2.clearIcon;
	      var value = this.state.value;
	      return _react["default"].createElement(_Panel["default"], {
	        clearText: clearText,
	        prefixCls: "".concat(prefixCls, "-panel"),
	        ref: this.savePanelRef,
	        value: value,
	        inputReadOnly: inputReadOnly,
	        onChange: this.onPanelChange,
	        onAmPmChange: this.onAmPmChange,
	        defaultOpenValue: defaultOpenValue,
	        showHour: showHour,
	        showMinute: showMinute,
	        showSecond: showSecond,
	        onEsc: this.onEsc,
	        format: this.getFormat(),
	        placeholder: placeholder,
	        disabledHours: disabledHours,
	        disabledMinutes: disabledMinutes,
	        disabledSeconds: disabledSeconds,
	        hideDisabledOptions: hideDisabledOptions,
	        use12Hours: use12Hours,
	        hourStep: hourStep,
	        minuteStep: minuteStep,
	        secondStep: secondStep,
	        addon: addon,
	        focusOnOpen: focusOnOpen,
	        onKeyDown: onKeyDown,
	        clearIcon: clearIcon
	      });
	    }
	  }, {
	    key: "getPopupClassName",
	    value: function getPopupClassName() {
	      var _this$props3 = this.props,
	          showHour = _this$props3.showHour,
	          showMinute = _this$props3.showMinute,
	          showSecond = _this$props3.showSecond,
	          use12Hours = _this$props3.use12Hours,
	          prefixCls = _this$props3.prefixCls,
	          popupClassName = _this$props3.popupClassName;
	      var selectColumnCount = 0;
	
	      if (showHour) {
	        selectColumnCount += 1;
	      }
	
	      if (showMinute) {
	        selectColumnCount += 1;
	      }
	
	      if (showSecond) {
	        selectColumnCount += 1;
	      }
	
	      if (use12Hours) {
	        selectColumnCount += 1;
	      } // Keep it for old compatibility
	
	
	      return (0, _classnames["default"])(popupClassName, _defineProperty({}, "".concat(prefixCls, "-panel-narrow"), (!showHour || !showMinute || !showSecond) && !use12Hours), "".concat(prefixCls, "-panel-column-").concat(selectColumnCount));
	    }
	  }, {
	    key: "setOpen",
	    value: function setOpen(open) {
	      var _this$props4 = this.props,
	          onOpen = _this$props4.onOpen,
	          onClose = _this$props4.onClose;
	      var currentOpen = this.state.open;
	
	      if (currentOpen !== open) {
	        if (!('open' in this.props)) {
	          this.setState({
	            open: open
	          });
	        }
	
	        if (open) {
	          onOpen({
	            open: open
	          });
	        } else {
	          onClose({
	            open: open
	          });
	        }
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.picker.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.picker.blur();
	    }
	  }, {
	    key: "renderClearButton",
	    value: function renderClearButton() {
	      var _this2 = this;
	
	      var value = this.state.value;
	      var _this$props5 = this.props,
	          prefixCls = _this$props5.prefixCls,
	          allowEmpty = _this$props5.allowEmpty,
	          clearIcon = _this$props5.clearIcon,
	          clearText = _this$props5.clearText,
	          disabled = _this$props5.disabled;
	
	      if (!allowEmpty || !value || disabled) {
	        return null;
	      }
	
	      if (_react["default"].isValidElement(clearIcon)) {
	        var _ref = clearIcon.props || {},
	            _onClick = _ref.onClick;
	
	        return _react["default"].cloneElement(clearIcon, {
	          onClick: function onClick() {
	            if (_onClick) _onClick.apply(void 0, arguments);
	
	            _this2.onClear.apply(_this2, arguments);
	          }
	        });
	      }
	
	      return _react["default"].createElement("a", {
	        role: "button",
	        className: "".concat(prefixCls, "-clear"),
	        title: clearText,
	        onClick: this.onClear,
	        tabIndex: 0
	      }, clearIcon || _react["default"].createElement("i", {
	        className: "".concat(prefixCls, "-clear-icon")
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          prefixCls = _this$props6.prefixCls,
	          placeholder = _this$props6.placeholder,
	          placement = _this$props6.placement,
	          align = _this$props6.align,
	          id = _this$props6.id,
	          disabled = _this$props6.disabled,
	          transitionName = _this$props6.transitionName,
	          style = _this$props6.style,
	          className = _this$props6.className,
	          getPopupContainer = _this$props6.getPopupContainer,
	          name = _this$props6.name,
	          autoComplete = _this$props6.autoComplete,
	          onFocus = _this$props6.onFocus,
	          onBlur = _this$props6.onBlur,
	          autoFocus = _this$props6.autoFocus,
	          inputReadOnly = _this$props6.inputReadOnly,
	          inputIcon = _this$props6.inputIcon,
	          popupStyle = _this$props6.popupStyle;
	      var _this$state = this.state,
	          open = _this$state.open,
	          value = _this$state.value;
	      var popupClassName = this.getPopupClassName();
	      return _react["default"].createElement(_rcTrigger["default"], {
	        prefixCls: "".concat(prefixCls, "-panel"),
	        popupClassName: popupClassName,
	        popupStyle: popupStyle,
	        popup: this.getPanelElement(),
	        popupAlign: align,
	        builtinPlacements: _placements["default"],
	        popupPlacement: placement,
	        action: disabled ? [] : ['click'],
	        destroyPopupOnHide: true,
	        getPopupContainer: getPopupContainer,
	        popupTransitionName: transitionName,
	        popupVisible: open,
	        onPopupVisibleChange: this.onVisibleChange
	      }, _react["default"].createElement("span", {
	        className: (0, _classnames["default"])(prefixCls, className),
	        style: style
	      }, _react["default"].createElement("input", {
	        className: "".concat(prefixCls, "-input"),
	        ref: this.saveInputRef,
	        type: "text",
	        placeholder: placeholder,
	        name: name,
	        onKeyDown: this.onKeyDown,
	        disabled: disabled,
	        value: value && value.format(this.getFormat()) || '',
	        autoComplete: autoComplete,
	        onFocus: onFocus,
	        onBlur: onBlur,
	        autoFocus: autoFocus,
	        onChange: noop,
	        readOnly: !!inputReadOnly,
	        id: id
	      }), inputIcon || _react["default"].createElement("span", {
	        className: "".concat(prefixCls, "-icon")
	      }), this.renderClearButton()));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(props, state) {
	      var newState = {};
	
	      if ('value' in props) {
	        newState.value = props.value;
	      }
	
	      if (props.open !== undefined) {
	        newState.open = props.open;
	      }
	
	      return Object.keys(newState).length > 0 ? _objectSpread({}, state, {}, newState) : null;
	    }
	  }]);
	
	  return Picker;
	}(_react.Component);
	
	_defineProperty(Picker, "propTypes", {
	  prefixCls: _propTypes["default"].string,
	  clearText: _propTypes["default"].string,
	  value: _propTypes["default"].object,
	  defaultOpenValue: _propTypes["default"].object,
	  inputReadOnly: _propTypes["default"].bool,
	  disabled: _propTypes["default"].bool,
	  allowEmpty: _propTypes["default"].bool,
	  defaultValue: _propTypes["default"].object,
	  open: _propTypes["default"].bool,
	  defaultOpen: _propTypes["default"].bool,
	  align: _propTypes["default"].object,
	  placement: _propTypes["default"].any,
	  transitionName: _propTypes["default"].string,
	  getPopupContainer: _propTypes["default"].func,
	  placeholder: _propTypes["default"].string,
	  format: _propTypes["default"].string,
	  showHour: _propTypes["default"].bool,
	  showMinute: _propTypes["default"].bool,
	  showSecond: _propTypes["default"].bool,
	  style: _propTypes["default"].object,
	  className: _propTypes["default"].string,
	  popupClassName: _propTypes["default"].string,
	  popupStyle: _propTypes["default"].object,
	  disabledHours: _propTypes["default"].func,
	  disabledMinutes: _propTypes["default"].func,
	  disabledSeconds: _propTypes["default"].func,
	  hideDisabledOptions: _propTypes["default"].bool,
	  onChange: _propTypes["default"].func,
	  onAmPmChange: _propTypes["default"].func,
	  onOpen: _propTypes["default"].func,
	  onClose: _propTypes["default"].func,
	  onFocus: _propTypes["default"].func,
	  onBlur: _propTypes["default"].func,
	  addon: _propTypes["default"].func,
	  name: _propTypes["default"].string,
	  autoComplete: _propTypes["default"].string,
	  use12Hours: _propTypes["default"].bool,
	  hourStep: _propTypes["default"].number,
	  minuteStep: _propTypes["default"].number,
	  secondStep: _propTypes["default"].number,
	  focusOnOpen: _propTypes["default"].bool,
	  onKeyDown: _propTypes["default"].func,
	  autoFocus: _propTypes["default"].bool,
	  id: _propTypes["default"].string,
	  inputIcon: _propTypes["default"].node,
	  clearIcon: _propTypes["default"].node
	});
	
	_defineProperty(Picker, "defaultProps", {
	  clearText: 'clear',
	  prefixCls: 'rc-time-picker',
	  defaultOpen: false,
	  inputReadOnly: false,
	  style: {},
	  className: '',
	  popupClassName: '',
	  popupStyle: {},
	  id: '',
	  align: {},
	  defaultOpenValue: (0, _moment["default"])(),
	  allowEmpty: true,
	  showHour: true,
	  showMinute: true,
	  showSecond: true,
	  disabledHours: noop,
	  disabledMinutes: noop,
	  disabledSeconds: noop,
	  hideDisabledOptions: false,
	  placement: 'bottomLeft',
	  onChange: noop,
	  onAmPmChange: noop,
	  onOpen: noop,
	  onClose: noop,
	  onFocus: noop,
	  onBlur: noop,
	  addon: noop,
	  use12Hours: false,
	  focusOnOpen: false,
	  onKeyDown: noop
	});
	
	(0, _reactLifecyclesCompat.polyfill)(Picker);
	var _default = Picker;
	exports["default"] = _default;

/***/ },
/* 719 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	var targetOffset = [0, 0];
	var placements = {
	  bottomLeft: {
	    points: ['tl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -3],
	    targetOffset: targetOffset
	  },
	  bottomRight: {
	    points: ['tr', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -3],
	    targetOffset: targetOffset
	  },
	  topRight: {
	    points: ['br', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 3],
	    targetOffset: targetOffset
	  },
	  topLeft: {
	    points: ['bl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 3],
	    targetOffset: targetOffset
	  }
	};
	var _default = placements;
	exports["default"] = _default;

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(104);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(49);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(51);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(50);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcAlign = __webpack_require__(709);
	
	var _rcAlign2 = _interopRequireDefault(_rcAlign);
	
	var _rcAnimate = __webpack_require__(711);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _PopupInner = __webpack_require__(721);
	
	var _PopupInner2 = _interopRequireDefault(_PopupInner);
	
	var _LazyRenderBox = __webpack_require__(401);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	var _utils = __webpack_require__(402);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Popup = function (_Component) {
	  (0, _inherits3['default'])(Popup, _Component);
	
	  function Popup(props) {
	    (0, _classCallCheck3['default'])(this, Popup);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      // Used for stretch
	      stretchChecked: false,
	      targetWidth: undefined,
	      targetHeight: undefined
	    };
	
	    _this.savePopupRef = _utils.saveRef.bind(_this, 'popupInstance');
	    _this.saveAlignRef = _utils.saveRef.bind(_this, 'alignInstance');
	    return _this;
	  }
	
	  Popup.prototype.componentDidMount = function componentDidMount() {
	    this.rootNode = this.getPopupDomNode();
	    this.setStretchSize();
	  };
	
	  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.setStretchSize();
	  };
	
	  // Record size if stretch needed
	
	
	  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
	    return _reactDom2['default'].findDOMNode(this.popupInstance);
	  };
	
	  // `target` on `rc-align` can accept as a function to get the bind element or a point.
	  // ref: https://www.npmjs.com/package/rc-align
	
	
	  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
	    var props = this.props;
	    var transitionName = props.maskTransitionName;
	    var animation = props.maskAnimation;
	    if (!transitionName && animation) {
	      transitionName = props.prefixCls + '-' + animation;
	    }
	    return transitionName;
	  };
	
	  Popup.prototype.getTransitionName = function getTransitionName() {
	    var props = this.props;
	    var transitionName = props.transitionName;
	    if (!transitionName && props.animation) {
	      transitionName = props.prefixCls + '-' + props.animation;
	    }
	    return transitionName;
	  };
	
	  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
	    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
	  };
	
	  Popup.prototype.getPopupElement = function getPopupElement() {
	    var _this2 = this;
	
	    var savePopupRef = this.savePopupRef;
	    var _state = this.state,
	        stretchChecked = _state.stretchChecked,
	        targetHeight = _state.targetHeight,
	        targetWidth = _state.targetWidth;
	    var _props = this.props,
	        align = _props.align,
	        visible = _props.visible,
	        prefixCls = _props.prefixCls,
	        style = _props.style,
	        getClassNameFromAlign = _props.getClassNameFromAlign,
	        destroyPopupOnHide = _props.destroyPopupOnHide,
	        stretch = _props.stretch,
	        children = _props.children,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseLeave = _props.onMouseLeave,
	        onMouseDown = _props.onMouseDown,
	        onTouchStart = _props.onTouchStart;
	
	    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
	    var hiddenClassName = prefixCls + '-hidden';
	
	    if (!visible) {
	      this.currentAlignClassName = null;
	    }
	
	    var sizeStyle = {};
	    if (stretch) {
	      // Stretch with target
	      if (stretch.indexOf('height') !== -1) {
	        sizeStyle.height = targetHeight;
	      } else if (stretch.indexOf('minHeight') !== -1) {
	        sizeStyle.minHeight = targetHeight;
	      }
	      if (stretch.indexOf('width') !== -1) {
	        sizeStyle.width = targetWidth;
	      } else if (stretch.indexOf('minWidth') !== -1) {
	        sizeStyle.minWidth = targetWidth;
	      }
	
	      // Delay force align to makes ui smooth
	      if (!stretchChecked) {
	        sizeStyle.visibility = 'hidden';
	        setTimeout(function () {
	          if (_this2.alignInstance) {
	            _this2.alignInstance.forceAlign();
	          }
	        }, 0);
	      }
	    }
	
	    var newStyle = (0, _extends3['default'])({}, sizeStyle, style, this.getZIndexStyle());
	
	    var popupInnerProps = {
	      className: className,
	      prefixCls: prefixCls,
	      ref: savePopupRef,
	      onMouseEnter: onMouseEnter,
	      onMouseLeave: onMouseLeave,
	      onMouseDown: onMouseDown,
	      onTouchStart: onTouchStart,
	      style: newStyle
	    };
	    if (destroyPopupOnHide) {
	      return _react2['default'].createElement(
	        _rcAnimate2['default'],
	        {
	          component: '',
	          exclusive: true,
	          transitionAppear: true,
	          transitionName: this.getTransitionName()
	        },
	        visible ? _react2['default'].createElement(
	          _rcAlign2['default'],
	          {
	            target: this.getAlignTarget(),
	            key: 'popup',
	            ref: this.saveAlignRef,
	            monitorWindowResize: true,
	            align: align,
	            onAlign: this.onAlign
	          },
	          _react2['default'].createElement(
	            _PopupInner2['default'],
	            (0, _extends3['default'])({
	              visible: true
	            }, popupInnerProps),
	            children
	          )
	        ) : null
	      );
	    }
	
	    return _react2['default'].createElement(
	      _rcAnimate2['default'],
	      {
	        component: '',
	        exclusive: true,
	        transitionAppear: true,
	        transitionName: this.getTransitionName(),
	        showProp: 'xVisible'
	      },
	      _react2['default'].createElement(
	        _rcAlign2['default'],
	        {
	          target: this.getAlignTarget(),
	          key: 'popup',
	          ref: this.saveAlignRef,
	          monitorWindowResize: true,
	          xVisible: visible,
	          childrenProps: { visible: 'xVisible' },
	          disabled: !visible,
	          align: align,
	          onAlign: this.onAlign
	        },
	        _react2['default'].createElement(
	          _PopupInner2['default'],
	          (0, _extends3['default'])({
	            hiddenClassName: hiddenClassName
	          }, popupInnerProps),
	          children
	        )
	      )
	    );
	  };
	
	  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
	    var style = {};
	    var props = this.props;
	    if (props.zIndex !== undefined) {
	      style.zIndex = props.zIndex;
	    }
	    return style;
	  };
	
	  Popup.prototype.getMaskElement = function getMaskElement() {
	    var props = this.props;
	    var maskElement = void 0;
	    if (props.mask) {
	      var maskTransition = this.getMaskTransitionName();
	      maskElement = _react2['default'].createElement(_LazyRenderBox2['default'], {
	        style: this.getZIndexStyle(),
	        key: 'mask',
	        className: props.prefixCls + '-mask',
	        hiddenClassName: props.prefixCls + '-mask-hidden',
	        visible: props.visible
	      });
	      if (maskTransition) {
	        maskElement = _react2['default'].createElement(
	          _rcAnimate2['default'],
	          {
	            key: 'mask',
	            showProp: 'visible',
	            transitionAppear: true,
	            component: '',
	            transitionName: maskTransition
	          },
	          maskElement
	        );
	      }
	    }
	    return maskElement;
	  };
	
	  Popup.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      this.getMaskElement(),
	      this.getPopupElement()
	    );
	  };
	
	  return Popup;
	}(_react.Component);
	
	Popup.propTypes = {
	  visible: _propTypes2['default'].bool,
	  style: _propTypes2['default'].object,
	  getClassNameFromAlign: _propTypes2['default'].func,
	  onAlign: _propTypes2['default'].func,
	  getRootDomNode: _propTypes2['default'].func,
	  align: _propTypes2['default'].any,
	  destroyPopupOnHide: _propTypes2['default'].bool,
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  onMouseDown: _propTypes2['default'].func,
	  onTouchStart: _propTypes2['default'].func,
	  stretch: _propTypes2['default'].string,
	  children: _propTypes2['default'].node,
	  point: _propTypes2['default'].shape({
	    pageX: _propTypes2['default'].number,
	    pageY: _propTypes2['default'].number
	  })
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.onAlign = function (popupDomNode, align) {
	    var props = _this3.props;
	    var currentAlignClassName = props.getClassNameFromAlign(align);
	    // FIX: https://github.com/react-component/trigger/issues/56
	    // FIX: https://github.com/react-component/tooltip/issues/79
	    if (_this3.currentAlignClassName !== currentAlignClassName) {
	      _this3.currentAlignClassName = currentAlignClassName;
	      popupDomNode.className = _this3.getClassName(currentAlignClassName);
	    }
	    props.onAlign(popupDomNode, align);
	  };
	
	  this.setStretchSize = function () {
	    var _props2 = _this3.props,
	        stretch = _props2.stretch,
	        getRootDomNode = _props2.getRootDomNode,
	        visible = _props2.visible;
	    var _state2 = _this3.state,
	        stretchChecked = _state2.stretchChecked,
	        targetHeight = _state2.targetHeight,
	        targetWidth = _state2.targetWidth;
	
	
	    if (!stretch || !visible) {
	      if (stretchChecked) {
	        _this3.setState({ stretchChecked: false });
	      }
	      return;
	    }
	
	    var $ele = getRootDomNode();
	    if (!$ele) return;
	
	    var height = $ele.offsetHeight;
	    var width = $ele.offsetWidth;
	
	    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
	      _this3.setState({
	        stretchChecked: true,
	        targetHeight: height,
	        targetWidth: width
	      });
	    }
	  };
	
	  this.getTargetElement = function () {
	    return _this3.props.getRootDomNode();
	  };
	
	  this.getAlignTarget = function () {
	    var point = _this3.props.point;
	
	    if (point) {
	      return point;
	    }
	    return _this3.getTargetElement;
	  };
	};
	
	exports['default'] = Popup;
	module.exports = exports['default'];

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(49);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(51);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(50);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LazyRenderBox = __webpack_require__(401);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PopupInner = function (_Component) {
	  (0, _inherits3['default'])(PopupInner, _Component);
	
	  function PopupInner() {
	    (0, _classCallCheck3['default'])(this, PopupInner);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  PopupInner.prototype.render = function render() {
	    var props = this.props;
	    var className = props.className;
	    if (!props.visible) {
	      className += ' ' + props.hiddenClassName;
	    }
	    return _react2['default'].createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: props.onMouseEnter,
	        onMouseLeave: props.onMouseLeave,
	        onMouseDown: props.onMouseDown,
	        onTouchStart: props.onTouchStart,
	        style: props.style
	      },
	      _react2['default'].createElement(
	        _LazyRenderBox2['default'],
	        { className: props.prefixCls + '-content', visible: props.visible },
	        props.children
	      )
	    );
	  };
	
	  return PopupInner;
	}(_react.Component);
	
	PopupInner.propTypes = {
	  hiddenClassName: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  onMouseDown: _propTypes2['default'].func,
	  onTouchStart: _propTypes2['default'].func,
	  children: _propTypes2['default'].any
	};
	exports['default'] = PopupInner;
	module.exports = exports['default'];

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(104);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(49);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(51);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(50);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactLifecyclesCompat = __webpack_require__(45);
	
	var _contains = __webpack_require__(404);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _addEventListener = __webpack_require__(403);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ContainerRender = __webpack_require__(723);
	
	var _ContainerRender2 = _interopRequireDefault(_ContainerRender);
	
	var _Portal = __webpack_require__(724);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(402);
	
	var _Popup = __webpack_require__(720);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function returnEmptyString() {
	  return '';
	}
	
	function returnDocument() {
	  return window.document;
	}
	
	var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];
	
	var IS_REACT_16 = !!_reactDom.createPortal;
	
	var contextTypes = {
	  rcTrigger: _propTypes2['default'].shape({
	    onPopupMouseDown: _propTypes2['default'].func
	  })
	};
	
	var Trigger = function (_React$Component) {
	  (0, _inherits3['default'])(Trigger, _React$Component);
	
	  function Trigger(props) {
	    (0, _classCallCheck3['default'])(this, Trigger);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var popupVisible = void 0;
	    if ('popupVisible' in props) {
	      popupVisible = !!props.popupVisible;
	    } else {
	      popupVisible = !!props.defaultPopupVisible;
	    }
	
	    _this.state = {
	      prevPopupVisible: popupVisible,
	      popupVisible: popupVisible
	    };
	
	    ALL_HANDLERS.forEach(function (h) {
	      _this['fire' + h] = function (e) {
	        _this.fireEvents(h, e);
	      };
	    });
	    return _this;
	  }
	
	  Trigger.prototype.getChildContext = function getChildContext() {
	    return {
	      rcTrigger: {
	        onPopupMouseDown: this.onPopupMouseDown
	      }
	    };
	  };
	
	  Trigger.prototype.componentDidMount = function componentDidMount() {
	    this.componentDidUpdate({}, {
	      popupVisible: this.state.popupVisible
	    });
	  };
	
	  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
	    var props = this.props;
	    var state = this.state;
	    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
	      if (prevState.popupVisible !== state.popupVisible) {
	        props.afterPopupVisibleChange(state.popupVisible);
	      }
	    };
	    if (!IS_REACT_16) {
	      this.renderComponent(null, triggerAfterPopupVisibleChange);
	    }
	
	    // We must listen to `mousedown` or `touchstart`, edge case:
	    // https://github.com/ant-design/ant-design/issues/5804
	    // https://github.com/react-component/calendar/issues/250
	    // https://github.com/react-component/trigger/issues/50
	    if (state.popupVisible) {
	      var currentDocument = void 0;
	      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
	        currentDocument = props.getDocument();
	        this.clickOutsideHandler = (0, _addEventListener2['default'])(currentDocument, 'mousedown', this.onDocumentClick);
	      }
	      // always hide on mobile
	      if (!this.touchOutsideHandler) {
	        currentDocument = currentDocument || props.getDocument();
	        this.touchOutsideHandler = (0, _addEventListener2['default'])(currentDocument, 'touchstart', this.onDocumentClick);
	      }
	      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
	      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
	        currentDocument = currentDocument || props.getDocument();
	        this.contextMenuOutsideHandler1 = (0, _addEventListener2['default'])(currentDocument, 'scroll', this.onContextMenuClose);
	      }
	      // close popup when trigger type contains 'onContextMenu' and window is blur.
	      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
	        this.contextMenuOutsideHandler2 = (0, _addEventListener2['default'])(window, 'blur', this.onContextMenuClose);
	      }
	      return;
	    }
	
	    this.clearOutsideHandler();
	  };
	
	  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.clearDelayTimer();
	    this.clearOutsideHandler();
	    clearTimeout(this.mouseDownTimeout);
	  };
	
	  Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var popupVisible = _ref.popupVisible;
	
	    var newState = {};
	
	    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
	      newState.popupVisible = popupVisible;
	      newState.prevPopupVisible = prevState.popupVisible;
	    }
	
	    return newState;
	  };
	
	  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
	    // for test
	    if (this._component && this._component.getPopupDomNode) {
	      return this._component.getPopupDomNode();
	    }
	    return null;
	  };
	
	  Trigger.prototype.getPopupAlign = function getPopupAlign() {
	    var props = this.props;
	    var popupPlacement = props.popupPlacement,
	        popupAlign = props.popupAlign,
	        builtinPlacements = props.builtinPlacements;
	
	    if (popupPlacement && builtinPlacements) {
	      return (0, _utils.getAlignFromPlacement)(builtinPlacements, popupPlacement, popupAlign);
	    }
	    return popupAlign;
	  };
	
	  /**
	   * @param popupVisible    Show or not the popup element
	   * @param event           SyntheticEvent, used for `pointAlign`
	   */
	  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
	    var alignPoint = this.props.alignPoint;
	    var prevPopupVisible = this.state.popupVisible;
	
	
	    this.clearDelayTimer();
	
	    if (prevPopupVisible !== popupVisible) {
	      if (!('popupVisible' in this.props)) {
	        this.setState({ popupVisible: popupVisible, prevPopupVisible: prevPopupVisible });
	      }
	      this.props.onPopupVisibleChange(popupVisible);
	    }
	
	    // Always record the point position since mouseEnterDelay will delay the show
	    if (alignPoint && event) {
	      this.setPoint(event);
	    }
	  };
	
	  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
	    var _this2 = this;
	
	    var delay = delayS * 1000;
	    this.clearDelayTimer();
	    if (delay) {
	      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
	      this.delayTimer = setTimeout(function () {
	        _this2.setPopupVisible(visible, point);
	        _this2.clearDelayTimer();
	      }, delay);
	    } else {
	      this.setPopupVisible(visible, event);
	    }
	  };
	
	  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
	    if (this.delayTimer) {
	      clearTimeout(this.delayTimer);
	      this.delayTimer = null;
	    }
	  };
	
	  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
	    if (this.clickOutsideHandler) {
	      this.clickOutsideHandler.remove();
	      this.clickOutsideHandler = null;
	    }
	
	    if (this.contextMenuOutsideHandler1) {
	      this.contextMenuOutsideHandler1.remove();
	      this.contextMenuOutsideHandler1 = null;
	    }
	
	    if (this.contextMenuOutsideHandler2) {
	      this.contextMenuOutsideHandler2.remove();
	      this.contextMenuOutsideHandler2 = null;
	    }
	
	    if (this.touchOutsideHandler) {
	      this.touchOutsideHandler.remove();
	      this.touchOutsideHandler = null;
	    }
	  };
	
	  Trigger.prototype.createTwoChains = function createTwoChains(event) {
	    var childPros = this.props.children.props;
	    var props = this.props;
	    if (childPros[event] && props[event]) {
	      return this['fire' + event];
	    }
	    return childPros[event] || props[event];
	  };
	
	  Trigger.prototype.isClickToShow = function isClickToShow() {
	    var _props = this.props,
	        action = _props.action,
	        showAction = _props.showAction;
	
	    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
	  };
	
	  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
	    var _props2 = this.props,
	        action = _props2.action,
	        showAction = _props2.showAction;
	
	    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
	  };
	
	  Trigger.prototype.isClickToHide = function isClickToHide() {
	    var _props3 = this.props,
	        action = _props3.action,
	        hideAction = _props3.hideAction;
	
	    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
	  };
	
	  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
	    var _props4 = this.props,
	        action = _props4.action,
	        showAction = _props4.showAction;
	
	    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
	  };
	
	  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
	    var _props5 = this.props,
	        action = _props5.action,
	        hideAction = _props5.hideAction;
	
	    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
	  };
	
	  Trigger.prototype.isFocusToShow = function isFocusToShow() {
	    var _props6 = this.props,
	        action = _props6.action,
	        showAction = _props6.showAction;
	
	    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
	  };
	
	  Trigger.prototype.isBlurToHide = function isBlurToHide() {
	    var _props7 = this.props,
	        action = _props7.action,
	        hideAction = _props7.hideAction;
	
	    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
	  };
	
	  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
	    if (this.state.popupVisible && this._component && this._component.alignInstance) {
	      this._component.alignInstance.forceAlign();
	    }
	  };
	
	  Trigger.prototype.fireEvents = function fireEvents(type, e) {
	    var childCallback = this.props.children.props[type];
	    if (childCallback) {
	      childCallback(e);
	    }
	    var callback = this.props[type];
	    if (callback) {
	      callback(e);
	    }
	  };
	
	  Trigger.prototype.close = function close() {
	    this.setPopupVisible(false);
	  };
	
	  Trigger.prototype.render = function render() {
	    var _this3 = this;
	
	    var popupVisible = this.state.popupVisible;
	    var _props8 = this.props,
	        children = _props8.children,
	        forceRender = _props8.forceRender,
	        alignPoint = _props8.alignPoint,
	        className = _props8.className;
	
	    var child = _react2['default'].Children.only(children);
	    var newChildProps = { key: 'trigger' };
	
	    if (this.isContextMenuToShow()) {
	      newChildProps.onContextMenu = this.onContextMenu;
	    } else {
	      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
	    }
	
	    if (this.isClickToHide() || this.isClickToShow()) {
	      newChildProps.onClick = this.onClick;
	      newChildProps.onMouseDown = this.onMouseDown;
	      newChildProps.onTouchStart = this.onTouchStart;
	    } else {
	      newChildProps.onClick = this.createTwoChains('onClick');
	      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
	      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
	    }
	    if (this.isMouseEnterToShow()) {
	      newChildProps.onMouseEnter = this.onMouseEnter;
	      if (alignPoint) {
	        newChildProps.onMouseMove = this.onMouseMove;
	      }
	    } else {
	      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
	    }
	    if (this.isMouseLeaveToHide()) {
	      newChildProps.onMouseLeave = this.onMouseLeave;
	    } else {
	      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
	    }
	    if (this.isFocusToShow() || this.isBlurToHide()) {
	      newChildProps.onFocus = this.onFocus;
	      newChildProps.onBlur = this.onBlur;
	    } else {
	      newChildProps.onFocus = this.createTwoChains('onFocus');
	      newChildProps.onBlur = this.createTwoChains('onBlur');
	    }
	
	    var childrenClassName = (0, _classnames2['default'])(child && child.props && child.props.className, className);
	    if (childrenClassName) {
	      newChildProps.className = childrenClassName;
	    }
	    var trigger = _react2['default'].cloneElement(child, newChildProps);
	
	    if (!IS_REACT_16) {
	      return _react2['default'].createElement(
	        _ContainerRender2['default'],
	        {
	          parent: this,
	          visible: popupVisible,
	          autoMount: false,
	          forceRender: forceRender,
	          getComponent: this.getComponent,
	          getContainer: this.getContainer
	        },
	        function (_ref2) {
	          var renderComponent = _ref2.renderComponent;
	
	          _this3.renderComponent = renderComponent;
	          return trigger;
	        }
	      );
	    }
	
	    var portal = void 0;
	    // prevent unmounting after it's rendered
	    if (popupVisible || this._component || forceRender) {
	      portal = _react2['default'].createElement(
	        _Portal2['default'],
	        { key: 'portal', getContainer: this.getContainer, didUpdate: this.handlePortalUpdate },
	        this.getComponent()
	      );
	    }
	
	    return [trigger, portal];
	  };
	
	  return Trigger;
	}(_react2['default'].Component);
	
	Trigger.propTypes = {
	  children: _propTypes2['default'].any,
	  action: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].arrayOf(_propTypes2['default'].string)]),
	  showAction: _propTypes2['default'].any,
	  hideAction: _propTypes2['default'].any,
	  getPopupClassNameFromAlign: _propTypes2['default'].any,
	  onPopupVisibleChange: _propTypes2['default'].func,
	  afterPopupVisibleChange: _propTypes2['default'].func,
	  popup: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	  popupStyle: _propTypes2['default'].object,
	  prefixCls: _propTypes2['default'].string,
	  popupClassName: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  popupPlacement: _propTypes2['default'].string,
	  builtinPlacements: _propTypes2['default'].object,
	  popupTransitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  popupAnimation: _propTypes2['default'].any,
	  mouseEnterDelay: _propTypes2['default'].number,
	  mouseLeaveDelay: _propTypes2['default'].number,
	  zIndex: _propTypes2['default'].number,
	  focusDelay: _propTypes2['default'].number,
	  blurDelay: _propTypes2['default'].number,
	  getPopupContainer: _propTypes2['default'].func,
	  getDocument: _propTypes2['default'].func,
	  forceRender: _propTypes2['default'].bool,
	  destroyPopupOnHide: _propTypes2['default'].bool,
	  mask: _propTypes2['default'].bool,
	  maskClosable: _propTypes2['default'].bool,
	  onPopupAlign: _propTypes2['default'].func,
	  popupAlign: _propTypes2['default'].object,
	  popupVisible: _propTypes2['default'].bool,
	  defaultPopupVisible: _propTypes2['default'].bool,
	  maskTransitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  maskAnimation: _propTypes2['default'].string,
	  stretch: _propTypes2['default'].string,
	  alignPoint: _propTypes2['default'].bool // Maybe we can support user pass position in the future
	};
	Trigger.contextTypes = contextTypes;
	Trigger.childContextTypes = contextTypes;
	Trigger.defaultProps = {
	  prefixCls: 'rc-trigger-popup',
	  getPopupClassNameFromAlign: returnEmptyString,
	  getDocument: returnDocument,
	  onPopupVisibleChange: noop,
	  afterPopupVisibleChange: noop,
	  onPopupAlign: noop,
	  popupClassName: '',
	  mouseEnterDelay: 0,
	  mouseLeaveDelay: 0.1,
	  focusDelay: 0,
	  blurDelay: 0.15,
	  popupStyle: {},
	  destroyPopupOnHide: false,
	  popupAlign: {},
	  defaultPopupVisible: false,
	  mask: false,
	  maskClosable: true,
	  action: [],
	  showAction: [],
	  hideAction: []
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.onMouseEnter = function (e) {
	    var mouseEnterDelay = _this4.props.mouseEnterDelay;
	
	    _this4.fireEvents('onMouseEnter', e);
	    _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
	  };
	
	  this.onMouseMove = function (e) {
	    _this4.fireEvents('onMouseMove', e);
	    _this4.setPoint(e);
	  };
	
	  this.onMouseLeave = function (e) {
	    _this4.fireEvents('onMouseLeave', e);
	    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
	  };
	
	  this.onPopupMouseEnter = function () {
	    _this4.clearDelayTimer();
	  };
	
	  this.onPopupMouseLeave = function (e) {
	    // https://github.com/react-component/trigger/pull/13
	    // react bug?
	    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && (0, _contains2['default'])(_this4._component.getPopupDomNode(), e.relatedTarget)) {
	      return;
	    }
	    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
	  };
	
	  this.onFocus = function (e) {
	    _this4.fireEvents('onFocus', e);
	    // incase focusin and focusout
	    _this4.clearDelayTimer();
	    if (_this4.isFocusToShow()) {
	      _this4.focusTime = Date.now();
	      _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
	    }
	  };
	
	  this.onMouseDown = function (e) {
	    _this4.fireEvents('onMouseDown', e);
	    _this4.preClickTime = Date.now();
	  };
	
	  this.onTouchStart = function (e) {
	    _this4.fireEvents('onTouchStart', e);
	    _this4.preTouchTime = Date.now();
	  };
	
	  this.onBlur = function (e) {
	    _this4.fireEvents('onBlur', e);
	    _this4.clearDelayTimer();
	    if (_this4.isBlurToHide()) {
	      _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
	    }
	  };
	
	  this.onContextMenu = function (e) {
	    e.preventDefault();
	    _this4.fireEvents('onContextMenu', e);
	    _this4.setPopupVisible(true, e);
	  };
	
	  this.onContextMenuClose = function () {
	    if (_this4.isContextMenuToShow()) {
	      _this4.close();
	    }
	  };
	
	  this.onClick = function (event) {
	    _this4.fireEvents('onClick', event);
	    // focus will trigger click
	    if (_this4.focusTime) {
	      var preTime = void 0;
	      if (_this4.preClickTime && _this4.preTouchTime) {
	        preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
	      } else if (_this4.preClickTime) {
	        preTime = _this4.preClickTime;
	      } else if (_this4.preTouchTime) {
	        preTime = _this4.preTouchTime;
	      }
	      if (Math.abs(preTime - _this4.focusTime) < 20) {
	        return;
	      }
	      _this4.focusTime = 0;
	    }
	    _this4.preClickTime = 0;
	    _this4.preTouchTime = 0;
	
	    // Only prevent default when all the action is click.
	    // https://github.com/ant-design/ant-design/issues/17043
	    // https://github.com/ant-design/ant-design/issues/17291
	    if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) {
	      event.preventDefault();
	    }
	    var nextVisible = !_this4.state.popupVisible;
	    if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
	      _this4.setPopupVisible(!_this4.state.popupVisible, event);
	    }
	  };
	
	  this.onPopupMouseDown = function () {
	    var _context$rcTrigger = _this4.context.rcTrigger,
	        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;
	
	    _this4.hasPopupMouseDown = true;
	
	    clearTimeout(_this4.mouseDownTimeout);
	    _this4.mouseDownTimeout = setTimeout(function () {
	      _this4.hasPopupMouseDown = false;
	    }, 0);
	
	    if (rcTrigger.onPopupMouseDown) {
	      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
	    }
	  };
	
	  this.onDocumentClick = function (event) {
	    if (_this4.props.mask && !_this4.props.maskClosable) {
	      return;
	    }
	
	    var target = event.target;
	    var root = (0, _reactDom.findDOMNode)(_this4);
	    if (!(0, _contains2['default'])(root, target) && !_this4.hasPopupMouseDown) {
	      _this4.close();
	    }
	  };
	
	  this.getRootDomNode = function () {
	    return (0, _reactDom.findDOMNode)(_this4);
	  };
	
	  this.getPopupClassNameFromAlign = function (align) {
	    var className = [];
	    var _props9 = _this4.props,
	        popupPlacement = _props9.popupPlacement,
	        builtinPlacements = _props9.builtinPlacements,
	        prefixCls = _props9.prefixCls,
	        alignPoint = _props9.alignPoint,
	        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;
	
	    if (popupPlacement && builtinPlacements) {
	      className.push((0, _utils.getAlignPopupClassName)(builtinPlacements, prefixCls, align, alignPoint));
	    }
	    if (getPopupClassNameFromAlign) {
	      className.push(getPopupClassNameFromAlign(align));
	    }
	    return className.join(' ');
	  };
	
	  this.getComponent = function () {
	    var _props10 = _this4.props,
	        prefixCls = _props10.prefixCls,
	        destroyPopupOnHide = _props10.destroyPopupOnHide,
	        popupClassName = _props10.popupClassName,
	        action = _props10.action,
	        onPopupAlign = _props10.onPopupAlign,
	        popupAnimation = _props10.popupAnimation,
	        popupTransitionName = _props10.popupTransitionName,
	        popupStyle = _props10.popupStyle,
	        mask = _props10.mask,
	        maskAnimation = _props10.maskAnimation,
	        maskTransitionName = _props10.maskTransitionName,
	        zIndex = _props10.zIndex,
	        popup = _props10.popup,
	        stretch = _props10.stretch,
	        alignPoint = _props10.alignPoint;
	    var _state = _this4.state,
	        popupVisible = _state.popupVisible,
	        point = _state.point;
	
	
	    var align = _this4.getPopupAlign();
	
	    var mouseProps = {};
	    if (_this4.isMouseEnterToShow()) {
	      mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
	    }
	    if (_this4.isMouseLeaveToHide()) {
	      mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
	    }
	
	    mouseProps.onMouseDown = _this4.onPopupMouseDown;
	    mouseProps.onTouchStart = _this4.onPopupMouseDown;
	
	    return _react2['default'].createElement(
	      _Popup2['default'],
	      (0, _extends3['default'])({
	        prefixCls: prefixCls,
	        destroyPopupOnHide: destroyPopupOnHide,
	        visible: popupVisible,
	        point: alignPoint && point,
	        className: popupClassName,
	        action: action,
	        align: align,
	        onAlign: onPopupAlign,
	        animation: popupAnimation,
	        getClassNameFromAlign: _this4.getPopupClassNameFromAlign
	      }, mouseProps, {
	        stretch: stretch,
	        getRootDomNode: _this4.getRootDomNode,
	        style: popupStyle,
	        mask: mask,
	        zIndex: zIndex,
	        transitionName: popupTransitionName,
	        maskAnimation: maskAnimation,
	        maskTransitionName: maskTransitionName,
	        ref: _this4.savePopup
	      }),
	      typeof popup === 'function' ? popup() : popup
	    );
	  };
	
	  this.getContainer = function () {
	    var props = _this4.props;
	
	    var popupContainer = document.createElement('div');
	    // Make sure default popup container will never cause scrollbar appearing
	    // https://github.com/react-component/trigger/issues/41
	    popupContainer.style.position = 'absolute';
	    popupContainer.style.top = '0';
	    popupContainer.style.left = '0';
	    popupContainer.style.width = '100%';
	    var mountNode = props.getPopupContainer ? props.getPopupContainer((0, _reactDom.findDOMNode)(_this4)) : props.getDocument().body;
	    mountNode.appendChild(popupContainer);
	    return popupContainer;
	  };
	
	  this.setPoint = function (point) {
	    var alignPoint = _this4.props.alignPoint;
	
	    if (!alignPoint || !point) return;
	
	    _this4.setState({
	      point: {
	        pageX: point.pageX,
	        pageY: point.pageY
	      }
	    });
	  };
	
	  this.handlePortalUpdate = function () {
	    if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) {
	      _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
	    }
	  };
	
	  this.savePopup = function (node) {
	    _this4._component = node;
	  };
	};
	
	(0, _reactLifecyclesCompat.polyfill)(Trigger);
	
	exports['default'] = Trigger;
	module.exports = exports['default'];

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(23));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var ContainerRender = /*#__PURE__*/function (_React$Component) {
	  _inherits(ContainerRender, _React$Component);
	
	  var _super = _createSuper(ContainerRender);
	
	  function ContainerRender() {
	    var _this;
	
	    _classCallCheck(this, ContainerRender);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _this.removeContainer = function () {
	      if (_this.container) {
	        _reactDom.default.unmountComponentAtNode(_this.container);
	
	        _this.container.parentNode.removeChild(_this.container);
	
	        _this.container = null;
	      }
	    };
	
	    _this.renderComponent = function (props, ready) {
	      var _this$props = _this.props,
	          visible = _this$props.visible,
	          getComponent = _this$props.getComponent,
	          forceRender = _this$props.forceRender,
	          getContainer = _this$props.getContainer,
	          parent = _this$props.parent;
	
	      if (visible || parent._component || forceRender) {
	        if (!_this.container) {
	          _this.container = getContainer();
	        }
	
	        _reactDom.default.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
	          if (ready) {
	            ready.call(this);
	          }
	        });
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(ContainerRender, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.autoMount) {
	        this.renderComponent();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.props.autoMount) {
	        this.renderComponent();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.props.autoDestroy) {
	        this.removeContainer();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children({
	        renderComponent: this.renderComponent,
	        removeContainer: this.removeContainer
	      });
	    }
	  }]);
	
	  return ContainerRender;
	}(_react.default.Component);
	
	exports.default = ContainerRender;
	ContainerRender.propTypes = {
	  autoMount: _propTypes.default.bool,
	  autoDestroy: _propTypes.default.bool,
	  visible: _propTypes.default.bool,
	  forceRender: _propTypes.default.bool,
	  parent: _propTypes.default.any,
	  getComponent: _propTypes.default.func.isRequired,
	  getContainer: _propTypes.default.func.isRequired,
	  children: _propTypes.default.func.isRequired
	};
	ContainerRender.defaultProps = {
	  autoMount: true,
	  autoDestroy: true,
	  forceRender: false
	};

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(23));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var Portal = /*#__PURE__*/function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  var _super = _createSuper(Portal);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(Portal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.createContainer();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var didUpdate = this.props.didUpdate;
	
	      if (didUpdate) {
	        didUpdate(prevProps);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.removeContainer();
	    }
	  }, {
	    key: "createContainer",
	    value: function createContainer() {
	      this._container = this.props.getContainer();
	      this.forceUpdate();
	    }
	  }, {
	    key: "removeContainer",
	    value: function removeContainer() {
	      if (this._container) {
	        this._container.parentNode.removeChild(this._container);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this._container) {
	        return _reactDom.default.createPortal(this.props.children, this._container);
	      }
	
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react.default.Component);
	
	exports.default = Portal;
	Portal.propTypes = {
	  getContainer: _propTypes.default.func.isRequired,
	  children: _propTypes.default.node.isRequired,
	  didUpdate: _propTypes.default.func
	};

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  } // only handle componentWillReceiveProps
	
	
	  if (typeof prototype.componentWillReceiveProps !== 'function') {
	    return Component;
	  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
	  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler
	
	
	  if (!_react.default.Profiler) {
	    return Component;
	  } // Here polyfill get started
	
	
	  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
	  delete prototype.componentWillReceiveProps;
	  return Component;
	};
	
	var _default = unsafeLifecyclesPolyfill;
	exports.default = _default;

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.startLoadingScripts = startLoadingScripts;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(151);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _utils = __webpack_require__(727);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var loadedScript = [];
	var pendingScripts = {};
	var failedScript = [];
	
	function startLoadingScripts(scripts) {
	  var onComplete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils.noop;
	
	  // sequence load
	  var loadNewScript = function loadNewScript(src) {
	    if (loadedScript.indexOf(src) < 0) {
	      return function (taskComplete) {
	        var callbacks = pendingScripts[src] || [];
	        callbacks.push(taskComplete);
	        pendingScripts[src] = callbacks;
	        if (callbacks.length === 1) {
	          return (0, _utils.newScript)(src)(function (err) {
	            pendingScripts[src].forEach(function (cb) {
	              return cb(err, src);
	            });
	            delete pendingScripts[src];
	          });
	        }
	      };
	    }
	  };
	  var tasks = scripts.map(function (src) {
	    if (Array.isArray(src)) {
	      return src.map(loadNewScript);
	    } else return loadNewScript(src);
	  });
	
	  _utils.series.apply(undefined, _toConsumableArray(tasks))(function (err, src) {
	    if (err) {
	      failedScript.push(src);
	    } else {
	      if (Array.isArray(src)) {
	        src.forEach(addCache);
	      } else addCache(src);
	    }
	  })(function (err) {
	    removeFailedScript();
	    onComplete(err);
	  });
	}
	
	var addCache = function addCache(entry) {
	  if (loadedScript.indexOf(entry) < 0) {
	    loadedScript.push(entry);
	  }
	};
	
	var removeFailedScript = function removeFailedScript() {
	  if (failedScript.length > 0) {
	    failedScript.forEach(function (script) {
	      var node = document.querySelector('script[src=\'' + script + '\']');
	      if (node != null) {
	        node.parentNode.removeChild(node);
	      }
	    });
	
	    failedScript = [];
	  }
	};
	
	var scriptLoader = function scriptLoader() {
	  for (var _len = arguments.length, scripts = Array(_len), _key = 0; _key < _len; _key++) {
	    scripts[_key] = arguments[_key];
	  }
	
	  return function (WrappedComponent) {
	    var ScriptLoader = function (_Component) {
	      _inherits(ScriptLoader, _Component);
	
	      function ScriptLoader(props, context) {
	        _classCallCheck(this, ScriptLoader);
	
	        var _this = _possibleConstructorReturn(this, (ScriptLoader.__proto__ || Object.getPrototypeOf(ScriptLoader)).call(this, props, context));
	
	        _this.state = {
	          isScriptLoaded: false,
	          isScriptLoadSucceed: false
	        };
	
	        _this._isMounted = false;
	        return _this;
	      }
	
	      _createClass(ScriptLoader, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          var _this2 = this;
	
	          this._isMounted = true;
	          startLoadingScripts(scripts, function (err) {
	            if (_this2._isMounted) {
	              _this2.setState({
	                isScriptLoaded: true,
	                isScriptLoadSucceed: !err
	              }, function () {
	                if (!err) {
	                  _this2.props.onScriptLoaded();
	                }
	              });
	            }
	          });
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          this._isMounted = false;
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var props = _extends({}, this.props, this.state);
	
	          return _react2.default.createElement(WrappedComponent, props);
	        }
	      }]);
	
	      return ScriptLoader;
	    }(_react.Component);
	
	    ScriptLoader.propTypes = {
	      onScriptLoaded: _propTypes2.default.func
	    };
	    ScriptLoader.defaultProps = {
	      onScriptLoaded: _utils.noop
	    };
	
	
	    return (0, _hoistNonReactStatics2.default)(ScriptLoader, WrappedComponent);
	  };
	};
	
	exports.default = scriptLoader;

/***/ },
/* 727 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isDefined = exports.isDefined = function isDefined(val) {
	  return val != null;
	};
	var isFunction = exports.isFunction = function isFunction(val) {
	  return typeof val === 'function';
	};
	var noop = exports.noop = function noop(_) {};
	
	var newScript = exports.newScript = function newScript(src) {
	  return function (cb) {
	    var script = document.createElement('script');
	    script.src = src;
	    script.addEventListener('load', function () {
	      return cb(null, src);
	    });
	    script.addEventListener('error', function () {
	      return cb(true, src);
	    });
	    document.body.appendChild(script);
	    return script;
	  };
	};
	
	var keyIterator = function keyIterator(cols) {
	  var keys = Object.keys(cols);
	  var i = -1;
	  return {
	    next: function next() {
	      i++; // inc
	      if (i >= keys.length) return null;else return keys[i];
	    }
	  };
	};
	
	// tasks should be a collection of thunk
	var parallel = exports.parallel = function parallel() {
	  for (var _len = arguments.length, tasks = Array(_len), _key = 0; _key < _len; _key++) {
	    tasks[_key] = arguments[_key];
	  }
	
	  return function (each) {
	    return function (cb) {
	      var hasError = false;
	      var successed = 0;
	      var ret = [];
	      tasks = tasks.filter(isFunction);
	
	      if (tasks.length <= 0) cb(null);else {
	        tasks.forEach(function (task, i) {
	          var thunk = task;
	          thunk(function (err) {
	            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	              args[_key2 - 1] = arguments[_key2];
	            }
	
	            if (err) hasError = true;else {
	              // collect result
	              if (args.length <= 1) args = args[0];
	
	              ret[i] = args;
	              successed++;
	            }
	
	            if (isFunction(each)) each.call(null, err, args, i);
	
	            if (hasError) cb(true);else if (tasks.length === successed) {
	              cb(null, ret);
	            }
	          });
	        });
	      }
	    };
	  };
	};
	
	// tasks should be a collection of thunk
	var series = exports.series = function series() {
	  for (var _len3 = arguments.length, tasks = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    tasks[_key3] = arguments[_key3];
	  }
	
	  return function (each) {
	    return function (cb) {
	      tasks = tasks.filter(function (val) {
	        return val != null;
	      });
	      var nextKey = keyIterator(tasks);
	      var nextThunk = function nextThunk() {
	        var key = nextKey.next();
	        var thunk = tasks[key];
	        if (Array.isArray(thunk)) thunk = parallel.apply(null, thunk).call(null, each);
	        return [+key, thunk]; // convert `key` to number
	      };
	      var key = void 0,
	          thunk = void 0;
	      var next = nextThunk();
	      key = next[0];
	      thunk = next[1];
	      if (thunk == null) return cb(null);
	
	      var ret = [];
	      var iterator = function iterator() {
	        thunk(function (err) {
	          for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	            args[_key4 - 1] = arguments[_key4];
	          }
	
	          if (args.length <= 1) args = args[0];
	          if (isFunction(each)) each.call(null, err, args, key);
	
	          if (err) cb(err);else {
	            // collect result
	            ret.push(args);
	
	            next = nextThunk();
	            key = next[0];
	            thunk = next[1];
	            if (thunk == null) return cb(null, ret); // finished
	            else iterator();
	          }
	        });
	      };
	      iterator();
	    };
	  };
	};

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _themrShape = __webpack_require__(730);
	
	var _themrShape2 = _interopRequireDefault(_themrShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ThemeProvider = (_temp = _class = function (_Component) {
	  _inherits(ThemeProvider, _Component);
	
	  function ThemeProvider() {
	    _classCallCheck(this, ThemeProvider);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ThemeProvider.prototype.getChildContext = function getChildContext() {
	    return {
	      themr: {
	        theme: this.props.theme
	      }
	    };
	  };
	
	  ThemeProvider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return ThemeProvider;
	}(_react.Component), _class.propTypes = {
	  children: _propTypes2.default.element.isRequired,
	  theme: _propTypes2.default.object.isRequired
	}, _class.defaultProps = {
	  theme: {}
	}, _class.childContextTypes = {
	  themr: _themrShape2.default.isRequired
	}, _temp);
	exports.default = ThemeProvider;

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.themeable = themeable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(151);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @typedef {Object.<string, TReactCSSThemrTheme>} TReactCSSThemrTheme
	 */
	
	/**
	 * @typedef {{}} TReactCSSThemrOptions
	 * @property {String|Boolean} [composeTheme=COMPOSE_DEEPLY]
	 */
	
	var COMPOSE_DEEPLY = 'deeply';
	var COMPOSE_SOFTLY = 'softly';
	var DONT_COMPOSE = false;
	
	var DEFAULT_OPTIONS = {
	  composeTheme: COMPOSE_DEEPLY,
	  mapThemrProps: defaultMapThemrProps
	};
	
	var THEMR_CONFIG = typeof Symbol !== 'undefined' ? Symbol('THEMR_CONFIG') : '__REACT_CSS_THEMR_CONFIG__';
	
	/**
	 * Themr decorator
	 * @param {String|Number|Symbol} componentName - Component name
	 * @param {TReactCSSThemrTheme} [localTheme] - Base theme
	 * @param {{}} [options] - Themr options
	 * @returns {function(ThemedComponent:Function):Function} - ThemedComponent
	 */
	
	exports.default = function (componentName, localTheme) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  return function (ThemedComponent) {
	    var _class, _temp;
	
	    var _DEFAULT_OPTIONS$opti = _extends({}, DEFAULT_OPTIONS, options),
	        optionComposeTheme = _DEFAULT_OPTIONS$opti.composeTheme,
	        optionMapThemrProps = _DEFAULT_OPTIONS$opti.mapThemrProps;
	
	    validateComposeOption(optionComposeTheme);
	
	    var config = ThemedComponent[THEMR_CONFIG];
	    if (config && config.componentName === componentName) {
	      config.localTheme = themeable(config.localTheme, localTheme);
	      return ThemedComponent;
	    }
	
	    config = {
	      componentName: componentName,
	      localTheme: localTheme
	    };
	
	    /**
	     * @property {{wrappedInstance: *}} refs
	     */
	    var Themed = (_temp = _class = function (_Component) {
	      _inherits(Themed, _Component);
	
	      function Themed() {
	        _classCallCheck(this, Themed);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        var _this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args)));
	
	        _this.theme_ = _this.calcTheme(_this.props);
	        return _this;
	      }
	
	      Themed.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(true, 'DEPRECATED: To access the wrapped instance, you have to pass ' + '{ innerRef: fn } and retrieve with a callback ref style.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Themed.prototype.getNamespacedTheme = function getNamespacedTheme(props) {
	        var themeNamespace = props.themeNamespace,
	            theme = props.theme;
	
	        if (!themeNamespace) return theme;
	        if (themeNamespace && !theme) throw new Error('Invalid themeNamespace use in react-css-themr. ' + 'themeNamespace prop should be used only with theme prop.');
	
	        return Object.keys(theme).filter(function (key) {
	          return key.startsWith(themeNamespace);
	        }).reduce(function (result, key) {
	          var _extends2;
	
	          return _extends({}, result, (_extends2 = {}, _extends2[removeNamespace(key, themeNamespace)] = theme[key], _extends2));
	        }, {});
	      };
	
	      Themed.prototype.getThemeNotComposed = function getThemeNotComposed(props) {
	        if (props.theme) return this.getNamespacedTheme(props);
	        if (config.localTheme) return config.localTheme;
	        return this.getContextTheme();
	      };
	
	      Themed.prototype.getContextTheme = function getContextTheme() {
	        return this.context.themr ? this.context.themr.theme[config.componentName] : {};
	      };
	
	      Themed.prototype.getTheme = function getTheme(props) {
	        return props.composeTheme === COMPOSE_SOFTLY ? _extends({}, this.getContextTheme(), config.localTheme, this.getNamespacedTheme(props)) : themeable(themeable(this.getContextTheme(), config.localTheme), this.getNamespacedTheme(props));
	      };
	
	      Themed.prototype.calcTheme = function calcTheme(props) {
	        var composeTheme = props.composeTheme;
	
	        return composeTheme ? this.getTheme(props) : this.getThemeNotComposed(props);
	      };
	
	      Themed.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (nextProps.composeTheme !== this.props.composeTheme || nextProps.theme !== this.props.theme || nextProps.themeNamespace !== this.props.themeNamespace) {
	          this.theme_ = this.calcTheme(nextProps);
	        }
	      };
	
	      Themed.prototype.render = function render() {
	        return _react2.default.createElement(ThemedComponent, this.props.mapThemrProps(this.props, this.theme_));
	      };
	
	      return Themed;
	    }(_react.Component), _class.displayName = 'Themed' + ThemedComponent.name, _class.contextTypes = {
	      themr: _propTypes2.default.object
	    }, _class.propTypes = _extends({}, ThemedComponent.propTypes, {
	      composeTheme: _propTypes2.default.oneOf([COMPOSE_DEEPLY, COMPOSE_SOFTLY, DONT_COMPOSE]),
	      innerRef: _propTypes2.default.func,
	      theme: _propTypes2.default.object,
	      themeNamespace: _propTypes2.default.string,
	      mapThemrProps: _propTypes2.default.func
	    }), _class.defaultProps = _extends({}, ThemedComponent.defaultProps, {
	      composeTheme: optionComposeTheme,
	      mapThemrProps: optionMapThemrProps
	    }), _temp);
	
	
	    Themed[THEMR_CONFIG] = config;
	
	    return (0, _hoistNonReactStatics2.default)(Themed, ThemedComponent);
	  };
	};
	
	/**
	 * Merges passed themes by concatenating string keys and processing nested themes
	 *
	 * @param {...TReactCSSThemrTheme} themes - Themes
	 * @returns {TReactCSSThemrTheme} - Resulting theme
	 */
	
	
	function themeable() {
	  for (var _len2 = arguments.length, themes = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    themes[_key2] = arguments[_key2];
	  }
	
	  return themes.reduce(function (acc, theme) {
	    return merge(acc, theme);
	  }, {});
	}
	
	/**
	 * @param {TReactCSSThemrTheme} [original] - Original theme
	 * @param {TReactCSSThemrTheme} [mixin] - Mixin theme
	 * @returns {TReactCSSThemrTheme} - resulting theme
	 */
	function merge() {
	  var original = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var mixin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  //make a copy to avoid mutations of nested objects
	  //also strip all functions injected by isomorphic-style-loader
	  var result = Object.keys(original).reduce(function (acc, key) {
	    var value = original[key];
	    if (typeof value !== 'function') {
	      acc[key] = value;
	    }
	    return acc;
	  }, {});
	
	  //traverse mixin keys and merge them to resulting theme
	  Object.keys(mixin).forEach(function (key) {
	    //there's no need to set any defaults here
	    var originalValue = result[key];
	    var mixinValue = mixin[key];
	
	    switch (typeof mixinValue === 'undefined' ? 'undefined' : _typeof(mixinValue)) {
	      case 'object':
	        {
	          //possibly nested theme object
	          switch (typeof originalValue === 'undefined' ? 'undefined' : _typeof(originalValue)) {
	            case 'object':
	              {
	                //exactly nested theme object - go recursive
	                result[key] = merge(originalValue, mixinValue);
	                break;
	              }
	
	            case 'undefined':
	              {
	                //original does not contain this nested key - just take it as is
	                result[key] = mixinValue;
	                break;
	              }
	
	            default:
	              {
	                //can't merge an object with a non-object
	                throw new Error('You are merging object ' + key + ' with a non-object ' + originalValue);
	              }
	          }
	          break;
	        }
	
	      case 'undefined': //fallthrough - handles accidentally unset values which may come from props
	      case 'function':
	        {
	          //this handles issue when isomorphic-style-loader addes helper functions to css-module
	          break; //just skip
	        }
	
	      default:
	        {
	          //plain values
	          switch (typeof originalValue === 'undefined' ? 'undefined' : _typeof(originalValue)) {
	            case 'object':
	              {
	                //can't merge a non-object with an object
	                throw new Error('You are merging non-object ' + mixinValue + ' with an object ' + key);
	              }
	
	            case 'undefined':
	              {
	                //mixin key is new to original theme - take it as is
	                result[key] = mixinValue;
	                break;
	              }
	            case 'function':
	              {
	                //this handles issue when isomorphic-style-loader addes helper functions to css-module
	                break; //just skip
	              }
	
	            default:
	              {
	                //finally we can merge
	                result[key] = originalValue.split(' ').concat(mixinValue.split(' ')).filter(function (item, pos, self) {
	                  return self.indexOf(item) === pos && item !== '';
	                }).join(' ');
	                break;
	              }
	          }
	          break;
	        }
	    }
	  });
	
	  return result;
	}
	
	/**
	 * Validates compose option
	 *
	 * @param {String|Boolean} composeTheme - Compose them option
	 * @throws
	 * @returns {undefined}
	 */
	function validateComposeOption(composeTheme) {
	  if ([COMPOSE_DEEPLY, COMPOSE_SOFTLY, DONT_COMPOSE].indexOf(composeTheme) === -1) {
	    throw new Error('Invalid composeTheme option for react-css-themr. Valid composition options are ' + COMPOSE_DEEPLY + ', ' + COMPOSE_SOFTLY + ' and ' + DONT_COMPOSE + '. The given option was ' + composeTheme);
	  }
	}
	
	/**
	 * Removes namespace from key
	 *
	 * @param {String} key - Key
	 * @param {String} themeNamespace - Theme namespace
	 * @returns {String} - Key
	 */
	function removeNamespace(key, themeNamespace) {
	  var capitalized = key.substr(themeNamespace.length);
	  return capitalized.slice(0, 1).toLowerCase() + capitalized.slice(1);
	}
	
	/**
	 * Maps props and theme to an object that will be used to pass down props to the
	 * decorated component.
	 *
	 * @param {Object} ownProps - All props given to the decorated component
	 * @param {Object} theme - Calculated then that should be passed down
	 * @returns {Object} - Props that will be passed down to the decorated component
	 */
	function defaultMapThemrProps(ownProps, theme) {
	  var composeTheme = ownProps.composeTheme,
	      innerRef = ownProps.innerRef,
	      themeNamespace = ownProps.themeNamespace,
	      mapThemrProps = ownProps.mapThemrProps,
	      rest = _objectWithoutProperties(ownProps, ['composeTheme', 'innerRef', 'themeNamespace', 'mapThemrProps']);
	
	  return _extends({}, rest, {
	    ref: innerRef,
	    theme: theme
	  });
	}

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.shape({
	  theme: _propTypes2.default.object.isRequired
	});

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.renderViewDefault = renderViewDefault;
	exports.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
	exports.renderTrackVerticalDefault = renderTrackVerticalDefault;
	exports.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
	exports.renderThumbVerticalDefault = renderThumbVerticalDefault;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/* eslint-disable react/prop-types */
	
	function renderViewDefault(props) {
	    return _react2["default"].createElement('div', props);
	}
	
	function renderTrackHorizontalDefault(_ref) {
	    var style = _ref.style,
	        props = _objectWithoutProperties(_ref, ['style']);
	
	    var finalStyle = _extends({}, style, {
	        right: 2,
	        bottom: 2,
	        left: 2,
	        borderRadius: 3
	    });
	    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
	}
	
	function renderTrackVerticalDefault(_ref2) {
	    var style = _ref2.style,
	        props = _objectWithoutProperties(_ref2, ['style']);
	
	    var finalStyle = _extends({}, style, {
	        right: 2,
	        bottom: 2,
	        top: 2,
	        borderRadius: 3
	    });
	    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
	}
	
	function renderThumbHorizontalDefault(_ref3) {
	    var style = _ref3.style,
	        props = _objectWithoutProperties(_ref3, ['style']);
	
	    var finalStyle = _extends({}, style, {
	        cursor: 'pointer',
	        borderRadius: 'inherit',
	        backgroundColor: 'rgba(0,0,0,.2)'
	    });
	    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
	}
	
	function renderThumbVerticalDefault(_ref4) {
	    var style = _ref4.style,
	        props = _objectWithoutProperties(_ref4, ['style']);
	
	    var finalStyle = _extends({}, style, {
	        cursor: 'pointer',
	        borderRadius: 'inherit',
	        backgroundColor: 'rgba(0,0,0,.2)'
	    });
	    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
	}

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _raf2 = __webpack_require__(392);
	
	var _raf3 = _interopRequireDefault(_raf2);
	
	var _domCss = __webpack_require__(229);
	
	var _domCss2 = _interopRequireDefault(_domCss);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isString = __webpack_require__(738);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _getScrollbarWidth = __webpack_require__(737);
	
	var _getScrollbarWidth2 = _interopRequireDefault(_getScrollbarWidth);
	
	var _returnFalse = __webpack_require__(739);
	
	var _returnFalse2 = _interopRequireDefault(_returnFalse);
	
	var _getInnerWidth = __webpack_require__(736);
	
	var _getInnerWidth2 = _interopRequireDefault(_getInnerWidth);
	
	var _getInnerHeight = __webpack_require__(735);
	
	var _getInnerHeight2 = _interopRequireDefault(_getInnerHeight);
	
	var _styles = __webpack_require__(733);
	
	var _defaultRenderElements = __webpack_require__(731);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scrollbars = function (_Component) {
	    _inherits(Scrollbars, _Component);
	
	    function Scrollbars(props) {
	        var _ref;
	
	        _classCallCheck(this, Scrollbars);
	
	        for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	            rest[_key - 1] = arguments[_key];
	        }
	
	        var _this = _possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [this, props].concat(rest)));
	
	        _this.getScrollLeft = _this.getScrollLeft.bind(_this);
	        _this.getScrollTop = _this.getScrollTop.bind(_this);
	        _this.getScrollWidth = _this.getScrollWidth.bind(_this);
	        _this.getScrollHeight = _this.getScrollHeight.bind(_this);
	        _this.getClientWidth = _this.getClientWidth.bind(_this);
	        _this.getClientHeight = _this.getClientHeight.bind(_this);
	        _this.getValues = _this.getValues.bind(_this);
	        _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
	        _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
	        _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
	        _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);
	
	        _this.scrollLeft = _this.scrollLeft.bind(_this);
	        _this.scrollTop = _this.scrollTop.bind(_this);
	        _this.scrollToLeft = _this.scrollToLeft.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.scrollToRight = _this.scrollToRight.bind(_this);
	        _this.scrollToBottom = _this.scrollToBottom.bind(_this);
	
	        _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
	        _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
	        _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
	        _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
	        _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
	        _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
	        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	        _this.handleScroll = _this.handleScroll.bind(_this);
	        _this.handleDrag = _this.handleDrag.bind(_this);
	        _this.handleDragEnd = _this.handleDragEnd.bind(_this);
	
	        _this.state = {
	            didMountUniversal: false
	        };
	        return _this;
	    }
	
	    _createClass(Scrollbars, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.addListeners();
	            this.update();
	            this.componentDidMountUniversal();
	        }
	    }, {
	        key: 'componentDidMountUniversal',
	        value: function componentDidMountUniversal() {
	            // eslint-disable-line react/sort-comp
	            var universal = this.props.universal;
	
	            if (!universal) return;
	            this.setState({ didMountUniversal: true });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.update();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.removeListeners();
	            (0, _raf2.cancel)(this.requestFrame);
	            clearTimeout(this.hideTracksTimeout);
	            clearInterval(this.detectScrollingInterval);
	        }
	    }, {
	        key: 'getScrollLeft',
	        value: function getScrollLeft() {
	            if (!this.view) return 0;
	            return this.view.scrollLeft;
	        }
	    }, {
	        key: 'getScrollTop',
	        value: function getScrollTop() {
	            if (!this.view) return 0;
	            return this.view.scrollTop;
	        }
	    }, {
	        key: 'getScrollWidth',
	        value: function getScrollWidth() {
	            if (!this.view) return 0;
	            return this.view.scrollWidth;
	        }
	    }, {
	        key: 'getScrollHeight',
	        value: function getScrollHeight() {
	            if (!this.view) return 0;
	            return this.view.scrollHeight;
	        }
	    }, {
	        key: 'getClientWidth',
	        value: function getClientWidth() {
	            if (!this.view) return 0;
	            return this.view.clientWidth;
	        }
	    }, {
	        key: 'getClientHeight',
	        value: function getClientHeight() {
	            if (!this.view) return 0;
	            return this.view.clientHeight;
	        }
	    }, {
	        key: 'getValues',
	        value: function getValues() {
	            var _ref2 = this.view || {},
	                _ref2$scrollLeft = _ref2.scrollLeft,
	                scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
	                _ref2$scrollTop = _ref2.scrollTop,
	                scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop,
	                _ref2$scrollWidth = _ref2.scrollWidth,
	                scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth,
	                _ref2$scrollHeight = _ref2.scrollHeight,
	                scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight,
	                _ref2$clientWidth = _ref2.clientWidth,
	                clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth,
	                _ref2$clientHeight = _ref2.clientHeight,
	                clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;
	
	            return {
	                left: scrollLeft / (scrollWidth - clientWidth) || 0,
	                top: scrollTop / (scrollHeight - clientHeight) || 0,
	                scrollLeft: scrollLeft,
	                scrollTop: scrollTop,
	                scrollWidth: scrollWidth,
	                scrollHeight: scrollHeight,
	                clientWidth: clientWidth,
	                clientHeight: clientHeight
	            };
	        }
	    }, {
	        key: 'getThumbHorizontalWidth',
	        value: function getThumbHorizontalWidth() {
	            var _props = this.props,
	                thumbSize = _props.thumbSize,
	                thumbMinSize = _props.thumbMinSize;
	            var _view = this.view,
	                scrollWidth = _view.scrollWidth,
	                clientWidth = _view.clientWidth;
	
	            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
	            var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
	            if (trackWidth === width) return 0;
	            if (thumbSize) return thumbSize;
	            return Math.max(width, thumbMinSize);
	        }
	    }, {
	        key: 'getThumbVerticalHeight',
	        value: function getThumbVerticalHeight() {
	            var _props2 = this.props,
	                thumbSize = _props2.thumbSize,
	                thumbMinSize = _props2.thumbMinSize;
	            var _view2 = this.view,
	                scrollHeight = _view2.scrollHeight,
	                clientHeight = _view2.clientHeight;
	
	            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
	            var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
	            if (trackHeight === height) return 0;
	            if (thumbSize) return thumbSize;
	            return Math.max(height, thumbMinSize);
	        }
	    }, {
	        key: 'getScrollLeftForOffset',
	        value: function getScrollLeftForOffset(offset) {
	            var _view3 = this.view,
	                scrollWidth = _view3.scrollWidth,
	                clientWidth = _view3.clientWidth;
	
	            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
	            var thumbWidth = this.getThumbHorizontalWidth();
	            return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
	        }
	    }, {
	        key: 'getScrollTopForOffset',
	        value: function getScrollTopForOffset(offset) {
	            var _view4 = this.view,
	                scrollHeight = _view4.scrollHeight,
	                clientHeight = _view4.clientHeight;
	
	            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
	            var thumbHeight = this.getThumbVerticalHeight();
	            return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
	        }
	    }, {
	        key: 'scrollLeft',
	        value: function scrollLeft() {
	            var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	            if (!this.view) return;
	            this.view.scrollLeft = left;
	        }
	    }, {
	        key: 'scrollTop',
	        value: function scrollTop() {
	            var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	            if (!this.view) return;
	            this.view.scrollTop = top;
	        }
	    }, {
	        key: 'scrollToLeft',
	        value: function scrollToLeft() {
	            if (!this.view) return;
	            this.view.scrollLeft = 0;
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (!this.view) return;
	            this.view.scrollTop = 0;
	        }
	    }, {
	        key: 'scrollToRight',
	        value: function scrollToRight() {
	            if (!this.view) return;
	            this.view.scrollLeft = this.view.scrollWidth;
	        }
	    }, {
	        key: 'scrollToBottom',
	        value: function scrollToBottom() {
	            if (!this.view) return;
	            this.view.scrollTop = this.view.scrollHeight;
	        }
	    }, {
	        key: 'addListeners',
	        value: function addListeners() {
	            /* istanbul ignore if */
	            if (typeof document === 'undefined' || !this.view) return;
	            var view = this.view,
	                trackHorizontal = this.trackHorizontal,
	                trackVertical = this.trackVertical,
	                thumbHorizontal = this.thumbHorizontal,
	                thumbVertical = this.thumbVertical;
	
	            view.addEventListener('scroll', this.handleScroll);
	            if (!(0, _getScrollbarWidth2["default"])()) return;
	            trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
	            trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
	            trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
	            trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
	            trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
	            trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
	            thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
	            thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
	            window.addEventListener('resize', this.handleWindowResize);
	        }
	    }, {
	        key: 'removeListeners',
	        value: function removeListeners() {
	            /* istanbul ignore if */
	            if (typeof document === 'undefined' || !this.view) return;
	            var view = this.view,
	                trackHorizontal = this.trackHorizontal,
	                trackVertical = this.trackVertical,
	                thumbHorizontal = this.thumbHorizontal,
	                thumbVertical = this.thumbVertical;
	
	            view.removeEventListener('scroll', this.handleScroll);
	            if (!(0, _getScrollbarWidth2["default"])()) return;
	            trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
	            trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
	            trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
	            trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
	            trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
	            trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
	            thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
	            thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
	            window.removeEventListener('resize', this.handleWindowResize);
	            // Possibly setup by `handleDragStart`
	            this.teardownDragging();
	        }
	    }, {
	        key: 'handleScroll',
	        value: function handleScroll(event) {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                onScroll = _props3.onScroll,
	                onScrollFrame = _props3.onScrollFrame;
	
	            if (onScroll) onScroll(event);
	            this.update(function (values) {
	                var scrollLeft = values.scrollLeft,
	                    scrollTop = values.scrollTop;
	
	                _this2.viewScrollLeft = scrollLeft;
	                _this2.viewScrollTop = scrollTop;
	                if (onScrollFrame) onScrollFrame(values);
	            });
	            this.detectScrolling();
	        }
	    }, {
	        key: 'handleScrollStart',
	        value: function handleScrollStart() {
	            var onScrollStart = this.props.onScrollStart;
	
	            if (onScrollStart) onScrollStart();
	            this.handleScrollStartAutoHide();
	        }
	    }, {
	        key: 'handleScrollStartAutoHide',
	        value: function handleScrollStartAutoHide() {
	            var autoHide = this.props.autoHide;
	
	            if (!autoHide) return;
	            this.showTracks();
	        }
	    }, {
	        key: 'handleScrollStop',
	        value: function handleScrollStop() {
	            var onScrollStop = this.props.onScrollStop;
	
	            if (onScrollStop) onScrollStop();
	            this.handleScrollStopAutoHide();
	        }
	    }, {
	        key: 'handleScrollStopAutoHide',
	        value: function handleScrollStopAutoHide() {
	            var autoHide = this.props.autoHide;
	
	            if (!autoHide) return;
	            this.hideTracks();
	        }
	    }, {
	        key: 'handleWindowResize',
	        value: function handleWindowResize() {
	            this.update();
	        }
	    }, {
	        key: 'handleHorizontalTrackMouseDown',
	        value: function handleHorizontalTrackMouseDown(event) {
	            event.preventDefault();
	            var target = event.target,
	                clientX = event.clientX;
	
	            var _target$getBoundingCl = target.getBoundingClientRect(),
	                targetLeft = _target$getBoundingCl.left;
	
	            var thumbWidth = this.getThumbHorizontalWidth();
	            var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
	            this.view.scrollLeft = this.getScrollLeftForOffset(offset);
	        }
	    }, {
	        key: 'handleVerticalTrackMouseDown',
	        value: function handleVerticalTrackMouseDown(event) {
	            event.preventDefault();
	            var target = event.target,
	                clientY = event.clientY;
	
	            var _target$getBoundingCl2 = target.getBoundingClientRect(),
	                targetTop = _target$getBoundingCl2.top;
	
	            var thumbHeight = this.getThumbVerticalHeight();
	            var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
	            this.view.scrollTop = this.getScrollTopForOffset(offset);
	        }
	    }, {
	        key: 'handleHorizontalThumbMouseDown',
	        value: function handleHorizontalThumbMouseDown(event) {
	            event.preventDefault();
	            this.handleDragStart(event);
	            var target = event.target,
	                clientX = event.clientX;
	            var offsetWidth = target.offsetWidth;
	
	            var _target$getBoundingCl3 = target.getBoundingClientRect(),
	                left = _target$getBoundingCl3.left;
	
	            this.prevPageX = offsetWidth - (clientX - left);
	        }
	    }, {
	        key: 'handleVerticalThumbMouseDown',
	        value: function handleVerticalThumbMouseDown(event) {
	            event.preventDefault();
	            this.handleDragStart(event);
	            var target = event.target,
	                clientY = event.clientY;
	            var offsetHeight = target.offsetHeight;
	
	            var _target$getBoundingCl4 = target.getBoundingClientRect(),
	                top = _target$getBoundingCl4.top;
	
	            this.prevPageY = offsetHeight - (clientY - top);
	        }
	    }, {
	        key: 'setupDragging',
	        value: function setupDragging() {
	            (0, _domCss2["default"])(document.body, _styles.disableSelectStyle);
	            document.addEventListener('mousemove', this.handleDrag);
	            document.addEventListener('mouseup', this.handleDragEnd);
	            document.onselectstart = _returnFalse2["default"];
	        }
	    }, {
	        key: 'teardownDragging',
	        value: function teardownDragging() {
	            (0, _domCss2["default"])(document.body, _styles.disableSelectStyleReset);
	            document.removeEventListener('mousemove', this.handleDrag);
	            document.removeEventListener('mouseup', this.handleDragEnd);
	            document.onselectstart = undefined;
	        }
	    }, {
	        key: 'handleDragStart',
	        value: function handleDragStart(event) {
	            this.dragging = true;
	            event.stopImmediatePropagation();
	            this.setupDragging();
	        }
	    }, {
	        key: 'handleDrag',
	        value: function handleDrag(event) {
	            if (this.prevPageX) {
	                var clientX = event.clientX;
	
	                var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(),
	                    trackLeft = _trackHorizontal$getB.left;
	
	                var thumbWidth = this.getThumbHorizontalWidth();
	                var clickPosition = thumbWidth - this.prevPageX;
	                var offset = -trackLeft + clientX - clickPosition;
	                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
	            }
	            if (this.prevPageY) {
	                var clientY = event.clientY;
	
	                var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(),
	                    trackTop = _trackVertical$getBou.top;
	
	                var thumbHeight = this.getThumbVerticalHeight();
	                var _clickPosition = thumbHeight - this.prevPageY;
	                var _offset = -trackTop + clientY - _clickPosition;
	                this.view.scrollTop = this.getScrollTopForOffset(_offset);
	            }
	            return false;
	        }
	    }, {
	        key: 'handleDragEnd',
	        value: function handleDragEnd() {
	            this.dragging = false;
	            this.prevPageX = this.prevPageY = 0;
	            this.teardownDragging();
	            this.handleDragEndAutoHide();
	        }
	    }, {
	        key: 'handleDragEndAutoHide',
	        value: function handleDragEndAutoHide() {
	            var autoHide = this.props.autoHide;
	
	            if (!autoHide) return;
	            this.hideTracks();
	        }
	    }, {
	        key: 'handleTrackMouseEnter',
	        value: function handleTrackMouseEnter() {
	            this.trackMouseOver = true;
	            this.handleTrackMouseEnterAutoHide();
	        }
	    }, {
	        key: 'handleTrackMouseEnterAutoHide',
	        value: function handleTrackMouseEnterAutoHide() {
	            var autoHide = this.props.autoHide;
	
	            if (!autoHide) return;
	            this.showTracks();
	        }
	    }, {
	        key: 'handleTrackMouseLeave',
	        value: function handleTrackMouseLeave() {
	            this.trackMouseOver = false;
	            this.handleTrackMouseLeaveAutoHide();
	        }
	    }, {
	        key: 'handleTrackMouseLeaveAutoHide',
	        value: function handleTrackMouseLeaveAutoHide() {
	            var autoHide = this.props.autoHide;
	
	            if (!autoHide) return;
	            this.hideTracks();
	        }
	    }, {
	        key: 'showTracks',
	        value: function showTracks() {
	            clearTimeout(this.hideTracksTimeout);
	            (0, _domCss2["default"])(this.trackHorizontal, { opacity: 1 });
	            (0, _domCss2["default"])(this.trackVertical, { opacity: 1 });
	        }
	    }, {
	        key: 'hideTracks',
	        value: function hideTracks() {
	            var _this3 = this;
	
	            if (this.dragging) return;
	            if (this.scrolling) return;
	            if (this.trackMouseOver) return;
	            var autoHideTimeout = this.props.autoHideTimeout;
	
	            clearTimeout(this.hideTracksTimeout);
	            this.hideTracksTimeout = setTimeout(function () {
	                (0, _domCss2["default"])(_this3.trackHorizontal, { opacity: 0 });
	                (0, _domCss2["default"])(_this3.trackVertical, { opacity: 0 });
	            }, autoHideTimeout);
	        }
	    }, {
	        key: 'detectScrolling',
	        value: function detectScrolling() {
	            var _this4 = this;
	
	            if (this.scrolling) return;
	            this.scrolling = true;
	            this.handleScrollStart();
	            this.detectScrollingInterval = setInterval(function () {
	                if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
	                    clearInterval(_this4.detectScrollingInterval);
	                    _this4.scrolling = false;
	                    _this4.handleScrollStop();
	                }
	                _this4.lastViewScrollLeft = _this4.viewScrollLeft;
	                _this4.lastViewScrollTop = _this4.viewScrollTop;
	            }, 100);
	        }
	    }, {
	        key: 'raf',
	        value: function raf(callback) {
	            var _this5 = this;
	
	            if (this.requestFrame) _raf3["default"].cancel(this.requestFrame);
	            this.requestFrame = (0, _raf3["default"])(function () {
	                _this5.requestFrame = undefined;
	                callback();
	            });
	        }
	    }, {
	        key: 'update',
	        value: function update(callback) {
	            var _this6 = this;
	
	            this.raf(function () {
	                return _this6._update(callback);
	            });
	        }
	    }, {
	        key: '_update',
	        value: function _update(callback) {
	            var _props4 = this.props,
	                onUpdate = _props4.onUpdate,
	                hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;
	
	            var values = this.getValues();
	            if ((0, _getScrollbarWidth2["default"])()) {
	                var scrollLeft = values.scrollLeft,
	                    clientWidth = values.clientWidth,
	                    scrollWidth = values.scrollWidth;
	
	                var trackHorizontalWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
	                var thumbHorizontalWidth = this.getThumbHorizontalWidth();
	                var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
	                var thumbHorizontalStyle = {
	                    width: thumbHorizontalWidth,
	                    transform: 'translateX(' + thumbHorizontalX + 'px)'
	                };
	                var scrollTop = values.scrollTop,
	                    clientHeight = values.clientHeight,
	                    scrollHeight = values.scrollHeight;
	
	                var trackVerticalHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
	                var thumbVerticalHeight = this.getThumbVerticalHeight();
	                var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
	                var thumbVerticalStyle = {
	                    height: thumbVerticalHeight,
	                    transform: 'translateY(' + thumbVerticalY + 'px)'
	                };
	                if (hideTracksWhenNotNeeded) {
	                    var trackHorizontalStyle = {
	                        visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
	                    };
	                    var trackVerticalStyle = {
	                        visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
	                    };
	                    (0, _domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
	                    (0, _domCss2["default"])(this.trackVertical, trackVerticalStyle);
	                }
	                (0, _domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
	                (0, _domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
	            }
	            if (onUpdate) onUpdate(values);
	            if (typeof callback !== 'function') return;
	            callback(values);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this7 = this;
	
	            var scrollbarWidth = (0, _getScrollbarWidth2["default"])();
	            /* eslint-disable no-unused-vars */
	
	            var _props5 = this.props,
	                onScroll = _props5.onScroll,
	                onScrollFrame = _props5.onScrollFrame,
	                onScrollStart = _props5.onScrollStart,
	                onScrollStop = _props5.onScrollStop,
	                onUpdate = _props5.onUpdate,
	                renderView = _props5.renderView,
	                renderTrackHorizontal = _props5.renderTrackHorizontal,
	                renderTrackVertical = _props5.renderTrackVertical,
	                renderThumbHorizontal = _props5.renderThumbHorizontal,
	                renderThumbVertical = _props5.renderThumbVertical,
	                tagName = _props5.tagName,
	                hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded,
	                autoHide = _props5.autoHide,
	                autoHideTimeout = _props5.autoHideTimeout,
	                autoHideDuration = _props5.autoHideDuration,
	                thumbSize = _props5.thumbSize,
	                thumbMinSize = _props5.thumbMinSize,
	                universal = _props5.universal,
	                autoHeight = _props5.autoHeight,
	                autoHeightMin = _props5.autoHeightMin,
	                autoHeightMax = _props5.autoHeightMax,
	                style = _props5.style,
	                children = _props5.children,
	                props = _objectWithoutProperties(_props5, ['onScroll', 'onScrollFrame', 'onScrollStart', 'onScrollStop', 'onUpdate', 'renderView', 'renderTrackHorizontal', 'renderTrackVertical', 'renderThumbHorizontal', 'renderThumbVertical', 'tagName', 'hideTracksWhenNotNeeded', 'autoHide', 'autoHideTimeout', 'autoHideDuration', 'thumbSize', 'thumbMinSize', 'universal', 'autoHeight', 'autoHeightMin', 'autoHeightMax', 'style', 'children']);
	            /* eslint-enable no-unused-vars */
	
	            var didMountUniversal = this.state.didMountUniversal;
	
	
	            var containerStyle = _extends({}, _styles.containerStyleDefault, autoHeight && _extends({}, _styles.containerStyleAutoHeight, {
	                minHeight: autoHeightMin,
	                maxHeight: autoHeightMax
	            }), style);
	
	            var viewStyle = _extends({}, _styles.viewStyleDefault, {
	                // Hide scrollbars by setting a negative margin
	                marginRight: scrollbarWidth ? -scrollbarWidth : 0,
	                marginBottom: scrollbarWidth ? -scrollbarWidth : 0
	            }, autoHeight && _extends({}, _styles.viewStyleAutoHeight, {
	                // Add scrollbarWidth to autoHeight in order to compensate negative margins
	                minHeight: (0, _isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
	                maxHeight: (0, _isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
	            }), autoHeight && universal && !didMountUniversal && {
	                minHeight: autoHeightMin,
	                maxHeight: autoHeightMax
	            }, universal && !didMountUniversal && _styles.viewStyleUniversalInitial);
	
	            var trackAutoHeightStyle = {
	                transition: 'opacity ' + autoHideDuration + 'ms',
	                opacity: 0
	            };
	
	            var trackHorizontalStyle = _extends({}, _styles.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
	                display: 'none'
	            });
	
	            var trackVerticalStyle = _extends({}, _styles.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
	                display: 'none'
	            });
	
	            return (0, _react.createElement)(tagName, _extends({}, props, { style: containerStyle, ref: function ref(_ref3) {
	                    _this7.container = _ref3;
	                } }), [(0, _react.cloneElement)(renderView({ style: viewStyle }), { key: 'view', ref: function ref(_ref4) {
	                    _this7.view = _ref4;
	                } }, children), (0, _react.cloneElement)(renderTrackHorizontal({ style: trackHorizontalStyle }), { key: 'trackHorizontal', ref: function ref(_ref5) {
	                    _this7.trackHorizontal = _ref5;
	                } }, (0, _react.cloneElement)(renderThumbHorizontal({ style: _styles.thumbHorizontalStyleDefault }), { ref: function ref(_ref6) {
	                    _this7.thumbHorizontal = _ref6;
	                } })), (0, _react.cloneElement)(renderTrackVertical({ style: trackVerticalStyle }), { key: 'trackVertical', ref: function ref(_ref7) {
	                    _this7.trackVertical = _ref7;
	                } }, (0, _react.cloneElement)(renderThumbVertical({ style: _styles.thumbVerticalStyleDefault }), { ref: function ref(_ref8) {
	                    _this7.thumbVertical = _ref8;
	                } }))]);
	        }
	    }]);
	
	    return Scrollbars;
	}(_react.Component);
	
	exports["default"] = Scrollbars;
	
	
	Scrollbars.propTypes = {
	    onScroll: _propTypes2["default"].func,
	    onScrollFrame: _propTypes2["default"].func,
	    onScrollStart: _propTypes2["default"].func,
	    onScrollStop: _propTypes2["default"].func,
	    onUpdate: _propTypes2["default"].func,
	    renderView: _propTypes2["default"].func,
	    renderTrackHorizontal: _propTypes2["default"].func,
	    renderTrackVertical: _propTypes2["default"].func,
	    renderThumbHorizontal: _propTypes2["default"].func,
	    renderThumbVertical: _propTypes2["default"].func,
	    tagName: _propTypes2["default"].string,
	    thumbSize: _propTypes2["default"].number,
	    thumbMinSize: _propTypes2["default"].number,
	    hideTracksWhenNotNeeded: _propTypes2["default"].bool,
	    autoHide: _propTypes2["default"].bool,
	    autoHideTimeout: _propTypes2["default"].number,
	    autoHideDuration: _propTypes2["default"].number,
	    autoHeight: _propTypes2["default"].bool,
	    autoHeightMin: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
	    autoHeightMax: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
	    universal: _propTypes2["default"].bool,
	    style: _propTypes2["default"].object,
	    children: _propTypes2["default"].node
	};
	
	Scrollbars.defaultProps = {
	    renderView: _defaultRenderElements.renderViewDefault,
	    renderTrackHorizontal: _defaultRenderElements.renderTrackHorizontalDefault,
	    renderTrackVertical: _defaultRenderElements.renderTrackVerticalDefault,
	    renderThumbHorizontal: _defaultRenderElements.renderThumbHorizontalDefault,
	    renderThumbVertical: _defaultRenderElements.renderThumbVerticalDefault,
	    tagName: 'div',
	    thumbMinSize: 30,
	    hideTracksWhenNotNeeded: false,
	    autoHide: false,
	    autoHideTimeout: 1000,
	    autoHideDuration: 200,
	    autoHeight: false,
	    autoHeightMin: 0,
	    autoHeightMax: 200,
	    universal: false
	};

/***/ },
/* 733 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var containerStyleDefault = exports.containerStyleDefault = {
	    position: 'relative',
	    overflow: 'hidden',
	    width: '100%',
	    height: '100%'
	};
	
	// Overrides containerStyleDefault properties
	var containerStyleAutoHeight = exports.containerStyleAutoHeight = {
	    height: 'auto'
	};
	
	var viewStyleDefault = exports.viewStyleDefault = {
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    overflow: 'scroll',
	    WebkitOverflowScrolling: 'touch'
	};
	
	// Overrides viewStyleDefault properties
	var viewStyleAutoHeight = exports.viewStyleAutoHeight = {
	    position: 'relative',
	    top: undefined,
	    left: undefined,
	    right: undefined,
	    bottom: undefined
	};
	
	var viewStyleUniversalInitial = exports.viewStyleUniversalInitial = {
	    overflow: 'hidden',
	    marginRight: 0,
	    marginBottom: 0
	};
	
	var trackHorizontalStyleDefault = exports.trackHorizontalStyleDefault = {
	    position: 'absolute',
	    height: 6
	};
	
	var trackVerticalStyleDefault = exports.trackVerticalStyleDefault = {
	    position: 'absolute',
	    width: 6
	};
	
	var thumbHorizontalStyleDefault = exports.thumbHorizontalStyleDefault = {
	    position: 'relative',
	    display: 'block',
	    height: '100%'
	};
	
	var thumbVerticalStyleDefault = exports.thumbVerticalStyleDefault = {
	    position: 'relative',
	    display: 'block',
	    width: '100%'
	};
	
	var disableSelectStyle = exports.disableSelectStyle = {
	    userSelect: 'none'
	};
	
	var disableSelectStyleReset = exports.disableSelectStyleReset = {
	    userSelect: ''
	};

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Scrollbars = undefined;
	
	var _Scrollbars = __webpack_require__(732);
	
	var _Scrollbars2 = _interopRequireDefault(_Scrollbars);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _Scrollbars2["default"];
	exports.Scrollbars = _Scrollbars2["default"];

/***/ },
/* 735 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = getInnerHeight;
	function getInnerHeight(el) {
	    var clientHeight = el.clientHeight;
	
	    var _getComputedStyle = getComputedStyle(el),
	        paddingTop = _getComputedStyle.paddingTop,
	        paddingBottom = _getComputedStyle.paddingBottom;
	
	    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
	}

/***/ },
/* 736 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = getInnerWidth;
	function getInnerWidth(el) {
	    var clientWidth = el.clientWidth;
	
	    var _getComputedStyle = getComputedStyle(el),
	        paddingLeft = _getComputedStyle.paddingLeft,
	        paddingRight = _getComputedStyle.paddingRight;
	
	    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
	}

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = getScrollbarWidth;
	
	var _domCss = __webpack_require__(229);
	
	var _domCss2 = _interopRequireDefault(_domCss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var scrollbarWidth = false;
	
	function getScrollbarWidth() {
	    if (scrollbarWidth !== false) return scrollbarWidth;
	    /* istanbul ignore else */
	    if (typeof document !== 'undefined') {
	        var div = document.createElement('div');
	        (0, _domCss2["default"])(div, {
	            width: 100,
	            height: 100,
	            position: 'absolute',
	            top: -9999,
	            overflow: 'scroll',
	            MsOverflowStyle: 'scrollbar'
	        });
	        document.body.appendChild(div);
	        scrollbarWidth = div.offsetWidth - div.clientWidth;
	        document.body.removeChild(div);
	    } else {
	        scrollbarWidth = 0;
	    }
	    return scrollbarWidth || 0;
	}

/***/ },
/* 738 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = isString;
	function isString(maybe) {
	    return typeof maybe === 'string';
	}

/***/ },
/* 739 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = returnFalse;
	function returnFalse() {
	    return false;
	}

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.normalizeConfig = normalizeConfig;
	
	var _lodash = __webpack_require__(30);
	
	var _helpers = __webpack_require__(94);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function normalizeFields(validationName, fields) {
	  var result = fields;
	  if (result == null) {
	    result = [validationName];
	  }
	  if (typeof result === 'string') {
	    result = [result];
	  }
	  if ((0, _lodash.isArray)(result) && (result.length === 0 || typeof result[0] === 'string')) {
	    result = [result, result];
	  }
	  var wellFormed = (0, _lodash.isArray)(result) && result.length === 2 && result.every(function (i) {
	    return (0, _lodash.isArray)(i);
	  }) && result[0].every(function (i) {
	    return typeof i === 'string';
	  }) && result[1].every(function (i) {
	    return typeof i === 'string';
	  });
	  (0, _helpers.assertSpec)(wellFormed, 'Invalid validation config! Malformed fields for validation ' + validationName + '.', fields, 'Array<Array<string>> of length 2 or Array<string> or string or null');
	  // result has form [dependsOn, needTouch]
	  //   dependsOn: Array<string>, field names that hide the validation result if
	  //   the user is changing any of them (typing)
	  //   needTouch: Array<string>, field names that need to be touched
	  //   (changed/blurred/submitted) before the validation result is shown
	  return result;
	}
	
	function normalizeRules(validationName, rules) {
	  (0, _helpers.assertSpec)((0, _lodash.isArray)(rules) && rules.every(function (r) {
	    return (0, _lodash.isArray)(r);
	  }), 'Invalid validation config! Malformed rules for validation ' + validationName + '.', rules, 'Array of Arrays');
	
	  var result = [];
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = rules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var r = _step.value;
	
	      var rr = r;
	      if (rr.length > 0 && typeof rr[0] === 'function') {
	        rr = [r[0].name].concat(_toConsumableArray(r));
	      }
	      (0, _helpers.assertSpec)(rr.length >= 2 && typeof rr[0] === 'string' && typeof rr[1] === 'function', 'Invalid validation config! Malformed rule for validation ' + validationName + '.', r, '[string, function, ...arguments] or [function, ...arguments]');
	      result.push(rr);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return result;
	}
	
	function normalizeAllFields(fields) {
	  (0, _helpers.assertSpec)((0, _lodash.isArray)(fields) && fields.every(function (f) {
	    return typeof f === 'string';
	  }), 'Invalid validation config! Malformed fields.', fields, 'Array<string>');
	  return fields;
	}
	
	function normalizeTypingDebounce(typingDebounce) {
	  var result = typingDebounce;
	  if (result == null) {
	    result = [2500, 1000];
	  }
	  if (typeof result === 'number') {
	    result = [result, result];
	  }
	  (0, _helpers.assertSpec)((0, _lodash.isArray)(result) && result.length === 2 && result.every(function (r) {
	    return typeof r === 'number';
	  }), 'Invalid validation config! Malformed option typingDebounce.', typingDebounce, 'Array<number> of length 2 or number or null');
	  return result;
	}
	
	function normalizeConfig(config) {
	  var validations = config.validations,
	      fields = config.fields,
	      _config$onValidation = config.onValidation,
	      onValidation = _config$onValidation === undefined ? function () {} : _config$onValidation,
	      _config$options = config.options;
	  _config$options = _config$options === undefined ? {} : _config$options;
	  var _config$options$async = _config$options.asyncThrottle,
	      asyncThrottle = _config$options$async === undefined ? 500 : _config$options$async,
	      typingDebounce = _config$options.typingDebounce;
	
	
	  (0, _helpers.assertSpec)(typeof asyncThrottle === 'number', 'Invalid validation config! Malformed option asyncThrottle.', asyncThrottle, 'number');
	  typingDebounce = normalizeTypingDebounce(typingDebounce);
	
	  var resultValidations = {};
	
	  for (var name in validations) {
	    var v = validations[name];
	    if ((0, _lodash.isArray)(v)) {
	      // only rules were provided, expand the config to its full form
	      v = { rules: v, fields: null };
	    }
	
	    resultValidations[name] = {
	      rules: normalizeRules(name, v.rules),
	      fields: normalizeFields(name, v.fields),
	      debounce: asyncThrottle
	    };
	  }
	
	  return {
	    validations: resultValidations,
	    fields: normalizeAllFields(fields),
	    typingDebounce: { before: typingDebounce[0], after: typingDebounce[1] },
	    onValidation: onValidation
	  };
	}

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.handleFieldEvent = handleFieldEvent;
	exports.shouldShowValidation = shouldShowValidation;
	
	var _immutabilityHelper = __webpack_require__(116);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _lodash = __webpack_require__(30);
	
	var _helpers = __webpack_require__(94);
	
	var _state = __webpack_require__(115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var EVENTS = ['change', 'blur', 'submit', 'reset'];
	
	function normalizeDebounce(state, field, event, debounce) {
	  if (event !== 'change') {
	    // disallow debounce for other event types
	    (0, _helpers.assertSpec)(debounce === false || debounce === 0 || debounce == null, 'Nonzero debounce is allowed only for change event', debounce, 'false or 0 or null');
	    return 0;
	  }
	
	  (0, _helpers.assertSpec)(typeof debounce === 'number' || typeof debounce === 'boolean' || debounce == null, 'Invalid debounce.', debounce, 'number or boolean or null');
	
	  if (debounce === true || debounce == null) {
	    // use default debounce set in (normalized) config
	    var _state$config$typingD = state.config.typingDebounce,
	        before = _state$config$typingD.before,
	        after = _state$config$typingD.after,
	        _state$fields = state.fields,
	        blur = _state$fields.blur,
	        submit = _state$fields.submit;
	
	    return field in blur || field in submit ? after : before;
	  } else if (debounce === false) {
	    return 0;
	  } else {
	    return debounce;
	  }
	}
	
	function normalizeFields(state, fields) {
	  var result = fields == null ? state.config.fields : fields;
	  result = (0, _lodash.isArray)(result) ? result : [result];
	
	  (0, _helpers.assertSpec)((0, _lodash.isArray)(result) && result.every(function (f) {
	    return typeof f === 'string';
	  }), 'Invalid field.', fields, 'string or Array<string> or null');
	  return result;
	}
	
	function withoutKeys(keys) {
	  return function (obj) {
	    var result = _extends({}, obj);
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var k = _step.value;
	
	        delete result[k];
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return result;
	  };
	}
	
	function withKeys(keys, value) {
	  return function (obj) {
	    var result = _extends({}, obj);
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	      for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var k = _step2.value;
	
	        result[k] = value;
	      }
	    } catch (err) {
	      _didIteratorError2 = true;
	      _iteratorError2 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	          _iterator2.return();
	        }
	      } finally {
	        if (_didIteratorError2) {
	          throw _iteratorError2;
	        }
	      }
	    }
	
	    return result;
	  };
	}
	
	function handleReset(state, fields) {
	  if (fields == null) {
	    // delete all recorded field events
	    return (0, _immutabilityHelper2.default)(state, { fields: { $set: _state.initialFieldsState } });
	  } else {
	    var _fields = normalizeFields(state, fields);
	    return (0, _immutabilityHelper2.default)(state, {
	      fields: {
	        change: { $apply: withoutKeys(_fields) },
	        blur: { $apply: withoutKeys(_fields) },
	        submit: { $apply: withoutKeys(_fields) },
	        isTyping: { $apply: withoutKeys(_fields) }
	      }
	    });
	  }
	}
	
	function handleFieldEvent(dispatchUpdate, field, event, debounce) {
	  dispatchUpdate(function (state) {
	    (0, _helpers.assertSpec)(EVENTS.indexOf(event) >= 0, 'Invalid event.', event, 'one of ' + EVENTS);
	
	    if (event === 'reset') {
	      return handleReset(state, field);
	    }
	
	    var fields = normalizeFields(state, field);
	    var debounces = {};
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	      for (var _iterator3 = fields[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	        var _f = _step3.value;
	
	        var nd = normalizeDebounce(state, _f, event, debounce);
	        if (nd > 0) {
	          debounces[_f] = nd;
	        }
	      }
	    } catch (err) {
	      _didIteratorError3 = true;
	      _iteratorError3 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion3 && _iterator3.return) {
	          _iterator3.return();
	        }
	      } finally {
	        if (_didIteratorError3) {
	          throw _iteratorError3;
	        }
	      }
	    }
	
	    var now = new Date().getTime();
	
	    var updateDesc = _defineProperty({}, event, { $apply: withKeys(fields, true) });
	
	    var _loop = function _loop(f) {
	      var d = debounces[f];
	      if (updateDesc.isTyping == null) {
	        updateDesc.isTyping = {};
	      }
	      updateDesc.isTyping[f] = { $set: now + d };
	
	      setTimeout(function () {
	        return dispatchUpdate(function (laterState) {
	          var isTyping = laterState.fields.isTyping;
	          if (isTyping[f] === now + d) {
	            return (0, _immutabilityHelper2.default)(laterState, { fields: { isTyping: { $apply: withoutKeys([f]) } } });
	          } else {
	            return laterState;
	          }
	        });
	      }, d);
	    };
	
	    for (var f in debounces) {
	      _loop(f);
	    }
	
	    if (event === 'submit' || event === 'blur') {
	      updateDesc.isTyping = { $apply: withoutKeys(fields) };
	    }
	
	    return (0, _immutabilityHelper2.default)(state, { fields: updateDesc });
	  });
	}
	
	function shouldShowValidation(validationFields, fields) {
	  var change = fields.change,
	      blur = fields.blur,
	      submit = fields.submit,
	      isTyping = fields.isTyping;
	
	  var _validationFields = _slicedToArray(validationFields, 2),
	      dependsOn = _validationFields[0],
	      needTouch = _validationFields[1];
	
	  var touched = needTouch.every(function (f) {
	    return f in change || f in blur || f in submit;
	  });
	  var typing = dependsOn.some(function (f) {
	    return isTyping[f] != null;
	  });
	  return touched && !typing;
	}

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.updateResults = updateResults;
	
	var _immutabilityHelper = __webpack_require__(116);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _lodash = __webpack_require__(30);
	
	var _state = __webpack_require__(115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function isResultValid(result) {
	  return result === true || result == null || result === [] || result === {};
	}
	
	function isPromise(obj) {
	  return obj != null && typeof obj.then === 'function';
	}
	
	//TODO why works this not? (bug in next?)
	//async function asyncAnd(rules) {
	//  for (let {name, pResult} of rules) {
	//    let result = await pResult
	//    if (!isResultValid(result)) {
	//      return {isValid: false, error: {reason: result, rule: name}}
	//    }
	//  }
	//  return {isValid: true, error: {}}
	//}
	
	function asyncAnd(rules) {
	  if (rules.length === 0) {
	    return { isValid: true, error: {} };
	  }
	  var _rules$ = rules[0],
	      name = _rules$.name,
	      pResult = _rules$.result;
	
	  return pResult.then(function (result) {
	    if (!isResultValid(result)) {
	      return { isValid: false, error: { reason: result, rule: name } };
	    } else {
	      return asyncAnd(rules.slice(1));
	    }
	  });
	}
	
	function and(rules) {
	  var asyncRules = [];
	  var wasPromise = false;
	  // resolve sync rules first to prevent server load, save async rules to array
	  // to deal with later
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = rules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var rule = _step.value;
	
	      var name = rule[0];
	      var fn = rule[1];
	      var args = rule.slice(2);
	      var result = fn.apply(null, args);
	      if (wasPromise || isPromise(result)) {
	        wasPromise = true;
	        asyncRules.push({ name: name, result: Promise.resolve(result) });
	      } else if (!isResultValid(result)) {
	        return { isValid: false, error: { reason: result, rule: name } };
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  if (asyncRules.length === 0) {
	    return { isValid: true, error: {} };
	  }
	  return asyncAnd(asyncRules);
	}
	
	function setLastAsyncFnStart(state, name, when) {
	  return (0, _immutabilityHelper2.default)(state, { results: _defineProperty({}, name, { lastAsyncFnStart: { $set: when } }) });
	}
	
	function setResult(state, name, result) {
	  return (0, _immutabilityHelper2.default)(state, { results: _defineProperty({}, name, { result: { $set: result } }) });
	}
	
	function runFn(state, name, dispatchUpdate) {
	  var lastFn = state.results[name].lastFn;
	
	  var r = lastFn();
	  if (!isPromise(r)) {
	    return setResult(state, name, r);
	  } else {
	    var s = setLastAsyncFnStart(state, name, new Date().getTime());
	    r.then(function (rr) {
	      dispatchUpdate(function (laterState) {
	        var laterLastFn = laterState.results[name].lastFn;
	
	        if (lastFn === laterLastFn) {
	          return setResult(laterState, name, rr);
	        } else {
	          return laterState;
	        }
	      });
	    });
	    return s;
	  }
	}
	
	function runLater(name, fn, timeout, dispatchUpdate) {
	  setTimeout(function () {
	    dispatchUpdate(function (state) {
	      var lastFn = state.results[name].lastFn;
	
	      if (fn !== lastFn) {
	        return state;
	      } else {
	        return runFn(state, name, dispatchUpdate);
	      }
	    });
	  }, timeout);
	}
	
	// Update results according to new config
	function updateResults(dispatchUpdate) {
	  dispatchUpdate(function (state) {
	    var config = state.config;
	
	    var oldResults = state.results;
	    var newState = (0, _immutabilityHelper2.default)(state, { results: { $set: _state.initialResultsState } });
	
	    var _loop = function _loop(name) {
	      var _config$validations$n = config.validations[name],
	          rules = _config$validations$n.rules,
	          debounce = _config$validations$n.debounce;
	
	
	      if (name in oldResults && (0, _lodash.isEqual)(rules, oldResults[name].rules)) {
	        // rules have not changed => no need to recalculate the result
	        newState = (0, _immutabilityHelper2.default)(newState, { results: _defineProperty({}, name, { $set: _extends({}, oldResults[name], { debounce: debounce }) }) });
	      } else {
	        var lastFn = function lastFn() {
	          return and(rules);
	        };
	
	        var _ref = oldResults[name] || {},
	            _ref$lastAsyncFnStart = _ref.lastAsyncFnStart,
	            lastAsyncFnStart = _ref$lastAsyncFnStart === undefined ? 0 : _ref$lastAsyncFnStart;
	
	        var result = { isValid: null, error: {} };
	
	        newState = (0, _immutabilityHelper2.default)(newState, { results: _defineProperty({}, name, { $set: { rules: rules, debounce: debounce, lastFn: lastFn, lastAsyncFnStart: lastAsyncFnStart, result: result } }) });
	
	        var nextRunIn = lastAsyncFnStart + debounce - new Date().getTime();
	
	        if (nextRunIn > 0) {
	          runLater(name, lastFn, nextRunIn, dispatchUpdate);
	        } else {
	          newState = runFn(newState, name, dispatchUpdate);
	        }
	      }
	    };
	
	    for (var name in config.validations) {
	      _loop(name);
	    }
	    return newState;
	  });
	}
	
	// TODO add this check in some form
	// for (let ruleName in rules) {
	//   // Unequality of rule functions could easily happen by providing a lambda function.
	//   // This would lead to an infinite loop, so we do not allow it.
	//   if (this.rules[ruleName] != null && this.rules[ruleName][0] !== rules[ruleName][0]) {
	//     throw new Error(
	//       'Changing the rule function (first argument) is not allowed. Note that \'() => {...}\' creates a ' +
	//       `different function anytime it is evaluated. Check the rule ${this.name}/${ruleName}.`)
	//   }
	// }

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetSubmit = resetSubmit;
	exports.updateSubmit = updateSubmit;
	exports.submit = submit;
	
	var _immutabilityHelper = __webpack_require__(116);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _helpers = __webpack_require__(94);
	
	var _state = __webpack_require__(115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _isFormValid(config, validationData) {
	  if (config.formValid != null) {
	    return config.formValid;
	  } else {
	    return (0, _helpers.isFormValid)(validationData);
	  }
	}
	
	function resetSubmit(state) {
	  return (0, _immutabilityHelper2.default)(state, { submit: { $set: _state.initialSubmitState } });
	}
	
	function updateSubmit(state) {
	  var _state$submit = state.submit,
	      isSubmitting = _state$submit.isSubmitting,
	      onValid = _state$submit.onValid,
	      onInvalid = _state$submit.onInvalid,
	      config = state.config,
	      validationData = state.validationData;
	
	  if (!isSubmitting) {
	    return state;
	  }
	  var valid = _isFormValid(config, validationData);
	  if (valid != null) {
	    if (valid === true && onValid != null) {
	      onValid();
	    } else if (onInvalid != null) {
	      onInvalid();
	    }
	    return resetSubmit(state);
	  }
	  return state;
	}
	
	function submit(state, onValid, onInvalid) {
	  var result = (0, _immutabilityHelper2.default)(state, { submit: { $set: { isSubmitting: true, onValid: onValid, onInvalid: onInvalid } } });
	  return updateSubmit(result);
	}

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.validated = validated;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutabilityHelper = __webpack_require__(116);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _lodash = __webpack_require__(30);
	
	var _config = __webpack_require__(740);
	
	var _fields = __webpack_require__(741);
	
	var _results = __webpack_require__(742);
	
	var _submit = __webpack_require__(743);
	
	var _state = __webpack_require__(115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function updateValidationData(state) {
	  var results = state.results,
	      fields = state.fields,
	      validations = state.config.validations;
	
	  var validationData = {};
	  for (var name in validations) {
	    validationData[name] = (0, _lodash.cloneDeep)(results[name].result);
	    validationData[name].show = (0, _fields.shouldShowValidation)(validations[name].fields, fields);
	  }
	  return (0, _immutabilityHelper2.default)(state, { validationData: { $set: validationData } });
	}
	
	function validated(getConfig) {
	  return function (Component) {
	    var _class, _temp2;
	
	    return _temp2 = _class = function (_React$Component) {
	      _inherits(_class, _React$Component);
	
	      function _class() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.fieldEvent = function (type, field, debounce) {
	          // Cancel submitting if user is still changing data in the form or if the
	          // form was reset
	          if (type === 'change' || type === 'reset') {
	            _this.registry = (0, _submit.resetSubmit)(_this.registry);
	          }
	
	          var dispatchUpdate = function dispatchUpdate(fn) {
	            var oldRegistry = _this.registry;
	            if (!_this.registry.isMounted) {
	              return;
	            }
	            _this.registry = fn(_this.registry);
	            _this.registry = updateValidationData(_this.registry);
	            _this.forceUpdateIfNeeded(oldRegistry, _this.registry);
	          };
	          (0, _fields.handleFieldEvent)(dispatchUpdate, field, type, debounce);
	        }, _this.field = function (field, handleChange, handleBlur, debounce) {
	          return {
	            onChange: function onChange(e) {
	              (handleChange || function () {})(e);
	              _this.fieldEvent('change', field, debounce);
	            },
	            onBlur: function onBlur(e) {
	              (handleBlur || function () {})(e);
	              _this.fieldEvent('blur', field, false);
	            }
	          };
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _createClass(_class, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	          this.shouldForceUpdate = false;
	          this.registry = (0, _state.initialState)((0, _config.normalizeConfig)(getConfig(this.props)));
	          this.componentWillReceiveProps(this.props);
	        }
	      }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          // forceUpdate should be called only on the client (it should not be called
	          // on the server during server-side rendering). We use componentDidMount
	          // (which is called only on the client) to distinguish client from server
	          this.shouldForceUpdate = true;
	        }
	      }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	          var _this2 = this;
	
	          var config = (0, _config.normalizeConfig)(getConfig(nextProps));
	
	          // Cancel submitting if user is still changing data in the form
	          if (!(0, _lodash.isEqual)(this.registry.config.validations, config.validations)) {
	            this.registry = (0, _submit.resetSubmit)(this.registry);
	          }
	
	          this.registry = (0, _immutabilityHelper2.default)(this.registry, { config: { $set: config } });
	
	          var dispatchUpdate = function dispatchUpdate(fn) {
	            var oldRegistry = _this2.registry;
	            if (!_this2.registry.isMounted) {
	              return;
	            }
	            _this2.registry = fn(_this2.registry);
	            _this2.registry = updateValidationData(_this2.registry);
	            _this2.registry = (0, _submit.updateSubmit)(_this2.registry);
	            _this2.forceUpdateIfNeeded(oldRegistry, _this2.registry);
	          };
	          (0, _results.updateResults)(dispatchUpdate);
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          this.registry = (0, _immutabilityHelper2.default)(this.registry, { isMounted: { $set: false } });
	        }
	      }, {
	        key: 'forceUpdateIfNeeded',
	        value: function forceUpdateIfNeeded(oldRegistry, newRegistry) {
	          // ensure that the decorated component gets new props
	          if (!(0, _lodash.isEqual)(oldRegistry.validationData, newRegistry.validationData)) {
	            this.shouldForceUpdate && this.forceUpdate();
	          }
	          // ensure that onValidation handler is called
	          var _newRegistry$config = newRegistry.config,
	              onValidation = _newRegistry$config.onValidation,
	              validations = _newRegistry$config.validations;
	
	          for (var name in validations) {
	            if (!(0, _lodash.isEqual)(oldRegistry.validationData[name], newRegistry.validationData[name])) {
	              onValidation(name, newRegistry.validationData[name]);
	            }
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _this3 = this;
	
	          var validationProps = {
	            $validation: this.registry.validationData,
	            $fieldEvent: this.fieldEvent,
	            $field: this.field,
	            $submit: function $submit(onValid, onInvalid) {
	              var fieldEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	              if (fieldEvent) {
	                _this3.fieldEvent('submit');
	              }
	              _this3.registry = (0, _submit.submit)(_this3.registry, onValid, onInvalid);
	            }
	          };
	          for (var p in validationProps) {
	            if (p in this.props) {
	              var message = 'Naming collision: validated component ' + (Component.name || Component.displayName) + ' ' + ('cannot receive prop ' + p + ', as this prop name is reserved by the validation library.');
	              throw new Error(message);
	            }
	          }
	          return _react2.default.createElement(Component, _extends({}, this.props, validationProps));
	        }
	      }]);
	
	      return _class;
	    }(_react2.default.Component), _class.displayName = 'Validated-' + (Component.name || Component.displayName), _temp2;
	  };
	}

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactLifecyclesCompat = __webpack_require__(45);
	
	var _Divider = _interopRequireDefault(__webpack_require__(752));
	
	var _DayInput = _interopRequireDefault(__webpack_require__(746));
	
	var _MonthInput = _interopRequireDefault(__webpack_require__(747));
	
	var _MonthSelect = _interopRequireDefault(__webpack_require__(748));
	
	var _YearInput = _interopRequireDefault(__webpack_require__(750));
	
	var _NativeInput = _interopRequireDefault(__webpack_require__(749));
	
	var _dateFormatter = __webpack_require__(405);
	
	var _dates = __webpack_require__(77);
	
	var _propTypes2 = __webpack_require__(58);
	
	var _utils = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var defaultMinDate = new Date(-8.64e15);
	var defaultMaxDate = new Date(8.64e15);
	var allViews = ['century', 'decade', 'year', 'month'];
	var allValueTypes = [].concat(_toConsumableArray(allViews.slice(1)), ['day']);
	
	var datesAreDifferent = function datesAreDifferent(date1, date2) {
	  return date1 && !date2 || !date1 && date2 || date1 && date2 && date1.getTime() !== date2.getTime();
	};
	/**
	 * Returns value type that can be returned with currently applied settings.
	 */
	
	
	var getValueType = function getValueType(maxDetail) {
	  return allValueTypes[allViews.indexOf(maxDetail)];
	};
	
	var getValueFromRange = function getValueFromRange(valueOrArrayOfValues, index) {
	  if (Array.isArray(valueOrArrayOfValues)) {
	    return valueOrArrayOfValues[index];
	  }
	
	  return valueOrArrayOfValues;
	};
	
	var parseAndValidateDate = function parseAndValidateDate(rawValue) {
	  if (!rawValue) {
	    return null;
	  }
	
	  var valueDate = new Date(rawValue);
	
	  if (isNaN(valueDate.getTime())) {
	    throw new Error("Invalid date: ".concat(rawValue));
	  }
	
	  return valueDate;
	};
	
	var getValueFrom = function getValueFrom(value) {
	  var valueFrom = getValueFromRange(value, 0);
	  return parseAndValidateDate(valueFrom);
	};
	
	var getDetailValueFrom = function getDetailValueFrom(value, minDate, maxDate, maxDetail) {
	  var valueFrom = getValueFrom(value);
	
	  if (!valueFrom) {
	    return null;
	  }
	
	  var detailValueFrom = (0, _dates.getBegin)(getValueType(maxDetail), valueFrom);
	  return (0, _utils.between)(detailValueFrom, minDate, maxDate);
	};
	
	var getValueTo = function getValueTo(value) {
	  var valueTo = getValueFromRange(value, 1);
	  return parseAndValidateDate(valueTo);
	};
	
	var getDetailValueTo = function getDetailValueTo(value, minDate, maxDate, maxDetail) {
	  var valueTo = getValueTo(value);
	
	  if (!valueTo) {
	    return null;
	  }
	
	  var detailValueTo = (0, _dates.getEnd)(getValueType(maxDetail), valueTo);
	  return (0, _utils.between)(detailValueTo, minDate, maxDate);
	};
	
	var getDetailValueArray = function getDetailValueArray(value, minDate, maxDate, maxDetail) {
	  if (value instanceof Array) {
	    return value;
	  }
	
	  return [getDetailValueFrom(value, minDate, maxDate, maxDetail), getDetailValueTo(value, minDate, maxDate, maxDetail)];
	};
	
	var isValidInput = function isValidInput(element) {
	  return element.tagName === 'INPUT' && element.type === 'number';
	};
	
	var findInput = function findInput(element, property) {
	  var nextElement = element;
	
	  do {
	    nextElement = nextElement[property];
	  } while (nextElement && !isValidInput(nextElement));
	
	  return nextElement;
	};
	
	var focus = function focus(element) {
	  return element && element.focus();
	};
	
	var _renderCustomInputs = function renderCustomInputs(placeholder, elementFunctions, allowMultipleInstances) {
	  var usedFunctions = [];
	  var pattern = new RegExp(Object.keys(elementFunctions).map(function (el) {
	    return "".concat(el, "+");
	  }).join('|'), 'g');
	  var matches = placeholder.match(pattern);
	  return placeholder.split(pattern).reduce(function (arr, element, index) {
	    var divider = element && // eslint-disable-next-line react/no-array-index-key
	    _react["default"].createElement(_Divider["default"], {
	      key: "separator_".concat(index)
	    }, element);
	
	    var res = [].concat(_toConsumableArray(arr), [divider]);
	    var currentMatch = matches && matches[index];
	
	    if (currentMatch) {
	      var renderFunction = elementFunctions[currentMatch] || elementFunctions[Object.keys(elementFunctions).find(function (elementFunction) {
	        return currentMatch.match(elementFunction);
	      })];
	
	      if (!allowMultipleInstances && usedFunctions.includes(renderFunction)) {
	        res.push(currentMatch);
	      } else {
	        res.push(renderFunction(currentMatch));
	        usedFunctions.push(renderFunction);
	      }
	    }
	
	    return res;
	  }, []);
	};
	
	var DateInput =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(DateInput, _PureComponent);
	
	  function DateInput() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, DateInput);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DateInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "state", {
	      year: null,
	      month: null,
	      day: null
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
	      if (event.target === event.currentTarget) {
	        // Wrapper was directly clicked
	        var firstInput = event.target.children[1];
	        focus(firstInput);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
	      switch (event.key) {
	        case 'ArrowLeft':
	        case 'ArrowRight':
	        case _this.divider:
	          {
	            event.preventDefault();
	            var input = event.target;
	            var property = event.key === 'ArrowLeft' ? 'previousElementSibling' : 'nextElementSibling';
	            var nextInput = findInput(input, property);
	            focus(nextInput);
	            break;
	          }
	
	        default:
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onKeyUp", function (event) {
	      var key = event.key,
	          input = event.target;
	      var isNumberKey = !isNaN(parseInt(key, 10));
	
	      if (!isNumberKey) {
	        return;
	      }
	
	      var value = input.value;
	      var max = parseInt(input.getAttribute('max'), 10);
	      /**
	       * Given 1, the smallest possible number the user could type by adding another digit is 10.
	       * 10 would be a valid value given max = 12, so we won't jump to the next input.
	       * However, given 2, smallers possible number would be 20, and thus keeping the focus in
	       * this field doesn't make sense.
	       */
	
	      if (value * 10 > max) {
	        var property = 'nextElementSibling';
	        var nextInput = findInput(input, property);
	        focus(nextInput);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onChange", function (event) {
	      var _event$target = event.target,
	          name = _event$target.name,
	          value = _event$target.value;
	
	      _this.setState(_defineProperty({}, name, value ? parseInt(value, 10) : null), _this.onChangeExternal);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onChangeNative", function (event) {
	      var onChange = _this.props.onChange;
	      var value = event.target.value;
	
	      if (!onChange) {
	        return;
	      }
	
	      var processedValue = function () {
	        if (!value) {
	          return null;
	        }
	
	        var _value$split = value.split('-'),
	            _value$split2 = _slicedToArray(_value$split, 3),
	            yearString = _value$split2[0],
	            monthString = _value$split2[1],
	            dayString = _value$split2[2];
	
	        var year = parseInt(yearString, 10);
	        var monthIndex = parseInt(monthString, 10) - 1 || 0;
	        var date = parseInt(dayString, 10) || 1;
	        return new Date(year, monthIndex, date);
	      }();
	
	      onChange(processedValue, false);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onChangeExternal", function () {
	      var onChange = _this.props.onChange;
	
	      if (!onChange) {
	        return;
	      }
	
	      var formElements = [_this.dayInput, _this.monthInput, _this.yearInput].filter(Boolean);
	      var values = {};
	      formElements.forEach(function (formElement) {
	        values[formElement.name] = formElement.value;
	      });
	
	      if (formElements.every(function (formElement) {
	        return !formElement.value;
	      })) {
	        onChange(null, false);
	      } else if (formElements.every(function (formElement) {
	        return formElement.value && formElement.checkValidity();
	      })) {
	        var year = parseInt(values.year, 10);
	        var month = parseInt(values.month || 1, 10);
	        var day = parseInt(values.day || 1, 10);
	        var proposedValue = new Date(year, month - 1, day);
	
	        var processedValue = _this.getProcessedValue(proposedValue);
	
	        onChange(processedValue, false);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "renderDay", function (currentMatch) {
	      var _this$props = _this.props,
	          dayAriaLabel = _this$props.dayAriaLabel,
	          dayPlaceholder = _this$props.dayPlaceholder,
	          showLeadingZeros = _this$props.showLeadingZeros;
	      var _this$state = _this.state,
	          day = _this$state.day,
	          month = _this$state.month,
	          year = _this$state.year;
	
	      if (currentMatch && currentMatch.length > 2) {
	        throw new Error("Unsupported token: ".concat(currentMatch));
	      }
	
	      var showLeadingZerosFromFormat = currentMatch && currentMatch.length === 2;
	      return _react["default"].createElement(_DayInput["default"], _extends({
	        key: "day"
	      }, _this.commonInputProps, {
	        ariaLabel: dayAriaLabel,
	        month: month,
	        placeholder: dayPlaceholder,
	        showLeadingZeros: showLeadingZerosFromFormat || showLeadingZeros,
	        value: day,
	        year: year
	      }));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "renderMonth", function (currentMatch) {
	      var _this$props2 = _this.props,
	          locale = _this$props2.locale,
	          monthAriaLabel = _this$props2.monthAriaLabel,
	          monthPlaceholder = _this$props2.monthPlaceholder,
	          showLeadingZeros = _this$props2.showLeadingZeros;
	      var _this$state2 = _this.state,
	          month = _this$state2.month,
	          year = _this$state2.year;
	
	      if (currentMatch && currentMatch.length > 4) {
	        throw new Error("Unsupported token: ".concat(currentMatch));
	      }
	
	      if (currentMatch.length > 2) {
	        return _react["default"].createElement(_MonthSelect["default"], _extends({
	          key: "month"
	        }, _this.commonInputProps, {
	          ariaLabel: monthAriaLabel,
	          locale: locale,
	          placeholder: monthPlaceholder,
	          "short": currentMatch.length === 3,
	          value: month,
	          year: year
	        }));
	      }
	
	      var showLeadingZerosFromFormat = currentMatch && currentMatch.length === 2;
	      return _react["default"].createElement(_MonthInput["default"], _extends({
	        key: "month"
	      }, _this.commonInputProps, {
	        ariaLabel: monthAriaLabel,
	        placeholder: monthPlaceholder,
	        showLeadingZeros: showLeadingZerosFromFormat || showLeadingZeros,
	        value: month,
	        year: year
	      }));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "renderYear", function () {
	      var _this$props3 = _this.props,
	          yearAriaLabel = _this$props3.yearAriaLabel,
	          yearPlaceholder = _this$props3.yearPlaceholder;
	      var year = _this.state.year;
	      return _react["default"].createElement(_YearInput["default"], _extends({
	        key: "year"
	      }, _this.commonInputProps, {
	        ariaLabel: yearAriaLabel,
	        placeholder: yearPlaceholder,
	        value: year,
	        valueType: _this.valueType
	      }));
	    });
	
	    return _this;
	  }
	
	  _createClass(DateInput, [{
	    key: "getProcessedValue",
	
	    /**
	     * Gets current value in a desired format.
	     */
	    value: function getProcessedValue(value) {
	      var _this$props4 = this.props,
	          minDate = _this$props4.minDate,
	          maxDate = _this$props4.maxDate,
	          maxDetail = _this$props4.maxDetail,
	          returnValue = _this$props4.returnValue;
	
	      switch (returnValue) {
	        case 'start':
	          return getDetailValueFrom(value, minDate, maxDate, maxDetail);
	
	        case 'end':
	          return getDetailValueTo(value, minDate, maxDate, maxDetail);
	
	        case 'range':
	          return getDetailValueArray(value, minDate, maxDate, maxDetail);
	
	        default:
	          throw new Error('Invalid returnValue.');
	      }
	    }
	  }, {
	    key: "renderCustomInputs",
	    value: function renderCustomInputs() {
	      var placeholder = this.placeholder;
	      var format = this.props.format;
	      var elementFunctions = {
	        d: this.renderDay,
	        M: this.renderMonth,
	        y: this.renderYear
	      };
	      var allowMultipleInstances = typeof format !== 'undefined';
	      return _renderCustomInputs(placeholder, elementFunctions, allowMultipleInstances);
	    }
	  }, {
	    key: "renderNativeInput",
	    value: function renderNativeInput() {
	      var _this$props5 = this.props,
	          disabled = _this$props5.disabled,
	          maxDate = _this$props5.maxDate,
	          minDate = _this$props5.minDate,
	          name = _this$props5.name,
	          nativeInputAriaLabel = _this$props5.nativeInputAriaLabel,
	          required = _this$props5.required;
	      var value = this.state.value;
	      return _react["default"].createElement(_NativeInput["default"], {
	        key: "date",
	        ariaLabel: nativeInputAriaLabel,
	        disabled: disabled,
	        maxDate: maxDate || defaultMaxDate,
	        minDate: minDate || defaultMinDate,
	        name: name,
	        onChange: this.onChangeNative,
	        required: required,
	        value: value,
	        valueType: this.valueType
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var className = this.props.className;
	      return _react["default"].createElement("div", {
	        className: className,
	        onClick: this.onClick,
	        role: "presentation"
	      }, this.renderNativeInput(), this.renderCustomInputs());
	    }
	  }, {
	    key: "formatDate",
	    get: function get() {
	      var maxDetail = this.props.maxDetail;
	      var options = {
	        year: 'numeric'
	      };
	      var level = allViews.indexOf(maxDetail);
	
	      if (level >= 2) {
	        options.month = 'numeric';
	      }
	
	      if (level >= 3) {
	        options.day = 'numeric';
	      }
	
	      return (0, _dateFormatter.getFormatter)(options);
	    } // eslint-disable-next-line class-methods-use-this
	
	  }, {
	    key: "formatNumber",
	    get: function get() {
	      var options = {
	        useGrouping: false
	      };
	      return (0, _dateFormatter.getFormatter)(options);
	    }
	  }, {
	    key: "divider",
	    get: function get() {
	      return this.placeholder.match(/[^0-9a-z]/i)[0];
	    }
	  }, {
	    key: "placeholder",
	    get: function get() {
	      var _this$props6 = this.props,
	          format = _this$props6.format,
	          locale = _this$props6.locale;
	
	      if (format) {
	        return format;
	      }
	
	      var year = 2017;
	      var monthIndex = 11;
	      var day = 11;
	      var date = new Date(year, monthIndex, day);
	      return this.formatDate(locale, date).replace(this.formatNumber(locale, year), 'y').replace(this.formatNumber(locale, monthIndex + 1), 'M').replace(this.formatNumber(locale, day), 'd');
	    }
	  }, {
	    key: "commonInputProps",
	    get: function get() {
	      var _this2 = this;
	
	      var _this$props7 = this.props,
	          className = _this$props7.className,
	          disabled = _this$props7.disabled,
	          isCalendarOpen = _this$props7.isCalendarOpen,
	          maxDate = _this$props7.maxDate,
	          minDate = _this$props7.minDate,
	          required = _this$props7.required;
	      return {
	        className: className,
	        disabled: disabled,
	        maxDate: maxDate || defaultMaxDate,
	        minDate: minDate || defaultMinDate,
	        onChange: this.onChange,
	        onKeyDown: this.onKeyDown,
	        onKeyUp: this.onKeyUp,
	        // This is only for showing validity when editing
	        required: required || isCalendarOpen,
	        itemRef: function itemRef(ref, name) {
	          // Save a reference to each input field
	          _this2["".concat(name, "Input")] = ref;
	        }
	      };
	    }
	  }, {
	    key: "valueType",
	    get: function get() {
	      var maxDetail = this.props.maxDetail;
	      return getValueType(maxDetail);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var minDate = nextProps.minDate,
	          maxDate = nextProps.maxDate,
	          maxDetail = nextProps.maxDetail;
	      var nextState = {};
	      /**
	       * If isCalendarOpen flag has changed, we have to update it.
	       * It's saved in state purely for use in getDerivedStateFromProps.
	       */
	
	      if (nextProps.isCalendarOpen !== prevState.isCalendarOpen) {
	        nextState.isCalendarOpen = nextProps.isCalendarOpen;
	      }
	      /**
	       * If the next value is different from the current one  (with an exception of situation in
	       * which values provided are limited by minDate and maxDate so that the dates are the same),
	       * get a new one.
	       */
	
	
	      var nextValue = getDetailValueFrom(nextProps.value, minDate, maxDate, maxDetail);
	      var values = [nextValue, prevState.value];
	
	      if ( // Toggling calendar visibility resets values
	      nextState.isCalendarOpen // Flag was toggled
	      || datesAreDifferent.apply(void 0, _toConsumableArray(values.map(function (value) {
	        return getDetailValueFrom(value, minDate, maxDate, maxDetail);
	      }))) || datesAreDifferent.apply(void 0, _toConsumableArray(values.map(function (value) {
	        return getDetailValueTo(value, minDate, maxDate, maxDetail);
	      })))) {
	        if (nextValue) {
	          nextState.year = (0, _dates.getYear)(nextValue);
	          nextState.month = (0, _dates.getMonth)(nextValue);
	          nextState.day = (0, _dates.getDay)(nextValue);
	        } else {
	          nextState.year = null;
	          nextState.month = null;
	          nextState.day = null;
	        }
	
	        nextState.value = nextValue;
	      }
	
	      return nextState;
	    }
	  }]);
	
	  return DateInput;
	}(_react.PureComponent);
	
	exports["default"] = DateInput;
	DateInput.defaultProps = {
	  maxDetail: 'month',
	  name: 'date',
	  returnValue: 'start'
	};
	
	var isValue = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)]);
	
	DateInput.propTypes = {
	  className: _propTypes["default"].string.isRequired,
	  dayAriaLabel: _propTypes["default"].string,
	  dayPlaceholder: _propTypes["default"].string,
	  disabled: _propTypes["default"].bool,
	  format: _propTypes["default"].string,
	  isCalendarOpen: _propTypes["default"].bool,
	  locale: _propTypes["default"].string,
	  maxDate: _propTypes2.isMaxDate,
	  maxDetail: _propTypes["default"].oneOf(allViews),
	  minDate: _propTypes2.isMinDate,
	  monthAriaLabel: _propTypes["default"].string,
	  monthPlaceholder: _propTypes["default"].string,
	  name: _propTypes["default"].string,
	  nativeInputAriaLabel: _propTypes["default"].string,
	  onChange: _propTypes["default"].func,
	  required: _propTypes["default"].bool,
	  returnValue: _propTypes["default"].oneOf(['start', 'end', 'range']),
	  showLeadingZeros: _propTypes["default"].bool,
	  value: _propTypes["default"].oneOfType([isValue, _propTypes["default"].arrayOf(isValue)]),
	  yearAriaLabel: _propTypes["default"].string,
	  yearPlaceholder: _propTypes["default"].string
	};
	(0, _reactLifecyclesCompat.polyfill)(DateInput);

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = DayInput;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Input = _interopRequireDefault(__webpack_require__(159));
	
	var _dates = __webpack_require__(77);
	
	var _propTypes2 = __webpack_require__(58);
	
	var _utils = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function DayInput(_ref) {
	  var maxDate = _ref.maxDate,
	      minDate = _ref.minDate,
	      month = _ref.month,
	      year = _ref.year,
	      otherProps = _objectWithoutProperties(_ref, ["maxDate", "minDate", "month", "year"]);
	
	  var currentMonthMaxDays = function () {
	    if (!month) {
	      return 31;
	    }
	
	    return (0, _dates.getDaysInMonth)(new Date(year, month - 1, 1));
	  }();
	
	  var maxDay = (0, _utils.min)(currentMonthMaxDays, maxDate && year === (0, _dates.getYear)(maxDate) && month === (0, _dates.getMonth)(maxDate) && (0, _dates.getDay)(maxDate));
	  var minDay = (0, _utils.max)(1, minDate && year === (0, _dates.getYear)(minDate) && month === (0, _dates.getMonth)(minDate) && (0, _dates.getDay)(minDate));
	  return _react["default"].createElement(_Input["default"], _extends({
	    max: maxDay,
	    min: minDay,
	    name: "day"
	  }, otherProps));
	}
	
	DayInput.propTypes = {
	  ariaLabel: _propTypes["default"].string,
	  className: _propTypes["default"].string.isRequired,
	  disabled: _propTypes["default"].bool,
	  itemRef: _propTypes["default"].func,
	  maxDate: _propTypes2.isMaxDate,
	  minDate: _propTypes2.isMinDate,
	  month: _propTypes["default"].number,
	  onChange: _propTypes["default"].func,
	  onKeyDown: _propTypes["default"].func,
	  onKeyUp: _propTypes["default"].func,
	  placeholder: _propTypes["default"].string,
	  required: _propTypes["default"].bool,
	  showLeadingZeros: _propTypes["default"].bool,
	  value: _propTypes["default"].number,
	  year: _propTypes["default"].number
	};

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = MonthInput;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Input = _interopRequireDefault(__webpack_require__(159));
	
	var _dates = __webpack_require__(77);
	
	var _propTypes2 = __webpack_require__(58);
	
	var _utils = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function MonthInput(_ref) {
	  var maxDate = _ref.maxDate,
	      minDate = _ref.minDate,
	      year = _ref.year,
	      otherProps = _objectWithoutProperties(_ref, ["maxDate", "minDate", "year"]);
	
	  var maxMonth = (0, _utils.min)(12, maxDate && year === (0, _dates.getYear)(maxDate) && (0, _dates.getMonth)(maxDate));
	  var minMonth = (0, _utils.max)(1, minDate && year === (0, _dates.getYear)(minDate) && (0, _dates.getMonth)(minDate));
	  return _react["default"].createElement(_Input["default"], _extends({
	    max: maxMonth,
	    min: minMonth,
	    name: "month"
	  }, otherProps));
	}
	
	MonthInput.propTypes = {
	  ariaLabel: _propTypes["default"].string,
	  className: _propTypes["default"].string.isRequired,
	  disabled: _propTypes["default"].bool,
	  itemRef: _propTypes["default"].func,
	  maxDate: _propTypes2.isMaxDate,
	  minDate: _propTypes2.isMinDate,
	  onChange: _propTypes["default"].func,
	  onKeyDown: _propTypes["default"].func,
	  onKeyUp: _propTypes["default"].func,
	  placeholder: _propTypes["default"].string,
	  required: _propTypes["default"].bool,
	  showLeadingZeros: _propTypes["default"].bool,
	  value: _propTypes["default"].number,
	  year: _propTypes["default"].number
	};

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = MonthSelect;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _mergeClassNames = _interopRequireDefault(__webpack_require__(93));
	
	var _dates = __webpack_require__(77);
	
	var _dateFormatter = __webpack_require__(405);
	
	var _propTypes2 = __webpack_require__(58);
	
	var _utils = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function MonthSelect(_ref) {
	  var ariaLabel = _ref.ariaLabel,
	      className = _ref.className,
	      itemRef = _ref.itemRef,
	      locale = _ref.locale,
	      maxDate = _ref.maxDate,
	      minDate = _ref.minDate,
	      _short = _ref["short"],
	      year = _ref.year,
	      value = _ref.value,
	      placeholder = _ref.placeholder,
	      otherProps = _objectWithoutProperties(_ref, ["ariaLabel", "className", "itemRef", "locale", "maxDate", "minDate", "short", "year", "value", "placeholder"]);
	
	  var maxMonth = (0, _utils.min)(12, maxDate && year === (0, _dates.getYear)(maxDate) && (0, _dates.getMonth)(maxDate));
	  var minMonth = (0, _utils.max)(1, minDate && year === (0, _dates.getYear)(minDate) && (0, _dates.getMonth)(minDate));
	
	  var dates = _toConsumableArray(Array(12)).map(function (el, index) {
	    return new Date(2019, index, 1);
	  });
	
	  var name = 'month';
	  var formatter = _short ? _dateFormatter.formatShortMonth : _dateFormatter.formatMonth;
	  return _react["default"].createElement("select", _extends({
	    "aria-label": ariaLabel,
	    className: (0, _mergeClassNames["default"])("".concat(className, "__input"), "".concat(className, "__").concat(name)),
	    name: name,
	    ref: function ref(_ref2) {
	      if (itemRef) {
	        itemRef(_ref2, name);
	      }
	    },
	    value: value !== null ? value : ''
	  }, otherProps), !value && _react["default"].createElement("option", {
	    value: ""
	  }, placeholder), dates.map(function (date) {
	    var month = (0, _dates.getMonth)(date);
	    var disabled = month < minMonth || month > maxMonth;
	    return _react["default"].createElement("option", {
	      key: month,
	      disabled: disabled,
	      value: month
	    }, formatter(locale, date));
	  }));
	}
	
	MonthSelect.propTypes = {
	  ariaLabel: _propTypes["default"].string,
	  className: _propTypes["default"].string.isRequired,
	  disabled: _propTypes["default"].bool,
	  itemRef: _propTypes["default"].func,
	  locale: _propTypes["default"].string,
	  maxDate: _propTypes2.isMaxDate,
	  minDate: _propTypes2.isMinDate,
	  onChange: _propTypes["default"].func,
	  onKeyDown: _propTypes["default"].func,
	  onKeyUp: _propTypes["default"].func,
	  placeholder: _propTypes["default"].string,
	  required: _propTypes["default"].bool,
	  "short": _propTypes["default"].bool,
	  value: _propTypes["default"].number,
	  year: _propTypes["default"].number
	};
	MonthSelect.defaultProps = {
	  placeholder: '--'
	};

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = NativeInput;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _dates = __webpack_require__(77);
	
	var _propTypes2 = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function NativeInput(_ref) {
	  var ariaLabel = _ref.ariaLabel,
	      disabled = _ref.disabled,
	      maxDate = _ref.maxDate,
	      minDate = _ref.minDate,
	      name = _ref.name,
	      onChange = _ref.onChange,
	      required = _ref.required,
	      value = _ref.value,
	      valueType = _ref.valueType;
	
	  var nativeInputType = function () {
	    switch (valueType) {
	      case 'decade':
	      case 'year':
	        return 'number';
	
	      case 'month':
	        return 'month';
	
	      case 'day':
	        return 'date';
	
	      default:
	        throw new Error('Invalid valueType.');
	    }
	  }();
	
	  var nativeValueParser = function () {
	    switch (valueType) {
	      case 'century':
	      case 'decade':
	      case 'year':
	        return _dates.getYear;
	
	      case 'month':
	        return _dates.getISOLocalMonth;
	
	      case 'day':
	        return _dates.getISOLocalDate;
	
	      default:
	        throw new Error('Invalid valueType.');
	    }
	  }();
	
	  function stopPropagation(event) {
	    event.stopPropagation();
	  }
	
	  return _react["default"].createElement("input", {
	    "aria-label": ariaLabel,
	    disabled: disabled,
	    max: maxDate ? nativeValueParser(maxDate) : null,
	    min: minDate ? nativeValueParser(minDate) : null,
	    name: name,
	    onChange: onChange,
	    onFocus: stopPropagation,
	    required: required,
	    style: {
	      visibility: 'hidden',
	      position: 'absolute',
	      top: '-9999px',
	      left: '-9999px'
	    },
	    type: nativeInputType,
	    value: value ? nativeValueParser(value) : ''
	  });
	}
	
	NativeInput.propTypes = {
	  ariaLabel: _propTypes["default"].string,
	  disabled: _propTypes["default"].bool,
	  maxDate: _propTypes2.isMaxDate,
	  minDate: _propTypes2.isMinDate,
	  name: _propTypes["default"].string,
	  onChange: _propTypes["default"].func,
	  required: _propTypes["default"].bool,
	  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)]),
	  valueType: _propTypes2.isValueType
	};

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = YearInput;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Input = _interopRequireDefault(__webpack_require__(159));
	
	var _dates = __webpack_require__(77);
	
	var _propTypes2 = __webpack_require__(58);
	
	var _utils = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function YearInput(_ref) {
	  var maxDate = _ref.maxDate,
	      minDate = _ref.minDate,
	      valueType = _ref.valueType,
	      otherProps = _objectWithoutProperties(_ref, ["maxDate", "minDate", "valueType"]);
	
	  var maxYear = (0, _utils.min)(275760, maxDate && (0, _dates.getYear)(maxDate));
	  var minYear = (0, _utils.max)(1000, minDate && (0, _dates.getYear)(minDate));
	
	  var yearStep = function () {
	    if (valueType === 'century') {
	      return 10;
	    }
	
	    return 1;
	  }();
	
	  return _react["default"].createElement(_Input["default"], _extends({
	    max: maxYear,
	    min: minYear,
	    name: "year",
	    step: yearStep
	  }, otherProps));
	}
	
	YearInput.propTypes = {
	  ariaLabel: _propTypes["default"].string,
	  className: _propTypes["default"].string.isRequired,
	  disabled: _propTypes["default"].bool,
	  itemRef: _propTypes["default"].func,
	  maxDate: _propTypes2.isMaxDate,
	  minDate: _propTypes2.isMinDate,
	  onChange: _propTypes["default"].func,
	  onKeyDown: _propTypes["default"].func,
	  onKeyUp: _propTypes["default"].func,
	  placeholder: _propTypes["default"].string,
	  required: _propTypes["default"].bool,
	  value: _propTypes["default"].number,
	  valueType: _propTypes2.isValueType
	};
	YearInput.defaultProps = {
	  placeholder: '----'
	};

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactLifecyclesCompat = __webpack_require__(45);
	
	var _makeEventProps = _interopRequireDefault(__webpack_require__(680));
	
	var _mergeClassNames = _interopRequireDefault(__webpack_require__(93));
	
	var _reactFit = _interopRequireDefault(__webpack_require__(832));
	
	var _entry = _interopRequireDefault(__webpack_require__(767));
	
	var _DateInput = _interopRequireDefault(__webpack_require__(745));
	
	var _propTypes2 = __webpack_require__(58);
	
	var _utils = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var baseClassName = 'react-date-picker';
	var outsideActionEvents = ['mousedown', 'focusin', 'touchstart'];
	var allViews = ['century', 'decade', 'year', 'month'];
	
	var DatePicker =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(DatePicker, _PureComponent);
	
	  function DatePicker() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, DatePicker);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DatePicker)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "state", {});
	
	    _defineProperty(_assertThisInitialized(_this), "onOutsideAction", function (event) {
	      if (_this.wrapper && !_this.wrapper.contains(event.target)) {
	        _this.closeCalendar();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
	      var closeCalendar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      _this.setState({
	        isOpen: !closeCalendar
	      });
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange(value);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onFocus", function (event) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          onFocus = _this$props.onFocus;
	
	      if (onFocus) {
	        onFocus(event);
	      } // Internet Explorer still fires onFocus on disabled elements
	
	
	      if (disabled) {
	        return;
	      }
	
	      _this.openCalendar();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "openCalendar", function () {
	      _this.setState({
	        isOpen: true
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "closeCalendar", function () {
	      _this.setState(function (prevState) {
	        if (!prevState.isOpen) {
	          return null;
	        }
	
	        return {
	          isOpen: false
	        };
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "toggleCalendar", function () {
	      _this.setState(function (prevState) {
	        return {
	          isOpen: !prevState.isOpen
	        };
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "stopPropagation", function (event) {
	      return event.stopPropagation();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "clear", function () {
	      return _this.onChange(null);
	    });
	
	    return _this;
	  }
	
	  _createClass(DatePicker, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.handleOutsideActionListeners();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      var isOpen = this.state.isOpen;
	      var _this$props2 = this.props,
	          onCalendarClose = _this$props2.onCalendarClose,
	          onCalendarOpen = _this$props2.onCalendarOpen;
	
	      if (isOpen !== prevState.isOpen) {
	        this.handleOutsideActionListeners();
	        (0, _utils.callIfDefined)(isOpen ? onCalendarOpen : onCalendarClose);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.handleOutsideActionListeners(false);
	    }
	  }, {
	    key: "handleOutsideActionListeners",
	    value: function handleOutsideActionListeners(shouldListen) {
	      var _this2 = this;
	
	      var isOpen = this.state.isOpen;
	      var shouldListenWithFallback = typeof shouldListen !== 'undefined' ? shouldListen : isOpen;
	      var fnName = shouldListenWithFallback ? 'addEventListener' : 'removeEventListener';
	      outsideActionEvents.forEach(function (eventName) {
	        return document[fnName](eventName, _this2.onOutsideAction);
	      });
	    }
	  }, {
	    key: "renderInputs",
	    value: function renderInputs() {
	      var _this$props3 = this.props,
	          calendarAriaLabel = _this$props3.calendarAriaLabel,
	          calendarIcon = _this$props3.calendarIcon,
	          clearAriaLabel = _this$props3.clearAriaLabel,
	          clearIcon = _this$props3.clearIcon,
	          dayAriaLabel = _this$props3.dayAriaLabel,
	          dayPlaceholder = _this$props3.dayPlaceholder,
	          disableCalendar = _this$props3.disableCalendar,
	          disabled = _this$props3.disabled,
	          format = _this$props3.format,
	          locale = _this$props3.locale,
	          maxDate = _this$props3.maxDate,
	          maxDetail = _this$props3.maxDetail,
	          minDate = _this$props3.minDate,
	          monthAriaLabel = _this$props3.monthAriaLabel,
	          monthPlaceholder = _this$props3.monthPlaceholder,
	          name = _this$props3.name,
	          nativeInputAriaLabel = _this$props3.nativeInputAriaLabel,
	          required = _this$props3.required,
	          returnValue = _this$props3.returnValue,
	          showLeadingZeros = _this$props3.showLeadingZeros,
	          value = _this$props3.value,
	          yearAriaLabel = _this$props3.yearAriaLabel,
	          yearPlaceholder = _this$props3.yearPlaceholder;
	      var isOpen = this.state.isOpen;
	
	      var _concat = [].concat(value),
	          _concat2 = _slicedToArray(_concat, 1),
	          valueFrom = _concat2[0];
	
	      var ariaLabelProps = {
	        dayAriaLabel: dayAriaLabel,
	        monthAriaLabel: monthAriaLabel,
	        nativeInputAriaLabel: nativeInputAriaLabel,
	        yearAriaLabel: yearAriaLabel
	      };
	      var placeholderProps = {
	        dayPlaceholder: dayPlaceholder,
	        monthPlaceholder: monthPlaceholder,
	        yearPlaceholder: yearPlaceholder
	      };
	      return _react["default"].createElement("div", {
	        className: "".concat(baseClassName, "__wrapper")
	      }, _react["default"].createElement(_DateInput["default"], _extends({}, ariaLabelProps, placeholderProps, {
	        className: "".concat(baseClassName, "__inputGroup"),
	        disabled: disabled,
	        format: format,
	        isCalendarOpen: isOpen,
	        locale: locale,
	        maxDate: maxDate,
	        maxDetail: maxDetail,
	        minDate: minDate,
	        name: name,
	        onChange: this.onChange,
	        required: required,
	        returnValue: returnValue,
	        showLeadingZeros: showLeadingZeros,
	        value: valueFrom
	      })), clearIcon !== null && _react["default"].createElement("button", {
	        "aria-label": clearAriaLabel,
	        className: "".concat(baseClassName, "__clear-button ").concat(baseClassName, "__button"),
	        disabled: disabled,
	        onClick: this.clear,
	        onFocus: this.stopPropagation,
	        type: "button"
	      }, clearIcon), calendarIcon !== null && !disableCalendar && _react["default"].createElement("button", {
	        "aria-label": calendarAriaLabel,
	        className: "".concat(baseClassName, "__calendar-button ").concat(baseClassName, "__button"),
	        disabled: disabled,
	        onBlur: this.resetValue,
	        onClick: this.toggleCalendar,
	        onFocus: this.stopPropagation,
	        type: "button"
	      }, calendarIcon));
	    }
	  }, {
	    key: "renderCalendar",
	    value: function renderCalendar() {
	      var disableCalendar = this.props.disableCalendar;
	      var isOpen = this.state.isOpen;
	
	      if (isOpen === null || disableCalendar) {
	        return null;
	      }
	
	      var _this$props4 = this.props,
	          calendarClassName = _this$props4.calendarClassName,
	          datePickerClassName = _this$props4.className,
	          onChange = _this$props4.onChange,
	          value = _this$props4.value,
	          calendarProps = _objectWithoutProperties(_this$props4, ["calendarClassName", "className", "onChange", "value"]);
	
	      var className = "".concat(baseClassName, "__calendar");
	      return _react["default"].createElement(_reactFit["default"], null, _react["default"].createElement("div", {
	        className: (0, _mergeClassNames["default"])(className, "".concat(className, "--").concat(isOpen ? 'open' : 'closed'))
	      }, _react["default"].createElement(_entry["default"], _extends({
	        className: calendarClassName,
	        onChange: this.onChange,
	        value: value || null
	      }, calendarProps))));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _this$props5 = this.props,
	          className = _this$props5.className,
	          disabled = _this$props5.disabled;
	      var isOpen = this.state.isOpen;
	      return _react["default"].createElement("div", _extends({
	        className: (0, _mergeClassNames["default"])(baseClassName, "".concat(baseClassName, "--").concat(isOpen ? 'open' : 'closed'), "".concat(baseClassName, "--").concat(disabled ? 'disabled' : 'enabled'), className)
	      }, this.eventProps, {
	        onFocus: this.onFocus,
	        ref: function ref(_ref) {
	          if (!_ref) {
	            return;
	          }
	
	          _this3.wrapper = _ref;
	        }
	      }), this.renderInputs(), this.renderCalendar());
	    }
	  }, {
	    key: "eventProps",
	    get: function get() {
	      return (0, _makeEventProps["default"])(this.props);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      if (nextProps.isOpen !== prevState.isOpenProps) {
	        return {
	          isOpen: nextProps.isOpen,
	          isOpenProps: nextProps.isOpen
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return DatePicker;
	}(_react.PureComponent);
	
	exports["default"] = DatePicker;
	var iconProps = {
	  xmlns: 'http://www.w3.org/2000/svg',
	  width: 19,
	  height: 19,
	  viewBox: '0 0 19 19',
	  stroke: 'black',
	  strokeWidth: 2
	};
	
	var CalendarIcon = _react["default"].createElement("svg", _extends({}, iconProps, {
	  className: "".concat(baseClassName, "__calendar-button__icon ").concat(baseClassName, "__button__icon")
	}), _react["default"].createElement("rect", {
	  fill: "none",
	  height: "15",
	  width: "15",
	  x: "2",
	  y: "2"
	}), _react["default"].createElement("line", {
	  x1: "6",
	  x2: "6",
	  y1: "0",
	  y2: "4"
	}), _react["default"].createElement("line", {
	  x1: "13",
	  x2: "13",
	  y1: "0",
	  y2: "4"
	}));
	
	var ClearIcon = _react["default"].createElement("svg", _extends({}, iconProps, {
	  className: "".concat(baseClassName, "__clear-button__icon ").concat(baseClassName, "__button__icon")
	}), _react["default"].createElement("line", {
	  x1: "4",
	  x2: "15",
	  y1: "4",
	  y2: "15"
	}), _react["default"].createElement("line", {
	  x1: "15",
	  x2: "4",
	  y1: "4",
	  y2: "15"
	}));
	
	DatePicker.defaultProps = {
	  calendarIcon: CalendarIcon,
	  clearIcon: ClearIcon,
	  isOpen: null,
	  returnValue: 'start'
	};
	
	var isValue = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)]);
	
	DatePicker.propTypes = {
	  calendarAriaLabel: _propTypes["default"].string,
	  calendarClassName: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
	  calendarIcon: _propTypes["default"].node,
	  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
	  clearAriaLabel: _propTypes["default"].string,
	  clearIcon: _propTypes["default"].node,
	  dayAriaLabel: _propTypes["default"].string,
	  dayPlaceholder: _propTypes["default"].string,
	  disableCalendar: _propTypes["default"].bool,
	  disabled: _propTypes["default"].bool,
	  format: _propTypes["default"].string,
	  isOpen: _propTypes["default"].bool,
	  locale: _propTypes["default"].string,
	  maxDate: _propTypes2.isMaxDate,
	  maxDetail: _propTypes["default"].oneOf(allViews),
	  minDate: _propTypes2.isMinDate,
	  monthAriaLabel: _propTypes["default"].string,
	  monthPlaceholder: _propTypes["default"].string,
	  name: _propTypes["default"].string,
	  nativeInputAriaLabel: _propTypes["default"].string,
	  onCalendarClose: _propTypes["default"].func,
	  onCalendarOpen: _propTypes["default"].func,
	  onChange: _propTypes["default"].func,
	  onFocus: _propTypes["default"].func,
	  required: _propTypes["default"].bool,
	  returnValue: _propTypes["default"].oneOf(['start', 'end', 'range']),
	  showLeadingZeros: _propTypes["default"].bool,
	  value: _propTypes["default"].oneOfType([isValue, _propTypes["default"].arrayOf(isValue)]),
	  yearAriaLabel: _propTypes["default"].string,
	  yearPlaceholder: _propTypes["default"].string
	};
	(0, _reactLifecyclesCompat.polyfill)(DatePicker);

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Divider;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function Divider(_ref) {
	  var children = _ref.children;
	  return _react["default"].createElement("span", {
	    className: "react-date-picker__inputGroup__divider"
	  }, children);
	}
	
	Divider.propTypes = {
	  children: _propTypes["default"].node
	};

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	__webpack_require__(613);
	
	var _DatePicker = _interopRequireDefault(__webpack_require__(751));
	
	__webpack_require__(612);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// File is created during build phase and placed in dist directory
	// eslint-disable-next-line import/no-unresolved
	var _default = _DatePicker["default"];
	exports["default"] = _default;

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactLifecyclesCompat = __webpack_require__(45);
	
	var _mergeClassNames = _interopRequireDefault(__webpack_require__(93));
	
	var _Navigation = _interopRequireDefault(__webpack_require__(755));
	
	var _CenturyView = _interopRequireDefault(__webpack_require__(406));
	
	var _DecadeView = _interopRequireDefault(__webpack_require__(407));
	
	var _YearView = _interopRequireDefault(__webpack_require__(409));
	
	var _MonthView = _interopRequireDefault(__webpack_require__(408));
	
	var _dates = __webpack_require__(27);
	
	var _propTypes2 = __webpack_require__(25);
	
	var _utils = __webpack_require__(161);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var baseClassName = 'react-calendar';
	var allViews = ['century', 'decade', 'year', 'month'];
	var allValueTypes = [].concat(_toConsumableArray(allViews.slice(1)), ['day']);
	
	var datesAreDifferent = function datesAreDifferent(date1, date2) {
	  return date1 && !date2 || !date1 && date2 || date1 && date2 && date1.getTime() !== date2.getTime();
	};
	/**
	 * Returns views array with disallowed values cut off.
	 */
	
	
	var getLimitedViews = function getLimitedViews(minDetail, maxDetail) {
	  return allViews.slice(allViews.indexOf(minDetail), allViews.indexOf(maxDetail) + 1);
	};
	/**
	 * Determines whether a given view is allowed with currently applied settings.
	 */
	
	
	var isViewAllowed = function isViewAllowed(view, minDetail, maxDetail) {
	  var views = getLimitedViews(minDetail, maxDetail);
	  return views.indexOf(view) !== -1;
	};
	/**
	 * Gets either provided view if allowed by minDetail and maxDetail, or gets
	 * the default view if not allowed.
	 */
	
	
	var getView = function getView(view, minDetail, maxDetail) {
	  if (isViewAllowed(view, minDetail, maxDetail)) {
	    return view;
	  }
	
	  return getLimitedViews(minDetail, maxDetail).pop();
	};
	/**
	 * Returns value type that can be returned with currently applied settings.
	 */
	
	
	var getValueType = function getValueType(maxDetail) {
	  return allValueTypes[allViews.indexOf(maxDetail)];
	};
	
	var getValueFrom = function getValueFrom(value) {
	  if (!value) {
	    return null;
	  }
	
	  var rawValueFrom = value instanceof Array && value.length === 2 ? value[0] : value;
	
	  if (!rawValueFrom) {
	    return null;
	  }
	
	  var valueFromDate = new Date(rawValueFrom);
	
	  if (isNaN(valueFromDate.getTime())) {
	    throw new Error("Invalid date: ".concat(value));
	  }
	
	  return valueFromDate;
	};
	
	var getDetailValueFrom = function getDetailValueFrom(value, minDate, maxDate, maxDetail) {
	  var valueFrom = getValueFrom(value);
	
	  if (!valueFrom) {
	    return null;
	  }
	
	  var detailValueFrom = (0, _dates.getBegin)(getValueType(maxDetail), valueFrom);
	  return (0, _utils.between)(detailValueFrom, minDate, maxDate);
	};
	
	var getValueTo = function getValueTo(value) {
	  if (!value) {
	    return null;
	  }
	
	  var rawValueTo = value instanceof Array && value.length === 2 ? value[1] : value;
	
	  if (!rawValueTo) {
	    return null;
	  }
	
	  var valueToDate = new Date(rawValueTo);
	
	  if (isNaN(valueToDate.getTime())) {
	    throw new Error("Invalid date: ".concat(value));
	  }
	
	  return valueToDate;
	};
	
	var getDetailValueTo = function getDetailValueTo(value, minDate, maxDate, maxDetail) {
	  var valueTo = getValueTo(value);
	
	  if (!valueTo) {
	    return null;
	  }
	
	  var detailValueTo = (0, _dates.getEnd)(getValueType(maxDetail), valueTo);
	  return (0, _utils.between)(detailValueTo, minDate, maxDate);
	};
	
	var getDetailValueArray = function getDetailValueArray(value, minDate, maxDate, maxDetail) {
	  if (value instanceof Array) {
	    return value;
	  }
	
	  return [getDetailValueFrom(value, minDate, maxDate, maxDetail), getDetailValueTo(value, minDate, maxDate, maxDetail)];
	};
	
	var getActiveStartDate = function getActiveStartDate(props) {
	  var activeStartDate = props.activeStartDate,
	      maxDate = props.maxDate,
	      maxDetail = props.maxDetail,
	      minDate = props.minDate,
	      minDetail = props.minDetail,
	      value = props.value,
	      view = props.view;
	  var rangeType = getView(view, minDetail, maxDetail);
	  var valueFrom = getDetailValueFrom(value, minDate, maxDate, maxDetail) || activeStartDate || new Date();
	  return (0, _dates.getBegin)(rangeType, valueFrom);
	};
	
	var Calendar =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Calendar, _Component);
	
	  function Calendar() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Calendar);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Calendar)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "state", {});
	
	    _defineProperty(_assertThisInitialized(_this), "setActiveStartDate", function (activeStartDate) {
	      var onActiveDateChange = _this.props.onActiveDateChange;
	
	      _this.setState({
	        activeStartDate: activeStartDate
	      }, function () {
	        var view = _this.state.view;
	        (0, _utils.callIfDefined)(onActiveDateChange, {
	          activeStartDate: activeStartDate,
	          view: view
	        });
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "drillDown", function (activeStartDate) {
	      if (!_this.drillDownAvailable) {
	        return;
	      }
	
	      var _this$props = _this.props,
	          maxDetail = _this$props.maxDetail,
	          minDetail = _this$props.minDetail,
	          onDrillDown = _this$props.onDrillDown;
	      var views = getLimitedViews(minDetail, maxDetail);
	
	      _this.setState(function (prevState) {
	        var nextView = views[views.indexOf(prevState.view) + 1];
	        return {
	          activeStartDate: activeStartDate,
	          view: nextView
	        };
	      }, function () {
	        var view = _this.state.view;
	        (0, _utils.callIfDefined)(onDrillDown, {
	          activeStartDate: activeStartDate,
	          view: view
	        });
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "drillUp", function () {
	      if (!_this.drillUpAvailable) {
	        return;
	      }
	
	      var _this$props2 = _this.props,
	          maxDetail = _this$props2.maxDetail,
	          minDetail = _this$props2.minDetail,
	          onDrillUp = _this$props2.onDrillUp;
	      var views = getLimitedViews(minDetail, maxDetail);
	
	      _this.setState(function (prevState) {
	        var nextView = views[views.indexOf(prevState.view) - 1];
	        var activeStartDate = (0, _dates.getBegin)(nextView, prevState.activeStartDate);
	        return {
	          activeStartDate: activeStartDate,
	          view: nextView
	        };
	      }, function () {
	        var _this$state = _this.state,
	            activeStartDate = _this$state.activeStartDate,
	            view = _this$state.view;
	        (0, _utils.callIfDefined)(onDrillUp, {
	          activeStartDate: activeStartDate,
	          view: view
	        });
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
	      var _this$props3 = _this.props,
	          onChange = _this$props3.onChange,
	          selectRange = _this$props3.selectRange;
	      var nextValue;
	      var callback;
	
	      if (selectRange) {
	        var previousValue = _this.state.value; // Range selection turned on
	
	        if (!previousValue || [].concat(previousValue).length !== 1 // 0 or 2 - either way we're starting a new array
	        ) {
	            // First value
	            nextValue = (0, _dates.getBegin)(_this.valueType, value);
	          } else {
	          // Second value
	          nextValue = (0, _dates.getValueRange)(_this.valueType, previousValue, value);
	
	          callback = function callback() {
	            return (0, _utils.callIfDefined)(onChange, nextValue);
	          };
	        }
	      } else {
	        // Range selection turned off
	        nextValue = _this.getProcessedValue(value);
	
	        callback = function callback() {
	          return (0, _utils.callIfDefined)(onChange, nextValue);
	        };
	      }
	
	      _this.setState({
	        value: nextValue
	      }, callback);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMouseOver", function (value) {
	      _this.setState(function (prevState) {
	        if (prevState.hover && prevState.hover.getTime() === value.getTime()) {
	          return null;
	        }
	
	        return {
	          hover: value
	        };
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
	      _this.setState({
	        hover: null
	      });
	    });
	
	    return _this;
	  }
	
	  _createClass(Calendar, [{
	    key: "getProcessedValue",
	
	    /**
	     * Gets current value in a desired format.
	     */
	    value: function getProcessedValue(value) {
	      var _this$props4 = this.props,
	          minDate = _this$props4.minDate,
	          maxDate = _this$props4.maxDate,
	          maxDetail = _this$props4.maxDetail,
	          returnValue = _this$props4.returnValue;
	
	      var processFunction = function () {
	        switch (returnValue) {
	          case 'start':
	            return getDetailValueFrom;
	
	          case 'end':
	            return getDetailValueTo;
	
	          case 'range':
	            return getDetailValueArray;
	
	          default:
	            throw new Error('Invalid returnValue.');
	        }
	      }();
	
	      return processFunction(value, minDate, maxDate, maxDetail);
	    }
	    /**
	     * Called when the user uses navigation buttons.
	     */
	
	  }, {
	    key: "renderContent",
	    value: function renderContent() {
	      var _this$props5 = this.props,
	          calendarType = _this$props5.calendarType,
	          locale = _this$props5.locale,
	          maxDate = _this$props5.maxDate,
	          minDate = _this$props5.minDate,
	          renderChildren = _this$props5.renderChildren,
	          selectRange = _this$props5.selectRange,
	          tileClassName = _this$props5.tileClassName,
	          tileContent = _this$props5.tileContent,
	          tileDisabled = _this$props5.tileDisabled;
	      var _this$state2 = this.state,
	          activeStartDate = _this$state2.activeStartDate,
	          hover = _this$state2.hover,
	          value = _this$state2.value,
	          view = _this$state2.view;
	      var onMouseOver = this.onMouseOver,
	          valueType = this.valueType;
	      var commonProps = {
	        activeStartDate: activeStartDate,
	        hover: hover,
	        locale: locale,
	        maxDate: maxDate,
	        minDate: minDate,
	        onMouseOver: selectRange ? onMouseOver : null,
	        tileClassName: tileClassName,
	        tileContent: tileContent || renderChildren,
	        // For backwards compatibility
	        tileDisabled: tileDisabled,
	        value: value,
	        valueType: valueType
	      };
	      var clickAction = this.drillDownAvailable ? this.drillDown : this.onChange;
	
	      switch (view) {
	        case 'century':
	          {
	            var onClickDecade = this.props.onClickDecade;
	            return _react["default"].createElement(_CenturyView["default"], _extends({
	              onClick: (0, _utils.mergeFunctions)(clickAction, onClickDecade)
	            }, commonProps));
	          }
	
	        case 'decade':
	          {
	            var onClickYear = this.props.onClickYear;
	            return _react["default"].createElement(_DecadeView["default"], _extends({
	              onClick: (0, _utils.mergeFunctions)(clickAction, onClickYear)
	            }, commonProps));
	          }
	
	        case 'year':
	          {
	            var _this$props6 = this.props,
	                formatMonth = _this$props6.formatMonth,
	                onClickMonth = _this$props6.onClickMonth;
	            return _react["default"].createElement(_YearView["default"], _extends({
	              formatMonth: formatMonth,
	              onClick: (0, _utils.mergeFunctions)(clickAction, onClickMonth)
	            }, commonProps));
	          }
	
	        case 'month':
	          {
	            var _this$props7 = this.props,
	                formatShortWeekday = _this$props7.formatShortWeekday,
	                onClickDay = _this$props7.onClickDay,
	                onClickWeekNumber = _this$props7.onClickWeekNumber,
	                showFixedNumberOfWeeks = _this$props7.showFixedNumberOfWeeks,
	                showNeighboringMonth = _this$props7.showNeighboringMonth,
	                showWeekNumbers = _this$props7.showWeekNumbers;
	            var onMouseLeave = this.onMouseLeave;
	            return _react["default"].createElement(_MonthView["default"], _extends({
	              calendarType: calendarType,
	              formatShortWeekday: formatShortWeekday,
	              onClick: (0, _utils.mergeFunctions)(clickAction, onClickDay),
	              onClickWeekNumber: onClickWeekNumber,
	              onMouseLeave: onMouseLeave,
	              showFixedNumberOfWeeks: showFixedNumberOfWeeks,
	              showNeighboringMonth: showNeighboringMonth,
	              showWeekNumbers: showWeekNumbers
	            }, commonProps));
	          }
	
	        default:
	          throw new Error("Invalid view: ".concat(view, "."));
	      }
	    }
	  }, {
	    key: "renderNavigation",
	    value: function renderNavigation() {
	      var showNavigation = this.props.showNavigation;
	
	      if (!showNavigation) {
	        return null;
	      }
	
	      var _this$props8 = this.props,
	          formatMonthYear = _this$props8.formatMonthYear,
	          locale = _this$props8.locale,
	          maxDate = _this$props8.maxDate,
	          maxDetail = _this$props8.maxDetail,
	          minDate = _this$props8.minDate,
	          minDetail = _this$props8.minDetail,
	          navigationAriaLabel = _this$props8.navigationAriaLabel,
	          navigationLabel = _this$props8.navigationLabel,
	          next2AriaLabel = _this$props8.next2AriaLabel,
	          next2Label = _this$props8.next2Label,
	          nextAriaLabel = _this$props8.nextAriaLabel,
	          nextLabel = _this$props8.nextLabel,
	          prev2AriaLabel = _this$props8.prev2AriaLabel,
	          prev2Label = _this$props8.prev2Label,
	          prevAriaLabel = _this$props8.prevAriaLabel,
	          prevLabel = _this$props8.prevLabel;
	      var _this$state3 = this.state,
	          activeStartDate = _this$state3.activeStartDate,
	          view = _this$state3.view;
	      return _react["default"].createElement(_Navigation["default"], {
	        activeStartDate: activeStartDate,
	        drillUp: this.drillUp,
	        formatMonthYear: formatMonthYear,
	        locale: locale,
	        maxDate: maxDate,
	        minDate: minDate,
	        navigationAriaLabel: navigationAriaLabel,
	        navigationLabel: navigationLabel,
	        next2AriaLabel: next2AriaLabel,
	        next2Label: next2Label,
	        nextAriaLabel: nextAriaLabel,
	        nextLabel: nextLabel,
	        prev2AriaLabel: prev2AriaLabel,
	        prev2Label: prev2Label,
	        prevAriaLabel: prevAriaLabel,
	        prevLabel: prevLabel,
	        setActiveStartDate: this.setActiveStartDate,
	        view: view,
	        views: getLimitedViews(minDetail, maxDetail)
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props9 = this.props,
	          className = _this$props9.className,
	          selectRange = _this$props9.selectRange;
	      var value = this.state.value;
	      var onMouseLeave = this.onMouseLeave;
	      var valueArray = [].concat(value);
	      return _react["default"].createElement("div", {
	        className: (0, _mergeClassNames["default"])(baseClassName, selectRange && valueArray.length === 1 && "".concat(baseClassName, "--selectRange"), className)
	      }, this.renderNavigation(), _react["default"].createElement("div", {
	        className: "".concat(baseClassName, "__viewContainer"),
	        onBlur: selectRange ? onMouseLeave : null,
	        onMouseLeave: selectRange ? onMouseLeave : null
	      }, this.renderContent()));
	    }
	  }, {
	    key: "drillDownAvailable",
	    get: function get() {
	      var _this$props10 = this.props,
	          maxDetail = _this$props10.maxDetail,
	          minDetail = _this$props10.minDetail;
	      var view = this.state.view;
	      var views = getLimitedViews(minDetail, maxDetail);
	      return views.indexOf(view) < views.length - 1;
	    }
	  }, {
	    key: "drillUpAvailable",
	    get: function get() {
	      var _this$props11 = this.props,
	          maxDetail = _this$props11.maxDetail,
	          minDetail = _this$props11.minDetail;
	      var view = this.state.view;
	      var views = getLimitedViews(minDetail, maxDetail);
	      return views.indexOf(view) > 0;
	    }
	  }, {
	    key: "valueType",
	    get: function get() {
	      var maxDetail = this.props.maxDetail;
	      return getValueType(maxDetail);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var minDate = nextProps.minDate,
	          maxDate = nextProps.maxDate,
	          minDetail = nextProps.minDetail,
	          maxDetail = nextProps.maxDetail;
	      var nextState = {};
	      /**
	       * If the next activeStartDate is different from the current one, update
	       * activeStartDate (for display) and activeStartDateProps (for future comparisons)
	       */
	
	      var nextActiveStartDate = getActiveStartDate(nextProps);
	
	      if (datesAreDifferent(nextActiveStartDate, prevState.activeStartDateProps)) {
	        nextState.activeStartDate = nextActiveStartDate;
	        nextState.activeStartDateProps = nextActiveStartDate;
	      }
	      /**
	       * If the next view is different from the current one, and the previously set view is not
	       * valid based on minDetail and maxDetail, get a new one.
	       */
	
	
	      var nextView = getView(nextProps.view, minDetail, maxDetail);
	
	      if (nextView !== prevState.viewProps && !isViewAllowed(prevState.view, minDetail, maxDetail)) {
	        nextState.view = nextView;
	        nextState.viewProps = nextView;
	      }
	      /**
	       * If the next value is different from the current one (with an exception of situation in
	       * which values provided are limited by minDate and maxDate so that the dates are the same),
	       * get a new one.
	       */
	
	
	      var values = [nextProps.value, prevState.valueProps];
	
	      if (nextState.view // Allowed view changed
	      || datesAreDifferent.apply(void 0, _toConsumableArray(values.map(function (value) {
	        return getValueFrom(value, minDate, maxDate, maxDetail);
	      }))) || datesAreDifferent.apply(void 0, _toConsumableArray(values.map(function (value) {
	        return getValueTo(value, minDate, maxDate, maxDetail);
	      })))) {
	        nextState.value = nextProps.value;
	        nextState.valueProps = nextProps.value;
	      }
	
	      if (!nextProps.selectRange && prevState.hover) {
	        nextState.hover = null;
	      }
	
	      return nextState;
	    }
	  }]);
	
	  return Calendar;
	}(_react.Component);
	
	exports["default"] = Calendar;
	Calendar.defaultProps = {
	  maxDetail: 'month',
	  minDetail: 'century',
	  returnValue: 'start',
	  showNavigation: true,
	  showNeighboringMonth: true,
	  view: 'month'
	};
	Calendar.propTypes = {
	  activeStartDate: _propTypes["default"].instanceOf(Date),
	  calendarType: _propTypes2.isCalendarType,
	  className: _propTypes2.isClassName,
	  formatMonth: _propTypes["default"].func,
	  formatMonthYear: _propTypes["default"].func,
	  formatShortWeekday: _propTypes["default"].func,
	  locale: _propTypes["default"].string,
	  maxDate: _propTypes2.isMaxDate,
	  maxDetail: _propTypes["default"].oneOf(allViews),
	  minDate: _propTypes2.isMinDate,
	  minDetail: _propTypes["default"].oneOf(allViews),
	  navigationAriaLabel: _propTypes["default"].string,
	  navigationLabel: _propTypes["default"].func,
	  next2AriaLabel: _propTypes["default"].string,
	  next2Label: _propTypes["default"].node,
	  nextAriaLabel: _propTypes["default"].string,
	  nextLabel: _propTypes["default"].node,
	  onActiveDateChange: _propTypes["default"].func,
	  onChange: _propTypes["default"].func,
	  onClickDay: _propTypes["default"].func,
	  onClickDecade: _propTypes["default"].func,
	  onClickMonth: _propTypes["default"].func,
	  onClickWeekNumber: _propTypes["default"].func,
	  onClickYear: _propTypes["default"].func,
	  onDrillDown: _propTypes["default"].func,
	  onDrillUp: _propTypes["default"].func,
	  prev2AriaLabel: _propTypes["default"].string,
	  prev2Label: _propTypes["default"].node,
	  prevAriaLabel: _propTypes["default"].string,
	  prevLabel: _propTypes["default"].node,
	  renderChildren: _propTypes["default"].func,
	  // For backwards compatibility
	  returnValue: _propTypes["default"].oneOf(['start', 'end', 'range']),
	  selectRange: _propTypes["default"].bool,
	  showFixedNumberOfWeeks: _propTypes["default"].bool,
	  showNavigation: _propTypes["default"].bool,
	  showNeighboringMonth: _propTypes["default"].bool,
	  showWeekNumbers: _propTypes["default"].bool,
	  tileClassName: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes2.isClassName]),
	  tileContent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
	  tileDisabled: _propTypes["default"].func,
	  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes2.isValue]),
	  view: _propTypes["default"].oneOf(allViews)
	};
	(0, _reactLifecyclesCompat.polyfill)(Calendar);

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Navigation;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _dates = __webpack_require__(27);
	
	var _dateFormatter = __webpack_require__(119);
	
	var _propTypes2 = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var className = 'react-calendar__navigation';
	
	function Navigation(_ref) {
	  var date = _ref.activeStartDate,
	      drillUp = _ref.drillUp,
	      formatMonthYear = _ref.formatMonthYear,
	      locale = _ref.locale,
	      maxDate = _ref.maxDate,
	      minDate = _ref.minDate,
	      navigationAriaLabel = _ref.navigationAriaLabel,
	      navigationLabel = _ref.navigationLabel,
	      next2AriaLabel = _ref.next2AriaLabel,
	      next2Label = _ref.next2Label,
	      nextAriaLabel = _ref.nextAriaLabel,
	      nextLabel = _ref.nextLabel,
	      prev2AriaLabel = _ref.prev2AriaLabel,
	      prev2Label = _ref.prev2Label,
	      prevAriaLabel = _ref.prevAriaLabel,
	      prevLabel = _ref.prevLabel,
	      setActiveStartDate = _ref.setActiveStartDate,
	      view = _ref.view,
	      views = _ref.views;
	  var drillUpAvailable = views.indexOf(view) > 0;
	  var shouldShowPrevNext2Buttons = view !== 'century';
	  var previousActiveStartDate = (0, _dates.getBeginPrevious)(view, date);
	  var previousActiveStartDate2 = shouldShowPrevNext2Buttons && (0, _dates.getBeginPrevious2)(view, date);
	  var nextActiveStartDate = (0, _dates.getBeginNext)(view, date);
	  var nextActiveStartDate2 = shouldShowPrevNext2Buttons && (0, _dates.getBeginNext2)(view, date);
	
	  var prevButtonDisabled = function () {
	    if (previousActiveStartDate.getFullYear() < 1000) {
	      return true;
	    }
	
	    var previousActiveEndDate = (0, _dates.getEndPrevious)(view, date);
	    return minDate && minDate >= previousActiveEndDate;
	  }();
	
	  var prev2ButtonDisabled = shouldShowPrevNext2Buttons && function () {
	    if (previousActiveStartDate2.getFullYear() < 1000) {
	      return true;
	    }
	
	    var previousActiveEndDate = (0, _dates.getEndPrevious2)(view, date);
	    return minDate && minDate >= previousActiveEndDate;
	  }();
	
	  var nextButtonDisabled = maxDate && maxDate <= nextActiveStartDate;
	  var next2ButtonDisabled = shouldShowPrevNext2Buttons && maxDate && maxDate <= nextActiveStartDate2;
	
	  function onClickPrevious() {
	    setActiveStartDate(previousActiveStartDate);
	  }
	
	  function onClickPrevious2() {
	    setActiveStartDate(previousActiveStartDate2);
	  }
	
	  function onClickNext() {
	    setActiveStartDate(nextActiveStartDate);
	  }
	
	  function onClickNext2() {
	    setActiveStartDate(nextActiveStartDate2);
	  }
	
	  var label = function () {
	    switch (view) {
	      case 'century':
	        return (0, _dates.getCenturyLabel)(date);
	
	      case 'decade':
	        return (0, _dates.getDecadeLabel)(date);
	
	      case 'year':
	        return (0, _dates.getYear)(date);
	
	      case 'month':
	        return formatMonthYear(locale, date);
	
	      default:
	        throw new Error("Invalid view: ".concat(view, "."));
	    }
	  }();
	
	  return _react["default"].createElement("div", {
	    className: className,
	    style: {
	      display: 'flex'
	    }
	  }, prev2Label !== null && shouldShowPrevNext2Buttons && _react["default"].createElement("button", {
	    "aria-label": prev2AriaLabel,
	    className: "".concat(className, "__arrow ").concat(className, "__prev2-button"),
	    disabled: prev2ButtonDisabled,
	    onClick: onClickPrevious2,
	    type: "button"
	  }, prev2Label), _react["default"].createElement("button", {
	    "aria-label": prevAriaLabel,
	    className: "".concat(className, "__arrow ").concat(className, "__prev-button"),
	    disabled: prevButtonDisabled,
	    onClick: onClickPrevious,
	    type: "button"
	  }, prevLabel), _react["default"].createElement("button", {
	    "aria-label": navigationAriaLabel,
	    className: "react-calendar__navigation__label",
	    disabled: !drillUpAvailable,
	    onClick: drillUp,
	    style: {
	      flexGrow: 1
	    },
	    type: "button"
	  }, navigationLabel ? navigationLabel({
	    date: date,
	    view: view,
	    label: label
	  }) : label), _react["default"].createElement("button", {
	    "aria-label": nextAriaLabel,
	    className: "".concat(className, "__arrow ").concat(className, "__next-button"),
	    disabled: nextButtonDisabled,
	    onClick: onClickNext,
	    type: "button"
	  }, nextLabel), next2Label !== null && shouldShowPrevNext2Buttons && _react["default"].createElement("button", {
	    "aria-label": next2AriaLabel,
	    className: "".concat(className, "__arrow ").concat(className, "__next2-button"),
	    disabled: next2ButtonDisabled,
	    onClick: onClickNext2,
	    type: "button"
	  }, next2Label));
	}
	
	Navigation.defaultProps = {
	  formatMonthYear: _dateFormatter.formatMonthYear,
	  navigationAriaLabel: '',
	  next2AriaLabel: '',
	  next2Label: '»',
	  nextAriaLabel: '',
	  nextLabel: '›',
	  prev2AriaLabel: '',
	  prev2Label: '«',
	  prevAriaLabel: '',
	  prevLabel: '‹'
	};
	Navigation.propTypes = {
	  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
	  drillUp: _propTypes["default"].func.isRequired,
	  formatMonthYear: _propTypes["default"].func,
	  locale: _propTypes["default"].string,
	  maxDate: _propTypes["default"].instanceOf(Date),
	  minDate: _propTypes["default"].instanceOf(Date),
	  navigationAriaLabel: _propTypes["default"].string,
	  navigationLabel: _propTypes["default"].func,
	  next2AriaLabel: _propTypes["default"].string,
	  next2Label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
	  nextAriaLabel: _propTypes["default"].string,
	  nextLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
	  prev2AriaLabel: _propTypes["default"].string,
	  prev2Label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
	  prevAriaLabel: _propTypes["default"].string,
	  prevLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
	  setActiveStartDate: _propTypes["default"].func.isRequired,
	  view: _propTypes2.isView.isRequired,
	  views: _propTypes2.isViews.isRequired
	};

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Decade;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Tile = _interopRequireDefault(__webpack_require__(117));
	
	var _dates = __webpack_require__(27);
	
	var _propTypes2 = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var className = 'react-calendar__century-view__decades__decade';
	
	function Decade(_ref) {
	  var classes = _ref.classes,
	      point = _ref.point,
	      otherProps = _objectWithoutProperties(_ref, ["classes", "point"]);
	
	  return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
	    classes: [].concat(classes, className),
	    maxDateTransform: _dates.getEndOfDecade,
	    minDateTransform: _dates.getBeginOfDecade,
	    view: "century"
	  }), (0, _dates.getDecadeLabel)(point));
	}
	
	Decade.propTypes = _objectSpread({}, _propTypes2.tileProps, {
	  point: _propTypes["default"].number.isRequired
	});

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Decades;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _TileGroup = _interopRequireDefault(__webpack_require__(118));
	
	var _Decade = _interopRequireDefault(__webpack_require__(756));
	
	var _dates = __webpack_require__(27);
	
	var _propTypes = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function Decades(props) {
	  var activeStartDate = props.activeStartDate;
	  var start = (0, _dates.getBeginOfCenturyYear)(activeStartDate);
	  var end = start + 99;
	  return _react["default"].createElement(_TileGroup["default"], _extends({}, props, {
	    className: "react-calendar__century-view__decades",
	    dateTransform: _dates.getBeginOfDecade,
	    dateType: "decade",
	    end: end,
	    start: start,
	    step: 10,
	    tile: _Decade["default"]
	  }));
	}
	
	Decades.propTypes = _objectSpread({}, _propTypes.tileGroupProps);

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Year;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Tile = _interopRequireDefault(__webpack_require__(117));
	
	var _dates = __webpack_require__(27);
	
	var _propTypes2 = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var className = 'react-calendar__decade-view__years__year';
	
	function Year(_ref) {
	  var classes = _ref.classes,
	      point = _ref.point,
	      otherProps = _objectWithoutProperties(_ref, ["classes", "point"]);
	
	  return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
	    classes: [].concat(classes, className),
	    maxDateTransform: _dates.getEndOfYear,
	    minDateTransform: _dates.getBeginOfYear,
	    view: "decade"
	  }), point);
	}
	
	Year.propTypes = _objectSpread({}, _propTypes2.tileProps, {
	  point: _propTypes["default"].number.isRequired
	});

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Years;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _TileGroup = _interopRequireDefault(__webpack_require__(118));
	
	var _Year = _interopRequireDefault(__webpack_require__(758));
	
	var _dates = __webpack_require__(27);
	
	var _propTypes = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function Years(props) {
	  var activeStartDate = props.activeStartDate;
	  var start = (0, _dates.getBeginOfDecadeYear)(activeStartDate);
	  var end = start + 9;
	  return _react["default"].createElement(_TileGroup["default"], _extends({}, props, {
	    className: "react-calendar__decade-view__years",
	    dateTransform: function dateTransform(year) {
	      return new Date(year, 0, 1);
	    },
	    dateType: "year",
	    end: end,
	    start: start,
	    tile: _Year["default"]
	  }));
	}
	
	Years.propTypes = _objectSpread({}, _propTypes.tileGroupProps);

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Day;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Tile = _interopRequireDefault(__webpack_require__(117));
	
	var _dates = __webpack_require__(27);
	
	var _dateFormatter = __webpack_require__(119);
	
	var _propTypes2 = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var className = 'react-calendar__month-view__days__day';
	
	function Day(_ref) {
	  var calendarType = _ref.calendarType,
	      classes = _ref.classes,
	      currentMonthIndex = _ref.currentMonthIndex,
	      date = _ref.date,
	      otherProps = _objectWithoutProperties(_ref, ["calendarType", "classes", "currentMonthIndex", "date"]);
	
	  return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
	    classes: [].concat(classes, className, (0, _dates.isWeekend)(date, calendarType) ? "".concat(className, "--weekend") : null, date.getMonth() !== currentMonthIndex ? "".concat(className, "--neighboringMonth") : null),
	    date: date,
	    formatAbbr: _dateFormatter.formatLongDate,
	    maxDateTransform: _dates.getEndOfDay,
	    minDateTransform: _dates.getBeginOfDay,
	    view: "month"
	  }), (0, _dates.getDay)(date));
	}
	
	Day.propTypes = _objectSpread({}, _propTypes2.tileProps, {
	  currentMonthIndex: _propTypes["default"].number.isRequired
	});

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Days;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _TileGroup = _interopRequireDefault(__webpack_require__(118));
	
	var _Day = _interopRequireDefault(__webpack_require__(760));
	
	var _dates = __webpack_require__(27);
	
	var _propTypes2 = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function Days(props) {
	  var activeStartDate = props.activeStartDate,
	      calendarType = props.calendarType;
	
	  var showFixedNumberOfWeeks = props.showFixedNumberOfWeeks,
	      showNeighboringMonth = props.showNeighboringMonth,
	      otherProps = _objectWithoutProperties(props, ["showFixedNumberOfWeeks", "showNeighboringMonth"]);
	
	  var year = (0, _dates.getYear)(activeStartDate);
	  var monthIndex = (0, _dates.getMonthIndex)(activeStartDate);
	  var hasFixedNumberOfWeeks = showFixedNumberOfWeeks || showNeighboringMonth;
	  var dayOfWeek = (0, _dates.getDayOfWeek)(activeStartDate, calendarType);
	  var offset = hasFixedNumberOfWeeks ? 0 : dayOfWeek;
	  /**
	   * Defines on which day of the month the grid shall start. If we simply show current
	   * month, we obviously start on day one, but if showNeighboringMonth is set to
	   * true, we need to find the beginning of the week the first day of the month is in.
	   */
	
	  var start = (hasFixedNumberOfWeeks ? -dayOfWeek : 0) + 1;
	  /**
	   * Defines on which day of the month the grid shall end. If we simply show current
	   * month, we need to stop on the last day of the month, but if showNeighboringMonth
	   * is set to true, we need to find the end of the week the last day of the month is in.
	   */
	
	  var end = function () {
	    if (showFixedNumberOfWeeks) {
	      // Always show 6 weeks
	      return start + 6 * 7 - 1;
	    }
	
	    var daysInMonth = (0, _dates.getDaysInMonth)(activeStartDate);
	
	    if (showNeighboringMonth) {
	      var activeEndDate = new Date(year, monthIndex, daysInMonth);
	      return daysInMonth + (7 - (0, _dates.getDayOfWeek)(activeEndDate, calendarType) - 1);
	    }
	
	    return daysInMonth;
	  }();
	
	  return _react["default"].createElement(_TileGroup["default"], _extends({}, otherProps, {
	    className: "react-calendar__month-view__days",
	    count: 7,
	    currentMonthIndex: monthIndex,
	    dateTransform: function dateTransform(day) {
	      return new Date(year, monthIndex, day);
	    },
	    dateType: "day",
	    end: end,
	    offset: offset,
	    start: start,
	    tile: _Day["default"]
	  }));
	}
	
	Days.propTypes = _objectSpread({
	  calendarType: _propTypes2.isCalendarType.isRequired,
	  showFixedNumberOfWeeks: _propTypes["default"].bool,
	  showNeighboringMonth: _propTypes["default"].bool
	}, _propTypes2.tileGroupProps);

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = WeekNumber;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function WeekNumber(_ref) {
	  var date = _ref.date,
	      onClickWeekNumber = _ref.onClickWeekNumber,
	      weekNumber = _ref.weekNumber;
	  return onClickWeekNumber ? _react["default"].createElement("button", {
	    className: "react-calendar__tile",
	    onClick: function onClick() {
	      return onClickWeekNumber(weekNumber, date);
	    },
	    style: {
	      flexGrow: 1
	    },
	    type: "button"
	  }, _react["default"].createElement("span", null, weekNumber)) : _react["default"].createElement("div", {
	    className: "react-calendar__tile",
	    style: {
	      flexGrow: 1
	    }
	  }, _react["default"].createElement("span", null, weekNumber));
	}
	
	WeekNumber.propTypes = {
	  date: _propTypes["default"].instanceOf(Date).isRequired,
	  onClickWeekNumber: _propTypes["default"].func,
	  weekNumber: _propTypes["default"].number.isRequired
	};

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = WeekNumbers;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _WeekNumber = _interopRequireDefault(__webpack_require__(762));
	
	var _Flex = _interopRequireDefault(__webpack_require__(160));
	
	var _dates = __webpack_require__(27);
	
	var _propTypes2 = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function WeekNumbers(props) {
	  var activeStartDate = props.activeStartDate,
	      calendarType = props.calendarType,
	      onClickWeekNumber = props.onClickWeekNumber,
	      onMouseLeave = props.onMouseLeave,
	      showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
	
	  var numberOfWeeks = function () {
	    if (showFixedNumberOfWeeks) {
	      return 6;
	    }
	
	    var numberOfDays = (0, _dates.getDaysInMonth)(activeStartDate);
	    var startWeekday = (0, _dates.getDayOfWeek)(activeStartDate, calendarType);
	    var days = numberOfDays - (7 - startWeekday);
	    return 1 + Math.ceil(days / 7);
	  }();
	
	  var dates = function () {
	    var year = (0, _dates.getYear)(activeStartDate);
	    var monthIndex = (0, _dates.getMonthIndex)(activeStartDate);
	    var day = (0, _dates.getDay)(activeStartDate);
	    var result = [];
	
	    for (var index = 0; index < numberOfWeeks; index += 1) {
	      result.push((0, _dates.getBeginOfWeek)(new Date(year, monthIndex, day + index * 7), calendarType));
	    }
	
	    return result;
	  }();
	
	  var weekNumbers = dates.map(function (date) {
	    return (0, _dates.getWeekNumber)(date, calendarType);
	  });
	  return _react["default"].createElement(_Flex["default"], {
	    className: "react-calendar__month-view__weekNumbers",
	    count: numberOfWeeks,
	    direction: "column",
	    onFocus: onMouseLeave,
	    onMouseOver: onMouseLeave,
	    style: {
	      flexBasis: 'calc(100% * (1 / 8)',
	      flexShrink: 0
	    }
	  }, weekNumbers.map(function (weekNumber, weekIndex) {
	    return _react["default"].createElement(_WeekNumber["default"], {
	      key: weekNumber,
	      date: dates[weekIndex],
	      onClickWeekNumber: onClickWeekNumber,
	      weekNumber: weekNumber
	    });
	  }));
	}
	
	WeekNumbers.propTypes = {
	  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
	  calendarType: _propTypes2.isCalendarType.isRequired,
	  onClickWeekNumber: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  showFixedNumberOfWeeks: _propTypes["default"].bool
	};

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Weekdays;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Flex = _interopRequireDefault(__webpack_require__(160));
	
	var _dates = __webpack_require__(27);
	
	var _dateFormatter = __webpack_require__(119);
	
	var _propTypes2 = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function Weekdays(props) {
	  var calendarType = props.calendarType,
	      formatShortWeekday = props.formatShortWeekday,
	      locale = props.locale,
	      onMouseLeave = props.onMouseLeave;
	  var anyDate = new Date();
	  var beginOfMonth = (0, _dates.getBeginOfMonth)(anyDate);
	  var year = (0, _dates.getYear)(beginOfMonth);
	  var monthIndex = (0, _dates.getMonthIndex)(beginOfMonth);
	  var weekdays = [];
	
	  for (var weekday = 1; weekday <= 7; weekday += 1) {
	    var weekdayDate = new Date(year, monthIndex, weekday - (0, _dates.getDayOfWeek)(beginOfMonth, calendarType));
	    var abbr = (0, _dateFormatter.formatWeekday)(locale, weekdayDate);
	    weekdays.push(_react["default"].createElement("div", {
	      key: weekday,
	      className: "react-calendar__month-view__weekdays__weekday"
	    }, _react["default"].createElement("abbr", {
	      "aria-label": abbr,
	      title: abbr
	    }, formatShortWeekday(locale, weekdayDate).replace('.', ''))));
	  }
	
	  return _react["default"].createElement(_Flex["default"], {
	    className: "react-calendar__month-view__weekdays",
	    count: 7,
	    onFocus: onMouseLeave,
	    onMouseOver: onMouseLeave
	  }, weekdays);
	}
	
	Weekdays.defaultProps = {
	  formatShortWeekday: _dateFormatter.formatShortWeekday
	};
	Weekdays.propTypes = {
	  calendarType: _propTypes2.isCalendarType.isRequired,
	  formatShortWeekday: _propTypes["default"].func,
	  locale: _propTypes["default"].string,
	  onMouseLeave: _propTypes["default"].func
	};

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Month;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Tile = _interopRequireDefault(__webpack_require__(117));
	
	var _dates = __webpack_require__(27);
	
	var _dateFormatter = __webpack_require__(119);
	
	var _propTypes2 = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var className = 'react-calendar__year-view__months__month';
	
	function Month(_ref) {
	  var classes = _ref.classes,
	      date = _ref.date,
	      formatMonth = _ref.formatMonth,
	      locale = _ref.locale,
	      otherProps = _objectWithoutProperties(_ref, ["classes", "date", "formatMonth", "locale"]);
	
	  return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
	    classes: [].concat(classes, className),
	    date: date,
	    formatAbbr: _dateFormatter.formatMonthYear,
	    locale: locale,
	    maxDateTransform: _dates.getEndOfMonth,
	    minDateTransform: _dates.getBeginOfMonth,
	    view: "year"
	  }), formatMonth(locale, date));
	}
	
	Month.defaultProps = {
	  formatMonth: _dateFormatter.formatMonth
	};
	Month.propTypes = _objectSpread({}, _propTypes2.tileProps, {
	  formatMonth: _propTypes["default"].func
	});

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Months;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _TileGroup = _interopRequireDefault(__webpack_require__(118));
	
	var _Month = _interopRequireDefault(__webpack_require__(765));
	
	var _dates = __webpack_require__(27);
	
	var _propTypes2 = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function Months(props) {
	  var activeStartDate = props.activeStartDate;
	  var start = 0;
	  var end = 11;
	  var year = (0, _dates.getYear)(activeStartDate);
	  return _react["default"].createElement(_TileGroup["default"], _extends({}, props, {
	    className: "react-calendar__year-view__months",
	    dateTransform: function dateTransform(monthIndex) {
	      return new Date(year, monthIndex, 1);
	    },
	    dateType: "month",
	    end: end,
	    start: start,
	    tile: _Month["default"]
	  }));
	}
	
	Months.propTypes = _objectSpread({}, _propTypes2.tileGroupProps, {
	  locale: _propTypes["default"].string
	});

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Calendar", {
	  enumerable: true,
	  get: function get() {
	    return _Calendar["default"];
	  }
	});
	Object.defineProperty(exports, "CenturyView", {
	  enumerable: true,
	  get: function get() {
	    return _CenturyView["default"];
	  }
	});
	Object.defineProperty(exports, "DecadeView", {
	  enumerable: true,
	  get: function get() {
	    return _DecadeView["default"];
	  }
	});
	Object.defineProperty(exports, "YearView", {
	  enumerable: true,
	  get: function get() {
	    return _YearView["default"];
	  }
	});
	Object.defineProperty(exports, "MonthView", {
	  enumerable: true,
	  get: function get() {
	    return _MonthView["default"];
	  }
	});
	exports["default"] = void 0;
	
	var _Calendar = _interopRequireDefault(__webpack_require__(754));
	
	var _CenturyView = _interopRequireDefault(__webpack_require__(406));
	
	var _DecadeView = _interopRequireDefault(__webpack_require__(407));
	
	var _YearView = _interopRequireDefault(__webpack_require__(409));
	
	var _MonthView = _interopRequireDefault(__webpack_require__(408));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _Calendar["default"];
	exports["default"] = _default;

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = undefined;
	exports.removeDocumentMeta = removeDocumentMeta;
	exports.insertDocumentMeta = insertDocumentMeta;
	
	var _utils = __webpack_require__(410);
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function removeNode(node) {
	  node.parentNode.removeChild(node);
	}
	
	function removeDocumentMeta() {
	  (0, _utils.forEach)(document.querySelectorAll('head [data-rdm]'), removeNode);
	}
	
	function insertDocumentMetaNode(entry) {
	  var tagName = entry.tagName,
	      attr = _objectWithoutProperties(entry, ['tagName']);
	
	  var newNode = document.createElement(tagName);
	  for (var prop in attr) {
	    if (entry.hasOwnProperty(prop)) {
	      newNode.setAttribute(prop, entry[prop]);
	    }
	  }
	  newNode.setAttribute('data-rdm', '');
	  document.getElementsByTagName('head')[0].appendChild(newNode);
	}
	
	function insertDocumentMeta(nodes) {
	  removeDocumentMeta();
	
	  (0, _utils.forEach)(nodes, insertDocumentMetaNode);
	}


/***/ },
/* 769 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(22);
	
	var focusNode = __webpack_require__(234);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(96);
	var ExecutionEnvironment = __webpack_require__(26);
	var FallbackCompositionState = __webpack_require__(777);
	var SyntheticCompositionEvent = __webpack_require__(811);
	var SyntheticInputEvent = __webpack_require__(814);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(411);
	var ExecutionEnvironment = __webpack_require__(26);
	var ReactInstrumentation = __webpack_require__(33);
	
	var camelizeStyleName = __webpack_require__(617);
	var dangerousStyleValue = __webpack_require__(820);
	var hyphenateStyleName = __webpack_require__(624);
	var memoizeStringOnly = __webpack_require__(627);
	var warning = __webpack_require__(14);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(95);
	var EventPropagators = __webpack_require__(96);
	var ExecutionEnvironment = __webpack_require__(26);
	var ReactDOMComponentTree = __webpack_require__(22);
	var ReactUpdates = __webpack_require__(35);
	var SyntheticEvent = __webpack_require__(37);
	
	var getEventTarget = __webpack_require__(174);
	var isEventSupported = __webpack_require__(176);
	var isTextInputElement = __webpack_require__(433);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var DOMLazyTree = __webpack_require__(79);
	var ExecutionEnvironment = __webpack_require__(26);
	
	var createNodesFromMarkup = __webpack_require__(620);
	var emptyFunction = __webpack_require__(34);
	var invariant = __webpack_require__(6);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 775 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(96);
	var ReactDOMComponentTree = __webpack_require__(22);
	var SyntheticMouseEvent = __webpack_require__(121);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var PooledClass = __webpack_require__(59);
	
	var getTextContentAccessor = __webpack_require__(432);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(80);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(60);
	
	var instantiateReactComponent = __webpack_require__(175);
	var KeyEscapeUtils = __webpack_require__(166);
	var shouldUpdateReactComponent = __webpack_require__(177);
	var traverseAllChildren = __webpack_require__(435);
	var warning = __webpack_require__(14);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(460);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75)))

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(162);
	var ReactDOMIDOperations = __webpack_require__(786);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16),
	    _assign = __webpack_require__(18);
	
	var React = __webpack_require__(62);
	var ReactComponentEnvironment = __webpack_require__(168);
	var ReactCurrentOwner = __webpack_require__(38);
	var ReactErrorUtils = __webpack_require__(169);
	var ReactInstanceMap = __webpack_require__(97);
	var ReactInstrumentation = __webpack_require__(33);
	var ReactNodeTypes = __webpack_require__(425);
	var ReactReconciler = __webpack_require__(60);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(72);
	var invariant = __webpack_require__(6);
	var shallowEqual = __webpack_require__(146);
	var shouldUpdateReactComponent = __webpack_require__(177);
	var warning = __webpack_require__(14);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'childContext');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(22);
	var ReactDefaultInjection = __webpack_require__(418);
	var ReactMount = __webpack_require__(424);
	var ReactReconciler = __webpack_require__(60);
	var ReactUpdates = __webpack_require__(35);
	var ReactVersion = __webpack_require__(427);
	
	var findDOMNode = __webpack_require__(821);
	var getHostComponentFromComposite = __webpack_require__(431);
	var renderSubtreeIntoContainer = __webpack_require__(829);
	var warning = __webpack_require__(14);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16),
	    _assign = __webpack_require__(18);
	
	var AutoFocusUtils = __webpack_require__(770);
	var CSSPropertyOperations = __webpack_require__(772);
	var DOMLazyTree = __webpack_require__(79);
	var DOMNamespaces = __webpack_require__(163);
	var DOMProperty = __webpack_require__(80);
	var DOMPropertyOperations = __webpack_require__(413);
	var EventPluginHub = __webpack_require__(95);
	var EventPluginRegistry = __webpack_require__(164);
	var ReactBrowserEventEmitter = __webpack_require__(120);
	var ReactDOMComponentFlags = __webpack_require__(414);
	var ReactDOMComponentTree = __webpack_require__(22);
	var ReactDOMInput = __webpack_require__(787);
	var ReactDOMOption = __webpack_require__(788);
	var ReactDOMSelect = __webpack_require__(416);
	var ReactDOMTextarea = __webpack_require__(792);
	var ReactInstrumentation = __webpack_require__(33);
	var ReactMultiChild = __webpack_require__(798);
	var ReactServerRenderingTransaction = __webpack_require__(426);
	
	var emptyFunction = __webpack_require__(34);
	var escapeTextContentForBrowser = __webpack_require__(123);
	var invariant = __webpack_require__(6);
	var isEventSupported = __webpack_require__(176);
	var shallowEqual = __webpack_require__(146);
	var validateDOMNesting = __webpack_require__(178);
	var warning = __webpack_require__(14);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var DOMLazyTree = __webpack_require__(79);
	var ReactDOMComponentTree = __webpack_require__(22);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 785 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(162);
	var ReactDOMComponentTree = __webpack_require__(22);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16),
	    _assign = __webpack_require__(18);
	
	var DOMPropertyOperations = __webpack_require__(413);
	var LinkedValueUtils = __webpack_require__(167);
	var ReactDOMComponentTree = __webpack_require__(22);
	var ReactUpdates = __webpack_require__(35);
	
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(14);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var React = __webpack_require__(62);
	var ReactDOMComponentTree = __webpack_require__(22);
	var ReactDOMSelect = __webpack_require__(416);
	
	var warning = __webpack_require__(14);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(26);
	
	var getNodeForCharacterOffset = __webpack_require__(826);
	var getTextContentAccessor = __webpack_require__(432);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(418);
	var ReactServerRendering = __webpack_require__(804);
	var ReactVersion = __webpack_require__(427);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16),
	    _assign = __webpack_require__(18);
	
	var DOMChildrenOperations = __webpack_require__(162);
	var DOMLazyTree = __webpack_require__(79);
	var ReactDOMComponentTree = __webpack_require__(22);
	
	var escapeTextContentForBrowser = __webpack_require__(123);
	var invariant = __webpack_require__(6);
	var validateDOMNesting = __webpack_require__(178);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16),
	    _assign = __webpack_require__(18);
	
	var LinkedValueUtils = __webpack_require__(167);
	var ReactDOMComponentTree = __webpack_require__(22);
	var ReactUpdates = __webpack_require__(35);
	
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(14);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 794 */
461,
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(95);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var EventListener = __webpack_require__(233);
	var ExecutionEnvironment = __webpack_require__(26);
	var PooledClass = __webpack_require__(59);
	var ReactDOMComponentTree = __webpack_require__(22);
	var ReactUpdates = __webpack_require__(35);
	
	var getEventTarget = __webpack_require__(174);
	var getUnboundedScrollPosition = __webpack_require__(622);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(80);
	var EventPluginHub = __webpack_require__(95);
	var EventPluginUtils = __webpack_require__(165);
	var ReactComponentEnvironment = __webpack_require__(168);
	var ReactEmptyComponent = __webpack_require__(419);
	var ReactBrowserEventEmitter = __webpack_require__(120);
	var ReactHostComponent = __webpack_require__(421);
	var ReactUpdates = __webpack_require__(35);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var ReactComponentEnvironment = __webpack_require__(168);
	var ReactInstanceMap = __webpack_require__(97);
	var ReactInstrumentation = __webpack_require__(33);
	
	var ReactCurrentOwner = __webpack_require__(38);
	var ReactReconciler = __webpack_require__(60);
	var ReactChildReconciler = __webpack_require__(779);
	
	var emptyFunction = __webpack_require__(34);
	var flattenChildren = __webpack_require__(822);
	var invariant = __webpack_require__(6);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var invariant = __webpack_require__(6);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 800 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var CallbackQueue = __webpack_require__(412);
	var PooledClass = __webpack_require__(59);
	var ReactBrowserEventEmitter = __webpack_require__(120);
	var ReactInputSelection = __webpack_require__(422);
	var ReactInstrumentation = __webpack_require__(33);
	var Transaction = __webpack_require__(122);
	var ReactUpdateQueue = __webpack_require__(170);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(799);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 803 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var React = __webpack_require__(62);
	var ReactDOMContainerInfo = __webpack_require__(415);
	var ReactDefaultBatchingStrategy = __webpack_require__(417);
	var ReactInstrumentation = __webpack_require__(33);
	var ReactMarkupChecksum = __webpack_require__(423);
	var ReactReconciler = __webpack_require__(60);
	var ReactServerBatchingStrategy = __webpack_require__(803);
	var ReactServerRenderingTransaction = __webpack_require__(426);
	var ReactUpdates = __webpack_require__(35);
	
	var emptyObject = __webpack_require__(72);
	var instantiateReactComponent = __webpack_require__(175);
	var invariant = __webpack_require__(6);
	
	var pendingTransactions = 0;
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToStringImpl(element, makeStaticMarkup) {
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);
	
	    pendingTransactions++;
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, true);
	      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
	      );
	      if (false) {
	        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
	      }
	      if (!makeStaticMarkup) {
	        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
	      }
	      return markup;
	    }, null);
	  } finally {
	    pendingTransactions--;
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    if (!pendingTransactions) {
	      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	    }
	  }
	}
	
	/**
	 * Render a ReactElement to its initial HTML. This should only be used on the
	 * server.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
	 */
	function renderToString(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
	  return renderToStringImpl(element, false);
	}
	
	/**
	 * Similar to renderToString, except this doesn't create extra DOM attributes
	 * such as data-react-id that React uses internally.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
	 */
	function renderToStaticMarkup(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
	  return renderToStringImpl(element, true);
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(170);
	
	var warning = __webpack_require__(14);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 806 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(96);
	var ExecutionEnvironment = __webpack_require__(26);
	var ReactDOMComponentTree = __webpack_require__(22);
	var ReactInputSelection = __webpack_require__(422);
	var SyntheticEvent = __webpack_require__(37);
	
	var getActiveElement = __webpack_require__(235);
	var isTextInputElement = __webpack_require__(433);
	var shallowEqual = __webpack_require__(146);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var EventListener = __webpack_require__(233);
	var EventPropagators = __webpack_require__(96);
	var ReactDOMComponentTree = __webpack_require__(22);
	var SyntheticAnimationEvent = __webpack_require__(809);
	var SyntheticClipboardEvent = __webpack_require__(810);
	var SyntheticEvent = __webpack_require__(37);
	var SyntheticFocusEvent = __webpack_require__(813);
	var SyntheticKeyboardEvent = __webpack_require__(815);
	var SyntheticMouseEvent = __webpack_require__(121);
	var SyntheticDragEvent = __webpack_require__(812);
	var SyntheticTouchEvent = __webpack_require__(816);
	var SyntheticTransitionEvent = __webpack_require__(817);
	var SyntheticUIEvent = __webpack_require__(98);
	var SyntheticWheelEvent = __webpack_require__(818);
	
	var emptyFunction = __webpack_require__(34);
	var getEventCharCode = __webpack_require__(172);
	var invariant = __webpack_require__(6);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(37);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(37);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(37);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(121);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(98);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(37);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(98);
	
	var getEventCharCode = __webpack_require__(172);
	var getEventKey = __webpack_require__(823);
	var getEventModifierState = __webpack_require__(173);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(98);
	
	var getEventModifierState = __webpack_require__(173);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(37);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(121);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 819 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(411);
	var warning = __webpack_require__(14);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(16);
	
	var ReactCurrentOwner = __webpack_require__(38);
	var ReactDOMComponentTree = __webpack_require__(22);
	var ReactInstanceMap = __webpack_require__(97);
	
	var getHostComponentFromComposite = __webpack_require__(431);
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(14);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(166);
	var traverseAllChildren = __webpack_require__(435);
	var warning = __webpack_require__(14);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(460);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75)))

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(172);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 824 */
464,
/* 825 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 826 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(26);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(123);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(424);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.ReactPixel=t():e.ReactPixel=t()}(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=1)}([function(e,t,n){"use strict";function r(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}Object.defineProperty(t,"__esModule",{value:!0});var o=!1,i=!1,a=function(){return o||console.warn("Pixel not initialized before using call ReactPixel.init with required params"),o},c=function(){for(var e,t=arguments.length,n=Array(t),o=0;o<t;o++)n[o]=arguments[o];(e=console).info.apply(e,r(["[react-facebook-pixel]"].concat(n)))},f={autoConfig:!0,debug:!1};t.default={init:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:f;!function(e,t,n,r,o,i,a){e.fbq||(o=e.fbq=function(){o.callMethod?o.callMethod.apply(o,arguments):o.queue.push(arguments)},e._fbq||(e._fbq=o),o.push=o,o.loaded=!0,o.version="2.0",o.queue=[],i=t.createElement(n),i.async=!0,i.src=r,a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(i,a))}(window,document,"script","https://connect.facebook.net/en_US/fbevents.js"),e?(!1===n.autoConfig&&fbq("set","autoConfig",!1,e),fbq("init",e,t),o=!0,i=n.debug):console.warn("Please insert pixel id for initializing")},pageView:function(){a()&&(fbq("track","PageView"),i&&c("called fbq('track', 'PageView');"))},track:function(e,t){a()&&(fbq("track",e,t),i&&(c("called fbq('track', '"+e+"');"),t&&c("with data",t)))},trackCustom:function(e,t){a()&&(fbq("trackCustom",e,t),i&&(c("called fbq('trackCustom', '"+e+"');"),t&&c("with data",t)))},fbq:function(e){function t(){return e.apply(this,arguments)}return t.toString=function(){return e.toString()},t}(function(){if(a()){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];fbq.apply(void 0,t),i&&(c("called fbq('"+t.slice(0,2).join("', '")+"')"),t[2]&&c("with data",t[2]))}})}},function(e,t,n){e.exports=n(0)}])});
	//# sourceMappingURL=fb-pixel.js.map

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	'use client';
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (this && this.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var react_1 = __importStar(__webpack_require__(1));
	var react_dom_1 = __webpack_require__(23);
	var prop_types_1 = __importDefault(__webpack_require__(4));
	var detect_element_overflow_1 = __importDefault(__webpack_require__(594));
	var tiny_warning_1 = __importDefault(__webpack_require__(945));
	var isBrowser = typeof document !== 'undefined';
	var isDisplayContentsSupported = isBrowser && 'CSS' in window && 'supports' in window.CSS && CSS.supports('display', 'contents');
	var isMutationObserverSupported = isBrowser && 'MutationObserver' in window;
	function capitalize(string) {
	    return (string.charAt(0).toUpperCase() + string.slice(1));
	}
	function findScrollContainer(element) {
	    var parent = element.parentElement;
	    while (parent) {
	        var overflow = window.getComputedStyle(parent).overflow;
	        if (overflow.split(' ').every(function (o) { return o === 'auto' || o === 'scroll'; })) {
	            return parent;
	        }
	        parent = parent.parentElement;
	    }
	    return document.documentElement;
	}
	function alignAxis(_a) {
	    var axis = _a.axis, container = _a.container, element = _a.element, invertAxis = _a.invertAxis, secondary = _a.secondary, scrollContainer = _a.scrollContainer, spacing = _a.spacing;
	    var style = window.getComputedStyle(element);
	    var parent = container.parentElement;
	    if (!parent) {
	        return;
	    }
	    var scrollContainerCollisions = (0, detect_element_overflow_1.default)(parent, scrollContainer);
	    var documentCollisions = (0, detect_element_overflow_1.default)(parent, document.documentElement);
	    var isX = axis === 'x';
	    var startProperty = isX ? 'left' : 'top';
	    var endProperty = isX ? 'right' : 'bottom';
	    var sizeProperty = isX ? 'width' : 'height';
	    var overflowStartProperty = "overflow".concat(capitalize(startProperty));
	    var overflowEndProperty = "overflow".concat(capitalize(endProperty));
	    var scrollProperty = "scroll".concat(capitalize(startProperty));
	    var uppercasedSizeProperty = capitalize(sizeProperty);
	    var offsetSizeProperty = "offset".concat(uppercasedSizeProperty);
	    var clientSizeProperty = "client".concat(uppercasedSizeProperty);
	    var minSizeProperty = "min-".concat(sizeProperty);
	    var scrollbarWidth = scrollContainer[offsetSizeProperty] - scrollContainer[clientSizeProperty];
	    var startSpacing = typeof spacing === 'object' ? spacing[startProperty] : spacing;
	    var availableStartSpace = -Math.max(scrollContainerCollisions[overflowStartProperty], documentCollisions[overflowStartProperty] + document.documentElement[scrollProperty]) - startSpacing;
	    var endSpacing = typeof spacing === 'object' ? spacing[endProperty] : spacing;
	    var availableEndSpace = -Math.max(scrollContainerCollisions[overflowEndProperty], documentCollisions[overflowEndProperty] - document.documentElement[scrollProperty]) -
	        endSpacing -
	        scrollbarWidth;
	    if (secondary) {
	        availableStartSpace += parent[clientSizeProperty];
	        availableEndSpace += parent[clientSizeProperty];
	    }
	    var offsetSize = element[offsetSizeProperty];
	    function displayStart() {
	        element.style[startProperty] = 'auto';
	        element.style[endProperty] = secondary ? '0' : '100%';
	    }
	    function displayEnd() {
	        element.style[startProperty] = secondary ? '0' : '100%';
	        element.style[endProperty] = 'auto';
	    }
	    function displayIfFits(availableSpace, display) {
	        var fits = offsetSize <= availableSpace;
	        if (fits) {
	            display();
	        }
	        return fits;
	    }
	    function displayStartIfFits() {
	        return displayIfFits(availableStartSpace, displayStart);
	    }
	    function displayEndIfFits() {
	        return displayIfFits(availableEndSpace, displayEnd);
	    }
	    function displayWhereverShrinkedFits() {
	        var moreSpaceStart = availableStartSpace > availableEndSpace;
	        var rawMinSize = style.getPropertyValue(minSizeProperty);
	        var minSize = rawMinSize ? parseInt(rawMinSize, 10) : null;
	        function shrinkToSize(size) {
	            (0, tiny_warning_1.default)(!minSize || size >= minSize, "<Fit />'s child will not fit anywhere with its current ".concat(minSizeProperty, " of ").concat(minSize, "px."));
	            var newSize = Math.max(size, minSize || 0);
	            (0, tiny_warning_1.default)(false, "<Fit />'s child needed to have its ".concat(sizeProperty, " decreased to ").concat(newSize, "px."));
	            element.style[sizeProperty] = "".concat(newSize, "px");
	        }
	        if (moreSpaceStart) {
	            shrinkToSize(availableStartSpace);
	            displayStart();
	        }
	        else {
	            shrinkToSize(availableEndSpace);
	            displayEnd();
	        }
	    }
	    var fits;
	    if (invertAxis) {
	        fits = displayStartIfFits() || displayEndIfFits();
	    }
	    else {
	        fits = displayEndIfFits() || displayStartIfFits();
	    }
	    if (!fits) {
	        displayWhereverShrinkedFits();
	    }
	}
	function alignMainAxis(args) {
	    alignAxis(args);
	}
	function alignSecondaryAxis(args) {
	    alignAxis(__assign(__assign({}, args), { axis: args.axis === 'x' ? 'y' : 'x', secondary: true }));
	}
	function alignBothAxis(args) {
	    var invertAxis = args.invertAxis, invertSecondaryAxis = args.invertSecondaryAxis, commonArgs = __rest(args, ["invertAxis", "invertSecondaryAxis"]);
	    alignMainAxis(__assign(__assign({}, commonArgs), { invertAxis: invertAxis }));
	    alignSecondaryAxis(__assign(__assign({}, commonArgs), { invertAxis: invertSecondaryAxis }));
	}
	var Fit = /** @class */ (function (_super) {
	    __extends(Fit, _super);
	    function Fit() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.fit = function () {
	            var _a = _this, scrollContainer = _a.scrollContainer, container = _a.container, element = _a.element;
	            if (!scrollContainer || !container || !element) {
	                return;
	            }
	            var elementWidth = element.clientWidth;
	            var elementHeight = element.clientHeight;
	            // No need to recalculate - already did that for current dimensions
	            if (_this.elementWidth === elementWidth && _this.elementHeight === elementHeight) {
	                return;
	            }
	            // Save the dimensions so that we know we don't need to repeat the function if unchanged
	            _this.elementWidth = elementWidth;
	            _this.elementHeight = elementHeight;
	            var parent = container.parentElement;
	            // Container was unmounted
	            if (!parent) {
	                return;
	            }
	            /**
	             * We need to ensure that <Fit />'s child has a absolute position. Otherwise,
	             * we wouldn't be able to place the child in the correct position.
	             */
	            var style = window.getComputedStyle(element);
	            var position = style.position;
	            if (position !== 'absolute') {
	                element.style.position = 'absolute';
	            }
	            /**
	             * We need to ensure that <Fit />'s parent has a relative or absolute position. Otherwise,
	             * we wouldn't be able to place the child in the correct position.
	             */
	            var parentStyle = window.getComputedStyle(parent);
	            var parentPosition = parentStyle.position;
	            if (parentPosition !== 'relative' && parentPosition !== 'absolute') {
	                parent.style.position = 'relative';
	            }
	            var _b = _this.props, invertAxis = _b.invertAxis, invertSecondaryAxis = _b.invertSecondaryAxis, _c = _b.mainAxis, mainAxis = _c === void 0 ? 'y' : _c, _d = _b.spacing, spacing = _d === void 0 ? 8 : _d;
	            alignBothAxis({
	                container: container,
	                element: element,
	                invertAxis: invertAxis,
	                invertSecondaryAxis: invertSecondaryAxis,
	                axis: mainAxis,
	                scrollContainer: scrollContainer,
	                spacing: spacing,
	            });
	        };
	        return _this;
	    }
	    Fit.prototype.componentDidMount = function () {
	        var _this = this;
	        if (!isDisplayContentsSupported) {
	            // eslint-disable-next-line react/no-find-dom-node
	            var element = (0, react_dom_1.findDOMNode)(this);
	            if (!element || !(element instanceof HTMLElement)) {
	                return;
	            }
	            this.container = element;
	            this.element = element;
	            this.scrollContainer = findScrollContainer(element);
	        }
	        this.fit();
	        var onMutation = function () {
	            _this.fit();
	        };
	        if (isMutationObserverSupported && this.element) {
	            var mutationObserver = new MutationObserver(onMutation);
	            mutationObserver.observe(this.element, {
	                attributes: true,
	                attributeFilter: ['class', 'style'],
	            });
	        }
	    };
	    Fit.prototype.render = function () {
	        var _this = this;
	        var children = this.props.children;
	        var child = react_1.default.Children.only(children);
	        if (isDisplayContentsSupported) {
	            return (react_1.default.createElement("span", { ref: function (container) {
	                    _this.container = container;
	                    var element = container && container.firstElementChild;
	                    if (!element || !(element instanceof HTMLElement)) {
	                        return;
	                    }
	                    _this.element = element;
	                    _this.scrollContainer = findScrollContainer(element);
	                }, style: { display: 'contents' } }, child));
	        }
	        return child;
	    };
	    Fit.propTypes = {
	        children: prop_types_1.default.node.isRequired,
	        invertAxis: prop_types_1.default.bool,
	        invertSecondaryAxis: prop_types_1.default.bool,
	        mainAxis: prop_types_1.default.oneOf(['x', 'y']),
	        spacing: prop_types_1.default.oneOfType([
	            prop_types_1.default.number,
	            prop_types_1.default.shape({
	                bottom: prop_types_1.default.number.isRequired,
	                left: prop_types_1.default.number.isRequired,
	                right: prop_types_1.default.number.isRequired,
	                top: prop_types_1.default.number.isRequired,
	            }),
	        ]),
	    };
	    return Fit;
	}(react_1.Component));
	exports.default = Fit;


/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Fit = void 0;
	var Fit_js_1 = __importDefault(__webpack_require__(831));
	exports.Fit = Fit_js_1.default;
	exports.default = Fit_js_1.default;


/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(4));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__14__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 11);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = warn;
	
	function warn(s) {
	  console.warn('[react-ga]', s);
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = trim;
	
	// GA strings need to have leading/trailing whitespace trimmed, and not all
	// browsers have String.prototoype.trim().
	function trim(s) {
	  return s && s.toString().replace(/^\s+|\s+$/g, '');
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addTrackers = addTrackers;
	exports.initialize = initialize;
	exports.ga = ga;
	exports.set = set;
	exports.send = send;
	exports.pageview = pageview;
	exports.modalview = modalview;
	exports.timing = timing;
	exports.event = event;
	exports.exception = exception;
	exports.outboundLink = outboundLink;
	exports["default"] = exports.testModeAPI = exports.plugin = void 0;
	
	var _format2 = _interopRequireDefault(__webpack_require__(3));
	
	var _removeLeadingSlash = _interopRequireDefault(__webpack_require__(7));
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	var _loadGA = _interopRequireDefault(__webpack_require__(8));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	var _log = _interopRequireDefault(__webpack_require__(9));
	
	var _testModeAPI = _interopRequireDefault(__webpack_require__(10));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';
	
	var _debug = false;
	var _titleCase = true;
	var _testMode = false;
	var _alwaysSendToDefaultTracker = true;
	var _redactEmail = true;
	
	var internalGa = function internalGa() {
	  var _window;
	
	  if (_testMode) return _testModeAPI["default"].ga.apply(_testModeAPI["default"], arguments);
	  if (_isNotBrowser) return false;
	  if (!window.ga) return (0, _warn["default"])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
	  return (_window = window).ga.apply(_window, arguments);
	};
	
	function _format(s) {
	  return (0, _format2["default"])(s, _titleCase, _redactEmail);
	}
	
	function _gaCommand(trackerNames) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var command = args[0];
	
	  if (typeof internalGa === 'function') {
	    if (typeof command !== 'string') {
	      (0, _warn["default"])('ga command must be a string');
	      return;
	    }
	
	    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);
	
	    if (Array.isArray(trackerNames)) {
	      trackerNames.forEach(function (name) {
	        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
	      });
	    }
	  }
	}
	
	function _initialize(gaTrackingID, options) {
	  if (!gaTrackingID) {
	    (0, _warn["default"])('gaTrackingID is required in initialize()');
	    return;
	  }
	
	  if (options) {
	    if (options.debug && options.debug === true) {
	      _debug = true;
	    }
	
	    if (options.titleCase === false) {
	      _titleCase = false;
	    }
	
	    if (options.redactEmail === false) {
	      _redactEmail = false;
	    }
	
	    if (options.useExistingGa) {
	      return;
	    }
	  }
	
	  if (options && options.gaOptions) {
	    internalGa('create', gaTrackingID, options.gaOptions);
	  } else {
	    internalGa('create', gaTrackingID, 'auto');
	  }
	}
	
	function addTrackers(configsOrTrackingId, options) {
	  if (Array.isArray(configsOrTrackingId)) {
	    configsOrTrackingId.forEach(function (config) {
	      if (_typeof(config) !== 'object') {
	        (0, _warn["default"])('All configs must be an object');
	        return;
	      }
	
	      _initialize(config.trackingId, config);
	    });
	  } else {
	    _initialize(configsOrTrackingId, options);
	  }
	
	  return true;
	}
	
	function initialize(configsOrTrackingId, options) {
	  if (options && options.testMode === true) {
	    _testMode = true;
	  } else {
	    if (_isNotBrowser) {
	      return;
	    }
	
	    if (!options || options.standardImplementation !== true) (0, _loadGA["default"])(options);
	  }
	
	  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
	  addTrackers(configsOrTrackingId, options);
	}
	/**
	 * ga:
	 * Returns the original GA object.
	 */
	
	
	function ga() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (args.length > 0) {
	    internalGa.apply(void 0, args);
	
	    if (_debug) {
	      (0, _log["default"])("called ga('arguments');");
	      (0, _log["default"])("with arguments: ".concat(JSON.stringify(args)));
	    }
	  }
	
	  return window.ga;
	}
	/**
	 * set:
	 * GA tracker set method
	 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function set(fieldsObject, trackerNames) {
	  if (!fieldsObject) {
	    (0, _warn["default"])('`fieldsObject` is required in .set()');
	    return;
	  }
	
	  if (_typeof(fieldsObject) !== 'object') {
	    (0, _warn["default"])('Expected `fieldsObject` arg to be an Object');
	    return;
	  }
	
	  if (Object.keys(fieldsObject).length === 0) {
	    (0, _warn["default"])('empty `fieldsObject` given to .set()');
	  }
	
	  _gaCommand(trackerNames, 'set', fieldsObject);
	
	  if (_debug) {
	    (0, _log["default"])("called ga('set', fieldsObject);");
	    (0, _log["default"])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
	  }
	}
	/**
	 * send:
	 * Clone of the low level `ga.send` method
	 * WARNING: No validations will be applied to this
	 * @param  {Object} fieldObject - field object for tracking different analytics
	 * @param  {Array} trackerNames - trackers to send the command to
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function send(fieldObject, trackerNames) {
	  _gaCommand(trackerNames, 'send', fieldObject);
	
	  if (_debug) {
	    (0, _log["default"])("called ga('send', fieldObject);");
	    (0, _log["default"])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
	    (0, _log["default"])("with trackers: ".concat(JSON.stringify(trackerNames)));
	  }
	}
	/**
	 * pageview:
	 * Basic GA pageview tracking
	 * @param  {String} path - the current page page e.g. '/about'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 * @param {String} title - (optional) the page title e. g. 'My Website'
	 */
	
	
	function pageview(rawPath, trackerNames, title) {
	  if (!rawPath) {
	    (0, _warn["default"])('path is required in .pageview()');
	    return;
	  }
	
	  var path = (0, _trim["default"])(rawPath);
	
	  if (path === '') {
	    (0, _warn["default"])('path cannot be an empty string in .pageview()');
	    return;
	  }
	
	  var extraFields = {};
	
	  if (title) {
	    extraFields.title = title;
	  }
	
	  if (typeof ga === 'function') {
	    _gaCommand(trackerNames, 'send', _objectSpread({
	      hitType: 'pageview',
	      page: path
	    }, extraFields));
	
	    if (_debug) {
	      (0, _log["default"])("called ga('send', 'pageview', path);");
	      var extraLog = '';
	
	      if (title) {
	        extraLog = " and title: ".concat(title);
	      }
	
	      (0, _log["default"])("with path: ".concat(path).concat(extraLog));
	    }
	  }
	}
	/**
	 * modalview:
	 * a proxy to basic GA pageview tracking to consistently track
	 * modal views that are an equivalent UX to a traditional pageview
	 * @param  {String} modalName e.g. 'add-or-edit-club'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function modalview(rawModalName, trackerNames) {
	  if (!rawModalName) {
	    (0, _warn["default"])('modalName is required in .modalview(modalName)');
	    return;
	  }
	
	  var modalName = (0, _removeLeadingSlash["default"])((0, _trim["default"])(rawModalName));
	
	  if (modalName === '') {
	    (0, _warn["default"])('modalName cannot be an empty string or a single / in .modalview()');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    var path = "/modal/".concat(modalName);
	
	    _gaCommand(trackerNames, 'send', 'pageview', path);
	
	    if (_debug) {
	      (0, _log["default"])("called ga('send', 'pageview', path);");
	      (0, _log["default"])("with path: ".concat(path));
	    }
	  }
	}
	/**
	 * timing:
	 * GA timing
	 * @param args.category {String} required
	 * @param args.variable {String} required
	 * @param args.value  {Int}  required
	 * @param args.label  {String} required
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function timing() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref.category,
	      variable = _ref.variable,
	      value = _ref.value,
	      label = _ref.label;
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    if (!category || !variable || typeof value !== 'number') {
	      (0, _warn["default"])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'timing',
	      timingCategory: _format(category),
	      timingVar: _format(variable),
	      timingValue: value
	    };
	
	    if (label) {
	      fieldObject.timingLabel = _format(label);
	    }
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * event:
	 * GA event tracking
	 * @param args.category {String} required
	 * @param args.action {String} required
	 * @param args.label {String} optional
	 * @param args.value {Int} optional
	 * @param args.nonInteraction {boolean} optional
	 * @param args.transport {string} optional
	 * @param {{action: string, category: string}} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function event() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref2.category,
	      action = _ref2.action,
	      label = _ref2.label,
	      value = _ref2.value,
	      nonInteraction = _ref2.nonInteraction,
	      transport = _ref2.transport,
	      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!category || !action) {
	      (0, _warn["default"])('args.category AND args.action are required in event()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: _format(category),
	      eventAction: _format(action)
	    }; // Optional Fields
	
	    if (label) {
	      fieldObject.eventLabel = _format(label);
	    }
	
	    if (typeof value !== 'undefined') {
	      if (typeof value !== 'number') {
	        (0, _warn["default"])('Expected `args.value` arg to be a Number.');
	      } else {
	        fieldObject.eventValue = value;
	      }
	    }
	
	    if (typeof nonInteraction !== 'undefined') {
	      if (typeof nonInteraction !== 'boolean') {
	        (0, _warn["default"])('`args.nonInteraction` must be a boolean.');
	      } else {
	        fieldObject.nonInteraction = nonInteraction;
	      }
	    }
	
	    if (typeof transport !== 'undefined') {
	      if (typeof transport !== 'string') {
	        (0, _warn["default"])('`args.transport` must be a string.');
	      } else {
	        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
	          (0, _warn["default"])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
	        }
	
	        fieldObject.transport = transport;
	      }
	    }
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'dimension'.length) === 'dimension';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'metric'.length) === 'metric';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    }); // Send to GA
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * exception:
	 * GA exception tracking
	 * @param args.description {String} optional
	 * @param args.fatal {boolean} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function exception(_ref3, trackerNames) {
	  var description = _ref3.description,
	      fatal = _ref3.fatal;
	
	  if (typeof ga === 'function') {
	    // Required Fields
	    var fieldObject = {
	      hitType: 'exception'
	    }; // Optional Fields
	
	    if (description) {
	      fieldObject.exDescription = _format(description);
	    }
	
	    if (typeof fatal !== 'undefined') {
	      if (typeof fatal !== 'boolean') {
	        (0, _warn["default"])('`args.fatal` must be a boolean.');
	      } else {
	        fieldObject.exFatal = fatal;
	      }
	    } // Send to GA
	
	
	    send(fieldObject, trackerNames);
	  }
	}
	
	var plugin = {
	  /**
	   * require:
	   * GA requires a plugin
	   * @param name {String} e.g. 'ecommerce' or 'myplugin'
	   * @param options {Object} optional e.g {path: '/log', debug: true}
	   * @param trackerName {String} optional e.g 'trackerName'
	   */
	  require: function require(rawName, options, trackerName) {
	    if (typeof ga === 'function') {
	      // Required Fields
	      if (!rawName) {
	        (0, _warn["default"])('`name` is required in .require()');
	        return;
	      }
	
	      var name = (0, _trim["default"])(rawName);
	
	      if (name === '') {
	        (0, _warn["default"])('`name` cannot be an empty string in .require()');
	        return;
	      }
	
	      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields
	
	      if (options) {
	        if (_typeof(options) !== 'object') {
	          (0, _warn["default"])('Expected `options` arg to be an Object');
	          return;
	        }
	
	        if (Object.keys(options).length === 0) {
	          (0, _warn["default"])('Empty `options` given to .require()');
	        }
	
	        ga(requireString, name, options);
	
	        if (_debug) {
	          (0, _log["default"])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
	        }
	      } else {
	        ga(requireString, name);
	
	        if (_debug) {
	          (0, _log["default"])("called ga('require', '".concat(name, "');"));
	        }
	      }
	    }
	  },
	
	  /**
	   * execute:
	   * GA execute action for plugin
	   * Takes variable number of arguments
	   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
	   * @param action {String} e.g. 'addItem' or 'myCustomAction'
	   * @param actionType {String} optional e.g. 'detail'
	   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
	   */
	  execute: function execute(pluginName, action) {
	    var payload;
	    var actionType;
	
	    for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
	      args[_key3 - 2] = arguments[_key3];
	    }
	
	    if (args.length === 1) {
	      payload = args[0];
	    } else {
	      actionType = args[0];
	      payload = args[1];
	    }
	
	    if (typeof ga === 'function') {
	      if (typeof pluginName !== 'string') {
	        (0, _warn["default"])('Expected `pluginName` arg to be a String.');
	      } else if (typeof action !== 'string') {
	        (0, _warn["default"])('Expected `action` arg to be a String.');
	      } else {
	        var command = "".concat(pluginName, ":").concat(action);
	        payload = payload || null;
	
	        if (actionType && payload) {
	          ga(command, actionType, payload);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	            (0, _log["default"])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
	          }
	        } else if (payload) {
	          ga(command, payload);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	            (0, _log["default"])("with payload: ".concat(JSON.stringify(payload)));
	          }
	        } else {
	          ga(command);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	          }
	        }
	      }
	    }
	  }
	};
	/**
	 * outboundLink:
	 * GA outboundLink tracking
	 * @param args.label {String} e.g. url, or 'Create an Account'
	 * @param {function} hitCallback - Called after processing a hit.
	 */
	
	exports.plugin = plugin;
	
	function outboundLink(args, hitCallback, trackerNames) {
	  if (typeof hitCallback !== 'function') {
	    (0, _warn["default"])('hitCallback function is required');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!args || !args.label) {
	      (0, _warn["default"])('args.label is required in outboundLink()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: 'Outbound',
	      eventAction: 'Click',
	      eventLabel: _format(args.label)
	    };
	    var safetyCallbackCalled = false;
	
	    var safetyCallback = function safetyCallback() {
	      // This prevents a delayed response from GA
	      // causing hitCallback from being fired twice
	      safetyCallbackCalled = true;
	      hitCallback();
	    }; // Using a timeout to ensure the execution of critical application code
	    // in the case when the GA server might be down
	    // or an ad blocker prevents sending the data
	    // register safety net timeout:
	
	
	    var t = setTimeout(safetyCallback, 250);
	
	    var clearableCallbackForGA = function clearableCallbackForGA() {
	      clearTimeout(t);
	
	      if (!safetyCallbackCalled) {
	        hitCallback();
	      }
	    };
	
	    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA
	
	    send(fieldObject, trackerNames);
	  } else {
	    // if ga is not defined, return the callback so the application
	    // continues to work as expected
	    setTimeout(hitCallback, 0);
	  }
	}
	
	var testModeAPI = _testModeAPI["default"];
	exports.testModeAPI = testModeAPI;
	var _default = {
	  initialize: initialize,
	  ga: ga,
	  set: set,
	  send: send,
	  pageview: pageview,
	  modalview: modalview,
	  timing: timing,
	  event: event,
	  exception: exception,
	  plugin: plugin,
	  outboundLink: outboundLink,
	  testModeAPI: _testModeAPI["default"]
	};
	exports["default"] = _default;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = format;
	
	var _redactEmail = _interopRequireDefault(__webpack_require__(4));
	
	var _toTitleCase = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function format() {
	  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var titleCase = arguments.length > 1 ? arguments[1] : undefined;
	  var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  var _str = s || '';
	
	  if (titleCase) {
	    _str = (0, _toTitleCase["default"])(s);
	  }
	
	  if (redactingEmail) {
	    _str = (0, _redactEmail["default"])(_str);
	  }
	
	  return _str;
	}
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = redactEmail;
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	var _mightBeEmail = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var redacted = 'REDACTED (Potential Email Address)';
	
	function redactEmail(string) {
	  if ((0, _mightBeEmail["default"])(string)) {
	    (0, _warn["default"])('This arg looks like an email address, redacting.');
	    return redacted;
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = mightBeEmail;
	
	// See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return typeof s === 'string' && s.indexOf('@') !== -1;
	}
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = toTitleCase;
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * To Title Case 2.1 - http://individed.com/code/to-title-case/
	 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
	 * https://github.com/gouch/to-title-case
	 */
	var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; // test
	
	function toTitleCase(string) {
	  return (0, _trim["default"])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = removeLeadingSlash;
	
	function removeLeadingSlash(string) {
	  if (string.substring(0, 1) === '/') {
	    return string.substring(1);
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = _default;
	var isLoaded = false;
	
	function _default(options) {
	  if (isLoaded) return;
	  isLoaded = true;
	  var gaAddress = 'https://www.google-analytics.com/analytics.js';
	
	  if (options && options.gaAddress) {
	    gaAddress = options.gaAddress;
	  } else if (options && options.debug) {
	    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
	  }
	
	  var onerror = options && options.onerror; // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	
	  /* eslint-disable */
	
	  (function (i, s, o, g, r, a, m) {
	    i['GoogleAnalyticsObject'] = r;
	    i[r] = i[r] || function () {
	      (i[r].q = i[r].q || []).push(arguments);
	    }, i[r].l = 1 * new Date();
	    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	    a.async = 1;
	    a.src = g;
	    a.onerror = onerror;
	    m.parentNode.insertBefore(a, m);
	  })(window, document, 'script', gaAddress, 'ga');
	  /* eslint-enable */
	
	}
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = log;
	
	function log(s) {
	  console.info('[react-ga]', s);
	}
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.gaCalls = void 0;
	var gaCalls = [];
	exports.gaCalls = gaCalls;
	var _default = {
	  calls: gaCalls,
	  ga: function ga() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    gaCalls.push([].concat(args));
	  },
	  resetCalls: function resetCalls() {
	    gaCalls.length = 0;
	  }
	};
	exports["default"] = _default;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.OutboundLink = exports.testModeAPI = exports.outboundLink = exports.plugin = exports.exception = exports.event = exports.timing = exports.modalview = exports.pageview = exports.send = exports.set = exports.ga = exports.addTrackers = exports.initialize = void 0;
	
	var _OutboundLink = _interopRequireDefault(__webpack_require__(12));
	
	var Defaults = _interopRequireWildcard(__webpack_require__(2));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialize = Defaults.initialize;
	exports.initialize = initialize;
	var addTrackers = Defaults.addTrackers;
	exports.addTrackers = addTrackers;
	var ga = Defaults.ga;
	exports.ga = ga;
	var set = Defaults.set;
	exports.set = set;
	var send = Defaults.send;
	exports.send = send;
	var pageview = Defaults.pageview;
	exports.pageview = pageview;
	var modalview = Defaults.modalview;
	exports.modalview = modalview;
	var timing = Defaults.timing;
	exports.timing = timing;
	var event = Defaults.event;
	exports.event = event;
	var exception = Defaults.exception;
	exports.exception = exception;
	var plugin = Defaults.plugin;
	exports.plugin = plugin;
	var outboundLink = Defaults.outboundLink;
	exports.outboundLink = outboundLink;
	var testModeAPI = Defaults.testModeAPI;
	exports.testModeAPI = testModeAPI;
	_OutboundLink["default"].origTrackLink = _OutboundLink["default"].trackLink;
	_OutboundLink["default"].trackLink = Defaults.outboundLink;
	var OutboundLink = _OutboundLink["default"];
	exports.OutboundLink = OutboundLink;
	
	var _default = _objectSpread(_objectSpread({}, Defaults), {}, {
	  OutboundLink: OutboundLink
	});
	
	exports["default"] = _default;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NEWTAB = '_blank';
	var MIDDLECLICK = 1;
	
	var OutboundLink = /*#__PURE__*/function (_Component) {
	  _inherits(OutboundLink, _Component);
	
	  var _super = _createSuper(OutboundLink);
	
	  function OutboundLink() {
	    var _this;
	
	    _classCallCheck(this, OutboundLink);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
	      var _this$props = _this.props,
	          target = _this$props.target,
	          eventLabel = _this$props.eventLabel,
	          to = _this$props.to,
	          onClick = _this$props.onClick,
	          trackerNames = _this$props.trackerNames;
	      var eventMeta = {
	        label: eventLabel
	      };
	      var sameTarget = target !== NEWTAB;
	      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);
	
	      if (sameTarget && normalClick) {
	        event.preventDefault();
	        OutboundLink.trackLink(eventMeta, function () {
	          window.location.href = to;
	        }, trackerNames);
	      } else {
	        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(OutboundLink, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          href = _this$props2.to,
	          target = _this$props2.target,
	          oldProps = _objectWithoutProperties(_this$props2, ["to", "target"]);
	
	      var props = _objectSpread(_objectSpread({}, oldProps), {}, {
	        target: target,
	        href: href,
	        onClick: this.handleClick
	      });
	
	      if (target === NEWTAB) {
	        props.rel = "".concat(props.rel ? props.rel : '', " noopener noreferrer").trim();
	      }
	
	      delete props.eventLabel;
	      delete props.trackerNames;
	      return /*#__PURE__*/_react["default"].createElement('a', props);
	    }
	  }]);
	
	  return OutboundLink;
	}(_react.Component);
	
	exports["default"] = OutboundLink;
	
	_defineProperty(OutboundLink, "trackLink", function () {
	  (0, _warn["default"])('ga tracking not enabled');
	});
	
	OutboundLink.propTypes = {
	  eventLabel: _propTypes["default"].string.isRequired,
	  target: _propTypes["default"].string,
	  to: _propTypes["default"].string,
	  onClick: _propTypes["default"].func,
	  trackerNames: _propTypes["default"].arrayOf(_propTypes["default"].string)
	};
	OutboundLink.defaultProps = {
	  target: null,
	  to: null,
	  onClick: null,
	  trackerNames: null
	};
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__13__;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__14__;
	
	/***/ })
	/******/ ]);
	});

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _warn = __webpack_require__(837);
	
	var _warn2 = _interopRequireDefault(_warn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// https://developers.google.com/tag-manager/quickstart
	
	var Snippets = {
	  tags: function tags(_ref) {
	    var id = _ref.id,
	        events = _ref.events,
	        dataLayer = _ref.dataLayer,
	        dataLayerName = _ref.dataLayerName,
	        preview = _ref.preview,
	        auth = _ref.auth;
	
	    var gtm_auth = '&gtm_auth=' + auth;
	    var gtm_preview = '&gtm_preview=' + preview;
	
	    if (!id) (0, _warn2.default)('GTM Id is required');
	
	    var iframe = '\n      <iframe src="https://www.googletagmanager.com/ns.html?id=' + id + gtm_auth + gtm_preview + '&gtm_cookies_win=x"\n        height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>';
	
	    var script = '\n      (function(w,d,s,l,i){w[l]=w[l]||[];\n        w[l].push({\'gtm.start\': new Date().getTime(),event:\'gtm.js\', ' + JSON.stringify(events).slice(1, -1) + '});\n        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';\n        j.async=true;j.src=\'https://www.googletagmanager.com/gtm.js?id=\'+i+dl+\'' + gtm_auth + gtm_preview + '&gtm_cookies_win=x\';\n        f.parentNode.insertBefore(j,f);\n      })(window,document,\'script\',\'' + dataLayerName + '\',\'' + id + '\');';
	
	    var dataLayerVar = this.dataLayer(dataLayer, dataLayerName);
	
	    return {
	      iframe: iframe,
	      script: script,
	      dataLayerVar: dataLayerVar
	    };
	  },
	  dataLayer: function dataLayer(_dataLayer, dataLayerName) {
	    return '\n      window.' + dataLayerName + ' = window.' + dataLayerName + ' || [];\n      window.' + dataLayerName + '.push(' + JSON.stringify(_dataLayer) + ')';
	  }
	};
	
	module.exports = Snippets;

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Snippets = __webpack_require__(834);
	
	var _Snippets2 = _interopRequireDefault(_Snippets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TagManager = {
	  dataScript: function dataScript(dataLayer) {
	    var script = document.createElement('script');
	    script.innerHTML = dataLayer;
	    return script;
	  },
	  gtm: function gtm(args) {
	    var snippets = _Snippets2.default.tags(args);
	
	    var noScript = function noScript() {
	      var noscript = document.createElement('noscript');
	      noscript.innerHTML = snippets.iframe;
	      return noscript;
	    };
	
	    var script = function script() {
	      var script = document.createElement('script');
	      script.innerHTML = snippets.script;
	      return script;
	    };
	
	    var dataScript = this.dataScript(snippets.dataLayerVar);
	
	    return {
	      noScript: noScript,
	      script: script,
	      dataScript: dataScript
	    };
	  },
	  initialize: function initialize(_ref) {
	    var gtmId = _ref.gtmId,
	        _ref$events = _ref.events,
	        events = _ref$events === undefined ? {} : _ref$events,
	        dataLayer = _ref.dataLayer,
	        _ref$dataLayerName = _ref.dataLayerName,
	        dataLayerName = _ref$dataLayerName === undefined ? 'dataLayer' : _ref$dataLayerName,
	        _ref$auth = _ref.auth,
	        auth = _ref$auth === undefined ? '' : _ref$auth,
	        _ref$preview = _ref.preview,
	        preview = _ref$preview === undefined ? '' : _ref$preview;
	
	    var gtm = this.gtm({
	      id: gtmId,
	      events: events,
	      dataLayer: dataLayer || undefined,
	      dataLayerName: dataLayerName,
	      auth: auth,
	      preview: preview
	    });
	    if (dataLayer) document.head.appendChild(gtm.dataScript);
	    document.head.insertBefore(gtm.script(), document.head.childNodes[0]);
	    document.body.insertBefore(gtm.noScript(), document.body.childNodes[0]);
	  },
	  dataLayer: function dataLayer(_ref2) {
	    var _dataLayer = _ref2.dataLayer,
	        _ref2$dataLayerName = _ref2.dataLayerName,
	        dataLayerName = _ref2$dataLayerName === undefined ? 'dataLayer' : _ref2$dataLayerName;
	
	    if (window[dataLayerName]) return window[dataLayerName].push(_dataLayer);
	    var snippets = _Snippets2.default.dataLayer(_dataLayer, dataLayerName);
	    var dataScript = this.dataScript(snippets);
	    document.head.insertBefore(dataScript, document.head.childNodes[0]);
	  }
	};
	
	module.exports = TagManager;

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _TagManager = __webpack_require__(835);
	
	var _TagManager2 = _interopRequireDefault(_TagManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _TagManager2.default;

/***/ },
/* 837 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var warn = function warn(s) {
	  console.warn('[react-gtm]', s);
	};
	
	exports.default = warn;

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(4);
	var createClass = __webpack_require__(590);
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var AutosizeInput = createClass({
		propTypes: {
			className: PropTypes.string, // className for the outer element
			defaultValue: PropTypes.any, // default field value
			inputClassName: PropTypes.string, // className for the input element
			inputRef: PropTypes.func, // ref callback for the input element
			inputStyle: PropTypes.object, // css styles for the input element
			minWidth: PropTypes.oneOfType([// minimum width for input element
			PropTypes.number, PropTypes.string]),
			onAutosize: PropTypes.func, // onAutosize handler: function(newWidth) {}
			onChange: PropTypes.func, // onChange handler: function(newValue) {}
			placeholder: PropTypes.string, // placeholder text
			placeholderIsMinWidth: PropTypes.bool, // don't collapse size to less than the placeholder
			style: PropTypes.object, // css styles for the outer element
			value: PropTypes.any },
		// field value
		getDefaultProps: function getDefaultProps() {
			return {
				minWidth: 1
			};
		},
		getInitialState: function getInitialState() {
			return {
				inputWidth: this.props.minWidth,
				inputId: '_' + Math.random().toString(36).substr(2, 12)
			};
		},
		componentDidMount: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		},
		componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		},
		componentWillUnmount: function componentWillUnmount() {
			this.mounted = false;
		},
		inputRef: function inputRef(el) {
			this.input = el;
			if (typeof this.props.inputRef === 'function') {
				this.props.inputRef(el);
			}
		},
		placeHolderSizerRef: function placeHolderSizerRef(el) {
			this.placeHolderSizer = el;
		},
		sizerRef: function sizerRef(el) {
			this.sizer = el;
		},
		copyInputStyles: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyle = this.input && window.getComputedStyle(this.input);
			if (!inputStyle) {
				return;
			}
			var widthNode = this.sizer;
			widthNode.style.fontSize = inputStyle.fontSize;
			widthNode.style.fontFamily = inputStyle.fontFamily;
			widthNode.style.fontWeight = inputStyle.fontWeight;
			widthNode.style.fontStyle = inputStyle.fontStyle;
			widthNode.style.letterSpacing = inputStyle.letterSpacing;
			widthNode.style.textTransform = inputStyle.textTransform;
			if (this.props.placeholder) {
				var placeholderNode = this.placeHolderSizer;
				placeholderNode.style.fontSize = inputStyle.fontSize;
				placeholderNode.style.fontFamily = inputStyle.fontFamily;
				placeholderNode.style.fontWeight = inputStyle.fontWeight;
				placeholderNode.style.fontStyle = inputStyle.fontStyle;
				placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
				placeholderNode.style.textTransform = inputStyle.textTransform;
			}
		},
		updateInputWidth: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = undefined;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		},
		getInput: function getInput() {
			return this.input;
		},
		focus: function focus() {
			this.input.focus();
		},
		blur: function blur() {
			this.input.blur();
		},
		select: function select() {
			this.input.select();
		},
		render: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});
	
			var wrapperStyle = this.props.style || {};
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
			var inputStyle = _extends({}, this.props.inputStyle);
			inputStyle.width = this.state.inputWidth + 'px';
			inputStyle.boxSizing = 'content-box';
			var inputProps = _extends({}, this.props);
			inputProps.className = this.props.inputClassName;
			inputProps.style = inputStyle;
			// ensure props meant for `AutosizeInput` don't end up on the `input`
			delete inputProps.inputClassName;
			delete inputProps.inputStyle;
			delete inputProps.minWidth;
			delete inputProps.onAutosize;
			delete inputProps.placeholderIsMinWidth;
			delete inputProps.inputRef;
			return React.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				React.createElement('style', { dangerouslySetInnerHTML: {
						__html: ['input#' + this.state.id + '::-ms-clear {display: none;}'].join('\n')
					} }),
				React.createElement('input', _extends({ id: this.state.id }, inputProps, { ref: this.inputRef })),
				React.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? React.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	});
	
	module.exports = AutosizeInput;

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var newlineRegex = /(\r\n|\n\r|\r|\n)/g;
	
	module.exports = function(str) {
	  if (typeof str === 'number') {
	    return str;
	  } else if (typeof str !== 'string') {
	    return '';
	  }
	
	  return str.split(newlineRegex).map(function(line, index) {
	    if (line.match(newlineRegex)) {
	      return React.createElement('br', { key: index });
	    } else {
	      return line;
	    }
	  });
	};


/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(482);
	
	var _consolidatedEvents = __webpack_require__(555);
	
	var _object = __webpack_require__(685);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _document = __webpack_require__(595);
	
	var _document2 = _interopRequireDefault(_document);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DISPLAY = {
	  BLOCK: 'block',
	  FLEX: 'flex',
	  INLINE: 'inline',
	  INLINE_BLOCK: 'inline-block',
	  CONTENTS: 'contents'
	};
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
	  children: _propTypes2['default'].node.isRequired,
	  onOutsideClick: _propTypes2['default'].func.isRequired,
	  disabled: _propTypes2['default'].bool,
	  useCapture: _propTypes2['default'].bool,
	  display: _propTypes2['default'].oneOf((0, _object2['default'])(DISPLAY))
	});
	
	var defaultProps = {
	  disabled: false,
	
	  // `useCapture` is set to true by default so that a `stopPropagation` in the
	  // children will not prevent all outside click handlers from firing - maja
	  useCapture: true,
	  display: DISPLAY.BLOCK
	};
	
	var OutsideClickHandler = function (_React$Component) {
	  _inherits(OutsideClickHandler, _React$Component);
	
	  function OutsideClickHandler() {
	    var _ref;
	
	    _classCallCheck(this, OutsideClickHandler);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, (_ref = OutsideClickHandler.__proto__ || Object.getPrototypeOf(OutsideClickHandler)).call.apply(_ref, [this].concat(args)));
	
	    _this.onMouseDown = _this.onMouseDown.bind(_this);
	    _this.onMouseUp = _this.onMouseUp.bind(_this);
	    _this.setChildNodeRef = _this.setChildNodeRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(OutsideClickHandler, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        var _props = this.props,
	            disabled = _props.disabled,
	            useCapture = _props.useCapture;
	
	
	        if (!disabled) this.addMouseDownEventListener(useCapture);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(_ref2) {
	        var prevDisabled = _ref2.disabled;
	        var _props2 = this.props,
	            disabled = _props2.disabled,
	            useCapture = _props2.useCapture;
	
	        if (prevDisabled !== disabled) {
	          if (disabled) {
	            this.removeEventListeners();
	          } else {
	            this.addMouseDownEventListener(useCapture);
	          }
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        this.removeEventListeners();
	      }
	
	      return componentWillUnmount;
	    }()
	
	    // Use mousedown/mouseup to enforce that clicks remain outside the root's
	    // descendant tree, even when dragged. This should also get triggered on
	    // touch devices.
	
	  }, {
	    key: 'onMouseDown',
	    value: function () {
	      function onMouseDown(e) {
	        var useCapture = this.props.useCapture;
	
	
	        var isDescendantOfRoot = this.childNode && (0, _document2['default'])(this.childNode, e.target);
	        if (!isDescendantOfRoot) {
	          if (this.removeMouseUp) {
	            this.removeMouseUp();
	            this.removeMouseUp = null;
	          }
	          this.removeMouseUp = (0, _consolidatedEvents.addEventListener)(document, 'mouseup', this.onMouseUp, { capture: useCapture });
	        }
	      }
	
	      return onMouseDown;
	    }()
	
	    // Use mousedown/mouseup to enforce that clicks remain outside the root's
	    // descendant tree, even when dragged. This should also get triggered on
	    // touch devices.
	
	  }, {
	    key: 'onMouseUp',
	    value: function () {
	      function onMouseUp(e) {
	        var onOutsideClick = this.props.onOutsideClick;
	
	
	        var isDescendantOfRoot = this.childNode && (0, _document2['default'])(this.childNode, e.target);
	        if (this.removeMouseUp) {
	          this.removeMouseUp();
	          this.removeMouseUp = null;
	        }
	
	        if (!isDescendantOfRoot) {
	          onOutsideClick(e);
	        }
	      }
	
	      return onMouseUp;
	    }()
	  }, {
	    key: 'setChildNodeRef',
	    value: function () {
	      function setChildNodeRef(ref) {
	        this.childNode = ref;
	      }
	
	      return setChildNodeRef;
	    }()
	  }, {
	    key: 'addMouseDownEventListener',
	    value: function () {
	      function addMouseDownEventListener(useCapture) {
	        this.removeMouseDown = (0, _consolidatedEvents.addEventListener)(document, 'mousedown', this.onMouseDown, { capture: useCapture });
	      }
	
	      return addMouseDownEventListener;
	    }()
	  }, {
	    key: 'removeEventListeners',
	    value: function () {
	      function removeEventListeners() {
	        if (this.removeMouseDown) this.removeMouseDown();
	        if (this.removeMouseUp) this.removeMouseUp();
	      }
	
	      return removeEventListeners;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props3 = this.props,
	            children = _props3.children,
	            display = _props3.display;
	
	
	        return _react2['default'].createElement(
	          'div',
	          {
	            ref: this.setChildNodeRef,
	            style: display !== DISPLAY.BLOCK && (0, _object2['default'])(DISPLAY).includes(display) ? { display: display } : undefined
	          },
	          children
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return OutsideClickHandler;
	}(_react2['default'].Component);
	
	exports['default'] = OutsideClickHandler;
	
	
	OutsideClickHandler.propTypes = propTypes;
	OutsideClickHandler.defaultProps = defaultProps;

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	// eslint-disable-next-line import/no-unresolved
	module.exports = __webpack_require__(840);


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(23), __webpack_require__(726), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports, require('react'), require('react-dom'), require('react-async-script-loader'), require('prop-types'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports, global.react, global.reactDom, global.reactAsyncScriptLoader, global.propTypes);
	        global.index = mod.exports;
	    }
	})(this, function (exports, _react, _reactDom, _reactAsyncScriptLoader, _propTypes) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    var _react2 = _interopRequireDefault(_react);
	
	    var _reactDom2 = _interopRequireDefault(_reactDom);
	
	    var _reactAsyncScriptLoader2 = _interopRequireDefault(_reactAsyncScriptLoader);
	
	    var _propTypes2 = _interopRequireDefault(_propTypes);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    function _possibleConstructorReturn(self, call) {
	        if (!self) {
	            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	        }
	
	        return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    }
	
	    function _inherits(subClass, superClass) {
	        if (typeof superClass !== "function" && superClass !== null) {
	            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	        }
	
	        subClass.prototype = Object.create(superClass && superClass.prototype, {
	            constructor: {
	                value: subClass,
	                enumerable: false,
	                writable: true,
	                configurable: true
	            }
	        });
	        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    }
	
	    var PaypalButton = function (_React$Component) {
	        _inherits(PaypalButton, _React$Component);
	
	        function PaypalButton(props) {
	            _classCallCheck(this, PaypalButton);
	
	            var _this = _possibleConstructorReturn(this, (PaypalButton.__proto__ || Object.getPrototypeOf(PaypalButton)).call(this, props));
	
	            window.React = _react2.default;
	            window.ReactDOM = _reactDom2.default;
	            _this.state = {
	                showButton: false
	            };
	            return _this;
	        }
	
	        _createClass(PaypalButton, [{
	            key: 'componentWillReceiveProps',
	            value: function componentWillReceiveProps(_ref) {
	                var isScriptLoaded = _ref.isScriptLoaded,
	                    isScriptLoadSucceed = _ref.isScriptLoadSucceed;
	
	                if (!this.state.show) {
	                    if (isScriptLoaded && !this.props.isScriptLoaded) {
	                        if (isScriptLoadSucceed) {
	                            this.setState({ showButton: true });
	                        } else {
	                            console.log('Cannot load Paypal script!');
	                            this.props.onError();
	                        }
	                    }
	                }
	            }
	        }, {
	            key: 'componentDidMount',
	            value: function componentDidMount() {
	                var _props = this.props,
	                    isScriptLoaded = _props.isScriptLoaded,
	                    isScriptLoadSucceed = _props.isScriptLoadSucceed;
	
	                if (isScriptLoaded && isScriptLoadSucceed) {
	                    this.setState({ showButton: true });
	                }
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var _this2 = this;
	
	                var payment = function payment() {
	                    return paypal.rest.payment.create(_this2.props.env, _this2.props.client, Object.assign({
	                        transactions: [{ amount: { total: _this2.props.total, currency: _this2.props.currency } }]
	                    }, _this2.props.paymentOptions), {
	                        input_fields: {
	                            // any values other than null, and the address is not returned after payment execution.
	                            no_shipping: _this2.props.shipping
	                        }
	                    });
	                };
	
	                var onAuthorize = function onAuthorize(data, actions) {
	                    return actions.payment.execute().then(function (payment_data) {
	                        // console.log(`payment_data: ${JSON.stringify(payment_data, null, 1)}`)
	                        var payment = Object.assign({}, _this2.props.payment);
	                        payment.paid = true;
	                        payment.cancelled = false;
	                        payment.payerID = data.payerID;
	                        payment.paymentID = data.paymentID;
	                        payment.paymentToken = data.paymentToken;
	                        payment.returnUrl = data.returnUrl;
	                        // getting buyer's shipping address and email
	                        payment.address = payment_data.payer.payer_info.shipping_address;
	                        payment.email = payment_data.payer.payer_info.email;
	                        _this2.props.onSuccess(payment);
	                    });
	                };
	
	                var ppbtn = '';
	                if (this.state.showButton) {
	                    ppbtn = _react2.default.createElement(paypal.Button.react, {
	                        env: this.props.env,
	                        client: this.props.client,
	                        style: this.props.style,
	                        payment: payment,
	                        commit: true,
	                        onAuthorize: onAuthorize,
	                        onCancel: this.props.onCancel
	
	                        // "Error: Unrecognized prop: shipping" was caused by the next line
	                        // shipping={this.props.shipping}
	                    });
	                }
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    ppbtn
	                );
	            }
	        }]);
	
	        return PaypalButton;
	    }(_react2.default.Component);
	
	    PaypalButton.propTypes = {
	        currency: _propTypes2.default.string.isRequired,
	        total: _propTypes2.default.number.isRequired,
	        client: _propTypes2.default.object.isRequired,
	        style: _propTypes2.default.object
	    };
	
	    PaypalButton.defaultProps = {
	        paymentOptions: {},
	        env: 'sandbox',
	        // null means buyer address is returned in the payment execution response
	        shipping: null,
	        onSuccess: function onSuccess(payment) {
	            console.log('The payment was succeeded!', payment);
	        },
	        onCancel: function onCancel(data) {
	            console.log('The payment was cancelled!', data);
	        },
	        onError: function onError(err) {
	            console.log('Error loading Paypal script!', err);
	        }
	    };
	
	    exports.default = (0, _reactAsyncScriptLoader2.default)('https://www.paypalobjects.com/api/checkout.js')(PaypalButton);
	});

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(842);

/***/ },
/* 844 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * From https://gist.github.com/nolanlawson/10340255
	 */
	module.exports = function createBlob(parts, properties) {
	  parts = parts || [];
	  properties = properties || {};
	  try {
	    return new Blob(parts, properties);
	  } catch (e) {
	    if (e.name !== "TypeError") {
	      throw e;
	    }
	    var BlobBuilder = window.BlobBuilder || window.MSBlobBuilder || window.MozBlobBuilder || window.WebKitBlobBuilder;
	    var builder = new BlobBuilder();
	    for (var i = 0; i < parts.length; i += 1) {
	      builder.append(parts[i]);
	    }
	    return builder.getBlob(properties.type);
	  }
	};

/***/ },
/* 845 */
/***/ function(module, exports) {

	'use strict';
	
	function NoVideoInputDevicesError() {
	  this.name = 'NoVideoInputDevicesError';
	  this.message = 'No video input devices found';
	}
	NoVideoInputDevicesError.prototype = new Error();
	
	module.exports = {
	  NoVideoInputDevicesError: NoVideoInputDevicesError
	};

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(845),
	    NoVideoInputDevicesError = _require.NoVideoInputDevicesError;
	
	function defaultDeviceIdChooser(filteredDevices, videoDevices, facingMode) {
	  if (filteredDevices.length > 0) {
	    return filteredDevices[0].deviceId;
	  }
	  if (videoDevices.length == 1 || facingMode == 'user') {
	    return videoDevices[0].deviceId;
	  }
	  return videoDevices[1].deviceId;
	}
	
	var getFacingModePattern = function getFacingModePattern(facingMode) {
	  return facingMode == 'environment' ? /rear|back|environment/ig : /front|user|face/ig;
	};
	
	function getDeviceId(facingMode) {
	  var chooseDeviceId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultDeviceIdChooser;
	
	  // Get manual deviceId from available devices.
	  return new Promise(function (resolve, reject) {
	    var enumerateDevices = void 0;
	    try {
	      enumerateDevices = navigator.mediaDevices.enumerateDevices();
	    } catch (err) {
	      reject(new NoVideoInputDevicesError());
	    }
	    enumerateDevices.then(function (devices) {
	      // Filter out non-videoinputs
	      var videoDevices = devices.filter(function (device) {
	        return device.kind == 'videoinput';
	      });
	
	      if (videoDevices.length < 1) {
	        reject(new NoVideoInputDevicesError());
	        return;
	      }
	
	      var pattern = getFacingModePattern(facingMode);
	
	      // Filter out video devices without the pattern
	      var filteredDevices = videoDevices.filter(function (_ref) {
	        var label = _ref.label;
	        return pattern.test(label);
	      });
	
	      resolve(chooseDeviceId(filteredDevices, videoDevices, facingMode));
	    });
	  });
	}
	
	module.exports = { getDeviceId: getDeviceId, getFacingModePattern: getFacingModePattern };

/***/ },
/* 847 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function havePropsChanged(prevProps, nextProps, keys) {
	  var changedProps = [];
	  keys.forEach(function (key) {
	    if (prevProps[key] != nextProps[key]) {
	      changedProps.push(key);
	    }
	  });
	  return changedProps;
	};

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(440);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(82);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(442);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    string = _React$PropTypes.string,
	    object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(82);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(46);
	
	var _InternalPropTypes = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(46);
	
	var _InternalPropTypes = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    string = _React$PropTypes.string,
	    func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager2 = __webpack_require__(446);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(100);
	
	var _RouterContext = __webpack_require__(183);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(46);
	
	var _RouterUtils = __webpack_require__(443);
	
	var _routerWarning = __webpack_require__(82);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    func = _React$PropTypes.func,
	    object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(180);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	var enterHooks = new PendingHooks();
	var changeHooks = new PendingHooks();
	
	function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	  var isSync = hook.length < asyncArity;
	
	  var transitionHook = function transitionHook() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (isSync) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	
	  pendingHooks.add(transitionHook);
	
	  return transitionHook;
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location) {
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  enterHooks.clear();
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    var wrappedNext = function wrappedNext() {
	      if (enterHooks.has(hooks[index])) {
	        next.apply(undefined, arguments);
	        enterHooks.remove(hooks[index]);
	      }
	    };
	    hooks[index](nextState, replace, wrappedNext);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  changeHooks.clear();
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    var wrappedNext = function wrappedNext() {
	      if (changeHooks.has(hooks[index])) {
	        next.apply(undefined, arguments);
	        changeHooks.remove(hooks[index]);
	      }
	    };
	    hooks[index](state, nextState, replace, wrappedNext);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(183);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(82);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(636);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(445);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(81);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(180);
	
	var _PromiseUtils = __webpack_require__(441);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(81);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(637);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(445);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(81);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(110);
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(444);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(446);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(46);
	
	var _RouterUtils = __webpack_require__(443);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(180);
	
	var _PromiseUtils = __webpack_require__(441);
	
	var _PatternUtils = __webpack_require__(81);
	
	var _routerWarning = __webpack_require__(82);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(24);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(151);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(181);
	
	var _PropTypes = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(867).enable();
	  window.Promise = __webpack_require__(866);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(868);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(865);


/***/ },
/* 865 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(448);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(448);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 868 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(83);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _utilsStripDiacritics = __webpack_require__(451);
	
	var _utilsStripDiacritics2 = _interopRequireDefault(_utilsStripDiacritics);
	
	var propTypes = {
		autoload: _react2['default'].PropTypes.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _react2['default'].PropTypes.any, // object to use to cache results; set to null/false to disable caching
		children: _react2['default'].PropTypes.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _react2['default'].PropTypes.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _react2['default'].PropTypes.bool, // perform case-insensitive filtering; defaults to true
		loadingPlaceholder: _react2['default'].PropTypes.oneOfType([// replaces the placeholder while options are loading
		_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
		loadOptions: _react2['default'].PropTypes.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		options: _react.PropTypes.array.isRequired, // array of options
		placeholder: _react2['default'].PropTypes.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
		noResultsText: _react2['default'].PropTypes.oneOfType([// field noResultsText, displayed when no options come back from the server
		_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
		onChange: _react2['default'].PropTypes.func, // onChange handler: function (newValue) {}
		searchPromptText: _react2['default'].PropTypes.oneOfType([// label to prompt for search input
		_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
		onInputChange: _react2['default'].PropTypes.func, // optional for keeping track of what is being typed
		value: _react2['default'].PropTypes.any };
	
	// initial field value
	var defaultCache = {};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = (function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			_get(Object.getPrototypeOf(Async.prototype), 'constructor', this).call(this, props, context);
	
			this._cache = props.cache === defaultCache ? {} : props.cache;
	
			this.state = {
				isLoading: false,
				options: props.options
			};
	
			this._onInputChange = this._onInputChange.bind(this);
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nextProps, nextState) {
				var _this = this;
	
				var propertiesToSync = ['options'];
				propertiesToSync.forEach(function (prop) {
					if (_this.props[prop] !== nextProps[prop]) {
						_this.setState(_defineProperty({}, prop, nextProps[prop]));
					}
				});
			}
		}, {
			key: 'clearOptions',
			value: function clearOptions() {
				this.setState({ options: [] });
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && cache.hasOwnProperty(inputValue)) {
					this.setState({
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						var options = data && data.options || [];
	
						if (cache) {
							cache[inputValue] = options;
						}
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
	
				return inputValue;
			}
		}, {
			key: '_onInputChange',
			value: function _onInputChange(inputValue) {
				var _props = this.props;
				var ignoreAccents = _props.ignoreAccents;
				var ignoreCase = _props.ignoreCase;
				var onInputChange = _props.onInputChange;
	
				if (ignoreAccents) {
					inputValue = (0, _utilsStripDiacritics2['default'])(inputValue);
				}
	
				if (ignoreCase) {
					inputValue = inputValue.toLowerCase();
				}
	
				if (onInputChange) {
					onInputChange(inputValue);
				}
	
				return this.loadOptions(inputValue);
			}
		}, {
			key: 'inputValue',
			value: function inputValue() {
				if (this.select) {
					return this.select.state.inputValue;
				}
				return '';
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props;
				var loadingPlaceholder = _props2.loadingPlaceholder;
				var noResultsText = _props2.noResultsText;
				var searchPromptText = _props2.searchPromptText;
				var isLoading = this.state.isLoading;
	
				var inputValue = this.inputValue();
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props;
				var children = _props3.children;
				var loadingPlaceholder = _props3.loadingPlaceholder;
				var placeholder = _props3.placeholder;
				var _state = this.state;
				var isLoading = _state.isLoading;
				var options = _state.options;
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					},
					onChange: function onChange(newValues) {
						if (_this3.props.multi && _this3.props.value && newValues.length > _this3.props.value.length) {
							_this3.clearOptions();
						}
						_this3.props.onChange(newValues);
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this._onInputChange
				}));
			}
		}]);
	
		return Async;
	})(_react.Component);
	
	exports['default'] = Async;
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;
	
	function defaultChildren(props) {
		return _react2['default'].createElement(_Select2['default'], props);
	};
	module.exports = exports['default'];

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(83);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function reduce(obj) {
		var props = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
		return Object.keys(obj).reduce(function (props, key) {
			var value = obj[key];
			if (value !== undefined) props[key] = value;
			return props;
		}, props);
	}
	
	var AsyncCreatable = _react2['default'].createClass({
		displayName: 'AsyncCreatableSelect',
	
		render: function render() {
			var _this = this;
	
			return _react2['default'].createElement(
				_Select2['default'].Async,
				this.props,
				function (asyncProps) {
					return _react2['default'].createElement(
						_Select2['default'].Creatable,
						_this.props,
						function (creatableProps) {
							return _react2['default'].createElement(_Select2['default'], _extends({}, reduce(asyncProps, reduce(creatableProps, {})), {
								onInputChange: function (input) {
									creatableProps.onInputChange(input);
									return asyncProps.onInputChange(input);
								},
								ref: function (ref) {
									creatableProps.ref(ref);
									asyncProps.ref(ref);
								}
							}));
						}
					);
				}
			);
		}
	});
	
	module.exports = AsyncCreatable;

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(83);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _utilsDefaultFilterOptions = __webpack_require__(449);
	
	var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);
	
	var _utilsDefaultMenuRenderer = __webpack_require__(450);
	
	var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);
	
	var Creatable = _react2['default'].createClass({
		displayName: 'CreatableSelect',
	
		propTypes: {
			// Child function responsible for creating the inner Select component
			// This component can be used to compose HOCs (eg Creatable and Async)
			// (props: Object): PropTypes.element
			children: _react2['default'].PropTypes.func,
	
			// See Select.propTypes.filterOptions
			filterOptions: _react2['default'].PropTypes.any,
	
			// Searches for any matching option within the set of options.
			// This function prevents duplicate options from being created.
			// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
			isOptionUnique: _react2['default'].PropTypes.func,
	
			// Determines if the current input text represents a valid option.
			// ({ label: string }): boolean
			isValidNewOption: _react2['default'].PropTypes.func,
	
			// See Select.propTypes.menuRenderer
			menuRenderer: _react2['default'].PropTypes.any,
	
			// Factory to create new option.
			// ({ label: string, labelKey: string, valueKey: string }): Object
			newOptionCreator: _react2['default'].PropTypes.func,
	
			// input change handler: function (inputValue) {}
			onInputChange: _react2['default'].PropTypes.func,
	
			// input keyDown handler: function (event) {}
			onInputKeyDown: _react2['default'].PropTypes.func,
	
			// new option click handler: function (option) {}
			onNewOptionClick: _react2['default'].PropTypes.func,
	
			// See Select.propTypes.options
			options: _react2['default'].PropTypes.array,
	
			// Creates prompt/placeholder option text.
			// (filterText: string): string
			promptTextCreator: _react2['default'].PropTypes.func,
	
			// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
			shouldKeyDownEventCreateNewOption: _react2['default'].PropTypes.func
		},
	
		// Default prop methods
		statics: {
			isOptionUnique: isOptionUnique,
			isValidNewOption: isValidNewOption,
			newOptionCreator: newOptionCreator,
			promptTextCreator: promptTextCreator,
			shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
		},
	
		getDefaultProps: function getDefaultProps() {
			return {
				filterOptions: _utilsDefaultFilterOptions2['default'],
				isOptionUnique: isOptionUnique,
				isValidNewOption: isValidNewOption,
				menuRenderer: _utilsDefaultMenuRenderer2['default'],
				newOptionCreator: newOptionCreator,
				promptTextCreator: promptTextCreator,
				shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
			};
		},
	
		createNewOption: function createNewOption() {
			var _props = this.props;
			var isValidNewOption = _props.isValidNewOption;
			var newOptionCreator = _props.newOptionCreator;
			var onNewOptionClick = _props.onNewOptionClick;
			var _props$options = _props.options;
			var options = _props$options === undefined ? [] : _props$options;
			var shouldKeyDownEventCreateNewOption = _props.shouldKeyDownEventCreateNewOption;
	
			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option });
	
				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);
	
						this.select.selectValue(option);
					}
				}
			}
		},
	
		filterOptions: function filterOptions() {
			var _props2 = this.props;
			var filterOptions = _props2.filterOptions;
			var isValidNewOption = _props2.isValidNewOption;
			var options = _props2.options;
			var promptTextCreator = _props2.promptTextCreator;
	
			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
			var excludeOptions = arguments[2] || [];
	
			var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;
	
				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});
	
				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});
	
				if (_isOptionUnique2) {
					var _prompt = promptTextCreator(this.inputValue);
	
					this._createPlaceholderOption = _newOptionCreator({
						label: _prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					filteredOptions.unshift(this._createPlaceholderOption);
				}
			}
	
			return filteredOptions;
		},
	
		isOptionUnique: function isOptionUnique(_ref2) {
			var option = _ref2.option;
			var options = _ref2.options;
			var isOptionUnique = this.props.isOptionUnique;
	
			options = options || this.select.filterOptions();
	
			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		},
	
		menuRenderer: function menuRenderer(params) {
			var menuRenderer = this.props.menuRenderer;
	
			return menuRenderer(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		},
	
		onInputChange: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;
	
			if (onInputChange) {
				onInputChange(input);
			}
	
			// This value may be needed in between Select mounts (when this.select is null)
			this.inputValue = input;
		},
	
		onInputKeyDown: function onInputKeyDown(event) {
			var _props3 = this.props;
			var shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption;
			var onInputKeyDown = _props3.onInputKeyDown;
	
			var focusedOption = this.select.getFocusedOption();
	
			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
				this.createNewOption();
	
				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		},
	
		onOptionSelect: function onOptionSelect(option, event) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		},
	
		render: function render() {
			var _this = this;
	
			var _props4 = this.props;
			var newOptionCreator = _props4.newOptionCreator;
			var shouldKeyDownEventCreateNewOption = _props4.shouldKeyDownEventCreateNewOption;
	
			var restProps = _objectWithoutProperties(_props4, ['newOptionCreator', 'shouldKeyDownEventCreateNewOption']);
	
			var children = this.props.children;
	
			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.
			if (!children) {
				children = defaultChildren;
			}
	
			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref) {
					_this.select = _ref;
	
					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref) {
						_this.labelKey = _ref.props.labelKey;
						_this.valueKey = _ref.props.valueKey;
					}
				}
			});
	
			return children(props);
		}
	});
	
	function defaultChildren(props) {
		return _react2['default'].createElement(_Select2['default'], props);
	};
	
	function isOptionUnique(_ref3) {
		var option = _ref3.option;
		var options = _ref3.options;
		var labelKey = _ref3.labelKey;
		var valueKey = _ref3.valueKey;
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	function isValidNewOption(_ref4) {
		var label = _ref4.label;
	
		return !!label;
	};
	
	function newOptionCreator(_ref5) {
		var label = _ref5.label;
		var labelKey = _ref5.labelKey;
		var valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
		return option;
	};
	
	function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	}
	
	function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
		}
	
		return false;
	};
	
	module.exports = Creatable;

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Option = _react2['default'].createClass({
		displayName: 'Option',
	
		propTypes: {
			children: _react2['default'].PropTypes.node,
			className: _react2['default'].PropTypes.string, // className (based on mouse position)
			instancePrefix: _react2['default'].PropTypes.string.isRequired, // unique prefix for the ids (used for aria)
			isDisabled: _react2['default'].PropTypes.bool, // the option is disabled
			isFocused: _react2['default'].PropTypes.bool, // the option is focused
			isSelected: _react2['default'].PropTypes.bool, // the option is selected
			onFocus: _react2['default'].PropTypes.func, // method to handle mouseEnter on option element
			onSelect: _react2['default'].PropTypes.func, // method to handle click on option element
			onUnfocus: _react2['default'].PropTypes.func, // method to handle mouseLeave on option element
			option: _react2['default'].PropTypes.object.isRequired, // object that is base for that option
			optionIndex: _react2['default'].PropTypes.number },
		// index of the option, used to generate unique ids for aria
		blockEvent: function blockEvent(event) {
			event.preventDefault();
			event.stopPropagation();
			if (event.target.tagName !== 'A' || !('href' in event.target)) {
				return;
			}
			if (event.target.target) {
				window.open(event.target.href, event.target.target);
			} else {
				window.location.href = event.target.href;
			}
		},
	
		handleMouseDown: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		},
	
		handleMouseEnter: function handleMouseEnter(event) {
			this.onFocus(event);
		},
	
		handleMouseMove: function handleMouseMove(event) {
			this.onFocus(event);
		},
	
		handleTouchEnd: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			this.handleMouseDown(event);
		},
	
		handleTouchMove: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		},
	
		handleTouchStart: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		},
	
		onFocus: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		},
		render: function render() {
			var _props = this.props;
			var option = _props.option;
			var instancePrefix = _props.instancePrefix;
			var optionIndex = _props.optionIndex;
	
			var className = (0, _classnames2['default'])(this.props.className, option.className);
	
			return option.disabled ? _react2['default'].createElement(
				'div',
				{ className: className,
					onMouseDown: this.blockEvent,
					onClick: this.blockEvent },
				this.props.children
			) : _react2['default'].createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	});
	
	module.exports = Option;

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Value = _react2['default'].createClass({
	
		displayName: 'Value',
	
		propTypes: {
			children: _react2['default'].PropTypes.node,
			disabled: _react2['default'].PropTypes.bool, // disabled prop passed to ReactSelect
			id: _react2['default'].PropTypes.string, // Unique id for the value - used for aria
			onClick: _react2['default'].PropTypes.func, // method to handle click on value label
			onRemove: _react2['default'].PropTypes.func, // method to handle removal of the value
			value: _react2['default'].PropTypes.object.isRequired },
	
		// the option object for this value
		handleMouseDown: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		},
	
		onRemove: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		},
	
		handleTouchEndRemove: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			// Fire the mouse events
			this.onRemove(event);
		},
	
		handleTouchMove: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		},
	
		handleTouchStart: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		},
	
		renderRemoveIcon: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'×'
			);
		},
	
		renderLabel: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? _react2['default'].createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : _react2['default'].createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		},
	
		render: function render() {
			return _react2['default'].createElement(
				'div',
				{ className: (0, _classnames2['default'])('Select-value', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	
	});
	
	module.exports = Value;

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports["default"] = arrowRenderer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2["default"].createElement("span", {
			className: "Select-arrow",
			onMouseDown: onMouseDown
		});
	}
	
	;
	module.exports = exports["default"];

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	exports['default'] = clearRenderer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function clearRenderer() {
		return _react2['default'].createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	}
	
	;
	module.exports = exports['default'];

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(185);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.generateIcon = generateIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _icons = __webpack_require__(877);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function generateIcon(network) {
	  if (!_icons2.default[network.toLowerCase()]) {
	    throw new Error('invalid network name for a social icon');
	  }
	
	  var iconConfig = _icons2.default[network.toLowerCase()];
	
	  return _react2.default.createClass({
	    propTypes: {
	      className: _react2.default.PropTypes.string,
	      iconBgStyle: _react2.default.PropTypes.object,
	      logoFillColor: _react2.default.PropTypes.string,
	      round: _react2.default.PropTypes.bool,
	      size: _react2.default.PropTypes.number
	    },
	
	    getDefaultProps: function getDefaultProps() {
	      return {
	        logoFillColor: 'white',
	        size: 64
	      };
	    },
	    render: function render() {
	      var _props = this.props,
	          className = _props.className,
	          iconBgStyle = _props.iconBgStyle,
	          logoFillColor = _props.logoFillColor,
	          round = _props.round,
	          size = _props.size;
	
	
	      var baseStyle = {
	        width: size,
	        height: size
	      };
	
	      var classes = 'social-icon social-icon--' + network + ' ' + (className || '');
	
	      var finalIconBgStyle = (0, _extends3.default)({}, iconBgStyle);
	
	      return _react2.default.createElement(
	        'div',
	        { style: baseStyle },
	        _react2.default.createElement(
	          'svg',
	          {
	            viewBox: '0 0 64 64',
	            fill: logoFillColor,
	            width: size,
	            height: size,
	            className: classes },
	          _react2.default.createElement(
	            'g',
	            null,
	            !round ? _react2.default.createElement('rect', {
	              width: '64',
	              height: '64',
	              fill: iconConfig.color,
	              style: finalIconBgStyle }) : _react2.default.createElement('circle', {
	              cx: '32',
	              cy: '32',
	              r: '31',
	              fill: iconConfig.color,
	              style: finalIconBgStyle })
	          ),
	          _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: iconConfig.icon })
	          )
	        )
	      );
	    }
	  });
	}

/***/ },
/* 877 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable max-len */
	exports.default = {
	  facebook: {
	    icon: 'M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z',
	    mask: 'M0,0v64h64V0H0z M39.6,22l-2.8,0c-2.2,0-2.6,1.1-2.6,2.6V28h5.3l-0.7,5.3h-4.6V47h-5.5V33.3H24V28h4.6V24 c0-4.6,2.8-7,6.9-7c2,0,3.6,0.1,4.1,0.2V22z',
	    color: '#3b5998'
	  },
	  google: {
	    icon: 'M25.3,30.1v3.8h6.3c-0.3,1.6-1.9,4.8-6.3,4.8c-3.8,0-6.9-3.1-6.9-7s3.1-7,6.9-7c2.2,0,3.6,0.9,4.4,1.7l3-2.9c-1.9-1.8-4.4-2.9-7.4-2.9c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1c6.4,0,10.7-4.5,10.7-10.9c0-0.7-0.1-1.3-0.2-1.8H25.3L25.3,30.1z M49.8,28.9h-3.2v-3.2h-3.2v3.2h-3.2v3.2h3.2v3.2h3.2v-3.2h3.2',
	    mask: 'M0,0v64h64V0H0z M31.3,19.1c0.3,0.3,0.6,0.7,0.9,1.2c0.3,0.4,0.5,0.9,0.7,1.5c0.2,0.6,0.3,1.3,0.3,2.1 c0,1.4-0.3,2.6-0.9,3.4c-0.3,0.4-0.6,0.8-0.9,1.2c-0.4,0.4-0.8,0.7-1.2,1.1c-0.2,0.2-0.5,0.5-0.7,0.8c-0.2,0.3-0.4,0.7-0.4,1.1 c0,0.4,0.1,0.8,0.4,1c0.2,0.3,0.4,0.5,0.6,0.7l1.4,1.1c0.8,0.7,1.6,1.5,2.2,2.3c0.6,0.8,0.9,2,0.9,3.3c0,1.9-0.9,3.7-2.6,5.2 c-1.8,1.6-4.3,2.4-7.7,2.4c-2.8,0-4.9-0.6-6.3-1.8c-1.4-1.1-2.1-2.4-2.1-3.9c0-0.7,0.2-1.6,0.7-2.5c0.4-0.9,1.2-1.7,2.4-2.4 c1.3-0.7,2.7-1.2,4.1-1.5c1.4-0.2,2.6-0.3,3.5-0.4c-0.3-0.4-0.5-0.8-0.8-1.2c-0.3-0.4-0.4-0.9-0.4-1.5c0-0.4,0-0.6,0.2-0.9 c0.1-0.2,0.2-0.5,0.2-0.7c-0.5,0.1-0.9,0.1-1.3,0.1c-2.1,0-3.8-0.7-4.9-2c-1.2-1.2-1.8-2.7-1.8-4.3c0-2,0.8-3.8,2.5-5.4 c1.1-0.9,2.3-1.6,3.5-1.8c1.2-0.2,2.3-0.4,3.4-0.4h8L33,18.4h-2.5C30.7,18.6,31,18.8,31.3,19.1z M48,32h-4.3v4.2h-2.5V32H37v-2.5 h4.2v-4.3h2.5v4.3H48V32z M27.1,19.1c-0.6-0.5-1.4-0.7-2.2-0.7c-1.1,0-2,0.5-2.7,1.3c-0.6,0.9-0.9,1.9-0.9,3c0,1.5,0.4,3,1.3,4.5 c0.4,0.7,0.9,1.4,1.6,1.9c0.6,0.5,1.4,0.8,2.2,0.8c1.1,0,1.9-0.4,2.6-1.1c0.3-0.5,0.6-1,0.7-1.6c0.1-0.5,0.1-1,0.1-1.4 c0-1.6-0.4-3.2-1.2-4.8C28.2,20.2,27.7,19.5,27.1,19.1z M26.9,36.2c-0.2,0-0.7,0-1.6,0.1c-0.8,0.1-1.7,0.3-2.5,0.6 c-0.2,0.1-0.5,0.2-0.9,0.4c-0.4,0.2-0.7,0.4-1.1,0.7c-0.4,0.3-0.7,0.7-0.9,1.2c-0.3,0.5-0.4,1.1-0.4,1.8c0,1.4,0.6,2.6,1.9,3.5 c1.2,0.9,2.9,1.4,5,1.4c1.9,0,3.3-0.4,4.3-1.3c1-0.8,1.5-1.8,1.5-3.1c0-1-0.3-1.9-1-2.7c-0.7-0.7-1.8-1.6-3.3-2.6 C27.5,36.2,27.2,36.2,26.9,36.2z',
	    color: '#dd4b39'
	  },
	  linkedin: {
	    icon: 'M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z',
	    mask: 'M0,0v64h64V0H0z M25.8,44h-5.4V26.6h5.4V44z M23.1,24.3c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1 c1.7,0,3.1,1.4,3.1,3.1C26.2,22.9,24.8,24.3,23.1,24.3z M46,44h-5.4v-8.4c0-2,0-4.6-2.8-4.6c-2.8,0-3.2,2.2-3.2,4.5V44h-5.4V26.6 h5.2V29h0.1c0.7-1.4,2.5-2.8,5.1-2.8c5.5,0,6.5,3.6,6.5,8.3V44z',
	    color: '#007fb1'
	  },
	  twitter: {
	    icon: 'M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z',
	    mask: 'M0,0v64h64V0H0z M44.7,25.5c0,0.3,0,0.6,0,0.8C44.7,35,38.1,45,26.1,45c-3.7,0-7.2-1.1-10.1-2.9 c0.5,0.1,1,0.1,1.6,0.1c3.1,0,5.9-1,8.2-2.8c-2.9-0.1-5.3-2-6.1-4.6c0.4,0.1,0.8,0.1,1.2,0.1c0.6,0,1.2-0.1,1.7-0.2 c-3-0.6-5.3-3.3-5.3-6.4c0,0,0-0.1,0-0.1c0.9,0.5,1.9,0.8,3,0.8c-1.8-1.2-2.9-3.2-2.9-5.5c0-1.2,0.3-2.3,0.9-3.3 c3.2,4,8.1,6.6,13.5,6.9c-0.1-0.5-0.2-1-0.2-1.5c0-3.6,2.9-6.6,6.6-6.6c1.9,0,3.6,0.8,4.8,2.1c1.5-0.3,2.9-0.8,4.2-1.6 c-0.5,1.5-1.5,2.8-2.9,3.6c1.3-0.2,2.6-0.5,3.8-1C47.1,23.4,46,24.5,44.7,25.5z',
	    color: '#00aced'
	  },
	  pinterest: {
	    icon: 'M32,16c-8.8,0-16,7.2-16,16c0,6.6,3.9,12.2,9.6,14.7c0-1.1,0-2.5,0.3-3.7 c0.3-1.3,2.1-8.7,2.1-8.7s-0.5-1-0.5-2.5c0-2.4,1.4-4.1,3.1-4.1c1.5,0,2.2,1.1,2.2,2.4c0,1.5-0.9,3.7-1.4,5.7 c-0.4,1.7,0.9,3.1,2.5,3.1c3,0,5.1-3.9,5.1-8.5c0-3.5-2.4-6.1-6.7-6.1c-4.9,0-7.9,3.6-7.9,7.7c0,1.4,0.4,2.4,1.1,3.1 c0.3,0.3,0.3,0.5,0.2,0.9c-0.1,0.3-0.3,1-0.3,1.3c-0.1,0.4-0.4,0.6-0.8,0.4c-2.2-0.9-3.3-3.4-3.3-6.1c0-4.5,3.8-10,11.4-10 c6.1,0,10.1,4.4,10.1,9.2c0,6.3-3.5,11-8.6,11c-1.7,0-3.4-0.9-3.9-2c0,0-0.9,3.7-1.1,4.4c-0.3,1.2-1,2.5-1.6,3.4 c1.4,0.4,3,0.7,4.5,0.7c8.8,0,16-7.2,16-16C48,23.2,40.8,16,32,16z',
	    mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
	    color: '#cb2128'
	  },
	  vk: {
	    icon: 'M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
	    mask: 'M0,0v64h64V0H0z M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
	    color: '#45668e'
	  },
	  ok: {
	    icon: 'M39,30c-1,0-3,2-7,2s-6-2-7-2c-1.1,0-2,0.9-2,2c0,1,0.6,1.5,1,1.7c1.2,0.7,5,2.3,5,2.3l-4.3,5.4   c0,0-0.8,0.9-0.8,1.6c0,1.1,0.9,2,2,2c1,0,1.5-0.7,1.5-0.7S32,39,32,39c0,0,4.5,5.3,4.5,5.3S37,45,38,45c1.1,0,2-0.9,2-2   c0-0.6-0.8-1.6-0.8-1.6L35,36c0,0,3.8-1.6,5-2.3c0.4-0.3,1-0.7,1-1.7C41,30.9,40.1,30,39,30z M32,15c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7S35.9,15,32,15z M32,25.5   c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5C35.5,23.9,33.9,22.5,35,22.5z ',
	    mask: 'M45,1H5C2.8,1,1,2.8,1,5v40c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4V5C49,2.8,47.2,1,45,1z',
	    color: '#f2720c'
	  },
	  telegram: {
	    icon: 'm45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957',
	    mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
	    color: '#37aee2'
	  },
	  whatsapp: {
	    icon: 'm42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915',
	    mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
	    color: '#2cb742'
	  }
	};
	/* eslint-enable max-len */

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShareCounts = exports.ShareButtons = exports.generateShareIcon = undefined;
	
	var _generateIcon = __webpack_require__(876);
	
	var _shareButtons = __webpack_require__(879);
	
	var ShareButtons = _interopRequireWildcard(_shareButtons);
	
	var _shareCounts = __webpack_require__(881);
	
	var ShareCounts = _interopRequireWildcard(_shareCounts);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.generateShareIcon = _generateIcon.generateIcon;
	exports.ShareButtons = ShareButtons;
	exports.ShareCounts = ShareCounts;

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OKShareButton = exports.VKShareButton = exports.PinterestShareButton = exports.LinkedinShareButton = exports.GooglePlusShareButton = exports.WhatsappShareButton = exports.TelegramShareButton = exports.TwitterShareButton = exports.FacebookShareButton = undefined;
	
	var _extends2 = __webpack_require__(185);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(887);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(891);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(892);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(894);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(893);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _keys = __webpack_require__(452);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(454);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _socialMediaShareLinks = __webpack_require__(882);
	
	var links = _interopRequireWildcard(_socialMediaShareLinks);
	
	var _utils = __webpack_require__(184);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/no-multi-comp */
	var supportedNetworks = (0, _keys2.default)(links);
	
	var ShareButton = function (_Component) {
	  (0, _inherits3.default)(ShareButton, _Component);
	
	  function ShareButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ShareButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ShareButton.__proto__ || (0, _getPrototypeOf2.default)(ShareButton)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (e) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          windowWidth = _this$props.windowWidth,
	          windowHeight = _this$props.windowHeight,
	          beforeOnClick = _this$props.beforeOnClick;
	
	
	      if (!disabled) {
	        e.preventDefault();
	
	        var windowOptions = {
	          height: windowHeight,
	          width: windowWidth
	        };
	
	        var windowOpenBound = function windowOpenBound() {
	          return (0, _utils.windowOpen)(_this.link(), windowOptions);
	        };
	
	        if (beforeOnClick) {
	          beforeOnClick().then(function () {
	            return windowOpenBound();
	          });
	        } else {
	          windowOpenBound();
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ShareButton, [{
	    key: 'link',
	    value: function link() {
	      var _props = this.props,
	          url = _props.url,
	          opts = _props.opts,
	          network = _props.network;
	
	      return links[network](url, opts);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          className = _props2.className,
	          disabled = _props2.disabled,
	          disabledStyle = _props2.disabledStyle,
	          network = _props2.network,
	          style = _props2.style;
	
	
	      var classes = (0, _classnames2.default)('SocialMediaShareButton', 'SocialMediaShareButton--' + network, {
	        'SocialMediaShareButton--disabled': !!disabled,
	        disabled: !!disabled
	      }, className);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onClick: this.onClick,
	          className: classes,
	          style: (0, _extends3.default)({}, style, disabled ? disabledStyle : {}) },
	        children
	      );
	    }
	  }]);
	  return ShareButton;
	}(_react.Component);
	
	/* HOC to ease migration from v1 to v2.
	 * To-be-removed in v2.
	 */
	
	
	ShareButton.propTypes = {
	  children: _react.PropTypes.node,
	  className: _react.PropTypes.string,
	  disabled: _react.PropTypes.bool,
	  disabledStyle: _react.PropTypes.object,
	  network: _react.PropTypes.oneOf(supportedNetworks),
	  opts: _react.PropTypes.object,
	  url: _react.PropTypes.string.isRequired,
	  style: _react.PropTypes.object,
	  windowWidth: _react.PropTypes.number,
	  windowHeight: _react.PropTypes.number,
	  beforeOnClick: _react.PropTypes.func
	};
	ShareButton.defaultProps = {
	  disabledStyle: {
	    opacity: 0.6
	  }
	};
	exports.default = ShareButton;
	function createShareButton(network) {
	  var optsMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	    return {};
	  };
	  var propTypes = arguments[2];
	  var defaultProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var CreatedButton = _react2.default.createClass({
	    displayName: 'CreatedButton',
	
	    propTypes: propTypes,
	
	    render: function render() {
	      return _react2.default.createElement(ShareButton, (0, _extends3.default)({}, this.props, {
	        network: network,
	        opts: optsMap(this.props) }));
	    }
	  });
	
	  CreatedButton.defaultProps = defaultProps;
	
	  return CreatedButton;
	}
	
	var FacebookShareButton = exports.FacebookShareButton = createShareButton('facebook', function (props) {
	  return {
	    description: props.description,
	    title: props.title,
	    picture: props.picture,
	    hashtag: props.hashtag
	  };
	}, {
	  description: _react.PropTypes.string,
	  title: _react.PropTypes.string,
	  picture: _react.PropTypes.string,
	  hashtag: _react.PropTypes.string
	}, {
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	var TwitterShareButton = exports.TwitterShareButton = createShareButton('twitter', function (props) {
	  return {
	    hashtags: props.hashtags,
	    title: props.title,
	    via: props.via
	  };
	}, {
	  hashtags: _react.PropTypes.arrayOf(_react.PropTypes.string),
	  title: _react.PropTypes.string,
	  via: _react.PropTypes.string
	}, {
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	var TelegramShareButton = exports.TelegramShareButton = createShareButton('telegram', function (props) {
	  return {
	    title: props.title,
	    via: props.via
	  };
	}, {
	  title: _react.PropTypes.string,
	  via: _react.PropTypes.string
	}, {
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	var WhatsappShareButton = exports.WhatsappShareButton = createShareButton('whatsapp', function (props) {
	  return {
	    title: props.title,
	    separator: props.separator
	  };
	}, {
	  title: _react.PropTypes.string,
	  separator: _react.PropTypes.string
	}, {
	  separator: ' ',
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	var GooglePlusShareButton = exports.GooglePlusShareButton = createShareButton('googlePlus', undefined, undefined, {
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	var LinkedinShareButton = exports.LinkedinShareButton = createShareButton('linkedin', function (props) {
	  return {
	    title: props.title,
	    description: props.description
	  };
	}, {
	  title: _react.PropTypes.string,
	  description: _react.PropTypes.string
	}, {
	  windowWidth: 750,
	  windowHeight: 600
	});
	
	var PinterestShareButton = exports.PinterestShareButton = createShareButton('pinterest', function (props) {
	  return {
	    media: props.media,
	    description: props.description
	  };
	}, {
	  media: _react.PropTypes.string.isRequired,
	  description: _react.PropTypes.string
	}, {
	  windowWidth: 1000,
	  windowHeight: 730
	});
	
	var VKShareButton = exports.VKShareButton = createShareButton('vk', function (props) {
	  return {
	    title: props.title,
	    description: props.description,
	    image: props.image
	  };
	}, {
	  title: _react.PropTypes.string,
	  description: _react.PropTypes.string,
	  image: _react.PropTypes.string
	}, {
	  windowWidth: 660,
	  windowHeight: 460
	});
	
	var OKShareButton = exports.OKShareButton = createShareButton('ok', function (props) {
	  return {
	    title: props.title,
	    description: props.description,
	    image: props.image
	  };
	}, {
	  title: _react.PropTypes.string,
	  description: _react.PropTypes.string,
	  image: _react.PropTypes.string
	}, {
	  windowWidth: 660,
	  windowHeight: 460
	});

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getVKShareCount = undefined;
	
	var _stringify = __webpack_require__(883);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.getFacebookShareCount = getFacebookShareCount;
	exports.getGooglePlusShareCount = getGooglePlusShareCount;
	exports.getLinkedinShareCount = getLinkedinShareCount;
	exports.getPinterestShareCount = getPinterestShareCount;
	exports.getOKShareCount = getOKShareCount;
	
	var _jsonp = __webpack_require__(674);
	
	var _jsonp2 = _interopRequireDefault(_jsonp);
	
	var _platform = __webpack_require__(389);
	
	var _platform2 = _interopRequireDefault(_platform);
	
	var _utils = __webpack_require__(184);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getFacebookShareCount(shareUrl, callback) {
	  var endpoint = 'https://graph.facebook.com/?id=' + shareUrl;
	
	  (0, _jsonp2.default)(endpoint, function (err, data) {
	    callback(!err && data && data.share && data.share.share_count ? data.share.share_count : undefined);
	  });
	}
	
	function getGooglePlusShareCount(shareUrl, callback) {
	  if (_platform2.default.name === 'IE' && parseInt(_platform2.default.version, 10) < 11) {
	    /* eslint-disable no-console */
	    console.error('Google plus share count is not supported in <=IE10!');
	    /* eslint-enable no-console */
	    return;
	  }
	
	  var xhr = new XMLHttpRequest();
	
	  xhr.open('POST', 'https://clients6.google.com/rpc');
	  xhr.setRequestHeader('Accept', 'application/json');
	  xhr.setRequestHeader('Content-type', 'application/json;charset=UTF-8');
	
	  xhr.send((0, _stringify2.default)({
	    method: 'pos.plusones.get',
	    id: 'p',
	    params: {
	      nolog: true,
	      id: shareUrl,
	      source: 'widget',
	      userId: '@viewer',
	      groupId: '@self'
	    },
	    jsonrpc: '2.0',
	    key: 'p',
	    apiVersion: 'v1'
	  }));
	
	  xhr.onload = function onSuccessdata() {
	    var data = JSON.parse(this.responseText);
	    callback(!!data ? data.result.metadata.globalCounts.count : undefined);
	  };
	
	  xhr.onerror = function onErrordata() {};
	}
	
	function getLinkedinShareCount(shareUrl, callback) {
	  var url = 'https://www.linkedin.com/countserv/count/share';
	
	  return (0, _jsonp2.default)(url + (0, _utils.objectToGetParams)({
	    url: shareUrl,
	    format: 'jsonp'
	  }), function (err, data) {
	    callback(!!data ? data.count : undefined);
	  });
	}
	
	function getPinterestShareCount(shareUrl, callback) {
	  var url = 'https://api.pinterest.com/v1/urls/count.json';
	
	  return (0, _jsonp2.default)(url + (0, _utils.objectToGetParams)({
	    url: shareUrl
	  }), function (err, data) {
	    callback(!!data ? data.count : undefined);
	  });
	}
	
	function getVKShareCount(shareUrl, callback) {
	  if (!window.VK) {
	    window.VK = {
	      Share: {
	        count: function count(index, _count2) {
	          return window.VK.callbacks[index](_count2);
	        }
	      },
	      callbacks: []
	    };
	  }
	
	  var url = 'https://vk.com/share.php';
	  var index = window.VK.callbacks.length;
	
	  window.VK.callbacks.push(callback);
	
	  return (0, _jsonp2.default)(url + (0, _utils.objectToGetParams)({
	    act: 'count',
	    index: index,
	    url: shareUrl
	  }));
	}
	
	exports.getVKShareCount = getVKShareCount;
	function getOKShareCount(shareUrl, callback) {
	  if (!window.OK) {
	    window.OK = {
	      Share: {
	        count: function count(index, _count) {
	          return window.OK.callbacks[index](_count);
	        }
	      },
	      callbacks: []
	    };
	  }
	
	  var url = 'https://connect.ok.ru/dk';
	  var index = window.OK.callbacks.length;
	
	  window.ODKL = {
	    updateCount: function updateCount(a, b) {
	      window.OK.callbacks[index](b);
	    }
	  };
	  window.OK.callbacks.push(callback);
	
	  return (0, _jsonp2.default)(url + (0, _utils.objectToGetParams)({
	    'st.cmd': 'extLike',
	    uid: 'odklcnt0',
	    ref: shareUrl
	  }));
	}

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TwitterShareCount = exports.OKShareCount = exports.VKShareCount = exports.PinterestShareCount = exports.GooglePlusShareCount = exports.LinkedinShareCount = exports.FacebookShareCount = undefined;
	
	var _extends2 = __webpack_require__(185);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(454);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shareCountGetters = __webpack_require__(880);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialMediaShareCount = _react2.default.createClass({
	  displayName: 'SocialMediaShareCount',
	
	  propTypes: {
	    children: _react2.default.PropTypes.func,
	    className: _react2.default.PropTypes.string,
	    getCount: _react2.default.PropTypes.func,
	    url: _react2.default.PropTypes.string.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      count: 0
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.updateCount(this.props.url);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.url !== this.props.url) {
	      this.updateCount(nextProps.url);
	    }
	  },
	  updateCount: function updateCount(url) {
	    var _this = this;
	
	    if (this.props.getCount) {
	      this.setState({
	        isLoading: true
	      });
	
	      this.props.getCount(url, function (count) {
	        if (_this.isMounted()) {
	          _this.setState({
	            count: count,
	            isLoading: false
	          });
	        }
	      });
	    }
	  },
	  render: function render() {
	    var _state = this.state,
	        count = _state.count,
	        isLoading = _state.isLoading;
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('SocialMediaShareCount', className) },
	      !isLoading && children(count || 0)
	    );
	  }
	}); /* eslint-disable react/no-multi-comp */
	
	
	SocialMediaShareCount.defaultProps = {
	  children: function children(shareCount) {
	    return shareCount;
	  }
	};
	
	function shareCountFactory(getCount) {
	  return function (props) {
	    return _react2.default.createElement(SocialMediaShareCount, (0, _extends3.default)({ getCount: getCount }, props));
	  };
	}
	
	var FacebookShareCount = exports.FacebookShareCount = shareCountFactory(_shareCountGetters.getFacebookShareCount);
	var LinkedinShareCount = exports.LinkedinShareCount = shareCountFactory(_shareCountGetters.getLinkedinShareCount);
	var GooglePlusShareCount = exports.GooglePlusShareCount = shareCountFactory(_shareCountGetters.getGooglePlusShareCount);
	var PinterestShareCount = exports.PinterestShareCount = shareCountFactory(_shareCountGetters.getPinterestShareCount);
	var VKShareCount = exports.VKShareCount = shareCountFactory(_shareCountGetters.getVKShareCount);
	var OKShareCount = exports.OKShareCount = shareCountFactory(_shareCountGetters.getOKShareCount);
	var TwitterShareCount = exports.TwitterShareCount = function TwitterShareCount() {
	  throw new Error('TwitterShareCount was removed in version 1.3.0 because' + 'the Twitter API was shut down and there is no replacement. Please ' + 'remove it from your code.');
	};

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.email = email;
	exports.twitter = twitter;
	exports.telegram = telegram;
	exports.whatsapp = whatsapp;
	exports.facebook = facebook;
	exports.googlePlus = googlePlus;
	exports.linkedin = linkedin;
	exports.pinterest = pinterest;
	exports.vk = vk;
	exports.ok = ok;
	
	var _assert = __webpack_require__(484);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _utils = __webpack_require__(184);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable prefer-template */
	function email(subject, body) {
	  (0, _assert2.default)(subject, 'email.subject');
	  (0, _assert2.default)(body, 'email.body');
	
	  return 'mailto:' + (0, _utils.objectToGetParams)({ subject: subject, body: body });
	}
	
	function twitter(url, _ref) {
	  var title = _ref.title,
	      via = _ref.via,
	      _ref$hashtags = _ref.hashtags,
	      hashtags = _ref$hashtags === undefined ? [] : _ref$hashtags;
	
	  (0, _assert2.default)(url, 'twitter.url');
	  (0, _assert2.default)(Array.isArray(hashtags), 'twitter.hashtags is not an array');
	
	  return 'https://twitter.com/share' + (0, _utils.objectToGetParams)({
	    url: url,
	    text: title,
	    via: via,
	    hashtags: hashtags.join(',')
	  });
	}
	
	function telegram(url, _ref2) {
	  var title = _ref2.title;
	
	  (0, _assert2.default)(url, 'telegram.url');
	  return 'https://telegram.me/share/' + (0, _utils.objectToGetParams)({
	    url: url,
	    text: title
	  });
	}
	
	function whatsapp(url, _ref3) {
	  var title = _ref3.title,
	      separator = _ref3.separator;
	
	  (0, _assert2.default)(url, 'whatsapp.url');
	  return 'whatsapp://send' + (0, _utils.objectToGetParams)({
	    text: title + separator + url
	  });
	}
	
	function facebook(url, _ref4) {
	  var title = _ref4.title,
	      description = _ref4.description,
	      picture = _ref4.picture,
	      hashtag = _ref4.hashtag;
	
	  (0, _assert2.default)(url, 'facebook.url');
	
	  return 'https://www.facebook.com/sharer/sharer.php' + (0, _utils.objectToGetParams)({
	    u: url,
	    title: title,
	    description: description,
	    picture: picture,
	    hashtag: hashtag
	  });
	}
	
	function googlePlus(url) {
	  (0, _assert2.default)(url, 'googlePlus.url');
	
	  return 'https://plus.google.com/share' + (0, _utils.objectToGetParams)({ url: url });
	}
	
	function linkedin(url, _ref5) {
	  var title = _ref5.title,
	      description = _ref5.description;
	
	  (0, _assert2.default)(url, 'linkedin.url');
	
	  return 'https://linkedin.com/shareArticle' + (0, _utils.objectToGetParams)({
	    url: url,
	    title: title,
	    summary: description
	  });
	}
	
	function pinterest(url, _ref6) {
	  var media = _ref6.media,
	      description = _ref6.description;
	
	  (0, _assert2.default)(url, 'pinterest.url');
	  (0, _assert2.default)(media, 'pinterest.media');
	
	  return 'https://pinterest.com/pin/create/button/' + (0, _utils.objectToGetParams)({
	    url: url,
	    media: media,
	    description: description
	  });
	}
	
	function vk(url, _ref7) {
	  var title = _ref7.title,
	      description = _ref7.description,
	      image = _ref7.image;
	
	  (0, _assert2.default)(url, 'vk.url');
	
	  return 'https://vk.com/share.php' + (0, _utils.objectToGetParams)({
	    url: url,
	    title: title,
	    description: description,
	    image: image
	  });
	}
	
	function ok(url, _ref8) {
	  var title = _ref8.title,
	      description = _ref8.description,
	      image = _ref8.image;
	
	  (0, _assert2.default)(url, 'ok.url');
	
	  return 'https://connect.ok.ru/offer' + (0, _utils.objectToGetParams)({
	    url: url,
	    title: title,
	    description: description,
	    imageUrl: image
	  });
	}

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(557), __esModule: true };

/***/ },
/* 884 */
542,
/* 885 */
543,
/* 886 */
204,
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(558), __esModule: true };

/***/ },
/* 888 */
544,
/* 889 */
545,
/* 890 */
546,
/* 891 */
49,
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(886);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(888);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(885);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(453);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(453);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var shallowEqual = _interopDefault(__webpack_require__(942));
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(SideEffect, _Component);
	
	      function SideEffect() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      // Try to use displayName of wrapped component
	      // Expose canUseDOM so tests can monkeypatch it
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      var _proto = SideEffect.prototype;
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      _proto.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      _proto.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      _proto.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
	
	    _defineProperty(SideEffect, "canUseDOM", canUseDOM);
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NextArrow = exports.PrevArrow = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _innerSliderUtils = __webpack_require__(125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var PrevArrow =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(PrevArrow, _React$PureComponent);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PrevArrow).apply(this, arguments));
	  }
	
	  _createClass(PrevArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var prevClasses = {
	        "slick-arrow": true,
	        "slick-prev": true
	      };
	      var prevHandler = this.clickHandler.bind(this, {
	        message: "previous"
	      });
	
	      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	        prevClasses["slick-disabled"] = true;
	        prevHandler = null;
	      }
	
	      var prevArrowProps = {
	        key: "0",
	        "data-role": "none",
	        className: (0, _classnames["default"])(prevClasses),
	        style: {
	          display: "block"
	        },
	        onClick: prevHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var prevArrow;
	
	      if (this.props.prevArrow) {
	        prevArrow = _react["default"].cloneElement(this.props.prevArrow, _objectSpread({}, prevArrowProps, {}, customProps));
	      } else {
	        prevArrow = _react["default"].createElement("button", _extends({
	          key: "0",
	          type: "button"
	        }, prevArrowProps), " ", "Previous");
	      }
	
	      return prevArrow;
	    }
	  }]);
	
	  return PrevArrow;
	}(_react["default"].PureComponent);
	
	exports.PrevArrow = PrevArrow;
	
	var NextArrow =
	/*#__PURE__*/
	function (_React$PureComponent2) {
	  _inherits(NextArrow, _React$PureComponent2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(NextArrow).apply(this, arguments));
	  }
	
	  _createClass(NextArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var nextClasses = {
	        "slick-arrow": true,
	        "slick-next": true
	      };
	      var nextHandler = this.clickHandler.bind(this, {
	        message: "next"
	      });
	
	      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
	        nextClasses["slick-disabled"] = true;
	        nextHandler = null;
	      }
	
	      var nextArrowProps = {
	        key: "1",
	        "data-role": "none",
	        className: (0, _classnames["default"])(nextClasses),
	        style: {
	          display: "block"
	        },
	        onClick: nextHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var nextArrow;
	
	      if (this.props.nextArrow) {
	        nextArrow = _react["default"].cloneElement(this.props.nextArrow, _objectSpread({}, nextArrowProps, {}, customProps));
	      } else {
	        nextArrow = _react["default"].createElement("button", _extends({
	          key: "1",
	          type: "button"
	        }, nextArrowProps), " ", "Next");
	      }
	
	      return nextArrow;
	    }
	  }]);
	
	  return NextArrow;
	}(_react["default"].PureComponent);
	
	exports.NextArrow = NextArrow;

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return _react["default"].createElement("ul", {
	      style: {
	        display: "block"
	      }
	    }, dots);
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return _react["default"].createElement("button", null, i + 1);
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	var _default = defaultProps;
	exports["default"] = _default;

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dots = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	
	  return dots;
	};
	
	var Dots =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(Dots, _React$PureComponent);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Dots).apply(this, arguments));
	  }
	
	  _createClass(Dots, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      // In Autoplay the focus stays on clicked button even after transition
	      // to next slide. That only goes away by click somewhere outside
	      e.preventDefault();
	      this.props.clickHandler(options);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      var dotCount = getDotCount({
	        slideCount: this.props.slideCount,
	        slidesToScroll: this.props.slidesToScroll,
	        slidesToShow: this.props.slidesToShow,
	        infinite: this.props.infinite
	      }); // Apply join & split to Array to pre-fill it for IE8
	      //
	      // Credit: http://stackoverflow.com/a/13735425/1849458
	
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave;
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
	        var leftBound = i * _this.props.slidesToScroll;
	        var rightBound = i * _this.props.slidesToScroll + (_this.props.slidesToScroll - 1);
	        var className = (0, _classnames["default"])({
	          "slick-active": _this.props.currentSlide >= leftBound && _this.props.currentSlide <= rightBound
	        });
	        var dotOptions = {
	          message: "dots",
	          index: i,
	          slidesToScroll: _this.props.slidesToScroll,
	          currentSlide: _this.props.currentSlide
	        };
	
	        var onClick = _this.clickHandler.bind(_this, dotOptions);
	
	        return _react["default"].createElement("li", {
	          key: i,
	          className: className
	        }, _react["default"].cloneElement(_this.props.customPaging(i), {
	          onClick: onClick
	        }));
	      });
	      return _react["default"].cloneElement(this.props.appendDots(dots), _objectSpread({
	        className: this.props.dotsClass
	      }, mouseEvents));
	    }
	  }]);
	
	  return Dots;
	}(_react["default"].PureComponent);
	
	exports.Dots = Dots;

/***/ },
/* 899 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false,
	  // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: {
	    startX: 0,
	    startY: 0,
	    curX: 0,
	    curY: 0
	  },
	  trackStyle: {},
	  trackWidth: 0
	};
	var _default = initialState;
	exports["default"] = _default;

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InnerSlider = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(23));
	
	var _initialState = _interopRequireDefault(__webpack_require__(899));
	
	var _lodash = _interopRequireDefault(__webpack_require__(678));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _innerSliderUtils = __webpack_require__(125);
	
	var _track = __webpack_require__(902);
	
	var _dots = __webpack_require__(898);
	
	var _arrows = __webpack_require__(896);
	
	var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(940));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var InnerSlider =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(InnerSlider, _React$Component);
	
	  function InnerSlider(props) {
	    var _this;
	
	    _classCallCheck(this, InnerSlider);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(InnerSlider).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
	      return _this.list = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
	      return _this.track = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
	      if (_this.props.adaptiveHeight && _this.list) {
	        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
	
	        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
	      _this.ssrInit();
	
	      _this.props.onInit && _this.props.onInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, {}, _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props);
	
	      _this.updateState(spec, true, function () {
	        _this.adaptHeight();
	
	        _this.props.autoplay && _this.autoPlay("update");
	      });
	
	      if (_this.props.lazyLoad === "progressive") {
	        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
	      }
	
	      _this.ro = new _resizeObserverPolyfill["default"](function () {
	        if (_this.state.animating) {
	          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
	
	
	          _this.callbackTimers.push(setTimeout(function () {
	            return _this.onWindowResized();
	          }, _this.props.speed));
	        } else {
	          _this.onWindowResized();
	        }
	      });
	
	      _this.ro.observe(_this.list);
	
	      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
	        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
	        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
	      }); // To support server-side rendering
	
	      if (!window) {
	        return;
	      }
	
	      if (window.addEventListener) {
	        window.addEventListener("resize", _this.onWindowResized);
	      } else {
	        window.attachEvent("onresize", _this.onWindowResized);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
	      if (_this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	      }
	
	      if (_this.lazyLoadTimer) {
	        clearInterval(_this.lazyLoadTimer);
	      }
	
	      if (_this.callbackTimers.length) {
	        _this.callbackTimers.forEach(function (timer) {
	          return clearTimeout(timer);
	        });
	
	        _this.callbackTimers = [];
	      }
	
	      if (window.addEventListener) {
	        window.removeEventListener("resize", _this.onWindowResized);
	      } else {
	        window.detachEvent("onresize", _this.onWindowResized);
	      }
	
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, nextProps, {}, _this.state);
	
	      var setTrackStyle = false;
	
	      for (var _i = 0, _Object$keys = Object.keys(_this.props); _i < _Object$keys.length; _i++) {
	        var key = _Object$keys[_i];
	
	        if (!nextProps.hasOwnProperty(key)) {
	          setTrackStyle = true;
	          break;
	        }
	
	        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
	          continue;
	        }
	
	        if (nextProps[key] !== _this.props[key]) {
	          setTrackStyle = true;
	          break;
	        }
	      }
	
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.state.currentSlide >= _react["default"].Children.count(nextProps.children)) {
	          _this.changeSlide({
	            message: "index",
	            index: _react["default"].Children.count(nextProps.children) - nextProps.slidesToShow,
	            currentSlide: _this.state.currentSlide
	          });
	        }
	
	        if (nextProps.autoplay) {
	          _this.autoPlay("update");
	        } else {
	          _this.pause("paused");
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
	      _this.checkImagesLoad();
	
	      _this.props.onReInit && _this.props.onReInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, {}, _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      } // if (this.props.onLazyLoad) {
	      //   this.props.onLazyLoad([leftMostSlide])
	      // }
	
	
	      _this.adaptHeight();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
	      if (_this.debouncedResize) _this.debouncedResize.cancel();
	      _this.debouncedResize = (0, _lodash["default"])(function () {
	        return _this.resizeWindow(setTrackStyle);
	      }, 50);
	
	      _this.debouncedResize();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
	      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      if (!_reactDom["default"].findDOMNode(_this.track)) return;
	
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props, {}, _this.state);
	
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
	      }); // animating state should be cleared while resizing, otherwise autoplay stops working
	
	
	      _this.setState({
	        animating: false
	      });
	
	      clearTimeout(_this.animationEndCallback);
	      delete _this.animationEndCallback;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
	      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
	      spec = _objectSpread({}, spec, {}, updatedState, {
	        slideIndex: updatedState.currentSlide
	      });
	      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
	      spec = _objectSpread({}, spec, {
	        left: targetLeft
	      });
	      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
	
	      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
	        updatedState["trackStyle"] = trackStyle;
	      }
	
	      _this.setState(updatedState, callback);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
	      if (_this.props.variableWidth) {
	        var _trackWidth = 0,
	            _trackLeft = 0;
	        var childrenWidths = [];
	        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread({}, _this.props, {}, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread({}, _this.props, {}, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	
	        _this.props.children.forEach(function (child) {
	          childrenWidths.push(child.props.style.width);
	          _trackWidth += child.props.style.width;
	        });
	
	        for (var i = 0; i < preClones; i++) {
	          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
	          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
	        }
	
	        for (var _i2 = 0; _i2 < postClones; _i2++) {
	          _trackWidth += childrenWidths[_i2];
	        }
	
	        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
	          _trackLeft += childrenWidths[_i3];
	        }
	
	        var _trackStyle = {
	          width: _trackWidth + "px",
	          left: -_trackLeft + "px"
	        };
	
	        if (_this.props.centerMode) {
	          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
	          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
	        }
	
	        _this.setState({
	          trackStyle: _trackStyle
	        });
	
	        return;
	      }
	
	      var childrenCount = _react["default"].Children.count(_this.props.children);
	
	      var spec = _objectSpread({}, _this.props, {}, _this.state, {
	        slideCount: childrenCount
	      });
	
	      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
	      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
	      var slideWidth = 100 / slideCount;
	      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
	
	      if (_this.props.centerMode) {
	        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
	      }
	
	      var trackStyle = {
	        width: trackWidth + "%",
	        left: trackLeft + "%"
	      };
	
	      _this.setState({
	        slideWidth: slideWidth + "%",
	        trackStyle: trackStyle
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
	      var images = document.querySelectorAll(".slick-slide img");
	      var imagesCount = images.length,
	          loadedCount = 0;
	      Array.prototype.forEach.call(images, function (image) {
	        var handler = function handler() {
	          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
	        };
	
	        if (!image.onclick) {
	          image.onclick = function () {
	            return image.parentNode.focus();
	          };
	        } else {
	          var prevClickHandler = image.onclick;
	
	          image.onclick = function () {
	            prevClickHandler();
	            image.parentNode.focus();
	          };
	        }
	
	        if (!image.onload) {
	          if (_this.props.lazyLoad) {
	            image.onload = function () {
	              _this.adaptHeight();
	
	              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
	            };
	          } else {
	            image.onload = handler;
	
	            image.onerror = function () {
	              handler();
	              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
	            };
	          }
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
	      var slidesToLoad = [];
	
	      var spec = _objectSpread({}, _this.props, {}, _this.state);
	
	      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
	        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
	          slidesToLoad.push(index);
	          break;
	        }
	      }
	
	      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
	        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
	          slidesToLoad.push(_index);
	          break;
	        }
	      }
	
	      if (slidesToLoad.length > 0) {
	        _this.setState(function (state) {
	          return {
	            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
	          };
	        });
	
	        if (_this.props.onLazyLoad) {
	          _this.props.onLazyLoad(slidesToLoad);
	        }
	      } else {
	        if (_this.lazyLoadTimer) {
	          clearInterval(_this.lazyLoadTimer);
	          delete _this.lazyLoadTimer;
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _this$props = _this.props,
	          asNavFor = _this$props.asNavFor,
	          beforeChange = _this$props.beforeChange,
	          onLazyLoad = _this$props.onLazyLoad,
	          speed = _this$props.speed,
	          afterChange = _this$props.afterChange; // capture currentslide before state is updated
	
	      var currentSlide = _this.state.currentSlide;
	
	      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread({
	        index: index
	      }, _this.props, {}, _this.state, {
	        trackRef: _this.track,
	        useCSS: _this.props.useCSS && !dontAnimate
	      })),
	          state = _slideHandler.state,
	          nextState = _slideHandler.nextState;
	
	      if (!state) return;
	      beforeChange && beforeChange(currentSlide, state.currentSlide);
	      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
	        return _this.state.lazyLoadedList.indexOf(value) < 0;
	      });
	      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
	
	      _this.setState(state, function () {
	        asNavFor && asNavFor.innerSlider.slideHandler(index);
	        if (!nextState) return;
	        _this.animationEndCallback = setTimeout(function () {
	          var animating = nextState.animating,
	              firstBatch = _objectWithoutProperties(nextState, ["animating"]);
	
	          _this.setState(firstBatch, function () {
	            _this.callbackTimers.push(setTimeout(function () {
	              return _this.setState({
	                animating: animating
	              });
	            }, 10));
	
	            afterChange && afterChange(state.currentSlide);
	            delete _this.animationEndCallback;
	          });
	        }, speed);
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var spec = _objectSpread({}, _this.props, {}, _this.state);
	
	      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
	      if (targetSlide !== 0 && !targetSlide) return;
	
	      if (dontAnimate === true) {
	        _this.slideHandler(targetSlide, dontAnimate);
	      } else {
	        _this.slideHandler(targetSlide);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
	      if (_this.clickable === false) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	
	      _this.clickable = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
	      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
	      dir !== "" && _this.changeSlide({
	        message: dir
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
	      _this.changeSlide(options);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	      };
	
	      window.ontouchmove = preventDefault;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
	      window.ontouchmove = null;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
	      if (_this.props.verticalSwiping) {
	        _this.disableBodyScroll();
	      }
	
	      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
	      state !== "" && _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
	      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread({}, _this.props, {}, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	
	      if (state["swiping"]) {
	        _this.clickable = false;
	      }
	
	      _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
	      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread({}, _this.props, {}, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      var triggerSlideHandler = state["triggerSlideHandler"];
	      delete state["triggerSlideHandler"];
	
	      _this.setState(state);
	
	      if (triggerSlideHandler === undefined) return;
	
	      _this.slideHandler(triggerSlideHandler);
	
	      if (_this.props.verticalSwiping) {
	        _this.enableBodyScroll();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
	      // this and fellow methods are wrapped in setTimeout
	      // to make sure initialize setState has happened before
	      // any of such methods are called
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "previous"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "next"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      slide = Number(slide);
	      if (isNaN(slide)) return "";
	
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "index",
	          index: slide,
	          currentSlide: _this.state.currentSlide
	        }, dontAnimate);
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "play", function () {
	      var nextIndex;
	
	      if (_this.props.rtl) {
	        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
	      } else {
	        if ((0, _innerSliderUtils.canGoNext)(_objectSpread({}, _this.props, {}, _this.state))) {
	          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
	        } else {
	          return false;
	        }
	      }
	
	      _this.slideHandler(nextIndex);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (playType === "update") {
	        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
	          return;
	        }
	      } else if (playType === "leave") {
	        if (autoplaying === "paused" || autoplaying === "focused") {
	          return;
	        }
	      } else if (playType === "blur") {
	        if (autoplaying === "paused" || autoplaying === "hovered") {
	          return;
	        }
	      }
	
	      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
	
	      _this.setState({
	        autoplaying: "playing"
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	        _this.autoplayTimer = null;
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (pauseType === "paused") {
	        _this.setState({
	          autoplaying: "paused"
	        });
	      } else if (pauseType === "focused") {
	        if (autoplaying === "hovered" || autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "focused"
	          });
	        }
	      } else {
	        // pauseType  is 'hovered'
	        if (autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "hovered"
	          });
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
	      return _this.props.autoplay && _this.pause("focused");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "render", function () {
	      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
	        "slick-vertical": _this.props.vertical,
	        "slick-initialized": true
	      });
	
	      var spec = _objectSpread({}, _this.props, {}, _this.state);
	
	      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
	      var pauseOnHover = _this.props.pauseOnHover;
	      trackProps = _objectSpread({}, trackProps, {
	        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
	        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
	        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
	        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
	      });
	      var dots;
	
	      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
	        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
	        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
	        dotProps = _objectSpread({}, dotProps, {
	          clickHandler: _this.changeSlide,
	          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
	          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
	          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
	        });
	        dots = _react["default"].createElement(_dots.Dots, dotProps);
	      }
	
	      var prevArrow, nextArrow;
	      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
	      arrowProps.clickHandler = _this.changeSlide;
	
	      if (_this.props.arrows) {
	        prevArrow = _react["default"].createElement(_arrows.PrevArrow, arrowProps);
	        nextArrow = _react["default"].createElement(_arrows.NextArrow, arrowProps);
	      }
	
	      var verticalHeightStyle = null;
	
	      if (_this.props.vertical) {
	        verticalHeightStyle = {
	          height: _this.state.listHeight
	        };
	      }
	
	      var centerPaddingStyle = null;
	
	      if (_this.props.vertical === false) {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: "0px " + _this.props.centerPadding
	          };
	        }
	      } else {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: _this.props.centerPadding + " 0px"
	          };
	        }
	      }
	
	      var listStyle = _objectSpread({}, verticalHeightStyle, {}, centerPaddingStyle);
	
	      var touchMove = _this.props.touchMove;
	      var listProps = {
	        className: "slick-list",
	        style: listStyle,
	        onClick: _this.clickHandler,
	        onMouseDown: touchMove ? _this.swipeStart : null,
	        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onMouseUp: touchMove ? _this.swipeEnd : null,
	        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onTouchStart: touchMove ? _this.swipeStart : null,
	        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onTouchEnd: touchMove ? _this.swipeEnd : null,
	        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
	      };
	      var innerSliderProps = {
	        className: className,
	        dir: "ltr",
	        style: _this.props.style
	      };
	
	      if (_this.props.unslick) {
	        listProps = {
	          className: "slick-list"
	        };
	        innerSliderProps = {
	          className: className
	        };
	      }
	
	      return _react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", _react["default"].createElement("div", _extends({
	        ref: _this.listRefHandler
	      }, listProps), _react["default"].createElement(_track.Track, _extends({
	        ref: _this.trackRefHandler
	      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
	    });
	
	    _this.list = null;
	    _this.track = null;
	    _this.state = _objectSpread({}, _initialState["default"], {
	      currentSlide: _this.props.initialSlide,
	      slideCount: _react["default"].Children.count(_this.props.children)
	    });
	    _this.callbackTimers = [];
	    _this.clickable = true;
	    _this.debouncedResize = null;
	    return _this;
	  }
	
	  return InnerSlider;
	}(_react["default"].Component);
	
	exports.InnerSlider = InnerSlider;

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _innerSlider = __webpack_require__(900);
	
	var _json2mq = _interopRequireDefault(__webpack_require__(673));
	
	var _defaultProps = _interopRequireDefault(__webpack_require__(897));
	
	var _innerSliderUtils = __webpack_require__(125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(607);
	
	var Slider =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    var _this;
	
	    _classCallCheck(this, Slider);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
	      return _this.innerSlider = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
	      return _this.innerSlider.slickPrev();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
	      return _this.innerSlider.slickNext();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
	      return _this.innerSlider.pause("paused");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
	      return _this.innerSlider.autoPlay("play");
	    });
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	
	  _createClass(Slider, [{
	    key: "media",
	    value: function media(query, handler) {
	      // javascript handler for  css media query
	      enquire.register(query, handler);
	
	      this._responsiveMediaHandlers.push({
	        query: query,
	        handler: handler
	      });
	    } // handles responsive breakpoints
	
	  }, {
	    key: "UNSAFE_componentWillMount",
	    value: function UNSAFE_componentWillMount() {
	      var _this2 = this;
	
	      // performance monitoring
	      //if (process.env.NODE_ENV !== 'production') {
	      //const { whyDidYouUpdate } = require('why-did-you-update')
	      //whyDidYouUpdate(React)
	      //}
	      if (this.props.responsive) {
	        var breakpoints = this.props.responsive.map(function (breakpt) {
	          return breakpt.breakpoint;
	        }); // sort them in increasing order of their numerical value
	
	        breakpoints.sort(function (x, y) {
	          return x - y;
	        });
	        breakpoints.forEach(function (breakpoint, index) {
	          // media query for each breakpoint
	          var bQuery;
	
	          if (index === 0) {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: 0,
	              maxWidth: breakpoint
	            });
	          } else {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: breakpoints[index - 1] + 1,
	              maxWidth: breakpoint
	            });
	          } // when not using server side rendering
	
	
	          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	            _this2.setState({
	              breakpoint: breakpoint
	            });
	          });
	        }); // Register media query for full screen. Need to support resize from small to large
	        // convert javascript object to media query string
	
	        var query = (0, _json2mq["default"])({
	          minWidth: breakpoints.slice(-1)[0]
	        });
	        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	          _this2.setState({
	            breakpoint: null
	          });
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._responsiveMediaHandlers.forEach(function (obj) {
	        enquire.unregister(obj.query, obj.handler);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var settings;
	      var newProps;
	
	      if (this.state.breakpoint) {
	        newProps = this.props.responsive.filter(function (resp) {
	          return resp.breakpoint === _this3.state.breakpoint;
	        });
	        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread({}, _defaultProps["default"], {}, this.props, {}, newProps[0].settings);
	      } else {
	        settings = _objectSpread({}, _defaultProps["default"], {}, this.props);
	      } // force scrolling by one if centerMode is on
	
	
	      if (settings.centerMode) {
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToScroll = 1;
	      } // force showing one slide and scrolling by one if the fade mode is on
	
	
	      if (settings.fade) {
	        if (settings.slidesToShow > 1 && ("production") !== "production") {
	          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
	        }
	
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToShow = 1;
	        settings.slidesToScroll = 1;
	      } // makes sure that children is an array, even when there is only 1 child
	
	
	      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
	      // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	
	
	      children = children.filter(function (child) {
	        if (typeof child === "string") {
	          return !!child.trim();
	        }
	
	        return !!child;
	      }); // rows and slidesPerRow logic is handled here
	
	      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	        settings.variableWidth = false;
	      }
	
	      var newChildren = [];
	      var currentWidth = null;
	
	      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	        var newSlide = [];
	
	        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	          var row = [];
	
	          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	            if (settings.variableWidth && children[k].props.style) {
	              currentWidth = children[k].props.style.width;
	            }
	
	            if (k >= children.length) break;
	            row.push(_react["default"].cloneElement(children[k], {
	              key: 100 * i + 10 * j + k,
	              tabIndex: -1,
	              style: {
	                width: "".concat(100 / settings.slidesPerRow, "%"),
	                display: "inline-block"
	              }
	            }));
	          }
	
	          newSlide.push(_react["default"].createElement("div", {
	            key: 10 * i + j
	          }, row));
	        }
	
	        if (settings.variableWidth) {
	          newChildren.push(_react["default"].createElement("div", {
	            key: i,
	            style: {
	              width: currentWidth
	            }
	          }, newSlide));
	        } else {
	          newChildren.push(_react["default"].createElement("div", {
	            key: i
	          }, newSlide));
	        }
	      }
	
	      if (settings === "unslick") {
	        var className = "regular slider " + (this.props.className || "");
	        return _react["default"].createElement("div", {
	          className: className
	        }, newChildren);
	      } else if (newChildren.length <= settings.slidesToShow) {
	        settings.unslick = true;
	      }
	
	      return _react["default"].createElement(_innerSlider.InnerSlider, _extends({
	        style: this.props.style,
	        ref: this.innerSliderRefHandler
	      }, settings), newChildren);
	    }
	  }]);
	
	  return Slider;
	}(_react["default"].Component);
	
	exports["default"] = Slider;

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Track = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _innerSliderUtils = __webpack_require__(125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	
	  slickCloned = index < 0 || index >= spec.slideCount;
	
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	
	  var slickCurrent = index === spec.currentSlide;
	  return {
	    "slick-slide": true,
	    "slick-active": slickActive,
	    "slick-center": slickCenter,
	    "slick-cloned": slickCloned,
	    "slick-current": slickCurrent // dubious in case of RTL
	
	  };
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = "relative";
	
	    if (spec.vertical) {
	      style.top = -spec.index * parseInt(spec.slideHeight);
	    } else {
	      style.left = -spec.index * parseInt(spec.slideWidth);
	    }
	
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	
	  var childrenCount = _react["default"].Children.count(spec.children);
	
	  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
	  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
	
	  _react["default"].Children.forEach(spec.children, function (elem, index) {
	    var child;
	    var childOnClickOptions = {
	      message: "children",
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    }; // in case of lazyLoad, whether or not we want to fetch the slide
	
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = _react["default"].createElement("div", null);
	    }
	
	    var childStyle = getSlideStyle(_objectSpread({}, spec, {
	      index: index
	    }));
	    var slideClass = child.props.className || "";
	    var slideClasses = getSlideClasses(_objectSpread({}, spec, {
	      index: index
	    })); // push a cloned element of the desired slide
	
	    slides.push(_react["default"].cloneElement(child, {
	      key: "original" + getKey(child, index),
	      "data-index": index,
	      className: (0, _classnames["default"])(slideClasses, slideClass),
	      tabIndex: "-1",
	      "aria-hidden": !slideClasses["slick-active"],
	      style: _objectSpread({
	        outline: "none"
	      }, child.props.style || {}, {}, childStyle),
	      onClick: function onClick(e) {
	        child.props && child.props.onClick && child.props.onClick(e);
	
	        if (spec.focusOnSelect) {
	          spec.focusOnSelect(childOnClickOptions);
	        }
	      }
	    })); // if slide needs to be precloned or postcloned
	
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	
	      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	
	        if (key >= startIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread({}, spec, {
	          index: key
	        }));
	        preCloneSlides.push(_react["default"].cloneElement(child, {
	          key: "precloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames["default"])(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread({}, child.props.style || {}, {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	
	        if (key < endIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread({}, spec, {
	          index: key
	        }));
	        postCloneSlides.push(_react["default"].cloneElement(child, {
	          key: "postcloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames["default"])(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread({}, child.props.style || {}, {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(Track, _React$PureComponent);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Track).apply(this, arguments));
	  }
	
	  _createClass(Track, [{
	    key: "render",
	    value: function render() {
	      var slides = renderSlides(this.props);
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave;
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      return _react["default"].createElement("div", _extends({
	        className: "slick-track",
	        style: this.props.trackStyle
	      }, mouseEvents), slides);
	    }
	  }]);
	
	  return Track;
	}(_react["default"].PureComponent);
	
	exports.Track = Track;

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _renderPropsVersion = _interopRequireDefault(__webpack_require__(456));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function Sticky(props) {
	  var mode = props.mode,
	      onFixedToggle = props.onFixedToggle,
	      hideOnBoundaryHit = props.hideOnBoundaryHit,
	      offsetTransforms = props.offsetTransforms,
	      disabled = props.disabled,
	      boundaryElement = props.boundaryElement,
	      scrollElement = props.scrollElement,
	      bottomOffset = props.bottomOffset,
	      topOffset = props.topOffset,
	      positionRecheckInterval = props.positionRecheckInterval,
	      noExceptionOnMissedScrollElement = props.noExceptionOnMissedScrollElement,
	      children = props.children,
	      isIOSFixEnabled = props.isIOSFixEnabled,
	      dontUpdateHolderHeightWhenSticky = props.dontUpdateHolderHeightWhenSticky,
	      wrapperClassName = props.wrapperClassName,
	      stickyClassName = props.stickyClassName,
	      stickyStyle = props.stickyStyle,
	      rest = _objectWithoutProperties(props, ["mode", "onFixedToggle", "hideOnBoundaryHit", "offsetTransforms", "disabled", "boundaryElement", "scrollElement", "bottomOffset", "topOffset", "positionRecheckInterval", "noExceptionOnMissedScrollElement", "children", "isIOSFixEnabled", "dontUpdateHolderHeightWhenSticky", "wrapperClassName", "stickyClassName", "stickyStyle"]);
	
	  return _react.default.createElement(_renderPropsVersion.default, {
	    mode: mode,
	    onFixedToggle: onFixedToggle,
	    hideOnBoundaryHit: hideOnBoundaryHit,
	    offsetTransforms: offsetTransforms,
	    disabled: disabled,
	    boundaryElement: boundaryElement,
	    scrollElement: scrollElement,
	    bottomOffset: bottomOffset,
	    topOffset: topOffset,
	    positionRecheckInterval: positionRecheckInterval,
	    noExceptionOnMissedScrollElement: noExceptionOnMissedScrollElement,
	    isIOSFixEnabled: isIOSFixEnabled,
	    dontUpdateHolderHeightWhenSticky: dontUpdateHolderHeightWhenSticky
	  }, function (_ref) {
	    var isFixed = _ref.isFixed,
	        wrapperStyles = _ref.wrapperStyles,
	        wrapperRef = _ref.wrapperRef,
	        holderStyles = _ref.holderStyles,
	        holderRef = _ref.holderRef;
	    return _react.default.createElement("div", _extends({}, rest, {
	      ref: holderRef,
	      style: holderStyles
	    }), _react.default.createElement("div", _extends({}, rest, {
	      className: "".concat(wrapperClassName, " ").concat(isFixed ? stickyClassName : ''),
	      style: // $FlowFixMe - flow does not like when we merge 2 inexact objects
	      isFixed ? _objectSpread({}, wrapperStyles, {}, stickyStyle) : wrapperStyles,
	      ref: wrapperRef
	    }), children));
	  });
	}
	
	Sticky.defaultProps = {
	  stickyClassName: 'sticky',
	  wrapperClassName: '',
	  stickyStyle: {}
	};
	var _default = Sticky;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 904 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.listen = listen;
	exports.unlisten = unlisten;
	////////////////////////////////////////////////////////////////////////////////////////
	// Small helpers that provide an easy and efficient way to add/remove event listeners //
	////////////////////////////////////////////////////////////////////////////////////////
	var elementsWithListeners = [];
	var registeredListeners = [];
	
	function createListener(el) {
	  return {
	    el: el,
	    callbacks: {},
	    realCallbacks: {},
	    realListenersCnt: 0
	  };
	}
	
	function addCallback(listener, event, cb) {
	  if (listener.callbacks[event]) {
	    if (listener.callbacks[event].indexOf(cb) === -1) {
	      listener.callbacks[event].push(cb);
	    }
	
	    return;
	  }
	
	  listener.callbacks[event] = [cb];
	
	  listener.realCallbacks[event] = function (e) {
	    for (var i = 0, l = listener.callbacks[event].length; i < l; i += 1) {
	      listener.callbacks[event][i](e);
	    }
	  };
	
	  listener.el.addEventListener(event, listener.realCallbacks[event]);
	  listener.realListenersCnt += 1;
	}
	
	function removeCallback(listener, event, cb) {
	  if (!listener.callbacks[event]) {
	    return;
	  }
	
	  var idx = listener.callbacks[event].indexOf(cb);
	
	  if (idx === -1) {
	    return;
	  }
	
	  listener.callbacks[event].splice(idx, 1);
	
	  if (listener.callbacks[event].length > 0) {
	    return;
	  } // no more listeners, lets clean up
	
	
	  listener.el.removeEventListener(event, listener.realCallbacks[event]);
	  delete listener.callbacks[event];
	  delete listener.realCallbacks[event];
	  listener.realListenersCnt -= 1;
	}
	
	function addListener(el, event, cb) {
	  var idx = elementsWithListeners.indexOf(el);
	
	  if (idx === -1) {
	    idx = elementsWithListeners.length;
	    elementsWithListeners.push(el);
	    registeredListeners.push(createListener(el));
	  }
	
	  var listener = registeredListeners[idx];
	  addCallback(listener, event, cb);
	}
	
	function removeListener(el, event, cb) {
	  var idx = elementsWithListeners.indexOf(el);
	
	  if (idx === -1) {
	    return;
	  }
	
	  var listener = registeredListeners[idx];
	  removeCallback(listener, event, cb);
	
	  if (listener.realListenersCnt > 0) {
	    return;
	  } // no more listeners lets clean up
	
	
	  elementsWithListeners.splice(idx, 1);
	  registeredListeners.splice(idx, 1);
	}
	/**
	 * Subscribe cb to events list
	 * @param  {HTMLElement}   el       target element
	 * @param  {Array}         events   array of event names
	 * @param  {Function} cb   callback that should be called
	 */
	
	
	function listen(el, events, cb) {
	  for (var i = 0, l = events.length; i < l; i += 1) {
	    addListener(el, events[i], cb);
	  }
	}
	/**
	 * Unsubscribe cb from events list
	 * @param  {HTMLElement}   el       target element
	 * @param  {Array}         events   array of event names
	 * @param  {Function} cb   callback that should be unsubscribed
	 */
	
	
	function unlisten(el, events, cb) {
	  for (var i = 0, l = events.length; i < l; i += 1) {
	    removeListener(el, events[i], cb);
	  }
	}

/***/ },
/* 905 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = find;
	var basicSelectors = {};
	
	if (typeof document !== 'undefined') {
	  basicSelectors.body = document.body;
	  basicSelectors.window = window;
	  basicSelectors.document = document;
	}
	
	var matchesMethodName = function () {
	  if (typeof document !== 'undefined' && document.body) {
	    var body = document.body;
	    return typeof body.matches === 'function' ? 'matches' : // $FlowFixMe - flow doesn't like vendors, so do I, but we have to support such case
	    typeof body.webkitMatchesSelector === 'function' ? 'webkitMatchesSelector' : //webkit
	    // $FlowFixMe - see above
	    typeof body.mozMatchesSelector === 'function' ? 'mozMatchesSelector' : //mozilla
	    // $FlowFixMe - see above
	    typeof body.msMatchesSelector === 'function' ? 'msMatchesSelector' : //ie
	    // $FlowFixMe - see above
	    typeof body.oMatchesSelector === 'function' ? 'oMatchesSelector' : //old opera
	    null;
	  }
	
	  return null;
	}();
	
	function find(selector, el) {
	  if (!selector) {
	    return null;
	  }
	
	  if (basicSelectors.hasOwnProperty(selector)) {
	    return basicSelectors[selector];
	  } // select by id
	
	
	  if (selector[0] === '#') {
	    return document.getElementById(selector.slice(1));
	  }
	
	  if (matchesMethodName === null) {
	    return null;
	  }
	
	  var temp = el; // eslint-disable-next-line no-cond-assign
	
	  while (temp = temp.parentElement) {
	    // $FlowFixMe - flow does not approve it, but it works fine :)
	    if (temp[matchesMethodName](selector)) {
	      return temp || null;
	    }
	  } // nothing has been found :(
	
	
	  return null;
	}
	
	module.exports = exports.default;

/***/ },
/* 906 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getClosestTransformedParent;
	
	function getClosestTransformedParent(el) {
	  do {
	    var style = window.getComputedStyle(el);
	    if (style.transform !== 'none' || style.webkitTransform !== 'none') return el; // $FlowFixMe - it's fine
	
	    el = el.parentElement || el.parentNode;
	  } while (el !== null && el.nodeType === 1);
	
	  return null;
	}
	
	module.exports = exports.default;

/***/ },
/* 907 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRect = getRect;
	exports.isIntersecting = isIntersecting;
	exports.infiniteRect = void 0;
	var infiniteRect = {
	  top: -Infinity,
	  bottom: Infinity,
	  height: Infinity,
	  left: -Infinity,
	  right: Infinity,
	  width: Infinity
	};
	exports.infiniteRect = infiniteRect;
	
	function getRect(el) {
	  if (el && typeof el.getBoundingClientRect === 'function') {
	    return el.getBoundingClientRect();
	  }
	
	  if (el === window || el === document) {
	    return {
	      top: 0,
	      left: 0,
	      bottom: window.innerHeight,
	      height: window.innerHeight,
	      width: window.innerWidth,
	      right: window.innerWidth
	    };
	  }
	
	  return {
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    width: 0,
	    height: 0
	  };
	}
	
	function isIntersecting(r1, r2, topOffset, bottomOffset) {
	  var r1Top = r1.top + topOffset,
	      r1Bottom = r1.bottom + bottomOffset;
	  return r1Top >= r2.top && r1Top <= r2.bottom || r1Bottom >= r2.top && r1Bottom <= r2.bottom || r1Bottom >= r2.bottom && r1Top <= r2.top;
	}

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "RenderPropSticky", {
	  enumerable: true,
	  get: function get() {
	    return _renderPropsVersion.default;
	  }
	});
	exports.default = void 0;
	
	var _renderPropsVersion = _interopRequireDefault(__webpack_require__(456));
	
	var _basicVersion = _interopRequireDefault(__webpack_require__(903));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _basicVersion.default;
	exports.default = _default;

/***/ },
/* 909 */
/***/ function(module, exports) {

	// GENERATED DO NOT EDIT
	module.exports = [
	  "alignContent",
	  "MozAlignContent",
	  "WebkitAlignContent",
	  "MSAlignContent",
	  "OAlignContent",
	  "alignItems",
	  "MozAlignItems",
	  "WebkitAlignItems",
	  "MSAlignItems",
	  "OAlignItems",
	  "alignSelf",
	  "MozAlignSelf",
	  "WebkitAlignSelf",
	  "MSAlignSelf",
	  "OAlignSelf",
	  "all",
	  "MozAll",
	  "WebkitAll",
	  "MSAll",
	  "OAll",
	  "animation",
	  "MozAnimation",
	  "WebkitAnimation",
	  "MSAnimation",
	  "OAnimation",
	  "animationDelay",
	  "MozAnimationDelay",
	  "WebkitAnimationDelay",
	  "MSAnimationDelay",
	  "OAnimationDelay",
	  "animationDirection",
	  "MozAnimationDirection",
	  "WebkitAnimationDirection",
	  "MSAnimationDirection",
	  "OAnimationDirection",
	  "animationDuration",
	  "MozAnimationDuration",
	  "WebkitAnimationDuration",
	  "MSAnimationDuration",
	  "OAnimationDuration",
	  "animationFillMode",
	  "MozAnimationFillMode",
	  "WebkitAnimationFillMode",
	  "MSAnimationFillMode",
	  "OAnimationFillMode",
	  "animationIterationCount",
	  "MozAnimationIterationCount",
	  "WebkitAnimationIterationCount",
	  "MSAnimationIterationCount",
	  "OAnimationIterationCount",
	  "animationName",
	  "MozAnimationName",
	  "WebkitAnimationName",
	  "MSAnimationName",
	  "OAnimationName",
	  "animationPlayState",
	  "MozAnimationPlayState",
	  "WebkitAnimationPlayState",
	  "MSAnimationPlayState",
	  "OAnimationPlayState",
	  "animationTimingFunction",
	  "MozAnimationTimingFunction",
	  "WebkitAnimationTimingFunction",
	  "MSAnimationTimingFunction",
	  "OAnimationTimingFunction",
	  "backfaceVisibility",
	  "MozBackfaceVisibility",
	  "WebkitBackfaceVisibility",
	  "MSBackfaceVisibility",
	  "OBackfaceVisibility",
	  "background",
	  "MozBackground",
	  "WebkitBackground",
	  "MSBackground",
	  "OBackground",
	  "backgroundAttachment",
	  "MozBackgroundAttachment",
	  "WebkitBackgroundAttachment",
	  "MSBackgroundAttachment",
	  "OBackgroundAttachment",
	  "backgroundBlendMode",
	  "MozBackgroundBlendMode",
	  "WebkitBackgroundBlendMode",
	  "MSBackgroundBlendMode",
	  "OBackgroundBlendMode",
	  "backgroundClip",
	  "MozBackgroundClip",
	  "WebkitBackgroundClip",
	  "MSBackgroundClip",
	  "OBackgroundClip",
	  "backgroundColor",
	  "MozBackgroundColor",
	  "WebkitBackgroundColor",
	  "MSBackgroundColor",
	  "OBackgroundColor",
	  "backgroundImage",
	  "MozBackgroundImage",
	  "WebkitBackgroundImage",
	  "MSBackgroundImage",
	  "OBackgroundImage",
	  "backgroundOrigin",
	  "MozBackgroundOrigin",
	  "WebkitBackgroundOrigin",
	  "MSBackgroundOrigin",
	  "OBackgroundOrigin",
	  "backgroundPosition",
	  "MozBackgroundPosition",
	  "WebkitBackgroundPosition",
	  "MSBackgroundPosition",
	  "OBackgroundPosition",
	  "backgroundRepeat",
	  "MozBackgroundRepeat",
	  "WebkitBackgroundRepeat",
	  "MSBackgroundRepeat",
	  "OBackgroundRepeat",
	  "backgroundSize",
	  "MozBackgroundSize",
	  "WebkitBackgroundSize",
	  "MSBackgroundSize",
	  "OBackgroundSize",
	  "blockSize",
	  "MozBlockSize",
	  "WebkitBlockSize",
	  "MSBlockSize",
	  "OBlockSize",
	  "border",
	  "MozBorder",
	  "WebkitBorder",
	  "MSBorder",
	  "OBorder",
	  "borderBlockEnd",
	  "MozBorderBlockEnd",
	  "WebkitBorderBlockEnd",
	  "MSBorderBlockEnd",
	  "OBorderBlockEnd",
	  "borderBlockEndColor",
	  "MozBorderBlockEndColor",
	  "WebkitBorderBlockEndColor",
	  "MSBorderBlockEndColor",
	  "OBorderBlockEndColor",
	  "borderBlockEndStyle",
	  "MozBorderBlockEndStyle",
	  "WebkitBorderBlockEndStyle",
	  "MSBorderBlockEndStyle",
	  "OBorderBlockEndStyle",
	  "borderBlockEndWidth",
	  "MozBorderBlockEndWidth",
	  "WebkitBorderBlockEndWidth",
	  "MSBorderBlockEndWidth",
	  "OBorderBlockEndWidth",
	  "borderBlockStart",
	  "MozBorderBlockStart",
	  "WebkitBorderBlockStart",
	  "MSBorderBlockStart",
	  "OBorderBlockStart",
	  "borderBlockStartColor",
	  "MozBorderBlockStartColor",
	  "WebkitBorderBlockStartColor",
	  "MSBorderBlockStartColor",
	  "OBorderBlockStartColor",
	  "borderBlockStartStyle",
	  "MozBorderBlockStartStyle",
	  "WebkitBorderBlockStartStyle",
	  "MSBorderBlockStartStyle",
	  "OBorderBlockStartStyle",
	  "borderBlockStartWidth",
	  "MozBorderBlockStartWidth",
	  "WebkitBorderBlockStartWidth",
	  "MSBorderBlockStartWidth",
	  "OBorderBlockStartWidth",
	  "borderBottom",
	  "MozBorderBottom",
	  "WebkitBorderBottom",
	  "MSBorderBottom",
	  "OBorderBottom",
	  "borderBottomColor",
	  "MozBorderBottomColor",
	  "WebkitBorderBottomColor",
	  "MSBorderBottomColor",
	  "OBorderBottomColor",
	  "borderBottomLeftRadius",
	  "MozBorderBottomLeftRadius",
	  "WebkitBorderBottomLeftRadius",
	  "MSBorderBottomLeftRadius",
	  "OBorderBottomLeftRadius",
	  "borderBottomRightRadius",
	  "MozBorderBottomRightRadius",
	  "WebkitBorderBottomRightRadius",
	  "MSBorderBottomRightRadius",
	  "OBorderBottomRightRadius",
	  "borderBottomStyle",
	  "MozBorderBottomStyle",
	  "WebkitBorderBottomStyle",
	  "MSBorderBottomStyle",
	  "OBorderBottomStyle",
	  "borderBottomWidth",
	  "MozBorderBottomWidth",
	  "WebkitBorderBottomWidth",
	  "MSBorderBottomWidth",
	  "OBorderBottomWidth",
	  "borderCollapse",
	  "MozBorderCollapse",
	  "WebkitBorderCollapse",
	  "MSBorderCollapse",
	  "OBorderCollapse",
	  "borderColor",
	  "MozBorderColor",
	  "WebkitBorderColor",
	  "MSBorderColor",
	  "OBorderColor",
	  "borderImage",
	  "MozBorderImage",
	  "WebkitBorderImage",
	  "MSBorderImage",
	  "OBorderImage",
	  "borderImageOutset",
	  "MozBorderImageOutset",
	  "WebkitBorderImageOutset",
	  "MSBorderImageOutset",
	  "OBorderImageOutset",
	  "borderImageRepeat",
	  "MozBorderImageRepeat",
	  "WebkitBorderImageRepeat",
	  "MSBorderImageRepeat",
	  "OBorderImageRepeat",
	  "borderImageSlice",
	  "MozBorderImageSlice",
	  "WebkitBorderImageSlice",
	  "MSBorderImageSlice",
	  "OBorderImageSlice",
	  "borderImageSource",
	  "MozBorderImageSource",
	  "WebkitBorderImageSource",
	  "MSBorderImageSource",
	  "OBorderImageSource",
	  "borderImageWidth",
	  "MozBorderImageWidth",
	  "WebkitBorderImageWidth",
	  "MSBorderImageWidth",
	  "OBorderImageWidth",
	  "borderInlineEnd",
	  "MozBorderInlineEnd",
	  "WebkitBorderInlineEnd",
	  "MSBorderInlineEnd",
	  "OBorderInlineEnd",
	  "borderInlineEndColor",
	  "MozBorderInlineEndColor",
	  "WebkitBorderInlineEndColor",
	  "MSBorderInlineEndColor",
	  "OBorderInlineEndColor",
	  "borderInlineEndStyle",
	  "MozBorderInlineEndStyle",
	  "WebkitBorderInlineEndStyle",
	  "MSBorderInlineEndStyle",
	  "OBorderInlineEndStyle",
	  "borderInlineEndWidth",
	  "MozBorderInlineEndWidth",
	  "WebkitBorderInlineEndWidth",
	  "MSBorderInlineEndWidth",
	  "OBorderInlineEndWidth",
	  "borderInlineStart",
	  "MozBorderInlineStart",
	  "WebkitBorderInlineStart",
	  "MSBorderInlineStart",
	  "OBorderInlineStart",
	  "borderInlineStartColor",
	  "MozBorderInlineStartColor",
	  "WebkitBorderInlineStartColor",
	  "MSBorderInlineStartColor",
	  "OBorderInlineStartColor",
	  "borderInlineStartStyle",
	  "MozBorderInlineStartStyle",
	  "WebkitBorderInlineStartStyle",
	  "MSBorderInlineStartStyle",
	  "OBorderInlineStartStyle",
	  "borderInlineStartWidth",
	  "MozBorderInlineStartWidth",
	  "WebkitBorderInlineStartWidth",
	  "MSBorderInlineStartWidth",
	  "OBorderInlineStartWidth",
	  "borderLeft",
	  "MozBorderLeft",
	  "WebkitBorderLeft",
	  "MSBorderLeft",
	  "OBorderLeft",
	  "borderLeftColor",
	  "MozBorderLeftColor",
	  "WebkitBorderLeftColor",
	  "MSBorderLeftColor",
	  "OBorderLeftColor",
	  "borderLeftStyle",
	  "MozBorderLeftStyle",
	  "WebkitBorderLeftStyle",
	  "MSBorderLeftStyle",
	  "OBorderLeftStyle",
	  "borderLeftWidth",
	  "MozBorderLeftWidth",
	  "WebkitBorderLeftWidth",
	  "MSBorderLeftWidth",
	  "OBorderLeftWidth",
	  "borderRadius",
	  "MozBorderRadius",
	  "WebkitBorderRadius",
	  "MSBorderRadius",
	  "OBorderRadius",
	  "borderRight",
	  "MozBorderRight",
	  "WebkitBorderRight",
	  "MSBorderRight",
	  "OBorderRight",
	  "borderRightColor",
	  "MozBorderRightColor",
	  "WebkitBorderRightColor",
	  "MSBorderRightColor",
	  "OBorderRightColor",
	  "borderRightStyle",
	  "MozBorderRightStyle",
	  "WebkitBorderRightStyle",
	  "MSBorderRightStyle",
	  "OBorderRightStyle",
	  "borderRightWidth",
	  "MozBorderRightWidth",
	  "WebkitBorderRightWidth",
	  "MSBorderRightWidth",
	  "OBorderRightWidth",
	  "borderSpacing",
	  "MozBorderSpacing",
	  "WebkitBorderSpacing",
	  "MSBorderSpacing",
	  "OBorderSpacing",
	  "borderStyle",
	  "MozBorderStyle",
	  "WebkitBorderStyle",
	  "MSBorderStyle",
	  "OBorderStyle",
	  "borderTop",
	  "MozBorderTop",
	  "WebkitBorderTop",
	  "MSBorderTop",
	  "OBorderTop",
	  "borderTopColor",
	  "MozBorderTopColor",
	  "WebkitBorderTopColor",
	  "MSBorderTopColor",
	  "OBorderTopColor",
	  "borderTopLeftRadius",
	  "MozBorderTopLeftRadius",
	  "WebkitBorderTopLeftRadius",
	  "MSBorderTopLeftRadius",
	  "OBorderTopLeftRadius",
	  "borderTopRightRadius",
	  "MozBorderTopRightRadius",
	  "WebkitBorderTopRightRadius",
	  "MSBorderTopRightRadius",
	  "OBorderTopRightRadius",
	  "borderTopStyle",
	  "MozBorderTopStyle",
	  "WebkitBorderTopStyle",
	  "MSBorderTopStyle",
	  "OBorderTopStyle",
	  "borderTopWidth",
	  "MozBorderTopWidth",
	  "WebkitBorderTopWidth",
	  "MSBorderTopWidth",
	  "OBorderTopWidth",
	  "borderWidth",
	  "MozBorderWidth",
	  "WebkitBorderWidth",
	  "MSBorderWidth",
	  "OBorderWidth",
	  "bottom",
	  "MozBottom",
	  "WebkitBottom",
	  "MSBottom",
	  "OBottom",
	  "boxDecorationBreak",
	  "MozBoxDecorationBreak",
	  "WebkitBoxDecorationBreak",
	  "MSBoxDecorationBreak",
	  "OBoxDecorationBreak",
	  "boxShadow",
	  "MozBoxShadow",
	  "WebkitBoxShadow",
	  "MSBoxShadow",
	  "OBoxShadow",
	  "boxSizing",
	  "MozBoxSizing",
	  "WebkitBoxSizing",
	  "MSBoxSizing",
	  "OBoxSizing",
	  "breakAfter",
	  "MozBreakAfter",
	  "WebkitBreakAfter",
	  "MSBreakAfter",
	  "OBreakAfter",
	  "breakBefore",
	  "MozBreakBefore",
	  "WebkitBreakBefore",
	  "MSBreakBefore",
	  "OBreakBefore",
	  "breakInside",
	  "MozBreakInside",
	  "WebkitBreakInside",
	  "MSBreakInside",
	  "OBreakInside",
	  "captionSide",
	  "MozCaptionSide",
	  "WebkitCaptionSide",
	  "MSCaptionSide",
	  "OCaptionSide",
	  "caretColor",
	  "MozCaretColor",
	  "WebkitCaretColor",
	  "MSCaretColor",
	  "OCaretColor",
	  "ch",
	  "MozCh",
	  "WebkitCh",
	  "MSCh",
	  "OCh",
	  "clear",
	  "MozClear",
	  "WebkitClear",
	  "MSClear",
	  "OClear",
	  "clip",
	  "MozClip",
	  "WebkitClip",
	  "MSClip",
	  "OClip",
	  "clipPath",
	  "MozClipPath",
	  "WebkitClipPath",
	  "MSClipPath",
	  "OClipPath",
	  "cm",
	  "MozCm",
	  "WebkitCm",
	  "MSCm",
	  "OCm",
	  "color",
	  "MozColor",
	  "WebkitColor",
	  "MSColor",
	  "OColor",
	  "columnCount",
	  "MozColumnCount",
	  "WebkitColumnCount",
	  "MSColumnCount",
	  "OColumnCount",
	  "columnFill",
	  "MozColumnFill",
	  "WebkitColumnFill",
	  "MSColumnFill",
	  "OColumnFill",
	  "columnGap",
	  "MozColumnGap",
	  "WebkitColumnGap",
	  "MSColumnGap",
	  "OColumnGap",
	  "columnRule",
	  "MozColumnRule",
	  "WebkitColumnRule",
	  "MSColumnRule",
	  "OColumnRule",
	  "columnRuleColor",
	  "MozColumnRuleColor",
	  "WebkitColumnRuleColor",
	  "MSColumnRuleColor",
	  "OColumnRuleColor",
	  "columnRuleStyle",
	  "MozColumnRuleStyle",
	  "WebkitColumnRuleStyle",
	  "MSColumnRuleStyle",
	  "OColumnRuleStyle",
	  "columnRuleWidth",
	  "MozColumnRuleWidth",
	  "WebkitColumnRuleWidth",
	  "MSColumnRuleWidth",
	  "OColumnRuleWidth",
	  "columnSpan",
	  "MozColumnSpan",
	  "WebkitColumnSpan",
	  "MSColumnSpan",
	  "OColumnSpan",
	  "columnWidth",
	  "MozColumnWidth",
	  "WebkitColumnWidth",
	  "MSColumnWidth",
	  "OColumnWidth",
	  "columns",
	  "MozColumns",
	  "WebkitColumns",
	  "MSColumns",
	  "OColumns",
	  "content",
	  "MozContent",
	  "WebkitContent",
	  "MSContent",
	  "OContent",
	  "counterIncrement",
	  "MozCounterIncrement",
	  "WebkitCounterIncrement",
	  "MSCounterIncrement",
	  "OCounterIncrement",
	  "counterReset",
	  "MozCounterReset",
	  "WebkitCounterReset",
	  "MSCounterReset",
	  "OCounterReset",
	  "cursor",
	  "MozCursor",
	  "WebkitCursor",
	  "MSCursor",
	  "OCursor",
	  "deg",
	  "MozDeg",
	  "WebkitDeg",
	  "MSDeg",
	  "ODeg",
	  "direction",
	  "MozDirection",
	  "WebkitDirection",
	  "MSDirection",
	  "ODirection",
	  "display",
	  "MozDisplay",
	  "WebkitDisplay",
	  "MSDisplay",
	  "ODisplay",
	  "dpcm",
	  "MozDpcm",
	  "WebkitDpcm",
	  "MSDpcm",
	  "ODpcm",
	  "dpi",
	  "MozDpi",
	  "WebkitDpi",
	  "MSDpi",
	  "ODpi",
	  "dppx",
	  "MozDppx",
	  "WebkitDppx",
	  "MSDppx",
	  "ODppx",
	  "em",
	  "MozEm",
	  "WebkitEm",
	  "MSEm",
	  "OEm",
	  "emptyCells",
	  "MozEmptyCells",
	  "WebkitEmptyCells",
	  "MSEmptyCells",
	  "OEmptyCells",
	  "ex",
	  "MozEx",
	  "WebkitEx",
	  "MSEx",
	  "OEx",
	  "filter",
	  "MozFilter",
	  "WebkitFilter",
	  "MSFilter",
	  "OFilter",
	  "flexBasis",
	  "MozFlexBasis",
	  "WebkitFlexBasis",
	  "MSFlexBasis",
	  "OFlexBasis",
	  "flexDirection",
	  "MozFlexDirection",
	  "WebkitFlexDirection",
	  "MSFlexDirection",
	  "OFlexDirection",
	  "flexFlow",
	  "MozFlexFlow",
	  "WebkitFlexFlow",
	  "MSFlexFlow",
	  "OFlexFlow",
	  "flexGrow",
	  "MozFlexGrow",
	  "WebkitFlexGrow",
	  "MSFlexGrow",
	  "OFlexGrow",
	  "flexShrink",
	  "MozFlexShrink",
	  "WebkitFlexShrink",
	  "MSFlexShrink",
	  "OFlexShrink",
	  "flexWrap",
	  "MozFlexWrap",
	  "WebkitFlexWrap",
	  "MSFlexWrap",
	  "OFlexWrap",
	  "float",
	  "MozFloat",
	  "WebkitFloat",
	  "MSFloat",
	  "OFloat",
	  "font",
	  "MozFont",
	  "WebkitFont",
	  "MSFont",
	  "OFont",
	  "fontFamily",
	  "MozFontFamily",
	  "WebkitFontFamily",
	  "MSFontFamily",
	  "OFontFamily",
	  "fontFeatureSettings",
	  "MozFontFeatureSettings",
	  "WebkitFontFeatureSettings",
	  "MSFontFeatureSettings",
	  "OFontFeatureSettings",
	  "fontKerning",
	  "MozFontKerning",
	  "WebkitFontKerning",
	  "MSFontKerning",
	  "OFontKerning",
	  "fontLanguageOverride",
	  "MozFontLanguageOverride",
	  "WebkitFontLanguageOverride",
	  "MSFontLanguageOverride",
	  "OFontLanguageOverride",
	  "fontSize",
	  "MozFontSize",
	  "WebkitFontSize",
	  "MSFontSize",
	  "OFontSize",
	  "fontSizeAdjust",
	  "MozFontSizeAdjust",
	  "WebkitFontSizeAdjust",
	  "MSFontSizeAdjust",
	  "OFontSizeAdjust",
	  "fontStretch",
	  "MozFontStretch",
	  "WebkitFontStretch",
	  "MSFontStretch",
	  "OFontStretch",
	  "fontStyle",
	  "MozFontStyle",
	  "WebkitFontStyle",
	  "MSFontStyle",
	  "OFontStyle",
	  "fontSynthesis",
	  "MozFontSynthesis",
	  "WebkitFontSynthesis",
	  "MSFontSynthesis",
	  "OFontSynthesis",
	  "fontVariant",
	  "MozFontVariant",
	  "WebkitFontVariant",
	  "MSFontVariant",
	  "OFontVariant",
	  "fontVariantAlternates",
	  "MozFontVariantAlternates",
	  "WebkitFontVariantAlternates",
	  "MSFontVariantAlternates",
	  "OFontVariantAlternates",
	  "fontVariantCaps",
	  "MozFontVariantCaps",
	  "WebkitFontVariantCaps",
	  "MSFontVariantCaps",
	  "OFontVariantCaps",
	  "fontVariantEastAsian",
	  "MozFontVariantEastAsian",
	  "WebkitFontVariantEastAsian",
	  "MSFontVariantEastAsian",
	  "OFontVariantEastAsian",
	  "fontVariantLigatures",
	  "MozFontVariantLigatures",
	  "WebkitFontVariantLigatures",
	  "MSFontVariantLigatures",
	  "OFontVariantLigatures",
	  "fontVariantNumeric",
	  "MozFontVariantNumeric",
	  "WebkitFontVariantNumeric",
	  "MSFontVariantNumeric",
	  "OFontVariantNumeric",
	  "fontVariantPosition",
	  "MozFontVariantPosition",
	  "WebkitFontVariantPosition",
	  "MSFontVariantPosition",
	  "OFontVariantPosition",
	  "fontWeight",
	  "MozFontWeight",
	  "WebkitFontWeight",
	  "MSFontWeight",
	  "OFontWeight",
	  "fr",
	  "MozFr",
	  "WebkitFr",
	  "MSFr",
	  "OFr",
	  "grad",
	  "MozGrad",
	  "WebkitGrad",
	  "MSGrad",
	  "OGrad",
	  "grid",
	  "MozGrid",
	  "WebkitGrid",
	  "MSGrid",
	  "OGrid",
	  "gridArea",
	  "MozGridArea",
	  "WebkitGridArea",
	  "MSGridArea",
	  "OGridArea",
	  "gridAutoColumns",
	  "MozGridAutoColumns",
	  "WebkitGridAutoColumns",
	  "MSGridAutoColumns",
	  "OGridAutoColumns",
	  "gridAutoFlow",
	  "MozGridAutoFlow",
	  "WebkitGridAutoFlow",
	  "MSGridAutoFlow",
	  "OGridAutoFlow",
	  "gridAutoRows",
	  "MozGridAutoRows",
	  "WebkitGridAutoRows",
	  "MSGridAutoRows",
	  "OGridAutoRows",
	  "gridColumn",
	  "MozGridColumn",
	  "WebkitGridColumn",
	  "MSGridColumn",
	  "OGridColumn",
	  "gridColumnEnd",
	  "MozGridColumnEnd",
	  "WebkitGridColumnEnd",
	  "MSGridColumnEnd",
	  "OGridColumnEnd",
	  "gridColumnGap",
	  "MozGridColumnGap",
	  "WebkitGridColumnGap",
	  "MSGridColumnGap",
	  "OGridColumnGap",
	  "gridColumnStart",
	  "MozGridColumnStart",
	  "WebkitGridColumnStart",
	  "MSGridColumnStart",
	  "OGridColumnStart",
	  "gridGap",
	  "MozGridGap",
	  "WebkitGridGap",
	  "MSGridGap",
	  "OGridGap",
	  "gridRow",
	  "MozGridRow",
	  "WebkitGridRow",
	  "MSGridRow",
	  "OGridRow",
	  "gridRowEnd",
	  "MozGridRowEnd",
	  "WebkitGridRowEnd",
	  "MSGridRowEnd",
	  "OGridRowEnd",
	  "gridRowGap",
	  "MozGridRowGap",
	  "WebkitGridRowGap",
	  "MSGridRowGap",
	  "OGridRowGap",
	  "gridRowStart",
	  "MozGridRowStart",
	  "WebkitGridRowStart",
	  "MSGridRowStart",
	  "OGridRowStart",
	  "gridTemplate",
	  "MozGridTemplate",
	  "WebkitGridTemplate",
	  "MSGridTemplate",
	  "OGridTemplate",
	  "gridTemplateAreas",
	  "MozGridTemplateAreas",
	  "WebkitGridTemplateAreas",
	  "MSGridTemplateAreas",
	  "OGridTemplateAreas",
	  "gridTemplateColumns",
	  "MozGridTemplateColumns",
	  "WebkitGridTemplateColumns",
	  "MSGridTemplateColumns",
	  "OGridTemplateColumns",
	  "gridTemplateRows",
	  "MozGridTemplateRows",
	  "WebkitGridTemplateRows",
	  "MSGridTemplateRows",
	  "OGridTemplateRows",
	  "height",
	  "MozHeight",
	  "WebkitHeight",
	  "MSHeight",
	  "OHeight",
	  "hyphens",
	  "MozHyphens",
	  "WebkitHyphens",
	  "MSHyphens",
	  "OHyphens",
	  "hz",
	  "MozHz",
	  "WebkitHz",
	  "MSHz",
	  "OHz",
	  "imageOrientation",
	  "MozImageOrientation",
	  "WebkitImageOrientation",
	  "MSImageOrientation",
	  "OImageOrientation",
	  "imageRendering",
	  "MozImageRendering",
	  "WebkitImageRendering",
	  "MSImageRendering",
	  "OImageRendering",
	  "imageResolution",
	  "MozImageResolution",
	  "WebkitImageResolution",
	  "MSImageResolution",
	  "OImageResolution",
	  "imeMode",
	  "MozImeMode",
	  "WebkitImeMode",
	  "MSImeMode",
	  "OImeMode",
	  "in",
	  "MozIn",
	  "WebkitIn",
	  "MSIn",
	  "OIn",
	  "inherit",
	  "MozInherit",
	  "WebkitInherit",
	  "MSInherit",
	  "OInherit",
	  "initial",
	  "MozInitial",
	  "WebkitInitial",
	  "MSInitial",
	  "OInitial",
	  "inlineSize",
	  "MozInlineSize",
	  "WebkitInlineSize",
	  "MSInlineSize",
	  "OInlineSize",
	  "isolation",
	  "MozIsolation",
	  "WebkitIsolation",
	  "MSIsolation",
	  "OIsolation",
	  "justifyContent",
	  "MozJustifyContent",
	  "WebkitJustifyContent",
	  "MSJustifyContent",
	  "OJustifyContent",
	  "khz",
	  "MozKhz",
	  "WebkitKhz",
	  "MSKhz",
	  "OKhz",
	  "left",
	  "MozLeft",
	  "WebkitLeft",
	  "MSLeft",
	  "OLeft",
	  "letterSpacing",
	  "MozLetterSpacing",
	  "WebkitLetterSpacing",
	  "MSLetterSpacing",
	  "OLetterSpacing",
	  "lineBreak",
	  "MozLineBreak",
	  "WebkitLineBreak",
	  "MSLineBreak",
	  "OLineBreak",
	  "lineHeight",
	  "MozLineHeight",
	  "WebkitLineHeight",
	  "MSLineHeight",
	  "OLineHeight",
	  "listStyle",
	  "MozListStyle",
	  "WebkitListStyle",
	  "MSListStyle",
	  "OListStyle",
	  "listStyleImage",
	  "MozListStyleImage",
	  "WebkitListStyleImage",
	  "MSListStyleImage",
	  "OListStyleImage",
	  "listStylePosition",
	  "MozListStylePosition",
	  "WebkitListStylePosition",
	  "MSListStylePosition",
	  "OListStylePosition",
	  "listStyleType",
	  "MozListStyleType",
	  "WebkitListStyleType",
	  "MSListStyleType",
	  "OListStyleType",
	  "margin",
	  "MozMargin",
	  "WebkitMargin",
	  "MSMargin",
	  "OMargin",
	  "marginBlockEnd",
	  "MozMarginBlockEnd",
	  "WebkitMarginBlockEnd",
	  "MSMarginBlockEnd",
	  "OMarginBlockEnd",
	  "marginBlockStart",
	  "MozMarginBlockStart",
	  "WebkitMarginBlockStart",
	  "MSMarginBlockStart",
	  "OMarginBlockStart",
	  "marginBottom",
	  "MozMarginBottom",
	  "WebkitMarginBottom",
	  "MSMarginBottom",
	  "OMarginBottom",
	  "marginInlineEnd",
	  "MozMarginInlineEnd",
	  "WebkitMarginInlineEnd",
	  "MSMarginInlineEnd",
	  "OMarginInlineEnd",
	  "marginInlineStart",
	  "MozMarginInlineStart",
	  "WebkitMarginInlineStart",
	  "MSMarginInlineStart",
	  "OMarginInlineStart",
	  "marginLeft",
	  "MozMarginLeft",
	  "WebkitMarginLeft",
	  "MSMarginLeft",
	  "OMarginLeft",
	  "marginRight",
	  "MozMarginRight",
	  "WebkitMarginRight",
	  "MSMarginRight",
	  "OMarginRight",
	  "marginTop",
	  "MozMarginTop",
	  "WebkitMarginTop",
	  "MSMarginTop",
	  "OMarginTop",
	  "mask",
	  "MozMask",
	  "WebkitMask",
	  "MSMask",
	  "OMask",
	  "maskClip",
	  "MozMaskClip",
	  "WebkitMaskClip",
	  "MSMaskClip",
	  "OMaskClip",
	  "maskComposite",
	  "MozMaskComposite",
	  "WebkitMaskComposite",
	  "MSMaskComposite",
	  "OMaskComposite",
	  "maskImage",
	  "MozMaskImage",
	  "WebkitMaskImage",
	  "MSMaskImage",
	  "OMaskImage",
	  "maskMode",
	  "MozMaskMode",
	  "WebkitMaskMode",
	  "MSMaskMode",
	  "OMaskMode",
	  "maskOrigin",
	  "MozMaskOrigin",
	  "WebkitMaskOrigin",
	  "MSMaskOrigin",
	  "OMaskOrigin",
	  "maskPosition",
	  "MozMaskPosition",
	  "WebkitMaskPosition",
	  "MSMaskPosition",
	  "OMaskPosition",
	  "maskRepeat",
	  "MozMaskRepeat",
	  "WebkitMaskRepeat",
	  "MSMaskRepeat",
	  "OMaskRepeat",
	  "maskSize",
	  "MozMaskSize",
	  "WebkitMaskSize",
	  "MSMaskSize",
	  "OMaskSize",
	  "maskType",
	  "MozMaskType",
	  "WebkitMaskType",
	  "MSMaskType",
	  "OMaskType",
	  "maxHeight",
	  "MozMaxHeight",
	  "WebkitMaxHeight",
	  "MSMaxHeight",
	  "OMaxHeight",
	  "maxWidth",
	  "MozMaxWidth",
	  "WebkitMaxWidth",
	  "MSMaxWidth",
	  "OMaxWidth",
	  "minBlockSize",
	  "MozMinBlockSize",
	  "WebkitMinBlockSize",
	  "MSMinBlockSize",
	  "OMinBlockSize",
	  "minHeight",
	  "MozMinHeight",
	  "WebkitMinHeight",
	  "MSMinHeight",
	  "OMinHeight",
	  "minInlineSize",
	  "MozMinInlineSize",
	  "WebkitMinInlineSize",
	  "MSMinInlineSize",
	  "OMinInlineSize",
	  "minWidth",
	  "MozMinWidth",
	  "WebkitMinWidth",
	  "MSMinWidth",
	  "OMinWidth",
	  "mixBlendMode",
	  "MozMixBlendMode",
	  "WebkitMixBlendMode",
	  "MSMixBlendMode",
	  "OMixBlendMode",
	  "mm",
	  "MozMm",
	  "WebkitMm",
	  "MSMm",
	  "OMm",
	  "ms",
	  "MozMs",
	  "WebkitMs",
	  "MSMs",
	  "OMs",
	  "objectFit",
	  "MozObjectFit",
	  "WebkitObjectFit",
	  "MSObjectFit",
	  "OObjectFit",
	  "objectPosition",
	  "MozObjectPosition",
	  "WebkitObjectPosition",
	  "MSObjectPosition",
	  "OObjectPosition",
	  "offsetBlockEnd",
	  "MozOffsetBlockEnd",
	  "WebkitOffsetBlockEnd",
	  "MSOffsetBlockEnd",
	  "OOffsetBlockEnd",
	  "offsetBlockStart",
	  "MozOffsetBlockStart",
	  "WebkitOffsetBlockStart",
	  "MSOffsetBlockStart",
	  "OOffsetBlockStart",
	  "offsetInlineEnd",
	  "MozOffsetInlineEnd",
	  "WebkitOffsetInlineEnd",
	  "MSOffsetInlineEnd",
	  "OOffsetInlineEnd",
	  "offsetInlineStart",
	  "MozOffsetInlineStart",
	  "WebkitOffsetInlineStart",
	  "MSOffsetInlineStart",
	  "OOffsetInlineStart",
	  "opacity",
	  "MozOpacity",
	  "WebkitOpacity",
	  "MSOpacity",
	  "OOpacity",
	  "order",
	  "MozOrder",
	  "WebkitOrder",
	  "MSOrder",
	  "OOrder",
	  "orphans",
	  "MozOrphans",
	  "WebkitOrphans",
	  "MSOrphans",
	  "OOrphans",
	  "outline",
	  "MozOutline",
	  "WebkitOutline",
	  "MSOutline",
	  "OOutline",
	  "outlineColor",
	  "MozOutlineColor",
	  "WebkitOutlineColor",
	  "MSOutlineColor",
	  "OOutlineColor",
	  "outlineOffset",
	  "MozOutlineOffset",
	  "WebkitOutlineOffset",
	  "MSOutlineOffset",
	  "OOutlineOffset",
	  "outlineStyle",
	  "MozOutlineStyle",
	  "WebkitOutlineStyle",
	  "MSOutlineStyle",
	  "OOutlineStyle",
	  "outlineWidth",
	  "MozOutlineWidth",
	  "WebkitOutlineWidth",
	  "MSOutlineWidth",
	  "OOutlineWidth",
	  "overflow",
	  "MozOverflow",
	  "WebkitOverflow",
	  "MSOverflow",
	  "OOverflow",
	  "overflowWrap",
	  "MozOverflowWrap",
	  "WebkitOverflowWrap",
	  "MSOverflowWrap",
	  "OOverflowWrap",
	  "overflowX",
	  "MozOverflowX",
	  "WebkitOverflowX",
	  "MSOverflowX",
	  "OOverflowX",
	  "overflowY",
	  "MozOverflowY",
	  "WebkitOverflowY",
	  "MSOverflowY",
	  "OOverflowY",
	  "padding",
	  "MozPadding",
	  "WebkitPadding",
	  "MSPadding",
	  "OPadding",
	  "paddingBlockEnd",
	  "MozPaddingBlockEnd",
	  "WebkitPaddingBlockEnd",
	  "MSPaddingBlockEnd",
	  "OPaddingBlockEnd",
	  "paddingBlockStart",
	  "MozPaddingBlockStart",
	  "WebkitPaddingBlockStart",
	  "MSPaddingBlockStart",
	  "OPaddingBlockStart",
	  "paddingBottom",
	  "MozPaddingBottom",
	  "WebkitPaddingBottom",
	  "MSPaddingBottom",
	  "OPaddingBottom",
	  "paddingInlineEnd",
	  "MozPaddingInlineEnd",
	  "WebkitPaddingInlineEnd",
	  "MSPaddingInlineEnd",
	  "OPaddingInlineEnd",
	  "paddingInlineStart",
	  "MozPaddingInlineStart",
	  "WebkitPaddingInlineStart",
	  "MSPaddingInlineStart",
	  "OPaddingInlineStart",
	  "paddingLeft",
	  "MozPaddingLeft",
	  "WebkitPaddingLeft",
	  "MSPaddingLeft",
	  "OPaddingLeft",
	  "paddingRight",
	  "MozPaddingRight",
	  "WebkitPaddingRight",
	  "MSPaddingRight",
	  "OPaddingRight",
	  "paddingTop",
	  "MozPaddingTop",
	  "WebkitPaddingTop",
	  "MSPaddingTop",
	  "OPaddingTop",
	  "pageBreakAfter",
	  "MozPageBreakAfter",
	  "WebkitPageBreakAfter",
	  "MSPageBreakAfter",
	  "OPageBreakAfter",
	  "pageBreakBefore",
	  "MozPageBreakBefore",
	  "WebkitPageBreakBefore",
	  "MSPageBreakBefore",
	  "OPageBreakBefore",
	  "pageBreakInside",
	  "MozPageBreakInside",
	  "WebkitPageBreakInside",
	  "MSPageBreakInside",
	  "OPageBreakInside",
	  "pc",
	  "MozPc",
	  "WebkitPc",
	  "MSPc",
	  "OPc",
	  "perspective",
	  "MozPerspective",
	  "WebkitPerspective",
	  "MSPerspective",
	  "OPerspective",
	  "perspectiveOrigin",
	  "MozPerspectiveOrigin",
	  "WebkitPerspectiveOrigin",
	  "MSPerspectiveOrigin",
	  "OPerspectiveOrigin",
	  "pointerEvents",
	  "MozPointerEvents",
	  "WebkitPointerEvents",
	  "MSPointerEvents",
	  "OPointerEvents",
	  "position",
	  "MozPosition",
	  "WebkitPosition",
	  "MSPosition",
	  "OPosition",
	  "pt",
	  "MozPt",
	  "WebkitPt",
	  "MSPt",
	  "OPt",
	  "px",
	  "MozPx",
	  "WebkitPx",
	  "MSPx",
	  "OPx",
	  "q",
	  "MozQ",
	  "WebkitQ",
	  "MSQ",
	  "OQ",
	  "quotes",
	  "MozQuotes",
	  "WebkitQuotes",
	  "MSQuotes",
	  "OQuotes",
	  "rad",
	  "MozRad",
	  "WebkitRad",
	  "MSRad",
	  "ORad",
	  "rem",
	  "MozRem",
	  "WebkitRem",
	  "MSRem",
	  "ORem",
	  "resize",
	  "MozResize",
	  "WebkitResize",
	  "MSResize",
	  "OResize",
	  "revert",
	  "MozRevert",
	  "WebkitRevert",
	  "MSRevert",
	  "ORevert",
	  "right",
	  "MozRight",
	  "WebkitRight",
	  "MSRight",
	  "ORight",
	  "rubyAlign",
	  "MozRubyAlign",
	  "WebkitRubyAlign",
	  "MSRubyAlign",
	  "ORubyAlign",
	  "rubyMerge",
	  "MozRubyMerge",
	  "WebkitRubyMerge",
	  "MSRubyMerge",
	  "ORubyMerge",
	  "rubyPosition",
	  "MozRubyPosition",
	  "WebkitRubyPosition",
	  "MSRubyPosition",
	  "ORubyPosition",
	  "s",
	  "MozS",
	  "WebkitS",
	  "MSS",
	  "OS",
	  "scrollBehavior",
	  "MozScrollBehavior",
	  "WebkitScrollBehavior",
	  "MSScrollBehavior",
	  "OScrollBehavior",
	  "scrollSnapCoordinate",
	  "MozScrollSnapCoordinate",
	  "WebkitScrollSnapCoordinate",
	  "MSScrollSnapCoordinate",
	  "OScrollSnapCoordinate",
	  "scrollSnapDestination",
	  "MozScrollSnapDestination",
	  "WebkitScrollSnapDestination",
	  "MSScrollSnapDestination",
	  "OScrollSnapDestination",
	  "scrollSnapType",
	  "MozScrollSnapType",
	  "WebkitScrollSnapType",
	  "MSScrollSnapType",
	  "OScrollSnapType",
	  "shapeImageThreshold",
	  "MozShapeImageThreshold",
	  "WebkitShapeImageThreshold",
	  "MSShapeImageThreshold",
	  "OShapeImageThreshold",
	  "shapeMargin",
	  "MozShapeMargin",
	  "WebkitShapeMargin",
	  "MSShapeMargin",
	  "OShapeMargin",
	  "shapeOutside",
	  "MozShapeOutside",
	  "WebkitShapeOutside",
	  "MSShapeOutside",
	  "OShapeOutside",
	  "tabSize",
	  "MozTabSize",
	  "WebkitTabSize",
	  "MSTabSize",
	  "OTabSize",
	  "tableLayout",
	  "MozTableLayout",
	  "WebkitTableLayout",
	  "MSTableLayout",
	  "OTableLayout",
	  "textAlign",
	  "MozTextAlign",
	  "WebkitTextAlign",
	  "MSTextAlign",
	  "OTextAlign",
	  "textAlignLast",
	  "MozTextAlignLast",
	  "WebkitTextAlignLast",
	  "MSTextAlignLast",
	  "OTextAlignLast",
	  "textCombineUpright",
	  "MozTextCombineUpright",
	  "WebkitTextCombineUpright",
	  "MSTextCombineUpright",
	  "OTextCombineUpright",
	  "textDecoration",
	  "MozTextDecoration",
	  "WebkitTextDecoration",
	  "MSTextDecoration",
	  "OTextDecoration",
	  "textDecorationColor",
	  "MozTextDecorationColor",
	  "WebkitTextDecorationColor",
	  "MSTextDecorationColor",
	  "OTextDecorationColor",
	  "textDecorationLine",
	  "MozTextDecorationLine",
	  "WebkitTextDecorationLine",
	  "MSTextDecorationLine",
	  "OTextDecorationLine",
	  "textDecorationStyle",
	  "MozTextDecorationStyle",
	  "WebkitTextDecorationStyle",
	  "MSTextDecorationStyle",
	  "OTextDecorationStyle",
	  "textEmphasis",
	  "MozTextEmphasis",
	  "WebkitTextEmphasis",
	  "MSTextEmphasis",
	  "OTextEmphasis",
	  "textEmphasisColor",
	  "MozTextEmphasisColor",
	  "WebkitTextEmphasisColor",
	  "MSTextEmphasisColor",
	  "OTextEmphasisColor",
	  "textEmphasisPosition",
	  "MozTextEmphasisPosition",
	  "WebkitTextEmphasisPosition",
	  "MSTextEmphasisPosition",
	  "OTextEmphasisPosition",
	  "textEmphasisStyle",
	  "MozTextEmphasisStyle",
	  "WebkitTextEmphasisStyle",
	  "MSTextEmphasisStyle",
	  "OTextEmphasisStyle",
	  "textIndent",
	  "MozTextIndent",
	  "WebkitTextIndent",
	  "MSTextIndent",
	  "OTextIndent",
	  "textOrientation",
	  "MozTextOrientation",
	  "WebkitTextOrientation",
	  "MSTextOrientation",
	  "OTextOrientation",
	  "textOverflow",
	  "MozTextOverflow",
	  "WebkitTextOverflow",
	  "MSTextOverflow",
	  "OTextOverflow",
	  "textRendering",
	  "MozTextRendering",
	  "WebkitTextRendering",
	  "MSTextRendering",
	  "OTextRendering",
	  "textShadow",
	  "MozTextShadow",
	  "WebkitTextShadow",
	  "MSTextShadow",
	  "OTextShadow",
	  "textTransform",
	  "MozTextTransform",
	  "WebkitTextTransform",
	  "MSTextTransform",
	  "OTextTransform",
	  "textUnderlinePosition",
	  "MozTextUnderlinePosition",
	  "WebkitTextUnderlinePosition",
	  "MSTextUnderlinePosition",
	  "OTextUnderlinePosition",
	  "top",
	  "MozTop",
	  "WebkitTop",
	  "MSTop",
	  "OTop",
	  "touchAction",
	  "MozTouchAction",
	  "WebkitTouchAction",
	  "MSTouchAction",
	  "OTouchAction",
	  "transform",
	  "MozTransform",
	  "WebkitTransform",
	  "msTransform",
	  "OTransform",
	  "transformBox",
	  "MozTransformBox",
	  "WebkitTransformBox",
	  "MSTransformBox",
	  "OTransformBox",
	  "transformOrigin",
	  "MozTransformOrigin",
	  "WebkitTransformOrigin",
	  "MSTransformOrigin",
	  "OTransformOrigin",
	  "transformStyle",
	  "MozTransformStyle",
	  "WebkitTransformStyle",
	  "MSTransformStyle",
	  "OTransformStyle",
	  "transition",
	  "MozTransition",
	  "WebkitTransition",
	  "MSTransition",
	  "OTransition",
	  "transitionDelay",
	  "MozTransitionDelay",
	  "WebkitTransitionDelay",
	  "MSTransitionDelay",
	  "OTransitionDelay",
	  "transitionDuration",
	  "MozTransitionDuration",
	  "WebkitTransitionDuration",
	  "MSTransitionDuration",
	  "OTransitionDuration",
	  "transitionProperty",
	  "MozTransitionProperty",
	  "WebkitTransitionProperty",
	  "MSTransitionProperty",
	  "OTransitionProperty",
	  "transitionTimingFunction",
	  "MozTransitionTimingFunction",
	  "WebkitTransitionTimingFunction",
	  "MSTransitionTimingFunction",
	  "OTransitionTimingFunction",
	  "turn",
	  "MozTurn",
	  "WebkitTurn",
	  "MSTurn",
	  "OTurn",
	  "unicodeBidi",
	  "MozUnicodeBidi",
	  "WebkitUnicodeBidi",
	  "MSUnicodeBidi",
	  "OUnicodeBidi",
	  "unset",
	  "MozUnset",
	  "WebkitUnset",
	  "MSUnset",
	  "OUnset",
	  "verticalAlign",
	  "MozVerticalAlign",
	  "WebkitVerticalAlign",
	  "MSVerticalAlign",
	  "OVerticalAlign",
	  "vh",
	  "MozVh",
	  "WebkitVh",
	  "MSVh",
	  "OVh",
	  "visibility",
	  "MozVisibility",
	  "WebkitVisibility",
	  "MSVisibility",
	  "OVisibility",
	  "vmax",
	  "MozVmax",
	  "WebkitVmax",
	  "MSVmax",
	  "OVmax",
	  "vmin",
	  "MozVmin",
	  "WebkitVmin",
	  "MSVmin",
	  "OVmin",
	  "vw",
	  "MozVw",
	  "WebkitVw",
	  "MSVw",
	  "OVw",
	  "whiteSpace",
	  "MozWhiteSpace",
	  "WebkitWhiteSpace",
	  "MSWhiteSpace",
	  "OWhiteSpace",
	  "widows",
	  "MozWidows",
	  "WebkitWidows",
	  "MSWidows",
	  "OWidows",
	  "width",
	  "MozWidth",
	  "WebkitWidth",
	  "MSWidth",
	  "OWidth",
	  "willChange",
	  "MozWillChange",
	  "WebkitWillChange",
	  "MSWillChange",
	  "OWillChange",
	  "wordBreak",
	  "MozWordBreak",
	  "WebkitWordBreak",
	  "MSWordBreak",
	  "OWordBreak",
	  "wordSpacing",
	  "MozWordSpacing",
	  "WebkitWordSpacing",
	  "MSWordSpacing",
	  "OWordSpacing",
	  "wordWrap",
	  "MozWordWrap",
	  "WebkitWordWrap",
	  "MSWordWrap",
	  "OWordWrap",
	  "writingMode",
	  "MozWritingMode",
	  "WebkitWritingMode",
	  "MSWritingMode",
	  "OWritingMode",
	  "zIndex",
	  "MozZIndex",
	  "WebkitZIndex",
	  "MSZIndex",
	  "OZIndex",
	  "fontSize",
	  "MozFontSize",
	  "WebkitFontSize",
	  "MSFontSize",
	  "OFontSize",
	  "flex",
	  "MozFlex",
	  "WebkitFlex",
	  "MSFlex",
	  "OFlex",
	  "fr",
	  "MozFr",
	  "WebkitFr",
	  "MSFr",
	  "OFr",
	  "overflowScrolling",
	  "MozOverflowScrolling",
	  "WebkitOverflowScrolling",
	  "MSOverflowScrolling",
	  "OOverflowScrolling",
	  "userSelect",
	  "MozUserSelect",
	  "WebkitUserSelect",
	  "MSUserSelect",
	  "OUserSelect"
	]


/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	var properties = __webpack_require__(909);
	var PropTypes = __webpack_require__(4);
	
	module.exports = function(props, propName, componentName) {
	  var styles = props[propName];
	  if (!styles) {
	    return;
	  }
	
	  var failures = [];
	  Object.keys(styles).forEach(function(styleKey){
	    if (properties.indexOf(styleKey) === -1) {
	      failures.push(styleKey);
	    }
	  });
	  if (failures.length) {
	    throw new Error('Prop ' + propName + ' passed to ' + componentName + '. Has invalid keys ' + failures.join(', '));
	  }
	};
	
	module.exports.isRequired = function(props, propName, componentName) {
	  if (!props[propName]) {
	    throw new Error('Prop ' + propName + ' passed to ' + componentName + ' is required');
	  }
	  return module.exports(props, propName, componentName);
	};
	
	module.exports.supportingArrays = PropTypes.oneOfType([
	  PropTypes.arrayOf(module.exports),
	  module.exports
	]);


/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.reactTextMask=t(require("react")):e.reactTextMask=t(e.React)}(this,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.conformToMask=void 0;var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},l=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),f=r(3);Object.defineProperty(t,"conformToMask",{enumerable:!0,get:function(){return n(f).default}});var c=r(11),p=n(c),d=r(9),h=n(d),v=r(5),y=n(v),m=r(2),b=function(e){function t(){var e;i(this,t);for(var r=arguments.length,n=Array(r),o=0;o<r;o++)n[o]=arguments[o];var u=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(n)));return u.setRef=u.setRef.bind(u),u.onBlur=u.onBlur.bind(u),u.onChange=u.onChange.bind(u),u}return u(t,e),l(t,[{key:"setRef",value:function(e){this.inputElement=e}},{key:"initTextMask",value:function(){var e=this.props,t=this.props.value;this.textMaskInputElement=(0,y.default)(s({inputElement:this.inputElement},e)),this.textMaskInputElement.update(t)}},{key:"componentDidMount",value:function(){this.initTextMask()}},{key:"componentDidUpdate",value:function(e){var t=this.props,r=t.value,n=t.pipe,o=t.mask,i=t.guide,a=t.placeholderChar,u=t.showMask,s={guide:i,placeholderChar:a,showMask:u},l="function"==typeof n&&"function"==typeof e.pipe?n.toString()!==e.pipe.toString():(0,m.isNil)(n)&&!(0,m.isNil)(e.pipe)||!(0,m.isNil)(n)&&(0,m.isNil)(e.pipe),f=o.toString()!==e.mask.toString(),c=Object.keys(s).some(function(t){return s[t]!==e[t]})||f||l,p=r!==this.inputElement.value;(p||c)&&this.initTextMask()}},{key:"render",value:function e(){var t=this.props,e=t.render,r=o(t,["render"]);return delete r.mask,delete r.guide,delete r.pipe,delete r.placeholderChar,delete r.keepCharPositions,delete r.value,delete r.onBlur,delete r.onChange,delete r.showMask,e(this.setRef,s({onBlur:this.onBlur,onChange:this.onChange,defaultValue:this.props.value},r))}},{key:"onChange",value:function(e){this.textMaskInputElement.update(),"function"==typeof this.props.onChange&&this.props.onChange(e)}},{key:"onBlur",value:function(e){"function"==typeof this.props.onBlur&&this.props.onBlur(e)}}]),t}(p.default.PureComponent);t.default=b,b.propTypes={mask:h.default.oneOfType([h.default.array,h.default.func,h.default.bool,h.default.shape({mask:h.default.oneOfType([h.default.array,h.default.func]),pipe:h.default.func})]).isRequired,guide:h.default.bool,value:h.default.oneOfType([h.default.string,h.default.number]),pipe:h.default.func,placeholderChar:h.default.string,keepCharPositions:h.default.bool,showMask:h.default.bool},b.defaultProps={render:function(e,t){return p.default.createElement("input",s({ref:e},t))}}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.placeholderChar="_",t.strFunction="function"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l.placeholderChar;if(!o(e))throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");if(e.indexOf(t)!==-1)throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n"+("The placeholder character that was received is: "+JSON.stringify(t)+"\n\n")+("The mask that was received is: "+JSON.stringify(e)));return e.map(function(e){return e instanceof RegExp?t:e}).join("")}function o(e){return Array.isArray&&Array.isArray(e)||e instanceof Array}function i(e){return"string"==typeof e||e instanceof String}function a(e){return"number"==typeof e&&void 0===e.length&&!isNaN(e)}function u(e){return"undefined"==typeof e||null===e}function s(e){for(var t=[],r=void 0;r=e.indexOf(c),r!==-1;)t.push(r),e.splice(r,1);return{maskWithoutCaretTraps:e,indexes:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.convertMaskToPlaceholder=n,t.isArray=o,t.isString=i,t.isNumber=a,t.isNil=u,t.processCaretTraps=s;var l=r(1),f=[],c="[]"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!(0,i.isArray)(t)){if(("undefined"==typeof t?"undefined":o(t))!==a.strFunction)throw new Error("Text-mask:conformToMask; The mask property must be an array.");t=t(e,r),t=(0,i.processCaretTraps)(t).maskWithoutCaretTraps}var n=r.guide,l=void 0===n||n,f=r.previousConformedValue,c=void 0===f?s:f,p=r.placeholderChar,d=void 0===p?a.placeholderChar:p,h=r.placeholder,v=void 0===h?(0,i.convertMaskToPlaceholder)(t,d):h,y=r.currentCaretPosition,m=r.keepCharPositions,b=l===!1&&void 0!==c,g=e.length,k=c.length,C=v.length,O=t.length,T=g-k,P=T>0,x=y+(P?-T:0),w=x+Math.abs(T);if(m===!0&&!P){for(var S=s,_=x;_<w;_++)v[_]===d&&(S+=d);e=e.slice(0,x)+S+e.slice(x,g)}for(var M=e.split(s).map(function(e,t){return{char:e,isNew:t>=x&&t<w}}),j=g-1;j>=0;j--){var E=M[j].char;if(E!==d){var R=j>=x&&k===O;E===v[R?j-T:j]&&M.splice(j,1)}}var V=s,N=!1;e:for(var A=0;A<C;A++){var B=v[A];if(B===d){if(M.length>0)for(;M.length>0;){var I=M.shift(),F=I.char,q=I.isNew;if(F===d&&b!==!0){V+=d;continue e}if(t[A].test(F)){if(m===!0&&q!==!1&&c!==s&&l!==!1&&P){for(var D=M.length,L=null,W=0;W<D;W++){var J=M[W];if(J.char!==d&&J.isNew===!1)break;if(J.char===d){L=W;break}}null!==L?(V+=F,M.splice(L,1)):A--}else V+=F;continue e}N=!0}b===!1&&(V+=v.substr(A,C));break}V+=B}if(b&&P===!1){for(var U=null,H=0;H<V.length;H++)v[H]===d&&(U=H);V=null!==U?V.substr(0,U+1):s}return{conformedValue:V,meta:{someCharsRejected:N}}}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=n;var i=r(2),a=r(1),u=[],s=""},function(e,t){"use strict";function r(e){var t=e.previousConformedValue,r=void 0===t?o:t,i=e.previousPlaceholder,a=void 0===i?o:i,u=e.currentCaretPosition,s=void 0===u?0:u,l=e.conformedValue,f=e.rawValue,c=e.placeholderChar,p=e.placeholder,d=e.indexesOfPipedChars,h=void 0===d?n:d,v=e.caretTrapIndexes,y=void 0===v?n:v;if(0===s||!f.length)return 0;var m=f.length,b=r.length,g=p.length,k=l.length,C=m-b,O=C>0,T=0===b,P=C>1&&!O&&!T;if(P)return s;var x=O&&(r===l||l===p),w=0,S=void 0,_=void 0;if(x)w=s-C;else{var M=l.toLowerCase(),j=f.toLowerCase(),E=j.substr(0,s).split(o),R=E.filter(function(e){return M.indexOf(e)!==-1});_=R[R.length-1];var V=a.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,N=p.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,A=N!==V,B=void 0!==a[R.length-1]&&void 0!==p[R.length-2]&&a[R.length-1]!==c&&a[R.length-1]!==p[R.length-1]&&a[R.length-1]===p[R.length-2];!O&&(A||B)&&V>0&&p.indexOf(_)>-1&&void 0!==f[s]&&(S=!0,_=f[s]);for(var I=h.map(function(e){return M[e]}),F=I.filter(function(e){return e===_}).length,q=R.filter(function(e){return e===_}).length,D=p.substr(0,p.indexOf(c)).split(o).filter(function(e,t){return e===_&&f[t]!==e}).length,L=D+q+F+(S?1:0),W=0,J=0;J<k;J++){var U=M[J];if(w=J+1,U===_&&W++,W>=L)break}}if(O){for(var H=w,Y=w;Y<=g;Y++)if(p[Y]===c&&(H=Y),p[Y]===c||y.indexOf(Y)!==-1||Y===g)return H}else if(S){for(var z=w-1;z>=0;z--)if(l[z]===_||y.indexOf(z)!==-1||0===z)return z}else for(var G=w;G>=0;G--)if(p[G-1]===c||y.indexOf(G)!==-1||0===G)return G}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var n=[],o=""},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e){var t={previousConformedValue:void 0,previousPlaceholder:void 0};return{state:t,update:function(r){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:e,o=n.inputElement,l=n.mask,c=n.guide,y=n.pipe,b=n.placeholderChar,g=void 0===b?h.placeholderChar:b,k=n.keepCharPositions,C=void 0!==k&&k,O=n.showMask,T=void 0!==O&&O;if("undefined"==typeof r&&(r=o.value),r!==t.previousConformedValue){("undefined"==typeof l?"undefined":s(l))===m&&void 0!==l.pipe&&void 0!==l.mask&&(y=l.pipe,l=l.mask);var P=void 0,x=void 0;if(l instanceof Array&&(P=(0,d.convertMaskToPlaceholder)(l,g)),l!==!1){var w=a(r),S=o.selectionEnd,_=t.previousConformedValue,M=t.previousPlaceholder,j=void 0;if(("undefined"==typeof l?"undefined":s(l))===h.strFunction){if(x=l(w,{currentCaretPosition:S,previousConformedValue:_,placeholderChar:g}),x===!1)return;var E=(0,d.processCaretTraps)(x),R=E.maskWithoutCaretTraps,V=E.indexes;x=R,j=V,P=(0,d.convertMaskToPlaceholder)(x,g)}else x=l;var N={previousConformedValue:_,guide:c,placeholderChar:g,pipe:y,placeholder:P,currentCaretPosition:S,keepCharPositions:C},A=(0,p.default)(w,x,N),B=A.conformedValue,I=("undefined"==typeof y?"undefined":s(y))===h.strFunction,F={};I&&(F=y(B,u({rawValue:w},N)),F===!1?F={value:_,rejected:!0}:(0,d.isString)(F)&&(F={value:F}));var q=I?F.value:B,D=(0,f.default)({previousConformedValue:_,previousPlaceholder:M,conformedValue:q,placeholder:P,rawValue:w,currentCaretPosition:S,placeholderChar:g,indexesOfPipedChars:F.indexesOfPipedChars,caretTrapIndexes:j}),L=q===P&&0===D,W=T?P:v,J=L?W:q;t.previousConformedValue=J,t.previousPlaceholder=P,o.value!==J&&(o.value=J,i(o,D))}}}}}function i(e,t){document.activeElement===e&&(b?g(function(){return e.setSelectionRange(t,t,y)},0):e.setSelectionRange(t,t,y))}function a(e){if((0,d.isString)(e))return e;if((0,d.isNumber)(e))return String(e);if(void 0===e||null===e)return v;throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n "+JSON.stringify(e))}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=o;var l=r(4),f=n(l),c=r(3),p=n(c),d=r(2),h=r(1),v="",y="none",m="object",b="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),g="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setTimeout},function(e,t){"use strict";function r(e){return function(){return e}}var n=function(){};n.thatReturns=r,n.thatReturnsFalse=r(!1),n.thatReturnsTrue=r(!0),n.thatReturnsNull=r(null),n.thatReturnsThis=function(){return this},n.thatReturnsArgument=function(e){return e},e.exports=n},function(e,t,r){"use strict";function n(e,t,r,n,i,a,u,s){if(o(t),!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var f=[r,n,i,a,u,s],c=0;l=new Error(t.replace(/%s/g,function(){return f[c++]})),l.name="Invariant Violation"}throw l.framesToPop=1,l}}var o=function(e){};e.exports=n},function(e,t,r){"use strict";var n=r(6),o=r(7),i=r(10);e.exports=function(){function e(e,t,r,n,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=n,r.PropTypes=r,r}},function(e,t,r){"use strict";"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports=r(8)()},function(e,t){"use strict";var r="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=r},function(t,r){t.exports=e}])});

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Button = exports.buttonFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(20);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(44);
	
	var _identifiers = __webpack_require__(61);
	
	var _FontIcon = __webpack_require__(187);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Ripple = __webpack_require__(457);
	
	var _Ripple2 = _interopRequireDefault(_Ripple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(ripple, FontIcon) {
	  var Button = function (_Component) {
	    _inherits(Button, _Component);
	
	    function Button() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Button);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.getLevel = function () {
	        if (_this.props.primary) return 'primary';
	        if (_this.props.accent) return 'accent';
	        return 'neutral';
	      }, _this.getShape = function () {
	        if (_this.props.raised) return 'raised';
	        if (_this.props.floating) return 'floating';
	        return 'flat';
	      }, _this.handleMouseUp = function (event) {
	        _this.buttonNode.blur();
	        if (_this.props.onMouseUp) _this.props.onMouseUp(event);
	      }, _this.handleMouseLeave = function (event) {
	        _this.buttonNode.blur();
	        if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Button, [{
	      key: 'render',
	      value: function render() {
	        var _classnames,
	            _this2 = this;
	
	        var _props = this.props,
	            accent = _props.accent,
	            children = _props.children,
	            className = _props.className,
	            flat = _props.flat,
	            floating = _props.floating,
	            href = _props.href,
	            icon = _props.icon,
	            inverse = _props.inverse,
	            label = _props.label,
	            mini = _props.mini,
	            neutral = _props.neutral,
	            primary = _props.primary,
	            raised = _props.raised,
	            theme = _props.theme,
	            type = _props.type,
	            others = _objectWithoutProperties(_props, ['accent', 'children', 'className', 'flat', 'floating', 'href', 'icon', 'inverse', 'label', 'mini', 'neutral', 'primary', 'raised', 'theme', 'type']);
	
	        var element = href ? 'a' : 'button';
	        var level = this.getLevel();
	        var shape = this.getShape();
	        var mouseEvents = {
	          onMouseUp: this.handleMouseUp,
	          onMouseLeave: this.handleMouseLeave
	        };
	
	        var classes = (0, _classnames3.default)(theme.button, [theme[shape]], (_classnames = {}, _defineProperty(_classnames, theme[level], neutral), _defineProperty(_classnames, theme.mini, mini), _defineProperty(_classnames, theme.inverse, inverse), _classnames), className);
	
	        var props = _extends({}, others, mouseEvents, {
	          href: href,
	          ref: function ref(node) {
	            _this2.buttonNode = node;
	          },
	          className: classes,
	          disabled: this.props.disabled,
	          type: !href ? type : null,
	          'data-react-toolbox': 'button'
	        });
	
	        var buttonElement = _react2.default.createElement(element, props, icon ? _react2.default.createElement(FontIcon, { className: theme.icon, value: icon }) : null, label, children);
	
	        return others.onMouseEnter && this.props.disabled ? _react2.default.createElement(
	          'span',
	          mouseEvents,
	          buttonElement
	        ) : buttonElement;
	      }
	    }]);
	
	    return Button;
	  }(_react.Component);
	
	  Button.propTypes = {
	    accent: _propTypes2.default.bool,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    flat: _propTypes2.default.bool,
	    floating: _propTypes2.default.bool,
	    href: _propTypes2.default.string,
	    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    inverse: _propTypes2.default.bool,
	    label: _propTypes2.default.string,
	    mini: _propTypes2.default.bool,
	    neutral: _propTypes2.default.bool,
	    onMouseLeave: _propTypes2.default.func,
	    onMouseUp: _propTypes2.default.func,
	    primary: _propTypes2.default.bool,
	    raised: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      accent: _propTypes2.default.string,
	      button: _propTypes2.default.string,
	      flat: _propTypes2.default.string,
	      floating: _propTypes2.default.string,
	      icon: _propTypes2.default.string,
	      inverse: _propTypes2.default.string,
	      mini: _propTypes2.default.string,
	      neutral: _propTypes2.default.string,
	      primary: _propTypes2.default.string,
	      raised: _propTypes2.default.string,
	      rippleWrapper: _propTypes2.default.string,
	      toggle: _propTypes2.default.string
	    }),
	    type: _propTypes2.default.string
	  };
	  Button.defaultProps = {
	    accent: false,
	    className: '',
	    flat: false,
	    floating: false,
	    mini: false,
	    neutral: true,
	    primary: false,
	    raised: false,
	    type: 'button'
	  };
	
	
	  return ripple(Button);
	};
	
	var Button = factory((0, _Ripple2.default)({ centered: false }), _FontIcon2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.BUTTON)(Button);
	exports.buttonFactory = factory;
	exports.Button = Button;

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconButton = exports.iconButtonFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(20);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(44);
	
	var _identifiers = __webpack_require__(61);
	
	var _FontIcon = __webpack_require__(187);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Ripple = __webpack_require__(457);
	
	var _Ripple2 = _interopRequireDefault(_Ripple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(ripple, FontIcon) {
	  var IconButton = function (_Component) {
	    _inherits(IconButton, _Component);
	
	    function IconButton() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, IconButton);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IconButton.__proto__ || Object.getPrototypeOf(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.getLevel = function () {
	        if (_this.props.primary) return 'primary';
	        if (_this.props.accent) return 'accent';
	        return 'neutral';
	      }, _this.handleMouseUp = function (event) {
	        _this.buttonNode.blur();
	        if (_this.props.onMouseUp) _this.props.onMouseUp(event);
	      }, _this.handleMouseLeave = function (event) {
	        _this.buttonNode.blur();
	        if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(IconButton, [{
	      key: 'render',
	      value: function render() {
	        var _classnames,
	            _this2 = this;
	
	        var _props = this.props,
	            accent = _props.accent,
	            children = _props.children,
	            className = _props.className,
	            href = _props.href,
	            icon = _props.icon,
	            inverse = _props.inverse,
	            neutral = _props.neutral,
	            primary = _props.primary,
	            theme = _props.theme,
	            type = _props.type,
	            others = _objectWithoutProperties(_props, ['accent', 'children', 'className', 'href', 'icon', 'inverse', 'neutral', 'primary', 'theme', 'type']);
	
	        var element = href ? 'a' : 'button';
	        var level = this.getLevel();
	        var classes = (0, _classnames3.default)([theme.toggle], (_classnames = {}, _defineProperty(_classnames, theme[level], neutral), _defineProperty(_classnames, theme.inverse, inverse), _classnames), className);
	
	        var props = _extends({}, others, {
	          href: href,
	          ref: function ref(node) {
	            _this2.buttonNode = node;
	          },
	          className: classes,
	          disabled: this.props.disabled,
	          onMouseUp: this.handleMouseUp,
	          onMouseLeave: this.handleMouseLeave,
	          type: !href ? type : null,
	          'data-react-toolbox': 'button'
	        });
	
	        var iconElement = typeof icon === 'string' ? _react2.default.createElement(FontIcon, { className: theme.icon, value: icon }) : icon;
	
	        return _react2.default.createElement(element, props, icon && iconElement, children);
	      }
	    }]);
	
	    return IconButton;
	  }(_react.Component);
	
	  IconButton.propTypes = {
	    accent: _propTypes2.default.bool,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    href: _propTypes2.default.string,
	    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    inverse: _propTypes2.default.bool,
	    neutral: _propTypes2.default.bool,
	    onMouseLeave: _propTypes2.default.func,
	    onMouseUp: _propTypes2.default.func,
	    primary: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      accent: _propTypes2.default.string,
	      button: _propTypes2.default.string,
	      flat: _propTypes2.default.string,
	      floating: _propTypes2.default.string,
	      icon: _propTypes2.default.string,
	      inverse: _propTypes2.default.string,
	      mini: _propTypes2.default.string,
	      neutral: _propTypes2.default.string,
	      primary: _propTypes2.default.string,
	      raised: _propTypes2.default.string,
	      rippleWrapper: _propTypes2.default.string,
	      toggle: _propTypes2.default.string
	    }),
	    type: _propTypes2.default.string
	  };
	  IconButton.defaultProps = {
	    accent: false,
	    className: '',
	    neutral: true,
	    primary: false,
	    type: 'button'
	  };
	
	
	  return ripple(IconButton);
	};
	
	var IconButton = factory((0, _Ripple2.default)({ centered: true }), _FontIcon2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.BUTTON)(IconButton);
	exports.iconButtonFactory = factory;
	exports.IconButton = IconButton;

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(927);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransition = __webpack_require__(925);
	
	var _CSSTransition2 = _interopRequireDefault(_CSSTransition);
	
	var _utils = __webpack_require__(188);
	
	var _time = __webpack_require__(101);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _CalendarMonth = __webpack_require__(916);
	
	var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DIRECTION_STEPS = { left: -1, right: 1 };
	
	var factory = function factory(IconButton) {
	  var Calendar = function (_Component) {
	    _inherits(Calendar, _Component);
	
	    function Calendar() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Calendar);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        viewDate: _this.props.selectedDate
	      }, _this.handleDayClick = function (day) {
	        _this.props.onChange(_time2.default.setDay(_this.state.viewDate, day), true);
	      }, _this.handleYearClick = function (event) {
	        var year = parseInt(event.currentTarget.id, 10);
	        var viewDate = _time2.default.setYear(_this.props.selectedDate, year);
	        _this.setState({ viewDate: viewDate });
	        _this.props.onChange(viewDate, false);
	      }, _this.handleKeys = function (e) {
	        var selectedDate = _this.props.selectedDate;
	
	
	        if (e.which === 37 || e.which === 38 || e.which === 39 || e.which === 40 || e.which === 13) {
	          e.preventDefault();
	        }
	
	        switch (e.which) {
	          case 13:
	            _this.props.handleSelect();break; // enter
	          case 37:
	            _this.handleDayArrowKey(_time2.default.addDays(selectedDate, -1));break; // left
	          case 38:
	            _this.handleDayArrowKey(_time2.default.addDays(selectedDate, -7));break; // up
	          case 39:
	            _this.handleDayArrowKey(_time2.default.addDays(selectedDate, 1));break; // right
	          case 40:
	            _this.handleDayArrowKey(_time2.default.addDays(selectedDate, 7));break; // down
	          default:
	            break;
	        }
	      }, _this.handleDayArrowKey = function (date) {
	        _this.setState({ viewDate: date });
	        _this.props.onChange(date, false);
	      }, _this.changeViewMonth = function (event) {
	        var direction = event.currentTarget.id;
	        _this.setState({
	          direction: direction,
	          viewDate: _time2.default.addMonths(_this.state.viewDate, DIRECTION_STEPS[direction])
	        });
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Calendar, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        document.body.addEventListener('keydown', this.handleKeys);
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        if (this.activeYearNode) {
	          this.scrollToActive();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        document.body.removeEventListener('keydown', this.handleKeys);
	      }
	    }, {
	      key: 'scrollToActive',
	      value: function scrollToActive() {
	        var offset = this.yearsNode.offsetHeight / 2 + this.activeYearNode.offsetHeight / 2;
	        this.yearsNode.scrollTop = this.activeYearNode.offsetTop - offset;
	      }
	    }, {
	      key: 'renderYears',
	      value: function renderYears() {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	          'ul',
	          {
	            'data-react-toolbox': 'years',
	            className: this.props.theme.years,
	            ref: function ref(node) {
	              _this2.yearsNode = node;
	            }
	          },
	          (0, _utils.range)(1900, 2100).map(function (year) {
	            return _react2.default.createElement(
	              'li',
	              {
	                className: year === _this2.state.viewDate.getFullYear() ? _this2.props.theme.active : '',
	                id: year,
	                key: year,
	                onClick: _this2.handleYearClick,
	                ref: function ref(node) {
	                  if (year === _this2.state.viewDate.getFullYear()) {
	                    _this2.activeYearNode = node;
	                  }
	                }
	              },
	              year
	            );
	          })
	        );
	      }
	    }, {
	      key: 'renderMonths',
	      value: function renderMonths() {
	        var theme = this.props.theme;
	
	        var animation = this.state.direction === 'left' ? 'slideLeft' : 'slideRight';
	        var animationModule = (0, _utils.getAnimationModule)(animation, theme);
	        return _react2.default.createElement(
	          'div',
	          { 'data-react-toolbox': 'calendar' },
	          _react2.default.createElement(IconButton, { id: 'left', className: theme.prev, icon: 'chevron_left', onClick: this.changeViewMonth }),
	          _react2.default.createElement(IconButton, { id: 'right', className: theme.next, icon: 'chevron_right', onClick: this.changeViewMonth }),
	          _react2.default.createElement(
	            _TransitionGroup2.default,
	            null,
	            _react2.default.createElement(
	              _CSSTransition2.default,
	              { classNames: animationModule, timeout: 350 },
	              _react2.default.createElement(_CalendarMonth2.default, {
	                enabledDates: this.props.enabledDates,
	                disabledDates: this.props.disabledDates,
	                key: this.state.viewDate.getMonth(),
	                locale: this.props.locale,
	                maxDate: this.props.maxDate,
	                minDate: this.props.minDate,
	                onDayClick: this.handleDayClick,
	                selectedDate: this.props.selectedDate,
	                sundayFirstDayOfWeek: this.props.sundayFirstDayOfWeek,
	                theme: this.props.theme,
	                viewDate: this.state.viewDate
	              })
	            )
	          )
	        );
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(
	          'div',
	          { className: this.props.theme.calendar },
	          this.props.display === 'months' ? this.renderMonths() : this.renderYears()
	        );
	      }
	    }]);
	
	    return Calendar;
	  }(_react.Component);
	
	  Calendar.propTypes = {
	    disabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	    display: _propTypes2.default.oneOf(['months', 'years']),
	    enabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	    handleSelect: _propTypes2.default.func,
	    locale: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	    maxDate: _propTypes2.default.instanceOf(Date),
	    minDate: _propTypes2.default.instanceOf(Date),
	    onChange: _propTypes2.default.func,
	    selectedDate: _propTypes2.default.instanceOf(Date),
	    sundayFirstDayOfWeek: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      active: _propTypes2.default.string,
	      calendar: _propTypes2.default.string,
	      next: _propTypes2.default.string,
	      prev: _propTypes2.default.string,
	      years: _propTypes2.default.string
	    })
	  };
	  Calendar.defaultProps = {
	    display: 'months',
	    selectedDate: new Date()
	  };
	
	
	  return Calendar;
	};
	
	exports.default = factory;

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(20);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _time = __webpack_require__(101);
	
	var _time2 = _interopRequireDefault(_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Day = function (_Component) {
	  _inherits(Day, _Component);
	
	  function Day() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Day);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Day.__proto__ || Object.getPrototypeOf(Day)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
	      if (!_this.props.disabled && _this.props.onClick) {
	        _this.props.onClick(_this.props.day);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Day, [{
	    key: 'dayStyle',
	    value: function dayStyle() {
	      if (this.props.day === 1) {
	        var e = this.props.sundayFirstDayOfWeek ? 0 : 1;
	        var firstDay = _time2.default.getFirstWeekDay(this.props.viewDate) - e;
	        return {
	          marginLeft: (firstDay >= 0 ? firstDay : 6) * (100 / 7) + '%'
	        };
	      }
	      return undefined;
	    }
	  }, {
	    key: 'isSelected',
	    value: function isSelected() {
	      var sameYear = this.props.viewDate.getFullYear() === this.props.selectedDate.getFullYear();
	      var sameMonth = this.props.viewDate.getMonth() === this.props.selectedDate.getMonth();
	      var sameDay = this.props.day === this.props.selectedDate.getDate();
	      return sameYear && sameMonth && sameDay;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var className = (0, _classnames3.default)(this.props.theme.day, (_classnames = {}, _defineProperty(_classnames, this.props.theme.active, this.isSelected()), _defineProperty(_classnames, this.props.theme.disabled, this.props.disabled), _classnames));
	
	      return _react2.default.createElement(
	        'div',
	        { 'data-react-toolbox': 'day', className: className, style: this.dayStyle() },
	        _react2.default.createElement(
	          'span',
	          { onClick: this.handleClick },
	          this.props.day
	        )
	      );
	    }
	  }]);
	
	  return Day;
	}(_react.Component);
	
	Day.propTypes = {
	  day: _propTypes2.default.number,
	  disabled: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  selectedDate: _propTypes2.default.instanceOf(Date),
	  sundayFirstDayOfWeek: _propTypes2.default.bool,
	  theme: _propTypes2.default.shape({
	    active: _propTypes2.default.string,
	    day: _propTypes2.default.string,
	    disabled: _propTypes2.default.string
	  }),
	  viewDate: _propTypes2.default.instanceOf(Date)
	};
	exports.default = Day;

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(188);
	
	var _time = __webpack_require__(101);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _CalendarDay = __webpack_require__(915);
	
	var _CalendarDay2 = _interopRequireDefault(_CalendarDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Month = function (_Component) {
	  _inherits(Month, _Component);
	
	  function Month() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Month);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [this].concat(args))), _this), _this.handleDayClick = function (day) {
	      if (_this.props.onDayClick) _this.props.onDayClick(day);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Month, [{
	    key: 'isDayDisabled',
	    value: function isDayDisabled(date) {
	      var _props = this.props,
	          minDate = _props.minDate,
	          maxDate = _props.maxDate,
	          enabledDates = _props.enabledDates,
	          disabledDates = _props.disabledDates;
	
	      var compareDate = function compareDate(compDate) {
	        return date.getTime() === compDate.getTime();
	      };
	      var dateInDisabled = disabledDates.filter(compareDate).length > 0;
	      var dateInEnabled = enabledDates.filter(compareDate).length > 0;
	      return _time2.default.dateOutOfRange(date, minDate, maxDate) || enabledDates.length > 0 && !dateInEnabled || dateInDisabled;
	    }
	  }, {
	    key: 'renderWeeks',
	    value: function renderWeeks() {
	      var _this2 = this;
	
	      var days = (0, _utils.range)(0, 7).map(function (d) {
	        return _time2.default.getDayOfWeekLetter(d, _this2.props.locale);
	      });
	      var source = this.props.sundayFirstDayOfWeek ? days : [].concat(_toConsumableArray(days.slice(1)), [days[0]]);
	      return source.map(function (day, i) {
	        return _react2.default.createElement(
	          'span',
	          { key: i },
	          day
	        );
	      }); // eslint-disable-line
	    }
	  }, {
	    key: 'renderDays',
	    value: function renderDays() {
	      var _this3 = this;
	
	      return (0, _utils.range)(1, _time2.default.getDaysInMonth(this.props.viewDate) + 1).map(function (i) {
	        var date = new Date(_this3.props.viewDate.getFullYear(), _this3.props.viewDate.getMonth(), i);
	        return _react2.default.createElement(_CalendarDay2.default, {
	          key: i,
	          day: i,
	          disabled: _this3.isDayDisabled(date),
	          onClick: _this3.handleDayClick,
	          selectedDate: _this3.props.selectedDate,
	          theme: _this3.props.theme,
	          viewDate: _this3.props.viewDate,
	          sundayFirstDayOfWeek: _this3.props.sundayFirstDayOfWeek
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var fullMonth = _time2.default.getFullMonth(this.props.viewDate, this.props.locale);
	      var fullYear = this.props.viewDate.getFullYear();
	      return _react2.default.createElement(
	        'div',
	        { 'data-react-toolbox': 'month', className: this.props.theme.month },
	        _react2.default.createElement(
	          'span',
	          { className: this.props.theme.title },
	          fullMonth,
	          ' ',
	          fullYear
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.props.theme.week },
	          this.renderWeeks()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.props.theme.days },
	          this.renderDays()
	        )
	      );
	    }
	  }]);
	
	  return Month;
	}(_react.Component);
	
	Month.propTypes = {
	  disabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	  enabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	  locale: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  maxDate: _propTypes2.default.instanceOf(Date),
	  minDate: _propTypes2.default.instanceOf(Date),
	  onDayClick: _propTypes2.default.func,
	  selectedDate: _propTypes2.default.instanceOf(Date),
	  sundayFirstDayOfWeek: _propTypes2.default.bool,
	  theme: _propTypes2.default.shape({
	    days: _propTypes2.default.string,
	    month: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    week: _propTypes2.default.string
	  }),
	  viewDate: _propTypes2.default.instanceOf(Date)
	};
	Month.defaultProps = {
	  disabledDates: [],
	  enabledDates: []
	};
	exports.default = Month;

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _time = __webpack_require__(101);
	
	var _time2 = _interopRequireDefault(_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(Dialog, Calendar) {
	  var CalendarDialog = function (_Component) {
	    _inherits(CalendarDialog, _Component);
	
	    function CalendarDialog() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, CalendarDialog);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CalendarDialog.__proto__ || Object.getPrototypeOf(CalendarDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        display: 'months',
	        date: _this.props.value
	      }, _this.handleNewDate = function (value, dayClick) {
	        var state = { display: 'months', date: value };
	        if (_time2.default.dateOutOfRange(value, _this.props.minDate, _this.props.maxDate)) {
	          if (_this.props.maxDate && _this.props.minDate) {
	            state.date = _time2.default.closestDate(value, _this.props.maxDate, _this.props.minDate);
	          } else {
	            state.date = _this.props.maxDate || _this.props.minDate;
	          }
	        }
	        _this.setState(state);
	        if (dayClick && _this.props.autoOk && _this.props.onSelect) {
	          _this.props.onSelect(value);
	        }
	      }, _this.handleSelect = function (event) {
	        if (_this.props.onSelect) _this.props.onSelect(_this.state.date, event);
	      }, _this.handleSwitchDisplay = function (event) {
	        _this.setState({ display: event.target.id });
	      }, _this.updateStateDate = function (date) {
	        if (Object.prototype.toString.call(date) === '[object Date]') {
	          _this.handleNewDate(date, false);
	        }
	      }, _this.actions = [{
	        label: _this.props.cancelLabel,
	        className: _this.props.theme.button,
	        onClick: _this.props.onDismiss
	      }, {
	        label: _this.props.okLabel,
	        className: _this.props.theme.button,
	        name: _this.props.name,
	        onClick: _this.handleSelect
	      }], _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(CalendarDialog, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        this.updateStateDate(this.props.value);
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        this.updateStateDate(nextProps.value);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var theme = this.props.theme;
	
	        var display = this.state.display + 'Display';
	        var className = (0, _classnames2.default)(theme.dialog, this.props.className);
	        var headerClassName = (0, _classnames2.default)(theme.header, theme[display]);
	        var shortDayOfWeek = _time2.default.getShortDayOfWeek(this.state.date.getDay(), this.props.locale);
	        var shortMonth = _time2.default.getShortMonth(this.state.date, this.props.locale);
	        var date = this.state.date.getDate();
	
	        return _react2.default.createElement(
	          Dialog,
	          {
	            actions: this.actions,
	            active: this.props.active,
	            className: className,
	            onEscKeyDown: this.props.onEscKeyDown,
	            onOverlayClick: this.props.onOverlayClick,
	            type: 'custom'
	          },
	          _react2.default.createElement(
	            'header',
	            { className: headerClassName },
	            _react2.default.createElement(
	              'span',
	              { id: 'years', className: theme.year, onClick: this.handleSwitchDisplay },
	              this.state.date.getFullYear()
	            ),
	            _react2.default.createElement(
	              'h3',
	              { id: 'months', className: theme.date, onClick: this.handleSwitchDisplay },
	              shortDayOfWeek,
	              ', ',
	              shortMonth,
	              ' ',
	              date
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: theme.calendarWrapper },
	            _react2.default.createElement(Calendar, {
	              disabledDates: this.props.disabledDates,
	              display: this.state.display,
	              enabledDates: this.props.enabledDates,
	              handleSelect: this.handleSelect,
	              maxDate: this.props.maxDate,
	              minDate: this.props.minDate,
	              onChange: this.handleNewDate,
	              selectedDate: this.state.date,
	              theme: this.props.theme,
	              locale: this.props.locale,
	              sundayFirstDayOfWeek: this.props.sundayFirstDayOfWeek
	            })
	          )
	        );
	      }
	    }]);
	
	    return CalendarDialog;
	  }(_react.Component);
	
	  CalendarDialog.propTypes = {
	    active: _propTypes2.default.bool,
	    autoOk: _propTypes2.default.bool,
	    cancelLabel: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    disabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	    enabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	    locale: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	    maxDate: _propTypes2.default.instanceOf(Date),
	    minDate: _propTypes2.default.instanceOf(Date),
	    name: _propTypes2.default.string,
	    okLabel: _propTypes2.default.string,
	    onDismiss: _propTypes2.default.func,
	    onEscKeyDown: _propTypes2.default.func,
	    onOverlayClick: _propTypes2.default.func,
	    onSelect: _propTypes2.default.func,
	    sundayFirstDayOfWeek: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      button: _propTypes2.default.string,
	      calendarWrapper: _propTypes2.default.string,
	      date: _propTypes2.default.string,
	      dialog: _propTypes2.default.string,
	      header: _propTypes2.default.string,
	      monthsDisplay: _propTypes2.default.string,
	      year: _propTypes2.default.string,
	      yearsDisplay: _propTypes2.default.string
	    }),
	    value: _propTypes2.default.instanceOf(Date)
	  };
	  CalendarDialog.defaultProps = {
	    active: false,
	    cancelLabel: 'Cancel',
	    className: '',
	    okLabel: 'Ok',
	    value: new Date()
	  };
	
	
	  return CalendarDialog;
	};
	
	exports.default = factory;

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dialogFactory = exports.Dialog = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssThemr = __webpack_require__(44);
	
	var _classnames3 = __webpack_require__(20);
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	var _identifiers = __webpack_require__(61);
	
	var _Portal = __webpack_require__(920);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _ActivableRenderer = __webpack_require__(919);
	
	var _ActivableRenderer2 = _interopRequireDefault(_ActivableRenderer);
	
	var _Button = __webpack_require__(912);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Overlay = __webpack_require__(922);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable jsx-a11y/aria-role */
	
	
	var factory = function factory(Overlay, Button) {
	  var Dialog = function Dialog(props) {
	    var actions = props.actions.map(function (action, idx) {
	      var className = (0, _classnames4.default)(props.theme.button, _defineProperty({}, action.className, action.className));
	      return _react2.default.createElement(Button, _extends({ key: idx }, action, { className: className })); // eslint-disable-line
	    });
	
	    var className = (0, _classnames4.default)([props.theme.dialog, props.theme[props.type]], _defineProperty({}, props.theme.active, props.active), props.className);
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      { className: props.theme.wrapper },
	      _react2.default.createElement(Overlay, {
	        active: props.active,
	        className: props.theme.overlay,
	        onClick: props.onOverlayClick,
	        onEscKeyDown: props.onEscKeyDown,
	        onMouseDown: props.onOverlayMouseDown,
	        onMouseMove: props.onOverlayMouseMove,
	        onMouseUp: props.onOverlayMouseUp,
	        theme: props.theme,
	        themeNamespace: 'overlay'
	      }),
	      _react2.default.createElement(
	        'div',
	        { 'data-react-toolbox': 'dialog', className: className },
	        _react2.default.createElement(
	          'section',
	          { role: 'body', className: props.theme.body },
	          props.title ? _react2.default.createElement(
	            'h6',
	            { className: props.theme.title },
	            props.title
	          ) : null,
	          props.children
	        ),
	        actions.length ? _react2.default.createElement(
	          'nav',
	          { className: props.theme.navigation },
	          actions
	        ) : null
	      )
	    );
	  };
	
	  Dialog.propTypes = {
	    actions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      className: _propTypes2.default.string,
	      label: _propTypes2.default.string,
	      children: _propTypes2.default.node
	    })),
	    active: _propTypes2.default.bool,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    onEscKeyDown: _propTypes2.default.func,
	    onOverlayClick: _propTypes2.default.func,
	    onOverlayMouseDown: _propTypes2.default.func,
	    onOverlayMouseMove: _propTypes2.default.func,
	    onOverlayMouseUp: _propTypes2.default.func,
	    theme: _propTypes2.default.shape({
	      active: _propTypes2.default.string,
	      body: _propTypes2.default.string,
	      button: _propTypes2.default.string,
	      dialog: _propTypes2.default.string,
	      navigation: _propTypes2.default.string,
	      overflow: _propTypes2.default.string,
	      overlay: _propTypes2.default.string,
	      title: _propTypes2.default.string,
	      wrapper: _propTypes2.default.string
	    }),
	    title: _propTypes2.default.string,
	    type: _propTypes2.default.string
	  };
	
	  Dialog.defaultProps = {
	    actions: [],
	    active: false,
	    type: 'normal'
	  };
	
	  return (0, _ActivableRenderer2.default)()(Dialog);
	};
	
	var Dialog = factory(_Overlay2.default, _Button2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.DIALOG)(Dialog);
	exports.Dialog = Dialog;
	exports.dialogFactory = factory;

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivableRendererFactory = function ActivableRendererFactory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { delay: 500 };
	  return function (ActivableComponent) {
	    var _class, _temp2;
	
	    return _temp2 = _class = function (_Component) {
	      _inherits(ActivableRenderer, _Component);
	
	      function ActivableRenderer() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ActivableRenderer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivableRenderer.__proto__ || Object.getPrototypeOf(ActivableRenderer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	          active: _this.props.active,
	          rendered: _this.props.active
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _createClass(ActivableRenderer, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	          if (nextProps.active && !this.props.active) this.renderAndActivate();
	          if (!nextProps.active && this.props.active) this.deactivateAndUnrender();
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          clearTimeout(this.activateTimeout);
	          clearTimeout(this.unrenderTimeout);
	        }
	      }, {
	        key: 'deactivateAndUnrender',
	        value: function deactivateAndUnrender() {
	          var _this2 = this;
	
	          this.setState({ rendered: true, active: false }, function () {
	            _this2.unrenderTimeout = setTimeout(function () {
	              _this2.setState({ rendered: false });
	              _this2.unrenderTimeout = null;
	            }, _this2.props.delay);
	          });
	        }
	      }, {
	        key: 'renderAndActivate',
	        value: function renderAndActivate() {
	          var _this3 = this;
	
	          if (this.unrenderTimeout) clearTimeout(this.unrenderTimeout);
	          this.setState({ rendered: true, active: false }, function () {
	            _this3.activateTimeout = setTimeout(function () {
	              return _this3.setState({ active: true });
	            }, 20);
	          });
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _props = this.props,
	              delay = _props.delay,
	              others = _objectWithoutProperties(_props, ['delay']); // eslint-disable-line no-unused-vars
	
	
	          var _state = this.state,
	              active = _state.active,
	              rendered = _state.rendered;
	
	          return rendered ? _react2.default.createElement(ActivableComponent, _extends({}, others, { active: active })) : null;
	        }
	      }]);
	
	      return ActivableRenderer;
	    }(_react.Component), _class.propTypes = {
	      active: _propTypes2.default.bool.isRequired,
	      children: _propTypes2.default.node,
	      delay: _propTypes2.default.number
	    }, _class.defaultProps = {
	      delay: options.delay
	    }, _temp2;
	  };
	};
	
	exports.default = ActivableRendererFactory;

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactStyleProptype = __webpack_require__(910);
	
	var _reactStyleProptype2 = _interopRequireDefault(_reactStyleProptype);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portal = function (_Component) {
	  _inherits(Portal, _Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._renderOverlay();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this._overlayTarget && nextProps.container !== this.props.container) {
	        this._portalContainerNode.removeChild(this._overlayTarget);
	        this._portalContainerNode = getContainer(nextProps.container);
	        this._portalContainerNode.appendChild(this._overlayTarget);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._renderOverlay();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._unrenderOverlay();
	      this._unmountOverlayTarget();
	    }
	  }, {
	    key: 'getMountNode',
	    value: function getMountNode() {
	      return this._overlayTarget;
	    }
	  }, {
	    key: 'getOverlayDOMNode',
	    value: function getOverlayDOMNode() {
	      if (!this.isMounted()) {
	        // eslint-disable-line
	        throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
	      }
	
	      if (this._overlayInstance) {
	        if (this._overlayInstance.getWrappedDOMNode) {
	          return this._overlayInstance.getWrappedDOMNode();
	        }
	        return _reactDom2.default.findDOMNode(this._overlayInstance);
	      }
	
	      return null;
	    }
	  }, {
	    key: '_getOverlay',
	    value: function _getOverlay() {
	      if (!this.props.children) return null;
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.className, style: this.props.style },
	        this.props.children
	      );
	    }
	  }, {
	    key: '_renderOverlay',
	    value: function _renderOverlay() {
	      var overlay = this._getOverlay();
	      if (overlay !== null) {
	        this._mountOverlayTarget();
	        this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
	      } else {
	        this._unrenderOverlay();
	        this._unmountOverlayTarget();
	      }
	    }
	  }, {
	    key: '_unrenderOverlay',
	    value: function _unrenderOverlay() {
	      if (this._overlayTarget) {
	        _reactDom2.default.unmountComponentAtNode(this._overlayTarget);
	        this._overlayInstance = null;
	      }
	    }
	  }, {
	    key: '_mountOverlayTarget',
	    value: function _mountOverlayTarget() {
	      if (!this._overlayTarget) {
	        this._overlayTarget = document.createElement('div');
	        this._portalContainerNode = getContainer(this.props.container);
	        this._portalContainerNode.appendChild(this._overlayTarget);
	      }
	    }
	  }, {
	    key: '_unmountOverlayTarget',
	    value: function _unmountOverlayTarget() {
	      if (this._overlayTarget) {
	        this._portalContainerNode.removeChild(this._overlayTarget);
	        this._overlayTarget = null;
	      }
	      this._portalContainerNode = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react.Component);
	
	Portal.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  container: _propTypes2.default.node,
	  style: _reactStyleProptype2.default
	};
	Portal.defaultProps = {
	  className: ''
	};
	
	
	function getContainer(container) {
	  var _container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(_container) || document.body;
	}
	
	exports.default = Portal;

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Input = exports.inputFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames4 = __webpack_require__(20);
	
	var _classnames5 = _interopRequireDefault(_classnames4);
	
	var _reactCssThemr = __webpack_require__(44);
	
	var _utils = __webpack_require__(188);
	
	var _identifiers = __webpack_require__(61);
	
	var _FontIcon = __webpack_require__(187);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(FontIcon) {
	  var Input = function (_React$Component) {
	    _inherits(Input, _React$Component);
	
	    function Input() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Input);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (event) {
	        var _this$props = _this.props,
	            onChange = _this$props.onChange,
	            multiline = _this$props.multiline,
	            maxLength = _this$props.maxLength;
	
	        var valueFromEvent = event.target.value;
	
	        // Trim value to maxLength if that exists (only on multiline inputs).
	        // Note that this is still required even tho we have the onKeyPress filter
	        // because the user could paste smt in the textarea.
	        var haveToTrim = multiline && maxLength && event.target.value.length > maxLength;
	        var value = haveToTrim ? valueFromEvent.substr(0, maxLength) : valueFromEvent;
	
	        // propagate to to store and therefore to the input
	        if (onChange) onChange(value, event);
	      }, _this.handleAutoresize = function () {
	        var element = _this.inputNode;
	        var rows = _this.props.rows;
	
	        if (typeof rows === 'number' && !isNaN(rows)) {
	          element.style.height = null;
	        } else {
	          // compute the height difference between inner height and outer height
	          var style = getComputedStyle(element, null);
	          var heightOffset = style.boxSizing === 'content-box' ? -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom)) : parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
	
	          // resize the input to its content size
	          element.style.height = 'auto';
	          element.style.height = element.scrollHeight + heightOffset + 'px';
	        }
	      }, _this.handleKeyPress = function (event) {
	        // prevent insertion of more characters if we're a multiline input
	        // and maxLength exists
	        var _this$props2 = _this.props,
	            multiline = _this$props2.multiline,
	            maxLength = _this$props2.maxLength,
	            onKeyPress = _this$props2.onKeyPress;
	
	        if (multiline && maxLength) {
	          // check if smt is selected, in which case the newly added charcter would
	          // replace the selected characters, so the length of value doesn't actually
	          // increase.
	          var isReplacing = event.target.selectionEnd - event.target.selectionStart;
	          var value = event.target.value;
	
	          if (!isReplacing && value.length === maxLength) {
	            event.preventDefault();
	            event.stopPropagation();
	            return undefined;
	          }
	        }
	
	        if (onKeyPress) onKeyPress(event);
	        return undefined;
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Input, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (this.props.multiline) {
	          window.addEventListener('resize', this.handleAutoresize);
	          this.handleAutoresize();
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (!this.props.multiline && nextProps.multiline) {
	          window.addEventListener('resize', this.handleAutoresize);
	        } else if (this.props.multiline && !nextProps.multiline) {
	          window.removeEventListener('resize', this.handleAutoresize);
	        }
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        // resize the textarea, if nessesary
	        if (this.props.multiline) this.handleAutoresize();
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.props.multiline) window.removeEventListener('resize', this.handleAutoresize);
	      }
	    }, {
	      key: 'blur',
	      value: function blur() {
	        this.inputNode.blur();
	      }
	    }, {
	      key: 'focus',
	      value: function focus() {
	        this.inputNode.focus();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _classnames2,
	            _this2 = this;
	
	        var _props = this.props,
	            children = _props.children,
	            defaultValue = _props.defaultValue,
	            disabled = _props.disabled,
	            error = _props.error,
	            floating = _props.floating,
	            hint = _props.hint,
	            icon = _props.icon,
	            name = _props.name,
	            labelText = _props.label,
	            maxLength = _props.maxLength,
	            multiline = _props.multiline,
	            required = _props.required,
	            role = _props.role,
	            theme = _props.theme,
	            type = _props.type,
	            value = _props.value,
	            onKeyPress = _props.onKeyPress,
	            _props$rows = _props.rows,
	            rows = _props$rows === undefined ? 1 : _props$rows,
	            others = _objectWithoutProperties(_props, ['children', 'defaultValue', 'disabled', 'error', 'floating', 'hint', 'icon', 'name', 'label', 'maxLength', 'multiline', 'required', 'role', 'theme', 'type', 'value', 'onKeyPress', 'rows']);
	
	        var length = maxLength && value ? value.length : 0;
	        var labelClassName = (0, _classnames5.default)(theme.label, _defineProperty({}, theme.fixed, !floating));
	
	        var className = (0, _classnames5.default)(theme.input, (_classnames2 = {}, _defineProperty(_classnames2, theme.disabled, disabled), _defineProperty(_classnames2, theme.errored, error), _defineProperty(_classnames2, theme.hidden, type === 'hidden'), _defineProperty(_classnames2, theme.withIcon, icon), _classnames2), this.props.className);
	
	        var valuePresent = (0, _utils.isValuePresent)(value) || (0, _utils.isValuePresent)(defaultValue);
	
	        var inputElementProps = _extends({}, others, {
	          className: (0, _classnames5.default)(theme.inputElement, _defineProperty({}, theme.filled, valuePresent)),
	          onChange: this.handleChange,
	          ref: function ref(node) {
	            _this2.inputNode = node;
	          },
	          role: role,
	          name: name,
	          defaultValue: defaultValue,
	          disabled: disabled,
	          required: required,
	          type: type,
	          value: value
	        });
	        if (!multiline) {
	          inputElementProps.maxLength = maxLength;
	          inputElementProps.onKeyPress = onKeyPress;
	        } else {
	          inputElementProps.rows = rows;
	          inputElementProps.onKeyPress = this.handleKeyPress;
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { 'data-react-toolbox': 'input', className: className },
	          _react2.default.createElement(multiline ? 'textarea' : 'input', inputElementProps),
	          icon ? _react2.default.createElement(FontIcon, { className: theme.icon, value: icon }) : null,
	          _react2.default.createElement('span', { className: theme.bar }),
	          labelText ? _react2.default.createElement(
	            'label',
	            { className: labelClassName },
	            labelText,
	            required ? _react2.default.createElement(
	              'span',
	              { className: theme.required },
	              ' * '
	            ) : null
	          ) : null,
	          hint ? _react2.default.createElement(
	            'span',
	            { hidden: labelText, className: theme.hint },
	            hint
	          ) : null,
	          error ? _react2.default.createElement(
	            'span',
	            { className: theme.error },
	            error
	          ) : null,
	          maxLength ? _react2.default.createElement(
	            'span',
	            { className: theme.counter },
	            length,
	            '/',
	            maxLength
	          ) : null,
	          children
	        );
	      }
	    }]);
	
	    return Input;
	  }(_react2.default.Component);
	
	  Input.propTypes = {
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    defaultValue: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    error: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	    floating: _propTypes2.default.bool,
	    hint: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	    maxLength: _propTypes2.default.number,
	    multiline: _propTypes2.default.bool,
	    name: _propTypes2.default.string,
	    onBlur: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    onFocus: _propTypes2.default.func,
	    onKeyPress: _propTypes2.default.func,
	    required: _propTypes2.default.bool,
	    role: _propTypes2.default.string,
	    rows: _propTypes2.default.number,
	    theme: _propTypes2.default.shape({
	      bar: _propTypes2.default.string,
	      counter: _propTypes2.default.string,
	      disabled: _propTypes2.default.string,
	      error: _propTypes2.default.string,
	      errored: _propTypes2.default.string,
	      hidden: _propTypes2.default.string,
	      hint: _propTypes2.default.string,
	      icon: _propTypes2.default.string,
	      input: _propTypes2.default.string,
	      inputElement: _propTypes2.default.string,
	      required: _propTypes2.default.string,
	      withIcon: _propTypes2.default.string
	    }),
	    type: _propTypes2.default.string,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object, _propTypes2.default.string])
	  };
	  Input.defaultProps = {
	    className: '',
	    hint: '',
	    disabled: false,
	    floating: true,
	    multiline: false,
	    required: false,
	    role: 'input',
	    type: 'text'
	  };
	
	
	  return Input;
	};
	
	var Input = factory(_FontIcon2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.INPUT)(Input);
	exports.inputFactory = factory;
	exports.Input = Input;

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Overlay = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(20);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(44);
	
	var _identifiers = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overlay = function (_Component) {
	  _inherits(Overlay, _Component);
	
	  function Overlay() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Overlay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call.apply(_ref, [this].concat(args))), _this), _this.handleEscKey = function (e) {
	      if (_this.props.active && _this.props.onEscKeyDown && e.which === 27) {
	        _this.props.onEscKeyDown(e);
	      }
	    }, _this.handleClick = function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Overlay, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          active = _props.active,
	          lockScroll = _props.lockScroll,
	          onEscKeyDown = _props.onEscKeyDown;
	
	      if (onEscKeyDown) document.body.addEventListener('keydown', this.handleEscKey);
	      if (active && lockScroll) document.body.style.overflow = 'hidden';
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (this.props.lockScroll) {
	        var becomingActive = nextProps.active && !this.props.active;
	        var becomingUnactive = !nextProps.active && this.props.active;
	
	        if (becomingActive) {
	          document.body.style.overflow = 'hidden';
	        }
	
	        if (becomingUnactive && !document.querySelectorAll('[data-react-toolbox="overlay"]')[1]) {
	          document.body.style.overflow = '';
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.onEscKeyDown) {
	        if (this.props.active && !prevProps.active) {
	          document.body.addEventListener('keydown', this.handleEscKey);
	        } else if (!this.props.active && prevProps.active) {
	          document.body.removeEventListener('keydown', this.handleEscKey);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.active && this.props.lockScroll) {
	        if (!document.querySelectorAll('[data-react-toolbox="overlay"]')[1]) {
	          document.body.style.overflow = '';
	        }
	      }
	
	      if (this.props.onEscKeyDown) {
	        document.body.removeEventListener('keydown', this.handleEscKey);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          active = _props2.active,
	          className = _props2.className,
	          lockScroll = _props2.lockScroll,
	          theme = _props2.theme,
	          onEscKeyDown = _props2.onEscKeyDown,
	          other = _objectWithoutProperties(_props2, ['active', 'className', 'lockScroll', 'theme', 'onEscKeyDown']); // eslint-disable-line
	
	
	      return _react2.default.createElement('div', _extends({}, other, {
	        onClick: this.handleClick,
	        className: (0, _classnames3.default)(theme.overlay, _defineProperty({}, theme.active, active), className)
	      }));
	    }
	  }]);
	
	  return Overlay;
	}(_react.Component);
	
	Overlay.propTypes = {
	  active: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  lockScroll: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  onEscKeyDown: _propTypes2.default.func,
	  theme: _propTypes2.default.shape({
	    active: _propTypes2.default.string,
	    backdrop: _propTypes2.default.string,
	    overlay: _propTypes2.default.string
	  })
	};
	Overlay.defaultProps = {
	  lockScroll: true
	};
	exports.default = (0, _reactCssThemr.themr)(_identifiers.OVERLAY)(Overlay);
	exports.Overlay = Overlay;

/***/ },
/* 923 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasOwnProperty;
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}

/***/ },
/* 924 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var WEBKIT = 'Webkit';
	var MICROSOFT = 'Ms';
	
	var properties = {
	  transform: [WEBKIT, MICROSOFT]
	};
	
	function capitalize(string) {
	  return string.charAt(0).toUpperCase() + string.substr(1);
	}
	
	function getPrefixes(property, value) {
	  return properties[property].reduce(function (acc, item) {
	    acc['' + item + capitalize(property)] = value; // eslint-disable-line no-param-reassign
	    return acc;
	  }, {});
	}
	
	function addPrefixesTo(style, property, value) {
	  var vendor = getPrefixes(property, value);
	  for (var prefix in vendor) {
	    // eslint-disable-line no-restricted-syntax
	    if ({}.hasOwnProperty.call(vendor, prefix)) {
	      style[prefix] = vendor[prefix]; // eslint-disable-line no-param-reassign
	    }
	  }
	
	  return style;
	}
	
	function prefixer(style) {
	  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var _style = defaultValue;
	  for (var property in style) {
	    // eslint-disable-line no-restricted-syntax
	    if ({}.hasOwnProperty.call(style, property)) {
	      _style[property] = style[property];
	      if (properties[property]) {
	        addPrefixesTo(_style, property, style[property]);
	      }
	    }
	  }
	
	  return _style;
	}
	
	exports.default = prefixer;

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(4));
	
	var _addClass = _interopRequireDefault(__webpack_require__(598));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(600));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(926));
	
	var _PropTypes = __webpack_require__(459);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
	 * using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity: 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var appearClassName = _this.getClassNames('appear').doneClassName;
	
	      var enterClassName = _this.getClassNames('enter').doneClassName;
	
	      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames5.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
	      var className = isStringClassNames ? prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
	      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$getClassNames6 = this.getClassNames(type),
	        className = _this$getClassNames6.className,
	        activeClassName = _this$getClassNames6.activeClassName,
	        doneClassName = _this$getClassNames6.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    if (className) {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	      /* eslint-enable no-unused-expressions */
	
	      addClass(node, className);
	    }
	  };
	
	  _proto.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it enters, exits or
	   * has finished the transition. A single name can be provided and it will be
	   * suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
	   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
	   *
	   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
	   * This allows you to define different behavior for when appearing is done and
	   * when regular entering is done, using selectors like
	   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
	   * epic entrance animation when element first appears in the DOM using
	   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   * simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(23));
	
	var _reactLifecyclesCompat = __webpack_require__(45);
	
	var _PropTypes = __webpack_require__(459);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(45);
	
	var _ChildMapping = __webpack_require__(928);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: {
	        isMounting: !this.appeared
	      }
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	    this.mounted = true;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	
	    return _react.default.createElement(Component, props, children);
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes.default.object.isRequired
	};
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ },
/* 929 */
166,
/* 930 */
[1042, 87],
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(930);
	var ReactElement = __webpack_require__(86);
	
	var emptyFunction = __webpack_require__(34);
	var traverseAllChildren = __webpack_require__(939);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(87),
	    _assign = __webpack_require__(18);
	
	var ReactComponent = __webpack_require__(189);
	var ReactElement = __webpack_require__(86);
	var ReactPropTypeLocationNames = __webpack_require__(462);
	var ReactNoopUpdateQueue = __webpack_require__(190);
	
	var emptyObject = __webpack_require__(72);
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(14);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(86);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(86);
	var ReactPropTypeLocationNames = __webpack_require__(462);
	var ReactPropTypesSecret = __webpack_require__(935);
	
	var emptyFunction = __webpack_require__(34);
	var getIteratorFn = __webpack_require__(464);
	var warning = __webpack_require__(14);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	/**
	 * We use an Error-like object for backward compatibility as people may call
	 * PropTypes directly and inspect their output. However we don't use real
	 * Errors anymore. We don't inspect their stack anyway, and creating them
	 * is prohibitively expensive if they are created too often, such as what
	 * happens in oneOfType() for any type before the one that matched.
	 */
	function PropTypeError(message) {
	  this.message = message;
	  this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in production with the next major version. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        if (props[propName] === null) {
	          return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	        }
	        return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 935 */
800,
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var ReactComponent = __webpack_require__(189);
	var ReactNoopUpdateQueue = __webpack_require__(190);
	
	var emptyObject = __webpack_require__(72);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 937 */
427,
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(87);
	
	var ReactElement = __webpack_require__(86);
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(87);
	
	var ReactCurrentOwner = __webpack_require__(38);
	var REACT_ELEMENT_TYPE = __webpack_require__(461);
	
	var getIteratorFn = __webpack_require__(464);
	var invariant = __webpack_require__(6);
	var KeyEscapeUtils = __webpack_require__(929);
	var warning = __webpack_require__(14);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
	 *
	 *  Use of this source code is governed by a BSD-style license
	 *  that can be found in the LICENSE file in the root of the source
	 *  tree.
	 */
	 /* eslint-env node */
	'use strict';
	
	var SDPUtils = __webpack_require__(465);
	
	function fixStatsType(stat) {
	  return {
	    inboundrtp: 'inbound-rtp',
	    outboundrtp: 'outbound-rtp',
	    candidatepair: 'candidate-pair',
	    localcandidate: 'local-candidate',
	    remotecandidate: 'remote-candidate'
	  }[stat.type] || stat.type;
	}
	
	function writeMediaSection(transceiver, caps, type, stream, dtlsRole) {
	  var sdp = SDPUtils.writeRtpDescription(transceiver.kind, caps);
	
	  // Map ICE parameters (ufrag, pwd) to SDP.
	  sdp += SDPUtils.writeIceParameters(
	      transceiver.iceGatherer.getLocalParameters());
	
	  // Map DTLS parameters to SDP.
	  sdp += SDPUtils.writeDtlsParameters(
	      transceiver.dtlsTransport.getLocalParameters(),
	      type === 'offer' ? 'actpass' : dtlsRole || 'active');
	
	  sdp += 'a=mid:' + transceiver.mid + '\r\n';
	
	  if (transceiver.rtpSender && transceiver.rtpReceiver) {
	    sdp += 'a=sendrecv\r\n';
	  } else if (transceiver.rtpSender) {
	    sdp += 'a=sendonly\r\n';
	  } else if (transceiver.rtpReceiver) {
	    sdp += 'a=recvonly\r\n';
	  } else {
	    sdp += 'a=inactive\r\n';
	  }
	
	  if (transceiver.rtpSender) {
	    var trackId = transceiver.rtpSender._initialTrackId ||
	        transceiver.rtpSender.track.id;
	    transceiver.rtpSender._initialTrackId = trackId;
	    // spec.
	    var msid = 'msid:' + (stream ? stream.id : '-') + ' ' +
	        trackId + '\r\n';
	    sdp += 'a=' + msid;
	    // for Chrome. Legacy should no longer be required.
	    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
	        ' ' + msid;
	
	    // RTX
	    if (transceiver.sendEncodingParameters[0].rtx) {
	      sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
	          ' ' + msid;
	      sdp += 'a=ssrc-group:FID ' +
	          transceiver.sendEncodingParameters[0].ssrc + ' ' +
	          transceiver.sendEncodingParameters[0].rtx.ssrc +
	          '\r\n';
	    }
	  }
	  // FIXME: this should be written by writeRtpDescription.
	  sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
	      ' cname:' + SDPUtils.localCName + '\r\n';
	  if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) {
	    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
	        ' cname:' + SDPUtils.localCName + '\r\n';
	  }
	  return sdp;
	}
	
	// Edge does not like
	// 1) stun: filtered after 14393 unless ?transport=udp is present
	// 2) turn: that does not have all of turn:host:port?transport=udp
	// 3) turn: with ipv6 addresses
	// 4) turn: occurring muliple times
	function filterIceServers(iceServers, edgeVersion) {
	  var hasTurn = false;
	  iceServers = JSON.parse(JSON.stringify(iceServers));
	  return iceServers.filter(function(server) {
	    if (server && (server.urls || server.url)) {
	      var urls = server.urls || server.url;
	      if (server.url && !server.urls) {
	        console.warn('RTCIceServer.url is deprecated! Use urls instead.');
	      }
	      var isString = typeof urls === 'string';
	      if (isString) {
	        urls = [urls];
	      }
	      urls = urls.filter(function(url) {
	        var validTurn = url.indexOf('turn:') === 0 &&
	            url.indexOf('transport=udp') !== -1 &&
	            url.indexOf('turn:[') === -1 &&
	            !hasTurn;
	
	        if (validTurn) {
	          hasTurn = true;
	          return true;
	        }
	        return url.indexOf('stun:') === 0 && edgeVersion >= 14393 &&
	            url.indexOf('?transport=udp') === -1;
	      });
	
	      delete server.url;
	      server.urls = isString ? urls[0] : urls;
	      return !!urls.length;
	    }
	  });
	}
	
	// Determines the intersection of local and remote capabilities.
	function getCommonCapabilities(localCapabilities, remoteCapabilities) {
	  var commonCapabilities = {
	    codecs: [],
	    headerExtensions: [],
	    fecMechanisms: []
	  };
	
	  var findCodecByPayloadType = function(pt, codecs) {
	    pt = parseInt(pt, 10);
	    for (var i = 0; i < codecs.length; i++) {
	      if (codecs[i].payloadType === pt ||
	          codecs[i].preferredPayloadType === pt) {
	        return codecs[i];
	      }
	    }
	  };
	
	  var rtxCapabilityMatches = function(lRtx, rRtx, lCodecs, rCodecs) {
	    var lCodec = findCodecByPayloadType(lRtx.parameters.apt, lCodecs);
	    var rCodec = findCodecByPayloadType(rRtx.parameters.apt, rCodecs);
	    return lCodec && rCodec &&
	        lCodec.name.toLowerCase() === rCodec.name.toLowerCase();
	  };
	
	  localCapabilities.codecs.forEach(function(lCodec) {
	    for (var i = 0; i < remoteCapabilities.codecs.length; i++) {
	      var rCodec = remoteCapabilities.codecs[i];
	      if (lCodec.name.toLowerCase() === rCodec.name.toLowerCase() &&
	          lCodec.clockRate === rCodec.clockRate) {
	        if (lCodec.name.toLowerCase() === 'rtx' &&
	            lCodec.parameters && rCodec.parameters.apt) {
	          // for RTX we need to find the local rtx that has a apt
	          // which points to the same local codec as the remote one.
	          if (!rtxCapabilityMatches(lCodec, rCodec,
	              localCapabilities.codecs, remoteCapabilities.codecs)) {
	            continue;
	          }
	        }
	        rCodec = JSON.parse(JSON.stringify(rCodec)); // deepcopy
	        // number of channels is the highest common number of channels
	        rCodec.numChannels = Math.min(lCodec.numChannels,
	            rCodec.numChannels);
	        // push rCodec so we reply with offerer payload type
	        commonCapabilities.codecs.push(rCodec);
	
	        // determine common feedback mechanisms
	        rCodec.rtcpFeedback = rCodec.rtcpFeedback.filter(function(fb) {
	          for (var j = 0; j < lCodec.rtcpFeedback.length; j++) {
	            if (lCodec.rtcpFeedback[j].type === fb.type &&
	                lCodec.rtcpFeedback[j].parameter === fb.parameter) {
	              return true;
	            }
	          }
	          return false;
	        });
	        // FIXME: also need to determine .parameters
	        //  see https://github.com/openpeer/ortc/issues/569
	        break;
	      }
	    }
	  });
	
	  localCapabilities.headerExtensions.forEach(function(lHeaderExtension) {
	    for (var i = 0; i < remoteCapabilities.headerExtensions.length;
	         i++) {
	      var rHeaderExtension = remoteCapabilities.headerExtensions[i];
	      if (lHeaderExtension.uri === rHeaderExtension.uri) {
	        commonCapabilities.headerExtensions.push(rHeaderExtension);
	        break;
	      }
	    }
	  });
	
	  // FIXME: fecMechanisms
	  return commonCapabilities;
	}
	
	// is action=setLocalDescription with type allowed in signalingState
	function isActionAllowedInSignalingState(action, type, signalingState) {
	  return {
	    offer: {
	      setLocalDescription: ['stable', 'have-local-offer'],
	      setRemoteDescription: ['stable', 'have-remote-offer']
	    },
	    answer: {
	      setLocalDescription: ['have-remote-offer', 'have-local-pranswer'],
	      setRemoteDescription: ['have-local-offer', 'have-remote-pranswer']
	    }
	  }[type][action].indexOf(signalingState) !== -1;
	}
	
	function maybeAddCandidate(iceTransport, candidate) {
	  // Edge's internal representation adds some fields therefore
	  // not all fieldѕ are taken into account.
	  var alreadyAdded = iceTransport.getRemoteCandidates()
	      .find(function(remoteCandidate) {
	        return candidate.foundation === remoteCandidate.foundation &&
	            candidate.ip === remoteCandidate.ip &&
	            candidate.port === remoteCandidate.port &&
	            candidate.priority === remoteCandidate.priority &&
	            candidate.protocol === remoteCandidate.protocol &&
	            candidate.type === remoteCandidate.type;
	      });
	  if (!alreadyAdded) {
	    iceTransport.addRemoteCandidate(candidate);
	  }
	  return !alreadyAdded;
	}
	
	
	function makeError(name, description) {
	  var e = new Error(description);
	  e.name = name;
	  // legacy error codes from https://heycam.github.io/webidl/#idl-DOMException-error-names
	  e.code = {
	    NotSupportedError: 9,
	    InvalidStateError: 11,
	    InvalidAccessError: 15,
	    TypeError: undefined,
	    OperationError: undefined
	  }[name];
	  return e;
	}
	
	module.exports = function(window, edgeVersion) {
	  // https://w3c.github.io/mediacapture-main/#mediastream
	  // Helper function to add the track to the stream and
	  // dispatch the event ourselves.
	  function addTrackToStreamAndFireEvent(track, stream) {
	    stream.addTrack(track);
	    stream.dispatchEvent(new window.MediaStreamTrackEvent('addtrack',
	        {track: track}));
	  }
	
	  function removeTrackFromStreamAndFireEvent(track, stream) {
	    stream.removeTrack(track);
	    stream.dispatchEvent(new window.MediaStreamTrackEvent('removetrack',
	        {track: track}));
	  }
	
	  function fireAddTrack(pc, track, receiver, streams) {
	    var trackEvent = new Event('track');
	    trackEvent.track = track;
	    trackEvent.receiver = receiver;
	    trackEvent.transceiver = {receiver: receiver};
	    trackEvent.streams = streams;
	    window.setTimeout(function() {
	      pc._dispatchEvent('track', trackEvent);
	    });
	  }
	
	  var RTCPeerConnection = function(config) {
	    var pc = this;
	
	    var _eventTarget = document.createDocumentFragment();
	    ['addEventListener', 'removeEventListener', 'dispatchEvent']
	        .forEach(function(method) {
	          pc[method] = _eventTarget[method].bind(_eventTarget);
	        });
	
	    this.canTrickleIceCandidates = null;
	
	    this.needNegotiation = false;
	
	    this.localStreams = [];
	    this.remoteStreams = [];
	
	    this._localDescription = null;
	    this._remoteDescription = null;
	
	    this.signalingState = 'stable';
	    this.iceConnectionState = 'new';
	    this.connectionState = 'new';
	    this.iceGatheringState = 'new';
	
	    config = JSON.parse(JSON.stringify(config || {}));
	
	    this.usingBundle = config.bundlePolicy === 'max-bundle';
	    if (config.rtcpMuxPolicy === 'negotiate') {
	      throw(makeError('NotSupportedError',
	          'rtcpMuxPolicy \'negotiate\' is not supported'));
	    } else if (!config.rtcpMuxPolicy) {
	      config.rtcpMuxPolicy = 'require';
	    }
	
	    switch (config.iceTransportPolicy) {
	      case 'all':
	      case 'relay':
	        break;
	      default:
	        config.iceTransportPolicy = 'all';
	        break;
	    }
	
	    switch (config.bundlePolicy) {
	      case 'balanced':
	      case 'max-compat':
	      case 'max-bundle':
	        break;
	      default:
	        config.bundlePolicy = 'balanced';
	        break;
	    }
	
	    config.iceServers = filterIceServers(config.iceServers || [], edgeVersion);
	
	    this._iceGatherers = [];
	    if (config.iceCandidatePoolSize) {
	      for (var i = config.iceCandidatePoolSize; i > 0; i--) {
	        this._iceGatherers.push(new window.RTCIceGatherer({
	          iceServers: config.iceServers,
	          gatherPolicy: config.iceTransportPolicy
	        }));
	      }
	    } else {
	      config.iceCandidatePoolSize = 0;
	    }
	
	    this._config = config;
	
	    // per-track iceGathers, iceTransports, dtlsTransports, rtpSenders, ...
	    // everything that is needed to describe a SDP m-line.
	    this.transceivers = [];
	
	    this._sdpSessionId = SDPUtils.generateSessionId();
	    this._sdpSessionVersion = 0;
	
	    this._dtlsRole = undefined; // role for a=setup to use in answers.
	
	    this._isClosed = false;
	  };
	
	  Object.defineProperty(RTCPeerConnection.prototype, 'localDescription', {
	    configurable: true,
	    get: function() {
	      return this._localDescription;
	    }
	  });
	  Object.defineProperty(RTCPeerConnection.prototype, 'remoteDescription', {
	    configurable: true,
	    get: function() {
	      return this._remoteDescription;
	    }
	  });
	
	  // set up event handlers on prototype
	  RTCPeerConnection.prototype.onicecandidate = null;
	  RTCPeerConnection.prototype.onaddstream = null;
	  RTCPeerConnection.prototype.ontrack = null;
	  RTCPeerConnection.prototype.onremovestream = null;
	  RTCPeerConnection.prototype.onsignalingstatechange = null;
	  RTCPeerConnection.prototype.oniceconnectionstatechange = null;
	  RTCPeerConnection.prototype.onconnectionstatechange = null;
	  RTCPeerConnection.prototype.onicegatheringstatechange = null;
	  RTCPeerConnection.prototype.onnegotiationneeded = null;
	  RTCPeerConnection.prototype.ondatachannel = null;
	
	  RTCPeerConnection.prototype._dispatchEvent = function(name, event) {
	    if (this._isClosed) {
	      return;
	    }
	    this.dispatchEvent(event);
	    if (typeof this['on' + name] === 'function') {
	      this['on' + name](event);
	    }
	  };
	
	  RTCPeerConnection.prototype._emitGatheringStateChange = function() {
	    var event = new Event('icegatheringstatechange');
	    this._dispatchEvent('icegatheringstatechange', event);
	  };
	
	  RTCPeerConnection.prototype.getConfiguration = function() {
	    return this._config;
	  };
	
	  RTCPeerConnection.prototype.getLocalStreams = function() {
	    return this.localStreams;
	  };
	
	  RTCPeerConnection.prototype.getRemoteStreams = function() {
	    return this.remoteStreams;
	  };
	
	  // internal helper to create a transceiver object.
	  // (which is not yet the same as the WebRTC 1.0 transceiver)
	  RTCPeerConnection.prototype._createTransceiver = function(kind, doNotAdd) {
	    var hasBundleTransport = this.transceivers.length > 0;
	    var transceiver = {
	      track: null,
	      iceGatherer: null,
	      iceTransport: null,
	      dtlsTransport: null,
	      localCapabilities: null,
	      remoteCapabilities: null,
	      rtpSender: null,
	      rtpReceiver: null,
	      kind: kind,
	      mid: null,
	      sendEncodingParameters: null,
	      recvEncodingParameters: null,
	      stream: null,
	      associatedRemoteMediaStreams: [],
	      wantReceive: true
	    };
	    if (this.usingBundle && hasBundleTransport) {
	      transceiver.iceTransport = this.transceivers[0].iceTransport;
	      transceiver.dtlsTransport = this.transceivers[0].dtlsTransport;
	    } else {
	      var transports = this._createIceAndDtlsTransports();
	      transceiver.iceTransport = transports.iceTransport;
	      transceiver.dtlsTransport = transports.dtlsTransport;
	    }
	    if (!doNotAdd) {
	      this.transceivers.push(transceiver);
	    }
	    return transceiver;
	  };
	
	  RTCPeerConnection.prototype.addTrack = function(track, stream) {
	    if (this._isClosed) {
	      throw makeError('InvalidStateError',
	          'Attempted to call addTrack on a closed peerconnection.');
	    }
	
	    var alreadyExists = this.transceivers.find(function(s) {
	      return s.track === track;
	    });
	
	    if (alreadyExists) {
	      throw makeError('InvalidAccessError', 'Track already exists.');
	    }
	
	    var transceiver;
	    for (var i = 0; i < this.transceivers.length; i++) {
	      if (!this.transceivers[i].track &&
	          this.transceivers[i].kind === track.kind) {
	        transceiver = this.transceivers[i];
	      }
	    }
	    if (!transceiver) {
	      transceiver = this._createTransceiver(track.kind);
	    }
	
	    this._maybeFireNegotiationNeeded();
	
	    if (this.localStreams.indexOf(stream) === -1) {
	      this.localStreams.push(stream);
	    }
	
	    transceiver.track = track;
	    transceiver.stream = stream;
	    transceiver.rtpSender = new window.RTCRtpSender(track,
	        transceiver.dtlsTransport);
	    return transceiver.rtpSender;
	  };
	
	  RTCPeerConnection.prototype.addStream = function(stream) {
	    var pc = this;
	    if (edgeVersion >= 15025) {
	      stream.getTracks().forEach(function(track) {
	        pc.addTrack(track, stream);
	      });
	    } else {
	      // Clone is necessary for local demos mostly, attaching directly
	      // to two different senders does not work (build 10547).
	      // Fixed in 15025 (or earlier)
	      var clonedStream = stream.clone();
	      stream.getTracks().forEach(function(track, idx) {
	        var clonedTrack = clonedStream.getTracks()[idx];
	        track.addEventListener('enabled', function(event) {
	          clonedTrack.enabled = event.enabled;
	        });
	      });
	      clonedStream.getTracks().forEach(function(track) {
	        pc.addTrack(track, clonedStream);
	      });
	    }
	  };
	
	  RTCPeerConnection.prototype.removeTrack = function(sender) {
	    if (this._isClosed) {
	      throw makeError('InvalidStateError',
	          'Attempted to call removeTrack on a closed peerconnection.');
	    }
	
	    if (!(sender instanceof window.RTCRtpSender)) {
	      throw new TypeError('Argument 1 of RTCPeerConnection.removeTrack ' +
	          'does not implement interface RTCRtpSender.');
	    }
	
	    var transceiver = this.transceivers.find(function(t) {
	      return t.rtpSender === sender;
	    });
	
	    if (!transceiver) {
	      throw makeError('InvalidAccessError',
	          'Sender was not created by this connection.');
	    }
	    var stream = transceiver.stream;
	
	    transceiver.rtpSender.stop();
	    transceiver.rtpSender = null;
	    transceiver.track = null;
	    transceiver.stream = null;
	
	    // remove the stream from the set of local streams
	    var localStreams = this.transceivers.map(function(t) {
	      return t.stream;
	    });
	    if (localStreams.indexOf(stream) === -1 &&
	        this.localStreams.indexOf(stream) > -1) {
	      this.localStreams.splice(this.localStreams.indexOf(stream), 1);
	    }
	
	    this._maybeFireNegotiationNeeded();
	  };
	
	  RTCPeerConnection.prototype.removeStream = function(stream) {
	    var pc = this;
	    stream.getTracks().forEach(function(track) {
	      var sender = pc.getSenders().find(function(s) {
	        return s.track === track;
	      });
	      if (sender) {
	        pc.removeTrack(sender);
	      }
	    });
	  };
	
	  RTCPeerConnection.prototype.getSenders = function() {
	    return this.transceivers.filter(function(transceiver) {
	      return !!transceiver.rtpSender;
	    })
	    .map(function(transceiver) {
	      return transceiver.rtpSender;
	    });
	  };
	
	  RTCPeerConnection.prototype.getReceivers = function() {
	    return this.transceivers.filter(function(transceiver) {
	      return !!transceiver.rtpReceiver;
	    })
	    .map(function(transceiver) {
	      return transceiver.rtpReceiver;
	    });
	  };
	
	
	  RTCPeerConnection.prototype._createIceGatherer = function(sdpMLineIndex,
	      usingBundle) {
	    var pc = this;
	    if (usingBundle && sdpMLineIndex > 0) {
	      return this.transceivers[0].iceGatherer;
	    } else if (this._iceGatherers.length) {
	      return this._iceGatherers.shift();
	    }
	    var iceGatherer = new window.RTCIceGatherer({
	      iceServers: this._config.iceServers,
	      gatherPolicy: this._config.iceTransportPolicy
	    });
	    Object.defineProperty(iceGatherer, 'state',
	        {value: 'new', writable: true}
	    );
	
	    this.transceivers[sdpMLineIndex].bufferedCandidateEvents = [];
	    this.transceivers[sdpMLineIndex].bufferCandidates = function(event) {
	      var end = !event.candidate || Object.keys(event.candidate).length === 0;
	      // polyfill since RTCIceGatherer.state is not implemented in
	      // Edge 10547 yet.
	      iceGatherer.state = end ? 'completed' : 'gathering';
	      if (pc.transceivers[sdpMLineIndex].bufferedCandidateEvents !== null) {
	        pc.transceivers[sdpMLineIndex].bufferedCandidateEvents.push(event);
	      }
	    };
	    iceGatherer.addEventListener('localcandidate',
	      this.transceivers[sdpMLineIndex].bufferCandidates);
	    return iceGatherer;
	  };
	
	  // start gathering from an RTCIceGatherer.
	  RTCPeerConnection.prototype._gather = function(mid, sdpMLineIndex) {
	    var pc = this;
	    var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;
	    if (iceGatherer.onlocalcandidate) {
	      return;
	    }
	    var bufferedCandidateEvents =
	      this.transceivers[sdpMLineIndex].bufferedCandidateEvents;
	    this.transceivers[sdpMLineIndex].bufferedCandidateEvents = null;
	    iceGatherer.removeEventListener('localcandidate',
	      this.transceivers[sdpMLineIndex].bufferCandidates);
	    iceGatherer.onlocalcandidate = function(evt) {
	      if (pc.usingBundle && sdpMLineIndex > 0) {
	        // if we know that we use bundle we can drop candidates with
	        // ѕdpMLineIndex > 0. If we don't do this then our state gets
	        // confused since we dispose the extra ice gatherer.
	        return;
	      }
	      var event = new Event('icecandidate');
	      event.candidate = {sdpMid: mid, sdpMLineIndex: sdpMLineIndex};
	
	      var cand = evt.candidate;
	      // Edge emits an empty object for RTCIceCandidateComplete‥
	      var end = !cand || Object.keys(cand).length === 0;
	      if (end) {
	        // polyfill since RTCIceGatherer.state is not implemented in
	        // Edge 10547 yet.
	        if (iceGatherer.state === 'new' || iceGatherer.state === 'gathering') {
	          iceGatherer.state = 'completed';
	        }
	      } else {
	        if (iceGatherer.state === 'new') {
	          iceGatherer.state = 'gathering';
	        }
	        // RTCIceCandidate doesn't have a component, needs to be added
	        cand.component = 1;
	        // also the usernameFragment. TODO: update SDP to take both variants.
	        cand.ufrag = iceGatherer.getLocalParameters().usernameFragment;
	
	        var serializedCandidate = SDPUtils.writeCandidate(cand);
	        event.candidate = Object.assign(event.candidate,
	            SDPUtils.parseCandidate(serializedCandidate));
	
	        event.candidate.candidate = serializedCandidate;
	        event.candidate.toJSON = function() {
	          return {
	            candidate: event.candidate.candidate,
	            sdpMid: event.candidate.sdpMid,
	            sdpMLineIndex: event.candidate.sdpMLineIndex,
	            usernameFragment: event.candidate.usernameFragment
	          };
	        };
	      }
	
	      // update local description.
	      var sections = SDPUtils.getMediaSections(pc._localDescription.sdp);
	      if (!end) {
	        sections[event.candidate.sdpMLineIndex] +=
	            'a=' + event.candidate.candidate + '\r\n';
	      } else {
	        sections[event.candidate.sdpMLineIndex] +=
	            'a=end-of-candidates\r\n';
	      }
	      pc._localDescription.sdp =
	          SDPUtils.getDescription(pc._localDescription.sdp) +
	          sections.join('');
	      var complete = pc.transceivers.every(function(transceiver) {
	        return transceiver.iceGatherer &&
	            transceiver.iceGatherer.state === 'completed';
	      });
	
	      if (pc.iceGatheringState !== 'gathering') {
	        pc.iceGatheringState = 'gathering';
	        pc._emitGatheringStateChange();
	      }
	
	      // Emit candidate. Also emit null candidate when all gatherers are
	      // complete.
	      if (!end) {
	        pc._dispatchEvent('icecandidate', event);
	      }
	      if (complete) {
	        pc._dispatchEvent('icecandidate', new Event('icecandidate'));
	        pc.iceGatheringState = 'complete';
	        pc._emitGatheringStateChange();
	      }
	    };
	
	    // emit already gathered candidates.
	    window.setTimeout(function() {
	      bufferedCandidateEvents.forEach(function(e) {
	        iceGatherer.onlocalcandidate(e);
	      });
	    }, 0);
	  };
	
	  // Create ICE transport and DTLS transport.
	  RTCPeerConnection.prototype._createIceAndDtlsTransports = function() {
	    var pc = this;
	    var iceTransport = new window.RTCIceTransport(null);
	    iceTransport.onicestatechange = function() {
	      pc._updateIceConnectionState();
	      pc._updateConnectionState();
	    };
	
	    var dtlsTransport = new window.RTCDtlsTransport(iceTransport);
	    dtlsTransport.ondtlsstatechange = function() {
	      pc._updateConnectionState();
	    };
	    dtlsTransport.onerror = function() {
	      // onerror does not set state to failed by itself.
	      Object.defineProperty(dtlsTransport, 'state',
	          {value: 'failed', writable: true});
	      pc._updateConnectionState();
	    };
	
	    return {
	      iceTransport: iceTransport,
	      dtlsTransport: dtlsTransport
	    };
	  };
	
	  // Destroy ICE gatherer, ICE transport and DTLS transport.
	  // Without triggering the callbacks.
	  RTCPeerConnection.prototype._disposeIceAndDtlsTransports = function(
	      sdpMLineIndex) {
	    var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;
	    if (iceGatherer) {
	      delete iceGatherer.onlocalcandidate;
	      delete this.transceivers[sdpMLineIndex].iceGatherer;
	    }
	    var iceTransport = this.transceivers[sdpMLineIndex].iceTransport;
	    if (iceTransport) {
	      delete iceTransport.onicestatechange;
	      delete this.transceivers[sdpMLineIndex].iceTransport;
	    }
	    var dtlsTransport = this.transceivers[sdpMLineIndex].dtlsTransport;
	    if (dtlsTransport) {
	      delete dtlsTransport.ondtlsstatechange;
	      delete dtlsTransport.onerror;
	      delete this.transceivers[sdpMLineIndex].dtlsTransport;
	    }
	  };
	
	  // Start the RTP Sender and Receiver for a transceiver.
	  RTCPeerConnection.prototype._transceive = function(transceiver,
	      send, recv) {
	    var params = getCommonCapabilities(transceiver.localCapabilities,
	        transceiver.remoteCapabilities);
	    if (send && transceiver.rtpSender) {
	      params.encodings = transceiver.sendEncodingParameters;
	      params.rtcp = {
	        cname: SDPUtils.localCName,
	        compound: transceiver.rtcpParameters.compound
	      };
	      if (transceiver.recvEncodingParameters.length) {
	        params.rtcp.ssrc = transceiver.recvEncodingParameters[0].ssrc;
	      }
	      transceiver.rtpSender.send(params);
	    }
	    if (recv && transceiver.rtpReceiver && params.codecs.length > 0) {
	      // remove RTX field in Edge 14942
	      if (transceiver.kind === 'video'
	          && transceiver.recvEncodingParameters
	          && edgeVersion < 15019) {
	        transceiver.recvEncodingParameters.forEach(function(p) {
	          delete p.rtx;
	        });
	      }
	      if (transceiver.recvEncodingParameters.length) {
	        params.encodings = transceiver.recvEncodingParameters;
	      } else {
	        params.encodings = [{}];
	      }
	      params.rtcp = {
	        compound: transceiver.rtcpParameters.compound
	      };
	      if (transceiver.rtcpParameters.cname) {
	        params.rtcp.cname = transceiver.rtcpParameters.cname;
	      }
	      if (transceiver.sendEncodingParameters.length) {
	        params.rtcp.ssrc = transceiver.sendEncodingParameters[0].ssrc;
	      }
	      transceiver.rtpReceiver.receive(params);
	    }
	  };
	
	  RTCPeerConnection.prototype.setLocalDescription = function(description) {
	    var pc = this;
	
	    // Note: pranswer is not supported.
	    if (['offer', 'answer'].indexOf(description.type) === -1) {
	      return Promise.reject(makeError('TypeError',
	          'Unsupported type "' + description.type + '"'));
	    }
	
	    if (!isActionAllowedInSignalingState('setLocalDescription',
	        description.type, pc.signalingState) || pc._isClosed) {
	      return Promise.reject(makeError('InvalidStateError',
	          'Can not set local ' + description.type +
	          ' in state ' + pc.signalingState));
	    }
	
	    var sections;
	    var sessionpart;
	    if (description.type === 'offer') {
	      // VERY limited support for SDP munging. Limited to:
	      // * changing the order of codecs
	      sections = SDPUtils.splitSections(description.sdp);
	      sessionpart = sections.shift();
	      sections.forEach(function(mediaSection, sdpMLineIndex) {
	        var caps = SDPUtils.parseRtpParameters(mediaSection);
	        pc.transceivers[sdpMLineIndex].localCapabilities = caps;
	      });
	
	      pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
	        pc._gather(transceiver.mid, sdpMLineIndex);
	      });
	    } else if (description.type === 'answer') {
	      sections = SDPUtils.splitSections(pc._remoteDescription.sdp);
	      sessionpart = sections.shift();
	      var isIceLite = SDPUtils.matchPrefix(sessionpart,
	          'a=ice-lite').length > 0;
	      sections.forEach(function(mediaSection, sdpMLineIndex) {
	        var transceiver = pc.transceivers[sdpMLineIndex];
	        var iceGatherer = transceiver.iceGatherer;
	        var iceTransport = transceiver.iceTransport;
	        var dtlsTransport = transceiver.dtlsTransport;
	        var localCapabilities = transceiver.localCapabilities;
	        var remoteCapabilities = transceiver.remoteCapabilities;
	
	        // treat bundle-only as not-rejected.
	        var rejected = SDPUtils.isRejected(mediaSection) &&
	            SDPUtils.matchPrefix(mediaSection, 'a=bundle-only').length === 0;
	
	        if (!rejected && !transceiver.rejected) {
	          var remoteIceParameters = SDPUtils.getIceParameters(
	              mediaSection, sessionpart);
	          var remoteDtlsParameters = SDPUtils.getDtlsParameters(
	              mediaSection, sessionpart);
	          if (isIceLite) {
	            remoteDtlsParameters.role = 'server';
	          }
	
	          if (!pc.usingBundle || sdpMLineIndex === 0) {
	            pc._gather(transceiver.mid, sdpMLineIndex);
	            if (iceTransport.state === 'new') {
	              iceTransport.start(iceGatherer, remoteIceParameters,
	                  isIceLite ? 'controlling' : 'controlled');
	            }
	            if (dtlsTransport.state === 'new') {
	              dtlsTransport.start(remoteDtlsParameters);
	            }
	          }
	
	          // Calculate intersection of capabilities.
	          var params = getCommonCapabilities(localCapabilities,
	              remoteCapabilities);
	
	          // Start the RTCRtpSender. The RTCRtpReceiver for this
	          // transceiver has already been started in setRemoteDescription.
	          pc._transceive(transceiver,
	              params.codecs.length > 0,
	              false);
	        }
	      });
	    }
	
	    pc._localDescription = {
	      type: description.type,
	      sdp: description.sdp
	    };
	    if (description.type === 'offer') {
	      pc._updateSignalingState('have-local-offer');
	    } else {
	      pc._updateSignalingState('stable');
	    }
	
	    return Promise.resolve();
	  };
	
	  RTCPeerConnection.prototype.setRemoteDescription = function(description) {
	    var pc = this;
	
	    // Note: pranswer is not supported.
	    if (['offer', 'answer'].indexOf(description.type) === -1) {
	      return Promise.reject(makeError('TypeError',
	          'Unsupported type "' + description.type + '"'));
	    }
	
	    if (!isActionAllowedInSignalingState('setRemoteDescription',
	        description.type, pc.signalingState) || pc._isClosed) {
	      return Promise.reject(makeError('InvalidStateError',
	          'Can not set remote ' + description.type +
	          ' in state ' + pc.signalingState));
	    }
	
	    var streams = {};
	    pc.remoteStreams.forEach(function(stream) {
	      streams[stream.id] = stream;
	    });
	    var receiverList = [];
	    var sections = SDPUtils.splitSections(description.sdp);
	    var sessionpart = sections.shift();
	    var isIceLite = SDPUtils.matchPrefix(sessionpart,
	        'a=ice-lite').length > 0;
	    var usingBundle = SDPUtils.matchPrefix(sessionpart,
	        'a=group:BUNDLE ').length > 0;
	    pc.usingBundle = usingBundle;
	    var iceOptions = SDPUtils.matchPrefix(sessionpart,
	        'a=ice-options:')[0];
	    if (iceOptions) {
	      pc.canTrickleIceCandidates = iceOptions.substr(14).split(' ')
	          .indexOf('trickle') >= 0;
	    } else {
	      pc.canTrickleIceCandidates = false;
	    }
	
	    sections.forEach(function(mediaSection, sdpMLineIndex) {
	      var lines = SDPUtils.splitLines(mediaSection);
	      var kind = SDPUtils.getKind(mediaSection);
	      // treat bundle-only as not-rejected.
	      var rejected = SDPUtils.isRejected(mediaSection) &&
	          SDPUtils.matchPrefix(mediaSection, 'a=bundle-only').length === 0;
	      var protocol = lines[0].substr(2).split(' ')[2];
	
	      var direction = SDPUtils.getDirection(mediaSection, sessionpart);
	      var remoteMsid = SDPUtils.parseMsid(mediaSection);
	
	      var mid = SDPUtils.getMid(mediaSection) || SDPUtils.generateIdentifier();
	
	      // Reject datachannels which are not implemented yet.
	      if (rejected || (kind === 'application' && (protocol === 'DTLS/SCTP' ||
	          protocol === 'UDP/DTLS/SCTP'))) {
	        // TODO: this is dangerous in the case where a non-rejected m-line
	        //     becomes rejected.
	        pc.transceivers[sdpMLineIndex] = {
	          mid: mid,
	          kind: kind,
	          protocol: protocol,
	          rejected: true
	        };
	        return;
	      }
	
	      if (!rejected && pc.transceivers[sdpMLineIndex] &&
	          pc.transceivers[sdpMLineIndex].rejected) {
	        // recycle a rejected transceiver.
	        pc.transceivers[sdpMLineIndex] = pc._createTransceiver(kind, true);
	      }
	
	      var transceiver;
	      var iceGatherer;
	      var iceTransport;
	      var dtlsTransport;
	      var rtpReceiver;
	      var sendEncodingParameters;
	      var recvEncodingParameters;
	      var localCapabilities;
	
	      var track;
	      // FIXME: ensure the mediaSection has rtcp-mux set.
	      var remoteCapabilities = SDPUtils.parseRtpParameters(mediaSection);
	      var remoteIceParameters;
	      var remoteDtlsParameters;
	      if (!rejected) {
	        remoteIceParameters = SDPUtils.getIceParameters(mediaSection,
	            sessionpart);
	        remoteDtlsParameters = SDPUtils.getDtlsParameters(mediaSection,
	            sessionpart);
	        remoteDtlsParameters.role = 'client';
	      }
	      recvEncodingParameters =
	          SDPUtils.parseRtpEncodingParameters(mediaSection);
	
	      var rtcpParameters = SDPUtils.parseRtcpParameters(mediaSection);
	
	      var isComplete = SDPUtils.matchPrefix(mediaSection,
	          'a=end-of-candidates', sessionpart).length > 0;
	      var cands = SDPUtils.matchPrefix(mediaSection, 'a=candidate:')
	          .map(function(cand) {
	            return SDPUtils.parseCandidate(cand);
	          })
	          .filter(function(cand) {
	            return cand.component === 1;
	          });
	
	      // Check if we can use BUNDLE and dispose transports.
	      if ((description.type === 'offer' || description.type === 'answer') &&
	          !rejected && usingBundle && sdpMLineIndex > 0 &&
	          pc.transceivers[sdpMLineIndex]) {
	        pc._disposeIceAndDtlsTransports(sdpMLineIndex);
	        pc.transceivers[sdpMLineIndex].iceGatherer =
	            pc.transceivers[0].iceGatherer;
	        pc.transceivers[sdpMLineIndex].iceTransport =
	            pc.transceivers[0].iceTransport;
	        pc.transceivers[sdpMLineIndex].dtlsTransport =
	            pc.transceivers[0].dtlsTransport;
	        if (pc.transceivers[sdpMLineIndex].rtpSender) {
	          pc.transceivers[sdpMLineIndex].rtpSender.setTransport(
	              pc.transceivers[0].dtlsTransport);
	        }
	        if (pc.transceivers[sdpMLineIndex].rtpReceiver) {
	          pc.transceivers[sdpMLineIndex].rtpReceiver.setTransport(
	              pc.transceivers[0].dtlsTransport);
	        }
	      }
	      if (description.type === 'offer' && !rejected) {
	        transceiver = pc.transceivers[sdpMLineIndex] ||
	            pc._createTransceiver(kind);
	        transceiver.mid = mid;
	
	        if (!transceiver.iceGatherer) {
	          transceiver.iceGatherer = pc._createIceGatherer(sdpMLineIndex,
	              usingBundle);
	        }
	
	        if (cands.length && transceiver.iceTransport.state === 'new') {
	          if (isComplete && (!usingBundle || sdpMLineIndex === 0)) {
	            transceiver.iceTransport.setRemoteCandidates(cands);
	          } else {
	            cands.forEach(function(candidate) {
	              maybeAddCandidate(transceiver.iceTransport, candidate);
	            });
	          }
	        }
	
	        localCapabilities = window.RTCRtpReceiver.getCapabilities(kind);
	
	        // filter RTX until additional stuff needed for RTX is implemented
	        // in adapter.js
	        if (edgeVersion < 15019) {
	          localCapabilities.codecs = localCapabilities.codecs.filter(
	              function(codec) {
	                return codec.name !== 'rtx';
	              });
	        }
	
	        sendEncodingParameters = transceiver.sendEncodingParameters || [{
	          ssrc: (2 * sdpMLineIndex + 2) * 1001
	        }];
	
	        // TODO: rewrite to use http://w3c.github.io/webrtc-pc/#set-associated-remote-streams
	        var isNewTrack = false;
	        if (direction === 'sendrecv' || direction === 'sendonly') {
	          isNewTrack = !transceiver.rtpReceiver;
	          rtpReceiver = transceiver.rtpReceiver ||
	              new window.RTCRtpReceiver(transceiver.dtlsTransport, kind);
	
	          if (isNewTrack) {
	            var stream;
	            track = rtpReceiver.track;
	            // FIXME: does not work with Plan B.
	            if (remoteMsid && remoteMsid.stream === '-') {
	              // no-op. a stream id of '-' means: no associated stream.
	            } else if (remoteMsid) {
	              if (!streams[remoteMsid.stream]) {
	                streams[remoteMsid.stream] = new window.MediaStream();
	                Object.defineProperty(streams[remoteMsid.stream], 'id', {
	                  get: function() {
	                    return remoteMsid.stream;
	                  }
	                });
	              }
	              Object.defineProperty(track, 'id', {
	                get: function() {
	                  return remoteMsid.track;
	                }
	              });
	              stream = streams[remoteMsid.stream];
	            } else {
	              if (!streams.default) {
	                streams.default = new window.MediaStream();
	              }
	              stream = streams.default;
	            }
	            if (stream) {
	              addTrackToStreamAndFireEvent(track, stream);
	              transceiver.associatedRemoteMediaStreams.push(stream);
	            }
	            receiverList.push([track, rtpReceiver, stream]);
	          }
	        } else if (transceiver.rtpReceiver && transceiver.rtpReceiver.track) {
	          transceiver.associatedRemoteMediaStreams.forEach(function(s) {
	            var nativeTrack = s.getTracks().find(function(t) {
	              return t.id === transceiver.rtpReceiver.track.id;
	            });
	            if (nativeTrack) {
	              removeTrackFromStreamAndFireEvent(nativeTrack, s);
	            }
	          });
	          transceiver.associatedRemoteMediaStreams = [];
	        }
	
	        transceiver.localCapabilities = localCapabilities;
	        transceiver.remoteCapabilities = remoteCapabilities;
	        transceiver.rtpReceiver = rtpReceiver;
	        transceiver.rtcpParameters = rtcpParameters;
	        transceiver.sendEncodingParameters = sendEncodingParameters;
	        transceiver.recvEncodingParameters = recvEncodingParameters;
	
	        // Start the RTCRtpReceiver now. The RTPSender is started in
	        // setLocalDescription.
	        pc._transceive(pc.transceivers[sdpMLineIndex],
	            false,
	            isNewTrack);
	      } else if (description.type === 'answer' && !rejected) {
	        transceiver = pc.transceivers[sdpMLineIndex];
	        iceGatherer = transceiver.iceGatherer;
	        iceTransport = transceiver.iceTransport;
	        dtlsTransport = transceiver.dtlsTransport;
	        rtpReceiver = transceiver.rtpReceiver;
	        sendEncodingParameters = transceiver.sendEncodingParameters;
	        localCapabilities = transceiver.localCapabilities;
	
	        pc.transceivers[sdpMLineIndex].recvEncodingParameters =
	            recvEncodingParameters;
	        pc.transceivers[sdpMLineIndex].remoteCapabilities =
	            remoteCapabilities;
	        pc.transceivers[sdpMLineIndex].rtcpParameters = rtcpParameters;
	
	        if (cands.length && iceTransport.state === 'new') {
	          if ((isIceLite || isComplete) &&
	              (!usingBundle || sdpMLineIndex === 0)) {
	            iceTransport.setRemoteCandidates(cands);
	          } else {
	            cands.forEach(function(candidate) {
	              maybeAddCandidate(transceiver.iceTransport, candidate);
	            });
	          }
	        }
	
	        if (!usingBundle || sdpMLineIndex === 0) {
	          if (iceTransport.state === 'new') {
	            iceTransport.start(iceGatherer, remoteIceParameters,
	                'controlling');
	          }
	          if (dtlsTransport.state === 'new') {
	            dtlsTransport.start(remoteDtlsParameters);
	          }
	        }
	
	        // If the offer contained RTX but the answer did not,
	        // remove RTX from sendEncodingParameters.
	        var commonCapabilities = getCommonCapabilities(
	          transceiver.localCapabilities,
	          transceiver.remoteCapabilities);
	
	        var hasRtx = commonCapabilities.codecs.filter(function(c) {
	          return c.name.toLowerCase() === 'rtx';
	        }).length;
	        if (!hasRtx && transceiver.sendEncodingParameters[0].rtx) {
	          delete transceiver.sendEncodingParameters[0].rtx;
	        }
	
	        pc._transceive(transceiver,
	            direction === 'sendrecv' || direction === 'recvonly',
	            direction === 'sendrecv' || direction === 'sendonly');
	
	        // TODO: rewrite to use http://w3c.github.io/webrtc-pc/#set-associated-remote-streams
	        if (rtpReceiver &&
	            (direction === 'sendrecv' || direction === 'sendonly')) {
	          track = rtpReceiver.track;
	          if (remoteMsid) {
	            if (!streams[remoteMsid.stream]) {
	              streams[remoteMsid.stream] = new window.MediaStream();
	            }
	            addTrackToStreamAndFireEvent(track, streams[remoteMsid.stream]);
	            receiverList.push([track, rtpReceiver, streams[remoteMsid.stream]]);
	          } else {
	            if (!streams.default) {
	              streams.default = new window.MediaStream();
	            }
	            addTrackToStreamAndFireEvent(track, streams.default);
	            receiverList.push([track, rtpReceiver, streams.default]);
	          }
	        } else {
	          // FIXME: actually the receiver should be created later.
	          delete transceiver.rtpReceiver;
	        }
	      }
	    });
	
	    if (pc._dtlsRole === undefined) {
	      pc._dtlsRole = description.type === 'offer' ? 'active' : 'passive';
	    }
	
	    pc._remoteDescription = {
	      type: description.type,
	      sdp: description.sdp
	    };
	    if (description.type === 'offer') {
	      pc._updateSignalingState('have-remote-offer');
	    } else {
	      pc._updateSignalingState('stable');
	    }
	    Object.keys(streams).forEach(function(sid) {
	      var stream = streams[sid];
	      if (stream.getTracks().length) {
	        if (pc.remoteStreams.indexOf(stream) === -1) {
	          pc.remoteStreams.push(stream);
	          var event = new Event('addstream');
	          event.stream = stream;
	          window.setTimeout(function() {
	            pc._dispatchEvent('addstream', event);
	          });
	        }
	
	        receiverList.forEach(function(item) {
	          var track = item[0];
	          var receiver = item[1];
	          if (stream.id !== item[2].id) {
	            return;
	          }
	          fireAddTrack(pc, track, receiver, [stream]);
	        });
	      }
	    });
	    receiverList.forEach(function(item) {
	      if (item[2]) {
	        return;
	      }
	      fireAddTrack(pc, item[0], item[1], []);
	    });
	
	    // check whether addIceCandidate({}) was called within four seconds after
	    // setRemoteDescription.
	    window.setTimeout(function() {
	      if (!(pc && pc.transceivers)) {
	        return;
	      }
	      pc.transceivers.forEach(function(transceiver) {
	        if (transceiver.iceTransport &&
	            transceiver.iceTransport.state === 'new' &&
	            transceiver.iceTransport.getRemoteCandidates().length > 0) {
	          console.warn('Timeout for addRemoteCandidate. Consider sending ' +
	              'an end-of-candidates notification');
	          transceiver.iceTransport.addRemoteCandidate({});
	        }
	      });
	    }, 4000);
	
	    return Promise.resolve();
	  };
	
	  RTCPeerConnection.prototype.close = function() {
	    this.transceivers.forEach(function(transceiver) {
	      /* not yet
	      if (transceiver.iceGatherer) {
	        transceiver.iceGatherer.close();
	      }
	      */
	      if (transceiver.iceTransport) {
	        transceiver.iceTransport.stop();
	      }
	      if (transceiver.dtlsTransport) {
	        transceiver.dtlsTransport.stop();
	      }
	      if (transceiver.rtpSender) {
	        transceiver.rtpSender.stop();
	      }
	      if (transceiver.rtpReceiver) {
	        transceiver.rtpReceiver.stop();
	      }
	    });
	    // FIXME: clean up tracks, local streams, remote streams, etc
	    this._isClosed = true;
	    this._updateSignalingState('closed');
	  };
	
	  // Update the signaling state.
	  RTCPeerConnection.prototype._updateSignalingState = function(newState) {
	    this.signalingState = newState;
	    var event = new Event('signalingstatechange');
	    this._dispatchEvent('signalingstatechange', event);
	  };
	
	  // Determine whether to fire the negotiationneeded event.
	  RTCPeerConnection.prototype._maybeFireNegotiationNeeded = function() {
	    var pc = this;
	    if (this.signalingState !== 'stable' || this.needNegotiation === true) {
	      return;
	    }
	    this.needNegotiation = true;
	    window.setTimeout(function() {
	      if (pc.needNegotiation) {
	        pc.needNegotiation = false;
	        var event = new Event('negotiationneeded');
	        pc._dispatchEvent('negotiationneeded', event);
	      }
	    }, 0);
	  };
	
	  // Update the ice connection state.
	  RTCPeerConnection.prototype._updateIceConnectionState = function() {
	    var newState;
	    var states = {
	      'new': 0,
	      closed: 0,
	      checking: 0,
	      connected: 0,
	      completed: 0,
	      disconnected: 0,
	      failed: 0
	    };
	    this.transceivers.forEach(function(transceiver) {
	      if (transceiver.iceTransport && !transceiver.rejected) {
	        states[transceiver.iceTransport.state]++;
	      }
	    });
	
	    newState = 'new';
	    if (states.failed > 0) {
	      newState = 'failed';
	    } else if (states.checking > 0) {
	      newState = 'checking';
	    } else if (states.disconnected > 0) {
	      newState = 'disconnected';
	    } else if (states.new > 0) {
	      newState = 'new';
	    } else if (states.connected > 0) {
	      newState = 'connected';
	    } else if (states.completed > 0) {
	      newState = 'completed';
	    }
	
	    if (newState !== this.iceConnectionState) {
	      this.iceConnectionState = newState;
	      var event = new Event('iceconnectionstatechange');
	      this._dispatchEvent('iceconnectionstatechange', event);
	    }
	  };
	
	  // Update the connection state.
	  RTCPeerConnection.prototype._updateConnectionState = function() {
	    var newState;
	    var states = {
	      'new': 0,
	      closed: 0,
	      connecting: 0,
	      connected: 0,
	      completed: 0,
	      disconnected: 0,
	      failed: 0
	    };
	    this.transceivers.forEach(function(transceiver) {
	      if (transceiver.iceTransport && transceiver.dtlsTransport &&
	          !transceiver.rejected) {
	        states[transceiver.iceTransport.state]++;
	        states[transceiver.dtlsTransport.state]++;
	      }
	    });
	    // ICETransport.completed and connected are the same for this purpose.
	    states.connected += states.completed;
	
	    newState = 'new';
	    if (states.failed > 0) {
	      newState = 'failed';
	    } else if (states.connecting > 0) {
	      newState = 'connecting';
	    } else if (states.disconnected > 0) {
	      newState = 'disconnected';
	    } else if (states.new > 0) {
	      newState = 'new';
	    } else if (states.connected > 0) {
	      newState = 'connected';
	    }
	
	    if (newState !== this.connectionState) {
	      this.connectionState = newState;
	      var event = new Event('connectionstatechange');
	      this._dispatchEvent('connectionstatechange', event);
	    }
	  };
	
	  RTCPeerConnection.prototype.createOffer = function() {
	    var pc = this;
	
	    if (pc._isClosed) {
	      return Promise.reject(makeError('InvalidStateError',
	          'Can not call createOffer after close'));
	    }
	
	    var numAudioTracks = pc.transceivers.filter(function(t) {
	      return t.kind === 'audio';
	    }).length;
	    var numVideoTracks = pc.transceivers.filter(function(t) {
	      return t.kind === 'video';
	    }).length;
	
	    // Determine number of audio and video tracks we need to send/recv.
	    var offerOptions = arguments[0];
	    if (offerOptions) {
	      // Reject Chrome legacy constraints.
	      if (offerOptions.mandatory || offerOptions.optional) {
	        throw new TypeError(
	            'Legacy mandatory/optional constraints not supported.');
	      }
	      if (offerOptions.offerToReceiveAudio !== undefined) {
	        if (offerOptions.offerToReceiveAudio === true) {
	          numAudioTracks = 1;
	        } else if (offerOptions.offerToReceiveAudio === false) {
	          numAudioTracks = 0;
	        } else {
	          numAudioTracks = offerOptions.offerToReceiveAudio;
	        }
	      }
	      if (offerOptions.offerToReceiveVideo !== undefined) {
	        if (offerOptions.offerToReceiveVideo === true) {
	          numVideoTracks = 1;
	        } else if (offerOptions.offerToReceiveVideo === false) {
	          numVideoTracks = 0;
	        } else {
	          numVideoTracks = offerOptions.offerToReceiveVideo;
	        }
	      }
	    }
	
	    pc.transceivers.forEach(function(transceiver) {
	      if (transceiver.kind === 'audio') {
	        numAudioTracks--;
	        if (numAudioTracks < 0) {
	          transceiver.wantReceive = false;
	        }
	      } else if (transceiver.kind === 'video') {
	        numVideoTracks--;
	        if (numVideoTracks < 0) {
	          transceiver.wantReceive = false;
	        }
	      }
	    });
	
	    // Create M-lines for recvonly streams.
	    while (numAudioTracks > 0 || numVideoTracks > 0) {
	      if (numAudioTracks > 0) {
	        pc._createTransceiver('audio');
	        numAudioTracks--;
	      }
	      if (numVideoTracks > 0) {
	        pc._createTransceiver('video');
	        numVideoTracks--;
	      }
	    }
	
	    var sdp = SDPUtils.writeSessionBoilerplate(pc._sdpSessionId,
	        pc._sdpSessionVersion++);
	    pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
	      // For each track, create an ice gatherer, ice transport,
	      // dtls transport, potentially rtpsender and rtpreceiver.
	      var track = transceiver.track;
	      var kind = transceiver.kind;
	      var mid = transceiver.mid || SDPUtils.generateIdentifier();
	      transceiver.mid = mid;
	
	      if (!transceiver.iceGatherer) {
	        transceiver.iceGatherer = pc._createIceGatherer(sdpMLineIndex,
	            pc.usingBundle);
	      }
	
	      var localCapabilities = window.RTCRtpSender.getCapabilities(kind);
	      // filter RTX until additional stuff needed for RTX is implemented
	      // in adapter.js
	      if (edgeVersion < 15019) {
	        localCapabilities.codecs = localCapabilities.codecs.filter(
	            function(codec) {
	              return codec.name !== 'rtx';
	            });
	      }
	      localCapabilities.codecs.forEach(function(codec) {
	        // work around https://bugs.chromium.org/p/webrtc/issues/detail?id=6552
	        // by adding level-asymmetry-allowed=1
	        if (codec.name === 'H264' &&
	            codec.parameters['level-asymmetry-allowed'] === undefined) {
	          codec.parameters['level-asymmetry-allowed'] = '1';
	        }
	
	        // for subsequent offers, we might have to re-use the payload
	        // type of the last offer.
	        if (transceiver.remoteCapabilities &&
	            transceiver.remoteCapabilities.codecs) {
	          transceiver.remoteCapabilities.codecs.forEach(function(remoteCodec) {
	            if (codec.name.toLowerCase() === remoteCodec.name.toLowerCase() &&
	                codec.clockRate === remoteCodec.clockRate) {
	              codec.preferredPayloadType = remoteCodec.payloadType;
	            }
	          });
	        }
	      });
	      localCapabilities.headerExtensions.forEach(function(hdrExt) {
	        var remoteExtensions = transceiver.remoteCapabilities &&
	            transceiver.remoteCapabilities.headerExtensions || [];
	        remoteExtensions.forEach(function(rHdrExt) {
	          if (hdrExt.uri === rHdrExt.uri) {
	            hdrExt.id = rHdrExt.id;
	          }
	        });
	      });
	
	      // generate an ssrc now, to be used later in rtpSender.send
	      var sendEncodingParameters = transceiver.sendEncodingParameters || [{
	        ssrc: (2 * sdpMLineIndex + 1) * 1001
	      }];
	      if (track) {
	        // add RTX
	        if (edgeVersion >= 15019 && kind === 'video' &&
	            !sendEncodingParameters[0].rtx) {
	          sendEncodingParameters[0].rtx = {
	            ssrc: sendEncodingParameters[0].ssrc + 1
	          };
	        }
	      }
	
	      if (transceiver.wantReceive) {
	        transceiver.rtpReceiver = new window.RTCRtpReceiver(
	            transceiver.dtlsTransport, kind);
	      }
	
	      transceiver.localCapabilities = localCapabilities;
	      transceiver.sendEncodingParameters = sendEncodingParameters;
	    });
	
	    // always offer BUNDLE and dispose on return if not supported.
	    if (pc._config.bundlePolicy !== 'max-compat') {
	      sdp += 'a=group:BUNDLE ' + pc.transceivers.map(function(t) {
	        return t.mid;
	      }).join(' ') + '\r\n';
	    }
	    sdp += 'a=ice-options:trickle\r\n';
	
	    pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
	      sdp += writeMediaSection(transceiver, transceiver.localCapabilities,
	          'offer', transceiver.stream, pc._dtlsRole);
	      sdp += 'a=rtcp-rsize\r\n';
	
	      if (transceiver.iceGatherer && pc.iceGatheringState !== 'new' &&
	          (sdpMLineIndex === 0 || !pc.usingBundle)) {
	        transceiver.iceGatherer.getLocalCandidates().forEach(function(cand) {
	          cand.component = 1;
	          sdp += 'a=' + SDPUtils.writeCandidate(cand) + '\r\n';
	        });
	
	        if (transceiver.iceGatherer.state === 'completed') {
	          sdp += 'a=end-of-candidates\r\n';
	        }
	      }
	    });
	
	    var desc = new window.RTCSessionDescription({
	      type: 'offer',
	      sdp: sdp
	    });
	    return Promise.resolve(desc);
	  };
	
	  RTCPeerConnection.prototype.createAnswer = function() {
	    var pc = this;
	
	    if (pc._isClosed) {
	      return Promise.reject(makeError('InvalidStateError',
	          'Can not call createAnswer after close'));
	    }
	
	    if (!(pc.signalingState === 'have-remote-offer' ||
	        pc.signalingState === 'have-local-pranswer')) {
	      return Promise.reject(makeError('InvalidStateError',
	          'Can not call createAnswer in signalingState ' + pc.signalingState));
	    }
	
	    var sdp = SDPUtils.writeSessionBoilerplate(pc._sdpSessionId,
	        pc._sdpSessionVersion++);
	    if (pc.usingBundle) {
	      sdp += 'a=group:BUNDLE ' + pc.transceivers.map(function(t) {
	        return t.mid;
	      }).join(' ') + '\r\n';
	    }
	    sdp += 'a=ice-options:trickle\r\n';
	
	    var mediaSectionsInOffer = SDPUtils.getMediaSections(
	        pc._remoteDescription.sdp).length;
	    pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
	      if (sdpMLineIndex + 1 > mediaSectionsInOffer) {
	        return;
	      }
	      if (transceiver.rejected) {
	        if (transceiver.kind === 'application') {
	          if (transceiver.protocol === 'DTLS/SCTP') { // legacy fmt
	            sdp += 'm=application 0 DTLS/SCTP 5000\r\n';
	          } else {
	            sdp += 'm=application 0 ' + transceiver.protocol +
	                ' webrtc-datachannel\r\n';
	          }
	        } else if (transceiver.kind === 'audio') {
	          sdp += 'm=audio 0 UDP/TLS/RTP/SAVPF 0\r\n' +
	              'a=rtpmap:0 PCMU/8000\r\n';
	        } else if (transceiver.kind === 'video') {
	          sdp += 'm=video 0 UDP/TLS/RTP/SAVPF 120\r\n' +
	              'a=rtpmap:120 VP8/90000\r\n';
	        }
	        sdp += 'c=IN IP4 0.0.0.0\r\n' +
	            'a=inactive\r\n' +
	            'a=mid:' + transceiver.mid + '\r\n';
	        return;
	      }
	
	      // FIXME: look at direction.
	      if (transceiver.stream) {
	        var localTrack;
	        if (transceiver.kind === 'audio') {
	          localTrack = transceiver.stream.getAudioTracks()[0];
	        } else if (transceiver.kind === 'video') {
	          localTrack = transceiver.stream.getVideoTracks()[0];
	        }
	        if (localTrack) {
	          // add RTX
	          if (edgeVersion >= 15019 && transceiver.kind === 'video' &&
	              !transceiver.sendEncodingParameters[0].rtx) {
	            transceiver.sendEncodingParameters[0].rtx = {
	              ssrc: transceiver.sendEncodingParameters[0].ssrc + 1
	            };
	          }
	        }
	      }
	
	      // Calculate intersection of capabilities.
	      var commonCapabilities = getCommonCapabilities(
	          transceiver.localCapabilities,
	          transceiver.remoteCapabilities);
	
	      var hasRtx = commonCapabilities.codecs.filter(function(c) {
	        return c.name.toLowerCase() === 'rtx';
	      }).length;
	      if (!hasRtx && transceiver.sendEncodingParameters[0].rtx) {
	        delete transceiver.sendEncodingParameters[0].rtx;
	      }
	
	      sdp += writeMediaSection(transceiver, commonCapabilities,
	          'answer', transceiver.stream, pc._dtlsRole);
	      if (transceiver.rtcpParameters &&
	          transceiver.rtcpParameters.reducedSize) {
	        sdp += 'a=rtcp-rsize\r\n';
	      }
	    });
	
	    var desc = new window.RTCSessionDescription({
	      type: 'answer',
	      sdp: sdp
	    });
	    return Promise.resolve(desc);
	  };
	
	  RTCPeerConnection.prototype.addIceCandidate = function(candidate) {
	    var pc = this;
	    var sections;
	    if (candidate && !(candidate.sdpMLineIndex !== undefined ||
	        candidate.sdpMid)) {
	      return Promise.reject(new TypeError('sdpMLineIndex or sdpMid required'));
	    }
	
	    // TODO: needs to go into ops queue.
	    return new Promise(function(resolve, reject) {
	      if (!pc._remoteDescription) {
	        return reject(makeError('InvalidStateError',
	            'Can not add ICE candidate without a remote description'));
	      } else if (!candidate || candidate.candidate === '') {
	        for (var j = 0; j < pc.transceivers.length; j++) {
	          if (pc.transceivers[j].rejected) {
	            continue;
	          }
	          pc.transceivers[j].iceTransport.addRemoteCandidate({});
	          sections = SDPUtils.getMediaSections(pc._remoteDescription.sdp);
	          sections[j] += 'a=end-of-candidates\r\n';
	          pc._remoteDescription.sdp =
	              SDPUtils.getDescription(pc._remoteDescription.sdp) +
	              sections.join('');
	          if (pc.usingBundle) {
	            break;
	          }
	        }
	      } else {
	        var sdpMLineIndex = candidate.sdpMLineIndex;
	        if (candidate.sdpMid) {
	          for (var i = 0; i < pc.transceivers.length; i++) {
	            if (pc.transceivers[i].mid === candidate.sdpMid) {
	              sdpMLineIndex = i;
	              break;
	            }
	          }
	        }
	        var transceiver = pc.transceivers[sdpMLineIndex];
	        if (transceiver) {
	          if (transceiver.rejected) {
	            return resolve();
	          }
	          var cand = Object.keys(candidate.candidate).length > 0 ?
	              SDPUtils.parseCandidate(candidate.candidate) : {};
	          // Ignore Chrome's invalid candidates since Edge does not like them.
	          if (cand.protocol === 'tcp' && (cand.port === 0 || cand.port === 9)) {
	            return resolve();
	          }
	          // Ignore RTCP candidates, we assume RTCP-MUX.
	          if (cand.component && cand.component !== 1) {
	            return resolve();
	          }
	          // when using bundle, avoid adding candidates to the wrong
	          // ice transport. And avoid adding candidates added in the SDP.
	          if (sdpMLineIndex === 0 || (sdpMLineIndex > 0 &&
	              transceiver.iceTransport !== pc.transceivers[0].iceTransport)) {
	            if (!maybeAddCandidate(transceiver.iceTransport, cand)) {
	              return reject(makeError('OperationError',
	                  'Can not add ICE candidate'));
	            }
	          }
	
	          // update the remoteDescription.
	          var candidateString = candidate.candidate.trim();
	          if (candidateString.indexOf('a=') === 0) {
	            candidateString = candidateString.substr(2);
	          }
	          sections = SDPUtils.getMediaSections(pc._remoteDescription.sdp);
	          sections[sdpMLineIndex] += 'a=' +
	              (cand.type ? candidateString : 'end-of-candidates')
	              + '\r\n';
	          pc._remoteDescription.sdp =
	              SDPUtils.getDescription(pc._remoteDescription.sdp) +
	              sections.join('');
	        } else {
	          return reject(makeError('OperationError',
	              'Can not add ICE candidate'));
	        }
	      }
	      resolve();
	    });
	  };
	
	  RTCPeerConnection.prototype.getStats = function(selector) {
	    if (selector && selector instanceof window.MediaStreamTrack) {
	      var senderOrReceiver = null;
	      this.transceivers.forEach(function(transceiver) {
	        if (transceiver.rtpSender &&
	            transceiver.rtpSender.track === selector) {
	          senderOrReceiver = transceiver.rtpSender;
	        } else if (transceiver.rtpReceiver &&
	            transceiver.rtpReceiver.track === selector) {
	          senderOrReceiver = transceiver.rtpReceiver;
	        }
	      });
	      if (!senderOrReceiver) {
	        throw makeError('InvalidAccessError', 'Invalid selector.');
	      }
	      return senderOrReceiver.getStats();
	    }
	
	    var promises = [];
	    this.transceivers.forEach(function(transceiver) {
	      ['rtpSender', 'rtpReceiver', 'iceGatherer', 'iceTransport',
	          'dtlsTransport'].forEach(function(method) {
	            if (transceiver[method]) {
	              promises.push(transceiver[method].getStats());
	            }
	          });
	    });
	    return Promise.all(promises).then(function(allStats) {
	      var results = new Map();
	      allStats.forEach(function(stats) {
	        stats.forEach(function(stat) {
	          results.set(stat.id, stat);
	        });
	      });
	      return results;
	    });
	  };
	
	  // fix low-level stat names and return Map instead of object.
	  var ortcObjects = ['RTCRtpSender', 'RTCRtpReceiver', 'RTCIceGatherer',
	    'RTCIceTransport', 'RTCDtlsTransport'];
	  ortcObjects.forEach(function(ortcObjectName) {
	    var obj = window[ortcObjectName];
	    if (obj && obj.prototype && obj.prototype.getStats) {
	      var nativeGetstats = obj.prototype.getStats;
	      obj.prototype.getStats = function() {
	        return nativeGetstats.apply(this)
	        .then(function(nativeStats) {
	          var mapStats = new Map();
	          Object.keys(nativeStats).forEach(function(id) {
	            nativeStats[id].type = fixStatsType(nativeStats[id]);
	            mapStats.set(id, nativeStats[id]);
	          });
	          return mapStats;
	        });
	      };
	    }
	  });
	
	  // legacy callback shims. Should be moved to adapter.js some days.
	  var methods = ['createOffer', 'createAnswer'];
	  methods.forEach(function(method) {
	    var nativeMethod = RTCPeerConnection.prototype[method];
	    RTCPeerConnection.prototype[method] = function() {
	      var args = arguments;
	      if (typeof args[0] === 'function' ||
	          typeof args[1] === 'function') { // legacy
	        return nativeMethod.apply(this, [arguments[2]])
	        .then(function(description) {
	          if (typeof args[0] === 'function') {
	            args[0].apply(null, [description]);
	          }
	        }, function(error) {
	          if (typeof args[1] === 'function') {
	            args[1].apply(null, [error]);
	          }
	        });
	      }
	      return nativeMethod.apply(this, arguments);
	    };
	  });
	
	  methods = ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate'];
	  methods.forEach(function(method) {
	    var nativeMethod = RTCPeerConnection.prototype[method];
	    RTCPeerConnection.prototype[method] = function() {
	      var args = arguments;
	      if (typeof args[1] === 'function' ||
	          typeof args[2] === 'function') { // legacy
	        return nativeMethod.apply(this, arguments)
	        .then(function() {
	          if (typeof args[1] === 'function') {
	            args[1].apply(null);
	          }
	        }, function(error) {
	          if (typeof args[2] === 'function') {
	            args[2].apply(null, [error]);
	          }
	        });
	      }
	      return nativeMethod.apply(this, arguments);
	    };
	  });
	
	  // getStats is special. It doesn't have a spec legacy method yet we support
	  // getStats(something, cb) without error callbacks.
	  ['getStats'].forEach(function(method) {
	    var nativeMethod = RTCPeerConnection.prototype[method];
	    RTCPeerConnection.prototype[method] = function() {
	      var args = arguments;
	      if (typeof args[1] === 'function') {
	        return nativeMethod.apply(this, arguments)
	        .then(function() {
	          if (typeof args[1] === 'function') {
	            args[1].apply(null);
	          }
	        });
	      }
	      return nativeMethod.apply(this, arguments);
	    };
	  });
	
	  return RTCPeerConnection;
	};


/***/ },
/* 942 */
/***/ function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ },
/* 943 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 944 */
/***/ function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	
	var space = __webpack_require__(948)
	
	/**
	 * Export.
	 */
	
	module.exports = toCamelCase
	
	/**
	 * Convert a `string` to camel case.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function toCamelCase(string) {
	  return space(string).replace(/\s(\w)/g, function (matches, letter) {
	    return letter.toUpperCase()
	  })
	}


/***/ },
/* 947 */
/***/ function(module, exports) {

	
	/**
	 * Export.
	 */
	
	module.exports = toNoCase
	
	/**
	 * Test whether a string is camel-case.
	 */
	
	var hasSpace = /\s/
	var hasSeparator = /(_|-|\.|:)/
	var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/
	
	/**
	 * Remove any starting case from a `string`, like camel or snake, but keep
	 * spaces and punctuation that may be important otherwise.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function toNoCase(string) {
	  if (hasSpace.test(string)) return string.toLowerCase()
	  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
	  if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
	  return string.toLowerCase()
	}
	
	/**
	 * Separator splitter.
	 */
	
	var separatorSplitter = /[\W_]+(.|$)/g
	
	/**
	 * Un-separate a `string`.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function unseparate(string) {
	  return string.replace(separatorSplitter, function (m, next) {
	    return next ? ' ' + next : ''
	  })
	}
	
	/**
	 * Camelcase splitter.
	 */
	
	var camelSplitter = /(.)([A-Z]+)/g
	
	/**
	 * Un-camelcase a `string`.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function uncamelize(string) {
	  return string.replace(camelSplitter, function (m, previous, uppers) {
	    return previous + ' ' + uppers.toLowerCase().split('').join(' ')
	  })
	}


/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	
	var clean = __webpack_require__(947)
	
	/**
	 * Export.
	 */
	
	module.exports = toSpaceCase
	
	/**
	 * Convert a `string` to space case.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function toSpaceCase(string) {
	  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
	    return match ? ' ' + match : ''
	  }).trim()
	}


/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	var _camelize = __webpack_require__(950);
	var _curry = __webpack_require__(550);
	
	module.exports = _curry(function camelize(str) {
	  return _camelize(str, true);
	});


/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	var trim = __webpack_require__(954);
	var decap = __webpack_require__(951);
	
	module.exports = function camelize(str, decapitalize) {
	  str = trim(str).replace(/[-_\s]+(.)?/g, function(match, c) {
	    return c ? c.toUpperCase() : "";
	  });
	
	  if (decapitalize === true) {
	    return decap(str);
	  } else {
	    return str;
	  }
	};


/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(191);
	
	module.exports = function decapitalize(str) {
	  str = makeString(str);
	  return str.charAt(0).toLowerCase() + str.slice(1);
	};


/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	var escapeRegExp = __webpack_require__(953);
	
	module.exports = function defaultToWhiteSpace(characters) {
	  if (characters == null)
	    return '\\s';
	  else if (characters.source)
	    return characters.source;
	  else
	    return '[' + escapeRegExp(characters) + ']';
	};


/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(191);
	
	module.exports = function escapeRegExp(str) {
	  return makeString(str).replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
	};


/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(191);
	var defaultToWhiteSpace = __webpack_require__(952);
	var nativeTrim = String.prototype.trim;
	
	module.exports = function trim(str, characters) {
	  str = makeString(str);
	  if (!characters && nativeTrim) return nativeTrim.call(str);
	  characters = defaultToWhiteSpace(characters);
	  return str.replace(new RegExp('^' + characters + '+|' + characters + '+$', 'g'), '');
	};


/***/ },
/* 955 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.updateInputWidth = exports.measureText = exports.getFontShorthand = void 0;
	var allowedVariants = ['normal', 'small-caps'];
	/**
	 * Gets font CSS shorthand property given element.
	 *
	 * @param {HTMLElement} element Element to get font CSS shorthand property from
	 */
	function getFontShorthand(element) {
	    if (!element) {
	        return '';
	    }
	    var style = window.getComputedStyle(element);
	    if (style.font) {
	        return style.font;
	    }
	    var isFontDefined = style.fontFamily !== '';
	    if (!isFontDefined) {
	        return '';
	    }
	    var fontVariant = allowedVariants.includes(style.fontVariant) ? style.fontVariant : 'normal';
	    return "".concat(style.fontStyle, " ").concat(fontVariant, " ").concat(style.fontWeight, " ").concat(style.fontSize, " / ").concat(style.lineHeight, " ").concat(style.fontFamily);
	}
	exports.getFontShorthand = getFontShorthand;
	var cachedCanvas;
	/**
	 * Measures text width given text and font CSS shorthand.
	 *
	 * @param {string} text Text to measure
	 * @param {string} font Font to use when measuring the text
	 */
	function measureText(text, font) {
	    var canvas = cachedCanvas || (cachedCanvas = document.createElement('canvas'));
	    var context = canvas.getContext('2d');
	    // Context type not supported
	    if (!context) {
	        return null;
	    }
	    context.font = font;
	    var width = context.measureText(text).width;
	    return Math.ceil(width);
	}
	exports.measureText = measureText;
	/**
	 * Updates input element width to fit its content given input element
	 * @param {HTMLInputElement} element
	 */
	function updateInputWidth(element) {
	    if (typeof document === 'undefined' || !element) {
	        return null;
	    }
	    var font = getFontShorthand(element);
	    var text = element.value || element.placeholder;
	    var width = measureText(text, font);
	    if (width === null) {
	        return null;
	    }
	    element.style.width = "".concat(width, "px");
	    return width;
	}
	exports.updateInputWidth = updateInputWidth;
	exports.default = updateInputWidth;


/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/loader.a4f2cb80.gif";

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/products-no-image.379bdc70.jpg";

/***/ },
/* 958 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 959 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 960 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production","PUBLIC_URL":""}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(960);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(959);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(75)))

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = contains;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	var _toString = _interopRequireDefault(__webpack_require__(475));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function contains(str, elem) {
	  (0, _assertString.default)(str);
	  return str.indexOf((0, _toString.default)(elem)) >= 0;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = equals;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function equals(str, comparison) {
	  (0, _assertString.default)(str);
	  return str === comparison;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = escape;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escape(str) {
	  (0, _assertString.default)(str);
	  return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\//g, '&#x2F;').replace(/\\/g, '&#x5C;').replace(/`/g, '&#96;');
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAfter;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	var _toDate = _interopRequireDefault(__webpack_require__(193));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAfter(str) {
	  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
	  (0, _assertString.default)(str);
	  var comparison = (0, _toDate.default)(date);
	  var original = (0, _toDate.default)(str);
	  return !!(original && comparison && original > comparison);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAlpha;
	exports.locales = void 0;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	var _alpha = __webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAlpha(str) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
	  (0, _assertString.default)(str);
	
	  if (locale in _alpha.alpha) {
	    return _alpha.alpha[locale].test(str);
	  }
	
	  throw new Error("Invalid locale '".concat(locale, "'"));
	}
	
	var locales = Object.keys(_alpha.alpha);
	exports.locales = locales;

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAlphanumeric;
	exports.locales = void 0;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	var _alpha = __webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAlphanumeric(str) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
	  (0, _assertString.default)(str);
	
	  if (locale in _alpha.alphanumeric) {
	    return _alpha.alphanumeric[locale].test(str);
	  }
	
	  throw new Error("Invalid locale '".concat(locale, "'"));
	}
	
	var locales = Object.keys(_alpha.alphanumeric);
	exports.locales = locales;

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAscii;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-control-regex */
	var ascii = /^[\x00-\x7F]+$/;
	/* eslint-enable no-control-regex */
	
	function isAscii(str) {
	  (0, _assertString.default)(str);
	  return ascii.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBase32;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var base32 = /^[A-Z2-7]+=*$/;
	
	function isBase32(str) {
	  (0, _assertString.default)(str);
	  var len = str.length;
	
	  if (len > 0 && len % 8 === 0 && base32.test(str)) {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBase64;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var notBase64 = /[^A-Z0-9+\/=]/i;
	
	function isBase64(str) {
	  (0, _assertString.default)(str);
	  var len = str.length;
	
	  if (!len || len % 4 !== 0 || notBase64.test(str)) {
	    return false;
	  }
	
	  var firstPaddingChar = str.indexOf('=');
	  return firstPaddingChar === -1 || firstPaddingChar === len - 1 || firstPaddingChar === len - 2 && str[len - 1] === '=';
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBefore;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	var _toDate = _interopRequireDefault(__webpack_require__(193));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBefore(str) {
	  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
	  (0, _assertString.default)(str);
	  var comparison = (0, _toDate.default)(date);
	  var original = (0, _toDate.default)(str);
	  return !!(original && comparison && original < comparison);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBoolean;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBoolean(str) {
	  (0, _assertString.default)(str);
	  return ['true', 'false', '1', '0'].indexOf(str) >= 0;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isCreditCard;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|6[27][0-9]{14})$/;
	/* eslint-enable max-len */
	
	function isCreditCard(str) {
	  (0, _assertString.default)(str);
	  var sanitized = str.replace(/[- ]+/g, '');
	
	  if (!creditCard.test(sanitized)) {
	    return false;
	  }
	
	  var sum = 0;
	  var digit;
	  var tmpNum;
	  var shouldDouble;
	
	  for (var i = sanitized.length - 1; i >= 0; i--) {
	    digit = sanitized.substring(i, i + 1);
	    tmpNum = parseInt(digit, 10);
	
	    if (shouldDouble) {
	      tmpNum *= 2;
	
	      if (tmpNum >= 10) {
	        sum += tmpNum % 10 + 1;
	      } else {
	        sum += tmpNum;
	      }
	    } else {
	      sum += tmpNum;
	    }
	
	    shouldDouble = !shouldDouble;
	  }
	
	  return !!(sum % 10 === 0 ? sanitized : false);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isCurrency;
	
	var _merge = _interopRequireDefault(__webpack_require__(63));
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function currencyRegex(options) {
	  var decimal_digits = "\\d{".concat(options.digits_after_decimal[0], "}");
	  options.digits_after_decimal.forEach(function (digit, index) {
	    if (index !== 0) decimal_digits = "".concat(decimal_digits, "|\\d{").concat(digit, "}");
	  });
	  var symbol = "(\\".concat(options.symbol.replace(/\./g, '\\.'), ")").concat(options.require_symbol ? '' : '?'),
	      negative = '-?',
	      whole_dollar_amount_without_sep = '[1-9]\\d*',
	      whole_dollar_amount_with_sep = "[1-9]\\d{0,2}(\\".concat(options.thousands_separator, "\\d{3})*"),
	      valid_whole_dollar_amounts = ['0', whole_dollar_amount_without_sep, whole_dollar_amount_with_sep],
	      whole_dollar_amount = "(".concat(valid_whole_dollar_amounts.join('|'), ")?"),
	      decimal_amount = "(\\".concat(options.decimal_separator, "(").concat(decimal_digits, "))").concat(options.require_decimal ? '' : '?');
	  var pattern = whole_dollar_amount + (options.allow_decimal || options.require_decimal ? decimal_amount : ''); // default is negative sign before symbol, but there are two other options (besides parens)
	
	  if (options.allow_negatives && !options.parens_for_negatives) {
	    if (options.negative_sign_after_digits) {
	      pattern += negative;
	    } else if (options.negative_sign_before_digits) {
	      pattern = negative + pattern;
	    }
	  } // South African Rand, for example, uses R 123 (space) and R-123 (no space)
	
	
	  if (options.allow_negative_sign_placeholder) {
	    pattern = "( (?!\\-))?".concat(pattern);
	  } else if (options.allow_space_after_symbol) {
	    pattern = " ?".concat(pattern);
	  } else if (options.allow_space_after_digits) {
	    pattern += '( (?!$))?';
	  }
	
	  if (options.symbol_after_digits) {
	    pattern += symbol;
	  } else {
	    pattern = symbol + pattern;
	  }
	
	  if (options.allow_negatives) {
	    if (options.parens_for_negatives) {
	      pattern = "(\\(".concat(pattern, "\\)|").concat(pattern, ")");
	    } else if (!(options.negative_sign_before_digits || options.negative_sign_after_digits)) {
	      pattern = negative + pattern;
	    }
	  } // ensure there's a dollar and/or decimal amount, and that
	  // it doesn't start with a space or a negative sign followed by a space
	
	
	  return new RegExp("^(?!-? )(?=.*\\d)".concat(pattern, "$"));
	}
	
	var default_currency_options = {
	  symbol: '$',
	  require_symbol: false,
	  allow_space_after_symbol: false,
	  symbol_after_digits: false,
	  allow_negatives: true,
	  parens_for_negatives: false,
	  negative_sign_before_digits: false,
	  negative_sign_after_digits: false,
	  allow_negative_sign_placeholder: false,
	  thousands_separator: ',',
	  decimal_separator: '.',
	  allow_decimal: true,
	  require_decimal: false,
	  digits_after_decimal: [2],
	  allow_space_after_digits: false
	};
	
	function isCurrency(str, options) {
	  (0, _assertString.default)(str);
	  options = (0, _merge.default)(options, default_currency_options);
	  return currencyRegex(options).test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDataURI;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validMediaType = /^[a-z]+\/[a-z0-9\-\+]+$/i;
	var validAttribute = /^[a-z\-]+=[a-z0-9\-]+$/i;
	var validData = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;
	
	function isDataURI(str) {
	  (0, _assertString.default)(str);
	  var data = str.split(',');
	
	  if (data.length < 2) {
	    return false;
	  }
	
	  var attributes = data.shift().trim().split(';');
	  var schemeAndMediaType = attributes.shift();
	
	  if (schemeAndMediaType.substr(0, 5) !== 'data:') {
	    return false;
	  }
	
	  var mediaType = schemeAndMediaType.substr(5);
	
	  if (mediaType !== '' && !validMediaType.test(mediaType)) {
	    return false;
	  }
	
	  for (var i = 0; i < attributes.length; i++) {
	    if (i === attributes.length - 1 && attributes[i].toLowerCase() === 'base64') {// ok
	    } else if (!validAttribute.test(attributes[i])) {
	      return false;
	    }
	  }
	
	  for (var _i = 0; _i < data.length; _i++) {
	    if (!validData.test(data[_i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDecimal;
	
	var _merge = _interopRequireDefault(__webpack_require__(63));
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	var _includes = _interopRequireDefault(__webpack_require__(194));
	
	var _alpha = __webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function decimalRegExp(options) {
	  var regExp = new RegExp("^[-+]?([0-9]+)?(\\".concat(_alpha.decimal[options.locale], "[0-9]{").concat(options.decimal_digits, "})").concat(options.force_decimal ? '' : '?', "$"));
	  return regExp;
	}
	
	var default_decimal_options = {
	  force_decimal: false,
	  decimal_digits: '1,',
	  locale: 'en-US'
	};
	var blacklist = ['', '-', '+'];
	
	function isDecimal(str, options) {
	  (0, _assertString.default)(str);
	  options = (0, _merge.default)(options, default_decimal_options);
	
	  if (options.locale in _alpha.decimal) {
	    return !(0, _includes.default)(blacklist, str.replace(/ /g, '')) && decimalRegExp(options).test(str);
	  }
	
	  throw new Error("Invalid locale '".concat(options.locale, "'"));
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDivisibleBy;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	var _toFloat = _interopRequireDefault(__webpack_require__(474));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isDivisibleBy(str, num) {
	  (0, _assertString.default)(str);
	  return (0, _toFloat.default)(str) % parseInt(num, 10) === 0;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmail;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	var _merge = _interopRequireDefault(__webpack_require__(63));
	
	var _isByteLength = _interopRequireDefault(__webpack_require__(467));
	
	var _isFQDN = _interopRequireDefault(__webpack_require__(192));
	
	var _isIP = _interopRequireDefault(__webpack_require__(127));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var default_email_options = {
	  allow_display_name: false,
	  require_display_name: false,
	  allow_utf8_local_part: true,
	  require_tld: true
	};
	/* eslint-disable max-len */
	
	/* eslint-disable no-control-regex */
	
	var splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)<(.+)>$/i;
	var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
	var gmailUserPart = /^[a-z\d]+$/;
	var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
	var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
	var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
	var defaultMaxEmailLength = 254;
	/* eslint-enable max-len */
	
	/* eslint-enable no-control-regex */
	
	/**
	 * Validate display name according to the RFC2822: https://tools.ietf.org/html/rfc2822#appendix-A.1.2
	 * @param {String} display_name
	 */
	
	function validateDisplayName(display_name) {
	  var trim_quotes = display_name.match(/^"(.+)"$/i);
	  var display_name_without_quotes = trim_quotes ? trim_quotes[1] : display_name; // display name with only spaces is not valid
	
	  if (!display_name_without_quotes.trim()) {
	    return false;
	  } // check whether display name contains illegal character
	
	
	  var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);
	
	  if (contains_illegal) {
	    // if contains illegal characters,
	    // must to be enclosed in double-quotes, otherwise it's not a valid display name
	    if (!trim_quotes) {
	      return false;
	    } // the quotes in display name must start with character symbol \
	
	
	    var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;
	
	    if (!all_start_with_back_slash) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function isEmail(str, options) {
	  (0, _assertString.default)(str);
	  options = (0, _merge.default)(options, default_email_options);
	
	  if (options.require_display_name || options.allow_display_name) {
	    var display_email = str.match(splitNameAddress);
	
	    if (display_email) {
	      var display_name;
	
	      var _display_email = _slicedToArray(display_email, 3);
	
	      display_name = _display_email[1];
	      str = _display_email[2];
	
	      // sometimes need to trim the last space to get the display name
	      // because there may be a space between display name and email address
	      // eg. myname <address@gmail.com>
	      // the display name is `myname` instead of `myname `, so need to trim the last space
	      if (display_name.endsWith(' ')) {
	        display_name = display_name.substr(0, display_name.length - 1);
	      }
	
	      if (!validateDisplayName(display_name)) {
	        return false;
	      }
	    } else if (options.require_display_name) {
	      return false;
	    }
	  }
	
	  if (!options.ignore_max_length && str.length > defaultMaxEmailLength) {
	    return false;
	  }
	
	  var parts = str.split('@');
	  var domain = parts.pop();
	  var user = parts.join('@');
	  var lower_domain = domain.toLowerCase();
	
	  if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
	    /*
	      Previously we removed dots for gmail addresses before validating.
	      This was removed because it allows `multiple..dots@gmail.com`
	      to be reported as valid, but it is not.
	      Gmail only normalizes single dots, removing them from here is pointless,
	      should be done in normalizeEmail
	    */
	    user = user.toLowerCase(); // Removing sub-address from username before gmail validation
	
	    var username = user.split('+')[0]; // Dots are not included in gmail length restriction
	
	    if (!(0, _isByteLength.default)(username.replace('.', ''), {
	      min: 6,
	      max: 30
	    })) {
	      return false;
	    }
	
	    var _user_parts = username.split('.');
	
	    for (var i = 0; i < _user_parts.length; i++) {
	      if (!gmailUserPart.test(_user_parts[i])) {
	        return false;
	      }
	    }
	  }
	
	  if (!(0, _isByteLength.default)(user, {
	    max: 64
	  }) || !(0, _isByteLength.default)(domain, {
	    max: 254
	  })) {
	    return false;
	  }
	
	  if (!(0, _isFQDN.default)(domain, {
	    require_tld: options.require_tld
	  })) {
	    if (!options.allow_ip_domain) {
	      return false;
	    }
	
	    if (!(0, _isIP.default)(domain)) {
	      if (!domain.startsWith('[') || !domain.endsWith(']')) {
	        return false;
	      }
	
	      var noBracketdomain = domain.substr(1, domain.length - 2);
	
	      if (noBracketdomain.length === 0 || !(0, _isIP.default)(noBracketdomain)) {
	        return false;
	      }
	    }
	  }
	
	  if (user[0] === '"') {
	    user = user.slice(1, user.length - 1);
	    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
	  }
	
	  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
	  var user_parts = user.split('.');
	
	  for (var _i2 = 0; _i2 < user_parts.length; _i2++) {
	    if (!pattern.test(user_parts[_i2])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmpty;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	var _merge = _interopRequireDefault(__webpack_require__(63));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_is_empty_options = {
	  ignore_whitespace: false
	};
	
	function isEmpty(str, options) {
	  (0, _assertString.default)(str);
	  options = (0, _merge.default)(options, default_is_empty_options);
	  return (options.ignore_whitespace ? str.trim().length : str.length) === 0;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFloat;
	exports.locales = void 0;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	var _alpha = __webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isFloat(str, options) {
	  (0, _assertString.default)(str);
	  options = options || {};
	  var float = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(options.locale ? _alpha.decimal[options.locale] : '.', "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));
	
	  if (str === '' || str === '.' || str === '-' || str === '+') {
	    return false;
	  }
	
	  var value = parseFloat(str.replace(',', '.'));
	  return float.test(str) && (!options.hasOwnProperty('min') || value >= options.min) && (!options.hasOwnProperty('max') || value <= options.max) && (!options.hasOwnProperty('lt') || value < options.lt) && (!options.hasOwnProperty('gt') || value > options.gt);
	}
	
	var locales = Object.keys(_alpha.decimal);
	exports.locales = locales;

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHash;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lengths = {
	  md5: 32,
	  md4: 32,
	  sha1: 40,
	  sha256: 64,
	  sha384: 96,
	  sha512: 128,
	  ripemd128: 32,
	  ripemd160: 40,
	  tiger128: 32,
	  tiger160: 40,
	  tiger192: 48,
	  crc32: 8,
	  crc32b: 8
	};
	
	function isHash(str, algorithm) {
	  (0, _assertString.default)(str);
	  var hash = new RegExp("^[a-f0-9]{".concat(lengths[algorithm], "}$"));
	  return hash.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHexColor;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{6})$/i;
	
	function isHexColor(str) {
	  (0, _assertString.default)(str);
	  return hexcolor.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isIPRange;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	var _isIP = _interopRequireDefault(__webpack_require__(127));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subnetMaybe = /^\d{1,2}$/;
	
	function isIPRange(str) {
	  (0, _assertString.default)(str);
	  var parts = str.split('/'); // parts[0] -> ip, parts[1] -> subnet
	
	  if (parts.length !== 2) {
	    return false;
	  }
	
	  if (!subnetMaybe.test(parts[1])) {
	    return false;
	  } // Disallow preceding 0 i.e. 01, 02, ...
	
	
	  if (parts[1].length > 1 && parts[1].startsWith('0')) {
	    return false;
	  }
	
	  return (0, _isIP.default)(parts[0], 4) && parts[1] <= 32 && parts[1] >= 0;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISBN;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isbn10Maybe = /^(?:[0-9]{9}X|[0-9]{10})$/;
	var isbn13Maybe = /^(?:[0-9]{13})$/;
	var factor = [1, 3];
	
	function isISBN(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  (0, _assertString.default)(str);
	  version = String(version);
	
	  if (!version) {
	    return isISBN(str, 10) || isISBN(str, 13);
	  }
	
	  var sanitized = str.replace(/[\s-]+/g, '');
	  var checksum = 0;
	  var i;
	
	  if (version === '10') {
	    if (!isbn10Maybe.test(sanitized)) {
	      return false;
	    }
	
	    for (i = 0; i < 9; i++) {
	      checksum += (i + 1) * sanitized.charAt(i);
	    }
	
	    if (sanitized.charAt(9) === 'X') {
	      checksum += 10 * 10;
	    } else {
	      checksum += 10 * sanitized.charAt(9);
	    }
	
	    if (checksum % 11 === 0) {
	      return !!sanitized;
	    }
	  } else if (version === '13') {
	    if (!isbn13Maybe.test(sanitized)) {
	      return false;
	    }
	
	    for (i = 0; i < 12; i++) {
	      checksum += factor[i % 2] * sanitized.charAt(i);
	    }
	
	    if (sanitized.charAt(12) - (10 - checksum % 10) % 10 === 0) {
	      return !!sanitized;
	    }
	  }
	
	  return false;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISIN;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isin = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;
	
	function isISIN(str) {
	  (0, _assertString.default)(str);
	
	  if (!isin.test(str)) {
	    return false;
	  }
	
	  var checksumStr = str.replace(/[A-Z]/g, function (character) {
	    return parseInt(character, 36);
	  });
	  var sum = 0;
	  var digit;
	  var tmpNum;
	  var shouldDouble = true;
	
	  for (var i = checksumStr.length - 2; i >= 0; i--) {
	    digit = checksumStr.substring(i, i + 1);
	    tmpNum = parseInt(digit, 10);
	
	    if (shouldDouble) {
	      tmpNum *= 2;
	
	      if (tmpNum >= 10) {
	        sum += tmpNum + 1;
	      } else {
	        sum += tmpNum;
	      }
	    } else {
	      sum += tmpNum;
	    }
	
	    shouldDouble = !shouldDouble;
	  }
	
	  return parseInt(str.substr(str.length - 1), 10) === (10000 - sum) % 10;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISO31661Alpha2;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	var _includes = _interopRequireDefault(__webpack_require__(194));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
	var validISO31661Alpha2CountriesCodes = ['AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AO', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AW', 'AX', 'AZ', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BQ', 'BR', 'BS', 'BT', 'BV', 'BW', 'BY', 'BZ', 'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE', 'EG', 'EH', 'ER', 'ES', 'ET', 'FI', 'FJ', 'FK', 'FM', 'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GR', 'GS', 'GT', 'GU', 'GW', 'GY', 'HK', 'HM', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IM', 'IN', 'IO', 'IQ', 'IR', 'IS', 'IT', 'JE', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR', 'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PL', 'PM', 'PN', 'PR', 'PS', 'PT', 'PW', 'PY', 'QA', 'RE', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY', 'SZ', 'TC', 'TD', 'TF', 'TG', 'TH', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TR', 'TT', 'TV', 'TW', 'TZ', 'UA', 'UG', 'UM', 'US', 'UY', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VI', 'VN', 'VU', 'WF', 'WS', 'YE', 'YT', 'ZA', 'ZM', 'ZW'];
	
	function isISO31661Alpha2(str) {
	  (0, _assertString.default)(str);
	  return (0, _includes.default)(validISO31661Alpha2CountriesCodes, str.toUpperCase());
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISO31661Alpha3;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	var _includes = _interopRequireDefault(__webpack_require__(194));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3
	var validISO31661Alpha3CountriesCodes = ['AFG', 'ALA', 'ALB', 'DZA', 'ASM', 'AND', 'AGO', 'AIA', 'ATA', 'ATG', 'ARG', 'ARM', 'ABW', 'AUS', 'AUT', 'AZE', 'BHS', 'BHR', 'BGD', 'BRB', 'BLR', 'BEL', 'BLZ', 'BEN', 'BMU', 'BTN', 'BOL', 'BES', 'BIH', 'BWA', 'BVT', 'BRA', 'IOT', 'BRN', 'BGR', 'BFA', 'BDI', 'KHM', 'CMR', 'CAN', 'CPV', 'CYM', 'CAF', 'TCD', 'CHL', 'CHN', 'CXR', 'CCK', 'COL', 'COM', 'COG', 'COD', 'COK', 'CRI', 'CIV', 'HRV', 'CUB', 'CUW', 'CYP', 'CZE', 'DNK', 'DJI', 'DMA', 'DOM', 'ECU', 'EGY', 'SLV', 'GNQ', 'ERI', 'EST', 'ETH', 'FLK', 'FRO', 'FJI', 'FIN', 'FRA', 'GUF', 'PYF', 'ATF', 'GAB', 'GMB', 'GEO', 'DEU', 'GHA', 'GIB', 'GRC', 'GRL', 'GRD', 'GLP', 'GUM', 'GTM', 'GGY', 'GIN', 'GNB', 'GUY', 'HTI', 'HMD', 'VAT', 'HND', 'HKG', 'HUN', 'ISL', 'IND', 'IDN', 'IRN', 'IRQ', 'IRL', 'IMN', 'ISR', 'ITA', 'JAM', 'JPN', 'JEY', 'JOR', 'KAZ', 'KEN', 'KIR', 'PRK', 'KOR', 'KWT', 'KGZ', 'LAO', 'LVA', 'LBN', 'LSO', 'LBR', 'LBY', 'LIE', 'LTU', 'LUX', 'MAC', 'MKD', 'MDG', 'MWI', 'MYS', 'MDV', 'MLI', 'MLT', 'MHL', 'MTQ', 'MRT', 'MUS', 'MYT', 'MEX', 'FSM', 'MDA', 'MCO', 'MNG', 'MNE', 'MSR', 'MAR', 'MOZ', 'MMR', 'NAM', 'NRU', 'NPL', 'NLD', 'NCL', 'NZL', 'NIC', 'NER', 'NGA', 'NIU', 'NFK', 'MNP', 'NOR', 'OMN', 'PAK', 'PLW', 'PSE', 'PAN', 'PNG', 'PRY', 'PER', 'PHL', 'PCN', 'POL', 'PRT', 'PRI', 'QAT', 'REU', 'ROU', 'RUS', 'RWA', 'BLM', 'SHN', 'KNA', 'LCA', 'MAF', 'SPM', 'VCT', 'WSM', 'SMR', 'STP', 'SAU', 'SEN', 'SRB', 'SYC', 'SLE', 'SGP', 'SXM', 'SVK', 'SVN', 'SLB', 'SOM', 'ZAF', 'SGS', 'SSD', 'ESP', 'LKA', 'SDN', 'SUR', 'SJM', 'SWZ', 'SWE', 'CHE', 'SYR', 'TWN', 'TJK', 'TZA', 'THA', 'TLS', 'TGO', 'TKL', 'TON', 'TTO', 'TUN', 'TUR', 'TKM', 'TCA', 'TUV', 'UGA', 'UKR', 'ARE', 'GBR', 'USA', 'UMI', 'URY', 'UZB', 'VUT', 'VEN', 'VNM', 'VGB', 'VIR', 'WLF', 'ESH', 'YEM', 'ZMB', 'ZWE'];
	
	function isISO31661Alpha3(str) {
	  (0, _assertString.default)(str);
	  return (0, _includes.default)(validISO31661Alpha3CountriesCodes, str.toUpperCase());
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISO8601;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	// from http://goo.gl/0ejHHW
	var iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
	/* eslint-enable max-len */
	
	var isValidDate = function isValidDate(str) {
	  // str must have passed the ISO8601 check
	  // this check is meant to catch invalid dates
	  // like 2009-02-31
	  // first check for ordinal dates
	  var ordinalMatch = str.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);
	
	  if (ordinalMatch) {
	    var oYear = Number(ordinalMatch[1]);
	    var oDay = Number(ordinalMatch[2]); // if is leap year
	
	    if (oYear % 4 === 0 && oYear % 100 !== 0 || oYear % 400 === 0) return oDay <= 366;
	    return oDay <= 365;
	  }
	
	  var match = str.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number);
	  var year = match[1];
	  var month = match[2];
	  var day = match[3];
	  var monthString = month ? "0".concat(month).slice(-2) : month;
	  var dayString = day ? "0".concat(day).slice(-2) : day; // create a date object and compare
	
	  var d = new Date("".concat(year, "-").concat(monthString || '01', "-").concat(dayString || '01'));
	
	  if (month && day) {
	    return d.getUTCFullYear() === year && d.getUTCMonth() + 1 === month && d.getUTCDate() === day;
	  }
	
	  return true;
	};
	
	function isISO8601(str, options) {
	  (0, _assertString.default)(str);
	  var check = iso8601.test(str);
	  if (!options) return check;
	  if (check && options.strict) return isValidDate(str);
	  return check;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISRC;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// see http://isrc.ifpi.org/en/isrc-standard/code-syntax
	var isrc = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;
	
	function isISRC(str) {
	  (0, _assertString.default)(str);
	  return isrc.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISSN;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var issn = '^\\d{4}-?\\d{3}[\\dX]$';
	
	function isISSN(str) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  (0, _assertString.default)(str);
	  var testIssn = issn;
	  testIssn = options.require_hyphen ? testIssn.replace('?', '') : testIssn;
	  testIssn = options.case_sensitive ? new RegExp(testIssn) : new RegExp(testIssn, 'i');
	
	  if (!testIssn.test(str)) {
	    return false;
	  }
	
	  var digits = str.replace('-', '').toUpperCase();
	  var checksum = 0;
	
	  for (var i = 0; i < digits.length; i++) {
	    var digit = digits[i];
	    checksum += (digit === 'X' ? 10 : +digit) * (8 - i);
	  }
	
	  return checksum % 11 === 0;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isIdentityCard;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validators = {
	  ES: function ES(str) {
	    (0, _assertString.default)(str);
	    var DNI = /^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/;
	    var charsValue = {
	      X: 0,
	      Y: 1,
	      Z: 2
	    };
	    var controlDigits = ['T', 'R', 'W', 'A', 'G', 'M', 'Y', 'F', 'P', 'D', 'X', 'B', 'N', 'J', 'Z', 'S', 'Q', 'V', 'H', 'L', 'C', 'K', 'E']; // sanitize user input
	
	    var sanitized = str.trim().toUpperCase(); // validate the data structure
	
	    if (!DNI.test(sanitized)) {
	      return false;
	    } // validate the control digit
	
	
	    var number = sanitized.slice(0, -1).replace(/[X,Y,Z]/g, function (char) {
	      return charsValue[char];
	    });
	    return sanitized.endsWith(controlDigits[number % 23]);
	  },
	  'he-IL': function heIL(str) {
	    var DNI = /^\d{9}$/; // sanitize user input
	
	    var sanitized = str.trim(); // validate the data structure
	
	    if (!DNI.test(sanitized)) {
	      return false;
	    }
	
	    var id = sanitized;
	    var sum = 0,
	        incNum;
	
	    for (var i = 0; i < id.length; i++) {
	      incNum = Number(id[i]) * (i % 2 + 1); // Multiply number by 1 or 2
	
	      sum += incNum > 9 ? incNum - 9 : incNum; // Sum the digits up and add to total
	    }
	
	    return sum % 10 === 0;
	  },
	  'zh-TW': function zhTW(str) {
	    var ALPHABET_CODES = {
	      A: 10,
	      B: 11,
	      C: 12,
	      D: 13,
	      E: 14,
	      F: 15,
	      G: 16,
	      H: 17,
	      I: 34,
	      J: 18,
	      K: 19,
	      L: 20,
	      M: 21,
	      N: 22,
	      O: 35,
	      P: 23,
	      Q: 24,
	      R: 25,
	      S: 26,
	      T: 27,
	      U: 28,
	      V: 29,
	      W: 32,
	      X: 30,
	      Y: 31,
	      Z: 33
	    };
	    var sanitized = str.trim().toUpperCase();
	    if (!/^[A-Z][0-9]{9}$/.test(sanitized)) return false;
	    return Array.from(sanitized).reduce(function (sum, number, index) {
	      if (index === 0) {
	        var code = ALPHABET_CODES[number];
	        return code % 10 * 9 + Math.floor(code / 10);
	      }
	
	      if (index === 9) {
	        return (10 - sum % 10 - Number(number)) % 10 === 0;
	      }
	
	      return sum + Number(number) * (9 - index);
	    }, 0);
	  }
	};
	
	function isIdentityCard(str, locale) {
	  (0, _assertString.default)(str);
	
	  if (locale in validators) {
	    return validators[locale](str);
	  } else if (locale === 'any') {
	    for (var key in validators) {
	      // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
	      // istanbul ignore else
	      if (validators.hasOwnProperty(key)) {
	        var validator = validators[key];
	
	        if (validator(str)) {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  }
	
	  throw new Error("Invalid locale '".concat(locale, "'"));
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isIn;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	var _toString = _interopRequireDefault(__webpack_require__(475));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function isIn(str, options) {
	  (0, _assertString.default)(str);
	  var i;
	
	  if (Object.prototype.toString.call(options) === '[object Array]') {
	    var array = [];
	
	    for (i in options) {
	      // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
	      // istanbul ignore else
	      if ({}.hasOwnProperty.call(options, i)) {
	        array[i] = (0, _toString.default)(options[i]);
	      }
	    }
	
	    return array.indexOf(str) >= 0;
	  } else if (_typeof(options) === 'object') {
	    return options.hasOwnProperty(str);
	  } else if (options && typeof options.indexOf === 'function') {
	    return options.indexOf(str) >= 0;
	  }
	
	  return false;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isJSON;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function isJSON(str) {
	  (0, _assertString.default)(str);
	
	  try {
	    var obj = JSON.parse(str);
	    return !!obj && _typeof(obj) === 'object';
	  } catch (e) {
	    /* ignore */
	  }
	
	  return false;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isJWT;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jwt = /^([A-Za-z0-9\-_~+\/]+[=]{0,2})\.([A-Za-z0-9\-_~+\/]+[=]{0,2})(?:\.([A-Za-z0-9\-_~+\/]+[=]{0,2}))?$/;
	
	function isJWT(str) {
	  (0, _assertString.default)(str);
	  return jwt.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lat = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;
	var long = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/;
	
	function _default(str) {
	  (0, _assertString.default)(str);
	  if (!str.includes(',')) return false;
	  var pair = str.split(',');
	  return lat.test(pair[0]) && long.test(pair[1]);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLength;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	/* eslint-disable prefer-rest-params */
	function isLength(str, options) {
	  (0, _assertString.default)(str);
	  var min;
	  var max;
	
	  if (_typeof(options) === 'object') {
	    min = options.min || 0;
	    max = options.max;
	  } else {
	    // backwards compatibility: isLength(str, min [, max])
	    min = arguments[1];
	    max = arguments[2];
	  }
	
	  var surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
	  var len = str.length - surrogatePairs.length;
	  return len >= min && (typeof max === 'undefined' || len <= max);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLowercase;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isLowercase(str) {
	  (0, _assertString.default)(str);
	  return str === str.toLowerCase();
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMACAddress;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var macAddress = /^([0-9a-fA-F][0-9a-fA-F]:){5}([0-9a-fA-F][0-9a-fA-F])$/;
	var macAddressNoColons = /^([0-9a-fA-F]){12}$/;
	
	function isMACAddress(str, options) {
	  (0, _assertString.default)(str);
	
	  if (options && options.no_colons) {
	    return macAddressNoColons.test(str);
	  }
	
	  return macAddress.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMD5;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var md5 = /^[a-f0-9]{32}$/;
	
	function isMD5(str) {
	  (0, _assertString.default)(str);
	  return md5.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMagnetURI;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var magnetURI = /^magnet:\?xt=urn:[a-z0-9]+:[a-z0-9]{32,40}&dn=.+&tr=.+$/i;
	
	function isMagnetURI(url) {
	  (0, _assertString.default)(url);
	  return magnetURI.test(url.trim());
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMimeType;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	  Checks if the provided string matches to a correct Media type format (MIME type)
	
	  This function only checks is the string format follows the
	  etablished rules by the according RFC specifications.
	  This function supports 'charset' in textual media types
	  (https://tools.ietf.org/html/rfc6657).
	
	  This function does not check against all the media types listed
	  by the IANA (https://www.iana.org/assignments/media-types/media-types.xhtml)
	  because of lightness purposes : it would require to include
	  all these MIME types in this librairy, which would weigh it
	  significantly. This kind of effort maybe is not worth for the use that
	  this function has in this entire librairy.
	
	  More informations in the RFC specifications :
	  - https://tools.ietf.org/html/rfc2045
	  - https://tools.ietf.org/html/rfc2046
	  - https://tools.ietf.org/html/rfc7231#section-3.1.1.1
	  - https://tools.ietf.org/html/rfc7231#section-3.1.1.5
	*/
	// Match simple MIME types
	// NB :
	//   Subtype length must not exceed 100 characters.
	//   This rule does not comply to the RFC specs (what is the max length ?).
	var mimeTypeSimple = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+]{1,100}$/i; // eslint-disable-line max-len
	// Handle "charset" in "text/*"
	
	var mimeTypeText = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i; // eslint-disable-line max-len
	// Handle "boundary" in "multipart/*"
	
	var mimeTypeMultipart = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i; // eslint-disable-line max-len
	
	function isMimeType(str) {
	  (0, _assertString.default)(str);
	  return mimeTypeSimple.test(str) || mimeTypeText.test(str) || mimeTypeMultipart.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMobilePhone;
	exports.locales = void 0;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	var phones = {
	  'ar-AE': /^((\+?971)|0)?5[024568]\d{7}$/,
	  'ar-BH': /^(\+?973)?(3|6)\d{7}$/,
	  'ar-DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
	  'ar-EG': /^((\+?20)|0)?1[0125]\d{8}$/,
	  'ar-IQ': /^(\+?964|0)?7[0-9]\d{8}$/,
	  'ar-JO': /^(\+?962|0)?7[789]\d{7}$/,
	  'ar-KW': /^(\+?965)[569]\d{7}$/,
	  'ar-SA': /^(!?(\+?966)|0)?5\d{8}$/,
	  'ar-SY': /^(!?(\+?963)|0)?9\d{8}$/,
	  'ar-TN': /^(\+?216)?[2459]\d{7}$/,
	  'be-BY': /^(\+?375)?(24|25|29|33|44)\d{7}$/,
	  'bg-BG': /^(\+?359|0)?8[789]\d{7}$/,
	  'bn-BD': /^(\+?880|0)1[1356789][0-9]{8}$/,
	  'cs-CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
	  'da-DK': /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
	  'de-DE': /^(\+49)?0?1(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7}$/,
	  'el-GR': /^(\+?30|0)?(69\d{8})$/,
	  'en-AU': /^(\+?61|0)4\d{8}$/,
	  'en-GB': /^(\+?44|0)7\d{9}$/,
	  'en-GH': /^(\+233|0)(20|50|24|54|27|57|26|56|23|28)\d{7}$/,
	  'en-HK': /^(\+?852\-?)?[456789]\d{3}\-?\d{4}$/,
	  'en-IE': /^(\+?353|0)8[356789]\d{7}$/,
	  'en-IN': /^(\+?91|0)?[6789]\d{9}$/,
	  'en-KE': /^(\+?254|0)(7|1)\d{8}$/,
	  'en-MT': /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
	  'en-MU': /^(\+?230|0)?\d{8}$/,
	  'en-NG': /^(\+?234|0)?[789]\d{9}$/,
	  'en-NZ': /^(\+?64|0)[28]\d{7,9}$/,
	  'en-PK': /^((\+92)|(0092))-{0,1}\d{3}-{0,1}\d{7}$|^\d{11}$|^\d{4}-\d{7}$/,
	  'en-RW': /^(\+?250|0)?[7]\d{8}$/,
	  'en-SG': /^(\+65)?[89]\d{7}$/,
	  'en-TZ': /^(\+?255|0)?[67]\d{8}$/,
	  'en-UG': /^(\+?256|0)?[7]\d{8}$/,
	  'en-US': /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
	  'en-ZA': /^(\+?27|0)\d{9}$/,
	  'en-ZM': /^(\+?26)?09[567]\d{7}$/,
	  'es-CL': /^(\+?56|0)[2-9]\d{1}\d{7}$/,
	  'es-ES': /^(\+?34)?(6\d{1}|7[1234])\d{7}$/,
	  'es-MX': /^(\+?52)?(1|01)?\d{10,11}$/,
	  'es-PY': /^(\+?595|0)9[9876]\d{7}$/,
	  'es-UY': /^(\+598|0)9[1-9][\d]{6}$/,
	  'et-EE': /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
	  'fa-IR': /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
	  'fi-FI': /^(\+?358|0)\s?(4(0|1|2|4|5|6)?|50)\s?(\d\s?){4,8}\d$/,
	  'fj-FJ': /^(\+?679)?\s?\d{3}\s?\d{4}$/,
	  'fo-FO': /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
	  'fr-FR': /^(\+?33|0)[67]\d{8}$/,
	  'he-IL': /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
	  'hu-HU': /^(\+?36)(20|30|70)\d{7}$/,
	  'id-ID': /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
	  'it-IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
	  'ja-JP': /^(\+?81|0)[789]0[ \-]?[1-9]\d{2}[ \-]?\d{5}$/,
	  'kk-KZ': /^(\+?7|8)?7\d{9}$/,
	  'kl-GL': /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
	  'ko-KR': /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
	  'lt-LT': /^(\+370|8)\d{8}$/,
	  'ms-MY': /^(\+?6?01){1}(([0145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
	  'nb-NO': /^(\+?47)?[49]\d{7}$/,
	  'nl-BE': /^(\+?32|0)4?\d{8}$/,
	  'nl-NL': /^(\+?31|0)6?\d{8}$/,
	  'nn-NO': /^(\+?47)?[49]\d{7}$/,
	  'pl-PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
	  'pt-BR': /(?=^(\+?5{2}\-?|0)[1-9]{2}\-?\d{4}\-?\d{4}$)(^(\+?5{2}\-?|0)[1-9]{2}\-?[6-9]{1}\d{3}\-?\d{4}$)|(^(\+?5{2}\-?|0)[1-9]{2}\-?9[6-9]{1}\d{3}\-?\d{4}$)/,
	  'pt-PT': /^(\+?351)?9[1236]\d{7}$/,
	  'ro-RO': /^(\+?4?0)\s?7\d{2}(\/|\s|\.|\-)?\d{3}(\s|\.|\-)?\d{3}$/,
	  'ru-RU': /^(\+?7|8)?9\d{9}$/,
	  'sl-SI': /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
	  'sk-SK': /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
	  'sr-RS': /^(\+3816|06)[- \d]{5,9}$/,
	  'sv-SE': /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
	  'th-TH': /^(\+66|66|0)\d{9}$/,
	  'tr-TR': /^(\+?90|0)?5\d{9}$/,
	  'uk-UA': /^(\+?38|8)?0\d{9}$/,
	  'vi-VN': /^(\+?84|0)((3([2-9]))|(5([2689]))|(7([0|6-9]))|(8([1-6|89]))|(9([0-9])))([0-9]{7})$/,
	  'zh-CN': /^((\+|00)86)?1([358][0-9]|4[579]|6[67]|7[0135678]|9[189])[0-9]{8}$/,
	  'zh-TW': /^(\+?886\-?|0)?9\d{8}$/
	};
	/* eslint-enable max-len */
	// aliases
	
	phones['en-CA'] = phones['en-US'];
	phones['fr-BE'] = phones['nl-BE'];
	phones['zh-HK'] = phones['en-HK'];
	
	function isMobilePhone(str, locale, options) {
	  (0, _assertString.default)(str);
	
	  if (options && options.strictMode && !str.startsWith('+')) {
	    return false;
	  }
	
	  if (Array.isArray(locale)) {
	    return locale.some(function (key) {
	      // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
	      // istanbul ignore else
	      if (phones.hasOwnProperty(key)) {
	        var phone = phones[key];
	
	        if (phone.test(str)) {
	          return true;
	        }
	      }
	
	      return false;
	    });
	  } else if (locale in phones) {
	    return phones[locale].test(str); // alias falsey locale as 'any'
	  } else if (!locale || locale === 'any') {
	    for (var key in phones) {
	      // istanbul ignore else
	      if (phones.hasOwnProperty(key)) {
	        var phone = phones[key];
	
	        if (phone.test(str)) {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  }
	
	  throw new Error("Invalid locale '".concat(locale, "'"));
	}
	
	var locales = Object.keys(phones);
	exports.locales = locales;

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMongoId;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	var _isHexadecimal = _interopRequireDefault(__webpack_require__(470));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isMongoId(str) {
	  (0, _assertString.default)(str);
	  return (0, _isHexadecimal.default)(str) && str.length === 24;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMultibyte;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-control-regex */
	var multibyte = /[^\x00-\x7F]/;
	/* eslint-enable no-control-regex */
	
	function isMultibyte(str) {
	  (0, _assertString.default)(str);
	  return multibyte.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isNumeric;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var numeric = /^[+-]?([0-9]*[.])?[0-9]+$/;
	var numericNoSymbols = /^[0-9]+$/;
	
	function isNumeric(str, options) {
	  (0, _assertString.default)(str);
	
	  if (options && options.no_symbols) {
	    return numericNoSymbols.test(str);
	  }
	
	  return numeric.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPort;
	
	var _isInt = _interopRequireDefault(__webpack_require__(471));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isPort(str) {
	  return (0, _isInt.default)(str, {
	    min: 0,
	    max: 65535
	  });
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	exports.locales = void 0;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// common patterns
	var threeDigit = /^\d{3}$/;
	var fourDigit = /^\d{4}$/;
	var fiveDigit = /^\d{5}$/;
	var sixDigit = /^\d{6}$/;
	var patterns = {
	  AD: /^AD\d{3}$/,
	  AT: fourDigit,
	  AU: fourDigit,
	  BE: fourDigit,
	  BG: fourDigit,
	  BR: /^\d{5}-\d{3}$/,
	  CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
	  CH: fourDigit,
	  CZ: /^\d{3}\s?\d{2}$/,
	  DE: fiveDigit,
	  DK: fourDigit,
	  DZ: fiveDigit,
	  EE: fiveDigit,
	  ES: fiveDigit,
	  FI: fiveDigit,
	  FR: /^\d{2}\s?\d{3}$/,
	  GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
	  GR: /^\d{3}\s?\d{2}$/,
	  HR: /^([1-5]\d{4}$)/,
	  HU: fourDigit,
	  ID: fiveDigit,
	  IL: fiveDigit,
	  IN: sixDigit,
	  IS: threeDigit,
	  IT: fiveDigit,
	  JP: /^\d{3}\-\d{4}$/,
	  KE: fiveDigit,
	  LI: /^(948[5-9]|949[0-7])$/,
	  LT: /^LT\-\d{5}$/,
	  LU: fourDigit,
	  LV: /^LV\-\d{4}$/,
	  MX: fiveDigit,
	  MT: /^[A-Za-z]{3}\s{0,1}\d{4}$/,
	  NL: /^\d{4}\s?[a-z]{2}$/i,
	  NO: fourDigit,
	  NZ: fourDigit,
	  PL: /^\d{2}\-\d{3}$/,
	  PR: /^00[679]\d{2}([ -]\d{4})?$/,
	  PT: /^\d{4}\-\d{3}?$/,
	  RO: sixDigit,
	  RU: sixDigit,
	  SA: fiveDigit,
	  SE: /^\d{3}\s?\d{2}$/,
	  SI: fourDigit,
	  SK: /^\d{3}\s?\d{2}$/,
	  TN: fourDigit,
	  TW: /^\d{3}(\d{2})?$/,
	  UA: fiveDigit,
	  US: /^\d{5}(-\d{4})?$/,
	  ZA: fourDigit,
	  ZM: fiveDigit
	};
	var locales = Object.keys(patterns);
	exports.locales = locales;
	
	function _default(str, locale) {
	  (0, _assertString.default)(str);
	
	  if (locale in patterns) {
	    return patterns[locale].test(str);
	  } else if (locale === 'any') {
	    for (var key in patterns) {
	      // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
	      // istanbul ignore else
	      if (patterns.hasOwnProperty(key)) {
	        var pattern = patterns[key];
	
	        if (pattern.test(str)) {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  }
	
	  throw new Error("Invalid locale '".concat(locale, "'"));
	}

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isRFC3339;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Based on https://tools.ietf.org/html/rfc3339#section-5.6 */
	var dateFullYear = /[0-9]{4}/;
	var dateMonth = /(0[1-9]|1[0-2])/;
	var dateMDay = /([12]\d|0[1-9]|3[01])/;
	var timeHour = /([01][0-9]|2[0-3])/;
	var timeMinute = /[0-5][0-9]/;
	var timeSecond = /([0-5][0-9]|60)/;
	var timeSecFrac = /(\.[0-9]+)?/;
	var timeNumOffset = new RegExp("[-+]".concat(timeHour.source, ":").concat(timeMinute.source));
	var timeOffset = new RegExp("([zZ]|".concat(timeNumOffset.source, ")"));
	var partialTime = new RegExp("".concat(timeHour.source, ":").concat(timeMinute.source, ":").concat(timeSecond.source).concat(timeSecFrac.source));
	var fullDate = new RegExp("".concat(dateFullYear.source, "-").concat(dateMonth.source, "-").concat(dateMDay.source));
	var fullTime = new RegExp("".concat(partialTime.source).concat(timeOffset.source));
	var rfc3339 = new RegExp("".concat(fullDate.source, "[ tT]").concat(fullTime.source));
	
	function isRFC3339(str) {
	  (0, _assertString.default)(str);
	  return rfc3339.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSurrogatePair;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
	
	function isSurrogatePair(str) {
	  (0, _assertString.default)(str);
	  return surrogatePair.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isURL;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	var _isFQDN = _interopRequireDefault(__webpack_require__(192));
	
	var _isIP = _interopRequireDefault(__webpack_require__(127));
	
	var _merge = _interopRequireDefault(__webpack_require__(63));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_url_options = {
	  protocols: ['http', 'https', 'ftp'],
	  require_tld: true,
	  require_protocol: false,
	  require_host: true,
	  require_valid_protocol: true,
	  allow_underscores: false,
	  allow_trailing_dot: false,
	  allow_protocol_relative_urls: false
	};
	var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;
	
	function isRegExp(obj) {
	  return Object.prototype.toString.call(obj) === '[object RegExp]';
	}
	
	function checkHost(host, matches) {
	  for (var i = 0; i < matches.length; i++) {
	    var match = matches[i];
	
	    if (host === match || isRegExp(match) && match.test(host)) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function isURL(url, options) {
	  (0, _assertString.default)(url);
	
	  if (!url || url.length >= 2083 || /[\s<>]/.test(url)) {
	    return false;
	  }
	
	  if (url.indexOf('mailto:') === 0) {
	    return false;
	  }
	
	  options = (0, _merge.default)(options, default_url_options);
	  var protocol, auth, host, hostname, port, port_str, split, ipv6;
	  split = url.split('#');
	  url = split.shift();
	  split = url.split('?');
	  url = split.shift();
	  split = url.split('://');
	
	  if (split.length > 1) {
	    protocol = split.shift().toLowerCase();
	
	    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
	      return false;
	    }
	  } else if (options.require_protocol) {
	    return false;
	  } else if (url.substr(0, 2) === '//') {
	    if (!options.allow_protocol_relative_urls) {
	      return false;
	    }
	
	    split[0] = url.substr(2);
	  }
	
	  url = split.join('://');
	
	  if (url === '') {
	    return false;
	  }
	
	  split = url.split('/');
	  url = split.shift();
	
	  if (url === '' && !options.require_host) {
	    return true;
	  }
	
	  split = url.split('@');
	
	  if (split.length > 1) {
	    if (options.disallow_auth) {
	      return false;
	    }
	
	    auth = split.shift();
	
	    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
	      return false;
	    }
	  }
	
	  hostname = split.join('@');
	  port_str = null;
	  ipv6 = null;
	  var ipv6_match = hostname.match(wrapped_ipv6);
	
	  if (ipv6_match) {
	    host = '';
	    ipv6 = ipv6_match[1];
	    port_str = ipv6_match[2] || null;
	  } else {
	    split = hostname.split(':');
	    host = split.shift();
	
	    if (split.length) {
	      port_str = split.join(':');
	    }
	  }
	
	  if (port_str !== null) {
	    port = parseInt(port_str, 10);
	
	    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
	      return false;
	    }
	  }
	
	  if (!(0, _isIP.default)(host) && !(0, _isFQDN.default)(host, options) && (!ipv6 || !(0, _isIP.default)(ipv6, 6))) {
	    return false;
	  }
	
	  host = host || ipv6;
	
	  if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
	    return false;
	  }
	
	  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
	    return false;
	  }
	
	  return true;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isUUID;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uuid = {
	  3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
	  4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
	  5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
	  all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
	};
	
	function isUUID(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
	  (0, _assertString.default)(str);
	  var pattern = uuid[version];
	  return pattern && pattern.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isUppercase;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isUppercase(str) {
	  (0, _assertString.default)(str);
	  return str === str.toUpperCase();
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isVariableWidth;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	var _isFullWidth = __webpack_require__(468);
	
	var _isHalfWidth = __webpack_require__(469);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isVariableWidth(str) {
	  (0, _assertString.default)(str);
	  return _isFullWidth.fullWidth.test(str) && _isHalfWidth.halfWidth.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWhitelisted;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isWhitelisted(str, chars) {
	  (0, _assertString.default)(str);
	
	  for (var i = str.length - 1; i >= 0; i--) {
	    if (chars.indexOf(str[i]) === -1) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = matches;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function matches(str, pattern, modifiers) {
	  (0, _assertString.default)(str);
	
	  if (Object.prototype.toString.call(pattern) !== '[object RegExp]') {
	    pattern = new RegExp(pattern, modifiers);
	  }
	
	  return pattern.test(str);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = normalizeEmail;
	
	var _merge = _interopRequireDefault(__webpack_require__(63));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_normalize_email_options = {
	  // The following options apply to all email addresses
	  // Lowercases the local part of the email address.
	  // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
	  // The domain is always lowercased, as per RFC 1035
	  all_lowercase: true,
	  // The following conversions are specific to GMail
	  // Lowercases the local part of the GMail address (known to be case-insensitive)
	  gmail_lowercase: true,
	  // Removes dots from the local part of the email address, as that's ignored by GMail
	  gmail_remove_dots: true,
	  // Removes the subaddress (e.g. "+foo") from the email address
	  gmail_remove_subaddress: true,
	  // Conversts the googlemail.com domain to gmail.com
	  gmail_convert_googlemaildotcom: true,
	  // The following conversions are specific to Outlook.com / Windows Live / Hotmail
	  // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
	  outlookdotcom_lowercase: true,
	  // Removes the subaddress (e.g. "+foo") from the email address
	  outlookdotcom_remove_subaddress: true,
	  // The following conversions are specific to Yahoo
	  // Lowercases the local part of the Yahoo address (known to be case-insensitive)
	  yahoo_lowercase: true,
	  // Removes the subaddress (e.g. "-foo") from the email address
	  yahoo_remove_subaddress: true,
	  // The following conversions are specific to Yandex
	  // Lowercases the local part of the Yandex address (known to be case-insensitive)
	  yandex_lowercase: true,
	  // The following conversions are specific to iCloud
	  // Lowercases the local part of the iCloud address (known to be case-insensitive)
	  icloud_lowercase: true,
	  // Removes the subaddress (e.g. "+foo") from the email address
	  icloud_remove_subaddress: true
	}; // List of domains used by iCloud
	
	var icloud_domains = ['icloud.com', 'me.com']; // List of domains used by Outlook.com and its predecessors
	// This list is likely incomplete.
	// Partial reference:
	// https://blogs.office.com/2013/04/17/outlook-com-gets-two-step-verification-sign-in-by-alias-and-new-international-domains/
	
	var outlookdotcom_domains = ['hotmail.at', 'hotmail.be', 'hotmail.ca', 'hotmail.cl', 'hotmail.co.il', 'hotmail.co.nz', 'hotmail.co.th', 'hotmail.co.uk', 'hotmail.com', 'hotmail.com.ar', 'hotmail.com.au', 'hotmail.com.br', 'hotmail.com.gr', 'hotmail.com.mx', 'hotmail.com.pe', 'hotmail.com.tr', 'hotmail.com.vn', 'hotmail.cz', 'hotmail.de', 'hotmail.dk', 'hotmail.es', 'hotmail.fr', 'hotmail.hu', 'hotmail.id', 'hotmail.ie', 'hotmail.in', 'hotmail.it', 'hotmail.jp', 'hotmail.kr', 'hotmail.lv', 'hotmail.my', 'hotmail.ph', 'hotmail.pt', 'hotmail.sa', 'hotmail.sg', 'hotmail.sk', 'live.be', 'live.co.uk', 'live.com', 'live.com.ar', 'live.com.mx', 'live.de', 'live.es', 'live.eu', 'live.fr', 'live.it', 'live.nl', 'msn.com', 'outlook.at', 'outlook.be', 'outlook.cl', 'outlook.co.il', 'outlook.co.nz', 'outlook.co.th', 'outlook.com', 'outlook.com.ar', 'outlook.com.au', 'outlook.com.br', 'outlook.com.gr', 'outlook.com.pe', 'outlook.com.tr', 'outlook.com.vn', 'outlook.cz', 'outlook.de', 'outlook.dk', 'outlook.es', 'outlook.fr', 'outlook.hu', 'outlook.id', 'outlook.ie', 'outlook.in', 'outlook.it', 'outlook.jp', 'outlook.kr', 'outlook.lv', 'outlook.my', 'outlook.ph', 'outlook.pt', 'outlook.sa', 'outlook.sg', 'outlook.sk', 'passport.com']; // List of domains used by Yahoo Mail
	// This list is likely incomplete
	
	var yahoo_domains = ['rocketmail.com', 'yahoo.ca', 'yahoo.co.uk', 'yahoo.com', 'yahoo.de', 'yahoo.fr', 'yahoo.in', 'yahoo.it', 'ymail.com']; // List of domains used by yandex.ru
	
	var yandex_domains = ['yandex.ru', 'yandex.ua', 'yandex.kz', 'yandex.com', 'yandex.by', 'ya.ru']; // replace single dots, but not multiple consecutive dots
	
	function dotsReplacer(match) {
	  if (match.length > 1) {
	    return match;
	  }
	
	  return '';
	}
	
	function normalizeEmail(email, options) {
	  options = (0, _merge.default)(options, default_normalize_email_options);
	  var raw_parts = email.split('@');
	  var domain = raw_parts.pop();
	  var user = raw_parts.join('@');
	  var parts = [user, domain]; // The domain is always lowercased, as it's case-insensitive per RFC 1035
	
	  parts[1] = parts[1].toLowerCase();
	
	  if (parts[1] === 'gmail.com' || parts[1] === 'googlemail.com') {
	    // Address is GMail
	    if (options.gmail_remove_subaddress) {
	      parts[0] = parts[0].split('+')[0];
	    }
	
	    if (options.gmail_remove_dots) {
	      // this does not replace consecutive dots like example..email@gmail.com
	      parts[0] = parts[0].replace(/\.+/g, dotsReplacer);
	    }
	
	    if (!parts[0].length) {
	      return false;
	    }
	
	    if (options.all_lowercase || options.gmail_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	
	    parts[1] = options.gmail_convert_googlemaildotcom ? 'gmail.com' : parts[1];
	  } else if (icloud_domains.indexOf(parts[1]) >= 0) {
	    // Address is iCloud
	    if (options.icloud_remove_subaddress) {
	      parts[0] = parts[0].split('+')[0];
	    }
	
	    if (!parts[0].length) {
	      return false;
	    }
	
	    if (options.all_lowercase || options.icloud_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	  } else if (outlookdotcom_domains.indexOf(parts[1]) >= 0) {
	    // Address is Outlook.com
	    if (options.outlookdotcom_remove_subaddress) {
	      parts[0] = parts[0].split('+')[0];
	    }
	
	    if (!parts[0].length) {
	      return false;
	    }
	
	    if (options.all_lowercase || options.outlookdotcom_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	  } else if (yahoo_domains.indexOf(parts[1]) >= 0) {
	    // Address is Yahoo
	    if (options.yahoo_remove_subaddress) {
	      var components = parts[0].split('-');
	      parts[0] = components.length > 1 ? components.slice(0, -1).join('-') : components[0];
	    }
	
	    if (!parts[0].length) {
	      return false;
	    }
	
	    if (options.all_lowercase || options.yahoo_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	  } else if (yandex_domains.indexOf(parts[1]) >= 0) {
	    if (options.all_lowercase || options.yandex_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	
	    parts[1] = 'yandex.ru'; // all yandex domains are equal, 1st preffered
	  } else if (options.all_lowercase) {
	    // Any other address
	    parts[0] = parts[0].toLowerCase();
	  }
	
	  return parts.join('@');
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stripLow;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	var _blacklist = _interopRequireDefault(__webpack_require__(466));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function stripLow(str, keep_new_lines) {
	  (0, _assertString.default)(str);
	  var chars = keep_new_lines ? '\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F' : '\\x00-\\x1F\\x7F';
	  return (0, _blacklist.default)(str, chars);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toBoolean;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toBoolean(str, strict) {
	  (0, _assertString.default)(str);
	
	  if (strict) {
	    return str === '1' || str === 'true';
	  }
	
	  return str !== '0' && str !== 'false' && str !== '';
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toInt;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toInt(str, radix) {
	  (0, _assertString.default)(str);
	  return parseInt(str, radix || 10);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = trim;
	
	var _rtrim = _interopRequireDefault(__webpack_require__(473));
	
	var _ltrim = _interopRequireDefault(__webpack_require__(472));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function trim(str, chars) {
	  return (0, _rtrim.default)((0, _ltrim.default)(str, chars), chars);
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = unescape;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function unescape(str) {
	  (0, _assertString.default)(str);
	  return str.replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#x2F;/g, '/').replace(/&#x5C;/g, '\\').replace(/&#96;/g, '`');
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = whitelist;
	
	var _assertString = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function whitelist(str, chars) {
	  (0, _assertString.default)(str);
	  return str.replace(new RegExp("[^".concat(chars, "]+"), 'g'), '');
	}
	
	module.exports = exports.default;
	module.exports.default = exports.default;

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
	 *
	 *  Use of this source code is governed by a BSD-style license
	 *  that can be found in the LICENSE file in the root of the source
	 *  tree.
	 */
	/* eslint-env node */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _adapter_factory = __webpack_require__(1024);
	
	var adapter = (0, _adapter_factory.adapterFactory)({ window: typeof window === 'undefined' ? undefined : window });
	exports.default = adapter;


/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.adapterFactory = adapterFactory;
	
	var _utils = __webpack_require__(39);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _chrome_shim = __webpack_require__(1025);
	
	var chromeShim = _interopRequireWildcard(_chrome_shim);
	
	var _edge_shim = __webpack_require__(1029);
	
	var edgeShim = _interopRequireWildcard(_edge_shim);
	
	var _firefox_shim = __webpack_require__(1033);
	
	var firefoxShim = _interopRequireWildcard(_firefox_shim);
	
	var _safari_shim = __webpack_require__(1036);
	
	var safariShim = _interopRequireWildcard(_safari_shim);
	
	var _common_shim = __webpack_require__(1028);
	
	var commonShim = _interopRequireWildcard(_common_shim);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Shimming starts here.
	/*
	 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
	 *
	 *  Use of this source code is governed by a BSD-style license
	 *  that can be found in the LICENSE file in the root of the source
	 *  tree.
	 */
	function adapterFactory() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      window = _ref.window;
	
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    shimChrome: true,
	    shimFirefox: true,
	    shimEdge: true,
	    shimSafari: true
	  };
	
	  // Utils.
	  var logging = utils.log;
	  var browserDetails = utils.detectBrowser(window);
	
	  var adapter = {
	    browserDetails: browserDetails,
	    commonShim: commonShim,
	    extractVersion: utils.extractVersion,
	    disableLog: utils.disableLog,
	    disableWarnings: utils.disableWarnings
	  };
	
	  // Shim browser if found.
	  switch (browserDetails.browser) {
	    case 'chrome':
	      if (!chromeShim || !chromeShim.shimPeerConnection || !options.shimChrome) {
	        logging('Chrome shim is not included in this adapter release.');
	        return adapter;
	      }
	      if (browserDetails.version === null) {
	        logging('Chrome shim can not determine version, not shimming.');
	        return adapter;
	      }
	      logging('adapter.js shimming chrome.');
	      // Export to the adapter global object visible in the browser.
	      adapter.browserShim = chromeShim;
	
	      // Must be called before shimPeerConnection.
	      commonShim.shimAddIceCandidateNullOrEmpty(window, browserDetails);
	
	      chromeShim.shimGetUserMedia(window, browserDetails);
	      chromeShim.shimMediaStream(window, browserDetails);
	      chromeShim.shimPeerConnection(window, browserDetails);
	      chromeShim.shimOnTrack(window, browserDetails);
	      chromeShim.shimAddTrackRemoveTrack(window, browserDetails);
	      chromeShim.shimGetSendersWithDtmf(window, browserDetails);
	      chromeShim.shimGetStats(window, browserDetails);
	      chromeShim.shimSenderReceiverGetStats(window, browserDetails);
	      chromeShim.fixNegotiationNeeded(window, browserDetails);
	
	      commonShim.shimRTCIceCandidate(window, browserDetails);
	      commonShim.shimConnectionState(window, browserDetails);
	      commonShim.shimMaxMessageSize(window, browserDetails);
	      commonShim.shimSendThrowTypeError(window, browserDetails);
	      commonShim.removeExtmapAllowMixed(window, browserDetails);
	      break;
	    case 'firefox':
	      if (!firefoxShim || !firefoxShim.shimPeerConnection || !options.shimFirefox) {
	        logging('Firefox shim is not included in this adapter release.');
	        return adapter;
	      }
	      logging('adapter.js shimming firefox.');
	      // Export to the adapter global object visible in the browser.
	      adapter.browserShim = firefoxShim;
	
	      // Must be called before shimPeerConnection.
	      commonShim.shimAddIceCandidateNullOrEmpty(window, browserDetails);
	
	      firefoxShim.shimGetUserMedia(window, browserDetails);
	      firefoxShim.shimPeerConnection(window, browserDetails);
	      firefoxShim.shimOnTrack(window, browserDetails);
	      firefoxShim.shimRemoveStream(window, browserDetails);
	      firefoxShim.shimSenderGetStats(window, browserDetails);
	      firefoxShim.shimReceiverGetStats(window, browserDetails);
	      firefoxShim.shimRTCDataChannel(window, browserDetails);
	      firefoxShim.shimAddTransceiver(window, browserDetails);
	      firefoxShim.shimGetParameters(window, browserDetails);
	      firefoxShim.shimCreateOffer(window, browserDetails);
	      firefoxShim.shimCreateAnswer(window, browserDetails);
	
	      commonShim.shimRTCIceCandidate(window, browserDetails);
	      commonShim.shimConnectionState(window, browserDetails);
	      commonShim.shimMaxMessageSize(window, browserDetails);
	      commonShim.shimSendThrowTypeError(window, browserDetails);
	      break;
	    case 'edge':
	      if (!edgeShim || !edgeShim.shimPeerConnection || !options.shimEdge) {
	        logging('MS edge shim is not included in this adapter release.');
	        return adapter;
	      }
	      logging('adapter.js shimming edge.');
	      // Export to the adapter global object visible in the browser.
	      adapter.browserShim = edgeShim;
	
	      edgeShim.shimGetUserMedia(window, browserDetails);
	      edgeShim.shimGetDisplayMedia(window, browserDetails);
	      edgeShim.shimPeerConnection(window, browserDetails);
	      edgeShim.shimReplaceTrack(window, browserDetails);
	
	      // the edge shim implements the full RTCIceCandidate object.
	
	      commonShim.shimMaxMessageSize(window, browserDetails);
	      commonShim.shimSendThrowTypeError(window, browserDetails);
	      break;
	    case 'safari':
	      if (!safariShim || !options.shimSafari) {
	        logging('Safari shim is not included in this adapter release.');
	        return adapter;
	      }
	      logging('adapter.js shimming safari.');
	      // Export to the adapter global object visible in the browser.
	      adapter.browserShim = safariShim;
	
	      // Must be called before shimCallbackAPI.
	      commonShim.shimAddIceCandidateNullOrEmpty(window, browserDetails);
	
	      safariShim.shimRTCIceServerUrls(window, browserDetails);
	      safariShim.shimCreateOfferLegacy(window, browserDetails);
	      safariShim.shimCallbacksAPI(window, browserDetails);
	      safariShim.shimLocalStreamsAPI(window, browserDetails);
	      safariShim.shimRemoteStreamsAPI(window, browserDetails);
	      safariShim.shimTrackEventTransceiver(window, browserDetails);
	      safariShim.shimGetUserMedia(window, browserDetails);
	      safariShim.shimAudioContext(window, browserDetails);
	
	      commonShim.shimRTCIceCandidate(window, browserDetails);
	      commonShim.shimMaxMessageSize(window, browserDetails);
	      commonShim.shimSendThrowTypeError(window, browserDetails);
	      commonShim.removeExtmapAllowMixed(window, browserDetails);
	      break;
	    default:
	      logging('Unsupported browser!');
	      break;
	  }
	
	  return adapter;
	}
	
	// Browser shims.


/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
	 *
	 *  Use of this source code is governed by a BSD-style license
	 *  that can be found in the LICENSE file in the root of the source
	 *  tree.
	 */
	/* eslint-env node */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shimGetDisplayMedia = exports.shimGetUserMedia = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _getusermedia = __webpack_require__(1027);
	
	Object.defineProperty(exports, 'shimGetUserMedia', {
	  enumerable: true,
	  get: function get() {
	    return _getusermedia.shimGetUserMedia;
	  }
	});
	
	var _getdisplaymedia = __webpack_require__(1026);
	
	Object.defineProperty(exports, 'shimGetDisplayMedia', {
	  enumerable: true,
	  get: function get() {
	    return _getdisplaymedia.shimGetDisplayMedia;
	  }
	});
	exports.shimMediaStream = shimMediaStream;
	exports.shimOnTrack = shimOnTrack;
	exports.shimGetSendersWithDtmf = shimGetSendersWithDtmf;
	exports.shimGetStats = shimGetStats;
	exports.shimSenderReceiverGetStats = shimSenderReceiverGetStats;
	exports.shimAddTrackRemoveTrackWithNative = shimAddTrackRemoveTrackWithNative;
	exports.shimAddTrackRemoveTrack = shimAddTrackRemoveTrack;
	exports.shimPeerConnection = shimPeerConnection;
	exports.fixNegotiationNeeded = fixNegotiationNeeded;
	
	var _utils = __webpack_require__(39);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function shimMediaStream(window) {
	  window.MediaStream = window.MediaStream || window.webkitMediaStream;
	}
	
	function shimOnTrack(window) {
	  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection && !('ontrack' in window.RTCPeerConnection.prototype)) {
	    Object.defineProperty(window.RTCPeerConnection.prototype, 'ontrack', {
	      get: function get() {
	        return this._ontrack;
	      },
	      set: function set(f) {
	        if (this._ontrack) {
	          this.removeEventListener('track', this._ontrack);
	        }
	        this.addEventListener('track', this._ontrack = f);
	      },
	
	      enumerable: true,
	      configurable: true
	    });
	    var origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
	    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
	      var _this = this;
	
	      if (!this._ontrackpoly) {
	        this._ontrackpoly = function (e) {
	          // onaddstream does not fire when a track is added to an existing
	          // stream. But stream.onaddtrack is implemented so we use that.
	          e.stream.addEventListener('addtrack', function (te) {
	            var receiver = void 0;
	            if (window.RTCPeerConnection.prototype.getReceivers) {
	              receiver = _this.getReceivers().find(function (r) {
	                return r.track && r.track.id === te.track.id;
	              });
	            } else {
	              receiver = { track: te.track };
	            }
	
	            var event = new Event('track');
	            event.track = te.track;
	            event.receiver = receiver;
	            event.transceiver = { receiver: receiver };
	            event.streams = [e.stream];
	            _this.dispatchEvent(event);
	          });
	          e.stream.getTracks().forEach(function (track) {
	            var receiver = void 0;
	            if (window.RTCPeerConnection.prototype.getReceivers) {
	              receiver = _this.getReceivers().find(function (r) {
	                return r.track && r.track.id === track.id;
	              });
	            } else {
	              receiver = { track: track };
	            }
	            var event = new Event('track');
	            event.track = track;
	            event.receiver = receiver;
	            event.transceiver = { receiver: receiver };
	            event.streams = [e.stream];
	            _this.dispatchEvent(event);
	          });
	        };
	        this.addEventListener('addstream', this._ontrackpoly);
	      }
	      return origSetRemoteDescription.apply(this, arguments);
	    };
	  } else {
	    // even if RTCRtpTransceiver is in window, it is only used and
	    // emitted in unified-plan. Unfortunately this means we need
	    // to unconditionally wrap the event.
	    utils.wrapPeerConnectionEvent(window, 'track', function (e) {
	      if (!e.transceiver) {
	        Object.defineProperty(e, 'transceiver', { value: { receiver: e.receiver } });
	      }
	      return e;
	    });
	  }
	}
	
	function shimGetSendersWithDtmf(window) {
	  // Overrides addTrack/removeTrack, depends on shimAddTrackRemoveTrack.
	  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection && !('getSenders' in window.RTCPeerConnection.prototype) && 'createDTMFSender' in window.RTCPeerConnection.prototype) {
	    var shimSenderWithDtmf = function shimSenderWithDtmf(pc, track) {
	      return {
	        track: track,
	        get dtmf() {
	          if (this._dtmf === undefined) {
	            if (track.kind === 'audio') {
	              this._dtmf = pc.createDTMFSender(track);
	            } else {
	              this._dtmf = null;
	            }
	          }
	          return this._dtmf;
	        },
	        _pc: pc
	      };
	    };
	
	    // augment addTrack when getSenders is not available.
	    if (!window.RTCPeerConnection.prototype.getSenders) {
	      window.RTCPeerConnection.prototype.getSenders = function getSenders() {
	        this._senders = this._senders || [];
	        return this._senders.slice(); // return a copy of the internal state.
	      };
	      var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
	      window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
	        var sender = origAddTrack.apply(this, arguments);
	        if (!sender) {
	          sender = shimSenderWithDtmf(this, track);
	          this._senders.push(sender);
	        }
	        return sender;
	      };
	
	      var origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
	      window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
	        origRemoveTrack.apply(this, arguments);
	        var idx = this._senders.indexOf(sender);
	        if (idx !== -1) {
	          this._senders.splice(idx, 1);
	        }
	      };
	    }
	    var origAddStream = window.RTCPeerConnection.prototype.addStream;
	    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
	      var _this2 = this;
	
	      this._senders = this._senders || [];
	      origAddStream.apply(this, [stream]);
	      stream.getTracks().forEach(function (track) {
	        _this2._senders.push(shimSenderWithDtmf(_this2, track));
	      });
	    };
	
	    var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
	    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
	      var _this3 = this;
	
	      this._senders = this._senders || [];
	      origRemoveStream.apply(this, [stream]);
	
	      stream.getTracks().forEach(function (track) {
	        var sender = _this3._senders.find(function (s) {
	          return s.track === track;
	        });
	        if (sender) {
	          // remove sender
	          _this3._senders.splice(_this3._senders.indexOf(sender), 1);
	        }
	      });
	    };
	  } else if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection && 'getSenders' in window.RTCPeerConnection.prototype && 'createDTMFSender' in window.RTCPeerConnection.prototype && window.RTCRtpSender && !('dtmf' in window.RTCRtpSender.prototype)) {
	    var origGetSenders = window.RTCPeerConnection.prototype.getSenders;
	    window.RTCPeerConnection.prototype.getSenders = function getSenders() {
	      var _this4 = this;
	
	      var senders = origGetSenders.apply(this, []);
	      senders.forEach(function (sender) {
	        return sender._pc = _this4;
	      });
	      return senders;
	    };
	
	    Object.defineProperty(window.RTCRtpSender.prototype, 'dtmf', {
	      get: function get() {
	        if (this._dtmf === undefined) {
	          if (this.track.kind === 'audio') {
	            this._dtmf = this._pc.createDTMFSender(this.track);
	          } else {
	            this._dtmf = null;
	          }
	        }
	        return this._dtmf;
	      }
	    });
	  }
	}
	
	function shimGetStats(window) {
	  if (!window.RTCPeerConnection) {
	    return;
	  }
	
	  var origGetStats = window.RTCPeerConnection.prototype.getStats;
	  window.RTCPeerConnection.prototype.getStats = function getStats() {
	    var _this5 = this;
	
	    var _arguments = Array.prototype.slice.call(arguments),
	        selector = _arguments[0],
	        onSucc = _arguments[1],
	        onErr = _arguments[2];
	
	    // If selector is a function then we are in the old style stats so just
	    // pass back the original getStats format to avoid breaking old users.
	
	
	    if (arguments.length > 0 && typeof selector === 'function') {
	      return origGetStats.apply(this, arguments);
	    }
	
	    // When spec-style getStats is supported, return those when called with
	    // either no arguments or the selector argument is null.
	    if (origGetStats.length === 0 && (arguments.length === 0 || typeof selector !== 'function')) {
	      return origGetStats.apply(this, []);
	    }
	
	    var fixChromeStats_ = function fixChromeStats_(response) {
	      var standardReport = {};
	      var reports = response.result();
	      reports.forEach(function (report) {
	        var standardStats = {
	          id: report.id,
	          timestamp: report.timestamp,
	          type: {
	            localcandidate: 'local-candidate',
	            remotecandidate: 'remote-candidate'
	          }[report.type] || report.type
	        };
	        report.names().forEach(function (name) {
	          standardStats[name] = report.stat(name);
	        });
	        standardReport[standardStats.id] = standardStats;
	      });
	
	      return standardReport;
	    };
	
	    // shim getStats with maplike support
	    var makeMapStats = function makeMapStats(stats) {
	      return new Map(Object.keys(stats).map(function (key) {
	        return [key, stats[key]];
	      }));
	    };
	
	    if (arguments.length >= 2) {
	      var successCallbackWrapper_ = function successCallbackWrapper_(response) {
	        onSucc(makeMapStats(fixChromeStats_(response)));
	      };
	
	      return origGetStats.apply(this, [successCallbackWrapper_, selector]);
	    }
	
	    // promise-support
	    return new Promise(function (resolve, reject) {
	      origGetStats.apply(_this5, [function (response) {
	        resolve(makeMapStats(fixChromeStats_(response)));
	      }, reject]);
	    }).then(onSucc, onErr);
	  };
	}
	
	function shimSenderReceiverGetStats(window) {
	  if (!((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection && window.RTCRtpSender && window.RTCRtpReceiver)) {
	    return;
	  }
	
	  // shim sender stats.
	  if (!('getStats' in window.RTCRtpSender.prototype)) {
	    var origGetSenders = window.RTCPeerConnection.prototype.getSenders;
	    if (origGetSenders) {
	      window.RTCPeerConnection.prototype.getSenders = function getSenders() {
	        var _this6 = this;
	
	        var senders = origGetSenders.apply(this, []);
	        senders.forEach(function (sender) {
	          return sender._pc = _this6;
	        });
	        return senders;
	      };
	    }
	
	    var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
	    if (origAddTrack) {
	      window.RTCPeerConnection.prototype.addTrack = function addTrack() {
	        var sender = origAddTrack.apply(this, arguments);
	        sender._pc = this;
	        return sender;
	      };
	    }
	    window.RTCRtpSender.prototype.getStats = function getStats() {
	      var sender = this;
	      return this._pc.getStats().then(function (result) {
	        return (
	          /* Note: this will include stats of all senders that
	           *   send a track with the same id as sender.track as
	           *   it is not possible to identify the RTCRtpSender.
	           */
	          utils.filterStats(result, sender.track, true)
	        );
	      });
	    };
	  }
	
	  // shim receiver stats.
	  if (!('getStats' in window.RTCRtpReceiver.prototype)) {
	    var origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
	    if (origGetReceivers) {
	      window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
	        var _this7 = this;
	
	        var receivers = origGetReceivers.apply(this, []);
	        receivers.forEach(function (receiver) {
	          return receiver._pc = _this7;
	        });
	        return receivers;
	      };
	    }
	    utils.wrapPeerConnectionEvent(window, 'track', function (e) {
	      e.receiver._pc = e.srcElement;
	      return e;
	    });
	    window.RTCRtpReceiver.prototype.getStats = function getStats() {
	      var receiver = this;
	      return this._pc.getStats().then(function (result) {
	        return utils.filterStats(result, receiver.track, false);
	      });
	    };
	  }
	
	  if (!('getStats' in window.RTCRtpSender.prototype && 'getStats' in window.RTCRtpReceiver.prototype)) {
	    return;
	  }
	
	  // shim RTCPeerConnection.getStats(track).
	  var origGetStats = window.RTCPeerConnection.prototype.getStats;
	  window.RTCPeerConnection.prototype.getStats = function getStats() {
	    if (arguments.length > 0 && arguments[0] instanceof window.MediaStreamTrack) {
	      var track = arguments[0];
	      var sender = void 0;
	      var receiver = void 0;
	      var err = void 0;
	      this.getSenders().forEach(function (s) {
	        if (s.track === track) {
	          if (sender) {
	            err = true;
	          } else {
	            sender = s;
	          }
	        }
	      });
	      this.getReceivers().forEach(function (r) {
	        if (r.track === track) {
	          if (receiver) {
	            err = true;
	          } else {
	            receiver = r;
	          }
	        }
	        return r.track === track;
	      });
	      if (err || sender && receiver) {
	        return Promise.reject(new DOMException('There are more than one sender or receiver for the track.', 'InvalidAccessError'));
	      } else if (sender) {
	        return sender.getStats();
	      } else if (receiver) {
	        return receiver.getStats();
	      }
	      return Promise.reject(new DOMException('There is no sender or receiver for the track.', 'InvalidAccessError'));
	    }
	    return origGetStats.apply(this, arguments);
	  };
	}
	
	function shimAddTrackRemoveTrackWithNative(window) {
	  // shim addTrack/removeTrack with native variants in order to make
	  // the interactions with legacy getLocalStreams behave as in other browsers.
	  // Keeps a mapping stream.id => [stream, rtpsenders...]
	  window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
	    var _this8 = this;
	
	    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
	    return Object.keys(this._shimmedLocalStreams).map(function (streamId) {
	      return _this8._shimmedLocalStreams[streamId][0];
	    });
	  };
	
	  var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
	  window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
	    if (!stream) {
	      return origAddTrack.apply(this, arguments);
	    }
	    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
	
	    var sender = origAddTrack.apply(this, arguments);
	    if (!this._shimmedLocalStreams[stream.id]) {
	      this._shimmedLocalStreams[stream.id] = [stream, sender];
	    } else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) {
	      this._shimmedLocalStreams[stream.id].push(sender);
	    }
	    return sender;
	  };
	
	  var origAddStream = window.RTCPeerConnection.prototype.addStream;
	  window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
	    var _this9 = this;
	
	    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
	
	    stream.getTracks().forEach(function (track) {
	      var alreadyExists = _this9.getSenders().find(function (s) {
	        return s.track === track;
	      });
	      if (alreadyExists) {
	        throw new DOMException('Track already exists.', 'InvalidAccessError');
	      }
	    });
	    var existingSenders = this.getSenders();
	    origAddStream.apply(this, arguments);
	    var newSenders = this.getSenders().filter(function (newSender) {
	      return existingSenders.indexOf(newSender) === -1;
	    });
	    this._shimmedLocalStreams[stream.id] = [stream].concat(newSenders);
	  };
	
	  var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
	  window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
	    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
	    delete this._shimmedLocalStreams[stream.id];
	    return origRemoveStream.apply(this, arguments);
	  };
	
	  var origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
	  window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
	    var _this10 = this;
	
	    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
	    if (sender) {
	      Object.keys(this._shimmedLocalStreams).forEach(function (streamId) {
	        var idx = _this10._shimmedLocalStreams[streamId].indexOf(sender);
	        if (idx !== -1) {
	          _this10._shimmedLocalStreams[streamId].splice(idx, 1);
	        }
	        if (_this10._shimmedLocalStreams[streamId].length === 1) {
	          delete _this10._shimmedLocalStreams[streamId];
	        }
	      });
	    }
	    return origRemoveTrack.apply(this, arguments);
	  };
	}
	
	function shimAddTrackRemoveTrack(window, browserDetails) {
	  if (!window.RTCPeerConnection) {
	    return;
	  }
	  // shim addTrack and removeTrack.
	  if (window.RTCPeerConnection.prototype.addTrack && browserDetails.version >= 65) {
	    return shimAddTrackRemoveTrackWithNative(window);
	  }
	
	  // also shim pc.getLocalStreams when addTrack is shimmed
	  // to return the original streams.
	  var origGetLocalStreams = window.RTCPeerConnection.prototype.getLocalStreams;
	  window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
	    var _this11 = this;
	
	    var nativeStreams = origGetLocalStreams.apply(this);
	    this._reverseStreams = this._reverseStreams || {};
	    return nativeStreams.map(function (stream) {
	      return _this11._reverseStreams[stream.id];
	    });
	  };
	
	  var origAddStream = window.RTCPeerConnection.prototype.addStream;
	  window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
	    var _this12 = this;
	
	    this._streams = this._streams || {};
	    this._reverseStreams = this._reverseStreams || {};
	
	    stream.getTracks().forEach(function (track) {
	      var alreadyExists = _this12.getSenders().find(function (s) {
	        return s.track === track;
	      });
	      if (alreadyExists) {
	        throw new DOMException('Track already exists.', 'InvalidAccessError');
	      }
	    });
	    // Add identity mapping for consistency with addTrack.
	    // Unless this is being used with a stream from addTrack.
	    if (!this._reverseStreams[stream.id]) {
	      var newStream = new window.MediaStream(stream.getTracks());
	      this._streams[stream.id] = newStream;
	      this._reverseStreams[newStream.id] = stream;
	      stream = newStream;
	    }
	    origAddStream.apply(this, [stream]);
	  };
	
	  var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
	  window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
	    this._streams = this._streams || {};
	    this._reverseStreams = this._reverseStreams || {};
	
	    origRemoveStream.apply(this, [this._streams[stream.id] || stream]);
	    delete this._reverseStreams[this._streams[stream.id] ? this._streams[stream.id].id : stream.id];
	    delete this._streams[stream.id];
	  };
	
	  window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
	    var _this13 = this;
	
	    if (this.signalingState === 'closed') {
	      throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
	    }
	    var streams = [].slice.call(arguments, 1);
	    if (streams.length !== 1 || !streams[0].getTracks().find(function (t) {
	      return t === track;
	    })) {
	      // this is not fully correct but all we can manage without
	      // [[associated MediaStreams]] internal slot.
	      throw new DOMException('The adapter.js addTrack polyfill only supports a single ' + ' stream which is associated with the specified track.', 'NotSupportedError');
	    }
	
	    var alreadyExists = this.getSenders().find(function (s) {
	      return s.track === track;
	    });
	    if (alreadyExists) {
	      throw new DOMException('Track already exists.', 'InvalidAccessError');
	    }
	
	    this._streams = this._streams || {};
	    this._reverseStreams = this._reverseStreams || {};
	    var oldStream = this._streams[stream.id];
	    if (oldStream) {
	      // this is using odd Chrome behaviour, use with caution:
	      // https://bugs.chromium.org/p/webrtc/issues/detail?id=7815
	      // Note: we rely on the high-level addTrack/dtmf shim to
	      // create the sender with a dtmf sender.
	      oldStream.addTrack(track);
	
	      // Trigger ONN async.
	      Promise.resolve().then(function () {
	        _this13.dispatchEvent(new Event('negotiationneeded'));
	      });
	    } else {
	      var newStream = new window.MediaStream([track]);
	      this._streams[stream.id] = newStream;
	      this._reverseStreams[newStream.id] = stream;
	      this.addStream(newStream);
	    }
	    return this.getSenders().find(function (s) {
	      return s.track === track;
	    });
	  };
	
	  // replace the internal stream id with the external one and
	  // vice versa.
	  function replaceInternalStreamId(pc, description) {
	    var sdp = description.sdp;
	    Object.keys(pc._reverseStreams || []).forEach(function (internalId) {
	      var externalStream = pc._reverseStreams[internalId];
	      var internalStream = pc._streams[externalStream.id];
	      sdp = sdp.replace(new RegExp(internalStream.id, 'g'), externalStream.id);
	    });
	    return new RTCSessionDescription({
	      type: description.type,
	      sdp: sdp
	    });
	  }
	  function replaceExternalStreamId(pc, description) {
	    var sdp = description.sdp;
	    Object.keys(pc._reverseStreams || []).forEach(function (internalId) {
	      var externalStream = pc._reverseStreams[internalId];
	      var internalStream = pc._streams[externalStream.id];
	      sdp = sdp.replace(new RegExp(externalStream.id, 'g'), internalStream.id);
	    });
	    return new RTCSessionDescription({
	      type: description.type,
	      sdp: sdp
	    });
	  }
	  ['createOffer', 'createAnswer'].forEach(function (method) {
	    var nativeMethod = window.RTCPeerConnection.prototype[method];
	    var methodObj = _defineProperty({}, method, function () {
	      var _this14 = this;
	
	      var args = arguments;
	      var isLegacyCall = arguments.length && typeof arguments[0] === 'function';
	      if (isLegacyCall) {
	        return nativeMethod.apply(this, [function (description) {
	          var desc = replaceInternalStreamId(_this14, description);
	          args[0].apply(null, [desc]);
	        }, function (err) {
	          if (args[1]) {
	            args[1].apply(null, err);
	          }
	        }, arguments[2]]);
	      }
	      return nativeMethod.apply(this, arguments).then(function (description) {
	        return replaceInternalStreamId(_this14, description);
	      });
	    });
	    window.RTCPeerConnection.prototype[method] = methodObj[method];
	  });
	
	  var origSetLocalDescription = window.RTCPeerConnection.prototype.setLocalDescription;
	  window.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
	    if (!arguments.length || !arguments[0].type) {
	      return origSetLocalDescription.apply(this, arguments);
	    }
	    arguments[0] = replaceExternalStreamId(this, arguments[0]);
	    return origSetLocalDescription.apply(this, arguments);
	  };
	
	  // TODO: mangle getStats: https://w3c.github.io/webrtc-stats/#dom-rtcmediastreamstats-streamidentifier
	
	  var origLocalDescription = Object.getOwnPropertyDescriptor(window.RTCPeerConnection.prototype, 'localDescription');
	  Object.defineProperty(window.RTCPeerConnection.prototype, 'localDescription', {
	    get: function get() {
	      var description = origLocalDescription.get.apply(this);
	      if (description.type === '') {
	        return description;
	      }
	      return replaceInternalStreamId(this, description);
	    }
	  });
	
	  window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
	    var _this15 = this;
	
	    if (this.signalingState === 'closed') {
	      throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
	    }
	    // We can not yet check for sender instanceof RTCRtpSender
	    // since we shim RTPSender. So we check if sender._pc is set.
	    if (!sender._pc) {
	      throw new DOMException('Argument 1 of RTCPeerConnection.removeTrack ' + 'does not implement interface RTCRtpSender.', 'TypeError');
	    }
	    var isLocal = sender._pc === this;
	    if (!isLocal) {
	      throw new DOMException('Sender was not created by this connection.', 'InvalidAccessError');
	    }
	
	    // Search for the native stream the senders track belongs to.
	    this._streams = this._streams || {};
	    var stream = void 0;
	    Object.keys(this._streams).forEach(function (streamid) {
	      var hasTrack = _this15._streams[streamid].getTracks().find(function (track) {
	        return sender.track === track;
	      });
	      if (hasTrack) {
	        stream = _this15._streams[streamid];
	      }
	    });
	
	    if (stream) {
	      if (stream.getTracks().length === 1) {
	        // if this is the last track of the stream, remove the stream. This
	        // takes care of any shimmed _senders.
	        this.removeStream(this._reverseStreams[stream.id]);
	      } else {
	        // relying on the same odd chrome behaviour as above.
	        stream.removeTrack(sender.track);
	      }
	      this.dispatchEvent(new Event('negotiationneeded'));
	    }
	  };
	}
	
	function shimPeerConnection(window, browserDetails) {
	  if (!window.RTCPeerConnection && window.webkitRTCPeerConnection) {
	    // very basic support for old versions.
	    window.RTCPeerConnection = window.webkitRTCPeerConnection;
	  }
	  if (!window.RTCPeerConnection) {
	    return;
	  }
	
	  // shim implicit creation of RTCSessionDescription/RTCIceCandidate
	  if (browserDetails.version < 53) {
	    ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate'].forEach(function (method) {
	      var nativeMethod = window.RTCPeerConnection.prototype[method];
	      var methodObj = _defineProperty({}, method, function () {
	        arguments[0] = new (method === 'addIceCandidate' ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
	        return nativeMethod.apply(this, arguments);
	      });
	      window.RTCPeerConnection.prototype[method] = methodObj[method];
	    });
	  }
	}
	
	// Attempt to fix ONN in plan-b mode.
	function fixNegotiationNeeded(window, browserDetails) {
	  utils.wrapPeerConnectionEvent(window, 'negotiationneeded', function (e) {
	    var pc = e.target;
	    if (browserDetails.version < 72 || pc.getConfiguration && pc.getConfiguration().sdpSemantics === 'plan-b') {
	      if (pc.signalingState !== 'stable') {
	        return;
	      }
	    }
	    return e;
	  });
	}


/***/ },
/* 1026 */
/***/ function(module, exports) {

	/*
	 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
	 *
	 *  Use of this source code is governed by a BSD-style license
	 *  that can be found in the LICENSE file in the root of the source
	 *  tree.
	 */
	/* eslint-env node */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shimGetDisplayMedia = shimGetDisplayMedia;
	function shimGetDisplayMedia(window, getSourceId) {
	  if (window.navigator.mediaDevices && 'getDisplayMedia' in window.navigator.mediaDevices) {
	    return;
	  }
	  if (!window.navigator.mediaDevices) {
	    return;
	  }
	  // getSourceId is a function that returns a promise resolving with
	  // the sourceId of the screen/window/tab to be shared.
	  if (typeof getSourceId !== 'function') {
	    console.error('shimGetDisplayMedia: getSourceId argument is not ' + 'a function');
	    return;
	  }
	  window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
	    return getSourceId(constraints).then(function (sourceId) {
	      var widthSpecified = constraints.video && constraints.video.width;
	      var heightSpecified = constraints.video && constraints.video.height;
	      var frameRateSpecified = constraints.video && constraints.video.frameRate;
	      constraints.video = {
	        mandatory: {
	          chromeMediaSource: 'desktop',
	          chromeMediaSourceId: sourceId,
	          maxFrameRate: frameRateSpecified || 3
	        }
	      };
	      if (widthSpecified) {
	        constraints.video.mandatory.maxWidth = widthSpecified;
	      }
	      if (heightSpecified) {
	        constraints.video.mandatory.maxHeight = heightSpecified;
	      }
	      return window.navigator.mediaDevices.getUserMedia(constraints);
	    });
	  };
	}


/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
	 *
	 *  Use of this source code is governed by a BSD-style license
	 *  that can be found in the LICENSE file in the root of the source
	 *  tree.
	 */
	/* eslint-env node */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.shimGetUserMedia = shimGetUserMedia;
	
	var _utils = __webpack_require__(39);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var logging = utils.log;
	
	function shimGetUserMedia(window, browserDetails) {
	  var navigator = window && window.navigator;
	
	  if (!navigator.mediaDevices) {
	    return;
	  }
	
	  var constraintsToChrome_ = function constraintsToChrome_(c) {
	    if ((typeof c === 'undefined' ? 'undefined' : _typeof(c)) !== 'object' || c.mandatory || c.optional) {
	      return c;
	    }
	    var cc = {};
	    Object.keys(c).forEach(function (key) {
	      if (key === 'require' || key === 'advanced' || key === 'mediaSource') {
	        return;
	      }
	      var r = _typeof(c[key]) === 'object' ? c[key] : { ideal: c[key] };
	      if (r.exact !== undefined && typeof r.exact === 'number') {
	        r.min = r.max = r.exact;
	      }
	      var oldname_ = function oldname_(prefix, name) {
	        if (prefix) {
	          return prefix + name.charAt(0).toUpperCase() + name.slice(1);
	        }
	        return name === 'deviceId' ? 'sourceId' : name;
	      };
	      if (r.ideal !== undefined) {
	        cc.optional = cc.optional || [];
	        var oc = {};
	        if (typeof r.ideal === 'number') {
	          oc[oldname_('min', key)] = r.ideal;
	          cc.optional.push(oc);
	          oc = {};
	          oc[oldname_('max', key)] = r.ideal;
	          cc.optional.push(oc);
	        } else {
	          oc[oldname_('', key)] = r.ideal;
	          cc.optional.push(oc);
	        }
	      }
	      if (r.exact !== undefined && typeof r.exact !== 'number') {
	        cc.mandatory = cc.mandatory || {};
	        cc.mandatory[oldname_('', key)] = r.exact;
	      } else {
	        ['min', 'max'].forEach(function (mix) {
	          if (r[mix] !== undefined) {
	            cc.mandatory = cc.mandatory || {};
	            cc.mandatory[oldname_(mix, key)] = r[mix];
	          }
	        });
	      }
	    });
	    if (c.advanced) {
	      cc.optional = (cc.optional || []).concat(c.advanced);
	    }
	    return cc;
	  };
	
	  var shimConstraints_ = function shimConstraints_(constraints, func) {
	    if (browserDetails.version >= 61) {
	      return func(constraints);
	    }
	    constraints = JSON.parse(JSON.stringify(constraints));
	    if (constraints && _typeof(constraints.audio) === 'object') {
	      var remap = function remap(obj, a, b) {
	        if (a in obj && !(b in obj)) {
	          obj[b] = obj[a];
	          delete obj[a];
	        }
	      };
	      constraints = JSON.parse(JSON.stringify(constraints));
	      remap(constraints.audio, 'autoGainControl', 'googAutoGainControl');
	      remap(constraints.audio, 'noiseSuppression', 'googNoiseSuppression');
	      constraints.audio = constraintsToChrome_(constraints.audio);
	    }
	    if (constraints && _typeof(constraints.video) === 'object') {
	      // Shim facingMode for mobile & surface pro.
	      var face = constraints.video.facingMode;
	      face = face && ((typeof face === 'undefined' ? 'undefined' : _typeof(face)) === 'object' ? face : { ideal: face });
	      var getSupportedFacingModeLies = browserDetails.version < 66;
	
	      if (face && (face.exact === 'user' || face.exact === 'environment' || face.ideal === 'user' || face.ideal === 'environment') && !(navigator.mediaDevices.getSupportedConstraints && navigator.mediaDevices.getSupportedConstraints().facingMode && !getSupportedFacingModeLies)) {
	        delete constraints.video.facingMode;
	        var matches = void 0;
	        if (face.exact === 'environment' || face.ideal === 'environment') {
	          matches = ['back', 'rear'];
	        } else if (face.exact === 'user' || face.ideal === 'user') {
	          matches = ['front'];
	        }
	        if (matches) {
	          // Look for matches in label, or use last cam for back (typical).
	          return navigator.mediaDevices.enumerateDevices().then(function (devices) {
	            devices = devices.filter(function (d) {
	              return d.kind === 'videoinput';
	            });
	            var dev = devices.find(function (d) {
	              return matches.some(function (match) {
	                return d.label.toLowerCase().includes(match);
	              });
	            });
	            if (!dev && devices.length && matches.includes('back')) {
	              dev = devices[devices.length - 1]; // more likely the back cam
	            }
	            if (dev) {
	              constraints.video.deviceId = face.exact ? { exact: dev.deviceId } : { ideal: dev.deviceId };
	            }
	            constraints.video = constraintsToChrome_(constraints.video);
	            logging('chrome: ' + JSON.stringify(constraints));
	            return func(constraints);
	          });
	        }
	      }
	      constraints.video = constraintsToChrome_(constraints.video);
	    }
	    logging('chrome: ' + JSON.stringify(constraints));
	    return func(constraints);
	  };
	
	  var shimError_ = function shimError_(e) {
	    if (browserDetails.version >= 64) {
	      return e;
	    }
	    return {
	      name: {
	        PermissionDeniedError: 'NotAllowedError',
	        PermissionDismissedError: 'NotAllowedError',
	        InvalidStateError: 'NotAllowedError',
	        DevicesNotFoundError: 'NotFoundError',
	        ConstraintNotSatisfiedError: 'OverconstrainedError',
	        TrackStartError: 'NotReadableError',
	        MediaDeviceFailedDueToShutdown: 'NotAllowedError',
	        MediaDeviceKillSwitchOn: 'NotAllowedError',
	        TabCaptureError: 'AbortError',
	        ScreenCaptureError: 'AbortError',
	        DeviceCaptureError: 'AbortError'
	      }[e.name] || e.name,
	      message: e.message,
	      constraint: e.constraint || e.constraintName,
	      toString: function toString() {
	        return this.name + (this.message && ': ') + this.message;
	      }
	    };
	  };
	
	  var getUserMedia_ = function getUserMedia_(constraints, onSuccess, onError) {
	    shimConstraints_(constraints, function (c) {
	      navigator.webkitGetUserMedia(c, onSuccess, function (e) {
	        if (onError) {
	          onError(shimError_(e));
	        }
	      });
	    });
	  };
	  navigator.getUserMedia = getUserMedia_.bind(navigator);
	
	  // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
	  // function which returns a Promise, it does not accept spec-style
	  // constraints.
	  if (navigator.mediaDevices.getUserMedia) {
	    var origGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
	    navigator.mediaDevices.getUserMedia = function (cs) {
	      return shimConstraints_(cs, function (c) {
	        return origGetUserMedia(c).then(function (stream) {
	          if (c.audio && !stream.getAudioTracks().length || c.video && !stream.getVideoTracks().length) {
	            stream.getTracks().forEach(function (track) {
	              track.stop();
	            });
	            throw new DOMException('', 'NotFoundError');
	          }
	          return stream;
	        }, function (e) {
	          return Promise.reject(shimError_(e));
	        });
	      });
	    };
	  }
	}


/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
	 *
	 *  Use of this source code is governed by a BSD-style license
	 *  that can be found in the LICENSE file in the root of the source
	 *  tree.
	 */
	/* eslint-env node */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.shimRTCIceCandidate = shimRTCIceCandidate;
	exports.shimMaxMessageSize = shimMaxMessageSize;
	exports.shimSendThrowTypeError = shimSendThrowTypeError;
	exports.shimConnectionState = shimConnectionState;
	exports.removeExtmapAllowMixed = removeExtmapAllowMixed;
	exports.shimAddIceCandidateNullOrEmpty = shimAddIceCandidateNullOrEmpty;
	
	var _sdp = __webpack_require__(465);
	
	var _sdp2 = _interopRequireDefault(_sdp);
	
	var _utils = __webpack_require__(39);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function shimRTCIceCandidate(window) {
	  // foundation is arbitrarily chosen as an indicator for full support for
	  // https://w3c.github.io/webrtc-pc/#rtcicecandidate-interface
	  if (!window.RTCIceCandidate || window.RTCIceCandidate && 'foundation' in window.RTCIceCandidate.prototype) {
	    return;
	  }
	
	  var NativeRTCIceCandidate = window.RTCIceCandidate;
	  window.RTCIceCandidate = function RTCIceCandidate(args) {
	    // Remove the a= which shouldn't be part of the candidate string.
	    if ((typeof args === 'undefined' ? 'undefined' : _typeof(args)) === 'object' && args.candidate && args.candidate.indexOf('a=') === 0) {
	      args = JSON.parse(JSON.stringify(args));
	      args.candidate = args.candidate.substr(2);
	    }
	
	    if (args.candidate && args.candidate.length) {
	      // Augment the native candidate with the parsed fields.
	      var nativeCandidate = new NativeRTCIceCandidate(args);
	      var parsedCandidate = _sdp2.default.parseCandidate(args.candidate);
	      var augmentedCandidate = Object.assign(nativeCandidate, parsedCandidate);
	
	      // Add a serializer that does not serialize the extra attributes.
	      augmentedCandidate.toJSON = function toJSON() {
	        return {
	          candidate: augmentedCandidate.candidate,
	          sdpMid: augmentedCandidate.sdpMid,
	          sdpMLineIndex: augmentedCandidate.sdpMLineIndex,
	          usernameFragment: augmentedCandidate.usernameFragment
	        };
	      };
	      return augmentedCandidate;
	    }
	    return new NativeRTCIceCandidate(args);
	  };
	  window.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype;
	
	  // Hook up the augmented candidate in onicecandidate and
	  // addEventListener('icecandidate', ...)
	  utils.wrapPeerConnectionEvent(window, 'icecandidate', function (e) {
	    if (e.candidate) {
	      Object.defineProperty(e, 'candidate', {
	        value: new window.RTCIceCandidate(e.candidate),
	        writable: 'false'
	      });
	    }
	    return e;
	  });
	}
	
	function shimMaxMessageSize(window, browserDetails) {
	  if (!window.RTCPeerConnection) {
	    return;
	  }
	
	  if (!('sctp' in window.RTCPeerConnection.prototype)) {
	    Object.defineProperty(window.RTCPeerConnection.prototype, 'sctp', {
	      get: function get() {
	        return typeof this._sctp === 'undefined' ? null : this._sctp;
	      }
	    });
	  }
	
	  var sctpInDescription = function sctpInDescription(description) {
	    if (!description || !description.sdp) {
	      return false;
	    }
	    var sections = _sdp2.default.splitSections(description.sdp);
	    sections.shift();
	    return sections.some(function (mediaSection) {
	      var mLine = _sdp2.default.parseMLine(mediaSection);
	      return mLine && mLine.kind === 'application' && mLine.protocol.indexOf('SCTP') !== -1;
	    });
	  };
	
	  var getRemoteFirefoxVersion = function getRemoteFirefoxVersion(description) {
	    // TODO: Is there a better solution for detecting Firefox?
	    var match = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
	    if (match === null || match.length < 2) {
	      return -1;
	    }
	    var version = parseInt(match[1], 10);
	    // Test for NaN (yes, this is ugly)
	    return version !== version ? -1 : version;
	  };
	
	  var getCanSendMaxMessageSize = function getCanSendMaxMessageSize(remoteIsFirefox) {
	    // Every implementation we know can send at least 64 KiB.
	    // Note: Although Chrome is technically able to send up to 256 KiB, the
	    //       data does not reach the other peer reliably.
	    //       See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8419
	    var canSendMaxMessageSize = 65536;
	    if (browserDetails.browser === 'firefox') {
	      if (browserDetails.version < 57) {
	        if (remoteIsFirefox === -1) {
	          // FF < 57 will send in 16 KiB chunks using the deprecated PPID
	          // fragmentation.
	          canSendMaxMessageSize = 16384;
	        } else {
	          // However, other FF (and RAWRTC) can reassemble PPID-fragmented
	          // messages. Thus, supporting ~2 GiB when sending.
	          canSendMaxMessageSize = 2147483637;
	        }
	      } else if (browserDetails.version < 60) {
	        // Currently, all FF >= 57 will reset the remote maximum message size
	        // to the default value when a data channel is created at a later
	        // stage. :(
	        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
	        canSendMaxMessageSize = browserDetails.version === 57 ? 65535 : 65536;
	      } else {
	        // FF >= 60 supports sending ~2 GiB
	        canSendMaxMessageSize = 2147483637;
	      }
	    }
	    return canSendMaxMessageSize;
	  };
	
	  var getMaxMessageSize = function getMaxMessageSize(description, remoteIsFirefox) {
	    // Note: 65536 bytes is the default value from the SDP spec. Also,
	    //       every implementation we know supports receiving 65536 bytes.
	    var maxMessageSize = 65536;
	
	    // FF 57 has a slightly incorrect default remote max message size, so
	    // we need to adjust it here to avoid a failure when sending.
	    // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1425697
	    if (browserDetails.browser === 'firefox' && browserDetails.version === 57) {
	      maxMessageSize = 65535;
	    }
	
	    var match = _sdp2.default.matchPrefix(description.sdp, 'a=max-message-size:');
	    if (match.length > 0) {
	      maxMessageSize = parseInt(match[0].substr(19), 10);
	    } else if (browserDetails.browser === 'firefox' && remoteIsFirefox !== -1) {
	      // If the maximum message size is not present in the remote SDP and
	      // both local and remote are Firefox, the remote peer can receive
	      // ~2 GiB.
	      maxMessageSize = 2147483637;
	    }
	    return maxMessageSize;
	  };
	
	  var origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
	  window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
	    this._sctp = null;
	    // Chrome decided to not expose .sctp in plan-b mode.
	    // As usual, adapter.js has to do an 'ugly worakaround'
	    // to cover up the mess.
	    if (browserDetails.browser === 'chrome' && browserDetails.version >= 76) {
	      var _getConfiguration = this.getConfiguration(),
	          sdpSemantics = _getConfiguration.sdpSemantics;
	
	      if (sdpSemantics === 'plan-b') {
	        Object.defineProperty(this, 'sctp', {
	          get: function get() {
	            return typeof this._sctp === 'undefined' ? null : this._sctp;
	          },
	
	          enumerable: true,
	          configurable: true
	        });
	      }
	    }
	
	    if (sctpInDescription(arguments[0])) {
	      // Check if the remote is FF.
	      var isFirefox = getRemoteFirefoxVersion(arguments[0]);
	
	      // Get the maximum message size the local peer is capable of sending
	      var canSendMMS = getCanSendMaxMessageSize(isFirefox);
	
	      // Get the maximum message size of the remote peer.
	      var remoteMMS = getMaxMessageSize(arguments[0], isFirefox);
	
	      // Determine final maximum message size
	      var maxMessageSize = void 0;
	      if (canSendMMS === 0 && remoteMMS === 0) {
	        maxMessageSize = Number.POSITIVE_INFINITY;
	      } else if (canSendMMS === 0 || remoteMMS === 0) {
	        maxMessageSize = Math.max(canSendMMS, remoteMMS);
	      } else {
	        maxMessageSize = Math.min(canSendMMS, remoteMMS);
	      }
	
	      // Create a dummy RTCSctpTransport object and the 'maxMessageSize'
	      // attribute.
	      var sctp = {};
	      Object.defineProperty(sctp, 'maxMessageSize', {
	        get: function get() {
	          return maxMessageSize;
	        }
	      });
	      this._sctp = sctp;
	    }
	
	    return origSetRemoteDescription.apply(this, arguments);
	  };
	}
	
	function shimSendThrowTypeError(window) {
	  if (!(window.RTCPeerConnection && 'createDataChannel' in window.RTCPeerConnection.prototype)) {
	    return;
	  }
	
	  // Note: Although Firefox >= 57 has a native implementation, the maximum
	  //       message size can be reset for all data channels at a later stage.
	  //       See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
	
	  function wrapDcSend(dc, pc) {
	    var origDataChannelSend = dc.send;
	    dc.send = function send() {
	      var data = arguments[0];
	      var length = data.length || data.size || data.byteLength;
	      if (dc.readyState === 'open' && pc.sctp && length > pc.sctp.maxMessageSize) {
	        throw new TypeError('Message too large (can send a maximum of ' + pc.sctp.maxMessageSize + ' bytes)');
	      }
	      return origDataChannelSend.apply(dc, arguments);
	    };
	  }
	  var origCreateDataChannel = window.RTCPeerConnection.prototype.createDataChannel;
	  window.RTCPeerConnection.prototype.createDataChannel = function createDataChannel() {
	    var dataChannel = origCreateDataChannel.apply(this, arguments);
	    wrapDcSend(dataChannel, this);
	    return dataChannel;
	  };
	  utils.wrapPeerConnectionEvent(window, 'datachannel', function (e) {
	    wrapDcSend(e.channel, e.target);
	    return e;
	  });
	}
	
	/* shims RTCConnectionState by pretending it is the same as iceConnectionState.
	 * See https://bugs.chromium.org/p/webrtc/issues/detail?id=6145#c12
	 * for why this is a valid hack in Chrome. In Firefox it is slightly incorrect
	 * since DTLS failures would be hidden. See
	 * https://bugzilla.mozilla.org/show_bug.cgi?id=1265827
	 * for the Firefox tracking bug.
	 */
	function shimConnectionState(window) {
	  if (!window.RTCPeerConnection || 'connectionState' in window.RTCPeerConnection.prototype) {
	    return;
	  }
	  var proto = window.RTCPeerConnection.prototype;
	  Object.defineProperty(proto, 'connectionState', {
	    get: function get() {
	      return {
	        completed: 'connected',
	        checking: 'connecting'
	      }[this.iceConnectionState] || this.iceConnectionState;
	    },
	
	    enumerable: true,
	    configurable: true
	  });
	  Object.defineProperty(proto, 'onconnectionstatechange', {
	    get: function get() {
	      return this._onconnectionstatechange || null;
	    },
	    set: function set(cb) {
	      if (this._onconnectionstatechange) {
	        this.removeEventListener('connectionstatechange', this._onconnectionstatechange);
	        delete this._onconnectionstatechange;
	      }
	      if (cb) {
	        this.addEventListener('connectionstatechange', this._onconnectionstatechange = cb);
	      }
	    },
	
	    enumerable: true,
	    configurable: true
	  });
	
	  ['setLocalDescription', 'setRemoteDescription'].forEach(function (method) {
	    var origMethod = proto[method];
	    proto[method] = function () {
	      if (!this._connectionstatechangepoly) {
	        this._connectionstatechangepoly = function (e) {
	          var pc = e.target;
	          if (pc._lastConnectionState !== pc.connectionState) {
	            pc._lastConnectionState = pc.connectionState;
	            var newEvent = new Event('connectionstatechange', e);
	            pc.dispatchEvent(newEvent);
	          }
	          return e;
	        };
	        this.addEventListener('iceconnectionstatechange', this._connectionstatechangepoly);
	      }
	      return origMethod.apply(this, arguments);
	    };
	  });
	}
	
	function removeExtmapAllowMixed(window, browserDetails) {
	  /* remove a=extmap-allow-mixed for webrtc.org < M71 */
	  if (!window.RTCPeerConnection) {
	    return;
	  }
	  if (browserDetails.browser === 'chrome' && browserDetails.version >= 71) {
	    return;
	  }
	  if (browserDetails.browser === 'safari' && browserDetails.version >= 605) {
	    return;
	  }
	  var nativeSRD = window.RTCPeerConnection.prototype.setRemoteDescription;
	  window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription(desc) {
	    if (desc && desc.sdp && desc.sdp.indexOf('\na=extmap-allow-mixed') !== -1) {
	      var sdp = desc.sdp.split('\n').filter(function (line) {
	        return line.trim() !== 'a=extmap-allow-mixed';
	      }).join('\n');
	      // Safari enforces read-only-ness of RTCSessionDescription fields.
	      if (window.RTCSessionDescription && desc instanceof window.RTCSessionDescription) {
	        arguments[0] = new window.RTCSessionDescription({
	          type: desc.type,
	          sdp: sdp
	        });
	      } else {
	        desc.sdp = sdp;
	      }
	    }
	    return nativeSRD.apply(this, arguments);
	  };
	}
	
	function shimAddIceCandidateNullOrEmpty(window, browserDetails) {
	  // Support for addIceCandidate(null or undefined)
	  // as well as addIceCandidate({candidate: "", ...})
	  // https://bugs.chromium.org/p/chromium/issues/detail?id=978582
	  // Note: must be called before other polyfills which change the signature.
	  if (!(window.RTCPeerConnection && window.RTCPeerConnection.prototype)) {
	    return;
	  }
	  var nativeAddIceCandidate = window.RTCPeerConnection.prototype.addIceCandidate;
	  if (!nativeAddIceCandidate || nativeAddIceCandidate.length === 0) {
	    return;
	  }
	  window.RTCPeerConnection.prototype.addIceCandidate = function addIceCandidate() {
	    if (!arguments[0]) {
	      if (arguments[1]) {
	        arguments[1].apply(null);
	      }
	      return Promise.resolve();
	    }
	    // Firefox 68+ emits and processes {candidate: "", ...}, ignore
	    // in older versions.
	    // Native support for ignoring exists for Chrome M77+.
	    // Safari ignores as well, exact version unknown but works in the same
	    // version that also ignores addIceCandidate(null).
	    if ((browserDetails.browser === 'chrome' && browserDetails.version < 78 || browserDetails.browser === 'firefox' && browserDetails.version < 68 || browserDetails.browser === 'safari') && arguments[0] && arguments[0].candidate === '') {
	      return Promise.resolve();
	    }
	    return nativeAddIceCandidate.apply(this, arguments);
	  };
	}


/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
	 *
	 *  Use of this source code is governed by a BSD-style license
	 *  that can be found in the LICENSE file in the root of the source
	 *  tree.
	 */
	/* eslint-env node */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shimGetDisplayMedia = exports.shimGetUserMedia = undefined;
	
	var _getusermedia = __webpack_require__(1032);
	
	Object.defineProperty(exports, 'shimGetUserMedia', {
	  enumerable: true,
	  get: function get() {
	    return _getusermedia.shimGetUserMedia;
	  }
	});
	
	var _getdisplaymedia = __webpack_require__(1031);
	
	Object.defineProperty(exports, 'shimGetDisplayMedia', {
	  enumerable: true,
	  get: function get() {
	    return _getdisplaymedia.shimGetDisplayMedia;
	  }
	});
	exports.shimPeerConnection = shimPeerConnection;
	exports.shimReplaceTrack = shimReplaceTrack;
	
	var _utils = __webpack_require__(39);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _filtericeservers = __webpack_require__(1030);
	
	var _rtcpeerconnectionShim = __webpack_require__(941);
	
	var _rtcpeerconnectionShim2 = _interopRequireDefault(_rtcpeerconnectionShim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function shimPeerConnection(window, browserDetails) {
	  if (window.RTCIceGatherer) {
	    if (!window.RTCIceCandidate) {
	      window.RTCIceCandidate = function RTCIceCandidate(args) {
	        return args;
	      };
	    }
	    if (!window.RTCSessionDescription) {
	      window.RTCSessionDescription = function RTCSessionDescription(args) {
	        return args;
	      };
	    }
	    // this adds an additional event listener to MediaStrackTrack that signals
	    // when a tracks enabled property was changed. Workaround for a bug in
	    // addStream, see below. No longer required in 15025+
	    if (browserDetails.version < 15025) {
	      var origMSTEnabled = Object.getOwnPropertyDescriptor(window.MediaStreamTrack.prototype, 'enabled');
	      Object.defineProperty(window.MediaStreamTrack.prototype, 'enabled', {
	        set: function set(value) {
	          origMSTEnabled.set.call(this, value);
	          var ev = new Event('enabled');
	          ev.enabled = value;
	          this.dispatchEvent(ev);
	        }
	      });
	    }
	  }
	
	  // ORTC defines the DTMF sender a bit different.
	  // https://github.com/w3c/ortc/issues/714
	  if (window.RTCRtpSender && !('dtmf' in window.RTCRtpSender.prototype)) {
	    Object.defineProperty(window.RTCRtpSender.prototype, 'dtmf', {
	      get: function get() {
	        if (this._dtmf === undefined) {
	          if (this.track.kind === 'audio') {
	            this._dtmf = new window.RTCDtmfSender(this);
	          } else if (this.track.kind === 'video') {
	            this._dtmf = null;
	          }
	        }
	        return this._dtmf;
	      }
	    });
	  }
	  // Edge currently only implements the RTCDtmfSender, not the
	  // RTCDTMFSender alias. See http://draft.ortc.org/#rtcdtmfsender2*
	  if (window.RTCDtmfSender && !window.RTCDTMFSender) {
	    window.RTCDTMFSender = window.RTCDtmfSender;
	  }
	
	  var RTCPeerConnectionShim = (0, _rtcpeerconnectionShim2.default)(window, browserDetails.version);
	  window.RTCPeerConnection = function RTCPeerConnection(config) {
	    if (config && config.iceServers) {
	      config.iceServers = (0, _filtericeservers.filterIceServers)(config.iceServers, browserDetails.version);
	      utils.log('ICE servers after filtering:', config.iceServers);
	    }
	    return new RTCPeerConnectionShim(config);
	  };
	  window.RTCPeerConnection.prototype = RTCPeerConnectionShim.prototype;
	}
	
	function shimReplaceTrack(window) {
	  // ORTC has replaceTrack -- https://github.com/w3c/ortc/issues/614
	  if (window.RTCRtpSender && !('replaceTrack' in window.RTCRtpSender.prototype)) {
	    window.RTCRtpSender.prototype.replaceTrack = window.RTCRtpSender.prototype.setTrack;
	  }
	}


/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *  Copyright (c) 2018 The WebRTC project authors. All Rights Reserved.
	 *
	 *  Use of this source code is governed by a BSD-style license
	 *  that can be found in the LICENSE file in the root of the source
	 *  tree.
	 */
	/* eslint-env node */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.filterIceServers = filterIceServers;
	
	var _utils = __webpack_require__(39);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Edge does not like
	// 1) stun: filtered after 14393 unless ?transport=udp is present
	// 2) turn: that does not have all of turn:host:port?transport=udp
	// 3) turn: with ipv6 addresses
	// 4) turn: occurring muliple times
	function filterIceServers(iceServers, edgeVersion) {
	  var hasTurn = false;
	  iceServers = JSON.parse(JSON.stringify(iceServers));
	  return iceServers.filter(function (server) {
	    if (server && (server.urls || server.url)) {
	      var urls = server.urls || server.url;
	      if (server.url && !server.urls) {
	        utils.deprecated('RTCIceServer.url', 'RTCIceServer.urls');
	      }
	      var isString = typeof urls === 'string';
	      if (isString) {
	        urls = [urls];
	      }
	      urls = urls.filter(function (url) {
	        // filter STUN unconditionally.
	        if (url.indexOf('stun:') === 0) {
	          return false;
	        }
	
	        var validTurn = url.startsWith('turn') && !url.startsWith('turn:[') && url.includes('transport=udp');
	        if (validTurn && !hasTurn) {
	          hasTurn = true;
	          return true;
	        }
	        return validTurn && !hasTurn;
	      });
	
	      delete server.url;
	      server.urls = isString ? urls[0] : urls;
	      return !!urls.length;
	    }
	  });
	}


/***/ },
/* 1031 */
/***/ function(module, exports) {

	/*
	 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
	 *
	 *  Use of this source code is governed by a BSD-style license
	 *  that can be found in the LICENSE file in the root of the source
	 *  tree.
	 */
	/* eslint-env node */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shimGetDisplayMedia = shimGetDisplayMedia;
	function shimGetDisplayMedia(window) {
	  if (!('getDisplayMedia' in window.navigator)) {
	    return;
	  }
	  if (!window.navigator.mediaDevices) {
	    return;
	  }
	  if (window.navigator.mediaDevices && 'getDisplayMedia' in window.navigator.mediaDevices) {
	    return;
	  }
	  window.navigator.mediaDevices.getDisplayMedia = window.navigator.getDisplayMedia.bind(window.navigator);
	}


/***/ },
/* 1032 */
/***/ function(module, exports) {

	/*
	 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
	 *
	 *  Use of this source code is governed by a BSD-style license
	 *  that can be found in the LICENSE file in the root of the source
	 *  tree.
	 */
	/* eslint-env node */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shimGetUserMedia = shimGetUserMedia;
	function shimGetUserMedia(window) {
	  var navigator = window && window.navigator;
	
	  var shimError_ = function shimError_(e) {
	    return {
	      name: { PermissionDeniedError: 'NotAllowedError' }[e.name] || e.name,
	      message: e.message,
	      constraint: e.constraint,
	      toString: function toString() {
	        return this.name;
	      }
	    };
	  };
	
	  // getUserMedia error shim.
	  var origGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
	  navigator.mediaDevices.getUserMedia = function (c) {
	    return origGetUserMedia(c).catch(function (e) {
	      return Promise.reject(shimError_(e));
	    });
	  };
	}


/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
	 *
	 *  Use of this source code is governed by a BSD-style license
	 *  that can be found in the LICENSE file in the root of the source
	 *  tree.
	 */
	/* eslint-env node */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shimGetDisplayMedia = exports.shimGetUserMedia = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _getusermedia = __webpack_require__(1035);
	
	Object.defineProperty(exports, 'shimGetUserMedia', {
	  enumerable: true,
	  get: function get() {
	    return _getusermedia.shimGetUserMedia;
	  }
	});
	
	var _getdisplaymedia = __webpack_require__(1034);
	
	Object.defineProperty(exports, 'shimGetDisplayMedia', {
	  enumerable: true,
	  get: function get() {
	    return _getdisplaymedia.shimGetDisplayMedia;
	  }
	});
	exports.shimOnTrack = shimOnTrack;
	exports.shimPeerConnection = shimPeerConnection;
	exports.shimSenderGetStats = shimSenderGetStats;
	exports.shimReceiverGetStats = shimReceiverGetStats;
	exports.shimRemoveStream = shimRemoveStream;
	exports.shimRTCDataChannel = shimRTCDataChannel;
	exports.shimAddTransceiver = shimAddTransceiver;
	exports.shimGetParameters = shimGetParameters;
	exports.shimCreateOffer = shimCreateOffer;
	exports.shimCreateAnswer = shimCreateAnswer;
	
	var _utils = __webpack_require__(39);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function shimOnTrack(window) {
	  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCTrackEvent && 'receiver' in window.RTCTrackEvent.prototype && !('transceiver' in window.RTCTrackEvent.prototype)) {
	    Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
	      get: function get() {
	        return { receiver: this.receiver };
	      }
	    });
	  }
	}
	
	function shimPeerConnection(window, browserDetails) {
	  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || !(window.RTCPeerConnection || window.mozRTCPeerConnection)) {
	    return; // probably media.peerconnection.enabled=false in about:config
	  }
	  if (!window.RTCPeerConnection && window.mozRTCPeerConnection) {
	    // very basic support for old versions.
	    window.RTCPeerConnection = window.mozRTCPeerConnection;
	  }
	
	  if (browserDetails.version < 53) {
	    // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
	    ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate'].forEach(function (method) {
	      var nativeMethod = window.RTCPeerConnection.prototype[method];
	      var methodObj = _defineProperty({}, method, function () {
	        arguments[0] = new (method === 'addIceCandidate' ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
	        return nativeMethod.apply(this, arguments);
	      });
	      window.RTCPeerConnection.prototype[method] = methodObj[method];
	    });
	  }
	
	  var modernStatsTypes = {
	    inboundrtp: 'inbound-rtp',
	    outboundrtp: 'outbound-rtp',
	    candidatepair: 'candidate-pair',
	    localcandidate: 'local-candidate',
	    remotecandidate: 'remote-candidate'
	  };
	
	  var nativeGetStats = window.RTCPeerConnection.prototype.getStats;
	  window.RTCPeerConnection.prototype.getStats = function getStats() {
	    var _arguments = Array.prototype.slice.call(arguments),
	        selector = _arguments[0],
	        onSucc = _arguments[1],
	        onErr = _arguments[2];
	
	    return nativeGetStats.apply(this, [selector || null]).then(function (stats) {
	      if (browserDetails.version < 53 && !onSucc) {
	        // Shim only promise getStats with spec-hyphens in type names
	        // Leave callback version alone; misc old uses of forEach before Map
	        try {
	          stats.forEach(function (stat) {
	            stat.type = modernStatsTypes[stat.type] || stat.type;
	          });
	        } catch (e) {
	          if (e.name !== 'TypeError') {
	            throw e;
	          }
	          // Avoid TypeError: "type" is read-only, in old versions. 34-43ish
	          stats.forEach(function (stat, i) {
	            stats.set(i, Object.assign({}, stat, {
	              type: modernStatsTypes[stat.type] || stat.type
	            }));
	          });
	        }
	      }
	      return stats;
	    }).then(onSucc, onErr);
	  };
	}
	
	function shimSenderGetStats(window) {
	  if (!((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection && window.RTCRtpSender)) {
	    return;
	  }
	  if (window.RTCRtpSender && 'getStats' in window.RTCRtpSender.prototype) {
	    return;
	  }
	  var origGetSenders = window.RTCPeerConnection.prototype.getSenders;
	  if (origGetSenders) {
	    window.RTCPeerConnection.prototype.getSenders = function getSenders() {
	      var _this = this;
	
	      var senders = origGetSenders.apply(this, []);
	      senders.forEach(function (sender) {
	        return sender._pc = _this;
	      });
	      return senders;
	    };
	  }
	
	  var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
	  if (origAddTrack) {
	    window.RTCPeerConnection.prototype.addTrack = function addTrack() {
	      var sender = origAddTrack.apply(this, arguments);
	      sender._pc = this;
	      return sender;
	    };
	  }
	  window.RTCRtpSender.prototype.getStats = function getStats() {
	    return this.track ? this._pc.getStats(this.track) : Promise.resolve(new Map());
	  };
	}
	
	function shimReceiverGetStats(window) {
	  if (!((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection && window.RTCRtpSender)) {
	    return;
	  }
	  if (window.RTCRtpSender && 'getStats' in window.RTCRtpReceiver.prototype) {
	    return;
	  }
	  var origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
	  if (origGetReceivers) {
	    window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
	      var _this2 = this;
	
	      var receivers = origGetReceivers.apply(this, []);
	      receivers.forEach(function (receiver) {
	        return receiver._pc = _this2;
	      });
	      return receivers;
	    };
	  }
	  utils.wrapPeerConnectionEvent(window, 'track', function (e) {
	    e.receiver._pc = e.srcElement;
	    return e;
	  });
	  window.RTCRtpReceiver.prototype.getStats = function getStats() {
	    return this._pc.getStats(this.track);
	  };
	}
	
	function shimRemoveStream(window) {
	  if (!window.RTCPeerConnection || 'removeStream' in window.RTCPeerConnection.prototype) {
	    return;
	  }
	  window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
	    var _this3 = this;
	
	    utils.deprecated('removeStream', 'removeTrack');
	    this.getSenders().forEach(function (sender) {
	      if (sender.track && stream.getTracks().includes(sender.track)) {
	        _this3.removeTrack(sender);
	      }
	    });
	  };
	}
	
	function shimRTCDataChannel(window) {
	  // rename DataChannel to RTCDataChannel (native fix in FF60):
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=1173851
	  if (window.DataChannel && !window.RTCDataChannel) {
	    window.RTCDataChannel = window.DataChannel;
	  }
	}
	
	function shimAddTransceiver(window) {
	  // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
	  // Firefox ignores the init sendEncodings options passed to addTransceiver
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
	  if (!((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection)) {
	    return;
	  }
	  var origAddTransceiver = window.RTCPeerConnection.prototype.addTransceiver;
	  if (origAddTransceiver) {
	    window.RTCPeerConnection.prototype.addTransceiver = function addTransceiver() {
	      this.setParametersPromises = [];
	      var initParameters = arguments[1];
	      var shouldPerformCheck = initParameters && 'sendEncodings' in initParameters;
	      if (shouldPerformCheck) {
	        // If sendEncodings params are provided, validate grammar
	        initParameters.sendEncodings.forEach(function (encodingParam) {
	          if ('rid' in encodingParam) {
	            var ridRegex = /^[a-z0-9]{0,16}$/i;
	            if (!ridRegex.test(encodingParam.rid)) {
	              throw new TypeError('Invalid RID value provided.');
	            }
	          }
	          if ('scaleResolutionDownBy' in encodingParam) {
	            if (!(parseFloat(encodingParam.scaleResolutionDownBy) >= 1.0)) {
	              throw new RangeError('scale_resolution_down_by must be >= 1.0');
	            }
	          }
	          if ('maxFramerate' in encodingParam) {
	            if (!(parseFloat(encodingParam.maxFramerate) >= 0)) {
	              throw new RangeError('max_framerate must be >= 0.0');
	            }
	          }
	        });
	      }
	      var transceiver = origAddTransceiver.apply(this, arguments);
	      if (shouldPerformCheck) {
	        // Check if the init options were applied. If not we do this in an
	        // asynchronous way and save the promise reference in a global object.
	        // This is an ugly hack, but at the same time is way more robust than
	        // checking the sender parameters before and after the createOffer
	        // Also note that after the createoffer we are not 100% sure that
	        // the params were asynchronously applied so we might miss the
	        // opportunity to recreate offer.
	        var sender = transceiver.sender;
	
	        var params = sender.getParameters();
	        if (!('encodings' in params) ||
	        // Avoid being fooled by patched getParameters() below.
	        params.encodings.length === 1 && Object.keys(params.encodings[0]).length === 0) {
	          params.encodings = initParameters.sendEncodings;
	          sender.sendEncodings = initParameters.sendEncodings;
	          this.setParametersPromises.push(sender.setParameters(params).then(function () {
	            delete sender.sendEncodings;
	          }).catch(function () {
	            delete sender.sendEncodings;
	          }));
	        }
	      }
	      return transceiver;
	    };
	  }
	}
	
	function shimGetParameters(window) {
	  if (!((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCRtpSender)) {
	    return;
	  }
	  var origGetParameters = window.RTCRtpSender.prototype.getParameters;
	  if (origGetParameters) {
	    window.RTCRtpSender.prototype.getParameters = function getParameters() {
	      var params = origGetParameters.apply(this, arguments);
	      if (!('encodings' in params)) {
	        params.encodings = [].concat(this.sendEncodings || [{}]);
	      }
	      return params;
	    };
	  }
	}
	
	function shimCreateOffer(window) {
	  // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
	  // Firefox ignores the init sendEncodings options passed to addTransceiver
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
	  if (!((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection)) {
	    return;
	  }
	  var origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
	  window.RTCPeerConnection.prototype.createOffer = function createOffer() {
	    var _this4 = this,
	        _arguments2 = arguments;
	
	    if (this.setParametersPromises && this.setParametersPromises.length) {
	      return Promise.all(this.setParametersPromises).then(function () {
	        return origCreateOffer.apply(_this4, _arguments2);
	      }).finally(function () {
	        _this4.setParametersPromises = [];
	      });
	    }
	    return origCreateOffer.apply(this, arguments);
	  };
	}
	
	function shimCreateAnswer(window) {
	  // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
	  // Firefox ignores the init sendEncodings options passed to addTransceiver
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
	  if (!((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection)) {
	    return;
	  }
	  var origCreateAnswer = window.RTCPeerConnection.prototype.createAnswer;
	  window.RTCPeerConnection.prototype.createAnswer = function createAnswer() {
	    var _this5 = this,
	        _arguments3 = arguments;
	
	    if (this.setParametersPromises && this.setParametersPromises.length) {
	      return Promise.all(this.setParametersPromises).then(function () {
	        return origCreateAnswer.apply(_this5, _arguments3);
	      }).finally(function () {
	        _this5.setParametersPromises = [];
	      });
	    }
	    return origCreateAnswer.apply(this, arguments);
	  };
	}


/***/ },
/* 1034 */
/***/ function(module, exports) {

	/*
	 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
	 *
	 *  Use of this source code is governed by a BSD-style license
	 *  that can be found in the LICENSE file in the root of the source
	 *  tree.
	 */
	/* eslint-env node */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shimGetDisplayMedia = shimGetDisplayMedia;
	function shimGetDisplayMedia(window, preferredMediaSource) {
	  if (window.navigator.mediaDevices && 'getDisplayMedia' in window.navigator.mediaDevices) {
	    return;
	  }
	  if (!window.navigator.mediaDevices) {
	    return;
	  }
	  window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
	    if (!(constraints && constraints.video)) {
	      var err = new DOMException('getDisplayMedia without video ' + 'constraints is undefined');
	      err.name = 'NotFoundError';
	      // from https://heycam.github.io/webidl/#idl-DOMException-error-names
	      err.code = 8;
	      return Promise.reject(err);
	    }
	    if (constraints.video === true) {
	      constraints.video = { mediaSource: preferredMediaSource };
	    } else {
	      constraints.video.mediaSource = preferredMediaSource;
	    }
	    return window.navigator.mediaDevices.getUserMedia(constraints);
	  };
	}


/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
	 *
	 *  Use of this source code is governed by a BSD-style license
	 *  that can be found in the LICENSE file in the root of the source
	 *  tree.
	 */
	/* eslint-env node */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.shimGetUserMedia = shimGetUserMedia;
	
	var _utils = __webpack_require__(39);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function shimGetUserMedia(window, browserDetails) {
	  var navigator = window && window.navigator;
	  var MediaStreamTrack = window && window.MediaStreamTrack;
	
	  navigator.getUserMedia = function (constraints, onSuccess, onError) {
	    // Replace Firefox 44+'s deprecation warning with unprefixed version.
	    utils.deprecated('navigator.getUserMedia', 'navigator.mediaDevices.getUserMedia');
	    navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
	  };
	
	  if (!(browserDetails.version > 55 && 'autoGainControl' in navigator.mediaDevices.getSupportedConstraints())) {
	    var remap = function remap(obj, a, b) {
	      if (a in obj && !(b in obj)) {
	        obj[b] = obj[a];
	        delete obj[a];
	      }
	    };
	
	    var nativeGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
	    navigator.mediaDevices.getUserMedia = function (c) {
	      if ((typeof c === 'undefined' ? 'undefined' : _typeof(c)) === 'object' && _typeof(c.audio) === 'object') {
	        c = JSON.parse(JSON.stringify(c));
	        remap(c.audio, 'autoGainControl', 'mozAutoGainControl');
	        remap(c.audio, 'noiseSuppression', 'mozNoiseSuppression');
	      }
	      return nativeGetUserMedia(c);
	    };
	
	    if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
	      var nativeGetSettings = MediaStreamTrack.prototype.getSettings;
	      MediaStreamTrack.prototype.getSettings = function () {
	        var obj = nativeGetSettings.apply(this, arguments);
	        remap(obj, 'mozAutoGainControl', 'autoGainControl');
	        remap(obj, 'mozNoiseSuppression', 'noiseSuppression');
	        return obj;
	      };
	    }
	
	    if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
	      var nativeApplyConstraints = MediaStreamTrack.prototype.applyConstraints;
	      MediaStreamTrack.prototype.applyConstraints = function (c) {
	        if (this.kind === 'audio' && (typeof c === 'undefined' ? 'undefined' : _typeof(c)) === 'object') {
	          c = JSON.parse(JSON.stringify(c));
	          remap(c, 'autoGainControl', 'mozAutoGainControl');
	          remap(c, 'noiseSuppression', 'mozNoiseSuppression');
	        }
	        return nativeApplyConstraints.apply(this, [c]);
	      };
	    }
	  }
	}


/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
	 *
	 *  Use of this source code is governed by a BSD-style license
	 *  that can be found in the LICENSE file in the root of the source
	 *  tree.
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.shimLocalStreamsAPI = shimLocalStreamsAPI;
	exports.shimRemoteStreamsAPI = shimRemoteStreamsAPI;
	exports.shimCallbacksAPI = shimCallbacksAPI;
	exports.shimGetUserMedia = shimGetUserMedia;
	exports.shimConstraints = shimConstraints;
	exports.shimRTCIceServerUrls = shimRTCIceServerUrls;
	exports.shimTrackEventTransceiver = shimTrackEventTransceiver;
	exports.shimCreateOfferLegacy = shimCreateOfferLegacy;
	exports.shimAudioContext = shimAudioContext;
	
	var _utils = __webpack_require__(39);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function shimLocalStreamsAPI(window) {
	  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || !window.RTCPeerConnection) {
	    return;
	  }
	  if (!('getLocalStreams' in window.RTCPeerConnection.prototype)) {
	    window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
	      if (!this._localStreams) {
	        this._localStreams = [];
	      }
	      return this._localStreams;
	    };
	  }
	  if (!('addStream' in window.RTCPeerConnection.prototype)) {
	    var _addTrack = window.RTCPeerConnection.prototype.addTrack;
	    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
	      var _this = this;
	
	      if (!this._localStreams) {
	        this._localStreams = [];
	      }
	      if (!this._localStreams.includes(stream)) {
	        this._localStreams.push(stream);
	      }
	      // Try to emulate Chrome's behaviour of adding in audio-video order.
	      // Safari orders by track id.
	      stream.getAudioTracks().forEach(function (track) {
	        return _addTrack.call(_this, track, stream);
	      });
	      stream.getVideoTracks().forEach(function (track) {
	        return _addTrack.call(_this, track, stream);
	      });
	    };
	
	    window.RTCPeerConnection.prototype.addTrack = function addTrack(track) {
	      var _this2 = this;
	
	      for (var _len = arguments.length, streams = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        streams[_key - 1] = arguments[_key];
	      }
	
	      if (streams) {
	        streams.forEach(function (stream) {
	          if (!_this2._localStreams) {
	            _this2._localStreams = [stream];
	          } else if (!_this2._localStreams.includes(stream)) {
	            _this2._localStreams.push(stream);
	          }
	        });
	      }
	      return _addTrack.apply(this, arguments);
	    };
	  }
	  if (!('removeStream' in window.RTCPeerConnection.prototype)) {
	    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
	      var _this3 = this;
	
	      if (!this._localStreams) {
	        this._localStreams = [];
	      }
	      var index = this._localStreams.indexOf(stream);
	      if (index === -1) {
	        return;
	      }
	      this._localStreams.splice(index, 1);
	      var tracks = stream.getTracks();
	      this.getSenders().forEach(function (sender) {
	        if (tracks.includes(sender.track)) {
	          _this3.removeTrack(sender);
	        }
	      });
	    };
	  }
	}
	
	function shimRemoteStreamsAPI(window) {
	  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || !window.RTCPeerConnection) {
	    return;
	  }
	  if (!('getRemoteStreams' in window.RTCPeerConnection.prototype)) {
	    window.RTCPeerConnection.prototype.getRemoteStreams = function getRemoteStreams() {
	      return this._remoteStreams ? this._remoteStreams : [];
	    };
	  }
	  if (!('onaddstream' in window.RTCPeerConnection.prototype)) {
	    Object.defineProperty(window.RTCPeerConnection.prototype, 'onaddstream', {
	      get: function get() {
	        return this._onaddstream;
	      },
	      set: function set(f) {
	        var _this4 = this;
	
	        if (this._onaddstream) {
	          this.removeEventListener('addstream', this._onaddstream);
	          this.removeEventListener('track', this._onaddstreampoly);
	        }
	        this.addEventListener('addstream', this._onaddstream = f);
	        this.addEventListener('track', this._onaddstreampoly = function (e) {
	          e.streams.forEach(function (stream) {
	            if (!_this4._remoteStreams) {
	              _this4._remoteStreams = [];
	            }
	            if (_this4._remoteStreams.includes(stream)) {
	              return;
	            }
	            _this4._remoteStreams.push(stream);
	            var event = new Event('addstream');
	            event.stream = stream;
	            _this4.dispatchEvent(event);
	          });
	        });
	      }
	    });
	    var origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
	    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
	      var pc = this;
	      if (!this._onaddstreampoly) {
	        this.addEventListener('track', this._onaddstreampoly = function (e) {
	          e.streams.forEach(function (stream) {
	            if (!pc._remoteStreams) {
	              pc._remoteStreams = [];
	            }
	            if (pc._remoteStreams.indexOf(stream) >= 0) {
	              return;
	            }
	            pc._remoteStreams.push(stream);
	            var event = new Event('addstream');
	            event.stream = stream;
	            pc.dispatchEvent(event);
	          });
	        });
	      }
	      return origSetRemoteDescription.apply(pc, arguments);
	    };
	  }
	}
	
	function shimCallbacksAPI(window) {
	  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || !window.RTCPeerConnection) {
	    return;
	  }
	  var prototype = window.RTCPeerConnection.prototype;
	  var origCreateOffer = prototype.createOffer;
	  var origCreateAnswer = prototype.createAnswer;
	  var setLocalDescription = prototype.setLocalDescription;
	  var setRemoteDescription = prototype.setRemoteDescription;
	  var addIceCandidate = prototype.addIceCandidate;
	
	  prototype.createOffer = function createOffer(successCallback, failureCallback) {
	    var options = arguments.length >= 2 ? arguments[2] : arguments[0];
	    var promise = origCreateOffer.apply(this, [options]);
	    if (!failureCallback) {
	      return promise;
	    }
	    promise.then(successCallback, failureCallback);
	    return Promise.resolve();
	  };
	
	  prototype.createAnswer = function createAnswer(successCallback, failureCallback) {
	    var options = arguments.length >= 2 ? arguments[2] : arguments[0];
	    var promise = origCreateAnswer.apply(this, [options]);
	    if (!failureCallback) {
	      return promise;
	    }
	    promise.then(successCallback, failureCallback);
	    return Promise.resolve();
	  };
	
	  var withCallback = function withCallback(description, successCallback, failureCallback) {
	    var promise = setLocalDescription.apply(this, [description]);
	    if (!failureCallback) {
	      return promise;
	    }
	    promise.then(successCallback, failureCallback);
	    return Promise.resolve();
	  };
	  prototype.setLocalDescription = withCallback;
	
	  withCallback = function withCallback(description, successCallback, failureCallback) {
	    var promise = setRemoteDescription.apply(this, [description]);
	    if (!failureCallback) {
	      return promise;
	    }
	    promise.then(successCallback, failureCallback);
	    return Promise.resolve();
	  };
	  prototype.setRemoteDescription = withCallback;
	
	  withCallback = function withCallback(candidate, successCallback, failureCallback) {
	    var promise = addIceCandidate.apply(this, [candidate]);
	    if (!failureCallback) {
	      return promise;
	    }
	    promise.then(successCallback, failureCallback);
	    return Promise.resolve();
	  };
	  prototype.addIceCandidate = withCallback;
	}
	
	function shimGetUserMedia(window) {
	  var navigator = window && window.navigator;
	
	  if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
	    // shim not needed in Safari 12.1
	    var mediaDevices = navigator.mediaDevices;
	    var _getUserMedia = mediaDevices.getUserMedia.bind(mediaDevices);
	    navigator.mediaDevices.getUserMedia = function (constraints) {
	      return _getUserMedia(shimConstraints(constraints));
	    };
	  }
	
	  if (!navigator.getUserMedia && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
	    navigator.getUserMedia = function getUserMedia(constraints, cb, errcb) {
	      navigator.mediaDevices.getUserMedia(constraints).then(cb, errcb);
	    }.bind(navigator);
	  }
	}
	
	function shimConstraints(constraints) {
	  if (constraints && constraints.video !== undefined) {
	    return Object.assign({}, constraints, { video: utils.compactObject(constraints.video) });
	  }
	
	  return constraints;
	}
	
	function shimRTCIceServerUrls(window) {
	  if (!window.RTCPeerConnection) {
	    return;
	  }
	  // migrate from non-spec RTCIceServer.url to RTCIceServer.urls
	  var OrigPeerConnection = window.RTCPeerConnection;
	  window.RTCPeerConnection = function RTCPeerConnection(pcConfig, pcConstraints) {
	    if (pcConfig && pcConfig.iceServers) {
	      var newIceServers = [];
	      for (var i = 0; i < pcConfig.iceServers.length; i++) {
	        var server = pcConfig.iceServers[i];
	        if (!server.hasOwnProperty('urls') && server.hasOwnProperty('url')) {
	          utils.deprecated('RTCIceServer.url', 'RTCIceServer.urls');
	          server = JSON.parse(JSON.stringify(server));
	          server.urls = server.url;
	          delete server.url;
	          newIceServers.push(server);
	        } else {
	          newIceServers.push(pcConfig.iceServers[i]);
	        }
	      }
	      pcConfig.iceServers = newIceServers;
	    }
	    return new OrigPeerConnection(pcConfig, pcConstraints);
	  };
	  window.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
	  // wrap static methods. Currently just generateCertificate.
	  if ('generateCertificate' in OrigPeerConnection) {
	    Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
	      get: function get() {
	        return OrigPeerConnection.generateCertificate;
	      }
	    });
	  }
	}
	
	function shimTrackEventTransceiver(window) {
	  // Add event.transceiver member over deprecated event.receiver
	  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCTrackEvent && 'receiver' in window.RTCTrackEvent.prototype && !('transceiver' in window.RTCTrackEvent.prototype)) {
	    Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
	      get: function get() {
	        return { receiver: this.receiver };
	      }
	    });
	  }
	}
	
	function shimCreateOfferLegacy(window) {
	  var origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
	  window.RTCPeerConnection.prototype.createOffer = function createOffer(offerOptions) {
	    if (offerOptions) {
	      if (typeof offerOptions.offerToReceiveAudio !== 'undefined') {
	        // support bit values
	        offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
	      }
	      var audioTransceiver = this.getTransceivers().find(function (transceiver) {
	        return transceiver.receiver.track.kind === 'audio';
	      });
	      if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
	        if (audioTransceiver.direction === 'sendrecv') {
	          if (audioTransceiver.setDirection) {
	            audioTransceiver.setDirection('sendonly');
	          } else {
	            audioTransceiver.direction = 'sendonly';
	          }
	        } else if (audioTransceiver.direction === 'recvonly') {
	          if (audioTransceiver.setDirection) {
	            audioTransceiver.setDirection('inactive');
	          } else {
	            audioTransceiver.direction = 'inactive';
	          }
	        }
	      } else if (offerOptions.offerToReceiveAudio === true && !audioTransceiver) {
	        this.addTransceiver('audio');
	      }
	
	      if (typeof offerOptions.offerToReceiveVideo !== 'undefined') {
	        // support bit values
	        offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
	      }
	      var videoTransceiver = this.getTransceivers().find(function (transceiver) {
	        return transceiver.receiver.track.kind === 'video';
	      });
	      if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
	        if (videoTransceiver.direction === 'sendrecv') {
	          if (videoTransceiver.setDirection) {
	            videoTransceiver.setDirection('sendonly');
	          } else {
	            videoTransceiver.direction = 'sendonly';
	          }
	        } else if (videoTransceiver.direction === 'recvonly') {
	          if (videoTransceiver.setDirection) {
	            videoTransceiver.setDirection('inactive');
	          } else {
	            videoTransceiver.direction = 'inactive';
	          }
	        }
	      } else if (offerOptions.offerToReceiveVideo === true && !videoTransceiver) {
	        this.addTransceiver('video');
	      }
	    }
	    return origCreateOffer.apply(this, arguments);
	  };
	}
	
	function shimAudioContext(window) {
	  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || window.AudioContext) {
	    return;
	  }
	  window.AudioContext = window.webkitAudioContext;
	}


/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var _arity = __webpack_require__(__webpack_module_template_argument_0__);
	var _curry2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	
	/**
	 * Creates a function that is bound to a context.
	 * Note: `R.bind` does not provide the additional argument-binding capabilities of
	 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @category Object
	 * @sig (* -> *) -> {*} -> (* -> *)
	 * @param {Function} fn The function to bind to context
	 * @param {Object} thisObj The context to bind `fn` to
	 * @return {Function} A function that will execute in the context of `thisObj`.
	 * @see R.partial
	 * @example
	 *
	 *      var log = R.bind(console.log, console);
	 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
	 *      // logs {a: 2}
	 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
	 */
	module.exports = _curry2(function bind(fn, thisObj) {
	  return _arity(fn.length, function() {
	    return fn.apply(thisObj, arguments);
	  });
	});


/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var _isPlaceholder = __webpack_require__(__webpack_module_template_argument_0__);
	
	
	/**
	 * Optimized internal one-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry1(fn) {
	  return function f1(a) {
	    if (arguments.length === 0 || _isPlaceholder(a)) {
	      return f1;
	    } else {
	      return fn.apply(this, arguments);
	    }
	  };
	};


/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var _curry1 = __webpack_require__(__webpack_module_template_argument_0__);
	var _isPlaceholder = __webpack_require__(__webpack_module_template_argument_1__);
	
	
	/**
	 * Optimized internal two-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry2(fn) {
	  return function f2(a, b) {
	    switch (arguments.length) {
	      case 0:
	        return f2;
	      case 1:
	        return _isPlaceholder(a) ? f2
	             : _curry1(function(_b) { return fn(a, _b); });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f2
	             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b); })
	             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b); })
	             : fn(a, b);
	    }
	  };
	};


/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var _curry1 = __webpack_require__(__webpack_module_template_argument_0__);
	var _curry2 = __webpack_require__(__webpack_module_template_argument_1__);
	var _isPlaceholder = __webpack_require__(__webpack_module_template_argument_2__);
	
	
	/**
	 * Optimized internal three-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry3(fn) {
	  return function f3(a, b, c) {
	    switch (arguments.length) {
	      case 0:
	        return f3;
	      case 1:
	        return _isPlaceholder(a) ? f3
	             : _curry2(function(_b, _c) { return fn(a, _b, _c); });
	      case 2:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f3
	             : _isPlaceholder(a) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
	             : _isPlaceholder(b) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
	             : _curry1(function(_c) { return fn(a, b, _c); });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3
	             : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function(_a, _b) { return fn(_a, _b, c); })
	             : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
	             : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
	             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b, c); })
	             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b, c); })
	             : _isPlaceholder(c) ? _curry1(function(_c) { return fn(a, b, _c); })
	             : fn(a, b, c);
	    }
	  };
	};


/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var _has = __webpack_require__(__webpack_module_template_argument_0__);
	
	
	module.exports = (function() {
	  var toString = Object.prototype.toString;
	  return toString.call(arguments) === '[object Arguments]' ?
	    function _isArguments(x) { return toString.call(x) === '[object Arguments]'; } :
	    function _isArguments(x) { return _has('callee', x); };
	}());


/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.53dd1581.js